import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  JSON: any;
  JSONObject: any;
  Upload: any;
};

export type AccessPermissionListInput = {
  id: Scalars['String'];
  package_code?: InputMaybe<Scalars['String']>;
  permission_uuid?: InputMaybe<Scalars['String']>;
  permissionId: Scalars['Float'];
};

export type AccountMappingInput = {
  companyId: Scalars['String'];
  glAccountList: Array<AccountMappingListInputProps>;
};

export type AccountMappingListInputProps = {
  glAccountCode?: InputMaybe<Scalars['String']>;
  glAccountId?: InputMaybe<Scalars['String']>;
  glType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  table?: InputMaybe<Scalars['String']>;
};

export type AccountMappingListProps = {
  __typename?: 'accountMappingListProps';
  glAccountCode?: Maybe<Scalars['String']>;
  glAccountId?: Maybe<Scalars['String']>;
  glType?: Maybe<GlAccountTypeEnum>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  table?: Maybe<Scalars['String']>;
};

export type AccountMappingOutput = {
  __typename?: 'accountMappingOutput';
  costCentre?: Maybe<Scalars['String']>;
  dataList?: Maybe<Array<AccountMappingListProps>>;
  debtorAccountCode?: Maybe<Scalars['String']>;
  journalType?: Maybe<Scalars['String']>;
};

export type AccountSpecEntity = {
  __typename?: 'accountSpecEntity';
  accountCode?: Maybe<Scalars['String']>;
  accountId: Scalars['String'];
  id: Scalars['String'];
  integrationAutoCapitalize: Scalars['Boolean'];
  leadAssignmentActivated: Scalars['Boolean'];
  loanPlusInfo: Scalars['JSONObject'];
  loanPlusProjectId?: Maybe<Scalars['Float']>;
  projectIntegration?: Maybe<Array<ProjectIntegrationEntity>>;
  purchaserAccountRef?: Maybe<PurchaserAccountReferenceEntity>;
  purchaserAppCss?: Maybe<PurchaserAppCssOutput>;
  smptInfo?: Maybe<SmtpInfoOutput>;
};

export type ActiveLoanStatusOutput = {
  __typename?: 'ActiveLoanStatusOutput';
  assignedCount: Scalars['Float'];
  count: Scalars['Float'];
  docsSubmittedCount: Scalars['Float'];
  loanAppealedCount: Scalars['Float'];
  loanDocSignedCount: Scalars['Float'];
  loanIssuedCount: Scalars['Float'];
  loanSignedCount: Scalars['Float'];
  openCount: Scalars['Float'];
  pendingDocsCount: Scalars['Float'];
  unassignedCount: Scalars['Float'];
  unreachableCount: Scalars['Float'];
};

export type ActivePaymentPlanOutput = {
  __typename?: 'activePaymentPlanOutput';
  isStakeholder: Scalars['Boolean'];
  paymentPlanId: Scalars['String'];
  paymentPlanName: Scalars['String'];
  status: Scalars['String'];
};

export type AddAccountReceivableAging = {
  companyArPolicyPeriod1: Scalars['Float'];
  companyArPolicyPeriod2: Scalars['Float'];
  companyArPolicyPeriod3: Scalars['Float'];
  companyArPolicyPeriod4: Scalars['Float'];
  companyArPolicyPeriod5: Scalars['Float'];
  companyArPolicyPeriod6: Scalars['Float'];
  companyId: Scalars['String'];
};

export type AddAndEditBookingFeeInput = {
  bankId?: InputMaybe<Scalars['String']>;
  bookingFeeAttachment?: InputMaybe<Array<Scalars['Upload']>>;
  deleteAttachments?: InputMaybe<Array<Scalars['String']>>;
  mode: Scalars['String'];
  paymentAmt: Scalars['Float'];
  paymentMethod: Scalars['String'];
  paymentRefNo?: InputMaybe<Scalars['String']>;
  paymentRemark: Scalars['String'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  salePaymentId?: InputMaybe<Scalars['String']>;
  transactionDate?: InputMaybe<Scalars['DateTime']>;
};

export type AddAssignNotaryInput = {
  notariesId: Array<Scalars['String']>;
};

export type AddBankInput = {
  code: Scalars['String'];
  name: Scalars['String'];
};

export type AddBankPaymentInput = {
  bankAccountId: Scalars['String'];
  billList?: InputMaybe<Array<AllocationListing>>;
  description: Scalars['String'];
  documentDate: Scalars['DateTime'];
  file?: InputMaybe<Array<Scalars['Upload']>>;
  financierId: Scalars['String'];
  refNo: Scalars['String'];
  status: CreditControlStatus;
};

export type AddBillItemInput = {
  billItemType: BillItem;
  classificationId?: InputMaybe<Scalars['String']>;
  msicId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type AddCarParkInput = {
  discountAmt?: InputMaybe<Scalars['Float']>;
  discountId?: InputMaybe<Scalars['String']>;
  isIncludeContract?: InputMaybe<Scalars['Boolean']>;
  paymentPlanId?: InputMaybe<Scalars['String']>;
  paymentPlanSummary?: InputMaybe<Array<BasePaymentPlanSummary>>;
  projectCarparkPaymentPlanId?: InputMaybe<Scalars['String']>;
  saleId: Scalars['String'];
  sellingMethod?: InputMaybe<Scalars['String']>;
  sellingPrice: Scalars['Float'];
  taxSchemeId?: InputMaybe<Scalars['String']>;
  unitId: Scalars['String'];
};

export type AddCarParkUnitTransferInput = {
  discountAmt?: InputMaybe<Scalars['Float']>;
  discountId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isIncludeContract?: InputMaybe<Scalars['Boolean']>;
  paymentPlanId?: InputMaybe<Scalars['String']>;
  paymentPlanSummary?: InputMaybe<Array<BasePaymentPlanSummary>>;
  sellingMethod?: InputMaybe<Scalars['String']>;
  sellingPrice: Scalars['Float'];
  taxSchemeId?: InputMaybe<Scalars['String']>;
  unitId: Scalars['String'];
  unitNo?: InputMaybe<Scalars['String']>;
};

export type AddCommissionPaymentInput = {
  paidToDate: Scalars['Float'];
  refId: Scalars['ID'];
  refTable: Scalars['String'];
  release: Scalars['Float'];
  remarks: Scalars['String'];
};

export type AddCommissionStatutoryDocumentInput = {
  commissionPaymentId: Scalars['ID'];
  statutoryDocId: Scalars['ID'];
};

export type AddCompanyBankAccountInput = {
  accountNo: Scalars['String'];
  accountType: BankAccountType;
  code: Scalars['String'];
  companyId: Scalars['String'];
  currency?: InputMaybe<Scalars['String']>;
  effectiveDate: Scalars['DateTime'];
  swiftCode?: InputMaybe<Scalars['String']>;
};

export type AddCompanyBankProfileInput = {
  address?: InputMaybe<Scalars['String']>;
  companyId: Scalars['String'];
  inputBankAccount?: InputMaybe<Array<AddCompanyBankAccountInput>>;
  name: Scalars['String'];
  phoneNo: Scalars['String'];
};

export type AddCompanyInput = {
  companyCode: Scalars['String'];
  companyDesc: Scalars['String'];
  companyName: Scalars['String'];
  eInvEndDate?: InputMaybe<Scalars['DateTime']>;
  eInvStartDate?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  eSign?: InputMaybe<Scalars['String']>;
  eSignExpiryDate?: InputMaybe<Scalars['DateTime']>;
  groupGstRegNo?: InputMaybe<Scalars['String']>;
  gstRegNo?: InputMaybe<Scalars['String']>;
  isEinvIntegrated: Scalars['Boolean'];
  logoUrl?: InputMaybe<Scalars['String']>;
  officeAddress: AddressJsonInput;
  officeTelNo: Scalars['String'];
  regNo: Scalars['String'];
  sstRegNo?: InputMaybe<Scalars['String']>;
  tin?: InputMaybe<Scalars['String']>;
};

export type AddCountryCodeInput = {
  code: Scalars['String'];
  name: Scalars['String'];
};

export type AddDownpaymentReminderInput = {
  input: Array<DownpaymentReminderInput>;
};

export type AddEditApprovalAssignmentInput = {
  approvalListForm: Array<ApprovalAssignmentListFormInput>;
  category?: InputMaybe<Scalars['String']>;
};

export type AddEditApprovalPolicyInput = {
  approvalListForm: Array<ApprovalListFormInput>;
  category?: InputMaybe<Scalars['String']>;
};

export type AddEmailLogSchemeInput = {
  bccEmails?: InputMaybe<Scalars['String']>;
  ccEmails?: InputMaybe<Scalars['String']>;
  content: Scalars['String'];
  errorMessage?: InputMaybe<Scalars['String']>;
  isEmailSent: Scalars['Boolean'];
  recipientEmail: Scalars['String'];
  refId: Scalars['String'];
  refType: Scalars['String'];
  subject: Scalars['String'];
};

export type AdditionalPackageInstallmentDetail = {
  __typename?: 'additionalPackageInstallmentDetail';
  allocationAmount?: Maybe<Scalars['Float']>;
  billType?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  documentAmount?: Maybe<Scalars['Float']>;
  documentDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  transactionDate?: Maybe<Scalars['DateTime']>;
};

export type AdditionalPackagesPaymentPlanOutput = {
  __typename?: 'additionalPackagesPaymentPlanOutput';
  additionalPackageInstallmentDetail?: Maybe<Array<AdditionalPackageInstallmentDetail>>;
  creditTerm?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  sellingPrice?: Maybe<Scalars['Float']>;
};

export type AddJobPositionInput = {
  positionName: Scalars['String'];
  projectId: Scalars['String'];
};

export type AddLadInput = {
  byFacilityDate?: InputMaybe<Scalars['DateTime']>;
  byUnitDate: Scalars['DateTime'];
  commonFacility: Scalars['Boolean'];
  contraDate: Scalars['DateTime'];
  facilityLadDuration?: InputMaybe<Scalars['Float']>;
  facilityLadPercent?: InputMaybe<Scalars['Float']>;
  isSimulate: Scalars['Boolean'];
  ladUnitDetails?: InputMaybe<Array<AddLadUnitInput>>;
  payoutPercent: Scalars['Float'];
  spaPercent: Scalars['Float'];
  startWith: LadType;
  taxSchemeId?: InputMaybe<Scalars['String']>;
  unitDuration: Scalars['Float'];
  unitLadPercent: Scalars['Float'];
};

export type AddLadUnitInput = {
  facilityDueDays?: InputMaybe<Scalars['Float']>;
  facilityLadAmount?: InputMaybe<Scalars['Float']>;
  saleId: Scalars['String'];
  totalTaxAmount: Scalars['Float'];
  totalUnitFacilityAmountWithoutTax: Scalars['Float'];
  unitDueDays: Scalars['Float'];
  unitId: Scalars['String'];
  unitLadAmount: Scalars['Float'];
  unitNo: Scalars['String'];
};

export type AddLateInterestInput = {
  enableFloatingInterest?: InputMaybe<Scalars['Boolean']>;
  excludeHolidays?: InputMaybe<Scalars['Boolean']>;
  excludePayment?: InputMaybe<Scalars['Boolean']>;
  loanGracePeriod: Scalars['Float'];
  loanGracePeriodStartWith: ProjectLateInterestEnum;
  minInterestAmt: Scalars['Float'];
  projectID: Scalars['String'];
  taxSchemeId: Scalars['String'];
};

export type AddLoanPaymentInput = {
  bankAccountId: Scalars['String'];
  documentAmt: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  saleLoanPaymentPlanDetails?: InputMaybe<Array<SaleLoanNoticeInput>>;
  saleloanReleaseNotificationId: Scalars['String'];
};

export type AddLoanSettlementInput = {
  rrSolicitors?: InputMaybe<Array<RrSolicitorInput>>;
  saleId: Scalars['String'];
};

export type AddMotTrackingInput = {
  confirmationPresentationReceipt: Scalars['DateTime'];
  forwardMotComSec: Scalars['DateTime'];
  forwardMotDirector: Scalars['DateTime'];
  instructionToSolicitor: Scalars['DateTime'];
  motIn: Scalars['DateTime'];
  motMortgageDate: Scalars['DateTime'];
  motMortgageNo?: InputMaybe<Scalars['String']>;
  motOut: Scalars['DateTime'];
  motReceiptNo?: InputMaybe<Scalars['String']>;
  motSolicitorId: Scalars['String'];
  motSolicitorReferenceNo?: InputMaybe<Scalars['String']>;
  motSubmissionDate: Scalars['DateTime'];
  motSubmissionNo?: InputMaybe<Scalars['String']>;
  motTransferDate: Scalars['DateTime'];
  projectId: Scalars['String'];
  receivedFrom?: InputMaybe<Scalars['String']>;
  receivedTitleDutyTransferred: Scalars['DateTime'];
  receiveLawyerAcknowledgement: Scalars['DateTime'];
  receiveMotCancellation: Scalars['DateTime'];
  receiveMotComSec: Scalars['DateTime'];
  receiveMotDirector: Scalars['DateTime'];
  releaseForTitle: Scalars['DateTime'];
  remark?: InputMaybe<Scalars['String']>;
  requestForTitle: Scalars['DateTime'];
  saleId?: InputMaybe<Scalars['String']>;
  stampDutyPayment: Scalars['Float'];
  stampDutyPaymentDate: Scalars['DateTime'];
  titleExecutionDate: Scalars['DateTime'];
  titleForward: Scalars['DateTime'];
  titleNotificationDate: Scalars['DateTime'];
};

export type AddNewPurchaserTransferInput = {
  address?: InputMaybe<AddressJsonInput>;
  addressListing?: InputMaybe<Array<AddressJsonInput>>;
  allowedSendingMarketingMaterial?: InputMaybe<Scalars['Boolean']>;
  bookingAttachment?: InputMaybe<Array<Scalars['Upload']>>;
  commonStatus?: InputMaybe<Scalars['String']>;
  companyPurchase?: InputMaybe<Scalars['Boolean']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  fullName: Scalars['String'];
  gender: Scalars['String'];
  homeTelNo?: InputMaybe<Scalars['String']>;
  identityNo: Scalars['String'];
  identityType: Scalars['String'];
  incomeRange?: InputMaybe<Scalars['String']>;
  isVip?: InputMaybe<Scalars['Boolean']>;
  mailingMethod?: InputMaybe<Scalars['String']>;
  maritalStatusId?: InputMaybe<Scalars['String']>;
  mobileNo: Scalars['String'];
  nationalityId: Scalars['String'];
  officeNo?: InputMaybe<Scalars['String']>;
  professionId?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
  religionId?: InputMaybe<Scalars['String']>;
  remarks?: InputMaybe<Scalars['String']>;
  salutationId?: InputMaybe<Scalars['String']>;
  subscribeMaterialEmail?: InputMaybe<Scalars['Boolean']>;
  subscribeMaterialSms?: InputMaybe<Scalars['Boolean']>;
  subscribeMaterialWeChat?: InputMaybe<Scalars['Boolean']>;
  subscribeMaterialWhatsApp?: InputMaybe<Scalars['Boolean']>;
  taxRegAddress?: InputMaybe<Scalars['String']>;
  taxRegName?: InputMaybe<Scalars['String']>;
  taxRegNo?: InputMaybe<Scalars['String']>;
  unitId: Scalars['String'];
};

export type AddNewUnitBookingInput = {
  bookDate?: InputMaybe<Scalars['DateTime']>;
  jointBuyers: Array<AddNewUnitBookingPurchaserInput>;
  mainPurchaser: AddNewUnitBookingPurchaserInput;
};

export type AddNewUnitBookingPurchaserInput = {
  addressList?: InputMaybe<Array<AddressJsonInput>>;
  addressListing?: InputMaybe<Array<AddressJsonInput>>;
  allowedSendingMarketingMaterial?: InputMaybe<Scalars['Boolean']>;
  bookingAttachment?: InputMaybe<Array<Scalars['Upload']>>;
  companyName?: InputMaybe<Scalars['String']>;
  companyPurchase?: InputMaybe<Scalars['Boolean']>;
  companyRegNo?: InputMaybe<Scalars['String']>;
  contactExtId?: InputMaybe<Scalars['String']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  fullName: Scalars['String'];
  gender: Scalars['String'];
  homeTelNo?: InputMaybe<Scalars['String']>;
  identityNo: Scalars['String'];
  identityType: Scalars['String'];
  incomeRange?: InputMaybe<Scalars['String']>;
  isForeignPurchase?: InputMaybe<Scalars['Boolean']>;
  isVip?: InputMaybe<Scalars['Boolean']>;
  mailingMethod?: InputMaybe<Scalars['String']>;
  maritalStatusId?: InputMaybe<Scalars['String']>;
  mobileNo: Scalars['String'];
  nationalityId: Scalars['String'];
  officeNo?: InputMaybe<Scalars['String']>;
  professionId?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
  religionId?: InputMaybe<Scalars['String']>;
  remarks?: InputMaybe<Scalars['String']>;
  salutationId?: InputMaybe<Scalars['String']>;
  subscribeMaterialEmail?: InputMaybe<Scalars['Boolean']>;
  subscribeMaterialSms?: InputMaybe<Scalars['Boolean']>;
  subscribeMaterialWeChat?: InputMaybe<Scalars['Boolean']>;
  subscribeMaterialWhatsApp?: InputMaybe<Scalars['Boolean']>;
  taxRegAddress?: InputMaybe<Scalars['String']>;
  taxRegName?: InputMaybe<Scalars['String']>;
  taxRegNo?: InputMaybe<Scalars['String']>;
  unitId: Scalars['String'];
};

export type AddNumberingFormatDetailInput = {
  formatType: DocumentNumberDetailTypeEnum;
  formatValue: Scalars['String'];
  resetBy?: InputMaybe<Scalars['String']>;
  seqNo?: InputMaybe<Scalars['Float']>;
  startFrom?: InputMaybe<Scalars['Float']>;
};

export type AddNumberingFormatInput = {
  companyId: Scalars['String'];
  inputNumberingFormatDetail?: InputMaybe<Array<AddNumberingFormatDetailInput>>;
  refTable: Scalars['String'];
  sampleOutput: Scalars['String'];
  type: DocumentNumberHeaderTypeIndoEnum;
};

export type AddOnRef = {
  __typename?: 'addOnRef';
  data?: Maybe<Array<Data>>;
  titleBar?: Maybe<Scalars['String']>;
};

export type AddOverduePurchaseCaInput = {
  activityDate: Scalars['DateTime'];
  activityRemark: Scalars['String'];
  activityStatus?: InputMaybe<Scalars['String']>;
  attachments?: InputMaybe<Array<Scalars['Upload']>>;
  overduePurchaserAccountId: Scalars['String'];
  saleId: Scalars['String'];
};

export type AddPackageInput = {
  numRow?: InputMaybe<Scalars['Float']>;
  openMarketValue?: InputMaybe<Scalars['Float']>;
  packageId: Scalars['String'];
  paymentPlanId?: InputMaybe<Scalars['String']>;
  paymentPlanSummary?: InputMaybe<Array<BasePaymentPlanSummary>>;
  projectPackagePaymentPlanId?: InputMaybe<Scalars['String']>;
  saleId: Scalars['String'];
  sellingMethod: Scalars['String'];
  sellingPrice?: InputMaybe<Scalars['Float']>;
  taxSchemeId?: InputMaybe<Scalars['String']>;
};

export type AddPackageUnitTransferInput = {
  openMarketValue?: InputMaybe<Scalars['Float']>;
  packageId: Scalars['String'];
  paymentPlanId?: InputMaybe<Scalars['String']>;
  paymentPlanSummary?: InputMaybe<Array<BasePaymentPlanSummary>>;
  sellingMethod: Scalars['String'];
  sellingPrice?: InputMaybe<Scalars['Float']>;
  taxSchemeId?: InputMaybe<Scalars['String']>;
};

export type AddPaCollectionActivityListingInput = {
  activityDate: Scalars['DateTime'];
  activityRemark: Scalars['String'];
  activityStatus?: InputMaybe<Scalars['String']>;
  attachments?: InputMaybe<Array<Scalars['Upload']>>;
  saleId: Scalars['String'];
};

export type AddPAdebitNoteInput = {
  allocationList?: InputMaybe<Array<AllocationList>>;
  amount: Scalars['Float'];
  attachments?: InputMaybe<Array<Scalars['Upload']>>;
  billItemId: Scalars['String'];
  creditTerm: Scalars['Float'];
  description?: InputMaybe<Scalars['String']>;
  documentAmount: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  documentRef?: InputMaybe<Scalars['String']>;
  interestRate: Scalars['Float'];
  projectId: Scalars['String'];
  requestedBy?: InputMaybe<Scalars['String']>;
  saleId: Scalars['String'];
  taxDetails?: InputMaybe<Array<TaxDetailsAfterCalculation>>;
  taxSchemeDetailId?: InputMaybe<Scalars['String']>;
  taxSchemeId: Scalars['String'];
};

export type AddPaLateInterestInput = {
  generateDate: Scalars['DateTime'];
  lateInterestList: Array<PaLateInterestInput>;
  saleId: Scalars['String'];
};

export type AddPaMiscBillingInput = {
  allocationList?: InputMaybe<Array<AllocationList>>;
  amount: Scalars['Float'];
  attachments?: InputMaybe<Array<Scalars['Upload']>>;
  billItemId: Scalars['String'];
  creditTerm: Scalars['Float'];
  description?: InputMaybe<Scalars['String']>;
  documentAmount: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  documentRef?: InputMaybe<Scalars['String']>;
  interestRate: Scalars['Float'];
  projectId: Scalars['String'];
  requestedBy?: InputMaybe<Scalars['String']>;
  saleId: Scalars['String'];
  taxDetails?: InputMaybe<Array<TaxDetailsAfterCalculation>>;
  taxSchemeDetailId?: InputMaybe<Scalars['String']>;
  taxSchemeId: Scalars['String'];
};

export type AddPAmoduleDataInput = {
  allocationList?: InputMaybe<Array<AllocationList>>;
  amount: Scalars['Float'];
  attachments?: InputMaybe<Array<Scalars['Upload']>>;
  billItemId: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  documentAmount: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  documentRef?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
  requestedBy?: InputMaybe<Scalars['String']>;
  saleId: Scalars['String'];
  taxDetails?: InputMaybe<Array<TaxDetailsAfterCalculation>>;
  taxSchemeDetailId?: InputMaybe<Scalars['String']>;
  taxSchemeId: Scalars['String'];
};

export type AddPavSettingInput = {
  taxId: Scalars['String'];
};

export type AddPaymentinterestExceptionInput = {
  remark: Scalars['String'];
  saleId: Scalars['String'];
};

export type AddPaymentPlanDetailInput = {
  amountType: AmountType;
  amountValue: Scalars['Float'];
  detailId: Scalars['String'];
  includeIn?: InputMaybe<Array<IncludeInDetailInput>>;
  installmentBillingDay?: InputMaybe<Scalars['Float']>;
  isDownpayment?: InputMaybe<Scalars['Boolean']>;
  isStakeholder?: InputMaybe<Scalars['Boolean']>;
  isVpStage?: InputMaybe<Scalars['Boolean']>;
  isWithInterest?: InputMaybe<Scalars['Boolean']>;
  numberOfPayment?: InputMaybe<Scalars['Float']>;
  paymentPlanId?: InputMaybe<Scalars['String']>;
  stageSeqNo?: InputMaybe<Scalars['Float']>;
  stakeholderDuration?: InputMaybe<Scalars['Float']>;
  title: Scalars['String'];
  workProgressId: Scalars['String'];
};

export type AddPaymentPlanInput = {
  effectiveDate: Scalars['DateTime'];
  inputPaymentPlanDetail?: InputMaybe<Array<AddPaymentPlanDetailInput>>;
  name: Scalars['String'];
  payMethod?: InputMaybe<Scalars['String']>;
};

export type AddPaymentReminderInput = {
  balanceAmount?: InputMaybe<Scalars['Float']>;
  finalTaxToDate?: InputMaybe<Scalars['Float']>;
  intervalDays?: InputMaybe<Scalars['Float']>;
  maxReminder?: InputMaybe<Scalars['Float']>;
  paidToDate?: InputMaybe<Scalars['Float']>;
  refId?: InputMaybe<Scalars['String']>;
  refTable?: InputMaybe<Scalars['String']>;
  refundAmt?: InputMaybe<Scalars['Float']>;
  reminderDate?: InputMaybe<Scalars['DateTime']>;
  reminderSeq?: InputMaybe<Scalars['Float']>;
  saleId?: InputMaybe<Scalars['String']>;
  taxSchemeId?: InputMaybe<Scalars['String']>;
  taxToDate?: InputMaybe<Scalars['Float']>;
  unitNo?: InputMaybe<Scalars['String']>;
};

export type AddPriceAdjustmentInput = {
  computationMode: Scalars['String'];
  computationValue: Scalars['Float'];
  name: Scalars['String'];
  projectId: Scalars['String'];
  reason: Scalars['String'];
  remark?: InputMaybe<Scalars['String']>;
  roundingMode: Scalars['String'];
  roundingPrecision: Scalars['String'];
  status: Scalars['String'];
  unitIdList: Array<Scalars['String']>;
};

export type AddProjectAreaVarianceInputIndonesia = {
  effectiveDate: Scalars['DateTime'];
  formula?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  projectId: Scalars['String'];
};

export type AddProjectClusterInput = {
  desc: Scalars['String'];
  developmentCompany: Scalars['String'];
  name: Scalars['String'];
  projectId: Scalars['String'];
};

export type AddProjectCommissionInput = {
  commissionTypeId: Scalars['ID'];
  description: Scalars['String'];
  projectId: Scalars['String'];
  rateClassification: Scalars['String'];
};

export type AddProjectMiscChargesInput = {
  billItemId: Scalars['String'];
  formula?: InputMaybe<Scalars['String']>;
  interestRate: Scalars['Float'];
  remark?: InputMaybe<Scalars['String']>;
  taxSchemeId: Scalars['String'];
};

export type AddProjectPaymentPlanInput = {
  defaulted: Scalars['Boolean'];
  endDate: Scalars['DateTime'];
  paymentPlanId: Scalars['String'];
  projectId: Scalars['String'];
  startDate: Scalars['DateTime'];
  typePaymentPlan: TypePaymentPlanEnum;
};

export type AddProjectPermitInput = {
  expiryDate: Scalars['DateTime'];
  issueDate: Scalars['DateTime'];
  permitNo: Scalars['String'];
  permitType: PermitType;
  projectId: Scalars['String'];
};

export type AddProjectPolicyInput = {
  creditTerms: Scalars['Float'];
  interestRate: Scalars['Float'];
  projectId: Scalars['String'];
  roundingMode: RoundingMode;
  roundingPrecision: RoundingPrecision;
};

export type AddProjectRedemptionInput = {
  taxId: Scalars['String'];
};

export type AddProjectReminderInput = {
  paymentReminder1: Scalars['Float'];
  paymentReminder2: Scalars['Float'];
  paymentReminder3: Scalars['Float'];
  paymentReminder4: Scalars['Float'];
  paymentReminderScheduler: Scalars['Boolean'];
  paymentReminderSchedulerTime?: InputMaybe<Scalars['String']>;
};

export type AddProjectSalesPolicyDetailsInput = {
  depositAmount?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['String']>;
  landAreaFrom?: InputMaybe<Scalars['Float']>;
  landAreaTo?: InputMaybe<Scalars['Float']>;
};

export type AddProjectSalesPolicyInput = {
  collectLandDeposit: Scalars['Boolean'];
  DepositAmount?: InputMaybe<Scalars['Float']>;
  generateOverdueDebtorEvery?: InputMaybe<Scalars['String']>;
  generateOverdueDebtorTime?: InputMaybe<Scalars['String']>;
  interestBasicRate: Scalars['String'];
  interestRate: Scalars['Float'];
  minimumDepositAmount?: InputMaybe<Scalars['Float']>;
  npvBasicRate?: InputMaybe<Scalars['String']>;
  npvRate?: InputMaybe<Scalars['Float']>;
  projectSalesPolicyDetailsArray?: InputMaybe<Array<AddProjectSalesPolicyDetailsInput>>;
  roundingMode: Scalars['String'];
  roundingPrecision: Scalars['String'];
  taxSchemeId?: InputMaybe<Scalars['String']>;
};

export type AddProjectTitleInput = {
  expiryDate: Scalars['DateTime'];
  issueDate: Scalars['DateTime'];
  projectId: Scalars['String'];
  receiveDate: Scalars['DateTime'];
  remark?: InputMaybe<Scalars['String']>;
  titleNo: Scalars['String'];
  titleType: ProjectTitleType;
  unitId: Array<Scalars['String']>;
};

export type AddPromotionalItemInput = {
  cost: Scalars['Float'];
  description: Scalars['String'];
  name: Scalars['String'];
  projectId: Scalars['String'];
};

export type AddPromotionalPackagesInput = {
  addPromotionalPackagesItemInput: Array<AddPromotionalPackagesItemInput>;
  endDate: Scalars['DateTime'];
  name: Scalars['String'];
  startDate: Scalars['DateTime'];
};

export type AddPromotionalPackagesItemInput = {
  costPrice: Scalars['Float'];
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  promoPrice: Scalars['Float'];
  promotionalItemId: Scalars['String'];
  promotionalPackagesId?: InputMaybe<Scalars['String']>;
};

export type AddPurchaserIdTypeInput = {
  description: Scalars['String'];
  identityDoc: Scalars['String'];
};

export type AddPurchaserPaymentPlanDetailsOutput = {
  __typename?: 'addPurchaserPaymentPlanDetailsOutput';
  id?: Maybe<Scalars['String']>;
};

export type AddPurchaserPaymentPlanInput = {
  addPurchaserPaymentPlanDetailsInput?: InputMaybe<Array<AddPurchaserPaymentPlantDetailsInput>>;
  effectiveDate: Scalars['DateTime'];
  markUpPercentage: Scalars['Float'];
  name: Scalars['String'];
};

export type AddPurchaserPaymentPlantDetailsInput = {
  billAfter: Scalars['String'];
  billCount: Scalars['Float'];
  billFrequency: Scalars['String'];
  billType: Scalars['String'];
  deductBookingFee: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  installmentNum: Scalars['Float'];
  paymentBy: Scalars['String'];
  paymentValue: Scalars['Float'];
  title: Scalars['String'];
};

export type AddPurchaserTransferInput = {
  adminFee: Scalars['Float'];
  approvalStatus: Scalars['String'];
  documentNo: Scalars['String'];
  jointBuyers: Array<AddNewPurchaserTransferInput>;
  mainBuyerContactId: Scalars['String'];
  mainPurchaser: AddNewPurchaserTransferInput;
  miscBillId: Scalars['String'];
  projectId: Scalars['String'];
  purchaserTransferId?: InputMaybe<Scalars['String']>;
  saleId: Scalars['String'];
  transferDate: Scalars['DateTime'];
};

export type AddRefinancingInput = {
  financierList: Array<FinancierListInput>;
  id: Scalars['String'];
  table: Scalars['String'];
};

export type AddRefundDataInput = {
  allocationList?: InputMaybe<Array<AllocationList>>;
  attachments?: InputMaybe<Array<Scalars['Upload']>>;
  bankAccountId?: InputMaybe<Scalars['String']>;
  chequeDate?: InputMaybe<Scalars['DateTime']>;
  chequeExpireDate?: InputMaybe<Scalars['DateTime']>;
  creditCardType?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  documentAmount: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  documentRef?: InputMaybe<Scalars['String']>;
  glGenerated?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
  refundMethod: Scalars['String'];
  saleId: Scalars['String'];
};

/** JsonType */
export type Address = {
  __typename?: 'Address';
  address?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  AddressType?: Maybe<AddressType>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  ID?: Maybe<Scalars['String']>;
  postCode?: Maybe<Scalars['String']>;
  postCodeName?: Maybe<Scalars['String']>;
  siteName?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type AddressInput = {
  address?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  AddressType?: InputMaybe<AddressType>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  district?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['String']>;
  postCode?: InputMaybe<Scalars['String']>;
  postCodeName?: InputMaybe<Scalars['String']>;
  siteName?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

export type AddressJson = {
  __typename?: 'AddressJson';
  address?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  AddressType?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  postCode?: Maybe<Scalars['String']>;
  postCodeName?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  subdistrict?: Maybe<Scalars['String']>;
};

export type AddressJsonInput = {
  address?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  AddressType?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  district?: InputMaybe<Scalars['String']>;
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  postCode?: InputMaybe<Scalars['String']>;
  postCodeName?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  subdistrict?: InputMaybe<Scalars['String']>;
};

export type AddressList = {
  __typename?: 'addressList';
  address?: Maybe<AddressJson>;
  addressType: Scalars['String'];
  isPrimary: Scalars['Boolean'];
};

export type AddressPaymentReminder = {
  __typename?: 'addressPaymentReminder';
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  postCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export enum AddressType {
  Delivery = 'DELIVERY',
  Primary = 'PRIMARY',
  Site = 'SITE'
}

export type AddSaleLoanBuyBackListInput = {
  approvalStatus: Scalars['String'];
  bankAccountId: Scalars['String'];
  buyBackAmount: Scalars['Float'];
  buyBackDate: Scalars['DateTime'];
  financierId: Scalars['String'];
  loanRefRecordId: Scalars['String'];
  loanRefTable: Scalars['String'];
  oldBalance: Array<OldBalanceBuyBackInput>;
  projectId: Scalars['String'];
  remarks: Scalars['String'];
  saleId: Scalars['String'];
};

export type AddSaleLoanCancellationInput = {
  cancelDate: Scalars['DateTime'];
  cancelReason: Scalars['String'];
  cancelRemark?: InputMaybe<Scalars['String']>;
  saleId?: InputMaybe<Scalars['String']>;
  status: Scalars['String'];
};

export type AddSaleLoanDetailInput = {
  borrowerAddress: AddressJsonInput;
  borrowerName: Scalars['String'];
  cancelDate?: InputMaybe<Scalars['String']>;
  cancelReason?: InputMaybe<Scalars['String']>;
  financierId: Scalars['String'];
  financierReference: Scalars['String'];
  generationBatchDate?: InputMaybe<Scalars['DateTime']>;
  generationId?: InputMaybe<Scalars['String']>;
  loanAmount: Scalars['Float'];
  loanApprovalDate?: InputMaybe<Scalars['DateTime']>;
  loanLimit: Scalars['Float'];
  loanLooDate?: InputMaybe<Scalars['DateTime']>;
  loanPercentage: Scalars['Float'];
  loanPeriod?: InputMaybe<Scalars['Float']>;
  loanSeqno: Scalars['Float'];
  loanSignDate?: InputMaybe<Scalars['DateTime']>;
  remark: Scalars['String'];
  renoticeDate?: InputMaybe<Scalars['DateTime']>;
  rrDate?: InputMaybe<Scalars['DateTime']>;
  rrSolicitorId?: InputMaybe<Scalars['String']>;
  rrSolicitorReferenceNo?: InputMaybe<Scalars['String']>;
  saleId?: InputMaybe<Scalars['String']>;
  solicitorId: Scalars['String'];
  solicitorReference: Scalars['String'];
  taxSchemeId: Scalars['String'];
  totalLoanAmount: Scalars['Float'];
};

export type AddSaleLoanInput = {
  inputSaleLoanDetail?: InputMaybe<Array<AddSaleLoanDetailInput>>;
  saleId: Scalars['String'];
};

export type AddSaleLoanRefinancingInput = {
  approvalStatus: Scalars['String'];
  borrowerAcct: Scalars['String'];
  borrowerName: Scalars['String'];
  endfinancierMortgageId: Scalars['String'];
  loanRefRecordId: Scalars['String'];
  loanRefTable: Scalars['String'];
  newFinancierId: Scalars['String'];
  oldBalance: Array<OldBalanceInput>;
  paymentPlan: Array<NewPaymentPlanInput>;
  projectId: Scalars['String'];
  refinancingDate: Scalars['DateTime'];
  remarks?: InputMaybe<Scalars['String']>;
  saleId: Scalars['String'];
};

export type AddSalesCancellationInput = {
  cancellationDate: Scalars['DateTime'];
  cancelReason: Scalars['String'];
  chargeFinalTax?: InputMaybe<Scalars['Boolean']>;
  finalTaxToDate: Scalars['Float'];
  forfeitureSum: Scalars['Float'];
  refundAmt: Scalars['Float'];
  refundTax?: InputMaybe<Scalars['Boolean']>;
  remark: Scalars['String'];
  saleId: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
  taxSchemeId: Scalars['String'];
  taxToDate: Scalars['Float'];
};

export type AddSalesContractContactInput = {
  ContactNo: Scalars['String'];
  Email?: InputMaybe<Scalars['String']>;
  IsPrimary: Scalars['Boolean'];
  Name: Scalars['String'];
  OfficeTel?: InputMaybe<Scalars['String']>;
  RelationshipID?: InputMaybe<Scalars['String']>;
  Remark?: InputMaybe<Scalars['String']>;
  SalutationID?: InputMaybe<Scalars['String']>;
};

export type AddSalesContractDiscountInput = {
  discountAmount: Scalars['Float'];
  discountID: Scalars['String'];
  discountMethod: Scalars['String'];
  formula: Scalars['String'];
};

export type AddSalesContractPackageInput = {
  OpenMarketValue: Scalars['Float'];
  PackageID: Scalars['String'];
  PaymentPlanID?: InputMaybe<Scalars['String']>;
  sellingMethod: Scalars['String'];
  SellingPrice: Scalars['Float'];
  taxSchemeId: Scalars['String'];
  workProgressId: Scalars['String'];
};

export type AddSalesContractRebateInput = {
  campaignId: Scalars['String'];
  discountAmount: Scalars['Float'];
  discountId: Scalars['String'];
  discountMethod: Scalars['String'];
  roundingMode: Scalars['String'];
  roundingPrecision: Scalars['String'];
  saleId: Scalars['String'];
  workProgressId: Scalars['String'];
};

export type AddSalesContractSubproductInput = {
  PaymentPlanID?: InputMaybe<Scalars['String']>;
  SellingMethod: Scalars['String'];
  SellingPrice: Scalars['Float'];
};

export type AddSalesExtensionInput = {
  buyerReference: Scalars['String'];
  campaignId?: InputMaybe<Scalars['String']>;
  creditTerm?: InputMaybe<Scalars['Float']>;
  developerReference: Scalars['String'];
  discardBumiDiscount: Scalars['Boolean'];
  isCashBuyer: Scalars['Boolean'];
  isGenerateInterest: Scalars['Boolean'];
  isGenerateReminder: Scalars['Boolean'];
  loanGracePeriod?: InputMaybe<Scalars['Float']>;
  paymentPlanID: Scalars['String'];
  salesPerson?: InputMaybe<Scalars['String']>;
  salesType: SalesType;
  totalSalesValue: Scalars['Float'];
};

export type AddSalesPackageInput = {
  defaulted: Scalars['Boolean'];
  desc: Scalars['String'];
  endDate: Scalars['DateTime'];
  id?: InputMaybe<Scalars['String']>;
  listPrice: Scalars['Float'];
  marketValue: Scalars['Float'];
  name: Scalars['String'];
  projectId: Scalars['String'];
  startDate: Scalars['DateTime'];
  taxSchemeId: Scalars['String'];
};

export type AddSalesRegistrationDiscountInput = {
  discountAmount: Scalars['Float'];
  discountID: Scalars['String'];
  discountMethod: Scalars['String'];
  formula: Scalars['String'];
};

export type AddSalesStatutoryDocumentIndoInput = {
  bpnLandArea?: InputMaybe<Scalars['Float']>;
  contactId?: InputMaybe<Scalars['String']>;
  document_ref: Scalars['String'];
  documentDate?: InputMaybe<Scalars['DateTime']>;
  file?: InputMaybe<Array<Scalars['Upload']>>;
  notaryId?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
  saleId?: InputMaybe<Scalars['String']>;
  statutoryDocumentId: Scalars['String'];
  unitStatutoryId: Scalars['String'];
};

export type AddSpaReminderInput = {
  input: Array<SpaReminderInput>;
};

export type AddStampDutyInput = {
  code: Scalars['String'];
  description: Scalars['String'];
  details: Array<DetailInput>;
  id: Scalars['String'];
};

export type AddStatutoryDocumentIndoInput = {
  code: Scalars['String'];
  name: Scalars['String'];
  perSalesContract?: InputMaybe<Scalars['Boolean']>;
};

export type AddStatutoryDocumentInput = {
  code: Scalars['String'];
  name: Scalars['String'];
  perSalesContract?: InputMaybe<Scalars['Boolean']>;
};

export type AddSubsaleInput = {
  administrationCharge: Scalars['Float'];
  buyerSolicitorId: Scalars['String'];
  buyerSolicitorReferenceNo: Scalars['String'];
  dmcDate: Scalars['DateTime'];
  doaDate: Scalars['DateTime'];
  JointBuyers?: InputMaybe<Array<AddSubsalePurchaserDetailsInput>>;
  printingCharge: Scalars['Float'];
  PurchaserDetails?: InputMaybe<AddSubsalePurchaserDetailsInput>;
  rrDate: Scalars['DateTime'];
  sellingPrice: Scalars['Float'];
  serviceChargeDeposit: Scalars['Float'];
  spaDate: Scalars['DateTime'];
  subsaleCategory: SubsaleType;
  subsaleLoans?: InputMaybe<Array<AddSubsaleLoanInput>>;
  unitId: Scalars['String'];
  vendorSolicitorId: Scalars['String'];
  vendorSolicitorReferenceNo: Scalars['String'];
};

export type AddSubsaleLoanInput = {
  detailId: Scalars['String'];
  doaDate: Scalars['DateTime'];
  doaSolicitorId: Scalars['String'];
  doaSolicitorReferenceNo: Scalars['String'];
  endFinancierId: Scalars['String'];
  endFinancierReferenceNo: Scalars['String'];
  loanSolicitorId: Scalars['String'];
  loanSolicitorReferenceNo: Scalars['String'];
  rrDate: Scalars['DateTime'];
  rrSolicitorId: Scalars['String'];
  rrSolicitorReferenceNo: Scalars['String'];
};

export type AddSubsalePurchaserDetailsInput = {
  address: AddressJsonInput;
  companyName?: InputMaybe<Scalars['String']>;
  companyPurchase?: InputMaybe<Scalars['Boolean']>;
  companyRegNo?: InputMaybe<Scalars['String']>;
  detailId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  gender?: InputMaybe<Scalars['String']>;
  homeTelNo?: InputMaybe<Scalars['String']>;
  identityNo: Scalars['String'];
  maritalStatus?: InputMaybe<Scalars['String']>;
  mobileNo: Scalars['String'];
  name: Scalars['String'];
  nationality: Scalars['String'];
  newPurchaserExt?: InputMaybe<ContactExt>;
  officeTelNo?: InputMaybe<Scalars['String']>;
  race?: InputMaybe<Scalars['String']>;
  salutation?: InputMaybe<Scalars['String']>;
};

export type AddTaxInput = {
  classType: Scalars['String'];
  code: Scalars['String'];
  description: Scalars['String'];
  isClaimable: Scalars['Boolean'];
  isFinal: Scalars['Boolean'];
  schemeTypeId: Scalars['String'];
  taxDetail: Array<TaxDetail>;
};

export type AddTaxSchemeDetailInput = {
  detailId: Scalars['String'];
  effectiveDate: Scalars['DateTime'];
  taxSchemeDetailItem?: InputMaybe<Array<AddTaxSchemeDetailItemInput>>;
};

export type AddTaxSchemeDetailItemInput = {
  classType: Scalars['String'];
  computeMethod: ComputeMethod;
  detailId: Scalars['String'];
  detailItemId: Scalars['String'];
  seqNo?: InputMaybe<Scalars['Float']>;
  taxId: Scalars['String'];
  taxOnSeq?: InputMaybe<Array<TaxOnSeq>>;
};

export type AddTaxSchemeInput = {
  description?: InputMaybe<Scalars['String']>;
  isExclusive?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  taxSchemeDetail?: InputMaybe<Array<AddTaxSchemeDetailInput>>;
};

export type AddTownshipInput = {
  code: Scalars['String'];
  companyId: Scalars['String'];
  file?: InputMaybe<Scalars['Upload']>;
  location: Scalars['String'];
  logo_url?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  seq_no?: InputMaybe<Scalars['Float']>;
};

export type AddUnitStatutoryDocumentIndoInput = {
  unitStatutoryDocument: Array<UnitStatutoryDocument>;
};

export type AddUnitTransferIndoInput = {
  adminFee?: InputMaybe<Scalars['Float']>;
  cancelReasonId: Scalars['String'];
  newUnitId: Scalars['String'];
  oldUnitId: Scalars['String'];
  saleInfo?: InputMaybe<SalesRegistrationInput>;
};

export type AddUnitTransferInput = {
  administrationCharges?: InputMaybe<Scalars['Float']>;
  discount?: InputMaybe<UnitTansferDiscountInput>;
  newListPrice: Scalars['Float'];
  newSellingPrice: Scalars['Float'];
  newUnitId: Scalars['String'];
  oldSaleDetail?: InputMaybe<UnitTransferOldSaleDetailInput>;
  oldSellingPrice: Scalars['Float'];
  oldUnitId?: InputMaybe<Scalars['String']>;
  paymentMethod?: InputMaybe<Scalars['String']>;
  paymentPlanId: Scalars['String'];
  reason: Scalars['String'];
  remark?: InputMaybe<Scalars['String']>;
  saleId?: InputMaybe<Scalars['String']>;
  status: Scalars['String'];
  transferDate: Scalars['DateTime'];
};

export type AdminAddPanelInput = {
  financier_id?: InputMaybe<Scalars['String']>;
  is_panel: Scalars['Boolean'];
  project_id: Scalars['String'];
};

export type AdminCampaignInput = {
  endDate: Scalars['DateTime'];
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  projectId?: InputMaybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
};

export type AdminEditGalleryInput = {
  block?: InputMaybe<Scalars['String']>;
  bucket_file_name?: InputMaybe<Scalars['String']>;
  caption?: InputMaybe<Scalars['String']>;
  delete?: InputMaybe<Scalars['Boolean']>;
  file_name?: InputMaybe<Scalars['String']>;
  floor?: InputMaybe<Scalars['Float']>;
  gallery_type: Scalars['String'];
  is_private?: InputMaybe<Scalars['Boolean']>;
  media_type?: InputMaybe<Scalars['String']>;
  picture_id?: InputMaybe<Scalars['String']>;
  project_id: Scalars['String'];
  resource_id?: InputMaybe<Scalars['String']>;
  seq_no?: InputMaybe<Scalars['Float']>;
  unit_layout_id?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  videoType?: InputMaybe<Scalars['String']>;
};

export type AdminEditGalleryTourInput = {
  caption?: InputMaybe<Scalars['String']>;
  project_id: Scalars['String'];
  url?: InputMaybe<Scalars['String']>;
};

export type AdminEditGalleryVideoInput = {
  caption?: InputMaybe<Scalars['String']>;
  project_id: Scalars['String'];
  url?: InputMaybe<Scalars['String']>;
  videoType?: InputMaybe<Scalars['String']>;
};

export type AdminEditLayoutBlockInput = {
  block?: InputMaybe<Scalars['String']>;
  bucket_file_name?: InputMaybe<Scalars['String']>;
  caption?: InputMaybe<Scalars['String']>;
  file_name?: InputMaybe<Scalars['String']>;
  is_private?: InputMaybe<Scalars['Boolean']>;
  media_type?: InputMaybe<Scalars['String']>;
  picture_id?: InputMaybe<Scalars['String']>;
  project_id: Scalars['String'];
  resource_id?: InputMaybe<Scalars['String']>;
  seq_no?: InputMaybe<Scalars['Float']>;
  url?: InputMaybe<Scalars['String']>;
};

export type AdminEditLayoutFloorInput = {
  block: Scalars['String'];
  blockFloor: Scalars['String'];
  bucket_file_name?: InputMaybe<Scalars['String']>;
  caption?: InputMaybe<Scalars['String']>;
  file_name?: InputMaybe<Scalars['String']>;
  floor: Scalars['Float'];
  is_private?: InputMaybe<Scalars['Boolean']>;
  media_type?: InputMaybe<Scalars['String']>;
  picture_id?: InputMaybe<Scalars['String']>;
  project_id: Scalars['String'];
  resource_id?: InputMaybe<Scalars['String']>;
  seq_no: Scalars['Float'];
  url: Scalars['String'];
};

export type AdminEditLayoutUnitInput = {
  bucket_file_name?: InputMaybe<Scalars['String']>;
  caption?: InputMaybe<Scalars['String']>;
  file_name?: InputMaybe<Scalars['String']>;
  is_private?: InputMaybe<Scalars['Boolean']>;
  media_type?: InputMaybe<Scalars['String']>;
  picture_id?: InputMaybe<Scalars['String']>;
  project_id: Scalars['String'];
  resource_id?: InputMaybe<Scalars['String']>;
  seq_no?: InputMaybe<Scalars['Float']>;
  unit_layout_id?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type AdminEditProjectGalleryInput = {
  bucket_file_name?: InputMaybe<Scalars['String']>;
  caption?: InputMaybe<Scalars['String']>;
  file_name?: InputMaybe<Scalars['String']>;
  is_private?: InputMaybe<Scalars['Boolean']>;
  media_type?: InputMaybe<Scalars['String']>;
  picture_id?: InputMaybe<Scalars['String']>;
  project_id: Scalars['String'];
  resource_id?: InputMaybe<Scalars['String']>;
  seq_no?: InputMaybe<Scalars['Float']>;
  url?: InputMaybe<Scalars['String']>;
};

export type AdminEventsInput = {
  budget: Scalars['Float'];
  campaignId?: InputMaybe<Scalars['String']>;
  desc?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  location: Scalars['String'];
  name: Scalars['String'];
  startDate?: InputMaybe<Scalars['DateTime']>;
  website: Scalars['String'];
};

export type AdminFinancierPanelInput = {
  contactIds: Array<Scalars['String']>;
  financialLimit?: InputMaybe<Scalars['Float']>;
  financierId: Scalars['String'];
  projectId: Scalars['String'];
};

export type AdminProjectInput = {
  bankAccounts?: InputMaybe<Array<BankAccountInput>>;
  city: Scalars['String'];
  completionDate?: InputMaybe<Scalars['DateTime']>;
  country: Scalars['String'];
  currency: Scalars['String'];
  desc?: InputMaybe<Scalars['String']>;
  developmentCompany: Scalars['String'];
  holdingCompany: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  landType: Scalars['String'];
  launchDate?: InputMaybe<Scalars['DateTime']>;
  maxPrice?: InputMaybe<Scalars['Float']>;
  minPrice?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  plotNo?: InputMaybe<Scalars['String']>;
  projectAddress?: InputMaybe<Scalars['String']>;
  projectCode: Scalars['String'];
  projectType: Scalars['String'];
  state: Scalars['String'];
  tenure: Scalars['String'];
  townshipId?: InputMaybe<Scalars['String']>;
  uom: Scalars['String'];
};

export type AdminSaveProjectSpecInput = {
  address_show: Scalars['Boolean'];
  auto_reassign_lead_activated: Scalars['Boolean'];
  auto_reassign_lead_duration?: InputMaybe<Scalars['Float']>;
  booking_fee_mandatory: Scalars['Boolean'];
  booking_form_lang: Scalars['String'];
  booking_sign_required: Scalars['Boolean'];
  bookingconsent_required: Scalars['Boolean'];
  bookingfee_amount_required: Scalars['Boolean'];
  ccr_attachment_required: Scalars['Boolean'];
  company_show: Scalars['String'];
  discounts_show: Scalars['Boolean'];
  ELetteringSMSRequired?: InputMaybe<Scalars['Boolean']>;
  expected_snp_duration?: InputMaybe<Scalars['Float']>;
  expected_snp_required: Scalars['Boolean'];
  lead_aging_manager_handled?: InputMaybe<Array<Scalars['String']>>;
  lead_idle_one?: InputMaybe<Scalars['Float']>;
  lead_idle_three?: InputMaybe<Scalars['Float']>;
  lead_idle_two?: InputMaybe<Scalars['Float']>;
  leadAging_activated: Scalars['Boolean'];
  leadAging_notification_method?: InputMaybe<Array<Scalars['String']>>;
  loan_screening: Scalars['Boolean'];
  loanconsent_required: Scalars['Boolean'];
  maritalstatus_show: Scalars['Boolean'];
  min_age?: InputMaybe<Scalars['Float']>;
  min_age_required: Scalars['Boolean'];
  min_bookingfee_amount: Scalars['Float'];
  notify_unattended_lead_activated?: InputMaybe<Scalars['Boolean']>;
  notify_unattended_lead_duration?: InputMaybe<Scalars['Float']>;
  nric_attachment_required: Scalars['Boolean'];
  packages_show: Scalars['Boolean'];
  payment_gateway_id?: InputMaybe<Scalars['String']>;
  payment_gateway_refund_policy?: InputMaybe<Scalars['String']>;
  project_id: Scalars['String'];
  purchaser_app_setting?: InputMaybe<Scalars['String']>;
  reassign_end_time?: InputMaybe<Scalars['String']>;
  reassign_start_time?: InputMaybe<Scalars['String']>;
  remarks_show: Scalars['Boolean'];
  software_code?: InputMaybe<Array<Scalars['String']>>;
  unattended_lead_manager_handled?: InputMaybe<Array<Scalars['String']>>;
  unattended_lead_notification_method?: InputMaybe<Array<Scalars['String']>>;
};

export type AdminSolicitorInput = {
  contactEmail: Scalars['String'];
  contactName: Scalars['String'];
  contactPhoneNo: Scalars['String'];
  contacts?: InputMaybe<Array<SolicitorContact>>;
  id?: InputMaybe<Scalars['String']>;
  logo?: InputMaybe<Scalars['Upload']>;
  officeAddress?: InputMaybe<AddressJsonInput>;
  officeTel: Scalars['String'];
  solicitorCode?: InputMaybe<Scalars['String']>;
  solicitorEmail: Scalars['String'];
  solicitorName: Scalars['String'];
};

export type AdminUnitIntegrationInput = {
  baseUrl: Scalars['String'];
  gracePeriod?: InputMaybe<Scalars['Float']>;
  ifcaCompanyID: Scalars['String'];
  ifcaCompanyName?: InputMaybe<Scalars['String']>;
  ifcaPhaseID: Scalars['String'];
  ifcaPhaseName?: InputMaybe<Scalars['String']>;
  ifcaProjectID: Scalars['String'];
  ifcaProjectName?: InputMaybe<Scalars['String']>;
  paymentPlanCode?: InputMaybe<Scalars['String']>;
  paymentPlanDesc?: InputMaybe<Scalars['String']>;
  paymentPlanId?: InputMaybe<Scalars['String']>;
};

export type AdminUnitSalesChartInput = {
  block: Scalars['String'];
  coordinate: Scalars['String'];
  floor: Scalars['Float'];
  projectid: Scalars['String'];
  resourceid: Scalars['String'];
  unitid: Scalars['String'];
};

export type AdminUnitStatusInput = {
  status: Scalars['String'];
  unitid: Scalars['String'];
};

export type AdminUpdateUnitVirtualModelInput = {
  picture_id: Scalars['String'];
  project_id: Scalars['String'];
  unit_layout_id: Scalars['String'];
  virtualModelLink?: InputMaybe<Scalars['String']>;
};

export type AgencyAppointedCount = {
  __typename?: 'agencyAppointedCount';
  lastAppointedDate?: Maybe<Scalars['DateTime']>;
  totalAppointed?: Maybe<Scalars['Float']>;
};

export type AgencyAppointedEntity = AuditEntity & {
  __typename?: 'agencyAppointedEntity';
  accountId: Scalars['String'];
  address: AddressJson;
  agencyContractProjectCount?: Maybe<Scalars['Float']>;
  agencyId?: Maybe<Scalars['String']>;
  agencyUnitCounts?: Maybe<AgentUnitCounts>;
  agentNegotiator: Scalars['Boolean'];
  commonStatus: Scalars['String'];
  contactEmail: Scalars['String'];
  contactName: Scalars['String'];
  contactPhoneNo: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  email: Scalars['String'];
  id: Scalars['String'];
  invitationLink: Scalars['String'];
  logoUrl?: Maybe<Scalars['String']>;
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  name: Scalars['String'];
  officeTel: Scalars['String'];
  pictureBlockUrl?: Maybe<Scalars['String']>;
  sales?: Maybe<Array<SaleEntity>>;
};


export type AgencyAppointedEntityAgencyUnitCountsArgs = {
  projectId: Scalars['String'];
};


export type AgencyAppointedEntityPictureBlockUrlArgs = {
  block: Scalars['String'];
};

export type AgencyContactEntity = AuditEntity & {
  __typename?: 'agencyContactEntity';
  agencyAppointed: AgencyAppointedEntity;
  agencyUserRole: AgencyUserRoleEntity;
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isDeletable: Scalars['Boolean'];
  isSuspendible: Scalars['Boolean'];
  languageSet: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  name: Scalars['String'];
  phoneNo?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  reportingTo?: Maybe<Scalars['String']>;
  reportingToUserId?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  user: AgencyUserEntity;
  userId: Scalars['String'];
};

export type AgencyContractEntity = AuditEntity & {
  __typename?: 'agencyContractEntity';
  accountId: Scalars['String'];
  agency: AgencyEntity;
  agencyId: Scalars['String'];
  allocatedUnitId: Array<Scalars['String']>;
  allowUpdateLoanStatus: Scalars['Boolean'];
  allowWaitinglist: Scalars['Boolean'];
  attachment?: Maybe<Array<AttachmentEntity>>;
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  id: Scalars['String'];
  isExpired: Scalars['Boolean'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  project: ProjectEntity;
  projectId: Scalars['String'];
  startDate: Scalars['DateTime'];
};

export type AgencyEntity = AuditEntity & {
  __typename?: 'agencyEntity';
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  name: Scalars['String'];
};

export type AgencyLeadNotificationInput = {
  loanAssignment?: InputMaybe<LoanAssignmentInput>;
};

export type AgencyLeadNotificationOutput = {
  __typename?: 'AgencyLeadNotificationOutput';
  loanAssignment?: Maybe<LoanAssignmentOutput>;
};

export type AgencyNotificationEntity = {
  __typename?: 'agencyNotificationEntity';
  accountId: Scalars['String'];
  agencyNotificationRecipient: Array<AgencyNotificationRecipientEntity>;
  body: Scalars['String'];
  id: Scalars['String'];
  permissionId: Scalars['Float'];
  projectId: Scalars['String'];
  subject: Scalars['String'];
};

export type AgencyNotificationPolicyEntity = {
  __typename?: 'agencyNotificationPolicyEntity';
  accountId: Scalars['String'];
  id: Scalars['String'];
  notificationDuration: Scalars['Float'];
  permissionId: Scalars['Float'];
  userId: Scalars['String'];
};

export type AgencyNotificationRecipientEntity = AuditEntity & {
  __typename?: 'agencyNotificationRecipientEntity';
  accountId: Scalars['String'];
  agencyNotification: AgencyNotificationEntity;
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  isRead: Scalars['Boolean'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  notificationId: Scalars['String'];
  projectId: Scalars['String'];
  recipientId: Scalars['String'];
};

export type AgencySalesChartOutput = {
  __typename?: 'agencySalesChartOutput';
  coordinates: Scalars['String'];
  price: Scalars['Float'];
  status?: Maybe<Scalars['String']>;
  unit_id: Scalars['String'];
  unit_no: Scalars['String'];
  unit_status: Scalars['String'];
  unit_type: Scalars['String'];
};

export type AgencyTeamOutput = {
  __typename?: 'AgencyTeamOutput';
  agencyContractId: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  users: Array<AgencyTeamUserOutput>;
};

export type AgencyTeamUserOutput = {
  __typename?: 'AgencyTeamUserOutput';
  agencyContractId: Scalars['String'];
  agencyId: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type AgencyUnitAllocationEntity = AuditEntity & {
  __typename?: 'agencyUnitAllocationEntity';
  accountId: Scalars['String'];
  agency: AgencyEntity;
  agencyId: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  project: ProjectEntity;
  projectId: Scalars['String'];
  unit: UnitEntity;
  unitId: Scalars['String'];
};

export type AgencyUserEntity = AuditEntity & {
  __typename?: 'agencyUserEntity';
  accessToken?: Maybe<Scalars['String']>;
  activated: Scalars['Boolean'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  forgotPasswordLink?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  loginId: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  passwordHash?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
};

export type AgencyUserRoleEntity = AuditEntity & {
  __typename?: 'agencyUserRoleEntity';
  agency: AgencyEntity;
  agencyId: Scalars['String'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  reportPerson: AgencyUserEntity;
  reportPersonId?: Maybe<Scalars['String']>;
  role: Scalars['String'];
  user: AgencyUserEntity;
  userId: Scalars['String'];
};

export type AgentPermissionEntity = AuditEntity & {
  __typename?: 'agentPermissionEntity';
  agency: AgencyEntity;
  agencyContact?: Maybe<AgencyContactEntity>;
  agencyId: Scalars['String'];
  agencyUser: AgencyUserEntity;
  agencyUserId: Scalars['String'];
  allowBook: Scalars['Boolean'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  project: ProjectEntity;
  projectId: Scalars['String'];
};

export type AgentUnitCounts = {
  __typename?: 'agentUnitCounts';
  allocatedunit?: Maybe<Scalars['Float']>;
  bookedunit?: Maybe<Scalars['Float']>;
  spasignedunit?: Maybe<Scalars['Float']>;
};

export type AlertOutput = {
  __typename?: 'alertOutput';
  allocationDate?: Maybe<Scalars['DateTime']>;
  buyBackAmt?: Maybe<Scalars['Float']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  finalTaxToDate?: Maybe<Scalars['Float']>;
  installmentId: Scalars['String'];
  intervalDays?: Maybe<Scalars['Float']>;
  label: Scalars['String'];
  outstanding?: Maybe<Scalars['Float']>;
  paidToDate?: Maybe<Scalars['Float']>;
  prevAllocDate?: Maybe<Scalars['DateTime']>;
  refTable?: Maybe<Scalars['String']>;
  reminderId?: Maybe<Scalars['String']>;
  taxToDate?: Maybe<Scalars['Float']>;
};

export type AllLateInterestOutput = {
  __typename?: 'allLateInterestOutput';
  bankAccountName?: Maybe<Scalars['String']>;
  bankAccountNo?: Maybe<Scalars['Float']>;
  carParkTotalInterestAmt: Scalars['Float'];
  carParkWaiveAmt: Scalars['Float'];
  generationBatch: Scalars['String'];
  interestEndDate: Scalars['DateTime'];
  miscBillingTotalInterestAmt: Scalars['Float'];
  miscBillingWaiveAmt: Scalars['Float'];
  packagesTotalInterestAmt: Scalars['Float'];
  packagesWaiveAmt: Scalars['Float'];
  saleId: Scalars['String'];
  status: Scalars['String'];
  submittedBy: Scalars['String'];
  totalInterestAmt: Scalars['Float'];
  totalWaiveAmt: Scalars['Float'];
  unitTotalInterestAmt: Scalars['Float'];
  unitWaiveAmt: Scalars['Float'];
};

export type AllLoanPaymentAllocationOutput = {
  __typename?: 'allLoanPaymentAllocationOutput';
  allocateAmt?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  docDate?: Maybe<Scalars['String']>;
  docNo?: Maybe<Scalars['String']>;
};

export type AllLoanPaymentMainOutput = {
  __typename?: 'allLoanPaymentMainOutput';
  allowReversal: Scalars['Boolean'];
  bankAccount: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  docDate: Scalars['DateTime'];
  docRef?: Maybe<Scalars['String']>;
  financierName: Scalars['String'];
  generationBatchId: Scalars['String'];
  getReceiptAttachmentByBatch?: Maybe<Array<AttachmentEntity>>;
  receiptList: Array<AllLoanPaymentOutput>;
  totalDocAmt: Scalars['Float'];
};

export type AllLoanPaymentOutput = {
  __typename?: 'allLoanPaymentOutput';
  allocateDetail: Array<AllLoanPaymentAllocationOutput>;
  allowReversal: Scalars['Boolean'];
  docAmt: Scalars['Float'];
  docDate: Scalars['String'];
  docNo: Scalars['String'];
  receiptId: Scalars['String'];
  unitNo: Scalars['String'];
};

export type AllocatePAmoduleDataInput = {
  creditId?: InputMaybe<Scalars['String']>;
  creditRefTable: Scalars['String'];
  docAmount?: InputMaybe<Scalars['Float']>;
  inputAllocationDetail?: InputMaybe<Array<AllocationList>>;
};

export type AllocationBillingCreditDetails = {
  __typename?: 'AllocationBillingCreditDetails';
  allocate_amount: Scalars['Float'];
  credit_id: Scalars['String'];
};

export type AllocationBillingCreditOutput = {
  __typename?: 'AllocationBillingCreditOutput';
  allocate_amount?: Maybe<Scalars['Float']>;
  credit_id?: Maybe<Scalars['String']>;
};

export type AllocationBillingDebitDetails = {
  __typename?: 'AllocationBillingDebitDetails';
  allocateAmount: Scalars['Float'];
  debitId: Scalars['String'];
};

export type AllocationBillingDetails = {
  __typename?: 'AllocationBillingDetails';
  bill_item_id: Scalars['String'];
  bill_item_type: Scalars['String'];
  credit: Array<AllocationBillingCreditDetails>;
  description: Scalars['String'];
  document_amount: Scalars['Float'];
  document_date: Scalars['DateTime'];
  document_no: Scalars['String'];
  id: Scalars['String'];
  outstanding: Scalars['Float'];
  table: Scalars['String'];
  total_allocated: Scalars['Float'];
};

export type AllocationBillingOutput = {
  __typename?: 'AllocationBillingOutput';
  credit?: Maybe<Array<AllocationBillingCreditOutput>>;
  description?: Maybe<Scalars['String']>;
  document_amount?: Maybe<Scalars['Float']>;
  document_date?: Maybe<Scalars['DateTime']>;
  document_no?: Maybe<Scalars['String']>;
  enabledAllocate?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  outstanding?: Maybe<Scalars['Float']>;
  table?: Maybe<Scalars['String']>;
  total_allocated?: Maybe<Scalars['Float']>;
};

export type AllocationContraInput = {
  allocationDate: Scalars['DateTime'];
  allocationList?: InputMaybe<Array<AllocationList>>;
  id: Scalars['String'];
  saleId: Scalars['String'];
};

export type AllocationData = {
  __typename?: 'AllocationData';
  allocateAmount?: Maybe<Scalars['Float']>;
  allocationDate?: Maybe<Scalars['DateTime']>;
  allocationId?: Maybe<Scalars['String']>;
  carParkDescription?: Maybe<Scalars['String']>;
  creditId?: Maybe<Scalars['String']>;
  debitId?: Maybe<Scalars['String']>;
  debitNoteDescription?: Maybe<Scalars['String']>;
  documentNo?: Maybe<Scalars['String']>;
  installmentDescription?: Maybe<Scalars['String']>;
  lateInterestDescription?: Maybe<Scalars['String']>;
  miscDescription?: Maybe<Scalars['String']>;
  packagesDescription?: Maybe<Scalars['String']>;
  rebateDescription?: Maybe<Scalars['String']>;
  receiptDescription?: Maybe<Scalars['String']>;
};

export type AllocationDetailOutput = {
  __typename?: 'AllocationDetailOutput';
  amount?: Maybe<Scalars['Float']>;
  billItemName?: Maybe<Scalars['String']>;
  currentAllocate?: Maybe<Scalars['Float']>;
  currentOutstanding?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  documentAmount?: Maybe<Scalars['Float']>;
  documentDate?: Maybe<Scalars['DateTime']>;
  documentNo?: Maybe<Scalars['String']>;
  enabledAllocate?: Maybe<Scalars['Boolean']>;
  financialBillingId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  numRow?: Maybe<Scalars['Float']>;
  outstanding?: Maybe<Scalars['Float']>;
  reverseDate?: Maybe<Scalars['DateTime']>;
  table?: Maybe<Scalars['String']>;
  totalAllocateAmount?: Maybe<Scalars['Float']>;
};

export type AllocationEntity = {
  __typename?: 'allocationEntity';
  accountId: Scalars['String'];
  allocateAmount: Scalars['Float'];
  allocateBaseAmount: Scalars['Float'];
  allocateLuxAmount: Scalars['Float'];
  allocateLuxRate: Scalars['Float'];
  allocateVatAmount: Scalars['Float'];
  allocateVatRate: Scalars['Float'];
  allocateWthAmount: Scalars['Float'];
  allocateWthRate: Scalars['Float'];
  allocationDate?: Maybe<Scalars['DateTime']>;
  allowReversal: Scalars['Boolean'];
  commonStatus: Scalars['String'];
  contra?: Maybe<ContraEntity>;
  createdTs: Scalars['DateTime'];
  creditId: Scalars['String'];
  creditNote?: Maybe<CreditNoteEntity>;
  creditRefTable: Scalars['String'];
  debitId: Scalars['String'];
  debitNote?: Maybe<DebitNoteEntity>;
  debitRefTable: Scalars['String'];
  documentNo?: Maybe<Scalars['String']>;
  financialBillingId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  interest?: Maybe<LateInterestDetailEntity>;
  miscBilling?: Maybe<MiscBillingEntity>;
  originalId?: Maybe<Scalars['String']>;
  progressBilling?: Maybe<ProgressBillingEntity>;
  project: ProjectEntity;
  projectId: Scalars['String'];
  rebate?: Maybe<RebateEntity>;
  receipt?: Maybe<ReceiptEntity>;
  refund?: Maybe<RefundEntity>;
};

export type AllocationInput = {
  allocationList?: InputMaybe<Array<AllocationList>>;
  id: Scalars['String'];
  saleId: Scalars['String'];
};

export type AllocationInputIndo = {
  allocationDate: Scalars['DateTime'];
  allocationList?: InputMaybe<Array<AllocationList>>;
  id: Scalars['String'];
  saleId: Scalars['String'];
};

export type AllocationList = {
  allocationDate?: InputMaybe<Scalars['DateTime']>;
  amount: Scalars['Float'];
  creditId?: InputMaybe<Scalars['String']>;
  debitId?: InputMaybe<Scalars['String']>;
  debitRefTable?: InputMaybe<Scalars['String']>;
  documentNo?: InputMaybe<Scalars['String']>;
  financialBillingId?: InputMaybe<Scalars['String']>;
  table?: InputMaybe<Scalars['String']>;
};

export type AllocationListing = {
  amount: Scalars['Float'];
  creditId?: InputMaybe<Scalars['String']>;
  debitId?: InputMaybe<Scalars['String']>;
  debitRefTable?: InputMaybe<Scalars['String']>;
  financialBillingId?: InputMaybe<Scalars['String']>;
  saleId: Scalars['String'];
  table?: InputMaybe<Scalars['String']>;
};

export type AllProjectPaymentPlanOutput = {
  __typename?: 'allProjectPaymentPlanOutput';
  accountId: Scalars['String'];
  block: Scalars['String'];
  commonStatus: Scalars['String'];
  defaulted: Scalars['Boolean'];
  endDate: Scalars['DateTime'];
  id: Scalars['String'];
  paymentPlanEffecDate?: Maybe<Scalars['DateTime']>;
  paymentPlanId: Scalars['String'];
  paymentPlanName?: Maybe<Scalars['String']>;
  projectId: Scalars['String'];
  startDate: Scalars['DateTime'];
};

export type AllStandardCoreBaseEntity = StandardAuditEntity & {
  __typename?: 'AllStandardCoreBaseEntity';
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  ID: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
};

export type Amenities = {
  __typename?: 'Amenities';
  category: Scalars['String'];
  items: Array<Scalars['String']>;
};

export type AmenitiesInput = {
  category: Scalars['String'];
  items: Array<Scalars['String']>;
};

export enum AmountType {
  Amount = 'AMOUNT',
  DescriptionList = 'DescriptionList',
  GetDescription = 'GetDescription',
  Percent = 'PERCENT'
}

export type AppointmentEntity = {
  __typename?: 'AppointmentEntity';
  accountId: Scalars['String'];
  appointmentDate: Scalars['DateTime'];
  appointmentPurpose: AppointmentTypeEntity;
  appointmentTypeId: Scalars['String'];
  commonStatus: Scalars['String'];
  contactId: Scalars['String'];
  createdBy: Scalars['String'];
  createdTs: Scalars['DateTime'];
  endTime: Scalars['String'];
  id: Scalars['String'];
  lead: LeadContactEntity;
  leadId: Scalars['String'];
  leadSourceFromLead?: Maybe<LeadEntity>;
  modBy: Scalars['String'];
  modTs: Scalars['DateTime'];
  needManagerAssistant: Scalars['Boolean'];
  participantLimit: Scalars['Float'];
  project: ProjectEntity;
  projectId: Scalars['String'];
  remarks: Scalars['String'];
  salePerson: SUserEntity;
  salesPersonId: Scalars['String'];
  salesPersonOrigin: Scalars['String'];
  saleTeam: SaleTeamEntity;
  startTime: Scalars['String'];
  teamId: Scalars['String'];
};

export type AppointmentSchedulingEntity = {
  __typename?: 'appointmentSchedulingEntity';
  accountId: Scalars['String'];
  endTime: Scalars['String'];
  id: Scalars['String'];
  participantLimit: Scalars['Float'];
  projectId: Scalars['String'];
  salesGalleryCloseDate: Array<SalesGalleryCloseDateEntity>;
  startTime: Scalars['String'];
};

export type AppointmentTypeEntity = {
  __typename?: 'AppointmentTypeEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  defaulted: Scalars['Boolean'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  name: Scalars['String'];
  seqNo: Scalars['Float'];
  systemUse: Scalars['Boolean'];
};

export type ApprovalAssignmentListFormInput = {
  approvalList?: InputMaybe<Array<ApprovalListJsonInput>>;
  id: Scalars['String'];
  lowerLimit?: InputMaybe<Scalars['Float']>;
  upperLimit?: InputMaybe<Scalars['Float']>;
};

export enum ApprovalLevel {
  Fifth = 'FIFTH',
  First = 'FIRST',
  Fourth = 'FOURTH',
  Second = 'SECOND',
  Third = 'THIRD'
}

export type ApprovalListFormInput = {
  approvalList?: InputMaybe<Array<ApprovalListJsonInput>>;
  id: Scalars['String'];
  lowerLimit?: InputMaybe<Scalars['Float']>;
  upperLimit?: InputMaybe<Scalars['Float']>;
};

/** JsonType */
export type ApprovalListJson = {
  __typename?: 'ApprovalListJson';
  predicate?: Maybe<Scalars['String']>;
  roleId: Scalars['String'];
  roleName?: Maybe<Scalars['String']>;
  stepNo: Scalars['Float'];
};

export type ApprovalListJsonInput = {
  predicate?: InputMaybe<Scalars['String']>;
  roleId: Scalars['String'];
  roleName?: InputMaybe<Scalars['String']>;
  stepNo: Scalars['Float'];
};

export type ApprovalPolicyAssignmentEntity = {
  __typename?: 'approvalPolicyAssignmentEntity';
  accountId: Scalars['String'];
  approvalList: Array<ApprovalListJson>;
  category: Scalars['String'];
  commonStatus: Scalars['String'];
  entityId: Scalars['String'];
  id: Scalars['String'];
  lowerLimit?: Maybe<Scalars['Float']>;
  upperLimit?: Maybe<Scalars['Float']>;
};

export type ApprovalPolicyEntity = {
  __typename?: 'approvalPolicyEntity';
  accountId: Scalars['String'];
  approvalList: Array<ApprovalListJson>;
  category: Scalars['String'];
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  lowerLimit?: Maybe<Scalars['Float']>;
  upperLimit?: Maybe<Scalars['Float']>;
};

export type ApprovalStatusOutput = {
  __typename?: 'approvalStatusOutput';
  approvalstatus?: Maybe<Scalars['String']>;
};

export type ApproveAndCancelBookingFeeInput = {
  saleId: Scalars['String'];
  salePaymentId: Scalars['String'];
  salePaymentStatus: Scalars['String'];
};

export type ApproveBankPaymentInput = {
  action: Scalars['String'];
  receiptIds: Array<Scalars['String']>;
};

export type ApprovedPurchaserInListingInput = {
  purchaserTransferId?: InputMaybe<Scalars['String']>;
  saleId: Scalars['String'];
};

export type ApproveUnitTransferIndoInput = {
  attachments?: InputMaybe<Array<Scalars['Upload']>>;
  remarks: Scalars['String'];
  transferId: Scalars['String'];
};

export type ApSummary = {
  __typename?: 'APSummary';
  itemCount: Scalars['Float'];
  totalDocAmt: Scalars['Float'];
  totalSellingPrice: Scalars['Float'];
  totalUnallocatedAmt: Scalars['Float'];
};

export type ArchitectCertEntity = {
  __typename?: 'architectCertEntity';
  accountId: Scalars['String'];
  architectCertUnit?: Maybe<Array<ArchitectCertUnitEntity>>;
  architectCertUnitStatus?: Maybe<Scalars['String']>;
  architectCertWorkProgress?: Maybe<Array<ArchitectCertWorkProgressEntity>>;
  certificateDate: Scalars['DateTime'];
  certificateNo: Scalars['String'];
  commonStatus: Scalars['String'];
  getArchitectCertAttachment?: Maybe<Array<AttachmentEntity>>;
  id: Scalars['String'];
  projectId: Scalars['String'];
  totalPostedBill?: Maybe<Scalars['Float']>;
  totalUnitCount?: Maybe<Scalars['Float']>;
};

export type ArchitectCertInput = {
  certAttachments?: InputMaybe<Array<Scalars['Upload']>>;
  certificateDate: Scalars['DateTime'];
  certificateNo: Scalars['String'];
  projectId: Scalars['String'];
  unitId: Array<Scalars['String']>;
  workProgressId: Array<Scalars['String']>;
};

export type ArchitectCertListOutput = {
  __typename?: 'ArchitectCertListOutput';
  allowReversal?: Maybe<Scalars['Boolean']>;
  approvedCount?: Maybe<Scalars['Float']>;
  architectCertUnitStatus?: Maybe<Scalars['String']>;
  billCount?: Maybe<Scalars['Float']>;
  billingStageIndex?: Maybe<Array<Scalars['String']>>;
  certificateDate?: Maybe<Scalars['DateTime']>;
  certificateNo?: Maybe<Scalars['String']>;
  formattedCertificateDate?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  pbUnitIds?: Maybe<Array<Scalars['String']>>;
  pendingCount?: Maybe<Scalars['Float']>;
  totalUnitCount?: Maybe<Scalars['Float']>;
  unitIds?: Maybe<Array<Scalars['String']>>;
  unitIndex?: Maybe<Array<Scalars['String']>>;
};

export type ArchitectCertOutput = {
  __typename?: 'ArchitectCertOutput';
  architectCertEntity: ArchitectCertEntity;
};

export type ArchitectCertUnitEntity = {
  __typename?: 'architectCertUnitEntity';
  accountId: Scalars['String'];
  architectCert: ArchitectCertEntity;
  architectCertId: Scalars['String'];
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  projectId: Scalars['String'];
  status: Scalars['String'];
  unitId: Scalars['String'];
  units?: Maybe<UnitEntity>;
};

export type ArchitectCertWorkProgressEntity = {
  __typename?: 'architectCertWorkProgressEntity';
  accountId: Scalars['String'];
  architectCertId: Scalars['String'];
  architectCerts: ArchitectCertEntity;
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  paymentPlanDetail?: Maybe<Array<PaymentPlanDetailEntity>>;
  progress: Array<WorkProgressEntity>;
  projectId: Scalars['String'];
  workProgressId: Scalars['String'];
};

export type AreaVarianceEntity = {
  __typename?: 'areaVarianceEntity';
  accountId: Scalars['String'];
  actualBuiltUp: Scalars['Float'];
  actualLandArea: Scalars['Float'];
  builtUp: Scalars['Float'];
  commonStatus: Scalars['String'];
  compensateAmount: Scalars['Float'];
  documentNo?: Maybe<Scalars['String']>;
  formula: Scalars['String'];
  id: Scalars['String'];
  landArea: Scalars['Float'];
  projectId: Scalars['String'];
  refId?: Maybe<Scalars['String']>;
  refTable?: Maybe<Scalars['String']>;
  saleId: Scalars['String'];
  sales?: Maybe<SaleEntity>;
  unitData?: Maybe<AreaVarianceUnitOutput>;
};

export type AreaVarianceInputIndonesia = {
  actualBuiltUp: Scalars['Float'];
  actualLandArea: Scalars['Float'];
  builtUp: Scalars['Float'];
  compensateAmount: Scalars['Float'];
  formula: Scalars['String'];
  landArea: Scalars['Float'];
  refId?: InputMaybe<Scalars['String']>;
  refTable?: InputMaybe<Scalars['String']>;
  saleId: Scalars['String'];
  unitId: Scalars['String'];
};

export type AreaVarianceSummaryIndonesiaOutput = {
  __typename?: 'areaVarianceSummaryIndonesiaOutput';
  count?: Maybe<Scalars['Float']>;
  nettBuiltUp?: Maybe<Scalars['Float']>;
  totalCompensate?: Maybe<Scalars['Float']>;
};

export type AreaVarianceUnitOutput = {
  __typename?: 'areaVarianceUnitOutput';
  builtUp?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['String']>;
  landArea?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  saleId?: Maybe<Scalars['String']>;
  unitNo?: Maybe<Scalars['String']>;
  unitStatus?: Maybe<Scalars['String']>;
};

export type AssignCarParkInput = {
  carParkIdsAdded?: InputMaybe<Array<Scalars['String']>>;
  carParkIdsRemoved?: InputMaybe<Array<Scalars['String']>>;
  parentId: Scalars['String'];
};

export type AssignDiscountInput = {
  discountId: Scalars['String'];
  effectiveDate: Scalars['DateTime'];
  expired_date: Scalars['DateTime'];
  projectId: Scalars['String'];
};

export type AssignedBatchDetails = {
  __typename?: 'AssignedBatchDetails';
  batch_id: Scalars['String'];
  batch_title: Scalars['String'];
  countLeadSource?: Maybe<LeadBatchCountLeadSourceOutput>;
  createdTs?: Maybe<Scalars['DateTime']>;
  isRoundRobinUser?: Maybe<Scalars['Boolean']>;
  projects?: Maybe<Array<AssignedProjectDetails>>;
  record_count: Scalars['Float'];
};

export type AssignedNotaryOutput = {
  __typename?: 'AssignedNotaryOutput';
  email?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  notaryCode?: Maybe<Scalars['String']>;
  notaryId?: Maybe<Scalars['String']>;
  projectId?: Maybe<Scalars['String']>;
};

export type AssignedProjectDetails = {
  __typename?: 'AssignedProjectDetails';
  assigned_date: Scalars['DateTime'];
  batch_id: Scalars['String'];
  lead_count: Scalars['Float'];
  project_name: Scalars['String'];
};

export type AssignedStaffListOutput = {
  __typename?: 'assignedStaffListOutput';
  accountId: Scalars['String'];
  email: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  phone: Scalars['String'];
  projectId: Scalars['String'];
  salesPersonId: Scalars['String'];
};

export type AssignedUnitCp = {
  __typename?: 'assignedUnitCp';
  carParks?: Maybe<Array<CarParkOutput>>;
  parentId: Scalars['String'];
  parentUnitNo: Scalars['String'];
};

export type AssignOverduedPaInput = {
  followedUpId: Scalars['String'];
  id: Scalars['String'];
  saleId: Scalars['String'];
};

export type AttachmentEmateraiEntity = AuditEntity & {
  __typename?: 'attachmentEmateraiEntity';
  accountId: Scalars['String'];
  bucketFileName: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  docAmt?: Maybe<Scalars['Float']>;
  docNo?: Maybe<Scalars['String']>;
  fileName: Scalars['String'];
  fileNameSign?: Maybe<Scalars['String']>;
  fileSerialNumber?: Maybe<Scalars['String']>;
  fileStatus?: Maybe<Scalars['String']>;
  fileToken?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isPrivate: Scalars['Boolean'];
  mediaType: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  refId: Scalars['String'];
  refTable: Scalars['String'];
  refType: Scalars['String'];
  resourceUrl: Scalars['String'];
  resourceUrlSigned: Scalars['String'];
  seqNo: Scalars['Float'];
  softwareCode: Scalars['String'];
};

export type AttachmentEntity = AuditEntity & {
  __typename?: 'attachmentEntity';
  accountId: Scalars['String'];
  allowDelete?: Maybe<Scalars['Boolean']>;
  bucketFileName: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  fileName: Scalars['String'];
  id: Scalars['String'];
  isPrivate: Scalars['Boolean'];
  mediaType: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  refId: Scalars['String'];
  refTable: Scalars['String'];
  refType: Scalars['String'];
  resourceUrl: Scalars['String'];
  seqNo: Scalars['Float'];
  softwareCode: Scalars['String'];
};

export type AttachmentList = {
  __typename?: 'attachmentList';
  fileName: Scalars['String'];
  mediaType: Scalars['String'];
  resourceUrl: Scalars['String'];
};

export type AttachmentOutput = {
  __typename?: 'AttachmentOutput';
  brochureUrl?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
};

export type AuditEntity = {
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
};

export type AuditEntity_Temp = {
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  recordStatus: Scalars['String'];
};

export type AuthorizedStaffListingOutput = {
  __typename?: 'authorizedStaffListingOutput';
  email: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  phone: Scalars['String'];
};

export type AutoReleaseNotificationReminderInput = {
  agencyUserReceive?: InputMaybe<Scalars['Boolean']>;
  reminderDay?: InputMaybe<Scalars['Float']>;
  salesUserReceive?: InputMaybe<Scalars['Boolean']>;
};

export type AutoReleaseNotificationReminderOutput = {
  __typename?: 'autoReleaseNotificationReminderOutput';
  agencyUserReceive?: Maybe<Scalars['Boolean']>;
  reminderDay?: Maybe<Scalars['Float']>;
  salesUserReceive?: Maybe<Scalars['Boolean']>;
};

export type AvailableCloneProjectOutput = {
  __typename?: 'availableCloneProjectOutput';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type AvailableCopyCompanyListProp = {
  __typename?: 'availableCopyCompanyListProp';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type BankAccountEntity = AuditEntity & {
  __typename?: 'BankAccountEntity';
  accountHolder?: Maybe<Scalars['String']>;
  accountID: Scalars['String'];
  accountNo: Scalars['String'];
  bankClearance?: Maybe<Scalars['String']>;
  bankProfile?: Maybe<BankProfileEntity>;
  bankProfileID: Scalars['String'];
  branchCode?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  commonStatus: CommonStatus;
  companyID: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  currencyID?: Maybe<Scalars['String']>;
  effectiveDate: Scalars['String'];
  glAccountCode?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  isCash?: Maybe<Scalars['Boolean']>;
  isKeyCardCash?: Maybe<Scalars['Boolean']>;
  isSecurityCash?: Maybe<Scalars['Boolean']>;
  masterCOAID?: Maybe<Scalars['String']>;
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  q3RevenueMapping?: Maybe<Array<Scalars['JSON']>>;
  swiftCode?: Maybe<Scalars['String']>;
  type: BankAccountType;
};

export type BankAccountInput = {
  bankAccountCode?: InputMaybe<Scalars['String']>;
  bankAccountId?: InputMaybe<Scalars['String']>;
  bankAccountNo?: InputMaybe<Scalars['String']>;
  bankCurrency?: InputMaybe<Scalars['String']>;
  bankProfileId?: InputMaybe<Scalars['String']>;
  bankProfileName?: InputMaybe<Scalars['String']>;
};

export type BankAccountList = {
  __typename?: 'bankAccountList';
  bankAccountCode: Scalars['String'];
  bankAccountId: Scalars['String'];
  bankAccountNo: Scalars['String'];
  bankProfileId: Scalars['String'];
  bankProfileName: Scalars['String'];
  currency: Scalars['String'];
  isSelected: Scalars['Boolean'];
};

export type BankAccountOutput = {
  __typename?: 'BankAccountOutput';
  bankAccountCode?: Maybe<Scalars['String']>;
  bankAccountId?: Maybe<Scalars['String']>;
  bankAccountNo?: Maybe<Scalars['String']>;
  bankCurrency?: Maybe<Scalars['String']>;
  bankProfileId?: Maybe<Scalars['String']>;
  bankProfileName?: Maybe<Scalars['String']>;
};

export enum BankAccountType {
  Bank = 'BANK',
  Cash = 'CASH'
}

export type BankEntity = {
  __typename?: 'bankEntity';
  accountId: Scalars['String'];
  code: Scalars['String'];
  commonStatus: Scalars['String'];
  financier: Array<FinancierEntity>;
  id: Scalars['String'];
  isExistInEndFinancier: Scalars['Float'];
  isExistInMasterData: Array<Scalars['String']>;
  isExistInTransactionData: Array<Scalars['String']>;
  name: Scalars['String'];
};

export type BankListingOutput = {
  __typename?: 'bankListingOutput';
  accountNo?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type BankLoanSummary = {
  __typename?: 'bankLoanSummary';
  loanAppliedAmount?: Maybe<Scalars['Float']>;
  loanApprovedAmount?: Maybe<Scalars['Float']>;
};

export type BankOutput = {
  __typename?: 'bankOutput';
  accountNo: Scalars['String'];
  code: Scalars['String'];
  currency: Scalars['String'];
  label: Scalars['String'];
  value: Scalars['String'];
};

export type BankPaymentListingOutput = {
  __typename?: 'bankPaymentListingOutput';
  bankAccountId: Scalars['String'];
  bankAccountNo: Scalars['String'];
  bankCode: Scalars['String'];
  description: Scalars['String'];
  documentRef: Scalars['String'];
  financierCode?: Maybe<Scalars['String']>;
  financierId: Scalars['String'];
  financierName: Scalars['String'];
  generationBatchDate: Scalars['DateTime'];
  generationBatchId: Scalars['String'];
  receiptDate: Scalars['DateTime'];
  receiptList?: Maybe<Array<ReceiptOutputList>>;
  status: Scalars['String'];
  totalDocumentAmount: Scalars['Float'];
};

export type BankProfileEntity = AuditEntity & {
  __typename?: 'BankProfileEntity';
  accountID: Scalars['String'];
  address: Scalars['JSON'];
  bankAccount?: Maybe<Array<BankAccountEntity>>;
  commonStatus: CommonStatus;
  contactNo?: Maybe<Scalars['String']>;
  contactPerson?: Maybe<Array<Scalars['JSON']>>;
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  name: Scalars['String'];
};

export type BaseInput = {
  commonStatus?: InputMaybe<CommonStatus>;
  createdBy?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['String']>;
};

export type BasePaymentPlanSummary = {
  billAfter: Scalars['String'];
  billCount: Scalars['Float'];
  billFreq: Scalars['String'];
  billType: Scalars['String'];
  carParkId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  installmentDetail: Array<InstallmentDetailInput>;
  noInstallment: Scalars['Float'];
  paymentAmt: Scalars['Float'];
  purchaserPaymentPlanDetailsId: Scalars['String'];
  salePackageId?: InputMaybe<Scalars['String']>;
};

export enum BillAfter {
  DescriptionList = 'DescriptionList',
  GetDescription = 'GetDescription',
  SalesRegistrationDate = 'SALES_REGISTRATION_DATE'
}

export enum BillFrequency {
  Day = 'DAY',
  DescriptionList = 'DescriptionList',
  GetDescription = 'GetDescription',
  Month = 'MONTH'
}

export type BillingDetailTaxData = {
  __typename?: 'BillingDetailTaxData';
  taxSchemeName?: Maybe<Scalars['String']>;
  totalTaxAmount?: Maybe<Scalars['String']>;
  totalTaxRate?: Maybe<Scalars['String']>;
};

export type BillingListingOutput = {
  __typename?: 'billingListingOutput';
  bankAccountId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  documentDate?: Maybe<Scalars['DateTime']>;
  documentNo?: Maybe<Scalars['String']>;
  financierDetail?: Maybe<Array<EndFinancierDetailListing>>;
  financierId?: Maybe<Scalars['String']>;
  refNo?: Maybe<Scalars['String']>;
};

export enum BillItem {
  AdminFee = 'ADMIN_FEE',
  AreaVariance = 'AREA_VARIANCE',
  Contra = 'CONTRA',
  CreditNote = 'CREDIT_NOTE',
  DebitNote = 'DEBIT_NOTE',
  Deposit = 'DEPOSIT',
  DescriptionList = 'DescriptionList',
  Forfeiture = 'FORFEITURE',
  GetDescription = 'GetDescription',
  Interest = 'INTEREST',
  Lad = 'LAD',
  Misc = 'MISC',
  ProgressBilling = 'PROGRESS_BILLING',
  Rebate = 'REBATE',
  RedemptionReceipt = 'REDEMPTION_RECEIPT',
  StakeholderContra = 'STAKEHOLDER_CONTRA'
}

export type BillItemEntity = {
  __typename?: 'billItemEntity';
  accountId: Scalars['String'];
  billItemType: Scalars['String'];
  classificationId?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  isExistInMasterData: Array<Scalars['String']>;
  isExistInTransactionData: Array<Scalars['String']>;
  msicId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  systemUse: Scalars['Boolean'];
};

export type BillItemIntEntity = {
  __typename?: 'billItemIntEntity';
  accountId: Scalars['String'];
  billItemType: Scalars['String'];
  commonStatus: Scalars['String'];
  creditTerm: Scalars['Float'];
  gracePeriod: Scalars['Float'];
  id: Scalars['String'];
  latePaymentInterest?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  systemUse?: Maybe<Scalars['Boolean']>;
  taxSchema?: Maybe<TaxSchemeEntity>;
  taxSchemeId: Scalars['String'];
};

export type BillItemIntInput = {
  billItemType: BillItemType;
  creditTerm: Scalars['Float'];
  gracePeriod: Scalars['Float'];
  id?: InputMaybe<Scalars['String']>;
  latePaymentInterest: Scalars['String'];
  name: Scalars['String'];
  taxSchema: Scalars['String'];
};

export enum BillItemType {
  Contra = 'CONTRA',
  CreditNote = 'CREDIT_NOTE',
  DebitNote = 'DEBIT_NOTE',
  Deposit = 'DEPOSIT',
  GetDescription = 'GetDescription',
  Misc = 'MISC',
  Rebate = 'REBATE',
  TransactionType = 'TransactionType'
}

export enum BillType {
  BankLoan = 'BANK_LOAN',
  DescriptionList = 'DescriptionList',
  DownPayment = 'DOWN_PAYMENT',
  GetDescription = 'GetDescription',
  Installment = 'INSTALLMENT'
}

export type BlockByProjectOutput = {
  __typename?: 'BlockByProjectOutput';
  blocks: Array<Scalars['String']>;
  integrated: Scalars['Boolean'];
};

export type BlockCountByStatusOutput = {
  __typename?: 'BlockCountByStatusOutput';
  availableUnitCount: Scalars['Float'];
  block?: Maybe<Scalars['String']>;
  bookUnitCount: Scalars['Float'];
  reservationUnitCount?: Maybe<Scalars['Float']>;
  signUnitCount: Scalars['Float'];
  soldUnitCount: Scalars['Float'];
  totalUnitCount: Scalars['Float'];
  unavailableUnitCount: Scalars['Float'];
};

export type BlockFLoorOutput = {
  __typename?: 'BlockFLoorOutput';
  block?: Maybe<Scalars['String']>;
  floor?: Maybe<Scalars['Float']>;
  floorlabel?: Maybe<Scalars['String']>;
  unitId?: Maybe<Scalars['String']>;
  unitNo?: Maybe<Scalars['String']>;
};

export type BlockGalleryOutput = {
  __typename?: 'BlockGalleryOutput';
  block: Scalars['String'];
  caption?: Maybe<Scalars['String']>;
  pictureid: Scalars['String'];
  resourceid: Scalars['String'];
  seqno: Scalars['Float'];
  url: Scalars['String'];
};

export type BlockInput = {
  currentLabel: Scalars['String'];
  modifiedLabel?: InputMaybe<Scalars['String']>;
};

export type BlockListingOutput = {
  __typename?: 'blockListingOutput';
  block: Scalars['String'];
  floorList?: Maybe<Array<FloorListingOutput>>;
  totalFloor: Scalars['Float'];
};

export type BookingAnalysisBiOutput = {
  __typename?: 'BookingAnalysisBIOutput';
  cancelCount?: Maybe<Scalars['Float']>;
  cancelRate?: Maybe<Scalars['Float']>;
  leadSources?: Maybe<Array<BookingAnalysisSourceListBiOutput>>;
  signCount?: Maybe<Scalars['Float']>;
  signRate?: Maybe<Scalars['Float']>;
  totalAmount?: Maybe<Scalars['Float']>;
  totalCount?: Maybe<Scalars['Float']>;
};

export type BookingAnalysisSourceListBiOutput = {
  __typename?: 'BookingAnalysisSourceListBIOutput';
  leadSourceCount?: Maybe<Scalars['Float']>;
  leadSourceName: Scalars['String'];
  value?: Maybe<Scalars['Float']>;
};

export type BookingAttachmentsOutput = {
  __typename?: 'bookingAttachmentsOutput';
  bookingCcrAttachments: Array<AttachmentEntity>;
  bookingFeeAttachments: Array<AttachmentEntity>;
  bookingNricAttachments: Array<AttachmentEntity>;
  bookingPdpaAttachments: Array<AttachmentEntity>;
  solicitorAgreementAttachments: Array<AttachmentEntity>;
  solicitorOthersAttachments: Array<AttachmentEntity>;
};

export type BookingBiOutput = {
  __typename?: 'BookingBIOutput';
  agency: BookingListDetailBiOutput;
  cancelCount?: Maybe<Scalars['Float']>;
  cancelRate?: Maybe<Scalars['Float']>;
  direct: BookingListDetailBiOutput;
  lead: BookingListDetailBiOutput;
  signCount?: Maybe<Scalars['Float']>;
  signRate?: Maybe<Scalars['Float']>;
  totalAmount?: Maybe<Scalars['Float']>;
  totalCount?: Maybe<Scalars['Float']>;
};

export type BookingCancellationNotificationInput = {
  agencyUserReceive?: InputMaybe<Scalars['Boolean']>;
  purchaserReceive?: InputMaybe<Scalars['Boolean']>;
  salesUserReceive?: InputMaybe<Scalars['Boolean']>;
};

export type BookingCancellationNotificationOutput = {
  __typename?: 'BookingCancellationNotificationOutput';
  agencyUserReceive?: Maybe<Scalars['Boolean']>;
  purchaserReceive?: Maybe<Scalars['Boolean']>;
  salesUserReceive?: Maybe<Scalars['Boolean']>;
};

export type BookingConfirmationStatusOutput = {
  __typename?: 'BookingConfirmationStatusOutput';
  cancelledCount: Scalars['Float'];
  eLaunchAppCount: Scalars['Float'];
  integrationCount: Scalars['Float'];
  pendingCount?: Maybe<Scalars['Float']>;
  purchaserAppCount: Scalars['Float'];
  reservationCount: Scalars['Float'];
  total: Scalars['Float'];
};

export type BookingContactSaleOutput = {
  __typename?: 'bookingContactSaleOutput';
  companyName?: Maybe<Scalars['String']>;
  companyRegNo?: Maybe<Scalars['String']>;
  contactExtId?: Maybe<Scalars['String']>;
  contactId: Scalars['String'];
  correspondenceAddress?: Maybe<AddressJson>;
  customerOrigin?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  fullName: Scalars['String'];
  gender?: Maybe<Scalars['String']>;
  identityNo?: Maybe<Scalars['String']>;
  identityType?: Maybe<Scalars['String']>;
  incomeRange?: Maybe<Scalars['String']>;
  isForeignPurchase?: Maybe<Scalars['Boolean']>;
  isVip?: Maybe<Scalars['Boolean']>;
  mailingMethod?: Maybe<Scalars['String']>;
  maritalStatus?: Maybe<Scalars['String']>;
  nameOnTax?: Maybe<Scalars['String']>;
  nationality?: Maybe<Scalars['String']>;
  otherContactNumber?: Maybe<Scalars['String']>;
  otherHomeTelNo?: Maybe<Scalars['String']>;
  otherOfficeTelNo?: Maybe<Scalars['String']>;
  profession?: Maybe<Scalars['String']>;
  religion?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
  salutation?: Maybe<Scalars['String']>;
  subscribeMaterialEmail?: Maybe<Scalars['Boolean']>;
  subscribeMaterialPaNews?: Maybe<Scalars['Boolean']>;
  subscribeMaterialSms?: Maybe<Scalars['Boolean']>;
  subscribeMaterialWhatsApp?: Maybe<Scalars['Boolean']>;
  taxRegistrationAddress?: Maybe<Scalars['String']>;
  taxRegistrationNo?: Maybe<Scalars['String']>;
};

export type BookingDetails2Output = {
  __typename?: 'BookingDetails2Output';
  BookingFeeAmt?: Maybe<Scalars['Float']>;
  BookingFeeAttached?: Maybe<Scalars['Boolean']>;
  BookingFeePaymentType?: Maybe<Scalars['String']>;
  ContactID: Scalars['String'];
  ContractNo?: Maybe<Scalars['String']>;
  DiscountName?: Maybe<Scalars['String']>;
  DiscountPrice?: Maybe<Scalars['Float']>;
  IntegrationType?: Maybe<Scalars['String']>;
  IsBumiUnit: Scalars['Boolean'];
  JointBuyerCount?: Maybe<Scalars['Float']>;
  PackageName?: Maybe<Scalars['String']>;
  PackagePrice?: Maybe<Scalars['Float']>;
  PurchaserAddress?: Maybe<Scalars['String']>;
  PurchaserEmail?: Maybe<Scalars['String']>;
  PurchaserIdentityNo?: Maybe<Scalars['String']>;
  PurchaserMobileNo?: Maybe<Scalars['String']>;
  PurchaserName: Scalars['String'];
  SaleAttachmentCount?: Maybe<Scalars['Float']>;
  SaleBillProgress?: Maybe<Scalars['Float']>;
  SaleDate: Scalars['DateTime'];
  SaleRemark?: Maybe<Scalars['String']>;
  SaleSellingPrice: Scalars['Float'];
  SaleSignDate?: Maybe<Scalars['DateTime']>;
  SalesNo: Scalars['String'];
  SalesPerson?: Maybe<Scalars['String']>;
  SaleStatus: Scalars['String'];
  SubProductPrice?: Maybe<Scalars['Float']>;
  UnitBlock?: Maybe<Scalars['String']>;
  UnitBuildUp?: Maybe<Scalars['Float']>;
  UnitDirection?: Maybe<Scalars['String']>;
  UnitExtraLandPrice?: Maybe<Scalars['Float']>;
  UnitID: Scalars['String'];
  UnitLandRate?: Maybe<Scalars['Float']>;
  UnitLayoutType?: Maybe<Scalars['String']>;
  UnitListPrice?: Maybe<Scalars['Float']>;
  UnitNo: Scalars['String'];
  UnitPropertyType?: Maybe<Scalars['String']>;
};

export type BookingDetailsOutput = {
  __typename?: 'BookingDetailsOutput';
  Address?: Maybe<Scalars['String']>;
  Attachment?: Maybe<Array<AttachmentEntity>>;
  BookingAmt?: Maybe<Scalars['Float']>;
  BuildUpArea?: Maybe<Scalars['Float']>;
  DeveloperAddress?: Maybe<Scalars['String']>;
  DeveloperMobileNo?: Maybe<Scalars['String']>;
  DiscountName?: Maybe<Scalars['String']>;
  Email: Scalars['String'];
  FullName: Scalars['String'];
  IdentityNo?: Maybe<Scalars['String']>;
  IsBumi: Scalars['Boolean'];
  ListPrice?: Maybe<Scalars['Float']>;
  MobileNo?: Maybe<Scalars['String']>;
  PackageName?: Maybe<Scalars['String']>;
  PaymentMethod?: Maybe<Scalars['String']>;
  PaymentRef?: Maybe<Scalars['String']>;
  PaymentTo?: Maybe<Scalars['String']>;
  Remark?: Maybe<Scalars['String']>;
  SaleID: Scalars['String'];
  SaleNo: Scalars['String'];
  SellingPrice?: Maybe<Scalars['Float']>;
  StaffName?: Maybe<Scalars['String']>;
  UnitNo: Scalars['String'];
};

export type BookingFeeDetailsOuput = {
  __typename?: 'bookingFeeDetailsOuput';
  attachment?: Maybe<Array<AttachmentEntity>>;
  bankId?: Maybe<Scalars['String']>;
  modBy?: Maybe<Scalars['String']>;
  modTs?: Maybe<Scalars['DateTime']>;
  paymentAmt?: Maybe<Scalars['Float']>;
  paymentDate?: Maybe<Scalars['DateTime']>;
  paymentMethod: Scalars['String'];
  paymentRefNo?: Maybe<Scalars['String']>;
  paymentRemarks?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<Scalars['String']>;
  trNo?: Maybe<Scalars['String']>;
};

export type BookingFeeELetterOutput = {
  __typename?: 'bookingFeeELetterOutput';
  content: Scalars['String'];
  fileName: Scalars['String'];
};

export type BookingFeeEletterTemplateOutput = {
  __typename?: 'bookingFeeEletterTemplateOutput';
  defaulted: Scalars['Boolean'];
  id: Scalars['String'];
  letterType: Scalars['String'];
  name: Scalars['String'];
};

export type BookingJointBuyerOutput = {
  __typename?: 'BookingJointBuyerOutput';
  Email?: Maybe<Scalars['String']>;
  IdentityNo: Scalars['String'];
  MobilePhone?: Maybe<Scalars['String']>;
  Name: Scalars['String'];
};

export type BookingLeadsOutput = {
  __typename?: 'BookingLeadsOutput';
  contact_id: Scalars['String'];
  email: Scalars['String'];
  full_name: Scalars['String'];
  ic_no?: Maybe<Scalars['String']>;
  lead_id?: Maybe<Scalars['String']>;
  lead_source_id?: Maybe<Scalars['String']>;
  military_ic?: Maybe<Scalars['String']>;
  nationality_id?: Maybe<Scalars['String']>;
  phone_no: Scalars['String'];
};

export type BookingListDataOutput = {
  __typename?: 'BookingListDataOutput';
  agentPersonName?: Maybe<Scalars['String']>;
  bookingRemark?: Maybe<Scalars['String']>;
  builtUp: Scalars['String'];
  buyerCompanyName?: Maybe<Scalars['String']>;
  buyerCompanyRegNo?: Maybe<Scalars['String']>;
  buyerEmail?: Maybe<Scalars['String']>;
  buyerId: Scalars['String'];
  buyerName: Scalars['String'];
  buyerNric: Scalars['String'];
  buyerPhoneNo?: Maybe<Scalars['String']>;
  cancelledByName?: Maybe<Scalars['String']>;
  cancelledDate?: Maybe<Scalars['DateTime']>;
  cancelledReason?: Maybe<Scalars['String']>;
  isCompany?: Maybe<Scalars['Boolean']>;
  isPurchaserInfoComplete?: Maybe<Scalars['Boolean']>;
  listPrice: Scalars['String'];
  paidAmount?: Maybe<Scalars['Float']>;
  paymentMethod?: Maybe<Scalars['String']>;
  projectId: Scalars['String'];
  saleDate: Scalars['DateTime'];
  salePaymentId?: Maybe<Scalars['String']>;
  salePaymentStatus?: Maybe<Scalars['String']>;
  salePersonName?: Maybe<Scalars['String']>;
  salesId: Scalars['String'];
  salesNo: Scalars['String'];
  salesStatus: Scalars['String'];
  sellingPrice: Scalars['String'];
  unitId: Scalars['String'];
  unitLayout?: Maybe<Scalars['String']>;
  unitNo: Scalars['String'];
};

export type BookingListDetailBiOutput = {
  __typename?: 'BookingListDetailBIOutput';
  existingAmount?: Maybe<Scalars['Float']>;
  existingCount?: Maybe<Scalars['Float']>;
  newAmount?: Maybe<Scalars['Float']>;
  newCount?: Maybe<Scalars['Float']>;
  totalAmount?: Maybe<Scalars['Float']>;
  totalCount?: Maybe<Scalars['Float']>;
};

export type BookingListLoanScreeningOutput = {
  __typename?: 'BookingListLoanScreeningOutput';
  caseCode: Scalars['String'];
  CCRIS?: Maybe<Scalars['String']>;
  CTOS?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type BookingNotificationInput = {
  assignmentAgencyUserReceive?: InputMaybe<Scalars['Boolean']>;
  assignmentPurchaserReceive?: InputMaybe<Scalars['Boolean']>;
  assignmentSalesUserReceive?: InputMaybe<Scalars['Boolean']>;
  attachBookingAttachment?: InputMaybe<Scalars['Boolean']>;
  attachTr?: InputMaybe<Scalars['Boolean']>;
};

export type BookingNotificationOutput = {
  __typename?: 'BookingNotificationOutput';
  assignmentAgencyUserReceive?: Maybe<Scalars['Boolean']>;
  assignmentPurchaserReceive?: Maybe<Scalars['Boolean']>;
  assignmentSalesUserReceive?: Maybe<Scalars['Boolean']>;
  attachBookingAttachment?: Maybe<Scalars['Boolean']>;
  attachTr?: Maybe<Scalars['Boolean']>;
};

export type BookingWaitlistEntity = {
  __typename?: 'bookingWaitlistEntity';
  accountId: Scalars['String'];
  agency?: Maybe<UserEntity>;
  agencyAcctId?: Maybe<Scalars['String']>;
  agentPersonId?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  contact: LeadContactEntity;
  contactId: Scalars['String'];
  id: Scalars['String'];
  lead: LeadEntity;
  leadId: Scalars['String'];
  leaveTime?: Maybe<Scalars['DateTime']>;
  project: ProjectEntity;
  queueTime: Scalars['DateTime'];
  reason?: Maybe<Scalars['String']>;
  releaseDate?: Maybe<Scalars['DateTime']>;
  salesPerson?: Maybe<UserEntity>;
  salesPersonId: Scalars['String'];
  seqno: Scalars['Float'];
  team: SaleTeamEntity;
  teamId: Scalars['String'];
  unit: UnitEntity;
};

export type BookStatusOutput = {
  __typename?: 'BookStatusOutput';
  bookedCount?: Maybe<Scalars['Float']>;
  cancelledCount?: Maybe<Scalars['Float']>;
  reserveCount?: Maybe<Scalars['Float']>;
  signedCount?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  totalSellingPrice?: Maybe<Scalars['Float']>;
};

export type BpDownloadAttachmentInput = {
  attachmentName: Scalars['String'];
  attachmentUrl: Scalars['String'];
};

export type BridgingFinancierEntity = {
  __typename?: 'bridgingFinancierEntity';
  accountId: Scalars['String'];
  bridgingFinancierUnit: Array<BridgingFinancierUnitEntity>;
  chargeExecutionType: Scalars['String'];
  chargeExecutionValue: Scalars['Float'];
  commonStatus: Scalars['String'];
  financierId: Scalars['String'];
  financierReferenceNo: Scalars['String'];
  id: Scalars['String'];
  projectId: Scalars['String'];
  solicitorId: Scalars['String'];
  solicitorReferenceNo: Scalars['String'];
};

export type BridgingFinancierSharedOutput = {
  __typename?: 'bridgingFinancierSharedOutput';
  bridgingFinancier: Scalars['String'];
  bridgingFinancierCode?: Maybe<Scalars['String']>;
  bridgingFinancierRefNo?: Maybe<Scalars['String']>;
  bridgingSolicitor: Scalars['String'];
  bridgingSolicitorRefNo?: Maybe<Scalars['String']>;
  chargeExeType?: Maybe<Scalars['String']>;
  chargeExeValue: Scalars['Float'];
  financierDetail?: Maybe<Array<BridgingFinancierUnitDetailsOutput>>;
  id: Scalars['String'];
  redemptionBalance?: Maybe<Scalars['Float']>;
  redemptionPaid?: Maybe<Scalars['Float']>;
  totalBfAmount: Scalars['Float'];
  totalBfUnits: Scalars['Float'];
  unitNo?: Maybe<Array<Scalars['String']>>;
};

export type BridgingFinancierUnitDetailsOutput = {
  __typename?: 'bridgingFinancierUnitDetailsOutput';
  bfuId: Scalars['String'];
  unitAmount: Scalars['Float'];
  unitNo: Scalars['String'];
};

export type BridgingFinancierUnitEntity = {
  __typename?: 'bridgingFinancierUnitEntity';
  accountId: Scalars['String'];
  amount: Scalars['Float'];
  bridgingFinancier: BridgingFinancierEntity;
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  projectBridgingFinancierId: Scalars['String'];
  projectId: Scalars['String'];
  unitId: Scalars['String'];
};

export type BuildingContractInfo = {
  architecturePermit?: InputMaybe<Scalars['String']>;
  buildingContractorAwarded?: InputMaybe<Scalars['String']>;
  buildingContractorName?: InputMaybe<Scalars['String']>;
  builtUpArea?: InputMaybe<Scalars['Float']>;
  commonArea?: InputMaybe<Scalars['Float']>;
  commonAreaPercent?: InputMaybe<Scalars['Float']>;
  constructionPermit?: InputMaybe<Scalars['String']>;
  densityPercentage?: InputMaybe<Scalars['Float']>;
  DLPTerm1?: InputMaybe<Scalars['Float']>;
  DLPTerm2?: InputMaybe<Scalars['Float']>;
  floorArea?: InputMaybe<Scalars['Float']>;
  floorAreaPercent?: InputMaybe<Scalars['Float']>;
  greenspaceArea?: InputMaybe<Scalars['Float']>;
  greenspaceAreaPercent?: InputMaybe<Scalars['Float']>;
  landArea?: InputMaybe<Scalars['Float']>;
  salesPermit?: InputMaybe<Scalars['String']>;
  usagePurpose?: InputMaybe<Scalars['String']>;
  usageRatioPercent?: InputMaybe<Scalars['Float']>;
  warrantyPeriod?: InputMaybe<Scalars['Float']>;
};

export type BusinessInsightSummaryOutput = {
  __typename?: 'BusinessInsightSummaryOutput';
  bookingListSummary: Scalars['String'];
  cpSummary: Scalars['String'];
  loanBISummary: Scalars['String'];
  lsmSummary: Scalars['String'];
  outstandingSnPSummary: Scalars['String'];
  pspSummary: Scalars['String'];
  salesAnalysisByUnitSummary: Scalars['String'];
  salesAnalysisSummary: Scalars['String'];
  salesMovementSummary: Scalars['String'];
  sapSummary: Scalars['String'];
  scaSummary: Scalars['String'];
  sdaSummary: Scalars['String'];
  slpSummary: Scalars['String'];
  stpSummary: Scalars['String'];
  ToPMsummary: Scalars['String'];
  waitingListSummary: Scalars['String'];
};

export type BuyBackDataOutput = {
  __typename?: 'buyBackDataOutput';
  banks: Array<BankOutput>;
  unitList: Array<BuyBackUnitList>;
};

export type BuyBackUnitList = {
  __typename?: 'buyBackUnitList';
  financier_id: Scalars['String'];
  full_name: Scalars['String'];
  is_refinanced: Scalars['String'];
  name: Scalars['String'];
  old_balance?: Maybe<Array<Scalars['JSONObject']>>;
  projectId: Scalars['String'];
  sale_id: Scalars['String'];
  sale_loan_id: Scalars['String'];
  saleLoanPayment?: Maybe<Array<SalePaymentOutput>>;
  table_ref: Scalars['String'];
  unit_no: Scalars['String'];
  unitClusterId: Scalars['String'];
  unitId: Scalars['String'];
  unitNo: Scalars['String'];
};

export type Buyer = {
  address?: InputMaybe<AddressJsonInput>;
  addressListing?: InputMaybe<Array<AddressJsonInput>>;
  attachment?: InputMaybe<Array<Scalars['Upload']>>;
  companyName?: InputMaybe<Scalars['String']>;
  companyPurchaser?: InputMaybe<Scalars['Boolean']>;
  companyRegNo?: InputMaybe<Scalars['String']>;
  contactId?: InputMaybe<Scalars['String']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']>;
  deleteAttachments?: InputMaybe<Array<Scalars['String']>>;
  email: Scalars['String'];
  gender: Scalars['String'];
  homeNo?: InputMaybe<Scalars['String']>;
  icNo: Scalars['String'];
  identityType: Scalars['String'];
  incomeRange?: InputMaybe<Scalars['String']>;
  isForeignPurchase?: InputMaybe<Scalars['Boolean']>;
  isPrincipalBuyer?: InputMaybe<Scalars['Boolean']>;
  isVip?: InputMaybe<Scalars['Boolean']>;
  jointSeqNo?: InputMaybe<Scalars['Float']>;
  mailingMethod: Scalars['String'];
  maritalStatusId: Scalars['String'];
  militaryIc?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  nameTaxReg?: InputMaybe<Scalars['String']>;
  nationalityId: Scalars['String'];
  officeNo?: InputMaybe<Scalars['String']>;
  phoneNo: Scalars['String'];
  professionId?: InputMaybe<Scalars['String']>;
  religionId?: InputMaybe<Scalars['String']>;
  remark: Scalars['String'];
  saleId?: InputMaybe<Scalars['String']>;
  salutationId?: InputMaybe<Scalars['String']>;
  subscribeEmail?: InputMaybe<Scalars['Boolean']>;
  subscribeWeChat?: InputMaybe<Scalars['Boolean']>;
  subscribeWhatsapp?: InputMaybe<Scalars['Boolean']>;
  taxRegAddr?: InputMaybe<Scalars['String']>;
  taxRegNo?: InputMaybe<Scalars['String']>;
};

export type BuyerListOutput = {
  __typename?: 'buyerListOutput';
  address?: Maybe<AddressJson>;
  addressList?: Maybe<Array<AddressList>>;
  commonStatus?: Maybe<Scalars['String']>;
  contactExt?: Maybe<ContactExti>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  detailId: Scalars['String'];
  email: Scalars['String'];
  gender: Scalars['String'];
  homeTelNo?: Maybe<Scalars['String']>;
  identityNo: Scalars['String'];
  incomeRange?: Maybe<Scalars['String']>;
  IsPrincipalBuyer: Scalars['Boolean'];
  maritalStatus: Scalars['String'];
  mobileNo: Scalars['String'];
  name: Scalars['String'];
  nationality: Scalars['String'];
  officeTelNo?: Maybe<Scalars['String']>;
  profession?: Maybe<Scalars['String']>;
  religion?: Maybe<Scalars['String']>;
  salutation?: Maybe<Scalars['String']>;
  tax?: Maybe<Tax>;
};

export type BuyerRegistrationOutput = {
  __typename?: 'BuyerRegistrationOutput';
  address?: Maybe<AddressJson>;
  attachmentUrl?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  gender: Scalars['String'];
  homeNo?: Maybe<Scalars['String']>;
  icNo: Scalars['String'];
  id: Scalars['String'];
  identityType: Scalars['String'];
  mailing?: Maybe<Scalars['String']>;
  maritalStatus: Scalars['String'];
  name: Scalars['String'];
  nameTaxReg?: Maybe<Scalars['String']>;
  nationality: Scalars['String'];
  officeNo?: Maybe<Scalars['String']>;
  phoneNo?: Maybe<Scalars['String']>;
  profession?: Maybe<Scalars['String']>;
  religion?: Maybe<Scalars['String']>;
  remark: Scalars['String'];
  salutation?: Maybe<Scalars['String']>;
  subscribeEmail: Scalars['Boolean'];
  subscribeWeChat: Scalars['Boolean'];
  subscribeWhatsapp: Scalars['Boolean'];
  taxRegAddr?: Maybe<Scalars['String']>;
  taxRegNo?: Maybe<Scalars['String']>;
};

export type CalculateBridgingExeValueInput = {
  chargeExeType: Scalars['String'];
  chargeExeValue: Scalars['Float'];
  unitIds: Array<Scalars['String']>;
};

export type CalculateDiscountAmountInput = {
  DefaultTaxRate?: InputMaybe<Scalars['Float']>;
  discountMethod: Scalars['String'];
  discountVal: Scalars['Float'];
  getTax?: InputMaybe<Scalars['Boolean']>;
  isRounding?: InputMaybe<Scalars['Boolean']>;
  isSeq: Scalars['Boolean'];
  prefix: Scalars['String'];
  roundingMode?: InputMaybe<Scalars['String']>;
  roundingPrecision?: InputMaybe<Scalars['String']>;
  saleID: Scalars['String'];
  seqNo: Scalars['Float'];
  type: Scalars['String'];
};

export type CalculatedUnitExeDetails = {
  __typename?: 'calculatedUnitExeDetails';
  calculatedUnitValue: Scalars['Float'];
  unitId: Scalars['String'];
  unitNo: Scalars['String'];
};

export type CalculatedUnitExeValue = {
  __typename?: 'calculatedUnitExeValue';
  totalCalculatedValue?: Maybe<Scalars['Float']>;
  unitExeDetail: Array<CalculatedUnitExeDetails>;
};

export type CalculateLadGenerateValueInput = {
  commonFacility: Scalars['Boolean'];
  facilityDuration?: InputMaybe<Scalars['Float']>;
  facilityLADPercent?: InputMaybe<Scalars['Float']>;
  handoverDateByCommonFacility?: InputMaybe<Scalars['DateTime']>;
  handoverDateByUnit: Scalars['DateTime'];
  payoutPercent: Scalars['Float'];
  spaPercent: Scalars['Float'];
  startWith: Scalars['String'];
  taxSchemeId: Scalars['String'];
  unitDuration: Scalars['Float'];
  unitLadPercent: Scalars['Float'];
  units: Array<Scalars['String']>;
};

export type CalculateMiscBillingTaxAmountInput = {
  amount: Scalars['Float'];
  date: Scalars['DateTime'];
  taxSchemeId: Scalars['String'];
};

export type CalculateSalesDiscountInput = {
  DefaultTaxRate?: InputMaybe<Scalars['Float']>;
  discountMethod: Scalars['String'];
  discountsList?: InputMaybe<Array<UnitTransferDiscounts>>;
  discountVal: Scalars['Float'];
  getTax?: InputMaybe<Scalars['Boolean']>;
  isRounding?: InputMaybe<Scalars['Boolean']>;
  isSeq: Scalars['Boolean'];
  prefix: Scalars['String'];
  premiumAmount?: InputMaybe<Scalars['Float']>;
  roundingMode?: InputMaybe<Scalars['String']>;
  roundingPrecision?: InputMaybe<Scalars['String']>;
  saleID?: InputMaybe<Scalars['String']>;
  seqNo: Scalars['Float'];
  type: Scalars['String'];
  unitId?: InputMaybe<Scalars['String']>;
};

export type CalculateSalesRegDiscountInput = {
  discountMethod: Scalars['String'];
  discounts?: InputMaybe<Array<AddSalesRegistrationDiscountInput>>;
  discountVal: Scalars['Float'];
  isRounding?: InputMaybe<Scalars['Boolean']>;
  prefix: Scalars['String'];
  roundingMode?: InputMaybe<Scalars['String']>;
  roundingPrecision?: InputMaybe<Scalars['String']>;
  saleId: Scalars['String'];
  taxSchemeId: Scalars['String'];
};

export type CalculateTaxAmountInput = {
  amount: Scalars['Float'];
  date: Scalars['DateTime'];
  taxSchemeId: Scalars['String'];
};

export type CampaignEntity = {
  __typename?: 'campaignEntity';
  accountId: Scalars['String'];
  commonStatus?: Maybe<Scalars['String']>;
  endDate: Scalars['DateTime'];
  events: Array<EventsEntity>;
  getCampaignEventsCount: Scalars['Float'];
  getCampaignSaleRebatePackageCount: Scalars['Float'];
  id: Scalars['String'];
  isExistInMasterData: Array<Scalars['String']>;
  isExistInTransactionData: Array<Scalars['String']>;
  name: Scalars['String'];
  projectId?: Maybe<Scalars['String']>;
  saleRebatePackage: SaleRebatePackageEntity;
  startDate: Scalars['DateTime'];
};

export type CampaignPerformanceBiOutput = {
  __typename?: 'CampaignPerformanceBIOutput';
  booked?: Maybe<Scalars['Float']>;
  converted?: Maybe<Scalars['Float']>;
  endDate: Scalars['DateTime'];
  id: Scalars['String'];
  leads?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  signed?: Maybe<Scalars['Float']>;
  startDate: Scalars['DateTime'];
  total: Scalars['String'];
  unconverted?: Maybe<Scalars['Float']>;
};

export type CancelPurchaserTransferInput = {
  purchaserTransferId?: InputMaybe<Scalars['String']>;
};

export type Car_Park = {
  __typename?: 'car_park';
  carPark: Scalars['String'];
  progressBilling: Array<ProgressBilling>;
};

export type CarParkAdditionalPackageSummary = {
  __typename?: 'carParkAdditionalPackageSummary';
  itemCount?: Maybe<Scalars['Float']>;
  totalAllocateAmount?: Maybe<Scalars['Float']>;
  totalOutstandingAmount?: Maybe<Scalars['Float']>;
  totalSellingPrice?: Maybe<Scalars['Float']>;
};

export type CarParkIndOutput = {
  __typename?: 'carParkIndOutput';
  carParkId: Scalars['String'];
  carParkNo: Scalars['String'];
  carParkPrice?: Maybe<Scalars['Float']>;
  paymentAmt?: Maybe<Scalars['Float']>;
  paymentPlanId?: Maybe<Scalars['String']>;
  paymentPlanName?: Maybe<Scalars['String']>;
  sellingMethod: Scalars['String'];
  taxRate?: Maybe<Scalars['Float']>;
  taxSchemeId?: Maybe<Scalars['String']>;
  taxSchemeName?: Maybe<Scalars['String']>;
  unitId?: Maybe<Scalars['String']>;
};

export type CarParkInstallmentDetail = {
  __typename?: 'carParkInstallmentDetail';
  allocationAmount?: Maybe<Scalars['Float']>;
  billType?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  documentAmount?: Maybe<Scalars['Float']>;
  documentDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  transactionDate?: Maybe<Scalars['DateTime']>;
};

export type CarParkInstallmentEntity = {
  __typename?: 'carParkInstallmentEntity';
  accountId: Scalars['String'];
  baseAmt?: Maybe<Scalars['Float']>;
  billType?: Maybe<Scalars['String']>;
  carParkId: Scalars['String'];
  carparkPaymentId?: Maybe<Scalars['String']>;
  carParkPaymentPlan: CarParkPaymentPlanEntity;
  commonStatus: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  documentAmt?: Maybe<Scalars['Float']>;
  documentDate?: Maybe<Scalars['DateTime']>;
  documentNo?: Maybe<Scalars['String']>;
  glGenerated?: Maybe<Scalars['String']>;
  glGenerationBatch?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  interestRate?: Maybe<Scalars['Float']>;
  projectId: Scalars['String'];
  recordStatus: Scalars['String'];
  rescheduleId?: Maybe<Scalars['String']>;
  taxAmt?: Maybe<Scalars['Float']>;
  transDate?: Maybe<Scalars['DateTime']>;
};

export type CarParkInstallmentOutput = {
  __typename?: 'carParkInstallmentOutput';
  baseAmt: Scalars['Float'];
  billType: Scalars['String'];
  description: Scalars['String'];
  documentAmt: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  id: Scalars['String'];
  taxAmt: Scalars['Float'];
};

export type CarParkOutput = {
  __typename?: 'carParkOutput';
  id: Scalars['String'];
  unitNo: Scalars['String'];
};

export type CarParkPaymentPlanEntity = {
  __typename?: 'carParkPaymentPlanEntity';
  accountId: Scalars['String'];
  billAfter: BillAfter;
  billCount: Scalars['Float'];
  billFrequency: BillFrequency;
  billType: BillType;
  carParkId: Scalars['String'];
  carParkInstallment: Array<CarParkInstallmentEntity>;
  id: Scalars['String'];
  noInstallment: Scalars['Float'];
  paymentAmt: Scalars['Float'];
  purchaserPaymentPlanDetails: PurchaserPaymentPlanDetailsEntity;
  purchaserPaymentPlanDetailsId: Scalars['String'];
};

export type CarParkPaymentPlanListingOutput = {
  __typename?: 'carParkPaymentPlanListingOutput';
  id: Scalars['String'];
  markUpPercentage: Scalars['String'];
  name: Scalars['String'];
  projectPaymentPlanId: Scalars['String'];
  projectPlanEndDate: Scalars['DateTime'];
  projectPlanStartDate: Scalars['DateTime'];
};

export type CarParkPaymentPlanOutput = {
  __typename?: 'carParkPaymentPlanOutput';
  billAfter: Scalars['String'];
  billCount: Scalars['Float'];
  billFrequency: Scalars['String'];
  billType: Scalars['String'];
  carParkId: Scalars['String'];
  carparkPaymentId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  installmentDetails?: Maybe<Array<CarParkInstallmentOutput>>;
  noInstallment: Scalars['Float'];
  paymentAmt?: Maybe<Scalars['Float']>;
  paymentValue: Scalars['Float'];
  purchaserPaymentPlanDetailsId: Scalars['String'];
  title: Scalars['String'];
};

export type CarParkSummary = {
  __typename?: 'carParkSummary';
  itemCount?: Maybe<Scalars['Float']>;
  totalAllocateAmount?: Maybe<Scalars['Float']>;
  totalOutstandingAmount?: Maybe<Scalars['Float']>;
  totalSellingPrice?: Maybe<Scalars['Float']>;
};

export type CarParkUnitInstallmentOutput = {
  __typename?: 'carParkUnitInstallmentOutput';
  allocationAmount?: Maybe<Scalars['Float']>;
  carParkId?: Maybe<Scalars['String']>;
  document_amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['String']>;
  outstanding?: Maybe<Scalars['Float']>;
  total_allocated?: Maybe<Scalars['Float']>;
  unitNo?: Maybe<Scalars['String']>;
  unitPrice?: Maybe<Scalars['Float']>;
};

export type CheckAccessTokenOutout = {
  __typename?: 'checkAccessTokenOutout';
  accountId: Scalars['String'];
  userId: Scalars['String'];
};

export type CheckedItems = {
  baseAmount?: InputMaybe<Scalars['Float']>;
  billType?: InputMaybe<Scalars['String']>;
  commonStatus?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  documentAmount?: InputMaybe<Scalars['Float']>;
  documentDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  taxAmount?: InputMaybe<Scalars['Float']>;
  unallocatedAmount?: InputMaybe<Scalars['Float']>;
};

export type CityMasterDataOutput = {
  __typename?: 'CityMasterDataOutput';
  commonStatus: Scalars['String'];
  ID: Scalars['String'];
  name: Scalars['String'];
  stateID: Scalars['String'];
};

export type CloneStandardLetterInput = {
  letterTemplateId: Array<Scalars['String']>;
};

export type CloudStorageOutput = {
  __typename?: 'CloudStorageOutput';
  BucketFileName: Scalars['String'];
  FileName: Scalars['String'];
  IsPrivate?: Maybe<Scalars['Boolean']>;
  MediaType: Scalars['String'];
  PrivateUrl?: Maybe<Scalars['String']>;
  Url: Scalars['String'];
};

export type CnSummary = {
  __typename?: 'CNSummary';
  approveCount?: Maybe<Scalars['Float']>;
  draftCount?: Maybe<Scalars['Float']>;
  submitCount?: Maybe<Scalars['Float']>;
  totalDocAmt?: Maybe<Scalars['Float']>;
  totalUnallocatedAmt?: Maybe<Scalars['Float']>;
};

export type CollectionActivityEntity = {
  __typename?: 'collectionActivityEntity';
  accountId: Scalars['String'];
  activityDate: Scalars['DateTime'];
  activityRemark: Scalars['String'];
  activityStatus: Scalars['String'];
  activityType: Scalars['String'];
  attachment?: Maybe<Array<AttachmentEntity>>;
  commonStatus: Scalars['String'];
  completedDate: Scalars['DateTime'];
  followedUpId: Scalars['String'];
  id: Scalars['String'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
};

export type CollectionActivityIndoEntity = {
  __typename?: 'collectionActivityIndoEntity';
  accountId: Scalars['String'];
  activityDate: Scalars['DateTime'];
  activityRemark?: Maybe<Scalars['String']>;
  activityStatus?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  completedDate: Scalars['DateTime'];
  followedUpDate: Scalars['DateTime'];
  followedUpId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  overduePurchaserAccountId?: Maybe<Scalars['String']>;
  projectId: Scalars['String'];
  saleId: Scalars['String'];
};

export type CollectionActivityIndoOutput = {
  __typename?: 'collectionActivityIndoOutput';
  collectionActivityDetailList: Array<CollectionActivityEntity>;
  collectionActivitySummary: CollectionActivityOutput;
};

export type CollectionActivityListingOutput = {
  __typename?: 'collectionActivityListingOutput';
  activityDate: Scalars['DateTime'];
  activityRemark: Scalars['String'];
  documentAmount: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  fullName: Scalars['String'];
  id: Scalars['String'];
  saleId: Scalars['String'];
  sellingPrice: Scalars['Float'];
  unitId: Scalars['String'];
};

export type CollectionActivityOutput = {
  __typename?: 'collectionActivityOutput';
  purchaserDetail: PurchaserAccDetail;
  totalOutstanding: Scalars['Float'];
};

export type CollectionActivitySummaryOutput = {
  __typename?: 'collectionActivitySummaryOutput';
  activityDate: Scalars['DateTime'];
  activityRemark: Scalars['String'];
};

export type CollectionActivityUserPermEntity = {
  __typename?: 'CollectionActivityUserPermEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  projectId: Scalars['String'];
  salesPersonId: Scalars['String'];
};

export type CollectionActivityUserPermissionEntity = {
  __typename?: 'CollectionActivityUserPermissionEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  projectId: Scalars['String'];
  salesPersonId: Scalars['String'];
};

export type CollectionInfoLine = {
  __typename?: 'collectionInfoLine';
  totalApproved?: Maybe<Scalars['Float']>;
  totalDraft?: Maybe<Scalars['Float']>;
  totalSubmitted?: Maybe<Scalars['Float']>;
};

export enum CommercialPurpose {
  Commercial = 'COMMERCIAL',
  DescriptionList = 'DescriptionList',
  GetDescription = 'GetDescription',
  Residential = 'RESIDENTIAL'
}

export type CommissionCalculationDetailInput = {
  commissionAmt: Scalars['Float'];
  commissionDate: Scalars['DateTime'];
  commissionType: Scalars['String'];
  docDate: Scalars['DateTime'];
  docNo: Scalars['String'];
  employeeId: Scalars['String'];
  netSelling: Scalars['Float'];
  principal: Scalars['String'];
  projectCommissionPackageId: Scalars['String'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
};

export type CommissionCalculationInput = {
  employeeId: Scalars['String'];
  employeeName: Scalars['String'];
  generateDate: Scalars['DateTime'];
  principal: Scalars['String'];
  projectId: Scalars['String'];
  totalCommission: Scalars['Float'];
  totalSelling: Scalars['Float'];
};

export type CommissionCalculationOutput = {
  __typename?: 'CommissionCalculationOutput';
  commissionPackageTargetId: Scalars['String'];
  commissionType: Scalars['String'];
  companyCommissionTeamId?: Maybe<Scalars['String']>;
  companyId: Scalars['String'];
  dealClosure: Scalars['Float'];
  defaultPaidToDate?: Maybe<Scalars['Float']>;
  description: Scalars['String'];
  effectiveDate: Scalars['DateTime'];
  employeeId?: Maybe<Scalars['String']>;
  employeeName?: Maybe<Scalars['String']>;
  employeeTotalCommission: Scalars['Float'];
  employeeTotalSale: Scalars['Float'];
  existEmployeeId?: Maybe<Scalars['String']>;
  existProjectCommissionPackageId?: Maybe<Scalars['String']>;
  finalCommission?: Maybe<Scalars['Float']>;
  finalContractPrice?: Maybe<Scalars['Float']>;
  isDealClosure?: Maybe<Scalars['Boolean']>;
  jobPositionId?: Maybe<Scalars['String']>;
  level?: Maybe<Scalars['Float']>;
  minimumTarget: Scalars['Float'];
  overRiding: Scalars['Float'];
  paidToDate?: Maybe<Scalars['Float']>;
  paidToDatePercentage?: Maybe<Scalars['Float']>;
  parentId?: Maybe<Scalars['String']>;
  position: Scalars['String'];
  principal: Scalars['String'];
  projectCommissionPackageId?: Maybe<Scalars['String']>;
  propertyType: Scalars['String'];
  release: Scalars['Float'];
  saleId: Scalars['String'];
  salesConvertedStatus: Scalars['String'];
  salesRegistrationDate: Scalars['DateTime'];
  salesRegistrationNo?: Maybe<Scalars['String']>;
  totalFinalCommission?: Maybe<Scalars['Float']>;
  totalFinalContractPrice?: Maybe<Scalars['Float']>;
  unitLayout: Scalars['String'];
  unitNo: Scalars['String'];
  unitsSold: Scalars['Float'];
  unitSum?: Maybe<Scalars['Float']>;
};

export type CommissionPackageTargetDetailEntity = AuditEntity & {
  __typename?: 'commissionPackageTargetDetailEntity';
  accountId: Scalars['ID'];
  commissionPackageTargetId: Scalars['ID'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  dealClosure: Scalars['Float'];
  id: Scalars['ID'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  overriding: Scalars['Float'];
  position?: Maybe<JobPositionEntity>;
  positionId?: Maybe<Scalars['ID']>;
  teamPositionId?: Maybe<Scalars['ID']>;
};

export type CommissionPackageTargetDetailInput = {
  dealClosure: Scalars['Float'];
  id: Scalars['String'];
  overriding: Scalars['Float'];
  positionId?: InputMaybe<Scalars['String']>;
  teamPositionId: Scalars['String'];
};

export type CommissionPackageTargetEntity = AuditEntity & {
  __typename?: 'commissionPackageTargetEntity';
  accountId: Scalars['ID'];
  commissionPackageTargetDetails: Array<CommissionPackageTargetDetailEntity>;
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['ID'];
  minimumTarget: Scalars['Float'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  refId: Scalars['ID'];
  refTable: Scalars['String'];
};

export type CommissionPackageTargetInput = {
  commissionPackageTargetDetails: Array<CommissionPackageTargetDetailInput>;
  id: Scalars['String'];
  minimumTarget: Scalars['Float'];
};

export type CommissionPaymentEntity = AuditEntity & {
  __typename?: 'commissionPaymentEntity';
  accountId: Scalars['ID'];
  commissionStatutoryDocs: Array<CommissionStatutoryDocumentEntity>;
  commonStatus: Scalars['String'];
  companyCommission: CompanyCommissionEntity;
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['ID'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  paidToDate: Scalars['Float'];
  projectCommission: ProjectCommissionEntity;
  refId: Scalars['ID'];
  refTable: Scalars['String'];
  release: Scalars['Float'];
  remarks: Scalars['String'];
};

export type CommissionPaymentInput = {
  companyCommissionId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  paidToDate: Scalars['Float'];
  release: Scalars['Float'];
  remarks: Scalars['String'];
};

export type CommissionPaymentOutput = {
  __typename?: 'CommissionPaymentOutput';
  commissionStatutoryDocuments: Array<CommissionStatutoryDocumentOutput>;
  id: Scalars['ID'];
  paidToDate: Scalars['Float'];
  release: Scalars['Float'];
  remarks: Scalars['String'];
};

export type CommissionStatutoryDocumentEntity = AuditEntity & {
  __typename?: 'commissionStatutoryDocumentEntity';
  accountId: Scalars['ID'];
  commissionPayment: CommissionPaymentEntity;
  commissionPaymentId: Scalars['ID'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['ID'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  refId: Scalars['ID'];
  refTable: Scalars['String'];
  statutoryDocId: Scalars['ID'];
  statutoryDocument: StatutoryDocumentEntity;
};

export type CommissionStatutoryDocumentOutput = {
  __typename?: 'CommissionStatutoryDocumentOutput';
  code: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  statutoryDocId: Scalars['String'];
};

export type CommissionTypeEntity = {
  __typename?: 'commissionTypeEntity';
  accountId: Scalars['ID'];
  commonStatus: Scalars['String'];
  companyCommissions: Array<CompanyCommissionEntity>;
  id: Scalars['ID'];
  interval: Scalars['Float'];
  name: Scalars['String'];
  payOutType: Scalars['String'];
  projectCommissions: Array<ProjectCommissionEntity>;
  targetBy: Scalars['String'];
};

export type CommissionTypeInput = {
  id?: InputMaybe<Scalars['String']>;
  interval: Scalars['Float'];
  name: Scalars['String'];
  payOutType: Scalars['String'];
  targetBy: Scalars['String'];
};

export enum CommonStatus {
  Active = 'ACTIVE',
  Block = 'BLOCK',
  Inactive = 'INACTIVE'
}

export type CompanyArAgingPolicyEntity = {
  __typename?: 'companyArAgingPolicyEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  company: CompanyEntity;
  companyId: Scalars['String'];
  id: Scalars['String'];
  period1: Scalars['Float'];
  period2: Scalars['Float'];
  period3: Scalars['Float'];
  period4: Scalars['Float'];
  period5: Scalars['Float'];
  period6: Scalars['Float'];
};

export type CompanyBankAccountEntity = {
  __typename?: 'companyBankAccountEntity';
  accountId: Scalars['String'];
  accountNo: Scalars['String'];
  accountType: Scalars['String'];
  bankProfile: CompanyBankProfileEntity;
  bankProfileId: Scalars['String'];
  code: Scalars['String'];
  collection?: Maybe<Array<ReceiptEntity>>;
  commonStatus: Scalars['String'];
  companyId: Scalars['String'];
  currency: Scalars['String'];
  effectiveDate: Scalars['DateTime'];
  financier: Array<FinancierEntity>;
  id: Scalars['String'];
  projectBankIndos?: Maybe<Array<ProjectBankIndoEntity>>;
  receiptReversal?: Maybe<Array<ReceiptReversalEntity>>;
  swiftCode: Scalars['String'];
};

export type CompanyBankAccountOutput = {
  __typename?: 'companyBankAccountOutput';
  accountNo: Scalars['String'];
  accountType: Scalars['String'];
  bankAccountId: Scalars['String'];
  bankProfileId: Scalars['String'];
  code: Scalars['String'];
  currency?: Maybe<Scalars['String']>;
  effectiveDate: Scalars['DateTime'];
  swiftCode?: Maybe<Scalars['String']>;
};

export type CompanyBankList = {
  __typename?: 'companyBankList';
  bankAccountCode: Scalars['String'];
  bankAccountId: Scalars['String'];
  bankAccountNo: Scalars['String'];
  bankProfileId: Scalars['String'];
  bankProfileName: Scalars['String'];
  currency: Scalars['String'];
  isSelected?: Maybe<Scalars['Boolean']>;
};

export type CompanyBankOutput = {
  __typename?: 'companyBankOutput';
  bankAccountCode: Scalars['String'];
  bankAccountId: Scalars['String'];
  bankAccountNo: Scalars['String'];
  bankCurrency: Scalars['String'];
  bankProfileId: Scalars['String'];
  bankProfileName: Scalars['String'];
};

export type CompanyBankProfileEntity = {
  __typename?: 'companyBankProfileEntity';
  accountId: Scalars['String'];
  address: Scalars['String'];
  bankAccount: Array<CompanyBankAccountEntity>;
  commonStatus: Scalars['String'];
  company: CompanyEntity;
  companyId: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  phoneNo: Scalars['String'];
};

export type CompanyBankProfileOutput = {
  __typename?: 'companyBankProfileOutput';
  bankAccounts?: Maybe<Array<CompanyBankAccountOutput>>;
  bankAddress: Scalars['String'];
  bankId: Scalars['String'];
  bankName: Scalars['String'];
  bankPhoneNo: Scalars['String'];
};

export type CompanyCommissionCalculationDetailChild = {
  __typename?: 'CompanyCommissionCalculationDetailChild';
  children: Array<CompanyCommissionCalculationDetailSubChild>;
  commission_amt?: Maybe<Scalars['Float']>;
  commission_type?: Maybe<Scalars['String']>;
  company_commission_calc_id?: Maybe<Scalars['String']>;
  detail_id?: Maybe<Scalars['String']>;
  doc_date?: Maybe<Scalars['DateTime']>;
  doc_no?: Maybe<Scalars['String']>;
  employee_name?: Maybe<Scalars['String']>;
  generate_date?: Maybe<Scalars['DateTime']>;
  net_selling?: Maybe<Scalars['Float']>;
  principal?: Maybe<Scalars['String']>;
  sale_id?: Maybe<Scalars['String']>;
  sales_registration_no?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  unit_no?: Maybe<Scalars['String']>;
};

export type CompanyCommissionCalculationDetailOutput = {
  __typename?: 'CompanyCommissionCalculationDetailOutput';
  child_id?: Maybe<Scalars['String']>;
  children: Array<CompanyCommissionCalculationDetailChild>;
  commission_amt?: Maybe<Scalars['Float']>;
  commission_type?: Maybe<Scalars['String']>;
  company_commission_calc_id?: Maybe<Scalars['String']>;
  detail_id?: Maybe<Scalars['String']>;
  doc_date?: Maybe<Scalars['DateTime']>;
  doc_no?: Maybe<Scalars['String']>;
  employee_id?: Maybe<Scalars['String']>;
  employee_name?: Maybe<Scalars['String']>;
  generate_date?: Maybe<Scalars['DateTime']>;
  job_position?: Maybe<Scalars['String']>;
  net_selling?: Maybe<Scalars['Float']>;
  parent_id: Scalars['String'];
  principal: Scalars['String'];
  sale_id?: Maybe<Scalars['String']>;
  sales_commission?: Maybe<Scalars['Float']>;
  sales_registration_no?: Maybe<Scalars['String']>;
  total_commission: Scalars['String'];
  total_net_selling: Scalars['Float'];
  total_selling?: Maybe<Scalars['Float']>;
  type: Scalars['String'];
  unit_no?: Maybe<Scalars['String']>;
};

export type CompanyCommissionCalculationDetailSubChild = {
  __typename?: 'CompanyCommissionCalculationDetailSubChild';
  child_id?: Maybe<Scalars['String']>;
  commission_amt?: Maybe<Scalars['Float']>;
  commission_type?: Maybe<Scalars['String']>;
  company_commission_calc_id?: Maybe<Scalars['String']>;
  detail_id?: Maybe<Scalars['String']>;
  doc_date?: Maybe<Scalars['DateTime']>;
  doc_no?: Maybe<Scalars['String']>;
  net_selling?: Maybe<Scalars['Float']>;
  sale_id?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type CompanyCommissionEntity = {
  __typename?: 'companyCommissionEntity';
  accountId: Scalars['ID'];
  commissionPayments: Array<CommissionPaymentEntity>;
  commissionType: CommissionTypeEntity;
  commissionTypeId: Scalars['ID'];
  commonStatus: Scalars['String'];
  companyId: Scalars['ID'];
  description: Scalars['String'];
  id: Scalars['ID'];
};

export type CompanyCommissionPackageDetailEntity = {
  __typename?: 'companyCommissionPackageDetailEntity';
  accountId: Scalars['ID'];
  commissionPackageTargets: Array<CommissionPackageTargetEntity>;
  commonStatus: Scalars['String'];
  companyCommissionPackage: CompanyCommissionPackageEntity;
  companyCommissionPackageId: Scalars['ID'];
  effectiveDate: Scalars['DateTime'];
  id: Scalars['ID'];
};

export type CompanyCommissionPackageDetailInput = {
  commissionPackageTargets: Array<CommissionPackageTargetInput>;
  companyCommissionPackageId: Scalars['String'];
  effectiveDate: Scalars['DateTime'];
  id?: InputMaybe<Scalars['String']>;
};

export type CompanyCommissionPackageEntity = {
  __typename?: 'companyCommissionPackageEntity';
  accountId: Scalars['ID'];
  commonStatus: Scalars['String'];
  companyCommission: CompanyCommissionEntity;
  companyCommissionId: Scalars['ID'];
  companyCommissionPackageDetails: Array<CompanyCommissionPackageDetailEntity>;
  companyId: Scalars['ID'];
  id: Scalars['ID'];
  principal: Scalars['String'];
};

export type CompanyCommissionTeamDetailEntity = {
  __typename?: 'companyCommissionTeamDetailEntity';
  accountId: Scalars['ID'];
  children?: Maybe<Array<CompanyCommissionTeamDetailEntity>>;
  commonStatus: Scalars['String'];
  companyCommissionTeam: CompanyCommissionTeamEntity;
  companyCommissionTeamId: Scalars['ID'];
  id: Scalars['ID'];
  level?: Maybe<Scalars['Float']>;
  parent?: Maybe<CompanyCommissionTeamDetailEntity>;
  parentId?: Maybe<Scalars['ID']>;
  position?: Maybe<JobPositionEntity>;
  positionId?: Maybe<Scalars['ID']>;
  principal: Scalars['String'];
};

export type CompanyCommissionTeamDetailInput = {
  companyCommissionTeamId: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  level?: InputMaybe<Scalars['Float']>;
  parentId?: InputMaybe<Scalars['ID']>;
  positionId?: InputMaybe<Scalars['ID']>;
  principal: Scalars['String'];
};

export type CompanyCommissionTeamEntity = {
  __typename?: 'companyCommissionTeamEntity';
  accountId: Scalars['ID'];
  commonStatus: Scalars['String'];
  companyId: Scalars['ID'];
  details: Array<CompanyCommissionTeamDetailEntity>;
  generateDate: Scalars['DateTime'];
  id: Scalars['ID'];
  saleCommissionTeams: Array<SaleCommissionTeamEntity>;
};

export type CompanyCommissionTeamHeaderEntity = {
  __typename?: 'companyCommissionTeamHeaderEntity';
  accountId: Scalars['ID'];
  agency?: Maybe<AgencyAppointedEntity>;
  agencyAppointedId?: Maybe<Scalars['ID']>;
  commonStatus: Scalars['String'];
  companyCommissionTeam: CompanyCommissionTeamEntity;
  companyCommissionTeamId: Scalars['ID'];
  id: Scalars['ID'];
  position?: Maybe<JobPositionEntity>;
  positionId?: Maybe<Scalars['ID']>;
  principal: Scalars['String'];
  subheaders: Array<CompanyCommissionTeamSubheaderEntity>;
};

export type CompanyCommissionTeamSubheaderEntity = {
  __typename?: 'companyCommissionTeamSubheaderEntity';
  accountId: Scalars['ID'];
  agency?: Maybe<AgencyAppointedEntity>;
  agencyAppointedId?: Maybe<Scalars['ID']>;
  commonStatus: Scalars['String'];
  companyCommissionTeamHeaderId: Scalars['ID'];
  header: CompanyCommissionTeamHeaderEntity;
  id: Scalars['ID'];
  position?: Maybe<JobPositionEntity>;
  positionId?: Maybe<Scalars['ID']>;
  principal: Scalars['String'];
};

export type CompanyDetailOutput = {
  __typename?: 'companyDetailOutput';
  companyAddress: AddressJson;
  companyArPolicyPeriod1?: Maybe<Scalars['Float']>;
  companyArPolicyPeriod2?: Maybe<Scalars['Float']>;
  companyArPolicyPeriod3?: Maybe<Scalars['Float']>;
  companyArPolicyPeriod4?: Maybe<Scalars['Float']>;
  companyArPolicyPeriod5?: Maybe<Scalars['Float']>;
  companyArPolicyPeriod6?: Maybe<Scalars['Float']>;
  companyCode: Scalars['String'];
  companyDesc: Scalars['String'];
  companyEmail: Scalars['String'];
  companyGroupGstRegNo?: Maybe<Scalars['String']>;
  companyGstRegNo?: Maybe<Scalars['String']>;
  companyId: Scalars['String'];
  companyLogo?: Maybe<Scalars['String']>;
  companyName: Scalars['String'];
  companyOfficeTel: Scalars['String'];
  companyRegNo: Scalars['String'];
  companySstRegNo?: Maybe<Scalars['String']>;
  lastUpdateBank?: Maybe<Scalars['DateTime']>;
  lastUpdateTown?: Maybe<Scalars['DateTime']>;
};

export type CompanyEntity = {
  __typename?: 'companyEntity';
  accountId: Scalars['String'];
  address?: Maybe<AddressJson>;
  bankLastUpdate?: Maybe<Scalars['DateTime']>;
  bankProfile: Array<CompanyBankProfileEntity>;
  bankProfileCount?: Maybe<Scalars['Float']>;
  baseCurrencyId: Scalars['String'];
  code: Scalars['String'];
  companyArAgingPolicy?: Maybe<CompanyArAgingPolicyEntity>;
  companyLastUpdate?: Maybe<Scalars['DateTime']>;
  companyRegNo?: Maybe<Scalars['String']>;
  companyTax?: Maybe<CompanyTax>;
  contactNo?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  development: ProjectEntity;
  email?: Maybe<Scalars['String']>;
  groupGstRegNo?: Maybe<Scalars['String']>;
  gstExpiryDate?: Maybe<Scalars['DateTime']>;
  gstNo?: Maybe<Scalars['String']>;
  holding: ProjectEntity;
  id: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  imageBucketFile?: Maybe<Scalars['String']>;
  imageLogoPosition?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  isDeletable: Scalars['Boolean'];
  isoImplementation?: Maybe<Scalars['Boolean']>;
  isoLogoPosition?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  numberingStructureLastUpdate?: Maybe<Scalars['DateTime']>;
  officeTel?: Maybe<Scalars['String']>;
  parentCompanyId?: Maybe<Scalars['String']>;
  recordStatus: Scalars['String'];
  regionId?: Maybe<Scalars['String']>;
  sstNo?: Maybe<Scalars['String']>;
  township: Array<TownshipEntity>;
  townshipCount?: Maybe<Scalars['Float']>;
  townshipLastUpdate?: Maybe<Scalars['DateTime']>;
  watermarkImplementation?: Maybe<Scalars['Boolean']>;
  watermarkWording?: Maybe<Scalars['String']>;
  websiteUrl?: Maybe<Scalars['String']>;
};



export type CompanyExtEntity = {
  __typename?: 'companyExtEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  companyId: Scalars['String'];
  groupGstRegNo?: Maybe<Scalars['String']>;
  gstEffectiveDate?: Maybe<Scalars['DateTime']>;
  gstRegNo?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  sstRegNo?: Maybe<Scalars['String']>;
};

export type CompanyInfoOutput = {
  __typename?: 'companyInfoOutput';
  bankProfiles?: Maybe<Array<CompanyBankProfileOutput>>;
  companyCode: Scalars['String'];
  companyEmail: Scalars['String'];
  companyId: Scalars['String'];
  companyLogo?: Maybe<Scalars['String']>;
  companyName: Scalars['String'];
  companyOfficeTel?: Maybe<Scalars['String']>;
};

export type CompanyMsicAssignmentEntity = AuditEntity & {
  __typename?: 'CompanyMsicAssignmentEntity';
  accountID: Scalars['String'];
  companyID: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  eInvoiceMsicCode: EInvoiceMsicEntity;
  eInvoiceMsicCodeID: Scalars['String'];
  ID: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
};

export type CompanyNumberingStructureListingOutput = {
  __typename?: 'CompanyNumberingStructureListingOutput';
  sampleOutput?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  type: Scalars['String'];
};

export type CompanyNumberSetupEntity = {
  __typename?: 'companyNumberSetupEntity';
  companyId: Scalars['String'];
  id: Scalars['String'];
  nextNumber: Scalars['Float'];
  numberFormat: NumberFormatEntity;
  numberFormatId: Scalars['String'];
};

export type CompanyRewardCalculationOutput = {
  __typename?: 'CompanyRewardCalculationOutput';
  companyId: Scalars['String'];
  createdTs?: Maybe<Scalars['DateTime']>;
  employeeId: Scalars['String'];
  employeeName?: Maybe<Scalars['String']>;
  generateDate?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  principal: Scalars['String'];
  totalCommission?: Maybe<Scalars['Float']>;
  totalSelling?: Maybe<Scalars['Float']>;
};

export type CompanyRewardDetailInput = {
  commissionAmt: Scalars['Float'];
  commissionDate: Scalars['DateTime'];
  commissionType: Scalars['String'];
  companyCommissionPackageId: Scalars['String'];
  companyId: Scalars['String'];
  docDate: Scalars['DateTime'];
  docNo: Scalars['String'];
  employeeId: Scalars['String'];
  netSelling: Scalars['Float'];
  principal: Scalars['String'];
  saleId: Scalars['String'];
};

export type CompanyRewardInput = {
  companyId: Scalars['String'];
  employeeId: Scalars['String'];
  employeeName: Scalars['String'];
  generateDate: Scalars['DateTime'];
  principal: Scalars['String'];
  totalCommission: Scalars['Float'];
  totalSelling: Scalars['Float'];
};

export type CompanyRewardInputDetailEntity = {
  __typename?: 'companyRewardInputDetailEntity';
  accountId: Scalars['String'];
  commissionAmt: Scalars['Float'];
  commissionDate: Scalars['DateTime'];
  commissionType: Scalars['String'];
  commonStatus: Scalars['String'];
  companyCommissionCalcId: Scalars['String'];
  companyCommissionPackageId: Scalars['String'];
  companyId: Scalars['String'];
  createdBy: Scalars['String'];
  createdTs: Scalars['DateTime'];
  docDate: Scalars['DateTime'];
  docNo: Scalars['String'];
  id: Scalars['String'];
  modBy: Scalars['String'];
  modTs: Scalars['DateTime'];
  netSelling: Scalars['Float'];
  saleId: Scalars['String'];
};

export type CompanyRewardInputEntity = {
  __typename?: 'companyRewardInputEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  companyId: Scalars['String'];
  createdBy: Scalars['String'];
  createdTs: Scalars['DateTime'];
  employeeId: Scalars['String'];
  employeeName: Scalars['String'];
  generateDate: Scalars['DateTime'];
  id: Scalars['String'];
  modBy: Scalars['String'];
  modTs: Scalars['DateTime'];
  principal: Scalars['String'];
  totalCommission: Scalars['Float'];
  totalSelling: Scalars['Float'];
};

export type CompanyRewardOutput = {
  __typename?: 'CompanyRewardOutput';
  commissionType: Scalars['String'];
  companyCommissionPackageId?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['String']>;
  dealClosure?: Maybe<Scalars['Float']>;
  description: Scalars['String'];
  effectiveDate: Scalars['DateTime'];
  ejpEmployeeId?: Maybe<Scalars['String']>;
  ejpEmployeeName: Scalars['String'];
  employeeId?: Maybe<Scalars['String']>;
  employeeName?: Maybe<Scalars['String']>;
  employeeTotalCommission?: Maybe<Scalars['Float']>;
  employeeTotalSale?: Maybe<Scalars['Float']>;
  existCompanyCommissionPackageId?: Maybe<Scalars['String']>;
  existEmployeeId?: Maybe<Scalars['String']>;
  finalCommission?: Maybe<Scalars['Float']>;
  finalContractPrice?: Maybe<Scalars['Float']>;
  generateDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDealClosure?: Maybe<Scalars['Boolean']>;
  jobPosition?: Maybe<Scalars['String']>;
  level?: Maybe<Scalars['Float']>;
  overRiding?: Maybe<Scalars['Float']>;
  paidToDatePercentage?: Maybe<Scalars['Float']>;
  paymentPlanMarkUpAmount?: Maybe<Scalars['Float']>;
  principal: Scalars['String'];
  projectId: Scalars['String'];
  propertyType: Scalars['String'];
  saleId?: Maybe<Scalars['String']>;
  salesRegistrationDate: Scalars['DateTime'];
  salesRegistrationNo?: Maybe<Scalars['String']>;
  taxSchemeId?: Maybe<Scalars['String']>;
  totalFinalCommission?: Maybe<Scalars['Float']>;
  totalSelling?: Maybe<Scalars['Float']>;
  unitNo: Scalars['String'];
};

export enum CompanyTax {
  GstNo = 'GST_NO',
  NoTax = 'NO_TAX',
  SstNo = 'SST_NO'
}

export type CompletedCollectionAppointment = {
  electricalDate?: InputMaybe<Scalars['DateTime']>;
  electricalRemark?: InputMaybe<Scalars['String']>;
  handOverDate: Scalars['DateTime'];
  id: Scalars['String'];
  keysCollected: Scalars['Float'];
  saleId: Scalars['String'];
  sanitaryDate?: InputMaybe<Scalars['DateTime']>;
  sanitaryRemark?: InputMaybe<Scalars['String']>;
};

export enum ComputeMethod {
  DescriptionList = 'DescriptionList',
  GetDescription = 'GetDescription',
  TaxOnGross = 'TAX_ON_GROSS',
  TaxOnTaxedPrice = 'TAX_ON_TAXED_PRICE'
}

export type Contact = {
  __typename?: 'Contact';
  contactId: Scalars['String'];
  contactInfo?: Maybe<FinancierContactEntity>;
  date?: Maybe<Scalars['String']>;
  default?: Maybe<Scalars['Boolean']>;
  link: Scalars['String'];
};

export type ContactAddressEntity = {
  __typename?: 'contactAddressEntity';
  accountId: Scalars['String'];
  address: AddressJson;
  contact: ContactEntity;
  contactId: Scalars['String'];
  id: Scalars['String'];
  isPrimary: Scalars['Boolean'];
};

export type ContactEntity = {
  __typename?: 'contactEntity';
  accountId: Scalars['String'];
  address?: Maybe<AddressJson>;
  addressList?: Maybe<Array<ContactAddressEntity>>;
  bookingWaitlists: Array<BookingWaitlistEntity>;
  commonStatus: Scalars['String'];
  companyName?: Maybe<Scalars['String']>;
  companyRegNo?: Maybe<Scalars['String']>;
  contactAddress?: Maybe<Array<AddressJson>>;
  contactExt?: Maybe<ContactExtensionEntity>;
  dob?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  fullName: Scalars['String'];
  gender?: Maybe<Scalars['String']>;
  homeTel?: Maybe<Scalars['String']>;
  icNo?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  incomeRange?: Maybe<IncomeRangeEntity>;
  isPurchaserRegisted?: Maybe<Scalars['Boolean']>;
  jointBuyers: Array<JointBuyerEntity>;
  jointBuyerSignature?: Maybe<Scalars['String']>;
  leads?: Maybe<Array<LeadEntity>>;
  maritalStatus?: Maybe<MaritalStatusEntity>;
  militaryIc?: Maybe<Scalars['String']>;
  nationality?: Maybe<SNationalityEntity>;
  officeTel?: Maybe<Scalars['String']>;
  phoneNo?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  race?: Maybe<RaceEntity>;
  sales: Array<SaleEntity>;
  salutation?: Maybe<SalutationEntity>;
  signatureUrl?: Maybe<Scalars['String']>;
  spouse?: Maybe<ContactEntity>;
  subsaleContactExtension?: Maybe<ContactExtensionEntity>;
  subsaleJointBuyerContactExtension?: Maybe<ContactExtensionEntity>;
};


export type ContactEntityLeadsArgs = {
  project_id?: InputMaybe<Scalars['String']>;
};

export type ContactExt = {
  customerOrigin: Scalars['String'];
  identityType: Scalars['String'];
  isBumi: Scalars['Boolean'];
  isForeignPurchase: Scalars['Boolean'];
  mailingMethod: Scalars['String'];
  remark?: InputMaybe<Scalars['String']>;
  subscribeMaterialEmail: Scalars['Boolean'];
  subscribeMaterialPaNews: Scalars['Boolean'];
  subscribeMaterialSms: Scalars['Boolean'];
  subscribeMaterialWhatsapp: Scalars['Boolean'];
};

export type ContactExtensionEntity = AuditEntity & {
  __typename?: 'contactExtensionEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  contact?: Maybe<ContactEntity>;
  contactId: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  customerOrigin: Scalars['String'];
  id: Scalars['String'];
  identityType: Scalars['String'];
  isBumi: Scalars['Boolean'];
  isForeignPurchase: Scalars['Boolean'];
  isPrincipalBuyer: Scalars['Boolean'];
  isVip: Scalars['Boolean'];
  mailingMethod: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  nameOnTax?: Maybe<Scalars['String']>;
  professionId?: Maybe<Scalars['String']>;
  religionId?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  sstNo?: Maybe<Scalars['String']>;
  subscribeMaterialEmail: Scalars['Boolean'];
  subscribeMaterialPaNews: Scalars['Boolean'];
  subscribeMaterialSms: Scalars['Boolean'];
  subscribeMaterialWhatsapp: Scalars['Boolean'];
  taxRegistrationAddress?: Maybe<Scalars['String']>;
  taxRegistrationNo?: Maybe<Scalars['String']>;
  tin?: Maybe<Scalars['String']>;
};

export type ContactExti = {
  __typename?: 'contactExti';
  contactExtId: Scalars['String'];
  identityType: Scalars['String'];
  IsVip: Scalars['Boolean'];
  mailingMethod: Scalars['String'];
  remark?: Maybe<Scalars['String']>;
  subscribeMaterialEmail: Scalars['Boolean'];
  subscribeMaterialPaNews: Scalars['Boolean'];
  subscribeMaterialSms: Scalars['Boolean'];
  subscribeMaterialWhatsapp: Scalars['Boolean'];
};

export type ContactNupInput = {
  email?: InputMaybe<Scalars['String']>;
  hometel?: InputMaybe<Scalars['String']>;
  icNo?: InputMaybe<Scalars['String']>;
  identitytype?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  officetel?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type ContactNupJson = {
  __typename?: 'contactNupJson';
  email?: Maybe<Scalars['String']>;
  hometel?: Maybe<Scalars['String']>;
  icNo?: Maybe<Scalars['String']>;
  identitytype?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  officetel?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

/** JsonType */
export type ContactPerson = {
  __typename?: 'ContactPerson';
  associateID?: Maybe<Scalars['String']>;
  contactNo?: Maybe<Scalars['String']>;
  designation?: Maybe<Scalars['String']>;
  docRefTable?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  ID?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type ContactPersonInput = {
  associateID?: InputMaybe<Scalars['String']>;
  contactNo?: InputMaybe<Scalars['String']>;
  designation?: InputMaybe<Scalars['String']>;
  docRefTable?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type ContractorDetail = {
  __typename?: 'contractorDetail';
  contractorType: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type ContractorListByType = {
  __typename?: 'contractorListByType';
  ALARM_VENDOR?: Maybe<Array<ContractorDetail>>;
  ELECTRICIAN?: Maybe<Array<ContractorDetail>>;
  PLUMBER?: Maybe<Array<ContractorDetail>>;
  SITE_SUPERVISOR?: Maybe<Array<ContractorDetail>>;
};

export type ContraEntity = {
  __typename?: 'contraEntity';
  accountId: Scalars['String'];
  allocation?: Maybe<Array<AllocationEntity>>;
  allowReversal: Scalars['Boolean'];
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  approveUserData?: Maybe<UserEntity>;
  attachment?: Maybe<Array<AttachmentEntity>>;
  billItem?: Maybe<BillItemEntity>;
  billItemId: Scalars['String'];
  commonStatus: Scalars['String'];
  deposit?: Maybe<DepositEntity>;
  description: Scalars['String'];
  documentAmount: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  documentNo?: Maybe<Scalars['String']>;
  documentRef?: Maybe<Scalars['String']>;
  glGenerated: Scalars['String'];
  glGenerationBatch?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  projectDetail?: Maybe<ProjectEntity>;
  projectId: Scalars['String'];
  ref_table?: Maybe<Scalars['String']>;
  refId?: Maybe<Scalars['String']>;
  requestedBy?: Maybe<Scalars['String']>;
  requestUserData?: Maybe<UserEntity>;
  saleId: Scalars['String'];
  status: Scalars['String'];
  submittedBy?: Maybe<Scalars['String']>;
  submittedDate?: Maybe<Scalars['DateTime']>;
  submitUserData?: Maybe<UserEntity>;
  taxData?: Maybe<TaxSchemeDropdownOutput>;
  unallocatedAmount?: Maybe<Scalars['Float']>;
  unallocatedAmountSummary?: Maybe<Scalars['Float']>;
  voidBy?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
  voidUserData?: Maybe<UserEntity>;
};

export type ContraInput = {
  contraAttachments?: InputMaybe<Array<Scalars['Upload']>>;
  description: Scalars['String'];
  documentAmount: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  documentRef?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  reqDeleteAttId?: InputMaybe<Array<Scalars['String']>>;
  requestedBy: Scalars['String'];
  saleId: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
  taxAmount: Scalars['Float'];
  taxId: Scalars['String'];
  taxRate: Scalars['Float'];
};

export type ContraStatusInput = {
  id?: InputMaybe<Array<Scalars['String']>>;
  status?: InputMaybe<Scalars['String']>;
};

export type ContraSummary = {
  __typename?: 'ContraSummary';
  approveCount?: Maybe<Scalars['Float']>;
  draftCount?: Maybe<Scalars['Float']>;
  submitCount?: Maybe<Scalars['Float']>;
  totalDocAmt?: Maybe<Scalars['Float']>;
  totalUnallocatedAmt?: Maybe<Scalars['Float']>;
};

export type CopyFromNumberingFormatInput = {
  companyId: Scalars['String'];
  companyIdParam: Scalars['String'];
};

export type CoreApprovalLogEntity = AuditEntity & {
  __typename?: 'CoreApprovalLogEntity';
  accountID: Scalars['String'];
  approverID: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  ID: Scalars['String'];
  logDate?: Maybe<Scalars['DateTime']>;
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  notifiedDate?: Maybe<Scalars['DateTime']>;
  remarks?: Maybe<Scalars['String']>;
  toDoID: Scalars['String'];
  toDoStatus: ToDoStatus;
};

export type CoreBaseEntity = AuditEntity & {
  __typename?: 'CoreBaseEntity';
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  ID: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
};

export type CoreDocTypeEntity = AuditEntity & {
  __typename?: 'CoreDocTypeEntity';
  commonStatus: CommonStatus;
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  docName: Scalars['String'];
  ID: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
};

export type CoreEntityRoleUserAssignmentEntity = AuditEntity & {
  __typename?: 'CoreEntityRoleUserAssignmentEntity';
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  entityID: Scalars['String'];
  ID: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  roleID: Scalars['String'];
};

export type CoreNewsEntity = AuditEntity & {
  __typename?: 'CoreNewsEntity';
  accountID: Scalars['String'];
  content?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  endDate?: Maybe<Scalars['DateTime']>;
  ID: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  postStatus: PostStatus;
  startDate?: Maybe<Scalars['DateTime']>;
  title?: Maybe<Scalars['String']>;
};

export type CoreNewsReadEntity = AuditEntity & {
  __typename?: 'CoreNewsReadEntity';
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  ID: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  userID: Scalars['String'];
};

export type CoreNotificationEntity = AuditEntity & {
  __typename?: 'CoreNotificationEntity';
  accountID: Scalars['String'];
  body: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  docRefID: Scalars['String'];
  docRefTable: Scalars['String'];
  ID: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  readStatus: ReadStatus;
  recipientID?: Maybe<Scalars['String']>;
  senderID?: Maybe<Scalars['String']>;
  subject: Scalars['String'];
};

export type CoreNotificationGuidelineEntity = AuditEntity & {
  __typename?: 'CoreNotificationGuidelineEntity';
  accountID: Scalars['String'];
  commonStatus: CommonStatus;
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  docRefTable: Scalars['String'];
  ID: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
};

export type CoreNotiRoleUserAssignmentEntity = AuditEntity & {
  __typename?: 'CoreNotiRoleUserAssignmentEntity';
  accountID: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  ID: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  notiPolicyID: Scalars['String'];
  roleID?: Maybe<Scalars['String']>;
  userID?: Maybe<Scalars['String']>;
};

export type CoreNumberFormatEntity = AuditEntity & {
  __typename?: 'CoreNumberFormatEntity';
  accountID?: Maybe<Scalars['String']>;
  commonStatus: CommonStatus;
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  docTypeID: Scalars['String'];
  ID: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  numberFormat: Scalars['String'];
  numberLength: Scalars['Float'];
  prefix: Scalars['String'];
};

export type CorePermissionEntity = {
  __typename?: 'CorePermissionEntity';
  index: Scalars['String'];
  name: Scalars['String'];
};

export type CorePolicyGuidelineEntity = AuditEntity & {
  __typename?: 'CorePolicyGuidelineEntity';
  accountID: Scalars['String'];
  commonStatus: CommonStatus;
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  docRefTable: Scalars['String'];
  ID: Scalars['String'];
  lowerLimit?: Maybe<Scalars['Float']>;
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  upperLimit?: Maybe<Scalars['Float']>;
};

export type CorePolicyRoleAssignmentEntity = AuditEntity & {
  __typename?: 'CorePolicyRoleAssignmentEntity';
  accountID: Scalars['String'];
  approvalLevel: ApprovalLevel;
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  ID: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  policyID: Scalars['String'];
  roleID: Scalars['String'];
};

export type CoreRoleEntity = AuditEntity & {
  __typename?: 'CoreRoleEntity';
  accountID: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  ID: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  name: Scalars['String'];
};

export type CoreRolePermissionAssignmentEntity = AuditEntity & {
  __typename?: 'CoreRolePermissionAssignmentEntity';
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  ID: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  permissionID: Scalars['Float'];
  roleID: Scalars['String'];
};

export type CoreRunningNumberSetupEntity = AuditEntity & {
  __typename?: 'CoreRunningNumberSetupEntity';
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  ID: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  nextNumber: Scalars['Float'];
  numberFormatID: Scalars['String'];
};

export type CoreToDoEntity = AuditEntity & {
  __typename?: 'CoreToDoEntity';
  accountID: Scalars['String'];
  approvalLevel?: Maybe<ApprovalLevel>;
  body: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  docRefID: Scalars['String'];
  docRefTable: Scalars['String'];
  ID: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  notifiedDate?: Maybe<Scalars['DateTime']>;
  subject: Scalars['String'];
  submitterID: Scalars['String'];
  toDoStatus: ToDoStatus;
};

export type CountryCodeEntity = {
  __typename?: 'countryCodeEntity';
  accountId: Scalars['String'];
  code: Scalars['String'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  name: Scalars['String'];
};

export type CountryCodeOutput = {
  __typename?: 'countryCodeOutput';
  code: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type CountryMasterDataOutput = {
  __typename?: 'CountryMasterDataOutput';
  code: Scalars['String'];
  commonStatus: Scalars['String'];
  ID: Scalars['String'];
  name: Scalars['String'];
};

export type CountStatusBookingOutput = {
  __typename?: 'countStatusBookingOutput';
  collectedBookingFee?: Maybe<Scalars['Float']>;
  convertedStatus?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type CountWaitingUnitOutput = {
  __typename?: 'CountWaitingUnitOutput';
  activeUnits?: Maybe<Scalars['Float']>;
  leaveQueue?: Maybe<Scalars['Float']>;
  waitList?: Maybe<Scalars['Float']>;
};

export type CreateAuditInput = {
  createdBy?: InputMaybe<Scalars['String']>;
};

export type CreateStampDutyIntegrationInput = {
  extension: Scalars['String'];
  projectLetterTemplateId: Scalars['String'];
  stampDutyId: Scalars['String'];
  type: Scalars['String'];
};

export type CreateTransactionCodeDetailInput = {
  code: Scalars['String'];
  description: Scalars['String'];
  taxTransactionCodeId: Scalars['String'];
  type: Scalars['String'];
};

export enum CreditCardType {
  Amex = 'AMEX',
  DescriptionList = 'DescriptionList',
  Diners = 'DINERS',
  GetDescription = 'GetDescription',
  Master = 'MASTER',
  Visa = 'VISA'
}

export enum CreditControlStatus {
  Approved = 'APPROVED',
  Draft = 'DRAFT',
  Submitted = 'SUBMITTED'
}

export type CreditNoteEntity = {
  __typename?: 'creditNoteEntity';
  accountId: Scalars['String'];
  adjustDocumentReference?: Maybe<Scalars['String']>;
  allocation?: Maybe<Array<AllocationEntity>>;
  allocationData?: Maybe<Array<AllocationData>>;
  allowReversal: Scalars['Boolean'];
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  approveUserData?: Maybe<UserEntity>;
  attachment?: Maybe<Array<AttachmentEntity>>;
  billItem?: Maybe<BillItemEntity>;
  billItemId?: Maybe<Scalars['String']>;
  billItemInt?: Maybe<BillItemIntEntity>;
  clusterName?: Maybe<ProjectClusterEntity>;
  commonStatus: Scalars['String'];
  contactDetail?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  documentAmount: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  documentNo?: Maybe<Scalars['String']>;
  documentRef?: Maybe<Scalars['String']>;
  glGenerated: Scalars['String'];
  glGenerationBatch?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isReversal: Scalars['Boolean'];
  projectDetail?: Maybe<ProjectEntity>;
  projectId: Scalars['String'];
  requestedBy?: Maybe<Scalars['String']>;
  requestUserData?: Maybe<UserEntity>;
  saleId: Scalars['String'];
  salesRegNo?: Maybe<SaleExtensionEntity>;
  status: Scalars['String'];
  submittedBy?: Maybe<Scalars['String']>;
  submittedDate?: Maybe<Scalars['DateTime']>;
  submitUserData?: Maybe<UserEntity>;
  taxData?: Maybe<TaxSchemeDropdownOutput>;
  taxLedger?: Maybe<TaxLedgerEntity>;
  unallocatedAmount?: Maybe<Scalars['Float']>;
  unallocatedAmountSummary?: Maybe<Scalars['Float']>;
  unitDetail?: Maybe<Scalars['String']>;
  voidBy?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
  voidUserData?: Maybe<UserEntity>;
};

export type CurrencyEntity = AuditEntity & {
  __typename?: 'CurrencyEntity';
  code: Scalars['String'];
  commonStatus: CommonStatus;
  company: Array<CompanyEntity>;
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  format: NumericFormatter;
  ID: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  name: Scalars['String'];
  symbol: Scalars['String'];
};

export type CurrencyExchangeEntity = AuditEntity & {
  __typename?: 'CurrencyExchangeEntity';
  accountID: Scalars['String'];
  commonStatus: CommonStatus;
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  currencyLog?: Maybe<Array<Scalars['JSON']>>;
  effectiveDate: Scalars['String'];
  exchangeRate: Scalars['Float'];
  fromAmt: Scalars['Float'];
  fromCurrencyID: Scalars['String'];
  ID: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  toAmt: Scalars['Float'];
  toCurrencyID: Scalars['String'];
};

export type CurrencyExchangeOutput = {
  __typename?: 'currencyExchangeOutput';
  commonStatus: Scalars['String'];
  exchangeRate: Scalars['Float'];
  fromAmt: Scalars['Float'];
  fromCurrencyCode: Scalars['String'];
  id: Scalars['String'];
  isExistInMasterData: Array<Scalars['String']>;
  isExistInTransactionData: Array<Scalars['String']>;
  toAmt: Scalars['Float'];
  toCurrencyCode: Scalars['String'];
};

export type CurrencyExchangeRateEditInput = {
  fromAmt: Scalars['Float'];
  id: Scalars['String'];
  toAmt: Scalars['Float'];
};

export type CurrencyExchangeRateEntity = {
  __typename?: 'currencyExchangeRateEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  currencyLog?: Maybe<Array<CurrencyLogObject>>;
  exchangeRate: Scalars['Float'];
  fromAmt: Scalars['Float'];
  fromCurrencyCode: Scalars['String'];
  id: Scalars['String'];
  toAmt: Scalars['Float'];
  toCurrencyCode: Scalars['String'];
};

export type CurrencyExchangeRateInput = {
  fromAmt: Scalars['Float'];
  fromCurrencyCode: Scalars['String'];
  toAmt: Scalars['Float'];
  toCurrencyCode: Scalars['String'];
};

export type CurrencyLogInput = {
  exchange_rate: Scalars['Float'];
  from_amt: Scalars['Float'];
  modifiedBy: Scalars['String'];
  modifiedDate: Scalars['DateTime'];
  modifiedName: Scalars['String'];
  to_amt: Scalars['Float'];
};

/** JsonType */
export type CurrencyLogObject = {
  __typename?: 'currencyLogObject';
  exchange_rate: Scalars['Float'];
  from_amt: Scalars['Float'];
  modifiedBy: Scalars['String'];
  modifiedDate: Scalars['DateTime'];
  modifiedName: Scalars['String'];
  to_amt: Scalars['Float'];
};

export type CustomerCareLocalInfo = {
  customerCareLocalAuthorityAddress?: InputMaybe<AddressJsonInput>;
  customerCareLocalAuthorityContactNo?: InputMaybe<Scalars['String']>;
  customerCareLocalAuthorityName?: InputMaybe<Scalars['String']>;
};

export type DailyBookChartCountOutput = {
  __typename?: 'dailyBookChartCountOutput';
  bookedCount: Scalars['Float'];
  cancelBookCount: Scalars['Float'];
  cumulativeCount: Scalars['Float'];
  daily_date: Scalars['DateTime'];
};

export type DailyChartCount = {
  __typename?: 'dailyChartCount';
  cumulativeCount: Scalars['Float'];
  dailyCount: Scalars['Float'];
  dailyDate: Scalars['DateTime'];
};

export type DailySignChartCountOutput = {
  __typename?: 'dailySignChartCountOutput';
  cancelSignCount: Scalars['Float'];
  cumulativeCount: Scalars['Float'];
  daily_date: Scalars['DateTime'];
  signedCount: Scalars['Float'];
};

export type Data = {
  __typename?: 'data';
  account_id: Scalars['String'];
  acId?: Maybe<Scalars['String']>;
  add_on_ref_id?: Maybe<Scalars['String']>;
  add_on_ref_table?: Maybe<Scalars['String']>;
  addOnData?: Maybe<Scalars['String']>;
  allow_reversal: Scalars['Boolean'];
  bill_item_id: Scalars['String'];
  canReversal: Scalars['Boolean'];
  charge_percent: Scalars['String'];
  common_status: Scalars['String'];
  createdBy: Scalars['String'];
  createdTs: Scalars['String'];
  credit_term: Scalars['Float'];
  creditDocumentNo?: Maybe<Array<Scalars['String']>>;
  description: Scalars['String'];
  document_amount?: Maybe<Scalars['Float']>;
  document_date?: Maybe<Scalars['DateTime']>;
  document_no?: Maybe<Scalars['String']>;
  document_ref?: Maybe<Scalars['String']>;
  due_date?: Maybe<Scalars['DateTime']>;
  fbData?: Maybe<FbData>;
  generation_batch?: Maybe<Scalars['String']>;
  generation_batch_credit_term?: Maybe<Scalars['String']>;
  gl_generated: Scalars['String'];
  gl_generation_batch?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  installment_seq_no?: Maybe<Scalars['Float']>;
  installmentData?: Maybe<Array<PBdata>>;
  interest_rate: Scalars['String'];
  is_downpayment: Scalars['Boolean'];
  is_include_holiday: Scalars['Boolean'];
  is_installment: Scalars['Boolean'];
  is_stakeholder: Scalars['Boolean'];
  is_vp_stage: Scalars['Boolean'];
  isAC: Scalars['Boolean'];
  isBuyer: Scalars['Boolean'];
  isReversal: Scalars['Boolean'];
  isVoid: Scalars['Boolean'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['String'];
  outstandingAmt: Scalars['Float'];
  payment_plan_detail_id: Scalars['String'];
  pbAmount: Scalars['String'];
  principal_amt: Scalars['String'];
  project_id: Scalars['String'];
  sale_id: Scalars['String'];
  stage_seq_no: Scalars['Float'];
  sumOrengeAmount: Scalars['Float'];
  sumRedAmount: Scalars['Float'];
  title?: Maybe<Scalars['String']>;
  totalAllocateAmount: Scalars['Float'];
  totalFBamount: Scalars['Float'];
  void_by?: Maybe<Scalars['String']>;
  void_date?: Maybe<Scalars['DateTime']>;
};

export type DataSource = {
  __typename?: 'DataSource';
  Columns?: Maybe<Array<Scalars['String']>>;
  DataMember: Scalars['String'];
  DataSource: Scalars['String'];
  DynamicFilterColumn?: Maybe<Scalars['String']>;
  IsMainQuery?: Maybe<Scalars['Boolean']>;
  IsStoreProcedure?: Maybe<Scalars['Boolean']>;
};

export type DataSourceInput = {
  Columns?: InputMaybe<Array<Scalars['String']>>;
  DataMember: Scalars['String'];
  DataSource: Scalars['String'];
  DynamicFilterColumn?: InputMaybe<Scalars['String']>;
  IsMainQuery?: InputMaybe<Scalars['Boolean']>;
  IsStoreProcedure?: InputMaybe<Scalars['Boolean']>;
};

export type DebitNoteEntity = {
  __typename?: 'debitNoteEntity';
  accountId: Scalars['String'];
  adjustDocumentReference?: Maybe<Scalars['String']>;
  allocation?: Maybe<Array<AllocationEntity>>;
  allowReversal: Scalars['Boolean'];
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  approveUserData?: Maybe<UserEntity>;
  attachment?: Maybe<Array<AttachmentEntity>>;
  billItem?: Maybe<BillItemEntity>;
  billItemId?: Maybe<Scalars['String']>;
  billItemInt?: Maybe<BillItemIntEntity>;
  clusterName?: Maybe<ProjectClusterEntity>;
  commonStatus: Scalars['String'];
  contactDetail?: Maybe<Scalars['String']>;
  creditTerm: Scalars['Float'];
  description?: Maybe<Scalars['String']>;
  documentAmount: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  documentNo?: Maybe<Scalars['String']>;
  documentRef?: Maybe<Scalars['String']>;
  dueDate: Scalars['DateTime'];
  glGenerated: Scalars['String'];
  glGenerationBatch?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  interestRate: Scalars['Float'];
  isIncludeHoliday: Scalars['Boolean'];
  isReversal: Scalars['Boolean'];
  projectDetail?: Maybe<ProjectEntity>;
  projectId: Scalars['String'];
  requestedBy?: Maybe<Scalars['String']>;
  requestUserData?: Maybe<UserEntity>;
  saleId: Scalars['String'];
  sales?: Maybe<SaleEntity>;
  salesRegNo?: Maybe<SaleExtensionEntity>;
  status: Scalars['String'];
  submittedBy?: Maybe<Scalars['String']>;
  submittedDate?: Maybe<Scalars['DateTime']>;
  submitUserData?: Maybe<UserEntity>;
  taxData?: Maybe<TaxSchemeDropdownOutput>;
  taxLedger?: Maybe<TaxLedgerEntity>;
  unallocatedAmount?: Maybe<Scalars['Float']>;
  unallocatedAmountSummary?: Maybe<Scalars['Float']>;
  unitDetail?: Maybe<Scalars['String']>;
  voidBy?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
  voidUserData?: Maybe<UserEntity>;
};

export type DebitRecordDetails = {
  __typename?: 'DebitRecordDetails';
  description: Scalars['String'];
  document_amount: Scalars['Float'];
  document_date: Scalars['DateTime'];
  document_no: Scalars['String'];
  id: Scalars['String'];
  outstanding: Scalars['Float'];
  sale_id: Scalars['String'];
  total_allocated: Scalars['Float'];
};

export enum DeductBookingFee {
  DescriptionList = 'DescriptionList',
  FirstInstallment = 'FIRST_INSTALLMENT',
  GetDescription = 'GetDescription',
  None = 'NONE',
  Prorated = 'PRORATED'
}

export type DeemCollectedData = {
  __typename?: 'DeemCollectedData';
  bankName?: Maybe<Scalars['String']>;
  buyerName?: Maybe<Scalars['String']>;
  collectionBatchId?: Maybe<Scalars['String']>;
  financialBillingId?: Maybe<Scalars['String']>;
  financierCode?: Maybe<Scalars['String']>;
  financierName?: Maybe<Scalars['String']>;
  pbDescription?: Maybe<Scalars['String']>;
  pbDocumentNo?: Maybe<Scalars['String']>;
  pbId: Scalars['String'];
  saleId: Scalars['String'];
  spAmount: Scalars['Float'];
  spDueDate?: Maybe<Scalars['String']>;
  spId: Scalars['String'];
  unitNo: Scalars['String'];
};

export type DeemCollectedInput = {
  attachments?: InputMaybe<Array<Scalars['Upload']>>;
  durationFlag: DurationFlagType;
  paymentDate?: InputMaybe<Scalars['DateTime']>;
  referenceNo?: InputMaybe<Scalars['String']>;
  solicitor: Scalars['String'];
  spId: Array<Scalars['String']>;
};

export type DeemCollectedUnitDetail = {
  deemCollectedUnitDetail: Array<StakeholderDetails>;
  saleId: Scalars['String'];
  totalDeemCollected: Scalars['Float'];
  unitNo: Scalars['String'];
};

export type DeleteAssignNotaryInput = {
  ids: Array<Scalars['String']>;
};

export type DeleteDataInput = {
  stampDutyDetailIds: Array<Scalars['String']>;
  stampDutyExtIds: Array<Scalars['String']>;
};

export type DeleteFinancialBillingInput = {
  id: Scalars['String'];
};

export type DeleteFinancierUnitOutput = {
  __typename?: 'deleteFinancierUnitOutput';
  count: Scalars['Float'];
  isEmpty: Scalars['Boolean'];
};

export type DeletePaymentinterestExceptionInput = {
  saleId: Scalars['String'];
};

export type DeleteSaleLoanInput = {
  loanAmount: Scalars['Float'];
  loanLimit: Scalars['Float'];
  saleId: Scalars['String'];
  saleLoanId: Scalars['String'];
};

export type DeleteUnitInput = {
  unitId: Array<Scalars['String']>;
};

export type DepositEntity = {
  __typename?: 'depositEntity';
  accountId: Scalars['String'];
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  approveUserData?: Maybe<UserEntity>;
  attachment?: Maybe<Array<AttachmentEntity>>;
  bankAccount?: Maybe<CompanyBankAccountEntity>;
  bankAccountId: Scalars['String'];
  billItemInt?: Maybe<BillItemIntEntity>;
  chequeDate?: Maybe<Scalars['DateTime']>;
  chequeExpireDate?: Maybe<Scalars['DateTime']>;
  chequeNo?: Maybe<Scalars['String']>;
  clusterName?: Maybe<ProjectClusterEntity>;
  commonStatus: Scalars['String'];
  contactDetail?: Maybe<Scalars['String']>;
  convertedToPayment: Scalars['Boolean'];
  creditCardType?: Maybe<Scalars['String']>;
  depositTypeId: Scalars['String'];
  description: Scalars['String'];
  documentAmount: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  documentNo?: Maybe<Scalars['String']>;
  documentRef?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  outstanding?: Maybe<Scalars['Float']>;
  paymentMethod: Scalars['String'];
  projectDetail?: Maybe<UserEntity>;
  projectId: Scalars['String'];
  ref_table: Scalars['String'];
  refId: Scalars['String'];
  saleId: Scalars['String'];
  salesRegNo?: Maybe<SaleExtensionEntity>;
  status: Scalars['String'];
  submittedBy?: Maybe<Scalars['String']>;
  submittedDate?: Maybe<Scalars['DateTime']>;
  submitUserData?: Maybe<UserEntity>;
  taxData?: Maybe<TaxSchemeDropdownOutput>;
  taxLedger?: Maybe<TaxLedgerEntity>;
  unitDetail?: Maybe<Scalars['String']>;
  voidBy?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
  voidUserData?: Maybe<UserEntity>;
};

export type DepositOutput = {
  __typename?: 'DepositOutput';
  bankName: Scalars['String'];
  depositAmount: Scalars['Float'];
  depositDate: Scalars['DateTime'];
  depositType: Scalars['String'];
  description: Scalars['String'];
  documentNo: Scalars['String'];
  id: Scalars['String'];
  paymentMethod: Scalars['String'];
};

export type DepositSummary = {
  __typename?: 'DepositSummary';
  approveCount?: Maybe<Scalars['Float']>;
  draftCount?: Maybe<Scalars['Float']>;
  submitCount?: Maybe<Scalars['Float']>;
  totalDocAmt?: Maybe<Scalars['Float']>;
  totalUnallocatedAmt?: Maybe<Scalars['Float']>;
};

export type DesignLetterTemplateInput = {
  id: Scalars['String'];
  templateBody: Scalars['String'];
};

export type DetailInput = {
  detailItems: Array<DetailItemInput>;
  effectiveDate: Scalars['DateTime'];
  id: Scalars['String'];
};

export type DetailInputForUpdate = {
  detailItems: Array<DetailItemInputWithId>;
  effectiveDate: Scalars['DateTime'];
  id: Scalars['String'];
};

export type DetailItemInput = {
  fromAmt: Scalars['String'];
  toAmt: Scalars['String'];
  value: Scalars['String'];
};

export type DetailItemInputWithId = {
  fromAmt: Scalars['String'];
  id: Scalars['String'];
  toAmt: Scalars['String'];
  value: Scalars['String'];
};

export type Details = {
  __typename?: 'details';
  addOnPurchase?: Maybe<Scalars['String']>;
  addOnPurchaseName?: Maybe<Scalars['String']>;
  calculatedDocumentAmt: Scalars['Float'];
  creditDocumentNo?: Maybe<Scalars['String']>;
  documentDate?: Maybe<Scalars['String']>;
  documentNo?: Maybe<Scalars['String']>;
  installmentSeqNo?: Maybe<Scalars['Float']>;
  isStakeholder: Scalars['Boolean'];
  isVp: Scalars['Boolean'];
  outstandingAmt: Scalars['Float'];
  paymentParty: Scalars['String'];
  paymentPartyCode?: Maybe<Scalars['String']>;
  paymentPlanDetailTitle?: Maybe<Scalars['String']>;
  progressBillingId?: Maybe<Scalars['String']>;
  stageSeqNo: Scalars['Float'];
  totalTaxAmt?: Maybe<Scalars['Float']>;
};

export type DevBuyerSolicitorOutput = {
  __typename?: 'DevBuyerSolicitorOutput';
  BuyerLawyerAddress?: Maybe<Scalars['String']>;
  BuyerLawyerEmail?: Maybe<Scalars['String']>;
  BuyerLawyerName?: Maybe<Scalars['String']>;
  BuyerLawyerPhone?: Maybe<Scalars['String']>;
  BuyerLawyerReferenceNo?: Maybe<Scalars['String']>;
  DevLawyerAddress?: Maybe<Scalars['String']>;
  DevLawyerEmail?: Maybe<Scalars['String']>;
  DevLawyerName?: Maybe<Scalars['String']>;
  DevLawyerPhone?: Maybe<Scalars['String']>;
  DevLawyerReferenceNo?: Maybe<Scalars['String']>;
};

export type DirectionEntity = {
  __typename?: 'directionEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  defaulted: Scalars['Boolean'];
  id: Scalars['String'];
  isDeletable: Scalars['Boolean'];
  isExistInMasterData: Array<Scalars['String']>;
  isExistInTransactionData: Array<Scalars['String']>;
  name: Scalars['String'];
  seq_no?: Maybe<Scalars['Float']>;
  units: Array<UnitEntity>;
};

export type DirectionInput = {
  name: Scalars['String'];
};

export type DiscardPendingDataInput = {
  changes?: InputMaybe<Array<FormChangesInput>>;
  saleId: Scalars['String'];
};

export type DiscountDetail = {
  __typename?: 'discountDetail';
  amount?: Maybe<Scalars['Float']>;
  discountId?: Maybe<Scalars['String']>;
  discountMethod?: Maybe<Scalars['String']>;
  formula?: Maybe<Scalars['String']>;
  seqNo?: Maybe<Scalars['Float']>;
  title?: Maybe<Scalars['String']>;
};

export type DiscountEntity = {
  __typename?: 'discountEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  discountIntegration?: Maybe<Array<IntegrationDiscountEntity>>;
  discountType?: Maybe<DiscountTypeEntity>;
  discountTypeId?: Maybe<Scalars['String']>;
  discountVal?: Maybe<Scalars['Float']>;
  formula?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isDiscountRebate: Scalars['Boolean'];
  isExistInMasterData: Array<Scalars['String']>;
  isExistInTransactionData: Array<Scalars['String']>;
  isIntegrated: Scalars['Boolean'];
  prefix?: Maybe<Scalars['String']>;
  projectDiscounts: Array<ProjectDiscountEntity>;
  saleRebatePackage?: Maybe<Array<SaleRebatePackageEntity>>;
  salesDiscount: Array<SaleDiscountEntity>;
  saleSubProduct?: Maybe<SaleSubproductEntity>;
  title: Scalars['String'];
};

export type DiscountInfo = {
  __typename?: 'discountInfo';
  amount: Scalars['Float'];
  id: Scalars['String'];
  method: Scalars['String'];
  name: Scalars['String'];
};

export type DiscountInput = {
  description?: InputMaybe<Scalars['String']>;
  discountTypeId: Scalars['String'];
  discountVal: Scalars['Float'];
  formula: Scalars['String'];
  prefix: Scalars['String'];
  title: Scalars['String'];
};

/** JsonType */
export type DiscountListingObject = {
  __typename?: 'discountListingObject';
  amount: Scalars['Float'];
  discountId: Scalars['String'];
  discountMethod: Scalars['String'];
  formula: Scalars['String'];
  seqNo: Scalars['Float'];
  title: Scalars['String'];
};

export type DiscountListingUnitTransferInput = {
  amount: Scalars['Float'];
  discountId: Scalars['String'];
  discountMethod: Scalars['String'];
  formula: Scalars['String'];
  seqNo: Scalars['Float'];
  title: Scalars['String'];
};

export type DiscountListOutput = {
  __typename?: 'discountListOutput';
  disabled: Scalars['Boolean'];
  discountId: Scalars['String'];
  discountPrefix: Scalars['String'];
  discountTitle: Scalars['String'];
  discountVal: Scalars['Float'];
};

/** JsonType */
export type DiscountObject = {
  __typename?: 'discountObject';
  discardBumi: Scalars['Boolean'];
  discounts?: Maybe<Array<DiscountListingObject>>;
};

export type DiscountParamaterValueOutput = {
  __typename?: 'DiscountParamaterValueOutput';
  amount: Scalars['Float'];
  description?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  type: Scalars['String'];
};

export type DiscountRegistrationListOutput = {
  __typename?: 'discountRegistrationListOutput';
  disabled: Scalars['Boolean'];
  discountId: Scalars['String'];
  discountPrefix: Scalars['String'];
  discountTitle: Scalars['String'];
  discountVal: Scalars['Float'];
};

export type DiscountSummaryInfo = {
  __typename?: 'discountSummaryInfo';
  count: Scalars['Float'];
  info: Scalars['String'];
  isBumiDiscard: Scalars['Boolean'];
  totalPrice: Scalars['Float'];
};

export type DiscountTypeEntity = AuditEntity & {
  __typename?: 'discountTypeEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  discount?: Maybe<DiscountEntity>;
  id: Scalars['String'];
  isExistInMasterData: Array<Scalars['String']>;
  isExistInTransactionData: Array<Scalars['String']>;
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  name: Scalars['String'];
  systemUse: Scalars['Boolean'];
};

export type DiscountTypeInput = {
  name: Scalars['String'];
};

export type DiscountUnitTransferInput = {
  discardBumi: Scalars['Boolean'];
  discounts?: InputMaybe<Array<DiscountListingUnitTransferInput>>;
};

export type DistinctBlockByProjectOutput = {
  __typename?: 'DistinctBlockByProjectOutput';
  block: Scalars['String'];
};

export type DistinctFloorByProjectOutput = {
  __typename?: 'DistinctFloorByProjectOutput';
  block: Scalars['String'];
  blockFloor: Scalars['String'];
  floor: Scalars['Float'];
  floorLabel: Scalars['String'];
};

export type DistinctUnitByProjectOutput = {
  __typename?: 'DistinctUnitByProjectOutput';
  desc: Scalars['String'];
  unit_layout_id: Scalars['String'];
};

export type DistrictMasterDataOutput = {
  __typename?: 'DistrictMasterDataOutput';
  commonStatus: Scalars['String'];
  ID: Scalars['String'];
  name: Scalars['String'];
  stateID: Scalars['String'];
};

export type DnSummary = {
  __typename?: 'DNSummary';
  approveCount?: Maybe<Scalars['Float']>;
  draftCount?: Maybe<Scalars['Float']>;
  submitCount?: Maybe<Scalars['Float']>;
  totalDocAmt?: Maybe<Scalars['Float']>;
  totalUnallocatedAmt?: Maybe<Scalars['Float']>;
};

export type DocumentNumberDetailEntity = {
  __typename?: 'documentNumberDetailEntity';
  accountId: Scalars['String'];
  approvedBy: Scalars['String'];
  approvedTs?: Maybe<Scalars['DateTime']>;
  commonStatus: Scalars['String'];
  documentNumberHeader: DocumentNumberHeaderEntity;
  documentNumberHeaderId: Scalars['String'];
  formatType: Scalars['String'];
  formatValue: Scalars['String'];
  id: Scalars['String'];
  nextNumber?: Maybe<Scalars['Float']>;
  resetBy?: Maybe<Scalars['String']>;
  sequence: Scalars['Float'];
  startFrom?: Maybe<Scalars['Float']>;
  submittedBy: Scalars['String'];
  submittedTs?: Maybe<Scalars['DateTime']>;
};

export enum DocumentNumberDetailTypeEnum {
  CompanyCode = 'COMPANY_CODE',
  Constant = 'CONSTANT',
  DescriptionList = 'DescriptionList',
  GetDescription = 'GetDescription',
  SerialNo = 'SERIAL_NO',
  TrxMonth = 'TRX_MONTH',
  TrxYear = 'TRX_YEAR'
}

export type DocumentNumberHeaderEntity = {
  __typename?: 'documentNumberHeaderEntity';
  accountId: Scalars['String'];
  approvedBy: Scalars['String'];
  approvedTs?: Maybe<Scalars['DateTime']>;
  commonStatus: Scalars['String'];
  companyId: Scalars['String'];
  docNumGenerated?: Maybe<Scalars['Boolean']>;
  documentNumberDetails?: Maybe<Array<DocumentNumberDetailEntity>>;
  documentNumberResetBy?: Maybe<Array<DocumentNumberResetByEntity>>;
  id: Scalars['String'];
  isAutoDocNo?: Maybe<Scalars['Boolean']>;
  refRecordId: Scalars['String'];
  refTable: Scalars['String'];
  sampleOutput: Scalars['String'];
  submittedBy: Scalars['String'];
  submittedTs?: Maybe<Scalars['DateTime']>;
  type: DocumentNumberHeaderTypeIndoEnum;
};

export enum DocumentNumberHeaderTypeIndoEnum {
  Allocation = 'ALLOCATION',
  AreaVariance = 'AREA_VARIANCE',
  BookingNo = 'BOOKING_NO',
  BookingReceipt = 'BOOKING_RECEIPT',
  BuyBack = 'BUY_BACK',
  Contra = 'CONTRA',
  CreditNote = 'CREDIT_NOTE',
  DebitNote = 'DEBIT_NOTE',
  DepositReceipt = 'DEPOSIT_RECEIPT',
  DescriptionList = 'DescriptionList',
  GetDescription = 'GetDescription',
  Interest = 'INTEREST',
  Lad = 'LAD',
  LoanApproval = 'LOAN_APPROVAL',
  LoanPayment = 'LOAN_PAYMENT',
  LoanReleaseNotification = 'LOAN_RELEASE_NOTIFICATION',
  Misc = 'MISC',
  OfficialReceipt = 'OFFICIAL_RECEIPT',
  PaymentReminders = 'PAYMENT_REMINDERS',
  PurchaserNameTransfer = 'PURCHASER_NAME_TRANSFER',
  Refinancing = 'REFINANCING',
  Refund = 'REFUND',
  RescheduleInstallment = 'RESCHEDULE_INSTALLMENT',
  SalesRebate = 'SALES_REBATE',
  SalesRegistration = 'SALES_REGISTRATION',
  TemporaryReceipt = 'TEMPORARY_RECEIPT',
  Unallocation = 'UNALLOCATION',
  UnitTransfer = 'UNIT_TRANSFER'
}

export type DocumentNumberResetByEntity = {
  __typename?: 'documentNumberResetByEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  companyId: Scalars['String'];
  documentNumberHeader: DocumentNumberHeaderEntity;
  documentNumberHeaderId: Scalars['String'];
  id: Scalars['String'];
  month?: Maybe<Scalars['Float']>;
  nextNumber?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

export type DownpaymentRawOutput = {
  __typename?: 'downpaymentRawOutput';
  balanceAmt: Scalars['Float'];
  buyerName: Scalars['String'];
  companyName?: Maybe<Scalars['String']>;
  docAmt: Scalars['Float'];
  isCompany?: Maybe<Scalars['Boolean']>;
  progressBillingId: Scalars['String'];
  reminderSeq: Scalars['Float'];
  saleId: Scalars['String'];
  unitNo: Scalars['String'];
};

export type DownpaymentReminderDetailOutput = {
  __typename?: 'downpaymentReminderDetailOutput';
  reminder1: Scalars['Float'];
  reminder2: Scalars['Float'];
  reminder3: Scalars['Float'];
  reminderList: Array<ProgressBillingReminderOutput>;
  totalBalance: Scalars['Float'];
};

export type DownpaymentReminderEntity = AuditEntity & {
  __typename?: 'downpaymentReminderEntity';
  accountId: Scalars['String'];
  balanceAmount: Scalars['Float'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  generationBatch?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  progressBillingId: Scalars['String'];
  projectId: Scalars['String'];
  reminderDate: Scalars['DateTime'];
  reminderSeq: Scalars['Float'];
  saleId: Scalars['String'];
  share?: Maybe<Array<ShareObject>>;
};

export type DownpaymentReminderInput = {
  progressBillingId: Scalars['String'];
  projectId: Scalars['String'];
  reminderDate: Scalars['DateTime'];
  reminderSeq: Scalars['Float'];
  saleId: Scalars['String'];
  share?: InputMaybe<Array<ShareInput>>;
};

export type DownpaymentReminderListingOutput = {
  __typename?: 'downpaymentReminderListingOutput';
  amount: Scalars['Float'];
  generationBatch: Scalars['String'];
  reminder1: Scalars['Float'];
  reminder2: Scalars['Float'];
  reminder3: Scalars['Float'];
  reminderDate: Scalars['DateTime'];
  unitNo: Array<Scalars['String']>;
};

export type DownpaymentShareOutput = {
  __typename?: 'downpaymentShareOutput';
  attachment?: Maybe<Array<PdfOutput>>;
  downloadFile: Scalars['Boolean'];
  isProject?: Maybe<Scalars['Boolean']>;
  letterTemplateList?: Maybe<Array<ShareLetterTemplateOutput>>;
};

export type DropDownDataOutput = {
  __typename?: 'dropDownDataOutput';
  id: Scalars['String'];
  name: Scalars['String'];
  solicitorCode?: Maybe<Scalars['String']>;
};

export type DropDownDataSource = {
  __typename?: 'DropDownDataSource';
  DataMember: Scalars['String'];
  DataSource: Scalars['String'];
  parameters: Array<DropDownParamterInterface>;
};

export type DropDownDataSourceInput = {
  DataMember: Scalars['String'];
  DataSource: Scalars['String'];
  parameters: Array<DropDownDataSourceParameterInput>;
};

export type DropDownDataSourceParameterInput = {
  Name: Scalars['String'];
  ParameterName: Scalars['String'];
};

export type DropDownMember = {
  __typename?: 'DropDownMember';
  DynamicSource?: Maybe<DynamicSource>;
  StaticData?: Maybe<Array<StaticData>>;
  ValueSource: Scalars['String'];
};

export type DropDownMemberInput = {
  DynamicSource?: InputMaybe<DynamicSourceInput>;
  StaticData?: InputMaybe<Array<StaticDataInput>>;
  ValueSource: Scalars['String'];
};

export type DropDownParamterInterface = {
  __typename?: 'DropDownParamterInterface';
  Name: Scalars['String'];
  ParameterName: Scalars['String'];
};

export type DueDateRange = {
  __typename?: 'dueDateRange';
  range1?: Maybe<DueDateRangeDetail>;
  range2?: Maybe<DueDateRangeDetail>;
  range3?: Maybe<DueDateRangeDetail>;
  range4?: Maybe<DueDateRangeDetail>;
  range5?: Maybe<DueDateRangeDetail>;
  range6?: Maybe<DueDateRangeDetail>;
  range7?: Maybe<DueDateRangeDetail>;
  unallocated?: Maybe<DueDateRangeDetail>;
};

export type DueDateRangeDetail = {
  __typename?: 'dueDateRangeDetail';
  dueDateRangeHeader?: Maybe<DueDateRangeHeader>;
  dueDateRangeListing?: Maybe<DueDateRangeListing>;
  totalDueDateRange?: Maybe<Scalars['Float']>;
};

export type DueDateRangeHeader = {
  __typename?: 'dueDateRangeHeader';
  addPackageInstallmentDetail?: Maybe<DueDateRangeHeaderDetail>;
  carparkInstallmentDetail?: Maybe<DueDateRangeHeaderDetail>;
  contraDetail?: Maybe<DueDateRangeHeaderDetail>;
  creditNoteDetail?: Maybe<DueDateRangeHeaderDetail>;
  debitNoteDetail?: Maybe<DueDateRangeHeaderDetail>;
  lateInterestDetail?: Maybe<DueDateRangeHeaderDetail>;
  miscBillingDetail?: Maybe<DueDateRangeHeaderDetail>;
  paymentDetail?: Maybe<DueDateRangeHeaderDetail>;
  purchaserInstallmentDetail?: Maybe<DueDateRangeHeaderDetail>;
  rebateDetail?: Maybe<DueDateRangeHeaderDetail>;
};

export type DueDateRangeHeaderDetail = {
  __typename?: 'dueDateRangeHeaderDetail';
  title?: Maybe<Scalars['String']>;
  totalDocumentAmount?: Maybe<Scalars['Float']>;
  totalOutstanding?: Maybe<Scalars['Float']>;
};

export type DueDateRangeListing = {
  __typename?: 'dueDateRangeListing';
  addPackageInstallmentDetail?: Maybe<Array<DueDateRangeListingDetail>>;
  carparkInstallmentDetail?: Maybe<Array<DueDateRangeListingDetail>>;
  contraDetail?: Maybe<Array<DueDateRangeListingDetail>>;
  creditNoteDetail?: Maybe<Array<DueDateRangeListingDetail>>;
  debitNoteDetail?: Maybe<Array<DueDateRangeListingDetail>>;
  lateInterestDetail?: Maybe<Array<DueDateRangeListingDetail>>;
  miscBillingDetail?: Maybe<Array<DueDateRangeListingDetail>>;
  paymentDetail?: Maybe<Array<DueDateRangeListingDetail>>;
  purchaserInstallmentDetail?: Maybe<Array<DueDateRangeListingDetail>>;
  rebateDetail?: Maybe<Array<DueDateRangeListingDetail>>;
};

export type DueDateRangeListingDetail = {
  __typename?: 'dueDateRangeListingDetail';
  description?: Maybe<Scalars['String']>;
  documentAmount?: Maybe<Scalars['Float']>;
  documentDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  outstanding?: Maybe<Scalars['Float']>;
  totalAlocated?: Maybe<Scalars['Float']>;
};

export type DuplicatePaymentPlanInput = {
  effectiveDate: Scalars['DateTime'];
  name: Scalars['String'];
  paymentPlanId: Scalars['String'];
};

export enum DurationFlagType {
  CollectionDate = 'COLLECTION_DATE',
  DescriptionList = 'DescriptionList',
  GetDescription = 'GetDescription',
  UserDefinedDate = 'USER_DEFINED_DATE',
  VpBillingDate = 'VP_BILLING_DATE',
  VpLetterDate = 'VP_LETTER_DATE'
}

export type DynamicSource = {
  __typename?: 'DynamicSource';
  DataSource: DropDownDataSource;
  DisplayMember: Scalars['String'];
  ValueMember: Scalars['String'];
};

export type DynamicSourceInput = {
  DataSource: DropDownDataSourceInput;
  DisplayMember: Scalars['String'];
  ValueMember: Scalars['String'];
};

export type EditAccessRoleInput = {
  permissionList?: InputMaybe<Array<AccessPermissionListInput>>;
  roleId: Scalars['String'];
  roleName: Scalars['String'];
};

export type EditArchitectCertInput = {
  certAttachments?: InputMaybe<Array<Scalars['Upload']>>;
  certificateDate: Scalars['DateTime'];
  certificateNo: Scalars['String'];
  deleteAttachments?: InputMaybe<Array<Scalars['String']>>;
  dialog?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  projectId: Scalars['String'];
  unitId: Array<Scalars['String']>;
  workProgressId: Array<Scalars['String']>;
};

export type EditAreaVarianceIndonesiaInput = {
  actualBuiltUp: Scalars['Float'];
  actualLandArea: Scalars['Float'];
  builtUp: Scalars['Float'];
  compensateAmount: Scalars['Float'];
  formula: Scalars['String'];
  id: Scalars['String'];
  landArea: Scalars['Float'];
  refId?: InputMaybe<Scalars['String']>;
  refTable?: InputMaybe<Scalars['String']>;
  saleId: Scalars['String'];
  unitId: Scalars['String'];
};

export type EditBankInput = {
  code: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type EditBankPaymentInput = {
  bankAccountId: Scalars['String'];
  billList?: InputMaybe<Array<AllocationListing>>;
  description: Scalars['String'];
  documentDate: Scalars['DateTime'];
  file?: InputMaybe<Array<Scalars['Upload']>>;
  financierId: Scalars['String'];
  generationBatchDate: Scalars['DateTime'];
  generationBatchId: Scalars['String'];
  refNo: Scalars['String'];
  status: CreditControlStatus;
};

export type EditBillItemInput = {
  billItemType: BillItem;
  classificationId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  msicId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type EditBlockInput = {
  blocks: Array<BlockInput>;
  prefix: Scalars['String'];
};

export type EditCarParkInput = {
  discountAmt?: InputMaybe<Scalars['Float']>;
  discountId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  isIncludeContract?: InputMaybe<Scalars['Boolean']>;
  oldSellingMethod?: InputMaybe<Scalars['String']>;
  oldSellingPrice?: InputMaybe<Scalars['Float']>;
  oldUnitId: Scalars['String'];
  paymentPlanId?: InputMaybe<Scalars['String']>;
  paymentPlanSummary?: InputMaybe<Array<BasePaymentPlanSummary>>;
  projectCarparkPaymentPlanId?: InputMaybe<Scalars['String']>;
  saleId: Scalars['String'];
  sellingMethod?: InputMaybe<Scalars['String']>;
  sellingPrice: Scalars['Float'];
  taxSchemeId?: InputMaybe<Scalars['String']>;
  unitId: Scalars['String'];
};

export type EditCommissionPaymentInput = {
  paidToDate: Scalars['Float'];
  release: Scalars['Float'];
  remarks: Scalars['String'];
};

export type EditCompanyBankAccountInput = {
  accountNo: Scalars['String'];
  accountType: BankAccountType;
  bankProfileId: Scalars['String'];
  code: Scalars['String'];
  companyId: Scalars['String'];
  currency?: InputMaybe<Scalars['String']>;
  effectiveDate: Scalars['DateTime'];
  id?: InputMaybe<Scalars['String']>;
  swiftCode?: InputMaybe<Scalars['String']>;
};

export type EditCompanyBankProfileInput = {
  address?: InputMaybe<Scalars['String']>;
  companyId: Scalars['String'];
  editBankAccount?: InputMaybe<Array<EditCompanyBankAccountInput>>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  phoneNo: Scalars['String'];
};

export type EditCompanyInput = {
  companyCode: Scalars['String'];
  companyDesc: Scalars['String'];
  companyId: Scalars['String'];
  companyName: Scalars['String'];
  eInvEndDate?: InputMaybe<Scalars['DateTime']>;
  eInvStartDate?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  eSign?: InputMaybe<Scalars['String']>;
  eSignExpiryDate?: InputMaybe<Scalars['DateTime']>;
  groupGstRegNo?: InputMaybe<Scalars['String']>;
  gstRegNo?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isEinvIntegrated: Scalars['Boolean'];
  logoUrl?: InputMaybe<Scalars['String']>;
  officeAddress: AddressJsonInput;
  officeTelNo: Scalars['String'];
  regNo: Scalars['String'];
  sstRegNo?: InputMaybe<Scalars['String']>;
  tin?: InputMaybe<Scalars['String']>;
};

export type EditCountryCodeInput = {
  code: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type EditDeemCollectedInput = {
  attachments?: InputMaybe<Array<Scalars['Upload']>>;
  collectionBatch: Scalars['String'];
  deleteAttachments?: InputMaybe<Array<Scalars['String']>>;
  durationFlag: DurationFlagType;
  id: Scalars['String'];
  paymentDate?: InputMaybe<Scalars['DateTime']>;
  referenceNo?: InputMaybe<Scalars['String']>;
  solicitor: Scalars['String'];
  spId: Array<Scalars['String']>;
};

export type EditDirectionInput = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type EditDiscountInput = {
  description?: InputMaybe<Scalars['String']>;
  discountTypeId: Scalars['String'];
  discountVal: Scalars['Float'];
  formula: Scalars['String'];
  id: Scalars['String'];
  prefix: Scalars['String'];
  title: Scalars['String'];
};

export type EditDiscountTypeInput = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type EditDownpaymentReminder = {
  progressBillingId: Scalars['String'];
  projectId: Scalars['String'];
  reminderDate: Scalars['DateTime'];
  reminderId: Scalars['String'];
  reminderSeq: Scalars['Float'];
  saleId: Scalars['String'];
  share?: InputMaybe<Array<ShareInput>>;
};

export type EditDownpaymentReminderInput = {
  input: Array<EditDownpaymentReminder>;
};

export type EditEmailLogSchemeInput = {
  accountId: Scalars['String'];
  bccEmails?: InputMaybe<Scalars['String']>;
  ccEmails?: InputMaybe<Scalars['String']>;
  content: Scalars['String'];
  errorMessage?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  isEmailSent: Scalars['Boolean'];
  recipientEmail: Scalars['String'];
  refId: Scalars['String'];
  refType: Scalars['String'];
  subject: Scalars['String'];
};

export type EditEmployeeJobPositionInput = {
  positionId?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
  userId: Scalars['String'];
};

export type EditFinancialBillingInput = {
  amount: Scalars['Float'];
  financierId: Scalars['String'];
  id: Scalars['String'];
  progressBillingId: Scalars['String'];
  project_id: Scalars['String'];
  sale_id: Scalars['String'];
  saleLoanId: Scalars['String'];
};

export type EditFinancierListInput = {
  doaDate: Scalars['DateTime'];
  doaSolicitorId: Scalars['String'];
  doaSolicitorReferenceNo: Scalars['String'];
  financierId: Scalars['String'];
  financierReferenceNo: Scalars['String'];
  loanAgreementDate: Scalars['DateTime'];
  loanAmount: Scalars['Float'];
  loanSeqNo: Scalars['Float'];
  loanSolicitorId: Scalars['String'];
  loanSolicitorReferenceNo: Scalars['String'];
  refinancingId?: InputMaybe<Scalars['String']>;
  rrDate: Scalars['DateTime'];
  rrSolicitorId: Scalars['String'];
  rrSolicitorReferenceNo: Scalars['String'];
};

export type EditIncomeRangeInput = {
  id: Scalars['String'];
  range: Scalars['String'];
  seqNo?: InputMaybe<Scalars['Float']>;
};

export type EditKeyCollectionAppointmentInput = {
  alarmVendorId?: InputMaybe<Scalars['String']>;
  electricianId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  keyCollectionTimeslotId: Scalars['String'];
  plumberId?: InputMaybe<Scalars['String']>;
  saleId: Scalars['String'];
  siteSupervisorId?: InputMaybe<Scalars['String']>;
};

export type EditKeyCollectionInput = {
  endDate: Scalars['DateTime'];
  endTime: Scalars['DateTime'];
  id: Scalars['String'];
  interval: Scalars['Float'];
  startDate: Scalars['DateTime'];
  startTime: Scalars['DateTime'];
  teamMember: Array<Scalars['String']>;
};

export type EditLadInput = {
  byFacilityDate?: InputMaybe<Scalars['DateTime']>;
  byUnitDate: Scalars['DateTime'];
  commonFacility: Scalars['Boolean'];
  contraDate: Scalars['DateTime'];
  facilityLadDuration?: InputMaybe<Scalars['Float']>;
  facilityLadPercent?: InputMaybe<Scalars['Float']>;
  id: Scalars['String'];
  isSimulate: Scalars['Boolean'];
  ladUnitDetails?: InputMaybe<Array<AddLadUnitInput>>;
  payoutPercent: Scalars['Float'];
  spaPercent: Scalars['Float'];
  startWith: LadType;
  taxSchemeId?: InputMaybe<Scalars['String']>;
  unitDuration: Scalars['Float'];
  unitLadPercent: Scalars['Float'];
};

export type EditLateInterestInput = {
  enableFloatingInterest?: InputMaybe<Scalars['Boolean']>;
  excludeHolidays?: InputMaybe<Scalars['Boolean']>;
  excludePayment?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  loanGracePeriod: Scalars['Float'];
  loanGracePeriodStartWith: ProjectLateInterestEnum;
  minInterestAmt: Scalars['Float'];
  projectID: Scalars['String'];
  taxSchemeId: Scalars['String'];
};

export type EditLatePaymentInterestExceptionInput = {
  id: Scalars['String'];
  remark: Scalars['String'];
};

export type EditLeadSourceInput = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type EditLetterTemplateInput = {
  id: Scalars['String'];
  isReportDesignEditor: Scalars['Boolean'];
  jointBuyerSignRequired: Scalars['Boolean'];
  name: Scalars['String'];
  standardLetterId: Scalars['String'];
};

export type EditMaritalStatusInput = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type EditMiscBillingInput = {
  billingDate: Scalars['DateTime'];
  creditTerm: Scalars['Float'];
  generationBatch: Scalars['String'];
  interestRate: Scalars['Float'];
  projectMiscBillingData: Array<Scalars['String']>;
  status: Scalars['String'];
  unitId: Array<Scalars['String']>;
};

export type EditMotTrackingInput = {
  confirmationPresentationReceipt: Scalars['DateTime'];
  forwardMotComSec: Scalars['DateTime'];
  forwardMotDirector: Scalars['DateTime'];
  id: Scalars['String'];
  instructionToSolicitor: Scalars['DateTime'];
  motIn: Scalars['DateTime'];
  motMortgageDate: Scalars['DateTime'];
  motMortgageNo?: InputMaybe<Scalars['String']>;
  motOut: Scalars['DateTime'];
  motReceiptNo?: InputMaybe<Scalars['String']>;
  motSolicitorId: Scalars['String'];
  motSolicitorReferenceNo?: InputMaybe<Scalars['String']>;
  motSubmissionDate: Scalars['DateTime'];
  motSubmissionNo?: InputMaybe<Scalars['String']>;
  motTransferDate: Scalars['DateTime'];
  projectId: Scalars['String'];
  receivedFrom?: InputMaybe<Scalars['String']>;
  receivedTitleDutyTransferred: Scalars['DateTime'];
  receiveLawyerAcknowledgement: Scalars['DateTime'];
  receiveMotCancellation: Scalars['DateTime'];
  receiveMotComSec: Scalars['DateTime'];
  receiveMotDirector: Scalars['DateTime'];
  releaseForTitle: Scalars['DateTime'];
  remark?: InputMaybe<Scalars['String']>;
  requestForTitle: Scalars['DateTime'];
  saleId?: InputMaybe<Scalars['String']>;
  stampDutyPayment: Scalars['Float'];
  stampDutyPaymentDate: Scalars['DateTime'];
  titleExecutionDate: Scalars['DateTime'];
  titleForward: Scalars['DateTime'];
  titleNotificationDate: Scalars['DateTime'];
};

export type EditNotaryInput = {
  address?: InputMaybe<AddressJsonInput>;
  contactDetails?: InputMaybe<Array<NotaryContactDetailsInput>>;
  email: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  notaryCode?: InputMaybe<Scalars['String']>;
  officeTel: Scalars['String'];
  ppatNo?: InputMaybe<Scalars['String']>;
};

export type EditNumberingFormatDetailInput = {
  formatType: DocumentNumberDetailTypeEnum;
  formatValue: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  resetBy?: InputMaybe<Scalars['String']>;
  seqNo?: InputMaybe<Scalars['Float']>;
  startFrom?: InputMaybe<Scalars['Float']>;
};

export type EditNumberingFormatInput = {
  companyId: Scalars['String'];
  editNumberingFormatDetail?: InputMaybe<Array<EditNumberingFormatDetailInput>>;
  id?: InputMaybe<Scalars['String']>;
  inputNumberingFormatDetail?: InputMaybe<Array<AddNumberingFormatDetailInput>>;
  refTable: Scalars['String'];
  sampleOutput: Scalars['String'];
  type: DocumentNumberHeaderTypeIndoEnum;
};

export type EditOtherSalesInfoInput = {
  address?: InputMaybe<AddressJsonInput>;
  campaignId?: InputMaybe<Scalars['String']>;
  creditTerm?: InputMaybe<Scalars['Float']>;
  incomeRangeId?: InputMaybe<Scalars['String']>;
  isCashBuyer: Scalars['Boolean'];
  isGenerateInterest: Scalars['Boolean'];
  isGenerateReminder: Scalars['Boolean'];
  leadId?: InputMaybe<Scalars['String']>;
  loanGracePeriod?: InputMaybe<Scalars['Float']>;
  saleId: Scalars['String'];
  salesPersonId?: InputMaybe<Scalars['String']>;
  salesTeamId?: InputMaybe<Scalars['String']>;
  salesType?: InputMaybe<SalesType>;
};

export type EditOverduePurchaseCaInput = {
  activityDate: Scalars['DateTime'];
  activityRemark: Scalars['String'];
  activityStatus?: InputMaybe<Scalars['String']>;
  attachments?: InputMaybe<Array<Scalars['Upload']>>;
  deleteAttachments?: InputMaybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  overduePurchaserAccountId: Scalars['String'];
  saleId: Scalars['String'];
};

export type EditPackageInput = {
  id: Scalars['String'];
  numRow?: InputMaybe<Scalars['Float']>;
  oldSellingMethod?: InputMaybe<Scalars['String']>;
  oldSellingPrice?: InputMaybe<Scalars['Float']>;
  openMarketValue?: InputMaybe<Scalars['Float']>;
  packageId: Scalars['String'];
  paymentPlanId?: InputMaybe<Scalars['String']>;
  paymentPlanSummary?: InputMaybe<Array<BasePaymentPlanSummary>>;
  projectPackagePaymentPlanId?: InputMaybe<Scalars['String']>;
  saleId: Scalars['String'];
  sellingMethod: Scalars['String'];
  sellingPrice?: InputMaybe<Scalars['Float']>;
  taxSchemeId?: InputMaybe<Scalars['String']>;
};

export type EditPaCollectionActivityInput = {
  activityDate: Scalars['DateTime'];
  activityRemark: Scalars['String'];
  activityStatus?: InputMaybe<Scalars['String']>;
  attachments?: InputMaybe<Array<Scalars['Upload']>>;
  deleteAttachments?: InputMaybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  saleId: Scalars['String'];
};

export type EditPAdebitNoteInput = {
  allocationList?: InputMaybe<Array<AllocationList>>;
  amount: Scalars['Float'];
  attachments?: InputMaybe<Array<Scalars['Upload']>>;
  billItemId: Scalars['String'];
  creditTerm: Scalars['Float'];
  deleteAttachments?: InputMaybe<Array<Scalars['String']>>;
  description?: InputMaybe<Scalars['String']>;
  documentAmount: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  documentRef?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  interestRate: Scalars['Float'];
  projectId: Scalars['String'];
  requestedBy?: InputMaybe<Scalars['String']>;
  saleId: Scalars['String'];
  taxDetails?: InputMaybe<Array<TaxDetailsAfterCalculation>>;
  taxSchemeDetailId?: InputMaybe<Scalars['String']>;
  taxSchemeId: Scalars['String'];
};

export type EditPaMiscBillingInput = {
  allocationList?: InputMaybe<Array<AllocationList>>;
  amount: Scalars['Float'];
  attachments?: InputMaybe<Array<Scalars['Upload']>>;
  billItemId: Scalars['String'];
  creditTerm: Scalars['Float'];
  deleteAttachments?: InputMaybe<Array<Scalars['String']>>;
  description?: InputMaybe<Scalars['String']>;
  documentAmount: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  documentRef?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  interestRate: Scalars['Float'];
  projectId: Scalars['String'];
  requestedBy?: InputMaybe<Scalars['String']>;
  saleId: Scalars['String'];
  taxDetails?: InputMaybe<Array<TaxDetailsAfterCalculation>>;
  taxSchemeDetailId?: InputMaybe<Scalars['String']>;
  taxSchemeId: Scalars['String'];
};

export type EditPAmoduleDataInput = {
  allocationList?: InputMaybe<Array<AllocationList>>;
  amount: Scalars['Float'];
  attachments?: InputMaybe<Array<Scalars['Upload']>>;
  billItemId: Scalars['String'];
  deleteAttachments?: InputMaybe<Array<Scalars['String']>>;
  description?: InputMaybe<Scalars['String']>;
  documentAmount: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  documentRef?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  projectId: Scalars['String'];
  requestedBy?: InputMaybe<Scalars['String']>;
  saleId: Scalars['String'];
  taxDetails?: InputMaybe<Array<TaxDetailsAfterCalculation>>;
  taxSchemeDetailId?: InputMaybe<Scalars['String']>;
  taxSchemeId: Scalars['String'];
};

export type EditParameterInput = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type EditPavSettingInput = {
  id: Scalars['String'];
  taxId: Scalars['String'];
};

export type EditPaymentinterestExceptionInput = {
  remark: Scalars['String'];
  saleId: Scalars['String'];
};

export type EditPaymentPlanDetailInput = {
  amountType: AmountType;
  amountValue: Scalars['Float'];
  detailId: Scalars['String'];
  id: Scalars['String'];
  includeIn?: InputMaybe<Array<IncludeInDetailInput>>;
  installmentBillingDay?: InputMaybe<Scalars['Float']>;
  isDownpayment?: InputMaybe<Scalars['Boolean']>;
  isStakeholder?: InputMaybe<Scalars['Boolean']>;
  isVpStage?: InputMaybe<Scalars['Boolean']>;
  isWithInterest?: InputMaybe<Scalars['Boolean']>;
  numberOfPayment?: InputMaybe<Scalars['Float']>;
  paymentPlanId?: InputMaybe<Scalars['String']>;
  stageSeqNo?: InputMaybe<Scalars['Float']>;
  stakeholderDuration?: InputMaybe<Scalars['Float']>;
  title: Scalars['String'];
  workProgressId: Scalars['String'];
};

export type EditPaymentPlanInput = {
  editPaymentDetail?: InputMaybe<Array<EditPaymentPlanDetailInput>>;
  effectiveDate: Scalars['DateTime'];
  id?: InputMaybe<Scalars['String']>;
  inputPaymentPlanDetail?: InputMaybe<Array<AddPaymentPlanDetailInput>>;
  name: Scalars['String'];
  payMethod?: InputMaybe<Scalars['String']>;
};

export type EditPriceAdjustmentInput = {
  computationMode: Scalars['String'];
  computationValue: Scalars['Float'];
  id: Scalars['String'];
  name: Scalars['String'];
  projectId: Scalars['String'];
  reason: Scalars['String'];
  remark?: InputMaybe<Scalars['String']>;
  roundingMode: Scalars['String'];
  roundingPrecision: Scalars['String'];
  status: Scalars['String'];
  unitIdList: Array<Scalars['String']>;
};

export type EditProgressBillingInput = {
  billingDate: Scalars['DateTime'];
  creditTerm: Scalars['Float'];
  generationBatch: Scalars['String'];
};

export type EditProjectAreaVarianceInputIndonesia = {
  effectiveDate: Scalars['DateTime'];
  formula?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  projectId: Scalars['String'];
};

export type EditProjectClusterInput = {
  desc: Scalars['String'];
  developmentCompany: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  projectId: Scalars['String'];
};

export type EditProjectCommissionInput = {
  commissionTypeId: Scalars['ID'];
  description: Scalars['String'];
  rateClassification: Scalars['String'];
};

export type EditProjectConstructionInputInput = {
  architect?: InputMaybe<Scalars['String']>;
  architectureStructure?: InputMaybe<Scalars['String']>;
  basePrice?: InputMaybe<Scalars['Float']>;
  buildingDesigner?: InputMaybe<Scalars['String']>;
  completionDate?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
  landPermitDate?: InputMaybe<Scalars['DateTime']>;
  landProprietor?: InputMaybe<Scalars['String']>;
  numberBlockUnit?: InputMaybe<Scalars['Float']>;
  planner?: InputMaybe<Scalars['String']>;
  propertyAgent?: InputMaybe<Scalars['String']>;
  spaDuration?: InputMaybe<Scalars['Float']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  superStructureType?: InputMaybe<Scalars['String']>;
  taxRegNo?: InputMaybe<Scalars['String']>;
};

export type EditProjectFireInsuranceInput = {
  certificateNo?: InputMaybe<Scalars['String']>;
  companyAddress?: InputMaybe<AddressJsonInput>;
  companyName?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  projectId: Scalars['String'];
};

export type EditProjectKeyCollectionContractorInput = {
  contactNo: Scalars['String'];
  contractorType: Scalars['String'];
  email: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  projectId: Scalars['String'];
};

export type EditProjectLadInput = {
  commonFacility: Scalars['Boolean'];
  facilityLadDuration?: InputMaybe<Scalars['Float']>;
  facilityLadPercent?: InputMaybe<Scalars['Float']>;
  id: Scalars['String'];
  payoutPercent: Scalars['Float'];
  spaPercent?: InputMaybe<Scalars['Float']>;
  startWith: Scalars['String'];
  taxSchemeId: Scalars['String'];
  unitDuration: Scalars['Float'];
  unitLadPercent: Scalars['Float'];
};

export type EditProjectMiscChargesInput = {
  billItemId: Scalars['String'];
  formula?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  interestRate: Scalars['Float'];
  remark?: InputMaybe<Scalars['String']>;
  taxSchemeId: Scalars['String'];
};

export type EditProjectPaymentPlanInput = {
  defaulted: Scalars['Boolean'];
  endDate: Scalars['DateTime'];
  id: Scalars['String'];
  paymentPlanId: Scalars['String'];
  projectId: Scalars['String'];
  startDate: Scalars['DateTime'];
  typePaymentPlan: TypePaymentPlanEnum;
};

export type EditProjectPaymentReminderExceptionInput = {
  id: Scalars['String'];
  maxReminder: Scalars['Float'];
};

export type EditProjectPermitInput = {
  expiryDate: Scalars['DateTime'];
  id: Scalars['String'];
  issueDate: Scalars['DateTime'];
  permitNo: Scalars['String'];
  permitType: PermitType;
  projectId: Scalars['String'];
};

export type EditProjectPolicyInput = {
  creditTerms: Scalars['Float'];
  id: Scalars['String'];
  interestRate: Scalars['Float'];
  projectId: Scalars['String'];
  roundingMode: RoundingMode;
  roundingPrecision: RoundingPrecision;
};

export type EditProjectRedemptionInput = {
  id: Scalars['String'];
  taxId: Scalars['String'];
};

export type EditProjectReminderInput = {
  id: Scalars['String'];
  paymentReminder1: Scalars['Float'];
  paymentReminder2: Scalars['Float'];
  paymentReminder3: Scalars['Float'];
  paymentReminder4: Scalars['Float'];
  paymentReminderScheduler: Scalars['Boolean'];
  paymentReminderSchedulerTime?: InputMaybe<Scalars['String']>;
};

export type EditProjectSalesPolicyDetailsInput = {
  depositAmount?: InputMaybe<Scalars['Float']>;
  id: Scalars['String'];
  landAreaFrom?: InputMaybe<Scalars['Float']>;
  landAreaTo?: InputMaybe<Scalars['Float']>;
};

export type EditProjectSalesPolicyInput = {
  collectLandDeposit: Scalars['Boolean'];
  DepositAmount?: InputMaybe<Scalars['Float']>;
  generateOverdueDebtorEvery?: InputMaybe<Scalars['String']>;
  generateOverdueDebtorTime?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  interestBasicRate: Scalars['String'];
  interestRate: Scalars['Float'];
  minimumDepositAmount?: InputMaybe<Scalars['Float']>;
  npvBasicRate?: InputMaybe<Scalars['String']>;
  npvRate?: InputMaybe<Scalars['Float']>;
  projectSalesPolicyDetailsArray?: InputMaybe<Array<AddProjectSalesPolicyDetailsInput>>;
  roundingMode: Scalars['String'];
  roundingPrecision: Scalars['String'];
  taxSchemeId?: InputMaybe<Scalars['String']>;
};

export type EditProjectTitleInput = {
  expiryDate: Scalars['DateTime'];
  id: Scalars['String'];
  issueDate: Scalars['DateTime'];
  projectId: Scalars['String'];
  receiveDate: Scalars['DateTime'];
  remark?: InputMaybe<Scalars['String']>;
  titleNo: Scalars['String'];
  titleType: ProjectTitleType;
  unitId: Array<Scalars['String']>;
};

export type EditProjectTypeInput = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type EditPromotionalItemInput = {
  cost: Scalars['Float'];
  description: Scalars['String'];
  name: Scalars['String'];
  projectId: Scalars['String'];
  promotionalItemId: Scalars['String'];
};

export type EditPromotionalPackagesInput = {
  addPromotionalPackagesItemInput: Array<AddPromotionalPackagesItemInput>;
  endDate: Scalars['DateTime'];
  id: Scalars['String'];
  name: Scalars['String'];
  startDate: Scalars['DateTime'];
};

export type EditPromotionalPackagesItemInput = {
  costPrice: Scalars['Float'];
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  promoPrice: Scalars['Float'];
  promotionalItemId: Scalars['String'];
  promotionalPackagesId?: InputMaybe<Scalars['String']>;
};

export type EditPropertyTypeInput = {
  commercialPurpose: CommercialPurpose;
  id: Scalars['String'];
  landPlots?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
};

export type EditPurchaserPaymentPlanDetailsInput = {
  billAfter: Scalars['String'];
  billCount: Scalars['Float'];
  billFreq: Scalars['String'];
  billType: Scalars['String'];
  noInstallment: Scalars['Float'];
  paymentBy: Scalars['String'];
  paymentPlanDetailsTitle: Scalars['String'];
  paymentValue: Scalars['Float'];
};

export type EditPurchaserPaymentPlanInput = {
  addPurchaserPaymentPlanDetailsInput?: InputMaybe<Array<AddPurchaserPaymentPlantDetailsInput>>;
  effectiveDate: Scalars['DateTime'];
  id: Scalars['String'];
  markUpPercentage: Scalars['Float'];
  name: Scalars['String'];
};

export type EditPurchaserTransferInput = {
  adminFee: Scalars['Float'];
  approvalStatus: Scalars['String'];
  documentNo: Scalars['String'];
  id: Scalars['String'];
  jointBuyers: Array<AddNewPurchaserTransferInput>;
  mainBuyerContactId: Scalars['String'];
  mainPurchaser: AddNewPurchaserTransferInput;
  miscBillId: Scalars['String'];
  projectId: Scalars['String'];
  purchaserTransferId?: InputMaybe<Scalars['String']>;
  saleId: Scalars['String'];
  transferDate: Scalars['DateTime'];
};

export type EditRaceInput = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type EditReasonCodeInput = {
  id: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type EditReceiptInput = {
  allocationList?: InputMaybe<Array<AllocationList>>;
  attachment?: InputMaybe<Array<Scalars['Upload']>>;
  bankAccountId: Scalars['String'];
  chequeDate?: InputMaybe<Scalars['DateTime']>;
  chequeExpireDate?: InputMaybe<Scalars['DateTime']>;
  creditCardType?: InputMaybe<CreditCardType>;
  deleteAttachments?: InputMaybe<Array<Scalars['String']>>;
  description: Scalars['String'];
  documentAmount: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  id: Scalars['String'];
  paymentMethod: PaymentMethod;
  receiptAmount: Scalars['Float'];
  referenceNo: Scalars['String'];
  saleId: Scalars['String'];
  status: CreditControlStatus;
};

export type EditRedemptionRepaymentInput = {
  documentDate: Scalars['DateTime'];
  paidById: Scalars['String'];
  paymentParty: Scalars['String'];
  redemptionDetailArray: Array<RedemptionRepaymentDetailInput>;
  redemptionId: Scalars['String'];
  redemptionSum: Scalars['Float'];
  referenceNo?: InputMaybe<Scalars['String']>;
};

export type EditRefinancingInput = {
  deletedId?: InputMaybe<Array<Scalars['String']>>;
  financierList: Array<EditFinancierListInput>;
  generationBatch: Scalars['String'];
  id: Scalars['String'];
  table: Scalars['String'];
};

export type EditRefundDataInput = {
  allocationList?: InputMaybe<Array<AllocationList>>;
  attachments?: InputMaybe<Array<Scalars['Upload']>>;
  bankAccountId?: InputMaybe<Scalars['String']>;
  chequeDate?: InputMaybe<Scalars['DateTime']>;
  chequeExpireDate?: InputMaybe<Scalars['DateTime']>;
  creditCardType?: InputMaybe<Scalars['String']>;
  deleteAttachments?: InputMaybe<Array<Scalars['String']>>;
  description?: InputMaybe<Scalars['String']>;
  documentAmount: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  documentRef?: InputMaybe<Scalars['String']>;
  glGenerated?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  projectId: Scalars['String'];
  refundMethod: Scalars['String'];
  saleId: Scalars['String'];
};

export type EditReleaseCollectedInput = {
  attachments?: InputMaybe<Array<Scalars['Upload']>>;
  bankAccountId: Scalars['String'];
  deleteAttachments?: InputMaybe<Array<Scalars['String']>>;
  detail: Array<ReleaseCollectedDetailInput>;
  id: Scalars['String'];
  paymentDate: Scalars['DateTime'];
  paymentMethod: Scalars['String'];
  referenceNo?: InputMaybe<Scalars['String']>;
  remark?: InputMaybe<Scalars['String']>;
  solicitorId: Scalars['String'];
};

export type EditSaleContactPersonInput = {
  email: Scalars['String'];
  id: Scalars['String'];
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  officeNo?: InputMaybe<Scalars['String']>;
  phoneNo: Scalars['String'];
  relationshipId?: InputMaybe<Scalars['String']>;
  remark?: InputMaybe<Scalars['String']>;
  salutationId?: InputMaybe<Scalars['String']>;
};

export type EditSaleInput = {
  commonStatus?: InputMaybe<CommonStatus>;
  createdBy?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  ID?: InputMaybe<Scalars['String']>;
  sellingPrice: Scalars['Float'];
};

export type EditSaleLoanBuyBackListInput = {
  approvalStatus: Scalars['String'];
  bankAccountId: Scalars['String'];
  buyBackAmount: Scalars['Float'];
  buyBackDate: Scalars['DateTime'];
  financierId: Scalars['String'];
  id: Scalars['String'];
  loanRefRecordId: Scalars['String'];
  loanRefTable: Scalars['String'];
  oldBalance: Array<OldBalanceBuyBackInput>;
  projectId: Scalars['String'];
  remarks: Scalars['String'];
  saleId: Scalars['String'];
};

export type EditSaleLoanCancellationInput = {
  cancelDate: Scalars['DateTime'];
  cancelReason: Scalars['String'];
  cancelRemark?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  saleId?: InputMaybe<Scalars['String']>;
  status: Scalars['String'];
};

export type EditSaleLoanDetailInput = {
  borrowerAddress: AddressJsonInput;
  borrowerName: Scalars['String'];
  cancelDate?: InputMaybe<Scalars['String']>;
  cancelReason?: InputMaybe<Scalars['String']>;
  financierId: Scalars['String'];
  financierReference: Scalars['String'];
  generationBatchDate?: InputMaybe<Scalars['DateTime']>;
  generationId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  loanAmount: Scalars['Float'];
  loanApprovalDate?: InputMaybe<Scalars['DateTime']>;
  loanLimit: Scalars['Float'];
  loanLooDate?: InputMaybe<Scalars['DateTime']>;
  loanPercentage: Scalars['Float'];
  loanPeriod?: InputMaybe<Scalars['Float']>;
  loanSeqno: Scalars['Float'];
  loanSignDate?: InputMaybe<Scalars['DateTime']>;
  remark: Scalars['String'];
  renoticeDate?: InputMaybe<Scalars['DateTime']>;
  rrDate?: InputMaybe<Scalars['DateTime']>;
  rrSolicitorId?: InputMaybe<Scalars['String']>;
  rrSolicitorReferenceNo?: InputMaybe<Scalars['String']>;
  saleId?: InputMaybe<Scalars['String']>;
  solicitorId: Scalars['String'];
  solicitorReference: Scalars['String'];
  taxSchemeId: Scalars['String'];
  totalLoanAmount: Scalars['Float'];
};

export type EditSaleLoanInput = {
  editSaleLoanDetail?: InputMaybe<Array<EditSaleLoanDetailInput>>;
  id?: InputMaybe<Scalars['String']>;
  inputSaleLoanDetail?: InputMaybe<Array<AddSaleLoanDetailInput>>;
  saleId: Scalars['String'];
};

export type EditSaleLoanRefinancingInput = {
  approvalStatus: Scalars['String'];
  borrowerAcct: Scalars['String'];
  borrowerName: Scalars['String'];
  endfinancierMortgageId: Scalars['String'];
  id: Scalars['String'];
  loanRefRecordId: Scalars['String'];
  loanRefTable: Scalars['String'];
  newFinancierId: Scalars['String'];
  oldBalance: Array<OldBalanceInput>;
  paymentPlan: Array<NewPaymentPlanInput>;
  projectId: Scalars['String'];
  refinancingDate: Scalars['DateTime'];
  remarks?: InputMaybe<Scalars['String']>;
  saleId: Scalars['String'];
};

export type EditSalesCancellationInput = {
  cancellationDate: Scalars['DateTime'];
  cancelReason: Scalars['String'];
  chargeFinalTax?: InputMaybe<Scalars['Boolean']>;
  finalTaxToDate: Scalars['Float'];
  forfeitureSum: Scalars['Float'];
  id: Scalars['String'];
  refundAmt: Scalars['Float'];
  refundTax?: InputMaybe<Scalars['Boolean']>;
  remark: Scalars['String'];
  saleId: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
  taxSchemeId: Scalars['String'];
  taxToDate: Scalars['Float'];
};

export type EditSalesContractContactInput = {
  ContactNo: Scalars['String'];
  Email?: InputMaybe<Scalars['String']>;
  ID: Scalars['String'];
  IsPrimary: Scalars['Boolean'];
  Name: Scalars['String'];
  OfficeTel?: InputMaybe<Scalars['String']>;
  RelationshipID?: InputMaybe<Scalars['String']>;
  Remark?: InputMaybe<Scalars['String']>;
  SalutationID?: InputMaybe<Scalars['String']>;
};

export type EditSalesContractDiscountInput = {
  discountAmount: Scalars['Float'];
  discountID: Scalars['String'];
  discountMethod: Scalars['String'];
  formula: Scalars['String'];
  ID: Scalars['String'];
};

export type EditSalesContractInfoInput = {
  address?: InputMaybe<AddressJsonInput>;
  bookDate?: InputMaybe<Scalars['DateTime']>;
  creditTerm?: InputMaybe<Scalars['Float']>;
  eventId?: InputMaybe<Scalars['String']>;
  incomeRangeId?: InputMaybe<Scalars['String']>;
  isCashBuyer?: InputMaybe<Scalars['Boolean']>;
  isGenerateInterest: Scalars['Boolean'];
  isGenerateReminder: Scalars['Boolean'];
  leadId?: InputMaybe<Scalars['String']>;
  loanGracePeriod?: InputMaybe<Scalars['Float']>;
  saleId: Scalars['String'];
  salesPersonId?: InputMaybe<Scalars['String']>;
  salesTeamId?: InputMaybe<Scalars['String']>;
  salesType?: InputMaybe<SalesType>;
};

export type EditSalesContractPackageInput = {
  ID: Scalars['String'];
  OpenMarketValue: Scalars['Float'];
  PackageID: Scalars['String'];
  PaymentPlanID?: InputMaybe<Scalars['String']>;
  sellingMethod: Scalars['String'];
  SellingPrice: Scalars['Float'];
  taxSchemeId: Scalars['String'];
  workProgressId: Scalars['String'];
};

export type EditSalesContractRebateInput = {
  campaignId: Scalars['String'];
  discountAmount: Scalars['Float'];
  discountId: Scalars['String'];
  discountMethod: Scalars['String'];
  ID: Scalars['String'];
  roundingMode: Scalars['String'];
  roundingPrecision: Scalars['String'];
  saleId: Scalars['String'];
  workProgressId: Scalars['String'];
};

export type EditSalesContractSubproductInput = {
  ID: Scalars['String'];
  PaymentPlanID?: InputMaybe<Scalars['String']>;
  SellingMethod: Scalars['String'];
  SellingPrice: Scalars['Float'];
};

export type EditSalesExtensionInput = {
  buyerReference: Scalars['String'];
  campaignId?: InputMaybe<Scalars['String']>;
  creditTerm?: InputMaybe<Scalars['Float']>;
  developerReference: Scalars['String'];
  discardBumiDiscount: Scalars['Boolean'];
  id: Scalars['String'];
  isCashBuyer: Scalars['Boolean'];
  isGenerateInterest: Scalars['Boolean'];
  isGenerateReminder: Scalars['Boolean'];
  loanGracePeriod?: InputMaybe<Scalars['Float']>;
  paymentPlanID: Scalars['String'];
  salesPerson?: InputMaybe<Scalars['String']>;
  salesType: SalesType;
  totalSalesValue: Scalars['Float'];
};

export type EditSalesOfficeInput = {
  BuildingContractorInfo?: InputMaybe<BuildingContractInfo>;
  CustomerCareLocalAuth?: InputMaybe<CustomerCareLocalInfo>;
  id?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['String']>;
  PropertySalesLocalAuth?: InputMaybe<PropertySalesInfo>;
  SalesOfficeInfo?: InputMaybe<SalesOfficeInfo>;
};

export type EditSalesPackageInput = {
  defaulted: Scalars['Boolean'];
  desc: Scalars['String'];
  endDate: Scalars['DateTime'];
  id: Scalars['String'];
  listPrice: Scalars['Float'];
  marketValue: Scalars['Float'];
  name: Scalars['String'];
  projectId: Scalars['String'];
  startDate: Scalars['DateTime'];
  taxSchemeId: Scalars['String'];
};

export type EditSalesRegistrationDiscountInput = {
  discountAmount: Scalars['Float'];
  discountID: Scalars['String'];
  discountMethod: Scalars['String'];
  formula: Scalars['String'];
  ID: Scalars['String'];
};

export type EditSalesStatutoryDocumentIndoInput = {
  bpnLandArea?: InputMaybe<Scalars['Float']>;
  document_ref: Scalars['String'];
  documentDate?: InputMaybe<Scalars['DateTime']>;
  file?: InputMaybe<Array<Scalars['Upload']>>;
  id: Scalars['String'];
  notaryId?: InputMaybe<Scalars['String']>;
};

export type EditSalutationInput = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type EditSolicitorsInput = {
  buyerReference: Scalars['String'];
  buyerSolicitorID: Scalars['String'];
  developerReference: Scalars['String'];
  developerSolicitorID: Scalars['String'];
  id: Scalars['String'];
};

export type EditSpaReminder = {
  projectId: Scalars['String'];
  reminderDate: Scalars['DateTime'];
  reminderId: Scalars['String'];
  reminderSeq: Scalars['Float'];
  saleId: Scalars['String'];
  share?: InputMaybe<Array<ShareInput>>;
};

export type EditSpaReminderInput = {
  input: Array<EditSpaReminder>;
};

export type EditStandardLetterInput = {
  id: Scalars['String'];
  isReportDesignEditor: Scalars['Boolean'];
  jointBuyerSignRequired: Scalars['Boolean'];
  name: Scalars['String'];
  standardLetterId: Scalars['String'];
};

export type EditStandardLetterParameterInput = {
  columnName: Scalars['String'];
  displayName: Scalars['String'];
  id: Scalars['String'];
  standardLetterId: Scalars['String'];
};

export type EditStatutoryDocumentIndoInput = {
  code: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  perSalesContract?: InputMaybe<Scalars['Boolean']>;
};

export type EditStatutoryDocumentInput = {
  code: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  perSalesContract?: InputMaybe<Scalars['Boolean']>;
};

export type EditSubsaleInput = {
  administrationCharge: Scalars['Float'];
  buyerSolicitorId: Scalars['String'];
  buyerSolicitorReferenceNo: Scalars['String'];
  dmcDate: Scalars['DateTime'];
  doaDate: Scalars['DateTime'];
  id: Scalars['String'];
  JointBuyers?: InputMaybe<Array<AddSubsalePurchaserDetailsInput>>;
  printingCharge: Scalars['Float'];
  PurchaserDetails?: InputMaybe<AddSubsalePurchaserDetailsInput>;
  rrDate: Scalars['DateTime'];
  sellingPrice: Scalars['Float'];
  serviceChargeDeposit: Scalars['Float'];
  spaDate: Scalars['DateTime'];
  subsaleCategory: SubsaleType;
  subsaleLoans?: InputMaybe<Array<AddSubsaleLoanInput>>;
  unitId: Scalars['String'];
  vendorSolicitorId: Scalars['String'];
  vendorSolicitorReferenceNo: Scalars['String'];
};

export type EditTaxInput = {
  classType: Scalars['String'];
  code: Scalars['String'];
  deletedId: Array<Scalars['String']>;
  description: Scalars['String'];
  isClaimable: Scalars['Boolean'];
  isFinal: Scalars['Boolean'];
  schemeTypeId: Scalars['String'];
  taxDetail: Array<TaxDetail>;
  taxId: Scalars['String'];
};

export type EditTaxSchemeInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isExclusive?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  taxSchemeDetail?: InputMaybe<Array<AddTaxSchemeDetailInput>>;
};

export type EditTeamInput = {
  id: Scalars['String'];
  name: Scalars['String'];
  projectId: Scalars['String'];
};

export type EditTownshipInput = {
  code: Scalars['String'];
  companyId: Scalars['String'];
  file?: InputMaybe<Scalars['Upload']>;
  id: Scalars['String'];
  location: Scalars['String'];
  logo_url?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  seq_no?: InputMaybe<Scalars['Float']>;
};

export type EditTransactionCodeDetailInput = {
  code: Scalars['String'];
  description: Scalars['String'];
  taxTransactionCodeId: Scalars['String'];
  type: Scalars['String'];
};

export type EditUnitInformationInput = {
  block: Scalars['String'];
  isSubProduct: Scalars['Boolean'];
  projectId: Scalars['String'];
  unitId: Array<Scalars['String']>;
  unitInformation: Array<UnitInformationListInput>;
};

export type EditUnitInput = {
  commonStatus?: InputMaybe<CommonStatus>;
  createdBy?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  ID?: InputMaybe<Scalars['String']>;
  unitStatus: Scalars['String'];
};

export type EditUnitTransferInput = {
  administrationCharges?: InputMaybe<Scalars['Float']>;
  discount?: InputMaybe<UnitTansferDiscountInput>;
  id: Scalars['String'];
  newListPrice: Scalars['Float'];
  newSellingPrice: Scalars['Float'];
  newUnitId: Scalars['String'];
  oldSaleDetail?: InputMaybe<UnitTransferOldSaleDetailInput>;
  oldSellingPrice: Scalars['Float'];
  oldUnitId?: InputMaybe<Scalars['String']>;
  paymentMethod?: InputMaybe<Scalars['String']>;
  paymentPlanId: Scalars['String'];
  reason: Scalars['String'];
  remark?: InputMaybe<Scalars['String']>;
  saleId?: InputMaybe<Scalars['String']>;
  status: Scalars['String'];
  transferDate: Scalars['DateTime'];
};

export type EditUnitTypeInput = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type EditUserInput = {
  allowOpenLead: Scalars['Boolean'];
  allowPropertyAgency: Scalars['Boolean'];
  email: Scalars['String'];
  name: Scalars['String'];
  phoneNo: Scalars['String'];
  superUser: Scalars['Boolean'];
  userId: Scalars['String'];
  username: Scalars['String'];
};

export type EditWorkProgressInput = {
  id: Scalars['String'];
  isCarPark?: InputMaybe<Scalars['Boolean']>;
  isVp?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
};

export type EInvoiceClassificationEntity = {
  __typename?: 'eInvoiceClassificationEntity';
  classificationCode?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
};

export type EInvoiceGeneralTinEntity = {
  __typename?: 'eInvoiceGeneralTinEntity';
  displaySeq?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  tin?: Maybe<Scalars['String']>;
  tinParty?: Maybe<Scalars['String']>;
};

export type EInvoiceMsicEntity = {
  __typename?: 'eInvoiceMsicEntity';
  categoryReference?: Maybe<Scalars['String']>;
  companyMsicAssignment: Array<CompanyMsicAssignmentEntity>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  msicCode?: Maybe<Scalars['String']>;
};

export type EInvoiceUomEntity = {
  __typename?: 'eInvoiceUomEntity';
  code?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export type ELaunchAllocationEntity = AuditEntity & {
  __typename?: 'eLaunchAllocationEntity';
  accountId: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  eLaunch: ELaunchEntity;
  eLaunchId: Scalars['String'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  unit: UnitEntity;
  unitId: Scalars['String'];
};

export type ELaunchContactEntity = AuditEntity & {
  __typename?: 'eLaunchContactEntity';
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  elaunchUser: ELaunchUserEntity;
  email?: Maybe<Scalars['String']>;
  getLangMasterData: Array<LanguageNamesOutput>;
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  name: Scalars['String'];
  phoneNo?: Maybe<Scalars['String']>;
  pictureUrl?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
  userLanguageChoose: LanguageOutput;
};

export type ELaunchEntity = AuditEntity & {
  __typename?: 'eLaunchEntity';
  accountId: Scalars['String'];
  code: Scalars['String'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  eLaunchAllocation?: Maybe<Array<ELaunchAllocationEntity>>;
  eLaunchLeadBatch?: Maybe<Array<ELaunchLeadBatchEntity>>;
  endDate: Scalars['DateTime'];
  hasEnded?: Maybe<Scalars['Boolean']>;
  hasPublished?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  name: Scalars['String'];
  projectId: Scalars['String'];
  publishDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
  terminationDate: Scalars['DateTime'];
};

export type ELaunchFavouriteUnitEntity = AuditEntity & {
  __typename?: 'eLaunchFavouriteUnitEntity';
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  eLaunchId: Scalars['String'];
  eLaunchUser: ELaunchUserEntity;
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  unitId: Scalars['String'];
  userId: Scalars['String'];
};

export type ELaunchInvitationTemplateEntity = AuditEntity & {
  __typename?: 'eLaunchInvitationTemplateEntity';
  accountId: Scalars['String'];
  accountSpec: AccountSpecEntity;
  commonStatus: Scalars['String'];
  content: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  eLaunch: ELaunchEntity;
  eLaunchId: Scalars['String'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  salesDoc?: Maybe<SalesDocEntity>;
  salesDocId?: Maybe<Array<Scalars['String']>>;
  subject?: Maybe<Scalars['String']>;
};

export type ELaunchLeadBatchEntity = AuditEntity & {
  __typename?: 'eLaunchLeadBatchEntity';
  accountId: Scalars['String'];
  batchTitle: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  eLaunch: ELaunchEntity;
  eLaunchId: Scalars['String'];
  id: Scalars['String'];
  lastEmailSend?: Maybe<Array<LastEmailSendOutput>>;
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  recordCount: Scalars['Float'];
};

export type ELaunchLeadEntity = AuditEntity & {
  __typename?: 'eLaunchLeadEntity';
  accountId: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  eLaunchBatchId: Scalars['String'];
  eLaunchLeadBatch: ELaunchLeadBatchEntity;
  id: Scalars['String'];
  lead: LeadEntity;
  leadId: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
};

export type ELaunchLogEntity = AuditEntity & {
  __typename?: 'eLaunchLogEntity';
  accountId: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  eLaunch: ELaunchEntity;
  eLaunchId: Scalars['String'];
  id: Scalars['String'];
  log: Scalars['JSONObject'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
};

export type ELaunchOtpEntity = AuditEntity & {
  __typename?: 'eLaunchOtpEntity';
  accountId: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  ipAddress?: Maybe<Scalars['String']>;
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  otpCode: Scalars['String'];
  otpExpiry: Scalars['DateTime'];
  otpType: Scalars['String'];
  phoneNo: Scalars['String'];
};

export type ELaunchRegisterEntity = AuditEntity & {
  __typename?: 'eLaunchRegisterEntity';
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  eLaunch: ELaunchEntity;
  eLaunchId: Scalars['String'];
  eLaunchUser: ELaunchUserEntity;
  id: Scalars['String'];
  invitedBy?: Maybe<Scalars['String']>;
  invitedById?: Maybe<Scalars['String']>;
  leadId: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  userId: Scalars['String'];
};

export type ELaunchUserEntity = AuditEntity & {
  __typename?: 'eLaunchUserEntity';
  accessToken?: Maybe<Scalars['String']>;
  accountId: Scalars['String'];
  activated: Scalars['Boolean'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  forgotPasswordLink?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  languageSet: Scalars['String'];
  loginId: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  refreshToken?: Maybe<Scalars['String']>;
};

export type ELetterOutput = {
  __typename?: 'ELetterOutput';
  content: Scalars['String'];
  fileName: Scalars['String'];
};

export type ELetterProjectLetterOutput = {
  __typename?: 'ELetterProjectLetterOutput';
  defaulted: Scalars['Boolean'];
  id: Scalars['String'];
  letterType: Scalars['String'];
  name: Scalars['String'];
};

export type EmailLetterEntity = {
  __typename?: 'emailLetterEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  emailLetterParameter: Array<EmailLetterParameterEntity>;
  emailLetterTemplate: Array<EmailLetterTemplateEntity>;
  emailType: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  seqNo: Scalars['Float'];
};

export type EmailLetterParameterEntity = {
  __typename?: 'emailLetterParameterEntity';
  accountId: Scalars['String'];
  columnName: Scalars['String'];
  commonStatus: Scalars['String'];
  displayName: Scalars['String'];
  emailLetter: EmailLetterEntity;
  emailLetterId: Scalars['String'];
  id: Scalars['String'];
};

export type EmailLetterTemplateEntity = AuditEntity & {
  __typename?: 'emailLetterTemplateEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  emailLetter: EmailLetterEntity;
  emailLetterId: Scalars['String'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  name: Scalars['String'];
  projectEmailLetter: ProjectEmailLetterEntity;
  systemUse: Scalars['Boolean'];
  templateBody?: Maybe<Scalars['String']>;
};

export type EmailLogEntity = {
  __typename?: 'emailLogEntity';
  accountId: Scalars['String'];
  bccEmails: Scalars['String'];
  ccEmails: Scalars['String'];
  commonStatus: Scalars['String'];
  content: Scalars['String'];
  errorMessage?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isEmailSent: Scalars['Boolean'];
  recipientEmail: Scalars['String'];
  refId: Scalars['String'];
  refType: Scalars['String'];
  subject: Scalars['String'];
};

export type EmailLogOutput = {
  __typename?: 'EmailLogOutput';
  accountId: Scalars['String'];
  bccEmails?: Maybe<Scalars['String']>;
  ccEmails?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  content: Scalars['String'];
  errorMessage?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isEmailSent: Scalars['Boolean'];
  recipientEmail: Scalars['String'];
  refId: Scalars['String'];
  refType: Scalars['String'];
  subject: Scalars['String'];
};

export type EmployeeInfo = {
  __typename?: 'EmployeeInfo';
  employeeName: Scalars['String'];
  id: Scalars['String'];
};

export type EmployeeJobPosition = {
  __typename?: 'employeeJobPosition';
  employeeName: Scalars['String'];
  id: Scalars['String'];
};

export type EmployeeJobPositionEntity = AuditEntity & {
  __typename?: 'employeeJobPositionEntity';
  accountId: Scalars['String'];
  commonStatus?: Maybe<Scalars['String']>;
  companyId: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  employeeName: Scalars['String'];
  id: Scalars['String'];
  jobPosition: JobPositionEntity;
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  positionId: Scalars['String'];
  userId: Scalars['String'];
};

export type EmployeeJobPositionOutput = {
  __typename?: 'employeeJobPositionOutput';
  employeeJobPosition?: Maybe<Array<EmployeeJobPosition>>;
  id: Scalars['String'];
  position: Scalars['String'];
};

export type EndFinancierDataOutput = {
  __typename?: 'endFinancierDataOutput';
  endfinName?: Maybe<Scalars['String']>;
  endFinPaymentPlans?: Maybe<Array<EndFinPaymentPlan>>;
  financierName?: Maybe<Scalars['String']>;
};

export type EndFinancierDetailListing = {
  __typename?: 'endFinancierDetailListing';
  buyerName: Scalars['String'];
  creditId?: Maybe<Scalars['String']>;
  creditRefTable: Scalars['String'];
  currentAllocate: Scalars['Float'];
  debitId: Scalars['String'];
  debitRefTable: Scalars['String'];
  documentNo: Scalars['String'];
  financialBillingId: Scalars['String'];
  financierCode?: Maybe<Scalars['String']>;
  outstandingBalance: Scalars['Float'];
  pbDescription: Scalars['String'];
  pbDocumentAmount: Scalars['Float'];
  saleId: Scalars['String'];
  unitId: Scalars['String'];
  unitNo: Scalars['String'];
};

export type EndFinancierDetailListingOutput = {
  __typename?: 'endFinancierDetailListingOutput';
  financierId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  projectId?: Maybe<Scalars['String']>;
  projectName?: Maybe<Scalars['String']>;
  projectSaleCount?: Maybe<Scalars['Float']>;
  projectTotalLoanAmount?: Maybe<Scalars['Float']>;
  projectTotalPendingAmount?: Maybe<Scalars['Float']>;
};

export type EndFinancierOutput = {
  __typename?: 'endFinancierOutput';
  financierBankId?: Maybe<Scalars['String']>;
  financierName: Scalars['String'];
  id: Scalars['String'];
};

export type EndFinancingInfoLine = {
  __typename?: 'endFinancingInfoLine';
  totalDraft?: Maybe<Scalars['Float']>;
  totalSubmitted?: Maybe<Scalars['Float']>;
};

export type EndFinancingLimitStatusOutput = {
  __typename?: 'EndFinancingLimitStatusOutput';
  approvalAmount: Scalars['Float'];
  financialLimit: Scalars['Float'];
  name: Scalars['String'];
};

export type EndfinContactEntity = {
  __typename?: 'endfinContactEntity';
  email?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  phoneNo?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  user: EndfinUserEntity;
  userId: Scalars['String'];
};

export type EndfinFinancierEntity = {
  __typename?: 'endfinFinancierEntity';
  activated: Scalars['Boolean'];
  commonStatus: Scalars['String'];
  endfinUserRoles: Array<EndfinUserRoleEntity>;
  financier?: Maybe<FinancierEntity>;
  financiers: Array<FinancierEntity>;
  id: Scalars['String'];
  name: Scalars['String'];
  staffCount?: Maybe<Scalars['Float']>;
};

export type EndfinLoanAppActivityEntity = {
  __typename?: 'endfinLoanAppActivityEntity';
  activityType: Scalars['String'];
  activityTypeDesc: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdDate: Scalars['DateTime'];
  id: Scalars['String'];
  loanApp: EndfinLoanAppEntity;
  loanAppId: Scalars['String'];
  loanAppStatus: EndfinLoanAppStatusEntity;
  loanAppStatusId: Scalars['String'];
  remark?: Maybe<Scalars['String']>;
};

export type EndfinLoanAppEntity = {
  __typename?: 'endfinLoanAppEntity';
  accountId: Scalars['String'];
  activityData?: Maybe<Array<EndfinLoanAppActivityEntity>>;
  agingDate?: Maybe<Scalars['DateTime']>;
  applyAmount: Scalars['Float'];
  applyDate: Scalars['DateTime'];
  approvalAmount?: Maybe<Scalars['Float']>;
  approvalDate?: Maybe<Scalars['DateTime']>;
  assignedDate?: Maybe<Scalars['DateTime']>;
  documentData?: Maybe<Array<AttachmentEntity>>;
  eLetteringExistenceType?: Maybe<Array<Scalars['String']>>;
  endfinLoanAppActivities: Array<EndfinLoanAppActivityEntity>;
  financier: FinancierEntity;
  financierId: Scalars['String'];
  id: Scalars['String'];
  lastActivity?: Maybe<EndfinLoanAppActivityEntity>;
  loanAppStatus: EndfinLoanAppStatusEntity;
  loanAppStatusId: Scalars['String'];
  loanType: Scalars['String'];
  sale: SaleEntity;
  saleId: Scalars['String'];
  staff?: Maybe<EndfinUserEntity>;
  tenure?: Maybe<Scalars['Float']>;
  user?: Maybe<EndfinUserEntity>;
  userId: Scalars['String'];
};

export type EndfinLoanAppStatusEntity = {
  __typename?: 'endfinLoanAppStatusEntity';
  endfinLoanAppActivities: Array<EndfinLoanAppActivityEntity>;
  endfinLoanApps: Array<EndfinLoanAppEntity>;
  id: Scalars['String'];
  seqNo: Scalars['Float'];
  stages: Scalars['Float'];
  statusCode: Scalars['String'];
  statusName: Scalars['String'];
};

export type EndfinNotificationEntity = AuditEntity & {
  __typename?: 'endfinNotificationEntity';
  accountId: Scalars['String'];
  body: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  endfinNotificationRecipient: Array<EndfinNotificationRecipientEntity>;
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  permissionId: Scalars['Float'];
  projectId: Scalars['String'];
  subject: Scalars['String'];
};

export type EndfinNotificationPolicyEntity = {
  __typename?: 'endfinNotificationPolicyEntity';
  accountId: Scalars['String'];
  id: Scalars['String'];
  notificationDuration: Scalars['Float'];
  permissionId: Scalars['Float'];
  userId: Scalars['String'];
};

export type EndfinNotificationRecipientEntity = AuditEntity & {
  __typename?: 'endfinNotificationRecipientEntity';
  accountId: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  endfinNotification: EndfinNotificationEntity;
  id: Scalars['String'];
  isRead: Scalars['Boolean'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  notificationId: Scalars['String'];
  projectId: Scalars['String'];
  recipientId: Scalars['String'];
};

export type EndFinPaymentPlan = {
  __typename?: 'endFinPaymentPlan';
  glAccountCode?: Maybe<Scalars['String']>;
  glAccountId?: Maybe<Scalars['String']>;
  glType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  table?: Maybe<Scalars['String']>;
};

export type EndfinProjectFinancierEntity = {
  __typename?: 'endfinProjectFinancierEntity';
  accountId: Scalars['String'];
  assignedDate: Scalars['DateTime'];
  commonStatus: Scalars['String'];
  financialLimit: Scalars['Float'];
  financier: FinancierEntity;
  financierCommonStatus: Scalars['String'];
  financierId: Scalars['String'];
  financierInfo: FinancierEntity;
  financierStatus: Scalars['Boolean'];
  id: Scalars['String'];
  interestRate?: Maybe<Scalars['Float']>;
  isPanel: Scalars['Boolean'];
  project: ProjectEntity;
  projectId: Scalars['String'];
};

export type EndfinUserEntity = {
  __typename?: 'endfinUserEntity';
  accessToken?: Maybe<Scalars['String']>;
  activated: Scalars['Boolean'];
  assignedLoanCount?: Maybe<LoanAssignedCountOutput>;
  commonStatus: Scalars['String'];
  contact?: Maybe<EndfinContactEntity>;
  endfinContacts: EndfinContactEntity;
  endfinLoanApps: Array<EndfinLoanAppEntity>;
  endfinUserRoles: EndfinUserRoleEntity;
  forgotPasswordLink?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  loginId: Scalars['String'];
  passwordHash?: Maybe<Scalars['String']>;
  projectLoanCount?: Maybe<Array<LoanProjectCountOutput>>;
  refreshToken?: Maybe<Scalars['String']>;
  userRole?: Maybe<EndfinUserRoleEntity>;
};

export type EndfinUserRoleEntity = {
  __typename?: 'endfinUserRoleEntity';
  commonStatus: Scalars['String'];
  financier: EndfinFinancierEntity;
  financierId: Scalars['String'];
  id: Scalars['String'];
  role: Scalars['String'];
  user: EndfinUserEntity;
  userId: Scalars['String'];
};

export type EntityRoleUserAssignmentEntity = AuditEntity & {
  __typename?: 'entityRoleUserAssignmentEntity';
  accountId: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  entityId: Scalars['String'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  roleId: Scalars['String'];
  userId: Scalars['String'];
};

/** JsonType */
export type EnvironmentUrl = {
  __typename?: 'EnvironmentUrl';
  environment?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type EnvironmentUrlInput = {
  environment?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type ESignProjectLetterListingOutput = {
  __typename?: 'ESignProjectLetterListingOutput';
  defaulted?: Maybe<Scalars['Boolean']>;
  letterTemplateId?: Maybe<Scalars['String']>;
  letterType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type EventOutput = {
  __typename?: 'eventOutput';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type EventPerformanceBiOutput = {
  __typename?: 'EventPerformanceBIOutput';
  booked?: Maybe<Scalars['Float']>;
  budget: Scalars['Float'];
  cancelled?: Maybe<Scalars['Float']>;
  cold?: Maybe<Scalars['Float']>;
  converted?: Maybe<Scalars['Float']>;
  drop?: Maybe<Scalars['Float']>;
  endDate: Scalars['DateTime'];
  hot?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  leads?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  open?: Maybe<Scalars['Float']>;
  repeat?: Maybe<Scalars['Float']>;
  signed?: Maybe<Scalars['Float']>;
  startDate: Scalars['DateTime'];
  total: Scalars['String'];
  unconverted?: Maybe<Scalars['Float']>;
  wait?: Maybe<Scalars['Float']>;
};

export type EventsEntity = {
  __typename?: 'eventsEntity';
  accountId: Scalars['String'];
  budget: Scalars['Float'];
  campaign: CampaignEntity;
  campaignId: Scalars['String'];
  commonStatus?: Maybe<Scalars['String']>;
  desc?: Maybe<Scalars['String']>;
  endDate: Scalars['DateTime'];
  id: Scalars['String'];
  location: Scalars['String'];
  name: Scalars['String'];
  startDate: Scalars['DateTime'];
  website: Scalars['String'];
};

export type ExchangeLog = {
  __typename?: 'ExchangeLog';
  exchangeRate?: Maybe<Scalars['Float']>;
  modBy?: Maybe<Scalars['String']>;
  modTs?: Maybe<Scalars['DateTime']>;
};

export type ExchangeLogInput = {
  exchangeRate?: InputMaybe<Scalars['Float']>;
  modBy?: InputMaybe<Scalars['String']>;
  modTs?: InputMaybe<Scalars['DateTime']>;
};

export type FbData = {
  __typename?: 'fbData';
  fbList?: Maybe<Fdata>;
  totalFBamount?: Maybe<Scalars['Float']>;
};

export type Fdata = {
  __typename?: 'fdata';
  financier_code?: Maybe<Scalars['String']>;
  financier_name?: Maybe<Scalars['String']>;
};

export type FieldError = {
  __typename?: 'FieldError';
  field: Scalars['String'];
  message: Scalars['String'];
};

export type FinancialBillingEntity = {
  __typename?: 'financialBillingEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  documentAmount?: Maybe<Scalars['Float']>;
  financierId: Scalars['String'];
  id: Scalars['String'];
  principalAmt: Scalars['Float'];
  progressBilling?: Maybe<ProgressBillingEntity>;
  progressBillingId: Scalars['String'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  saleLoan?: Maybe<SaleLoanEntity>;
  saleLoanId: Scalars['String'];
  taxAmount?: Maybe<Scalars['Float']>;
};

export type FinancialBillingInput = {
  amount: Scalars['Float'];
  financierId: Scalars['String'];
  progressBillingId: Scalars['String'];
  project_id: Scalars['String'];
  sale_id: Scalars['String'];
  saleLoanId: Scalars['String'];
};

export type Financier = {
  __typename?: 'financier';
  financierCode?: Maybe<Scalars['String']>;
  financierLogo?: Maybe<Scalars['String']>;
  financierName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type FinancierBankListOutput = {
  __typename?: 'financierBankListOutput';
  bankList?: Maybe<Array<BankAccountList>>;
  financierList?: Maybe<Array<FinancierList>>;
};

export type FinancierContact = {
  email: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  phoneNo: Scalars['String'];
};

export type FinancierContactEntity = {
  __typename?: 'financierContactEntity';
  email: Scalars['String'];
  financier: FinancierEntity;
  financierId: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  phoneNo: Scalars['String'];
};

export type FinancierContacts = {
  __typename?: 'financierContacts';
  default?: Maybe<Scalars['Boolean']>;
  email: Scalars['String'];
  id: Scalars['String'];
  invitationDate?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  phoneNo: Scalars['String'];
};

export type FinancierData = {
  __typename?: 'financierData';
  financierId: Scalars['String'];
  financierName: Scalars['String'];
};

export type FinancierDetailsOutput = {
  __typename?: 'FinancierDetailsOutput';
  FinancierAddress?: Maybe<Scalars['String']>;
  FinancierEmail?: Maybe<Scalars['String']>;
  FinancierLawyerAddress?: Maybe<Scalars['String']>;
  FinancierLawyerEmail?: Maybe<Scalars['String']>;
  FinancierLawyerName?: Maybe<Scalars['String']>;
  FinancierLawyerPhone?: Maybe<Scalars['String']>;
  FinancierLawyerReferenceNo?: Maybe<Scalars['String']>;
  FinancierName?: Maybe<Scalars['String']>;
  FinancierPhone?: Maybe<Scalars['String']>;
  FinancierReferenceNo?: Maybe<Scalars['String']>;
};

export type FinancierEntity = {
  __typename?: 'financierEntity';
  accountId: Scalars['String'];
  address?: Maybe<AddressJson>;
  assignedProjectCount: Scalars['Float'];
  bank?: Maybe<CompanyBankAccountEntity>;
  bankId?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  collection?: Maybe<Array<SaleLoanEntity>>;
  commonStatus: Scalars['String'];
  country?: Maybe<Scalars['String']>;
  disbursementFinancierId?: Maybe<Scalars['String']>;
  endfinLoanApps: Array<EndfinLoanAppEntity>;
  endfinProjectFinanciers: Array<EndfinProjectFinancierEntity>;
  financialLimit?: Maybe<Scalars['Float']>;
  financier: EndfinFinancierEntity;
  financierCode?: Maybe<Scalars['String']>;
  financierContact: Array<FinancierContactEntity>;
  financierId?: Maybe<Scalars['String']>;
  financierLastUpdate?: Maybe<Scalars['DateTime']>;
  financierTotalLoanAmount?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  isExistInTransactionData: Array<Scalars['String']>;
  loanCount: Scalars['Float'];
  loanNumberCount?: Maybe<Scalars['Float']>;
  logoUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  officeTel?: Maybe<Scalars['String']>;
  projectInvitation?: Maybe<Array<FinancierProject>>;
  projectLoanNumberCount?: Maybe<Scalars['Float']>;
  receiptReversal?: Maybe<Array<ReceiptReversalEntity>>;
  saleLoan?: Maybe<Array<SaleLoanEntity>>;
  saleLoanRelease: Array<SaleLoanReleaseEntity>;
  state?: Maybe<Scalars['String']>;
};

export type FinancierInput = {
  address?: InputMaybe<AddressJsonInput>;
  bank?: InputMaybe<Scalars['String']>;
  contacts?: InputMaybe<Array<FinancierContact>>;
  disbursementFinancierId?: InputMaybe<Scalars['String']>;
  financierCode?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  logo?: InputMaybe<Scalars['Upload']>;
  name: Scalars['String'];
  officeTel?: InputMaybe<Scalars['String']>;
};

export type FinancierList = {
  __typename?: 'financierList';
  financierCode?: Maybe<Scalars['String']>;
  financierId: Scalars['String'];
  financierName: Scalars['String'];
};

export type FinancierListInput = {
  doaDate: Scalars['DateTime'];
  doaSolicitorId: Scalars['String'];
  doaSolicitorReferenceNo: Scalars['String'];
  financierId: Scalars['String'];
  financierReferenceNo: Scalars['String'];
  loanAgreementDate: Scalars['DateTime'];
  loanAmount: Scalars['Float'];
  loanSeqNo: Scalars['Float'];
  loanSolicitorId: Scalars['String'];
  loanSolicitorReferenceNo: Scalars['String'];
  rrDate: Scalars['DateTime'];
  rrSolicitorId: Scalars['String'];
  rrSolicitorReferenceNo: Scalars['String'];
};

export type FinancierListOutput = {
  __typename?: 'financierListOutput';
  doaDate: Scalars['String'];
  doaSolicitorId: Scalars['String'];
  doaSolicitorName: Scalars['String'];
  doaSolicitorReference: Scalars['String'];
  financierId: Scalars['String'];
  financierName: Scalars['String'];
  financierReference: Scalars['String'];
  loanAgreementDate: Scalars['String'];
  loanAmount: Scalars['String'];
  loanSeqNo: Scalars['String'];
  loanSolicitorId: Scalars['String'];
  loanSolicitorName: Scalars['String'];
  loanSolicitorReference: Scalars['String'];
  refinancingId: Scalars['String'];
  rrDate: Scalars['String'];
  rrSolicitorId: Scalars['String'];
  rrSolicitorName: Scalars['String'];
  rrSolicitorReference: Scalars['String'];
};

export type FinancierLists = {
  __typename?: 'financierLists';
  financierName: Scalars['String'];
  newFinancierId: Scalars['String'];
};

export type FinancierPanelDetails = {
  __typename?: 'financierPanelDetails';
  address?: Maybe<AddressJson>;
  endfinFinancierId?: Maybe<Scalars['String']>;
  financierContact: Array<FinancierContacts>;
  id: Scalars['String'];
  name: Scalars['String'];
  officeTel?: Maybe<Scalars['String']>;
};

export type FinancierPaymentAllocateDetailOutput = {
  __typename?: 'financierPaymentAllocateDetailOutput';
  allocateAmt?: Maybe<Scalars['Float']>;
  docDate?: Maybe<Scalars['String']>;
  docNo?: Maybe<Scalars['String']>;
  docRef?: Maybe<Scalars['String']>;
  unitNo: Scalars['String'];
};

export type FinancierPaymentBillingOutput = {
  __typename?: 'financierPaymentBillingOutput';
  allocateDetail?: Maybe<Array<FinancierPaymentAllocateDetailOutput>>;
  bankAccount: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  docDate: Scalars['DateTime'];
  docRef?: Maybe<Scalars['String']>;
  financierName: Scalars['String'];
  generationBatchId: Scalars['String'];
  getBankPaymentAttachment?: Maybe<Array<AttachmentEntity>>;
  receiptIds: Array<Scalars['String']>;
  status: Scalars['String'];
  totalDocAmt: Scalars['Float'];
};

export type FinancierProject = {
  __typename?: 'FinancierProject';
  invitation: Array<Contact>;
  projectId: Scalars['String'];
};

export type FinancierProjectStaff = {
  __typename?: 'financierProjectStaff';
  name?: Maybe<Scalars['String']>;
};

export type FinancierStaff = {
  __typename?: 'financierStaff';
  common_status: Scalars['String'];
  email: Scalars['String'];
  name: Scalars['String'];
  phone_no: Scalars['String'];
  role: Scalars['String'];
  user_id: Scalars['String'];
};

export type FinancierUnitMortgage = {
  __typename?: 'financierUnitMortgage';
  financierName?: Maybe<Scalars['String']>;
  interestRate?: Maybe<Scalars['Float']>;
};

export type FloorByBlockOutput = {
  __typename?: 'floorByBlockOutput';
  availableUnitCount?: Maybe<Scalars['Float']>;
  cellList?: Maybe<Array<Scalars['String']>>;
  floorList?: Maybe<Array<FloorList>>;
  signUnitCount?: Maybe<Scalars['Float']>;
  soldUnitCount?: Maybe<Scalars['Float']>;
  unavailableUnitCount?: Maybe<Scalars['Float']>;
};

export type FloorGalleryOutput = {
  __typename?: 'FloorGalleryOutput';
  block: Scalars['String'];
  blockFloor: Scalars['String'];
  caption?: Maybe<Scalars['String']>;
  floor: Scalars['Float'];
  pictureid: Scalars['String'];
  resourceid: Scalars['String'];
  seqno: Scalars['Float'];
  url: Scalars['String'];
};

export type FloorList = {
  __typename?: 'floorList';
  floorLabel: Scalars['String'];
  unitList: Array<UnitFloorList>;
};

export type FloorListingOutput = {
  __typename?: 'floorListingOutput';
  floor?: Maybe<Scalars['Float']>;
  floorLabel?: Maybe<Scalars['String']>;
  totalUnit?: Maybe<Scalars['Float']>;
  unitList?: Maybe<Array<UnitListingOutput>>;
};

export type FloorOutput = {
  __typename?: 'FloorOutput';
  ActiveUnit?: Maybe<Array<UnitEntity>>;
  block: Scalars['String'];
  floor: Scalars['Float'];
  floorlabel: Scalars['String'];
  isSubProduct: Scalars['Boolean'];
  projectid: Scalars['String'];
  Unit?: Maybe<Array<UnitEntity>>;
};

export type FormChangesInput = {
  data: Scalars['JSONObject'];
  method: Scalars['String'];
  module: Scalars['String'];
};

export type GenerateMiscBillingInput = {
  billingDate: Scalars['DateTime'];
  creditTerm: Scalars['Float'];
  interestRate: Scalars['Float'];
  projectMiscBillingData: Array<Scalars['String']>;
  status: Scalars['String'];
  unitId: Array<Scalars['String']>;
};

export type GeneratePaymentReminderOutput = {
  __typename?: 'generatePaymentReminderOutput';
  outstanding: Scalars['Float'];
  reminder1: Scalars['Float'];
  reminder2: Scalars['Float'];
  reminder3: Scalars['Float'];
  reminderList?: Maybe<Array<PaymentReminderOutput>>;
};

export type GeneratePaymentRemindersOutput = {
  __typename?: 'generatePaymentRemindersOutput';
  reminderList: Array<PaymentReminder>;
};

export type GenerateProgressBillingBasicInput = {
  billingDate: Scalars['DateTime'];
  creditTerm: Scalars['Float'];
  pbIdList: Array<Scalars['String']>;
};

export type GenerateProgressBillingDetailInput = {
  progressBillingId: Array<Scalars['String']>;
  saleId: Scalars['String'];
};

export type GenerateUnitBasicInput = {
  blockNumber: Scalars['String'];
  bookingFee?: InputMaybe<Scalars['Float']>;
  bottomPrice?: InputMaybe<Scalars['Float']>;
  builtUpArea: Scalars['Float'];
  clusterId?: InputMaybe<Scalars['String']>;
  direction?: InputMaybe<Scalars['String']>;
  floorList: Array<Scalars['Float']>;
  isSubproduct?: InputMaybe<Scalars['Boolean']>;
  listPrice: Scalars['Float'];
  paymentPlan?: InputMaybe<Scalars['String']>;
  prefix?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
  propertyType: Scalars['String'];
  specialList?: InputMaybe<Array<SpecialListInput>>;
  specialUnitList?: InputMaybe<Array<SpecialUnitListInput>>;
  taxSchemeId?: InputMaybe<Scalars['String']>;
  unitLayout: Scalars['String'];
  unitList: Array<Scalars['String']>;
  unitType: Scalars['String'];
};

export type GenerateUnitInput = {
  actualBuiltUpArea?: InputMaybe<Scalars['Float']>;
  actualLandArea?: InputMaybe<Scalars['Float']>;
  address?: InputMaybe<AddressJsonInput>;
  blockNumber: Scalars['String'];
  bookingFee?: InputMaybe<Scalars['Float']>;
  bottomPrice?: InputMaybe<Scalars['Float']>;
  builtUpArea: Scalars['Float'];
  cellingHeight?: InputMaybe<Scalars['String']>;
  clusterId?: InputMaybe<Scalars['String']>;
  direction?: InputMaybe<Scalars['String']>;
  district?: InputMaybe<Scalars['String']>;
  dlpDate1?: InputMaybe<Scalars['DateTime']>;
  dlpDate2?: InputMaybe<Scalars['DateTime']>;
  dlpExpiryDate?: InputMaybe<Scalars['DateTime']>;
  extraLandArea?: InputMaybe<Scalars['Float']>;
  floorList: Array<Scalars['Float']>;
  hsdHsmNo?: InputMaybe<Scalars['String']>;
  isSubproduct?: InputMaybe<Scalars['Boolean']>;
  landArea?: InputMaybe<Scalars['String']>;
  landRate?: InputMaybe<Scalars['Float']>;
  lawyerId?: InputMaybe<Scalars['String']>;
  leasePejakanNegeri?: InputMaybe<Scalars['String']>;
  listPrice: Scalars['Float'];
  lotPtNo?: InputMaybe<Scalars['String']>;
  masterGrantNo?: InputMaybe<Scalars['String']>;
  noOfKey?: InputMaybe<Scalars['Float']>;
  noOfStorey?: InputMaybe<Scalars['Float']>;
  paymentPlan?: InputMaybe<Scalars['String']>;
  prefix?: InputMaybe<Scalars['String']>;
  premium?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
  propertyType: Scalars['String'];
  remark?: InputMaybe<Scalars['String']>;
  scheduleLaunchDate?: InputMaybe<Scalars['DateTime']>;
  shareValue?: InputMaybe<Scalars['String']>;
  specialList?: InputMaybe<Array<SpecialListInput>>;
  specialUnitList?: InputMaybe<Array<SpecialUnitListInput>>;
  stakeholder?: InputMaybe<Scalars['String']>;
  stampDutyWaiver?: InputMaybe<Scalars['Boolean']>;
  subdivisionMukim?: InputMaybe<Scalars['String']>;
  taxSchemeId?: InputMaybe<Scalars['String']>;
  unitLayout: Scalars['String'];
  unitList: Array<Scalars['String']>;
  unitType: Scalars['String'];
  unitView?: InputMaybe<Scalars['String']>;
  usableArea?: InputMaybe<Scalars['Float']>;
  vpBillingDate?: InputMaybe<Scalars['DateTime']>;
  vpLetterDate?: InputMaybe<Scalars['DateTime']>;
};

export type GenerateUnitOutput = {
  __typename?: 'generateUnitOutput';
  cellLabel: Scalars['String'];
  floorLabel: Scalars['String'];
  unitNo: Scalars['String'];
};

export type GenerationBatchPostingInput = {
  creditTerm: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  generationBatchId: Scalars['String'];
};

export type GetAddressListByContactOutput = {
  __typename?: 'getAddressListByContactOutput';
  addressList?: Maybe<AddressJson>;
  contactId?: Maybe<Scalars['String']>;
};

export type GetApprovedLoanRescheduleListOutput = {
  __typename?: 'getApprovedLoanRescheduleListOutput';
  baseamt?: Maybe<Scalars['Float']>;
  billtype?: Maybe<Scalars['String']>;
  commonstatus?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  documentamount?: Maybe<Scalars['Float']>;
  documentdate?: Maybe<Scalars['DateTime']>;
  expiredate?: Maybe<Scalars['DateTime']>;
  expiryby?: Maybe<Scalars['String']>;
  installmentid?: Maybe<Scalars['String']>;
  isbuyerportion?: Maybe<Scalars['Boolean']>;
  isselected?: Maybe<Scalars['Boolean']>;
  ledgertype?: Maybe<Scalars['String']>;
  oldinstallmentid?: Maybe<Scalars['String']>;
  rescheduledate?: Maybe<Scalars['DateTime']>;
  rescheduleid?: Maybe<Scalars['String']>;
  rescheduleno?: Maybe<Scalars['String']>;
  taxamt?: Maybe<Scalars['Float']>;
  unallocatedamount?: Maybe<Scalars['Float']>;
};

export type GetApprovedRescheduleListOutput = {
  __typename?: 'getApprovedRescheduleListOutput';
  baseamt?: Maybe<Scalars['Float']>;
  billtype?: Maybe<Scalars['String']>;
  commonstatus?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  documentamount?: Maybe<Scalars['Float']>;
  documentdate?: Maybe<Scalars['DateTime']>;
  expiredate?: Maybe<Scalars['DateTime']>;
  expiryby?: Maybe<Scalars['String']>;
  installmentid?: Maybe<Scalars['String']>;
  isbuyerportion?: Maybe<Scalars['Boolean']>;
  isselected?: Maybe<Scalars['Boolean']>;
  ledgertype?: Maybe<Scalars['String']>;
  oldinstallmentid?: Maybe<Scalars['String']>;
  rescheduledate?: Maybe<Scalars['DateTime']>;
  rescheduleid?: Maybe<Scalars['String']>;
  rescheduleno?: Maybe<Scalars['String']>;
  taxamt?: Maybe<Scalars['Float']>;
  unallocatedamount?: Maybe<Scalars['Float']>;
};

export type GetInstallmentPendingListOutput = {
  __typename?: 'getInstallmentPendingListOutput';
  accountId: Scalars['String'];
  approvalStatus?: Maybe<Array<ApprovalStatusOutput>>;
  baseAmt?: Maybe<Scalars['Float']>;
  billType?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  documentAmt?: Maybe<Scalars['Float']>;
  documentDate?: Maybe<Scalars['DateTime']>;
  documentNo?: Maybe<Scalars['String']>;
  glGenerated?: Maybe<Scalars['String']>;
  glGenerationBatch?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  interestRate?: Maybe<Scalars['Float']>;
  ledgerType?: Maybe<Scalars['String']>;
  oldInstallmentId?: Maybe<Scalars['String']>;
  projectId: Scalars['String'];
  rescheduleDetailId?: Maybe<Scalars['String']>;
  rescheduleId?: Maybe<Scalars['String']>;
  sale: SaleEntity;
  saleId: Scalars['String'];
  salePaymentId?: Maybe<Scalars['String']>;
  salesPaymentPlan: SalesPaymentPlanEntity;
  taxAmt?: Maybe<Scalars['Float']>;
  transDate?: Maybe<Scalars['DateTime']>;
  unallocatedamount?: Maybe<Scalars['Float']>;
  unallocatedAmount?: Maybe<Scalars['Float']>;
};

export type GetLoanReleaseListingOutput = {
  __typename?: 'getLoanReleaseListingOutput';
  amtPerPaymentPlan: Scalars['String'];
  approvalStatus: Scalars['String'];
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  docNo?: Maybe<Scalars['String']>;
  endFinancierMortgageId: Scalars['String'];
  endfinMortgagePaymentPlanId?: Maybe<Scalars['String']>;
  endfinMortgageRetentionId?: Maybe<Scalars['String']>;
  financier?: Maybe<FinancierEntity>;
  financierId: Scalars['String'];
  id: Scalars['String'];
  isPaid: Scalars['Boolean'];
  isSaleLoanPayment: Scalars['Boolean'];
  isSaleLoanRefinancing: Scalars['Boolean'];
  mortgagePayment?: Maybe<MortgagePaymentEntity>;
  mortgagePlan?: Maybe<MortgagePlanEntity>;
  mortgageRetention?: Maybe<MortgageRetentionEntity>;
  releaseDate?: Maybe<Scalars['DateTime']>;
  saleLoanPaymentPlanDetails?: Maybe<Array<SaleLoanNotice>>;
  submittedBy?: Maybe<Scalars['String']>;
  submittedDate?: Maybe<Scalars['DateTime']>;
};

export type GetNupOutput = {
  __typename?: 'getNupOutput';
  agentName: Scalars['String'];
  amount: Scalars['Float'];
  cluster: Scalars['String'];
  code: Scalars['String'];
  contact?: Maybe<ContactNupJson>;
  contactId: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  expiredDate: Scalars['DateTime'];
  id: Scalars['String'];
  ktpUrl?: Maybe<Scalars['String']>;
  media: Scalars['String'];
  npwpUrl?: Maybe<Scalars['String']>;
  nupNumber?: Maybe<Scalars['String']>;
  paymentUrl?: Maybe<Scalars['String']>;
  reason: Scalars['String'];
  rejectedBy?: Maybe<Scalars['String']>;
  rejectedTs?: Maybe<Scalars['DateTime']>;
  remarks: Scalars['String'];
  reservedDate: Scalars['DateTime'];
  status: Scalars['String'];
  type: Scalars['String'];
  unitId: Scalars['String'];
  unitNo: Scalars['String'];
};

export type GetOverdueAgingOutputs = {
  __typename?: 'getOverdueAgingOutputs';
  agingId?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['String']>;
  period1?: Maybe<Scalars['Float']>;
  period2?: Maybe<Scalars['Float']>;
  period3?: Maybe<Scalars['Float']>;
  period4?: Maybe<Scalars['Float']>;
  period5?: Maybe<Scalars['Float']>;
  period6?: Maybe<Scalars['Float']>;
  projectId?: Maybe<Scalars['String']>;
};

export type GetOverdueInstallmentDetailsOutput = {
  __typename?: 'getOverdueInstallmentDetailsOutput';
  carparkInstallment?: Maybe<Array<OverduePurchaserInstallmentOutput>>;
  debitNote?: Maybe<Array<OverduePurchaserInstallmentOutput>>;
  installment?: Maybe<Array<OverduePurchaserInstallmentOutput>>;
  lateInterest?: Maybe<Array<OverduePurchaserInstallmentOutput>>;
  miscBilling?: Maybe<Array<OverduePurchaserInstallmentOutput>>;
  packagesInstallment?: Maybe<Array<OverduePurchaserInstallmentOutput>>;
};

export type GetPaIndoPaymentSummaryOutput = {
  __typename?: 'getPAIndoPaymentSummaryOutput';
  data: Array<ReceiptEntity>;
  isHasMore: Scalars['Boolean'];
  totalDataLength: Scalars['Float'];
};

export type GetProjectCommissionByIdOutput = {
  __typename?: 'GetProjectCommissionByIdOutput';
  commissionTypeId: Scalars['ID'];
  description: Scalars['String'];
  id: Scalars['ID'];
  rateClassification: Scalars['String'];
};

export type GetProjectCommissionsOutput = {
  __typename?: 'GetProjectCommissionsOutput';
  canEditOrDelete: Scalars['Boolean'];
  commissionPayments: Array<CommissionPaymentOutput>;
  description: Scalars['String'];
  id: Scalars['ID'];
  interval: Scalars['Float'];
  payOutType: Scalars['String'];
  rateClassification: Scalars['String'];
  targetBy: Scalars['String'];
};

export type GetPurchaserNameByIdOutput = {
  __typename?: 'getPurchaserNameByIdOutput';
  adminFee: Scalars['Float'];
  buyerList?: Maybe<Array<BuyerListOutput>>;
  documentAmount?: Maybe<Scalars['Float']>;
  documentNo: Scalars['String'];
  email: Scalars['String'];
  fullName: Scalars['String'];
  icNo: Scalars['String'];
  miscBillingId?: Maybe<Scalars['String']>;
  oldContactId: Scalars['String'];
  phoneNo: Scalars['String'];
  purchaserNameTransferId?: Maybe<Scalars['String']>;
  saleId: Scalars['String'];
  salesConvertedStatus: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  unitClusterId: Scalars['String'];
  unitId: Scalars['String'];
  unitNo: Scalars['String'];
};

export type GetRescheduleDetailsOutput = {
  __typename?: 'getRescheduleDetailsOutput';
  accountId: Scalars['String'];
  baseAmt: Scalars['Float'];
  billType?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  documentDate: Scalars['DateTime'];
  id: Scalars['String'];
  installmentId: Scalars['String'];
  isSelected: Scalars['Boolean'];
  ledgerType: Scalars['String'];
  reschedule: RescheduleEntity;
  rescheduleId: Scalars['String'];
  startDate: Scalars['DateTime'];
  taxAmt: Scalars['Float'];
  unallocatedAmount?: Maybe<Scalars['Float']>;
};

export type GetRescheduleLoanOutput = {
  __typename?: 'getRescheduleLoanOutput';
  billType: Scalars['String'];
  description: Scalars['String'];
  noInstallment: Scalars['Float'];
  premiumAmount: Scalars['Float'];
  projectClusterName: Scalars['String'];
  salesRegistrationNo: Scalars['String'];
  startDate: Scalars['DateTime'];
  submittedBy: Scalars['String'];
  submittedDate: Scalars['DateTime'];
  unitNo: Scalars['String'];
};

export type GetSaleForRegistrationOutput = {
  __typename?: 'getSaleForRegistrationOutput';
  carPark?: Maybe<Array<SaleSubproductEntity>>;
  sale: SaleEntity;
  salePackage?: Maybe<Array<SalePackageEntity>>;
  unitClusterNo: Scalars['String'];
  unitExtension: UnitExtensionEntity;
};

export type GetSaleLoanCancellationDetailOutput = {
  __typename?: 'getSaleLoanCancellationDetailOutput';
  cancelDate: Scalars['DateTime'];
  cancelReason: Scalars['String'];
  cancelRemark?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  financierDetails?: Maybe<Array<SaleLoanFinancierOutput>>;
  isCompany?: Maybe<Scalars['Boolean']>;
  purchaserName: Scalars['String'];
  saleId: Scalars['String'];
  saleLoanCancellationId: Scalars['String'];
  spaDate?: Maybe<Scalars['DateTime']>;
  unitNo: Scalars['String'];
};

export type GetSaleLoanCancellationDropdownOutput = {
  __typename?: 'getSaleLoanCancellationDropdownOutput';
  companyName?: Maybe<Scalars['String']>;
  financierDetails?: Maybe<Array<SaleLoanFinancierOutput>>;
  isCompany?: Maybe<Scalars['Boolean']>;
  purchaserName: Scalars['String'];
  saleId: Scalars['String'];
  spaDate?: Maybe<Scalars['DateTime']>;
  unitNo: Scalars['String'];
};

export type GetSaleLoanDetailOutput = {
  __typename?: 'getSaleLoanDetailOutput';
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  approvedName?: Maybe<Scalars['String']>;
  docNo?: Maybe<Scalars['String']>;
  financierId: Scalars['String'];
  financierName: Scalars['String'];
  mortgageId: Scalars['String'];
  mortgageName: Scalars['String'];
  paymentId?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  paymentPercentage?: Maybe<Scalars['Float']>;
  releaseDate?: Maybe<Scalars['DateTime']>;
  retentionBy?: Maybe<Scalars['String']>;
  retentionId?: Maybe<Scalars['String']>;
  retentionName?: Maybe<Scalars['String']>;
  retentionValue?: Maybe<Scalars['Float']>;
  saleLoanPaymentId: Scalars['String'];
  saleLoanPaymentPlanDetails?: Maybe<Array<SaleLoanReleasePaymentPlanDetailsOutput>>;
  submittedBy?: Maybe<Scalars['String']>;
  submittedDate?: Maybe<Scalars['DateTime']>;
  submittedName?: Maybe<Scalars['String']>;
  totalApproveAmt?: Maybe<Scalars['Float']>;
};

export type GetSaleLoanListingOutput = {
  __typename?: 'getSaleLoanListingOutput';
  approvalRoleId?: Maybe<Scalars['String']>;
  approvalStatus: Scalars['String'];
  cancelDate: Scalars['DateTime'];
  cancelReason: Scalars['String'];
  id: Scalars['String'];
  saleId: Scalars['String'];
  unitNo: Scalars['String'];
};

export type GetSaleLoanTableListingOutput = {
  __typename?: 'getSaleLoanTableListingOutput';
  apply_amt: Scalars['Float'];
  approved_amt: Scalars['Float'];
  emp_name: Scalars['String'];
  event_statutory_doc_id?: Maybe<Scalars['String']>;
  full_name: Scalars['String'];
  is_refinanced: Scalars['Boolean'];
  sale_id: Scalars['String'];
  sale_loan_amount?: Maybe<Scalars['String']>;
  sale_loan_id: Scalars['String'];
  sale_loan_payment_plan_id?: Maybe<Scalars['String']>;
  table_ref?: Maybe<Scalars['String']>;
  unit_no: Scalars['String'];
  unit_statutory_document_id?: Maybe<Scalars['String']>;
};

export type GetUnitTransferPricingPaymentPlanInput = {
  finalContractPrice?: InputMaybe<Scalars['Float']>;
  id: Scalars['String'];
  InstallmentSummaryInput?: InputMaybe<Array<InstallmentSummaryInput>>;
  paymentPlanId?: InputMaybe<Scalars['String']>;
  regDate: Scalars['DateTime'];
  taxSchemeId?: InputMaybe<Scalars['String']>;
  unitId: Scalars['String'];
};

export type GetUnitTransferPricingPaymentPlanOutput = {
  __typename?: 'GetUnitTransferPricingPaymentPlanOutput';
  discAmt?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  installmentSummary?: Maybe<Array<InstallmentSummaryOutput>>;
  markUpPercentage?: Maybe<Scalars['Float']>;
  markUpPrice?: Maybe<Scalars['Float']>;
  paymentPlanDate: Scalars['DateTime'];
  paymentPlanId: Scalars['String'];
};

export type GlAccountEntity = {
  __typename?: 'glAccountEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  companyId: Scalars['String'];
  glAccountCode: Scalars['String'];
  glType: Scalars['String'];
  id: Scalars['String'];
  refId: Scalars['String'];
  refTable: Scalars['String'];
};

export enum GlAccountTypeEnum {
  Bank = 'BANK',
  BillItem = 'BILL_ITEM',
  BillItemInt = 'BILL_ITEM_INT',
  BridgingFinancier = 'BRIDGING_FINANCIER',
  CostCentre = 'COST_CENTRE',
  DebtorAccountCode = 'DEBTOR_ACCOUNT_CODE',
  JournalType = 'JOURNAL_TYPE',
  Package = 'PACKAGE',
  Property = 'PROPERTY',
  Tax = 'TAX',
  UnallocatedReceipt = 'UNALLOCATED_RECEIPT'
}

export type GlExportDataOutput = {
  __typename?: 'glExportDataOutput';
  costCentre: Scalars['String'];
  creditAmount: Scalars['Float'];
  debitAmount: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  documentNo: Scalars['String'];
  glAccountCode: Scalars['String'];
  glAccountId: Scalars['String'];
  glTransactionType: Scalars['String'];
  glType: Scalars['String'];
  journalType: Scalars['String'];
  refDescription?: Maybe<Scalars['String']>;
  refId: Scalars['String'];
  refTable: Scalars['String'];
  taxId?: Maybe<Scalars['String']>;
};

export type GlExportEntity = {
  __typename?: 'glExportEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  companyId: Scalars['String'];
  costCentre: Scalars['String'];
  creditAmount: Scalars['Float'];
  debitAmount: Scalars['Float'];
  glAccountCode: Scalars['String'];
  glDate: Scalars['DateTime'];
  glGenerationBatch: Scalars['String'];
  glTransactionType: Scalars['String'];
  glType: Scalars['String'];
  id: Scalars['String'];
  journalType: Scalars['String'];
  posted: Scalars['Boolean'];
  refDescription?: Maybe<Scalars['String']>;
  refDocumentDate: Scalars['DateTime'];
  refDocumentNo: Scalars['String'];
  refId: Scalars['String'];
  refTable: Scalars['String'];
  taxId?: Maybe<Scalars['String']>;
};

export type GlExportInput = {
  companyId: Scalars['String'];
  glDate: Scalars['DateTime'];
  glList: Array<GlExportListInput>;
  submitAction: Scalars['String'];
};

export type GlExportListingOutput = {
  __typename?: 'glExportListingOutput';
  documentNo: Array<Scalars['String']>;
  endDate: Scalars['DateTime'];
  generationBatch: Scalars['String'];
  glDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
  transactionCount: Scalars['Float'];
};

export type GlExportListInput = {
  costCentre: Scalars['String'];
  creditAmount: Scalars['Float'];
  debitAmount: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  documentNo: Scalars['String'];
  glAccountCode: Scalars['String'];
  glAccountId: Scalars['String'];
  glTransactionType: Scalars['String'];
  glType: Scalars['String'];
  journalType: Scalars['String'];
  refDescription?: InputMaybe<Scalars['String']>;
  refId: Scalars['String'];
  refTable: Scalars['String'];
  taxId?: InputMaybe<Scalars['String']>;
};

export type GlJournalDownloadProps = {
  __typename?: 'glJournalDownloadProps';
  base64?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
};

export type GlJournalPostStatus = {
  __typename?: 'glJournalPostStatus';
  base64?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  postStatus: Scalars['Boolean'];
};

export type GlRevenueMapping = {
  __typename?: 'GLRevenueMapping';
  ExpenseCredit?: Maybe<Scalars['String']>;
  ExpenseDebit?: Maybe<Scalars['String']>;
  ExpenseDept?: Maybe<Scalars['String']>;
  ExpenseDiv?: Maybe<Scalars['String']>;
  modBy?: Maybe<Scalars['String']>;
  modTs?: Maybe<Scalars['DateTime']>;
  RevenueCredit?: Maybe<Scalars['String']>;
  RevenueDebit?: Maybe<Scalars['String']>;
  RevenueDept?: Maybe<Scalars['String']>;
  RevenueDiv?: Maybe<Scalars['String']>;
  ReverseCredit?: Maybe<Scalars['String']>;
  ReverseDebit?: Maybe<Scalars['String']>;
  ReverseDept?: Maybe<Scalars['String']>;
  ReverseDiv?: Maybe<Scalars['String']>;
};

export type GlRevenueMappingInput = {
  ExpenseCredit?: InputMaybe<Scalars['String']>;
  ExpenseDebit?: InputMaybe<Scalars['String']>;
  ExpenseDept?: InputMaybe<Scalars['String']>;
  ExpenseDiv?: InputMaybe<Scalars['String']>;
  modBy?: InputMaybe<Scalars['String']>;
  modTs?: InputMaybe<Scalars['DateTime']>;
  RevenueCredit?: InputMaybe<Scalars['String']>;
  RevenueDebit?: InputMaybe<Scalars['String']>;
  RevenueDept?: InputMaybe<Scalars['String']>;
  RevenueDiv?: InputMaybe<Scalars['String']>;
  ReverseCredit?: InputMaybe<Scalars['String']>;
  ReverseDebit?: InputMaybe<Scalars['String']>;
  ReverseDept?: InputMaybe<Scalars['String']>;
  ReverseDiv?: InputMaybe<Scalars['String']>;
};

export type HuaweiStorageOutput = {
  __typename?: 'HuaweiStorageOutput';
  BucketFileName: Scalars['String'];
  FileName: Scalars['String'];
  IsPrivate?: Maybe<Scalars['Boolean']>;
  MediaType: Scalars['String'];
  PrivateUrl?: Maybe<Scalars['String']>;
  Url: Scalars['String'];
};

export type ImportDocObject = {
  __typename?: 'importDocObject';
  documentDate?: Maybe<Scalars['String']>;
  documentRef?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type ImportLeadDetails = {
  __typename?: 'ImportLeadDetails';
  address?: Maybe<Scalars['String']>;
  annual_income?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  contact_id?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  event_id?: Maybe<Scalars['String']>;
  full_name: Scalars['String'];
  gender_id?: Maybe<Scalars['String']>;
  isContactExisted: Scalars['Boolean'];
  lead_source_id: Scalars['String'];
  marital_id?: Maybe<Scalars['String']>;
  nationality_id?: Maybe<Scalars['String']>;
  phone_no: Scalars['String'];
  postCode?: Maybe<Scalars['String']>;
  prefer_location?: Maybe<Scalars['String']>;
  prefer_property?: Maybe<Scalars['String']>;
  race_id?: Maybe<Scalars['String']>;
  salutation_id?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  utm_campaign?: Maybe<Scalars['String']>;
  utm_content?: Maybe<Scalars['String']>;
  utm_id?: Maybe<Scalars['String']>;
  utm_medium?: Maybe<Scalars['String']>;
  utm_source?: Maybe<Scalars['String']>;
  utm_term?: Maybe<Scalars['String']>;
};

export type ImportStatutoryOutput = {
  __typename?: 'ImportStatutoryOutput';
  cluster_name: Scalars['String'];
  code: Scalars['String'];
  documents: Array<ImportDocObject>;
  purchaser_name?: Maybe<Scalars['String']>;
  seq_no: Scalars['Float'];
  unit_no: Scalars['String'];
};

export type ImportUnitInput = {
  attachments: Scalars['Upload'];
};

export type ImportUnitOptionOutput = {
  __typename?: 'ImportUnitOptionOutput';
  append: Scalars['Boolean'];
  displayImportMethods: Scalars['Boolean'];
  integrated: Scalars['Boolean'];
  overwrite: Scalars['Boolean'];
};

export type InactiveJointBuyerTransferIndoInput = {
  id: Scalars['String'];
  saleId: Scalars['String'];
};

/** JsonType */
export type IncludeInDetail = {
  __typename?: 'includeInDetail';
  paymentPlanDetailId?: Maybe<Scalars['String']>;
};

export type IncludeInDetailInput = {
  paymentPlanDetailId?: InputMaybe<Scalars['String']>;
};

export type IncomeRangeEntity = {
  __typename?: 'incomeRangeEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  contact: Array<ContactEntity>;
  defaulted: Scalars['Boolean'];
  id: Scalars['String'];
  isDeletable: Scalars['Boolean'];
  isExistInMasterData: Array<Scalars['String']>;
  isExistInTransactionData: Array<Scalars['String']>;
  leadContact: Array<LeadContactEntity>;
  range: Scalars['String'];
  sales: Array<SaleEntity>;
  seqNo?: Maybe<Scalars['Float']>;
};

export type IncomeRangeInput = {
  range: Scalars['String'];
  seqNo?: InputMaybe<Scalars['Float']>;
};

export type Installment = {
  __typename?: 'installment';
  description: Scalars['String'];
  documentAmt: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  documentNo: Scalars['String'];
};

export type InstallmentDetail = {
  __typename?: 'installmentDetail';
  baseAmt?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  documentAmt?: Maybe<Scalars['String']>;
  documentDate?: Maybe<Scalars['String']>;
  taxAmt?: Maybe<Scalars['String']>;
};

export type InstallmentDetailInput = {
  baseAmt: Scalars['Float'];
  billType: Scalars['String'];
  carParkId?: InputMaybe<Scalars['String']>;
  carparkPaymentId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  documentAmt: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  installmentId?: InputMaybe<Scalars['String']>;
  interestRate: Scalars['Float'];
  packagesPaymentId?: InputMaybe<Scalars['String']>;
  salePackageId?: InputMaybe<Scalars['String']>;
  seqNo?: InputMaybe<Scalars['String']>;
  taxAmt: Scalars['Float'];
};

export type InstallmentEntity = {
  __typename?: 'installmentEntity';
  accountId: Scalars['String'];
  approvalStatus?: Maybe<Array<ApprovalStatusOutput>>;
  baseAmt?: Maybe<Scalars['Float']>;
  billType?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  documentAmt?: Maybe<Scalars['Float']>;
  documentDate?: Maybe<Scalars['DateTime']>;
  documentNo?: Maybe<Scalars['String']>;
  glGenerated?: Maybe<Scalars['String']>;
  glGenerationBatch?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  interestRate?: Maybe<Scalars['Float']>;
  oldInstallmentId?: Maybe<Scalars['String']>;
  projectId: Scalars['String'];
  rescheduleDetailId?: Maybe<Scalars['String']>;
  rescheduleId?: Maybe<Scalars['String']>;
  sale: SaleEntity;
  saleId: Scalars['String'];
  salePaymentId?: Maybe<Scalars['String']>;
  salesPaymentPlan: SalesPaymentPlanEntity;
  taxAmt?: Maybe<Scalars['Float']>;
  transDate?: Maybe<Scalars['DateTime']>;
  unallocatedAmount?: Maybe<Scalars['Float']>;
};

export type InstallmentListOutput = {
  __typename?: 'InstallmentListOutput';
  baseAmt: Scalars['Float'];
  billType: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  installementDate: Scalars['String'];
  npvAmt: Scalars['Float'];
  payableAmt: Scalars['Float'];
  seqNo: Scalars['Float'];
  taxAmt: Scalars['Float'];
};

export type InstallmentListPaymentReminderOutput = {
  __typename?: 'installmentListPaymentReminderOutput';
  allocateAmt?: Maybe<Scalars['Float']>;
  allocationDate?: Maybe<Scalars['DateTime']>;
  allocSeq?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  documentAmt?: Maybe<Scalars['Float']>;
  documentDate?: Maybe<Scalars['DateTime']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  dueInstallment?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['String']>;
  installmentId?: Maybe<Scalars['String']>;
  intervalDays?: Maybe<Scalars['Float']>;
  orderSeq?: Maybe<Scalars['Float']>;
  outstanding?: Maybe<Scalars['Float']>;
  penaltyAmt?: Maybe<Scalars['Float']>;
  refTable?: Maybe<Scalars['String']>;
  saleIdDrRow?: Maybe<Scalars['Float']>;
};

export type InstallmentSummaryInput = {
  billAfter?: InputMaybe<Scalars['String']>;
  billCount?: InputMaybe<Scalars['Float']>;
  billFreq?: InputMaybe<BillFrequency>;
  billType?: InputMaybe<Scalars['String']>;
  deductBookingFee?: InputMaybe<DeductBookingFee>;
  id: Scalars['String'];
  noInstallment?: InputMaybe<Scalars['Float']>;
  paymentBy?: InputMaybe<PaymentBy>;
  paymentValue?: InputMaybe<Scalars['Float']>;
};

export type InstallmentSummaryOutput = {
  __typename?: 'InstallmentSummaryOutput';
  billAfter: Scalars['String'];
  billCount: Scalars['Float'];
  billFreq: Scalars['String'];
  billType: Scalars['String'];
  deductBookingFee: DeductBookingFee;
  installmentCount?: Maybe<Scalars['Float']>;
  installmentDetails?: Maybe<Array<InstallmentListOutput>>;
  isFixAmt?: Maybe<Scalars['Boolean']>;
  markUpPercentage?: Maybe<Scalars['Float']>;
  paymentPlanDetailsId: Scalars['String'];
  paymentPlanName: Scalars['String'];
  totalPayableAmt?: Maybe<Scalars['Float']>;
};

export type IntegrationDiscountEntity = {
  __typename?: 'integrationDiscountEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  discount: DiscountEntity;
  discountId: Scalars['String'];
  effectiveDate?: Maybe<Scalars['DateTime']>;
  expiredDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  ifcaDiscountId: Scalars['Float'];
  project: ProjectEntity;
  projectId: Scalars['String'];
  projectIntegration: ProjectIntegrationEntity;
};

export type IntegrationPackageEntity = {
  __typename?: 'integrationPackageEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  ifcaPackageId: Scalars['Float'];
  package: PackageEntity;
  packageId: Scalars['String'];
  project: ProjectEntity;
  projectId: Scalars['String'];
};

export type IntegrationSolicitorEntity = {
  __typename?: 'integrationSolicitorEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  ifcaSolicitorId: Scalars['Float'];
  project: ProjectEntity;
  projectIntegration: ProjectIntegrationEntity;
  solicitor: SolicitorAppointedEntity;
  solicitorId: Scalars['String'];
};

export type IntegrationUnitOutput = {
  __typename?: 'IntegrationUnitOutput';
  block: Scalars['String'];
  cell: Scalars['Float'];
  floor: Scalars['Float'];
  floorLabel: Scalars['String'];
  ifcaUnitId: Scalars['Float'];
  unitNo: Scalars['String'];
};

export type IntegrationUnitStatusOutput = {
  __typename?: 'IntegrationUnitStatusOutput';
  crmStatus?: Maybe<Scalars['String']>;
  dotnetPplusStatus: Scalars['String'];
};

export enum InterestBasicRate {
  Daily = 'DAILY',
  DescriptionList = 'DescriptionList',
  GetDescription = 'GetDescription',
  Yearly = 'YEARLY'
}

export type InterestEntity = {
  __typename?: 'interestEntity';
  account_id: Scalars['String'];
  batchId?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  interestAmount: Scalars['String'];
  interestDate: Scalars['DateTime'];
  interestRate: Scalars['String'];
  invoice: LedgerEntity;
  invoiceId: Scalars['String'];
  isWaive: Scalars['Boolean'];
  ledger: LedgerEntity;
  overdueAmount: Scalars['String'];
  overdueDay: Scalars['Float'];
  postedDate?: Maybe<Scalars['DateTime']>;
  project: ProjectEntity;
  sale: SaleEntity;
  trxStatus: Scalars['String'];
};

export type JobPositionEntity = AuditEntity & {
  __typename?: 'jobPositionEntity';
  accountId: Scalars['String'];
  commonStatus?: Maybe<Scalars['String']>;
  companyId: Scalars['String'];
  countOfEmployee: Scalars['Float'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  employeeJobPosition: Array<EmployeeJobPositionEntity>;
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  position: Scalars['String'];
};

export type JobPositionListWithRecentModTs = {
  __typename?: 'JobPositionListWithRecentModTs';
  jobPositions: Array<JobPositionEntity>;
  recentModTs?: Maybe<Scalars['DateTime']>;
};

export type JobPositionOptionOutput = {
  __typename?: 'jobPositionOptionOutput';
  id: Scalars['String'];
  position: Scalars['String'];
};

export type JointBuyerEntity = {
  __typename?: 'jointBuyerEntity';
  commonStatus: Scalars['String'];
  contact: ContactEntity;
  contactId: Scalars['String'];
  id: Scalars['String'];
  ifcaContactId: Scalars['String'];
  ifcaSaleId: Scalars['Float'];
  jointBuyerIdentityNo?: Maybe<Scalars['String']>;
  jointBuyerIdentityType?: Maybe<Scalars['String']>;
  jointBuyerName?: Maybe<Scalars['String']>;
  sale: SaleEntity;
  saleId: Scalars['String'];
  seq_no?: Maybe<Scalars['Float']>;
};

export type JointBuyerInfoForBookingListing = {
  __typename?: 'JointBuyerInfoForBookingListing';
  isJointBuyerInfoRequired?: Maybe<Scalars['Boolean']>;
  saleId?: Maybe<Scalars['String']>;
  totalJointBuyer?: Maybe<Scalars['Float']>;
};

export type JointBuyerOutput = {
  __typename?: 'jointBuyerOutput';
  contactId?: Maybe<Scalars['String']>;
  homeTelJoint?: Maybe<Scalars['String']>;
  jointBuyerId?: Maybe<Scalars['String']>;
  jointBuyerName?: Maybe<Scalars['String']>;
  nameOnTaxJoint?: Maybe<Scalars['String']>;
  officeTelJoint?: Maybe<Scalars['String']>;
  phoneNoJoint?: Maybe<Scalars['String']>;
  professionIdJoint?: Maybe<Scalars['String']>;
  religionIdJoint?: Maybe<Scalars['String']>;
  taxRegistrationAddressJoint?: Maybe<Scalars['String']>;
  taxRegistrationNoJoint?: Maybe<Scalars['String']>;
};

export type JointBuyerParamaterValueOutput = {
  __typename?: 'JointBuyerParamaterValueOutput';
  contact: Scalars['String'];
  incomeRange: Scalars['String'];
  nationality: Scalars['String'];
  race: Scalars['String'];
  salutation: Scalars['String'];
};

export type KeyAppointmentList = {
  __typename?: 'keyAppointmentList';
  alarmVendorId?: Maybe<Scalars['String']>;
  alarmVendorName?: Maybe<Scalars['String']>;
  contactName: Scalars['String'];
  date: Scalars['DateTime'];
  electricalDate?: Maybe<Scalars['DateTime']>;
  electricalRemark?: Maybe<Scalars['String']>;
  electricianId?: Maybe<Scalars['String']>;
  electricianName?: Maybe<Scalars['String']>;
  handOverDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  keyCollectionTimeslotId: Scalars['String'];
  keysCollected?: Maybe<Scalars['Float']>;
  noOfKey?: Maybe<Scalars['Float']>;
  plumberId?: Maybe<Scalars['String']>;
  plumberName?: Maybe<Scalars['String']>;
  saleId: Scalars['String'];
  sanitaryDate?: Maybe<Scalars['DateTime']>;
  sanitaryRemark?: Maybe<Scalars['String']>;
  siteSupervisorId?: Maybe<Scalars['String']>;
  siteSupervisorName?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  time: Scalars['String'];
  unitNo: Scalars['String'];
  userName: Scalars['String'];
};

export type KeyCollectionAppointmentEntity = {
  __typename?: 'keyCollectionAppointmentEntity';
  accountId: Scalars['String'];
  alarmVendorId?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  electricalDate?: Maybe<Scalars['DateTime']>;
  electricalRemark?: Maybe<Scalars['String']>;
  electricianId?: Maybe<Scalars['String']>;
  handOverDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  keyCollectionTimeslot?: Maybe<ProjectKeyCollectionTimeSlotEntity>;
  keyCollectionTimeslotId: Scalars['String'];
  keysCollected?: Maybe<Scalars['Float']>;
  plumberId?: Maybe<Scalars['String']>;
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  sales?: Maybe<SaleEntity>;
  sanitaryDate?: Maybe<Scalars['DateTime']>;
  sanitaryRemark?: Maybe<Scalars['String']>;
  siteSupervisorId?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type KeyCollectionAppointmentInput = {
  alarmVendorId?: InputMaybe<Scalars['String']>;
  electricianId?: InputMaybe<Scalars['String']>;
  keyCollectionTimeslotId: Scalars['String'];
  plumberId?: InputMaybe<Scalars['String']>;
  saleId: Scalars['String'];
  siteSupervisorId?: InputMaybe<Scalars['String']>;
};

export type KeyCollectionAppointmentRescheduleInput = {
  agencyUserReceive?: InputMaybe<Scalars['Boolean']>;
  keyCollectionSalesPersonReceive?: InputMaybe<Scalars['Boolean']>;
  purchaserUserReceive?: InputMaybe<Scalars['Boolean']>;
  salesUserReceive?: InputMaybe<Scalars['Boolean']>;
};

export type KeyCollectionSummaryOutput = {
  __typename?: 'keyCollectionSummaryOutput';
  totalCompletedCount?: Maybe<Scalars['Float']>;
  totalCount?: Maybe<Scalars['Float']>;
};

export type KeyCollectionUnitList = {
  __typename?: 'keyCollectionUnitList';
  fullName: Scalars['String'];
  saleId: Scalars['String'];
  unitId: Scalars['String'];
  unitNo: Scalars['String'];
};

export type LadCalculateGenerateOutput = {
  __typename?: 'ladCalculateGenerateOutput';
  actualFacilityLADAmount: Scalars['Float'];
  actualUnitLADAmount: Scalars['Float'];
  facilityDuesDay: Scalars['Float'];
  saleId: Scalars['String'];
  totalTaxAmount: Scalars['Float'];
  totalUnitFacilityAmount: Scalars['Float'];
  totalUnitFacilityAmountWithoutTax: Scalars['Float'];
  unitDuesDay: Scalars['Float'];
  unitId: Scalars['String'];
  unitNo: Scalars['String'];
};

export type LadDetailListingOutput = {
  __typename?: 'ladDetailListingOutput';
  actualFacilityLADAmount: Scalars['Float'];
  actualUnitLADAmount: Scalars['Float'];
  contraId: Scalars['String'];
  documentNo: Scalars['String'];
  facilityDuesDay: Scalars['Float'];
  isAllocated: Scalars['Boolean'];
  ladId: Scalars['String'];
  saleId: Scalars['String'];
  totalUnitFacilityAmount: Scalars['Float'];
  unitDuesDay: Scalars['Float'];
  unitId: Scalars['String'];
  unitNo: Scalars['String'];
};

export type LadDetailOutput = {
  __typename?: 'ladDetailOutput';
  generationBatchDate: Scalars['DateTime'];
  LADDetailListing: Array<LadDetailListingOutput>;
  totalAllUnitFacilityAmount: Scalars['Float'];
  totalFacilityLadAmount: Scalars['Float'];
  totalUnit: Scalars['Float'];
  totalUnitLadAmount: Scalars['Float'];
};

export type LadEntity = {
  __typename?: 'ladEntity';
  accountId: Scalars['String'];
  byFacilityDate?: Maybe<Scalars['DateTime']>;
  byUnitDate: Scalars['DateTime'];
  commonFacility: Scalars['Boolean'];
  commonStatus: Scalars['String'];
  contraId?: Maybe<Scalars['String']>;
  documentNo?: Maybe<Scalars['String']>;
  facilityDueDays?: Maybe<Scalars['Float']>;
  facilityLadAmount?: Maybe<Scalars['Float']>;
  facilityLadDuration?: Maybe<Scalars['Float']>;
  facilityLadPercent?: Maybe<Scalars['Float']>;
  generationBatch: Scalars['String'];
  generationBatchDate: Scalars['DateTime'];
  id: Scalars['String'];
  isAllocated: Scalars['Boolean'];
  isSimulate: Scalars['Boolean'];
  payoutPercent: Scalars['Float'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  spaPercent: Scalars['Float'];
  startWith: Scalars['String'];
  unitDueDays?: Maybe<Scalars['Float']>;
  unitDuration: Scalars['Float'];
  unitLadAmount: Scalars['Float'];
  unitLadPercent: Scalars['Float'];
  voidBy?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
};

export type LadGenerateOutput = {
  __typename?: 'ladGenerateOutput';
  LADGenerateListing: Array<LadCalculateGenerateOutput>;
  totalAllUnitFacilityAmount: Scalars['Float'];
  totalFacilityLadAmount: Scalars['Float'];
  totalUnit: Scalars['Float'];
  totalUnitLadAmount: Scalars['Float'];
};

export type LadListingOutput = {
  __typename?: 'ladListingOutput';
  facilityLadAmount?: Maybe<Scalars['Float']>;
  generationBatchDate: Scalars['DateTime'];
  generationBatchId: Scalars['String'];
  isSimulate: Scalars['Boolean'];
  totalUnitAndFacilityAmount: Scalars['Float'];
  unitLadAmount: Scalars['Float'];
  unitsByBatchCount: Scalars['Float'];
};

export type LadSimulatedDetailListingOutput = {
  __typename?: 'ladSimulatedDetailListingOutput';
  actualFacilityLADAmount: Scalars['Float'];
  actualUnitLADAmount: Scalars['Float'];
  facilityDuesDay: Scalars['Float'];
  saleId: Scalars['String'];
  totalUnitFacilityAmount: Scalars['Float'];
  unitDuesDay: Scalars['Float'];
  unitId: Scalars['String'];
  unitNo: Scalars['String'];
};

export type LadSimulatedDetailOutput = {
  __typename?: 'ladSimulatedDetailOutput';
  generationBatchDate: Scalars['DateTime'];
  LADDetailListing: Array<LadSimulatedDetailListingOutput>;
  totalAllUnitFacilityAmount: Scalars['Float'];
  totalFacilityLadAmount: Scalars['Float'];
  totalUnit: Scalars['Float'];
  totalUnitLadAmount: Scalars['Float'];
};

export type LadSummaryOutput = {
  __typename?: 'ladSummaryOutput';
  totalAmount?: Maybe<Scalars['Float']>;
  totalCount?: Maybe<Scalars['Float']>;
  totalFacilityAmount?: Maybe<Scalars['Float']>;
  totalUnitAmount?: Maybe<Scalars['Float']>;
};

export enum LadType {
  DescriptionList = 'DescriptionList',
  FirstPaymentDate = 'FIRST_PAYMENT_DATE',
  GetDescription = 'GetDescription',
  SalesDate = 'SALES_DATE',
  SpaDate = 'SPA_DATE',
  StampingDate = 'STAMPING_DATE'
}

export type LanguageNamesOutput = {
  __typename?: 'LanguageNamesOutput';
  langCode?: Maybe<Scalars['String']>;
  langName?: Maybe<Scalars['String']>;
};

export type LanguageOutput = {
  __typename?: 'LanguageOutput';
  fileNames?: Maybe<Array<Scalars['String']>>;
  obj?: Maybe<Scalars['String']>;
};

export type LastEmailSendInput = {
  SendBy: Scalars['String'];
  SendDate: Scalars['DateTime'];
};

export type LastEmailSendOutput = {
  __typename?: 'LastEmailSendOutput';
  SendBy: Scalars['String'];
  SendDate: Scalars['DateTime'];
};

export type LateInterestBySaleIdOutput = {
  __typename?: 'lateInterestBySaleIdOutput';
  allocationDate?: Maybe<Scalars['DateTime']>;
  creditTerm: Scalars['Float'];
  description: Scalars['String'];
  documentAmount: Scalars['Float'];
  documentDate?: Maybe<Scalars['DateTime']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  generateDate: Scalars['DateTime'];
  installmentId?: Maybe<Scalars['String']>;
  interestAmount?: Maybe<Scalars['Float']>;
  interestEndDate?: Maybe<Scalars['DateTime']>;
  interestStartDate?: Maybe<Scalars['DateTime']>;
  outstanding?: Maybe<Scalars['Float']>;
  overdueDay?: Maybe<Scalars['Float']>;
  saleId: Scalars['String'];
  taxSchemeId?: Maybe<Scalars['String']>;
};

export type LateInterestChargesStatus = {
  __typename?: 'lateInterestChargesStatus';
  status: Array<Scalars['String']>;
};

export type LateInterestDetailEntity = {
  __typename?: 'lateInterestDetailEntity';
  accountId: Scalars['String'];
  allocation?: Maybe<Array<AllocationEntity>>;
  allowReversal: Scalars['Boolean'];
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  approveUserData?: Maybe<UserEntity>;
  billItemId: Scalars['String'];
  calculateAmt: Scalars['Float'];
  calculateRate: Scalars['Float'];
  commonStatus: Scalars['String'];
  creditTerm?: Maybe<Scalars['Float']>;
  description: Scalars['String'];
  documentAmount: Scalars['Float'];
  documentDate?: Maybe<Scalars['DateTime']>;
  documentNo?: Maybe<Scalars['String']>;
  documentRef?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  generationBatch?: Maybe<Scalars['String']>;
  generationBatchDate?: Maybe<Scalars['DateTime']>;
  glGenerated: Scalars['String'];
  glGenerationBatch?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  interestAmount: Scalars['Float'];
  interestEndDate?: Maybe<Scalars['DateTime']>;
  interestStartDate: Scalars['DateTime'];
  isIncludeHoliday: Scalars['Boolean'];
  lateInterestId: Scalars['String'];
  overdueDay: Scalars['Float'];
  projectDetail?: Maybe<UserEntity>;
  projectId: Scalars['String'];
  refId: Scalars['String'];
  refTable: Scalars['String'];
  saleId: Scalars['String'];
  sales?: Maybe<SaleEntity>;
  status: Scalars['String'];
  submittedBy?: Maybe<Scalars['String']>;
  submittedDate?: Maybe<Scalars['DateTime']>;
  submitUserData?: Maybe<UserEntity>;
  taxData?: Maybe<TaxSchemeDropdownOutput>;
  unallocatedAmount?: Maybe<Scalars['Float']>;
  voidBy?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
  voidUserData?: Maybe<UserEntity>;
  waiveAmt: Scalars['Float'];
};

export type LateInterestDetailOutput = {
  __typename?: 'lateInterestDetailOutput';
  billingId: Scalars['String'];
  description: Scalars['String'];
  documentAmount: Scalars['Float'];
  documentDate: Scalars['String'];
  documentNo?: Maybe<Scalars['String']>;
  documentRef?: Maybe<Scalars['String']>;
  endDate: Scalars['String'];
  interestAmount: Scalars['Float'];
  lateInterestDocumentNo?: Maybe<Scalars['String']>;
  lateInterestId: Scalars['String'];
  overdueDay: Scalars['String'];
  seqNo: Scalars['String'];
  startDate: Scalars['String'];
  status: Scalars['String'];
  table: Scalars['String'];
};

export type LateInterestEntity = {
  __typename?: 'lateInterestEntity';
  accountId: Scalars['String'];
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  bankAccount?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  description: Scalars['String'];
  documentAmount: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  documentNo?: Maybe<Scalars['String']>;
  glGenerated: Scalars['String'];
  glGenerationBatch?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  status: Scalars['String'];
  submittedBy?: Maybe<Scalars['String']>;
  submittedDate?: Maybe<Scalars['DateTime']>;
  taxSchemeId: Scalars['String'];
  totalNegotiateAmt: Scalars['Float'];
  totalWaiveAmt: Scalars['Float'];
  voidBy?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
};

export type LateInterestInput = {
  enableFloatingInterest?: InputMaybe<Scalars['Boolean']>;
  excludeHolidays?: InputMaybe<Scalars['Boolean']>;
  excludePayment?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  loanGracePeriod: Scalars['Float'];
  loanGracePeriodStartWith: ProjectLateInterestEnum;
  minInterestAmt: Scalars['Float'];
  projectID: Scalars['String'];
  taxSchemeId: Scalars['String'];
};

export type LateInterestList = {
  __typename?: 'lateInterestList';
  billDocumentNo: Scalars['String'];
  billItemId: Scalars['String'];
  calculateAmt: Scalars['Float'];
  calculateRate: Scalars['Float'];
  creditTerm?: Maybe<Scalars['Float']>;
  description: Scalars['String'];
  documentAmount: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  documentRef: Scalars['String'];
  dueDate?: Maybe<Scalars['DateTime']>;
  generationBatch: Scalars['String'];
  generationBatchDate: Scalars['DateTime'];
  interestEndDate: Scalars['DateTime'];
  interestStartDate: Scalars['DateTime'];
  isIncludeHoliday: Scalars['Boolean'];
  overdueDay: Scalars['Float'];
  refId: Scalars['String'];
  refTable: Scalars['String'];
  status: Scalars['String'];
};

export type LateInterestListingOutput = {
  __typename?: 'lateInterestListingOutput';
  amount: Scalars['Float'];
  billingCount: Scalars['Float'];
  generationBatch: Scalars['String'];
  generationBatchDate: Scalars['DateTime'];
  lateInterestId?: Maybe<Array<Scalars['String']>>;
  unitNo: Array<Scalars['String']>;
};

export type LateInterestOutput = {
  __typename?: 'lateInterestOutput';
  bankAccountName?: Maybe<Scalars['String']>;
  bankAccountNo?: Maybe<Scalars['Float']>;
  carParkLateInterest: Array<LateInterestBySaleIdOutput>;
  mainUnitLateInterest: Array<LateInterestBySaleIdOutput>;
  miscBillingLateInterest: Array<LateInterestBySaleIdOutput>;
  packagesLateInterest: Array<LateInterestBySaleIdOutput>;
};

export type LateInterestSummary = {
  __typename?: 'lateInterestSummary';
  totalCharges?: Maybe<Scalars['Float']>;
  totalUnallocated?: Maybe<Scalars['Float']>;
};

export type LateInterestSummaryInfoOutput = {
  __typename?: 'lateInterestSummaryInfoOutput';
  amount: Scalars['Float'];
  lastGenerateDate: Scalars['DateTime'];
};

export type LateInterestSummaryOutput = {
  __typename?: 'lateInterestSummaryOutput';
  billingCount: Scalars['Float'];
  endDate: Scalars['DateTime'];
  lateInterestDetail: Array<LateInterestDetailOutput>;
  saleId: Scalars['String'];
  startDate: Scalars['DateTime'];
  totalDocumentAmount: Scalars['Float'];
  unitNo: Scalars['String'];
};

export type LateListInterestOutput = {
  __typename?: 'LateListInterestOutput';
  accountId: Scalars['String'];
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  bankAccount?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  description: Scalars['String'];
  documentAmount: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  documentNo?: Maybe<Scalars['String']>;
  glGenerated?: Maybe<Scalars['String']>;
  glGenerationBatch?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  status: Scalars['String'];
  submittedBy?: Maybe<Scalars['String']>;
  submittedDate?: Maybe<Scalars['DateTime']>;
  submitUserData?: Maybe<UserEntity>;
  totalCharges: Scalars['Float'];
  totalNegotiateAmt: Scalars['Float'];
  totalUnallocated: Scalars['Float'];
  totalWaiveAmt: Scalars['Float'];
  voidBy?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
};

export type LatePaymentInterestExceptionInput = {
  remark: Scalars['String'];
  saleId: Array<Scalars['String']>;
};

export type LatePaymentInterestExceptionOutput = {
  __typename?: 'latePaymentInterestExceptionOutput';
  companyName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isCompany?: Maybe<Scalars['Boolean']>;
  isVip: Scalars['Boolean'];
  purchaserName: Scalars['String'];
  remark: Scalars['String'];
  unitNo: Scalars['String'];
};

export type Lead3rdpartyIntegrationEntity = {
  __typename?: 'lead3rdpartyIntegrationEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  integrationType: Scalars['String'];
  integrationUrl?: Maybe<Scalars['String']>;
  key: Scalars['String'];
  loginId?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  projectId?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  token?: Maybe<Scalars['String']>;
};

export type Lead3rdPartyIntegrationPostLogEntity = {
  __typename?: 'lead3rdPartyIntegrationPostLogEntity';
  accountId: Scalars['String'];
  body: Scalars['JSONObject'];
  header: Scalars['JSONObject'];
  id: Scalars['String'];
  integrationType: Scalars['String'];
  isSuccess: Scalars['Boolean'];
  modifiedDate?: Maybe<Scalars['DateTime']>;
  projectId?: Maybe<Scalars['String']>;
  receiveDate: Scalars['DateTime'];
  response?: Maybe<Scalars['String']>;
};

export type LeadActivityDetails = {
  __typename?: 'LeadActivityDetails';
  actiontakenname?: Maybe<Scalars['String']>;
  activityAudio?: Maybe<Scalars['String']>;
  activitydate: Scalars['DateTime'];
  activitydesc?: Maybe<Scalars['String']>;
  activitytype?: Maybe<Scalars['String']>;
  agencyname?: Maybe<Scalars['String']>;
  followupdate?: Maybe<Scalars['DateTime']>;
  followupremark?: Maybe<Scalars['String']>;
  lead_id?: Maybe<Scalars['String']>;
  leadStatus: Scalars['String'];
  remark?: Maybe<Scalars['String']>;
};

export type LeadActivityEntity = {
  __typename?: 'leadActivityEntity';
  accountId: Scalars['String'];
  actionBy?: Maybe<Scalars['String']>;
  activityAudio?: Maybe<Scalars['String']>;
  activityDate: Scalars['DateTime'];
  activityDesc?: Maybe<Scalars['String']>;
  activityType: Scalars['String'];
  followUpDate?: Maybe<Scalars['DateTime']>;
  followUpRemark?: Maybe<Scalars['String']>;
  fromPersonId?: Maybe<Scalars['String']>;
  fromProject: ProjectEntity;
  fromTeam: SaleTeamEntity;
  id: Scalars['String'];
  lead: LeadEntity;
  leadId: Scalars['String'];
  leadStatus: Scalars['String'];
  personId?: Maybe<Scalars['String']>;
  project: ProjectEntity;
  remark?: Maybe<Scalars['String']>;
  team: SaleTeamEntity;
};

export type LeadAddressEntity = {
  __typename?: 'leadAddressEntity';
  accountId: Scalars['String'];
  address: AddressJson;
  contactId: Scalars['String'];
  id: Scalars['String'];
  isPrimary: Scalars['Boolean'];
  leadContact: LeadContactEntity;
};

export type LeadAssignmentSettingEntity = {
  __typename?: 'leadAssignmentSettingEntity';
  accountId: Scalars['String'];
  id: Scalars['String'];
  lastAssign: Scalars['DateTime'];
  leadCount: Scalars['Float'];
  projectId: Scalars['String'];
  seq: Scalars['Float'];
  userId: Scalars['String'];
  weight: Scalars['Float'];
};

export type LeadBatchCountLeadSourceOutput = {
  __typename?: 'LeadBatchCountLeadSourceOutput';
  id: Scalars['String'];
  others: Array<LeadBatchCountLeadSourceValuesOutput>;
  top1: Array<LeadBatchCountLeadSourceValuesOutput>;
  top2: Array<LeadBatchCountLeadSourceValuesOutput>;
  top3: Array<LeadBatchCountLeadSourceValuesOutput>;
};

export type LeadBatchCountLeadSourceValuesOutput = {
  __typename?: 'LeadBatchCountLeadSourceValuesOutput';
  count: Scalars['Float'];
  name: Scalars['String'];
};

export type LeadBatchEntity = AuditEntity & {
  __typename?: 'leadBatchEntity';
  accountId: Scalars['String'];
  assignedToProjectLeadCount: Scalars['Float'];
  batchTitle: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  lastAssignedToProject: LeadActivityEntity;
  leads: Array<LeadEntity>;
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  recordCount: Scalars['Float'];
};

export type LeadByBatch = {
  __typename?: 'LeadByBatch';
  contact_id: Scalars['String'];
  email: Scalars['String'];
  full_name: Scalars['String'];
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isRegistered?: Maybe<Scalars['Boolean']>;
  lead_id: Scalars['String'];
  lead_source?: Maybe<Scalars['String']>;
  phone_no: Scalars['String'];
  project_count: Scalars['Float'];
  project_id?: Maybe<Scalars['String']>;
};

export type LeadByBatchIds = {
  __typename?: 'LeadByBatchIds';
  assignedProjectDetails?: Maybe<Array<AssignedProjectDetails>>;
  batchTitle?: Maybe<Scalars['String']>;
  coldTotal?: Maybe<Scalars['Float']>;
  createdTs?: Maybe<Scalars['DateTime']>;
  dropTotal?: Maybe<Scalars['Float']>;
  hotTotal?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['String']>;
  isRoundRobinUser?: Maybe<Scalars['Boolean']>;
  leadData?: Maybe<Array<LeadDataOutput>>;
  openTotal?: Maybe<Scalars['Float']>;
  recordCount?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  warmTotal?: Maybe<Scalars['Float']>;
};

export type LeadContactEntity = {
  __typename?: 'leadContactEntity';
  accountId: Scalars['String'];
  address?: Maybe<AddressJson>;
  addressList?: Maybe<Array<LeadAddressEntity>>;
  altEmail?: Maybe<Array<Scalars['String']>>;
  bookingWaitlists: Array<BookingWaitlistEntity>;
  commonStatus: Scalars['String'];
  companyName?: Maybe<Scalars['String']>;
  companyRegNo?: Maybe<Scalars['String']>;
  distance: Scalars['Float'];
  dob?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  fullName: Scalars['String'];
  gender?: Maybe<Scalars['String']>;
  homeTel?: Maybe<Scalars['String']>;
  icNo?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  identityType?: Maybe<Scalars['String']>;
  incomeRange?: Maybe<IncomeRangeEntity>;
  jointBuyers: Array<JointBuyerEntity>;
  jointBuyerSignature?: Maybe<Scalars['String']>;
  leadAddress?: Maybe<Array<AddressJson>>;
  leadJointBuyers: Array<LeadJointBuyerEntity>;
  leads?: Maybe<Array<LeadEntity>>;
  maritalStatus?: Maybe<MaritalStatusEntity>;
  militaryIc?: Maybe<Scalars['String']>;
  nationality?: Maybe<SNationalityEntity>;
  officeTel?: Maybe<Scalars['String']>;
  phoneNo: Scalars['String'];
  photoUrl?: Maybe<Scalars['String']>;
  race?: Maybe<RaceEntity>;
  sales: Array<SaleEntity>;
  salutation?: Maybe<SalutationEntity>;
  signatureUrl?: Maybe<Scalars['String']>;
};

export type LeadConversionRateOutput = {
  __typename?: 'LeadConversionRateOutput';
  rate?: Maybe<Scalars['Float']>;
  totalSales?: Maybe<Scalars['Float']>;
  totalSalesAmt?: Maybe<Scalars['Float']>;
};

export type LeadDataOutput = {
  __typename?: 'LeadDataOutput';
  activity_date?: Maybe<Scalars['DateTime']>;
  activity_desc?: Maybe<Scalars['String']>;
  contact_id: Scalars['String'];
  converted_to_booking: Scalars['Boolean'];
  createdTs?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  event_name?: Maybe<Scalars['String']>;
  existing_purchaser: Scalars['Boolean'];
  follow_up_date?: Maybe<Scalars['DateTime']>;
  follow_up_remark?: Maybe<Scalars['String']>;
  full_name: Scalars['String'];
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isRegistered?: Maybe<Scalars['Boolean']>;
  lead_id: Scalars['String'];
  lead_source: Scalars['String'];
  lead_status: Scalars['String'];
  phone_no: Scalars['String'];
  project_count: Scalars['Float'];
  sales_person_id?: Maybe<Scalars['String']>;
  sales_person_name?: Maybe<Scalars['String']>;
};

export type LeadDropRateOutput = {
  __typename?: 'LeadDropRateOutput';
  rate?: Maybe<Scalars['Float']>;
  totalDropLead?: Maybe<Scalars['Float']>;
};

export type LeadEntity = {
  __typename?: 'leadEntity';
  accountId: Scalars['String'];
  agencyAcctId?: Maybe<Scalars['String']>;
  assignStatus?: Maybe<Scalars['String']>;
  batch: LeadBatchEntity;
  batchId?: Maybe<Scalars['String']>;
  contact: LeadContactEntity;
  contactId: Scalars['String'];
  eventId?: Maybe<Scalars['String']>;
  events?: Maybe<EventsEntity>;
  id: Scalars['String'];
  incomeRange?: Maybe<IncomeRangeEntity>;
  incomeRangeId?: Maybe<Scalars['String']>;
  lastLeadActId?: Maybe<Scalars['String']>;
  leadActivities: Array<LeadActivityEntity>;
  LeadActivity: Scalars['JSONObject'];
  leadAddress?: Maybe<Array<AddressJson>>;
  leadDetailsActivity?: Maybe<Array<LeadActivityDetails>>;
  leadJointBuyers: Array<LeadJointBuyerEntity>;
  leadSource: LeadSourceEntity;
  leadSourceId: Scalars['String'];
  leadStatus: Scalars['String'];
  LeadStatus: Scalars['JSONObject'];
  loanScreening?: Maybe<LoanScreenStatusOutput>;
  occupation?: Maybe<Scalars['String']>;
  preferLocation?: Maybe<Scalars['String']>;
  project: ProjectEntity;
  projectId?: Maybe<Scalars['String']>;
  propertyType?: Maybe<PropertyTypeEntity>;
  propertyTypeId?: Maybe<Scalars['String']>;
  referralContactNo?: Maybe<Scalars['String']>;
  referralName?: Maybe<Scalars['String']>;
  referralReferenceNo?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
  sales: Array<SaleEntity>;
  salesPerson?: Maybe<UserEntity>;
  salesPersonId: Scalars['String'];
  team?: Maybe<SaleTeamEntity>;
  teamId: Scalars['String'];
  unit: UnitEntity;
  utm_campaign?: Maybe<Scalars['String']>;
  utm_content?: Maybe<Scalars['String']>;
  utm_id?: Maybe<Scalars['String']>;
  utm_medium?: Maybe<Scalars['String']>;
  utm_source?: Maybe<Scalars['String']>;
  utm_term?: Maybe<Scalars['String']>;
  waitingList: Array<BookingWaitlistEntity>;
};

export type LeadHandleByWhichUserOutput = {
  __typename?: 'LeadHandleByWhichUserOutput';
  assignStatus: Scalars['String'];
  eLaunchId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  salesPersonId?: Maybe<Scalars['String']>;
};

export type LeadJointBuyerEntity = {
  __typename?: 'leadJointBuyerEntity';
  commonStatus: Scalars['String'];
  contact: LeadContactEntity;
  contactId: Scalars['String'];
  id: Scalars['String'];
  lead: LeadEntity;
  leadId: Scalars['String'];
};

export type LeadSourceEntity = {
  __typename?: 'leadSourceEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  defaulted: Scalars['Boolean'];
  id: Scalars['String'];
  isDeletable: Scalars['Boolean'];
  isExistInMasterData: Array<Scalars['String']>;
  isExistInTransactionData: Array<Scalars['String']>;
  leads: Array<LeadEntity>;
  name: Scalars['String'];
  sales: Array<SaleEntity>;
  seqNo?: Maybe<Scalars['Float']>;
  systemUse: Scalars['Boolean'];
};

export type LeadSourceInput = {
  name: Scalars['String'];
};

export type LeadStatusCountOutput = {
  __typename?: 'LeadStatusCountOutput';
  bookedCount?: Maybe<Scalars['Float']>;
  coldCount?: Maybe<Scalars['Float']>;
  conversionRate?: Maybe<LeadConversionRateOutput>;
  dropCount?: Maybe<Scalars['Float']>;
  droppedRate: LeadDropRateOutput;
  hotCount?: Maybe<Scalars['Float']>;
  openCount?: Maybe<Scalars['Float']>;
  projectId?: Maybe<Scalars['String']>;
  reservationCount?: Maybe<Scalars['Float']>;
  signedCount?: Maybe<Scalars['Float']>;
  totalConvertedAmount?: Maybe<Scalars['Float']>;
  totalCount?: Maybe<Scalars['Float']>;
  waitingCount?: Maybe<Scalars['Float']>;
  warmCount?: Maybe<Scalars['Float']>;
};


export type LeadStatusCountOutputConversionRateArgs = {
  lead_source_id?: InputMaybe<Scalars['String']>;
};

export type LeadTemplateReturnOutput = {
  __typename?: 'LeadTemplateReturnOutput';
  file?: Maybe<Scalars['String']>;
  file_name?: Maybe<Scalars['String']>;
  leadIds?: Maybe<Array<Scalars['String']>>;
  message?: Maybe<Scalars['String']>;
};

export type LedgerEntity = {
  __typename?: 'ledgerEntity';
  account_id: Scalars['String'];
  adjustmentType?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  debtorClass?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  docAmount: Scalars['String'];
  documentNo?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  interestInvoice: Array<InterestEntity>;
  interestLegder: Array<InterestEntity>;
  invoice: LedgerEntity;
  ledgers: Array<LedgerEntity>;
  mode: Scalars['String'];
  paymentInclude?: Maybe<Scalars['Boolean']>;
  paymentMethod?: Maybe<Scalars['String']>;
  postedDate?: Maybe<Scalars['DateTime']>;
  project: ProjectEntity;
  referenceNo?: Maybe<Scalars['String']>;
  reminders: Array<ReminderEntity>;
  sale: SaleEntity;
  schedule: ScheduleEntity;
  tax_id: Scalars['String'];
  taxAmount?: Maybe<Scalars['String']>;
  trxClass?: Maybe<Scalars['String']>;
  trxDate: Scalars['DateTime'];
  trxStatus: Scalars['String'];
  voidDate?: Maybe<Scalars['DateTime']>;
  voidReason?: Maybe<Scalars['String']>;
};

export type LetterCategoryDetailOutput = {
  __typename?: 'letterCategoryDetailOutput';
  id: Scalars['String'];
  isAllowHtmlEditor: Scalars['Boolean'];
  isAllowReportDesignEditor: Scalars['Boolean'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type LetterSignEntity = AuditEntity & {
  __typename?: 'letterSignEntity';
  contactId: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  sale: SaleEntity;
};

export type LetterTemplateEntity = AuditEntity & {
  __typename?: 'letterTemplateEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  defaulted: Scalars['Boolean'];
  id: Scalars['String'];
  isReportDesignEditor: Scalars['Boolean'];
  jointBuyerSignRequired: Scalars['Boolean'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  name: Scalars['String'];
  projectLetter: Array<ProjectLetterEntity>;
  slDataSource?: Maybe<StandardLetterDataSourceEntity>;
  standardLetter: StandardLetterEntity;
  standardLetterDataSourceVersion?: Maybe<Scalars['Float']>;
  standardLetterId: Scalars['String'];
  templateBody?: Maybe<Scalars['String']>;
};

export type LetterTemplateInput = {
  isReportDesignEditor: Scalars['Boolean'];
  jointBuyerSignRequired: Scalars['Boolean'];
  name: Scalars['String'];
  standardLetterId: Scalars['String'];
};

export type LhdnEinvoiceSettingsEntity = {
  __typename?: 'lhdnEinvoiceSettingsEntity';
  eInvAccessToken?: Maybe<Scalars['String']>;
  eInvApiUrl?: Maybe<Scalars['String']>;
  eInvClientId: Scalars['String'];
  eInvClientSecret?: Maybe<Scalars['String']>;
  eInvClientSecret2?: Maybe<Scalars['String']>;
};

export type ListOfSalesStaffByTeam = {
  __typename?: 'ListOfSalesStaffByTeam';
  teamId: Scalars['String'];
  teamName: Scalars['String'];
  userId: Scalars['String'];
  userName: Scalars['String'];
};

export type LiSummary = {
  __typename?: 'LISummary';
  totalApproved?: Maybe<Scalars['Float']>;
  totalCharges?: Maybe<Scalars['Float']>;
  totalUnallocatedAmt?: Maybe<Scalars['Float']>;
};

export type LoanAcceptanceRateOutput = {
  __typename?: 'LoanAcceptanceRateOutput';
  accepted: Scalars['Float'];
  name: Scalars['String'];
  pending: Scalars['Float'];
  rejected: Scalars['Float'];
  total: Scalars['Float'];
};

export type LoanAlertAgingInput = {
  isActive: Scalars['Boolean'];
  maxMajorLoanAlertAging: Scalars['Float'];
  maxMinorLoanAlertAging: Scalars['Float'];
};

export type LoanAlertAgingOutput = {
  __typename?: 'LoanAlertAgingOutput';
  isActive: Scalars['Boolean'];
  maxMajorLoanAlertAging: Scalars['Float'];
  maxMinorLoanAlertAging: Scalars['Float'];
};

export type LoanAppRenotice = {
  generationBatchId: Scalars['String'];
  renoticeDate?: InputMaybe<Scalars['DateTime']>;
  saleId: Scalars['String'];
};

export type LoanApprovalCountOutput = {
  __typename?: 'LoanApprovalCountOutput';
  approvedCount?: Maybe<Scalars['Float']>;
  draftCount?: Maybe<Scalars['Float']>;
  submittedCount?: Maybe<Scalars['Float']>;
};

export type LoanAssignedCountOutput = {
  __typename?: 'LoanAssignedCountOutput';
  active_count: Scalars['Float'];
  total_count: Scalars['Float'];
  withdrawn_count: Scalars['Float'];
};

export type LoanAssignmentInput = {
  agencyUserReceive?: InputMaybe<Scalars['Boolean']>;
  endFinUserReceive?: InputMaybe<Scalars['Boolean']>;
  salesUserReceive?: InputMaybe<Scalars['Boolean']>;
};

export type LoanAssignmentOutput = {
  __typename?: 'loanAssignmentOutput';
  agencyUserReceive?: Maybe<Scalars['Boolean']>;
  endFinUserReceive?: Maybe<Scalars['Boolean']>;
  salesUserReceive?: Maybe<Scalars['Boolean']>;
};

export type LoanBiOutput = {
  __typename?: 'LoanBIOutput';
  name: Scalars['String'];
};

export type LoanDifferentialCountOutput = {
  __typename?: 'loanDifferentialCountOutput';
  completedCount?: Maybe<Scalars['Float']>;
  pendingCount?: Maybe<Scalars['Float']>;
};

export type LoanDifferentialListingOutput = {
  __typename?: 'loanDifferentialListingOutput';
  applyAmount?: Maybe<Scalars['Float']>;
  approvalDate?: Maybe<Scalars['DateTime']>;
  approvedAmount?: Maybe<Scalars['Float']>;
  borrowerName: Scalars['String'];
  clusterCode: Scalars['String'];
  financier: Scalars['String'];
  id: Scalars['String'];
  rescheduleApprovalStatus?: Maybe<Scalars['String']>;
  rescheduled?: Maybe<Scalars['Boolean']>;
  rescheduleId?: Maybe<Scalars['String']>;
  rescheduling?: Maybe<Scalars['String']>;
  saleId: Scalars['String'];
  unitNo: Scalars['String'];
};

export type LoanFinancierDetail = {
  __typename?: 'LoanFinancierDetail';
  financierId: Scalars['String'];
  name: Scalars['String'];
};

export type LoanLeadNotificationInput = {
  leadAssignment?: InputMaybe<Scalars['Boolean']>;
};

export type LoanLeadNotificationOutput = {
  __typename?: 'LoanLeadNotificationOutput';
  leadAssignment?: Maybe<Scalars['Boolean']>;
};

export type LoanPaymentDetailOutput = {
  __typename?: 'loanPaymentDetailOutput';
  approvedAmtLoanExt?: Maybe<Scalars['Float']>;
  approvedBy: Scalars['String'];
  approvedDate?: Maybe<Scalars['DateTime']>;
  disbursementBankAccount?: Maybe<Scalars['String']>;
  endFinancier: Scalars['String'];
  loanPaymentDate: Scalars['DateTime'];
  loanPaymentNo: Scalars['String'];
  loanReleaseDate: Scalars['DateTime'];
  loanReleaseNo: Scalars['String'];
  mortgagePlan: Scalars['String'];
  paymentName?: Maybe<Scalars['String']>;
  paymentPercentage?: Maybe<Scalars['Float']>;
  retentionBy?: Maybe<Scalars['String']>;
  retentionId?: Maybe<Scalars['String']>;
  retentionName?: Maybe<Scalars['String']>;
  retentionValue?: Maybe<Scalars['Float']>;
  saleLoanPaymentPlanDetails?: Maybe<Array<SaleLoanPaymentPlanDetailsOutput>>;
  submittedBy: Scalars['String'];
  submittedDate: Scalars['DateTime'];
  totalApproveAmt?: Maybe<Scalars['Float']>;
};

export type LoanPaymentEntity = {
  __typename?: 'loanPaymentEntity';
  accountId: Scalars['String'];
  approvalStatus: Scalars['String'];
  bankAccountId: Scalars['String'];
  commonStatus: Scalars['String'];
  documentAmt: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  id: Scalars['String'];
  loanPaymentNo?: Maybe<Scalars['String']>;
  postBy?: Maybe<Scalars['String']>;
  postDate?: Maybe<Scalars['DateTime']>;
  projectId: Scalars['String'];
  saleLoanPaymentPlanDetails?: Maybe<Array<SaleLoanNotice>>;
  saleLoanReleaseNotificationId: Scalars['String'];
};

export type LoanPaymentInput = {
  date: Scalars['DateTime'];
  desc: Scalars['String'];
  financier: Scalars['String'];
  referenceNo: Scalars['String'];
  taxAmount?: InputMaybe<Scalars['Float']>;
};

export type LoanPaymentListingByIdOutput = {
  __typename?: 'loanPaymentListingByIdOutput';
  bankAccountId: Scalars['String'];
  documentAmt: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  financier: Scalars['String'];
  id: Scalars['String'];
  loanReleaseId: Scalars['String'];
  referenceNo: Scalars['String'];
  saleLoanPaymentPlanDetails?: Maybe<Array<SaleLoanPaymentPlanDetailsOutput>>;
};

export type LoanPaymentListingOutput = {
  __typename?: 'loanPaymentListingOutput';
  approvalStatus: Scalars['String'];
  documentAmt: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  financier: Scalars['String'];
  id: Scalars['String'];
  loanPaymentNo?: Maybe<Scalars['String']>;
  referenceNo: Scalars['String'];
};

export type LoanPaymentSummaryOutput = {
  __typename?: 'loanPaymentSummaryOutput';
  draft: Scalars['Float'];
  posted: Scalars['Float'];
};

export type LoanProjectCountOutput = {
  __typename?: 'LoanProjectCountOutput';
  active_count: Scalars['Float'];
  project_id: Scalars['String'];
  project_name: Scalars['String'];
  total_count: Scalars['Float'];
  withdrawn_count: Scalars['Float'];
};

export type LoanScreenEntity = {
  __typename?: 'loanScreenEntity';
  accountId: Scalars['String'];
  caseCode?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  payload: Scalars['JSONObject'];
  project: ProjectEntity;
  projectId: Scalars['String'];
  refCode?: Maybe<Scalars['String']>;
  refId: Scalars['String'];
  refTable: Scalars['String'];
  reportType: Scalars['String'];
  reportUrl?: Maybe<Scalars['String']>;
  serviceProvider: Scalars['String'];
  status: Scalars['String'];
};

export type LoanScreenReportOutput = {
  __typename?: 'LoanScreenReportOutput';
  fileName: Scalars['String'];
  mediaType: Scalars['String'];
  refType: Scalars['String'];
  resourceUrl: Scalars['String'];
};

export type LoanScreenStatusOutput = {
  __typename?: 'LoanScreenStatusOutput';
  caseCode: Scalars['String'];
  CCRIS?: Maybe<Scalars['String']>;
  createdDate: Scalars['DateTime'];
  CTOS?: Maybe<Scalars['String']>;
  modifiedDate: Scalars['DateTime'];
  status: Scalars['String'];
};

export type LoanSettlementDetailOutput = {
  __typename?: 'loanSettlementDetailOutput';
  companyName?: Maybe<Scalars['String']>;
  financierDetail?: Maybe<Array<LoanSettlementEndFinOutput>>;
  isCompany?: Maybe<Scalars['Boolean']>;
  purchaserName?: Maybe<Scalars['String']>;
  saleId: Scalars['String'];
  unitNo: Scalars['String'];
};

export type LoanSettlementEndFinOutput = {
  __typename?: 'loanSettlementEndFinOutput';
  financierCode?: Maybe<Scalars['String']>;
  financierName: Scalars['String'];
  rrDate?: Maybe<Scalars['DateTime']>;
  rrSolCode?: Maybe<Scalars['String']>;
  rrSolId?: Maybe<Scalars['String']>;
  rrSolName?: Maybe<Scalars['String']>;
  rrSolRefNo?: Maybe<Scalars['String']>;
  saleId?: Maybe<Scalars['String']>;
  saleLoanId?: Maybe<Scalars['String']>;
  solicitorCode?: Maybe<Scalars['String']>;
  solicitorName: Scalars['String'];
};

export type LoanSettlementFinanciers = {
  __typename?: 'loanSettlementFinanciers';
  financierCode?: Maybe<Scalars['String']>;
  financierName: Scalars['String'];
  id: Scalars['String'];
};

export type LoanSettlementListingOutput = {
  __typename?: 'loanSettlementListingOutput';
  companyName?: Maybe<Scalars['String']>;
  financierList?: Maybe<Array<LoanSettlementFinanciers>>;
  isCompany?: Maybe<Scalars['Boolean']>;
  purchaserName?: Maybe<Scalars['String']>;
  rrDate?: Maybe<Scalars['DateTime']>;
  saleId: Scalars['String'];
  unitNo: Scalars['String'];
};

export type LoanSettlementOutput = {
  __typename?: 'loanSettlementOutput';
  contactId: Scalars['String'];
  fullName: Scalars['String'];
  saleLoanId?: Maybe<Scalars['String']>;
  salesId: Scalars['String'];
  unitId: Scalars['String'];
  unitNo: Scalars['String'];
};

export type LoanSettlementSolicitor = {
  __typename?: 'loanSettlementSolicitor';
  id: Scalars['String'];
  solicitorCode?: Maybe<Scalars['String']>;
  solicitorName: Scalars['String'];
};

export type LoanSettlementUnitOutput = {
  __typename?: 'loanSettlementUnitOutput';
  purchaserName?: Maybe<Scalars['String']>;
  saleId?: Maybe<Scalars['String']>;
  unitId: Scalars['String'];
  unitNo: Scalars['String'];
};

export type LoanStatusOutput = {
  __typename?: 'LoanStatusOutput';
  acceptedCount: Scalars['Float'];
  approvedCount: Scalars['Float'];
  count: Scalars['Float'];
  rejectedCount: Scalars['Float'];
  withdrawnCount: Scalars['Float'];
};

export type LocalBankEntity = AuditEntity & {
  __typename?: 'LocalBankEntity';
  address: Address;
  code: Scalars['String'];
  commonStatus: CommonStatus;
  contactNo: Scalars['String'];
  countryID?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  faxNo?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  name: Scalars['String'];
  website?: Maybe<Scalars['String']>;
};

export type LoginResponse = {
  __typename?: 'LoginResponse';
  accessToken: Scalars['String'];
  user: UserResponse;
};

export type LotStatusData = {
  __typename?: 'LotStatusData';
  bookedCount?: Maybe<Scalars['Float']>;
  cancelledCount?: Maybe<Scalars['Float']>;
  soldCount?: Maybe<Scalars['Float']>;
  transactionDate?: Maybe<Scalars['DateTime']>;
};

export type LotStatusMovement = {
  __typename?: 'LotStatusMovement';
  monthlyMovement: Array<LotStatusData>;
  weeklyMovement: Array<LotStatusData>;
};

export type MainOutput = {
  __typename?: 'mainOutput';
  assignedCarparks?: Maybe<Array<AssignedUnitCp>>;
  carParks: Array<CarParkOutput>;
};

export type MaritalStatusEntity = {
  __typename?: 'maritalStatusEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  contacts: Array<ContactEntity>;
  defaulted: Scalars['Boolean'];
  id: Scalars['String'];
  isDeletable: Scalars['Boolean'];
  isExistInMasterData: Array<Scalars['String']>;
  isExistInTransactionData: Array<Scalars['String']>;
  name: Scalars['String'];
  seqNo?: Maybe<Scalars['Float']>;
  systemUse: Scalars['Boolean'];
};

export type MaritalStatusInput = {
  name: Scalars['String'];
};

export type MarkUpInput = {
  id: Scalars['String'];
  markUpBy: Scalars['String'];
  markUpReason: Scalars['String'];
  markUpValue: Scalars['Float'];
};

export type MarkUpSummaryInfo = {
  __typename?: 'markUpSummaryInfo';
  markUpAmount?: Maybe<Scalars['Float']>;
  markUpBy?: Maybe<Scalars['String']>;
  markUpReason?: Maybe<Scalars['String']>;
  markUpValue?: Maybe<Scalars['Float']>;
};

export type MasterDataOutput = {
  __typename?: 'MasterDataOutput';
  AddressType: Scalars['JSONObject'];
  City: Array<SCityEntity>;
  CommercialPurposes: Scalars['JSONObject'];
  Countries: Array<CountryMasterDataOutput>;
  CurrencyCode: Array<Array<Scalars['String']>>;
  DiscountPrefix: Scalars['JSONObject'];
  DiscountType: Array<DiscountTypeEntity>;
  ELettering: Scalars['JSONObject'];
  Events: Array<EventsEntity>;
  Genders: Scalars['JSONObject'];
  IncomeRanges: Array<IncomeRangeEntity>;
  IntegrationTypes: Scalars['JSONObject'];
  LandType: Scalars['JSONObject'];
  Language: Scalars['JSONObject'];
  LeadSources: Array<LeadSourceEntity>;
  LoanType: Scalars['JSONObject'];
  MaritalStatus: Array<MaritalStatusEntity>;
  Nationalities: Array<SNationalityEntity>;
  PaymentMethods: Scalars['JSONObject'];
  PaymentStatus: Scalars['JSONObject'];
  PayMethod: Scalars['JSONObject'];
  ProjectTypes: Array<ProjectTypeEntity>;
  PropertyTypes: Array<PropertyTypeEntity>;
  PurchaserAppSetting: Scalars['JSONObject'];
  Races: Array<RaceEntity>;
  ReasonCode: Array<ReasonCodeEntity>;
  Region: Array<RegionEntity>;
  Salutations: Array<SalutationEntity>;
  Tenures: Scalars['JSONObject'];
  UnitLayoutbyProject: Array<UnitLayoutEntity>;
  UnitTypes: Array<UnitTypeEntity>;
  UOM: Scalars['JSONObject'];
  UserPermission: Array<Scalars['Float']>;
};


export type MasterDataOutputPaymentMethodsArgs = {
  projectId?: InputMaybe<Scalars['String']>;
  saleId?: InputMaybe<Scalars['String']>;
};


export type MasterDataOutputPaymentStatusArgs = {
  projectId?: InputMaybe<Scalars['String']>;
  saleId?: InputMaybe<Scalars['String']>;
};


export type MasterDataOutputUnitLayoutbyProjectArgs = {
  project_id: Scalars['String'];
};


export type MasterDataOutputUserPermissionArgs = {
  projectId: Scalars['String'];
};

export type MbSummary = {
  __typename?: 'MBSummary';
  approveCount?: Maybe<Scalars['Float']>;
  draftCount?: Maybe<Scalars['Float']>;
  submitCount?: Maybe<Scalars['Float']>;
  totalDocAmt?: Maybe<Scalars['Float']>;
  totalUnallocatedAmt?: Maybe<Scalars['Float']>;
};

export type MediaSource = {
  __typename?: 'MediaSource';
  caption?: Maybe<Scalars['String']>;
  url: Scalars['String'];
  videoType?: Maybe<Scalars['String']>;
};

export type MediaSourceInput = {
  caption?: InputMaybe<Scalars['String']>;
  url: Scalars['String'];
  videoType?: InputMaybe<Scalars['String']>;
};

export type MergeSalesStatutoryDocumentIndoInput = {
  bpnLandArea?: InputMaybe<Scalars['Float']>;
  checked: Array<MergeSelection>;
  contactId?: InputMaybe<Scalars['String']>;
  document_ref: Scalars['String'];
  documentDate?: InputMaybe<Scalars['DateTime']>;
  file?: InputMaybe<Array<Scalars['Upload']>>;
  notaryId?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
  statutoryDocumentId: Scalars['String'];
  unitStatutoryId: Scalars['String'];
};

export type MergeSelection = {
  contactId?: InputMaybe<Scalars['String']>;
  documentDate: Scalars['String'];
  documentRef: Scalars['String'];
  id: Scalars['String'];
  statutoryDocumentId: Scalars['String'];
  unitStatutoryId: Scalars['String'];
};

export type MicrositeNewLeadOutput = {
  __typename?: 'MicrositeNewLeadOutput';
  accountId?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  eventId?: Maybe<Scalars['String']>;
  fullName: Scalars['String'];
  gender?: Maybe<Scalars['String']>;
  homeTel?: Maybe<Scalars['String']>;
  icNo?: Maybe<Scalars['String']>;
  incomeRange?: Maybe<Scalars['String']>;
  leadSourceId?: Maybe<Scalars['String']>;
  maritalStatus?: Maybe<Scalars['String']>;
  militaryIc?: Maybe<Scalars['String']>;
  nationality?: Maybe<Scalars['String']>;
  officeTel?: Maybe<Scalars['String']>;
  passportNo?: Maybe<Scalars['String']>;
  phoneNo: Scalars['String'];
  postCode?: Maybe<Scalars['String']>;
  preferLocation?: Maybe<Scalars['String']>;
  projectId?: Maybe<Scalars['String']>;
  propertyType?: Maybe<Scalars['String']>;
  race?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  salesPersonId?: Maybe<Scalars['String']>;
  salutation?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  teamId?: Maybe<Scalars['String']>;
  utmCampaign?: Maybe<Scalars['String']>;
  utmContent?: Maybe<Scalars['String']>;
  utmId?: Maybe<Scalars['String']>;
  utmMedium?: Maybe<Scalars['String']>;
  utmSource?: Maybe<Scalars['String']>;
  utmTerm?: Maybe<Scalars['String']>;
};

export type MiscBillingData = {
  __typename?: 'miscBillingData';
  count: Scalars['Float'];
  miscBillingEntity?: Maybe<MiscBillingEntity>;
  total: Scalars['Float'];
};

export type MiscBillingDetailByGenerationOutput = {
  __typename?: 'miscBillingDetailByGenerationOutput';
  billItemIds: Array<Scalars['String']>;
  creditTerm: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  interestRate: Scalars['Float'];
  units: Array<Scalars['String']>;
};

export type MiscBillingDetailOutput = {
  __typename?: 'miscBillingDetailOutput';
  id: Scalars['String'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
};

export type MiscBillingEntity = {
  __typename?: 'miscBillingEntity';
  accountId: Scalars['String'];
  allowReversal: Scalars['Boolean'];
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  approveUserData?: Maybe<UserEntity>;
  attachment?: Maybe<Array<AttachmentEntity>>;
  billItem?: Maybe<BillItemEntity>;
  billItemId: Scalars['String'];
  billItemInt?: Maybe<BillItemIntEntity>;
  clusterName?: Maybe<ProjectClusterEntity>;
  commonStatus: Scalars['String'];
  contactDetail?: Maybe<Scalars['String']>;
  creditTerm: Scalars['Float'];
  description: Scalars['String'];
  documentAmount: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  documentNo?: Maybe<Scalars['String']>;
  documentRef?: Maybe<Scalars['String']>;
  dueDate: Scalars['DateTime'];
  generationBatch?: Maybe<Scalars['String']>;
  generationBatchDate?: Maybe<Scalars['DateTime']>;
  glGenerated?: Maybe<Scalars['Boolean']>;
  glGenerationBatch?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  interestRate?: Maybe<Scalars['Float']>;
  isIncludeHoliday: Scalars['Boolean'];
  projectDetail?: Maybe<UserEntity>;
  projectId: Scalars['String'];
  requestedBy?: Maybe<Scalars['String']>;
  requestUserData?: Maybe<UserEntity>;
  saleId: Scalars['String'];
  sales?: Maybe<SaleEntity>;
  salesRegNo?: Maybe<SaleExtensionEntity>;
  status: Scalars['String'];
  submittedBy?: Maybe<Scalars['String']>;
  submittedDate?: Maybe<Scalars['DateTime']>;
  submitUserData?: Maybe<UserEntity>;
  taxData?: Maybe<TaxSchemeDropdownOutput>;
  taxLedger?: Maybe<TaxLedgerEntity>;
  unallocatedAmount?: Maybe<Scalars['Float']>;
  unallocatedAmountSummary?: Maybe<Scalars['Float']>;
  unitDetail?: Maybe<Scalars['String']>;
  voidBy?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
  voidUserData?: Maybe<UserEntity>;
};

export type MiscBillingListOutput = {
  __typename?: 'miscBillingListOutput';
  documentDate: Scalars['DateTime'];
  generationBatch: Scalars['String'];
  status: Scalars['String'];
  totalAmount: Scalars['Float'];
  unitList: Array<MiscBillingUnitList>;
};

export type MiscBillingSummary = {
  __typename?: 'miscBillingSummary';
  totalCharges?: Maybe<Scalars['Float']>;
  totalOverdue?: Maybe<Scalars['Float']>;
};

export type MiscBillingTaxOutput = {
  __typename?: 'miscBillingTaxOutput';
  code: Scalars['String'];
  effectiveDate: Scalars['DateTime'];
  rate: Scalars['Float'];
  taxId: Scalars['String'];
};

export type MiscBillingUnitBillingList = {
  __typename?: 'miscBillingUnitBillingList';
  billItem: Scalars['String'];
  docAmount: Scalars['Float'];
};

export type MiscBillingUnitList = {
  __typename?: 'miscBillingUnitList';
  billingList: Array<MiscBillingUnitBillingList>;
  totalAmount: Scalars['Float'];
  unitNo: Scalars['String'];
};

export type MiscChargesDropdownOutput = {
  __typename?: 'miscChargesDropdownOutput';
  billItemId: Scalars['String'];
  billItemName: Scalars['String'];
  effectiveDate: Scalars['DateTime'];
  miscChargesId: Scalars['String'];
  taxSchemeDetailId: Scalars['String'];
  taxSchemeDetailItems: Array<TaxSchemeDetailItemOutput>;
  taxSchemeId: Scalars['String'];
  taxSchemeName: Scalars['String'];
  totalTaxRate?: Maybe<Scalars['String']>;
};

export type ModuleEntity = AuditEntity & {
  __typename?: 'ModuleEntity';
  code: Scalars['String'];
  commonStatus: CommonStatus;
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  environmentUrl?: Maybe<Array<EnvironmentUrl>>;
  ID: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  name: Scalars['String'];
  product: ProductEntity;
  productID: Scalars['String'];
};

export type MonthlyBookChartCountOutput = {
  __typename?: 'monthlyBookChartCountOutput';
  bookedCount: Scalars['Float'];
  cancelBookCount: Scalars['Float'];
  cumulativeCount: Scalars['Float'];
  months?: Maybe<Scalars['String']>;
  months_alt: Scalars['Float'];
};

export type MonthlyChartCount = {
  __typename?: 'monthlyChartCount';
  cumulativeCount: Scalars['Float'];
  monthlyCount: Scalars['Float'];
  monthlyDate: Scalars['DateTime'];
};

export type MonthlySignChartCountOutput = {
  __typename?: 'monthlySignChartCountOutput';
  cancelSignCount: Scalars['Float'];
  cumulativeCount: Scalars['Float'];
  months?: Maybe<Scalars['String']>;
  months_alt: Scalars['Float'];
  signedCount: Scalars['Float'];
};

export type MortgagePaymentEntity = {
  __typename?: 'mortgagePaymentEntity';
  accountId: Scalars['String'];
  endfinancierMortgagePlanId: Scalars['String'];
  eventItem?: Maybe<Scalars['String']>;
  eventStatutoryDocId?: Maybe<Scalars['String']>;
  expectedCount: Scalars['Float'];
  expectedFreq: Scalars['String'];
  expectedFrom: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  paymentEvent: Scalars['String'];
  percentage: Scalars['String'];
  retentions?: Maybe<Array<MortgageRetentionEntity>>;
  saleLoanPayment: SaleLoanPaymentEntity;
  saleLoanRelease: SaleLoanReleaseEntity;
};

export type MortgagePaymentFormMasterData = {
  __typename?: 'MortgagePaymentFormMasterData';
  expectedFreq: Array<Scalars['String']>;
  expectedFrom: Array<Scalars['String']>;
};

export type MortgagePaymentInput = {
  endfinancierMortgagePlanId: Scalars['String'];
  eventItem: Scalars['String'];
  expectedCount: Scalars['Float'];
  expectedFreq: Scalars['String'];
  expectedFrom: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  paymentEvent: Scalars['String'];
  percentage: Scalars['String'];
};

export type MortgagePaymentOutput = {
  __typename?: 'mortgagePaymentOutput';
  endfinancierMortgagePlanId: Scalars['String'];
  id: Scalars['String'];
  mortgageExpectedCount: Scalars['String'];
  mortgageExpectedFreq: Scalars['String'];
  mortgageExpectedFrom: Scalars['String'];
  mortgagePaymentName: Scalars['String'];
  mortgagePercentage: Scalars['Float'];
  retention?: Maybe<Array<NewMortgageRetentionOutput>>;
  sumRetention?: Maybe<Scalars['Float']>;
};

export type MortgagePaymentValidationInput = {
  mortgagePaymentId?: InputMaybe<Scalars['String']>;
  mortgagePlanId: Scalars['String'];
  name: Scalars['String'];
};

export type MortgagePlanEntity = {
  __typename?: 'mortgagePlanEntity';
  accountId: Scalars['String'];
  financierId: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  payments?: Maybe<Array<MortgagePaymentEntity>>;
  saleLoan: SaleLoanEntity;
  saleLoanRelease: SaleLoanReleaseEntity;
};

export type MortgagePlanInput = {
  financierId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type MortgagePlanOutput = {
  __typename?: 'mortgagePlanOutput';
  id: Scalars['String'];
  mortgagePlanName: Scalars['String'];
};

export type MortgagePlanValidationInput = {
  financierId: Scalars['String'];
  name: Scalars['String'];
};

export type MortgageRetentionEntity = {
  __typename?: 'mortgageRetentionEntity';
  accountId: Scalars['String'];
  endfinMortgagePaymentId: Scalars['String'];
  eventItem?: Maybe<Scalars['String']>;
  eventStatutoryDocId?: Maybe<Scalars['String']>;
  expectedCount: Scalars['Float'];
  expectedFreq: Scalars['String'];
  expectedFrom: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  retentionBy: Scalars['String'];
  retentionEvent: Scalars['String'];
  retentionValue: Scalars['String'];
  saleLoanRelease: SaleLoanReleaseEntity;
  saleLoanRetention: SaleLoanRetentionEntity;
};

export type MortgageRetentionInput = {
  endfinMortgagePaymentId: Scalars['String'];
  eventItem: Scalars['String'];
  expectedCount: Scalars['Float'];
  expectedFreq: Scalars['String'];
  expectedFrom: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  retentionBy: Scalars['String'];
  retentionEvent: Scalars['String'];
  retentionValue: Scalars['String'];
};

export type MortgageRetentionOutput = {
  __typename?: 'mortgageRetentionOutput';
  endfinMortgagePaymentId: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  retentionBy: Scalars['String'];
  retentionExpectedCount: Scalars['String'];
  retentionExpectedFreq: Scalars['String'];
  retentionExpectedFrom: Scalars['String'];
  retentionValue: Scalars['Float'];
};

export type MortgageRetentionValidationInput = {
  mortgagePaymentId: Scalars['String'];
  mortgageRetentionId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type MotTrackingDetailOutput = {
  __typename?: 'motTrackingDetailOutput';
  buyerSolicitorCode?: Maybe<Scalars['String']>;
  buyerSolicitorName?: Maybe<Scalars['String']>;
  confirmationPresentationReceipt: Scalars['DateTime'];
  developerSolicitorCode?: Maybe<Scalars['String']>;
  developerSolicitorName?: Maybe<Scalars['String']>;
  forwardMotComSec: Scalars['DateTime'];
  forwardMotDirector: Scalars['DateTime'];
  hsdHsmNo?: Maybe<Scalars['String']>;
  instructionToSolicitor: Scalars['DateTime'];
  lotPtNo?: Maybe<Scalars['String']>;
  motIn: Scalars['DateTime'];
  motMortgageDate: Scalars['DateTime'];
  motMortgageNo: Scalars['String'];
  motOut: Scalars['DateTime'];
  motReceiptNo: Scalars['String'];
  motSolicitorId: Scalars['String'];
  motSolicitorReferenceNo?: Maybe<Scalars['String']>;
  motSubmissionDate: Scalars['DateTime'];
  motSubmissionNo: Scalars['String'];
  motTransferDate: Scalars['DateTime'];
  receivedFrom?: Maybe<Scalars['String']>;
  receivedTitleDutyTransferred: Scalars['DateTime'];
  receiveLawyerAcknowledgement: Scalars['DateTime'];
  receiveMotCancellation: Scalars['DateTime'];
  receiveMotComSec: Scalars['DateTime'];
  receiveMotDirector: Scalars['DateTime'];
  releaseForTitle: Scalars['DateTime'];
  remark?: Maybe<Scalars['String']>;
  requestForTitle: Scalars['DateTime'];
  stampDutyPayment: Scalars['Float'];
  stampDutyPaymentDate: Scalars['DateTime'];
  titleExecutionDate: Scalars['DateTime'];
  titleForward: Scalars['DateTime'];
  titleNotificationDate: Scalars['DateTime'];
  unitNo: Scalars['String'];
};

export type MotTrackingEntity = {
  __typename?: 'motTrackingEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  confirmationPresentationReceipt: Scalars['DateTime'];
  forwardMotComSec: Scalars['DateTime'];
  forwardMotDirector: Scalars['DateTime'];
  id: Scalars['String'];
  instructionToSolicitor: Scalars['DateTime'];
  motIn: Scalars['DateTime'];
  motMortgageDate: Scalars['DateTime'];
  motMortgageNo: Scalars['String'];
  motOut: Scalars['DateTime'];
  motReceiptNo: Scalars['String'];
  motSolicitorId: Scalars['String'];
  motSolicitorReferenceNo?: Maybe<Scalars['String']>;
  motSubmissionDate: Scalars['DateTime'];
  motSubmissionNo?: Maybe<Scalars['String']>;
  motTransferDate: Scalars['DateTime'];
  projectId: Scalars['String'];
  receivedFrom?: Maybe<Scalars['String']>;
  receivedTitleDutyTransferred: Scalars['DateTime'];
  receiveLawyerAcknowledgement: Scalars['DateTime'];
  receiveMotCancellation: Scalars['DateTime'];
  receiveMotComSec: Scalars['DateTime'];
  receiveMotDirector: Scalars['DateTime'];
  releaseForTitle: Scalars['DateTime'];
  remark?: Maybe<Scalars['String']>;
  requestForTitle: Scalars['DateTime'];
  saleId: Scalars['String'];
  sales?: Maybe<SaleEntity>;
  stampDutyPayment: Scalars['Float'];
  stampDutyPaymentDate: Scalars['DateTime'];
  titleExecutionDate: Scalars['DateTime'];
  titleForward: Scalars['DateTime'];
  titleNotificationDate: Scalars['DateTime'];
  units?: Maybe<UnitEntity>;
};

export type MotTrackingListingOutput = {
  __typename?: 'motTrackingListingOutput';
  id: Scalars['String'];
  titleExecutionDate: Scalars['DateTime'];
  titleNotificationDate: Scalars['DateTime'];
  unitNo: Scalars['String'];
};

export type MotTrackingUnitOutput = {
  __typename?: 'motTrackingUnitOutput';
  buyerSolicitorCode?: Maybe<Scalars['String']>;
  buyerSolicitorName?: Maybe<Scalars['String']>;
  developerSolicitorCode?: Maybe<Scalars['String']>;
  developerSolicitorName?: Maybe<Scalars['String']>;
  hsdHsmNo?: Maybe<Scalars['String']>;
  lotPtNo?: Maybe<Scalars['String']>;
  saleId: Scalars['String'];
  unitNo: Scalars['String'];
};

export type MultipleEsignProjectLetterListingOutput = {
  __typename?: 'MultipleEsignProjectLetterListingOutput';
  letter?: Maybe<Array<ESignProjectLetterListingOutput>>;
  letterTypeName?: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  abortMiscBilling: Scalars['Boolean'];
  activateBank: Scalars['Boolean'];
  activateBillItem: Scalars['Boolean'];
  activateCampaignById: Scalars['Boolean'];
  activateCompany: Scalars['Boolean'];
  activateCurrencyExchange: Scalars['Boolean'];
  activateDesignationById: Scalars['Boolean'];
  activateDirectionById: Scalars['Boolean'];
  activateEducationById: Scalars['Boolean'];
  activateIncomeRangeById: Scalars['Boolean'];
  activateIndustryById: Scalars['Boolean'];
  activateMaritalStatus: Scalars['Boolean'];
  activatePackage: Scalars['Boolean'];
  activatePaymentPlan: Scalars['Boolean'];
  activateProfessionById: Scalars['Boolean'];
  activateProjectTypeById: Scalars['Boolean'];
  activatePropertyTypeById: Scalars['Boolean'];
  activateRaceById: Scalars['Boolean'];
  activateReasonCode: Scalars['Boolean'];
  activateRelationshipById: Scalars['Boolean'];
  activateReligionById: Scalars['Boolean'];
  activateSalutation: Scalars['Boolean'];
  activateSolicitorById: Scalars['Boolean'];
  activateTax: Scalars['Boolean'];
  activateTaxScheme: Scalars['Boolean'];
  activateUnitTypeById: Scalars['Boolean'];
  activateUser: Scalars['Boolean'];
  activateWorkProgressById: Scalars['Boolean'];
  activeDiscount: Scalars['Boolean'];
  addAndEditBookingFeeBySaleId: Scalars['Boolean'];
  addAppointment: Scalars['Boolean'];
  addArAging: Scalars['Boolean'];
  addArchitectCert: Scalars['Boolean'];
  addAreaVarianceIndonesia: Scalars['Boolean'];
  addAssignNotary: Scalars['Boolean'];
  addAttachments: Array<AttachmentEntity>;
  addBank: Scalars['Boolean'];
  addBillItem: Scalars['Boolean'];
  addCampaign: Scalars['Boolean'];
  addCarPark: Scalars['String'];
  addCommissionPayments: Scalars['Boolean'];
  addCommissionStatutoryDocument: Scalars['Boolean'];
  addCompany: Scalars['Boolean'];
  addCompanyBankProfile: Scalars['Boolean'];
  addCompanyCommissionPackage: Scalars['Boolean'];
  addCompanyCommissionPackageDetail: Scalars['Boolean'];
  addCompanyCommissionTeam: Scalars['Boolean'];
  addCompanyNumberingStructure: Scalars['Boolean'];
  addCompanyRewardCommPayment: Scalars['Boolean'];
  addContactPerson: Scalars['Boolean'];
  addCountryCode: Scalars['Boolean'];
  addDeemCollected: Scalars['Boolean'];
  addDesignation: Scalars['Boolean'];
  addDirection: Scalars['Boolean'];
  addDiscount: Scalars['Boolean'];
  addDiscountType: Scalars['Boolean'];
  addEditApprovalPolicy: Scalars['Boolean'];
  addEditApprovalPolicyAssignment: Scalars['Boolean'];
  addEducation: Scalars['Boolean'];
  addEvents: Scalars['Boolean'];
  addExchangeRate: Scalars['Boolean'];
  addFinancierContact: Scalars['Boolean'];
  addIncomeRange: Scalars['Boolean'];
  addIndustry: Scalars['Boolean'];
  addJobPosition: Scalars['Boolean'];
  addJointBuyer: Scalars['Boolean'];
  addKeyCollectionAppointment: Scalars['Boolean'];
  addLad: Scalars['Boolean'];
  addLatePaymentInterest: Scalars['Boolean'];
  addLeadSource: Scalars['Boolean'];
  addLetterTemplate: Scalars['String'];
  addLoanPayment: Scalars['Boolean'];
  addLoanSettlement: Scalars['Boolean'];
  addMaritalStatus: Scalars['Boolean'];
  addMotTracking: Scalars['Boolean'];
  addNotary: Scalars['Boolean'];
  addOverduePurchaseCA: Scalars['Boolean'];
  addPackageIntoSale: Scalars['String'];
  addPACollectionActivity: Scalars['Boolean'];
  addPACollectionActivityIndo: Scalars['Boolean'];
  addPAcontra: Scalars['Boolean'];
  addPAcreditNote: Scalars['Boolean'];
  addPAdebitNote: Scalars['Boolean'];
  addPALateInterestCharges: Scalars['Boolean'];
  addPAmiscBilling: Scalars['Boolean'];
  addPArebate: Scalars['Boolean'];
  addPArefund: Scalars['Boolean'];
  addPasswordPolicy: Scalars['Boolean'];
  addPaymentGateWay: Scalars['Boolean'];
  addPaymentInterestException: Scalars['Boolean'];
  addPaymentPlan: Scalars['Boolean'];
  addPaymentReminderList: Scalars['Boolean'];
  addPriceAdjustment: Scalars['Boolean'];
  addProfession: Scalars['Boolean'];
  addProject: Scalars['Boolean'];
  addProjectAreaVarianceIndonesia: Scalars['Boolean'];
  addProjectBridgingFinancier: Scalars['Boolean'];
  addProjectCluster: Scalars['Boolean'];
  addProjectCommission: Scalars['Boolean'];
  addProjectCommissionPackage: Scalars['Boolean'];
  addProjectCommissionPackageDetail: Scalars['Boolean'];
  addProjectConstruction: Scalars['Boolean'];
  addProjectKeyCollectionContractor: Scalars['Boolean'];
  addProjectKeyCollectionSchedule: Scalars['Boolean'];
  addProjectLad: Scalars['Boolean'];
  addProjectMiscCharges: Scalars['Boolean'];
  addProjectPaymentPlan: Scalars['Boolean'];
  addProjectPaymentReminderException: Scalars['Boolean'];
  addProjectPermit: Scalars['Boolean'];
  addProjectPolicy: Scalars['Boolean'];
  addProjectReminderSetting: Scalars['Boolean'];
  addProjectSalesAndDetailsPolicy?: Maybe<Scalars['Boolean']>;
  addProjectSalesOffice: Scalars['Boolean'];
  addProjectTitle: Scalars['Boolean'];
  addProjectType: Scalars['Boolean'];
  addPromotionalItem: Scalars['Boolean'];
  addPromotionalPackage: Scalars['Boolean'];
  addPropertyType: Scalars['Boolean'];
  addPurchaserIDType: Scalars['Boolean'];
  addPurchaserPaymentPlan: Scalars['Boolean'];
  addPurchaserPaymentPlanDetails: AddPurchaserPaymentPlanDetailsOutput;
  addRace: Scalars['Boolean'];
  addReasonCode: Scalars['Boolean'];
  addReceiptReversal: Scalars['Boolean'];
  addRedemptionRepayment: Scalars['Boolean'];
  addRefinancing: Scalars['Boolean'];
  addRelationship: Scalars['Boolean'];
  addReleaseCollected: Scalars['Boolean'];
  addReligion: Scalars['Boolean'];
  addRescheduleInstallment: Scalars['Boolean'];
  addSaleIntoRegistration: Scalars['Boolean'];
  addSaleLoan: Scalars['Boolean'];
  addSaleLoanBuyBack: Scalars['Boolean'];
  addSaleLoanCancellation: Scalars['Boolean'];
  addSaleLoanEndFin: Scalars['Boolean'];
  addSaleLoanRefinancing: Scalars['Boolean'];
  addSaleLoanRelease: Scalars['Boolean'];
  addSaleMarkUp: Scalars['Boolean'];
  addSaleRebatePackage: Scalars['Boolean'];
  addSalesCancellation: Scalars['Boolean'];
  addSalesContractDiscount: Scalars['Boolean'];
  addSalesContractOtherContact: Scalars['Boolean'];
  addSalesContractPackage: Scalars['Boolean'];
  addSalesContractSubProduct: Scalars['Boolean'];
  addSalesPackage: Scalars['Boolean'];
  addSalesRegistrationDiscount: Scalars['String'];
  addSalesStatutoryDocument: Scalars['Boolean'];
  addSalesTeams: Scalars['Boolean'];
  addSalutation: Scalars['Boolean'];
  addSolicitor: Scalars['Boolean'];
  addStampDuty: Scalars['Boolean'];
  addStandardLetter: Scalars['String'];
  addStandardLetterParameter: Scalars['Boolean'];
  addStatutoryDocument: Scalars['Boolean'];
  addSubsale: Scalars['Boolean'];
  addTax: Scalars['Boolean'];
  addTaxScheme: Scalars['Boolean'];
  addTownship: Scalars['Boolean'];
  addUnitOfMeasurement: UnitOfMeasurementMutationOutput;
  addUnitStatutoryDocument: Scalars['Boolean'];
  addUnitTransfer: Scalars['Boolean'];
  addUnitType: Scalars['Boolean'];
  addUser: Scalars['Boolean'];
  addWorkProgress: Scalars['Boolean'];
  allocatePAmodule: Scalars['Boolean'];
  allocationContraIndo: Scalars['Boolean'];
  allocationReceipt: Scalars['Boolean'];
  allocationReceiptIndo: Scalars['Boolean'];
  approvalArchitectCert: Scalars['Boolean'];
  approveAndCancelBookingFeeById: Scalars['Boolean'];
  approveBuyBackLoan: Scalars['Boolean'];
  approvedMiscBilling: Scalars['Boolean'];
  approvedPurchaserTransfer: Scalars['Boolean'];
  approvedPurchaserTransferInListing: Scalars['Boolean'];
  approveLateInterestsById: Scalars['Boolean'];
  approveRefinancing: Scalars['Boolean'];
  approveRescheduleInstallment: Scalars['Boolean'];
  approveSaleLoanCancellation: Scalars['Boolean'];
  approveSaleLoanRelease: Scalars['Boolean'];
  approveSalesCancellation: Scalars['Boolean'];
  approveUnitTransfer: Scalars['Boolean'];
  approveUnitTransferIndo: Scalars['String'];
  assignAuthorizedSaleStaff: Scalars['Boolean'];
  assignCarPark: Scalars['Boolean'];
  assignClassificationCode: Scalars['Boolean'];
  assignDiscount: Scalars['Boolean'];
  assignMsicCode: Scalars['Boolean'];
  assignOverduedPA: Scalars['Boolean'];
  assignPanel: Scalars['Boolean'];
  assignSolicitorToProject: Scalars['Boolean'];
  assignTeamMember: Scalars['Boolean'];
  cancelFinancialBilling: Scalars['Boolean'];
  cancelKeyCollectionAppointment: Scalars['Boolean'];
  cancelPurchaserTransfer: Scalars['Boolean'];
  changeLeadStatus: Scalars['Boolean'];
  changePassword: Scalars['Boolean'];
  changeStakeholder: Scalars['Boolean'];
  changeSubmittedSaleStatus: Scalars['Boolean'];
  clearPBbyBatchId: Scalars['Boolean'];
  cloneProjectMiscCharges: Scalars['Boolean'];
  cloneStandardLetter: Scalars['Boolean'];
  completedRefinancing: Scalars['Boolean'];
  completeKeyCollectionAppointment: Scalars['Boolean'];
  completeSubsale: Scalars['Boolean'];
  convertToPayment: Scalars['Boolean'];
  convertToSign: SalesContractMutationOutput;
  convertToStamped: Scalars['Boolean'];
  copyFromApprovalPolicy: Scalars['Boolean'];
  copyFromCompanyNumberingStructure: Scalars['Boolean'];
  copyGlAccount: Scalars['Boolean'];
  createBankPayment: Scalars['Boolean'];
  createBillItem: Scalars['Boolean'];
  createCompanyRewardCalculation: Scalars['Boolean'];
  createcontra: ContraEntity;
  createFinancialBilling: FinancialBillingEntity;
  createFinancier: Scalars['Boolean'];
  createGLExport: GlJournalPostStatus;
  createLatePaymentInterestException: Scalars['Boolean'];
  CreateListEntityRoleUser: Scalars['Boolean'];
  createMortgagePayment: Scalars['Boolean'];
  createMortgagePlan: Scalars['Boolean'];
  createMortgageRetention: Scalars['Boolean'];
  createPaidLandDeposit: Scalars['Boolean'];
  createPAIndoDeposit: Scalars['Boolean'];
  createProjectCommissionCalculation: Scalars['Boolean'];
  createProjectFireInsurance: ProjectFireInsuranceEntity;
  createProjectPolicy: ProjectPolicyEntity;
  CreateProjectRoleUser: Scalars['Boolean'];
  createReceipt: Scalars['Boolean'];
  createSalesLandDeposit: Scalars['Boolean'];
  createStampDutyIntegration: Scalars['Boolean'];
  createTransactionCode: TaxTransactionCodeEntity;
  createTransactionCodeDetail: TaxTransactionCodeDetailEntity;
  deactivateBillItem: Scalars['Boolean'];
  deactivateCurrencyExchange: Scalars['Boolean'];
  deactivateDesignationById: Scalars['Boolean'];
  deactivateEducationById: Scalars['Boolean'];
  deactivateIncomeRangeById: Scalars['Boolean'];
  deactivateIndustryById: Scalars['Boolean'];
  deactivateMaritalStatus: Scalars['Boolean'];
  deactivatePackage: Scalars['Boolean'];
  deactivatePaymentPlan: Scalars['Boolean'];
  deactivateProfessionById: Scalars['Boolean'];
  deactivateProjectPaymentPlan: Scalars['Boolean'];
  deactivateReasonCode: Scalars['Boolean'];
  deactivateRelationshipById: Scalars['Boolean'];
  deactivateReligionById: Scalars['Boolean'];
  deactivateSalutation: Scalars['Boolean'];
  deactivateStampDutyById: Scalars['Boolean'];
  deactivateTax: Scalars['Boolean'];
  deactivateTaxScheme: Scalars['Boolean'];
  deactivateWorkProgressById: Scalars['Boolean'];
  deactiveDiscount: Scalars['Boolean'];
  deleteAppointment: Scalars['Boolean'];
  deleteArchitectCert: Scalars['Boolean'];
  deleteAreaVarianceById: Scalars['Boolean'];
  deleteAssignNotary: Scalars['Boolean'];
  deleteAttachment: Scalars['Boolean'];
  deleteBank: Scalars['Boolean'];
  deleteBankPaymentById: Scalars['Boolean'];
  deleteBillItem: Scalars['Boolean'];
  deleteBillItemInt: Scalars['Boolean'];
  DeleteBlockGallery: Scalars['Boolean'];
  deleteBridgingFinancierUnit: DeleteFinancierUnitOutput;
  deleteCampaignById: Scalars['Boolean'];
  deleteCarPark: Scalars['Boolean'];
  deleteCommissionPaymentById: Scalars['Boolean'];
  deleteCommissionStatutoryDocumentById: Scalars['Boolean'];
  deleteCommissionType: Scalars['Boolean'];
  deleteCompany: Scalars['Boolean'];
  deleteCompanyBankProfile: Scalars['Boolean'];
  deleteCompanyCommissionPackageDetail: Scalars['Boolean'];
  deleteCompanyCommissionTeamDetail: Scalars['Boolean'];
  deleteCompanyReward: Scalars['Boolean'];
  deleteCompanyRewardCommPayment: Scalars['Boolean'];
  deleteCompanyRewardCommStatutoryDoc: Scalars['Boolean'];
  deleteContactPerson: Scalars['Boolean'];
  deleteCountryCode: Scalars['Boolean'];
  deleteDesignationById: Scalars['Boolean'];
  deleteDirectionById: Scalars['Boolean'];
  deleteDiscount: Scalars['Boolean'];
  deleteDiscountTypeById: Scalars['Boolean'];
  deleteEducationById: Scalars['Boolean'];
  deleteEventsById: Scalars['Boolean'];
  deleteExchangeRate: Scalars['Boolean'];
  deleteFinancier: Scalars['Boolean'];
  DeleteFloorGallery: Scalars['Boolean'];
  deleteIncomeRangeById: Scalars['Boolean'];
  deleteIndustryById: Scalars['Boolean'];
  deleteJobPosition: Scalars['Boolean'];
  deleteJointBuyer: Scalars['Boolean'];
  deleteKeyCollectionAppointmentById: Scalars['Boolean'];
  deleteLad: Scalars['Boolean'];
  deleteLatePaymentInterest: Scalars['Boolean'];
  deleteLatePaymentInterestException: Scalars['Boolean'];
  deleteLeadSourceById: Scalars['Boolean'];
  deleteLetterTemplateById: Scalars['Boolean'];
  deleteLoanPayment: Scalars['Boolean'];
  deleteLoanSettlement: Scalars['Boolean'];
  deleteMainPurchaser: Scalars['Boolean'];
  deleteMaritalStatusById: Scalars['Boolean'];
  deleteMortgagePayment: Scalars['Boolean'];
  deleteMortgagePlan: Scalars['Boolean'];
  deleteMortgageRetention: Scalars['Boolean'];
  deleteMotTracking: Scalars['Boolean'];
  deleteNotary: Scalars['Boolean'];
  deletePackage: Scalars['Boolean'];
  deletePAdata: Scalars['Boolean'];
  deletePAmbData: Scalars['Boolean'];
  deletePaymentGateway: Scalars['Boolean'];
  deletePaymentInterestException: Scalars['Boolean'];
  deletePaymentPlan: Scalars['Boolean'];
  deletePaymentPlanDetail: Scalars['Boolean'];
  deletePaymentReminderList: Scalars['Boolean'];
  deleteProductConstructionById: Scalars['Boolean'];
  deleteProfessionById: Scalars['Boolean'];
  deleteProjectAreaVarianceIndonesiaById: Scalars['Boolean'];
  deleteProjectBridgingFinancier: Scalars['Boolean'];
  deleteProjectCluster: Scalars['Boolean'];
  deleteProjectCommissionById: Scalars['Boolean'];
  deleteProjectCommissionPackageDetail: Scalars['Boolean'];
  deleteProjectCommissionTeam: Scalars['Boolean'];
  deleteProjectCommissionTeamDetail: Scalars['Boolean'];
  DeleteProjectGallery: Scalars['Boolean'];
  deleteProjectKeyCollectionContractorById: Scalars['Boolean'];
  deleteProjectKeyCollectionSchedule: Scalars['Boolean'];
  deleteProjectMiscCharges: Scalars['Boolean'];
  deleteProjectPaymentPlan: Scalars['Boolean'];
  deleteProjectPaymentReminderException: Scalars['Boolean'];
  deleteProjectPermit: Scalars['Boolean'];
  deleteProjectSalesOffice: Scalars['Boolean'];
  deleteProjectTitle: Scalars['Boolean'];
  deleteProjectTypeById: Scalars['Boolean'];
  deletePromotionalItem: Scalars['Boolean'];
  deletePromotionalItemInDetailsListing: Scalars['Boolean'];
  deletePromotionalPackage: Scalars['Boolean'];
  deletePropertyTypeById: Scalars['Boolean'];
  deletePurchaserIDType: Scalars['Boolean'];
  deletePurchaserPaymentPlan: Scalars['Boolean'];
  deletePurchaserPaymentPlanDetails: Scalars['Boolean'];
  deleteRaceById: Scalars['Boolean'];
  deleteReasonCodeById: Scalars['Boolean'];
  deleteRedemptionRepayment: Scalars['Boolean'];
  deleteRefinancing: Scalars['Boolean'];
  deleteRelationshipById: Scalars['Boolean'];
  deleteReleaseData: Scalars['Boolean'];
  deleteReligionById: Scalars['Boolean'];
  deleteRole: Scalars['Boolean'];
  deleteSaleLoan: Scalars['Boolean'];
  deleteSaleLoanBuyBack: Scalars['Boolean'];
  deleteSaleLoanCancellation: Scalars['Boolean'];
  deleteSaleLoanRefinancing: Scalars['Boolean'];
  deleteSaleLoanRelease: Scalars['Boolean'];
  deleteSalesCancellation: Scalars['Boolean'];
  deleteSalesContractDiscount: Scalars['Boolean'];
  deleteSalesContractOtherContact: Scalars['Boolean'];
  deleteSalesContractPackage: Scalars['Boolean'];
  deleteSalesContractSubProduct: Scalars['Boolean'];
  deleteSalesRebate: Scalars['Boolean'];
  deleteSalesStatutoryDocument: Scalars['Boolean'];
  deleteSalesTeamById: Scalars['Boolean'];
  deleteSalutationById: Scalars['Boolean'];
  deleteSelectedUnits: Scalars['Boolean'];
  deleteStampDutyIntegration: Scalars['Boolean'];
  deleteStandardLetter: Scalars['Boolean'];
  deleteStandardLetterById: Scalars['Boolean'];
  deleteStandardLetterParameterById: Scalars['Boolean'];
  deleteStatutoryDocument: Scalars['Boolean'];
  deleteSubsale: Scalars['Boolean'];
  deleteTownship: Scalars['Boolean'];
  deleteTransactionCode: Scalars['Boolean'];
  deleteTransactionCodeDetail: Scalars['Boolean'];
  DeleteUnitGallery: Scalars['Boolean'];
  deleteUnitOfMeasurementById: Scalars['String'];
  deleteUnitTransfer: Scalars['Boolean'];
  deleteUnitTypeById: Scalars['Boolean'];
  deleteWorkProgressById: Scalars['Boolean'];
  designLetterTemplate: Scalars['Boolean'];
  designProjectLetterTemplate: Scalars['Boolean'];
  discardPendingData: Scalars['Boolean'];
  downloadAttachment: AttachmentOutput;
  duplicatePaymentPlan: Scalars['Boolean'];
  editAppointment: Scalars['Boolean'];
  editArchitectCert: Scalars['Boolean'];
  editAreaVarianceIndonesia: Scalars['Boolean'];
  editAssignDiscount: Scalars['Boolean'];
  editBank: Scalars['Boolean'];
  editBankPayment: Scalars['Boolean'];
  editBillItem: Scalars['Boolean'];
  EditBlockGallery: Scalars['Boolean'];
  editBlockLabel: Scalars['Boolean'];
  editCampaign: Scalars['Boolean'];
  editCarPark: Scalars['Boolean'];
  editCommissionPaymentById: Scalars['Boolean'];
  editCommissionStatutoryDocumentById: Scalars['Boolean'];
  editCompany: Scalars['Boolean'];
  editCompanyBankProfile: Scalars['Boolean'];
  editCompanyCommissionPackageDetail: Scalars['Boolean'];
  editCompanyNumberingStructure: Scalars['Boolean'];
  editCompanyRewardCommPayment: Scalars['Boolean'];
  editContactPerson: Scalars['Boolean'];
  editCountryCode: Scalars['Boolean'];
  editDeemCollected: Scalars['Boolean'];
  editDesignation: Scalars['Boolean'];
  editDirection: Scalars['Boolean'];
  editDiscount: Scalars['Boolean'];
  editDiscountType: Scalars['Boolean'];
  editEducation: Scalars['Boolean'];
  editEmployeeJobPosition: Scalars['Boolean'];
  editEvents: Scalars['Boolean'];
  editExchangeRate: Scalars['Boolean'];
  editFinancialLimit: Scalars['Boolean'];
  editFinancier: Scalars['Boolean'];
  EditFloorGallery: Scalars['Boolean'];
  EditGallery: Scalars['Boolean'];
  EditGalleryTour: Scalars['Boolean'];
  EditGalleryVideo: Scalars['Boolean'];
  editIncomeRange: Scalars['Boolean'];
  editIndustry: Scalars['Boolean'];
  editJobPosition: Scalars['Boolean'];
  editJointBuyer: Scalars['Boolean'];
  editKeyCollectionAppointment: Scalars['Boolean'];
  editLatePaymentInterest: Scalars['Boolean'];
  editLeadSource: Scalars['Boolean'];
  editLetterTemplate: Scalars['String'];
  editLoanPayment: Scalars['Boolean'];
  editMaritalStatus: Scalars['Boolean'];
  editMiscBilling: Scalars['Boolean'];
  editMiscBillingStatus: Scalars['Boolean'];
  editMortgagePayment: Scalars['Boolean'];
  editMortgagePlan: Scalars['Boolean'];
  editMortgageRetention: Scalars['Boolean'];
  editMotTracking: Scalars['Boolean'];
  editOverduePurchaseCA: Scalars['Boolean'];
  editPackageSaleRegistration: Scalars['Boolean'];
  editPACollectionActivity: Scalars['Boolean'];
  editPACollectionActivityIndo: Scalars['Boolean'];
  editPAcontra: Scalars['Boolean'];
  editPAcreditNote: Scalars['Boolean'];
  editPAdebitNote: Scalars['Boolean'];
  editPAIndoDeposit: Scalars['Boolean'];
  editPAmiscBilling: Scalars['Boolean'];
  editPAmoduleStatus: Scalars['Boolean'];
  editPArebate: Scalars['Boolean'];
  editPArefund: Scalars['Boolean'];
  editPasswordPolicy: Scalars['Boolean'];
  editPaymentGateWay: Scalars['Boolean'];
  editPaymentInterestException: Scalars['Boolean'];
  editPaymentPlan: Scalars['Boolean'];
  editPriceAdjustment: Scalars['Boolean'];
  editProductConstruction: Scalars['Boolean'];
  editProfession: Scalars['Boolean'];
  editProject: Scalars['Boolean'];
  editProjectAreaVarianceIndonesia: Scalars['Boolean'];
  editProjectCluster: Scalars['Boolean'];
  editProjectCommissionById: Scalars['Boolean'];
  editProjectCommissionPackageDetail: Scalars['Boolean'];
  EditProjectGallery: Scalars['Boolean'];
  editProjectKeyCollectionContractor: Scalars['Boolean'];
  editProjectLad: Scalars['Boolean'];
  editProjectMiscCharges: Scalars['Boolean'];
  editProjectPaymentPlan: Scalars['Boolean'];
  editProjectPaymentReminderException: Scalars['Boolean'];
  editProjectPermit: Scalars['Boolean'];
  editProjectReminderSetting: Scalars['Boolean'];
  editProjectSalesOffice: Scalars['Boolean'];
  editProjectSalesPolicyAndDetails?: Maybe<Scalars['Boolean']>;
  EditProjectSpec: Scalars['Boolean'];
  editProjectTitle: Scalars['Boolean'];
  editProjectType: Scalars['Boolean'];
  editPromotionalItem: Scalars['Boolean'];
  editPromotionalPackages: Scalars['Boolean'];
  editPropertyType: Scalars['Boolean'];
  editPurchaserIDType: Scalars['Boolean'];
  editPurchaserInfo: Scalars['Boolean'];
  editPurchaserPaymentPlan: Scalars['Boolean'];
  editPurchaserPaymentPlanAndDetails: Scalars['Boolean'];
  editPurchaserPaymentPlanDetails: Scalars['Boolean'];
  editRace: Scalars['Boolean'];
  editReasonCode: Scalars['Boolean'];
  editReceipt: Scalars['Boolean'];
  editRedemptionRepayment: Scalars['Boolean'];
  editRefinancing: Scalars['Boolean'];
  editRelationship: Scalars['Boolean'];
  editReleaseCollected: Scalars['Boolean'];
  editReligion: Scalars['Boolean'];
  editRole: Scalars['Boolean'];
  editSaleLoanBuyBack: Scalars['Boolean'];
  editSaleLoanCancellation: Scalars['Boolean'];
  editSaleLoanEndFin: Scalars['Boolean'];
  editSaleLoanRefinancing: Scalars['Boolean'];
  editSaleLoanRelease: Scalars['Boolean'];
  editSaleRebatePackage: Scalars['Boolean'];
  editSalesCancellation: Scalars['Boolean'];
  editSalesContractDiscount: Scalars['Boolean'];
  editSalesContractOtherContact: Scalars['Boolean'];
  editSalesContractOtherSalesInfo: Scalars['Boolean'];
  editSalesContractPackage: Scalars['Boolean'];
  editSalesContractSolicitors: Scalars['Boolean'];
  editSalesContractSubProduct: Scalars['Boolean'];
  editSalesPackage: Scalars['Boolean'];
  editSalesStatutoryDocument: Scalars['Boolean'];
  editSalesTeams: Scalars['Boolean'];
  editSalutation: Scalars['Boolean'];
  editSolicitor: Scalars['Boolean'];
  editStandardLetter: Scalars['String'];
  editStandardLetterParameter: Scalars['Boolean'];
  editStatutoryDocument: Scalars['Boolean'];
  editSubsale: Scalars['Boolean'];
  editTax: Scalars['Boolean'];
  editTaxScheme: Scalars['Boolean'];
  editTownship: Scalars['Boolean'];
  editTransactionCodeDetail: TaxTransactionCodeDetailEntity;
  EditUnitGallery: Scalars['Boolean'];
  editUnitInformation: Scalars['Boolean'];
  editUnitOfMeasurementById: UnitOfMeasurementMutationOutput;
  editUnitTaxScheme: Scalars['Boolean'];
  editUnitTransfer: Scalars['Boolean'];
  editUnitTransferIndo: Scalars['String'];
  editUnitType: Scalars['Boolean'];
  editUser: Scalars['Boolean'];
  editWorkProgress: Scalars['Boolean'];
  forgotPassword: Scalars['Boolean'];
  generateBillingAreaVariance: Scalars['Boolean'];
  generateCarPark: Scalars['Boolean'];
  generateLatePayment: Scalars['String'];
  generateLatePaymentInterest: Scalars['Boolean'];
  generateMiscBilling: Scalars['Boolean'];
  generateProgressBilling: Scalars['Boolean'];
  generateProgressBillingReminder?: Maybe<DownpaymentReminderDetailOutput>;
  generateReminderSaleList?: Maybe<SaleReminderDetailOutput>;
  generateUnit: Scalars['Boolean'];
  insertNewSaleLoan: Scalars['Boolean'];
  insertNewSaleLoanPayment: Scalars['Boolean'];
  insertNewSaleLoanRetention: Scalars['Boolean'];
  letterTemplateRebuildReport: Scalars['Boolean'];
  login: UserLoginOutput;
  loginWithMicrosoft: UserLoginOutput;
  markAsDefault: Scalars['Boolean'];
  markAsRead: Scalars['Boolean'];
  mergeSalesStatutoryDocument: Scalars['Boolean'];
  newPassword: Scalars['Boolean'];
  newPasswordCheck: Scalars['Boolean'];
  newRole: Scalars['Boolean'];
  organizeDesignation: Scalars['Boolean'];
  organizeDirection: Scalars['Boolean'];
  organizeEducation: Scalars['Boolean'];
  organizeIncomeRange: Scalars['Boolean'];
  organizeIndustry: Scalars['Boolean'];
  organizeLeadSource: Scalars['Boolean'];
  organizeMaritalStatus: Scalars['Boolean'];
  organizeParameter: Scalars['Boolean'];
  organizeProfession: Scalars['Boolean'];
  organizeProjectType: Scalars['Boolean'];
  organizePropertyType: Scalars['Boolean'];
  organizeRace: Scalars['Boolean'];
  organizeReasonCode: Scalars['Boolean'];
  organizeReligion: Scalars['Boolean'];
  organizeSalutation: Scalars['Boolean'];
  organizeUnitType: Scalars['Boolean'];
  PatchingTaxLedger: Scalars['Boolean'];
  postDeemCollected: Scalars['Boolean'];
  postingMiscBilling: Scalars['Boolean'];
  postingProgressBilling: Scalars['Boolean'];
  postingReceipt: Scalars['Boolean'];
  postingRefund: Scalars['Boolean'];
  postRedemptionRepayment: Scalars['Boolean'];
  postReleaseData: Scalars['Boolean'];
  projectLetterTemplateRebuildReport: Scalars['Boolean'];
  recalculateProgressBilling: Scalars['Boolean'];
  rejectApproveReceipt: Scalars['Boolean'];
  rejectLateInterestsById: Scalars['Boolean'];
  rejectRescheduleInstallment: Scalars['Boolean'];
  rejectSaleLoanCancellation: Scalars['Boolean'];
  rejectSaleLoanRelease: Scalars['Boolean'];
  rejectSalesCancellation: Scalars['Boolean'];
  rejectUnitTransfer: Scalars['Boolean'];
  removeDefaultDirection: Scalars['Boolean'];
  removeDefaultIncomeRange: Scalars['Boolean'];
  removeDefaultLeadSource: Scalars['Boolean'];
  removeDefaultMaritalStatus: Scalars['Boolean'];
  removeDefaultParameter: Scalars['Boolean'];
  removeDefaultProjectType: Scalars['Boolean'];
  removeDefaultPropertyType: Scalars['Boolean'];
  removeDefaultRace: Scalars['Boolean'];
  removeDefaultReasonCode: Scalars['Boolean'];
  removeDefaultSalutation: Scalars['Boolean'];
  removeDefaultUnitType: Scalars['Boolean'];
  removeInvitationContact: Scalars['Boolean'];
  renoticeLoanApplication: Scalars['Boolean'];
  reopenSubsale: Scalars['Boolean'];
  rescheduledLoanDifferential: Scalars['Boolean'];
  rescheduleInstallment: Scalars['Boolean'];
  resendInvitation: Scalars['Boolean'];
  resendSolicitorAppointedInvitation: Scalars['Boolean'];
  resetPassword: Scalars['Boolean'];
  resetSalesChartByBlock: Scalars['Boolean'];
  reversalAllocation: Scalars['Boolean'];
  reversalArchitectCert: Scalars['Boolean'];
  reversalAreaVariance: Scalars['Boolean'];
  reversalBankPayment: Scalars['Boolean'];
  reversalLad: Scalars['Boolean'];
  reversalMiscBilling: Scalars['Boolean'];
  reversalPARecordById: Scalars['Boolean'];
  reversalPBdata: Scalars['Boolean'];
  reversalProgressBilling: Scalars['Boolean'];
  reversalRedemptionRepayment: Scalars['Boolean'];
  reversalReleaseData: Scalars['Boolean'];
  reversalStakeholderProcess: Scalars['Boolean'];
  roleAssignment: Scalars['Boolean'];
  saveBookingExpress: Scalars['Boolean'];
  saveDraftPurchaserTransfer: Scalars['Boolean'];
  saveNotificationPermission: Scalars['Boolean'];
  saveUnitsVpLetterDate: Scalars['Boolean'];
  sendProjectInvitation: Scalars['Boolean'];
  setDefaultDesignation: Scalars['Boolean'];
  setDefaultDirection: Scalars['Boolean'];
  setDefaultDiscountForProject: Scalars['Boolean'];
  setDefaultEducation: Scalars['Boolean'];
  setDefaultELetter: Scalars['Boolean'];
  setDefaultFinancierContact: Scalars['Boolean'];
  setDefaultIncomeRange: Scalars['Boolean'];
  setDefaultIndustry: Scalars['Boolean'];
  setDefaultLeadSource: Scalars['Boolean'];
  setDefaultMaritalStatus: Scalars['Boolean'];
  setDefaultParameter: Scalars['Boolean'];
  setDefaultPaymentPlanForProject: Scalars['Boolean'];
  setDefaultProfession: Scalars['Boolean'];
  setDefaultProjectType: Scalars['Boolean'];
  setDefaultPropertyType: Scalars['Boolean'];
  setDefaultRace: Scalars['Boolean'];
  setDefaultReasonCode: Scalars['Boolean'];
  setDefaultReligion: Scalars['Boolean'];
  setDefaultSalesPackageForProject: Scalars['Boolean'];
  setDefaultSalutation: Scalars['Boolean'];
  setDefaultStandardLetter: Scalars['Boolean'];
  setDefaultSystemUse: Scalars['Boolean'];
  setDefaultUnitType: Scalars['Boolean'];
  setProjectCommissionTeam: Scalars['Boolean'];
  setProjectCommissionTeamDetail: Scalars['Boolean'];
  shareDownpaymentReminder?: Maybe<DownpaymentShareOutput>;
  shareDownpaymentReminderByTemplateId?: Maybe<Array<PdfOutput>>;
  sharePaymentReminder: PaymentReminderShareOutput;
  sharePaymentReminderByTemplateId?: Maybe<Array<PdfOutput>>;
  shareSpaReminder: ReminderOutput;
  shareSpaReminderByLetterTemplateId: Scalars['Boolean'];
  softDeletePriceAdjustment: Scalars['Boolean'];
  softDeleteStakeholderProcess: Scalars['Boolean'];
  spaSigningReversal: Scalars['Boolean'];
  submitCommissionType: Scalars['Boolean'];
  submitCompanyCommissionTeamDetail: Scalars['Boolean'];
  submitCompanyReward: Scalars['Boolean'];
  submitCompanyRewardCommStatutoryDoc: Scalars['Boolean'];
  submitNup: Scalars['Boolean'];
  submitUnitTransferForm: Scalars['String'];
  suspendEndFinancier: Scalars['Boolean'];
  suspendSolicitor: Scalars['Boolean'];
  suspendUser: Scalars['Boolean'];
  temporaryUploadUnitBooking: Scalars['Boolean'];
  testGenerateOverdue: Scalars['Boolean'];
  unassignAuthorizedSaleStaff: Scalars['Boolean'];
  unassignClassificationCode: Scalars['Boolean'];
  unassignDiscount: Scalars['Boolean'];
  unassignMsicCode: Scalars['Boolean'];
  unassignPanel: Scalars['Boolean'];
  unassignSolicitorFromProject: Scalars['Boolean'];
  unassignTeamMember: Scalars['Boolean'];
  unblockUser: Scalars['Boolean'];
  unBlockUser: Scalars['Boolean'];
  unSuspendUser: Scalars['Boolean'];
  updateAcceptLead: Scalars['Boolean'];
  updateBillItem: Scalars['Boolean'];
  updateCarParkInstallment: Scalars['Boolean'];
  updateCollectionActivityStatus: Scalars['Boolean'];
  updateDiscardBumi: Scalars['Boolean'];
  updateFinancialBilling: FinancialBillingEntity;
  updateGlAccountMapping: Scalars['Boolean'];
  updateJointBuyerSeq: Scalars['Boolean'];
  updateLateInterestsById: Scalars['Boolean'];
  updateLateInterestStatus: Scalars['Boolean'];
  updateLateInterestStatusByGenerationBatch: Scalars['Boolean'];
  updateLatePaymentInterestException: Scalars['Boolean'];
  updateLoanApproval: Scalars['Boolean'];
  updateNewPassword: Scalars['Boolean'];
  updateNotary: Scalars['Boolean'];
  updatePACollectionActivity: Scalars['Boolean'];
  updatePACollectionActivityIndo: Scalars['Boolean'];
  updatePaymentPlanCarPark: Scalars['Boolean'];
  updatePaymentPlanPackage: Scalars['Boolean'];
  updatePriceAdjustmentStatus: Scalars['Boolean'];
  updateProfile: Scalars['Boolean'];
  updateProgressBilling: Scalars['Boolean'];
  updateProjectFireInsurance: ProjectFireInsuranceEntity;
  updateProjectPolicy: ProjectPolicyEntity;
  updateSaleLoanApprval: Scalars['Boolean'];
  updateSalesCancellationStatus: Scalars['Boolean'];
  updateSalesContractPaymentPlan: Scalars['Boolean'];
  updateStampDuty: Scalars['Boolean'];
  updateStampDutyIntegration: Scalars['Boolean'];
  updateStatusOverduePurchaseCA: Scalars['Boolean'];
  updateTransactionCode: TaxTransactionCodeEntity;
  UpdateUnitGalleryVirtualModel: Scalars['Boolean'];
  UpdateUnitStatus: Scalars['Boolean'];
  updateUserLatestEntity: Scalars['Boolean'];
  voidArchitectCert: Scalars['Boolean'];
};


export type MutationAbortMiscBillingArgs = {
  input: PostingMiscBillingInput;
};


export type MutationActivateBankArgs = {
  bankId: Scalars['String'];
};


export type MutationActivateBillItemArgs = {
  billItemId: Scalars['String'];
};


export type MutationActivateCampaignByIdArgs = {
  campaignId: Scalars['String'];
};


export type MutationActivateCompanyArgs = {
  companyId: Scalars['String'];
};


export type MutationActivateCurrencyExchangeArgs = {
  currencyExchangeId: Scalars['String'];
};


export type MutationActivateDesignationByIdArgs = {
  designationId: Scalars['String'];
};


export type MutationActivateDirectionByIdArgs = {
  directionId: Scalars['String'];
};


export type MutationActivateEducationByIdArgs = {
  educationId: Scalars['String'];
};


export type MutationActivateIncomeRangeByIdArgs = {
  incomeRangeId: Scalars['String'];
};


export type MutationActivateIndustryByIdArgs = {
  industryId: Scalars['String'];
};


export type MutationActivateMaritalStatusArgs = {
  maritalStatusId: Scalars['String'];
};


export type MutationActivatePackageArgs = {
  id: Scalars['String'];
};


export type MutationActivatePaymentPlanArgs = {
  paymentPlanId: Scalars['String'];
};


export type MutationActivateProfessionByIdArgs = {
  professionId: Scalars['String'];
};


export type MutationActivateProjectTypeByIdArgs = {
  projectTypeId: Scalars['String'];
};


export type MutationActivatePropertyTypeByIdArgs = {
  propertyTypeId: Scalars['String'];
};


export type MutationActivateRaceByIdArgs = {
  raceId: Scalars['String'];
};


export type MutationActivateReasonCodeArgs = {
  reasonCodeId: Scalars['String'];
};


export type MutationActivateRelationshipByIdArgs = {
  relationshipId: Scalars['String'];
};


export type MutationActivateReligionByIdArgs = {
  religionId: Scalars['String'];
};


export type MutationActivateSalutationArgs = {
  salutationId: Scalars['String'];
};


export type MutationActivateSolicitorByIdArgs = {
  solicitorAppointedId: Scalars['String'];
};


export type MutationActivateTaxArgs = {
  taxId: Scalars['String'];
};


export type MutationActivateTaxSchemeArgs = {
  taxSchemeId: Scalars['String'];
};


export type MutationActivateUnitTypeByIdArgs = {
  unitTypeId: Scalars['String'];
};


export type MutationActivateUserArgs = {
  input: UpdatePasswordInput;
};


export type MutationActivateWorkProgressByIdArgs = {
  progressId: Scalars['String'];
};


export type MutationActiveDiscountArgs = {
  discountId: Scalars['String'];
};


export type MutationAddAndEditBookingFeeBySaleIdArgs = {
  input: AddAndEditBookingFeeInput;
};


export type MutationAddAppointmentArgs = {
  input: NewAppointmentInput;
};


export type MutationAddArAgingArgs = {
  input: AddAccountReceivableAging;
};


export type MutationAddArchitectCertArgs = {
  input: ArchitectCertInput;
};


export type MutationAddAreaVarianceIndonesiaArgs = {
  input: AreaVarianceInputIndonesia;
};


export type MutationAddAssignNotaryArgs = {
  input: AddAssignNotaryInput;
};


export type MutationAddAttachmentsArgs = {
  input: SalesAddAttachmentsInput;
};


export type MutationAddBankArgs = {
  input: AddBankInput;
};


export type MutationAddBillItemArgs = {
  input: AddBillItemInput;
};


export type MutationAddCampaignArgs = {
  input: AdminCampaignInput;
};


export type MutationAddCarParkArgs = {
  input: AddCarParkInput;
};


export type MutationAddCommissionPaymentsArgs = {
  inputs: Array<AddCommissionPaymentInput>;
};


export type MutationAddCommissionStatutoryDocumentArgs = {
  input: AddCommissionStatutoryDocumentInput;
};


export type MutationAddCompanyArgs = {
  file: Scalars['Upload'];
  input: AddCompanyInput;
};


export type MutationAddCompanyBankProfileArgs = {
  inputBankProfile: AddCompanyBankProfileInput;
};


export type MutationAddCompanyCommissionPackageArgs = {
  companyCommissionId: Scalars['String'];
  principal: Scalars['String'];
};


export type MutationAddCompanyCommissionPackageDetailArgs = {
  input: CompanyCommissionPackageDetailInput;
};


export type MutationAddCompanyCommissionTeamArgs = {
  generateDate: Scalars['DateTime'];
};


export type MutationAddCompanyNumberingStructureArgs = {
  input: AddNumberingFormatInput;
};


export type MutationAddCompanyRewardCommPaymentArgs = {
  input: Array<CommissionPaymentInput>;
};


export type MutationAddContactPersonArgs = {
  input: SaleContactPersonInput;
  saleId: Scalars['String'];
};


export type MutationAddCountryCodeArgs = {
  input: AddCountryCodeInput;
};


export type MutationAddDeemCollectedArgs = {
  input: DeemCollectedInput;
};


export type MutationAddDesignationArgs = {
  input: ParameterInput;
};


export type MutationAddDirectionArgs = {
  input: DirectionInput;
};


export type MutationAddDiscountArgs = {
  input: DiscountInput;
};


export type MutationAddDiscountTypeArgs = {
  input: DiscountTypeInput;
};


export type MutationAddEditApprovalPolicyArgs = {
  input: AddEditApprovalPolicyInput;
};


export type MutationAddEditApprovalPolicyAssignmentArgs = {
  input: AddEditApprovalAssignmentInput;
};


export type MutationAddEducationArgs = {
  input: ParameterInput;
};


export type MutationAddEventsArgs = {
  input: AdminEventsInput;
};


export type MutationAddExchangeRateArgs = {
  input: CurrencyExchangeRateInput;
};


export type MutationAddFinancierContactArgs = {
  financier_id: Scalars['String'];
  input: FinancierContact;
};


export type MutationAddIncomeRangeArgs = {
  input: IncomeRangeInput;
};


export type MutationAddIndustryArgs = {
  input: ParameterInput;
};


export type MutationAddJobPositionArgs = {
  input: AddJobPositionInput;
};


export type MutationAddJointBuyerArgs = {
  input: Buyer;
};


export type MutationAddKeyCollectionAppointmentArgs = {
  input: KeyCollectionAppointmentInput;
};


export type MutationAddLadArgs = {
  input: AddLadInput;
};


export type MutationAddLatePaymentInterestArgs = {
  input: AddLateInterestInput;
};


export type MutationAddLeadSourceArgs = {
  input: LeadSourceInput;
};


export type MutationAddLetterTemplateArgs = {
  input: LetterTemplateInput;
};


export type MutationAddLoanPaymentArgs = {
  input: AddLoanPaymentInput;
  projectId: Scalars['String'];
  status: Scalars['String'];
};


export type MutationAddLoanSettlementArgs = {
  input: AddLoanSettlementInput;
};


export type MutationAddMaritalStatusArgs = {
  input: MaritalStatusInput;
};


export type MutationAddMotTrackingArgs = {
  input: AddMotTrackingInput;
};


export type MutationAddNotaryArgs = {
  input: NotaryInput;
};


export type MutationAddOverduePurchaseCaArgs = {
  input: AddOverduePurchaseCaInput;
};


export type MutationAddPackageIntoSaleArgs = {
  input: AddPackageInput;
};


export type MutationAddPaCollectionActivityArgs = {
  input: AddPaCollectionActivityListingInput;
};


export type MutationAddPaCollectionActivityIndoArgs = {
  input: AddOverduePurchaseCaInput;
};


export type MutationAddPAcontraArgs = {
  input: AddPAmoduleDataInput;
  isSubmitted: Scalars['Boolean'];
};


export type MutationAddPAcreditNoteArgs = {
  input: AddPAmoduleDataInput;
  isSubmitted: Scalars['Boolean'];
};


export type MutationAddPAdebitNoteArgs = {
  input: AddPAdebitNoteInput;
  isSubmitted: Scalars['Boolean'];
};


export type MutationAddPaLateInterestChargesArgs = {
  input: AddPaLateInterestInput;
};


export type MutationAddPAmiscBillingArgs = {
  input: AddPaMiscBillingInput;
  isSubmitted: Scalars['Boolean'];
};


export type MutationAddPArebateArgs = {
  input: AddPAmoduleDataInput;
  isSubmitted: Scalars['Boolean'];
};


export type MutationAddPArefundArgs = {
  input: AddRefundDataInput;
  isSubmitted: Scalars['Boolean'];
};


export type MutationAddPasswordPolicyArgs = {
  input: PasswordPolicyInput;
};


export type MutationAddPaymentGateWayArgs = {
  input: PaymentGatewayInput;
};


export type MutationAddPaymentInterestExceptionArgs = {
  input: Array<AddPaymentinterestExceptionInput>;
};


export type MutationAddPaymentPlanArgs = {
  input: AddPaymentPlanInput;
};


export type MutationAddPaymentReminderListArgs = {
  input: PaymentReminderListInput;
};


export type MutationAddPriceAdjustmentArgs = {
  input: AddPriceAdjustmentInput;
};


export type MutationAddProfessionArgs = {
  input: ParameterInput;
};


export type MutationAddProjectArgs = {
  input: AdminProjectInput;
};


export type MutationAddProjectAreaVarianceIndonesiaArgs = {
  input: AddProjectAreaVarianceInputIndonesia;
};


export type MutationAddProjectBridgingFinancierArgs = {
  input: ProjectBridgingFinancierInput;
};


export type MutationAddProjectClusterArgs = {
  input: AddProjectClusterInput;
};


export type MutationAddProjectCommissionArgs = {
  input: AddProjectCommissionInput;
};


export type MutationAddProjectCommissionPackageArgs = {
  principal: Scalars['String'];
  projectCommissionId: Scalars['String'];
};


export type MutationAddProjectCommissionPackageDetailArgs = {
  input: ProjectCommissionPackageDetailInput;
};


export type MutationAddProjectConstructionArgs = {
  input: ProjectConstructionInput;
};


export type MutationAddProjectKeyCollectionContractorArgs = {
  input: ProjectKeyCollectionContractorInput;
};


export type MutationAddProjectKeyCollectionScheduleArgs = {
  input: ProjectKeyCollectionInput;
};


export type MutationAddProjectLadArgs = {
  input: ProjectLadInput;
};


export type MutationAddProjectMiscChargesArgs = {
  input: AddProjectMiscChargesInput;
};


export type MutationAddProjectPaymentPlanArgs = {
  input: AddProjectPaymentPlanInput;
};


export type MutationAddProjectPaymentReminderExceptionArgs = {
  input: Array<ProjectPaymentReminderExceptionInput>;
};


export type MutationAddProjectPermitArgs = {
  input: AddProjectPermitInput;
};


export type MutationAddProjectPolicyArgs = {
  latePaymentInput: LateInterestInput;
  projectPolicyInput: ProjectPolicyInput;
};


export type MutationAddProjectReminderSettingArgs = {
  input: AddProjectReminderInput;
};


export type MutationAddProjectSalesAndDetailsPolicyArgs = {
  input: AddProjectSalesPolicyInput;
  projectId: Scalars['String'];
};


export type MutationAddProjectSalesOfficeArgs = {
  input: SalesOfficeInput;
};


export type MutationAddProjectTitleArgs = {
  input: AddProjectTitleInput;
};


export type MutationAddProjectTypeArgs = {
  input: ProjectTypeInput;
};


export type MutationAddPromotionalItemArgs = {
  input: AddPromotionalItemInput;
};


export type MutationAddPromotionalPackageArgs = {
  input: AddPromotionalPackagesInput;
  projectId: Scalars['String'];
};


export type MutationAddPropertyTypeArgs = {
  input: PropertyTypeInput;
};


export type MutationAddPurchaserIdTypeArgs = {
  input: AddPurchaserIdTypeInput;
};


export type MutationAddPurchaserPaymentPlanArgs = {
  input: AddPurchaserPaymentPlanInput;
};


export type MutationAddPurchaserPaymentPlanDetailsArgs = {
  input: AddPurchaserPaymentPlantDetailsInput;
  paymentPlanId: Scalars['String'];
};


export type MutationAddRaceArgs = {
  input: RaceInput;
};


export type MutationAddReasonCodeArgs = {
  input: ReasonCodeInput;
};


export type MutationAddReceiptReversalArgs = {
  receiptId: Scalars['String'];
};


export type MutationAddRedemptionRepaymentArgs = {
  input: RedemptionRepaymentInput;
};


export type MutationAddRefinancingArgs = {
  input: AddRefinancingInput;
};


export type MutationAddRelationshipArgs = {
  input: ParameterInput;
};


export type MutationAddReleaseCollectedArgs = {
  input: ReleaseCollectedInput;
};


export type MutationAddReligionArgs = {
  input: ParameterInput;
};


export type MutationAddRescheduleInstallmentArgs = {
  input: RescheduleInstInput;
};


export type MutationAddSaleIntoRegistrationArgs = {
  input: SalesRegistrationInput;
};


export type MutationAddSaleLoanArgs = {
  input: AddSaleLoanInput;
};


export type MutationAddSaleLoanBuyBackArgs = {
  input: AddSaleLoanBuyBackListInput;
};


export type MutationAddSaleLoanCancellationArgs = {
  input: AddSaleLoanCancellationInput;
};


export type MutationAddSaleLoanEndFinArgs = {
  input: AddSaleLoanDetailInput;
};


export type MutationAddSaleLoanRefinancingArgs = {
  input: AddSaleLoanRefinancingInput;
};


export type MutationAddSaleLoanReleaseArgs = {
  input: SaleLoanReleaseInput;
};


export type MutationAddSaleMarkUpArgs = {
  input: MarkUpInput;
};


export type MutationAddSaleRebatePackageArgs = {
  input: AddSalesContractRebateInput;
};


export type MutationAddSalesCancellationArgs = {
  input: AddSalesCancellationInput;
};


export type MutationAddSalesContractDiscountArgs = {
  input: AddSalesContractDiscountInput;
  saleId: Scalars['String'];
};


export type MutationAddSalesContractOtherContactArgs = {
  input: AddSalesContractContactInput;
  saleID: Scalars['String'];
};


export type MutationAddSalesContractPackageArgs = {
  input: AddSalesContractPackageInput;
  saleID: Scalars['String'];
};


export type MutationAddSalesContractSubProductArgs = {
  input: AddSalesContractSubproductInput;
  saleID: Scalars['String'];
  unitID: Scalars['String'];
};


export type MutationAddSalesPackageArgs = {
  input: AddSalesPackageInput;
};


export type MutationAddSalesRegistrationDiscountArgs = {
  input: AddSalesContractDiscountInput;
  saleId: Scalars['String'];
};


export type MutationAddSalesStatutoryDocumentArgs = {
  input: AddSalesStatutoryDocumentIndoInput;
};


export type MutationAddSalesTeamsArgs = {
  input: TeamInput;
};


export type MutationAddSalutationArgs = {
  input: SalutationInput;
};


export type MutationAddSolicitorArgs = {
  input: AdminSolicitorInput;
};


export type MutationAddStampDutyArgs = {
  input: AddStampDutyInput;
};


export type MutationAddStandardLetterArgs = {
  input: StandardLetterInput;
};


export type MutationAddStandardLetterParameterArgs = {
  input: StandardLetterParameterInput;
};


export type MutationAddStatutoryDocumentArgs = {
  input: AddStatutoryDocumentIndoInput;
};


export type MutationAddSubsaleArgs = {
  input: AddSubsaleInput;
};


export type MutationAddTaxArgs = {
  input: AddTaxInput;
};


export type MutationAddTaxSchemeArgs = {
  input: AddTaxSchemeInput;
};


export type MutationAddTownshipArgs = {
  input: AddTownshipInput;
};


export type MutationAddUnitOfMeasurementArgs = {
  input: UnitOfMeasurementMutationInput;
};


export type MutationAddUnitStatutoryDocumentArgs = {
  input: AddUnitStatutoryDocumentIndoInput;
};


export type MutationAddUnitTransferArgs = {
  input: AddUnitTransferInput;
};


export type MutationAddUnitTypeArgs = {
  input: UnitTypeInput;
};


export type MutationAddUserArgs = {
  input: NewUserInput;
};


export type MutationAddWorkProgressArgs = {
  input: WorkProgressInput;
};


export type MutationAllocatePAmoduleArgs = {
  input: AllocatePAmoduleDataInput;
};


export type MutationAllocationContraIndoArgs = {
  input: AllocationContraInput;
};


export type MutationAllocationReceiptArgs = {
  input: AllocationInput;
};


export type MutationAllocationReceiptIndoArgs = {
  input: AllocationInputIndo;
};


export type MutationApprovalArchitectCertArgs = {
  architectCertId: Scalars['String'];
  projectId: Scalars['String'];
  unitIds: Array<Scalars['String']>;
};


export type MutationApproveAndCancelBookingFeeByIdArgs = {
  input: ApproveAndCancelBookingFeeInput;
};


export type MutationApproveBuyBackLoanArgs = {
  buyBackLoanId: Scalars['String'];
  projectId: Scalars['String'];
};


export type MutationApprovedMiscBillingArgs = {
  action: Scalars['String'];
  generationBatchIds: Array<Scalars['String']>;
};


export type MutationApprovedPurchaserTransferArgs = {
  input: AddPurchaserTransferInput;
};


export type MutationApprovedPurchaserTransferInListingArgs = {
  input: ApprovedPurchaserInListingInput;
};


export type MutationApproveLateInterestsByIdArgs = {
  lateInterestId: Scalars['String'];
  saleId: Scalars['String'];
};


export type MutationApproveRefinancingArgs = {
  projectId: Scalars['String'];
  refinancingId: Scalars['String'];
};


export type MutationApproveRescheduleInstallmentArgs = {
  rescheduleId: Scalars['String'];
  saleId: Scalars['String'];
};


export type MutationApproveSaleLoanCancellationArgs = {
  saleLoanCancellationIds: Array<Scalars['String']>;
};


export type MutationApproveSaleLoanReleaseArgs = {
  releaseId: Scalars['String'];
};


export type MutationApproveSalesCancellationArgs = {
  ids: Array<Scalars['String']>;
};


export type MutationApproveUnitTransferArgs = {
  unitTransferIds: Array<Scalars['String']>;
};


export type MutationApproveUnitTransferIndoArgs = {
  input: ApproveUnitTransferIndoInput;
};


export type MutationAssignAuthorizedSaleStaffArgs = {
  projectId: Scalars['String'];
  salesPersonId: Array<Scalars['String']>;
};


export type MutationAssignCarParkArgs = {
  input: Array<AssignCarParkInput>;
};


export type MutationAssignClassificationCodeArgs = {
  billItemIds: Array<Scalars['String']>;
  classificationId: Scalars['String'];
};


export type MutationAssignDiscountArgs = {
  input: AssignDiscountInput;
};


export type MutationAssignMsicCodeArgs = {
  billItemIds: Array<Scalars['String']>;
  msicId: Scalars['String'];
};


export type MutationAssignOverduedPaArgs = {
  input: Array<AssignOverduedPaInput>;
};


export type MutationAssignPanelArgs = {
  input: AdminFinancierPanelInput;
};


export type MutationAssignSolicitorToProjectArgs = {
  project_id: Scalars['String'];
  solicitor_appointed_id: Array<Scalars['String']>;
};


export type MutationAssignTeamMemberArgs = {
  projectId: Scalars['String'];
  teamId: Scalars['String'];
  userIds: Array<Scalars['String']>;
};


export type MutationCancelFinancialBillingArgs = {
  input: DeleteFinancialBillingInput;
};


export type MutationCancelKeyCollectionAppointmentArgs = {
  id: Scalars['String'];
  saleId: Scalars['String'];
};


export type MutationCancelPurchaserTransferArgs = {
  input: CancelPurchaserTransferInput;
};


export type MutationChangeLeadStatusArgs = {
  sourceId: Scalars['String'];
  status: Scalars['Boolean'];
};


export type MutationChangePasswordArgs = {
  input: UserChangePasswordInput;
};


export type MutationChangeStakeholderArgs = {
  saleIdList: Array<Scalars['String']>;
  solicitorId: Scalars['String'];
};


export type MutationChangeSubmittedSaleStatusArgs = {
  saleId: Scalars['String'];
  status: Scalars['String'];
};


export type MutationClearPBbyBatchIdArgs = {
  generateBatchId: Scalars['String'];
};


export type MutationCloneProjectMiscChargesArgs = {
  cloneProjectMiscChargesId: Scalars['String'];
};


export type MutationCloneStandardLetterArgs = {
  letterTemplateIds: Array<Scalars['String']>;
};


export type MutationCompletedRefinancingArgs = {
  generationBatch: Scalars['String'];
};


export type MutationCompleteKeyCollectionAppointmentArgs = {
  input: CompletedCollectionAppointment;
};


export type MutationCompleteSubsaleArgs = {
  subsaleId: Scalars['String'];
};


export type MutationConvertToPaymentArgs = {
  depositDate: Scalars['String'];
  depositId: Scalars['String'];
  documentAmount: Scalars['Float'];
};


export type MutationConvertToSignArgs = {
  input: UpdateSnpSigned;
};


export type MutationConvertToStampedArgs = {
  input: UpdateSnpStamped;
};


export type MutationCopyFromApprovalPolicyArgs = {
  category: Scalars['String'];
};


export type MutationCopyFromCompanyNumberingStructureArgs = {
  input: CopyFromNumberingFormatInput;
};


export type MutationCopyGlAccountArgs = {
  companyId: Scalars['String'];
  copyCompanyId: Scalars['String'];
};


export type MutationCreateBankPaymentArgs = {
  input: AddBankPaymentInput;
};


export type MutationCreateBillItemArgs = {
  input: BillItemIntInput;
};


export type MutationCreateCompanyRewardCalculationArgs = {
  input: Array<CompanyRewardInput>;
  inputDetail: Array<CompanyRewardDetailInput>;
};


export type MutationCreatecontraArgs = {
  input: ContraInput;
};


export type MutationCreateFinancialBillingArgs = {
  input: FinancialBillingInput;
};


export type MutationCreateFinancierArgs = {
  input: FinancierInput;
};


export type MutationCreateGlExportArgs = {
  input: GlExportInput;
};


export type MutationCreateLatePaymentInterestExceptionArgs = {
  input: LatePaymentInterestExceptionInput;
};


export type MutationCreateListEntityRoleUserArgs = {
  projectId: Scalars['String'];
  roleUserIDs: Array<UserRoleAssignmentInput>;
};


export type MutationCreateMortgagePaymentArgs = {
  input: MortgagePaymentInput;
};


export type MutationCreateMortgagePlanArgs = {
  input: MortgagePlanInput;
};


export type MutationCreateMortgageRetentionArgs = {
  input: MortgageRetentionInput;
};


export type MutationCreatePaidLandDepositArgs = {
  input: PaidLandDepositInput;
};


export type MutationCreatePaIndoDepositArgs = {
  input: PaIndoDepositInput;
};


export type MutationCreateProjectCommissionCalculationArgs = {
  input: Array<CommissionCalculationInput>;
  inputDetail: Array<CommissionCalculationDetailInput>;
};


export type MutationCreateProjectFireInsuranceArgs = {
  input: ProjectFireInsuranceInput;
};


export type MutationCreateProjectPolicyArgs = {
  input: AddProjectPolicyInput;
};


export type MutationCreateProjectRoleUserArgs = {
  input: ProjectRoleInput;
};


export type MutationCreateReceiptArgs = {
  input: ReceiptInput;
};


export type MutationCreateSalesLandDepositArgs = {
  saleId: Scalars['String'];
};


export type MutationCreateStampDutyIntegrationArgs = {
  input: CreateStampDutyIntegrationInput;
};


export type MutationCreateTransactionCodeArgs = {
  description: Scalars['String'];
  taxTrxCode: Scalars['String'];
};


export type MutationCreateTransactionCodeDetailArgs = {
  input: CreateTransactionCodeDetailInput;
};


export type MutationDeactivateBillItemArgs = {
  billItemId: Scalars['String'];
};


export type MutationDeactivateCurrencyExchangeArgs = {
  currencyExchangeId: Scalars['String'];
};


export type MutationDeactivateDesignationByIdArgs = {
  designationId: Scalars['String'];
};


export type MutationDeactivateEducationByIdArgs = {
  educationId: Scalars['String'];
};


export type MutationDeactivateIncomeRangeByIdArgs = {
  incomeRangeId: Scalars['String'];
};


export type MutationDeactivateIndustryByIdArgs = {
  industryId: Scalars['String'];
};


export type MutationDeactivateMaritalStatusArgs = {
  maritalStatusId: Scalars['String'];
};


export type MutationDeactivatePackageArgs = {
  id: Scalars['String'];
};


export type MutationDeactivatePaymentPlanArgs = {
  paymentPlanId: Scalars['String'];
};


export type MutationDeactivateProfessionByIdArgs = {
  professionId: Scalars['String'];
};


export type MutationDeactivateProjectPaymentPlanArgs = {
  projectPaymentPlanId: Scalars['String'];
  typePaymentPlan: TypePaymentPlanEnum;
};


export type MutationDeactivateReasonCodeArgs = {
  reasonCodeId: Scalars['String'];
};


export type MutationDeactivateRelationshipByIdArgs = {
  relationshipId: Scalars['String'];
};


export type MutationDeactivateReligionByIdArgs = {
  religionId: Scalars['String'];
};


export type MutationDeactivateSalutationArgs = {
  salutationId: Scalars['String'];
};


export type MutationDeactivateStampDutyByIdArgs = {
  id: Scalars['String'];
};


export type MutationDeactivateTaxArgs = {
  isDeletable: Scalars['Boolean'];
  taxId: Scalars['String'];
};


export type MutationDeactivateTaxSchemeArgs = {
  isDeletable: Scalars['Boolean'];
  taxSchemeId: Scalars['String'];
};


export type MutationDeactivateWorkProgressByIdArgs = {
  progressId: Scalars['String'];
};


export type MutationDeactiveDiscountArgs = {
  discountId: Scalars['String'];
};


export type MutationDeleteAppointmentArgs = {
  appointment_id: Scalars['String'];
};


export type MutationDeleteArchitectCertArgs = {
  architectCertId: Scalars['String'];
  projectId: Scalars['String'];
};


export type MutationDeleteAreaVarianceByIdArgs = {
  areaVarianceId: Scalars['String'];
  saleId: Scalars['String'];
};


export type MutationDeleteAssignNotaryArgs = {
  input: DeleteAssignNotaryInput;
};


export type MutationDeleteAttachmentArgs = {
  attachmentId: Scalars['String'];
};


export type MutationDeleteBankArgs = {
  bankId: Scalars['String'];
  isDeletable: Scalars['Boolean'];
};


export type MutationDeleteBankPaymentByIdArgs = {
  generationBatchId: Scalars['String'];
};


export type MutationDeleteBillItemArgs = {
  id: Scalars['String'];
};


export type MutationDeleteBillItemIntArgs = {
  id: Scalars['String'];
};


export type MutationDeleteBlockGalleryArgs = {
  input: Array<AdminEditLayoutBlockInput>;
};


export type MutationDeleteBridgingFinancierUnitArgs = {
  bfId: Scalars['String'];
  bfuId: Scalars['String'];
};


export type MutationDeleteCampaignByIdArgs = {
  campaignId: Scalars['String'];
  isDeletable: Scalars['Boolean'];
};


export type MutationDeleteCarParkArgs = {
  carParkId: Scalars['String'];
};


export type MutationDeleteCommissionPaymentByIdArgs = {
  id: Scalars['String'];
};


export type MutationDeleteCommissionStatutoryDocumentByIdArgs = {
  id: Scalars['String'];
};


export type MutationDeleteCommissionTypeArgs = {
  id: Scalars['String'];
};


export type MutationDeleteCompanyArgs = {
  companyId: Scalars['String'];
};


export type MutationDeleteCompanyBankProfileArgs = {
  bankId: Scalars['String'];
  companyId: Scalars['String'];
};


export type MutationDeleteCompanyCommissionPackageDetailArgs = {
  id: Scalars['String'];
};


export type MutationDeleteCompanyCommissionTeamDetailArgs = {
  id: Scalars['String'];
};


export type MutationDeleteCompanyRewardArgs = {
  id: Scalars['String'];
};


export type MutationDeleteCompanyRewardCommPaymentArgs = {
  id: Scalars['String'];
};


export type MutationDeleteCompanyRewardCommStatutoryDocArgs = {
  id: Scalars['String'];
};


export type MutationDeleteContactPersonArgs = {
  saleContactId: Scalars['String'];
};


export type MutationDeleteCountryCodeArgs = {
  id: Scalars['String'];
};


export type MutationDeleteDesignationByIdArgs = {
  designationId: Scalars['String'];
};


export type MutationDeleteDirectionByIdArgs = {
  directionId: Scalars['String'];
  isDeletable: Scalars['Boolean'];
};


export type MutationDeleteDiscountArgs = {
  discountId: Scalars['String'];
  isDeletable: Scalars['Boolean'];
};


export type MutationDeleteDiscountTypeByIdArgs = {
  discountTypeId: Scalars['String'];
};


export type MutationDeleteEducationByIdArgs = {
  educationId: Scalars['String'];
};


export type MutationDeleteEventsByIdArgs = {
  eventsId: Scalars['String'];
};


export type MutationDeleteExchangeRateArgs = {
  id: Scalars['String'];
};


export type MutationDeleteFinancierArgs = {
  financier_id: Scalars['String'];
};


export type MutationDeleteFloorGalleryArgs = {
  input: Array<AdminEditLayoutFloorInput>;
};


export type MutationDeleteIncomeRangeByIdArgs = {
  incomeRangeId: Scalars['String'];
};


export type MutationDeleteIndustryByIdArgs = {
  industryId: Scalars['String'];
};


export type MutationDeleteJobPositionArgs = {
  positionId: Scalars['String'];
};


export type MutationDeleteJointBuyerArgs = {
  jointBuyerId: Scalars['String'];
  saleId: Scalars['String'];
};


export type MutationDeleteKeyCollectionAppointmentByIdArgs = {
  id: Scalars['String'];
};


export type MutationDeleteLadArgs = {
  ladId: Scalars['String'];
};


export type MutationDeleteLatePaymentInterestArgs = {
  ID: Scalars['String'];
};


export type MutationDeleteLatePaymentInterestExceptionArgs = {
  id: Scalars['String'];
};


export type MutationDeleteLeadSourceByIdArgs = {
  sourceId: Scalars['String'];
};


export type MutationDeleteLetterTemplateByIdArgs = {
  letterTemplateId: Scalars['String'];
};


export type MutationDeleteLoanPaymentArgs = {
  id: Scalars['String'];
};


export type MutationDeleteLoanSettlementArgs = {
  saleId: Scalars['String'];
};


export type MutationDeleteMainPurchaserArgs = {
  saleId: Scalars['String'];
};


export type MutationDeleteMaritalStatusByIdArgs = {
  maritalStatusId: Scalars['String'];
};


export type MutationDeleteMortgagePaymentArgs = {
  input: Scalars['String'];
};


export type MutationDeleteMortgagePlanArgs = {
  input: Scalars['String'];
};


export type MutationDeleteMortgageRetentionArgs = {
  input: Scalars['String'];
};


export type MutationDeleteMotTrackingArgs = {
  motTrackingId: Scalars['String'];
};


export type MutationDeleteNotaryArgs = {
  id: Scalars['String'];
};


export type MutationDeletePackageArgs = {
  packageId: Scalars['String'];
};


export type MutationDeletePAdataArgs = {
  haveAllocation: Scalars['Boolean'];
  id: Scalars['String'];
  tableRef: Scalars['String'];
};


export type MutationDeletePAmbDataArgs = {
  id: Scalars['String'];
};


export type MutationDeletePaymentGatewayArgs = {
  payment_gateway_id: Scalars['String'];
};


export type MutationDeletePaymentInterestExceptionArgs = {
  input: DeletePaymentinterestExceptionInput;
};


export type MutationDeletePaymentPlanArgs = {
  paymentPlanId: Scalars['String'];
};


export type MutationDeletePaymentPlanDetailArgs = {
  detailId: Scalars['String'];
};


export type MutationDeletePaymentReminderListArgs = {
  input: PaymentReminderIdsInput;
};


export type MutationDeleteProductConstructionByIdArgs = {
  projectConstructionId: Scalars['String'];
  projectId: Scalars['String'];
};


export type MutationDeleteProfessionByIdArgs = {
  professionId: Scalars['String'];
};


export type MutationDeleteProjectAreaVarianceIndonesiaByIdArgs = {
  projectAreaVarianceId: Scalars['String'];
};


export type MutationDeleteProjectBridgingFinancierArgs = {
  id: Scalars['String'];
};


export type MutationDeleteProjectClusterArgs = {
  id: Scalars['String'];
};


export type MutationDeleteProjectCommissionByIdArgs = {
  id: Scalars['String'];
};


export type MutationDeleteProjectCommissionPackageDetailArgs = {
  id: Scalars['String'];
};


export type MutationDeleteProjectCommissionTeamArgs = {
  id: Scalars['String'];
};


export type MutationDeleteProjectCommissionTeamDetailArgs = {
  id: Scalars['String'];
};


export type MutationDeleteProjectGalleryArgs = {
  input: Array<AdminEditProjectGalleryInput>;
};


export type MutationDeleteProjectKeyCollectionContractorByIdArgs = {
  id: Scalars['String'];
};


export type MutationDeleteProjectKeyCollectionScheduleArgs = {
  collectionKeyScheduleID: Scalars['String'];
};


export type MutationDeleteProjectMiscChargesArgs = {
  projectMiscChargesId: Scalars['String'];
};


export type MutationDeleteProjectPaymentPlanArgs = {
  projectPaymentPlanId: Scalars['String'];
  typePaymentPlan: TypePaymentPlanEnum;
};


export type MutationDeleteProjectPaymentReminderExceptionArgs = {
  id: Scalars['String'];
};


export type MutationDeleteProjectPermitArgs = {
  id: Scalars['String'];
};


export type MutationDeleteProjectSalesOfficeArgs = {
  ID: Scalars['String'];
};


export type MutationDeleteProjectTitleArgs = {
  projectTitleId: Scalars['String'];
};


export type MutationDeleteProjectTypeByIdArgs = {
  isDeletable: Scalars['Boolean'];
  projectTypeId: Scalars['String'];
};


export type MutationDeletePromotionalItemArgs = {
  projectId: Scalars['String'];
  promotionalItemId: Scalars['String'];
};


export type MutationDeletePromotionalItemInDetailsListingArgs = {
  promotionalPackagesItemId: Scalars['String'];
};


export type MutationDeletePromotionalPackageArgs = {
  projectId: Scalars['String'];
  promotionalPackageId: Scalars['String'];
};


export type MutationDeletePropertyTypeByIdArgs = {
  isDeletable: Scalars['Boolean'];
  propertyTypeId: Scalars['String'];
};


export type MutationDeletePurchaserIdTypeArgs = {
  id: Scalars['String'];
};


export type MutationDeletePurchaserPaymentPlanArgs = {
  purchaserPaymentID: Scalars['String'];
};


export type MutationDeletePurchaserPaymentPlanDetailsArgs = {
  purchaserDetailsId: Scalars['String'];
};


export type MutationDeleteRaceByIdArgs = {
  isDeletable: Scalars['Boolean'];
  raceId: Scalars['String'];
};


export type MutationDeleteReasonCodeByIdArgs = {
  reasonCodeId: Scalars['String'];
};


export type MutationDeleteRedemptionRepaymentArgs = {
  redemptionRepaymentId: Scalars['String'];
};


export type MutationDeleteRefinancingArgs = {
  generationBatch: Scalars['String'];
};


export type MutationDeleteRelationshipByIdArgs = {
  relationshipId: Scalars['String'];
};


export type MutationDeleteReleaseDataArgs = {
  id: Scalars['String'];
};


export type MutationDeleteReligionByIdArgs = {
  religionId: Scalars['String'];
};


export type MutationDeleteRoleArgs = {
  roleId: Scalars['String'];
};


export type MutationDeleteSaleLoanArgs = {
  input: DeleteSaleLoanInput;
};


export type MutationDeleteSaleLoanBuyBackArgs = {
  input: Scalars['String'];
};


export type MutationDeleteSaleLoanCancellationArgs = {
  saleLoanCancellationId: Scalars['String'];
};


export type MutationDeleteSaleLoanRefinancingArgs = {
  refinancingId: Scalars['String'];
};


export type MutationDeleteSaleLoanReleaseArgs = {
  releaseId: Scalars['String'];
};


export type MutationDeleteSalesCancellationArgs = {
  id: Scalars['String'];
};


export type MutationDeleteSalesContractDiscountArgs = {
  discountId: Scalars['String'];
  saleId: Scalars['String'];
};


export type MutationDeleteSalesContractOtherContactArgs = {
  saleContactId: Scalars['String'];
};


export type MutationDeleteSalesContractPackageArgs = {
  id: Scalars['String'];
  saleID: Scalars['String'];
};


export type MutationDeleteSalesContractSubProductArgs = {
  id: Scalars['String'];
  saleID: Scalars['String'];
  unitID: Scalars['String'];
};


export type MutationDeleteSalesRebateArgs = {
  saleId: Scalars['String'];
  saleRebateId: Scalars['String'];
};


export type MutationDeleteSalesStatutoryDocumentArgs = {
  id: Scalars['String'];
};


export type MutationDeleteSalesTeamByIdArgs = {
  teamId: Scalars['String'];
};


export type MutationDeleteSalutationByIdArgs = {
  salutationId: Scalars['String'];
};


export type MutationDeleteSelectedUnitsArgs = {
  input: DeleteUnitInput;
};


export type MutationDeleteStampDutyIntegrationArgs = {
  id: Scalars['String'];
};


export type MutationDeleteStandardLetterArgs = {
  letterTemplateId: Scalars['String'];
};


export type MutationDeleteStandardLetterByIdArgs = {
  standardLetterId: Scalars['String'];
};


export type MutationDeleteStandardLetterParameterByIdArgs = {
  stdLtrParamId: Scalars['String'];
};


export type MutationDeleteStatutoryDocumentArgs = {
  input: Scalars['String'];
};


export type MutationDeleteSubsaleArgs = {
  subsaleId: Scalars['String'];
};


export type MutationDeleteTownshipArgs = {
  companyId: Scalars['String'];
  townshipId: Scalars['String'];
};


export type MutationDeleteTransactionCodeArgs = {
  id: Scalars['String'];
};


export type MutationDeleteTransactionCodeDetailArgs = {
  id: Scalars['String'];
};


export type MutationDeleteUnitGalleryArgs = {
  input: AdminEditLayoutUnitInput;
};


export type MutationDeleteUnitOfMeasurementByIdArgs = {
  id: Scalars['String'];
};


export type MutationDeleteUnitTransferArgs = {
  unitTransferId: Scalars['String'];
};


export type MutationDeleteUnitTypeByIdArgs = {
  isDeletable: Scalars['Boolean'];
  unitTypeId: Scalars['String'];
};


export type MutationDeleteWorkProgressByIdArgs = {
  progressId: Scalars['String'];
};


export type MutationDesignLetterTemplateArgs = {
  input: DesignLetterTemplateInput;
};


export type MutationDesignProjectLetterTemplateArgs = {
  input: DesignLetterTemplateInput;
};


export type MutationDiscardPendingDataArgs = {
  input: DiscardPendingDataInput;
};


export type MutationDownloadAttachmentArgs = {
  input: SalesDownloadAttachmentInput;
};


export type MutationDuplicatePaymentPlanArgs = {
  input: DuplicatePaymentPlanInput;
};


export type MutationEditAppointmentArgs = {
  appointment_id: Scalars['String'];
  input: NewAppointmentInput;
};


export type MutationEditArchitectCertArgs = {
  input: EditArchitectCertInput;
};


export type MutationEditAreaVarianceIndonesiaArgs = {
  input: EditAreaVarianceIndonesiaInput;
};


export type MutationEditAssignDiscountArgs = {
  input: AssignDiscountInput;
};


export type MutationEditBankArgs = {
  input: EditBankInput;
};


export type MutationEditBankPaymentArgs = {
  input: EditBankPaymentInput;
};


export type MutationEditBillItemArgs = {
  input: EditBillItemInput;
};


export type MutationEditBlockGalleryArgs = {
  input: Array<AdminEditLayoutBlockInput>;
};


export type MutationEditBlockLabelArgs = {
  input: EditBlockInput;
};


export type MutationEditCampaignArgs = {
  input: AdminCampaignInput;
};


export type MutationEditCarParkArgs = {
  input: EditCarParkInput;
};


export type MutationEditCommissionPaymentByIdArgs = {
  id: Scalars['String'];
  input: EditCommissionPaymentInput;
};


export type MutationEditCommissionStatutoryDocumentByIdArgs = {
  id: Scalars['String'];
  statutoryDocId: Scalars['String'];
};


export type MutationEditCompanyArgs = {
  file?: InputMaybe<Scalars['Upload']>;
  input: EditCompanyInput;
};


export type MutationEditCompanyBankProfileArgs = {
  input: EditCompanyBankProfileInput;
};


export type MutationEditCompanyCommissionPackageDetailArgs = {
  input: CompanyCommissionPackageDetailInput;
};


export type MutationEditCompanyNumberingStructureArgs = {
  input: EditNumberingFormatInput;
};


export type MutationEditCompanyRewardCommPaymentArgs = {
  input: CommissionPaymentInput;
};


export type MutationEditContactPersonArgs = {
  input: EditSaleContactPersonInput;
  saleId: Scalars['String'];
};


export type MutationEditCountryCodeArgs = {
  input: EditCountryCodeInput;
};


export type MutationEditDeemCollectedArgs = {
  input: EditDeemCollectedInput;
};


export type MutationEditDesignationArgs = {
  input: EditParameterInput;
};


export type MutationEditDirectionArgs = {
  input: EditDirectionInput;
};


export type MutationEditDiscountArgs = {
  input: EditDiscountInput;
};


export type MutationEditDiscountTypeArgs = {
  input: EditDiscountTypeInput;
};


export type MutationEditEducationArgs = {
  input: EditParameterInput;
};


export type MutationEditEmployeeJobPositionArgs = {
  input: EditEmployeeJobPositionInput;
};


export type MutationEditEventsArgs = {
  input: AdminEventsInput;
};


export type MutationEditExchangeRateArgs = {
  input: CurrencyExchangeRateEditInput;
};


export type MutationEditFinancialLimitArgs = {
  financialLimit: Scalars['Float'];
  id: Scalars['String'];
};


export type MutationEditFinancierArgs = {
  input: FinancierInput;
};


export type MutationEditFloorGalleryArgs = {
  input: Array<AdminEditLayoutFloorInput>;
};


export type MutationEditGalleryArgs = {
  input: AdminEditGalleryInput;
};


export type MutationEditGalleryTourArgs = {
  input: AdminEditGalleryTourInput;
};


export type MutationEditGalleryVideoArgs = {
  input: AdminEditGalleryVideoInput;
};


export type MutationEditIncomeRangeArgs = {
  input: EditIncomeRangeInput;
};


export type MutationEditIndustryArgs = {
  input: EditParameterInput;
};


export type MutationEditJobPositionArgs = {
  positionId: Scalars['String'];
  positionName: Scalars['String'];
};


export type MutationEditJointBuyerArgs = {
  input: Buyer;
};


export type MutationEditKeyCollectionAppointmentArgs = {
  input: EditKeyCollectionAppointmentInput;
};


export type MutationEditLatePaymentInterestArgs = {
  input: EditLateInterestInput;
};


export type MutationEditLeadSourceArgs = {
  input: EditLeadSourceInput;
};


export type MutationEditLetterTemplateArgs = {
  input: EditLetterTemplateInput;
};


export type MutationEditLoanPaymentArgs = {
  id: Scalars['String'];
  input: AddLoanPaymentInput;
  projectId: Scalars['String'];
  status: Scalars['String'];
};


export type MutationEditMaritalStatusArgs = {
  input: EditMaritalStatusInput;
};


export type MutationEditMiscBillingArgs = {
  input: EditMiscBillingInput;
};


export type MutationEditMiscBillingStatusArgs = {
  isApproved: Scalars['Boolean'];
  sourceIds: Array<Scalars['String']>;
};


export type MutationEditMortgagePaymentArgs = {
  input: MortgagePaymentInput;
};


export type MutationEditMortgagePlanArgs = {
  input: MortgagePlanInput;
};


export type MutationEditMortgageRetentionArgs = {
  input: MortgageRetentionInput;
};


export type MutationEditMotTrackingArgs = {
  input: EditMotTrackingInput;
};


export type MutationEditOverduePurchaseCaArgs = {
  input: EditOverduePurchaseCaInput;
};


export type MutationEditPackageSaleRegistrationArgs = {
  input: EditPackageInput;
};


export type MutationEditPaCollectionActivityArgs = {
  input: EditPaCollectionActivityInput;
};


export type MutationEditPaCollectionActivityIndoArgs = {
  input: EditOverduePurchaseCaInput;
};


export type MutationEditPAcontraArgs = {
  input: EditPAmoduleDataInput;
  isSubmitted: Scalars['Boolean'];
};


export type MutationEditPAcreditNoteArgs = {
  input: EditPAmoduleDataInput;
  isSubmitted: Scalars['Boolean'];
};


export type MutationEditPAdebitNoteArgs = {
  input: EditPAdebitNoteInput;
  isSubmitted: Scalars['Boolean'];
};


export type MutationEditPaIndoDepositArgs = {
  input: PaIndoEditDepositInput;
};


export type MutationEditPAmiscBillingArgs = {
  input: EditPaMiscBillingInput;
  isSubmitted: Scalars['Boolean'];
};


export type MutationEditPAmoduleStatusArgs = {
  isApproved: Scalars['Boolean'];
  sourceIds: Array<Scalars['String']>;
  tableRef: Scalars['String'];
};


export type MutationEditPArebateArgs = {
  input: EditPAmoduleDataInput;
  isSubmitted: Scalars['Boolean'];
};


export type MutationEditPArefundArgs = {
  input: EditRefundDataInput;
  isSubmitted: Scalars['Boolean'];
};


export type MutationEditPasswordPolicyArgs = {
  input: PasswordPolicyInput;
};


export type MutationEditPaymentGateWayArgs = {
  input: PaymentGatewayInput;
};


export type MutationEditPaymentInterestExceptionArgs = {
  input: EditPaymentinterestExceptionInput;
};


export type MutationEditPaymentPlanArgs = {
  input: EditPaymentPlanInput;
};


export type MutationEditPriceAdjustmentArgs = {
  input: EditPriceAdjustmentInput;
};


export type MutationEditProductConstructionArgs = {
  input: EditProjectConstructionInputInput;
};


export type MutationEditProfessionArgs = {
  input: EditParameterInput;
};


export type MutationEditProjectArgs = {
  input: AdminProjectInput;
};


export type MutationEditProjectAreaVarianceIndonesiaArgs = {
  input: EditProjectAreaVarianceInputIndonesia;
};


export type MutationEditProjectClusterArgs = {
  input: EditProjectClusterInput;
};


export type MutationEditProjectCommissionByIdArgs = {
  id: Scalars['String'];
  input: EditProjectCommissionInput;
};


export type MutationEditProjectCommissionPackageDetailArgs = {
  input: ProjectCommissionPackageDetailInput;
};


export type MutationEditProjectGalleryArgs = {
  input: Array<AdminEditProjectGalleryInput>;
};


export type MutationEditProjectKeyCollectionContractorArgs = {
  input: EditProjectKeyCollectionContractorInput;
};


export type MutationEditProjectLadArgs = {
  input: EditProjectLadInput;
};


export type MutationEditProjectMiscChargesArgs = {
  input: EditProjectMiscChargesInput;
};


export type MutationEditProjectPaymentPlanArgs = {
  input: EditProjectPaymentPlanInput;
};


export type MutationEditProjectPaymentReminderExceptionArgs = {
  input: EditProjectPaymentReminderExceptionInput;
};


export type MutationEditProjectPermitArgs = {
  input: EditProjectPermitInput;
};


export type MutationEditProjectReminderSettingArgs = {
  input: EditProjectReminderInput;
};


export type MutationEditProjectSalesOfficeArgs = {
  input: EditSalesOfficeInput;
};


export type MutationEditProjectSalesPolicyAndDetailsArgs = {
  input: EditProjectSalesPolicyInput;
  projectId: Scalars['String'];
  projectSalesPolicyId: Scalars['String'];
};


export type MutationEditProjectSpecArgs = {
  input: AdminSaveProjectSpecInput;
};


export type MutationEditProjectTitleArgs = {
  input: EditProjectTitleInput;
};


export type MutationEditProjectTypeArgs = {
  input: EditProjectTypeInput;
};


export type MutationEditPromotionalItemArgs = {
  input: EditPromotionalItemInput;
};


export type MutationEditPromotionalPackagesArgs = {
  input: EditPromotionalPackagesInput;
  projectId: Scalars['String'];
  promotionalPackageId: Scalars['String'];
};


export type MutationEditPropertyTypeArgs = {
  input: EditPropertyTypeInput;
};


export type MutationEditPurchaserIdTypeArgs = {
  id: Scalars['String'];
  input: AddPurchaserIdTypeInput;
};


export type MutationEditPurchaserInfoArgs = {
  input: Buyer;
};


export type MutationEditPurchaserPaymentPlanArgs = {
  input: EditPurchaserPaymentPlanInput;
};


export type MutationEditPurchaserPaymentPlanAndDetailsArgs = {
  input: EditPurchaserPaymentPlanInput;
};


export type MutationEditPurchaserPaymentPlanDetailsArgs = {
  input: AddPurchaserPaymentPlantDetailsInput;
};


export type MutationEditRaceArgs = {
  input: EditRaceInput;
};


export type MutationEditReasonCodeArgs = {
  input: EditReasonCodeInput;
};


export type MutationEditReceiptArgs = {
  input: EditReceiptInput;
};


export type MutationEditRedemptionRepaymentArgs = {
  input: EditRedemptionRepaymentInput;
};


export type MutationEditRefinancingArgs = {
  input: EditRefinancingInput;
};


export type MutationEditRelationshipArgs = {
  input: EditParameterInput;
};


export type MutationEditReleaseCollectedArgs = {
  input: EditReleaseCollectedInput;
};


export type MutationEditReligionArgs = {
  input: EditParameterInput;
};


export type MutationEditRoleArgs = {
  input: EditAccessRoleInput;
};


export type MutationEditSaleLoanBuyBackArgs = {
  input: EditSaleLoanBuyBackListInput;
};


export type MutationEditSaleLoanCancellationArgs = {
  input: EditSaleLoanCancellationInput;
};


export type MutationEditSaleLoanEndFinArgs = {
  input: EditSaleLoanDetailInput;
};


export type MutationEditSaleLoanRefinancingArgs = {
  input: EditSaleLoanRefinancingInput;
};


export type MutationEditSaleLoanReleaseArgs = {
  fileDB?: InputMaybe<Array<Scalars['String']>>;
  fileOld?: InputMaybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  input: SaleLoanReleaseInput;
};


export type MutationEditSaleRebatePackageArgs = {
  input: EditSalesContractRebateInput;
};


export type MutationEditSalesCancellationArgs = {
  input: EditSalesCancellationInput;
};


export type MutationEditSalesContractDiscountArgs = {
  input: EditSalesContractDiscountInput;
  saleId: Scalars['String'];
};


export type MutationEditSalesContractOtherContactArgs = {
  input: EditSalesContractContactInput;
  saleID: Scalars['String'];
};


export type MutationEditSalesContractOtherSalesInfoArgs = {
  input: EditOtherSalesInfoInput;
};


export type MutationEditSalesContractPackageArgs = {
  input: EditSalesContractPackageInput;
  saleID: Scalars['String'];
};


export type MutationEditSalesContractSolicitorsArgs = {
  input: EditSolicitorsInput;
};


export type MutationEditSalesContractSubProductArgs = {
  input: EditSalesContractSubproductInput;
  saleID: Scalars['String'];
  unitID: Scalars['String'];
};


export type MutationEditSalesPackageArgs = {
  input: EditSalesPackageInput;
};


export type MutationEditSalesStatutoryDocumentArgs = {
  input: EditSalesStatutoryDocumentIndoInput;
};


export type MutationEditSalesTeamsArgs = {
  input: EditTeamInput;
};


export type MutationEditSalutationArgs = {
  input: EditSalutationInput;
};


export type MutationEditSolicitorArgs = {
  input: AdminSolicitorInput;
  solicitor_appointed_id: Scalars['String'];
};


export type MutationEditStandardLetterArgs = {
  input: EditStandardLetterInput;
};


export type MutationEditStandardLetterParameterArgs = {
  input: EditStandardLetterParameterInput;
};


export type MutationEditStatutoryDocumentArgs = {
  input: EditStatutoryDocumentIndoInput;
};


export type MutationEditSubsaleArgs = {
  input: EditSubsaleInput;
};


export type MutationEditTaxArgs = {
  input: EditTaxInput;
};


export type MutationEditTaxSchemeArgs = {
  input: EditTaxSchemeInput;
};


export type MutationEditTownshipArgs = {
  input: EditTownshipInput;
};


export type MutationEditTransactionCodeDetailArgs = {
  id: Scalars['String'];
  input: EditTransactionCodeDetailInput;
};


export type MutationEditUnitGalleryArgs = {
  input: Array<AdminEditLayoutUnitInput>;
};


export type MutationEditUnitInformationArgs = {
  input: EditUnitInformationInput;
};


export type MutationEditUnitOfMeasurementByIdArgs = {
  id: Scalars['String'];
  input: UnitOfMeasurementMutationInput;
};


export type MutationEditUnitTaxSchemeArgs = {
  saleId: Scalars['String'];
  taxSchemeId: Scalars['String'];
  unitId: Scalars['String'];
};


export type MutationEditUnitTransferArgs = {
  input: EditUnitTransferInput;
};


export type MutationEditUnitTransferIndoArgs = {
  input: SubmitUnitTransferFormInput;
  transferId: Scalars['String'];
};


export type MutationEditUnitTypeArgs = {
  input: EditUnitTypeInput;
};


export type MutationEditUserArgs = {
  input: EditUserInput;
};


export type MutationEditWorkProgressArgs = {
  input: EditWorkProgressInput;
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String'];
};


export type MutationGenerateBillingAreaVarianceArgs = {
  areaVarianceId: Scalars['String'];
  unitId: Scalars['String'];
};


export type MutationGenerateCarParkArgs = {
  input: GenerateUnitBasicInput;
};


export type MutationGenerateLatePaymentArgs = {
  input: PaymentLateInterestInput;
};


export type MutationGenerateLatePaymentInterestArgs = {
  carParkNegotiatedAmount: Scalars['Float'];
  generationDate: Scalars['DateTime'];
  miscBillingNegotiatedAmount: Scalars['Float'];
  packagesNegotiatedAmount: Scalars['Float'];
  saleId: Scalars['String'];
  status: Scalars['String'];
  unitNegotiatedAmount: Scalars['Float'];
};


export type MutationGenerateMiscBillingArgs = {
  input: GenerateMiscBillingInput;
};


export type MutationGenerateProgressBillingArgs = {
  input: GenerateProgressBillingBasicInput;
};


export type MutationGenerateProgressBillingReminderArgs = {
  reminderDate: Scalars['DateTime'];
};


export type MutationGenerateReminderSaleListArgs = {
  reminderDate: Scalars['DateTime'];
};


export type MutationGenerateUnitArgs = {
  input: GenerateUnitInput;
};


export type MutationInsertNewSaleLoanArgs = {
  input: SaleLoanInput;
};


export type MutationInsertNewSaleLoanPaymentArgs = {
  input: SaleLoanPaymentInput;
};


export type MutationInsertNewSaleLoanRetentionArgs = {
  input: SaleLoanRetentionInput;
};


export type MutationLetterTemplateRebuildReportArgs = {
  id: Scalars['String'];
  sldsId: Scalars['String'];
};


export type MutationLoginArgs = {
  LoginId: Scalars['String'];
  Password: Scalars['String'];
};


export type MutationLoginWithMicrosoftArgs = {
  microsoftEmail: Scalars['String'];
  ssoToken: Scalars['String'];
};


export type MutationMarkAsDefaultArgs = {
  projectId: Scalars['String'];
  solicitorId: Scalars['String'];
};


export type MutationMarkAsReadArgs = {
  notificationIds: Array<Scalars['String']>;
};


export type MutationMergeSalesStatutoryDocumentArgs = {
  input: MergeSalesStatutoryDocumentIndoInput;
};


export type MutationNewPasswordArgs = {
  confirmPassword: Scalars['String'];
  newPassword: Scalars['String'];
};


export type MutationNewRoleArgs = {
  input: NewAccessRoleInput;
};


export type MutationOrganizeDesignationArgs = {
  designationIds: Scalars['String'];
};


export type MutationOrganizeDirectionArgs = {
  directionId: Array<Scalars['String']>;
};


export type MutationOrganizeEducationArgs = {
  educationIds: Scalars['String'];
};


export type MutationOrganizeIncomeRangeArgs = {
  incomeRangeIds: Array<Scalars['String']>;
};


export type MutationOrganizeIndustryArgs = {
  industryIds: Scalars['String'];
};


export type MutationOrganizeLeadSourceArgs = {
  sourceIds: Array<Scalars['String']>;
};


export type MutationOrganizeMaritalStatusArgs = {
  maritalStatusIds: Array<Scalars['String']>;
};


export type MutationOrganizeParameterArgs = {
  parameterIds: Array<Scalars['String']>;
  parameterType: Scalars['String'];
};


export type MutationOrganizeProfessionArgs = {
  professionIds: Scalars['String'];
};


export type MutationOrganizeProjectTypeArgs = {
  projectTypeId: Array<Scalars['String']>;
};


export type MutationOrganizePropertyTypeArgs = {
  propertyTypeId: Array<Scalars['String']>;
};


export type MutationOrganizeRaceArgs = {
  raceIds: Array<Scalars['String']>;
};


export type MutationOrganizeReasonCodeArgs = {
  reasonCodeIds: Array<Scalars['String']>;
};


export type MutationOrganizeReligionArgs = {
  religionIds: Array<Scalars['String']>;
};


export type MutationOrganizeSalutationArgs = {
  salutationIds: Array<Scalars['String']>;
};


export type MutationOrganizeUnitTypeArgs = {
  unitTypeId: Array<Scalars['String']>;
};


export type MutationPostDeemCollectedArgs = {
  input: PostDeemCollectedInput;
};


export type MutationPostingMiscBillingArgs = {
  input: PostingMiscBillingInput;
};


export type MutationPostingProgressBillingArgs = {
  input: Array<UpdatePbStatusInput>;
};


export type MutationPostingReceiptArgs = {
  input: PostingInput;
};


export type MutationPostingRefundArgs = {
  input: PostingInput;
};


export type MutationPostRedemptionRepaymentArgs = {
  id: Scalars['String'];
};


export type MutationPostReleaseDataArgs = {
  id: Scalars['String'];
};


export type MutationProjectLetterTemplateRebuildReportArgs = {
  id: Scalars['String'];
  sldsId: Scalars['String'];
};


export type MutationRecalculateProgressBillingArgs = {
  saleId: Scalars['String'];
};


export type MutationRejectApproveReceiptArgs = {
  input: ApproveBankPaymentInput;
};


export type MutationRejectLateInterestsByIdArgs = {
  lateInterestId: Scalars['String'];
  saleId: Scalars['String'];
};


export type MutationRejectRescheduleInstallmentArgs = {
  rescheduleId: Scalars['String'];
  saleId: Scalars['String'];
};


export type MutationRejectSaleLoanCancellationArgs = {
  saleLoanCancellationIds: Array<Scalars['String']>;
};


export type MutationRejectSaleLoanReleaseArgs = {
  releaseId: Scalars['String'];
};


export type MutationRejectSalesCancellationArgs = {
  ids: Array<Scalars['String']>;
};


export type MutationRejectUnitTransferArgs = {
  unitTransferIds: Array<Scalars['String']>;
};


export type MutationRemoveDefaultDirectionArgs = {
  directionId: Scalars['String'];
};


export type MutationRemoveDefaultIncomeRangeArgs = {
  incomeRangeId: Scalars['String'];
};


export type MutationRemoveDefaultLeadSourceArgs = {
  sourceId: Scalars['String'];
};


export type MutationRemoveDefaultMaritalStatusArgs = {
  maritalStatusId: Scalars['String'];
};


export type MutationRemoveDefaultParameterArgs = {
  parameterId: Scalars['String'];
  parameterType: Scalars['String'];
};


export type MutationRemoveDefaultProjectTypeArgs = {
  projectTypeId: Scalars['String'];
};


export type MutationRemoveDefaultPropertyTypeArgs = {
  propertyTypeId: Scalars['String'];
};


export type MutationRemoveDefaultRaceArgs = {
  raceId: Scalars['String'];
};


export type MutationRemoveDefaultReasonCodeArgs = {
  reasonCodeId: Scalars['String'];
  type: Scalars['String'];
};


export type MutationRemoveDefaultSalutationArgs = {
  salutationId: Scalars['String'];
};


export type MutationRemoveDefaultUnitTypeArgs = {
  unitTypeId: Scalars['String'];
};


export type MutationRemoveInvitationContactArgs = {
  input: AdminFinancierPanelInput;
};


export type MutationRenoticeLoanApplicationArgs = {
  input: LoanAppRenotice;
};


export type MutationReopenSubsaleArgs = {
  subsaleId: Scalars['String'];
};


export type MutationRescheduledLoanDifferentialArgs = {
  input: RescheduleLoanInput;
};


export type MutationRescheduleInstallmentArgs = {
  inputReschedule: RescheduleInput;
  inputRescheduleDetail: Array<RescheduleDetailInput>;
};


export type MutationResendInvitationArgs = {
  userId: Scalars['String'];
};


export type MutationResendSolicitorAppointedInvitationArgs = {
  project_id: Scalars['String'];
  solicitor_appointed_id: Scalars['String'];
};


export type MutationResetPasswordArgs = {
  input: UpdatePasswordInput;
};


export type MutationResetSalesChartByBlockArgs = {
  block: Scalars['String'];
  projectId: Scalars['String'];
};


export type MutationReversalAllocationArgs = {
  allocationId: Scalars['String'];
  creditId: Scalars['String'];
  debitId: Scalars['String'];
  projectId: Scalars['String'];
  reversalDate: Scalars['String'];
  saleId: Scalars['String'];
};


export type MutationReversalArchitectCertArgs = {
  architectCertId: Scalars['String'];
  projectId: Scalars['String'];
  unitIds: Array<Scalars['String']>;
};


export type MutationReversalAreaVarianceArgs = {
  areaVarianceId: Scalars['String'];
  refId: Scalars['String'];
};


export type MutationReversalBankPaymentArgs = {
  input: ReversalBankPaymentInput;
};


export type MutationReversalLadArgs = {
  input: ReversalLadInput;
};


export type MutationReversalMiscBillingArgs = {
  generationBatch: Scalars['String'];
};


export type MutationReversalPaRecordByIdArgs = {
  id: Scalars['String'];
  saleId: Scalars['String'];
  tableRef: Scalars['String'];
};


export type MutationReversalPBdataArgs = {
  input: PostingProgressBillingInput;
};


export type MutationReversalProgressBillingArgs = {
  input: Array<UpdatePbStatusInput>;
  removeGenerationBatch: Scalars['Boolean'];
};


export type MutationReversalRedemptionRepaymentArgs = {
  id: Scalars['String'];
};


export type MutationReversalReleaseDataArgs = {
  id: Scalars['String'];
};


export type MutationReversalStakeholderProcessArgs = {
  collectionBatchId: Scalars['String'];
  solicitorId: Scalars['String'];
};


export type MutationRoleAssignmentArgs = {
  input: ProjectUserRoleAssignmentInput;
};


export type MutationSaveBookingExpressArgs = {
  input: AddNewUnitBookingInput;
};


export type MutationSaveDraftPurchaserTransferArgs = {
  input: AddPurchaserTransferInput;
};


export type MutationSaveNotificationPermissionArgs = {
  input: NotificationInput;
};


export type MutationSaveUnitsVpLetterDateArgs = {
  input: UnitsVpLetterInput;
};


export type MutationSendProjectInvitationArgs = {
  input: AdminFinancierPanelInput;
};


export type MutationSetDefaultDesignationArgs = {
  designationId: Scalars['String'];
};


export type MutationSetDefaultDirectionArgs = {
  directionId: Scalars['String'];
};


export type MutationSetDefaultDiscountForProjectArgs = {
  check: Scalars['Boolean'];
  discountId: Scalars['String'];
  projectId: Scalars['String'];
};


export type MutationSetDefaultEducationArgs = {
  educationId: Scalars['String'];
};


export type MutationSetDefaultELetterArgs = {
  defaulted: Scalars['Boolean'];
  letterTemplateId: Scalars['String'];
};


export type MutationSetDefaultFinancierContactArgs = {
  contactId: Scalars['String'];
  financier_id: Scalars['String'];
  project_id: Scalars['String'];
};


export type MutationSetDefaultIncomeRangeArgs = {
  incomeRangeId: Scalars['String'];
};


export type MutationSetDefaultIndustryArgs = {
  industryId: Scalars['String'];
};


export type MutationSetDefaultLeadSourceArgs = {
  sourceId: Scalars['String'];
};


export type MutationSetDefaultMaritalStatusArgs = {
  maritalStatusId: Scalars['String'];
};


export type MutationSetDefaultParameterArgs = {
  parameterId: Scalars['String'];
  parameterType: Scalars['String'];
};


export type MutationSetDefaultPaymentPlanForProjectArgs = {
  input: SetDefaultPaymentPlanForProjectInput;
};


export type MutationSetDefaultProfessionArgs = {
  professionId: Scalars['String'];
};


export type MutationSetDefaultProjectTypeArgs = {
  projectTypeId: Scalars['String'];
};


export type MutationSetDefaultPropertyTypeArgs = {
  propertyTypeId: Scalars['String'];
};


export type MutationSetDefaultRaceArgs = {
  raceId: Scalars['String'];
};


export type MutationSetDefaultReasonCodeArgs = {
  reasonCodeId: Scalars['String'];
  type: Scalars['String'];
};


export type MutationSetDefaultReligionArgs = {
  religionId: Scalars['String'];
};


export type MutationSetDefaultSalesPackageForProjectArgs = {
  check: Scalars['Boolean'];
  packageId: Scalars['String'];
  projectId: Scalars['String'];
};


export type MutationSetDefaultSalutationArgs = {
  salutationId: Scalars['String'];
};


export type MutationSetDefaultStandardLetterArgs = {
  defaulted: Scalars['Boolean'];
  letterTemplateId: Scalars['String'];
};


export type MutationSetDefaultSystemUseArgs = {
  workProgressId: Scalars['String'];
};


export type MutationSetDefaultUnitTypeArgs = {
  unitTypeId: Scalars['String'];
};


export type MutationSetProjectCommissionTeamArgs = {
  input: ProjectCommissionTeamInput;
};


export type MutationSetProjectCommissionTeamDetailArgs = {
  input: ProjectCommissionTeamDetailInput;
};


export type MutationShareDownpaymentReminderArgs = {
  input: ShareDownpaymentReminderInput;
};


export type MutationShareDownpaymentReminderByTemplateIdArgs = {
  input: ShareDownpaymentReminderByIdInput;
};


export type MutationSharePaymentReminderArgs = {
  input: SharePaymentReminderBasicInput;
};


export type MutationSharePaymentReminderByTemplateIdArgs = {
  input: SharePaymentReminderByIdInput;
};


export type MutationShareSpaReminderArgs = {
  input: ReminderInput;
};


export type MutationShareSpaReminderByLetterTemplateIdArgs = {
  input: ShareSpaReminderByIdInput;
};


export type MutationSoftDeletePriceAdjustmentArgs = {
  id: Scalars['String'];
};


export type MutationSoftDeleteStakeholderProcessArgs = {
  collectionBatchId: Scalars['String'];
  solicitorId: Scalars['String'];
};


export type MutationSpaSigningReversalArgs = {
  saleId: Scalars['String'];
};


export type MutationSubmitCommissionTypeArgs = {
  input: CommissionTypeInput;
};


export type MutationSubmitCompanyCommissionTeamDetailArgs = {
  input: CompanyCommissionTeamDetailInput;
};


export type MutationSubmitCompanyRewardArgs = {
  commissionTypeId: Scalars['String'];
  description: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
};


export type MutationSubmitCompanyRewardCommStatutoryDocArgs = {
  commissionPaymentId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  statutoryDocId: Scalars['String'];
};


export type MutationSubmitNupArgs = {
  nupId: Scalars['String'];
  status: Scalars['String'];
};


export type MutationSubmitUnitTransferFormArgs = {
  input: SubmitUnitTransferFormInput;
  transferId?: InputMaybe<Scalars['String']>;
};


export type MutationSuspendEndFinancierArgs = {
  financierId: Scalars['String'];
};


export type MutationSuspendSolicitorArgs = {
  isDeletable: Scalars['Boolean'];
  solicitor_appointed_id: Scalars['String'];
};


export type MutationSuspendUserArgs = {
  userId: Scalars['String'];
};


export type MutationTemporaryUploadUnitBookingArgs = {
  input: TemporaryUploadPurchaser;
};


export type MutationTestGenerateOverdueArgs = {
  projectId: Scalars['String'];
};


export type MutationUnassignAuthorizedSaleStaffArgs = {
  id: Array<Scalars['String']>;
};


export type MutationUnassignClassificationCodeArgs = {
  billItemIds: Array<Scalars['String']>;
  classificationId: Scalars['String'];
};


export type MutationUnassignDiscountArgs = {
  discountId: Scalars['String'];
  projectId: Scalars['String'];
};


export type MutationUnassignMsicCodeArgs = {
  billItemIds: Array<Scalars['String']>;
  msicId: Scalars['String'];
};


export type MutationUnassignPanelArgs = {
  financier_id: Scalars['String'];
  project_id: Scalars['String'];
};


export type MutationUnassignSolicitorFromProjectArgs = {
  project_id: Scalars['String'];
  solicitor_id: Scalars['String'];
};


export type MutationUnassignTeamMemberArgs = {
  teamId: Scalars['String'];
  userIds: Array<Scalars['String']>;
};


export type MutationUnblockUserArgs = {
  confirmPassword: Scalars['String'];
  newPassword: Scalars['String'];
  userId: Scalars['String'];
};


export type MutationUnBlockUserArgs = {
  newPassword: Scalars['String'];
  userId: Scalars['String'];
};


export type MutationUnSuspendUserArgs = {
  userId: Scalars['String'];
};


export type MutationUpdateAcceptLeadArgs = {
  isAcceptLead: Scalars['Boolean'];
};


export type MutationUpdateBillItemArgs = {
  input: BillItemIntInput;
};


export type MutationUpdateCarParkInstallmentArgs = {
  input: BasePaymentPlanSummary;
};


export type MutationUpdateCollectionActivityStatusArgs = {
  activityStatus: Scalars['String'];
  collectionActivityId: Scalars['String'];
};


export type MutationUpdateDiscardBumiArgs = {
  discardBumi: Scalars['Boolean'];
  saleId: Scalars['String'];
};


export type MutationUpdateFinancialBillingArgs = {
  input: EditFinancialBillingInput;
};


export type MutationUpdateGlAccountMappingArgs = {
  input: AccountMappingInput;
};


export type MutationUpdateJointBuyerSeqArgs = {
  input: UpdateJointBuyerSeqInput;
  saleId: Scalars['String'];
};


export type MutationUpdateLateInterestsByIdArgs = {
  carParkNegotiatedAmount: Scalars['Float'];
  generationDate: Scalars['DateTime'];
  lateInterestId: Scalars['String'];
  miscBillingNegotiatedAmount: Scalars['Float'];
  packagesNegotiatedAmount: Scalars['Float'];
  saleId: Scalars['String'];
  status: Scalars['String'];
  unitNegotiatedAmount: Scalars['Float'];
};


export type MutationUpdateLateInterestStatusArgs = {
  input: UpdatePaymentLateInterestInput;
};


export type MutationUpdateLateInterestStatusByGenerationBatchArgs = {
  input: GenerationBatchPostingInput;
};


export type MutationUpdateLatePaymentInterestExceptionArgs = {
  input: EditLatePaymentInterestExceptionInput;
};


export type MutationUpdateLoanApprovalArgs = {
  input: UpdateSaleLoanApprovalInput;
};


export type MutationUpdateNewPasswordArgs = {
  input: UpdatePasswordInput;
};


export type MutationUpdateNotaryArgs = {
  input: EditNotaryInput;
};


export type MutationUpdatePaCollectionActivityArgs = {
  input: UpdatePaCollectionActivityInput;
};


export type MutationUpdatePaCollectionActivityIndoArgs = {
  input: UpdatePaCollectionActivityInput;
};


export type MutationUpdatePaymentPlanCarParkArgs = {
  regDate?: InputMaybe<Scalars['DateTime']>;
  saleId: Scalars['String'];
};


export type MutationUpdatePaymentPlanPackageArgs = {
  regDate?: InputMaybe<Scalars['DateTime']>;
  saleId: Scalars['String'];
};


export type MutationUpdatePriceAdjustmentStatusArgs = {
  isApproved: Scalars['Boolean'];
  projectId: Scalars['String'];
  sourceIds: Array<Scalars['String']>;
};


export type MutationUpdateProfileArgs = {
  input: UserContactInput;
};


export type MutationUpdateProgressBillingArgs = {
  input: EditProgressBillingInput;
};


export type MutationUpdateProjectFireInsuranceArgs = {
  input: EditProjectFireInsuranceInput;
};


export type MutationUpdateProjectPolicyArgs = {
  input: EditProjectPolicyInput;
};


export type MutationUpdateSaleLoanApprvalArgs = {
  input: UpdateSaleLoanApprovalFormInput;
};


export type MutationUpdateSalesCancellationStatusArgs = {
  input: UpdateStatusCancellationInput;
};


export type MutationUpdateSalesContractPaymentPlanArgs = {
  paymentPlanId: Scalars['String'];
  saleId: Scalars['String'];
};


export type MutationUpdateStampDutyArgs = {
  input: UpdateStampDutyInput;
};


export type MutationUpdateStampDutyIntegrationArgs = {
  input: UpdateStampDutyIntegrationInput;
};


export type MutationUpdateStatusOverduePurchaseCaArgs = {
  input: UpdateStatusOverduePurchaseCaInput;
};


export type MutationUpdateTransactionCodeArgs = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  taxTrxCode?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateUnitGalleryVirtualModelArgs = {
  input: AdminUpdateUnitVirtualModelInput;
};


export type MutationUpdateUnitStatusArgs = {
  models: Array<AdminUnitStatusInput>;
};


export type MutationUpdateUserLatestEntityArgs = {
  project_id: Scalars['String'];
};


export type MutationVoidArchitectCertArgs = {
  architectCertId: Scalars['String'];
  projectId: Scalars['String'];
  unitIds: Array<Scalars['String']>;
};

export type NewAccessRoleInput = {
  permissionList?: InputMaybe<Array<AccessPermissionListInput>>;
  roleName: Scalars['String'];
};

export type NewAppointmentInput = {
  appointmentDate: Scalars['String'];
  appointmentTypeID: Scalars['String'];
  email: Scalars['String'];
  endTime: Scalars['String'];
  leadSourceID: Scalars['String'];
  name: Scalars['String'];
  needManagerAssistance?: InputMaybe<Scalars['Boolean']>;
  participantLimit: Scalars['Float'];
  phoneNo: Scalars['String'];
  projectID: Scalars['String'];
  remark?: InputMaybe<Scalars['String']>;
  salesPersonId?: InputMaybe<Scalars['String']>;
  startTime: Scalars['String'];
  teamId: Scalars['String'];
};

export type NewDiscount = {
  __typename?: 'newDiscount';
  discardBumi?: Maybe<Scalars['Boolean']>;
  discounts?: Maybe<Array<NewDiscountList>>;
};

export type NewDiscountList = {
  __typename?: 'newDiscountList';
  amount?: Maybe<Scalars['Float']>;
  discountId?: Maybe<Scalars['String']>;
  discountMethod?: Maybe<Scalars['String']>;
  formula?: Maybe<Scalars['String']>;
  seqNo?: Maybe<Scalars['Float']>;
  title?: Maybe<Scalars['String']>;
};

export type NewMortgageRetentionOutput = {
  __typename?: 'newMortgageRetentionOutput';
  endfinMortgagePaymentId: Scalars['String'];
  retentionBy: Scalars['String'];
  retentionExpectedCount: Scalars['String'];
  retentionExpectedFreq: Scalars['String'];
  retentionExpectedFrom: Scalars['String'];
  retentionId: Scalars['String'];
  retentionName: Scalars['String'];
  retentionValue: Scalars['Float'];
};

export type NewPaymentPlan = {
  __typename?: 'NewPaymentPlan';
  endfin_mortgage_payment_id?: Maybe<Scalars['String']>;
  endfin_mortgage_retention_id?: Maybe<Scalars['String']>;
  event_amt: Scalars['Float'];
  event_estimate_date: Scalars['String'];
  event_item: Scalars['String'];
};

export type NewPaymentPlanInput = {
  endfin_mortgage_payment_id?: InputMaybe<Scalars['String']>;
  endfin_mortgage_retention_id?: InputMaybe<Scalars['String']>;
  event_amt: Scalars['Float'];
  event_estimate_date: Scalars['String'];
  event_item: Scalars['String'];
};

export type NewsAnnouncementEntity = AuditEntity & {
  __typename?: 'newsAnnouncementEntity';
  accountId: Scalars['String'];
  attachment?: Maybe<Array<AttachmentEntity>>;
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  endDate: Scalars['DateTime'];
  id: Scalars['String'];
  isExpired?: Maybe<Scalars['Boolean']>;
  isPublish: Scalars['Boolean'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  newsProjects: Array<NewsProjectEntity>;
  startDate: Scalars['DateTime'];
  title: Scalars['String'];
};


export type NewsAnnouncementEntityAttachmentArgs = {
  limit?: InputMaybe<Scalars['Float']>;
};

export type NewsAnnouncementPurchaserOutput = {
  __typename?: 'newsAnnouncementPurchaserOutput';
  newsData?: Maybe<Array<NewsAnnouncementEntity>>;
  total: Scalars['Float'];
};

export type NewsProjectEntity = AuditEntity & {
  __typename?: 'newsProjectEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  newsAnnouncement: NewsAnnouncementEntity;
  newsId: Scalars['String'];
  projectId: Scalars['String'];
};

export type NewUserInput = {
  allowOpenLead?: InputMaybe<Scalars['Boolean']>;
  allowPropertyAgency?: InputMaybe<Scalars['Boolean']>;
  email: Scalars['String'];
  name: Scalars['String'];
  phoneNo: Scalars['String'];
  superUser?: InputMaybe<Scalars['Boolean']>;
  username: Scalars['String'];
};

export type NotaryContactDetailsInput = {
  email: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  phoneNo: Scalars['String'];
};

export type NotaryContactDetailsOutput = {
  __typename?: 'notaryContactDetailsOutput';
  email: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  phoneNo: Scalars['String'];
};

export type NotaryContactEntity = {
  __typename?: 'notaryContactEntity';
  commonStatus: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  notaryAppointedId: Scalars['String'];
  phoneNo: Scalars['String'];
};

export type NotaryEntity = {
  __typename?: 'notaryEntity';
  accountId: Scalars['String'];
  address?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  invitationLink?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notaryCode?: Maybe<Scalars['String']>;
  notaryId?: Maybe<Scalars['String']>;
  officeTel?: Maybe<Scalars['String']>;
  ppatNo?: Maybe<Scalars['String']>;
};

export type NotaryInput = {
  address?: InputMaybe<AddressJsonInput>;
  contactDetails?: InputMaybe<Array<NotaryContactDetailsInput>>;
  email: Scalars['String'];
  name: Scalars['String'];
  notaryCode?: InputMaybe<Scalars['String']>;
  officeTel: Scalars['String'];
  ppatNo?: InputMaybe<Scalars['String']>;
};

export type NotaryOutput = {
  __typename?: 'notaryOutput';
  accountId: Scalars['String'];
  address?: Maybe<AddressJson>;
  commonStatus: Scalars['String'];
  contactDetails?: Maybe<Array<NotaryContactDetailsOutput>>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  invitationLink?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notaryCode?: Maybe<Scalars['String']>;
  notaryId?: Maybe<Scalars['String']>;
  officeTel?: Maybe<Scalars['String']>;
  ppatNo?: Maybe<Scalars['String']>;
};

export type NotaryProjectEntity = {
  __typename?: 'notaryProjectEntity';
  accountId: Scalars['String'];
  id: Scalars['String'];
  notaryId?: Maybe<Scalars['String']>;
  projectId: Scalars['String'];
};

export type NotarySelectionOutput = {
  __typename?: 'notarySelectionOutput';
  name: Scalars['String'];
  notaryId: Scalars['String'];
};

export type NotificationInput = {
  day?: InputMaybe<Scalars['Float']>;
  notificationList?: InputMaybe<Array<Scalars['String']>>;
};

export enum NpvBasicRate {
  Daily = 'DAILY',
  DescriptionList = 'DescriptionList',
  GetDescription = 'GetDescription',
  Monthly = 'MONTHLY',
  Yearly = 'YEARLY'
}

export type NumberFormatEntity = {
  __typename?: 'numberFormatEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  companyNumberSetups: Array<CompanyNumberSetupEntity>;
  id: Scalars['String'];
  numberFormat: Scalars['String'];
  numberType: Scalars['String'];
};

export enum NumericFormatter {
  Billions = 'BILLIONS',
  Lumpsum = 'LUMPSUM',
  Millions = 'MILLIONS',
  Thousands = 'THOUSANDS'
}

export type NupCountOutput = {
  __typename?: 'NupCountOutput';
  approve: Scalars['Float'];
  pending: Scalars['Float'];
  reject: Scalars['Float'];
};

export type NupEntity = {
  __typename?: 'nupEntity';
  accountId: Scalars['String'];
  address: AddressJson;
  amount: Scalars['Float'];
  code: Scalars['String'];
  commonStatus: Scalars['String'];
  companyId: Scalars['String'];
  contact: ContactNupJson;
  contactId?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  expiredDate: Scalars['DateTime'];
  gender?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  ktpUrl?: Maybe<Scalars['String']>;
  maritalStatusId?: Maybe<MaritalStatusEntity>;
  mediaId: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  nationalityId?: Maybe<SNationalityEntity>;
  npwpUrl?: Maybe<Scalars['String']>;
  nupNumber?: Maybe<Scalars['String']>;
  paymentUrl?: Maybe<Scalars['String']>;
  professionId?: Maybe<Scalars['String']>;
  projectId?: Maybe<Scalars['String']>;
  reasonId: Scalars['String'];
  rejectedBy?: Maybe<Scalars['String']>;
  rejectedDate?: Maybe<Scalars['DateTime']>;
  religionId?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
  reservedDate?: Maybe<Scalars['DateTime']>;
  salutationId?: Maybe<SalutationEntity>;
  status: Scalars['String'];
  typeId: Scalars['String'];
  unitId: Scalars['String'];
};

export type NupReasonEntity = {
  __typename?: 'nupReasonEntity';
  accountId: Scalars['String'];
  code: Scalars['String'];
  commonStatus: Scalars['String'];
  companyId: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
};

export type NupTypeEntity = {
  __typename?: 'nupTypeEntity';
  accountId: Scalars['String'];
  amount: Scalars['Float'];
  commonStatus: Scalars['String'];
  companyId: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  description: Scalars['String'];
  discount: Scalars['Float'];
  expiredTime: Scalars['Float'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  prefix: Scalars['String'];
  projectId: Scalars['String'];
  refundable: Scalars['Boolean'];
  type: Scalars['String'];
  viaAgent: Scalars['Boolean'];
  viaMobile: Scalars['Boolean'];
};

export type OldBalance = {
  __typename?: 'OldBalance';
  endfin_mortgage_payment_id?: Maybe<Scalars['String']>;
  endfin_mortgage_retention_id?: Maybe<Scalars['String']>;
  event_name: Scalars['String'];
  net_balance?: Maybe<Scalars['Float']>;
  old_balance: Scalars['Float'];
  retentions?: Maybe<Array<Scalars['JSONObject']>>;
};

export type OldBalanceBase = {
  endfin_mortgage_payment_id?: InputMaybe<Scalars['String']>;
  endfin_mortgage_retention_id?: InputMaybe<Scalars['String']>;
  event_name: Scalars['String'];
  net_balance?: InputMaybe<Scalars['Float']>;
  old_balance: Scalars['Float'];
};

export type OldBalanceBuyBack = {
  __typename?: 'OldBalanceBuyBack';
  endfin_mortgage_payment_id?: Maybe<Scalars['String']>;
  endfin_mortgage_retention_id?: Maybe<Scalars['String']>;
  event_name: Scalars['String'];
  net_balance?: Maybe<Scalars['Float']>;
  old_balance: Scalars['Float'];
  retentions?: Maybe<Array<Scalars['JSONObject']>>;
};

export type OldBalanceBuyBackInput = {
  endfin_mortgage_payment_id?: InputMaybe<Scalars['String']>;
  endfin_mortgage_retention_id?: InputMaybe<Scalars['String']>;
  event_name: Scalars['String'];
  net_balance?: InputMaybe<Scalars['Float']>;
  old_balance: Scalars['Float'];
  retentions?: InputMaybe<Array<OldBalanceInputBase>>;
};

export type OldBalanceInput = {
  endfin_mortgage_payment_id?: InputMaybe<Scalars['String']>;
  endfin_mortgage_retention_id?: InputMaybe<Scalars['String']>;
  event_name: Scalars['String'];
  net_balance?: InputMaybe<Scalars['Float']>;
  old_balance: Scalars['Float'];
  retentions?: InputMaybe<Array<OldBalanceBase>>;
};

export type OldBalanceInputBase = {
  endfin_mortgage_payment_id?: InputMaybe<Scalars['String']>;
  endfin_mortgage_retention_id?: InputMaybe<Scalars['String']>;
  event_name: Scalars['String'];
  net_balance?: InputMaybe<Scalars['Float']>;
  old_balance: Scalars['Float'];
};

/** JsonType */
export type OldSaleDetail = {
  __typename?: 'oldSaleDetail';
  discounts?: Maybe<Array<DiscountListingObject>>;
};

export type OldSaleDetailInput = {
  discounts?: InputMaybe<Array<DiscountListingUnitTransferInput>>;
};

export type OldUnitSaleDetail = {
  __typename?: 'oldUnitSaleDetail';
  discounts?: Maybe<Array<NewDiscountList>>;
};

export type OnlineUserEntity = AuditEntity & {
  __typename?: 'OnlineUserEntity';
  accountId: Scalars['String'];
  accountName?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  ID: Scalars['String'];
  ipAddress?: Maybe<Scalars['String']>;
  lastLogin: Scalars['DateTime'];
  lastLogout?: Maybe<Scalars['DateTime']>;
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  socketId?: Maybe<Scalars['String']>;
  softwareCode?: Maybe<Scalars['String']>;
  softwarePackage?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type OpenLeadAssignmentSettingEntity = {
  __typename?: 'openLeadAssignmentSettingEntity';
  accountId: Scalars['String'];
  id: Scalars['String'];
  lastAssign: Scalars['DateTime'];
  leadCount: Scalars['Float'];
  seq: Scalars['Float'];
  userId: Scalars['String'];
  weight: Scalars['Float'];
};

export type OpenLeadSummary = {
  __typename?: 'OpenLeadSummary';
  lastAssignedLeadCount?: Maybe<Scalars['Float']>;
  lastAssignedLeadDate?: Maybe<Scalars['String']>;
  lastImportedDate?: Maybe<Scalars['DateTime']>;
  lastImportedLeadCount?: Maybe<Scalars['Float']>;
  totalBatchImported?: Maybe<Scalars['Float']>;
};

export type OptionListOutput = {
  __typename?: 'optionListOutput';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type OutstandingAmt = {
  __typename?: 'OutstandingAmt';
  miscBillingOSAmt: Scalars['Float'];
};

export type OutstandingSnPOutput = {
  __typename?: 'OutstandingSnPOutput';
  fourWeek: Array<UnitData>;
  oneWeek: Array<UnitData>;
  threeWeek: Array<UnitData>;
  twoWeek: Array<UnitData>;
};

export type Overdue = {
  __typename?: 'overdue';
  aging?: Maybe<Scalars['String']>;
  overduePurchaser?: Maybe<Array<OverduePurchaserOutput>>;
};

export type OverdueAging = {
  __typename?: 'overdueAging';
  period1?: Maybe<Scalars['String']>;
  period2?: Maybe<Scalars['String']>;
  period3?: Maybe<Scalars['String']>;
  period4?: Maybe<Scalars['String']>;
  period5?: Maybe<Scalars['String']>;
  period6?: Maybe<Scalars['String']>;
};

export type OverdueCaAttachment = {
  __typename?: 'overdueCAAttachment';
  attachmentId: Scalars['String'];
  fileName: Scalars['String'];
  mediaType: Scalars['String'];
  resourceUrl: Scalars['String'];
};

export type OverduedPurchaserAccountDetailsEntity = {
  __typename?: 'overduedPurchaserAccountDetailsEntity';
  accountId: Scalars['String'];
  billMethod: Scalars['String'];
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  overduedPurchaserAccount: OverduedPurchaserAccountEntity;
  overduedPurchaserAccountId: Scalars['String'];
  projectId: Scalars['String'];
  refId: Scalars['String'];
  saleId: Scalars['String'];
};

export type OverduedPurchaserAccountEntity = {
  __typename?: 'overduedPurchaserAccountEntity';
  accountId: Scalars['String'];
  assignedDate?: Maybe<Scalars['DateTime']>;
  assignTo?: Maybe<Scalars['String']>;
  batchId: Scalars['String'];
  commonStatus: Scalars['String'];
  generateDate: Scalars['DateTime'];
  id: Scalars['String'];
  overduedPurchaserAccountDetails?: Maybe<OverduedPurchaserAccountDetailsEntity>;
  projectId: Scalars['String'];
  saleId: Scalars['String'];
};

export type OverduePurchaseAccountCaDetailOutput = {
  __typename?: 'overduePurchaseAccountCADetailOutput';
  actionDate: Scalars['DateTime'];
  attachments?: Maybe<Array<OverdueCaAttachment>>;
  caId: Scalars['String'];
  followedUpName?: Maybe<Scalars['String']>;
  OverduePurchaserAccountDetails: OverduePurchaserAccountDetailsOutput;
  reason?: Maybe<Scalars['String']>;
};

export type OverduePurchaseCaListingOutput = {
  __typename?: 'overduePurchaseCAListingOutput';
  activityDate: Scalars['DateTime'];
  activityRemark?: Maybe<Scalars['String']>;
  activityStatus?: Maybe<Scalars['String']>;
  caId: Scalars['String'];
  countDoc?: Maybe<Scalars['Float']>;
  saleId: Scalars['String'];
};

export type OverduePurchaseCaOutput = {
  __typename?: 'overduePurchaseCAOutput';
  overduePurchaseCAListing?: Maybe<Array<OverduePurchaseCaListingOutput>>;
  OverduePurchaserAccountDetails: OverduePurchaserAccountDetailsOutput;
};

export type OverduePurchaserAccountDetailsOutput = {
  __typename?: 'OverduePurchaserAccountDetailsOutput';
  assignTo?: Maybe<Scalars['String']>;
  clusterId: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  fullName: Scalars['String'];
  generateDate: Scalars['DateTime'];
  overduePurchaser?: Maybe<Array<OverduePurchaserOutput>>;
  phoneNo?: Maybe<Scalars['String']>;
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  totalAllAllocatedAmount?: Maybe<Scalars['Float']>;
  totalAllDocumentAmount?: Maybe<Scalars['Float']>;
  totalAllOutstanding?: Maybe<Scalars['Float']>;
  unitId: Scalars['String'];
  unitNo?: Maybe<Scalars['String']>;
};

export type OverduePurchaserAccountListingOutput = {
  __typename?: 'OverduePurchaserAccountListingOutput';
  assign?: Maybe<Array<OverduePurchaserAccountOutput>>;
  notAssign?: Maybe<Array<OverduePurchaserAccountOutput>>;
};

export type OverduePurchaserAccountOutput = {
  __typename?: 'OverduePurchaserAccountOutput';
  activityDate?: Maybe<Scalars['DateTime']>;
  activityRemark?: Maybe<Scalars['String']>;
  assignedDate?: Maybe<Scalars['DateTime']>;
  assignName?: Maybe<Scalars['String']>;
  assignTo?: Maybe<Scalars['String']>;
  billingType?: Maybe<Scalars['String']>;
  clusterId: Scalars['String'];
  createdTimestamp?: Maybe<Scalars['String']>;
  dueDate: Scalars['DateTime'];
  fullName: Scalars['String'];
  generateDate?: Maybe<Scalars['DateTime']>;
  overduedPurchaserAccountId?: Maybe<Scalars['String']>;
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  totalAllocatedAmount?: Maybe<Scalars['Float']>;
  totalDocumentAmount?: Maybe<Scalars['Float']>;
  totalOutstanding?: Maybe<Scalars['Float']>;
  unitId: Scalars['String'];
  unitNo?: Maybe<Scalars['String']>;
};

export type OverduePurchaserAccountSummaryOutput = {
  __typename?: 'OverduePurchaserAccountSummaryOutput';
  countAllDataNotAssign?: Maybe<Scalars['Float']>;
  sumAllOutstandingAmount?: Maybe<Scalars['Float']>;
};

export enum OverduePurchaserDay {
  DayList = 'DayList',
  Friday = 'FRIDAY',
  GetDay = 'GetDay',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type OverduePurchaserInstallmentOutput = {
  __typename?: 'overduePurchaserInstallmentOutput';
  billingType?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  docId: Scalars['String'];
  dueDate: Scalars['DateTime'];
  itemName?: Maybe<Scalars['String']>;
  totalAllocatedAmount?: Maybe<Scalars['Float']>;
  totalDocumentAmount?: Maybe<Scalars['Float']>;
  totalOutstanding?: Maybe<Scalars['Float']>;
};

export type OverduePurchaserOutput = {
  __typename?: 'overduePurchaserOutput';
  billingType: Scalars['String'];
  creditTerm?: Maybe<Scalars['Float']>;
  docId: Scalars['String'];
  dueDate: Scalars['DateTime'];
  generateDate: Scalars['DateTime'];
  totalAllocatedAmount?: Maybe<Scalars['Float']>;
  totalDocumentAmount?: Maybe<Scalars['Float']>;
  totalOutstanding?: Maybe<Scalars['Float']>;
};

export type OverdueUserListOutput = {
  __typename?: 'overdueUserListOutput';
  fullName?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type PackageEntity = {
  __typename?: 'packageEntity';
  commonStatus: Scalars['String'];
  desc?: Maybe<Scalars['String']>;
  endDate: Scalars['DateTime'];
  id: Scalars['String'];
  integrationPackage: Array<IntegrationPackageEntity>;
  isDeletable: Scalars['Boolean'];
  isIntegrated: Scalars['Boolean'];
  listPrice: Scalars['Float'];
  marketValue: Scalars['Float'];
  name: Scalars['String'];
  packageExt?: Maybe<PackageExtEntity>;
  project: ProjectEntity;
  projectId: Scalars['String'];
  salesContractPackage?: Maybe<SalePackageEntity>;
  salesPackage: Array<SaleEntity>;
  startDate: Scalars['DateTime'];
};

export type PackageExtEntity = {
  __typename?: 'packageExtEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  defaulted: Scalars['Boolean'];
  id: Scalars['String'];
  package: PackageEntity;
  packageId: Scalars['String'];
  taxSchemeId: Scalars['String'];
};

export type PackageInfo = {
  __typename?: 'packageInfo';
  id: Scalars['String'];
  packageNo: Scalars['String'];
  packagePrice: Scalars['Float'];
};

export type PackagePaymentPlanOutput = {
  __typename?: 'packagePaymentPlanOutput';
  billAfter: Scalars['String'];
  billCount: Scalars['Float'];
  billFrequency: Scalars['String'];
  billType: Scalars['String'];
  id: Scalars['String'];
  noInstallment: Scalars['Float'];
  paymentAmt: Scalars['Float'];
  paymentValue: Scalars['Float'];
  purchaserPaymentPlanDetailsId: Scalars['String'];
  salePackageId: Scalars['String'];
  title: Scalars['String'];
};

export type PackagesInstallmentEntity = {
  __typename?: 'packagesInstallmentEntity';
  accountId: Scalars['String'];
  baseAmt?: Maybe<Scalars['Float']>;
  billType?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  documentAmt?: Maybe<Scalars['Float']>;
  documentDate?: Maybe<Scalars['DateTime']>;
  documentNo?: Maybe<Scalars['String']>;
  glGenerated?: Maybe<Scalars['String']>;
  glGenerationBatch?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  interestRate?: Maybe<Scalars['Float']>;
  packagesPaymentId?: Maybe<Scalars['String']>;
  packagesPaymentPlan: PackagesPaymentPlanEntity;
  projectId: Scalars['String'];
  rescheduleId?: Maybe<Scalars['String']>;
  salePackageId: Scalars['String'];
  taxAmt?: Maybe<Scalars['Float']>;
  transDate?: Maybe<Scalars['DateTime']>;
};

export type PackagesPaymentPlanEntity = {
  __typename?: 'packagesPaymentPlanEntity';
  accountId: Scalars['String'];
  billAfter: BillAfter;
  billCount: Scalars['Float'];
  billFrequency: BillFrequency;
  billType: BillType;
  id: Scalars['String'];
  noInstallment: Scalars['Float'];
  packagesInstallment: Array<PackagesInstallmentEntity>;
  paymentAmt: Scalars['Float'];
  purchaserPaymentPlanDetails: PurchaserPaymentPlanDetailsEntity;
  purchaserPaymentPlanDetailsId: Scalars['String'];
  salePackage: SalePackageEntity;
  salePackageId: Scalars['String'];
};

export type PAcontactOutput = {
  __typename?: 'PAcontactOutput';
  companyName?: Maybe<Scalars['String']>;
  companyRegNo?: Maybe<Scalars['String']>;
  contactId: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  icNo: Scalars['String'];
  isCompany?: Maybe<Scalars['Boolean']>;
  officeTel?: Maybe<Scalars['String']>;
  phoneNo: Scalars['String'];
  purchaserName: Scalars['String'];
};

export type PaginationInput = {
  limit?: InputMaybe<Scalars['Float']>;
  offset: Scalars['Float'];
  searchKeyword?: InputMaybe<Scalars['String']>;
};

export type PaidByListSelection = {
  __typename?: 'paidByListSelection';
  financierCode?: Maybe<Scalars['String']>;
  icNo?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type PaidLandDepositInput = {
  bankId: Scalars['String'];
  depositAmount: Scalars['String'];
  depositDate: Scalars['String'];
  depositType: Scalars['String'];
  description: Scalars['String'];
  file?: InputMaybe<Array<Scalars['Upload']>>;
  paymentMethod: Scalars['String'];
  referenceNo: Scalars['String'];
  saleId: Scalars['String'];
};

export type PaidLandDepositsOutput = {
  __typename?: 'PaidLandDepositsOutput';
  depositAmount: Scalars['Float'];
  depositDate: Scalars['DateTime'];
  depositType: Scalars['String'];
  id: Scalars['String'];
};

export type PaIndoAdditionalPackageListingOutput = {
  __typename?: 'paIndoAdditionalPackageListingOutput';
  additionalPackageInstallmentListing?: Maybe<Array<PaIndoPackageOutput>>;
  allocationAmount?: Maybe<Scalars['Float']>;
};

export type PaIndoCarParkDetailOutput = {
  __typename?: 'paIndoCarParkDetailOutput';
  billType?: Maybe<Scalars['String']>;
  creditTerm?: Maybe<Scalars['Float']>;
  documentAmount?: Maybe<Scalars['Float']>;
  documentDate?: Maybe<Scalars['DateTime']>;
  documentNo?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  outstanding?: Maybe<Scalars['Float']>;
  totalAllocated?: Maybe<Scalars['Float']>;
};

export type PaIndoCarParkInstallmentOutput = {
  __typename?: 'PAIndoCarParkInstallmentOutput';
  carParkInstallmentDetail?: Maybe<Array<CarParkInstallmentDetail>>;
  creditTerm?: Maybe<Scalars['Float']>;
  unitNo?: Maybe<Scalars['String']>;
  unitPrice?: Maybe<Scalars['Float']>;
};

export type PaIndoCarParkOutput = {
  __typename?: 'paIndoCarParkOutput';
  clusterName?: Maybe<Scalars['String']>;
  contactName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  itemName?: Maybe<Scalars['String']>;
  sellingPrice?: Maybe<Scalars['Float']>;
  totalAllocated?: Maybe<Scalars['Float']>;
  totalDocumentAmount?: Maybe<Scalars['Float']>;
  totalOutstanding?: Maybe<Scalars['Float']>;
  unitId?: Maybe<Scalars['String']>;
  unitNo?: Maybe<Scalars['String']>;
};

export type PaIndoCarParkUnitOutput = {
  __typename?: 'paIndoCarParkUnitOutput';
  clusterName?: Maybe<Scalars['String']>;
  contactName?: Maybe<Scalars['String']>;
  installmentCount?: Maybe<Scalars['Float']>;
  totalAllocated?: Maybe<Scalars['Float']>;
  totalDocumentAmount?: Maybe<Scalars['Float']>;
  totalOutstanding?: Maybe<Scalars['Float']>;
  unitId?: Maybe<Scalars['String']>;
  unitNo?: Maybe<Scalars['String']>;
};

export type PaIndoDepositInput = {
  attachment?: InputMaybe<Array<Scalars['Upload']>>;
  bankAccountId: Scalars['String'];
  chequeDate?: InputMaybe<Scalars['DateTime']>;
  chequeExpireDate?: InputMaybe<Scalars['DateTime']>;
  creditCardType?: InputMaybe<CreditCardType>;
  depositType: Scalars['String'];
  description: Scalars['String'];
  documentAmount: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  documentNo?: InputMaybe<Scalars['String']>;
  documentRef: Scalars['String'];
  paymentMethod: PaymentMethod;
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  status: CreditControlStatus;
};

export type PaIndoEditDepositInput = {
  attachment?: InputMaybe<Array<Scalars['Upload']>>;
  bankAccountId: Scalars['String'];
  chequeDate?: InputMaybe<Scalars['DateTime']>;
  chequeExpireDate?: InputMaybe<Scalars['DateTime']>;
  creditCardType?: InputMaybe<CreditCardType>;
  deleteAttachments?: InputMaybe<Array<Scalars['String']>>;
  depositType: Scalars['String'];
  description: Scalars['String'];
  documentAmount: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  documentNo?: InputMaybe<Scalars['String']>;
  documentRef: Scalars['String'];
  id: Scalars['String'];
  paymentMethod: PaymentMethod;
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  status: CreditControlStatus;
};

export type PaIndoLateInterestListingOutput = {
  __typename?: 'PAIndoLateInterestListingOutput';
  allocateAmount?: Maybe<Scalars['Float']>;
  bankAccount?: Maybe<Scalars['String']>;
  clusterName: Scalars['String'];
  debitId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  documentAmount: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  documentNo?: Maybe<Scalars['String']>;
  fullName: Scalars['String'];
  id: Scalars['String'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  submittedBy: Scalars['String'];
  submittedDate?: Maybe<Scalars['DateTime']>;
  submitUserData?: Maybe<UserEntity>;
  totalNegotiateAmt: Scalars['Float'];
  totalWaiveAmt: Scalars['Float'];
  unitNo: Scalars['String'];
};

export type PaIndoPackageDetailOutput = {
  __typename?: 'paIndoPackageDetailOutput';
  billType?: Maybe<Scalars['String']>;
  creditTerm?: Maybe<Scalars['Float']>;
  document_amount?: Maybe<Scalars['Float']>;
  document_date?: Maybe<Scalars['DateTime']>;
  document_no?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  outstanding?: Maybe<Scalars['Float']>;
  total_allocated?: Maybe<Scalars['Float']>;
};

export type PaIndoPackageListingOutput = {
  __typename?: 'paIndoPackageListingOutput';
  fullName?: Maybe<Scalars['String']>;
  saleId?: Maybe<Scalars['String']>;
  sellingPrice?: Maybe<Scalars['Float']>;
  totalAllocated?: Maybe<Scalars['Float']>;
  totalDocumentAmount?: Maybe<Scalars['Float']>;
  totalOutstanding?: Maybe<Scalars['Float']>;
  totalSalePackage?: Maybe<Scalars['Float']>;
  unitName?: Maybe<Scalars['String']>;
};

export type PaIndoPackageOutput = {
  __typename?: 'paIndoPackageOutput';
  id?: Maybe<Scalars['String']>;
  itemName?: Maybe<Scalars['String']>;
  numRow?: Maybe<Scalars['Float']>;
  packageId?: Maybe<Scalars['String']>;
  sellingPrice?: Maybe<Scalars['Float']>;
  totalAllocated?: Maybe<Scalars['Float']>;
  totalDocumentAmount?: Maybe<Scalars['Float']>;
  totalOutstanding?: Maybe<Scalars['Float']>;
};

export type PaIndoPackageSummaryOutput = {
  __typename?: 'paIndoPackageSummaryOutput';
  totalAllocated: Scalars['Float'];
  totalCount: Scalars['Float'];
  totalDocumentAmount: Scalars['Float'];
  totalOutstanding?: Maybe<Scalars['Float']>;
  totalSellingPrice: Scalars['Float'];
};

export type PaIndoPurchaserInstallmentDetailOutput = {
  __typename?: 'paIndoPurchaserInstallmentDetailOutput';
  billType?: Maybe<Scalars['String']>;
  documentAmt?: Maybe<Scalars['Float']>;
  documentDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  outStandingAmt?: Maybe<Scalars['Float']>;
  saleId?: Maybe<Scalars['String']>;
  transDate?: Maybe<Scalars['DateTime']>;
};

export type PaIndoPurchaserInstallmentHeaderOutput = {
  __typename?: 'paIndoPurchaserInstallmentHeaderOutput';
  bankLoan: Array<PaIndoPurchaserInstallmentDetailOutput>;
  downPayment: Array<PaIndoPurchaserInstallmentDetailOutput>;
  installment: Array<PaIndoPurchaserInstallmentDetailOutput>;
};

export type PaIndoPurchaserInstallmentListingOutput = {
  __typename?: 'paIndoPurchaserInstallmentListingOutput';
  clusterName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  saleId?: Maybe<Scalars['String']>;
  salesNo?: Maybe<Scalars['String']>;
  salesRegistrationDate?: Maybe<Scalars['DateTime']>;
  salesRegistrationNo?: Maybe<Scalars['String']>;
  totalDocAmt?: Maybe<Scalars['Float']>;
  totalUnallocatedAmt?: Maybe<Scalars['Float']>;
  unitNo?: Maybe<Scalars['String']>;
};

export type PaIndoSubmoduleList = {
  __typename?: 'PAIndoSubmoduleList';
  billName?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  documentAmt?: Maybe<Scalars['Float']>;
  documentDate?: Maybe<Scalars['DateTime']>;
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  saleId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  unitNo?: Maybe<Scalars['String']>;
};

export type PaLateInterestInput = {
  billItemId: Scalars['String'];
  calculateAmt: Scalars['Float'];
  calculateRate: Scalars['Float'];
  creditTerm: Scalars['Float'];
  description: Scalars['String'];
  documentAmount: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  documentRef: Scalars['String'];
  generationBatchDate: Scalars['DateTime'];
  interestAmount: Scalars['Float'];
  interestEndDate: Scalars['DateTime'];
  interestStartDate: Scalars['DateTime'];
  isIncludeHoliday: Scalars['Boolean'];
  overdueDay: Scalars['Float'];
  refId: Scalars['String'];
  refTable: Scalars['String'];
};

export type PaLateInterestSummary = {
  __typename?: 'PALateInterestSummary';
  lastCalculatedDate?: Maybe<Scalars['DateTime']>;
  sellingPrice?: Maybe<Scalars['Float']>;
  totalApproved?: Maybe<Scalars['Float']>;
  totalCharges?: Maybe<Scalars['Float']>;
  totalDraft?: Maybe<Scalars['Float']>;
  totalInstallmentOutstanding?: Maybe<Scalars['Float']>;
  totalInstallmentSaleAmount?: Maybe<Scalars['Float']>;
  totalSubmitted?: Maybe<Scalars['Float']>;
  totalUnallocated?: Maybe<Scalars['Float']>;
};

export type PaLedgerSubmmitedListingOutput = {
  __typename?: 'PALedgerSubmmitedListingOutput';
  approvalRoleId?: Maybe<Scalars['String']>;
  approvedBy: Scalars['String'];
  approveUserData?: Maybe<UserEntity>;
  attachment?: Maybe<Array<AttachmentEntity>>;
  billingDetailTaxData?: Maybe<BillingDetailTaxData>;
  billItem?: Maybe<BillItemEntity>;
  billItemId?: Maybe<Scalars['String']>;
  creditTerm?: Maybe<Scalars['Float']>;
  description: Scalars['String'];
  documentAmount: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  id: Scalars['String'];
  interestRate?: Maybe<Scalars['Float']>;
  refTable: Scalars['String'];
  requestedBy?: Maybe<Scalars['String']>;
  requestUserData?: Maybe<UserEntity>;
  saleId: Scalars['String'];
  submittedBy: Scalars['String'];
  submittedDate: Scalars['DateTime'];
  submitUserData?: Maybe<UserEntity>;
  taxData?: Maybe<TaxSchemeDropdownOutput>;
  unallocatedAmount?: Maybe<Scalars['Float']>;
};

export type PAmoduleSummary = {
  __typename?: 'PAmoduleSummary';
  sellingPrice?: Maybe<Scalars['Float']>;
  totalApproved?: Maybe<Scalars['Float']>;
  totalCharges?: Maybe<Scalars['Float']>;
  totalDraft?: Maybe<Scalars['Float']>;
  totalInstallmentOutstanding?: Maybe<Scalars['Float']>;
  totalInstallmentSaleAmount?: Maybe<Scalars['Float']>;
  totalSubmitted?: Maybe<Scalars['Float']>;
  totalUnallocated?: Maybe<Scalars['Float']>;
};

export type PanelListDto = {
  __typename?: 'PanelListDto';
  bank_name: Scalars['String'];
  financier_name: Scalars['String'];
  finproject_id: Scalars['String'];
  logo_url: Scalars['String'];
  office_tel?: Maybe<Scalars['Float']>;
  total_staff: Scalars['Float'];
};

export type PaPaymentReminderDetails = {
  __typename?: 'paPaymentReminderDetails';
  balanceAmount: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  documentNo: Scalars['String'];
  dueDate: Scalars['DateTime'];
  reminderSeq: Scalars['Float'];
};

export type PaPaymentReminderListingOutput = {
  __typename?: 'paPaymentReminderListingOutput';
  generationBatch: Scalars['String'];
  paymentReminderDetails?: Maybe<Array<PaPaymentReminderDetails>>;
  reminderDate: Scalars['DateTime'];
  saleId: Scalars['String'];
  unitNo: Scalars['String'];
};

export type ParamaterValueOutput = {
  __typename?: 'ParamaterValueOutput';
  address?: Maybe<AddressJson>;
  buyerSolicitor?: Maybe<SolicitorAppointedEntity>;
  company: CompanyEntity;
  developerSolicitor?: Maybe<SolicitorAppointedEntity>;
  developmentCompany: CompanyEntity;
  discount?: Maybe<Array<DiscountParamaterValueOutput>>;
  financier?: Maybe<FinancierEntity>;
  holdingCompany: CompanyEntity;
  installment?: Maybe<Array<Installment>>;
  jointBuyerDetails?: Maybe<Array<ContactEntity>>;
  jointBuyers?: Maybe<Array<JointBuyerEntity>>;
  jointBuyerSignRequired: Scalars['Boolean'];
  lead?: Maybe<LeadEntity>;
  mainBuyerDetails?: Maybe<ContactEntity>;
  mortgagePayment?: Maybe<MortgagePaymentEntity>;
  mortgagePaymentValue?: Maybe<MortgagePaymentEntity>;
  mortgageRetention?: Maybe<MortgageRetentionEntity>;
  mortgageRetentionValues?: Maybe<Array<MortgageRetentionEntity>>;
  payment?: Maybe<SalePaymentValueOutput>;
  project: ProjectEntity;
  receipt?: Maybe<ReceiptEntity>;
  sale?: Maybe<SaleEntity>;
  saleLoan?: Maybe<Array<SaleLoanEntity>>;
  saleLoanRelease?: Maybe<SaleLoanReleaseEntity>;
  salePackage?: Maybe<Array<PackageEntity>>;
  salesCancellation?: Maybe<SaleCancellationEntity>;
  spouse?: Maybe<ContactEntity>;
  unit: UnitEntity;
};

export type ParameterEntity = {
  __typename?: 'parameterEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  defaulted: Scalars['Boolean'];
  id: Scalars['String'];
  isDeletable: Scalars['Boolean'];
  isExistInMasterData: Array<Scalars['String']>;
  isExistInTransactionData: Array<Scalars['String']>;
  name: Scalars['String'];
  parameterType: Scalars['String'];
  saleContact: SaleContactEntity;
  seqNo?: Maybe<Scalars['Float']>;
};

export type ParameterInput = {
  name: Scalars['String'];
};

export type PAreceiptMasterDateOutput = {
  __typename?: 'PAreceiptMasterDateOutput';
  bankList?: Maybe<Array<CompanyBankList>>;
  financierList?: Maybe<Array<FinancierData>>;
  unitNo?: Maybe<Scalars['String']>;
};

export type PartiallyPaidInput = {
  baseAmt?: InputMaybe<Scalars['Float']>;
  billType?: InputMaybe<Scalars['String']>;
  commonStatus?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['DateTime']>;
  descs?: InputMaybe<Scalars['String']>;
  docAmt?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['String']>;
  payAmt?: InputMaybe<Scalars['Float']>;
  taxAmt?: InputMaybe<Scalars['Float']>;
};

export type PartiallyPaidLoanInput = {
  baseAmt?: InputMaybe<Scalars['Float']>;
  billType?: InputMaybe<Scalars['String']>;
  commonStatus?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['DateTime']>;
  descs?: InputMaybe<Scalars['String']>;
  docAmt?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['String']>;
  payAmt?: InputMaybe<Scalars['Float']>;
  taxAmt?: InputMaybe<Scalars['Float']>;
};

export type PassswordErrorMsgOuput = {
  __typename?: 'PassswordErrorMsgOuput';
  RequireDigit: Scalars['String'];
  RequiredLength: Scalars['String'];
  RequiredUniqueChars: Scalars['String'];
  RequireLowercase: Scalars['String'];
  RequireNonAlphanumeric: Scalars['String'];
  RequireUppercase: Scalars['String'];
};

export type PassswordPolicyOuput = {
  __typename?: 'PassswordPolicyOuput';
  ErrorMsg: PassswordErrorMsgOuput;
  RequireDigit: Scalars['Boolean'];
  RequiredLength: Scalars['Float'];
  RequiredUniqueChars: Scalars['Float'];
  RequireLowercase: Scalars['Boolean'];
  RequireNonAlphanumeric: Scalars['Boolean'];
  RequireUppercase: Scalars['Boolean'];
};

export type PasswordPolicyEntity = {
  __typename?: 'passwordPolicyEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  notAllowReusePasswordForLast?: Maybe<Scalars['Float']>;
  passwordResetByDay?: Maybe<Scalars['Float']>;
  requiredDigit: Scalars['Boolean'];
  requiredMinNoCharacter?: Maybe<Scalars['Float']>;
  requiredSpecialCharacter: Scalars['Boolean'];
  requiredUpperLowerCase: Scalars['Boolean'];
};

export type PasswordPolicyInput = {
  changeDays?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['String']>;
  minChar?: InputMaybe<Scalars['Float']>;
  requireDigit: Scalars['Boolean'];
  requireSpecialChar: Scalars['Boolean'];
  requireUpperLower: Scalars['Boolean'];
  samePassword?: InputMaybe<Scalars['Float']>;
};

export type PAuditEntity = {
  created_by: Scalars['String'];
  created_date: Scalars['DateTime'];
  created_ref_table: Scalars['String'];
  modified_by: Scalars['String'];
  modified_date: Scalars['DateTime'];
  modified_ref_table: Scalars['String'];
};

export type PAunitOutput = {
  __typename?: 'PAunitOutput';
  clusterName: Scalars['String'];
  contactId: Scalars['String'];
  saleId: Scalars['String'];
  salesConvertedStatus: Scalars['String'];
  unitId: Scalars['String'];
  unitNo: Scalars['String'];
  unitStatus: Scalars['String'];
};

export type Payment = {
  __typename?: 'payment';
  endfinMortgagePaymentId?: Maybe<Scalars['String']>;
  expectedCount?: Maybe<Scalars['String']>;
  expectedFreq?: Maybe<Scalars['String']>;
  expectedFrom?: Maybe<Scalars['String']>;
  loanAmount?: Maybe<Scalars['String']>;
  paymentId?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
  retention?: Maybe<Array<Retention>>;
};

export enum PaymentBy {
  DescriptionList = 'DescriptionList',
  FixedAmount = 'FIXED_AMOUNT',
  GetDescription = 'GetDescription',
  Percentage = 'PERCENTAGE'
}

export type PaymentELetterOutput = {
  __typename?: 'paymentELetterOutput';
  content: Scalars['String'];
  fileName: Scalars['String'];
};

export type PaymentEletterTemplateOutput = {
  __typename?: 'paymentEletterTemplateOutput';
  defaulted: Scalars['Boolean'];
  id: Scalars['String'];
  letterType: Scalars['String'];
  name: Scalars['String'];
};

export type PaymentExceptionReminderOutput = {
  __typename?: 'paymentExceptionReminderOutput';
  companyName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isCompany?: Maybe<Scalars['Boolean']>;
  maxReminder: Scalars['Float'];
  name: Scalars['String'];
  unitNo: Scalars['String'];
};

export type PaymentGatewayEntity = {
  __typename?: 'paymentGatewayEntity';
  accountId: Scalars['String'];
  assignedProjectCount: Scalars['Float'];
  commonStatus: Scalars['String'];
  gatewayInfo: Scalars['JSONObject'];
  gatewayType: Scalars['String'];
  gatewayTypeDesc: Scalars['String'];
  id: Scalars['String'];
  lastUpdate?: Maybe<Scalars['DateTime']>;
  projectSpecs: Array<ProjectSpecEntity>;
  title: Scalars['String'];
};

export type PaymentGatewayInput = {
  accountId?: InputMaybe<Scalars['String']>;
  gateway_info: Scalars['JSONObject'];
  gateway_type: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type PaymentInterestExceptionFormOutput = {
  __typename?: 'paymentInterestExceptionFormOutput';
  fullName: Scalars['String'];
  isVip?: Maybe<Scalars['Boolean']>;
  saleId: Scalars['String'];
  unitNo: Scalars['String'];
};

export type PaymentInterestExceptionOutput = {
  __typename?: 'paymentInterestExceptionOutput';
  fullName: Scalars['String'];
  isVip?: Maybe<Scalars['Boolean']>;
  remark: Scalars['String'];
  saleId: Scalars['String'];
  unitNo: Scalars['String'];
};

export type PaymentLateInterestInput = {
  generateDate: Scalars['DateTime'];
};

export enum PaymentMethod {
  Cash = 'CASH',
  Cheque = 'CHEQUE',
  CreditCard = 'CREDIT_CARD',
  DescriptionList = 'DescriptionList',
  GetDescription = 'GetDescription',
  OnlinePayment = 'ONLINE_PAYMENT',
  OnlineTransfer = 'ONLINE_TRANSFER'
}

export type PaymentMethodBiOutput = {
  __typename?: 'PaymentMethodBIOutput';
  cashAmount?: Maybe<Scalars['Float']>;
  cashCount?: Maybe<Scalars['Float']>;
  chequeAmount?: Maybe<Scalars['Float']>;
  chequeCount?: Maybe<Scalars['Float']>;
  creditCardAmount?: Maybe<Scalars['Float']>;
  creditCardCount?: Maybe<Scalars['Float']>;
  onlinePaymentAmount?: Maybe<Scalars['Float']>;
  onlinePaymentCount?: Maybe<Scalars['Float']>;
  onlineTransferAmount?: Maybe<Scalars['Float']>;
  onlineTransferCount?: Maybe<Scalars['Float']>;
  totalAmount?: Maybe<Scalars['Float']>;
  totalCount?: Maybe<Scalars['Float']>;
};

export type PaymentPartySelection = {
  __typename?: 'paymentPartySelection';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type PaymentPlan = {
  expectedCount?: InputMaybe<Scalars['String']>;
  expectedFreq?: InputMaybe<Scalars['String']>;
  expectedFrom?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  loanAmount?: InputMaybe<Scalars['Float']>;
  retention?: InputMaybe<Array<RetentionPlan>>;
};

export type PaymentPlanDetail = {
  __typename?: 'paymentPlanDetail';
  title?: Maybe<Scalars['String']>;
};

export type PaymentPlanDetailEntity = {
  __typename?: 'paymentPlanDetailEntity';
  accountId: Scalars['String'];
  amountType: Scalars['String'];
  amountValue: Scalars['Float'];
  architectCertWorkProgress?: Maybe<ArchitectCertWorkProgressEntity>;
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  includeInDetailId?: Maybe<Array<IncludeInDetail>>;
  installmentBillingDay?: Maybe<Scalars['Float']>;
  isDeletable: Scalars['Boolean'];
  isDownpayment: Scalars['Boolean'];
  isStakeholder: Scalars['Boolean'];
  isVpStage: Scalars['Boolean'];
  isWithInterest: Scalars['Boolean'];
  numberOfPayment?: Maybe<Scalars['Float']>;
  payment: PaymentPlanEntity;
  paymentPlanId: Scalars['String'];
  progressBilling?: Maybe<Array<ProgressBillingEntity>>;
  stageSeqNo: Scalars['Float'];
  stakeholderDuration?: Maybe<Scalars['Float']>;
  title: Scalars['String'];
  workProgress?: Maybe<WorkProgressEntity>;
  workProgressId: Scalars['String'];
};

export type PaymentPlanDetails = {
  amount: Scalars['Float'];
  saleId?: InputMaybe<Scalars['String']>;
  saleLoanId?: InputMaybe<Scalars['String']>;
  saleLoanPaymentPlanId?: InputMaybe<Scalars['String']>;
};

export type PaymentPlanEntity = {
  __typename?: 'paymentPlanEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  details?: Maybe<Array<PaymentPlanDetailEntity>>;
  effectiveDate: Scalars['DateTime'];
  id: Scalars['String'];
  isDeletable: Scalars['Boolean'];
  isEditable: Scalars['Boolean'];
  isExistInMasterData: Array<Scalars['String']>;
  isExistInTableData: Array<Scalars['String']>;
  isExistInTransactionData: Array<Scalars['String']>;
  name: Scalars['String'];
  payMethod?: Maybe<Scalars['String']>;
  projectPaymentPlan?: Maybe<Array<ProjectPaymentPlanEntity>>;
  saleExt?: Maybe<SaleExtensionEntity>;
  unitExt?: Maybe<UnitExtensionEntity>;
};

export type PaymentPlanInstallmentOutput = {
  __typename?: 'PaymentPlanInstallmentOutput';
  discAmt?: Maybe<Scalars['Float']>;
  installmentSummary?: Maybe<Array<InstallmentSummaryOutput>>;
  markUpPercentage?: Maybe<Scalars['Float']>;
  markUpPrice?: Maybe<Scalars['Float']>;
  paymentPlanDate?: Maybe<Scalars['DateTime']>;
  paymentPlanId: Scalars['String'];
};

export type PaymentPlanOutput = {
  __typename?: 'paymentPlanOutput';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type PaymentPlanSummary = {
  billAfter: Scalars['String'];
  billCount: Scalars['Float'];
  billFreq: Scalars['String'];
  billType: Scalars['String'];
  carParkId?: InputMaybe<Scalars['String']>;
  deductBookingFee?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  installmentDetail: Array<InstallmentDetailInput>;
  isFixAmt?: InputMaybe<Scalars['Boolean']>;
  noInstallment: Scalars['Float'];
  paymentAmt: Scalars['Float'];
  purchaserPaymentPlanDetailsId: Scalars['String'];
  salePackageId?: InputMaybe<Scalars['String']>;
  value: Scalars['Float'];
};

export type PaymentReminder = {
  __typename?: 'paymentReminder';
  alertList: Array<AlertOutput>;
  balanceAmount?: Maybe<Scalars['Float']>;
  maxReminder?: Maybe<Scalars['Float']>;
  numAlert: Scalars['Float'];
  reminderNo?: Maybe<Scalars['String']>;
  saleId: Scalars['String'];
  taxSchemeId?: Maybe<Scalars['String']>;
  unitNo: Scalars['String'];
};

export type PaymentReminderDetailList = {
  __typename?: 'paymentReminderDetailList';
  docAmt: Scalars['Float'];
  docDate: Scalars['String'];
  docNo: Scalars['String'];
  dueDate: Scalars['String'];
  outstanding: Scalars['Float'];
  refId: Scalars['String'];
  refTable: Scalars['String'];
  reminderDate: Scalars['String'];
  reminderId?: Maybe<Scalars['String']>;
  reminderSeq: Scalars['Float'];
};

export type PaymentReminderDocumentOutput = {
  __typename?: 'paymentReminderDocumentOutput';
  balanceAmt: Scalars['Float'];
  desc?: Maybe<Scalars['String']>;
  docAmt: Scalars['Float'];
  docNo: Scalars['String'];
  reminderSeq: Scalars['Float'];
};

export type PaymentReminderEntity = {
  __typename?: 'paymentReminderEntity';
  accountId: Scalars['String'];
  balanceAmount: Scalars['Float'];
  commonStatus: Scalars['String'];
  generationBatch?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  intervalDays: Scalars['Float'];
  projectId: Scalars['String'];
  refId: Scalars['String'];
  refTable: Scalars['String'];
  reminderDate: Scalars['DateTime'];
  reminderNo?: Maybe<Scalars['String']>;
  reminderSeq: Scalars['Float'];
  saleId: Scalars['String'];
  share?: Maybe<Array<ShareObject>>;
};

export type PaymentReminderIdsInput = {
  reminderIds?: InputMaybe<Array<Scalars['String']>>;
};

export type PaymentReminderListingIndoOutput = {
  __typename?: 'paymentReminderListingIndoOutput';
  balanceAmount: Scalars['Float'];
  generationBatch: Scalars['String'];
  reminder1: Scalars['Float'];
  reminder2: Scalars['Float'];
  reminder3: Scalars['Float'];
  reminderDate: Scalars['DateTime'];
  reminderId: Scalars['String'];
  unitNo: Array<Scalars['String']>;
};

export type PaymentReminderListingOutput = {
  __typename?: 'paymentReminderListingOutput';
  balanceAmount: Scalars['Float'];
  generationBatch: Scalars['String'];
  reminder1: Scalars['Float'];
  reminder2: Scalars['Float'];
  reminder3: Scalars['Float'];
  reminder4: Scalars['Float'];
  reminderDate: Scalars['DateTime'];
  unitNo: Array<Scalars['String']>;
};

export type PaymentReminderListInput = {
  reminderList: Array<AddPaymentReminderInput>;
};

export type PaymentReminderOutput = {
  __typename?: 'paymentReminderOutput';
  billing: Array<PaymentReminderDetailList>;
  reminder1: Scalars['Float'];
  reminder2: Scalars['Float'];
  reminder3: Scalars['Float'];
  saleId: Scalars['String'];
  share?: Maybe<Array<ShareObject>>;
  totalBalance: Scalars['Float'];
  unitNo: Scalars['String'];
};

export type PaymentReminderRawOutput = {
  __typename?: 'paymentReminderRawOutput';
  actualBuiltUpArea?: Maybe<Scalars['Float']>;
  billingList: Array<PaymentReminderDocumentOutput>;
  block?: Maybe<Scalars['String']>;
  builtUpArea?: Maybe<Scalars['Float']>;
  buyerName: Scalars['String'];
  clusterCode?: Maybe<Scalars['String']>;
  clusterName?: Maybe<Scalars['String']>;
  companyAddress?: Maybe<AddressPaymentReminder>;
  companyEmail?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  companyOfficeTel?: Maybe<Scalars['String']>;
  correspondenceAddress?: Maybe<AddressPaymentReminder>;
  email: Scalars['String'];
  floorLabel?: Maybe<Scalars['String']>;
  projectAddress?: Maybe<Scalars['String']>;
  projectCity?: Maybe<Scalars['String']>;
  projectName?: Maybe<Scalars['String']>;
  reminderDate: Scalars['DateTime'];
  townshipName?: Maybe<Scalars['String']>;
  unitNo: Scalars['String'];
  unitPhase?: Maybe<Scalars['Float']>;
  unitPrice?: Maybe<Scalars['Float']>;
};

export type PaymentReminderShareOutput = {
  __typename?: 'paymentReminderShareOutput';
  attachment?: Maybe<Array<PdfOutput>>;
  downloadFile: Scalars['Boolean'];
  isProject?: Maybe<Scalars['Boolean']>;
  letterTemplateList?: Maybe<Array<ShareLetterTemplateOutput>>;
};

export type PaymentReminderSummaryOutput = {
  __typename?: 'paymentReminderSummaryOutput';
  reminder1: Scalars['Float'];
  reminder2: Scalars['Float'];
  reminder3: Scalars['Float'];
};

export type PaymentSummary = {
  __typename?: 'PaymentSummary';
  approveCount?: Maybe<Scalars['Float']>;
  draftCount?: Maybe<Scalars['Float']>;
  submitCount?: Maybe<Scalars['Float']>;
  totalDocAmt?: Maybe<Scalars['Float']>;
  totalUnallocatedAmt?: Maybe<Scalars['Float']>;
};

export type PaymentWithReminderOutput = {
  __typename?: 'paymentWithReminderOutput';
  companyName?: Maybe<Scalars['String']>;
  isCompany?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  saleId: Scalars['String'];
  unitNo: Scalars['String'];
};

export type PbData = {
  __typename?: 'pbData';
  has_architect_cert?: Maybe<Scalars['Boolean']>;
  has_posted?: Maybe<Scalars['Boolean']>;
  stage_seq_no?: Maybe<Scalars['Float']>;
};

export type PBdata = {
  __typename?: 'PBdata';
  account_id: Scalars['String'];
  acId?: Maybe<Scalars['String']>;
  add_on_ref_id?: Maybe<Scalars['String']>;
  add_on_ref_table?: Maybe<Scalars['String']>;
  addOnData?: Maybe<Scalars['String']>;
  allow_reversal: Scalars['Boolean'];
  bill_item_id: Scalars['String'];
  charge_percent: Scalars['String'];
  common_status: Scalars['String'];
  createdBy: Scalars['String'];
  createdTs: Scalars['String'];
  credit_term: Scalars['Float'];
  creditDocumentNo?: Maybe<Array<Scalars['String']>>;
  description: Scalars['String'];
  document_amount?: Maybe<Scalars['Float']>;
  document_date?: Maybe<Scalars['DateTime']>;
  document_no?: Maybe<Scalars['String']>;
  document_ref?: Maybe<Scalars['String']>;
  due_date?: Maybe<Scalars['DateTime']>;
  fbData?: Maybe<FbData>;
  generation_batch?: Maybe<Scalars['String']>;
  generation_batch_credit_term?: Maybe<Scalars['String']>;
  gl_generated: Scalars['String'];
  gl_generation_batch?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  installment_seq_no?: Maybe<Scalars['Float']>;
  interest_rate: Scalars['String'];
  is_downpayment: Scalars['Boolean'];
  is_include_holiday: Scalars['Boolean'];
  is_installment: Scalars['Boolean'];
  is_stakeholder: Scalars['Boolean'];
  is_vp_stage: Scalars['Boolean'];
  isAC: Scalars['Boolean'];
  isBuyer: Scalars['Boolean'];
  isReversal: Scalars['Boolean'];
  isVoid: Scalars['Boolean'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['String'];
  outstandingAmt: Scalars['Float'];
  payment_plan_detail_id: Scalars['String'];
  pbAmount: Scalars['String'];
  principal_amt: Scalars['String'];
  project_id: Scalars['String'];
  sale_id: Scalars['String'];
  stage_seq_no: Scalars['Float'];
  title?: Maybe<Scalars['String']>;
  totalAllocateAmount: Scalars['Float'];
  totalFBamount: Scalars['Float'];
  void_by?: Maybe<Scalars['String']>;
  void_date?: Maybe<Scalars['DateTime']>;
};

export type PBdataList = {
  __typename?: 'PBdataList';
  sale_package?: Maybe<Array<AddOnRef>>;
  sale_product: Array<AddOnRef>;
  sale_subproduct?: Maybe<Array<AddOnRef>>;
};

export type PBsummary = {
  __typename?: 'PBsummary';
  pbData?: Maybe<Array<PbData>>;
  totalCharges?: Maybe<Scalars['Float']>;
  totalUnallocated?: Maybe<Scalars['Float']>;
};

export type PdfOutput = {
  __typename?: 'pdfOutput';
  base64: Scalars['String'];
  fileName: Scalars['String'];
};

export type PdpaDetailByProject = {
  __typename?: 'PDPADetailByProject';
  id?: Maybe<Scalars['String']>;
  letterType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  standardLetterId?: Maybe<Scalars['String']>;
  templateBody?: Maybe<Scalars['String']>;
};

export type PendingInstallmentByIdOutput = {
  __typename?: 'pendingInstallmentByIdOutput';
  applyAmount?: Maybe<Scalars['Float']>;
  approvalDate?: Maybe<Scalars['DateTime']>;
  approvedAmount?: Maybe<Scalars['Float']>;
  bookDate?: Maybe<Scalars['DateTime']>;
  borrowerName: Scalars['String'];
  clusterCode: Scalars['String'];
  financier: Scalars['String'];
  fullName: Scalars['String'];
  id: Scalars['String'];
  installments: Array<RescheduledInstallmentOutput>;
  rescheduleDate?: Maybe<Scalars['DateTime']>;
  saleId: Scalars['String'];
  salesNo: Scalars['String'];
  unitNo: Scalars['String'];
};

export type PerformanceByInternalAndAgency = {
  __typename?: 'PerformanceByInternalAndAgency';
  agencyName?: Maybe<Scalars['String']>;
  staff?: Maybe<Array<SalesPersonSalesAvgOutput>>;
  teamId: Scalars['String'];
  teamName: Scalars['String'];
  totalTeamCount?: Maybe<Scalars['Float']>;
  totalTeamPrice?: Maybe<Scalars['Float']>;
};

export type PermissionDetail = {
  __typename?: 'PermissionDetail';
  action?: Maybe<Scalars['String']>;
  child?: Maybe<Array<PermissionDetail>>;
  code?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  id: Scalars['String'];
  module?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  package_code: Scalars['String'];
  parent_id?: Maybe<Scalars['String']>;
  permission_key: Scalars['String'];
  permissionId?: Maybe<Scalars['Float']>;
  permissionType?: Maybe<PermissionType>;
  seq_no?: Maybe<Scalars['Float']>;
  submodule?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type PermissionEntity = {
  __typename?: 'PermissionEntity';
  accountId?: Maybe<Scalars['ID']>;
  action?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  module: Scalars['String'];
  name: Scalars['String'];
  packageCode: Scalars['String'];
  parentId?: Maybe<Scalars['ID']>;
  permissionOldId?: Maybe<Scalars['Float']>;
  permissionRoleAssignments: Array<PermissionRoleAssignmentEntity>;
  seqNo?: Maybe<Scalars['Float']>;
  softwareCode: Scalars['String'];
  submodule?: Maybe<Scalars['String']>;
};

export type PermissionRoleAssignmentEntity = AuditEntity & {
  __typename?: 'permissionRoleAssignmentEntity';
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  permission: PermissionEntity;
  permission_uuid: Scalars['String'];
  permissionId: Scalars['Float'];
  roleId: Scalars['String'];
};

export enum PermissionType {
  Report = 'REPORT',
  SalesAdmin = 'SALES_ADMIN'
}

export enum PermitType {
  AdvertisementPermit = 'ADVERTISEMENT_PERMIT',
  BuildingPlan = 'BUILDING_PLAN',
  DescriptionList = 'DescriptionList',
  DeveloperLicense = 'DEVELOPER_LICENSE',
  GetDescription = 'GetDescription'
}

export type PictureBlockEntity = {
  __typename?: 'pictureBlockEntity';
  block: Scalars['String'];
  id: Scalars['String'];
  project: ProjectEntity;
  resource: ResourceEntity;
  seqNo: Scalars['Float'];
};

export type PictureFloorEntity = {
  __typename?: 'pictureFloorEntity';
  block: Scalars['String'];
  floor: Scalars['Float'];
  id: Scalars['String'];
  project: ProjectEntity;
  resource: ResourceEntity;
  seqNo: Scalars['Float'];
};

export type PictureGalleryEntity = {
  __typename?: 'pictureGalleryEntity';
  id: Scalars['String'];
  project: ProjectEntity;
  resource: ResourceEntity;
  seqNo: Scalars['Float'];
};

export type PictureUnitlayoutEntity = {
  __typename?: 'pictureUnitlayoutEntity';
  block: Scalars['String'];
  id: Scalars['String'];
  noOfBathroom: Scalars['Float'];
  noOfBedroom: Scalars['Float'];
  project: ProjectEntity;
  projectId: Scalars['String'];
  resource: ResourceEntity;
  seqNo: Scalars['Float'];
  unitLayout: UnitLayoutEntity;
  unitType?: Maybe<Scalars['String']>;
  virtualModelLink: Scalars['String'];
};

export type PiSummary = {
  __typename?: 'PISummary';
  approveCount?: Maybe<Scalars['Float']>;
  draftCount?: Maybe<Scalars['Float']>;
  submitCount?: Maybe<Scalars['Float']>;
  totalDocAmt?: Maybe<Scalars['Float']>;
  totalUnallocatedAmt?: Maybe<Scalars['Float']>;
};

export type PlatformUserAssignedAccountEntity = {
  __typename?: 'PlatformUserAssignedAccountEntity';
  accountId: Scalars['String'];
  commonStatus: CommonStatus;
  id: Scalars['String'];
  platformUserId: Scalars['String'];
};

export type PlatformUserEntity = {
  __typename?: 'PlatformUserEntity';
  accessToken?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['String']>;
  commonStatus: CommonStatus;
  contactNo?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  ID: Scalars['String'];
  isActivated: Scalars['Boolean'];
  name: Scalars['String'];
  password: Scalars['String'];
  refreshToken?: Maybe<Scalars['String']>;
  role: PlatformUserRole;
  username: Scalars['String'];
};

export enum PlatformUserRole {
  Admin = 'ADMIN',
  Staff = 'STAFF',
  Superadmin = 'SUPERADMIN'
}

export type PositionCodeOption = {
  __typename?: 'positionCodeOption';
  positionId?: Maybe<Scalars['String']>;
  teamPositionId: Scalars['String'];
  teamPositionName: Scalars['String'];
};

export type PositionInfo = {
  __typename?: 'PositionInfo';
  position: Scalars['String'];
};

export type PostCodeMasterDataOutput = {
  __typename?: 'PostCodeMasterDataOutput';
  cityID: Scalars['String'];
  commonStatus: Scalars['String'];
  ID: Scalars['String'];
  postcode: Scalars['String'];
};

export type PostDeemCollectedInput = {
  collectionBatchId: Scalars['String'];
  deemCollectedUnitDetail: Array<DeemCollectedUnitDetail>;
  documentAmount: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  documentRef: Scalars['String'];
  solicitorId: Scalars['String'];
};

export type PostedUnitListingOutput = {
  __typename?: 'postedUnitListingOutput';
  unitId?: Maybe<Scalars['String']>;
};

export type PostingInput = {
  action: Scalars['String'];
  receiptIds: Array<Scalars['String']>;
};

export type PostingMiscBillingInput = {
  miscBillingId: Array<Scalars['String']>;
};

export type PostingProgressBillingInput = {
  progressBillingId: Array<Scalars['String']>;
  saleId?: InputMaybe<Scalars['String']>;
};

export type PostLogEntity = {
  __typename?: 'postLogEntity';
  body: Scalars['JSONObject'];
  endpoint?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isSuccess: Scalars['Boolean'];
  modifiedDate: Scalars['DateTime'];
  postDate: Scalars['DateTime'];
  response?: Maybe<Scalars['String']>;
  retryCount?: Maybe<Scalars['Float']>;
  unitId?: Maybe<Scalars['Float']>;
};

export enum PostStatus {
  Draft = 'DRAFT',
  Posted = 'POSTED'
}

export type PriceAdjustmentDetailOutput = {
  __typename?: 'priceAdjustmentDetailOutput';
  approvalRoleId?: Maybe<Scalars['String']>;
  computationMode: Scalars['String'];
  computationValue: Scalars['Float'];
  defaultReason?: Maybe<Array<ReasonCodeEntity>>;
  displayRoundingMode?: Maybe<Scalars['String']>;
  displayRoundingPrecision?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  priceAdjustmentUnit?: Maybe<Array<PriceAdjustmentUnitList>>;
  reason: Scalars['String'];
  remark: Scalars['String'];
  roundingMode: Scalars['String'];
  roundingPrecision: Scalars['String'];
  status: Scalars['String'];
};

export type PriceAdjustmentEntity = {
  __typename?: 'priceAdjustmentEntity';
  accountId: Scalars['String'];
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  commonStatus: Scalars['String'];
  computationMode: Scalars['String'];
  computationValue: Scalars['Float'];
  id: Scalars['String'];
  name: Scalars['String'];
  priceAdjustmentUnit: Array<PriceAdjustmentUnitEntity>;
  projectId: Scalars['String'];
  reason: Scalars['String'];
  remark?: Maybe<Scalars['String']>;
  roundingMode: Scalars['String'];
  roundingPrecision: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  submittedBy?: Maybe<Scalars['String']>;
  submittedDate?: Maybe<Scalars['DateTime']>;
};

export type PriceAdjustmentListOutput = {
  __typename?: 'priceAdjustmentListOutput';
  approvalRoleId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  submittedBy?: Maybe<Scalars['String']>;
  submitUserData?: Maybe<UserEntity>;
  unitCount?: Maybe<Scalars['Float']>;
};

export type PriceAdjustmentUnitEntity = {
  __typename?: 'priceAdjustmentUnitEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  newUnitListPrice: Scalars['Float'];
  priceAdjustmentId: Scalars['String'];
  priceAdjustments: PriceAdjustmentEntity;
  projectId: Scalars['String'];
  unitId: Scalars['String'];
  unitListPrice: Scalars['Float'];
  units: UnitEntity;
};

export type PriceAdjustmentUnitList = {
  __typename?: 'priceAdjustmentUnitList';
  id: Scalars['String'];
  newUnitListPrice: Scalars['Float'];
  unitId: Scalars['String'];
  unitListPrice: Scalars['Float'];
  unitNo: Scalars['String'];
};

export type ProductEntity = AuditEntity & {
  __typename?: 'ProductEntity';
  accessTokenSecret: Scalars['String'];
  code: Scalars['String'];
  commonStatus: CommonStatus;
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  description: Scalars['String'];
  environmentUrl?: Maybe<Array<EnvironmentUrl>>;
  ID: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  module: Array<ModuleEntity>;
  name: Scalars['String'];
  refreshTokenSecret: Scalars['String'];
};

export type Progress_Billing = {
  __typename?: 'progress_billing';
  car_park?: Maybe<Array<Car_Park>>;
  sale_package?: Maybe<Array<Sale_Package>>;
  sale_progress_billing?: Maybe<Array<Sale_Progress_Billing>>;
};

export type ProgressBilling = {
  __typename?: 'progressBilling';
  allow_reversal: Scalars['Boolean'];
  details?: Maybe<Array<Details>>;
  gotAC: Scalars['Boolean'];
  isReversal?: Maybe<Scalars['Boolean']>;
  paymentPlanDetailTitle?: Maybe<Scalars['String']>;
  stageSeqNo: Scalars['Float'];
  system_use?: Maybe<Scalars['Boolean']>;
  totalDocumentAmt?: Maybe<Scalars['Float']>;
  totalOutstanding?: Maybe<Scalars['Float']>;
};

export type ProgressBillingByGenerationBatchSummary = {
  __typename?: 'progressBillingByGenerationBatchSummary';
  billingCount: Scalars['Float'];
  billingDetail: Array<ProgressBillingDetail>;
  creditTerm: Scalars['Float'];
  docDate: Scalars['String'];
  interestRate: Scalars['Float'];
  pbDetail?: Maybe<Array<Sale_Progress_Billing>>;
  saleId: Scalars['String'];
  salesStatus: Scalars['String'];
  saleUnitNo: Scalars['String'];
  totalDocAmt: Scalars['Float'];
  totalPrincipalAmt: Scalars['Float'];
  totalTaxAmt: Scalars['Float'];
  unitNo: Scalars['String'];
};

export type ProgressBillingByTypeName = {
  __typename?: 'ProgressBillingByTypeName';
  name: Scalars['String'];
  progressBillingList: Array<ProgressBillingEntity>;
};

export type ProgressBillingData = {
  __typename?: 'progressBillingData';
  addOnRefId?: Maybe<Scalars['String']>;
  addOnRefTable?: Maybe<Scalars['String']>;
  chargePercent: Scalars['Float'];
  commonStatus: Scalars['String'];
  creditTerm: Scalars['Float'];
  description: Scalars['String'];
  documentAmount?: Maybe<Scalars['Float']>;
  documentDate?: Maybe<Scalars['DateTime']>;
  documentNo?: Maybe<Scalars['String']>;
  documentRef?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  generationBatch?: Maybe<Scalars['String']>;
  glGenerated: Scalars['Boolean'];
  installmentSeqNo?: Maybe<Scalars['Float']>;
  interestRate: Scalars['Float'];
  isDownpayment: Scalars['Boolean'];
  isIncludeHoliday: Scalars['Boolean'];
  isInstallment: Scalars['Boolean'];
  isStakeholder: Scalars['Boolean'];
  isVpStage: Scalars['Boolean'];
  paymentPlanDetail: Array<PaymentPlanDetail>;
  paymentPlanDetailId: Scalars['String'];
  principalAmt?: Maybe<Scalars['Float']>;
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  stageSeqNo: Scalars['Float'];
  taxAmount?: Maybe<Scalars['Float']>;
  taxId: Scalars['String'];
  taxRate?: Maybe<Scalars['Float']>;
};

export type ProgressBillingDetail = {
  __typename?: 'progressBillingDetail';
  addOnRefId?: Maybe<Scalars['String']>;
  addOnRefTable?: Maybe<Scalars['String']>;
  docAmt: Scalars['Float'];
  docDate?: Maybe<Scalars['String']>;
  docNo?: Maybe<Scalars['String']>;
  installmentSeqNo?: Maybe<Scalars['Float']>;
  principalAmt: Scalars['Float'];
  progressBillingId: Scalars['String'];
  stageSeqNo: Scalars['Float'];
  taxAmt: Scalars['Float'];
  title: Scalars['String'];
};

export type ProgressBillingDetailOutput = {
  __typename?: 'ProgressBillingDetailOutput';
  creditTerm: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  generationBatch?: Maybe<Scalars['String']>;
  paymentPlan: Array<ProgressBillingPaymentPlanDetail>;
  principalAmt: Scalars['Float'];
  progressBillingId: Array<Scalars['String']>;
  saleId: Scalars['String'];
  unitNo: Scalars['String'];
  workProgressTitle: Scalars['String'];
};

export type ProgressBillingEntity = {
  __typename?: 'progressBillingEntity';
  accountId: Scalars['String'];
  addOnName?: Maybe<Scalars['String']>;
  addOnRefId?: Maybe<Scalars['String']>;
  addOnRefTable?: Maybe<Scalars['String']>;
  allowReversal: Scalars['Boolean'];
  amount?: Maybe<Scalars['Float']>;
  billingDetailTaxData?: Maybe<BillingDetailTaxData>;
  billItem?: Maybe<BillItemEntity>;
  billItemId: Scalars['String'];
  chargePercent: Scalars['Float'];
  commonStatus: Scalars['String'];
  creditTerm: Scalars['Float'];
  description: Scalars['String'];
  documentAmount?: Maybe<Scalars['Float']>;
  documentDate?: Maybe<Scalars['DateTime']>;
  documentNo?: Maybe<Scalars['String']>;
  documentRef?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  financialBilling?: Maybe<Array<FinancialBillingEntity>>;
  generationBatch?: Maybe<Scalars['String']>;
  generationBatchCreditTerm?: Maybe<Scalars['Float']>;
  glGenerated: Scalars['String'];
  glGenerationBatch?: Maybe<Scalars['String']>;
  gotArchitectCert: Scalars['Boolean'];
  groupId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  installmentSeqNo?: Maybe<Scalars['Float']>;
  interestRate?: Maybe<Scalars['Float']>;
  isDownpayment: Scalars['Boolean'];
  isFinancialBilling: Scalars['Boolean'];
  isIncludeHoliday: Scalars['Boolean'];
  isInstallment: Scalars['Boolean'];
  isStakeholder: Scalars['Boolean'];
  isVpStage: Scalars['Boolean'];
  paymentPlanDetail?: Maybe<PaymentPlanDetailEntity>;
  paymentPlanDetailId: Scalars['String'];
  principalAmt?: Maybe<Scalars['Float']>;
  projectDetail?: Maybe<ProjectEntity>;
  projectId: Scalars['String'];
  purchaserAcc?: Maybe<Scalars['String']>;
  saleId: Scalars['String'];
  sales?: Maybe<SaleEntity>;
  stageSeqNo: Scalars['Float'];
  stakeholderProcess?: Maybe<StakeholderProcessEntity>;
  subproduct?: Maybe<SaleSubproductEntity>;
  taxData?: Maybe<TaxSchemeDropdownOutput>;
  taxLedger?: Maybe<Array<TaxLedgerEntity>>;
  title?: Maybe<Scalars['String']>;
  totalAmount?: Maybe<Scalars['Float']>;
  unallocatedAmount?: Maybe<Scalars['Float']>;
  voidBy?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
  voidUserData?: Maybe<UserEntity>;
};

export type ProgressBillingList2 = {
  __typename?: 'ProgressBillingList2';
  allowPosted: Scalars['Boolean'];
  allowReversal: Scalars['Boolean'];
  billingDetail: Array<ProgressBillingListDetailOutput>;
  documentDate: Scalars['DateTime'];
  generationBatch?: Maybe<Scalars['String']>;
  isReversal: Scalars['Boolean'];
  totalPrincipalAmt: Scalars['Float'];
  unitCount: Scalars['Float'];
  unitIndex?: Maybe<Scalars['String']>;
};

export type ProgressBillingListDetailOutput = {
  __typename?: 'ProgressBillingListDetailOutput';
  allowPosted: Scalars['Boolean'];
  allowReversal: Scalars['Boolean'];
  progressBillingId: Scalars['String'];
  saleId: Scalars['String'];
  unitNo: Scalars['String'];
};

export type ProgressBillingOutput = {
  __typename?: 'ProgressBillingOutput';
  package: Array<ProgressBillingByTypeName>;
  sale: Array<ProgressBillingByTypeName>;
  subProduct: Array<ProgressBillingByTypeName>;
};

export type ProgressBillingOverView = {
  __typename?: 'progressBillingOverView';
  description: Scalars['String'];
  id: Scalars['String'];
  paymentPlanDetailId: Scalars['String'];
  saleId: Scalars['String'];
  stageSeqNo: Scalars['Float'];
};

export type ProgressBillingPaymentPlanDetail = {
  __typename?: 'progressBillingPaymentPlanDetail';
  principalAmt: Scalars['Float'];
  title: Scalars['String'];
};

export type ProgressBillingReminderOutput = {
  __typename?: 'progressBillingReminderOutput';
  balanceAmount: Scalars['Float'];
  buyerName: Scalars['String'];
  companyName?: Maybe<Scalars['String']>;
  docNo: Scalars['String'];
  isCompany?: Maybe<Scalars['Boolean']>;
  progressBillingId: Scalars['String'];
  reminderId: Scalars['String'];
  reminderSeq: Scalars['Float'];
  saleId: Scalars['String'];
  share?: Maybe<Array<ShareObject>>;
  unitNo: Scalars['String'];
};

export type ProgressBillingSummary = {
  __typename?: 'progressBillingSummary';
  billingCount: Scalars['Float'];
  billingDetail: Array<ProgressBillingDetail>;
  pbDetail?: Maybe<Array<Sale_Progress_Billing>>;
  saleId: Scalars['String'];
  salesStatus: Scalars['String'];
  saleUnitNo: Scalars['String'];
  totalDocAmt: Scalars['Float'];
  totalPrincipalAmt: Scalars['Float'];
  totalTaxAmt: Scalars['Float'];
  unitNo: Scalars['String'];
};

export type ProgressBillsListOutput = {
  __typename?: 'ProgressBillsListOutput';
  packageProgressBilling: Array<ProgressBillingEntity>;
  progressBilling: Array<ProgressBillingEntity>;
  subProductProgressBilling: Array<ProgressBillingEntity>;
};

export type ProgressLogDetails = {
  __typename?: 'ProgressLogDetails';
  name?: Maybe<Scalars['String']>;
  progressdate?: Maybe<Scalars['DateTime']>;
  progressdesc?: Maybe<Scalars['String']>;
  progresstype?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  sale_id?: Maybe<Scalars['String']>;
  spastatus?: Maybe<Scalars['String']>;
};

export type ProgressStageOutput = {
  __typename?: 'progressStageOutput';
  id?: Maybe<Scalars['String']>;
  isCarPark: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
};

export type ProjectAreaVarianceEntity = {
  __typename?: 'projectAreaVarianceEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  effectiveDate: Scalars['DateTime'];
  formula?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  projectId: Scalars['String'];
};

export type ProjectBankIndoEntity = {
  __typename?: 'projectBankIndoEntity';
  accountId: Scalars['String'];
  bankAccount: CompanyBankAccountEntity;
  bankAccountId: Scalars['String'];
  bankProfileId: Scalars['String'];
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  project: ProjectEntity;
  projectId: Scalars['String'];
};

export type ProjectBlockMediaOuput = {
  __typename?: 'ProjectBlockMediaOuput';
  block: Scalars['String'];
  caption?: Maybe<Scalars['String']>;
  pictureid: Scalars['String'];
  resourceid?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type ProjectBookingDetailOutput = {
  __typename?: 'ProjectBookingDetailOutput';
  bookingFeeAttachments: Scalars['Float'];
  buyer: Scalars['Float'];
  joinBuyer: Scalars['Float'];
  otherAttachments: Scalars['Float'];
  sale: Scalars['Float'];
  unit: Scalars['Float'];
};

export type ProjectBridgingFinancierInput = {
  chargeExeType: Scalars['String'];
  chargeExeValue: Scalars['Float'];
  financierId: Scalars['String'];
  financierReferenceNo: Scalars['String'];
  projectId: Scalars['String'];
  solicitorId: Scalars['String'];
  solicitorReferenceNo: Scalars['String'];
  unitInput: Array<ProjectBridgingFinancierUnitInput>;
};

export type ProjectBridgingFinancierUnitInput = {
  amount: Scalars['Float'];
  unitId: Scalars['String'];
};

export type ProjectBridgingInput = {
  bridgingFinancierInput: ProjectBridgingFinancierInput;
  unitInput: Array<ProjectBridgingFinancierUnitInput>;
};

export type ProjectCarparkPaymentPlanEntity = {
  __typename?: 'projectCarparkPaymentPlanEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  defaulted: Scalars['Boolean'];
  endDate: Scalars['DateTime'];
  id: Scalars['String'];
  paymentPlanId: Scalars['String'];
  projectId: Scalars['String'];
  purchaserPaymentPlan: PurchaserPaymentPlanEntity;
  startDate: Scalars['DateTime'];
};

export type ProjectClusterEntity = {
  __typename?: 'projectClusterEntity';
  accountId: Scalars['String'];
  desc: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  projectId: Scalars['String'];
  unitExt: Array<UnitExtensionEntity>;
};

export type ProjectCommissionCalculationDetailChild = {
  __typename?: 'ProjectCommissionCalculationDetailChild';
  children: Array<ProjectCommissionCalculationDetailSubChild>;
  commission_amt?: Maybe<Scalars['Float']>;
  commission_type?: Maybe<Scalars['String']>;
  detail_id?: Maybe<Scalars['String']>;
  doc_date?: Maybe<Scalars['DateTime']>;
  doc_no?: Maybe<Scalars['String']>;
  employee_name?: Maybe<Scalars['String']>;
  generate_date?: Maybe<Scalars['DateTime']>;
  net_selling?: Maybe<Scalars['Float']>;
  principal?: Maybe<Scalars['String']>;
  project_commission_calc_id?: Maybe<Scalars['String']>;
  sale_id?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  unit_no?: Maybe<Scalars['String']>;
};

export type ProjectCommissionCalculationDetailOutput = {
  __typename?: 'ProjectCommissionCalculationDetailOutput';
  child_id?: Maybe<Scalars['String']>;
  children: Array<ProjectCommissionCalculationDetailChild>;
  commission_amt?: Maybe<Scalars['Float']>;
  commission_type?: Maybe<Scalars['String']>;
  detail_id?: Maybe<Scalars['String']>;
  doc_date?: Maybe<Scalars['DateTime']>;
  doc_no?: Maybe<Scalars['String']>;
  employee_id?: Maybe<Scalars['String']>;
  employee_name?: Maybe<Scalars['String']>;
  generate_date?: Maybe<Scalars['DateTime']>;
  job_position?: Maybe<Scalars['String']>;
  net_selling?: Maybe<Scalars['Float']>;
  parent_id: Scalars['String'];
  principal?: Maybe<Scalars['String']>;
  project_commission_calc_id?: Maybe<Scalars['String']>;
  sale_id?: Maybe<Scalars['String']>;
  sales_commission?: Maybe<Scalars['Float']>;
  total_commission: Scalars['String'];
  total_net_selling: Scalars['Float'];
  total_selling?: Maybe<Scalars['Float']>;
  type: Scalars['String'];
  unit_no?: Maybe<Scalars['String']>;
};

export type ProjectCommissionCalculationDetailSubChild = {
  __typename?: 'ProjectCommissionCalculationDetailSubChild';
  child_id?: Maybe<Scalars['String']>;
  commission_amt?: Maybe<Scalars['Float']>;
  commission_type?: Maybe<Scalars['String']>;
  detail_id?: Maybe<Scalars['String']>;
  doc_date?: Maybe<Scalars['DateTime']>;
  doc_no?: Maybe<Scalars['String']>;
  net_selling?: Maybe<Scalars['Float']>;
  project_commission_calc_id?: Maybe<Scalars['String']>;
  sale_id?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type ProjectCommissionCalculationOutput = {
  __typename?: 'ProjectCommissionCalculationOutput';
  createdTs: Scalars['DateTime'];
  employeeId: Scalars['String'];
  employeeName?: Maybe<Scalars['String']>;
  generateDate?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  principal?: Maybe<Scalars['String']>;
  projectId: Scalars['String'];
  totalCommission?: Maybe<Scalars['Float']>;
  totalSelling?: Maybe<Scalars['Float']>;
};

export type ProjectCommissionEntity = AuditEntity & {
  __typename?: 'projectCommissionEntity';
  accountId: Scalars['ID'];
  commissionPayments: Array<CommissionPaymentEntity>;
  commissionType: CommissionTypeEntity;
  commissionTypeId: Scalars['ID'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['ID'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  projectId: Scalars['ID'];
  rateClassification: Scalars['String'];
};

export type ProjectCommissionPackageDetailEntity = {
  __typename?: 'projectCommissionPackageDetailEntity';
  accountId: Scalars['ID'];
  commissionPackageTargets: Array<CommissionPackageTargetEntity>;
  commonStatus: Scalars['String'];
  effectiveDate: Scalars['DateTime'];
  id: Scalars['ID'];
  projectCommissionPackage: ProjectCommissionPackageEntity;
  projectCommissionPackageId: Scalars['ID'];
  refId?: Maybe<Scalars['ID']>;
  refTable?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type ProjectCommissionPackageDetailInput = {
  commissionPackageTargets: Array<ProjectCommissionPackageTargetInput>;
  effectiveDate: Scalars['DateTime'];
  id?: InputMaybe<Scalars['String']>;
  projectCommissionPackageId: Scalars['String'];
  rateClassification?: InputMaybe<Scalars['String']>;
  refId?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};

export type ProjectCommissionPackageEntity = {
  __typename?: 'projectCommissionPackageEntity';
  accountId: Scalars['ID'];
  commonStatus: Scalars['String'];
  id: Scalars['ID'];
  principal: Scalars['String'];
  projectCommission: ProjectCommissionEntity;
  projectCommissionId: Scalars['ID'];
  projectCommissionPackageDetails: Array<ProjectCommissionPackageDetailEntity>;
  projectId: Scalars['ID'];
};

export type ProjectCommissionPackageInputDetailEntity = {
  __typename?: 'projectCommissionPackageInputDetailEntity';
  accountId: Scalars['String'];
  commissionAmt: Scalars['Float'];
  commissionDate: Scalars['DateTime'];
  commissionType: Scalars['String'];
  commonStatus: Scalars['String'];
  createdBy: Scalars['String'];
  createdTs: Scalars['DateTime'];
  docDate: Scalars['DateTime'];
  docNo: Scalars['String'];
  id: Scalars['String'];
  modBy: Scalars['String'];
  modTs: Scalars['DateTime'];
  netSelling: Scalars['Float'];
  projectCommisionPackage?: Maybe<ProjectCommissionPackageEntity>;
  projectCommissionCalcId: Scalars['String'];
  projectCommissionPackageId: Scalars['String'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
};

export type ProjectCommissionPackageInputEntity = {
  __typename?: 'projectCommissionPackageInputEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  createdBy: Scalars['String'];
  createdTs: Scalars['DateTime'];
  employeeId: Scalars['String'];
  employeeName: Scalars['String'];
  generateDate: Scalars['DateTime'];
  id: Scalars['String'];
  modBy: Scalars['String'];
  modTs: Scalars['DateTime'];
  principal: Scalars['String'];
  projectId: Scalars['String'];
  totalCommission: Scalars['Float'];
  totalSelling: Scalars['Float'];
};

export type ProjectCommissionPackageListingEntity = {
  __typename?: 'projectCommissionPackageListingEntity';
  accountId: Scalars['ID'];
  commonStatus: Scalars['String'];
  id: Scalars['ID'];
  packageTypes: Array<ProjectCommissionPackageDetailEntity>;
  principal: Scalars['String'];
  projectCommission: ProjectCommissionEntity;
  projectCommissionId: Scalars['ID'];
  projectCommissionPackageDetails: Array<ProjectCommissionPackageDetailEntity>;
  projectId: Scalars['ID'];
};

export type ProjectCommissionPackageTargetDetailInput = {
  dealClosure: Scalars['Float'];
  id: Scalars['String'];
  overriding: Scalars['Float'];
  positionId?: InputMaybe<Scalars['String']>;
  teamPositionId: Scalars['String'];
};

export type ProjectCommissionPackageTargetInput = {
  commissionPackageTargetDetails: Array<ProjectCommissionPackageTargetDetailInput>;
  id: Scalars['String'];
  minimumTarget: Scalars['Float'];
};

export type ProjectCommissionPackageTypes = {
  __typename?: 'projectCommissionPackageTypes';
  id: Scalars['ID'];
  name: Scalars['String'];
  projectCommissionPackageDetails: Array<ProjectCommissionPackageDetailEntity>;
};

export type ProjectCommissionTeamDetailEntity = {
  __typename?: 'projectCommissionTeamDetailEntity';
  accountId: Scalars['ID'];
  agency?: Maybe<AgencyAppointedEntity>;
  agencyAppointedId?: Maybe<Scalars['ID']>;
  children?: Maybe<Array<ProjectCommissionTeamDetailEntity>>;
  commonStatus: Scalars['String'];
  id: Scalars['ID'];
  level?: Maybe<Scalars['Float']>;
  parent?: Maybe<ProjectCommissionTeamDetailEntity>;
  parentId?: Maybe<Scalars['ID']>;
  position?: Maybe<JobPositionEntity>;
  positionId: Scalars['ID'];
  principal: Scalars['String'];
  projectCommissionTeam: ProjectCommissionTeamEntity;
  projectCommissionTeamId: Scalars['ID'];
  projectId: Scalars['ID'];
};

export type ProjectCommissionTeamDetailInput = {
  agencyAppointedId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  level?: InputMaybe<Scalars['Float']>;
  parentId?: InputMaybe<Scalars['ID']>;
  positionId?: InputMaybe<Scalars['ID']>;
  principal: Scalars['String'];
  projectCommissionTeamId: Scalars['String'];
};

export type ProjectCommissionTeamEntity = {
  __typename?: 'projectCommissionTeamEntity';
  accountId: Scalars['ID'];
  commonStatus: Scalars['String'];
  details: Array<ProjectCommissionTeamDetailEntity>;
  generateDate: Scalars['DateTime'];
  id: Scalars['ID'];
  projectId: Scalars['ID'];
};

export type ProjectCommissionTeamHeaderEntity = {
  __typename?: 'projectCommissionTeamHeaderEntity';
  accountId: Scalars['ID'];
  agency?: Maybe<AgencyAppointedEntity>;
  commonStatus: Scalars['String'];
  id: Scalars['ID'];
  jobPosition?: Maybe<JobPositionEntity>;
  principal: Scalars['String'];
  projectId: Scalars['ID'];
  subheaders: Array<ProjectCommissionTeamSubheaderEntity>;
  team: ProjectCommissionTeamEntity;
};

export type ProjectCommissionTeamInput = {
  generateDate: Scalars['DateTime'];
  id?: InputMaybe<Scalars['String']>;
};

export type ProjectCommissionTeamSubheaderEntity = {
  __typename?: 'projectCommissionTeamSubheaderEntity';
  accountId: Scalars['ID'];
  agency?: Maybe<AgencyAppointedEntity>;
  commonStatus: Scalars['String'];
  header: ProjectCommissionTeamHeaderEntity;
  id: Scalars['ID'];
  jobPosition?: Maybe<JobPositionEntity>;
  principal: Scalars['String'];
  projectId: Scalars['ID'];
};

export type ProjectConstructionEntity = {
  __typename?: 'projectConstructionEntity';
  accountId: Scalars['String'];
  architect?: Maybe<Scalars['String']>;
  architectureStructure?: Maybe<Scalars['String']>;
  basePrice?: Maybe<Scalars['Float']>;
  buildingDesigner?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  completionDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  landPermitDate?: Maybe<Scalars['DateTime']>;
  landProprietor?: Maybe<Scalars['String']>;
  numberBlockUnit?: Maybe<Scalars['Float']>;
  planner?: Maybe<Scalars['String']>;
  projectId: Scalars['String'];
  propertyAgent?: Maybe<Scalars['String']>;
  spaDuration?: Maybe<Scalars['Float']>;
  startDate?: Maybe<Scalars['DateTime']>;
  superStructureType?: Maybe<Scalars['String']>;
  taxRegNo?: Maybe<Scalars['String']>;
};

export type ProjectConstructionInput = {
  architect?: InputMaybe<Scalars['String']>;
  architectureStructure?: InputMaybe<Scalars['String']>;
  basePrice?: InputMaybe<Scalars['Float']>;
  buildingDesigner?: InputMaybe<Scalars['String']>;
  completionDate?: InputMaybe<Scalars['DateTime']>;
  landPermitDate?: InputMaybe<Scalars['DateTime']>;
  landProprietor?: InputMaybe<Scalars['String']>;
  numberBlockUnit?: InputMaybe<Scalars['Float']>;
  planner?: InputMaybe<Scalars['String']>;
  propertyAgent?: InputMaybe<Scalars['String']>;
  spaDuration?: InputMaybe<Scalars['Float']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  superStructureType?: InputMaybe<Scalars['String']>;
  taxRegNo?: InputMaybe<Scalars['String']>;
};

export type ProjectDetail = {
  __typename?: 'ProjectDetail';
  name: Scalars['String'];
  projectId: Scalars['String'];
};

export type ProjectDetailOutput = {
  __typename?: 'ProjectDetailOutput';
  bankAccounts?: Maybe<Array<BankAccountOutput>>;
  bankCode?: Maybe<Scalars['String']>;
  bankId?: Maybe<Scalars['String']>;
  bankName?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  completionDate?: Maybe<Scalars['DateTime']>;
  country: Scalars['String'];
  currency: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  developmentCompanyId: Scalars['String'];
  developmentCompanyName: Scalars['String'];
  firstGalleryImage?: Maybe<ProjectResourceOuput>;
  holdingCompanyId: Scalars['String'];
  holdingCompanyName: Scalars['String'];
  id: Scalars['String'];
  landType: Scalars['String'];
  launchDate?: Maybe<Scalars['DateTime']>;
  maxPrice?: Maybe<Scalars['Float']>;
  minPrice?: Maybe<Scalars['Float']>;
  plotNo?: Maybe<Scalars['String']>;
  projectCode: Scalars['String'];
  projectName: Scalars['String'];
  projectType: Scalars['String'];
  projectTypeId: Scalars['String'];
  state: Scalars['String'];
  tenure: Scalars['String'];
  townshipId?: Maybe<Scalars['String']>;
  townshipName?: Maybe<Scalars['String']>;
  uom: Scalars['String'];
};

export type ProjectDiscountEntity = {
  __typename?: 'projectDiscountEntity';
  commonStatus: Scalars['String'];
  defaulted: Scalars['Boolean'];
  discount: DiscountEntity;
  discountId: Scalars['String'];
  effectiveDate: Scalars['DateTime'];
  expired_date: Scalars['DateTime'];
  id: Scalars['String'];
  project: ProjectEntity;
  projectId: Scalars['String'];
};

export type ProjectEmailLetterEntity = AuditEntity & {
  __typename?: 'projectEmailLetterEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  emailLetterTemplate: EmailLetterTemplateEntity;
  emailLetterTemplateId: Scalars['String'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  project: ProjectEntity;
  projectId: Scalars['String'];
  subject: Scalars['String'];
  templateBody: Scalars['String'];
};

export type ProjectEntity = {
  __typename?: 'projectEntity';
  accountId: Scalars['String'];
  activeLoans?: Maybe<ActiveLoanStatusOutput>;
  agencyAppointedCount?: Maybe<AgencyAppointedCount>;
  agencyContract: Array<AgencyContractEntity>;
  agencySalesChartUnitDisplay?: Maybe<Array<AgencySalesChartOutput>>;
  allocations: Array<AllocationEntity>;
  amenities?: Maybe<Array<Amenities>>;
  architectCertLastUpdate?: Maybe<Scalars['DateTime']>;
  attachment?: Maybe<Array<AttachmentEntity>>;
  blockGalleryImage?: Maybe<Array<ProjectBlockMediaOuput>>;
  bookingWaitlists: Array<BookingWaitlistEntity>;
  builtup?: Maybe<Array<Scalars['Float']>>;
  city?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  company?: Maybe<CompanyEntity>;
  completionDate?: Maybe<Scalars['DateTime']>;
  countBook?: Maybe<BookStatusOutput>;
  countBookConfirmation?: Maybe<BookingConfirmationStatusOutput>;
  countLoan?: Maybe<LoanStatusOutput>;
  country: Scalars['String'];
  countUnassignedLeads: Scalars['Float'];
  countUnitAvailable: Scalars['Float'];
  countUnitReserved: Scalars['Float'];
  countUnitSigned: Scalars['Float'];
  countUnitTotal: Scalars['Float'];
  countWaitlistTotal: CountWaitingUnitOutput;
  currency: Scalars['String'];
  desc?: Maybe<Scalars['String']>;
  developmentCompany: CompanyEntity;
  developmentCompanyId: Scalars['String'];
  discountLastUpdate?: Maybe<Scalars['DateTime']>;
  discounts: Array<ProjectDiscountEntity>;
  distinctBlock: Array<Scalars['String']>;
  distinctBlockFloor?: Maybe<Array<ProjectUnitBlockFloorOuput>>;
  efPanelLastUpdate?: Maybe<Scalars['DateTime']>;
  embededGoogleDriveLink?: Maybe<Array<ProjectYoutubeLinkOutput>>;
  embededVimeoLink?: Maybe<Array<ProjectYoutubeLinkOutput>>;
  embededYoutubeLink?: Maybe<Array<ProjectYoutubeLinkOutput>>;
  endfinProjectFinanciers: Array<EndfinProjectFinancierEntity>;
  existingPurchaser?: Maybe<Scalars['Float']>;
  firstGalleryImage?: Maybe<ProjectResourceOuput>;
  floorGalleryImage?: Maybe<Array<ProjectFloorMediaOuput>>;
  galleryImage?: Maybe<Array<ProjectGalleryMediaOuput>>;
  galleryLastUpdate?: Maybe<Scalars['DateTime']>;
  getCSRRewardLetterCountByProject?: Maybe<Scalars['Float']>;
  getDownpayment1CountByProject?: Maybe<Scalars['Float']>;
  getDownpayment2CountByProject?: Maybe<Scalars['Float']>;
  getLetterOfOfferLetterCountByProject?: Maybe<Scalars['Float']>;
  getPDPALetterCountByProject?: Maybe<Scalars['Float']>;
  getPromotionLetterCountByProject?: Maybe<Scalars['Float']>;
  getReservationFormCountByProject?: Maybe<Scalars['Float']>;
  getSalesGalleryLetterCountByProject?: Maybe<Scalars['Float']>;
  getWarrantyLetterCountByProject?: Maybe<Scalars['Float']>;
  holdingCompany: CompanyEntity;
  holdingCompanyId: Scalars['String'];
  id: Scalars['String'];
  integrationDiscount: Array<IntegrationDiscountEntity>;
  interests: Array<InterestEntity>;
  isIntegrated: Scalars['Boolean'];
  isManager: Scalars['Boolean'];
  isSaleMade: Scalars['Boolean'];
  IsSubscribed: Scalars['JSONObject'];
  landType: Scalars['String'];
  landTypeDesc: Scalars['String'];
  latePaymentInterestLastUpdate?: Maybe<Scalars['DateTime']>;
  launchDate?: Maybe<Scalars['DateTime']>;
  layoutImagesLastUpdate?: Maybe<Scalars['DateTime']>;
  leadActivitiesFromProject: Array<LeadActivityEntity>;
  leadActivitiesProject: Array<LeadActivityEntity>;
  leads: Array<LeadEntity>;
  leadStatusCount?: Maybe<LeadStatusCountOutput>;
  ledgers: Array<LedgerEntity>;
  loanScreens: Array<LoanScreenEntity>;
  loanStatusList: Array<EndfinLoanAppStatusEntity>;
  maxPrice?: Maybe<Scalars['Float']>;
  minPrice?: Maybe<Scalars['Float']>;
  miscBillingLastUpdate?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  packages: Array<PackageEntity>;
  pictureBlocks: Array<PictureBlockEntity>;
  pictureBlockUrl?: Maybe<Scalars['String']>;
  pictureFloors: Array<PictureFloorEntity>;
  pictureGalleries: Array<PictureGalleryEntity>;
  pictureUnitLayouts: Array<PictureUnitlayoutEntity>;
  policySettingLastUpdate?: Maybe<Scalars['DateTime']>;
  priceRange?: Maybe<Scalars['String']>;
  progressBillingLastUpdate?: Maybe<Scalars['DateTime']>;
  projectAddress?: Maybe<Scalars['String']>;
  projectBankIndos: Array<ProjectBankIndoEntity>;
  projectBrochureLastUpdate?: Maybe<Scalars['DateTime']>;
  projectCode: Scalars['String'];
  projectDetailsUnit?: Maybe<Array<UnitEntity>>;
  projectEmailLetter: Array<ProjectEmailLetterEntity>;
  projectExt?: Maybe<ProjectExtEntity>;
  projectGps?: Maybe<Scalars['String']>;
  projectIntegration: ProjectIntegrationEntity;
  projectLastUpdate?: Maybe<Scalars['DateTime']>;
  projectLetter: Array<ProjectLetterEntity>;
  projectSpec: Array<ProjectSpecEntity>;
  projectSpecs: ProjectSpecEntity;
  projectType: ProjectTypeEntity;
  redemptionTotalSum?: Maybe<Scalars['Float']>;
  reminders: Array<ReminderEntity>;
  resourcefloor?: Maybe<Array<ResourceEntity>>;
  resourceunitlayout?: Maybe<Array<ResourceEntity>>;
  roleAuthorizationLastUpdate?: Maybe<Scalars['DateTime']>;
  saleGalleryAddress?: Maybe<Scalars['String']>;
  saleGalleryGps?: Maybe<Scalars['String']>;
  saleLoan: SaleLoanEntity;
  sales: Array<SaleEntity>;
  saleschartBlock: Array<Scalars['String']>;
  salesChartLastUpdate?: Maybe<Scalars['DateTime']>;
  salesCharts: Array<SalesChartEntity>;
  salesDoc: Array<SalesDocEntity>;
  salesDocLastUpdate?: Maybe<Scalars['DateTime']>;
  salesPackageLastUpdate?: Maybe<Scalars['DateTime']>;
  saleTeamAllocation: Array<SaleTeamAllocationEntity>;
  schedules: Array<ScheduleEntity>;
  siteProgressLastUpdate?: Maybe<Scalars['DateTime']>;
  solicitorCount?: Maybe<SolicitorStatusCount>;
  solicitorLastUpdate?: Maybe<Scalars['DateTime']>;
  solicitorLayoutList?: Maybe<Array<SolicitorLayoutList>>;
  standardLetterLastUpdate?: Maybe<Scalars['DateTime']>;
  state?: Maybe<Scalars['String']>;
  teamAssignmentLastUpdate?: Maybe<Scalars['DateTime']>;
  tenure: Scalars['String'];
  tenureDesc: Scalars['String'];
  totalLoanCount?: Maybe<Scalars['Float']>;
  totalReminderEmailTemplate?: Maybe<Scalars['Float']>;
  totalReminderLetterTemplate?: Maybe<Scalars['Float']>;
  townshipName?: Maybe<Scalars['String']>;
  unitAllocationLastUpdate?: Maybe<Scalars['DateTime']>;
  unitCountByBlock: Array<BlockCountByStatusOutput>;
  unitCountByStatus?: Maybe<ProjectUnitStatusCount>;
  unitCountByUnitType: Array<UnitTypeCountByStatusOutput>;
  unitLayoutGalleryImage?: Maybe<Array<ProjectUnitLayoutMediaOuput>>;
  unitLayouts: Array<UnitLayoutEntity>;
  unitMaxBuiltUp?: Maybe<Scalars['String']>;
  unitMaxPrice?: Maybe<Scalars['String']>;
  unitMinBuiltUp?: Maybe<Scalars['String']>;
  unitMinPrice?: Maybe<Scalars['String']>;
  units: Array<UnitEntity>;
  unitSetupLastUpdate?: Maybe<Scalars['DateTime']>;
  unitTourVirtual?: Maybe<Array<UnitTourVirtualOutput>>;
  unitTypes?: Maybe<Array<UnitTypeOutput>>;
  uom: Scalars['String'];
  uomDesc: Scalars['String'];
  videoLink?: Maybe<Array<MediaSource>>;
  virtualModel?: Maybe<Array<ProjectResourceOuput>>;
  virtualModelLink?: Maybe<Array<MediaSource>>;
  vpDate?: Maybe<Scalars['DateTime']>;
  withdrawnLoans?: Maybe<WithdrawnLoanStatusOutput>;
};


export type ProjectEntityAgencySalesChartUnitDisplayArgs = {
  agencyId: Scalars['String'];
  block: Scalars['String'];
};


export type ProjectEntityPictureBlockUrlArgs = {
  block: Scalars['String'];
};


export type ProjectEntitySolicitorLayoutListArgs = {
  solicitorAppointedId?: InputMaybe<Scalars['String']>;
};

export type ProjectExtEntity = {
  __typename?: 'projectExtEntity';
  accountId: Scalars['String'];
  bankAccountId?: Maybe<Scalars['String']>;
  bankProfileId: Scalars['String'];
  commonStatus: Scalars['String'];
  companyBankAccount?: Maybe<CompanyBankAccountEntity>;
  companyBankProfile?: Maybe<CompanyBankProfileEntity>;
  id: Scalars['String'];
  plotNo?: Maybe<Scalars['String']>;
  project: ProjectEntity;
  projectId: Scalars['String'];
  township?: Maybe<TownshipEntity>;
  townshipId?: Maybe<Scalars['String']>;
};

export type ProjectFireInsuranceEntity = {
  __typename?: 'projectFireInsuranceEntity';
  accountId: Scalars['String'];
  certificateNo?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  companyAddress?: Maybe<AddressJson>;
  companyName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  projectId: Scalars['String'];
};

export type ProjectFireInsuranceInput = {
  certificateNo?: InputMaybe<Scalars['String']>;
  companyAddress?: InputMaybe<AddressJsonInput>;
  companyName?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
};

export type ProjectFloorMediaOuput = {
  __typename?: 'ProjectFloorMediaOuput';
  block: Scalars['String'];
  caption?: Maybe<Scalars['String']>;
  floor: Scalars['Float'];
  floorlabel?: Maybe<Scalars['String']>;
  pictureid: Scalars['String'];
  resourceid?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type ProjectGalleryMediaOuput = {
  __typename?: 'ProjectGalleryMediaOuput';
  caption?: Maybe<Scalars['String']>;
  pictureid: Scalars['String'];
  resourceid?: Maybe<Scalars['String']>;
  seqno?: Maybe<Scalars['Float']>;
  url?: Maybe<Scalars['String']>;
};

export type ProjectGalleryOutput = {
  __typename?: 'ProjectGalleryOutput';
  caption?: Maybe<Scalars['String']>;
  pictureid: Scalars['String'];
  resourceid: Scalars['String'];
  seqno: Scalars['Float'];
  url: Scalars['String'];
};

export type ProjectIntegrationEntity = {
  __typename?: 'projectIntegrationEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  gracePeriod?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  ifcaCompanyId?: Maybe<Scalars['String']>;
  ifcaCompanyName?: Maybe<Scalars['String']>;
  ifcaPhaseId?: Maybe<Scalars['String']>;
  ifcaPhaseName?: Maybe<Scalars['String']>;
  ifcaProjectId?: Maybe<Scalars['String']>;
  ifcaProjectName?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  integrationUrl?: Maybe<Scalars['String']>;
  isDiscountIntegrated: Scalars['Boolean'];
  isPackagesIntegrated: Scalars['Boolean'];
  isRebateIntegrated: Scalars['Boolean'];
  isSolicitorIntegrated: Scalars['Boolean'];
  paymentPlanCode?: Maybe<Scalars['String']>;
  paymentPlanDesc?: Maybe<Scalars['String']>;
  paymentPlanId?: Maybe<Scalars['String']>;
  projectId: Scalars['String'];
};

export type ProjectInvolvementLevel = {
  __typename?: 'ProjectInvolvementLevel';
  level?: Maybe<Scalars['String']>;
  project?: Maybe<ProjectEntity>;
};

export type ProjectKeyCollectionContractorEntity = {
  __typename?: 'projectKeyCollectionContractorEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  contactNo: Scalars['String'];
  contractorType: Scalars['String'];
  email: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  projectId: Scalars['String'];
};

export type ProjectKeyCollectionContractorInput = {
  contactNo: Scalars['String'];
  contractorType: Scalars['String'];
  email: Scalars['String'];
  name: Scalars['String'];
  projectId: Scalars['String'];
};

export type ProjectKeyCollectionInput = {
  endDate: Scalars['DateTime'];
  endTime: Scalars['DateTime'];
  interval: Scalars['Float'];
  startDate: Scalars['DateTime'];
  startTime: Scalars['DateTime'];
  teamMember: Array<Scalars['String']>;
};

export type ProjectKeyCollectionScheduleEntity = {
  __typename?: 'projectKeyCollectionScheduleEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  endDate: Scalars['DateTime'];
  endTime: Scalars['String'];
  id: Scalars['String'];
  interval: Scalars['Float'];
  isDeletable: Scalars['Boolean'];
  projectId: Scalars['String'];
  startDate: Scalars['DateTime'];
  startTime: Scalars['String'];
  teamMember: TeamMemberObject;
  timeslot: Array<ProjectKeyCollectionTimeSlotEntity>;
};

export type ProjectKeyCollectionSettingOutput = {
  __typename?: 'projectKeyCollectionSettingOutput';
  scheduleTime: Scalars['String'];
  timeSlotDetail: Array<TimeSlotDetail>;
};

export type ProjectKeyCollectionTimeSlotEntity = {
  __typename?: 'projectKeyCollectionTimeSlotEntity';
  accountId: Scalars['String'];
  appointment?: Maybe<KeyCollectionAppointmentEntity>;
  collectionScheduleId: Scalars['String'];
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  keyCollectionSchedule?: Maybe<ProjectKeyCollectionScheduleEntity>;
  projectId: Scalars['String'];
  scheduleDate: Scalars['DateTime'];
  scheduleTime: Scalars['String'];
  userId: Scalars['String'];
};

export type ProjectKeySummaryOutput = {
  __typename?: 'projectKeySummaryOutput';
  dateList: Array<Scalars['DateTime']>;
  endDate: Scalars['DateTime'];
  endTime: Scalars['String'];
  startDate: Scalars['DateTime'];
  startTime: Scalars['String'];
  teamMember: Array<UserList>;
};

export type ProjectLadEntity = {
  __typename?: 'projectLadEntity';
  accountId: Scalars['String'];
  commonFacility: Scalars['Boolean'];
  commonStatus: Scalars['String'];
  facilityLadDuration?: Maybe<Scalars['Float']>;
  facilityLadPercent?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  payoutPercent: Scalars['Float'];
  projectId: Scalars['String'];
  spaPercent?: Maybe<Scalars['Float']>;
  startWith: Scalars['String'];
  taxSchemeId: Scalars['String'];
  unitDuration: Scalars['Float'];
  unitLadPercent: Scalars['Float'];
};

export type ProjectLadInput = {
  commonFacility: Scalars['Boolean'];
  facilityLadDuration?: InputMaybe<Scalars['Float']>;
  facilityLadPercent?: InputMaybe<Scalars['Float']>;
  payoutPercent: Scalars['Float'];
  spaPercent?: InputMaybe<Scalars['Float']>;
  startWith: Scalars['String'];
  taxSchemeId: Scalars['String'];
  unitDuration: Scalars['Float'];
  unitLadPercent: Scalars['Float'];
};

export type ProjectLastActiveTransactionsEntity = {
  __typename?: 'projectLastActiveTransactionsEntity';
  booked: Scalars['Float'];
  cancelled: Scalars['Float'];
  project_id: Scalars['String'];
  signed: Scalars['Float'];
  total: Scalars['Float'];
  transaction_date: Scalars['DateTime'];
};

export type ProjectLateInterestEntity = {
  __typename?: 'projectLateInterestEntity';
  accountId: Scalars['String'];
  enableFloatingInterest: Scalars['Boolean'];
  excludeHoliday: Scalars['Boolean'];
  excludePaymentDate: Scalars['Boolean'];
  id: Scalars['String'];
  loanGracePeriod: Scalars['Float'];
  loanGracePeriodStartWith: Scalars['String'];
  minimumInterestAmount: Scalars['Float'];
  projectId: Scalars['String'];
  taxSchemeId?: Maybe<Scalars['String']>;
};

export enum ProjectLateInterestEnum {
  BookDate = 'BOOK_DATE',
  SpaDate = 'SPA_DATE',
  StampDate = 'STAMP_DATE'
}

export type ProjectLateInterestExceptionEntity = {
  __typename?: 'projectLateInterestExceptionEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  projectId: Scalars['String'];
  remark: Scalars['String'];
  saleId: Scalars['String'];
  sales?: Maybe<SaleEntity>;
};

export type ProjectLetterEntity = {
  __typename?: 'projectLetterEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  defaulted: Scalars['Boolean'];
  id: Scalars['String'];
  letterTemplate: LetterTemplateEntity;
  project: ProjectEntity;
};

export type ProjectLetterTemplateEntity = {
  __typename?: 'projectLetterTemplateEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  defaulted: Scalars['Boolean'];
  id: Scalars['String'];
  isReportDesignEditor: Scalars['Boolean'];
  jointBuyerSignRequired: Scalars['Boolean'];
  name: Scalars['String'];
  projectId: Scalars['String'];
  slDataSource?: Maybe<StandardLetterDataSourceEntity>;
  standardLetter: StandardLetterEntity;
  standardLetterDataSourceVersion?: Maybe<Scalars['Float']>;
  standardLetterId: Scalars['String'];
  templateBody?: Maybe<Scalars['String']>;
};

export type ProjectLetterTemplateOutput = {
  __typename?: 'projectLetterTemplateOutput';
  letterName: Scalars['String'];
  stdLtrId: Scalars['String'];
  templateId: Scalars['String'];
  templateName: Scalars['String'];
};

export type ProjectMiscChargesEntity = {
  __typename?: 'projectMiscChargesEntity';
  accountId: Scalars['String'];
  billItemId: Scalars['String'];
  billItemName: Scalars['String'];
  commonStatus: Scalars['String'];
  formula: Scalars['String'];
  id: Scalars['String'];
  interestRate: Scalars['Float'];
  isDeletable: Scalars['Boolean'];
  projectId: Scalars['String'];
  remark?: Maybe<Scalars['String']>;
  taxSchemeId: Scalars['String'];
};

export type ProjectPackagePaymentPlanEntity = {
  __typename?: 'projectPackagePaymentPlanEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  defaulted: Scalars['Boolean'];
  endDate: Scalars['DateTime'];
  id: Scalars['String'];
  paymentPlanId: Scalars['String'];
  projectId: Scalars['String'];
  purchaserPaymentPlan: PurchaserPaymentPlanEntity;
  startDate: Scalars['DateTime'];
};

export type ProjectPaymentPlanEntity = {
  __typename?: 'projectPaymentPlanEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  defaulted: Scalars['Boolean'];
  endDate: Scalars['DateTime'];
  id: Scalars['String'];
  isDeletable: Scalars['Boolean'];
  paymentPlan: PaymentPlanEntity;
  paymentPlanId: Scalars['String'];
  projectId: Scalars['String'];
  purchaserPaymentPlan: PurchaserPaymentPlanEntity;
  startDate: Scalars['DateTime'];
};

export type ProjectPaymentReminderExceptionEntity = AuditEntity & {
  __typename?: 'projectPaymentReminderExceptionEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  maxReminder?: Maybe<Scalars['Float']>;
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
};

export type ProjectPaymentReminderExceptionInput = {
  maxReminder: Scalars['Float'];
  saleId: Scalars['String'];
};

export type ProjectPermitEntity = {
  __typename?: 'projectPermitEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  expiryDate: Scalars['DateTime'];
  id: Scalars['String'];
  issueDate: Scalars['DateTime'];
  permitNo: Scalars['String'];
  permitType: Scalars['String'];
  projectId: Scalars['String'];
};

export type ProjectPolicyEntity = {
  __typename?: 'projectPolicyEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  creditTerms: Scalars['Float'];
  id: Scalars['String'];
  interestRate: Scalars['Float'];
  projectId: Scalars['String'];
  roundingMode: Scalars['String'];
  roundingPrecision: Scalars['String'];
  unitSort?: Maybe<Scalars['String']>;
};

export type ProjectPolicyInput = {
  creditTerms: Scalars['Float'];
  id?: InputMaybe<Scalars['String']>;
  interestRate: Scalars['Float'];
  projectId: Scalars['String'];
  roundingMode: RoundingMode;
  roundingPrecision: RoundingPrecision;
  unitSort: Scalars['String'];
};

export type ProjectReminderEntity = AuditEntity & {
  __typename?: 'projectReminderEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  downpaymentReminder1?: Maybe<Scalars['Float']>;
  downpaymentReminder2?: Maybe<Scalars['Float']>;
  downpaymentReminder3?: Maybe<Scalars['Float']>;
  downpaymentReminder4?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  minimumAmount?: Maybe<Scalars['Float']>;
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  paymentReminder1: Scalars['Float'];
  paymentReminder2: Scalars['Float'];
  paymentReminder3: Scalars['Float'];
  paymentReminder4: Scalars['Float'];
  paymentReminderScheduler: Scalars['Boolean'];
  paymentReminderSchedulerTime: Scalars['String'];
  projectId: Scalars['String'];
  reminderFor?: Maybe<Scalars['String']>;
  spaReminder1?: Maybe<Scalars['Float']>;
  spaReminder2?: Maybe<Scalars['Float']>;
  spaReminder3?: Maybe<Scalars['Float']>;
  spaReminder4?: Maybe<Scalars['Float']>;
};

export type ProjectResourceOuput = {
  __typename?: 'ProjectResourceOuput';
  caption?: Maybe<Scalars['String']>;
  resourceid?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type ProjectRoleInput = {
  assignment: Array<ProjectRoleUserAssignmentInput>;
  projectId: Scalars['String'];
};

export type ProjectRoleUserAssignmentInput = {
  roleId: Scalars['String'];
  userId: Scalars['String'];
};

export type ProjectRoleUserListingOutput = {
  __typename?: 'projectRoleUserListingOutput';
  ID: Scalars['String'];
  name: Scalars['String'];
  roleIds?: Maybe<Scalars['String']>;
};

export type ProjectSaleListOuput = {
  __typename?: 'ProjectSaleListOuput';
  booking_amount?: Maybe<Scalars['Float']>;
  contact_id: Scalars['String'];
  date: Scalars['DateTime'];
  full_name: Scalars['String'];
  project_id: Scalars['String'];
  sale_id: Scalars['String'];
  sales_status: Scalars['String'];
  salesPerson?: Maybe<UserEntity>;
  unit_id: Scalars['String'];
  unit_no: Scalars['String'];
  unit_price: Scalars['String'];
};

export type ProjectSalesOfficeEntity = {
  __typename?: 'ProjectSalesOfficeEntity';
  accountId: Scalars['String'];
  architecturePermit?: Maybe<Scalars['String']>;
  areaUOM1?: Maybe<Scalars['String']>;
  areaUOM2?: Maybe<Scalars['String']>;
  areaUOM3?: Maybe<Scalars['String']>;
  areaUOMConversion1?: Maybe<Scalars['String']>;
  areaUOMConversion2?: Maybe<Scalars['String']>;
  buildingContractorAwarded?: Maybe<Scalars['String']>;
  buildingContractorName?: Maybe<Scalars['String']>;
  builtUpArea?: Maybe<Scalars['Float']>;
  commonArea?: Maybe<Scalars['Float']>;
  commonAreaPercent?: Maybe<Scalars['Float']>;
  commonStatus: Scalars['String'];
  constructionPermit?: Maybe<Scalars['String']>;
  creditControlEmail?: Maybe<Scalars['String']>;
  creditControlHOD?: Maybe<Scalars['String']>;
  creditControlOfficeTel?: Maybe<Scalars['String']>;
  customerCareContactNo?: Maybe<Scalars['String']>;
  customerCareEmail?: Maybe<Scalars['String']>;
  customerCareHOD?: Maybe<Scalars['String']>;
  customerCareLocalAuthorityAddress?: Maybe<AddressJson>;
  customerCareLocalAuthorityContactNo?: Maybe<Scalars['String']>;
  customerCareLocalAuthorityName?: Maybe<Scalars['String']>;
  densityPercentage?: Maybe<Scalars['Float']>;
  DLPTerm1?: Maybe<Scalars['String']>;
  DLPTerm2?: Maybe<Scalars['String']>;
  floorArea?: Maybe<Scalars['Float']>;
  floorAreaPercent?: Maybe<Scalars['Float']>;
  generalManager?: Maybe<Scalars['String']>;
  greenspaceArea?: Maybe<Scalars['Float']>;
  greenspaceAreaPercent?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  landArea?: Maybe<Scalars['Float']>;
  projectId: Scalars['String'];
  projectManager?: Maybe<Scalars['String']>;
  propertyManager?: Maybe<Scalars['String']>;
  salesLocalAuthorityAddress?: Maybe<AddressJson>;
  salesLocalAuthorityContactNo?: Maybe<Scalars['String']>;
  salesLocalAuthorityName?: Maybe<Scalars['String']>;
  salesMarketingHOD?: Maybe<Scalars['String']>;
  salesOfficeAddress?: Maybe<Scalars['String']>;
  salesOfficeFax?: Maybe<Scalars['String']>;
  salesOfficeTel?: Maybe<Scalars['String']>;
  salesPermit?: Maybe<Scalars['String']>;
  usagePurpose?: Maybe<Scalars['String']>;
  usageRatioPercent?: Maybe<Scalars['Float']>;
  warrantyPeriod?: Maybe<Scalars['Float']>;
};

export type ProjectSalesPolicyDetailsEntity = {
  __typename?: 'projectSalesPolicyDetailsEntity';
  accountId: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  depositAmount?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  landAreaFrom?: Maybe<Scalars['Float']>;
  landAreaTo?: Maybe<Scalars['Float']>;
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  projectSalesPolicy: ProjectSalesPolicyEntity;
  projectSalesPolicyId: Scalars['String'];
  recordStatus: Scalars['String'];
};

export type ProjectSalesPolicyEntity = {
  __typename?: 'projectSalesPolicyEntity';
  accountId: Scalars['String'];
  collectLandDeposit: Scalars['Boolean'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  generateOverdueDebtorEvery: OverduePurchaserDay;
  generateOverdueDebtorTime: Scalars['String'];
  id: Scalars['String'];
  interestBasicRate: InterestBasicRate;
  interestRate: Scalars['Float'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  npvBasicRate?: Maybe<NpvBasicRate>;
  npvRate?: Maybe<Scalars['Float']>;
  policyDetails: Array<ProjectSalesPolicyDetailsEntity>;
  projectId: Scalars['String'];
  recordStatus: Scalars['String'];
  roundingMode: RoundingModeInt;
  roundingPrecision: RoundingPrecisionInt;
  taxSchemeId: Scalars['String'];
  ujpDepositAmount: Scalars['Float'];
  ujpMinimumDepositAmount: Scalars['Float'];
};

export type ProjectSalesPolicyEnum = {
  __typename?: 'ProjectSalesPolicyEnum';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type ProjectSalesPolicyEnumsOutput = {
  __typename?: 'ProjectSalesPolicyEnumsOutput';
  interestBasicRate: Array<ProjectSalesPolicyEnum>;
  npvBasicRate: Array<ProjectSalesPolicyEnum>;
  overdueDay: Array<ProjectSalesPolicyEnum>;
  roundingMode: Array<ProjectSalesPolicyEnum>;
  roundingPrecision: Array<ProjectSalesPolicyEnum>;
};

export type ProjectSalesPolicyOutput = {
  __typename?: 'projectSalesPolicyOutput';
  collectLandDeposit: Scalars['Boolean'];
  generateOverdueDebtorEvery?: Maybe<Scalars['String']>;
  generateOverdueDebtorTime?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  interestBasicRate: Scalars['String'];
  interestRate: Scalars['Float'];
  npvBasicRate?: Maybe<Scalars['String']>;
  npvRate?: Maybe<Scalars['Float']>;
  projectSalesPolicy?: Maybe<Array<Ujpp>>;
  roundingMode: Scalars['String'];
  roundingPrecision: Scalars['String'];
  taxSchemeId?: Maybe<Scalars['String']>;
  ujpDepositAmount?: Maybe<Scalars['Float']>;
  ujpMinimumDepositAmount?: Maybe<Scalars['Float']>;
};

export type ProjectSpecEntity = {
  __typename?: 'projectSpecEntity';
  accountId: Scalars['String'];
  agencyLeadNotification?: Maybe<AgencyLeadNotificationOutput>;
  alertAgingActivated: Scalars['Boolean'];
  assignEndTime?: Maybe<Scalars['String']>;
  assignStartTime?: Maybe<Scalars['String']>;
  autoAssignLeadActivated: Scalars['Boolean'];
  autoReassignLeadActivated: Scalars['Boolean'];
  autoReassignLeadDuration?: Maybe<Scalars['Float']>;
  autoReleaseNotificationReminder?: Maybe<AutoReleaseNotificationReminderOutput>;
  autoReleaseReservationDay: Scalars['Float'];
  bookingfeeAmountRequired: Scalars['Boolean'];
  bookingFeeMandatory: Scalars['Boolean'];
  bookingFormLang: Scalars['String'];
  bookingPDPAconsentRequired: Scalars['Boolean'];
  bookingRefundPolicyconsentRequired: Scalars['Boolean'];
  bookingSignRequired: Scalars['Boolean'];
  ccrAttachmentRequired: Scalars['Boolean'];
  creditTerm?: Maybe<Scalars['Float']>;
  display2DChart: Scalars['Boolean'];
  ELetteringSMSRequired: Scalars['Boolean'];
  expectedSnpDuration?: Maybe<Scalars['Float']>;
  expectedSnpRequired: Scalars['Boolean'];
  formLang?: Maybe<Scalars['String']>;
  getAccountSpec?: Maybe<AccountSpecEntity>;
  getSoftwareCode?: Maybe<Array<Scalars['JSONObject']>>;
  gracePeriod?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  ifcaReceiptDesc: Scalars['String'];
  isIfcaReceiptDefaultDesc: Scalars['Boolean'];
  isReservationEnable?: Maybe<Scalars['Boolean']>;
  lateInterestRate?: Maybe<Scalars['Float']>;
  leadAgingActivated: Scalars['Boolean'];
  leadAgingManagerHandled?: Maybe<Array<Scalars['String']>>;
  leadAgingManagerNames?: Maybe<Array<ProjectSpecManagerOutput>>;
  leadAgingNotificationMethod?: Maybe<Array<Scalars['String']>>;
  leadAssignNotificationActivated: Scalars['Boolean'];
  leadAssignNotificationMethod?: Maybe<Array<Scalars['String']>>;
  leadEmailRequired: Scalars['Boolean'];
  leadIdleOne?: Maybe<Scalars['Float']>;
  leadIdleThree?: Maybe<Scalars['Float']>;
  leadIdleTwo?: Maybe<Scalars['Float']>;
  loanAlertAging?: Maybe<LoanAlertAgingOutput>;
  loanconsentRequired: Scalars['Boolean'];
  loanLeadNotification?: Maybe<LoanLeadNotificationOutput>;
  loanScreening: Scalars['Boolean'];
  minAge?: Maybe<Scalars['Float']>;
  minAgeRequired: Scalars['Boolean'];
  minBookingfeeAmount: Scalars['Float'];
  notifyUnattendedLeadActivated: Scalars['Boolean'];
  notifyUnattendedLeadDuration?: Maybe<Scalars['Float']>;
  nricAttachmentRequired: Scalars['Boolean'];
  paymentGateway?: Maybe<PaymentGatewayEntity>;
  paymentGatewayId?: Maybe<Scalars['String']>;
  paymentGatewayRefundPolicy?: Maybe<Scalars['String']>;
  project: ProjectEntity;
  projectId: Scalars['String'];
  purchaserAppSetting: Scalars['String'];
  purchaserAppSettings: Scalars['String'];
  purchaserAppSubmenu?: Maybe<PurchaserAppSubmenuOutput>;
  purchaserLeadNotification?: Maybe<PurchaserLeadNotificationOutput>;
  reassignEndTime?: Maybe<Scalars['String']>;
  reassignStartTime?: Maybe<Scalars['String']>;
  reminder_1Duration?: Maybe<Scalars['Float']>;
  reminder_2Duration?: Maybe<Scalars['Float']>;
  reminder_3Duration?: Maybe<Scalars['Float']>;
  reminder_4Duration?: Maybe<Scalars['Float']>;
  reservationAgency: Scalars['Boolean'];
  reservationSales: Scalars['Boolean'];
  saleLeadNotification?: Maybe<SaleLeadNotificationOutput>;
  salesAlertAging?: Maybe<SalesAlertAgingOutput>;
  SoftwareCode: Scalars['JSONObject'];
  solicitorAlertAging?: Maybe<SolicitorAlertAgingOutput>;
  solicitorLeadNotification?: Maybe<SolicitorLeadNotificationOutput>;
  statementRefundPolicy?: Maybe<Scalars['String']>;
  templateAddressShow: Scalars['Boolean'];
  templateCompanyShow?: Maybe<Scalars['String']>;
  templateDiscountsShow: Scalars['Boolean'];
  templateMaritalStatusShow: Scalars['Boolean'];
  templatePackagesShow: Scalars['Boolean'];
  templateRemarksShow: Scalars['Boolean'];
  trGeneration: Scalars['Boolean'];
  unattendedLeadManagerHandled?: Maybe<Array<Scalars['String']>>;
  unattendedLeadManagerNames?: Maybe<Array<ProjectSpecManagerOutput>>;
  unattendedLeadNotificationMethod?: Maybe<Array<Scalars['String']>>;
  unitLockAgency: Scalars['Boolean'];
  unitLockBufferDuration: Scalars['Float'];
  unitLockDuration: Scalars['Float'];
  unitLockSales: Scalars['Boolean'];
  unitSort: Scalars['String'];
};

export type ProjectSpecManagerOutput = {
  __typename?: 'ProjectSpecManagerOutput';
  name: Scalars['String'];
};

export type ProjectTitleBlockListingOutput = {
  __typename?: 'projectTitleBlockListingOutput';
  block: Scalars['String'];
  floorList?: Maybe<Array<ProjectTitleFloorListingOutput>>;
  totalFloor: Scalars['Float'];
};

export type ProjectTitleEntity = AuditEntity & {
  __typename?: 'projectTitleEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  expiryDate: Scalars['DateTime'];
  id: Scalars['String'];
  issueDate: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  projectId: Scalars['String'];
  projectTitleUnits: Array<ProjectTitleUnitEntity>;
  receiveDate: Scalars['DateTime'];
  remark?: Maybe<Scalars['String']>;
  titleNo: Scalars['String'];
  titleType: Scalars['String'];
  unitIndex?: Maybe<Scalars['String']>;
};

export type ProjectTitleFloorListingOutput = {
  __typename?: 'projectTitleFloorListingOutput';
  floor?: Maybe<Scalars['Float']>;
  floorLabel?: Maybe<Scalars['String']>;
  totalUnit?: Maybe<Scalars['Float']>;
  unitList?: Maybe<Array<ProjectTitleUnitListingOutput>>;
};

export enum ProjectTitleType {
  Block = 'BLOCK',
  DescriptionList = 'DescriptionList',
  Final = 'FINAL',
  GetDescription = 'GetDescription',
  Individual = 'INDIVIDUAL',
  Master = 'MASTER',
  Strata = 'STRATA'
}

export type ProjectTitleUnitEntity = {
  __typename?: 'projectTitleUnitEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  projectId: Scalars['String'];
  projectTitle: ProjectTitleEntity;
  projectTitleId: Scalars['String'];
  unitId: Scalars['String'];
  units: UnitEntity;
};

export type ProjectTitleUnitListingOutput = {
  __typename?: 'projectTitleUnitListingOutput';
  unitId?: Maybe<Scalars['String']>;
  unitNo?: Maybe<Scalars['String']>;
};

export type ProjectTypeEntity = {
  __typename?: 'projectTypeEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  defaulted: Scalars['Boolean'];
  id: Scalars['String'];
  isDeletable: Scalars['Boolean'];
  isExistInMasterData: Array<Scalars['String']>;
  isExistInTransactionData: Array<Scalars['String']>;
  name: Scalars['String'];
  projects: Array<ProjectEntity>;
  seq_no?: Maybe<Scalars['Float']>;
};

export type ProjectTypeInput = {
  name: Scalars['String'];
};

export type ProjectUnitBlockFloorOuput = {
  __typename?: 'ProjectUnitBlockFloorOuput';
  block: Scalars['String'];
  floor: Scalars['Float'];
  floorlabel: Scalars['String'];
};

export type ProjectUnitLayoutMediaOuput = {
  __typename?: 'ProjectUnitLayoutMediaOuput';
  block?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  desc?: Maybe<Scalars['String']>;
  noOfBathroom?: Maybe<Scalars['Float']>;
  noOfBedroom?: Maybe<Scalars['Float']>;
  pictureid: Scalars['String'];
  resourceid?: Maybe<Scalars['String']>;
  seqno?: Maybe<Scalars['Float']>;
  unit_type_desc?: Maybe<Scalars['String']>;
  unit_type_id?: Maybe<Scalars['String']>;
  unitcount?: Maybe<Scalars['Float']>;
  unitLayout?: Maybe<Scalars['String']>;
  unitlayoutid?: Maybe<Scalars['String']>;
  url: Scalars['String'];
  virtualModelLink?: Maybe<Scalars['String']>;
};

export type ProjectUnitStatusCount = {
  __typename?: 'ProjectUnitStatusCount';
  availableUnitCount?: Maybe<Scalars['Float']>;
  bookUnitCount?: Maybe<Scalars['Float']>;
  reservationUnitCount?: Maybe<Scalars['Float']>;
  signedUnitCount?: Maybe<Scalars['Float']>;
  soldUnitCount?: Maybe<Scalars['Float']>;
  totalAvailableUnitPrice?: Maybe<Scalars['Float']>;
  totalBookUnitPrice?: Maybe<Scalars['Float']>;
  totalReservationUnitPrice?: Maybe<Scalars['Float']>;
  totalSignedUnitPrice?: Maybe<Scalars['Float']>;
  totalSoldUnitPrice?: Maybe<Scalars['Float']>;
  totalUnavailableUnitPrice?: Maybe<Scalars['Float']>;
  totalUnitCount?: Maybe<Scalars['Float']>;
  totalUnitPrice?: Maybe<Scalars['Float']>;
  unavailableUnitCount?: Maybe<Scalars['Float']>;
};

export type ProjectUserRoleAssignmentInput = {
  assignment: Array<UserRoleAssignmentInput>;
  projectId: Scalars['String'];
};

export type ProjectYoutubeLinkOutput = {
  __typename?: 'ProjectYoutubeLinkOutput';
  caption?: Maybe<Scalars['String']>;
  thumbnail: Scalars['String'];
  url: Scalars['String'];
  videoType?: Maybe<Scalars['String']>;
};

export type PromotionalItemEntity = {
  __typename?: 'promotionalItemEntity';
  accountId: Scalars['String'];
  cost: Scalars['Float'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  name: Scalars['String'];
  projectId: Scalars['String'];
  promotionalPackagesItem?: Maybe<PromotionalPackagesItemEntity>;
  recordStatus: Scalars['String'];
};

export type PromotionalItemOutput = {
  __typename?: 'PromotionalItemOutput';
  name: Scalars['String'];
  promotionalItemId: Scalars['String'];
};

export type PromotionalPackageOutput = {
  __typename?: 'promotionalPackageOutput';
  id: Scalars['String'];
  itemCount: Scalars['Float'];
  openMarketValue?: Maybe<Scalars['Float']>;
  packageId: Scalars['String'];
  packageName: Scalars['String'];
  paymentPlanId?: Maybe<Scalars['String']>;
  sellingMethod: Scalars['String'];
  sellingPrice?: Maybe<Scalars['Float']>;
  taxSchemeId?: Maybe<Scalars['String']>;
  taxSchemeName?: Maybe<Scalars['String']>;
};

export type PromotionalPackagesEntity = {
  __typename?: 'promotionalPackagesEntity';
  accountId: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  id: Scalars['String'];
  items?: Maybe<Array<PromotionalPackagesItemEntity>>;
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  name: Scalars['String'];
  projectId: Scalars['String'];
  recordStatus: Scalars['String'];
  salePackage: SalePackageEntity;
  startDate: Scalars['DateTime'];
};

export type PromotionalPackagesItemEntity = {
  __typename?: 'promotionalPackagesItemEntity';
  accountId: Scalars['String'];
  costPrice: Scalars['Float'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  packages: PromotionalPackagesEntity;
  promoPrice: Scalars['Float'];
  promotionalItem: PromotionalItemEntity;
  promotionalItemId: Scalars['String'];
  promotionalPackagesId: Scalars['String'];
  recordStatus: Scalars['String'];
};

export type PromotionalPackagesItemsDetailsOutput = {
  __typename?: 'promotionalPackagesItemsDetailsOutput';
  costPrice: Scalars['Float'];
  endDate: Scalars['DateTime'];
  id: Scalars['String'];
  itemDescription: Scalars['String'];
  itemName: Scalars['String'];
  packageName: Scalars['String'];
  promoPrice: Scalars['Float'];
  promotionalItemId: Scalars['String'];
  promotionalPackageId: Scalars['String'];
  startDate: Scalars['DateTime'];
};

export type PromotionalPackagesOutput = {
  __typename?: 'promotionalPackagesOutput';
  accountId: Scalars['String'];
  costPrice: Scalars['Float'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  id: Scalars['String'];
  items?: Maybe<Array<PromotionalPackagesItemEntity>>;
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  name: Scalars['String'];
  projectId: Scalars['String'];
  promoPrice: Scalars['Float'];
  promotionalPackageId: Scalars['String'];
  recordStatus: Scalars['String'];
  salePackage: SalePackageEntity;
  startDate: Scalars['DateTime'];
};

export type PropertySalesInfo = {
  salesLocalAuthorityAddress?: InputMaybe<AddressJsonInput>;
  salesLocalAuthorityContactNo?: InputMaybe<Scalars['String']>;
  salesLocalAuthorityName?: InputMaybe<Scalars['String']>;
};

export type PropertyTypeEntity = {
  __typename?: 'propertyTypeEntity';
  accountId: Scalars['String'];
  commercialPurpose: Scalars['String'];
  commercialPurposeDesc: Scalars['String'];
  commonStatus: Scalars['String'];
  defaulted: Scalars['Boolean'];
  id: Scalars['String'];
  isDeletable: Scalars['Boolean'];
  isExistInMasterData: Array<Scalars['String']>;
  isExistInTransactionData: Array<Scalars['String']>;
  landPlots: Scalars['Boolean'];
  name: Scalars['String'];
  propertyTypeExt?: Maybe<PropertyTypeExtEntity>;
  seq_no?: Maybe<Scalars['Float']>;
  units: Array<UnitEntity>;
};

export type PropertyTypeExtEntity = {
  __typename?: 'propertyTypeExtEntity';
  accountId: Scalars['String'];
  bookingFeeAmt: Scalars['Float'];
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  propertyType: PropertyTypeEntity;
  propertyTypeId: Scalars['String'];
};

export type PropertyTypeInput = {
  commercialPurpose: CommercialPurpose;
  landPlots?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
};

export type PurchaseLeadNotificationInput = {
  keyCollectionAppointment?: InputMaybe<PurchaserKeyCollectionAppointmentInput>;
  keyCollectionAppointmentReschedule?: InputMaybe<KeyCollectionAppointmentRescheduleInput>;
};

export type PurchaserAccDetail = {
  __typename?: 'PurchaserAccDetail';
  clusterName: Scalars['String'];
  companyName?: Maybe<Scalars['String']>;
  contactId: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  icNo: Scalars['String'];
  isCompany?: Maybe<Scalars['Boolean']>;
  officeTel?: Maybe<Scalars['String']>;
  phoneNo: Scalars['String'];
  purchaserName: Scalars['String'];
  saleId: Scalars['String'];
  taxSchemeId: Scalars['String'];
  totalOutstanding: Scalars['Float'];
  unitNo: Scalars['String'];
};

export type PurchaserAccListing = {
  __typename?: 'PurchaserAccListing';
  clusterName: Scalars['String'];
  contactId: Scalars['String'];
  date?: Maybe<Scalars['DateTime']>;
  icNo: Scalars['String'];
  phoneNo: Scalars['String'];
  purchaserName: Scalars['String'];
  receiptAmount?: Maybe<Scalars['Float']>;
  receiptDate?: Maybe<Scalars['DateTime']>;
  remark?: Maybe<Scalars['String']>;
  saleId: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  totalOutstanding?: Maybe<Scalars['Float']>;
  unitId: Scalars['String'];
  unitNo: Scalars['String'];
};

export type PurchaserAccountIndoSummary = {
  __typename?: 'PurchaserAccountIndoSummary';
  additionalPackageSummary: ApSummary;
  carParkSummary: CarParkSummary;
  contraSummary: ContraSummary;
  creditNoteSummary: CnSummary;
  debitNoteSummary: DnSummary;
  depositSummary: DepositSummary;
  lateInterestSummary: LiSummary;
  miscBillingSummary: MbSummary;
  paymentSummary: PaymentSummary;
  purchaserInstallmentSummary: PiSummary;
  rebateSummary: RebateSummary;
  refundSummary: RefundSummary;
};

export type PurchaserAccountReferenceEntity = AuditEntity & {
  __typename?: 'purchaserAccountReferenceEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  refId?: Maybe<Array<PurchaserReferenceOutput>>;
  userId: Scalars['String'];
};

export type PurchaserAccountSummary = {
  __typename?: 'PurchaserAccountSummary';
  additionalPackageSummary: CarParkAdditionalPackageSummary;
  bankLoanSummary: BankLoanSummary;
  carParkSummary: CarParkAdditionalPackageSummary;
  collectionActivity?: Maybe<CollectionActivitySummaryOutput>;
  collectionSummary: PAmoduleSummary;
  contactData: PAcontactOutput;
  contraSummary: PAmoduleSummary;
  creditNoteSummary: PAmoduleSummary;
  debitNoteSummary: PAmoduleSummary;
  depositSummary: PAmoduleSummary;
  dueDateRange: DueDateRange;
  lateInterestSummary: PaLateInterestSummary;
  miscBillingSummary: PAmoduleSummary;
  overdueAging: OverdueAging;
  paymentReminder?: Maybe<PaymentReminderSummaryOutput>;
  progressBillingSummary: PBsummary;
  purchaserDetail?: Maybe<PurchaserAccDetail>;
  purchaserInstallmentSummary: PAmoduleSummary;
  rebateSummary: PAmoduleSummary;
  refundSummary: PAmoduleSummary;
  totalGrandOutstading?: Maybe<Scalars['Float']>;
  totalUnallocated?: Maybe<Scalars['Float']>;
  unitData: PAunitOutput;
};

export type PurchaserAppBookedSubmenuInput = {
  booking_info?: InputMaybe<Scalars['Boolean']>;
  loan?: InputMaybe<Scalars['Boolean']>;
  overall_site_progress?: InputMaybe<Scalars['Boolean']>;
};

export type PurchaserAppBookedSubmenuOutput = {
  __typename?: 'PurchaserAppBookedSubmenuOutput';
  booking_info?: Maybe<Scalars['Boolean']>;
  loan?: Maybe<Scalars['Boolean']>;
  overall_site_progress?: Maybe<Scalars['Boolean']>;
};

export type PurchaserAppCssInput = {
  backgroundAttachment?: InputMaybe<Scalars['String']>;
  backgroundImage?: InputMaybe<Scalars['String']>;
  backgroundPosition?: InputMaybe<Scalars['String']>;
  backgroundRepeat?: InputMaybe<Scalars['String']>;
  backgroundSize?: InputMaybe<Scalars['String']>;
  boxShadow?: InputMaybe<Scalars['String']>;
  cardColor?: InputMaybe<Scalars['String']>;
  headerColor?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  showLoginIcon?: InputMaybe<Scalars['Boolean']>;
  showPurchaserAppWord?: InputMaybe<Scalars['Boolean']>;
};

export type PurchaserAppCssOutput = {
  __typename?: 'purchaserAppCssOutput';
  backgroundAttachment?: Maybe<Scalars['String']>;
  backgroundImage?: Maybe<Scalars['String']>;
  backgroundPosition?: Maybe<Scalars['String']>;
  backgroundRepeat?: Maybe<Scalars['String']>;
  backgroundSize?: Maybe<Scalars['String']>;
  boxShadow?: Maybe<Scalars['String']>;
  cardColor?: Maybe<Scalars['String']>;
  headerColor?: Maybe<Scalars['String']>;
  logoUrl?: Maybe<Scalars['String']>;
  showLoginIcon?: Maybe<Scalars['Boolean']>;
  showPurchaserAppWord?: Maybe<Scalars['Boolean']>;
};

export type PurchaserAppSignedSubmenuInput = {
  accounts?: InputMaybe<Scalars['Boolean']>;
  key_collection?: InputMaybe<Scalars['Boolean']>;
  overall_site_progress?: InputMaybe<Scalars['Boolean']>;
  s_and_p?: InputMaybe<Scalars['Boolean']>;
};

export type PurchaserAppSignedSubmenuOutput = {
  __typename?: 'PurchaserAppSignedSubmenuOutput';
  accounts?: Maybe<Scalars['Boolean']>;
  key_collection?: Maybe<Scalars['Boolean']>;
  overall_site_progress?: Maybe<Scalars['Boolean']>;
  s_and_p?: Maybe<Scalars['Boolean']>;
};

export type PurchaserAppSubmenuInput = {
  booked?: InputMaybe<PurchaserAppBookedSubmenuInput>;
  signed?: InputMaybe<PurchaserAppSignedSubmenuInput>;
};

export type PurchaserAppSubmenuOutput = {
  __typename?: 'PurchaserAppSubmenuOutput';
  booked?: Maybe<PurchaserAppBookedSubmenuOutput>;
  signed?: Maybe<PurchaserAppSignedSubmenuOutput>;
};

export type PurchaserContactDetails = {
  __typename?: 'PurchaserContactDetails';
  address?: Maybe<AddressJson>;
  ContactId?: Maybe<Scalars['String']>;
  DOB?: Maybe<Scalars['DateTime']>;
  Email: Scalars['String'];
  FullName: Scalars['String'];
  Gender?: Maybe<Scalars['String']>;
  IdentityNo?: Maybe<Scalars['String']>;
  MaritalStatus?: Maybe<MaritalStatusEntity>;
  Nationality?: Maybe<SNationalityEntity>;
  PhoneNo?: Maybe<Scalars['String']>;
  Race?: Maybe<RaceEntity>;
  Salutation?: Maybe<SalutationEntity>;
};

export type PurchaserContactEntity = AuditEntity & {
  __typename?: 'purchaserContactEntity';
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lead?: Maybe<Array<PurchaserLeadContactOutput>>;
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  name: Scalars['String'];
  phoneNo?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  user: PurchaserUserEntity;
  userId: Scalars['String'];
};

export type PurchaserDataOutput = {
  __typename?: 'purchaserDataOutput';
  clusterName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  salesRegistrationDate?: Maybe<Scalars['DateTime']>;
  salesRegistrationNo?: Maybe<Scalars['String']>;
  totalDocAmt?: Maybe<Scalars['String']>;
  totalOutstanding?: Maybe<Scalars['String']>;
  unitNo?: Maybe<Scalars['String']>;
};

export type PurchaserDemographicBiOutput = {
  __typename?: 'PurchaserDemographicBIOutput';
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  value?: Maybe<Scalars['Float']>;
};

export type PurchaserIdTypeEntity = AuditEntity & {
  __typename?: 'purchaserIDTypeEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  createdBy: Scalars['String'];
  createdTs: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['String'];
  identityDoc: Scalars['String'];
  modBy: Scalars['String'];
  modTs: Scalars['DateTime'];
};

export type PurchaserInfoInfoOutput = {
  __typename?: 'purchaserInfoInfoOutput';
  count: Scalars['Float'];
  error: Scalars['Boolean'];
  name: Scalars['String'];
};

export type PurchaserInfoOutput = {
  __typename?: 'purchaserInfoOutput';
  jointBuyers: Array<JointBuyerEntity>;
  purchaserInfo: ContactEntity;
};

export type PurchaserKeyCollectionAppointmentInput = {
  agencyUserReceive?: InputMaybe<Scalars['Boolean']>;
  keyCollectionSalesPersonReceive?: InputMaybe<Scalars['Boolean']>;
  purchaserUserReceive?: InputMaybe<Scalars['Boolean']>;
  salesUserReceive?: InputMaybe<Scalars['Boolean']>;
};

export type PurchaserKeyCollectionAppointmentOutput = {
  __typename?: 'purchaserKeyCollectionAppointmentOutput';
  agencyUserReceive?: Maybe<Scalars['Boolean']>;
  keyCollectionSalesPersonReceive?: Maybe<Scalars['Boolean']>;
  purchaserUserReceive?: Maybe<Scalars['Boolean']>;
  salesUserReceive?: Maybe<Scalars['Boolean']>;
};

export type PurchaserKeyCollectionAppointmentRescheduleOutput = {
  __typename?: 'purchaserKeyCollectionAppointmentRescheduleOutput';
  agencyUserReceive?: Maybe<Scalars['Boolean']>;
  keyCollectionSalesPersonReceive?: Maybe<Scalars['Boolean']>;
  purchaserUserReceive?: Maybe<Scalars['Boolean']>;
  salesUserReceive?: Maybe<Scalars['Boolean']>;
};

export type PurchaserLeadContactInput = {
  LeadId: Scalars['String'];
  ProjectId: Scalars['String'];
};

export type PurchaserLeadContactOutput = {
  __typename?: 'PurchaserLeadContactOutput';
  LeadId: Scalars['String'];
  ProjectId: Scalars['String'];
};

export type PurchaserLeadNotificationOutput = {
  __typename?: 'PurchaserLeadNotificationOutput';
  keyCollectionAppointment?: Maybe<PurchaserKeyCollectionAppointmentOutput>;
  keyCollectionAppointmentReschedule?: Maybe<PurchaserKeyCollectionAppointmentRescheduleOutput>;
};

export type PurchaserListingOutput = {
  __typename?: 'purchaserListingOutput';
  companyName?: Maybe<Scalars['String']>;
  companyRegNo?: Maybe<Scalars['String']>;
  draggable: Scalars['Boolean'];
  error: Scalars['Float'];
  icNo: Scalars['String'];
  id: Scalars['String'];
  isBumi?: Maybe<Scalars['Boolean']>;
  isCompany?: Maybe<Scalars['Boolean']>;
  jointBuyerId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  seqNo: Scalars['Float'];
};

export type PurchaserNotificationEntity = {
  __typename?: 'purchaserNotificationEntity';
  accountId: Scalars['String'];
  body: Scalars['String'];
  id: Scalars['String'];
  projectId: Scalars['String'];
  purchaserNotificationRecipient: Array<PurchaserNotificationRecipientEntity>;
  subject: Scalars['String'];
};

export type PurchaserNotificationRecipientEntity = {
  __typename?: 'purchaserNotificationRecipientEntity';
  accountId: Scalars['String'];
  id: Scalars['String'];
  isRead: Scalars['Boolean'];
  notificationId: Scalars['String'];
  projectId: Scalars['String'];
  purchaserNotification: PurchaserNotificationEntity;
  recipientId: Scalars['String'];
};

export type PurchaserPaymentEntity = AuditEntity & {
  __typename?: 'purchaserPaymentEntity';
  accountId: Scalars['String'];
  amount: Scalars['Float'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  ifcaSaleId?: Maybe<Scalars['Float']>;
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  paymentGatewayId?: Maybe<Scalars['String']>;
  paymentMethod: Scalars['String'];
  paymentStatus: Scalars['String'];
  receiptNo?: Maybe<Scalars['String']>;
  refNo?: Maybe<Scalars['String']>;
  response: Scalars['JSONObject'];
  saleId?: Maybe<Scalars['String']>;
  transactionDate?: Maybe<Scalars['DateTime']>;
  transactionMethod?: Maybe<Scalars['String']>;
  unitId: Scalars['String'];
};

export type PurchaserPaymentPlanDetailsEntity = {
  __typename?: 'purchaserPaymentPlanDetailsEntity';
  accountId: Scalars['String'];
  billAfter: Scalars['String'];
  billCount: Scalars['Float'];
  billFrequency: BillFrequency;
  billType: BillType;
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  deductBookingFee: DeductBookingFee;
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  noInstallment: Scalars['Float'];
  payment: PurchaserPaymentPlanEntity;
  paymentBy: PaymentBy;
  paymentValue: Scalars['Float'];
  purchaserPaymentPlanId: Scalars['String'];
  recordStatus: Scalars['String'];
  salesPaymentPlan: Array<SalesPaymentPlanEntity>;
  title: Scalars['String'];
};

export type PurchaserPaymentPlanDetailsOutput = {
  __typename?: 'purchaserPaymentPlanDetailsOutput';
  billAfter: Scalars['String'];
  billCount: Scalars['Float'];
  billFrequency: Scalars['String'];
  deductBookingFee: Scalars['String'];
  effectiveDate: Scalars['DateTime'];
  id: Scalars['String'];
  markUpPercentage: Scalars['Float'];
  noInstallment: Scalars['Float'];
  paymentPlanName: Scalars['String'];
  paymentValue: Scalars['String'];
  recordStatus?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type PurchaserPaymentPlanEntity = {
  __typename?: 'purchaserPaymentPlanEntity';
  accountId: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  details?: Maybe<Array<PurchaserPaymentPlanDetailsEntity>>;
  effectiveDate: Scalars['DateTime'];
  id: Scalars['String'];
  markUpPercentage: Scalars['Float'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  name: Scalars['String'];
  projectCarparkPaymentPlans: Array<ProjectCarparkPaymentPlanEntity>;
  projectPackagePaymentPlans: Array<ProjectPackagePaymentPlanEntity>;
  projectPaymentPlans: Array<ProjectPaymentPlanEntity>;
  recordStatus: Scalars['String'];
};

export type PurchaserPaymentPlanEnum = {
  __typename?: 'PurchaserPaymentPlanEnum';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type PurchaserPaymentPlanEnumsOutput = {
  __typename?: 'PurchaserPaymentPlanEnumsOutput';
  billAfter: Array<PurchaserPaymentPlanEnum>;
  billFrequency: Array<PurchaserPaymentPlanEnum>;
  billType: Array<PurchaserPaymentPlanEnum>;
  deductBookingFee: Array<PurchaserPaymentPlanEnum>;
  paymentBy: Array<PurchaserPaymentPlanEnum>;
};

export type PurchaserPaymentPlanOutput = {
  __typename?: 'purchaserPaymentPlanOutput';
  accountId: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  details?: Maybe<Array<PurchaserPaymentPlanDetailsEntity>>;
  effectiveDate: Scalars['DateTime'];
  id: Scalars['String'];
  installmentSum?: Maybe<Scalars['Float']>;
  markUpPercentage?: Maybe<Scalars['Float']>;
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  name: Scalars['String'];
  projectCarparkPaymentPlans: Array<ProjectCarparkPaymentPlanEntity>;
  projectPackagePaymentPlans: Array<ProjectPackagePaymentPlanEntity>;
  projectPaymentPlans: Array<ProjectPaymentPlanEntity>;
  recordStatus?: Maybe<Scalars['String']>;
};

export type PurchaserPaymentScheduleOutput = {
  __typename?: 'purchaserPaymentScheduleOutput';
  bookDate?: Maybe<Scalars['DateTime']>;
  clusterName?: Maybe<Scalars['String']>;
  detail: Array<InstallmentDetail>;
  fullName?: Maybe<Scalars['String']>;
  saleId?: Maybe<Scalars['String']>;
  salesNo?: Maybe<Scalars['String']>;
  salesRegistrationNo?: Maybe<Scalars['String']>;
  salesRegNo?: Maybe<Scalars['String']>;
  sellingPrice?: Maybe<Scalars['Float']>;
  unitNo?: Maybe<Scalars['String']>;
};

export type PurchaserProfileDetail = {
  __typename?: 'PurchaserProfileDetail';
  Address?: Maybe<Scalars['String']>;
  Email?: Maybe<Scalars['String']>;
  IdentityNo?: Maybe<Scalars['String']>;
  Name: Scalars['String'];
  Nationality?: Maybe<Scalars['String']>;
  PhoneNo?: Maybe<Scalars['String']>;
  ProfilePic?: Maybe<Scalars['String']>;
  Race?: Maybe<Scalars['String']>;
};

export type PurchaserReferenceInput = {
  AccountID: Scalars['Float'];
  IntegrationId?: InputMaybe<Scalars['String']>;
  IsIntegrate?: InputMaybe<Scalars['Boolean']>;
  ProjectId: Scalars['Float'];
  ProjectID: Scalars['Float'];
  SaleId: Scalars['Float'];
  SaleStatus: Scalars['String'];
  UnitId: Scalars['Float'];
};

export type PurchaserReferenceOutput = {
  __typename?: 'PurchaserReferenceOutput';
  AccountID: Scalars['Float'];
  IntegrationId?: Maybe<Scalars['String']>;
  IsIntegrate?: Maybe<Scalars['Boolean']>;
  ProjectId: Scalars['Float'];
  ProjectID: Scalars['Float'];
  SaleId: Scalars['Float'];
  SaleStatus: Scalars['String'];
  UnitId: Scalars['Float'];
};

export type PurchaserTransferIndoDetailsEntity = {
  __typename?: 'purchaserTransferIndoDetailsEntity';
  address?: Maybe<AddressJson>;
  commonStatus: Scalars['String'];
  contactId: Scalars['String'];
  id: Scalars['String'];
  isPrimary: Scalars['Boolean'];
  purchaserTransferIndoId: Scalars['String'];
  status: Scalars['String'];
};

export type PurchaserTransferIndoEntity = {
  __typename?: 'purchaserTransferIndoEntity';
  accountId: Scalars['String'];
  adminFee: Scalars['Float'];
  approvalStatus: Scalars['String'];
  approvedBy: Scalars['String'];
  approvedDate: Scalars['DateTime'];
  commonStatus: Scalars['String'];
  documentNo: Scalars['String'];
  id: Scalars['String'];
  miscBillId: Scalars['String'];
  purchaserTransferIndoDetails?: Maybe<PurchaserTransferIndoDetailsEntity>;
  saleId: Scalars['String'];
  transferDate: Scalars['DateTime'];
};

export type PurchaserTransferOutput = {
  __typename?: 'purchaserTransferOutput';
  adminFee: Scalars['Float'];
  approvalStatus: Scalars['String'];
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  contactId: Scalars['String'];
  documentNo: Scalars['String'];
  id: Scalars['String'];
  jointBuyer: Array<JointBuyerEntity>;
  mainBuyer: ContactEntity;
  miscBillId: Scalars['String'];
  newContactId: Scalars['String'];
  oldContactId: Scalars['String'];
  oldPurchaserEmail: Scalars['String'];
  oldPurchaserIdentityNo: Scalars['String'];
  oldPurchaserMobileNo: Scalars['String'];
  oldPurchaserName: Scalars['String'];
  projectId: Scalars['String'];
  remarks: Scalars['String'];
  saleId: Scalars['String'];
  transferDate: Scalars['DateTime'];
  unitClusterId: Scalars['String'];
  unitId: Scalars['String'];
  unitNo: Scalars['String'];
};

export type PurchaserUserEntity = AuditEntity & {
  __typename?: 'purchaserUserEntity';
  accessToken?: Maybe<Scalars['String']>;
  activated: Scalars['Boolean'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  forgotPasswordLink?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  loginId: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  passwordHash?: Maybe<Scalars['String']>;
  purchaserAccountReference?: Maybe<PurchaserAccountReferenceEntity>;
  refreshToken?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  accessSecurityListing: UserAndRoleCount;
  activeFinancierList: Array<FinancierEntity>;
  activeSolicitorList: Array<SolicitorAppointedEntity>;
  allowAddProject: Scalars['Boolean'];
  allProject?: Maybe<WorkDeskProjectListOutput>;
  allProjectInvolve?: Maybe<Array<ProjectInvolvementLevel>>;
  approvalPolicyDate?: Maybe<Scalars['DateTime']>;
  archCertStagesCount?: Maybe<Scalars['Float']>;
  architectCertLastUpdate?: Maybe<Scalars['DateTime']>;
  areaVarianceIndonesiaCount?: Maybe<Scalars['Float']>;
  areaVarianceIndonesiaLastUpdate?: Maybe<Scalars['DateTime']>;
  areaVariancePolicyIndonesiaLastUpdate?: Maybe<Scalars['DateTime']>;
  areaVarianceSummaryIndonesia?: Maybe<AreaVarianceSummaryIndonesiaOutput>;
  assignedDiscountCount?: Maybe<Scalars['Float']>;
  bankCount?: Maybe<Scalars['Float']>;
  bankLoanTotalAmount?: Maybe<Scalars['Float']>;
  bankLoanUnitCount?: Maybe<Scalars['Float']>;
  bankProfileListing: CompanyEntity;
  billItemCount?: Maybe<Scalars['Float']>;
  BookingContactList: Array<BookingContactSaleOutput>;
  bookingListAnalysisBusinessInsight?: Maybe<BookingAnalysisBiOutput>;
  bookingListBusinessInsight?: Maybe<BookingBiOutput>;
  bridgingFinanceLastUpdate?: Maybe<Scalars['DateTime']>;
  businessPermitLastUpdate?: Maybe<Scalars['DateTime']>;
  calculateBridgingValue: CalculatedUnitExeValue;
  calculateDiscountAmount: Scalars['JSON'];
  calculateLADGenerateValue: LadGenerateOutput;
  calculateMiscBillingTaxAmount: Scalars['JSON'];
  calculateSaleDiscountAmount: Scalars['JSON'];
  calculateSalesRegDiscount: Scalars['JSONObject'];
  calculateTaxAmount: Scalars['JSON'];
  carParkCount?: Maybe<Scalars['Float']>;
  checkFirstTimeUserPasswordToken: Scalars['Boolean'];
  checkProjectSpec: ProjectSpecEntity;
  checkSetupBridgingFinancier: Scalars['Boolean'];
  classificationCodeCount?: Maybe<Scalars['Float']>;
  collectionActivityCount?: Maybe<Scalars['Float']>;
  collectionActivityLastUpdate?: Maybe<Scalars['DateTime']>;
  collectionSummary?: Maybe<CollectionInfoLine>;
  commissionTypeCount?: Maybe<Scalars['Float']>;
  companyCommissionPackageDate?: Maybe<Scalars['DateTime']>;
  companyCommissionTeamDate?: Maybe<Scalars['DateTime']>;
  companyCount?: Maybe<Scalars['Float']>;
  companyDetail?: Maybe<CompanyEntity>;
  companyEditList: CompanyDetailOutput;
  companyListing: Array<CompanyEntity>;
  constructionInfoLastUpdate?: Maybe<Scalars['DateTime']>;
  countryCodeCount?: Maybe<Scalars['Float']>;
  creditControlLastUpdate?: Maybe<Scalars['DateTime']>;
  currencyExchangeCount?: Maybe<Scalars['Float']>;
  designationCount?: Maybe<Scalars['Float']>;
  discountCount?: Maybe<Scalars['Float']>;
  discountTypeCount?: Maybe<Scalars['Float']>;
  downloadStatutoryDocumentList: UnitExcelOutput;
  downpaymentReminderCount?: Maybe<Scalars['Float']>;
  educationCount?: Maybe<Scalars['Float']>;
  endFinancingLimitStatus?: Maybe<Array<EndFinancingLimitStatusOutput>>;
  endFinancingSummary?: Maybe<EndFinancingInfoLine>;
  exportBookingListAnalysis: ReportingExcelOutput;
  exportCampaignPerformance: ReportingExcelOutput;
  exportExcel: UnitExcelOutput;
  exportGLJournal: GlJournalDownloadProps;
  exportLoanAndFinancing: ReportingExcelOutput;
  exportLotStatusMovement: ReportingExcelOutput;
  exportOutstandingSP: ReportingExcelOutput;
  exportSalesAnalysis: ReportingExcelOutput;
  exportSalesAnalysisByUnit: ReportingExcelOutput;
  exportSalesDemographicAnalysis: ReportingExcelOutput;
  exportSalesLeadPerformance: ReportingExcelOutput;
  exportSalesMovement: ReportingExcelOutput;
  exportSalesPerformance: ReportingExcelOutput;
  exportTeamPerformance: ReportingExcelOutput;
  exportTrackingOfPaymentMethod: ReportingExcelOutput;
  exportWaitListByUnitType: ReportingExcelOutput;
  fireInsuranceLastUpdate?: Maybe<Scalars['DateTime']>;
  formatCastNumber: Scalars['String'];
  generatePaymentReminderList?: Maybe<GeneratePaymentRemindersOutput>;
  generatePaymentReminderProgressBillingList?: Maybe<GeneratePaymentReminderOutput>;
  getAccountName: Scalars['String'];
  getAccountNameHome: Scalars['JSONObject'];
  getActiveBankList?: Maybe<Array<BankEntity>>;
  GetActiveBlockByProject: Array<Scalars['String']>;
  getActiveCampaignByProject: Array<CampaignEntity>;
  GetActiveFloorAndUnitByProjectBlock: Array<FloorOutput>;
  getActiveProjectPaymentPlan: Array<ActivePaymentPlanOutput>;
  getActivityStatusType: Scalars['JSONObject'];
  getAddressById?: Maybe<Scalars['JSON']>;
  getAddressListByContact: Array<GetAddressListByContactOutput>;
  getAgencyTeam?: Maybe<Array<AgencyTeamOutput>>;
  getAllAllocation?: Maybe<Array<AllocationEntity>>;
  getAllArchitectCert: Array<ArchitectCertListOutput>;
  getAllAreaVarianceIndonesia: Array<AreaVarianceEntity>;
  getAllBillingBySaleId?: Maybe<Array<AllocationDetailOutput>>;
  getAllDesignation?: Maybe<Array<ParameterEntity>>;
  getAllDirection?: Maybe<Array<DirectionEntity>>;
  getAllDiscount: Array<DiscountEntity>;
  getAllDiscountType?: Maybe<Array<DiscountTypeEntity>>;
  getAllDownpaymentReminder?: Maybe<Array<DownpaymentReminderListingOutput>>;
  getAllEducation?: Maybe<Array<ParameterEntity>>;
  getAllEmployeeJobPosition: Array<EmployeeJobPositionOutput>;
  getAllFinancialBilling?: Maybe<Array<FinancialBillingEntity>>;
  getAllFloorByBlock: FloorByBlockOutput;
  getAllIncomeRange?: Maybe<Array<IncomeRangeEntity>>;
  getAllIndustry?: Maybe<Array<ParameterEntity>>;
  getAllJobPosition: JobPositionListWithRecentModTs;
  getAllJobPositionOption: Array<JobPositionOptionOutput>;
  getAllLad: Array<LadListingOutput>;
  getAllLateInterest?: Maybe<Array<LateInterestListingOutput>>;
  getAllLatePaymentInterestException?: Maybe<Array<LatePaymentInterestExceptionOutput>>;
  getAllLeadSource?: Maybe<Array<LeadSourceEntity>>;
  getAllMaritalStatus?: Maybe<Array<MaritalStatusEntity>>;
  GetAllMasterInfo: MasterDataOutput;
  getAllMiscBillingByStatus?: Maybe<Array<MiscBillingListOutput>>;
  getAllMotTracking: Array<MotTrackingListingOutput>;
  getAllNationality: Array<SNationalityEntity>;
  getAllNotary: Array<NotaryOutput>;
  getAllocationByCreditId?: Maybe<AllocationEntity>;
  getAllocationListing?: Maybe<Array<AllocationEntity>>;
  getAllPackageByProject?: Maybe<Array<PackageEntity>>;
  getAllPaymentInterestException: Array<PaymentInterestExceptionOutput>;
  getAllPaymentInterestExceptionForm: Array<PaymentInterestExceptionFormOutput>;
  getAllPaymentPlan: Array<PaymentPlanEntity>;
  getAllPaymentPlanDetail: Array<PaymentPlanDetailEntity>;
  getAllPaymentPlanForProject: Array<PurchaserPaymentPlanEntity>;
  getAllPaymentReminder?: Maybe<Array<PaymentReminderListingOutput>>;
  getAllProfession?: Maybe<Array<ParameterEntity>>;
  getAllProject: Array<ProjectEntity>;
  getAllProjectAreaVarianceIndonesia?: Maybe<Array<ProjectAreaVarianceEntity>>;
  getAllProjectConstruction?: Maybe<Array<ProjectConstructionEntity>>;
  getAllProjectCount: Scalars['Float'];
  getAllProjectKeyCollectionContractor?: Maybe<Array<ProjectKeyCollectionContractorEntity>>;
  getAllProjectKeyCollectionSchedule?: Maybe<Array<ProjectKeyCollectionScheduleEntity>>;
  getAllProjectLateInterest: Array<ProjectLateInterestEntity>;
  getAllProjectMiscCharges: Array<ProjectMiscChargesEntity>;
  getAllProjectPaymentPlan: Array<AllProjectPaymentPlanOutput>;
  getAllProjectPaymentReminderException: Array<PaymentExceptionReminderOutput>;
  getAllProjectPermit: Array<ProjectPermitEntity>;
  getAllProjectSalesOffice: Array<ProjectSalesOfficeEntity>;
  getAllProjectTitle: Array<ProjectTitleEntity>;
  getAllProjectType?: Maybe<Array<ProjectTypeEntity>>;
  getAllPropertyType?: Maybe<Array<PropertyTypeEntity>>;
  getAllRace?: Maybe<Array<RaceEntity>>;
  getAllReasonCode?: Maybe<Array<ReasonCodeEntity>>;
  getAllReceipt?: Maybe<Array<ReceiptOutput>>;
  getAllReceiptByFinancier: Array<BankPaymentListingOutput>;
  getAllReceiptByGenerationBatchId: AllLoanPaymentMainOutput;
  getAllReceiptBySaleId?: Maybe<Array<ReceiptOutput>>;
  getAllRedemptionRepayment: Array<RedemptionRepaymentListingOutput>;
  getAllRefinancing?: Maybe<Array<RefinancingListingOutput>>;
  getAllRelationship?: Maybe<Array<ParameterEntity>>;
  getAllReligion?: Maybe<Array<ParameterEntity>>;
  getAllSaleLoan: Array<SaleLoanEntity>;
  getAllSaleUnitNoList?: Maybe<Array<SaleEntity>>;
  getAllSalutation?: Maybe<Array<SalutationEntity>>;
  getAllSolicitorList: Array<SolicitorAppointedEntity>;
  getAllSpaReminder?: Maybe<Array<SaleReminderListingOutput>>;
  getAllStakeholderProcess: Array<StakeholderProcessListOutput>;
  getAllSubsale: Array<SubsaleListingOutput>;
  getAllTypeBillingBySaleId?: Maybe<Array<AllocationDetailOutput>>;
  getAllUnitMotTracking?: Maybe<Array<MotTrackingUnitOutput>>;
  GetAllUnitProject: Scalars['JSON'];
  getAllUnitStatusSigned: Array<UnitEntity>;
  getAllUnitsVpLetter?: Maybe<Array<VacantPossessionOutput>>;
  getAllUnitType?: Maybe<Array<UnitTypeEntity>>;
  getAllWorkProgress?: Maybe<Array<WorkProgressEntity>>;
  getAllWorkProgressByCarPark?: Maybe<Array<WorkProgressEntity>>;
  getAppAccessToken: Scalars['String'];
  getApprovalPolicyAssignmentFlag: Scalars['JSON'];
  getApprovalPolicyAssignmentListingByCategory?: Maybe<Array<ApprovalPolicyAssignmentEntity>>;
  getApprovalPolicyFlag: Scalars['JSON'];
  getApprovalPolicyListingByCategory?: Maybe<Array<ApprovalPolicyEntity>>;
  getApprovedLoanRescheduleList: Array<GetApprovedLoanRescheduleListOutput>;
  getApprovedRescheduleList: Array<GetApprovedRescheduleListOutput>;
  getArAging?: Maybe<CompanyArAgingPolicyEntity>;
  getArchitectCertById: ArchitectCertEntity;
  getAreaVarianceByIdIndonesia: AreaVarianceEntity;
  getAssignedClassificationBillItems: Array<BillItemEntity>;
  getAssignedDiscountById: ProjectDiscountEntity;
  getAssignedMsicBillItems: Array<BillItemEntity>;
  getAssignedNotaryList: Array<AssignedNotaryOutput>;
  getAssignedStaffList?: Maybe<Array<AssignedStaffListOutput>>;
  getAssignedTeamMembers: Array<UserEntity>;
  getAssignPaymentPlanForm: Scalars['JSONObject'];
  getAttachment?: Maybe<Array<AttachmentEntity>>;
  getAttachmentRelease: Array<AttachmentEntity>;
  getAvaiableCloneMiscChargeProject?: Maybe<Array<AvailableCloneProjectOutput>>;
  getAvailableBankProfileWithAccount: Array<CompanyBankOutput>;
  getAvailableCompanyList: Array<AvailableCopyCompanyListProp>;
  getAvailableCopyNumCompanyList?: Maybe<Array<AvailableCopyCompanyListProp>>;
  getAvailableUnitByProjectID: Array<UnitEntity>;
  getAvailableUnitDropdown?: Maybe<Array<UnitTransferDropdownOutput>>;
  getBankList?: Maybe<Array<BankEntity>>;
  getBankListing?: Maybe<Array<BankListingOutput>>;
  getBankPaymentMasterData?: Maybe<FinancierBankListOutput>;
  getBankProfile: Array<CompanyBankProfileEntity>;
  getBankProfileWithAccount?: Maybe<Array<CompanyBankOutput>>;
  getBillAfterDesc: Scalars['JSONObject'];
  getBillingListingByFinancierId?: Maybe<BillingListingOutput>;
  getBillItemByType?: Maybe<Array<BillItemIntEntity>>;
  getBillItemIntListByType?: Maybe<Array<BillItemIntEntity>>;
  getBillItemList?: Maybe<Array<BillItemEntity>>;
  getBillTypeDesc: Scalars['JSONObject'];
  getBllItemListAtCreditAndDebit: Array<BillItemEntity>;
  getBllItemListById: BillItemEntity;
  getBllItemListByType?: Maybe<Array<BillItemEntity>>;
  GetBlockByProject: BlockByProjectOutput;
  getBlockFloorUnit: Array<BlockListingOutput>;
  GetBlockGalleryByProject: Array<BlockGalleryOutput>;
  getBookingFeeById: BookingFeeDetailsOuput;
  getBookingFeeELetter: BookingFeeELetterOutput;
  getBookingFeeELetterTemplateListing?: Maybe<Array<BookingFeeEletterTemplateOutput>>;
  getBookingFeeListingBySaleId?: Maybe<UnitBookingFeeListingOutput>;
  getBridgingFinanceDetails?: Maybe<Scalars['JSONObject']>;
  getBridgingFinancierList: Array<BridgingFinancierSharedOutput>;
  getBridgingFinancierType: Scalars['JSONObject'];
  getBridgingFinancingUnits: Array<BlockListingOutput>;
  getBusinessInsightSummary?: Maybe<BusinessInsightSummaryOutput>;
  getBuyerListBySaleId: Array<BuyerListOutput>;
  getCampaignById: CampaignEntity;
  getCampaignList: Array<CampaignEntity>;
  getCampaignPerformance?: Maybe<Array<CampaignPerformanceBiOutput>>;
  getCarParkInfo: CarParkIndOutput;
  getCarParkInstallment?: Maybe<Array<PaIndoCarParkOutput>>;
  getCarParkInstallmentDetail?: Maybe<Array<PaIndoCarParkDetailOutput>>;
  getCarParkListing: Array<CarParkIndOutput>;
  getCarParkOption: Array<UnitEntity>;
  getCarParkPaymentPlan: Array<CarParkPaymentPlanListingOutput>;
  getCarParks?: Maybe<MainOutput>;
  getCarParkUnitInstallment?: Maybe<Array<PaIndoCarParkUnitOutput>>;
  getCityByState: Array<CityMasterDataOutput>;
  getClassificationCodeListing: Array<EInvoiceClassificationEntity>;
  getCollectionActivityById: CollectionActivityEntity;
  getCollectionActivityBySaleId?: Maybe<Array<PurchaserAccListing>>;
  getCollectionActivityDetailByID: CollectionActivityEntity;
  getCollectionActivityIndo?: Maybe<Array<OverduePurchaserAccountOutput>>;
  getCollectionActivityIndoDetailByID: OverduePurchaseAccountCaDetailOutput;
  getCollectionActivityIndoDetailListAndSummary: CollectionActivityIndoOutput;
  getCollectionActivityList: Array<CollectionActivityEntity>;
  getCollectionActivityListing: Array<CollectionActivityEntity>;
  getCollectionActivitySummary: CollectionActivityOutput;
  getCollectionActivityWithOPAHeaders?: Maybe<OverduePurchaseCaOutput>;
  getCollectionMasterData?: Maybe<ReceiptMasterDateOutput>;
  getCommissionCalculationData: Array<ProjectCommissionCalculationOutput>;
  getCommissionCalculationDetailData: Array<ProjectCommissionCalculationDetailOutput>;
  getCommissionCalculationListing: Array<CommissionCalculationOutput>;
  getCommissionCalculationListingData: Array<CommissionCalculationOutput>;
  getCommissionCalculationRecentData?: Maybe<Scalars['DateTime']>;
  getCommissionTypeListing: Array<CommissionTypeEntity>;
  getCompanyBankAccount?: Maybe<Array<CompanyBankList>>;
  getCompanyBankAcct?: Maybe<Array<CompanyBankList>>;
  getCompanyCommissionPackageListing: Array<CompanyCommissionPackageEntity>;
  getCompanyCommissionPackageListingData: Array<CompanyCommissionPackageEntity>;
  getCompanyCommissionTeamListing: Scalars['JSON'];
  getCompanyRewardCount: Scalars['Float'];
  getCompanyRewardData: Array<CompanyRewardOutput>;
  getCompanyRewardDetailData: Array<CompanyCommissionCalculationDetailOutput>;
  getCompanyRewardListing: Array<CompanyCommissionEntity>;
  getCompanyRewardListingData: Array<CompanyCommissionEntity>;
  getCompanyRewardListingNew: Array<CompanyRewardCalculationOutput>;
  getContactById: ContactEntity;
  getContactList: Array<PAcontactOutput>;
  getContactPersonById: SaleContactEntity;
  getContactPricingList: Array<SaleContactEntity>;
  getcontra: Array<ContraEntity>;
  getContractorByType: ContractorListByType;
  getContractUnitDetails: UnitDetailsOutput;
  getCountry: Array<CountryMasterDataOutput>;
  getCountryCodeById: CountryCodeEntity;
  getCountryCodeListing?: Maybe<Array<CountryCodeOutput>>;
  getCountryStateCity: Array<SCountryEntity>;
  getCountStatusBooking?: Maybe<Array<CountStatusBookingOutput>>;
  getCreditCardTypeDesc: Scalars['JSONObject'];
  getCreditTerms?: Maybe<Scalars['Float']>;
  getCurrentBuyerDetails?: Maybe<Array<SaleEntity>>;
  getDailySalesAnalysisCount?: Maybe<Array<DailyChartCount>>;
  getDashboardNews: Array<NewsAnnouncementEntity>;
  getDateByScheduleId: ProjectKeySummaryOutput;
  getDaysOfAppointment?: Maybe<Array<Scalars['DateTime']>>;
  getDefaultAppointmentStartEndTime: AppointmentSchedulingEntity;
  getDesignationById: ParameterEntity;
  getDeveloperRedemptionUnitList: Array<RedemptionUnitsSelection>;
  getDirectionById: DirectionEntity;
  getDiscountAssigmentByProjectId?: Maybe<Array<DiscountEntity>>;
  getDiscountAssignedByProjectId: Array<DiscountEntity>;
  getDiscountBasedOnId: DiscountEntity;
  getDiscountById: DiscountEntity;
  getDiscountListByProjectId: Array<DiscountEntity>;
  getDiscountTypeById: DiscountTypeEntity;
  GetDistinctBlockByProjectId: Array<DistinctBlockByProjectOutput>;
  GetDistinctFloorByProjectId: Array<DistinctFloorByProjectOutput>;
  GetDistinctUnitByProjectId: Array<DistinctUnitByProjectOutput>;
  getDistrictbyCity: Array<CityMasterDataOutput>;
  getDocumentNumberDetailType: Scalars['JSONObject'];
  getDocumentNumberHeaderListing: Array<CompanyNumberingStructureListingOutput>;
  getDocumentNumberHeaderType: Scalars['JSONObject'];
  getDocumentType?: Maybe<DocumentNumberHeaderEntity>;
  getDownpaymentReminderById?: Maybe<DownpaymentReminderDetailOutput>;
  getEditUser: UserEntity;
  getEducationById: ParameterEntity;
  getEndFinancierDetails: Array<EndfinProjectFinancierEntity>;
  getEndFinancierForLoanApproval: Array<EndFinancierOutput>;
  getEndFinSolicitorFormSource: Array<LoanSettlementEndFinOutput>;
  getEventByDate: Array<EventOutput>;
  getEventById: EventsEntity;
  getEventPerformanceByCampaignId?: Maybe<Array<EventPerformanceBiOutput>>;
  getEventsDetails: EventsEntity;
  getEventsListByCampaign?: Maybe<CampaignEntity>;
  getExchangeById: CurrencyExchangeOutput;
  getExchangeList?: Maybe<Array<CurrencyExchangeOutput>>;
  getExchangeListByCode?: Maybe<Array<CurrencyExchangeOutput>>;
  getExportPreviewGLData?: Maybe<Array<GlExportDataOutput>>;
  getFinancialBilling: Array<FinancialBillingEntity>;
  getFinancierDetail: FinancierEntity;
  getFinancierDetailListing: Array<EndFinancierDetailListingOutput>;
  getFinancierList: Array<FinancierEntity>;
  getFinancierRedemptionUnitList: Array<RedemptionUnitsSelection>;
  GetFloorByProjectBlock: Array<FloorOutput>;
  GetFloorGalleryByProject: Array<FloorGalleryOutput>;
  GetGalleryByProject: Array<ProjectEntity>;
  GetGalleryByType: Array<ProjectEntity>;
  GetGalleryTourByProject: Array<Scalars['JSONObject']>;
  getGeneralTinByParty: EInvoiceGeneralTinEntity;
  getGeneralTinListing: Array<EInvoiceGeneralTinEntity>;
  getGLDetailByGenerationBatch?: Maybe<Array<GlExportEntity>>;
  getGLExportListing?: Maybe<Array<GlExportListingOutput>>;
  getIncomeRangeById: IncomeRangeEntity;
  getIndustryById: ParameterEntity;
  getInstallmentApprovalList?: Maybe<Array<RescheduleInstallmentOutput>>;
  getInstallmentBySaleId: SalePaymentPlanOutput;
  getInstallmentList: Array<InstallmentEntity>;
  getInstallmentPendingList: Array<GetInstallmentPendingListOutput>;
  getInstallmentsByCarParkId?: Maybe<Array<CarParkInstallmentEntity>>;
  getInstallmentsByPackageId?: Maybe<Array<PackagesInstallmentEntity>>;
  getJointBuyer: ContactEntity;
  getJointBuyerDetailsByContactId: UnitBookingPurchaserDetailsOutput;
  getKeyCollectionAppointmentById: KeyAppointmentList;
  getKeyCollectionAppointmentList?: Maybe<Array<KeyAppointmentList>>;
  getKeyCollectionContractorListbyType: Array<ProjectKeyCollectionContractorEntity>;
  getKeyCollectionContractorType: Scalars['JSONObject'];
  getLandDepositBySale?: Maybe<SalesLandDepositOutput>;
  getLandDepositFormMasterData: Scalars['JSONObject'];
  getLandDepositFormMasterDataByProject: Scalars['JSONObject'];
  getLandDepositListingByProject?: Maybe<Array<SalesLandDepositOutput>>;
  getLateInterestById: Array<LateInterestSummaryOutput>;
  getLateInterestBySaleId: LateInterestOutput;
  getLateInterestsDetail: Array<LateInterestDetailEntity>;
  getLeadCountByProject: LeadStatusCountOutput;
  getLeadSourceById: LeadSourceEntity;
  getLeadSourceFilterList: Array<LeadSourceEntity>;
  getLeadStatus: Array<ReportingStatus>;
  getLetterTemplate?: Maybe<Array<LetterTemplateEntity>>;
  getLetterTemplateById?: Maybe<LetterTemplateEntity>;
  getLetterTemplateByStdLtrParameterId: Array<LetterTemplateEntity>;
  getLetterTemplateListing: Array<LetterTemplateEntity>;
  getListLateInterest: Array<LateListInterestOutput>;
  getLoanApplyForLoanApproval: SaleLoanInfoOutput;
  getLoanApplyUnitForLoanApproval: Array<SaleLoanUnitInfoOutput>;
  getLoanApprovalCount: LoanApprovalCountOutput;
  getLoanDifferentialCount: LoanDifferentialCountOutput;
  getLoanDifferentialListing: Array<LoanDifferentialListingOutput>;
  getLoanPaymentDetails: LoanPaymentDetailOutput;
  getLoanPaymentListing: Array<LoanPaymentListingOutput>;
  getLoanPaymentListingById: LoanPaymentListingByIdOutput;
  getLoanPaymentSummary: LoanPaymentSummaryOutput;
  getLoanReleaseListing: Array<GetLoanReleaseListingOutput>;
  getLoanReleaseNotificationELetter: ELetterOutput;
  getLoanReleaseNotificationProjectELetterListing?: Maybe<Array<ELetterProjectLetterOutput>>;
  getLoanReleases: Array<GetLoanReleaseListingOutput>;
  getLoanSettlementById: LoanSettlementDetailOutput;
  getLoanSettlementListing: Array<LoanSettlementListingOutput>;
  getLoanStatus: Array<ReportingStatus>;
  getLotStatusMovementData: LotStatusMovement;
  getManyAppointmentForDay?: Maybe<Array<AppointmentEntity>>;
  getManyAppointmentType: Array<AppointmentTypeEntity>;
  getMaritalStatusById: MaritalStatusEntity;
  getMarkUpBy: Scalars['JSONObject'];
  getMarkUpBySaleId?: Maybe<SaleEntity>;
  getMBallUnit: Array<BlockListingOutput>;
  getMiscBillingByBatchId: MiscBillingDetailByGenerationOutput;
  getMiscBillingDetails: MiscBillingListOutput;
  getMiscBillingTax: Array<MiscBillingTaxOutput>;
  getMiscBillingTaxByDocDate: Array<TaxSchemeDropdownOutput>;
  getMiscBillItem?: Maybe<Array<BillItemEntity>>;
  getMiscChargesByDate: Array<MiscChargesDropdownOutput>;
  getMonthlySalesAnalysisCount?: Maybe<Array<MonthlyChartCount>>;
  getMortgageData: Array<MortgagePlanEntity>;
  getMortgagePaymentFromMortgagePlanId: Array<MortgagePaymentOutput>;
  getMortgagePaymentFromMortgagePlanIdWithSaleLoanId: Array<MortgagePaymentOutput>;
  getMortgagePlanFromFinancierId: Array<MortgagePlanOutput>;
  getMortgagePlansList: Array<MortgagePlanEntity>;
  getMortgageRetentionFromPaymentId: Array<MortgageRetentionOutput>;
  getMotTrackingById?: Maybe<MotTrackingDetailOutput>;
  getMsicCodeListing: Array<EInvoiceMsicEntity>;
  getNewPaymentPlan: Array<SaleRefinancingNewPaymentPlanOutput>;
  getNewPBdata?: Maybe<Progress_Billing>;
  getNewsAnnouncement: NewsAnnouncementPurchaserOutput;
  getNewsDetails: NewsAnnouncementEntity;
  getNotaryById: NotaryOutput;
  getNotarySelectionList: Array<NotarySelectionOutput>;
  getNotificationHistoryDay?: Maybe<Scalars['Float']>;
  getNotificationPermission: Scalars['JSONObject'];
  getNotifications: Scalars['JSONObject'];
  getNotificationsList: Scalars['JSONObject'];
  getNupCount: NupCountOutput;
  getNupListing?: Maybe<Array<GetNupOutput>>;
  getOneAppointment: AppointmentEntity;
  getOptionList: Array<OptionListOutput>;
  getOSAmount?: Maybe<Scalars['JSON']>;
  getOtherContactById: SaleContactEntity;
  getOtherContactList: Array<SaleContactEntity>;
  getOutstandingSnP?: Maybe<OutstandingSnPOutput>;
  getOverdueAging: GetOverdueAgingOutputs;
  getOverdueInstallmentDetails: GetOverdueInstallmentDetailsOutput;
  getOverduePurchaseAccountCADetail: OverduePurchaseAccountCaDetailOutput;
  getOverduePurchaseAccountHeader: OverduePurchaserAccountDetailsOutput;
  getOverdueUserList: Array<OverdueUserListOutput>;
  getPackageFormSource: Array<PackageEntity>;
  getPackageInfo: SalePackageEntity;
  getPackageItemListing?: Maybe<Array<PaIndoPackageOutput>>;
  getPackageListing: Array<PromotionalPackageOutput>;
  getPackageOption: Array<PromotionalPackagesEntity>;
  getPAcollectionMasterData?: Maybe<PAreceiptMasterDateOutput>;
  getPAcontraById: ContraEntity;
  getPAcontraList: Array<ContraEntity>;
  getPAContraSubmittedList: Array<PaLedgerSubmmitedListingOutput>;
  getPAcontraSummary?: Maybe<PAmoduleSummary>;
  getPAcreditNoteById: CreditNoteEntity;
  getPAcreditNoteList: Array<CreditNoteEntity>;
  getPACreditNoteSubmittedList: Array<PaLedgerSubmmitedListingOutput>;
  getPAcreditNoteSummary?: Maybe<PAmoduleSummary>;
  getPAdebitNoteById: DebitNoteEntity;
  getPAdebitNoteList: Array<DebitNoteEntity>;
  getPAdebitNoteSummary?: Maybe<PAmoduleSummary>;
  getPaidByList: Array<PaidByListSelection>;
  getPaidLandDepositById?: Maybe<DepositOutput>;
  getPaidLandDepositsListingBySale: Array<PaidLandDepositsOutput>;
  getPaIndoAdditionalDetail?: Maybe<Array<PaIndoPackageDetailOutput>>;
  getPAIndoAddtionalPackages: Array<PaIndoPackageListingOutput>;
  getPAIndoContraById: ContraEntity;
  getPAIndoContraList: Array<ContraEntity>;
  getPAIndoCreditNoteById: CreditNoteEntity;
  getPAIndoCreditNoteSummary: Array<CreditNoteEntity>;
  getPAIndoDebitNoteById: DebitNoteEntity;
  getPAIndoDebitNoteSummary: Array<DebitNoteEntity>;
  getPAIndoDepositById: DepositEntity;
  getPAIndoDepositSummary: Array<DepositEntity>;
  getPAIndoLateInterestListing: Array<PaIndoLateInterestListingOutput>;
  getPAIndomiscBillingById: MiscBillingEntity;
  getPAIndoMiscBillingSummary: Array<MiscBillingEntity>;
  getPAIndoPaymentById: ReceiptEntity;
  getPAIndoPaymentSummary: Array<ReceiptEntity>;
  getPAIndoPaymentSummaryListWPagination: GetPaIndoPaymentSummaryOutput;
  getPAIndoRebateById: RebateEntity;
  getPAIndoRebateSummary: Array<RebateEntity>;
  getPAIndoRefundById: RefundEntity;
  getPAIndoRefundSummary: Array<RefundEntity>;
  getPAIndoSummary?: Maybe<PurchaserAccountIndoSummary>;
  getPAlateInterestById: LateInterestDetailEntity;
  getPAlateInterestList: Array<LateInterestDetailEntity>;
  getPAlateInterestStatus: LateInterestChargesStatus;
  getPAlateInterestSummary?: Maybe<PAmoduleSummary>;
  getPAmiscBillingById: MiscBillingEntity;
  getPAmiscBillingList: Array<MiscBillingEntity>;
  getPAMiscBillingSubmittedList: Array<PaLedgerSubmmitedListingOutput>;
  getPAmiscBillingSummary?: Maybe<PAmoduleSummary>;
  getPArebateById: RebateEntity;
  getPArebateList: Array<RebateEntity>;
  getPARebateSubmittedList: Array<PaLedgerSubmmitedListingOutput>;
  getPArebateSummary?: Maybe<PAmoduleSummary>;
  getPArefundById: RefundEntity;
  getPArefundList: Array<RefundEntity>;
  getPARefundSubmittedList: Array<PaLedgerSubmmitedListingOutput>;
  getPArefundSummary?: Maybe<PAmoduleSummary>;
  getPasswordPolicy?: Maybe<PasswordPolicyEntity>;
  getPasswordPolicyWithoutAuth?: Maybe<PasswordPolicyEntity>;
  getPAsummary?: Maybe<PurchaserAccountSummary>;
  getPaymentELetter: PaymentELetterOutput;
  getPaymentELetterTemplateListing?: Maybe<Array<PaymentEletterTemplateOutput>>;
  getPaymentFormMasterData: Scalars['JSONObject'];
  getPaymentgatewayEnum: Scalars['JSONObject'];
  getPaymentMethodData: PaymentMethodBiOutput;
  getPaymentMethodDesc: Scalars['JSONObject'];
  getPaymentPlan: Array<MortgageRetentionEntity>;
  getPaymentPlanById: PaymentPlanEntity;
  getPaymentPlanDetailById: PaymentPlanDetailEntity;
  getPaymentPlanDetails: PaymentPlanInstallmentOutput;
  getPaymentPlanDropdown: Array<ProjectPaymentPlanEntity>;
  getPaymentReminderByGenerationBatch?: Maybe<GeneratePaymentReminderOutput>;
  getPaymentReminderBySaleId: Array<PaPaymentReminderListingOutput>;
  getPaymentRemindersByGenerationBatch?: Maybe<GeneratePaymentRemindersOutput>;
  getPBdataList?: Maybe<PBdataList>;
  getPBlistBySaleIdAndType?: Maybe<Array<ProgressBillingEntity>>;
  getPBsaleProductList?: Maybe<Array<ProgressBillingEntity>>;
  getPBvoidList?: Maybe<Array<ProgressBillingEntity>>;
  getPendingInstallmentById: Array<PendingInstallmentByIdOutput>;
  getPendingRegisterUnits: Array<SaleRegistrationListingOutput>;
  getPermission: Scalars['JSONObject'];
  getPermissionKeyByRoleId: Array<Scalars['String']>;
  getPositionCodeOptionsByCompanyCommissionTeam: Array<PositionCodeOption>;
  getPostCodeByCity: Array<PostCodeMasterDataOutput>;
  getPostedLadDetailById: LadDetailOutput;
  getPostedUnitList: Array<PostedUnitListingOutput>;
  getPrecisionRounding: Scalars['String'];
  getPriceAdjustmentById?: Maybe<PriceAdjustmentDetailOutput>;
  getPriceAdjustmentList?: Maybe<Array<PriceAdjustmentListOutput>>;
  getProductConstructionById: ProjectConstructionEntity;
  getProfessionById: ParameterEntity;
  getProfileAndAccountList: CompanyBankProfileOutput;
  getProgressBilling?: Maybe<Array<ProgressBillingList2>>;
  getProgressBillingByGenerationId: Array<ProgressBillingByGenerationBatchSummary>;
  getProgressBillingById?: Maybe<ProgressBillingEntity>;
  getProgressStage: Array<ProgressStageOutput>;
  getProjectAreaVarianceByEffectiveDate?: Maybe<ProjectAreaVarianceEntity>;
  getProjectBridgingFinancierById: BridgingFinancierSharedOutput;
  getProjectById: ProjectEntity;
  getProjectClusterListing: Array<ProjectClusterEntity>;
  getProjectCommissionById: GetProjectCommissionByIdOutput;
  getProjectCommissionOptions: Array<ProjectCommissionEntity>;
  getProjectCommissionPackageListing: Scalars['JSON'];
  getProjectCommissions: Array<GetProjectCommissionsOutput>;
  getProjectCommissionTeamAgencyAppointed: Array<AgencyAppointedEntity>;
  getProjectCommissionTeamStructureListing: Scalars['JSON'];
  getProjectCreditTerm: ProjectPolicyEntity;
  getProjectDetailById: ProjectDetailOutput;
  getProjectDiscountList?: Maybe<Array<DiscountListOutput>>;
  getProjectDiscountListWithoutSaleRebate?: Maybe<Array<ProjectDiscountEntity>>;
  getProjectFireInsurance: Array<ProjectFireInsuranceEntity>;
  GetProjectGalleryByProject: Array<ProjectGalleryOutput>;
  getProjectKeyCollectionContractorById: ProjectKeyCollectionContractorEntity;
  getProjectKeyCollectionScheduleByID: Array<ProjectKeyCollectionSettingOutput>;
  getProjectLadByProjectId?: Maybe<ProjectLadEntity>;
  getProjectLateInterestById?: Maybe<ProjectLateInterestEntity>;
  getProjectLetterTemplate?: Maybe<Array<ProjectLetterTemplateOutput>>;
  getProjectLetterTemplateById: ProjectLetterTemplateEntity;
  getProjectLetterTemplateListing: Array<ProjectLetterTemplateEntity>;
  getProjectLoanFinancier: Array<LoanFinancierDetail>;
  getProjectMiscChargesById: ProjectMiscChargesEntity;
  getProjectName?: Maybe<Scalars['String']>;
  getProjectPaymentPlan: Array<ProjectPaymentPlanEntity>;
  getProjectPaymentReminderExceptionById: PaymentExceptionReminderOutput;
  getProjectPaymentWithReminder: Array<PaymentWithReminderOutput>;
  getProjectPermitById: ProjectPermitEntity;
  getProjectPermitType: Scalars['JSONObject'];
  getProjectPolicy?: Maybe<ProjectPolicyEntity>;
  getProjectReminderSetting?: Maybe<ProjectReminderEntity>;
  getProjectSalesOffice?: Maybe<ProjectSalesOfficeEntity>;
  getProjectSalesPolicyByProjectId?: Maybe<ProjectSalesPolicyOutput>;
  getProjectSalesPolicyEnumOutput: ProjectSalesPolicyEnumsOutput;
  getProjectSetupInfoLine: Scalars['JSON'];
  GetProjectSpecByProjectId: ProjectSpecEntity;
  getProjectTitleById: ProjectTitleEntity;
  getProjectTypeById: ProjectTypeEntity;
  getProjectUserRole?: Maybe<Array<ProjectRoleUserListingOutput>>;
  getPromotionalItem: Array<PromotionalItemOutput>;
  getPromotionalItemListing?: Maybe<Array<PromotionalItemEntity>>;
  getPromotionalPackagesByProjectId: PromotionalPackagesEntity;
  getPromotionalPackagesItemDetailsListing?: Maybe<Array<PromotionalPackagesItemsDetailsOutput>>;
  getPromotionalPackagesListing?: Maybe<Array<PromotionalPackagesOutput>>;
  getPropertyTax: Array<TaxEntity>;
  getPropertyTaxByInput: Array<TaxEntity>;
  getPropertyTitleType: Scalars['JSONObject'];
  getPropertyTypeExt: Array<PropertyTypeExtEntity>;
  getPropertyTypeList: Array<PropertyTypeEntity>;
  getPurchaserAccListing?: Maybe<Array<PurchaserAccListing>>;
  getPurchaserData?: Maybe<PurchaserDataOutput>;
  getPurchaserDetail?: Maybe<PurchaserAccDetail>;
  getPurchaserDetailsByContactId: UnitBookingPurchaserDetailsOutput;
  getPurchaserIDTypeListing: Array<PurchaserIdTypeEntity>;
  getPurchaserInfo: ContactEntity;
  getPurchaserInfoListing: Array<PurchaserListingOutput>;
  getPurchaserInstallment?: Maybe<Array<InstallmentEntity>>;
  getPurchaserInstallmentListing?: Maybe<Array<PaIndoPurchaserInstallmentListingOutput>>;
  getPurchaserNameById: GetPurchaserNameByIdOutput;
  getPurchaserPaymentListing?: Maybe<Array<PurchaserPaymentPlanOutput>>;
  getPurchaserPaymentPlanById: PurchaserPaymentPlanEntity;
  getPurchaserPaymentPlanDetail?: Maybe<PurchaserPaymentPlanDetailsEntity>;
  getPurchaserPaymentPlanDetailsListing?: Maybe<Array<PurchaserPaymentPlanDetailsOutput>>;
  getPurchaserPaymentPlanEnumsOutput: PurchaserPaymentPlanEnumsOutput;
  getPurchaserPaymentSchedule?: Maybe<Array<PurchaserPaymentScheduleOutput>>;
  getPurchaserRedemptionUnitList: Array<RedemptionUnitsSelection>;
  getPurchaserTransferList: Array<PurchaserTransferOutput>;
  getRaceById: RaceEntity;
  getReasonCodeById: ReasonCodeEntity;
  getReasonCodeTypeListing: Array<ReasonCodeTypeListingOutput>;
  getReasonList: Array<ReasonCodeEntity>;
  getReceiptBillingByGenerationBatchId: FinancierPaymentBillingOutput;
  getReceiptById: ReceiptOutput;
  getRedemptionPaymentParty: Array<PaymentPartySelection>;
  getRedemptionRepaymentById: RedemptionRepaymentByIdOutput;
  getRedemptionUnitSelection: Array<RedemptionUnitsSelection>;
  getRefinancingById: RefinancingDetailOutput;
  getRefinancingDetailsById: RefinancingListOutput;
  getRefinancingMasterData: RefinancingDataOutput;
  getRefinancingSingleDetailById: FinancierListOutput;
  getRefinancingUnit?: Maybe<Array<RefinancingUnitDropDownOutput>>;
  getRefundAllocation?: Maybe<Array<RefundAllocationOutput>>;
  getRelationshipById: ParameterEntity;
  getReligionById: ParameterEntity;
  getRemainingSubscriptionDays: Scalars['Float'];
  getRescheduleDetails: Array<GetRescheduleDetailsOutput>;
  getRescheduleInstallment?: Maybe<Array<RescheduleInstallmentOutput>>;
  getRescheduleLoan: GetRescheduleLoanOutput;
  getRetentionFormMasterData: Scalars['JSONObject'];
  getRoleById: RoleEntity;
  getRoles: Array<RoleEntity>;
  getRounding: RoundingOutput;
  getSaleCancelReason: Array<ReasonCodeEntity>;
  getSaleContactList?: Maybe<Array<ContactEntity>>;
  getSaleContractSubProductById: SaleSubproductEntity;
  getSaleLoanBuyBackCount: SaleLoanBuyBackCountOutput;
  getSaleLoanByGenerationId: SaleLoanDetailOutput;
  getSaleLoanCancellationById?: Maybe<GetSaleLoanCancellationDetailOutput>;
  getSaleLoanCancellationDropdown?: Maybe<Array<GetSaleLoanCancellationDropdownOutput>>;
  getSaleLoanCancellationListing?: Maybe<Array<GetSaleLoanListingOutput>>;
  getSaleLoanCancelReason: Array<ReasonCodeEntity>;
  getSaleLoanDetails: GetSaleLoanDetailOutput;
  getSaleLoanForIndo: SaleLoanOutputForIndo;
  getSaleLoanInfoBasedOnSaleLoanId: SalePaymentPlanOutputForViewOnly;
  getSaleLoanListing?: Maybe<Array<SaleLoanListingOutput>>;
  getSaleLoanListingForIndo: Array<SaleLoanListingOutputForIndo>;
  getSaleLoanReleaseCount: SaleLoanReleaseCountOutput;
  getSaleLoanTableListing: Array<GetSaleLoanTableListingOutput>;
  getSaleLoanUnit: Array<SaleLoanOutput>;
  getSaleRefinancingCount: SaleRefinancingCountOutput;
  getSalesAgeBI: Array<PurchaserDemographicBiOutput>;
  getSalesAnalysisCount?: Maybe<SalesAnalysisOutput>;
  getSalesCancellationById: SaleCancellationSharedOutput;
  getSalesCancellationCount: SaleCancellationCountOutput;
  getSalesCancellationELetter: SalesELetterOutput;
  getSalesCancellationELetterTemplateListing?: Maybe<Array<SalesCancellationEletterTemplateOutput>>;
  getSalesCancellationList: Array<SaleCancellationSharedOutput>;
  getSalesCancellationStatus: Array<Scalars['String']>;
  GetSalesChartByBlock: SalesChartFloorUnitOutput;
  GetSalesChartData?: Maybe<ProjectEntity>;
  getSalesContractAttachments: SaleEntity;
  getSalesContractById: SaleEntity;
  getSalesContractCreditTerm?: Maybe<SaleExtensionEntity>;
  getSalesContractDetailData: SalesContractDetailOutput;
  getSalesContractList: Array<SaleEntity>;
  getSalesContractListingData: SalesContractListingOutput;
  getSalesContractPackageById: SalePackageEntity;
  getSalesDiscountById: SaleDiscountEntity;
  getSalesDiscountList?: Maybe<Array<SaleDiscountEntity>>;
  getSalesDiscountListing: Array<SalesDiscountListingOutput>;
  getSalesFromSignedUnit: Array<SignedUnitListingOutput>;
  getSalesInformation?: Maybe<SaleInformation>;
  getSalesJointBuyerIncomeRange: Array<PurchaserDemographicBiOutput>;
  getSalesLoanBuyBackDetails?: Maybe<SaleLoanBuyBackListOutput>;
  getSalesLoanBuyBackList?: Maybe<Array<SaleLoanBuyBackListOutput>>;
  getSalesLoanRefinancingList?: Maybe<Array<RefinancingListOutput>>;
  getSalesMovementData: SalesStatisticMovement;
  getSalesPackageById: PackageEntity;
  getSalesPackageList?: Maybe<Array<SalePackageListingOutput>>;
  getSalesPackagesList: Array<PackageEntity>;
  getSalesPerformanceStatus: Array<ReportingStatus>;
  getSalesPerson?: Maybe<Array<SUserEntity>>;
  getSalesPurchaserIncomeRange: Array<PurchaserDemographicBiOutput>;
  getSalesRaceBI: Array<PurchaserDemographicBiOutput>;
  getSalesRebatePackage?: Maybe<Array<SaleRebateListingOutput>>;
  getSalesRebatePackageById: SaleRebatePackageEntity;
  getSalesRegistrationCount: SalesRegistrationCountOutput;
  getSalesRegistrationDiscountById: SalesDiscountDetailOutput;
  getSalesRegistrationELetter: SalesRegistrationELetterOutput;
  getSalesRegistrationELetterTemplateListing?: Maybe<Array<SalesRegistrationEletterTemplateOutput>>;
  getSalesRegistrationList: Array<SaleRegistrationListingOutput>;
  getSalesRegistrationsMasterData: Scalars['JSONObject'];
  getSalesTeam: Array<TeamDetail>;
  getSalesTeamBI?: Maybe<SaleTeamPerformanceOutput>;
  getSalesTeamByProject: Array<SaleTeamEntity>;
  getSalesTeamStatus: Array<ReportingStatus>;
  getSaleSubProductList: Array<SaleSubProductListingOutput>;
  getSalutationById: SalutationEntity;
  getSCAdata?: Maybe<Scalars['String']>;
  getSelectedCarParkPaymentPlan?: Maybe<Array<CarParkPaymentPlanOutput>>;
  getSelectedPackagePaymentPlan?: Maybe<Array<PackagePaymentPlanOutput>>;
  getSelectUnitAtPriceAdjustment: Array<ProjectTitleBlockListingOutput>;
  getSellingMethodType: Array<SellingMethodSelection>;
  getSimulatedLadDetailById: LadSimulatedDetailOutput;
  getSolicitorAppointedList: Array<SolicitorAppointedEntity>;
  getSolicitorList: Array<SolicitorEntity>;
  getSolicitorSignedInfo: SignedDetailsOutput;
  getSpaReminderById?: Maybe<SaleReminderDetailOutput>;
  getStakeholderAvailableDeemCollectedUnit?: Maybe<Array<StakeholderAvailableDeemCollectedUnit>>;
  getStakeholderDeemCollectedDetail?: Maybe<StakeholderDeemCollectedDetail>;
  getStakeholderDeemCollectedListing?: Maybe<Array<StakeholderProcessDeemCollected>>;
  getStakeholderProcessBySolicitorId?: Maybe<StakeholderProcess>;
  getStakeholderProcessListing?: Maybe<Array<StakeholderProcess>>;
  getStakeholderReleaseDetail?: Maybe<StakeholderReleaseDetail>;
  getStakeholderReleaseListing?: Maybe<Array<StakeholderProcessRelease>>;
  getStakeholderReleaseUnit?: Maybe<Array<StakeholderAvailableReleaseUnit>>;
  getStakeholderUnitDetail?: Maybe<Array<StakeholderUnitDetail>>;
  getStakeholderUnitSummaryBySolicitorId?: Maybe<Array<StakeholderUnitSummary>>;
  getStampDutyAttachment?: Maybe<Array<StampDutyAttachmentOutput>>;
  getStampDutyById: StampDutyEntity;
  getStampDutyIntegration?: Maybe<StampDutyIntegrationOutput>;
  getStampDutyIntegrationListing?: Maybe<Array<StampDutyIntegrationListingOutput>>;
  getStampDutyListing: Array<StampDutyEntity>;
  getStampDutyOptions?: Maybe<Array<StampDutyOptionOutput>>;
  getStandardLetter: Array<StandardLetterEntity>;
  getStandardLetterByCategory?: Maybe<Array<StandardLetterCategoryOutput>>;
  getStandardLetterParameter: Array<StandardLetterParameterEntity>;
  getStandardLetterParameterById: StandardLetterParameterEntity;
  getState: Array<SCountryEntity>;
  getStateByCountry: Array<StateMasterDataOutput>;
  getStatutoryDocsList?: Maybe<Array<StatutoryDocumentEntity>>;
  getStatutoryTypeByUnit: Array<StatutoryTypeListByUnitOutput>;
  getStatutoryUnitList?: Maybe<Array<UnitStatutoryListByUnitSelectionOutput>>;
  getSubsaleById?: Maybe<SubsaleEntity>;
  getSubsaleContactList?: Maybe<Array<ContactEntity>>;
  getSubsaleJointBuyerById?: Maybe<SubsaleJointBuyerEntity>;
  getSubsaleLoanById?: Maybe<SubsaleLoanEntity>;
  getSubsaleUnit?: Maybe<Array<UnitDetailOutput>>;
  getSubsaleUnitDetail?: Maybe<UnitDetailOutput>;
  getSummarySaleContract: SaleContractMenuSummaryOutput;
  getSuserListForProjectSpec: Array<UserEntity>;
  getTaxById: TaxEntity;
  getTaxListing?: Maybe<Array<TaxListingOutput>>;
  getTaxRate: Scalars['Float'];
  getTaxSchemeById?: Maybe<TaxSchemeEntity>;
  getTaxSchemeInputListing: Array<TaxSchemeDropdownOutput>;
  getTaxSchemeLateInterest: Array<TaxSchemeDropdownOutput>;
  getTaxSchemeList?: Maybe<Array<TaxListOutput>>;
  getTaxSchemeListing: Array<TaxSchemeListingOutput>;
  getTaxSchemeOutputListing: Array<TaxSchemeDropdownOutput>;
  getTaxSchemeTax: Array<TaxDropdownOutput>;
  getTaxSchemeTypeID?: Maybe<Array<TaxSchemeTypeEntity>>;
  getTeam?: Maybe<Array<SalesTeamOutput>>;
  getTeamBI: SaleTeamPerformanceOutput;
  getTeams?: Maybe<Array<SaleTeamEntity>>;
  getTempPAlateInterestList: Array<LateInterestList>;
  getTimeSlotByDate?: Maybe<ScheduleDetail>;
  getTotalPermission: Scalars['Float'];
  getTotalPricePromotionalPackages: PromotionalPackagesItemEntity;
  getTownship: Array<TownshipEntity>;
  getTransactionCodeListing: Array<TaxTransactionCodeEntity>;
  getUnassignedClassificationBillItems: Array<BillItemEntity>;
  getUnassignedMsicBillItems: Array<BillItemEntity>;
  getUnassignedNotaryList: Array<UnassignedNotaryOutput>;
  getUnassignedStaffList?: Maybe<Array<AuthorizedStaffListingOutput>>;
  getUnassignedTeamMembers: Array<UserEntity>;
  getUnitAndContactList?: Maybe<Array<UnitAndContactListOutput>>;
  getUnitAtAreaVariance: AreaVarianceUnitOutput;
  getUnitBookingDetails: UnitBookingDetailsOutput;
  getUnitBookingDetailsBySaleId: SaleDetailsOutput;
  getUnitBookingListingSale?: Maybe<Array<UnitBookingListingOutput>>;
  getUnitByID: UnitEntity;
  GetUnitByProjectBlock: Array<UnitEntity>;
  getUnitByStatus?: Maybe<Array<UnitByStatusOutput>>;
  getUnitByUnitId?: Maybe<UnitByStatusOutput>;
  GetUnitDetail: UnitEntity;
  GetUnitDetails: UnitEntity;
  getUnitForPaymentPlanDetails: Array<SaleLoanPaymentPlanDetailsOutput>;
  GetUnitGalleryByProject: Array<UnitGalleryOutput>;
  getUnitInfo: UnitInfoOutput;
  getUnitIsSubProductByProjectId: Array<UnitEntity>;
  getUnitLayoutBlockByProjectId: Array<UnitLayoutBlockOutput>;
  getUnitList: Array<PAunitOutput>;
  getUnitListAtAreaVariance: Array<AreaVarianceUnitOutput>;
  getUnitListTransfer: Array<UnitListOutput>;
  getUnitMasterData: UnitMasterDataOutput;
  getUnitNoPrefix: Array<Scalars['String']>;
  getUnitOfMeasurements: Array<UnitOfMeasurementEntity>;
  getUnitPropertyTitleCreate: Array<ProjectTitleBlockListingOutput>;
  getUnitPropertyTitleList: Array<ProjectTitleBlockListingOutput>;
  getUnitsForKeyCollection?: Maybe<Array<KeyCollectionUnitList>>;
  getUnitsForSalesCancel: Array<UnitsSignedOutput>;
  getUnitsLadFormSource: Array<BlockListingOutput>;
  getUnitStatutoryDocsList: Array<UnitStatutoryDocumentOutput>;
  getUnitStatutoryDocumentListByType?: Maybe<Array<UnitStatutoryListObject>>;
  getUnitsVpFormSource: Array<BlockListingOutput>;
  getUnitsVpLetterByDate: Array<BlockListingOutput>;
  getUnitTransferById?: Maybe<UnitTransferDetailOutput>;
  getUnitTransferDropdown?: Maybe<Array<UnitTransferDropdownOutput>>;
  getUnitTransferIndoById?: Maybe<UnitTransferIndoByUnitIdOutput>;
  getUnitTransferIndoCount: UnitTransferIndoCountOutput;
  getUnitTransferIndoDetails: UnitTransferIndoDetails;
  getUnitTransferIndoList?: Maybe<Array<UnitTransferIndoOutput>>;
  getUnitTransferIndoMasterData: UnitTransferIndoMasterDataOutput;
  getUnitTransferListing?: Maybe<Array<UnitTransferDetailOutput>>;
  getUnitTransferPaymentPlanDetails: PaymentPlanInstallmentOutput;
  getUnitTransferPricingPaymentPlanDetails: Array<GetUnitTransferPricingPaymentPlanOutput>;
  getUnitTransferReason: Array<ReasonCodeEntity>;
  getUnitType: Array<UnitTypeDetail>;
  getUnitTypeById: UnitTypeEntity;
  getUnitTypeList: Array<UnitTypeEntity>;
  getUnitTypeSAByUnitType?: Maybe<Array<UnitTypeCountByStatusOutput>>;
  getUnitWorkProgressCreate: Array<BlockListingOutput>;
  getUnitWorkProgressUpdate: Array<BlockListingOutput>;
  getUserDetails: UserEntity;
  getUserNotificationPermission?: Maybe<Array<Scalars['String']>>;
  getUserRole?: Maybe<Scalars['String']>;
  getUserRoleIds: Scalars['JSON'];
  getUsersRoleProject: Scalars['JSON'];
  GetVideoGalleryByProject: Array<Scalars['JSONObject']>;
  getVpLetter: Array<UnitExtensionEntity>;
  getVPviewUnit: Array<UnitEntity>;
  getWaitListByDirection?: Maybe<Array<WaitingListByDirection>>;
  getWaitListByView?: Maybe<Array<WaitingListByView>>;
  getWaitListDetailsByDirectionId: Array<WaitingListTableOutput>;
  getWaitListDetailsByView: Array<WaitingListTableOutput>;
  getWeeklySalesAnalysisCount?: Maybe<Array<WeeklyChartCount>>;
  getWorkProgressById: WorkProgressEntity;
  getWorkProgressBySale?: Maybe<Array<WorkProgressEntity>>;
  glAccountCode: Array<AccountMappingListProps>;
  glEndFinancierList: Array<EndFinancierDataOutput>;
  hasTeam: Scalars['Boolean'];
  importExcel: UnitExcelReturnOutput;
  ImportUnitOptions: UnitImportOptionOutput;
  incomeRangeCount?: Maybe<Scalars['Float']>;
  industryCount?: Maybe<Scalars['Float']>;
  isAllowAddUser: Scalars['Boolean'];
  isCanEditOrDeleteCommisionType: Scalars['Boolean'];
  isCodeExist: Scalars['Boolean'];
  isEmailExist: Scalars['Boolean'];
  isEndFinEmailExist: Scalars['Boolean'];
  isIntegratedProject?: Maybe<Scalars['Boolean']>;
  isMortgagePaymentExist: Scalars['Boolean'];
  isMortgagePlanExist: Scalars['Boolean'];
  isMortgageRetentionExist: Scalars['Boolean'];
  isSolicitorExist: Scalars['Boolean'];
  isUserNameExist: Scalars['Boolean'];
  keyCollectionAppointmentLastUpdate?: Maybe<Scalars['DateTime']>;
  keyCollectionContractorLastUpdate?: Maybe<Scalars['DateTime']>;
  keyCollectionCount?: Maybe<KeyCollectionSummaryOutput>;
  keyCollectionScheduleLastUpdate?: Maybe<Scalars['DateTime']>;
  ladProcessingCount?: Maybe<Scalars['Float']>;
  ladSettingLastUpdate?: Maybe<Scalars['DateTime']>;
  ladSummary?: Maybe<LadSummaryOutput>;
  latePaymentInterestExceptionLastUpdate?: Maybe<Scalars['DateTime']>;
  latePaymentInterestGenerationLastUpdate?: Maybe<Scalars['DateTime']>;
  latePaymentInterestLastUpdated?: Maybe<LateInterestSummaryInfoOutput>;
  leadChannelCount?: Maybe<Scalars['Float']>;
  loanAcceptanceRate?: Maybe<Array<LoanAcceptanceRateOutput>>;
  loanCancellationSummary?: Maybe<SaleLoanCancellationInfoLine>;
  loanSettlementUnitFormSource: Array<LoanSettlementUnitOutput>;
  logout: Scalars['Boolean'];
  logoutWithMicrosoft: Scalars['Boolean'];
  maritalStatusCount?: Maybe<Scalars['Float']>;
  markAllRead: Scalars['Boolean'];
  miscBillingLastUpdate?: Maybe<Scalars['DateTime']>;
  motTrackingCount?: Maybe<Scalars['Float']>;
  msicCodeCount?: Maybe<Scalars['Float']>;
  notaryAssignmentLastUpdate?: Maybe<Scalars['DateTime']>;
  notaryCount?: Maybe<Scalars['Float']>;
  NotificationDispatcher: Scalars['Boolean'];
  overduePurchaserAccountCAListing?: Maybe<OverduePurchaseCaOutput>;
  overduePurchaserAccountListing: OverduePurchaserAccountListingOutput;
  overduePurchaserAccountSummary: OverduePurchaserAccountSummaryOutput;
  panelByProject: Array<EndfinProjectFinancierEntity>;
  panelDetails: FinancierPanelDetails;
  panelEndFinCount?: Maybe<Scalars['Float']>;
  panelFinancierList: Array<FinancierEntity>;
  panelSolicitorCount?: Maybe<Scalars['Float']>;
  passswordPolicy: PassswordPolicyOuput;
  passwordPolicyLastUpdate?: Maybe<Scalars['DateTime']>;
  paymentGatewayDetails: PaymentGatewayEntity;
  paymentGatewayListing: Array<PaymentGatewayEntity>;
  paymentInterestExceptionCount?: Maybe<Scalars['Float']>;
  paymentPlanCount?: Maybe<Scalars['Float']>;
  paymentReminderCount?: Maybe<Scalars['Float']>;
  paymentReminderLastUpdate?: Maybe<Scalars['DateTime']>;
  priceAdjustmentSummary?: Maybe<SummaryOutput>;
  professionCount?: Maybe<Scalars['Float']>;
  profile: UserEntity;
  progressBillingLastUpdate?: Maybe<Scalars['DateTime']>;
  progressBillingListForGenerate?: Maybe<Array<ProgressBillingSummary>>;
  progressMiscBillingLastUpdate?: Maybe<Scalars['DateTime']>;
  projectCampaignCount?: Maybe<Scalars['Float']>;
  projectClusterNameExist: Scalars['Boolean'];
  projectCommissionDate?: Maybe<Scalars['DateTime']>;
  projectCommissionPackageDate?: Maybe<Scalars['DateTime']>;
  projectCommissionTeamStructureDate?: Maybe<Scalars['DateTime']>;
  projectDetail: ProjectEntity;
  projectLadLastUpdate?: Maybe<Scalars['DateTime']>;
  projectLastUpdate?: Maybe<Scalars['DateTime']>;
  projectLetterLastUpdate?: Maybe<Scalars['DateTime']>;
  projectPaymentPlanCount?: Maybe<Scalars['Float']>;
  projectPaymentPlanLastUpdate?: Maybe<Scalars['DateTime']>;
  projectReminderLastUpdate?: Maybe<Scalars['DateTime']>;
  projectReminderSettingLastUpdate?: Maybe<Scalars['DateTime']>;
  projectSalesBusinessInsightData?: Maybe<ProjectEntity>;
  projectSalesPolicyLastUpdate?: Maybe<Scalars['DateTime']>;
  projectTypeCount?: Maybe<Scalars['Float']>;
  promotionalPackagesLastUpdate?: Maybe<Scalars['DateTime']>;
  propertyTitleUnitCount?: Maybe<Scalars['Float']>;
  propertyTypeCount?: Maybe<Scalars['Float']>;
  purchaserAccountsCount?: Maybe<Scalars['Float']>;
  purchaserIDTypeCount?: Maybe<Scalars['Float']>;
  purchaserPaymentPlanCount?: Maybe<Scalars['Float']>;
  raceCount?: Maybe<Scalars['Float']>;
  reasonCodeCount?: Maybe<Scalars['Float']>;
  reCalculateTotalSaleDiscount?: Maybe<Scalars['Float']>;
  redemptionRepaymentLastUpdate?: Maybe<Scalars['DateTime']>;
  redemptionRepaymentTotalAmount?: Maybe<Scalars['Float']>;
  refinancingInfoline?: Maybe<RefinancingInfolineOutput>;
  refreshToken: Scalars['String'];
  relationshipCount?: Maybe<Scalars['Float']>;
  religonCount?: Maybe<Scalars['Float']>;
  rescheduleInstallmentLastUpdate?: Maybe<Scalars['DateTime']>;
  rescheduleInstallmentSubmittedCount?: Maybe<Scalars['Float']>;
  reversalArchCertUnitListing: Array<ReversalUnitListingOutput>;
  roleAuthLastUpdate?: Maybe<Scalars['DateTime']>;
  roleLastUpdate?: Maybe<Scalars['DateTime']>;
  saleCancellationSummary?: Maybe<SaleCancellationInfoLine>;
  saleContractSummary?: Maybe<SaleContractInfoLine>;
  saleLandDepositSummary?: Maybe<SaleLandDepositInfoLine>;
  salesLoanBuyBackMasterData: BuyBackDataOutput;
  salesLoanBuyBackMasterDataDetails: BuyBackDataOutput;
  salesOfficeLastUpdate?: Maybe<Scalars['DateTime']>;
  salesPackagesCount?: Maybe<Scalars['Float']>;
  salesTestPermission: Scalars['String'];
  salutationCount?: Maybe<Scalars['Float']>;
  solicitorAppointedDetails: SolicitorAppointedEntity;
  solicitorAppointedList: Array<SolicitorAppointedEntity>;
  solicitorDetails?: Maybe<SolicitorAppointedEntity>;
  solicitorListForAssignment: Array<SolicitorAppointedEntity>;
  spReminderCount?: Maybe<Scalars['Float']>;
  stakeholderCount?: Maybe<StakeholderSummaryOutput>;
  stampDutyCount?: Maybe<Scalars['Float']>;
  stampDutyIntegrationLastUpdate?: Maybe<Scalars['DateTime']>;
  standardELetteringTemplateDate?: Maybe<Scalars['DateTime']>;
  standardMiscChargesLastUpdate?: Maybe<Scalars['DateTime']>;
  standardParameterDate?: Maybe<Scalars['DateTime']>;
  statutoryDocsDate?: Maybe<Scalars['DateTime']>;
  subsaleCount?: Maybe<Scalars['Float']>;
  taxSchemeTotalCount?: Maybe<Scalars['Float']>;
  taxSetupCount?: Maybe<Scalars['Float']>;
  taxTransactionCodeCount?: Maybe<Scalars['Float']>;
  teamAssignmentLastUpdate?: Maybe<Scalars['DateTime']>;
  testGetMostRecentPurchases: Array<CollectionActivityListingOutput>;
  testOutputMostRecentCollectionActivity?: Maybe<Array<CollectionActivityListingOutput>>;
  todoList: TodoListOutput;
  totalBridgingFinancing?: Maybe<Scalars['Float']>;
  totalFinancialLimit?: Maybe<Scalars['Float']>;
  totalLoanAppliedAmount?: Maybe<Scalars['Float']>;
  totalLoanAppliedCount?: Maybe<Scalars['Float']>;
  totalLoanApprovedCount?: Maybe<Scalars['Float']>;
  totalLoanSettledCount?: Maybe<Scalars['Float']>;
  totalMotUnitCount?: Maybe<Scalars['Float']>;
  totalPropertyTitleUnitCount?: Maybe<Scalars['Float']>;
  totalRedemption?: Maybe<Scalars['Float']>;
  totalRefinancingCount?: Maybe<Scalars['Float']>;
  townshipListing?: Maybe<CompanyEntity>;
  unitCount?: Maybe<Scalars['Float']>;
  unitDirectionCount?: Maybe<Scalars['Float']>;
  unitOfMeasurementCount?: Maybe<Scalars['Float']>;
  unitStatutoryDocumentCount?: Maybe<Scalars['Float']>;
  unitsVpLetterCount?: Maybe<Scalars['Float']>;
  unitTransferSummary?: Maybe<UnitTransferInfoLine>;
  unitTypeCount?: Maybe<Scalars['Float']>;
  unReadNotificationCount?: Maybe<Scalars['Float']>;
  UpdateSalesChart: Scalars['Boolean'];
  uploadStatutoryDocumentList: UploadStatutoryReturnOutput;
  userLastUpdate?: Maybe<Scalars['DateTime']>;
  userListing: Array<UserEntity>;
  waitingListCountBI: WaitingListBiCount;
  waitingListTableBI?: Maybe<Array<WaitingListTableOutput>>;
  waitingListUnitSAByUnitType?: Maybe<Array<WaitingListByUnitTypeOutput>>;
  waitingListUnitTypeBI?: Maybe<Array<WaitingListByUnitTypeOutput>>;
};


export type QueryAllProjectArgs = {
  limit: Scalars['Float'];
  page: Scalars['Float'];
  search?: InputMaybe<Scalars['String']>;
};


export type QueryAllProjectInvolveArgs = {
  limit: Scalars['Float'];
  page: Scalars['Float'];
  search?: InputMaybe<Scalars['String']>;
};


export type QueryAssignedDiscountCountArgs = {
  projectId: Scalars['String'];
};


export type QueryBankProfileListingArgs = {
  companyId: Scalars['String'];
};


export type QueryBusinessPermitLastUpdateArgs = {
  projectId: Scalars['String'];
};


export type QueryCalculateBridgingValueArgs = {
  input: CalculateBridgingExeValueInput;
};


export type QueryCalculateDiscountAmountArgs = {
  input: CalculateDiscountAmountInput;
};


export type QueryCalculateLadGenerateValueArgs = {
  input: CalculateLadGenerateValueInput;
};


export type QueryCalculateMiscBillingTaxAmountArgs = {
  input: CalculateMiscBillingTaxAmountInput;
};


export type QueryCalculateSaleDiscountAmountArgs = {
  input: CalculateSalesDiscountInput;
};


export type QueryCalculateSalesRegDiscountArgs = {
  input: CalculateSalesRegDiscountInput;
};


export type QueryCalculateTaxAmountArgs = {
  input: CalculateTaxAmountInput;
};


export type QueryCarParkCountArgs = {
  projectId: Scalars['String'];
};


export type QueryCompanyDetailArgs = {
  id: Scalars['String'];
};


export type QueryCompanyEditListArgs = {
  companyId: Scalars['String'];
};


export type QueryCompanyListingArgs = {
  companyId?: InputMaybe<Scalars['String']>;
};


export type QueryConstructionInfoLastUpdateArgs = {
  projectId: Scalars['String'];
};


export type QueryDownloadStatutoryDocumentListArgs = {
  projectId: Scalars['String'];
};


export type QueryExportBookingListAnalysisArgs = {
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
};


export type QueryExportCampaignPerformanceArgs = {
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
};


export type QueryExportExcelArgs = {
  exportType: Scalars['String'];
  projectId: Scalars['String'];
};


export type QueryExportGlJournalArgs = {
  companyId: Scalars['String'];
  generationBatch: Scalars['String'];
};


export type QueryExportLoanAndFinancingArgs = {
  endDate: Scalars['DateTime'];
  financier: Scalars['String'];
  startDate: Scalars['DateTime'];
  status: Scalars['String'];
};


export type QueryExportLotStatusMovementArgs = {
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
  status: Scalars['String'];
};


export type QueryExportOutstandingSpArgs = {
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
};


export type QueryExportSalesAnalysisArgs = {
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
  status: Scalars['String'];
};


export type QueryExportSalesAnalysisByUnitArgs = {
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
  status: Scalars['String'];
};


export type QueryExportSalesDemographicAnalysisArgs = {
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
};


export type QueryExportSalesLeadPerformanceArgs = {
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
  status: Scalars['String'];
};


export type QueryExportSalesMovementArgs = {
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
  status: Scalars['String'];
};


export type QueryExportSalesPerformanceArgs = {
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
  status: Scalars['String'];
};


export type QueryExportTeamPerformanceArgs = {
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
};


export type QueryExportTrackingOfPaymentMethodArgs = {
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
};


export type QueryExportWaitListByUnitTypeArgs = {
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
  unitType: Scalars['String'];
};


export type QueryFireInsuranceLastUpdateArgs = {
  projectId: Scalars['String'];
};


export type QueryFormatCastNumberArgs = {
  amount: Scalars['Float'];
};


export type QueryGeneratePaymentReminderListArgs = {
  reminderDate: Scalars['DateTime'];
};


export type QueryGeneratePaymentReminderProgressBillingListArgs = {
  reminderDate: Scalars['DateTime'];
};


export type QueryGetActiveBlockByProjectArgs = {
  ProjectId: Scalars['String'];
};


export type QueryGetActiveFloorAndUnitByProjectBlockArgs = {
  Block: Scalars['String'];
  ProjectId: Scalars['String'];
};


export type QueryGetActiveProjectPaymentPlanArgs = {
  saleId: Scalars['String'];
};


export type QueryGetAddressByIdArgs = {
  contactId: Scalars['String'];
};


export type QueryGetAddressListByContactArgs = {
  contactId?: InputMaybe<Scalars['String']>;
};


export type QueryGetAllAllocationArgs = {
  projectId: Scalars['String'];
  refId: Scalars['String'];
  refTable: Scalars['String'];
};


export type QueryGetAllBillingBySaleIdArgs = {
  billItemId?: InputMaybe<Scalars['String']>;
  creditId?: InputMaybe<Scalars['String']>;
  debitId?: InputMaybe<Scalars['String']>;
  isApproved?: InputMaybe<Scalars['Boolean']>;
  mainTable: Scalars['String'];
  projectId?: InputMaybe<Scalars['String']>;
  saleId: Scalars['String'];
  tableFilter?: InputMaybe<Scalars['String']>;
  tabType?: InputMaybe<Scalars['String']>;
  taxSchemeId?: InputMaybe<Scalars['String']>;
};


export type QueryGetAllEmployeeJobPositionArgs = {
  projectId: Scalars['String'];
};


export type QueryGetAllFinancialBillingArgs = {
  projectId: Scalars['String'];
};


export type QueryGetAllFloorByBlockArgs = {
  block: Scalars['String'];
  projectId: Scalars['String'];
  subproductStatus: Scalars['Boolean'];
};


export type QueryGetAllJobPositionArgs = {
  projectId: Scalars['String'];
};


export type QueryGetAllJobPositionOptionArgs = {
  projectId: Scalars['String'];
};


export type QueryGetAllMiscBillingByStatusArgs = {
  status: Scalars['String'];
};


export type QueryGetAllMotTrackingArgs = {
  projectId: Scalars['String'];
};


export type QueryGetAllocationByCreditIdArgs = {
  id: Scalars['String'];
};


export type QueryGetAllocationListingArgs = {
  creditId: Scalars['String'];
  projectId: Scalars['String'];
  refTable: Scalars['String'];
};


export type QueryGetAllPaymentPlanDetailArgs = {
  planId: Scalars['String'];
};


export type QueryGetAllProjectConstructionArgs = {
  projectId: Scalars['String'];
};


export type QueryGetAllProjectPaymentPlanArgs = {
  project_id: Scalars['String'];
  typePaymentPlan: TypePaymentPlanEnum;
};


export type QueryGetAllProjectPermitArgs = {
  projectId: Scalars['String'];
};


export type QueryGetAllReasonCodeArgs = {
  type: Scalars['String'];
};


export type QueryGetAllReceiptArgs = {
  status: Scalars['String'];
};


export type QueryGetAllReceiptByFinancierArgs = {
  status: Scalars['String'];
};


export type QueryGetAllReceiptByGenerationBatchIdArgs = {
  generationBatchId: Scalars['String'];
};


export type QueryGetAllReceiptBySaleIdArgs = {
  saleId: Scalars['String'];
  status: Scalars['String'];
};


export type QueryGetAllSaleUnitNoListArgs = {
  projectId: Scalars['String'];
};


export type QueryGetAllStakeholderProcessArgs = {
  project_id: Scalars['String'];
};


export type QueryGetAllTypeBillingBySaleIdArgs = {
  billItemId?: InputMaybe<Scalars['String']>;
  creditId?: InputMaybe<Scalars['String']>;
  debitId?: InputMaybe<Scalars['String']>;
  isApproved?: InputMaybe<Scalars['Boolean']>;
  mainTable: Scalars['String'];
  projectId?: InputMaybe<Scalars['String']>;
  saleId: Scalars['String'];
  tableFilter?: InputMaybe<Scalars['String']>;
  tableStatus?: InputMaybe<Scalars['String']>;
};


export type QueryGetAllUnitMotTrackingArgs = {
  projectId: Scalars['String'];
};


export type QueryGetAllUnitProjectArgs = {
  projectId: Scalars['String'];
};


export type QueryGetAllUnitStatusSignedArgs = {
  ProjectId: Scalars['String'];
};


export type QueryGetAllWorkProgressByCarParkArgs = {
  isCarPark?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetAppAccessTokenArgs = {
  app: Scalars['String'];
};


export type QueryGetApprovalPolicyAssignmentListingByCategoryArgs = {
  category: Scalars['String'];
};


export type QueryGetApprovalPolicyListingByCategoryArgs = {
  category: Scalars['String'];
};


export type QueryGetApprovedLoanRescheduleListArgs = {
  rescheduleId: Scalars['String'];
  saleId: Scalars['String'];
};


export type QueryGetApprovedRescheduleListArgs = {
  rescheduleId: Scalars['String'];
  saleId: Scalars['String'];
};


export type QueryGetArAgingArgs = {
  companyId: Scalars['String'];
};


export type QueryGetArchitectCertByIdArgs = {
  architectCertId: Scalars['String'];
  projectId: Scalars['String'];
};


export type QueryGetAreaVarianceByIdIndonesiaArgs = {
  areaVarianceId: Scalars['String'];
};


export type QueryGetAssignedClassificationBillItemsArgs = {
  classificationId: Scalars['String'];
};


export type QueryGetAssignedDiscountByIdArgs = {
  discountId: Scalars['String'];
  projectId: Scalars['String'];
};


export type QueryGetAssignedMsicBillItemsArgs = {
  msicId: Scalars['String'];
};


export type QueryGetAssignedStaffListArgs = {
  projectId: Scalars['String'];
};


export type QueryGetAssignedTeamMembersArgs = {
  teamId: Scalars['String'];
};


export type QueryGetAssignPaymentPlanFormArgs = {
  projectId: Scalars['String'];
};


export type QueryGetAttachmentArgs = {
  contactId: Scalars['String'];
};


export type QueryGetAttachmentReleaseArgs = {
  refId: Scalars['String'];
};


export type QueryGetAvailableBankProfileWithAccountArgs = {
  companyId: Scalars['String'];
};


export type QueryGetAvailableCompanyListArgs = {
  companyId: Scalars['String'];
};


export type QueryGetAvailableCopyNumCompanyListArgs = {
  companyId: Scalars['String'];
};


export type QueryGetBankProfileArgs = {
  accountId?: InputMaybe<Scalars['String']>;
  commonStatus?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  orderByAsc?: InputMaybe<Scalars['String']>;
  orderByDesc?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Float']>;
  take?: InputMaybe<Scalars['Float']>;
};


export type QueryGetBankProfileWithAccountArgs = {
  companyId: Scalars['String'];
};


export type QueryGetBillingListingByFinancierIdArgs = {
  financierId: Scalars['String'];
  generationBatchId?: InputMaybe<Scalars['String']>;
};


export type QueryGetBillItemByTypeArgs = {
  billItemType: Scalars['String'];
};


export type QueryGetBillItemIntListByTypeArgs = {
  type: Scalars['String'];
};


export type QueryGetBllItemListByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetBllItemListByTypeArgs = {
  type: Scalars['String'];
};


export type QueryGetBlockByProjectArgs = {
  ProjectId: Scalars['String'];
  SubproductStatus: Scalars['Boolean'];
};


export type QueryGetBlockFloorUnitArgs = {
  projectId: Scalars['String'];
};


export type QueryGetBlockGalleryByProjectArgs = {
  projectId: Scalars['String'];
};


export type QueryGetBookingFeeByIdArgs = {
  salePaymentId: Scalars['String'];
};


export type QueryGetBookingFeeELetterArgs = {
  letterTemplateId: Scalars['String'];
  salePaymentId: Scalars['String'];
};


export type QueryGetBookingFeeELetterTemplateListingArgs = {
  projectId: Scalars['String'];
};


export type QueryGetBookingFeeListingBySaleIdArgs = {
  saleId: Scalars['String'];
};


export type QueryGetBridgingFinanceDetailsArgs = {
  bFinancierId: Scalars['String'];
};


export type QueryGetBuyerListBySaleIdArgs = {
  projectId: Scalars['String'];
  saleId: Scalars['String'];
};


export type QueryGetCampaignByIdArgs = {
  campaignId: Scalars['String'];
};


export type QueryGetCampaignListArgs = {
  projectId?: InputMaybe<Scalars['String']>;
};


export type QueryGetCarParkInfoArgs = {
  carParkId: Scalars['String'];
  saleId: Scalars['String'];
};


export type QueryGetCarParkInstallmentArgs = {
  saleId?: InputMaybe<Scalars['String']>;
  unitId?: InputMaybe<Scalars['String']>;
};


export type QueryGetCarParkInstallmentDetailArgs = {
  id: Scalars['String'];
  saleId?: InputMaybe<Scalars['String']>;
};


export type QueryGetCarParkListingArgs = {
  saleId: Scalars['String'];
};


export type QueryGetCarParkOptionArgs = {
  carParkId?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
  saleId?: InputMaybe<Scalars['String']>;
  unitId?: InputMaybe<Scalars['String']>;
};


export type QueryGetCarParkPaymentPlanArgs = {
  projectId: Scalars['String'];
};


export type QueryGetCarParksArgs = {
  parentId?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryGetCarParkUnitInstallmentArgs = {
  saleId?: InputMaybe<Scalars['String']>;
};


export type QueryGetCityByStateArgs = {
  stateId: Scalars['String'];
};


export type QueryGetCollectionActivityByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetCollectionActivityDetailByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetCollectionActivityIndoDetailByIdArgs = {
  caId: Scalars['String'];
  overdueId?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
  saleId: Scalars['String'];
};


export type QueryGetCollectionActivityIndoDetailListAndSummaryArgs = {
  saleId: Scalars['String'];
};


export type QueryGetCollectionActivityListingArgs = {
  saleId: Scalars['String'];
};


export type QueryGetCollectionActivitySummaryArgs = {
  saleId: Scalars['String'];
};


export type QueryGetCollectionActivityWithOpaHeadersArgs = {
  overduePurchaserAccountId: Scalars['String'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
};


export type QueryGetCommissionCalculationDataArgs = {
  inputDate?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
};


export type QueryGetCommissionCalculationDetailDataArgs = {
  inputDate?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
};


export type QueryGetCommissionCalculationListingArgs = {
  inputDate?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
};


export type QueryGetCommissionCalculationListingDataArgs = {
  inputDate?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
};


export type QueryGetCommissionCalculationRecentDataArgs = {
  projectId: Scalars['String'];
};


export type QueryGetCompanyCommissionPackageListingArgs = {
  principal: Scalars['String'];
};


export type QueryGetCompanyCommissionPackageListingDataArgs = {
  principal: Scalars['String'];
  projectId: Scalars['String'];
};


export type QueryGetCompanyRewardDataArgs = {
  inputDate?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
};


export type QueryGetCompanyRewardDetailDataArgs = {
  detailId?: InputMaybe<Scalars['String']>;
  inputDate?: InputMaybe<Scalars['String']>;
};


export type QueryGetContactByIdArgs = {
  contactId: Scalars['String'];
};


export type QueryGetContactListArgs = {
  unitId?: InputMaybe<Scalars['String']>;
};


export type QueryGetContactPersonByIdArgs = {
  contactPersonId: Scalars['String'];
};


export type QueryGetContactPricingListArgs = {
  saleID: Scalars['String'];
};


export type QueryGetcontraArgs = {
  id?: InputMaybe<Scalars['String']>;
  orderByAsc?: InputMaybe<Scalars['String']>;
  orderByDesc?: InputMaybe<Scalars['String']>;
  project_id: Scalars['String'];
  skip?: InputMaybe<Scalars['Float']>;
  take?: InputMaybe<Scalars['Float']>;
};


export type QueryGetContractUnitDetailsArgs = {
  unitId: Scalars['String'];
};


export type QueryGetCountryCodeByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetCountStatusBookingArgs = {
  projectId: Scalars['String'];
};


export type QueryGetCurrentBuyerDetailsArgs = {
  saleId: Scalars['String'];
};


export type QueryGetDailySalesAnalysisCountArgs = {
  salesType: Scalars['String'];
  selectedDate: Scalars['DateTime'];
};


export type QueryGetDashboardNewsArgs = {
  projectId: Scalars['String'];
};


export type QueryGetDateByScheduleIdArgs = {
  id: Scalars['String'];
};


export type QueryGetDefaultAppointmentStartEndTimeArgs = {
  projectId: Scalars['String'];
};


export type QueryGetDesignationByIdArgs = {
  designationId: Scalars['String'];
};


export type QueryGetDirectionByIdArgs = {
  directionId: Scalars['String'];
};


export type QueryGetDiscountAssigmentByProjectIdArgs = {
  projectId: Scalars['String'];
};


export type QueryGetDiscountAssignedByProjectIdArgs = {
  projectId: Scalars['String'];
};


export type QueryGetDiscountBasedOnIdArgs = {
  discountId: Scalars['String'];
};


export type QueryGetDiscountByIdArgs = {
  discountId: Scalars['String'];
};


export type QueryGetDiscountTypeByIdArgs = {
  discountTypeId: Scalars['String'];
};


export type QueryGetDistinctBlockByProjectIdArgs = {
  projectId: Scalars['String'];
};


export type QueryGetDistinctFloorByProjectIdArgs = {
  projectId: Scalars['String'];
};


export type QueryGetDistinctUnitByProjectIdArgs = {
  projectId: Scalars['String'];
};


export type QueryGetDistrictbyCityArgs = {
  cityId: Scalars['String'];
};


export type QueryGetDocumentNumberHeaderListingArgs = {
  companyId: Scalars['String'];
};


export type QueryGetDocumentTypeArgs = {
  companyId: Scalars['String'];
  type: Scalars['String'];
};


export type QueryGetDownpaymentReminderByIdArgs = {
  generationBatch: Scalars['String'];
  reminderDate: Scalars['DateTime'];
};


export type QueryGetEditUserArgs = {
  userId: Scalars['String'];
};


export type QueryGetEducationByIdArgs = {
  educationId: Scalars['String'];
};


export type QueryGetEndFinancierDetailsArgs = {
  projectId: Scalars['String'];
};


export type QueryGetEndFinancierForLoanApprovalArgs = {
  projectId: Scalars['String'];
};


export type QueryGetEndFinSolicitorFormSourceArgs = {
  saleId?: InputMaybe<Scalars['String']>;
};


export type QueryGetEventByDateArgs = {
  saleId: Scalars['String'];
};


export type QueryGetEventByIdArgs = {
  campaignId: Scalars['String'];
  id: Scalars['String'];
};


export type QueryGetEventPerformanceByCampaignIdArgs = {
  campaignId: Scalars['String'];
};


export type QueryGetEventsDetailsArgs = {
  eventsId: Scalars['String'];
};


export type QueryGetEventsListByCampaignArgs = {
  campaignId: Scalars['String'];
};


export type QueryGetExchangeByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetExportPreviewGlDataArgs = {
  companyId: Scalars['String'];
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
};


export type QueryGetFinancialBillingArgs = {
  id?: InputMaybe<Scalars['String']>;
  orderByAsc?: InputMaybe<Scalars['String']>;
  orderByDesc?: InputMaybe<Scalars['String']>;
  project_id: Scalars['String'];
  skip?: InputMaybe<Scalars['Float']>;
  take?: InputMaybe<Scalars['Float']>;
};


export type QueryGetFinancierDetailArgs = {
  financier_id: Scalars['String'];
};


export type QueryGetFinancierDetailListingArgs = {
  financierId: Scalars['String'];
};


export type QueryGetFinancierRedemptionUnitListArgs = {
  financierId?: InputMaybe<Scalars['String']>;
};


export type QueryGetFloorByProjectBlockArgs = {
  Block: Scalars['String'];
  ProjectId: Scalars['String'];
};


export type QueryGetFloorGalleryByProjectArgs = {
  projectId: Scalars['String'];
};


export type QueryGetGalleryByProjectArgs = {
  projectId: Scalars['String'];
};


export type QueryGetGalleryByTypeArgs = {
  galleryType: Scalars['String'];
  projectId: Scalars['String'];
};


export type QueryGetGalleryTourByProjectArgs = {
  projectId: Scalars['String'];
};


export type QueryGetGeneralTinByPartyArgs = {
  party?: InputMaybe<Scalars['String']>;
};


export type QueryGetGlDetailByGenerationBatchArgs = {
  companyId: Scalars['String'];
  generationBatch: Scalars['String'];
};


export type QueryGetGlExportListingArgs = {
  companyId: Scalars['String'];
};


export type QueryGetIncomeRangeByIdArgs = {
  incomeRangeId: Scalars['String'];
};


export type QueryGetIndustryByIdArgs = {
  industryId: Scalars['String'];
};


export type QueryGetInstallmentApprovalListArgs = {
  projectId: Scalars['String'];
  status: Scalars['String'];
};


export type QueryGetInstallmentBySaleIdArgs = {
  saleId: Scalars['String'];
};


export type QueryGetInstallmentListArgs = {
  saleId: Scalars['String'];
};


export type QueryGetInstallmentPendingListArgs = {
  rescheduleId: Scalars['String'];
  saleId: Scalars['String'];
};


export type QueryGetInstallmentsByCarParkIdArgs = {
  carParkId: Scalars['String'];
};


export type QueryGetInstallmentsByPackageIdArgs = {
  packageId: Scalars['String'];
};


export type QueryGetJointBuyerArgs = {
  contactId: Scalars['String'];
};


export type QueryGetJointBuyerDetailsByContactIdArgs = {
  contactId: Scalars['String'];
  jointBuyerId: Scalars['String'];
};


export type QueryGetKeyCollectionAppointmentByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetKeyCollectionContractorListbyTypeArgs = {
  contractorType: Scalars['String'];
};


export type QueryGetLandDepositBySaleArgs = {
  saleId: Scalars['String'];
};


export type QueryGetLandDepositFormMasterDataArgs = {
  projectId?: InputMaybe<Scalars['String']>;
};


export type QueryGetLandDepositFormMasterDataByProjectArgs = {
  projectId?: InputMaybe<Scalars['String']>;
};


export type QueryGetLandDepositListingByProjectArgs = {
  projectId: Scalars['String'];
};


export type QueryGetLateInterestByIdArgs = {
  generationBatchDate: Scalars['DateTime'];
  generationBatchId: Scalars['String'];
};


export type QueryGetLateInterestBySaleIdArgs = {
  generationDate: Scalars['DateTime'];
  saleId: Scalars['String'];
};


export type QueryGetLateInterestsDetailArgs = {
  lateInterestId: Scalars['String'];
  saleId: Scalars['String'];
};


export type QueryGetLeadCountByProjectArgs = {
  lead_source_id?: InputMaybe<Scalars['String']>;
};


export type QueryGetLeadSourceByIdArgs = {
  sourceId: Scalars['String'];
};


export type QueryGetLetterTemplateByIdArgs = {
  letterTemplateId: Scalars['String'];
};


export type QueryGetLetterTemplateByStdLtrParameterIdArgs = {
  standardLetterParameterId: Scalars['String'];
};


export type QueryGetLetterTemplateListingArgs = {
  standardLetterId: Scalars['String'];
};


export type QueryGetListLateInterestArgs = {
  saleId: Scalars['String'];
};


export type QueryGetLoanApplyForLoanApprovalArgs = {
  unitId: Scalars['String'];
};


export type QueryGetLoanApplyUnitForLoanApprovalArgs = {
  projectId: Scalars['String'];
  saleLoanID?: InputMaybe<Scalars['String']>;
};


export type QueryGetLoanApprovalCountArgs = {
  projectId: Scalars['String'];
};


export type QueryGetLoanDifferentialCountArgs = {
  projectId: Scalars['String'];
};


export type QueryGetLoanDifferentialListingArgs = {
  projectId: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
};


export type QueryGetLoanPaymentDetailsArgs = {
  saleLoanPaymentId: Scalars['String'];
};


export type QueryGetLoanPaymentListingArgs = {
  projectId: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};


export type QueryGetLoanPaymentListingByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetLoanPaymentSummaryArgs = {
  projectId: Scalars['String'];
};


export type QueryGetLoanReleaseListingArgs = {
  projectId: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
};


export type QueryGetLoanReleaseNotificationELetterArgs = {
  financierId: Scalars['String'];
  letterTemplateId: Scalars['String'];
  loanReleaseId?: InputMaybe<Scalars['String']>;
  mortgagePaymentId?: InputMaybe<Scalars['String']>;
  mortgageRetentionId?: InputMaybe<Scalars['String']>;
  saleLoanIds?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryGetLoanReleaseNotificationProjectELetterListingArgs = {
  projectId: Scalars['String'];
};


export type QueryGetLoanReleasesArgs = {
  projectId: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
};


export type QueryGetLoanSettlementByIdArgs = {
  saleId?: InputMaybe<Scalars['String']>;
};


export type QueryGetLotStatusMovementDataArgs = {
  propertyTypeId?: InputMaybe<Scalars['String']>;
  unitTypeId?: InputMaybe<Scalars['String']>;
};


export type QueryGetManyAppointmentForDayArgs = {
  appointment_date?: InputMaybe<Scalars['String']>;
};


export type QueryGetMaritalStatusByIdArgs = {
  maritalStatusId: Scalars['String'];
};


export type QueryGetMarkUpBySaleIdArgs = {
  id: Scalars['String'];
};


export type QueryGetMiscBillingByBatchIdArgs = {
  generationBatch: Scalars['String'];
};


export type QueryGetMiscBillingDetailsArgs = {
  generationBatch: Scalars['String'];
};


export type QueryGetMiscBillingTaxByDocDateArgs = {
  docDate: Scalars['DateTime'];
};


export type QueryGetMiscBillItemArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryGetMiscChargesByDateArgs = {
  date: Scalars['DateTime'];
};


export type QueryGetMonthlySalesAnalysisCountArgs = {
  salesType: Scalars['String'];
  selectedDate: Scalars['DateTime'];
};


export type QueryGetMortgageDataArgs = {
  newFinancierId: Scalars['String'];
  prevMortgageId: Scalars['String'];
};


export type QueryGetMortgagePaymentFromMortgagePlanIdArgs = {
  mortgageId: Scalars['String'];
};


export type QueryGetMortgagePaymentFromMortgagePlanIdWithSaleLoanIdArgs = {
  mortgageId: Scalars['String'];
  saleLoanId: Scalars['String'];
};


export type QueryGetMortgagePlanFromFinancierIdArgs = {
  financierId: Scalars['String'];
};


export type QueryGetMortgagePlansListArgs = {
  financier_id: Scalars['String'];
};


export type QueryGetMortgageRetentionFromPaymentIdArgs = {
  paymentId: Array<Scalars['String']>;
};


export type QueryGetMotTrackingByIdArgs = {
  id: Scalars['String'];
  projectId: Scalars['String'];
};


export type QueryGetNewPaymentPlanArgs = {
  mortgageId: Scalars['String'];
};


export type QueryGetNewPBdataArgs = {
  saleId: Scalars['String'];
};


export type QueryGetNewsAnnouncementArgs = {
  limit: Scalars['Float'];
  page: Scalars['Float'];
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetNewsDetailsArgs = {
  newsId: Scalars['String'];
};


export type QueryGetNotaryByIdArgs = {
  notaryId: Scalars['String'];
};


export type QueryGetNotarySelectionListArgs = {
  projectId: Scalars['String'];
};


export type QueryGetNotificationsArgs = {
  limit: Scalars['Float'];
  page: Scalars['Float'];
  projectId: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetNotificationsListArgs = {
  limit: Scalars['Float'];
  page: Scalars['Float'];
  projectId?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetNupCountArgs = {
  projectId: Scalars['String'];
};


export type QueryGetNupListingArgs = {
  approvalStatus?: InputMaybe<Scalars['String']>;
  nupId?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
};


export type QueryGetOneAppointmentArgs = {
  appointment_id?: InputMaybe<Scalars['String']>;
};


export type QueryGetOptionListArgs = {
  financierId?: InputMaybe<Scalars['String']>;
};


export type QueryGetOsAmountArgs = {
  saleId: Scalars['String'];
};


export type QueryGetOtherContactByIdArgs = {
  ID: Scalars['String'];
  saleID: Scalars['String'];
};


export type QueryGetOtherContactListArgs = {
  saleID: Scalars['String'];
};


export type QueryGetOverdueAgingArgs = {
  projectId: Scalars['String'];
};


export type QueryGetOverdueInstallmentDetailsArgs = {
  interval: Scalars['String'];
  overdueId?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
  saleId: Scalars['String'];
};


export type QueryGetOverduePurchaseAccountCaDetailArgs = {
  caId: Scalars['String'];
  overdueId?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
  saleId: Scalars['String'];
};


export type QueryGetOverduePurchaseAccountHeaderArgs = {
  overdueId?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
  saleId: Scalars['String'];
};


export type QueryGetPackageFormSourceArgs = {
  saleId: Scalars['String'];
};


export type QueryGetPackageInfoArgs = {
  packageId: Scalars['String'];
};


export type QueryGetPackageItemListingArgs = {
  saleId: Scalars['String'];
};


export type QueryGetPackageListingArgs = {
  saleId: Scalars['String'];
};


export type QueryGetPackageOptionArgs = {
  projectId: Scalars['String'];
};


export type QueryGetPAcollectionMasterDataArgs = {
  saleId: Scalars['String'];
};


export type QueryGetPAcontraByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetPAcontraListArgs = {
  saleId: Scalars['String'];
  status: Scalars['String'];
};


export type QueryGetPaContraSubmittedListArgs = {
  saleId: Scalars['String'];
};


export type QueryGetPAcontraSummaryArgs = {
  projectId: Scalars['String'];
  saleId: Scalars['String'];
};


export type QueryGetPAcreditNoteByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetPAcreditNoteListArgs = {
  saleId: Scalars['String'];
  status: Scalars['String'];
};


export type QueryGetPaCreditNoteSubmittedListArgs = {
  saleId: Scalars['String'];
};


export type QueryGetPAcreditNoteSummaryArgs = {
  projectId: Scalars['String'];
  saleId: Scalars['String'];
};


export type QueryGetPAdebitNoteByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetPAdebitNoteListArgs = {
  saleId: Scalars['String'];
  status: Scalars['String'];
};


export type QueryGetPAdebitNoteSummaryArgs = {
  projectId: Scalars['String'];
  saleId: Scalars['String'];
};


export type QueryGetPaidByListArgs = {
  selectedParty: Scalars['String'];
};


export type QueryGetPaidLandDepositByIdArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryGetPaidLandDepositsListingBySaleArgs = {
  saleId: Scalars['String'];
};


export type QueryGetPaIndoAdditionalDetailArgs = {
  id: Scalars['String'];
  saleId: Scalars['String'];
};


export type QueryGetPaIndoContraByIdArgs = {
  id: Scalars['String'];
  projectId: Scalars['String'];
};


export type QueryGetPaIndoContraListArgs = {
  projectId: Scalars['String'];
  saleId?: InputMaybe<Scalars['String']>;
};


export type QueryGetPaIndoCreditNoteByIdArgs = {
  id: Scalars['String'];
  projectId: Scalars['String'];
};


export type QueryGetPaIndoCreditNoteSummaryArgs = {
  projectId: Scalars['String'];
  saleId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};


export type QueryGetPaIndoDebitNoteByIdArgs = {
  id: Scalars['String'];
  projectId: Scalars['String'];
};


export type QueryGetPaIndoDebitNoteSummaryArgs = {
  projectId: Scalars['String'];
  saleId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};


export type QueryGetPaIndoDepositByIdArgs = {
  id: Scalars['String'];
  projectId: Scalars['String'];
};


export type QueryGetPaIndoDepositSummaryArgs = {
  projectId: Scalars['String'];
  saleId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};


export type QueryGetPaIndoLateInterestListingArgs = {
  projectId: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
};


export type QueryGetPaIndomiscBillingByIdArgs = {
  id: Scalars['String'];
  projectId: Scalars['String'];
};


export type QueryGetPaIndoMiscBillingSummaryArgs = {
  projectId: Scalars['String'];
  saleId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};


export type QueryGetPaIndoPaymentByIdArgs = {
  id: Scalars['String'];
  projectId: Scalars['String'];
};


export type QueryGetPaIndoPaymentSummaryArgs = {
  projectId: Scalars['String'];
  saleId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};


export type QueryGetPaIndoPaymentSummaryListWPaginationArgs = {
  pgnInput: PaginationInput;
  projectId: Scalars['String'];
  saleId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};


export type QueryGetPaIndoRebateByIdArgs = {
  id: Scalars['String'];
  projectId: Scalars['String'];
};


export type QueryGetPaIndoRebateSummaryArgs = {
  projectId: Scalars['String'];
  saleId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};


export type QueryGetPaIndoRefundByIdArgs = {
  id: Scalars['String'];
  projectId: Scalars['String'];
};


export type QueryGetPaIndoRefundSummaryArgs = {
  projectId: Scalars['String'];
  saleId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};


export type QueryGetPaIndoSummaryArgs = {
  projectId: Scalars['String'];
};


export type QueryGetPAlateInterestByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetPAlateInterestListArgs = {
  saleId: Scalars['String'];
};


export type QueryGetPAlateInterestSummaryArgs = {
  saleId: Scalars['String'];
};


export type QueryGetPAmiscBillingByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetPAmiscBillingListArgs = {
  saleId: Scalars['String'];
  status: Scalars['String'];
};


export type QueryGetPaMiscBillingSubmittedListArgs = {
  saleId: Scalars['String'];
};


export type QueryGetPAmiscBillingSummaryArgs = {
  saleId: Scalars['String'];
};


export type QueryGetPArebateByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetPArebateListArgs = {
  saleId: Scalars['String'];
  status: Scalars['String'];
};


export type QueryGetPaRebateSubmittedListArgs = {
  saleId: Scalars['String'];
};


export type QueryGetPArebateSummaryArgs = {
  projectId: Scalars['String'];
  saleId: Scalars['String'];
};


export type QueryGetPArefundByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetPArefundListArgs = {
  saleId: Scalars['String'];
  status: Scalars['String'];
};


export type QueryGetPaRefundSubmittedListArgs = {
  saleId: Scalars['String'];
};


export type QueryGetPArefundSummaryArgs = {
  projectId: Scalars['String'];
  saleId: Scalars['String'];
};


export type QueryGetPAsummaryArgs = {
  saleId: Scalars['String'];
};


export type QueryGetPaymentELetterArgs = {
  letterTemplateId: Scalars['String'];
  receiptId: Scalars['String'];
};


export type QueryGetPaymentELetterTemplateListingArgs = {
  projectId: Scalars['String'];
};


export type QueryGetPaymentPlanArgs = {
  mortgageId: Scalars['String'];
};


export type QueryGetPaymentPlanByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetPaymentPlanDetailByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetPaymentPlanDetailsArgs = {
  finalContractPrice?: InputMaybe<Scalars['Float']>;
  InstallmentSummaryInput?: InputMaybe<Array<InstallmentSummaryInput>>;
  isCarparkOrPackage?: InputMaybe<Scalars['Boolean']>;
  paymentMarkUpAmt?: InputMaybe<Scalars['Float']>;
  paymentPlanId: Scalars['String'];
  regDate?: InputMaybe<Scalars['DateTime']>;
  saleId: Scalars['String'];
  taxSchemeId?: InputMaybe<Scalars['String']>;
};


export type QueryGetPaymentReminderByGenerationBatchArgs = {
  generationBatch: Scalars['String'];
};


export type QueryGetPaymentReminderBySaleIdArgs = {
  saleId: Scalars['String'];
};


export type QueryGetPaymentRemindersByGenerationBatchArgs = {
  generationBatch: Scalars['String'];
};


export type QueryGetPBdataListArgs = {
  saleId: Scalars['String'];
};


export type QueryGetPBlistBySaleIdAndTypeArgs = {
  saleId: Scalars['String'];
  type: Scalars['String'];
};


export type QueryGetPBsaleProductListArgs = {
  saleId: Scalars['String'];
};


export type QueryGetPBvoidListArgs = {
  saleId: Scalars['String'];
};


export type QueryGetPendingInstallmentByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetPendingRegisterUnitsArgs = {
  projectId: Scalars['String'];
};


export type QueryGetPermissionKeyByRoleIdArgs = {
  roleId: Scalars['String'];
};


export type QueryGetPositionCodeOptionsByCompanyCommissionTeamArgs = {
  generateDate: Scalars['DateTime'];
  principal: Scalars['String'];
};


export type QueryGetPostCodeByCityArgs = {
  cityId: Scalars['String'];
};


export type QueryGetPostedLadDetailByIdArgs = {
  generationBatch: Scalars['String'];
};


export type QueryGetPostedUnitListArgs = {
  architectCertId: Scalars['String'];
};


export type QueryGetPrecisionRoundingArgs = {
  projectId: Scalars['String'];
};


export type QueryGetPriceAdjustmentByIdArgs = {
  id: Scalars['String'];
  projectId: Scalars['String'];
};


export type QueryGetPriceAdjustmentListArgs = {
  projectId: Scalars['String'];
  statusFilter?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryGetProductConstructionByIdArgs = {
  projectConstructionId: Scalars['String'];
  projectId: Scalars['String'];
};


export type QueryGetProfessionByIdArgs = {
  professionId: Scalars['String'];
};


export type QueryGetProfileAndAccountListArgs = {
  bankProfileId: Scalars['String'];
  companyId: Scalars['String'];
};


export type QueryGetProgressBillingArgs = {
  status: Scalars['String'];
};


export type QueryGetProgressBillingByGenerationIdArgs = {
  generationBatchId: Scalars['String'];
};


export type QueryGetProgressBillingByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetProgressStageArgs = {
  isCarpark: Scalars['Boolean'];
  projectId: Scalars['String'];
};


export type QueryGetProjectBridgingFinancierByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetProjectByIdArgs = {
  projectId: Scalars['String'];
};


export type QueryGetProjectClusterListingArgs = {
  projectId: Scalars['String'];
};


export type QueryGetProjectCommissionByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetProjectCommissionOptionsArgs = {
  projectId: Scalars['String'];
};


export type QueryGetProjectCommissionPackageListingArgs = {
  principal: Scalars['String'];
  projectId: Scalars['String'];
};


export type QueryGetProjectCommissionsArgs = {
  projectId: Scalars['String'];
};


export type QueryGetProjectCommissionTeamAgencyAppointedArgs = {
  projectId: Scalars['String'];
};


export type QueryGetProjectCommissionTeamStructureListingArgs = {
  projectId: Scalars['String'];
};


export type QueryGetProjectDetailByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetProjectDiscountListArgs = {
  discountType?: InputMaybe<Scalars['String']>;
  saleRebateId?: InputMaybe<Scalars['String']>;
};


export type QueryGetProjectDiscountListWithoutSaleRebateArgs = {
  discountType?: InputMaybe<Scalars['String']>;
  saleId?: InputMaybe<Scalars['String']>;
};


export type QueryGetProjectFireInsuranceArgs = {
  projectId: Scalars['String'];
};


export type QueryGetProjectGalleryByProjectArgs = {
  projectId: Scalars['String'];
};


export type QueryGetProjectKeyCollectionContractorByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetProjectKeyCollectionScheduleByIdArgs = {
  date: Scalars['DateTime'];
  id: Scalars['String'];
};


export type QueryGetProjectLetterTemplateArgs = {
  letterType: Scalars['String'];
};


export type QueryGetProjectLetterTemplateByIdArgs = {
  letterTemplateId: Scalars['String'];
  projectId: Scalars['String'];
  standardLetterId: Scalars['String'];
};


export type QueryGetProjectLetterTemplateListingArgs = {
  projectId: Scalars['String'];
  standardLetterId: Scalars['String'];
};


export type QueryGetProjectMiscChargesByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetProjectPaymentReminderExceptionByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetProjectPermitByIdArgs = {
  projectId: Scalars['String'];
};


export type QueryGetProjectPolicyArgs = {
  projectId: Scalars['String'];
};


export type QueryGetProjectSalesPolicyByProjectIdArgs = {
  projectId: Scalars['String'];
};


export type QueryGetProjectSetupInfoLineArgs = {
  projectId: Scalars['String'];
};


export type QueryGetProjectSpecByProjectIdArgs = {
  project_id: Scalars['String'];
};


export type QueryGetProjectTitleByIdArgs = {
  id: Scalars['String'];
  projectId: Scalars['String'];
};


export type QueryGetProjectTypeByIdArgs = {
  projectTypeId: Scalars['String'];
};


export type QueryGetProjectUserRoleArgs = {
  projectId: Scalars['String'];
};


export type QueryGetPromotionalItemListingArgs = {
  projectId: Scalars['String'];
};


export type QueryGetPromotionalPackagesByProjectIdArgs = {
  projectId: Scalars['String'];
  promotionalPackagesId: Scalars['String'];
};


export type QueryGetPromotionalPackagesItemDetailsListingArgs = {
  promotionalPackagesId: Scalars['String'];
};


export type QueryGetPromotionalPackagesListingArgs = {
  projectId: Scalars['String'];
};


export type QueryGetPropertyTypeListArgs = {
  projectId: Scalars['String'];
};


export type QueryGetPurchaserDataArgs = {
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  tableRef: Scalars['String'];
};


export type QueryGetPurchaserDetailArgs = {
  saleId: Scalars['String'];
};


export type QueryGetPurchaserDetailsByContactIdArgs = {
  contactId: Scalars['String'];
  saleId: Scalars['String'];
};


export type QueryGetPurchaserInfoArgs = {
  contactId: Scalars['String'];
};


export type QueryGetPurchaserInfoListingArgs = {
  saleId: Scalars['String'];
};


export type QueryGetPurchaserInstallmentArgs = {
  projectId: Scalars['String'];
  saleId: Scalars['String'];
};


export type QueryGetPurchaserInstallmentListingArgs = {
  projectId: Scalars['String'];
};


export type QueryGetPurchaserNameByIdArgs = {
  projectId: Scalars['String'];
  purchaserNameTransferId?: InputMaybe<Scalars['String']>;
  saleId: Scalars['String'];
};


export type QueryGetPurchaserPaymentPlanByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetPurchaserPaymentPlanDetailArgs = {
  paymentPlanDetailId: Scalars['String'];
};


export type QueryGetPurchaserPaymentPlanDetailsListingArgs = {
  purchaserPaymentPlanId?: InputMaybe<Scalars['String']>;
};


export type QueryGetPurchaserPaymentScheduleArgs = {
  projectId: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetPurchaserRedemptionUnitListArgs = {
  contactId?: InputMaybe<Scalars['String']>;
};


export type QueryGetPurchaserTransferListArgs = {
  approvalStatus: Scalars['String'];
  projectId: Scalars['String'];
};


export type QueryGetRaceByIdArgs = {
  raceId: Scalars['String'];
};


export type QueryGetReasonCodeByIdArgs = {
  reasonCodeId: Scalars['String'];
};


export type QueryGetReceiptBillingByGenerationBatchIdArgs = {
  generationBatchId: Scalars['String'];
};


export type QueryGetReceiptByIdArgs = {
  docType?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};


export type QueryGetRedemptionRepaymentByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetRedemptionUnitSelectionArgs = {
  selectedParty: Scalars['String'];
  selectedPartyId?: InputMaybe<Scalars['String']>;
};


export type QueryGetRefinancingByIdArgs = {
  generationBatch: Scalars['String'];
};


export type QueryGetRefinancingDetailsByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetRefinancingSingleDetailByIdArgs = {
  generationBatch: Scalars['String'];
  refinancingId: Scalars['String'];
};


export type QueryGetRefundAllocationArgs = {
  refundId?: InputMaybe<Scalars['String']>;
  saleId: Scalars['String'];
};


export type QueryGetRelationshipByIdArgs = {
  relationshipId: Scalars['String'];
};


export type QueryGetReligionByIdArgs = {
  religionId: Scalars['String'];
};


export type QueryGetRescheduleDetailsArgs = {
  rescheduleId: Scalars['String'];
};


export type QueryGetRescheduleInstallmentArgs = {
  projectId: Scalars['String'];
  saleId: Scalars['String'];
};


export type QueryGetRescheduleLoanArgs = {
  rescheduleId: Scalars['String'];
};


export type QueryGetRoleByIdArgs = {
  roleId: Scalars['String'];
};


export type QueryGetSaleContactListArgs = {
  isCompany: Scalars['Boolean'];
};


export type QueryGetSaleContractSubProductByIdArgs = {
  saleId: Scalars['String'];
  subProductId: Scalars['String'];
};


export type QueryGetSaleLoanBuyBackCountArgs = {
  projectId: Scalars['String'];
};


export type QueryGetSaleLoanByGenerationIdArgs = {
  generationId: Scalars['String'];
  projectID: Scalars['String'];
};


export type QueryGetSaleLoanCancellationByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetSaleLoanCancellationListingArgs = {
  status: Scalars['String'];
};


export type QueryGetSaleLoanDetailsArgs = {
  saleLoanReleaseId: Scalars['String'];
};


export type QueryGetSaleLoanInfoBasedOnSaleLoanIdArgs = {
  id: Scalars['String'];
};


export type QueryGetSaleLoanListingArgs = {
  status: Scalars['String'];
};


export type QueryGetSaleLoanListingForIndoArgs = {
  keySearch?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
};


export type QueryGetSaleLoanReleaseCountArgs = {
  projectId: Scalars['String'];
};


export type QueryGetSaleLoanTableListingArgs = {
  endfinancierMortgagePlanId?: InputMaybe<Scalars['String']>;
  financierId: Scalars['String'];
  loanSignDate: Scalars['DateTime'];
  paymentId?: InputMaybe<Scalars['String']>;
  saleLoanReleaseId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};


export type QueryGetSaleRefinancingCountArgs = {
  projectId: Scalars['String'];
};


export type QueryGetSalesAnalysisCountArgs = {
  selectedDate: Scalars['DateTime'];
};


export type QueryGetSalesCancellationByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetSalesCancellationCountArgs = {
  projectId: Scalars['String'];
};


export type QueryGetSalesCancellationELetterArgs = {
  letterTemplateId: Scalars['String'];
  saleCancellationId: Scalars['String'];
};


export type QueryGetSalesCancellationELetterTemplateListingArgs = {
  projectId: Scalars['String'];
};


export type QueryGetSalesChartByBlockArgs = {
  block: Scalars['String'];
  project_id: Scalars['String'];
};


export type QueryGetSalesChartDataArgs = {
  projectId: Scalars['String'];
};


export type QueryGetSalesContractAttachmentsArgs = {
  sale_id: Scalars['String'];
};


export type QueryGetSalesContractByIdArgs = {
  saleID: Scalars['String'];
};


export type QueryGetSalesContractCreditTermArgs = {
  saleId: Scalars['String'];
};


export type QueryGetSalesContractDetailDataArgs = {
  saleId: Scalars['String'];
};


export type QueryGetSalesContractPackageByIdArgs = {
  packageId: Scalars['String'];
  saleId: Scalars['String'];
};


export type QueryGetSalesDiscountByIdArgs = {
  discountId: Scalars['String'];
  saleId: Scalars['String'];
};


export type QueryGetSalesDiscountListArgs = {
  saleID: Scalars['String'];
};


export type QueryGetSalesDiscountListingArgs = {
  saleId: Scalars['String'];
};


export type QueryGetSalesInformationArgs = {
  saleId: Scalars['String'];
};


export type QueryGetSalesLoanBuyBackDetailsArgs = {
  id: Scalars['String'];
};


export type QueryGetSalesLoanBuyBackListArgs = {
  approvalStatus: Scalars['String'];
  projectId: Scalars['String'];
};


export type QueryGetSalesLoanRefinancingListArgs = {
  approvalStatus: Scalars['String'];
  projectId: Scalars['String'];
};


export type QueryGetSalesMovementDataArgs = {
  selectedDate: Scalars['DateTime'];
};


export type QueryGetSalesPackageByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetSalesPackageListArgs = {
  saleID: Scalars['String'];
};


export type QueryGetSalesPersonArgs = {
  teamId: Scalars['String'];
};


export type QueryGetSalesRebatePackageArgs = {
  saleId: Scalars['String'];
};


export type QueryGetSalesRebatePackageByIdArgs = {
  saleId: Scalars['String'];
  saleRebateId: Scalars['String'];
};


export type QueryGetSalesRegistrationCountArgs = {
  projectId: Scalars['String'];
};


export type QueryGetSalesRegistrationDiscountByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetSalesRegistrationELetterArgs = {
  letterTemplateId: Scalars['String'];
  saleId: Scalars['String'];
};


export type QueryGetSalesRegistrationELetterTemplateListingArgs = {
  projectId: Scalars['String'];
};


export type QueryGetSalesRegistrationListArgs = {
  approvalStatus: Scalars['String'];
  projectId: Scalars['String'];
};


export type QueryGetSalesTeamArgs = {
  status: Scalars['String'];
};


export type QueryGetSalesTeamByProjectArgs = {
  projectId: Scalars['String'];
};


export type QueryGetSaleSubProductListArgs = {
  saleID: Scalars['String'];
};


export type QueryGetSalutationByIdArgs = {
  salutationId: Scalars['String'];
};


export type QueryGetScAdataArgs = {
  selectedDate: Scalars['DateTime'];
};


export type QueryGetSelectedCarParkPaymentPlanArgs = {
  carParkId: Scalars['String'];
};


export type QueryGetSelectedPackagePaymentPlanArgs = {
  packageId: Scalars['String'];
};


export type QueryGetSelectUnitAtPriceAdjustmentArgs = {
  id?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
};


export type QueryGetSimulatedLadDetailByIdArgs = {
  generationBatch: Scalars['String'];
};


export type QueryGetSolicitorSignedInfoArgs = {
  salesId: Scalars['String'];
};


export type QueryGetSpaReminderByIdArgs = {
  generationBatch: Scalars['String'];
  reminderDate: Scalars['DateTime'];
};


export type QueryGetStakeholderAvailableDeemCollectedUnitArgs = {
  collectionBatchId?: InputMaybe<Scalars['String']>;
  mode: Scalars['String'];
  solicitorId: Scalars['String'];
};


export type QueryGetStakeholderDeemCollectedDetailArgs = {
  collectionBatchId: Scalars['String'];
  solicitorId: Scalars['String'];
};


export type QueryGetStakeholderDeemCollectedListingArgs = {
  solicitorId: Scalars['String'];
};


export type QueryGetStakeholderProcessBySolicitorIdArgs = {
  solicitorId: Scalars['String'];
};


export type QueryGetStakeholderReleaseDetailArgs = {
  solicitorId: Scalars['String'];
  stakeholderReleaseId: Scalars['String'];
};


export type QueryGetStakeholderReleaseListingArgs = {
  solicitorId: Scalars['String'];
};


export type QueryGetStakeholderReleaseUnitArgs = {
  id?: InputMaybe<Scalars['String']>;
  solicitorId: Scalars['String'];
};


export type QueryGetStakeholderUnitDetailArgs = {
  saleId: Scalars['String'];
  solicitorId: Scalars['String'];
};


export type QueryGetStakeholderUnitSummaryBySolicitorIdArgs = {
  solicitorId: Scalars['String'];
};


export type QueryGetStampDutyByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetStampDutyIntegrationArgs = {
  id: Scalars['String'];
  projectId: Scalars['String'];
};


export type QueryGetStampDutyIntegrationListingArgs = {
  projectId: Scalars['String'];
};


export type QueryGetStandardLetterArgs = {
  id?: InputMaybe<Scalars['String']>;
  letterCategory?: InputMaybe<Scalars['String']>;
  letterType?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  orderByAsc?: InputMaybe<Scalars['String']>;
  orderByDesc?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Float']>;
  take?: InputMaybe<Scalars['Float']>;
};


export type QueryGetStandardLetterParameterArgs = {
  columnName?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  orderByAsc?: InputMaybe<Scalars['String']>;
  orderByDesc?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Float']>;
  standardLetterId?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Float']>;
};


export type QueryGetStandardLetterParameterByIdArgs = {
  standardLetterParameterId: Scalars['String'];
};


export type QueryGetStateByCountryArgs = {
  countryId: Scalars['String'];
};


export type QueryGetStatutoryTypeByUnitArgs = {
  projectId: Scalars['String'];
  unitId: Scalars['String'];
};


export type QueryGetStatutoryUnitListArgs = {
  projectId: Scalars['String'];
};


export type QueryGetSubsaleByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetSubsaleContactListArgs = {
  isCompany: Scalars['Boolean'];
};


export type QueryGetSubsaleJointBuyerByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetSubsaleLoanByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetSubsaleUnitDetailArgs = {
  id: Scalars['String'];
};


export type QueryGetSummarySaleContractArgs = {
  saleId: Scalars['String'];
};


export type QueryGetTaxByIdArgs = {
  taxId: Scalars['String'];
};


export type QueryGetTaxListingArgs = {
  schemeTypeId: Array<Scalars['String']>;
};


export type QueryGetTaxRateArgs = {
  taxSchemeId: Scalars['String'];
};


export type QueryGetTaxSchemeByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetTeamBiArgs = {
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
};


export type QueryGetTeamsArgs = {
  projectId: Scalars['String'];
};


export type QueryGetTempPAlateInterestListArgs = {
  generateDate: Scalars['DateTime'];
  saleId: Scalars['String'];
  temporary: Scalars['Boolean'];
};


export type QueryGetTimeSlotByDateArgs = {
  date: Scalars['DateTime'];
};


export type QueryGetTownshipArgs = {
  accountId?: InputMaybe<Scalars['String']>;
  commonStatus?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  orderByAsc?: InputMaybe<Scalars['String']>;
  orderByDesc?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Float']>;
  take?: InputMaybe<Scalars['Float']>;
};


export type QueryGetTransactionCodeListingArgs = {
  id?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetUnassignedStaffListArgs = {
  projectId: Scalars['String'];
};


export type QueryGetUnassignedTeamMembersArgs = {
  projectId: Scalars['String'];
  teamId: Scalars['String'];
};


export type QueryGetUnitAndContactListArgs = {
  projectId: Scalars['String'];
  saleId?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetUnitAtAreaVarianceArgs = {
  unitId: Scalars['String'];
};


export type QueryGetUnitBookingDetailsArgs = {
  projectId: Scalars['String'];
  saleId: Scalars['String'];
};


export type QueryGetUnitBookingDetailsBySaleIdArgs = {
  projectId: Scalars['String'];
  saleId: Scalars['String'];
};


export type QueryGetUnitBookingListingSaleArgs = {
  approvalStatus?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
};


export type QueryGetUnitByIdArgs = {
  unitId: Scalars['String'];
};


export type QueryGetUnitByProjectBlockArgs = {
  Block: Scalars['String'];
  ProjectId: Scalars['String'];
};


export type QueryGetUnitByStatusArgs = {
  launchDate: Scalars['DateTime'];
  projectId: Scalars['String'];
};


export type QueryGetUnitByUnitIdArgs = {
  projectId: Scalars['String'];
  unitId: Scalars['String'];
};


export type QueryGetUnitDetailArgs = {
  unitId: Scalars['String'];
};


export type QueryGetUnitDetailsArgs = {
  unitId: Scalars['String'];
};


export type QueryGetUnitForPaymentPlanDetailsArgs = {
  loanPaymentPlanDetails: Array<UnitForPaymentPlanDetailsInput>;
};


export type QueryGetUnitGalleryByProjectArgs = {
  projectId: Scalars['String'];
};


export type QueryGetUnitInfoArgs = {
  unitId: Scalars['String'];
};


export type QueryGetUnitLayoutBlockByProjectIdArgs = {
  ProjectId: Scalars['String'];
};


export type QueryGetUnitListArgs = {
  contactId?: InputMaybe<Scalars['String']>;
};


export type QueryGetUnitListAtAreaVarianceArgs = {
  projectId: Scalars['String'];
};


export type QueryGetUnitListTransferArgs = {
  projectId: Scalars['String'];
  unitTransferId?: InputMaybe<Scalars['String']>;
};


export type QueryGetUnitMasterDataArgs = {
  projectId: Scalars['String'];
};


export type QueryGetUnitPropertyTitleCreateArgs = {
  projectId: Scalars['String'];
  propertyTitleId?: InputMaybe<Scalars['String']>;
};


export type QueryGetUnitPropertyTitleListArgs = {
  projectId: Scalars['String'];
};


export type QueryGetUnitStatutoryDocumentListByTypeArgs = {
  perSalesContract: Scalars['Boolean'];
  projectId: Scalars['String'];
  statutoryDocumentId: Scalars['String'];
};


export type QueryGetUnitsVpLetterByDateArgs = {
  vpLetterDate: Scalars['DateTime'];
};


export type QueryGetUnitTransferByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetUnitTransferIndoByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetUnitTransferIndoDetailsArgs = {
  transferId: Scalars['String'];
};


export type QueryGetUnitTransferIndoListArgs = {
  status: Scalars['String'];
};


export type QueryGetUnitTransferIndoMasterDataArgs = {
  transferDate?: InputMaybe<Scalars['DateTime']>;
  transferId?: InputMaybe<Scalars['String']>;
};


export type QueryGetUnitTransferListingArgs = {
  status: Scalars['String'];
};


export type QueryGetUnitTransferPaymentPlanDetailsArgs = {
  finalContractPrice?: InputMaybe<Scalars['Float']>;
  InstallmentSummaryInput?: InputMaybe<Array<InstallmentSummaryInput>>;
  isCarparkOrPackage?: InputMaybe<Scalars['Boolean']>;
  paymentMarkUpAmt?: InputMaybe<Scalars['Float']>;
  paymentPlanId: Scalars['String'];
  prevSaleId: Scalars['String'];
  regDate?: InputMaybe<Scalars['DateTime']>;
  taxSchemeId?: InputMaybe<Scalars['String']>;
  unitId: Scalars['String'];
};


export type QueryGetUnitTransferPricingPaymentPlanDetailsArgs = {
  inputs: Array<GetUnitTransferPricingPaymentPlanInput>;
};


export type QueryGetUnitTypeByIdArgs = {
  unitTypeId: Scalars['String'];
};


export type QueryGetUnitTypeListArgs = {
  projectId: Scalars['String'];
};


export type QueryGetUnitWorkProgressCreateArgs = {
  isCarpark: Scalars['Boolean'];
  progressIds: Array<Scalars['String']>;
  projectId: Scalars['String'];
};


export type QueryGetUnitWorkProgressUpdateArgs = {
  id: Scalars['String'];
  isCarpark: Scalars['Boolean'];
  projectId: Scalars['String'];
};


export type QueryGetUserDetailsArgs = {
  userId: Scalars['String'];
};


export type QueryGetUsersRoleProjectArgs = {
  projectId: Scalars['String'];
  roleId: Scalars['String'];
};


export type QueryGetVideoGalleryByProjectArgs = {
  projectId: Scalars['String'];
};


export type QueryGetVpLetterArgs = {
  id?: InputMaybe<Scalars['String']>;
  orderByAsc?: InputMaybe<Scalars['String']>;
  orderByDesc?: InputMaybe<Scalars['String']>;
  project_id: Scalars['String'];
  skip?: InputMaybe<Scalars['Float']>;
  take?: InputMaybe<Scalars['Float']>;
};


export type QueryGetVPviewUnitArgs = {
  vpLetterDate: Scalars['DateTime'];
};


export type QueryGetWaitListDetailsByDirectionIdArgs = {
  directionId?: InputMaybe<Scalars['String']>;
};


export type QueryGetWaitListDetailsByViewArgs = {
  view?: InputMaybe<Scalars['String']>;
};


export type QueryGetWeeklySalesAnalysisCountArgs = {
  salesType: Scalars['String'];
  selectedDate: Scalars['DateTime'];
};


export type QueryGetWorkProgressByIdArgs = {
  workProgressId: Scalars['String'];
};


export type QueryGetWorkProgressBySaleArgs = {
  saleId: Scalars['String'];
};


export type QueryGlAccountCodeArgs = {
  companyId: Scalars['String'];
};


export type QueryGlEndFinancierListArgs = {
  companyId: Scalars['String'];
};


export type QueryImportExcelArgs = {
  file: Scalars['Upload'];
  importType: Scalars['String'];
  method: Scalars['String'];
  projectId: Scalars['String'];
};


export type QueryImportUnitOptionsArgs = {
  checkType: Scalars['String'];
  projectId: Scalars['String'];
};


export type QueryIsCanEditOrDeleteCommisionTypeArgs = {
  commisionId: Scalars['String'];
};


export type QueryIsCodeExistArgs = {
  code: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
};


export type QueryIsEmailExistArgs = {
  email: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
};


export type QueryIsEndFinEmailExistArgs = {
  email: Scalars['String'];
};


export type QueryIsIntegratedProjectArgs = {
  projectId: Scalars['String'];
};


export type QueryIsMortgagePaymentExistArgs = {
  input: MortgagePaymentValidationInput;
};


export type QueryIsMortgagePlanExistArgs = {
  input: MortgagePlanValidationInput;
};


export type QueryIsMortgageRetentionExistArgs = {
  input: MortgageRetentionValidationInput;
};


export type QueryIsSolicitorExistArgs = {
  email: Scalars['String'];
  solicitor_appointed_id: Scalars['String'];
};


export type QueryIsUserNameExistArgs = {
  userId?: InputMaybe<Scalars['String']>;
  userName: Scalars['String'];
};


export type QueryLoanSettlementUnitFormSourceArgs = {
  saleId?: InputMaybe<Scalars['String']>;
};


export type QueryMarkAllReadArgs = {
  projectId?: InputMaybe<Scalars['String']>;
};


export type QueryNotaryAssignmentLastUpdateArgs = {
  projectId: Scalars['String'];
};


export type QueryNotificationDispatcherArgs = {
  notificationIds: Array<Scalars['String']>;
};


export type QueryOverduePurchaserAccountCaListingArgs = {
  overduePurchaserAccountId: Scalars['String'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
};


export type QueryOverduePurchaserAccountListingArgs = {
  projectId: Scalars['String'];
  saleId?: InputMaybe<Scalars['String']>;
};


export type QueryOverduePurchaserAccountSummaryArgs = {
  projectId: Scalars['String'];
};


export type QueryPanelByProjectArgs = {
  projectId: Scalars['String'];
};


export type QueryPanelDetailsArgs = {
  financier_id: Scalars['String'];
  project_id: Scalars['String'];
};


export type QueryPanelEndFinCountArgs = {
  projectId: Scalars['String'];
};


export type QueryPanelFinancierListArgs = {
  financier_id?: InputMaybe<Scalars['String']>;
  project_id: Scalars['String'];
};


export type QueryPanelSolicitorCountArgs = {
  projectId: Scalars['String'];
};


export type QueryPaymentGatewayDetailsArgs = {
  payment_gateway_id: Scalars['String'];
};


export type QueryPriceAdjustmentSummaryArgs = {
  projectId: Scalars['String'];
};


export type QueryProgressBillingListForGenerateArgs = {
  booked: Scalars['Boolean'];
  docDate: Scalars['DateTime'];
  signed: Scalars['Boolean'];
};


export type QueryProjectCampaignCountArgs = {
  projectId?: InputMaybe<Scalars['String']>;
};


export type QueryProjectClusterNameExistArgs = {
  clusterId?: InputMaybe<Scalars['String']>;
  developmentCompany: Scalars['String'];
  name: Scalars['String'];
};


export type QueryProjectCommissionPackageDateArgs = {
  projectId: Scalars['String'];
};


export type QueryProjectCommissionTeamStructureDateArgs = {
  projectId: Scalars['String'];
};


export type QueryProjectDetailArgs = {
  id: Scalars['String'];
};


export type QueryProjectLastUpdateArgs = {
  projectId: Scalars['String'];
};


export type QueryProjectLetterLastUpdateArgs = {
  projectId: Scalars['String'];
};


export type QueryProjectPaymentPlanCountArgs = {
  projectId: Scalars['String'];
};


export type QueryProjectPaymentPlanLastUpdateArgs = {
  projectId: Scalars['String'];
};


export type QueryProjectReminderSettingLastUpdateArgs = {
  projectId: Scalars['String'];
};


export type QueryProjectSalesPolicyLastUpdateArgs = {
  projectId: Scalars['String'];
};


export type QueryPromotionalPackagesLastUpdateArgs = {
  projectId: Scalars['String'];
};


export type QueryReCalculateTotalSaleDiscountArgs = {
  paymentPlanMarkUpAmt: Scalars['Float'];
  saleId: Scalars['String'];
};


export type QueryReversalArchCertUnitListingArgs = {
  architectCertId: Scalars['String'];
};


export type QueryRoleAuthLastUpdateArgs = {
  projectId: Scalars['String'];
};


export type QuerySalesLoanBuyBackMasterDataArgs = {
  companyId: Scalars['String'];
  isAddForm?: InputMaybe<Scalars['Boolean']>;
};


export type QuerySalesLoanBuyBackMasterDataDetailsArgs = {
  companyId: Scalars['String'];
  isAddForm?: InputMaybe<Scalars['Boolean']>;
};


export type QuerySalesOfficeLastUpdateArgs = {
  projectId: Scalars['String'];
};


export type QuerySalesPackagesCountArgs = {
  projectId: Scalars['String'];
};


export type QuerySalesTestPermissionArgs = {
  salesPerm: SalesAdminPermission;
};


export type QuerySolicitorAppointedDetailsArgs = {
  solicitor_appointed_id: Scalars['String'];
};


export type QuerySolicitorAppointedListArgs = {
  project_id: Scalars['String'];
};


export type QuerySolicitorDetailsArgs = {
  solicitor_appointed_id: Scalars['String'];
};


export type QuerySolicitorListForAssignmentArgs = {
  project_id: Scalars['String'];
};


export type QueryStampDutyIntegrationLastUpdateArgs = {
  projectId: Scalars['String'];
};


export type QueryTeamAssignmentLastUpdateArgs = {
  projectId: Scalars['String'];
};


export type QueryTodoListArgs = {
  limit: Scalars['Float'];
  page: Scalars['Float'];
  search?: InputMaybe<Scalars['String']>;
};


export type QueryTotalFinancialLimitArgs = {
  projectId: Scalars['String'];
};


export type QueryTownshipListingArgs = {
  companyId: Scalars['String'];
};


export type QueryUnitCountArgs = {
  projectId: Scalars['String'];
};


export type QueryUnitStatutoryDocumentCountArgs = {
  projectId: Scalars['String'];
};


export type QueryUpdateSalesChartArgs = {
  models: Array<AdminUnitSalesChartInput>;
};


export type QueryUploadStatutoryDocumentListArgs = {
  file: Scalars['Upload'];
  projectId: Scalars['String'];
};


export type QueryUserListingArgs = {
  activeStatus?: InputMaybe<Scalars['String']>;
  activeUserOnly?: InputMaybe<Scalars['Boolean']>;
  isSuperUser?: InputMaybe<Scalars['Boolean']>;
};


export type QueryWaitingListTableBiArgs = {
  unit_layout_id: Scalars['String'];
  unit_type_id: Scalars['String'];
};

export type QueryFilterString = {
  __typename?: 'QueryFilterString';
  Column: Scalars['String'];
  Expression: Scalars['String'];
  ParameterName?: Maybe<Scalars['String']>;
  Value: Scalars['String'];
};

export type QueryFilterStringInput = {
  Column: Scalars['String'];
  Expression: Scalars['String'];
  ParameterName?: InputMaybe<Scalars['String']>;
  Value: Scalars['String'];
};

export type QueryParameter = {
  __typename?: 'QueryParameter';
  Name: Scalars['String'];
  Type?: Maybe<Scalars['String']>;
  Value: Scalars['String'];
  ValueType: Scalars['String'];
};

export type QueryParameterInput = {
  Name: Scalars['String'];
  Type?: InputMaybe<Scalars['String']>;
  Value: Scalars['String'];
  ValueType: Scalars['String'];
};

export type RaceEntity = {
  __typename?: 'raceEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  contacts: Array<ContactEntity>;
  defaulted: Scalars['Boolean'];
  id: Scalars['String'];
  isDeletable: Scalars['Boolean'];
  isExistInMasterData: Array<Scalars['String']>;
  isExistInTransactionData: Array<Scalars['String']>;
  name: Scalars['String'];
  seqNo?: Maybe<Scalars['Float']>;
};

export type RaceInput = {
  name: Scalars['String'];
};

export enum ReadStatus {
  Read = 'READ',
  Seen = 'SEEN',
  Unread = 'UNREAD'
}

export type ReasonCodeEntity = {
  __typename?: 'reasonCodeEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  defaulted: Scalars['Boolean'];
  id: Scalars['String'];
  isDeletable: Scalars['Boolean'];
  isExistInMasterData: Array<Scalars['String']>;
  isExistInTransactionData: Array<Scalars['String']>;
  name: Scalars['String'];
  seqNo?: Maybe<Scalars['Float']>;
  systemUse: Scalars['Boolean'];
  type: Scalars['String'];
};

export type ReasonCodeInput = {
  name: Scalars['String'];
  type: Scalars['String'];
};

export type ReasonCodeTypeListingOutput = {
  __typename?: 'ReasonCodeTypeListingOutput';
  reasonCodeType: Scalars['String'];
};

export type RebateEntity = {
  __typename?: 'rebateEntity';
  accountId: Scalars['String'];
  allocation?: Maybe<Array<AllocationEntity>>;
  allocationData?: Maybe<Array<AllocationData>>;
  allowReversal: Scalars['Boolean'];
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  approveUserData?: Maybe<UserEntity>;
  attachment?: Maybe<Array<AttachmentEntity>>;
  billItem?: Maybe<BillItemEntity>;
  billItemId: Scalars['String'];
  billItemInt?: Maybe<BillItemIntEntity>;
  clusterName?: Maybe<ProjectClusterEntity>;
  commonStatus: Scalars['String'];
  contactDetail?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  documentAmount: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  documentNo?: Maybe<Scalars['String']>;
  documentRef?: Maybe<Scalars['String']>;
  glGenerated: Scalars['String'];
  glGenerationBatch?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  projectDetail?: Maybe<ProjectEntity>;
  projectId: Scalars['String'];
  requestedBy?: Maybe<Scalars['String']>;
  requestUserData?: Maybe<UserEntity>;
  saleId: Scalars['String'];
  saleRebatePackage: SaleRebatePackageEntity;
  salesRegNo?: Maybe<SaleExtensionEntity>;
  status: Scalars['String'];
  submittedBy?: Maybe<Scalars['String']>;
  submittedDate?: Maybe<Scalars['DateTime']>;
  submitUserData?: Maybe<UserEntity>;
  taxData?: Maybe<TaxSchemeDropdownOutput>;
  taxLedger?: Maybe<TaxLedgerEntity>;
  unallocatedAmount?: Maybe<Scalars['Float']>;
  unallocatedAmountSummary?: Maybe<Scalars['Float']>;
  unitDetail?: Maybe<Scalars['String']>;
  voidBy?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
  voidUserData?: Maybe<UserEntity>;
};

export type RebateSummary = {
  __typename?: 'RebateSummary';
  approveCount?: Maybe<Scalars['Float']>;
  draftCount?: Maybe<Scalars['Float']>;
  submitCount?: Maybe<Scalars['Float']>;
  totalDocAmt?: Maybe<Scalars['Float']>;
  totalUnallocatedAmt?: Maybe<Scalars['Float']>;
};

export type ReceiptAllocationList = {
  __typename?: 'receiptAllocationList';
  allocateAmount: Scalars['Float'];
  description?: Maybe<Scalars['String']>;
  documentDate: Scalars['DateTime'];
  documentNo: Scalars['String'];
};

export type ReceiptAllocationListData = {
  __typename?: 'receiptAllocationListData';
  allocateAmount: Scalars['Float'];
  description?: Maybe<Scalars['String']>;
  documentDate: Scalars['DateTime'];
  documentNo: Scalars['String'];
};

export type ReceiptbillingOutput = {
  __typename?: 'receiptbillingOutput';
  creditId?: Maybe<Scalars['String']>;
  debitId: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  documentAmount?: Maybe<Scalars['Float']>;
  documentDate?: Maybe<Scalars['DateTime']>;
  documentNo?: Maybe<Scalars['String']>;
  outstanding?: Maybe<Scalars['Float']>;
  table?: Maybe<Scalars['String']>;
  totalAllocated?: Maybe<Scalars['Float']>;
};

export type ReceiptEntity = {
  __typename?: 'receiptEntity';
  accountId: Scalars['String'];
  accounts?: Maybe<Array<CompanyBankAccountEntity>>;
  allocation?: Maybe<Array<AllocationEntity>>;
  allocationData?: Maybe<Array<AllocationData>>;
  allowReversal: Scalars['Boolean'];
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  approveUserData?: Maybe<UserEntity>;
  attachment?: Maybe<Array<AttachmentEntity>>;
  bankAccount?: Maybe<CompanyBankAccountEntity>;
  bankAccountId?: Maybe<Scalars['String']>;
  cbGenerated: Scalars['Boolean'];
  cbGenerationBatch?: Maybe<Scalars['String']>;
  chequeDate?: Maybe<Scalars['DateTime']>;
  chequeExpireDate?: Maybe<Scalars['DateTime']>;
  clusterName?: Maybe<ProjectClusterEntity>;
  commonStatus: Scalars['String'];
  contactDetail?: Maybe<Scalars['String']>;
  creditCardFacilityId?: Maybe<Scalars['String']>;
  creditCardType?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  documentAmount: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  documentNo?: Maybe<Scalars['String']>;
  documentRef?: Maybe<Scalars['String']>;
  exchangeRate?: Maybe<Scalars['Float']>;
  financierId?: Maybe<Scalars['String']>;
  financiers?: Maybe<Array<FinancierEntity>>;
  generationBatch: Scalars['String'];
  generationBatchDate: Scalars['DateTime'];
  glGenerated: Scalars['String'];
  glGenerationBatch?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  paymentMethod: Scalars['String'];
  projectDetail?: Maybe<UserEntity>;
  projectId: Scalars['String'];
  receiptAmount: Scalars['Float'];
  refId?: Maybe<Scalars['String']>;
  refTable?: Maybe<Scalars['String']>;
  saleId: Scalars['String'];
  sales?: Maybe<SaleEntity>;
  salesRegNo?: Maybe<SaleExtensionEntity>;
  status: Scalars['String'];
  submittedBy?: Maybe<Scalars['String']>;
  submittedDate?: Maybe<Scalars['DateTime']>;
  submitUserData?: Maybe<UserEntity>;
  taxData?: Maybe<TaxSchemeDropdownOutput>;
  taxLedger?: Maybe<TaxLedgerEntity>;
  unallocatedAmount?: Maybe<Scalars['Float']>;
  unallocatedAmountSummary?: Maybe<Scalars['Float']>;
  unitDetail?: Maybe<Scalars['String']>;
  voidBy?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
  voidUserData?: Maybe<UserEntity>;
};

export type ReceiptInput = {
  allocationList?: InputMaybe<Array<AllocationList>>;
  attachment?: InputMaybe<Array<Scalars['Upload']>>;
  bankAccountId: Scalars['String'];
  chequeDate?: InputMaybe<Scalars['DateTime']>;
  chequeExpireDate?: InputMaybe<Scalars['DateTime']>;
  creditCardType?: InputMaybe<CreditCardType>;
  description: Scalars['String'];
  documentAmount: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  paymentMethod: PaymentMethod;
  receiptAmount: Scalars['Float'];
  referenceNo: Scalars['String'];
  saleId: Scalars['String'];
  status: CreditControlStatus;
};

export type ReceiptMasterDateOutput = {
  __typename?: 'receiptMasterDateOutput';
  currency?: Maybe<Scalars['String']>;
  unitList?: Maybe<Array<UnitList>>;
};

export type ReceiptOutput = {
  __typename?: 'receiptOutput';
  allocateAmount: Scalars['Float'];
  allocationDocumentNo?: Maybe<Scalars['String']>;
  allocationList?: Maybe<Array<ReceiptAllocationList>>;
  allowReversal: Scalars['Boolean'];
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  bankAccountId: Scalars['String'];
  bankAccountNo: Scalars['String'];
  bankCode: Scalars['String'];
  chequeDate?: Maybe<Scalars['DateTime']>;
  chequeExpireDate?: Maybe<Scalars['DateTime']>;
  creditCardType?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  docType: Scalars['String'];
  documentAmount: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  documentNo?: Maybe<Scalars['String']>;
  documentRef?: Maybe<Scalars['String']>;
  exchangeRate?: Maybe<Scalars['Float']>;
  financierId?: Maybe<Scalars['String']>;
  financierName?: Maybe<Scalars['String']>;
  generationBatch?: Maybe<Scalars['String']>;
  generationBatchDate?: Maybe<Scalars['DateTime']>;
  getAttachment?: Maybe<Array<AttachmentEntity>>;
  paymentMethod?: Maybe<Scalars['String']>;
  projectDetail?: Maybe<ProjectEntity>;
  receiptAmount: Scalars['Float'];
  receiptId: Scalars['String'];
  salesId: Scalars['String'];
  status: Scalars['String'];
  submittedBy?: Maybe<Scalars['String']>;
  submittedDate?: Maybe<Scalars['DateTime']>;
  unAllocateAmount: Scalars['Float'];
  unitNo: Scalars['String'];
  voidBy?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
};

export type ReceiptOutputList = {
  __typename?: 'receiptOutputList';
  allocationId?: Maybe<Array<Scalars['String']>>;
  creditId: Scalars['String'];
  debitId?: Maybe<Array<Scalars['String']>>;
  salesId: Scalars['String'];
};

export type ReceiptReversalEntity = {
  __typename?: 'receiptReversalEntity';
  accountId: Scalars['String'];
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  bankAccount?: Maybe<Array<CompanyBankAccountEntity>>;
  bankAccountId?: Maybe<Scalars['String']>;
  cbGenerated: Scalars['Boolean'];
  cbGenerationBatch?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  currency?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  documentAmount: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  documentNo: Scalars['String'];
  exchangeRate?: Maybe<Scalars['Float']>;
  financierId?: Maybe<Scalars['String']>;
  financiers?: Maybe<Array<FinancierEntity>>;
  glGenerated: Scalars['String'];
  glGenerationBatch?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  projectId: Scalars['String'];
  receiptAmount: Scalars['Float'];
  saleId: Scalars['String'];
  sales?: Maybe<SaleEntity>;
  status: Scalars['String'];
  submittedBy?: Maybe<Scalars['String']>;
  submittedDate?: Maybe<Scalars['DateTime']>;
  voidBy?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
};

export type RedemptionDetailEntity = {
  __typename?: 'redemptionDetailEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  contraId?: Maybe<Scalars['String']>;
  documentNo?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  projectId: Scalars['String'];
  redemption: RedemptionEntity;
  redemptionAmount: Scalars['Float'];
  redemptionId: Scalars['String'];
  unitId: Scalars['String'];
};

export type RedemptionEntity = {
  __typename?: 'redemptionEntity';
  accountId: Scalars['String'];
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  commonStatus: Scalars['String'];
  documentDate: Scalars['DateTime'];
  id: Scalars['String'];
  isPosted: Scalars['Boolean'];
  paidById: Scalars['String'];
  paidByParty: Scalars['String'];
  paymentParty: Scalars['String'];
  projectId: Scalars['String'];
  redemptionDetails: Array<RedemptionDetailEntity>;
  redemptionSum: Scalars['Float'];
  redemptionUnitsCount?: Maybe<Scalars['Float']>;
  referenceNo?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  submittedBy?: Maybe<Scalars['DateTime']>;
  submittedDate?: Maybe<Scalars['DateTime']>;
  voidBy?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
};

export type RedemptionRepaymentByIdOutput = {
  __typename?: 'redemptionRepaymentByIdOutput';
  redemption: RedemptionEntity;
  redemptionUnits: Array<RedemptionUnitsDetails>;
};

export type RedemptionRepaymentDetailInput = {
  redemptionAmount: Scalars['Float'];
  unitId: Scalars['String'];
};

export type RedemptionRepaymentInput = {
  documentDate: Scalars['DateTime'];
  paidById: Scalars['String'];
  paymentParty: Scalars['String'];
  redemptionDetailArray: Array<RedemptionRepaymentDetailInput>;
  redemptionSum: Scalars['Float'];
  referenceNo?: InputMaybe<Scalars['String']>;
};

export type RedemptionRepaymentListingOutput = {
  __typename?: 'redemptionRepaymentListingOutput';
  byThisParty?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  documentDate: Scalars['DateTime'];
  documentNo?: Maybe<Array<Scalars['String']>>;
  financierCode?: Maybe<Scalars['String']>;
  financierName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  icNo?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isPosted: Scalars['Boolean'];
  paidById: Scalars['String'];
  paymentParty: Scalars['String'];
  redemptionSum: Scalars['Float'];
  redemptionUnitsCount: Scalars['Float'];
  referenceNo?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  unitNo: Array<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
};

export type RedemptionUnitsDetails = {
  __typename?: 'redemptionUnitsDetails';
  documentNo?: Maybe<Scalars['String']>;
  redemptionAmount: Scalars['Float'];
  unitId: Scalars['String'];
  unitNo: Scalars['String'];
};

export type RedemptionUnitsSelection = {
  __typename?: 'redemptionUnitsSelection';
  redemptionAmount: Scalars['Float'];
  redemptionBalance: Scalars['Float'];
  unitId: Scalars['String'];
  unitNo: Scalars['String'];
};

export type RefinancingDataOutput = {
  __typename?: 'refinancingDataOutput';
  financierLists: Array<FinancierLists>;
  unitList: Array<RefinancingUnitList>;
};

export type RefinancingDetailFieldOutput = {
  __typename?: 'refinancingDetailFieldOutput';
  buyerName?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  financierDetail: Array<UnitFinancierDetailOutput>;
  isCompany?: Maybe<Scalars['Boolean']>;
  unitNo: Scalars['String'];
};

export type RefinancingDetailOutput = {
  __typename?: 'refinancingDetailOutput';
  financierList: Array<FinancierListOutput>;
  generationBatch: Scalars['String'];
  refinancingLoan?: Maybe<RefinancingDetailFieldOutput>;
  refTable: Scalars['String'];
  saleId: Scalars['String'];
};

export type RefinancingEntity = {
  __typename?: 'refinancingEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  completedDate?: Maybe<Scalars['DateTime']>;
  doaDate: Scalars['DateTime'];
  doaSolicitorId: Scalars['String'];
  doaSolicitorReferenceNo: Scalars['String'];
  financierId: Scalars['String'];
  financierReferenceNo: Scalars['String'];
  generationBatch: Scalars['String'];
  id: Scalars['String'];
  loanAgreementDate: Scalars['DateTime'];
  loanAmount: Scalars['Float'];
  loanSeqNo?: Maybe<Scalars['Float']>;
  loanSolicitorId: Scalars['String'];
  loanSolicitorReferenceNo?: Maybe<Scalars['String']>;
  projectId: Scalars['String'];
  refId: Scalars['String'];
  refTable?: Maybe<Scalars['String']>;
  rrDate: Scalars['DateTime'];
  rrSolicitorId: Scalars['String'];
  rrSolicitorReferenceNo: Scalars['String'];
  status: Scalars['String'];
};

export type RefinancingInfolineOutput = {
  __typename?: 'refinancingInfolineOutput';
  loanAmount?: Maybe<Scalars['Float']>;
  refinancingCount?: Maybe<Scalars['Float']>;
};

export type RefinancingListingOutput = {
  __typename?: 'refinancingListingOutput';
  buyerName?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  completedDate?: Maybe<Scalars['DateTime']>;
  financierList: Array<Scalars['String']>;
  generationBatch: Scalars['String'];
  isCompany?: Maybe<Scalars['Boolean']>;
  loanAgreementDate: Scalars['DateTime'];
  loanAmount: Scalars['Float'];
  status: Scalars['String'];
  unitNo: Scalars['String'];
};

export type RefinancingListOutput = {
  __typename?: 'refinancingListOutput';
  approvalStatus: Scalars['String'];
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  borrowerAcct: Scalars['String'];
  borrowerName: Scalars['String'];
  endfinancierMortgageId: Scalars['String'];
  fullName: Scalars['String'];
  id: Scalars['String'];
  loanRefRecordId: Scalars['String'];
  loanRefTable: Scalars['String'];
  mortgageName: Scalars['String'];
  newFinancier: Scalars['String'];
  newFinancierId: Scalars['String'];
  newPaymentPlan: Array<NewPaymentPlan>;
  oldBalance: Array<OldBalance>;
  oldFinancier: Scalars['String'];
  oldFinancierId: Scalars['String'];
  projectId: Scalars['String'];
  refinancingDate: Scalars['DateTime'];
  refinancingNo?: Maybe<Scalars['String']>;
  remarks: Scalars['String'];
  saleId: Scalars['String'];
  submittedBy?: Maybe<Scalars['String']>;
  submittedDate?: Maybe<Scalars['DateTime']>;
  unitNo: Scalars['String'];
};

export type RefinancingUnitDropDownOutput = {
  __typename?: 'refinancingUnitDropDownOutput';
  buyerName?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  financierDetail: Array<UnitFinancierDetailOutput>;
  id: Scalars['String'];
  isCompany?: Maybe<Scalars['Boolean']>;
  table: Scalars['String'];
  unitNo: Scalars['String'];
};

export type RefinancingUnitList = {
  __typename?: 'refinancingUnitList';
  approved_date?: Maybe<Scalars['DateTime']>;
  borrower_acct?: Maybe<Scalars['String']>;
  borrower_name: Scalars['String'];
  endfinancier_mortgage_plan_id?: Maybe<Scalars['String']>;
  full_name: Scalars['String'];
  loan_sign_date?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  old_balance?: Maybe<Array<Scalars['JSONObject']>>;
  projectId: Scalars['String'];
  sale_id: Scalars['String'];
  sale_loan_id: Scalars['String'];
  sale_loan_payment_id?: Maybe<Scalars['String']>;
  saleLoanPayment?: Maybe<Array<SalePaymentOutput>>;
  table_ref: Scalars['String'];
  unit_no: Scalars['String'];
  unitClusterId: Scalars['String'];
  unitId: Scalars['String'];
  unitNo: Scalars['String'];
};

export type RefundAllocationOutput = {
  __typename?: 'RefundAllocationOutput';
  creditId: Scalars['String'];
  creditRefTable: Scalars['String'];
  currentAllocate: Scalars['Float'];
  description?: Maybe<Scalars['String']>;
  docAmt: Scalars['Float'];
  docDate: Scalars['DateTime'];
  docNo: Scalars['String'];
  outstandingAmt: Scalars['Float'];
  totalAllocate: Scalars['Float'];
};

export type RefundEntity = {
  __typename?: 'refundEntity';
  accountId: Scalars['String'];
  allocationData?: Maybe<Array<AllocationData>>;
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  approveUserData?: Maybe<UserEntity>;
  attachment?: Maybe<Array<AttachmentEntity>>;
  bankAccount?: Maybe<CompanyBankAccountEntity>;
  bankAccountId?: Maybe<Scalars['String']>;
  chequeDate?: Maybe<Scalars['DateTime']>;
  chequeExpireDate?: Maybe<Scalars['DateTime']>;
  clusterName?: Maybe<ProjectClusterEntity>;
  commonStatus: Scalars['String'];
  contactDetail?: Maybe<Scalars['String']>;
  creditCardType?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  documentAmount: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  documentNo?: Maybe<Scalars['String']>;
  documentRef?: Maybe<Scalars['String']>;
  glGenerated: Scalars['String'];
  glGenerationBatch?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  projectDetail?: Maybe<ProjectEntity>;
  projectId: Scalars['String'];
  refundMethod: Scalars['String'];
  saleId: Scalars['String'];
  sales?: Maybe<SaleEntity>;
  salesRegNo?: Maybe<SaleExtensionEntity>;
  status: Scalars['String'];
  submittedBy?: Maybe<Scalars['String']>;
  submittedDate?: Maybe<Scalars['DateTime']>;
  submitUserData?: Maybe<UserEntity>;
  taxData?: Maybe<TaxSchemeDropdownOutput>;
  taxLedger?: Maybe<TaxLedgerEntity>;
  unallocatedAmount?: Maybe<Scalars['Float']>;
  unitDetail?: Maybe<Scalars['String']>;
};

export type RefundSummary = {
  __typename?: 'RefundSummary';
  approveCount?: Maybe<Scalars['Float']>;
  draftCount?: Maybe<Scalars['Float']>;
  submitCount?: Maybe<Scalars['Float']>;
  totalDocAmt?: Maybe<Scalars['Float']>;
  totalUnallocatedAmt?: Maybe<Scalars['Float']>;
};

export type RegionEntity = {
  __typename?: 'regionEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  defaulted: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
  seqNo?: Maybe<Scalars['Float']>;
  systemUse: Scalars['Boolean'];
};



export type ReleaseCollectedDetailInput = {
  amount: Scalars['Float'];
  dueDate: Scalars['DateTime'];
  id: Scalars['String'];
  saleId: Scalars['String'];
};

export type ReleaseCollectedInput = {
  attachments?: InputMaybe<Array<Scalars['Upload']>>;
  bankAccountId: Scalars['String'];
  detail: Array<ReleaseCollectedDetailInput>;
  paymentDate: Scalars['DateTime'];
  paymentMethod: Scalars['String'];
  referenceNo?: InputMaybe<Scalars['String']>;
  remark?: InputMaybe<Scalars['String']>;
  solicitorId: Scalars['String'];
};

export type ReminderBasicOutput = {
  __typename?: 'reminderBasicOutput';
  emailTemplate?: Maybe<Scalars['String']>;
  isProject: Scalars['Boolean'];
  letterTemplateList?: Maybe<Array<ReminderTemplateListOutput>>;
  multiple: Scalars['Boolean'];
  standardParameters?: Maybe<Array<Scalars['String']>>;
};

export type ReminderDetaiListOutput = {
  __typename?: 'reminderDetaiListOutput';
  bookDate: Scalars['Float'];
  buyerName: Scalars['String'];
  companyName?: Maybe<Scalars['String']>;
  isCompany?: Maybe<Scalars['Boolean']>;
  reminderDate?: Maybe<Scalars['Float']>;
  reminderId: Scalars['String'];
  reminderSeq: Scalars['Float'];
  saleId: Scalars['String'];
  share?: Maybe<Array<ShareObject>>;
  unitNo: Scalars['String'];
};

export type ReminderEntity = {
  __typename?: 'reminderEntity';
  balanceAmount: Scalars['String'];
  batchId: Scalars['String'];
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  ledger: LedgerEntity;
  project: ProjectEntity;
  reminderDate: Scalars['DateTime'];
  reminderNo?: Maybe<Scalars['String']>;
  reminderSeq: Scalars['Float'];
  sale: SaleEntity;
  trxStatus: Scalars['String'];
};

export type ReminderInput = {
  reminderIds: Array<Scalars['String']>;
  sharedBy: Scalars['String'];
  sharedDateTime: Scalars['DateTime'];
};

export type ReminderOutput = {
  __typename?: 'reminderOutput';
  downloadFile: Scalars['Boolean'];
  isProject?: Maybe<Scalars['Boolean']>;
  letterTemplateList?: Maybe<Array<ShareLetterTemplateOutput>>;
};

export type ReminderTemplateListOutput = {
  __typename?: 'reminderTemplateListOutput';
  letterTemplateId: Scalars['String'];
  name: Scalars['String'];
};

export type ReportingExcelOutput = {
  __typename?: 'ReportingExcelOutput';
  base64: Scalars['String'];
  projectName: Scalars['String'];
};

export type ReportingSalesPerformanceData = {
  __typename?: 'ReportingSalesPerformanceData';
  projectData?: Maybe<Array<ProjectDetail>>;
  status: Array<Scalars['String']>;
};

export type ReportingStatus = {
  __typename?: 'ReportingStatus';
  code: Scalars['String'];
  desc: Scalars['String'];
};

export type ReportParameter = {
  __typename?: 'ReportParameter';
  AllowNull?: Maybe<Scalars['Boolean']>;
  Description: Scalars['String'];
  DropDownMember?: Maybe<DropDownMember>;
  GlobalType?: Maybe<Scalars['String']>;
  IsDateRange?: Maybe<Scalars['Boolean']>;
  MultiValue?: Maybe<Scalars['Boolean']>;
  Name: Scalars['String'];
  Tag?: Maybe<Scalars['String']>;
  Type: Scalars['String'];
  Visible?: Maybe<Scalars['Boolean']>;
};

export type ReportParameterInput = {
  AllowNull?: InputMaybe<Scalars['Boolean']>;
  Description: Scalars['String'];
  DropDownMember?: InputMaybe<DropDownMemberInput>;
  GlobalType?: InputMaybe<Scalars['String']>;
  IsDateRange?: InputMaybe<Scalars['Boolean']>;
  MultiValue?: InputMaybe<Scalars['Boolean']>;
  Name: Scalars['String'];
  Tag?: InputMaybe<Scalars['String']>;
  Type: Scalars['String'];
  Visible?: InputMaybe<Scalars['Boolean']>;
};

export type ReportPermissionEntity = AuditEntity & {
  __typename?: 'reportPermissionEntity';
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  permissionId: Scalars['Float'];
  roleId: Scalars['String'];
};

export type RescheduleDetailEntity = {
  __typename?: 'rescheduleDetailEntity';
  accountId: Scalars['String'];
  baseAmt: Scalars['Float'];
  billType: Scalars['String'];
  description: Scalars['String'];
  documentDate: Scalars['DateTime'];
  id: Scalars['String'];
  installmentId: Scalars['String'];
  isSelected: Scalars['Boolean'];
  ledgerType: Scalars['String'];
  reschedule: RescheduleEntity;
  rescheduleId: Scalars['String'];
  startDate: Scalars['DateTime'];
  taxAmt: Scalars['Float'];
};

export type RescheduleDetailInput = {
  baseAmt: Scalars['Float'];
  description: Scalars['String'];
  documentDate: Scalars['String'];
  isSelected: Scalars['Boolean'];
  ledgerType: Scalars['String'];
  rescheduleId: Scalars['String'];
  taxAmt: Scalars['Float'];
};

export type RescheduleDetails = {
  billType: BillType;
  rescheduleAmount: Scalars['Float'];
  rescheduleDescription: Scalars['String'];
  startDate: Scalars['DateTime'];
};

export type RescheduledInstallmentOutput = {
  __typename?: 'RescheduledInstallmentOutput';
  baseAmount?: Maybe<Scalars['Float']>;
  billType: Scalars['String'];
  commonStatus: Scalars['String'];
  description: Scalars['String'];
  documentAmount: Scalars['Float'];
  documentAmt: Scalars['Float'];
  documentDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  saleId: Scalars['String'];
  taxAmount?: Maybe<Scalars['Float']>;
  unallocatedAmount?: Maybe<Scalars['Float']>;
};

export type RescheduledLoanDifferentialInput = {
  installmentIds: Array<Scalars['ID']>;
  newInstallments: Array<RescheduledLoanDifferentialInstallmentInput>;
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  saleLoanId: Scalars['String'];
};

export type RescheduledLoanDifferentialInstallmentInput = {
  baseAmount?: InputMaybe<Scalars['Float']>;
  billType: Scalars['String'];
  desc: Scalars['String'];
  documentDate?: InputMaybe<Scalars['DateTime']>;
  taxAmount?: InputMaybe<Scalars['Float']>;
};

export type RescheduleEntity = {
  __typename?: 'rescheduleEntity';
  accountId: Scalars['String'];
  approvalStatus: Scalars['String'];
  billType: Scalars['String'];
  description: Scalars['String'];
  detail?: Maybe<Array<RescheduleDetailEntity>>;
  documentNo: Scalars['String'];
  id: Scalars['String'];
  isLoanDifferential: Scalars['Boolean'];
  premiumAmt: Scalars['Float'];
  projectId: Scalars['String'];
  recordStatus: Scalars['String'];
  rescheduleDate: Scalars['DateTime'];
  saleId: Scalars['String'];
  startDate: Scalars['DateTime'];
};

export type RescheduleInput = {
  description: Scalars['String'];
  documentNo: Scalars['String'];
  premiumAmt: Scalars['Float'];
  projectId: Scalars['String'];
  rescheduleDate: Scalars['String'];
  saleId: Scalars['String'];
};

export type RescheduleInstallmentOutput = {
  __typename?: 'rescheduleInstallmentOutput';
  approvalStatus?: Maybe<Scalars['String']>;
  billType?: Maybe<Scalars['String']>;
  clusterName?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdByName?: Maybe<Scalars['String']>;
  createdTs?: Maybe<Scalars['DateTime']>;
  descs?: Maybe<Scalars['String']>;
  docDate?: Maybe<Scalars['DateTime']>;
  docNo: Scalars['String'];
  installment?: Maybe<Scalars['Float']>;
  modBy?: Maybe<Scalars['String']>;
  modByName?: Maybe<Scalars['String']>;
  modTs?: Maybe<Scalars['DateTime']>;
  precision?: Maybe<Scalars['String']>;
  premiumAmt?: Maybe<Scalars['Float']>;
  rescheduleId: Scalars['String'];
  saleId: Scalars['String'];
  unitNo?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
};

export type RescheduleInstInput = {
  baseAmt?: InputMaybe<Scalars['Float']>;
  billType?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  docAmt?: InputMaybe<Scalars['Float']>;
  installmentId: Array<Scalars['String']>;
  noInstallment?: InputMaybe<Scalars['Float']>;
  partiallyPaid?: InputMaybe<Array<PartiallyPaidInput>>;
  payableAmt?: InputMaybe<Scalars['Float']>;
  premiumAmt?: InputMaybe<Scalars['Float']>;
  rescheduleDate?: InputMaybe<Scalars['DateTime']>;
  rescheduleDetail: Array<RescheduleDetails>;
  saleId: Scalars['String'];
  startDate?: InputMaybe<Scalars['DateTime']>;
  taxAmt?: InputMaybe<Scalars['Float']>;
};

export type RescheduleLoanDetails = {
  oldInstallmentId?: InputMaybe<Scalars['String']>;
  rescheduleAmount: Scalars['Float'];
  rescheduleBillType: Scalars['String'];
  rescheduleDate: Scalars['DateTime'];
  rescheduleDescription: Scalars['String'];
};

export type RescheduleLoanInput = {
  baseAmt?: InputMaybe<Scalars['Float']>;
  billType?: InputMaybe<Scalars['String']>;
  checkedItems?: InputMaybe<Array<CheckedItems>>;
  description?: InputMaybe<Scalars['String']>;
  docAmt?: InputMaybe<Scalars['Float']>;
  noInstallment?: InputMaybe<Scalars['Float']>;
  partiallyPaidLoanInput?: InputMaybe<Array<PartiallyPaidLoanInput>>;
  payableAmt?: InputMaybe<Scalars['Float']>;
  premiumAmt?: InputMaybe<Scalars['Float']>;
  rescheduleDate: Scalars['DateTime'];
  rescheduleLoanDetails: Array<RescheduleLoanDetails>;
  saleId: Scalars['String'];
  startDate?: InputMaybe<Scalars['DateTime']>;
  taxAmt?: InputMaybe<Scalars['Float']>;
};

export type ResourceEntity = AuditEntity & {
  __typename?: 'resourceEntity';
  account_id: Scalars['String'];
  bucketFileName: Scalars['String'];
  caption?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  fileName: Scalars['String'];
  id: Scalars['String'];
  isPrivate: Scalars['Boolean'];
  mediaType: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  pictureBlocks: Array<PictureBlockEntity>;
  pictureFloors: Array<PictureFloorEntity>;
  pictureGalleries: Array<PictureGalleryEntity>;
  pictureUnitlayouts: Array<PictureUnitlayoutEntity>;
  resourceUrl: Scalars['String'];
  salesCharts: Array<SalesChartEntity>;
};

export type Retention = {
  __typename?: 'retention';
  endfinMortgageRetentionId?: Maybe<Scalars['String']>;
  expectedCount?: Maybe<Scalars['String']>;
  expectedFreq?: Maybe<Scalars['String']>;
  expectedFrom?: Maybe<Scalars['String']>;
  loanAmount?: Maybe<Scalars['String']>;
  retentionBy?: Maybe<Scalars['String']>;
  retentionId?: Maybe<Scalars['String']>;
  retentionName?: Maybe<Scalars['String']>;
};

export type RetentionOutput = {
  __typename?: 'retentionOutput';
  retentionBy: Scalars['String'];
  retentionId: Scalars['String'];
  retentionName: Scalars['String'];
  retentionValue: Scalars['Float'];
};

export type RetentionPlan = {
  endfinMortgageRetentionId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  loanAmount?: InputMaybe<Scalars['Float']>;
  retentionExpectedCount?: InputMaybe<Scalars['String']>;
  retentionExpectedFreq?: InputMaybe<Scalars['String']>;
  retentionExpectedFrom?: InputMaybe<Scalars['String']>;
};

export type ReversalBankPaymentInput = {
  receiptIds: Array<Scalars['String']>;
};

export type ReversalLadInput = {
  ladIds: Array<Scalars['String']>;
};

export type ReversalUnitListingOutput = {
  __typename?: 'reversalUnitListingOutput';
  saleUnitNo?: Maybe<Scalars['String']>;
  unitId?: Maybe<Scalars['String']>;
  unitNo?: Maybe<Scalars['String']>;
  unitStatus?: Maybe<Scalars['String']>;
};

export type RoleEntity = AuditEntity & {
  __typename?: 'roleEntity';
  accountId: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  isDeletable: Scalars['Boolean'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  name: Scalars['String'];
  permissionIds: Array<Scalars['String']>;
  permissions: Array<Scalars['String']>;
  returnSalePermissionOutput: Array<SalesPermission>;
  salesAndReportPermission: Array<Scalars['String']>;
  salesAndReportPermissionIds: Array<Scalars['String']>;
  softwareCode: Scalars['String'];
  userCountByRole: Scalars['Float'];
  users?: Maybe<Array<UserEntity>>;
};


export type RoleEntityUsersArgs = {
  projectId?: InputMaybe<Scalars['String']>;
};

export type RoundingListingOutput = {
  __typename?: 'roundingListingOutput';
  id: Scalars['String'];
  name: Scalars['String'];
};

export enum RoundingMode {
  DescriptionList = 'DescriptionList',
  Down = 'DOWN',
  GetDescription = 'GetDescription',
  NoRounding = 'NO_ROUNDING',
  Rounding = 'ROUNDING',
  Up = 'UP'
}

export enum RoundingModeInt {
  DescriptionList = 'DescriptionList',
  Down = 'DOWN',
  GetDescription = 'GetDescription',
  Rounding = 'ROUNDING',
  Up = 'UP'
}

export type RoundingOutput = {
  __typename?: 'roundingOutput';
  roundingMode: Array<RoundingListingOutput>;
  roundingPrecision: Array<RoundingListingOutput>;
};

export enum RoundingPrecision {
  Cent = 'CENT',
  CentTen = 'CENT_TEN',
  DescriptionList = 'DescriptionList',
  Dollar = 'DOLLAR',
  DollarHundred = 'DOLLAR_HUNDRED',
  DollarTen = 'DOLLAR_TEN',
  DollarTenThousand = 'DOLLAR_TEN_THOUSAND',
  DollarThousand = 'DOLLAR_THOUSAND',
  GetDescription = 'GetDescription'
}

export enum RoundingPrecisionInt {
  DescriptionList = 'DescriptionList',
  Dollar = 'DOLLAR',
  DollarHundred = 'DOLLAR_HUNDRED',
  DollarHundredThousand = 'DOLLAR_HUNDRED_THOUSAND',
  DollarMillion = 'DOLLAR_MILLION',
  DollarTen = 'DOLLAR_TEN',
  DollarTenThousand = 'DOLLAR_TEN_THOUSAND',
  DollarThousand = 'DOLLAR_THOUSAND',
  GetDescription = 'GetDescription',
  PointZeroOneCent = 'POINT_ZERO_ONE_CENT',
  ZeroPointOneCent = 'ZERO_POINT_ONE_CENT'
}

export type RrSolicitorInput = {
  rrDate?: InputMaybe<Scalars['DateTime']>;
  rrSolicitorId?: InputMaybe<Scalars['String']>;
  rrSolicitorReferenceNo?: InputMaybe<Scalars['String']>;
  saleLoanId?: InputMaybe<Scalars['String']>;
};

export type Sale_Package = {
  __typename?: 'sale_package';
  progressBilling: Array<ProgressBilling>;
  salePackage: Scalars['String'];
};

export type Sale_Progress_Billing = {
  __typename?: 'sale_progress_billing';
  addOnPurchase?: Maybe<Scalars['String']>;
  addOnPurchaseName?: Maybe<Scalars['String']>;
  allow_reversal?: Maybe<Scalars['Boolean']>;
  details?: Maybe<Array<Details>>;
  gotAC?: Maybe<Scalars['Boolean']>;
  isReversal?: Maybe<Scalars['Boolean']>;
  paymentParty?: Maybe<Scalars['String']>;
  paymentPartyCode?: Maybe<Scalars['String']>;
  paymentPlanDetailTitle?: Maybe<Scalars['String']>;
  stageSeqNo?: Maybe<Scalars['Float']>;
  system_use?: Maybe<Scalars['Boolean']>;
  totalDocumentAmt?: Maybe<Scalars['Float']>;
  totalOutstanding?: Maybe<Scalars['Float']>;
};

export type SaleCancellationCountOutput = {
  __typename?: 'SaleCancellationCountOutput';
  cancelCount: Scalars['Float'];
  completedCount: Scalars['Float'];
  openCount: Scalars['Float'];
};

export type SaleCancellationEntity = AuditEntity & {
  __typename?: 'saleCancellationEntity';
  accountId: Scalars['String'];
  cancellationDate: Scalars['DateTime'];
  cancelReason: Scalars['String'];
  chargeFinalTax: Scalars['Boolean'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  finalTaxToDate: Scalars['Float'];
  forfeitureSum: Scalars['Float'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  projectId: Scalars['String'];
  reasonCode?: Maybe<ReasonCodeEntity>;
  refundAmt: Scalars['Float'];
  refundTax: Scalars['Boolean'];
  remark: Scalars['String'];
  saleId: Scalars['String'];
  sales?: Maybe<SaleEntity>;
  status: Scalars['String'];
  taxSchemeId: Scalars['String'];
  taxToDate: Scalars['Float'];
};

export type SaleCancellationInfoLine = {
  __typename?: 'saleCancellationInfoLine';
  count?: Maybe<Scalars['Float']>;
  totalForfeitureSum?: Maybe<Scalars['Float']>;
};

export type SaleCancellationListingOutput = {
  __typename?: 'saleCancellationListingOutput';
  data: Array<SaleCancellationSharedOutput>;
  total?: Maybe<Scalars['Float']>;
};

export type SaleCancellationSharedOutput = {
  __typename?: 'saleCancellationSharedOutput';
  approvalRoleId?: Maybe<Scalars['String']>;
  bookDate?: Maybe<Scalars['DateTime']>;
  buyBackAmount?: Maybe<Scalars['Float']>;
  cancellationDate?: Maybe<Scalars['DateTime']>;
  cancellationReason?: Maybe<Scalars['String']>;
  cancellationReasonId: Scalars['String'];
  chargeFinalTax?: Maybe<Scalars['Boolean']>;
  clusterName: Scalars['String'];
  companyName?: Maybe<Scalars['String']>;
  completedBy?: Maybe<Scalars['String']>;
  contactId: Scalars['String'];
  finalTaxToDate?: Maybe<Scalars['Float']>;
  finalTaxToDateAmount?: Maybe<Scalars['Float']>;
  forfeitureSum?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  isCompany?: Maybe<Scalars['Boolean']>;
  modBy?: Maybe<Scalars['String']>;
  modTs?: Maybe<Scalars['DateTime']>;
  paidToDate?: Maybe<Scalars['Float']>;
  purchaserName?: Maybe<Scalars['String']>;
  refundAmt?: Maybe<Scalars['Float']>;
  refundTax?: Maybe<Scalars['Boolean']>;
  remarks?: Maybe<Scalars['String']>;
  saleId: Scalars['String'];
  salesNo: Scalars['String'];
  salesRegistrationNo?: Maybe<Scalars['String']>;
  sellingPrice?: Maybe<Scalars['Float']>;
  status: Scalars['String'];
  taxSchemeId: Scalars['String'];
  taxToDate?: Maybe<Scalars['Float']>;
  taxToDateAmount?: Maybe<Scalars['Float']>;
  totalRefundableAmount?: Maybe<Scalars['Float']>;
  unitId: Scalars['String'];
  unitNo?: Maybe<Scalars['String']>;
};

export type SaleCommissionTeamEntity = AuditEntity & {
  __typename?: 'saleCommissionTeamEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  companyCommissionTeam: CompanyCommissionTeamEntity;
  companyCommissionTeamId?: Maybe<Scalars['String']>;
  companyId: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  employeeId?: Maybe<Scalars['String']>;
  employeeName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isDealClosure: Scalars['Boolean'];
  jobPositionId?: Maybe<Scalars['String']>;
  jobPositionName?: Maybe<Scalars['String']>;
  level?: Maybe<Scalars['Float']>;
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  parentId?: Maybe<Scalars['String']>;
  projectId: Scalars['String'];
  saleId: Scalars['String'];
};

export type SaleCommissionTeamInput = {
  commonStatus: Scalars['String'];
  companyCommissionTeamId: Scalars['String'];
  employeeName: Scalars['String'];
  employeId: Scalars['String'];
  id: Scalars['String'];
  level: Scalars['Float'];
  parentId?: InputMaybe<Scalars['String']>;
  positionId: Scalars['String'];
  positionName: Scalars['String'];
};

export type SaleCommissionTeamOutput = {
  __typename?: 'SaleCommissionTeamOutput';
  commonStatus?: Maybe<Scalars['String']>;
  companyCommissionTeamId?: Maybe<Scalars['String']>;
  employee?: Maybe<EmployeeInfo>;
  id: Scalars['String'];
  isDisable?: Maybe<Scalars['Boolean']>;
  level?: Maybe<Scalars['Float']>;
  parentId?: Maybe<Scalars['String']>;
  position?: Maybe<PositionInfo>;
  positionId?: Maybe<Scalars['String']>;
};

export type SaleContactEntity = AuditEntity & {
  __typename?: 'saleContactEntity';
  accountId: Scalars['String'];
  contactNo: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  email: Scalars['String'];
  id: Scalars['String'];
  isPrimary: Scalars['Boolean'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  name: Scalars['String'];
  officeTel?: Maybe<Scalars['String']>;
  parameter?: Maybe<ParameterEntity>;
  relationshipId?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  saleId: Scalars['String'];
  salutation?: Maybe<SalutationEntity>;
  salutationId?: Maybe<Scalars['String']>;
};

export type SaleContactPersonInput = {
  email: Scalars['String'];
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  officeNo?: InputMaybe<Scalars['String']>;
  phoneNo: Scalars['String'];
  relationshipId?: InputMaybe<Scalars['String']>;
  remark?: InputMaybe<Scalars['String']>;
  salutationId?: InputMaybe<Scalars['String']>;
};

export type SaleContractInfoLine = {
  __typename?: 'saleContractInfoLine';
  totalBooked?: Maybe<Scalars['Float']>;
  totalCancelled?: Maybe<Scalars['Float']>;
  totalSigned?: Maybe<Scalars['Float']>;
};

export type SaleContractMenuSummaryOutput = {
  __typename?: 'SaleContractMenuSummaryOutput';
  discount?: Maybe<DiscountSummaryInfo>;
  markUp?: Maybe<MarkUpSummaryInfo>;
  packages: SummaryInfo;
  subProduct: SummaryInfo;
  unit?: Maybe<UnitSummaryInfo>;
};

export type SaleDetailsOutput = {
  __typename?: 'saleDetailsOutput';
  accountId: Scalars['String'];
  address?: Maybe<AddressJson>;
  bookingFee: Scalars['Float'];
  carPark: Scalars['JSONObject'];
  commissionStructure?: Maybe<Array<SaleCommissionTeamOutput>>;
  contactId: Scalars['String'];
  discounts: Scalars['JSONObject'];
  jointBuyer: Array<JointBuyerEntity>;
  mainBuyer: ContactEntity;
  others: Scalars['JSONObject'];
  paymentPlan: Array<Scalars['JSONObject']>;
  projectId: Scalars['String'];
  registerDate?: Maybe<Scalars['DateTime']>;
  saleContractPrice: Scalars['Float'];
  saleDate: Scalars['DateTime'];
  saleId: Scalars['String'];
  saleListPrice: Scalars['Float'];
  saleNo: Scalars['String'];
  salePackage: Scalars['JSONObject'];
  salePayment: Array<Scalars['JSONObject']>;
  salesConvertedStatus?: Maybe<Scalars['String']>;
  salesPaymentPlan: Array<Scalars['JSONObject']>;
  salesRegistrationNo?: Maybe<Scalars['String']>;
  taxAmt?: Maybe<Scalars['Float']>;
  taxRate: Scalars['Float'];
  taxSchemeId: Scalars['String'];
  unitClusterId: Scalars['String'];
  unitDetails: UnitInfoOutput;
  unitId: Scalars['String'];
  unitNo: Scalars['String'];
};

export type SaleDiscountDetailsOutput = {
  __typename?: 'saleDiscountDetailsOutput';
  discountId: Scalars['String'];
  discountName: Scalars['String'];
};

export type SaleDiscountEntity = {
  __typename?: 'saleDiscountEntity';
  amount: Scalars['Float'];
  createdTs: Scalars['DateTime'];
  currentDiscountDetail: ProjectDiscountEntity;
  discount: DiscountEntity;
  discountId: Scalars['String'];
  id: Scalars['String'];
  sale: SaleEntity;
  saleDiscountExtension?: Maybe<SalesDiscountExtEntity>;
  saleId: Scalars['String'];
  salesDiscountDiscardBumi?: Maybe<Scalars['JSON']>;
  seqNo: Scalars['Float'];
};

export type SaleEntity = {
  __typename?: 'saleEntity';
  accountId: Scalars['String'];
  accountSpec?: Maybe<AccountSpecEntity>;
  addOnTotal?: Maybe<Scalars['JSON']>;
  address?: Maybe<AddressJson>;
  addressList?: Maybe<Array<ContactAddressEntity>>;
  agencyAccId?: Maybe<AgencyEntity>;
  agencyAcctId?: Maybe<Scalars['String']>;
  agencyContractId?: Maybe<Scalars['String']>;
  agencyUser?: Maybe<AgencyContactEntity>;
  agentPersonId?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  areaVariance?: Maybe<Array<AreaVarianceEntity>>;
  attachment?: Maybe<AttachmentEntity>;
  attendedBy?: Maybe<Scalars['String']>;
  billMethod?: Maybe<Scalars['String']>;
  bookDate: Scalars['DateTime'];
  bookingAmount?: Maybe<Scalars['Float']>;
  bookingAttachments: BookingAttachmentsOutput;
  bookingAttachmentsCount: Scalars['Float'];
  bookingBadgeCount: Scalars['Float'];
  bookingFeeAttachments: Array<AttachmentEntity>;
  bookingFeeInfo?: Maybe<SalePaymentEntity>;
  bookingRemark?: Maybe<Scalars['String']>;
  bookingTimeTaken?: Maybe<Scalars['Float']>;
  buyerIdentityNo?: Maybe<Scalars['String']>;
  buyerIdentityType?: Maybe<Scalars['String']>;
  buyerName?: Maybe<Scalars['String']>;
  buyerReference?: Maybe<Scalars['String']>;
  buyerSignatureUrl?: Maybe<Scalars['String']>;
  buyerSolicitor?: Maybe<SolicitorAppointedEntity>;
  cancelledBy?: Maybe<Scalars['String']>;
  cancelledByUser?: Maybe<UserEntity>;
  cancelledDate?: Maybe<Scalars['DateTime']>;
  cancelledReason?: Maybe<Scalars['String']>;
  cancelReasonId?: Maybe<Scalars['String']>;
  checkSalePackage?: Maybe<SalePackageInfoOutput>;
  collectedDate?: Maybe<Scalars['DateTime']>;
  commonStatus: Scalars['String'];
  contact: ContactEntity;
  contactAddress?: Maybe<Array<AddressJson>>;
  contactId?: Maybe<Scalars['String']>;
  ContractPricingDiscount?: Maybe<Scalars['Float']>;
  convertedToBooking: Scalars['Boolean'];
  debitNote?: Maybe<Array<DebitNoteEntity>>;
  developerReference?: Maybe<Scalars['String']>;
  developerSolicitor?: Maybe<SolicitorAppointedEntity>;
  developerSolicitorId?: Maybe<Scalars['String']>;
  developerSpaStatus?: Maybe<Scalars['String']>;
  discount: Array<SaleDiscountEntity>;
  distance?: Maybe<Scalars['String']>;
  elaunchId?: Maybe<Scalars['String']>;
  employerAddress?: Maybe<Scalars['String']>;
  employerName?: Maybe<Scalars['String']>;
  endfinLoanApps: Array<EndfinLoanAppEntity>;
  endfinLoanAppsCount: Scalars['Float'];
  eventId?: Maybe<Scalars['String']>;
  events?: Maybe<EventsEntity>;
  expectedSnpDate?: Maybe<Scalars['DateTime']>;
  followUpBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  ifcaContactId: Scalars['String'];
  ifcaSaleId: Scalars['Float'];
  ifcaSaleNo: Scalars['String'];
  incomeRange?: Maybe<IncomeRangeEntity>;
  installments?: Maybe<Array<InstallmentEntity>>;
  integrationDiscount?: Maybe<Array<IntegrationDiscountEntity>>;
  interests: Array<InterestEntity>;
  isAutoReleaseNotified: Scalars['Boolean'];
  isBumi: Scalars['Boolean'];
  isCompany: Scalars['Boolean'];
  isCustomisedBookingForm: Scalars['Boolean'];
  isReservationVerify: Scalars['Boolean'];
  joinBuyer: Array<JointBuyerEntity>;
  joinBuyerInfo?: Maybe<JointBuyerInfoForBookingListing>;
  jointBuyers: Array<JointBuyerEntity>;
  keyCollectionAppointment?: Maybe<Array<KeyCollectionAppointmentEntity>>;
  lateInterest?: Maybe<Array<LateInterestDetailEntity>>;
  lateInterestException?: Maybe<ProjectLateInterestExceptionEntity>;
  lead: LeadEntity;
  leadId?: Maybe<Scalars['String']>;
  leadSource?: Maybe<LeadSourceEntity>;
  ledgers: Array<LedgerEntity>;
  letterSign: Array<LetterSignEntity>;
  listPrice?: Maybe<Scalars['Float']>;
  loanScreening?: Maybe<LoanScreenStatusOutput>;
  loanScreeningReports?: Maybe<Array<LoanScreenReportOutput>>;
  markUpAmount?: Maybe<Scalars['Float']>;
  markUpBy?: Maybe<Scalars['String']>;
  markUpReason?: Maybe<Scalars['String']>;
  markUpValue?: Maybe<Scalars['Float']>;
  miscBilling?: Maybe<Array<MiscBillingEntity>>;
  motTracking?: Maybe<Array<MotTrackingEntity>>;
  nonIntegratedRebate?: Maybe<Array<SaleRebateEntity>>;
  otherAttachments: Array<AttachmentEntity>;
  otherContactName?: Maybe<Scalars['JSON']>;
  package?: Maybe<Array<Scalars['String']>>;
  packageList: Array<PackageEntity>;
  paymentMethod?: Maybe<Scalars['String']>;
  paymentMethodDesc?: Maybe<Scalars['String']>;
  paymentReference?: Maybe<Scalars['String']>;
  paymentRemark?: Maybe<Scalars['String']>;
  PdpaSignatureUrl?: Maybe<Scalars['String']>;
  pendingIntegrate: Scalars['Boolean'];
  progressBilling?: Maybe<Array<ProgressBillingEntity>>;
  ProgressBilling?: Maybe<Scalars['JSON']>;
  progressBillingTotal?: Maybe<Scalars['Float']>;
  progressLogSolicitor?: Maybe<Array<ProgressLogDetails>>;
  project: ProjectEntity;
  projectCompany: CompanyEntity;
  projectId: Scalars['String'];
  projectIntegration?: Maybe<Array<ProjectIntegrationEntity>>;
  purchaserInfoName?: Maybe<PurchaserInfoInfoOutput>;
  receipt?: Maybe<Array<ReceiptEntity>>;
  receiptReversal?: Maybe<Array<ReceiptReversalEntity>>;
  referralContactNo?: Maybe<Scalars['String']>;
  referralName?: Maybe<Scalars['String']>;
  referralReferenceNo?: Maybe<Scalars['String']>;
  refund?: Maybe<Array<RefundEntity>>;
  reminders: Array<ReminderEntity>;
  repeatPurchaserAgency?: Maybe<Scalars['Float']>;
  repeatPurchaserSales?: Maybe<Scalars['Float']>;
  reserveDate?: Maybe<Scalars['DateTime']>;
  retryCount: Scalars['Float'];
  saleCancellation?: Maybe<SaleCancellationEntity>;
  saleExtension?: Maybe<SaleExtensionEntity>;
  saleLoan?: Maybe<Array<SaleLoanEntity>>;
  saleOrigin: Scalars['String'];
  salePackage?: Maybe<Array<SalePackageEntity>>;
  salePayment?: Maybe<SalePaymentEntity>;
  saleRebate?: Maybe<Array<SaleRebatePackageEntity>>;
  salesDiscount: Array<SaleDiscountEntity>;
  salesNo: Scalars['String'];
  salesPerson?: Maybe<Scalars['String']>;
  salesPersonId?: Maybe<Scalars['String']>;
  salesRebateName?: Maybe<Array<SaleRebateInfoOutput>>;
  salesStatus: Scalars['String'];
  salesStatutoryDocument?: Maybe<Array<SalesStatutoryDocumentEntity>>;
  SaleStatusList: Scalars['JSONObject'];
  salesTeam?: Maybe<SaleTeamEntity>;
  salesTeamId?: Maybe<Scalars['String']>;
  salesTeamName?: Maybe<Scalars['String']>;
  schedules: Array<ScheduleEntity>;
  sellingPrice?: Maybe<Scalars['Float']>;
  snpReminderAfterDaysNotify: Scalars['Boolean'];
  snpReminderBeforeDaysNotify: Scalars['Boolean'];
  solicitorProgressLog?: Maybe<Array<SolicitorProgressLogEntity>>;
  spaDate?: Maybe<Scalars['DateTime']>;
  spaNo?: Maybe<Scalars['String']>;
  spaReminder?: Maybe<Array<SpaReminderEntity>>;
  spouse?: Maybe<ContactEntity>;
  spouseContactId?: Maybe<Scalars['String']>;
  stakeholder: SolicitorAppointedEntity;
  stampDate?: Maybe<Scalars['DateTime']>;
  subProduct?: Maybe<Array<SaleSubproductEntity>>;
  taxAmt?: Maybe<Scalars['Float']>;
  taxDetail?: Maybe<Array<SaleTaxOutput>>;
  taxRate?: Maybe<Scalars['Float']>;
  trNo: Scalars['String'];
  unit: UnitEntity;
  unitId: Scalars['String'];
  unitIntegration?: Maybe<UnitIntegrationEntity>;
  vpDate?: Maybe<Scalars['DateTime']>;
};

export type SaleExtensionEntity = AuditEntity & {
  __typename?: 'saleExtensionEntity';
  accountId: Scalars['String'];
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  campaignId?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  creditTerm?: Maybe<Scalars['Float']>;
  discardBumiDiscount?: Maybe<Scalars['Boolean']>;
  eventId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isCashBuyer?: Maybe<Scalars['Boolean']>;
  isGenerateInterest?: Maybe<Scalars['Boolean']>;
  isGenerateReminder?: Maybe<Scalars['Boolean']>;
  loanGracePeriod?: Maybe<Scalars['Float']>;
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  paymentPlan?: Maybe<PaymentPlanEntity>;
  paymentPlanId?: Maybe<Scalars['String']>;
  paymentPlanMarkUpAmt: Scalars['Float'];
  saleId: Scalars['String'];
  sales: SaleEntity;
  salesConvertedStatus: Scalars['String'];
  salesRegistrationDate?: Maybe<Scalars['DateTime']>;
  salesRegistrationNo?: Maybe<Scalars['String']>;
  salesType?: Maybe<Scalars['String']>;
  submittedBy?: Maybe<Scalars['String']>;
  submittedDate?: Maybe<Scalars['DateTime']>;
  taxScheme?: Maybe<TaxSchemeEntity>;
  taxSchemeId?: Maybe<Scalars['String']>;
  totalSalesValue?: Maybe<Scalars['Float']>;
};

export type SaleInformation = {
  __typename?: 'saleInformation';
  companyName?: Maybe<Scalars['String']>;
  isCompany?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  totalAllocateAmount: Scalars['Float'];
  totalAmount: Scalars['Float'];
  unAllocateAmount: Scalars['Float'];
  unitNo: Scalars['String'];
};

export type SaleJointBuyerInfoOutPut = {
  __typename?: 'SaleJointBuyerInfoOutPut';
  Email?: Maybe<Scalars['String']>;
  MobileNo: Scalars['String'];
  Name: Scalars['String'];
};

export type SaleLandDepositInfoLine = {
  __typename?: 'SaleLandDepositInfoLine';
  outstandingCount?: Maybe<Scalars['Float']>;
  showMenu?: Maybe<Scalars['Boolean']>;
};

export type SaleLeadNotificationInput = {
  booking?: InputMaybe<BookingNotificationInput>;
  bookingCancellation?: InputMaybe<BookingCancellationNotificationInput>;
  bookingReassignment?: InputMaybe<Scalars['Boolean']>;
  leadAssignment?: InputMaybe<Scalars['Boolean']>;
  loanAssignment?: InputMaybe<LoanAssignmentInput>;
  reservation?: InputMaybe<BookingNotificationInput>;
  snpSigningReminder?: InputMaybe<SnpSigningReminderInput>;
  solicitorCaseAssignment?: InputMaybe<SolicitorCaseAssignmentInput>;
};

export type SaleLeadNotificationOutput = {
  __typename?: 'SaleLeadNotificationOutput';
  booking?: Maybe<BookingNotificationOutput>;
  bookingCancellation?: Maybe<BookingCancellationNotificationOutput>;
  bookingReassignment?: Maybe<Scalars['Boolean']>;
  leadAssignment?: Maybe<Scalars['Boolean']>;
  loanAssignment?: Maybe<LoanAssignmentOutput>;
  reservation?: Maybe<BookingNotificationOutput>;
  snpSigningReminder?: Maybe<SnpSigningReminderOutput>;
  solicitorCaseAssignment?: Maybe<SolicitorCaseAssignmentOutput>;
};

export type SaleListRawObject = {
  __typename?: 'saleListRawObject';
  bookDate: Scalars['DateTime'];
  companyName?: Maybe<Scalars['String']>;
  dueDay: Scalars['Float'];
  fullName: Scalars['String'];
  isCompany?: Maybe<Scalars['Boolean']>;
  reminderSeq: Scalars['Float'];
  saleId: Scalars['String'];
  unitNo: Scalars['String'];
};

export type SaleLoanBuyBackCountOutput = {
  __typename?: 'saleLoanBuyBackCountOutput';
  approvedCount: Scalars['Float'];
  draftCount: Scalars['Float'];
  submittedCount: Scalars['Float'];
};

export type SaleLoanBuyBackListOutput = {
  __typename?: 'saleLoanBuyBackListOutput';
  approvalStatus: Scalars['String'];
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  bankAccountId: Scalars['String'];
  bankAccountNo: Scalars['String'];
  bankName: Scalars['String'];
  buyBackAmount: Scalars['String'];
  buyBackDate: Scalars['DateTime'];
  docNo?: Maybe<Scalars['String']>;
  financierId: Scalars['String'];
  fullName: Scalars['String'];
  id: Scalars['String'];
  newFinancier: Scalars['String'];
  oldBalance?: Maybe<Array<Scalars['JSONObject']>>;
  projectId: Scalars['String'];
  refRecordId: Scalars['String'];
  refTable: Scalars['String'];
  remarks?: Maybe<Scalars['String']>;
  saleId: Scalars['String'];
  saleLoanPayment?: Maybe<Array<SalePaymentOutput>>;
  submittedBy?: Maybe<Scalars['String']>;
  submittedDate?: Maybe<Scalars['DateTime']>;
  unitClusterId: Scalars['String'];
  unitId: Scalars['String'];
  unitNo: Scalars['String'];
};

export type SaleLoanCancellationDetailEntity = AuditEntity & {
  __typename?: 'saleLoanCancellationDetailEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  saleLoanCancellationId: Scalars['String'];
  saleLoanId: Scalars['String'];
};

export type SaleLoanCancellationEntity = AuditEntity & {
  __typename?: 'saleLoanCancellationEntity';
  accountId: Scalars['String'];
  approvalStatus: Scalars['String'];
  cancelDate: Scalars['DateTime'];
  cancelReason: Scalars['String'];
  cancelRemark?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  saleId: Scalars['String'];
};

export type SaleLoanCancellationInfoLine = {
  __typename?: 'saleLoanCancellationInfoLine';
  totalDraft?: Maybe<Scalars['Float']>;
  totalSubmitted?: Maybe<Scalars['Float']>;
};

export type SaleLoanDetailOutput = {
  __typename?: 'saleLoanDetailOutput';
  companyName?: Maybe<Scalars['String']>;
  financierDetail?: Maybe<Array<SaleLoanEndFinancierOutput>>;
  generationBatchDate?: Maybe<Scalars['DateTime']>;
  generationBatchId?: Maybe<Scalars['String']>;
  isCompany?: Maybe<Scalars['Boolean']>;
  loanLimit: Scalars['Float'];
  looDate: Scalars['DateTime'];
  otherLoan: Scalars['Float'];
  purchaserName?: Maybe<Scalars['String']>;
  renoticeDate?: Maybe<Scalars['DateTime']>;
  saleId: Scalars['String'];
  sellingPrice: Scalars['Float'];
  spaDate: Scalars['DateTime'];
  taxSchemeId: Scalars['String'];
  unitNo: Scalars['String'];
};

export type SaleLoanEndFinancierOutput = {
  __typename?: 'saleLoanEndFinancierOutput';
  borrowerAddress: AddressJson;
  borrowerName: Scalars['String'];
  endFinancierId: Scalars['String'];
  endFinRefNo: Scalars['String'];
  financierLogo?: Maybe<Scalars['String']>;
  financierName: Scalars['String'];
  loanAmount: Scalars['Float'];
  loanApprovalDate?: Maybe<Scalars['DateTime']>;
  loanLimit: Scalars['Float'];
  loanLooDate: Scalars['DateTime'];
  loanPercent: Scalars['Float'];
  loanPeriod?: Maybe<Scalars['Float']>;
  loanSequence: Scalars['Float'];
  loanSignDate?: Maybe<Scalars['DateTime']>;
  remark: Scalars['String'];
  saleId: Scalars['String'];
  saleLoanId: Scalars['String'];
  sellingPrice: Scalars['Float'];
  solicitorCode?: Maybe<Scalars['String']>;
  solicitorId: Scalars['String'];
  solicitorName: Scalars['String'];
  solicitorRefNo: Scalars['String'];
  taxSchemeId: Scalars['String'];
};

export type SaleLoanEntity = AuditEntity & {
  __typename?: 'saleLoanEntity';
  accountId: Scalars['String'];
  borrowerAddress?: Maybe<AddressJson>;
  borrowerName?: Maybe<Scalars['String']>;
  commonStatus?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  endfinancierMortgagePlanId: Scalars['String'];
  financialBilling?: Maybe<Array<FinancialBillingEntity>>;
  financierId: Scalars['String'];
  financierReference?: Maybe<Scalars['String']>;
  financiers?: Maybe<Array<FinancierEntity>>;
  generationBatch?: Maybe<Scalars['String']>;
  generationBatchDate?: Maybe<Scalars['DateTime']>;
  gstFinanceByBank?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  loanAmount?: Maybe<Scalars['Float']>;
  loanLimit?: Maybe<Scalars['Float']>;
  loanLooDate?: Maybe<Scalars['DateTime']>;
  loanPercentage?: Maybe<Scalars['Float']>;
  loanPeriod?: Maybe<Scalars['Float']>;
  loanSeqno?: Maybe<Scalars['Float']>;
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  mortgagePlan: MortgagePlanEntity;
  project: ProjectEntity;
  projectId: Scalars['String'];
  remark?: Maybe<Scalars['String']>;
  renoticeDate?: Maybe<Scalars['DateTime']>;
  rrDate?: Maybe<Scalars['DateTime']>;
  rrSolicitorId?: Maybe<Scalars['String']>;
  rrSolicitorReferenceNo?: Maybe<Scalars['String']>;
  sale?: Maybe<SaleEntity>;
  saleId: Scalars['String'];
  saleLoanExt: SaleLoanExtensionEntity;
  saleLoanExtId: Scalars['String'];
  saleLoanPayment: SaleLoanPaymentEntity;
  solicitorAppointed?: Maybe<Array<SolicitorAppointedEntity>>;
  solicitorId?: Maybe<Scalars['String']>;
  solicitorReference?: Maybe<Scalars['String']>;
  taxSchemeId?: Maybe<Scalars['String']>;
  totalLoanAmount?: Maybe<Scalars['Float']>;
};

export type SaleLoanExtensionEntity = AuditEntity & {
  __typename?: 'saleLoanExtensionEntity';
  accountId: Scalars['String'];
  applyAmt: Scalars['Float'];
  approvalStatus: Scalars['String'];
  approvedAmt?: Maybe<Scalars['Float']>;
  borrowerAcct?: Maybe<Scalars['String']>;
  cancelDate?: Maybe<Scalars['DateTime']>;
  cancelReason?: Maybe<Scalars['String']>;
  constructionDate: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  description: Scalars['String'];
  financierRef: Scalars['String'];
  id: Scalars['String'];
  isDifferentialRescheduled: Scalars['Boolean'];
  isRefinanced: Scalars['Boolean'];
  loanApprovalDate?: Maybe<Scalars['DateTime']>;
  loanInterestMonth?: Maybe<Scalars['Float']>;
  loanInterestRate?: Maybe<Scalars['Float']>;
  loanSignDate?: Maybe<Scalars['DateTime']>;
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  projectId: Scalars['String'];
  saleLoan: SaleLoanEntity;
  saleLoanNo?: Maybe<Scalars['String']>;
  submittedBy: Scalars['String'];
  submittedDate: Scalars['DateTime'];
};

export type SaleLoanFinancierOutput = {
  __typename?: 'saleLoanFinancierOutput';
  financierCode?: Maybe<Scalars['String']>;
  financierName: Scalars['String'];
  solicitorCode?: Maybe<Scalars['String']>;
  solicitorName: Scalars['String'];
};

export type SaleLoanInfoOutput = {
  __typename?: 'saleLoanInfoOutput';
  fullName: Scalars['String'];
};

export type SaleLoanInput = {
  applyAmt: Scalars['Float'];
  approvalStatus: Scalars['String'];
  approvedAmt?: InputMaybe<Scalars['Float']>;
  borrowerAcct?: InputMaybe<Scalars['String']>;
  borrowerAddress?: InputMaybe<AddressJsonInput>;
  borrowerName?: InputMaybe<Scalars['String']>;
  cancelDate?: InputMaybe<Scalars['DateTime']>;
  cancelReason?: InputMaybe<Scalars['String']>;
  commonStatus?: InputMaybe<Scalars['String']>;
  constructionDate: Scalars['DateTime'];
  description: Scalars['String'];
  endfinancierMortgagePlanId: Scalars['String'];
  financierId: Scalars['String'];
  financierRef: Scalars['String'];
  financierReference?: InputMaybe<Scalars['String']>;
  gstFinanceByBank?: InputMaybe<Scalars['Boolean']>;
  isDiffrentialRescheduled?: InputMaybe<Scalars['Boolean']>;
  loanAmount?: InputMaybe<Scalars['Float']>;
  loanApprovalDate?: InputMaybe<Scalars['DateTime']>;
  loanInterestMonth?: InputMaybe<Scalars['Float']>;
  loanInterestRate?: InputMaybe<Scalars['Float']>;
  loanLimit?: InputMaybe<Scalars['Float']>;
  loanLooDate?: InputMaybe<Scalars['DateTime']>;
  loanPercentage?: InputMaybe<Scalars['Float']>;
  loanPeriod?: InputMaybe<Scalars['Float']>;
  loanSeqno?: InputMaybe<Scalars['Float']>;
  loanSignDate?: InputMaybe<Scalars['DateTime']>;
  paymentPlan?: InputMaybe<Array<PaymentPlan>>;
  projectId: Scalars['String'];
  remark?: InputMaybe<Scalars['String']>;
  renoticeDate?: InputMaybe<Scalars['DateTime']>;
  rrDate?: InputMaybe<Scalars['DateTime']>;
  rrSolicitorId?: InputMaybe<Scalars['String']>;
  rrSolicitorReferenceNo?: InputMaybe<Scalars['String']>;
  saleId: Scalars['String'];
  solicitorId?: InputMaybe<Scalars['String']>;
  solicitorReference?: InputMaybe<Scalars['String']>;
  taxSchemeId?: InputMaybe<Scalars['String']>;
  totalLoanAmount?: InputMaybe<Scalars['Float']>;
};

export type SaleLoanListingOutput = {
  __typename?: 'saleLoanListingOutput';
  cancelDate?: Maybe<Scalars['DateTime']>;
  cancellationStatus?: Maybe<Scalars['String']>;
  financierList?: Maybe<Array<Financier>>;
  generationBatchId?: Maybe<Scalars['String']>;
  renoticeDate?: Maybe<Scalars['DateTime']>;
  saleId: Scalars['String'];
  totalAmount: Scalars['Float'];
  totalPercentage: Scalars['Float'];
  unitNo: Scalars['String'];
};

export type SaleLoanListingOutputForIndo = {
  __typename?: 'saleLoanListingOutputForIndo';
  applyAmount?: Maybe<Scalars['Float']>;
  approvalStatus: Scalars['String'];
  approvedAmount?: Maybe<Scalars['Float']>;
  approvedPercentage: Scalars['Float'];
  borrowerName: Scalars['String'];
  financier: Scalars['String'];
  id: Scalars['String'];
  loanSignDate?: Maybe<Scalars['DateTime']>;
  projectId: Scalars['String'];
  saleLoanNo?: Maybe<Scalars['String']>;
  unitClusterId: Scalars['String'];
  unitId: Scalars['String'];
  unitNo: Scalars['String'];
};

export type SaleLoanNotice = {
  __typename?: 'SaleLoanNotice';
  amount: Scalars['Float'];
  sale_id: Scalars['String'];
  sale_loan_id?: Maybe<Scalars['String']>;
  sale_loan_payment_plan_id?: Maybe<Scalars['String']>;
  sale_loan_refinancing_id?: Maybe<Scalars['String']>;
  sale_loan_refinancing_payment_plan_id?: Maybe<Scalars['String']>;
  sale_loan_refinancing_retention_id?: Maybe<Scalars['String']>;
  sale_loan_retention_id?: Maybe<Scalars['String']>;
};

export type SaleLoanNoticeInput = {
  amount: Scalars['Float'];
  sale_id: Scalars['String'];
  sale_loan_id?: InputMaybe<Scalars['String']>;
  sale_loan_payment_plan_id?: InputMaybe<Scalars['String']>;
  sale_loan_refinancing_id?: InputMaybe<Scalars['String']>;
  sale_loan_refinancing_payment_plan_id?: InputMaybe<Scalars['String']>;
  sale_loan_refinancing_retention_id?: InputMaybe<Scalars['String']>;
  sale_loan_retention_id?: InputMaybe<Scalars['String']>;
};

export type SaleLoanOutput = {
  __typename?: 'saleLoanOutput';
  companyName?: Maybe<Scalars['String']>;
  contactId: Scalars['String'];
  fullName: Scalars['String'];
  isCashBuyer?: Maybe<Scalars['Boolean']>;
  isCompany?: Maybe<Scalars['Boolean']>;
  propertyType: Scalars['String'];
  propertyTypeName: Scalars['String'];
  saleId: Scalars['String'];
  salesStatus: Scalars['String'];
  sellingPrice?: Maybe<Scalars['Float']>;
  spaDate: Scalars['DateTime'];
  taxSchemeId?: Maybe<Scalars['String']>;
  unitId: Scalars['String'];
  unitNo: Scalars['String'];
};

export type SaleLoanOutputForIndo = {
  __typename?: 'saleLoanOutputForIndo';
  applyAmt?: Maybe<Scalars['Float']>;
  approvalStatus: Scalars['String'];
  approvedAmt?: Maybe<Scalars['Float']>;
  borrowerName: Scalars['String'];
  constructionDate?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  financier: Scalars['String'];
  fullName: Scalars['String'];
  id: Scalars['String'];
  loanAmount: Scalars['Float'];
  mortgageName: Scalars['String'];
  signDate?: Maybe<Scalars['DateTime']>;
  unitNo: Scalars['String'];
};

export type SaleLoanPaymentEntity = AuditEntity & {
  __typename?: 'saleLoanPaymentEntity';
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  endfinMortgagePaymentId: Scalars['String'];
  expectedCount: Scalars['Float'];
  expectedFreq: Scalars['String'];
  expectedFrom: Scalars['String'];
  id: Scalars['String'];
  loanAmount: Scalars['Float'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  mortgagePayment?: Maybe<MortgagePaymentEntity>;
  saleLoan: SaleLoanEntity;
  saleLoanId: Scalars['String'];
  saleLoanPayment: SaleLoanPaymentEntity;
  saleLoanRetention: SaleLoanRetentionEntity;
};

export type SaleLoanPaymentInput = {
  endfinMortgagePaymentId: Scalars['String'];
  expectedCount: Scalars['Float'];
  expectedFreq: Scalars['String'];
  expectedFrom: Scalars['String'];
  loanAmt: Scalars['Float'];
  saleLoanId: Scalars['String'];
};

export type SaleLoanPaymentPlanDetailsOutput = {
  __typename?: 'saleLoanPaymentPlanDetailsOutput';
  amount?: Maybe<Scalars['Float']>;
  approvedAmt?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sale_id: Scalars['String'];
  sale_loan_id?: Maybe<Scalars['String']>;
  sale_loan_no?: Maybe<Scalars['String']>;
  sale_loan_payment_plan_id?: Maybe<Scalars['String']>;
  sale_loan_refinancing_id?: Maybe<Scalars['String']>;
  sale_loan_refinancing_payment_plan_id?: Maybe<Scalars['String']>;
  sale_loan_refinancing_retention_id?: Maybe<Scalars['String']>;
  unit_no: Scalars['String'];
};

export type SaleLoanRefinancingPaymentPlanEntity = AuditEntity & {
  __typename?: 'saleLoanRefinancingPaymentPlanEntity';
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  endfinMortgagePaymentId: Scalars['String'];
  estimateDate?: Maybe<Scalars['DateTime']>;
  eventItem: Scalars['String'];
  id: Scalars['String'];
  loanAmount: Scalars['Float'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  mortgagePayment?: Maybe<MortgagePaymentEntity>;
  saleLoanRefinancing: SalesLoanRefinancingEntity;
  saleLoanRefinancingId: Scalars['String'];
};

export type SaleLoanRefinancingRetentionEntity = AuditEntity & {
  __typename?: 'saleLoanRefinancingRetentionEntity';
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  endfinMortgagePaymentId: Scalars['String'];
  endfinMortgageRetentionId: Scalars['String'];
  estimateDate?: Maybe<Scalars['DateTime']>;
  eventItem: Scalars['String'];
  id: Scalars['String'];
  loanAmount: Scalars['Float'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  mortgagePayment?: Maybe<MortgagePaymentEntity>;
  mortgageRetention: MortgageRetentionEntity;
  saleLoanRefinancing: SalesLoanRefinancingEntity;
  saleLoanRefinancingId: Scalars['String'];
};

export type SaleLoanReleaseCountOutput = {
  __typename?: 'SaleLoanReleaseCountOutput';
  approvedCount: Scalars['Float'];
  draftCount: Scalars['Float'];
  submittedCount: Scalars['Float'];
};

export type SaleLoanReleaseEntity = {
  __typename?: 'saleLoanReleaseEntity';
  accountId: Scalars['String'];
  approvalStatus: Scalars['String'];
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  commonStatus: Scalars['String'];
  docNo?: Maybe<Scalars['String']>;
  endFinancierMortgageId: Scalars['String'];
  endfinMortgagePaymentPlanId?: Maybe<Scalars['String']>;
  endfinMortgageRetentionId?: Maybe<Scalars['String']>;
  financier?: Maybe<FinancierEntity>;
  financierId: Scalars['String'];
  id: Scalars['String'];
  isPaid: Scalars['Boolean'];
  mortgagePayment?: Maybe<MortgagePaymentEntity>;
  mortgagePlan?: Maybe<MortgagePlanEntity>;
  mortgageRetention?: Maybe<MortgageRetentionEntity>;
  projectId: Scalars['String'];
  releaseDate?: Maybe<Scalars['DateTime']>;
  saleLoanPaymentPlanDetails?: Maybe<Array<SaleLoanNotice>>;
  submittedBy?: Maybe<Scalars['String']>;
  submittedDate?: Maybe<Scalars['DateTime']>;
};

export type SaleLoanReleaseInput = {
  approvalStatus: Scalars['String'];
  endFinancierMortgageId: Scalars['String'];
  endFinMortgageRetentionId?: InputMaybe<Scalars['String']>;
  endFinMrtgagePaymentPlanId?: InputMaybe<Scalars['String']>;
  file?: InputMaybe<Array<Scalars['Upload']>>;
  financierId: Scalars['String'];
  isPaid: Scalars['Boolean'];
  paymentPlanDetails?: InputMaybe<Array<SaleLoanNoticeInput>>;
  projectId: Scalars['String'];
  releaseDate: Scalars['DateTime'];
};

export type SaleLoanReleasePaymentPlanDetailsOutput = {
  __typename?: 'saleLoanReleasePaymentPlanDetailsOutput';
  appAmt: Scalars['String'];
  approvedAmt: Scalars['String'];
  fullName: Scalars['String'];
  saleId: Scalars['String'];
  saleLoanId: Scalars['String'];
  saleLoanNo: Scalars['String'];
  unitId: Scalars['String'];
  unitNo: Scalars['String'];
};

export type SaleLoanRetentionEntity = AuditEntity & {
  __typename?: 'saleLoanRetentionEntity';
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  endfinMortgageRetentionId: Scalars['String'];
  expectedCount: Scalars['Float'];
  expectedFreq: Scalars['String'];
  expectedFrom: Scalars['String'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  mortgageRetention: MortgageRetentionEntity;
  retentionValue: Scalars['Float'];
  saleLoanPayment: SaleLoanPaymentEntity;
  saleLoanPaymentId: Scalars['String'];
};

export type SaleLoanRetentionInput = {
  endfinMortgageRetentionId: Scalars['String'];
  expectedCount: Scalars['Float'];
  expectedFreq: Scalars['String'];
  expectedFrom: Scalars['String'];
  retentionValue: Scalars['Float'];
  saleLoanPaymentId: Scalars['String'];
};

export type SaleLoanUnitInfoOutput = {
  __typename?: 'saleLoanUnitInfoOutput';
  appliedAmt: Scalars['Float'];
  fullName: Scalars['String'];
  id: Scalars['String'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  unitClusterId: Scalars['String'];
  unitNo: Scalars['String'];
};

export type SalePackageEntity = AuditEntity & {
  __typename?: 'salePackageEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  discountAmount?: Maybe<Scalars['Float']>;
  discountId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isIncludeContract: Scalars['Boolean'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  numRow?: Maybe<Scalars['Float']>;
  openMarketValue?: Maybe<Scalars['Float']>;
  package: PackageEntity;
  packageId?: Maybe<Scalars['String']>;
  packagesPaymentPlan: Array<PackagesPaymentPlanEntity>;
  paymentPlanId?: Maybe<Scalars['String']>;
  projectPackagePaymentPlanId?: Maybe<Scalars['String']>;
  projectPaymentPlan?: Maybe<ProjectPaymentPlanEntity>;
  promotionalPackage: PromotionalPackagesEntity;
  promotionalPackageId: Scalars['String'];
  saleId: Scalars['String'];
  salePackage?: Maybe<PackageEntity>;
  sales?: Maybe<SaleEntity>;
  sellingMethod: Scalars['String'];
  sellingPrice?: Maybe<Scalars['Float']>;
  taxSchemeId?: Maybe<Scalars['String']>;
  workProgress: WorkProgressEntity;
  workProgressId?: Maybe<Scalars['String']>;
};

export type SalePackageInfoOutput = {
  __typename?: 'salePackageInfoOutput';
  includeContractInvalid?: Maybe<Scalars['Float']>;
  noIncludeContractInvalid?: Maybe<Scalars['Float']>;
};

export type SalePackageListingOutput = {
  __typename?: 'salePackageListingOutput';
  desc: Scalars['String'];
  error: Scalars['Boolean'];
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  sellingMethod: Scalars['String'];
  sellingPrice: Scalars['Float'];
};

export type SalePaymentEntity = {
  __typename?: 'salePaymentEntity';
  accountId: Scalars['String'];
  amount?: Maybe<Scalars['Float']>;
  approvedBy?: Maybe<Scalars['String']>;
  approvedTs?: Maybe<Scalars['DateTime']>;
  attachment?: Maybe<AttachmentEntity>;
  bankId?: Maybe<Scalars['String']>;
  bookingFeeAttachments: Array<AttachmentEntity>;
  id: Scalars['String'];
  paymentGatewayId?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<Scalars['String']>;
  paymentMethodDesc?: Maybe<Scalars['String']>;
  receiptNo?: Maybe<Scalars['String']>;
  refNo?: Maybe<Scalars['String']>;
  rejectedBy?: Maybe<Scalars['String']>;
  rejectedTs?: Maybe<Scalars['DateTime']>;
  remark?: Maybe<Scalars['String']>;
  response: Scalars['JSONObject'];
  sale: SaleEntity;
  saleId: Scalars['String'];
  status: Scalars['String'];
  transactionDate?: Maybe<Scalars['DateTime']>;
  transactionMethod?: Maybe<Scalars['String']>;
  verificationStatus: Scalars['String'];
};

export type SalePaymentOutput = {
  __typename?: 'salePaymentOutput';
  constructionDate: Scalars['DateTime'];
  endfinMortgagePaymentId?: Maybe<Scalars['String']>;
  expectedCount: Scalars['Float'];
  expectedFreq: Scalars['String'];
  expectedFrom: Scalars['String'];
  loanAmt?: Maybe<Scalars['Float']>;
  loanSignDate: Scalars['DateTime'];
  netAmt?: Maybe<Scalars['Float']>;
  paymentId?: Maybe<Scalars['String']>;
  paymentName: Scalars['String'];
  saleLoanId?: Maybe<Scalars['String']>;
  saleLoanRetention?: Maybe<Array<SaleRetentionOutput>>;
};

export type SalePaymentPlanInput = {
  paymentPlanId: Scalars['String'];
  paymentPlanProjectId: Scalars['String'];
  paymentPlanSummary: Array<PaymentPlanSummary>;
};

export type SalePaymentPlanOutput = {
  __typename?: 'salePaymentPlanOutput';
  id: Scalars['String'];
  isFixAmt: Scalars['Boolean'];
  paymentAmt: Scalars['Float'];
  value: Scalars['Float'];
};

export type SalePaymentPlanOutputForViewOnly = {
  __typename?: 'salePaymentPlanOutputForViewOnly';
  accountId: Scalars['String'];
  applyAmount: Scalars['Float'];
  approvalStatus: Scalars['String'];
  approvedAmount: Scalars['Float'];
  borrowerAccount?: Maybe<Scalars['String']>;
  borrowerName?: Maybe<Scalars['String']>;
  constructionDate: Scalars['DateTime'];
  description: Scalars['String'];
  endfinancierMortgagePlanId: Scalars['String'];
  financierId: Scalars['String'];
  financierName: Scalars['String'];
  financierReference: Scalars['String'];
  fullName: Scalars['String'];
  id: Scalars['String'];
  loanInterestMonth?: Maybe<Scalars['Float']>;
  loanInterestRate?: Maybe<Scalars['Float']>;
  loanPeriod?: Maybe<Scalars['Float']>;
  loanSignDate: Scalars['DateTime'];
  mortgageName: Scalars['String'];
  payment?: Maybe<Array<Payment>>;
  projectId: Scalars['String'];
  saleLoanNo?: Maybe<Scalars['String']>;
  submittedBy: Scalars['String'];
  submittedDate: Scalars['DateTime'];
  unitClusterId: Scalars['String'];
  unitId: Scalars['String'];
  unitNo: Scalars['String'];
};

export type SalePaymentValueOutput = {
  __typename?: 'SalePaymentValueOutput';
  amount: Scalars['Float'];
  receiptNo: Scalars['String'];
};

export type SaleRebateEntity = {
  __typename?: 'saleRebateEntity';
  amount: Scalars['Float'];
  discount: DiscountEntity;
  discountId: Scalars['String'];
  id: Scalars['String'];
  sale: SaleEntity;
  saleDiscountExtension?: Maybe<SalesDiscountExtEntity>;
  saleId: Scalars['String'];
  seqNo: Scalars['Float'];
};

export type SaleRebateInfoOutput = {
  __typename?: 'saleRebateInfoOutput';
  checkPaymentPlan: Scalars['Boolean'];
  discountAmount: Scalars['Float'];
  title: Scalars['String'];
};

export type SaleRebateListingOutput = {
  __typename?: 'saleRebateListingOutput';
  discountAmount: Scalars['Float'];
  discountTitle: Scalars['String'];
  documentNo?: Maybe<Scalars['String']>;
  error: Scalars['Boolean'];
  id: Scalars['String'];
  workProgressName: Scalars['String'];
};

export type SaleRebatePackageEntity = AuditEntity & {
  __typename?: 'saleRebatePackageEntity';
  accountId: Scalars['String'];
  campaign: CampaignEntity;
  campaignId: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  discount: DiscountEntity;
  discountAmount: Scalars['Float'];
  discountId: Scalars['String'];
  discountMethod: Scalars['String'];
  displayDiscountMethod?: Maybe<Scalars['String']>;
  displayRoundingMode?: Maybe<Scalars['String']>;
  displayRoundingPrecision?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  rebate?: Maybe<RebateEntity>;
  rebateId?: Maybe<Scalars['String']>;
  roundingMode: Scalars['String'];
  roundingPrecision: Scalars['String'];
  saleId: Scalars['String'];
  sales?: Maybe<SaleEntity>;
  seqNo?: Maybe<Scalars['Float']>;
  workProgress: WorkProgressEntity;
  workProgressId: Scalars['String'];
};

export type SaleRefinancingCountOutput = {
  __typename?: 'saleRefinancingCountOutput';
  approvedCount?: Maybe<Scalars['Float']>;
  draftCount?: Maybe<Scalars['Float']>;
  submittedCount?: Maybe<Scalars['Float']>;
};

export type SaleRefinancingNewPaymentPlanOutput = {
  __typename?: 'saleRefinancingNewPaymentPlanOutput';
  endfinMortgagePaymentId?: Maybe<Scalars['String']>;
  endfinMortgageRetentionId?: Maybe<Scalars['String']>;
  eventItem?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type SaleRegistrationListingOutput = {
  __typename?: 'saleRegistrationListingOutput';
  finalContractPrice: Scalars['Float'];
  jointBuyerCount?: Maybe<Scalars['Float']>;
  paymentPlanName?: Maybe<Scalars['String']>;
  projectId: Scalars['String'];
  purchaserName: Scalars['String'];
  saleContractPrice: Scalars['Float'];
  saleDate: Scalars['DateTime'];
  saleId: Scalars['String'];
  saleNo: Scalars['String'];
  saleRegDate?: Maybe<Scalars['DateTime']>;
  salesRegistrationNo?: Maybe<Scalars['String']>;
  unitClusterId: Scalars['String'];
  unitId: Scalars['String'];
  unitNo: Scalars['String'];
};

export type SaleRegistrationValueOutput = {
  __typename?: 'SaleRegistrationValueOutput';
  fullName?: Maybe<Scalars['String']>;
};

export type SaleReminderDetailOutput = {
  __typename?: 'saleReminderDetailOutput';
  reminder1: Scalars['Float'];
  reminder2: Scalars['Float'];
  reminder3: Scalars['Float'];
  reminderDetailList: Array<ReminderDetaiListOutput>;
};

export type SaleReminderListingOutput = {
  __typename?: 'saleReminderListingOutput';
  generationBatch?: Maybe<Scalars['String']>;
  reminder1: Scalars['Float'];
  reminder2: Scalars['Float'];
  reminder3: Scalars['Float'];
  reminderDate: Scalars['DateTime'];
  unitNo: Array<Scalars['String']>;
};

export type SaleReminderOutput = {
  __typename?: 'saleReminderOutput';
  bookDate: Scalars['Float'];
  buyerName: Scalars['String'];
  companyName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isCompany?: Maybe<Scalars['Boolean']>;
  reminderDate?: Maybe<Scalars['Float']>;
  reminderId: Scalars['String'];
  reminderSeq: Scalars['Float'];
  saleId: Scalars['String'];
  share?: Maybe<Array<ShareObject>>;
  unitNo: Scalars['String'];
};

export type SaleRetentionOutput = {
  __typename?: 'saleRetentionOutput';
  constructionDate: Scalars['DateTime'];
  endfinMortgageRetentionId?: Maybe<Scalars['String']>;
  expectedCount: Scalars['Float'];
  expectedFreq: Scalars['String'];
  expectedFrom: Scalars['String'];
  loanSignDate: Scalars['DateTime'];
  retentionId?: Maybe<Scalars['String']>;
  retentionName: Scalars['String'];
  retentionValue?: Maybe<Scalars['Float']>;
  saleLoanPaymentId?: Maybe<Scalars['String']>;
};

export type SalesAccountOutput = {
  __typename?: 'SalesAccountOutput';
  AccountID: Scalars['String'];
  BalanceAmt?: Maybe<Scalars['Float']>;
  BookDate?: Maybe<Scalars['DateTime']>;
  InclusiveTax_SPA?: Maybe<Scalars['Float']>;
  IsIntegrate: Scalars['Boolean'];
  KeyCollected?: Maybe<Scalars['DateTime']>;
  KeyCollectionDate?: Maybe<Scalars['DateTime']>;
  NotificationCount?: Maybe<Scalars['Float']>;
  ProjectID: Scalars['String'];
  ProjectName: Scalars['String'];
  SaleID: Scalars['String'];
  SaleStatus: Scalars['String'];
  SignDate?: Maybe<Scalars['DateTime']>;
  SignProgressDate?: Maybe<Scalars['DateTime']>;
  UnitID: Scalars['String'];
  UnitNo: Scalars['String'];
  VPLetter?: Maybe<Scalars['DateTime']>;
};

export type SalesAddAttachmentsInput = {
  attachments: Array<Scalars['Upload']>;
  ref_type: Scalars['String'];
  sale_id: Scalars['String'];
};

export enum SalesAdminPermission {
  BusinessInsightIcon = 'BUSINESS_INSIGHT__________ICON',
  BusinessInsightView = 'BUSINESS_INSIGHT__________VIEW',
  BusinessInsightBookingListView = 'BUSINESS_INSIGHT_BOOKING_LIST_______VIEW',
  BusinessInsightCampaignPerformanceView = 'BUSINESS_INSIGHT_CAMPAIGN_PERFORMANCE_______VIEW',
  BusinessInsightLeadSourceView = 'BUSINESS_INSIGHT_LEAD_SOURCE_______VIEW',
  BusinessInsightLoanView = 'BUSINESS_INSIGHT_LOAN_______VIEW',
  BusinessInsightPendingSpaView = 'BUSINESS_INSIGHT_PENDING_SPA_______VIEW',
  BusinessInsightProjectSalesMovementView = 'BUSINESS_INSIGHT_PROJECT_SALES_MOVEMENT_______VIEW',
  BusinessInsightProjectSalesPerformanceView = 'BUSINESS_INSIGHT_PROJECT_SALES_PERFORMANCE_______VIEW',
  BusinessInsightPurchaserDemographicView = 'BUSINESS_INSIGHT_PURCHASER_DEMOGRAPHIC_______VIEW',
  BusinessInsightSalesLeadPerformanceView = 'BUSINESS_INSIGHT_SALES_LEAD_PERFORMANCE_______VIEW',
  BusinessInsightSalesMovementView = 'BUSINESS_INSIGHT_SALES_MOVEMENT_______VIEW',
  BusinessInsightSalesTeamPerformanceView = 'BUSINESS_INSIGHT_SALES_TEAM_PERFORMANCE_______VIEW',
  BusinessInsightTrackingPaymentMethodView = 'BUSINESS_INSIGHT_TRACKING_PAYMENT_METHOD_______VIEW',
  BusinessInsightWaitingListView = 'BUSINESS_INSIGHT_WAITING_LIST_______VIEW',
  CommonSettingsIcon = 'COMMON_SETTINGS__________ICON',
  CommonSettingsView = 'COMMON_SETTINGS__________VIEW',
  CommonSettingsArchitectCertStagesCreate = 'COMMON_SETTINGS_ARCHITECT_CERT_STAGES_______CREATE',
  CommonSettingsArchitectCertStagesDelete = 'COMMON_SETTINGS_ARCHITECT_CERT_STAGES_______DELETE',
  CommonSettingsArchitectCertStagesUpdate = 'COMMON_SETTINGS_ARCHITECT_CERT_STAGES_______UPDATE',
  CommonSettingsArchitectCertStagesView = 'COMMON_SETTINGS_ARCHITECT_CERT_STAGES_______VIEW',
  CommonSettingsCancellationReasonCreate = 'COMMON_SETTINGS_CANCELLATION_REASON_______CREATE',
  CommonSettingsCancellationReasonDelete = 'COMMON_SETTINGS_CANCELLATION_REASON_______DELETE',
  CommonSettingsCancellationReasonUpdate = 'COMMON_SETTINGS_CANCELLATION_REASON_______UPDATE',
  CommonSettingsCancellationReasonView = 'COMMON_SETTINGS_CANCELLATION_REASON_______VIEW',
  CommonSettingsCompanySettingsCreate = 'COMMON_SETTINGS_COMPANY_SETTINGS_______CREATE',
  CommonSettingsCompanySettingsView = 'COMMON_SETTINGS_COMPANY_SETTINGS_______VIEW',
  CommonSettingsCompanySettingsAccountReceivableAgingUpdate = 'COMMON_SETTINGS_COMPANY_SETTINGS_ACCOUNT_RECEIVABLE_AGING____UPDATE',
  CommonSettingsCompanySettingsAccountReceivableAgingView = 'COMMON_SETTINGS_COMPANY_SETTINGS_ACCOUNT_RECEIVABLE_AGING____VIEW',
  CommonSettingsCompanySettingsBankCreate = 'COMMON_SETTINGS_COMPANY_SETTINGS_BANK____CREATE',
  CommonSettingsCompanySettingsBankDelete = 'COMMON_SETTINGS_COMPANY_SETTINGS_BANK____DELETE',
  CommonSettingsCompanySettingsBankUpdate = 'COMMON_SETTINGS_COMPANY_SETTINGS_BANK____UPDATE',
  CommonSettingsCompanySettingsBankView = 'COMMON_SETTINGS_COMPANY_SETTINGS_BANK____VIEW',
  CommonSettingsCompanySettingsCompanyProfileUpdate = 'COMMON_SETTINGS_COMPANY_SETTINGS_COMPANY_PROFILE____UPDATE',
  CommonSettingsCompanySettingsCompanyProfileView = 'COMMON_SETTINGS_COMPANY_SETTINGS_COMPANY_PROFILE____VIEW',
  CommonSettingsCompanySettingsTownshipCreate = 'COMMON_SETTINGS_COMPANY_SETTINGS_TOWNSHIP____CREATE',
  CommonSettingsCompanySettingsTownshipDelete = 'COMMON_SETTINGS_COMPANY_SETTINGS_TOWNSHIP____DELETE',
  CommonSettingsCompanySettingsTownshipUpdate = 'COMMON_SETTINGS_COMPANY_SETTINGS_TOWNSHIP____UPDATE',
  CommonSettingsCompanySettingsTownshipView = 'COMMON_SETTINGS_COMPANY_SETTINGS_TOWNSHIP____VIEW',
  CommonSettingsDiscountCreate = 'COMMON_SETTINGS_DISCOUNT_______CREATE',
  CommonSettingsDiscountDelete = 'COMMON_SETTINGS_DISCOUNT_______DELETE',
  CommonSettingsDiscountUpdate = 'COMMON_SETTINGS_DISCOUNT_______UPDATE',
  CommonSettingsDiscountView = 'COMMON_SETTINGS_DISCOUNT_______VIEW',
  CommonSettingsDiscountTypeCreate = 'COMMON_SETTINGS_DISCOUNT_TYPE_______CREATE',
  CommonSettingsDiscountTypeDelete = 'COMMON_SETTINGS_DISCOUNT_TYPE_______DELETE',
  CommonSettingsDiscountTypeUpdate = 'COMMON_SETTINGS_DISCOUNT_TYPE_______UPDATE',
  CommonSettingsDiscountTypeView = 'COMMON_SETTINGS_DISCOUNT_TYPE_______VIEW',
  CommonSettingsLeadChannelCreate = 'COMMON_SETTINGS_LEAD_CHANNEL_______CREATE',
  CommonSettingsLeadChannelDelete = 'COMMON_SETTINGS_LEAD_CHANNEL_______DELETE',
  CommonSettingsLeadChannelUpdate = 'COMMON_SETTINGS_LEAD_CHANNEL_______UPDATE',
  CommonSettingsLeadChannelView = 'COMMON_SETTINGS_LEAD_CHANNEL_______VIEW',
  CommonSettingsPaymentPlanCreate = 'COMMON_SETTINGS_PAYMENT_PLAN_______CREATE',
  CommonSettingsPaymentPlanDelete = 'COMMON_SETTINGS_PAYMENT_PLAN_______DELETE',
  CommonSettingsPaymentPlanUpdate = 'COMMON_SETTINGS_PAYMENT_PLAN_______UPDATE',
  CommonSettingsPaymentPlanView = 'COMMON_SETTINGS_PAYMENT_PLAN_______VIEW',
  CommonSettingsStandardApprovalFlowView = 'COMMON_SETTINGS_STANDARD_APPROVAL_FLOW_______VIEW',
  CommonSettingsStandardApprovalFlowCollectionUpdate = 'COMMON_SETTINGS_STANDARD_APPROVAL_FLOW_COLLECTION____UPDATE',
  CommonSettingsStandardApprovalFlowCollectionView = 'COMMON_SETTINGS_STANDARD_APPROVAL_FLOW_COLLECTION____VIEW',
  CommonSettingsStandardApprovalFlowContraUpdate = 'COMMON_SETTINGS_STANDARD_APPROVAL_FLOW_CONTRA____UPDATE',
  CommonSettingsStandardApprovalFlowContraView = 'COMMON_SETTINGS_STANDARD_APPROVAL_FLOW_CONTRA____VIEW',
  CommonSettingsStandardApprovalFlowCreditNoteUpdate = 'COMMON_SETTINGS_STANDARD_APPROVAL_FLOW_CREDIT_NOTE____UPDATE',
  CommonSettingsStandardApprovalFlowCreditNoteView = 'COMMON_SETTINGS_STANDARD_APPROVAL_FLOW_CREDIT_NOTE____VIEW',
  CommonSettingsStandardApprovalFlowDebitNoteUpdate = 'COMMON_SETTINGS_STANDARD_APPROVAL_FLOW_DEBIT_NOTE____UPDATE',
  CommonSettingsStandardApprovalFlowDebitNoteView = 'COMMON_SETTINGS_STANDARD_APPROVAL_FLOW_DEBIT_NOTE____VIEW',
  CommonSettingsStandardApprovalFlowLateInterestChargesUpdate = 'COMMON_SETTINGS_STANDARD_APPROVAL_FLOW_LATE_INTEREST_CHARGES____UPDATE',
  CommonSettingsStandardApprovalFlowLateInterestChargesView = 'COMMON_SETTINGS_STANDARD_APPROVAL_FLOW_LATE_INTEREST_CHARGES____VIEW',
  CommonSettingsStandardApprovalFlowMiscBillingUpdate = 'COMMON_SETTINGS_STANDARD_APPROVAL_FLOW_MISC_BILLING____UPDATE',
  CommonSettingsStandardApprovalFlowMiscBillingView = 'COMMON_SETTINGS_STANDARD_APPROVAL_FLOW_MISC_BILLING____VIEW',
  CommonSettingsStandardApprovalFlowProgressBillingUpdate = 'COMMON_SETTINGS_STANDARD_APPROVAL_FLOW_PROGRESS_BILLING____UPDATE',
  CommonSettingsStandardApprovalFlowProgressBillingView = 'COMMON_SETTINGS_STANDARD_APPROVAL_FLOW_PROGRESS_BILLING____VIEW',
  CommonSettingsStandardApprovalFlowRebateUpdate = 'COMMON_SETTINGS_STANDARD_APPROVAL_FLOW_REBATE____UPDATE',
  CommonSettingsStandardApprovalFlowRebateView = 'COMMON_SETTINGS_STANDARD_APPROVAL_FLOW_REBATE____VIEW',
  CommonSettingsStandardApprovalFlowRefundUpdate = 'COMMON_SETTINGS_STANDARD_APPROVAL_FLOW_REFUND____UPDATE',
  CommonSettingsStandardApprovalFlowRefundView = 'COMMON_SETTINGS_STANDARD_APPROVAL_FLOW_REFUND____VIEW',
  CommonSettingsStandardApprovalFlowSalesCancellationUpdate = 'COMMON_SETTINGS_STANDARD_APPROVAL_FLOW_SALES_CANCELLATION____UPDATE',
  CommonSettingsStandardApprovalFlowSalesCancellationView = 'COMMON_SETTINGS_STANDARD_APPROVAL_FLOW_SALES_CANCELLATION____VIEW',
  CommonSettingsStandardEletteringCreate = 'COMMON_SETTINGS_STANDARD_ELETTERING_______CREATE',
  CommonSettingsStandardEletteringPreview = 'COMMON_SETTINGS_STANDARD_ELETTERING_______PREVIEW',
  CommonSettingsStandardEletteringView = 'COMMON_SETTINGS_STANDARD_ELETTERING_______VIEW',
  CommonSettingsStandardParametersView = 'COMMON_SETTINGS_STANDARD_PARAMETERS_______VIEW',
  CommonSettingsStandardParametersDesignationCreate = 'COMMON_SETTINGS_STANDARD_PARAMETERS_DESIGNATION____CREATE',
  CommonSettingsStandardParametersDesignationDelete = 'COMMON_SETTINGS_STANDARD_PARAMETERS_DESIGNATION____DELETE',
  CommonSettingsStandardParametersDesignationUpdate = 'COMMON_SETTINGS_STANDARD_PARAMETERS_DESIGNATION____UPDATE',
  CommonSettingsStandardParametersDesignationView = 'COMMON_SETTINGS_STANDARD_PARAMETERS_DESIGNATION____VIEW',
  CommonSettingsStandardParametersEducationCreate = 'COMMON_SETTINGS_STANDARD_PARAMETERS_EDUCATION____CREATE',
  CommonSettingsStandardParametersEducationDelete = 'COMMON_SETTINGS_STANDARD_PARAMETERS_EDUCATION____DELETE',
  CommonSettingsStandardParametersEducationUpdate = 'COMMON_SETTINGS_STANDARD_PARAMETERS_EDUCATION____UPDATE',
  CommonSettingsStandardParametersEducationView = 'COMMON_SETTINGS_STANDARD_PARAMETERS_EDUCATION____VIEW',
  CommonSettingsStandardParametersIncomeRangeView = 'COMMON_SETTINGS_STANDARD_PARAMETERS_INCOME_RANGE____VIEW',
  CommonSettingsStandardParametersIndustryCreate = 'COMMON_SETTINGS_STANDARD_PARAMETERS_INDUSTRY____CREATE',
  CommonSettingsStandardParametersIndustryDelete = 'COMMON_SETTINGS_STANDARD_PARAMETERS_INDUSTRY____DELETE',
  CommonSettingsStandardParametersIndustryUpdate = 'COMMON_SETTINGS_STANDARD_PARAMETERS_INDUSTRY____UPDATE',
  CommonSettingsStandardParametersIndustryView = 'COMMON_SETTINGS_STANDARD_PARAMETERS_INDUSTRY____VIEW',
  CommonSettingsStandardParametersMaritalStatusCreate = 'COMMON_SETTINGS_STANDARD_PARAMETERS_MARITAL_STATUS____CREATE',
  CommonSettingsStandardParametersMaritalStatusDelete = 'COMMON_SETTINGS_STANDARD_PARAMETERS_MARITAL_STATUS____DELETE',
  CommonSettingsStandardParametersMaritalStatusUpdate = 'COMMON_SETTINGS_STANDARD_PARAMETERS_MARITAL_STATUS____UPDATE',
  CommonSettingsStandardParametersMaritalStatusView = 'COMMON_SETTINGS_STANDARD_PARAMETERS_MARITAL_STATUS____VIEW',
  CommonSettingsStandardParametersProfessionCreate = 'COMMON_SETTINGS_STANDARD_PARAMETERS_PROFESSION____CREATE',
  CommonSettingsStandardParametersProfessionDelete = 'COMMON_SETTINGS_STANDARD_PARAMETERS_PROFESSION____DELETE',
  CommonSettingsStandardParametersProfessionUpdate = 'COMMON_SETTINGS_STANDARD_PARAMETERS_PROFESSION____UPDATE',
  CommonSettingsStandardParametersProfessionView = 'COMMON_SETTINGS_STANDARD_PARAMETERS_PROFESSION____VIEW',
  CommonSettingsStandardParametersProjectTypeCreate = 'COMMON_SETTINGS_STANDARD_PARAMETERS_PROJECT_TYPE____CREATE',
  CommonSettingsStandardParametersProjectTypeDelete = 'COMMON_SETTINGS_STANDARD_PARAMETERS_PROJECT_TYPE____DELETE',
  CommonSettingsStandardParametersProjectTypeUpdate = 'COMMON_SETTINGS_STANDARD_PARAMETERS_PROJECT_TYPE____UPDATE',
  CommonSettingsStandardParametersProjectTypeView = 'COMMON_SETTINGS_STANDARD_PARAMETERS_PROJECT_TYPE____VIEW',
  CommonSettingsStandardParametersPropertyTypeCreate = 'COMMON_SETTINGS_STANDARD_PARAMETERS_PROPERTY_TYPE____CREATE',
  CommonSettingsStandardParametersPropertyTypeDelete = 'COMMON_SETTINGS_STANDARD_PARAMETERS_PROPERTY_TYPE____DELETE',
  CommonSettingsStandardParametersPropertyTypeUpdate = 'COMMON_SETTINGS_STANDARD_PARAMETERS_PROPERTY_TYPE____UPDATE',
  CommonSettingsStandardParametersPropertyTypeView = 'COMMON_SETTINGS_STANDARD_PARAMETERS_PROPERTY_TYPE____VIEW',
  CommonSettingsStandardParametersRaceCreate = 'COMMON_SETTINGS_STANDARD_PARAMETERS_RACE____CREATE',
  CommonSettingsStandardParametersRaceDelete = 'COMMON_SETTINGS_STANDARD_PARAMETERS_RACE____DELETE',
  CommonSettingsStandardParametersRaceUpdate = 'COMMON_SETTINGS_STANDARD_PARAMETERS_RACE____UPDATE',
  CommonSettingsStandardParametersRaceView = 'COMMON_SETTINGS_STANDARD_PARAMETERS_RACE____VIEW',
  CommonSettingsStandardParametersRelationshipCreate = 'COMMON_SETTINGS_STANDARD_PARAMETERS_RELATIONSHIP____CREATE',
  CommonSettingsStandardParametersRelationshipDelete = 'COMMON_SETTINGS_STANDARD_PARAMETERS_RELATIONSHIP____DELETE',
  CommonSettingsStandardParametersRelationshipUpdate = 'COMMON_SETTINGS_STANDARD_PARAMETERS_RELATIONSHIP____UPDATE',
  CommonSettingsStandardParametersRelationshipView = 'COMMON_SETTINGS_STANDARD_PARAMETERS_RELATIONSHIP____VIEW',
  CommonSettingsStandardParametersReligionCreate = 'COMMON_SETTINGS_STANDARD_PARAMETERS_RELIGION____CREATE',
  CommonSettingsStandardParametersReligionDelete = 'COMMON_SETTINGS_STANDARD_PARAMETERS_RELIGION____DELETE',
  CommonSettingsStandardParametersReligionUpdate = 'COMMON_SETTINGS_STANDARD_PARAMETERS_RELIGION____UPDATE',
  CommonSettingsStandardParametersReligionView = 'COMMON_SETTINGS_STANDARD_PARAMETERS_RELIGION____VIEW',
  CommonSettingsStandardParametersSalutationCreate = 'COMMON_SETTINGS_STANDARD_PARAMETERS_SALUTATION____CREATE',
  CommonSettingsStandardParametersSalutationDelete = 'COMMON_SETTINGS_STANDARD_PARAMETERS_SALUTATION____DELETE',
  CommonSettingsStandardParametersSalutationUpdate = 'COMMON_SETTINGS_STANDARD_PARAMETERS_SALUTATION____UPDATE',
  CommonSettingsStandardParametersSalutationView = 'COMMON_SETTINGS_STANDARD_PARAMETERS_SALUTATION____VIEW',
  CommonSettingsStandardParametersUnitDirectionCreate = 'COMMON_SETTINGS_STANDARD_PARAMETERS_UNIT_DIRECTION____CREATE',
  CommonSettingsStandardParametersUnitDirectionDelete = 'COMMON_SETTINGS_STANDARD_PARAMETERS_UNIT_DIRECTION____DELETE',
  CommonSettingsStandardParametersUnitDirectionUpdate = 'COMMON_SETTINGS_STANDARD_PARAMETERS_UNIT_DIRECTION____UPDATE',
  CommonSettingsStandardParametersUnitDirectionView = 'COMMON_SETTINGS_STANDARD_PARAMETERS_UNIT_DIRECTION____VIEW',
  CommonSettingsStandardParametersUnitTypeCreate = 'COMMON_SETTINGS_STANDARD_PARAMETERS_UNIT_TYPE____CREATE',
  CommonSettingsStandardParametersUnitTypeDelete = 'COMMON_SETTINGS_STANDARD_PARAMETERS_UNIT_TYPE____DELETE',
  CommonSettingsStandardParametersUnitTypeUpdate = 'COMMON_SETTINGS_STANDARD_PARAMETERS_UNIT_TYPE____UPDATE',
  CommonSettingsStandardParametersUnitTypeView = 'COMMON_SETTINGS_STANDARD_PARAMETERS_UNIT_TYPE____VIEW',
  CommonSettingsTaxSetupCreate = 'COMMON_SETTINGS_TAX_SETUP_______CREATE',
  CommonSettingsTaxSetupDeactive = 'COMMON_SETTINGS_TAX_SETUP_______DEACTIVE',
  CommonSettingsTaxSetupUpdate = 'COMMON_SETTINGS_TAX_SETUP_______UPDATE',
  CommonSettingsTaxSetupView = 'COMMON_SETTINGS_TAX_SETUP_______VIEW',
  EndFinancierCreate = 'END_FINANCIER__________CREATE',
  EndFinancierUpdate = 'END_FINANCIER__________UPDATE',
  EndFinancierView = 'END_FINANCIER__________VIEW',
  OpenLeadsIcon = 'OPEN_LEADS__________ICON',
  OpenLeadsView = 'OPEN_LEADS__________VIEW',
  OpenLeadsDownloadLeadTemplateView = 'OPEN_LEADS_DOWNLOAD_LEAD_TEMPLATE_______VIEW',
  OpenLeadsImportLeadsCreate = 'OPEN_LEADS_IMPORT_LEADS_______CREATE',
  OpenLeadsImportLeadsView = 'OPEN_LEADS_IMPORT_LEADS_______VIEW',
  OpenLeadsLeadAssignmentView = 'OPEN_LEADS_LEAD_ASSIGNMENT_______VIEW',
  ProjectSetupCreate = 'PROJECT_SETUP__________CREATE',
  ProjectSetupView = 'PROJECT_SETUP__________VIEW',
  ProjectSetupBusinessPermitsCreate = 'PROJECT_SETUP_BUSINESS_PERMITS_______CREATE',
  ProjectSetupBusinessPermitsDelete = 'PROJECT_SETUP_BUSINESS_PERMITS_______DELETE',
  ProjectSetupBusinessPermitsUpdate = 'PROJECT_SETUP_BUSINESS_PERMITS_______UPDATE',
  ProjectSetupBusinessPermitsView = 'PROJECT_SETUP_BUSINESS_PERMITS_______VIEW',
  ProjectSetupCampaignCreate = 'PROJECT_SETUP_CAMPAIGN_______CREATE',
  ProjectSetupCampaignDelete = 'PROJECT_SETUP_CAMPAIGN_______DELETE',
  ProjectSetupCampaignEventsList = 'PROJECT_SETUP_CAMPAIGN_______EVENTS_LIST',
  ProjectSetupCampaignUpdate = 'PROJECT_SETUP_CAMPAIGN_______UPDATE',
  ProjectSetupCampaignView = 'PROJECT_SETUP_CAMPAIGN_______VIEW',
  ProjectSetupCampaignEventsCreate = 'PROJECT_SETUP_CAMPAIGN_EVENTS____CREATE',
  ProjectSetupCampaignEventsDelete = 'PROJECT_SETUP_CAMPAIGN_EVENTS____DELETE',
  ProjectSetupCampaignEventsUpdate = 'PROJECT_SETUP_CAMPAIGN_EVENTS____UPDATE',
  ProjectSetupCampaignEventsView = 'PROJECT_SETUP_CAMPAIGN_EVENTS____VIEW',
  ProjectSetupConstructionInfoCreate = 'PROJECT_SETUP_CONSTRUCTION_INFO_______CREATE',
  ProjectSetupConstructionInfoView = 'PROJECT_SETUP_CONSTRUCTION_INFO_______VIEW',
  ProjectSetupDiscountCreate = 'PROJECT_SETUP_DISCOUNT_______CREATE',
  ProjectSetupDiscountDelete = 'PROJECT_SETUP_DISCOUNT_______DELETE',
  ProjectSetupDiscountUpdate = 'PROJECT_SETUP_DISCOUNT_______UPDATE',
  ProjectSetupDiscountView = 'PROJECT_SETUP_DISCOUNT_______VIEW',
  ProjectSetupFireInsuranceInfoCreate = 'PROJECT_SETUP_FIRE_INSURANCE_INFO_______CREATE',
  ProjectSetupFireInsuranceInfoView = 'PROJECT_SETUP_FIRE_INSURANCE_INFO_______VIEW',
  ProjectSetupPanelEndFinancierAdjust = 'PROJECT_SETUP_PANEL_END_FINANCIER_______ADJUST',
  ProjectSetupPanelEndFinancierCreate = 'PROJECT_SETUP_PANEL_END_FINANCIER_______CREATE',
  ProjectSetupPanelEndFinancierInvite = 'PROJECT_SETUP_PANEL_END_FINANCIER_______INVITE',
  ProjectSetupPanelEndFinancierUnassign = 'PROJECT_SETUP_PANEL_END_FINANCIER_______UNASSIGN',
  ProjectSetupPanelEndFinancierView = 'PROJECT_SETUP_PANEL_END_FINANCIER_______VIEW',
  ProjectSetupPanelSolicitorCreate = 'PROJECT_SETUP_PANEL_SOLICITOR_______CREATE',
  ProjectSetupPanelSolicitorDelete = 'PROJECT_SETUP_PANEL_SOLICITOR_______DELETE',
  ProjectSetupPanelSolicitorUpdate = 'PROJECT_SETUP_PANEL_SOLICITOR_______UPDATE',
  ProjectSetupPanelSolicitorView = 'PROJECT_SETUP_PANEL_SOLICITOR_______VIEW',
  ProjectSetupProjectApprovalFlowView = 'PROJECT_SETUP_PROJECT_APPROVAL_FLOW_______VIEW',
  ProjectSetupProjectApprovalFlowCollectionUpdate = 'PROJECT_SETUP_PROJECT_APPROVAL_FLOW_COLLECTION____UPDATE',
  ProjectSetupProjectApprovalFlowCollectionView = 'PROJECT_SETUP_PROJECT_APPROVAL_FLOW_COLLECTION____VIEW',
  ProjectSetupProjectApprovalFlowContraUpdate = 'PROJECT_SETUP_PROJECT_APPROVAL_FLOW_CONTRA____UPDATE',
  ProjectSetupProjectApprovalFlowContraView = 'PROJECT_SETUP_PROJECT_APPROVAL_FLOW_CONTRA____VIEW',
  ProjectSetupProjectApprovalFlowCreditNoteUpdate = 'PROJECT_SETUP_PROJECT_APPROVAL_FLOW_CREDIT_NOTE____UPDATE',
  ProjectSetupProjectApprovalFlowCreditNoteView = 'PROJECT_SETUP_PROJECT_APPROVAL_FLOW_CREDIT_NOTE____VIEW',
  ProjectSetupProjectApprovalFlowDebitNoteUpdate = 'PROJECT_SETUP_PROJECT_APPROVAL_FLOW_DEBIT_NOTE____UPDATE',
  ProjectSetupProjectApprovalFlowDebitNoteView = 'PROJECT_SETUP_PROJECT_APPROVAL_FLOW_DEBIT_NOTE____VIEW',
  ProjectSetupProjectApprovalFlowLateInterestChargesUpdate = 'PROJECT_SETUP_PROJECT_APPROVAL_FLOW_LATE_INTEREST_CHARGES____UPDATE',
  ProjectSetupProjectApprovalFlowLateInterestChargesView = 'PROJECT_SETUP_PROJECT_APPROVAL_FLOW_LATE_INTEREST_CHARGES____VIEW',
  ProjectSetupProjectApprovalFlowMiscBillingUpdate = 'PROJECT_SETUP_PROJECT_APPROVAL_FLOW_MISC_BILLING____UPDATE',
  ProjectSetupProjectApprovalFlowMiscBillingView = 'PROJECT_SETUP_PROJECT_APPROVAL_FLOW_MISC_BILLING____VIEW',
  ProjectSetupProjectApprovalFlowProgressBillingUpdate = 'PROJECT_SETUP_PROJECT_APPROVAL_FLOW_PROGRESS_BILLING____UPDATE',
  ProjectSetupProjectApprovalFlowProgressBillingView = 'PROJECT_SETUP_PROJECT_APPROVAL_FLOW_PROGRESS_BILLING____VIEW',
  ProjectSetupProjectApprovalFlowRebateUpdate = 'PROJECT_SETUP_PROJECT_APPROVAL_FLOW_REBATE____UPDATE',
  ProjectSetupProjectApprovalFlowRebateView = 'PROJECT_SETUP_PROJECT_APPROVAL_FLOW_REBATE____VIEW',
  ProjectSetupProjectApprovalFlowRefundUpdate = 'PROJECT_SETUP_PROJECT_APPROVAL_FLOW_REFUND____UPDATE',
  ProjectSetupProjectApprovalFlowRefundView = 'PROJECT_SETUP_PROJECT_APPROVAL_FLOW_REFUND____VIEW',
  ProjectSetupProjectApprovalFlowSalesCancellationUpdate = 'PROJECT_SETUP_PROJECT_APPROVAL_FLOW_SALES_CANCELLATION____UPDATE',
  ProjectSetupProjectApprovalFlowSalesCancellationView = 'PROJECT_SETUP_PROJECT_APPROVAL_FLOW_SALES_CANCELLATION____VIEW',
  ProjectSetupProjectDetailsView = 'PROJECT_SETUP_PROJECT_DETAILS_______VIEW',
  ProjectSetupProjectPolicyCreate = 'PROJECT_SETUP_PROJECT_POLICY_______CREATE',
  ProjectSetupProjectPolicyView = 'PROJECT_SETUP_PROJECT_POLICY_______VIEW',
  ProjectSetupProjectStandardLettersCreate = 'PROJECT_SETUP_PROJECT_STANDARD_LETTERS_______CREATE',
  ProjectSetupProjectStandardLettersPreview = 'PROJECT_SETUP_PROJECT_STANDARD_LETTERS_______PREVIEW',
  ProjectSetupProjectStandardLettersView = 'PROJECT_SETUP_PROJECT_STANDARD_LETTERS_______VIEW',
  ProjectSetupRoleAccessSecurityUpdate = 'PROJECT_SETUP_ROLE_ACCESS_SECURITY_______UPDATE',
  ProjectSetupRoleAccessSecurityView = 'PROJECT_SETUP_ROLE_ACCESS_SECURITY_______VIEW',
  ProjectSetupSalesOfficeInfoCreate = 'PROJECT_SETUP_SALES_OFFICE_INFO_______CREATE',
  ProjectSetupSalesOfficeInfoView = 'PROJECT_SETUP_SALES_OFFICE_INFO_______VIEW',
  ProjectSetupSalesPackagesCreate = 'PROJECT_SETUP_SALES_PACKAGES_______CREATE',
  ProjectSetupSalesPackagesDelete = 'PROJECT_SETUP_SALES_PACKAGES_______DELETE',
  ProjectSetupSalesPackagesUpdate = 'PROJECT_SETUP_SALES_PACKAGES_______UPDATE',
  ProjectSetupSalesPackagesView = 'PROJECT_SETUP_SALES_PACKAGES_______VIEW',
  ProjectSetupUnitSetupCreate = 'PROJECT_SETUP_UNIT_SETUP_______CREATE',
  ProjectSetupUnitSetupUpdate = 'PROJECT_SETUP_UNIT_SETUP_______UPDATE',
  ProjectSetupUnitSetupView = 'PROJECT_SETUP_UNIT_SETUP_______VIEW',
  PropertyAgencyCreate = 'PROPERTY_AGENCY__________CREATE',
  PropertyAgencyUpdate = 'PROPERTY_AGENCY__________UPDATE',
  PropertyAgencyView = 'PROPERTY_AGENCY__________VIEW',
  SalesAdminIcon = 'SALES_ADMIN__________ICON',
  SalesAdminView = 'SALES_ADMIN__________VIEW',
  SalesAdminAreaVarianceView = 'SALES_ADMIN_AREA_VARIANCE_______VIEW',
  SalesAdminAreaVarianceAreaVarianceCreate = 'SALES_ADMIN_AREA_VARIANCE_AREA_VARIANCE____CREATE',
  SalesAdminAreaVarianceAreaVarianceGenerate = 'SALES_ADMIN_AREA_VARIANCE_AREA_VARIANCE____GENERATE',
  SalesAdminAreaVarianceAreaVarianceReversal = 'SALES_ADMIN_AREA_VARIANCE_AREA_VARIANCE____REVERSAL',
  SalesAdminAreaVarianceAreaVarianceShare = 'SALES_ADMIN_AREA_VARIANCE_AREA_VARIANCE____SHARE',
  SalesAdminAreaVarianceAreaVarianceUpdate = 'SALES_ADMIN_AREA_VARIANCE_AREA_VARIANCE____UPDATE',
  SalesAdminAreaVarianceAreaVarianceView = 'SALES_ADMIN_AREA_VARIANCE_AREA_VARIANCE____VIEW',
  SalesAdminAreaVarianceAreaVariancePolicyCreate = 'SALES_ADMIN_AREA_VARIANCE_AREA_VARIANCE_POLICY____CREATE',
  SalesAdminAreaVarianceAreaVariancePolicyDelete = 'SALES_ADMIN_AREA_VARIANCE_AREA_VARIANCE_POLICY____DELETE',
  SalesAdminAreaVarianceAreaVariancePolicyUpdate = 'SALES_ADMIN_AREA_VARIANCE_AREA_VARIANCE_POLICY____UPDATE',
  SalesAdminAreaVarianceAreaVariancePolicyView = 'SALES_ADMIN_AREA_VARIANCE_AREA_VARIANCE_POLICY____VIEW',
  SalesAdminBridgingLoanView = 'SALES_ADMIN_BRIDGING_LOAN_______VIEW',
  SalesAdminBridgingLoanBridgingFinancingSettingCreate = 'SALES_ADMIN_BRIDGING_LOAN_BRIDGING_FINANCING_SETTING____CREATE',
  SalesAdminBridgingLoanBridgingFinancingSettingUpdate = 'SALES_ADMIN_BRIDGING_LOAN_BRIDGING_FINANCING_SETTING____UPDATE',
  SalesAdminBridgingLoanBridgingFinancingSettingView = 'SALES_ADMIN_BRIDGING_LOAN_BRIDGING_FINANCING_SETTING____VIEW',
  SalesAdminBridgingLoanRedemptionRepaymentCreate = 'SALES_ADMIN_BRIDGING_LOAN_REDEMPTION_REPAYMENT____CREATE',
  SalesAdminBridgingLoanRedemptionRepaymentReversal = 'SALES_ADMIN_BRIDGING_LOAN_REDEMPTION_REPAYMENT____REVERSAL',
  SalesAdminBridgingLoanRedemptionRepaymentView = 'SALES_ADMIN_BRIDGING_LOAN_REDEMPTION_REPAYMENT____VIEW',
  SalesAdminCreditControlView = 'SALES_ADMIN_CREDIT_CONTROL_______VIEW',
  SalesAdminCreditControlCollectionActivityCreate = 'SALES_ADMIN_CREDIT_CONTROL_COLLECTION_ACTIVITY____CREATE',
  SalesAdminCreditControlCollectionActivityStatus = 'SALES_ADMIN_CREDIT_CONTROL_COLLECTION_ACTIVITY____STATUS',
  SalesAdminCreditControlCollectionActivityUpdate = 'SALES_ADMIN_CREDIT_CONTROL_COLLECTION_ACTIVITY____UPDATE',
  SalesAdminCreditControlCollectionActivityView = 'SALES_ADMIN_CREDIT_CONTROL_COLLECTION_ACTIVITY____VIEW',
  SalesAdminCreditControlLatePaymentInterestCreate = 'SALES_ADMIN_CREDIT_CONTROL_LATE_PAYMENT_INTEREST____CREATE',
  SalesAdminCreditControlLatePaymentInterestShare = 'SALES_ADMIN_CREDIT_CONTROL_LATE_PAYMENT_INTEREST____SHARE',
  SalesAdminCreditControlLatePaymentInterestView = 'SALES_ADMIN_CREDIT_CONTROL_LATE_PAYMENT_INTEREST____VIEW',
  SalesAdminCreditControlLatePaymentInterestSettingCreate = 'SALES_ADMIN_CREDIT_CONTROL_LATE_PAYMENT_INTEREST_SETTING____CREATE',
  SalesAdminCreditControlPaymentReminderCreate = 'SALES_ADMIN_CREDIT_CONTROL_PAYMENT_REMINDER____CREATE',
  SalesAdminCreditControlPaymentReminderEmail = 'SALES_ADMIN_CREDIT_CONTROL_PAYMENT_REMINDER____EMAIL',
  SalesAdminCreditControlPaymentReminderPrint = 'SALES_ADMIN_CREDIT_CONTROL_PAYMENT_REMINDER____PRINT',
  SalesAdminCreditControlPaymentReminderView = 'SALES_ADMIN_CREDIT_CONTROL_PAYMENT_REMINDER____VIEW',
  SalesAdminCreditControlPaymentReminderSettingCreate = 'SALES_ADMIN_CREDIT_CONTROL_PAYMENT_REMINDER_SETTING____CREATE',
  SalesAdminDigitalReportingCreate = 'SALES_ADMIN_DIGITAL_REPORTING_______CREATE',
  SalesAdminDigitalReportingDelete = 'SALES_ADMIN_DIGITAL_REPORTING_______DELETE',
  SalesAdminDigitalReportingUpdate = 'SALES_ADMIN_DIGITAL_REPORTING_______UPDATE',
  SalesAdminDigitalReportingView = 'SALES_ADMIN_DIGITAL_REPORTING_______VIEW',
  SalesAdminDownpaymentReminderCreate = 'SALES_ADMIN_DOWNPAYMENT_REMINDER_______CREATE',
  SalesAdminDownpaymentReminderShare = 'SALES_ADMIN_DOWNPAYMENT_REMINDER_______SHARE',
  SalesAdminDownpaymentReminderView = 'SALES_ADMIN_DOWNPAYMENT_REMINDER_______VIEW',
  SalesAdminEndFinancingView = 'SALES_ADMIN_END_FINANCING_______VIEW',
  SalesAdminEndFinancingApprovedLoanCancel = 'SALES_ADMIN_END_FINANCING_APPROVED_LOAN____CANCEL',
  SalesAdminEndFinancingApprovedLoanCreate = 'SALES_ADMIN_END_FINANCING_APPROVED_LOAN____CREATE',
  SalesAdminEndFinancingApprovedLoanRenotice = 'SALES_ADMIN_END_FINANCING_APPROVED_LOAN____RENOTICE',
  SalesAdminEndFinancingApprovedLoanView = 'SALES_ADMIN_END_FINANCING_APPROVED_LOAN____VIEW',
  SalesAdminEndFinancingEndFinancierAccountsView = 'SALES_ADMIN_END_FINANCING_END_FINANCIER_ACCOUNTS____VIEW',
  SalesAdminEndFinancingLoanSettlementCreate = 'SALES_ADMIN_END_FINANCING_LOAN_SETTLEMENT____CREATE',
  SalesAdminEndFinancingLoanSettlementDelete = 'SALES_ADMIN_END_FINANCING_LOAN_SETTLEMENT____DELETE',
  SalesAdminEndFinancingLoanSettlementUpdate = 'SALES_ADMIN_END_FINANCING_LOAN_SETTLEMENT____UPDATE',
  SalesAdminEndFinancingLoanSettlementView = 'SALES_ADMIN_END_FINANCING_LOAN_SETTLEMENT____VIEW',
  SalesAdminEndFinancingRefinancingCreate = 'SALES_ADMIN_END_FINANCING_REFINANCING____CREATE',
  SalesAdminEndFinancingRefinancingDelete = 'SALES_ADMIN_END_FINANCING_REFINANCING____DELETE',
  SalesAdminEndFinancingRefinancingUpdate = 'SALES_ADMIN_END_FINANCING_REFINANCING____UPDATE',
  SalesAdminEndFinancingRefinancingView = 'SALES_ADMIN_END_FINANCING_REFINANCING____VIEW',
  SalesAdminKeyCollectionView = 'SALES_ADMIN_KEY_COLLECTION_______VIEW',
  SalesAdminKeyCollectionKeyCollectionAppointmentCreate = 'SALES_ADMIN_KEY_COLLECTION_KEY_COLLECTION_APPOINTMENT____CREATE',
  SalesAdminKeyCollectionKeyCollectionAppointmentDelete = 'SALES_ADMIN_KEY_COLLECTION_KEY_COLLECTION_APPOINTMENT____DELETE',
  SalesAdminKeyCollectionKeyCollectionAppointmentUpdate = 'SALES_ADMIN_KEY_COLLECTION_KEY_COLLECTION_APPOINTMENT____UPDATE',
  SalesAdminKeyCollectionKeyCollectionAppointmentView = 'SALES_ADMIN_KEY_COLLECTION_KEY_COLLECTION_APPOINTMENT____VIEW',
  SalesAdminKeyCollectionKeyCollectionContractorCreate = 'SALES_ADMIN_KEY_COLLECTION_KEY_COLLECTION_CONTRACTOR____CREATE',
  SalesAdminKeyCollectionKeyCollectionContractorDelete = 'SALES_ADMIN_KEY_COLLECTION_KEY_COLLECTION_CONTRACTOR____DELETE',
  SalesAdminKeyCollectionKeyCollectionContractorUpdate = 'SALES_ADMIN_KEY_COLLECTION_KEY_COLLECTION_CONTRACTOR____UPDATE',
  SalesAdminKeyCollectionKeyCollectionContractorView = 'SALES_ADMIN_KEY_COLLECTION_KEY_COLLECTION_CONTRACTOR____VIEW',
  SalesAdminKeyCollectionKeyCollectionScheduleSettingCreate = 'SALES_ADMIN_KEY_COLLECTION_KEY_COLLECTION_SCHEDULE_SETTING____CREATE',
  SalesAdminKeyCollectionKeyCollectionScheduleSettingDelete = 'SALES_ADMIN_KEY_COLLECTION_KEY_COLLECTION_SCHEDULE_SETTING____DELETE',
  SalesAdminKeyCollectionKeyCollectionScheduleSettingView = 'SALES_ADMIN_KEY_COLLECTION_KEY_COLLECTION_SCHEDULE_SETTING____VIEW',
  SalesAdminLadView = 'SALES_ADMIN_LAD_______VIEW',
  SalesAdminLadLadProcessingCreate = 'SALES_ADMIN_LAD_LAD_PROCESSING____CREATE',
  SalesAdminLadLadProcessingReversal = 'SALES_ADMIN_LAD_LAD_PROCESSING____REVERSAL',
  SalesAdminLadLadProcessingShare = 'SALES_ADMIN_LAD_LAD_PROCESSING____SHARE',
  SalesAdminLadLadProcessingView = 'SALES_ADMIN_LAD_LAD_PROCESSING____VIEW',
  SalesAdminLadLadSettingCreate = 'SALES_ADMIN_LAD_LAD_SETTING____CREATE',
  SalesAdminMotTrackingCreate = 'SALES_ADMIN_MOT_TRACKING_______CREATE',
  SalesAdminMotTrackingDelete = 'SALES_ADMIN_MOT_TRACKING_______DELETE',
  SalesAdminMotTrackingUpdate = 'SALES_ADMIN_MOT_TRACKING_______UPDATE',
  SalesAdminMotTrackingView = 'SALES_ADMIN_MOT_TRACKING_______VIEW',
  SalesAdminProgressMiscBillingView = 'SALES_ADMIN_PROGRESS_MISC_BILLING_______VIEW',
  SalesAdminProgressMiscBillingArchitectCertificatesApproval = 'SALES_ADMIN_PROGRESS_MISC_BILLING_ARCHITECT_CERTIFICATES____APPROVAL',
  SalesAdminProgressMiscBillingArchitectCertificatesCreate = 'SALES_ADMIN_PROGRESS_MISC_BILLING_ARCHITECT_CERTIFICATES____CREATE',
  SalesAdminProgressMiscBillingArchitectCertificatesReversal = 'SALES_ADMIN_PROGRESS_MISC_BILLING_ARCHITECT_CERTIFICATES____REVERSAL',
  SalesAdminProgressMiscBillingArchitectCertificatesUpdate = 'SALES_ADMIN_PROGRESS_MISC_BILLING_ARCHITECT_CERTIFICATES____UPDATE',
  SalesAdminProgressMiscBillingArchitectCertificatesView = 'SALES_ADMIN_PROGRESS_MISC_BILLING_ARCHITECT_CERTIFICATES____VIEW',
  SalesAdminProgressMiscBillingMiscBillingCreate = 'SALES_ADMIN_PROGRESS_MISC_BILLING_MISC_BILLING____CREATE',
  SalesAdminProgressMiscBillingMiscBillingPosting = 'SALES_ADMIN_PROGRESS_MISC_BILLING_MISC_BILLING____POSTING',
  SalesAdminProgressMiscBillingMiscBillingReversal = 'SALES_ADMIN_PROGRESS_MISC_BILLING_MISC_BILLING____REVERSAL',
  SalesAdminProgressMiscBillingMiscBillingView = 'SALES_ADMIN_PROGRESS_MISC_BILLING_MISC_BILLING____VIEW',
  SalesAdminProgressMiscBillingProgressBillingCreate = 'SALES_ADMIN_PROGRESS_MISC_BILLING_PROGRESS_BILLING____CREATE',
  SalesAdminProgressMiscBillingProgressBillingPosting = 'SALES_ADMIN_PROGRESS_MISC_BILLING_PROGRESS_BILLING____POSTING',
  SalesAdminProgressMiscBillingProgressBillingReversal = 'SALES_ADMIN_PROGRESS_MISC_BILLING_PROGRESS_BILLING____REVERSAL',
  SalesAdminProgressMiscBillingProgressBillingView = 'SALES_ADMIN_PROGRESS_MISC_BILLING_PROGRESS_BILLING____VIEW',
  SalesAdminProgressMiscBillingStandardMiscChargesSettingCreate = 'SALES_ADMIN_PROGRESS_MISC_BILLING_STANDARD_MISC_CHARGES_SETTING____CREATE',
  SalesAdminProgressMiscBillingStandardMiscChargesSettingDelete = 'SALES_ADMIN_PROGRESS_MISC_BILLING_STANDARD_MISC_CHARGES_SETTING____DELETE',
  SalesAdminProgressMiscBillingStandardMiscChargesSettingUpdate = 'SALES_ADMIN_PROGRESS_MISC_BILLING_STANDARD_MISC_CHARGES_SETTING____UPDATE',
  SalesAdminProgressMiscBillingStandardMiscChargesSettingView = 'SALES_ADMIN_PROGRESS_MISC_BILLING_STANDARD_MISC_CHARGES_SETTING____VIEW',
  SalesAdminPropertyTitleCreate = 'SALES_ADMIN_PROPERTY_TITLE_______CREATE',
  SalesAdminPropertyTitleDelete = 'SALES_ADMIN_PROPERTY_TITLE_______DELETE',
  SalesAdminPropertyTitleUpdate = 'SALES_ADMIN_PROPERTY_TITLE_______UPDATE',
  SalesAdminPropertyTitleView = 'SALES_ADMIN_PROPERTY_TITLE_______VIEW',
  SalesAdminPurchaserAccountsView = 'SALES_ADMIN_PURCHASER_ACCOUNTS_______VIEW',
  SalesAdminPurchaserAccountsCollectionAllocation = 'SALES_ADMIN_PURCHASER_ACCOUNTS_COLLECTION____ALLOCATION',
  SalesAdminPurchaserAccountsCollectionCreate = 'SALES_ADMIN_PURCHASER_ACCOUNTS_COLLECTION____CREATE',
  SalesAdminPurchaserAccountsCollectionUpdate = 'SALES_ADMIN_PURCHASER_ACCOUNTS_COLLECTION____UPDATE',
  SalesAdminPurchaserAccountsCollectionView = 'SALES_ADMIN_PURCHASER_ACCOUNTS_COLLECTION____VIEW',
  SalesAdminPurchaserAccountsCollectionActivityCreate = 'SALES_ADMIN_PURCHASER_ACCOUNTS_COLLECTION_ACTIVITY____CREATE',
  SalesAdminPurchaserAccountsCollectionActivityView = 'SALES_ADMIN_PURCHASER_ACCOUNTS_COLLECTION_ACTIVITY____VIEW',
  SalesAdminPurchaserAccountsContraAllocation = 'SALES_ADMIN_PURCHASER_ACCOUNTS_CONTRA____ALLOCATION',
  SalesAdminPurchaserAccountsContraCreate = 'SALES_ADMIN_PURCHASER_ACCOUNTS_CONTRA____CREATE',
  SalesAdminPurchaserAccountsContraUpdate = 'SALES_ADMIN_PURCHASER_ACCOUNTS_CONTRA____UPDATE',
  SalesAdminPurchaserAccountsContraView = 'SALES_ADMIN_PURCHASER_ACCOUNTS_CONTRA____VIEW',
  SalesAdminPurchaserAccountsCreditNoteAllocation = 'SALES_ADMIN_PURCHASER_ACCOUNTS_CREDIT_NOTE____ALLOCATION',
  SalesAdminPurchaserAccountsCreditNoteCreate = 'SALES_ADMIN_PURCHASER_ACCOUNTS_CREDIT_NOTE____CREATE',
  SalesAdminPurchaserAccountsCreditNoteUpdate = 'SALES_ADMIN_PURCHASER_ACCOUNTS_CREDIT_NOTE____UPDATE',
  SalesAdminPurchaserAccountsCreditNoteView = 'SALES_ADMIN_PURCHASER_ACCOUNTS_CREDIT_NOTE____VIEW',
  SalesAdminPurchaserAccountsDebitNoteCreate = 'SALES_ADMIN_PURCHASER_ACCOUNTS_DEBIT_NOTE____CREATE',
  SalesAdminPurchaserAccountsDebitNoteView = 'SALES_ADMIN_PURCHASER_ACCOUNTS_DEBIT_NOTE____VIEW',
  SalesAdminPurchaserAccountsDigitalDocumentsShare = 'SALES_ADMIN_PURCHASER_ACCOUNTS_DIGITAL_DOCUMENTS____SHARE',
  SalesAdminPurchaserAccountsDigitalDocumentsView = 'SALES_ADMIN_PURCHASER_ACCOUNTS_DIGITAL_DOCUMENTS____VIEW',
  SalesAdminPurchaserAccountsLateInterestChargesCreate = 'SALES_ADMIN_PURCHASER_ACCOUNTS_LATE_INTEREST_CHARGES____CREATE',
  SalesAdminPurchaserAccountsLateInterestChargesView = 'SALES_ADMIN_PURCHASER_ACCOUNTS_LATE_INTEREST_CHARGES____VIEW',
  SalesAdminPurchaserAccountsMiscBillingCreate = 'SALES_ADMIN_PURCHASER_ACCOUNTS_MISC_BILLING____CREATE',
  SalesAdminPurchaserAccountsMiscBillingView = 'SALES_ADMIN_PURCHASER_ACCOUNTS_MISC_BILLING____VIEW',
  SalesAdminPurchaserAccountsPaymentReminderView = 'SALES_ADMIN_PURCHASER_ACCOUNTS_PAYMENT_REMINDER____VIEW',
  SalesAdminPurchaserAccountsProgressBillingView = 'SALES_ADMIN_PURCHASER_ACCOUNTS_PROGRESS_BILLING____VIEW',
  SalesAdminPurchaserAccountsRebateAllocation = 'SALES_ADMIN_PURCHASER_ACCOUNTS_REBATE____ALLOCATION',
  SalesAdminPurchaserAccountsRebateCreate = 'SALES_ADMIN_PURCHASER_ACCOUNTS_REBATE____CREATE',
  SalesAdminPurchaserAccountsRebateUpdate = 'SALES_ADMIN_PURCHASER_ACCOUNTS_REBATE____UPDATE',
  SalesAdminPurchaserAccountsRebateView = 'SALES_ADMIN_PURCHASER_ACCOUNTS_REBATE____VIEW',
  SalesAdminPurchaserAccountsRefundCreate = 'SALES_ADMIN_PURCHASER_ACCOUNTS_REFUND____CREATE',
  SalesAdminPurchaserAccountsRefundView = 'SALES_ADMIN_PURCHASER_ACCOUNTS_REFUND____VIEW',
  SalesAdminPurchaserAccountsRefundVoid = 'SALES_ADMIN_PURCHASER_ACCOUNTS_REFUND____VOID',
  SalesAdminSalesCancellationApprove = 'SALES_ADMIN_SALES_CANCELLATION_______APPROVE',
  SalesAdminSalesCancellationCancel = 'SALES_ADMIN_SALES_CANCELLATION_______CANCEL',
  SalesAdminSalesCancellationCreate = 'SALES_ADMIN_SALES_CANCELLATION_______CREATE',
  SalesAdminSalesCancellationReject = 'SALES_ADMIN_SALES_CANCELLATION_______REJECT',
  SalesAdminSalesCancellationUpdate = 'SALES_ADMIN_SALES_CANCELLATION_______UPDATE',
  SalesAdminSalesCancellationView = 'SALES_ADMIN_SALES_CANCELLATION_______VIEW',
  SalesAdminSalesContractsCreate = 'SALES_ADMIN_SALES_CONTRACTS_______CREATE',
  SalesAdminSalesContractsView = 'SALES_ADMIN_SALES_CONTRACTS_______VIEW',
  SalesAdminSalesContractsAddOnPurchaseView = 'SALES_ADMIN_SALES_CONTRACTS_ADD_ON_PURCHASE____VIEW',
  SalesAdminSalesContractsContractPricingView = 'SALES_ADMIN_SALES_CONTRACTS_CONTRACT_PRICING____VIEW',
  SalesAdminSalesContractsOtherContactInfoCreate = 'SALES_ADMIN_SALES_CONTRACTS_OTHER_CONTACT_INFO____CREATE',
  SalesAdminSalesContractsOtherContactInfoView = 'SALES_ADMIN_SALES_CONTRACTS_OTHER_CONTACT_INFO____VIEW',
  SalesAdminSalesContractsOtherSalesInfoCreate = 'SALES_ADMIN_SALES_CONTRACTS_OTHER_SALES_INFO____CREATE',
  SalesAdminSalesContractsProgressBillingStatusView = 'SALES_ADMIN_SALES_CONTRACTS_PROGRESS_BILLING_STATUS____VIEW',
  SalesAdminSalesContractsPurchaserInfoCreate = 'SALES_ADMIN_SALES_CONTRACTS_PURCHASER_INFO____CREATE',
  SalesAdminSalesContractsPurchaserInfoDelete = 'SALES_ADMIN_SALES_CONTRACTS_PURCHASER_INFO____DELETE',
  SalesAdminSalesContractsPurchaserInfoUpdate = 'SALES_ADMIN_SALES_CONTRACTS_PURCHASER_INFO____UPDATE',
  SalesAdminSalesContractsPurchaserInfoView = 'SALES_ADMIN_SALES_CONTRACTS_PURCHASER_INFO____VIEW',
  SalesAdminSalesContractsSalesRebatePackageCreate = 'SALES_ADMIN_SALES_CONTRACTS_SALES_REBATE_PACKAGE____CREATE',
  SalesAdminSalesContractsSalesRebatePackageDelete = 'SALES_ADMIN_SALES_CONTRACTS_SALES_REBATE_PACKAGE____DELETE',
  SalesAdminSalesContractsSalesRebatePackageUpdate = 'SALES_ADMIN_SALES_CONTRACTS_SALES_REBATE_PACKAGE____UPDATE',
  SalesAdminSalesContractsSalesRebatePackageView = 'SALES_ADMIN_SALES_CONTRACTS_SALES_REBATE_PACKAGE____VIEW',
  SalesAdminSalesContractsSolicitorInfoCreate = 'SALES_ADMIN_SALES_CONTRACTS_SOLICITOR_INFO____CREATE',
  SalesAdminSalesContractsSpaSigningCreate = 'SALES_ADMIN_SALES_CONTRACTS_SPA_SIGNING____CREATE',
  SalesAdminSalesContractsSpaStampingCreate = 'SALES_ADMIN_SALES_CONTRACTS_SPA_STAMPING____CREATE',
  SalesAdminSpReminderCreate = 'SALES_ADMIN_SP_REMINDER_______CREATE',
  SalesAdminSpReminderShare = 'SALES_ADMIN_SP_REMINDER_______SHARE',
  SalesAdminSpReminderView = 'SALES_ADMIN_SP_REMINDER_______VIEW',
  SalesAdminStakeholderView = 'SALES_ADMIN_STAKEHOLDER_______VIEW',
  SalesAdminSubsaleComplete = 'SALES_ADMIN_SUBSALE_______COMPLETE',
  SalesAdminSubsaleCreate = 'SALES_ADMIN_SUBSALE_______CREATE',
  SalesAdminSubsaleDelete = 'SALES_ADMIN_SUBSALE_______DELETE',
  SalesAdminSubsaleReopen = 'SALES_ADMIN_SUBSALE_______REOPEN',
  SalesAdminSubsaleUpdate = 'SALES_ADMIN_SUBSALE_______UPDATE',
  SalesAdminSubsaleView = 'SALES_ADMIN_SUBSALE_______VIEW',
  SalesAdminVacantPossessionCreate = 'SALES_ADMIN_VACANT_POSSESSION_______CREATE',
  SalesAdminVacantPossessionShare = 'SALES_ADMIN_VACANT_POSSESSION_______SHARE',
  SalesAdminVacantPossessionView = 'SALES_ADMIN_VACANT_POSSESSION_______VIEW',
  SalesCrmView = 'SALES_CRM__________VIEW',
  SolicitorCreate = 'SOLICITOR__________CREATE',
  SolicitorUpdate = 'SOLICITOR__________UPDATE',
  SolicitorView = 'SOLICITOR__________VIEW',
  SystemAdminIcon = 'SYSTEM_ADMIN__________ICON',
  SystemAdminView = 'SYSTEM_ADMIN__________VIEW',
  SystemAdminRoleCreate = 'SYSTEM_ADMIN_ROLE_______CREATE',
  SystemAdminRoleDelete = 'SYSTEM_ADMIN_ROLE_______DELETE',
  SystemAdminRoleUpdate = 'SYSTEM_ADMIN_ROLE_______UPDATE',
  SystemAdminRoleView = 'SYSTEM_ADMIN_ROLE_______VIEW',
  SystemAdminRolePermissionAssignmentView = 'SYSTEM_ADMIN_ROLE_PERMISSION_ASSIGNMENT_______VIEW',
  SystemAdminUserActive = 'SYSTEM_ADMIN_USER_______ACTIVE',
  SystemAdminUserBlock = 'SYSTEM_ADMIN_USER_______BLOCK',
  SystemAdminUserChangePassword = 'SYSTEM_ADMIN_USER_______CHANGE_PASSWORD',
  SystemAdminUserCreate = 'SYSTEM_ADMIN_USER_______CREATE',
  SystemAdminUserDeactive = 'SYSTEM_ADMIN_USER_______DEACTIVE',
  SystemAdminUserResendInvitation = 'SYSTEM_ADMIN_USER_______RESEND_INVITATION',
  SystemAdminUserUnblock = 'SYSTEM_ADMIN_USER_______UNBLOCK',
  SystemAdminUserUpdate = 'SYSTEM_ADMIN_USER_______UPDATE',
  SystemAdminUserView = 'SYSTEM_ADMIN_USER_______VIEW',
  SystemAdminUserAccessLogView = 'SYSTEM_ADMIN_USER_ACCESS_LOG_______VIEW',
  SystemAdminUserSystemActivityLogView = 'SYSTEM_ADMIN_USER_SYSTEM_ACTIVITY_LOG_______VIEW'
}

export type SalesAgingDetails = {
  __typename?: 'SalesAgingDetails';
  alertAgingActivated?: Maybe<Scalars['Boolean']>;
  salesAlertAging?: Maybe<SalesAlertAginggOutput>;
};

export type SalesAlertAginggOutput = {
  __typename?: 'SalesAlertAginggOutput';
  isActive: Scalars['Boolean'];
  maxMajorSalesAlertAging: Scalars['Float'];
  maxMinorSalesAlertAging: Scalars['Float'];
};

export type SalesAlertAgingInput = {
  isActive: Scalars['Boolean'];
  maxMajorSalesAlertAging: Scalars['Float'];
  maxMinorSalesAlertAging: Scalars['Float'];
};

export type SalesAlertAgingOutput = {
  __typename?: 'SalesAlertAgingOutput';
  isActive: Scalars['Boolean'];
  maxMajorSalesAlertAging: Scalars['Float'];
  maxMinorSalesAlertAging: Scalars['Float'];
};

export type SalesAnalysisOutput = {
  __typename?: 'SalesAnalysisOutput';
  dailyBook: Array<DailyBookChartCountOutput>;
  dailySign: Array<DailySignChartCountOutput>;
  monthlyBook: Array<MonthlyBookChartCountOutput>;
  monthlySign: Array<MonthlySignChartCountOutput>;
  weeklyBook: Array<WeeklyBookChartCountOutput>;
  weeklySign: Array<WeeklySignChartCountOutput>;
};

export type SalesAttachmentOutput = {
  __typename?: 'SalesAttachmentOutput';
  DocumentDate?: Maybe<Scalars['DateTime']>;
  FileContent?: Maybe<Scalars['String']>;
  FileName?: Maybe<Scalars['String']>;
  FileSize?: Maybe<Scalars['Float']>;
  FileType?: Maybe<Scalars['String']>;
};

export type SalesCancellationEletterTemplateOutput = {
  __typename?: 'SalesCancellationEletterTemplateOutput';
  defaulted: Scalars['Boolean'];
  id: Scalars['String'];
  letterType: Scalars['String'];
  name: Scalars['String'];
};

export type SalesCancellationEntity = AuditEntity & {
  __typename?: 'salesCancellationEntity';
  accountId: Scalars['String'];
  approvalLevel?: Maybe<Scalars['Float']>;
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  notifiedDate: Scalars['DateTime'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  status: Scalars['String'];
};

export type SalesChartEntity = {
  __typename?: 'salesChartEntity';
  block: Scalars['String'];
  coordinates: Scalars['String'];
  floor: Scalars['Float'];
  id: Scalars['String'];
  project: ProjectEntity;
  resource: ResourceEntity;
  unit: UnitEntity;
};

export type SalesChartFloorOutput = {
  __typename?: 'SalesChartFloorOutput';
  floor: Scalars['Float'];
  floor_label?: Maybe<Scalars['String']>;
};

export type SalesChartFloorUnitOutput = {
  __typename?: 'SalesChartFloorUnitOutput';
  floors: Array<SalesChartFloorOutput>;
  units: Array<SalesChartUnitOutput>;
};

export type SalesChartUnitOutput = {
  __typename?: 'SalesChartUnitOutput';
  cell: Scalars['Float'];
  floor?: Maybe<Scalars['Float']>;
  floor_label?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['String']>;
  unit_id: Scalars['String'];
  unit_no: Scalars['String'];
  unit_status: Scalars['String'];
  unit_type?: Maybe<Scalars['String']>;
};

export type SalesContractDetailOutput = {
  __typename?: 'SalesContractDetailOutput';
  agencyName?: Maybe<Scalars['String']>;
  agencyUserName?: Maybe<Scalars['String']>;
  bookingRemark?: Maybe<Scalars['String']>;
  builtUp: Scalars['String'];
  buyerCompanyName?: Maybe<Scalars['String']>;
  buyerCompanyRegNo?: Maybe<Scalars['String']>;
  buyerEmail?: Maybe<Scalars['String']>;
  buyerId: Scalars['String'];
  buyerName: Scalars['String'];
  buyerNric: Scalars['String'];
  buyerPhoneNo?: Maybe<Scalars['String']>;
  cancelledByName?: Maybe<Scalars['String']>;
  extraLandArea?: Maybe<Scalars['Float']>;
  isBumi?: Maybe<Scalars['Boolean']>;
  isCompany?: Maybe<Scalars['Boolean']>;
  isPurchaserInfoComplete?: Maybe<Scalars['Boolean']>;
  joinBuyer: Array<JointBuyerEntity>;
  landArea?: Maybe<Scalars['String']>;
  leadSourceName?: Maybe<Scalars['String']>;
  listPrice: Scalars['String'];
  paidAmount?: Maybe<Scalars['Float']>;
  paymentMethod?: Maybe<Scalars['String']>;
  personName?: Maybe<Scalars['String']>;
  projectId: Scalars['String'];
  referralContactNo?: Maybe<Scalars['String']>;
  referralName?: Maybe<Scalars['String']>;
  referralReferenceNo?: Maybe<Scalars['String']>;
  salePaymentId?: Maybe<Scalars['String']>;
  salesId: Scalars['String'];
  salesNo: Scalars['String'];
  salesStatus: Scalars['String'];
  sellingPrice: Scalars['Float'];
  teamName?: Maybe<Scalars['String']>;
  unitId: Scalars['String'];
  unitLayout?: Maybe<Scalars['String']>;
  unitLayoutDes?: Maybe<Scalars['String']>;
  unitNo?: Maybe<Scalars['String']>;
};

export type SalesContractListingOutput = {
  __typename?: 'SalesContractListingOutput';
  bookDate?: Maybe<Scalars['DateTime']>;
  bookPaidAmount?: Maybe<Scalars['Float']>;
  buyerCompanyName?: Maybe<Scalars['String']>;
  buyerId: Scalars['String'];
  buyerName: Scalars['String'];
  expectedSnpDate?: Maybe<Scalars['DateTime']>;
  fullName?: Maybe<Scalars['String']>;
  isBumi?: Maybe<Scalars['Boolean']>;
  isCompany?: Maybe<Scalars['Boolean']>;
  isPurchaserInfoComplete?: Maybe<Scalars['Boolean']>;
  joinBuyerCount?: Maybe<Scalars['Float']>;
  paymentPlan?: Maybe<Scalars['String']>;
  projectId: Scalars['String'];
  saleDate: Scalars['DateTime'];
  salesConvertedStatus: Scalars['String'];
  salesExtId: Scalars['String'];
  salesId: Scalars['String'];
  salesNo: Scalars['String'];
  salesStatus: Scalars['String'];
  sellingPrice: Scalars['Float'];
  spaDate?: Maybe<Scalars['DateTime']>;
  unitId: Scalars['String'];
  unitNo?: Maybe<Scalars['String']>;
};

export type SalesContractMutationOutput = {
  __typename?: 'salesContractMutationOutput';
  isGenerated: Scalars['Boolean'];
  isSuccessful: Scalars['Boolean'];
};

export type SalesContractSharedOutput = {
  __typename?: 'SalesContractSharedOutput';
  buyerCompanyName?: Maybe<Scalars['String']>;
  buyerId: Scalars['String'];
  buyerName: Scalars['String'];
  isBumi?: Maybe<Scalars['Boolean']>;
  isCompany?: Maybe<Scalars['Boolean']>;
  isPurchaserInfoComplete?: Maybe<Scalars['Boolean']>;
  projectId: Scalars['String'];
  salesId: Scalars['String'];
  salesStatus: Scalars['String'];
  sellingPrice: Scalars['Float'];
  unitId: Scalars['String'];
  unitNo?: Maybe<Scalars['String']>;
};

export type SalesDiscountDetailOutput = {
  __typename?: 'salesDiscountDetailOutput';
  amount: Scalars['Float'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  method?: Maybe<Scalars['String']>;
  prefix?: Maybe<Scalars['String']>;
  seqNo: Scalars['Float'];
  title?: Maybe<Scalars['String']>;
};

export type SalesDiscountExtEntity = AuditEntity & {
  __typename?: 'salesDiscountExtEntity';
  accountId: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  discountMethod: Scalars['String'];
  formula: Scalars['String'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  saleDiscount: SaleDiscountEntity;
  saleDiscountId: Scalars['String'];
};

export type SalesDiscountListingOutput = {
  __typename?: 'salesDiscountListingOutput';
  amount: Scalars['Float'];
  description?: Maybe<Scalars['String']>;
  discountId: Scalars['String'];
  id: Scalars['String'];
  title?: Maybe<Scalars['String']>;
};

export type SalesDocEntity = AuditEntity & {
  __typename?: 'salesDocEntity';
  accountId: Scalars['String'];
  allowAgency: Scalars['Boolean'];
  allowSalesTeam: Scalars['Boolean'];
  attachment: AttachmentEntity;
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  docName: Scalars['String'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  projectId: Scalars['String'];
  type: Scalars['String'];
  typeDescription: Scalars['String'];
};

export type SalesDownloadAttachmentInput = {
  attachmentName: Scalars['String'];
  attachmentUrl: Scalars['String'];
};

export type SalesELetterOutput = {
  __typename?: 'SalesELetterOutput';
  content?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
};

export type SalesGalleryCloseDateEntity = {
  __typename?: 'salesGalleryCloseDateEntity';
  accountId: Scalars['String'];
  appointmentScheduling: AppointmentSchedulingEntity;
  appointmentSchedulingId: Scalars['String'];
  endDate: Scalars['DateTime'];
  endTime: Scalars['String'];
  id: Scalars['String'];
  projectId: Scalars['String'];
  startDate: Scalars['DateTime'];
  startTime: Scalars['String'];
};

export type SaleSignInformationOutput = {
  __typename?: 'SaleSignInformationOutput';
  DevSolicitor?: Maybe<DevBuyerSolicitorOutput>;
  FinancierDetails?: Maybe<Array<FinancierDetailsOutput>>;
};

export type SalesLandDepositEntity = {
  __typename?: 'salesLandDepositEntity';
  accountId: Scalars['String'];
  attachments?: Maybe<Array<AttachmentEntity>>;
  depositBillingAmount: Scalars['Float'];
  depositTypeId: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['String'];
  project: ProjectEntity;
  projectId: Scalars['String'];
  recordStatus: Scalars['String'];
  sale: SaleEntity;
  saleId: Scalars['String'];
};

export type SalesLandDepositOutput = {
  __typename?: 'SalesLandDepositOutput';
  paidCounter: Scalars['Float'];
  projectId: Scalars['String'];
  purchaserName: Scalars['String'];
  saleDate: Scalars['DateTime'];
  saleId: Scalars['String'];
  saleNo: Scalars['String'];
  salePrice: Scalars['Float'];
  sellingPrice: Scalars['Float'];
  ujpBillingAmt: Scalars['Float'];
  ujpCurrentOutstanding: Scalars['Float'];
  ujpPaidAmt: Scalars['Float'];
  ujppBillingAmt: Scalars['Float'];
  ujppCurrentOutstanding: Scalars['Float'];
  ujppPaidAmt: Scalars['Float'];
  ujppTotalAmt: Scalars['Float'];
  ujpTotalAmt: Scalars['Float'];
  unitClusterId: Scalars['String'];
  unitId: Scalars['String'];
  unitLandArea?: Maybe<Scalars['Float']>;
  unitNo: Scalars['String'];
};

export type SalesLeadOutput = {
  __typename?: 'SalesLeadOutput';
  coldTotal?: Maybe<Scalars['Float']>;
  data?: Maybe<Array<LeadDataOutput>>;
  dropTotal?: Maybe<Scalars['Float']>;
  hotTotal?: Maybe<Scalars['Float']>;
  openTotal?: Maybe<Scalars['Float']>;
  reservedTotal?: Maybe<Scalars['Float']>;
  salesAgingDetails?: Maybe<SalesAgingDetails>;
  showSaleStaff?: Maybe<Scalars['Boolean']>;
  signTotal?: Maybe<Scalars['Float']>;
  soldTotal?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  waitingListTotal?: Maybe<Scalars['Float']>;
  warmTotal?: Maybe<Scalars['Float']>;
};

export type SalesLoanBuyBackEntity = {
  __typename?: 'salesLoanBuyBackEntity';
  accountId: Scalars['String'];
  approvalStatus: Scalars['String'];
  approvedBy: Scalars['String'];
  approvedDate: Scalars['DateTime'];
  bankAccountId: Scalars['String'];
  buyBackAmt: Scalars['Float'];
  buyBackDate: Scalars['DateTime'];
  commonStatus: Scalars['String'];
  docNo?: Maybe<Scalars['String']>;
  financierId: Scalars['String'];
  id: Scalars['String'];
  oldBalance: Array<OldBalanceBuyBack>;
  projectId: Scalars['String'];
  refRecordId: Scalars['String'];
  refTable: Scalars['String'];
  remarks?: Maybe<Scalars['String']>;
  saleId: Scalars['String'];
  submittedBy: Scalars['String'];
  submittedDate: Scalars['DateTime'];
};

export type SalesLoanRefinancingEntity = {
  __typename?: 'salesLoanRefinancingEntity';
  accountId: Scalars['String'];
  approvalStatus: Scalars['String'];
  approvedBy: Scalars['String'];
  approvedDate: Scalars['DateTime'];
  borrowerAcct: Scalars['String'];
  borrowerName: Scalars['String'];
  commonStatus: Scalars['String'];
  endfinancierMortgageId: Scalars['String'];
  endfinMortgagePaymentplanId: Scalars['String'];
  endfinMortgageRetentionId: Scalars['String'];
  id: Scalars['String'];
  isRefinanced: Scalars['Boolean'];
  loanRefRecordId: Scalars['String'];
  loanRefTable: Scalars['String'];
  newFinancierId: Scalars['String'];
  newPaymentPlan: Array<NewPaymentPlan>;
  oldBalance: Array<OldBalance>;
  projectId: Scalars['String'];
  refinancingDate: Scalars['DateTime'];
  refinancingNo?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
  saleId: Scalars['String'];
  saleLoanRefinancingPaymentPlan: SaleLoanRefinancingPaymentPlanEntity;
  saleLoanRefinancingRetention: SaleLoanRefinancingRetentionEntity;
  submittedBy: Scalars['String'];
  submittedDate: Scalars['DateTime'];
};

export type SalesOfficeInfo = {
  areaUOM1?: InputMaybe<Scalars['String']>;
  areaUOM2?: InputMaybe<Scalars['String']>;
  areaUOM3?: InputMaybe<Scalars['String']>;
  areaUOMConversion1?: InputMaybe<Scalars['String']>;
  areaUOMConversion2?: InputMaybe<Scalars['String']>;
  creditControlEmail?: InputMaybe<Scalars['String']>;
  creditControlHOD?: InputMaybe<Scalars['String']>;
  creditControlOfficeTel?: InputMaybe<Scalars['String']>;
  customerCareContactNo?: InputMaybe<Scalars['String']>;
  customerCareEmail?: InputMaybe<Scalars['String']>;
  customerCareHOD?: InputMaybe<Scalars['String']>;
  generalManager?: InputMaybe<Scalars['String']>;
  projectManager?: InputMaybe<Scalars['String']>;
  propertyManager?: InputMaybe<Scalars['String']>;
  salesMarketingHOD?: InputMaybe<Scalars['String']>;
  salesOfficeAddress?: InputMaybe<Scalars['String']>;
  salesOfficeFax?: InputMaybe<Scalars['String']>;
  salesOfficeTel?: InputMaybe<Scalars['String']>;
};

export type SalesOfficeInput = {
  BuildingContractorInfo?: InputMaybe<BuildingContractInfo>;
  CustomerCareLocalAuth?: InputMaybe<CustomerCareLocalInfo>;
  projectId?: InputMaybe<Scalars['String']>;
  PropertySalesLocalAuth?: InputMaybe<PropertySalesInfo>;
  SalesOfficeInfo?: InputMaybe<SalesOfficeInfo>;
};

export type SalesPaymentPlanEntity = {
  __typename?: 'salesPaymentPlanEntity';
  accountId: Scalars['String'];
  billAfter: BillAfter;
  billCount: Scalars['Float'];
  billFrequency: BillFrequency;
  billType: BillType;
  deductBookingFee: DeductBookingFee;
  id: Scalars['String'];
  installment: Array<InstallmentEntity>;
  isFixAmt: Scalars['Boolean'];
  noInstallment: Scalars['Float'];
  paymentAmt: Scalars['Float'];
  projectPaymentPlanId: Scalars['String'];
  purchaserPaymentPlanDetails: PurchaserPaymentPlanDetailsEntity;
  purchaserPaymentPlanDetailsId: Scalars['String'];
  saleId: Scalars['String'];
  value: Scalars['Float'];
};

export enum SalesPermission {
  AdminRead = 'ADMIN__READ',
  AdminProjectCarParkSetupRead = 'ADMIN_PROJECT_CAR_PARK_SETUP_READ',
  AdminProjectDiscountRead = 'ADMIN_PROJECT_DISCOUNT_READ',
  AdminProjectEmailLetterRead = 'ADMIN_PROJECT_EMAIL_LETTER_READ',
  AdminProjectGalleryRead = 'ADMIN_PROJECT_GALLERY_READ',
  AdminProjectLayoutImagesRead = 'ADMIN_PROJECT_LAYOUT_IMAGES_READ',
  AdminProjectPanelEndFinancierRead = 'ADMIN_PROJECT_PANEL_END_FINANCIER_READ',
  AdminProjectPanelSolicitorRead = 'ADMIN_PROJECT_PANEL_SOLICITOR_READ',
  AdminProjectPolicySettingRead = 'ADMIN_PROJECT_POLICY_SETTING_READ',
  AdminProjectProjectDetailsRead = 'ADMIN_PROJECT_PROJECT_DETAILS_READ',
  AdminProjectRoleAuthorizationRead = 'ADMIN_PROJECT_ROLE_AUTHORIZATION_READ',
  AdminProjectSalesChartSetupRead = 'ADMIN_PROJECT_SALES_CHART_SETUP_READ',
  AdminProjectSalesDocumentsRead = 'ADMIN_PROJECT_SALES_DOCUMENTS_READ',
  AdminProjectSalesPackagesRead = 'ADMIN_PROJECT_SALES_PACKAGES_READ',
  AdminProjectSiteProgressRead = 'ADMIN_PROJECT_SITE_PROGRESS_READ',
  AdminProjectStandardLetterRead = 'ADMIN_PROJECT_STANDARD_LETTER_READ',
  AdminProjectTeamAssignmentRead = 'ADMIN_PROJECT_TEAM_ASSIGNMENT_READ',
  AdminProjectUnitAllocationRead = 'ADMIN_PROJECT_UNIT_ALLOCATION_READ',
  AdminProjectUnitSetupRead = 'ADMIN_PROJECT_UNIT_SETUP_READ',
  ProjectReadAll = 'PROJECT_______READ_ALL',
  ProjectReadInternalAndAgencyTeam = 'PROJECT_______READ_INTERNAL_AND_AGENCY_TEAM',
  ProjectReadSelf = 'PROJECT_______READ_SELF',
  ProjectReadTeam = 'PROJECT_______READ_TEAM',
  ProjectAppointedAgencyRead = 'PROJECT_APPOINTED_AGENCY____READ',
  ProjectBookingListAllowBook = 'PROJECT_BOOKING_LIST____ALLOW_BOOK',
  ProjectBookingListCancel = 'PROJECT_BOOKING_LIST____CANCEL',
  ProjectBookingListEditDiscount = 'PROJECT_BOOKING_LIST____EDIT_DISCOUNT',
  ProjectBookingListEditPurchaserAndJointBuyer = 'PROJECT_BOOKING_LIST____EDIT_PURCHASER_AND_JOINT_BUYER',
  ProjectBookingListEditPurchaserAndJointBuyerCompanyRegNo = 'PROJECT_BOOKING_LIST____EDIT_PURCHASER_AND_JOINT_BUYER_COMPANY_REG_NO',
  ProjectBookingListEditPurchaserAndJointBuyerIdType = 'PROJECT_BOOKING_LIST____EDIT_PURCHASER_AND_JOINT_BUYER_ID_TYPE',
  ProjectBookingListEditPurchaserAndJointBuyerNameAndIc = 'PROJECT_BOOKING_LIST____EDIT_PURCHASER_AND_JOINT_BUYER_NAME_AND_IC',
  ProjectBookingListEditPurchaserAndJointBuyerNationality = 'PROJECT_BOOKING_LIST____EDIT_PURCHASER_AND_JOINT_BUYER_NATIONALITY',
  ProjectBookingListEditPurchaserAndJointBuyerSequence = 'PROJECT_BOOKING_LIST____EDIT_PURCHASER_AND_JOINT_BUYER_SEQUENCE',
  ProjectBookingListEditPurchaserAndJointBuyerTinNoAndSstRegNo = 'PROJECT_BOOKING_LIST____EDIT_PURCHASER_AND_JOINT_BUYER_TIN_NO_AND_SST_REG_NO',
  ProjectBookingListEditSalesPackages = 'PROJECT_BOOKING_LIST____EDIT_SALES_PACKAGES',
  ProjectBookingListEditSalesRebates = 'PROJECT_BOOKING_LIST____EDIT_SALES_REBATES',
  ProjectBookingListEditSalesTeamAndSalesPersonnel = 'PROJECT_BOOKING_LIST____EDIT_SALES_TEAM_AND_SALES_PERSONNEL',
  ProjectBookingListOnline = 'PROJECT_BOOKING_LIST____ONLINE',
  ProjectBookingListRead = 'PROJECT_BOOKING_LIST____READ',
  ProjectBusinessActiveSalesPerformanceRead = 'PROJECT_BUSINESS_ACTIVE_SALES_PERFORMANCE_READ',
  ProjectBusinessInsightsRead = 'PROJECT_BUSINESS_INSIGHTS____READ',
  ProjectBusinessInsightsBookingListAnalysisRead = 'PROJECT_BUSINESS_INSIGHTS_BOOKING_LIST_ANALYSIS_READ',
  ProjectBusinessInsightsBookingListRead = 'PROJECT_BUSINESS_INSIGHTS_BOOKING_LIST_READ',
  ProjectBusinessInsightsCampaignPerformanceRead = 'PROJECT_BUSINESS_INSIGHTS_CAMPAIGN_PERFORMANCE_READ',
  ProjectBusinessInsightsELaunchBookingTimeTakenRead = 'PROJECT_BUSINESS_INSIGHTS_E_LAUNCH_BOOKING_TIME_TAKEN_READ',
  ProjectBusinessInsightsELaunchMostFavouriteRead = 'PROJECT_BUSINESS_INSIGHTS_E_LAUNCH_MOST_FAVOURITE_READ',
  ProjectBusinessInsightsELaunchPerformanceRead = 'PROJECT_BUSINESS_INSIGHTS_E_LAUNCH_PERFORMANCE_READ',
  ProjectBusinessInsightsELaunchPurchaserDemographicRead = 'PROJECT_BUSINESS_INSIGHTS_E_LAUNCH_PURCHASER_DEMOGRAPHIC_READ',
  ProjectBusinessInsightsLeadDemographicRead = 'PROJECT_BUSINESS_INSIGHTS_LEAD_DEMOGRAPHIC_READ',
  ProjectBusinessInsightsLeadSourceRead = 'PROJECT_BUSINESS_INSIGHTS_LEAD_SOURCE_READ',
  ProjectBusinessInsightsLoanRead = 'PROJECT_BUSINESS_INSIGHTS_LOAN_READ',
  ProjectBusinessInsightsPaymentSourceRead = 'PROJECT_BUSINESS_INSIGHTS_PAYMENT_SOURCE_READ',
  ProjectBusinessInsightsPurchaserDemographicRead = 'PROJECT_BUSINESS_INSIGHTS_PURCHASER_DEMOGRAPHIC_READ',
  ProjectBusinessInsightsSalesLeadPerformanceRead = 'PROJECT_BUSINESS_INSIGHTS_SALES_LEAD_PERFORMANCE_READ',
  ProjectBusinessInsightsSalesLeadTeamPerformanceRead = 'PROJECT_BUSINESS_INSIGHTS_SALES_LEAD_TEAM_PERFORMANCE_READ',
  ProjectBusinessInsightsSalesMovementRead = 'PROJECT_BUSINESS_INSIGHTS_SALES_MOVEMENT_READ',
  ProjectBusinessInsightsSalesPerformanceRead = 'PROJECT_BUSINESS_INSIGHTS_SALES_PERFORMANCE_READ',
  ProjectBusinessInsightsSalesTeamPerformanceRead = 'PROJECT_BUSINESS_INSIGHTS_SALES_TEAM_PERFORMANCE_READ',
  ProjectBusinessInsightsWaitingListRead = 'PROJECT_BUSINESS_INSIGHTS_WAITING_LIST_READ',
  ProjectDigitalDocumentsPurchaserBooking = 'PROJECT_DIGITAL_DOCUMENTS_PURCHASER_BOOKING',
  ProjectDigitalDocumentsPurchaserBookingCreate = 'PROJECT_DIGITAL_DOCUMENTS_PURCHASER_BOOKING_CREATE',
  ProjectDigitalDocumentsPurchaserBookingDelete = 'PROJECT_DIGITAL_DOCUMENTS_PURCHASER_BOOKING_DELETE',
  ProjectDigitalDocumentsPurchaserLoan = 'PROJECT_DIGITAL_DOCUMENTS_PURCHASER_LOAN',
  ProjectDigitalDocumentsPurchaserLoanCreate = 'PROJECT_DIGITAL_DOCUMENTS_PURCHASER_LOAN_CREATE',
  ProjectDigitalDocumentsPurchaserLoanDelete = 'PROJECT_DIGITAL_DOCUMENTS_PURCHASER_LOAN_DELETE',
  ProjectDigitalDocumentsPurchaserSales = 'PROJECT_DIGITAL_DOCUMENTS_PURCHASER_SALES',
  ProjectDigitalDocumentsPurchaserSalesCreate = 'PROJECT_DIGITAL_DOCUMENTS_PURCHASER_SALES_CREATE',
  ProjectDigitalDocumentsPurchaserSalesDelete = 'PROJECT_DIGITAL_DOCUMENTS_PURCHASER_SALES_DELETE',
  ProjectLoanRead = 'PROJECT_LOAN____READ',
  ProjectNotificationBookingListAllowBook = 'PROJECT_NOTIFICATION_BOOKING_LIST_ALLOW_BOOK',
  ProjectNotificationBookingListBookingFee = 'PROJECT_NOTIFICATION_BOOKING_LIST_BOOKING_FEE',
  ProjectNotificationBookingListCancel = 'PROJECT_NOTIFICATION_BOOKING_LIST_CANCEL',
  ProjectNotificationBookingListSpaCollected = 'PROJECT_NOTIFICATION_BOOKING_LIST_SPA_COLLECTED',
  ProjectNotificationBookingListSpaReminder = 'PROJECT_NOTIFICATION_BOOKING_LIST_SPA_REMINDER',
  ProjectNotificationBookingListSpaSign = 'PROJECT_NOTIFICATION_BOOKING_LIST_SPA_SIGN',
  ProjectNotificationBookingListSpaStamped = 'PROJECT_NOTIFICATION_BOOKING_LIST_SPA_STAMPED',
  ProjectNotificationCollaborativeAgecny = 'PROJECT_NOTIFICATION_COLLABORATIVE_AGECNY',
  ProjectNotificationCollaborativeEndFinancier = 'PROJECT_NOTIFICATION_COLLABORATIVE_END_FINANCIER',
  ProjectNotificationCollaborativeSolicitor = 'PROJECT_NOTIFICATION_COLLABORATIVE_SOLICITOR',
  ProjectNotificationLoanAccepted = 'PROJECT_NOTIFICATION_LOAN_ACCEPTED',
  ProjectNotificationLoanAmountUpdate = 'PROJECT_NOTIFICATION_LOAN_AMOUNT_UPDATE',
  ProjectNotificationLoanAssign = 'PROJECT_NOTIFICATION_LOAN_ASSIGN',
  ProjectNotificationLoanIssued = 'PROJECT_NOTIFICATION_LOAN_ISSUED',
  ProjectNotificationLoanWithdrawal = 'PROJECT_NOTIFICATION_LOAN_WITHDRAWAL',
  ProjectNotificationSalesLeadAging = 'PROJECT_NOTIFICATION_SALES_LEAD_AGING',
  ProjectNotificationSalesLeadAssign = 'PROJECT_NOTIFICATION_SALES_LEAD_ASSIGN',
  ProjectNotificationSalesLeadAssignProejct = 'PROJECT_NOTIFICATION_SALES_LEAD_ASSIGN_PROEJCT',
  ProjectNotificationSalesLeadDrop = 'PROJECT_NOTIFICATION_SALES_LEAD_DROP',
  ProjectNotificationSalesLeadReassign = 'PROJECT_NOTIFICATION_SALES_LEAD_REASSIGN',
  ProjectNotificationSalesLeadUnattended = 'PROJECT_NOTIFICATION_SALES_LEAD_UNATTENDED',
  ProjectNotificationWaitingListAvailable = 'PROJECT_NOTIFICATION_WAITING_LIST_AVAILABLE',
  ProjectNotificationWaitingListLeadJoint = 'PROJECT_NOTIFICATION_WAITING_LIST_LEAD_JOINT',
  ProjectNotificationWaitingListLeadLeaveQueue = 'PROJECT_NOTIFICATION_WAITING_LIST_LEAD_LEAVE_QUEUE',
  ProjectNotificationWaitingListMoveToTop = 'PROJECT_NOTIFICATION_WAITING_LIST_MOVE_TO_TOP',
  ProjectNotificationWaitingListUnavailable = 'PROJECT_NOTIFICATION_WAITING_LIST_UNAVAILABLE',
  ProjectSalesLeadAssign = 'PROJECT_SALES_LEAD____ASSIGN',
  ProjectSalesLeadRead = 'PROJECT_SALES_LEAD____READ',
  ProjectSolicitorAssignmentRead = 'PROJECT_SOLICITOR_ASSIGNMENT____READ',
  ProjectSolicitorAssignmentReassignment = 'PROJECT_SOLICITOR_ASSIGNMENT_REASSIGNMENT',
  ProjectSolicitorSpaSign = 'PROJECT_SOLICITOR_SPA_SIGN',
  ProjectWaitingListLeaveQueue = 'PROJECT_WAITING_LIST____LEAVE_QUEUE',
  ProjectWaitingListMoveToTop = 'PROJECT_WAITING_LIST____MOVE_TO_TOP',
  ProjectWaitingListRead = 'PROJECT_WAITING_LIST____READ',
  WorkdeskProjectWorkdeskAppointmentAppointmentAdd = 'WORKDESK_PROJECT_WORKDESK_APPOINTMENT_APPOINTMENT_ADD'
}

export type SalesPersonSalesAvgOutput = {
  __typename?: 'SalesPersonSalesAvgOutput';
  bookCount?: Maybe<Scalars['Float']>;
  cancelCount?: Maybe<Scalars['Float']>;
  reserveCount?: Maybe<Scalars['Float']>;
  salesPersonName?: Maybe<Scalars['String']>;
  signedCount?: Maybe<Scalars['Float']>;
  sumBookAmt?: Maybe<Scalars['Float']>;
  sumCancelAmt?: Maybe<Scalars['Float']>;
  sumReserveAmt?: Maybe<Scalars['Float']>;
  sumSpaPrice?: Maybe<Scalars['Float']>;
};

export type SalesRegistrationCountOutput = {
  __typename?: 'salesRegistrationCountOutput';
  approvedCount?: Maybe<Scalars['Float']>;
  draftCount?: Maybe<Scalars['Float']>;
  rejectedCount?: Maybe<Scalars['Float']>;
  submittedCount?: Maybe<Scalars['Float']>;
};

export type SalesRegistrationDetailOutput = {
  __typename?: 'SalesRegistrationDetailOutput';
  agencyName?: Maybe<Scalars['String']>;
  agencyUserName?: Maybe<Scalars['String']>;
  bookingRemark?: Maybe<Scalars['String']>;
  builtUp: Scalars['String'];
  buyerCompanyName?: Maybe<Scalars['String']>;
  buyerCompanyRegNo?: Maybe<Scalars['String']>;
  buyerEmail?: Maybe<Scalars['String']>;
  buyerId: Scalars['String'];
  buyerName: Scalars['String'];
  buyerNric: Scalars['String'];
  buyerPhoneNo?: Maybe<Scalars['String']>;
  cancelledByName?: Maybe<Scalars['String']>;
  extraLandArea?: Maybe<Scalars['Float']>;
  isBumi?: Maybe<Scalars['Boolean']>;
  isCompany?: Maybe<Scalars['Boolean']>;
  isPurchaserInfoComplete?: Maybe<Scalars['Boolean']>;
  landArea?: Maybe<Scalars['String']>;
  leadSourceName?: Maybe<Scalars['String']>;
  listPrice: Scalars['String'];
  paidAmount?: Maybe<Scalars['Float']>;
  paymentMethod?: Maybe<Scalars['String']>;
  personName?: Maybe<Scalars['String']>;
  projectId: Scalars['String'];
  referralContactNo?: Maybe<Scalars['String']>;
  referralName?: Maybe<Scalars['String']>;
  referralReferenceNo?: Maybe<Scalars['String']>;
  salePaymentId?: Maybe<Scalars['String']>;
  salesId: Scalars['String'];
  salesNo: Scalars['String'];
  salesStatus: Scalars['String'];
  sellingPrice: Scalars['Float'];
  teamName?: Maybe<Scalars['String']>;
  unitId: Scalars['String'];
  unitLayout?: Maybe<Scalars['String']>;
  unitLayoutDes?: Maybe<Scalars['String']>;
  unitNo?: Maybe<Scalars['String']>;
};

export type SalesRegistrationELetterOutput = {
  __typename?: 'salesRegistrationELetterOutput';
  content: Scalars['String'];
  fileName: Scalars['String'];
};

export type SalesRegistrationEletterTemplateOutput = {
  __typename?: 'SalesRegistrationEletterTemplateOutput';
  defaulted: Scalars['Boolean'];
  id: Scalars['String'];
  letterType: Scalars['String'];
  name: Scalars['String'];
};

export type SalesRegistrationInput = {
  campaignId?: InputMaybe<Scalars['String']>;
  correspondenceAddress?: InputMaybe<AddressJsonInput>;
  creditTerms?: InputMaybe<Scalars['Float']>;
  discountAmount?: InputMaybe<Scalars['Float']>;
  discounts?: InputMaybe<Array<AddSalesRegistrationDiscountInput>>;
  eventId?: InputMaybe<Scalars['String']>;
  finalContractPrice?: InputMaybe<Scalars['Float']>;
  gracePeriod?: InputMaybe<Scalars['Float']>;
  leadChannelId?: InputMaybe<Scalars['String']>;
  paymentPlan: SalePaymentPlanInput;
  paymentPlanMarkUpAmt?: InputMaybe<Scalars['Float']>;
  projectId: Scalars['String'];
  registerDate: Scalars['DateTime'];
  saleCommissionTeam: Array<SaleCommissionTeamInput>;
  saleId: Scalars['String'];
  salesPersonId: Scalars['String'];
  salesTeamId: Scalars['String'];
  salesType: Scalars['String'];
  saveType: Scalars['String'];
  sellingPrice?: InputMaybe<Scalars['Float']>;
  taxAmt?: InputMaybe<Scalars['Float']>;
  taxRate?: InputMaybe<Scalars['Float']>;
  taxSchemeId?: InputMaybe<Scalars['String']>;
};

export type SalesRegistrationListingOutput = {
  __typename?: 'SalesRegistrationListingOutput';
  bookDate?: Maybe<Scalars['DateTime']>;
  buyerCompanyName?: Maybe<Scalars['String']>;
  buyerId: Scalars['String'];
  buyerName: Scalars['String'];
  expectedSnpDate?: Maybe<Scalars['DateTime']>;
  fullName?: Maybe<Scalars['String']>;
  isBumi?: Maybe<Scalars['Boolean']>;
  isCompany?: Maybe<Scalars['Boolean']>;
  isPurchaserInfoComplete?: Maybe<Scalars['Boolean']>;
  joinBuyerCount?: Maybe<Scalars['Float']>;
  paymentPlan?: Maybe<Scalars['String']>;
  projectId: Scalars['String'];
  saleDate: Scalars['DateTime'];
  salesConvertedStatus: Scalars['String'];
  salesExtId: Scalars['String'];
  salesId: Scalars['String'];
  salesNo: Scalars['String'];
  salesStatus: Scalars['String'];
  sellingPrice: Scalars['Float'];
  unitId: Scalars['String'];
  unitNo?: Maybe<Scalars['String']>;
};

export type SalesRegistrationOutput = {
  __typename?: 'salesRegistrationOutput';
  bookingDate: Scalars['DateTime'];
  builtUp: Scalars['String'];
  carPark?: Maybe<Array<CarParkIndOutput>>;
  discounts?: Maybe<Array<DiscountInfo>>;
  isBumi?: Maybe<Scalars['Boolean']>;
  isCompany?: Maybe<Scalars['Boolean']>;
  jointBuyers?: Maybe<Array<BuyerRegistrationOutput>>;
  listingPrice: Scalars['Float'];
  mainBuyerName: Scalars['String'];
  packages?: Maybe<Array<PackageInfo>>;
  saleId: Scalars['String'];
  salesNo: Scalars['String'];
  sellingPrice: Scalars['Float'];
  taxScheme?: Maybe<Scalars['String']>;
  unitNo?: Maybe<Scalars['String']>;
};

export type SalesRegistrationSharedOutput = {
  __typename?: 'SalesRegistrationSharedOutput';
  buyerCompanyName?: Maybe<Scalars['String']>;
  buyerId: Scalars['String'];
  buyerName: Scalars['String'];
  isBumi?: Maybe<Scalars['Boolean']>;
  isCompany?: Maybe<Scalars['Boolean']>;
  isPurchaserInfoComplete?: Maybe<Scalars['Boolean']>;
  projectId: Scalars['String'];
  salesId: Scalars['String'];
  salesStatus: Scalars['String'];
  sellingPrice: Scalars['Float'];
  unitId: Scalars['String'];
  unitNo?: Maybe<Scalars['String']>;
};

export type SalesSoaDetetails = {
  __typename?: 'SalesSOADetetails';
  DocumentAmt: Scalars['Float'];
  DocumentDate: Scalars['DateTime'];
  DocumentDesc?: Maybe<Scalars['String']>;
  DocumentNo: Scalars['String'];
  DueDate?: Maybe<Scalars['DateTime']>;
  SeqNo?: Maybe<Scalars['Float']>;
  TrxType: Scalars['String'];
};

export type SalesSoaSummaryOutput = {
  __typename?: 'SalesSOASummaryOutput';
  GateWayId?: Maybe<Scalars['String']>;
  GateWayType?: Maybe<Scalars['String']>;
  ListOfTrx?: Maybe<Array<SalesSoaDetetails>>;
  TotalOutStanding?: Maybe<Scalars['Float']>;
  UnitId: Scalars['String'];
  UnitNo: Scalars['String'];
};

export type SalesStatisticChartData = {
  __typename?: 'SalesStatisticChartData';
  bookedData: Array<Scalars['Float']>;
  cancelledData: Array<Scalars['Float']>;
  date: Array<Scalars['String']>;
  reservedData: Array<Scalars['Float']>;
  signedData: Array<Scalars['Float']>;
};

export type SalesStatisticDailyMovement = {
  __typename?: 'SalesStatisticDailyMovement';
  bookedCount: Scalars['Float'];
  bookedTotalSellingPrice: Scalars['Float'];
  cancelledCount: Scalars['Float'];
  cancelledTotalSellingPrice: Scalars['Float'];
  daily_date: Scalars['DateTime'];
  reserveCount: Scalars['Float'];
  reserveTotalSellingPrice: Scalars['Float'];
  sale_origin?: Maybe<Scalars['String']>;
  signedCount: Scalars['Float'];
  signedTotalSellingPrice: Scalars['Float'];
};

export type SalesStatisticEntity = AuditEntity & {
  __typename?: 'salesStatisticEntity';
  accountId: Scalars['String'];
  contactId: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  listPrice: Scalars['Float'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  saleStatus: Scalars['String'];
  spaPrice?: Maybe<Scalars['Float']>;
  transactionDate: Scalars['DateTime'];
  unitId: Scalars['String'];
};

export type SalesStatisticMonthlyMovement = {
  __typename?: 'SalesStatisticMonthlyMovement';
  bookedCount: Scalars['Float'];
  bookedTotalSellingPrice: Scalars['Float'];
  cancelledCount: Scalars['Float'];
  cancelledTotalSellingPrice: Scalars['Float'];
  months?: Maybe<Scalars['String']>;
  months_alt: Scalars['Float'];
  reserveCount: Scalars['Float'];
  reserveTotalSellingPrice: Scalars['Float'];
  sale_origin?: Maybe<Scalars['String']>;
  signedCount: Scalars['Float'];
  signedTotalSellingPrice: Scalars['Float'];
};

export type SalesStatisticMovement = {
  __typename?: 'SalesStatisticMovement';
  currency: Scalars['String'];
  dailyMovement: Array<SalesStatisticDailyMovement>;
  monthlyMovement: Array<SalesStatisticMonthlyMovement>;
  weeklyMovement: Array<SalesStatisticWeeklyMovement>;
};

export type SalesStatisticWeeklyMovement = {
  __typename?: 'SalesStatisticWeeklyMovement';
  bookedCount: Scalars['Float'];
  bookedTotalSellingPrice: Scalars['Float'];
  cancelledCount: Scalars['Float'];
  cancelledTotalSellingPrice: Scalars['Float'];
  end_week?: Maybe<Scalars['String']>;
  reserveCount: Scalars['Float'];
  reserveTotalSellingPrice: Scalars['Float'];
  sale_origin?: Maybe<Scalars['String']>;
  signedCount: Scalars['Float'];
  signedTotalSellingPrice: Scalars['Float'];
  start_week?: Maybe<Scalars['String']>;
  start_week_alt: Scalars['DateTime'];
};

export type SalesStatutoryDocumentEntity = {
  __typename?: 'SalesStatutoryDocumentEntity';
  accountId: Scalars['String'];
  attachment?: Maybe<Scalars['String']>;
  bpnLandArea: Scalars['Float'];
  commonStatus: Scalars['String'];
  contactId?: Maybe<Scalars['String']>;
  documentDate: Scalars['DateTime'];
  documentRef: Scalars['String'];
  id: Scalars['String'];
  isMerge: Scalars['Boolean'];
  newSalesStatutoryDocumentId: Scalars['String'];
  notaryId: Scalars['String'];
  projectId: Scalars['String'];
  saleId?: Maybe<Scalars['String']>;
  sales: Array<SaleEntity>;
  statutoryDocument: Array<StatutoryDocumentEntity>;
  statutoryDocumentId: Scalars['String'];
  unitStatutoryId: Scalars['String'];
};

export type SalesStatutoryObject = {
  __typename?: 'salesStatutoryObject';
  accountId?: Maybe<Scalars['String']>;
  attachment?: Maybe<Scalars['String']>;
  bpnLandArea?: Maybe<Scalars['Float']>;
  documentDate?: Maybe<Scalars['String']>;
  documentRef?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isMerge?: Maybe<Scalars['Boolean']>;
  mediaType?: Maybe<Scalars['String']>;
  notaryId?: Maybe<Scalars['String']>;
  projectId?: Maybe<Scalars['String']>;
  resourceUrl?: Maybe<Scalars['String']>;
  statutoryDocumentId?: Maybe<Scalars['String']>;
  unitStatutoryId?: Maybe<Scalars['String']>;
};

export enum SaleStatus {
  Booked = 'BOOKED',
  Cancelled = 'CANCELLED',
  DescriptionList = 'DescriptionList',
  Draft = 'DRAFT',
  GetDescription = 'GetDescription',
  Signed = 'SIGNED'
}

export type SaleStatusEnum = {
  __typename?: 'saleStatusEnum';
  saleStatus: SaleStatus;
};

export type SalesTeamBiSearchDateOutput = {
  __typename?: 'SalesTeamBISearchDateOutput';
  createdTs: Scalars['DateTime'];
};

export type SalesTeamOutput = {
  __typename?: 'SalesTeamOutput';
  commonStatus?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  users: Array<SalesTeamUserOuput>;
};

export type SalesTeamUserInfoOuput = {
  __typename?: 'SalesTeamUserInfoOuput';
  contactNo: Scalars['String'];
  email: Scalars['String'];
  ID: Scalars['String'];
  name: Scalars['String'];
};

export type SalesTeamUserOuput = {
  __typename?: 'SalesTeamUserOuput';
  id: Scalars['String'];
  leadCount?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  teamId: Scalars['String'];
};

export enum SalesType {
  GetSalesTypeList = 'GetSalesTypeList',
  GovernmentServant = 'GOVERNMENT_SERVANT',
  Public = 'PUBLIC',
  SalesTypeList = 'SalesTypeList',
  StaffPurchase = 'STAFF_PURCHASE'
}

export type SaleSubproductEntity = AuditEntity & {
  __typename?: 'saleSubproductEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  discount?: Maybe<DiscountEntity>;
  discountAmount?: Maybe<Scalars['Float']>;
  discountId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  paymentPlanId?: Maybe<Scalars['String']>;
  progressBilling?: Maybe<Array<ProgressBillingEntity>>;
  projectCarparkPaymentPlanId?: Maybe<Scalars['String']>;
  projectPaymentPlan?: Maybe<ProjectPaymentPlanEntity>;
  saleId: Scalars['String'];
  sales?: Maybe<SaleEntity>;
  sellingMethod: Scalars['String'];
  sellingPrice: Scalars['Float'];
  taxScheme: TaxSchemeEntity;
  taxSchemeId: Scalars['String'];
  unit?: Maybe<UnitEntity>;
  unitDataLoader: UnitEntity;
  unitId: Scalars['String'];
};

export type SaleSubProductListingOutput = {
  __typename?: 'saleSubProductListingOutput';
  id: Scalars['String'];
  parentId?: Maybe<Scalars['String']>;
  paymentPlanId?: Maybe<Scalars['String']>;
  saleId: Scalars['String'];
  sellingMethod: Scalars['String'];
  sellingPrice: Scalars['Float'];
  unitId: Scalars['String'];
  unitNo: Scalars['String'];
};

export type SalesUnitDetails = {
  __typename?: 'SalesUnitDetails';
  BuyerKind: Scalars['String'];
  CompletionDate?: Maybe<Scalars['String']>;
  FacingDirection?: Maybe<Scalars['String']>;
  InclusiveTax_SPA: Scalars['Float'];
  IsBumi?: Maybe<Scalars['Boolean']>;
  LandArea?: Maybe<Scalars['Float']>;
  Layout?: Maybe<Scalars['String']>;
  ProjectID: Scalars['String'];
  ProjectName: Scalars['String'];
  PropertyType?: Maybe<Scalars['String']>;
  SaleID: Scalars['String'];
  Scenery?: Maybe<Scalars['String']>;
  SignDate: Scalars['String'];
  UnitID: Scalars['String'];
  UnitNo: Scalars['String'];
  UOM?: Maybe<Scalars['String']>;
};

export type SaleTaxOutput = {
  __typename?: 'SaleTaxOutput';
  description: Scalars['String'];
  sale_id: Scalars['String'];
  tax_code?: Maybe<Scalars['String']>;
  tax_desc?: Maybe<Scalars['String']>;
  tax_id: Scalars['String'];
  tax_rate: Scalars['Float'];
};

export type SaleTeamAllocationEntity = {
  __typename?: 'saleTeamAllocationEntity';
  accountId: Scalars['String'];
  id: Scalars['String'];
  project: ProjectEntity;
  projectId: Scalars['String'];
  saleTeam: SaleTeamEntity;
  teamId: Scalars['String'];
  unit: UnitEntity;
  unitId: Scalars['String'];
};

export type SaleTeamEntity = {
  __typename?: 'saleTeamEntity';
  accountId: Scalars['String'];
  checkPermission?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  enableAllocation: Scalars['Boolean'];
  id: Scalars['String'];
  leadActivities: Array<LeadActivityEntity>;
  leadActivitiesTeam: Array<LeadActivityEntity>;
  leads: Array<LeadEntity>;
  memberCount?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  projectId: Scalars['String'];
  sales: Array<SaleEntity>;
  saleTeamMembers?: Maybe<Array<SaleTeamUserEntity>>;
  saleTeamUnitAllocation?: Maybe<Array<SaleTeamAllocationEntity>>;
  saleTeamUsers?: Maybe<Array<SaleTeamUserEntity>>;
  waitlistTeam?: Maybe<Array<BookingWaitlistEntity>>;
};

export type SaleTeamMemberLeadAssignmentOutput = {
  __typename?: 'SaleTeamMemberLeadAssignmentOutput';
  leadCount?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  teamId: Scalars['String'];
  userId?: Maybe<Scalars['String']>;
};

export type SaleTeamPerformanceOutput = {
  __typename?: 'SaleTeamPerformanceOutput';
  agency?: Maybe<Array<PerformanceByInternalAndAgency>>;
  team?: Maybe<Array<PerformanceByInternalAndAgency>>;
};

export type SaleTeamUserEntity = {
  __typename?: 'saleTeamUserEntity';
  acceptLead: Scalars['Boolean'];
  accountId: Scalars['String'];
  id: Scalars['String'];
  saleTeam: SaleTeamEntity;
  teamId: Scalars['String'];
  user?: Maybe<UserEntity>;
  userId: Scalars['String'];
};

export type SalutationEntity = {
  __typename?: 'salutationEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  contacts: Array<ContactEntity>;
  defaulted: Scalars['Boolean'];
  id: Scalars['String'];
  isDeletable: Scalars['Boolean'];
  isExistInMasterData: Array<Scalars['String']>;
  isExistInTransactionData: Array<Scalars['String']>;
  name: Scalars['String'];
  saleContact: SaleContactEntity;
  seqNo?: Maybe<Scalars['Float']>;
};

export type SalutationInput = {
  name: Scalars['String'];
};

export type ScheduleDetail = {
  __typename?: 'scheduleDetail';
  scheduleId: Scalars['String'];
  timeSlot: Array<ProjectKeyCollectionSettingOutput>;
  userData: Array<UserList>;
};

export type ScheduleEntity = {
  __typename?: 'scheduleEntity';
  batchId?: Maybe<Scalars['String']>;
  billedDate?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  docAmount: Scalars['String'];
  id: Scalars['String'];
  ledgers: Array<LedgerEntity>;
  project: ProjectEntity;
  sale: SaleEntity;
  scheduleDate: Scalars['DateTime'];
};

export type SCityEntity = {
  __typename?: 'sCityEntity';
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  sPostcode?: Maybe<Array<SPostcodeEntity>>;
  state: SStateEntity;
};

export type SCountryEntity = {
  __typename?: 'sCountryEntity';
  code: Scalars['String'];
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  sStates: Array<SStateEntity>;
};

export type SellingMethodSelection = {
  __typename?: 'sellingMethodSelection';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type SetDefaultPaymentPlanForProjectInput = {
  isDefault: Scalars['Boolean'];
  projectId: Scalars['String'];
  projectPaymentPlanId: Scalars['String'];
  typePaymentPlan: TypePaymentPlanEnum;
};

export type SGatewayUpdates_A = AuditEntity & {
  __typename?: 'SGatewayUpdates_A';
  commonStatus: CommonStatus;
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  hasSqlUpdate: Scalars['Boolean'];
  ID: Scalars['String'];
  IntegrationType?: Maybe<Scalars['String']>;
  md5?: Maybe<Scalars['String']>;
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  releaseNote?: Maybe<Scalars['String']>;
  sql?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  verifySql?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type ShareDownpaymentReminderByIdInput = {
  isProject: Scalars['Boolean'];
  letterTemplateId: Scalars['String'];
  reminderIds: Array<Scalars['String']>;
  sharedBy: Scalars['String'];
  sharedDateTime: Scalars['DateTime'];
  sharedMethod: Scalars['String'];
};

export type ShareDownpaymentReminderInput = {
  reminderIds: Array<Scalars['String']>;
  sharedBy: Scalars['String'];
  sharedDateTime: Scalars['DateTime'];
  sharedMethod: Scalars['String'];
};

export type ShareInput = {
  sharedBy: Scalars['String'];
  sharedDateTime: Scalars['String'];
  sharedMethod?: InputMaybe<Scalars['String']>;
};

export type ShareLetterTemplateOutput = {
  __typename?: 'shareLetterTemplateOutput';
  letterTemplateId: Scalars['String'];
  letterTemplateName: Scalars['String'];
};

/** JsonType */
export type ShareObject = {
  __typename?: 'shareObject';
  sharedBy: Scalars['String'];
  sharedDateTime: Scalars['String'];
  sharedMethod?: Maybe<Scalars['String']>;
};

export type SharePaymentReminderBasicInput = {
  reminderList: Array<SharePaymentReminderListInput>;
  sharedBy: Scalars['String'];
  sharedDateTime: Scalars['DateTime'];
  sharedMethod: Scalars['String'];
};

export type SharePaymentReminderByIdInput = {
  isProject: Scalars['Boolean'];
  letterTemplateId: Scalars['String'];
  reminderList: Array<SharePaymentReminderListInput>;
  sharedBy: Scalars['String'];
  sharedDateTime: Scalars['DateTime'];
  sharedMethod: Scalars['String'];
};

export type SharePaymentReminderListInput = {
  reminderIds: Array<Scalars['String']>;
  saleId: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
};

export type ShareSpaReminderByIdInput = {
  isProject: Scalars['Boolean'];
  letterTemplateId: Scalars['String'];
  reminderIds: Array<Scalars['String']>;
  sharedBy: Scalars['String'];
  sharedDateTime: Scalars['DateTime'];
};

export type SignedDetailsOutput = {
  __typename?: 'SignedDetailsOutput';
  bookDate?: Maybe<Scalars['DateTime']>;
  collectedDate?: Maybe<Scalars['DateTime']>;
  remark?: Maybe<Scalars['String']>;
  signedDate?: Maybe<Scalars['DateTime']>;
  snpAgreement?: Maybe<Array<SnpAgreements>>;
  stampDate?: Maybe<Scalars['DateTime']>;
};

export type SignedUnitListingOutput = {
  __typename?: 'signedUnitListingOutput';
  companyName?: Maybe<Scalars['String']>;
  isCompany?: Maybe<Scalars['Boolean']>;
  isVip: Scalars['Boolean'];
  purchaserName: Scalars['String'];
  saleId: Scalars['String'];
  unitId: Scalars['String'];
  unitNo: Scalars['String'];
};

export type SiteProgressEntity = {
  __typename?: 'siteProgressEntity';
  accountId: Scalars['String'];
  attachment: Array<AttachmentEntity>;
  commonStatus: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  projectId: Scalars['String'];
  publishDate: Scalars['DateTime'];
  title: Scalars['String'];
};

export type SiteProgressPurchaserOutput = {
  __typename?: 'siteProgressPurchaserOutput';
  price: Scalars['Float'];
  siteData?: Maybe<Array<SiteProgressEntity>>;
  total: Scalars['Float'];
  unitNo: Scalars['String'];
};

export type SmtpInfoInput = {
  createdBy?: InputMaybe<Scalars['String']>;
  createdTs?: InputMaybe<Scalars['DateTime']>;
  enableSSL?: InputMaybe<Scalars['Boolean']>;
  hostName: Scalars['String'];
  lastUpdateBy?: InputMaybe<Scalars['String']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']>;
  maxRetry: Scalars['Float'];
  modBy?: InputMaybe<Scalars['String']>;
  modTs?: InputMaybe<Scalars['DateTime']>;
  password: Scalars['String'];
  portNumber: Scalars['Float'];
  userName: Scalars['String'];
};

export type SmtpInfoOutput = {
  __typename?: 'smtpInfoOutput';
  createdBy?: Maybe<Scalars['String']>;
  createdTs?: Maybe<Scalars['DateTime']>;
  enableSSL?: Maybe<Scalars['Boolean']>;
  hostName: Scalars['String'];
  lastUpdateBy?: Maybe<Scalars['String']>;
  lastUpdatedDate?: Maybe<Scalars['DateTime']>;
  maxRetry: Scalars['Float'];
  modBy?: Maybe<Scalars['String']>;
  modTs?: Maybe<Scalars['DateTime']>;
  password: Scalars['String'];
  portNumber: Scalars['Float'];
  userName: Scalars['String'];
};

export type SNationalityEntity = {
  __typename?: 'sNationalityEntity';
  commonStatus: Scalars['String'];
  contacts: Array<ContactEntity>;
  id: Scalars['String'];
  leadContacts: Array<LeadContactEntity>;
  name: Scalars['String'];
};

export type SnpAgreements = {
  __typename?: 'SNPAgreements';
  id?: Maybe<Scalars['String']>;
  mediaType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type SnpSigningReminderInput = {
  afterDay?: InputMaybe<Scalars['Float']>;
  agencyUserReceive?: InputMaybe<Scalars['Boolean']>;
  beforeDay?: InputMaybe<Scalars['Float']>;
  purchaserReceive?: InputMaybe<Scalars['Boolean']>;
  salesUserReceive?: InputMaybe<Scalars['Boolean']>;
};

export type SnpSigningReminderOutput = {
  __typename?: 'SNPSigningReminderOutput';
  afterDay?: Maybe<Scalars['Float']>;
  agencyUserReceive?: Maybe<Scalars['Boolean']>;
  beforeDay?: Maybe<Scalars['Float']>;
  purchaserReceive?: Maybe<Scalars['Boolean']>;
  salesUserReceive?: Maybe<Scalars['Boolean']>;
};

export type SolicitoAgreementDownloadOutput = {
  __typename?: 'SolicitoAgreementDownloadOutput';
  content: Scalars['String'];
  fileName: Scalars['String'];
};

export type SolicitorAlertAgingInput = {
  isActive: Scalars['Boolean'];
  maxMajorSolicitorAlertAging: Scalars['Float'];
  maxMinorSolicitorAlertAging: Scalars['Float'];
};

export type SolicitorAlertAgingOutput = {
  __typename?: 'SolicitorAlertAgingOutput';
  isActive: Scalars['Boolean'];
  maxMajorSolicitorAlertAging: Scalars['Float'];
  maxMinorSolicitorAlertAging: Scalars['Float'];
};

export type SolicitorAppointedContactEntity = AuditEntity & {
  __typename?: 'solicitorAppointedContactEntity';
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  name: Scalars['String'];
  phoneNo?: Maybe<Scalars['String']>;
  solicitor: SolicitorAppointedEntity;
  solicitorAppointedId: Scalars['String'];
};

export type SolicitorAppointedCount = {
  __typename?: 'solicitorAppointedCount';
  lastAppointedDate?: Maybe<Scalars['DateTime']>;
  totalAppointed?: Maybe<Scalars['Float']>;
};

export type SolicitorAppointedEntity = AuditEntity & {
  __typename?: 'solicitorAppointedEntity';
  accountId: Scalars['String'];
  address?: Maybe<AddressJson>;
  assignedProjectCount: Scalars['Float'];
  commonStatus: Scalars['String'];
  contact: Array<SolicitorAppointedContactEntity>;
  contactEmail?: Maybe<Scalars['String']>;
  contactName?: Maybe<Scalars['String']>;
  contactPhoneNo?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  default?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  invitationLink: Scalars['String'];
  isExistInMasterData: Array<Scalars['String']>;
  isExistInTransactionData: Array<Scalars['String']>;
  isIntegrated: Scalars['Boolean'];
  logoUrl?: Maybe<Scalars['String']>;
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  name: Scalars['String'];
  officeTel?: Maybe<Scalars['String']>;
  projectCount?: Maybe<Scalars['Float']>;
  saleBuyerSolicitor: Array<SaleEntity>;
  saleDeveloperSolicitor: Array<SaleEntity>;
  saleLoan: Array<SaleLoanEntity>;
  saleStakeholder: Array<SaleEntity>;
  solicitorCode?: Maybe<Scalars['String']>;
  solicitorId?: Maybe<Scalars['String']>;
  solicitorStatus: Scalars['Boolean'];
  solicitorUnitCount?: Maybe<SolicitorUnitCount>;
  subsaleBuyerSolicitor: Array<SubsaleEntity>;
  unitCount?: Maybe<Scalars['Float']>;
  unitExt: Array<UnitExtensionEntity>;
  unitExtLawyer: Array<UnitExtensionEntity>;
};


export type SolicitorAppointedEntityDefaultArgs = {
  projectId: Scalars['String'];
};


export type SolicitorAppointedEntitySolicitorStatusArgs = {
  project_id: Scalars['String'];
};


export type SolicitorAppointedEntitySolicitorUnitCountArgs = {
  project_id: Scalars['String'];
};

export type SolicitorCaseAssignmentInput = {
  agencyUserReceive?: InputMaybe<Scalars['Boolean']>;
  salesUserReceive?: InputMaybe<Scalars['Boolean']>;
  solicitorUserReceive?: InputMaybe<Scalars['Boolean']>;
};

export type SolicitorCaseAssignmentOutput = {
  __typename?: 'solicitorCaseAssignmentOutput';
  agencyUserReceive?: Maybe<Scalars['Boolean']>;
  salesUserReceive?: Maybe<Scalars['Boolean']>;
  solicitorUserReceive?: Maybe<Scalars['Boolean']>;
};

export type SolicitorContact = {
  email: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  phoneNo: Scalars['String'];
};

export type SolicitorContactEntity = AuditEntity & {
  __typename?: 'solicitorContactEntity';
  commonStatus?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isSuspendible: Scalars['Boolean'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  name: Scalars['String'];
  phoneNo?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  user: SolicitorUserEntity;
  userId: Scalars['String'];
};

export type SolicitorEntity = AuditEntity & {
  __typename?: 'solicitorEntity';
  address?: Maybe<AddressJson>;
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  name: Scalars['String'];
  officeTel?: Maybe<Scalars['String']>;
};

export type SolicitorLayoutList = {
  __typename?: 'solicitorLayoutList';
  allotted: Scalars['Float'];
  desc: Scalars['String'];
  layout_id: Scalars['String'];
  project_id: Scalars['String'];
  sold: Scalars['Float'];
  solicitor_project_id: Scalars['String'];
  total_selling: Scalars['Float'];
};

export type SolicitorLeadNotificationInput = {
  leadAssignment?: InputMaybe<Scalars['Boolean']>;
};

export type SolicitorLeadNotificationOutput = {
  __typename?: 'SolicitorLeadNotificationOutput';
  leadAssignment?: Maybe<Scalars['Boolean']>;
};

export type SolicitorNotificationEntity = AuditEntity & {
  __typename?: 'solicitorNotificationEntity';
  accountId: Scalars['String'];
  body: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  permissionId: Scalars['Float'];
  projectId: Scalars['String'];
  solicitorNotificationRecipient: Array<SolicitorNotificationRecipientEntity>;
  subject: Scalars['String'];
};

export type SolicitorNotificationPolicyEntity = {
  __typename?: 'solicitorNotificationPolicyEntity';
  accountId: Scalars['String'];
  id: Scalars['String'];
  notificationDuration: Scalars['Float'];
  permissionId: Scalars['Float'];
  userId: Scalars['String'];
};

export type SolicitorNotificationRecipientEntity = AuditEntity & {
  __typename?: 'solicitorNotificationRecipientEntity';
  accountId: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  isRead: Scalars['Boolean'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  notificationId: Scalars['String'];
  projectId: Scalars['String'];
  recipientId: Scalars['String'];
  solicitorNotification: SolicitorNotificationEntity;
};

export type SolicitorProgressLogEntity = AuditEntity & {
  __typename?: 'solicitorProgressLogEntity';
  accountId: Scalars['String'];
  actionBy: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  progressDate: Scalars['DateTime'];
  progressDesc?: Maybe<Scalars['String']>;
  progressType: Scalars['String'];
  remark?: Maybe<Scalars['String']>;
  sale: SaleEntity;
  saleId: Scalars['String'];
  solicitorId?: Maybe<Scalars['String']>;
  spaStatus?: Maybe<Scalars['String']>;
};

export type SolicitorProjectEntity = AuditEntity & {
  __typename?: 'solicitorProjectEntity';
  accountId: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  defaulted: Scalars['Boolean'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  project?: Maybe<ProjectEntity>;
  projectId: Scalars['String'];
  solicitorId: Scalars['String'];
};

export type SolicitorStatusCount = {
  __typename?: 'solicitorStatusCount';
  assignedCount?: Maybe<Scalars['Float']>;
  bookedCount?: Maybe<Scalars['Float']>;
  reservationCount?: Maybe<Scalars['Float']>;
  snpSignedCount?: Maybe<Scalars['Float']>;
  toBeAssignedCount?: Maybe<Scalars['Float']>;
  totalCount?: Maybe<Scalars['Float']>;
};

export type SolicitorUnitAllocationEntity = AuditEntity & {
  __typename?: 'solicitorUnitAllocationEntity';
  accountId: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  projectId: Scalars['String'];
  solicitorId: Scalars['String'];
  unit: UnitEntity;
  unitId: Scalars['String'];
};

export type SolicitorUnitCount = {
  __typename?: 'solicitorUnitCount';
  allocated?: Maybe<Scalars['Float']>;
  sold?: Maybe<Scalars['Float']>;
};

export type SolicitorUserEntity = AuditEntity & {
  __typename?: 'solicitorUserEntity';
  accessToken?: Maybe<Scalars['String']>;
  activated: Scalars['Boolean'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  forgotPasswordLink?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  loginId: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  passwordHash?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  solicitorId: Scalars['String'];
};

export type SpaReminderEntity = AuditEntity & {
  __typename?: 'spaReminderEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  generationBatch?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  projectId: Scalars['String'];
  reminderDate: Scalars['DateTime'];
  reminderSeq: Scalars['Float'];
  saleId: Scalars['String'];
  sales?: Maybe<SaleEntity>;
  share?: Maybe<Array<ShareObject>>;
};

export type SpaReminderInput = {
  projectId: Scalars['String'];
  reminderDate: Scalars['DateTime'];
  reminderSeq: Scalars['Float'];
  saleId: Scalars['String'];
  share?: InputMaybe<Array<ShareInput>>;
};

export type SpecialListInput = {
  displayFloorNo: Scalars['String'];
  floor: Scalars['Float'];
};

export type SpecialUnitListInput = {
  displayUnitNo: Scalars['String'];
  unit: Scalars['String'];
};

export type SPostcodeEntity = {
  __typename?: 'sPostcodeEntity';
  citys: SCityEntity;
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  postcode: Scalars['String'];
};

export type SStateEntity = {
  __typename?: 'sStateEntity';
  commonStatus: Scalars['String'];
  country: SCountryEntity;
  id: Scalars['String'];
  name: Scalars['String'];
  sCities?: Maybe<Array<SCityEntity>>;
};

export type StakeholderAttachment = {
  __typename?: 'StakeholderAttachment';
  attachmentId: Scalars['String'];
  fileName: Scalars['String'];
  mediaType: Scalars['String'];
  resourceUrl: Scalars['String'];
};

export type StakeholderAvailableDeemCollectedUnit = {
  __typename?: 'StakeholderAvailableDeemCollectedUnit';
  deemCollectedData?: Maybe<Array<DeemCollectedData>>;
  deemCollectedIds: Array<Scalars['String']>;
  saleId: Scalars['String'];
  totalDeemCollected: Scalars['Float'];
  unitNo: Scalars['String'];
};

export type StakeholderAvailableReleaseUnit = {
  __typename?: 'StakeholderAvailableReleaseUnit';
  amount: Scalars['Float'];
  billingStageName: Scalars['String'];
  collectionBatch: Scalars['String'];
  dueDate: Scalars['DateTime'];
  isCheck: Scalars['Boolean'];
  outstandingAmt: Scalars['Float'];
  purchaserName: Scalars['String'];
  releaseAmt?: Maybe<Scalars['Float']>;
  saleId: Scalars['String'];
  stakeholderProcessId: Scalars['String'];
  stakeholderProcessReleaseId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  unitNo: Scalars['String'];
};

export type StakeholderAvailableReleaseUnitByDueDate = {
  __typename?: 'StakeholderAvailableReleaseUnitByDueDate';
  dueDate: Scalars['DateTime'];
  saleCount: Scalars['Float'];
  totalOutstanding: Scalars['Float'];
  units: Array<StakeholderAvailableReleaseUnit>;
};

export type StakeholderDeemCollectedDetail = {
  __typename?: 'StakeholderDeemCollectedDetail';
  attachments?: Maybe<Array<StakeholderAttachment>>;
  collectionBatch: Scalars['String'];
  collectionDate: Scalars['DateTime'];
  collectionReferenceNo?: Maybe<Scalars['String']>;
  durationFlag: Scalars['String'];
  solicitorId: Scalars['String'];
  totalDeemCollected: Scalars['Float'];
};

export type StakeholderDeemCollectedUnitDetail = {
  __typename?: 'StakeholderDeemCollectedUnitDetail';
  saleId: Scalars['String'];
  stakeholderDetails: Array<StakeholderDeemCollectedUnitRecordDetail>;
  totalDeemCollected: Scalars['Float'];
  unitNo: Scalars['String'];
};

export type StakeholderDeemCollectedUnitRecordDetail = {
  __typename?: 'StakeholderDeemCollectedUnitRecordDetail';
  billingDescription?: Maybe<Scalars['String']>;
  deemCollected: Scalars['Float'];
  dueDate: Scalars['DateTime'];
  financialBillingId: Scalars['String'];
  progressBillingId: Scalars['String'];
};

export type StakeholderDetails = {
  bankName?: InputMaybe<Scalars['String']>;
  buyerName?: InputMaybe<Scalars['String']>;
  collectionBatchId?: InputMaybe<Scalars['String']>;
  financialBillingId?: InputMaybe<Scalars['String']>;
  financierCode?: InputMaybe<Scalars['String']>;
  financierName?: InputMaybe<Scalars['String']>;
  pbDescription?: InputMaybe<Scalars['String']>;
  pbDocumentNo?: InputMaybe<Scalars['String']>;
  pbId?: InputMaybe<Scalars['String']>;
  saleId?: InputMaybe<Scalars['String']>;
  spAmount?: InputMaybe<Scalars['Float']>;
  spDueDate?: InputMaybe<Scalars['String']>;
  spId?: InputMaybe<Scalars['String']>;
  unitNo?: InputMaybe<Scalars['String']>;
};

export type StakeholderOverdueRelease = {
  __typename?: 'StakeholderOverdueRelease';
  dueDate: Scalars['DateTime'];
  overdueReleaseUnitDetail: Array<StakeholderOverdueReleaseUnitDetail>;
  saleCount: Scalars['Float'];
  totalReleaseAmt: Scalars['Float'];
};

export type StakeholderOverdueReleaseUnitDetail = {
  __typename?: 'StakeholderOverdueReleaseUnitDetail';
  releaseAmt: Scalars['Float'];
  saleId: Scalars['String'];
  unitNo: Scalars['String'];
};

export type StakeholderProcess = {
  __typename?: 'StakeholderProcess';
  deemCollectedSaleCount: Scalars['Float'];
  outstandingReleaseAmt: Scalars['Float'];
  releaseSaleCount: Scalars['Float'];
  saleCount: Scalars['Float'];
  solicitorCode?: Maybe<Scalars['String']>;
  solicitorId: Scalars['String'];
  solicitorName: Scalars['String'];
  totalAmt: Scalars['Float'];
  totalDeemCollected: Scalars['Float'];
  totalReleaseAmt: Scalars['Float'];
  unitIndex: Scalars['String'];
};

export type StakeholderProcessDeemCollected = {
  __typename?: 'StakeholderProcessDeemCollected';
  attachment?: Maybe<Array<AttachmentList>>;
  collectionBatchId: Scalars['String'];
  collectionDate: Scalars['DateTime'];
  collectionReferenceNo?: Maybe<Scalars['String']>;
  documentDate?: Maybe<Scalars['DateTime']>;
  saleCount: Scalars['Float'];
  solicitorId: Scalars['String'];
  status: Scalars['String'];
  totalDeemCollected: Scalars['Float'];
  unitNo?: Maybe<Array<Scalars['String']>>;
  voidBy?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
};

export type StakeholderProcessEntity = {
  __typename?: 'stakeholderProcessEntity';
  accountId: Scalars['String'];
  amount: Scalars['Float'];
  collectionBatch?: Maybe<Scalars['String']>;
  collectionDate?: Maybe<Scalars['DateTime']>;
  collectionReferenceNo?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  contraId?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  duration: Scalars['Float'];
  durationFlag?: Maybe<Scalars['String']>;
  financialBillingId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isReversal: Scalars['Boolean'];
  progressBilling?: Maybe<ProgressBillingEntity>;
  progressBillingId: Scalars['String'];
  projectId: Scalars['String'];
  releaseDate: Scalars['DateTime'];
  saleId: Scalars['String'];
  solicitorId: Scalars['String'];
  status: Scalars['String'];
  voidBy?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
};

export type StakeholderProcessListOutput = {
  __typename?: 'StakeholderProcessListOutput';
  data: Array<StakeholderProcessEntity>;
  total: Scalars['Float'];
};

export type StakeholderProcessRelease = {
  __typename?: 'StakeholderProcessRelease';
  attachment?: Maybe<Array<AttachmentList>>;
  gl_generation_batch?: Maybe<Scalars['String']>;
  isVoid: Scalars['Boolean'];
  releaseDate: Scalars['DateTime'];
  releaseRefNo: Scalars['String'];
  saleCount: Scalars['Float'];
  solicitorId: Scalars['String'];
  stakeholderReleaseId: Scalars['String'];
  status: Scalars['String'];
  totalReleaseAmt: Scalars['Float'];
  unitNo?: Maybe<Array<Scalars['String']>>;
};

export type StakeholderProcessReleaseDetailEntity = {
  __typename?: 'stakeholderProcessReleaseDetailEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  releaseAmount: Scalars['Float'];
  stakeholderProcessId: Scalars['String'];
  stakeholderProcessReleaseId: Scalars['String'];
};

export type StakeholderProcessReleaseEntity = {
  __typename?: 'stakeholderProcessReleaseEntity';
  accountId: Scalars['String'];
  bankAccountId: Scalars['String'];
  commonStatus: Scalars['String'];
  gl_generated_reversed: Scalars['String'];
  glGenerated: Scalars['String'];
  glGenerationBatch?: Maybe<Scalars['String']>;
  glGenerationReversedBatch?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isReversal: Scalars['Boolean'];
  projectId: Scalars['String'];
  releaseDate: Scalars['DateTime'];
  releaseMethod: Scalars['String'];
  releaseReferenceNo?: Maybe<Scalars['String']>;
  releaseRemark?: Maybe<Scalars['String']>;
  solicitorId: Scalars['String'];
  status: Scalars['String'];
  voidBy?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
};

export type StakeholderReleaseDetail = {
  __typename?: 'StakeholderReleaseDetail';
  attachments?: Maybe<Array<StakeholderAttachment>>;
  overdueRelease: Array<StakeholderOverdueRelease>;
  releaseDate: Scalars['DateTime'];
  releaseMethod: Scalars['String'];
  releaseReferenceNo?: Maybe<Scalars['String']>;
  releaseRemark?: Maybe<Scalars['String']>;
  solicitorId: Scalars['String'];
  stakeholderReleaseId: Scalars['String'];
};

export type StakeholderSummaryOutput = {
  __typename?: 'stakeholderSummaryOutput';
  totalAmt?: Maybe<Scalars['Float']>;
  totalDeemCollected?: Maybe<Scalars['Float']>;
  totalReleaseAmt?: Maybe<Scalars['Float']>;
};

export type StakeholderUnitDetail = {
  __typename?: 'StakeholderUnitDetail';
  billingDescription: Scalars['String'];
  deemCollected: Scalars['Float'];
  dueDate?: Maybe<Scalars['DateTime']>;
  outstandingReleaseAmt: Scalars['Float'];
  saleId: Scalars['String'];
  unitNo: Scalars['String'];
};

export type StakeholderUnitSummary = {
  __typename?: 'StakeholderUnitSummary';
  block?: Maybe<Scalars['String']>;
  cell?: Maybe<Scalars['String']>;
  floor?: Maybe<Scalars['String']>;
  outstandingReleaseAmt: Scalars['Float'];
  saleId: Scalars['String'];
  totalDeemCollected: Scalars['Float'];
  totalReleaseAmt: Scalars['Float'];
  unitNo: Scalars['String'];
};

export type StampDutyAttachmentOutput = {
  __typename?: 'stampDutyAttachmentOutput';
  docAmt: Scalars['Float'];
  docNo: Scalars['String'];
  fileName: Scalars['String'];
  fileNameSign?: Maybe<Scalars['String']>;
  fileSerialNumber?: Maybe<Scalars['String']>;
  fileStatus?: Maybe<Scalars['String']>;
  fileToken?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  refTable: Scalars['String'];
  resourceUrl: Scalars['String'];
};

export type StampDutyDetailEntity = {
  __typename?: 'stampDutyDetailEntity';
  accountId: Scalars['ID'];
  commonStatus: Scalars['String'];
  fromAmt: Scalars['String'];
  id: Scalars['ID'];
  stampDutyExt: StampDutyExtEntity;
  stampExtId: Scalars['ID'];
  toAmt: Scalars['String'];
  value: Scalars['String'];
};

export type StampDutyEntity = {
  __typename?: 'stampDutyEntity';
  accountId: Scalars['ID'];
  code: Scalars['String'];
  commonStatus: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['ID'];
  stampDutyExts: Array<StampDutyExtEntity>;
};

export type StampDutyExtEntity = {
  __typename?: 'stampDutyExtEntity';
  accountId: Scalars['ID'];
  commonStatus: Scalars['String'];
  effectiveDate: Scalars['DateTime'];
  id: Scalars['ID'];
  stampDuty: StampDutyEntity;
  stampDutyDetails: Array<StampDutyDetailEntity>;
  stampDutyId: Scalars['ID'];
};

export type StampDutyIntegrationEntity = {
  __typename?: 'stampDutyIntegrationEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  extension: Scalars['String'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  projectId: Scalars['String'];
  projectLetterTemplateId: Scalars['String'];
  stampDutyId: Scalars['String'];
  type: Scalars['String'];
};

export type StampDutyIntegrationListingOutput = {
  __typename?: 'stampDutyIntegrationListingOutput';
  extension: Scalars['String'];
  id: Scalars['String'];
  projectLetterTemplateId: Scalars['String'];
  projectLetterTemplateName: Scalars['String'];
  stampDutyDescription: Scalars['String'];
  stampDutyId: Scalars['String'];
  type: Scalars['String'];
};

export type StampDutyIntegrationOutput = {
  __typename?: 'stampDutyIntegrationOutput';
  extension: Scalars['String'];
  id: Scalars['String'];
  projectLetterTemplateName: Scalars['String'];
  stampDutyDescription: Scalars['String'];
  type: Scalars['String'];
};

export type StampDutyOptionOutput = {
  __typename?: 'stampDutyOptionOutput';
  code: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['String'];
};

export type StandardAuditEntity = {
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
};

export type StandardCoreBaseEntity = AuditEntity & {
  __typename?: 'StandardCoreBaseEntity';
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  ID: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
};

export type StandardLetterCategoryOutput = {
  __typename?: 'standardLetterCategoryOutput';
  letterCategory: Scalars['String'];
  letterDetail: Array<LetterCategoryDetailOutput>;
};

export type StandardLetterDataSourceEntity = {
  __typename?: 'standardLetterDataSourceEntity';
  accountId: Scalars['String'];
  dataSource: Array<DataSource>;
  id: Scalars['String'];
  name: Scalars['String'];
  queryFilterString: Array<QueryFilterString>;
  queryParameter: Array<QueryParameter>;
  reportParameter: Array<ReportParameter>;
  standardLetterId: Scalars['String'];
  version: Scalars['Float'];
};

export type StandardLetterEntity = {
  __typename?: 'standardLetterEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  isAllowHtmlEditor: Scalars['Boolean'];
  isAllowReportDesignEditor: Scalars['Boolean'];
  letterCategory: Scalars['String'];
  letterTemplate: Array<LetterTemplateEntity>;
  letterType: Scalars['String'];
  name: Scalars['String'];
  projectTemplate: Array<ProjectLetterTemplateEntity>;
  standardLetterParameter: Array<StandardLetterParameterEntity>;
};

export type StandardLetterInput = {
  isReportDesignEditor: Scalars['Boolean'];
  jointBuyerSignRequired: Scalars['Boolean'];
  name: Scalars['String'];
  standardLetterId: Scalars['String'];
};

export type StandardLetterParameterEntity = {
  __typename?: 'standardLetterParameterEntity';
  accountId: Scalars['String'];
  columnName: Scalars['String'];
  commonStatus: Scalars['String'];
  displayName: Scalars['String'];
  id: Scalars['String'];
  standardLetter: StandardLetterEntity;
  standardLetterId: Scalars['String'];
};

export type StandardLetterParameterInput = {
  columnName: Scalars['String'];
  displayName: Scalars['String'];
  standardLetterId: Scalars['String'];
};

export type StateMasterDataOutput = {
  __typename?: 'StateMasterDataOutput';
  commonStatus: Scalars['String'];
  countryID: Scalars['String'];
  ID: Scalars['String'];
  name: Scalars['String'];
};

export type StaticData = {
  __typename?: 'StaticData';
  Desc: Scalars['String'];
  Value: Scalars['String'];
};

export type StaticDataInput = {
  Desc: Scalars['String'];
  Value: Scalars['String'];
};

export type StatutoryDocumentEntity = {
  __typename?: 'statutoryDocumentEntity';
  accountId: Scalars['String'];
  code?: Maybe<Scalars['String']>;
  commissionStatutoryDocuments: Array<CommissionStatutoryDocumentEntity>;
  id: Scalars['String'];
  name: Scalars['String'];
  perSalesContract: Scalars['Boolean'];
  salesStatutoryDocument?: Maybe<Array<SalesStatutoryDocumentEntity>>;
};

export type StatutoryTypeListByUnitOutput = {
  __typename?: 'statutoryTypeListByUnitOutput';
  code?: Maybe<Scalars['String']>;
  contactId?: Maybe<Scalars['String']>;
  documents: Array<SalesStatutoryObject>;
  fullName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  perSalesContract?: Maybe<Scalars['Boolean']>;
  saleId?: Maybe<Scalars['String']>;
  statutoryDocId?: Maybe<Scalars['String']>;
  totalNeedToBeUploaded?: Maybe<Scalars['Float']>;
  totalUploaded?: Maybe<Scalars['Float']>;
  unitStatutoryId?: Maybe<Scalars['String']>;
};

export type SubdistrictMasterDataOutput = {
  __typename?: 'SubdistrictMasterDataOutput';
  commonStatus: Scalars['String'];
  districID: Scalars['String'];
  ID: Scalars['String'];
  name: Scalars['String'];
};

export type SubmitUnitTransferFormInput = {
  action: Scalars['String'];
  additionalPackages?: InputMaybe<Array<AddPackageUnitTransferInput>>;
  campaignTheme?: InputMaybe<Scalars['String']>;
  carParks?: InputMaybe<Array<AddCarParkUnitTransferInput>>;
  contactPersons?: InputMaybe<Array<SaleContactPersonInput>>;
  correspondenceAddress?: InputMaybe<AddressJsonInput>;
  creditTerms?: InputMaybe<Scalars['Float']>;
  discounts?: InputMaybe<Array<AddSalesRegistrationDiscountInput>>;
  finalContractPrice: Scalars['Float'];
  fromUnit: Scalars['String'];
  gracePeriod?: InputMaybe<Scalars['Float']>;
  jointBuyer?: InputMaybe<Array<Buyer>>;
  leadChannelId?: InputMaybe<Scalars['String']>;
  mainBuyer?: InputMaybe<Buyer>;
  miscBillId: Scalars['String'];
  oldAllocationAmt?: InputMaybe<Scalars['Float']>;
  paymentPlan: SalePaymentPlanInput;
  paymentPlanMarkUpAmt?: InputMaybe<Scalars['Float']>;
  salesPersonId: Scalars['String'];
  salesTeamId: Scalars['String'];
  salesType: Scalars['String'];
  taxSchemaId?: InputMaybe<Scalars['String']>;
  toUnit: Scalars['String'];
  transferDate?: InputMaybe<Scalars['DateTime']>;
  transferReason?: InputMaybe<Scalars['String']>;
};

export type SubsaleEntity = {
  __typename?: 'subsaleEntity';
  accountId: Scalars['String'];
  administrationCharges: Scalars['Float'];
  buyerIdentityNo: Scalars['String'];
  buyerName: Scalars['String'];
  buyerSolicitor?: Maybe<SolicitorAppointedEntity>;
  buyerSolicitorId: Scalars['String'];
  buyerSolicitorReferenceNo: Scalars['String'];
  commonStatus: Scalars['String'];
  completedDate?: Maybe<Scalars['DateTime']>;
  contactId: Scalars['String'];
  dmcDate: Scalars['DateTime'];
  doaDate: Scalars['DateTime'];
  id: Scalars['String'];
  isCompany: Scalars['Boolean'];
  printingCharges: Scalars['Float'];
  projectId: Scalars['String'];
  rrDate: Scalars['DateTime'];
  sellingPrice: Scalars['Float'];
  serviceChargeDeposit: Scalars['Float'];
  spaDate: Scalars['DateTime'];
  status: Scalars['String'];
  subsaleCategory: Scalars['String'];
  subsaleContactName?: Maybe<ContactEntity>;
  subsaleJointBuyers?: Maybe<Array<SubsaleJointBuyerEntity>>;
  subsaleLoans?: Maybe<Array<SubsaleLoanEntity>>;
  unitId: Scalars['String'];
  units?: Maybe<UnitEntity>;
  vendorSolicitorId: Scalars['String'];
  vendorSolicitorReferenceNo: Scalars['String'];
};

export type SubsaleJointBuyerEntity = {
  __typename?: 'subsaleJointBuyerEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  contactId: Scalars['String'];
  id: Scalars['String'];
  ranking: Scalars['Float'];
  subsaleId: Scalars['String'];
  subsaleJointBuyerContactName?: Maybe<ContactEntity>;
  subsales: SubsaleEntity;
};

export type SubsaleListingOutput = {
  __typename?: 'subsaleListingOutput';
  companyName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isCompany?: Maybe<Scalars['Boolean']>;
  purchaserName: Scalars['String'];
  sellingPrice: Scalars['Float'];
  spaDate: Scalars['DateTime'];
  status: Scalars['String'];
  unitNo: Scalars['String'];
};

export type SubsaleLoanEntity = {
  __typename?: 'subsaleLoanEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  DOADate: Scalars['DateTime'];
  DOASolicitorId: Scalars['String'];
  DOASolicitorReferenceNo: Scalars['String'];
  financierId: Scalars['String'];
  financierReferenceNo: Scalars['String'];
  id: Scalars['String'];
  loanSeqNo: Scalars['Float'];
  LoanSolicitorId: Scalars['String'];
  loanSolicitorReferenceNo: Scalars['String'];
  RRDate: Scalars['DateTime'];
  RRSolicitorId: Scalars['String'];
  RRSolicitorReferenceNo: Scalars['String'];
  subsaleFinancierName?: Maybe<FinancierEntity>;
  subsaleId: Scalars['String'];
  subsales: SubsaleEntity;
};

export enum SubsaleType {
  Auction = 'AUCTION',
  DescriptionList = 'DescriptionList',
  GetDescription = 'GetDescription',
  LetterOfAdministrationOrExecutor = 'LETTER_OF_ADMINISTRATION_OR_EXECUTOR',
  Successor = 'SUCCESSOR',
  TransferOfOwnership = 'TRANSFER_OF_OWNERSHIP',
  TransferOfShare = 'TRANSFER_OF_SHARE'
}

export type SummaryInfo = {
  __typename?: 'summaryInfo';
  count: Scalars['Float'];
  info: Scalars['String'];
  totalPrice: Scalars['Float'];
};

export type SummaryOutput = {
  __typename?: 'summaryOutput';
  count: Scalars['Float'];
  lastUpdateDate?: Maybe<Scalars['DateTime']>;
};

export type SUserEntity = {
  __typename?: 'sUserEntity';
  accountID: Scalars['String'];
  address?: Maybe<Address>;
  avatar?: Maybe<Scalars['String']>;
  blockCount: Scalars['Float'];
  blockDuration: Scalars['Float'];
  commonStatus: CommonStatus;
  confirmed: Scalars['Boolean'];
  contactNo: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  department?: Maybe<Scalars['String']>;
  deviceIP?: Maybe<Scalars['String']>;
  deviceToken?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  ID: Scalars['String'];
  is2FA?: Maybe<Scalars['Boolean']>;
  isActivated: Scalars['Boolean'];
  isSuspendible: Scalars['Boolean'];
  jobTitle?: Maybe<Scalars['String']>;
  languageSet?: Maybe<Scalars['String']>;
  lastestAccessedEntity?: Maybe<Scalars['String']>;
  lastPwdChangedDate?: Maybe<Scalars['DateTime']>;
  loginAttempt: Scalars['Float'];
  loginTs?: Maybe<Scalars['DateTime']>;
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
  softwareCode: Scalars['String'];
  superUser: Scalars['Boolean'];
  userFeaturePermission: UserFeaturePermissionEntity;
  userName?: Maybe<Scalars['String']>;
};

export type Tax = {
  __typename?: 'tax';
  nameTax?: Maybe<Scalars['String']>;
  taxAddress?: Maybe<Scalars['String']>;
  taxRegNo?: Maybe<Scalars['String']>;
};

export enum TaxClassType {
  DescriptionList = 'DescriptionList',
  GetDescription = 'GetDescription',
  Input = 'INPUT',
  Output = 'OUTPUT'
}

export type TaxData = {
  __typename?: 'taxData';
  taxAmount: Scalars['Float'];
  taxId: Scalars['String'];
  taxRate: Scalars['String'];
};

export type TaxDataInput = {
  taxAmount: Scalars['Float'];
  taxId: Scalars['String'];
  taxRate: Scalars['Float'];
};

export type TaxDetail = {
  effectiveDate: Scalars['DateTime'];
  id?: InputMaybe<Scalars['String']>;
  rate: Scalars['Float'];
  taxId?: InputMaybe<Scalars['String']>;
};

export type TaxDetailEntity = {
  __typename?: 'taxDetailEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  effectiveDate: Scalars['DateTime'];
  id: Scalars['String'];
  rate: Scalars['Float'];
  tax: TaxEntity;
  taxId: Scalars['String'];
};

export type TaxDetails = {
  __typename?: 'TaxDetails';
  createdTs: Scalars['DateTime'];
  effectiveDate: Scalars['DateTime'];
  id: Scalars['String'];
  rate: Scalars['Float'];
};

export type TaxDetailsAfterCalculation = {
  seqNo: Scalars['String'];
  taxAmount: Scalars['Float'];
  taxId: Scalars['String'];
  taxRate: Scalars['Float'];
};

export type TaxDropdownOutput = {
  __typename?: 'TaxDropdownOutput';
  classType?: Maybe<TaxClassType>;
  code: Scalars['String'];
  effectiveDate: Scalars['DateTime'];
  rate: Scalars['Float'];
  schemeType?: Maybe<Scalars['String']>;
  schemeTypeId?: Maybe<Scalars['String']>;
  taxId: Scalars['String'];
};

export type TaxEntity = {
  __typename?: 'taxEntity';
  accountId: Scalars['String'];
  classType: Scalars['String'];
  code: Scalars['String'];
  commonStatus: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['String'];
  isClaimable: Scalars['Boolean'];
  schemeType: TaxSchemeTypeEntity;
  schemeTypeId: Scalars['String'];
  taxDetail: Array<TaxDetailEntity>;
  taxExt: TaxExtEntity;
  taxSchemeDetailItem: Array<TaxSchemeDetailItemEntity>;
};

export type TaxExtEntity = {
  __typename?: 'taxExtEntity';
  accountId: Scalars['String'];
  id: Scalars['String'];
  isFinal: Scalars['Boolean'];
  taxId: Scalars['String'];
};

export type TaxLedgerEntity = {
  __typename?: 'taxLedgerEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  progressBilling?: Maybe<ProgressBillingEntity>;
  projectId: Scalars['String'];
  refId: Scalars['String'];
  refTable: Scalars['String'];
  taxAmount: Scalars['Float'];
  taxId: Scalars['String'];
  taxRate: Scalars['Float'];
  taxSchemeDetailId?: Maybe<Scalars['String']>;
  taxSchemeId: Scalars['String'];
};

export type TaxListingOutput = {
  __typename?: 'TaxListingOutput';
  classType: Scalars['String'];
  code: Scalars['String'];
  createdDt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  effectiveDate?: Maybe<Scalars['DateTime']>;
  isExistInMasterData: Array<Scalars['String']>;
  isExistInTransactionData: Array<Scalars['String']>;
  rate?: Maybe<Scalars['String']>;
  schemeTypeId?: Maybe<Scalars['String']>;
  taxId: Scalars['String'];
  taxStatus: Scalars['String'];
};

export type TaxListOutput = {
  __typename?: 'TaxListOutput';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['String'];
  isExclusive: Scalars['Boolean'];
  modTs: Scalars['DateTime'];
  name: Scalars['String'];
};

export type TaxOnSeq = {
  seqNo: Scalars['Float'];
  taxSchemeDetailItemId: Scalars['String'];
};

export type TaxOnSeqInput = {
  seqNo: Scalars['Float'];
  taxSchemeDetailItemId: Scalars['String'];
};

/** JsonType */
export type TaxOnSeqObjects = {
  __typename?: 'taxOnSeqObjects';
  seqNo: Scalars['Float'];
  taxSchemeDetailItemId: Scalars['String'];
};

export type TaxSchemeDetailEntity = {
  __typename?: 'taxSchemeDetailEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  effectiveDate: Scalars['DateTime'];
  id: Scalars['String'];
  taxScheme: TaxSchemeEntity;
  taxSchemeDetailItems?: Maybe<Array<TaxSchemeDetailItemEntity>>;
  taxSchemeId: Scalars['String'];
};

export type TaxSchemeDetailItemEntity = {
  __typename?: 'taxSchemeDetailItemEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  computeMethod: Scalars['String'];
  id: Scalars['String'];
  seqNo?: Maybe<Scalars['Float']>;
  tax: TaxEntity;
  taxId: Scalars['String'];
  taxOnSeq?: Maybe<Array<TaxOnSeqObjects>>;
  taxSchemeDetail: TaxSchemeDetailEntity;
  taxSchemeDetailId: Scalars['String'];
};

export type TaxSchemeDetailItemOutput = {
  __typename?: 'TaxSchemeDetailItemOutput';
  taxCode: Scalars['String'];
  taxId: Scalars['String'];
  taxRate?: Maybe<Scalars['String']>;
};

export type TaxSchemeDropdownOutput = {
  __typename?: 'TaxSchemeDropdownOutput';
  effectiveDate: Scalars['DateTime'];
  isExclusive: Scalars['Boolean'];
  taxSchemeDetailId: Scalars['String'];
  taxSchemeDetailItems?: Maybe<Array<TaxSchemeDetailItemOutput>>;
  taxSchemeId: Scalars['String'];
  taxSchemeName: Scalars['String'];
  totalTaxAmount: Scalars['Float'];
  totalTaxRate?: Maybe<Scalars['String']>;
};

export type TaxSchemeEntity = {
  __typename?: 'taxSchemeEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isExclusive?: Maybe<Scalars['Boolean']>;
  isExistInMasterData: Array<Scalars['String']>;
  isExistInTransactionData: Array<Scalars['String']>;
  name: Scalars['String'];
  taxSchemeDetails?: Maybe<Array<TaxSchemeDetailEntity>>;
};

export type TaxSchemeListingOutput = {
  __typename?: 'TaxSchemeListingOutput';
  lastUpdatedDate?: Maybe<Scalars['DateTime']>;
  schemeType: Scalars['String'];
  schemeTypeId: Scalars['String'];
};

export type TaxSchemeTypeEntity = {
  __typename?: 'taxSchemeTypeEntity';
  code: Scalars['String'];
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  softwareCode: Scalars['String'];
  tax?: Maybe<Array<TaxEntity>>;
};

export type TaxTransactionCodeDetailEntity = {
  __typename?: 'taxTransactionCodeDetailEntity';
  accountId: Scalars['ID'];
  code: Scalars['String'];
  commonStatus: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['ID'];
  taxTransactionCode: TaxTransactionCodeEntity;
  taxTransactionCodeId: Scalars['String'];
  type: Scalars['String'];
};

export type TaxTransactionCodeEntity = {
  __typename?: 'taxTransactionCodeEntity';
  accountId: Scalars['ID'];
  commonStatus: Scalars['String'];
  description: Scalars['String'];
  details?: Maybe<Array<TaxTransactionCodeDetailEntity>>;
  id: Scalars['ID'];
  taxTrxCode: Scalars['String'];
};

export type TeamDetail = {
  __typename?: 'TeamDetail';
  name: Scalars['String'];
  teamId: Scalars['String'];
};

export type TeamInput = {
  name: Scalars['String'];
  projectId: Scalars['String'];
};

export type TeamMember = {
  person_in_charge: Array<Scalars['String']>;
};

/** JsonType */
export type TeamMemberObject = {
  __typename?: 'teamMemberObject';
  person_in_charge: Array<Scalars['String']>;
};

export type TemporaryUploadPurchaser = {
  bookingAttachment?: InputMaybe<Array<Scalars['Upload']>>;
  buyerId: Scalars['String'];
};

export type TemporaryUploadTransferPurchaser = {
  bookingAttachment?: InputMaybe<Array<Scalars['Upload']>>;
  buyerId: Scalars['String'];
};

export type TimeSlotDetail = {
  __typename?: 'timeSlotDetail';
  available: Scalars['Boolean'];
  id: Scalars['String'];
  unitNo?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type TodoCountOutput = {
  __typename?: 'TodoCountOutput';
  total?: Maybe<Scalars['Float']>;
};

export type TodoListOutput = {
  __typename?: 'TodoListOutput';
  projects: Array<TodoOutput>;
  total: Scalars['Float'];
  totalCountTodoList: Scalars['Float'];
};

export type TodoOutput = {
  __typename?: 'TodoOutput';
  count: TodoCountOutput;
  details: ProjectEntity;
};

export enum ToDoStatus {
  Active = 'ACTIVE',
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Closed = 'CLOSED',
  Inactive = 'INACTIVE',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Submit = 'SUBMIT'
}

export type TotpSecretTyes = {
  __typename?: 'TotpSecretTyes';
  dataURL?: Maybe<Scalars['String']>;
  is2FA?: Maybe<Scalars['Boolean']>;
  otpURL?: Maybe<Scalars['String']>;
  totpSecret?: Maybe<Scalars['String']>;
};

export type TownshipDetailsOutput = {
  __typename?: 'TownshipDetailsOutput';
  PICContactNo?: Maybe<Scalars['String']>;
  PICEmail?: Maybe<Scalars['String']>;
  PICName?: Maybe<Scalars['String']>;
  TownshipName: Scalars['String'];
};

export type TownshipEntity = {
  __typename?: 'townshipEntity';
  accountId: Scalars['String'];
  code: Scalars['String'];
  commonStatus: Scalars['String'];
  company: CompanyEntity;
  companyId: Scalars['String'];
  id: Scalars['String'];
  location: Scalars['String'];
  logoUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  projectExt?: Maybe<Array<ProjectExtEntity>>;
  seqNo: Scalars['Float'];
};

export type TransactionMidtransDetailEntity = {
  __typename?: 'transactionMidtransDetailEntity';
  amount: Scalars['Float'];
  billingId: Scalars['String'];
  billingName: Scalars['String'];
  creditId: Scalars['String'];
  debitId: Scalars['String'];
  id: Scalars['String'];
  transactionMidtransId: Scalars['String'];
};

export type TransactionMidtransEntity = {
  __typename?: 'transactionMidtransEntity';
  accountId: Scalars['String'];
  customerDetails: Scalars['JSONObject'];
  grossAmount: Scalars['Float'];
  id: Scalars['String'];
  paymentStatus?: Maybe<Scalars['String']>;
  paymentType?: Maybe<Scalars['String']>;
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  snapToken?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
};

/** Type for payment project */
export enum TypePaymentPlanEnum {
  Carpark = 'Carpark',
  Package = 'Package',
  Purchaser = 'Purchaser'
}

export type Ujpp = {
  __typename?: 'UJPP';
  depositAmount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['String']>;
  landAreaFrom?: Maybe<Scalars['Float']>;
  landAreaTo?: Maybe<Scalars['Float']>;
};

export type UnassignedNotaryOutput = {
  __typename?: 'UnassignedNotaryOutput';
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notaryCode?: Maybe<Scalars['String']>;
  notaryId?: Maybe<Scalars['String']>;
};

export type UnitAndContactListOutput = {
  __typename?: 'unitAndContactListOutput';
  clusterName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  saleId?: Maybe<Scalars['String']>;
  salesRegistrationNo?: Maybe<Scalars['String']>;
  unitId?: Maybe<Scalars['String']>;
  unitNo?: Maybe<Scalars['String']>;
};

export type UnitBookingBalanceOutput = {
  __typename?: 'unitBookingBalanceOutput';
  totalBalance: Scalars['Float'];
};

export type UnitBookingBookingFeeOutput = {
  __typename?: 'unitBookingBookingFeeOutput';
  amount?: Maybe<Scalars['Float']>;
  receiptNo?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  saleId: Scalars['String'];
  salePaymentId: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  transactionDate?: Maybe<Scalars['DateTime']>;
  verificationStatus?: Maybe<Scalars['String']>;
};

export type UnitBookingDetailsOutput = {
  __typename?: 'unitBookingDetailsOutput';
  amount?: Maybe<Scalars['Float']>;
  bookDate: Scalars['DateTime'];
  bookingFee?: Maybe<Scalars['Float']>;
  builtUp?: Maybe<Scalars['Float']>;
  builtUpAreaRate?: Maybe<Scalars['Float']>;
  commercialPurpose: Scalars['String'];
  contactId: Scalars['String'];
  fullName: Scalars['String'];
  homeTel?: Maybe<Scalars['String']>;
  jointBuyerCount?: Maybe<Scalars['Float']>;
  jointBuyers?: Maybe<Array<JointBuyerOutput>>;
  landArea?: Maybe<Scalars['Float']>;
  landAreaRate?: Maybe<Scalars['Float']>;
  nameOnTax?: Maybe<Scalars['String']>;
  officeTel?: Maybe<Scalars['String']>;
  phoneNo?: Maybe<Scalars['String']>;
  professionId?: Maybe<Scalars['String']>;
  projectId: Scalars['String'];
  propertyTypeName: Scalars['String'];
  religionId?: Maybe<Scalars['String']>;
  saleId: Scalars['String'];
  salesNo: Scalars['String'];
  sellingPrice: Scalars['Float'];
  taxRegistrationAddress?: Maybe<Scalars['String']>;
  taxRegistrationNo?: Maybe<Scalars['String']>;
  taxScheme?: Maybe<Scalars['String']>;
  unitClusterId: Scalars['String'];
  unitId: Scalars['String'];
  unitNo: Scalars['String'];
};

export type UnitBookingFeeDetailsAttachmentUploadOutput = {
  __typename?: 'unitBookingFeeDetailsAttachmentUploadOutput';
  contactId: Scalars['String'];
  jointBuyerId: Scalars['String'];
  jointBuyerName: Scalars['String'];
};

export type UnitBookingFeeDetailsOutput = {
  __typename?: 'unitBookingFeeDetailsOutput';
  amount?: Maybe<Scalars['Float']>;
  balance?: Maybe<Array<UnitBookingBalanceOutput>>;
  bookDate: Scalars['DateTime'];
  bookingFee?: Maybe<Scalars['Float']>;
  fullName: Scalars['String'];
  paymentMethod?: Maybe<Scalars['String']>;
  receiptNo?: Maybe<Scalars['String']>;
  refNo?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  saleId: Scalars['String'];
  salePaymentId: Scalars['String'];
  salesNo: Scalars['String'];
  sellingPrice: Scalars['Float'];
  transactionDate?: Maybe<Scalars['DateTime']>;
  unitId: Scalars['String'];
  unitNo: Scalars['String'];
  uploadAttachment?: Maybe<Array<UnitBookingFeeDetailsAttachmentUploadOutput>>;
};

export type UnitBookingFeeListingOutput = {
  __typename?: 'unitBookingFeeListingOutput';
  bookingFeeList?: Maybe<Array<UnitBookingBookingFeeOutput>>;
  saleInfo: UnitBookingListingOutput;
};

export type UnitBookingListingOutput = {
  __typename?: 'unitBookingListingOutput';
  bookDate: Scalars['DateTime'];
  collectedBookingFee?: Maybe<Scalars['Float']>;
  convertedToBooking: Scalars['Boolean'];
  fullName: Scalars['String'];
  jointBuyerCount?: Maybe<Scalars['Float']>;
  pendingBookingFee?: Maybe<Scalars['Float']>;
  projectId: Scalars['String'];
  saleBookingAmount?: Maybe<Scalars['Float']>;
  saleId: Scalars['String'];
  salesConvertedStatus?: Maybe<Scalars['String']>;
  salesNo: Scalars['String'];
  sellingPrice: Scalars['Float'];
  totalBookingFee?: Maybe<Scalars['Float']>;
  unitClusterId: Scalars['String'];
  unitId: Scalars['String'];
  unitNo: Scalars['String'];
};

export type UnitBookingPurchaserDetailsOutput = {
  __typename?: 'unitBookingPurchaserDetailsOutput';
  addressDetail?: Maybe<AddressJson>;
  contactAddresses?: Maybe<Array<Maybe<AddressJson>>>;
  customerOrigin?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  fullName: Scalars['String'];
  gender?: Maybe<Scalars['String']>;
  identityNo: Scalars['String'];
  identityType?: Maybe<Scalars['String']>;
  incomeRange?: Maybe<Scalars['String']>;
  isPrincipalBuyer?: Maybe<Scalars['Boolean']>;
  mailingMethod?: Maybe<Scalars['String']>;
  maritalStatus?: Maybe<Scalars['String']>;
  nameOnTax?: Maybe<Scalars['String']>;
  nationality: Scalars['String'];
  otherContactNumber?: Maybe<Scalars['String']>;
  otherHomeTelNo?: Maybe<Scalars['String']>;
  otherOfficeTelNo?: Maybe<Scalars['String']>;
  profession?: Maybe<Scalars['String']>;
  religion?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
  salutation?: Maybe<Scalars['String']>;
  subscribeMaterialEmail?: Maybe<Scalars['Boolean']>;
  subscribeMaterialPaNews?: Maybe<Scalars['Boolean']>;
  subscribeMaterialSms?: Maybe<Scalars['Boolean']>;
  subscribeMaterialWhatsApp?: Maybe<Scalars['Boolean']>;
  taxRegistrationAddress?: Maybe<Scalars['String']>;
  taxRegistrationNo?: Maybe<Scalars['String']>;
};

export type UnitByStatusOutput = {
  __typename?: 'unitByStatusOutput';
  builtUp?: Maybe<Scalars['Float']>;
  builtUpAreaRate?: Maybe<Scalars['Float']>;
  commercialPurpose: Scalars['String'];
  landArea?: Maybe<Scalars['Float']>;
  landAreaRate?: Maybe<Scalars['Float']>;
  price: Scalars['String'];
  projectId: Scalars['String'];
  propertyTypeName: Scalars['String'];
  unitClusterId: Scalars['String'];
  unitId: Scalars['String'];
  unitNo: Scalars['String'];
  unitStatus: Scalars['String'];
};

export type UnitData = {
  __typename?: 'unitData';
  book_date?: Maybe<Scalars['String']>;
  buyer_name?: Maybe<Scalars['String']>;
  sales_team_name?: Maybe<Scalars['String']>;
  spa_price?: Maybe<Scalars['String']>;
  unit_id?: Maybe<Scalars['String']>;
  unit_no?: Maybe<Scalars['String']>;
};

export type UnitDetailOutput = {
  __typename?: 'unitDetailOutput';
  buyerSolicitorCode?: Maybe<Scalars['String']>;
  buyerSolicitorName?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  isCompany?: Maybe<Scalars['Boolean']>;
  purchaserName?: Maybe<Scalars['String']>;
  unitId?: Maybe<Scalars['String']>;
  unitNo?: Maybe<Scalars['String']>;
};

export type UnitDetailsOutput = {
  __typename?: 'UnitDetailsOutput';
  builtUp?: Maybe<Scalars['Float']>;
  builtUpAreaRate?: Maybe<Scalars['Float']>;
  commercialPurpose?: Maybe<Scalars['String']>;
  isBumi: Scalars['Boolean'];
  landArea?: Maybe<Scalars['String']>;
  landAreaRate?: Maybe<Scalars['Float']>;
  propertyType?: Maybe<Scalars['String']>;
  shareValue?: Maybe<Scalars['Float']>;
  taxSchemeName?: Maybe<Scalars['String']>;
  unitNo?: Maybe<Scalars['String']>;
  uom: Uom;
};

export type UnitEntity = {
  __typename?: 'unitEntity';
  architectCertUnits?: Maybe<Array<ArchitectCertUnitEntity>>;
  block?: Maybe<Scalars['String']>;
  bookingWaitlists?: Maybe<Array<BookingWaitlistEntity>>;
  bottomPrice?: Maybe<Scalars['Float']>;
  builtUp: Scalars['Float'];
  carParks?: Maybe<Array<UnitEntity>>;
  cccDate?: Maybe<Scalars['DateTime']>;
  cell: Scalars['Float'];
  cellLabel?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  events: Array<EventsEntity>;
  extraLandArea?: Maybe<Scalars['Float']>;
  facingDirection?: Maybe<DirectionEntity>;
  facingDirectionId?: Maybe<Scalars['String']>;
  facingView?: Maybe<Scalars['String']>;
  floor?: Maybe<Scalars['Float']>;
  floorLabel?: Maybe<Scalars['String']>;
  floorLayoutUrl?: Maybe<Scalars['String']>;
  getIntegratedProjectCarParkNo?: Maybe<Scalars['String']>;
  hsdNo?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isBumi: Scalars['Boolean'];
  isCccReady: Scalars['Boolean'];
  isFinancialBilling: Scalars['Boolean'];
  isSubProduct: Scalars['Boolean'];
  landArea?: Maybe<Scalars['String']>;
  leads: Array<LeadEntity>;
  leadSelection: Array<LeadEntity>;
  motTracking?: Maybe<Array<MotTrackingEntity>>;
  parentId?: Maybe<Scalars['String']>;
  phase?: Maybe<Scalars['String']>;
  price: Scalars['Float'];
  priceAdjustmentUnit?: Maybe<PriceAdjustmentUnitEntity>;
  project: ProjectEntity;
  projectDetailsUnitLayout?: Maybe<UnitLayoutEntity>;
  projectId: Scalars['String'];
  projectSpec: Array<ProjectSpecEntity>;
  projectTitleUnit?: Maybe<ProjectTitleUnitEntity>;
  propertyType: PropertyTypeEntity;
  ptdNo?: Maybe<Scalars['String']>;
  sales: Array<SaleEntity>;
  salesCharts?: Maybe<SalesChartEntity>;
  saleSubProduct?: Maybe<SaleSubproductEntity>;
  subsaleUnit?: Maybe<SubsaleEntity>;
  timeLock?: Maybe<Scalars['DateTime']>;
  totalSaleCount?: Maybe<Scalars['Float']>;
  unitExt?: Maybe<UnitExtensionEntity>;
  unitIntegration?: Maybe<UnitIntegrationEntity>;
  unitLayout?: Maybe<UnitLayoutEntity>;
  unitLayoutDes?: Maybe<Scalars['String']>;
  unitLayoutId?: Maybe<Scalars['String']>;
  unitLayoutUrl?: Maybe<Scalars['String']>;
  unitLayoutVitualLink?: Maybe<Array<Scalars['String']>>;
  unitLockBy?: Maybe<Scalars['String']>;
  unitNo: Scalars['String'];
  units?: Maybe<UnitEntity>;
  unitStatus: Scalars['String'];
  unitType?: Maybe<UnitTypeEntity>;
  unitTypeId?: Maybe<Scalars['String']>;
  waitingListCount?: Maybe<Scalars['Float']>;
};

export type UnitExcelOutput = {
  __typename?: 'UnitExcelOutput';
  base64: Scalars['String'];
  isSubProduct: Scalars['Boolean'];
  projectname: Scalars['String'];
};

export type UnitExcelReturnOutput = {
  __typename?: 'UnitExcelReturnOutput';
  file?: Maybe<Scalars['String']>;
  file_name: Scalars['String'];
  isSubProduct?: Maybe<Scalars['Boolean']>;
  message: Scalars['String'];
};

export type UnitExtensionEntity = {
  __typename?: 'unitExtensionEntity';
  accountId: Scalars['String'];
  actualBuiltUpArea?: Maybe<Scalars['Float']>;
  actualLandArea?: Maybe<Scalars['Float']>;
  bookingFee?: Maybe<Scalars['Float']>;
  builtUpAreaRate?: Maybe<Scalars['Float']>;
  bumiAllocation?: Maybe<Scalars['Boolean']>;
  bumiReleaseDate?: Maybe<Scalars['DateTime']>;
  bumiReleaseReferenceNo?: Maybe<Scalars['String']>;
  clusterId: Scalars['String'];
  commonStatus: Scalars['String'];
  district?: Maybe<Scalars['String']>;
  dlp1Date?: Maybe<Scalars['DateTime']>;
  dlp2Date?: Maybe<Scalars['DateTime']>;
  dlpExpiryDate?: Maybe<Scalars['DateTime']>;
  extraLandAreaRate?: Maybe<Scalars['Float']>;
  hsdHsmNo?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  landAreaRate?: Maybe<Scalars['Float']>;
  lawyer?: Maybe<SolicitorAppointedEntity>;
  lawyerId?: Maybe<Scalars['String']>;
  leasePejakanNegeri?: Maybe<Scalars['String']>;
  lotPtNo?: Maybe<Scalars['String']>;
  masterGrantNo?: Maybe<Scalars['String']>;
  noOfKey?: Maybe<Scalars['Float']>;
  noOfStorey?: Maybe<Scalars['Float']>;
  paymentPlan?: Maybe<PaymentPlanEntity>;
  paymentPlanId?: Maybe<Scalars['String']>;
  premium?: Maybe<Scalars['String']>;
  projectCluster: ProjectClusterEntity;
  projectId: Scalars['String'];
  remark?: Maybe<Scalars['String']>;
  scheduleLaunchDate?: Maybe<Scalars['DateTime']>;
  shareValue?: Maybe<Scalars['String']>;
  stakeholder?: Maybe<SolicitorAppointedEntity>;
  stakeholderId?: Maybe<Scalars['String']>;
  stampDutyWaiver?: Maybe<Scalars['Boolean']>;
  state?: Maybe<Scalars['String']>;
  subdivisionMukim?: Maybe<Scalars['String']>;
  taxScheme: TaxSchemeEntity;
  taxSchemeId: Scalars['String'];
  unitAddress?: Maybe<AddressJson>;
  unitId: Scalars['String'];
  units: UnitEntity;
  usableArea?: Maybe<Scalars['Float']>;
  vpBillingDate?: Maybe<Scalars['DateTime']>;
  vpLetterDate?: Maybe<Scalars['DateTime']>;
};

export type UnitFinancierDetailOutput = {
  __typename?: 'unitFinancierDetailOutput';
  financier: Scalars['String'];
  financierReference: Scalars['String'];
  loanSeqNo: Scalars['String'];
  solicitor: Scalars['String'];
  solicitorReference: Scalars['String'];
};

export type UnitFloorList = {
  __typename?: 'unitFloorList';
  commonStatus: Scalars['String'];
  isBumi: Scalars['Boolean'];
  unitCell: Scalars['Float'];
  unitFloor: Scalars['Float'];
  unitFloorLabel: Scalars['String'];
  unitId: Scalars['String'];
  unitNo: Scalars['String'];
  unitStatus: Scalars['String'];
};

export type UnitForPaymentPlanDetailsInput = {
  amount: Scalars['Float'];
  sale_id: Scalars['String'];
  sale_loan_id?: InputMaybe<Scalars['String']>;
  sale_loan_payment_plan_id?: InputMaybe<Scalars['String']>;
  sale_loan_refinancing_id?: InputMaybe<Scalars['String']>;
  sale_loan_refinancing_payment_plan_id?: InputMaybe<Scalars['String']>;
  sale_loan_refinancing_retention_id?: InputMaybe<Scalars['String']>;
};

export type UnitGalleryOutput = {
  __typename?: 'UnitGalleryOutput';
  caption?: Maybe<Scalars['String']>;
  desc: Scalars['String'];
  pictureid: Scalars['String'];
  resourceid: Scalars['String'];
  seqno: Scalars['Float'];
  unit_layout_id: Scalars['String'];
  url: Scalars['String'];
  virtualModelLink?: Maybe<Scalars['String']>;
};

export type UnitImportCountOutput = {
  __typename?: 'UnitImportCountOutput';
  agencyUnitCount: Scalars['Float'];
  architectCertCount: Scalars['Float'];
  assignCarparkCount: Scalars['Float'];
  bookingCount: Scalars['Float'];
  bridgingFinancierCount: Scalars['Float'];
  elaunchCount: Scalars['Float'];
  elaunchFavouriteCount: Scalars['Float'];
  leadCount: Scalars['Float'];
  priceAdjustmentCount: Scalars['Float'];
  projectTitleCount: Scalars['Float'];
  saleChartCount: Scalars['Float'];
  salesCount: Scalars['Float'];
  saleSubproductCount: Scalars['Float'];
  saleTeamAllocationCount: Scalars['Float'];
  unitIds: Array<Scalars['String']>;
  unitIntegrationCount: Scalars['Float'];
};

export type UnitImportOptionOutput = {
  __typename?: 'UnitImportOptionOutput';
  append: Scalars['Boolean'];
  displayImportMethods: Scalars['Boolean'];
  emptyProject: Scalars['Boolean'];
  integrated: Scalars['Boolean'];
  modify: Scalars['Boolean'];
  overwrite: Scalars['Boolean'];
  unitIds: Array<Scalars['String']>;
};

export type UnitInfoOutput = {
  __typename?: 'unitInfoOutput';
  builtUp: Scalars['Float'];
  builtUpAreaRate?: Maybe<Scalars['Float']>;
  commercialPurpose: Scalars['String'];
  landArea?: Maybe<Scalars['String']>;
  landAreaRate?: Maybe<Scalars['Float']>;
  propertyType: Scalars['String'];
  taxSchemeId: Scalars['String'];
  taxSchemeName: Scalars['String'];
  unitId: Scalars['String'];
  unitPrice: Scalars['Float'];
};

export type UnitInformationListInput = {
  editValue?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};

export type UnitIntegrationEntity = {
  __typename?: 'unitIntegrationEntity';
  accountId: Scalars['String'];
  accountSpec?: Maybe<AccountSpecEntity>;
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  ifcaBlockId: Scalars['Float'];
  ifcaUnitId: Scalars['Float'];
  projectId: Scalars['String'];
  projectIntegration?: Maybe<ProjectIntegrationEntity>;
  sale?: Maybe<SaleEntity>;
  unit: UnitEntity;
  unitId: Scalars['String'];
  waitingList?: Maybe<BookingWaitlistEntity>;
};

export type UnitLayoutBlockOutput = {
  __typename?: 'UnitLayoutBlockOutput';
  block: Scalars['String'];
  unitLayoutId: Scalars['String'];
};

export type UnitLayoutEntity = {
  __typename?: 'unitLayoutEntity';
  desc: Scalars['String'];
  id: Scalars['String'];
  pictureUnitlayouts: Array<PictureUnitlayoutEntity>;
  project: ProjectEntity;
  projectId: Scalars['String'];
  units: Array<UnitEntity>;
  unitTourVirtualLinks: Array<UnitTourVirtualLinkEntity>;
};

export type UnitList = {
  __typename?: 'unitList';
  financierList?: Maybe<Array<FinancierData>>;
  saleId: Scalars['String'];
  unitNo: Scalars['String'];
};

export type UnitListingOutput = {
  __typename?: 'UnitListingOutput';
  unitId?: Maybe<Scalars['String']>;
  unitNo?: Maybe<Scalars['String']>;
};

export type UnitListOutput = {
  __typename?: 'unitListOutput';
  documentAmount?: Maybe<Scalars['Float']>;
  documentNo: Scalars['String'];
  email: Scalars['String'];
  fullName: Scalars['String'];
  icNo: Scalars['String'];
  miscBillingId?: Maybe<Scalars['String']>;
  oldContactId: Scalars['String'];
  phoneNo: Scalars['String'];
  saleId: Scalars['String'];
  salesConvertedStatus: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  unitClusterId: Scalars['String'];
  unitId: Scalars['String'];
  unitNo: Scalars['String'];
};

export type UnitMasterDataOutput = {
  __typename?: 'unitMasterDataOutput';
  cluster?: Maybe<Array<DropDownDataOutput>>;
  direction?: Maybe<Array<DropDownDataOutput>>;
  paymentPlan?: Maybe<Array<DropDownDataOutput>>;
  propertyType?: Maybe<Array<DropDownDataOutput>>;
  solicitor?: Maybe<Array<DropDownDataOutput>>;
  taxScheme?: Maybe<Array<DropDownDataOutput>>;
  unitLayout?: Maybe<Array<DropDownDataOutput>>;
  unitType?: Maybe<Array<DropDownDataOutput>>;
};

export type UnitMortgageOutput = {
  __typename?: 'UnitMortgageOutput';
  financierList?: Maybe<Array<FinancierUnitMortgage>>;
  unitId: Scalars['String'];
  unitNo: Scalars['String'];
  unitPrice: Scalars['Float'];
};

export type UnitOfMeasurementEntity = AuditEntity & {
  __typename?: 'unitOfMeasurementEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['ID'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  uom: Scalars['String'];
};

export type UnitOfMeasurementMutationInput = {
  description: Scalars['String'];
  uom: Scalars['String'];
};

export type UnitOfMeasurementMutationOutput = {
  __typename?: 'unitOfMeasurementMutationOutput';
  description: Scalars['String'];
  id: Scalars['ID'];
  uom: Scalars['String'];
};

export type UnitRegistrationDetailsOutput = {
  __typename?: 'UnitRegistrationDetailsOutput';
  builtUp?: Maybe<Scalars['Float']>;
  builtUpAreaRate?: Maybe<Scalars['Float']>;
  commercialPurpose?: Maybe<Scalars['String']>;
  isBumi: Scalars['Boolean'];
  landArea?: Maybe<Scalars['String']>;
  landAreaRate?: Maybe<Scalars['Float']>;
  propertyType?: Maybe<Scalars['String']>;
  shareValue?: Maybe<Scalars['Float']>;
  taxSchemeName?: Maybe<Scalars['String']>;
  unitNo?: Maybe<Scalars['String']>;
  uom: Uom;
};

export type UnitsSignedOutput = {
  __typename?: 'unitsSignedOutput';
  bookDate?: Maybe<Scalars['DateTime']>;
  buyBackAmt?: Maybe<Scalars['Float']>;
  companyName?: Maybe<Scalars['String']>;
  contactId: Scalars['String'];
  finalTaxToDate?: Maybe<Scalars['Float']>;
  isCompany?: Maybe<Scalars['Boolean']>;
  paidToDate?: Maybe<Scalars['Float']>;
  purchaserName: Scalars['String'];
  saleCancellationId: Scalars['String'];
  saleId: Scalars['String'];
  salesRegistrationDate?: Maybe<Scalars['DateTime']>;
  saleStatus: Scalars['String'];
  sellingPrice?: Maybe<Scalars['Float']>;
  taxSchemeId?: Maybe<Scalars['String']>;
  taxToDate?: Maybe<Scalars['Float']>;
  totalRefundableAmount?: Maybe<Scalars['Float']>;
  unitId: Scalars['String'];
  unitNo: Scalars['String'];
  unitStatus: Scalars['String'];
};

export type UnitStatutoryByDocTypeOutput = {
  __typename?: 'unitStatutoryByDocTypeOutput';
  clusterName: Scalars['String'];
  documents: Array<SalesStatutoryObject>;
  fullName: Scalars['String'];
  saleId: Scalars['String'];
  totalNeedToBeUpload: Scalars['Float'];
  totalUploaded: Scalars['Float'];
  unitId: Scalars['String'];
  unitNo: Scalars['String'];
  unitStatutoryDocId: Scalars['String'];
};

export type UnitStatutoryDocument = {
  docCnt: Scalars['Float'];
  projectId: Scalars['String'];
  statutoryDocId: Scalars['String'];
  unitId: Scalars['String'];
};

export type UnitStatutoryDocumentEntity = {
  __typename?: 'unitStatutoryDocumentEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  docCnt: Scalars['Float'];
  id: Scalars['String'];
  projectId: Scalars['String'];
  statutoryDocId: Scalars['String'];
  unitId: Scalars['String'];
};

export type UnitStatutoryDocumentOutput = {
  __typename?: 'unitStatutoryDocumentOutput';
  clusterName?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  docCnt: Scalars['Float'];
  id: Scalars['String'];
  statutoryDocCode?: Maybe<Scalars['String']>;
  statutoryDocId?: Maybe<Scalars['String']>;
  statutoryDocName?: Maybe<Scalars['String']>;
  unitId: Scalars['String'];
  unitNo?: Maybe<Scalars['String']>;
};

export type UnitStatutoryListByUnitSelectionOutput = {
  __typename?: 'unitStatutoryListByUnitSelectionOutput';
  clusterName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  unitId: Scalars['String'];
  unitNo: Scalars['String'];
  unitStatutoryId: Scalars['String'];
};

export type UnitStatutoryListDropDownOutput = {
  __typename?: 'unitStatutoryListDropDownOutput';
  clusterName?: Maybe<Scalars['String']>;
  unitId: Scalars['String'];
  unitNo: Scalars['String'];
};

export type UnitStatutoryListObject = {
  __typename?: 'unitStatutoryListObject';
  contactId?: Maybe<Scalars['String']>;
  documents: Array<SalesStatutoryObject>;
  fullName?: Maybe<Scalars['String']>;
  perSalesContract?: Maybe<Scalars['Boolean']>;
  projectId: Scalars['String'];
  saleId?: Maybe<Scalars['String']>;
  totalNeedToBeUpload: Scalars['Float'];
  totalUploaded: Scalars['Float'];
  unitClusterId: Scalars['String'];
  unitId: Scalars['String'];
  unitNo?: Maybe<Scalars['String']>;
  unitStatutoryId: Scalars['String'];
};

export type UnitSummaryInfo = {
  __typename?: 'unitSummaryInfo';
  area: Scalars['String'];
  propertyType: Scalars['String'];
  sellingPrice: Scalars['Float'];
  uom: Scalars['String'];
};

export type UnitsVpLetterInput = {
  unitIds: Array<Scalars['String']>;
  vpLetterDate: Scalars['DateTime'];
};

export type UnitTansferDiscountInput = {
  discardBumi: Scalars['Boolean'];
  discounts?: InputMaybe<Array<UnitTransferDiscountListingInput>>;
};

export type UnitTourVirtualLinkEntity = {
  __typename?: 'unitTourVirtualLinkEntity';
  block: Scalars['String'];
  id: Scalars['String'];
  projectId: Scalars['String'];
  seqNo: Scalars['Float'];
  unitLayout: UnitLayoutEntity;
  unitLayoutId?: Maybe<Scalars['String']>;
  unitType: UnitTypeEntity;
  unitTypeId?: Maybe<Scalars['String']>;
  virtualModelLink: Scalars['String'];
};

export type UnitTourVirtualOutput = {
  __typename?: 'unitTourVirtualOutput';
  block: Scalars['String'];
  tourId: Scalars['String'];
  unitLayoutId?: Maybe<Scalars['String']>;
  unitLayoutName?: Maybe<Scalars['String']>;
  unitTypeId?: Maybe<Scalars['String']>;
  unitTypeName?: Maybe<Scalars['String']>;
  virtualModelLink: Scalars['String'];
};

export type UnitTranserIndoEntity = {
  __typename?: 'unitTranserIndoEntity';
  accountId: Scalars['String'];
  adminFee: Scalars['Float'];
  approvalStatus?: Maybe<Scalars['String']>;
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  cancelReasonId: Scalars['String'];
  documentNo?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  miscBillId: Scalars['String'];
  newSaleId: Scalars['String'];
  oldAllocationAmt: Scalars['Float'];
  oldOutstandingAmt: Scalars['Float'];
  oldSaleId: Scalars['String'];
  projectId: Scalars['String'];
  transferDate: Scalars['DateTime'];
};

export type UnitTransferDetailOutput = {
  __typename?: 'unitTransferDetailOutput';
  administrationCharges?: Maybe<Scalars['Float']>;
  approvalRoleId?: Maybe<Scalars['String']>;
  builtUp?: Maybe<Scalars['Float']>;
  builtUpArea?: Maybe<Scalars['Float']>;
  builtUpAreaRate?: Maybe<Scalars['Float']>;
  companyName?: Maybe<Scalars['String']>;
  companyRegNo?: Maybe<Scalars['String']>;
  discardBumiDiscount?: Maybe<Scalars['Boolean']>;
  extraLandArea?: Maybe<Scalars['Float']>;
  extraLandAreaRate?: Maybe<Scalars['Float']>;
  fullName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  isCompany?: Maybe<Scalars['Boolean']>;
  landArea?: Maybe<Scalars['Float']>;
  landAreaRate?: Maybe<Scalars['Float']>;
  newBuiltUp?: Maybe<Scalars['Float']>;
  newBuiltUpArea?: Maybe<Scalars['Float']>;
  newBuiltUpAreaRate?: Maybe<Scalars['Float']>;
  newDiscount?: Maybe<NewDiscount>;
  newExtraLandArea?: Maybe<Scalars['Float']>;
  newExtraLandAreaRate?: Maybe<Scalars['Float']>;
  newLandArea?: Maybe<Scalars['Float']>;
  newLandAreaRate?: Maybe<Scalars['Float']>;
  newListPrice: Scalars['Float'];
  newSellingPrice: Scalars['Float'];
  newUnitId: Scalars['String'];
  newUnitNo?: Maybe<Scalars['String']>;
  oldSaleDetail?: Maybe<OldUnitSaleDetail>;
  oldUnitId?: Maybe<Scalars['String']>;
  oldUnitNo: Scalars['String'];
  paymentMethod?: Maybe<Scalars['String']>;
  paymentPlanId?: Maybe<Scalars['String']>;
  paymentPlanName?: Maybe<Scalars['String']>;
  phoneNo: Scalars['String'];
  reason: Scalars['String'];
  remark?: Maybe<Scalars['String']>;
  saleId: Scalars['String'];
  sellingPrice?: Maybe<Scalars['Float']>;
  transferDate: Scalars['DateTime'];
};

export type UnitTransferDiscountListingInput = {
  amount: Scalars['Float'];
  discountId: Scalars['String'];
  discountMethod?: InputMaybe<Scalars['String']>;
  formula?: InputMaybe<Scalars['String']>;
  seqNo: Scalars['Float'];
  title: Scalars['String'];
};

export type UnitTransferDiscounts = {
  discountAmount: Scalars['Float'];
  seq?: InputMaybe<Scalars['Float']>;
};

export type UnitTransferDropdownOutput = {
  __typename?: 'unitTransferDropdownOutput';
  builtUp?: Maybe<Scalars['Float']>;
  builtUpArea?: Maybe<Scalars['Float']>;
  builtUpAreaRate?: Maybe<Scalars['Float']>;
  companyName?: Maybe<Scalars['String']>;
  companyRegNo?: Maybe<Scalars['String']>;
  discardBumiDiscount?: Maybe<Scalars['Boolean']>;
  discountList?: Maybe<Array<DiscountDetail>>;
  extraLandArea?: Maybe<Scalars['Float']>;
  extraLandAreaRate?: Maybe<Scalars['Float']>;
  fullName?: Maybe<Scalars['String']>;
  isCompany?: Maybe<Scalars['Boolean']>;
  landArea?: Maybe<Scalars['Float']>;
  landAreaRate?: Maybe<Scalars['Float']>;
  listPrice?: Maybe<Scalars['Float']>;
  nricNo?: Maybe<Scalars['String']>;
  paymentPlanId?: Maybe<Scalars['String']>;
  paymentPlanName?: Maybe<Scalars['String']>;
  phoneNo?: Maybe<Scalars['String']>;
  saleId?: Maybe<Scalars['String']>;
  sellingPrice?: Maybe<Scalars['Float']>;
  unitId: Scalars['String'];
  unitNo: Scalars['String'];
};

export type UnitTransferEditDiscountOutput = {
  __typename?: 'UnitTransferEditDiscountOutput';
  discountAmount: Scalars['Float'];
  discountID: Scalars['String'];
  discountMethod: Scalars['String'];
  formula: Scalars['String'];
  title: Scalars['String'];
};

export type UnitTransferEntity = AuditEntity & {
  __typename?: 'unitTransferEntity';
  accountId: Scalars['String'];
  administrationCharges: Scalars['Float'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  discount?: Maybe<DiscountObject>;
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  newListPrice: Scalars['Float'];
  newSellingPrice: Scalars['Float'];
  newUnitId: Scalars['String'];
  oldSaleDetail?: Maybe<OldSaleDetail>;
  oldSellingPrice?: Maybe<Scalars['Float']>;
  oldUnitId: Scalars['String'];
  paymentMethod: Scalars['String'];
  paymentPlanId: Scalars['String'];
  projectId: Scalars['String'];
  reason: Scalars['String'];
  remark: Scalars['String'];
  saleId: Scalars['String'];
  status: Scalars['String'];
  transferDate: Scalars['DateTime'];
};

export type UnitTransferIndoByUnitIdOutput = {
  __typename?: 'unitTransferIndoByUnitIdOutput';
  accountId: Scalars['String'];
  adminFee: Scalars['Float'];
  carPark: Array<Scalars['JSONObject']>;
  discounts: Array<UnitTransferEditDiscountOutput>;
  fromUnit: UnitTransferIndoFromUnitDropdown;
  id: Scalars['String'];
  jointBuyer: Array<ContactEntity>;
  mainBuyer: ContactEntity;
  mainBuyerId: Scalars['String'];
  miscBillId: Scalars['String'];
  newUnitId: Scalars['String'];
  oldSaleId: Scalars['String'];
  others: Scalars['JSONObject'];
  saleId: Scalars['String'];
  salePackage: Array<Scalars['JSONObject']>;
  salesPaymentPlan: Array<Scalars['JSONObject']>;
  taxRate: Scalars['Float'];
  taxSchema: TaxSchemeEntity;
  taxSchemeId: Scalars['String'];
  totalAllocateAmt: Scalars['Float'];
  toUnit: UnitTransferIndoUnitDropdown;
  transferDate: Scalars['DateTime'];
  transferReason: Scalars['String'];
};

export type UnitTransferIndoCountOutput = {
  __typename?: 'unitTransferIndoCountOutput';
  completedCount?: Maybe<Scalars['Float']>;
  openCount?: Maybe<Scalars['Float']>;
};

export type UnitTransferIndoDetails = {
  __typename?: 'UnitTransferIndoDetails';
  adminFee: Scalars['String'];
  approvedBy: Scalars['String'];
  approvedDate: Scalars['DateTime'];
  attachment?: Maybe<Array<Scalars['JSONObject']>>;
  id: Scalars['String'];
  mainBuyer: Scalars['String'];
  newSaleId: Scalars['String'];
  newUnitNo: Scalars['String'];
  oldUnitNo: Scalars['String'];
  projectId: Scalars['String'];
  reason: Scalars['String'];
  salesPaymentPlan?: Maybe<Array<Scalars['JSONObject']>>;
  status: Scalars['String'];
  transferDate: Scalars['DateTime'];
};

export type UnitTransferIndoDropdownOutput = {
  __typename?: 'unitTransferIndoDropdownOutput';
  builtUpArea?: Maybe<Scalars['Float']>;
  fullName?: Maybe<Scalars['String']>;
  listPrice?: Maybe<Scalars['Float']>;
  saleId: Scalars['String'];
  unitId: Scalars['String'];
  unitNo: Scalars['String'];
};

export type UnitTransferIndoFromUnitDropdown = {
  __typename?: 'unitTransferIndoFromUnitDropdown';
  additionalPackages: Array<SalePackageEntity>;
  adminFee?: Maybe<Scalars['Float']>;
  billItemType?: Maybe<Scalars['String']>;
  builtUp: Scalars['Float'];
  builtUpAreaRate?: Maybe<Scalars['Float']>;
  commercialPurpose: Scalars['String'];
  contactId: Scalars['String'];
  landArea?: Maybe<Scalars['String']>;
  landAreaRate?: Maybe<Scalars['Float']>;
  listPrice: Scalars['Float'];
  mainBuyer: ContactEntity;
  miscBillId: Scalars['String'];
  projectId: Scalars['String'];
  propertyType: Scalars['String'];
  purchaserName?: Maybe<Scalars['String']>;
  saleId: Scalars['String'];
  saleRegDate?: Maybe<Scalars['DateTime']>;
  taxSchemeId?: Maybe<Scalars['String']>;
  taxSchemeName?: Maybe<Scalars['String']>;
  totalAllocateAmt: Scalars['Float'];
  totalUnallocateAmt: Scalars['Float'];
  unitClusterId: Scalars['String'];
  unitId: Scalars['String'];
  unitNo: Scalars['String'];
};

export type UnitTransferIndoMasterDataOutput = {
  __typename?: 'unitTransferIndoMasterDataOutput';
  fromUnit?: Maybe<Array<UnitTransferIndoFromUnitDropdown>>;
  paymentPlans?: Maybe<Array<UnitTransferPaymentPlan>>;
  toUnit?: Maybe<Array<UnitTransferIndoUnitDropdown>>;
  transferReason?: Maybe<Array<ReasonCodeEntity>>;
};

export type UnitTransferIndoOutput = {
  __typename?: 'UnitTransferIndoOutput';
  cancelReason: Scalars['String'];
  id: Scalars['String'];
  mainBuyer: Scalars['String'];
  newUnitClusterId: Scalars['String'];
  newUnitId: Scalars['String'];
  newUnitNo: Scalars['String'];
  oldUnitClusterId: Scalars['String'];
  oldUnitId: Scalars['String'];
  oldUnitNo: Scalars['String'];
  projectId: Scalars['String'];
  status: Scalars['String'];
  transferDate: Scalars['DateTime'];
};

export type UnitTransferIndoUnitDropdown = {
  __typename?: 'unitTransferIndoUnitDropdown';
  builtUp: Scalars['Float'];
  builtUpAreaRate?: Maybe<Scalars['Float']>;
  commercialPurpose: Scalars['String'];
  landArea?: Maybe<Scalars['String']>;
  landAreaRate?: Maybe<Scalars['Float']>;
  listPrice: Scalars['Float'];
  projectId: Scalars['String'];
  propertyType: Scalars['String'];
  purchaserName?: Maybe<Scalars['String']>;
  saleId: Scalars['String'];
  saleRegDate?: Maybe<Scalars['DateTime']>;
  taxSchemeId?: Maybe<Scalars['String']>;
  taxSchemeName?: Maybe<Scalars['String']>;
  totalAllocateAmt?: Maybe<Scalars['Float']>;
  unitClusterId: Scalars['String'];
  unitId: Scalars['String'];
  unitNo: Scalars['String'];
};

export type UnitTransferInfoLine = {
  __typename?: 'unitTransferInfoLine';
  totalDraft?: Maybe<Scalars['Float']>;
  totalSubmitted?: Maybe<Scalars['Float']>;
};

export type UnitTransferOldSaleDetailInput = {
  discounts?: InputMaybe<Array<UnitTransferDiscountListingInput>>;
};

export type UnitTransferPaymentPlan = {
  __typename?: 'UnitTransferPaymentPlan';
  id: Scalars['String'];
  markUpPercentage: Scalars['Float'];
  name: Scalars['String'];
  projectPaymentPlan: Scalars['String'];
  projectPlanEndDate: Scalars['DateTime'];
  projectPlanStartDate: Scalars['DateTime'];
};

export type UnitTransferUnitTaxField = {
  __typename?: 'UnitTransferUnitTaxField';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type UnitTypeCountByStatusOutput = {
  __typename?: 'UnitTypeCountByStatusOutput';
  availableUnitCount: Scalars['Float'];
  bookUnitCount: Scalars['Float'];
  reservationUnitCount?: Maybe<Scalars['Float']>;
  signUnitCount: Scalars['Float'];
  soldUnitCount: Scalars['Float'];
  totalUnitCount: Scalars['Float'];
  unavailableUnitCount: Scalars['Float'];
  unitType: Scalars['String'];
};

export type UnitTypeDetail = {
  __typename?: 'UnitTypeDetail';
  name: Scalars['String'];
  unitTypeId: Scalars['String'];
};

export type UnitTypeEntity = {
  __typename?: 'unitTypeEntity';
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  defaulted: Scalars['Boolean'];
  id: Scalars['String'];
  isDeletable: Scalars['Boolean'];
  isExistInMasterData: Array<Scalars['String']>;
  isExistInTransactionData: Array<Scalars['String']>;
  name: Scalars['String'];
  seq_no?: Maybe<Scalars['Float']>;
  units: Array<UnitEntity>;
  unitTourVirtualLinks: Array<UnitTourVirtualLinkEntity>;
};

export type UnitTypeInput = {
  name: Scalars['String'];
};

export type UnitTypeOutput = {
  __typename?: 'unitTypeOutput';
  builtUp?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type UnitViewLogEntity = {
  __typename?: 'unitViewLogEntity';
  accountId: Scalars['String'];
  block: Scalars['String'];
  id: Scalars['String'];
  ipAddress?: Maybe<Scalars['String']>;
  leftTime?: Maybe<Scalars['DateTime']>;
  projectId: Scalars['String'];
  socketId?: Maybe<Scalars['String']>;
  softwareCode: Scalars['String'];
  unitId: Scalars['String'];
  userId: Scalars['String'];
  visitTime: Scalars['DateTime'];
};

export enum Uom {
  DescriptionList = 'DescriptionList',
  GetDescription = 'GetDescription',
  SqFeet = 'SQ_FEET',
  SqMeter = 'SQ_METER'
}

export type UpdateAuditInput = {
  modBy?: InputMaybe<Scalars['String']>;
};

export type UpdateJointBuyerSeqInput = {
  ID: Array<Scalars['String']>;
};

export type UpdatePaCollectionActivityInput = {
  activityRemark: Scalars['String'];
  id: Scalars['String'];
  saleId: Scalars['String'];
};

export type UpdatePasswordInput = {
  currentPassword?: InputMaybe<Scalars['String']>;
  newPassword: Scalars['String'];
};

export type UpdatePaymentLateInterestDetailInput = {
  description: Scalars['String'];
  documentAmount: Scalars['Float'];
  lateInterestId: Scalars['String'];
};

export type UpdatePaymentLateInterestInput = {
  creditTerm: Scalars['Float'];
  detail: Array<UpdatePaymentLateInterestDetailInput>;
  documentDate: Scalars['DateTime'];
  generateId: Scalars['String'];
};

export type UpdatePbStatusInput = {
  progressBillingId: Scalars['String'];
  saleId: Scalars['String'];
};

export type UpdateSaleLoanApprovalFormInput = {
  approvalStatus: Scalars['String'];
  approveAmount: Scalars['Float'];
  borrowerAcct?: InputMaybe<Scalars['String']>;
  borrowerName?: InputMaybe<Scalars['String']>;
  constructionDate: Scalars['DateTime'];
  description: Scalars['String'];
  endfinancierMortgagePlanId: Scalars['String'];
  financierId: Scalars['String'];
  financierRef: Scalars['String'];
  isDiffrentialRescheduled?: InputMaybe<Scalars['Boolean']>;
  loanInterestMonth?: InputMaybe<Scalars['Float']>;
  loanInterestRate?: InputMaybe<Scalars['Float']>;
  loanPeriod?: InputMaybe<Scalars['Float']>;
  paymentPlan?: InputMaybe<Array<PaymentPlan>>;
  saleLoanId: Scalars['String'];
};

export type UpdateSaleLoanApprovalInput = {
  approvalStatus: Scalars['String'];
  saleLoanId: Scalars['String'];
};

export type UpdateSnpSigned = {
  sale_id: Scalars['String'];
  signed_date?: InputMaybe<Scalars['DateTime']>;
};

export type UpdateSnpStamped = {
  attachments?: InputMaybe<Array<Scalars['Upload']>>;
  sale_id: Scalars['String'];
  stampDate?: InputMaybe<Scalars['DateTime']>;
};

export type UpdateStampDutyInput = {
  code: Scalars['String'];
  deleteData: DeleteDataInput;
  description: Scalars['String'];
  details: Array<DetailInputForUpdate>;
  id: Scalars['String'];
};

export type UpdateStampDutyIntegrationInput = {
  extension: Scalars['String'];
  id: Scalars['String'];
  projectLetterTemplateId: Scalars['String'];
  stampDutyId: Scalars['String'];
  type: Scalars['String'];
};

export type UpdateStatusCancellationInput = {
  file?: InputMaybe<Array<Scalars['Upload']>>;
  id: Scalars['String'];
  remark: Scalars['String'];
  unitId: Scalars['String'];
};

export type UpdateStatusOverduePurchaseCaInput = {
  activityRemark: Scalars['String'];
  id: Scalars['String'];
};

export type UploadStatutoryReturnOutput = {
  __typename?: 'uploadStatutoryReturnOutput';
  message: Scalars['String'];
};

export type UserAndRoleCount = {
  __typename?: 'userAndRoleCount';
  activeUser?: Maybe<Scalars['Float']>;
  availableUser?: Maybe<Scalars['String']>;
  rolesCount?: Maybe<Scalars['Float']>;
  totalUser?: Maybe<Scalars['String']>;
};

export type UserChangePasswordInput = {
  confirmPassword: Scalars['String'];
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
};

export type UserContactInput = {
  avatar?: InputMaybe<Scalars['Upload']>;
  name: Scalars['String'];
  phoneNo: Scalars['String'];
};

export type UserEntity = {
  __typename?: 'UserEntity';
  accountID: Scalars['String'];
  address?: Maybe<Address>;
  avatar?: Maybe<Scalars['String']>;
  blockCount: Scalars['Float'];
  blockDuration: Scalars['Float'];
  commonStatus: CommonStatus;
  confirmed: Scalars['Boolean'];
  contactNo: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  department?: Maybe<Scalars['String']>;
  deviceIP?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  ID: Scalars['String'];
  is2FA?: Maybe<Scalars['Boolean']>;
  isActivated: Scalars['Boolean'];
  isSuspendible: Scalars['Boolean'];
  jobTitle?: Maybe<Scalars['String']>;
  lastestAccessedEntity?: Maybe<Scalars['String']>;
  loginAttempt: Scalars['Float'];
  loginTs?: Maybe<Scalars['DateTime']>;
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
  softwareCode: Scalars['String'];
  superUser: Scalars['Boolean'];
  userFeaturePermission: UserFeaturePermissionEntity;
  userName?: Maybe<Scalars['String']>;
};

export type UserFeaturePermissionEntity = AuditEntity & {
  __typename?: 'userFeaturePermissionEntity';
  accountId: Scalars['String'];
  allowGlobalBI: Scalars['Boolean'];
  allowOpenlead: Scalars['Boolean'];
  allowOpenLeadRoundRobin: Scalars['Boolean'];
  allowPropertyAgency: Scalars['Boolean'];
  allowRoundRobin: Scalars['Boolean'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  notificationHistory: Scalars['Float'];
  userId: Scalars['String'];
};

export type UserInput = {
  address?: InputMaybe<AddressInput>;
  avatar?: InputMaybe<Scalars['String']>;
  commonStatus?: InputMaybe<CommonStatus>;
  contactNo: Scalars['String'];
  department?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  hashed?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['String']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
  superUser?: InputMaybe<Scalars['Boolean']>;
  userName?: InputMaybe<Scalars['String']>;
};

export type UserList = {
  __typename?: 'userList';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type UserLoginOutput = {
  __typename?: 'userLoginOutput';
  accessToken: Scalars['String'];
  checkExpire: Scalars['Boolean'];
  user: UserResponse;
};

export type UserNotificationSettingEntity = {
  __typename?: 'userNotificationSettingEntity';
  accountId: Scalars['String'];
  id: Scalars['String'];
  permissionId: Scalars['Float'];
  userId: Scalars['String'];
};

export type UserOutput = {
  __typename?: 'UserOutput';
  email?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  phoneNo?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
};

export type UserResponse = AuditEntity & {
  __typename?: 'UserResponse';
  accountID: Scalars['String'];
  address?: Maybe<Address>;
  avatar?: Maybe<Scalars['String']>;
  blockCount?: Maybe<Scalars['Float']>;
  blockDuration?: Maybe<Scalars['Float']>;
  commonStatus: CommonStatus;
  confirmed: Scalars['Boolean'];
  contactNo: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  department?: Maybe<Scalars['String']>;
  deviceIP?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  errors?: Maybe<Array<FieldError>>;
  ID: Scalars['String'];
  is2FA?: Maybe<Scalars['Boolean']>;
  jobTitle?: Maybe<Scalars['String']>;
  lastestAccessedEntity?: Maybe<Scalars['String']>;
  loginAttempt?: Maybe<Scalars['Float']>;
  loginTs?: Maybe<Scalars['DateTime']>;
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  name: Scalars['String'];
  password?: Maybe<Scalars['String']>;
  superUser: Scalars['Boolean'];
  userName: Scalars['String'];
};

export type UserRoleAssignmentInput = {
  roleId: Scalars['String'];
  userIds: Array<Scalars['String']>;
};

export type VacantPossessionOutput = {
  __typename?: 'VacantPossessionOutput';
  unitIndex?: Maybe<Scalars['String']>;
  vpLetterCount?: Maybe<Scalars['Float']>;
  vpLetterDate?: Maybe<Scalars['DateTime']>;
};

export type VacantPossessionUnitsOutput = {
  __typename?: 'VacantPossessionUnitsOutput';
  unitNo: Scalars['String'];
  vpLetterDate?: Maybe<Scalars['DateTime']>;
};

export type ViewTaxDetailsOutput = {
  __typename?: 'ViewTaxDetailsOutput';
  classType: TaxClassType;
  code: Scalars['String'];
  description: Scalars['String'];
  taxDetail: Array<TaxDetails>;
};

export type VpUnitListingOutput = {
  __typename?: 'VPUnitListingOutput';
  unitNo?: Maybe<Scalars['String']>;
};

export type WaitingListBiCount = {
  __typename?: 'WaitingListBICount';
  cancelled: Scalars['Float'];
  converted: Scalars['Float'];
  total_waiting: Scalars['Float'];
};

export type WaitingListByDirection = {
  __typename?: 'WaitingListByDirection';
  count: Scalars['Float'];
  direction?: Maybe<Scalars['String']>;
  directionId?: Maybe<Scalars['String']>;
};

export type WaitingListByUnitType = {
  __typename?: 'WaitingListByUnitType';
  count: Scalars['Float'];
  unit_layout: Scalars['String'];
  unit_layout_id: Scalars['String'];
  unit_type: Scalars['String'];
  unit_type_id: Scalars['String'];
};

export type WaitingListByUnitTypeOutput = {
  __typename?: 'WaitingListByUnitTypeOutput';
  totalCount?: Maybe<Scalars['Float']>;
  unit_type: Scalars['String'];
  WaitingListByUnitType?: Maybe<Array<WaitingListByUnitType>>;
};

export type WaitingListByView = {
  __typename?: 'WaitingListByView';
  count: Scalars['Float'];
  view?: Maybe<Scalars['String']>;
};

export type WaitingListTableOutput = {
  __typename?: 'WaitingListTableOutput';
  count?: Maybe<Scalars['Float']>;
  unit_no: Scalars['String'];
  waitingListTableType?: Maybe<Array<WaitingListTableType>>;
};

export type WaitingListTableType = {
  __typename?: 'WaitingListTableType';
  no_of_unit?: Maybe<Scalars['Float']>;
  sales_by: Scalars['String'];
  unit_no: Scalars['String'];
};

export type WeeklyBookChartCountOutput = {
  __typename?: 'weeklyBookChartCountOutput';
  bookedCount: Scalars['Float'];
  cancelBookCount: Scalars['Float'];
  cumulativeCount: Scalars['Float'];
  end_week?: Maybe<Scalars['String']>;
  start_week?: Maybe<Scalars['String']>;
  start_week_alt: Scalars['DateTime'];
};

export type WeeklyChartCount = {
  __typename?: 'weeklyChartCount';
  cumulativeCount: Scalars['Float'];
  endWeek?: Maybe<Scalars['DateTime']>;
  startWeek?: Maybe<Scalars['DateTime']>;
  weeklyCount: Scalars['Float'];
};

export type WeeklySignChartCountOutput = {
  __typename?: 'weeklySignChartCountOutput';
  cancelSignCount: Scalars['Float'];
  cumulativeCount: Scalars['Float'];
  end_week?: Maybe<Scalars['String']>;
  signedCount: Scalars['Float'];
  start_week?: Maybe<Scalars['String']>;
  start_week_alt: Scalars['DateTime'];
};

export type WithdrawnLoanStatusOutput = {
  __typename?: 'WithdrawnLoanStatusOutput';
  count: Scalars['Float'];
  customerCancelledCount: Scalars['Float'];
  customerRejectedCount: Scalars['Float'];
  developerCancelledCount: Scalars['Float'];
  loanRejectedCount: Scalars['Float'];
};

export type WorkdeskNotificationEntity = AuditEntity & {
  __typename?: 'workdeskNotificationEntity';
  accountId: Scalars['String'];
  body: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  permissionId: Scalars['Float'];
  projectId: Scalars['String'];
  subject: Scalars['String'];
  wdNotificationRecipient: Array<WorkdeskNotificationRecipientEntity>;
};

export type WorkdeskNotificationRecipientEntity = AuditEntity & {
  __typename?: 'workdeskNotificationRecipientEntity';
  accountId: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  isRead: Scalars['Boolean'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  notificationId: Scalars['String'];
  projectId: Scalars['String'];
  recipientId: Scalars['String'];
  workdeskNotification: WorkdeskNotificationEntity;
};

export type WorkDeskProjectListOutput = {
  __typename?: 'WorkDeskProjectListOutput';
  projectCount?: Maybe<Scalars['Float']>;
  projects?: Maybe<Array<WorkDeskProjectOutput>>;
  totalUnread?: Maybe<Scalars['Float']>;
};

export type WorkDeskProjectOutput = {
  __typename?: 'WorkDeskProjectOutput';
  firstGalleryImageUrl?: Maybe<Scalars['String']>;
  newAppointment?: Maybe<Scalars['Float']>;
  newAssignment?: Maybe<Scalars['Float']>;
  newBooking?: Maybe<Scalars['Float']>;
  others?: Maybe<Scalars['Float']>;
  projectId: Scalars['String'];
  projectName: Scalars['String'];
  unReadNotification?: Maybe<Scalars['Float']>;
};

export type WorkFlowApprovedStepEntity = AuditEntity & {
  __typename?: 'workFlowApprovedStepEntity';
  accountId: Scalars['String'];
  approvalDate: Scalars['DateTime'];
  approvalRoleId: Scalars['String'];
  approvalStatus: Scalars['String'];
  approverId: Scalars['String'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  notifiedDate: Scalars['DateTime'];
  statusRemark?: Maybe<Scalars['String']>;
  workFlowStepId: Scalars['String'];
};

export type WorkFlowEntity = AuditEntity & {
  __typename?: 'workFlowEntity';
  accountId: Scalars['String'];
  approvalPolicyAssignmentId: Scalars['String'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  entityId: Scalars['String'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  refId: Scalars['String'];
  refTable: Scalars['String'];
  submitDate: Scalars['DateTime'];
  submitterId: Scalars['String'];
  workFlowStatus: Scalars['String'];
};

export type WorkFlowStepEntity = AuditEntity & {
  __typename?: 'workFlowStepEntity';
  accountId: Scalars['String'];
  approvalRoleId: Scalars['String'];
  approvalStatus: Scalars['String'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  id: Scalars['String'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  notifiedDate: Scalars['DateTime'];
  statusRemark?: Maybe<Scalars['String']>;
  stepNo: Scalars['Float'];
  workFlowId: Scalars['String'];
};

export type WorkProgressEntity = {
  __typename?: 'workProgressEntity';
  accountId: Scalars['String'];
  archCert: Array<ArchitectCertWorkProgressEntity>;
  commonStatus: Scalars['String'];
  id: Scalars['String'];
  isCarPark: Scalars['Boolean'];
  isExistInMasterData: Array<Scalars['String']>;
  isExistInTransactionData: Array<Scalars['String']>;
  isSystemUse: Scalars['Boolean'];
  isVp: Scalars['Boolean'];
  name: Scalars['String'];
  paymentPlanDetail: Array<PaymentPlanDetailEntity>;
  salePackage?: Maybe<Array<SalePackageEntity>>;
  saleRebatePackage?: Maybe<Array<SaleRebatePackageEntity>>;
  systemUse: Scalars['Boolean'];
};

export type WorkProgressInput = {
  isCarPark?: InputMaybe<Scalars['Boolean']>;
  isVp?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
};

export type GetAccessSecuritySummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAccessSecuritySummaryQuery = { __typename?: 'Query', userLastUpdate?: any | null, passwordPolicyLastUpdate?: any | null, roleLastUpdate?: any | null };

export type GetPasswordPolicyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPasswordPolicyQuery = { __typename?: 'Query', getPasswordPolicy?: { __typename?: 'passwordPolicyEntity', id: string, requiredMinNoCharacter?: number | null, requiredUpperLowerCase: boolean, requiredDigit: boolean, requiredSpecialCharacter: boolean, passwordResetByDay?: number | null, notAllowReusePasswordForLast?: number | null } | null };

export type GetPasswordPolicyWithoutAuthQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPasswordPolicyWithoutAuthQuery = { __typename?: 'Query', getPasswordPolicyWithoutAuth?: { __typename?: 'passwordPolicyEntity', id: string, requiredMinNoCharacter?: number | null, requiredUpperLowerCase: boolean, requiredDigit: boolean, requiredSpecialCharacter: boolean, passwordResetByDay?: number | null, notAllowReusePasswordForLast?: number | null } | null };

export type AddPasswordPolicyMutationVariables = Exact<{
  input: PasswordPolicyInput;
}>;


export type AddPasswordPolicyMutation = { __typename?: 'Mutation', addPasswordPolicy: boolean };

export type EditPasswordPolicyMutationVariables = Exact<{
  input: PasswordPolicyInput;
}>;


export type EditPasswordPolicyMutation = { __typename?: 'Mutation', editPasswordPolicy: boolean };

export type GetRolesQueryVariables = Exact<{
  projectId?: InputMaybe<Scalars['String']>;
}>;


export type GetRolesQuery = { __typename?: 'Query', getRoles: Array<{ __typename?: 'roleEntity', name: string, id: string, softwareCode: string, salesAndReportPermission: Array<string>, isDeletable: boolean, users?: Array<{ __typename?: 'UserEntity', userName?: string | null, ID: string, name?: string | null, superUser: boolean }> | null }> };

export type GetRoleByIdQueryVariables = Exact<{
  roleId: Scalars['String'];
  projectId?: InputMaybe<Scalars['String']>;
}>;


export type GetRoleByIdQuery = { __typename?: 'Query', getRoleById: { __typename?: 'roleEntity', name: string, id: string, softwareCode: string, salesAndReportPermissionIds: Array<string>, salesAndReportPermission: Array<string>, isDeletable: boolean, users?: Array<{ __typename?: 'UserEntity', name?: string | null, userName?: string | null, ID: string }> | null } };

export type GetPermissionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPermissionQuery = { __typename?: 'Query', getPermission: any };

export type GetPermissionKeyByRoleIdQueryVariables = Exact<{
  roleId: Scalars['String'];
}>;


export type GetPermissionKeyByRoleIdQuery = { __typename?: 'Query', getPermissionKeyByRoleId: Array<string> };

export type GetTotalPermissionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTotalPermissionQuery = { __typename?: 'Query', getTotalPermission: number };

export type RoleAssignmentMutationVariables = Exact<{
  input: ProjectUserRoleAssignmentInput;
}>;


export type RoleAssignmentMutation = { __typename?: 'Mutation', roleAssignment: boolean };

export type SalesTestPermissionQueryVariables = Exact<{
  salesPerm: SalesAdminPermission;
}>;


export type SalesTestPermissionQuery = { __typename?: 'Query', salesTestPermission: string };

export type NewRoleMutationVariables = Exact<{
  input: NewAccessRoleInput;
}>;


export type NewRoleMutation = { __typename?: 'Mutation', newRole: boolean };

export type EditRoleMutationVariables = Exact<{
  input: EditAccessRoleInput;
}>;


export type EditRoleMutation = { __typename?: 'Mutation', editRole: boolean };

export type DeleteRoleMutationVariables = Exact<{
  roleId: Scalars['String'];
}>;


export type DeleteRoleMutation = { __typename?: 'Mutation', deleteRole: boolean };

export type UserListingQueryVariables = Exact<{
  activeUserOnly?: InputMaybe<Scalars['Boolean']>;
  isSuperUser?: InputMaybe<Scalars['Boolean']>;
  activeStatus?: InputMaybe<Scalars['String']>;
}>;


export type UserListingQuery = { __typename?: 'Query', userListing: Array<{ __typename?: 'UserEntity', ID: string, userName?: string | null, email: string, contactNo: string, name?: string | null, jobTitle?: string | null, department?: string | null, superUser: boolean, commonStatus: CommonStatus, confirmed: boolean, isActivated: boolean, isSuspendible: boolean, userFeaturePermission: { __typename?: 'userFeaturePermissionEntity', userId: string, allowOpenlead: boolean, allowPropertyAgency: boolean } }> };

export type GetUserDetailsQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type GetUserDetailsQuery = { __typename?: 'Query', getUserDetails: { __typename?: 'UserEntity', ID: string, userName?: string | null, email: string, contactNo: string, name?: string | null, jobTitle?: string | null, department?: string | null, superUser: boolean, commonStatus: CommonStatus, confirmed: boolean, isActivated: boolean, isSuspendible: boolean, userFeaturePermission: { __typename?: 'userFeaturePermissionEntity', userId: string, allowOpenlead: boolean, allowPropertyAgency: boolean } } };

export type AddUserMutationVariables = Exact<{
  input: NewUserInput;
}>;


export type AddUserMutation = { __typename?: 'Mutation', addUser: boolean };

export type EditUserMutationVariables = Exact<{
  input: EditUserInput;
}>;


export type EditUserMutation = { __typename?: 'Mutation', editUser: boolean };

export type SuspendUserMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type SuspendUserMutation = { __typename?: 'Mutation', suspendUser: boolean };

export type UnSuspendUserMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type UnSuspendUserMutation = { __typename?: 'Mutation', unSuspendUser: boolean };

export type UnblockUserMutationVariables = Exact<{
  newPassword: Scalars['String'];
  confirmPassword: Scalars['String'];
  userId: Scalars['String'];
}>;


export type UnblockUserMutation = { __typename?: 'Mutation', unblockUser: boolean };

export type ChangePasswordMutationVariables = Exact<{
  input: UserChangePasswordInput;
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changePassword: boolean };

export type IsAllowAddUserQueryVariables = Exact<{ [key: string]: never; }>;


export type IsAllowAddUserQuery = { __typename?: 'Query', isAllowAddUser: boolean };

export type ResendInvitationMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type ResendInvitationMutation = { __typename?: 'Mutation', resendInvitation: boolean };

export type GetUserProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserProfileQuery = { __typename?: 'Query', profile: { __typename?: 'UserEntity', ID: string, accountID: string, name?: string | null, email: string, avatar?: string | null, contactNo: string, department?: string | null, jobTitle?: string | null, lastestAccessedEntity?: string | null, superUser: boolean } };

export type AccountNameQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountNameQuery = { __typename?: 'Query', getAccountName: string };

export type ForgotPasswordMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type ForgotPasswordMutation = { __typename?: 'Mutation', forgotPassword: boolean };

export type GetAppAccessTokenQueryVariables = Exact<{
  appName: Scalars['String'];
}>;


export type GetAppAccessTokenQuery = { __typename?: 'Query', getAppAccessToken: string };

export type GlAccountCodeQueryVariables = Exact<{
  companyId: Scalars['String'];
}>;


export type GlAccountCodeQuery = { __typename?: 'Query', glAccountCode: Array<{ __typename?: 'accountMappingListProps', id?: string | null, name?: string | null, table?: string | null, glType?: GlAccountTypeEnum | null, glAccountId?: string | null, glAccountCode?: string | null }> };

export type GlEndFinancierListQueryVariables = Exact<{
  companyId: Scalars['String'];
}>;


export type GlEndFinancierListQuery = { __typename?: 'Query', glEndFinancierList: Array<{ __typename?: 'endFinancierDataOutput', financierName?: string | null, endfinName?: string | null, endFinPaymentPlans?: Array<{ __typename?: 'endFinPaymentPlan', id?: string | null, name?: string | null, table?: string | null, glType?: string | null, glAccountId?: string | null, glAccountCode?: string | null }> | null }> };

export type GetAvailableCompanyListQueryVariables = Exact<{
  companyId: Scalars['String'];
}>;


export type GetAvailableCompanyListQuery = { __typename?: 'Query', getAvailableCompanyList: Array<{ __typename?: 'availableCopyCompanyListProp', id: string, name: string }> };

export type UpdateGlAccountMappingMutationVariables = Exact<{
  input: AccountMappingInput;
}>;


export type UpdateGlAccountMappingMutation = { __typename?: 'Mutation', updateGlAccountMapping: boolean };

export type CopyGlAccountMutationVariables = Exact<{
  companyId: Scalars['String'];
  copyCompanyId: Scalars['String'];
}>;


export type CopyGlAccountMutation = { __typename?: 'Mutation', copyGlAccount: boolean };

export type GetExportPreviewGlDataQueryVariables = Exact<{
  companyId: Scalars['String'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
}>;


export type GetExportPreviewGlDataQuery = { __typename?: 'Query', getExportPreviewGLData?: Array<{ __typename?: 'glExportDataOutput', glType: string, glTransactionType: string, glAccountCode: string, costCentre: string, journalType: string, documentDate: any, documentNo: string, refTable: string, refId: string, refDescription?: string | null, debitAmount: number, creditAmount: number, taxId?: string | null, glAccountId: string }> | null };

export type CreateGlExportMutationVariables = Exact<{
  input: GlExportInput;
}>;


export type CreateGlExportMutation = { __typename?: 'Mutation', createGLExport: { __typename?: 'glJournalPostStatus', postStatus: boolean, base64?: string | null, fileName?: string | null } };

export type GetGlExportListingQueryVariables = Exact<{
  companyId: Scalars['String'];
}>;


export type GetGlExportListingQuery = { __typename?: 'Query', getGLExportListing?: Array<{ __typename?: 'glExportListingOutput', startDate: any, endDate: any, transactionCount: number, glDate: any, generationBatch: string, documentNo: Array<string> }> | null };

export type GetGlDetailByGenerationBatchQueryVariables = Exact<{
  companyId: Scalars['String'];
  generationBatch: Scalars['String'];
}>;


export type GetGlDetailByGenerationBatchQuery = { __typename?: 'Query', getGLDetailByGenerationBatch?: Array<{ __typename?: 'glExportEntity', glDate: any, glType: string, glTransactionType: string, glAccountCode: string, refDocumentDate: any, refDocumentNo: string, refDescription?: string | null, debitAmount: number, creditAmount: number }> | null };

export type ExportGlJournalQueryVariables = Exact<{
  companyId: Scalars['String'];
  generationBatch: Scalars['String'];
}>;


export type ExportGlJournalQuery = { __typename?: 'Query', exportGLJournal: { __typename?: 'glJournalDownloadProps', base64?: string | null, fileName?: string | null } };

export type GetAllAreaVarianceIndonesiaQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllAreaVarianceIndonesiaQuery = { __typename?: 'Query', getAllAreaVarianceIndonesia: Array<{ __typename?: 'areaVarianceEntity', actualBuiltUp: number, actualLandArea: number, builtUp: number, commonStatus: string, compensateAmount: number, documentNo?: string | null, formula: string, id: string, landArea: number, refId?: string | null, refTable?: string | null, saleId: string, sales?: { __typename?: 'saleEntity', unitId: string, unit: { __typename?: 'unitEntity', id: string, unitNo: string } } | null }> };

export type GetAreaVarianceByIdIndonesiaQueryVariables = Exact<{
  areaVarianceId: Scalars['String'];
}>;


export type GetAreaVarianceByIdIndonesiaQuery = { __typename?: 'Query', getAreaVarianceByIdIndonesia: { __typename?: 'areaVarianceEntity', actualBuiltUp: number, actualLandArea: number, builtUp: number, commonStatus: string, compensateAmount: number, documentNo?: string | null, formula: string, id: string, landArea: number, refId?: string | null, refTable?: string | null, saleId: string, unitData?: { __typename?: 'areaVarianceUnitOutput', builtUp?: number | null, id?: string | null, landArea?: number | null, price?: number | null, saleId?: string | null, unitNo?: string | null, unitStatus?: string | null } | null } };

export type AddAreaVarianceIndonesiaMutationVariables = Exact<{
  input: AreaVarianceInputIndonesia;
}>;


export type AddAreaVarianceIndonesiaMutation = { __typename?: 'Mutation', addAreaVarianceIndonesia: boolean };

export type EditAreaVarianceIndonesiaMutationVariables = Exact<{
  input: EditAreaVarianceIndonesiaInput;
}>;


export type EditAreaVarianceIndonesiaMutation = { __typename?: 'Mutation', editAreaVarianceIndonesia: boolean };

export type GetUnitAtAreaVarianceQueryVariables = Exact<{
  unitId: Scalars['String'];
}>;


export type GetUnitAtAreaVarianceQuery = { __typename?: 'Query', getUnitAtAreaVariance: { __typename?: 'areaVarianceUnitOutput', id?: string | null, unitNo?: string | null, unitStatus?: string | null, price?: number | null, builtUp?: number | null, landArea?: number | null, saleId?: string | null } };

export type GetUnitListAtAreaVarianceQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetUnitListAtAreaVarianceQuery = { __typename?: 'Query', getUnitListAtAreaVariance: Array<{ __typename?: 'areaVarianceUnitOutput', builtUp?: number | null, id?: string | null, landArea?: number | null, price?: number | null, saleId?: string | null, unitNo?: string | null, unitStatus?: string | null }> };

export type GetAreaVarianceSettingSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAreaVarianceSettingSummaryQuery = { __typename?: 'Query', areaVarianceIndonesiaLastUpdate?: any | null, areaVariancePolicyIndonesiaLastUpdate?: any | null };

export type GenerateBillingAreaVarianceMutationVariables = Exact<{
  areaVarianceId: Scalars['String'];
  unitId: Scalars['String'];
}>;


export type GenerateBillingAreaVarianceMutation = { __typename?: 'Mutation', generateBillingAreaVariance: boolean };

export type ReversalAreaVarianceMutationVariables = Exact<{
  areaVarianceId: Scalars['String'];
  refId: Scalars['String'];
}>;


export type ReversalAreaVarianceMutation = { __typename?: 'Mutation', reversalAreaVariance: boolean };

export type GetAllProjectAreaVarianceIndonesiaQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllProjectAreaVarianceIndonesiaQuery = { __typename?: 'Query', getAllProjectAreaVarianceIndonesia?: Array<{ __typename?: 'projectAreaVarianceEntity', id: string, accountId: string, projectId: string, name: string, effectiveDate: any, formula?: string | null }> | null };

export type GetProjectAreaVarianceByEffectiveDateQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProjectAreaVarianceByEffectiveDateQuery = { __typename?: 'Query', getProjectAreaVarianceByEffectiveDate?: { __typename?: 'projectAreaVarianceEntity', id: string, name: string, effectiveDate: any, formula?: string | null } | null };

export type AddProjectAreaVarianceIndonesiaMutationVariables = Exact<{
  input: AddProjectAreaVarianceInputIndonesia;
}>;


export type AddProjectAreaVarianceIndonesiaMutation = { __typename?: 'Mutation', addProjectAreaVarianceIndonesia: boolean };

export type EditProjectAreaVarianceIndonesiaMutationVariables = Exact<{
  input: EditProjectAreaVarianceInputIndonesia;
}>;


export type EditProjectAreaVarianceIndonesiaMutation = { __typename?: 'Mutation', editProjectAreaVarianceIndonesia: boolean };

export type DeleteProjectAreaVarianceMutationVariables = Exact<{
  projectAreaVarianceId: Scalars['String'];
}>;


export type DeleteProjectAreaVarianceMutation = { __typename?: 'Mutation', deleteProjectAreaVarianceIndonesiaById: boolean };

export type LoginMutationVariables = Exact<{
  Password: Scalars['String'];
  LoginId: Scalars['String'];
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'userLoginOutput', accessToken: string, checkExpire: boolean, user: { __typename?: 'UserResponse', name: string, lastestAccessedEntity?: string | null } } };

export type LogoutWithMicrosoftQueryVariables = Exact<{ [key: string]: never; }>;


export type LogoutWithMicrosoftQuery = { __typename?: 'Query', logoutWithMicrosoft: boolean };

export type ProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfileQuery = { __typename?: 'Query', getUserRole?: string | null, profile: { __typename?: 'UserEntity', ID: string, accountID: string, name?: string | null, userName?: string | null, email: string, avatar?: string | null, contactNo: string, department?: string | null, jobTitle?: string | null, lastestAccessedEntity?: string | null, superUser: boolean } };

export type GetCurrentUserRoleIdQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserRoleIdQuery = { __typename?: 'Query', getUserRole?: string | null };

export type GetUserRoleIdsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserRoleIdsQuery = { __typename?: 'Query', getUserRoleIds: any };

export type CheckFirstTimeUserPasswordTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckFirstTimeUserPasswordTokenQuery = { __typename?: 'Query', checkFirstTimeUserPasswordToken: boolean };

export type UpdateNewPasswordMutationVariables = Exact<{
  input: UpdatePasswordInput;
}>;


export type UpdateNewPasswordMutation = { __typename?: 'Mutation', updateNewPassword: boolean };

export type ActivateUserMutationVariables = Exact<{
  input: UpdatePasswordInput;
}>;


export type ActivateUserMutation = { __typename?: 'Mutation', activateUser: boolean };

export type ResetPasswordMutationVariables = Exact<{
  input: UpdatePasswordInput;
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: boolean };

export type UpdateProfileMutationVariables = Exact<{
  input: UserContactInput;
}>;


export type UpdateProfileMutation = { __typename?: 'Mutation', updateProfile: boolean };

export type LoginWithMicrosoftMutationVariables = Exact<{
  ssoToken: Scalars['String'];
  microsoftEmail: Scalars['String'];
}>;


export type LoginWithMicrosoftMutation = { __typename?: 'Mutation', loginWithMicrosoft: { __typename?: 'userLoginOutput', accessToken: string, checkExpire: boolean, user: { __typename?: 'UserResponse', name: string, lastestAccessedEntity?: string | null } } };

export type GetCountryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCountryQuery = { __typename?: 'Query', getCountry: Array<{ __typename?: 'CountryMasterDataOutput', name: string, ID: string }> };

export type GetStateByCountryQueryVariables = Exact<{
  countryId: Scalars['String'];
}>;


export type GetStateByCountryQuery = { __typename?: 'Query', getStateByCountry: Array<{ __typename?: 'StateMasterDataOutput', name: string, ID: string }> };

export type GetCityByStateQueryVariables = Exact<{
  stateId: Scalars['String'];
}>;


export type GetCityByStateQuery = { __typename?: 'Query', getCityByState: Array<{ __typename?: 'CityMasterDataOutput', ID: string, name: string }> };

export type GetPostCodeByCityQueryVariables = Exact<{
  cityId: Scalars['String'];
}>;


export type GetPostCodeByCityQuery = { __typename?: 'Query', getPostCodeByCity: Array<{ __typename?: 'PostCodeMasterDataOutput', ID: string, postcode: string }> };

export type GetAllReceiptByFinancierQueryVariables = Exact<{
  status: Scalars['String'];
}>;


export type GetAllReceiptByFinancierQuery = { __typename?: 'Query', getAllReceiptByFinancier: Array<{ __typename?: 'bankPaymentListingOutput', status: string, generationBatchId: string, financierName: string, generationBatchDate: any, receiptDate: any, documentRef: string, totalDocumentAmount: number, financierId: string, financierCode?: string | null, receiptList?: Array<{ __typename?: 'receiptOutputList', salesId: string, creditId: string, debitId?: Array<string> | null, allocationId?: Array<string> | null }> | null }> };

export type GetBankPaymentMasterDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBankPaymentMasterDataQuery = { __typename?: 'Query', getBankPaymentMasterData?: { __typename?: 'financierBankListOutput', financierList?: Array<{ __typename?: 'financierList', financierId: string, financierName: string, financierCode?: string | null }> | null, bankList?: Array<{ __typename?: 'bankAccountList', bankAccountCode: string, bankAccountId: string, bankAccountNo: string, bankProfileId: string, bankProfileName: string, currency: string, isSelected: boolean }> | null } | null };

export type DeleteBankPaymentByIdMutationVariables = Exact<{
  generationBatchId: Scalars['String'];
}>;


export type DeleteBankPaymentByIdMutation = { __typename?: 'Mutation', deleteBankPaymentById: boolean };

export type RejectApproveReceiptMutationVariables = Exact<{
  input: ApproveBankPaymentInput;
}>;


export type RejectApproveReceiptMutation = { __typename?: 'Mutation', rejectApproveReceipt: boolean };

export type CreateBankPaymentMutationVariables = Exact<{
  input: AddBankPaymentInput;
}>;


export type CreateBankPaymentMutation = { __typename?: 'Mutation', createBankPayment: boolean };

export type EditBankPaymentMutationVariables = Exact<{
  input: EditBankPaymentInput;
}>;


export type EditBankPaymentMutation = { __typename?: 'Mutation', editBankPayment: boolean };

export type GetBillingListingByFinancierIdQueryVariables = Exact<{
  financierId: Scalars['String'];
  generationBatchId?: InputMaybe<Scalars['String']>;
}>;


export type GetBillingListingByFinancierIdQuery = { __typename?: 'Query', getBillingListingByFinancierId?: { __typename?: 'billingListingOutput', financierId?: string | null, documentDate?: any | null, refNo?: string | null, documentNo?: string | null, description?: string | null, bankAccountId?: string | null, financierDetail?: Array<{ __typename?: 'endFinancierDetailListing', creditId?: string | null, debitId: string, debitRefTable: string, creditRefTable: string, pbDocumentAmount: number, pbDescription: string, currentAllocate: number, financialBillingId: string, financierCode?: string | null, documentNo: string, saleId: string, unitId: string, unitNo: string, outstandingBalance: number, buyerName: string }> | null } | null };

export type EndFinancingSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type EndFinancingSummaryQuery = { __typename?: 'Query', endFinancingSummary?: { __typename?: 'endFinancingInfoLine', totalDraft?: number | null, totalSubmitted?: number | null } | null };

export type GetReceiptBillingByGenerationBatchIdQueryVariables = Exact<{
  generationBatchId: Scalars['String'];
}>;


export type GetReceiptBillingByGenerationBatchIdQuery = { __typename?: 'Query', getReceiptBillingByGenerationBatchId: { __typename?: 'financierPaymentBillingOutput', financierName: string, totalDocAmt: number, docDate: any, docRef?: string | null, description?: string | null, bankAccount: string, receiptIds: Array<string>, status: string, allocateDetail?: Array<{ __typename?: 'financierPaymentAllocateDetailOutput', docNo?: string | null, allocateAmt?: number | null, docDate?: string | null, docRef?: string | null, unitNo: string }> | null, getBankPaymentAttachment?: Array<{ __typename?: 'attachmentEntity', id: string, mediaType: string, resourceUrl: string, fileName: string }> | null } };

export type GetAllReceiptByGenerationBatchIdQueryVariables = Exact<{
  generationBatchId: Scalars['String'];
}>;


export type GetAllReceiptByGenerationBatchIdQuery = { __typename?: 'Query', getAllReceiptByGenerationBatchId: { __typename?: 'allLoanPaymentMainOutput', totalDocAmt: number, docDate: any, docRef?: string | null, description?: string | null, bankAccount: string, financierName: string, generationBatchId: string, allowReversal: boolean, receiptList: Array<{ __typename?: 'allLoanPaymentOutput', receiptId: string, docAmt: number, unitNo: string, docNo: string, docDate: string, allowReversal: boolean, allocateDetail: Array<{ __typename?: 'allLoanPaymentAllocationOutput', docNo?: string | null, allocateAmt?: number | null, docDate?: string | null, description?: string | null }> }>, getReceiptAttachmentByBatch?: Array<{ __typename?: 'attachmentEntity', id: string, mediaType: string, resourceUrl: string, fileName: string }> | null } };

export type ReversalBankPaymentMutationVariables = Exact<{
  input: ReversalBankPaymentInput;
}>;


export type ReversalBankPaymentMutation = { __typename?: 'Mutation', reversalBankPayment: boolean };

export type GetAllSaleLoanQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllSaleLoanQuery = { __typename?: 'Query', getAllSaleLoan: Array<{ __typename?: 'saleLoanEntity', id: string, saleId: string, financierId: string, financierReference?: string | null, solicitorId?: string | null, solicitorReference?: string | null, borrowerName?: string | null, loanLooDate?: any | null, loanPeriod?: number | null, loanAmount?: number | null, loanPercentage?: number | null, gstFinanceByBank?: boolean | null, taxSchemeId?: string | null, totalLoanAmount?: number | null, loanSeqno?: number | null, loanLimit?: number | null, remark?: string | null, renoticeDate?: any | null, rrDate?: any | null, rrSolicitorId?: string | null, rrSolicitorReferenceNo?: string | null, borrowerAddress?: { __typename?: 'AddressJson', address?: string | null } | null, sale?: { __typename?: 'saleEntity', id: string, unitId: string } | null, financiers?: Array<{ __typename?: 'financierEntity', id: string, logoUrl?: string | null }> | null }> };

export type GetSaleLoanListingQueryVariables = Exact<{
  status: Scalars['String'];
}>;


export type GetSaleLoanListingQuery = { __typename?: 'Query', getSaleLoanListing?: Array<{ __typename?: 'saleLoanListingOutput', saleId: string, totalAmount: number, totalPercentage: number, unitNo: string, renoticeDate?: any | null, cancelDate?: any | null, cancellationStatus?: string | null, generationBatchId?: string | null, financierList?: Array<{ __typename?: 'financier', id?: string | null, financierLogo?: string | null, financierCode?: string | null, financierName?: string | null }> | null }> | null };

export type GetSaleLoanByGenerationIdQueryVariables = Exact<{
  generationId: Scalars['String'];
  projectID: Scalars['String'];
}>;


export type GetSaleLoanByGenerationIdQuery = { __typename?: 'Query', getSaleLoanByGenerationId: { __typename?: 'saleLoanDetailOutput', generationBatchId?: string | null, generationBatchDate?: any | null, saleId: string, unitNo: string, purchaserName?: string | null, isCompany?: boolean | null, companyName?: string | null, sellingPrice: number, loanLimit: number, otherLoan: number, renoticeDate?: any | null, taxSchemeId: string, spaDate: any, looDate: any, financierDetail?: Array<{ __typename?: 'saleLoanEndFinancierOutput', endFinancierId: string, endFinRefNo: string, solicitorId: string, solicitorRefNo: string, borrowerName: string, loanPeriod?: number | null, loanSequence: number, loanAmount: number, remark: string, taxSchemeId: string, saleLoanId: string, saleId: string, solicitorName: string, solicitorCode?: string | null, financierName: string, financierLogo?: string | null, loanLooDate: any, loanApprovalDate?: any | null, loanSignDate?: any | null, loanPercent: number, loanLimit: number, sellingPrice: number, borrowerAddress: { __typename?: 'AddressJson', address?: string | null, country?: string | null, city?: string | null, state?: string | null, postCode?: string | null } }> | null } };

export type GetSaleLoanUnitQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSaleLoanUnitQuery = { __typename?: 'Query', getSaleLoanUnit: Array<{ __typename?: 'saleLoanOutput', saleId: string, salesStatus: string, spaDate: any, sellingPrice?: number | null, unitId: string, unitNo: string, contactId: string, fullName: string, propertyTypeName: string, taxSchemeId?: string | null, propertyType: string, isCashBuyer?: boolean | null, isCompany?: boolean | null, companyName?: string | null }> };

export type AddSaleLoanMutationVariables = Exact<{
  input: AddSaleLoanInput;
}>;


export type AddSaleLoanMutation = { __typename?: 'Mutation', addSaleLoan: boolean };

export type AddSaleLoanEndFinMutationVariables = Exact<{
  input: AddSaleLoanDetailInput;
}>;


export type AddSaleLoanEndFinMutation = { __typename?: 'Mutation', addSaleLoanEndFin: boolean };

export type EditSaleLoanEndFinMutationVariables = Exact<{
  input: EditSaleLoanDetailInput;
}>;


export type EditSaleLoanEndFinMutation = { __typename?: 'Mutation', editSaleLoanEndFin: boolean };

export type RenoticeLoanApplicationMutationVariables = Exact<{
  input: LoanAppRenotice;
}>;


export type RenoticeLoanApplicationMutation = { __typename?: 'Mutation', renoticeLoanApplication: boolean };

export type DeleteSaleLoanMutationVariables = Exact<{
  input: DeleteSaleLoanInput;
}>;


export type DeleteSaleLoanMutation = { __typename?: 'Mutation', deleteSaleLoan: boolean };

export type GetBankLoansSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBankLoansSummaryQuery = { __typename?: 'Query', totalLoanAppliedCount?: number | null, totalLoanApprovedCount?: number | null, totalLoanSettledCount?: number | null, totalLoanAppliedAmount?: number | null };

export type GetLoanApprovalCountQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetLoanApprovalCountQuery = { __typename?: 'Query', getLoanApprovalCount: { __typename?: 'LoanApprovalCountOutput', draftCount?: number | null, submittedCount?: number | null, approvedCount?: number | null } };

export type GetSaleLoanCancellationListingQueryVariables = Exact<{
  status: Scalars['String'];
}>;


export type GetSaleLoanCancellationListingQuery = { __typename?: 'Query', getSaleLoanCancellationListing?: Array<{ __typename?: 'getSaleLoanListingOutput', saleId: string, id: string, approvalRoleId?: string | null, unitNo: string, cancelDate: any, cancelReason: string, approvalStatus: string }> | null };

export type GetSaleLoanCancellationByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetSaleLoanCancellationByIdQuery = { __typename?: 'Query', getSaleLoanCancellationById?: { __typename?: 'getSaleLoanCancellationDetailOutput', saleId: string, saleLoanCancellationId: string, spaDate?: any | null, unitNo: string, purchaserName: string, companyName?: string | null, isCompany?: boolean | null, cancelDate: any, cancelReason: string, cancelRemark?: string | null, financierDetails?: Array<{ __typename?: 'saleLoanFinancierOutput', financierName: string, financierCode?: string | null, solicitorName: string, solicitorCode?: string | null }> | null } | null };

export type GetSaleLoanCancellationDropdownQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSaleLoanCancellationDropdownQuery = { __typename?: 'Query', getSaleLoanCancellationDropdown?: Array<{ __typename?: 'getSaleLoanCancellationDropdownOutput', saleId: string, unitNo: string, purchaserName: string, isCompany?: boolean | null, companyName?: string | null, spaDate?: any | null, financierDetails?: Array<{ __typename?: 'saleLoanFinancierOutput', financierName: string, financierCode?: string | null, solicitorName: string, solicitorCode?: string | null }> | null }> | null };

export type AddSaleLoanCancellationMutationVariables = Exact<{
  input: AddSaleLoanCancellationInput;
}>;


export type AddSaleLoanCancellationMutation = { __typename?: 'Mutation', addSaleLoanCancellation: boolean };

export type EditSaleLoanCancellationMutationVariables = Exact<{
  input: EditSaleLoanCancellationInput;
}>;


export type EditSaleLoanCancellationMutation = { __typename?: 'Mutation', editSaleLoanCancellation: boolean };

export type DeleteSaleLoanCancellationMutationVariables = Exact<{
  saleLoanCancellationId: Scalars['String'];
}>;


export type DeleteSaleLoanCancellationMutation = { __typename?: 'Mutation', deleteSaleLoanCancellation: boolean };

export type ApproveSaleLoanCancellationMutationVariables = Exact<{
  saleLoanCancellationIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type ApproveSaleLoanCancellationMutation = { __typename?: 'Mutation', approveSaleLoanCancellation: boolean };

export type RejectSaleLoanCancellationMutationVariables = Exact<{
  saleLoanCancellationIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type RejectSaleLoanCancellationMutation = { __typename?: 'Mutation', rejectSaleLoanCancellation: boolean };

export type LoanCancellationSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type LoanCancellationSummaryQuery = { __typename?: 'Query', loanCancellationSummary?: { __typename?: 'saleLoanCancellationInfoLine', totalDraft?: number | null, totalSubmitted?: number | null } | null };

export type GetLoanSettlementListingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLoanSettlementListingQuery = { __typename?: 'Query', getLoanSettlementListing: Array<{ __typename?: 'loanSettlementListingOutput', saleId: string, rrDate?: any | null, purchaserName?: string | null, unitNo: string, companyName?: string | null, isCompany?: boolean | null, financierList?: Array<{ __typename?: 'loanSettlementFinanciers', id: string, financierName: string, financierCode?: string | null }> | null }> };

export type GetLoanSettlementByIdQueryVariables = Exact<{
  saleId?: InputMaybe<Scalars['String']>;
}>;


export type GetLoanSettlementByIdQuery = { __typename?: 'Query', getLoanSettlementById: { __typename?: 'loanSettlementDetailOutput', saleId: string, unitNo: string, purchaserName?: string | null, companyName?: string | null, isCompany?: boolean | null, financierDetail?: Array<{ __typename?: 'loanSettlementEndFinOutput', financierName: string, financierCode?: string | null, solicitorCode?: string | null, solicitorName: string, saleLoanId?: string | null, rrSolId?: string | null, rrSolName?: string | null, rrSolCode?: string | null, rrSolRefNo?: string | null, rrDate?: any | null }> | null } };

export type LoanSettlementsUnitQueryVariables = Exact<{
  saleId?: InputMaybe<Scalars['String']>;
}>;


export type LoanSettlementsUnitQuery = { __typename?: 'Query', loanSettlementUnitFormSource: Array<{ __typename?: 'loanSettlementUnitOutput', saleId?: string | null, unitId: string, unitNo: string, purchaserName?: string | null }> };

export type GetEndFinSolicitorFormSourceQueryVariables = Exact<{
  saleId?: InputMaybe<Scalars['String']>;
}>;


export type GetEndFinSolicitorFormSourceQuery = { __typename?: 'Query', getEndFinSolicitorFormSource: Array<{ __typename?: 'loanSettlementEndFinOutput', saleId?: string | null, saleLoanId?: string | null, financierName: string, financierCode?: string | null, solicitorCode?: string | null, solicitorName: string, rrDate?: any | null, rrSolId?: string | null, rrSolRefNo?: string | null }> };

export type AddLoanSettlementMutationVariables = Exact<{
  input: AddLoanSettlementInput;
}>;


export type AddLoanSettlementMutation = { __typename?: 'Mutation', addLoanSettlement: boolean };

export type DeleteLoanSettlementMutationVariables = Exact<{
  saleId: Scalars['String'];
}>;


export type DeleteLoanSettlementMutation = { __typename?: 'Mutation', deleteLoanSettlement: boolean };

export type GetAllRefinancingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllRefinancingQuery = { __typename?: 'Query', getAllRefinancing?: Array<{ __typename?: 'refinancingListingOutput', unitNo: string, buyerName?: string | null, generationBatch: string, loanAgreementDate: any, financierList: Array<string>, loanAmount: number, completedDate?: any | null, status: string, isCompany?: boolean | null, companyName?: string | null }> | null };

export type GetRefinancingByIdQueryVariables = Exact<{
  generationBatch: Scalars['String'];
}>;


export type GetRefinancingByIdQuery = { __typename?: 'Query', getRefinancingById: { __typename?: 'refinancingDetailOutput', saleId: string, refTable: string, financierList: Array<{ __typename?: 'financierListOutput', refinancingId: string, financierId: string, financierName: string, financierReference: string, rrDate: string, rrSolicitorId: string, rrSolicitorName: string, rrSolicitorReference: string, doaDate: string, doaSolicitorId: string, doaSolicitorName: string, doaSolicitorReference: string, loanAgreementDate: string, loanAmount: string, loanSolicitorId: string, loanSolicitorName: string, loanSolicitorReference: string, loanSeqNo: string }>, refinancingLoan?: { __typename?: 'refinancingDetailFieldOutput', unitNo: string, buyerName?: string | null, isCompany?: boolean | null, companyName?: string | null, financierDetail: Array<{ __typename?: 'unitFinancierDetailOutput', financier: string, solicitor: string, financierReference: string, solicitorReference: string, loanSeqNo: string }> } | null } };

export type GetRefinancingUnitQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRefinancingUnitQuery = { __typename?: 'Query', getRefinancingUnit?: Array<{ __typename?: 'refinancingUnitDropDownOutput', unitNo: string, id: string, table: string, buyerName?: string | null, isCompany?: boolean | null, companyName?: string | null, financierDetail: Array<{ __typename?: 'unitFinancierDetailOutput', financier: string, solicitor: string, financierReference: string, solicitorReference: string, loanSeqNo: string }> }> | null };

export type AddRefinancingMutationVariables = Exact<{
  input: AddRefinancingInput;
}>;


export type AddRefinancingMutation = { __typename?: 'Mutation', addRefinancing: boolean };

export type EditRefinancingMutationVariables = Exact<{
  input: EditRefinancingInput;
}>;


export type EditRefinancingMutation = { __typename?: 'Mutation', editRefinancing: boolean };

export type DeleteRefinancingMutationVariables = Exact<{
  generationBatch: Scalars['String'];
}>;


export type DeleteRefinancingMutation = { __typename?: 'Mutation', deleteRefinancing: boolean };

export type CompletedRefinancingMutationVariables = Exact<{
  generationBatch: Scalars['String'];
}>;


export type CompletedRefinancingMutation = { __typename?: 'Mutation', completedRefinancing: boolean };

export type GetRefinancingSingleDetailByIdQueryVariables = Exact<{
  generationBatch: Scalars['String'];
  refinancingId: Scalars['String'];
}>;


export type GetRefinancingSingleDetailByIdQuery = { __typename?: 'Query', getRefinancingSingleDetailById: { __typename?: 'financierListOutput', refinancingId: string, financierId: string, financierName: string, financierReference: string, rrDate: string, rrSolicitorId: string, rrSolicitorName: string, rrSolicitorReference: string, doaDate: string, doaSolicitorId: string, doaSolicitorName: string, doaSolicitorReference: string, loanAgreementDate: string, loanAmount: string, loanSolicitorId: string, loanSolicitorName: string, loanSolicitorReference: string, loanSeqNo: string } };

export type GetRefinancingInfolineQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRefinancingInfolineQuery = { __typename?: 'Query', refinancingInfoline?: { __typename?: 'refinancingInfolineOutput', refinancingCount?: number | null, loanAmount?: number | null } | null };

export type GetBridgingFinancierListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBridgingFinancierListQuery = { __typename?: 'Query', getBridgingFinancierList: Array<{ __typename?: 'bridgingFinancierSharedOutput', id: string, bridgingFinancier: string, bridgingFinancierCode?: string | null, bridgingFinancierRefNo?: string | null, bridgingSolicitorRefNo?: string | null, totalBfUnits: number, totalBfAmount: number, redemptionPaid?: number | null, redemptionBalance?: number | null, unitNo?: Array<string> | null }> };

export type GetProjectBridgingFinancierByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetProjectBridgingFinancierByIdQuery = { __typename?: 'Query', getProjectBridgingFinancierById: { __typename?: 'bridgingFinancierSharedOutput', id: string, bridgingFinancier: string, bridgingFinancierRefNo?: string | null, bridgingFinancierCode?: string | null, bridgingSolicitor: string, bridgingSolicitorRefNo?: string | null, chargeExeType?: string | null, chargeExeValue: number, totalBfUnits: number, totalBfAmount: number, redemptionPaid?: number | null, redemptionBalance?: number | null, financierDetail?: Array<{ __typename?: 'bridgingFinancierUnitDetailsOutput', unitNo: string, unitAmount: number, bfuId: string }> | null } };

export type AddProjectBridgingFinancierMutationVariables = Exact<{
  input: ProjectBridgingFinancierInput;
}>;


export type AddProjectBridgingFinancierMutation = { __typename?: 'Mutation', addProjectBridgingFinancier: boolean };

export type GetBridgingFinancingUnitsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBridgingFinancingUnitsQuery = { __typename?: 'Query', getBridgingFinancingUnits: Array<{ __typename?: 'blockListingOutput', block: string, totalFloor: number, floorList?: Array<{ __typename?: 'floorListingOutput', floorLabel?: string | null, totalUnit?: number | null, unitList?: Array<{ __typename?: 'UnitListingOutput', unitId?: string | null, unitNo?: string | null }> | null }> | null }> };

export type DeleteBridgingFinancierUnitMutationVariables = Exact<{
  bfId: Scalars['String'];
  bfuId: Scalars['String'];
}>;


export type DeleteBridgingFinancierUnitMutation = { __typename?: 'Mutation', deleteBridgingFinancierUnit: { __typename?: 'deleteFinancierUnitOutput', count: number, isEmpty: boolean } };

export type DeleteProjectBridgingFinancierMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteProjectBridgingFinancierMutation = { __typename?: 'Mutation', deleteProjectBridgingFinancier: boolean };

export type GetBridgingFinancierTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBridgingFinancierTypeQuery = { __typename?: 'Query', getBridgingFinancierType: any };

export type GetBridgingLoanSettingSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBridgingLoanSettingSummaryQuery = { __typename?: 'Query', bridgingFinanceLastUpdate?: any | null, redemptionRepaymentLastUpdate?: any | null };

export type CalculateBridgingValueQueryVariables = Exact<{
  input: CalculateBridgingExeValueInput;
}>;


export type CalculateBridgingValueQuery = { __typename?: 'Query', calculateBridgingValue: { __typename?: 'calculatedUnitExeValue', totalCalculatedValue?: number | null, unitExeDetail: Array<{ __typename?: 'calculatedUnitExeDetails', unitId: string, unitNo: string, calculatedUnitValue: number }> } };

export type GetAllRedemptionRepaymentQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllRedemptionRepaymentQuery = { __typename?: 'Query', getAllRedemptionRepayment: Array<{ __typename?: 'redemptionRepaymentListingOutput', id: string, documentDate: any, referenceNo?: string | null, icNo?: string | null, redemptionSum: number, paymentParty: string, paidById: string, financierName?: string | null, financierCode?: string | null, documentNo?: Array<string> | null, unitNo: Array<string>, status?: string | null, isPosted: boolean, redemptionUnitsCount: number, voidDate?: any | null, companyName?: string | null, fullName?: string | null }> };

export type GetRedemptionRepaymentByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetRedemptionRepaymentByIdQuery = { __typename?: 'Query', getRedemptionRepaymentById: { __typename?: 'redemptionRepaymentByIdOutput', redemption: { __typename?: 'redemptionEntity', id: string, paymentParty: string, paidById: string, documentDate: any, referenceNo?: string | null, redemptionSum: number, redemptionUnitsCount?: number | null, paidByParty: string }, redemptionUnits: Array<{ __typename?: 'redemptionUnitsDetails', unitId: string, unitNo: string, documentNo?: string | null, redemptionAmount: number }> } };

export type AddRedemptionRepaymentMutationVariables = Exact<{
  input: RedemptionRepaymentInput;
}>;


export type AddRedemptionRepaymentMutation = { __typename?: 'Mutation', addRedemptionRepayment: boolean };

export type EditRedemptionRepaymentMutationVariables = Exact<{
  input: EditRedemptionRepaymentInput;
}>;


export type EditRedemptionRepaymentMutation = { __typename?: 'Mutation', editRedemptionRepayment: boolean };

export type DeleteRedemptionRepaymentMutationVariables = Exact<{
  redemptionRepaymentId: Scalars['String'];
}>;


export type DeleteRedemptionRepaymentMutation = { __typename?: 'Mutation', deleteRedemptionRepayment: boolean };

export type GetRedemptionPaymentPartyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRedemptionPaymentPartyQuery = { __typename?: 'Query', getRedemptionPaymentParty: Array<{ __typename?: 'paymentPartySelection', id: string, name: string }> };

export type GetPaidByListQueryVariables = Exact<{
  selectedParty: Scalars['String'];
}>;


export type GetPaidByListQuery = { __typename?: 'Query', getPaidByList: Array<{ __typename?: 'paidByListSelection', id: string, name: string, icNo?: string | null, financierCode?: string | null }> };

export type GetDeveloperRedemptionUnitListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDeveloperRedemptionUnitListQuery = { __typename?: 'Query', getDeveloperRedemptionUnitList: Array<{ __typename?: 'redemptionUnitsSelection', unitId: string, unitNo: string, redemptionBalance: number, redemptionAmount: number }> };

export type GetFinancierRedemptionUnitListQueryVariables = Exact<{
  financierId?: InputMaybe<Scalars['String']>;
}>;


export type GetFinancierRedemptionUnitListQuery = { __typename?: 'Query', getFinancierRedemptionUnitList: Array<{ __typename?: 'redemptionUnitsSelection', unitId: string, unitNo: string, redemptionBalance: number, redemptionAmount: number }> };

export type GetPurchaserRedemptionUnitListQueryVariables = Exact<{
  contactId?: InputMaybe<Scalars['String']>;
}>;


export type GetPurchaserRedemptionUnitListQuery = { __typename?: 'Query', getPurchaserRedemptionUnitList: Array<{ __typename?: 'redemptionUnitsSelection', unitId: string, unitNo: string, redemptionBalance: number, redemptionAmount: number }> };

export type GetRedemptionUnitSelectionQueryVariables = Exact<{
  selectedParty: Scalars['String'];
  selectedPartyId?: InputMaybe<Scalars['String']>;
}>;


export type GetRedemptionUnitSelectionQuery = { __typename?: 'Query', getRedemptionUnitSelection: Array<{ __typename?: 'redemptionUnitsSelection', unitId: string, unitNo: string, redemptionAmount: number }> };

export type PostRedemptionRepaymentMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type PostRedemptionRepaymentMutation = { __typename?: 'Mutation', postRedemptionRepayment: boolean };

export type ReversalRedemptionRepaymentMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ReversalRedemptionRepaymentMutation = { __typename?: 'Mutation', reversalRedemptionRepayment: boolean };

export type CheckSetupBridgingFinancierQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckSetupBridgingFinancierQuery = { __typename?: 'Query', checkSetupBridgingFinancier: boolean };

export type GetSalesLoanBuyBackListQueryVariables = Exact<{
  projectId: Scalars['String'];
  approvalStatus: Scalars['String'];
}>;


export type GetSalesLoanBuyBackListQuery = { __typename?: 'Query', getSalesLoanBuyBackList?: Array<{ __typename?: 'saleLoanBuyBackListOutput', id: string, unitNo: string, fullName: string, newFinancier: string, buyBackDate: any, buyBackAmount: string, approvalStatus: string, docNo?: string | null }> | null };

export type GetSalesLoanBuyBackMasterDataQueryVariables = Exact<{
  companyId: Scalars['String'];
  isAddForm?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetSalesLoanBuyBackMasterDataQuery = { __typename?: 'Query', salesLoanBuyBackMasterData: { __typename?: 'buyBackDataOutput', unitList: Array<{ __typename?: 'buyBackUnitList', sale_id: string, unitNo: string, full_name: string, name: string, table_ref: string, financier_id: string, is_refinanced: string, sale_loan_id: string, old_balance?: Array<any> | null, saleLoanPayment?: Array<{ __typename?: 'salePaymentOutput', paymentId?: string | null, loanAmt?: number | null, saleLoanId?: string | null, endfinMortgagePaymentId?: string | null, paymentName: string, constructionDate: any, loanSignDate: any, expectedCount: number, expectedFreq: string, expectedFrom: string, saleLoanRetention?: Array<{ __typename?: 'saleRetentionOutput', retentionId?: string | null, retentionName: string, retentionValue?: number | null, saleLoanPaymentId?: string | null, endfinMortgageRetentionId?: string | null, constructionDate: any, loanSignDate: any, expectedCount: number, expectedFreq: string, expectedFrom: string }> | null }> | null }>, banks: Array<{ __typename?: 'bankOutput', value: string, label: string, code: string, accountNo: string, currency: string }> } };

export type GetSalesLoanBuyBackMasterDataDetailsQueryVariables = Exact<{
  companyId: Scalars['String'];
  isAddForm?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetSalesLoanBuyBackMasterDataDetailsQuery = { __typename?: 'Query', salesLoanBuyBackMasterDataDetails: { __typename?: 'buyBackDataOutput', unitList: Array<{ __typename?: 'buyBackUnitList', sale_id: string, unitNo: string, full_name: string, name: string, table_ref: string, financier_id: string, is_refinanced: string, sale_loan_id: string, old_balance?: Array<any> | null, saleLoanPayment?: Array<{ __typename?: 'salePaymentOutput', paymentId?: string | null, loanAmt?: number | null, saleLoanId?: string | null, endfinMortgagePaymentId?: string | null, paymentName: string, constructionDate: any, loanSignDate: any, expectedCount: number, expectedFreq: string, expectedFrom: string, saleLoanRetention?: Array<{ __typename?: 'saleRetentionOutput', retentionId?: string | null, retentionName: string, retentionValue?: number | null, saleLoanPaymentId?: string | null, endfinMortgageRetentionId?: string | null, constructionDate: any, loanSignDate: any, expectedCount: number, expectedFreq: string, expectedFrom: string }> | null }> | null }>, banks: Array<{ __typename?: 'bankOutput', value: string, label: string, code: string, accountNo: string, currency: string }> } };

export type AddSaleLoanBuyBackMutationVariables = Exact<{
  input: AddSaleLoanBuyBackListInput;
}>;


export type AddSaleLoanBuyBackMutation = { __typename?: 'Mutation', addSaleLoanBuyBack: boolean };

export type EditSaleLoanBuyBackMutationVariables = Exact<{
  input: EditSaleLoanBuyBackListInput;
}>;


export type EditSaleLoanBuyBackMutation = { __typename?: 'Mutation', editSaleLoanBuyBack: boolean };

export type ApproveBuyBackLoanMutationVariables = Exact<{
  buyBackLoanId: Scalars['String'];
  projectId: Scalars['String'];
}>;


export type ApproveBuyBackLoanMutation = { __typename?: 'Mutation', approveBuyBackLoan: boolean };

export type GetSalesLoanBuyBackDetailsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetSalesLoanBuyBackDetailsQuery = { __typename?: 'Query', getSalesLoanBuyBackDetails?: { __typename?: 'saleLoanBuyBackListOutput', id: string, projectId: string, saleId: string, unitNo: string, fullName: string, refTable: string, refRecordId: string, newFinancier: string, buyBackDate: any, buyBackAmount: string, bankName: string, bankAccountNo: string, remarks?: string | null, financierId: string, bankAccountId: string, approvalStatus: string, submittedDate?: any | null, submittedBy?: string | null, approvedDate?: any | null, approvedBy?: string | null, oldBalance?: Array<any> | null, docNo?: string | null, saleLoanPayment?: Array<{ __typename?: 'salePaymentOutput', paymentId?: string | null, loanAmt?: number | null, saleLoanId?: string | null, endfinMortgagePaymentId?: string | null, paymentName: string, constructionDate: any, loanSignDate: any, expectedCount: number, expectedFreq: string, expectedFrom: string, saleLoanRetention?: Array<{ __typename?: 'saleRetentionOutput', retentionId?: string | null, retentionName: string, retentionValue?: number | null, saleLoanPaymentId?: string | null, endfinMortgageRetentionId?: string | null, constructionDate: any, loanSignDate: any, expectedCount: number, expectedFreq: string, expectedFrom: string }> | null }> | null } | null };

export type DeleteSaleLoanBuyBackMutationVariables = Exact<{
  input: Scalars['String'];
}>;


export type DeleteSaleLoanBuyBackMutation = { __typename?: 'Mutation', deleteSaleLoanBuyBack: boolean };

export type GetSaleLoanBuyBackCountQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetSaleLoanBuyBackCountQuery = { __typename?: 'Query', getSaleLoanBuyBackCount: { __typename?: 'saleLoanBuyBackCountOutput', draftCount: number, submittedCount: number, approvedCount: number } };

export type GetAllReceiptQueryVariables = Exact<{
  status: Scalars['String'];
}>;


export type GetAllReceiptQuery = { __typename?: 'Query', getAllReceipt?: Array<{ __typename?: 'receiptOutput', receiptId: string, salesId: string, unitNo: string, paymentMethod?: string | null, documentNo?: string | null, docType: string, documentRef?: string | null, description: string, documentDate: any, currency?: string | null, exchangeRate?: number | null, documentAmount: number, receiptAmount: number, chequeDate?: any | null, chequeExpireDate?: any | null, creditCardType?: string | null, bankAccountId: string, bankCode: string, bankAccountNo: string, financierId?: string | null, financierName?: string | null, allowReversal: boolean, status: string, submittedBy?: string | null, submittedDate?: any | null, allocationDocumentNo?: string | null, allocateAmount: number, unAllocateAmount: number, approvedBy?: string | null, approvedDate?: any | null, voidBy?: string | null, voidDate?: any | null, getAttachment?: Array<{ __typename?: 'attachmentEntity', id: string, resourceUrl: string, mediaType: string, fileName: string }> | null, allocationList?: Array<{ __typename?: 'receiptAllocationList', documentNo: string, allocateAmount: number, documentDate: any, description?: string | null }> | null }> | null };

export type GetAllReceiptBySaleIdQueryVariables = Exact<{
  status: Scalars['String'];
  saleId: Scalars['String'];
}>;


export type GetAllReceiptBySaleIdQuery = { __typename?: 'Query', getAllReceiptBySaleId?: Array<{ __typename?: 'receiptOutput', receiptId: string, salesId: string, unitNo: string, paymentMethod?: string | null, documentNo?: string | null, documentRef?: string | null, description: string, documentDate: any, docType: string, currency?: string | null, exchangeRate?: number | null, documentAmount: number, receiptAmount: number, chequeDate?: any | null, chequeExpireDate?: any | null, creditCardType?: string | null, bankAccountId: string, bankCode: string, bankAccountNo: string, financierId?: string | null, financierName?: string | null, voidBy?: string | null, voidDate?: any | null, status: string, submittedBy?: string | null, submittedDate?: any | null, allocationDocumentNo?: string | null, allocateAmount: number, unAllocateAmount: number, approvedBy?: string | null, approvedDate?: any | null, allowReversal: boolean, getAttachment?: Array<{ __typename?: 'attachmentEntity', id: string, resourceUrl: string, mediaType: string, fileName: string }> | null, allocationList?: Array<{ __typename?: 'receiptAllocationList', documentNo: string, allocateAmount: number, documentDate: any, description?: string | null }> | null }> | null };

export type CreateReceiptMutationVariables = Exact<{
  input: ReceiptInput;
}>;


export type CreateReceiptMutation = { __typename?: 'Mutation', createReceipt: boolean };

export type GetCollectionMasterDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCollectionMasterDataQuery = { __typename?: 'Query', getCollectionMasterData?: { __typename?: 'receiptMasterDateOutput', currency?: string | null, unitList?: Array<{ __typename?: 'unitList', saleId: string, unitNo: string, financierList?: Array<{ __typename?: 'financierData', financierId: string, financierName: string }> | null }> | null } | null };

export type GetCompanyBankAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompanyBankAccountQuery = { __typename?: 'Query', getCompanyBankAccount?: Array<{ __typename?: 'companyBankList', bankProfileId: string, bankProfileName: string, bankAccountId: string, bankAccountCode: string, bankAccountNo: string, isSelected?: boolean | null, currency: string }> | null };

export type GetCompanyBankAcctQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompanyBankAcctQuery = { __typename?: 'Query', getCompanyBankAcct?: Array<{ __typename?: 'companyBankList', bankProfileId: string, bankProfileName: string, bankAccountId: string, bankAccountCode: string, bankAccountNo: string, isSelected?: boolean | null, currency: string }> | null };

export type GetReceiptByIdQueryVariables = Exact<{
  id: Scalars['String'];
  docType?: InputMaybe<Scalars['String']>;
}>;


export type GetReceiptByIdQuery = { __typename?: 'Query', getReceiptById: { __typename?: 'receiptOutput', receiptId: string, salesId: string, unitNo: string, paymentMethod?: string | null, docType: string, allowReversal: boolean, documentNo?: string | null, documentRef?: string | null, description: string, documentDate: any, currency?: string | null, exchangeRate?: number | null, documentAmount: number, receiptAmount: number, chequeDate?: any | null, chequeExpireDate?: any | null, creditCardType?: string | null, bankAccountId: string, bankCode: string, bankAccountNo: string, financierId?: string | null, financierName?: string | null, voidBy?: string | null, voidDate?: any | null, status: string, submittedBy?: string | null, submittedDate?: any | null, allocationDocumentNo?: string | null, allocateAmount: number, unAllocateAmount: number, approvedBy?: string | null, approvedDate?: any | null, getAttachment?: Array<{ __typename?: 'attachmentEntity', id: string, resourceUrl: string, mediaType: string, fileName: string }> | null, projectDetail?: { __typename?: 'projectEntity', name: string } | null } };

export type EditReceiptMutationVariables = Exact<{
  input: EditReceiptInput;
}>;


export type EditReceiptMutation = { __typename?: 'Mutation', editReceipt: boolean };

export type AllocationReceiptMutationVariables = Exact<{
  input: AllocationInput;
}>;


export type AllocationReceiptMutation = { __typename?: 'Mutation', allocationReceipt: boolean };

export type PostingReceiptMutationVariables = Exact<{
  input: PostingInput;
}>;


export type PostingReceiptMutation = { __typename?: 'Mutation', postingReceipt: boolean };

export type GetSalesInformationQueryVariables = Exact<{
  saleId: Scalars['String'];
}>;


export type GetSalesInformationQuery = { __typename?: 'Query', getSalesInformation?: { __typename?: 'saleInformation', unitNo: string, name?: string | null, totalAmount: number, totalAllocateAmount: number, unAllocateAmount: number, isCompany?: boolean | null, companyName?: string | null } | null };

export type AddReceiptReversalMutationVariables = Exact<{
  receiptId: Scalars['String'];
}>;


export type AddReceiptReversalMutation = { __typename?: 'Mutation', addReceiptReversal: boolean };

export type GetApprovalPolicyFlagQueryVariables = Exact<{ [key: string]: never; }>;


export type GetApprovalPolicyFlagQuery = { __typename?: 'Query', getApprovalPolicyFlag: any };

export type GetApprovalPolicyListingByCategoryQueryVariables = Exact<{
  category: Scalars['String'];
}>;


export type GetApprovalPolicyListingByCategoryQuery = { __typename?: 'Query', getApprovalPolicyListingByCategory?: Array<{ __typename?: 'approvalPolicyEntity', id: string, lowerLimit?: number | null, upperLimit?: number | null, approvalList: Array<{ __typename?: 'ApprovalListJson', stepNo: number, roleId: string, roleName?: string | null }> }> | null };

export type AddEditApprovalPolicyMutationVariables = Exact<{
  input: AddEditApprovalPolicyInput;
}>;


export type AddEditApprovalPolicyMutation = { __typename?: 'Mutation', addEditApprovalPolicy: boolean };

export type GetBankListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBankListQuery = { __typename?: 'Query', getBankList?: Array<{ __typename?: 'bankEntity', id: string, name: string, code: string, isExistInEndFinancier: number, commonStatus: string, isExistInTransactionData: Array<string> }> | null };

export type GetBankListingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBankListingQuery = { __typename?: 'Query', getBankListing?: Array<{ __typename?: 'bankListingOutput', id?: string | null, name?: string | null, currency?: string | null, code?: string | null, accountNo?: string | null }> | null };

export type AddBankMutationVariables = Exact<{
  input: AddBankInput;
}>;


export type AddBankMutation = { __typename?: 'Mutation', addBank: boolean };

export type EditBankMutationVariables = Exact<{
  input: EditBankInput;
}>;


export type EditBankMutation = { __typename?: 'Mutation', editBank: boolean };

export type DeleteBankMutationVariables = Exact<{
  bankId: Scalars['String'];
  isDeletable: Scalars['Boolean'];
}>;


export type DeleteBankMutation = { __typename?: 'Mutation', deleteBank: boolean };

export type ActivateBankMutationVariables = Exact<{
  bankId: Scalars['String'];
}>;


export type ActivateBankMutation = { __typename?: 'Mutation', activateBank: boolean };

export type BankProfileListingQueryVariables = Exact<{
  companyId: Scalars['String'];
}>;


export type BankProfileListingQuery = { __typename?: 'Query', bankProfileListing: { __typename?: 'companyEntity', bankProfile: Array<{ __typename?: 'companyBankProfileEntity', id: string, name: string, phoneNo: string, address: string }> } };

export type GetBankProfileQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  commonStatus?: InputMaybe<Scalars['String']>;
}>;


export type GetBankProfileQuery = { __typename?: 'Query', getBankProfile: Array<{ __typename?: 'companyBankProfileEntity', id: string, name: string, phoneNo: string, address: string }> };

export type DeleteCompanyBankProfileMutationVariables = Exact<{
  companyId: Scalars['String'];
  bankId: Scalars['String'];
}>;


export type DeleteCompanyBankProfileMutation = { __typename?: 'Mutation', deleteCompanyBankProfile: boolean };

export type EditCompanyBankProfileMutationVariables = Exact<{
  input: EditCompanyBankProfileInput;
}>;


export type EditCompanyBankProfileMutation = { __typename?: 'Mutation', editCompanyBankProfile: boolean };

export type GetProfileAndAccountListQueryVariables = Exact<{
  companyId: Scalars['String'];
  bankProfileId: Scalars['String'];
}>;


export type GetProfileAndAccountListQuery = { __typename?: 'Query', getProfileAndAccountList: { __typename?: 'companyBankProfileOutput', bankId: string, bankName: string, bankAddress: string, bankPhoneNo: string, bankAccounts?: Array<{ __typename?: 'companyBankAccountOutput', bankAccountId: string, bankProfileId: string, code: string, accountType: string, accountNo: string, swiftCode?: string | null, currency?: string | null, effectiveDate: any }> | null } };

export type GetAllMasterInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllMasterInfoQuery = { __typename?: 'Query', GetAllMasterInfo: { __typename?: 'MasterDataOutput', CurrencyCode: Array<Array<string>>, LandType: any, UOM: any, Tenures: any, CommercialPurposes: any, DiscountPrefix: any } };

export type GetCommonSettingSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCommonSettingSummaryQuery = { __typename?: 'Query', statutoryDocsDate?: any | null, companyCount?: number | null, taxSetupCount?: number | null, stampDutyCount?: number | null, taxSchemeTotalCount?: number | null, purchaserIDTypeCount?: number | null, countryCodeCount?: number | null, billItemCount?: number | null, bankCount?: number | null, discountTypeCount?: number | null, discountCount?: number | null, archCertStagesCount?: number | null, paymentPlanCount?: number | null, purchaserPaymentPlanCount?: number | null, standardParameterDate?: any | null, standardELetteringTemplateDate?: any | null, approvalPolicyDate?: any | null, leadChannelCount?: number | null, reasonCodeCount?: number | null, currencyExchangeCount?: number | null, msicCodeCount?: number | null, classificationCodeCount?: number | null, notaryCount?: number | null, taxTransactionCodeCount?: number | null, unitOfMeasurementCount?: number | null };

export type CompanyListingQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyListingQuery = { __typename?: 'Query', companyListing: Array<{ __typename?: 'companyEntity', id: string, name: string, imageUrl?: string | null, email?: string | null, officeTel?: string | null, recordStatus: string, townshipCount?: number | null, bankProfileCount?: number | null, companyArAgingPolicy?: { __typename?: 'companyArAgingPolicyEntity', period1: number, period2: number, period3: number, period4: number, period5: number, period6: number } | null }> };

export type CompanyDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type CompanyDetailQuery = { __typename?: 'Query', companyDetail?: { __typename?: 'companyEntity', id: string, name: string, imageUrl?: string | null, companyRegNo?: string | null, description?: string | null, email?: string | null, officeTel?: string | null, code: string, groupGstRegNo?: string | null, gstNo?: string | null, sstNo?: string | null, companyLastUpdate?: any | null, bankLastUpdate?: any | null, townshipLastUpdate?: any | null, numberingStructureLastUpdate?: any | null, townshipCount?: number | null, bankProfileCount?: number | null, isDeletable: boolean, recordStatus: string, address?: { __typename?: 'AddressJson', address?: string | null, city?: string | null, state?: string | null, country?: string | null, postCode?: string | null } | null } | null };

export type AddCompanyMutationVariables = Exact<{
  input: AddCompanyInput;
  file: Scalars['Upload'];
}>;


export type AddCompanyMutation = { __typename?: 'Mutation', addCompany: boolean };

export type EditCompanyMutationVariables = Exact<{
  input: EditCompanyInput;
  file?: InputMaybe<Scalars['Upload']>;
}>;


export type EditCompanyMutation = { __typename?: 'Mutation', editCompany: boolean };

export type DeleteCompanyMutationVariables = Exact<{
  companyId: Scalars['String'];
}>;


export type DeleteCompanyMutation = { __typename?: 'Mutation', deleteCompany: boolean };

export type ActivateCompanyMutationVariables = Exact<{
  companyId: Scalars['String'];
}>;


export type ActivateCompanyMutation = { __typename?: 'Mutation', activateCompany: boolean };

export type GetArAgingQueryVariables = Exact<{
  companyId: Scalars['String'];
}>;


export type GetArAgingQuery = { __typename?: 'Query', getArAging?: { __typename?: 'companyArAgingPolicyEntity', period1: number, period2: number, period3: number, period4: number, period5: number, period6: number } | null };

export type AddArAgingMutationVariables = Exact<{
  input: AddAccountReceivableAging;
}>;


export type AddArAgingMutation = { __typename?: 'Mutation', addArAging: boolean };

export type AddCompanyBankProfileMutationVariables = Exact<{
  inputBankProfile: AddCompanyBankProfileInput;
}>;


export type AddCompanyBankProfileMutation = { __typename?: 'Mutation', addCompanyBankProfile: boolean };

export type TownshipListingQueryVariables = Exact<{
  companyId: Scalars['String'];
}>;


export type TownshipListingQuery = { __typename?: 'Query', townshipListing?: { __typename?: 'companyEntity', township: Array<{ __typename?: 'townshipEntity', id: string, name: string, code: string, location: string, logoUrl?: string | null }> } | null };

export type GetTownshipQueryVariables = Exact<{
  companyId: Scalars['String'];
  commonStatus: Scalars['String'];
}>;


export type GetTownshipQuery = { __typename?: 'Query', getTownship: Array<{ __typename?: 'townshipEntity', id: string, name: string, code: string, logoUrl?: string | null, location: string }> };

export type DeleteTownshipMutationVariables = Exact<{
  townshipId: Scalars['String'];
  companyId: Scalars['String'];
}>;


export type DeleteTownshipMutation = { __typename?: 'Mutation', deleteTownship: boolean };

export type AddTownshipMutationVariables = Exact<{
  input: AddTownshipInput;
}>;


export type AddTownshipMutation = { __typename?: 'Mutation', addTownship: boolean };

export type EditTownshipMutationVariables = Exact<{
  input: EditTownshipInput;
}>;


export type EditTownshipMutation = { __typename?: 'Mutation', editTownship: boolean };

export type GetCountryCodeListingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCountryCodeListingQuery = { __typename?: 'Query', getCountryCodeListing?: Array<{ __typename?: 'countryCodeOutput', id: string, code: string, name: string }> | null };

export type GetCountryCodeByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCountryCodeByIdQuery = { __typename?: 'Query', getCountryCodeById: { __typename?: 'countryCodeEntity', id: string, code: string, name: string } };

export type AddCountryCodeMutationVariables = Exact<{
  input: AddCountryCodeInput;
}>;


export type AddCountryCodeMutation = { __typename?: 'Mutation', addCountryCode: boolean };

export type EditCountryCodeMutationVariables = Exact<{
  input: EditCountryCodeInput;
}>;


export type EditCountryCodeMutation = { __typename?: 'Mutation', editCountryCode: boolean };

export type DeleteCountryCodeMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteCountryCodeMutation = { __typename?: 'Mutation', deleteCountryCode: boolean };

export type GetExchangeListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetExchangeListQuery = { __typename?: 'Query', getExchangeList?: Array<{ __typename?: 'currencyExchangeOutput', id: string, fromCurrencyCode: string, toCurrencyCode: string, fromAmt: number, toAmt: number, exchangeRate: number, commonStatus: string, isExistInTransactionData: Array<string> }> | null };

export type GetExchangeByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetExchangeByIdQuery = { __typename?: 'Query', getExchangeById: { __typename?: 'currencyExchangeOutput', id: string, fromCurrencyCode: string, toCurrencyCode: string, fromAmt: number, toAmt: number, exchangeRate: number } };

export type AddExchangeRateMutationVariables = Exact<{
  input: CurrencyExchangeRateInput;
}>;


export type AddExchangeRateMutation = { __typename?: 'Mutation', addExchangeRate: boolean };

export type EditExchangeRateMutationVariables = Exact<{
  input: CurrencyExchangeRateEditInput;
}>;


export type EditExchangeRateMutation = { __typename?: 'Mutation', editExchangeRate: boolean };

export type DeleteExchangeRateMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteExchangeRateMutation = { __typename?: 'Mutation', deleteExchangeRate: boolean };

export type GetExchangeListByCodeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetExchangeListByCodeQuery = { __typename?: 'Query', getExchangeListByCode?: Array<{ __typename?: 'currencyExchangeOutput', id: string, fromCurrencyCode: string, toCurrencyCode: string, fromAmt: number, toAmt: number, exchangeRate: number }> | null };

export type ActivateCurrencyExchangeMutationVariables = Exact<{
  currencyExchangeId: Scalars['String'];
}>;


export type ActivateCurrencyExchangeMutation = { __typename?: 'Mutation', activateCurrencyExchange: boolean };

export type DeactivateCurrencyExchangeMutationVariables = Exact<{
  currencyExchangeId: Scalars['String'];
}>;


export type DeactivateCurrencyExchangeMutation = { __typename?: 'Mutation', deactivateCurrencyExchange: boolean };

export type GetAllDiscountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllDiscountQuery = { __typename?: 'Query', getAllDiscount: Array<{ __typename?: 'discountEntity', title: string, id: string, description?: string | null, formula?: string | null, discountTypeId?: string | null, discountVal?: number | null, isIntegrated: boolean, prefix?: string | null, isExistInMasterData: Array<string>, isExistInTransactionData: Array<string>, commonStatus: string }> };

export type GetDiscountByIdQueryVariables = Exact<{
  discountId: Scalars['String'];
}>;


export type GetDiscountByIdQuery = { __typename?: 'Query', getDiscountById: { __typename?: 'discountEntity', title: string, formula?: string | null, id: string, discountTypeId?: string | null, prefix?: string | null, description?: string | null, discountVal?: number | null, isIntegrated: boolean }, GetAllMasterInfo: { __typename?: 'MasterDataOutput', DiscountPrefix: any, DiscountType: Array<{ __typename?: 'discountTypeEntity', id: string, name: string }> } };

export type AddDiscountMutationVariables = Exact<{
  input: DiscountInput;
}>;


export type AddDiscountMutation = { __typename?: 'Mutation', addDiscount: boolean };

export type EditDiscountMutationVariables = Exact<{
  input: EditDiscountInput;
}>;


export type EditDiscountMutation = { __typename?: 'Mutation', editDiscount: boolean };

export type DeleteDiscountMutationVariables = Exact<{
  discountId: Scalars['String'];
  isDeletable: Scalars['Boolean'];
}>;


export type DeleteDiscountMutation = { __typename?: 'Mutation', deleteDiscount: boolean };

export type ActiveDiscountMutationVariables = Exact<{
  discountId: Scalars['String'];
}>;


export type ActiveDiscountMutation = { __typename?: 'Mutation', activeDiscount: boolean };

export type GetAllDiscountTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllDiscountTypeQuery = { __typename?: 'Query', getAllDiscountType?: Array<{ __typename?: 'discountTypeEntity', id: string, name: string, systemUse: boolean, isExistInMasterData: Array<string> }> | null };

export type AddDiscountTypeMutationVariables = Exact<{
  input: DiscountTypeInput;
}>;


export type AddDiscountTypeMutation = { __typename?: 'Mutation', addDiscountType: boolean };

export type EditDiscountTypeMutationVariables = Exact<{
  input: EditDiscountTypeInput;
}>;


export type EditDiscountTypeMutation = { __typename?: 'Mutation', editDiscountType: boolean };

export type DeleteDiscountTypeByIdMutationVariables = Exact<{
  discountTypeId: Scalars['String'];
}>;


export type DeleteDiscountTypeByIdMutation = { __typename?: 'Mutation', deleteDiscountTypeById: boolean };

export type GetStandardLetterParameterQueryVariables = Exact<{
  standardLetterId: Scalars['String'];
}>;


export type GetStandardLetterParameterQuery = { __typename?: 'Query', getStandardLetterParameter: Array<{ __typename?: 'standardLetterParameterEntity', id: string, accountId: string, standardLetterId: string, displayName: string, columnName: string, commonStatus: string }> };

export type GetLetterTemplateListingQueryVariables = Exact<{
  standardLetterId: Scalars['String'];
}>;


export type GetLetterTemplateListingQuery = { __typename?: 'Query', getLetterTemplateListing: Array<{ __typename?: 'letterTemplateEntity', id: string, standardLetterId: string, name: string, modTs: any, isReportDesignEditor: boolean, defaulted: boolean, standardLetterDataSourceVersion?: number | null, standardLetter: { __typename?: 'standardLetterEntity', name: string }, slDataSource?: { __typename?: 'standardLetterDataSourceEntity', id: string, version: number } | null }> };

export type GetLetterTemplateStdLtrParameterIdQueryVariables = Exact<{
  standardLetterParameterId: Scalars['String'];
}>;


export type GetLetterTemplateStdLtrParameterIdQuery = { __typename?: 'Query', getLetterTemplateByStdLtrParameterId: Array<{ __typename?: 'letterTemplateEntity', id: string, name: string, templateBody?: string | null, jointBuyerSignRequired: boolean, commonStatus: string, createdTs: any, modTs: any }> };

export type GetLetterTemplateByIdQueryVariables = Exact<{
  letterTemplateID: Scalars['String'];
}>;


export type GetLetterTemplateByIdQuery = { __typename?: 'Query', getLetterTemplateById?: { __typename?: 'letterTemplateEntity', id: string, standardLetterId: string, name: string, templateBody?: string | null, jointBuyerSignRequired: boolean, isReportDesignEditor: boolean } | null };

export type AddLetterTemplateMutationVariables = Exact<{
  input: LetterTemplateInput;
}>;


export type AddLetterTemplateMutation = { __typename?: 'Mutation', addLetterTemplate: string };

export type EditLetterTemplateMutationVariables = Exact<{
  input: EditLetterTemplateInput;
}>;


export type EditLetterTemplateMutation = { __typename?: 'Mutation', editLetterTemplate: string };

export type DeleteLetterTemplateByIdMutationVariables = Exact<{
  letterTemplateID: Scalars['String'];
}>;


export type DeleteLetterTemplateByIdMutation = { __typename?: 'Mutation', deleteLetterTemplateById: boolean };

export type DesignLetterTemplateMutationVariables = Exact<{
  input: DesignLetterTemplateInput;
}>;


export type DesignLetterTemplateMutation = { __typename?: 'Mutation', designLetterTemplate: boolean };

export type LetterTemplateRebuildReportMutationVariables = Exact<{
  id: Scalars['String'];
  sldsId: Scalars['String'];
}>;


export type LetterTemplateRebuildReportMutation = { __typename?: 'Mutation', letterTemplateRebuildReport: boolean };

export type SetDefaultELetterMutationVariables = Exact<{
  letterTemplateId: Scalars['String'];
  defaulted: Scalars['Boolean'];
}>;


export type SetDefaultELetterMutation = { __typename?: 'Mutation', setDefaultELetter: boolean };

export type GetAllLeadSourceQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllLeadSourceQuery = { __typename?: 'Query', getAllLeadSource?: Array<{ __typename?: 'leadSourceEntity', id: string, name: string, commonStatus: string, systemUse: boolean, defaulted: boolean, isDeletable: boolean, isExistInTransactionData: Array<string> }> | null };

export type EditLeadSourceMutationVariables = Exact<{
  input: EditLeadSourceInput;
}>;


export type EditLeadSourceMutation = { __typename?: 'Mutation', editLeadSource: boolean };

export type AddLeadSourceMutationVariables = Exact<{
  input: LeadSourceInput;
}>;


export type AddLeadSourceMutation = { __typename?: 'Mutation', addLeadSource: boolean };

export type DeleteLeadSourceByIdMutationVariables = Exact<{
  sourceId: Scalars['String'];
}>;


export type DeleteLeadSourceByIdMutation = { __typename?: 'Mutation', deleteLeadSourceById: boolean };

export type ChangeLeadStatusMutationVariables = Exact<{
  sourceId: Scalars['String'];
  status: Scalars['Boolean'];
}>;


export type ChangeLeadStatusMutation = { __typename?: 'Mutation', changeLeadStatus: boolean };

export type SetDefaultLeadSourceMutationVariables = Exact<{
  sourceId: Scalars['String'];
}>;


export type SetDefaultLeadSourceMutation = { __typename?: 'Mutation', setDefaultLeadSource: boolean };

export type RemoveDefaultLeadSourceMutationVariables = Exact<{
  sourceId: Scalars['String'];
}>;


export type RemoveDefaultLeadSourceMutation = { __typename?: 'Mutation', removeDefaultLeadSource: boolean };

export type OrganizeLeadSourceMutationVariables = Exact<{
  sourceIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type OrganizeLeadSourceMutation = { __typename?: 'Mutation', organizeLeadSource: boolean };

export type GetAllNotaryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllNotaryQuery = { __typename?: 'Query', getAllNotary: Array<{ __typename?: 'notaryOutput', id: string, accountId: string, notaryId?: string | null, name: string, notaryCode?: string | null, ppatNo?: string | null, email?: string | null, officeTel?: string | null, invitationLink?: string | null, commonStatus: string, address?: { __typename?: 'AddressJson', address?: string | null, address2?: string | null, country?: string | null, city?: string | null, district?: string | null, subdistrict?: string | null, state?: string | null, postCode?: string | null, postCodeName?: string | null, AddressType?: string | null, isPrimary?: boolean | null } | null }> };

export type GetNotaryByIdQueryVariables = Exact<{
  notaryId: Scalars['String'];
}>;


export type GetNotaryByIdQuery = { __typename?: 'Query', getNotaryById: { __typename?: 'notaryOutput', id: string, accountId: string, notaryId?: string | null, name: string, notaryCode?: string | null, ppatNo?: string | null, email?: string | null, officeTel?: string | null, invitationLink?: string | null, commonStatus: string, address?: { __typename?: 'AddressJson', address?: string | null, address2?: string | null, country?: string | null, city?: string | null, district?: string | null, subdistrict?: string | null, state?: string | null, postCode?: string | null, postCodeName?: string | null, AddressType?: string | null, isPrimary?: boolean | null } | null, contactDetails?: Array<{ __typename?: 'notaryContactDetailsOutput', id?: string | null, name: string, phoneNo: string, email: string }> | null } };

export type AddNotaryMutationVariables = Exact<{
  input: NotaryInput;
}>;


export type AddNotaryMutation = { __typename?: 'Mutation', addNotary: boolean };

export type UpdateNotaryMutationVariables = Exact<{
  input: EditNotaryInput;
}>;


export type UpdateNotaryMutation = { __typename?: 'Mutation', updateNotary: boolean };

export type DeleteNotaryMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteNotaryMutation = { __typename?: 'Mutation', deleteNotary: boolean };

export type GetDocumentNumberHeaderListingQueryVariables = Exact<{
  companyId: Scalars['String'];
}>;


export type GetDocumentNumberHeaderListingQuery = { __typename?: 'Query', getDocumentNumberHeaderListing: Array<{ __typename?: 'CompanyNumberingStructureListingOutput', type: string, title: string, sampleOutput?: string | null }> };

export type GetAvailableCopyNumCompanyListQueryVariables = Exact<{
  companyId: Scalars['String'];
}>;


export type GetAvailableCopyNumCompanyListQuery = { __typename?: 'Query', getAvailableCopyNumCompanyList?: Array<{ __typename?: 'availableCopyCompanyListProp', id: string, name: string }> | null };

export type GetDocumentTypeQueryVariables = Exact<{
  type: Scalars['String'];
  companyId: Scalars['String'];
}>;


export type GetDocumentTypeQuery = { __typename?: 'Query', getDocumentType?: { __typename?: 'documentNumberHeaderEntity', id: string, sampleOutput: string, docNumGenerated?: boolean | null, documentNumberDetails?: Array<{ __typename?: 'documentNumberDetailEntity', id: string, sequence: number, formatType: string, formatValue: string, startFrom?: number | null, resetBy?: string | null }> | null } | null };

export type AddCompanyNumberingStructureMutationVariables = Exact<{
  input: AddNumberingFormatInput;
}>;


export type AddCompanyNumberingStructureMutation = { __typename?: 'Mutation', addCompanyNumberingStructure: boolean };

export type EditCompanyNumberingStructureMutationVariables = Exact<{
  input: EditNumberingFormatInput;
}>;


export type EditCompanyNumberingStructureMutation = { __typename?: 'Mutation', editCompanyNumberingStructure: boolean };

export type GetDocumentNumberDetailTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDocumentNumberDetailTypeQuery = { __typename?: 'Query', getDocumentNumberDetailType: any };

export type CopyFromCompanyNumberingStructureMutationVariables = Exact<{
  input: CopyFromNumberingFormatInput;
}>;


export type CopyFromCompanyNumberingStructureMutation = { __typename?: 'Mutation', copyFromCompanyNumberingStructure: boolean };

export type PaymentGatewayListingQueryVariables = Exact<{ [key: string]: never; }>;


export type PaymentGatewayListingQuery = { __typename?: 'Query', paymentGatewayListing: Array<{ __typename?: 'paymentGatewayEntity', id: string, gatewayType: string, gatewayInfo: any, commonStatus: string, gatewayTypeDesc: string, lastUpdate?: any | null, title: string }> };

export type GetAllPaymentPlanQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllPaymentPlanQuery = { __typename?: 'Query', getAllPaymentPlan: Array<{ __typename?: 'paymentPlanEntity', name: string, id: string, accountId: string, commonStatus: string, effectiveDate: any, isDeletable: boolean, isExistInMasterData: Array<string>, isExistInTransactionData: Array<string>, isExistInTableData: Array<string>, isEditable: boolean, details?: Array<{ __typename?: 'paymentPlanDetailEntity', id: string, amountType: string, amountValue: number, title: string, stageSeqNo: number, isDownpayment: boolean, workProgressId: string, isWithInterest: boolean, isStakeholder: boolean, isVpStage: boolean, installmentBillingDay?: number | null, numberOfPayment?: number | null, stakeholderDuration?: number | null, workProgress?: { __typename?: 'workProgressEntity', name: string, id: string, accountId: string, systemUse: boolean } | null }> | null }> };

export type GetPaymentPlanByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPaymentPlanByIdQuery = { __typename?: 'Query', getPaymentPlanById: { __typename?: 'paymentPlanEntity', name: string, id: string, accountId: string, commonStatus: string, effectiveDate: any, isEditable: boolean, details?: Array<{ __typename?: 'paymentPlanDetailEntity', id: string, amountType: string, amountValue: number, title: string, stageSeqNo: number, isDownpayment: boolean, workProgressId: string, isWithInterest: boolean, isStakeholder: boolean, isVpStage: boolean, installmentBillingDay?: number | null, numberOfPayment?: number | null, stakeholderDuration?: number | null, workProgress?: { __typename?: 'workProgressEntity', name: string, id: string, isVp: boolean, isCarPark: boolean, systemUse: boolean } | null, includeInDetailId?: Array<{ __typename?: 'includeInDetail', paymentPlanDetailId?: string | null }> | null }> | null } };

export type GetAllPaymentPlanDetailQueryVariables = Exact<{
  planId: Scalars['String'];
}>;


export type GetAllPaymentPlanDetailQuery = { __typename?: 'Query', getAllPaymentPlanDetail: Array<{ __typename?: 'paymentPlanDetailEntity', id: string, accountId: string, amountType: string, amountValue: number, title: string, stageSeqNo: number, isDownpayment: boolean, workProgressId: string, isWithInterest: boolean, isStakeholder: boolean, isVpStage: boolean, installmentBillingDay?: number | null, numberOfPayment?: number | null, stakeholderDuration?: number | null, isDeletable: boolean, workProgress?: { __typename?: 'workProgressEntity', name: string, id: string, accountId: string, systemUse: boolean } | null }> };

export type GetPaymentPlanDetailByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPaymentPlanDetailByIdQuery = { __typename?: 'Query', getPaymentPlanDetailById: { __typename?: 'paymentPlanDetailEntity', id: string, amountType: string, amountValue: number, title: string, stageSeqNo: number, isDownpayment: boolean, workProgressId: string, isWithInterest: boolean, isStakeholder: boolean, isVpStage: boolean, installmentBillingDay?: number | null, numberOfPayment?: number | null, stakeholderDuration?: number | null, workProgress?: { __typename?: 'workProgressEntity', name: string, id: string, accountId: string, systemUse: boolean } | null } };

export type AddPaymentPlanMutationVariables = Exact<{
  input: AddPaymentPlanInput;
}>;


export type AddPaymentPlanMutation = { __typename?: 'Mutation', addPaymentPlan: boolean };

export type EditPaymentPlanMutationVariables = Exact<{
  input: EditPaymentPlanInput;
}>;


export type EditPaymentPlanMutation = { __typename?: 'Mutation', editPaymentPlan: boolean };

export type DeactivatePaymentPlanMutationVariables = Exact<{
  paymentPlanId: Scalars['String'];
}>;


export type DeactivatePaymentPlanMutation = { __typename?: 'Mutation', deactivatePaymentPlan: boolean };

export type DuplicatePaymentPlanMutationVariables = Exact<{
  input: DuplicatePaymentPlanInput;
}>;


export type DuplicatePaymentPlanMutation = { __typename?: 'Mutation', duplicatePaymentPlan: boolean };

export type DeletePaymentPlanMutationVariables = Exact<{
  paymentPlanId: Scalars['String'];
}>;


export type DeletePaymentPlanMutation = { __typename?: 'Mutation', deletePaymentPlan: boolean };

export type ActivatePaymentPlanMutationVariables = Exact<{
  paymentPlanId: Scalars['String'];
}>;


export type ActivatePaymentPlanMutation = { __typename?: 'Mutation', activatePaymentPlan: boolean };

export type DeletePaymentPlanDetailMutationVariables = Exact<{
  detailId: Scalars['String'];
}>;


export type DeletePaymentPlanDetailMutation = { __typename?: 'Mutation', deletePaymentPlanDetail: boolean };

export type GetPurchaserIdTypeListingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPurchaserIdTypeListingQuery = { __typename?: 'Query', getPurchaserIDTypeListing: Array<{ __typename?: 'purchaserIDTypeEntity', id: string, identityDoc: string, description: string }> };

export type AddPurchaserIdTypeMutationVariables = Exact<{
  input: AddPurchaserIdTypeInput;
}>;


export type AddPurchaserIdTypeMutation = { __typename?: 'Mutation', addPurchaserIDType: boolean };

export type EditPurchaserIdTypeMutationVariables = Exact<{
  id: Scalars['String'];
  input: AddPurchaserIdTypeInput;
}>;


export type EditPurchaserIdTypeMutation = { __typename?: 'Mutation', editPurchaserIDType: boolean };

export type DeletePurchaserIdTypeMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeletePurchaserIdTypeMutation = { __typename?: 'Mutation', deletePurchaserIDType: boolean };

export type GetPurchaserPaymentListingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPurchaserPaymentListingQuery = { __typename?: 'Query', getPurchaserPaymentListing?: Array<{ __typename?: 'purchaserPaymentPlanOutput', id: string, accountId: string, name: string, effectiveDate: any, markUpPercentage?: number | null, installmentSum?: number | null, recordStatus?: string | null }> | null };

export type GetPurchaserPaymentPlanDetailsListingQueryVariables = Exact<{
  purchaserPaymentPlanId: Scalars['String'];
}>;


export type GetPurchaserPaymentPlanDetailsListingQuery = { __typename?: 'Query', getPurchaserPaymentPlanDetailsListing?: Array<{ __typename?: 'purchaserPaymentPlanDetailsOutput', id: string, paymentPlanName: string, effectiveDate: any, markUpPercentage: number, title: string, noInstallment: number, deductBookingFee: string, billCount: number, billFrequency: string, billAfter: string, paymentValue: string, recordStatus?: string | null }> | null };

export type GetPurchaserPaymentPlanByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPurchaserPaymentPlanByIdQuery = { __typename?: 'Query', getPurchaserPaymentPlanById: { __typename?: 'purchaserPaymentPlanEntity', name: string, id: string, accountId: string, recordStatus: string, effectiveDate: any, markUpPercentage: number, details?: Array<{ __typename?: 'purchaserPaymentPlanDetailsEntity', id: string, purchaserPaymentPlanId: string, title: string, paymentBy: PaymentBy, paymentValue: number, billType: BillType, noInstallment: number, deductBookingFee: DeductBookingFee, billCount: number, billFrequency: BillFrequency, billAfter: string }> | null } };

export type GetPurchaserPaymentPlanEnumsOutputQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPurchaserPaymentPlanEnumsOutputQuery = { __typename?: 'Query', getPurchaserPaymentPlanEnumsOutput: { __typename?: 'PurchaserPaymentPlanEnumsOutput', paymentBy: Array<{ __typename?: 'PurchaserPaymentPlanEnum', id: string, name: string }>, billType: Array<{ __typename?: 'PurchaserPaymentPlanEnum', id: string, name: string }>, deductBookingFee: Array<{ __typename?: 'PurchaserPaymentPlanEnum', id: string, name: string }>, billFrequency: Array<{ __typename?: 'PurchaserPaymentPlanEnum', id: string, name: string }>, billAfter: Array<{ __typename?: 'PurchaserPaymentPlanEnum', id: string, name: string }> } };

export type DeletePurchaserPaymentPlanMutationVariables = Exact<{
  purchaserPaymentID: Scalars['String'];
}>;


export type DeletePurchaserPaymentPlanMutation = { __typename?: 'Mutation', deletePurchaserPaymentPlan: boolean };

export type AddPurchaserPaymentPlanMutationVariables = Exact<{
  input: AddPurchaserPaymentPlanInput;
}>;


export type AddPurchaserPaymentPlanMutation = { __typename?: 'Mutation', addPurchaserPaymentPlan: boolean };

export type EditPurchaserPaymentPlanAndDetailsMutationVariables = Exact<{
  input: EditPurchaserPaymentPlanInput;
}>;


export type EditPurchaserPaymentPlanAndDetailsMutation = { __typename?: 'Mutation', editPurchaserPaymentPlanAndDetails: boolean };

export type DeletePurchaserPaymentPlanDetailsMutationVariables = Exact<{
  purchaserDetailsId: Scalars['String'];
}>;


export type DeletePurchaserPaymentPlanDetailsMutation = { __typename?: 'Mutation', deletePurchaserPaymentPlanDetails: boolean };

export type AddPurchaserPaymentPlanDetailsMutationVariables = Exact<{
  input: AddPurchaserPaymentPlantDetailsInput;
  paymentPlanId: Scalars['String'];
}>;


export type AddPurchaserPaymentPlanDetailsMutation = { __typename?: 'Mutation', addPurchaserPaymentPlanDetails: { __typename?: 'addPurchaserPaymentPlanDetailsOutput', id?: string | null } };

export type EditPurchaserPaymentPlanMutationVariables = Exact<{
  input: EditPurchaserPaymentPlanInput;
}>;


export type EditPurchaserPaymentPlanMutation = { __typename?: 'Mutation', editPurchaserPaymentPlan: boolean };

export type EditPurchaserPaymentPlanDetailsMutationVariables = Exact<{
  input: AddPurchaserPaymentPlantDetailsInput;
}>;


export type EditPurchaserPaymentPlanDetailsMutation = { __typename?: 'Mutation', editPurchaserPaymentPlanDetails: boolean };

export type GetReasonCodeTypeListingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReasonCodeTypeListingQuery = { __typename?: 'Query', getReasonCodeTypeListing: Array<{ __typename?: 'ReasonCodeTypeListingOutput', reasonCodeType: string }> };

export type GetAllReasonCodeQueryVariables = Exact<{
  type: Scalars['String'];
}>;


export type GetAllReasonCodeQuery = { __typename?: 'Query', getAllReasonCode?: Array<{ __typename?: 'reasonCodeEntity', id: string, name: string, commonStatus: string, defaulted: boolean, type: string, systemUse: boolean, isDeletable: boolean, isExistInTransactionData: Array<string> }> | null };

export type AddReasonCodeMutationVariables = Exact<{
  input: ReasonCodeInput;
}>;


export type AddReasonCodeMutation = { __typename?: 'Mutation', addReasonCode: boolean };

export type DeleteReasonCodeByIdMutationVariables = Exact<{
  reasonCodeId: Scalars['String'];
}>;


export type DeleteReasonCodeByIdMutation = { __typename?: 'Mutation', deleteReasonCodeById: boolean };

export type EditReasonCodeMutationVariables = Exact<{
  input: EditReasonCodeInput;
}>;


export type EditReasonCodeMutation = { __typename?: 'Mutation', editReasonCode: boolean };

export type SetDefaultReasonCodeMutationVariables = Exact<{
  reasonCodeId: Scalars['String'];
  type: Scalars['String'];
}>;


export type SetDefaultReasonCodeMutation = { __typename?: 'Mutation', setDefaultReasonCode: boolean };

export type RemoveDefaultReasonCodeMutationVariables = Exact<{
  reasonCodeId: Scalars['String'];
  type: Scalars['String'];
}>;


export type RemoveDefaultReasonCodeMutation = { __typename?: 'Mutation', removeDefaultReasonCode: boolean };

export type OrganizeReasonCodeMutationVariables = Exact<{
  reasonCodeIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type OrganizeReasonCodeMutation = { __typename?: 'Mutation', organizeReasonCode: boolean };

export type ActivateReasonCodeMutationVariables = Exact<{
  reasonCodeId: Scalars['String'];
}>;


export type ActivateReasonCodeMutation = { __typename?: 'Mutation', activateReasonCode: boolean };

export type DeactivateReasonCodeMutationVariables = Exact<{
  reasonCodeId: Scalars['String'];
}>;


export type DeactivateReasonCodeMutation = { __typename?: 'Mutation', deactivateReasonCode: boolean };

export type GetStampDutyListingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStampDutyListingQuery = { __typename?: 'Query', getStampDutyListing: Array<{ __typename?: 'stampDutyEntity', id: string, code: string, description: string, commonStatus: string, stampDutyExts: Array<{ __typename?: 'stampDutyExtEntity', id: string, effectiveDate: any }> }> };

export type AddStampDutyMutationVariables = Exact<{
  input: AddStampDutyInput;
}>;


export type AddStampDutyMutation = { __typename?: 'Mutation', addStampDuty: boolean };

export type DeactivateStampDutyByIdMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeactivateStampDutyByIdMutation = { __typename?: 'Mutation', deactivateStampDutyById: boolean };

export type UpdateStampDutyMutationVariables = Exact<{
  input: UpdateStampDutyInput;
}>;


export type UpdateStampDutyMutation = { __typename?: 'Mutation', updateStampDuty: boolean };

export type GetStampDutyByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetStampDutyByIdQuery = { __typename?: 'Query', getStampDutyById: { __typename?: 'stampDutyEntity', id: string, code: string, description: string, stampDutyExts: Array<{ __typename?: 'stampDutyExtEntity', id: string, effectiveDate: any, stampDutyDetails: Array<{ __typename?: 'stampDutyDetailEntity', id: string, fromAmt: string, toAmt: string, value: string }> }> } };

export type GetStatutoryDocsListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStatutoryDocsListQuery = { __typename?: 'Query', getStatutoryDocsList?: Array<{ __typename?: 'statutoryDocumentEntity', id: string, name: string, perSalesContract: boolean, code?: string | null }> | null };

export type IsCodeExistQueryVariables = Exact<{
  code: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
}>;


export type IsCodeExistQuery = { __typename?: 'Query', isCodeExist: boolean };

export type AddStatutoryDocumentMutationVariables = Exact<{
  input: AddStatutoryDocumentIndoInput;
}>;


export type AddStatutoryDocumentMutation = { __typename?: 'Mutation', addStatutoryDocument: boolean };

export type EditStatutoryDocumentMutationVariables = Exact<{
  input: EditStatutoryDocumentIndoInput;
}>;


export type EditStatutoryDocumentMutation = { __typename?: 'Mutation', editStatutoryDocument: boolean };

export type DeleteStatutoryDocumentMutationVariables = Exact<{
  input: Scalars['String'];
}>;


export type DeleteStatutoryDocumentMutation = { __typename?: 'Mutation', deleteStatutoryDocument: boolean };

export type GetTaxSchemeListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTaxSchemeListQuery = { __typename?: 'Query', getTaxSchemeList?: Array<{ __typename?: 'TaxListOutput', id: string, name: string, description: string, commonStatus: string, modTs: any, isExclusive: boolean }> | null };

export type GetTaxSchemeByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetTaxSchemeByIdQuery = { __typename?: 'Query', getTaxSchemeById?: { __typename?: 'taxSchemeEntity', name: string, description?: string | null, isExclusive?: boolean | null, taxSchemeDetails?: Array<{ __typename?: 'taxSchemeDetailEntity', id: string, effectiveDate: any, taxSchemeDetailItems?: Array<{ __typename?: 'taxSchemeDetailItemEntity', id: string, seqNo?: number | null, taxId: string, computeMethod: string, taxOnSeq?: Array<{ __typename?: 'taxOnSeqObjects', taxSchemeDetailItemId: string, seqNo: number }> | null }> | null }> | null } | null };

export type GetTaxSchemeTaxQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTaxSchemeTaxQuery = { __typename?: 'Query', getTaxSchemeTax: Array<{ __typename?: 'TaxDropdownOutput', taxId: string, code: string, rate: number, effectiveDate: any, schemeTypeId?: string | null, schemeType?: string | null, classType?: TaxClassType | null }> };

export type AddTaxSchemeMutationVariables = Exact<{
  input: AddTaxSchemeInput;
}>;


export type AddTaxSchemeMutation = { __typename?: 'Mutation', addTaxScheme: boolean };

export type EditTaxSchemeMutationVariables = Exact<{
  input: EditTaxSchemeInput;
}>;


export type EditTaxSchemeMutation = { __typename?: 'Mutation', editTaxScheme: boolean };

export type DeactivateTaxSchemeMutationVariables = Exact<{
  taxSchemeId: Scalars['String'];
  isDeletable: Scalars['Boolean'];
}>;


export type DeactivateTaxSchemeMutation = { __typename?: 'Mutation', deactivateTaxScheme: boolean };

export type ActivateTaxSchemeMutationVariables = Exact<{
  taxSchemeId: Scalars['String'];
}>;


export type ActivateTaxSchemeMutation = { __typename?: 'Mutation', activateTaxScheme: boolean };

export type GetTaxSchemeOutputListingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTaxSchemeOutputListingQuery = { __typename?: 'Query', getTaxSchemeOutputListing: Array<{ __typename?: 'TaxSchemeDropdownOutput', taxSchemeId: string, taxSchemeName: string, effectiveDate: any, isExclusive: boolean, taxSchemeDetailId: string, totalTaxRate?: string | null, taxSchemeDetailItems?: Array<{ __typename?: 'TaxSchemeDetailItemOutput', taxId: string, taxCode: string, taxRate?: string | null }> | null }> };

export type GetTaxSchemeInputListingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTaxSchemeInputListingQuery = { __typename?: 'Query', getTaxSchemeInputListing: Array<{ __typename?: 'TaxSchemeDropdownOutput', taxSchemeId: string, taxSchemeName: string, effectiveDate: any, isExclusive: boolean, taxSchemeDetailId: string, totalTaxRate?: string | null, taxSchemeDetailItems?: Array<{ __typename?: 'TaxSchemeDetailItemOutput', taxId: string, taxCode: string, taxRate?: string | null }> | null }> };

export type CalculateTaxAmountQueryVariables = Exact<{
  input: CalculateTaxAmountInput;
}>;


export type CalculateTaxAmountQuery = { __typename?: 'Query', calculateTaxAmount: any };

export type GetTaxSchemeListingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTaxSchemeListingQuery = { __typename?: 'Query', getTaxSchemeListing: Array<{ __typename?: 'TaxSchemeListingOutput', schemeTypeId: string, schemeType: string, lastUpdatedDate?: any | null }> };

export type GetTaxListingQueryVariables = Exact<{
  schemeTypeId: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetTaxListingQuery = { __typename?: 'Query', getTaxListing?: Array<{ __typename?: 'TaxListingOutput', taxId: string, code: string, description: string, classType: string, taxStatus: string, effectiveDate?: any | null, rate?: string | null, isExistInMasterData: Array<string>, isExistInTransactionData: Array<string>, schemeTypeId?: string | null, createdDt?: any | null }> | null };

export type AddTaxMutationVariables = Exact<{
  input: AddTaxInput;
}>;


export type AddTaxMutation = { __typename?: 'Mutation', addTax: boolean };

export type EditTaxMutationVariables = Exact<{
  input: EditTaxInput;
}>;


export type EditTaxMutation = { __typename?: 'Mutation', editTax: boolean };

export type DeactivateTaxMutationVariables = Exact<{
  taxId: Scalars['String'];
  isDeletable: Scalars['Boolean'];
}>;


export type DeactivateTaxMutation = { __typename?: 'Mutation', deactivateTax: boolean };

export type ActivateTaxMutationVariables = Exact<{
  taxId: Scalars['String'];
}>;


export type ActivateTaxMutation = { __typename?: 'Mutation', activateTax: boolean };

export type GetTaxByIdQueryVariables = Exact<{
  taxId: Scalars['String'];
}>;


export type GetTaxByIdQuery = { __typename?: 'Query', getTaxById: { __typename?: 'taxEntity', code: string, description: string, classType: string, schemeTypeId: string, isClaimable: boolean, schemeType: { __typename?: 'taxSchemeTypeEntity', name: string }, taxExt: { __typename?: 'taxExtEntity', isFinal: boolean }, taxDetail: Array<{ __typename?: 'taxDetailEntity', id: string, commonStatus: string, effectiveDate: any, rate: number }> } };

export type GetTaxSchemeTypeIdQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTaxSchemeTypeIdQuery = { __typename?: 'Query', getTaxSchemeTypeID?: Array<{ __typename?: 'taxSchemeTypeEntity', id: string, code: string, name: string }> | null };

export type GetTransactionCodeListingQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetTransactionCodeListingQuery = { __typename?: 'Query', getTransactionCodeListing: Array<{ __typename?: 'taxTransactionCodeEntity', id: string, taxTrxCode: string, description: string, details?: Array<{ __typename?: 'taxTransactionCodeDetailEntity', id: string, type: string, code: string, description: string }> | null }> };

export type CreateTransactionCodeMutationVariables = Exact<{
  taxTrxCode: Scalars['String'];
  description: Scalars['String'];
}>;


export type CreateTransactionCodeMutation = { __typename?: 'Mutation', createTransactionCode: { __typename?: 'taxTransactionCodeEntity', id: string, taxTrxCode: string, description: string } };

export type UpdateTransactionCodeMutationVariables = Exact<{
  id: Scalars['String'];
  taxTrxCode?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
}>;


export type UpdateTransactionCodeMutation = { __typename?: 'Mutation', updateTransactionCode: { __typename?: 'taxTransactionCodeEntity', id: string, taxTrxCode: string, description: string } };

export type DeleteTransactionCodeMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteTransactionCodeMutation = { __typename?: 'Mutation', deleteTransactionCode: boolean };

export type CreateTransactionCodeDetailMutationVariables = Exact<{
  input: CreateTransactionCodeDetailInput;
}>;


export type CreateTransactionCodeDetailMutation = { __typename?: 'Mutation', createTransactionCodeDetail: { __typename?: 'taxTransactionCodeDetailEntity', id: string, taxTransactionCodeId: string, type: string, code: string, description: string, commonStatus: string } };

export type EditTransactionCodeDetailMutationVariables = Exact<{
  id: Scalars['String'];
  input: EditTransactionCodeDetailInput;
}>;


export type EditTransactionCodeDetailMutation = { __typename?: 'Mutation', editTransactionCodeDetail: { __typename?: 'taxTransactionCodeDetailEntity', id: string, taxTransactionCodeId: string, type: string, code: string, description: string, commonStatus: string } };

export type DeleteTransactionCodeDetailMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteTransactionCodeDetailMutation = { __typename?: 'Mutation', deleteTransactionCodeDetail: boolean };

export type GetUnitOfMeasurementsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnitOfMeasurementsQuery = { __typename?: 'Query', getUnitOfMeasurements: Array<{ __typename?: 'unitOfMeasurementEntity', id: string, uom: string, description: string, commonStatus: string }> };

export type AddUnitOfMeasurementMutationVariables = Exact<{
  input: UnitOfMeasurementMutationInput;
}>;


export type AddUnitOfMeasurementMutation = { __typename?: 'Mutation', addUnitOfMeasurement: { __typename?: 'unitOfMeasurementMutationOutput', id: string, uom: string, description: string } };

export type EditUnitOfMeasurementByIdMutationVariables = Exact<{
  id: Scalars['String'];
  input: UnitOfMeasurementMutationInput;
}>;


export type EditUnitOfMeasurementByIdMutation = { __typename?: 'Mutation', editUnitOfMeasurementById: { __typename?: 'unitOfMeasurementMutationOutput', id: string, uom: string, description: string } };

export type DeleteUnitOfMeasurementByIdMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteUnitOfMeasurementByIdMutation = { __typename?: 'Mutation', deleteUnitOfMeasurementById: string };

export type GetAllWorkProgressQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllWorkProgressQuery = { __typename?: 'Query', getAllWorkProgress?: Array<{ __typename?: 'workProgressEntity', id: string, accountId: string, name: string, commonStatus: string, isVp: boolean, isExistInMasterData: Array<string>, isExistInTransactionData: Array<string>, isSystemUse: boolean, isCarPark: boolean }> | null };

export type GetAllWorkProgressByCarParkQueryVariables = Exact<{
  isCarPark?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetAllWorkProgressByCarParkQuery = { __typename?: 'Query', getAllWorkProgressByCarPark?: Array<{ __typename?: 'workProgressEntity', id: string, accountId: string, name: string, commonStatus: string, isVp: boolean, isExistInMasterData: Array<string>, isExistInTransactionData: Array<string>, isSystemUse: boolean, isCarPark: boolean }> | null };

export type GetWorkProgressByIdQueryVariables = Exact<{
  workProgressId: Scalars['String'];
}>;


export type GetWorkProgressByIdQuery = { __typename?: 'Query', getWorkProgressById: { __typename?: 'workProgressEntity', id: string, accountId: string, name: string } };

export type AddWorkProgressMutationVariables = Exact<{
  input: WorkProgressInput;
}>;


export type AddWorkProgressMutation = { __typename?: 'Mutation', addWorkProgress: boolean };

export type EditWorkProgressMutationVariables = Exact<{
  input: EditWorkProgressInput;
}>;


export type EditWorkProgressMutation = { __typename?: 'Mutation', editWorkProgress: boolean };

export type DeactivateWorkProgressByIdMutationVariables = Exact<{
  progressId: Scalars['String'];
}>;


export type DeactivateWorkProgressByIdMutation = { __typename?: 'Mutation', deactivateWorkProgressById: boolean };

export type DeleteWorkProgressByIdMutationVariables = Exact<{
  progressId: Scalars['String'];
}>;


export type DeleteWorkProgressByIdMutation = { __typename?: 'Mutation', deleteWorkProgressById: boolean };

export type ActivateWorkProgressByIdMutationVariables = Exact<{
  progressId: Scalars['String'];
}>;


export type ActivateWorkProgressByIdMutation = { __typename?: 'Mutation', activateWorkProgressById: boolean };

export type GetBillItemListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBillItemListQuery = { __typename?: 'Query', getBillItemList?: Array<{ __typename?: 'billItemEntity', id: string, name: string, systemUse: boolean, billItemType: string, isExistInTransactionData: Array<string>, commonStatus: string, classificationId?: string | null, msicId?: string | null }> | null };

export type AddBillItemMutationVariables = Exact<{
  input: AddBillItemInput;
}>;


export type AddBillItemMutation = { __typename?: 'Mutation', addBillItem: boolean };

export type EditBillItemMutationVariables = Exact<{
  input: EditBillItemInput;
}>;


export type EditBillItemMutation = { __typename?: 'Mutation', editBillItem: boolean };

export type DeleteBillItemMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteBillItemMutation = { __typename?: 'Mutation', deleteBillItem: boolean };

export type ActivateBillItemMutationVariables = Exact<{
  billItemId: Scalars['String'];
}>;


export type ActivateBillItemMutation = { __typename?: 'Mutation', activateBillItem: boolean };

export type DeactivateBillItemMutationVariables = Exact<{
  billItemId: Scalars['String'];
}>;


export type DeactivateBillItemMutation = { __typename?: 'Mutation', deactivateBillItem: boolean };

export type GetBllItemListByTypeQueryVariables = Exact<{
  type: Scalars['String'];
}>;


export type GetBllItemListByTypeQuery = { __typename?: 'Query', getBllItemListByType?: Array<{ __typename?: 'billItemEntity', id: string, name: string }> | null };

export type GetBllItemListByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetBllItemListByIdQuery = { __typename?: 'Query', getBllItemListById: { __typename?: 'billItemEntity', id: string, name: string } };

export type GetBllItemListAtCreditAndDebitQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBllItemListAtCreditAndDebitQuery = { __typename?: 'Query', getBllItemListAtCreditAndDebit: Array<{ __typename?: 'billItemEntity', id: string, name: string, billItemType: string }> };

export type GetBillItemByTypeQueryVariables = Exact<{
  type: Scalars['String'];
}>;


export type GetBillItemByTypeQuery = { __typename?: 'Query', getBillItemByType?: Array<{ __typename?: 'billItemIntEntity', id: string, name: string, systemUse?: boolean | null, creditTerm: number, billItemType: string, gracePeriod: number, latePaymentInterest?: string | null, taxSchema?: { __typename?: 'taxSchemeEntity', id: string, name: string } | null }> | null };

export type CreateBillItemMutationVariables = Exact<{
  input: BillItemIntInput;
}>;


export type CreateBillItemMutation = { __typename?: 'Mutation', createBillItem: boolean };

export type UpdateBillItemMutationVariables = Exact<{
  input: BillItemIntInput;
}>;


export type UpdateBillItemMutation = { __typename?: 'Mutation', updateBillItem: boolean };

export type DeleteBillItemIntMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteBillItemIntMutation = { __typename?: 'Mutation', deleteBillItemInt: boolean };

export type GetClassificationCodeListingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetClassificationCodeListingQuery = { __typename?: 'Query', getClassificationCodeListing: Array<{ __typename?: 'eInvoiceClassificationEntity', id: string, classificationCode?: string | null, description?: string | null }> };

export type GetUnassignedClassificationBillItemsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnassignedClassificationBillItemsQuery = { __typename?: 'Query', getUnassignedClassificationBillItems: Array<{ __typename?: 'billItemEntity', id: string, name: string, systemUse: boolean, billItemType: string, classificationId?: string | null, msicId?: string | null }> };

export type GetAssignedClassificationBillItemsQueryVariables = Exact<{
  classificationId: Scalars['String'];
}>;


export type GetAssignedClassificationBillItemsQuery = { __typename?: 'Query', getAssignedClassificationBillItems: Array<{ __typename?: 'billItemEntity', id: string, name: string, systemUse: boolean, billItemType: string, classificationId?: string | null, msicId?: string | null }> };

export type AssignClassificationCodeMutationVariables = Exact<{
  classificationId: Scalars['String'];
  billItemIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type AssignClassificationCodeMutation = { __typename?: 'Mutation', assignClassificationCode: boolean };

export type UnassignClassificationCodeMutationVariables = Exact<{
  classificationId: Scalars['String'];
  billItemIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type UnassignClassificationCodeMutation = { __typename?: 'Mutation', unassignClassificationCode: boolean };

export type GetMsicCodeListingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMsicCodeListingQuery = { __typename?: 'Query', getMsicCodeListing: Array<{ __typename?: 'eInvoiceMsicEntity', id: string, msicCode?: string | null, description?: string | null }> };

export type GetUnassignedMsicBillItemsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnassignedMsicBillItemsQuery = { __typename?: 'Query', getUnassignedMsicBillItems: Array<{ __typename?: 'billItemEntity', id: string, name: string, systemUse: boolean, billItemType: string, classificationId?: string | null, msicId?: string | null }> };

export type GetAssignedMsicBillItemsQueryVariables = Exact<{
  msicId: Scalars['String'];
}>;


export type GetAssignedMsicBillItemsQuery = { __typename?: 'Query', getAssignedMsicBillItems: Array<{ __typename?: 'billItemEntity', id: string, name: string, systemUse: boolean, billItemType: string, classificationId?: string | null, msicId?: string | null }> };

export type AssignMsicCodeMutationVariables = Exact<{
  msicId: Scalars['String'];
  billItemIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type AssignMsicCodeMutation = { __typename?: 'Mutation', assignMsicCode: boolean };

export type UnassignMsicCodeMutationVariables = Exact<{
  msicId: Scalars['String'];
  billItemIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type UnassignMsicCodeMutation = { __typename?: 'Mutation', unassignMsicCode: boolean };

export type GetCollectionActivityListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCollectionActivityListQuery = { __typename?: 'Query', getCollectionActivityList: Array<{ __typename?: 'collectionActivityEntity', id: string, accountId: string, saleId: string, activityDate: any, activityRemark: string, completedDate: any, activityStatus: string, commonStatus: string }> };

export type GetCollectionActivityBySaleIdQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCollectionActivityBySaleIdQuery = { __typename?: 'Query', getCollectionActivityBySaleId?: Array<{ __typename?: 'PurchaserAccListing', unitNo: string, purchaserName: string, saleId: string, contactId: string, phoneNo: string, icNo: string, remark?: string | null, date?: any | null, status?: string | null, receiptDate?: any | null, receiptAmount?: number | null }> | null };

export type GetCreditControlSettingSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCreditControlSettingSummaryQuery = { __typename?: 'Query', latePaymentInterestGenerationLastUpdate?: any | null, latePaymentInterestExceptionLastUpdate?: any | null, projectReminderLastUpdate?: any | null, paymentReminderLastUpdate?: any | null, paymentReminderCount?: number | null, paymentInterestExceptionCount?: number | null, collectionActivityCount?: number | null, latePaymentInterestLastUpdated?: { __typename?: 'lateInterestSummaryInfoOutput', lastGenerateDate: any, amount: number } | null };

export type GetAllProjectLateInterestQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllProjectLateInterestQuery = { __typename?: 'Query', getAllProjectLateInterest: Array<{ __typename?: 'projectLateInterestEntity', id: string, accountId: string, projectId: string, loanGracePeriod: number, minimumInterestAmount: number, excludeHoliday: boolean, excludePaymentDate: boolean, enableFloatingInterest: boolean }> };

export type GetProjectLateInterestByIdQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProjectLateInterestByIdQuery = { __typename?: 'Query', getProjectLateInterestById?: { __typename?: 'projectLateInterestEntity', id: string, accountId: string, projectId: string, loanGracePeriod: number, minimumInterestAmount: number, excludeHoliday: boolean, excludePaymentDate: boolean, enableFloatingInterest: boolean, loanGracePeriodStartWith: string, taxSchemeId?: string | null } | null };

export type GetAllLatePaymentInterestExceptionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllLatePaymentInterestExceptionQuery = { __typename?: 'Query', getAllLatePaymentInterestException?: Array<{ __typename?: 'latePaymentInterestExceptionOutput', id: string, unitNo: string, purchaserName: string, remark: string, isVip: boolean, isCompany?: boolean | null, companyName?: string | null }> | null };

export type GetSalesFromSignedUnitQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSalesFromSignedUnitQuery = { __typename?: 'Query', getSalesFromSignedUnit: Array<{ __typename?: 'signedUnitListingOutput', unitId: string, unitNo: string, purchaserName: string, saleId: string, isVip: boolean, isCompany?: boolean | null, companyName?: string | null }> };

export type AddLatePaymentInterestMutationVariables = Exact<{
  input: AddLateInterestInput;
}>;


export type AddLatePaymentInterestMutation = { __typename?: 'Mutation', addLatePaymentInterest: boolean };

export type EditLatePaymentInterestMutationVariables = Exact<{
  input: EditLateInterestInput;
}>;


export type EditLatePaymentInterestMutation = { __typename?: 'Mutation', editLatePaymentInterest: boolean };

export type CreateLatePaymentInterestExceptionMutationVariables = Exact<{
  input: LatePaymentInterestExceptionInput;
}>;


export type CreateLatePaymentInterestExceptionMutation = { __typename?: 'Mutation', createLatePaymentInterestException: boolean };

export type UpdateLatePaymentInterestExceptionMutationVariables = Exact<{
  input: EditLatePaymentInterestExceptionInput;
}>;


export type UpdateLatePaymentInterestExceptionMutation = { __typename?: 'Mutation', updateLatePaymentInterestException: boolean };

export type DeleteLatePaymentInterestExceptionMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteLatePaymentInterestExceptionMutation = { __typename?: 'Mutation', deleteLatePaymentInterestException: boolean };

export type GetAllPaymentReminderQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllPaymentReminderQuery = { __typename?: 'Query', getAllPaymentReminder?: Array<{ __typename?: 'paymentReminderListingOutput', unitNo: Array<string>, reminder1: number, reminder2: number, reminder3: number, reminder4: number, reminderDate: any, balanceAmount: number, generationBatch: string }> | null };

export type GetPaymentReminderByGenerationBatchQueryVariables = Exact<{
  generationBatch: Scalars['String'];
}>;


export type GetPaymentReminderByGenerationBatchQuery = { __typename?: 'Query', getPaymentReminderByGenerationBatch?: { __typename?: 'generatePaymentReminderOutput', reminder1: number, reminder2: number, reminder3: number, outstanding: number, reminderList?: Array<{ __typename?: 'paymentReminderOutput', saleId: string, unitNo: string, totalBalance: number, reminder1: number, reminder2: number, reminder3: number, share?: Array<{ __typename?: 'shareObject', sharedBy: string, sharedDateTime: string, sharedMethod?: string | null }> | null, billing: Array<{ __typename?: 'paymentReminderDetailList', reminderId?: string | null, refId: string, refTable: string, docNo: string, docAmt: number, docDate: string, dueDate: string, outstanding: number, reminderDate: string, reminderSeq: number }> }> | null } | null };

export type GeneratePaymentReminderProgressBillingListQueryVariables = Exact<{
  reminderDate: Scalars['DateTime'];
}>;


export type GeneratePaymentReminderProgressBillingListQuery = { __typename?: 'Query', generatePaymentReminderProgressBillingList?: { __typename?: 'generatePaymentReminderOutput', reminder1: number, reminder2: number, reminder3: number, outstanding: number, reminderList?: Array<{ __typename?: 'paymentReminderOutput', saleId: string, unitNo: string, totalBalance: number, reminder1: number, reminder2: number, reminder3: number, share?: Array<{ __typename?: 'shareObject', sharedBy: string, sharedDateTime: string, sharedMethod?: string | null }> | null, billing: Array<{ __typename?: 'paymentReminderDetailList', reminderId?: string | null, refId: string, refTable: string, docNo: string, docAmt: number, docDate: string, dueDate: string, outstanding: number, reminderDate: string, reminderSeq: number }> }> | null } | null };

export type SharePaymentReminderMutationVariables = Exact<{
  input: SharePaymentReminderBasicInput;
}>;


export type SharePaymentReminderMutation = { __typename?: 'Mutation', sharePaymentReminder: { __typename?: 'paymentReminderShareOutput', downloadFile: boolean, isProject?: boolean | null, letterTemplateList?: Array<{ __typename?: 'shareLetterTemplateOutput', letterTemplateId: string, letterTemplateName: string }> | null, attachment?: Array<{ __typename?: 'pdfOutput', base64: string, fileName: string }> | null } };

export type SharePaymentReminderByTemplateIdMutationVariables = Exact<{
  input: SharePaymentReminderByIdInput;
}>;


export type SharePaymentReminderByTemplateIdMutation = { __typename?: 'Mutation', sharePaymentReminderByTemplateId?: Array<{ __typename?: 'pdfOutput', base64: string, fileName: string }> | null };

export type GeneratePaymentReminderListQueryVariables = Exact<{
  reminderDate: Scalars['DateTime'];
}>;


export type GeneratePaymentReminderListQuery = { __typename?: 'Query', generatePaymentReminderList?: { __typename?: 'generatePaymentRemindersOutput', reminderList: Array<{ __typename?: 'paymentReminder', unitNo: string, taxSchemeId?: string | null, numAlert: number, saleId: string, maxReminder?: number | null, alertList: Array<{ __typename?: 'alertOutput', installmentId: string, dueDate?: any | null, allocationDate?: any | null, prevAllocDate?: any | null, refTable?: string | null, intervalDays?: number | null, outstanding?: number | null, label: string, taxToDate?: number | null, finalTaxToDate?: number | null, paidToDate?: number | null, buyBackAmt?: number | null }> }> } | null };

export type GetPaymentRemindersByGenerationBatchQueryVariables = Exact<{
  generationBatch: Scalars['String'];
}>;


export type GetPaymentRemindersByGenerationBatchQuery = { __typename?: 'Query', getPaymentRemindersByGenerationBatch?: { __typename?: 'generatePaymentRemindersOutput', reminderList: Array<{ __typename?: 'paymentReminder', unitNo: string, numAlert: number, saleId: string, reminderNo?: string | null, alertList: Array<{ __typename?: 'alertOutput', reminderId?: string | null, installmentId: string, dueDate?: any | null, allocationDate?: any | null, prevAllocDate?: any | null, refTable?: string | null, intervalDays?: number | null, outstanding?: number | null, label: string }> }> } | null };

export type AddPaymentReminderListMutationVariables = Exact<{
  input: PaymentReminderListInput;
}>;


export type AddPaymentReminderListMutation = { __typename?: 'Mutation', addPaymentReminderList: boolean };

export type DeletePaymentReminderListMutationVariables = Exact<{
  input: PaymentReminderIdsInput;
}>;


export type DeletePaymentReminderListMutation = { __typename?: 'Mutation', deletePaymentReminderList: boolean };

export type GetAllProjectPaymentReminderExceptionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllProjectPaymentReminderExceptionQuery = { __typename?: 'Query', getAllProjectPaymentReminderException: Array<{ __typename?: 'paymentExceptionReminderOutput', id: string, name: string, unitNo: string, maxReminder: number, isCompany?: boolean | null, companyName?: string | null }> };

export type GetProjectPaymentReminderExceptionByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetProjectPaymentReminderExceptionByIdQuery = { __typename?: 'Query', getProjectPaymentReminderExceptionById: { __typename?: 'paymentExceptionReminderOutput', id: string, name: string, unitNo: string, maxReminder: number } };

export type GetProjectPaymentWithReminderQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProjectPaymentWithReminderQuery = { __typename?: 'Query', getProjectPaymentWithReminder: Array<{ __typename?: 'paymentWithReminderOutput', saleId: string, unitNo: string, name: string, isCompany?: boolean | null, companyName?: string | null }> };

export type AddProjectPaymentReminderExceptionMutationVariables = Exact<{
  input: Array<ProjectPaymentReminderExceptionInput> | ProjectPaymentReminderExceptionInput;
}>;


export type AddProjectPaymentReminderExceptionMutation = { __typename?: 'Mutation', addProjectPaymentReminderException: boolean };

export type EditProjectPaymentReminderExceptionMutationVariables = Exact<{
  input: EditProjectPaymentReminderExceptionInput;
}>;


export type EditProjectPaymentReminderExceptionMutation = { __typename?: 'Mutation', editProjectPaymentReminderException: boolean };

export type DeleteProjectPaymentReminderExceptionMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteProjectPaymentReminderExceptionMutation = { __typename?: 'Mutation', deleteProjectPaymentReminderException: boolean };

export type GetProjectReminderSettingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProjectReminderSettingQuery = { __typename?: 'Query', getProjectReminderSetting?: { __typename?: 'projectReminderEntity', id: string, projectId: string, spaReminder1?: number | null, spaReminder2?: number | null, spaReminder3?: number | null, spaReminder4?: number | null, downpaymentReminder1?: number | null, downpaymentReminder2?: number | null, downpaymentReminder3?: number | null, downpaymentReminder4?: number | null, paymentReminder1: number, paymentReminder2: number, paymentReminder3: number, paymentReminder4: number, minimumAmount?: number | null, paymentReminderScheduler: boolean, paymentReminderSchedulerTime: string } | null };

export type AddProjectReminderSettingMutationVariables = Exact<{
  input: AddProjectReminderInput;
}>;


export type AddProjectReminderSettingMutation = { __typename?: 'Mutation', addProjectReminderSetting: boolean };

export type EditProjectReminderSettingMutationVariables = Exact<{
  input: EditProjectReminderInput;
}>;


export type EditProjectReminderSettingMutation = { __typename?: 'Mutation', editProjectReminderSetting: boolean };

export type GetAllLateInterestQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllLateInterestQuery = { __typename?: 'Query', getAllLateInterest?: Array<{ __typename?: 'lateInterestListingOutput', generationBatch: string, generationBatchDate: any, unitNo: Array<string>, amount: number, billingCount: number, lateInterestId?: Array<string> | null }> | null };

export type GetLateInterestByIdQueryVariables = Exact<{
  generationBatchDate: Scalars['DateTime'];
  generationBatchId: Scalars['String'];
}>;


export type GetLateInterestByIdQuery = { __typename?: 'Query', getLateInterestById: Array<{ __typename?: 'lateInterestSummaryOutput', unitNo: string, saleId: string, totalDocumentAmount: number, billingCount: number, startDate: any, endDate: any, lateInterestDetail: Array<{ __typename?: 'lateInterestDetailOutput', lateInterestId: string, documentNo?: string | null, documentDate: string, documentAmount: number, documentRef?: string | null, description: string, status: string, startDate: string, endDate: string, overdueDay: string, table: string, billingId: string, lateInterestDocumentNo?: string | null, seqNo: string, interestAmount: number }> }> };

export type GenerateLatePaymentMutationVariables = Exact<{
  input: PaymentLateInterestInput;
}>;


export type GenerateLatePaymentMutation = { __typename?: 'Mutation', generateLatePayment: string };

export type UpdateLateInterestStatusMutationVariables = Exact<{
  input: UpdatePaymentLateInterestInput;
}>;


export type UpdateLateInterestStatusMutation = { __typename?: 'Mutation', updateLateInterestStatus: boolean };

export type UpdateLateInterestStatusByGenerationBatchMutationVariables = Exact<{
  input: GenerationBatchPostingInput;
}>;


export type UpdateLateInterestStatusByGenerationBatchMutation = { __typename?: 'Mutation', updateLateInterestStatusByGenerationBatch: boolean };

export type GetAssignedStaffListQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetAssignedStaffListQuery = { __typename?: 'Query', getAssignedStaffList?: Array<{ __typename?: 'assignedStaffListOutput', id: string, email: string, name: string, phone: string }> | null };

export type GetUnassignedStaffListQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetUnassignedStaffListQuery = { __typename?: 'Query', getUnassignedStaffList?: Array<{ __typename?: 'authorizedStaffListingOutput', id: string, email: string, name: string, phone: string }> | null };

export type AssignAuthorizedSaleStaffMutationVariables = Exact<{
  projectId: Scalars['String'];
  salesPersonId: Array<Scalars['String']> | Scalars['String'];
}>;


export type AssignAuthorizedSaleStaffMutation = { __typename?: 'Mutation', assignAuthorizedSaleStaff: boolean };

export type UnassignAuthorizedSaleStaffMutationVariables = Exact<{
  id: Array<Scalars['String']> | Scalars['String'];
}>;


export type UnassignAuthorizedSaleStaffMutation = { __typename?: 'Mutation', unassignAuthorizedSaleStaff: boolean };

export type GetCollectionActivityIndoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCollectionActivityIndoQuery = { __typename?: 'Query', getCollectionActivityIndo?: Array<{ __typename?: 'OverduePurchaserAccountOutput', saleId: string, unitId: string, unitNo?: string | null, fullName: string, totalDocumentAmount?: number | null, totalAllocatedAmount?: number | null, totalOutstanding?: number | null, dueDate: any, billingType?: string | null, assignTo?: string | null, assignedDate?: any | null, generateDate?: any | null, overduedPurchaserAccountId?: string | null, assignName?: string | null, activityDate?: any | null, activityRemark?: string | null }> | null };

export type GetCollectionActivityWithOpaHeadersQueryVariables = Exact<{
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  overduePurchaserAccountId: Scalars['String'];
}>;


export type GetCollectionActivityWithOpaHeadersQuery = { __typename?: 'Query', getCollectionActivityWithOPAHeaders?: { __typename?: 'overduePurchaseCAOutput', OverduePurchaserAccountDetails: { __typename?: 'OverduePurchaserAccountDetailsOutput', saleId: string, unitId: string, unitNo?: string | null, fullName: string, email?: string | null, phoneNo?: string | null, totalAllDocumentAmount?: number | null, totalAllAllocatedAmount?: number | null, totalAllOutstanding?: number | null, generateDate: any, overduePurchaser?: Array<{ __typename?: 'overduePurchaserOutput', docId: string, totalDocumentAmount?: number | null, totalAllocatedAmount?: number | null, totalOutstanding?: number | null, dueDate: any, creditTerm?: number | null, generateDate: any, billingType: string }> | null }, overduePurchaseCAListing?: Array<{ __typename?: 'overduePurchaseCAListingOutput', caId: string, saleId: string, activityDate: any, activityRemark?: string | null, activityStatus?: string | null, countDoc?: number | null }> | null } | null };

export type GetCollectionActivityIndoDetailListAndSummaryQueryVariables = Exact<{
  saleId: Scalars['String'];
}>;


export type GetCollectionActivityIndoDetailListAndSummaryQuery = { __typename?: 'Query', getCollectionActivityIndoDetailListAndSummary: { __typename?: 'collectionActivityIndoOutput', collectionActivitySummary: { __typename?: 'collectionActivityOutput', totalOutstanding: number, purchaserDetail: { __typename?: 'PurchaserAccDetail', email?: string | null, purchaserName: string, unitNo: string, phoneNo: string, clusterName: string } }, collectionActivityDetailList: Array<{ __typename?: 'collectionActivityEntity', id: string, accountId: string, saleId: string, activityDate: any, activityRemark: string, completedDate: any, activityStatus: string, commonStatus: string, attachment?: Array<{ __typename?: 'attachmentEntity', allowDelete?: boolean | null, fileName: string, id: string, isPrivate: boolean, mediaType: string, resourceUrl: string }> | null }> } };

export type GetActivityStatusTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActivityStatusTypeQuery = { __typename?: 'Query', getActivityStatusType: any };

export type GetCollectionActivityIndoDetailByIdQueryVariables = Exact<{
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  caId: Scalars['String'];
  overdueId: Scalars['String'];
}>;


export type GetCollectionActivityIndoDetailByIdQuery = { __typename?: 'Query', getCollectionActivityIndoDetailByID: { __typename?: 'overduePurchaseAccountCADetailOutput', caId: string, actionDate: any, reason?: string | null, followedUpName?: string | null, attachments?: Array<{ __typename?: 'overdueCAAttachment', attachmentId: string, fileName: string, resourceUrl: string, mediaType: string }> | null, OverduePurchaserAccountDetails: { __typename?: 'OverduePurchaserAccountDetailsOutput', saleId: string, unitId: string, unitNo?: string | null, fullName: string, email?: string | null, phoneNo?: string | null, totalAllDocumentAmount?: number | null, totalAllAllocatedAmount?: number | null, totalAllOutstanding?: number | null } } };

export type UpdatePaCollectionActivityIndoMutationVariables = Exact<{
  input: UpdatePaCollectionActivityInput;
}>;


export type UpdatePaCollectionActivityIndoMutation = { __typename?: 'Mutation', updatePACollectionActivityIndo: boolean };

export type AddPaCollectionActivityIndoMutationVariables = Exact<{
  input: AddOverduePurchaseCaInput;
}>;


export type AddPaCollectionActivityIndoMutation = { __typename?: 'Mutation', addPACollectionActivityIndo: boolean };

export type EditPaCollectionActivityIndoMutationVariables = Exact<{
  input: EditOverduePurchaseCaInput;
}>;


export type EditPaCollectionActivityIndoMutation = { __typename?: 'Mutation', editPACollectionActivityIndo: boolean };

export type GetAllPaymentInterestExceptionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllPaymentInterestExceptionQuery = { __typename?: 'Query', getAllPaymentInterestException: Array<{ __typename?: 'paymentInterestExceptionOutput', saleId: string, unitNo: string, fullName: string, isVip?: boolean | null, remark: string }> };

export type GetAllPaymentInterestExceptionFormQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllPaymentInterestExceptionFormQuery = { __typename?: 'Query', getAllPaymentInterestExceptionForm: Array<{ __typename?: 'paymentInterestExceptionFormOutput', saleId: string, unitNo: string, fullName: string, isVip?: boolean | null }> };

export type AddPaymentInterestExceptionMutationVariables = Exact<{
  input: Array<AddPaymentinterestExceptionInput> | AddPaymentinterestExceptionInput;
}>;


export type AddPaymentInterestExceptionMutation = { __typename?: 'Mutation', addPaymentInterestException: boolean };

export type EditPaymentInterestExceptionMutationVariables = Exact<{
  input: EditPaymentinterestExceptionInput;
}>;


export type EditPaymentInterestExceptionMutation = { __typename?: 'Mutation', editPaymentInterestException: boolean };

export type DeletePaymentInterestExceptionMutationVariables = Exact<{
  input: DeletePaymentinterestExceptionInput;
}>;


export type DeletePaymentInterestExceptionMutation = { __typename?: 'Mutation', deletePaymentInterestException: boolean };

export type OverduePurchaserAccountListingQueryVariables = Exact<{
  projectId: Scalars['String'];
  saleId?: InputMaybe<Scalars['String']>;
}>;


export type OverduePurchaserAccountListingQuery = { __typename?: 'Query', overduePurchaserAccountListing: { __typename?: 'OverduePurchaserAccountListingOutput', assign?: Array<{ __typename?: 'OverduePurchaserAccountOutput', saleId: string, unitId: string, unitNo?: string | null, fullName: string, totalDocumentAmount?: number | null, totalAllocatedAmount?: number | null, totalOutstanding?: number | null, dueDate: any, billingType?: string | null, assignTo?: string | null, assignedDate?: any | null, generateDate?: any | null, createdTimestamp?: string | null, overduedPurchaserAccountId?: string | null, assignName?: string | null, activityDate?: any | null, activityRemark?: string | null }> | null, notAssign?: Array<{ __typename?: 'OverduePurchaserAccountOutput', saleId: string, unitId: string, unitNo?: string | null, fullName: string, totalDocumentAmount?: number | null, totalAllocatedAmount?: number | null, totalOutstanding?: number | null, dueDate: any, billingType?: string | null, assignTo?: string | null, assignedDate?: any | null, generateDate?: any | null, createdTimestamp?: string | null, overduedPurchaserAccountId?: string | null, activityDate?: any | null, activityRemark?: string | null }> | null } };

export type OverduePurchaserAccountSummaryQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type OverduePurchaserAccountSummaryQuery = { __typename?: 'Query', overduePurchaserAccountSummary: { __typename?: 'OverduePurchaserAccountSummaryOutput', sumAllOutstandingAmount?: number | null, countAllDataNotAssign?: number | null } };

export type GetOverdueUserListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOverdueUserListQuery = { __typename?: 'Query', getOverdueUserList: Array<{ __typename?: 'overdueUserListOutput', userId: string, fullName?: string | null }> };

export type OverduePurchaserAccountCaListingQueryVariables = Exact<{
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  overduePurchaserAccountId: Scalars['String'];
}>;


export type OverduePurchaserAccountCaListingQuery = { __typename?: 'Query', overduePurchaserAccountCAListing?: { __typename?: 'overduePurchaseCAOutput', OverduePurchaserAccountDetails: { __typename?: 'OverduePurchaserAccountDetailsOutput', saleId: string, unitId: string, unitNo?: string | null, fullName: string, email?: string | null, phoneNo?: string | null, totalAllDocumentAmount?: number | null, totalAllAllocatedAmount?: number | null, totalAllOutstanding?: number | null, generateDate: any, assignTo?: string | null, overduePurchaser?: Array<{ __typename?: 'overduePurchaserOutput', docId: string, totalDocumentAmount?: number | null, totalAllocatedAmount?: number | null, totalOutstanding?: number | null, dueDate: any, creditTerm?: number | null, generateDate: any, billingType: string }> | null }, overduePurchaseCAListing?: Array<{ __typename?: 'overduePurchaseCAListingOutput', caId: string, saleId: string, activityDate: any, activityRemark?: string | null, activityStatus?: string | null, countDoc?: number | null }> | null } | null };

export type GetOverduePurchaseAccountCaDetailQueryVariables = Exact<{
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  caId: Scalars['String'];
  overdueId: Scalars['String'];
}>;


export type GetOverduePurchaseAccountCaDetailQuery = { __typename?: 'Query', getOverduePurchaseAccountCADetail: { __typename?: 'overduePurchaseAccountCADetailOutput', caId: string, actionDate: any, reason?: string | null, followedUpName?: string | null, attachments?: Array<{ __typename?: 'overdueCAAttachment', attachmentId: string, fileName: string, resourceUrl: string, mediaType: string }> | null, OverduePurchaserAccountDetails: { __typename?: 'OverduePurchaserAccountDetailsOutput', saleId: string, unitId: string, unitNo?: string | null, fullName: string, email?: string | null, phoneNo?: string | null, totalAllDocumentAmount?: number | null, totalAllAllocatedAmount?: number | null, totalAllOutstanding?: number | null } } };

export type GetOverduePurchaseAccountHeaderQueryVariables = Exact<{
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  overdueId: Scalars['String'];
}>;


export type GetOverduePurchaseAccountHeaderQuery = { __typename?: 'Query', getOverduePurchaseAccountHeader: { __typename?: 'OverduePurchaserAccountDetailsOutput', saleId: string, unitId: string, unitNo?: string | null, fullName: string, email?: string | null, phoneNo?: string | null, totalAllDocumentAmount?: number | null, totalAllAllocatedAmount?: number | null, totalAllOutstanding?: number | null } };

export type GetOverdueInstallmentDetailsQueryVariables = Exact<{
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  interval: Scalars['String'];
  overdueId: Scalars['String'];
}>;


export type GetOverdueInstallmentDetailsQuery = { __typename?: 'Query', getOverdueInstallmentDetails: { __typename?: 'getOverdueInstallmentDetailsOutput', installment?: Array<{ __typename?: 'overduePurchaserInstallmentOutput', docId: string, totalDocumentAmount?: number | null, totalAllocatedAmount?: number | null, totalOutstanding?: number | null, dueDate: any, description?: string | null, billingType?: string | null, itemName?: string | null }> | null, debitNote?: Array<{ __typename?: 'overduePurchaserInstallmentOutput', docId: string, totalDocumentAmount?: number | null, totalAllocatedAmount?: number | null, totalOutstanding?: number | null, dueDate: any, description?: string | null, billingType?: string | null, itemName?: string | null }> | null, miscBilling?: Array<{ __typename?: 'overduePurchaserInstallmentOutput', docId: string, totalDocumentAmount?: number | null, totalAllocatedAmount?: number | null, totalOutstanding?: number | null, dueDate: any, description?: string | null, billingType?: string | null, itemName?: string | null }> | null, packagesInstallment?: Array<{ __typename?: 'overduePurchaserInstallmentOutput', docId: string, totalDocumentAmount?: number | null, totalAllocatedAmount?: number | null, totalOutstanding?: number | null, dueDate: any, description?: string | null, billingType?: string | null, itemName?: string | null }> | null, carparkInstallment?: Array<{ __typename?: 'overduePurchaserInstallmentOutput', docId: string, totalDocumentAmount?: number | null, totalAllocatedAmount?: number | null, totalOutstanding?: number | null, dueDate: any, description?: string | null, billingType?: string | null, itemName?: string | null }> | null, lateInterest?: Array<{ __typename?: 'overduePurchaserInstallmentOutput', docId: string, totalDocumentAmount?: number | null, totalAllocatedAmount?: number | null, totalOutstanding?: number | null, dueDate: any, description?: string | null, billingType?: string | null, itemName?: string | null }> | null } };

export type GetOverdueAgingQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetOverdueAgingQuery = { __typename?: 'Query', getOverdueAging: { __typename?: 'getOverdueAgingOutputs', agingId?: string | null, projectId?: string | null, companyId?: string | null, period1?: number | null, period2?: number | null, period3?: number | null, period4?: number | null, period5?: number | null, period6?: number | null } };

export type AddOverduePurchaseCaMutationVariables = Exact<{
  input: AddOverduePurchaseCaInput;
}>;


export type AddOverduePurchaseCaMutation = { __typename?: 'Mutation', addOverduePurchaseCA: boolean };

export type EditOverduePurchaseCaMutationVariables = Exact<{
  input: EditOverduePurchaseCaInput;
}>;


export type EditOverduePurchaseCaMutation = { __typename?: 'Mutation', editOverduePurchaseCA: boolean };

export type AssignOverduedPaMutationVariables = Exact<{
  input: Array<AssignOverduedPaInput> | AssignOverduedPaInput;
}>;


export type AssignOverduedPaMutation = { __typename?: 'Mutation', assignOverduedPA: boolean };

export type UpdateStatusOverduePurchaseCaMutationVariables = Exact<{
  input: UpdateStatusOverduePurchaseCaInput;
}>;


export type UpdateStatusOverduePurchaseCaMutation = { __typename?: 'Mutation', updateStatusOverduePurchaseCA: boolean };

export type GenerateProgressBillingReminderMutationVariables = Exact<{
  reminderDate: Scalars['DateTime'];
}>;


export type GenerateProgressBillingReminderMutation = { __typename?: 'Mutation', generateProgressBillingReminder?: { __typename?: 'downpaymentReminderDetailOutput', reminder1: number, reminder2: number, reminder3: number, totalBalance: number, reminderList: Array<{ __typename?: 'progressBillingReminderOutput', reminderId: string, progressBillingId: string, saleId: string, isCompany?: boolean | null, companyName?: string | null, unitNo: string, docNo: string, reminderSeq: number, balanceAmount: number, buyerName: string, share?: Array<{ __typename?: 'shareObject', sharedBy: string, sharedDateTime: string, sharedMethod?: string | null }> | null }> } | null };

export type GetAllDownpaymentReminderQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllDownpaymentReminderQuery = { __typename?: 'Query', getAllDownpaymentReminder?: Array<{ __typename?: 'downpaymentReminderListingOutput', reminderDate: any, generationBatch: string, reminder1: number, reminder2: number, reminder3: number, amount: number, unitNo: Array<string> }> | null };

export type GetDownpaymentReminderByIdQueryVariables = Exact<{
  reminderDate: Scalars['DateTime'];
  generationBatch: Scalars['String'];
}>;


export type GetDownpaymentReminderByIdQuery = { __typename?: 'Query', getDownpaymentReminderById?: { __typename?: 'downpaymentReminderDetailOutput', reminder1: number, reminder2: number, reminder3: number, totalBalance: number, reminderList: Array<{ __typename?: 'progressBillingReminderOutput', reminderId: string, progressBillingId: string, saleId: string, isCompany?: boolean | null, companyName?: string | null, unitNo: string, docNo: string, reminderSeq: number, balanceAmount: number, buyerName: string, share?: Array<{ __typename?: 'shareObject', sharedBy: string, sharedDateTime: string, sharedMethod?: string | null }> | null }> } | null };

export type ShareDownpaymentReminderMutationVariables = Exact<{
  input: ShareDownpaymentReminderInput;
}>;


export type ShareDownpaymentReminderMutation = { __typename?: 'Mutation', shareDownpaymentReminder?: { __typename?: 'downpaymentShareOutput', downloadFile: boolean, isProject?: boolean | null, letterTemplateList?: Array<{ __typename?: 'shareLetterTemplateOutput', letterTemplateId: string, letterTemplateName: string }> | null, attachment?: Array<{ __typename?: 'pdfOutput', base64: string, fileName: string }> | null } | null };

export type ShareDownpaymentReminderByTemplateIdMutationVariables = Exact<{
  input: ShareDownpaymentReminderByIdInput;
}>;


export type ShareDownpaymentReminderByTemplateIdMutation = { __typename?: 'Mutation', shareDownpaymentReminderByTemplateId?: Array<{ __typename?: 'pdfOutput', base64: string, fileName: string }> | null };

export type GetFinancierListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFinancierListQuery = { __typename?: 'Query', getFinancierList: Array<{ __typename?: 'financierEntity', id: string, name: string, financierLastUpdate?: any | null, financierCode?: string | null, financierId?: string | null, officeTel?: string | null, logoUrl?: string | null, commonStatus: string, projectLoanNumberCount?: number | null, loanNumberCount?: number | null, financierTotalLoanAmount?: number | null, isExistInTransactionData: Array<string>, address?: { __typename?: 'AddressJson', address?: string | null, city?: string | null, state?: string | null, country?: string | null, postCode?: string | null } | null }> };

export type GetActiveFinancierListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveFinancierListQuery = { __typename?: 'Query', activeFinancierList: Array<{ __typename?: 'financierEntity', id: string, name: string, financierLastUpdate?: any | null, financierCode?: string | null, financierId?: string | null, officeTel?: string | null, logoUrl?: string | null, commonStatus: string, assignedProjectCount: number, address?: { __typename?: 'AddressJson', address?: string | null, city?: string | null, state?: string | null, country?: string | null, postCode?: string | null } | null }> };

export type GetFinancierDetailListingQueryVariables = Exact<{
  financierId: Scalars['String'];
}>;


export type GetFinancierDetailListingQuery = { __typename?: 'Query', getFinancierDetailListing: Array<{ __typename?: 'endFinancierDetailListingOutput', projectName?: string | null, projectSaleCount?: number | null, projectTotalLoanAmount?: number | null, projectTotalPendingAmount?: number | null }> };

export type GetFinancierDetailQueryVariables = Exact<{
  financierId: Scalars['String'];
}>;


export type GetFinancierDetailQuery = { __typename?: 'Query', getFinancierDetail: { __typename?: 'financierEntity', id: string, name: string, bankId?: string | null, officeTel?: string | null, logoUrl?: string | null, financierId?: string | null, financierCode?: string | null, projectLoanNumberCount?: number | null, loanNumberCount?: number | null, financierTotalLoanAmount?: number | null, disbursementFinancierId?: string | null, bank?: { __typename?: 'companyBankAccountEntity', id: string, code: string, commonStatus: string, bankProfile: { __typename?: 'companyBankProfileEntity', name: string } } | null, address?: { __typename?: 'AddressJson', address?: string | null, city?: string | null, state?: string | null, country?: string | null, postCode?: string | null } | null, financierContact: Array<{ __typename?: 'financierContactEntity', id: string, name: string, phoneNo: string, email: string }> } };

export type CreateFinancierMutationVariables = Exact<{
  input: FinancierInput;
}>;


export type CreateFinancierMutation = { __typename?: 'Mutation', createFinancier: boolean };

export type AddFinancierContactMutationVariables = Exact<{
  financierId: Scalars['String'];
  input: FinancierContact;
}>;


export type AddFinancierContactMutation = { __typename?: 'Mutation', addFinancierContact: boolean };

export type SuspendEndFinancierMutationVariables = Exact<{
  financierId: Scalars['String'];
}>;


export type SuspendEndFinancierMutation = { __typename?: 'Mutation', suspendEndFinancier: boolean };

export type EditFinancierMutationVariables = Exact<{
  input: FinancierInput;
}>;


export type EditFinancierMutation = { __typename?: 'Mutation', editFinancier: boolean };

export type DeleteFinancierMutationVariables = Exact<{
  financierId: Scalars['String'];
}>;


export type DeleteFinancierMutation = { __typename?: 'Mutation', deleteFinancier: boolean };

export type GetMortgagePlansListQueryVariables = Exact<{
  financier_id: Scalars['String'];
}>;


export type GetMortgagePlansListQuery = { __typename?: 'Query', getMortgagePlansList: Array<{ __typename?: 'mortgagePlanEntity', id: string, name: string, payments?: Array<{ __typename?: 'mortgagePaymentEntity', id: string, name: string, percentage: string, paymentEvent: string, eventItem?: string | null, eventStatutoryDocId?: string | null, expectedCount: number, expectedFreq: string, expectedFrom: string, endfinancierMortgagePlanId: string, retentions?: Array<{ __typename?: 'mortgageRetentionEntity', id: string, name: string, retentionBy: string, retentionValue: string, retentionEvent: string, eventItem?: string | null, eventStatutoryDocId?: string | null, expectedCount: number, expectedFreq: string, expectedFrom: string, endfinMortgagePaymentId: string }> | null }> | null }> };

export type GetPaymentFormMasterDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPaymentFormMasterDataQuery = { __typename?: 'Query', getPaymentFormMasterData: any };

export type GetRetentionFormMasterDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRetentionFormMasterDataQuery = { __typename?: 'Query', getRetentionFormMasterData: any };

export type CreateMortgagePlanMutationVariables = Exact<{
  input: MortgagePlanInput;
}>;


export type CreateMortgagePlanMutation = { __typename?: 'Mutation', createMortgagePlan: boolean };

export type IsMortgagePlanExistQueryVariables = Exact<{
  input: MortgagePlanValidationInput;
}>;


export type IsMortgagePlanExistQuery = { __typename?: 'Query', isMortgagePlanExist: boolean };

export type EditMortgagePlanMutationVariables = Exact<{
  input: MortgagePlanInput;
}>;


export type EditMortgagePlanMutation = { __typename?: 'Mutation', editMortgagePlan: boolean };

export type DeleteMortgagePlanMutationVariables = Exact<{
  input: Scalars['String'];
}>;


export type DeleteMortgagePlanMutation = { __typename?: 'Mutation', deleteMortgagePlan: boolean };

export type CreateMortgagePaymentMutationVariables = Exact<{
  input: MortgagePaymentInput;
}>;


export type CreateMortgagePaymentMutation = { __typename?: 'Mutation', createMortgagePayment: boolean };

export type IsMortgagePaymentExistQueryVariables = Exact<{
  input: MortgagePaymentValidationInput;
}>;


export type IsMortgagePaymentExistQuery = { __typename?: 'Query', isMortgagePaymentExist: boolean };

export type EditMortgagePaymentMutationVariables = Exact<{
  input: MortgagePaymentInput;
}>;


export type EditMortgagePaymentMutation = { __typename?: 'Mutation', editMortgagePayment: boolean };

export type DeleteMortgagePaymentMutationVariables = Exact<{
  input: Scalars['String'];
}>;


export type DeleteMortgagePaymentMutation = { __typename?: 'Mutation', deleteMortgagePayment: boolean };

export type CreateMortgageRetentionMutationVariables = Exact<{
  input: MortgageRetentionInput;
}>;


export type CreateMortgageRetentionMutation = { __typename?: 'Mutation', createMortgageRetention: boolean };

export type IsMortgageRetentionExistQueryVariables = Exact<{
  input: MortgageRetentionValidationInput;
}>;


export type IsMortgageRetentionExistQuery = { __typename?: 'Query', isMortgageRetentionExist: boolean };

export type EditMortgageRetentionMutationVariables = Exact<{
  input: MortgageRetentionInput;
}>;


export type EditMortgageRetentionMutation = { __typename?: 'Mutation', editMortgageRetention: boolean };

export type DeleteMortgageRetentionMutationVariables = Exact<{
  input: Scalars['String'];
}>;


export type DeleteMortgageRetentionMutation = { __typename?: 'Mutation', deleteMortgageRetention: boolean };

export type GetOptionListQueryVariables = Exact<{
  financierId?: InputMaybe<Scalars['String']>;
}>;


export type GetOptionListQuery = { __typename?: 'Query', getOptionList: Array<{ __typename?: 'optionListOutput', id?: string | null, name?: string | null }> };

export type ProjectsQueryVariables = Exact<{
  limit: Scalars['Float'];
  page: Scalars['Float'];
  search?: InputMaybe<Scalars['String']>;
}>;


export type ProjectsQuery = { __typename?: 'Query', allProject?: { __typename?: 'WorkDeskProjectListOutput', totalUnread?: number | null, projectCount?: number | null, projects?: Array<{ __typename?: 'WorkDeskProjectOutput', projectId: string, projectName: string, unReadNotification?: number | null, firstGalleryImageUrl?: string | null, newBooking?: number | null, newAssignment?: number | null, newAppointment?: number | null, others?: number | null }> | null } | null };

export type GetTodoListQueryVariables = Exact<{
  limit: Scalars['Float'];
  page: Scalars['Float'];
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetTodoListQuery = { __typename?: 'Query', todoList: { __typename?: 'TodoListOutput', total: number, projects: Array<{ __typename?: 'TodoOutput', details: { __typename?: 'projectEntity', id: string, name: string, firstGalleryImage?: { __typename?: 'ProjectResourceOuput', resourceid?: string | null, url?: string | null } | null }, count: { __typename?: 'TodoCountOutput', total?: number | null } }> } };

export type GetTodoListCountQueryVariables = Exact<{
  limit: Scalars['Float'];
  page: Scalars['Float'];
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetTodoListCountQuery = { __typename?: 'Query', todoList: { __typename?: 'TodoListOutput', totalCountTodoList: number } };

export type GetAccountNameHomeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAccountNameHomeQuery = { __typename?: 'Query', getAccountNameHome: any };

export type GetUnreadNotificationListCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnreadNotificationListCountQuery = { __typename?: 'Query', unReadNotificationCount?: number | null };

export type GetRemainingSubscriptionDaysQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRemainingSubscriptionDaysQuery = { __typename?: 'Query', getRemainingSubscriptionDays: number };

export type DeleteAppointmentMutationVariables = Exact<{
  appointmentId: Scalars['String'];
}>;


export type DeleteAppointmentMutation = { __typename?: 'Mutation', deleteAppointment: boolean };

export type GetAppointmentsForDayQueryVariables = Exact<{
  appointmentDate?: InputMaybe<Scalars['String']>;
}>;


export type GetAppointmentsForDayQuery = { __typename?: 'Query', getManyAppointmentForDay?: Array<{ __typename?: 'AppointmentEntity', id: string, startTime: string, endTime: string, salePerson: { __typename?: 'sUserEntity', ID: string, name?: string | null }, appointmentPurpose: { __typename?: 'AppointmentTypeEntity', name: string }, project: { __typename?: 'projectEntity', id: string, name: string } }> | null };

export type AddAppointmentMutationVariables = Exact<{
  input: NewAppointmentInput;
}>;


export type AddAppointmentMutation = { __typename?: 'Mutation', addAppointment: boolean };

export type EditAppointmentMutationVariables = Exact<{
  input: NewAppointmentInput;
  appointmentId: Scalars['String'];
}>;


export type EditAppointmentMutation = { __typename?: 'Mutation', editAppointment: boolean };

export type GetDefaultAppointmentStartEndTimeQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetDefaultAppointmentStartEndTimeQuery = { __typename?: 'Query', getDefaultAppointmentStartEndTime: { __typename?: 'appointmentSchedulingEntity', id: string, projectId: string, startTime: string, endTime: string } };

export type GetEditAppointmentQueryVariables = Exact<{
  appointmentId: Scalars['String'];
}>;


export type GetEditAppointmentQuery = { __typename?: 'Query', getOneAppointment: { __typename?: 'AppointmentEntity', id: string, appointmentDate: any, startTime: string, endTime: string, needManagerAssistant: boolean, remarks: string, participantLimit: number, project: { __typename?: 'projectEntity', id: string, name: string }, salePerson: { __typename?: 'sUserEntity', ID: string, name?: string | null }, saleTeam: { __typename?: 'saleTeamEntity', id: string, name: string }, appointmentPurpose: { __typename?: 'AppointmentTypeEntity', id: string, name: string }, lead: { __typename?: 'leadContactEntity', id: string, fullName: string, phoneNo: string, email: string }, leadSourceFromLead?: { __typename?: 'leadEntity', leadSource: { __typename?: 'leadSourceEntity', id: string, name: string } } | null } };

export type GetFormDataQueryVariables = Exact<{
  limit: Scalars['Float'];
  page: Scalars['Float'];
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetFormDataQuery = { __typename?: 'Query', allProjectInvolve?: Array<{ __typename?: 'ProjectInvolvementLevel', level?: string | null, project?: { __typename?: 'projectEntity', id: string, name: string } | null }> | null, getManyAppointmentType: Array<{ __typename?: 'AppointmentTypeEntity', id: string, name: string }> };

export type GetSalesPersonQueryVariables = Exact<{
  teamID: Scalars['String'];
}>;


export type GetSalesPersonQuery = { __typename?: 'Query', getSalesPerson?: Array<{ __typename?: 'sUserEntity', ID: string, name?: string | null }> | null };

export type GetTeamsQueryVariables = Exact<{
  projectID: Scalars['String'];
}>;


export type GetTeamsQuery = { __typename?: 'Query', getTeams?: Array<{ __typename?: 'saleTeamEntity', id: string, name: string }> | null };

export type LeadGetMasterDataQueryVariables = Exact<{ [key: string]: never; }>;


export type LeadGetMasterDataQuery = { __typename?: 'Query', GetAllMasterInfo: { __typename?: 'MasterDataOutput', LeadSources: Array<{ __typename?: 'leadSourceEntity', id: string, name: string, commonStatus: string, defaulted: boolean }> } };

export type GetDaysAppointmentQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDaysAppointmentQuery = { __typename?: 'Query', getDaysOfAppointment?: Array<any> | null };

export type GetNotificationsListQueryVariables = Exact<{
  limit: Scalars['Float'];
  page: Scalars['Float'];
  search?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['String']>;
}>;


export type GetNotificationsListQuery = { __typename?: 'Query', getNotificationsList: any };

export type MarkAllReadQueryVariables = Exact<{
  projectId?: InputMaybe<Scalars['String']>;
}>;


export type MarkAllReadQuery = { __typename?: 'Query', markAllRead: boolean };

export type MarkAsReadMutationVariables = Exact<{
  notificationIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type MarkAsReadMutation = { __typename?: 'Mutation', markAsRead: boolean };

export type GetNewsAnnouncementListQueryVariables = Exact<{
  limit: Scalars['Float'];
  page: Scalars['Float'];
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetNewsAnnouncementListQuery = { __typename?: 'Query', getNewsAnnouncement: { __typename?: 'newsAnnouncementPurchaserOutput', total: number, newsData?: Array<{ __typename?: 'newsAnnouncementEntity', id: string, title: string, startDate: any, endDate: any, attachment?: Array<{ __typename?: 'attachmentEntity', id: string, seqNo: number, resourceUrl: string }> | null }> | null } };

export type GetNewsDetailsQueryVariables = Exact<{
  newsId: Scalars['String'];
}>;


export type GetNewsDetailsQuery = { __typename?: 'Query', getNewsDetails: { __typename?: 'newsAnnouncementEntity', id: string, title: string, description?: string | null, startDate: any, endDate: any, attachment?: Array<{ __typename?: 'attachmentEntity', id: string, seqNo: number, resourceUrl: string }> | null } };

export type GetKeyCollectionAppointmentListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetKeyCollectionAppointmentListQuery = { __typename?: 'Query', getKeyCollectionAppointmentList?: Array<{ __typename?: 'keyAppointmentList', id: string, unitNo: string, keyCollectionTimeslotId: string, contactName: string, date: any, time: string, userName: string, saleId: string, status: string, plumberId?: string | null, plumberName?: string | null, electricianId?: string | null, electricianName?: string | null, alarmVendorId?: string | null, alarmVendorName?: string | null, siteSupervisorId?: string | null, siteSupervisorName?: string | null, noOfKey?: number | null }> | null };

export type GetKeyCollectionAppointmentByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetKeyCollectionAppointmentByIdQuery = { __typename?: 'Query', getKeyCollectionAppointmentById: { __typename?: 'keyAppointmentList', id: string, unitNo: string, keyCollectionTimeslotId: string, contactName: string, date: any, time: string, userName: string, saleId: string, status: string, plumberId?: string | null, plumberName?: string | null, electricianId?: string | null, electricianName?: string | null, alarmVendorId?: string | null, alarmVendorName?: string | null, siteSupervisorId?: string | null, siteSupervisorName?: string | null, handOverDate?: any | null, keysCollected?: number | null, sanitaryDate?: any | null, sanitaryRemark?: string | null, electricalDate?: any | null, electricalRemark?: string | null } };

export type AddKeyCollectionAppointmentMutationVariables = Exact<{
  input: KeyCollectionAppointmentInput;
}>;


export type AddKeyCollectionAppointmentMutation = { __typename?: 'Mutation', addKeyCollectionAppointment: boolean };

export type EditKeyCollectionAppointmentMutationVariables = Exact<{
  input: EditKeyCollectionAppointmentInput;
}>;


export type EditKeyCollectionAppointmentMutation = { __typename?: 'Mutation', editKeyCollectionAppointment: boolean };

export type CompleteKeyCollectionAppointmentMutationVariables = Exact<{
  input: CompletedCollectionAppointment;
}>;


export type CompleteKeyCollectionAppointmentMutation = { __typename?: 'Mutation', completeKeyCollectionAppointment: boolean };

export type DeleteKeyCollectionAppointmentByIdMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteKeyCollectionAppointmentByIdMutation = { __typename?: 'Mutation', deleteKeyCollectionAppointmentById: boolean };

export type CancelKeyCollectionAppointmentMutationVariables = Exact<{
  id: Scalars['String'];
  saleId: Scalars['String'];
}>;


export type CancelKeyCollectionAppointmentMutation = { __typename?: 'Mutation', cancelKeyCollectionAppointment: boolean };

export type GetUnitsForKeyCollectionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnitsForKeyCollectionQuery = { __typename?: 'Query', getUnitsForKeyCollection?: Array<{ __typename?: 'keyCollectionUnitList', saleId: string, unitId: string, unitNo: string, fullName: string }> | null };

export type GetTimeSlotByDateQueryVariables = Exact<{
  date: Scalars['DateTime'];
}>;


export type GetTimeSlotByDateQuery = { __typename?: 'Query', getTimeSlotByDate?: { __typename?: 'scheduleDetail', scheduleId: string, userData: Array<{ __typename?: 'userList', id: string, name: string }>, timeSlot: Array<{ __typename?: 'projectKeyCollectionSettingOutput', scheduleTime: string, timeSlotDetail: Array<{ __typename?: 'timeSlotDetail', id: string, userId: string, available: boolean, unitNo?: string | null }> }> } | null };

export type GetContractorByTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContractorByTypeQuery = { __typename?: 'Query', getContractorByType: { __typename?: 'contractorListByType', PLUMBER?: Array<{ __typename?: 'contractorDetail', id: string, name: string, contractorType: string }> | null, ELECTRICIAN?: Array<{ __typename?: 'contractorDetail', id: string, name: string, contractorType: string }> | null, ALARM_VENDOR?: Array<{ __typename?: 'contractorDetail', id: string, name: string, contractorType: string }> | null, SITE_SUPERVISOR?: Array<{ __typename?: 'contractorDetail', id: string, name: string, contractorType: string }> | null } };

export type GetOsAmountQueryVariables = Exact<{
  saleId: Scalars['String'];
}>;


export type GetOsAmountQuery = { __typename?: 'Query', getOSAmount?: any | null };

export type GetAllProjectKeyCollectionContractorQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllProjectKeyCollectionContractorQuery = { __typename?: 'Query', getAllProjectKeyCollectionContractor?: Array<{ __typename?: 'projectKeyCollectionContractorEntity', id: string, name: string, contactNo: string, email: string, contractorType: string, commonStatus: string }> | null };

export type GetProjectKeyCollectionContractorByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetProjectKeyCollectionContractorByIdQuery = { __typename?: 'Query', getProjectKeyCollectionContractorById: { __typename?: 'projectKeyCollectionContractorEntity', name: string, contactNo: string, email: string, contractorType: string } };

export type AddProjectKeyCollectionContractorMutationVariables = Exact<{
  input: ProjectKeyCollectionContractorInput;
}>;


export type AddProjectKeyCollectionContractorMutation = { __typename?: 'Mutation', addProjectKeyCollectionContractor: boolean };

export type EditProjectKeyCollectionContractorMutationVariables = Exact<{
  input: EditProjectKeyCollectionContractorInput;
}>;


export type EditProjectKeyCollectionContractorMutation = { __typename?: 'Mutation', editProjectKeyCollectionContractor: boolean };

export type DeleteProjectKeyCollectionContractorByIdMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteProjectKeyCollectionContractorByIdMutation = { __typename?: 'Mutation', deleteProjectKeyCollectionContractorById: boolean };

export type GetKeyCollectionContractorTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetKeyCollectionContractorTypeQuery = { __typename?: 'Query', getKeyCollectionContractorType: any };

export type GetAllProjectKeyCollectionScheduleQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllProjectKeyCollectionScheduleQuery = { __typename?: 'Query', getAllProjectKeyCollectionSchedule?: Array<{ __typename?: 'projectKeyCollectionScheduleEntity', projectId: string, id: string, accountId: string, startDate: any, endDate: any, startTime: string, endTime: string, interval: number, isDeletable: boolean }> | null };

export type AddProjectKeyCollectionScheduleMutationVariables = Exact<{
  input: ProjectKeyCollectionInput;
}>;


export type AddProjectKeyCollectionScheduleMutation = { __typename?: 'Mutation', addProjectKeyCollectionSchedule: boolean };

export type DeleteProjectKeyCollectionScheduleMutationVariables = Exact<{
  collectionKeyScheduleID: Scalars['String'];
}>;


export type DeleteProjectKeyCollectionScheduleMutation = { __typename?: 'Mutation', deleteProjectKeyCollectionSchedule: boolean };

export type GetKeyCollectionSettingSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetKeyCollectionSettingSummaryQuery = { __typename?: 'Query', keyCollectionContractorLastUpdate?: any | null, keyCollectionScheduleLastUpdate?: any | null, keyCollectionAppointmentLastUpdate?: any | null };

export type GetDateByScheduleIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetDateByScheduleIdQuery = { __typename?: 'Query', getDateByScheduleId: { __typename?: 'projectKeySummaryOutput', dateList: Array<any>, startDate: any, endDate: any, startTime: string, endTime: string, teamMember: Array<{ __typename?: 'userList', id: string, name: string }> } };

export type GetProjectKeyCollectionScheduleByIdQueryVariables = Exact<{
  date: Scalars['DateTime'];
  id: Scalars['String'];
}>;


export type GetProjectKeyCollectionScheduleByIdQuery = { __typename?: 'Query', getProjectKeyCollectionScheduleByID: Array<{ __typename?: 'projectKeyCollectionSettingOutput', scheduleTime: string, timeSlotDetail: Array<{ __typename?: 'timeSlotDetail', id: string, userId: string, available: boolean }> }> };

export type GetAllLadQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllLadQuery = { __typename?: 'Query', getAllLad: Array<{ __typename?: 'ladListingOutput', generationBatchDate: any, generationBatchId: string, totalUnitAndFacilityAmount: number, unitsByBatchCount: number, unitLadAmount: number, isSimulate: boolean, facilityLadAmount?: number | null }> };

export type GetUnitsLadFormSourceQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnitsLadFormSourceQuery = { __typename?: 'Query', getUnitsLadFormSource: Array<{ __typename?: 'blockListingOutput', block: string, totalFloor: number, floorList?: Array<{ __typename?: 'floorListingOutput', floorLabel?: string | null, totalUnit?: number | null, unitList?: Array<{ __typename?: 'UnitListingOutput', unitId?: string | null, unitNo?: string | null }> | null }> | null }> };

export type GetPostedLadDetailByIdQueryVariables = Exact<{
  generationBatch: Scalars['String'];
}>;


export type GetPostedLadDetailByIdQuery = { __typename?: 'Query', getPostedLadDetailById: { __typename?: 'ladDetailOutput', totalUnit: number, totalUnitLadAmount: number, totalFacilityLadAmount: number, totalAllUnitFacilityAmount: number, generationBatchDate: any, LADDetailListing: Array<{ __typename?: 'ladDetailListingOutput', saleId: string, unitId: string, unitNo: string, ladId: string, unitDuesDay: number, facilityDuesDay: number, actualUnitLADAmount: number, actualFacilityLADAmount: number, totalUnitFacilityAmount: number, contraId: string, isAllocated: boolean, documentNo: string }> } };

export type GetSimulatedLadDetailByIdQueryVariables = Exact<{
  generationBatch: Scalars['String'];
}>;


export type GetSimulatedLadDetailByIdQuery = { __typename?: 'Query', getSimulatedLadDetailById: { __typename?: 'ladSimulatedDetailOutput', totalUnit: number, totalUnitLadAmount: number, totalFacilityLadAmount: number, totalAllUnitFacilityAmount: number, generationBatchDate: any, LADDetailListing: Array<{ __typename?: 'ladSimulatedDetailListingOutput', saleId: string, unitId: string, unitNo: string, unitDuesDay: number, facilityDuesDay: number, actualUnitLADAmount: number, actualFacilityLADAmount: number, totalUnitFacilityAmount: number }> } };

export type AddLadMutationVariables = Exact<{
  input: AddLadInput;
}>;


export type AddLadMutation = { __typename?: 'Mutation', addLad: boolean };

export type DeleteLadMutationVariables = Exact<{
  ladId: Scalars['String'];
}>;


export type DeleteLadMutation = { __typename?: 'Mutation', deleteLad: boolean };

export type ReversalLadMutationVariables = Exact<{
  input: ReversalLadInput;
}>;


export type ReversalLadMutation = { __typename?: 'Mutation', reversalLad: boolean };

export type CalculateLadGenerateValueQueryVariables = Exact<{
  input: CalculateLadGenerateValueInput;
}>;


export type CalculateLadGenerateValueQuery = { __typename?: 'Query', calculateLADGenerateValue: { __typename?: 'ladGenerateOutput', totalUnit: number, totalUnitLadAmount: number, totalAllUnitFacilityAmount: number, totalFacilityLadAmount: number, LADGenerateListing: Array<{ __typename?: 'ladCalculateGenerateOutput', saleId: string, unitId: string, unitNo: string, actualUnitLADAmount: number, unitDuesDay: number, facilityDuesDay: number, actualFacilityLADAmount: number, totalUnitFacilityAmount: number, totalUnitFacilityAmountWithoutTax: number, totalTaxAmount: number }> } };

export type GetProjectLadByProjectIdQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProjectLadByProjectIdQuery = { __typename?: 'Query', getProjectLadByProjectId?: { __typename?: 'projectLadEntity', id: string, accountId: string, projectId: string, startWith: string, unitLadPercent: number, unitDuration: number, payoutPercent: number, spaPercent?: number | null, commonFacility: boolean, facilityLadPercent?: number | null, facilityLadDuration?: number | null, taxSchemeId: string, commonStatus: string } | null };

export type AddProjectLadMutationVariables = Exact<{
  input: ProjectLadInput;
}>;


export type AddProjectLadMutation = { __typename?: 'Mutation', addProjectLad: boolean };

export type EditProjectLadMutationVariables = Exact<{
  input: EditProjectLadInput;
}>;


export type EditProjectLadMutation = { __typename?: 'Mutation', editProjectLad: boolean };

export type GetLadSettingSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLadSettingSummaryQuery = { __typename?: 'Query', ladSettingLastUpdate?: any | null, projectLadLastUpdate?: any | null, ladProcessingCount?: number | null };

export type GetLandDepositListingByProjectQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetLandDepositListingByProjectQuery = { __typename?: 'Query', getLandDepositListingByProject?: Array<{ __typename?: 'SalesLandDepositOutput', saleDate: any, saleNo: string, unitNo: string, purchaserName: string, ujpPaidAmt: number, ujppPaidAmt: number, ujpTotalAmt: number, ujppTotalAmt: number, ujpBillingAmt: number, ujppBillingAmt: number, paidCounter: number, salePrice: number, saleId: string }> | null };

export type GetPaidLandDepositsListingBySaleQueryVariables = Exact<{
  saleId: Scalars['String'];
}>;


export type GetPaidLandDepositsListingBySaleQuery = { __typename?: 'Query', getLandDepositBySale?: { __typename?: 'SalesLandDepositOutput', saleDate: any, saleNo: string, unitNo: string, purchaserName: string, ujpPaidAmt: number, ujppPaidAmt: number, ujpTotalAmt: number, ujpBillingAmt: number, ujppBillingAmt: number, ujppCurrentOutstanding: number, ujpCurrentOutstanding: number, ujppTotalAmt: number, paidCounter: number, salePrice: number } | null, getPaidLandDepositsListingBySale: Array<{ __typename?: 'PaidLandDepositsOutput', id: string, depositDate: any, depositType: string, depositAmount: number }> };

export type GetPaidLandDepositByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
  saleId: Scalars['String'];
}>;


export type GetPaidLandDepositByIdQuery = { __typename?: 'Query', getLandDepositBySale?: { __typename?: 'SalesLandDepositOutput', saleDate: any, saleNo: string, unitNo: string, purchaserName: string, ujpPaidAmt: number, ujppPaidAmt: number, ujpBillingAmt: number, ujppBillingAmt: number, paidCounter: number, salePrice: number } | null, getPaidLandDepositById?: { __typename?: 'DepositOutput', id: string, depositType: string, depositAmount: number, documentNo: string, paymentMethod: string, bankName: string, description: string, depositDate: any } | null };

export type GetLandDepositFormMasterDataQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetLandDepositFormMasterDataQuery = { __typename?: 'Query', getLandDepositFormMasterData: any };

export type GetLandDepositFormMasterDataByProjectQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetLandDepositFormMasterDataByProjectQuery = { __typename?: 'Query', getLandDepositFormMasterDataByProject: any };

export type CreatePaidLandDepositMutationVariables = Exact<{
  input: PaidLandDepositInput;
}>;


export type CreatePaidLandDepositMutation = { __typename?: 'Mutation', createPaidLandDeposit: boolean };

export type GetSaleLoanListingForIndoQueryVariables = Exact<{
  status?: InputMaybe<Scalars['String']>;
  keySearch?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
}>;


export type GetSaleLoanListingForIndoQuery = { __typename?: 'Query', getSaleLoanListingForIndo: Array<{ __typename?: 'saleLoanListingOutputForIndo', id: string, borrowerName: string, loanSignDate?: any | null, saleLoanNo?: string | null, approvalStatus: string, unitNo: string, financier: string, approvedPercentage: number, applyAmount?: number | null, approvedAmount?: number | null }> };

export type GetLoanApplyUnitForLoanApprovalQueryVariables = Exact<{
  projectId: Scalars['String'];
  saleLoanID?: InputMaybe<Scalars['String']>;
}>;


export type GetLoanApplyUnitForLoanApprovalQuery = { __typename?: 'Query', getLoanApplyUnitForLoanApproval: Array<{ __typename?: 'saleLoanUnitInfoOutput', saleId: string, id: string, unitNo: string, fullName: string, appliedAmt: number }> };

export type GetLoanApplyForLoanApprovalQueryVariables = Exact<{
  unitId: Scalars['String'];
}>;


export type GetLoanApplyForLoanApprovalQuery = { __typename?: 'Query', getLoanApplyForLoanApproval: { __typename?: 'saleLoanInfoOutput', fullName: string } };

export type GetEndFinancierForLoanApprovalQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetEndFinancierForLoanApprovalQuery = { __typename?: 'Query', getEndFinancierForLoanApproval: Array<{ __typename?: 'endFinancierOutput', id: string, financierName: string, financierBankId?: string | null }> };

export type GetMortgagePlanFromFinancierIdQueryVariables = Exact<{
  financierId: Scalars['String'];
}>;


export type GetMortgagePlanFromFinancierIdQuery = { __typename?: 'Query', getMortgagePlanFromFinancierId: Array<{ __typename?: 'mortgagePlanOutput', id: string, mortgagePlanName: string }> };

export type GetMortgagePaymentFromMortgagePlanIdQueryVariables = Exact<{
  mortgageId: Scalars['String'];
}>;


export type GetMortgagePaymentFromMortgagePlanIdQuery = { __typename?: 'Query', getMortgagePaymentFromMortgagePlanId: Array<{ __typename?: 'mortgagePaymentOutput', id: string, endfinancierMortgagePlanId: string, mortgagePaymentName: string, mortgagePercentage: number, mortgageExpectedCount: string, mortgageExpectedFreq: string, mortgageExpectedFrom: string, sumRetention?: number | null, retention?: Array<{ __typename?: 'newMortgageRetentionOutput', retentionId: string, retentionName: string, retentionValue: number, retentionBy: string, retentionExpectedCount: string, retentionExpectedFreq: string, retentionExpectedFrom: string, endfinMortgagePaymentId: string }> | null }> };

export type GetMortgagePaymentFromMortgagePlanIdWithSaleLoanIdQueryVariables = Exact<{
  mortgageId: Scalars['String'];
  saleLoanId: Scalars['String'];
}>;


export type GetMortgagePaymentFromMortgagePlanIdWithSaleLoanIdQuery = { __typename?: 'Query', getMortgagePaymentFromMortgagePlanIdWithSaleLoanId: Array<{ __typename?: 'mortgagePaymentOutput', id: string, endfinancierMortgagePlanId: string, mortgagePaymentName: string, mortgagePercentage: number, mortgageExpectedCount: string, mortgageExpectedFreq: string, mortgageExpectedFrom: string, retention?: Array<{ __typename?: 'newMortgageRetentionOutput', retentionId: string, retentionName: string, retentionValue: number, retentionBy: string, retentionExpectedCount: string, retentionExpectedFreq: string, retentionExpectedFrom: string, endfinMortgagePaymentId: string }> | null }> };

export type GetInstallmentBySaleIdQueryVariables = Exact<{
  saleId: Scalars['String'];
}>;


export type GetInstallmentBySaleIdQuery = { __typename?: 'Query', getInstallmentBySaleId: { __typename?: 'salePaymentPlanOutput', id: string, isFixAmt: boolean, value: number, paymentAmt: number } };

export type GetMortgageRetentionFromPaymentIdQueryVariables = Exact<{
  paymentId: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetMortgageRetentionFromPaymentIdQuery = { __typename?: 'Query', getMortgageRetentionFromPaymentId: Array<{ __typename?: 'mortgageRetentionOutput', id: string, name: string, retentionValue: number, retentionBy: string, retentionExpectedCount: string, retentionExpectedFreq: string, retentionExpectedFrom: string, endfinMortgagePaymentId: string }> };

export type GetSaleLoanInfoBasedOnSaleLoanIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetSaleLoanInfoBasedOnSaleLoanIdQuery = { __typename?: 'Query', getSaleLoanInfoBasedOnSaleLoanId: { __typename?: 'salePaymentPlanOutputForViewOnly', id: string, accountId: string, unitId: string, unitNo: string, applyAmount: number, approvedAmount: number, financierName: string, financierId: string, financierReference: string, loanSignDate: any, constructionDate: any, fullName: string, borrowerName?: string | null, endfinancierMortgagePlanId: string, mortgageName: string, description: string, loanPeriod?: number | null, loanInterestRate?: number | null, loanInterestMonth?: number | null, approvalStatus: string, saleLoanNo?: string | null, submittedBy: string, submittedDate: any, payment?: Array<{ __typename?: 'payment', paymentId?: string | null, paymentName?: string | null, loanAmount?: string | null, expectedCount?: string | null, expectedFreq?: string | null, expectedFrom?: string | null, endfinMortgagePaymentId?: string | null, retention?: Array<{ __typename?: 'retention', retentionId?: string | null, retentionName?: string | null, loanAmount?: string | null, expectedCount?: string | null, expectedFreq?: string | null, expectedFrom?: string | null, endfinMortgageRetentionId?: string | null }> | null }> | null } };

export type InsertNewSaleLoanMutationVariables = Exact<{
  input: SaleLoanInput;
}>;


export type InsertNewSaleLoanMutation = { __typename?: 'Mutation', insertNewSaleLoan: boolean };

export type UpdateLoanApprovalMutationVariables = Exact<{
  input: UpdateSaleLoanApprovalInput;
}>;


export type UpdateLoanApprovalMutation = { __typename?: 'Mutation', updateLoanApproval: boolean };

export type UpdateSaleLoanApprvalMutationVariables = Exact<{
  input: UpdateSaleLoanApprovalFormInput;
}>;


export type UpdateSaleLoanApprvalMutation = { __typename?: 'Mutation', updateSaleLoanApprval: boolean };

export type GetLoanDifferentialListingQueryVariables = Exact<{
  projectId: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
}>;


export type GetLoanDifferentialListingQuery = { __typename?: 'Query', getLoanDifferentialListing: Array<{ __typename?: 'loanDifferentialListingOutput', id: string, borrowerName: string, applyAmount?: number | null, approvedAmount?: number | null, unitNo: string, financier: string, approvalDate?: any | null, rescheduled?: boolean | null, rescheduling?: string | null, clusterCode: string, saleId: string, rescheduleId?: string | null, rescheduleApprovalStatus?: string | null }> };

export type GetPendingInstallmentByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPendingInstallmentByIdQuery = { __typename?: 'Query', getPendingInstallmentById: Array<{ __typename?: 'pendingInstallmentByIdOutput', id: string, borrowerName: string, approvedAmount?: number | null, applyAmount?: number | null, unitNo: string, clusterCode: string, saleId: string, financier: string, approvalDate?: any | null, bookDate?: any | null, fullName: string, salesNo: string, rescheduleDate?: any | null, installments: Array<{ __typename?: 'RescheduledInstallmentOutput', unallocatedAmount?: number | null, id: string, commonStatus: string, taxAmount?: number | null, baseAmount?: number | null, documentDate?: any | null, documentAmount: number, billType: string, description: string }> }> };

export type RescheduledLoanDifferentialMutationVariables = Exact<{
  input: RescheduleLoanInput;
}>;


export type RescheduledLoanDifferentialMutation = { __typename?: 'Mutation', rescheduledLoanDifferential: boolean };

export type GetApprovedLoanRescheduleListQueryVariables = Exact<{
  saleId: Scalars['String'];
  rescheduleId: Scalars['String'];
}>;


export type GetApprovedLoanRescheduleListQuery = { __typename?: 'Query', getApprovedLoanRescheduleList: Array<{ __typename?: 'getApprovedLoanRescheduleListOutput', rescheduleid?: string | null, installmentid?: string | null, isbuyerportion?: boolean | null, billtype?: string | null, ledgertype?: string | null, isselected?: boolean | null, documentdate?: any | null, description?: string | null, documentamount?: number | null, rescheduleno?: string | null, rescheduledate?: any | null, expiredate?: any | null, expiryby?: string | null, baseamt?: number | null, taxamt?: number | null, unallocatedamount?: number | null, oldinstallmentid?: string | null, commonstatus?: string | null }> };

export type GetRescheduleLoanQueryVariables = Exact<{
  rescheduleId: Scalars['String'];
}>;


export type GetRescheduleLoanQuery = { __typename?: 'Query', getRescheduleLoan: { __typename?: 'getRescheduleLoanOutput', premiumAmount: number, billType: string, startDate: any, description: string, submittedBy: string, submittedDate: any, noInstallment: number, unitNo: string, projectClusterName: string, salesRegistrationNo: string } };

export type GetLoanDifferentialCountQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetLoanDifferentialCountQuery = { __typename?: 'Query', getLoanDifferentialCount: { __typename?: 'loanDifferentialCountOutput', pendingCount?: number | null, completedCount?: number | null } };

export type GetLoanPaymentListingByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetLoanPaymentListingByIdQuery = { __typename?: 'Query', getLoanPaymentListingById: { __typename?: 'loanPaymentListingByIdOutput', id: string, loanReleaseId: string, referenceNo: string, financier: string, documentAmt: number, documentDate: any, bankAccountId: string, saleLoanPaymentPlanDetails?: Array<{ __typename?: 'saleLoanPaymentPlanDetailsOutput', sale_id: string, sale_loan_id?: string | null, sale_loan_payment_plan_id?: string | null, amount?: number | null, unit_no: string, name?: string | null }> | null } };

export type GetLoanPaymentListingQueryVariables = Exact<{
  projectId: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetLoanPaymentListingQuery = { __typename?: 'Query', getLoanPaymentListing: Array<{ __typename?: 'loanPaymentListingOutput', id: string, referenceNo: string, documentAmt: number, documentDate: any, financier: string, approvalStatus: string, loanPaymentNo?: string | null }> };

export type GetLoanPaymentDetailsQueryVariables = Exact<{
  saleLoanPaymentId: Scalars['String'];
}>;


export type GetLoanPaymentDetailsQuery = { __typename?: 'Query', getLoanPaymentDetails: { __typename?: 'loanPaymentDetailOutput', loanPaymentNo: string, loanPaymentDate: any, loanReleaseNo: string, loanReleaseDate: any, endFinancier: string, disbursementBankAccount?: string | null, mortgagePlan: string, paymentName?: string | null, paymentPercentage?: number | null, retentionId?: string | null, retentionName?: string | null, retentionBy?: string | null, retentionValue?: number | null, submittedBy: string, submittedDate: any, approvedBy: string, approvedDate?: any | null, totalApproveAmt?: number | null, approvedAmtLoanExt?: number | null, saleLoanPaymentPlanDetails?: Array<{ __typename?: 'saleLoanPaymentPlanDetailsOutput', sale_id: string, sale_loan_id?: string | null, sale_loan_no?: string | null, sale_loan_payment_plan_id?: string | null, unit_no: string, name?: string | null, amount?: number | null, approvedAmt?: string | null }> | null } };

export type GetLoanPaymentSummaryQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetLoanPaymentSummaryQuery = { __typename?: 'Query', getLoanPaymentSummary: { __typename?: 'loanPaymentSummaryOutput', posted: number, draft: number } };

export type GetUnitForPaymentPlanDetailsQueryVariables = Exact<{
  loanPaymentPlanDetails: Array<UnitForPaymentPlanDetailsInput> | UnitForPaymentPlanDetailsInput;
}>;


export type GetUnitForPaymentPlanDetailsQuery = { __typename?: 'Query', getUnitForPaymentPlanDetails: Array<{ __typename?: 'saleLoanPaymentPlanDetailsOutput', sale_id: string, sale_loan_id?: string | null, sale_loan_payment_plan_id?: string | null, sale_loan_refinancing_id?: string | null, sale_loan_refinancing_payment_plan_id?: string | null, sale_loan_refinancing_retention_id?: string | null, amount?: number | null, unit_no: string, name?: string | null }> };

export type AddLoanPaymentMutationVariables = Exact<{
  input: AddLoanPaymentInput;
  projectId: Scalars['String'];
  status: Scalars['String'];
}>;


export type AddLoanPaymentMutation = { __typename?: 'Mutation', addLoanPayment: boolean };

export type EditLoanPaymentMutationVariables = Exact<{
  input: AddLoanPaymentInput;
  projectId: Scalars['String'];
  id: Scalars['String'];
  status: Scalars['String'];
}>;


export type EditLoanPaymentMutation = { __typename?: 'Mutation', editLoanPayment: boolean };

export type DeleteLoanPaymentMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteLoanPaymentMutation = { __typename?: 'Mutation', deleteLoanPayment: boolean };

export type GetLoanReleaseListingQueryVariables = Exact<{
  projectId: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
}>;


export type GetLoanReleaseListingQuery = { __typename?: 'Query', getLoanReleaseListing: Array<{ __typename?: 'getLoanReleaseListingOutput', id: string, docNo?: string | null, releaseDate?: any | null, isPaid: boolean, approvalStatus: string, submittedDate?: any | null, amtPerPaymentPlan: string, submittedBy?: string | null, approvedDate?: any | null, approvedBy?: string | null, financierId: string, endFinancierMortgageId: string, endfinMortgagePaymentPlanId?: string | null, endfinMortgageRetentionId?: string | null, isSaleLoanPayment: boolean, isSaleLoanRefinancing: boolean, saleLoanPaymentPlanDetails?: Array<{ __typename?: 'SaleLoanNotice', amount: number, sale_id: string, sale_loan_id?: string | null, sale_loan_refinancing_id?: string | null, sale_loan_payment_plan_id?: string | null, sale_loan_retention_id?: string | null, sale_loan_refinancing_payment_plan_id?: string | null, sale_loan_refinancing_retention_id?: string | null }> | null, financier?: { __typename?: 'financierEntity', name: string, id: string } | null, mortgagePayment?: { __typename?: 'mortgagePaymentEntity', id: string, name: string } | null, mortgagePlan?: { __typename?: 'mortgagePlanEntity', id: string, name: string } | null, mortgageRetention?: { __typename?: 'mortgageRetentionEntity', id: string, name: string } | null }> };

export type GetLoanReleasesQueryVariables = Exact<{
  projectId: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
}>;


export type GetLoanReleasesQuery = { __typename?: 'Query', getLoanReleases: Array<{ __typename?: 'getLoanReleaseListingOutput', id: string, docNo?: string | null, releaseDate?: any | null, isPaid: boolean, approvalStatus: string, submittedDate?: any | null, amtPerPaymentPlan: string, submittedBy?: string | null, approvedDate?: any | null, approvedBy?: string | null, financierId: string, endFinancierMortgageId: string, endfinMortgagePaymentPlanId?: string | null, endfinMortgageRetentionId?: string | null, saleLoanPaymentPlanDetails?: Array<{ __typename?: 'SaleLoanNotice', sale_loan_payment_plan_id?: string | null, amount: number, sale_id: string, sale_loan_id?: string | null }> | null, financier?: { __typename?: 'financierEntity', name: string, id: string } | null, mortgagePayment?: { __typename?: 'mortgagePaymentEntity', id: string, name: string } | null, mortgagePlan?: { __typename?: 'mortgagePlanEntity', id: string, name: string } | null, mortgageRetention?: { __typename?: 'mortgageRetentionEntity', id: string, name: string } | null }> };

export type GetSaleLoanTableListingQueryVariables = Exact<{
  financierId: Scalars['String'];
  endfinancierMortgagePlanId: Scalars['String'];
  type: Scalars['String'];
  paymentId: Scalars['String'];
  saleLoanReleaseId: Scalars['String'];
  loanSignDate: Scalars['DateTime'];
}>;


export type GetSaleLoanTableListingQuery = { __typename?: 'Query', getSaleLoanTableListing: Array<{ __typename?: 'getSaleLoanTableListingOutput', sale_loan_id: string, full_name: string, sale_loan_amount?: string | null, sale_id: string, unit_no: string, emp_name: string, apply_amt: number, approved_amt: number, is_refinanced: boolean, table_ref?: string | null, sale_loan_payment_plan_id?: string | null }> };

export type GetSaleLoanDetailsQueryVariables = Exact<{
  saleLoanReleaseId: Scalars['String'];
}>;


export type GetSaleLoanDetailsQuery = { __typename?: 'Query', getSaleLoanDetails: { __typename?: 'getSaleLoanDetailOutput', saleLoanPaymentId: string, docNo?: string | null, financierId: string, financierName: string, mortgageId: string, mortgageName: string, paymentId?: string | null, paymentName?: string | null, paymentPercentage?: number | null, retentionId?: string | null, retentionName?: string | null, retentionBy?: string | null, retentionValue?: number | null, submittedBy?: string | null, submittedName?: string | null, releaseDate?: any | null, approvedDate?: any | null, submittedDate?: any | null, totalApproveAmt?: number | null, approvedName?: string | null, approvedBy?: string | null, saleLoanPaymentPlanDetails?: Array<{ __typename?: 'saleLoanReleasePaymentPlanDetailsOutput', saleLoanId: string, saleId: string, unitId: string, unitNo: string, approvedAmt: string, appAmt: string, saleLoanNo: string, fullName: string }> | null } };

export type GetAttachmentReleaseQueryVariables = Exact<{
  refId: Scalars['String'];
}>;


export type GetAttachmentReleaseQuery = { __typename?: 'Query', getAttachmentRelease: Array<{ __typename?: 'attachmentEntity', id: string, mediaType: string, resourceUrl: string, fileName: string, seqNo: number }> };

export type AddSaleLoanReleaseMutationVariables = Exact<{
  input: SaleLoanReleaseInput;
}>;


export type AddSaleLoanReleaseMutation = { __typename?: 'Mutation', addSaleLoanRelease: boolean };

export type EditSaleLoanReleaseMutationVariables = Exact<{
  id: Scalars['String'];
  input: SaleLoanReleaseInput;
  fileDB?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  fileOld?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type EditSaleLoanReleaseMutation = { __typename?: 'Mutation', editSaleLoanRelease: boolean };

export type DeleteSaleLoanReleaseMutationVariables = Exact<{
  releaseId: Scalars['String'];
}>;


export type DeleteSaleLoanReleaseMutation = { __typename?: 'Mutation', deleteSaleLoanRelease: boolean };

export type ApproveSaleLoanReleaseMutationVariables = Exact<{
  releaseId: Scalars['String'];
}>;


export type ApproveSaleLoanReleaseMutation = { __typename?: 'Mutation', approveSaleLoanRelease: boolean };

export type RejectSaleLoanReleaseMutationVariables = Exact<{
  releaseId: Scalars['String'];
}>;


export type RejectSaleLoanReleaseMutation = { __typename?: 'Mutation', rejectSaleLoanRelease: boolean };

export type GetLoanReleaseNotificationELetterQueryVariables = Exact<{
  saleLoanIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  financierId: Scalars['String'];
  letterTemplateId: Scalars['String'];
  loanReleaseId?: InputMaybe<Scalars['String']>;
  mortgagePaymentId?: InputMaybe<Scalars['String']>;
  mortgageRetentionId?: InputMaybe<Scalars['String']>;
}>;


export type GetLoanReleaseNotificationELetterQuery = { __typename?: 'Query', getLoanReleaseNotificationELetter: { __typename?: 'ELetterOutput', content: string, fileName: string } };

export type GetLoanReleaseNotificationProjectELetterListingQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetLoanReleaseNotificationProjectELetterListingQuery = { __typename?: 'Query', getLoanReleaseNotificationProjectELetterListing?: Array<{ __typename?: 'ELetterProjectLetterOutput', id: string, name: string, letterType: string, defaulted: boolean }> | null };

export type GetSaleLoanReleaseCountQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetSaleLoanReleaseCountQuery = { __typename?: 'Query', getSaleLoanReleaseCount: { __typename?: 'SaleLoanReleaseCountOutput', draftCount: number, submittedCount: number, approvedCount: number } };

export type GetAllMotTrackingQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetAllMotTrackingQuery = { __typename?: 'Query', getAllMotTracking: Array<{ __typename?: 'motTrackingListingOutput', id: string, unitNo: string, titleExecutionDate: any, titleNotificationDate: any }> };

export type GetAllUnitMotTrackingQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetAllUnitMotTrackingQuery = { __typename?: 'Query', getAllUnitMotTracking?: Array<{ __typename?: 'motTrackingUnitOutput', saleId: string, unitNo: string, hsdHsmNo?: string | null, lotPtNo?: string | null, buyerSolicitorName?: string | null, buyerSolicitorCode?: string | null, developerSolicitorName?: string | null, developerSolicitorCode?: string | null }> | null };

export type GetMotTrackingByIdQueryVariables = Exact<{
  projectId: Scalars['String'];
  id: Scalars['String'];
}>;


export type GetMotTrackingByIdQuery = { __typename?: 'Query', getMotTrackingById?: { __typename?: 'motTrackingDetailOutput', unitNo: string, hsdHsmNo?: string | null, lotPtNo?: string | null, titleExecutionDate: any, titleNotificationDate: any, titleForward: any, motReceiptNo: string, motTransferDate: any, motSubmissionNo: string, motSubmissionDate: any, motMortgageNo: string, motMortgageDate: any, instructionToSolicitor: any, motIn: any, motOut: any, receiveMotCancellation: any, forwardMotDirector: any, receiveMotDirector: any, forwardMotComSec: any, receiveMotComSec: any, receiveLawyerAcknowledgement: any, requestForTitle: any, releaseForTitle: any, receivedTitleDutyTransferred: any, confirmationPresentationReceipt: any, receivedFrom?: string | null, stampDutyPaymentDate: any, stampDutyPayment: number, remark?: string | null, buyerSolicitorName?: string | null, buyerSolicitorCode?: string | null, developerSolicitorName?: string | null, developerSolicitorCode?: string | null, motSolicitorId: string, motSolicitorReferenceNo?: string | null } | null };

export type AddMotTrackingMutationVariables = Exact<{
  input: AddMotTrackingInput;
}>;


export type AddMotTrackingMutation = { __typename?: 'Mutation', addMotTracking: boolean };

export type EditMotTrackingMutationVariables = Exact<{
  input: EditMotTrackingInput;
}>;


export type EditMotTrackingMutation = { __typename?: 'Mutation', editMotTracking: boolean };

export type DeleteMotTrackingMutationVariables = Exact<{
  motTrackingId: Scalars['String'];
}>;


export type DeleteMotTrackingMutation = { __typename?: 'Mutation', deleteMotTracking: boolean };

export type GetNupListingQueryVariables = Exact<{
  projectId: Scalars['String'];
  approvalStatus?: InputMaybe<Scalars['String']>;
  nupId?: InputMaybe<Scalars['String']>;
}>;


export type GetNupListingQuery = { __typename?: 'Query', getNupListing?: Array<{ __typename?: 'getNupOutput', id: string, unitId: string, contactId: string, agentName: string, unitNo: string, cluster: string, type: string, media: string, code: string, status: string, amount: number, description?: string | null, remarks: string, reason: string, reservedDate: any, expiredDate: any, nupNumber?: string | null, rejectedBy?: string | null, rejectedTs?: any | null, ktpUrl?: string | null, npwpUrl?: string | null, paymentUrl?: string | null, contact?: { __typename?: 'contactNupJson', name?: string | null } | null }> | null };

export type SubmitNupMutationVariables = Exact<{
  status: Scalars['String'];
  nupId: Scalars['String'];
}>;


export type SubmitNupMutation = { __typename?: 'Mutation', submitNup: boolean };

export type GetNupCountQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetNupCountQuery = { __typename?: 'Query', getNupCount: { __typename?: 'NupCountOutput', pending: number, approve: number, reject: number } };

export type GetNotificationHistoryDayQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNotificationHistoryDayQuery = { __typename?: 'Query', getNotificationHistoryDay?: number | null };

export type SaveNotificationPermissionMutationVariables = Exact<{
  input: NotificationInput;
}>;


export type SaveNotificationPermissionMutation = { __typename?: 'Mutation', saveNotificationPermission: boolean };

export type GetPurchaserPaymentScheduleQueryVariables = Exact<{
  projectId: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetPurchaserPaymentScheduleQuery = { __typename?: 'Query', getPurchaserPaymentSchedule?: Array<{ __typename?: 'purchaserPaymentScheduleOutput', saleId?: string | null, salesNo?: string | null, salesRegistrationNo?: string | null, salesRegNo?: string | null, unitNo?: string | null, fullName?: string | null, bookDate?: any | null, sellingPrice?: number | null, clusterName?: string | null, detail: Array<{ __typename?: 'installmentDetail', documentDate?: string | null, baseAmt?: string | null, taxAmt?: string | null, documentAmt?: string | null, description?: string | null }> }> | null };

export type GetRescheduleInstallmentQueryVariables = Exact<{
  projectId: Scalars['String'];
  saleId: Scalars['String'];
}>;


export type GetRescheduleInstallmentQuery = { __typename?: 'Query', getRescheduleInstallment?: Array<{ __typename?: 'rescheduleInstallmentOutput', rescheduleId: string, saleId: string, docNo: string, docDate?: any | null, descs?: string | null, approvalStatus?: string | null, installment?: number | null, premiumAmt?: number | null, billType?: string | null, precision?: string | null }> | null };

export type GetRescheduleDetailsQueryVariables = Exact<{
  rescheduleId: Scalars['String'];
}>;


export type GetRescheduleDetailsQuery = { __typename?: 'Query', getRescheduleDetails: Array<{ __typename?: 'getRescheduleDetailsOutput', id: string, rescheduleId: string, ledgerType: string, documentDate: any, baseAmt: number, taxAmt: number, description: string, isSelected: boolean, unallocatedAmount?: number | null, billType?: string | null, reschedule: { __typename?: 'rescheduleEntity', premiumAmt: number, startDate: any } }> };

export type GetInstallmentListQueryVariables = Exact<{
  saleId: Scalars['String'];
}>;


export type GetInstallmentListQuery = { __typename?: 'Query', getInstallmentList: Array<{ __typename?: 'installmentEntity', id: string, saleId: string, rescheduleId?: string | null, projectId: string, glGenerationBatch?: string | null, documentDate?: any | null, documentAmt?: number | null, baseAmt?: number | null, taxAmt?: number | null, unallocatedAmount?: number | null, transDate?: any | null, description?: string | null, interestRate?: number | null, glGenerated?: string | null, billType?: string | null, salePaymentId?: string | null, commonStatus: string, sale: { __typename?: 'saleEntity', unitId: string, salesNo: string, salesStatus: string, listPrice?: number | null }, approvalStatus?: Array<{ __typename?: 'approvalStatusOutput', approvalstatus?: string | null }> | null }> };

export type GetInstallmentPendingListQueryVariables = Exact<{
  saleId: Scalars['String'];
  rescheduleId: Scalars['String'];
}>;


export type GetInstallmentPendingListQuery = { __typename?: 'Query', getInstallmentPendingList: Array<{ __typename?: 'getInstallmentPendingListOutput', id: string, saleId: string, rescheduleId?: string | null, projectId: string, glGenerationBatch?: string | null, documentDate?: any | null, documentAmt?: number | null, baseAmt?: number | null, taxAmt?: number | null, unallocatedAmount?: number | null, transDate?: any | null, description?: string | null, interestRate?: number | null, glGenerated?: string | null, billType?: string | null, salePaymentId?: string | null, commonStatus: string, ledgerType?: string | null, oldInstallmentId?: string | null, sale: { __typename?: 'saleEntity', unitId: string, salesNo: string, salesStatus: string, listPrice?: number | null } }> };

export type GetApprovedRescheduleListQueryVariables = Exact<{
  saleId: Scalars['String'];
  rescheduleId: Scalars['String'];
}>;


export type GetApprovedRescheduleListQuery = { __typename?: 'Query', getApprovedRescheduleList: Array<{ __typename?: 'getApprovedRescheduleListOutput', rescheduleid?: string | null, installmentid?: string | null, isbuyerportion?: boolean | null, billtype?: string | null, ledgertype?: string | null, isselected?: boolean | null, documentdate?: any | null, description?: string | null, documentamount?: number | null, rescheduleno?: string | null, rescheduledate?: any | null, expiredate?: any | null, expiryby?: string | null, baseamt?: number | null, taxamt?: number | null, unallocatedamount?: number | null, oldinstallmentid?: string | null, commonstatus?: string | null }> };

export type AddRescheduleInstallmentMutationVariables = Exact<{
  input: RescheduleInstInput;
}>;


export type AddRescheduleInstallmentMutation = { __typename?: 'Mutation', addRescheduleInstallment: boolean };

export type GetInstallmentApprovalListQueryVariables = Exact<{
  projectId: Scalars['String'];
  status: Scalars['String'];
}>;


export type GetInstallmentApprovalListQuery = { __typename?: 'Query', getInstallmentApprovalList?: Array<{ __typename?: 'rescheduleInstallmentOutput', rescheduleId: string, saleId: string, docNo: string, docDate?: any | null, descs?: string | null, approvalStatus?: string | null, installment?: number | null, premiumAmt?: number | null, unitNo?: string | null, clusterName?: string | null, billType?: string | null, createdBy?: string | null, modBy?: string | null, createdTs?: any | null, modTs?: any | null, createdByName?: string | null, modByName?: string | null }> | null };

export type ApproveRescheduleInstallmentMutationVariables = Exact<{
  saleId: Scalars['String'];
  rescheduleId: Scalars['String'];
}>;


export type ApproveRescheduleInstallmentMutation = { __typename?: 'Mutation', approveRescheduleInstallment: boolean };

export type RejectRescheduleInstallmentMutationVariables = Exact<{
  saleId: Scalars['String'];
  rescheduleId: Scalars['String'];
}>;


export type RejectRescheduleInstallmentMutation = { __typename?: 'Mutation', rejectRescheduleInstallment: boolean };

export type GetPrecisionRoundingQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetPrecisionRoundingQuery = { __typename?: 'Query', getPrecisionRounding: string };

export type GetAllArchitectCertQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllArchitectCertQuery = { __typename?: 'Query', getAllArchitectCert: Array<{ __typename?: 'ArchitectCertListOutput', id?: string | null, certificateNo?: string | null, certificateDate?: any | null, formattedCertificateDate?: string | null, billCount?: number | null, totalUnitCount?: number | null, approvedCount?: number | null, pendingCount?: number | null, allowReversal?: boolean | null, architectCertUnitStatus?: string | null, unitIds?: Array<string> | null, unitIndex?: Array<string> | null, billingStageIndex?: Array<string> | null, pbUnitIds?: Array<string> | null }> };

export type GetUnitWorkProgressCreateQueryVariables = Exact<{
  projectId: Scalars['String'];
  progressIds: Array<Scalars['String']> | Scalars['String'];
  isCarpark: Scalars['Boolean'];
}>;


export type GetUnitWorkProgressCreateQuery = { __typename?: 'Query', getUnitWorkProgressCreate: Array<{ __typename?: 'blockListingOutput', block: string, totalFloor: number, floorList?: Array<{ __typename?: 'floorListingOutput', floorLabel?: string | null, totalUnit?: number | null, unitList?: Array<{ __typename?: 'UnitListingOutput', unitId?: string | null, unitNo?: string | null }> | null }> | null }> };

export type GetBlockFloorUnitQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetBlockFloorUnitQuery = { __typename?: 'Query', getBlockFloorUnit: Array<{ __typename?: 'blockListingOutput', block: string, totalFloor: number, floorList?: Array<{ __typename?: 'floorListingOutput', floorLabel?: string | null, totalUnit?: number | null, unitList?: Array<{ __typename?: 'UnitListingOutput', unitId?: string | null, unitNo?: string | null }> | null }> | null }> };

export type GetUnitWorkProgressUpdateQueryVariables = Exact<{
  projectId: Scalars['String'];
  id: Scalars['String'];
  isCarpark: Scalars['Boolean'];
}>;


export type GetUnitWorkProgressUpdateQuery = { __typename?: 'Query', getUnitWorkProgressUpdate: Array<{ __typename?: 'blockListingOutput', block: string, totalFloor: number, floorList?: Array<{ __typename?: 'floorListingOutput', floorLabel?: string | null, totalUnit?: number | null, unitList?: Array<{ __typename?: 'UnitListingOutput', unitId?: string | null, unitNo?: string | null }> | null }> | null }> };

export type GetProgressStageQueryVariables = Exact<{
  projectId: Scalars['String'];
  isCarpark: Scalars['Boolean'];
}>;


export type GetProgressStageQuery = { __typename?: 'Query', getProgressStage: Array<{ __typename?: 'progressStageOutput', id?: string | null, name?: string | null, isCarPark: boolean }> };

export type GetArchitectCertByIdQueryVariables = Exact<{
  architectCertId: Scalars['String'];
  projectId: Scalars['String'];
}>;


export type GetArchitectCertByIdQuery = { __typename?: 'Query', getArchitectCertById: { __typename?: 'architectCertEntity', id: string, accountId: string, projectId: string, certificateDate: any, certificateNo: string, commonStatus: string, totalUnitCount?: number | null, totalPostedBill?: number | null, architectCertUnitStatus?: string | null, architectCertUnit?: Array<{ __typename?: 'architectCertUnitEntity', unitId: string, status: string, units?: { __typename?: 'unitEntity', unitNo: string, id: string, unitStatus: string, saleSubProduct?: { __typename?: 'saleSubproductEntity', sales?: { __typename?: 'saleEntity', unit: { __typename?: 'unitEntity', unitNo: string } } | null } | null } | null }> | null, getArchitectCertAttachment?: Array<{ __typename?: 'attachmentEntity', resourceUrl: string, mediaType: string, fileName: string }> | null, architectCertWorkProgress?: Array<{ __typename?: 'architectCertWorkProgressEntity', progress: Array<{ __typename?: 'workProgressEntity', name: string, id: string, isCarPark: boolean }> }> | null } };

export type AddArchitectCertMutationVariables = Exact<{
  input: ArchitectCertInput;
}>;


export type AddArchitectCertMutation = { __typename?: 'Mutation', addArchitectCert: boolean };

export type DeleteArchitectCertMutationVariables = Exact<{
  architectCertId: Scalars['String'];
  projectId: Scalars['String'];
}>;


export type DeleteArchitectCertMutation = { __typename?: 'Mutation', deleteArchitectCert: boolean };

export type EditArchitectCertMutationVariables = Exact<{
  input: EditArchitectCertInput;
}>;


export type EditArchitectCertMutation = { __typename?: 'Mutation', editArchitectCert: boolean };

export type ApprovalArchitectCertMutationVariables = Exact<{
  architectCertId: Scalars['String'];
  projectId: Scalars['String'];
  unitIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type ApprovalArchitectCertMutation = { __typename?: 'Mutation', approvalArchitectCert: boolean };

export type VoidArchitectCertMutationVariables = Exact<{
  architectCertId: Scalars['String'];
  projectId: Scalars['String'];
  unitIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type VoidArchitectCertMutation = { __typename?: 'Mutation', voidArchitectCert: boolean };

export type ReversalArchCertUnitListingQueryVariables = Exact<{
  architectCertId: Scalars['String'];
}>;


export type ReversalArchCertUnitListingQuery = { __typename?: 'Query', reversalArchCertUnitListing: Array<{ __typename?: 'reversalUnitListingOutput', unitId?: string | null, unitNo?: string | null, unitStatus?: string | null, saleUnitNo?: string | null }> };

export type GetPostedUnitListQueryVariables = Exact<{
  architectCertId: Scalars['String'];
}>;


export type GetPostedUnitListQuery = { __typename?: 'Query', getPostedUnitList: Array<{ __typename?: 'postedUnitListingOutput', unitId?: string | null }> };

export type ReversalArchitectCertMutationVariables = Exact<{
  architectCertId: Scalars['String'];
  projectId: Scalars['String'];
  unitIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type ReversalArchitectCertMutation = { __typename?: 'Mutation', reversalArchitectCert: boolean };

export type GetAllMiscBillingByStatusQueryVariables = Exact<{
  status: Scalars['String'];
}>;


export type GetAllMiscBillingByStatusQuery = { __typename?: 'Query', getAllMiscBillingByStatus?: Array<{ __typename?: 'miscBillingListOutput', documentDate: any, generationBatch: string, totalAmount: number, status: string, unitList: Array<{ __typename?: 'miscBillingUnitList', unitNo: string, totalAmount: number, billingList: Array<{ __typename?: 'miscBillingUnitBillingList', billItem: string, docAmount: number }> }> }> | null };

export type GetMiscBillingByBatchIdQueryVariables = Exact<{
  generationBatch: Scalars['String'];
}>;


export type GetMiscBillingByBatchIdQuery = { __typename?: 'Query', getMiscBillingByBatchId: { __typename?: 'miscBillingDetailByGenerationOutput', documentDate: any, billItemIds: Array<string>, units: Array<string>, creditTerm: number, interestRate: number } };

export type GetMiscBillingDetailsQueryVariables = Exact<{
  generationBatch: Scalars['String'];
}>;


export type GetMiscBillingDetailsQuery = { __typename?: 'Query', getMiscBillingDetails: { __typename?: 'miscBillingListOutput', documentDate: any, generationBatch: string, totalAmount: number, status: string, unitList: Array<{ __typename?: 'miscBillingUnitList', unitNo: string, totalAmount: number, billingList: Array<{ __typename?: 'miscBillingUnitBillingList', billItem: string, docAmount: number }> }> } };

export type GenerateMiscBillingMutationVariables = Exact<{
  input: GenerateMiscBillingInput;
}>;


export type GenerateMiscBillingMutation = { __typename?: 'Mutation', generateMiscBilling: boolean };

export type EditMiscBillingMutationVariables = Exact<{
  input: EditMiscBillingInput;
}>;


export type EditMiscBillingMutation = { __typename?: 'Mutation', editMiscBilling: boolean };

export type ApprovedMiscBillingMutationVariables = Exact<{
  generationBatchIds: Array<Scalars['String']> | Scalars['String'];
  action: Scalars['String'];
}>;


export type ApprovedMiscBillingMutation = { __typename?: 'Mutation', approvedMiscBilling: boolean };

export type PostingMiscBillingMutationVariables = Exact<{
  input: PostingMiscBillingInput;
}>;


export type PostingMiscBillingMutation = { __typename?: 'Mutation', postingMiscBilling: boolean };

export type AbortMiscBillingMutationVariables = Exact<{
  input: PostingMiscBillingInput;
}>;


export type AbortMiscBillingMutation = { __typename?: 'Mutation', abortMiscBilling: boolean };

export type ReversalMiscBillingMutationVariables = Exact<{
  generationBatch: Scalars['String'];
}>;


export type ReversalMiscBillingMutation = { __typename?: 'Mutation', reversalMiscBilling: boolean };

export type GetMBallUnitQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMBallUnitQuery = { __typename?: 'Query', getMBallUnit: Array<{ __typename?: 'blockListingOutput', block: string, totalFloor: number, floorList?: Array<{ __typename?: 'floorListingOutput', floorLabel?: string | null, totalUnit?: number | null, unitList?: Array<{ __typename?: 'UnitListingOutput', unitId?: string | null, unitNo?: string | null }> | null }> | null }> };

export type GetMiscChargesByDateQueryVariables = Exact<{
  date: Scalars['DateTime'];
}>;


export type GetMiscChargesByDateQuery = { __typename?: 'Query', getMiscChargesByDate: Array<{ __typename?: 'miscChargesDropdownOutput', miscChargesId: string, billItemName: string, billItemId: string, taxSchemeId: string, taxSchemeName: string, effectiveDate: any, taxSchemeDetailId: string, totalTaxRate?: string | null, taxSchemeDetailItems: Array<{ __typename?: 'TaxSchemeDetailItemOutput', taxId: string, taxCode: string, taxRate?: string | null }> }> };

export type ProgressBillingListForGenerateQueryVariables = Exact<{
  signed: Scalars['Boolean'];
  booked: Scalars['Boolean'];
  docDate: Scalars['DateTime'];
}>;


export type ProgressBillingListForGenerateQuery = { __typename?: 'Query', progressBillingListForGenerate?: Array<{ __typename?: 'progressBillingSummary', unitNo: string, saleUnitNo: string, saleId: string, salesStatus: string, totalPrincipalAmt: number, totalDocAmt: number, totalTaxAmt: number, billingCount: number, billingDetail: Array<{ __typename?: 'progressBillingDetail', title: string, principalAmt: number, progressBillingId: string, addOnRefTable?: string | null, addOnRefId?: string | null, docNo?: string | null, docAmt: number, stageSeqNo: number, installmentSeqNo?: number | null, docDate?: string | null, taxAmt: number }> }> | null };

export type GenerateProgressBillingMutationVariables = Exact<{
  input: GenerateProgressBillingBasicInput;
}>;


export type GenerateProgressBillingMutation = { __typename?: 'Mutation', generateProgressBilling: boolean };

export type PostingProgressBillingMutationVariables = Exact<{
  input: Array<UpdatePbStatusInput> | UpdatePbStatusInput;
}>;


export type PostingProgressBillingMutation = { __typename?: 'Mutation', postingProgressBilling: boolean };

export type ReversalProgressBillingMutationVariables = Exact<{
  input: Array<UpdatePbStatusInput> | UpdatePbStatusInput;
  removeGenerationBatch: Scalars['Boolean'];
}>;


export type ReversalProgressBillingMutation = { __typename?: 'Mutation', reversalProgressBilling: boolean };

export type UpdateProgressBillingMutationVariables = Exact<{
  input: EditProgressBillingInput;
}>;


export type UpdateProgressBillingMutation = { __typename?: 'Mutation', updateProgressBilling: boolean };

export type GetProjectCreditTermQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProjectCreditTermQuery = { __typename?: 'Query', getProjectCreditTerm: { __typename?: 'projectPolicyEntity', creditTerms: number, interestRate: number } };

export type GetProgressBillingQueryVariables = Exact<{
  status: Scalars['String'];
}>;


export type GetProgressBillingQuery = { __typename?: 'Query', getProgressBilling?: Array<{ __typename?: 'ProgressBillingList2', documentDate: any, generationBatch?: string | null, totalPrincipalAmt: number, unitCount: number, allowPosted: boolean, allowReversal: boolean, isReversal: boolean, unitIndex?: string | null, billingDetail: Array<{ __typename?: 'ProgressBillingListDetailOutput', progressBillingId: string, unitNo: string, saleId: string, allowPosted: boolean, allowReversal: boolean }> }> | null };

export type GetProgressBillingByGenerationIdQueryVariables = Exact<{
  generationBatchId: Scalars['String'];
}>;


export type GetProgressBillingByGenerationIdQuery = { __typename?: 'Query', getProgressBillingByGenerationId: Array<{ __typename?: 'progressBillingByGenerationBatchSummary', unitNo: string, saleUnitNo: string, saleId: string, docDate: string, creditTerm: number, salesStatus: string, totalPrincipalAmt: number, totalDocAmt: number, totalTaxAmt: number, billingCount: number, interestRate: number, billingDetail: Array<{ __typename?: 'progressBillingDetail', title: string, principalAmt: number, progressBillingId: string, addOnRefTable?: string | null, addOnRefId?: string | null, docNo?: string | null, docAmt: number, stageSeqNo: number, installmentSeqNo?: number | null, docDate?: string | null, taxAmt: number }>, pbDetail?: Array<{ __typename?: 'sale_progress_billing', isReversal?: boolean | null, stageSeqNo?: number | null, paymentParty?: string | null, addOnPurchase?: string | null, paymentPartyCode?: string | null, addOnPurchaseName?: string | null, paymentPlanDetailTitle?: string | null, totalDocumentAmt?: number | null, gotAC?: boolean | null, details?: Array<{ __typename?: 'details', totalTaxAmt?: number | null, isVp: boolean, documentNo?: string | null, stageSeqNo: number, documentDate?: string | null, paymentParty: string, addOnPurchase?: string | null, isStakeholder: boolean, creditDocumentNo?: string | null, installmentSeqNo?: number | null, paymentPartyCode?: string | null, addOnPurchaseName?: string | null, progressBillingId?: string | null, calculatedDocumentAmt: number, paymentPlanDetailTitle?: string | null }> | null }> | null }> };

export type ClearPBbyBatchIdMutationVariables = Exact<{
  generateBatchId: Scalars['String'];
}>;


export type ClearPBbyBatchIdMutation = { __typename?: 'Mutation', clearPBbyBatchId: boolean };

export type GetProgressMiscBillingSettingSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProgressMiscBillingSettingSummaryQuery = { __typename?: 'Query', standardMiscChargesLastUpdate?: any | null, architectCertLastUpdate?: any | null, progressBillingLastUpdate?: any | null, miscBillingLastUpdate?: any | null };

export type GetAllProjectMiscChargesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllProjectMiscChargesQuery = { __typename?: 'Query', getAllProjectMiscCharges: Array<{ __typename?: 'projectMiscChargesEntity', id: string, accountId: string, interestRate: number, remark?: string | null, taxSchemeId: string, formula: string, billItemName: string, isDeletable: boolean }> };

export type GetProjectMiscChargesByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetProjectMiscChargesByIdQuery = { __typename?: 'Query', getProjectMiscChargesById: { __typename?: 'projectMiscChargesEntity', id: string, accountId: string, interestRate: number, remark?: string | null, taxSchemeId: string, formula: string, billItemName: string, billItemId: string, isDeletable: boolean } };

export type AddProjectMiscChargesMutationVariables = Exact<{
  input: AddProjectMiscChargesInput;
}>;


export type AddProjectMiscChargesMutation = { __typename?: 'Mutation', addProjectMiscCharges: boolean };

export type DeleteProjectMiscChargesMutationVariables = Exact<{
  projectMiscChargesId: Scalars['String'];
}>;


export type DeleteProjectMiscChargesMutation = { __typename?: 'Mutation', deleteProjectMiscCharges: boolean };

export type EditProjectMiscChargesMutationVariables = Exact<{
  input: EditProjectMiscChargesInput;
}>;


export type EditProjectMiscChargesMutation = { __typename?: 'Mutation', editProjectMiscCharges: boolean };

export type CloneProjectMiscChargesMutationVariables = Exact<{
  cloneProjectMiscChargesId: Scalars['String'];
}>;


export type CloneProjectMiscChargesMutation = { __typename?: 'Mutation', cloneProjectMiscCharges: boolean };

export type GetMiscBillItemQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
}>;


export type GetMiscBillItemQuery = { __typename?: 'Query', getMiscBillItem?: Array<{ __typename?: 'billItemEntity', id: string, name: string }> | null };

export type GetAvaiableCloneMiscChargeProjectQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAvaiableCloneMiscChargeProjectQuery = { __typename?: 'Query', getAvaiableCloneMiscChargeProject?: Array<{ __typename?: 'availableCloneProjectOutput', id: string, name: string }> | null };

export type GetApprovalPolicyAssignmentFlagQueryVariables = Exact<{ [key: string]: never; }>;


export type GetApprovalPolicyAssignmentFlagQuery = { __typename?: 'Query', getApprovalPolicyAssignmentFlag: any };

export type GetApprovalPolicyAssignmentListingByCategoryQueryVariables = Exact<{
  category: Scalars['String'];
}>;


export type GetApprovalPolicyAssignmentListingByCategoryQuery = { __typename?: 'Query', getApprovalPolicyAssignmentListingByCategory?: Array<{ __typename?: 'approvalPolicyAssignmentEntity', id: string, lowerLimit?: number | null, upperLimit?: number | null, approvalList: Array<{ __typename?: 'ApprovalListJson', stepNo: number, roleId: string, roleName?: string | null }> }> | null };

export type AddEditApprovalPolicyAssignmentMutationVariables = Exact<{
  input: AddEditApprovalAssignmentInput;
}>;


export type AddEditApprovalPolicyAssignmentMutation = { __typename?: 'Mutation', addEditApprovalPolicyAssignment: boolean };

export type CopyFromApprovalPolicyMutationVariables = Exact<{
  category: Scalars['String'];
}>;


export type CopyFromApprovalPolicyMutation = { __typename?: 'Mutation', copyFromApprovalPolicy: boolean };

export type GetCampaignListByProjectQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetCampaignListByProjectQuery = { __typename?: 'Query', getCampaignList: Array<{ __typename?: 'campaignEntity', id: string, accountId: string, name: string, startDate: any, endDate: any, commonStatus?: string | null, getCampaignEventsCount: number, getCampaignSaleRebatePackageCount: number, isExistInMasterData: Array<string>, isExistInTransactionData: Array<string> }> };

export type AddCampaignMutationVariables = Exact<{
  input: AdminCampaignInput;
}>;


export type AddCampaignMutation = { __typename?: 'Mutation', addCampaign: boolean };

export type EditCampaignMutationVariables = Exact<{
  input: AdminCampaignInput;
}>;


export type EditCampaignMutation = { __typename?: 'Mutation', editCampaign: boolean };

export type DeleteCampaignByIdMutationVariables = Exact<{
  campaignId: Scalars['String'];
  isDeletable: Scalars['Boolean'];
}>;


export type DeleteCampaignByIdMutation = { __typename?: 'Mutation', deleteCampaignById: boolean };

export type ActivateCampaignByIdMutationVariables = Exact<{
  campaignId: Scalars['String'];
}>;


export type ActivateCampaignByIdMutation = { __typename?: 'Mutation', activateCampaignById: boolean };

export type CampaignDataByIdQueryVariables = Exact<{
  campaign_id: Scalars['String'];
}>;


export type CampaignDataByIdQuery = { __typename?: 'Query', getCampaignById: { __typename?: 'campaignEntity', name: string, id: string, startDate: any, endDate: any } };

export type GetEventsListByCampaignQueryVariables = Exact<{
  campaign_id: Scalars['String'];
}>;


export type GetEventsListByCampaignQuery = { __typename?: 'Query', getEventsListByCampaign?: { __typename?: 'campaignEntity', events: Array<{ __typename?: 'eventsEntity', id: string, name: string, desc?: string | null, website: string, location: string, startDate: any, endDate: any, budget: number }> } | null };

export type GetEventByIdQueryVariables = Exact<{
  campaignId: Scalars['String'];
  id: Scalars['String'];
}>;


export type GetEventByIdQuery = { __typename?: 'Query', getEventById: { __typename?: 'eventsEntity', id: string, name: string, desc?: string | null, website: string, location: string, startDate: any, endDate: any, budget: number } };

export type GetEventByDateQueryVariables = Exact<{
  saleId: Scalars['String'];
}>;


export type GetEventByDateQuery = { __typename?: 'Query', getEventByDate: Array<{ __typename?: 'eventOutput', id: string, name: string }> };

export type AddEventsMutationVariables = Exact<{
  input: AdminEventsInput;
}>;


export type AddEventsMutation = { __typename?: 'Mutation', addEvents: boolean };

export type EditEventsMutationVariables = Exact<{
  input: AdminEventsInput;
}>;


export type EditEventsMutation = { __typename?: 'Mutation', editEvents: boolean };

export type DeleteEventsMutationVariables = Exact<{
  eventsId: Scalars['String'];
}>;


export type DeleteEventsMutation = { __typename?: 'Mutation', deleteEventsById: boolean };

export type AssignCarParkMutationVariables = Exact<{
  input: Array<AssignCarParkInput> | AssignCarParkInput;
}>;


export type AssignCarParkMutation = { __typename?: 'Mutation', assignCarPark: boolean };

export type GetCarParksQueryVariables = Exact<{
  parentId?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetCarParksQuery = { __typename?: 'Query', getCarParks?: { __typename?: 'mainOutput', carParks: Array<{ __typename?: 'carParkOutput', id: string, unitNo: string }>, assignedCarparks?: Array<{ __typename?: 'assignedUnitCp', parentId: string, parentUnitNo: string, carParks?: Array<{ __typename?: 'carParkOutput', id: string, unitNo: string }> | null }> | null } | null };

export type GenerateCarParkMutationVariables = Exact<{
  input: GenerateUnitBasicInput;
}>;


export type GenerateCarParkMutation = { __typename?: 'Mutation', generateCarPark: boolean };

export type GetProjectConstructionQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetProjectConstructionQuery = { __typename?: 'Query', getAllProjectConstruction?: Array<{ __typename?: 'projectConstructionEntity', id: string, architectureStructure?: string | null, numberBlockUnit?: number | null, landProprietor?: string | null, planner?: string | null, buildingDesigner?: string | null, superStructureType?: string | null, propertyAgent?: string | null, architect?: string | null, startDate?: any | null, completionDate?: any | null, landPermitDate?: any | null, taxRegNo?: string | null, spaDuration?: number | null, basePrice?: number | null }> | null };

export type AddProjectConstructionMutationVariables = Exact<{
  input: ProjectConstructionInput;
}>;


export type AddProjectConstructionMutation = { __typename?: 'Mutation', addProjectConstruction: boolean };

export type EditProjectConstructionMutationVariables = Exact<{
  input: EditProjectConstructionInputInput;
}>;


export type EditProjectConstructionMutation = { __typename?: 'Mutation', editProductConstruction: boolean };

export type AssignDiscountMutationVariables = Exact<{
  input: AssignDiscountInput;
}>;


export type AssignDiscountMutation = { __typename?: 'Mutation', assignDiscount: boolean };

export type EditAssignDiscountMutationVariables = Exact<{
  input: AssignDiscountInput;
}>;


export type EditAssignDiscountMutation = { __typename?: 'Mutation', editAssignDiscount: boolean };

export type UnassignDiscountMutationVariables = Exact<{
  projectId: Scalars['String'];
  discountId: Scalars['String'];
}>;


export type UnassignDiscountMutation = { __typename?: 'Mutation', unassignDiscount: boolean };

export type SetDefaultDiscountForProjectMutationVariables = Exact<{
  projectId: Scalars['String'];
  discountId: Scalars['String'];
  check: Scalars['Boolean'];
}>;


export type SetDefaultDiscountForProjectMutation = { __typename?: 'Mutation', setDefaultDiscountForProject: boolean };

export type GetAssignedDiscountByIdQueryVariables = Exact<{
  projectId: Scalars['String'];
  discountId: Scalars['String'];
}>;


export type GetAssignedDiscountByIdQuery = { __typename?: 'Query', getAssignedDiscountById: { __typename?: 'projectDiscountEntity', discountId: string, projectId: string, effectiveDate: any, expired_date: any, defaulted: boolean } };

export type GetDiscountAssignedByProjectIdQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetDiscountAssignedByProjectIdQuery = { __typename?: 'Query', getDiscountAssignedByProjectId: Array<{ __typename?: 'discountEntity', id: string, title: string, formula?: string | null, prefix?: string | null, discountTypeId?: string | null, description?: string | null, isIntegrated: boolean, discountVal?: number | null, isExistInMasterData: Array<string>, isExistInTransactionData: Array<string>, projectDiscounts: Array<{ __typename?: 'projectDiscountEntity', id: string, projectId: string, discountId: string, effectiveDate: any, expired_date: any, defaulted: boolean }> }> };

export type GetDiscountAssigmentByProjectIdQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetDiscountAssigmentByProjectIdQuery = { __typename?: 'Query', getDiscountAssigmentByProjectId?: Array<{ __typename?: 'discountEntity', title: string, description?: string | null, formula?: string | null, discountTypeId?: string | null, discountVal?: number | null, id: string, isIntegrated: boolean, prefix?: string | null, isExistInMasterData: Array<string>, isExistInTransactionData: Array<string> }> | null };

export type GetProjectFireInsuranceQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetProjectFireInsuranceQuery = { __typename?: 'Query', getProjectFireInsurance: Array<{ __typename?: 'projectFireInsuranceEntity', id: string, accountId: string, projectId: string, companyName?: string | null, certificateNo?: string | null, companyAddress?: { __typename?: 'AddressJson', address?: string | null, city?: string | null, state?: string | null, country?: string | null, postCode?: string | null } | null }> };

export type CreateProjectFireInsuranceMutationVariables = Exact<{
  input: ProjectFireInsuranceInput;
}>;


export type CreateProjectFireInsuranceMutation = { __typename?: 'Mutation', createProjectFireInsurance: { __typename?: 'projectFireInsuranceEntity', projectId: string, companyName?: string | null, certificateNo?: string | null, companyAddress?: { __typename?: 'AddressJson', address?: string | null, country?: string | null, city?: string | null, state?: string | null, postCode?: string | null } | null } };

export type UpdateProjectFireInsuranceMutationVariables = Exact<{
  input: EditProjectFireInsuranceInput;
}>;


export type UpdateProjectFireInsuranceMutation = { __typename?: 'Mutation', updateProjectFireInsurance: { __typename?: 'projectFireInsuranceEntity', id: string, projectId: string, companyName?: string | null, certificateNo?: string | null, companyAddress?: { __typename?: 'AddressJson', address?: string | null, country?: string | null, city?: string | null, state?: string | null, postCode?: string | null } | null } };

export type GetUnassignedNotaryListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnassignedNotaryListQuery = { __typename?: 'Query', getUnassignedNotaryList: Array<{ __typename?: 'UnassignedNotaryOutput', notaryId?: string | null, name?: string | null, email?: string | null, notaryCode?: string | null }> };

export type GetAssignedNotaryListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAssignedNotaryListQuery = { __typename?: 'Query', getAssignedNotaryList: Array<{ __typename?: 'AssignedNotaryOutput', id: string, name?: string | null, email?: string | null, notaryCode?: string | null, notaryId?: string | null }> };

export type AddAssignNotaryMutationVariables = Exact<{
  input: AddAssignNotaryInput;
}>;


export type AddAssignNotaryMutation = { __typename?: 'Mutation', addAssignNotary: boolean };

export type DeleteAssignNotaryMutationVariables = Exact<{
  input: DeleteAssignNotaryInput;
}>;


export type DeleteAssignNotaryMutation = { __typename?: 'Mutation', deleteAssignNotary: boolean };

export type FinancierPanelListQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type FinancierPanelListQuery = { __typename?: 'Query', panelByProject: Array<{ __typename?: 'endfinProjectFinancierEntity', financierStatus: boolean, id: string, assignedDate: any, financialLimit: number, financierCommonStatus: string, financierInfo: { __typename?: 'financierEntity', id: string, name: string, financierId?: string | null } }> };

export type FinancierAssignListQueryVariables = Exact<{
  projectId: Scalars['String'];
  financierId?: InputMaybe<Scalars['String']>;
}>;


export type FinancierAssignListQuery = { __typename?: 'Query', panelFinancierList: Array<{ __typename?: 'financierEntity', id: string, name: string, financialLimit?: number | null, financierContact: Array<{ __typename?: 'financierContactEntity', id: string, name: string }>, projectInvitation?: Array<{ __typename?: 'FinancierProject', projectId: string, invitation: Array<{ __typename?: 'Contact', contactInfo?: { __typename?: 'financierContactEntity', id: string, name: string } | null }> }> | null }> };

export type FinancierPanelDetailQueryVariables = Exact<{
  financierId: Scalars['String'];
  projectId: Scalars['String'];
}>;


export type FinancierPanelDetailQuery = { __typename?: 'Query', panelDetails: { __typename?: 'financierPanelDetails', id: string, name: string, endfinFinancierId?: string | null, officeTel?: string | null, address?: { __typename?: 'AddressJson', address?: string | null, city?: string | null, state?: string | null, country?: string | null, postCode?: string | null } | null, financierContact: Array<{ __typename?: 'financierContacts', id: string, name: string, phoneNo: string, email: string, invitationDate?: any | null, default?: boolean | null }> } };

export type SetDefaultFinancierContactMutationVariables = Exact<{
  contactId: Scalars['String'];
  project_id: Scalars['String'];
  financier_id: Scalars['String'];
}>;


export type SetDefaultFinancierContactMutation = { __typename?: 'Mutation', setDefaultFinancierContact: boolean };

export type FinancierAssignPanelMutationVariables = Exact<{
  input: AdminFinancierPanelInput;
}>;


export type FinancierAssignPanelMutation = { __typename?: 'Mutation', assignPanel: boolean };

export type FinancierUnassignPanelMutationVariables = Exact<{
  financierId: Scalars['String'];
  projectId: Scalars['String'];
}>;


export type FinancierUnassignPanelMutation = { __typename?: 'Mutation', unassignPanel: boolean };

export type EditFinancierLimitMutationVariables = Exact<{
  id: Scalars['String'];
  financialLimit: Scalars['Float'];
}>;


export type EditFinancierLimitMutation = { __typename?: 'Mutation', editFinancialLimit: boolean };

export type SolicitorAppointedListQueryVariables = Exact<{
  project_id: Scalars['String'];
}>;


export type SolicitorAppointedListQuery = { __typename?: 'Query', solicitorAppointedList: Array<{ __typename?: 'solicitorAppointedEntity', id: string, solicitorId?: string | null, name: string, modTs: any, logoUrl?: string | null, commonStatus: string, officeTel?: string | null, default?: boolean | null, solicitorStatus: boolean, solicitorUnitCount?: { __typename?: 'solicitorUnitCount', allocated?: number | null, sold?: number | null } | null }> };

export type SolicitorListForAssignmentQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type SolicitorListForAssignmentQuery = { __typename?: 'Query', solicitorListForAssignment: Array<{ __typename?: 'solicitorAppointedEntity', id: string, solicitorId?: string | null, name: string }> };

export type AssignSolicitorToProjectMutationVariables = Exact<{
  projectId: Scalars['String'];
  solicitor_appointed_id: Array<Scalars['String']> | Scalars['String'];
}>;


export type AssignSolicitorToProjectMutation = { __typename?: 'Mutation', assignSolicitorToProject: boolean };

export type SolicitorAppointedDetailsQueryVariables = Exact<{
  solicitor_appointed_id: Scalars['String'];
}>;


export type SolicitorAppointedDetailsQuery = { __typename?: 'Query', solicitorAppointedDetails: { __typename?: 'solicitorAppointedEntity', id: string, name: string, email?: string | null, officeTel?: string | null, createdTs: any, contactName?: string | null, contactEmail?: string | null, contactPhoneNo?: string | null, address?: { __typename?: 'AddressJson', address?: string | null } | null } };

export type UnassignPanelSolicitorMutationVariables = Exact<{
  project_id: Scalars['String'];
  solicitor_id: Scalars['String'];
}>;


export type UnassignPanelSolicitorMutation = { __typename?: 'Mutation', unassignSolicitorFromProject: boolean };

export type MarkAsDefaultSolicitorMutationVariables = Exact<{
  projectId: Scalars['String'];
  solicitorId: Scalars['String'];
}>;


export type MarkAsDefaultSolicitorMutation = { __typename?: 'Mutation', markAsDefault: boolean };

export type GetAllProjectPaymentPlanQueryVariables = Exact<{
  project_id: Scalars['String'];
  typePaymentPlan: TypePaymentPlanEnum;
}>;


export type GetAllProjectPaymentPlanQuery = { __typename?: 'Query', getAllProjectPaymentPlan: Array<{ __typename?: 'allProjectPaymentPlanOutput', id: string, accountId: string, projectId: string, paymentPlanId: string, defaulted: boolean, commonStatus: string, startDate: any, endDate: any, paymentPlanName?: string | null, paymentPlanEffecDate?: any | null }> };

export type GetAllPaymentPlanForProjectQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllPaymentPlanForProjectQuery = { __typename?: 'Query', getAllPaymentPlanForProject: Array<{ __typename?: 'purchaserPaymentPlanEntity', name: string, id: string, accountId: string, recordStatus: string, effectiveDate: any }> };

export type SetDefaultPaymentPlanForProjectMutationVariables = Exact<{
  input: SetDefaultPaymentPlanForProjectInput;
}>;


export type SetDefaultPaymentPlanForProjectMutation = { __typename?: 'Mutation', setDefaultPaymentPlanForProject: boolean };

export type AddProjectPaymentPlanMutationVariables = Exact<{
  input: AddProjectPaymentPlanInput;
}>;


export type AddProjectPaymentPlanMutation = { __typename?: 'Mutation', addProjectPaymentPlan: boolean };

export type DeleteProjectPaymentPlanMutationVariables = Exact<{
  projectPaymentPlanId: Scalars['String'];
  typePaymentPlan: TypePaymentPlanEnum;
}>;


export type DeleteProjectPaymentPlanMutation = { __typename?: 'Mutation', deleteProjectPaymentPlan: boolean };

export type DeactivateProjectPaymentPlanMutationVariables = Exact<{
  projectPaymentPlanId: Scalars['String'];
  typePaymentPlan: TypePaymentPlanEnum;
}>;


export type DeactivateProjectPaymentPlanMutation = { __typename?: 'Mutation', deactivateProjectPaymentPlan: boolean };

export type GetAllProjectPermitQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetAllProjectPermitQuery = { __typename?: 'Query', getAllProjectPermit: Array<{ __typename?: 'projectPermitEntity', id: string, projectId: string, permitNo: string, permitType: string, issueDate: any, expiryDate: any, commonStatus: string }> };

export type GetProjectPermitByIdQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetProjectPermitByIdQuery = { __typename?: 'Query', getProjectPermitById: { __typename?: 'projectPermitEntity', id: string, projectId: string, permitNo: string, permitType: string, issueDate: any, expiryDate: any, commonStatus: string } };

export type AddProjectPermitMutationVariables = Exact<{
  input: AddProjectPermitInput;
}>;


export type AddProjectPermitMutation = { __typename?: 'Mutation', addProjectPermit: boolean };

export type EditProjectPermitMutationVariables = Exact<{
  input: EditProjectPermitInput;
}>;


export type EditProjectPermitMutation = { __typename?: 'Mutation', editProjectPermit: boolean };

export type DeleteProjectPermitMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteProjectPermitMutation = { __typename?: 'Mutation', deleteProjectPermit: boolean };

export type GetProjectPermitTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProjectPermitTypeQuery = { __typename?: 'Query', getProjectPermitType: any };

export type GetAllProjectQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllProjectQuery = { __typename?: 'Query', getAllProject: Array<{ __typename?: 'projectEntity', id: string, name: string, holdingCompanyId: string, developmentCompanyId: string, townshipName?: string | null, desc?: string | null, completionDate?: any | null, launchDate?: any | null, state?: string | null, city?: string | null, minPrice?: number | null, maxPrice?: number | null, tenure: string, currency: string, uom: string, landType: string, projectCode: string, firstGalleryImage?: { __typename?: 'ProjectResourceOuput', url?: string | null } | null, holdingCompany: { __typename?: 'companyEntity', name: string, id: string }, developmentCompany: { __typename?: 'companyEntity', name: string, id: string } }> };

export type ProjectDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ProjectDetailQuery = { __typename?: 'Query', projectDetail: { __typename?: 'projectEntity', name: string, projectCode: string, developmentCompanyId: string, desc?: string | null, townshipName?: string | null, landType: string, tenure: string, state?: string | null, city?: string | null, minPrice?: number | null, maxPrice?: number | null, launchDate?: any | null, completionDate?: any | null, totalReminderEmailTemplate?: number | null, totalReminderLetterTemplate?: number | null, holdingCompany: { __typename?: 'companyEntity', id: string, name: string }, developmentCompany: { __typename?: 'companyEntity', id: string, name: string }, projectType: { __typename?: 'projectTypeEntity', id: string, name: string }, projectExt?: { __typename?: 'projectExtEntity', id: string, bankAccountId?: string | null, bankProfileId: string, plotNo?: string | null, companyBankProfile?: { __typename?: 'companyBankProfileEntity', id: string, name: string, bankAccount: Array<{ __typename?: 'companyBankAccountEntity', id: string, code: string }> } | null, companyBankAccount?: { __typename?: 'companyBankAccountEntity', id: string, code: string, accountNo: string } | null } | null } };

export type AddProjectMutationVariables = Exact<{
  input: AdminProjectInput;
}>;


export type AddProjectMutation = { __typename?: 'Mutation', addProject: boolean };

export type EditProjectMutationVariables = Exact<{
  input: AdminProjectInput;
}>;


export type EditProjectMutation = { __typename?: 'Mutation', editProject: boolean };

export type GetProjectDetailByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetProjectDetailByIdQuery = { __typename?: 'Query', getProjectDetailById: { __typename?: 'ProjectDetailOutput', id: string, projectName: string, projectCode: string, description?: string | null, holdingCompanyId: string, holdingCompanyName: string, developmentCompanyId: string, developmentCompanyName: string, townshipId?: string | null, townshipName?: string | null, projectTypeId: string, projectType: string, landType: string, tenure: string, uom: string, currency: string, country: string, state: string, city: string, minPrice?: number | null, maxPrice?: number | null, launchDate?: any | null, completionDate?: any | null, plotNo?: string | null, bankId?: string | null, bankCode?: string | null, bankName?: string | null, firstGalleryImage?: { __typename?: 'ProjectResourceOuput', url?: string | null } | null, bankAccounts?: Array<{ __typename?: 'BankAccountOutput', bankAccountId?: string | null, bankProfileId?: string | null, bankAccountCode?: string | null, bankAccountNo?: string | null, bankCurrency?: string | null, bankProfileName?: string | null }> | null } };

export type GetBankProfileWithAccountQueryVariables = Exact<{
  companyId: Scalars['String'];
}>;


export type GetBankProfileWithAccountQuery = { __typename?: 'Query', getBankProfileWithAccount?: Array<{ __typename?: 'companyBankOutput', bankAccountId: string, bankProfileId: string, bankAccountCode: string, bankAccountNo: string, bankCurrency: string, bankProfileName: string }> | null };

export type GetAvailableBankProfileWithAccountQueryVariables = Exact<{
  companyId: Scalars['String'];
}>;


export type GetAvailableBankProfileWithAccountQuery = { __typename?: 'Query', getAvailableBankProfileWithAccount: Array<{ __typename?: 'companyBankOutput', bankAccountId: string, bankProfileId: string, bankAccountCode: string, bankAccountNo: string, bankCurrency: string, bankProfileName: string }> };

export type UserAccessEntityMutationVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type UserAccessEntityMutation = { __typename?: 'Mutation', updateUserLatestEntity: boolean };

export type GetProjectClusterListingQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetProjectClusterListingQuery = { __typename?: 'Query', getProjectClusterListing: Array<{ __typename?: 'projectClusterEntity', id: string, projectId: string, name: string, desc: string, accountId: string }> };

export type ProjectClusterNameExistQueryVariables = Exact<{
  name: Scalars['String'];
  clusterId: Scalars['String'];
  developmentCompany: Scalars['String'];
}>;


export type ProjectClusterNameExistQuery = { __typename?: 'Query', projectClusterNameExist: boolean };

export type AddProjectClusterMutationVariables = Exact<{
  input: AddProjectClusterInput;
}>;


export type AddProjectClusterMutation = { __typename?: 'Mutation', addProjectCluster: boolean };

export type EditProjectClusterMutationVariables = Exact<{
  input: EditProjectClusterInput;
}>;


export type EditProjectClusterMutation = { __typename?: 'Mutation', editProjectCluster: boolean };

export type DeleteProjectClusterMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteProjectClusterMutation = { __typename?: 'Mutation', deleteProjectCluster: boolean };

export type GetProjectPolicyQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetProjectPolicyQuery = { __typename?: 'Query', getProjectPolicy?: { __typename?: 'projectPolicyEntity', id: string, projectId: string, interestRate: number, creditTerms: number, roundingMode: string, roundingPrecision: string, unitSort?: string | null } | null };

export type CreateProjectPolicyMutationVariables = Exact<{
  input: AddProjectPolicyInput;
}>;


export type CreateProjectPolicyMutation = { __typename?: 'Mutation', createProjectPolicy: { __typename?: 'projectPolicyEntity', projectId: string, interestRate: number, creditTerms: number, roundingMode: string, roundingPrecision: string } };

export type UpdateProjectPolicyMutationVariables = Exact<{
  input: EditProjectPolicyInput;
}>;


export type UpdateProjectPolicyMutation = { __typename?: 'Mutation', updateProjectPolicy: { __typename?: 'projectPolicyEntity', id: string, projectId: string, interestRate: number, creditTerms: number, roundingMode: string, roundingPrecision: string } };

export type AddProjectPolicyMutationVariables = Exact<{
  projectPolicyInput: ProjectPolicyInput;
  latePaymentInput: LateInterestInput;
}>;


export type AddProjectPolicyMutation = { __typename?: 'Mutation', addProjectPolicy: boolean };

export type GetUsersRoleProjectQueryVariables = Exact<{
  projectId: Scalars['String'];
  roleId: Scalars['String'];
}>;


export type GetUsersRoleProjectQuery = { __typename?: 'Query', getUsersRoleProject: any };

export type GetProjectUserRoleQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetProjectUserRoleQuery = { __typename?: 'Query', getProjectUserRole?: Array<{ __typename?: 'projectRoleUserListingOutput', ID: string, name: string, roleIds?: string | null }> | null };

export type CreateListEntityRoleUserMutationVariables = Exact<{
  roleUserIDs: Array<UserRoleAssignmentInput> | UserRoleAssignmentInput;
  projectId: Scalars['String'];
}>;


export type CreateListEntityRoleUserMutation = { __typename?: 'Mutation', CreateListEntityRoleUser: boolean };

export type CreateProjectRoleUserMutationVariables = Exact<{
  input: ProjectRoleInput;
}>;


export type CreateProjectRoleUserMutation = { __typename?: 'Mutation', CreateProjectRoleUser: boolean };

export type GetProjectSalesPolicyByProjectIdQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetProjectSalesPolicyByProjectIdQuery = { __typename?: 'Query', getProjectSalesPolicyByProjectId?: { __typename?: 'projectSalesPolicyOutput', id: string, npvBasicRate?: string | null, npvRate?: number | null, roundingPrecision: string, roundingMode: string, interestBasicRate: string, interestRate: number, collectLandDeposit: boolean, ujpMinimumDepositAmount?: number | null, ujpDepositAmount?: number | null, generateOverdueDebtorEvery?: string | null, generateOverdueDebtorTime?: string | null, taxSchemeId?: string | null, projectSalesPolicy?: Array<{ __typename?: 'UJPP', id?: string | null, landAreaFrom?: number | null, landAreaTo?: number | null, depositAmount?: number | null }> | null } | null };

export type GetTaxSchemeLateInterestQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTaxSchemeLateInterestQuery = { __typename?: 'Query', getTaxSchemeLateInterest: Array<{ __typename?: 'TaxSchemeDropdownOutput', taxSchemeId: string, taxSchemeName: string }> };

export type AddProjectSalesAndDetailsPolicyMutationVariables = Exact<{
  input: AddProjectSalesPolicyInput;
  projectId: Scalars['String'];
}>;


export type AddProjectSalesAndDetailsPolicyMutation = { __typename?: 'Mutation', addProjectSalesAndDetailsPolicy?: boolean | null };

export type EditProjectSalesPolicyAndDetailsMutationVariables = Exact<{
  input: EditProjectSalesPolicyInput;
  projectId: Scalars['String'];
  projectSalesPolicyId: Scalars['String'];
}>;


export type EditProjectSalesPolicyAndDetailsMutation = { __typename?: 'Mutation', editProjectSalesPolicyAndDetails?: boolean | null };

export type GetProjectSalesPolicyEnumOutputQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProjectSalesPolicyEnumOutputQuery = { __typename?: 'Query', getProjectSalesPolicyEnumOutput: { __typename?: 'ProjectSalesPolicyEnumsOutput', npvBasicRate: Array<{ __typename?: 'ProjectSalesPolicyEnum', id: string, name: string }>, roundingMode: Array<{ __typename?: 'ProjectSalesPolicyEnum', id: string, name: string }>, roundingPrecision: Array<{ __typename?: 'ProjectSalesPolicyEnum', id: string, name: string }>, interestBasicRate: Array<{ __typename?: 'ProjectSalesPolicyEnum', id: string, name: string }>, overdueDay: Array<{ __typename?: 'ProjectSalesPolicyEnum', id: string, name: string }> } };

export type GetProjectSettingSummaryQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetProjectSettingSummaryQuery = { __typename?: 'Query', projectLastUpdate?: any | null, roleAuthLastUpdate?: any | null, projectSalesPolicyLastUpdate?: any | null, unitCount?: number | null, carParkCount?: number | null, salesPackagesCount?: number | null, assignedDiscountCount?: number | null, projectCampaignCount?: number | null, panelEndFinCount?: number | null, totalFinancialLimit?: number | null, panelSolicitorCount?: number | null, projectLetterLastUpdate?: any | null, stampDutyIntegrationLastUpdate?: any | null, salesOfficeLastUpdate?: any | null, constructionInfoLastUpdate?: any | null, fireInsuranceLastUpdate?: any | null, businessPermitLastUpdate?: any | null, projectPaymentPlanLastUpdate?: any | null, projectPaymentPlanCount?: number | null, promotionalPackagesLastUpdate?: any | null, teamAssignmentLastUpdate?: any | null, projectReminderSettingLastUpdate?: any | null, unitStatutoryDocumentCount?: number | null, notaryAssignmentLastUpdate?: any | null, priceAdjustmentSummary?: { __typename?: 'summaryOutput', lastUpdateDate?: any | null, count: number } | null };

export type GetPromotionalItemListingQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetPromotionalItemListingQuery = { __typename?: 'Query', getPromotionalItemListing?: Array<{ __typename?: 'promotionalItemEntity', id: string, name: string, cost: number, description: string }> | null };

export type AddPromotionalItemMutationVariables = Exact<{
  input: AddPromotionalItemInput;
}>;


export type AddPromotionalItemMutation = { __typename?: 'Mutation', addPromotionalItem: boolean };

export type EditPromotionalItemMutationVariables = Exact<{
  input: EditPromotionalItemInput;
}>;


export type EditPromotionalItemMutation = { __typename?: 'Mutation', editPromotionalItem: boolean };

export type DeletePromotionalItemMutationVariables = Exact<{
  projectId: Scalars['String'];
  promotionalItemId: Scalars['String'];
}>;


export type DeletePromotionalItemMutation = { __typename?: 'Mutation', deletePromotionalItem: boolean };

export type GetPromotionalPackagesListingQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetPromotionalPackagesListingQuery = { __typename?: 'Query', getPromotionalPackagesListing?: Array<{ __typename?: 'promotionalPackagesOutput', name: string, promotionalPackageId: string, costPrice: number, promoPrice: number, startDate: any, endDate: any }> | null };

export type GetPromotionalPackagesItemDetailsListingQueryVariables = Exact<{
  promotionalPackagesId: Scalars['String'];
}>;


export type GetPromotionalPackagesItemDetailsListingQuery = { __typename?: 'Query', getPromotionalPackagesItemDetailsListing?: Array<{ __typename?: 'promotionalPackagesItemsDetailsOutput', id: string, packageName: string, startDate: any, endDate: any, itemName: string, costPrice: number, promoPrice: number, itemDescription: string, promotionalPackageId: string, promotionalItemId: string }> | null };

export type GetPromotionalPackagesByProjectIdQueryVariables = Exact<{
  promotionalPackagesId: Scalars['String'];
  projectId: Scalars['String'];
}>;


export type GetPromotionalPackagesByProjectIdQuery = { __typename?: 'Query', getPromotionalPackagesByProjectId: { __typename?: 'promotionalPackagesEntity', id: string, accountId: string, projectId: string, name: string, startDate: any, endDate: any, createdBy?: string | null, createdTs: any, items?: Array<{ __typename?: 'promotionalPackagesItemEntity', id: string, accountId: string, promotionalPackagesId: string, promotionalItemId: string, costPrice: number, promoPrice: number, description: string, recordStatus: string, createdBy?: string | null, createdTs: any }> | null } };

export type GetPromotionalItemQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPromotionalItemQuery = { __typename?: 'Query', getPromotionalItem: Array<{ __typename?: 'PromotionalItemOutput', promotionalItemId: string, name: string }> };

export type AddPromotionalPackageMutationVariables = Exact<{
  projectId: Scalars['String'];
  input: AddPromotionalPackagesInput;
}>;


export type AddPromotionalPackageMutation = { __typename?: 'Mutation', addPromotionalPackage: boolean };

export type EditPromotionalPackagesMutationVariables = Exact<{
  projectId: Scalars['String'];
  input: EditPromotionalPackagesInput;
  promotionalPackageId: Scalars['String'];
}>;


export type EditPromotionalPackagesMutation = { __typename?: 'Mutation', editPromotionalPackages: boolean };

export type DeletePromotionalPackageMutationVariables = Exact<{
  projectId: Scalars['String'];
  promotionalPackageId: Scalars['String'];
}>;


export type DeletePromotionalPackageMutation = { __typename?: 'Mutation', deletePromotionalPackage: boolean };

export type DeletePromotionalItemInDetailsListingMutationVariables = Exact<{
  promotionalPackagesItemId: Scalars['String'];
}>;


export type DeletePromotionalItemInDetailsListingMutation = { __typename?: 'Mutation', deletePromotionalItemInDetailsListing: boolean };

export type GetProjectSalesOfficeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProjectSalesOfficeQuery = { __typename?: 'Query', getProjectSalesOffice?: { __typename?: 'ProjectSalesOfficeEntity', id: string, salesOfficeTel?: string | null, salesOfficeFax?: string | null, salesOfficeAddress?: string | null, propertyManager?: string | null, projectManager?: string | null, generalManager?: string | null, salesMarketingHOD?: string | null, creditControlHOD?: string | null, creditControlOfficeTel?: string | null, creditControlEmail?: string | null, customerCareHOD?: string | null, customerCareContactNo?: string | null, customerCareEmail?: string | null, areaUOM1?: string | null, areaUOM2?: string | null, areaUOM3?: string | null, areaUOMConversion1?: string | null, areaUOMConversion2?: string | null, salesLocalAuthorityName?: string | null, salesLocalAuthorityContactNo?: string | null, customerCareLocalAuthorityName?: string | null, customerCareLocalAuthorityContactNo?: string | null, buildingContractorAwarded?: string | null, buildingContractorName?: string | null, warrantyPeriod?: number | null, DLPTerm1?: string | null, DLPTerm2?: string | null, salesPermit?: string | null, architecturePermit?: string | null, constructionPermit?: string | null, builtUpArea?: number | null, densityPercentage?: number | null, floorArea?: number | null, floorAreaPercent?: number | null, commonArea?: number | null, commonAreaPercent?: number | null, greenspaceArea?: number | null, greenspaceAreaPercent?: number | null, landArea?: number | null, usageRatioPercent?: number | null, usagePurpose?: string | null, salesLocalAuthorityAddress?: { __typename?: 'AddressJson', address?: string | null, country?: string | null, city?: string | null, state?: string | null, postCode?: string | null } | null, customerCareLocalAuthorityAddress?: { __typename?: 'AddressJson', address?: string | null, country?: string | null, city?: string | null, state?: string | null, postCode?: string | null } | null } | null };

export type AddProjectSalesOfficeMutationVariables = Exact<{
  input: SalesOfficeInput;
}>;


export type AddProjectSalesOfficeMutation = { __typename?: 'Mutation', addProjectSalesOffice: boolean };

export type EditProjectSalesOfficeMutationVariables = Exact<{
  input: EditSalesOfficeInput;
}>;


export type EditProjectSalesOfficeMutation = { __typename?: 'Mutation', editProjectSalesOffice: boolean };

export type GetPackageFormSourceQueryVariables = Exact<{
  saleId: Scalars['String'];
}>;


export type GetPackageFormSourceQuery = { __typename?: 'Query', getPackageFormSource: Array<{ __typename?: 'packageEntity', id: string, name: string, desc?: string | null, projectId: string, listPrice: number, marketValue: number, startDate: any, endDate: any, isDeletable: boolean, isIntegrated: boolean, commonStatus: string, packageExt?: { __typename?: 'packageExtEntity', taxSchemeId: string, defaulted: boolean } | null }> };

export type GetSalesPackagesListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSalesPackagesListQuery = { __typename?: 'Query', getSalesPackagesList: Array<{ __typename?: 'packageEntity', id: string, name: string, desc?: string | null, projectId: string, listPrice: number, marketValue: number, startDate: any, endDate: any, isDeletable: boolean, isIntegrated: boolean, commonStatus: string, packageExt?: { __typename?: 'packageExtEntity', taxSchemeId: string, defaulted: boolean } | null }> };

export type SetDefaultSalesPackageForProjectMutationVariables = Exact<{
  projectId: Scalars['String'];
  packageId: Scalars['String'];
  check: Scalars['Boolean'];
}>;


export type SetDefaultSalesPackageForProjectMutation = { __typename?: 'Mutation', setDefaultSalesPackageForProject: boolean };

export type AddSalesPackageMutationVariables = Exact<{
  input: AddSalesPackageInput;
}>;


export type AddSalesPackageMutation = { __typename?: 'Mutation', addSalesPackage: boolean };

export type EditSalesPackageMutationVariables = Exact<{
  input: EditSalesPackageInput;
}>;


export type EditSalesPackageMutation = { __typename?: 'Mutation', editSalesPackage: boolean };

export type GetSalesPackageByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetSalesPackageByIdQuery = { __typename?: 'Query', getSalesPackageById: { __typename?: 'packageEntity', id: string, name: string, desc?: string | null, projectId: string, listPrice: number, marketValue: number, startDate: any, endDate: any, packageExt?: { __typename?: 'packageExtEntity', taxSchemeId: string, defaulted: boolean } | null } };

export type ActivatePackageMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ActivatePackageMutation = { __typename?: 'Mutation', activatePackage: boolean };

export type DeactivatePackageMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeactivatePackageMutation = { __typename?: 'Mutation', deactivatePackage: boolean };

export type GetProjectByIdQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetProjectByIdQuery = { __typename?: 'Query', getProjectById: { __typename?: 'projectEntity', id: string, name: string, currency: string } };

export type GetStampDutyIntegrationQueryVariables = Exact<{
  projectId: Scalars['String'];
  id: Scalars['String'];
}>;


export type GetStampDutyIntegrationQuery = { __typename?: 'Query', getStampDutyIntegration?: { __typename?: 'stampDutyIntegrationOutput', id: string, type: string, projectLetterTemplateName: string, extension: string, stampDutyDescription: string } | null };

export type GetStampDutyIntegrationListingQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetStampDutyIntegrationListingQuery = { __typename?: 'Query', getStampDutyIntegrationListing?: Array<{ __typename?: 'stampDutyIntegrationListingOutput', id: string, type: string, projectLetterTemplateId: string, projectLetterTemplateName: string, extension: string, stampDutyId: string, stampDutyDescription: string }> | null };

export type CreateStampDutyIntegrationMutationVariables = Exact<{
  input: CreateStampDutyIntegrationInput;
}>;


export type CreateStampDutyIntegrationMutation = { __typename?: 'Mutation', createStampDutyIntegration: boolean };

export type UpdateStampDutyIntegrationMutationVariables = Exact<{
  input: UpdateStampDutyIntegrationInput;
}>;


export type UpdateStampDutyIntegrationMutation = { __typename?: 'Mutation', updateStampDutyIntegration: boolean };

export type DeleteStampDutyIntegrationMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteStampDutyIntegrationMutation = { __typename?: 'Mutation', deleteStampDutyIntegration: boolean };

export type GetStampDutyOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStampDutyOptionsQuery = { __typename?: 'Query', getStampDutyOptions?: Array<{ __typename?: 'stampDutyOptionOutput', id: string, code: string, description: string }> | null };

export type GetStandardLetterByCategoryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStandardLetterByCategoryQuery = { __typename?: 'Query', getStandardLetterByCategory?: Array<{ __typename?: 'standardLetterCategoryOutput', letterCategory: string, letterDetail: Array<{ __typename?: 'letterCategoryDetailOutput', id: string, name: string, type: string, isAllowHtmlEditor: boolean, isAllowReportDesignEditor: boolean }> }> | null };

export type GetProjectLetterTemplateListingQueryVariables = Exact<{
  standardLetterId: Scalars['String'];
  projectId: Scalars['String'];
}>;


export type GetProjectLetterTemplateListingQuery = { __typename?: 'Query', getProjectLetterTemplateListing: Array<{ __typename?: 'projectLetterTemplateEntity', id: string, standardLetterId: string, name: string, defaulted: boolean, isReportDesignEditor: boolean, standardLetterDataSourceVersion?: number | null, standardLetter: { __typename?: 'standardLetterEntity', name: string, isAllowHtmlEditor: boolean, isAllowReportDesignEditor: boolean }, slDataSource?: { __typename?: 'standardLetterDataSourceEntity', id: string, version: number } | null }> };

export type AddStandardLetterMutationVariables = Exact<{
  input: StandardLetterInput;
}>;


export type AddStandardLetterMutation = { __typename?: 'Mutation', addStandardLetter: string };

export type EditStandardLetterMutationVariables = Exact<{
  input: EditStandardLetterInput;
}>;


export type EditStandardLetterMutation = { __typename?: 'Mutation', editStandardLetter: string };

export type GetProjectLetterTemplateByIdQueryVariables = Exact<{
  standardLetterId: Scalars['String'];
  projectId: Scalars['String'];
  letterTemplateId: Scalars['String'];
}>;


export type GetProjectLetterTemplateByIdQuery = { __typename?: 'Query', getProjectLetterTemplateById: { __typename?: 'projectLetterTemplateEntity', id: string, standardLetterId: string, name: string, templateBody?: string | null, jointBuyerSignRequired: boolean, isReportDesignEditor: boolean } };

export type CloneStandardLetterMutationVariables = Exact<{
  letterTemplateIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type CloneStandardLetterMutation = { __typename?: 'Mutation', cloneStandardLetter: boolean };

export type DeleteStandardLetterMutationVariables = Exact<{
  letterTemplateId: Scalars['String'];
}>;


export type DeleteStandardLetterMutation = { __typename?: 'Mutation', deleteStandardLetter: boolean };

export type SetDefaultStandardLetterMutationVariables = Exact<{
  letterTemplateId: Scalars['String'];
  defaulted: Scalars['Boolean'];
}>;


export type SetDefaultStandardLetterMutation = { __typename?: 'Mutation', setDefaultStandardLetter: boolean };

export type ProjectLetterTemplateRebuildReportMutationVariables = Exact<{
  id: Scalars['String'];
  sldsId: Scalars['String'];
}>;


export type ProjectLetterTemplateRebuildReportMutation = { __typename?: 'Mutation', projectLetterTemplateRebuildReport: boolean };

export type DesignProjectLetterTemplateMutationVariables = Exact<{
  input: DesignLetterTemplateInput;
}>;


export type DesignProjectLetterTemplateMutation = { __typename?: 'Mutation', designProjectLetterTemplate: boolean };

export type GetSalesTeamByProjectQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetSalesTeamByProjectQuery = { __typename?: 'Query', getSalesTeamByProject: Array<{ __typename?: 'saleTeamEntity', id: string, name: string, memberCount?: number | null }> };

export type EditSalesTeamsMutationVariables = Exact<{
  input: EditTeamInput;
}>;


export type EditSalesTeamsMutation = { __typename?: 'Mutation', editSalesTeams: boolean };

export type AddSalesTeamsMutationVariables = Exact<{
  input: TeamInput;
}>;


export type AddSalesTeamsMutation = { __typename?: 'Mutation', addSalesTeams: boolean };

export type DeleteSalesTeamByIdMutationVariables = Exact<{
  teamId: Scalars['String'];
}>;


export type DeleteSalesTeamByIdMutation = { __typename?: 'Mutation', deleteSalesTeamById: boolean };

export type GetAssignedTeamMembersQueryVariables = Exact<{
  teamId: Scalars['String'];
}>;


export type GetAssignedTeamMembersQuery = { __typename?: 'Query', getAssignedTeamMembers: Array<{ __typename?: 'UserEntity', ID: string, name?: string | null, contactNo: string, email: string }> };

export type GetUnassignedTeamMembersQueryVariables = Exact<{
  projectId: Scalars['String'];
  teamId: Scalars['String'];
}>;


export type GetUnassignedTeamMembersQuery = { __typename?: 'Query', getUnassignedTeamMembers: Array<{ __typename?: 'UserEntity', ID: string, name?: string | null, contactNo: string, email: string }> };

export type AssignTeamMemberMutationVariables = Exact<{
  projectId: Scalars['String'];
  teamId: Scalars['String'];
  userIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type AssignTeamMemberMutation = { __typename?: 'Mutation', assignTeamMember: boolean };

export type UnassignTeamMemberMutationVariables = Exact<{
  teamId: Scalars['String'];
  userIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type UnassignTeamMemberMutation = { __typename?: 'Mutation', unassignTeamMember: boolean };

export type GetPriceAdjustmentListQueryVariables = Exact<{
  projectId: Scalars['String'];
  statusFilter?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetPriceAdjustmentListQuery = { __typename?: 'Query', getPriceAdjustmentList?: Array<{ __typename?: 'priceAdjustmentListOutput', id: string, name?: string | null, remark?: string | null, status: string, approvalRoleId?: string | null, unitCount?: number | null, submitUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null }> | null };

export type GetPriceAdjustmentByIdQueryVariables = Exact<{
  projectId: Scalars['String'];
  id: Scalars['String'];
}>;


export type GetPriceAdjustmentByIdQuery = { __typename?: 'Query', getPriceAdjustmentById?: { __typename?: 'priceAdjustmentDetailOutput', id: string, name: string, computationMode: string, computationValue: number, roundingMode: string, roundingPrecision: string, displayRoundingMode?: string | null, displayRoundingPrecision?: string | null, reason: string, remark: string, status: string, approvalRoleId?: string | null, priceAdjustmentUnit?: Array<{ __typename?: 'priceAdjustmentUnitList', id: string, newUnitListPrice: number, unitListPrice: number, unitNo: string, unitId: string }> | null, defaultReason?: Array<{ __typename?: 'reasonCodeEntity', id: string, name: string }> | null } | null };

export type AddPriceAdjustmentMutationVariables = Exact<{
  input: AddPriceAdjustmentInput;
}>;


export type AddPriceAdjustmentMutation = { __typename?: 'Mutation', addPriceAdjustment: boolean };

export type EditPriceAdjustmentMutationVariables = Exact<{
  input: EditPriceAdjustmentInput;
}>;


export type EditPriceAdjustmentMutation = { __typename?: 'Mutation', editPriceAdjustment: boolean };

export type GetSelectUnitAtPriceAdjustmentQueryVariables = Exact<{
  projectId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
}>;


export type GetSelectUnitAtPriceAdjustmentQuery = { __typename?: 'Query', getSelectUnitAtPriceAdjustment: Array<{ __typename?: 'projectTitleBlockListingOutput', block: string, totalFloor: number, floorList?: Array<{ __typename?: 'projectTitleFloorListingOutput', floorLabel?: string | null, totalUnit?: number | null, unitList?: Array<{ __typename?: 'projectTitleUnitListingOutput', unitId?: string | null, unitNo?: string | null }> | null }> | null }> };

export type UpdatePriceAdjustmentStatusMutationVariables = Exact<{
  projectId: Scalars['String'];
  isApproved: Scalars['Boolean'];
  sourceIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type UpdatePriceAdjustmentStatusMutation = { __typename?: 'Mutation', updatePriceAdjustmentStatus: boolean };

export type GetReasonListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReasonListQuery = { __typename?: 'Query', getReasonList: Array<{ __typename?: 'reasonCodeEntity', id: string, name: string }> };

export type SoftDeletePriceAdjustmentMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type SoftDeletePriceAdjustmentMutation = { __typename?: 'Mutation', softDeletePriceAdjustment: boolean };

export type GetBlockByProjectQueryVariables = Exact<{
  ProjectId: Scalars['String'];
  SubproductStatus: Scalars['Boolean'];
}>;


export type GetBlockByProjectQuery = { __typename?: 'Query', GetBlockByProject: { __typename?: 'BlockByProjectOutput', blocks: Array<string>, integrated: boolean } };

export type GetUnitByProjectBlockQueryVariables = Exact<{
  ProjectId: Scalars['String'];
  Block: Scalars['String'];
}>;


export type GetUnitByProjectBlockQuery = { __typename?: 'Query', GetUnitByProjectBlock: Array<{ __typename?: 'unitEntity', id: string, unitNo: string, phase?: string | null, unitTypeId?: string | null, unitLayoutId?: string | null, unitLayoutDes?: string | null, facingDirectionId?: string | null, block?: string | null, floor?: number | null, floorLabel?: string | null, builtUp: number, landArea?: string | null, extraLandArea?: number | null, facingView?: string | null, price: number, timeLock?: any | null, cell: number, hsdNo?: string | null, ptdNo?: string | null, isBumi: boolean, commonStatus: string, unitStatus: string, unitLockBy?: string | null, facingDirection?: { __typename?: 'directionEntity', id: string, name: string } | null, unitType?: { __typename?: 'unitTypeEntity', id: string, name: string, seq_no?: number | null } | null, unitLayout?: { __typename?: 'unitLayoutEntity', desc: string } | null }> };

export type GetAllPropertyUnitTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllPropertyUnitTypeQuery = { __typename?: 'Query', getAllPropertyType?: Array<{ __typename?: 'propertyTypeEntity', id: string, name: string, commercialPurposeDesc: string }> | null, getAllUnitType?: Array<{ __typename?: 'unitTypeEntity', id: string, name: string }> | null };

export type GetAllUnitProjectQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetAllUnitProjectQuery = { __typename?: 'Query', GetAllUnitProject: any };

export type GetAllFloorByBlockQueryVariables = Exact<{
  projectId: Scalars['String'];
  block: Scalars['String'];
  subproductStatus: Scalars['Boolean'];
}>;


export type GetAllFloorByBlockQuery = { __typename?: 'Query', getAllFloorByBlock: { __typename?: 'floorByBlockOutput', cellList?: Array<string> | null, availableUnitCount?: number | null, signUnitCount?: number | null, soldUnitCount?: number | null, unavailableUnitCount?: number | null, floorList?: Array<{ __typename?: 'floorList', floorLabel: string, unitList: Array<{ __typename?: 'unitFloorList', unitId: string, unitNo: string, unitCell: number, unitFloor: number, unitStatus: string, unitFloorLabel: string, commonStatus: string, isBumi: boolean }> }> | null } };

export type ExportExcelQueryVariables = Exact<{
  projectId: Scalars['String'];
  exportType: Scalars['String'];
}>;


export type ExportExcelQuery = { __typename?: 'Query', exportExcel: { __typename?: 'UnitExcelOutput', base64: string, projectname: string } };

export type ImportExcelQueryVariables = Exact<{
  file: Scalars['Upload'];
  projectId: Scalars['String'];
  method: Scalars['String'];
  importType: Scalars['String'];
}>;


export type ImportExcelQuery = { __typename?: 'Query', importExcel: { __typename?: 'UnitExcelReturnOutput', message: string, file_name: string, file?: string | null } };

export type ImportUnitOptionsQueryVariables = Exact<{
  projectId: Scalars['String'];
  checkType: Scalars['String'];
}>;


export type ImportUnitOptionsQuery = { __typename?: 'Query', ImportUnitOptions: { __typename?: 'UnitImportOptionOutput', displayImportMethods: boolean, overwrite: boolean, append: boolean, modify: boolean, emptyProject: boolean } };

export type GetUnitMasterDataQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetUnitMasterDataQuery = { __typename?: 'Query', getUnitMasterData: { __typename?: 'unitMasterDataOutput', propertyType?: Array<{ __typename?: 'dropDownDataOutput', id: string, name: string }> | null, paymentPlan?: Array<{ __typename?: 'dropDownDataOutput', id: string, name: string }> | null, direction?: Array<{ __typename?: 'dropDownDataOutput', id: string, name: string }> | null, unitType?: Array<{ __typename?: 'dropDownDataOutput', id: string, name: string }> | null, unitLayout?: Array<{ __typename?: 'dropDownDataOutput', id: string, name: string }> | null, solicitor?: Array<{ __typename?: 'dropDownDataOutput', id: string, name: string, solicitorCode?: string | null }> | null, cluster?: Array<{ __typename?: 'dropDownDataOutput', id: string, name: string }> | null, taxScheme?: Array<{ __typename?: 'dropDownDataOutput', id: string, name: string }> | null } };

export type GenerateUnitMutationVariables = Exact<{
  input: GenerateUnitInput;
}>;


export type GenerateUnitMutation = { __typename?: 'Mutation', generateUnit: boolean };

export type EditUnitInformationMutationVariables = Exact<{
  input: EditUnitInformationInput;
}>;


export type EditUnitInformationMutation = { __typename?: 'Mutation', editUnitInformation: boolean };

export type DeleteSelectedUnitsMutationVariables = Exact<{
  input: DeleteUnitInput;
}>;


export type DeleteSelectedUnitsMutation = { __typename?: 'Mutation', deleteSelectedUnits: boolean };

export type GetUnitByIdQueryVariables = Exact<{
  unitId: Scalars['String'];
}>;


export type GetUnitByIdQuery = { __typename?: 'Query', getUnitByID: { __typename?: 'unitEntity', id: string, unitNo: string, block?: string | null, floor?: number | null, floorLabel?: string | null, price: number, bottomPrice?: number | null, builtUp: number, landArea?: string | null, extraLandArea?: number | null, facingView?: string | null, isBumi: boolean, phase?: string | null, propertyType: { __typename?: 'propertyTypeEntity', name: string }, facingDirection?: { __typename?: 'directionEntity', name: string } | null, unitType?: { __typename?: 'unitTypeEntity', name: string } | null, unitLayout?: { __typename?: 'unitLayoutEntity', desc: string } | null, units?: { __typename?: 'unitEntity', unitNo: string } | null, unitExt?: { __typename?: 'unitExtensionEntity', landAreaRate?: number | null, usableArea?: number | null, noOfStorey?: number | null, dlpExpiryDate?: any | null, scheduleLaunchDate?: any | null, actualBuiltUpArea?: number | null, builtUpAreaRate?: number | null, actualLandArea?: number | null, shareValue?: string | null, lotPtNo?: string | null, hsdHsmNo?: string | null, masterGrantNo?: string | null, district?: string | null, subdivisionMukim?: string | null, leasePejakanNegeri?: string | null, noOfKey?: number | null, remark?: string | null, bumiReleaseDate?: any | null, bumiReleaseReferenceNo?: string | null, dlp1Date?: any | null, dlp2Date?: any | null, premium?: string | null, bumiAllocation?: boolean | null, stampDutyWaiver?: boolean | null, bookingFee?: number | null, unitAddress?: { __typename?: 'AddressJson', address?: string | null, country?: string | null, city?: string | null, state?: string | null, postCode?: string | null } | null, projectCluster: { __typename?: 'projectClusterEntity', name: string }, paymentPlan?: { __typename?: 'paymentPlanEntity', name: string } | null, lawyer?: { __typename?: 'solicitorAppointedEntity', name: string } | null, stakeholder?: { __typename?: 'solicitorAppointedEntity', name: string } | null } | null } };

export type EditBlockLabelMutationVariables = Exact<{
  input: EditBlockInput;
}>;


export type EditBlockLabelMutation = { __typename?: 'Mutation', editBlockLabel: boolean };

export type GetUnitNoPrefixQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnitNoPrefixQuery = { __typename?: 'Query', getUnitNoPrefix: Array<string> };

export type GetUnitStatutoryDocsListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnitStatutoryDocsListQuery = { __typename?: 'Query', getUnitStatutoryDocsList: Array<{ __typename?: 'unitStatutoryDocumentOutput', id: string, docCnt: number, unitNo?: string | null, statutoryDocId?: string | null, statutoryDocName?: string | null, statutoryDocCode?: string | null, clusterName?: string | null }> };

export type GetUnitPropertyTitleListQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetUnitPropertyTitleListQuery = { __typename?: 'Query', getUnitPropertyTitleList: Array<{ __typename?: 'projectTitleBlockListingOutput', block: string, totalFloor: number, floorList?: Array<{ __typename?: 'projectTitleFloorListingOutput', floorLabel?: string | null, totalUnit?: number | null, unitList?: Array<{ __typename?: 'projectTitleUnitListingOutput', unitId?: string | null, unitNo?: string | null }> | null }> | null }> };

export type AddUnitStatutoryDocumentMutationVariables = Exact<{
  input: AddUnitStatutoryDocumentIndoInput;
}>;


export type AddUnitStatutoryDocumentMutation = { __typename?: 'Mutation', addUnitStatutoryDocument: boolean };

export type BookingListBusinessInsightQueryVariables = Exact<{ [key: string]: never; }>;


export type BookingListBusinessInsightQuery = { __typename?: 'Query', bookingListBusinessInsight?: { __typename?: 'BookingBIOutput', totalCount?: number | null, totalAmount?: number | null, cancelCount?: number | null, signCount?: number | null, cancelRate?: number | null, signRate?: number | null, direct: { __typename?: 'BookingListDetailBIOutput', totalCount?: number | null, totalAmount?: number | null, existingCount?: number | null, existingAmount?: number | null, newCount?: number | null, newAmount?: number | null }, lead: { __typename?: 'BookingListDetailBIOutput', totalCount?: number | null, totalAmount?: number | null, existingCount?: number | null, existingAmount?: number | null, newCount?: number | null, newAmount?: number | null }, agency: { __typename?: 'BookingListDetailBIOutput', totalCount?: number | null, totalAmount?: number | null, existingCount?: number | null, existingAmount?: number | null, newCount?: number | null, newAmount?: number | null } } | null };

export type BookingListAnalysisBusinessInsightQueryVariables = Exact<{ [key: string]: never; }>;


export type BookingListAnalysisBusinessInsightQuery = { __typename?: 'Query', bookingListAnalysisBusinessInsight?: { __typename?: 'BookingAnalysisBIOutput', totalCount?: number | null, totalAmount?: number | null, cancelCount?: number | null, signCount?: number | null, cancelRate?: number | null, signRate?: number | null, leadSources?: Array<{ __typename?: 'BookingAnalysisSourceListBIOutput', leadSourceName: string, leadSourceCount?: number | null, value?: number | null }> | null } | null };

export type GetBusinessInsightSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBusinessInsightSummaryQuery = { __typename?: 'Query', getBusinessInsightSummary?: { __typename?: 'BusinessInsightSummaryOutput', ToPMsummary: string, waitingListSummary: string, outstandingSnPSummary: string, loanBISummary: string, bookingListSummary: string, slpSummary: string, pspSummary: string, lsmSummary: string, salesMovementSummary: string, salesAnalysisSummary: string, salesAnalysisByUnitSummary: string, scaSummary: string, stpSummary: string, sapSummary: string, sdaSummary: string, cpSummary: string } | null };

export type GetCampaignPerformanceQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCampaignPerformanceQuery = { __typename?: 'Query', getCampaignPerformance?: Array<{ __typename?: 'CampaignPerformanceBIOutput', id: string, name: string, total: string, converted?: number | null, unconverted?: number | null, booked?: number | null, signed?: number | null, leads?: number | null, startDate: any, endDate: any }> | null };

export type GetEventPerformanceByCampaignIdQueryVariables = Exact<{
  campaignId: Scalars['String'];
}>;


export type GetEventPerformanceByCampaignIdQuery = { __typename?: 'Query', getEventPerformanceByCampaignId?: Array<{ __typename?: 'EventPerformanceBIOutput', id: string, name: string, total: string, converted?: number | null, unconverted?: number | null, booked?: number | null, signed?: number | null, leads?: number | null, startDate: any, endDate: any, budget: number, cold?: number | null, hot?: number | null, open?: number | null, wait?: number | null, drop?: number | null, repeat?: number | null, cancelled?: number | null }> | null };

export type GetOutstandingSnPQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOutstandingSnPQuery = { __typename?: 'Query', getOutstandingSnP?: { __typename?: 'OutstandingSnPOutput', oneWeek: Array<{ __typename?: 'unitData', unit_id?: string | null, unit_no?: string | null, book_date?: string | null, sales_team_name?: string | null, buyer_name?: string | null, spa_price?: string | null }>, twoWeek: Array<{ __typename?: 'unitData', unit_id?: string | null, unit_no?: string | null, book_date?: string | null, sales_team_name?: string | null, buyer_name?: string | null, spa_price?: string | null }>, threeWeek: Array<{ __typename?: 'unitData', unit_id?: string | null, unit_no?: string | null, book_date?: string | null, sales_team_name?: string | null, buyer_name?: string | null, spa_price?: string | null }>, fourWeek: Array<{ __typename?: 'unitData', unit_id?: string | null, unit_no?: string | null, book_date?: string | null, sales_team_name?: string | null, buyer_name?: string | null, spa_price?: string | null }> } | null };

export type ProjectSalesBusinessInsightDataQueryVariables = Exact<{ [key: string]: never; }>;


export type ProjectSalesBusinessInsightDataQuery = { __typename?: 'Query', projectSalesBusinessInsightData?: { __typename?: 'projectEntity', id: string, currency: string, projectSpec: Array<{ __typename: 'projectSpecEntity', reservationSales: boolean, reservationAgency: boolean }>, unitCountByStatus?: { __typename: 'ProjectUnitStatusCount', totalUnitCount?: number | null, totalUnitPrice?: number | null, availableUnitCount?: number | null, signedUnitCount?: number | null, soldUnitCount?: number | null, bookUnitCount?: number | null, unavailableUnitCount?: number | null, reservationUnitCount?: number | null, totalAvailableUnitPrice?: number | null, totalSignedUnitPrice?: number | null, totalBookUnitPrice?: number | null, totalReservationUnitPrice?: number | null, totalSoldUnitPrice?: number | null, totalUnavailableUnitPrice?: number | null } | null, unitCountByBlock: Array<{ __typename: 'BlockCountByStatusOutput', block?: string | null, totalUnitCount: number, availableUnitCount: number, signUnitCount: number, soldUnitCount: number, bookUnitCount: number, unavailableUnitCount: number, reservationUnitCount?: number | null }>, unitCountByUnitType: Array<{ __typename: 'UnitTypeCountByStatusOutput', unitType: string, totalUnitCount: number, availableUnitCount: number, signUnitCount: number, soldUnitCount: number, bookUnitCount: number, unavailableUnitCount: number, reservationUnitCount?: number | null }> } | null };

export type GetLeadSourceFilterListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLeadSourceFilterListQuery = { __typename?: 'Query', getLeadSourceFilterList: Array<{ __typename?: 'leadSourceEntity', id: string, name: string }> };

export type GetLeadCountByProjectQueryVariables = Exact<{
  lead_source_id?: InputMaybe<Scalars['String']>;
}>;


export type GetLeadCountByProjectQuery = { __typename?: 'Query', getLeadCountByProject: { __typename?: 'LeadStatusCountOutput', projectId?: string | null, waitingCount?: number | null, openCount?: number | null, hotCount?: number | null, coldCount?: number | null, dropCount?: number | null, bookedCount?: number | null, reservationCount?: number | null, signedCount?: number | null, totalCount?: number | null, totalConvertedAmount?: number | null, droppedRate: { __typename?: 'LeadDropRateOutput', rate?: number | null, totalDropLead?: number | null } } };

export type GetSalesAnalysisCountQueryVariables = Exact<{
  selectedDate: Scalars['DateTime'];
}>;


export type GetSalesAnalysisCountQuery = { __typename?: 'Query', getSalesAnalysisCount?: { __typename?: 'SalesAnalysisOutput', dailyBook: Array<{ __typename?: 'dailyBookChartCountOutput', daily_date: any, bookedCount: number, cancelBookCount: number, cumulativeCount: number }>, dailySign: Array<{ __typename?: 'dailySignChartCountOutput', daily_date: any, signedCount: number, cancelSignCount: number, cumulativeCount: number }>, weeklyBook: Array<{ __typename?: 'weeklyBookChartCountOutput', start_week?: string | null, end_week?: string | null, start_week_alt: any, bookedCount: number, cancelBookCount: number, cumulativeCount: number }>, weeklySign: Array<{ __typename?: 'weeklySignChartCountOutput', start_week?: string | null, end_week?: string | null, start_week_alt: any, signedCount: number, cancelSignCount: number, cumulativeCount: number }>, monthlyBook: Array<{ __typename?: 'monthlyBookChartCountOutput', months?: string | null, months_alt: number, bookedCount: number, cancelBookCount: number, cumulativeCount: number }>, monthlySign: Array<{ __typename?: 'monthlySignChartCountOutput', months?: string | null, months_alt: number, signedCount: number, cancelSignCount: number, cumulativeCount: number }> } | null };

export type GetDailySalesAnalysisCountQueryVariables = Exact<{
  selectedDate: Scalars['DateTime'];
  salesType: Scalars['String'];
}>;


export type GetDailySalesAnalysisCountQuery = { __typename?: 'Query', getDailySalesAnalysisCount?: Array<{ __typename?: 'dailyChartCount', dailyDate: any, dailyCount: number, cumulativeCount: number }> | null };

export type GetWeeklySalesAnalysisCountQueryVariables = Exact<{
  selectedDate: Scalars['DateTime'];
  salesType: Scalars['String'];
}>;


export type GetWeeklySalesAnalysisCountQuery = { __typename?: 'Query', getWeeklySalesAnalysisCount?: Array<{ __typename?: 'weeklyChartCount', startWeek?: any | null, endWeek?: any | null, weeklyCount: number, cumulativeCount: number }> | null };

export type GetMonthlySalesAnalysisCountQueryVariables = Exact<{
  selectedDate: Scalars['DateTime'];
  salesType: Scalars['String'];
}>;


export type GetMonthlySalesAnalysisCountQuery = { __typename?: 'Query', getMonthlySalesAnalysisCount?: Array<{ __typename?: 'monthlyChartCount', monthlyDate: any, monthlyCount: number, cumulativeCount: number }> | null };

export type GetUnitTypeSaByUnitTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnitTypeSaByUnitTypeQuery = { __typename?: 'Query', getUnitTypeSAByUnitType?: Array<{ __typename?: 'UnitTypeCountByStatusOutput', unitType: string, totalUnitCount: number, availableUnitCount: number, signUnitCount: number, soldUnitCount: number, bookUnitCount: number, unavailableUnitCount: number, reservationUnitCount?: number | null }> | null };

export type WaitingListUnitSaByUnitTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type WaitingListUnitSaByUnitTypeQuery = { __typename?: 'Query', waitingListUnitSAByUnitType?: Array<{ __typename?: 'WaitingListByUnitTypeOutput', unit_type: string, totalCount?: number | null, WaitingListByUnitType?: Array<{ __typename?: 'WaitingListByUnitType', unit_layout_id: string, unit_type_id: string, unit_layout: string, unit_type: string, count: number }> | null }> | null };

export type GetSalesRaceBiQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSalesRaceBiQuery = { __typename?: 'Query', getSalesRaceBI: Array<{ __typename?: 'PurchaserDemographicBIOutput', id?: string | null, name: string, value?: number | null }> };

export type GetSalesAgeBiQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSalesAgeBiQuery = { __typename?: 'Query', getSalesAgeBI: Array<{ __typename?: 'PurchaserDemographicBIOutput', id?: string | null, name: string, value?: number | null }> };

export type GetSalesPurchaserIncomeRangeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSalesPurchaserIncomeRangeQuery = { __typename?: 'Query', getSalesPurchaserIncomeRange: Array<{ __typename?: 'PurchaserDemographicBIOutput', id?: string | null, name: string, value?: number | null }> };

export type GetSalesJointBuyerIncomeRangeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSalesJointBuyerIncomeRangeQuery = { __typename?: 'Query', getSalesJointBuyerIncomeRange: Array<{ __typename?: 'PurchaserDemographicBIOutput', id?: string | null, name: string, value?: number | null }> };

export type GetSalesMovementQueryVariables = Exact<{
  selectedDate: Scalars['DateTime'];
}>;


export type GetSalesMovementQuery = { __typename?: 'Query', getSalesMovementData: { __typename?: 'SalesStatisticMovement', currency: string, dailyMovement: Array<{ __typename: 'SalesStatisticDailyMovement', bookedTotalSellingPrice: number, bookedCount: number, reserveTotalSellingPrice: number, reserveCount: number, signedTotalSellingPrice: number, signedCount: number, cancelledTotalSellingPrice: number, cancelledCount: number, sale_origin?: string | null, daily_date: any }>, weeklyMovement: Array<{ __typename: 'SalesStatisticWeeklyMovement', bookedTotalSellingPrice: number, bookedCount: number, reserveTotalSellingPrice: number, reserveCount: number, signedTotalSellingPrice: number, signedCount: number, cancelledTotalSellingPrice: number, cancelledCount: number, sale_origin?: string | null, start_week?: string | null, end_week?: string | null, start_week_alt: any }>, monthlyMovement: Array<{ __typename: 'SalesStatisticMonthlyMovement', bookedTotalSellingPrice: number, bookedCount: number, reserveTotalSellingPrice: number, reserveCount: number, signedTotalSellingPrice: number, signedCount: number, cancelledTotalSellingPrice: number, cancelledCount: number, sale_origin?: string | null, months?: string | null, months_alt: number }> } };

export type GetTeamBiQueryVariables = Exact<{
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
}>;


export type GetTeamBiQuery = { __typename?: 'Query', getTeamBI: { __typename?: 'SaleTeamPerformanceOutput', team?: Array<{ __typename?: 'PerformanceByInternalAndAgency', teamId: string, teamName: string, totalTeamCount?: number | null, totalTeamPrice?: number | null, staff?: Array<{ __typename?: 'SalesPersonSalesAvgOutput', signedCount?: number | null, bookCount?: number | null, reserveCount?: number | null, cancelCount?: number | null, sumSpaPrice?: number | null, sumBookAmt?: number | null, sumReserveAmt?: number | null, sumCancelAmt?: number | null, salesPersonName?: string | null }> | null }> | null, agency?: Array<{ __typename?: 'PerformanceByInternalAndAgency', teamId: string, agencyName?: string | null, totalTeamCount?: number | null, totalTeamPrice?: number | null, staff?: Array<{ __typename?: 'SalesPersonSalesAvgOutput', signedCount?: number | null, bookCount?: number | null, reserveCount?: number | null, cancelCount?: number | null, sumSpaPrice?: number | null, sumBookAmt?: number | null, sumReserveAmt?: number | null, sumCancelAmt?: number | null, salesPersonName?: string | null }> | null }> | null } };

export type GetSalesTeamBiQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSalesTeamBiQuery = { __typename?: 'Query', getSalesTeamBI?: { __typename?: 'SaleTeamPerformanceOutput', team?: Array<{ __typename?: 'PerformanceByInternalAndAgency', teamId: string, teamName: string, totalTeamCount?: number | null, totalTeamPrice?: number | null, staff?: Array<{ __typename?: 'SalesPersonSalesAvgOutput', signedCount?: number | null, bookCount?: number | null, reserveCount?: number | null, cancelCount?: number | null, sumSpaPrice?: number | null, sumBookAmt?: number | null, sumReserveAmt?: number | null, sumCancelAmt?: number | null, salesPersonName?: string | null }> | null }> | null } | null };

export type GetPaymentMethodDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPaymentMethodDataQuery = { __typename?: 'Query', getPaymentMethodData: { __typename?: 'PaymentMethodBIOutput', totalCount?: number | null, totalAmount?: number | null, cashCount?: number | null, cashAmount?: number | null, chequeCount?: number | null, chequeAmount?: number | null, creditCardCount?: number | null, creditCardAmount?: number | null, onlinePaymentCount?: number | null, onlinePaymentAmount?: number | null, onlineTransferCount?: number | null, onlineTransferAmount?: number | null } };

export type WaitingListUnitTypeBiQueryVariables = Exact<{ [key: string]: never; }>;


export type WaitingListUnitTypeBiQuery = { __typename?: 'Query', waitingListUnitTypeBI?: Array<{ __typename?: 'WaitingListByUnitTypeOutput', unit_type: string, totalCount?: number | null, WaitingListByUnitType?: Array<{ __typename?: 'WaitingListByUnitType', unit_layout_id: string, unit_type_id: string, unit_layout: string, unit_type: string, count: number }> | null }> | null };

export type WaitingListCountBiQueryVariables = Exact<{ [key: string]: never; }>;


export type WaitingListCountBiQuery = { __typename?: 'Query', waitingListCountBI: { __typename?: 'WaitingListBICount', total_waiting: number, converted: number, cancelled: number } };

export type LoanAcceptanceRateQueryVariables = Exact<{ [key: string]: never; }>;


export type LoanAcceptanceRateQuery = { __typename?: 'Query', loanAcceptanceRate?: Array<{ __typename?: 'LoanAcceptanceRateOutput', accepted: number, name: string, pending: number, rejected: number, total: number }> | null };

export type EndFinancingLimitStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type EndFinancingLimitStatusQuery = { __typename?: 'Query', endFinancingLimitStatus?: Array<{ __typename?: 'EndFinancingLimitStatusOutput', approvalAmount: number, financialLimit: number, name: string }> | null };

export type GetLotStatusMovementDataQueryVariables = Exact<{
  unitTypeId?: InputMaybe<Scalars['String']>;
  propertyTypeId?: InputMaybe<Scalars['String']>;
}>;


export type GetLotStatusMovementDataQuery = { __typename?: 'Query', getLotStatusMovementData: { __typename?: 'LotStatusMovement', weeklyMovement: Array<{ __typename?: 'LotStatusData', transactionDate?: any | null, cancelledCount?: number | null, bookedCount?: number | null, soldCount?: number | null }>, monthlyMovement: Array<{ __typename?: 'LotStatusData', transactionDate?: any | null, cancelledCount?: number | null, bookedCount?: number | null, soldCount?: number | null }> } };

export type GetUnitTypeListQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetUnitTypeListQuery = { __typename?: 'Query', getUnitTypeList: Array<{ __typename?: 'unitTypeEntity', id: string, name: string }> };

export type GetPropertyTypeListQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetPropertyTypeListQuery = { __typename?: 'Query', getPropertyTypeList: Array<{ __typename?: 'propertyTypeEntity', id: string, name: string }> };

export type GetSalesPerformanceStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSalesPerformanceStatusQuery = { __typename?: 'Query', getSalesPerformanceStatus: Array<{ __typename?: 'ReportingStatus', code: string, desc: string }> };

export type GetUnitTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnitTypeQuery = { __typename?: 'Query', getUnitType: Array<{ __typename?: 'UnitTypeDetail', unitTypeId: string, name: string }> };

export type GetSalesTeamStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSalesTeamStatusQuery = { __typename?: 'Query', getSalesTeamStatus: Array<{ __typename?: 'ReportingStatus', code: string, desc: string }> };

export type GetLeadStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLeadStatusQuery = { __typename?: 'Query', getLeadStatus: Array<{ __typename?: 'ReportingStatus', code: string, desc: string }> };

export type GetSalesTeamQueryVariables = Exact<{
  status: Scalars['String'];
}>;


export type GetSalesTeamQuery = { __typename?: 'Query', getSalesTeam: Array<{ __typename?: 'TeamDetail', teamId: string, name: string }> };

export type GetLoanAndFinancierQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLoanAndFinancierQuery = { __typename?: 'Query', getProjectLoanFinancier: Array<{ __typename?: 'LoanFinancierDetail', financierId: string, name: string }>, getLoanStatus: Array<{ __typename?: 'ReportingStatus', code: string, desc: string }> };

export type ExportSalesPerformanceQueryVariables = Exact<{
  status: Scalars['String'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
}>;


export type ExportSalesPerformanceQuery = { __typename?: 'Query', exportSalesPerformance: { __typename?: 'ReportingExcelOutput', base64: string, projectName: string } };

export type ExportLotStatusMovementQueryVariables = Exact<{
  status: Scalars['String'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
}>;


export type ExportLotStatusMovementQuery = { __typename?: 'Query', exportLotStatusMovement: { __typename?: 'ReportingExcelOutput', base64: string, projectName: string } };

export type ExportSalesMovementQueryVariables = Exact<{
  status: Scalars['String'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
}>;


export type ExportSalesMovementQuery = { __typename?: 'Query', exportSalesMovement: { __typename?: 'ReportingExcelOutput', base64: string, projectName: string } };

export type ExportSalesAnalysisQueryVariables = Exact<{
  status: Scalars['String'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
}>;


export type ExportSalesAnalysisQuery = { __typename?: 'Query', exportSalesAnalysis: { __typename?: 'ReportingExcelOutput', base64: string, projectName: string } };

export type ExportSalesAnalysisByUnitQueryVariables = Exact<{
  status: Scalars['String'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
}>;


export type ExportSalesAnalysisByUnitQuery = { __typename?: 'Query', exportSalesAnalysisByUnit: { __typename?: 'ReportingExcelOutput', base64: string, projectName: string } };

export type ExportSalesDemographicAnalysisQueryVariables = Exact<{
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
}>;


export type ExportSalesDemographicAnalysisQuery = { __typename?: 'Query', exportSalesDemographicAnalysis: { __typename?: 'ReportingExcelOutput', base64: string, projectName: string } };

export type ExportWaitListByUnitTypeQueryVariables = Exact<{
  unitType: Scalars['String'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
}>;


export type ExportWaitListByUnitTypeQuery = { __typename?: 'Query', exportWaitListByUnitType: { __typename?: 'ReportingExcelOutput', base64: string, projectName: string } };

export type ExportCampaignPerformanceQueryVariables = Exact<{
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
}>;


export type ExportCampaignPerformanceQuery = { __typename?: 'Query', exportCampaignPerformance: { __typename?: 'ReportingExcelOutput', base64: string, projectName: string } };

export type ExportTeamPerformanceQueryVariables = Exact<{
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
}>;


export type ExportTeamPerformanceQuery = { __typename?: 'Query', exportTeamPerformance: { __typename?: 'ReportingExcelOutput', base64: string, projectName: string } };

export type ExportSalesLeadPerformanceQueryVariables = Exact<{
  status: Scalars['String'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
}>;


export type ExportSalesLeadPerformanceQuery = { __typename?: 'Query', exportSalesLeadPerformance: { __typename?: 'ReportingExcelOutput', base64: string, projectName: string } };

export type ExportTrackingOfPaymentMethodQueryVariables = Exact<{
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
}>;


export type ExportTrackingOfPaymentMethodQuery = { __typename?: 'Query', exportTrackingOfPaymentMethod: { __typename?: 'ReportingExcelOutput', base64: string, projectName: string } };

export type ExportBookingListAnalysisQueryVariables = Exact<{
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
}>;


export type ExportBookingListAnalysisQuery = { __typename?: 'Query', exportBookingListAnalysis: { __typename?: 'ReportingExcelOutput', base64: string, projectName: string } };

export type ExportLoanAndFinancingQueryVariables = Exact<{
  financier: Scalars['String'];
  status: Scalars['String'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
}>;


export type ExportLoanAndFinancingQuery = { __typename?: 'Query', exportLoanAndFinancing: { __typename?: 'ReportingExcelOutput', base64: string, projectName: string } };

export type ExportOutstandingSpQueryVariables = Exact<{
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
}>;


export type ExportOutstandingSpQuery = { __typename?: 'Query', exportOutstandingSP: { __typename?: 'ReportingExcelOutput', base64: string, projectName: string } };

export type GetAllProjectTitleQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllProjectTitleQuery = { __typename?: 'Query', getAllProjectTitle: Array<{ __typename?: 'projectTitleEntity', id: string, projectId: string, accountId: string, titleType: string, titleNo: string, issueDate: any, receiveDate: any, expiryDate: any, remark?: string | null, unitIndex?: string | null, projectTitleUnits: Array<{ __typename?: 'projectTitleUnitEntity', unitId: string, units: { __typename?: 'unitEntity', unitNo: string } }> }> };

export type GetProjectTitleByIdQueryVariables = Exact<{
  projectId: Scalars['String'];
  id: Scalars['String'];
}>;


export type GetProjectTitleByIdQuery = { __typename?: 'Query', getProjectTitleById: { __typename?: 'projectTitleEntity', id: string, projectId: string, accountId: string, titleType: string, titleNo: string, issueDate: any, receiveDate: any, expiryDate: any, remark?: string | null, projectTitleUnits: Array<{ __typename?: 'projectTitleUnitEntity', unitId: string }> } };

export type GetUnitPropertyTitleCreateQueryVariables = Exact<{
  projectId: Scalars['String'];
  propertyTitleId?: InputMaybe<Scalars['String']>;
}>;


export type GetUnitPropertyTitleCreateQuery = { __typename?: 'Query', getUnitPropertyTitleCreate: Array<{ __typename?: 'projectTitleBlockListingOutput', block: string, totalFloor: number, floorList?: Array<{ __typename?: 'projectTitleFloorListingOutput', floorLabel?: string | null, totalUnit?: number | null, unitList?: Array<{ __typename?: 'projectTitleUnitListingOutput', unitId?: string | null, unitNo?: string | null }> | null }> | null }> };

export type GetFloorByProjectBlockQueryVariables = Exact<{
  Block: Scalars['String'];
  ProjectId: Scalars['String'];
}>;


export type GetFloorByProjectBlockQuery = { __typename?: 'Query', GetFloorByProjectBlock: Array<{ __typename?: 'FloorOutput', projectid: string, block: string, floor: number, floorlabel: string, Unit?: Array<{ __typename?: 'unitEntity', projectId: string, unitNo: string, id: string, phase?: string | null, builtUp: number, price: number, cell: number, unitTypeId?: string | null, unitLayoutId?: string | null, block?: string | null, floorLabel?: string | null, floor?: number | null, unitStatus: string, unitLockBy?: string | null }> | null }> };

export type AddProjectTitleMutationVariables = Exact<{
  input: AddProjectTitleInput;
}>;


export type AddProjectTitleMutation = { __typename?: 'Mutation', addProjectTitle: boolean };

export type EditProjectTitleMutationVariables = Exact<{
  input: EditProjectTitleInput;
}>;


export type EditProjectTitleMutation = { __typename?: 'Mutation', editProjectTitle: boolean };

export type DeleteProjectTitleMutationVariables = Exact<{
  projectTitleId: Scalars['String'];
}>;


export type DeleteProjectTitleMutation = { __typename?: 'Mutation', deleteProjectTitle: boolean };

export type GetPropertyTitleTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPropertyTitleTypeQuery = { __typename?: 'Query', getPropertyTitleType: any };

export type GetCollectionActivityDetailByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCollectionActivityDetailByIdQuery = { __typename?: 'Query', getCollectionActivityDetailByID: { __typename?: 'collectionActivityEntity', activityDate: any, activityRemark: string, activityStatus: string, attachment?: Array<{ __typename?: 'attachmentEntity', allowDelete?: boolean | null, fileName: string, id: string, isPrivate: boolean, mediaType: string, resourceUrl: string }> | null } };

export type GetCollectionActivityListingQueryVariables = Exact<{
  saleId: Scalars['String'];
}>;


export type GetCollectionActivityListingQuery = { __typename?: 'Query', getCollectionActivityListing: Array<{ __typename?: 'collectionActivityEntity', id: string, accountId: string, saleId: string, activityDate: any, activityRemark: string, completedDate: any, activityStatus: string, commonStatus: string, attachment?: Array<{ __typename?: 'attachmentEntity', allowDelete?: boolean | null, fileName: string, id: string, isPrivate: boolean, mediaType: string, resourceUrl: string }> | null }> };

export type GetCollectionActivitySummaryQueryVariables = Exact<{
  saleId: Scalars['String'];
}>;


export type GetCollectionActivitySummaryQuery = { __typename?: 'Query', getCollectionActivitySummary: { __typename?: 'collectionActivityOutput', totalOutstanding: number, purchaserDetail: { __typename?: 'PurchaserAccDetail', email?: string | null, purchaserName: string, unitNo: string, phoneNo: string, isCompany?: boolean | null, companyName?: string | null, officeTel?: string | null } } };

export type AddPaCollectionActivityMutationVariables = Exact<{
  input: AddPaCollectionActivityListingInput;
}>;


export type AddPaCollectionActivityMutation = { __typename?: 'Mutation', addPACollectionActivity: boolean };

export type EditPaCollectionActivityMutationVariables = Exact<{
  input: EditPaCollectionActivityInput;
}>;


export type EditPaCollectionActivityMutation = { __typename?: 'Mutation', editPACollectionActivity: boolean };

export type UpdatePaCollectionActivityMutationVariables = Exact<{
  input: UpdatePaCollectionActivityInput;
}>;


export type UpdatePaCollectionActivityMutation = { __typename?: 'Mutation', updatePACollectionActivity: boolean };

export type GetPAcontraListQueryVariables = Exact<{
  saleId: Scalars['String'];
  status: Scalars['String'];
}>;


export type GetPAcontraListQuery = { __typename?: 'Query', getPAcontraList: Array<{ __typename?: 'contraEntity', allowReversal: boolean, id: string, documentDate: any, documentAmount: number, documentNo?: string | null, requestedBy?: string | null, description: string, approvedDate?: any | null, approvedBy?: string | null, status: string, unallocatedAmount?: number | null, submittedBy?: string | null, submittedDate?: any | null, attachment?: Array<{ __typename?: 'attachmentEntity', id: string, fileName: string, allowDelete?: boolean | null, isPrivate: boolean, mediaType: string, resourceUrl: string }> | null, requestUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, submitUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, approveUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, taxData?: { __typename?: 'TaxSchemeDropdownOutput', taxSchemeId: string, taxSchemeName: string, effectiveDate: any, taxSchemeDetailId: string, totalTaxRate?: string | null, totalTaxAmount: number } | null }> };

export type GetPaContraSubmittedListQueryVariables = Exact<{
  saleId: Scalars['String'];
}>;


export type GetPaContraSubmittedListQuery = { __typename?: 'Query', getPAContraSubmittedList: Array<{ __typename?: 'PALedgerSubmmitedListingOutput', id: string, documentAmount: number, documentDate: any, description: string, approvalRoleId?: string | null, submittedDate: any, unallocatedAmount?: number | null, attachment?: Array<{ __typename?: 'attachmentEntity', id: string, fileName: string, allowDelete?: boolean | null, isPrivate: boolean, mediaType: string, resourceUrl: string }> | null, billItem?: { __typename?: 'billItemEntity', billItemType: string, id: string, name: string } | null, requestUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, submitUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, approveUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, taxData?: { __typename?: 'TaxSchemeDropdownOutput', taxSchemeId: string, taxSchemeName: string, effectiveDate: any, taxSchemeDetailId: string, totalTaxRate?: string | null, totalTaxAmount: number } | null, billingDetailTaxData?: { __typename?: 'BillingDetailTaxData', taxSchemeName?: string | null, totalTaxRate?: string | null, totalTaxAmount?: string | null } | null }> };

export type GetPAcontraByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPAcontraByIdQuery = { __typename?: 'Query', getPAcontraById: { __typename?: 'contraEntity', allowReversal: boolean, approvedBy?: string | null, approvedDate?: any | null, billItemId: string, description: string, documentAmount: number, documentDate: any, documentNo?: string | null, documentRef?: string | null, id: string, requestedBy?: string | null, status: string, submittedBy?: string | null, submittedDate?: any | null, unallocatedAmount?: number | null, voidDate?: any | null, allocation?: Array<{ __typename?: 'allocationEntity', allocateAmount: number }> | null, attachment?: Array<{ __typename?: 'attachmentEntity', id: string, fileName: string, allowDelete?: boolean | null, isPrivate: boolean, mediaType: string, resourceUrl: string }> | null, billItem?: { __typename?: 'billItemEntity', id: string, name: string, billItemType: string } | null, requestUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, submitUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, approveUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, taxData?: { __typename?: 'TaxSchemeDropdownOutput', taxSchemeId: string, taxSchemeName: string, effectiveDate: any, taxSchemeDetailId: string, totalTaxRate?: string | null, totalTaxAmount: number, isExclusive: boolean } | null, projectDetail?: { __typename?: 'projectEntity', name: string } | null, voidUserData?: { __typename?: 'UserEntity', name?: string | null } | null } };

export type GetPAcontraSummaryQueryVariables = Exact<{
  projectId: Scalars['String'];
  saleId: Scalars['String'];
}>;


export type GetPAcontraSummaryQuery = { __typename?: 'Query', getPAcontraSummary?: { __typename?: 'PAmoduleSummary', totalCharges?: number | null, totalUnallocated?: number | null, totalDraft?: number | null, totalSubmitted?: number | null } | null };

export type AddPAcontraMutationVariables = Exact<{
  isSubmitted: Scalars['Boolean'];
  input: AddPAmoduleDataInput;
}>;


export type AddPAcontraMutation = { __typename?: 'Mutation', addPAcontra: boolean };

export type EditPAcontraMutationVariables = Exact<{
  isSubmitted: Scalars['Boolean'];
  input: EditPAmoduleDataInput;
}>;


export type EditPAcontraMutation = { __typename?: 'Mutation', editPAcontra: boolean };

export type GetPAcreditNoteListQueryVariables = Exact<{
  saleId: Scalars['String'];
  status: Scalars['String'];
}>;


export type GetPAcreditNoteListQuery = { __typename?: 'Query', getPAcreditNoteList: Array<{ __typename?: 'creditNoteEntity', allowReversal: boolean, approvedBy?: string | null, approvedDate?: any | null, description?: string | null, documentAmount: number, documentDate: any, documentNo?: string | null, id: string, requestedBy?: string | null, status: string, submittedBy?: string | null, submittedDate?: any | null, unallocatedAmount?: number | null, voidDate?: any | null, attachment?: Array<{ __typename?: 'attachmentEntity', id: string, fileName: string, allowDelete?: boolean | null, isPrivate: boolean, mediaType: string, resourceUrl: string }> | null, billItem?: { __typename?: 'billItemEntity', billItemType: string, id: string, name: string } | null, requestUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, submitUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, approveUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, taxData?: { __typename?: 'TaxSchemeDropdownOutput', taxSchemeId: string, taxSchemeName: string, effectiveDate: any, taxSchemeDetailId: string, totalTaxRate?: string | null, totalTaxAmount: number } | null }> };

export type GetPaCreditNoteSubmittedListQueryVariables = Exact<{
  saleId: Scalars['String'];
}>;


export type GetPaCreditNoteSubmittedListQuery = { __typename?: 'Query', getPACreditNoteSubmittedList: Array<{ __typename?: 'PALedgerSubmmitedListingOutput', id: string, documentAmount: number, documentDate: any, description: string, approvalRoleId?: string | null, submittedDate: any, unallocatedAmount?: number | null, attachment?: Array<{ __typename?: 'attachmentEntity', id: string, fileName: string, allowDelete?: boolean | null, isPrivate: boolean, mediaType: string, resourceUrl: string }> | null, billItem?: { __typename?: 'billItemEntity', billItemType: string, id: string, name: string } | null, requestUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, submitUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, approveUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, taxData?: { __typename?: 'TaxSchemeDropdownOutput', taxSchemeId: string, taxSchemeName: string, effectiveDate: any, taxSchemeDetailId: string, totalTaxRate?: string | null, totalTaxAmount: number } | null, billingDetailTaxData?: { __typename?: 'BillingDetailTaxData', taxSchemeName?: string | null, totalTaxRate?: string | null, totalTaxAmount?: string | null } | null }> };

export type GetPAcreditNoteSummaryQueryVariables = Exact<{
  projectId: Scalars['String'];
  saleId: Scalars['String'];
}>;


export type GetPAcreditNoteSummaryQuery = { __typename?: 'Query', getPAcreditNoteSummary?: { __typename?: 'PAmoduleSummary', totalCharges?: number | null, totalUnallocated?: number | null, totalDraft?: number | null, totalSubmitted?: number | null } | null };

export type GetPAcreditNoteByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPAcreditNoteByIdQuery = { __typename?: 'Query', getPAcreditNoteById: { __typename?: 'creditNoteEntity', allowReversal: boolean, approvedBy?: string | null, approvedDate?: any | null, billItemId?: string | null, description?: string | null, documentAmount: number, documentDate: any, documentNo?: string | null, documentRef?: string | null, isReversal: boolean, requestedBy?: string | null, status: string, submittedBy?: string | null, submittedDate?: any | null, unallocatedAmount?: number | null, voidBy?: string | null, voidDate?: any | null, attachment?: Array<{ __typename?: 'attachmentEntity', id: string, fileName: string, allowDelete?: boolean | null, isPrivate: boolean, mediaType: string, resourceUrl: string }> | null, billItem?: { __typename?: 'billItemEntity', id: string, name: string, billItemType: string } | null, requestUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, submitUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, approveUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, voidUserData?: { __typename?: 'UserEntity', name?: string | null } | null, taxData?: { __typename?: 'TaxSchemeDropdownOutput', taxSchemeId: string, taxSchemeName: string, effectiveDate: any, taxSchemeDetailId: string, totalTaxRate?: string | null, totalTaxAmount: number, isExclusive: boolean } | null, projectDetail?: { __typename?: 'projectEntity', name: string } | null } };

export type AddPAcreditNoteMutationVariables = Exact<{
  isSubmitted: Scalars['Boolean'];
  input: AddPAmoduleDataInput;
}>;


export type AddPAcreditNoteMutation = { __typename?: 'Mutation', addPAcreditNote: boolean };

export type EditPAcreditNoteMutationVariables = Exact<{
  isSubmitted: Scalars['Boolean'];
  input: EditPAmoduleDataInput;
}>;


export type EditPAcreditNoteMutation = { __typename?: 'Mutation', editPAcreditNote: boolean };

export type GetPAdebitNoteListQueryVariables = Exact<{
  saleId: Scalars['String'];
  status: Scalars['String'];
}>;


export type GetPAdebitNoteListQuery = { __typename?: 'Query', getPAdebitNoteList: Array<{ __typename?: 'debitNoteEntity', allowReversal: boolean, approvedBy?: string | null, approvedDate?: any | null, billItemId?: string | null, creditTerm: number, description?: string | null, documentAmount: number, documentDate: any, documentNo?: string | null, dueDate: any, id: string, interestRate: number, isReversal: boolean, requestedBy?: string | null, status: string, submittedBy?: string | null, submittedDate?: any | null, unallocatedAmount?: number | null, unitDetail?: string | null, contactDetail?: string | null, attachment?: Array<{ __typename?: 'attachmentEntity', allowDelete?: boolean | null, fileName: string, id: string, isPrivate: boolean, mediaType: string, resourceUrl: string }> | null, billItem?: { __typename?: 'billItemEntity', billItemType: string, id: string, name: string } | null, billItemInt?: { __typename?: 'billItemIntEntity', billItemType: string, id: string, name: string } | null, requestUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, submitUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, approveUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, taxData?: { __typename?: 'TaxSchemeDropdownOutput', taxSchemeId: string, taxSchemeName: string, effectiveDate: any, taxSchemeDetailId: string, totalTaxRate?: string | null, totalTaxAmount: number } | null }> };

export type GetPAdebitNoteSummaryQueryVariables = Exact<{
  projectId: Scalars['String'];
  saleId: Scalars['String'];
}>;


export type GetPAdebitNoteSummaryQuery = { __typename?: 'Query', getPAdebitNoteSummary?: { __typename?: 'PAmoduleSummary', totalCharges?: number | null, totalUnallocated?: number | null, totalDraft?: number | null, totalSubmitted?: number | null } | null };

export type GetPAdebitNoteByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPAdebitNoteByIdQuery = { __typename?: 'Query', getPAdebitNoteById: { __typename?: 'debitNoteEntity', approvedBy?: string | null, approvedDate?: any | null, billItemId?: string | null, description?: string | null, documentAmount: number, documentDate: any, documentNo?: string | null, dueDate: any, isIncludeHoliday: boolean, requestedBy?: string | null, status: string, submittedBy?: string | null, submittedDate?: any | null, unallocatedAmount?: number | null, voidDate?: any | null, creditTerm: number, interestRate: number, attachment?: Array<{ __typename?: 'attachmentEntity', allowDelete?: boolean | null, fileName: string, id: string, isPrivate: boolean, mediaType: string, resourceUrl: string }> | null, billItem?: { __typename?: 'billItemEntity', billItemType: string, id: string, name: string } | null, requestUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, submitUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, approveUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, voidUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, taxData?: { __typename?: 'TaxSchemeDropdownOutput', taxSchemeId: string, taxSchemeName: string, effectiveDate: any, taxSchemeDetailId: string, totalTaxRate?: string | null, totalTaxAmount: number, isExclusive: boolean } | null, projectDetail?: { __typename?: 'projectEntity', name: string } | null } };

export type AddPAdebitNoteMutationVariables = Exact<{
  isSubmitted: Scalars['Boolean'];
  input: AddPAdebitNoteInput;
}>;


export type AddPAdebitNoteMutation = { __typename?: 'Mutation', addPAdebitNote: boolean };

export type EditPAdebitNoteMutationVariables = Exact<{
  isSubmitted: Scalars['Boolean'];
  input: EditPAdebitNoteInput;
}>;


export type EditPAdebitNoteMutation = { __typename?: 'Mutation', editPAdebitNote: boolean };

export type GetPAlateInterestListQueryVariables = Exact<{
  saleId: Scalars['String'];
}>;


export type GetPAlateInterestListQuery = { __typename?: 'Query', getPAlateInterestList: Array<{ __typename?: 'lateInterestDetailEntity', id: string, documentDate?: any | null, documentAmount: number, description: string, status: string, dueDate?: any | null, documentNo?: string | null, creditTerm?: number | null, submittedDate?: any | null, submittedBy?: string | null, unallocatedAmount?: number | null, interestAmount: number }> };

export type GetPAlateInterestByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPAlateInterestByIdQuery = { __typename?: 'Query', getPAlateInterestById: { __typename?: 'lateInterestDetailEntity', documentNo?: string | null, documentDate?: any | null, dueDate?: any | null, creditTerm?: number | null, description: string, documentAmount: number, submittedDate?: any | null, submittedBy?: string | null, approvedDate?: any | null, approvedBy?: string | null, unallocatedAmount?: number | null, documentRef?: string | null, submitUserData?: { __typename?: 'UserEntity', name?: string | null } | null, approveUserData?: { __typename?: 'UserEntity', name?: string | null } | null, voidUserData?: { __typename?: 'UserEntity', name?: string | null } | null, taxData?: { __typename?: 'TaxSchemeDropdownOutput', taxSchemeId: string, taxSchemeName: string, effectiveDate: any, taxSchemeDetailId: string, totalTaxRate?: string | null, totalTaxAmount: number } | null, projectDetail?: { __typename?: 'UserEntity', name?: string | null } | null } };

export type GetPAlateInterestSummaryQueryVariables = Exact<{
  saleId: Scalars['String'];
}>;


export type GetPAlateInterestSummaryQuery = { __typename?: 'Query', getPAlateInterestSummary?: { __typename?: 'PAmoduleSummary', totalCharges?: number | null, totalUnallocated?: number | null, totalDraft?: number | null, totalSubmitted?: number | null } | null };

export type GetPAlateInterestStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPAlateInterestStatusQuery = { __typename?: 'Query', getPAlateInterestStatus: { __typename?: 'lateInterestChargesStatus', status: Array<string> } };

export type AddPaLateInterestChargesMutationVariables = Exact<{
  input: AddPaLateInterestInput;
}>;


export type AddPaLateInterestChargesMutation = { __typename?: 'Mutation', addPALateInterestCharges: boolean };

export type GetTempPAlateInterestListQueryVariables = Exact<{
  saleId: Scalars['String'];
  temporary: Scalars['Boolean'];
  generateDate: Scalars['DateTime'];
}>;


export type GetTempPAlateInterestListQuery = { __typename?: 'Query', getTempPAlateInterestList: Array<{ __typename?: 'lateInterestList', refTable: string, refId: string, overdueDay: number, documentRef: string, description: string, interestStartDate: any, documentDate: any, documentAmount: number, interestEndDate: any, dueDate?: any | null, status: string, creditTerm?: number | null, billItemId: string, generationBatchDate: any, generationBatch: string, isIncludeHoliday: boolean, calculateAmt: number, calculateRate: number, billDocumentNo: string }> };

export type GetCreditTermsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCreditTermsQuery = { __typename?: 'Query', getCreditTerms?: number | null };

export type GetPAcollectionMasterDataQueryVariables = Exact<{
  saleId: Scalars['String'];
}>;


export type GetPAcollectionMasterDataQuery = { __typename?: 'Query', getPAcollectionMasterData?: { __typename?: 'PAreceiptMasterDateOutput', unitNo?: string | null, financierList?: Array<{ __typename?: 'financierData', financierId: string, financierName: string }> | null, bankList?: Array<{ __typename?: 'companyBankList', bankAccountCode: string, bankAccountId: string, bankAccountNo: string, bankProfileId: string, bankProfileName: string, currency: string, isSelected?: boolean | null }> | null } | null };

export type GetPaymentReminderBySaleIdQueryVariables = Exact<{
  saleId: Scalars['String'];
}>;


export type GetPaymentReminderBySaleIdQuery = { __typename?: 'Query', getPaymentReminderBySaleId: Array<{ __typename?: 'paPaymentReminderListingOutput', unitNo: string, saleId: string, reminderDate: any, generationBatch: string, paymentReminderDetails?: Array<{ __typename?: 'paPaymentReminderDetails', documentNo: string, documentDate: any, dueDate: any, balanceAmount: number, reminderSeq: number }> | null }> };

export type GetMiscBillingTaxQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMiscBillingTaxQuery = { __typename?: 'Query', getMiscBillingTax: Array<{ __typename?: 'miscBillingTaxOutput', taxId: string, code: string, effectiveDate: any, rate: number }> };

export type GetMiscBillingTaxByDocDateQueryVariables = Exact<{
  docDate: Scalars['DateTime'];
}>;


export type GetMiscBillingTaxByDocDateQuery = { __typename?: 'Query', getMiscBillingTaxByDocDate: Array<{ __typename?: 'TaxSchemeDropdownOutput', taxSchemeId: string, taxSchemeName: string, effectiveDate: any, isExclusive: boolean, taxSchemeDetailId: string, totalTaxRate?: string | null, taxSchemeDetailItems?: Array<{ __typename?: 'TaxSchemeDetailItemOutput', taxId: string, taxCode: string, taxRate?: string | null }> | null }> };

export type GetPAmiscBillingListQueryVariables = Exact<{
  saleId: Scalars['String'];
  status: Scalars['String'];
}>;


export type GetPAmiscBillingListQuery = { __typename?: 'Query', getPAmiscBillingList: Array<{ __typename?: 'miscBillingEntity', allowReversal: boolean, approvedBy?: string | null, approvedDate?: any | null, billItemId: string, creditTerm: number, description: string, documentAmount: number, documentDate: any, documentNo?: string | null, dueDate: any, id: string, interestRate?: number | null, requestedBy?: string | null, status: string, submittedBy?: string | null, submittedDate?: any | null, unallocatedAmount?: number | null, attachment?: Array<{ __typename?: 'attachmentEntity', allowDelete?: boolean | null, fileName: string, id: string, isPrivate: boolean, mediaType: string, resourceUrl: string }> | null, billItem?: { __typename?: 'billItemEntity', billItemType: string, id: string, name: string } | null, requestUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, submitUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, approveUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, taxData?: { __typename?: 'TaxSchemeDropdownOutput', taxSchemeId: string, taxSchemeName: string, effectiveDate: any, taxSchemeDetailId: string, totalTaxRate?: string | null, totalTaxAmount: number } | null }> };

export type GetPAmiscBillingByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPAmiscBillingByIdQuery = { __typename?: 'Query', getPAmiscBillingById: { __typename?: 'miscBillingEntity', approvedBy?: string | null, approvedDate?: any | null, billItemId: string, creditTerm: number, description: string, documentAmount: number, documentDate: any, documentNo?: string | null, documentRef?: string | null, dueDate: any, interestRate?: number | null, isIncludeHoliday: boolean, status: string, submittedDate?: any | null, unallocatedAmount?: number | null, voidDate?: any | null, attachment?: Array<{ __typename?: 'attachmentEntity', allowDelete?: boolean | null, fileName: string, id: string, isPrivate: boolean, mediaType: string, resourceUrl: string }> | null, billItem?: { __typename?: 'billItemEntity', billItemType: string, id: string, name: string } | null, requestUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, submitUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, approveUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, voidUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, taxData?: { __typename?: 'TaxSchemeDropdownOutput', taxSchemeId: string, taxSchemeName: string, effectiveDate: any, taxSchemeDetailId: string, totalTaxRate?: string | null, totalTaxAmount: number, isExclusive: boolean } | null, projectDetail?: { __typename?: 'UserEntity', name?: string | null } | null } };

export type AddPAmiscBillingMutationVariables = Exact<{
  isSubmitted: Scalars['Boolean'];
  input: AddPaMiscBillingInput;
}>;


export type AddPAmiscBillingMutation = { __typename?: 'Mutation', addPAmiscBilling: boolean };

export type EditPAmiscBillingMutationVariables = Exact<{
  isSubmitted: Scalars['Boolean'];
  input: EditPaMiscBillingInput;
}>;


export type EditPAmiscBillingMutation = { __typename?: 'Mutation', editPAmiscBilling: boolean };

export type GetPAmiscBillingSummaryQueryVariables = Exact<{
  saleId: Scalars['String'];
}>;


export type GetPAmiscBillingSummaryQuery = { __typename?: 'Query', getPAmiscBillingSummary?: { __typename?: 'PAmoduleSummary', totalCharges?: number | null, totalUnallocated?: number | null, totalDraft?: number | null, totalSubmitted?: number | null } | null };

export type DeletePAmbDataMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeletePAmbDataMutation = { __typename?: 'Mutation', deletePAmbData: boolean };

export type GetSalesContractCreditTermQueryVariables = Exact<{
  saleId: Scalars['String'];
}>;


export type GetSalesContractCreditTermQuery = { __typename?: 'Query', getSalesContractCreditTerm?: { __typename?: 'saleExtensionEntity', creditTerm?: number | null } | null };

export type GetProgressBillingByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetProgressBillingByIdQuery = { __typename?: 'Query', getProgressBillingById?: { __typename?: 'progressBillingEntity', amount?: number | null, creditTerm: number, description: string, documentAmount?: number | null, documentDate?: any | null, documentNo?: string | null, documentRef?: string | null, dueDate?: any | null, gotArchitectCert: boolean, id: string, installmentSeqNo?: number | null, interestRate?: number | null, isFinancialBilling: boolean, isIncludeHoliday: boolean, isStakeholder: boolean, isVpStage: boolean, paymentPlanDetailId: string, principalAmt?: number | null, purchaserAcc?: string | null, stageSeqNo: number, title?: string | null, unallocatedAmount?: number | null, voidDate?: any | null, voidUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, taxData?: { __typename?: 'TaxSchemeDropdownOutput', taxSchemeId: string, taxSchemeName: string, effectiveDate: any, taxSchemeDetailId: string, totalTaxRate?: string | null, totalTaxAmount: number } | null, billingDetailTaxData?: { __typename?: 'BillingDetailTaxData', taxSchemeName?: string | null, totalTaxRate?: string | null, totalTaxAmount?: string | null } | null, projectDetail?: { __typename?: 'projectEntity', name: string } | null, billItem?: { __typename?: 'billItemEntity', billItemType: string, id: string, name: string } | null } | null };

export type ReversalPBdataMutationVariables = Exact<{
  input: PostingProgressBillingInput;
}>;


export type ReversalPBdataMutation = { __typename?: 'Mutation', reversalPBdata: boolean };

export type GetNewPBdataQueryVariables = Exact<{
  saleId: Scalars['String'];
}>;


export type GetNewPBdataQuery = { __typename?: 'Query', getNewPBdata?: { __typename?: 'progress_billing', sale_progress_billing?: Array<{ __typename?: 'sale_progress_billing', isReversal?: boolean | null, stageSeqNo?: number | null, paymentParty?: string | null, addOnPurchase?: string | null, paymentPartyCode?: string | null, addOnPurchaseName?: string | null, paymentPlanDetailTitle?: string | null, totalDocumentAmt?: number | null, totalOutstanding?: number | null, gotAC?: boolean | null, allow_reversal?: boolean | null, system_use?: boolean | null, details?: Array<{ __typename?: 'details', isVp: boolean, documentNo?: string | null, stageSeqNo: number, documentDate?: string | null, paymentParty: string, addOnPurchase?: string | null, isStakeholder: boolean, outstandingAmt: number, creditDocumentNo?: string | null, installmentSeqNo?: number | null, paymentPartyCode?: string | null, addOnPurchaseName?: string | null, progressBillingId?: string | null, calculatedDocumentAmt: number, paymentPlanDetailTitle?: string | null }> | null }> | null, car_park?: Array<{ __typename?: 'car_park', carPark: string, progressBilling: Array<{ __typename?: 'progressBilling', totalDocumentAmt?: number | null, totalOutstanding?: number | null, paymentPlanDetailTitle?: string | null, gotAC: boolean, allow_reversal: boolean, isReversal?: boolean | null, system_use?: boolean | null, details?: Array<{ __typename?: 'details', isVp: boolean, documentNo?: string | null, stageSeqNo: number, documentDate?: string | null, paymentParty: string, addOnPurchase?: string | null, isStakeholder: boolean, outstandingAmt: number, creditDocumentNo?: string | null, installmentSeqNo?: number | null, paymentPartyCode?: string | null, addOnPurchaseName?: string | null, progressBillingId?: string | null, calculatedDocumentAmt: number, paymentPlanDetailTitle?: string | null }> | null }> }> | null, sale_package?: Array<{ __typename?: 'sale_package', salePackage: string, progressBilling: Array<{ __typename?: 'progressBilling', totalDocumentAmt?: number | null, totalOutstanding?: number | null, paymentPlanDetailTitle?: string | null, gotAC: boolean, allow_reversal: boolean, isReversal?: boolean | null, system_use?: boolean | null, details?: Array<{ __typename?: 'details', isVp: boolean, documentNo?: string | null, stageSeqNo: number, documentDate?: string | null, paymentParty: string, addOnPurchase?: string | null, isStakeholder: boolean, outstandingAmt: number, creditDocumentNo?: string | null, installmentSeqNo?: number | null, paymentPartyCode?: string | null, addOnPurchaseName?: string | null, progressBillingId?: string | null, calculatedDocumentAmt: number, paymentPlanDetailTitle?: string | null }> | null }> }> | null } | null };

export type GetPBdataListQueryVariables = Exact<{
  saleId: Scalars['String'];
}>;


export type GetPBdataListQuery = { __typename?: 'Query', getPBdataList?: { __typename?: 'PBdataList', sale_product: Array<{ __typename?: 'addOnRef', titleBar?: string | null, data?: Array<{ __typename?: 'data', id: string, sale_id: string, is_stakeholder: boolean, document_no?: string | null, document_ref?: string | null, description: string, document_date?: any | null, due_date?: any | null, is_installment: boolean, is_vp_stage: boolean, stage_seq_no: number, installment_seq_no?: number | null, title?: string | null, acId?: string | null, isAC: boolean, isReversal: boolean, isBuyer: boolean, creditDocumentNo?: Array<string> | null, sumOrengeAmount: number, sumRedAmount: number, canReversal: boolean, isVoid: boolean, allow_reversal: boolean, fbData?: { __typename?: 'fbData', totalFBamount?: number | null, fbList?: { __typename?: 'fdata', financier_name?: string | null, financier_code?: string | null } | null } | null, installmentData?: Array<{ __typename?: 'PBdata', id: string, creditDocumentNo?: Array<string> | null, document_no?: string | null, isBuyer: boolean, outstandingAmt: number, pbAmount: string, document_date?: any | null }> | null }> | null }>, sale_subproduct?: Array<{ __typename?: 'addOnRef', titleBar?: string | null, data?: Array<{ __typename?: 'data', id: string, sale_id: string, is_stakeholder: boolean, document_no?: string | null, document_ref?: string | null, description: string, document_date?: any | null, due_date?: any | null, is_installment: boolean, is_vp_stage: boolean, stage_seq_no: number, installment_seq_no?: number | null, title?: string | null, acId?: string | null, isAC: boolean, isReversal: boolean, isBuyer: boolean, creditDocumentNo?: Array<string> | null, sumOrengeAmount: number, sumRedAmount: number, canReversal: boolean, isVoid: boolean, allow_reversal: boolean, fbData?: { __typename?: 'fbData', totalFBamount?: number | null, fbList?: { __typename?: 'fdata', financier_name?: string | null, financier_code?: string | null } | null } | null, installmentData?: Array<{ __typename?: 'PBdata', id: string, creditDocumentNo?: Array<string> | null, document_no?: string | null, isBuyer: boolean, outstandingAmt: number, pbAmount: string, document_date?: any | null }> | null }> | null }> | null, sale_package?: Array<{ __typename?: 'addOnRef', titleBar?: string | null, data?: Array<{ __typename?: 'data', id: string, sale_id: string, is_stakeholder: boolean, document_no?: string | null, document_ref?: string | null, description: string, document_date?: any | null, due_date?: any | null, is_installment: boolean, is_vp_stage: boolean, stage_seq_no: number, installment_seq_no?: number | null, title?: string | null, acId?: string | null, isAC: boolean, isReversal: boolean, isBuyer: boolean, creditDocumentNo?: Array<string> | null, sumOrengeAmount: number, sumRedAmount: number, canReversal: boolean, isVoid: boolean, allow_reversal: boolean, fbData?: { __typename?: 'fbData', totalFBamount?: number | null, fbList?: { __typename?: 'fdata', financier_name?: string | null, financier_code?: string | null } | null } | null, installmentData?: Array<{ __typename?: 'PBdata', id: string, creditDocumentNo?: Array<string> | null, document_no?: string | null, isBuyer: boolean, outstandingAmt: number, pbAmount: string, document_date?: any | null }> | null }> | null }> | null } | null };

export type GetPurchaserAccListingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPurchaserAccListingQuery = { __typename?: 'Query', getPurchaserAccListing?: Array<{ __typename?: 'PurchaserAccListing', unitId: string, unitNo: string, purchaserName: string, saleId: string, contactId: string, phoneNo: string, icNo: string, remark?: string | null, date?: any | null, status?: string | null }> | null };

export type GetPurchaserDetailQueryVariables = Exact<{
  saleId: Scalars['String'];
}>;


export type GetPurchaserDetailQuery = { __typename?: 'Query', getPurchaserDetail?: { __typename?: 'PurchaserAccDetail', saleId: string, purchaserName: string, unitNo: string, taxSchemeId: string, phoneNo: string, icNo: string, isCompany?: boolean | null, companyName?: string | null } | null };

export type EditPAmoduleStatusMutationVariables = Exact<{
  tableRef: Scalars['String'];
  isApproved: Scalars['Boolean'];
  sourceIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type EditPAmoduleStatusMutation = { __typename?: 'Mutation', editPAmoduleStatus: boolean };

export type AllocatePAmoduleMutationVariables = Exact<{
  input: AllocatePAmoduleDataInput;
}>;


export type AllocatePAmoduleMutation = { __typename?: 'Mutation', allocatePAmodule: boolean };

export type GetPAsummaryQueryVariables = Exact<{
  saleId: Scalars['String'];
}>;


export type GetPAsummaryQuery = { __typename?: 'Query', getPAsummary?: { __typename?: 'PurchaserAccountSummary', progressBillingSummary: { __typename?: 'PBsummary', totalCharges?: number | null, totalUnallocated?: number | null, pbData?: Array<{ __typename?: 'pbData', has_architect_cert?: boolean | null, has_posted?: boolean | null, stage_seq_no?: number | null }> | null }, purchaserDetail?: { __typename?: 'PurchaserAccDetail', saleId: string, purchaserName: string, unitNo: string, taxSchemeId: string, phoneNo: string, icNo: string, contactId: string } | null, creditNoteSummary: { __typename?: 'PAmoduleSummary', totalCharges?: number | null, totalUnallocated?: number | null, totalDraft?: number | null, totalSubmitted?: number | null }, debitNoteSummary: { __typename?: 'PAmoduleSummary', totalCharges?: number | null, totalUnallocated?: number | null, totalDraft?: number | null, totalSubmitted?: number | null }, rebateSummary: { __typename?: 'PAmoduleSummary', totalCharges?: number | null, totalUnallocated?: number | null, totalDraft?: number | null, totalSubmitted?: number | null }, contraSummary: { __typename?: 'PAmoduleSummary', totalCharges?: number | null, totalUnallocated?: number | null, totalDraft?: number | null, totalSubmitted?: number | null }, miscBillingSummary: { __typename?: 'PAmoduleSummary', totalCharges?: number | null, totalUnallocated?: number | null, totalDraft?: number | null, totalSubmitted?: number | null }, lateInterestSummary: { __typename?: 'PALateInterestSummary', totalCharges?: number | null, totalUnallocated?: number | null, totalDraft?: number | null, totalSubmitted?: number | null }, refundSummary: { __typename?: 'PAmoduleSummary', totalCharges?: number | null, totalUnallocated?: number | null, totalDraft?: number | null, totalSubmitted?: number | null }, collectionSummary: { __typename?: 'PAmoduleSummary', totalCharges?: number | null, totalUnallocated?: number | null, totalDraft?: number | null, totalSubmitted?: number | null }, contactData: { __typename?: 'PAcontactOutput', contactId: string, icNo: string, phoneNo: string, purchaserName: string, companyName?: string | null, companyRegNo?: string | null, isCompany?: boolean | null, officeTel?: string | null }, unitData: { __typename?: 'PAunitOutput', contactId: string, saleId: string, unitId: string, unitNo: string, unitStatus: string }, collectionActivity?: { __typename?: 'collectionActivitySummaryOutput', activityDate: any, activityRemark: string } | null, paymentReminder?: { __typename?: 'paymentReminderSummaryOutput', reminder1: number, reminder2: number, reminder3: number } | null } | null };

export type GetAllBillingBySaleIdQueryVariables = Exact<{
  billItemId?: InputMaybe<Scalars['String']>;
  creditId?: InputMaybe<Scalars['String']>;
  taxSchemeId?: InputMaybe<Scalars['String']>;
  mainTable: Scalars['String'];
  saleId: Scalars['String'];
}>;


export type GetAllBillingBySaleIdQuery = { __typename?: 'Query', getAllBillingBySaleId?: Array<{ __typename?: 'AllocationDetailOutput', id: string, table?: string | null, documentNo?: string | null, documentDate?: any | null, documentAmount?: number | null, description?: string | null, outstanding?: number | null, currentAllocate?: number | null, totalAllocateAmount?: number | null, enabledAllocate?: boolean | null, financialBillingId?: string | null }> | null };

export type ReversalPaRecordByIdMutationVariables = Exact<{
  id: Scalars['String'];
  saleId: Scalars['String'];
  tableRef: Scalars['String'];
}>;


export type ReversalPaRecordByIdMutation = { __typename?: 'Mutation', reversalPARecordById: boolean };

export type GetContactListQueryVariables = Exact<{
  unitId?: InputMaybe<Scalars['String']>;
}>;


export type GetContactListQuery = { __typename?: 'Query', getContactList: Array<{ __typename?: 'PAcontactOutput', contactId: string, icNo: string, phoneNo: string, purchaserName: string, isCompany?: boolean | null, companyName?: string | null, companyRegNo?: string | null, officeTel?: string | null }> };

export type GetUnitListQueryVariables = Exact<{
  contactId?: InputMaybe<Scalars['String']>;
}>;


export type GetUnitListQuery = { __typename?: 'Query', getUnitList: Array<{ __typename?: 'PAunitOutput', contactId: string, saleId: string, unitId: string, unitNo: string, unitStatus: string, salesConvertedStatus: string, clusterName: string }> };

export type DeletePAdataMutationVariables = Exact<{
  tableRef: Scalars['String'];
  id: Scalars['String'];
  haveAllocation: Scalars['Boolean'];
}>;


export type DeletePAdataMutation = { __typename?: 'Mutation', deletePAdata: boolean };

export type GetProjectLetterTemplateQueryVariables = Exact<{
  letterType: Scalars['String'];
}>;


export type GetProjectLetterTemplateQuery = { __typename?: 'Query', getProjectLetterTemplate?: Array<{ __typename?: 'projectLetterTemplateOutput', templateId: string, stdLtrId: string, templateName: string, letterName: string }> | null };

export type GetPArebateListQueryVariables = Exact<{
  saleId: Scalars['String'];
  status: Scalars['String'];
}>;


export type GetPArebateListQuery = { __typename?: 'Query', getPArebateList: Array<{ __typename?: 'rebateEntity', allowReversal: boolean, approvedBy?: string | null, approvedDate?: any | null, description?: string | null, documentAmount: number, documentDate: any, documentNo?: string | null, id: string, requestedBy?: string | null, status: string, submittedBy?: string | null, submittedDate?: any | null, unallocatedAmount?: number | null, attachment?: Array<{ __typename?: 'attachmentEntity', id: string, fileName: string, allowDelete?: boolean | null, isPrivate: boolean, mediaType: string, resourceUrl: string }> | null, billItem?: { __typename?: 'billItemEntity', billItemType: string, id: string, name: string } | null, requestUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, submitUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, approveUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, taxData?: { __typename?: 'TaxSchemeDropdownOutput', taxSchemeId: string, taxSchemeName: string, effectiveDate: any, taxSchemeDetailId: string, totalTaxRate?: string | null, totalTaxAmount: number } | null }> };

export type GetPaRebateSubmittedListQueryVariables = Exact<{
  saleId: Scalars['String'];
}>;


export type GetPaRebateSubmittedListQuery = { __typename?: 'Query', getPARebateSubmittedList: Array<{ __typename?: 'PALedgerSubmmitedListingOutput', id: string, documentAmount: number, documentDate: any, description: string, approvalRoleId?: string | null, submittedDate: any, unallocatedAmount?: number | null, attachment?: Array<{ __typename?: 'attachmentEntity', id: string, fileName: string, allowDelete?: boolean | null, isPrivate: boolean, mediaType: string, resourceUrl: string }> | null, billItem?: { __typename?: 'billItemEntity', billItemType: string, id: string, name: string } | null, requestUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, submitUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, approveUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, taxData?: { __typename?: 'TaxSchemeDropdownOutput', taxSchemeId: string, taxSchemeName: string, effectiveDate: any, taxSchemeDetailId: string, totalTaxRate?: string | null, totalTaxAmount: number } | null, billingDetailTaxData?: { __typename?: 'BillingDetailTaxData', taxSchemeName?: string | null, totalTaxRate?: string | null, totalTaxAmount?: string | null } | null }> };

export type GetPArebateSummaryQueryVariables = Exact<{
  projectId: Scalars['String'];
  saleId: Scalars['String'];
}>;


export type GetPArebateSummaryQuery = { __typename?: 'Query', getPArebateSummary?: { __typename?: 'PAmoduleSummary', totalCharges?: number | null, totalUnallocated?: number | null, totalDraft?: number | null, totalSubmitted?: number | null } | null };

export type GetPArebateByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPArebateByIdQuery = { __typename?: 'Query', getPArebateById: { __typename?: 'rebateEntity', allowReversal: boolean, approvedBy?: string | null, approvedDate?: any | null, billItemId: string, description?: string | null, documentAmount: number, documentDate: any, documentNo?: string | null, documentRef?: string | null, id: string, requestedBy?: string | null, status: string, submittedBy?: string | null, submittedDate?: any | null, unallocatedAmount?: number | null, voidDate?: any | null, allocation?: Array<{ __typename?: 'allocationEntity', allocateAmount: number }> | null, attachment?: Array<{ __typename?: 'attachmentEntity', id: string, fileName: string, allowDelete?: boolean | null, isPrivate: boolean, mediaType: string, resourceUrl: string }> | null, billItem?: { __typename?: 'billItemEntity', billItemType: string, id: string, name: string } | null, requestUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, submitUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, approveUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, taxData?: { __typename?: 'TaxSchemeDropdownOutput', taxSchemeId: string, taxSchemeName: string, effectiveDate: any, taxSchemeDetailId: string, totalTaxRate?: string | null, totalTaxAmount: number, isExclusive: boolean } | null, voidUserData?: { __typename?: 'UserEntity', name?: string | null } | null, projectDetail?: { __typename?: 'projectEntity', name: string } | null } };

export type AddPArebateMutationVariables = Exact<{
  isSubmitted: Scalars['Boolean'];
  input: AddPAmoduleDataInput;
}>;


export type AddPArebateMutation = { __typename?: 'Mutation', addPArebate: boolean };

export type EditPArebateMutationVariables = Exact<{
  isSubmitted: Scalars['Boolean'];
  input: EditPAmoduleDataInput;
}>;


export type EditPArebateMutation = { __typename?: 'Mutation', editPArebate: boolean };

export type GetPArefundListQueryVariables = Exact<{
  saleId: Scalars['String'];
  status: Scalars['String'];
}>;


export type GetPArefundListQuery = { __typename?: 'Query', getPArefundList: Array<{ __typename?: 'refundEntity', id: string, documentDate: any, documentAmount: number, documentNo?: string | null, description: string, status: string, submittedBy?: string | null, approvedBy?: string | null, approvedDate?: any | null, submittedDate?: any | null, attachment?: Array<{ __typename?: 'attachmentEntity', id: string, fileName: string, allowDelete?: boolean | null, isPrivate: boolean, mediaType: string, resourceUrl: string }> | null, submitUserData?: { __typename?: 'UserEntity', name?: string | null } | null, approveUserData?: { __typename?: 'UserEntity', name?: string | null } | null }> };

export type GetPaRefundSubmittedListQueryVariables = Exact<{
  saleId: Scalars['String'];
}>;


export type GetPaRefundSubmittedListQuery = { __typename?: 'Query', getPARefundSubmittedList: Array<{ __typename?: 'PALedgerSubmmitedListingOutput', id: string, documentAmount: number, documentDate: any, description: string, approvalRoleId?: string | null, submittedDate: any, attachment?: Array<{ __typename?: 'attachmentEntity', id: string, fileName: string, allowDelete?: boolean | null, isPrivate: boolean, mediaType: string, resourceUrl: string }> | null, submitUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, approveUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null }> };

export type GetPArefundSummaryQueryVariables = Exact<{
  projectId: Scalars['String'];
  saleId: Scalars['String'];
}>;


export type GetPArefundSummaryQuery = { __typename?: 'Query', getPArefundSummary?: { __typename?: 'PAmoduleSummary', totalCharges?: number | null, totalUnallocated?: number | null, totalDraft?: number | null, totalSubmitted?: number | null } | null };

export type GetPArefundByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPArefundByIdQuery = { __typename?: 'Query', getPArefundById: { __typename?: 'refundEntity', approvedBy?: string | null, approvedDate?: any | null, bankAccountId?: string | null, chequeDate?: any | null, chequeExpireDate?: any | null, creditCardType?: string | null, description: string, documentAmount: number, documentDate: any, documentNo?: string | null, documentRef?: string | null, id: string, refundMethod: string, saleId: string, status: string, submittedBy?: string | null, submittedDate?: any | null, attachment?: Array<{ __typename?: 'attachmentEntity', id: string, fileName: string, allowDelete?: boolean | null, isPrivate: boolean, mediaType: string, resourceUrl: string }> | null, submitUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, approveUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, projectDetail?: { __typename?: 'projectEntity', name: string } | null } };

export type AddPArefundMutationVariables = Exact<{
  isSubmitted: Scalars['Boolean'];
  input: AddRefundDataInput;
}>;


export type AddPArefundMutation = { __typename?: 'Mutation', addPArefund: boolean };

export type EditPArefundMutationVariables = Exact<{
  isSubmitted: Scalars['Boolean'];
  input: EditRefundDataInput;
}>;


export type EditPArefundMutation = { __typename?: 'Mutation', editPArefund: boolean };

export type GetRefundAllocationQueryVariables = Exact<{
  saleId: Scalars['String'];
  refundId?: InputMaybe<Scalars['String']>;
}>;


export type GetRefundAllocationQuery = { __typename?: 'Query', getRefundAllocation?: Array<{ __typename?: 'RefundAllocationOutput', creditId: string, docAmt: number, docNo: string, outstandingAmt: number, description?: string | null, docDate: any, creditRefTable: string, currentAllocate: number, totalAllocate: number }> | null };

export type GetAllocationByCreditIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetAllocationByCreditIdQuery = { __typename?: 'Query', getAllocationByCreditId?: { __typename?: 'allocationEntity', allocateAmount: number, debitNote?: { __typename?: 'debitNoteEntity', id: string, description?: string | null, documentAmount: number, documentDate: any, documentNo?: string | null, isReversal: boolean, voidBy?: string | null } | null } | null };

export type GetPaIndoSummaryQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetPaIndoSummaryQuery = { __typename?: 'Query', getPAIndoSummary?: { __typename?: 'PurchaserAccountIndoSummary', purchaserInstallmentSummary: { __typename?: 'PISummary', totalDocAmt?: number | null, draftCount?: number | null, submitCount?: number | null, approveCount?: number | null, totalUnallocatedAmt?: number | null }, additionalPackageSummary: { __typename?: 'APSummary', totalUnallocatedAmt: number, totalDocAmt: number, itemCount: number, totalSellingPrice: number }, carParkSummary: { __typename?: 'carParkSummary', totalOutstandingAmount?: number | null, totalAllocateAmount?: number | null, itemCount?: number | null, totalSellingPrice?: number | null }, miscBillingSummary: { __typename?: 'MBSummary', totalDocAmt?: number | null, draftCount?: number | null, submitCount?: number | null, approveCount?: number | null, totalUnallocatedAmt?: number | null }, lateInterestSummary: { __typename?: 'LISummary', totalCharges?: number | null, totalUnallocatedAmt?: number | null, totalApproved?: number | null }, debitNoteSummary: { __typename?: 'DNSummary', totalDocAmt?: number | null, draftCount?: number | null, submitCount?: number | null, approveCount?: number | null, totalUnallocatedAmt?: number | null }, creditNoteSummary: { __typename?: 'CNSummary', totalDocAmt?: number | null, draftCount?: number | null, submitCount?: number | null, approveCount?: number | null, totalUnallocatedAmt?: number | null }, rebateSummary: { __typename?: 'RebateSummary', totalDocAmt?: number | null, draftCount?: number | null, submitCount?: number | null, approveCount?: number | null, totalUnallocatedAmt?: number | null }, paymentSummary: { __typename?: 'PaymentSummary', totalDocAmt?: number | null, draftCount?: number | null, submitCount?: number | null, approveCount?: number | null, totalUnallocatedAmt?: number | null }, depositSummary: { __typename?: 'DepositSummary', totalDocAmt?: number | null, draftCount?: number | null, submitCount?: number | null, approveCount?: number | null, totalUnallocatedAmt?: number | null }, contraSummary: { __typename?: 'ContraSummary', totalDocAmt?: number | null, draftCount?: number | null, submitCount?: number | null, approveCount?: number | null, totalUnallocatedAmt?: number | null }, refundSummary: { __typename?: 'RefundSummary', totalDocAmt?: number | null, draftCount?: number | null, submitCount?: number | null, approveCount?: number | null, totalUnallocatedAmt?: number | null } } | null };

export type GetPaIndoMiscBillingSummaryQueryVariables = Exact<{
  projectId: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
  saleId?: InputMaybe<Scalars['String']>;
}>;


export type GetPaIndoMiscBillingSummaryQuery = { __typename?: 'Query', getPAIndoMiscBillingSummary: Array<{ __typename?: 'miscBillingEntity', id: string, saleId: string, documentDate: any, documentAmount: number, unitDetail?: string | null, contactDetail?: string | null, interestRate?: number | null, creditTerm: number, description: string, dueDate: any, requestedBy?: string | null, submittedBy?: string | null, submittedDate?: any | null, unallocatedAmount?: number | null, unallocatedAmountSummary?: number | null, documentNo?: string | null, status: string, generationBatch?: string | null, generationBatchDate?: any | null, billItemInt?: { __typename?: 'billItemIntEntity', billItemType: string, name: string } | null, taxData?: { __typename?: 'TaxSchemeDropdownOutput', taxSchemeName: string, totalTaxRate?: string | null } | null, taxLedger?: { __typename?: 'taxLedgerEntity', taxAmount: number } | null, attachment?: Array<{ __typename?: 'attachmentEntity', allowDelete?: boolean | null, fileName: string, id: string, isPrivate: boolean, mediaType: string, resourceUrl: string }> | null, requestUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null, userName?: string | null } | null, submitUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null, userName?: string | null } | null, approveUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null, userName?: string | null } | null, clusterName?: { __typename?: 'projectClusterEntity', name: string } | null, salesRegNo?: { __typename?: 'saleExtensionEntity', salesRegistrationNo?: string | null } | null }> };

export type GetUnitAndContactListQueryVariables = Exact<{
  projectId: Scalars['String'];
  saleId?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetUnitAndContactListQuery = { __typename?: 'Query', getUnitAndContactList?: Array<{ __typename?: 'unitAndContactListOutput', unitId?: string | null, saleId?: string | null, unitNo?: string | null, fullName?: string | null, clusterName?: string | null, salesRegistrationNo?: string | null }> | null };

export type GetBillItemIntListByTypeQueryVariables = Exact<{
  type: Scalars['String'];
}>;


export type GetBillItemIntListByTypeQuery = { __typename?: 'Query', getBillItemIntListByType?: Array<{ __typename?: 'billItemIntEntity', id: string, name: string }> | null };

export type GetPaIndoDebitNoteSummaryQueryVariables = Exact<{
  projectId: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
  saleId?: InputMaybe<Scalars['String']>;
}>;


export type GetPaIndoDebitNoteSummaryQuery = { __typename?: 'Query', getPAIndoDebitNoteSummary: Array<{ __typename?: 'debitNoteEntity', id: string, saleId: string, documentDate: any, documentAmount: number, documentNo?: string | null, unitDetail?: string | null, contactDetail?: string | null, interestRate: number, creditTerm: number, description?: string | null, dueDate: any, requestedBy?: string | null, submittedBy?: string | null, submittedDate?: any | null, unallocatedAmount?: number | null, unallocatedAmountSummary?: number | null, billItemInt?: { __typename?: 'billItemIntEntity', id: string, name: string, billItemType: string } | null, taxData?: { __typename?: 'TaxSchemeDropdownOutput', taxSchemeName: string, totalTaxRate?: string | null } | null, taxLedger?: { __typename?: 'taxLedgerEntity', taxAmount: number } | null, requestUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null, userName?: string | null } | null, submitUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null, userName?: string | null } | null, approveUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null, userName?: string | null } | null, attachment?: Array<{ __typename?: 'attachmentEntity', allowDelete?: boolean | null, fileName: string, id: string, isPrivate: boolean, mediaType: string, resourceUrl: string }> | null, clusterName?: { __typename?: 'projectClusterEntity', name: string } | null, salesRegNo?: { __typename?: 'saleExtensionEntity', salesRegistrationNo?: string | null } | null }> };

export type GetPaIndoCreditNoteSummaryQueryVariables = Exact<{
  projectId: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
  saleId?: InputMaybe<Scalars['String']>;
}>;


export type GetPaIndoCreditNoteSummaryQuery = { __typename?: 'Query', getPAIndoCreditNoteSummary: Array<{ __typename?: 'creditNoteEntity', id: string, saleId: string, documentDate: any, documentAmount: number, documentNo?: string | null, unitDetail?: string | null, contactDetail?: string | null, description?: string | null, requestedBy?: string | null, submittedBy?: string | null, submittedDate?: any | null, unallocatedAmount?: number | null, unallocatedAmountSummary?: number | null, billItemInt?: { __typename?: 'billItemIntEntity', id: string, name: string, billItemType: string } | null, taxData?: { __typename?: 'TaxSchemeDropdownOutput', taxSchemeName: string, totalTaxRate?: string | null } | null, taxLedger?: { __typename?: 'taxLedgerEntity', taxAmount: number } | null, requestUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null, userName?: string | null } | null, submitUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null, userName?: string | null } | null, approveUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null, userName?: string | null } | null, attachment?: Array<{ __typename?: 'attachmentEntity', allowDelete?: boolean | null, fileName: string, id: string, isPrivate: boolean, mediaType: string, resourceUrl: string }> | null, clusterName?: { __typename?: 'projectClusterEntity', name: string } | null, salesRegNo?: { __typename?: 'saleExtensionEntity', salesRegistrationNo?: string | null } | null, allocationData?: Array<{ __typename?: 'AllocationData', allocateAmount?: number | null, allocationDate?: any | null, creditId?: string | null, debitId?: string | null, miscDescription?: string | null, debitNoteDescription?: string | null, installmentDescription?: string | null, documentNo?: string | null }> | null }> };

export type GetPaIndoRebateSummaryQueryVariables = Exact<{
  projectId: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
  saleId?: InputMaybe<Scalars['String']>;
}>;


export type GetPaIndoRebateSummaryQuery = { __typename?: 'Query', getPAIndoRebateSummary: Array<{ __typename?: 'rebateEntity', id: string, saleId: string, documentDate: any, documentAmount: number, documentNo?: string | null, unitDetail?: string | null, contactDetail?: string | null, description?: string | null, requestedBy?: string | null, submittedBy?: string | null, submittedDate?: any | null, unallocatedAmount?: number | null, unallocatedAmountSummary?: number | null, billItemInt?: { __typename?: 'billItemIntEntity', id: string, name: string, billItemType: string } | null, taxData?: { __typename?: 'TaxSchemeDropdownOutput', taxSchemeName: string, totalTaxRate?: string | null } | null, taxLedger?: { __typename?: 'taxLedgerEntity', taxAmount: number } | null, requestUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null, userName?: string | null } | null, submitUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null, userName?: string | null } | null, approveUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null, userName?: string | null } | null, attachment?: Array<{ __typename?: 'attachmentEntity', allowDelete?: boolean | null, fileName: string, id: string, isPrivate: boolean, mediaType: string, resourceUrl: string }> | null, clusterName?: { __typename?: 'projectClusterEntity', name: string } | null, salesRegNo?: { __typename?: 'saleExtensionEntity', salesRegistrationNo?: string | null } | null, allocationData?: Array<{ __typename?: 'AllocationData', allocateAmount?: number | null, allocationDate?: any | null, creditId?: string | null, debitId?: string | null, miscDescription?: string | null, debitNoteDescription?: string | null, installmentDescription?: string | null, documentNo?: string | null }> | null }> };

export type GetPaIndoPaymentSummaryQueryVariables = Exact<{
  projectId: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
  saleId?: InputMaybe<Scalars['String']>;
}>;


export type GetPaIndoPaymentSummaryQuery = { __typename?: 'Query', getPAIndoPaymentSummary: Array<{ __typename?: 'receiptEntity', id: string, saleId: string, documentDate: any, documentAmount: number, documentNo?: string | null, unitDetail?: string | null, contactDetail?: string | null, description: string, paymentMethod: string, creditCardType?: string | null, chequeDate?: any | null, chequeExpireDate?: any | null, documentRef?: string | null, receiptAmount: number, submittedBy?: string | null, submittedDate?: any | null, allowReversal: boolean, unallocatedAmount?: number | null, unallocatedAmountSummary?: number | null, taxData?: { __typename?: 'TaxSchemeDropdownOutput', taxSchemeName: string, totalTaxRate?: string | null } | null, taxLedger?: { __typename?: 'taxLedgerEntity', taxAmount: number } | null, submitUserData?: { __typename?: 'UserEntity', userName?: string | null, name?: string | null } | null, approveUserData?: { __typename?: 'UserEntity', userName?: string | null, name?: string | null } | null, bankAccount?: { __typename?: 'companyBankAccountEntity', code: string, accountNo: string, bankProfile: { __typename?: 'companyBankProfileEntity', name: string } } | null, attachment?: Array<{ __typename?: 'attachmentEntity', allowDelete?: boolean | null, fileName: string, id: string, isPrivate: boolean, mediaType: string, resourceUrl: string }> | null, clusterName?: { __typename?: 'projectClusterEntity', name: string } | null, salesRegNo?: { __typename?: 'saleExtensionEntity', salesRegistrationNo?: string | null } | null, allocationData?: Array<{ __typename?: 'AllocationData', allocationId?: string | null, allocateAmount?: number | null, allocationDate?: any | null, creditId?: string | null, debitId?: string | null, miscDescription?: string | null, debitNoteDescription?: string | null, installmentDescription?: string | null, packagesDescription?: string | null, carParkDescription?: string | null, lateInterestDescription?: string | null, documentNo?: string | null }> | null }> };

export type GetPurchaserDataQueryVariables = Exact<{
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  tableRef: Scalars['String'];
}>;


export type GetPurchaserDataQuery = { __typename?: 'Query', getPurchaserData?: { __typename?: 'purchaserDataOutput', fullName?: string | null, unitNo?: string | null, totalDocAmt?: string | null, totalOutstanding?: string | null, clusterName?: string | null, salesRegistrationNo?: string | null, salesRegistrationDate?: any | null } | null };

export type GetCreditCardTypeDescQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCreditCardTypeDescQuery = { __typename?: 'Query', getCreditCardTypeDesc: any };

export type GetBillTypeDescQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBillTypeDescQuery = { __typename?: 'Query', getBillTypeDesc: any };

export type GetPaIndoDepositSummaryQueryVariables = Exact<{
  projectId: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
  saleId?: InputMaybe<Scalars['String']>;
}>;


export type GetPaIndoDepositSummaryQuery = { __typename?: 'Query', getPAIndoDepositSummary: Array<{ __typename?: 'depositEntity', id: string, saleId: string, unitDetail?: string | null, contactDetail?: string | null, description: string, submittedBy?: string | null, submittedDate?: any | null, outstanding?: number | null, documentNo?: string | null, paymentMethod: string, documentAmount: number, documentDate: any, bankAccountId: string, chequeDate?: any | null, chequeExpireDate?: any | null, documentRef?: string | null, creditCardType?: string | null, convertedToPayment: boolean, billItemInt?: { __typename?: 'billItemIntEntity', billItemType: string, name: string } | null, taxLedger?: { __typename?: 'taxLedgerEntity', taxAmount: number } | null, submitUserData?: { __typename?: 'UserEntity', name?: string | null, userName?: string | null } | null, approveUserData?: { __typename?: 'UserEntity', name?: string | null, userName?: string | null } | null, bankAccount?: { __typename?: 'companyBankAccountEntity', code: string, accountNo: string, bankProfile: { __typename?: 'companyBankProfileEntity', name: string } } | null, attachment?: Array<{ __typename?: 'attachmentEntity', allowDelete?: boolean | null, fileName: string, id: string, isPrivate: boolean, mediaType: string, resourceUrl: string }> | null, clusterName?: { __typename?: 'projectClusterEntity', name: string } | null, salesRegNo?: { __typename?: 'saleExtensionEntity', salesRegistrationNo?: string | null } | null }> };

export type GetPaIndoRefundSummaryQueryVariables = Exact<{
  projectId: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
  saleId?: InputMaybe<Scalars['String']>;
}>;


export type GetPaIndoRefundSummaryQuery = { __typename?: 'Query', getPAIndoRefundSummary: Array<{ __typename?: 'refundEntity', id: string, saleId: string, documentDate: any, documentAmount: number, documentNo?: string | null, unitDetail?: string | null, contactDetail?: string | null, description: string, refundMethod: string, creditCardType?: string | null, chequeDate?: any | null, chequeExpireDate?: any | null, bankAccountId?: string | null, documentRef?: string | null, submittedBy?: string | null, submittedDate?: any | null, unallocatedAmount?: number | null, taxData?: { __typename?: 'TaxSchemeDropdownOutput', taxSchemeName: string, totalTaxRate?: string | null } | null, taxLedger?: { __typename?: 'taxLedgerEntity', taxAmount: number } | null, submitUserData?: { __typename?: 'UserEntity', userName?: string | null, name?: string | null } | null, approveUserData?: { __typename?: 'UserEntity', userName?: string | null, name?: string | null } | null, attachment?: Array<{ __typename?: 'attachmentEntity', allowDelete?: boolean | null, fileName: string, id: string, isPrivate: boolean, mediaType: string, resourceUrl: string }> | null, bankAccount?: { __typename?: 'companyBankAccountEntity', code: string, accountNo: string, bankProfile: { __typename?: 'companyBankProfileEntity', name: string } } | null, clusterName?: { __typename?: 'projectClusterEntity', name: string } | null, salesRegNo?: { __typename?: 'saleExtensionEntity', salesRegistrationNo?: string | null } | null, allocationData?: Array<{ __typename?: 'AllocationData', allocateAmount?: number | null, allocationDate?: any | null, creditId?: string | null, debitId?: string | null, miscDescription?: string | null, debitNoteDescription?: string | null, installmentDescription?: string | null, documentNo?: string | null, receiptDescription?: string | null, rebateDescription?: string | null }> | null }> };

export type PaIndoPurchaserLedgerSummaryQueryVariables = Exact<{
  saleId: Scalars['String'];
}>;


export type PaIndoPurchaserLedgerSummaryQuery = { __typename?: 'Query', getPAsummary?: { __typename?: 'PurchaserAccountSummary', totalUnallocated?: number | null, totalGrandOutstading?: number | null, progressBillingSummary: { __typename?: 'PBsummary', totalCharges?: number | null, totalUnallocated?: number | null }, purchaserDetail?: { __typename?: 'PurchaserAccDetail', saleId: string, purchaserName: string, unitNo: string, phoneNo: string, icNo: string, contactId: string } | null, creditNoteSummary: { __typename?: 'PAmoduleSummary', totalCharges?: number | null, totalUnallocated?: number | null, totalDraft?: number | null, totalSubmitted?: number | null, totalApproved?: number | null }, debitNoteSummary: { __typename?: 'PAmoduleSummary', totalCharges?: number | null, totalUnallocated?: number | null, totalDraft?: number | null, totalSubmitted?: number | null, totalApproved?: number | null }, rebateSummary: { __typename?: 'PAmoduleSummary', totalCharges?: number | null, totalUnallocated?: number | null, totalDraft?: number | null, totalSubmitted?: number | null, totalApproved?: number | null }, contraSummary: { __typename?: 'PAmoduleSummary', totalCharges?: number | null, totalUnallocated?: number | null, totalDraft?: number | null, totalSubmitted?: number | null, totalApproved?: number | null }, miscBillingSummary: { __typename?: 'PAmoduleSummary', totalCharges?: number | null, totalUnallocated?: number | null, totalDraft?: number | null, totalSubmitted?: number | null, totalApproved?: number | null }, lateInterestSummary: { __typename?: 'PALateInterestSummary', totalCharges?: number | null, totalUnallocated?: number | null, lastCalculatedDate?: any | null }, refundSummary: { __typename?: 'PAmoduleSummary', totalCharges?: number | null, totalUnallocated?: number | null, totalDraft?: number | null, totalSubmitted?: number | null, totalApproved?: number | null }, collectionSummary: { __typename?: 'PAmoduleSummary', totalCharges?: number | null, totalUnallocated?: number | null, totalDraft?: number | null, totalSubmitted?: number | null, totalApproved?: number | null }, contactData: { __typename?: 'PAcontactOutput', contactId: string, icNo: string, phoneNo: string, purchaserName: string, email?: string | null }, unitData: { __typename?: 'PAunitOutput', contactId: string, saleId: string, unitId: string, unitNo: string, unitStatus: string, salesConvertedStatus: string, clusterName: string }, collectionActivity?: { __typename?: 'collectionActivitySummaryOutput', activityDate: any, activityRemark: string } | null, paymentReminder?: { __typename?: 'paymentReminderSummaryOutput', reminder1: number, reminder2: number, reminder3: number } | null, depositSummary: { __typename?: 'PAmoduleSummary', totalCharges?: number | null, totalUnallocated?: number | null, totalDraft?: number | null, totalSubmitted?: number | null, totalApproved?: number | null }, purchaserInstallmentSummary: { __typename?: 'PAmoduleSummary', totalCharges?: number | null, totalUnallocated?: number | null, totalInstallmentSaleAmount?: number | null }, bankLoanSummary: { __typename?: 'bankLoanSummary', loanAppliedAmount?: number | null, loanApprovedAmount?: number | null }, overdueAging: { __typename?: 'overdueAging', period1?: string | null, period2?: string | null, period3?: string | null, period4?: string | null, period5?: string | null, period6?: string | null }, dueDateRange: { __typename?: 'dueDateRange', range1?: { __typename?: 'dueDateRangeDetail', totalDueDateRange?: number | null, dueDateRangeListing?: { __typename?: 'dueDateRangeListing', purchaserInstallmentDetail?: Array<{ __typename?: 'dueDateRangeListingDetail', id?: string | null, documentDate?: any | null, description?: string | null, documentAmount?: number | null, totalAlocated?: number | null, outstanding?: number | null }> | null, miscBillingDetail?: Array<{ __typename?: 'dueDateRangeListingDetail', id?: string | null, documentDate?: any | null, description?: string | null, documentAmount?: number | null, totalAlocated?: number | null, outstanding?: number | null }> | null, debitNoteDetail?: Array<{ __typename?: 'dueDateRangeListingDetail', id?: string | null, documentDate?: any | null, description?: string | null, documentAmount?: number | null, totalAlocated?: number | null, outstanding?: number | null }> | null, carparkInstallmentDetail?: Array<{ __typename?: 'dueDateRangeListingDetail', id?: string | null, documentDate?: any | null, description?: string | null, documentAmount?: number | null, totalAlocated?: number | null, outstanding?: number | null }> | null, addPackageInstallmentDetail?: Array<{ __typename?: 'dueDateRangeListingDetail', id?: string | null, documentDate?: any | null, description?: string | null, documentAmount?: number | null, totalAlocated?: number | null, outstanding?: number | null }> | null, lateInterestDetail?: Array<{ __typename?: 'dueDateRangeListingDetail', id?: string | null, documentDate?: any | null, description?: string | null, documentAmount?: number | null, totalAlocated?: number | null, outstanding?: number | null }> | null } | null, dueDateRangeHeader?: { __typename?: 'dueDateRangeHeader', purchaserInstallmentDetail?: { __typename?: 'dueDateRangeHeaderDetail', title?: string | null, totalDocumentAmount?: number | null, totalOutstanding?: number | null } | null, miscBillingDetail?: { __typename?: 'dueDateRangeHeaderDetail', title?: string | null, totalDocumentAmount?: number | null, totalOutstanding?: number | null } | null, debitNoteDetail?: { __typename?: 'dueDateRangeHeaderDetail', title?: string | null, totalDocumentAmount?: number | null, totalOutstanding?: number | null } | null, carparkInstallmentDetail?: { __typename?: 'dueDateRangeHeaderDetail', title?: string | null, totalDocumentAmount?: number | null, totalOutstanding?: number | null } | null, addPackageInstallmentDetail?: { __typename?: 'dueDateRangeHeaderDetail', title?: string | null, totalDocumentAmount?: number | null, totalOutstanding?: number | null } | null, lateInterestDetail?: { __typename?: 'dueDateRangeHeaderDetail', title?: string | null, totalDocumentAmount?: number | null, totalOutstanding?: number | null } | null } | null } | null, range2?: { __typename?: 'dueDateRangeDetail', totalDueDateRange?: number | null, dueDateRangeListing?: { __typename?: 'dueDateRangeListing', purchaserInstallmentDetail?: Array<{ __typename?: 'dueDateRangeListingDetail', id?: string | null, documentDate?: any | null, description?: string | null, documentAmount?: number | null, totalAlocated?: number | null, outstanding?: number | null }> | null, miscBillingDetail?: Array<{ __typename?: 'dueDateRangeListingDetail', id?: string | null, documentDate?: any | null, description?: string | null, documentAmount?: number | null, totalAlocated?: number | null, outstanding?: number | null }> | null, debitNoteDetail?: Array<{ __typename?: 'dueDateRangeListingDetail', id?: string | null, documentDate?: any | null, description?: string | null, documentAmount?: number | null, totalAlocated?: number | null, outstanding?: number | null }> | null, carparkInstallmentDetail?: Array<{ __typename?: 'dueDateRangeListingDetail', id?: string | null, documentDate?: any | null, description?: string | null, documentAmount?: number | null, totalAlocated?: number | null, outstanding?: number | null }> | null, addPackageInstallmentDetail?: Array<{ __typename?: 'dueDateRangeListingDetail', id?: string | null, documentDate?: any | null, description?: string | null, documentAmount?: number | null, totalAlocated?: number | null, outstanding?: number | null }> | null, lateInterestDetail?: Array<{ __typename?: 'dueDateRangeListingDetail', id?: string | null, documentDate?: any | null, description?: string | null, documentAmount?: number | null, totalAlocated?: number | null, outstanding?: number | null }> | null } | null, dueDateRangeHeader?: { __typename?: 'dueDateRangeHeader', purchaserInstallmentDetail?: { __typename?: 'dueDateRangeHeaderDetail', title?: string | null, totalDocumentAmount?: number | null, totalOutstanding?: number | null } | null, miscBillingDetail?: { __typename?: 'dueDateRangeHeaderDetail', title?: string | null, totalDocumentAmount?: number | null, totalOutstanding?: number | null } | null, debitNoteDetail?: { __typename?: 'dueDateRangeHeaderDetail', title?: string | null, totalDocumentAmount?: number | null, totalOutstanding?: number | null } | null, carparkInstallmentDetail?: { __typename?: 'dueDateRangeHeaderDetail', title?: string | null, totalDocumentAmount?: number | null, totalOutstanding?: number | null } | null, addPackageInstallmentDetail?: { __typename?: 'dueDateRangeHeaderDetail', title?: string | null, totalDocumentAmount?: number | null, totalOutstanding?: number | null } | null, lateInterestDetail?: { __typename?: 'dueDateRangeHeaderDetail', title?: string | null, totalDocumentAmount?: number | null, totalOutstanding?: number | null } | null } | null } | null, range3?: { __typename?: 'dueDateRangeDetail', totalDueDateRange?: number | null, dueDateRangeListing?: { __typename?: 'dueDateRangeListing', purchaserInstallmentDetail?: Array<{ __typename?: 'dueDateRangeListingDetail', id?: string | null, documentDate?: any | null, description?: string | null, documentAmount?: number | null, totalAlocated?: number | null, outstanding?: number | null }> | null, miscBillingDetail?: Array<{ __typename?: 'dueDateRangeListingDetail', id?: string | null, documentDate?: any | null, description?: string | null, documentAmount?: number | null, totalAlocated?: number | null, outstanding?: number | null }> | null, debitNoteDetail?: Array<{ __typename?: 'dueDateRangeListingDetail', id?: string | null, documentDate?: any | null, description?: string | null, documentAmount?: number | null, totalAlocated?: number | null, outstanding?: number | null }> | null, carparkInstallmentDetail?: Array<{ __typename?: 'dueDateRangeListingDetail', id?: string | null, documentDate?: any | null, description?: string | null, documentAmount?: number | null, totalAlocated?: number | null, outstanding?: number | null }> | null, addPackageInstallmentDetail?: Array<{ __typename?: 'dueDateRangeListingDetail', id?: string | null, documentDate?: any | null, description?: string | null, documentAmount?: number | null, totalAlocated?: number | null, outstanding?: number | null }> | null, lateInterestDetail?: Array<{ __typename?: 'dueDateRangeListingDetail', id?: string | null, documentDate?: any | null, description?: string | null, documentAmount?: number | null, totalAlocated?: number | null, outstanding?: number | null }> | null } | null, dueDateRangeHeader?: { __typename?: 'dueDateRangeHeader', purchaserInstallmentDetail?: { __typename?: 'dueDateRangeHeaderDetail', title?: string | null, totalDocumentAmount?: number | null, totalOutstanding?: number | null } | null, miscBillingDetail?: { __typename?: 'dueDateRangeHeaderDetail', title?: string | null, totalDocumentAmount?: number | null, totalOutstanding?: number | null } | null, debitNoteDetail?: { __typename?: 'dueDateRangeHeaderDetail', title?: string | null, totalDocumentAmount?: number | null, totalOutstanding?: number | null } | null, carparkInstallmentDetail?: { __typename?: 'dueDateRangeHeaderDetail', title?: string | null, totalDocumentAmount?: number | null, totalOutstanding?: number | null } | null, addPackageInstallmentDetail?: { __typename?: 'dueDateRangeHeaderDetail', title?: string | null, totalDocumentAmount?: number | null, totalOutstanding?: number | null } | null, lateInterestDetail?: { __typename?: 'dueDateRangeHeaderDetail', title?: string | null, totalDocumentAmount?: number | null, totalOutstanding?: number | null } | null } | null } | null, range4?: { __typename?: 'dueDateRangeDetail', totalDueDateRange?: number | null, dueDateRangeListing?: { __typename?: 'dueDateRangeListing', purchaserInstallmentDetail?: Array<{ __typename?: 'dueDateRangeListingDetail', id?: string | null, documentDate?: any | null, description?: string | null, documentAmount?: number | null, totalAlocated?: number | null, outstanding?: number | null }> | null, miscBillingDetail?: Array<{ __typename?: 'dueDateRangeListingDetail', id?: string | null, documentDate?: any | null, description?: string | null, documentAmount?: number | null, totalAlocated?: number | null, outstanding?: number | null }> | null, debitNoteDetail?: Array<{ __typename?: 'dueDateRangeListingDetail', id?: string | null, documentDate?: any | null, description?: string | null, documentAmount?: number | null, totalAlocated?: number | null, outstanding?: number | null }> | null, carparkInstallmentDetail?: Array<{ __typename?: 'dueDateRangeListingDetail', id?: string | null, documentDate?: any | null, description?: string | null, documentAmount?: number | null, totalAlocated?: number | null, outstanding?: number | null }> | null, addPackageInstallmentDetail?: Array<{ __typename?: 'dueDateRangeListingDetail', id?: string | null, documentDate?: any | null, description?: string | null, documentAmount?: number | null, totalAlocated?: number | null, outstanding?: number | null }> | null, lateInterestDetail?: Array<{ __typename?: 'dueDateRangeListingDetail', id?: string | null, documentDate?: any | null, description?: string | null, documentAmount?: number | null, totalAlocated?: number | null, outstanding?: number | null }> | null } | null, dueDateRangeHeader?: { __typename?: 'dueDateRangeHeader', purchaserInstallmentDetail?: { __typename?: 'dueDateRangeHeaderDetail', title?: string | null, totalDocumentAmount?: number | null, totalOutstanding?: number | null } | null, miscBillingDetail?: { __typename?: 'dueDateRangeHeaderDetail', title?: string | null, totalDocumentAmount?: number | null, totalOutstanding?: number | null } | null, debitNoteDetail?: { __typename?: 'dueDateRangeHeaderDetail', title?: string | null, totalDocumentAmount?: number | null, totalOutstanding?: number | null } | null, carparkInstallmentDetail?: { __typename?: 'dueDateRangeHeaderDetail', title?: string | null, totalDocumentAmount?: number | null, totalOutstanding?: number | null } | null, addPackageInstallmentDetail?: { __typename?: 'dueDateRangeHeaderDetail', title?: string | null, totalDocumentAmount?: number | null, totalOutstanding?: number | null } | null, lateInterestDetail?: { __typename?: 'dueDateRangeHeaderDetail', title?: string | null, totalDocumentAmount?: number | null, totalOutstanding?: number | null } | null } | null } | null, range5?: { __typename?: 'dueDateRangeDetail', totalDueDateRange?: number | null, dueDateRangeListing?: { __typename?: 'dueDateRangeListing', purchaserInstallmentDetail?: Array<{ __typename?: 'dueDateRangeListingDetail', id?: string | null, documentDate?: any | null, description?: string | null, documentAmount?: number | null, totalAlocated?: number | null, outstanding?: number | null }> | null, miscBillingDetail?: Array<{ __typename?: 'dueDateRangeListingDetail', id?: string | null, documentDate?: any | null, description?: string | null, documentAmount?: number | null, totalAlocated?: number | null, outstanding?: number | null }> | null, debitNoteDetail?: Array<{ __typename?: 'dueDateRangeListingDetail', id?: string | null, documentDate?: any | null, description?: string | null, documentAmount?: number | null, totalAlocated?: number | null, outstanding?: number | null }> | null, carparkInstallmentDetail?: Array<{ __typename?: 'dueDateRangeListingDetail', id?: string | null, documentDate?: any | null, description?: string | null, documentAmount?: number | null, totalAlocated?: number | null, outstanding?: number | null }> | null, addPackageInstallmentDetail?: Array<{ __typename?: 'dueDateRangeListingDetail', id?: string | null, documentDate?: any | null, description?: string | null, documentAmount?: number | null, totalAlocated?: number | null, outstanding?: number | null }> | null, lateInterestDetail?: Array<{ __typename?: 'dueDateRangeListingDetail', id?: string | null, documentDate?: any | null, description?: string | null, documentAmount?: number | null, totalAlocated?: number | null, outstanding?: number | null }> | null } | null, dueDateRangeHeader?: { __typename?: 'dueDateRangeHeader', purchaserInstallmentDetail?: { __typename?: 'dueDateRangeHeaderDetail', title?: string | null, totalDocumentAmount?: number | null, totalOutstanding?: number | null } | null, miscBillingDetail?: { __typename?: 'dueDateRangeHeaderDetail', title?: string | null, totalDocumentAmount?: number | null, totalOutstanding?: number | null } | null, debitNoteDetail?: { __typename?: 'dueDateRangeHeaderDetail', title?: string | null, totalDocumentAmount?: number | null, totalOutstanding?: number | null } | null, carparkInstallmentDetail?: { __typename?: 'dueDateRangeHeaderDetail', title?: string | null, totalDocumentAmount?: number | null, totalOutstanding?: number | null } | null, addPackageInstallmentDetail?: { __typename?: 'dueDateRangeHeaderDetail', title?: string | null, totalDocumentAmount?: number | null, totalOutstanding?: number | null } | null, lateInterestDetail?: { __typename?: 'dueDateRangeHeaderDetail', title?: string | null, totalDocumentAmount?: number | null, totalOutstanding?: number | null } | null } | null } | null, range6?: { __typename?: 'dueDateRangeDetail', totalDueDateRange?: number | null, dueDateRangeListing?: { __typename?: 'dueDateRangeListing', purchaserInstallmentDetail?: Array<{ __typename?: 'dueDateRangeListingDetail', id?: string | null, documentDate?: any | null, description?: string | null, documentAmount?: number | null, totalAlocated?: number | null, outstanding?: number | null }> | null, miscBillingDetail?: Array<{ __typename?: 'dueDateRangeListingDetail', id?: string | null, documentDate?: any | null, description?: string | null, documentAmount?: number | null, totalAlocated?: number | null, outstanding?: number | null }> | null, debitNoteDetail?: Array<{ __typename?: 'dueDateRangeListingDetail', id?: string | null, documentDate?: any | null, description?: string | null, documentAmount?: number | null, totalAlocated?: number | null, outstanding?: number | null }> | null, carparkInstallmentDetail?: Array<{ __typename?: 'dueDateRangeListingDetail', id?: string | null, documentDate?: any | null, description?: string | null, documentAmount?: number | null, totalAlocated?: number | null, outstanding?: number | null }> | null, addPackageInstallmentDetail?: Array<{ __typename?: 'dueDateRangeListingDetail', id?: string | null, documentDate?: any | null, description?: string | null, documentAmount?: number | null, totalAlocated?: number | null, outstanding?: number | null }> | null, lateInterestDetail?: Array<{ __typename?: 'dueDateRangeListingDetail', id?: string | null, documentDate?: any | null, description?: string | null, documentAmount?: number | null, totalAlocated?: number | null, outstanding?: number | null }> | null } | null, dueDateRangeHeader?: { __typename?: 'dueDateRangeHeader', purchaserInstallmentDetail?: { __typename?: 'dueDateRangeHeaderDetail', title?: string | null, totalDocumentAmount?: number | null, totalOutstanding?: number | null } | null, miscBillingDetail?: { __typename?: 'dueDateRangeHeaderDetail', title?: string | null, totalDocumentAmount?: number | null, totalOutstanding?: number | null } | null, debitNoteDetail?: { __typename?: 'dueDateRangeHeaderDetail', title?: string | null, totalDocumentAmount?: number | null, totalOutstanding?: number | null } | null, carparkInstallmentDetail?: { __typename?: 'dueDateRangeHeaderDetail', title?: string | null, totalDocumentAmount?: number | null, totalOutstanding?: number | null } | null, addPackageInstallmentDetail?: { __typename?: 'dueDateRangeHeaderDetail', title?: string | null, totalDocumentAmount?: number | null, totalOutstanding?: number | null } | null, lateInterestDetail?: { __typename?: 'dueDateRangeHeaderDetail', title?: string | null, totalDocumentAmount?: number | null, totalOutstanding?: number | null } | null } | null } | null, range7?: { __typename?: 'dueDateRangeDetail', totalDueDateRange?: number | null, dueDateRangeListing?: { __typename?: 'dueDateRangeListing', purchaserInstallmentDetail?: Array<{ __typename?: 'dueDateRangeListingDetail', id?: string | null, documentDate?: any | null, description?: string | null, documentAmount?: number | null, totalAlocated?: number | null, outstanding?: number | null }> | null, miscBillingDetail?: Array<{ __typename?: 'dueDateRangeListingDetail', id?: string | null, documentDate?: any | null, description?: string | null, documentAmount?: number | null, totalAlocated?: number | null, outstanding?: number | null }> | null, debitNoteDetail?: Array<{ __typename?: 'dueDateRangeListingDetail', id?: string | null, documentDate?: any | null, description?: string | null, documentAmount?: number | null, totalAlocated?: number | null, outstanding?: number | null }> | null, carparkInstallmentDetail?: Array<{ __typename?: 'dueDateRangeListingDetail', id?: string | null, documentDate?: any | null, description?: string | null, documentAmount?: number | null, totalAlocated?: number | null, outstanding?: number | null }> | null, addPackageInstallmentDetail?: Array<{ __typename?: 'dueDateRangeListingDetail', id?: string | null, documentDate?: any | null, description?: string | null, documentAmount?: number | null, totalAlocated?: number | null, outstanding?: number | null }> | null, lateInterestDetail?: Array<{ __typename?: 'dueDateRangeListingDetail', id?: string | null, documentDate?: any | null, description?: string | null, documentAmount?: number | null, totalAlocated?: number | null, outstanding?: number | null }> | null } | null, dueDateRangeHeader?: { __typename?: 'dueDateRangeHeader', purchaserInstallmentDetail?: { __typename?: 'dueDateRangeHeaderDetail', title?: string | null, totalDocumentAmount?: number | null, totalOutstanding?: number | null } | null, miscBillingDetail?: { __typename?: 'dueDateRangeHeaderDetail', title?: string | null, totalDocumentAmount?: number | null, totalOutstanding?: number | null } | null, debitNoteDetail?: { __typename?: 'dueDateRangeHeaderDetail', title?: string | null, totalDocumentAmount?: number | null, totalOutstanding?: number | null } | null, carparkInstallmentDetail?: { __typename?: 'dueDateRangeHeaderDetail', title?: string | null, totalDocumentAmount?: number | null, totalOutstanding?: number | null } | null, addPackageInstallmentDetail?: { __typename?: 'dueDateRangeHeaderDetail', title?: string | null, totalDocumentAmount?: number | null, totalOutstanding?: number | null } | null, lateInterestDetail?: { __typename?: 'dueDateRangeHeaderDetail', title?: string | null, totalDocumentAmount?: number | null, totalOutstanding?: number | null } | null } | null } | null, unallocated?: { __typename?: 'dueDateRangeDetail', totalDueDateRange?: number | null, dueDateRangeListing?: { __typename?: 'dueDateRangeListing', creditNoteDetail?: Array<{ __typename?: 'dueDateRangeListingDetail', id?: string | null, documentDate?: any | null, description?: string | null, documentAmount?: number | null, totalAlocated?: number | null, outstanding?: number | null }> | null, rebateDetail?: Array<{ __typename?: 'dueDateRangeListingDetail', id?: string | null, documentDate?: any | null, description?: string | null, documentAmount?: number | null, totalAlocated?: number | null, outstanding?: number | null }> | null, paymentDetail?: Array<{ __typename?: 'dueDateRangeListingDetail', id?: string | null, documentDate?: any | null, description?: string | null, documentAmount?: number | null, totalAlocated?: number | null, outstanding?: number | null }> | null, contraDetail?: Array<{ __typename?: 'dueDateRangeListingDetail', id?: string | null, documentDate?: any | null, description?: string | null, documentAmount?: number | null, totalAlocated?: number | null, outstanding?: number | null }> | null } | null, dueDateRangeHeader?: { __typename?: 'dueDateRangeHeader', creditNoteDetail?: { __typename?: 'dueDateRangeHeaderDetail', title?: string | null, totalDocumentAmount?: number | null, totalOutstanding?: number | null } | null, rebateDetail?: { __typename?: 'dueDateRangeHeaderDetail', title?: string | null, totalDocumentAmount?: number | null, totalOutstanding?: number | null } | null, paymentDetail?: { __typename?: 'dueDateRangeHeaderDetail', title?: string | null, totalDocumentAmount?: number | null, totalOutstanding?: number | null } | null, contraDetail?: { __typename?: 'dueDateRangeHeaderDetail', title?: string | null, totalDocumentAmount?: number | null, totalOutstanding?: number | null } | null } | null } | null }, carParkSummary: { __typename?: 'carParkAdditionalPackageSummary', totalOutstandingAmount?: number | null, totalAllocateAmount?: number | null, itemCount?: number | null, totalSellingPrice?: number | null }, additionalPackageSummary: { __typename?: 'carParkAdditionalPackageSummary', totalOutstandingAmount?: number | null, totalAllocateAmount?: number | null, itemCount?: number | null, totalSellingPrice?: number | null } } | null };

export type GetIndoContactListQueryVariables = Exact<{
  unitId?: InputMaybe<Scalars['String']>;
}>;


export type GetIndoContactListQuery = { __typename?: 'Query', getContactList: Array<{ __typename?: 'PAcontactOutput', contactId: string, icNo: string, phoneNo: string, purchaserName: string, email?: string | null }> };

export type GetAllBillingIndoBySaleIdQueryVariables = Exact<{
  billItemId?: InputMaybe<Scalars['String']>;
  creditId?: InputMaybe<Scalars['String']>;
  mainTable: Scalars['String'];
  saleId: Scalars['String'];
  projectId?: InputMaybe<Scalars['String']>;
  tableFilter?: InputMaybe<Scalars['String']>;
  debitId?: InputMaybe<Scalars['String']>;
  isApproved?: InputMaybe<Scalars['Boolean']>;
  tabType?: InputMaybe<Scalars['String']>;
}>;


export type GetAllBillingIndoBySaleIdQuery = { __typename?: 'Query', getAllBillingBySaleId?: Array<{ __typename?: 'AllocationDetailOutput', id: string, table?: string | null, documentNo?: string | null, documentDate?: any | null, documentAmount?: number | null, description?: string | null, outstanding?: number | null, currentAllocate?: number | null, totalAllocateAmount?: number | null, enabledAllocate?: boolean | null, financialBillingId?: string | null, billItemName?: string | null, reverseDate?: any | null }> | null };

export type GetAllTypeBillingBySaleIdQueryVariables = Exact<{
  billItemId?: InputMaybe<Scalars['String']>;
  creditId?: InputMaybe<Scalars['String']>;
  mainTable: Scalars['String'];
  saleId: Scalars['String'];
  projectId?: InputMaybe<Scalars['String']>;
  tableFilter?: InputMaybe<Scalars['String']>;
  debitId?: InputMaybe<Scalars['String']>;
  isApproved?: InputMaybe<Scalars['Boolean']>;
  tableStatus?: InputMaybe<Scalars['String']>;
}>;


export type GetAllTypeBillingBySaleIdQuery = { __typename?: 'Query', getAllTypeBillingBySaleId?: Array<{ __typename?: 'AllocationDetailOutput', id: string, table?: string | null, name?: string | null, numRow?: number | null, documentNo?: string | null, documentDate?: any | null, documentAmount?: number | null, description?: string | null, outstanding?: number | null, currentAllocate?: number | null, totalAllocateAmount?: number | null, enabledAllocate?: boolean | null, financialBillingId?: string | null, billItemName?: string | null, reverseDate?: any | null, amount?: number | null, currentOutstanding?: number | null }> | null };

export type GetPaIndoPaymentSummaryListWPaginationQueryVariables = Exact<{
  projectId: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
  saleId?: InputMaybe<Scalars['String']>;
  pgnInput: PaginationInput;
}>;


export type GetPaIndoPaymentSummaryListWPaginationQuery = { __typename?: 'Query', getPAIndoPaymentSummaryListWPagination: { __typename?: 'getPAIndoPaymentSummaryOutput', totalDataLength: number, isHasMore: boolean, data: Array<{ __typename?: 'receiptEntity', id: string, saleId: string, documentDate: any, documentAmount: number, documentNo?: string | null, description: string, paymentMethod: string, creditCardType?: string | null, chequeDate?: any | null, chequeExpireDate?: any | null, documentRef?: string | null, receiptAmount: number, submittedBy?: string | null, submittedDate?: any | null, allowReversal: boolean, unallocatedAmount?: number | null, unallocatedAmountSummary?: number | null, taxData?: { __typename?: 'TaxSchemeDropdownOutput', taxSchemeName: string, totalTaxRate?: string | null } | null, taxLedger?: { __typename?: 'taxLedgerEntity', taxAmount: number } | null, submitUserData?: { __typename?: 'UserEntity', userName?: string | null, name?: string | null } | null, approveUserData?: { __typename?: 'UserEntity', userName?: string | null, name?: string | null } | null, bankAccount?: { __typename?: 'companyBankAccountEntity', code: string, accountNo: string, bankProfile: { __typename?: 'companyBankProfileEntity', name: string } } | null, attachment?: Array<{ __typename?: 'attachmentEntity', allowDelete?: boolean | null, fileName: string, id: string, isPrivate: boolean, mediaType: string, resourceUrl: string }> | null, clusterName?: { __typename?: 'projectClusterEntity', name: string } | null, salesRegNo?: { __typename?: 'saleExtensionEntity', salesRegistrationNo?: string | null } | null, allocationData?: Array<{ __typename?: 'AllocationData', allocationId?: string | null, allocateAmount?: number | null, allocationDate?: any | null, creditId?: string | null, debitId?: string | null, miscDescription?: string | null, debitNoteDescription?: string | null, installmentDescription?: string | null, packagesDescription?: string | null, carParkDescription?: string | null, lateInterestDescription?: string | null, documentNo?: string | null }> | null, sales?: { __typename?: 'saleEntity', unit: { __typename?: 'unitEntity', unitNo: string }, contact: { __typename?: 'contactEntity', fullName: string } } | null }> } };

export type GetPackageItemListingQueryVariables = Exact<{
  saleId: Scalars['String'];
}>;


export type GetPackageItemListingQuery = { __typename?: 'Query', getPackageItemListing?: Array<{ __typename?: 'paIndoPackageOutput', id?: string | null, sellingPrice?: number | null, itemName?: string | null, numRow?: number | null, totalOutstanding?: number | null, totalAllocated?: number | null, totalDocumentAmount?: number | null, packageId?: string | null }> | null };

export type GetPaIndoAdditionalDetailQueryVariables = Exact<{
  saleId: Scalars['String'];
  id: Scalars['String'];
}>;


export type GetPaIndoAdditionalDetailQuery = { __typename?: 'Query', getPaIndoAdditionalDetail?: Array<{ __typename?: 'paIndoPackageDetailOutput', id?: string | null, document_amount?: number | null, document_no?: string | null, outstanding?: number | null, total_allocated?: number | null, document_date?: any | null, creditTerm?: number | null, billType?: string | null }> | null };

export type GetPaIndoAddtionalPackagesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPaIndoAddtionalPackagesQuery = { __typename?: 'Query', getPAIndoAddtionalPackages: Array<{ __typename?: 'paIndoPackageListingOutput', sellingPrice?: number | null, unitName?: string | null, totalDocumentAmount?: number | null, totalOutstanding?: number | null, totalAllocated?: number | null, fullName?: string | null, saleId?: string | null, totalSalePackage?: number | null }> };

export type GetAllocationListingQueryVariables = Exact<{
  projectId: Scalars['String'];
  refTable: Scalars['String'];
  creditId: Scalars['String'];
}>;


export type GetAllocationListingQuery = { __typename?: 'Query', getAllocationListing?: Array<{ __typename?: 'allocationEntity', id: string, accountId: string, creditRefTable: string, creditId: string, allocateAmount: number, createdTs: any, debitRefTable: string, debitId: string, allowReversal: boolean, documentNo?: string | null, allocationDate?: any | null, originalId?: string | null }> | null };

export type ReversalAllocationMutationVariables = Exact<{
  projectId: Scalars['String'];
  creditId: Scalars['String'];
  debitId: Scalars['String'];
  allocationId: Scalars['String'];
  reversalDate: Scalars['String'];
  saleId: Scalars['String'];
}>;


export type ReversalAllocationMutation = { __typename?: 'Mutation', reversalAllocation: boolean };

export type GetCarParkUnitInstallmentQueryVariables = Exact<{
  saleId?: InputMaybe<Scalars['String']>;
}>;


export type GetCarParkUnitInstallmentQuery = { __typename?: 'Query', getCarParkUnitInstallment?: Array<{ __typename?: 'paIndoCarParkUnitOutput', totalDocumentAmount?: number | null, totalAllocated?: number | null, totalOutstanding?: number | null, unitId?: string | null, unitNo?: string | null, clusterName?: string | null, contactName?: string | null, installmentCount?: number | null }> | null };

export type GetCarParkInstallmentQueryVariables = Exact<{
  saleId?: InputMaybe<Scalars['String']>;
  unitId?: InputMaybe<Scalars['String']>;
}>;


export type GetCarParkInstallmentQuery = { __typename?: 'Query', getCarParkInstallment?: Array<{ __typename?: 'paIndoCarParkOutput', id?: string | null, sellingPrice?: number | null, itemName?: string | null, totalDocumentAmount?: number | null, totalAllocated?: number | null, totalOutstanding?: number | null, unitId?: string | null, unitNo?: string | null, clusterName?: string | null, contactName?: string | null }> | null };

export type GetCarParkInstallmentDetailQueryVariables = Exact<{
  saleId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
}>;


export type GetCarParkInstallmentDetailQuery = { __typename?: 'Query', getCarParkInstallmentDetail?: Array<{ __typename?: 'paIndoCarParkDetailOutput', id?: string | null, documentAmount?: number | null, documentNo?: string | null, outstanding?: number | null, totalAllocated?: number | null, documentDate?: any | null, creditTerm?: number | null, billType?: string | null }> | null };

export type GetPaIndoContraListQueryVariables = Exact<{
  projectId: Scalars['String'];
  saleId?: InputMaybe<Scalars['String']>;
}>;


export type GetPaIndoContraListQuery = { __typename?: 'Query', getPAIndoContraList: Array<{ __typename?: 'contraEntity', id: string, accountId: string, projectId: string, saleId: string, documentNo?: string | null, documentRef?: string | null, description: string, documentDate: any, documentAmount: number, requestedBy?: string | null, glGenerationBatch?: string | null, glGenerated: string, submittedBy?: string | null, submittedDate?: any | null, approvedBy?: string | null, approvedDate?: any | null, status: string, commonStatus: string, billItemId: string, voidBy?: string | null, voidDate?: any | null, allowReversal: boolean, refId?: string | null, ref_table?: string | null, unallocatedAmount?: number | null, unallocatedAmountSummary?: number | null }> };

export type GetPaIndoContraByIdQueryVariables = Exact<{
  projectId: Scalars['String'];
  id: Scalars['String'];
}>;


export type GetPaIndoContraByIdQuery = { __typename?: 'Query', getPAIndoContraById: { __typename?: 'contraEntity', id: string, accountId: string, projectId: string, saleId: string, documentNo?: string | null, documentRef?: string | null, description: string, documentDate: any, documentAmount: number, requestedBy?: string | null, glGenerationBatch?: string | null, glGenerated: string, submittedBy?: string | null, submittedDate?: any | null, approvedBy?: string | null, approvedDate?: any | null, status: string, commonStatus: string, billItemId: string, voidBy?: string | null, voidDate?: any | null, allowReversal: boolean, refId?: string | null, ref_table?: string | null, unallocatedAmount?: number | null, unallocatedAmountSummary?: number | null, deposit?: { __typename?: 'depositEntity', documentNo?: string | null } | null, submitUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null, userName?: string | null } | null, approveUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null, userName?: string | null } | null, voidUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null, userName?: string | null } | null } };

export type AllocationContraIndoMutationVariables = Exact<{
  input: AllocationContraInput;
}>;


export type AllocationContraIndoMutation = { __typename?: 'Mutation', allocationContraIndo: boolean };

export type GetPaIndoCreditNoteByIdQueryVariables = Exact<{
  projectId: Scalars['String'];
  id: Scalars['String'];
}>;


export type GetPaIndoCreditNoteByIdQuery = { __typename?: 'Query', getPAIndoCreditNoteById: { __typename?: 'creditNoteEntity', saleId: string, approvedBy?: string | null, approvedDate?: any | null, billItemId?: string | null, description?: string | null, documentAmount: number, documentDate: any, documentNo?: string | null, documentRef?: string | null, status: string, submittedDate?: any | null, unallocatedAmount?: number | null, voidDate?: any | null, unitDetail?: string | null, contactDetail?: string | null, attachment?: Array<{ __typename?: 'attachmentEntity', allowDelete?: boolean | null, fileName: string, id: string, isPrivate: boolean, mediaType: string, resourceUrl: string }> | null, billItemInt?: { __typename?: 'billItemIntEntity', billItemType: string, id: string, name: string } | null, requestUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, submitUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null, userName?: string | null } | null, approveUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null, userName?: string | null } | null, voidUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, taxData?: { __typename?: 'TaxSchemeDropdownOutput', taxSchemeId: string, taxSchemeName: string, effectiveDate: any, taxSchemeDetailId: string, totalTaxRate?: string | null, totalTaxAmount: number, isExclusive: boolean } | null, projectDetail?: { __typename?: 'projectEntity', name: string } | null, taxLedger?: { __typename?: 'taxLedgerEntity', taxAmount: number } | null, clusterName?: { __typename?: 'projectClusterEntity', name: string } | null } };

export type GetPaIndoDebitNoteByIdQueryVariables = Exact<{
  projectId: Scalars['String'];
  id: Scalars['String'];
}>;


export type GetPaIndoDebitNoteByIdQuery = { __typename?: 'Query', getPAIndoDebitNoteById: { __typename?: 'debitNoteEntity', saleId: string, approvedBy?: string | null, approvedDate?: any | null, billItemId?: string | null, creditTerm: number, description?: string | null, documentAmount: number, documentDate: any, documentNo?: string | null, documentRef?: string | null, dueDate: any, interestRate: number, isIncludeHoliday: boolean, status: string, submittedDate?: any | null, unallocatedAmount?: number | null, voidDate?: any | null, unitDetail?: string | null, contactDetail?: string | null, attachment?: Array<{ __typename?: 'attachmentEntity', allowDelete?: boolean | null, fileName: string, id: string, isPrivate: boolean, mediaType: string, resourceUrl: string }> | null, billItemInt?: { __typename?: 'billItemIntEntity', billItemType: string, id: string, name: string } | null, requestUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, submitUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null, userName?: string | null } | null, approveUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null, userName?: string | null } | null, voidUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, taxData?: { __typename?: 'TaxSchemeDropdownOutput', taxSchemeId: string, taxSchemeName: string, effectiveDate: any, taxSchemeDetailId: string, totalTaxRate?: string | null, totalTaxAmount: number, isExclusive: boolean } | null, projectDetail?: { __typename?: 'projectEntity', name: string } | null, taxLedger?: { __typename?: 'taxLedgerEntity', taxAmount: number } | null, clusterName?: { __typename?: 'projectClusterEntity', name: string } | null } };

export type GetPaIndoDepositByIdQueryVariables = Exact<{
  projectId: Scalars['String'];
  id: Scalars['String'];
}>;


export type GetPaIndoDepositByIdQuery = { __typename?: 'Query', getPAIndoDepositById: { __typename?: 'depositEntity', id: string, accountId: string, projectId: string, saleId: string, depositTypeId: string, paymentMethod: string, documentDate: any, documentAmount: number, documentRef?: string | null, description: string, bankAccountId: string, chequeNo?: string | null, status: string, submittedDate?: any | null, submittedBy?: string | null, approvedDate?: any | null, approvedBy?: string | null, commonStatus: string, voidDate?: any | null, voidBy?: string | null, documentNo?: string | null, chequeDate?: any | null, chequeExpireDate?: any | null, creditCardType?: string | null, outstanding?: number | null, unitDetail?: string | null, contactDetail?: string | null, attachment?: Array<{ __typename?: 'attachmentEntity', allowDelete?: boolean | null, fileName: string, id: string, isPrivate: boolean, mediaType: string, resourceUrl: string }> | null, billItemInt?: { __typename?: 'billItemIntEntity', billItemType: string, id: string, name: string } | null, submitUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null, userName?: string | null } | null, approveUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null, userName?: string | null } | null, voidUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null, userName?: string | null } | null, taxData?: { __typename?: 'TaxSchemeDropdownOutput', taxSchemeId: string, taxSchemeName: string, effectiveDate: any, taxSchemeDetailId: string, totalTaxRate?: string | null } | null, projectDetail?: { __typename?: 'UserEntity', name?: string | null } | null, taxLedger?: { __typename?: 'taxLedgerEntity', taxAmount: number } | null, bankAccount?: { __typename?: 'companyBankAccountEntity', id: string, code: string, accountNo: string, bankProfile: { __typename?: 'companyBankProfileEntity', name: string } } | null, clusterName?: { __typename?: 'projectClusterEntity', name: string } | null } };

export type CreatePaIndoDepositMutationVariables = Exact<{
  input: PaIndoDepositInput;
}>;


export type CreatePaIndoDepositMutation = { __typename?: 'Mutation', createPAIndoDeposit: boolean };

export type EditPaIndoDepositMutationVariables = Exact<{
  input: PaIndoEditDepositInput;
}>;


export type EditPaIndoDepositMutation = { __typename?: 'Mutation', editPAIndoDeposit: boolean };

export type ConvertToPaymentMutationVariables = Exact<{
  depositId: Scalars['String'];
  depositDate: Scalars['String'];
  documentAmount: Scalars['Float'];
}>;


export type ConvertToPaymentMutation = { __typename?: 'Mutation', convertToPayment: boolean };

export type GetLateInterestBySaleIdQueryVariables = Exact<{
  saleId: Scalars['String'];
  generationDate: Scalars['DateTime'];
}>;


export type GetLateInterestBySaleIdQuery = { __typename?: 'Query', getLateInterestBySaleId: { __typename?: 'lateInterestOutput', bankAccountNo?: number | null, bankAccountName?: string | null, mainUnitLateInterest: Array<{ __typename?: 'lateInterestBySaleIdOutput', saleId: string, installmentId?: string | null, dueDate?: any | null, description: string, documentDate?: any | null, allocationDate?: any | null, interestStartDate?: any | null, interestEndDate?: any | null, documentAmount: number, creditTerm: number, outstanding?: number | null, generateDate: any, overdueDay?: number | null, interestAmount?: number | null }>, carParkLateInterest: Array<{ __typename?: 'lateInterestBySaleIdOutput', saleId: string, installmentId?: string | null, dueDate?: any | null, description: string, documentDate?: any | null, allocationDate?: any | null, interestStartDate?: any | null, interestEndDate?: any | null, documentAmount: number, creditTerm: number, outstanding?: number | null, generateDate: any, overdueDay?: number | null, interestAmount?: number | null }>, packagesLateInterest: Array<{ __typename?: 'lateInterestBySaleIdOutput', saleId: string, installmentId?: string | null, dueDate?: any | null, description: string, documentDate?: any | null, allocationDate?: any | null, interestStartDate?: any | null, interestEndDate?: any | null, documentAmount: number, creditTerm: number, outstanding?: number | null, generateDate: any, overdueDay?: number | null, interestAmount?: number | null }>, miscBillingLateInterest: Array<{ __typename?: 'lateInterestBySaleIdOutput', saleId: string, installmentId?: string | null, dueDate?: any | null, description: string, documentDate?: any | null, allocationDate?: any | null, interestStartDate?: any | null, interestEndDate?: any | null, documentAmount: number, creditTerm: number, outstanding?: number | null, generateDate: any, overdueDay?: number | null, interestAmount?: number | null }> } };

export type GetListLateInterestQueryVariables = Exact<{
  saleId: Scalars['String'];
}>;


export type GetListLateInterestQuery = { __typename?: 'Query', getListLateInterest: Array<{ __typename?: 'LateListInterestOutput', id: string, accountId: string, projectId: string, saleId: string, documentNo?: string | null, documentDate: any, documentAmount: number, totalNegotiateAmt: number, totalWaiveAmt: number, description: string, bankAccount?: string | null, status: string, submittedDate?: any | null, submittedBy?: string | null, voidDate?: any | null, voidBy?: string | null, approvedDate?: any | null, approvedBy?: string | null, glGenerationBatch?: string | null, glGenerated?: string | null, commonStatus: string, totalCharges: number, totalUnallocated: number, submitUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null }> };

export type GetPaIndoLateInterestListingQueryVariables = Exact<{
  projectId: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
}>;


export type GetPaIndoLateInterestListingQuery = { __typename?: 'Query', getPAIndoLateInterestListing: Array<{ __typename?: 'PAIndoLateInterestListingOutput', id: string, projectId: string, saleId: string, debitId?: string | null, allocateAmount?: number | null, documentDate: any, documentNo?: string | null, description?: string | null, documentAmount: number, totalNegotiateAmt: number, bankAccount?: string | null, submittedDate?: any | null, submittedBy: string, totalWaiveAmt: number, fullName: string, unitNo: string, clusterName: string, submitUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null }> };

export type GetLateInterestsDetailQueryVariables = Exact<{
  saleId: Scalars['String'];
  lateInterestId: Scalars['String'];
}>;


export type GetLateInterestsDetailQuery = { __typename?: 'Query', getLateInterestsDetail: Array<{ __typename?: 'lateInterestDetailEntity', saleId: string, dueDate?: any | null, overdueDay: number, description: string, documentDate?: any | null, documentAmount: number, creditTerm?: number | null, interestStartDate: any, interestEndDate?: any | null, interestAmount: number, submittedDate?: any | null, refTable: string, refId: string, waiveAmt: number }> };

export type GenerateLatePaymentInterestMutationVariables = Exact<{
  saleId: Scalars['String'];
  status: Scalars['String'];
  generationDate: Scalars['DateTime'];
  unitNegotiatedAmount: Scalars['Float'];
  carParkNegotiatedAmount: Scalars['Float'];
  packagesNegotiatedAmount: Scalars['Float'];
  miscBillingNegotiatedAmount: Scalars['Float'];
}>;


export type GenerateLatePaymentInterestMutation = { __typename?: 'Mutation', generateLatePaymentInterest: boolean };

export type ApproveLateInterestsByIdMutationVariables = Exact<{
  saleId: Scalars['String'];
  lateInterestId: Scalars['String'];
}>;


export type ApproveLateInterestsByIdMutation = { __typename?: 'Mutation', approveLateInterestsById: boolean };

export type RejectLateInterestsByIdMutationVariables = Exact<{
  saleId: Scalars['String'];
  lateInterestId: Scalars['String'];
}>;


export type RejectLateInterestsByIdMutation = { __typename?: 'Mutation', rejectLateInterestsById: boolean };

export type UpdateLateInterestsByIdMutationVariables = Exact<{
  saleId: Scalars['String'];
  lateInterestId: Scalars['String'];
  status: Scalars['String'];
  generationDate: Scalars['DateTime'];
  unitNegotiatedAmount: Scalars['Float'];
  carParkNegotiatedAmount: Scalars['Float'];
  packagesNegotiatedAmount: Scalars['Float'];
  miscBillingNegotiatedAmount: Scalars['Float'];
}>;


export type UpdateLateInterestsByIdMutation = { __typename?: 'Mutation', updateLateInterestsById: boolean };

export type GetPaIndomiscBillingByIdQueryVariables = Exact<{
  projectId: Scalars['String'];
  id: Scalars['String'];
}>;


export type GetPaIndomiscBillingByIdQuery = { __typename?: 'Query', getPAIndomiscBillingById: { __typename?: 'miscBillingEntity', saleId: string, approvedBy?: string | null, approvedDate?: any | null, billItemId: string, creditTerm: number, description: string, documentAmount: number, documentDate: any, documentNo?: string | null, documentRef?: string | null, dueDate: any, interestRate?: number | null, isIncludeHoliday: boolean, status: string, submittedDate?: any | null, unallocatedAmount?: number | null, voidDate?: any | null, unitDetail?: string | null, contactDetail?: string | null, attachment?: Array<{ __typename?: 'attachmentEntity', allowDelete?: boolean | null, fileName: string, id: string, isPrivate: boolean, mediaType: string, resourceUrl: string }> | null, billItemInt?: { __typename?: 'billItemIntEntity', billItemType: string, id: string, name: string } | null, requestUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, submitUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null, userName?: string | null } | null, approveUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null, userName?: string | null } | null, voidUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, taxData?: { __typename?: 'TaxSchemeDropdownOutput', taxSchemeId: string, taxSchemeName: string, effectiveDate: any, taxSchemeDetailId: string, totalTaxRate?: string | null, totalTaxAmount: number, isExclusive: boolean } | null, projectDetail?: { __typename?: 'UserEntity', name?: string | null } | null, taxLedger?: { __typename?: 'taxLedgerEntity', taxAmount: number } | null, clusterName?: { __typename?: 'projectClusterEntity', name: string } | null } };

export type EditPaIndoMiscBillingMutationVariables = Exact<{
  isSubmitted: Scalars['Boolean'];
  input: EditPaMiscBillingInput;
}>;


export type EditPaIndoMiscBillingMutation = { __typename?: 'Mutation', editPAmiscBilling: boolean };

export type CalculateMiscBillingTaxAmountQueryVariables = Exact<{
  input: CalculateMiscBillingTaxAmountInput;
}>;


export type CalculateMiscBillingTaxAmountQuery = { __typename?: 'Query', calculateMiscBillingTaxAmount: any };

export type GetPaIndoPaymentByIdQueryVariables = Exact<{
  projectId: Scalars['String'];
  id: Scalars['String'];
}>;


export type GetPaIndoPaymentByIdQuery = { __typename?: 'Query', getPAIndoPaymentById: { __typename?: 'receiptEntity', saleId: string, approvedBy?: string | null, approvedDate?: any | null, description: string, documentAmount: number, documentDate: any, documentNo?: string | null, documentRef?: string | null, status: string, submittedDate?: any | null, unallocatedAmount?: number | null, paymentMethod: string, receiptAmount: number, chequeDate?: any | null, chequeExpireDate?: any | null, creditCardType?: string | null, bankAccountId?: string | null, voidDate?: any | null, unitDetail?: string | null, contactDetail?: string | null, attachment?: Array<{ __typename?: 'attachmentEntity', allowDelete?: boolean | null, fileName: string, id: string, isPrivate: boolean, mediaType: string, resourceUrl: string }> | null, submitUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null, userName?: string | null } | null, approveUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null, userName?: string | null } | null, voidUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, taxData?: { __typename?: 'TaxSchemeDropdownOutput', taxSchemeId: string, taxSchemeName: string, effectiveDate: any, taxSchemeDetailId: string, totalTaxRate?: string | null } | null, projectDetail?: { __typename?: 'UserEntity', name?: string | null } | null, taxLedger?: { __typename?: 'taxLedgerEntity', taxAmount: number } | null, bankAccount?: { __typename?: 'companyBankAccountEntity', id: string, code: string, accountNo: string, bankProfile: { __typename?: 'companyBankProfileEntity', name: string } } | null, clusterName?: { __typename?: 'projectClusterEntity', name: string } | null, salesRegNo?: { __typename?: 'saleExtensionEntity', salesRegistrationNo?: string | null, salesRegistrationDate?: any | null } | null } };

export type AllocationReceiptIndoMutationVariables = Exact<{
  input: AllocationInputIndo;
}>;


export type AllocationReceiptIndoMutation = { __typename?: 'Mutation', allocationReceiptIndo: boolean };

export type GetPaymentELetterTemplateListingQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetPaymentELetterTemplateListingQuery = { __typename?: 'Query', getPaymentELetterTemplateListing?: Array<{ __typename?: 'paymentEletterTemplateOutput', id: string, name: string, letterType: string, defaulted: boolean }> | null };

export type GetPaymentELetterQueryVariables = Exact<{
  letterTemplateId: Scalars['String'];
  receiptId: Scalars['String'];
}>;


export type GetPaymentELetterQuery = { __typename?: 'Query', getPaymentELetter: { __typename?: 'paymentELetterOutput', content: string, fileName: string } };

export type GetPaIndoPaymentReminderBySaleIdQueryVariables = Exact<{
  saleId: Scalars['String'];
}>;


export type GetPaIndoPaymentReminderBySaleIdQuery = { __typename?: 'Query', getPaymentReminderBySaleId: Array<{ __typename?: 'paPaymentReminderListingOutput', unitNo: string, saleId: string, reminderDate: any, generationBatch: string, paymentReminderDetails?: Array<{ __typename?: 'paPaymentReminderDetails', documentNo: string, documentDate: any, dueDate: any, balanceAmount: number, reminderSeq: number }> | null }> };

export type GetPaIndoAllPaymentReminderQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPaIndoAllPaymentReminderQuery = { __typename?: 'Query', getAllPaymentReminder?: Array<{ __typename?: 'paymentReminderListingOutput', unitNo: Array<string>, reminder1: number, reminder2: number, reminder3: number, reminderDate: any, balanceAmount: number, generationBatch: string }> | null };

export type GetPurchaserInstallmentListingQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetPurchaserInstallmentListingQuery = { __typename?: 'Query', getPurchaserInstallmentListing?: Array<{ __typename?: 'paIndoPurchaserInstallmentListingOutput', saleId?: string | null, fullName?: string | null, clusterName?: string | null, unitNo?: string | null, totalDocAmt?: number | null, totalUnallocatedAmt?: number | null, salesRegistrationDate?: any | null, salesNo?: string | null, salesRegistrationNo?: string | null }> | null };

export type GetPurchaserInstallmentQueryVariables = Exact<{
  projectId: Scalars['String'];
  saleId: Scalars['String'];
}>;


export type GetPurchaserInstallmentQuery = { __typename?: 'Query', getPurchaserInstallment?: Array<{ __typename?: 'installmentEntity', id: string, saleId: string, transDate?: any | null, documentDate?: any | null, documentAmt?: number | null, billType?: string | null, unallocatedAmount?: number | null, description?: string | null, sale: { __typename?: 'saleEntity', saleExtension?: { __typename?: 'saleExtensionEntity', creditTerm?: number | null } | null } }> | null };

export type GetPaIndoRebateByIdQueryVariables = Exact<{
  projectId: Scalars['String'];
  id: Scalars['String'];
}>;


export type GetPaIndoRebateByIdQuery = { __typename?: 'Query', getPAIndoRebateById: { __typename?: 'rebateEntity', saleId: string, approvedBy?: string | null, approvedDate?: any | null, billItemId: string, description?: string | null, documentAmount: number, documentDate: any, documentNo?: string | null, documentRef?: string | null, status: string, submittedDate?: any | null, unallocatedAmount?: number | null, voidDate?: any | null, unitDetail?: string | null, contactDetail?: string | null, attachment?: Array<{ __typename?: 'attachmentEntity', allowDelete?: boolean | null, fileName: string, id: string, isPrivate: boolean, mediaType: string, resourceUrl: string }> | null, billItemInt?: { __typename?: 'billItemIntEntity', billItemType: string, id: string, name: string } | null, requestUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, submitUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null, userName?: string | null } | null, approveUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null, userName?: string | null } | null, voidUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, taxData?: { __typename?: 'TaxSchemeDropdownOutput', taxSchemeId: string, taxSchemeName: string, effectiveDate: any, taxSchemeDetailId: string, totalTaxRate?: string | null, totalTaxAmount: number, isExclusive: boolean } | null, projectDetail?: { __typename?: 'projectEntity', name: string } | null, taxLedger?: { __typename?: 'taxLedgerEntity', taxAmount: number } | null, clusterName?: { __typename?: 'projectClusterEntity', name: string } | null } };

export type GetPaIndoRefundByIdQueryVariables = Exact<{
  projectId: Scalars['String'];
  id: Scalars['String'];
}>;


export type GetPaIndoRefundByIdQuery = { __typename?: 'Query', getPAIndoRefundById: { __typename?: 'refundEntity', saleId: string, approvedBy?: string | null, approvedDate?: any | null, description: string, documentAmount: number, documentDate: any, documentNo?: string | null, documentRef?: string | null, status: string, submittedDate?: any | null, unallocatedAmount?: number | null, refundMethod: string, chequeDate?: any | null, chequeExpireDate?: any | null, creditCardType?: string | null, bankAccountId?: string | null, unitDetail?: string | null, contactDetail?: string | null, attachment?: Array<{ __typename?: 'attachmentEntity', allowDelete?: boolean | null, fileName: string, id: string, isPrivate: boolean, mediaType: string, resourceUrl: string }> | null, submitUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, approveUserData?: { __typename?: 'UserEntity', ID: string, name?: string | null } | null, taxData?: { __typename?: 'TaxSchemeDropdownOutput', taxSchemeId: string, taxSchemeName: string, effectiveDate: any, taxSchemeDetailId: string, totalTaxRate?: string | null } | null, projectDetail?: { __typename?: 'projectEntity', name: string } | null, taxLedger?: { __typename?: 'taxLedgerEntity', taxAmount: number } | null, bankAccount?: { __typename?: 'companyBankAccountEntity', id: string, code: string, accountNo: string, bankProfile: { __typename?: 'companyBankProfileEntity', name: string } } | null, clusterName?: { __typename?: 'projectClusterEntity', name: string } | null } };

export type PostingRefundMutationVariables = Exact<{
  input: PostingInput;
}>;


export type PostingRefundMutation = { __typename?: 'Mutation', postingRefund: boolean };

export type GetUnitListTransferQueryVariables = Exact<{
  projectId: Scalars['String'];
  unitTransferId?: InputMaybe<Scalars['String']>;
}>;


export type GetUnitListTransferQuery = { __typename?: 'Query', getUnitListTransfer: Array<{ __typename?: 'unitListOutput', saleId: string, unitId: string, unitNo: string, documentAmount?: number | null, documentNo: string, miscBillingId?: string | null, oldContactId: string, fullName: string, email: string, phoneNo: string, icNo: string }> };

export type GetPurchaserTransferListQueryVariables = Exact<{
  projectId: Scalars['String'];
  approvalStatus: Scalars['String'];
}>;


export type GetPurchaserTransferListQuery = { __typename?: 'Query', getPurchaserTransferList: Array<{ __typename?: 'purchaserTransferOutput', id: string, unitNo: string, approvalStatus: string, adminFee: number, transferDate: any, saleId: string }> };

export type GetPurchaserNameByIdQueryVariables = Exact<{
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  purchaserNameTransferId: Scalars['String'];
}>;


export type GetPurchaserNameByIdQuery = { __typename?: 'Query', getPurchaserNameById: { __typename?: 'getPurchaserNameByIdOutput', purchaserNameTransferId?: string | null, saleId: string, unitId: string, adminFee: number, unitClusterId: string, unitNo: string, salesConvertedStatus: string, status?: string | null, miscBillingId?: string | null, documentAmount?: number | null, documentNo: string, oldContactId: string, fullName: string, email: string, phoneNo: string, icNo: string, buyerList?: Array<{ __typename?: 'buyerListOutput', IsPrincipalBuyer: boolean, detailId: string, email: string, gender: string, dateOfBirth?: any | null, incomeRange?: string | null, homeTelNo?: string | null, identityNo: string, maritalStatus: string, mobileNo: string, name: string, nationality: string, officeTelNo?: string | null, profession?: string | null, religion?: string | null, salutation?: string | null, commonStatus?: string | null, address?: { __typename?: 'AddressJson', address?: string | null, address2?: string | null, country?: string | null, city?: string | null, district?: string | null, subdistrict?: string | null, state?: string | null, postCode?: string | null, postCodeName?: string | null, AddressType?: string | null, isPrimary?: boolean | null } | null, addressList?: Array<{ __typename?: 'addressList', isPrimary: boolean, addressType: string, address?: { __typename?: 'AddressJson', address?: string | null, address2?: string | null, country?: string | null, city?: string | null, district?: string | null, subdistrict?: string | null, state?: string | null, postCode?: string | null, postCodeName?: string | null, AddressType?: string | null, isPrimary?: boolean | null } | null }> | null, contactExt?: { __typename?: 'contactExti', IsVip: boolean, contactExtId: string, identityType: string, mailingMethod: string, remark?: string | null, subscribeMaterialEmail: boolean, subscribeMaterialPaNews: boolean, subscribeMaterialSms: boolean, subscribeMaterialWhatsapp: boolean } | null, tax?: { __typename?: 'tax', nameTax?: string | null, taxRegNo?: string | null, taxAddress?: string | null } | null }> | null } };

export type GetBuyerListBySaleIdQueryVariables = Exact<{
  projectId: Scalars['String'];
  saleId: Scalars['String'];
}>;


export type GetBuyerListBySaleIdQuery = { __typename?: 'Query', getBuyerListBySaleId: Array<{ __typename?: 'buyerListOutput', IsPrincipalBuyer: boolean, detailId: string, email: string, gender: string, homeTelNo?: string | null, identityNo: string, maritalStatus: string, mobileNo: string, name: string, nationality: string, officeTelNo?: string | null, profession?: string | null, religion?: string | null, salutation?: string | null, commonStatus?: string | null, address?: { __typename?: 'AddressJson', address?: string | null, address2?: string | null, country?: string | null, city?: string | null, district?: string | null, subdistrict?: string | null, state?: string | null, postCode?: string | null, postCodeName?: string | null, AddressType?: string | null, isPrimary?: boolean | null } | null, addressList?: Array<{ __typename?: 'addressList', isPrimary: boolean, addressType: string, address?: { __typename?: 'AddressJson', address?: string | null, address2?: string | null, country?: string | null, city?: string | null, district?: string | null, subdistrict?: string | null, state?: string | null, postCode?: string | null, postCodeName?: string | null, AddressType?: string | null, isPrimary?: boolean | null } | null }> | null, contactExt?: { __typename?: 'contactExti', IsVip: boolean, contactExtId: string, identityType: string, mailingMethod: string, remark?: string | null, subscribeMaterialEmail: boolean, subscribeMaterialPaNews: boolean, subscribeMaterialSms: boolean, subscribeMaterialWhatsapp: boolean } | null, tax?: { __typename?: 'tax', nameTax?: string | null, taxRegNo?: string | null, taxAddress?: string | null } | null }> };

export type SaveDraftPurchaserTransferMutationVariables = Exact<{
  input: AddPurchaserTransferInput;
}>;


export type SaveDraftPurchaserTransferMutation = { __typename?: 'Mutation', saveDraftPurchaserTransfer: boolean };

export type ApprovedPurchaserTransferMutationVariables = Exact<{
  input: AddPurchaserTransferInput;
}>;


export type ApprovedPurchaserTransferMutation = { __typename?: 'Mutation', approvedPurchaserTransfer: boolean };

export type ApprovedPurchaserTransferInListingMutationVariables = Exact<{
  input: ApprovedPurchaserInListingInput;
}>;


export type ApprovedPurchaserTransferInListingMutation = { __typename?: 'Mutation', approvedPurchaserTransferInListing: boolean };

export type CancelPurchaserTransferMutationVariables = Exact<{
  input: CancelPurchaserTransferInput;
}>;


export type CancelPurchaserTransferMutation = { __typename?: 'Mutation', cancelPurchaserTransfer: boolean };

export type GetSalesLoanRefinancingListQueryVariables = Exact<{
  approvalStatus: Scalars['String'];
  projectId: Scalars['String'];
}>;


export type GetSalesLoanRefinancingListQuery = { __typename?: 'Query', getSalesLoanRefinancingList?: Array<{ __typename?: 'refinancingListOutput', id: string, projectId: string, approvalStatus: string, unitNo: string, fullName: string, newFinancier: string, refinancingDate: any, oldFinancier: string, refinancingNo?: string | null }> | null };

export type GetRefinancingDetailsByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetRefinancingDetailsByIdQuery = { __typename?: 'Query', getRefinancingDetailsById: { __typename?: 'refinancingListOutput', id: string, saleId: string, projectId: string, approvalStatus: string, unitNo: string, fullName: string, newFinancier: string, refinancingDate: any, oldFinancier: string, borrowerName: string, mortgageName: string, borrowerAcct: string, remarks: string, submittedBy?: string | null, submittedDate?: any | null, approvedBy?: string | null, approvedDate?: any | null, endfinancierMortgageId: string, loanRefRecordId: string, loanRefTable: string, newFinancierId: string, oldFinancierId: string, refinancingNo?: string | null, oldBalance: Array<{ __typename?: 'OldBalance', event_name: string, old_balance: number, net_balance?: number | null, endfin_mortgage_payment_id?: string | null, retentions?: Array<any> | null }>, newPaymentPlan: Array<{ __typename?: 'NewPaymentPlan', event_item: string, event_amt: number, event_estimate_date: string, endfin_mortgage_payment_id?: string | null, endfin_mortgage_retention_id?: string | null }> } };

export type ApproveRefinancingMutationVariables = Exact<{
  refinancingId: Scalars['String'];
  projectId: Scalars['String'];
}>;


export type ApproveRefinancingMutation = { __typename?: 'Mutation', approveRefinancing: boolean };

export type GetRefinancingMasterDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRefinancingMasterDataQuery = { __typename?: 'Query', getRefinancingMasterData: { __typename?: 'refinancingDataOutput', unitList: Array<{ __typename?: 'refinancingUnitList', sale_id: string, unitNo: string, borrower_name: string, borrower_acct?: string | null, full_name: string, name: string, endfinancier_mortgage_plan_id?: string | null, loan_sign_date?: any | null, table_ref: string, sale_loan_id: string, old_balance?: Array<any> | null, saleLoanPayment?: Array<{ __typename?: 'salePaymentOutput', paymentId?: string | null, loanAmt?: number | null, netAmt?: number | null, saleLoanId?: string | null, endfinMortgagePaymentId?: string | null, paymentName: string, constructionDate: any, loanSignDate: any, expectedCount: number, expectedFreq: string, expectedFrom: string, saleLoanRetention?: Array<{ __typename?: 'saleRetentionOutput', retentionId?: string | null, retentionName: string, retentionValue?: number | null, saleLoanPaymentId?: string | null, endfinMortgageRetentionId?: string | null, constructionDate: any, loanSignDate: any, expectedCount: number, expectedFreq: string, expectedFrom: string }> | null }> | null }>, financierLists: Array<{ __typename?: 'financierLists', newFinancierId: string, financierName: string }> } };

export type GetMortgageDataQueryVariables = Exact<{
  newFinancierId: Scalars['String'];
  prevMortgageId: Scalars['String'];
}>;


export type GetMortgageDataQuery = { __typename?: 'Query', getMortgageData: Array<{ __typename?: 'mortgagePlanEntity', id: string, financierId: string, name: string }> };

export type GetPaymentPlanQueryVariables = Exact<{
  mortgageId: Scalars['String'];
}>;


export type GetPaymentPlanQuery = { __typename?: 'Query', getPaymentPlan: Array<{ __typename?: 'mortgageRetentionEntity', id: string, endfinMortgagePaymentId: string, name: string, eventItem?: string | null }> };

export type GetNewPaymentPlanQueryVariables = Exact<{
  mortgageId: Scalars['String'];
}>;


export type GetNewPaymentPlanQuery = { __typename?: 'Query', getNewPaymentPlan: Array<{ __typename?: 'saleRefinancingNewPaymentPlanOutput', id?: string | null, endfinMortgagePaymentId?: string | null, endfinMortgageRetentionId?: string | null, name?: string | null, eventItem?: string | null }> };

export type AddSaleLoanRefinancingMutationVariables = Exact<{
  input: AddSaleLoanRefinancingInput;
}>;


export type AddSaleLoanRefinancingMutation = { __typename?: 'Mutation', addSaleLoanRefinancing: boolean };

export type EditSaleLoanRefinancingMutationVariables = Exact<{
  input: EditSaleLoanRefinancingInput;
}>;


export type EditSaleLoanRefinancingMutation = { __typename?: 'Mutation', editSaleLoanRefinancing: boolean };

export type DeleteSaleLoanRefinancingMutationVariables = Exact<{
  refinancingId: Scalars['String'];
}>;


export type DeleteSaleLoanRefinancingMutation = { __typename?: 'Mutation', deleteSaleLoanRefinancing: boolean };

export type GetSaleRefinancingCountQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetSaleRefinancingCountQuery = { __typename?: 'Query', getSaleRefinancingCount: { __typename?: 'saleRefinancingCountOutput', draftCount?: number | null, submittedCount?: number | null, approvedCount?: number | null } };

export type GetRoundingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRoundingQuery = { __typename?: 'Query', getRounding: { __typename?: 'roundingOutput', roundingMode: Array<{ __typename?: 'roundingListingOutput', id: string, name: string }>, roundingPrecision: Array<{ __typename?: 'roundingListingOutput', id: string, name: string }> } };

export type GetAllSpaReminderQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllSpaReminderQuery = { __typename?: 'Query', getAllSpaReminder?: Array<{ __typename?: 'saleReminderListingOutput', reminderDate: any, reminder1: number, reminder2: number, reminder3: number, generationBatch?: string | null, unitNo: Array<string> }> | null };

export type GenerateReminderSaleListMutationVariables = Exact<{
  reminderDate: Scalars['DateTime'];
}>;


export type GenerateReminderSaleListMutation = { __typename?: 'Mutation', generateReminderSaleList?: { __typename?: 'saleReminderDetailOutput', reminder1: number, reminder2: number, reminder3: number, reminderDetailList: Array<{ __typename?: 'reminderDetaiListOutput', reminderId: string, saleId: string, isCompany?: boolean | null, companyName?: string | null, unitNo: string, bookDate: number, reminderSeq: number, reminderDate?: number | null, buyerName: string, share?: Array<{ __typename?: 'shareObject', sharedBy: string, sharedDateTime: string, sharedMethod?: string | null }> | null }> } | null };

export type GetSpaReminderByIdQueryVariables = Exact<{
  reminderDate: Scalars['DateTime'];
  generationBatch: Scalars['String'];
}>;


export type GetSpaReminderByIdQuery = { __typename?: 'Query', getSpaReminderById?: { __typename?: 'saleReminderDetailOutput', reminder1: number, reminder2: number, reminder3: number, reminderDetailList: Array<{ __typename?: 'reminderDetaiListOutput', reminderId: string, saleId: string, unitNo: string, bookDate: number, reminderSeq: number, reminderDate?: number | null, buyerName: string, isCompany?: boolean | null, companyName?: string | null, share?: Array<{ __typename?: 'shareObject', sharedBy: string, sharedDateTime: string, sharedMethod?: string | null }> | null }> } | null };

export type ShareSpaReminderMutationVariables = Exact<{
  input: ReminderInput;
}>;


export type ShareSpaReminderMutation = { __typename?: 'Mutation', shareSpaReminder: { __typename?: 'reminderOutput', downloadFile: boolean, isProject?: boolean | null, letterTemplateList?: Array<{ __typename?: 'shareLetterTemplateOutput', letterTemplateId: string, letterTemplateName: string }> | null } };

export type ShareSpaReminderByLetterTemplateIdMutationVariables = Exact<{
  input: ShareSpaReminderByIdInput;
}>;


export type ShareSpaReminderByLetterTemplateIdMutation = { __typename?: 'Mutation', shareSpaReminderByLetterTemplateId: boolean };

export type GetSalesAdminSettingSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSalesAdminSettingSummaryQuery = { __typename?: 'Query', getProjectName?: string | null, spReminderCount?: number | null, downpaymentReminderCount?: number | null, bankLoanUnitCount?: number | null, bankLoanTotalAmount?: number | null, purchaserAccountsCount?: number | null, propertyTitleUnitCount?: number | null, totalPropertyTitleUnitCount?: number | null, unitsVpLetterCount?: number | null, areaVariancePolicyIndonesiaLastUpdate?: any | null, areaVarianceIndonesiaLastUpdate?: any | null, areaVarianceIndonesiaCount?: number | null, rescheduleInstallmentLastUpdate?: any | null, rescheduleInstallmentSubmittedCount?: number | null, motTrackingCount?: number | null, totalMotUnitCount?: number | null, subsaleCount?: number | null, totalBridgingFinancing?: number | null, totalRedemption?: number | null, saleContractSummary?: { __typename?: 'saleContractInfoLine', totalBooked?: number | null, totalSigned?: number | null, totalCancelled?: number | null } | null, saleCancellationSummary?: { __typename?: 'saleCancellationInfoLine', count?: number | null, totalForfeitureSum?: number | null } | null, unitTransferSummary?: { __typename?: 'unitTransferInfoLine', totalDraft?: number | null, totalSubmitted?: number | null } | null, collectionSummary?: { __typename?: 'collectionInfoLine', totalDraft?: number | null, totalSubmitted?: number | null, totalApproved?: number | null } | null, stakeholderCount?: { __typename?: 'stakeholderSummaryOutput', totalAmt?: number | null, totalDeemCollected?: number | null, totalReleaseAmt?: number | null } | null, areaVarianceSummaryIndonesia?: { __typename?: 'areaVarianceSummaryIndonesiaOutput', count?: number | null, nettBuiltUp?: number | null, totalCompensate?: number | null } | null, ladSummary?: { __typename?: 'ladSummaryOutput', totalCount?: number | null, totalUnitAmount?: number | null, totalFacilityAmount?: number | null, totalAmount?: number | null } | null, keyCollectionCount?: { __typename?: 'keyCollectionSummaryOutput', totalCount?: number | null, totalCompletedCount?: number | null } | null, saleLandDepositSummary?: { __typename?: 'SaleLandDepositInfoLine', showMenu?: boolean | null, outstandingCount?: number | null } | null };

export type GetAllProjectCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllProjectCountQuery = { __typename?: 'Query', getAllProjectCount: number };

export type GetSalesCancellationListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSalesCancellationListQuery = { __typename?: 'Query', getSalesCancellationStatus: Array<string>, getSalesCancellationList: Array<{ __typename?: 'saleCancellationSharedOutput', id: string, cancellationDate?: any | null, status: string, salesRegistrationNo?: string | null, clusterName: string, unitId: string, unitNo?: string | null, sellingPrice?: number | null, purchaserName?: string | null, cancellationReason?: string | null, salesNo: string, refundAmt?: number | null, paidToDate?: number | null }> };

export type GetSalesCancellationByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetSalesCancellationByIdQuery = { __typename?: 'Query', getSalesCancellationById: { __typename?: 'saleCancellationSharedOutput', cancellationDate?: any | null, completedBy?: string | null, saleId: string, status: string, unitId: string, unitNo?: string | null, sellingPrice?: number | null, bookDate?: any | null, contactId: string, purchaserName?: string | null, forfeitureSum?: number | null, taxSchemeId: string, cancellationReasonId: string, cancellationReason?: string | null, remarks?: string | null, totalRefundableAmount?: number | null, taxToDate?: number | null, taxToDateAmount?: number | null, finalTaxToDate?: number | null, finalTaxToDateAmount?: number | null, refundAmt?: number | null, refundTax?: boolean | null, chargeFinalTax?: boolean | null, salesNo: string, paidToDate?: number | null, buyBackAmount?: number | null } };

export type GetUnitsForSalesCancelQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnitsForSalesCancelQuery = { __typename?: 'Query', getUnitsForSalesCancel: Array<{ __typename?: 'unitsSignedOutput', saleId: string, saleStatus: string, bookDate?: any | null, unitId: string, unitNo: string, unitStatus: string, contactId: string, purchaserName: string, isCompany?: boolean | null, companyName?: string | null, sellingPrice?: number | null, taxSchemeId?: string | null, totalRefundableAmount?: number | null, paidToDate?: number | null, taxToDate?: number | null, finalTaxToDate?: number | null, buyBackAmt?: number | null, salesRegistrationDate?: any | null }> };

export type GetUnitDetailQueryVariables = Exact<{
  unitId: Scalars['String'];
}>;


export type GetUnitDetailQuery = { __typename?: 'Query', GetUnitDetail: { __typename?: 'unitEntity', id: string, unitNo: string, unitStatus: string, price: number, builtUp: number, landArea?: string | null } };

export type AddSalesCancellationMutationVariables = Exact<{
  input: AddSalesCancellationInput;
}>;


export type AddSalesCancellationMutation = { __typename?: 'Mutation', addSalesCancellation: boolean };

export type EditSalesCancellationMutationVariables = Exact<{
  input: EditSalesCancellationInput;
}>;


export type EditSalesCancellationMutation = { __typename?: 'Mutation', editSalesCancellation: boolean };

export type DeleteSalesCancellationMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteSalesCancellationMutation = { __typename?: 'Mutation', deleteSalesCancellation: boolean };

export type UpdateSalesCancellationStatusMutationVariables = Exact<{
  input: UpdateStatusCancellationInput;
}>;


export type UpdateSalesCancellationStatusMutation = { __typename?: 'Mutation', updateSalesCancellationStatus: boolean };

export type ApproveSalesCancellationMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;


export type ApproveSalesCancellationMutation = { __typename?: 'Mutation', approveSalesCancellation: boolean };

export type RejectSalesCancellationMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;


export type RejectSalesCancellationMutation = { __typename?: 'Mutation', rejectSalesCancellation: boolean };

export type GetSaleCancelReasonQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSaleCancelReasonQuery = { __typename?: 'Query', getSaleCancelReason: Array<{ __typename?: 'reasonCodeEntity', id: string, name: string, defaulted: boolean }> };

export type GetSalesCancellationELetterQueryVariables = Exact<{
  saleCancellationId: Scalars['String'];
  letterTemplateId: Scalars['String'];
}>;


export type GetSalesCancellationELetterQuery = { __typename?: 'Query', getSalesCancellationELetter: { __typename?: 'SalesELetterOutput', content?: string | null, fileName?: string | null } };

export type GetSalesCancellationELetterTemplateListingQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetSalesCancellationELetterTemplateListingQuery = { __typename?: 'Query', getSalesCancellationELetterTemplateListing?: Array<{ __typename?: 'SalesCancellationEletterTemplateOutput', id: string, name: string, letterType: string, defaulted: boolean }> | null };

export type GetSalesCancellationCountQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetSalesCancellationCountQuery = { __typename?: 'Query', getSalesCancellationCount: { __typename?: 'SaleCancellationCountOutput', openCount: number, completedCount: number, cancelCount: number } };

export type GetCommissionCalculationListingQueryVariables = Exact<{
  projectId: Scalars['String'];
  inputDate?: InputMaybe<Scalars['String']>;
}>;


export type GetCommissionCalculationListingQuery = { __typename?: 'Query', getCommissionCalculationListing: Array<{ __typename?: 'CommissionCalculationOutput', position: string, employeeName?: string | null, employeeId?: string | null, unitNo: string, salesConvertedStatus: string, salesRegistrationNo?: string | null, description: string, principal: string, effectiveDate: any, paidToDate?: number | null, release: number, propertyType: string, commissionType: string, minimumTarget: number, salesRegistrationDate: any, commissionPackageTargetId: string, companyId: string, dealClosure: number, parentId?: string | null, overRiding: number, unitsSold: number, unitSum?: number | null, saleId: string, finalContractPrice?: number | null, finalCommission?: number | null, projectCommissionPackageId?: string | null, totalFinalContractPrice?: number | null, totalFinalCommission?: number | null, companyCommissionTeamId?: string | null, jobPositionId?: string | null, level?: number | null }> };

export type CreateProjectCommissionCalculationMutationVariables = Exact<{
  input: Array<CommissionCalculationInput> | CommissionCalculationInput;
  inputDetail: Array<CommissionCalculationDetailInput> | CommissionCalculationDetailInput;
}>;


export type CreateProjectCommissionCalculationMutation = { __typename?: 'Mutation', createProjectCommissionCalculation: boolean };

export type GetCommissionCalculationDataQueryVariables = Exact<{
  projectId: Scalars['String'];
  inputDate?: InputMaybe<Scalars['String']>;
}>;


export type GetCommissionCalculationDataQuery = { __typename?: 'Query', getCommissionCalculationData: Array<{ __typename?: 'ProjectCommissionCalculationOutput', projectId: string, generateDate?: string | null, totalSelling?: number | null, principal?: string | null, employeeId: string }> };

export type GetCommissionCalculationDetailDataQueryVariables = Exact<{
  inputDate: Scalars['String'];
  projectId: Scalars['String'];
}>;


export type GetCommissionCalculationDetailDataQuery = { __typename?: 'Query', getCommissionCalculationDetailData: Array<{ __typename?: 'ProjectCommissionCalculationDetailOutput', parent_id: string, principal?: string | null, job_position?: string | null, generate_date?: any | null, employee_name?: string | null, employee_id?: string | null, total_selling?: number | null, total_commission: string, type: string, children: Array<{ __typename?: 'ProjectCommissionCalculationDetailChild', detail_id?: string | null, project_commission_calc_id?: string | null, doc_no?: string | null, doc_date?: any | null, sale_id?: string | null, net_selling?: number | null, commission_amt?: number | null, commission_type?: string | null, generate_date?: any | null, employee_name?: string | null, unit_no?: string | null, type: string, children: Array<{ __typename?: 'ProjectCommissionCalculationDetailSubChild', child_id?: string | null, project_commission_calc_id?: string | null, doc_no?: string | null, doc_date?: any | null, sale_id?: string | null, net_selling?: number | null, commission_amt?: number | null, commission_type?: string | null, type: string }> }> }> };

export type GetCompanyRewardDetailDataQueryVariables = Exact<{
  inputDate: Scalars['String'];
}>;


export type GetCompanyRewardDetailDataQuery = { __typename?: 'Query', getCompanyRewardDetailData: Array<{ __typename?: 'CompanyCommissionCalculationDetailOutput', parent_id: string, principal: string, job_position?: string | null, commission_type?: string | null, generate_date?: any | null, employee_name?: string | null, employee_id?: string | null, total_selling?: number | null, total_commission: string, type: string, children: Array<{ __typename?: 'CompanyCommissionCalculationDetailChild', detail_id?: string | null, sales_registration_no?: string | null, company_commission_calc_id?: string | null, unit_no?: string | null, doc_no?: string | null, doc_date?: any | null, sale_id?: string | null, net_selling?: number | null, commission_amt?: number | null, commission_type?: string | null, generate_date?: any | null, employee_name?: string | null, type: string, children: Array<{ __typename?: 'CompanyCommissionCalculationDetailSubChild', child_id?: string | null, company_commission_calc_id?: string | null, doc_no?: string | null, doc_date?: any | null, sale_id?: string | null, net_selling?: number | null, commission_amt?: number | null, commission_type?: string | null, type: string }> }> }> };

export type GetCommissionCalculationListingDataQueryVariables = Exact<{
  projectId: Scalars['String'];
  inputDate?: InputMaybe<Scalars['String']>;
}>;


export type GetCommissionCalculationListingDataQuery = { __typename?: 'Query', getCommissionCalculationListingData: Array<{ __typename?: 'CommissionCalculationOutput', employeeTotalCommission: number, employeeTotalSale: number, position: string, employeeName?: string | null, employeeId?: string | null, unitNo: string, salesConvertedStatus: string, propertyType: string, commissionType: string, salesRegistrationNo?: string | null, salesRegistrationDate: any, projectCommissionPackageId?: string | null, existProjectCommissionPackageId?: string | null, existEmployeeId?: string | null, companyId: string, unitSum?: number | null, finalCommission?: number | null, totalFinalContractPrice?: number | null, totalFinalCommission?: number | null, finalContractPrice?: number | null, saleId: string, principal: string, description: string, effectiveDate: any, minimumTarget: number, dealClosure: number, overRiding: number, unitsSold: number, unitLayout: string }> };

export type GetCompanyRewardDataQueryVariables = Exact<{
  projectId: Scalars['String'];
  inputDate?: InputMaybe<Scalars['String']>;
}>;


export type GetCompanyRewardDataQuery = { __typename?: 'Query', getCompanyRewardData: Array<{ __typename?: 'CompanyRewardOutput', id?: string | null, saleId?: string | null, employeeName?: string | null, employeeId?: string | null, projectId: string, salesRegistrationDate: any, salesRegistrationNo?: string | null, ejpEmployeeId?: string | null, ejpEmployeeName: string, description: string, jobPosition?: string | null, companyId?: string | null, commissionType: string, propertyType: string, principal: string, taxSchemeId?: string | null, paymentPlanMarkUpAmount?: number | null, existCompanyCommissionPackageId?: string | null, existEmployeeId?: string | null, unitNo: string, effectiveDate: any, finalContractPrice?: number | null, paidToDatePercentage?: number | null, isDealClosure?: boolean | null, finalCommission?: number | null, totalFinalCommission?: number | null, dealClosure?: number | null, overRiding?: number | null, companyCommissionPackageId?: string | null, employeeTotalCommission?: number | null, employeeTotalSale?: number | null }> };

export type CreateCompanyRewardCalculationMutationVariables = Exact<{
  input: Array<CompanyRewardInput> | CompanyRewardInput;
  inputDetail: Array<CompanyRewardDetailInput> | CompanyRewardDetailInput;
}>;


export type CreateCompanyRewardCalculationMutation = { __typename?: 'Mutation', createCompanyRewardCalculation: boolean };

export type GetCompanyRewardListingNewQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompanyRewardListingNewQuery = { __typename?: 'Query', getCompanyRewardListingNew: Array<{ __typename?: 'CompanyRewardCalculationOutput', id: string, companyId: string, generateDate?: string | null, totalSelling?: number | null, principal: string, employeeId: string }> };

export type AddCommissionPaymentsMutationVariables = Exact<{
  inputs: Array<AddCommissionPaymentInput> | AddCommissionPaymentInput;
}>;


export type AddCommissionPaymentsMutation = { __typename?: 'Mutation', addCommissionPayments: boolean };

export type EditCommissionPaymentByIdMutationVariables = Exact<{
  id: Scalars['String'];
  input: EditCommissionPaymentInput;
}>;


export type EditCommissionPaymentByIdMutation = { __typename?: 'Mutation', editCommissionPaymentById: boolean };

export type DeleteCommissionPaymentByIdMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteCommissionPaymentByIdMutation = { __typename?: 'Mutation', deleteCommissionPaymentById: boolean };

export type AddCommissionStatutoryDocumentMutationVariables = Exact<{
  input: AddCommissionStatutoryDocumentInput;
}>;


export type AddCommissionStatutoryDocumentMutation = { __typename?: 'Mutation', addCommissionStatutoryDocument: boolean };

export type DeleteCommissionStatutoryDocumentByIdMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteCommissionStatutoryDocumentByIdMutation = { __typename?: 'Mutation', deleteCommissionStatutoryDocumentById: boolean };

export type EditCommissionStatutoryDocumentByIdMutationVariables = Exact<{
  id: Scalars['String'];
  statutoryDocId: Scalars['String'];
}>;


export type EditCommissionStatutoryDocumentByIdMutation = { __typename?: 'Mutation', editCommissionStatutoryDocumentById: boolean };

export type GetCommissionTypeListingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCommissionTypeListingQuery = { __typename?: 'Query', getCommissionTypeListing: Array<{ __typename?: 'commissionTypeEntity', id: string, name: string, interval: number, payOutType: string, targetBy: string, commonStatus: string }> };

export type SubmitCommissionTypeMutationVariables = Exact<{
  input: CommissionTypeInput;
}>;


export type SubmitCommissionTypeMutation = { __typename?: 'Mutation', submitCommissionType: boolean };

export type DeleteCommissionTypeMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteCommissionTypeMutation = { __typename?: 'Mutation', deleteCommissionType: boolean };

export type IsCanEditOrDeleteCommisionTypeQueryVariables = Exact<{
  commisionId: Scalars['String'];
}>;


export type IsCanEditOrDeleteCommisionTypeQuery = { __typename?: 'Query', isCanEditOrDeleteCommisionType: boolean };

export type GetCompanyCommissionPackageListingQueryVariables = Exact<{
  principal: Scalars['String'];
}>;


export type GetCompanyCommissionPackageListingQuery = { __typename?: 'Query', getCompanyCommissionPackageListing: Array<{ __typename?: 'companyCommissionPackageEntity', id: string, companyId: string, companyCommissionId: string, principal: string, companyCommission: { __typename?: 'companyCommissionEntity', id: string, commissionTypeId: string, description: string }, companyCommissionPackageDetails: Array<{ __typename?: 'companyCommissionPackageDetailEntity', id: string, companyCommissionPackageId: string, effectiveDate: any, commissionPackageTargets: Array<{ __typename?: 'commissionPackageTargetEntity', id: string, refId: string, refTable: string, minimumTarget: number, commissionPackageTargetDetails: Array<{ __typename?: 'commissionPackageTargetDetailEntity', id: string, commissionPackageTargetId: string, positionId?: string | null, teamPositionId?: string | null, dealClosure: number, overriding: number }> }> }> }> };

export type AddCompanyCommissionPackageMutationVariables = Exact<{
  companyCommissionId: Scalars['String'];
  principal: Scalars['String'];
}>;


export type AddCompanyCommissionPackageMutation = { __typename?: 'Mutation', addCompanyCommissionPackage: boolean };

export type AddCompanyCommissionPackageDetailMutationVariables = Exact<{
  input: CompanyCommissionPackageDetailInput;
}>;


export type AddCompanyCommissionPackageDetailMutation = { __typename?: 'Mutation', addCompanyCommissionPackageDetail: boolean };

export type EditCompanyCommissionPackageDetailMutationVariables = Exact<{
  input: CompanyCommissionPackageDetailInput;
}>;


export type EditCompanyCommissionPackageDetailMutation = { __typename?: 'Mutation', editCompanyCommissionPackageDetail: boolean };

export type DeleteCompanyCommissionPackageDetailMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteCompanyCommissionPackageDetailMutation = { __typename?: 'Mutation', deleteCompanyCommissionPackageDetail: boolean };

export type GetCompanyCommissionTeamListingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompanyCommissionTeamListingQuery = { __typename?: 'Query', getCompanyCommissionTeamListing: any };

export type GetPositionCodeOptionsByCompanyCommissionTeamQueryVariables = Exact<{
  principal: Scalars['String'];
  generateDate: Scalars['DateTime'];
}>;


export type GetPositionCodeOptionsByCompanyCommissionTeamQuery = { __typename?: 'Query', getPositionCodeOptionsByCompanyCommissionTeam: Array<{ __typename?: 'positionCodeOption', positionId?: string | null, teamPositionId: string, teamPositionName: string }> };

export type AddCompanyCommissionTeamMutationVariables = Exact<{
  generateDate: Scalars['DateTime'];
}>;


export type AddCompanyCommissionTeamMutation = { __typename?: 'Mutation', addCompanyCommissionTeam: boolean };

export type SubmitCompanyCommissionTeamDetailMutationVariables = Exact<{
  input: CompanyCommissionTeamDetailInput;
}>;


export type SubmitCompanyCommissionTeamDetailMutation = { __typename?: 'Mutation', submitCompanyCommissionTeamDetail: boolean };

export type DeleteCompanyCommissionTeamDetailMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteCompanyCommissionTeamDetailMutation = { __typename?: 'Mutation', deleteCompanyCommissionTeamDetail: boolean };

export type GetCompanyRewardListingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompanyRewardListingQuery = { __typename?: 'Query', getCompanyRewardListing: Array<{ __typename?: 'companyCommissionEntity', id: string, companyId: string, commissionTypeId: string, description: string, commonStatus: string, commissionType: { __typename?: 'commissionTypeEntity', id: string, name: string, interval: number, payOutType: string, targetBy: string, commonStatus: string }, commissionPayments: Array<{ __typename?: 'commissionPaymentEntity', id: string, paidToDate: number, release: number, remarks: string, commissionStatutoryDocs: Array<{ __typename?: 'commissionStatutoryDocumentEntity', id: string, statutoryDocId: string, commissionPaymentId: string, statutoryDocument: { __typename?: 'statutoryDocumentEntity', id: string, name: string, code?: string | null } }> }> }> };

export type SubmitCompanyRewardMutationVariables = Exact<{
  commissionTypeId: Scalars['String'];
  description: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
}>;


export type SubmitCompanyRewardMutation = { __typename?: 'Mutation', submitCompanyReward: boolean };

export type DeleteCompanyRewardMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteCompanyRewardMutation = { __typename?: 'Mutation', deleteCompanyReward: boolean };

export type AddCompanyRewardCommPaymentMutationVariables = Exact<{
  input: Array<CommissionPaymentInput> | CommissionPaymentInput;
}>;


export type AddCompanyRewardCommPaymentMutation = { __typename?: 'Mutation', addCompanyRewardCommPayment: boolean };

export type EditCompanyRewardCommPaymentMutationVariables = Exact<{
  input: CommissionPaymentInput;
}>;


export type EditCompanyRewardCommPaymentMutation = { __typename?: 'Mutation', editCompanyRewardCommPayment: boolean };

export type DeleteCompanyRewardCommPaymentMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteCompanyRewardCommPaymentMutation = { __typename?: 'Mutation', deleteCompanyRewardCommPayment: boolean };

export type SubmitCompanyRewardCommStatutoryDocMutationVariables = Exact<{
  commissionPaymentId: Scalars['String'];
  statutoryDocId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
}>;


export type SubmitCompanyRewardCommStatutoryDocMutation = { __typename?: 'Mutation', submitCompanyRewardCommStatutoryDoc: boolean };

export type DeleteCompanyRewardCommStatutoryDocMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteCompanyRewardCommStatutoryDocMutation = { __typename?: 'Mutation', deleteCompanyRewardCommStatutoryDoc: boolean };

export type GetCompanyRewardCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompanyRewardCountQuery = { __typename?: 'Query', getCompanyRewardCount: number };

export type GetProjectCommissionsQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetProjectCommissionsQuery = { __typename?: 'Query', getProjectCommissions: Array<{ __typename?: 'GetProjectCommissionsOutput', id: string, description: string, interval: number, payOutType: string, targetBy: string, rateClassification: string, canEditOrDelete: boolean, commissionPayments: Array<{ __typename?: 'CommissionPaymentOutput', id: string, paidToDate: number, release: number, remarks: string, commissionStatutoryDocuments: Array<{ __typename?: 'CommissionStatutoryDocumentOutput', id: string, code: string, name: string, statutoryDocId: string }> }> }> };

export type GetProjectCommissionByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetProjectCommissionByIdQuery = { __typename?: 'Query', getProjectCommissionById: { __typename?: 'GetProjectCommissionByIdOutput', id: string, description: string, rateClassification: string, commissionTypeId: string } };

export type AddProjectCommisionMutationVariables = Exact<{
  input: AddProjectCommissionInput;
}>;


export type AddProjectCommisionMutation = { __typename?: 'Mutation', addProjectCommission: boolean };

export type EditProjectCommissionByIdMutationVariables = Exact<{
  id: Scalars['String'];
  input: EditProjectCommissionInput;
}>;


export type EditProjectCommissionByIdMutation = { __typename?: 'Mutation', editProjectCommissionById: boolean };

export type DeleteProjectCommissionByIdMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteProjectCommissionByIdMutation = { __typename?: 'Mutation', deleteProjectCommissionById: boolean };

export type GetProjectCommissionPackageListingQueryVariables = Exact<{
  projectId: Scalars['String'];
  principal: Scalars['String'];
}>;


export type GetProjectCommissionPackageListingQuery = { __typename?: 'Query', getProjectCommissionPackageListing: any };

export type AddProjectCommissionPackageMutationVariables = Exact<{
  projectCommissionId: Scalars['String'];
  principal: Scalars['String'];
}>;


export type AddProjectCommissionPackageMutation = { __typename?: 'Mutation', addProjectCommissionPackage: boolean };

export type AddProjectCommissionPackageDetailMutationVariables = Exact<{
  input: ProjectCommissionPackageDetailInput;
}>;


export type AddProjectCommissionPackageDetailMutation = { __typename?: 'Mutation', addProjectCommissionPackageDetail: boolean };

export type EditProjectCommissionPackageDetailMutationVariables = Exact<{
  input: ProjectCommissionPackageDetailInput;
}>;


export type EditProjectCommissionPackageDetailMutation = { __typename?: 'Mutation', editProjectCommissionPackageDetail: boolean };

export type DeleteProjectCommissionPackageDetailMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteProjectCommissionPackageDetailMutation = { __typename?: 'Mutation', deleteProjectCommissionPackageDetail: boolean };

export type GetProjectCommissionOptionsQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetProjectCommissionOptionsQuery = { __typename?: 'Query', getProjectCommissionOptions: Array<{ __typename?: 'projectCommissionEntity', id: string, description: string, rateClassification: string, commissionType: { __typename?: 'commissionTypeEntity', id: string, name: string, interval: number, payOutType: string, targetBy: string } }> };

export type GetProjectCommissionTeamStructureListingQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetProjectCommissionTeamStructureListingQuery = { __typename?: 'Query', getProjectCommissionTeamStructureListing: any };

export type SetProjectCommissionTeamMutationVariables = Exact<{
  projectCommissionTeamInput: ProjectCommissionTeamInput;
}>;


export type SetProjectCommissionTeamMutation = { __typename?: 'Mutation', setProjectCommissionTeam: boolean };

export type DeleteProjectCommissionTeamMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteProjectCommissionTeamMutation = { __typename?: 'Mutation', deleteProjectCommissionTeam: boolean };

export type SetProjectCommissionTeamDetailMutationVariables = Exact<{
  input: ProjectCommissionTeamDetailInput;
}>;


export type SetProjectCommissionTeamDetailMutation = { __typename?: 'Mutation', setProjectCommissionTeamDetail: boolean };

export type DeleteProjectCommissionTeamDetailMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteProjectCommissionTeamDetailMutation = { __typename?: 'Mutation', deleteProjectCommissionTeamDetail: boolean };

export type GetProjectCommissionTeamAgencyAppointedQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetProjectCommissionTeamAgencyAppointedQuery = { __typename?: 'Query', getProjectCommissionTeamAgencyAppointed: Array<{ __typename?: 'agencyAppointedEntity', id: string, name: string }> };

export type GetProjectNameByIdQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetProjectNameByIdQuery = { __typename?: 'Query', getProjectById: { __typename?: 'projectEntity', id: string, name: string } };

export type GetAllJobPositionQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetAllJobPositionQuery = { __typename?: 'Query', getAllJobPosition: { __typename?: 'JobPositionListWithRecentModTs', recentModTs?: any | null, jobPositions: Array<{ __typename?: 'jobPositionEntity', id: string, position: string, countOfEmployee: number }> } };

export type AddJobPositionMutationVariables = Exact<{
  input: AddJobPositionInput;
}>;


export type AddJobPositionMutation = { __typename?: 'Mutation', addJobPosition: boolean };

export type DeleteJobPositionMutationVariables = Exact<{
  positionId: Scalars['String'];
}>;


export type DeleteJobPositionMutation = { __typename?: 'Mutation', deleteJobPosition: boolean };

export type EditJobPositionMutationVariables = Exact<{
  positionId: Scalars['String'];
  positionName: Scalars['String'];
}>;


export type EditJobPositionMutation = { __typename?: 'Mutation', editJobPosition: boolean };

export type GetAllEmployeeJobPositionQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetAllEmployeeJobPositionQuery = { __typename?: 'Query', getAllEmployeeJobPosition: Array<{ __typename?: 'employeeJobPositionOutput', id: string, position: string, employeeJobPosition?: Array<{ __typename?: 'employeeJobPosition', id: string, employeeName: string }> | null }> };

export type EditEmployeeJobPositionMutationVariables = Exact<{
  input: EditEmployeeJobPositionInput;
}>;


export type EditEmployeeJobPositionMutation = { __typename?: 'Mutation', editEmployeeJobPosition: boolean };

export type GetAllJobPositionOptionQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetAllJobPositionOptionQuery = { __typename?: 'Query', getAllJobPositionOption: Array<{ __typename?: 'jobPositionOptionOutput', id: string, position: string }> };

export type GetSaleCommissionSummaryQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetSaleCommissionSummaryQuery = { __typename?: 'Query', commissionTypeCount?: number | null, companyCommissionTeamDate?: any | null, companyCommissionPackageDate?: any | null, projectCommissionDate?: any | null, projectCommissionTeamStructureDate?: any | null, projectCommissionPackageDate?: any | null, getCommissionCalculationRecentData?: any | null };

export type GetMarkUpBySaleIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetMarkUpBySaleIdQuery = { __typename?: 'Query', getMarkUpBySaleId?: { __typename?: 'saleEntity', markUpBy?: string | null, markUpValue?: number | null, markUpReason?: string | null, markUpAmount?: number | null } | null };

export type AddSaleMarkUpMutationVariables = Exact<{
  input: MarkUpInput;
}>;


export type AddSaleMarkUpMutation = { __typename?: 'Mutation', addSaleMarkUp: boolean };

export type GetMarkUpByQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMarkUpByQuery = { __typename?: 'Query', getMarkUpBy: any };

export type GetOtherContactListQueryVariables = Exact<{
  saleID: Scalars['String'];
}>;


export type GetOtherContactListQuery = { __typename?: 'Query', getOtherContactList: Array<{ __typename?: 'saleContactEntity', id: string, accountId: string, saleId: string, name: string, contactNo: string, officeTel?: string | null, email: string, salutationId?: string | null, relationshipId?: string | null, remark?: string | null, isPrimary: boolean }> };

export type GetOtherContactByIdQueryVariables = Exact<{
  saleID: Scalars['String'];
  ID: Scalars['String'];
}>;


export type GetOtherContactByIdQuery = { __typename?: 'Query', getOtherContactById: { __typename?: 'saleContactEntity', id: string, accountId: string, saleId: string, name: string, contactNo: string, officeTel?: string | null, email: string, salutationId?: string | null, relationshipId?: string | null, remark?: string | null, isPrimary: boolean, salutation?: { __typename?: 'salutationEntity', name: string, id: string } | null } };

export type AddSalesContractOtherContactMutationVariables = Exact<{
  input: AddSalesContractContactInput;
  saleID: Scalars['String'];
}>;


export type AddSalesContractOtherContactMutation = { __typename?: 'Mutation', addSalesContractOtherContact: boolean };

export type EditSalesContractOtherContactMutationVariables = Exact<{
  input: EditSalesContractContactInput;
  saleID: Scalars['String'];
}>;


export type EditSalesContractOtherContactMutation = { __typename?: 'Mutation', editSalesContractOtherContact: boolean };

export type GetPurchaserInfoListingQueryVariables = Exact<{
  saleId: Scalars['String'];
}>;


export type GetPurchaserInfoListingQuery = { __typename?: 'Query', getPurchaserInfoListing: Array<{ __typename?: 'purchaserListingOutput', name: string, error: number, draggable: boolean, isBumi?: boolean | null, icNo: string, id: string, seqNo: number, jointBuyerId?: string | null, isCompany?: boolean | null, companyName?: string | null, companyRegNo?: string | null }> };

export type DeleteJointBuyerMutationVariables = Exact<{
  jointBuyerId: Scalars['String'];
  saleId: Scalars['String'];
}>;


export type DeleteJointBuyerMutation = { __typename?: 'Mutation', deleteJointBuyer: boolean };

export type UpdateJointBuyerSeqMutationVariables = Exact<{
  input: UpdateJointBuyerSeqInput;
  saleId: Scalars['String'];
}>;


export type UpdateJointBuyerSeqMutation = { __typename?: 'Mutation', updateJointBuyerSeq: boolean };

export type GetGeneralTinByPartyQueryVariables = Exact<{
  party?: InputMaybe<Scalars['String']>;
}>;


export type GetGeneralTinByPartyQuery = { __typename?: 'Query', getGeneralTinByParty: { __typename?: 'eInvoiceGeneralTinEntity', tin?: string | null } };

export type GetAvailableUnitByProjectIdQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAvailableUnitByProjectIdQuery = { __typename?: 'Query', getAvailableUnitByProjectID: Array<{ __typename?: 'unitEntity', id: string, unitNo: string, builtUp: number, landArea?: string | null, isBumi: boolean, price: number, unitExt?: { __typename?: 'unitExtensionEntity', paymentPlanId?: string | null, builtUpAreaRate?: number | null, actualBuiltUpArea?: number | null, landAreaRate?: number | null, actualLandArea?: number | null, shareValue?: string | null } | null, propertyType: { __typename?: 'propertyTypeEntity', id: string, commercialPurpose: string, name: string } }> };

export type GetSalesContractListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSalesContractListQuery = { __typename?: 'Query', getSalesContractList: Array<{ __typename?: 'saleEntity', id: string, unitId: string, salesPersonId?: string | null, developerSolicitorId?: string | null, leadId?: string | null, salesTeamId?: string | null, distance?: string | null, developerReference?: string | null, buyerReference?: string | null, salesNo: string, sellingPrice?: number | null, isCompany: boolean, bookingRemark?: string | null, bookDate: any, isBumi: boolean, paymentMethod?: string | null, bookingAmount?: number | null, listPrice?: number | null, billMethod?: string | null, expectedSnpDate?: any | null, spaDate?: any | null, stampDate?: any | null, salesStatus: string, unit: { __typename?: 'unitEntity', unitNo: string, isBumi: boolean }, contact: { __typename?: 'contactEntity', id: string, fullName: string, companyName?: string | null } }> };

export type GetSalesContractByIdQueryVariables = Exact<{
  saleID: Scalars['String'];
}>;


export type GetSalesContractByIdQuery = { __typename?: 'Query', getSalesContractById: { __typename?: 'saleEntity', id: string, unitId: string, salesPersonId?: string | null, developerSolicitorId?: string | null, isCompany: boolean, leadId?: string | null, salesTeamId?: string | null, distance?: string | null, developerReference?: string | null, buyerReference?: string | null, salesNo: string, bookingRemark?: string | null, bookDate: any, isBumi: boolean, paymentMethod?: string | null, bookingAmount?: number | null, listPrice?: number | null, sellingPrice?: number | null, billMethod?: string | null, expectedSnpDate?: any | null, spaDate?: any | null, stampDate?: any | null, cancelledDate?: any | null, salesStatus: string, otherContactName?: any | null, addOnTotal?: any | null, progressBillingTotal?: number | null, salesPerson?: string | null, ContractPricingDiscount?: number | null, ProgressBilling?: any | null, eventId?: string | null, leadSource?: { __typename?: 'leadSourceEntity', id: string } | null, buyerSolicitor?: { __typename?: 'solicitorAppointedEntity', id: string, name: string } | null, developerSolicitor?: { __typename?: 'solicitorAppointedEntity', id: string, name: string } | null, incomeRange?: { __typename?: 'incomeRangeEntity', id: string, range: string, defaulted: boolean } | null, purchaserInfoName?: { __typename?: 'purchaserInfoInfoOutput', name: string, count: number, error: boolean } | null, salesRebateName?: Array<{ __typename?: 'saleRebateInfoOutput', title: string, checkPaymentPlan: boolean, discountAmount: number }> | null, checkSalePackage?: { __typename?: 'salePackageInfoOutput', includeContractInvalid?: number | null, noIncludeContractInvalid?: number | null } | null, saleExtension?: { __typename?: 'saleExtensionEntity', totalSalesValue?: number | null, loanGracePeriod?: number | null, isCashBuyer?: boolean | null, creditTerm?: number | null, isGenerateReminder?: boolean | null, isGenerateInterest?: boolean | null, campaignId?: string | null, salesType?: string | null, paymentPlanId?: string | null, paymentPlan?: { __typename?: 'paymentPlanEntity', name: string, details?: Array<{ __typename?: 'paymentPlanDetailEntity', isStakeholder: boolean }> | null } | null } | null, unit: { __typename?: 'unitEntity', unitNo: string, builtUp: number, isBumi: boolean, id: string, unitExt?: { __typename?: 'unitExtensionEntity', stakeholderId?: string | null } | null }, contact: { __typename?: 'contactEntity', id: string, fullName: string, companyName?: string | null }, bookingAttachments: { __typename?: 'bookingAttachmentsOutput', bookingNricAttachments: Array<{ __typename?: 'attachmentEntity', id: string }>, bookingCcrAttachments: Array<{ __typename?: 'attachmentEntity', id: string }> }, address?: { __typename?: 'AddressJson', city?: string | null, state?: string | null, address?: string | null, country?: string | null, postCode?: string | null } | null } };

export type GetMainContactQueryVariables = Exact<{
  saleID: Scalars['String'];
}>;


export type GetMainContactQuery = { __typename?: 'Query', getSalesContractById: { __typename?: 'saleEntity', contact: { __typename?: 'contactEntity', id: string, fullName: string } } };

export type GetWorkProgressBySaleQueryVariables = Exact<{
  saleId: Scalars['String'];
}>;


export type GetWorkProgressBySaleQuery = { __typename?: 'Query', getWorkProgressBySale?: Array<{ __typename?: 'workProgressEntity', id: string, name: string }> | null };

export type EditSalesContractSolicitorsMutationVariables = Exact<{
  input: EditSolicitorsInput;
}>;


export type EditSalesContractSolicitorsMutation = { __typename?: 'Mutation', editSalesContractSolicitors: boolean };

export type EditSalesContractOtherSalesInfoMutationVariables = Exact<{
  input: EditOtherSalesInfoInput;
}>;


export type EditSalesContractOtherSalesInfoMutation = { __typename?: 'Mutation', editSalesContractOtherSalesInfo: boolean };

export type DeleteSalesContractOtherContactMutationVariables = Exact<{
  saleContactId: Scalars['String'];
}>;


export type DeleteSalesContractOtherContactMutation = { __typename?: 'Mutation', deleteSalesContractOtherContact: boolean };

export type ConvertToSignMutationVariables = Exact<{
  input: UpdateSnpSigned;
}>;


export type ConvertToSignMutation = { __typename?: 'Mutation', convertToSign: { __typename?: 'salesContractMutationOutput', isSuccessful: boolean, isGenerated: boolean } };

export type ConvertToStampedMutationVariables = Exact<{
  input: UpdateSnpStamped;
}>;


export type ConvertToStampedMutation = { __typename?: 'Mutation', convertToStamped: boolean };

export type GetAllMasterDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllMasterDataQuery = { __typename?: 'Query', GetAllMasterInfo: { __typename?: 'MasterDataOutput', Genders: any, CurrencyCode: Array<Array<string>>, Races: Array<{ __typename?: 'raceEntity', id: string, name: string, defaulted: boolean }>, Salutations: Array<{ __typename?: 'salutationEntity', id: string, name: string, defaulted: boolean }>, LeadSources: Array<{ __typename?: 'leadSourceEntity', id: string, name: string, commonStatus: string, defaulted: boolean, systemUse: boolean }>, MaritalStatus: Array<{ __typename?: 'maritalStatusEntity', id: string, name: string, defaulted: boolean }>, IncomeRanges: Array<{ __typename?: 'incomeRangeEntity', id: string, range: string, defaulted: boolean }>, Nationalities: Array<{ __typename?: 'sNationalityEntity', id: string, name: string }> } };

export type GetDiscountListByProjectIdIntegratedFalseQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDiscountListByProjectIdIntegratedFalseQuery = { __typename?: 'Query', getDiscountListByProjectId: Array<{ __typename?: 'discountEntity', id: string, title: string, formula?: string | null, prefix?: string | null, description?: string | null, isIntegrated: boolean, discountVal?: number | null, projectDiscounts: Array<{ __typename?: 'projectDiscountEntity', effectiveDate: any, expired_date: any, defaulted: boolean }> }> };

export type GetProjectDiscountListQueryVariables = Exact<{
  discountType?: InputMaybe<Scalars['String']>;
  saleRebateId?: InputMaybe<Scalars['String']>;
}>;


export type GetProjectDiscountListQuery = { __typename?: 'Query', getProjectDiscountList?: Array<{ __typename?: 'discountListOutput', discountId: string, discountTitle: string, discountPrefix: string, discountVal: number, disabled: boolean }> | null };

export type GetProjectDiscountListWithoutSaleRebateQueryVariables = Exact<{
  discountType?: InputMaybe<Scalars['String']>;
  saleId?: InputMaybe<Scalars['String']>;
}>;


export type GetProjectDiscountListWithoutSaleRebateQuery = { __typename?: 'Query', getProjectDiscountListWithoutSaleRebate?: Array<{ __typename?: 'projectDiscountEntity', id: string, effectiveDate: any, expired_date: any, defaulted: boolean, discount: { __typename?: 'discountEntity', id: string, title: string, formula?: string | null, prefix?: string | null, discountVal?: number | null, discountType?: { __typename?: 'discountTypeEntity', name: string } | null } }> | null };

export type GetSummarySaleContractQueryVariables = Exact<{
  saleId: Scalars['String'];
}>;


export type GetSummarySaleContractQuery = { __typename?: 'Query', getSummarySaleContract: { __typename?: 'SaleContractMenuSummaryOutput', subProduct: { __typename?: 'summaryInfo', info: string, count: number, totalPrice: number }, packages: { __typename?: 'summaryInfo', info: string, count: number, totalPrice: number }, discount?: { __typename?: 'discountSummaryInfo', info: string, count: number, totalPrice: number, isBumiDiscard: boolean } | null, unit?: { __typename?: 'unitSummaryInfo', propertyType: string, sellingPrice: number, area: string, uom: string } | null, markUp?: { __typename?: 'markUpSummaryInfo', markUpBy?: string | null, markUpValue?: number | null, markUpReason?: string | null, markUpAmount?: number | null } | null } };

export type CalculateDiscountAmountQueryVariables = Exact<{
  input: CalculateDiscountAmountInput;
}>;


export type CalculateDiscountAmountQuery = { __typename?: 'Query', calculateDiscountAmount: any };

export type GetContractUnitDetailsQueryVariables = Exact<{
  unitId: Scalars['String'];
}>;


export type GetContractUnitDetailsQuery = { __typename?: 'Query', getContractUnitDetails: { __typename?: 'UnitDetailsOutput', unitNo?: string | null, propertyType?: string | null, commercialPurpose?: string | null, uom: Uom, builtUpAreaRate?: number | null, builtUp?: number | null, landArea?: string | null, landAreaRate?: number | null, shareValue?: number | null, taxSchemeName?: string | null, isBumi: boolean } };

export type GetAddressByIdQueryVariables = Exact<{
  contactId: Scalars['String'];
}>;


export type GetAddressByIdQuery = { __typename?: 'Query', getAddressById?: any | null };

export type GetContactByIdQueryVariables = Exact<{
  contactId: Scalars['String'];
}>;


export type GetContactByIdQuery = { __typename?: 'Query', getContactById: { __typename?: 'contactEntity', id: string, companyName?: string | null, companyRegNo?: string | null, fullName: string, email?: string | null, phoneNo?: string | null, officeTel?: string | null, homeTel?: string | null, gender?: string | null, icNo?: string | null, militaryIc?: string | null, photoUrl?: string | null, salutation?: { __typename?: 'salutationEntity', name: string, id: string } | null, nationality?: { __typename?: 'sNationalityEntity', name: string, id: string } | null, race?: { __typename?: 'raceEntity', name: string, id: string } | null, maritalStatus?: { __typename?: 'maritalStatusEntity', name: string, id: string } | null, contactExt?: { __typename?: 'contactExtensionEntity', id: string, identityType: string, customerOrigin: string, isBumi: boolean, isVip: boolean, isForeignPurchase: boolean, subscribeMaterialSms: boolean, subscribeMaterialWhatsapp: boolean, subscribeMaterialEmail: boolean, subscribeMaterialPaNews: boolean, mailingMethod: string, remark?: string | null, tin?: string | null, sstNo?: string | null } | null, addressList?: Array<{ __typename?: 'contactAddressEntity', id: string, contactId: string, isPrimary: boolean, address: { __typename?: 'AddressJson', address?: string | null, country?: string | null, city?: string | null, state?: string | null, postCode?: string | null, AddressType?: string | null } }> | null } };

export type GetAllPackageByProjectQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllPackageByProjectQuery = { __typename?: 'Query', getAllPackageByProject?: Array<{ __typename?: 'packageEntity', id: string, name: string, desc?: string | null, projectId: string, listPrice: number, marketValue: number, startDate: any, endDate: any, isIntegrated: boolean, packageExt?: { __typename?: 'packageExtEntity', defaulted: boolean, taxSchemeId: string } | null }> | null };

export type GetSalesContractAttachmentsQueryVariables = Exact<{
  sale_id: Scalars['String'];
}>;


export type GetSalesContractAttachmentsQuery = { __typename?: 'Query', getSalesContractAttachments: { __typename?: 'saleEntity', bookingAttachments: { __typename?: 'bookingAttachmentsOutput', bookingNricAttachments: Array<{ __typename?: 'attachmentEntity', id: string, accountId: string, refTable: string, refId: string, refType: string, mediaType: string, resourceUrl: string, fileName: string, bucketFileName: string, isPrivate: boolean, seqNo: number, allowDelete?: boolean | null }>, bookingFeeAttachments: Array<{ __typename?: 'attachmentEntity', id: string, accountId: string, refTable: string, refId: string, refType: string, mediaType: string, resourceUrl: string, fileName: string, bucketFileName: string, isPrivate: boolean, seqNo: number, allowDelete?: boolean | null }>, solicitorAgreementAttachments: Array<{ __typename?: 'attachmentEntity', id: string, accountId: string, refTable: string, refId: string, refType: string, mediaType: string, resourceUrl: string, fileName: string, bucketFileName: string, isPrivate: boolean, seqNo: number, allowDelete?: boolean | null }>, solicitorOthersAttachments: Array<{ __typename?: 'attachmentEntity', id: string, accountId: string, refTable: string, refId: string, refType: string, mediaType: string, resourceUrl: string, fileName: string, bucketFileName: string, isPrivate: boolean, seqNo: number, allowDelete?: boolean | null }>, bookingCcrAttachments: Array<{ __typename?: 'attachmentEntity', id: string, accountId: string, refTable: string, refId: string, refType: string, mediaType: string, resourceUrl: string, fileName: string, bucketFileName: string, isPrivate: boolean, seqNo: number, allowDelete?: boolean | null }> } } };

export type AddAttachmentsMutationVariables = Exact<{
  input: SalesAddAttachmentsInput;
}>;


export type AddAttachmentsMutation = { __typename?: 'Mutation', addAttachments: Array<{ __typename?: 'attachmentEntity', id: string, accountId: string, bucketFileName: string, fileName: string, isPrivate: boolean, mediaType: string, refId: string, refTable: string, refType: string, resourceUrl: string, seqNo: number }> };

export type DownloadAttachmentMutationVariables = Exact<{
  input: SalesDownloadAttachmentInput;
}>;


export type DownloadAttachmentMutation = { __typename?: 'Mutation', downloadAttachment: { __typename?: 'AttachmentOutput', content?: string | null, fileName?: string | null } };

export type DeleteAttachmentMutationVariables = Exact<{
  attachmentId: Scalars['String'];
}>;


export type DeleteAttachmentMutation = { __typename?: 'Mutation', deleteAttachment: boolean };

export type GetProjectPaymentPlanQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProjectPaymentPlanQuery = { __typename?: 'Query', getProjectPaymentPlan: Array<{ __typename?: 'projectPaymentPlanEntity', id: string, accountId: string, projectId: string, paymentPlanId: string, defaulted: boolean, paymentPlan: { __typename?: 'paymentPlanEntity', id: string, name: string, payMethod?: string | null, details?: Array<{ __typename?: 'paymentPlanDetailEntity', title: string, workProgressId: string, workProgress?: { __typename?: 'workProgressEntity', isCarPark: boolean } | null }> | null } }> };

export type GetActiveProjectPaymentPlanQueryVariables = Exact<{
  saleId: Scalars['String'];
}>;


export type GetActiveProjectPaymentPlanQuery = { __typename?: 'Query', getActiveProjectPaymentPlan: Array<{ __typename?: 'activePaymentPlanOutput', paymentPlanId: string, paymentPlanName: string, status: string, isStakeholder: boolean }> };

export type GetSolicitorSignedDetailQueryVariables = Exact<{
  sales_id: Scalars['String'];
}>;


export type GetSolicitorSignedDetailQuery = { __typename?: 'Query', getSolicitorSignedInfo: { __typename?: 'SignedDetailsOutput', bookDate?: any | null, signedDate?: any | null, stampDate?: any | null, remark?: string | null, snpAgreement?: Array<{ __typename?: 'SNPAgreements', mediaType?: string | null, name?: string | null, url?: string | null, id?: string | null }> | null } };

export type RecalculateProgressBillingMutationVariables = Exact<{
  saleId: Scalars['String'];
}>;


export type RecalculateProgressBillingMutation = { __typename?: 'Mutation', recalculateProgressBilling: boolean };

export type UpdateSalesContractPaymentPlanMutationVariables = Exact<{
  saleId: Scalars['String'];
  paymentPlanId: Scalars['String'];
}>;


export type UpdateSalesContractPaymentPlanMutation = { __typename?: 'Mutation', updateSalesContractPaymentPlan: boolean };

export type GetActiveCampaignByProjectQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveCampaignByProjectQuery = { __typename?: 'Query', getActiveCampaignByProject: Array<{ __typename?: 'campaignEntity', id: string, accountId: string, name: string, startDate: any, endDate: any, commonStatus?: string | null, getCampaignEventsCount: number }> };

export type GetSaleContactListQueryVariables = Exact<{
  isCompany: Scalars['Boolean'];
}>;


export type GetSaleContactListQuery = { __typename?: 'Query', getSaleContactList?: Array<{ __typename?: 'contactEntity', id: string, fullName: string, email?: string | null, phoneNo?: string | null, gender?: string | null, icNo?: string | null, militaryIc?: string | null, companyName?: string | null, companyRegNo?: string | null, homeTel?: string | null, officeTel?: string | null, salutation?: { __typename?: 'salutationEntity', id: string } | null, nationality?: { __typename?: 'sNationalityEntity', id: string } | null, race?: { __typename?: 'raceEntity', id: string } | null, maritalStatus?: { __typename?: 'maritalStatusEntity', id: string } | null, address?: { __typename?: 'AddressJson', address?: string | null, country?: string | null, city?: string | null, state?: string | null, postCode?: string | null } | null, contactExt?: { __typename?: 'contactExtensionEntity', identityType: string, customerOrigin: string, isBumi: boolean, isForeignPurchase: boolean, subscribeMaterialSms: boolean, subscribeMaterialWhatsapp: boolean, subscribeMaterialEmail: boolean, subscribeMaterialPaNews: boolean, mailingMethod: string, remark?: string | null } | null, addressList?: Array<{ __typename?: 'contactAddressEntity', id: string, isPrimary: boolean, address: { __typename?: 'AddressJson', address?: string | null, country?: string | null, city?: string | null, state?: string | null, postCode?: string | null, AddressType?: string | null } }> | null }> | null };

export type CheckProjectSpecQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckProjectSpecQuery = { __typename?: 'Query', checkProjectSpec: { __typename?: 'projectSpecEntity', bookingFeeMandatory: boolean, nricAttachmentRequired: boolean, ccrAttachmentRequired: boolean } };

export type SpaSigningReversalMutationVariables = Exact<{
  saleId: Scalars['String'];
}>;


export type SpaSigningReversalMutation = { __typename?: 'Mutation', spaSigningReversal: boolean };

export type GetSalesDiscountListQueryVariables = Exact<{
  saleID: Scalars['String'];
}>;


export type GetSalesDiscountListQuery = { __typename?: 'Query', getSalesDiscountList?: Array<{ __typename?: 'saleDiscountEntity', id: string, salesDiscountDiscardBumi?: any | null, discountId: string, amount: number, seqNo: number, discount: { __typename?: 'discountEntity', title: string, formula?: string | null, prefix?: string | null, discountVal?: number | null, discountType?: { __typename?: 'discountTypeEntity', name: string } | null }, saleDiscountExtension?: { __typename?: 'salesDiscountExtEntity', formula: string, discountMethod: string } | null }> | null };

export type AddSalesContractDiscountMutationVariables = Exact<{
  input: AddSalesContractDiscountInput;
  saleId: Scalars['String'];
}>;


export type AddSalesContractDiscountMutation = { __typename?: 'Mutation', addSalesContractDiscount: boolean };

export type EditSalesContractDiscountMutationVariables = Exact<{
  input: EditSalesContractDiscountInput;
  saleId: Scalars['String'];
}>;


export type EditSalesContractDiscountMutation = { __typename?: 'Mutation', editSalesContractDiscount: boolean };

export type DeleteSalesContractDiscountMutationVariables = Exact<{
  discountId: Scalars['String'];
  saleId: Scalars['String'];
}>;


export type DeleteSalesContractDiscountMutation = { __typename?: 'Mutation', deleteSalesContractDiscount: boolean };

export type GetSalesDiscountByIdQueryVariables = Exact<{
  saleId: Scalars['String'];
  discountId: Scalars['String'];
}>;


export type GetSalesDiscountByIdQuery = { __typename?: 'Query', getSalesDiscountById: { __typename?: 'saleDiscountEntity', id: string, discountId: string, amount: number, seqNo: number, discount: { __typename?: 'discountEntity', title: string, formula?: string | null, prefix?: string | null, discountVal?: number | null, discountType?: { __typename?: 'discountTypeEntity', name: string } | null }, saleDiscountExtension?: { __typename?: 'salesDiscountExtEntity', formula: string, discountMethod: string } | null, currentDiscountDetail: { __typename?: 'projectDiscountEntity', id: string, effectiveDate: any, expired_date: any, defaulted: boolean, discount: { __typename?: 'discountEntity', id: string, title: string, formula?: string | null, prefix?: string | null, discountVal?: number | null, discountType?: { __typename?: 'discountTypeEntity', name: string } | null } } } };

export type UpdateDiscardBumiMutationVariables = Exact<{
  saleId: Scalars['String'];
  discardBumi: Scalars['Boolean'];
}>;


export type UpdateDiscardBumiMutation = { __typename?: 'Mutation', updateDiscardBumi: boolean };

export type GetSalesPackageListQueryVariables = Exact<{
  saleID: Scalars['String'];
}>;


export type GetSalesPackageListQuery = { __typename?: 'Query', getSalesPackageList?: Array<{ __typename?: 'salePackageListingOutput', id: string, name?: string | null, desc: string, sellingPrice: number, sellingMethod: string, error: boolean }> | null };

export type AddSalesContractPackageMutationVariables = Exact<{
  input: AddSalesContractPackageInput;
  saleID: Scalars['String'];
}>;


export type AddSalesContractPackageMutation = { __typename?: 'Mutation', addSalesContractPackage: boolean };

export type EditSalesContractPackageMutationVariables = Exact<{
  input: EditSalesContractPackageInput;
  saleID: Scalars['String'];
}>;


export type EditSalesContractPackageMutation = { __typename?: 'Mutation', editSalesContractPackage: boolean };

export type DeleteSalesContractPackageMutationVariables = Exact<{
  id: Scalars['String'];
  saleID: Scalars['String'];
}>;


export type DeleteSalesContractPackageMutation = { __typename?: 'Mutation', deleteSalesContractPackage: boolean };

export type GetSalesContractPackageByIdQueryVariables = Exact<{
  saleId: Scalars['String'];
  packageId: Scalars['String'];
}>;


export type GetSalesContractPackageByIdQuery = { __typename?: 'Query', getSalesContractPackageById: { __typename?: 'salePackageEntity', id: string, accountId: string, saleId: string, packageId?: string | null, openMarketValue?: number | null, sellingPrice?: number | null, sellingMethod: string, taxSchemeId?: string | null, workProgressId?: string | null, paymentPlanId?: string | null, package: { __typename?: 'packageEntity', name: string }, workProgress: { __typename?: 'workProgressEntity', name: string, id: string }, salePackage?: { __typename?: 'packageEntity', id: string, name: string, desc?: string | null, projectId: string, listPrice: number, marketValue: number, startDate: any, endDate: any, isIntegrated: boolean } | null, projectPaymentPlan?: { __typename?: 'projectPaymentPlanEntity', id: string, accountId: string, projectId: string, paymentPlanId: string, defaulted: boolean, paymentPlan: { __typename?: 'paymentPlanEntity', id: string, name: string, payMethod?: string | null, details?: Array<{ __typename?: 'paymentPlanDetailEntity', title: string, workProgressId: string }> | null } } | null } };

export type AddSaleRebatePackageMutationVariables = Exact<{
  input: AddSalesContractRebateInput;
}>;


export type AddSaleRebatePackageMutation = { __typename?: 'Mutation', addSaleRebatePackage: boolean };

export type EditSaleRebatePackageMutationVariables = Exact<{
  input: EditSalesContractRebateInput;
}>;


export type EditSaleRebatePackageMutation = { __typename?: 'Mutation', editSaleRebatePackage: boolean };

export type GetSalesRebatePackageQueryVariables = Exact<{
  saleId: Scalars['String'];
}>;


export type GetSalesRebatePackageQuery = { __typename?: 'Query', getSalesRebatePackage?: Array<{ __typename?: 'saleRebateListingOutput', id: string, discountAmount: number, discountTitle: string, workProgressName: string, error: boolean, documentNo?: string | null }> | null };

export type DeleteSalesRebateMutationVariables = Exact<{
  saleRebateId: Scalars['String'];
  saleId: Scalars['String'];
}>;


export type DeleteSalesRebateMutation = { __typename?: 'Mutation', deleteSalesRebate: boolean };

export type GetSalesRebatePackageByIdQueryVariables = Exact<{
  saleId: Scalars['String'];
  saleRebateId: Scalars['String'];
}>;


export type GetSalesRebatePackageByIdQuery = { __typename?: 'Query', getSalesRebatePackageById: { __typename?: 'saleRebatePackageEntity', id: string, discountId: string, discountMethod: string, roundingMode: string, roundingPrecision: string, campaignId: string, workProgressId: string, discountAmount: number, displayRoundingPrecision?: string | null, displayRoundingMode?: string | null, displayDiscountMethod?: string | null, rebateId?: string | null, seqNo?: number | null, workProgress: { __typename?: 'workProgressEntity', name: string, id: string }, discount: { __typename?: 'discountEntity', title: string, discountVal?: number | null, prefix?: string | null, discountType?: { __typename?: 'discountTypeEntity', name: string } | null }, campaign: { __typename?: 'campaignEntity', name: string }, rebate?: { __typename?: 'rebateEntity', documentNo?: string | null } | null } };

export type HasTeamQueryVariables = Exact<{ [key: string]: never; }>;


export type HasTeamQuery = { __typename?: 'Query', hasTeam: boolean };

export type GetTeamQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTeamQuery = { __typename?: 'Query', getTeam?: Array<{ __typename?: 'SalesTeamOutput', id: string, name: string, users: Array<{ __typename?: 'SalesTeamUserOuput', id: string, name: string, teamId: string }> }> | null };

export type GetAgencyTeamQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAgencyTeamQuery = { __typename?: 'Query', getAgencyTeam?: Array<{ __typename?: 'AgencyTeamOutput', id: string, name: string, agencyContractId: string, users: Array<{ __typename?: 'AgencyTeamUserOutput', id: string, name: string, agencyContractId: string, agencyId: string }> }> | null };

export type GetSaleSubProductListQueryVariables = Exact<{
  saleID: Scalars['String'];
}>;


export type GetSaleSubProductListQuery = { __typename?: 'Query', getSaleSubProductList: Array<{ __typename?: 'saleSubProductListingOutput', id: string, saleId: string, unitId: string, sellingPrice: number, sellingMethod: string, paymentPlanId?: string | null, unitNo: string, parentId?: string | null }> };

export type GetSaleContractSubProductByIdQueryVariables = Exact<{
  saleId: Scalars['String'];
  subProductId: Scalars['String'];
}>;


export type GetSaleContractSubProductByIdQuery = { __typename?: 'Query', getSaleContractSubProductById: { __typename?: 'saleSubproductEntity', id: string, accountId: string, saleId: string, unitId: string, sellingPrice: number, sellingMethod: string, paymentPlanId?: string | null, unit?: { __typename?: 'unitEntity', id: string, unitNo: string, isBumi: boolean, price: number, unitExt?: { __typename?: 'unitExtensionEntity', paymentPlanId?: string | null } | null } | null, projectPaymentPlan?: { __typename?: 'projectPaymentPlanEntity', id: string, accountId: string, projectId: string, paymentPlanId: string, defaulted: boolean, paymentPlan: { __typename?: 'paymentPlanEntity', id: string, name: string, payMethod?: string | null, details?: Array<{ __typename?: 'paymentPlanDetailEntity', title: string, workProgressId: string }> | null } } | null } };

export type AddSalesContractSubProductMutationVariables = Exact<{
  input: AddSalesContractSubproductInput;
  saleID: Scalars['String'];
  unitID: Scalars['String'];
}>;


export type AddSalesContractSubProductMutation = { __typename?: 'Mutation', addSalesContractSubProduct: boolean };

export type EditSalesContractSubProductMutationVariables = Exact<{
  input: EditSalesContractSubproductInput;
  saleID: Scalars['String'];
  unitID: Scalars['String'];
}>;


export type EditSalesContractSubProductMutation = { __typename?: 'Mutation', editSalesContractSubProduct: boolean };

export type DeleteSalesContractSubProductMutationVariables = Exact<{
  id: Scalars['String'];
  saleID: Scalars['String'];
  unitID: Scalars['String'];
}>;


export type DeleteSalesContractSubProductMutation = { __typename?: 'Mutation', deleteSalesContractSubProduct: boolean };

export type GetUnitIsSubProductByProjectIdQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnitIsSubProductByProjectIdQuery = { __typename?: 'Query', getUnitIsSubProductByProjectId: Array<{ __typename?: 'unitEntity', id: string, unitNo: string, isBumi: boolean, price: number, unitExt?: { __typename?: 'unitExtensionEntity', paymentPlanId?: string | null } | null }> };

export type GetSellingMethodTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSellingMethodTypeQuery = { __typename?: 'Query', getSellingMethodType: Array<{ __typename?: 'sellingMethodSelection', id: string, name: string }> };

export type GetSalesRegistrationListQueryVariables = Exact<{
  projectId: Scalars['String'];
  approvalStatus: Scalars['String'];
}>;


export type GetSalesRegistrationListQuery = { __typename?: 'Query', getSalesRegistrationList: Array<{ __typename?: 'saleRegistrationListingOutput', projectId: string, saleId: string, unitNo: string, saleNo: string, saleDate: any, saleContractPrice: number, purchaserName: string, jointBuyerCount?: number | null, paymentPlanName?: string | null, salesRegistrationNo?: string | null, finalContractPrice: number, saleRegDate?: any | null }> };

export type GetPendingRegisterUnitsQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetPendingRegisterUnitsQuery = { __typename?: 'Query', getPendingRegisterUnits: Array<{ __typename?: 'saleRegistrationListingOutput', saleId: string, unitNo: string, saleNo: string, purchaserName: string }> };

export type GetUnitBookingDetailsBySaleIdQueryVariables = Exact<{
  saleId: Scalars['String'];
  projectId: Scalars['String'];
}>;


export type GetUnitBookingDetailsBySaleIdQuery = { __typename?: 'Query', getUnitBookingDetailsBySaleId: { __typename?: 'saleDetailsOutput', saleId: string, unitId: string, salesPaymentPlan: Array<any>, bookingFee: number, paymentPlan: Array<any>, salePayment: Array<any>, saleDate: any, registerDate?: any | null, saleNo: string, saleListPrice: number, saleContractPrice: number, unitNo: string, taxAmt?: number | null, carPark: any, salePackage: any, discounts: any, others: any, taxRate: number, salesRegistrationNo?: string | null, salesConvertedStatus?: string | null, mainBuyer: { __typename?: 'contactEntity', id: string, fullName: string }, jointBuyer: Array<{ __typename?: 'jointBuyerEntity', id: string, contact: { __typename?: 'contactEntity', id: string, fullName: string } }>, unitDetails: { __typename?: 'unitInfoOutput', unitPrice: number, landArea?: string | null, taxSchemeName: string, taxSchemeId: string, builtUp: number }, address?: { __typename?: 'AddressJson', address?: string | null, country?: string | null, city?: string | null, state?: string | null, postCode?: string | null, AddressType?: string | null, isPrimary?: boolean | null } | null, commissionStructure?: Array<{ __typename?: 'SaleCommissionTeamOutput', id: string, level?: number | null, parentId?: string | null, isDisable?: boolean | null, positionId?: string | null, commonStatus?: string | null, companyCommissionTeamId?: string | null, employee?: { __typename?: 'EmployeeInfo', id: string, employeeName: string } | null, position?: { __typename?: 'PositionInfo', position: string } | null }> | null } };

export type GetCarParkPaymentPlanQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetCarParkPaymentPlanQuery = { __typename?: 'Query', getCarParkPaymentPlan: Array<{ __typename?: 'carParkPaymentPlanListingOutput', id: string, name: string, markUpPercentage: string, projectPaymentPlanId: string, projectPlanStartDate: any, projectPlanEndDate: any }> };

export type GetUnitPriceInfoQueryVariables = Exact<{
  unitId: Scalars['String'];
}>;


export type GetUnitPriceInfoQuery = { __typename?: 'Query', getUnitInfo: { __typename?: 'unitInfoOutput', unitId: string, unitPrice: number, landArea?: string | null, taxSchemeId: string, taxSchemeName: string, landAreaRate?: number | null, builtUp: number, builtUpAreaRate?: number | null, commercialPurpose: string, propertyType: string } };

export type EditUnitTaxSchemeMutationVariables = Exact<{
  unitId: Scalars['String'];
  taxSchemeId: Scalars['String'];
  saleId: Scalars['String'];
}>;


export type EditUnitTaxSchemeMutation = { __typename?: 'Mutation', editUnitTaxScheme: boolean };

export type AddCarParkMutationVariables = Exact<{
  input: AddCarParkInput;
}>;


export type AddCarParkMutation = { __typename?: 'Mutation', addCarPark: string };

export type AddContactPersonMutationVariables = Exact<{
  input: SaleContactPersonInput;
  saleId: Scalars['String'];
}>;


export type AddContactPersonMutation = { __typename?: 'Mutation', addContactPerson: boolean };

export type EditContactPersonMutationVariables = Exact<{
  input: EditSaleContactPersonInput;
  saleId: Scalars['String'];
}>;


export type EditContactPersonMutation = { __typename?: 'Mutation', editContactPerson: boolean };

export type DeleteContactPersonMutationVariables = Exact<{
  saleContactId: Scalars['String'];
}>;


export type DeleteContactPersonMutation = { __typename?: 'Mutation', deleteContactPerson: boolean };

export type AddJointBuyerMutationVariables = Exact<{
  input: Buyer;
}>;


export type AddJointBuyerMutation = { __typename?: 'Mutation', addJointBuyer: boolean };

export type GetCarParkListingQueryVariables = Exact<{
  saleId: Scalars['String'];
}>;


export type GetCarParkListingQuery = { __typename?: 'Query', getCarParkListing: Array<{ __typename?: 'carParkIndOutput', carParkId: string, carParkNo: string, carParkPrice?: number | null, paymentAmt?: number | null, taxSchemeId?: string | null, taxSchemeName?: string | null, sellingMethod: string, paymentPlanId?: string | null, paymentPlanName?: string | null, unitId?: string | null }> };

export type GetCarParkOptionQueryVariables = Exact<{
  projectId: Scalars['String'];
  saleId?: InputMaybe<Scalars['String']>;
  unitId?: InputMaybe<Scalars['String']>;
  carParkId?: InputMaybe<Scalars['String']>;
}>;


export type GetCarParkOptionQuery = { __typename?: 'Query', getCarParkOption: Array<{ __typename?: 'unitEntity', id: string, unitNo: string, price: number }> };

export type GetCarParkInfoQueryVariables = Exact<{
  saleId: Scalars['String'];
  carParkId: Scalars['String'];
}>;


export type GetCarParkInfoQuery = { __typename?: 'Query', getCarParkInfo: { __typename?: 'carParkIndOutput', carParkId: string, carParkNo: string, unitId?: string | null, carParkPrice?: number | null, taxSchemeId?: string | null, taxSchemeName?: string | null, sellingMethod: string, paymentPlanId?: string | null, paymentPlanName?: string | null, taxRate?: number | null, paymentAmt?: number | null } };

export type GetSelectedCarParkPaymentPlanQueryVariables = Exact<{
  carParkId: Scalars['String'];
}>;


export type GetSelectedCarParkPaymentPlanQuery = { __typename?: 'Query', getSelectedCarParkPaymentPlan?: Array<{ __typename?: 'carParkPaymentPlanOutput', id: string, paymentAmt?: number | null, carParkId: string, billAfter: string, billCount: number, billFrequency: string, billType: string, purchaserPaymentPlanDetailsId: string, noInstallment: number, title: string, paymentValue: number, installmentDetails?: Array<{ __typename?: 'carParkInstallmentOutput', documentDate: any, documentAmt: number, billType: string, baseAmt: number, taxAmt: number, description: string }> | null }> | null };

export type GetInstallmentsByCarParkIdQueryVariables = Exact<{
  carParkId: Scalars['String'];
}>;


export type GetInstallmentsByCarParkIdQuery = { __typename?: 'Query', getInstallmentsByCarParkId?: Array<{ __typename?: 'carParkInstallmentEntity', id: string, documentAmt?: number | null, documentDate?: any | null, baseAmt?: number | null, taxAmt?: number | null, description?: string | null, billType?: string | null, carparkPaymentId?: string | null }> | null };

export type CalculateSalesRegDiscountQueryVariables = Exact<{
  input: CalculateSalesRegDiscountInput;
}>;


export type CalculateSalesRegDiscountQuery = { __typename?: 'Query', calculateSalesRegDiscount: any };

export type GetJointBuyerQueryVariables = Exact<{
  contactId: Scalars['String'];
}>;


export type GetJointBuyerQuery = { __typename?: 'Query', getJointBuyer: { __typename?: 'contactEntity', id: string, fullName: string, email?: string | null, phoneNo?: string | null, gender?: string | null, icNo?: string | null, militaryIc?: string | null, homeTel?: string | null, officeTel?: string | null, dob?: any | null, companyName?: string | null, companyRegNo?: string | null, incomeRange?: { __typename?: 'incomeRangeEntity', id: string, range: string } | null, salutation?: { __typename?: 'salutationEntity', name: string, id: string } | null, nationality?: { __typename?: 'sNationalityEntity', name: string, id: string } | null, race?: { __typename?: 'raceEntity', name: string, id: string } | null, maritalStatus?: { __typename?: 'maritalStatusEntity', name: string, id: string } | null, contactExt?: { __typename?: 'contactExtensionEntity', id: string, identityType: string, customerOrigin: string, isVip: boolean, isForeignPurchase: boolean, subscribeMaterialSms: boolean, subscribeMaterialWhatsapp: boolean, subscribeMaterialEmail: boolean, subscribeMaterialPaNews: boolean, mailingMethod: string, professionId?: string | null, religionId?: string | null, nameOnTax?: string | null, taxRegistrationNo?: string | null, taxRegistrationAddress?: string | null, isPrincipalBuyer: boolean, remark?: string | null } | null, contactAddress?: Array<{ __typename?: 'AddressJson', address?: string | null, country?: string | null, city?: string | null, state?: string | null, postCode?: string | null, AddressType?: string | null }> | null }, getAttachment?: Array<{ __typename?: 'attachmentEntity', id: string, fileName: string, bucketFileName: string, resourceUrl: string }> | null };

export type EditJointBuyerMutationVariables = Exact<{
  input: Buyer;
}>;


export type EditJointBuyerMutation = { __typename?: 'Mutation', editJointBuyer: boolean };

export type GetPaymentPlanDetailsQueryVariables = Exact<{
  saleId: Scalars['String'];
  paymentPlanId: Scalars['String'];
  finalContractPrice?: InputMaybe<Scalars['Float']>;
  InstallmentSummaryInput?: InputMaybe<Array<InstallmentSummaryInput> | InstallmentSummaryInput>;
  paymentMarkUpAmt?: InputMaybe<Scalars['Float']>;
  taxSchemeId?: InputMaybe<Scalars['String']>;
  isCarparkOrPackage?: InputMaybe<Scalars['Boolean']>;
  regDate?: InputMaybe<Scalars['DateTime']>;
}>;


export type GetPaymentPlanDetailsQuery = { __typename?: 'Query', getPaymentPlanDetails: { __typename?: 'PaymentPlanInstallmentOutput', paymentPlanId: string, markUpPercentage?: number | null, markUpPrice?: number | null, paymentPlanDate?: any | null, discAmt?: number | null, installmentSummary?: Array<{ __typename?: 'InstallmentSummaryOutput', paymentPlanDetailsId: string, paymentPlanName: string, billType: string, billAfter: string, billFreq: string, billCount: number, markUpPercentage?: number | null, installmentCount?: number | null, totalPayableAmt?: number | null, isFixAmt?: boolean | null, deductBookingFee: DeductBookingFee, installmentDetails?: Array<{ __typename?: 'InstallmentListOutput', billType: string, installementDate: string, baseAmt: number, taxAmt: number, payableAmt: number, seqNo: number, description?: string | null }> | null }> | null } };

export type GetPurchaserInfoQueryVariables = Exact<{
  contactId: Scalars['String'];
}>;


export type GetPurchaserInfoQuery = { __typename?: 'Query', getPurchaserInfo: { __typename?: 'contactEntity', id: string, fullName: string, email?: string | null, phoneNo?: string | null, gender?: string | null, icNo?: string | null, militaryIc?: string | null, homeTel?: string | null, officeTel?: string | null, companyName?: string | null, companyRegNo?: string | null, dob?: any | null, salutation?: { __typename?: 'salutationEntity', name: string, id: string } | null, nationality?: { __typename?: 'sNationalityEntity', name: string, id: string } | null, race?: { __typename?: 'raceEntity', name: string, id: string } | null, maritalStatus?: { __typename?: 'maritalStatusEntity', name: string, id: string } | null, incomeRange?: { __typename?: 'incomeRangeEntity', range: string, id: string } | null, contactExt?: { __typename?: 'contactExtensionEntity', id: string, identityType: string, customerOrigin: string, isVip: boolean, isForeignPurchase: boolean, subscribeMaterialSms: boolean, subscribeMaterialWhatsapp: boolean, subscribeMaterialEmail: boolean, subscribeMaterialPaNews: boolean, mailingMethod: string, professionId?: string | null, religionId?: string | null, nameOnTax?: string | null, taxRegistrationNo?: string | null, taxRegistrationAddress?: string | null, isPrincipalBuyer: boolean, remark?: string | null } | null, contactAddress?: Array<{ __typename?: 'AddressJson', address?: string | null, country?: string | null, city?: string | null, state?: string | null, postCode?: string | null, AddressType?: string | null, isPrimary?: boolean | null }> | null, address?: { __typename?: 'AddressJson', address?: string | null, country?: string | null, city?: string | null, state?: string | null, postCode?: string | null, AddressType?: string | null, isPrimary?: boolean | null } | null }, getAttachment?: Array<{ __typename?: 'attachmentEntity', id: string, fileName: string, bucketFileName: string, resourceUrl: string }> | null };

export type DeleteMainPurchaserMutationVariables = Exact<{
  saleId: Scalars['String'];
}>;


export type DeleteMainPurchaserMutation = { __typename?: 'Mutation', deleteMainPurchaser: boolean };

export type EditPurchaserInfoMutationVariables = Exact<{
  input: Buyer;
}>;


export type EditPurchaserInfoMutation = { __typename?: 'Mutation', editPurchaserInfo: boolean };

export type GetPackageListingQueryVariables = Exact<{
  saleId: Scalars['String'];
}>;


export type GetPackageListingQuery = { __typename?: 'Query', getPackageListing: Array<{ __typename?: 'promotionalPackageOutput', id: string, packageName: string, packageId: string, itemCount: number, openMarketValue?: number | null, sellingPrice?: number | null, sellingMethod: string, taxSchemeId?: string | null, taxSchemeName?: string | null, paymentPlanId?: string | null }> };

export type GetPackageOptionQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetPackageOptionQuery = { __typename?: 'Query', getPackageOption: Array<{ __typename?: 'promotionalPackagesEntity', id: string, name: string, items?: Array<{ __typename?: 'promotionalPackagesItemEntity', costPrice: number, promoPrice: number, description: string, promotionalItem: { __typename?: 'promotionalItemEntity', name: string } }> | null }> };

export type GetPackageInfoQueryVariables = Exact<{
  packageId: Scalars['String'];
}>;


export type GetPackageInfoQuery = { __typename?: 'Query', getPackageInfo: { __typename?: 'salePackageEntity', id: string, sellingMethod: string, taxSchemeId?: string | null, paymentPlanId?: string | null, promotionalPackage: { __typename?: 'promotionalPackagesEntity', id: string, name: string, items?: Array<{ __typename?: 'promotionalPackagesItemEntity', costPrice: number, promoPrice: number, description: string, promotionalItem: { __typename?: 'promotionalItemEntity', name: string } }> | null } } };

export type GetSelectedPackagePaymentPlanQueryVariables = Exact<{
  packageId: Scalars['String'];
}>;


export type GetSelectedPackagePaymentPlanQuery = { __typename?: 'Query', getSelectedPackagePaymentPlan?: Array<{ __typename?: 'packagePaymentPlanOutput', id: string, salePackageId: string, paymentAmt: number, paymentValue: number, purchaserPaymentPlanDetailsId: string, billType: string, billCount: number, billFrequency: string, billAfter: string, noInstallment: number, title: string }> | null };

export type GetInstallmentsByPackageIdQueryVariables = Exact<{
  packageId: Scalars['String'];
}>;


export type GetInstallmentsByPackageIdQuery = { __typename?: 'Query', getInstallmentsByPackageId?: Array<{ __typename?: 'packagesInstallmentEntity', id: string, description?: string | null, documentNo?: string | null, documentDate?: any | null, documentAmt?: number | null, baseAmt?: number | null, taxAmt?: number | null, billType?: string | null, packagesPaymentId?: string | null }> | null };

export type AddPackageIntoSaleMutationVariables = Exact<{
  input: AddPackageInput;
}>;


export type AddPackageIntoSaleMutation = { __typename?: 'Mutation', addPackageIntoSale: string };

export type SubmitSaleIntoRegistrationMutationVariables = Exact<{
  input: SalesRegistrationInput;
}>;


export type SubmitSaleIntoRegistrationMutation = { __typename?: 'Mutation', addSaleIntoRegistration: boolean };

export type ChangeSubmittedSaleStatusMutationVariables = Exact<{
  saleId: Scalars['String'];
  status: Scalars['String'];
}>;


export type ChangeSubmittedSaleStatusMutation = { __typename?: 'Mutation', changeSubmittedSaleStatus: boolean };

export type GetSalesRegistrationMasterDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSalesRegistrationMasterDataQuery = { __typename?: 'Query', getSalesRegistrationsMasterData: any, GetAllMasterInfo: { __typename?: 'MasterDataOutput', CommercialPurposes: any, LeadSources: Array<{ __typename?: 'leadSourceEntity', id: string, name: string }>, Events: Array<{ __typename?: 'eventsEntity', id: string, campaignId: string, name: string, startDate: any, endDate: any }> } };

export type GetContactPersonByIdQueryVariables = Exact<{
  contactPersonId: Scalars['String'];
}>;


export type GetContactPersonByIdQuery = { __typename?: 'Query', getContactPersonById: { __typename?: 'saleContactEntity', id: string, name: string, contactNo: string, officeTel?: string | null, email: string, remark?: string | null, salutationId?: string | null, isPrimary: boolean, relationshipId?: string | null } };

export type GetSalesRegistrationCountQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetSalesRegistrationCountQuery = { __typename?: 'Query', getSalesRegistrationCount: { __typename?: 'salesRegistrationCountOutput', draftCount?: number | null, submittedCount?: number | null, approvedCount?: number | null, rejectedCount?: number | null } };

export type DeleteCarParkMutationVariables = Exact<{
  carParkId: Scalars['String'];
}>;


export type DeleteCarParkMutation = { __typename?: 'Mutation', deleteCarPark: boolean };

export type EditCarParkMutationVariables = Exact<{
  input: EditCarParkInput;
}>;


export type EditCarParkMutation = { __typename?: 'Mutation', editCarPark: boolean };

export type DeletePackageMutationVariables = Exact<{
  packageId: Scalars['String'];
}>;


export type DeletePackageMutation = { __typename?: 'Mutation', deletePackage: boolean };

export type EditPackageSaleRegistrationMutationVariables = Exact<{
  input: EditPackageInput;
}>;


export type EditPackageSaleRegistrationMutation = { __typename?: 'Mutation', editPackageSaleRegistration: boolean };

export type DiscardPendingDataMutationVariables = Exact<{
  input: DiscardPendingDataInput;
}>;


export type DiscardPendingDataMutation = { __typename?: 'Mutation', discardPendingData: boolean };

export type GetSalesDiscountListingQueryVariables = Exact<{
  saleId: Scalars['String'];
}>;


export type GetSalesDiscountListingQuery = { __typename?: 'Query', getSalesDiscountListing: Array<{ __typename?: 'salesDiscountListingOutput', id: string, title?: string | null, description?: string | null, amount: number, discountId: string }> };

export type GetSalesRegistrationDiscountByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetSalesRegistrationDiscountByIdQuery = { __typename?: 'Query', getSalesRegistrationDiscountById: { __typename?: 'salesDiscountDetailOutput', id: string, title?: string | null, description?: string | null, amount: number, prefix?: string | null, method?: string | null, seqNo: number } };

export type CalculateSaleDiscountAmountQueryVariables = Exact<{
  input: CalculateSalesDiscountInput;
}>;


export type CalculateSaleDiscountAmountQuery = { __typename?: 'Query', calculateSaleDiscountAmount: any };

export type ReCalculateTotalSaleDiscountQueryVariables = Exact<{
  saleId: Scalars['String'];
  paymentPlanMarkUpAmt: Scalars['Float'];
}>;


export type ReCalculateTotalSaleDiscountQuery = { __typename?: 'Query', reCalculateTotalSaleDiscount?: number | null };

export type AddSalesRegistrationDiscountMutationVariables = Exact<{
  input: AddSalesContractDiscountInput;
  saleId: Scalars['String'];
}>;


export type AddSalesRegistrationDiscountMutation = { __typename?: 'Mutation', addSalesRegistrationDiscount: string };

export type GetSalesRegistrationELetterQueryVariables = Exact<{
  letterTemplateId: Scalars['String'];
  saleId: Scalars['String'];
}>;


export type GetSalesRegistrationELetterQuery = { __typename?: 'Query', getSalesRegistrationELetter: { __typename?: 'salesRegistrationELetterOutput', content: string, fileName: string } };

export type GetSalesRegistrationELetterTemplateListingQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetSalesRegistrationELetterTemplateListingQuery = { __typename?: 'Query', getSalesRegistrationELetterTemplateListing?: Array<{ __typename?: 'SalesRegistrationEletterTemplateOutput', id: string, name: string, letterType: string, defaulted: boolean }> | null };

export type UpdatePaymentPlanCarParkMutationVariables = Exact<{
  saleId: Scalars['String'];
  regDate?: InputMaybe<Scalars['DateTime']>;
}>;


export type UpdatePaymentPlanCarParkMutation = { __typename?: 'Mutation', updatePaymentPlanCarPark: boolean };

export type UpdatePaymentPlanPackageMutationVariables = Exact<{
  saleId: Scalars['String'];
  regDate?: InputMaybe<Scalars['DateTime']>;
}>;


export type UpdatePaymentPlanPackageMutation = { __typename?: 'Mutation', updatePaymentPlanPackage: boolean };

export type UpdateCarParkInstallmentMutationVariables = Exact<{
  input: BasePaymentPlanSummary;
}>;


export type UpdateCarParkInstallmentMutation = { __typename?: 'Mutation', updateCarParkInstallment: boolean };

export type GetAllSolicitorListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllSolicitorListQuery = { __typename?: 'Query', getAllSolicitorList: Array<{ __typename?: 'solicitorAppointedEntity', id: string, solicitorId?: string | null, name: string, solicitorCode?: string | null, commonStatus: string, projectCount?: number | null, unitCount?: number | null, isExistInMasterData: Array<string>, isExistInTransactionData: Array<string> }> };

export type GetActiveSolicitorQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveSolicitorQuery = { __typename?: 'Query', activeSolicitorList: Array<{ __typename?: 'solicitorAppointedEntity', id: string, solicitorId?: string | null, solicitorCode?: string | null, name: string, email?: string | null, createdTs: any, officeTel?: string | null, contactName?: string | null, contactPhoneNo?: string | null, commonStatus: string, contactEmail?: string | null, address?: { __typename?: 'AddressJson', address?: string | null, city?: string | null, state?: string | null, country?: string | null, postCode?: string | null } | null }> };

export type SolicitorDetailsQueryVariables = Exact<{
  solicitor_appointed_id: Scalars['String'];
}>;


export type SolicitorDetailsQuery = { __typename?: 'Query', solicitorDetails?: { __typename?: 'solicitorAppointedEntity', name: string, solicitorCode?: string | null, email?: string | null, id: string, officeTel?: string | null, contactName?: string | null, contactPhoneNo?: string | null, contactEmail?: string | null, address?: { __typename?: 'AddressJson', address?: string | null, city?: string | null, state?: string | null, country?: string | null, postCode?: string | null } | null, saleBuyerSolicitor: Array<{ __typename?: 'saleEntity', unitId: string, projectId: string, project: { __typename?: 'projectEntity', name: string } }>, saleDeveloperSolicitor: Array<{ __typename?: 'saleEntity', unitId: string, projectId: string, project: { __typename?: 'projectEntity', name: string } }>, saleLoan: Array<{ __typename?: 'saleLoanEntity', sale?: { __typename?: 'saleEntity', unitId: string, projectId: string, project: { __typename?: 'projectEntity', name: string } } | null }> } | null };

export type AddSolicitorMutationVariables = Exact<{
  input: AdminSolicitorInput;
}>;


export type AddSolicitorMutation = { __typename?: 'Mutation', addSolicitor: boolean };

export type EditSolicitorMutationVariables = Exact<{
  input: AdminSolicitorInput;
  solicitor_appointed_id: Scalars['String'];
}>;


export type EditSolicitorMutation = { __typename?: 'Mutation', editSolicitor: boolean };

export type SuspendSolicitorMutationVariables = Exact<{
  solicitor_appointed_id: Scalars['String'];
  isDeletable: Scalars['Boolean'];
}>;


export type SuspendSolicitorMutation = { __typename?: 'Mutation', suspendSolicitor: boolean };

export type ActivateSolicitorByIdMutationVariables = Exact<{
  solicitorAppointedId: Scalars['String'];
}>;


export type ActivateSolicitorByIdMutation = { __typename?: 'Mutation', activateSolicitorById: boolean };

export type GetStakeholderDeemCollectedListingQueryVariables = Exact<{
  solicitorId: Scalars['String'];
}>;


export type GetStakeholderDeemCollectedListingQuery = { __typename?: 'Query', getStakeholderDeemCollectedListing?: Array<{ __typename?: 'StakeholderProcessDeemCollected', solicitorId: string, collectionBatchId: string, collectionDate: any, saleCount: number, totalDeemCollected: number, unitNo?: Array<string> | null, status: string, voidBy?: string | null, documentDate?: any | null, collectionReferenceNo?: string | null, attachment?: Array<{ __typename?: 'attachmentList', fileName: string, mediaType: string, resourceUrl: string }> | null }> | null };

export type GetStakeholderDeemCollectedDetailQueryVariables = Exact<{
  solicitorId: Scalars['String'];
  collectionBatchId: Scalars['String'];
}>;


export type GetStakeholderDeemCollectedDetailQuery = { __typename?: 'Query', getStakeholderDeemCollectedDetail?: { __typename?: 'StakeholderDeemCollectedDetail', solicitorId: string, collectionBatch: string, collectionReferenceNo?: string | null, collectionDate: any, durationFlag: string, totalDeemCollected: number, attachments?: Array<{ __typename?: 'StakeholderAttachment', attachmentId: string, fileName: string, resourceUrl: string, mediaType: string }> | null } | null };

export type GetStakeholderAvailableDeemCollectedUnitQueryVariables = Exact<{
  solicitorId: Scalars['String'];
  mode: Scalars['String'];
  collectionBatchId?: InputMaybe<Scalars['String']>;
}>;


export type GetStakeholderAvailableDeemCollectedUnitQuery = { __typename?: 'Query', getStakeholderAvailableDeemCollectedUnit?: Array<{ __typename?: 'StakeholderAvailableDeemCollectedUnit', saleId: string, unitNo: string, totalDeemCollected: number, deemCollectedIds: Array<string>, deemCollectedData?: Array<{ __typename?: 'DeemCollectedData', bankName?: string | null, buyerName?: string | null, collectionBatchId?: string | null, financierCode?: string | null, financierName?: string | null, pbDescription?: string | null, pbDocumentNo?: string | null, pbId: string, saleId: string, spAmount: number, spDueDate?: string | null, spId: string, unitNo: string, financialBillingId?: string | null }> | null }> | null };

export type AddDeemCollectedMutationVariables = Exact<{
  input: DeemCollectedInput;
}>;


export type AddDeemCollectedMutation = { __typename?: 'Mutation', addDeemCollected: boolean };

export type EditDeemCollectedMutationVariables = Exact<{
  input: EditDeemCollectedInput;
}>;


export type EditDeemCollectedMutation = { __typename?: 'Mutation', editDeemCollected: boolean };

export type PostDeemCollectedMutationVariables = Exact<{
  input: PostDeemCollectedInput;
}>;


export type PostDeemCollectedMutation = { __typename?: 'Mutation', postDeemCollected: boolean };

export type SoftDeleteStakeholderProcessMutationVariables = Exact<{
  collectionBatchId: Scalars['String'];
  solicitorId: Scalars['String'];
}>;


export type SoftDeleteStakeholderProcessMutation = { __typename?: 'Mutation', softDeleteStakeholderProcess: boolean };

export type ReversalStakeholderProcessMutationVariables = Exact<{
  collectionBatchId: Scalars['String'];
  solicitorId: Scalars['String'];
}>;


export type ReversalStakeholderProcessMutation = { __typename?: 'Mutation', reversalStakeholderProcess: boolean };

export type PostReleaseDataMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type PostReleaseDataMutation = { __typename?: 'Mutation', postReleaseData: boolean };

export type ReversalReleaseDataMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ReversalReleaseDataMutation = { __typename?: 'Mutation', reversalReleaseData: boolean };

export type GetAllStakeholderProcessQueryVariables = Exact<{
  project_id: Scalars['String'];
}>;


export type GetAllStakeholderProcessQuery = { __typename?: 'Query', getAllStakeholderProcess: Array<{ __typename?: 'StakeholderProcessListOutput', total: number, data: Array<{ __typename?: 'stakeholderProcessEntity', id: string }> }> };

export type GetPaymentMethodDescQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPaymentMethodDescQuery = { __typename?: 'Query', getPaymentMethodDesc: any };

export type GetStakeholderProcessListingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStakeholderProcessListingQuery = { __typename?: 'Query', getStakeholderProcessListing?: Array<{ __typename?: 'StakeholderProcess', solicitorId: string, solicitorName: string, solicitorCode?: string | null, saleCount: number, totalAmt: number, totalDeemCollected: number, deemCollectedSaleCount: number, totalReleaseAmt: number, releaseSaleCount: number, outstandingReleaseAmt: number, unitIndex: string }> | null };

export type GetStakeholderProcessBySolicitorIdQueryVariables = Exact<{
  solicitorId: Scalars['String'];
}>;


export type GetStakeholderProcessBySolicitorIdQuery = { __typename?: 'Query', getStakeholderProcessBySolicitorId?: { __typename?: 'StakeholderProcess', solicitorId: string, solicitorName: string, solicitorCode?: string | null, saleCount: number, totalAmt: number, totalDeemCollected: number, deemCollectedSaleCount: number, totalReleaseAmt: number, releaseSaleCount: number, outstandingReleaseAmt: number } | null };

export type GetStakeholderUnitSummaryBySolicitorIdQueryVariables = Exact<{
  solicitorId: Scalars['String'];
}>;


export type GetStakeholderUnitSummaryBySolicitorIdQuery = { __typename?: 'Query', getStakeholderUnitSummaryBySolicitorId?: Array<{ __typename?: 'StakeholderUnitSummary', saleId: string, unitNo: string, totalDeemCollected: number, totalReleaseAmt: number, outstandingReleaseAmt: number }> | null };

export type GetStakeholderUnitDetailQueryVariables = Exact<{
  solicitorId: Scalars['String'];
  saleId: Scalars['String'];
}>;


export type GetStakeholderUnitDetailQuery = { __typename?: 'Query', getStakeholderUnitDetail?: Array<{ __typename?: 'StakeholderUnitDetail', saleId: string, unitNo: string, billingDescription: string, dueDate?: any | null, deemCollected: number, outstandingReleaseAmt: number }> | null };

export type ChangeStakeholderMutationVariables = Exact<{
  solicitorId: Scalars['String'];
  saleIdList: Array<Scalars['String']> | Scalars['String'];
}>;


export type ChangeStakeholderMutation = { __typename?: 'Mutation', changeStakeholder: boolean };

export type GetStakeholderReleaseListingQueryVariables = Exact<{
  solicitorId: Scalars['String'];
}>;


export type GetStakeholderReleaseListingQuery = { __typename?: 'Query', getStakeholderReleaseListing?: Array<{ __typename?: 'StakeholderProcessRelease', stakeholderReleaseId: string, solicitorId: string, releaseDate: any, saleCount: number, totalReleaseAmt: number, unitNo?: Array<string> | null, gl_generation_batch?: string | null, status: string, isVoid: boolean, releaseRefNo: string, attachment?: Array<{ __typename?: 'attachmentList', fileName: string, mediaType: string, resourceUrl: string }> | null }> | null };

export type GetStakeholderReleaseUnitQueryVariables = Exact<{
  solicitorId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
}>;


export type GetStakeholderReleaseUnitQuery = { __typename?: 'Query', getStakeholderReleaseUnit?: Array<{ __typename?: 'StakeholderAvailableReleaseUnit', dueDate: any, saleId: string, unitNo: string, outstandingAmt: number, stakeholderProcessId: string, stakeholderProcessReleaseId?: string | null, amount: number, releaseAmt?: number | null, collectionBatch: string, isCheck: boolean, title?: string | null, purchaserName: string, billingStageName: string }> | null };

export type AddReleaseCollectedMutationVariables = Exact<{
  input: ReleaseCollectedInput;
}>;


export type AddReleaseCollectedMutation = { __typename?: 'Mutation', addReleaseCollected: boolean };

export type EditReleaseCollectedMutationVariables = Exact<{
  input: EditReleaseCollectedInput;
}>;


export type EditReleaseCollectedMutation = { __typename?: 'Mutation', editReleaseCollected: boolean };

export type GetStakeholderReleaseDetailQueryVariables = Exact<{
  solicitorId: Scalars['String'];
  stakeholderReleaseId: Scalars['String'];
}>;


export type GetStakeholderReleaseDetailQuery = { __typename?: 'Query', getStakeholderReleaseDetail?: { __typename?: 'StakeholderReleaseDetail', stakeholderReleaseId: string, solicitorId: string, releaseDate: any, releaseMethod: string, releaseReferenceNo?: string | null, releaseRemark?: string | null, attachments?: Array<{ __typename?: 'StakeholderAttachment', attachmentId: string, fileName: string, resourceUrl: string, mediaType: string }> | null, overdueRelease: Array<{ __typename?: 'StakeholderOverdueRelease', dueDate: any, saleCount: number, totalReleaseAmt: number, overdueReleaseUnitDetail: Array<{ __typename?: 'StakeholderOverdueReleaseUnitDetail', saleId: string, unitNo: string, releaseAmt: number }> }> } | null };

export type DeleteReleaseDataMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteReleaseDataMutation = { __typename?: 'Mutation', deleteReleaseData: boolean };

export type GetAllPropertyTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllPropertyTypeQuery = { __typename?: 'Query', getAllPropertyType?: Array<{ __typename?: 'propertyTypeEntity', id: string, name: string, commonStatus: string, defaulted: boolean, commercialPurpose: string, landPlots: boolean, commercialPurposeDesc: string, isDeletable: boolean, isExistInMasterData: Array<string>, isExistInTransactionData: Array<string>, propertyTypeExt?: { __typename?: 'propertyTypeExtEntity', id: string } | null }> | null };

export type GetPropertyTypeExtQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPropertyTypeExtQuery = { __typename?: 'Query', getPropertyTypeExt: Array<{ __typename?: 'propertyTypeExtEntity', id: string, propertyTypeId: string }> };

export type GetPropertyTaxQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPropertyTaxQuery = { __typename?: 'Query', getPropertyTax: Array<{ __typename?: 'taxEntity', id: string, code: string, description: string, classType: string }> };

export type GetPropertyTaxByInputQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPropertyTaxByInputQuery = { __typename?: 'Query', getPropertyTaxByInput: Array<{ __typename?: 'taxEntity', id: string, code: string, description: string, classType: string }> };

export type AddPropertyTypeMutationVariables = Exact<{
  input: PropertyTypeInput;
}>;


export type AddPropertyTypeMutation = { __typename?: 'Mutation', addPropertyType: boolean };

export type EditPropertyTypeMutationVariables = Exact<{
  input: EditPropertyTypeInput;
}>;


export type EditPropertyTypeMutation = { __typename?: 'Mutation', editPropertyType: boolean };

export type DeletePropertyTypeByIdMutationVariables = Exact<{
  propertyTypeId: Scalars['String'];
  isDeletable: Scalars['Boolean'];
}>;


export type DeletePropertyTypeByIdMutation = { __typename?: 'Mutation', deletePropertyTypeById: boolean };

export type ActivatePropertyTypeByIdMutationVariables = Exact<{
  propertyTypeId: Scalars['String'];
}>;


export type ActivatePropertyTypeByIdMutation = { __typename?: 'Mutation', activatePropertyTypeById: boolean };

export type SetDefaultPropertyTypeMutationVariables = Exact<{
  propertyTypeId: Scalars['String'];
}>;


export type SetDefaultPropertyTypeMutation = { __typename?: 'Mutation', setDefaultPropertyType: boolean };

export type RemoveDefaultPropertyTypeMutationVariables = Exact<{
  propertyTypeId: Scalars['String'];
}>;


export type RemoveDefaultPropertyTypeMutation = { __typename?: 'Mutation', removeDefaultPropertyType: boolean };

export type OrganizePropertyTypeMutationVariables = Exact<{
  propertyTypeId: Array<Scalars['String']> | Scalars['String'];
}>;


export type OrganizePropertyTypeMutation = { __typename?: 'Mutation', organizePropertyType: boolean };

export type GetAllProjectTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllProjectTypeQuery = { __typename?: 'Query', getAllProjectType?: Array<{ __typename?: 'projectTypeEntity', id: string, name: string, commonStatus: string, defaulted: boolean, isDeletable: boolean, isExistInMasterData: Array<string>, isExistInTransactionData: Array<string> }> | null };

export type AddProjectTypeMutationVariables = Exact<{
  input: ProjectTypeInput;
}>;


export type AddProjectTypeMutation = { __typename?: 'Mutation', addProjectType: boolean };

export type EditProjectTypeMutationVariables = Exact<{
  input: EditProjectTypeInput;
}>;


export type EditProjectTypeMutation = { __typename?: 'Mutation', editProjectType: boolean };

export type DeleteProjectTypeByIdMutationVariables = Exact<{
  projectTypeId: Scalars['String'];
  isDeletable: Scalars['Boolean'];
}>;


export type DeleteProjectTypeByIdMutation = { __typename?: 'Mutation', deleteProjectTypeById: boolean };

export type ActivateProjectTypeByIdMutationVariables = Exact<{
  projectTypeId: Scalars['String'];
}>;


export type ActivateProjectTypeByIdMutation = { __typename?: 'Mutation', activateProjectTypeById: boolean };

export type SetDefaultProjectTypeMutationVariables = Exact<{
  projectTypeId: Scalars['String'];
}>;


export type SetDefaultProjectTypeMutation = { __typename?: 'Mutation', setDefaultProjectType: boolean };

export type RemoveDefaultProjectTypeMutationVariables = Exact<{
  projectTypeId: Scalars['String'];
}>;


export type RemoveDefaultProjectTypeMutation = { __typename?: 'Mutation', removeDefaultProjectType: boolean };

export type OrganizeProjectTypeMutationVariables = Exact<{
  projectTypeId: Array<Scalars['String']> | Scalars['String'];
}>;


export type OrganizeProjectTypeMutation = { __typename?: 'Mutation', organizeProjectType: boolean };

export type GetAllMaritalStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllMaritalStatusQuery = { __typename?: 'Query', getAllMaritalStatus?: Array<{ __typename?: 'maritalStatusEntity', id: string, name: string, commonStatus: string, defaulted: boolean, isDeletable: boolean, isExistInTransactionData: Array<string> }> | null };

export type EditMaritalStatusMutationVariables = Exact<{
  input: EditMaritalStatusInput;
}>;


export type EditMaritalStatusMutation = { __typename?: 'Mutation', editMaritalStatus: boolean };

export type AddMaritalStatusMutationVariables = Exact<{
  input: MaritalStatusInput;
}>;


export type AddMaritalStatusMutation = { __typename?: 'Mutation', addMaritalStatus: boolean };

export type DeleteMaritalStatusByIdMutationVariables = Exact<{
  maritalStatusId: Scalars['String'];
}>;


export type DeleteMaritalStatusByIdMutation = { __typename?: 'Mutation', deleteMaritalStatusById: boolean };

export type SetDefaultMaritalStatusMutationVariables = Exact<{
  maritalStatusId: Scalars['String'];
}>;


export type SetDefaultMaritalStatusMutation = { __typename?: 'Mutation', setDefaultMaritalStatus: boolean };

export type RemoveDefaultMaritalStatusMutationVariables = Exact<{
  maritalStatusId: Scalars['String'];
}>;


export type RemoveDefaultMaritalStatusMutation = { __typename?: 'Mutation', removeDefaultMaritalStatus: boolean };

export type OrganizeMaritalStatusMutationVariables = Exact<{
  maritalStatusIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type OrganizeMaritalStatusMutation = { __typename?: 'Mutation', organizeMaritalStatus: boolean };

export type ActivateMaritalStatusMutationVariables = Exact<{
  maritalStatusId: Scalars['String'];
}>;


export type ActivateMaritalStatusMutation = { __typename?: 'Mutation', activateMaritalStatus: boolean };

export type DeactivateMaritalStatusMutationVariables = Exact<{
  maritalStatusId: Scalars['String'];
}>;


export type DeactivateMaritalStatusMutation = { __typename?: 'Mutation', deactivateMaritalStatus: boolean };

export type GetAllDirectionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllDirectionQuery = { __typename?: 'Query', getAllDirection?: Array<{ __typename?: 'directionEntity', id: string, name: string, commonStatus: string, defaulted: boolean, isDeletable: boolean, isExistInMasterData: Array<string>, isExistInTransactionData: Array<string> }> | null };

export type EditDirectionMutationVariables = Exact<{
  input: EditDirectionInput;
}>;


export type EditDirectionMutation = { __typename?: 'Mutation', editDirection: boolean };

export type AddDirectionMutationVariables = Exact<{
  input: DirectionInput;
}>;


export type AddDirectionMutation = { __typename?: 'Mutation', addDirection: boolean };

export type DeleteDirectionByIdMutationVariables = Exact<{
  directionId: Scalars['String'];
  isDeletable: Scalars['Boolean'];
}>;


export type DeleteDirectionByIdMutation = { __typename?: 'Mutation', deleteDirectionById: boolean };

export type ActivateDirectionByIdMutationVariables = Exact<{
  directionId: Scalars['String'];
}>;


export type ActivateDirectionByIdMutation = { __typename?: 'Mutation', activateDirectionById: boolean };

export type SetDefaultDirectionMutationVariables = Exact<{
  directionId: Scalars['String'];
}>;


export type SetDefaultDirectionMutation = { __typename?: 'Mutation', setDefaultDirection: boolean };

export type RemoveDefaultDirectionMutationVariables = Exact<{
  directionId: Scalars['String'];
}>;


export type RemoveDefaultDirectionMutation = { __typename?: 'Mutation', removeDefaultDirection: boolean };

export type OrganizeDirectionMutationVariables = Exact<{
  directionId: Array<Scalars['String']> | Scalars['String'];
}>;


export type OrganizeDirectionMutation = { __typename?: 'Mutation', organizeDirection: boolean };

export type GetAllRaceQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllRaceQuery = { __typename?: 'Query', getAllRace?: Array<{ __typename?: 'raceEntity', id: string, name: string, commonStatus: string, defaulted: boolean, isDeletable: boolean, isExistInMasterData: Array<string>, isExistInTransactionData: Array<string> }> | null };

export type AddRaceMutationVariables = Exact<{
  input: RaceInput;
}>;


export type AddRaceMutation = { __typename?: 'Mutation', addRace: boolean };

export type EditRaceMutationVariables = Exact<{
  input: EditRaceInput;
}>;


export type EditRaceMutation = { __typename?: 'Mutation', editRace: boolean };

export type DeleteRaceByIdMutationVariables = Exact<{
  raceId: Scalars['String'];
  isDeletable: Scalars['Boolean'];
}>;


export type DeleteRaceByIdMutation = { __typename?: 'Mutation', deleteRaceById: boolean };

export type ActivateRaceByIdMutationVariables = Exact<{
  raceId: Scalars['String'];
}>;


export type ActivateRaceByIdMutation = { __typename?: 'Mutation', activateRaceById: boolean };

export type SetDefaultRaceMutationVariables = Exact<{
  raceId: Scalars['String'];
}>;


export type SetDefaultRaceMutation = { __typename?: 'Mutation', setDefaultRace: boolean };

export type RemoveDefaultRaceMutationVariables = Exact<{
  raceId: Scalars['String'];
}>;


export type RemoveDefaultRaceMutation = { __typename?: 'Mutation', removeDefaultRace: boolean };

export type OrganizeRaceMutationVariables = Exact<{
  raceIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type OrganizeRaceMutation = { __typename?: 'Mutation', organizeRace: boolean };

export type GetAllUnitTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllUnitTypeQuery = { __typename?: 'Query', getAllUnitType?: Array<{ __typename?: 'unitTypeEntity', id: string, name: string, commonStatus: string, defaulted: boolean, isDeletable: boolean, isExistInMasterData: Array<string>, isExistInTransactionData: Array<string> }> | null };

export type AddUnitTypeMutationVariables = Exact<{
  input: UnitTypeInput;
}>;


export type AddUnitTypeMutation = { __typename?: 'Mutation', addUnitType: boolean };

export type EditUnitTypeMutationVariables = Exact<{
  input: EditUnitTypeInput;
}>;


export type EditUnitTypeMutation = { __typename?: 'Mutation', editUnitType: boolean };

export type DeleteUnitTypeByIdMutationVariables = Exact<{
  unitTypeId: Scalars['String'];
  isDeletable: Scalars['Boolean'];
}>;


export type DeleteUnitTypeByIdMutation = { __typename?: 'Mutation', deleteUnitTypeById: boolean };

export type ActivateUnitTypeByIdMutationVariables = Exact<{
  unitTypeId: Scalars['String'];
}>;


export type ActivateUnitTypeByIdMutation = { __typename?: 'Mutation', activateUnitTypeById: boolean };

export type SetDefaultUnitTypeMutationVariables = Exact<{
  unitTypeId: Scalars['String'];
}>;


export type SetDefaultUnitTypeMutation = { __typename?: 'Mutation', setDefaultUnitType: boolean };

export type RemoveDefaultUnitTypeMutationVariables = Exact<{
  unitTypeId: Scalars['String'];
}>;


export type RemoveDefaultUnitTypeMutation = { __typename?: 'Mutation', removeDefaultUnitType: boolean };

export type OrganizeUnitTypeMutationVariables = Exact<{
  unitTypeId: Array<Scalars['String']> | Scalars['String'];
}>;


export type OrganizeUnitTypeMutation = { __typename?: 'Mutation', organizeUnitType: boolean };

export type GetAllDesignationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllDesignationQuery = { __typename?: 'Query', getAllDesignation?: Array<{ __typename?: 'parameterEntity', id: string, name: string, commonStatus: string, defaulted: boolean, isDeletable: boolean }> | null };

export type AddDesignationMutationVariables = Exact<{
  input: ParameterInput;
}>;


export type AddDesignationMutation = { __typename?: 'Mutation', addDesignation: boolean };

export type EditDesignationMutationVariables = Exact<{
  input: EditParameterInput;
}>;


export type EditDesignationMutation = { __typename?: 'Mutation', editDesignation: boolean };

export type DeleteDesignationByIdMutationVariables = Exact<{
  designationId: Scalars['String'];
}>;


export type DeleteDesignationByIdMutation = { __typename?: 'Mutation', deleteDesignationById: boolean };

export type DeactivateDesignationByIdMutationVariables = Exact<{
  designationId: Scalars['String'];
}>;


export type DeactivateDesignationByIdMutation = { __typename?: 'Mutation', deactivateDesignationById: boolean };

export type ActivateDesignationByIdMutationVariables = Exact<{
  designationId: Scalars['String'];
}>;


export type ActivateDesignationByIdMutation = { __typename?: 'Mutation', activateDesignationById: boolean };

export type GetAllIndustryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllIndustryQuery = { __typename?: 'Query', getAllIndustry?: Array<{ __typename?: 'parameterEntity', id: string, name: string, commonStatus: string, defaulted: boolean, isDeletable: boolean }> | null };

export type AddIndustryMutationVariables = Exact<{
  input: ParameterInput;
}>;


export type AddIndustryMutation = { __typename?: 'Mutation', addIndustry: boolean };

export type EditIndustryMutationVariables = Exact<{
  input: EditParameterInput;
}>;


export type EditIndustryMutation = { __typename?: 'Mutation', editIndustry: boolean };

export type DeleteIndustryByIdMutationVariables = Exact<{
  industryId: Scalars['String'];
}>;


export type DeleteIndustryByIdMutation = { __typename?: 'Mutation', deleteIndustryById: boolean };

export type DeactivateIndustryByIdMutationVariables = Exact<{
  industryId: Scalars['String'];
}>;


export type DeactivateIndustryByIdMutation = { __typename?: 'Mutation', deactivateIndustryById: boolean };

export type ActivateIndustryByIdMutationVariables = Exact<{
  industryId: Scalars['String'];
}>;


export type ActivateIndustryByIdMutation = { __typename?: 'Mutation', activateIndustryById: boolean };

export type GetAllProfessionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllProfessionQuery = { __typename?: 'Query', getAllProfession?: Array<{ __typename?: 'parameterEntity', id: string, name: string, commonStatus: string, defaulted: boolean, isDeletable: boolean, isExistInMasterData: Array<string>, isExistInTransactionData: Array<string> }> | null };

export type AddProfessionMutationVariables = Exact<{
  input: ParameterInput;
}>;


export type AddProfessionMutation = { __typename?: 'Mutation', addProfession: boolean };

export type EditProfessionMutationVariables = Exact<{
  input: EditParameterInput;
}>;


export type EditProfessionMutation = { __typename?: 'Mutation', editProfession: boolean };

export type DeleteProfessionByIdMutationVariables = Exact<{
  professionId: Scalars['String'];
}>;


export type DeleteProfessionByIdMutation = { __typename?: 'Mutation', deleteProfessionById: boolean };

export type DeactivateProfessionByIdMutationVariables = Exact<{
  professionId: Scalars['String'];
}>;


export type DeactivateProfessionByIdMutation = { __typename?: 'Mutation', deactivateProfessionById: boolean };

export type ActivateProfessionByIdMutationVariables = Exact<{
  professionId: Scalars['String'];
}>;


export type ActivateProfessionByIdMutation = { __typename?: 'Mutation', activateProfessionById: boolean };

export type GetAllRelationshipQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllRelationshipQuery = { __typename?: 'Query', getAllRelationship?: Array<{ __typename?: 'parameterEntity', id: string, name: string, commonStatus: string, defaulted: boolean, isDeletable: boolean, isExistInMasterData: Array<string>, isExistInTransactionData: Array<string> }> | null };

export type AddRelationshipMutationVariables = Exact<{
  input: ParameterInput;
}>;


export type AddRelationshipMutation = { __typename?: 'Mutation', addRelationship: boolean };

export type EditRelationshipMutationVariables = Exact<{
  input: EditParameterInput;
}>;


export type EditRelationshipMutation = { __typename?: 'Mutation', editRelationship: boolean };

export type DeleteRelationshipByIdMutationVariables = Exact<{
  relationshipId: Scalars['String'];
}>;


export type DeleteRelationshipByIdMutation = { __typename?: 'Mutation', deleteRelationshipById: boolean };

export type DeactivateRelationshipByIdMutationVariables = Exact<{
  relationshipId: Scalars['String'];
}>;


export type DeactivateRelationshipByIdMutation = { __typename?: 'Mutation', deactivateRelationshipById: boolean };

export type ActivateRelationshipByIdMutationVariables = Exact<{
  relationshipId: Scalars['String'];
}>;


export type ActivateRelationshipByIdMutation = { __typename?: 'Mutation', activateRelationshipById: boolean };

export type GetAllReligionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllReligionQuery = { __typename?: 'Query', getAllReligion?: Array<{ __typename?: 'parameterEntity', id: string, name: string, commonStatus: string, defaulted: boolean, isDeletable: boolean }> | null };

export type AddReligionMutationVariables = Exact<{
  input: ParameterInput;
}>;


export type AddReligionMutation = { __typename?: 'Mutation', addReligion: boolean };

export type EditReligionMutationVariables = Exact<{
  input: EditParameterInput;
}>;


export type EditReligionMutation = { __typename?: 'Mutation', editReligion: boolean };

export type DeleteReligionByIdMutationVariables = Exact<{
  religionId: Scalars['String'];
}>;


export type DeleteReligionByIdMutation = { __typename?: 'Mutation', deleteReligionById: boolean };

export type DeactivateReligionByIdMutationVariables = Exact<{
  religionId: Scalars['String'];
}>;


export type DeactivateReligionByIdMutation = { __typename?: 'Mutation', deactivateReligionById: boolean };

export type ActivateReligionByIdMutationVariables = Exact<{
  religionId: Scalars['String'];
}>;


export type ActivateReligionByIdMutation = { __typename?: 'Mutation', activateReligionById: boolean };

export type OrganizeReligionMutationVariables = Exact<{
  religionIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type OrganizeReligionMutation = { __typename?: 'Mutation', organizeReligion: boolean };

export type GetAllEducationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllEducationQuery = { __typename?: 'Query', getAllEducation?: Array<{ __typename?: 'parameterEntity', id: string, name: string, commonStatus: string, defaulted: boolean, isDeletable: boolean }> | null };

export type AddEducationMutationVariables = Exact<{
  input: ParameterInput;
}>;


export type AddEducationMutation = { __typename?: 'Mutation', addEducation: boolean };

export type DeleteEducationByIdMutationVariables = Exact<{
  educationId: Scalars['String'];
}>;


export type DeleteEducationByIdMutation = { __typename?: 'Mutation', deleteEducationById: boolean };

export type DeactivateEducationByIdMutationVariables = Exact<{
  educationId: Scalars['String'];
}>;


export type DeactivateEducationByIdMutation = { __typename?: 'Mutation', deactivateEducationById: boolean };

export type ActivateEducationByIdMutationVariables = Exact<{
  educationId: Scalars['String'];
}>;


export type ActivateEducationByIdMutation = { __typename?: 'Mutation', activateEducationById: boolean };

export type EditEducationMutationVariables = Exact<{
  input: EditParameterInput;
}>;


export type EditEducationMutation = { __typename?: 'Mutation', editEducation: boolean };

export type GetAllIncomeRangeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllIncomeRangeQuery = { __typename?: 'Query', getAllIncomeRange?: Array<{ __typename?: 'incomeRangeEntity', id: string, range: string, commonStatus: string, defaulted: boolean, isDeletable: boolean, isExistInTransactionData: Array<string> }> | null };

export type AddIncomeRangeMutationVariables = Exact<{
  input: IncomeRangeInput;
}>;


export type AddIncomeRangeMutation = { __typename?: 'Mutation', addIncomeRange: boolean };

export type DeleteIncomeRangeByIdMutationVariables = Exact<{
  incomeRangeId: Scalars['String'];
}>;


export type DeleteIncomeRangeByIdMutation = { __typename?: 'Mutation', deleteIncomeRangeById: boolean };

export type ActivateIncomeRangeByIdMutationVariables = Exact<{
  incomeRangeId: Scalars['String'];
}>;


export type ActivateIncomeRangeByIdMutation = { __typename?: 'Mutation', activateIncomeRangeById: boolean };

export type DeactivateIncomeRangeByIdMutationVariables = Exact<{
  incomeRangeId: Scalars['String'];
}>;


export type DeactivateIncomeRangeByIdMutation = { __typename?: 'Mutation', deactivateIncomeRangeById: boolean };

export type EditIncomeRangeMutationVariables = Exact<{
  input: EditIncomeRangeInput;
}>;


export type EditIncomeRangeMutation = { __typename?: 'Mutation', editIncomeRange: boolean };

export type SetDefaultIncomeRangeMutationVariables = Exact<{
  incomeRangeId: Scalars['String'];
}>;


export type SetDefaultIncomeRangeMutation = { __typename?: 'Mutation', setDefaultIncomeRange: boolean };

export type RemoveDefaultIncomeRangeMutationVariables = Exact<{
  incomeRangeId: Scalars['String'];
}>;


export type RemoveDefaultIncomeRangeMutation = { __typename?: 'Mutation', removeDefaultIncomeRange: boolean };

export type OrganizeIncomeRangeMutationVariables = Exact<{
  incomeRangeIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type OrganizeIncomeRangeMutation = { __typename?: 'Mutation', organizeIncomeRange: boolean };

export type GetAllSalutationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllSalutationQuery = { __typename?: 'Query', getAllSalutation?: Array<{ __typename?: 'salutationEntity', id: string, name: string, commonStatus: string, defaulted: boolean, isDeletable: boolean, isExistInTransactionData: Array<string> }> | null };

export type AddSalutationMutationVariables = Exact<{
  input: SalutationInput;
}>;


export type AddSalutationMutation = { __typename?: 'Mutation', addSalutation: boolean };

export type EditSalutationMutationVariables = Exact<{
  input: EditSalutationInput;
}>;


export type EditSalutationMutation = { __typename?: 'Mutation', editSalutation: boolean };

export type DeleteSalutationByIdMutationVariables = Exact<{
  salutationId: Scalars['String'];
}>;


export type DeleteSalutationByIdMutation = { __typename?: 'Mutation', deleteSalutationById: boolean };

export type SetDefaultSalutationMutationVariables = Exact<{
  salutationId: Scalars['String'];
}>;


export type SetDefaultSalutationMutation = { __typename?: 'Mutation', setDefaultSalutation: boolean };

export type RemoveDefaultSalutationMutationVariables = Exact<{
  salutationId: Scalars['String'];
}>;


export type RemoveDefaultSalutationMutation = { __typename?: 'Mutation', removeDefaultSalutation: boolean };

export type OrganizeSalutationMutationVariables = Exact<{
  salutationIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type OrganizeSalutationMutation = { __typename?: 'Mutation', organizeSalutation: boolean };

export type ActivateSalutationMutationVariables = Exact<{
  salutationId: Scalars['String'];
}>;


export type ActivateSalutationMutation = { __typename?: 'Mutation', activateSalutation: boolean };

export type DeactivateSalutationMutationVariables = Exact<{
  salutationId: Scalars['String'];
}>;


export type DeactivateSalutationMutation = { __typename?: 'Mutation', deactivateSalutation: boolean };

export type OrganizeParameterMutationVariables = Exact<{
  parameterIds: Array<Scalars['String']> | Scalars['String'];
  parameterType: Scalars['String'];
}>;


export type OrganizeParameterMutation = { __typename?: 'Mutation', organizeParameter: boolean };

export type SetDefaultParameterMutationVariables = Exact<{
  parameterId: Scalars['String'];
  parameterType: Scalars['String'];
}>;


export type SetDefaultParameterMutation = { __typename?: 'Mutation', setDefaultParameter: boolean };

export type RemoveDefaultParameterMutationVariables = Exact<{
  parameterId: Scalars['String'];
  parameterType: Scalars['String'];
}>;


export type RemoveDefaultParameterMutation = { __typename?: 'Mutation', removeDefaultParameter: boolean };

export type StandardParameterSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type StandardParameterSummaryQuery = { __typename?: 'Query', propertyTypeCount?: number | null, projectTypeCount?: number | null, unitDirectionCount?: number | null, unitTypeCount?: number | null, raceCount?: number | null, maritalStatusCount?: number | null, salutationCount?: number | null, religonCount?: number | null, relationshipCount?: number | null, educationCount?: number | null, industryCount?: number | null, designationCount?: number | null, professionCount?: number | null, incomeRangeCount?: number | null };

export type GetStatutoryTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStatutoryTypeQuery = { __typename?: 'Query', getStatutoryDocsList?: Array<{ __typename?: 'statutoryDocumentEntity', id: string, code?: string | null, name: string, perSalesContract: boolean }> | null };

export type GetUnitStatutoryDocumentListByTypeQueryVariables = Exact<{
  projectId: Scalars['String'];
  perSalesContract: Scalars['Boolean'];
  statutoryDocumentId: Scalars['String'];
}>;


export type GetUnitStatutoryDocumentListByTypeQuery = { __typename?: 'Query', getUnitStatutoryDocumentListByType?: Array<{ __typename?: 'unitStatutoryListObject', unitStatutoryId: string, projectId: string, unitId: string, unitNo?: string | null, fullName?: string | null, saleId?: string | null, contactId?: string | null, perSalesContract?: boolean | null, totalUploaded: number, totalNeedToBeUpload: number, documents: Array<{ __typename?: 'salesStatutoryObject', id?: string | null, projectId?: string | null, accountId?: string | null, unitStatutoryId?: string | null, statutoryDocumentId?: string | null, documentRef?: string | null, documentDate?: string | null, isMerge?: boolean | null, attachment?: string | null, notaryId?: string | null, bpnLandArea?: number | null, resourceUrl?: string | null, fileName?: string | null, mediaType?: string | null }> }> | null };

export type GetStatutoryUnitListQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetStatutoryUnitListQuery = { __typename?: 'Query', getStatutoryUnitList?: Array<{ __typename?: 'unitStatutoryListByUnitSelectionOutput', unitId: string, unitNo: string, clusterName?: string | null, fullName?: string | null }> | null };

export type GetStatutoryTypeByUnitQueryVariables = Exact<{
  unitId: Scalars['String'];
  projectId: Scalars['String'];
}>;


export type GetStatutoryTypeByUnitQuery = { __typename?: 'Query', getStatutoryTypeByUnit: Array<{ __typename?: 'statutoryTypeListByUnitOutput', statutoryDocId?: string | null, unitStatutoryId?: string | null, code?: string | null, name?: string | null, saleId?: string | null, contactId?: string | null, fullName?: string | null, perSalesContract?: boolean | null, totalUploaded?: number | null, totalNeedToBeUploaded?: number | null, documents: Array<{ __typename?: 'salesStatutoryObject', id?: string | null, accountId?: string | null, unitStatutoryId?: string | null, projectId?: string | null, documentRef?: string | null, documentDate?: string | null, statutoryDocumentId?: string | null, isMerge?: boolean | null, notaryId?: string | null, bpnLandArea?: number | null, attachment?: string | null, resourceUrl?: string | null, fileName?: string | null, mediaType?: string | null }> }> };

export type AddSalesStatutoryDocumentMutationVariables = Exact<{
  input: AddSalesStatutoryDocumentIndoInput;
}>;


export type AddSalesStatutoryDocumentMutation = { __typename?: 'Mutation', addSalesStatutoryDocument: boolean };

export type EditSalesStatutoryDocumentMutationVariables = Exact<{
  input: EditSalesStatutoryDocumentIndoInput;
}>;


export type EditSalesStatutoryDocumentMutation = { __typename?: 'Mutation', editSalesStatutoryDocument: boolean };

export type DeleteSalesStatutoryDocumentMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteSalesStatutoryDocumentMutation = { __typename?: 'Mutation', deleteSalesStatutoryDocument: boolean };

export type MergeSalesStatutoryDocumentMutationVariables = Exact<{
  input: MergeSalesStatutoryDocumentIndoInput;
}>;


export type MergeSalesStatutoryDocumentMutation = { __typename?: 'Mutation', mergeSalesStatutoryDocument: boolean };

export type DownloadStatutoryDocumentListQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type DownloadStatutoryDocumentListQuery = { __typename?: 'Query', downloadStatutoryDocumentList: { __typename?: 'UnitExcelOutput', base64: string, isSubProduct: boolean, projectname: string } };

export type UploadStatutoryDocumentListQueryVariables = Exact<{
  projectId: Scalars['String'];
  file: Scalars['Upload'];
}>;


export type UploadStatutoryDocumentListQuery = { __typename?: 'Query', uploadStatutoryDocumentList: { __typename?: 'uploadStatutoryReturnOutput', message: string } };

export type GetNotarySelectionListQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetNotarySelectionListQuery = { __typename?: 'Query', getNotarySelectionList: Array<{ __typename?: 'notarySelectionOutput', notaryId: string, name: string }> };

export type GetAllSubsaleQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllSubsaleQuery = { __typename?: 'Query', getAllSubsale: Array<{ __typename?: 'subsaleListingOutput', id: string, unitNo: string, spaDate: any, sellingPrice: number, purchaserName: string, status: string, isCompany?: boolean | null, companyName?: string | null }> };

export type GetSubsaleByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetSubsaleByIdQuery = { __typename?: 'Query', getSubsaleById?: { __typename?: 'subsaleEntity', id: string, subsaleCategory: string, rrDate: any, spaDate: any, sellingPrice: number, doaDate: any, buyerSolicitorId: string, buyerSolicitorReferenceNo: string, vendorSolicitorId: string, vendorSolicitorReferenceNo: string, administrationCharges: number, printingCharges: number, serviceChargeDeposit: number, dmcDate: any, buyerName: string, buyerIdentityNo: string, isCompany: boolean, contactId: string, units?: { __typename?: 'unitEntity', id: string, unitNo: string } | null, subsaleContactName?: { __typename?: 'contactEntity', companyName?: string | null, companyRegNo?: string | null, icNo?: string | null, militaryIc?: string | null, fullName: string, gender?: string | null, email?: string | null, homeTel?: string | null, phoneNo?: string | null, officeTel?: string | null, nationality?: { __typename?: 'sNationalityEntity', id: string, name: string } | null, salutation?: { __typename?: 'salutationEntity', id: string, name: string } | null, race?: { __typename?: 'raceEntity', id: string, name: string } | null, maritalStatus?: { __typename?: 'maritalStatusEntity', id: string, name: string } | null, address?: { __typename?: 'AddressJson', address?: string | null, country?: string | null, postCode?: string | null, state?: string | null, city?: string | null } | null, subsaleContactExtension?: { __typename?: 'contactExtensionEntity', customerOrigin: string, identityType: string, remark?: string | null, isBumi: boolean, isForeignPurchase: boolean, subscribeMaterialSms: boolean, subscribeMaterialWhatsapp: boolean, subscribeMaterialEmail: boolean, subscribeMaterialPaNews: boolean, mailingMethod: string } | null } | null, subsaleJointBuyers?: Array<{ __typename?: 'subsaleJointBuyerEntity', id: string, subsaleJointBuyerContactName?: { __typename?: 'contactEntity', icNo?: string | null, militaryIc?: string | null, fullName: string, gender?: string | null, email?: string | null, homeTel?: string | null, phoneNo?: string | null, officeTel?: string | null, nationality?: { __typename?: 'sNationalityEntity', id: string, name: string } | null, salutation?: { __typename?: 'salutationEntity', id: string, name: string } | null, race?: { __typename?: 'raceEntity', id: string, name: string } | null, maritalStatus?: { __typename?: 'maritalStatusEntity', id: string, name: string } | null, address?: { __typename?: 'AddressJson', address?: string | null, country?: string | null, postCode?: string | null, state?: string | null, city?: string | null } | null, subsaleJointBuyerContactExtension?: { __typename?: 'contactExtensionEntity', customerOrigin: string, identityType: string, remark?: string | null, isBumi: boolean, isForeignPurchase: boolean, subscribeMaterialSms: boolean, subscribeMaterialWhatsapp: boolean, subscribeMaterialEmail: boolean, subscribeMaterialPaNews: boolean, mailingMethod: string } | null } | null }> | null, subsaleLoans?: Array<{ __typename?: 'subsaleLoanEntity', id: string, financierId: string, financierReferenceNo: string, RRDate: any, RRSolicitorId: string, RRSolicitorReferenceNo: string, DOADate: any, DOASolicitorId: string, DOASolicitorReferenceNo: string, LoanSolicitorId: string, loanSolicitorReferenceNo: string, subsaleFinancierName?: { __typename?: 'financierEntity', name: string, financierCode?: string | null } | null }> | null } | null };

export type GetSubsaleUnitDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetSubsaleUnitDetailQuery = { __typename?: 'Query', getSubsaleUnitDetail?: { __typename?: 'unitDetailOutput', unitId?: string | null, unitNo?: string | null, purchaserName?: string | null, buyerSolicitorName?: string | null, buyerSolicitorCode?: string | null, isCompany?: boolean | null, companyName?: string | null } | null };

export type GetSubsaleUnitQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSubsaleUnitQuery = { __typename?: 'Query', getSubsaleUnit?: Array<{ __typename?: 'unitDetailOutput', unitId?: string | null, unitNo?: string | null, purchaserName?: string | null, buyerSolicitorName?: string | null, buyerSolicitorCode?: string | null, isCompany?: boolean | null, companyName?: string | null }> | null };

export type GetSubsaleContactListQueryVariables = Exact<{
  isCompany: Scalars['Boolean'];
}>;


export type GetSubsaleContactListQuery = { __typename?: 'Query', getSubsaleContactList?: Array<{ __typename?: 'contactEntity', id: string, fullName: string, email?: string | null, phoneNo?: string | null, gender?: string | null, icNo?: string | null, militaryIc?: string | null, companyName?: string | null, companyRegNo?: string | null, homeTel?: string | null, officeTel?: string | null, salutation?: { __typename?: 'salutationEntity', id: string } | null, nationality?: { __typename?: 'sNationalityEntity', id: string } | null, race?: { __typename?: 'raceEntity', id: string } | null, maritalStatus?: { __typename?: 'maritalStatusEntity', id: string } | null, address?: { __typename?: 'AddressJson', address?: string | null, country?: string | null, city?: string | null, state?: string | null, postCode?: string | null } | null, contactExt?: { __typename?: 'contactExtensionEntity', identityType: string, customerOrigin: string, isBumi: boolean, isForeignPurchase: boolean, subscribeMaterialSms: boolean, subscribeMaterialWhatsapp: boolean, subscribeMaterialEmail: boolean, subscribeMaterialPaNews: boolean, mailingMethod: string, remark?: string | null } | null }> | null };

export type GetSubsaleLoanByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetSubsaleLoanByIdQuery = { __typename?: 'Query', getSubsaleLoanById?: { __typename?: 'subsaleLoanEntity', financierId: string, financierReferenceNo: string, RRDate: any, RRSolicitorId: string, RRSolicitorReferenceNo: string, DOADate: any, DOASolicitorId: string, DOASolicitorReferenceNo: string, LoanSolicitorId: string, loanSolicitorReferenceNo: string } | null };

export type GetSubsaleJointBuyerByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetSubsaleJointBuyerByIdQuery = { __typename?: 'Query', getSubsaleJointBuyerById?: { __typename?: 'subsaleJointBuyerEntity', subsaleJointBuyerContactName?: { __typename?: 'contactEntity', icNo?: string | null, militaryIc?: string | null, fullName: string, gender?: string | null, email?: string | null, homeTel?: string | null, phoneNo?: string | null, officeTel?: string | null, nationality?: { __typename?: 'sNationalityEntity', name: string } | null, salutation?: { __typename?: 'salutationEntity', name: string } | null, race?: { __typename?: 'raceEntity', name: string } | null, maritalStatus?: { __typename?: 'maritalStatusEntity', name: string } | null, address?: { __typename?: 'AddressJson', address?: string | null, country?: string | null, postCode?: string | null, state?: string | null, city?: string | null } | null, subsaleJointBuyerContactExtension?: { __typename?: 'contactExtensionEntity', customerOrigin: string, identityType: string, remark?: string | null, isBumi: boolean, isForeignPurchase: boolean, subscribeMaterialSms: boolean, subscribeMaterialWhatsapp: boolean, subscribeMaterialEmail: boolean, subscribeMaterialPaNews: boolean, mailingMethod: string } | null } | null } | null };

export type AddSubsaleMutationVariables = Exact<{
  input: AddSubsaleInput;
}>;


export type AddSubsaleMutation = { __typename?: 'Mutation', addSubsale: boolean };

export type EditSubsaleMutationVariables = Exact<{
  input: EditSubsaleInput;
}>;


export type EditSubsaleMutation = { __typename?: 'Mutation', editSubsale: boolean };

export type DeleteSubsaleMutationVariables = Exact<{
  subsaleId: Scalars['String'];
}>;


export type DeleteSubsaleMutation = { __typename?: 'Mutation', deleteSubsale: boolean };

export type CompleteSubsaleMutationVariables = Exact<{
  subsaleId: Scalars['String'];
}>;


export type CompleteSubsaleMutation = { __typename?: 'Mutation', completeSubsale: boolean };

export type ReopenSubsaleMutationVariables = Exact<{
  subsaleId: Scalars['String'];
}>;


export type ReopenSubsaleMutation = { __typename?: 'Mutation', reopenSubsale: boolean };

export type GetAllNationalityQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllNationalityQuery = { __typename?: 'Query', getAllNationality: Array<{ __typename?: 'sNationalityEntity', id: string, name: string }> };

export type GetAllSaleUnitNoByProjectIdQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetAllSaleUnitNoByProjectIdQuery = { __typename?: 'Query', getAllSaleUnitNoList?: Array<{ __typename?: 'saleEntity', id: string, unitId: string, contact: { __typename?: 'contactEntity', id: string }, unit: { __typename?: 'unitEntity', unitNo: string } }> | null };

export type GetCurrentBuyerDetailsQueryVariables = Exact<{
  saleId: Scalars['String'];
}>;


export type GetCurrentBuyerDetailsQuery = { __typename?: 'Query', getCurrentBuyerDetails?: Array<{ __typename?: 'saleEntity', id: string, contact: { __typename?: 'contactEntity', id: string, fullName: string }, buyerSolicitor?: { __typename?: 'solicitorAppointedEntity', id: string, name: string } | null }> | null };

export type GetEndFinancierDetailsByProjectIdQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetEndFinancierDetailsByProjectIdQuery = { __typename?: 'Query', getEndFinancierDetails: Array<{ __typename?: 'endfinProjectFinancierEntity', id: string, financier: { __typename?: 'financierEntity', id: string, name: string } }> };

export type GetSolicitorAppointedListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSolicitorAppointedListQuery = { __typename?: 'Query', getSolicitorAppointedList: Array<{ __typename?: 'solicitorAppointedEntity', id: string, name: string }> };

export type GetUnitBookingListingSaleQueryVariables = Exact<{
  projectId: Scalars['String'];
  approvalStatus?: InputMaybe<Scalars['String']>;
}>;


export type GetUnitBookingListingSaleQuery = { __typename?: 'Query', getUnitBookingListingSale?: Array<{ __typename?: 'unitBookingListingOutput', saleId: string, bookDate: any, salesNo: string, unitId: string, unitNo: string, fullName: string, sellingPrice: number, totalBookingFee?: number | null, collectedBookingFee?: number | null, saleBookingAmount?: number | null, pendingBookingFee?: number | null, jointBuyerCount?: number | null, salesConvertedStatus?: string | null, convertedToBooking: boolean }> | null };

export type GetCountStatusBookingQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetCountStatusBookingQuery = { __typename?: 'Query', getCountStatusBooking?: Array<{ __typename?: 'countStatusBookingOutput', status?: string | null, convertedStatus?: string | null, collectedBookingFee?: number | null }> | null };

export type GetUnitBookingDetailsQueryVariables = Exact<{
  projectId: Scalars['String'];
  saleId: Scalars['String'];
}>;


export type GetUnitBookingDetailsQuery = { __typename?: 'Query', getUnitBookingDetails: { __typename?: 'unitBookingDetailsOutput', projectId: string, saleId: string, bookDate: any, salesNo: string, unitId: string, contactId: string, unitNo: string, bookingFee?: number | null, builtUp?: number | null, builtUpAreaRate?: number | null, landArea?: number | null, unitClusterId: string, landAreaRate?: number | null, commercialPurpose: string, propertyTypeName: string, taxScheme?: string | null, fullName: string, jointBuyerCount?: number | null, amount?: number | null, sellingPrice: number, professionId?: string | null, religionId?: string | null, nameOnTax?: string | null, taxRegistrationNo?: string | null, taxRegistrationAddress?: string | null, officeTel?: string | null, homeTel?: string | null, phoneNo?: string | null, jointBuyers?: Array<{ __typename?: 'jointBuyerOutput', jointBuyerId?: string | null, contactId?: string | null, jointBuyerName?: string | null, religionIdJoint?: string | null, professionIdJoint?: string | null, officeTelJoint?: string | null, homeTelJoint?: string | null, phoneNoJoint?: string | null, nameOnTaxJoint?: string | null, taxRegistrationNoJoint?: string | null, taxRegistrationAddressJoint?: string | null }> | null } };

export type GetPurchaserDetailsByContactIdQueryVariables = Exact<{
  saleId: Scalars['String'];
  contactId: Scalars['String'];
}>;


export type GetPurchaserDetailsByContactIdQuery = { __typename?: 'Query', getPurchaserDetailsByContactId: { __typename?: 'unitBookingPurchaserDetailsOutput', fullName: string, identityNo: string, nationality: string, email: string, identityType?: string | null, salutation?: string | null, maritalStatus?: string | null, gender?: string | null, dob?: any | null, incomeRange?: string | null, customerOrigin?: string | null, profession?: string | null, religion?: string | null, nameOnTax?: string | null, taxRegistrationNo?: string | null, taxRegistrationAddress?: string | null, otherContactNumber?: string | null, otherOfficeTelNo?: string | null, otherHomeTelNo?: string | null, mailingMethod?: string | null, subscribeMaterialEmail?: boolean | null, subscribeMaterialSms?: boolean | null, subscribeMaterialWhatsApp?: boolean | null, subscribeMaterialPaNews?: boolean | null, remarks?: string | null, isPrincipalBuyer?: boolean | null, addressDetail?: { __typename?: 'AddressJson', address?: string | null, country?: string | null, city?: string | null, state?: string | null, postCode?: string | null } | null, contactAddresses?: Array<{ __typename?: 'AddressJson', AddressType?: string | null, address?: string | null, country?: string | null, city?: string | null, state?: string | null, postCode?: string | null } | null> | null } };

export type GetJointBuyerDetailsByContactIdQueryVariables = Exact<{
  jointBuyerId: Scalars['String'];
  contactId: Scalars['String'];
}>;


export type GetJointBuyerDetailsByContactIdQuery = { __typename?: 'Query', getJointBuyerDetailsByContactId: { __typename?: 'unitBookingPurchaserDetailsOutput', fullName: string, identityNo: string, nationality: string, email: string, identityType?: string | null, salutation?: string | null, maritalStatus?: string | null, gender?: string | null, customerOrigin?: string | null, profession?: string | null, religion?: string | null, nameOnTax?: string | null, taxRegistrationNo?: string | null, taxRegistrationAddress?: string | null, otherContactNumber?: string | null, otherOfficeTelNo?: string | null, otherHomeTelNo?: string | null, mailingMethod?: string | null, subscribeMaterialEmail?: boolean | null, subscribeMaterialSms?: boolean | null, subscribeMaterialWhatsApp?: boolean | null, subscribeMaterialPaNews?: boolean | null, remarks?: string | null, isPrincipalBuyer?: boolean | null, addressDetail?: { __typename?: 'AddressJson', address?: string | null, country?: string | null, city?: string | null, state?: string | null, postCode?: string | null } | null } };

export type GetBookingFeeListingBySaleIdQueryVariables = Exact<{
  saleId: Scalars['String'];
}>;


export type GetBookingFeeListingBySaleIdQuery = { __typename?: 'Query', getBookingFeeListingBySaleId?: { __typename?: 'unitBookingFeeListingOutput', saleInfo: { __typename?: 'unitBookingListingOutput', saleId: string, bookDate: any, salesNo: string, unitId: string, unitNo: string, fullName: string, sellingPrice: number, totalBookingFee?: number | null, collectedBookingFee?: number | null, pendingBookingFee?: number | null, jointBuyerCount?: number | null }, bookingFeeList?: Array<{ __typename?: 'unitBookingBookingFeeOutput', saleId: string, salePaymentId: string, transactionDate?: any | null, receiptNo?: string | null, remark?: string | null, amount?: number | null, status?: string | null, verificationStatus?: string | null }> | null } | null };

export type GetBookingFeeByIdQueryVariables = Exact<{
  salePaymentId: Scalars['String'];
}>;


export type GetBookingFeeByIdQuery = { __typename?: 'Query', getBookingFeeById: { __typename?: 'bookingFeeDetailsOuput', paymentDate?: any | null, trNo?: string | null, paymentMethod: string, paymentAmt?: number | null, paymentRefNo?: string | null, paymentRemarks?: string | null, modBy?: string | null, modTs?: any | null, paymentStatus?: string | null, bankId?: string | null, attachment?: Array<{ __typename?: 'attachmentEntity', id: string, fileName: string, isPrivate: boolean, mediaType: string, resourceUrl: string }> | null } };

export type GetUnitByStatusQueryVariables = Exact<{
  projectId: Scalars['String'];
  launchDate: Scalars['DateTime'];
}>;


export type GetUnitByStatusQuery = { __typename?: 'Query', getUnitByStatus?: Array<{ __typename?: 'unitByStatusOutput', projectId: string, unitClusterId: string, unitId: string, unitNo: string, price: string, unitStatus: string, builtUp?: number | null, builtUpAreaRate?: number | null, landArea?: number | null, landAreaRate?: number | null, commercialPurpose: string, propertyTypeName: string }> | null };

export type GetUnitByUnitIdQueryVariables = Exact<{
  projectId: Scalars['String'];
  unitId: Scalars['String'];
}>;


export type GetUnitByUnitIdQuery = { __typename?: 'Query', getUnitByUnitId?: { __typename?: 'unitByStatusOutput', projectId: string, unitClusterId: string, unitId: string, unitNo: string, unitStatus: string, builtUp?: number | null, builtUpAreaRate?: number | null, landArea?: number | null, landAreaRate?: number | null, commercialPurpose: string, propertyTypeName: string } | null };

export type GetProfessionByIdQueryVariables = Exact<{
  professionId: Scalars['String'];
}>;


export type GetProfessionByIdQuery = { __typename?: 'Query', getProfessionById: { __typename?: 'parameterEntity', id: string, name: string } };

export type GetReligionByIdQueryVariables = Exact<{
  religionId: Scalars['String'];
}>;


export type GetReligionByIdQuery = { __typename?: 'Query', getReligionById: { __typename?: 'parameterEntity', id: string, name: string } };

export type BookingContactListQueryVariables = Exact<{ [key: string]: never; }>;


export type BookingContactListQuery = { __typename?: 'Query', BookingContactList: Array<{ __typename?: 'bookingContactSaleOutput', contactId: string, fullName: string, nationality?: string | null, identityNo?: string | null, otherContactNumber?: string | null, email: string, gender?: string | null, dob?: any | null, incomeRange?: string | null, contactExtId?: string | null, salutation?: string | null, maritalStatus?: string | null, identityType?: string | null, profession?: string | null, religion?: string | null, nameOnTax?: string | null, taxRegistrationAddress?: string | null, taxRegistrationNo?: string | null, mailingMethod?: string | null, subscribeMaterialEmail?: boolean | null, subscribeMaterialSms?: boolean | null, subscribeMaterialWhatsApp?: boolean | null, subscribeMaterialPaNews?: boolean | null, remarks?: string | null, customerOrigin?: string | null, companyName?: string | null, companyRegNo?: string | null, isForeignPurchase?: boolean | null, isVip?: boolean | null, correspondenceAddress?: { __typename?: 'AddressJson', state?: string | null, city?: string | null, postCode?: string | null, country?: string | null, address?: string | null } | null }> };

export type GetAddressListByContactQueryVariables = Exact<{
  contactId: Scalars['String'];
}>;


export type GetAddressListByContactQuery = { __typename?: 'Query', getAddressListByContact: Array<{ __typename?: 'getAddressListByContactOutput', contactId?: string | null, addressList?: { __typename?: 'AddressJson', state?: string | null, city?: string | null, postCode?: string | null, country?: string | null, address?: string | null, AddressType?: string | null } | null }> };

export type AddAndEditBookingFeeBySaleIdMutationVariables = Exact<{
  input: AddAndEditBookingFeeInput;
}>;


export type AddAndEditBookingFeeBySaleIdMutation = { __typename?: 'Mutation', addAndEditBookingFeeBySaleId: boolean };

export type ApproveAndCancelBookingFeeByIdMutationVariables = Exact<{
  input: ApproveAndCancelBookingFeeInput;
}>;


export type ApproveAndCancelBookingFeeByIdMutation = { __typename?: 'Mutation', approveAndCancelBookingFeeById: boolean };

export type SaveBookingExpressMutationVariables = Exact<{
  input: AddNewUnitBookingInput;
}>;


export type SaveBookingExpressMutation = { __typename?: 'Mutation', saveBookingExpress: boolean };

export type TemporaryUploadUnitBookingMutationVariables = Exact<{
  input: TemporaryUploadPurchaser;
}>;


export type TemporaryUploadUnitBookingMutation = { __typename?: 'Mutation', temporaryUploadUnitBooking: boolean };

export type GetBookingFeeELetterTemplateListingQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetBookingFeeELetterTemplateListingQuery = { __typename?: 'Query', getBookingFeeELetterTemplateListing?: Array<{ __typename?: 'bookingFeeEletterTemplateOutput', id: string, name: string, letterType: string, defaulted: boolean }> | null };

export type GetBookingFeeELetterQueryVariables = Exact<{
  letterTemplateId: Scalars['String'];
  salePaymentId: Scalars['String'];
}>;


export type GetBookingFeeELetterQuery = { __typename?: 'Query', getBookingFeeELetter: { __typename?: 'bookingFeeELetterOutput', content: string, fileName: string } };

export type GetUnitTransferListingQueryVariables = Exact<{
  status: Scalars['String'];
}>;


export type GetUnitTransferListingQuery = { __typename?: 'Query', getUnitTransferListing?: Array<{ __typename?: 'unitTransferDetailOutput', id?: string | null, saleId: string, oldUnitNo: string, fullName: string, phoneNo: string, builtUp?: number | null, builtUpArea?: number | null, landArea?: number | null, extraLandArea?: number | null, builtUpAreaRate?: number | null, landAreaRate?: number | null, extraLandAreaRate?: number | null, sellingPrice?: number | null, paymentPlanName?: string | null, discardBumiDiscount?: boolean | null, newUnitNo?: string | null, newBuiltUp?: number | null, newBuiltUpArea?: number | null, newLandArea?: number | null, newExtraLandArea?: number | null, newBuiltUpAreaRate?: number | null, newLandAreaRate?: number | null, newExtraLandAreaRate?: number | null, newListPrice: number, newSellingPrice: number, paymentPlanId?: string | null, transferDate: any, paymentMethod?: string | null, administrationCharges?: number | null, reason: string, remark?: string | null, approvalRoleId?: string | null, oldSaleDetail?: { __typename?: 'oldUnitSaleDetail', discounts?: Array<{ __typename?: 'newDiscountList', discountId?: string | null, title?: string | null, amount?: number | null, formula?: string | null, discountMethod?: string | null }> | null } | null, newDiscount?: { __typename?: 'newDiscount', discardBumi?: boolean | null, discounts?: Array<{ __typename?: 'newDiscountList', discountId?: string | null, title?: string | null, amount?: number | null, formula?: string | null, discountMethod?: string | null }> | null } | null }> | null };

export type GetUnitTransferByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetUnitTransferByIdQuery = { __typename?: 'Query', getUnitTransferById?: { __typename?: 'unitTransferDetailOutput', oldUnitId?: string | null, oldUnitNo: string, builtUp?: number | null, builtUpArea?: number | null, landArea?: number | null, extraLandArea?: number | null, builtUpAreaRate?: number | null, landAreaRate?: number | null, extraLandAreaRate?: number | null, sellingPrice?: number | null, discardBumiDiscount?: boolean | null, fullName: string, phoneNo: string, isCompany?: boolean | null, companyName?: string | null, companyRegNo?: string | null, paymentPlanName?: string | null, saleId: string, newUnitId: string, newUnitNo?: string | null, newBuiltUp?: number | null, newBuiltUpArea?: number | null, newLandArea?: number | null, newExtraLandArea?: number | null, newBuiltUpAreaRate?: number | null, newLandAreaRate?: number | null, newExtraLandAreaRate?: number | null, newListPrice: number, newSellingPrice: number, transferDate: any, paymentPlanId?: string | null, paymentMethod?: string | null, administrationCharges?: number | null, reason: string, remark?: string | null, oldSaleDetail?: { __typename?: 'oldUnitSaleDetail', discounts?: Array<{ __typename?: 'newDiscountList', discountId?: string | null, title?: string | null, seqNo?: number | null, amount?: number | null, formula?: string | null, discountMethod?: string | null }> | null } | null, newDiscount?: { __typename?: 'newDiscount', discardBumi?: boolean | null, discounts?: Array<{ __typename?: 'newDiscountList', discountId?: string | null, title?: string | null, seqNo?: number | null, amount?: number | null, formula?: string | null, discountMethod?: string | null }> | null } | null } | null };

export type GetUnitTransferDropdownQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnitTransferDropdownQuery = { __typename?: 'Query', getUnitTransferDropdown?: Array<{ __typename?: 'unitTransferDropdownOutput', saleId?: string | null, unitId: string, unitNo: string, fullName?: string | null, phoneNo?: string | null, builtUp?: number | null, builtUpArea?: number | null, landArea?: number | null, extraLandArea?: number | null, builtUpAreaRate?: number | null, landAreaRate?: number | null, extraLandAreaRate?: number | null, sellingPrice?: number | null, paymentPlanName?: string | null, isCompany?: boolean | null, companyName?: string | null, companyRegNo?: string | null, nricNo?: string | null, discardBumiDiscount?: boolean | null, discountList?: Array<{ __typename?: 'discountDetail', discountId?: string | null, title?: string | null, discountMethod?: string | null, amount?: number | null, seqNo?: number | null, formula?: string | null }> | null }> | null };

export type GetAvailableUnitDropdownQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAvailableUnitDropdownQuery = { __typename?: 'Query', getAvailableUnitDropdown?: Array<{ __typename?: 'unitTransferDropdownOutput', unitId: string, unitNo: string, builtUp?: number | null, builtUpArea?: number | null, landArea?: number | null, extraLandArea?: number | null, builtUpAreaRate?: number | null, landAreaRate?: number | null, extraLandAreaRate?: number | null, listPrice?: number | null, paymentPlanId?: string | null }> | null };

export type GetPaymentPlanDropdownQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPaymentPlanDropdownQuery = { __typename?: 'Query', getPaymentPlanDropdown: Array<{ __typename?: 'projectPaymentPlanEntity', id: string, paymentPlanId: string, defaulted: boolean, paymentPlan: { __typename?: 'paymentPlanEntity', name: string, payMethod?: string | null, effectiveDate: any } }> };

export type GetUnitTransferReasonQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnitTransferReasonQuery = { __typename?: 'Query', getUnitTransferReason: Array<{ __typename?: 'reasonCodeEntity', id: string, name: string, defaulted: boolean }> };

export type AddUnitTransferMutationVariables = Exact<{
  input: AddUnitTransferInput;
}>;


export type AddUnitTransferMutation = { __typename?: 'Mutation', addUnitTransfer: boolean };

export type EditUnitTransferMutationVariables = Exact<{
  input: EditUnitTransferInput;
}>;


export type EditUnitTransferMutation = { __typename?: 'Mutation', editUnitTransfer: boolean };

export type DeleteUnitTransferMutationVariables = Exact<{
  unitTransferId: Scalars['String'];
}>;


export type DeleteUnitTransferMutation = { __typename?: 'Mutation', deleteUnitTransfer: boolean };

export type RejectUnitTransferMutationVariables = Exact<{
  unitTransferIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type RejectUnitTransferMutation = { __typename?: 'Mutation', rejectUnitTransfer: boolean };

export type ApproveUnitTransferMutationVariables = Exact<{
  unitTransferIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type ApproveUnitTransferMutation = { __typename?: 'Mutation', approveUnitTransfer: boolean };

export type GetUnitTransferMasterDataQueryVariables = Exact<{
  transferId?: InputMaybe<Scalars['String']>;
  transferDate?: InputMaybe<Scalars['DateTime']>;
}>;


export type GetUnitTransferMasterDataQuery = { __typename?: 'Query', getUnitTransferIndoMasterData: { __typename?: 'unitTransferIndoMasterDataOutput', fromUnit?: Array<{ __typename?: 'unitTransferIndoFromUnitDropdown', saleId: string, adminFee?: number | null, miscBillId: string, unitNo: string, projectId: string, saleRegDate?: any | null, totalAllocateAmt: number, totalUnallocateAmt: number, builtUp: number, listPrice: number, additionalPackages: Array<{ __typename?: 'salePackageEntity', id: string, accountId: string, saleId: string, packageId?: string | null, promotionalPackageId: string, openMarketValue?: number | null, sellingPrice?: number | null, taxSchemeId?: string | null, workProgressId?: string | null, discountId?: string | null, discountAmount?: number | null, isIncludeContract: boolean, sellingMethod: string, paymentPlanId?: string | null, commonStatus: string, promotionalPackage: { __typename?: 'promotionalPackagesEntity', id: string, accountId: string, projectId: string, name: string, startDate: any, endDate: any, recordStatus: string } }>, mainBuyer: { __typename?: 'contactEntity', id: string, fullName: string, email?: string | null, phoneNo?: string | null, gender?: string | null, icNo?: string | null, militaryIc?: string | null, homeTel?: string | null, officeTel?: string | null, salutation?: { __typename?: 'salutationEntity', name: string, id: string } | null, nationality?: { __typename?: 'sNationalityEntity', name: string, id: string } | null, race?: { __typename?: 'raceEntity', name: string, id: string } | null, maritalStatus?: { __typename?: 'maritalStatusEntity', name: string, id: string } | null, contactExt?: { __typename?: 'contactExtensionEntity', id: string, identityType: string, customerOrigin: string, isVip: boolean, isForeignPurchase: boolean, subscribeMaterialSms: boolean, subscribeMaterialWhatsapp: boolean, subscribeMaterialEmail: boolean, subscribeMaterialPaNews: boolean, mailingMethod: string, professionId?: string | null, religionId?: string | null, nameOnTax?: string | null, taxRegistrationNo?: string | null, taxRegistrationAddress?: string | null, isPrincipalBuyer: boolean, remark?: string | null } | null, contactAddress?: Array<{ __typename?: 'AddressJson', address?: string | null, country?: string | null, city?: string | null, state?: string | null, postCode?: string | null, AddressType?: string | null }> | null } }> | null, toUnit?: Array<{ __typename?: 'unitTransferIndoUnitDropdown', unitId: string, unitNo: string, projectId: string, builtUp: number, purchaserName?: string | null, listPrice: number, landArea?: string | null, taxSchemeId?: string | null, taxSchemeName?: string | null, builtUpAreaRate?: number | null, landAreaRate?: number | null, commercialPurpose: string, propertyType: string }> | null, transferReason?: Array<{ __typename?: 'reasonCodeEntity', id: string, name: string }> | null, paymentPlans?: Array<{ __typename?: 'UnitTransferPaymentPlan', id: string, name: string, markUpPercentage: number, projectPaymentPlan: string, projectPlanStartDate: any, projectPlanEndDate: any }> | null } };

export type GetUnitTransferPaymentPlanDetailsQueryVariables = Exact<{
  unitId: Scalars['String'];
  paymentPlanId: Scalars['String'];
  finalContractPrice?: InputMaybe<Scalars['Float']>;
  InstallmentSummaryInput?: InputMaybe<Array<InstallmentSummaryInput> | InstallmentSummaryInput>;
  paymentMarkUpAmt?: InputMaybe<Scalars['Float']>;
  taxSchemeId?: InputMaybe<Scalars['String']>;
  isCarparkOrPackage?: InputMaybe<Scalars['Boolean']>;
  regDate?: InputMaybe<Scalars['DateTime']>;
  prevSaleId: Scalars['String'];
}>;


export type GetUnitTransferPaymentPlanDetailsQuery = { __typename?: 'Query', getUnitTransferPaymentPlanDetails: { __typename?: 'PaymentPlanInstallmentOutput', paymentPlanId: string, markUpPercentage?: number | null, markUpPrice?: number | null, paymentPlanDate?: any | null, installmentSummary?: Array<{ __typename?: 'InstallmentSummaryOutput', paymentPlanDetailsId: string, paymentPlanName: string, billType: string, billAfter: string, billFreq: string, billCount: number, markUpPercentage?: number | null, installmentCount?: number | null, totalPayableAmt?: number | null, isFixAmt?: boolean | null, deductBookingFee: DeductBookingFee, installmentDetails?: Array<{ __typename?: 'InstallmentListOutput', billType: string, installementDate: string, baseAmt: number, taxAmt: number, payableAmt: number, seqNo: number, description?: string | null }> | null }> | null } };

export type GetUnitTransferPricingPaymentPlanDetailsQueryVariables = Exact<{
  inputs: Array<GetUnitTransferPricingPaymentPlanInput> | GetUnitTransferPricingPaymentPlanInput;
}>;


export type GetUnitTransferPricingPaymentPlanDetailsQuery = { __typename?: 'Query', getUnitTransferPricingPaymentPlanDetails: Array<{ __typename?: 'GetUnitTransferPricingPaymentPlanOutput', id: string, paymentPlanId: string, markUpPercentage?: number | null, markUpPrice?: number | null, paymentPlanDate: any, installmentSummary?: Array<{ __typename?: 'InstallmentSummaryOutput', paymentPlanDetailsId: string, paymentPlanName: string, billType: string, billAfter: string, billFreq: string, billCount: number, markUpPercentage?: number | null, installmentCount?: number | null, totalPayableAmt?: number | null, isFixAmt?: boolean | null, deductBookingFee: DeductBookingFee, installmentDetails?: Array<{ __typename?: 'InstallmentListOutput', billType: string, installementDate: string, baseAmt: number, taxAmt: number, payableAmt: number, seqNo: number, description?: string | null }> | null }> | null }> };

export type SubmitUnitTransferFormMutationVariables = Exact<{
  input: SubmitUnitTransferFormInput;
  transferId?: InputMaybe<Scalars['String']>;
}>;


export type SubmitUnitTransferFormMutation = { __typename?: 'Mutation', submitUnitTransferForm: string };

export type GetUnitTransferIndoListingQueryVariables = Exact<{
  status: Scalars['String'];
}>;


export type GetUnitTransferIndoListingQuery = { __typename?: 'Query', getUnitTransferIndoList?: Array<{ __typename?: 'UnitTransferIndoOutput', id: string, mainBuyer: string, oldUnitNo: string, newUnitNo: string, transferDate: any, cancelReason: string }> | null };

export type GetPurchaserPaymentPlanDetailQueryVariables = Exact<{
  paymentPlanDetailId: Scalars['String'];
}>;


export type GetPurchaserPaymentPlanDetailQuery = { __typename?: 'Query', getPurchaserPaymentPlanDetail?: { __typename?: 'purchaserPaymentPlanDetailsEntity', id: string, accountId: string, purchaserPaymentPlanId: string, title: string, paymentBy: PaymentBy, paymentValue: number, billType: BillType, noInstallment: number, deductBookingFee: DeductBookingFee, billCount: number, billFrequency: BillFrequency, billAfter: string, recordStatus: string, createdBy?: string | null, createdTs: any, modBy?: string | null, modTs: any } | null };

export type GetUnitTransferIndoEditDataQueryVariables = Exact<{
  transferId: Scalars['String'];
}>;


export type GetUnitTransferIndoEditDataQuery = { __typename?: 'Query', getUnitTransferIndoById?: { __typename?: 'unitTransferIndoByUnitIdOutput', id: string, transferDate: any, transferReason: string, salePackage: Array<any>, carPark: Array<any>, salesPaymentPlan: Array<any>, others: any, taxRate: number, fromUnit: { __typename?: 'unitTransferIndoFromUnitDropdown', saleId: string, adminFee?: number | null, miscBillId: string, unitNo: string, projectId: string, totalAllocateAmt: number, saleRegDate?: any | null, builtUp: number, listPrice: number, mainBuyer: { __typename?: 'contactEntity', id: string, fullName: string, email?: string | null, phoneNo?: string | null, gender?: string | null, icNo?: string | null, militaryIc?: string | null, homeTel?: string | null, officeTel?: string | null, salutation?: { __typename?: 'salutationEntity', name: string, id: string } | null, nationality?: { __typename?: 'sNationalityEntity', name: string, id: string } | null, race?: { __typename?: 'raceEntity', name: string, id: string } | null, maritalStatus?: { __typename?: 'maritalStatusEntity', name: string, id: string } | null, contactExt?: { __typename?: 'contactExtensionEntity', id: string, identityType: string, customerOrigin: string, isVip: boolean, isForeignPurchase: boolean, subscribeMaterialSms: boolean, subscribeMaterialWhatsapp: boolean, subscribeMaterialEmail: boolean, subscribeMaterialPaNews: boolean, mailingMethod: string, professionId?: string | null, religionId?: string | null, nameOnTax?: string | null, taxRegistrationNo?: string | null, taxRegistrationAddress?: string | null, isPrincipalBuyer: boolean, remark?: string | null } | null, contactAddress?: Array<{ __typename?: 'AddressJson', address?: string | null, country?: string | null, city?: string | null, state?: string | null, postCode?: string | null, AddressType?: string | null }> | null } }, toUnit: { __typename?: 'unitTransferIndoUnitDropdown', unitId: string, unitNo: string, projectId: string, builtUp: number, listPrice: number, landArea?: string | null, taxSchemeId?: string | null, taxSchemeName?: string | null, builtUpAreaRate?: number | null, landAreaRate?: number | null, commercialPurpose: string, propertyType: string }, mainBuyer: { __typename?: 'contactEntity', id: string, fullName: string, email?: string | null, phoneNo?: string | null, gender?: string | null, icNo?: string | null, militaryIc?: string | null, homeTel?: string | null, officeTel?: string | null, salutation?: { __typename?: 'salutationEntity', name: string, id: string } | null, nationality?: { __typename?: 'sNationalityEntity', name: string, id: string } | null, race?: { __typename?: 'raceEntity', name: string, id: string } | null, maritalStatus?: { __typename?: 'maritalStatusEntity', name: string, id: string } | null, contactExt?: { __typename?: 'contactExtensionEntity', id: string, identityType: string, customerOrigin: string, isVip: boolean, isForeignPurchase: boolean, subscribeMaterialSms: boolean, subscribeMaterialWhatsapp: boolean, subscribeMaterialEmail: boolean, subscribeMaterialPaNews: boolean, mailingMethod: string, professionId?: string | null, religionId?: string | null, nameOnTax?: string | null, taxRegistrationNo?: string | null, taxRegistrationAddress?: string | null, isPrincipalBuyer: boolean, remark?: string | null } | null, contactAddress?: Array<{ __typename?: 'AddressJson', address?: string | null, country?: string | null, city?: string | null, state?: string | null, postCode?: string | null, AddressType?: string | null }> | null }, jointBuyer: Array<{ __typename?: 'contactEntity', id: string, fullName: string, email?: string | null, phoneNo?: string | null, gender?: string | null, icNo?: string | null, militaryIc?: string | null, homeTel?: string | null, officeTel?: string | null, salutation?: { __typename?: 'salutationEntity', name: string, id: string } | null, nationality?: { __typename?: 'sNationalityEntity', name: string, id: string } | null, race?: { __typename?: 'raceEntity', name: string, id: string } | null, maritalStatus?: { __typename?: 'maritalStatusEntity', name: string, id: string } | null, contactExt?: { __typename?: 'contactExtensionEntity', id: string, identityType: string, customerOrigin: string, isVip: boolean, isForeignPurchase: boolean, subscribeMaterialSms: boolean, subscribeMaterialWhatsapp: boolean, subscribeMaterialEmail: boolean, subscribeMaterialPaNews: boolean, mailingMethod: string, professionId?: string | null, religionId?: string | null, nameOnTax?: string | null, taxRegistrationNo?: string | null, taxRegistrationAddress?: string | null, isPrincipalBuyer: boolean, remark?: string | null } | null, contactAddress?: Array<{ __typename?: 'AddressJson', address?: string | null, country?: string | null, city?: string | null, state?: string | null, postCode?: string | null, AddressType?: string | null }> | null }>, taxSchema: { __typename?: 'taxSchemeEntity', id: string, name: string }, discounts: Array<{ __typename?: 'UnitTransferEditDiscountOutput', discountAmount: number, discountID: string, discountMethod: string, formula: string, title: string }> } | null };

export type EditUnitTransferIndoMutationVariables = Exact<{
  input: SubmitUnitTransferFormInput;
  transferId: Scalars['String'];
}>;


export type EditUnitTransferIndoMutation = { __typename?: 'Mutation', editUnitTransferIndo: string };

export type ApproveUnitTransferIndoMutationVariables = Exact<{
  input: ApproveUnitTransferIndoInput;
}>;


export type ApproveUnitTransferIndoMutation = { __typename?: 'Mutation', approveUnitTransferIndo: string };

export type GetUnitTransferIndoDetailsQueryVariables = Exact<{
  transferId: Scalars['String'];
}>;


export type GetUnitTransferIndoDetailsQuery = { __typename?: 'Query', getUnitTransferIndoDetails: { __typename?: 'UnitTransferIndoDetails', id: string, newSaleId: string, mainBuyer: string, projectId: string, oldUnitNo: string, newUnitNo: string, adminFee: string, reason: string, attachment?: Array<any> | null, status: string, transferDate: any, salesPaymentPlan?: Array<any> | null, approvedBy: string, approvedDate: any } };

export type GetTaxRateQueryVariables = Exact<{
  taxSchemeId: Scalars['String'];
}>;


export type GetTaxRateQuery = { __typename?: 'Query', getTaxRate: number };

export type GetAllUnitsVpLetterQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllUnitsVpLetterQuery = { __typename?: 'Query', getAllUnitsVpLetter?: Array<{ __typename?: 'VacantPossessionOutput', vpLetterDate?: any | null, vpLetterCount?: number | null, unitIndex?: string | null }> | null };

export type GetUnitsVpLetterByDateQueryVariables = Exact<{
  vpLetterDate: Scalars['DateTime'];
}>;


export type GetUnitsVpLetterByDateQuery = { __typename?: 'Query', getUnitsVpLetterByDate: Array<{ __typename?: 'blockListingOutput', block: string, totalFloor: number, floorList?: Array<{ __typename?: 'floorListingOutput', floorLabel?: string | null, totalUnit?: number | null, unitList?: Array<{ __typename?: 'UnitListingOutput', unitId?: string | null, unitNo?: string | null }> | null }> | null }> };

export type GetVPviewUnitQueryVariables = Exact<{
  vpLetterDate: Scalars['DateTime'];
}>;


export type GetVPviewUnitQuery = { __typename?: 'Query', getVPviewUnit: Array<{ __typename?: 'unitEntity', id: string, unitNo: string }> };

export type SaveUnitsVpLetterDateMutationVariables = Exact<{
  input: UnitsVpLetterInput;
}>;


export type SaveUnitsVpLetterDateMutation = { __typename?: 'Mutation', saveUnitsVpLetterDate: boolean };

export type GetUnitsVpFormSourceQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnitsVpFormSourceQuery = { __typename?: 'Query', getUnitsVpFormSource: Array<{ __typename?: 'blockListingOutput', block: string, totalFloor: number, floorList?: Array<{ __typename?: 'floorListingOutput', floorLabel?: string | null, totalUnit?: number | null, unitList?: Array<{ __typename?: 'UnitListingOutput', unitId?: string | null, unitNo?: string | null }> | null }> | null }> };


export const GetAccessSecuritySummaryDocument = gql`
    query getAccessSecuritySummary {
  userLastUpdate
  passwordPolicyLastUpdate
  roleLastUpdate
}
    `;

/**
 * __useGetAccessSecuritySummaryQuery__
 *
 * To run a query within a React component, call `useGetAccessSecuritySummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccessSecuritySummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccessSecuritySummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAccessSecuritySummaryQuery(baseOptions?: Apollo.QueryHookOptions<GetAccessSecuritySummaryQuery, GetAccessSecuritySummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccessSecuritySummaryQuery, GetAccessSecuritySummaryQueryVariables>(GetAccessSecuritySummaryDocument, options);
      }
export function useGetAccessSecuritySummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccessSecuritySummaryQuery, GetAccessSecuritySummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccessSecuritySummaryQuery, GetAccessSecuritySummaryQueryVariables>(GetAccessSecuritySummaryDocument, options);
        }
export type GetAccessSecuritySummaryQueryHookResult = ReturnType<typeof useGetAccessSecuritySummaryQuery>;
export type GetAccessSecuritySummaryLazyQueryHookResult = ReturnType<typeof useGetAccessSecuritySummaryLazyQuery>;
export type GetAccessSecuritySummaryQueryResult = Apollo.QueryResult<GetAccessSecuritySummaryQuery, GetAccessSecuritySummaryQueryVariables>;
export const GetPasswordPolicyDocument = gql`
    query getPasswordPolicy {
  getPasswordPolicy {
    id
    requiredMinNoCharacter
    requiredUpperLowerCase
    requiredDigit
    requiredSpecialCharacter
    passwordResetByDay
    notAllowReusePasswordForLast
  }
}
    `;

/**
 * __useGetPasswordPolicyQuery__
 *
 * To run a query within a React component, call `useGetPasswordPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPasswordPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPasswordPolicyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPasswordPolicyQuery(baseOptions?: Apollo.QueryHookOptions<GetPasswordPolicyQuery, GetPasswordPolicyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPasswordPolicyQuery, GetPasswordPolicyQueryVariables>(GetPasswordPolicyDocument, options);
      }
export function useGetPasswordPolicyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPasswordPolicyQuery, GetPasswordPolicyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPasswordPolicyQuery, GetPasswordPolicyQueryVariables>(GetPasswordPolicyDocument, options);
        }
export type GetPasswordPolicyQueryHookResult = ReturnType<typeof useGetPasswordPolicyQuery>;
export type GetPasswordPolicyLazyQueryHookResult = ReturnType<typeof useGetPasswordPolicyLazyQuery>;
export type GetPasswordPolicyQueryResult = Apollo.QueryResult<GetPasswordPolicyQuery, GetPasswordPolicyQueryVariables>;
export const GetPasswordPolicyWithoutAuthDocument = gql`
    query getPasswordPolicyWithoutAuth {
  getPasswordPolicyWithoutAuth {
    id
    requiredMinNoCharacter
    requiredUpperLowerCase
    requiredDigit
    requiredSpecialCharacter
    passwordResetByDay
    notAllowReusePasswordForLast
  }
}
    `;

/**
 * __useGetPasswordPolicyWithoutAuthQuery__
 *
 * To run a query within a React component, call `useGetPasswordPolicyWithoutAuthQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPasswordPolicyWithoutAuthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPasswordPolicyWithoutAuthQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPasswordPolicyWithoutAuthQuery(baseOptions?: Apollo.QueryHookOptions<GetPasswordPolicyWithoutAuthQuery, GetPasswordPolicyWithoutAuthQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPasswordPolicyWithoutAuthQuery, GetPasswordPolicyWithoutAuthQueryVariables>(GetPasswordPolicyWithoutAuthDocument, options);
      }
export function useGetPasswordPolicyWithoutAuthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPasswordPolicyWithoutAuthQuery, GetPasswordPolicyWithoutAuthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPasswordPolicyWithoutAuthQuery, GetPasswordPolicyWithoutAuthQueryVariables>(GetPasswordPolicyWithoutAuthDocument, options);
        }
export type GetPasswordPolicyWithoutAuthQueryHookResult = ReturnType<typeof useGetPasswordPolicyWithoutAuthQuery>;
export type GetPasswordPolicyWithoutAuthLazyQueryHookResult = ReturnType<typeof useGetPasswordPolicyWithoutAuthLazyQuery>;
export type GetPasswordPolicyWithoutAuthQueryResult = Apollo.QueryResult<GetPasswordPolicyWithoutAuthQuery, GetPasswordPolicyWithoutAuthQueryVariables>;
export const AddPasswordPolicyDocument = gql`
    mutation addPasswordPolicy($input: passwordPolicyInput!) {
  addPasswordPolicy(input: $input)
}
    `;
export type AddPasswordPolicyMutationFn = Apollo.MutationFunction<AddPasswordPolicyMutation, AddPasswordPolicyMutationVariables>;

/**
 * __useAddPasswordPolicyMutation__
 *
 * To run a mutation, you first call `useAddPasswordPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPasswordPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPasswordPolicyMutation, { data, loading, error }] = useAddPasswordPolicyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPasswordPolicyMutation(baseOptions?: Apollo.MutationHookOptions<AddPasswordPolicyMutation, AddPasswordPolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPasswordPolicyMutation, AddPasswordPolicyMutationVariables>(AddPasswordPolicyDocument, options);
      }
export type AddPasswordPolicyMutationHookResult = ReturnType<typeof useAddPasswordPolicyMutation>;
export type AddPasswordPolicyMutationResult = Apollo.MutationResult<AddPasswordPolicyMutation>;
export type AddPasswordPolicyMutationOptions = Apollo.BaseMutationOptions<AddPasswordPolicyMutation, AddPasswordPolicyMutationVariables>;
export const EditPasswordPolicyDocument = gql`
    mutation editPasswordPolicy($input: passwordPolicyInput!) {
  editPasswordPolicy(input: $input)
}
    `;
export type EditPasswordPolicyMutationFn = Apollo.MutationFunction<EditPasswordPolicyMutation, EditPasswordPolicyMutationVariables>;

/**
 * __useEditPasswordPolicyMutation__
 *
 * To run a mutation, you first call `useEditPasswordPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPasswordPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPasswordPolicyMutation, { data, loading, error }] = useEditPasswordPolicyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditPasswordPolicyMutation(baseOptions?: Apollo.MutationHookOptions<EditPasswordPolicyMutation, EditPasswordPolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditPasswordPolicyMutation, EditPasswordPolicyMutationVariables>(EditPasswordPolicyDocument, options);
      }
export type EditPasswordPolicyMutationHookResult = ReturnType<typeof useEditPasswordPolicyMutation>;
export type EditPasswordPolicyMutationResult = Apollo.MutationResult<EditPasswordPolicyMutation>;
export type EditPasswordPolicyMutationOptions = Apollo.BaseMutationOptions<EditPasswordPolicyMutation, EditPasswordPolicyMutationVariables>;
export const GetRolesDocument = gql`
    query getRoles($projectId: String) {
  getRoles {
    name
    id
    softwareCode
    salesAndReportPermission
    isDeletable
    users(projectId: $projectId) {
      userName
      ID
      name
      superUser
    }
  }
}
    `;

/**
 * __useGetRolesQuery__
 *
 * To run a query within a React component, call `useGetRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRolesQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetRolesQuery(baseOptions?: Apollo.QueryHookOptions<GetRolesQuery, GetRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options);
      }
export function useGetRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRolesQuery, GetRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options);
        }
export type GetRolesQueryHookResult = ReturnType<typeof useGetRolesQuery>;
export type GetRolesLazyQueryHookResult = ReturnType<typeof useGetRolesLazyQuery>;
export type GetRolesQueryResult = Apollo.QueryResult<GetRolesQuery, GetRolesQueryVariables>;
export const GetRoleByIdDocument = gql`
    query getRoleById($roleId: String!, $projectId: String) {
  getRoleById(roleId: $roleId) {
    name
    id
    softwareCode
    salesAndReportPermissionIds
    salesAndReportPermission
    isDeletable
    users(projectId: $projectId) {
      name
      userName
      ID
    }
  }
}
    `;

/**
 * __useGetRoleByIdQuery__
 *
 * To run a query within a React component, call `useGetRoleByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoleByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoleByIdQuery({
 *   variables: {
 *      roleId: // value for 'roleId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetRoleByIdQuery(baseOptions: Apollo.QueryHookOptions<GetRoleByIdQuery, GetRoleByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoleByIdQuery, GetRoleByIdQueryVariables>(GetRoleByIdDocument, options);
      }
export function useGetRoleByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoleByIdQuery, GetRoleByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoleByIdQuery, GetRoleByIdQueryVariables>(GetRoleByIdDocument, options);
        }
export type GetRoleByIdQueryHookResult = ReturnType<typeof useGetRoleByIdQuery>;
export type GetRoleByIdLazyQueryHookResult = ReturnType<typeof useGetRoleByIdLazyQuery>;
export type GetRoleByIdQueryResult = Apollo.QueryResult<GetRoleByIdQuery, GetRoleByIdQueryVariables>;
export const GetPermissionDocument = gql`
    query getPermission {
  getPermission
}
    `;

/**
 * __useGetPermissionQuery__
 *
 * To run a query within a React component, call `useGetPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPermissionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPermissionQuery(baseOptions?: Apollo.QueryHookOptions<GetPermissionQuery, GetPermissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPermissionQuery, GetPermissionQueryVariables>(GetPermissionDocument, options);
      }
export function useGetPermissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPermissionQuery, GetPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPermissionQuery, GetPermissionQueryVariables>(GetPermissionDocument, options);
        }
export type GetPermissionQueryHookResult = ReturnType<typeof useGetPermissionQuery>;
export type GetPermissionLazyQueryHookResult = ReturnType<typeof useGetPermissionLazyQuery>;
export type GetPermissionQueryResult = Apollo.QueryResult<GetPermissionQuery, GetPermissionQueryVariables>;
export const GetPermissionKeyByRoleIdDocument = gql`
    query getPermissionKeyByRoleId($roleId: String!) {
  getPermissionKeyByRoleId(roleId: $roleId)
}
    `;

/**
 * __useGetPermissionKeyByRoleIdQuery__
 *
 * To run a query within a React component, call `useGetPermissionKeyByRoleIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPermissionKeyByRoleIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPermissionKeyByRoleIdQuery({
 *   variables: {
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useGetPermissionKeyByRoleIdQuery(baseOptions: Apollo.QueryHookOptions<GetPermissionKeyByRoleIdQuery, GetPermissionKeyByRoleIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPermissionKeyByRoleIdQuery, GetPermissionKeyByRoleIdQueryVariables>(GetPermissionKeyByRoleIdDocument, options);
      }
export function useGetPermissionKeyByRoleIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPermissionKeyByRoleIdQuery, GetPermissionKeyByRoleIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPermissionKeyByRoleIdQuery, GetPermissionKeyByRoleIdQueryVariables>(GetPermissionKeyByRoleIdDocument, options);
        }
export type GetPermissionKeyByRoleIdQueryHookResult = ReturnType<typeof useGetPermissionKeyByRoleIdQuery>;
export type GetPermissionKeyByRoleIdLazyQueryHookResult = ReturnType<typeof useGetPermissionKeyByRoleIdLazyQuery>;
export type GetPermissionKeyByRoleIdQueryResult = Apollo.QueryResult<GetPermissionKeyByRoleIdQuery, GetPermissionKeyByRoleIdQueryVariables>;
export const GetTotalPermissionDocument = gql`
    query getTotalPermission {
  getTotalPermission
}
    `;

/**
 * __useGetTotalPermissionQuery__
 *
 * To run a query within a React component, call `useGetTotalPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTotalPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTotalPermissionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTotalPermissionQuery(baseOptions?: Apollo.QueryHookOptions<GetTotalPermissionQuery, GetTotalPermissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTotalPermissionQuery, GetTotalPermissionQueryVariables>(GetTotalPermissionDocument, options);
      }
export function useGetTotalPermissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTotalPermissionQuery, GetTotalPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTotalPermissionQuery, GetTotalPermissionQueryVariables>(GetTotalPermissionDocument, options);
        }
export type GetTotalPermissionQueryHookResult = ReturnType<typeof useGetTotalPermissionQuery>;
export type GetTotalPermissionLazyQueryHookResult = ReturnType<typeof useGetTotalPermissionLazyQuery>;
export type GetTotalPermissionQueryResult = Apollo.QueryResult<GetTotalPermissionQuery, GetTotalPermissionQueryVariables>;
export const RoleAssignmentDocument = gql`
    mutation roleAssignment($input: ProjectUserRoleAssignmentInput!) {
  roleAssignment(input: $input)
}
    `;
export type RoleAssignmentMutationFn = Apollo.MutationFunction<RoleAssignmentMutation, RoleAssignmentMutationVariables>;

/**
 * __useRoleAssignmentMutation__
 *
 * To run a mutation, you first call `useRoleAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRoleAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [roleAssignmentMutation, { data, loading, error }] = useRoleAssignmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRoleAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<RoleAssignmentMutation, RoleAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RoleAssignmentMutation, RoleAssignmentMutationVariables>(RoleAssignmentDocument, options);
      }
export type RoleAssignmentMutationHookResult = ReturnType<typeof useRoleAssignmentMutation>;
export type RoleAssignmentMutationResult = Apollo.MutationResult<RoleAssignmentMutation>;
export type RoleAssignmentMutationOptions = Apollo.BaseMutationOptions<RoleAssignmentMutation, RoleAssignmentMutationVariables>;
export const SalesTestPermissionDocument = gql`
    query salesTestPermission($salesPerm: SalesAdminPermission!) {
  salesTestPermission(salesPerm: $salesPerm)
}
    `;

/**
 * __useSalesTestPermissionQuery__
 *
 * To run a query within a React component, call `useSalesTestPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesTestPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesTestPermissionQuery({
 *   variables: {
 *      salesPerm: // value for 'salesPerm'
 *   },
 * });
 */
export function useSalesTestPermissionQuery(baseOptions: Apollo.QueryHookOptions<SalesTestPermissionQuery, SalesTestPermissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SalesTestPermissionQuery, SalesTestPermissionQueryVariables>(SalesTestPermissionDocument, options);
      }
export function useSalesTestPermissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SalesTestPermissionQuery, SalesTestPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SalesTestPermissionQuery, SalesTestPermissionQueryVariables>(SalesTestPermissionDocument, options);
        }
export type SalesTestPermissionQueryHookResult = ReturnType<typeof useSalesTestPermissionQuery>;
export type SalesTestPermissionLazyQueryHookResult = ReturnType<typeof useSalesTestPermissionLazyQuery>;
export type SalesTestPermissionQueryResult = Apollo.QueryResult<SalesTestPermissionQuery, SalesTestPermissionQueryVariables>;
export const NewRoleDocument = gql`
    mutation newRole($input: NewAccessRoleInput!) {
  newRole(input: $input)
}
    `;
export type NewRoleMutationFn = Apollo.MutationFunction<NewRoleMutation, NewRoleMutationVariables>;

/**
 * __useNewRoleMutation__
 *
 * To run a mutation, you first call `useNewRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newRoleMutation, { data, loading, error }] = useNewRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNewRoleMutation(baseOptions?: Apollo.MutationHookOptions<NewRoleMutation, NewRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NewRoleMutation, NewRoleMutationVariables>(NewRoleDocument, options);
      }
export type NewRoleMutationHookResult = ReturnType<typeof useNewRoleMutation>;
export type NewRoleMutationResult = Apollo.MutationResult<NewRoleMutation>;
export type NewRoleMutationOptions = Apollo.BaseMutationOptions<NewRoleMutation, NewRoleMutationVariables>;
export const EditRoleDocument = gql`
    mutation editRole($input: EditAccessRoleInput!) {
  editRole(input: $input)
}
    `;
export type EditRoleMutationFn = Apollo.MutationFunction<EditRoleMutation, EditRoleMutationVariables>;

/**
 * __useEditRoleMutation__
 *
 * To run a mutation, you first call `useEditRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editRoleMutation, { data, loading, error }] = useEditRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditRoleMutation(baseOptions?: Apollo.MutationHookOptions<EditRoleMutation, EditRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditRoleMutation, EditRoleMutationVariables>(EditRoleDocument, options);
      }
export type EditRoleMutationHookResult = ReturnType<typeof useEditRoleMutation>;
export type EditRoleMutationResult = Apollo.MutationResult<EditRoleMutation>;
export type EditRoleMutationOptions = Apollo.BaseMutationOptions<EditRoleMutation, EditRoleMutationVariables>;
export const DeleteRoleDocument = gql`
    mutation deleteRole($roleId: String!) {
  deleteRole(roleId: $roleId)
}
    `;
export type DeleteRoleMutationFn = Apollo.MutationFunction<DeleteRoleMutation, DeleteRoleMutationVariables>;

/**
 * __useDeleteRoleMutation__
 *
 * To run a mutation, you first call `useDeleteRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRoleMutation, { data, loading, error }] = useDeleteRoleMutation({
 *   variables: {
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useDeleteRoleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRoleMutation, DeleteRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRoleMutation, DeleteRoleMutationVariables>(DeleteRoleDocument, options);
      }
export type DeleteRoleMutationHookResult = ReturnType<typeof useDeleteRoleMutation>;
export type DeleteRoleMutationResult = Apollo.MutationResult<DeleteRoleMutation>;
export type DeleteRoleMutationOptions = Apollo.BaseMutationOptions<DeleteRoleMutation, DeleteRoleMutationVariables>;
export const UserListingDocument = gql`
    query userListing($activeUserOnly: Boolean, $isSuperUser: Boolean, $activeStatus: String) {
  userListing(activeUserOnly: $activeUserOnly, isSuperUser: $isSuperUser, activeStatus: $activeStatus) {
    ID
    userName
    email
    contactNo
    name
    jobTitle
    department
    superUser
    commonStatus
    confirmed
    userFeaturePermission {
      userId
      allowOpenlead
      allowPropertyAgency
    }
    isActivated
    isSuspendible
  }
}
    `;

/**
 * __useUserListingQuery__
 *
 * To run a query within a React component, call `useUserListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserListingQuery({
 *   variables: {
 *      activeUserOnly: // value for 'activeUserOnly'
 *      isSuperUser: // value for 'isSuperUser'
 *      activeStatus: // value for 'activeStatus'
 *   },
 * });
 */
export function useUserListingQuery(baseOptions?: Apollo.QueryHookOptions<UserListingQuery, UserListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserListingQuery, UserListingQueryVariables>(UserListingDocument, options);
      }
export function useUserListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserListingQuery, UserListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserListingQuery, UserListingQueryVariables>(UserListingDocument, options);
        }
export type UserListingQueryHookResult = ReturnType<typeof useUserListingQuery>;
export type UserListingLazyQueryHookResult = ReturnType<typeof useUserListingLazyQuery>;
export type UserListingQueryResult = Apollo.QueryResult<UserListingQuery, UserListingQueryVariables>;
export const GetUserDetailsDocument = gql`
    query getUserDetails($userId: String!) {
  getUserDetails(userId: $userId) {
    ID
    userName
    email
    contactNo
    name
    jobTitle
    department
    superUser
    commonStatus
    confirmed
    userFeaturePermission {
      userId
      allowOpenlead
      allowPropertyAgency
    }
    isActivated
    isSuspendible
  }
}
    `;

/**
 * __useGetUserDetailsQuery__
 *
 * To run a query within a React component, call `useGetUserDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserDetailsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetUserDetailsQuery, GetUserDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserDetailsQuery, GetUserDetailsQueryVariables>(GetUserDetailsDocument, options);
      }
export function useGetUserDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserDetailsQuery, GetUserDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserDetailsQuery, GetUserDetailsQueryVariables>(GetUserDetailsDocument, options);
        }
export type GetUserDetailsQueryHookResult = ReturnType<typeof useGetUserDetailsQuery>;
export type GetUserDetailsLazyQueryHookResult = ReturnType<typeof useGetUserDetailsLazyQuery>;
export type GetUserDetailsQueryResult = Apollo.QueryResult<GetUserDetailsQuery, GetUserDetailsQueryVariables>;
export const AddUserDocument = gql`
    mutation addUser($input: NewUserInput!) {
  addUser(input: $input)
}
    `;
export type AddUserMutationFn = Apollo.MutationFunction<AddUserMutation, AddUserMutationVariables>;

/**
 * __useAddUserMutation__
 *
 * To run a mutation, you first call `useAddUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserMutation, { data, loading, error }] = useAddUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddUserMutation(baseOptions?: Apollo.MutationHookOptions<AddUserMutation, AddUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserMutation, AddUserMutationVariables>(AddUserDocument, options);
      }
export type AddUserMutationHookResult = ReturnType<typeof useAddUserMutation>;
export type AddUserMutationResult = Apollo.MutationResult<AddUserMutation>;
export type AddUserMutationOptions = Apollo.BaseMutationOptions<AddUserMutation, AddUserMutationVariables>;
export const EditUserDocument = gql`
    mutation editUser($input: EditUserInput!) {
  editUser(input: $input)
}
    `;
export type EditUserMutationFn = Apollo.MutationFunction<EditUserMutation, EditUserMutationVariables>;

/**
 * __useEditUserMutation__
 *
 * To run a mutation, you first call `useEditUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editUserMutation, { data, loading, error }] = useEditUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditUserMutation(baseOptions?: Apollo.MutationHookOptions<EditUserMutation, EditUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditUserMutation, EditUserMutationVariables>(EditUserDocument, options);
      }
export type EditUserMutationHookResult = ReturnType<typeof useEditUserMutation>;
export type EditUserMutationResult = Apollo.MutationResult<EditUserMutation>;
export type EditUserMutationOptions = Apollo.BaseMutationOptions<EditUserMutation, EditUserMutationVariables>;
export const SuspendUserDocument = gql`
    mutation suspendUser($userId: String!) {
  suspendUser(userId: $userId)
}
    `;
export type SuspendUserMutationFn = Apollo.MutationFunction<SuspendUserMutation, SuspendUserMutationVariables>;

/**
 * __useSuspendUserMutation__
 *
 * To run a mutation, you first call `useSuspendUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuspendUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [suspendUserMutation, { data, loading, error }] = useSuspendUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSuspendUserMutation(baseOptions?: Apollo.MutationHookOptions<SuspendUserMutation, SuspendUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuspendUserMutation, SuspendUserMutationVariables>(SuspendUserDocument, options);
      }
export type SuspendUserMutationHookResult = ReturnType<typeof useSuspendUserMutation>;
export type SuspendUserMutationResult = Apollo.MutationResult<SuspendUserMutation>;
export type SuspendUserMutationOptions = Apollo.BaseMutationOptions<SuspendUserMutation, SuspendUserMutationVariables>;
export const UnSuspendUserDocument = gql`
    mutation unSuspendUser($userId: String!) {
  unSuspendUser(userId: $userId)
}
    `;
export type UnSuspendUserMutationFn = Apollo.MutationFunction<UnSuspendUserMutation, UnSuspendUserMutationVariables>;

/**
 * __useUnSuspendUserMutation__
 *
 * To run a mutation, you first call `useUnSuspendUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnSuspendUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unSuspendUserMutation, { data, loading, error }] = useUnSuspendUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUnSuspendUserMutation(baseOptions?: Apollo.MutationHookOptions<UnSuspendUserMutation, UnSuspendUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnSuspendUserMutation, UnSuspendUserMutationVariables>(UnSuspendUserDocument, options);
      }
export type UnSuspendUserMutationHookResult = ReturnType<typeof useUnSuspendUserMutation>;
export type UnSuspendUserMutationResult = Apollo.MutationResult<UnSuspendUserMutation>;
export type UnSuspendUserMutationOptions = Apollo.BaseMutationOptions<UnSuspendUserMutation, UnSuspendUserMutationVariables>;
export const UnblockUserDocument = gql`
    mutation unblockUser($newPassword: String!, $confirmPassword: String!, $userId: String!) {
  unblockUser(newPassword: $newPassword, confirmPassword: $confirmPassword, userId: $userId)
}
    `;
export type UnblockUserMutationFn = Apollo.MutationFunction<UnblockUserMutation, UnblockUserMutationVariables>;

/**
 * __useUnblockUserMutation__
 *
 * To run a mutation, you first call `useUnblockUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnblockUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unblockUserMutation, { data, loading, error }] = useUnblockUserMutation({
 *   variables: {
 *      newPassword: // value for 'newPassword'
 *      confirmPassword: // value for 'confirmPassword'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUnblockUserMutation(baseOptions?: Apollo.MutationHookOptions<UnblockUserMutation, UnblockUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnblockUserMutation, UnblockUserMutationVariables>(UnblockUserDocument, options);
      }
export type UnblockUserMutationHookResult = ReturnType<typeof useUnblockUserMutation>;
export type UnblockUserMutationResult = Apollo.MutationResult<UnblockUserMutation>;
export type UnblockUserMutationOptions = Apollo.BaseMutationOptions<UnblockUserMutation, UnblockUserMutationVariables>;
export const ChangePasswordDocument = gql`
    mutation changePassword($input: UserChangePasswordInput!) {
  changePassword(input: $input)
}
    `;
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, options);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const IsAllowAddUserDocument = gql`
    query isAllowAddUser {
  isAllowAddUser
}
    `;

/**
 * __useIsAllowAddUserQuery__
 *
 * To run a query within a React component, call `useIsAllowAddUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsAllowAddUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsAllowAddUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useIsAllowAddUserQuery(baseOptions?: Apollo.QueryHookOptions<IsAllowAddUserQuery, IsAllowAddUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsAllowAddUserQuery, IsAllowAddUserQueryVariables>(IsAllowAddUserDocument, options);
      }
export function useIsAllowAddUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsAllowAddUserQuery, IsAllowAddUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsAllowAddUserQuery, IsAllowAddUserQueryVariables>(IsAllowAddUserDocument, options);
        }
export type IsAllowAddUserQueryHookResult = ReturnType<typeof useIsAllowAddUserQuery>;
export type IsAllowAddUserLazyQueryHookResult = ReturnType<typeof useIsAllowAddUserLazyQuery>;
export type IsAllowAddUserQueryResult = Apollo.QueryResult<IsAllowAddUserQuery, IsAllowAddUserQueryVariables>;
export const ResendInvitationDocument = gql`
    mutation resendInvitation($userId: String!) {
  resendInvitation(userId: $userId)
}
    `;
export type ResendInvitationMutationFn = Apollo.MutationFunction<ResendInvitationMutation, ResendInvitationMutationVariables>;

/**
 * __useResendInvitationMutation__
 *
 * To run a mutation, you first call `useResendInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendInvitationMutation, { data, loading, error }] = useResendInvitationMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useResendInvitationMutation(baseOptions?: Apollo.MutationHookOptions<ResendInvitationMutation, ResendInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendInvitationMutation, ResendInvitationMutationVariables>(ResendInvitationDocument, options);
      }
export type ResendInvitationMutationHookResult = ReturnType<typeof useResendInvitationMutation>;
export type ResendInvitationMutationResult = Apollo.MutationResult<ResendInvitationMutation>;
export type ResendInvitationMutationOptions = Apollo.BaseMutationOptions<ResendInvitationMutation, ResendInvitationMutationVariables>;
export const GetUserProfileDocument = gql`
    query getUserProfile {
  profile {
    ID
    accountID
    name
    email
    avatar
    contactNo
    department
    jobTitle
    lastestAccessedEntity
    superUser
  }
}
    `;

/**
 * __useGetUserProfileQuery__
 *
 * To run a query within a React component, call `useGetUserProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserProfileQuery(baseOptions?: Apollo.QueryHookOptions<GetUserProfileQuery, GetUserProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserProfileQuery, GetUserProfileQueryVariables>(GetUserProfileDocument, options);
      }
export function useGetUserProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserProfileQuery, GetUserProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserProfileQuery, GetUserProfileQueryVariables>(GetUserProfileDocument, options);
        }
export type GetUserProfileQueryHookResult = ReturnType<typeof useGetUserProfileQuery>;
export type GetUserProfileLazyQueryHookResult = ReturnType<typeof useGetUserProfileLazyQuery>;
export type GetUserProfileQueryResult = Apollo.QueryResult<GetUserProfileQuery, GetUserProfileQueryVariables>;
export const AccountNameDocument = gql`
    query accountName {
  getAccountName
}
    `;

/**
 * __useAccountNameQuery__
 *
 * To run a query within a React component, call `useAccountNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountNameQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountNameQuery(baseOptions?: Apollo.QueryHookOptions<AccountNameQuery, AccountNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountNameQuery, AccountNameQueryVariables>(AccountNameDocument, options);
      }
export function useAccountNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountNameQuery, AccountNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountNameQuery, AccountNameQueryVariables>(AccountNameDocument, options);
        }
export type AccountNameQueryHookResult = ReturnType<typeof useAccountNameQuery>;
export type AccountNameLazyQueryHookResult = ReturnType<typeof useAccountNameLazyQuery>;
export type AccountNameQueryResult = Apollo.QueryResult<AccountNameQuery, AccountNameQueryVariables>;
export const ForgotPasswordDocument = gql`
    mutation forgotPassword($email: String!) {
  forgotPassword(email: $email)
}
    `;
export type ForgotPasswordMutationFn = Apollo.MutationFunction<ForgotPasswordMutation, ForgotPasswordMutationVariables>;

/**
 * __useForgotPasswordMutation__
 *
 * To run a mutation, you first call `useForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotPasswordMutation, { data, loading, error }] = useForgotPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument, options);
      }
export type ForgotPasswordMutationHookResult = ReturnType<typeof useForgotPasswordMutation>;
export type ForgotPasswordMutationResult = Apollo.MutationResult<ForgotPasswordMutation>;
export type ForgotPasswordMutationOptions = Apollo.BaseMutationOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const GetAppAccessTokenDocument = gql`
    query getAppAccessToken($appName: String!) {
  getAppAccessToken(app: $appName)
}
    `;

/**
 * __useGetAppAccessTokenQuery__
 *
 * To run a query within a React component, call `useGetAppAccessTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppAccessTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppAccessTokenQuery({
 *   variables: {
 *      appName: // value for 'appName'
 *   },
 * });
 */
export function useGetAppAccessTokenQuery(baseOptions: Apollo.QueryHookOptions<GetAppAccessTokenQuery, GetAppAccessTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppAccessTokenQuery, GetAppAccessTokenQueryVariables>(GetAppAccessTokenDocument, options);
      }
export function useGetAppAccessTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppAccessTokenQuery, GetAppAccessTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppAccessTokenQuery, GetAppAccessTokenQueryVariables>(GetAppAccessTokenDocument, options);
        }
export type GetAppAccessTokenQueryHookResult = ReturnType<typeof useGetAppAccessTokenQuery>;
export type GetAppAccessTokenLazyQueryHookResult = ReturnType<typeof useGetAppAccessTokenLazyQuery>;
export type GetAppAccessTokenQueryResult = Apollo.QueryResult<GetAppAccessTokenQuery, GetAppAccessTokenQueryVariables>;
export const GlAccountCodeDocument = gql`
    query glAccountCode($companyId: String!) {
  glAccountCode(companyId: $companyId) {
    id
    name
    table
    glType
    glAccountId
    glAccountCode
  }
}
    `;

/**
 * __useGlAccountCodeQuery__
 *
 * To run a query within a React component, call `useGlAccountCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlAccountCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlAccountCodeQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGlAccountCodeQuery(baseOptions: Apollo.QueryHookOptions<GlAccountCodeQuery, GlAccountCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GlAccountCodeQuery, GlAccountCodeQueryVariables>(GlAccountCodeDocument, options);
      }
export function useGlAccountCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GlAccountCodeQuery, GlAccountCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GlAccountCodeQuery, GlAccountCodeQueryVariables>(GlAccountCodeDocument, options);
        }
export type GlAccountCodeQueryHookResult = ReturnType<typeof useGlAccountCodeQuery>;
export type GlAccountCodeLazyQueryHookResult = ReturnType<typeof useGlAccountCodeLazyQuery>;
export type GlAccountCodeQueryResult = Apollo.QueryResult<GlAccountCodeQuery, GlAccountCodeQueryVariables>;
export const GlEndFinancierListDocument = gql`
    query glEndFinancierList($companyId: String!) {
  glEndFinancierList(companyId: $companyId) {
    financierName
    endfinName
    endFinPaymentPlans {
      id
      name
      table
      glType
      glAccountId
      glAccountCode
    }
  }
}
    `;

/**
 * __useGlEndFinancierListQuery__
 *
 * To run a query within a React component, call `useGlEndFinancierListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlEndFinancierListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlEndFinancierListQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGlEndFinancierListQuery(baseOptions: Apollo.QueryHookOptions<GlEndFinancierListQuery, GlEndFinancierListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GlEndFinancierListQuery, GlEndFinancierListQueryVariables>(GlEndFinancierListDocument, options);
      }
export function useGlEndFinancierListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GlEndFinancierListQuery, GlEndFinancierListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GlEndFinancierListQuery, GlEndFinancierListQueryVariables>(GlEndFinancierListDocument, options);
        }
export type GlEndFinancierListQueryHookResult = ReturnType<typeof useGlEndFinancierListQuery>;
export type GlEndFinancierListLazyQueryHookResult = ReturnType<typeof useGlEndFinancierListLazyQuery>;
export type GlEndFinancierListQueryResult = Apollo.QueryResult<GlEndFinancierListQuery, GlEndFinancierListQueryVariables>;
export const GetAvailableCompanyListDocument = gql`
    query getAvailableCompanyList($companyId: String!) {
  getAvailableCompanyList(companyId: $companyId) {
    id
    name
  }
}
    `;

/**
 * __useGetAvailableCompanyListQuery__
 *
 * To run a query within a React component, call `useGetAvailableCompanyListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableCompanyListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableCompanyListQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetAvailableCompanyListQuery(baseOptions: Apollo.QueryHookOptions<GetAvailableCompanyListQuery, GetAvailableCompanyListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableCompanyListQuery, GetAvailableCompanyListQueryVariables>(GetAvailableCompanyListDocument, options);
      }
export function useGetAvailableCompanyListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableCompanyListQuery, GetAvailableCompanyListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableCompanyListQuery, GetAvailableCompanyListQueryVariables>(GetAvailableCompanyListDocument, options);
        }
export type GetAvailableCompanyListQueryHookResult = ReturnType<typeof useGetAvailableCompanyListQuery>;
export type GetAvailableCompanyListLazyQueryHookResult = ReturnType<typeof useGetAvailableCompanyListLazyQuery>;
export type GetAvailableCompanyListQueryResult = Apollo.QueryResult<GetAvailableCompanyListQuery, GetAvailableCompanyListQueryVariables>;
export const UpdateGlAccountMappingDocument = gql`
    mutation updateGlAccountMapping($input: accountMappingInput!) {
  updateGlAccountMapping(input: $input)
}
    `;
export type UpdateGlAccountMappingMutationFn = Apollo.MutationFunction<UpdateGlAccountMappingMutation, UpdateGlAccountMappingMutationVariables>;

/**
 * __useUpdateGlAccountMappingMutation__
 *
 * To run a mutation, you first call `useUpdateGlAccountMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGlAccountMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGlAccountMappingMutation, { data, loading, error }] = useUpdateGlAccountMappingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGlAccountMappingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGlAccountMappingMutation, UpdateGlAccountMappingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGlAccountMappingMutation, UpdateGlAccountMappingMutationVariables>(UpdateGlAccountMappingDocument, options);
      }
export type UpdateGlAccountMappingMutationHookResult = ReturnType<typeof useUpdateGlAccountMappingMutation>;
export type UpdateGlAccountMappingMutationResult = Apollo.MutationResult<UpdateGlAccountMappingMutation>;
export type UpdateGlAccountMappingMutationOptions = Apollo.BaseMutationOptions<UpdateGlAccountMappingMutation, UpdateGlAccountMappingMutationVariables>;
export const CopyGlAccountDocument = gql`
    mutation copyGlAccount($companyId: String!, $copyCompanyId: String!) {
  copyGlAccount(companyId: $companyId, copyCompanyId: $copyCompanyId)
}
    `;
export type CopyGlAccountMutationFn = Apollo.MutationFunction<CopyGlAccountMutation, CopyGlAccountMutationVariables>;

/**
 * __useCopyGlAccountMutation__
 *
 * To run a mutation, you first call `useCopyGlAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyGlAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyGlAccountMutation, { data, loading, error }] = useCopyGlAccountMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      copyCompanyId: // value for 'copyCompanyId'
 *   },
 * });
 */
export function useCopyGlAccountMutation(baseOptions?: Apollo.MutationHookOptions<CopyGlAccountMutation, CopyGlAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyGlAccountMutation, CopyGlAccountMutationVariables>(CopyGlAccountDocument, options);
      }
export type CopyGlAccountMutationHookResult = ReturnType<typeof useCopyGlAccountMutation>;
export type CopyGlAccountMutationResult = Apollo.MutationResult<CopyGlAccountMutation>;
export type CopyGlAccountMutationOptions = Apollo.BaseMutationOptions<CopyGlAccountMutation, CopyGlAccountMutationVariables>;
export const GetExportPreviewGlDataDocument = gql`
    query getExportPreviewGLData($companyId: String!, $startDate: DateTime!, $endDate: DateTime!) {
  getExportPreviewGLData(companyId: $companyId, startDate: $startDate, endDate: $endDate) {
    glType
    glTransactionType
    glAccountCode
    costCentre
    journalType
    documentDate
    documentNo
    refTable
    refId
    refDescription
    debitAmount
    creditAmount
    taxId
    glAccountId
  }
}
    `;

/**
 * __useGetExportPreviewGlDataQuery__
 *
 * To run a query within a React component, call `useGetExportPreviewGlDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExportPreviewGlDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExportPreviewGlDataQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetExportPreviewGlDataQuery(baseOptions: Apollo.QueryHookOptions<GetExportPreviewGlDataQuery, GetExportPreviewGlDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExportPreviewGlDataQuery, GetExportPreviewGlDataQueryVariables>(GetExportPreviewGlDataDocument, options);
      }
export function useGetExportPreviewGlDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExportPreviewGlDataQuery, GetExportPreviewGlDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExportPreviewGlDataQuery, GetExportPreviewGlDataQueryVariables>(GetExportPreviewGlDataDocument, options);
        }
export type GetExportPreviewGlDataQueryHookResult = ReturnType<typeof useGetExportPreviewGlDataQuery>;
export type GetExportPreviewGlDataLazyQueryHookResult = ReturnType<typeof useGetExportPreviewGlDataLazyQuery>;
export type GetExportPreviewGlDataQueryResult = Apollo.QueryResult<GetExportPreviewGlDataQuery, GetExportPreviewGlDataQueryVariables>;
export const CreateGlExportDocument = gql`
    mutation createGLExport($input: glExportInput!) {
  createGLExport(input: $input) {
    postStatus
    base64
    fileName
  }
}
    `;
export type CreateGlExportMutationFn = Apollo.MutationFunction<CreateGlExportMutation, CreateGlExportMutationVariables>;

/**
 * __useCreateGlExportMutation__
 *
 * To run a mutation, you first call `useCreateGlExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGlExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGlExportMutation, { data, loading, error }] = useCreateGlExportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGlExportMutation(baseOptions?: Apollo.MutationHookOptions<CreateGlExportMutation, CreateGlExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGlExportMutation, CreateGlExportMutationVariables>(CreateGlExportDocument, options);
      }
export type CreateGlExportMutationHookResult = ReturnType<typeof useCreateGlExportMutation>;
export type CreateGlExportMutationResult = Apollo.MutationResult<CreateGlExportMutation>;
export type CreateGlExportMutationOptions = Apollo.BaseMutationOptions<CreateGlExportMutation, CreateGlExportMutationVariables>;
export const GetGlExportListingDocument = gql`
    query getGLExportListing($companyId: String!) {
  getGLExportListing(companyId: $companyId) {
    startDate
    endDate
    transactionCount
    glDate
    generationBatch
    documentNo
  }
}
    `;

/**
 * __useGetGlExportListingQuery__
 *
 * To run a query within a React component, call `useGetGlExportListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGlExportListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGlExportListingQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetGlExportListingQuery(baseOptions: Apollo.QueryHookOptions<GetGlExportListingQuery, GetGlExportListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGlExportListingQuery, GetGlExportListingQueryVariables>(GetGlExportListingDocument, options);
      }
export function useGetGlExportListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGlExportListingQuery, GetGlExportListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGlExportListingQuery, GetGlExportListingQueryVariables>(GetGlExportListingDocument, options);
        }
export type GetGlExportListingQueryHookResult = ReturnType<typeof useGetGlExportListingQuery>;
export type GetGlExportListingLazyQueryHookResult = ReturnType<typeof useGetGlExportListingLazyQuery>;
export type GetGlExportListingQueryResult = Apollo.QueryResult<GetGlExportListingQuery, GetGlExportListingQueryVariables>;
export const GetGlDetailByGenerationBatchDocument = gql`
    query getGLDetailByGenerationBatch($companyId: String!, $generationBatch: String!) {
  getGLDetailByGenerationBatch(companyId: $companyId, generationBatch: $generationBatch) {
    glDate
    glType
    glTransactionType
    glAccountCode
    refDocumentDate
    refDocumentNo
    refDescription
    debitAmount
    creditAmount
  }
}
    `;

/**
 * __useGetGlDetailByGenerationBatchQuery__
 *
 * To run a query within a React component, call `useGetGlDetailByGenerationBatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGlDetailByGenerationBatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGlDetailByGenerationBatchQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      generationBatch: // value for 'generationBatch'
 *   },
 * });
 */
export function useGetGlDetailByGenerationBatchQuery(baseOptions: Apollo.QueryHookOptions<GetGlDetailByGenerationBatchQuery, GetGlDetailByGenerationBatchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGlDetailByGenerationBatchQuery, GetGlDetailByGenerationBatchQueryVariables>(GetGlDetailByGenerationBatchDocument, options);
      }
export function useGetGlDetailByGenerationBatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGlDetailByGenerationBatchQuery, GetGlDetailByGenerationBatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGlDetailByGenerationBatchQuery, GetGlDetailByGenerationBatchQueryVariables>(GetGlDetailByGenerationBatchDocument, options);
        }
export type GetGlDetailByGenerationBatchQueryHookResult = ReturnType<typeof useGetGlDetailByGenerationBatchQuery>;
export type GetGlDetailByGenerationBatchLazyQueryHookResult = ReturnType<typeof useGetGlDetailByGenerationBatchLazyQuery>;
export type GetGlDetailByGenerationBatchQueryResult = Apollo.QueryResult<GetGlDetailByGenerationBatchQuery, GetGlDetailByGenerationBatchQueryVariables>;
export const ExportGlJournalDocument = gql`
    query exportGLJournal($companyId: String!, $generationBatch: String!) {
  exportGLJournal(companyId: $companyId, generationBatch: $generationBatch) {
    base64
    fileName
  }
}
    `;

/**
 * __useExportGlJournalQuery__
 *
 * To run a query within a React component, call `useExportGlJournalQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportGlJournalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportGlJournalQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      generationBatch: // value for 'generationBatch'
 *   },
 * });
 */
export function useExportGlJournalQuery(baseOptions: Apollo.QueryHookOptions<ExportGlJournalQuery, ExportGlJournalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportGlJournalQuery, ExportGlJournalQueryVariables>(ExportGlJournalDocument, options);
      }
export function useExportGlJournalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportGlJournalQuery, ExportGlJournalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportGlJournalQuery, ExportGlJournalQueryVariables>(ExportGlJournalDocument, options);
        }
export type ExportGlJournalQueryHookResult = ReturnType<typeof useExportGlJournalQuery>;
export type ExportGlJournalLazyQueryHookResult = ReturnType<typeof useExportGlJournalLazyQuery>;
export type ExportGlJournalQueryResult = Apollo.QueryResult<ExportGlJournalQuery, ExportGlJournalQueryVariables>;
export const GetAllAreaVarianceIndonesiaDocument = gql`
    query getAllAreaVarianceIndonesia {
  getAllAreaVarianceIndonesia {
    actualBuiltUp
    actualLandArea
    builtUp
    commonStatus
    compensateAmount
    documentNo
    formula
    id
    landArea
    refId
    refTable
    saleId
    sales {
      unitId
      unit {
        id
        unitNo
      }
    }
  }
}
    `;

/**
 * __useGetAllAreaVarianceIndonesiaQuery__
 *
 * To run a query within a React component, call `useGetAllAreaVarianceIndonesiaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAreaVarianceIndonesiaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllAreaVarianceIndonesiaQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllAreaVarianceIndonesiaQuery(baseOptions?: Apollo.QueryHookOptions<GetAllAreaVarianceIndonesiaQuery, GetAllAreaVarianceIndonesiaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllAreaVarianceIndonesiaQuery, GetAllAreaVarianceIndonesiaQueryVariables>(GetAllAreaVarianceIndonesiaDocument, options);
      }
export function useGetAllAreaVarianceIndonesiaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllAreaVarianceIndonesiaQuery, GetAllAreaVarianceIndonesiaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllAreaVarianceIndonesiaQuery, GetAllAreaVarianceIndonesiaQueryVariables>(GetAllAreaVarianceIndonesiaDocument, options);
        }
export type GetAllAreaVarianceIndonesiaQueryHookResult = ReturnType<typeof useGetAllAreaVarianceIndonesiaQuery>;
export type GetAllAreaVarianceIndonesiaLazyQueryHookResult = ReturnType<typeof useGetAllAreaVarianceIndonesiaLazyQuery>;
export type GetAllAreaVarianceIndonesiaQueryResult = Apollo.QueryResult<GetAllAreaVarianceIndonesiaQuery, GetAllAreaVarianceIndonesiaQueryVariables>;
export const GetAreaVarianceByIdIndonesiaDocument = gql`
    query getAreaVarianceByIdIndonesia($areaVarianceId: String!) {
  getAreaVarianceByIdIndonesia(areaVarianceId: $areaVarianceId) {
    actualBuiltUp
    actualLandArea
    builtUp
    commonStatus
    compensateAmount
    documentNo
    formula
    id
    landArea
    refId
    refTable
    saleId
    unitData {
      builtUp
      id
      landArea
      price
      saleId
      unitNo
      unitStatus
    }
  }
}
    `;

/**
 * __useGetAreaVarianceByIdIndonesiaQuery__
 *
 * To run a query within a React component, call `useGetAreaVarianceByIdIndonesiaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAreaVarianceByIdIndonesiaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAreaVarianceByIdIndonesiaQuery({
 *   variables: {
 *      areaVarianceId: // value for 'areaVarianceId'
 *   },
 * });
 */
export function useGetAreaVarianceByIdIndonesiaQuery(baseOptions: Apollo.QueryHookOptions<GetAreaVarianceByIdIndonesiaQuery, GetAreaVarianceByIdIndonesiaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAreaVarianceByIdIndonesiaQuery, GetAreaVarianceByIdIndonesiaQueryVariables>(GetAreaVarianceByIdIndonesiaDocument, options);
      }
export function useGetAreaVarianceByIdIndonesiaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAreaVarianceByIdIndonesiaQuery, GetAreaVarianceByIdIndonesiaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAreaVarianceByIdIndonesiaQuery, GetAreaVarianceByIdIndonesiaQueryVariables>(GetAreaVarianceByIdIndonesiaDocument, options);
        }
export type GetAreaVarianceByIdIndonesiaQueryHookResult = ReturnType<typeof useGetAreaVarianceByIdIndonesiaQuery>;
export type GetAreaVarianceByIdIndonesiaLazyQueryHookResult = ReturnType<typeof useGetAreaVarianceByIdIndonesiaLazyQuery>;
export type GetAreaVarianceByIdIndonesiaQueryResult = Apollo.QueryResult<GetAreaVarianceByIdIndonesiaQuery, GetAreaVarianceByIdIndonesiaQueryVariables>;
export const AddAreaVarianceIndonesiaDocument = gql`
    mutation addAreaVarianceIndonesia($input: areaVarianceInputIndonesia!) {
  addAreaVarianceIndonesia(input: $input)
}
    `;
export type AddAreaVarianceIndonesiaMutationFn = Apollo.MutationFunction<AddAreaVarianceIndonesiaMutation, AddAreaVarianceIndonesiaMutationVariables>;

/**
 * __useAddAreaVarianceIndonesiaMutation__
 *
 * To run a mutation, you first call `useAddAreaVarianceIndonesiaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAreaVarianceIndonesiaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAreaVarianceIndonesiaMutation, { data, loading, error }] = useAddAreaVarianceIndonesiaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAreaVarianceIndonesiaMutation(baseOptions?: Apollo.MutationHookOptions<AddAreaVarianceIndonesiaMutation, AddAreaVarianceIndonesiaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAreaVarianceIndonesiaMutation, AddAreaVarianceIndonesiaMutationVariables>(AddAreaVarianceIndonesiaDocument, options);
      }
export type AddAreaVarianceIndonesiaMutationHookResult = ReturnType<typeof useAddAreaVarianceIndonesiaMutation>;
export type AddAreaVarianceIndonesiaMutationResult = Apollo.MutationResult<AddAreaVarianceIndonesiaMutation>;
export type AddAreaVarianceIndonesiaMutationOptions = Apollo.BaseMutationOptions<AddAreaVarianceIndonesiaMutation, AddAreaVarianceIndonesiaMutationVariables>;
export const EditAreaVarianceIndonesiaDocument = gql`
    mutation editAreaVarianceIndonesia($input: EditAreaVarianceIndonesiaInput!) {
  editAreaVarianceIndonesia(input: $input)
}
    `;
export type EditAreaVarianceIndonesiaMutationFn = Apollo.MutationFunction<EditAreaVarianceIndonesiaMutation, EditAreaVarianceIndonesiaMutationVariables>;

/**
 * __useEditAreaVarianceIndonesiaMutation__
 *
 * To run a mutation, you first call `useEditAreaVarianceIndonesiaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditAreaVarianceIndonesiaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editAreaVarianceIndonesiaMutation, { data, loading, error }] = useEditAreaVarianceIndonesiaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditAreaVarianceIndonesiaMutation(baseOptions?: Apollo.MutationHookOptions<EditAreaVarianceIndonesiaMutation, EditAreaVarianceIndonesiaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditAreaVarianceIndonesiaMutation, EditAreaVarianceIndonesiaMutationVariables>(EditAreaVarianceIndonesiaDocument, options);
      }
export type EditAreaVarianceIndonesiaMutationHookResult = ReturnType<typeof useEditAreaVarianceIndonesiaMutation>;
export type EditAreaVarianceIndonesiaMutationResult = Apollo.MutationResult<EditAreaVarianceIndonesiaMutation>;
export type EditAreaVarianceIndonesiaMutationOptions = Apollo.BaseMutationOptions<EditAreaVarianceIndonesiaMutation, EditAreaVarianceIndonesiaMutationVariables>;
export const GetUnitAtAreaVarianceDocument = gql`
    query getUnitAtAreaVariance($unitId: String!) {
  getUnitAtAreaVariance(unitId: $unitId) {
    id
    unitNo
    unitStatus
    price
    builtUp
    landArea
    saleId
  }
}
    `;

/**
 * __useGetUnitAtAreaVarianceQuery__
 *
 * To run a query within a React component, call `useGetUnitAtAreaVarianceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitAtAreaVarianceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitAtAreaVarianceQuery({
 *   variables: {
 *      unitId: // value for 'unitId'
 *   },
 * });
 */
export function useGetUnitAtAreaVarianceQuery(baseOptions: Apollo.QueryHookOptions<GetUnitAtAreaVarianceQuery, GetUnitAtAreaVarianceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitAtAreaVarianceQuery, GetUnitAtAreaVarianceQueryVariables>(GetUnitAtAreaVarianceDocument, options);
      }
export function useGetUnitAtAreaVarianceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitAtAreaVarianceQuery, GetUnitAtAreaVarianceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitAtAreaVarianceQuery, GetUnitAtAreaVarianceQueryVariables>(GetUnitAtAreaVarianceDocument, options);
        }
export type GetUnitAtAreaVarianceQueryHookResult = ReturnType<typeof useGetUnitAtAreaVarianceQuery>;
export type GetUnitAtAreaVarianceLazyQueryHookResult = ReturnType<typeof useGetUnitAtAreaVarianceLazyQuery>;
export type GetUnitAtAreaVarianceQueryResult = Apollo.QueryResult<GetUnitAtAreaVarianceQuery, GetUnitAtAreaVarianceQueryVariables>;
export const GetUnitListAtAreaVarianceDocument = gql`
    query getUnitListAtAreaVariance($projectId: String!) {
  getUnitListAtAreaVariance(projectId: $projectId) {
    builtUp
    id
    landArea
    price
    saleId
    unitNo
    unitStatus
  }
}
    `;

/**
 * __useGetUnitListAtAreaVarianceQuery__
 *
 * To run a query within a React component, call `useGetUnitListAtAreaVarianceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitListAtAreaVarianceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitListAtAreaVarianceQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetUnitListAtAreaVarianceQuery(baseOptions: Apollo.QueryHookOptions<GetUnitListAtAreaVarianceQuery, GetUnitListAtAreaVarianceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitListAtAreaVarianceQuery, GetUnitListAtAreaVarianceQueryVariables>(GetUnitListAtAreaVarianceDocument, options);
      }
export function useGetUnitListAtAreaVarianceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitListAtAreaVarianceQuery, GetUnitListAtAreaVarianceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitListAtAreaVarianceQuery, GetUnitListAtAreaVarianceQueryVariables>(GetUnitListAtAreaVarianceDocument, options);
        }
export type GetUnitListAtAreaVarianceQueryHookResult = ReturnType<typeof useGetUnitListAtAreaVarianceQuery>;
export type GetUnitListAtAreaVarianceLazyQueryHookResult = ReturnType<typeof useGetUnitListAtAreaVarianceLazyQuery>;
export type GetUnitListAtAreaVarianceQueryResult = Apollo.QueryResult<GetUnitListAtAreaVarianceQuery, GetUnitListAtAreaVarianceQueryVariables>;
export const GetAreaVarianceSettingSummaryDocument = gql`
    query getAreaVarianceSettingSummary {
  areaVarianceIndonesiaLastUpdate
  areaVariancePolicyIndonesiaLastUpdate
}
    `;

/**
 * __useGetAreaVarianceSettingSummaryQuery__
 *
 * To run a query within a React component, call `useGetAreaVarianceSettingSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAreaVarianceSettingSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAreaVarianceSettingSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAreaVarianceSettingSummaryQuery(baseOptions?: Apollo.QueryHookOptions<GetAreaVarianceSettingSummaryQuery, GetAreaVarianceSettingSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAreaVarianceSettingSummaryQuery, GetAreaVarianceSettingSummaryQueryVariables>(GetAreaVarianceSettingSummaryDocument, options);
      }
export function useGetAreaVarianceSettingSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAreaVarianceSettingSummaryQuery, GetAreaVarianceSettingSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAreaVarianceSettingSummaryQuery, GetAreaVarianceSettingSummaryQueryVariables>(GetAreaVarianceSettingSummaryDocument, options);
        }
export type GetAreaVarianceSettingSummaryQueryHookResult = ReturnType<typeof useGetAreaVarianceSettingSummaryQuery>;
export type GetAreaVarianceSettingSummaryLazyQueryHookResult = ReturnType<typeof useGetAreaVarianceSettingSummaryLazyQuery>;
export type GetAreaVarianceSettingSummaryQueryResult = Apollo.QueryResult<GetAreaVarianceSettingSummaryQuery, GetAreaVarianceSettingSummaryQueryVariables>;
export const GenerateBillingAreaVarianceDocument = gql`
    mutation generateBillingAreaVariance($areaVarianceId: String!, $unitId: String!) {
  generateBillingAreaVariance(areaVarianceId: $areaVarianceId, unitId: $unitId)
}
    `;
export type GenerateBillingAreaVarianceMutationFn = Apollo.MutationFunction<GenerateBillingAreaVarianceMutation, GenerateBillingAreaVarianceMutationVariables>;

/**
 * __useGenerateBillingAreaVarianceMutation__
 *
 * To run a mutation, you first call `useGenerateBillingAreaVarianceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateBillingAreaVarianceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateBillingAreaVarianceMutation, { data, loading, error }] = useGenerateBillingAreaVarianceMutation({
 *   variables: {
 *      areaVarianceId: // value for 'areaVarianceId'
 *      unitId: // value for 'unitId'
 *   },
 * });
 */
export function useGenerateBillingAreaVarianceMutation(baseOptions?: Apollo.MutationHookOptions<GenerateBillingAreaVarianceMutation, GenerateBillingAreaVarianceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateBillingAreaVarianceMutation, GenerateBillingAreaVarianceMutationVariables>(GenerateBillingAreaVarianceDocument, options);
      }
export type GenerateBillingAreaVarianceMutationHookResult = ReturnType<typeof useGenerateBillingAreaVarianceMutation>;
export type GenerateBillingAreaVarianceMutationResult = Apollo.MutationResult<GenerateBillingAreaVarianceMutation>;
export type GenerateBillingAreaVarianceMutationOptions = Apollo.BaseMutationOptions<GenerateBillingAreaVarianceMutation, GenerateBillingAreaVarianceMutationVariables>;
export const ReversalAreaVarianceDocument = gql`
    mutation reversalAreaVariance($areaVarianceId: String!, $refId: String!) {
  reversalAreaVariance(areaVarianceId: $areaVarianceId, refId: $refId)
}
    `;
export type ReversalAreaVarianceMutationFn = Apollo.MutationFunction<ReversalAreaVarianceMutation, ReversalAreaVarianceMutationVariables>;

/**
 * __useReversalAreaVarianceMutation__
 *
 * To run a mutation, you first call `useReversalAreaVarianceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReversalAreaVarianceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reversalAreaVarianceMutation, { data, loading, error }] = useReversalAreaVarianceMutation({
 *   variables: {
 *      areaVarianceId: // value for 'areaVarianceId'
 *      refId: // value for 'refId'
 *   },
 * });
 */
export function useReversalAreaVarianceMutation(baseOptions?: Apollo.MutationHookOptions<ReversalAreaVarianceMutation, ReversalAreaVarianceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReversalAreaVarianceMutation, ReversalAreaVarianceMutationVariables>(ReversalAreaVarianceDocument, options);
      }
export type ReversalAreaVarianceMutationHookResult = ReturnType<typeof useReversalAreaVarianceMutation>;
export type ReversalAreaVarianceMutationResult = Apollo.MutationResult<ReversalAreaVarianceMutation>;
export type ReversalAreaVarianceMutationOptions = Apollo.BaseMutationOptions<ReversalAreaVarianceMutation, ReversalAreaVarianceMutationVariables>;
export const GetAllProjectAreaVarianceIndonesiaDocument = gql`
    query getAllProjectAreaVarianceIndonesia {
  getAllProjectAreaVarianceIndonesia {
    id
    accountId
    projectId
    name
    effectiveDate
    formula
  }
}
    `;

/**
 * __useGetAllProjectAreaVarianceIndonesiaQuery__
 *
 * To run a query within a React component, call `useGetAllProjectAreaVarianceIndonesiaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllProjectAreaVarianceIndonesiaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllProjectAreaVarianceIndonesiaQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllProjectAreaVarianceIndonesiaQuery(baseOptions?: Apollo.QueryHookOptions<GetAllProjectAreaVarianceIndonesiaQuery, GetAllProjectAreaVarianceIndonesiaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllProjectAreaVarianceIndonesiaQuery, GetAllProjectAreaVarianceIndonesiaQueryVariables>(GetAllProjectAreaVarianceIndonesiaDocument, options);
      }
export function useGetAllProjectAreaVarianceIndonesiaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllProjectAreaVarianceIndonesiaQuery, GetAllProjectAreaVarianceIndonesiaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllProjectAreaVarianceIndonesiaQuery, GetAllProjectAreaVarianceIndonesiaQueryVariables>(GetAllProjectAreaVarianceIndonesiaDocument, options);
        }
export type GetAllProjectAreaVarianceIndonesiaQueryHookResult = ReturnType<typeof useGetAllProjectAreaVarianceIndonesiaQuery>;
export type GetAllProjectAreaVarianceIndonesiaLazyQueryHookResult = ReturnType<typeof useGetAllProjectAreaVarianceIndonesiaLazyQuery>;
export type GetAllProjectAreaVarianceIndonesiaQueryResult = Apollo.QueryResult<GetAllProjectAreaVarianceIndonesiaQuery, GetAllProjectAreaVarianceIndonesiaQueryVariables>;
export const GetProjectAreaVarianceByEffectiveDateDocument = gql`
    query getProjectAreaVarianceByEffectiveDate {
  getProjectAreaVarianceByEffectiveDate {
    id
    name
    effectiveDate
    formula
  }
}
    `;

/**
 * __useGetProjectAreaVarianceByEffectiveDateQuery__
 *
 * To run a query within a React component, call `useGetProjectAreaVarianceByEffectiveDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectAreaVarianceByEffectiveDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectAreaVarianceByEffectiveDateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProjectAreaVarianceByEffectiveDateQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectAreaVarianceByEffectiveDateQuery, GetProjectAreaVarianceByEffectiveDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectAreaVarianceByEffectiveDateQuery, GetProjectAreaVarianceByEffectiveDateQueryVariables>(GetProjectAreaVarianceByEffectiveDateDocument, options);
      }
export function useGetProjectAreaVarianceByEffectiveDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectAreaVarianceByEffectiveDateQuery, GetProjectAreaVarianceByEffectiveDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectAreaVarianceByEffectiveDateQuery, GetProjectAreaVarianceByEffectiveDateQueryVariables>(GetProjectAreaVarianceByEffectiveDateDocument, options);
        }
export type GetProjectAreaVarianceByEffectiveDateQueryHookResult = ReturnType<typeof useGetProjectAreaVarianceByEffectiveDateQuery>;
export type GetProjectAreaVarianceByEffectiveDateLazyQueryHookResult = ReturnType<typeof useGetProjectAreaVarianceByEffectiveDateLazyQuery>;
export type GetProjectAreaVarianceByEffectiveDateQueryResult = Apollo.QueryResult<GetProjectAreaVarianceByEffectiveDateQuery, GetProjectAreaVarianceByEffectiveDateQueryVariables>;
export const AddProjectAreaVarianceIndonesiaDocument = gql`
    mutation addProjectAreaVarianceIndonesia($input: AddProjectAreaVarianceInputIndonesia!) {
  addProjectAreaVarianceIndonesia(input: $input)
}
    `;
export type AddProjectAreaVarianceIndonesiaMutationFn = Apollo.MutationFunction<AddProjectAreaVarianceIndonesiaMutation, AddProjectAreaVarianceIndonesiaMutationVariables>;

/**
 * __useAddProjectAreaVarianceIndonesiaMutation__
 *
 * To run a mutation, you first call `useAddProjectAreaVarianceIndonesiaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProjectAreaVarianceIndonesiaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProjectAreaVarianceIndonesiaMutation, { data, loading, error }] = useAddProjectAreaVarianceIndonesiaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddProjectAreaVarianceIndonesiaMutation(baseOptions?: Apollo.MutationHookOptions<AddProjectAreaVarianceIndonesiaMutation, AddProjectAreaVarianceIndonesiaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProjectAreaVarianceIndonesiaMutation, AddProjectAreaVarianceIndonesiaMutationVariables>(AddProjectAreaVarianceIndonesiaDocument, options);
      }
export type AddProjectAreaVarianceIndonesiaMutationHookResult = ReturnType<typeof useAddProjectAreaVarianceIndonesiaMutation>;
export type AddProjectAreaVarianceIndonesiaMutationResult = Apollo.MutationResult<AddProjectAreaVarianceIndonesiaMutation>;
export type AddProjectAreaVarianceIndonesiaMutationOptions = Apollo.BaseMutationOptions<AddProjectAreaVarianceIndonesiaMutation, AddProjectAreaVarianceIndonesiaMutationVariables>;
export const EditProjectAreaVarianceIndonesiaDocument = gql`
    mutation editProjectAreaVarianceIndonesia($input: EditProjectAreaVarianceInputIndonesia!) {
  editProjectAreaVarianceIndonesia(input: $input)
}
    `;
export type EditProjectAreaVarianceIndonesiaMutationFn = Apollo.MutationFunction<EditProjectAreaVarianceIndonesiaMutation, EditProjectAreaVarianceIndonesiaMutationVariables>;

/**
 * __useEditProjectAreaVarianceIndonesiaMutation__
 *
 * To run a mutation, you first call `useEditProjectAreaVarianceIndonesiaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditProjectAreaVarianceIndonesiaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editProjectAreaVarianceIndonesiaMutation, { data, loading, error }] = useEditProjectAreaVarianceIndonesiaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditProjectAreaVarianceIndonesiaMutation(baseOptions?: Apollo.MutationHookOptions<EditProjectAreaVarianceIndonesiaMutation, EditProjectAreaVarianceIndonesiaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditProjectAreaVarianceIndonesiaMutation, EditProjectAreaVarianceIndonesiaMutationVariables>(EditProjectAreaVarianceIndonesiaDocument, options);
      }
export type EditProjectAreaVarianceIndonesiaMutationHookResult = ReturnType<typeof useEditProjectAreaVarianceIndonesiaMutation>;
export type EditProjectAreaVarianceIndonesiaMutationResult = Apollo.MutationResult<EditProjectAreaVarianceIndonesiaMutation>;
export type EditProjectAreaVarianceIndonesiaMutationOptions = Apollo.BaseMutationOptions<EditProjectAreaVarianceIndonesiaMutation, EditProjectAreaVarianceIndonesiaMutationVariables>;
export const DeleteProjectAreaVarianceDocument = gql`
    mutation deleteProjectAreaVariance($projectAreaVarianceId: String!) {
  deleteProjectAreaVarianceIndonesiaById(projectAreaVarianceId: $projectAreaVarianceId)
}
    `;
export type DeleteProjectAreaVarianceMutationFn = Apollo.MutationFunction<DeleteProjectAreaVarianceMutation, DeleteProjectAreaVarianceMutationVariables>;

/**
 * __useDeleteProjectAreaVarianceMutation__
 *
 * To run a mutation, you first call `useDeleteProjectAreaVarianceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectAreaVarianceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectAreaVarianceMutation, { data, loading, error }] = useDeleteProjectAreaVarianceMutation({
 *   variables: {
 *      projectAreaVarianceId: // value for 'projectAreaVarianceId'
 *   },
 * });
 */
export function useDeleteProjectAreaVarianceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectAreaVarianceMutation, DeleteProjectAreaVarianceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectAreaVarianceMutation, DeleteProjectAreaVarianceMutationVariables>(DeleteProjectAreaVarianceDocument, options);
      }
export type DeleteProjectAreaVarianceMutationHookResult = ReturnType<typeof useDeleteProjectAreaVarianceMutation>;
export type DeleteProjectAreaVarianceMutationResult = Apollo.MutationResult<DeleteProjectAreaVarianceMutation>;
export type DeleteProjectAreaVarianceMutationOptions = Apollo.BaseMutationOptions<DeleteProjectAreaVarianceMutation, DeleteProjectAreaVarianceMutationVariables>;
export const LoginDocument = gql`
    mutation login($Password: String!, $LoginId: String!) {
  login(Password: $Password, LoginId: $LoginId) {
    accessToken
    user {
      name
      lastestAccessedEntity
    }
    checkExpire
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      Password: // value for 'Password'
 *      LoginId: // value for 'LoginId'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const LogoutWithMicrosoftDocument = gql`
    query logoutWithMicrosoft {
  logoutWithMicrosoft
}
    `;

/**
 * __useLogoutWithMicrosoftQuery__
 *
 * To run a query within a React component, call `useLogoutWithMicrosoftQuery` and pass it any options that fit your needs.
 * When your component renders, `useLogoutWithMicrosoftQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLogoutWithMicrosoftQuery({
 *   variables: {
 *   },
 * });
 */
export function useLogoutWithMicrosoftQuery(baseOptions?: Apollo.QueryHookOptions<LogoutWithMicrosoftQuery, LogoutWithMicrosoftQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LogoutWithMicrosoftQuery, LogoutWithMicrosoftQueryVariables>(LogoutWithMicrosoftDocument, options);
      }
export function useLogoutWithMicrosoftLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LogoutWithMicrosoftQuery, LogoutWithMicrosoftQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LogoutWithMicrosoftQuery, LogoutWithMicrosoftQueryVariables>(LogoutWithMicrosoftDocument, options);
        }
export type LogoutWithMicrosoftQueryHookResult = ReturnType<typeof useLogoutWithMicrosoftQuery>;
export type LogoutWithMicrosoftLazyQueryHookResult = ReturnType<typeof useLogoutWithMicrosoftLazyQuery>;
export type LogoutWithMicrosoftQueryResult = Apollo.QueryResult<LogoutWithMicrosoftQuery, LogoutWithMicrosoftQueryVariables>;
export const ProfileDocument = gql`
    query profile {
  profile {
    ID
    accountID
    name
    userName
    email
    avatar
    contactNo
    department
    jobTitle
    lastestAccessedEntity
    superUser
  }
  getUserRole
}
    `;

/**
 * __useProfileQuery__
 *
 * To run a query within a React component, call `useProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfileQuery(baseOptions?: Apollo.QueryHookOptions<ProfileQuery, ProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileQuery, ProfileQueryVariables>(ProfileDocument, options);
      }
export function useProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileQuery, ProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileQuery, ProfileQueryVariables>(ProfileDocument, options);
        }
export type ProfileQueryHookResult = ReturnType<typeof useProfileQuery>;
export type ProfileLazyQueryHookResult = ReturnType<typeof useProfileLazyQuery>;
export type ProfileQueryResult = Apollo.QueryResult<ProfileQuery, ProfileQueryVariables>;
export const GetCurrentUserRoleIdDocument = gql`
    query getCurrentUserRoleId {
  getUserRole
}
    `;

/**
 * __useGetCurrentUserRoleIdQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserRoleIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserRoleIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserRoleIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserRoleIdQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserRoleIdQuery, GetCurrentUserRoleIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserRoleIdQuery, GetCurrentUserRoleIdQueryVariables>(GetCurrentUserRoleIdDocument, options);
      }
export function useGetCurrentUserRoleIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserRoleIdQuery, GetCurrentUserRoleIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserRoleIdQuery, GetCurrentUserRoleIdQueryVariables>(GetCurrentUserRoleIdDocument, options);
        }
export type GetCurrentUserRoleIdQueryHookResult = ReturnType<typeof useGetCurrentUserRoleIdQuery>;
export type GetCurrentUserRoleIdLazyQueryHookResult = ReturnType<typeof useGetCurrentUserRoleIdLazyQuery>;
export type GetCurrentUserRoleIdQueryResult = Apollo.QueryResult<GetCurrentUserRoleIdQuery, GetCurrentUserRoleIdQueryVariables>;
export const GetUserRoleIdsDocument = gql`
    query getUserRoleIds {
  getUserRoleIds
}
    `;

/**
 * __useGetUserRoleIdsQuery__
 *
 * To run a query within a React component, call `useGetUserRoleIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserRoleIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserRoleIdsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserRoleIdsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserRoleIdsQuery, GetUserRoleIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserRoleIdsQuery, GetUserRoleIdsQueryVariables>(GetUserRoleIdsDocument, options);
      }
export function useGetUserRoleIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserRoleIdsQuery, GetUserRoleIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserRoleIdsQuery, GetUserRoleIdsQueryVariables>(GetUserRoleIdsDocument, options);
        }
export type GetUserRoleIdsQueryHookResult = ReturnType<typeof useGetUserRoleIdsQuery>;
export type GetUserRoleIdsLazyQueryHookResult = ReturnType<typeof useGetUserRoleIdsLazyQuery>;
export type GetUserRoleIdsQueryResult = Apollo.QueryResult<GetUserRoleIdsQuery, GetUserRoleIdsQueryVariables>;
export const CheckFirstTimeUserPasswordTokenDocument = gql`
    query checkFirstTimeUserPasswordToken {
  checkFirstTimeUserPasswordToken
}
    `;

/**
 * __useCheckFirstTimeUserPasswordTokenQuery__
 *
 * To run a query within a React component, call `useCheckFirstTimeUserPasswordTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckFirstTimeUserPasswordTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckFirstTimeUserPasswordTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useCheckFirstTimeUserPasswordTokenQuery(baseOptions?: Apollo.QueryHookOptions<CheckFirstTimeUserPasswordTokenQuery, CheckFirstTimeUserPasswordTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckFirstTimeUserPasswordTokenQuery, CheckFirstTimeUserPasswordTokenQueryVariables>(CheckFirstTimeUserPasswordTokenDocument, options);
      }
export function useCheckFirstTimeUserPasswordTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckFirstTimeUserPasswordTokenQuery, CheckFirstTimeUserPasswordTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckFirstTimeUserPasswordTokenQuery, CheckFirstTimeUserPasswordTokenQueryVariables>(CheckFirstTimeUserPasswordTokenDocument, options);
        }
export type CheckFirstTimeUserPasswordTokenQueryHookResult = ReturnType<typeof useCheckFirstTimeUserPasswordTokenQuery>;
export type CheckFirstTimeUserPasswordTokenLazyQueryHookResult = ReturnType<typeof useCheckFirstTimeUserPasswordTokenLazyQuery>;
export type CheckFirstTimeUserPasswordTokenQueryResult = Apollo.QueryResult<CheckFirstTimeUserPasswordTokenQuery, CheckFirstTimeUserPasswordTokenQueryVariables>;
export const UpdateNewPasswordDocument = gql`
    mutation updateNewPassword($input: updatePasswordInput!) {
  updateNewPassword(input: $input)
}
    `;
export type UpdateNewPasswordMutationFn = Apollo.MutationFunction<UpdateNewPasswordMutation, UpdateNewPasswordMutationVariables>;

/**
 * __useUpdateNewPasswordMutation__
 *
 * To run a mutation, you first call `useUpdateNewPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNewPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNewPasswordMutation, { data, loading, error }] = useUpdateNewPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNewPasswordMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNewPasswordMutation, UpdateNewPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNewPasswordMutation, UpdateNewPasswordMutationVariables>(UpdateNewPasswordDocument, options);
      }
export type UpdateNewPasswordMutationHookResult = ReturnType<typeof useUpdateNewPasswordMutation>;
export type UpdateNewPasswordMutationResult = Apollo.MutationResult<UpdateNewPasswordMutation>;
export type UpdateNewPasswordMutationOptions = Apollo.BaseMutationOptions<UpdateNewPasswordMutation, UpdateNewPasswordMutationVariables>;
export const ActivateUserDocument = gql`
    mutation activateUser($input: updatePasswordInput!) {
  activateUser(input: $input)
}
    `;
export type ActivateUserMutationFn = Apollo.MutationFunction<ActivateUserMutation, ActivateUserMutationVariables>;

/**
 * __useActivateUserMutation__
 *
 * To run a mutation, you first call `useActivateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateUserMutation, { data, loading, error }] = useActivateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useActivateUserMutation(baseOptions?: Apollo.MutationHookOptions<ActivateUserMutation, ActivateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateUserMutation, ActivateUserMutationVariables>(ActivateUserDocument, options);
      }
export type ActivateUserMutationHookResult = ReturnType<typeof useActivateUserMutation>;
export type ActivateUserMutationResult = Apollo.MutationResult<ActivateUserMutation>;
export type ActivateUserMutationOptions = Apollo.BaseMutationOptions<ActivateUserMutation, ActivateUserMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation resetPassword($input: updatePasswordInput!) {
  resetPassword(input: $input)
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const UpdateProfileDocument = gql`
    mutation updateProfile($input: UserContactInput!) {
  updateProfile(input: $input)
}
    `;
export type UpdateProfileMutationFn = Apollo.MutationFunction<UpdateProfileMutation, UpdateProfileMutationVariables>;

/**
 * __useUpdateProfileMutation__
 *
 * To run a mutation, you first call `useUpdateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileMutation, { data, loading, error }] = useUpdateProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProfileMutation, UpdateProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProfileMutation, UpdateProfileMutationVariables>(UpdateProfileDocument, options);
      }
export type UpdateProfileMutationHookResult = ReturnType<typeof useUpdateProfileMutation>;
export type UpdateProfileMutationResult = Apollo.MutationResult<UpdateProfileMutation>;
export type UpdateProfileMutationOptions = Apollo.BaseMutationOptions<UpdateProfileMutation, UpdateProfileMutationVariables>;
export const LoginWithMicrosoftDocument = gql`
    mutation loginWithMicrosoft($ssoToken: String!, $microsoftEmail: String!) {
  loginWithMicrosoft(ssoToken: $ssoToken, microsoftEmail: $microsoftEmail) {
    accessToken
    user {
      name
      lastestAccessedEntity
    }
    checkExpire
  }
}
    `;
export type LoginWithMicrosoftMutationFn = Apollo.MutationFunction<LoginWithMicrosoftMutation, LoginWithMicrosoftMutationVariables>;

/**
 * __useLoginWithMicrosoftMutation__
 *
 * To run a mutation, you first call `useLoginWithMicrosoftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginWithMicrosoftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginWithMicrosoftMutation, { data, loading, error }] = useLoginWithMicrosoftMutation({
 *   variables: {
 *      ssoToken: // value for 'ssoToken'
 *      microsoftEmail: // value for 'microsoftEmail'
 *   },
 * });
 */
export function useLoginWithMicrosoftMutation(baseOptions?: Apollo.MutationHookOptions<LoginWithMicrosoftMutation, LoginWithMicrosoftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginWithMicrosoftMutation, LoginWithMicrosoftMutationVariables>(LoginWithMicrosoftDocument, options);
      }
export type LoginWithMicrosoftMutationHookResult = ReturnType<typeof useLoginWithMicrosoftMutation>;
export type LoginWithMicrosoftMutationResult = Apollo.MutationResult<LoginWithMicrosoftMutation>;
export type LoginWithMicrosoftMutationOptions = Apollo.BaseMutationOptions<LoginWithMicrosoftMutation, LoginWithMicrosoftMutationVariables>;
export const GetCountryDocument = gql`
    query getCountry {
  getCountry {
    name
    ID
  }
}
    `;

/**
 * __useGetCountryQuery__
 *
 * To run a query within a React component, call `useGetCountryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCountryQuery(baseOptions?: Apollo.QueryHookOptions<GetCountryQuery, GetCountryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCountryQuery, GetCountryQueryVariables>(GetCountryDocument, options);
      }
export function useGetCountryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCountryQuery, GetCountryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCountryQuery, GetCountryQueryVariables>(GetCountryDocument, options);
        }
export type GetCountryQueryHookResult = ReturnType<typeof useGetCountryQuery>;
export type GetCountryLazyQueryHookResult = ReturnType<typeof useGetCountryLazyQuery>;
export type GetCountryQueryResult = Apollo.QueryResult<GetCountryQuery, GetCountryQueryVariables>;
export const GetStateByCountryDocument = gql`
    query getStateByCountry($countryId: String!) {
  getStateByCountry(countryId: $countryId) {
    name
    ID
  }
}
    `;

/**
 * __useGetStateByCountryQuery__
 *
 * To run a query within a React component, call `useGetStateByCountryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStateByCountryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStateByCountryQuery({
 *   variables: {
 *      countryId: // value for 'countryId'
 *   },
 * });
 */
export function useGetStateByCountryQuery(baseOptions: Apollo.QueryHookOptions<GetStateByCountryQuery, GetStateByCountryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStateByCountryQuery, GetStateByCountryQueryVariables>(GetStateByCountryDocument, options);
      }
export function useGetStateByCountryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStateByCountryQuery, GetStateByCountryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStateByCountryQuery, GetStateByCountryQueryVariables>(GetStateByCountryDocument, options);
        }
export type GetStateByCountryQueryHookResult = ReturnType<typeof useGetStateByCountryQuery>;
export type GetStateByCountryLazyQueryHookResult = ReturnType<typeof useGetStateByCountryLazyQuery>;
export type GetStateByCountryQueryResult = Apollo.QueryResult<GetStateByCountryQuery, GetStateByCountryQueryVariables>;
export const GetCityByStateDocument = gql`
    query getCityByState($stateId: String!) {
  getCityByState(stateId: $stateId) {
    ID
    name
  }
}
    `;

/**
 * __useGetCityByStateQuery__
 *
 * To run a query within a React component, call `useGetCityByStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCityByStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCityByStateQuery({
 *   variables: {
 *      stateId: // value for 'stateId'
 *   },
 * });
 */
export function useGetCityByStateQuery(baseOptions: Apollo.QueryHookOptions<GetCityByStateQuery, GetCityByStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCityByStateQuery, GetCityByStateQueryVariables>(GetCityByStateDocument, options);
      }
export function useGetCityByStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCityByStateQuery, GetCityByStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCityByStateQuery, GetCityByStateQueryVariables>(GetCityByStateDocument, options);
        }
export type GetCityByStateQueryHookResult = ReturnType<typeof useGetCityByStateQuery>;
export type GetCityByStateLazyQueryHookResult = ReturnType<typeof useGetCityByStateLazyQuery>;
export type GetCityByStateQueryResult = Apollo.QueryResult<GetCityByStateQuery, GetCityByStateQueryVariables>;
export const GetPostCodeByCityDocument = gql`
    query getPostCodeByCity($cityId: String!) {
  getPostCodeByCity(cityId: $cityId) {
    ID
    postcode
  }
}
    `;

/**
 * __useGetPostCodeByCityQuery__
 *
 * To run a query within a React component, call `useGetPostCodeByCityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostCodeByCityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostCodeByCityQuery({
 *   variables: {
 *      cityId: // value for 'cityId'
 *   },
 * });
 */
export function useGetPostCodeByCityQuery(baseOptions: Apollo.QueryHookOptions<GetPostCodeByCityQuery, GetPostCodeByCityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostCodeByCityQuery, GetPostCodeByCityQueryVariables>(GetPostCodeByCityDocument, options);
      }
export function useGetPostCodeByCityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostCodeByCityQuery, GetPostCodeByCityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostCodeByCityQuery, GetPostCodeByCityQueryVariables>(GetPostCodeByCityDocument, options);
        }
export type GetPostCodeByCityQueryHookResult = ReturnType<typeof useGetPostCodeByCityQuery>;
export type GetPostCodeByCityLazyQueryHookResult = ReturnType<typeof useGetPostCodeByCityLazyQuery>;
export type GetPostCodeByCityQueryResult = Apollo.QueryResult<GetPostCodeByCityQuery, GetPostCodeByCityQueryVariables>;
export const GetAllReceiptByFinancierDocument = gql`
    query getAllReceiptByFinancier($status: String!) {
  getAllReceiptByFinancier(status: $status) {
    status
    generationBatchId
    financierName
    generationBatchDate
    receiptDate
    documentRef
    totalDocumentAmount
    financierId
    financierCode
    receiptList {
      salesId
      creditId
      debitId
      allocationId
    }
  }
}
    `;

/**
 * __useGetAllReceiptByFinancierQuery__
 *
 * To run a query within a React component, call `useGetAllReceiptByFinancierQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllReceiptByFinancierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllReceiptByFinancierQuery({
 *   variables: {
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetAllReceiptByFinancierQuery(baseOptions: Apollo.QueryHookOptions<GetAllReceiptByFinancierQuery, GetAllReceiptByFinancierQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllReceiptByFinancierQuery, GetAllReceiptByFinancierQueryVariables>(GetAllReceiptByFinancierDocument, options);
      }
export function useGetAllReceiptByFinancierLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllReceiptByFinancierQuery, GetAllReceiptByFinancierQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllReceiptByFinancierQuery, GetAllReceiptByFinancierQueryVariables>(GetAllReceiptByFinancierDocument, options);
        }
export type GetAllReceiptByFinancierQueryHookResult = ReturnType<typeof useGetAllReceiptByFinancierQuery>;
export type GetAllReceiptByFinancierLazyQueryHookResult = ReturnType<typeof useGetAllReceiptByFinancierLazyQuery>;
export type GetAllReceiptByFinancierQueryResult = Apollo.QueryResult<GetAllReceiptByFinancierQuery, GetAllReceiptByFinancierQueryVariables>;
export const GetBankPaymentMasterDataDocument = gql`
    query getBankPaymentMasterData {
  getBankPaymentMasterData {
    financierList {
      financierId
      financierName
      financierCode
    }
    bankList {
      bankAccountCode
      bankAccountId
      bankAccountNo
      bankProfileId
      bankProfileName
      currency
      isSelected
    }
  }
}
    `;

/**
 * __useGetBankPaymentMasterDataQuery__
 *
 * To run a query within a React component, call `useGetBankPaymentMasterDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBankPaymentMasterDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBankPaymentMasterDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBankPaymentMasterDataQuery(baseOptions?: Apollo.QueryHookOptions<GetBankPaymentMasterDataQuery, GetBankPaymentMasterDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBankPaymentMasterDataQuery, GetBankPaymentMasterDataQueryVariables>(GetBankPaymentMasterDataDocument, options);
      }
export function useGetBankPaymentMasterDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBankPaymentMasterDataQuery, GetBankPaymentMasterDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBankPaymentMasterDataQuery, GetBankPaymentMasterDataQueryVariables>(GetBankPaymentMasterDataDocument, options);
        }
export type GetBankPaymentMasterDataQueryHookResult = ReturnType<typeof useGetBankPaymentMasterDataQuery>;
export type GetBankPaymentMasterDataLazyQueryHookResult = ReturnType<typeof useGetBankPaymentMasterDataLazyQuery>;
export type GetBankPaymentMasterDataQueryResult = Apollo.QueryResult<GetBankPaymentMasterDataQuery, GetBankPaymentMasterDataQueryVariables>;
export const DeleteBankPaymentByIdDocument = gql`
    mutation deleteBankPaymentById($generationBatchId: String!) {
  deleteBankPaymentById(generationBatchId: $generationBatchId)
}
    `;
export type DeleteBankPaymentByIdMutationFn = Apollo.MutationFunction<DeleteBankPaymentByIdMutation, DeleteBankPaymentByIdMutationVariables>;

/**
 * __useDeleteBankPaymentByIdMutation__
 *
 * To run a mutation, you first call `useDeleteBankPaymentByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBankPaymentByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBankPaymentByIdMutation, { data, loading, error }] = useDeleteBankPaymentByIdMutation({
 *   variables: {
 *      generationBatchId: // value for 'generationBatchId'
 *   },
 * });
 */
export function useDeleteBankPaymentByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBankPaymentByIdMutation, DeleteBankPaymentByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBankPaymentByIdMutation, DeleteBankPaymentByIdMutationVariables>(DeleteBankPaymentByIdDocument, options);
      }
export type DeleteBankPaymentByIdMutationHookResult = ReturnType<typeof useDeleteBankPaymentByIdMutation>;
export type DeleteBankPaymentByIdMutationResult = Apollo.MutationResult<DeleteBankPaymentByIdMutation>;
export type DeleteBankPaymentByIdMutationOptions = Apollo.BaseMutationOptions<DeleteBankPaymentByIdMutation, DeleteBankPaymentByIdMutationVariables>;
export const RejectApproveReceiptDocument = gql`
    mutation rejectApproveReceipt($input: approveBankPaymentInput!) {
  rejectApproveReceipt(input: $input)
}
    `;
export type RejectApproveReceiptMutationFn = Apollo.MutationFunction<RejectApproveReceiptMutation, RejectApproveReceiptMutationVariables>;

/**
 * __useRejectApproveReceiptMutation__
 *
 * To run a mutation, you first call `useRejectApproveReceiptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectApproveReceiptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectApproveReceiptMutation, { data, loading, error }] = useRejectApproveReceiptMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRejectApproveReceiptMutation(baseOptions?: Apollo.MutationHookOptions<RejectApproveReceiptMutation, RejectApproveReceiptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectApproveReceiptMutation, RejectApproveReceiptMutationVariables>(RejectApproveReceiptDocument, options);
      }
export type RejectApproveReceiptMutationHookResult = ReturnType<typeof useRejectApproveReceiptMutation>;
export type RejectApproveReceiptMutationResult = Apollo.MutationResult<RejectApproveReceiptMutation>;
export type RejectApproveReceiptMutationOptions = Apollo.BaseMutationOptions<RejectApproveReceiptMutation, RejectApproveReceiptMutationVariables>;
export const CreateBankPaymentDocument = gql`
    mutation createBankPayment($input: addBankPaymentInput!) {
  createBankPayment(input: $input)
}
    `;
export type CreateBankPaymentMutationFn = Apollo.MutationFunction<CreateBankPaymentMutation, CreateBankPaymentMutationVariables>;

/**
 * __useCreateBankPaymentMutation__
 *
 * To run a mutation, you first call `useCreateBankPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBankPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBankPaymentMutation, { data, loading, error }] = useCreateBankPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBankPaymentMutation(baseOptions?: Apollo.MutationHookOptions<CreateBankPaymentMutation, CreateBankPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBankPaymentMutation, CreateBankPaymentMutationVariables>(CreateBankPaymentDocument, options);
      }
export type CreateBankPaymentMutationHookResult = ReturnType<typeof useCreateBankPaymentMutation>;
export type CreateBankPaymentMutationResult = Apollo.MutationResult<CreateBankPaymentMutation>;
export type CreateBankPaymentMutationOptions = Apollo.BaseMutationOptions<CreateBankPaymentMutation, CreateBankPaymentMutationVariables>;
export const EditBankPaymentDocument = gql`
    mutation editBankPayment($input: EditBankPaymentInput!) {
  editBankPayment(input: $input)
}
    `;
export type EditBankPaymentMutationFn = Apollo.MutationFunction<EditBankPaymentMutation, EditBankPaymentMutationVariables>;

/**
 * __useEditBankPaymentMutation__
 *
 * To run a mutation, you first call `useEditBankPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditBankPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editBankPaymentMutation, { data, loading, error }] = useEditBankPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditBankPaymentMutation(baseOptions?: Apollo.MutationHookOptions<EditBankPaymentMutation, EditBankPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditBankPaymentMutation, EditBankPaymentMutationVariables>(EditBankPaymentDocument, options);
      }
export type EditBankPaymentMutationHookResult = ReturnType<typeof useEditBankPaymentMutation>;
export type EditBankPaymentMutationResult = Apollo.MutationResult<EditBankPaymentMutation>;
export type EditBankPaymentMutationOptions = Apollo.BaseMutationOptions<EditBankPaymentMutation, EditBankPaymentMutationVariables>;
export const GetBillingListingByFinancierIdDocument = gql`
    query getBillingListingByFinancierId($financierId: String!, $generationBatchId: String) {
  getBillingListingByFinancierId(financierId: $financierId, generationBatchId: $generationBatchId) {
    financierId
    documentDate
    refNo
    documentNo
    description
    bankAccountId
    financierDetail {
      creditId
      debitId
      debitRefTable
      creditRefTable
      pbDocumentAmount
      pbDescription
      currentAllocate
      financialBillingId
      financierCode
      documentNo
      saleId
      unitId
      unitNo
      outstandingBalance
      buyerName
    }
  }
}
    `;

/**
 * __useGetBillingListingByFinancierIdQuery__
 *
 * To run a query within a React component, call `useGetBillingListingByFinancierIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillingListingByFinancierIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBillingListingByFinancierIdQuery({
 *   variables: {
 *      financierId: // value for 'financierId'
 *      generationBatchId: // value for 'generationBatchId'
 *   },
 * });
 */
export function useGetBillingListingByFinancierIdQuery(baseOptions: Apollo.QueryHookOptions<GetBillingListingByFinancierIdQuery, GetBillingListingByFinancierIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBillingListingByFinancierIdQuery, GetBillingListingByFinancierIdQueryVariables>(GetBillingListingByFinancierIdDocument, options);
      }
export function useGetBillingListingByFinancierIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBillingListingByFinancierIdQuery, GetBillingListingByFinancierIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBillingListingByFinancierIdQuery, GetBillingListingByFinancierIdQueryVariables>(GetBillingListingByFinancierIdDocument, options);
        }
export type GetBillingListingByFinancierIdQueryHookResult = ReturnType<typeof useGetBillingListingByFinancierIdQuery>;
export type GetBillingListingByFinancierIdLazyQueryHookResult = ReturnType<typeof useGetBillingListingByFinancierIdLazyQuery>;
export type GetBillingListingByFinancierIdQueryResult = Apollo.QueryResult<GetBillingListingByFinancierIdQuery, GetBillingListingByFinancierIdQueryVariables>;
export const EndFinancingSummaryDocument = gql`
    query endFinancingSummary {
  endFinancingSummary {
    totalDraft
    totalSubmitted
  }
}
    `;

/**
 * __useEndFinancingSummaryQuery__
 *
 * To run a query within a React component, call `useEndFinancingSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useEndFinancingSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEndFinancingSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useEndFinancingSummaryQuery(baseOptions?: Apollo.QueryHookOptions<EndFinancingSummaryQuery, EndFinancingSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EndFinancingSummaryQuery, EndFinancingSummaryQueryVariables>(EndFinancingSummaryDocument, options);
      }
export function useEndFinancingSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EndFinancingSummaryQuery, EndFinancingSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EndFinancingSummaryQuery, EndFinancingSummaryQueryVariables>(EndFinancingSummaryDocument, options);
        }
export type EndFinancingSummaryQueryHookResult = ReturnType<typeof useEndFinancingSummaryQuery>;
export type EndFinancingSummaryLazyQueryHookResult = ReturnType<typeof useEndFinancingSummaryLazyQuery>;
export type EndFinancingSummaryQueryResult = Apollo.QueryResult<EndFinancingSummaryQuery, EndFinancingSummaryQueryVariables>;
export const GetReceiptBillingByGenerationBatchIdDocument = gql`
    query getReceiptBillingByGenerationBatchId($generationBatchId: String!) {
  getReceiptBillingByGenerationBatchId(generationBatchId: $generationBatchId) {
    financierName
    totalDocAmt
    docDate
    docRef
    description
    bankAccount
    receiptIds
    status
    allocateDetail {
      docNo
      allocateAmt
      docDate
      docRef
      unitNo
    }
    getBankPaymentAttachment {
      id
      mediaType
      resourceUrl
      fileName
    }
  }
}
    `;

/**
 * __useGetReceiptBillingByGenerationBatchIdQuery__
 *
 * To run a query within a React component, call `useGetReceiptBillingByGenerationBatchIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReceiptBillingByGenerationBatchIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReceiptBillingByGenerationBatchIdQuery({
 *   variables: {
 *      generationBatchId: // value for 'generationBatchId'
 *   },
 * });
 */
export function useGetReceiptBillingByGenerationBatchIdQuery(baseOptions: Apollo.QueryHookOptions<GetReceiptBillingByGenerationBatchIdQuery, GetReceiptBillingByGenerationBatchIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReceiptBillingByGenerationBatchIdQuery, GetReceiptBillingByGenerationBatchIdQueryVariables>(GetReceiptBillingByGenerationBatchIdDocument, options);
      }
export function useGetReceiptBillingByGenerationBatchIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReceiptBillingByGenerationBatchIdQuery, GetReceiptBillingByGenerationBatchIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReceiptBillingByGenerationBatchIdQuery, GetReceiptBillingByGenerationBatchIdQueryVariables>(GetReceiptBillingByGenerationBatchIdDocument, options);
        }
export type GetReceiptBillingByGenerationBatchIdQueryHookResult = ReturnType<typeof useGetReceiptBillingByGenerationBatchIdQuery>;
export type GetReceiptBillingByGenerationBatchIdLazyQueryHookResult = ReturnType<typeof useGetReceiptBillingByGenerationBatchIdLazyQuery>;
export type GetReceiptBillingByGenerationBatchIdQueryResult = Apollo.QueryResult<GetReceiptBillingByGenerationBatchIdQuery, GetReceiptBillingByGenerationBatchIdQueryVariables>;
export const GetAllReceiptByGenerationBatchIdDocument = gql`
    query getAllReceiptByGenerationBatchId($generationBatchId: String!) {
  getAllReceiptByGenerationBatchId(generationBatchId: $generationBatchId) {
    totalDocAmt
    docDate
    docRef
    description
    bankAccount
    financierName
    generationBatchId
    allowReversal
    receiptList {
      receiptId
      docAmt
      unitNo
      docNo
      docDate
      allowReversal
      allocateDetail {
        docNo
        allocateAmt
        docDate
        description
      }
    }
    getReceiptAttachmentByBatch {
      id
      mediaType
      resourceUrl
      fileName
    }
  }
}
    `;

/**
 * __useGetAllReceiptByGenerationBatchIdQuery__
 *
 * To run a query within a React component, call `useGetAllReceiptByGenerationBatchIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllReceiptByGenerationBatchIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllReceiptByGenerationBatchIdQuery({
 *   variables: {
 *      generationBatchId: // value for 'generationBatchId'
 *   },
 * });
 */
export function useGetAllReceiptByGenerationBatchIdQuery(baseOptions: Apollo.QueryHookOptions<GetAllReceiptByGenerationBatchIdQuery, GetAllReceiptByGenerationBatchIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllReceiptByGenerationBatchIdQuery, GetAllReceiptByGenerationBatchIdQueryVariables>(GetAllReceiptByGenerationBatchIdDocument, options);
      }
export function useGetAllReceiptByGenerationBatchIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllReceiptByGenerationBatchIdQuery, GetAllReceiptByGenerationBatchIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllReceiptByGenerationBatchIdQuery, GetAllReceiptByGenerationBatchIdQueryVariables>(GetAllReceiptByGenerationBatchIdDocument, options);
        }
export type GetAllReceiptByGenerationBatchIdQueryHookResult = ReturnType<typeof useGetAllReceiptByGenerationBatchIdQuery>;
export type GetAllReceiptByGenerationBatchIdLazyQueryHookResult = ReturnType<typeof useGetAllReceiptByGenerationBatchIdLazyQuery>;
export type GetAllReceiptByGenerationBatchIdQueryResult = Apollo.QueryResult<GetAllReceiptByGenerationBatchIdQuery, GetAllReceiptByGenerationBatchIdQueryVariables>;
export const ReversalBankPaymentDocument = gql`
    mutation reversalBankPayment($input: reversalBankPaymentInput!) {
  reversalBankPayment(input: $input)
}
    `;
export type ReversalBankPaymentMutationFn = Apollo.MutationFunction<ReversalBankPaymentMutation, ReversalBankPaymentMutationVariables>;

/**
 * __useReversalBankPaymentMutation__
 *
 * To run a mutation, you first call `useReversalBankPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReversalBankPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reversalBankPaymentMutation, { data, loading, error }] = useReversalBankPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReversalBankPaymentMutation(baseOptions?: Apollo.MutationHookOptions<ReversalBankPaymentMutation, ReversalBankPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReversalBankPaymentMutation, ReversalBankPaymentMutationVariables>(ReversalBankPaymentDocument, options);
      }
export type ReversalBankPaymentMutationHookResult = ReturnType<typeof useReversalBankPaymentMutation>;
export type ReversalBankPaymentMutationResult = Apollo.MutationResult<ReversalBankPaymentMutation>;
export type ReversalBankPaymentMutationOptions = Apollo.BaseMutationOptions<ReversalBankPaymentMutation, ReversalBankPaymentMutationVariables>;
export const GetAllSaleLoanDocument = gql`
    query getAllSaleLoan {
  getAllSaleLoan {
    id
    saleId
    financierId
    financierReference
    solicitorId
    solicitorReference
    borrowerName
    borrowerAddress {
      address
    }
    loanLooDate
    loanPeriod
    loanAmount
    loanPercentage
    gstFinanceByBank
    taxSchemeId
    totalLoanAmount
    loanSeqno
    loanLimit
    remark
    renoticeDate
    rrDate
    rrSolicitorId
    rrSolicitorReferenceNo
    sale {
      id
      unitId
    }
    financiers {
      id
      logoUrl
    }
  }
}
    `;

/**
 * __useGetAllSaleLoanQuery__
 *
 * To run a query within a React component, call `useGetAllSaleLoanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSaleLoanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllSaleLoanQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllSaleLoanQuery(baseOptions?: Apollo.QueryHookOptions<GetAllSaleLoanQuery, GetAllSaleLoanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllSaleLoanQuery, GetAllSaleLoanQueryVariables>(GetAllSaleLoanDocument, options);
      }
export function useGetAllSaleLoanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllSaleLoanQuery, GetAllSaleLoanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllSaleLoanQuery, GetAllSaleLoanQueryVariables>(GetAllSaleLoanDocument, options);
        }
export type GetAllSaleLoanQueryHookResult = ReturnType<typeof useGetAllSaleLoanQuery>;
export type GetAllSaleLoanLazyQueryHookResult = ReturnType<typeof useGetAllSaleLoanLazyQuery>;
export type GetAllSaleLoanQueryResult = Apollo.QueryResult<GetAllSaleLoanQuery, GetAllSaleLoanQueryVariables>;
export const GetSaleLoanListingDocument = gql`
    query getSaleLoanListing($status: String!) {
  getSaleLoanListing(status: $status) {
    saleId
    totalAmount
    totalPercentage
    unitNo
    renoticeDate
    cancelDate
    cancellationStatus
    generationBatchId
    financierList {
      id
      financierLogo
      financierCode
      financierName
    }
  }
}
    `;

/**
 * __useGetSaleLoanListingQuery__
 *
 * To run a query within a React component, call `useGetSaleLoanListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSaleLoanListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSaleLoanListingQuery({
 *   variables: {
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetSaleLoanListingQuery(baseOptions: Apollo.QueryHookOptions<GetSaleLoanListingQuery, GetSaleLoanListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSaleLoanListingQuery, GetSaleLoanListingQueryVariables>(GetSaleLoanListingDocument, options);
      }
export function useGetSaleLoanListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSaleLoanListingQuery, GetSaleLoanListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSaleLoanListingQuery, GetSaleLoanListingQueryVariables>(GetSaleLoanListingDocument, options);
        }
export type GetSaleLoanListingQueryHookResult = ReturnType<typeof useGetSaleLoanListingQuery>;
export type GetSaleLoanListingLazyQueryHookResult = ReturnType<typeof useGetSaleLoanListingLazyQuery>;
export type GetSaleLoanListingQueryResult = Apollo.QueryResult<GetSaleLoanListingQuery, GetSaleLoanListingQueryVariables>;
export const GetSaleLoanByGenerationIdDocument = gql`
    query getSaleLoanByGenerationId($generationId: String!, $projectID: String!) {
  getSaleLoanByGenerationId(generationId: $generationId, projectID: $projectID) {
    generationBatchId
    generationBatchDate
    saleId
    unitNo
    purchaserName
    isCompany
    companyName
    sellingPrice
    loanLimit
    otherLoan
    renoticeDate
    taxSchemeId
    spaDate
    looDate
    financierDetail {
      endFinancierId
      endFinRefNo
      solicitorId
      solicitorRefNo
      borrowerName
      borrowerAddress {
        address
        country
        city
        state
        postCode
      }
      loanPeriod
      loanSequence
      loanAmount
      remark
      taxSchemeId
      saleLoanId
      saleId
      solicitorName
      solicitorCode
      financierName
      financierLogo
      loanLooDate
      loanApprovalDate
      loanSignDate
      loanPercent
      loanLimit
      sellingPrice
    }
  }
}
    `;

/**
 * __useGetSaleLoanByGenerationIdQuery__
 *
 * To run a query within a React component, call `useGetSaleLoanByGenerationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSaleLoanByGenerationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSaleLoanByGenerationIdQuery({
 *   variables: {
 *      generationId: // value for 'generationId'
 *      projectID: // value for 'projectID'
 *   },
 * });
 */
export function useGetSaleLoanByGenerationIdQuery(baseOptions: Apollo.QueryHookOptions<GetSaleLoanByGenerationIdQuery, GetSaleLoanByGenerationIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSaleLoanByGenerationIdQuery, GetSaleLoanByGenerationIdQueryVariables>(GetSaleLoanByGenerationIdDocument, options);
      }
export function useGetSaleLoanByGenerationIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSaleLoanByGenerationIdQuery, GetSaleLoanByGenerationIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSaleLoanByGenerationIdQuery, GetSaleLoanByGenerationIdQueryVariables>(GetSaleLoanByGenerationIdDocument, options);
        }
export type GetSaleLoanByGenerationIdQueryHookResult = ReturnType<typeof useGetSaleLoanByGenerationIdQuery>;
export type GetSaleLoanByGenerationIdLazyQueryHookResult = ReturnType<typeof useGetSaleLoanByGenerationIdLazyQuery>;
export type GetSaleLoanByGenerationIdQueryResult = Apollo.QueryResult<GetSaleLoanByGenerationIdQuery, GetSaleLoanByGenerationIdQueryVariables>;
export const GetSaleLoanUnitDocument = gql`
    query getSaleLoanUnit {
  getSaleLoanUnit {
    saleId
    salesStatus
    spaDate
    sellingPrice
    unitId
    unitNo
    contactId
    fullName
    propertyTypeName
    taxSchemeId
    propertyType
    isCashBuyer
    isCompany
    companyName
  }
}
    `;

/**
 * __useGetSaleLoanUnitQuery__
 *
 * To run a query within a React component, call `useGetSaleLoanUnitQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSaleLoanUnitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSaleLoanUnitQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSaleLoanUnitQuery(baseOptions?: Apollo.QueryHookOptions<GetSaleLoanUnitQuery, GetSaleLoanUnitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSaleLoanUnitQuery, GetSaleLoanUnitQueryVariables>(GetSaleLoanUnitDocument, options);
      }
export function useGetSaleLoanUnitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSaleLoanUnitQuery, GetSaleLoanUnitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSaleLoanUnitQuery, GetSaleLoanUnitQueryVariables>(GetSaleLoanUnitDocument, options);
        }
export type GetSaleLoanUnitQueryHookResult = ReturnType<typeof useGetSaleLoanUnitQuery>;
export type GetSaleLoanUnitLazyQueryHookResult = ReturnType<typeof useGetSaleLoanUnitLazyQuery>;
export type GetSaleLoanUnitQueryResult = Apollo.QueryResult<GetSaleLoanUnitQuery, GetSaleLoanUnitQueryVariables>;
export const AddSaleLoanDocument = gql`
    mutation addSaleLoan($input: AddSaleLoanInput!) {
  addSaleLoan(input: $input)
}
    `;
export type AddSaleLoanMutationFn = Apollo.MutationFunction<AddSaleLoanMutation, AddSaleLoanMutationVariables>;

/**
 * __useAddSaleLoanMutation__
 *
 * To run a mutation, you first call `useAddSaleLoanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSaleLoanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSaleLoanMutation, { data, loading, error }] = useAddSaleLoanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddSaleLoanMutation(baseOptions?: Apollo.MutationHookOptions<AddSaleLoanMutation, AddSaleLoanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSaleLoanMutation, AddSaleLoanMutationVariables>(AddSaleLoanDocument, options);
      }
export type AddSaleLoanMutationHookResult = ReturnType<typeof useAddSaleLoanMutation>;
export type AddSaleLoanMutationResult = Apollo.MutationResult<AddSaleLoanMutation>;
export type AddSaleLoanMutationOptions = Apollo.BaseMutationOptions<AddSaleLoanMutation, AddSaleLoanMutationVariables>;
export const AddSaleLoanEndFinDocument = gql`
    mutation addSaleLoanEndFin($input: AddSaleLoanDetailInput!) {
  addSaleLoanEndFin(input: $input)
}
    `;
export type AddSaleLoanEndFinMutationFn = Apollo.MutationFunction<AddSaleLoanEndFinMutation, AddSaleLoanEndFinMutationVariables>;

/**
 * __useAddSaleLoanEndFinMutation__
 *
 * To run a mutation, you first call `useAddSaleLoanEndFinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSaleLoanEndFinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSaleLoanEndFinMutation, { data, loading, error }] = useAddSaleLoanEndFinMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddSaleLoanEndFinMutation(baseOptions?: Apollo.MutationHookOptions<AddSaleLoanEndFinMutation, AddSaleLoanEndFinMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSaleLoanEndFinMutation, AddSaleLoanEndFinMutationVariables>(AddSaleLoanEndFinDocument, options);
      }
export type AddSaleLoanEndFinMutationHookResult = ReturnType<typeof useAddSaleLoanEndFinMutation>;
export type AddSaleLoanEndFinMutationResult = Apollo.MutationResult<AddSaleLoanEndFinMutation>;
export type AddSaleLoanEndFinMutationOptions = Apollo.BaseMutationOptions<AddSaleLoanEndFinMutation, AddSaleLoanEndFinMutationVariables>;
export const EditSaleLoanEndFinDocument = gql`
    mutation editSaleLoanEndFin($input: EditSaleLoanDetailInput!) {
  editSaleLoanEndFin(input: $input)
}
    `;
export type EditSaleLoanEndFinMutationFn = Apollo.MutationFunction<EditSaleLoanEndFinMutation, EditSaleLoanEndFinMutationVariables>;

/**
 * __useEditSaleLoanEndFinMutation__
 *
 * To run a mutation, you first call `useEditSaleLoanEndFinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSaleLoanEndFinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSaleLoanEndFinMutation, { data, loading, error }] = useEditSaleLoanEndFinMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditSaleLoanEndFinMutation(baseOptions?: Apollo.MutationHookOptions<EditSaleLoanEndFinMutation, EditSaleLoanEndFinMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditSaleLoanEndFinMutation, EditSaleLoanEndFinMutationVariables>(EditSaleLoanEndFinDocument, options);
      }
export type EditSaleLoanEndFinMutationHookResult = ReturnType<typeof useEditSaleLoanEndFinMutation>;
export type EditSaleLoanEndFinMutationResult = Apollo.MutationResult<EditSaleLoanEndFinMutation>;
export type EditSaleLoanEndFinMutationOptions = Apollo.BaseMutationOptions<EditSaleLoanEndFinMutation, EditSaleLoanEndFinMutationVariables>;
export const RenoticeLoanApplicationDocument = gql`
    mutation renoticeLoanApplication($input: loanAppRenotice!) {
  renoticeLoanApplication(input: $input)
}
    `;
export type RenoticeLoanApplicationMutationFn = Apollo.MutationFunction<RenoticeLoanApplicationMutation, RenoticeLoanApplicationMutationVariables>;

/**
 * __useRenoticeLoanApplicationMutation__
 *
 * To run a mutation, you first call `useRenoticeLoanApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenoticeLoanApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renoticeLoanApplicationMutation, { data, loading, error }] = useRenoticeLoanApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRenoticeLoanApplicationMutation(baseOptions?: Apollo.MutationHookOptions<RenoticeLoanApplicationMutation, RenoticeLoanApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenoticeLoanApplicationMutation, RenoticeLoanApplicationMutationVariables>(RenoticeLoanApplicationDocument, options);
      }
export type RenoticeLoanApplicationMutationHookResult = ReturnType<typeof useRenoticeLoanApplicationMutation>;
export type RenoticeLoanApplicationMutationResult = Apollo.MutationResult<RenoticeLoanApplicationMutation>;
export type RenoticeLoanApplicationMutationOptions = Apollo.BaseMutationOptions<RenoticeLoanApplicationMutation, RenoticeLoanApplicationMutationVariables>;
export const DeleteSaleLoanDocument = gql`
    mutation deleteSaleLoan($input: DeleteSaleLoanInput!) {
  deleteSaleLoan(input: $input)
}
    `;
export type DeleteSaleLoanMutationFn = Apollo.MutationFunction<DeleteSaleLoanMutation, DeleteSaleLoanMutationVariables>;

/**
 * __useDeleteSaleLoanMutation__
 *
 * To run a mutation, you first call `useDeleteSaleLoanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSaleLoanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSaleLoanMutation, { data, loading, error }] = useDeleteSaleLoanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSaleLoanMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSaleLoanMutation, DeleteSaleLoanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSaleLoanMutation, DeleteSaleLoanMutationVariables>(DeleteSaleLoanDocument, options);
      }
export type DeleteSaleLoanMutationHookResult = ReturnType<typeof useDeleteSaleLoanMutation>;
export type DeleteSaleLoanMutationResult = Apollo.MutationResult<DeleteSaleLoanMutation>;
export type DeleteSaleLoanMutationOptions = Apollo.BaseMutationOptions<DeleteSaleLoanMutation, DeleteSaleLoanMutationVariables>;
export const GetBankLoansSummaryDocument = gql`
    query getBankLoansSummary {
  totalLoanAppliedCount
  totalLoanApprovedCount
  totalLoanSettledCount
  totalLoanAppliedAmount
}
    `;

/**
 * __useGetBankLoansSummaryQuery__
 *
 * To run a query within a React component, call `useGetBankLoansSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBankLoansSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBankLoansSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBankLoansSummaryQuery(baseOptions?: Apollo.QueryHookOptions<GetBankLoansSummaryQuery, GetBankLoansSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBankLoansSummaryQuery, GetBankLoansSummaryQueryVariables>(GetBankLoansSummaryDocument, options);
      }
export function useGetBankLoansSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBankLoansSummaryQuery, GetBankLoansSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBankLoansSummaryQuery, GetBankLoansSummaryQueryVariables>(GetBankLoansSummaryDocument, options);
        }
export type GetBankLoansSummaryQueryHookResult = ReturnType<typeof useGetBankLoansSummaryQuery>;
export type GetBankLoansSummaryLazyQueryHookResult = ReturnType<typeof useGetBankLoansSummaryLazyQuery>;
export type GetBankLoansSummaryQueryResult = Apollo.QueryResult<GetBankLoansSummaryQuery, GetBankLoansSummaryQueryVariables>;
export const GetLoanApprovalCountDocument = gql`
    query getLoanApprovalCount($projectId: String!) {
  getLoanApprovalCount(projectId: $projectId) {
    draftCount
    submittedCount
    approvedCount
  }
}
    `;

/**
 * __useGetLoanApprovalCountQuery__
 *
 * To run a query within a React component, call `useGetLoanApprovalCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoanApprovalCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoanApprovalCountQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetLoanApprovalCountQuery(baseOptions: Apollo.QueryHookOptions<GetLoanApprovalCountQuery, GetLoanApprovalCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoanApprovalCountQuery, GetLoanApprovalCountQueryVariables>(GetLoanApprovalCountDocument, options);
      }
export function useGetLoanApprovalCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLoanApprovalCountQuery, GetLoanApprovalCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoanApprovalCountQuery, GetLoanApprovalCountQueryVariables>(GetLoanApprovalCountDocument, options);
        }
export type GetLoanApprovalCountQueryHookResult = ReturnType<typeof useGetLoanApprovalCountQuery>;
export type GetLoanApprovalCountLazyQueryHookResult = ReturnType<typeof useGetLoanApprovalCountLazyQuery>;
export type GetLoanApprovalCountQueryResult = Apollo.QueryResult<GetLoanApprovalCountQuery, GetLoanApprovalCountQueryVariables>;
export const GetSaleLoanCancellationListingDocument = gql`
    query getSaleLoanCancellationListing($status: String!) {
  getSaleLoanCancellationListing(status: $status) {
    saleId
    id
    approvalRoleId
    unitNo
    cancelDate
    cancelReason
    approvalStatus
  }
}
    `;

/**
 * __useGetSaleLoanCancellationListingQuery__
 *
 * To run a query within a React component, call `useGetSaleLoanCancellationListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSaleLoanCancellationListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSaleLoanCancellationListingQuery({
 *   variables: {
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetSaleLoanCancellationListingQuery(baseOptions: Apollo.QueryHookOptions<GetSaleLoanCancellationListingQuery, GetSaleLoanCancellationListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSaleLoanCancellationListingQuery, GetSaleLoanCancellationListingQueryVariables>(GetSaleLoanCancellationListingDocument, options);
      }
export function useGetSaleLoanCancellationListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSaleLoanCancellationListingQuery, GetSaleLoanCancellationListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSaleLoanCancellationListingQuery, GetSaleLoanCancellationListingQueryVariables>(GetSaleLoanCancellationListingDocument, options);
        }
export type GetSaleLoanCancellationListingQueryHookResult = ReturnType<typeof useGetSaleLoanCancellationListingQuery>;
export type GetSaleLoanCancellationListingLazyQueryHookResult = ReturnType<typeof useGetSaleLoanCancellationListingLazyQuery>;
export type GetSaleLoanCancellationListingQueryResult = Apollo.QueryResult<GetSaleLoanCancellationListingQuery, GetSaleLoanCancellationListingQueryVariables>;
export const GetSaleLoanCancellationByIdDocument = gql`
    query getSaleLoanCancellationById($id: String!) {
  getSaleLoanCancellationById(id: $id) {
    saleId
    saleLoanCancellationId
    spaDate
    unitNo
    purchaserName
    companyName
    isCompany
    financierDetails {
      financierName
      financierCode
      solicitorName
      solicitorCode
    }
    cancelDate
    cancelReason
    cancelRemark
  }
}
    `;

/**
 * __useGetSaleLoanCancellationByIdQuery__
 *
 * To run a query within a React component, call `useGetSaleLoanCancellationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSaleLoanCancellationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSaleLoanCancellationByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSaleLoanCancellationByIdQuery(baseOptions: Apollo.QueryHookOptions<GetSaleLoanCancellationByIdQuery, GetSaleLoanCancellationByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSaleLoanCancellationByIdQuery, GetSaleLoanCancellationByIdQueryVariables>(GetSaleLoanCancellationByIdDocument, options);
      }
export function useGetSaleLoanCancellationByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSaleLoanCancellationByIdQuery, GetSaleLoanCancellationByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSaleLoanCancellationByIdQuery, GetSaleLoanCancellationByIdQueryVariables>(GetSaleLoanCancellationByIdDocument, options);
        }
export type GetSaleLoanCancellationByIdQueryHookResult = ReturnType<typeof useGetSaleLoanCancellationByIdQuery>;
export type GetSaleLoanCancellationByIdLazyQueryHookResult = ReturnType<typeof useGetSaleLoanCancellationByIdLazyQuery>;
export type GetSaleLoanCancellationByIdQueryResult = Apollo.QueryResult<GetSaleLoanCancellationByIdQuery, GetSaleLoanCancellationByIdQueryVariables>;
export const GetSaleLoanCancellationDropdownDocument = gql`
    query getSaleLoanCancellationDropdown {
  getSaleLoanCancellationDropdown {
    saleId
    unitNo
    purchaserName
    isCompany
    companyName
    financierDetails {
      financierName
      financierCode
      solicitorName
      solicitorCode
    }
    spaDate
  }
}
    `;

/**
 * __useGetSaleLoanCancellationDropdownQuery__
 *
 * To run a query within a React component, call `useGetSaleLoanCancellationDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSaleLoanCancellationDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSaleLoanCancellationDropdownQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSaleLoanCancellationDropdownQuery(baseOptions?: Apollo.QueryHookOptions<GetSaleLoanCancellationDropdownQuery, GetSaleLoanCancellationDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSaleLoanCancellationDropdownQuery, GetSaleLoanCancellationDropdownQueryVariables>(GetSaleLoanCancellationDropdownDocument, options);
      }
export function useGetSaleLoanCancellationDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSaleLoanCancellationDropdownQuery, GetSaleLoanCancellationDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSaleLoanCancellationDropdownQuery, GetSaleLoanCancellationDropdownQueryVariables>(GetSaleLoanCancellationDropdownDocument, options);
        }
export type GetSaleLoanCancellationDropdownQueryHookResult = ReturnType<typeof useGetSaleLoanCancellationDropdownQuery>;
export type GetSaleLoanCancellationDropdownLazyQueryHookResult = ReturnType<typeof useGetSaleLoanCancellationDropdownLazyQuery>;
export type GetSaleLoanCancellationDropdownQueryResult = Apollo.QueryResult<GetSaleLoanCancellationDropdownQuery, GetSaleLoanCancellationDropdownQueryVariables>;
export const AddSaleLoanCancellationDocument = gql`
    mutation addSaleLoanCancellation($input: AddSaleLoanCancellationInput!) {
  addSaleLoanCancellation(input: $input)
}
    `;
export type AddSaleLoanCancellationMutationFn = Apollo.MutationFunction<AddSaleLoanCancellationMutation, AddSaleLoanCancellationMutationVariables>;

/**
 * __useAddSaleLoanCancellationMutation__
 *
 * To run a mutation, you first call `useAddSaleLoanCancellationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSaleLoanCancellationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSaleLoanCancellationMutation, { data, loading, error }] = useAddSaleLoanCancellationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddSaleLoanCancellationMutation(baseOptions?: Apollo.MutationHookOptions<AddSaleLoanCancellationMutation, AddSaleLoanCancellationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSaleLoanCancellationMutation, AddSaleLoanCancellationMutationVariables>(AddSaleLoanCancellationDocument, options);
      }
export type AddSaleLoanCancellationMutationHookResult = ReturnType<typeof useAddSaleLoanCancellationMutation>;
export type AddSaleLoanCancellationMutationResult = Apollo.MutationResult<AddSaleLoanCancellationMutation>;
export type AddSaleLoanCancellationMutationOptions = Apollo.BaseMutationOptions<AddSaleLoanCancellationMutation, AddSaleLoanCancellationMutationVariables>;
export const EditSaleLoanCancellationDocument = gql`
    mutation editSaleLoanCancellation($input: EditSaleLoanCancellationInput!) {
  editSaleLoanCancellation(input: $input)
}
    `;
export type EditSaleLoanCancellationMutationFn = Apollo.MutationFunction<EditSaleLoanCancellationMutation, EditSaleLoanCancellationMutationVariables>;

/**
 * __useEditSaleLoanCancellationMutation__
 *
 * To run a mutation, you first call `useEditSaleLoanCancellationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSaleLoanCancellationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSaleLoanCancellationMutation, { data, loading, error }] = useEditSaleLoanCancellationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditSaleLoanCancellationMutation(baseOptions?: Apollo.MutationHookOptions<EditSaleLoanCancellationMutation, EditSaleLoanCancellationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditSaleLoanCancellationMutation, EditSaleLoanCancellationMutationVariables>(EditSaleLoanCancellationDocument, options);
      }
export type EditSaleLoanCancellationMutationHookResult = ReturnType<typeof useEditSaleLoanCancellationMutation>;
export type EditSaleLoanCancellationMutationResult = Apollo.MutationResult<EditSaleLoanCancellationMutation>;
export type EditSaleLoanCancellationMutationOptions = Apollo.BaseMutationOptions<EditSaleLoanCancellationMutation, EditSaleLoanCancellationMutationVariables>;
export const DeleteSaleLoanCancellationDocument = gql`
    mutation deleteSaleLoanCancellation($saleLoanCancellationId: String!) {
  deleteSaleLoanCancellation(saleLoanCancellationId: $saleLoanCancellationId)
}
    `;
export type DeleteSaleLoanCancellationMutationFn = Apollo.MutationFunction<DeleteSaleLoanCancellationMutation, DeleteSaleLoanCancellationMutationVariables>;

/**
 * __useDeleteSaleLoanCancellationMutation__
 *
 * To run a mutation, you first call `useDeleteSaleLoanCancellationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSaleLoanCancellationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSaleLoanCancellationMutation, { data, loading, error }] = useDeleteSaleLoanCancellationMutation({
 *   variables: {
 *      saleLoanCancellationId: // value for 'saleLoanCancellationId'
 *   },
 * });
 */
export function useDeleteSaleLoanCancellationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSaleLoanCancellationMutation, DeleteSaleLoanCancellationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSaleLoanCancellationMutation, DeleteSaleLoanCancellationMutationVariables>(DeleteSaleLoanCancellationDocument, options);
      }
export type DeleteSaleLoanCancellationMutationHookResult = ReturnType<typeof useDeleteSaleLoanCancellationMutation>;
export type DeleteSaleLoanCancellationMutationResult = Apollo.MutationResult<DeleteSaleLoanCancellationMutation>;
export type DeleteSaleLoanCancellationMutationOptions = Apollo.BaseMutationOptions<DeleteSaleLoanCancellationMutation, DeleteSaleLoanCancellationMutationVariables>;
export const ApproveSaleLoanCancellationDocument = gql`
    mutation approveSaleLoanCancellation($saleLoanCancellationIds: [String!]!) {
  approveSaleLoanCancellation(saleLoanCancellationIds: $saleLoanCancellationIds)
}
    `;
export type ApproveSaleLoanCancellationMutationFn = Apollo.MutationFunction<ApproveSaleLoanCancellationMutation, ApproveSaleLoanCancellationMutationVariables>;

/**
 * __useApproveSaleLoanCancellationMutation__
 *
 * To run a mutation, you first call `useApproveSaleLoanCancellationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveSaleLoanCancellationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveSaleLoanCancellationMutation, { data, loading, error }] = useApproveSaleLoanCancellationMutation({
 *   variables: {
 *      saleLoanCancellationIds: // value for 'saleLoanCancellationIds'
 *   },
 * });
 */
export function useApproveSaleLoanCancellationMutation(baseOptions?: Apollo.MutationHookOptions<ApproveSaleLoanCancellationMutation, ApproveSaleLoanCancellationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveSaleLoanCancellationMutation, ApproveSaleLoanCancellationMutationVariables>(ApproveSaleLoanCancellationDocument, options);
      }
export type ApproveSaleLoanCancellationMutationHookResult = ReturnType<typeof useApproveSaleLoanCancellationMutation>;
export type ApproveSaleLoanCancellationMutationResult = Apollo.MutationResult<ApproveSaleLoanCancellationMutation>;
export type ApproveSaleLoanCancellationMutationOptions = Apollo.BaseMutationOptions<ApproveSaleLoanCancellationMutation, ApproveSaleLoanCancellationMutationVariables>;
export const RejectSaleLoanCancellationDocument = gql`
    mutation rejectSaleLoanCancellation($saleLoanCancellationIds: [String!]!) {
  rejectSaleLoanCancellation(saleLoanCancellationIds: $saleLoanCancellationIds)
}
    `;
export type RejectSaleLoanCancellationMutationFn = Apollo.MutationFunction<RejectSaleLoanCancellationMutation, RejectSaleLoanCancellationMutationVariables>;

/**
 * __useRejectSaleLoanCancellationMutation__
 *
 * To run a mutation, you first call `useRejectSaleLoanCancellationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectSaleLoanCancellationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectSaleLoanCancellationMutation, { data, loading, error }] = useRejectSaleLoanCancellationMutation({
 *   variables: {
 *      saleLoanCancellationIds: // value for 'saleLoanCancellationIds'
 *   },
 * });
 */
export function useRejectSaleLoanCancellationMutation(baseOptions?: Apollo.MutationHookOptions<RejectSaleLoanCancellationMutation, RejectSaleLoanCancellationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectSaleLoanCancellationMutation, RejectSaleLoanCancellationMutationVariables>(RejectSaleLoanCancellationDocument, options);
      }
export type RejectSaleLoanCancellationMutationHookResult = ReturnType<typeof useRejectSaleLoanCancellationMutation>;
export type RejectSaleLoanCancellationMutationResult = Apollo.MutationResult<RejectSaleLoanCancellationMutation>;
export type RejectSaleLoanCancellationMutationOptions = Apollo.BaseMutationOptions<RejectSaleLoanCancellationMutation, RejectSaleLoanCancellationMutationVariables>;
export const LoanCancellationSummaryDocument = gql`
    query loanCancellationSummary {
  loanCancellationSummary {
    totalDraft
    totalSubmitted
  }
}
    `;

/**
 * __useLoanCancellationSummaryQuery__
 *
 * To run a query within a React component, call `useLoanCancellationSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoanCancellationSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoanCancellationSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useLoanCancellationSummaryQuery(baseOptions?: Apollo.QueryHookOptions<LoanCancellationSummaryQuery, LoanCancellationSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoanCancellationSummaryQuery, LoanCancellationSummaryQueryVariables>(LoanCancellationSummaryDocument, options);
      }
export function useLoanCancellationSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoanCancellationSummaryQuery, LoanCancellationSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoanCancellationSummaryQuery, LoanCancellationSummaryQueryVariables>(LoanCancellationSummaryDocument, options);
        }
export type LoanCancellationSummaryQueryHookResult = ReturnType<typeof useLoanCancellationSummaryQuery>;
export type LoanCancellationSummaryLazyQueryHookResult = ReturnType<typeof useLoanCancellationSummaryLazyQuery>;
export type LoanCancellationSummaryQueryResult = Apollo.QueryResult<LoanCancellationSummaryQuery, LoanCancellationSummaryQueryVariables>;
export const GetLoanSettlementListingDocument = gql`
    query getLoanSettlementListing {
  getLoanSettlementListing {
    saleId
    rrDate
    purchaserName
    unitNo
    companyName
    isCompany
    financierList {
      id
      financierName
      financierCode
    }
  }
}
    `;

/**
 * __useGetLoanSettlementListingQuery__
 *
 * To run a query within a React component, call `useGetLoanSettlementListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoanSettlementListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoanSettlementListingQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLoanSettlementListingQuery(baseOptions?: Apollo.QueryHookOptions<GetLoanSettlementListingQuery, GetLoanSettlementListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoanSettlementListingQuery, GetLoanSettlementListingQueryVariables>(GetLoanSettlementListingDocument, options);
      }
export function useGetLoanSettlementListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLoanSettlementListingQuery, GetLoanSettlementListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoanSettlementListingQuery, GetLoanSettlementListingQueryVariables>(GetLoanSettlementListingDocument, options);
        }
export type GetLoanSettlementListingQueryHookResult = ReturnType<typeof useGetLoanSettlementListingQuery>;
export type GetLoanSettlementListingLazyQueryHookResult = ReturnType<typeof useGetLoanSettlementListingLazyQuery>;
export type GetLoanSettlementListingQueryResult = Apollo.QueryResult<GetLoanSettlementListingQuery, GetLoanSettlementListingQueryVariables>;
export const GetLoanSettlementByIdDocument = gql`
    query getLoanSettlementById($saleId: String) {
  getLoanSettlementById(saleId: $saleId) {
    saleId
    unitNo
    purchaserName
    companyName
    isCompany
    financierDetail {
      financierName
      financierCode
      solicitorCode
      solicitorName
      saleLoanId
      rrSolId
      rrSolName
      rrSolCode
      rrSolRefNo
      rrDate
    }
  }
}
    `;

/**
 * __useGetLoanSettlementByIdQuery__
 *
 * To run a query within a React component, call `useGetLoanSettlementByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoanSettlementByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoanSettlementByIdQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetLoanSettlementByIdQuery(baseOptions?: Apollo.QueryHookOptions<GetLoanSettlementByIdQuery, GetLoanSettlementByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoanSettlementByIdQuery, GetLoanSettlementByIdQueryVariables>(GetLoanSettlementByIdDocument, options);
      }
export function useGetLoanSettlementByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLoanSettlementByIdQuery, GetLoanSettlementByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoanSettlementByIdQuery, GetLoanSettlementByIdQueryVariables>(GetLoanSettlementByIdDocument, options);
        }
export type GetLoanSettlementByIdQueryHookResult = ReturnType<typeof useGetLoanSettlementByIdQuery>;
export type GetLoanSettlementByIdLazyQueryHookResult = ReturnType<typeof useGetLoanSettlementByIdLazyQuery>;
export type GetLoanSettlementByIdQueryResult = Apollo.QueryResult<GetLoanSettlementByIdQuery, GetLoanSettlementByIdQueryVariables>;
export const LoanSettlementsUnitDocument = gql`
    query loanSettlementsUnit($saleId: String) {
  loanSettlementUnitFormSource(saleId: $saleId) {
    saleId
    unitId
    unitNo
    purchaserName
  }
}
    `;

/**
 * __useLoanSettlementsUnitQuery__
 *
 * To run a query within a React component, call `useLoanSettlementsUnitQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoanSettlementsUnitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoanSettlementsUnitQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useLoanSettlementsUnitQuery(baseOptions?: Apollo.QueryHookOptions<LoanSettlementsUnitQuery, LoanSettlementsUnitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoanSettlementsUnitQuery, LoanSettlementsUnitQueryVariables>(LoanSettlementsUnitDocument, options);
      }
export function useLoanSettlementsUnitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoanSettlementsUnitQuery, LoanSettlementsUnitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoanSettlementsUnitQuery, LoanSettlementsUnitQueryVariables>(LoanSettlementsUnitDocument, options);
        }
export type LoanSettlementsUnitQueryHookResult = ReturnType<typeof useLoanSettlementsUnitQuery>;
export type LoanSettlementsUnitLazyQueryHookResult = ReturnType<typeof useLoanSettlementsUnitLazyQuery>;
export type LoanSettlementsUnitQueryResult = Apollo.QueryResult<LoanSettlementsUnitQuery, LoanSettlementsUnitQueryVariables>;
export const GetEndFinSolicitorFormSourceDocument = gql`
    query getEndFinSolicitorFormSource($saleId: String) {
  getEndFinSolicitorFormSource(saleId: $saleId) {
    saleId
    saleLoanId
    financierName
    financierCode
    solicitorCode
    solicitorName
    rrDate
    rrSolId
    rrSolRefNo
  }
}
    `;

/**
 * __useGetEndFinSolicitorFormSourceQuery__
 *
 * To run a query within a React component, call `useGetEndFinSolicitorFormSourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEndFinSolicitorFormSourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEndFinSolicitorFormSourceQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetEndFinSolicitorFormSourceQuery(baseOptions?: Apollo.QueryHookOptions<GetEndFinSolicitorFormSourceQuery, GetEndFinSolicitorFormSourceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEndFinSolicitorFormSourceQuery, GetEndFinSolicitorFormSourceQueryVariables>(GetEndFinSolicitorFormSourceDocument, options);
      }
export function useGetEndFinSolicitorFormSourceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEndFinSolicitorFormSourceQuery, GetEndFinSolicitorFormSourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEndFinSolicitorFormSourceQuery, GetEndFinSolicitorFormSourceQueryVariables>(GetEndFinSolicitorFormSourceDocument, options);
        }
export type GetEndFinSolicitorFormSourceQueryHookResult = ReturnType<typeof useGetEndFinSolicitorFormSourceQuery>;
export type GetEndFinSolicitorFormSourceLazyQueryHookResult = ReturnType<typeof useGetEndFinSolicitorFormSourceLazyQuery>;
export type GetEndFinSolicitorFormSourceQueryResult = Apollo.QueryResult<GetEndFinSolicitorFormSourceQuery, GetEndFinSolicitorFormSourceQueryVariables>;
export const AddLoanSettlementDocument = gql`
    mutation addLoanSettlement($input: addLoanSettlementInput!) {
  addLoanSettlement(input: $input)
}
    `;
export type AddLoanSettlementMutationFn = Apollo.MutationFunction<AddLoanSettlementMutation, AddLoanSettlementMutationVariables>;

/**
 * __useAddLoanSettlementMutation__
 *
 * To run a mutation, you first call `useAddLoanSettlementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLoanSettlementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLoanSettlementMutation, { data, loading, error }] = useAddLoanSettlementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddLoanSettlementMutation(baseOptions?: Apollo.MutationHookOptions<AddLoanSettlementMutation, AddLoanSettlementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddLoanSettlementMutation, AddLoanSettlementMutationVariables>(AddLoanSettlementDocument, options);
      }
export type AddLoanSettlementMutationHookResult = ReturnType<typeof useAddLoanSettlementMutation>;
export type AddLoanSettlementMutationResult = Apollo.MutationResult<AddLoanSettlementMutation>;
export type AddLoanSettlementMutationOptions = Apollo.BaseMutationOptions<AddLoanSettlementMutation, AddLoanSettlementMutationVariables>;
export const DeleteLoanSettlementDocument = gql`
    mutation deleteLoanSettlement($saleId: String!) {
  deleteLoanSettlement(saleId: $saleId)
}
    `;
export type DeleteLoanSettlementMutationFn = Apollo.MutationFunction<DeleteLoanSettlementMutation, DeleteLoanSettlementMutationVariables>;

/**
 * __useDeleteLoanSettlementMutation__
 *
 * To run a mutation, you first call `useDeleteLoanSettlementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLoanSettlementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLoanSettlementMutation, { data, loading, error }] = useDeleteLoanSettlementMutation({
 *   variables: {
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useDeleteLoanSettlementMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLoanSettlementMutation, DeleteLoanSettlementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLoanSettlementMutation, DeleteLoanSettlementMutationVariables>(DeleteLoanSettlementDocument, options);
      }
export type DeleteLoanSettlementMutationHookResult = ReturnType<typeof useDeleteLoanSettlementMutation>;
export type DeleteLoanSettlementMutationResult = Apollo.MutationResult<DeleteLoanSettlementMutation>;
export type DeleteLoanSettlementMutationOptions = Apollo.BaseMutationOptions<DeleteLoanSettlementMutation, DeleteLoanSettlementMutationVariables>;
export const GetAllRefinancingDocument = gql`
    query getAllRefinancing {
  getAllRefinancing {
    unitNo
    buyerName
    generationBatch
    loanAgreementDate
    financierList
    loanAmount
    completedDate
    status
    isCompany
    companyName
  }
}
    `;

/**
 * __useGetAllRefinancingQuery__
 *
 * To run a query within a React component, call `useGetAllRefinancingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRefinancingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRefinancingQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllRefinancingQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRefinancingQuery, GetAllRefinancingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRefinancingQuery, GetAllRefinancingQueryVariables>(GetAllRefinancingDocument, options);
      }
export function useGetAllRefinancingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRefinancingQuery, GetAllRefinancingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRefinancingQuery, GetAllRefinancingQueryVariables>(GetAllRefinancingDocument, options);
        }
export type GetAllRefinancingQueryHookResult = ReturnType<typeof useGetAllRefinancingQuery>;
export type GetAllRefinancingLazyQueryHookResult = ReturnType<typeof useGetAllRefinancingLazyQuery>;
export type GetAllRefinancingQueryResult = Apollo.QueryResult<GetAllRefinancingQuery, GetAllRefinancingQueryVariables>;
export const GetRefinancingByIdDocument = gql`
    query getRefinancingById($generationBatch: String!) {
  getRefinancingById(generationBatch: $generationBatch) {
    saleId
    financierList {
      refinancingId
      financierId
      financierName
      financierReference
      rrDate
      rrSolicitorId
      rrSolicitorName
      rrSolicitorReference
      doaDate
      doaSolicitorId
      doaSolicitorName
      doaSolicitorReference
      loanAgreementDate
      loanAmount
      loanSolicitorId
      loanSolicitorName
      loanSolicitorReference
      loanSeqNo
    }
    refTable
    refinancingLoan {
      unitNo
      buyerName
      isCompany
      companyName
      financierDetail {
        financier
        solicitor
        financierReference
        solicitorReference
        loanSeqNo
      }
    }
  }
}
    `;

/**
 * __useGetRefinancingByIdQuery__
 *
 * To run a query within a React component, call `useGetRefinancingByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRefinancingByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRefinancingByIdQuery({
 *   variables: {
 *      generationBatch: // value for 'generationBatch'
 *   },
 * });
 */
export function useGetRefinancingByIdQuery(baseOptions: Apollo.QueryHookOptions<GetRefinancingByIdQuery, GetRefinancingByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRefinancingByIdQuery, GetRefinancingByIdQueryVariables>(GetRefinancingByIdDocument, options);
      }
export function useGetRefinancingByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRefinancingByIdQuery, GetRefinancingByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRefinancingByIdQuery, GetRefinancingByIdQueryVariables>(GetRefinancingByIdDocument, options);
        }
export type GetRefinancingByIdQueryHookResult = ReturnType<typeof useGetRefinancingByIdQuery>;
export type GetRefinancingByIdLazyQueryHookResult = ReturnType<typeof useGetRefinancingByIdLazyQuery>;
export type GetRefinancingByIdQueryResult = Apollo.QueryResult<GetRefinancingByIdQuery, GetRefinancingByIdQueryVariables>;
export const GetRefinancingUnitDocument = gql`
    query getRefinancingUnit {
  getRefinancingUnit {
    unitNo
    id
    table
    buyerName
    isCompany
    companyName
    financierDetail {
      financier
      solicitor
      financierReference
      solicitorReference
      loanSeqNo
    }
  }
}
    `;

/**
 * __useGetRefinancingUnitQuery__
 *
 * To run a query within a React component, call `useGetRefinancingUnitQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRefinancingUnitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRefinancingUnitQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRefinancingUnitQuery(baseOptions?: Apollo.QueryHookOptions<GetRefinancingUnitQuery, GetRefinancingUnitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRefinancingUnitQuery, GetRefinancingUnitQueryVariables>(GetRefinancingUnitDocument, options);
      }
export function useGetRefinancingUnitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRefinancingUnitQuery, GetRefinancingUnitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRefinancingUnitQuery, GetRefinancingUnitQueryVariables>(GetRefinancingUnitDocument, options);
        }
export type GetRefinancingUnitQueryHookResult = ReturnType<typeof useGetRefinancingUnitQuery>;
export type GetRefinancingUnitLazyQueryHookResult = ReturnType<typeof useGetRefinancingUnitLazyQuery>;
export type GetRefinancingUnitQueryResult = Apollo.QueryResult<GetRefinancingUnitQuery, GetRefinancingUnitQueryVariables>;
export const AddRefinancingDocument = gql`
    mutation addRefinancing($input: AddRefinancingInput!) {
  addRefinancing(input: $input)
}
    `;
export type AddRefinancingMutationFn = Apollo.MutationFunction<AddRefinancingMutation, AddRefinancingMutationVariables>;

/**
 * __useAddRefinancingMutation__
 *
 * To run a mutation, you first call `useAddRefinancingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRefinancingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRefinancingMutation, { data, loading, error }] = useAddRefinancingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddRefinancingMutation(baseOptions?: Apollo.MutationHookOptions<AddRefinancingMutation, AddRefinancingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddRefinancingMutation, AddRefinancingMutationVariables>(AddRefinancingDocument, options);
      }
export type AddRefinancingMutationHookResult = ReturnType<typeof useAddRefinancingMutation>;
export type AddRefinancingMutationResult = Apollo.MutationResult<AddRefinancingMutation>;
export type AddRefinancingMutationOptions = Apollo.BaseMutationOptions<AddRefinancingMutation, AddRefinancingMutationVariables>;
export const EditRefinancingDocument = gql`
    mutation editRefinancing($input: EditRefinancingInput!) {
  editRefinancing(input: $input)
}
    `;
export type EditRefinancingMutationFn = Apollo.MutationFunction<EditRefinancingMutation, EditRefinancingMutationVariables>;

/**
 * __useEditRefinancingMutation__
 *
 * To run a mutation, you first call `useEditRefinancingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditRefinancingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editRefinancingMutation, { data, loading, error }] = useEditRefinancingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditRefinancingMutation(baseOptions?: Apollo.MutationHookOptions<EditRefinancingMutation, EditRefinancingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditRefinancingMutation, EditRefinancingMutationVariables>(EditRefinancingDocument, options);
      }
export type EditRefinancingMutationHookResult = ReturnType<typeof useEditRefinancingMutation>;
export type EditRefinancingMutationResult = Apollo.MutationResult<EditRefinancingMutation>;
export type EditRefinancingMutationOptions = Apollo.BaseMutationOptions<EditRefinancingMutation, EditRefinancingMutationVariables>;
export const DeleteRefinancingDocument = gql`
    mutation deleteRefinancing($generationBatch: String!) {
  deleteRefinancing(generationBatch: $generationBatch)
}
    `;
export type DeleteRefinancingMutationFn = Apollo.MutationFunction<DeleteRefinancingMutation, DeleteRefinancingMutationVariables>;

/**
 * __useDeleteRefinancingMutation__
 *
 * To run a mutation, you first call `useDeleteRefinancingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRefinancingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRefinancingMutation, { data, loading, error }] = useDeleteRefinancingMutation({
 *   variables: {
 *      generationBatch: // value for 'generationBatch'
 *   },
 * });
 */
export function useDeleteRefinancingMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRefinancingMutation, DeleteRefinancingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRefinancingMutation, DeleteRefinancingMutationVariables>(DeleteRefinancingDocument, options);
      }
export type DeleteRefinancingMutationHookResult = ReturnType<typeof useDeleteRefinancingMutation>;
export type DeleteRefinancingMutationResult = Apollo.MutationResult<DeleteRefinancingMutation>;
export type DeleteRefinancingMutationOptions = Apollo.BaseMutationOptions<DeleteRefinancingMutation, DeleteRefinancingMutationVariables>;
export const CompletedRefinancingDocument = gql`
    mutation completedRefinancing($generationBatch: String!) {
  completedRefinancing(generationBatch: $generationBatch)
}
    `;
export type CompletedRefinancingMutationFn = Apollo.MutationFunction<CompletedRefinancingMutation, CompletedRefinancingMutationVariables>;

/**
 * __useCompletedRefinancingMutation__
 *
 * To run a mutation, you first call `useCompletedRefinancingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompletedRefinancingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completedRefinancingMutation, { data, loading, error }] = useCompletedRefinancingMutation({
 *   variables: {
 *      generationBatch: // value for 'generationBatch'
 *   },
 * });
 */
export function useCompletedRefinancingMutation(baseOptions?: Apollo.MutationHookOptions<CompletedRefinancingMutation, CompletedRefinancingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompletedRefinancingMutation, CompletedRefinancingMutationVariables>(CompletedRefinancingDocument, options);
      }
export type CompletedRefinancingMutationHookResult = ReturnType<typeof useCompletedRefinancingMutation>;
export type CompletedRefinancingMutationResult = Apollo.MutationResult<CompletedRefinancingMutation>;
export type CompletedRefinancingMutationOptions = Apollo.BaseMutationOptions<CompletedRefinancingMutation, CompletedRefinancingMutationVariables>;
export const GetRefinancingSingleDetailByIdDocument = gql`
    query getRefinancingSingleDetailById($generationBatch: String!, $refinancingId: String!) {
  getRefinancingSingleDetailById(generationBatch: $generationBatch, refinancingId: $refinancingId) {
    refinancingId
    financierId
    financierName
    financierReference
    rrDate
    rrSolicitorId
    rrSolicitorName
    rrSolicitorReference
    doaDate
    doaSolicitorId
    doaSolicitorName
    doaSolicitorReference
    loanAgreementDate
    loanAmount
    loanSolicitorId
    loanSolicitorName
    loanSolicitorReference
    loanSeqNo
  }
}
    `;

/**
 * __useGetRefinancingSingleDetailByIdQuery__
 *
 * To run a query within a React component, call `useGetRefinancingSingleDetailByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRefinancingSingleDetailByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRefinancingSingleDetailByIdQuery({
 *   variables: {
 *      generationBatch: // value for 'generationBatch'
 *      refinancingId: // value for 'refinancingId'
 *   },
 * });
 */
export function useGetRefinancingSingleDetailByIdQuery(baseOptions: Apollo.QueryHookOptions<GetRefinancingSingleDetailByIdQuery, GetRefinancingSingleDetailByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRefinancingSingleDetailByIdQuery, GetRefinancingSingleDetailByIdQueryVariables>(GetRefinancingSingleDetailByIdDocument, options);
      }
export function useGetRefinancingSingleDetailByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRefinancingSingleDetailByIdQuery, GetRefinancingSingleDetailByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRefinancingSingleDetailByIdQuery, GetRefinancingSingleDetailByIdQueryVariables>(GetRefinancingSingleDetailByIdDocument, options);
        }
export type GetRefinancingSingleDetailByIdQueryHookResult = ReturnType<typeof useGetRefinancingSingleDetailByIdQuery>;
export type GetRefinancingSingleDetailByIdLazyQueryHookResult = ReturnType<typeof useGetRefinancingSingleDetailByIdLazyQuery>;
export type GetRefinancingSingleDetailByIdQueryResult = Apollo.QueryResult<GetRefinancingSingleDetailByIdQuery, GetRefinancingSingleDetailByIdQueryVariables>;
export const GetRefinancingInfolineDocument = gql`
    query getRefinancingInfoline {
  refinancingInfoline {
    refinancingCount
    loanAmount
  }
}
    `;

/**
 * __useGetRefinancingInfolineQuery__
 *
 * To run a query within a React component, call `useGetRefinancingInfolineQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRefinancingInfolineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRefinancingInfolineQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRefinancingInfolineQuery(baseOptions?: Apollo.QueryHookOptions<GetRefinancingInfolineQuery, GetRefinancingInfolineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRefinancingInfolineQuery, GetRefinancingInfolineQueryVariables>(GetRefinancingInfolineDocument, options);
      }
export function useGetRefinancingInfolineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRefinancingInfolineQuery, GetRefinancingInfolineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRefinancingInfolineQuery, GetRefinancingInfolineQueryVariables>(GetRefinancingInfolineDocument, options);
        }
export type GetRefinancingInfolineQueryHookResult = ReturnType<typeof useGetRefinancingInfolineQuery>;
export type GetRefinancingInfolineLazyQueryHookResult = ReturnType<typeof useGetRefinancingInfolineLazyQuery>;
export type GetRefinancingInfolineQueryResult = Apollo.QueryResult<GetRefinancingInfolineQuery, GetRefinancingInfolineQueryVariables>;
export const GetBridgingFinancierListDocument = gql`
    query getBridgingFinancierList {
  getBridgingFinancierList {
    id
    bridgingFinancier
    bridgingFinancierCode
    bridgingFinancierRefNo
    bridgingSolicitorRefNo
    totalBfUnits
    totalBfAmount
    redemptionPaid
    redemptionBalance
    unitNo
  }
}
    `;

/**
 * __useGetBridgingFinancierListQuery__
 *
 * To run a query within a React component, call `useGetBridgingFinancierListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBridgingFinancierListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBridgingFinancierListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBridgingFinancierListQuery(baseOptions?: Apollo.QueryHookOptions<GetBridgingFinancierListQuery, GetBridgingFinancierListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBridgingFinancierListQuery, GetBridgingFinancierListQueryVariables>(GetBridgingFinancierListDocument, options);
      }
export function useGetBridgingFinancierListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBridgingFinancierListQuery, GetBridgingFinancierListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBridgingFinancierListQuery, GetBridgingFinancierListQueryVariables>(GetBridgingFinancierListDocument, options);
        }
export type GetBridgingFinancierListQueryHookResult = ReturnType<typeof useGetBridgingFinancierListQuery>;
export type GetBridgingFinancierListLazyQueryHookResult = ReturnType<typeof useGetBridgingFinancierListLazyQuery>;
export type GetBridgingFinancierListQueryResult = Apollo.QueryResult<GetBridgingFinancierListQuery, GetBridgingFinancierListQueryVariables>;
export const GetProjectBridgingFinancierByIdDocument = gql`
    query getProjectBridgingFinancierById($id: String!) {
  getProjectBridgingFinancierById(id: $id) {
    id
    bridgingFinancier
    bridgingFinancierRefNo
    bridgingFinancierCode
    bridgingSolicitor
    bridgingSolicitorRefNo
    chargeExeType
    chargeExeValue
    totalBfUnits
    totalBfAmount
    redemptionPaid
    redemptionBalance
    financierDetail {
      unitNo
      unitAmount
      bfuId
    }
  }
}
    `;

/**
 * __useGetProjectBridgingFinancierByIdQuery__
 *
 * To run a query within a React component, call `useGetProjectBridgingFinancierByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectBridgingFinancierByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectBridgingFinancierByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectBridgingFinancierByIdQuery(baseOptions: Apollo.QueryHookOptions<GetProjectBridgingFinancierByIdQuery, GetProjectBridgingFinancierByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectBridgingFinancierByIdQuery, GetProjectBridgingFinancierByIdQueryVariables>(GetProjectBridgingFinancierByIdDocument, options);
      }
export function useGetProjectBridgingFinancierByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectBridgingFinancierByIdQuery, GetProjectBridgingFinancierByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectBridgingFinancierByIdQuery, GetProjectBridgingFinancierByIdQueryVariables>(GetProjectBridgingFinancierByIdDocument, options);
        }
export type GetProjectBridgingFinancierByIdQueryHookResult = ReturnType<typeof useGetProjectBridgingFinancierByIdQuery>;
export type GetProjectBridgingFinancierByIdLazyQueryHookResult = ReturnType<typeof useGetProjectBridgingFinancierByIdLazyQuery>;
export type GetProjectBridgingFinancierByIdQueryResult = Apollo.QueryResult<GetProjectBridgingFinancierByIdQuery, GetProjectBridgingFinancierByIdQueryVariables>;
export const AddProjectBridgingFinancierDocument = gql`
    mutation addProjectBridgingFinancier($input: projectBridgingFinancierInput!) {
  addProjectBridgingFinancier(input: $input)
}
    `;
export type AddProjectBridgingFinancierMutationFn = Apollo.MutationFunction<AddProjectBridgingFinancierMutation, AddProjectBridgingFinancierMutationVariables>;

/**
 * __useAddProjectBridgingFinancierMutation__
 *
 * To run a mutation, you first call `useAddProjectBridgingFinancierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProjectBridgingFinancierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProjectBridgingFinancierMutation, { data, loading, error }] = useAddProjectBridgingFinancierMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddProjectBridgingFinancierMutation(baseOptions?: Apollo.MutationHookOptions<AddProjectBridgingFinancierMutation, AddProjectBridgingFinancierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProjectBridgingFinancierMutation, AddProjectBridgingFinancierMutationVariables>(AddProjectBridgingFinancierDocument, options);
      }
export type AddProjectBridgingFinancierMutationHookResult = ReturnType<typeof useAddProjectBridgingFinancierMutation>;
export type AddProjectBridgingFinancierMutationResult = Apollo.MutationResult<AddProjectBridgingFinancierMutation>;
export type AddProjectBridgingFinancierMutationOptions = Apollo.BaseMutationOptions<AddProjectBridgingFinancierMutation, AddProjectBridgingFinancierMutationVariables>;
export const GetBridgingFinancingUnitsDocument = gql`
    query getBridgingFinancingUnits {
  getBridgingFinancingUnits {
    block
    totalFloor
    floorList {
      floorLabel
      totalUnit
      unitList {
        unitId
        unitNo
      }
    }
  }
}
    `;

/**
 * __useGetBridgingFinancingUnitsQuery__
 *
 * To run a query within a React component, call `useGetBridgingFinancingUnitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBridgingFinancingUnitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBridgingFinancingUnitsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBridgingFinancingUnitsQuery(baseOptions?: Apollo.QueryHookOptions<GetBridgingFinancingUnitsQuery, GetBridgingFinancingUnitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBridgingFinancingUnitsQuery, GetBridgingFinancingUnitsQueryVariables>(GetBridgingFinancingUnitsDocument, options);
      }
export function useGetBridgingFinancingUnitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBridgingFinancingUnitsQuery, GetBridgingFinancingUnitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBridgingFinancingUnitsQuery, GetBridgingFinancingUnitsQueryVariables>(GetBridgingFinancingUnitsDocument, options);
        }
export type GetBridgingFinancingUnitsQueryHookResult = ReturnType<typeof useGetBridgingFinancingUnitsQuery>;
export type GetBridgingFinancingUnitsLazyQueryHookResult = ReturnType<typeof useGetBridgingFinancingUnitsLazyQuery>;
export type GetBridgingFinancingUnitsQueryResult = Apollo.QueryResult<GetBridgingFinancingUnitsQuery, GetBridgingFinancingUnitsQueryVariables>;
export const DeleteBridgingFinancierUnitDocument = gql`
    mutation deleteBridgingFinancierUnit($bfId: String!, $bfuId: String!) {
  deleteBridgingFinancierUnit(bfId: $bfId, bfuId: $bfuId) {
    count
    isEmpty
  }
}
    `;
export type DeleteBridgingFinancierUnitMutationFn = Apollo.MutationFunction<DeleteBridgingFinancierUnitMutation, DeleteBridgingFinancierUnitMutationVariables>;

/**
 * __useDeleteBridgingFinancierUnitMutation__
 *
 * To run a mutation, you first call `useDeleteBridgingFinancierUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBridgingFinancierUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBridgingFinancierUnitMutation, { data, loading, error }] = useDeleteBridgingFinancierUnitMutation({
 *   variables: {
 *      bfId: // value for 'bfId'
 *      bfuId: // value for 'bfuId'
 *   },
 * });
 */
export function useDeleteBridgingFinancierUnitMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBridgingFinancierUnitMutation, DeleteBridgingFinancierUnitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBridgingFinancierUnitMutation, DeleteBridgingFinancierUnitMutationVariables>(DeleteBridgingFinancierUnitDocument, options);
      }
export type DeleteBridgingFinancierUnitMutationHookResult = ReturnType<typeof useDeleteBridgingFinancierUnitMutation>;
export type DeleteBridgingFinancierUnitMutationResult = Apollo.MutationResult<DeleteBridgingFinancierUnitMutation>;
export type DeleteBridgingFinancierUnitMutationOptions = Apollo.BaseMutationOptions<DeleteBridgingFinancierUnitMutation, DeleteBridgingFinancierUnitMutationVariables>;
export const DeleteProjectBridgingFinancierDocument = gql`
    mutation deleteProjectBridgingFinancier($id: String!) {
  deleteProjectBridgingFinancier(id: $id)
}
    `;
export type DeleteProjectBridgingFinancierMutationFn = Apollo.MutationFunction<DeleteProjectBridgingFinancierMutation, DeleteProjectBridgingFinancierMutationVariables>;

/**
 * __useDeleteProjectBridgingFinancierMutation__
 *
 * To run a mutation, you first call `useDeleteProjectBridgingFinancierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectBridgingFinancierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectBridgingFinancierMutation, { data, loading, error }] = useDeleteProjectBridgingFinancierMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProjectBridgingFinancierMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectBridgingFinancierMutation, DeleteProjectBridgingFinancierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectBridgingFinancierMutation, DeleteProjectBridgingFinancierMutationVariables>(DeleteProjectBridgingFinancierDocument, options);
      }
export type DeleteProjectBridgingFinancierMutationHookResult = ReturnType<typeof useDeleteProjectBridgingFinancierMutation>;
export type DeleteProjectBridgingFinancierMutationResult = Apollo.MutationResult<DeleteProjectBridgingFinancierMutation>;
export type DeleteProjectBridgingFinancierMutationOptions = Apollo.BaseMutationOptions<DeleteProjectBridgingFinancierMutation, DeleteProjectBridgingFinancierMutationVariables>;
export const GetBridgingFinancierTypeDocument = gql`
    query getBridgingFinancierType {
  getBridgingFinancierType
}
    `;

/**
 * __useGetBridgingFinancierTypeQuery__
 *
 * To run a query within a React component, call `useGetBridgingFinancierTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBridgingFinancierTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBridgingFinancierTypeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBridgingFinancierTypeQuery(baseOptions?: Apollo.QueryHookOptions<GetBridgingFinancierTypeQuery, GetBridgingFinancierTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBridgingFinancierTypeQuery, GetBridgingFinancierTypeQueryVariables>(GetBridgingFinancierTypeDocument, options);
      }
export function useGetBridgingFinancierTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBridgingFinancierTypeQuery, GetBridgingFinancierTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBridgingFinancierTypeQuery, GetBridgingFinancierTypeQueryVariables>(GetBridgingFinancierTypeDocument, options);
        }
export type GetBridgingFinancierTypeQueryHookResult = ReturnType<typeof useGetBridgingFinancierTypeQuery>;
export type GetBridgingFinancierTypeLazyQueryHookResult = ReturnType<typeof useGetBridgingFinancierTypeLazyQuery>;
export type GetBridgingFinancierTypeQueryResult = Apollo.QueryResult<GetBridgingFinancierTypeQuery, GetBridgingFinancierTypeQueryVariables>;
export const GetBridgingLoanSettingSummaryDocument = gql`
    query getBridgingLoanSettingSummary {
  bridgingFinanceLastUpdate
  redemptionRepaymentLastUpdate
}
    `;

/**
 * __useGetBridgingLoanSettingSummaryQuery__
 *
 * To run a query within a React component, call `useGetBridgingLoanSettingSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBridgingLoanSettingSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBridgingLoanSettingSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBridgingLoanSettingSummaryQuery(baseOptions?: Apollo.QueryHookOptions<GetBridgingLoanSettingSummaryQuery, GetBridgingLoanSettingSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBridgingLoanSettingSummaryQuery, GetBridgingLoanSettingSummaryQueryVariables>(GetBridgingLoanSettingSummaryDocument, options);
      }
export function useGetBridgingLoanSettingSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBridgingLoanSettingSummaryQuery, GetBridgingLoanSettingSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBridgingLoanSettingSummaryQuery, GetBridgingLoanSettingSummaryQueryVariables>(GetBridgingLoanSettingSummaryDocument, options);
        }
export type GetBridgingLoanSettingSummaryQueryHookResult = ReturnType<typeof useGetBridgingLoanSettingSummaryQuery>;
export type GetBridgingLoanSettingSummaryLazyQueryHookResult = ReturnType<typeof useGetBridgingLoanSettingSummaryLazyQuery>;
export type GetBridgingLoanSettingSummaryQueryResult = Apollo.QueryResult<GetBridgingLoanSettingSummaryQuery, GetBridgingLoanSettingSummaryQueryVariables>;
export const CalculateBridgingValueDocument = gql`
    query calculateBridgingValue($input: calculateBridgingExeValueInput!) {
  calculateBridgingValue(input: $input) {
    unitExeDetail {
      unitId
      unitNo
      calculatedUnitValue
    }
    totalCalculatedValue
  }
}
    `;

/**
 * __useCalculateBridgingValueQuery__
 *
 * To run a query within a React component, call `useCalculateBridgingValueQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalculateBridgingValueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalculateBridgingValueQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCalculateBridgingValueQuery(baseOptions: Apollo.QueryHookOptions<CalculateBridgingValueQuery, CalculateBridgingValueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalculateBridgingValueQuery, CalculateBridgingValueQueryVariables>(CalculateBridgingValueDocument, options);
      }
export function useCalculateBridgingValueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalculateBridgingValueQuery, CalculateBridgingValueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalculateBridgingValueQuery, CalculateBridgingValueQueryVariables>(CalculateBridgingValueDocument, options);
        }
export type CalculateBridgingValueQueryHookResult = ReturnType<typeof useCalculateBridgingValueQuery>;
export type CalculateBridgingValueLazyQueryHookResult = ReturnType<typeof useCalculateBridgingValueLazyQuery>;
export type CalculateBridgingValueQueryResult = Apollo.QueryResult<CalculateBridgingValueQuery, CalculateBridgingValueQueryVariables>;
export const GetAllRedemptionRepaymentDocument = gql`
    query getAllRedemptionRepayment {
  getAllRedemptionRepayment {
    id
    documentDate
    referenceNo
    icNo
    redemptionSum
    paymentParty
    paidById
    financierName
    financierCode
    documentNo
    unitNo
    status
    isPosted
    redemptionUnitsCount
    voidDate
    companyName
    fullName
  }
}
    `;

/**
 * __useGetAllRedemptionRepaymentQuery__
 *
 * To run a query within a React component, call `useGetAllRedemptionRepaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRedemptionRepaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRedemptionRepaymentQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllRedemptionRepaymentQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRedemptionRepaymentQuery, GetAllRedemptionRepaymentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRedemptionRepaymentQuery, GetAllRedemptionRepaymentQueryVariables>(GetAllRedemptionRepaymentDocument, options);
      }
export function useGetAllRedemptionRepaymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRedemptionRepaymentQuery, GetAllRedemptionRepaymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRedemptionRepaymentQuery, GetAllRedemptionRepaymentQueryVariables>(GetAllRedemptionRepaymentDocument, options);
        }
export type GetAllRedemptionRepaymentQueryHookResult = ReturnType<typeof useGetAllRedemptionRepaymentQuery>;
export type GetAllRedemptionRepaymentLazyQueryHookResult = ReturnType<typeof useGetAllRedemptionRepaymentLazyQuery>;
export type GetAllRedemptionRepaymentQueryResult = Apollo.QueryResult<GetAllRedemptionRepaymentQuery, GetAllRedemptionRepaymentQueryVariables>;
export const GetRedemptionRepaymentByIdDocument = gql`
    query getRedemptionRepaymentById($id: String!) {
  getRedemptionRepaymentById(id: $id) {
    redemption {
      id
      paymentParty
      paidById
      documentDate
      referenceNo
      redemptionSum
      redemptionUnitsCount
      paidByParty
    }
    redemptionUnits {
      unitId
      unitNo
      documentNo
      redemptionAmount
    }
  }
}
    `;

/**
 * __useGetRedemptionRepaymentByIdQuery__
 *
 * To run a query within a React component, call `useGetRedemptionRepaymentByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRedemptionRepaymentByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRedemptionRepaymentByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRedemptionRepaymentByIdQuery(baseOptions: Apollo.QueryHookOptions<GetRedemptionRepaymentByIdQuery, GetRedemptionRepaymentByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRedemptionRepaymentByIdQuery, GetRedemptionRepaymentByIdQueryVariables>(GetRedemptionRepaymentByIdDocument, options);
      }
export function useGetRedemptionRepaymentByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRedemptionRepaymentByIdQuery, GetRedemptionRepaymentByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRedemptionRepaymentByIdQuery, GetRedemptionRepaymentByIdQueryVariables>(GetRedemptionRepaymentByIdDocument, options);
        }
export type GetRedemptionRepaymentByIdQueryHookResult = ReturnType<typeof useGetRedemptionRepaymentByIdQuery>;
export type GetRedemptionRepaymentByIdLazyQueryHookResult = ReturnType<typeof useGetRedemptionRepaymentByIdLazyQuery>;
export type GetRedemptionRepaymentByIdQueryResult = Apollo.QueryResult<GetRedemptionRepaymentByIdQuery, GetRedemptionRepaymentByIdQueryVariables>;
export const AddRedemptionRepaymentDocument = gql`
    mutation addRedemptionRepayment($input: redemptionRepaymentInput!) {
  addRedemptionRepayment(input: $input)
}
    `;
export type AddRedemptionRepaymentMutationFn = Apollo.MutationFunction<AddRedemptionRepaymentMutation, AddRedemptionRepaymentMutationVariables>;

/**
 * __useAddRedemptionRepaymentMutation__
 *
 * To run a mutation, you first call `useAddRedemptionRepaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRedemptionRepaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRedemptionRepaymentMutation, { data, loading, error }] = useAddRedemptionRepaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddRedemptionRepaymentMutation(baseOptions?: Apollo.MutationHookOptions<AddRedemptionRepaymentMutation, AddRedemptionRepaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddRedemptionRepaymentMutation, AddRedemptionRepaymentMutationVariables>(AddRedemptionRepaymentDocument, options);
      }
export type AddRedemptionRepaymentMutationHookResult = ReturnType<typeof useAddRedemptionRepaymentMutation>;
export type AddRedemptionRepaymentMutationResult = Apollo.MutationResult<AddRedemptionRepaymentMutation>;
export type AddRedemptionRepaymentMutationOptions = Apollo.BaseMutationOptions<AddRedemptionRepaymentMutation, AddRedemptionRepaymentMutationVariables>;
export const EditRedemptionRepaymentDocument = gql`
    mutation editRedemptionRepayment($input: editRedemptionRepaymentInput!) {
  editRedemptionRepayment(input: $input)
}
    `;
export type EditRedemptionRepaymentMutationFn = Apollo.MutationFunction<EditRedemptionRepaymentMutation, EditRedemptionRepaymentMutationVariables>;

/**
 * __useEditRedemptionRepaymentMutation__
 *
 * To run a mutation, you first call `useEditRedemptionRepaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditRedemptionRepaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editRedemptionRepaymentMutation, { data, loading, error }] = useEditRedemptionRepaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditRedemptionRepaymentMutation(baseOptions?: Apollo.MutationHookOptions<EditRedemptionRepaymentMutation, EditRedemptionRepaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditRedemptionRepaymentMutation, EditRedemptionRepaymentMutationVariables>(EditRedemptionRepaymentDocument, options);
      }
export type EditRedemptionRepaymentMutationHookResult = ReturnType<typeof useEditRedemptionRepaymentMutation>;
export type EditRedemptionRepaymentMutationResult = Apollo.MutationResult<EditRedemptionRepaymentMutation>;
export type EditRedemptionRepaymentMutationOptions = Apollo.BaseMutationOptions<EditRedemptionRepaymentMutation, EditRedemptionRepaymentMutationVariables>;
export const DeleteRedemptionRepaymentDocument = gql`
    mutation deleteRedemptionRepayment($redemptionRepaymentId: String!) {
  deleteRedemptionRepayment(redemptionRepaymentId: $redemptionRepaymentId)
}
    `;
export type DeleteRedemptionRepaymentMutationFn = Apollo.MutationFunction<DeleteRedemptionRepaymentMutation, DeleteRedemptionRepaymentMutationVariables>;

/**
 * __useDeleteRedemptionRepaymentMutation__
 *
 * To run a mutation, you first call `useDeleteRedemptionRepaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRedemptionRepaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRedemptionRepaymentMutation, { data, loading, error }] = useDeleteRedemptionRepaymentMutation({
 *   variables: {
 *      redemptionRepaymentId: // value for 'redemptionRepaymentId'
 *   },
 * });
 */
export function useDeleteRedemptionRepaymentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRedemptionRepaymentMutation, DeleteRedemptionRepaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRedemptionRepaymentMutation, DeleteRedemptionRepaymentMutationVariables>(DeleteRedemptionRepaymentDocument, options);
      }
export type DeleteRedemptionRepaymentMutationHookResult = ReturnType<typeof useDeleteRedemptionRepaymentMutation>;
export type DeleteRedemptionRepaymentMutationResult = Apollo.MutationResult<DeleteRedemptionRepaymentMutation>;
export type DeleteRedemptionRepaymentMutationOptions = Apollo.BaseMutationOptions<DeleteRedemptionRepaymentMutation, DeleteRedemptionRepaymentMutationVariables>;
export const GetRedemptionPaymentPartyDocument = gql`
    query getRedemptionPaymentParty {
  getRedemptionPaymentParty {
    id
    name
  }
}
    `;

/**
 * __useGetRedemptionPaymentPartyQuery__
 *
 * To run a query within a React component, call `useGetRedemptionPaymentPartyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRedemptionPaymentPartyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRedemptionPaymentPartyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRedemptionPaymentPartyQuery(baseOptions?: Apollo.QueryHookOptions<GetRedemptionPaymentPartyQuery, GetRedemptionPaymentPartyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRedemptionPaymentPartyQuery, GetRedemptionPaymentPartyQueryVariables>(GetRedemptionPaymentPartyDocument, options);
      }
export function useGetRedemptionPaymentPartyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRedemptionPaymentPartyQuery, GetRedemptionPaymentPartyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRedemptionPaymentPartyQuery, GetRedemptionPaymentPartyQueryVariables>(GetRedemptionPaymentPartyDocument, options);
        }
export type GetRedemptionPaymentPartyQueryHookResult = ReturnType<typeof useGetRedemptionPaymentPartyQuery>;
export type GetRedemptionPaymentPartyLazyQueryHookResult = ReturnType<typeof useGetRedemptionPaymentPartyLazyQuery>;
export type GetRedemptionPaymentPartyQueryResult = Apollo.QueryResult<GetRedemptionPaymentPartyQuery, GetRedemptionPaymentPartyQueryVariables>;
export const GetPaidByListDocument = gql`
    query getPaidByList($selectedParty: String!) {
  getPaidByList(selectedParty: $selectedParty) {
    id
    name
    icNo
    financierCode
  }
}
    `;

/**
 * __useGetPaidByListQuery__
 *
 * To run a query within a React component, call `useGetPaidByListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaidByListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaidByListQuery({
 *   variables: {
 *      selectedParty: // value for 'selectedParty'
 *   },
 * });
 */
export function useGetPaidByListQuery(baseOptions: Apollo.QueryHookOptions<GetPaidByListQuery, GetPaidByListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaidByListQuery, GetPaidByListQueryVariables>(GetPaidByListDocument, options);
      }
export function useGetPaidByListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaidByListQuery, GetPaidByListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaidByListQuery, GetPaidByListQueryVariables>(GetPaidByListDocument, options);
        }
export type GetPaidByListQueryHookResult = ReturnType<typeof useGetPaidByListQuery>;
export type GetPaidByListLazyQueryHookResult = ReturnType<typeof useGetPaidByListLazyQuery>;
export type GetPaidByListQueryResult = Apollo.QueryResult<GetPaidByListQuery, GetPaidByListQueryVariables>;
export const GetDeveloperRedemptionUnitListDocument = gql`
    query getDeveloperRedemptionUnitList {
  getDeveloperRedemptionUnitList {
    unitId
    unitNo
    redemptionBalance
    redemptionAmount
  }
}
    `;

/**
 * __useGetDeveloperRedemptionUnitListQuery__
 *
 * To run a query within a React component, call `useGetDeveloperRedemptionUnitListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeveloperRedemptionUnitListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeveloperRedemptionUnitListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDeveloperRedemptionUnitListQuery(baseOptions?: Apollo.QueryHookOptions<GetDeveloperRedemptionUnitListQuery, GetDeveloperRedemptionUnitListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeveloperRedemptionUnitListQuery, GetDeveloperRedemptionUnitListQueryVariables>(GetDeveloperRedemptionUnitListDocument, options);
      }
export function useGetDeveloperRedemptionUnitListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeveloperRedemptionUnitListQuery, GetDeveloperRedemptionUnitListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeveloperRedemptionUnitListQuery, GetDeveloperRedemptionUnitListQueryVariables>(GetDeveloperRedemptionUnitListDocument, options);
        }
export type GetDeveloperRedemptionUnitListQueryHookResult = ReturnType<typeof useGetDeveloperRedemptionUnitListQuery>;
export type GetDeveloperRedemptionUnitListLazyQueryHookResult = ReturnType<typeof useGetDeveloperRedemptionUnitListLazyQuery>;
export type GetDeveloperRedemptionUnitListQueryResult = Apollo.QueryResult<GetDeveloperRedemptionUnitListQuery, GetDeveloperRedemptionUnitListQueryVariables>;
export const GetFinancierRedemptionUnitListDocument = gql`
    query getFinancierRedemptionUnitList($financierId: String) {
  getFinancierRedemptionUnitList(financierId: $financierId) {
    unitId
    unitNo
    redemptionBalance
    redemptionAmount
  }
}
    `;

/**
 * __useGetFinancierRedemptionUnitListQuery__
 *
 * To run a query within a React component, call `useGetFinancierRedemptionUnitListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinancierRedemptionUnitListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinancierRedemptionUnitListQuery({
 *   variables: {
 *      financierId: // value for 'financierId'
 *   },
 * });
 */
export function useGetFinancierRedemptionUnitListQuery(baseOptions?: Apollo.QueryHookOptions<GetFinancierRedemptionUnitListQuery, GetFinancierRedemptionUnitListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFinancierRedemptionUnitListQuery, GetFinancierRedemptionUnitListQueryVariables>(GetFinancierRedemptionUnitListDocument, options);
      }
export function useGetFinancierRedemptionUnitListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFinancierRedemptionUnitListQuery, GetFinancierRedemptionUnitListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFinancierRedemptionUnitListQuery, GetFinancierRedemptionUnitListQueryVariables>(GetFinancierRedemptionUnitListDocument, options);
        }
export type GetFinancierRedemptionUnitListQueryHookResult = ReturnType<typeof useGetFinancierRedemptionUnitListQuery>;
export type GetFinancierRedemptionUnitListLazyQueryHookResult = ReturnType<typeof useGetFinancierRedemptionUnitListLazyQuery>;
export type GetFinancierRedemptionUnitListQueryResult = Apollo.QueryResult<GetFinancierRedemptionUnitListQuery, GetFinancierRedemptionUnitListQueryVariables>;
export const GetPurchaserRedemptionUnitListDocument = gql`
    query getPurchaserRedemptionUnitList($contactId: String) {
  getPurchaserRedemptionUnitList(contactId: $contactId) {
    unitId
    unitNo
    redemptionBalance
    redemptionAmount
  }
}
    `;

/**
 * __useGetPurchaserRedemptionUnitListQuery__
 *
 * To run a query within a React component, call `useGetPurchaserRedemptionUnitListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPurchaserRedemptionUnitListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPurchaserRedemptionUnitListQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useGetPurchaserRedemptionUnitListQuery(baseOptions?: Apollo.QueryHookOptions<GetPurchaserRedemptionUnitListQuery, GetPurchaserRedemptionUnitListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPurchaserRedemptionUnitListQuery, GetPurchaserRedemptionUnitListQueryVariables>(GetPurchaserRedemptionUnitListDocument, options);
      }
export function useGetPurchaserRedemptionUnitListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPurchaserRedemptionUnitListQuery, GetPurchaserRedemptionUnitListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPurchaserRedemptionUnitListQuery, GetPurchaserRedemptionUnitListQueryVariables>(GetPurchaserRedemptionUnitListDocument, options);
        }
export type GetPurchaserRedemptionUnitListQueryHookResult = ReturnType<typeof useGetPurchaserRedemptionUnitListQuery>;
export type GetPurchaserRedemptionUnitListLazyQueryHookResult = ReturnType<typeof useGetPurchaserRedemptionUnitListLazyQuery>;
export type GetPurchaserRedemptionUnitListQueryResult = Apollo.QueryResult<GetPurchaserRedemptionUnitListQuery, GetPurchaserRedemptionUnitListQueryVariables>;
export const GetRedemptionUnitSelectionDocument = gql`
    query getRedemptionUnitSelection($selectedParty: String!, $selectedPartyId: String) {
  getRedemptionUnitSelection(selectedParty: $selectedParty, selectedPartyId: $selectedPartyId) {
    unitId
    unitNo
    redemptionAmount
  }
}
    `;

/**
 * __useGetRedemptionUnitSelectionQuery__
 *
 * To run a query within a React component, call `useGetRedemptionUnitSelectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRedemptionUnitSelectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRedemptionUnitSelectionQuery({
 *   variables: {
 *      selectedParty: // value for 'selectedParty'
 *      selectedPartyId: // value for 'selectedPartyId'
 *   },
 * });
 */
export function useGetRedemptionUnitSelectionQuery(baseOptions: Apollo.QueryHookOptions<GetRedemptionUnitSelectionQuery, GetRedemptionUnitSelectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRedemptionUnitSelectionQuery, GetRedemptionUnitSelectionQueryVariables>(GetRedemptionUnitSelectionDocument, options);
      }
export function useGetRedemptionUnitSelectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRedemptionUnitSelectionQuery, GetRedemptionUnitSelectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRedemptionUnitSelectionQuery, GetRedemptionUnitSelectionQueryVariables>(GetRedemptionUnitSelectionDocument, options);
        }
export type GetRedemptionUnitSelectionQueryHookResult = ReturnType<typeof useGetRedemptionUnitSelectionQuery>;
export type GetRedemptionUnitSelectionLazyQueryHookResult = ReturnType<typeof useGetRedemptionUnitSelectionLazyQuery>;
export type GetRedemptionUnitSelectionQueryResult = Apollo.QueryResult<GetRedemptionUnitSelectionQuery, GetRedemptionUnitSelectionQueryVariables>;
export const PostRedemptionRepaymentDocument = gql`
    mutation postRedemptionRepayment($id: String!) {
  postRedemptionRepayment(id: $id)
}
    `;
export type PostRedemptionRepaymentMutationFn = Apollo.MutationFunction<PostRedemptionRepaymentMutation, PostRedemptionRepaymentMutationVariables>;

/**
 * __usePostRedemptionRepaymentMutation__
 *
 * To run a mutation, you first call `usePostRedemptionRepaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostRedemptionRepaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postRedemptionRepaymentMutation, { data, loading, error }] = usePostRedemptionRepaymentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePostRedemptionRepaymentMutation(baseOptions?: Apollo.MutationHookOptions<PostRedemptionRepaymentMutation, PostRedemptionRepaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PostRedemptionRepaymentMutation, PostRedemptionRepaymentMutationVariables>(PostRedemptionRepaymentDocument, options);
      }
export type PostRedemptionRepaymentMutationHookResult = ReturnType<typeof usePostRedemptionRepaymentMutation>;
export type PostRedemptionRepaymentMutationResult = Apollo.MutationResult<PostRedemptionRepaymentMutation>;
export type PostRedemptionRepaymentMutationOptions = Apollo.BaseMutationOptions<PostRedemptionRepaymentMutation, PostRedemptionRepaymentMutationVariables>;
export const ReversalRedemptionRepaymentDocument = gql`
    mutation reversalRedemptionRepayment($id: String!) {
  reversalRedemptionRepayment(id: $id)
}
    `;
export type ReversalRedemptionRepaymentMutationFn = Apollo.MutationFunction<ReversalRedemptionRepaymentMutation, ReversalRedemptionRepaymentMutationVariables>;

/**
 * __useReversalRedemptionRepaymentMutation__
 *
 * To run a mutation, you first call `useReversalRedemptionRepaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReversalRedemptionRepaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reversalRedemptionRepaymentMutation, { data, loading, error }] = useReversalRedemptionRepaymentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReversalRedemptionRepaymentMutation(baseOptions?: Apollo.MutationHookOptions<ReversalRedemptionRepaymentMutation, ReversalRedemptionRepaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReversalRedemptionRepaymentMutation, ReversalRedemptionRepaymentMutationVariables>(ReversalRedemptionRepaymentDocument, options);
      }
export type ReversalRedemptionRepaymentMutationHookResult = ReturnType<typeof useReversalRedemptionRepaymentMutation>;
export type ReversalRedemptionRepaymentMutationResult = Apollo.MutationResult<ReversalRedemptionRepaymentMutation>;
export type ReversalRedemptionRepaymentMutationOptions = Apollo.BaseMutationOptions<ReversalRedemptionRepaymentMutation, ReversalRedemptionRepaymentMutationVariables>;
export const CheckSetupBridgingFinancierDocument = gql`
    query checkSetupBridgingFinancier {
  checkSetupBridgingFinancier
}
    `;

/**
 * __useCheckSetupBridgingFinancierQuery__
 *
 * To run a query within a React component, call `useCheckSetupBridgingFinancierQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckSetupBridgingFinancierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckSetupBridgingFinancierQuery({
 *   variables: {
 *   },
 * });
 */
export function useCheckSetupBridgingFinancierQuery(baseOptions?: Apollo.QueryHookOptions<CheckSetupBridgingFinancierQuery, CheckSetupBridgingFinancierQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckSetupBridgingFinancierQuery, CheckSetupBridgingFinancierQueryVariables>(CheckSetupBridgingFinancierDocument, options);
      }
export function useCheckSetupBridgingFinancierLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckSetupBridgingFinancierQuery, CheckSetupBridgingFinancierQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckSetupBridgingFinancierQuery, CheckSetupBridgingFinancierQueryVariables>(CheckSetupBridgingFinancierDocument, options);
        }
export type CheckSetupBridgingFinancierQueryHookResult = ReturnType<typeof useCheckSetupBridgingFinancierQuery>;
export type CheckSetupBridgingFinancierLazyQueryHookResult = ReturnType<typeof useCheckSetupBridgingFinancierLazyQuery>;
export type CheckSetupBridgingFinancierQueryResult = Apollo.QueryResult<CheckSetupBridgingFinancierQuery, CheckSetupBridgingFinancierQueryVariables>;
export const GetSalesLoanBuyBackListDocument = gql`
    query getSalesLoanBuyBackList($projectId: String!, $approvalStatus: String!) {
  getSalesLoanBuyBackList(projectId: $projectId, approvalStatus: $approvalStatus) {
    id
    unitNo
    fullName
    newFinancier
    buyBackDate
    buyBackAmount
    approvalStatus
    docNo
  }
}
    `;

/**
 * __useGetSalesLoanBuyBackListQuery__
 *
 * To run a query within a React component, call `useGetSalesLoanBuyBackListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesLoanBuyBackListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesLoanBuyBackListQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      approvalStatus: // value for 'approvalStatus'
 *   },
 * });
 */
export function useGetSalesLoanBuyBackListQuery(baseOptions: Apollo.QueryHookOptions<GetSalesLoanBuyBackListQuery, GetSalesLoanBuyBackListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesLoanBuyBackListQuery, GetSalesLoanBuyBackListQueryVariables>(GetSalesLoanBuyBackListDocument, options);
      }
export function useGetSalesLoanBuyBackListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesLoanBuyBackListQuery, GetSalesLoanBuyBackListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesLoanBuyBackListQuery, GetSalesLoanBuyBackListQueryVariables>(GetSalesLoanBuyBackListDocument, options);
        }
export type GetSalesLoanBuyBackListQueryHookResult = ReturnType<typeof useGetSalesLoanBuyBackListQuery>;
export type GetSalesLoanBuyBackListLazyQueryHookResult = ReturnType<typeof useGetSalesLoanBuyBackListLazyQuery>;
export type GetSalesLoanBuyBackListQueryResult = Apollo.QueryResult<GetSalesLoanBuyBackListQuery, GetSalesLoanBuyBackListQueryVariables>;
export const GetSalesLoanBuyBackMasterDataDocument = gql`
    query getSalesLoanBuyBackMasterData($companyId: String!, $isAddForm: Boolean) {
  salesLoanBuyBackMasterData(companyId: $companyId, isAddForm: $isAddForm) {
    unitList {
      sale_id
      unitNo
      full_name
      name
      table_ref
      financier_id
      is_refinanced
      sale_loan_id
      old_balance
      saleLoanPayment {
        paymentId
        loanAmt
        saleLoanId
        endfinMortgagePaymentId
        paymentName
        constructionDate
        loanSignDate
        expectedCount
        expectedFreq
        expectedFrom
        saleLoanRetention {
          retentionId
          retentionName
          retentionValue
          saleLoanPaymentId
          endfinMortgageRetentionId
          constructionDate
          loanSignDate
          expectedCount
          expectedFreq
          expectedFrom
        }
      }
    }
    banks {
      value
      label
      code
      accountNo
      currency
    }
  }
}
    `;

/**
 * __useGetSalesLoanBuyBackMasterDataQuery__
 *
 * To run a query within a React component, call `useGetSalesLoanBuyBackMasterDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesLoanBuyBackMasterDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesLoanBuyBackMasterDataQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      isAddForm: // value for 'isAddForm'
 *   },
 * });
 */
export function useGetSalesLoanBuyBackMasterDataQuery(baseOptions: Apollo.QueryHookOptions<GetSalesLoanBuyBackMasterDataQuery, GetSalesLoanBuyBackMasterDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesLoanBuyBackMasterDataQuery, GetSalesLoanBuyBackMasterDataQueryVariables>(GetSalesLoanBuyBackMasterDataDocument, options);
      }
export function useGetSalesLoanBuyBackMasterDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesLoanBuyBackMasterDataQuery, GetSalesLoanBuyBackMasterDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesLoanBuyBackMasterDataQuery, GetSalesLoanBuyBackMasterDataQueryVariables>(GetSalesLoanBuyBackMasterDataDocument, options);
        }
export type GetSalesLoanBuyBackMasterDataQueryHookResult = ReturnType<typeof useGetSalesLoanBuyBackMasterDataQuery>;
export type GetSalesLoanBuyBackMasterDataLazyQueryHookResult = ReturnType<typeof useGetSalesLoanBuyBackMasterDataLazyQuery>;
export type GetSalesLoanBuyBackMasterDataQueryResult = Apollo.QueryResult<GetSalesLoanBuyBackMasterDataQuery, GetSalesLoanBuyBackMasterDataQueryVariables>;
export const GetSalesLoanBuyBackMasterDataDetailsDocument = gql`
    query getSalesLoanBuyBackMasterDataDetails($companyId: String!, $isAddForm: Boolean) {
  salesLoanBuyBackMasterDataDetails(companyId: $companyId, isAddForm: $isAddForm) {
    unitList {
      sale_id
      unitNo
      full_name
      name
      table_ref
      financier_id
      is_refinanced
      sale_loan_id
      old_balance
      saleLoanPayment {
        paymentId
        loanAmt
        saleLoanId
        endfinMortgagePaymentId
        paymentName
        constructionDate
        loanSignDate
        expectedCount
        expectedFreq
        expectedFrom
        saleLoanRetention {
          retentionId
          retentionName
          retentionValue
          saleLoanPaymentId
          endfinMortgageRetentionId
          constructionDate
          loanSignDate
          expectedCount
          expectedFreq
          expectedFrom
        }
      }
    }
    banks {
      value
      label
      code
      accountNo
      currency
    }
  }
}
    `;

/**
 * __useGetSalesLoanBuyBackMasterDataDetailsQuery__
 *
 * To run a query within a React component, call `useGetSalesLoanBuyBackMasterDataDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesLoanBuyBackMasterDataDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesLoanBuyBackMasterDataDetailsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      isAddForm: // value for 'isAddForm'
 *   },
 * });
 */
export function useGetSalesLoanBuyBackMasterDataDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetSalesLoanBuyBackMasterDataDetailsQuery, GetSalesLoanBuyBackMasterDataDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesLoanBuyBackMasterDataDetailsQuery, GetSalesLoanBuyBackMasterDataDetailsQueryVariables>(GetSalesLoanBuyBackMasterDataDetailsDocument, options);
      }
export function useGetSalesLoanBuyBackMasterDataDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesLoanBuyBackMasterDataDetailsQuery, GetSalesLoanBuyBackMasterDataDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesLoanBuyBackMasterDataDetailsQuery, GetSalesLoanBuyBackMasterDataDetailsQueryVariables>(GetSalesLoanBuyBackMasterDataDetailsDocument, options);
        }
export type GetSalesLoanBuyBackMasterDataDetailsQueryHookResult = ReturnType<typeof useGetSalesLoanBuyBackMasterDataDetailsQuery>;
export type GetSalesLoanBuyBackMasterDataDetailsLazyQueryHookResult = ReturnType<typeof useGetSalesLoanBuyBackMasterDataDetailsLazyQuery>;
export type GetSalesLoanBuyBackMasterDataDetailsQueryResult = Apollo.QueryResult<GetSalesLoanBuyBackMasterDataDetailsQuery, GetSalesLoanBuyBackMasterDataDetailsQueryVariables>;
export const AddSaleLoanBuyBackDocument = gql`
    mutation addSaleLoanBuyBack($input: addSaleLoanBuyBackListInput!) {
  addSaleLoanBuyBack(input: $input)
}
    `;
export type AddSaleLoanBuyBackMutationFn = Apollo.MutationFunction<AddSaleLoanBuyBackMutation, AddSaleLoanBuyBackMutationVariables>;

/**
 * __useAddSaleLoanBuyBackMutation__
 *
 * To run a mutation, you first call `useAddSaleLoanBuyBackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSaleLoanBuyBackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSaleLoanBuyBackMutation, { data, loading, error }] = useAddSaleLoanBuyBackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddSaleLoanBuyBackMutation(baseOptions?: Apollo.MutationHookOptions<AddSaleLoanBuyBackMutation, AddSaleLoanBuyBackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSaleLoanBuyBackMutation, AddSaleLoanBuyBackMutationVariables>(AddSaleLoanBuyBackDocument, options);
      }
export type AddSaleLoanBuyBackMutationHookResult = ReturnType<typeof useAddSaleLoanBuyBackMutation>;
export type AddSaleLoanBuyBackMutationResult = Apollo.MutationResult<AddSaleLoanBuyBackMutation>;
export type AddSaleLoanBuyBackMutationOptions = Apollo.BaseMutationOptions<AddSaleLoanBuyBackMutation, AddSaleLoanBuyBackMutationVariables>;
export const EditSaleLoanBuyBackDocument = gql`
    mutation editSaleLoanBuyBack($input: editSaleLoanBuyBackListInput!) {
  editSaleLoanBuyBack(input: $input)
}
    `;
export type EditSaleLoanBuyBackMutationFn = Apollo.MutationFunction<EditSaleLoanBuyBackMutation, EditSaleLoanBuyBackMutationVariables>;

/**
 * __useEditSaleLoanBuyBackMutation__
 *
 * To run a mutation, you first call `useEditSaleLoanBuyBackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSaleLoanBuyBackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSaleLoanBuyBackMutation, { data, loading, error }] = useEditSaleLoanBuyBackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditSaleLoanBuyBackMutation(baseOptions?: Apollo.MutationHookOptions<EditSaleLoanBuyBackMutation, EditSaleLoanBuyBackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditSaleLoanBuyBackMutation, EditSaleLoanBuyBackMutationVariables>(EditSaleLoanBuyBackDocument, options);
      }
export type EditSaleLoanBuyBackMutationHookResult = ReturnType<typeof useEditSaleLoanBuyBackMutation>;
export type EditSaleLoanBuyBackMutationResult = Apollo.MutationResult<EditSaleLoanBuyBackMutation>;
export type EditSaleLoanBuyBackMutationOptions = Apollo.BaseMutationOptions<EditSaleLoanBuyBackMutation, EditSaleLoanBuyBackMutationVariables>;
export const ApproveBuyBackLoanDocument = gql`
    mutation approveBuyBackLoan($buyBackLoanId: String!, $projectId: String!) {
  approveBuyBackLoan(buyBackLoanId: $buyBackLoanId, projectId: $projectId)
}
    `;
export type ApproveBuyBackLoanMutationFn = Apollo.MutationFunction<ApproveBuyBackLoanMutation, ApproveBuyBackLoanMutationVariables>;

/**
 * __useApproveBuyBackLoanMutation__
 *
 * To run a mutation, you first call `useApproveBuyBackLoanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveBuyBackLoanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveBuyBackLoanMutation, { data, loading, error }] = useApproveBuyBackLoanMutation({
 *   variables: {
 *      buyBackLoanId: // value for 'buyBackLoanId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useApproveBuyBackLoanMutation(baseOptions?: Apollo.MutationHookOptions<ApproveBuyBackLoanMutation, ApproveBuyBackLoanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveBuyBackLoanMutation, ApproveBuyBackLoanMutationVariables>(ApproveBuyBackLoanDocument, options);
      }
export type ApproveBuyBackLoanMutationHookResult = ReturnType<typeof useApproveBuyBackLoanMutation>;
export type ApproveBuyBackLoanMutationResult = Apollo.MutationResult<ApproveBuyBackLoanMutation>;
export type ApproveBuyBackLoanMutationOptions = Apollo.BaseMutationOptions<ApproveBuyBackLoanMutation, ApproveBuyBackLoanMutationVariables>;
export const GetSalesLoanBuyBackDetailsDocument = gql`
    query getSalesLoanBuyBackDetails($id: String!) {
  getSalesLoanBuyBackDetails(id: $id) {
    id
    projectId
    saleId
    unitNo
    fullName
    refTable
    refRecordId
    newFinancier
    buyBackDate
    buyBackAmount
    bankName
    bankAccountNo
    remarks
    financierId
    bankAccountId
    approvalStatus
    submittedDate
    submittedBy
    approvedDate
    approvedBy
    oldBalance
    docNo
    saleLoanPayment {
      paymentId
      loanAmt
      saleLoanId
      endfinMortgagePaymentId
      paymentName
      constructionDate
      loanSignDate
      expectedCount
      expectedFreq
      expectedFrom
      saleLoanRetention {
        retentionId
        retentionName
        retentionValue
        saleLoanPaymentId
        endfinMortgageRetentionId
        constructionDate
        loanSignDate
        expectedCount
        expectedFreq
        expectedFrom
      }
    }
  }
}
    `;

/**
 * __useGetSalesLoanBuyBackDetailsQuery__
 *
 * To run a query within a React component, call `useGetSalesLoanBuyBackDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesLoanBuyBackDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesLoanBuyBackDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSalesLoanBuyBackDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetSalesLoanBuyBackDetailsQuery, GetSalesLoanBuyBackDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesLoanBuyBackDetailsQuery, GetSalesLoanBuyBackDetailsQueryVariables>(GetSalesLoanBuyBackDetailsDocument, options);
      }
export function useGetSalesLoanBuyBackDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesLoanBuyBackDetailsQuery, GetSalesLoanBuyBackDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesLoanBuyBackDetailsQuery, GetSalesLoanBuyBackDetailsQueryVariables>(GetSalesLoanBuyBackDetailsDocument, options);
        }
export type GetSalesLoanBuyBackDetailsQueryHookResult = ReturnType<typeof useGetSalesLoanBuyBackDetailsQuery>;
export type GetSalesLoanBuyBackDetailsLazyQueryHookResult = ReturnType<typeof useGetSalesLoanBuyBackDetailsLazyQuery>;
export type GetSalesLoanBuyBackDetailsQueryResult = Apollo.QueryResult<GetSalesLoanBuyBackDetailsQuery, GetSalesLoanBuyBackDetailsQueryVariables>;
export const DeleteSaleLoanBuyBackDocument = gql`
    mutation deleteSaleLoanBuyBack($input: String!) {
  deleteSaleLoanBuyBack(input: $input)
}
    `;
export type DeleteSaleLoanBuyBackMutationFn = Apollo.MutationFunction<DeleteSaleLoanBuyBackMutation, DeleteSaleLoanBuyBackMutationVariables>;

/**
 * __useDeleteSaleLoanBuyBackMutation__
 *
 * To run a mutation, you first call `useDeleteSaleLoanBuyBackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSaleLoanBuyBackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSaleLoanBuyBackMutation, { data, loading, error }] = useDeleteSaleLoanBuyBackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSaleLoanBuyBackMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSaleLoanBuyBackMutation, DeleteSaleLoanBuyBackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSaleLoanBuyBackMutation, DeleteSaleLoanBuyBackMutationVariables>(DeleteSaleLoanBuyBackDocument, options);
      }
export type DeleteSaleLoanBuyBackMutationHookResult = ReturnType<typeof useDeleteSaleLoanBuyBackMutation>;
export type DeleteSaleLoanBuyBackMutationResult = Apollo.MutationResult<DeleteSaleLoanBuyBackMutation>;
export type DeleteSaleLoanBuyBackMutationOptions = Apollo.BaseMutationOptions<DeleteSaleLoanBuyBackMutation, DeleteSaleLoanBuyBackMutationVariables>;
export const GetSaleLoanBuyBackCountDocument = gql`
    query getSaleLoanBuyBackCount($projectId: String!) {
  getSaleLoanBuyBackCount(projectId: $projectId) {
    draftCount
    submittedCount
    approvedCount
  }
}
    `;

/**
 * __useGetSaleLoanBuyBackCountQuery__
 *
 * To run a query within a React component, call `useGetSaleLoanBuyBackCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSaleLoanBuyBackCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSaleLoanBuyBackCountQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetSaleLoanBuyBackCountQuery(baseOptions: Apollo.QueryHookOptions<GetSaleLoanBuyBackCountQuery, GetSaleLoanBuyBackCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSaleLoanBuyBackCountQuery, GetSaleLoanBuyBackCountQueryVariables>(GetSaleLoanBuyBackCountDocument, options);
      }
export function useGetSaleLoanBuyBackCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSaleLoanBuyBackCountQuery, GetSaleLoanBuyBackCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSaleLoanBuyBackCountQuery, GetSaleLoanBuyBackCountQueryVariables>(GetSaleLoanBuyBackCountDocument, options);
        }
export type GetSaleLoanBuyBackCountQueryHookResult = ReturnType<typeof useGetSaleLoanBuyBackCountQuery>;
export type GetSaleLoanBuyBackCountLazyQueryHookResult = ReturnType<typeof useGetSaleLoanBuyBackCountLazyQuery>;
export type GetSaleLoanBuyBackCountQueryResult = Apollo.QueryResult<GetSaleLoanBuyBackCountQuery, GetSaleLoanBuyBackCountQueryVariables>;
export const GetAllReceiptDocument = gql`
    query getAllReceipt($status: String!) {
  getAllReceipt(status: $status) {
    receiptId
    salesId
    unitNo
    paymentMethod
    documentNo
    docType
    documentRef
    description
    documentDate
    currency
    exchangeRate
    documentAmount
    receiptAmount
    chequeDate
    chequeExpireDate
    creditCardType
    bankAccountId
    bankCode
    bankAccountNo
    financierId
    financierName
    allowReversal
    getAttachment {
      id
      resourceUrl
      mediaType
      fileName
    }
    status
    submittedBy
    submittedDate
    allocationDocumentNo
    allocateAmount
    unAllocateAmount
    approvedBy
    approvedDate
    voidBy
    voidDate
    allocationList {
      documentNo
      allocateAmount
      documentDate
      description
    }
  }
}
    `;

/**
 * __useGetAllReceiptQuery__
 *
 * To run a query within a React component, call `useGetAllReceiptQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllReceiptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllReceiptQuery({
 *   variables: {
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetAllReceiptQuery(baseOptions: Apollo.QueryHookOptions<GetAllReceiptQuery, GetAllReceiptQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllReceiptQuery, GetAllReceiptQueryVariables>(GetAllReceiptDocument, options);
      }
export function useGetAllReceiptLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllReceiptQuery, GetAllReceiptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllReceiptQuery, GetAllReceiptQueryVariables>(GetAllReceiptDocument, options);
        }
export type GetAllReceiptQueryHookResult = ReturnType<typeof useGetAllReceiptQuery>;
export type GetAllReceiptLazyQueryHookResult = ReturnType<typeof useGetAllReceiptLazyQuery>;
export type GetAllReceiptQueryResult = Apollo.QueryResult<GetAllReceiptQuery, GetAllReceiptQueryVariables>;
export const GetAllReceiptBySaleIdDocument = gql`
    query getAllReceiptBySaleId($status: String!, $saleId: String!) {
  getAllReceiptBySaleId(status: $status, saleId: $saleId) {
    receiptId
    salesId
    unitNo
    paymentMethod
    documentNo
    documentRef
    description
    documentDate
    docType
    currency
    exchangeRate
    documentAmount
    receiptAmount
    chequeDate
    chequeExpireDate
    creditCardType
    bankAccountId
    bankCode
    bankAccountNo
    financierId
    financierName
    voidBy
    voidDate
    getAttachment {
      id
      resourceUrl
      mediaType
      fileName
    }
    status
    submittedBy
    submittedDate
    allocationDocumentNo
    allocateAmount
    unAllocateAmount
    approvedBy
    approvedDate
    allocationList {
      documentNo
      allocateAmount
      documentDate
      description
    }
    allowReversal
  }
}
    `;

/**
 * __useGetAllReceiptBySaleIdQuery__
 *
 * To run a query within a React component, call `useGetAllReceiptBySaleIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllReceiptBySaleIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllReceiptBySaleIdQuery({
 *   variables: {
 *      status: // value for 'status'
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetAllReceiptBySaleIdQuery(baseOptions: Apollo.QueryHookOptions<GetAllReceiptBySaleIdQuery, GetAllReceiptBySaleIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllReceiptBySaleIdQuery, GetAllReceiptBySaleIdQueryVariables>(GetAllReceiptBySaleIdDocument, options);
      }
export function useGetAllReceiptBySaleIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllReceiptBySaleIdQuery, GetAllReceiptBySaleIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllReceiptBySaleIdQuery, GetAllReceiptBySaleIdQueryVariables>(GetAllReceiptBySaleIdDocument, options);
        }
export type GetAllReceiptBySaleIdQueryHookResult = ReturnType<typeof useGetAllReceiptBySaleIdQuery>;
export type GetAllReceiptBySaleIdLazyQueryHookResult = ReturnType<typeof useGetAllReceiptBySaleIdLazyQuery>;
export type GetAllReceiptBySaleIdQueryResult = Apollo.QueryResult<GetAllReceiptBySaleIdQuery, GetAllReceiptBySaleIdQueryVariables>;
export const CreateReceiptDocument = gql`
    mutation createReceipt($input: receiptInput!) {
  createReceipt(input: $input)
}
    `;
export type CreateReceiptMutationFn = Apollo.MutationFunction<CreateReceiptMutation, CreateReceiptMutationVariables>;

/**
 * __useCreateReceiptMutation__
 *
 * To run a mutation, you first call `useCreateReceiptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReceiptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReceiptMutation, { data, loading, error }] = useCreateReceiptMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReceiptMutation(baseOptions?: Apollo.MutationHookOptions<CreateReceiptMutation, CreateReceiptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReceiptMutation, CreateReceiptMutationVariables>(CreateReceiptDocument, options);
      }
export type CreateReceiptMutationHookResult = ReturnType<typeof useCreateReceiptMutation>;
export type CreateReceiptMutationResult = Apollo.MutationResult<CreateReceiptMutation>;
export type CreateReceiptMutationOptions = Apollo.BaseMutationOptions<CreateReceiptMutation, CreateReceiptMutationVariables>;
export const GetCollectionMasterDataDocument = gql`
    query getCollectionMasterData {
  getCollectionMasterData {
    currency
    unitList {
      saleId
      unitNo
      financierList {
        financierId
        financierName
      }
    }
  }
}
    `;

/**
 * __useGetCollectionMasterDataQuery__
 *
 * To run a query within a React component, call `useGetCollectionMasterDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionMasterDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionMasterDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCollectionMasterDataQuery(baseOptions?: Apollo.QueryHookOptions<GetCollectionMasterDataQuery, GetCollectionMasterDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectionMasterDataQuery, GetCollectionMasterDataQueryVariables>(GetCollectionMasterDataDocument, options);
      }
export function useGetCollectionMasterDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectionMasterDataQuery, GetCollectionMasterDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectionMasterDataQuery, GetCollectionMasterDataQueryVariables>(GetCollectionMasterDataDocument, options);
        }
export type GetCollectionMasterDataQueryHookResult = ReturnType<typeof useGetCollectionMasterDataQuery>;
export type GetCollectionMasterDataLazyQueryHookResult = ReturnType<typeof useGetCollectionMasterDataLazyQuery>;
export type GetCollectionMasterDataQueryResult = Apollo.QueryResult<GetCollectionMasterDataQuery, GetCollectionMasterDataQueryVariables>;
export const GetCompanyBankAccountDocument = gql`
    query getCompanyBankAccount {
  getCompanyBankAccount {
    bankProfileId
    bankProfileName
    bankAccountId
    bankAccountCode
    bankAccountNo
    isSelected
    currency
  }
}
    `;

/**
 * __useGetCompanyBankAccountQuery__
 *
 * To run a query within a React component, call `useGetCompanyBankAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyBankAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyBankAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompanyBankAccountQuery(baseOptions?: Apollo.QueryHookOptions<GetCompanyBankAccountQuery, GetCompanyBankAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyBankAccountQuery, GetCompanyBankAccountQueryVariables>(GetCompanyBankAccountDocument, options);
      }
export function useGetCompanyBankAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyBankAccountQuery, GetCompanyBankAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyBankAccountQuery, GetCompanyBankAccountQueryVariables>(GetCompanyBankAccountDocument, options);
        }
export type GetCompanyBankAccountQueryHookResult = ReturnType<typeof useGetCompanyBankAccountQuery>;
export type GetCompanyBankAccountLazyQueryHookResult = ReturnType<typeof useGetCompanyBankAccountLazyQuery>;
export type GetCompanyBankAccountQueryResult = Apollo.QueryResult<GetCompanyBankAccountQuery, GetCompanyBankAccountQueryVariables>;
export const GetCompanyBankAcctDocument = gql`
    query getCompanyBankAcct {
  getCompanyBankAcct {
    bankProfileId
    bankProfileName
    bankAccountId
    bankAccountCode
    bankAccountNo
    isSelected
    currency
  }
}
    `;

/**
 * __useGetCompanyBankAcctQuery__
 *
 * To run a query within a React component, call `useGetCompanyBankAcctQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyBankAcctQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyBankAcctQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompanyBankAcctQuery(baseOptions?: Apollo.QueryHookOptions<GetCompanyBankAcctQuery, GetCompanyBankAcctQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyBankAcctQuery, GetCompanyBankAcctQueryVariables>(GetCompanyBankAcctDocument, options);
      }
export function useGetCompanyBankAcctLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyBankAcctQuery, GetCompanyBankAcctQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyBankAcctQuery, GetCompanyBankAcctQueryVariables>(GetCompanyBankAcctDocument, options);
        }
export type GetCompanyBankAcctQueryHookResult = ReturnType<typeof useGetCompanyBankAcctQuery>;
export type GetCompanyBankAcctLazyQueryHookResult = ReturnType<typeof useGetCompanyBankAcctLazyQuery>;
export type GetCompanyBankAcctQueryResult = Apollo.QueryResult<GetCompanyBankAcctQuery, GetCompanyBankAcctQueryVariables>;
export const GetReceiptByIdDocument = gql`
    query getReceiptById($id: String!, $docType: String) {
  getReceiptById(id: $id, docType: $docType) {
    receiptId
    salesId
    unitNo
    paymentMethod
    docType
    allowReversal
    documentNo
    documentRef
    description
    documentDate
    currency
    exchangeRate
    documentAmount
    receiptAmount
    chequeDate
    chequeExpireDate
    creditCardType
    bankAccountId
    bankCode
    bankAccountNo
    financierId
    financierName
    voidBy
    voidDate
    getAttachment {
      id
      resourceUrl
      mediaType
      fileName
    }
    status
    submittedBy
    submittedDate
    allocationDocumentNo
    allocateAmount
    unAllocateAmount
    approvedBy
    approvedDate
    projectDetail {
      name
    }
  }
}
    `;

/**
 * __useGetReceiptByIdQuery__
 *
 * To run a query within a React component, call `useGetReceiptByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReceiptByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReceiptByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      docType: // value for 'docType'
 *   },
 * });
 */
export function useGetReceiptByIdQuery(baseOptions: Apollo.QueryHookOptions<GetReceiptByIdQuery, GetReceiptByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReceiptByIdQuery, GetReceiptByIdQueryVariables>(GetReceiptByIdDocument, options);
      }
export function useGetReceiptByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReceiptByIdQuery, GetReceiptByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReceiptByIdQuery, GetReceiptByIdQueryVariables>(GetReceiptByIdDocument, options);
        }
export type GetReceiptByIdQueryHookResult = ReturnType<typeof useGetReceiptByIdQuery>;
export type GetReceiptByIdLazyQueryHookResult = ReturnType<typeof useGetReceiptByIdLazyQuery>;
export type GetReceiptByIdQueryResult = Apollo.QueryResult<GetReceiptByIdQuery, GetReceiptByIdQueryVariables>;
export const EditReceiptDocument = gql`
    mutation editReceipt($input: EditReceiptInput!) {
  editReceipt(input: $input)
}
    `;
export type EditReceiptMutationFn = Apollo.MutationFunction<EditReceiptMutation, EditReceiptMutationVariables>;

/**
 * __useEditReceiptMutation__
 *
 * To run a mutation, you first call `useEditReceiptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditReceiptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editReceiptMutation, { data, loading, error }] = useEditReceiptMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditReceiptMutation(baseOptions?: Apollo.MutationHookOptions<EditReceiptMutation, EditReceiptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditReceiptMutation, EditReceiptMutationVariables>(EditReceiptDocument, options);
      }
export type EditReceiptMutationHookResult = ReturnType<typeof useEditReceiptMutation>;
export type EditReceiptMutationResult = Apollo.MutationResult<EditReceiptMutation>;
export type EditReceiptMutationOptions = Apollo.BaseMutationOptions<EditReceiptMutation, EditReceiptMutationVariables>;
export const AllocationReceiptDocument = gql`
    mutation allocationReceipt($input: AllocationInput!) {
  allocationReceipt(input: $input)
}
    `;
export type AllocationReceiptMutationFn = Apollo.MutationFunction<AllocationReceiptMutation, AllocationReceiptMutationVariables>;

/**
 * __useAllocationReceiptMutation__
 *
 * To run a mutation, you first call `useAllocationReceiptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAllocationReceiptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [allocationReceiptMutation, { data, loading, error }] = useAllocationReceiptMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAllocationReceiptMutation(baseOptions?: Apollo.MutationHookOptions<AllocationReceiptMutation, AllocationReceiptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AllocationReceiptMutation, AllocationReceiptMutationVariables>(AllocationReceiptDocument, options);
      }
export type AllocationReceiptMutationHookResult = ReturnType<typeof useAllocationReceiptMutation>;
export type AllocationReceiptMutationResult = Apollo.MutationResult<AllocationReceiptMutation>;
export type AllocationReceiptMutationOptions = Apollo.BaseMutationOptions<AllocationReceiptMutation, AllocationReceiptMutationVariables>;
export const PostingReceiptDocument = gql`
    mutation postingReceipt($input: PostingInput!) {
  postingReceipt(input: $input)
}
    `;
export type PostingReceiptMutationFn = Apollo.MutationFunction<PostingReceiptMutation, PostingReceiptMutationVariables>;

/**
 * __usePostingReceiptMutation__
 *
 * To run a mutation, you first call `usePostingReceiptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostingReceiptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postingReceiptMutation, { data, loading, error }] = usePostingReceiptMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePostingReceiptMutation(baseOptions?: Apollo.MutationHookOptions<PostingReceiptMutation, PostingReceiptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PostingReceiptMutation, PostingReceiptMutationVariables>(PostingReceiptDocument, options);
      }
export type PostingReceiptMutationHookResult = ReturnType<typeof usePostingReceiptMutation>;
export type PostingReceiptMutationResult = Apollo.MutationResult<PostingReceiptMutation>;
export type PostingReceiptMutationOptions = Apollo.BaseMutationOptions<PostingReceiptMutation, PostingReceiptMutationVariables>;
export const GetSalesInformationDocument = gql`
    query getSalesInformation($saleId: String!) {
  getSalesInformation(saleId: $saleId) {
    unitNo
    name
    totalAmount
    totalAllocateAmount
    unAllocateAmount
    isCompany
    companyName
  }
}
    `;

/**
 * __useGetSalesInformationQuery__
 *
 * To run a query within a React component, call `useGetSalesInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesInformationQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetSalesInformationQuery(baseOptions: Apollo.QueryHookOptions<GetSalesInformationQuery, GetSalesInformationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesInformationQuery, GetSalesInformationQueryVariables>(GetSalesInformationDocument, options);
      }
export function useGetSalesInformationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesInformationQuery, GetSalesInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesInformationQuery, GetSalesInformationQueryVariables>(GetSalesInformationDocument, options);
        }
export type GetSalesInformationQueryHookResult = ReturnType<typeof useGetSalesInformationQuery>;
export type GetSalesInformationLazyQueryHookResult = ReturnType<typeof useGetSalesInformationLazyQuery>;
export type GetSalesInformationQueryResult = Apollo.QueryResult<GetSalesInformationQuery, GetSalesInformationQueryVariables>;
export const AddReceiptReversalDocument = gql`
    mutation addReceiptReversal($receiptId: String!) {
  addReceiptReversal(receiptId: $receiptId)
}
    `;
export type AddReceiptReversalMutationFn = Apollo.MutationFunction<AddReceiptReversalMutation, AddReceiptReversalMutationVariables>;

/**
 * __useAddReceiptReversalMutation__
 *
 * To run a mutation, you first call `useAddReceiptReversalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddReceiptReversalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addReceiptReversalMutation, { data, loading, error }] = useAddReceiptReversalMutation({
 *   variables: {
 *      receiptId: // value for 'receiptId'
 *   },
 * });
 */
export function useAddReceiptReversalMutation(baseOptions?: Apollo.MutationHookOptions<AddReceiptReversalMutation, AddReceiptReversalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddReceiptReversalMutation, AddReceiptReversalMutationVariables>(AddReceiptReversalDocument, options);
      }
export type AddReceiptReversalMutationHookResult = ReturnType<typeof useAddReceiptReversalMutation>;
export type AddReceiptReversalMutationResult = Apollo.MutationResult<AddReceiptReversalMutation>;
export type AddReceiptReversalMutationOptions = Apollo.BaseMutationOptions<AddReceiptReversalMutation, AddReceiptReversalMutationVariables>;
export const GetApprovalPolicyFlagDocument = gql`
    query getApprovalPolicyFlag {
  getApprovalPolicyFlag
}
    `;

/**
 * __useGetApprovalPolicyFlagQuery__
 *
 * To run a query within a React component, call `useGetApprovalPolicyFlagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApprovalPolicyFlagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApprovalPolicyFlagQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetApprovalPolicyFlagQuery(baseOptions?: Apollo.QueryHookOptions<GetApprovalPolicyFlagQuery, GetApprovalPolicyFlagQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApprovalPolicyFlagQuery, GetApprovalPolicyFlagQueryVariables>(GetApprovalPolicyFlagDocument, options);
      }
export function useGetApprovalPolicyFlagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApprovalPolicyFlagQuery, GetApprovalPolicyFlagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApprovalPolicyFlagQuery, GetApprovalPolicyFlagQueryVariables>(GetApprovalPolicyFlagDocument, options);
        }
export type GetApprovalPolicyFlagQueryHookResult = ReturnType<typeof useGetApprovalPolicyFlagQuery>;
export type GetApprovalPolicyFlagLazyQueryHookResult = ReturnType<typeof useGetApprovalPolicyFlagLazyQuery>;
export type GetApprovalPolicyFlagQueryResult = Apollo.QueryResult<GetApprovalPolicyFlagQuery, GetApprovalPolicyFlagQueryVariables>;
export const GetApprovalPolicyListingByCategoryDocument = gql`
    query getApprovalPolicyListingByCategory($category: String!) {
  getApprovalPolicyListingByCategory(category: $category) {
    id
    lowerLimit
    upperLimit
    approvalList {
      stepNo
      roleId
      roleName
    }
  }
}
    `;

/**
 * __useGetApprovalPolicyListingByCategoryQuery__
 *
 * To run a query within a React component, call `useGetApprovalPolicyListingByCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApprovalPolicyListingByCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApprovalPolicyListingByCategoryQuery({
 *   variables: {
 *      category: // value for 'category'
 *   },
 * });
 */
export function useGetApprovalPolicyListingByCategoryQuery(baseOptions: Apollo.QueryHookOptions<GetApprovalPolicyListingByCategoryQuery, GetApprovalPolicyListingByCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApprovalPolicyListingByCategoryQuery, GetApprovalPolicyListingByCategoryQueryVariables>(GetApprovalPolicyListingByCategoryDocument, options);
      }
export function useGetApprovalPolicyListingByCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApprovalPolicyListingByCategoryQuery, GetApprovalPolicyListingByCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApprovalPolicyListingByCategoryQuery, GetApprovalPolicyListingByCategoryQueryVariables>(GetApprovalPolicyListingByCategoryDocument, options);
        }
export type GetApprovalPolicyListingByCategoryQueryHookResult = ReturnType<typeof useGetApprovalPolicyListingByCategoryQuery>;
export type GetApprovalPolicyListingByCategoryLazyQueryHookResult = ReturnType<typeof useGetApprovalPolicyListingByCategoryLazyQuery>;
export type GetApprovalPolicyListingByCategoryQueryResult = Apollo.QueryResult<GetApprovalPolicyListingByCategoryQuery, GetApprovalPolicyListingByCategoryQueryVariables>;
export const AddEditApprovalPolicyDocument = gql`
    mutation addEditApprovalPolicy($input: AddEditApprovalPolicyInput!) {
  addEditApprovalPolicy(input: $input)
}
    `;
export type AddEditApprovalPolicyMutationFn = Apollo.MutationFunction<AddEditApprovalPolicyMutation, AddEditApprovalPolicyMutationVariables>;

/**
 * __useAddEditApprovalPolicyMutation__
 *
 * To run a mutation, you first call `useAddEditApprovalPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEditApprovalPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEditApprovalPolicyMutation, { data, loading, error }] = useAddEditApprovalPolicyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddEditApprovalPolicyMutation(baseOptions?: Apollo.MutationHookOptions<AddEditApprovalPolicyMutation, AddEditApprovalPolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEditApprovalPolicyMutation, AddEditApprovalPolicyMutationVariables>(AddEditApprovalPolicyDocument, options);
      }
export type AddEditApprovalPolicyMutationHookResult = ReturnType<typeof useAddEditApprovalPolicyMutation>;
export type AddEditApprovalPolicyMutationResult = Apollo.MutationResult<AddEditApprovalPolicyMutation>;
export type AddEditApprovalPolicyMutationOptions = Apollo.BaseMutationOptions<AddEditApprovalPolicyMutation, AddEditApprovalPolicyMutationVariables>;
export const GetBankListDocument = gql`
    query getBankList {
  getBankList {
    id
    name
    code
    isExistInEndFinancier
    commonStatus
    isExistInTransactionData
  }
}
    `;

/**
 * __useGetBankListQuery__
 *
 * To run a query within a React component, call `useGetBankListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBankListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBankListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBankListQuery(baseOptions?: Apollo.QueryHookOptions<GetBankListQuery, GetBankListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBankListQuery, GetBankListQueryVariables>(GetBankListDocument, options);
      }
export function useGetBankListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBankListQuery, GetBankListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBankListQuery, GetBankListQueryVariables>(GetBankListDocument, options);
        }
export type GetBankListQueryHookResult = ReturnType<typeof useGetBankListQuery>;
export type GetBankListLazyQueryHookResult = ReturnType<typeof useGetBankListLazyQuery>;
export type GetBankListQueryResult = Apollo.QueryResult<GetBankListQuery, GetBankListQueryVariables>;
export const GetBankListingDocument = gql`
    query getBankListing {
  getBankListing {
    id
    name
    currency
    code
    accountNo
  }
}
    `;

/**
 * __useGetBankListingQuery__
 *
 * To run a query within a React component, call `useGetBankListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBankListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBankListingQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBankListingQuery(baseOptions?: Apollo.QueryHookOptions<GetBankListingQuery, GetBankListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBankListingQuery, GetBankListingQueryVariables>(GetBankListingDocument, options);
      }
export function useGetBankListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBankListingQuery, GetBankListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBankListingQuery, GetBankListingQueryVariables>(GetBankListingDocument, options);
        }
export type GetBankListingQueryHookResult = ReturnType<typeof useGetBankListingQuery>;
export type GetBankListingLazyQueryHookResult = ReturnType<typeof useGetBankListingLazyQuery>;
export type GetBankListingQueryResult = Apollo.QueryResult<GetBankListingQuery, GetBankListingQueryVariables>;
export const AddBankDocument = gql`
    mutation addBank($input: AddBankInput!) {
  addBank(input: $input)
}
    `;
export type AddBankMutationFn = Apollo.MutationFunction<AddBankMutation, AddBankMutationVariables>;

/**
 * __useAddBankMutation__
 *
 * To run a mutation, you first call `useAddBankMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBankMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBankMutation, { data, loading, error }] = useAddBankMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddBankMutation(baseOptions?: Apollo.MutationHookOptions<AddBankMutation, AddBankMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddBankMutation, AddBankMutationVariables>(AddBankDocument, options);
      }
export type AddBankMutationHookResult = ReturnType<typeof useAddBankMutation>;
export type AddBankMutationResult = Apollo.MutationResult<AddBankMutation>;
export type AddBankMutationOptions = Apollo.BaseMutationOptions<AddBankMutation, AddBankMutationVariables>;
export const EditBankDocument = gql`
    mutation editBank($input: EditBankInput!) {
  editBank(input: $input)
}
    `;
export type EditBankMutationFn = Apollo.MutationFunction<EditBankMutation, EditBankMutationVariables>;

/**
 * __useEditBankMutation__
 *
 * To run a mutation, you first call `useEditBankMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditBankMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editBankMutation, { data, loading, error }] = useEditBankMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditBankMutation(baseOptions?: Apollo.MutationHookOptions<EditBankMutation, EditBankMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditBankMutation, EditBankMutationVariables>(EditBankDocument, options);
      }
export type EditBankMutationHookResult = ReturnType<typeof useEditBankMutation>;
export type EditBankMutationResult = Apollo.MutationResult<EditBankMutation>;
export type EditBankMutationOptions = Apollo.BaseMutationOptions<EditBankMutation, EditBankMutationVariables>;
export const DeleteBankDocument = gql`
    mutation deleteBank($bankId: String!, $isDeletable: Boolean!) {
  deleteBank(bankId: $bankId, isDeletable: $isDeletable)
}
    `;
export type DeleteBankMutationFn = Apollo.MutationFunction<DeleteBankMutation, DeleteBankMutationVariables>;

/**
 * __useDeleteBankMutation__
 *
 * To run a mutation, you first call `useDeleteBankMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBankMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBankMutation, { data, loading, error }] = useDeleteBankMutation({
 *   variables: {
 *      bankId: // value for 'bankId'
 *      isDeletable: // value for 'isDeletable'
 *   },
 * });
 */
export function useDeleteBankMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBankMutation, DeleteBankMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBankMutation, DeleteBankMutationVariables>(DeleteBankDocument, options);
      }
export type DeleteBankMutationHookResult = ReturnType<typeof useDeleteBankMutation>;
export type DeleteBankMutationResult = Apollo.MutationResult<DeleteBankMutation>;
export type DeleteBankMutationOptions = Apollo.BaseMutationOptions<DeleteBankMutation, DeleteBankMutationVariables>;
export const ActivateBankDocument = gql`
    mutation activateBank($bankId: String!) {
  activateBank(bankId: $bankId)
}
    `;
export type ActivateBankMutationFn = Apollo.MutationFunction<ActivateBankMutation, ActivateBankMutationVariables>;

/**
 * __useActivateBankMutation__
 *
 * To run a mutation, you first call `useActivateBankMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateBankMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateBankMutation, { data, loading, error }] = useActivateBankMutation({
 *   variables: {
 *      bankId: // value for 'bankId'
 *   },
 * });
 */
export function useActivateBankMutation(baseOptions?: Apollo.MutationHookOptions<ActivateBankMutation, ActivateBankMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateBankMutation, ActivateBankMutationVariables>(ActivateBankDocument, options);
      }
export type ActivateBankMutationHookResult = ReturnType<typeof useActivateBankMutation>;
export type ActivateBankMutationResult = Apollo.MutationResult<ActivateBankMutation>;
export type ActivateBankMutationOptions = Apollo.BaseMutationOptions<ActivateBankMutation, ActivateBankMutationVariables>;
export const BankProfileListingDocument = gql`
    query bankProfileListing($companyId: String!) {
  bankProfileListing(companyId: $companyId) {
    bankProfile {
      id
      name
      phoneNo
      address
    }
  }
}
    `;

/**
 * __useBankProfileListingQuery__
 *
 * To run a query within a React component, call `useBankProfileListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useBankProfileListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBankProfileListingQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useBankProfileListingQuery(baseOptions: Apollo.QueryHookOptions<BankProfileListingQuery, BankProfileListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BankProfileListingQuery, BankProfileListingQueryVariables>(BankProfileListingDocument, options);
      }
export function useBankProfileListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BankProfileListingQuery, BankProfileListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BankProfileListingQuery, BankProfileListingQueryVariables>(BankProfileListingDocument, options);
        }
export type BankProfileListingQueryHookResult = ReturnType<typeof useBankProfileListingQuery>;
export type BankProfileListingLazyQueryHookResult = ReturnType<typeof useBankProfileListingLazyQuery>;
export type BankProfileListingQueryResult = Apollo.QueryResult<BankProfileListingQuery, BankProfileListingQueryVariables>;
export const GetBankProfileDocument = gql`
    query getBankProfile($companyId: String, $id: String, $commonStatus: String) {
  getBankProfile(companyId: $companyId, id: $id, commonStatus: $commonStatus) {
    id
    name
    phoneNo
    address
  }
}
    `;

/**
 * __useGetBankProfileQuery__
 *
 * To run a query within a React component, call `useGetBankProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBankProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBankProfileQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      id: // value for 'id'
 *      commonStatus: // value for 'commonStatus'
 *   },
 * });
 */
export function useGetBankProfileQuery(baseOptions?: Apollo.QueryHookOptions<GetBankProfileQuery, GetBankProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBankProfileQuery, GetBankProfileQueryVariables>(GetBankProfileDocument, options);
      }
export function useGetBankProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBankProfileQuery, GetBankProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBankProfileQuery, GetBankProfileQueryVariables>(GetBankProfileDocument, options);
        }
export type GetBankProfileQueryHookResult = ReturnType<typeof useGetBankProfileQuery>;
export type GetBankProfileLazyQueryHookResult = ReturnType<typeof useGetBankProfileLazyQuery>;
export type GetBankProfileQueryResult = Apollo.QueryResult<GetBankProfileQuery, GetBankProfileQueryVariables>;
export const DeleteCompanyBankProfileDocument = gql`
    mutation deleteCompanyBankProfile($companyId: String!, $bankId: String!) {
  deleteCompanyBankProfile(companyId: $companyId, bankId: $bankId)
}
    `;
export type DeleteCompanyBankProfileMutationFn = Apollo.MutationFunction<DeleteCompanyBankProfileMutation, DeleteCompanyBankProfileMutationVariables>;

/**
 * __useDeleteCompanyBankProfileMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyBankProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyBankProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanyBankProfileMutation, { data, loading, error }] = useDeleteCompanyBankProfileMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      bankId: // value for 'bankId'
 *   },
 * });
 */
export function useDeleteCompanyBankProfileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCompanyBankProfileMutation, DeleteCompanyBankProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCompanyBankProfileMutation, DeleteCompanyBankProfileMutationVariables>(DeleteCompanyBankProfileDocument, options);
      }
export type DeleteCompanyBankProfileMutationHookResult = ReturnType<typeof useDeleteCompanyBankProfileMutation>;
export type DeleteCompanyBankProfileMutationResult = Apollo.MutationResult<DeleteCompanyBankProfileMutation>;
export type DeleteCompanyBankProfileMutationOptions = Apollo.BaseMutationOptions<DeleteCompanyBankProfileMutation, DeleteCompanyBankProfileMutationVariables>;
export const EditCompanyBankProfileDocument = gql`
    mutation editCompanyBankProfile($input: editCompanyBankProfileInput!) {
  editCompanyBankProfile(input: $input)
}
    `;
export type EditCompanyBankProfileMutationFn = Apollo.MutationFunction<EditCompanyBankProfileMutation, EditCompanyBankProfileMutationVariables>;

/**
 * __useEditCompanyBankProfileMutation__
 *
 * To run a mutation, you first call `useEditCompanyBankProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCompanyBankProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCompanyBankProfileMutation, { data, loading, error }] = useEditCompanyBankProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditCompanyBankProfileMutation(baseOptions?: Apollo.MutationHookOptions<EditCompanyBankProfileMutation, EditCompanyBankProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCompanyBankProfileMutation, EditCompanyBankProfileMutationVariables>(EditCompanyBankProfileDocument, options);
      }
export type EditCompanyBankProfileMutationHookResult = ReturnType<typeof useEditCompanyBankProfileMutation>;
export type EditCompanyBankProfileMutationResult = Apollo.MutationResult<EditCompanyBankProfileMutation>;
export type EditCompanyBankProfileMutationOptions = Apollo.BaseMutationOptions<EditCompanyBankProfileMutation, EditCompanyBankProfileMutationVariables>;
export const GetProfileAndAccountListDocument = gql`
    query getProfileAndAccountList($companyId: String!, $bankProfileId: String!) {
  getProfileAndAccountList(companyId: $companyId, bankProfileId: $bankProfileId) {
    bankId
    bankName
    bankAddress
    bankPhoneNo
    bankAccounts {
      bankAccountId
      bankProfileId
      code
      accountType
      accountNo
      swiftCode
      currency
      effectiveDate
    }
  }
}
    `;

/**
 * __useGetProfileAndAccountListQuery__
 *
 * To run a query within a React component, call `useGetProfileAndAccountListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileAndAccountListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfileAndAccountListQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      bankProfileId: // value for 'bankProfileId'
 *   },
 * });
 */
export function useGetProfileAndAccountListQuery(baseOptions: Apollo.QueryHookOptions<GetProfileAndAccountListQuery, GetProfileAndAccountListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProfileAndAccountListQuery, GetProfileAndAccountListQueryVariables>(GetProfileAndAccountListDocument, options);
      }
export function useGetProfileAndAccountListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProfileAndAccountListQuery, GetProfileAndAccountListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProfileAndAccountListQuery, GetProfileAndAccountListQueryVariables>(GetProfileAndAccountListDocument, options);
        }
export type GetProfileAndAccountListQueryHookResult = ReturnType<typeof useGetProfileAndAccountListQuery>;
export type GetProfileAndAccountListLazyQueryHookResult = ReturnType<typeof useGetProfileAndAccountListLazyQuery>;
export type GetProfileAndAccountListQueryResult = Apollo.QueryResult<GetProfileAndAccountListQuery, GetProfileAndAccountListQueryVariables>;
export const GetAllMasterInfoDocument = gql`
    query GetAllMasterInfo {
  GetAllMasterInfo {
    CurrencyCode
    LandType
    UOM
    Tenures
    CommercialPurposes
    DiscountPrefix
  }
}
    `;

/**
 * __useGetAllMasterInfoQuery__
 *
 * To run a query within a React component, call `useGetAllMasterInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllMasterInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllMasterInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllMasterInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetAllMasterInfoQuery, GetAllMasterInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllMasterInfoQuery, GetAllMasterInfoQueryVariables>(GetAllMasterInfoDocument, options);
      }
export function useGetAllMasterInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllMasterInfoQuery, GetAllMasterInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllMasterInfoQuery, GetAllMasterInfoQueryVariables>(GetAllMasterInfoDocument, options);
        }
export type GetAllMasterInfoQueryHookResult = ReturnType<typeof useGetAllMasterInfoQuery>;
export type GetAllMasterInfoLazyQueryHookResult = ReturnType<typeof useGetAllMasterInfoLazyQuery>;
export type GetAllMasterInfoQueryResult = Apollo.QueryResult<GetAllMasterInfoQuery, GetAllMasterInfoQueryVariables>;
export const GetCommonSettingSummaryDocument = gql`
    query getCommonSettingSummary {
  statutoryDocsDate
  companyCount
  taxSetupCount
  stampDutyCount
  taxSchemeTotalCount
  purchaserIDTypeCount
  countryCodeCount
  billItemCount
  bankCount
  discountTypeCount
  discountCount
  archCertStagesCount
  paymentPlanCount
  purchaserPaymentPlanCount
  standardParameterDate
  standardELetteringTemplateDate
  approvalPolicyDate
  leadChannelCount
  reasonCodeCount
  currencyExchangeCount
  msicCodeCount
  classificationCodeCount
  notaryCount
  taxTransactionCodeCount
  unitOfMeasurementCount
}
    `;

/**
 * __useGetCommonSettingSummaryQuery__
 *
 * To run a query within a React component, call `useGetCommonSettingSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommonSettingSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommonSettingSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCommonSettingSummaryQuery(baseOptions?: Apollo.QueryHookOptions<GetCommonSettingSummaryQuery, GetCommonSettingSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommonSettingSummaryQuery, GetCommonSettingSummaryQueryVariables>(GetCommonSettingSummaryDocument, options);
      }
export function useGetCommonSettingSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommonSettingSummaryQuery, GetCommonSettingSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommonSettingSummaryQuery, GetCommonSettingSummaryQueryVariables>(GetCommonSettingSummaryDocument, options);
        }
export type GetCommonSettingSummaryQueryHookResult = ReturnType<typeof useGetCommonSettingSummaryQuery>;
export type GetCommonSettingSummaryLazyQueryHookResult = ReturnType<typeof useGetCommonSettingSummaryLazyQuery>;
export type GetCommonSettingSummaryQueryResult = Apollo.QueryResult<GetCommonSettingSummaryQuery, GetCommonSettingSummaryQueryVariables>;
export const CompanyListingDocument = gql`
    query companyListing {
  companyListing {
    id
    name
    imageUrl
    email
    officeTel
    recordStatus
    townshipCount
    bankProfileCount
    companyArAgingPolicy {
      period1
      period2
      period3
      period4
      period5
      period6
    }
  }
}
    `;

/**
 * __useCompanyListingQuery__
 *
 * To run a query within a React component, call `useCompanyListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyListingQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompanyListingQuery(baseOptions?: Apollo.QueryHookOptions<CompanyListingQuery, CompanyListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyListingQuery, CompanyListingQueryVariables>(CompanyListingDocument, options);
      }
export function useCompanyListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyListingQuery, CompanyListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyListingQuery, CompanyListingQueryVariables>(CompanyListingDocument, options);
        }
export type CompanyListingQueryHookResult = ReturnType<typeof useCompanyListingQuery>;
export type CompanyListingLazyQueryHookResult = ReturnType<typeof useCompanyListingLazyQuery>;
export type CompanyListingQueryResult = Apollo.QueryResult<CompanyListingQuery, CompanyListingQueryVariables>;
export const CompanyDetailDocument = gql`
    query companyDetail($id: String!) {
  companyDetail(id: $id) {
    id
    name
    imageUrl
    companyRegNo
    description
    email
    officeTel
    code
    address {
      address
      city
      state
      country
      postCode
    }
    groupGstRegNo
    gstNo
    sstNo
    companyLastUpdate
    bankLastUpdate
    townshipLastUpdate
    numberingStructureLastUpdate
    townshipCount
    bankProfileCount
    isDeletable
    recordStatus
  }
}
    `;

/**
 * __useCompanyDetailQuery__
 *
 * To run a query within a React component, call `useCompanyDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompanyDetailQuery(baseOptions: Apollo.QueryHookOptions<CompanyDetailQuery, CompanyDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyDetailQuery, CompanyDetailQueryVariables>(CompanyDetailDocument, options);
      }
export function useCompanyDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyDetailQuery, CompanyDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyDetailQuery, CompanyDetailQueryVariables>(CompanyDetailDocument, options);
        }
export type CompanyDetailQueryHookResult = ReturnType<typeof useCompanyDetailQuery>;
export type CompanyDetailLazyQueryHookResult = ReturnType<typeof useCompanyDetailLazyQuery>;
export type CompanyDetailQueryResult = Apollo.QueryResult<CompanyDetailQuery, CompanyDetailQueryVariables>;
export const AddCompanyDocument = gql`
    mutation addCompany($input: addCompanyInput!, $file: Upload!) {
  addCompany(input: $input, file: $file)
}
    `;
export type AddCompanyMutationFn = Apollo.MutationFunction<AddCompanyMutation, AddCompanyMutationVariables>;

/**
 * __useAddCompanyMutation__
 *
 * To run a mutation, you first call `useAddCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCompanyMutation, { data, loading, error }] = useAddCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useAddCompanyMutation(baseOptions?: Apollo.MutationHookOptions<AddCompanyMutation, AddCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCompanyMutation, AddCompanyMutationVariables>(AddCompanyDocument, options);
      }
export type AddCompanyMutationHookResult = ReturnType<typeof useAddCompanyMutation>;
export type AddCompanyMutationResult = Apollo.MutationResult<AddCompanyMutation>;
export type AddCompanyMutationOptions = Apollo.BaseMutationOptions<AddCompanyMutation, AddCompanyMutationVariables>;
export const EditCompanyDocument = gql`
    mutation editCompany($input: editCompanyInput!, $file: Upload) {
  editCompany(input: $input, file: $file)
}
    `;
export type EditCompanyMutationFn = Apollo.MutationFunction<EditCompanyMutation, EditCompanyMutationVariables>;

/**
 * __useEditCompanyMutation__
 *
 * To run a mutation, you first call `useEditCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCompanyMutation, { data, loading, error }] = useEditCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useEditCompanyMutation(baseOptions?: Apollo.MutationHookOptions<EditCompanyMutation, EditCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCompanyMutation, EditCompanyMutationVariables>(EditCompanyDocument, options);
      }
export type EditCompanyMutationHookResult = ReturnType<typeof useEditCompanyMutation>;
export type EditCompanyMutationResult = Apollo.MutationResult<EditCompanyMutation>;
export type EditCompanyMutationOptions = Apollo.BaseMutationOptions<EditCompanyMutation, EditCompanyMutationVariables>;
export const DeleteCompanyDocument = gql`
    mutation deleteCompany($companyId: String!) {
  deleteCompany(companyId: $companyId)
}
    `;
export type DeleteCompanyMutationFn = Apollo.MutationFunction<DeleteCompanyMutation, DeleteCompanyMutationVariables>;

/**
 * __useDeleteCompanyMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanyMutation, { data, loading, error }] = useDeleteCompanyMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useDeleteCompanyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCompanyMutation, DeleteCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCompanyMutation, DeleteCompanyMutationVariables>(DeleteCompanyDocument, options);
      }
export type DeleteCompanyMutationHookResult = ReturnType<typeof useDeleteCompanyMutation>;
export type DeleteCompanyMutationResult = Apollo.MutationResult<DeleteCompanyMutation>;
export type DeleteCompanyMutationOptions = Apollo.BaseMutationOptions<DeleteCompanyMutation, DeleteCompanyMutationVariables>;
export const ActivateCompanyDocument = gql`
    mutation activateCompany($companyId: String!) {
  activateCompany(companyId: $companyId)
}
    `;
export type ActivateCompanyMutationFn = Apollo.MutationFunction<ActivateCompanyMutation, ActivateCompanyMutationVariables>;

/**
 * __useActivateCompanyMutation__
 *
 * To run a mutation, you first call `useActivateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateCompanyMutation, { data, loading, error }] = useActivateCompanyMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useActivateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<ActivateCompanyMutation, ActivateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateCompanyMutation, ActivateCompanyMutationVariables>(ActivateCompanyDocument, options);
      }
export type ActivateCompanyMutationHookResult = ReturnType<typeof useActivateCompanyMutation>;
export type ActivateCompanyMutationResult = Apollo.MutationResult<ActivateCompanyMutation>;
export type ActivateCompanyMutationOptions = Apollo.BaseMutationOptions<ActivateCompanyMutation, ActivateCompanyMutationVariables>;
export const GetArAgingDocument = gql`
    query getArAging($companyId: String!) {
  getArAging(companyId: $companyId) {
    period1
    period2
    period3
    period4
    period5
    period6
  }
}
    `;

/**
 * __useGetArAgingQuery__
 *
 * To run a query within a React component, call `useGetArAgingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArAgingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArAgingQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetArAgingQuery(baseOptions: Apollo.QueryHookOptions<GetArAgingQuery, GetArAgingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArAgingQuery, GetArAgingQueryVariables>(GetArAgingDocument, options);
      }
export function useGetArAgingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArAgingQuery, GetArAgingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArAgingQuery, GetArAgingQueryVariables>(GetArAgingDocument, options);
        }
export type GetArAgingQueryHookResult = ReturnType<typeof useGetArAgingQuery>;
export type GetArAgingLazyQueryHookResult = ReturnType<typeof useGetArAgingLazyQuery>;
export type GetArAgingQueryResult = Apollo.QueryResult<GetArAgingQuery, GetArAgingQueryVariables>;
export const AddArAgingDocument = gql`
    mutation addArAging($input: addAccountReceivableAging!) {
  addArAging(input: $input)
}
    `;
export type AddArAgingMutationFn = Apollo.MutationFunction<AddArAgingMutation, AddArAgingMutationVariables>;

/**
 * __useAddArAgingMutation__
 *
 * To run a mutation, you first call `useAddArAgingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddArAgingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addArAgingMutation, { data, loading, error }] = useAddArAgingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddArAgingMutation(baseOptions?: Apollo.MutationHookOptions<AddArAgingMutation, AddArAgingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddArAgingMutation, AddArAgingMutationVariables>(AddArAgingDocument, options);
      }
export type AddArAgingMutationHookResult = ReturnType<typeof useAddArAgingMutation>;
export type AddArAgingMutationResult = Apollo.MutationResult<AddArAgingMutation>;
export type AddArAgingMutationOptions = Apollo.BaseMutationOptions<AddArAgingMutation, AddArAgingMutationVariables>;
export const AddCompanyBankProfileDocument = gql`
    mutation addCompanyBankProfile($inputBankProfile: addCompanyBankProfileInput!) {
  addCompanyBankProfile(inputBankProfile: $inputBankProfile)
}
    `;
export type AddCompanyBankProfileMutationFn = Apollo.MutationFunction<AddCompanyBankProfileMutation, AddCompanyBankProfileMutationVariables>;

/**
 * __useAddCompanyBankProfileMutation__
 *
 * To run a mutation, you first call `useAddCompanyBankProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCompanyBankProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCompanyBankProfileMutation, { data, loading, error }] = useAddCompanyBankProfileMutation({
 *   variables: {
 *      inputBankProfile: // value for 'inputBankProfile'
 *   },
 * });
 */
export function useAddCompanyBankProfileMutation(baseOptions?: Apollo.MutationHookOptions<AddCompanyBankProfileMutation, AddCompanyBankProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCompanyBankProfileMutation, AddCompanyBankProfileMutationVariables>(AddCompanyBankProfileDocument, options);
      }
export type AddCompanyBankProfileMutationHookResult = ReturnType<typeof useAddCompanyBankProfileMutation>;
export type AddCompanyBankProfileMutationResult = Apollo.MutationResult<AddCompanyBankProfileMutation>;
export type AddCompanyBankProfileMutationOptions = Apollo.BaseMutationOptions<AddCompanyBankProfileMutation, AddCompanyBankProfileMutationVariables>;
export const TownshipListingDocument = gql`
    query townshipListing($companyId: String!) {
  townshipListing(companyId: $companyId) {
    township {
      id
      name
      code
      location
      logoUrl
    }
  }
}
    `;

/**
 * __useTownshipListingQuery__
 *
 * To run a query within a React component, call `useTownshipListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useTownshipListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTownshipListingQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useTownshipListingQuery(baseOptions: Apollo.QueryHookOptions<TownshipListingQuery, TownshipListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TownshipListingQuery, TownshipListingQueryVariables>(TownshipListingDocument, options);
      }
export function useTownshipListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TownshipListingQuery, TownshipListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TownshipListingQuery, TownshipListingQueryVariables>(TownshipListingDocument, options);
        }
export type TownshipListingQueryHookResult = ReturnType<typeof useTownshipListingQuery>;
export type TownshipListingLazyQueryHookResult = ReturnType<typeof useTownshipListingLazyQuery>;
export type TownshipListingQueryResult = Apollo.QueryResult<TownshipListingQuery, TownshipListingQueryVariables>;
export const GetTownshipDocument = gql`
    query getTownship($companyId: String!, $commonStatus: String!) {
  getTownship(companyId: $companyId, commonStatus: $commonStatus) {
    id
    name
    code
    logoUrl
    location
  }
}
    `;

/**
 * __useGetTownshipQuery__
 *
 * To run a query within a React component, call `useGetTownshipQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTownshipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTownshipQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      commonStatus: // value for 'commonStatus'
 *   },
 * });
 */
export function useGetTownshipQuery(baseOptions: Apollo.QueryHookOptions<GetTownshipQuery, GetTownshipQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTownshipQuery, GetTownshipQueryVariables>(GetTownshipDocument, options);
      }
export function useGetTownshipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTownshipQuery, GetTownshipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTownshipQuery, GetTownshipQueryVariables>(GetTownshipDocument, options);
        }
export type GetTownshipQueryHookResult = ReturnType<typeof useGetTownshipQuery>;
export type GetTownshipLazyQueryHookResult = ReturnType<typeof useGetTownshipLazyQuery>;
export type GetTownshipQueryResult = Apollo.QueryResult<GetTownshipQuery, GetTownshipQueryVariables>;
export const DeleteTownshipDocument = gql`
    mutation deleteTownship($townshipId: String!, $companyId: String!) {
  deleteTownship(townshipId: $townshipId, companyId: $companyId)
}
    `;
export type DeleteTownshipMutationFn = Apollo.MutationFunction<DeleteTownshipMutation, DeleteTownshipMutationVariables>;

/**
 * __useDeleteTownshipMutation__
 *
 * To run a mutation, you first call `useDeleteTownshipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTownshipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTownshipMutation, { data, loading, error }] = useDeleteTownshipMutation({
 *   variables: {
 *      townshipId: // value for 'townshipId'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useDeleteTownshipMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTownshipMutation, DeleteTownshipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTownshipMutation, DeleteTownshipMutationVariables>(DeleteTownshipDocument, options);
      }
export type DeleteTownshipMutationHookResult = ReturnType<typeof useDeleteTownshipMutation>;
export type DeleteTownshipMutationResult = Apollo.MutationResult<DeleteTownshipMutation>;
export type DeleteTownshipMutationOptions = Apollo.BaseMutationOptions<DeleteTownshipMutation, DeleteTownshipMutationVariables>;
export const AddTownshipDocument = gql`
    mutation addTownship($input: addTownshipInput!) {
  addTownship(input: $input)
}
    `;
export type AddTownshipMutationFn = Apollo.MutationFunction<AddTownshipMutation, AddTownshipMutationVariables>;

/**
 * __useAddTownshipMutation__
 *
 * To run a mutation, you first call `useAddTownshipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTownshipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTownshipMutation, { data, loading, error }] = useAddTownshipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddTownshipMutation(baseOptions?: Apollo.MutationHookOptions<AddTownshipMutation, AddTownshipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTownshipMutation, AddTownshipMutationVariables>(AddTownshipDocument, options);
      }
export type AddTownshipMutationHookResult = ReturnType<typeof useAddTownshipMutation>;
export type AddTownshipMutationResult = Apollo.MutationResult<AddTownshipMutation>;
export type AddTownshipMutationOptions = Apollo.BaseMutationOptions<AddTownshipMutation, AddTownshipMutationVariables>;
export const EditTownshipDocument = gql`
    mutation editTownship($input: editTownshipInput!) {
  editTownship(input: $input)
}
    `;
export type EditTownshipMutationFn = Apollo.MutationFunction<EditTownshipMutation, EditTownshipMutationVariables>;

/**
 * __useEditTownshipMutation__
 *
 * To run a mutation, you first call `useEditTownshipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditTownshipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editTownshipMutation, { data, loading, error }] = useEditTownshipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditTownshipMutation(baseOptions?: Apollo.MutationHookOptions<EditTownshipMutation, EditTownshipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditTownshipMutation, EditTownshipMutationVariables>(EditTownshipDocument, options);
      }
export type EditTownshipMutationHookResult = ReturnType<typeof useEditTownshipMutation>;
export type EditTownshipMutationResult = Apollo.MutationResult<EditTownshipMutation>;
export type EditTownshipMutationOptions = Apollo.BaseMutationOptions<EditTownshipMutation, EditTownshipMutationVariables>;
export const GetCountryCodeListingDocument = gql`
    query getCountryCodeListing {
  getCountryCodeListing {
    id
    code
    name
  }
}
    `;

/**
 * __useGetCountryCodeListingQuery__
 *
 * To run a query within a React component, call `useGetCountryCodeListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountryCodeListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountryCodeListingQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCountryCodeListingQuery(baseOptions?: Apollo.QueryHookOptions<GetCountryCodeListingQuery, GetCountryCodeListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCountryCodeListingQuery, GetCountryCodeListingQueryVariables>(GetCountryCodeListingDocument, options);
      }
export function useGetCountryCodeListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCountryCodeListingQuery, GetCountryCodeListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCountryCodeListingQuery, GetCountryCodeListingQueryVariables>(GetCountryCodeListingDocument, options);
        }
export type GetCountryCodeListingQueryHookResult = ReturnType<typeof useGetCountryCodeListingQuery>;
export type GetCountryCodeListingLazyQueryHookResult = ReturnType<typeof useGetCountryCodeListingLazyQuery>;
export type GetCountryCodeListingQueryResult = Apollo.QueryResult<GetCountryCodeListingQuery, GetCountryCodeListingQueryVariables>;
export const GetCountryCodeByIdDocument = gql`
    query getCountryCodeById($id: String!) {
  getCountryCodeById(id: $id) {
    id
    code
    name
  }
}
    `;

/**
 * __useGetCountryCodeByIdQuery__
 *
 * To run a query within a React component, call `useGetCountryCodeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountryCodeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountryCodeByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCountryCodeByIdQuery(baseOptions: Apollo.QueryHookOptions<GetCountryCodeByIdQuery, GetCountryCodeByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCountryCodeByIdQuery, GetCountryCodeByIdQueryVariables>(GetCountryCodeByIdDocument, options);
      }
export function useGetCountryCodeByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCountryCodeByIdQuery, GetCountryCodeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCountryCodeByIdQuery, GetCountryCodeByIdQueryVariables>(GetCountryCodeByIdDocument, options);
        }
export type GetCountryCodeByIdQueryHookResult = ReturnType<typeof useGetCountryCodeByIdQuery>;
export type GetCountryCodeByIdLazyQueryHookResult = ReturnType<typeof useGetCountryCodeByIdLazyQuery>;
export type GetCountryCodeByIdQueryResult = Apollo.QueryResult<GetCountryCodeByIdQuery, GetCountryCodeByIdQueryVariables>;
export const AddCountryCodeDocument = gql`
    mutation addCountryCode($input: AddCountryCodeInput!) {
  addCountryCode(input: $input)
}
    `;
export type AddCountryCodeMutationFn = Apollo.MutationFunction<AddCountryCodeMutation, AddCountryCodeMutationVariables>;

/**
 * __useAddCountryCodeMutation__
 *
 * To run a mutation, you first call `useAddCountryCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCountryCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCountryCodeMutation, { data, loading, error }] = useAddCountryCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCountryCodeMutation(baseOptions?: Apollo.MutationHookOptions<AddCountryCodeMutation, AddCountryCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCountryCodeMutation, AddCountryCodeMutationVariables>(AddCountryCodeDocument, options);
      }
export type AddCountryCodeMutationHookResult = ReturnType<typeof useAddCountryCodeMutation>;
export type AddCountryCodeMutationResult = Apollo.MutationResult<AddCountryCodeMutation>;
export type AddCountryCodeMutationOptions = Apollo.BaseMutationOptions<AddCountryCodeMutation, AddCountryCodeMutationVariables>;
export const EditCountryCodeDocument = gql`
    mutation editCountryCode($input: EditCountryCodeInput!) {
  editCountryCode(input: $input)
}
    `;
export type EditCountryCodeMutationFn = Apollo.MutationFunction<EditCountryCodeMutation, EditCountryCodeMutationVariables>;

/**
 * __useEditCountryCodeMutation__
 *
 * To run a mutation, you first call `useEditCountryCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCountryCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCountryCodeMutation, { data, loading, error }] = useEditCountryCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditCountryCodeMutation(baseOptions?: Apollo.MutationHookOptions<EditCountryCodeMutation, EditCountryCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCountryCodeMutation, EditCountryCodeMutationVariables>(EditCountryCodeDocument, options);
      }
export type EditCountryCodeMutationHookResult = ReturnType<typeof useEditCountryCodeMutation>;
export type EditCountryCodeMutationResult = Apollo.MutationResult<EditCountryCodeMutation>;
export type EditCountryCodeMutationOptions = Apollo.BaseMutationOptions<EditCountryCodeMutation, EditCountryCodeMutationVariables>;
export const DeleteCountryCodeDocument = gql`
    mutation deleteCountryCode($id: String!) {
  deleteCountryCode(id: $id)
}
    `;
export type DeleteCountryCodeMutationFn = Apollo.MutationFunction<DeleteCountryCodeMutation, DeleteCountryCodeMutationVariables>;

/**
 * __useDeleteCountryCodeMutation__
 *
 * To run a mutation, you first call `useDeleteCountryCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCountryCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCountryCodeMutation, { data, loading, error }] = useDeleteCountryCodeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCountryCodeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCountryCodeMutation, DeleteCountryCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCountryCodeMutation, DeleteCountryCodeMutationVariables>(DeleteCountryCodeDocument, options);
      }
export type DeleteCountryCodeMutationHookResult = ReturnType<typeof useDeleteCountryCodeMutation>;
export type DeleteCountryCodeMutationResult = Apollo.MutationResult<DeleteCountryCodeMutation>;
export type DeleteCountryCodeMutationOptions = Apollo.BaseMutationOptions<DeleteCountryCodeMutation, DeleteCountryCodeMutationVariables>;
export const GetExchangeListDocument = gql`
    query getExchangeList {
  getExchangeList {
    id
    fromCurrencyCode
    toCurrencyCode
    fromAmt
    toAmt
    exchangeRate
    commonStatus
    isExistInTransactionData
  }
}
    `;

/**
 * __useGetExchangeListQuery__
 *
 * To run a query within a React component, call `useGetExchangeListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExchangeListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExchangeListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetExchangeListQuery(baseOptions?: Apollo.QueryHookOptions<GetExchangeListQuery, GetExchangeListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExchangeListQuery, GetExchangeListQueryVariables>(GetExchangeListDocument, options);
      }
export function useGetExchangeListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExchangeListQuery, GetExchangeListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExchangeListQuery, GetExchangeListQueryVariables>(GetExchangeListDocument, options);
        }
export type GetExchangeListQueryHookResult = ReturnType<typeof useGetExchangeListQuery>;
export type GetExchangeListLazyQueryHookResult = ReturnType<typeof useGetExchangeListLazyQuery>;
export type GetExchangeListQueryResult = Apollo.QueryResult<GetExchangeListQuery, GetExchangeListQueryVariables>;
export const GetExchangeByIdDocument = gql`
    query getExchangeById($id: String!) {
  getExchangeById(id: $id) {
    id
    fromCurrencyCode
    toCurrencyCode
    fromAmt
    toAmt
    exchangeRate
  }
}
    `;

/**
 * __useGetExchangeByIdQuery__
 *
 * To run a query within a React component, call `useGetExchangeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExchangeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExchangeByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetExchangeByIdQuery(baseOptions: Apollo.QueryHookOptions<GetExchangeByIdQuery, GetExchangeByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExchangeByIdQuery, GetExchangeByIdQueryVariables>(GetExchangeByIdDocument, options);
      }
export function useGetExchangeByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExchangeByIdQuery, GetExchangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExchangeByIdQuery, GetExchangeByIdQueryVariables>(GetExchangeByIdDocument, options);
        }
export type GetExchangeByIdQueryHookResult = ReturnType<typeof useGetExchangeByIdQuery>;
export type GetExchangeByIdLazyQueryHookResult = ReturnType<typeof useGetExchangeByIdLazyQuery>;
export type GetExchangeByIdQueryResult = Apollo.QueryResult<GetExchangeByIdQuery, GetExchangeByIdQueryVariables>;
export const AddExchangeRateDocument = gql`
    mutation addExchangeRate($input: currencyExchangeRateInput!) {
  addExchangeRate(input: $input)
}
    `;
export type AddExchangeRateMutationFn = Apollo.MutationFunction<AddExchangeRateMutation, AddExchangeRateMutationVariables>;

/**
 * __useAddExchangeRateMutation__
 *
 * To run a mutation, you first call `useAddExchangeRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddExchangeRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addExchangeRateMutation, { data, loading, error }] = useAddExchangeRateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddExchangeRateMutation(baseOptions?: Apollo.MutationHookOptions<AddExchangeRateMutation, AddExchangeRateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddExchangeRateMutation, AddExchangeRateMutationVariables>(AddExchangeRateDocument, options);
      }
export type AddExchangeRateMutationHookResult = ReturnType<typeof useAddExchangeRateMutation>;
export type AddExchangeRateMutationResult = Apollo.MutationResult<AddExchangeRateMutation>;
export type AddExchangeRateMutationOptions = Apollo.BaseMutationOptions<AddExchangeRateMutation, AddExchangeRateMutationVariables>;
export const EditExchangeRateDocument = gql`
    mutation editExchangeRate($input: currencyExchangeRateEditInput!) {
  editExchangeRate(input: $input)
}
    `;
export type EditExchangeRateMutationFn = Apollo.MutationFunction<EditExchangeRateMutation, EditExchangeRateMutationVariables>;

/**
 * __useEditExchangeRateMutation__
 *
 * To run a mutation, you first call `useEditExchangeRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditExchangeRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editExchangeRateMutation, { data, loading, error }] = useEditExchangeRateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditExchangeRateMutation(baseOptions?: Apollo.MutationHookOptions<EditExchangeRateMutation, EditExchangeRateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditExchangeRateMutation, EditExchangeRateMutationVariables>(EditExchangeRateDocument, options);
      }
export type EditExchangeRateMutationHookResult = ReturnType<typeof useEditExchangeRateMutation>;
export type EditExchangeRateMutationResult = Apollo.MutationResult<EditExchangeRateMutation>;
export type EditExchangeRateMutationOptions = Apollo.BaseMutationOptions<EditExchangeRateMutation, EditExchangeRateMutationVariables>;
export const DeleteExchangeRateDocument = gql`
    mutation deleteExchangeRate($id: String!) {
  deleteExchangeRate(id: $id)
}
    `;
export type DeleteExchangeRateMutationFn = Apollo.MutationFunction<DeleteExchangeRateMutation, DeleteExchangeRateMutationVariables>;

/**
 * __useDeleteExchangeRateMutation__
 *
 * To run a mutation, you first call `useDeleteExchangeRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExchangeRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExchangeRateMutation, { data, loading, error }] = useDeleteExchangeRateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteExchangeRateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteExchangeRateMutation, DeleteExchangeRateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteExchangeRateMutation, DeleteExchangeRateMutationVariables>(DeleteExchangeRateDocument, options);
      }
export type DeleteExchangeRateMutationHookResult = ReturnType<typeof useDeleteExchangeRateMutation>;
export type DeleteExchangeRateMutationResult = Apollo.MutationResult<DeleteExchangeRateMutation>;
export type DeleteExchangeRateMutationOptions = Apollo.BaseMutationOptions<DeleteExchangeRateMutation, DeleteExchangeRateMutationVariables>;
export const GetExchangeListByCodeDocument = gql`
    query getExchangeListByCode {
  getExchangeListByCode {
    id
    fromCurrencyCode
    toCurrencyCode
    fromAmt
    toAmt
    exchangeRate
  }
}
    `;

/**
 * __useGetExchangeListByCodeQuery__
 *
 * To run a query within a React component, call `useGetExchangeListByCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExchangeListByCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExchangeListByCodeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetExchangeListByCodeQuery(baseOptions?: Apollo.QueryHookOptions<GetExchangeListByCodeQuery, GetExchangeListByCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExchangeListByCodeQuery, GetExchangeListByCodeQueryVariables>(GetExchangeListByCodeDocument, options);
      }
export function useGetExchangeListByCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExchangeListByCodeQuery, GetExchangeListByCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExchangeListByCodeQuery, GetExchangeListByCodeQueryVariables>(GetExchangeListByCodeDocument, options);
        }
export type GetExchangeListByCodeQueryHookResult = ReturnType<typeof useGetExchangeListByCodeQuery>;
export type GetExchangeListByCodeLazyQueryHookResult = ReturnType<typeof useGetExchangeListByCodeLazyQuery>;
export type GetExchangeListByCodeQueryResult = Apollo.QueryResult<GetExchangeListByCodeQuery, GetExchangeListByCodeQueryVariables>;
export const ActivateCurrencyExchangeDocument = gql`
    mutation activateCurrencyExchange($currencyExchangeId: String!) {
  activateCurrencyExchange(currencyExchangeId: $currencyExchangeId)
}
    `;
export type ActivateCurrencyExchangeMutationFn = Apollo.MutationFunction<ActivateCurrencyExchangeMutation, ActivateCurrencyExchangeMutationVariables>;

/**
 * __useActivateCurrencyExchangeMutation__
 *
 * To run a mutation, you first call `useActivateCurrencyExchangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateCurrencyExchangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateCurrencyExchangeMutation, { data, loading, error }] = useActivateCurrencyExchangeMutation({
 *   variables: {
 *      currencyExchangeId: // value for 'currencyExchangeId'
 *   },
 * });
 */
export function useActivateCurrencyExchangeMutation(baseOptions?: Apollo.MutationHookOptions<ActivateCurrencyExchangeMutation, ActivateCurrencyExchangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateCurrencyExchangeMutation, ActivateCurrencyExchangeMutationVariables>(ActivateCurrencyExchangeDocument, options);
      }
export type ActivateCurrencyExchangeMutationHookResult = ReturnType<typeof useActivateCurrencyExchangeMutation>;
export type ActivateCurrencyExchangeMutationResult = Apollo.MutationResult<ActivateCurrencyExchangeMutation>;
export type ActivateCurrencyExchangeMutationOptions = Apollo.BaseMutationOptions<ActivateCurrencyExchangeMutation, ActivateCurrencyExchangeMutationVariables>;
export const DeactivateCurrencyExchangeDocument = gql`
    mutation deactivateCurrencyExchange($currencyExchangeId: String!) {
  deactivateCurrencyExchange(currencyExchangeId: $currencyExchangeId)
}
    `;
export type DeactivateCurrencyExchangeMutationFn = Apollo.MutationFunction<DeactivateCurrencyExchangeMutation, DeactivateCurrencyExchangeMutationVariables>;

/**
 * __useDeactivateCurrencyExchangeMutation__
 *
 * To run a mutation, you first call `useDeactivateCurrencyExchangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateCurrencyExchangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateCurrencyExchangeMutation, { data, loading, error }] = useDeactivateCurrencyExchangeMutation({
 *   variables: {
 *      currencyExchangeId: // value for 'currencyExchangeId'
 *   },
 * });
 */
export function useDeactivateCurrencyExchangeMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateCurrencyExchangeMutation, DeactivateCurrencyExchangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateCurrencyExchangeMutation, DeactivateCurrencyExchangeMutationVariables>(DeactivateCurrencyExchangeDocument, options);
      }
export type DeactivateCurrencyExchangeMutationHookResult = ReturnType<typeof useDeactivateCurrencyExchangeMutation>;
export type DeactivateCurrencyExchangeMutationResult = Apollo.MutationResult<DeactivateCurrencyExchangeMutation>;
export type DeactivateCurrencyExchangeMutationOptions = Apollo.BaseMutationOptions<DeactivateCurrencyExchangeMutation, DeactivateCurrencyExchangeMutationVariables>;
export const GetAllDiscountDocument = gql`
    query getAllDiscount {
  getAllDiscount {
    title
    id
    description
    formula
    discountTypeId
    discountVal
    isIntegrated
    prefix
    isExistInMasterData
    isExistInTransactionData
    commonStatus
  }
}
    `;

/**
 * __useGetAllDiscountQuery__
 *
 * To run a query within a React component, call `useGetAllDiscountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllDiscountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllDiscountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllDiscountQuery(baseOptions?: Apollo.QueryHookOptions<GetAllDiscountQuery, GetAllDiscountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllDiscountQuery, GetAllDiscountQueryVariables>(GetAllDiscountDocument, options);
      }
export function useGetAllDiscountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllDiscountQuery, GetAllDiscountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllDiscountQuery, GetAllDiscountQueryVariables>(GetAllDiscountDocument, options);
        }
export type GetAllDiscountQueryHookResult = ReturnType<typeof useGetAllDiscountQuery>;
export type GetAllDiscountLazyQueryHookResult = ReturnType<typeof useGetAllDiscountLazyQuery>;
export type GetAllDiscountQueryResult = Apollo.QueryResult<GetAllDiscountQuery, GetAllDiscountQueryVariables>;
export const GetDiscountByIdDocument = gql`
    query getDiscountById($discountId: String!) {
  getDiscountById(discountId: $discountId) {
    title
    formula
    id
    discountTypeId
    prefix
    description
    discountVal
    isIntegrated
  }
  GetAllMasterInfo {
    DiscountType {
      id
      name
    }
    DiscountPrefix
  }
}
    `;

/**
 * __useGetDiscountByIdQuery__
 *
 * To run a query within a React component, call `useGetDiscountByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiscountByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiscountByIdQuery({
 *   variables: {
 *      discountId: // value for 'discountId'
 *   },
 * });
 */
export function useGetDiscountByIdQuery(baseOptions: Apollo.QueryHookOptions<GetDiscountByIdQuery, GetDiscountByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDiscountByIdQuery, GetDiscountByIdQueryVariables>(GetDiscountByIdDocument, options);
      }
export function useGetDiscountByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDiscountByIdQuery, GetDiscountByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDiscountByIdQuery, GetDiscountByIdQueryVariables>(GetDiscountByIdDocument, options);
        }
export type GetDiscountByIdQueryHookResult = ReturnType<typeof useGetDiscountByIdQuery>;
export type GetDiscountByIdLazyQueryHookResult = ReturnType<typeof useGetDiscountByIdLazyQuery>;
export type GetDiscountByIdQueryResult = Apollo.QueryResult<GetDiscountByIdQuery, GetDiscountByIdQueryVariables>;
export const AddDiscountDocument = gql`
    mutation addDiscount($input: DiscountInput!) {
  addDiscount(input: $input)
}
    `;
export type AddDiscountMutationFn = Apollo.MutationFunction<AddDiscountMutation, AddDiscountMutationVariables>;

/**
 * __useAddDiscountMutation__
 *
 * To run a mutation, you first call `useAddDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDiscountMutation, { data, loading, error }] = useAddDiscountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddDiscountMutation(baseOptions?: Apollo.MutationHookOptions<AddDiscountMutation, AddDiscountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDiscountMutation, AddDiscountMutationVariables>(AddDiscountDocument, options);
      }
export type AddDiscountMutationHookResult = ReturnType<typeof useAddDiscountMutation>;
export type AddDiscountMutationResult = Apollo.MutationResult<AddDiscountMutation>;
export type AddDiscountMutationOptions = Apollo.BaseMutationOptions<AddDiscountMutation, AddDiscountMutationVariables>;
export const EditDiscountDocument = gql`
    mutation editDiscount($input: EditDiscountInput!) {
  editDiscount(input: $input)
}
    `;
export type EditDiscountMutationFn = Apollo.MutationFunction<EditDiscountMutation, EditDiscountMutationVariables>;

/**
 * __useEditDiscountMutation__
 *
 * To run a mutation, you first call `useEditDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editDiscountMutation, { data, loading, error }] = useEditDiscountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditDiscountMutation(baseOptions?: Apollo.MutationHookOptions<EditDiscountMutation, EditDiscountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditDiscountMutation, EditDiscountMutationVariables>(EditDiscountDocument, options);
      }
export type EditDiscountMutationHookResult = ReturnType<typeof useEditDiscountMutation>;
export type EditDiscountMutationResult = Apollo.MutationResult<EditDiscountMutation>;
export type EditDiscountMutationOptions = Apollo.BaseMutationOptions<EditDiscountMutation, EditDiscountMutationVariables>;
export const DeleteDiscountDocument = gql`
    mutation deleteDiscount($discountId: String!, $isDeletable: Boolean!) {
  deleteDiscount(discountId: $discountId, isDeletable: $isDeletable)
}
    `;
export type DeleteDiscountMutationFn = Apollo.MutationFunction<DeleteDiscountMutation, DeleteDiscountMutationVariables>;

/**
 * __useDeleteDiscountMutation__
 *
 * To run a mutation, you first call `useDeleteDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDiscountMutation, { data, loading, error }] = useDeleteDiscountMutation({
 *   variables: {
 *      discountId: // value for 'discountId'
 *      isDeletable: // value for 'isDeletable'
 *   },
 * });
 */
export function useDeleteDiscountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDiscountMutation, DeleteDiscountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDiscountMutation, DeleteDiscountMutationVariables>(DeleteDiscountDocument, options);
      }
export type DeleteDiscountMutationHookResult = ReturnType<typeof useDeleteDiscountMutation>;
export type DeleteDiscountMutationResult = Apollo.MutationResult<DeleteDiscountMutation>;
export type DeleteDiscountMutationOptions = Apollo.BaseMutationOptions<DeleteDiscountMutation, DeleteDiscountMutationVariables>;
export const ActiveDiscountDocument = gql`
    mutation activeDiscount($discountId: String!) {
  activeDiscount(discountId: $discountId)
}
    `;
export type ActiveDiscountMutationFn = Apollo.MutationFunction<ActiveDiscountMutation, ActiveDiscountMutationVariables>;

/**
 * __useActiveDiscountMutation__
 *
 * To run a mutation, you first call `useActiveDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActiveDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activeDiscountMutation, { data, loading, error }] = useActiveDiscountMutation({
 *   variables: {
 *      discountId: // value for 'discountId'
 *   },
 * });
 */
export function useActiveDiscountMutation(baseOptions?: Apollo.MutationHookOptions<ActiveDiscountMutation, ActiveDiscountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActiveDiscountMutation, ActiveDiscountMutationVariables>(ActiveDiscountDocument, options);
      }
export type ActiveDiscountMutationHookResult = ReturnType<typeof useActiveDiscountMutation>;
export type ActiveDiscountMutationResult = Apollo.MutationResult<ActiveDiscountMutation>;
export type ActiveDiscountMutationOptions = Apollo.BaseMutationOptions<ActiveDiscountMutation, ActiveDiscountMutationVariables>;
export const GetAllDiscountTypeDocument = gql`
    query getAllDiscountType {
  getAllDiscountType {
    id
    name
    systemUse
    isExistInMasterData
  }
}
    `;

/**
 * __useGetAllDiscountTypeQuery__
 *
 * To run a query within a React component, call `useGetAllDiscountTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllDiscountTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllDiscountTypeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllDiscountTypeQuery(baseOptions?: Apollo.QueryHookOptions<GetAllDiscountTypeQuery, GetAllDiscountTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllDiscountTypeQuery, GetAllDiscountTypeQueryVariables>(GetAllDiscountTypeDocument, options);
      }
export function useGetAllDiscountTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllDiscountTypeQuery, GetAllDiscountTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllDiscountTypeQuery, GetAllDiscountTypeQueryVariables>(GetAllDiscountTypeDocument, options);
        }
export type GetAllDiscountTypeQueryHookResult = ReturnType<typeof useGetAllDiscountTypeQuery>;
export type GetAllDiscountTypeLazyQueryHookResult = ReturnType<typeof useGetAllDiscountTypeLazyQuery>;
export type GetAllDiscountTypeQueryResult = Apollo.QueryResult<GetAllDiscountTypeQuery, GetAllDiscountTypeQueryVariables>;
export const AddDiscountTypeDocument = gql`
    mutation addDiscountType($input: DiscountTypeInput!) {
  addDiscountType(input: $input)
}
    `;
export type AddDiscountTypeMutationFn = Apollo.MutationFunction<AddDiscountTypeMutation, AddDiscountTypeMutationVariables>;

/**
 * __useAddDiscountTypeMutation__
 *
 * To run a mutation, you first call `useAddDiscountTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDiscountTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDiscountTypeMutation, { data, loading, error }] = useAddDiscountTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddDiscountTypeMutation(baseOptions?: Apollo.MutationHookOptions<AddDiscountTypeMutation, AddDiscountTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDiscountTypeMutation, AddDiscountTypeMutationVariables>(AddDiscountTypeDocument, options);
      }
export type AddDiscountTypeMutationHookResult = ReturnType<typeof useAddDiscountTypeMutation>;
export type AddDiscountTypeMutationResult = Apollo.MutationResult<AddDiscountTypeMutation>;
export type AddDiscountTypeMutationOptions = Apollo.BaseMutationOptions<AddDiscountTypeMutation, AddDiscountTypeMutationVariables>;
export const EditDiscountTypeDocument = gql`
    mutation editDiscountType($input: EditDiscountTypeInput!) {
  editDiscountType(input: $input)
}
    `;
export type EditDiscountTypeMutationFn = Apollo.MutationFunction<EditDiscountTypeMutation, EditDiscountTypeMutationVariables>;

/**
 * __useEditDiscountTypeMutation__
 *
 * To run a mutation, you first call `useEditDiscountTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditDiscountTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editDiscountTypeMutation, { data, loading, error }] = useEditDiscountTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditDiscountTypeMutation(baseOptions?: Apollo.MutationHookOptions<EditDiscountTypeMutation, EditDiscountTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditDiscountTypeMutation, EditDiscountTypeMutationVariables>(EditDiscountTypeDocument, options);
      }
export type EditDiscountTypeMutationHookResult = ReturnType<typeof useEditDiscountTypeMutation>;
export type EditDiscountTypeMutationResult = Apollo.MutationResult<EditDiscountTypeMutation>;
export type EditDiscountTypeMutationOptions = Apollo.BaseMutationOptions<EditDiscountTypeMutation, EditDiscountTypeMutationVariables>;
export const DeleteDiscountTypeByIdDocument = gql`
    mutation deleteDiscountTypeById($discountTypeId: String!) {
  deleteDiscountTypeById(discountTypeId: $discountTypeId)
}
    `;
export type DeleteDiscountTypeByIdMutationFn = Apollo.MutationFunction<DeleteDiscountTypeByIdMutation, DeleteDiscountTypeByIdMutationVariables>;

/**
 * __useDeleteDiscountTypeByIdMutation__
 *
 * To run a mutation, you first call `useDeleteDiscountTypeByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDiscountTypeByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDiscountTypeByIdMutation, { data, loading, error }] = useDeleteDiscountTypeByIdMutation({
 *   variables: {
 *      discountTypeId: // value for 'discountTypeId'
 *   },
 * });
 */
export function useDeleteDiscountTypeByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDiscountTypeByIdMutation, DeleteDiscountTypeByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDiscountTypeByIdMutation, DeleteDiscountTypeByIdMutationVariables>(DeleteDiscountTypeByIdDocument, options);
      }
export type DeleteDiscountTypeByIdMutationHookResult = ReturnType<typeof useDeleteDiscountTypeByIdMutation>;
export type DeleteDiscountTypeByIdMutationResult = Apollo.MutationResult<DeleteDiscountTypeByIdMutation>;
export type DeleteDiscountTypeByIdMutationOptions = Apollo.BaseMutationOptions<DeleteDiscountTypeByIdMutation, DeleteDiscountTypeByIdMutationVariables>;
export const GetStandardLetterParameterDocument = gql`
    query getStandardLetterParameter($standardLetterId: String!) {
  getStandardLetterParameter(standardLetterId: $standardLetterId) {
    id
    accountId
    standardLetterId
    displayName
    columnName
    commonStatus
  }
}
    `;

/**
 * __useGetStandardLetterParameterQuery__
 *
 * To run a query within a React component, call `useGetStandardLetterParameterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStandardLetterParameterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStandardLetterParameterQuery({
 *   variables: {
 *      standardLetterId: // value for 'standardLetterId'
 *   },
 * });
 */
export function useGetStandardLetterParameterQuery(baseOptions: Apollo.QueryHookOptions<GetStandardLetterParameterQuery, GetStandardLetterParameterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStandardLetterParameterQuery, GetStandardLetterParameterQueryVariables>(GetStandardLetterParameterDocument, options);
      }
export function useGetStandardLetterParameterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStandardLetterParameterQuery, GetStandardLetterParameterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStandardLetterParameterQuery, GetStandardLetterParameterQueryVariables>(GetStandardLetterParameterDocument, options);
        }
export type GetStandardLetterParameterQueryHookResult = ReturnType<typeof useGetStandardLetterParameterQuery>;
export type GetStandardLetterParameterLazyQueryHookResult = ReturnType<typeof useGetStandardLetterParameterLazyQuery>;
export type GetStandardLetterParameterQueryResult = Apollo.QueryResult<GetStandardLetterParameterQuery, GetStandardLetterParameterQueryVariables>;
export const GetLetterTemplateListingDocument = gql`
    query getLetterTemplateListing($standardLetterId: String!) {
  getLetterTemplateListing(standardLetterId: $standardLetterId) {
    id
    standardLetterId
    name
    modTs
    standardLetter {
      name
    }
    slDataSource {
      id
      version
    }
    isReportDesignEditor
    defaulted
    standardLetterDataSourceVersion
  }
}
    `;

/**
 * __useGetLetterTemplateListingQuery__
 *
 * To run a query within a React component, call `useGetLetterTemplateListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLetterTemplateListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLetterTemplateListingQuery({
 *   variables: {
 *      standardLetterId: // value for 'standardLetterId'
 *   },
 * });
 */
export function useGetLetterTemplateListingQuery(baseOptions: Apollo.QueryHookOptions<GetLetterTemplateListingQuery, GetLetterTemplateListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLetterTemplateListingQuery, GetLetterTemplateListingQueryVariables>(GetLetterTemplateListingDocument, options);
      }
export function useGetLetterTemplateListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLetterTemplateListingQuery, GetLetterTemplateListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLetterTemplateListingQuery, GetLetterTemplateListingQueryVariables>(GetLetterTemplateListingDocument, options);
        }
export type GetLetterTemplateListingQueryHookResult = ReturnType<typeof useGetLetterTemplateListingQuery>;
export type GetLetterTemplateListingLazyQueryHookResult = ReturnType<typeof useGetLetterTemplateListingLazyQuery>;
export type GetLetterTemplateListingQueryResult = Apollo.QueryResult<GetLetterTemplateListingQuery, GetLetterTemplateListingQueryVariables>;
export const GetLetterTemplateStdLtrParameterIdDocument = gql`
    query getLetterTemplateStdLtrParameterId($standardLetterParameterId: String!) {
  getLetterTemplateByStdLtrParameterId(standardLetterParameterId: $standardLetterParameterId) {
    id
    name
    templateBody
    jointBuyerSignRequired
    commonStatus
    createdTs
    modTs
  }
}
    `;

/**
 * __useGetLetterTemplateStdLtrParameterIdQuery__
 *
 * To run a query within a React component, call `useGetLetterTemplateStdLtrParameterIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLetterTemplateStdLtrParameterIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLetterTemplateStdLtrParameterIdQuery({
 *   variables: {
 *      standardLetterParameterId: // value for 'standardLetterParameterId'
 *   },
 * });
 */
export function useGetLetterTemplateStdLtrParameterIdQuery(baseOptions: Apollo.QueryHookOptions<GetLetterTemplateStdLtrParameterIdQuery, GetLetterTemplateStdLtrParameterIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLetterTemplateStdLtrParameterIdQuery, GetLetterTemplateStdLtrParameterIdQueryVariables>(GetLetterTemplateStdLtrParameterIdDocument, options);
      }
export function useGetLetterTemplateStdLtrParameterIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLetterTemplateStdLtrParameterIdQuery, GetLetterTemplateStdLtrParameterIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLetterTemplateStdLtrParameterIdQuery, GetLetterTemplateStdLtrParameterIdQueryVariables>(GetLetterTemplateStdLtrParameterIdDocument, options);
        }
export type GetLetterTemplateStdLtrParameterIdQueryHookResult = ReturnType<typeof useGetLetterTemplateStdLtrParameterIdQuery>;
export type GetLetterTemplateStdLtrParameterIdLazyQueryHookResult = ReturnType<typeof useGetLetterTemplateStdLtrParameterIdLazyQuery>;
export type GetLetterTemplateStdLtrParameterIdQueryResult = Apollo.QueryResult<GetLetterTemplateStdLtrParameterIdQuery, GetLetterTemplateStdLtrParameterIdQueryVariables>;
export const GetLetterTemplateByIdDocument = gql`
    query getLetterTemplateByID($letterTemplateID: String!) {
  getLetterTemplateById(letterTemplateId: $letterTemplateID) {
    id
    standardLetterId
    name
    templateBody
    jointBuyerSignRequired
    isReportDesignEditor
  }
}
    `;

/**
 * __useGetLetterTemplateByIdQuery__
 *
 * To run a query within a React component, call `useGetLetterTemplateByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLetterTemplateByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLetterTemplateByIdQuery({
 *   variables: {
 *      letterTemplateID: // value for 'letterTemplateID'
 *   },
 * });
 */
export function useGetLetterTemplateByIdQuery(baseOptions: Apollo.QueryHookOptions<GetLetterTemplateByIdQuery, GetLetterTemplateByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLetterTemplateByIdQuery, GetLetterTemplateByIdQueryVariables>(GetLetterTemplateByIdDocument, options);
      }
export function useGetLetterTemplateByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLetterTemplateByIdQuery, GetLetterTemplateByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLetterTemplateByIdQuery, GetLetterTemplateByIdQueryVariables>(GetLetterTemplateByIdDocument, options);
        }
export type GetLetterTemplateByIdQueryHookResult = ReturnType<typeof useGetLetterTemplateByIdQuery>;
export type GetLetterTemplateByIdLazyQueryHookResult = ReturnType<typeof useGetLetterTemplateByIdLazyQuery>;
export type GetLetterTemplateByIdQueryResult = Apollo.QueryResult<GetLetterTemplateByIdQuery, GetLetterTemplateByIdQueryVariables>;
export const AddLetterTemplateDocument = gql`
    mutation addLetterTemplate($input: LetterTemplateInput!) {
  addLetterTemplate(input: $input)
}
    `;
export type AddLetterTemplateMutationFn = Apollo.MutationFunction<AddLetterTemplateMutation, AddLetterTemplateMutationVariables>;

/**
 * __useAddLetterTemplateMutation__
 *
 * To run a mutation, you first call `useAddLetterTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLetterTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLetterTemplateMutation, { data, loading, error }] = useAddLetterTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddLetterTemplateMutation(baseOptions?: Apollo.MutationHookOptions<AddLetterTemplateMutation, AddLetterTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddLetterTemplateMutation, AddLetterTemplateMutationVariables>(AddLetterTemplateDocument, options);
      }
export type AddLetterTemplateMutationHookResult = ReturnType<typeof useAddLetterTemplateMutation>;
export type AddLetterTemplateMutationResult = Apollo.MutationResult<AddLetterTemplateMutation>;
export type AddLetterTemplateMutationOptions = Apollo.BaseMutationOptions<AddLetterTemplateMutation, AddLetterTemplateMutationVariables>;
export const EditLetterTemplateDocument = gql`
    mutation editLetterTemplate($input: EditLetterTemplateInput!) {
  editLetterTemplate(input: $input)
}
    `;
export type EditLetterTemplateMutationFn = Apollo.MutationFunction<EditLetterTemplateMutation, EditLetterTemplateMutationVariables>;

/**
 * __useEditLetterTemplateMutation__
 *
 * To run a mutation, you first call `useEditLetterTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditLetterTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editLetterTemplateMutation, { data, loading, error }] = useEditLetterTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditLetterTemplateMutation(baseOptions?: Apollo.MutationHookOptions<EditLetterTemplateMutation, EditLetterTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditLetterTemplateMutation, EditLetterTemplateMutationVariables>(EditLetterTemplateDocument, options);
      }
export type EditLetterTemplateMutationHookResult = ReturnType<typeof useEditLetterTemplateMutation>;
export type EditLetterTemplateMutationResult = Apollo.MutationResult<EditLetterTemplateMutation>;
export type EditLetterTemplateMutationOptions = Apollo.BaseMutationOptions<EditLetterTemplateMutation, EditLetterTemplateMutationVariables>;
export const DeleteLetterTemplateByIdDocument = gql`
    mutation deleteLetterTemplateById($letterTemplateID: String!) {
  deleteLetterTemplateById(letterTemplateId: $letterTemplateID)
}
    `;
export type DeleteLetterTemplateByIdMutationFn = Apollo.MutationFunction<DeleteLetterTemplateByIdMutation, DeleteLetterTemplateByIdMutationVariables>;

/**
 * __useDeleteLetterTemplateByIdMutation__
 *
 * To run a mutation, you first call `useDeleteLetterTemplateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLetterTemplateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLetterTemplateByIdMutation, { data, loading, error }] = useDeleteLetterTemplateByIdMutation({
 *   variables: {
 *      letterTemplateID: // value for 'letterTemplateID'
 *   },
 * });
 */
export function useDeleteLetterTemplateByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLetterTemplateByIdMutation, DeleteLetterTemplateByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLetterTemplateByIdMutation, DeleteLetterTemplateByIdMutationVariables>(DeleteLetterTemplateByIdDocument, options);
      }
export type DeleteLetterTemplateByIdMutationHookResult = ReturnType<typeof useDeleteLetterTemplateByIdMutation>;
export type DeleteLetterTemplateByIdMutationResult = Apollo.MutationResult<DeleteLetterTemplateByIdMutation>;
export type DeleteLetterTemplateByIdMutationOptions = Apollo.BaseMutationOptions<DeleteLetterTemplateByIdMutation, DeleteLetterTemplateByIdMutationVariables>;
export const DesignLetterTemplateDocument = gql`
    mutation designLetterTemplate($input: DesignLetterTemplateInput!) {
  designLetterTemplate(input: $input)
}
    `;
export type DesignLetterTemplateMutationFn = Apollo.MutationFunction<DesignLetterTemplateMutation, DesignLetterTemplateMutationVariables>;

/**
 * __useDesignLetterTemplateMutation__
 *
 * To run a mutation, you first call `useDesignLetterTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDesignLetterTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [designLetterTemplateMutation, { data, loading, error }] = useDesignLetterTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDesignLetterTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DesignLetterTemplateMutation, DesignLetterTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DesignLetterTemplateMutation, DesignLetterTemplateMutationVariables>(DesignLetterTemplateDocument, options);
      }
export type DesignLetterTemplateMutationHookResult = ReturnType<typeof useDesignLetterTemplateMutation>;
export type DesignLetterTemplateMutationResult = Apollo.MutationResult<DesignLetterTemplateMutation>;
export type DesignLetterTemplateMutationOptions = Apollo.BaseMutationOptions<DesignLetterTemplateMutation, DesignLetterTemplateMutationVariables>;
export const LetterTemplateRebuildReportDocument = gql`
    mutation letterTemplateRebuildReport($id: String!, $sldsId: String!) {
  letterTemplateRebuildReport(id: $id, sldsId: $sldsId)
}
    `;
export type LetterTemplateRebuildReportMutationFn = Apollo.MutationFunction<LetterTemplateRebuildReportMutation, LetterTemplateRebuildReportMutationVariables>;

/**
 * __useLetterTemplateRebuildReportMutation__
 *
 * To run a mutation, you first call `useLetterTemplateRebuildReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLetterTemplateRebuildReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [letterTemplateRebuildReportMutation, { data, loading, error }] = useLetterTemplateRebuildReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *      sldsId: // value for 'sldsId'
 *   },
 * });
 */
export function useLetterTemplateRebuildReportMutation(baseOptions?: Apollo.MutationHookOptions<LetterTemplateRebuildReportMutation, LetterTemplateRebuildReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LetterTemplateRebuildReportMutation, LetterTemplateRebuildReportMutationVariables>(LetterTemplateRebuildReportDocument, options);
      }
export type LetterTemplateRebuildReportMutationHookResult = ReturnType<typeof useLetterTemplateRebuildReportMutation>;
export type LetterTemplateRebuildReportMutationResult = Apollo.MutationResult<LetterTemplateRebuildReportMutation>;
export type LetterTemplateRebuildReportMutationOptions = Apollo.BaseMutationOptions<LetterTemplateRebuildReportMutation, LetterTemplateRebuildReportMutationVariables>;
export const SetDefaultELetterDocument = gql`
    mutation setDefaultELetter($letterTemplateId: String!, $defaulted: Boolean!) {
  setDefaultELetter(letterTemplateId: $letterTemplateId, defaulted: $defaulted)
}
    `;
export type SetDefaultELetterMutationFn = Apollo.MutationFunction<SetDefaultELetterMutation, SetDefaultELetterMutationVariables>;

/**
 * __useSetDefaultELetterMutation__
 *
 * To run a mutation, you first call `useSetDefaultELetterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultELetterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultELetterMutation, { data, loading, error }] = useSetDefaultELetterMutation({
 *   variables: {
 *      letterTemplateId: // value for 'letterTemplateId'
 *      defaulted: // value for 'defaulted'
 *   },
 * });
 */
export function useSetDefaultELetterMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultELetterMutation, SetDefaultELetterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultELetterMutation, SetDefaultELetterMutationVariables>(SetDefaultELetterDocument, options);
      }
export type SetDefaultELetterMutationHookResult = ReturnType<typeof useSetDefaultELetterMutation>;
export type SetDefaultELetterMutationResult = Apollo.MutationResult<SetDefaultELetterMutation>;
export type SetDefaultELetterMutationOptions = Apollo.BaseMutationOptions<SetDefaultELetterMutation, SetDefaultELetterMutationVariables>;
export const GetAllLeadSourceDocument = gql`
    query getAllLeadSource {
  getAllLeadSource {
    id
    name
    commonStatus
    systemUse
    defaulted
    isDeletable
    isExistInTransactionData
  }
}
    `;

/**
 * __useGetAllLeadSourceQuery__
 *
 * To run a query within a React component, call `useGetAllLeadSourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllLeadSourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllLeadSourceQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllLeadSourceQuery(baseOptions?: Apollo.QueryHookOptions<GetAllLeadSourceQuery, GetAllLeadSourceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllLeadSourceQuery, GetAllLeadSourceQueryVariables>(GetAllLeadSourceDocument, options);
      }
export function useGetAllLeadSourceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllLeadSourceQuery, GetAllLeadSourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllLeadSourceQuery, GetAllLeadSourceQueryVariables>(GetAllLeadSourceDocument, options);
        }
export type GetAllLeadSourceQueryHookResult = ReturnType<typeof useGetAllLeadSourceQuery>;
export type GetAllLeadSourceLazyQueryHookResult = ReturnType<typeof useGetAllLeadSourceLazyQuery>;
export type GetAllLeadSourceQueryResult = Apollo.QueryResult<GetAllLeadSourceQuery, GetAllLeadSourceQueryVariables>;
export const EditLeadSourceDocument = gql`
    mutation editLeadSource($input: EditLeadSourceInput!) {
  editLeadSource(input: $input)
}
    `;
export type EditLeadSourceMutationFn = Apollo.MutationFunction<EditLeadSourceMutation, EditLeadSourceMutationVariables>;

/**
 * __useEditLeadSourceMutation__
 *
 * To run a mutation, you first call `useEditLeadSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditLeadSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editLeadSourceMutation, { data, loading, error }] = useEditLeadSourceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditLeadSourceMutation(baseOptions?: Apollo.MutationHookOptions<EditLeadSourceMutation, EditLeadSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditLeadSourceMutation, EditLeadSourceMutationVariables>(EditLeadSourceDocument, options);
      }
export type EditLeadSourceMutationHookResult = ReturnType<typeof useEditLeadSourceMutation>;
export type EditLeadSourceMutationResult = Apollo.MutationResult<EditLeadSourceMutation>;
export type EditLeadSourceMutationOptions = Apollo.BaseMutationOptions<EditLeadSourceMutation, EditLeadSourceMutationVariables>;
export const AddLeadSourceDocument = gql`
    mutation addLeadSource($input: LeadSourceInput!) {
  addLeadSource(input: $input)
}
    `;
export type AddLeadSourceMutationFn = Apollo.MutationFunction<AddLeadSourceMutation, AddLeadSourceMutationVariables>;

/**
 * __useAddLeadSourceMutation__
 *
 * To run a mutation, you first call `useAddLeadSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLeadSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLeadSourceMutation, { data, loading, error }] = useAddLeadSourceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddLeadSourceMutation(baseOptions?: Apollo.MutationHookOptions<AddLeadSourceMutation, AddLeadSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddLeadSourceMutation, AddLeadSourceMutationVariables>(AddLeadSourceDocument, options);
      }
export type AddLeadSourceMutationHookResult = ReturnType<typeof useAddLeadSourceMutation>;
export type AddLeadSourceMutationResult = Apollo.MutationResult<AddLeadSourceMutation>;
export type AddLeadSourceMutationOptions = Apollo.BaseMutationOptions<AddLeadSourceMutation, AddLeadSourceMutationVariables>;
export const DeleteLeadSourceByIdDocument = gql`
    mutation deleteLeadSourceById($sourceId: String!) {
  deleteLeadSourceById(sourceId: $sourceId)
}
    `;
export type DeleteLeadSourceByIdMutationFn = Apollo.MutationFunction<DeleteLeadSourceByIdMutation, DeleteLeadSourceByIdMutationVariables>;

/**
 * __useDeleteLeadSourceByIdMutation__
 *
 * To run a mutation, you first call `useDeleteLeadSourceByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLeadSourceByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLeadSourceByIdMutation, { data, loading, error }] = useDeleteLeadSourceByIdMutation({
 *   variables: {
 *      sourceId: // value for 'sourceId'
 *   },
 * });
 */
export function useDeleteLeadSourceByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLeadSourceByIdMutation, DeleteLeadSourceByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLeadSourceByIdMutation, DeleteLeadSourceByIdMutationVariables>(DeleteLeadSourceByIdDocument, options);
      }
export type DeleteLeadSourceByIdMutationHookResult = ReturnType<typeof useDeleteLeadSourceByIdMutation>;
export type DeleteLeadSourceByIdMutationResult = Apollo.MutationResult<DeleteLeadSourceByIdMutation>;
export type DeleteLeadSourceByIdMutationOptions = Apollo.BaseMutationOptions<DeleteLeadSourceByIdMutation, DeleteLeadSourceByIdMutationVariables>;
export const ChangeLeadStatusDocument = gql`
    mutation changeLeadStatus($sourceId: String!, $status: Boolean!) {
  changeLeadStatus(sourceId: $sourceId, status: $status)
}
    `;
export type ChangeLeadStatusMutationFn = Apollo.MutationFunction<ChangeLeadStatusMutation, ChangeLeadStatusMutationVariables>;

/**
 * __useChangeLeadStatusMutation__
 *
 * To run a mutation, you first call `useChangeLeadStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeLeadStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeLeadStatusMutation, { data, loading, error }] = useChangeLeadStatusMutation({
 *   variables: {
 *      sourceId: // value for 'sourceId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useChangeLeadStatusMutation(baseOptions?: Apollo.MutationHookOptions<ChangeLeadStatusMutation, ChangeLeadStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeLeadStatusMutation, ChangeLeadStatusMutationVariables>(ChangeLeadStatusDocument, options);
      }
export type ChangeLeadStatusMutationHookResult = ReturnType<typeof useChangeLeadStatusMutation>;
export type ChangeLeadStatusMutationResult = Apollo.MutationResult<ChangeLeadStatusMutation>;
export type ChangeLeadStatusMutationOptions = Apollo.BaseMutationOptions<ChangeLeadStatusMutation, ChangeLeadStatusMutationVariables>;
export const SetDefaultLeadSourceDocument = gql`
    mutation setDefaultLeadSource($sourceId: String!) {
  setDefaultLeadSource(sourceId: $sourceId)
}
    `;
export type SetDefaultLeadSourceMutationFn = Apollo.MutationFunction<SetDefaultLeadSourceMutation, SetDefaultLeadSourceMutationVariables>;

/**
 * __useSetDefaultLeadSourceMutation__
 *
 * To run a mutation, you first call `useSetDefaultLeadSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultLeadSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultLeadSourceMutation, { data, loading, error }] = useSetDefaultLeadSourceMutation({
 *   variables: {
 *      sourceId: // value for 'sourceId'
 *   },
 * });
 */
export function useSetDefaultLeadSourceMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultLeadSourceMutation, SetDefaultLeadSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultLeadSourceMutation, SetDefaultLeadSourceMutationVariables>(SetDefaultLeadSourceDocument, options);
      }
export type SetDefaultLeadSourceMutationHookResult = ReturnType<typeof useSetDefaultLeadSourceMutation>;
export type SetDefaultLeadSourceMutationResult = Apollo.MutationResult<SetDefaultLeadSourceMutation>;
export type SetDefaultLeadSourceMutationOptions = Apollo.BaseMutationOptions<SetDefaultLeadSourceMutation, SetDefaultLeadSourceMutationVariables>;
export const RemoveDefaultLeadSourceDocument = gql`
    mutation removeDefaultLeadSource($sourceId: String!) {
  removeDefaultLeadSource(sourceId: $sourceId)
}
    `;
export type RemoveDefaultLeadSourceMutationFn = Apollo.MutationFunction<RemoveDefaultLeadSourceMutation, RemoveDefaultLeadSourceMutationVariables>;

/**
 * __useRemoveDefaultLeadSourceMutation__
 *
 * To run a mutation, you first call `useRemoveDefaultLeadSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDefaultLeadSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDefaultLeadSourceMutation, { data, loading, error }] = useRemoveDefaultLeadSourceMutation({
 *   variables: {
 *      sourceId: // value for 'sourceId'
 *   },
 * });
 */
export function useRemoveDefaultLeadSourceMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDefaultLeadSourceMutation, RemoveDefaultLeadSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveDefaultLeadSourceMutation, RemoveDefaultLeadSourceMutationVariables>(RemoveDefaultLeadSourceDocument, options);
      }
export type RemoveDefaultLeadSourceMutationHookResult = ReturnType<typeof useRemoveDefaultLeadSourceMutation>;
export type RemoveDefaultLeadSourceMutationResult = Apollo.MutationResult<RemoveDefaultLeadSourceMutation>;
export type RemoveDefaultLeadSourceMutationOptions = Apollo.BaseMutationOptions<RemoveDefaultLeadSourceMutation, RemoveDefaultLeadSourceMutationVariables>;
export const OrganizeLeadSourceDocument = gql`
    mutation organizeLeadSource($sourceIds: [String!]!) {
  organizeLeadSource(sourceIds: $sourceIds)
}
    `;
export type OrganizeLeadSourceMutationFn = Apollo.MutationFunction<OrganizeLeadSourceMutation, OrganizeLeadSourceMutationVariables>;

/**
 * __useOrganizeLeadSourceMutation__
 *
 * To run a mutation, you first call `useOrganizeLeadSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizeLeadSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizeLeadSourceMutation, { data, loading, error }] = useOrganizeLeadSourceMutation({
 *   variables: {
 *      sourceIds: // value for 'sourceIds'
 *   },
 * });
 */
export function useOrganizeLeadSourceMutation(baseOptions?: Apollo.MutationHookOptions<OrganizeLeadSourceMutation, OrganizeLeadSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizeLeadSourceMutation, OrganizeLeadSourceMutationVariables>(OrganizeLeadSourceDocument, options);
      }
export type OrganizeLeadSourceMutationHookResult = ReturnType<typeof useOrganizeLeadSourceMutation>;
export type OrganizeLeadSourceMutationResult = Apollo.MutationResult<OrganizeLeadSourceMutation>;
export type OrganizeLeadSourceMutationOptions = Apollo.BaseMutationOptions<OrganizeLeadSourceMutation, OrganizeLeadSourceMutationVariables>;
export const GetAllNotaryDocument = gql`
    query getAllNotary {
  getAllNotary {
    id
    accountId
    notaryId
    name
    notaryCode
    ppatNo
    email
    officeTel
    address {
      address
      address2
      country
      city
      district
      subdistrict
      state
      postCode
      postCodeName
      AddressType
      isPrimary
    }
    invitationLink
    commonStatus
  }
}
    `;

/**
 * __useGetAllNotaryQuery__
 *
 * To run a query within a React component, call `useGetAllNotaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllNotaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllNotaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllNotaryQuery(baseOptions?: Apollo.QueryHookOptions<GetAllNotaryQuery, GetAllNotaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllNotaryQuery, GetAllNotaryQueryVariables>(GetAllNotaryDocument, options);
      }
export function useGetAllNotaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllNotaryQuery, GetAllNotaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllNotaryQuery, GetAllNotaryQueryVariables>(GetAllNotaryDocument, options);
        }
export type GetAllNotaryQueryHookResult = ReturnType<typeof useGetAllNotaryQuery>;
export type GetAllNotaryLazyQueryHookResult = ReturnType<typeof useGetAllNotaryLazyQuery>;
export type GetAllNotaryQueryResult = Apollo.QueryResult<GetAllNotaryQuery, GetAllNotaryQueryVariables>;
export const GetNotaryByIdDocument = gql`
    query getNotaryById($notaryId: String!) {
  getNotaryById(notaryId: $notaryId) {
    id
    accountId
    notaryId
    name
    notaryCode
    ppatNo
    email
    officeTel
    address {
      address
      address2
      country
      city
      district
      subdistrict
      state
      postCode
      postCodeName
      AddressType
      isPrimary
    }
    invitationLink
    commonStatus
    contactDetails {
      id
      name
      phoneNo
      email
    }
  }
}
    `;

/**
 * __useGetNotaryByIdQuery__
 *
 * To run a query within a React component, call `useGetNotaryByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotaryByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotaryByIdQuery({
 *   variables: {
 *      notaryId: // value for 'notaryId'
 *   },
 * });
 */
export function useGetNotaryByIdQuery(baseOptions: Apollo.QueryHookOptions<GetNotaryByIdQuery, GetNotaryByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotaryByIdQuery, GetNotaryByIdQueryVariables>(GetNotaryByIdDocument, options);
      }
export function useGetNotaryByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotaryByIdQuery, GetNotaryByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotaryByIdQuery, GetNotaryByIdQueryVariables>(GetNotaryByIdDocument, options);
        }
export type GetNotaryByIdQueryHookResult = ReturnType<typeof useGetNotaryByIdQuery>;
export type GetNotaryByIdLazyQueryHookResult = ReturnType<typeof useGetNotaryByIdLazyQuery>;
export type GetNotaryByIdQueryResult = Apollo.QueryResult<GetNotaryByIdQuery, GetNotaryByIdQueryVariables>;
export const AddNotaryDocument = gql`
    mutation addNotary($input: notaryInput!) {
  addNotary(input: $input)
}
    `;
export type AddNotaryMutationFn = Apollo.MutationFunction<AddNotaryMutation, AddNotaryMutationVariables>;

/**
 * __useAddNotaryMutation__
 *
 * To run a mutation, you first call `useAddNotaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNotaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNotaryMutation, { data, loading, error }] = useAddNotaryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddNotaryMutation(baseOptions?: Apollo.MutationHookOptions<AddNotaryMutation, AddNotaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddNotaryMutation, AddNotaryMutationVariables>(AddNotaryDocument, options);
      }
export type AddNotaryMutationHookResult = ReturnType<typeof useAddNotaryMutation>;
export type AddNotaryMutationResult = Apollo.MutationResult<AddNotaryMutation>;
export type AddNotaryMutationOptions = Apollo.BaseMutationOptions<AddNotaryMutation, AddNotaryMutationVariables>;
export const UpdateNotaryDocument = gql`
    mutation updateNotary($input: editNotaryInput!) {
  updateNotary(input: $input)
}
    `;
export type UpdateNotaryMutationFn = Apollo.MutationFunction<UpdateNotaryMutation, UpdateNotaryMutationVariables>;

/**
 * __useUpdateNotaryMutation__
 *
 * To run a mutation, you first call `useUpdateNotaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotaryMutation, { data, loading, error }] = useUpdateNotaryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNotaryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotaryMutation, UpdateNotaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotaryMutation, UpdateNotaryMutationVariables>(UpdateNotaryDocument, options);
      }
export type UpdateNotaryMutationHookResult = ReturnType<typeof useUpdateNotaryMutation>;
export type UpdateNotaryMutationResult = Apollo.MutationResult<UpdateNotaryMutation>;
export type UpdateNotaryMutationOptions = Apollo.BaseMutationOptions<UpdateNotaryMutation, UpdateNotaryMutationVariables>;
export const DeleteNotaryDocument = gql`
    mutation deleteNotary($id: String!) {
  deleteNotary(id: $id)
}
    `;
export type DeleteNotaryMutationFn = Apollo.MutationFunction<DeleteNotaryMutation, DeleteNotaryMutationVariables>;

/**
 * __useDeleteNotaryMutation__
 *
 * To run a mutation, you first call `useDeleteNotaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNotaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNotaryMutation, { data, loading, error }] = useDeleteNotaryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteNotaryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNotaryMutation, DeleteNotaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNotaryMutation, DeleteNotaryMutationVariables>(DeleteNotaryDocument, options);
      }
export type DeleteNotaryMutationHookResult = ReturnType<typeof useDeleteNotaryMutation>;
export type DeleteNotaryMutationResult = Apollo.MutationResult<DeleteNotaryMutation>;
export type DeleteNotaryMutationOptions = Apollo.BaseMutationOptions<DeleteNotaryMutation, DeleteNotaryMutationVariables>;
export const GetDocumentNumberHeaderListingDocument = gql`
    query getDocumentNumberHeaderListing($companyId: String!) {
  getDocumentNumberHeaderListing(companyId: $companyId) {
    type
    title
    sampleOutput
  }
}
    `;

/**
 * __useGetDocumentNumberHeaderListingQuery__
 *
 * To run a query within a React component, call `useGetDocumentNumberHeaderListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentNumberHeaderListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentNumberHeaderListingQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetDocumentNumberHeaderListingQuery(baseOptions: Apollo.QueryHookOptions<GetDocumentNumberHeaderListingQuery, GetDocumentNumberHeaderListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentNumberHeaderListingQuery, GetDocumentNumberHeaderListingQueryVariables>(GetDocumentNumberHeaderListingDocument, options);
      }
export function useGetDocumentNumberHeaderListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentNumberHeaderListingQuery, GetDocumentNumberHeaderListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentNumberHeaderListingQuery, GetDocumentNumberHeaderListingQueryVariables>(GetDocumentNumberHeaderListingDocument, options);
        }
export type GetDocumentNumberHeaderListingQueryHookResult = ReturnType<typeof useGetDocumentNumberHeaderListingQuery>;
export type GetDocumentNumberHeaderListingLazyQueryHookResult = ReturnType<typeof useGetDocumentNumberHeaderListingLazyQuery>;
export type GetDocumentNumberHeaderListingQueryResult = Apollo.QueryResult<GetDocumentNumberHeaderListingQuery, GetDocumentNumberHeaderListingQueryVariables>;
export const GetAvailableCopyNumCompanyListDocument = gql`
    query getAvailableCopyNumCompanyList($companyId: String!) {
  getAvailableCopyNumCompanyList(companyId: $companyId) {
    id
    name
  }
}
    `;

/**
 * __useGetAvailableCopyNumCompanyListQuery__
 *
 * To run a query within a React component, call `useGetAvailableCopyNumCompanyListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableCopyNumCompanyListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableCopyNumCompanyListQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetAvailableCopyNumCompanyListQuery(baseOptions: Apollo.QueryHookOptions<GetAvailableCopyNumCompanyListQuery, GetAvailableCopyNumCompanyListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableCopyNumCompanyListQuery, GetAvailableCopyNumCompanyListQueryVariables>(GetAvailableCopyNumCompanyListDocument, options);
      }
export function useGetAvailableCopyNumCompanyListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableCopyNumCompanyListQuery, GetAvailableCopyNumCompanyListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableCopyNumCompanyListQuery, GetAvailableCopyNumCompanyListQueryVariables>(GetAvailableCopyNumCompanyListDocument, options);
        }
export type GetAvailableCopyNumCompanyListQueryHookResult = ReturnType<typeof useGetAvailableCopyNumCompanyListQuery>;
export type GetAvailableCopyNumCompanyListLazyQueryHookResult = ReturnType<typeof useGetAvailableCopyNumCompanyListLazyQuery>;
export type GetAvailableCopyNumCompanyListQueryResult = Apollo.QueryResult<GetAvailableCopyNumCompanyListQuery, GetAvailableCopyNumCompanyListQueryVariables>;
export const GetDocumentTypeDocument = gql`
    query getDocumentType($type: String!, $companyId: String!) {
  getDocumentType(type: $type, companyId: $companyId) {
    id
    sampleOutput
    docNumGenerated
    documentNumberDetails {
      id
      sequence
      formatType
      formatValue
      startFrom
      resetBy
    }
  }
}
    `;

/**
 * __useGetDocumentTypeQuery__
 *
 * To run a query within a React component, call `useGetDocumentTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentTypeQuery({
 *   variables: {
 *      type: // value for 'type'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetDocumentTypeQuery(baseOptions: Apollo.QueryHookOptions<GetDocumentTypeQuery, GetDocumentTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentTypeQuery, GetDocumentTypeQueryVariables>(GetDocumentTypeDocument, options);
      }
export function useGetDocumentTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentTypeQuery, GetDocumentTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentTypeQuery, GetDocumentTypeQueryVariables>(GetDocumentTypeDocument, options);
        }
export type GetDocumentTypeQueryHookResult = ReturnType<typeof useGetDocumentTypeQuery>;
export type GetDocumentTypeLazyQueryHookResult = ReturnType<typeof useGetDocumentTypeLazyQuery>;
export type GetDocumentTypeQueryResult = Apollo.QueryResult<GetDocumentTypeQuery, GetDocumentTypeQueryVariables>;
export const AddCompanyNumberingStructureDocument = gql`
    mutation addCompanyNumberingStructure($input: AddNumberingFormatInput!) {
  addCompanyNumberingStructure(input: $input)
}
    `;
export type AddCompanyNumberingStructureMutationFn = Apollo.MutationFunction<AddCompanyNumberingStructureMutation, AddCompanyNumberingStructureMutationVariables>;

/**
 * __useAddCompanyNumberingStructureMutation__
 *
 * To run a mutation, you first call `useAddCompanyNumberingStructureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCompanyNumberingStructureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCompanyNumberingStructureMutation, { data, loading, error }] = useAddCompanyNumberingStructureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCompanyNumberingStructureMutation(baseOptions?: Apollo.MutationHookOptions<AddCompanyNumberingStructureMutation, AddCompanyNumberingStructureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCompanyNumberingStructureMutation, AddCompanyNumberingStructureMutationVariables>(AddCompanyNumberingStructureDocument, options);
      }
export type AddCompanyNumberingStructureMutationHookResult = ReturnType<typeof useAddCompanyNumberingStructureMutation>;
export type AddCompanyNumberingStructureMutationResult = Apollo.MutationResult<AddCompanyNumberingStructureMutation>;
export type AddCompanyNumberingStructureMutationOptions = Apollo.BaseMutationOptions<AddCompanyNumberingStructureMutation, AddCompanyNumberingStructureMutationVariables>;
export const EditCompanyNumberingStructureDocument = gql`
    mutation editCompanyNumberingStructure($input: EditNumberingFormatInput!) {
  editCompanyNumberingStructure(input: $input)
}
    `;
export type EditCompanyNumberingStructureMutationFn = Apollo.MutationFunction<EditCompanyNumberingStructureMutation, EditCompanyNumberingStructureMutationVariables>;

/**
 * __useEditCompanyNumberingStructureMutation__
 *
 * To run a mutation, you first call `useEditCompanyNumberingStructureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCompanyNumberingStructureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCompanyNumberingStructureMutation, { data, loading, error }] = useEditCompanyNumberingStructureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditCompanyNumberingStructureMutation(baseOptions?: Apollo.MutationHookOptions<EditCompanyNumberingStructureMutation, EditCompanyNumberingStructureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCompanyNumberingStructureMutation, EditCompanyNumberingStructureMutationVariables>(EditCompanyNumberingStructureDocument, options);
      }
export type EditCompanyNumberingStructureMutationHookResult = ReturnType<typeof useEditCompanyNumberingStructureMutation>;
export type EditCompanyNumberingStructureMutationResult = Apollo.MutationResult<EditCompanyNumberingStructureMutation>;
export type EditCompanyNumberingStructureMutationOptions = Apollo.BaseMutationOptions<EditCompanyNumberingStructureMutation, EditCompanyNumberingStructureMutationVariables>;
export const GetDocumentNumberDetailTypeDocument = gql`
    query getDocumentNumberDetailType {
  getDocumentNumberDetailType
}
    `;

/**
 * __useGetDocumentNumberDetailTypeQuery__
 *
 * To run a query within a React component, call `useGetDocumentNumberDetailTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentNumberDetailTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentNumberDetailTypeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDocumentNumberDetailTypeQuery(baseOptions?: Apollo.QueryHookOptions<GetDocumentNumberDetailTypeQuery, GetDocumentNumberDetailTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentNumberDetailTypeQuery, GetDocumentNumberDetailTypeQueryVariables>(GetDocumentNumberDetailTypeDocument, options);
      }
export function useGetDocumentNumberDetailTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentNumberDetailTypeQuery, GetDocumentNumberDetailTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentNumberDetailTypeQuery, GetDocumentNumberDetailTypeQueryVariables>(GetDocumentNumberDetailTypeDocument, options);
        }
export type GetDocumentNumberDetailTypeQueryHookResult = ReturnType<typeof useGetDocumentNumberDetailTypeQuery>;
export type GetDocumentNumberDetailTypeLazyQueryHookResult = ReturnType<typeof useGetDocumentNumberDetailTypeLazyQuery>;
export type GetDocumentNumberDetailTypeQueryResult = Apollo.QueryResult<GetDocumentNumberDetailTypeQuery, GetDocumentNumberDetailTypeQueryVariables>;
export const CopyFromCompanyNumberingStructureDocument = gql`
    mutation copyFromCompanyNumberingStructure($input: CopyFromNumberingFormatInput!) {
  copyFromCompanyNumberingStructure(input: $input)
}
    `;
export type CopyFromCompanyNumberingStructureMutationFn = Apollo.MutationFunction<CopyFromCompanyNumberingStructureMutation, CopyFromCompanyNumberingStructureMutationVariables>;

/**
 * __useCopyFromCompanyNumberingStructureMutation__
 *
 * To run a mutation, you first call `useCopyFromCompanyNumberingStructureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyFromCompanyNumberingStructureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyFromCompanyNumberingStructureMutation, { data, loading, error }] = useCopyFromCompanyNumberingStructureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCopyFromCompanyNumberingStructureMutation(baseOptions?: Apollo.MutationHookOptions<CopyFromCompanyNumberingStructureMutation, CopyFromCompanyNumberingStructureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyFromCompanyNumberingStructureMutation, CopyFromCompanyNumberingStructureMutationVariables>(CopyFromCompanyNumberingStructureDocument, options);
      }
export type CopyFromCompanyNumberingStructureMutationHookResult = ReturnType<typeof useCopyFromCompanyNumberingStructureMutation>;
export type CopyFromCompanyNumberingStructureMutationResult = Apollo.MutationResult<CopyFromCompanyNumberingStructureMutation>;
export type CopyFromCompanyNumberingStructureMutationOptions = Apollo.BaseMutationOptions<CopyFromCompanyNumberingStructureMutation, CopyFromCompanyNumberingStructureMutationVariables>;
export const PaymentGatewayListingDocument = gql`
    query paymentGatewayListing {
  paymentGatewayListing {
    id
    gatewayType
    gatewayInfo
    commonStatus
    gatewayTypeDesc
    lastUpdate
    title
  }
}
    `;

/**
 * __usePaymentGatewayListingQuery__
 *
 * To run a query within a React component, call `usePaymentGatewayListingQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentGatewayListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentGatewayListingQuery({
 *   variables: {
 *   },
 * });
 */
export function usePaymentGatewayListingQuery(baseOptions?: Apollo.QueryHookOptions<PaymentGatewayListingQuery, PaymentGatewayListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentGatewayListingQuery, PaymentGatewayListingQueryVariables>(PaymentGatewayListingDocument, options);
      }
export function usePaymentGatewayListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentGatewayListingQuery, PaymentGatewayListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentGatewayListingQuery, PaymentGatewayListingQueryVariables>(PaymentGatewayListingDocument, options);
        }
export type PaymentGatewayListingQueryHookResult = ReturnType<typeof usePaymentGatewayListingQuery>;
export type PaymentGatewayListingLazyQueryHookResult = ReturnType<typeof usePaymentGatewayListingLazyQuery>;
export type PaymentGatewayListingQueryResult = Apollo.QueryResult<PaymentGatewayListingQuery, PaymentGatewayListingQueryVariables>;
export const GetAllPaymentPlanDocument = gql`
    query getAllPaymentPlan {
  getAllPaymentPlan {
    name
    id
    accountId
    commonStatus
    effectiveDate
    isDeletable
    isExistInMasterData
    isExistInTransactionData
    isExistInTableData
    isEditable
    details {
      id
      amountType
      amountValue
      title
      stageSeqNo
      isDownpayment
      workProgressId
      amountType
      amountValue
      isWithInterest
      isStakeholder
      isVpStage
      installmentBillingDay
      numberOfPayment
      stakeholderDuration
      workProgress {
        name
        id
        accountId
        systemUse
      }
    }
  }
}
    `;

/**
 * __useGetAllPaymentPlanQuery__
 *
 * To run a query within a React component, call `useGetAllPaymentPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPaymentPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPaymentPlanQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllPaymentPlanQuery(baseOptions?: Apollo.QueryHookOptions<GetAllPaymentPlanQuery, GetAllPaymentPlanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllPaymentPlanQuery, GetAllPaymentPlanQueryVariables>(GetAllPaymentPlanDocument, options);
      }
export function useGetAllPaymentPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllPaymentPlanQuery, GetAllPaymentPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllPaymentPlanQuery, GetAllPaymentPlanQueryVariables>(GetAllPaymentPlanDocument, options);
        }
export type GetAllPaymentPlanQueryHookResult = ReturnType<typeof useGetAllPaymentPlanQuery>;
export type GetAllPaymentPlanLazyQueryHookResult = ReturnType<typeof useGetAllPaymentPlanLazyQuery>;
export type GetAllPaymentPlanQueryResult = Apollo.QueryResult<GetAllPaymentPlanQuery, GetAllPaymentPlanQueryVariables>;
export const GetPaymentPlanByIdDocument = gql`
    query getPaymentPlanById($id: String!) {
  getPaymentPlanById(id: $id) {
    name
    id
    accountId
    commonStatus
    effectiveDate
    isEditable
    details {
      id
      amountType
      amountValue
      title
      stageSeqNo
      isDownpayment
      workProgressId
      amountType
      amountValue
      isWithInterest
      isStakeholder
      isVpStage
      installmentBillingDay
      numberOfPayment
      stakeholderDuration
      workProgress {
        name
        id
        isVp
        isCarPark
        systemUse
      }
      includeInDetailId {
        paymentPlanDetailId
      }
    }
  }
}
    `;

/**
 * __useGetPaymentPlanByIdQuery__
 *
 * To run a query within a React component, call `useGetPaymentPlanByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentPlanByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentPlanByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPaymentPlanByIdQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentPlanByIdQuery, GetPaymentPlanByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentPlanByIdQuery, GetPaymentPlanByIdQueryVariables>(GetPaymentPlanByIdDocument, options);
      }
export function useGetPaymentPlanByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentPlanByIdQuery, GetPaymentPlanByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentPlanByIdQuery, GetPaymentPlanByIdQueryVariables>(GetPaymentPlanByIdDocument, options);
        }
export type GetPaymentPlanByIdQueryHookResult = ReturnType<typeof useGetPaymentPlanByIdQuery>;
export type GetPaymentPlanByIdLazyQueryHookResult = ReturnType<typeof useGetPaymentPlanByIdLazyQuery>;
export type GetPaymentPlanByIdQueryResult = Apollo.QueryResult<GetPaymentPlanByIdQuery, GetPaymentPlanByIdQueryVariables>;
export const GetAllPaymentPlanDetailDocument = gql`
    query getAllPaymentPlanDetail($planId: String!) {
  getAllPaymentPlanDetail(planId: $planId) {
    id
    accountId
    amountType
    amountValue
    title
    stageSeqNo
    isDownpayment
    workProgressId
    amountType
    amountValue
    isWithInterest
    isStakeholder
    isVpStage
    installmentBillingDay
    numberOfPayment
    stakeholderDuration
    isDeletable
    workProgress {
      name
      id
      accountId
      systemUse
    }
  }
}
    `;

/**
 * __useGetAllPaymentPlanDetailQuery__
 *
 * To run a query within a React component, call `useGetAllPaymentPlanDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPaymentPlanDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPaymentPlanDetailQuery({
 *   variables: {
 *      planId: // value for 'planId'
 *   },
 * });
 */
export function useGetAllPaymentPlanDetailQuery(baseOptions: Apollo.QueryHookOptions<GetAllPaymentPlanDetailQuery, GetAllPaymentPlanDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllPaymentPlanDetailQuery, GetAllPaymentPlanDetailQueryVariables>(GetAllPaymentPlanDetailDocument, options);
      }
export function useGetAllPaymentPlanDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllPaymentPlanDetailQuery, GetAllPaymentPlanDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllPaymentPlanDetailQuery, GetAllPaymentPlanDetailQueryVariables>(GetAllPaymentPlanDetailDocument, options);
        }
export type GetAllPaymentPlanDetailQueryHookResult = ReturnType<typeof useGetAllPaymentPlanDetailQuery>;
export type GetAllPaymentPlanDetailLazyQueryHookResult = ReturnType<typeof useGetAllPaymentPlanDetailLazyQuery>;
export type GetAllPaymentPlanDetailQueryResult = Apollo.QueryResult<GetAllPaymentPlanDetailQuery, GetAllPaymentPlanDetailQueryVariables>;
export const GetPaymentPlanDetailByIdDocument = gql`
    query getPaymentPlanDetailById($id: String!) {
  getPaymentPlanDetailById(id: $id) {
    id
    amountType
    amountValue
    title
    stageSeqNo
    isDownpayment
    workProgressId
    amountType
    amountValue
    isWithInterest
    isStakeholder
    isVpStage
    installmentBillingDay
    numberOfPayment
    stakeholderDuration
    workProgress {
      name
      id
      accountId
      systemUse
    }
  }
}
    `;

/**
 * __useGetPaymentPlanDetailByIdQuery__
 *
 * To run a query within a React component, call `useGetPaymentPlanDetailByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentPlanDetailByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentPlanDetailByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPaymentPlanDetailByIdQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentPlanDetailByIdQuery, GetPaymentPlanDetailByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentPlanDetailByIdQuery, GetPaymentPlanDetailByIdQueryVariables>(GetPaymentPlanDetailByIdDocument, options);
      }
export function useGetPaymentPlanDetailByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentPlanDetailByIdQuery, GetPaymentPlanDetailByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentPlanDetailByIdQuery, GetPaymentPlanDetailByIdQueryVariables>(GetPaymentPlanDetailByIdDocument, options);
        }
export type GetPaymentPlanDetailByIdQueryHookResult = ReturnType<typeof useGetPaymentPlanDetailByIdQuery>;
export type GetPaymentPlanDetailByIdLazyQueryHookResult = ReturnType<typeof useGetPaymentPlanDetailByIdLazyQuery>;
export type GetPaymentPlanDetailByIdQueryResult = Apollo.QueryResult<GetPaymentPlanDetailByIdQuery, GetPaymentPlanDetailByIdQueryVariables>;
export const AddPaymentPlanDocument = gql`
    mutation addPaymentPlan($input: AddPaymentPlanInput!) {
  addPaymentPlan(input: $input)
}
    `;
export type AddPaymentPlanMutationFn = Apollo.MutationFunction<AddPaymentPlanMutation, AddPaymentPlanMutationVariables>;

/**
 * __useAddPaymentPlanMutation__
 *
 * To run a mutation, you first call `useAddPaymentPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPaymentPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPaymentPlanMutation, { data, loading, error }] = useAddPaymentPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPaymentPlanMutation(baseOptions?: Apollo.MutationHookOptions<AddPaymentPlanMutation, AddPaymentPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPaymentPlanMutation, AddPaymentPlanMutationVariables>(AddPaymentPlanDocument, options);
      }
export type AddPaymentPlanMutationHookResult = ReturnType<typeof useAddPaymentPlanMutation>;
export type AddPaymentPlanMutationResult = Apollo.MutationResult<AddPaymentPlanMutation>;
export type AddPaymentPlanMutationOptions = Apollo.BaseMutationOptions<AddPaymentPlanMutation, AddPaymentPlanMutationVariables>;
export const EditPaymentPlanDocument = gql`
    mutation editPaymentPlan($input: EditPaymentPlanInput!) {
  editPaymentPlan(input: $input)
}
    `;
export type EditPaymentPlanMutationFn = Apollo.MutationFunction<EditPaymentPlanMutation, EditPaymentPlanMutationVariables>;

/**
 * __useEditPaymentPlanMutation__
 *
 * To run a mutation, you first call `useEditPaymentPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPaymentPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPaymentPlanMutation, { data, loading, error }] = useEditPaymentPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditPaymentPlanMutation(baseOptions?: Apollo.MutationHookOptions<EditPaymentPlanMutation, EditPaymentPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditPaymentPlanMutation, EditPaymentPlanMutationVariables>(EditPaymentPlanDocument, options);
      }
export type EditPaymentPlanMutationHookResult = ReturnType<typeof useEditPaymentPlanMutation>;
export type EditPaymentPlanMutationResult = Apollo.MutationResult<EditPaymentPlanMutation>;
export type EditPaymentPlanMutationOptions = Apollo.BaseMutationOptions<EditPaymentPlanMutation, EditPaymentPlanMutationVariables>;
export const DeactivatePaymentPlanDocument = gql`
    mutation deactivatePaymentPlan($paymentPlanId: String!) {
  deactivatePaymentPlan(paymentPlanId: $paymentPlanId)
}
    `;
export type DeactivatePaymentPlanMutationFn = Apollo.MutationFunction<DeactivatePaymentPlanMutation, DeactivatePaymentPlanMutationVariables>;

/**
 * __useDeactivatePaymentPlanMutation__
 *
 * To run a mutation, you first call `useDeactivatePaymentPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivatePaymentPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivatePaymentPlanMutation, { data, loading, error }] = useDeactivatePaymentPlanMutation({
 *   variables: {
 *      paymentPlanId: // value for 'paymentPlanId'
 *   },
 * });
 */
export function useDeactivatePaymentPlanMutation(baseOptions?: Apollo.MutationHookOptions<DeactivatePaymentPlanMutation, DeactivatePaymentPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivatePaymentPlanMutation, DeactivatePaymentPlanMutationVariables>(DeactivatePaymentPlanDocument, options);
      }
export type DeactivatePaymentPlanMutationHookResult = ReturnType<typeof useDeactivatePaymentPlanMutation>;
export type DeactivatePaymentPlanMutationResult = Apollo.MutationResult<DeactivatePaymentPlanMutation>;
export type DeactivatePaymentPlanMutationOptions = Apollo.BaseMutationOptions<DeactivatePaymentPlanMutation, DeactivatePaymentPlanMutationVariables>;
export const DuplicatePaymentPlanDocument = gql`
    mutation duplicatePaymentPlan($input: DuplicatePaymentPlanInput!) {
  duplicatePaymentPlan(input: $input)
}
    `;
export type DuplicatePaymentPlanMutationFn = Apollo.MutationFunction<DuplicatePaymentPlanMutation, DuplicatePaymentPlanMutationVariables>;

/**
 * __useDuplicatePaymentPlanMutation__
 *
 * To run a mutation, you first call `useDuplicatePaymentPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicatePaymentPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicatePaymentPlanMutation, { data, loading, error }] = useDuplicatePaymentPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDuplicatePaymentPlanMutation(baseOptions?: Apollo.MutationHookOptions<DuplicatePaymentPlanMutation, DuplicatePaymentPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicatePaymentPlanMutation, DuplicatePaymentPlanMutationVariables>(DuplicatePaymentPlanDocument, options);
      }
export type DuplicatePaymentPlanMutationHookResult = ReturnType<typeof useDuplicatePaymentPlanMutation>;
export type DuplicatePaymentPlanMutationResult = Apollo.MutationResult<DuplicatePaymentPlanMutation>;
export type DuplicatePaymentPlanMutationOptions = Apollo.BaseMutationOptions<DuplicatePaymentPlanMutation, DuplicatePaymentPlanMutationVariables>;
export const DeletePaymentPlanDocument = gql`
    mutation deletePaymentPlan($paymentPlanId: String!) {
  deletePaymentPlan(paymentPlanId: $paymentPlanId)
}
    `;
export type DeletePaymentPlanMutationFn = Apollo.MutationFunction<DeletePaymentPlanMutation, DeletePaymentPlanMutationVariables>;

/**
 * __useDeletePaymentPlanMutation__
 *
 * To run a mutation, you first call `useDeletePaymentPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePaymentPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePaymentPlanMutation, { data, loading, error }] = useDeletePaymentPlanMutation({
 *   variables: {
 *      paymentPlanId: // value for 'paymentPlanId'
 *   },
 * });
 */
export function useDeletePaymentPlanMutation(baseOptions?: Apollo.MutationHookOptions<DeletePaymentPlanMutation, DeletePaymentPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePaymentPlanMutation, DeletePaymentPlanMutationVariables>(DeletePaymentPlanDocument, options);
      }
export type DeletePaymentPlanMutationHookResult = ReturnType<typeof useDeletePaymentPlanMutation>;
export type DeletePaymentPlanMutationResult = Apollo.MutationResult<DeletePaymentPlanMutation>;
export type DeletePaymentPlanMutationOptions = Apollo.BaseMutationOptions<DeletePaymentPlanMutation, DeletePaymentPlanMutationVariables>;
export const ActivatePaymentPlanDocument = gql`
    mutation activatePaymentPlan($paymentPlanId: String!) {
  activatePaymentPlan(paymentPlanId: $paymentPlanId)
}
    `;
export type ActivatePaymentPlanMutationFn = Apollo.MutationFunction<ActivatePaymentPlanMutation, ActivatePaymentPlanMutationVariables>;

/**
 * __useActivatePaymentPlanMutation__
 *
 * To run a mutation, you first call `useActivatePaymentPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivatePaymentPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activatePaymentPlanMutation, { data, loading, error }] = useActivatePaymentPlanMutation({
 *   variables: {
 *      paymentPlanId: // value for 'paymentPlanId'
 *   },
 * });
 */
export function useActivatePaymentPlanMutation(baseOptions?: Apollo.MutationHookOptions<ActivatePaymentPlanMutation, ActivatePaymentPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivatePaymentPlanMutation, ActivatePaymentPlanMutationVariables>(ActivatePaymentPlanDocument, options);
      }
export type ActivatePaymentPlanMutationHookResult = ReturnType<typeof useActivatePaymentPlanMutation>;
export type ActivatePaymentPlanMutationResult = Apollo.MutationResult<ActivatePaymentPlanMutation>;
export type ActivatePaymentPlanMutationOptions = Apollo.BaseMutationOptions<ActivatePaymentPlanMutation, ActivatePaymentPlanMutationVariables>;
export const DeletePaymentPlanDetailDocument = gql`
    mutation deletePaymentPlanDetail($detailId: String!) {
  deletePaymentPlanDetail(detailId: $detailId)
}
    `;
export type DeletePaymentPlanDetailMutationFn = Apollo.MutationFunction<DeletePaymentPlanDetailMutation, DeletePaymentPlanDetailMutationVariables>;

/**
 * __useDeletePaymentPlanDetailMutation__
 *
 * To run a mutation, you first call `useDeletePaymentPlanDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePaymentPlanDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePaymentPlanDetailMutation, { data, loading, error }] = useDeletePaymentPlanDetailMutation({
 *   variables: {
 *      detailId: // value for 'detailId'
 *   },
 * });
 */
export function useDeletePaymentPlanDetailMutation(baseOptions?: Apollo.MutationHookOptions<DeletePaymentPlanDetailMutation, DeletePaymentPlanDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePaymentPlanDetailMutation, DeletePaymentPlanDetailMutationVariables>(DeletePaymentPlanDetailDocument, options);
      }
export type DeletePaymentPlanDetailMutationHookResult = ReturnType<typeof useDeletePaymentPlanDetailMutation>;
export type DeletePaymentPlanDetailMutationResult = Apollo.MutationResult<DeletePaymentPlanDetailMutation>;
export type DeletePaymentPlanDetailMutationOptions = Apollo.BaseMutationOptions<DeletePaymentPlanDetailMutation, DeletePaymentPlanDetailMutationVariables>;
export const GetPurchaserIdTypeListingDocument = gql`
    query getPurchaserIDTypeListing {
  getPurchaserIDTypeListing {
    id
    identityDoc
    description
  }
}
    `;

/**
 * __useGetPurchaserIdTypeListingQuery__
 *
 * To run a query within a React component, call `useGetPurchaserIdTypeListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPurchaserIdTypeListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPurchaserIdTypeListingQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPurchaserIdTypeListingQuery(baseOptions?: Apollo.QueryHookOptions<GetPurchaserIdTypeListingQuery, GetPurchaserIdTypeListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPurchaserIdTypeListingQuery, GetPurchaserIdTypeListingQueryVariables>(GetPurchaserIdTypeListingDocument, options);
      }
export function useGetPurchaserIdTypeListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPurchaserIdTypeListingQuery, GetPurchaserIdTypeListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPurchaserIdTypeListingQuery, GetPurchaserIdTypeListingQueryVariables>(GetPurchaserIdTypeListingDocument, options);
        }
export type GetPurchaserIdTypeListingQueryHookResult = ReturnType<typeof useGetPurchaserIdTypeListingQuery>;
export type GetPurchaserIdTypeListingLazyQueryHookResult = ReturnType<typeof useGetPurchaserIdTypeListingLazyQuery>;
export type GetPurchaserIdTypeListingQueryResult = Apollo.QueryResult<GetPurchaserIdTypeListingQuery, GetPurchaserIdTypeListingQueryVariables>;
export const AddPurchaserIdTypeDocument = gql`
    mutation addPurchaserIDType($input: addPurchaserIDTypeInput!) {
  addPurchaserIDType(input: $input)
}
    `;
export type AddPurchaserIdTypeMutationFn = Apollo.MutationFunction<AddPurchaserIdTypeMutation, AddPurchaserIdTypeMutationVariables>;

/**
 * __useAddPurchaserIdTypeMutation__
 *
 * To run a mutation, you first call `useAddPurchaserIdTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPurchaserIdTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPurchaserIdTypeMutation, { data, loading, error }] = useAddPurchaserIdTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPurchaserIdTypeMutation(baseOptions?: Apollo.MutationHookOptions<AddPurchaserIdTypeMutation, AddPurchaserIdTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPurchaserIdTypeMutation, AddPurchaserIdTypeMutationVariables>(AddPurchaserIdTypeDocument, options);
      }
export type AddPurchaserIdTypeMutationHookResult = ReturnType<typeof useAddPurchaserIdTypeMutation>;
export type AddPurchaserIdTypeMutationResult = Apollo.MutationResult<AddPurchaserIdTypeMutation>;
export type AddPurchaserIdTypeMutationOptions = Apollo.BaseMutationOptions<AddPurchaserIdTypeMutation, AddPurchaserIdTypeMutationVariables>;
export const EditPurchaserIdTypeDocument = gql`
    mutation editPurchaserIDType($id: String!, $input: addPurchaserIDTypeInput!) {
  editPurchaserIDType(id: $id, input: $input)
}
    `;
export type EditPurchaserIdTypeMutationFn = Apollo.MutationFunction<EditPurchaserIdTypeMutation, EditPurchaserIdTypeMutationVariables>;

/**
 * __useEditPurchaserIdTypeMutation__
 *
 * To run a mutation, you first call `useEditPurchaserIdTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPurchaserIdTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPurchaserIdTypeMutation, { data, loading, error }] = useEditPurchaserIdTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditPurchaserIdTypeMutation(baseOptions?: Apollo.MutationHookOptions<EditPurchaserIdTypeMutation, EditPurchaserIdTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditPurchaserIdTypeMutation, EditPurchaserIdTypeMutationVariables>(EditPurchaserIdTypeDocument, options);
      }
export type EditPurchaserIdTypeMutationHookResult = ReturnType<typeof useEditPurchaserIdTypeMutation>;
export type EditPurchaserIdTypeMutationResult = Apollo.MutationResult<EditPurchaserIdTypeMutation>;
export type EditPurchaserIdTypeMutationOptions = Apollo.BaseMutationOptions<EditPurchaserIdTypeMutation, EditPurchaserIdTypeMutationVariables>;
export const DeletePurchaserIdTypeDocument = gql`
    mutation deletePurchaserIDType($id: String!) {
  deletePurchaserIDType(id: $id)
}
    `;
export type DeletePurchaserIdTypeMutationFn = Apollo.MutationFunction<DeletePurchaserIdTypeMutation, DeletePurchaserIdTypeMutationVariables>;

/**
 * __useDeletePurchaserIdTypeMutation__
 *
 * To run a mutation, you first call `useDeletePurchaserIdTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePurchaserIdTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePurchaserIdTypeMutation, { data, loading, error }] = useDeletePurchaserIdTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePurchaserIdTypeMutation(baseOptions?: Apollo.MutationHookOptions<DeletePurchaserIdTypeMutation, DeletePurchaserIdTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePurchaserIdTypeMutation, DeletePurchaserIdTypeMutationVariables>(DeletePurchaserIdTypeDocument, options);
      }
export type DeletePurchaserIdTypeMutationHookResult = ReturnType<typeof useDeletePurchaserIdTypeMutation>;
export type DeletePurchaserIdTypeMutationResult = Apollo.MutationResult<DeletePurchaserIdTypeMutation>;
export type DeletePurchaserIdTypeMutationOptions = Apollo.BaseMutationOptions<DeletePurchaserIdTypeMutation, DeletePurchaserIdTypeMutationVariables>;
export const GetPurchaserPaymentListingDocument = gql`
    query getPurchaserPaymentListing {
  getPurchaserPaymentListing {
    id
    accountId
    name
    effectiveDate
    markUpPercentage
    installmentSum
    recordStatus
  }
}
    `;

/**
 * __useGetPurchaserPaymentListingQuery__
 *
 * To run a query within a React component, call `useGetPurchaserPaymentListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPurchaserPaymentListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPurchaserPaymentListingQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPurchaserPaymentListingQuery(baseOptions?: Apollo.QueryHookOptions<GetPurchaserPaymentListingQuery, GetPurchaserPaymentListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPurchaserPaymentListingQuery, GetPurchaserPaymentListingQueryVariables>(GetPurchaserPaymentListingDocument, options);
      }
export function useGetPurchaserPaymentListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPurchaserPaymentListingQuery, GetPurchaserPaymentListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPurchaserPaymentListingQuery, GetPurchaserPaymentListingQueryVariables>(GetPurchaserPaymentListingDocument, options);
        }
export type GetPurchaserPaymentListingQueryHookResult = ReturnType<typeof useGetPurchaserPaymentListingQuery>;
export type GetPurchaserPaymentListingLazyQueryHookResult = ReturnType<typeof useGetPurchaserPaymentListingLazyQuery>;
export type GetPurchaserPaymentListingQueryResult = Apollo.QueryResult<GetPurchaserPaymentListingQuery, GetPurchaserPaymentListingQueryVariables>;
export const GetPurchaserPaymentPlanDetailsListingDocument = gql`
    query getPurchaserPaymentPlanDetailsListing($purchaserPaymentPlanId: String!) {
  getPurchaserPaymentPlanDetailsListing(purchaserPaymentPlanId: $purchaserPaymentPlanId) {
    id
    paymentPlanName
    effectiveDate
    markUpPercentage
    title
    noInstallment
    deductBookingFee
    billCount
    billFrequency
    billAfter
    paymentValue
    recordStatus
  }
}
    `;

/**
 * __useGetPurchaserPaymentPlanDetailsListingQuery__
 *
 * To run a query within a React component, call `useGetPurchaserPaymentPlanDetailsListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPurchaserPaymentPlanDetailsListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPurchaserPaymentPlanDetailsListingQuery({
 *   variables: {
 *      purchaserPaymentPlanId: // value for 'purchaserPaymentPlanId'
 *   },
 * });
 */
export function useGetPurchaserPaymentPlanDetailsListingQuery(baseOptions: Apollo.QueryHookOptions<GetPurchaserPaymentPlanDetailsListingQuery, GetPurchaserPaymentPlanDetailsListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPurchaserPaymentPlanDetailsListingQuery, GetPurchaserPaymentPlanDetailsListingQueryVariables>(GetPurchaserPaymentPlanDetailsListingDocument, options);
      }
export function useGetPurchaserPaymentPlanDetailsListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPurchaserPaymentPlanDetailsListingQuery, GetPurchaserPaymentPlanDetailsListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPurchaserPaymentPlanDetailsListingQuery, GetPurchaserPaymentPlanDetailsListingQueryVariables>(GetPurchaserPaymentPlanDetailsListingDocument, options);
        }
export type GetPurchaserPaymentPlanDetailsListingQueryHookResult = ReturnType<typeof useGetPurchaserPaymentPlanDetailsListingQuery>;
export type GetPurchaserPaymentPlanDetailsListingLazyQueryHookResult = ReturnType<typeof useGetPurchaserPaymentPlanDetailsListingLazyQuery>;
export type GetPurchaserPaymentPlanDetailsListingQueryResult = Apollo.QueryResult<GetPurchaserPaymentPlanDetailsListingQuery, GetPurchaserPaymentPlanDetailsListingQueryVariables>;
export const GetPurchaserPaymentPlanByIdDocument = gql`
    query getPurchaserPaymentPlanById($id: String!) {
  getPurchaserPaymentPlanById(id: $id) {
    name
    id
    accountId
    recordStatus
    effectiveDate
    markUpPercentage
    details {
      id
      purchaserPaymentPlanId
      title
      paymentBy
      paymentValue
      billType
      noInstallment
      deductBookingFee
      billCount
      billFrequency
      billAfter
    }
  }
}
    `;

/**
 * __useGetPurchaserPaymentPlanByIdQuery__
 *
 * To run a query within a React component, call `useGetPurchaserPaymentPlanByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPurchaserPaymentPlanByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPurchaserPaymentPlanByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPurchaserPaymentPlanByIdQuery(baseOptions: Apollo.QueryHookOptions<GetPurchaserPaymentPlanByIdQuery, GetPurchaserPaymentPlanByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPurchaserPaymentPlanByIdQuery, GetPurchaserPaymentPlanByIdQueryVariables>(GetPurchaserPaymentPlanByIdDocument, options);
      }
export function useGetPurchaserPaymentPlanByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPurchaserPaymentPlanByIdQuery, GetPurchaserPaymentPlanByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPurchaserPaymentPlanByIdQuery, GetPurchaserPaymentPlanByIdQueryVariables>(GetPurchaserPaymentPlanByIdDocument, options);
        }
export type GetPurchaserPaymentPlanByIdQueryHookResult = ReturnType<typeof useGetPurchaserPaymentPlanByIdQuery>;
export type GetPurchaserPaymentPlanByIdLazyQueryHookResult = ReturnType<typeof useGetPurchaserPaymentPlanByIdLazyQuery>;
export type GetPurchaserPaymentPlanByIdQueryResult = Apollo.QueryResult<GetPurchaserPaymentPlanByIdQuery, GetPurchaserPaymentPlanByIdQueryVariables>;
export const GetPurchaserPaymentPlanEnumsOutputDocument = gql`
    query getPurchaserPaymentPlanEnumsOutput {
  getPurchaserPaymentPlanEnumsOutput {
    paymentBy {
      id
      name
    }
    billType {
      id
      name
    }
    deductBookingFee {
      id
      name
    }
    billFrequency {
      id
      name
    }
    billAfter {
      id
      name
    }
  }
}
    `;

/**
 * __useGetPurchaserPaymentPlanEnumsOutputQuery__
 *
 * To run a query within a React component, call `useGetPurchaserPaymentPlanEnumsOutputQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPurchaserPaymentPlanEnumsOutputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPurchaserPaymentPlanEnumsOutputQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPurchaserPaymentPlanEnumsOutputQuery(baseOptions?: Apollo.QueryHookOptions<GetPurchaserPaymentPlanEnumsOutputQuery, GetPurchaserPaymentPlanEnumsOutputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPurchaserPaymentPlanEnumsOutputQuery, GetPurchaserPaymentPlanEnumsOutputQueryVariables>(GetPurchaserPaymentPlanEnumsOutputDocument, options);
      }
export function useGetPurchaserPaymentPlanEnumsOutputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPurchaserPaymentPlanEnumsOutputQuery, GetPurchaserPaymentPlanEnumsOutputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPurchaserPaymentPlanEnumsOutputQuery, GetPurchaserPaymentPlanEnumsOutputQueryVariables>(GetPurchaserPaymentPlanEnumsOutputDocument, options);
        }
export type GetPurchaserPaymentPlanEnumsOutputQueryHookResult = ReturnType<typeof useGetPurchaserPaymentPlanEnumsOutputQuery>;
export type GetPurchaserPaymentPlanEnumsOutputLazyQueryHookResult = ReturnType<typeof useGetPurchaserPaymentPlanEnumsOutputLazyQuery>;
export type GetPurchaserPaymentPlanEnumsOutputQueryResult = Apollo.QueryResult<GetPurchaserPaymentPlanEnumsOutputQuery, GetPurchaserPaymentPlanEnumsOutputQueryVariables>;
export const DeletePurchaserPaymentPlanDocument = gql`
    mutation deletePurchaserPaymentPlan($purchaserPaymentID: String!) {
  deletePurchaserPaymentPlan(purchaserPaymentID: $purchaserPaymentID)
}
    `;
export type DeletePurchaserPaymentPlanMutationFn = Apollo.MutationFunction<DeletePurchaserPaymentPlanMutation, DeletePurchaserPaymentPlanMutationVariables>;

/**
 * __useDeletePurchaserPaymentPlanMutation__
 *
 * To run a mutation, you first call `useDeletePurchaserPaymentPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePurchaserPaymentPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePurchaserPaymentPlanMutation, { data, loading, error }] = useDeletePurchaserPaymentPlanMutation({
 *   variables: {
 *      purchaserPaymentID: // value for 'purchaserPaymentID'
 *   },
 * });
 */
export function useDeletePurchaserPaymentPlanMutation(baseOptions?: Apollo.MutationHookOptions<DeletePurchaserPaymentPlanMutation, DeletePurchaserPaymentPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePurchaserPaymentPlanMutation, DeletePurchaserPaymentPlanMutationVariables>(DeletePurchaserPaymentPlanDocument, options);
      }
export type DeletePurchaserPaymentPlanMutationHookResult = ReturnType<typeof useDeletePurchaserPaymentPlanMutation>;
export type DeletePurchaserPaymentPlanMutationResult = Apollo.MutationResult<DeletePurchaserPaymentPlanMutation>;
export type DeletePurchaserPaymentPlanMutationOptions = Apollo.BaseMutationOptions<DeletePurchaserPaymentPlanMutation, DeletePurchaserPaymentPlanMutationVariables>;
export const AddPurchaserPaymentPlanDocument = gql`
    mutation addPurchaserPaymentPlan($input: AddPurchaserPaymentPlanInput!) {
  addPurchaserPaymentPlan(input: $input)
}
    `;
export type AddPurchaserPaymentPlanMutationFn = Apollo.MutationFunction<AddPurchaserPaymentPlanMutation, AddPurchaserPaymentPlanMutationVariables>;

/**
 * __useAddPurchaserPaymentPlanMutation__
 *
 * To run a mutation, you first call `useAddPurchaserPaymentPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPurchaserPaymentPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPurchaserPaymentPlanMutation, { data, loading, error }] = useAddPurchaserPaymentPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPurchaserPaymentPlanMutation(baseOptions?: Apollo.MutationHookOptions<AddPurchaserPaymentPlanMutation, AddPurchaserPaymentPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPurchaserPaymentPlanMutation, AddPurchaserPaymentPlanMutationVariables>(AddPurchaserPaymentPlanDocument, options);
      }
export type AddPurchaserPaymentPlanMutationHookResult = ReturnType<typeof useAddPurchaserPaymentPlanMutation>;
export type AddPurchaserPaymentPlanMutationResult = Apollo.MutationResult<AddPurchaserPaymentPlanMutation>;
export type AddPurchaserPaymentPlanMutationOptions = Apollo.BaseMutationOptions<AddPurchaserPaymentPlanMutation, AddPurchaserPaymentPlanMutationVariables>;
export const EditPurchaserPaymentPlanAndDetailsDocument = gql`
    mutation editPurchaserPaymentPlanAndDetails($input: EditPurchaserPaymentPlanInput!) {
  editPurchaserPaymentPlanAndDetails(input: $input)
}
    `;
export type EditPurchaserPaymentPlanAndDetailsMutationFn = Apollo.MutationFunction<EditPurchaserPaymentPlanAndDetailsMutation, EditPurchaserPaymentPlanAndDetailsMutationVariables>;

/**
 * __useEditPurchaserPaymentPlanAndDetailsMutation__
 *
 * To run a mutation, you first call `useEditPurchaserPaymentPlanAndDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPurchaserPaymentPlanAndDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPurchaserPaymentPlanAndDetailsMutation, { data, loading, error }] = useEditPurchaserPaymentPlanAndDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditPurchaserPaymentPlanAndDetailsMutation(baseOptions?: Apollo.MutationHookOptions<EditPurchaserPaymentPlanAndDetailsMutation, EditPurchaserPaymentPlanAndDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditPurchaserPaymentPlanAndDetailsMutation, EditPurchaserPaymentPlanAndDetailsMutationVariables>(EditPurchaserPaymentPlanAndDetailsDocument, options);
      }
export type EditPurchaserPaymentPlanAndDetailsMutationHookResult = ReturnType<typeof useEditPurchaserPaymentPlanAndDetailsMutation>;
export type EditPurchaserPaymentPlanAndDetailsMutationResult = Apollo.MutationResult<EditPurchaserPaymentPlanAndDetailsMutation>;
export type EditPurchaserPaymentPlanAndDetailsMutationOptions = Apollo.BaseMutationOptions<EditPurchaserPaymentPlanAndDetailsMutation, EditPurchaserPaymentPlanAndDetailsMutationVariables>;
export const DeletePurchaserPaymentPlanDetailsDocument = gql`
    mutation deletePurchaserPaymentPlanDetails($purchaserDetailsId: String!) {
  deletePurchaserPaymentPlanDetails(purchaserDetailsId: $purchaserDetailsId)
}
    `;
export type DeletePurchaserPaymentPlanDetailsMutationFn = Apollo.MutationFunction<DeletePurchaserPaymentPlanDetailsMutation, DeletePurchaserPaymentPlanDetailsMutationVariables>;

/**
 * __useDeletePurchaserPaymentPlanDetailsMutation__
 *
 * To run a mutation, you first call `useDeletePurchaserPaymentPlanDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePurchaserPaymentPlanDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePurchaserPaymentPlanDetailsMutation, { data, loading, error }] = useDeletePurchaserPaymentPlanDetailsMutation({
 *   variables: {
 *      purchaserDetailsId: // value for 'purchaserDetailsId'
 *   },
 * });
 */
export function useDeletePurchaserPaymentPlanDetailsMutation(baseOptions?: Apollo.MutationHookOptions<DeletePurchaserPaymentPlanDetailsMutation, DeletePurchaserPaymentPlanDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePurchaserPaymentPlanDetailsMutation, DeletePurchaserPaymentPlanDetailsMutationVariables>(DeletePurchaserPaymentPlanDetailsDocument, options);
      }
export type DeletePurchaserPaymentPlanDetailsMutationHookResult = ReturnType<typeof useDeletePurchaserPaymentPlanDetailsMutation>;
export type DeletePurchaserPaymentPlanDetailsMutationResult = Apollo.MutationResult<DeletePurchaserPaymentPlanDetailsMutation>;
export type DeletePurchaserPaymentPlanDetailsMutationOptions = Apollo.BaseMutationOptions<DeletePurchaserPaymentPlanDetailsMutation, DeletePurchaserPaymentPlanDetailsMutationVariables>;
export const AddPurchaserPaymentPlanDetailsDocument = gql`
    mutation addPurchaserPaymentPlanDetails($input: AddPurchaserPaymentPlantDetailsInput!, $paymentPlanId: String!) {
  addPurchaserPaymentPlanDetails(input: $input, paymentPlanId: $paymentPlanId) {
    id
  }
}
    `;
export type AddPurchaserPaymentPlanDetailsMutationFn = Apollo.MutationFunction<AddPurchaserPaymentPlanDetailsMutation, AddPurchaserPaymentPlanDetailsMutationVariables>;

/**
 * __useAddPurchaserPaymentPlanDetailsMutation__
 *
 * To run a mutation, you first call `useAddPurchaserPaymentPlanDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPurchaserPaymentPlanDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPurchaserPaymentPlanDetailsMutation, { data, loading, error }] = useAddPurchaserPaymentPlanDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *      paymentPlanId: // value for 'paymentPlanId'
 *   },
 * });
 */
export function useAddPurchaserPaymentPlanDetailsMutation(baseOptions?: Apollo.MutationHookOptions<AddPurchaserPaymentPlanDetailsMutation, AddPurchaserPaymentPlanDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPurchaserPaymentPlanDetailsMutation, AddPurchaserPaymentPlanDetailsMutationVariables>(AddPurchaserPaymentPlanDetailsDocument, options);
      }
export type AddPurchaserPaymentPlanDetailsMutationHookResult = ReturnType<typeof useAddPurchaserPaymentPlanDetailsMutation>;
export type AddPurchaserPaymentPlanDetailsMutationResult = Apollo.MutationResult<AddPurchaserPaymentPlanDetailsMutation>;
export type AddPurchaserPaymentPlanDetailsMutationOptions = Apollo.BaseMutationOptions<AddPurchaserPaymentPlanDetailsMutation, AddPurchaserPaymentPlanDetailsMutationVariables>;
export const EditPurchaserPaymentPlanDocument = gql`
    mutation editPurchaserPaymentPlan($input: EditPurchaserPaymentPlanInput!) {
  editPurchaserPaymentPlan(input: $input)
}
    `;
export type EditPurchaserPaymentPlanMutationFn = Apollo.MutationFunction<EditPurchaserPaymentPlanMutation, EditPurchaserPaymentPlanMutationVariables>;

/**
 * __useEditPurchaserPaymentPlanMutation__
 *
 * To run a mutation, you first call `useEditPurchaserPaymentPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPurchaserPaymentPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPurchaserPaymentPlanMutation, { data, loading, error }] = useEditPurchaserPaymentPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditPurchaserPaymentPlanMutation(baseOptions?: Apollo.MutationHookOptions<EditPurchaserPaymentPlanMutation, EditPurchaserPaymentPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditPurchaserPaymentPlanMutation, EditPurchaserPaymentPlanMutationVariables>(EditPurchaserPaymentPlanDocument, options);
      }
export type EditPurchaserPaymentPlanMutationHookResult = ReturnType<typeof useEditPurchaserPaymentPlanMutation>;
export type EditPurchaserPaymentPlanMutationResult = Apollo.MutationResult<EditPurchaserPaymentPlanMutation>;
export type EditPurchaserPaymentPlanMutationOptions = Apollo.BaseMutationOptions<EditPurchaserPaymentPlanMutation, EditPurchaserPaymentPlanMutationVariables>;
export const EditPurchaserPaymentPlanDetailsDocument = gql`
    mutation editPurchaserPaymentPlanDetails($input: AddPurchaserPaymentPlantDetailsInput!) {
  editPurchaserPaymentPlanDetails(input: $input)
}
    `;
export type EditPurchaserPaymentPlanDetailsMutationFn = Apollo.MutationFunction<EditPurchaserPaymentPlanDetailsMutation, EditPurchaserPaymentPlanDetailsMutationVariables>;

/**
 * __useEditPurchaserPaymentPlanDetailsMutation__
 *
 * To run a mutation, you first call `useEditPurchaserPaymentPlanDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPurchaserPaymentPlanDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPurchaserPaymentPlanDetailsMutation, { data, loading, error }] = useEditPurchaserPaymentPlanDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditPurchaserPaymentPlanDetailsMutation(baseOptions?: Apollo.MutationHookOptions<EditPurchaserPaymentPlanDetailsMutation, EditPurchaserPaymentPlanDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditPurchaserPaymentPlanDetailsMutation, EditPurchaserPaymentPlanDetailsMutationVariables>(EditPurchaserPaymentPlanDetailsDocument, options);
      }
export type EditPurchaserPaymentPlanDetailsMutationHookResult = ReturnType<typeof useEditPurchaserPaymentPlanDetailsMutation>;
export type EditPurchaserPaymentPlanDetailsMutationResult = Apollo.MutationResult<EditPurchaserPaymentPlanDetailsMutation>;
export type EditPurchaserPaymentPlanDetailsMutationOptions = Apollo.BaseMutationOptions<EditPurchaserPaymentPlanDetailsMutation, EditPurchaserPaymentPlanDetailsMutationVariables>;
export const GetReasonCodeTypeListingDocument = gql`
    query getReasonCodeTypeListing {
  getReasonCodeTypeListing {
    reasonCodeType
  }
}
    `;

/**
 * __useGetReasonCodeTypeListingQuery__
 *
 * To run a query within a React component, call `useGetReasonCodeTypeListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReasonCodeTypeListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReasonCodeTypeListingQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReasonCodeTypeListingQuery(baseOptions?: Apollo.QueryHookOptions<GetReasonCodeTypeListingQuery, GetReasonCodeTypeListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReasonCodeTypeListingQuery, GetReasonCodeTypeListingQueryVariables>(GetReasonCodeTypeListingDocument, options);
      }
export function useGetReasonCodeTypeListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReasonCodeTypeListingQuery, GetReasonCodeTypeListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReasonCodeTypeListingQuery, GetReasonCodeTypeListingQueryVariables>(GetReasonCodeTypeListingDocument, options);
        }
export type GetReasonCodeTypeListingQueryHookResult = ReturnType<typeof useGetReasonCodeTypeListingQuery>;
export type GetReasonCodeTypeListingLazyQueryHookResult = ReturnType<typeof useGetReasonCodeTypeListingLazyQuery>;
export type GetReasonCodeTypeListingQueryResult = Apollo.QueryResult<GetReasonCodeTypeListingQuery, GetReasonCodeTypeListingQueryVariables>;
export const GetAllReasonCodeDocument = gql`
    query getAllReasonCode($type: String!) {
  getAllReasonCode(type: $type) {
    id
    name
    commonStatus
    defaulted
    type
    systemUse
    isDeletable
    isExistInTransactionData
  }
}
    `;

/**
 * __useGetAllReasonCodeQuery__
 *
 * To run a query within a React component, call `useGetAllReasonCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllReasonCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllReasonCodeQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetAllReasonCodeQuery(baseOptions: Apollo.QueryHookOptions<GetAllReasonCodeQuery, GetAllReasonCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllReasonCodeQuery, GetAllReasonCodeQueryVariables>(GetAllReasonCodeDocument, options);
      }
export function useGetAllReasonCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllReasonCodeQuery, GetAllReasonCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllReasonCodeQuery, GetAllReasonCodeQueryVariables>(GetAllReasonCodeDocument, options);
        }
export type GetAllReasonCodeQueryHookResult = ReturnType<typeof useGetAllReasonCodeQuery>;
export type GetAllReasonCodeLazyQueryHookResult = ReturnType<typeof useGetAllReasonCodeLazyQuery>;
export type GetAllReasonCodeQueryResult = Apollo.QueryResult<GetAllReasonCodeQuery, GetAllReasonCodeQueryVariables>;
export const AddReasonCodeDocument = gql`
    mutation addReasonCode($input: ReasonCodeInput!) {
  addReasonCode(input: $input)
}
    `;
export type AddReasonCodeMutationFn = Apollo.MutationFunction<AddReasonCodeMutation, AddReasonCodeMutationVariables>;

/**
 * __useAddReasonCodeMutation__
 *
 * To run a mutation, you first call `useAddReasonCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddReasonCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addReasonCodeMutation, { data, loading, error }] = useAddReasonCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddReasonCodeMutation(baseOptions?: Apollo.MutationHookOptions<AddReasonCodeMutation, AddReasonCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddReasonCodeMutation, AddReasonCodeMutationVariables>(AddReasonCodeDocument, options);
      }
export type AddReasonCodeMutationHookResult = ReturnType<typeof useAddReasonCodeMutation>;
export type AddReasonCodeMutationResult = Apollo.MutationResult<AddReasonCodeMutation>;
export type AddReasonCodeMutationOptions = Apollo.BaseMutationOptions<AddReasonCodeMutation, AddReasonCodeMutationVariables>;
export const DeleteReasonCodeByIdDocument = gql`
    mutation deleteReasonCodeById($reasonCodeId: String!) {
  deleteReasonCodeById(reasonCodeId: $reasonCodeId)
}
    `;
export type DeleteReasonCodeByIdMutationFn = Apollo.MutationFunction<DeleteReasonCodeByIdMutation, DeleteReasonCodeByIdMutationVariables>;

/**
 * __useDeleteReasonCodeByIdMutation__
 *
 * To run a mutation, you first call `useDeleteReasonCodeByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReasonCodeByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReasonCodeByIdMutation, { data, loading, error }] = useDeleteReasonCodeByIdMutation({
 *   variables: {
 *      reasonCodeId: // value for 'reasonCodeId'
 *   },
 * });
 */
export function useDeleteReasonCodeByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReasonCodeByIdMutation, DeleteReasonCodeByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReasonCodeByIdMutation, DeleteReasonCodeByIdMutationVariables>(DeleteReasonCodeByIdDocument, options);
      }
export type DeleteReasonCodeByIdMutationHookResult = ReturnType<typeof useDeleteReasonCodeByIdMutation>;
export type DeleteReasonCodeByIdMutationResult = Apollo.MutationResult<DeleteReasonCodeByIdMutation>;
export type DeleteReasonCodeByIdMutationOptions = Apollo.BaseMutationOptions<DeleteReasonCodeByIdMutation, DeleteReasonCodeByIdMutationVariables>;
export const EditReasonCodeDocument = gql`
    mutation editReasonCode($input: EditReasonCodeInput!) {
  editReasonCode(input: $input)
}
    `;
export type EditReasonCodeMutationFn = Apollo.MutationFunction<EditReasonCodeMutation, EditReasonCodeMutationVariables>;

/**
 * __useEditReasonCodeMutation__
 *
 * To run a mutation, you first call `useEditReasonCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditReasonCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editReasonCodeMutation, { data, loading, error }] = useEditReasonCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditReasonCodeMutation(baseOptions?: Apollo.MutationHookOptions<EditReasonCodeMutation, EditReasonCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditReasonCodeMutation, EditReasonCodeMutationVariables>(EditReasonCodeDocument, options);
      }
export type EditReasonCodeMutationHookResult = ReturnType<typeof useEditReasonCodeMutation>;
export type EditReasonCodeMutationResult = Apollo.MutationResult<EditReasonCodeMutation>;
export type EditReasonCodeMutationOptions = Apollo.BaseMutationOptions<EditReasonCodeMutation, EditReasonCodeMutationVariables>;
export const SetDefaultReasonCodeDocument = gql`
    mutation setDefaultReasonCode($reasonCodeId: String!, $type: String!) {
  setDefaultReasonCode(reasonCodeId: $reasonCodeId, type: $type)
}
    `;
export type SetDefaultReasonCodeMutationFn = Apollo.MutationFunction<SetDefaultReasonCodeMutation, SetDefaultReasonCodeMutationVariables>;

/**
 * __useSetDefaultReasonCodeMutation__
 *
 * To run a mutation, you first call `useSetDefaultReasonCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultReasonCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultReasonCodeMutation, { data, loading, error }] = useSetDefaultReasonCodeMutation({
 *   variables: {
 *      reasonCodeId: // value for 'reasonCodeId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useSetDefaultReasonCodeMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultReasonCodeMutation, SetDefaultReasonCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultReasonCodeMutation, SetDefaultReasonCodeMutationVariables>(SetDefaultReasonCodeDocument, options);
      }
export type SetDefaultReasonCodeMutationHookResult = ReturnType<typeof useSetDefaultReasonCodeMutation>;
export type SetDefaultReasonCodeMutationResult = Apollo.MutationResult<SetDefaultReasonCodeMutation>;
export type SetDefaultReasonCodeMutationOptions = Apollo.BaseMutationOptions<SetDefaultReasonCodeMutation, SetDefaultReasonCodeMutationVariables>;
export const RemoveDefaultReasonCodeDocument = gql`
    mutation removeDefaultReasonCode($reasonCodeId: String!, $type: String!) {
  removeDefaultReasonCode(reasonCodeId: $reasonCodeId, type: $type)
}
    `;
export type RemoveDefaultReasonCodeMutationFn = Apollo.MutationFunction<RemoveDefaultReasonCodeMutation, RemoveDefaultReasonCodeMutationVariables>;

/**
 * __useRemoveDefaultReasonCodeMutation__
 *
 * To run a mutation, you first call `useRemoveDefaultReasonCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDefaultReasonCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDefaultReasonCodeMutation, { data, loading, error }] = useRemoveDefaultReasonCodeMutation({
 *   variables: {
 *      reasonCodeId: // value for 'reasonCodeId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useRemoveDefaultReasonCodeMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDefaultReasonCodeMutation, RemoveDefaultReasonCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveDefaultReasonCodeMutation, RemoveDefaultReasonCodeMutationVariables>(RemoveDefaultReasonCodeDocument, options);
      }
export type RemoveDefaultReasonCodeMutationHookResult = ReturnType<typeof useRemoveDefaultReasonCodeMutation>;
export type RemoveDefaultReasonCodeMutationResult = Apollo.MutationResult<RemoveDefaultReasonCodeMutation>;
export type RemoveDefaultReasonCodeMutationOptions = Apollo.BaseMutationOptions<RemoveDefaultReasonCodeMutation, RemoveDefaultReasonCodeMutationVariables>;
export const OrganizeReasonCodeDocument = gql`
    mutation organizeReasonCode($reasonCodeIds: [String!]!) {
  organizeReasonCode(reasonCodeIds: $reasonCodeIds)
}
    `;
export type OrganizeReasonCodeMutationFn = Apollo.MutationFunction<OrganizeReasonCodeMutation, OrganizeReasonCodeMutationVariables>;

/**
 * __useOrganizeReasonCodeMutation__
 *
 * To run a mutation, you first call `useOrganizeReasonCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizeReasonCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizeReasonCodeMutation, { data, loading, error }] = useOrganizeReasonCodeMutation({
 *   variables: {
 *      reasonCodeIds: // value for 'reasonCodeIds'
 *   },
 * });
 */
export function useOrganizeReasonCodeMutation(baseOptions?: Apollo.MutationHookOptions<OrganizeReasonCodeMutation, OrganizeReasonCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizeReasonCodeMutation, OrganizeReasonCodeMutationVariables>(OrganizeReasonCodeDocument, options);
      }
export type OrganizeReasonCodeMutationHookResult = ReturnType<typeof useOrganizeReasonCodeMutation>;
export type OrganizeReasonCodeMutationResult = Apollo.MutationResult<OrganizeReasonCodeMutation>;
export type OrganizeReasonCodeMutationOptions = Apollo.BaseMutationOptions<OrganizeReasonCodeMutation, OrganizeReasonCodeMutationVariables>;
export const ActivateReasonCodeDocument = gql`
    mutation activateReasonCode($reasonCodeId: String!) {
  activateReasonCode(reasonCodeId: $reasonCodeId)
}
    `;
export type ActivateReasonCodeMutationFn = Apollo.MutationFunction<ActivateReasonCodeMutation, ActivateReasonCodeMutationVariables>;

/**
 * __useActivateReasonCodeMutation__
 *
 * To run a mutation, you first call `useActivateReasonCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateReasonCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateReasonCodeMutation, { data, loading, error }] = useActivateReasonCodeMutation({
 *   variables: {
 *      reasonCodeId: // value for 'reasonCodeId'
 *   },
 * });
 */
export function useActivateReasonCodeMutation(baseOptions?: Apollo.MutationHookOptions<ActivateReasonCodeMutation, ActivateReasonCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateReasonCodeMutation, ActivateReasonCodeMutationVariables>(ActivateReasonCodeDocument, options);
      }
export type ActivateReasonCodeMutationHookResult = ReturnType<typeof useActivateReasonCodeMutation>;
export type ActivateReasonCodeMutationResult = Apollo.MutationResult<ActivateReasonCodeMutation>;
export type ActivateReasonCodeMutationOptions = Apollo.BaseMutationOptions<ActivateReasonCodeMutation, ActivateReasonCodeMutationVariables>;
export const DeactivateReasonCodeDocument = gql`
    mutation deactivateReasonCode($reasonCodeId: String!) {
  deactivateReasonCode(reasonCodeId: $reasonCodeId)
}
    `;
export type DeactivateReasonCodeMutationFn = Apollo.MutationFunction<DeactivateReasonCodeMutation, DeactivateReasonCodeMutationVariables>;

/**
 * __useDeactivateReasonCodeMutation__
 *
 * To run a mutation, you first call `useDeactivateReasonCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateReasonCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateReasonCodeMutation, { data, loading, error }] = useDeactivateReasonCodeMutation({
 *   variables: {
 *      reasonCodeId: // value for 'reasonCodeId'
 *   },
 * });
 */
export function useDeactivateReasonCodeMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateReasonCodeMutation, DeactivateReasonCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateReasonCodeMutation, DeactivateReasonCodeMutationVariables>(DeactivateReasonCodeDocument, options);
      }
export type DeactivateReasonCodeMutationHookResult = ReturnType<typeof useDeactivateReasonCodeMutation>;
export type DeactivateReasonCodeMutationResult = Apollo.MutationResult<DeactivateReasonCodeMutation>;
export type DeactivateReasonCodeMutationOptions = Apollo.BaseMutationOptions<DeactivateReasonCodeMutation, DeactivateReasonCodeMutationVariables>;
export const GetStampDutyListingDocument = gql`
    query getStampDutyListing {
  getStampDutyListing {
    id
    code
    description
    commonStatus
    stampDutyExts {
      id
      effectiveDate
    }
  }
}
    `;

/**
 * __useGetStampDutyListingQuery__
 *
 * To run a query within a React component, call `useGetStampDutyListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStampDutyListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStampDutyListingQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStampDutyListingQuery(baseOptions?: Apollo.QueryHookOptions<GetStampDutyListingQuery, GetStampDutyListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStampDutyListingQuery, GetStampDutyListingQueryVariables>(GetStampDutyListingDocument, options);
      }
export function useGetStampDutyListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStampDutyListingQuery, GetStampDutyListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStampDutyListingQuery, GetStampDutyListingQueryVariables>(GetStampDutyListingDocument, options);
        }
export type GetStampDutyListingQueryHookResult = ReturnType<typeof useGetStampDutyListingQuery>;
export type GetStampDutyListingLazyQueryHookResult = ReturnType<typeof useGetStampDutyListingLazyQuery>;
export type GetStampDutyListingQueryResult = Apollo.QueryResult<GetStampDutyListingQuery, GetStampDutyListingQueryVariables>;
export const AddStampDutyDocument = gql`
    mutation addStampDuty($input: addStampDutyInput!) {
  addStampDuty(input: $input)
}
    `;
export type AddStampDutyMutationFn = Apollo.MutationFunction<AddStampDutyMutation, AddStampDutyMutationVariables>;

/**
 * __useAddStampDutyMutation__
 *
 * To run a mutation, you first call `useAddStampDutyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddStampDutyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addStampDutyMutation, { data, loading, error }] = useAddStampDutyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddStampDutyMutation(baseOptions?: Apollo.MutationHookOptions<AddStampDutyMutation, AddStampDutyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddStampDutyMutation, AddStampDutyMutationVariables>(AddStampDutyDocument, options);
      }
export type AddStampDutyMutationHookResult = ReturnType<typeof useAddStampDutyMutation>;
export type AddStampDutyMutationResult = Apollo.MutationResult<AddStampDutyMutation>;
export type AddStampDutyMutationOptions = Apollo.BaseMutationOptions<AddStampDutyMutation, AddStampDutyMutationVariables>;
export const DeactivateStampDutyByIdDocument = gql`
    mutation deactivateStampDutyById($id: String!) {
  deactivateStampDutyById(id: $id)
}
    `;
export type DeactivateStampDutyByIdMutationFn = Apollo.MutationFunction<DeactivateStampDutyByIdMutation, DeactivateStampDutyByIdMutationVariables>;

/**
 * __useDeactivateStampDutyByIdMutation__
 *
 * To run a mutation, you first call `useDeactivateStampDutyByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateStampDutyByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateStampDutyByIdMutation, { data, loading, error }] = useDeactivateStampDutyByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeactivateStampDutyByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateStampDutyByIdMutation, DeactivateStampDutyByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateStampDutyByIdMutation, DeactivateStampDutyByIdMutationVariables>(DeactivateStampDutyByIdDocument, options);
      }
export type DeactivateStampDutyByIdMutationHookResult = ReturnType<typeof useDeactivateStampDutyByIdMutation>;
export type DeactivateStampDutyByIdMutationResult = Apollo.MutationResult<DeactivateStampDutyByIdMutation>;
export type DeactivateStampDutyByIdMutationOptions = Apollo.BaseMutationOptions<DeactivateStampDutyByIdMutation, DeactivateStampDutyByIdMutationVariables>;
export const UpdateStampDutyDocument = gql`
    mutation updateStampDuty($input: updateStampDutyInput!) {
  updateStampDuty(input: $input)
}
    `;
export type UpdateStampDutyMutationFn = Apollo.MutationFunction<UpdateStampDutyMutation, UpdateStampDutyMutationVariables>;

/**
 * __useUpdateStampDutyMutation__
 *
 * To run a mutation, you first call `useUpdateStampDutyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStampDutyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStampDutyMutation, { data, loading, error }] = useUpdateStampDutyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStampDutyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStampDutyMutation, UpdateStampDutyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStampDutyMutation, UpdateStampDutyMutationVariables>(UpdateStampDutyDocument, options);
      }
export type UpdateStampDutyMutationHookResult = ReturnType<typeof useUpdateStampDutyMutation>;
export type UpdateStampDutyMutationResult = Apollo.MutationResult<UpdateStampDutyMutation>;
export type UpdateStampDutyMutationOptions = Apollo.BaseMutationOptions<UpdateStampDutyMutation, UpdateStampDutyMutationVariables>;
export const GetStampDutyByIdDocument = gql`
    query getStampDutyById($id: String!) {
  getStampDutyById(id: $id) {
    id
    code
    description
    stampDutyExts {
      id
      effectiveDate
      stampDutyDetails {
        id
        fromAmt
        toAmt
        value
      }
    }
  }
}
    `;

/**
 * __useGetStampDutyByIdQuery__
 *
 * To run a query within a React component, call `useGetStampDutyByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStampDutyByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStampDutyByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetStampDutyByIdQuery(baseOptions: Apollo.QueryHookOptions<GetStampDutyByIdQuery, GetStampDutyByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStampDutyByIdQuery, GetStampDutyByIdQueryVariables>(GetStampDutyByIdDocument, options);
      }
export function useGetStampDutyByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStampDutyByIdQuery, GetStampDutyByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStampDutyByIdQuery, GetStampDutyByIdQueryVariables>(GetStampDutyByIdDocument, options);
        }
export type GetStampDutyByIdQueryHookResult = ReturnType<typeof useGetStampDutyByIdQuery>;
export type GetStampDutyByIdLazyQueryHookResult = ReturnType<typeof useGetStampDutyByIdLazyQuery>;
export type GetStampDutyByIdQueryResult = Apollo.QueryResult<GetStampDutyByIdQuery, GetStampDutyByIdQueryVariables>;
export const GetStatutoryDocsListDocument = gql`
    query getStatutoryDocsList {
  getStatutoryDocsList {
    id
    name
    perSalesContract
    code
  }
}
    `;

/**
 * __useGetStatutoryDocsListQuery__
 *
 * To run a query within a React component, call `useGetStatutoryDocsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStatutoryDocsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStatutoryDocsListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStatutoryDocsListQuery(baseOptions?: Apollo.QueryHookOptions<GetStatutoryDocsListQuery, GetStatutoryDocsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStatutoryDocsListQuery, GetStatutoryDocsListQueryVariables>(GetStatutoryDocsListDocument, options);
      }
export function useGetStatutoryDocsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStatutoryDocsListQuery, GetStatutoryDocsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStatutoryDocsListQuery, GetStatutoryDocsListQueryVariables>(GetStatutoryDocsListDocument, options);
        }
export type GetStatutoryDocsListQueryHookResult = ReturnType<typeof useGetStatutoryDocsListQuery>;
export type GetStatutoryDocsListLazyQueryHookResult = ReturnType<typeof useGetStatutoryDocsListLazyQuery>;
export type GetStatutoryDocsListQueryResult = Apollo.QueryResult<GetStatutoryDocsListQuery, GetStatutoryDocsListQueryVariables>;
export const IsCodeExistDocument = gql`
    query isCodeExist($code: String!, $id: String) {
  isCodeExist(code: $code, id: $id)
}
    `;

/**
 * __useIsCodeExistQuery__
 *
 * To run a query within a React component, call `useIsCodeExistQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsCodeExistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsCodeExistQuery({
 *   variables: {
 *      code: // value for 'code'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIsCodeExistQuery(baseOptions: Apollo.QueryHookOptions<IsCodeExistQuery, IsCodeExistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsCodeExistQuery, IsCodeExistQueryVariables>(IsCodeExistDocument, options);
      }
export function useIsCodeExistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsCodeExistQuery, IsCodeExistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsCodeExistQuery, IsCodeExistQueryVariables>(IsCodeExistDocument, options);
        }
export type IsCodeExistQueryHookResult = ReturnType<typeof useIsCodeExistQuery>;
export type IsCodeExistLazyQueryHookResult = ReturnType<typeof useIsCodeExistLazyQuery>;
export type IsCodeExistQueryResult = Apollo.QueryResult<IsCodeExistQuery, IsCodeExistQueryVariables>;
export const AddStatutoryDocumentDocument = gql`
    mutation addStatutoryDocument($input: AddStatutoryDocumentIndoInput!) {
  addStatutoryDocument(input: $input)
}
    `;
export type AddStatutoryDocumentMutationFn = Apollo.MutationFunction<AddStatutoryDocumentMutation, AddStatutoryDocumentMutationVariables>;

/**
 * __useAddStatutoryDocumentMutation__
 *
 * To run a mutation, you first call `useAddStatutoryDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddStatutoryDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addStatutoryDocumentMutation, { data, loading, error }] = useAddStatutoryDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddStatutoryDocumentMutation(baseOptions?: Apollo.MutationHookOptions<AddStatutoryDocumentMutation, AddStatutoryDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddStatutoryDocumentMutation, AddStatutoryDocumentMutationVariables>(AddStatutoryDocumentDocument, options);
      }
export type AddStatutoryDocumentMutationHookResult = ReturnType<typeof useAddStatutoryDocumentMutation>;
export type AddStatutoryDocumentMutationResult = Apollo.MutationResult<AddStatutoryDocumentMutation>;
export type AddStatutoryDocumentMutationOptions = Apollo.BaseMutationOptions<AddStatutoryDocumentMutation, AddStatutoryDocumentMutationVariables>;
export const EditStatutoryDocumentDocument = gql`
    mutation editStatutoryDocument($input: EditStatutoryDocumentIndoInput!) {
  editStatutoryDocument(input: $input)
}
    `;
export type EditStatutoryDocumentMutationFn = Apollo.MutationFunction<EditStatutoryDocumentMutation, EditStatutoryDocumentMutationVariables>;

/**
 * __useEditStatutoryDocumentMutation__
 *
 * To run a mutation, you first call `useEditStatutoryDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditStatutoryDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editStatutoryDocumentMutation, { data, loading, error }] = useEditStatutoryDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditStatutoryDocumentMutation(baseOptions?: Apollo.MutationHookOptions<EditStatutoryDocumentMutation, EditStatutoryDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditStatutoryDocumentMutation, EditStatutoryDocumentMutationVariables>(EditStatutoryDocumentDocument, options);
      }
export type EditStatutoryDocumentMutationHookResult = ReturnType<typeof useEditStatutoryDocumentMutation>;
export type EditStatutoryDocumentMutationResult = Apollo.MutationResult<EditStatutoryDocumentMutation>;
export type EditStatutoryDocumentMutationOptions = Apollo.BaseMutationOptions<EditStatutoryDocumentMutation, EditStatutoryDocumentMutationVariables>;
export const DeleteStatutoryDocumentDocument = gql`
    mutation deleteStatutoryDocument($input: String!) {
  deleteStatutoryDocument(input: $input)
}
    `;
export type DeleteStatutoryDocumentMutationFn = Apollo.MutationFunction<DeleteStatutoryDocumentMutation, DeleteStatutoryDocumentMutationVariables>;

/**
 * __useDeleteStatutoryDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteStatutoryDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStatutoryDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStatutoryDocumentMutation, { data, loading, error }] = useDeleteStatutoryDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteStatutoryDocumentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteStatutoryDocumentMutation, DeleteStatutoryDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteStatutoryDocumentMutation, DeleteStatutoryDocumentMutationVariables>(DeleteStatutoryDocumentDocument, options);
      }
export type DeleteStatutoryDocumentMutationHookResult = ReturnType<typeof useDeleteStatutoryDocumentMutation>;
export type DeleteStatutoryDocumentMutationResult = Apollo.MutationResult<DeleteStatutoryDocumentMutation>;
export type DeleteStatutoryDocumentMutationOptions = Apollo.BaseMutationOptions<DeleteStatutoryDocumentMutation, DeleteStatutoryDocumentMutationVariables>;
export const GetTaxSchemeListDocument = gql`
    query getTaxSchemeList {
  getTaxSchemeList {
    id
    name
    description
    commonStatus
    modTs
    isExclusive
  }
}
    `;

/**
 * __useGetTaxSchemeListQuery__
 *
 * To run a query within a React component, call `useGetTaxSchemeListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaxSchemeListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaxSchemeListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTaxSchemeListQuery(baseOptions?: Apollo.QueryHookOptions<GetTaxSchemeListQuery, GetTaxSchemeListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaxSchemeListQuery, GetTaxSchemeListQueryVariables>(GetTaxSchemeListDocument, options);
      }
export function useGetTaxSchemeListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaxSchemeListQuery, GetTaxSchemeListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaxSchemeListQuery, GetTaxSchemeListQueryVariables>(GetTaxSchemeListDocument, options);
        }
export type GetTaxSchemeListQueryHookResult = ReturnType<typeof useGetTaxSchemeListQuery>;
export type GetTaxSchemeListLazyQueryHookResult = ReturnType<typeof useGetTaxSchemeListLazyQuery>;
export type GetTaxSchemeListQueryResult = Apollo.QueryResult<GetTaxSchemeListQuery, GetTaxSchemeListQueryVariables>;
export const GetTaxSchemeByIdDocument = gql`
    query getTaxSchemeById($id: String!) {
  getTaxSchemeById(id: $id) {
    name
    description
    isExclusive
    taxSchemeDetails {
      id
      effectiveDate
      taxSchemeDetailItems {
        id
        seqNo
        taxId
        computeMethod
        taxOnSeq {
          taxSchemeDetailItemId
          seqNo
        }
      }
    }
  }
}
    `;

/**
 * __useGetTaxSchemeByIdQuery__
 *
 * To run a query within a React component, call `useGetTaxSchemeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaxSchemeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaxSchemeByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTaxSchemeByIdQuery(baseOptions: Apollo.QueryHookOptions<GetTaxSchemeByIdQuery, GetTaxSchemeByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaxSchemeByIdQuery, GetTaxSchemeByIdQueryVariables>(GetTaxSchemeByIdDocument, options);
      }
export function useGetTaxSchemeByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaxSchemeByIdQuery, GetTaxSchemeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaxSchemeByIdQuery, GetTaxSchemeByIdQueryVariables>(GetTaxSchemeByIdDocument, options);
        }
export type GetTaxSchemeByIdQueryHookResult = ReturnType<typeof useGetTaxSchemeByIdQuery>;
export type GetTaxSchemeByIdLazyQueryHookResult = ReturnType<typeof useGetTaxSchemeByIdLazyQuery>;
export type GetTaxSchemeByIdQueryResult = Apollo.QueryResult<GetTaxSchemeByIdQuery, GetTaxSchemeByIdQueryVariables>;
export const GetTaxSchemeTaxDocument = gql`
    query getTaxSchemeTax {
  getTaxSchemeTax {
    taxId
    code
    rate
    effectiveDate
    schemeTypeId
    schemeType
    classType
  }
}
    `;

/**
 * __useGetTaxSchemeTaxQuery__
 *
 * To run a query within a React component, call `useGetTaxSchemeTaxQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaxSchemeTaxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaxSchemeTaxQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTaxSchemeTaxQuery(baseOptions?: Apollo.QueryHookOptions<GetTaxSchemeTaxQuery, GetTaxSchemeTaxQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaxSchemeTaxQuery, GetTaxSchemeTaxQueryVariables>(GetTaxSchemeTaxDocument, options);
      }
export function useGetTaxSchemeTaxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaxSchemeTaxQuery, GetTaxSchemeTaxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaxSchemeTaxQuery, GetTaxSchemeTaxQueryVariables>(GetTaxSchemeTaxDocument, options);
        }
export type GetTaxSchemeTaxQueryHookResult = ReturnType<typeof useGetTaxSchemeTaxQuery>;
export type GetTaxSchemeTaxLazyQueryHookResult = ReturnType<typeof useGetTaxSchemeTaxLazyQuery>;
export type GetTaxSchemeTaxQueryResult = Apollo.QueryResult<GetTaxSchemeTaxQuery, GetTaxSchemeTaxQueryVariables>;
export const AddTaxSchemeDocument = gql`
    mutation addTaxScheme($input: AddTaxSchemeInput!) {
  addTaxScheme(input: $input)
}
    `;
export type AddTaxSchemeMutationFn = Apollo.MutationFunction<AddTaxSchemeMutation, AddTaxSchemeMutationVariables>;

/**
 * __useAddTaxSchemeMutation__
 *
 * To run a mutation, you first call `useAddTaxSchemeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTaxSchemeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTaxSchemeMutation, { data, loading, error }] = useAddTaxSchemeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddTaxSchemeMutation(baseOptions?: Apollo.MutationHookOptions<AddTaxSchemeMutation, AddTaxSchemeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTaxSchemeMutation, AddTaxSchemeMutationVariables>(AddTaxSchemeDocument, options);
      }
export type AddTaxSchemeMutationHookResult = ReturnType<typeof useAddTaxSchemeMutation>;
export type AddTaxSchemeMutationResult = Apollo.MutationResult<AddTaxSchemeMutation>;
export type AddTaxSchemeMutationOptions = Apollo.BaseMutationOptions<AddTaxSchemeMutation, AddTaxSchemeMutationVariables>;
export const EditTaxSchemeDocument = gql`
    mutation editTaxScheme($input: EditTaxSchemeInput!) {
  editTaxScheme(input: $input)
}
    `;
export type EditTaxSchemeMutationFn = Apollo.MutationFunction<EditTaxSchemeMutation, EditTaxSchemeMutationVariables>;

/**
 * __useEditTaxSchemeMutation__
 *
 * To run a mutation, you first call `useEditTaxSchemeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditTaxSchemeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editTaxSchemeMutation, { data, loading, error }] = useEditTaxSchemeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditTaxSchemeMutation(baseOptions?: Apollo.MutationHookOptions<EditTaxSchemeMutation, EditTaxSchemeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditTaxSchemeMutation, EditTaxSchemeMutationVariables>(EditTaxSchemeDocument, options);
      }
export type EditTaxSchemeMutationHookResult = ReturnType<typeof useEditTaxSchemeMutation>;
export type EditTaxSchemeMutationResult = Apollo.MutationResult<EditTaxSchemeMutation>;
export type EditTaxSchemeMutationOptions = Apollo.BaseMutationOptions<EditTaxSchemeMutation, EditTaxSchemeMutationVariables>;
export const DeactivateTaxSchemeDocument = gql`
    mutation deactivateTaxScheme($taxSchemeId: String!, $isDeletable: Boolean!) {
  deactivateTaxScheme(taxSchemeId: $taxSchemeId, isDeletable: $isDeletable)
}
    `;
export type DeactivateTaxSchemeMutationFn = Apollo.MutationFunction<DeactivateTaxSchemeMutation, DeactivateTaxSchemeMutationVariables>;

/**
 * __useDeactivateTaxSchemeMutation__
 *
 * To run a mutation, you first call `useDeactivateTaxSchemeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateTaxSchemeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateTaxSchemeMutation, { data, loading, error }] = useDeactivateTaxSchemeMutation({
 *   variables: {
 *      taxSchemeId: // value for 'taxSchemeId'
 *      isDeletable: // value for 'isDeletable'
 *   },
 * });
 */
export function useDeactivateTaxSchemeMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateTaxSchemeMutation, DeactivateTaxSchemeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateTaxSchemeMutation, DeactivateTaxSchemeMutationVariables>(DeactivateTaxSchemeDocument, options);
      }
export type DeactivateTaxSchemeMutationHookResult = ReturnType<typeof useDeactivateTaxSchemeMutation>;
export type DeactivateTaxSchemeMutationResult = Apollo.MutationResult<DeactivateTaxSchemeMutation>;
export type DeactivateTaxSchemeMutationOptions = Apollo.BaseMutationOptions<DeactivateTaxSchemeMutation, DeactivateTaxSchemeMutationVariables>;
export const ActivateTaxSchemeDocument = gql`
    mutation activateTaxScheme($taxSchemeId: String!) {
  activateTaxScheme(taxSchemeId: $taxSchemeId)
}
    `;
export type ActivateTaxSchemeMutationFn = Apollo.MutationFunction<ActivateTaxSchemeMutation, ActivateTaxSchemeMutationVariables>;

/**
 * __useActivateTaxSchemeMutation__
 *
 * To run a mutation, you first call `useActivateTaxSchemeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateTaxSchemeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateTaxSchemeMutation, { data, loading, error }] = useActivateTaxSchemeMutation({
 *   variables: {
 *      taxSchemeId: // value for 'taxSchemeId'
 *   },
 * });
 */
export function useActivateTaxSchemeMutation(baseOptions?: Apollo.MutationHookOptions<ActivateTaxSchemeMutation, ActivateTaxSchemeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateTaxSchemeMutation, ActivateTaxSchemeMutationVariables>(ActivateTaxSchemeDocument, options);
      }
export type ActivateTaxSchemeMutationHookResult = ReturnType<typeof useActivateTaxSchemeMutation>;
export type ActivateTaxSchemeMutationResult = Apollo.MutationResult<ActivateTaxSchemeMutation>;
export type ActivateTaxSchemeMutationOptions = Apollo.BaseMutationOptions<ActivateTaxSchemeMutation, ActivateTaxSchemeMutationVariables>;
export const GetTaxSchemeOutputListingDocument = gql`
    query getTaxSchemeOutputListing {
  getTaxSchemeOutputListing {
    taxSchemeId
    taxSchemeName
    effectiveDate
    isExclusive
    taxSchemeDetailId
    totalTaxRate
    taxSchemeDetailItems {
      taxId
      taxCode
      taxRate
    }
  }
}
    `;

/**
 * __useGetTaxSchemeOutputListingQuery__
 *
 * To run a query within a React component, call `useGetTaxSchemeOutputListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaxSchemeOutputListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaxSchemeOutputListingQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTaxSchemeOutputListingQuery(baseOptions?: Apollo.QueryHookOptions<GetTaxSchemeOutputListingQuery, GetTaxSchemeOutputListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaxSchemeOutputListingQuery, GetTaxSchemeOutputListingQueryVariables>(GetTaxSchemeOutputListingDocument, options);
      }
export function useGetTaxSchemeOutputListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaxSchemeOutputListingQuery, GetTaxSchemeOutputListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaxSchemeOutputListingQuery, GetTaxSchemeOutputListingQueryVariables>(GetTaxSchemeOutputListingDocument, options);
        }
export type GetTaxSchemeOutputListingQueryHookResult = ReturnType<typeof useGetTaxSchemeOutputListingQuery>;
export type GetTaxSchemeOutputListingLazyQueryHookResult = ReturnType<typeof useGetTaxSchemeOutputListingLazyQuery>;
export type GetTaxSchemeOutputListingQueryResult = Apollo.QueryResult<GetTaxSchemeOutputListingQuery, GetTaxSchemeOutputListingQueryVariables>;
export const GetTaxSchemeInputListingDocument = gql`
    query getTaxSchemeInputListing {
  getTaxSchemeInputListing {
    taxSchemeId
    taxSchemeName
    effectiveDate
    isExclusive
    taxSchemeDetailId
    totalTaxRate
    taxSchemeDetailItems {
      taxId
      taxCode
      taxRate
    }
  }
}
    `;

/**
 * __useGetTaxSchemeInputListingQuery__
 *
 * To run a query within a React component, call `useGetTaxSchemeInputListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaxSchemeInputListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaxSchemeInputListingQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTaxSchemeInputListingQuery(baseOptions?: Apollo.QueryHookOptions<GetTaxSchemeInputListingQuery, GetTaxSchemeInputListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaxSchemeInputListingQuery, GetTaxSchemeInputListingQueryVariables>(GetTaxSchemeInputListingDocument, options);
      }
export function useGetTaxSchemeInputListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaxSchemeInputListingQuery, GetTaxSchemeInputListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaxSchemeInputListingQuery, GetTaxSchemeInputListingQueryVariables>(GetTaxSchemeInputListingDocument, options);
        }
export type GetTaxSchemeInputListingQueryHookResult = ReturnType<typeof useGetTaxSchemeInputListingQuery>;
export type GetTaxSchemeInputListingLazyQueryHookResult = ReturnType<typeof useGetTaxSchemeInputListingLazyQuery>;
export type GetTaxSchemeInputListingQueryResult = Apollo.QueryResult<GetTaxSchemeInputListingQuery, GetTaxSchemeInputListingQueryVariables>;
export const CalculateTaxAmountDocument = gql`
    query calculateTaxAmount($input: calculateTaxAmountInput!) {
  calculateTaxAmount(input: $input)
}
    `;

/**
 * __useCalculateTaxAmountQuery__
 *
 * To run a query within a React component, call `useCalculateTaxAmountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalculateTaxAmountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalculateTaxAmountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCalculateTaxAmountQuery(baseOptions: Apollo.QueryHookOptions<CalculateTaxAmountQuery, CalculateTaxAmountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalculateTaxAmountQuery, CalculateTaxAmountQueryVariables>(CalculateTaxAmountDocument, options);
      }
export function useCalculateTaxAmountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalculateTaxAmountQuery, CalculateTaxAmountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalculateTaxAmountQuery, CalculateTaxAmountQueryVariables>(CalculateTaxAmountDocument, options);
        }
export type CalculateTaxAmountQueryHookResult = ReturnType<typeof useCalculateTaxAmountQuery>;
export type CalculateTaxAmountLazyQueryHookResult = ReturnType<typeof useCalculateTaxAmountLazyQuery>;
export type CalculateTaxAmountQueryResult = Apollo.QueryResult<CalculateTaxAmountQuery, CalculateTaxAmountQueryVariables>;
export const GetTaxSchemeListingDocument = gql`
    query getTaxSchemeListing {
  getTaxSchemeListing {
    schemeTypeId
    schemeType
    lastUpdatedDate
  }
}
    `;

/**
 * __useGetTaxSchemeListingQuery__
 *
 * To run a query within a React component, call `useGetTaxSchemeListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaxSchemeListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaxSchemeListingQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTaxSchemeListingQuery(baseOptions?: Apollo.QueryHookOptions<GetTaxSchemeListingQuery, GetTaxSchemeListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaxSchemeListingQuery, GetTaxSchemeListingQueryVariables>(GetTaxSchemeListingDocument, options);
      }
export function useGetTaxSchemeListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaxSchemeListingQuery, GetTaxSchemeListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaxSchemeListingQuery, GetTaxSchemeListingQueryVariables>(GetTaxSchemeListingDocument, options);
        }
export type GetTaxSchemeListingQueryHookResult = ReturnType<typeof useGetTaxSchemeListingQuery>;
export type GetTaxSchemeListingLazyQueryHookResult = ReturnType<typeof useGetTaxSchemeListingLazyQuery>;
export type GetTaxSchemeListingQueryResult = Apollo.QueryResult<GetTaxSchemeListingQuery, GetTaxSchemeListingQueryVariables>;
export const GetTaxListingDocument = gql`
    query getTaxListing($schemeTypeId: [String!]!) {
  getTaxListing(schemeTypeId: $schemeTypeId) {
    taxId
    code
    description
    classType
    taxStatus
    effectiveDate
    rate
    isExistInMasterData
    isExistInTransactionData
    schemeTypeId
    createdDt
  }
}
    `;

/**
 * __useGetTaxListingQuery__
 *
 * To run a query within a React component, call `useGetTaxListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaxListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaxListingQuery({
 *   variables: {
 *      schemeTypeId: // value for 'schemeTypeId'
 *   },
 * });
 */
export function useGetTaxListingQuery(baseOptions: Apollo.QueryHookOptions<GetTaxListingQuery, GetTaxListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaxListingQuery, GetTaxListingQueryVariables>(GetTaxListingDocument, options);
      }
export function useGetTaxListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaxListingQuery, GetTaxListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaxListingQuery, GetTaxListingQueryVariables>(GetTaxListingDocument, options);
        }
export type GetTaxListingQueryHookResult = ReturnType<typeof useGetTaxListingQuery>;
export type GetTaxListingLazyQueryHookResult = ReturnType<typeof useGetTaxListingLazyQuery>;
export type GetTaxListingQueryResult = Apollo.QueryResult<GetTaxListingQuery, GetTaxListingQueryVariables>;
export const AddTaxDocument = gql`
    mutation addTax($input: AddTaxInput!) {
  addTax(input: $input)
}
    `;
export type AddTaxMutationFn = Apollo.MutationFunction<AddTaxMutation, AddTaxMutationVariables>;

/**
 * __useAddTaxMutation__
 *
 * To run a mutation, you first call `useAddTaxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTaxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTaxMutation, { data, loading, error }] = useAddTaxMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddTaxMutation(baseOptions?: Apollo.MutationHookOptions<AddTaxMutation, AddTaxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTaxMutation, AddTaxMutationVariables>(AddTaxDocument, options);
      }
export type AddTaxMutationHookResult = ReturnType<typeof useAddTaxMutation>;
export type AddTaxMutationResult = Apollo.MutationResult<AddTaxMutation>;
export type AddTaxMutationOptions = Apollo.BaseMutationOptions<AddTaxMutation, AddTaxMutationVariables>;
export const EditTaxDocument = gql`
    mutation editTax($input: EditTaxInput!) {
  editTax(input: $input)
}
    `;
export type EditTaxMutationFn = Apollo.MutationFunction<EditTaxMutation, EditTaxMutationVariables>;

/**
 * __useEditTaxMutation__
 *
 * To run a mutation, you first call `useEditTaxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditTaxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editTaxMutation, { data, loading, error }] = useEditTaxMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditTaxMutation(baseOptions?: Apollo.MutationHookOptions<EditTaxMutation, EditTaxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditTaxMutation, EditTaxMutationVariables>(EditTaxDocument, options);
      }
export type EditTaxMutationHookResult = ReturnType<typeof useEditTaxMutation>;
export type EditTaxMutationResult = Apollo.MutationResult<EditTaxMutation>;
export type EditTaxMutationOptions = Apollo.BaseMutationOptions<EditTaxMutation, EditTaxMutationVariables>;
export const DeactivateTaxDocument = gql`
    mutation deactivateTax($taxId: String!, $isDeletable: Boolean!) {
  deactivateTax(taxId: $taxId, isDeletable: $isDeletable)
}
    `;
export type DeactivateTaxMutationFn = Apollo.MutationFunction<DeactivateTaxMutation, DeactivateTaxMutationVariables>;

/**
 * __useDeactivateTaxMutation__
 *
 * To run a mutation, you first call `useDeactivateTaxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateTaxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateTaxMutation, { data, loading, error }] = useDeactivateTaxMutation({
 *   variables: {
 *      taxId: // value for 'taxId'
 *      isDeletable: // value for 'isDeletable'
 *   },
 * });
 */
export function useDeactivateTaxMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateTaxMutation, DeactivateTaxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateTaxMutation, DeactivateTaxMutationVariables>(DeactivateTaxDocument, options);
      }
export type DeactivateTaxMutationHookResult = ReturnType<typeof useDeactivateTaxMutation>;
export type DeactivateTaxMutationResult = Apollo.MutationResult<DeactivateTaxMutation>;
export type DeactivateTaxMutationOptions = Apollo.BaseMutationOptions<DeactivateTaxMutation, DeactivateTaxMutationVariables>;
export const ActivateTaxDocument = gql`
    mutation activateTax($taxId: String!) {
  activateTax(taxId: $taxId)
}
    `;
export type ActivateTaxMutationFn = Apollo.MutationFunction<ActivateTaxMutation, ActivateTaxMutationVariables>;

/**
 * __useActivateTaxMutation__
 *
 * To run a mutation, you first call `useActivateTaxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateTaxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateTaxMutation, { data, loading, error }] = useActivateTaxMutation({
 *   variables: {
 *      taxId: // value for 'taxId'
 *   },
 * });
 */
export function useActivateTaxMutation(baseOptions?: Apollo.MutationHookOptions<ActivateTaxMutation, ActivateTaxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateTaxMutation, ActivateTaxMutationVariables>(ActivateTaxDocument, options);
      }
export type ActivateTaxMutationHookResult = ReturnType<typeof useActivateTaxMutation>;
export type ActivateTaxMutationResult = Apollo.MutationResult<ActivateTaxMutation>;
export type ActivateTaxMutationOptions = Apollo.BaseMutationOptions<ActivateTaxMutation, ActivateTaxMutationVariables>;
export const GetTaxByIdDocument = gql`
    query getTaxById($taxId: String!) {
  getTaxById(taxId: $taxId) {
    code
    description
    classType
    schemeTypeId
    isClaimable
    schemeType {
      name
    }
    taxExt {
      isFinal
    }
    taxDetail {
      id
      commonStatus
      effectiveDate
      rate
    }
  }
}
    `;

/**
 * __useGetTaxByIdQuery__
 *
 * To run a query within a React component, call `useGetTaxByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaxByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaxByIdQuery({
 *   variables: {
 *      taxId: // value for 'taxId'
 *   },
 * });
 */
export function useGetTaxByIdQuery(baseOptions: Apollo.QueryHookOptions<GetTaxByIdQuery, GetTaxByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaxByIdQuery, GetTaxByIdQueryVariables>(GetTaxByIdDocument, options);
      }
export function useGetTaxByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaxByIdQuery, GetTaxByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaxByIdQuery, GetTaxByIdQueryVariables>(GetTaxByIdDocument, options);
        }
export type GetTaxByIdQueryHookResult = ReturnType<typeof useGetTaxByIdQuery>;
export type GetTaxByIdLazyQueryHookResult = ReturnType<typeof useGetTaxByIdLazyQuery>;
export type GetTaxByIdQueryResult = Apollo.QueryResult<GetTaxByIdQuery, GetTaxByIdQueryVariables>;
export const GetTaxSchemeTypeIdDocument = gql`
    query getTaxSchemeTypeID {
  getTaxSchemeTypeID {
    id
    code
    name
  }
}
    `;

/**
 * __useGetTaxSchemeTypeIdQuery__
 *
 * To run a query within a React component, call `useGetTaxSchemeTypeIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaxSchemeTypeIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaxSchemeTypeIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTaxSchemeTypeIdQuery(baseOptions?: Apollo.QueryHookOptions<GetTaxSchemeTypeIdQuery, GetTaxSchemeTypeIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaxSchemeTypeIdQuery, GetTaxSchemeTypeIdQueryVariables>(GetTaxSchemeTypeIdDocument, options);
      }
export function useGetTaxSchemeTypeIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaxSchemeTypeIdQuery, GetTaxSchemeTypeIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaxSchemeTypeIdQuery, GetTaxSchemeTypeIdQueryVariables>(GetTaxSchemeTypeIdDocument, options);
        }
export type GetTaxSchemeTypeIdQueryHookResult = ReturnType<typeof useGetTaxSchemeTypeIdQuery>;
export type GetTaxSchemeTypeIdLazyQueryHookResult = ReturnType<typeof useGetTaxSchemeTypeIdLazyQuery>;
export type GetTaxSchemeTypeIdQueryResult = Apollo.QueryResult<GetTaxSchemeTypeIdQuery, GetTaxSchemeTypeIdQueryVariables>;
export const GetTransactionCodeListingDocument = gql`
    query getTransactionCodeListing($id: String, $search: String) {
  getTransactionCodeListing(id: $id, search: $search) {
    id
    taxTrxCode
    description
    details {
      id
      type
      code
      description
    }
  }
}
    `;

/**
 * __useGetTransactionCodeListingQuery__
 *
 * To run a query within a React component, call `useGetTransactionCodeListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionCodeListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionCodeListingQuery({
 *   variables: {
 *      id: // value for 'id'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetTransactionCodeListingQuery(baseOptions?: Apollo.QueryHookOptions<GetTransactionCodeListingQuery, GetTransactionCodeListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransactionCodeListingQuery, GetTransactionCodeListingQueryVariables>(GetTransactionCodeListingDocument, options);
      }
export function useGetTransactionCodeListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransactionCodeListingQuery, GetTransactionCodeListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransactionCodeListingQuery, GetTransactionCodeListingQueryVariables>(GetTransactionCodeListingDocument, options);
        }
export type GetTransactionCodeListingQueryHookResult = ReturnType<typeof useGetTransactionCodeListingQuery>;
export type GetTransactionCodeListingLazyQueryHookResult = ReturnType<typeof useGetTransactionCodeListingLazyQuery>;
export type GetTransactionCodeListingQueryResult = Apollo.QueryResult<GetTransactionCodeListingQuery, GetTransactionCodeListingQueryVariables>;
export const CreateTransactionCodeDocument = gql`
    mutation createTransactionCode($taxTrxCode: String!, $description: String!) {
  createTransactionCode(taxTrxCode: $taxTrxCode, description: $description) {
    id
    taxTrxCode
    description
  }
}
    `;
export type CreateTransactionCodeMutationFn = Apollo.MutationFunction<CreateTransactionCodeMutation, CreateTransactionCodeMutationVariables>;

/**
 * __useCreateTransactionCodeMutation__
 *
 * To run a mutation, you first call `useCreateTransactionCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTransactionCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTransactionCodeMutation, { data, loading, error }] = useCreateTransactionCodeMutation({
 *   variables: {
 *      taxTrxCode: // value for 'taxTrxCode'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useCreateTransactionCodeMutation(baseOptions?: Apollo.MutationHookOptions<CreateTransactionCodeMutation, CreateTransactionCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTransactionCodeMutation, CreateTransactionCodeMutationVariables>(CreateTransactionCodeDocument, options);
      }
export type CreateTransactionCodeMutationHookResult = ReturnType<typeof useCreateTransactionCodeMutation>;
export type CreateTransactionCodeMutationResult = Apollo.MutationResult<CreateTransactionCodeMutation>;
export type CreateTransactionCodeMutationOptions = Apollo.BaseMutationOptions<CreateTransactionCodeMutation, CreateTransactionCodeMutationVariables>;
export const UpdateTransactionCodeDocument = gql`
    mutation updateTransactionCode($id: String!, $taxTrxCode: String, $description: String) {
  updateTransactionCode(id: $id, taxTrxCode: $taxTrxCode, description: $description) {
    id
    taxTrxCode
    description
  }
}
    `;
export type UpdateTransactionCodeMutationFn = Apollo.MutationFunction<UpdateTransactionCodeMutation, UpdateTransactionCodeMutationVariables>;

/**
 * __useUpdateTransactionCodeMutation__
 *
 * To run a mutation, you first call `useUpdateTransactionCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTransactionCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTransactionCodeMutation, { data, loading, error }] = useUpdateTransactionCodeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      taxTrxCode: // value for 'taxTrxCode'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUpdateTransactionCodeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTransactionCodeMutation, UpdateTransactionCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTransactionCodeMutation, UpdateTransactionCodeMutationVariables>(UpdateTransactionCodeDocument, options);
      }
export type UpdateTransactionCodeMutationHookResult = ReturnType<typeof useUpdateTransactionCodeMutation>;
export type UpdateTransactionCodeMutationResult = Apollo.MutationResult<UpdateTransactionCodeMutation>;
export type UpdateTransactionCodeMutationOptions = Apollo.BaseMutationOptions<UpdateTransactionCodeMutation, UpdateTransactionCodeMutationVariables>;
export const DeleteTransactionCodeDocument = gql`
    mutation deleteTransactionCode($id: String!) {
  deleteTransactionCode(id: $id)
}
    `;
export type DeleteTransactionCodeMutationFn = Apollo.MutationFunction<DeleteTransactionCodeMutation, DeleteTransactionCodeMutationVariables>;

/**
 * __useDeleteTransactionCodeMutation__
 *
 * To run a mutation, you first call `useDeleteTransactionCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTransactionCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTransactionCodeMutation, { data, loading, error }] = useDeleteTransactionCodeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTransactionCodeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTransactionCodeMutation, DeleteTransactionCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTransactionCodeMutation, DeleteTransactionCodeMutationVariables>(DeleteTransactionCodeDocument, options);
      }
export type DeleteTransactionCodeMutationHookResult = ReturnType<typeof useDeleteTransactionCodeMutation>;
export type DeleteTransactionCodeMutationResult = Apollo.MutationResult<DeleteTransactionCodeMutation>;
export type DeleteTransactionCodeMutationOptions = Apollo.BaseMutationOptions<DeleteTransactionCodeMutation, DeleteTransactionCodeMutationVariables>;
export const CreateTransactionCodeDetailDocument = gql`
    mutation CreateTransactionCodeDetail($input: CreateTransactionCodeDetailInput!) {
  createTransactionCodeDetail(input: $input) {
    id
    taxTransactionCodeId
    type
    code
    description
    commonStatus
  }
}
    `;
export type CreateTransactionCodeDetailMutationFn = Apollo.MutationFunction<CreateTransactionCodeDetailMutation, CreateTransactionCodeDetailMutationVariables>;

/**
 * __useCreateTransactionCodeDetailMutation__
 *
 * To run a mutation, you first call `useCreateTransactionCodeDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTransactionCodeDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTransactionCodeDetailMutation, { data, loading, error }] = useCreateTransactionCodeDetailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTransactionCodeDetailMutation(baseOptions?: Apollo.MutationHookOptions<CreateTransactionCodeDetailMutation, CreateTransactionCodeDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTransactionCodeDetailMutation, CreateTransactionCodeDetailMutationVariables>(CreateTransactionCodeDetailDocument, options);
      }
export type CreateTransactionCodeDetailMutationHookResult = ReturnType<typeof useCreateTransactionCodeDetailMutation>;
export type CreateTransactionCodeDetailMutationResult = Apollo.MutationResult<CreateTransactionCodeDetailMutation>;
export type CreateTransactionCodeDetailMutationOptions = Apollo.BaseMutationOptions<CreateTransactionCodeDetailMutation, CreateTransactionCodeDetailMutationVariables>;
export const EditTransactionCodeDetailDocument = gql`
    mutation EditTransactionCodeDetail($id: String!, $input: EditTransactionCodeDetailInput!) {
  editTransactionCodeDetail(id: $id, input: $input) {
    id
    taxTransactionCodeId
    type
    code
    description
    commonStatus
  }
}
    `;
export type EditTransactionCodeDetailMutationFn = Apollo.MutationFunction<EditTransactionCodeDetailMutation, EditTransactionCodeDetailMutationVariables>;

/**
 * __useEditTransactionCodeDetailMutation__
 *
 * To run a mutation, you first call `useEditTransactionCodeDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditTransactionCodeDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editTransactionCodeDetailMutation, { data, loading, error }] = useEditTransactionCodeDetailMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditTransactionCodeDetailMutation(baseOptions?: Apollo.MutationHookOptions<EditTransactionCodeDetailMutation, EditTransactionCodeDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditTransactionCodeDetailMutation, EditTransactionCodeDetailMutationVariables>(EditTransactionCodeDetailDocument, options);
      }
export type EditTransactionCodeDetailMutationHookResult = ReturnType<typeof useEditTransactionCodeDetailMutation>;
export type EditTransactionCodeDetailMutationResult = Apollo.MutationResult<EditTransactionCodeDetailMutation>;
export type EditTransactionCodeDetailMutationOptions = Apollo.BaseMutationOptions<EditTransactionCodeDetailMutation, EditTransactionCodeDetailMutationVariables>;
export const DeleteTransactionCodeDetailDocument = gql`
    mutation DeleteTransactionCodeDetail($id: String!) {
  deleteTransactionCodeDetail(id: $id)
}
    `;
export type DeleteTransactionCodeDetailMutationFn = Apollo.MutationFunction<DeleteTransactionCodeDetailMutation, DeleteTransactionCodeDetailMutationVariables>;

/**
 * __useDeleteTransactionCodeDetailMutation__
 *
 * To run a mutation, you first call `useDeleteTransactionCodeDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTransactionCodeDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTransactionCodeDetailMutation, { data, loading, error }] = useDeleteTransactionCodeDetailMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTransactionCodeDetailMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTransactionCodeDetailMutation, DeleteTransactionCodeDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTransactionCodeDetailMutation, DeleteTransactionCodeDetailMutationVariables>(DeleteTransactionCodeDetailDocument, options);
      }
export type DeleteTransactionCodeDetailMutationHookResult = ReturnType<typeof useDeleteTransactionCodeDetailMutation>;
export type DeleteTransactionCodeDetailMutationResult = Apollo.MutationResult<DeleteTransactionCodeDetailMutation>;
export type DeleteTransactionCodeDetailMutationOptions = Apollo.BaseMutationOptions<DeleteTransactionCodeDetailMutation, DeleteTransactionCodeDetailMutationVariables>;
export const GetUnitOfMeasurementsDocument = gql`
    query getUnitOfMeasurements {
  getUnitOfMeasurements {
    id
    uom
    description
    commonStatus
  }
}
    `;

/**
 * __useGetUnitOfMeasurementsQuery__
 *
 * To run a query within a React component, call `useGetUnitOfMeasurementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitOfMeasurementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitOfMeasurementsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUnitOfMeasurementsQuery(baseOptions?: Apollo.QueryHookOptions<GetUnitOfMeasurementsQuery, GetUnitOfMeasurementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitOfMeasurementsQuery, GetUnitOfMeasurementsQueryVariables>(GetUnitOfMeasurementsDocument, options);
      }
export function useGetUnitOfMeasurementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitOfMeasurementsQuery, GetUnitOfMeasurementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitOfMeasurementsQuery, GetUnitOfMeasurementsQueryVariables>(GetUnitOfMeasurementsDocument, options);
        }
export type GetUnitOfMeasurementsQueryHookResult = ReturnType<typeof useGetUnitOfMeasurementsQuery>;
export type GetUnitOfMeasurementsLazyQueryHookResult = ReturnType<typeof useGetUnitOfMeasurementsLazyQuery>;
export type GetUnitOfMeasurementsQueryResult = Apollo.QueryResult<GetUnitOfMeasurementsQuery, GetUnitOfMeasurementsQueryVariables>;
export const AddUnitOfMeasurementDocument = gql`
    mutation addUnitOfMeasurement($input: unitOfMeasurementMutationInput!) {
  addUnitOfMeasurement(input: $input) {
    id
    uom
    description
  }
}
    `;
export type AddUnitOfMeasurementMutationFn = Apollo.MutationFunction<AddUnitOfMeasurementMutation, AddUnitOfMeasurementMutationVariables>;

/**
 * __useAddUnitOfMeasurementMutation__
 *
 * To run a mutation, you first call `useAddUnitOfMeasurementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUnitOfMeasurementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUnitOfMeasurementMutation, { data, loading, error }] = useAddUnitOfMeasurementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddUnitOfMeasurementMutation(baseOptions?: Apollo.MutationHookOptions<AddUnitOfMeasurementMutation, AddUnitOfMeasurementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUnitOfMeasurementMutation, AddUnitOfMeasurementMutationVariables>(AddUnitOfMeasurementDocument, options);
      }
export type AddUnitOfMeasurementMutationHookResult = ReturnType<typeof useAddUnitOfMeasurementMutation>;
export type AddUnitOfMeasurementMutationResult = Apollo.MutationResult<AddUnitOfMeasurementMutation>;
export type AddUnitOfMeasurementMutationOptions = Apollo.BaseMutationOptions<AddUnitOfMeasurementMutation, AddUnitOfMeasurementMutationVariables>;
export const EditUnitOfMeasurementByIdDocument = gql`
    mutation editUnitOfMeasurementById($id: String!, $input: unitOfMeasurementMutationInput!) {
  editUnitOfMeasurementById(id: $id, input: $input) {
    id
    uom
    description
  }
}
    `;
export type EditUnitOfMeasurementByIdMutationFn = Apollo.MutationFunction<EditUnitOfMeasurementByIdMutation, EditUnitOfMeasurementByIdMutationVariables>;

/**
 * __useEditUnitOfMeasurementByIdMutation__
 *
 * To run a mutation, you first call `useEditUnitOfMeasurementByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditUnitOfMeasurementByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editUnitOfMeasurementByIdMutation, { data, loading, error }] = useEditUnitOfMeasurementByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditUnitOfMeasurementByIdMutation(baseOptions?: Apollo.MutationHookOptions<EditUnitOfMeasurementByIdMutation, EditUnitOfMeasurementByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditUnitOfMeasurementByIdMutation, EditUnitOfMeasurementByIdMutationVariables>(EditUnitOfMeasurementByIdDocument, options);
      }
export type EditUnitOfMeasurementByIdMutationHookResult = ReturnType<typeof useEditUnitOfMeasurementByIdMutation>;
export type EditUnitOfMeasurementByIdMutationResult = Apollo.MutationResult<EditUnitOfMeasurementByIdMutation>;
export type EditUnitOfMeasurementByIdMutationOptions = Apollo.BaseMutationOptions<EditUnitOfMeasurementByIdMutation, EditUnitOfMeasurementByIdMutationVariables>;
export const DeleteUnitOfMeasurementByIdDocument = gql`
    mutation deleteUnitOfMeasurementById($id: String!) {
  deleteUnitOfMeasurementById(id: $id)
}
    `;
export type DeleteUnitOfMeasurementByIdMutationFn = Apollo.MutationFunction<DeleteUnitOfMeasurementByIdMutation, DeleteUnitOfMeasurementByIdMutationVariables>;

/**
 * __useDeleteUnitOfMeasurementByIdMutation__
 *
 * To run a mutation, you first call `useDeleteUnitOfMeasurementByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUnitOfMeasurementByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUnitOfMeasurementByIdMutation, { data, loading, error }] = useDeleteUnitOfMeasurementByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUnitOfMeasurementByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUnitOfMeasurementByIdMutation, DeleteUnitOfMeasurementByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUnitOfMeasurementByIdMutation, DeleteUnitOfMeasurementByIdMutationVariables>(DeleteUnitOfMeasurementByIdDocument, options);
      }
export type DeleteUnitOfMeasurementByIdMutationHookResult = ReturnType<typeof useDeleteUnitOfMeasurementByIdMutation>;
export type DeleteUnitOfMeasurementByIdMutationResult = Apollo.MutationResult<DeleteUnitOfMeasurementByIdMutation>;
export type DeleteUnitOfMeasurementByIdMutationOptions = Apollo.BaseMutationOptions<DeleteUnitOfMeasurementByIdMutation, DeleteUnitOfMeasurementByIdMutationVariables>;
export const GetAllWorkProgressDocument = gql`
    query getAllWorkProgress {
  getAllWorkProgress {
    id
    accountId
    name
    commonStatus
    isVp
    isExistInMasterData
    isExistInTransactionData
    isSystemUse
    isCarPark
  }
}
    `;

/**
 * __useGetAllWorkProgressQuery__
 *
 * To run a query within a React component, call `useGetAllWorkProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllWorkProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllWorkProgressQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllWorkProgressQuery(baseOptions?: Apollo.QueryHookOptions<GetAllWorkProgressQuery, GetAllWorkProgressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllWorkProgressQuery, GetAllWorkProgressQueryVariables>(GetAllWorkProgressDocument, options);
      }
export function useGetAllWorkProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllWorkProgressQuery, GetAllWorkProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllWorkProgressQuery, GetAllWorkProgressQueryVariables>(GetAllWorkProgressDocument, options);
        }
export type GetAllWorkProgressQueryHookResult = ReturnType<typeof useGetAllWorkProgressQuery>;
export type GetAllWorkProgressLazyQueryHookResult = ReturnType<typeof useGetAllWorkProgressLazyQuery>;
export type GetAllWorkProgressQueryResult = Apollo.QueryResult<GetAllWorkProgressQuery, GetAllWorkProgressQueryVariables>;
export const GetAllWorkProgressByCarParkDocument = gql`
    query getAllWorkProgressByCarPark($isCarPark: Boolean) {
  getAllWorkProgressByCarPark(isCarPark: $isCarPark) {
    id
    accountId
    name
    commonStatus
    isVp
    isExistInMasterData
    isExistInTransactionData
    isSystemUse
    isCarPark
  }
}
    `;

/**
 * __useGetAllWorkProgressByCarParkQuery__
 *
 * To run a query within a React component, call `useGetAllWorkProgressByCarParkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllWorkProgressByCarParkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllWorkProgressByCarParkQuery({
 *   variables: {
 *      isCarPark: // value for 'isCarPark'
 *   },
 * });
 */
export function useGetAllWorkProgressByCarParkQuery(baseOptions?: Apollo.QueryHookOptions<GetAllWorkProgressByCarParkQuery, GetAllWorkProgressByCarParkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllWorkProgressByCarParkQuery, GetAllWorkProgressByCarParkQueryVariables>(GetAllWorkProgressByCarParkDocument, options);
      }
export function useGetAllWorkProgressByCarParkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllWorkProgressByCarParkQuery, GetAllWorkProgressByCarParkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllWorkProgressByCarParkQuery, GetAllWorkProgressByCarParkQueryVariables>(GetAllWorkProgressByCarParkDocument, options);
        }
export type GetAllWorkProgressByCarParkQueryHookResult = ReturnType<typeof useGetAllWorkProgressByCarParkQuery>;
export type GetAllWorkProgressByCarParkLazyQueryHookResult = ReturnType<typeof useGetAllWorkProgressByCarParkLazyQuery>;
export type GetAllWorkProgressByCarParkQueryResult = Apollo.QueryResult<GetAllWorkProgressByCarParkQuery, GetAllWorkProgressByCarParkQueryVariables>;
export const GetWorkProgressByIdDocument = gql`
    query getWorkProgressById($workProgressId: String!) {
  getWorkProgressById(workProgressId: $workProgressId) {
    id
    accountId
    name
  }
}
    `;

/**
 * __useGetWorkProgressByIdQuery__
 *
 * To run a query within a React component, call `useGetWorkProgressByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkProgressByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkProgressByIdQuery({
 *   variables: {
 *      workProgressId: // value for 'workProgressId'
 *   },
 * });
 */
export function useGetWorkProgressByIdQuery(baseOptions: Apollo.QueryHookOptions<GetWorkProgressByIdQuery, GetWorkProgressByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkProgressByIdQuery, GetWorkProgressByIdQueryVariables>(GetWorkProgressByIdDocument, options);
      }
export function useGetWorkProgressByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkProgressByIdQuery, GetWorkProgressByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkProgressByIdQuery, GetWorkProgressByIdQueryVariables>(GetWorkProgressByIdDocument, options);
        }
export type GetWorkProgressByIdQueryHookResult = ReturnType<typeof useGetWorkProgressByIdQuery>;
export type GetWorkProgressByIdLazyQueryHookResult = ReturnType<typeof useGetWorkProgressByIdLazyQuery>;
export type GetWorkProgressByIdQueryResult = Apollo.QueryResult<GetWorkProgressByIdQuery, GetWorkProgressByIdQueryVariables>;
export const AddWorkProgressDocument = gql`
    mutation addWorkProgress($input: WorkProgressInput!) {
  addWorkProgress(input: $input)
}
    `;
export type AddWorkProgressMutationFn = Apollo.MutationFunction<AddWorkProgressMutation, AddWorkProgressMutationVariables>;

/**
 * __useAddWorkProgressMutation__
 *
 * To run a mutation, you first call `useAddWorkProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddWorkProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addWorkProgressMutation, { data, loading, error }] = useAddWorkProgressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddWorkProgressMutation(baseOptions?: Apollo.MutationHookOptions<AddWorkProgressMutation, AddWorkProgressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddWorkProgressMutation, AddWorkProgressMutationVariables>(AddWorkProgressDocument, options);
      }
export type AddWorkProgressMutationHookResult = ReturnType<typeof useAddWorkProgressMutation>;
export type AddWorkProgressMutationResult = Apollo.MutationResult<AddWorkProgressMutation>;
export type AddWorkProgressMutationOptions = Apollo.BaseMutationOptions<AddWorkProgressMutation, AddWorkProgressMutationVariables>;
export const EditWorkProgressDocument = gql`
    mutation editWorkProgress($input: EditWorkProgressInput!) {
  editWorkProgress(input: $input)
}
    `;
export type EditWorkProgressMutationFn = Apollo.MutationFunction<EditWorkProgressMutation, EditWorkProgressMutationVariables>;

/**
 * __useEditWorkProgressMutation__
 *
 * To run a mutation, you first call `useEditWorkProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditWorkProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editWorkProgressMutation, { data, loading, error }] = useEditWorkProgressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditWorkProgressMutation(baseOptions?: Apollo.MutationHookOptions<EditWorkProgressMutation, EditWorkProgressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditWorkProgressMutation, EditWorkProgressMutationVariables>(EditWorkProgressDocument, options);
      }
export type EditWorkProgressMutationHookResult = ReturnType<typeof useEditWorkProgressMutation>;
export type EditWorkProgressMutationResult = Apollo.MutationResult<EditWorkProgressMutation>;
export type EditWorkProgressMutationOptions = Apollo.BaseMutationOptions<EditWorkProgressMutation, EditWorkProgressMutationVariables>;
export const DeactivateWorkProgressByIdDocument = gql`
    mutation deactivateWorkProgressById($progressId: String!) {
  deactivateWorkProgressById(progressId: $progressId)
}
    `;
export type DeactivateWorkProgressByIdMutationFn = Apollo.MutationFunction<DeactivateWorkProgressByIdMutation, DeactivateWorkProgressByIdMutationVariables>;

/**
 * __useDeactivateWorkProgressByIdMutation__
 *
 * To run a mutation, you first call `useDeactivateWorkProgressByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateWorkProgressByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateWorkProgressByIdMutation, { data, loading, error }] = useDeactivateWorkProgressByIdMutation({
 *   variables: {
 *      progressId: // value for 'progressId'
 *   },
 * });
 */
export function useDeactivateWorkProgressByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateWorkProgressByIdMutation, DeactivateWorkProgressByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateWorkProgressByIdMutation, DeactivateWorkProgressByIdMutationVariables>(DeactivateWorkProgressByIdDocument, options);
      }
export type DeactivateWorkProgressByIdMutationHookResult = ReturnType<typeof useDeactivateWorkProgressByIdMutation>;
export type DeactivateWorkProgressByIdMutationResult = Apollo.MutationResult<DeactivateWorkProgressByIdMutation>;
export type DeactivateWorkProgressByIdMutationOptions = Apollo.BaseMutationOptions<DeactivateWorkProgressByIdMutation, DeactivateWorkProgressByIdMutationVariables>;
export const DeleteWorkProgressByIdDocument = gql`
    mutation deleteWorkProgressById($progressId: String!) {
  deleteWorkProgressById(progressId: $progressId)
}
    `;
export type DeleteWorkProgressByIdMutationFn = Apollo.MutationFunction<DeleteWorkProgressByIdMutation, DeleteWorkProgressByIdMutationVariables>;

/**
 * __useDeleteWorkProgressByIdMutation__
 *
 * To run a mutation, you first call `useDeleteWorkProgressByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkProgressByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkProgressByIdMutation, { data, loading, error }] = useDeleteWorkProgressByIdMutation({
 *   variables: {
 *      progressId: // value for 'progressId'
 *   },
 * });
 */
export function useDeleteWorkProgressByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWorkProgressByIdMutation, DeleteWorkProgressByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWorkProgressByIdMutation, DeleteWorkProgressByIdMutationVariables>(DeleteWorkProgressByIdDocument, options);
      }
export type DeleteWorkProgressByIdMutationHookResult = ReturnType<typeof useDeleteWorkProgressByIdMutation>;
export type DeleteWorkProgressByIdMutationResult = Apollo.MutationResult<DeleteWorkProgressByIdMutation>;
export type DeleteWorkProgressByIdMutationOptions = Apollo.BaseMutationOptions<DeleteWorkProgressByIdMutation, DeleteWorkProgressByIdMutationVariables>;
export const ActivateWorkProgressByIdDocument = gql`
    mutation activateWorkProgressById($progressId: String!) {
  activateWorkProgressById(progressId: $progressId)
}
    `;
export type ActivateWorkProgressByIdMutationFn = Apollo.MutationFunction<ActivateWorkProgressByIdMutation, ActivateWorkProgressByIdMutationVariables>;

/**
 * __useActivateWorkProgressByIdMutation__
 *
 * To run a mutation, you first call `useActivateWorkProgressByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateWorkProgressByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateWorkProgressByIdMutation, { data, loading, error }] = useActivateWorkProgressByIdMutation({
 *   variables: {
 *      progressId: // value for 'progressId'
 *   },
 * });
 */
export function useActivateWorkProgressByIdMutation(baseOptions?: Apollo.MutationHookOptions<ActivateWorkProgressByIdMutation, ActivateWorkProgressByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateWorkProgressByIdMutation, ActivateWorkProgressByIdMutationVariables>(ActivateWorkProgressByIdDocument, options);
      }
export type ActivateWorkProgressByIdMutationHookResult = ReturnType<typeof useActivateWorkProgressByIdMutation>;
export type ActivateWorkProgressByIdMutationResult = Apollo.MutationResult<ActivateWorkProgressByIdMutation>;
export type ActivateWorkProgressByIdMutationOptions = Apollo.BaseMutationOptions<ActivateWorkProgressByIdMutation, ActivateWorkProgressByIdMutationVariables>;
export const GetBillItemListDocument = gql`
    query getBillItemList {
  getBillItemList {
    id
    name
    systemUse
    billItemType
    isExistInTransactionData
    commonStatus
    classificationId
    msicId
  }
}
    `;

/**
 * __useGetBillItemListQuery__
 *
 * To run a query within a React component, call `useGetBillItemListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillItemListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBillItemListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBillItemListQuery(baseOptions?: Apollo.QueryHookOptions<GetBillItemListQuery, GetBillItemListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBillItemListQuery, GetBillItemListQueryVariables>(GetBillItemListDocument, options);
      }
export function useGetBillItemListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBillItemListQuery, GetBillItemListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBillItemListQuery, GetBillItemListQueryVariables>(GetBillItemListDocument, options);
        }
export type GetBillItemListQueryHookResult = ReturnType<typeof useGetBillItemListQuery>;
export type GetBillItemListLazyQueryHookResult = ReturnType<typeof useGetBillItemListLazyQuery>;
export type GetBillItemListQueryResult = Apollo.QueryResult<GetBillItemListQuery, GetBillItemListQueryVariables>;
export const AddBillItemDocument = gql`
    mutation addBillItem($input: AddBillItemInput!) {
  addBillItem(input: $input)
}
    `;
export type AddBillItemMutationFn = Apollo.MutationFunction<AddBillItemMutation, AddBillItemMutationVariables>;

/**
 * __useAddBillItemMutation__
 *
 * To run a mutation, you first call `useAddBillItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBillItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBillItemMutation, { data, loading, error }] = useAddBillItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddBillItemMutation(baseOptions?: Apollo.MutationHookOptions<AddBillItemMutation, AddBillItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddBillItemMutation, AddBillItemMutationVariables>(AddBillItemDocument, options);
      }
export type AddBillItemMutationHookResult = ReturnType<typeof useAddBillItemMutation>;
export type AddBillItemMutationResult = Apollo.MutationResult<AddBillItemMutation>;
export type AddBillItemMutationOptions = Apollo.BaseMutationOptions<AddBillItemMutation, AddBillItemMutationVariables>;
export const EditBillItemDocument = gql`
    mutation editBillItem($input: EditBillItemInput!) {
  editBillItem(input: $input)
}
    `;
export type EditBillItemMutationFn = Apollo.MutationFunction<EditBillItemMutation, EditBillItemMutationVariables>;

/**
 * __useEditBillItemMutation__
 *
 * To run a mutation, you first call `useEditBillItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditBillItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editBillItemMutation, { data, loading, error }] = useEditBillItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditBillItemMutation(baseOptions?: Apollo.MutationHookOptions<EditBillItemMutation, EditBillItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditBillItemMutation, EditBillItemMutationVariables>(EditBillItemDocument, options);
      }
export type EditBillItemMutationHookResult = ReturnType<typeof useEditBillItemMutation>;
export type EditBillItemMutationResult = Apollo.MutationResult<EditBillItemMutation>;
export type EditBillItemMutationOptions = Apollo.BaseMutationOptions<EditBillItemMutation, EditBillItemMutationVariables>;
export const DeleteBillItemDocument = gql`
    mutation deleteBillItem($id: String!) {
  deleteBillItem(id: $id)
}
    `;
export type DeleteBillItemMutationFn = Apollo.MutationFunction<DeleteBillItemMutation, DeleteBillItemMutationVariables>;

/**
 * __useDeleteBillItemMutation__
 *
 * To run a mutation, you first call `useDeleteBillItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBillItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBillItemMutation, { data, loading, error }] = useDeleteBillItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBillItemMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBillItemMutation, DeleteBillItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBillItemMutation, DeleteBillItemMutationVariables>(DeleteBillItemDocument, options);
      }
export type DeleteBillItemMutationHookResult = ReturnType<typeof useDeleteBillItemMutation>;
export type DeleteBillItemMutationResult = Apollo.MutationResult<DeleteBillItemMutation>;
export type DeleteBillItemMutationOptions = Apollo.BaseMutationOptions<DeleteBillItemMutation, DeleteBillItemMutationVariables>;
export const ActivateBillItemDocument = gql`
    mutation activateBillItem($billItemId: String!) {
  activateBillItem(billItemId: $billItemId)
}
    `;
export type ActivateBillItemMutationFn = Apollo.MutationFunction<ActivateBillItemMutation, ActivateBillItemMutationVariables>;

/**
 * __useActivateBillItemMutation__
 *
 * To run a mutation, you first call `useActivateBillItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateBillItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateBillItemMutation, { data, loading, error }] = useActivateBillItemMutation({
 *   variables: {
 *      billItemId: // value for 'billItemId'
 *   },
 * });
 */
export function useActivateBillItemMutation(baseOptions?: Apollo.MutationHookOptions<ActivateBillItemMutation, ActivateBillItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateBillItemMutation, ActivateBillItemMutationVariables>(ActivateBillItemDocument, options);
      }
export type ActivateBillItemMutationHookResult = ReturnType<typeof useActivateBillItemMutation>;
export type ActivateBillItemMutationResult = Apollo.MutationResult<ActivateBillItemMutation>;
export type ActivateBillItemMutationOptions = Apollo.BaseMutationOptions<ActivateBillItemMutation, ActivateBillItemMutationVariables>;
export const DeactivateBillItemDocument = gql`
    mutation deactivateBillItem($billItemId: String!) {
  deactivateBillItem(billItemId: $billItemId)
}
    `;
export type DeactivateBillItemMutationFn = Apollo.MutationFunction<DeactivateBillItemMutation, DeactivateBillItemMutationVariables>;

/**
 * __useDeactivateBillItemMutation__
 *
 * To run a mutation, you first call `useDeactivateBillItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateBillItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateBillItemMutation, { data, loading, error }] = useDeactivateBillItemMutation({
 *   variables: {
 *      billItemId: // value for 'billItemId'
 *   },
 * });
 */
export function useDeactivateBillItemMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateBillItemMutation, DeactivateBillItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateBillItemMutation, DeactivateBillItemMutationVariables>(DeactivateBillItemDocument, options);
      }
export type DeactivateBillItemMutationHookResult = ReturnType<typeof useDeactivateBillItemMutation>;
export type DeactivateBillItemMutationResult = Apollo.MutationResult<DeactivateBillItemMutation>;
export type DeactivateBillItemMutationOptions = Apollo.BaseMutationOptions<DeactivateBillItemMutation, DeactivateBillItemMutationVariables>;
export const GetBllItemListByTypeDocument = gql`
    query getBllItemListByType($type: String!) {
  getBllItemListByType(type: $type) {
    id
    name
  }
}
    `;

/**
 * __useGetBllItemListByTypeQuery__
 *
 * To run a query within a React component, call `useGetBllItemListByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBllItemListByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBllItemListByTypeQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetBllItemListByTypeQuery(baseOptions: Apollo.QueryHookOptions<GetBllItemListByTypeQuery, GetBllItemListByTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBllItemListByTypeQuery, GetBllItemListByTypeQueryVariables>(GetBllItemListByTypeDocument, options);
      }
export function useGetBllItemListByTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBllItemListByTypeQuery, GetBllItemListByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBllItemListByTypeQuery, GetBllItemListByTypeQueryVariables>(GetBllItemListByTypeDocument, options);
        }
export type GetBllItemListByTypeQueryHookResult = ReturnType<typeof useGetBllItemListByTypeQuery>;
export type GetBllItemListByTypeLazyQueryHookResult = ReturnType<typeof useGetBllItemListByTypeLazyQuery>;
export type GetBllItemListByTypeQueryResult = Apollo.QueryResult<GetBllItemListByTypeQuery, GetBllItemListByTypeQueryVariables>;
export const GetBllItemListByIdDocument = gql`
    query getBllItemListById($id: String!) {
  getBllItemListById(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useGetBllItemListByIdQuery__
 *
 * To run a query within a React component, call `useGetBllItemListByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBllItemListByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBllItemListByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBllItemListByIdQuery(baseOptions: Apollo.QueryHookOptions<GetBllItemListByIdQuery, GetBllItemListByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBllItemListByIdQuery, GetBllItemListByIdQueryVariables>(GetBllItemListByIdDocument, options);
      }
export function useGetBllItemListByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBllItemListByIdQuery, GetBllItemListByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBllItemListByIdQuery, GetBllItemListByIdQueryVariables>(GetBllItemListByIdDocument, options);
        }
export type GetBllItemListByIdQueryHookResult = ReturnType<typeof useGetBllItemListByIdQuery>;
export type GetBllItemListByIdLazyQueryHookResult = ReturnType<typeof useGetBllItemListByIdLazyQuery>;
export type GetBllItemListByIdQueryResult = Apollo.QueryResult<GetBllItemListByIdQuery, GetBllItemListByIdQueryVariables>;
export const GetBllItemListAtCreditAndDebitDocument = gql`
    query getBllItemListAtCreditAndDebit {
  getBllItemListAtCreditAndDebit {
    id
    name
    billItemType
  }
}
    `;

/**
 * __useGetBllItemListAtCreditAndDebitQuery__
 *
 * To run a query within a React component, call `useGetBllItemListAtCreditAndDebitQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBllItemListAtCreditAndDebitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBllItemListAtCreditAndDebitQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBllItemListAtCreditAndDebitQuery(baseOptions?: Apollo.QueryHookOptions<GetBllItemListAtCreditAndDebitQuery, GetBllItemListAtCreditAndDebitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBllItemListAtCreditAndDebitQuery, GetBllItemListAtCreditAndDebitQueryVariables>(GetBllItemListAtCreditAndDebitDocument, options);
      }
export function useGetBllItemListAtCreditAndDebitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBllItemListAtCreditAndDebitQuery, GetBllItemListAtCreditAndDebitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBllItemListAtCreditAndDebitQuery, GetBllItemListAtCreditAndDebitQueryVariables>(GetBllItemListAtCreditAndDebitDocument, options);
        }
export type GetBllItemListAtCreditAndDebitQueryHookResult = ReturnType<typeof useGetBllItemListAtCreditAndDebitQuery>;
export type GetBllItemListAtCreditAndDebitLazyQueryHookResult = ReturnType<typeof useGetBllItemListAtCreditAndDebitLazyQuery>;
export type GetBllItemListAtCreditAndDebitQueryResult = Apollo.QueryResult<GetBllItemListAtCreditAndDebitQuery, GetBllItemListAtCreditAndDebitQueryVariables>;
export const GetBillItemByTypeDocument = gql`
    query getBillItemByType($type: String!) {
  getBillItemByType(billItemType: $type) {
    id
    name
    systemUse
    creditTerm
    billItemType
    gracePeriod
    latePaymentInterest
    taxSchema {
      id
      name
    }
  }
}
    `;

/**
 * __useGetBillItemByTypeQuery__
 *
 * To run a query within a React component, call `useGetBillItemByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillItemByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBillItemByTypeQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetBillItemByTypeQuery(baseOptions: Apollo.QueryHookOptions<GetBillItemByTypeQuery, GetBillItemByTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBillItemByTypeQuery, GetBillItemByTypeQueryVariables>(GetBillItemByTypeDocument, options);
      }
export function useGetBillItemByTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBillItemByTypeQuery, GetBillItemByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBillItemByTypeQuery, GetBillItemByTypeQueryVariables>(GetBillItemByTypeDocument, options);
        }
export type GetBillItemByTypeQueryHookResult = ReturnType<typeof useGetBillItemByTypeQuery>;
export type GetBillItemByTypeLazyQueryHookResult = ReturnType<typeof useGetBillItemByTypeLazyQuery>;
export type GetBillItemByTypeQueryResult = Apollo.QueryResult<GetBillItemByTypeQuery, GetBillItemByTypeQueryVariables>;
export const CreateBillItemDocument = gql`
    mutation createBillItem($input: billItemIntInput!) {
  createBillItem(input: $input)
}
    `;
export type CreateBillItemMutationFn = Apollo.MutationFunction<CreateBillItemMutation, CreateBillItemMutationVariables>;

/**
 * __useCreateBillItemMutation__
 *
 * To run a mutation, you first call `useCreateBillItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBillItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBillItemMutation, { data, loading, error }] = useCreateBillItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBillItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateBillItemMutation, CreateBillItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBillItemMutation, CreateBillItemMutationVariables>(CreateBillItemDocument, options);
      }
export type CreateBillItemMutationHookResult = ReturnType<typeof useCreateBillItemMutation>;
export type CreateBillItemMutationResult = Apollo.MutationResult<CreateBillItemMutation>;
export type CreateBillItemMutationOptions = Apollo.BaseMutationOptions<CreateBillItemMutation, CreateBillItemMutationVariables>;
export const UpdateBillItemDocument = gql`
    mutation updateBillItem($input: billItemIntInput!) {
  updateBillItem(input: $input)
}
    `;
export type UpdateBillItemMutationFn = Apollo.MutationFunction<UpdateBillItemMutation, UpdateBillItemMutationVariables>;

/**
 * __useUpdateBillItemMutation__
 *
 * To run a mutation, you first call `useUpdateBillItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBillItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBillItemMutation, { data, loading, error }] = useUpdateBillItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBillItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBillItemMutation, UpdateBillItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBillItemMutation, UpdateBillItemMutationVariables>(UpdateBillItemDocument, options);
      }
export type UpdateBillItemMutationHookResult = ReturnType<typeof useUpdateBillItemMutation>;
export type UpdateBillItemMutationResult = Apollo.MutationResult<UpdateBillItemMutation>;
export type UpdateBillItemMutationOptions = Apollo.BaseMutationOptions<UpdateBillItemMutation, UpdateBillItemMutationVariables>;
export const DeleteBillItemIntDocument = gql`
    mutation deleteBillItemInt($id: String!) {
  deleteBillItemInt(id: $id)
}
    `;
export type DeleteBillItemIntMutationFn = Apollo.MutationFunction<DeleteBillItemIntMutation, DeleteBillItemIntMutationVariables>;

/**
 * __useDeleteBillItemIntMutation__
 *
 * To run a mutation, you first call `useDeleteBillItemIntMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBillItemIntMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBillItemIntMutation, { data, loading, error }] = useDeleteBillItemIntMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBillItemIntMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBillItemIntMutation, DeleteBillItemIntMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBillItemIntMutation, DeleteBillItemIntMutationVariables>(DeleteBillItemIntDocument, options);
      }
export type DeleteBillItemIntMutationHookResult = ReturnType<typeof useDeleteBillItemIntMutation>;
export type DeleteBillItemIntMutationResult = Apollo.MutationResult<DeleteBillItemIntMutation>;
export type DeleteBillItemIntMutationOptions = Apollo.BaseMutationOptions<DeleteBillItemIntMutation, DeleteBillItemIntMutationVariables>;
export const GetClassificationCodeListingDocument = gql`
    query getClassificationCodeListing {
  getClassificationCodeListing {
    id
    classificationCode
    description
  }
}
    `;

/**
 * __useGetClassificationCodeListingQuery__
 *
 * To run a query within a React component, call `useGetClassificationCodeListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassificationCodeListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassificationCodeListingQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetClassificationCodeListingQuery(baseOptions?: Apollo.QueryHookOptions<GetClassificationCodeListingQuery, GetClassificationCodeListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClassificationCodeListingQuery, GetClassificationCodeListingQueryVariables>(GetClassificationCodeListingDocument, options);
      }
export function useGetClassificationCodeListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClassificationCodeListingQuery, GetClassificationCodeListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClassificationCodeListingQuery, GetClassificationCodeListingQueryVariables>(GetClassificationCodeListingDocument, options);
        }
export type GetClassificationCodeListingQueryHookResult = ReturnType<typeof useGetClassificationCodeListingQuery>;
export type GetClassificationCodeListingLazyQueryHookResult = ReturnType<typeof useGetClassificationCodeListingLazyQuery>;
export type GetClassificationCodeListingQueryResult = Apollo.QueryResult<GetClassificationCodeListingQuery, GetClassificationCodeListingQueryVariables>;
export const GetUnassignedClassificationBillItemsDocument = gql`
    query getUnassignedClassificationBillItems {
  getUnassignedClassificationBillItems {
    id
    name
    systemUse
    billItemType
    classificationId
    msicId
  }
}
    `;

/**
 * __useGetUnassignedClassificationBillItemsQuery__
 *
 * To run a query within a React component, call `useGetUnassignedClassificationBillItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnassignedClassificationBillItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnassignedClassificationBillItemsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUnassignedClassificationBillItemsQuery(baseOptions?: Apollo.QueryHookOptions<GetUnassignedClassificationBillItemsQuery, GetUnassignedClassificationBillItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnassignedClassificationBillItemsQuery, GetUnassignedClassificationBillItemsQueryVariables>(GetUnassignedClassificationBillItemsDocument, options);
      }
export function useGetUnassignedClassificationBillItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnassignedClassificationBillItemsQuery, GetUnassignedClassificationBillItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnassignedClassificationBillItemsQuery, GetUnassignedClassificationBillItemsQueryVariables>(GetUnassignedClassificationBillItemsDocument, options);
        }
export type GetUnassignedClassificationBillItemsQueryHookResult = ReturnType<typeof useGetUnassignedClassificationBillItemsQuery>;
export type GetUnassignedClassificationBillItemsLazyQueryHookResult = ReturnType<typeof useGetUnassignedClassificationBillItemsLazyQuery>;
export type GetUnassignedClassificationBillItemsQueryResult = Apollo.QueryResult<GetUnassignedClassificationBillItemsQuery, GetUnassignedClassificationBillItemsQueryVariables>;
export const GetAssignedClassificationBillItemsDocument = gql`
    query getAssignedClassificationBillItems($classificationId: String!) {
  getAssignedClassificationBillItems(classificationId: $classificationId) {
    id
    name
    systemUse
    billItemType
    classificationId
    msicId
  }
}
    `;

/**
 * __useGetAssignedClassificationBillItemsQuery__
 *
 * To run a query within a React component, call `useGetAssignedClassificationBillItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignedClassificationBillItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignedClassificationBillItemsQuery({
 *   variables: {
 *      classificationId: // value for 'classificationId'
 *   },
 * });
 */
export function useGetAssignedClassificationBillItemsQuery(baseOptions: Apollo.QueryHookOptions<GetAssignedClassificationBillItemsQuery, GetAssignedClassificationBillItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssignedClassificationBillItemsQuery, GetAssignedClassificationBillItemsQueryVariables>(GetAssignedClassificationBillItemsDocument, options);
      }
export function useGetAssignedClassificationBillItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssignedClassificationBillItemsQuery, GetAssignedClassificationBillItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssignedClassificationBillItemsQuery, GetAssignedClassificationBillItemsQueryVariables>(GetAssignedClassificationBillItemsDocument, options);
        }
export type GetAssignedClassificationBillItemsQueryHookResult = ReturnType<typeof useGetAssignedClassificationBillItemsQuery>;
export type GetAssignedClassificationBillItemsLazyQueryHookResult = ReturnType<typeof useGetAssignedClassificationBillItemsLazyQuery>;
export type GetAssignedClassificationBillItemsQueryResult = Apollo.QueryResult<GetAssignedClassificationBillItemsQuery, GetAssignedClassificationBillItemsQueryVariables>;
export const AssignClassificationCodeDocument = gql`
    mutation assignClassificationCode($classificationId: String!, $billItemIds: [String!]!) {
  assignClassificationCode(classificationId: $classificationId, billItemIds: $billItemIds)
}
    `;
export type AssignClassificationCodeMutationFn = Apollo.MutationFunction<AssignClassificationCodeMutation, AssignClassificationCodeMutationVariables>;

/**
 * __useAssignClassificationCodeMutation__
 *
 * To run a mutation, you first call `useAssignClassificationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignClassificationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignClassificationCodeMutation, { data, loading, error }] = useAssignClassificationCodeMutation({
 *   variables: {
 *      classificationId: // value for 'classificationId'
 *      billItemIds: // value for 'billItemIds'
 *   },
 * });
 */
export function useAssignClassificationCodeMutation(baseOptions?: Apollo.MutationHookOptions<AssignClassificationCodeMutation, AssignClassificationCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignClassificationCodeMutation, AssignClassificationCodeMutationVariables>(AssignClassificationCodeDocument, options);
      }
export type AssignClassificationCodeMutationHookResult = ReturnType<typeof useAssignClassificationCodeMutation>;
export type AssignClassificationCodeMutationResult = Apollo.MutationResult<AssignClassificationCodeMutation>;
export type AssignClassificationCodeMutationOptions = Apollo.BaseMutationOptions<AssignClassificationCodeMutation, AssignClassificationCodeMutationVariables>;
export const UnassignClassificationCodeDocument = gql`
    mutation unassignClassificationCode($classificationId: String!, $billItemIds: [String!]!) {
  unassignClassificationCode(classificationId: $classificationId, billItemIds: $billItemIds)
}
    `;
export type UnassignClassificationCodeMutationFn = Apollo.MutationFunction<UnassignClassificationCodeMutation, UnassignClassificationCodeMutationVariables>;

/**
 * __useUnassignClassificationCodeMutation__
 *
 * To run a mutation, you first call `useUnassignClassificationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignClassificationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignClassificationCodeMutation, { data, loading, error }] = useUnassignClassificationCodeMutation({
 *   variables: {
 *      classificationId: // value for 'classificationId'
 *      billItemIds: // value for 'billItemIds'
 *   },
 * });
 */
export function useUnassignClassificationCodeMutation(baseOptions?: Apollo.MutationHookOptions<UnassignClassificationCodeMutation, UnassignClassificationCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnassignClassificationCodeMutation, UnassignClassificationCodeMutationVariables>(UnassignClassificationCodeDocument, options);
      }
export type UnassignClassificationCodeMutationHookResult = ReturnType<typeof useUnassignClassificationCodeMutation>;
export type UnassignClassificationCodeMutationResult = Apollo.MutationResult<UnassignClassificationCodeMutation>;
export type UnassignClassificationCodeMutationOptions = Apollo.BaseMutationOptions<UnassignClassificationCodeMutation, UnassignClassificationCodeMutationVariables>;
export const GetMsicCodeListingDocument = gql`
    query getMsicCodeListing {
  getMsicCodeListing {
    id
    msicCode
    description
  }
}
    `;

/**
 * __useGetMsicCodeListingQuery__
 *
 * To run a query within a React component, call `useGetMsicCodeListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMsicCodeListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMsicCodeListingQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMsicCodeListingQuery(baseOptions?: Apollo.QueryHookOptions<GetMsicCodeListingQuery, GetMsicCodeListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMsicCodeListingQuery, GetMsicCodeListingQueryVariables>(GetMsicCodeListingDocument, options);
      }
export function useGetMsicCodeListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMsicCodeListingQuery, GetMsicCodeListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMsicCodeListingQuery, GetMsicCodeListingQueryVariables>(GetMsicCodeListingDocument, options);
        }
export type GetMsicCodeListingQueryHookResult = ReturnType<typeof useGetMsicCodeListingQuery>;
export type GetMsicCodeListingLazyQueryHookResult = ReturnType<typeof useGetMsicCodeListingLazyQuery>;
export type GetMsicCodeListingQueryResult = Apollo.QueryResult<GetMsicCodeListingQuery, GetMsicCodeListingQueryVariables>;
export const GetUnassignedMsicBillItemsDocument = gql`
    query getUnassignedMsicBillItems {
  getUnassignedMsicBillItems {
    id
    name
    systemUse
    billItemType
    classificationId
    msicId
  }
}
    `;

/**
 * __useGetUnassignedMsicBillItemsQuery__
 *
 * To run a query within a React component, call `useGetUnassignedMsicBillItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnassignedMsicBillItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnassignedMsicBillItemsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUnassignedMsicBillItemsQuery(baseOptions?: Apollo.QueryHookOptions<GetUnassignedMsicBillItemsQuery, GetUnassignedMsicBillItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnassignedMsicBillItemsQuery, GetUnassignedMsicBillItemsQueryVariables>(GetUnassignedMsicBillItemsDocument, options);
      }
export function useGetUnassignedMsicBillItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnassignedMsicBillItemsQuery, GetUnassignedMsicBillItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnassignedMsicBillItemsQuery, GetUnassignedMsicBillItemsQueryVariables>(GetUnassignedMsicBillItemsDocument, options);
        }
export type GetUnassignedMsicBillItemsQueryHookResult = ReturnType<typeof useGetUnassignedMsicBillItemsQuery>;
export type GetUnassignedMsicBillItemsLazyQueryHookResult = ReturnType<typeof useGetUnassignedMsicBillItemsLazyQuery>;
export type GetUnassignedMsicBillItemsQueryResult = Apollo.QueryResult<GetUnassignedMsicBillItemsQuery, GetUnassignedMsicBillItemsQueryVariables>;
export const GetAssignedMsicBillItemsDocument = gql`
    query getAssignedMsicBillItems($msicId: String!) {
  getAssignedMsicBillItems(msicId: $msicId) {
    id
    name
    systemUse
    billItemType
    classificationId
    msicId
  }
}
    `;

/**
 * __useGetAssignedMsicBillItemsQuery__
 *
 * To run a query within a React component, call `useGetAssignedMsicBillItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignedMsicBillItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignedMsicBillItemsQuery({
 *   variables: {
 *      msicId: // value for 'msicId'
 *   },
 * });
 */
export function useGetAssignedMsicBillItemsQuery(baseOptions: Apollo.QueryHookOptions<GetAssignedMsicBillItemsQuery, GetAssignedMsicBillItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssignedMsicBillItemsQuery, GetAssignedMsicBillItemsQueryVariables>(GetAssignedMsicBillItemsDocument, options);
      }
export function useGetAssignedMsicBillItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssignedMsicBillItemsQuery, GetAssignedMsicBillItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssignedMsicBillItemsQuery, GetAssignedMsicBillItemsQueryVariables>(GetAssignedMsicBillItemsDocument, options);
        }
export type GetAssignedMsicBillItemsQueryHookResult = ReturnType<typeof useGetAssignedMsicBillItemsQuery>;
export type GetAssignedMsicBillItemsLazyQueryHookResult = ReturnType<typeof useGetAssignedMsicBillItemsLazyQuery>;
export type GetAssignedMsicBillItemsQueryResult = Apollo.QueryResult<GetAssignedMsicBillItemsQuery, GetAssignedMsicBillItemsQueryVariables>;
export const AssignMsicCodeDocument = gql`
    mutation assignMsicCode($msicId: String!, $billItemIds: [String!]!) {
  assignMsicCode(msicId: $msicId, billItemIds: $billItemIds)
}
    `;
export type AssignMsicCodeMutationFn = Apollo.MutationFunction<AssignMsicCodeMutation, AssignMsicCodeMutationVariables>;

/**
 * __useAssignMsicCodeMutation__
 *
 * To run a mutation, you first call `useAssignMsicCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignMsicCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignMsicCodeMutation, { data, loading, error }] = useAssignMsicCodeMutation({
 *   variables: {
 *      msicId: // value for 'msicId'
 *      billItemIds: // value for 'billItemIds'
 *   },
 * });
 */
export function useAssignMsicCodeMutation(baseOptions?: Apollo.MutationHookOptions<AssignMsicCodeMutation, AssignMsicCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignMsicCodeMutation, AssignMsicCodeMutationVariables>(AssignMsicCodeDocument, options);
      }
export type AssignMsicCodeMutationHookResult = ReturnType<typeof useAssignMsicCodeMutation>;
export type AssignMsicCodeMutationResult = Apollo.MutationResult<AssignMsicCodeMutation>;
export type AssignMsicCodeMutationOptions = Apollo.BaseMutationOptions<AssignMsicCodeMutation, AssignMsicCodeMutationVariables>;
export const UnassignMsicCodeDocument = gql`
    mutation unassignMsicCode($msicId: String!, $billItemIds: [String!]!) {
  unassignMsicCode(msicId: $msicId, billItemIds: $billItemIds)
}
    `;
export type UnassignMsicCodeMutationFn = Apollo.MutationFunction<UnassignMsicCodeMutation, UnassignMsicCodeMutationVariables>;

/**
 * __useUnassignMsicCodeMutation__
 *
 * To run a mutation, you first call `useUnassignMsicCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignMsicCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignMsicCodeMutation, { data, loading, error }] = useUnassignMsicCodeMutation({
 *   variables: {
 *      msicId: // value for 'msicId'
 *      billItemIds: // value for 'billItemIds'
 *   },
 * });
 */
export function useUnassignMsicCodeMutation(baseOptions?: Apollo.MutationHookOptions<UnassignMsicCodeMutation, UnassignMsicCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnassignMsicCodeMutation, UnassignMsicCodeMutationVariables>(UnassignMsicCodeDocument, options);
      }
export type UnassignMsicCodeMutationHookResult = ReturnType<typeof useUnassignMsicCodeMutation>;
export type UnassignMsicCodeMutationResult = Apollo.MutationResult<UnassignMsicCodeMutation>;
export type UnassignMsicCodeMutationOptions = Apollo.BaseMutationOptions<UnassignMsicCodeMutation, UnassignMsicCodeMutationVariables>;
export const GetCollectionActivityListDocument = gql`
    query getCollectionActivityList {
  getCollectionActivityList {
    id
    accountId
    saleId
    activityDate
    activityRemark
    completedDate
    activityStatus
    commonStatus
  }
}
    `;

/**
 * __useGetCollectionActivityListQuery__
 *
 * To run a query within a React component, call `useGetCollectionActivityListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionActivityListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionActivityListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCollectionActivityListQuery(baseOptions?: Apollo.QueryHookOptions<GetCollectionActivityListQuery, GetCollectionActivityListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectionActivityListQuery, GetCollectionActivityListQueryVariables>(GetCollectionActivityListDocument, options);
      }
export function useGetCollectionActivityListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectionActivityListQuery, GetCollectionActivityListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectionActivityListQuery, GetCollectionActivityListQueryVariables>(GetCollectionActivityListDocument, options);
        }
export type GetCollectionActivityListQueryHookResult = ReturnType<typeof useGetCollectionActivityListQuery>;
export type GetCollectionActivityListLazyQueryHookResult = ReturnType<typeof useGetCollectionActivityListLazyQuery>;
export type GetCollectionActivityListQueryResult = Apollo.QueryResult<GetCollectionActivityListQuery, GetCollectionActivityListQueryVariables>;
export const GetCollectionActivityBySaleIdDocument = gql`
    query getCollectionActivityBySaleId {
  getCollectionActivityBySaleId {
    unitNo
    purchaserName
    saleId
    contactId
    phoneNo
    icNo
    remark
    date
    status
    receiptDate
    receiptAmount
  }
}
    `;

/**
 * __useGetCollectionActivityBySaleIdQuery__
 *
 * To run a query within a React component, call `useGetCollectionActivityBySaleIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionActivityBySaleIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionActivityBySaleIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCollectionActivityBySaleIdQuery(baseOptions?: Apollo.QueryHookOptions<GetCollectionActivityBySaleIdQuery, GetCollectionActivityBySaleIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectionActivityBySaleIdQuery, GetCollectionActivityBySaleIdQueryVariables>(GetCollectionActivityBySaleIdDocument, options);
      }
export function useGetCollectionActivityBySaleIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectionActivityBySaleIdQuery, GetCollectionActivityBySaleIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectionActivityBySaleIdQuery, GetCollectionActivityBySaleIdQueryVariables>(GetCollectionActivityBySaleIdDocument, options);
        }
export type GetCollectionActivityBySaleIdQueryHookResult = ReturnType<typeof useGetCollectionActivityBySaleIdQuery>;
export type GetCollectionActivityBySaleIdLazyQueryHookResult = ReturnType<typeof useGetCollectionActivityBySaleIdLazyQuery>;
export type GetCollectionActivityBySaleIdQueryResult = Apollo.QueryResult<GetCollectionActivityBySaleIdQuery, GetCollectionActivityBySaleIdQueryVariables>;
export const GetCreditControlSettingSummaryDocument = gql`
    query getCreditControlSettingSummary {
  latePaymentInterestGenerationLastUpdate
  latePaymentInterestExceptionLastUpdate
  projectReminderLastUpdate
  paymentReminderLastUpdate
  paymentReminderCount
  paymentInterestExceptionCount
  collectionActivityCount
  latePaymentInterestLastUpdated {
    lastGenerateDate
    amount
  }
}
    `;

/**
 * __useGetCreditControlSettingSummaryQuery__
 *
 * To run a query within a React component, call `useGetCreditControlSettingSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditControlSettingSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditControlSettingSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCreditControlSettingSummaryQuery(baseOptions?: Apollo.QueryHookOptions<GetCreditControlSettingSummaryQuery, GetCreditControlSettingSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditControlSettingSummaryQuery, GetCreditControlSettingSummaryQueryVariables>(GetCreditControlSettingSummaryDocument, options);
      }
export function useGetCreditControlSettingSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditControlSettingSummaryQuery, GetCreditControlSettingSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditControlSettingSummaryQuery, GetCreditControlSettingSummaryQueryVariables>(GetCreditControlSettingSummaryDocument, options);
        }
export type GetCreditControlSettingSummaryQueryHookResult = ReturnType<typeof useGetCreditControlSettingSummaryQuery>;
export type GetCreditControlSettingSummaryLazyQueryHookResult = ReturnType<typeof useGetCreditControlSettingSummaryLazyQuery>;
export type GetCreditControlSettingSummaryQueryResult = Apollo.QueryResult<GetCreditControlSettingSummaryQuery, GetCreditControlSettingSummaryQueryVariables>;
export const GetAllProjectLateInterestDocument = gql`
    query getAllProjectLateInterest {
  getAllProjectLateInterest {
    id
    accountId
    projectId
    loanGracePeriod
    minimumInterestAmount
    excludeHoliday
    excludePaymentDate
    enableFloatingInterest
  }
}
    `;

/**
 * __useGetAllProjectLateInterestQuery__
 *
 * To run a query within a React component, call `useGetAllProjectLateInterestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllProjectLateInterestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllProjectLateInterestQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllProjectLateInterestQuery(baseOptions?: Apollo.QueryHookOptions<GetAllProjectLateInterestQuery, GetAllProjectLateInterestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllProjectLateInterestQuery, GetAllProjectLateInterestQueryVariables>(GetAllProjectLateInterestDocument, options);
      }
export function useGetAllProjectLateInterestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllProjectLateInterestQuery, GetAllProjectLateInterestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllProjectLateInterestQuery, GetAllProjectLateInterestQueryVariables>(GetAllProjectLateInterestDocument, options);
        }
export type GetAllProjectLateInterestQueryHookResult = ReturnType<typeof useGetAllProjectLateInterestQuery>;
export type GetAllProjectLateInterestLazyQueryHookResult = ReturnType<typeof useGetAllProjectLateInterestLazyQuery>;
export type GetAllProjectLateInterestQueryResult = Apollo.QueryResult<GetAllProjectLateInterestQuery, GetAllProjectLateInterestQueryVariables>;
export const GetProjectLateInterestByIdDocument = gql`
    query getProjectLateInterestById {
  getProjectLateInterestById {
    id
    accountId
    projectId
    loanGracePeriod
    minimumInterestAmount
    excludeHoliday
    excludePaymentDate
    enableFloatingInterest
    loanGracePeriodStartWith
    taxSchemeId
  }
}
    `;

/**
 * __useGetProjectLateInterestByIdQuery__
 *
 * To run a query within a React component, call `useGetProjectLateInterestByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectLateInterestByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectLateInterestByIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProjectLateInterestByIdQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectLateInterestByIdQuery, GetProjectLateInterestByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectLateInterestByIdQuery, GetProjectLateInterestByIdQueryVariables>(GetProjectLateInterestByIdDocument, options);
      }
export function useGetProjectLateInterestByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectLateInterestByIdQuery, GetProjectLateInterestByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectLateInterestByIdQuery, GetProjectLateInterestByIdQueryVariables>(GetProjectLateInterestByIdDocument, options);
        }
export type GetProjectLateInterestByIdQueryHookResult = ReturnType<typeof useGetProjectLateInterestByIdQuery>;
export type GetProjectLateInterestByIdLazyQueryHookResult = ReturnType<typeof useGetProjectLateInterestByIdLazyQuery>;
export type GetProjectLateInterestByIdQueryResult = Apollo.QueryResult<GetProjectLateInterestByIdQuery, GetProjectLateInterestByIdQueryVariables>;
export const GetAllLatePaymentInterestExceptionDocument = gql`
    query getAllLatePaymentInterestException {
  getAllLatePaymentInterestException {
    id
    unitNo
    purchaserName
    remark
    isVip
    isCompany
    companyName
  }
}
    `;

/**
 * __useGetAllLatePaymentInterestExceptionQuery__
 *
 * To run a query within a React component, call `useGetAllLatePaymentInterestExceptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllLatePaymentInterestExceptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllLatePaymentInterestExceptionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllLatePaymentInterestExceptionQuery(baseOptions?: Apollo.QueryHookOptions<GetAllLatePaymentInterestExceptionQuery, GetAllLatePaymentInterestExceptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllLatePaymentInterestExceptionQuery, GetAllLatePaymentInterestExceptionQueryVariables>(GetAllLatePaymentInterestExceptionDocument, options);
      }
export function useGetAllLatePaymentInterestExceptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllLatePaymentInterestExceptionQuery, GetAllLatePaymentInterestExceptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllLatePaymentInterestExceptionQuery, GetAllLatePaymentInterestExceptionQueryVariables>(GetAllLatePaymentInterestExceptionDocument, options);
        }
export type GetAllLatePaymentInterestExceptionQueryHookResult = ReturnType<typeof useGetAllLatePaymentInterestExceptionQuery>;
export type GetAllLatePaymentInterestExceptionLazyQueryHookResult = ReturnType<typeof useGetAllLatePaymentInterestExceptionLazyQuery>;
export type GetAllLatePaymentInterestExceptionQueryResult = Apollo.QueryResult<GetAllLatePaymentInterestExceptionQuery, GetAllLatePaymentInterestExceptionQueryVariables>;
export const GetSalesFromSignedUnitDocument = gql`
    query getSalesFromSignedUnit {
  getSalesFromSignedUnit {
    unitId
    unitNo
    purchaserName
    saleId
    isVip
    isCompany
    companyName
  }
}
    `;

/**
 * __useGetSalesFromSignedUnitQuery__
 *
 * To run a query within a React component, call `useGetSalesFromSignedUnitQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesFromSignedUnitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesFromSignedUnitQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSalesFromSignedUnitQuery(baseOptions?: Apollo.QueryHookOptions<GetSalesFromSignedUnitQuery, GetSalesFromSignedUnitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesFromSignedUnitQuery, GetSalesFromSignedUnitQueryVariables>(GetSalesFromSignedUnitDocument, options);
      }
export function useGetSalesFromSignedUnitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesFromSignedUnitQuery, GetSalesFromSignedUnitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesFromSignedUnitQuery, GetSalesFromSignedUnitQueryVariables>(GetSalesFromSignedUnitDocument, options);
        }
export type GetSalesFromSignedUnitQueryHookResult = ReturnType<typeof useGetSalesFromSignedUnitQuery>;
export type GetSalesFromSignedUnitLazyQueryHookResult = ReturnType<typeof useGetSalesFromSignedUnitLazyQuery>;
export type GetSalesFromSignedUnitQueryResult = Apollo.QueryResult<GetSalesFromSignedUnitQuery, GetSalesFromSignedUnitQueryVariables>;
export const AddLatePaymentInterestDocument = gql`
    mutation addLatePaymentInterest($input: AddLateInterestInput!) {
  addLatePaymentInterest(input: $input)
}
    `;
export type AddLatePaymentInterestMutationFn = Apollo.MutationFunction<AddLatePaymentInterestMutation, AddLatePaymentInterestMutationVariables>;

/**
 * __useAddLatePaymentInterestMutation__
 *
 * To run a mutation, you first call `useAddLatePaymentInterestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLatePaymentInterestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLatePaymentInterestMutation, { data, loading, error }] = useAddLatePaymentInterestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddLatePaymentInterestMutation(baseOptions?: Apollo.MutationHookOptions<AddLatePaymentInterestMutation, AddLatePaymentInterestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddLatePaymentInterestMutation, AddLatePaymentInterestMutationVariables>(AddLatePaymentInterestDocument, options);
      }
export type AddLatePaymentInterestMutationHookResult = ReturnType<typeof useAddLatePaymentInterestMutation>;
export type AddLatePaymentInterestMutationResult = Apollo.MutationResult<AddLatePaymentInterestMutation>;
export type AddLatePaymentInterestMutationOptions = Apollo.BaseMutationOptions<AddLatePaymentInterestMutation, AddLatePaymentInterestMutationVariables>;
export const EditLatePaymentInterestDocument = gql`
    mutation editLatePaymentInterest($input: EditLateInterestInput!) {
  editLatePaymentInterest(input: $input)
}
    `;
export type EditLatePaymentInterestMutationFn = Apollo.MutationFunction<EditLatePaymentInterestMutation, EditLatePaymentInterestMutationVariables>;

/**
 * __useEditLatePaymentInterestMutation__
 *
 * To run a mutation, you first call `useEditLatePaymentInterestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditLatePaymentInterestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editLatePaymentInterestMutation, { data, loading, error }] = useEditLatePaymentInterestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditLatePaymentInterestMutation(baseOptions?: Apollo.MutationHookOptions<EditLatePaymentInterestMutation, EditLatePaymentInterestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditLatePaymentInterestMutation, EditLatePaymentInterestMutationVariables>(EditLatePaymentInterestDocument, options);
      }
export type EditLatePaymentInterestMutationHookResult = ReturnType<typeof useEditLatePaymentInterestMutation>;
export type EditLatePaymentInterestMutationResult = Apollo.MutationResult<EditLatePaymentInterestMutation>;
export type EditLatePaymentInterestMutationOptions = Apollo.BaseMutationOptions<EditLatePaymentInterestMutation, EditLatePaymentInterestMutationVariables>;
export const CreateLatePaymentInterestExceptionDocument = gql`
    mutation createLatePaymentInterestException($input: LatePaymentInterestExceptionInput!) {
  createLatePaymentInterestException(input: $input)
}
    `;
export type CreateLatePaymentInterestExceptionMutationFn = Apollo.MutationFunction<CreateLatePaymentInterestExceptionMutation, CreateLatePaymentInterestExceptionMutationVariables>;

/**
 * __useCreateLatePaymentInterestExceptionMutation__
 *
 * To run a mutation, you first call `useCreateLatePaymentInterestExceptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLatePaymentInterestExceptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLatePaymentInterestExceptionMutation, { data, loading, error }] = useCreateLatePaymentInterestExceptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLatePaymentInterestExceptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateLatePaymentInterestExceptionMutation, CreateLatePaymentInterestExceptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLatePaymentInterestExceptionMutation, CreateLatePaymentInterestExceptionMutationVariables>(CreateLatePaymentInterestExceptionDocument, options);
      }
export type CreateLatePaymentInterestExceptionMutationHookResult = ReturnType<typeof useCreateLatePaymentInterestExceptionMutation>;
export type CreateLatePaymentInterestExceptionMutationResult = Apollo.MutationResult<CreateLatePaymentInterestExceptionMutation>;
export type CreateLatePaymentInterestExceptionMutationOptions = Apollo.BaseMutationOptions<CreateLatePaymentInterestExceptionMutation, CreateLatePaymentInterestExceptionMutationVariables>;
export const UpdateLatePaymentInterestExceptionDocument = gql`
    mutation updateLatePaymentInterestException($input: EditLatePaymentInterestExceptionInput!) {
  updateLatePaymentInterestException(input: $input)
}
    `;
export type UpdateLatePaymentInterestExceptionMutationFn = Apollo.MutationFunction<UpdateLatePaymentInterestExceptionMutation, UpdateLatePaymentInterestExceptionMutationVariables>;

/**
 * __useUpdateLatePaymentInterestExceptionMutation__
 *
 * To run a mutation, you first call `useUpdateLatePaymentInterestExceptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLatePaymentInterestExceptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLatePaymentInterestExceptionMutation, { data, loading, error }] = useUpdateLatePaymentInterestExceptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLatePaymentInterestExceptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLatePaymentInterestExceptionMutation, UpdateLatePaymentInterestExceptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLatePaymentInterestExceptionMutation, UpdateLatePaymentInterestExceptionMutationVariables>(UpdateLatePaymentInterestExceptionDocument, options);
      }
export type UpdateLatePaymentInterestExceptionMutationHookResult = ReturnType<typeof useUpdateLatePaymentInterestExceptionMutation>;
export type UpdateLatePaymentInterestExceptionMutationResult = Apollo.MutationResult<UpdateLatePaymentInterestExceptionMutation>;
export type UpdateLatePaymentInterestExceptionMutationOptions = Apollo.BaseMutationOptions<UpdateLatePaymentInterestExceptionMutation, UpdateLatePaymentInterestExceptionMutationVariables>;
export const DeleteLatePaymentInterestExceptionDocument = gql`
    mutation deleteLatePaymentInterestException($id: String!) {
  deleteLatePaymentInterestException(id: $id)
}
    `;
export type DeleteLatePaymentInterestExceptionMutationFn = Apollo.MutationFunction<DeleteLatePaymentInterestExceptionMutation, DeleteLatePaymentInterestExceptionMutationVariables>;

/**
 * __useDeleteLatePaymentInterestExceptionMutation__
 *
 * To run a mutation, you first call `useDeleteLatePaymentInterestExceptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLatePaymentInterestExceptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLatePaymentInterestExceptionMutation, { data, loading, error }] = useDeleteLatePaymentInterestExceptionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLatePaymentInterestExceptionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLatePaymentInterestExceptionMutation, DeleteLatePaymentInterestExceptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLatePaymentInterestExceptionMutation, DeleteLatePaymentInterestExceptionMutationVariables>(DeleteLatePaymentInterestExceptionDocument, options);
      }
export type DeleteLatePaymentInterestExceptionMutationHookResult = ReturnType<typeof useDeleteLatePaymentInterestExceptionMutation>;
export type DeleteLatePaymentInterestExceptionMutationResult = Apollo.MutationResult<DeleteLatePaymentInterestExceptionMutation>;
export type DeleteLatePaymentInterestExceptionMutationOptions = Apollo.BaseMutationOptions<DeleteLatePaymentInterestExceptionMutation, DeleteLatePaymentInterestExceptionMutationVariables>;
export const GetAllPaymentReminderDocument = gql`
    query getAllPaymentReminder {
  getAllPaymentReminder {
    unitNo
    reminder1
    reminder2
    reminder3
    reminder4
    reminderDate
    balanceAmount
    generationBatch
  }
}
    `;

/**
 * __useGetAllPaymentReminderQuery__
 *
 * To run a query within a React component, call `useGetAllPaymentReminderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPaymentReminderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPaymentReminderQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllPaymentReminderQuery(baseOptions?: Apollo.QueryHookOptions<GetAllPaymentReminderQuery, GetAllPaymentReminderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllPaymentReminderQuery, GetAllPaymentReminderQueryVariables>(GetAllPaymentReminderDocument, options);
      }
export function useGetAllPaymentReminderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllPaymentReminderQuery, GetAllPaymentReminderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllPaymentReminderQuery, GetAllPaymentReminderQueryVariables>(GetAllPaymentReminderDocument, options);
        }
export type GetAllPaymentReminderQueryHookResult = ReturnType<typeof useGetAllPaymentReminderQuery>;
export type GetAllPaymentReminderLazyQueryHookResult = ReturnType<typeof useGetAllPaymentReminderLazyQuery>;
export type GetAllPaymentReminderQueryResult = Apollo.QueryResult<GetAllPaymentReminderQuery, GetAllPaymentReminderQueryVariables>;
export const GetPaymentReminderByGenerationBatchDocument = gql`
    query getPaymentReminderByGenerationBatch($generationBatch: String!) {
  getPaymentReminderByGenerationBatch(generationBatch: $generationBatch) {
    reminder1
    reminder2
    reminder3
    outstanding
    reminderList {
      saleId
      unitNo
      totalBalance
      reminder1
      reminder2
      reminder3
      share {
        sharedBy
        sharedDateTime
        sharedMethod
      }
      billing {
        reminderId
        refId
        refTable
        docNo
        docAmt
        docDate
        dueDate
        outstanding
        reminderDate
        reminderSeq
      }
    }
  }
}
    `;

/**
 * __useGetPaymentReminderByGenerationBatchQuery__
 *
 * To run a query within a React component, call `useGetPaymentReminderByGenerationBatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentReminderByGenerationBatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentReminderByGenerationBatchQuery({
 *   variables: {
 *      generationBatch: // value for 'generationBatch'
 *   },
 * });
 */
export function useGetPaymentReminderByGenerationBatchQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentReminderByGenerationBatchQuery, GetPaymentReminderByGenerationBatchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentReminderByGenerationBatchQuery, GetPaymentReminderByGenerationBatchQueryVariables>(GetPaymentReminderByGenerationBatchDocument, options);
      }
export function useGetPaymentReminderByGenerationBatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentReminderByGenerationBatchQuery, GetPaymentReminderByGenerationBatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentReminderByGenerationBatchQuery, GetPaymentReminderByGenerationBatchQueryVariables>(GetPaymentReminderByGenerationBatchDocument, options);
        }
export type GetPaymentReminderByGenerationBatchQueryHookResult = ReturnType<typeof useGetPaymentReminderByGenerationBatchQuery>;
export type GetPaymentReminderByGenerationBatchLazyQueryHookResult = ReturnType<typeof useGetPaymentReminderByGenerationBatchLazyQuery>;
export type GetPaymentReminderByGenerationBatchQueryResult = Apollo.QueryResult<GetPaymentReminderByGenerationBatchQuery, GetPaymentReminderByGenerationBatchQueryVariables>;
export const GeneratePaymentReminderProgressBillingListDocument = gql`
    query generatePaymentReminderProgressBillingList($reminderDate: DateTime!) {
  generatePaymentReminderProgressBillingList(reminderDate: $reminderDate) {
    reminder1
    reminder2
    reminder3
    outstanding
    reminderList {
      saleId
      unitNo
      totalBalance
      reminder1
      reminder2
      reminder3
      share {
        sharedBy
        sharedDateTime
        sharedMethod
      }
      billing {
        reminderId
        refId
        refTable
        docNo
        docAmt
        docDate
        dueDate
        outstanding
        reminderDate
        reminderSeq
      }
    }
  }
}
    `;

/**
 * __useGeneratePaymentReminderProgressBillingListQuery__
 *
 * To run a query within a React component, call `useGeneratePaymentReminderProgressBillingListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeneratePaymentReminderProgressBillingListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeneratePaymentReminderProgressBillingListQuery({
 *   variables: {
 *      reminderDate: // value for 'reminderDate'
 *   },
 * });
 */
export function useGeneratePaymentReminderProgressBillingListQuery(baseOptions: Apollo.QueryHookOptions<GeneratePaymentReminderProgressBillingListQuery, GeneratePaymentReminderProgressBillingListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GeneratePaymentReminderProgressBillingListQuery, GeneratePaymentReminderProgressBillingListQueryVariables>(GeneratePaymentReminderProgressBillingListDocument, options);
      }
export function useGeneratePaymentReminderProgressBillingListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GeneratePaymentReminderProgressBillingListQuery, GeneratePaymentReminderProgressBillingListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GeneratePaymentReminderProgressBillingListQuery, GeneratePaymentReminderProgressBillingListQueryVariables>(GeneratePaymentReminderProgressBillingListDocument, options);
        }
export type GeneratePaymentReminderProgressBillingListQueryHookResult = ReturnType<typeof useGeneratePaymentReminderProgressBillingListQuery>;
export type GeneratePaymentReminderProgressBillingListLazyQueryHookResult = ReturnType<typeof useGeneratePaymentReminderProgressBillingListLazyQuery>;
export type GeneratePaymentReminderProgressBillingListQueryResult = Apollo.QueryResult<GeneratePaymentReminderProgressBillingListQuery, GeneratePaymentReminderProgressBillingListQueryVariables>;
export const SharePaymentReminderDocument = gql`
    mutation sharePaymentReminder($input: sharePaymentReminderBasicInput!) {
  sharePaymentReminder(input: $input) {
    downloadFile
    isProject
    letterTemplateList {
      letterTemplateId
      letterTemplateName
    }
    attachment {
      base64
      fileName
    }
  }
}
    `;
export type SharePaymentReminderMutationFn = Apollo.MutationFunction<SharePaymentReminderMutation, SharePaymentReminderMutationVariables>;

/**
 * __useSharePaymentReminderMutation__
 *
 * To run a mutation, you first call `useSharePaymentReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSharePaymentReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sharePaymentReminderMutation, { data, loading, error }] = useSharePaymentReminderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSharePaymentReminderMutation(baseOptions?: Apollo.MutationHookOptions<SharePaymentReminderMutation, SharePaymentReminderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SharePaymentReminderMutation, SharePaymentReminderMutationVariables>(SharePaymentReminderDocument, options);
      }
export type SharePaymentReminderMutationHookResult = ReturnType<typeof useSharePaymentReminderMutation>;
export type SharePaymentReminderMutationResult = Apollo.MutationResult<SharePaymentReminderMutation>;
export type SharePaymentReminderMutationOptions = Apollo.BaseMutationOptions<SharePaymentReminderMutation, SharePaymentReminderMutationVariables>;
export const SharePaymentReminderByTemplateIdDocument = gql`
    mutation sharePaymentReminderByTemplateId($input: sharePaymentReminderByIdInput!) {
  sharePaymentReminderByTemplateId(input: $input) {
    base64
    fileName
  }
}
    `;
export type SharePaymentReminderByTemplateIdMutationFn = Apollo.MutationFunction<SharePaymentReminderByTemplateIdMutation, SharePaymentReminderByTemplateIdMutationVariables>;

/**
 * __useSharePaymentReminderByTemplateIdMutation__
 *
 * To run a mutation, you first call `useSharePaymentReminderByTemplateIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSharePaymentReminderByTemplateIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sharePaymentReminderByTemplateIdMutation, { data, loading, error }] = useSharePaymentReminderByTemplateIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSharePaymentReminderByTemplateIdMutation(baseOptions?: Apollo.MutationHookOptions<SharePaymentReminderByTemplateIdMutation, SharePaymentReminderByTemplateIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SharePaymentReminderByTemplateIdMutation, SharePaymentReminderByTemplateIdMutationVariables>(SharePaymentReminderByTemplateIdDocument, options);
      }
export type SharePaymentReminderByTemplateIdMutationHookResult = ReturnType<typeof useSharePaymentReminderByTemplateIdMutation>;
export type SharePaymentReminderByTemplateIdMutationResult = Apollo.MutationResult<SharePaymentReminderByTemplateIdMutation>;
export type SharePaymentReminderByTemplateIdMutationOptions = Apollo.BaseMutationOptions<SharePaymentReminderByTemplateIdMutation, SharePaymentReminderByTemplateIdMutationVariables>;
export const GeneratePaymentReminderListDocument = gql`
    query generatePaymentReminderList($reminderDate: DateTime!) {
  generatePaymentReminderList(reminderDate: $reminderDate) {
    reminderList {
      unitNo
      taxSchemeId
      numAlert
      saleId
      maxReminder
      alertList {
        installmentId
        dueDate
        allocationDate
        prevAllocDate
        refTable
        intervalDays
        outstanding
        label
        taxToDate
        finalTaxToDate
        paidToDate
        buyBackAmt
      }
    }
  }
}
    `;

/**
 * __useGeneratePaymentReminderListQuery__
 *
 * To run a query within a React component, call `useGeneratePaymentReminderListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeneratePaymentReminderListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeneratePaymentReminderListQuery({
 *   variables: {
 *      reminderDate: // value for 'reminderDate'
 *   },
 * });
 */
export function useGeneratePaymentReminderListQuery(baseOptions: Apollo.QueryHookOptions<GeneratePaymentReminderListQuery, GeneratePaymentReminderListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GeneratePaymentReminderListQuery, GeneratePaymentReminderListQueryVariables>(GeneratePaymentReminderListDocument, options);
      }
export function useGeneratePaymentReminderListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GeneratePaymentReminderListQuery, GeneratePaymentReminderListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GeneratePaymentReminderListQuery, GeneratePaymentReminderListQueryVariables>(GeneratePaymentReminderListDocument, options);
        }
export type GeneratePaymentReminderListQueryHookResult = ReturnType<typeof useGeneratePaymentReminderListQuery>;
export type GeneratePaymentReminderListLazyQueryHookResult = ReturnType<typeof useGeneratePaymentReminderListLazyQuery>;
export type GeneratePaymentReminderListQueryResult = Apollo.QueryResult<GeneratePaymentReminderListQuery, GeneratePaymentReminderListQueryVariables>;
export const GetPaymentRemindersByGenerationBatchDocument = gql`
    query getPaymentRemindersByGenerationBatch($generationBatch: String!) {
  getPaymentRemindersByGenerationBatch(generationBatch: $generationBatch) {
    reminderList {
      unitNo
      numAlert
      saleId
      reminderNo
      alertList {
        reminderId
        installmentId
        dueDate
        allocationDate
        prevAllocDate
        refTable
        intervalDays
        outstanding
        label
      }
    }
  }
}
    `;

/**
 * __useGetPaymentRemindersByGenerationBatchQuery__
 *
 * To run a query within a React component, call `useGetPaymentRemindersByGenerationBatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentRemindersByGenerationBatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentRemindersByGenerationBatchQuery({
 *   variables: {
 *      generationBatch: // value for 'generationBatch'
 *   },
 * });
 */
export function useGetPaymentRemindersByGenerationBatchQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentRemindersByGenerationBatchQuery, GetPaymentRemindersByGenerationBatchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentRemindersByGenerationBatchQuery, GetPaymentRemindersByGenerationBatchQueryVariables>(GetPaymentRemindersByGenerationBatchDocument, options);
      }
export function useGetPaymentRemindersByGenerationBatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentRemindersByGenerationBatchQuery, GetPaymentRemindersByGenerationBatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentRemindersByGenerationBatchQuery, GetPaymentRemindersByGenerationBatchQueryVariables>(GetPaymentRemindersByGenerationBatchDocument, options);
        }
export type GetPaymentRemindersByGenerationBatchQueryHookResult = ReturnType<typeof useGetPaymentRemindersByGenerationBatchQuery>;
export type GetPaymentRemindersByGenerationBatchLazyQueryHookResult = ReturnType<typeof useGetPaymentRemindersByGenerationBatchLazyQuery>;
export type GetPaymentRemindersByGenerationBatchQueryResult = Apollo.QueryResult<GetPaymentRemindersByGenerationBatchQuery, GetPaymentRemindersByGenerationBatchQueryVariables>;
export const AddPaymentReminderListDocument = gql`
    mutation addPaymentReminderList($input: paymentReminderListInput!) {
  addPaymentReminderList(input: $input)
}
    `;
export type AddPaymentReminderListMutationFn = Apollo.MutationFunction<AddPaymentReminderListMutation, AddPaymentReminderListMutationVariables>;

/**
 * __useAddPaymentReminderListMutation__
 *
 * To run a mutation, you first call `useAddPaymentReminderListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPaymentReminderListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPaymentReminderListMutation, { data, loading, error }] = useAddPaymentReminderListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPaymentReminderListMutation(baseOptions?: Apollo.MutationHookOptions<AddPaymentReminderListMutation, AddPaymentReminderListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPaymentReminderListMutation, AddPaymentReminderListMutationVariables>(AddPaymentReminderListDocument, options);
      }
export type AddPaymentReminderListMutationHookResult = ReturnType<typeof useAddPaymentReminderListMutation>;
export type AddPaymentReminderListMutationResult = Apollo.MutationResult<AddPaymentReminderListMutation>;
export type AddPaymentReminderListMutationOptions = Apollo.BaseMutationOptions<AddPaymentReminderListMutation, AddPaymentReminderListMutationVariables>;
export const DeletePaymentReminderListDocument = gql`
    mutation deletePaymentReminderList($input: paymentReminderIdsInput!) {
  deletePaymentReminderList(input: $input)
}
    `;
export type DeletePaymentReminderListMutationFn = Apollo.MutationFunction<DeletePaymentReminderListMutation, DeletePaymentReminderListMutationVariables>;

/**
 * __useDeletePaymentReminderListMutation__
 *
 * To run a mutation, you first call `useDeletePaymentReminderListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePaymentReminderListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePaymentReminderListMutation, { data, loading, error }] = useDeletePaymentReminderListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePaymentReminderListMutation(baseOptions?: Apollo.MutationHookOptions<DeletePaymentReminderListMutation, DeletePaymentReminderListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePaymentReminderListMutation, DeletePaymentReminderListMutationVariables>(DeletePaymentReminderListDocument, options);
      }
export type DeletePaymentReminderListMutationHookResult = ReturnType<typeof useDeletePaymentReminderListMutation>;
export type DeletePaymentReminderListMutationResult = Apollo.MutationResult<DeletePaymentReminderListMutation>;
export type DeletePaymentReminderListMutationOptions = Apollo.BaseMutationOptions<DeletePaymentReminderListMutation, DeletePaymentReminderListMutationVariables>;
export const GetAllProjectPaymentReminderExceptionDocument = gql`
    query getAllProjectPaymentReminderException {
  getAllProjectPaymentReminderException {
    id
    name
    unitNo
    maxReminder
    isCompany
    companyName
  }
}
    `;

/**
 * __useGetAllProjectPaymentReminderExceptionQuery__
 *
 * To run a query within a React component, call `useGetAllProjectPaymentReminderExceptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllProjectPaymentReminderExceptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllProjectPaymentReminderExceptionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllProjectPaymentReminderExceptionQuery(baseOptions?: Apollo.QueryHookOptions<GetAllProjectPaymentReminderExceptionQuery, GetAllProjectPaymentReminderExceptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllProjectPaymentReminderExceptionQuery, GetAllProjectPaymentReminderExceptionQueryVariables>(GetAllProjectPaymentReminderExceptionDocument, options);
      }
export function useGetAllProjectPaymentReminderExceptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllProjectPaymentReminderExceptionQuery, GetAllProjectPaymentReminderExceptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllProjectPaymentReminderExceptionQuery, GetAllProjectPaymentReminderExceptionQueryVariables>(GetAllProjectPaymentReminderExceptionDocument, options);
        }
export type GetAllProjectPaymentReminderExceptionQueryHookResult = ReturnType<typeof useGetAllProjectPaymentReminderExceptionQuery>;
export type GetAllProjectPaymentReminderExceptionLazyQueryHookResult = ReturnType<typeof useGetAllProjectPaymentReminderExceptionLazyQuery>;
export type GetAllProjectPaymentReminderExceptionQueryResult = Apollo.QueryResult<GetAllProjectPaymentReminderExceptionQuery, GetAllProjectPaymentReminderExceptionQueryVariables>;
export const GetProjectPaymentReminderExceptionByIdDocument = gql`
    query getProjectPaymentReminderExceptionById($id: String!) {
  getProjectPaymentReminderExceptionById(id: $id) {
    id
    name
    unitNo
    maxReminder
  }
}
    `;

/**
 * __useGetProjectPaymentReminderExceptionByIdQuery__
 *
 * To run a query within a React component, call `useGetProjectPaymentReminderExceptionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectPaymentReminderExceptionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectPaymentReminderExceptionByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectPaymentReminderExceptionByIdQuery(baseOptions: Apollo.QueryHookOptions<GetProjectPaymentReminderExceptionByIdQuery, GetProjectPaymentReminderExceptionByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectPaymentReminderExceptionByIdQuery, GetProjectPaymentReminderExceptionByIdQueryVariables>(GetProjectPaymentReminderExceptionByIdDocument, options);
      }
export function useGetProjectPaymentReminderExceptionByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectPaymentReminderExceptionByIdQuery, GetProjectPaymentReminderExceptionByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectPaymentReminderExceptionByIdQuery, GetProjectPaymentReminderExceptionByIdQueryVariables>(GetProjectPaymentReminderExceptionByIdDocument, options);
        }
export type GetProjectPaymentReminderExceptionByIdQueryHookResult = ReturnType<typeof useGetProjectPaymentReminderExceptionByIdQuery>;
export type GetProjectPaymentReminderExceptionByIdLazyQueryHookResult = ReturnType<typeof useGetProjectPaymentReminderExceptionByIdLazyQuery>;
export type GetProjectPaymentReminderExceptionByIdQueryResult = Apollo.QueryResult<GetProjectPaymentReminderExceptionByIdQuery, GetProjectPaymentReminderExceptionByIdQueryVariables>;
export const GetProjectPaymentWithReminderDocument = gql`
    query getProjectPaymentWithReminder {
  getProjectPaymentWithReminder {
    saleId
    unitNo
    name
    isCompany
    companyName
  }
}
    `;

/**
 * __useGetProjectPaymentWithReminderQuery__
 *
 * To run a query within a React component, call `useGetProjectPaymentWithReminderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectPaymentWithReminderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectPaymentWithReminderQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProjectPaymentWithReminderQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectPaymentWithReminderQuery, GetProjectPaymentWithReminderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectPaymentWithReminderQuery, GetProjectPaymentWithReminderQueryVariables>(GetProjectPaymentWithReminderDocument, options);
      }
export function useGetProjectPaymentWithReminderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectPaymentWithReminderQuery, GetProjectPaymentWithReminderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectPaymentWithReminderQuery, GetProjectPaymentWithReminderQueryVariables>(GetProjectPaymentWithReminderDocument, options);
        }
export type GetProjectPaymentWithReminderQueryHookResult = ReturnType<typeof useGetProjectPaymentWithReminderQuery>;
export type GetProjectPaymentWithReminderLazyQueryHookResult = ReturnType<typeof useGetProjectPaymentWithReminderLazyQuery>;
export type GetProjectPaymentWithReminderQueryResult = Apollo.QueryResult<GetProjectPaymentWithReminderQuery, GetProjectPaymentWithReminderQueryVariables>;
export const AddProjectPaymentReminderExceptionDocument = gql`
    mutation addProjectPaymentReminderException($input: [projectPaymentReminderExceptionInput!]!) {
  addProjectPaymentReminderException(input: $input)
}
    `;
export type AddProjectPaymentReminderExceptionMutationFn = Apollo.MutationFunction<AddProjectPaymentReminderExceptionMutation, AddProjectPaymentReminderExceptionMutationVariables>;

/**
 * __useAddProjectPaymentReminderExceptionMutation__
 *
 * To run a mutation, you first call `useAddProjectPaymentReminderExceptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProjectPaymentReminderExceptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProjectPaymentReminderExceptionMutation, { data, loading, error }] = useAddProjectPaymentReminderExceptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddProjectPaymentReminderExceptionMutation(baseOptions?: Apollo.MutationHookOptions<AddProjectPaymentReminderExceptionMutation, AddProjectPaymentReminderExceptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProjectPaymentReminderExceptionMutation, AddProjectPaymentReminderExceptionMutationVariables>(AddProjectPaymentReminderExceptionDocument, options);
      }
export type AddProjectPaymentReminderExceptionMutationHookResult = ReturnType<typeof useAddProjectPaymentReminderExceptionMutation>;
export type AddProjectPaymentReminderExceptionMutationResult = Apollo.MutationResult<AddProjectPaymentReminderExceptionMutation>;
export type AddProjectPaymentReminderExceptionMutationOptions = Apollo.BaseMutationOptions<AddProjectPaymentReminderExceptionMutation, AddProjectPaymentReminderExceptionMutationVariables>;
export const EditProjectPaymentReminderExceptionDocument = gql`
    mutation editProjectPaymentReminderException($input: editProjectPaymentReminderExceptionInput!) {
  editProjectPaymentReminderException(input: $input)
}
    `;
export type EditProjectPaymentReminderExceptionMutationFn = Apollo.MutationFunction<EditProjectPaymentReminderExceptionMutation, EditProjectPaymentReminderExceptionMutationVariables>;

/**
 * __useEditProjectPaymentReminderExceptionMutation__
 *
 * To run a mutation, you first call `useEditProjectPaymentReminderExceptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditProjectPaymentReminderExceptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editProjectPaymentReminderExceptionMutation, { data, loading, error }] = useEditProjectPaymentReminderExceptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditProjectPaymentReminderExceptionMutation(baseOptions?: Apollo.MutationHookOptions<EditProjectPaymentReminderExceptionMutation, EditProjectPaymentReminderExceptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditProjectPaymentReminderExceptionMutation, EditProjectPaymentReminderExceptionMutationVariables>(EditProjectPaymentReminderExceptionDocument, options);
      }
export type EditProjectPaymentReminderExceptionMutationHookResult = ReturnType<typeof useEditProjectPaymentReminderExceptionMutation>;
export type EditProjectPaymentReminderExceptionMutationResult = Apollo.MutationResult<EditProjectPaymentReminderExceptionMutation>;
export type EditProjectPaymentReminderExceptionMutationOptions = Apollo.BaseMutationOptions<EditProjectPaymentReminderExceptionMutation, EditProjectPaymentReminderExceptionMutationVariables>;
export const DeleteProjectPaymentReminderExceptionDocument = gql`
    mutation deleteProjectPaymentReminderException($id: String!) {
  deleteProjectPaymentReminderException(id: $id)
}
    `;
export type DeleteProjectPaymentReminderExceptionMutationFn = Apollo.MutationFunction<DeleteProjectPaymentReminderExceptionMutation, DeleteProjectPaymentReminderExceptionMutationVariables>;

/**
 * __useDeleteProjectPaymentReminderExceptionMutation__
 *
 * To run a mutation, you first call `useDeleteProjectPaymentReminderExceptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectPaymentReminderExceptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectPaymentReminderExceptionMutation, { data, loading, error }] = useDeleteProjectPaymentReminderExceptionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProjectPaymentReminderExceptionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectPaymentReminderExceptionMutation, DeleteProjectPaymentReminderExceptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectPaymentReminderExceptionMutation, DeleteProjectPaymentReminderExceptionMutationVariables>(DeleteProjectPaymentReminderExceptionDocument, options);
      }
export type DeleteProjectPaymentReminderExceptionMutationHookResult = ReturnType<typeof useDeleteProjectPaymentReminderExceptionMutation>;
export type DeleteProjectPaymentReminderExceptionMutationResult = Apollo.MutationResult<DeleteProjectPaymentReminderExceptionMutation>;
export type DeleteProjectPaymentReminderExceptionMutationOptions = Apollo.BaseMutationOptions<DeleteProjectPaymentReminderExceptionMutation, DeleteProjectPaymentReminderExceptionMutationVariables>;
export const GetProjectReminderSettingDocument = gql`
    query getProjectReminderSetting {
  getProjectReminderSetting {
    id
    projectId
    spaReminder1
    spaReminder2
    spaReminder3
    spaReminder4
    downpaymentReminder1
    downpaymentReminder2
    downpaymentReminder3
    downpaymentReminder4
    paymentReminder1
    paymentReminder2
    paymentReminder3
    paymentReminder4
    minimumAmount
    paymentReminderScheduler
    paymentReminderSchedulerTime
  }
}
    `;

/**
 * __useGetProjectReminderSettingQuery__
 *
 * To run a query within a React component, call `useGetProjectReminderSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectReminderSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectReminderSettingQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProjectReminderSettingQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectReminderSettingQuery, GetProjectReminderSettingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectReminderSettingQuery, GetProjectReminderSettingQueryVariables>(GetProjectReminderSettingDocument, options);
      }
export function useGetProjectReminderSettingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectReminderSettingQuery, GetProjectReminderSettingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectReminderSettingQuery, GetProjectReminderSettingQueryVariables>(GetProjectReminderSettingDocument, options);
        }
export type GetProjectReminderSettingQueryHookResult = ReturnType<typeof useGetProjectReminderSettingQuery>;
export type GetProjectReminderSettingLazyQueryHookResult = ReturnType<typeof useGetProjectReminderSettingLazyQuery>;
export type GetProjectReminderSettingQueryResult = Apollo.QueryResult<GetProjectReminderSettingQuery, GetProjectReminderSettingQueryVariables>;
export const AddProjectReminderSettingDocument = gql`
    mutation addProjectReminderSetting($input: AddProjectReminderInput!) {
  addProjectReminderSetting(input: $input)
}
    `;
export type AddProjectReminderSettingMutationFn = Apollo.MutationFunction<AddProjectReminderSettingMutation, AddProjectReminderSettingMutationVariables>;

/**
 * __useAddProjectReminderSettingMutation__
 *
 * To run a mutation, you first call `useAddProjectReminderSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProjectReminderSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProjectReminderSettingMutation, { data, loading, error }] = useAddProjectReminderSettingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddProjectReminderSettingMutation(baseOptions?: Apollo.MutationHookOptions<AddProjectReminderSettingMutation, AddProjectReminderSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProjectReminderSettingMutation, AddProjectReminderSettingMutationVariables>(AddProjectReminderSettingDocument, options);
      }
export type AddProjectReminderSettingMutationHookResult = ReturnType<typeof useAddProjectReminderSettingMutation>;
export type AddProjectReminderSettingMutationResult = Apollo.MutationResult<AddProjectReminderSettingMutation>;
export type AddProjectReminderSettingMutationOptions = Apollo.BaseMutationOptions<AddProjectReminderSettingMutation, AddProjectReminderSettingMutationVariables>;
export const EditProjectReminderSettingDocument = gql`
    mutation editProjectReminderSetting($input: EditProjectReminderInput!) {
  editProjectReminderSetting(input: $input)
}
    `;
export type EditProjectReminderSettingMutationFn = Apollo.MutationFunction<EditProjectReminderSettingMutation, EditProjectReminderSettingMutationVariables>;

/**
 * __useEditProjectReminderSettingMutation__
 *
 * To run a mutation, you first call `useEditProjectReminderSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditProjectReminderSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editProjectReminderSettingMutation, { data, loading, error }] = useEditProjectReminderSettingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditProjectReminderSettingMutation(baseOptions?: Apollo.MutationHookOptions<EditProjectReminderSettingMutation, EditProjectReminderSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditProjectReminderSettingMutation, EditProjectReminderSettingMutationVariables>(EditProjectReminderSettingDocument, options);
      }
export type EditProjectReminderSettingMutationHookResult = ReturnType<typeof useEditProjectReminderSettingMutation>;
export type EditProjectReminderSettingMutationResult = Apollo.MutationResult<EditProjectReminderSettingMutation>;
export type EditProjectReminderSettingMutationOptions = Apollo.BaseMutationOptions<EditProjectReminderSettingMutation, EditProjectReminderSettingMutationVariables>;
export const GetAllLateInterestDocument = gql`
    query getAllLateInterest {
  getAllLateInterest {
    generationBatch
    generationBatchDate
    unitNo
    amount
    billingCount
    lateInterestId
  }
}
    `;

/**
 * __useGetAllLateInterestQuery__
 *
 * To run a query within a React component, call `useGetAllLateInterestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllLateInterestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllLateInterestQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllLateInterestQuery(baseOptions?: Apollo.QueryHookOptions<GetAllLateInterestQuery, GetAllLateInterestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllLateInterestQuery, GetAllLateInterestQueryVariables>(GetAllLateInterestDocument, options);
      }
export function useGetAllLateInterestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllLateInterestQuery, GetAllLateInterestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllLateInterestQuery, GetAllLateInterestQueryVariables>(GetAllLateInterestDocument, options);
        }
export type GetAllLateInterestQueryHookResult = ReturnType<typeof useGetAllLateInterestQuery>;
export type GetAllLateInterestLazyQueryHookResult = ReturnType<typeof useGetAllLateInterestLazyQuery>;
export type GetAllLateInterestQueryResult = Apollo.QueryResult<GetAllLateInterestQuery, GetAllLateInterestQueryVariables>;
export const GetLateInterestByIdDocument = gql`
    query getLateInterestById($generationBatchDate: DateTime!, $generationBatchId: String!) {
  getLateInterestById(generationBatchDate: $generationBatchDate, generationBatchId: $generationBatchId) {
    unitNo
    saleId
    totalDocumentAmount
    billingCount
    startDate
    endDate
    lateInterestDetail {
      lateInterestId
      documentNo
      documentDate
      documentAmount
      documentRef
      description
      status
      startDate
      endDate
      overdueDay
      table
      billingId
      lateInterestDocumentNo
      seqNo
      interestAmount
    }
  }
}
    `;

/**
 * __useGetLateInterestByIdQuery__
 *
 * To run a query within a React component, call `useGetLateInterestByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLateInterestByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLateInterestByIdQuery({
 *   variables: {
 *      generationBatchDate: // value for 'generationBatchDate'
 *      generationBatchId: // value for 'generationBatchId'
 *   },
 * });
 */
export function useGetLateInterestByIdQuery(baseOptions: Apollo.QueryHookOptions<GetLateInterestByIdQuery, GetLateInterestByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLateInterestByIdQuery, GetLateInterestByIdQueryVariables>(GetLateInterestByIdDocument, options);
      }
export function useGetLateInterestByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLateInterestByIdQuery, GetLateInterestByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLateInterestByIdQuery, GetLateInterestByIdQueryVariables>(GetLateInterestByIdDocument, options);
        }
export type GetLateInterestByIdQueryHookResult = ReturnType<typeof useGetLateInterestByIdQuery>;
export type GetLateInterestByIdLazyQueryHookResult = ReturnType<typeof useGetLateInterestByIdLazyQuery>;
export type GetLateInterestByIdQueryResult = Apollo.QueryResult<GetLateInterestByIdQuery, GetLateInterestByIdQueryVariables>;
export const GenerateLatePaymentDocument = gql`
    mutation generateLatePayment($input: paymentLateInterestInput!) {
  generateLatePayment(input: $input)
}
    `;
export type GenerateLatePaymentMutationFn = Apollo.MutationFunction<GenerateLatePaymentMutation, GenerateLatePaymentMutationVariables>;

/**
 * __useGenerateLatePaymentMutation__
 *
 * To run a mutation, you first call `useGenerateLatePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateLatePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateLatePaymentMutation, { data, loading, error }] = useGenerateLatePaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateLatePaymentMutation(baseOptions?: Apollo.MutationHookOptions<GenerateLatePaymentMutation, GenerateLatePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateLatePaymentMutation, GenerateLatePaymentMutationVariables>(GenerateLatePaymentDocument, options);
      }
export type GenerateLatePaymentMutationHookResult = ReturnType<typeof useGenerateLatePaymentMutation>;
export type GenerateLatePaymentMutationResult = Apollo.MutationResult<GenerateLatePaymentMutation>;
export type GenerateLatePaymentMutationOptions = Apollo.BaseMutationOptions<GenerateLatePaymentMutation, GenerateLatePaymentMutationVariables>;
export const UpdateLateInterestStatusDocument = gql`
    mutation updateLateInterestStatus($input: updatePaymentLateInterestInput!) {
  updateLateInterestStatus(input: $input)
}
    `;
export type UpdateLateInterestStatusMutationFn = Apollo.MutationFunction<UpdateLateInterestStatusMutation, UpdateLateInterestStatusMutationVariables>;

/**
 * __useUpdateLateInterestStatusMutation__
 *
 * To run a mutation, you first call `useUpdateLateInterestStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLateInterestStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLateInterestStatusMutation, { data, loading, error }] = useUpdateLateInterestStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLateInterestStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLateInterestStatusMutation, UpdateLateInterestStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLateInterestStatusMutation, UpdateLateInterestStatusMutationVariables>(UpdateLateInterestStatusDocument, options);
      }
export type UpdateLateInterestStatusMutationHookResult = ReturnType<typeof useUpdateLateInterestStatusMutation>;
export type UpdateLateInterestStatusMutationResult = Apollo.MutationResult<UpdateLateInterestStatusMutation>;
export type UpdateLateInterestStatusMutationOptions = Apollo.BaseMutationOptions<UpdateLateInterestStatusMutation, UpdateLateInterestStatusMutationVariables>;
export const UpdateLateInterestStatusByGenerationBatchDocument = gql`
    mutation updateLateInterestStatusByGenerationBatch($input: generationBatchPostingInput!) {
  updateLateInterestStatusByGenerationBatch(input: $input)
}
    `;
export type UpdateLateInterestStatusByGenerationBatchMutationFn = Apollo.MutationFunction<UpdateLateInterestStatusByGenerationBatchMutation, UpdateLateInterestStatusByGenerationBatchMutationVariables>;

/**
 * __useUpdateLateInterestStatusByGenerationBatchMutation__
 *
 * To run a mutation, you first call `useUpdateLateInterestStatusByGenerationBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLateInterestStatusByGenerationBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLateInterestStatusByGenerationBatchMutation, { data, loading, error }] = useUpdateLateInterestStatusByGenerationBatchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLateInterestStatusByGenerationBatchMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLateInterestStatusByGenerationBatchMutation, UpdateLateInterestStatusByGenerationBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLateInterestStatusByGenerationBatchMutation, UpdateLateInterestStatusByGenerationBatchMutationVariables>(UpdateLateInterestStatusByGenerationBatchDocument, options);
      }
export type UpdateLateInterestStatusByGenerationBatchMutationHookResult = ReturnType<typeof useUpdateLateInterestStatusByGenerationBatchMutation>;
export type UpdateLateInterestStatusByGenerationBatchMutationResult = Apollo.MutationResult<UpdateLateInterestStatusByGenerationBatchMutation>;
export type UpdateLateInterestStatusByGenerationBatchMutationOptions = Apollo.BaseMutationOptions<UpdateLateInterestStatusByGenerationBatchMutation, UpdateLateInterestStatusByGenerationBatchMutationVariables>;
export const GetAssignedStaffListDocument = gql`
    query getAssignedStaffList($projectId: String!) {
  getAssignedStaffList(projectId: $projectId) {
    id
    email
    name
    phone
  }
}
    `;

/**
 * __useGetAssignedStaffListQuery__
 *
 * To run a query within a React component, call `useGetAssignedStaffListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignedStaffListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignedStaffListQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetAssignedStaffListQuery(baseOptions: Apollo.QueryHookOptions<GetAssignedStaffListQuery, GetAssignedStaffListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssignedStaffListQuery, GetAssignedStaffListQueryVariables>(GetAssignedStaffListDocument, options);
      }
export function useGetAssignedStaffListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssignedStaffListQuery, GetAssignedStaffListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssignedStaffListQuery, GetAssignedStaffListQueryVariables>(GetAssignedStaffListDocument, options);
        }
export type GetAssignedStaffListQueryHookResult = ReturnType<typeof useGetAssignedStaffListQuery>;
export type GetAssignedStaffListLazyQueryHookResult = ReturnType<typeof useGetAssignedStaffListLazyQuery>;
export type GetAssignedStaffListQueryResult = Apollo.QueryResult<GetAssignedStaffListQuery, GetAssignedStaffListQueryVariables>;
export const GetUnassignedStaffListDocument = gql`
    query getUnassignedStaffList($projectId: String!) {
  getUnassignedStaffList(projectId: $projectId) {
    id
    email
    name
    phone
  }
}
    `;

/**
 * __useGetUnassignedStaffListQuery__
 *
 * To run a query within a React component, call `useGetUnassignedStaffListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnassignedStaffListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnassignedStaffListQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetUnassignedStaffListQuery(baseOptions: Apollo.QueryHookOptions<GetUnassignedStaffListQuery, GetUnassignedStaffListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnassignedStaffListQuery, GetUnassignedStaffListQueryVariables>(GetUnassignedStaffListDocument, options);
      }
export function useGetUnassignedStaffListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnassignedStaffListQuery, GetUnassignedStaffListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnassignedStaffListQuery, GetUnassignedStaffListQueryVariables>(GetUnassignedStaffListDocument, options);
        }
export type GetUnassignedStaffListQueryHookResult = ReturnType<typeof useGetUnassignedStaffListQuery>;
export type GetUnassignedStaffListLazyQueryHookResult = ReturnType<typeof useGetUnassignedStaffListLazyQuery>;
export type GetUnassignedStaffListQueryResult = Apollo.QueryResult<GetUnassignedStaffListQuery, GetUnassignedStaffListQueryVariables>;
export const AssignAuthorizedSaleStaffDocument = gql`
    mutation assignAuthorizedSaleStaff($projectId: String!, $salesPersonId: [String!]!) {
  assignAuthorizedSaleStaff(projectId: $projectId, salesPersonId: $salesPersonId)
}
    `;
export type AssignAuthorizedSaleStaffMutationFn = Apollo.MutationFunction<AssignAuthorizedSaleStaffMutation, AssignAuthorizedSaleStaffMutationVariables>;

/**
 * __useAssignAuthorizedSaleStaffMutation__
 *
 * To run a mutation, you first call `useAssignAuthorizedSaleStaffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignAuthorizedSaleStaffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignAuthorizedSaleStaffMutation, { data, loading, error }] = useAssignAuthorizedSaleStaffMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      salesPersonId: // value for 'salesPersonId'
 *   },
 * });
 */
export function useAssignAuthorizedSaleStaffMutation(baseOptions?: Apollo.MutationHookOptions<AssignAuthorizedSaleStaffMutation, AssignAuthorizedSaleStaffMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignAuthorizedSaleStaffMutation, AssignAuthorizedSaleStaffMutationVariables>(AssignAuthorizedSaleStaffDocument, options);
      }
export type AssignAuthorizedSaleStaffMutationHookResult = ReturnType<typeof useAssignAuthorizedSaleStaffMutation>;
export type AssignAuthorizedSaleStaffMutationResult = Apollo.MutationResult<AssignAuthorizedSaleStaffMutation>;
export type AssignAuthorizedSaleStaffMutationOptions = Apollo.BaseMutationOptions<AssignAuthorizedSaleStaffMutation, AssignAuthorizedSaleStaffMutationVariables>;
export const UnassignAuthorizedSaleStaffDocument = gql`
    mutation unassignAuthorizedSaleStaff($id: [String!]!) {
  unassignAuthorizedSaleStaff(id: $id)
}
    `;
export type UnassignAuthorizedSaleStaffMutationFn = Apollo.MutationFunction<UnassignAuthorizedSaleStaffMutation, UnassignAuthorizedSaleStaffMutationVariables>;

/**
 * __useUnassignAuthorizedSaleStaffMutation__
 *
 * To run a mutation, you first call `useUnassignAuthorizedSaleStaffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignAuthorizedSaleStaffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignAuthorizedSaleStaffMutation, { data, loading, error }] = useUnassignAuthorizedSaleStaffMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnassignAuthorizedSaleStaffMutation(baseOptions?: Apollo.MutationHookOptions<UnassignAuthorizedSaleStaffMutation, UnassignAuthorizedSaleStaffMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnassignAuthorizedSaleStaffMutation, UnassignAuthorizedSaleStaffMutationVariables>(UnassignAuthorizedSaleStaffDocument, options);
      }
export type UnassignAuthorizedSaleStaffMutationHookResult = ReturnType<typeof useUnassignAuthorizedSaleStaffMutation>;
export type UnassignAuthorizedSaleStaffMutationResult = Apollo.MutationResult<UnassignAuthorizedSaleStaffMutation>;
export type UnassignAuthorizedSaleStaffMutationOptions = Apollo.BaseMutationOptions<UnassignAuthorizedSaleStaffMutation, UnassignAuthorizedSaleStaffMutationVariables>;
export const GetCollectionActivityIndoDocument = gql`
    query getCollectionActivityIndo {
  getCollectionActivityIndo {
    saleId
    unitId
    unitNo
    fullName
    totalDocumentAmount
    totalAllocatedAmount
    totalOutstanding
    dueDate
    billingType
    assignTo
    assignedDate
    generateDate
    overduedPurchaserAccountId
    assignName
    activityDate
    activityRemark
  }
}
    `;

/**
 * __useGetCollectionActivityIndoQuery__
 *
 * To run a query within a React component, call `useGetCollectionActivityIndoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionActivityIndoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionActivityIndoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCollectionActivityIndoQuery(baseOptions?: Apollo.QueryHookOptions<GetCollectionActivityIndoQuery, GetCollectionActivityIndoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectionActivityIndoQuery, GetCollectionActivityIndoQueryVariables>(GetCollectionActivityIndoDocument, options);
      }
export function useGetCollectionActivityIndoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectionActivityIndoQuery, GetCollectionActivityIndoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectionActivityIndoQuery, GetCollectionActivityIndoQueryVariables>(GetCollectionActivityIndoDocument, options);
        }
export type GetCollectionActivityIndoQueryHookResult = ReturnType<typeof useGetCollectionActivityIndoQuery>;
export type GetCollectionActivityIndoLazyQueryHookResult = ReturnType<typeof useGetCollectionActivityIndoLazyQuery>;
export type GetCollectionActivityIndoQueryResult = Apollo.QueryResult<GetCollectionActivityIndoQuery, GetCollectionActivityIndoQueryVariables>;
export const GetCollectionActivityWithOpaHeadersDocument = gql`
    query getCollectionActivityWithOPAHeaders($projectId: String!, $saleId: String!, $overduePurchaserAccountId: String!) {
  getCollectionActivityWithOPAHeaders(projectId: $projectId, saleId: $saleId, overduePurchaserAccountId: $overduePurchaserAccountId) {
    OverduePurchaserAccountDetails {
      saleId
      unitId
      unitNo
      fullName
      email
      phoneNo
      totalAllDocumentAmount
      totalAllAllocatedAmount
      totalAllOutstanding
      generateDate
      overduePurchaser {
        docId
        totalDocumentAmount
        totalAllocatedAmount
        totalOutstanding
        dueDate
        creditTerm
        generateDate
        billingType
      }
    }
    overduePurchaseCAListing {
      caId
      saleId
      activityDate
      activityRemark
      activityStatus
      countDoc
    }
  }
}
    `;

/**
 * __useGetCollectionActivityWithOpaHeadersQuery__
 *
 * To run a query within a React component, call `useGetCollectionActivityWithOpaHeadersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionActivityWithOpaHeadersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionActivityWithOpaHeadersQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      saleId: // value for 'saleId'
 *      overduePurchaserAccountId: // value for 'overduePurchaserAccountId'
 *   },
 * });
 */
export function useGetCollectionActivityWithOpaHeadersQuery(baseOptions: Apollo.QueryHookOptions<GetCollectionActivityWithOpaHeadersQuery, GetCollectionActivityWithOpaHeadersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectionActivityWithOpaHeadersQuery, GetCollectionActivityWithOpaHeadersQueryVariables>(GetCollectionActivityWithOpaHeadersDocument, options);
      }
export function useGetCollectionActivityWithOpaHeadersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectionActivityWithOpaHeadersQuery, GetCollectionActivityWithOpaHeadersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectionActivityWithOpaHeadersQuery, GetCollectionActivityWithOpaHeadersQueryVariables>(GetCollectionActivityWithOpaHeadersDocument, options);
        }
export type GetCollectionActivityWithOpaHeadersQueryHookResult = ReturnType<typeof useGetCollectionActivityWithOpaHeadersQuery>;
export type GetCollectionActivityWithOpaHeadersLazyQueryHookResult = ReturnType<typeof useGetCollectionActivityWithOpaHeadersLazyQuery>;
export type GetCollectionActivityWithOpaHeadersQueryResult = Apollo.QueryResult<GetCollectionActivityWithOpaHeadersQuery, GetCollectionActivityWithOpaHeadersQueryVariables>;
export const GetCollectionActivityIndoDetailListAndSummaryDocument = gql`
    query getCollectionActivityIndoDetailListAndSummary($saleId: String!) {
  getCollectionActivityIndoDetailListAndSummary(saleId: $saleId) {
    collectionActivitySummary {
      totalOutstanding
      purchaserDetail {
        email
        purchaserName
        unitNo
        phoneNo
        clusterName
      }
    }
    collectionActivityDetailList {
      id
      accountId
      saleId
      activityDate
      activityRemark
      completedDate
      activityStatus
      commonStatus
      attachment {
        allowDelete
        fileName
        id
        isPrivate
        mediaType
        resourceUrl
      }
    }
  }
}
    `;

/**
 * __useGetCollectionActivityIndoDetailListAndSummaryQuery__
 *
 * To run a query within a React component, call `useGetCollectionActivityIndoDetailListAndSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionActivityIndoDetailListAndSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionActivityIndoDetailListAndSummaryQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetCollectionActivityIndoDetailListAndSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetCollectionActivityIndoDetailListAndSummaryQuery, GetCollectionActivityIndoDetailListAndSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectionActivityIndoDetailListAndSummaryQuery, GetCollectionActivityIndoDetailListAndSummaryQueryVariables>(GetCollectionActivityIndoDetailListAndSummaryDocument, options);
      }
export function useGetCollectionActivityIndoDetailListAndSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectionActivityIndoDetailListAndSummaryQuery, GetCollectionActivityIndoDetailListAndSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectionActivityIndoDetailListAndSummaryQuery, GetCollectionActivityIndoDetailListAndSummaryQueryVariables>(GetCollectionActivityIndoDetailListAndSummaryDocument, options);
        }
export type GetCollectionActivityIndoDetailListAndSummaryQueryHookResult = ReturnType<typeof useGetCollectionActivityIndoDetailListAndSummaryQuery>;
export type GetCollectionActivityIndoDetailListAndSummaryLazyQueryHookResult = ReturnType<typeof useGetCollectionActivityIndoDetailListAndSummaryLazyQuery>;
export type GetCollectionActivityIndoDetailListAndSummaryQueryResult = Apollo.QueryResult<GetCollectionActivityIndoDetailListAndSummaryQuery, GetCollectionActivityIndoDetailListAndSummaryQueryVariables>;
export const GetActivityStatusTypeDocument = gql`
    query getActivityStatusType {
  getActivityStatusType
}
    `;

/**
 * __useGetActivityStatusTypeQuery__
 *
 * To run a query within a React component, call `useGetActivityStatusTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityStatusTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityStatusTypeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActivityStatusTypeQuery(baseOptions?: Apollo.QueryHookOptions<GetActivityStatusTypeQuery, GetActivityStatusTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActivityStatusTypeQuery, GetActivityStatusTypeQueryVariables>(GetActivityStatusTypeDocument, options);
      }
export function useGetActivityStatusTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActivityStatusTypeQuery, GetActivityStatusTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActivityStatusTypeQuery, GetActivityStatusTypeQueryVariables>(GetActivityStatusTypeDocument, options);
        }
export type GetActivityStatusTypeQueryHookResult = ReturnType<typeof useGetActivityStatusTypeQuery>;
export type GetActivityStatusTypeLazyQueryHookResult = ReturnType<typeof useGetActivityStatusTypeLazyQuery>;
export type GetActivityStatusTypeQueryResult = Apollo.QueryResult<GetActivityStatusTypeQuery, GetActivityStatusTypeQueryVariables>;
export const GetCollectionActivityIndoDetailByIdDocument = gql`
    query getCollectionActivityIndoDetailByID($projectId: String!, $saleId: String!, $caId: String!, $overdueId: String!) {
  getCollectionActivityIndoDetailByID(projectId: $projectId, saleId: $saleId, caId: $caId, overdueId: $overdueId) {
    caId
    actionDate
    reason
    followedUpName
    attachments {
      attachmentId
      fileName
      resourceUrl
      mediaType
    }
    OverduePurchaserAccountDetails {
      saleId
      unitId
      unitNo
      fullName
      email
      phoneNo
      totalAllDocumentAmount
      totalAllAllocatedAmount
      totalAllOutstanding
    }
  }
}
    `;

/**
 * __useGetCollectionActivityIndoDetailByIdQuery__
 *
 * To run a query within a React component, call `useGetCollectionActivityIndoDetailByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionActivityIndoDetailByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionActivityIndoDetailByIdQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      saleId: // value for 'saleId'
 *      caId: // value for 'caId'
 *      overdueId: // value for 'overdueId'
 *   },
 * });
 */
export function useGetCollectionActivityIndoDetailByIdQuery(baseOptions: Apollo.QueryHookOptions<GetCollectionActivityIndoDetailByIdQuery, GetCollectionActivityIndoDetailByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectionActivityIndoDetailByIdQuery, GetCollectionActivityIndoDetailByIdQueryVariables>(GetCollectionActivityIndoDetailByIdDocument, options);
      }
export function useGetCollectionActivityIndoDetailByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectionActivityIndoDetailByIdQuery, GetCollectionActivityIndoDetailByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectionActivityIndoDetailByIdQuery, GetCollectionActivityIndoDetailByIdQueryVariables>(GetCollectionActivityIndoDetailByIdDocument, options);
        }
export type GetCollectionActivityIndoDetailByIdQueryHookResult = ReturnType<typeof useGetCollectionActivityIndoDetailByIdQuery>;
export type GetCollectionActivityIndoDetailByIdLazyQueryHookResult = ReturnType<typeof useGetCollectionActivityIndoDetailByIdLazyQuery>;
export type GetCollectionActivityIndoDetailByIdQueryResult = Apollo.QueryResult<GetCollectionActivityIndoDetailByIdQuery, GetCollectionActivityIndoDetailByIdQueryVariables>;
export const UpdatePaCollectionActivityIndoDocument = gql`
    mutation updatePACollectionActivityIndo($input: UpdatePACollectionActivityInput!) {
  updatePACollectionActivityIndo(input: $input)
}
    `;
export type UpdatePaCollectionActivityIndoMutationFn = Apollo.MutationFunction<UpdatePaCollectionActivityIndoMutation, UpdatePaCollectionActivityIndoMutationVariables>;

/**
 * __useUpdatePaCollectionActivityIndoMutation__
 *
 * To run a mutation, you first call `useUpdatePaCollectionActivityIndoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaCollectionActivityIndoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaCollectionActivityIndoMutation, { data, loading, error }] = useUpdatePaCollectionActivityIndoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePaCollectionActivityIndoMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaCollectionActivityIndoMutation, UpdatePaCollectionActivityIndoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePaCollectionActivityIndoMutation, UpdatePaCollectionActivityIndoMutationVariables>(UpdatePaCollectionActivityIndoDocument, options);
      }
export type UpdatePaCollectionActivityIndoMutationHookResult = ReturnType<typeof useUpdatePaCollectionActivityIndoMutation>;
export type UpdatePaCollectionActivityIndoMutationResult = Apollo.MutationResult<UpdatePaCollectionActivityIndoMutation>;
export type UpdatePaCollectionActivityIndoMutationOptions = Apollo.BaseMutationOptions<UpdatePaCollectionActivityIndoMutation, UpdatePaCollectionActivityIndoMutationVariables>;
export const AddPaCollectionActivityIndoDocument = gql`
    mutation addPACollectionActivityIndo($input: AddOverduePurchaseCAInput!) {
  addPACollectionActivityIndo(input: $input)
}
    `;
export type AddPaCollectionActivityIndoMutationFn = Apollo.MutationFunction<AddPaCollectionActivityIndoMutation, AddPaCollectionActivityIndoMutationVariables>;

/**
 * __useAddPaCollectionActivityIndoMutation__
 *
 * To run a mutation, you first call `useAddPaCollectionActivityIndoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPaCollectionActivityIndoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPaCollectionActivityIndoMutation, { data, loading, error }] = useAddPaCollectionActivityIndoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPaCollectionActivityIndoMutation(baseOptions?: Apollo.MutationHookOptions<AddPaCollectionActivityIndoMutation, AddPaCollectionActivityIndoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPaCollectionActivityIndoMutation, AddPaCollectionActivityIndoMutationVariables>(AddPaCollectionActivityIndoDocument, options);
      }
export type AddPaCollectionActivityIndoMutationHookResult = ReturnType<typeof useAddPaCollectionActivityIndoMutation>;
export type AddPaCollectionActivityIndoMutationResult = Apollo.MutationResult<AddPaCollectionActivityIndoMutation>;
export type AddPaCollectionActivityIndoMutationOptions = Apollo.BaseMutationOptions<AddPaCollectionActivityIndoMutation, AddPaCollectionActivityIndoMutationVariables>;
export const EditPaCollectionActivityIndoDocument = gql`
    mutation editPACollectionActivityIndo($input: EditOverduePurchaseCAInput!) {
  editPACollectionActivityIndo(input: $input)
}
    `;
export type EditPaCollectionActivityIndoMutationFn = Apollo.MutationFunction<EditPaCollectionActivityIndoMutation, EditPaCollectionActivityIndoMutationVariables>;

/**
 * __useEditPaCollectionActivityIndoMutation__
 *
 * To run a mutation, you first call `useEditPaCollectionActivityIndoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPaCollectionActivityIndoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPaCollectionActivityIndoMutation, { data, loading, error }] = useEditPaCollectionActivityIndoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditPaCollectionActivityIndoMutation(baseOptions?: Apollo.MutationHookOptions<EditPaCollectionActivityIndoMutation, EditPaCollectionActivityIndoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditPaCollectionActivityIndoMutation, EditPaCollectionActivityIndoMutationVariables>(EditPaCollectionActivityIndoDocument, options);
      }
export type EditPaCollectionActivityIndoMutationHookResult = ReturnType<typeof useEditPaCollectionActivityIndoMutation>;
export type EditPaCollectionActivityIndoMutationResult = Apollo.MutationResult<EditPaCollectionActivityIndoMutation>;
export type EditPaCollectionActivityIndoMutationOptions = Apollo.BaseMutationOptions<EditPaCollectionActivityIndoMutation, EditPaCollectionActivityIndoMutationVariables>;
export const GetAllPaymentInterestExceptionDocument = gql`
    query getAllPaymentInterestException {
  getAllPaymentInterestException {
    saleId
    unitNo
    fullName
    isVip
    remark
  }
}
    `;

/**
 * __useGetAllPaymentInterestExceptionQuery__
 *
 * To run a query within a React component, call `useGetAllPaymentInterestExceptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPaymentInterestExceptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPaymentInterestExceptionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllPaymentInterestExceptionQuery(baseOptions?: Apollo.QueryHookOptions<GetAllPaymentInterestExceptionQuery, GetAllPaymentInterestExceptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllPaymentInterestExceptionQuery, GetAllPaymentInterestExceptionQueryVariables>(GetAllPaymentInterestExceptionDocument, options);
      }
export function useGetAllPaymentInterestExceptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllPaymentInterestExceptionQuery, GetAllPaymentInterestExceptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllPaymentInterestExceptionQuery, GetAllPaymentInterestExceptionQueryVariables>(GetAllPaymentInterestExceptionDocument, options);
        }
export type GetAllPaymentInterestExceptionQueryHookResult = ReturnType<typeof useGetAllPaymentInterestExceptionQuery>;
export type GetAllPaymentInterestExceptionLazyQueryHookResult = ReturnType<typeof useGetAllPaymentInterestExceptionLazyQuery>;
export type GetAllPaymentInterestExceptionQueryResult = Apollo.QueryResult<GetAllPaymentInterestExceptionQuery, GetAllPaymentInterestExceptionQueryVariables>;
export const GetAllPaymentInterestExceptionFormDocument = gql`
    query getAllPaymentInterestExceptionForm {
  getAllPaymentInterestExceptionForm {
    saleId
    unitNo
    fullName
    isVip
  }
}
    `;

/**
 * __useGetAllPaymentInterestExceptionFormQuery__
 *
 * To run a query within a React component, call `useGetAllPaymentInterestExceptionFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPaymentInterestExceptionFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPaymentInterestExceptionFormQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllPaymentInterestExceptionFormQuery(baseOptions?: Apollo.QueryHookOptions<GetAllPaymentInterestExceptionFormQuery, GetAllPaymentInterestExceptionFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllPaymentInterestExceptionFormQuery, GetAllPaymentInterestExceptionFormQueryVariables>(GetAllPaymentInterestExceptionFormDocument, options);
      }
export function useGetAllPaymentInterestExceptionFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllPaymentInterestExceptionFormQuery, GetAllPaymentInterestExceptionFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllPaymentInterestExceptionFormQuery, GetAllPaymentInterestExceptionFormQueryVariables>(GetAllPaymentInterestExceptionFormDocument, options);
        }
export type GetAllPaymentInterestExceptionFormQueryHookResult = ReturnType<typeof useGetAllPaymentInterestExceptionFormQuery>;
export type GetAllPaymentInterestExceptionFormLazyQueryHookResult = ReturnType<typeof useGetAllPaymentInterestExceptionFormLazyQuery>;
export type GetAllPaymentInterestExceptionFormQueryResult = Apollo.QueryResult<GetAllPaymentInterestExceptionFormQuery, GetAllPaymentInterestExceptionFormQueryVariables>;
export const AddPaymentInterestExceptionDocument = gql`
    mutation addPaymentInterestException($input: [addPaymentinterestExceptionInput!]!) {
  addPaymentInterestException(input: $input)
}
    `;
export type AddPaymentInterestExceptionMutationFn = Apollo.MutationFunction<AddPaymentInterestExceptionMutation, AddPaymentInterestExceptionMutationVariables>;

/**
 * __useAddPaymentInterestExceptionMutation__
 *
 * To run a mutation, you first call `useAddPaymentInterestExceptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPaymentInterestExceptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPaymentInterestExceptionMutation, { data, loading, error }] = useAddPaymentInterestExceptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPaymentInterestExceptionMutation(baseOptions?: Apollo.MutationHookOptions<AddPaymentInterestExceptionMutation, AddPaymentInterestExceptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPaymentInterestExceptionMutation, AddPaymentInterestExceptionMutationVariables>(AddPaymentInterestExceptionDocument, options);
      }
export type AddPaymentInterestExceptionMutationHookResult = ReturnType<typeof useAddPaymentInterestExceptionMutation>;
export type AddPaymentInterestExceptionMutationResult = Apollo.MutationResult<AddPaymentInterestExceptionMutation>;
export type AddPaymentInterestExceptionMutationOptions = Apollo.BaseMutationOptions<AddPaymentInterestExceptionMutation, AddPaymentInterestExceptionMutationVariables>;
export const EditPaymentInterestExceptionDocument = gql`
    mutation editPaymentInterestException($input: editPaymentinterestExceptionInput!) {
  editPaymentInterestException(input: $input)
}
    `;
export type EditPaymentInterestExceptionMutationFn = Apollo.MutationFunction<EditPaymentInterestExceptionMutation, EditPaymentInterestExceptionMutationVariables>;

/**
 * __useEditPaymentInterestExceptionMutation__
 *
 * To run a mutation, you first call `useEditPaymentInterestExceptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPaymentInterestExceptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPaymentInterestExceptionMutation, { data, loading, error }] = useEditPaymentInterestExceptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditPaymentInterestExceptionMutation(baseOptions?: Apollo.MutationHookOptions<EditPaymentInterestExceptionMutation, EditPaymentInterestExceptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditPaymentInterestExceptionMutation, EditPaymentInterestExceptionMutationVariables>(EditPaymentInterestExceptionDocument, options);
      }
export type EditPaymentInterestExceptionMutationHookResult = ReturnType<typeof useEditPaymentInterestExceptionMutation>;
export type EditPaymentInterestExceptionMutationResult = Apollo.MutationResult<EditPaymentInterestExceptionMutation>;
export type EditPaymentInterestExceptionMutationOptions = Apollo.BaseMutationOptions<EditPaymentInterestExceptionMutation, EditPaymentInterestExceptionMutationVariables>;
export const DeletePaymentInterestExceptionDocument = gql`
    mutation deletePaymentInterestException($input: deletePaymentinterestExceptionInput!) {
  deletePaymentInterestException(input: $input)
}
    `;
export type DeletePaymentInterestExceptionMutationFn = Apollo.MutationFunction<DeletePaymentInterestExceptionMutation, DeletePaymentInterestExceptionMutationVariables>;

/**
 * __useDeletePaymentInterestExceptionMutation__
 *
 * To run a mutation, you first call `useDeletePaymentInterestExceptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePaymentInterestExceptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePaymentInterestExceptionMutation, { data, loading, error }] = useDeletePaymentInterestExceptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePaymentInterestExceptionMutation(baseOptions?: Apollo.MutationHookOptions<DeletePaymentInterestExceptionMutation, DeletePaymentInterestExceptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePaymentInterestExceptionMutation, DeletePaymentInterestExceptionMutationVariables>(DeletePaymentInterestExceptionDocument, options);
      }
export type DeletePaymentInterestExceptionMutationHookResult = ReturnType<typeof useDeletePaymentInterestExceptionMutation>;
export type DeletePaymentInterestExceptionMutationResult = Apollo.MutationResult<DeletePaymentInterestExceptionMutation>;
export type DeletePaymentInterestExceptionMutationOptions = Apollo.BaseMutationOptions<DeletePaymentInterestExceptionMutation, DeletePaymentInterestExceptionMutationVariables>;
export const OverduePurchaserAccountListingDocument = gql`
    query overduePurchaserAccountListing($projectId: String!, $saleId: String) {
  overduePurchaserAccountListing(projectId: $projectId, saleId: $saleId) {
    assign {
      saleId
      unitId
      unitNo
      fullName
      totalDocumentAmount
      totalAllocatedAmount
      totalOutstanding
      dueDate
      billingType
      assignTo
      assignedDate
      generateDate
      createdTimestamp
      overduedPurchaserAccountId
      assignName
      activityDate
      activityRemark
    }
    notAssign {
      saleId
      unitId
      unitNo
      fullName
      totalDocumentAmount
      totalAllocatedAmount
      totalOutstanding
      dueDate
      billingType
      assignTo
      assignedDate
      generateDate
      createdTimestamp
      overduedPurchaserAccountId
      activityDate
      activityRemark
    }
  }
}
    `;

/**
 * __useOverduePurchaserAccountListingQuery__
 *
 * To run a query within a React component, call `useOverduePurchaserAccountListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useOverduePurchaserAccountListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOverduePurchaserAccountListingQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useOverduePurchaserAccountListingQuery(baseOptions: Apollo.QueryHookOptions<OverduePurchaserAccountListingQuery, OverduePurchaserAccountListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OverduePurchaserAccountListingQuery, OverduePurchaserAccountListingQueryVariables>(OverduePurchaserAccountListingDocument, options);
      }
export function useOverduePurchaserAccountListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OverduePurchaserAccountListingQuery, OverduePurchaserAccountListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OverduePurchaserAccountListingQuery, OverduePurchaserAccountListingQueryVariables>(OverduePurchaserAccountListingDocument, options);
        }
export type OverduePurchaserAccountListingQueryHookResult = ReturnType<typeof useOverduePurchaserAccountListingQuery>;
export type OverduePurchaserAccountListingLazyQueryHookResult = ReturnType<typeof useOverduePurchaserAccountListingLazyQuery>;
export type OverduePurchaserAccountListingQueryResult = Apollo.QueryResult<OverduePurchaserAccountListingQuery, OverduePurchaserAccountListingQueryVariables>;
export const OverduePurchaserAccountSummaryDocument = gql`
    query overduePurchaserAccountSummary($projectId: String!) {
  overduePurchaserAccountSummary(projectId: $projectId) {
    sumAllOutstandingAmount
    countAllDataNotAssign
  }
}
    `;

/**
 * __useOverduePurchaserAccountSummaryQuery__
 *
 * To run a query within a React component, call `useOverduePurchaserAccountSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useOverduePurchaserAccountSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOverduePurchaserAccountSummaryQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useOverduePurchaserAccountSummaryQuery(baseOptions: Apollo.QueryHookOptions<OverduePurchaserAccountSummaryQuery, OverduePurchaserAccountSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OverduePurchaserAccountSummaryQuery, OverduePurchaserAccountSummaryQueryVariables>(OverduePurchaserAccountSummaryDocument, options);
      }
export function useOverduePurchaserAccountSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OverduePurchaserAccountSummaryQuery, OverduePurchaserAccountSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OverduePurchaserAccountSummaryQuery, OverduePurchaserAccountSummaryQueryVariables>(OverduePurchaserAccountSummaryDocument, options);
        }
export type OverduePurchaserAccountSummaryQueryHookResult = ReturnType<typeof useOverduePurchaserAccountSummaryQuery>;
export type OverduePurchaserAccountSummaryLazyQueryHookResult = ReturnType<typeof useOverduePurchaserAccountSummaryLazyQuery>;
export type OverduePurchaserAccountSummaryQueryResult = Apollo.QueryResult<OverduePurchaserAccountSummaryQuery, OverduePurchaserAccountSummaryQueryVariables>;
export const GetOverdueUserListDocument = gql`
    query getOverdueUserList {
  getOverdueUserList {
    userId
    fullName
  }
}
    `;

/**
 * __useGetOverdueUserListQuery__
 *
 * To run a query within a React component, call `useGetOverdueUserListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOverdueUserListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOverdueUserListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOverdueUserListQuery(baseOptions?: Apollo.QueryHookOptions<GetOverdueUserListQuery, GetOverdueUserListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOverdueUserListQuery, GetOverdueUserListQueryVariables>(GetOverdueUserListDocument, options);
      }
export function useGetOverdueUserListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOverdueUserListQuery, GetOverdueUserListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOverdueUserListQuery, GetOverdueUserListQueryVariables>(GetOverdueUserListDocument, options);
        }
export type GetOverdueUserListQueryHookResult = ReturnType<typeof useGetOverdueUserListQuery>;
export type GetOverdueUserListLazyQueryHookResult = ReturnType<typeof useGetOverdueUserListLazyQuery>;
export type GetOverdueUserListQueryResult = Apollo.QueryResult<GetOverdueUserListQuery, GetOverdueUserListQueryVariables>;
export const OverduePurchaserAccountCaListingDocument = gql`
    query overduePurchaserAccountCAListing($projectId: String!, $saleId: String!, $overduePurchaserAccountId: String!) {
  overduePurchaserAccountCAListing(projectId: $projectId, saleId: $saleId, overduePurchaserAccountId: $overduePurchaserAccountId) {
    OverduePurchaserAccountDetails {
      saleId
      unitId
      unitNo
      fullName
      email
      phoneNo
      totalAllDocumentAmount
      totalAllAllocatedAmount
      totalAllOutstanding
      generateDate
      assignTo
      overduePurchaser {
        docId
        totalDocumentAmount
        totalAllocatedAmount
        totalOutstanding
        dueDate
        creditTerm
        generateDate
        billingType
      }
    }
    overduePurchaseCAListing {
      caId
      saleId
      activityDate
      activityRemark
      activityStatus
      countDoc
    }
  }
}
    `;

/**
 * __useOverduePurchaserAccountCaListingQuery__
 *
 * To run a query within a React component, call `useOverduePurchaserAccountCaListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useOverduePurchaserAccountCaListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOverduePurchaserAccountCaListingQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      saleId: // value for 'saleId'
 *      overduePurchaserAccountId: // value for 'overduePurchaserAccountId'
 *   },
 * });
 */
export function useOverduePurchaserAccountCaListingQuery(baseOptions: Apollo.QueryHookOptions<OverduePurchaserAccountCaListingQuery, OverduePurchaserAccountCaListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OverduePurchaserAccountCaListingQuery, OverduePurchaserAccountCaListingQueryVariables>(OverduePurchaserAccountCaListingDocument, options);
      }
export function useOverduePurchaserAccountCaListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OverduePurchaserAccountCaListingQuery, OverduePurchaserAccountCaListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OverduePurchaserAccountCaListingQuery, OverduePurchaserAccountCaListingQueryVariables>(OverduePurchaserAccountCaListingDocument, options);
        }
export type OverduePurchaserAccountCaListingQueryHookResult = ReturnType<typeof useOverduePurchaserAccountCaListingQuery>;
export type OverduePurchaserAccountCaListingLazyQueryHookResult = ReturnType<typeof useOverduePurchaserAccountCaListingLazyQuery>;
export type OverduePurchaserAccountCaListingQueryResult = Apollo.QueryResult<OverduePurchaserAccountCaListingQuery, OverduePurchaserAccountCaListingQueryVariables>;
export const GetOverduePurchaseAccountCaDetailDocument = gql`
    query getOverduePurchaseAccountCADetail($projectId: String!, $saleId: String!, $caId: String!, $overdueId: String!) {
  getOverduePurchaseAccountCADetail(projectId: $projectId, saleId: $saleId, caId: $caId, overdueId: $overdueId) {
    caId
    actionDate
    reason
    followedUpName
    attachments {
      attachmentId
      fileName
      resourceUrl
      mediaType
    }
    OverduePurchaserAccountDetails {
      saleId
      unitId
      unitNo
      fullName
      email
      phoneNo
      totalAllDocumentAmount
      totalAllAllocatedAmount
      totalAllOutstanding
    }
  }
}
    `;

/**
 * __useGetOverduePurchaseAccountCaDetailQuery__
 *
 * To run a query within a React component, call `useGetOverduePurchaseAccountCaDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOverduePurchaseAccountCaDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOverduePurchaseAccountCaDetailQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      saleId: // value for 'saleId'
 *      caId: // value for 'caId'
 *      overdueId: // value for 'overdueId'
 *   },
 * });
 */
export function useGetOverduePurchaseAccountCaDetailQuery(baseOptions: Apollo.QueryHookOptions<GetOverduePurchaseAccountCaDetailQuery, GetOverduePurchaseAccountCaDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOverduePurchaseAccountCaDetailQuery, GetOverduePurchaseAccountCaDetailQueryVariables>(GetOverduePurchaseAccountCaDetailDocument, options);
      }
export function useGetOverduePurchaseAccountCaDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOverduePurchaseAccountCaDetailQuery, GetOverduePurchaseAccountCaDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOverduePurchaseAccountCaDetailQuery, GetOverduePurchaseAccountCaDetailQueryVariables>(GetOverduePurchaseAccountCaDetailDocument, options);
        }
export type GetOverduePurchaseAccountCaDetailQueryHookResult = ReturnType<typeof useGetOverduePurchaseAccountCaDetailQuery>;
export type GetOverduePurchaseAccountCaDetailLazyQueryHookResult = ReturnType<typeof useGetOverduePurchaseAccountCaDetailLazyQuery>;
export type GetOverduePurchaseAccountCaDetailQueryResult = Apollo.QueryResult<GetOverduePurchaseAccountCaDetailQuery, GetOverduePurchaseAccountCaDetailQueryVariables>;
export const GetOverduePurchaseAccountHeaderDocument = gql`
    query getOverduePurchaseAccountHeader($projectId: String!, $saleId: String!, $overdueId: String!) {
  getOverduePurchaseAccountHeader(projectId: $projectId, saleId: $saleId, overdueId: $overdueId) {
    saleId
    unitId
    unitNo
    fullName
    email
    phoneNo
    totalAllDocumentAmount
    totalAllAllocatedAmount
    totalAllOutstanding
  }
}
    `;

/**
 * __useGetOverduePurchaseAccountHeaderQuery__
 *
 * To run a query within a React component, call `useGetOverduePurchaseAccountHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOverduePurchaseAccountHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOverduePurchaseAccountHeaderQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      saleId: // value for 'saleId'
 *      overdueId: // value for 'overdueId'
 *   },
 * });
 */
export function useGetOverduePurchaseAccountHeaderQuery(baseOptions: Apollo.QueryHookOptions<GetOverduePurchaseAccountHeaderQuery, GetOverduePurchaseAccountHeaderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOverduePurchaseAccountHeaderQuery, GetOverduePurchaseAccountHeaderQueryVariables>(GetOverduePurchaseAccountHeaderDocument, options);
      }
export function useGetOverduePurchaseAccountHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOverduePurchaseAccountHeaderQuery, GetOverduePurchaseAccountHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOverduePurchaseAccountHeaderQuery, GetOverduePurchaseAccountHeaderQueryVariables>(GetOverduePurchaseAccountHeaderDocument, options);
        }
export type GetOverduePurchaseAccountHeaderQueryHookResult = ReturnType<typeof useGetOverduePurchaseAccountHeaderQuery>;
export type GetOverduePurchaseAccountHeaderLazyQueryHookResult = ReturnType<typeof useGetOverduePurchaseAccountHeaderLazyQuery>;
export type GetOverduePurchaseAccountHeaderQueryResult = Apollo.QueryResult<GetOverduePurchaseAccountHeaderQuery, GetOverduePurchaseAccountHeaderQueryVariables>;
export const GetOverdueInstallmentDetailsDocument = gql`
    query getOverdueInstallmentDetails($projectId: String!, $saleId: String!, $interval: String!, $overdueId: String!) {
  getOverdueInstallmentDetails(projectId: $projectId, saleId: $saleId, interval: $interval, overdueId: $overdueId) {
    installment {
      docId
      totalDocumentAmount
      totalAllocatedAmount
      totalOutstanding
      dueDate
      description
      billingType
      itemName
    }
    debitNote {
      docId
      totalDocumentAmount
      totalAllocatedAmount
      totalOutstanding
      dueDate
      description
      billingType
      itemName
    }
    miscBilling {
      docId
      totalDocumentAmount
      totalAllocatedAmount
      totalOutstanding
      dueDate
      description
      billingType
      itemName
    }
    packagesInstallment {
      docId
      totalDocumentAmount
      totalAllocatedAmount
      totalOutstanding
      dueDate
      description
      billingType
      itemName
    }
    carparkInstallment {
      docId
      totalDocumentAmount
      totalAllocatedAmount
      totalOutstanding
      dueDate
      description
      billingType
      itemName
    }
    lateInterest {
      docId
      totalDocumentAmount
      totalAllocatedAmount
      totalOutstanding
      dueDate
      description
      billingType
      itemName
    }
  }
}
    `;

/**
 * __useGetOverdueInstallmentDetailsQuery__
 *
 * To run a query within a React component, call `useGetOverdueInstallmentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOverdueInstallmentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOverdueInstallmentDetailsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      saleId: // value for 'saleId'
 *      interval: // value for 'interval'
 *      overdueId: // value for 'overdueId'
 *   },
 * });
 */
export function useGetOverdueInstallmentDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetOverdueInstallmentDetailsQuery, GetOverdueInstallmentDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOverdueInstallmentDetailsQuery, GetOverdueInstallmentDetailsQueryVariables>(GetOverdueInstallmentDetailsDocument, options);
      }
export function useGetOverdueInstallmentDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOverdueInstallmentDetailsQuery, GetOverdueInstallmentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOverdueInstallmentDetailsQuery, GetOverdueInstallmentDetailsQueryVariables>(GetOverdueInstallmentDetailsDocument, options);
        }
export type GetOverdueInstallmentDetailsQueryHookResult = ReturnType<typeof useGetOverdueInstallmentDetailsQuery>;
export type GetOverdueInstallmentDetailsLazyQueryHookResult = ReturnType<typeof useGetOverdueInstallmentDetailsLazyQuery>;
export type GetOverdueInstallmentDetailsQueryResult = Apollo.QueryResult<GetOverdueInstallmentDetailsQuery, GetOverdueInstallmentDetailsQueryVariables>;
export const GetOverdueAgingDocument = gql`
    query getOverdueAging($projectId: String!) {
  getOverdueAging(projectId: $projectId) {
    agingId
    projectId
    companyId
    period1
    period2
    period3
    period4
    period5
    period6
  }
}
    `;

/**
 * __useGetOverdueAgingQuery__
 *
 * To run a query within a React component, call `useGetOverdueAgingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOverdueAgingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOverdueAgingQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetOverdueAgingQuery(baseOptions: Apollo.QueryHookOptions<GetOverdueAgingQuery, GetOverdueAgingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOverdueAgingQuery, GetOverdueAgingQueryVariables>(GetOverdueAgingDocument, options);
      }
export function useGetOverdueAgingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOverdueAgingQuery, GetOverdueAgingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOverdueAgingQuery, GetOverdueAgingQueryVariables>(GetOverdueAgingDocument, options);
        }
export type GetOverdueAgingQueryHookResult = ReturnType<typeof useGetOverdueAgingQuery>;
export type GetOverdueAgingLazyQueryHookResult = ReturnType<typeof useGetOverdueAgingLazyQuery>;
export type GetOverdueAgingQueryResult = Apollo.QueryResult<GetOverdueAgingQuery, GetOverdueAgingQueryVariables>;
export const AddOverduePurchaseCaDocument = gql`
    mutation addOverduePurchaseCA($input: AddOverduePurchaseCAInput!) {
  addOverduePurchaseCA(input: $input)
}
    `;
export type AddOverduePurchaseCaMutationFn = Apollo.MutationFunction<AddOverduePurchaseCaMutation, AddOverduePurchaseCaMutationVariables>;

/**
 * __useAddOverduePurchaseCaMutation__
 *
 * To run a mutation, you first call `useAddOverduePurchaseCaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOverduePurchaseCaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOverduePurchaseCaMutation, { data, loading, error }] = useAddOverduePurchaseCaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddOverduePurchaseCaMutation(baseOptions?: Apollo.MutationHookOptions<AddOverduePurchaseCaMutation, AddOverduePurchaseCaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddOverduePurchaseCaMutation, AddOverduePurchaseCaMutationVariables>(AddOverduePurchaseCaDocument, options);
      }
export type AddOverduePurchaseCaMutationHookResult = ReturnType<typeof useAddOverduePurchaseCaMutation>;
export type AddOverduePurchaseCaMutationResult = Apollo.MutationResult<AddOverduePurchaseCaMutation>;
export type AddOverduePurchaseCaMutationOptions = Apollo.BaseMutationOptions<AddOverduePurchaseCaMutation, AddOverduePurchaseCaMutationVariables>;
export const EditOverduePurchaseCaDocument = gql`
    mutation editOverduePurchaseCA($input: EditOverduePurchaseCAInput!) {
  editOverduePurchaseCA(input: $input)
}
    `;
export type EditOverduePurchaseCaMutationFn = Apollo.MutationFunction<EditOverduePurchaseCaMutation, EditOverduePurchaseCaMutationVariables>;

/**
 * __useEditOverduePurchaseCaMutation__
 *
 * To run a mutation, you first call `useEditOverduePurchaseCaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditOverduePurchaseCaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editOverduePurchaseCaMutation, { data, loading, error }] = useEditOverduePurchaseCaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditOverduePurchaseCaMutation(baseOptions?: Apollo.MutationHookOptions<EditOverduePurchaseCaMutation, EditOverduePurchaseCaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditOverduePurchaseCaMutation, EditOverduePurchaseCaMutationVariables>(EditOverduePurchaseCaDocument, options);
      }
export type EditOverduePurchaseCaMutationHookResult = ReturnType<typeof useEditOverduePurchaseCaMutation>;
export type EditOverduePurchaseCaMutationResult = Apollo.MutationResult<EditOverduePurchaseCaMutation>;
export type EditOverduePurchaseCaMutationOptions = Apollo.BaseMutationOptions<EditOverduePurchaseCaMutation, EditOverduePurchaseCaMutationVariables>;
export const AssignOverduedPaDocument = gql`
    mutation assignOverduedPA($input: [assignOverduedPAInput!]!) {
  assignOverduedPA(input: $input)
}
    `;
export type AssignOverduedPaMutationFn = Apollo.MutationFunction<AssignOverduedPaMutation, AssignOverduedPaMutationVariables>;

/**
 * __useAssignOverduedPaMutation__
 *
 * To run a mutation, you first call `useAssignOverduedPaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignOverduedPaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignOverduedPaMutation, { data, loading, error }] = useAssignOverduedPaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignOverduedPaMutation(baseOptions?: Apollo.MutationHookOptions<AssignOverduedPaMutation, AssignOverduedPaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignOverduedPaMutation, AssignOverduedPaMutationVariables>(AssignOverduedPaDocument, options);
      }
export type AssignOverduedPaMutationHookResult = ReturnType<typeof useAssignOverduedPaMutation>;
export type AssignOverduedPaMutationResult = Apollo.MutationResult<AssignOverduedPaMutation>;
export type AssignOverduedPaMutationOptions = Apollo.BaseMutationOptions<AssignOverduedPaMutation, AssignOverduedPaMutationVariables>;
export const UpdateStatusOverduePurchaseCaDocument = gql`
    mutation updateStatusOverduePurchaseCA($input: updateStatusOverduePurchaseCAInput!) {
  updateStatusOverduePurchaseCA(input: $input)
}
    `;
export type UpdateStatusOverduePurchaseCaMutationFn = Apollo.MutationFunction<UpdateStatusOverduePurchaseCaMutation, UpdateStatusOverduePurchaseCaMutationVariables>;

/**
 * __useUpdateStatusOverduePurchaseCaMutation__
 *
 * To run a mutation, you first call `useUpdateStatusOverduePurchaseCaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStatusOverduePurchaseCaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStatusOverduePurchaseCaMutation, { data, loading, error }] = useUpdateStatusOverduePurchaseCaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStatusOverduePurchaseCaMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStatusOverduePurchaseCaMutation, UpdateStatusOverduePurchaseCaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStatusOverduePurchaseCaMutation, UpdateStatusOverduePurchaseCaMutationVariables>(UpdateStatusOverduePurchaseCaDocument, options);
      }
export type UpdateStatusOverduePurchaseCaMutationHookResult = ReturnType<typeof useUpdateStatusOverduePurchaseCaMutation>;
export type UpdateStatusOverduePurchaseCaMutationResult = Apollo.MutationResult<UpdateStatusOverduePurchaseCaMutation>;
export type UpdateStatusOverduePurchaseCaMutationOptions = Apollo.BaseMutationOptions<UpdateStatusOverduePurchaseCaMutation, UpdateStatusOverduePurchaseCaMutationVariables>;
export const GenerateProgressBillingReminderDocument = gql`
    mutation generateProgressBillingReminder($reminderDate: DateTime!) {
  generateProgressBillingReminder(reminderDate: $reminderDate) {
    reminder1
    reminder2
    reminder3
    totalBalance
    reminderList {
      reminderId
      progressBillingId
      saleId
      isCompany
      companyName
      unitNo
      docNo
      reminderSeq
      balanceAmount
      buyerName
      share {
        sharedBy
        sharedDateTime
        sharedMethod
      }
    }
  }
}
    `;
export type GenerateProgressBillingReminderMutationFn = Apollo.MutationFunction<GenerateProgressBillingReminderMutation, GenerateProgressBillingReminderMutationVariables>;

/**
 * __useGenerateProgressBillingReminderMutation__
 *
 * To run a mutation, you first call `useGenerateProgressBillingReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateProgressBillingReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateProgressBillingReminderMutation, { data, loading, error }] = useGenerateProgressBillingReminderMutation({
 *   variables: {
 *      reminderDate: // value for 'reminderDate'
 *   },
 * });
 */
export function useGenerateProgressBillingReminderMutation(baseOptions?: Apollo.MutationHookOptions<GenerateProgressBillingReminderMutation, GenerateProgressBillingReminderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateProgressBillingReminderMutation, GenerateProgressBillingReminderMutationVariables>(GenerateProgressBillingReminderDocument, options);
      }
export type GenerateProgressBillingReminderMutationHookResult = ReturnType<typeof useGenerateProgressBillingReminderMutation>;
export type GenerateProgressBillingReminderMutationResult = Apollo.MutationResult<GenerateProgressBillingReminderMutation>;
export type GenerateProgressBillingReminderMutationOptions = Apollo.BaseMutationOptions<GenerateProgressBillingReminderMutation, GenerateProgressBillingReminderMutationVariables>;
export const GetAllDownpaymentReminderDocument = gql`
    query getAllDownpaymentReminder {
  getAllDownpaymentReminder {
    reminderDate
    generationBatch
    reminder1
    reminder2
    reminder3
    amount
    unitNo
  }
}
    `;

/**
 * __useGetAllDownpaymentReminderQuery__
 *
 * To run a query within a React component, call `useGetAllDownpaymentReminderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllDownpaymentReminderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllDownpaymentReminderQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllDownpaymentReminderQuery(baseOptions?: Apollo.QueryHookOptions<GetAllDownpaymentReminderQuery, GetAllDownpaymentReminderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllDownpaymentReminderQuery, GetAllDownpaymentReminderQueryVariables>(GetAllDownpaymentReminderDocument, options);
      }
export function useGetAllDownpaymentReminderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllDownpaymentReminderQuery, GetAllDownpaymentReminderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllDownpaymentReminderQuery, GetAllDownpaymentReminderQueryVariables>(GetAllDownpaymentReminderDocument, options);
        }
export type GetAllDownpaymentReminderQueryHookResult = ReturnType<typeof useGetAllDownpaymentReminderQuery>;
export type GetAllDownpaymentReminderLazyQueryHookResult = ReturnType<typeof useGetAllDownpaymentReminderLazyQuery>;
export type GetAllDownpaymentReminderQueryResult = Apollo.QueryResult<GetAllDownpaymentReminderQuery, GetAllDownpaymentReminderQueryVariables>;
export const GetDownpaymentReminderByIdDocument = gql`
    query getDownpaymentReminderById($reminderDate: DateTime!, $generationBatch: String!) {
  getDownpaymentReminderById(reminderDate: $reminderDate, generationBatch: $generationBatch) {
    reminder1
    reminder2
    reminder3
    totalBalance
    reminderList {
      reminderId
      progressBillingId
      saleId
      isCompany
      companyName
      unitNo
      docNo
      reminderSeq
      balanceAmount
      buyerName
      share {
        sharedBy
        sharedDateTime
        sharedMethod
      }
    }
  }
}
    `;

/**
 * __useGetDownpaymentReminderByIdQuery__
 *
 * To run a query within a React component, call `useGetDownpaymentReminderByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDownpaymentReminderByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDownpaymentReminderByIdQuery({
 *   variables: {
 *      reminderDate: // value for 'reminderDate'
 *      generationBatch: // value for 'generationBatch'
 *   },
 * });
 */
export function useGetDownpaymentReminderByIdQuery(baseOptions: Apollo.QueryHookOptions<GetDownpaymentReminderByIdQuery, GetDownpaymentReminderByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDownpaymentReminderByIdQuery, GetDownpaymentReminderByIdQueryVariables>(GetDownpaymentReminderByIdDocument, options);
      }
export function useGetDownpaymentReminderByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDownpaymentReminderByIdQuery, GetDownpaymentReminderByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDownpaymentReminderByIdQuery, GetDownpaymentReminderByIdQueryVariables>(GetDownpaymentReminderByIdDocument, options);
        }
export type GetDownpaymentReminderByIdQueryHookResult = ReturnType<typeof useGetDownpaymentReminderByIdQuery>;
export type GetDownpaymentReminderByIdLazyQueryHookResult = ReturnType<typeof useGetDownpaymentReminderByIdLazyQuery>;
export type GetDownpaymentReminderByIdQueryResult = Apollo.QueryResult<GetDownpaymentReminderByIdQuery, GetDownpaymentReminderByIdQueryVariables>;
export const ShareDownpaymentReminderDocument = gql`
    mutation shareDownpaymentReminder($input: shareDownpaymentReminderInput!) {
  shareDownpaymentReminder(input: $input) {
    downloadFile
    isProject
    letterTemplateList {
      letterTemplateId
      letterTemplateName
    }
    attachment {
      base64
      fileName
    }
  }
}
    `;
export type ShareDownpaymentReminderMutationFn = Apollo.MutationFunction<ShareDownpaymentReminderMutation, ShareDownpaymentReminderMutationVariables>;

/**
 * __useShareDownpaymentReminderMutation__
 *
 * To run a mutation, you first call `useShareDownpaymentReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareDownpaymentReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareDownpaymentReminderMutation, { data, loading, error }] = useShareDownpaymentReminderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useShareDownpaymentReminderMutation(baseOptions?: Apollo.MutationHookOptions<ShareDownpaymentReminderMutation, ShareDownpaymentReminderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShareDownpaymentReminderMutation, ShareDownpaymentReminderMutationVariables>(ShareDownpaymentReminderDocument, options);
      }
export type ShareDownpaymentReminderMutationHookResult = ReturnType<typeof useShareDownpaymentReminderMutation>;
export type ShareDownpaymentReminderMutationResult = Apollo.MutationResult<ShareDownpaymentReminderMutation>;
export type ShareDownpaymentReminderMutationOptions = Apollo.BaseMutationOptions<ShareDownpaymentReminderMutation, ShareDownpaymentReminderMutationVariables>;
export const ShareDownpaymentReminderByTemplateIdDocument = gql`
    mutation shareDownpaymentReminderByTemplateId($input: shareDownpaymentReminderByIdInput!) {
  shareDownpaymentReminderByTemplateId(input: $input) {
    base64
    fileName
  }
}
    `;
export type ShareDownpaymentReminderByTemplateIdMutationFn = Apollo.MutationFunction<ShareDownpaymentReminderByTemplateIdMutation, ShareDownpaymentReminderByTemplateIdMutationVariables>;

/**
 * __useShareDownpaymentReminderByTemplateIdMutation__
 *
 * To run a mutation, you first call `useShareDownpaymentReminderByTemplateIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareDownpaymentReminderByTemplateIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareDownpaymentReminderByTemplateIdMutation, { data, loading, error }] = useShareDownpaymentReminderByTemplateIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useShareDownpaymentReminderByTemplateIdMutation(baseOptions?: Apollo.MutationHookOptions<ShareDownpaymentReminderByTemplateIdMutation, ShareDownpaymentReminderByTemplateIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShareDownpaymentReminderByTemplateIdMutation, ShareDownpaymentReminderByTemplateIdMutationVariables>(ShareDownpaymentReminderByTemplateIdDocument, options);
      }
export type ShareDownpaymentReminderByTemplateIdMutationHookResult = ReturnType<typeof useShareDownpaymentReminderByTemplateIdMutation>;
export type ShareDownpaymentReminderByTemplateIdMutationResult = Apollo.MutationResult<ShareDownpaymentReminderByTemplateIdMutation>;
export type ShareDownpaymentReminderByTemplateIdMutationOptions = Apollo.BaseMutationOptions<ShareDownpaymentReminderByTemplateIdMutation, ShareDownpaymentReminderByTemplateIdMutationVariables>;
export const GetFinancierListDocument = gql`
    query getFinancierList {
  getFinancierList {
    id
    name
    financierLastUpdate
    financierCode
    financierId
    officeTel
    logoUrl
    address {
      address
      city
      state
      country
      postCode
    }
    commonStatus
    projectLoanNumberCount
    loanNumberCount
    financierTotalLoanAmount
    isExistInTransactionData
  }
}
    `;

/**
 * __useGetFinancierListQuery__
 *
 * To run a query within a React component, call `useGetFinancierListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinancierListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinancierListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFinancierListQuery(baseOptions?: Apollo.QueryHookOptions<GetFinancierListQuery, GetFinancierListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFinancierListQuery, GetFinancierListQueryVariables>(GetFinancierListDocument, options);
      }
export function useGetFinancierListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFinancierListQuery, GetFinancierListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFinancierListQuery, GetFinancierListQueryVariables>(GetFinancierListDocument, options);
        }
export type GetFinancierListQueryHookResult = ReturnType<typeof useGetFinancierListQuery>;
export type GetFinancierListLazyQueryHookResult = ReturnType<typeof useGetFinancierListLazyQuery>;
export type GetFinancierListQueryResult = Apollo.QueryResult<GetFinancierListQuery, GetFinancierListQueryVariables>;
export const GetActiveFinancierListDocument = gql`
    query getActiveFinancierList {
  activeFinancierList {
    id
    name
    financierLastUpdate
    financierCode
    financierId
    officeTel
    logoUrl
    address {
      address
      city
      state
      country
      postCode
    }
    commonStatus
    assignedProjectCount
  }
}
    `;

/**
 * __useGetActiveFinancierListQuery__
 *
 * To run a query within a React component, call `useGetActiveFinancierListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveFinancierListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveFinancierListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActiveFinancierListQuery(baseOptions?: Apollo.QueryHookOptions<GetActiveFinancierListQuery, GetActiveFinancierListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveFinancierListQuery, GetActiveFinancierListQueryVariables>(GetActiveFinancierListDocument, options);
      }
export function useGetActiveFinancierListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveFinancierListQuery, GetActiveFinancierListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveFinancierListQuery, GetActiveFinancierListQueryVariables>(GetActiveFinancierListDocument, options);
        }
export type GetActiveFinancierListQueryHookResult = ReturnType<typeof useGetActiveFinancierListQuery>;
export type GetActiveFinancierListLazyQueryHookResult = ReturnType<typeof useGetActiveFinancierListLazyQuery>;
export type GetActiveFinancierListQueryResult = Apollo.QueryResult<GetActiveFinancierListQuery, GetActiveFinancierListQueryVariables>;
export const GetFinancierDetailListingDocument = gql`
    query getFinancierDetailListing($financierId: String!) {
  getFinancierDetailListing(financierId: $financierId) {
    projectName
    projectSaleCount
    projectTotalLoanAmount
    projectTotalPendingAmount
  }
}
    `;

/**
 * __useGetFinancierDetailListingQuery__
 *
 * To run a query within a React component, call `useGetFinancierDetailListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinancierDetailListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinancierDetailListingQuery({
 *   variables: {
 *      financierId: // value for 'financierId'
 *   },
 * });
 */
export function useGetFinancierDetailListingQuery(baseOptions: Apollo.QueryHookOptions<GetFinancierDetailListingQuery, GetFinancierDetailListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFinancierDetailListingQuery, GetFinancierDetailListingQueryVariables>(GetFinancierDetailListingDocument, options);
      }
export function useGetFinancierDetailListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFinancierDetailListingQuery, GetFinancierDetailListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFinancierDetailListingQuery, GetFinancierDetailListingQueryVariables>(GetFinancierDetailListingDocument, options);
        }
export type GetFinancierDetailListingQueryHookResult = ReturnType<typeof useGetFinancierDetailListingQuery>;
export type GetFinancierDetailListingLazyQueryHookResult = ReturnType<typeof useGetFinancierDetailListingLazyQuery>;
export type GetFinancierDetailListingQueryResult = Apollo.QueryResult<GetFinancierDetailListingQuery, GetFinancierDetailListingQueryVariables>;
export const GetFinancierDetailDocument = gql`
    query getFinancierDetail($financierId: String!) {
  getFinancierDetail(financier_id: $financierId) {
    id
    name
    bankId
    bank {
      id
      code
      commonStatus
      bankProfile {
        name
      }
    }
    officeTel
    logoUrl
    financierId
    financierCode
    projectLoanNumberCount
    loanNumberCount
    financierTotalLoanAmount
    address {
      address
      city
      state
      country
      postCode
    }
    financierContact {
      id
      name
      phoneNo
      email
    }
    disbursementFinancierId
  }
}
    `;

/**
 * __useGetFinancierDetailQuery__
 *
 * To run a query within a React component, call `useGetFinancierDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinancierDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinancierDetailQuery({
 *   variables: {
 *      financierId: // value for 'financierId'
 *   },
 * });
 */
export function useGetFinancierDetailQuery(baseOptions: Apollo.QueryHookOptions<GetFinancierDetailQuery, GetFinancierDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFinancierDetailQuery, GetFinancierDetailQueryVariables>(GetFinancierDetailDocument, options);
      }
export function useGetFinancierDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFinancierDetailQuery, GetFinancierDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFinancierDetailQuery, GetFinancierDetailQueryVariables>(GetFinancierDetailDocument, options);
        }
export type GetFinancierDetailQueryHookResult = ReturnType<typeof useGetFinancierDetailQuery>;
export type GetFinancierDetailLazyQueryHookResult = ReturnType<typeof useGetFinancierDetailLazyQuery>;
export type GetFinancierDetailQueryResult = Apollo.QueryResult<GetFinancierDetailQuery, GetFinancierDetailQueryVariables>;
export const CreateFinancierDocument = gql`
    mutation createFinancier($input: FinancierInput!) {
  createFinancier(input: $input)
}
    `;
export type CreateFinancierMutationFn = Apollo.MutationFunction<CreateFinancierMutation, CreateFinancierMutationVariables>;

/**
 * __useCreateFinancierMutation__
 *
 * To run a mutation, you first call `useCreateFinancierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFinancierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFinancierMutation, { data, loading, error }] = useCreateFinancierMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFinancierMutation(baseOptions?: Apollo.MutationHookOptions<CreateFinancierMutation, CreateFinancierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFinancierMutation, CreateFinancierMutationVariables>(CreateFinancierDocument, options);
      }
export type CreateFinancierMutationHookResult = ReturnType<typeof useCreateFinancierMutation>;
export type CreateFinancierMutationResult = Apollo.MutationResult<CreateFinancierMutation>;
export type CreateFinancierMutationOptions = Apollo.BaseMutationOptions<CreateFinancierMutation, CreateFinancierMutationVariables>;
export const AddFinancierContactDocument = gql`
    mutation addFinancierContact($financierId: String!, $input: FinancierContact!) {
  addFinancierContact(financier_id: $financierId, input: $input)
}
    `;
export type AddFinancierContactMutationFn = Apollo.MutationFunction<AddFinancierContactMutation, AddFinancierContactMutationVariables>;

/**
 * __useAddFinancierContactMutation__
 *
 * To run a mutation, you first call `useAddFinancierContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFinancierContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFinancierContactMutation, { data, loading, error }] = useAddFinancierContactMutation({
 *   variables: {
 *      financierId: // value for 'financierId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddFinancierContactMutation(baseOptions?: Apollo.MutationHookOptions<AddFinancierContactMutation, AddFinancierContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddFinancierContactMutation, AddFinancierContactMutationVariables>(AddFinancierContactDocument, options);
      }
export type AddFinancierContactMutationHookResult = ReturnType<typeof useAddFinancierContactMutation>;
export type AddFinancierContactMutationResult = Apollo.MutationResult<AddFinancierContactMutation>;
export type AddFinancierContactMutationOptions = Apollo.BaseMutationOptions<AddFinancierContactMutation, AddFinancierContactMutationVariables>;
export const SuspendEndFinancierDocument = gql`
    mutation suspendEndFinancier($financierId: String!) {
  suspendEndFinancier(financierId: $financierId)
}
    `;
export type SuspendEndFinancierMutationFn = Apollo.MutationFunction<SuspendEndFinancierMutation, SuspendEndFinancierMutationVariables>;

/**
 * __useSuspendEndFinancierMutation__
 *
 * To run a mutation, you first call `useSuspendEndFinancierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuspendEndFinancierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [suspendEndFinancierMutation, { data, loading, error }] = useSuspendEndFinancierMutation({
 *   variables: {
 *      financierId: // value for 'financierId'
 *   },
 * });
 */
export function useSuspendEndFinancierMutation(baseOptions?: Apollo.MutationHookOptions<SuspendEndFinancierMutation, SuspendEndFinancierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuspendEndFinancierMutation, SuspendEndFinancierMutationVariables>(SuspendEndFinancierDocument, options);
      }
export type SuspendEndFinancierMutationHookResult = ReturnType<typeof useSuspendEndFinancierMutation>;
export type SuspendEndFinancierMutationResult = Apollo.MutationResult<SuspendEndFinancierMutation>;
export type SuspendEndFinancierMutationOptions = Apollo.BaseMutationOptions<SuspendEndFinancierMutation, SuspendEndFinancierMutationVariables>;
export const EditFinancierDocument = gql`
    mutation editFinancier($input: FinancierInput!) {
  editFinancier(input: $input)
}
    `;
export type EditFinancierMutationFn = Apollo.MutationFunction<EditFinancierMutation, EditFinancierMutationVariables>;

/**
 * __useEditFinancierMutation__
 *
 * To run a mutation, you first call `useEditFinancierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditFinancierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editFinancierMutation, { data, loading, error }] = useEditFinancierMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditFinancierMutation(baseOptions?: Apollo.MutationHookOptions<EditFinancierMutation, EditFinancierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditFinancierMutation, EditFinancierMutationVariables>(EditFinancierDocument, options);
      }
export type EditFinancierMutationHookResult = ReturnType<typeof useEditFinancierMutation>;
export type EditFinancierMutationResult = Apollo.MutationResult<EditFinancierMutation>;
export type EditFinancierMutationOptions = Apollo.BaseMutationOptions<EditFinancierMutation, EditFinancierMutationVariables>;
export const DeleteFinancierDocument = gql`
    mutation deleteFinancier($financierId: String!) {
  deleteFinancier(financier_id: $financierId)
}
    `;
export type DeleteFinancierMutationFn = Apollo.MutationFunction<DeleteFinancierMutation, DeleteFinancierMutationVariables>;

/**
 * __useDeleteFinancierMutation__
 *
 * To run a mutation, you first call `useDeleteFinancierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFinancierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFinancierMutation, { data, loading, error }] = useDeleteFinancierMutation({
 *   variables: {
 *      financierId: // value for 'financierId'
 *   },
 * });
 */
export function useDeleteFinancierMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFinancierMutation, DeleteFinancierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFinancierMutation, DeleteFinancierMutationVariables>(DeleteFinancierDocument, options);
      }
export type DeleteFinancierMutationHookResult = ReturnType<typeof useDeleteFinancierMutation>;
export type DeleteFinancierMutationResult = Apollo.MutationResult<DeleteFinancierMutation>;
export type DeleteFinancierMutationOptions = Apollo.BaseMutationOptions<DeleteFinancierMutation, DeleteFinancierMutationVariables>;
export const GetMortgagePlansListDocument = gql`
    query getMortgagePlansList($financier_id: String!) {
  getMortgagePlansList(financier_id: $financier_id) {
    id
    name
    payments {
      id
      name
      percentage
      paymentEvent
      eventItem
      eventStatutoryDocId
      expectedCount
      expectedFreq
      expectedFrom
      endfinancierMortgagePlanId
      retentions {
        id
        name
        retentionBy
        retentionValue
        retentionEvent
        eventItem
        eventStatutoryDocId
        expectedCount
        expectedFreq
        expectedFrom
        endfinMortgagePaymentId
      }
    }
  }
}
    `;

/**
 * __useGetMortgagePlansListQuery__
 *
 * To run a query within a React component, call `useGetMortgagePlansListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMortgagePlansListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMortgagePlansListQuery({
 *   variables: {
 *      financier_id: // value for 'financier_id'
 *   },
 * });
 */
export function useGetMortgagePlansListQuery(baseOptions: Apollo.QueryHookOptions<GetMortgagePlansListQuery, GetMortgagePlansListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMortgagePlansListQuery, GetMortgagePlansListQueryVariables>(GetMortgagePlansListDocument, options);
      }
export function useGetMortgagePlansListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMortgagePlansListQuery, GetMortgagePlansListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMortgagePlansListQuery, GetMortgagePlansListQueryVariables>(GetMortgagePlansListDocument, options);
        }
export type GetMortgagePlansListQueryHookResult = ReturnType<typeof useGetMortgagePlansListQuery>;
export type GetMortgagePlansListLazyQueryHookResult = ReturnType<typeof useGetMortgagePlansListLazyQuery>;
export type GetMortgagePlansListQueryResult = Apollo.QueryResult<GetMortgagePlansListQuery, GetMortgagePlansListQueryVariables>;
export const GetPaymentFormMasterDataDocument = gql`
    query getPaymentFormMasterData {
  getPaymentFormMasterData
}
    `;

/**
 * __useGetPaymentFormMasterDataQuery__
 *
 * To run a query within a React component, call `useGetPaymentFormMasterDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentFormMasterDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentFormMasterDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPaymentFormMasterDataQuery(baseOptions?: Apollo.QueryHookOptions<GetPaymentFormMasterDataQuery, GetPaymentFormMasterDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentFormMasterDataQuery, GetPaymentFormMasterDataQueryVariables>(GetPaymentFormMasterDataDocument, options);
      }
export function useGetPaymentFormMasterDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentFormMasterDataQuery, GetPaymentFormMasterDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentFormMasterDataQuery, GetPaymentFormMasterDataQueryVariables>(GetPaymentFormMasterDataDocument, options);
        }
export type GetPaymentFormMasterDataQueryHookResult = ReturnType<typeof useGetPaymentFormMasterDataQuery>;
export type GetPaymentFormMasterDataLazyQueryHookResult = ReturnType<typeof useGetPaymentFormMasterDataLazyQuery>;
export type GetPaymentFormMasterDataQueryResult = Apollo.QueryResult<GetPaymentFormMasterDataQuery, GetPaymentFormMasterDataQueryVariables>;
export const GetRetentionFormMasterDataDocument = gql`
    query getRetentionFormMasterData {
  getRetentionFormMasterData
}
    `;

/**
 * __useGetRetentionFormMasterDataQuery__
 *
 * To run a query within a React component, call `useGetRetentionFormMasterDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRetentionFormMasterDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRetentionFormMasterDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRetentionFormMasterDataQuery(baseOptions?: Apollo.QueryHookOptions<GetRetentionFormMasterDataQuery, GetRetentionFormMasterDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRetentionFormMasterDataQuery, GetRetentionFormMasterDataQueryVariables>(GetRetentionFormMasterDataDocument, options);
      }
export function useGetRetentionFormMasterDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRetentionFormMasterDataQuery, GetRetentionFormMasterDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRetentionFormMasterDataQuery, GetRetentionFormMasterDataQueryVariables>(GetRetentionFormMasterDataDocument, options);
        }
export type GetRetentionFormMasterDataQueryHookResult = ReturnType<typeof useGetRetentionFormMasterDataQuery>;
export type GetRetentionFormMasterDataLazyQueryHookResult = ReturnType<typeof useGetRetentionFormMasterDataLazyQuery>;
export type GetRetentionFormMasterDataQueryResult = Apollo.QueryResult<GetRetentionFormMasterDataQuery, GetRetentionFormMasterDataQueryVariables>;
export const CreateMortgagePlanDocument = gql`
    mutation createMortgagePlan($input: MortgagePlanInput!) {
  createMortgagePlan(input: $input)
}
    `;
export type CreateMortgagePlanMutationFn = Apollo.MutationFunction<CreateMortgagePlanMutation, CreateMortgagePlanMutationVariables>;

/**
 * __useCreateMortgagePlanMutation__
 *
 * To run a mutation, you first call `useCreateMortgagePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMortgagePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMortgagePlanMutation, { data, loading, error }] = useCreateMortgagePlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMortgagePlanMutation(baseOptions?: Apollo.MutationHookOptions<CreateMortgagePlanMutation, CreateMortgagePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMortgagePlanMutation, CreateMortgagePlanMutationVariables>(CreateMortgagePlanDocument, options);
      }
export type CreateMortgagePlanMutationHookResult = ReturnType<typeof useCreateMortgagePlanMutation>;
export type CreateMortgagePlanMutationResult = Apollo.MutationResult<CreateMortgagePlanMutation>;
export type CreateMortgagePlanMutationOptions = Apollo.BaseMutationOptions<CreateMortgagePlanMutation, CreateMortgagePlanMutationVariables>;
export const IsMortgagePlanExistDocument = gql`
    query isMortgagePlanExist($input: MortgagePlanValidationInput!) {
  isMortgagePlanExist(input: $input)
}
    `;

/**
 * __useIsMortgagePlanExistQuery__
 *
 * To run a query within a React component, call `useIsMortgagePlanExistQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsMortgagePlanExistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsMortgagePlanExistQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIsMortgagePlanExistQuery(baseOptions: Apollo.QueryHookOptions<IsMortgagePlanExistQuery, IsMortgagePlanExistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsMortgagePlanExistQuery, IsMortgagePlanExistQueryVariables>(IsMortgagePlanExistDocument, options);
      }
export function useIsMortgagePlanExistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsMortgagePlanExistQuery, IsMortgagePlanExistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsMortgagePlanExistQuery, IsMortgagePlanExistQueryVariables>(IsMortgagePlanExistDocument, options);
        }
export type IsMortgagePlanExistQueryHookResult = ReturnType<typeof useIsMortgagePlanExistQuery>;
export type IsMortgagePlanExistLazyQueryHookResult = ReturnType<typeof useIsMortgagePlanExistLazyQuery>;
export type IsMortgagePlanExistQueryResult = Apollo.QueryResult<IsMortgagePlanExistQuery, IsMortgagePlanExistQueryVariables>;
export const EditMortgagePlanDocument = gql`
    mutation editMortgagePlan($input: MortgagePlanInput!) {
  editMortgagePlan(input: $input)
}
    `;
export type EditMortgagePlanMutationFn = Apollo.MutationFunction<EditMortgagePlanMutation, EditMortgagePlanMutationVariables>;

/**
 * __useEditMortgagePlanMutation__
 *
 * To run a mutation, you first call `useEditMortgagePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditMortgagePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editMortgagePlanMutation, { data, loading, error }] = useEditMortgagePlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditMortgagePlanMutation(baseOptions?: Apollo.MutationHookOptions<EditMortgagePlanMutation, EditMortgagePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditMortgagePlanMutation, EditMortgagePlanMutationVariables>(EditMortgagePlanDocument, options);
      }
export type EditMortgagePlanMutationHookResult = ReturnType<typeof useEditMortgagePlanMutation>;
export type EditMortgagePlanMutationResult = Apollo.MutationResult<EditMortgagePlanMutation>;
export type EditMortgagePlanMutationOptions = Apollo.BaseMutationOptions<EditMortgagePlanMutation, EditMortgagePlanMutationVariables>;
export const DeleteMortgagePlanDocument = gql`
    mutation deleteMortgagePlan($input: String!) {
  deleteMortgagePlan(input: $input)
}
    `;
export type DeleteMortgagePlanMutationFn = Apollo.MutationFunction<DeleteMortgagePlanMutation, DeleteMortgagePlanMutationVariables>;

/**
 * __useDeleteMortgagePlanMutation__
 *
 * To run a mutation, you first call `useDeleteMortgagePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMortgagePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMortgagePlanMutation, { data, loading, error }] = useDeleteMortgagePlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteMortgagePlanMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMortgagePlanMutation, DeleteMortgagePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMortgagePlanMutation, DeleteMortgagePlanMutationVariables>(DeleteMortgagePlanDocument, options);
      }
export type DeleteMortgagePlanMutationHookResult = ReturnType<typeof useDeleteMortgagePlanMutation>;
export type DeleteMortgagePlanMutationResult = Apollo.MutationResult<DeleteMortgagePlanMutation>;
export type DeleteMortgagePlanMutationOptions = Apollo.BaseMutationOptions<DeleteMortgagePlanMutation, DeleteMortgagePlanMutationVariables>;
export const CreateMortgagePaymentDocument = gql`
    mutation createMortgagePayment($input: MortgagePaymentInput!) {
  createMortgagePayment(input: $input)
}
    `;
export type CreateMortgagePaymentMutationFn = Apollo.MutationFunction<CreateMortgagePaymentMutation, CreateMortgagePaymentMutationVariables>;

/**
 * __useCreateMortgagePaymentMutation__
 *
 * To run a mutation, you first call `useCreateMortgagePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMortgagePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMortgagePaymentMutation, { data, loading, error }] = useCreateMortgagePaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMortgagePaymentMutation(baseOptions?: Apollo.MutationHookOptions<CreateMortgagePaymentMutation, CreateMortgagePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMortgagePaymentMutation, CreateMortgagePaymentMutationVariables>(CreateMortgagePaymentDocument, options);
      }
export type CreateMortgagePaymentMutationHookResult = ReturnType<typeof useCreateMortgagePaymentMutation>;
export type CreateMortgagePaymentMutationResult = Apollo.MutationResult<CreateMortgagePaymentMutation>;
export type CreateMortgagePaymentMutationOptions = Apollo.BaseMutationOptions<CreateMortgagePaymentMutation, CreateMortgagePaymentMutationVariables>;
export const IsMortgagePaymentExistDocument = gql`
    query isMortgagePaymentExist($input: MortgagePaymentValidationInput!) {
  isMortgagePaymentExist(input: $input)
}
    `;

/**
 * __useIsMortgagePaymentExistQuery__
 *
 * To run a query within a React component, call `useIsMortgagePaymentExistQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsMortgagePaymentExistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsMortgagePaymentExistQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIsMortgagePaymentExistQuery(baseOptions: Apollo.QueryHookOptions<IsMortgagePaymentExistQuery, IsMortgagePaymentExistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsMortgagePaymentExistQuery, IsMortgagePaymentExistQueryVariables>(IsMortgagePaymentExistDocument, options);
      }
export function useIsMortgagePaymentExistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsMortgagePaymentExistQuery, IsMortgagePaymentExistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsMortgagePaymentExistQuery, IsMortgagePaymentExistQueryVariables>(IsMortgagePaymentExistDocument, options);
        }
export type IsMortgagePaymentExistQueryHookResult = ReturnType<typeof useIsMortgagePaymentExistQuery>;
export type IsMortgagePaymentExistLazyQueryHookResult = ReturnType<typeof useIsMortgagePaymentExistLazyQuery>;
export type IsMortgagePaymentExistQueryResult = Apollo.QueryResult<IsMortgagePaymentExistQuery, IsMortgagePaymentExistQueryVariables>;
export const EditMortgagePaymentDocument = gql`
    mutation editMortgagePayment($input: MortgagePaymentInput!) {
  editMortgagePayment(input: $input)
}
    `;
export type EditMortgagePaymentMutationFn = Apollo.MutationFunction<EditMortgagePaymentMutation, EditMortgagePaymentMutationVariables>;

/**
 * __useEditMortgagePaymentMutation__
 *
 * To run a mutation, you first call `useEditMortgagePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditMortgagePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editMortgagePaymentMutation, { data, loading, error }] = useEditMortgagePaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditMortgagePaymentMutation(baseOptions?: Apollo.MutationHookOptions<EditMortgagePaymentMutation, EditMortgagePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditMortgagePaymentMutation, EditMortgagePaymentMutationVariables>(EditMortgagePaymentDocument, options);
      }
export type EditMortgagePaymentMutationHookResult = ReturnType<typeof useEditMortgagePaymentMutation>;
export type EditMortgagePaymentMutationResult = Apollo.MutationResult<EditMortgagePaymentMutation>;
export type EditMortgagePaymentMutationOptions = Apollo.BaseMutationOptions<EditMortgagePaymentMutation, EditMortgagePaymentMutationVariables>;
export const DeleteMortgagePaymentDocument = gql`
    mutation deleteMortgagePayment($input: String!) {
  deleteMortgagePayment(input: $input)
}
    `;
export type DeleteMortgagePaymentMutationFn = Apollo.MutationFunction<DeleteMortgagePaymentMutation, DeleteMortgagePaymentMutationVariables>;

/**
 * __useDeleteMortgagePaymentMutation__
 *
 * To run a mutation, you first call `useDeleteMortgagePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMortgagePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMortgagePaymentMutation, { data, loading, error }] = useDeleteMortgagePaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteMortgagePaymentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMortgagePaymentMutation, DeleteMortgagePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMortgagePaymentMutation, DeleteMortgagePaymentMutationVariables>(DeleteMortgagePaymentDocument, options);
      }
export type DeleteMortgagePaymentMutationHookResult = ReturnType<typeof useDeleteMortgagePaymentMutation>;
export type DeleteMortgagePaymentMutationResult = Apollo.MutationResult<DeleteMortgagePaymentMutation>;
export type DeleteMortgagePaymentMutationOptions = Apollo.BaseMutationOptions<DeleteMortgagePaymentMutation, DeleteMortgagePaymentMutationVariables>;
export const CreateMortgageRetentionDocument = gql`
    mutation createMortgageRetention($input: MortgageRetentionInput!) {
  createMortgageRetention(input: $input)
}
    `;
export type CreateMortgageRetentionMutationFn = Apollo.MutationFunction<CreateMortgageRetentionMutation, CreateMortgageRetentionMutationVariables>;

/**
 * __useCreateMortgageRetentionMutation__
 *
 * To run a mutation, you first call `useCreateMortgageRetentionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMortgageRetentionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMortgageRetentionMutation, { data, loading, error }] = useCreateMortgageRetentionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMortgageRetentionMutation(baseOptions?: Apollo.MutationHookOptions<CreateMortgageRetentionMutation, CreateMortgageRetentionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMortgageRetentionMutation, CreateMortgageRetentionMutationVariables>(CreateMortgageRetentionDocument, options);
      }
export type CreateMortgageRetentionMutationHookResult = ReturnType<typeof useCreateMortgageRetentionMutation>;
export type CreateMortgageRetentionMutationResult = Apollo.MutationResult<CreateMortgageRetentionMutation>;
export type CreateMortgageRetentionMutationOptions = Apollo.BaseMutationOptions<CreateMortgageRetentionMutation, CreateMortgageRetentionMutationVariables>;
export const IsMortgageRetentionExistDocument = gql`
    query isMortgageRetentionExist($input: MortgageRetentionValidationInput!) {
  isMortgageRetentionExist(input: $input)
}
    `;

/**
 * __useIsMortgageRetentionExistQuery__
 *
 * To run a query within a React component, call `useIsMortgageRetentionExistQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsMortgageRetentionExistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsMortgageRetentionExistQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIsMortgageRetentionExistQuery(baseOptions: Apollo.QueryHookOptions<IsMortgageRetentionExistQuery, IsMortgageRetentionExistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsMortgageRetentionExistQuery, IsMortgageRetentionExistQueryVariables>(IsMortgageRetentionExistDocument, options);
      }
export function useIsMortgageRetentionExistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsMortgageRetentionExistQuery, IsMortgageRetentionExistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsMortgageRetentionExistQuery, IsMortgageRetentionExistQueryVariables>(IsMortgageRetentionExistDocument, options);
        }
export type IsMortgageRetentionExistQueryHookResult = ReturnType<typeof useIsMortgageRetentionExistQuery>;
export type IsMortgageRetentionExistLazyQueryHookResult = ReturnType<typeof useIsMortgageRetentionExistLazyQuery>;
export type IsMortgageRetentionExistQueryResult = Apollo.QueryResult<IsMortgageRetentionExistQuery, IsMortgageRetentionExistQueryVariables>;
export const EditMortgageRetentionDocument = gql`
    mutation editMortgageRetention($input: MortgageRetentionInput!) {
  editMortgageRetention(input: $input)
}
    `;
export type EditMortgageRetentionMutationFn = Apollo.MutationFunction<EditMortgageRetentionMutation, EditMortgageRetentionMutationVariables>;

/**
 * __useEditMortgageRetentionMutation__
 *
 * To run a mutation, you first call `useEditMortgageRetentionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditMortgageRetentionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editMortgageRetentionMutation, { data, loading, error }] = useEditMortgageRetentionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditMortgageRetentionMutation(baseOptions?: Apollo.MutationHookOptions<EditMortgageRetentionMutation, EditMortgageRetentionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditMortgageRetentionMutation, EditMortgageRetentionMutationVariables>(EditMortgageRetentionDocument, options);
      }
export type EditMortgageRetentionMutationHookResult = ReturnType<typeof useEditMortgageRetentionMutation>;
export type EditMortgageRetentionMutationResult = Apollo.MutationResult<EditMortgageRetentionMutation>;
export type EditMortgageRetentionMutationOptions = Apollo.BaseMutationOptions<EditMortgageRetentionMutation, EditMortgageRetentionMutationVariables>;
export const DeleteMortgageRetentionDocument = gql`
    mutation deleteMortgageRetention($input: String!) {
  deleteMortgageRetention(input: $input)
}
    `;
export type DeleteMortgageRetentionMutationFn = Apollo.MutationFunction<DeleteMortgageRetentionMutation, DeleteMortgageRetentionMutationVariables>;

/**
 * __useDeleteMortgageRetentionMutation__
 *
 * To run a mutation, you first call `useDeleteMortgageRetentionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMortgageRetentionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMortgageRetentionMutation, { data, loading, error }] = useDeleteMortgageRetentionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteMortgageRetentionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMortgageRetentionMutation, DeleteMortgageRetentionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMortgageRetentionMutation, DeleteMortgageRetentionMutationVariables>(DeleteMortgageRetentionDocument, options);
      }
export type DeleteMortgageRetentionMutationHookResult = ReturnType<typeof useDeleteMortgageRetentionMutation>;
export type DeleteMortgageRetentionMutationResult = Apollo.MutationResult<DeleteMortgageRetentionMutation>;
export type DeleteMortgageRetentionMutationOptions = Apollo.BaseMutationOptions<DeleteMortgageRetentionMutation, DeleteMortgageRetentionMutationVariables>;
export const GetOptionListDocument = gql`
    query getOptionList($financierId: String) {
  getOptionList(financierId: $financierId) {
    id
    name
  }
}
    `;

/**
 * __useGetOptionListQuery__
 *
 * To run a query within a React component, call `useGetOptionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOptionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOptionListQuery({
 *   variables: {
 *      financierId: // value for 'financierId'
 *   },
 * });
 */
export function useGetOptionListQuery(baseOptions?: Apollo.QueryHookOptions<GetOptionListQuery, GetOptionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOptionListQuery, GetOptionListQueryVariables>(GetOptionListDocument, options);
      }
export function useGetOptionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOptionListQuery, GetOptionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOptionListQuery, GetOptionListQueryVariables>(GetOptionListDocument, options);
        }
export type GetOptionListQueryHookResult = ReturnType<typeof useGetOptionListQuery>;
export type GetOptionListLazyQueryHookResult = ReturnType<typeof useGetOptionListLazyQuery>;
export type GetOptionListQueryResult = Apollo.QueryResult<GetOptionListQuery, GetOptionListQueryVariables>;
export const ProjectsDocument = gql`
    query projects($limit: Float!, $page: Float!, $search: String) {
  allProject(limit: $limit, page: $page, search: $search) {
    projects {
      projectId
      projectName
      unReadNotification
      firstGalleryImageUrl
      newBooking
      newAssignment
      newAppointment
      others
    }
    totalUnread
    projectCount
  }
}
    `;

/**
 * __useProjectsQuery__
 *
 * To run a query within a React component, call `useProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useProjectsQuery(baseOptions: Apollo.QueryHookOptions<ProjectsQuery, ProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectsQuery, ProjectsQueryVariables>(ProjectsDocument, options);
      }
export function useProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectsQuery, ProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectsQuery, ProjectsQueryVariables>(ProjectsDocument, options);
        }
export type ProjectsQueryHookResult = ReturnType<typeof useProjectsQuery>;
export type ProjectsLazyQueryHookResult = ReturnType<typeof useProjectsLazyQuery>;
export type ProjectsQueryResult = Apollo.QueryResult<ProjectsQuery, ProjectsQueryVariables>;
export const GetTodoListDocument = gql`
    query getTodoList($limit: Float!, $page: Float!, $search: String) {
  todoList(limit: $limit, page: $page, search: $search) {
    projects {
      details {
        id
        name
        firstGalleryImage {
          resourceid
          url
        }
      }
      count {
        total
      }
    }
    total
  }
}
    `;

/**
 * __useGetTodoListQuery__
 *
 * To run a query within a React component, call `useGetTodoListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTodoListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTodoListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetTodoListQuery(baseOptions: Apollo.QueryHookOptions<GetTodoListQuery, GetTodoListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTodoListQuery, GetTodoListQueryVariables>(GetTodoListDocument, options);
      }
export function useGetTodoListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTodoListQuery, GetTodoListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTodoListQuery, GetTodoListQueryVariables>(GetTodoListDocument, options);
        }
export type GetTodoListQueryHookResult = ReturnType<typeof useGetTodoListQuery>;
export type GetTodoListLazyQueryHookResult = ReturnType<typeof useGetTodoListLazyQuery>;
export type GetTodoListQueryResult = Apollo.QueryResult<GetTodoListQuery, GetTodoListQueryVariables>;
export const GetTodoListCountDocument = gql`
    query getTodoListCount($limit: Float!, $page: Float!, $search: String) {
  todoList(limit: $limit, page: $page, search: $search) {
    totalCountTodoList
  }
}
    `;

/**
 * __useGetTodoListCountQuery__
 *
 * To run a query within a React component, call `useGetTodoListCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTodoListCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTodoListCountQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetTodoListCountQuery(baseOptions: Apollo.QueryHookOptions<GetTodoListCountQuery, GetTodoListCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTodoListCountQuery, GetTodoListCountQueryVariables>(GetTodoListCountDocument, options);
      }
export function useGetTodoListCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTodoListCountQuery, GetTodoListCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTodoListCountQuery, GetTodoListCountQueryVariables>(GetTodoListCountDocument, options);
        }
export type GetTodoListCountQueryHookResult = ReturnType<typeof useGetTodoListCountQuery>;
export type GetTodoListCountLazyQueryHookResult = ReturnType<typeof useGetTodoListCountLazyQuery>;
export type GetTodoListCountQueryResult = Apollo.QueryResult<GetTodoListCountQuery, GetTodoListCountQueryVariables>;
export const GetAccountNameHomeDocument = gql`
    query getAccountNameHome {
  getAccountNameHome
}
    `;

/**
 * __useGetAccountNameHomeQuery__
 *
 * To run a query within a React component, call `useGetAccountNameHomeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountNameHomeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountNameHomeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAccountNameHomeQuery(baseOptions?: Apollo.QueryHookOptions<GetAccountNameHomeQuery, GetAccountNameHomeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountNameHomeQuery, GetAccountNameHomeQueryVariables>(GetAccountNameHomeDocument, options);
      }
export function useGetAccountNameHomeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountNameHomeQuery, GetAccountNameHomeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountNameHomeQuery, GetAccountNameHomeQueryVariables>(GetAccountNameHomeDocument, options);
        }
export type GetAccountNameHomeQueryHookResult = ReturnType<typeof useGetAccountNameHomeQuery>;
export type GetAccountNameHomeLazyQueryHookResult = ReturnType<typeof useGetAccountNameHomeLazyQuery>;
export type GetAccountNameHomeQueryResult = Apollo.QueryResult<GetAccountNameHomeQuery, GetAccountNameHomeQueryVariables>;
export const GetUnreadNotificationListCountDocument = gql`
    query getUnreadNotificationListCount {
  unReadNotificationCount
}
    `;

/**
 * __useGetUnreadNotificationListCountQuery__
 *
 * To run a query within a React component, call `useGetUnreadNotificationListCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnreadNotificationListCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnreadNotificationListCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUnreadNotificationListCountQuery(baseOptions?: Apollo.QueryHookOptions<GetUnreadNotificationListCountQuery, GetUnreadNotificationListCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnreadNotificationListCountQuery, GetUnreadNotificationListCountQueryVariables>(GetUnreadNotificationListCountDocument, options);
      }
export function useGetUnreadNotificationListCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnreadNotificationListCountQuery, GetUnreadNotificationListCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnreadNotificationListCountQuery, GetUnreadNotificationListCountQueryVariables>(GetUnreadNotificationListCountDocument, options);
        }
export type GetUnreadNotificationListCountQueryHookResult = ReturnType<typeof useGetUnreadNotificationListCountQuery>;
export type GetUnreadNotificationListCountLazyQueryHookResult = ReturnType<typeof useGetUnreadNotificationListCountLazyQuery>;
export type GetUnreadNotificationListCountQueryResult = Apollo.QueryResult<GetUnreadNotificationListCountQuery, GetUnreadNotificationListCountQueryVariables>;
export const GetRemainingSubscriptionDaysDocument = gql`
    query getRemainingSubscriptionDays {
  getRemainingSubscriptionDays
}
    `;

/**
 * __useGetRemainingSubscriptionDaysQuery__
 *
 * To run a query within a React component, call `useGetRemainingSubscriptionDaysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRemainingSubscriptionDaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRemainingSubscriptionDaysQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRemainingSubscriptionDaysQuery(baseOptions?: Apollo.QueryHookOptions<GetRemainingSubscriptionDaysQuery, GetRemainingSubscriptionDaysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRemainingSubscriptionDaysQuery, GetRemainingSubscriptionDaysQueryVariables>(GetRemainingSubscriptionDaysDocument, options);
      }
export function useGetRemainingSubscriptionDaysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRemainingSubscriptionDaysQuery, GetRemainingSubscriptionDaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRemainingSubscriptionDaysQuery, GetRemainingSubscriptionDaysQueryVariables>(GetRemainingSubscriptionDaysDocument, options);
        }
export type GetRemainingSubscriptionDaysQueryHookResult = ReturnType<typeof useGetRemainingSubscriptionDaysQuery>;
export type GetRemainingSubscriptionDaysLazyQueryHookResult = ReturnType<typeof useGetRemainingSubscriptionDaysLazyQuery>;
export type GetRemainingSubscriptionDaysQueryResult = Apollo.QueryResult<GetRemainingSubscriptionDaysQuery, GetRemainingSubscriptionDaysQueryVariables>;
export const DeleteAppointmentDocument = gql`
    mutation DeleteAppointment($appointmentId: String!) {
  deleteAppointment(appointment_id: $appointmentId)
}
    `;
export type DeleteAppointmentMutationFn = Apollo.MutationFunction<DeleteAppointmentMutation, DeleteAppointmentMutationVariables>;

/**
 * __useDeleteAppointmentMutation__
 *
 * To run a mutation, you first call `useDeleteAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAppointmentMutation, { data, loading, error }] = useDeleteAppointmentMutation({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *   },
 * });
 */
export function useDeleteAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAppointmentMutation, DeleteAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAppointmentMutation, DeleteAppointmentMutationVariables>(DeleteAppointmentDocument, options);
      }
export type DeleteAppointmentMutationHookResult = ReturnType<typeof useDeleteAppointmentMutation>;
export type DeleteAppointmentMutationResult = Apollo.MutationResult<DeleteAppointmentMutation>;
export type DeleteAppointmentMutationOptions = Apollo.BaseMutationOptions<DeleteAppointmentMutation, DeleteAppointmentMutationVariables>;
export const GetAppointmentsForDayDocument = gql`
    query getAppointmentsForDay($appointmentDate: String) {
  getManyAppointmentForDay(appointment_date: $appointmentDate) {
    id
    startTime
    endTime
    salePerson {
      ID
      name
    }
    appointmentPurpose {
      name
    }
    project {
      id
      name
    }
  }
}
    `;

/**
 * __useGetAppointmentsForDayQuery__
 *
 * To run a query within a React component, call `useGetAppointmentsForDayQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentsForDayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentsForDayQuery({
 *   variables: {
 *      appointmentDate: // value for 'appointmentDate'
 *   },
 * });
 */
export function useGetAppointmentsForDayQuery(baseOptions?: Apollo.QueryHookOptions<GetAppointmentsForDayQuery, GetAppointmentsForDayQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentsForDayQuery, GetAppointmentsForDayQueryVariables>(GetAppointmentsForDayDocument, options);
      }
export function useGetAppointmentsForDayLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentsForDayQuery, GetAppointmentsForDayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentsForDayQuery, GetAppointmentsForDayQueryVariables>(GetAppointmentsForDayDocument, options);
        }
export type GetAppointmentsForDayQueryHookResult = ReturnType<typeof useGetAppointmentsForDayQuery>;
export type GetAppointmentsForDayLazyQueryHookResult = ReturnType<typeof useGetAppointmentsForDayLazyQuery>;
export type GetAppointmentsForDayQueryResult = Apollo.QueryResult<GetAppointmentsForDayQuery, GetAppointmentsForDayQueryVariables>;
export const AddAppointmentDocument = gql`
    mutation AddAppointment($input: NewAppointmentInput!) {
  addAppointment(input: $input)
}
    `;
export type AddAppointmentMutationFn = Apollo.MutationFunction<AddAppointmentMutation, AddAppointmentMutationVariables>;

/**
 * __useAddAppointmentMutation__
 *
 * To run a mutation, you first call `useAddAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAppointmentMutation, { data, loading, error }] = useAddAppointmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<AddAppointmentMutation, AddAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAppointmentMutation, AddAppointmentMutationVariables>(AddAppointmentDocument, options);
      }
export type AddAppointmentMutationHookResult = ReturnType<typeof useAddAppointmentMutation>;
export type AddAppointmentMutationResult = Apollo.MutationResult<AddAppointmentMutation>;
export type AddAppointmentMutationOptions = Apollo.BaseMutationOptions<AddAppointmentMutation, AddAppointmentMutationVariables>;
export const EditAppointmentDocument = gql`
    mutation EditAppointment($input: NewAppointmentInput!, $appointmentId: String!) {
  editAppointment(input: $input, appointment_id: $appointmentId)
}
    `;
export type EditAppointmentMutationFn = Apollo.MutationFunction<EditAppointmentMutation, EditAppointmentMutationVariables>;

/**
 * __useEditAppointmentMutation__
 *
 * To run a mutation, you first call `useEditAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editAppointmentMutation, { data, loading, error }] = useEditAppointmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *      appointmentId: // value for 'appointmentId'
 *   },
 * });
 */
export function useEditAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<EditAppointmentMutation, EditAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditAppointmentMutation, EditAppointmentMutationVariables>(EditAppointmentDocument, options);
      }
export type EditAppointmentMutationHookResult = ReturnType<typeof useEditAppointmentMutation>;
export type EditAppointmentMutationResult = Apollo.MutationResult<EditAppointmentMutation>;
export type EditAppointmentMutationOptions = Apollo.BaseMutationOptions<EditAppointmentMutation, EditAppointmentMutationVariables>;
export const GetDefaultAppointmentStartEndTimeDocument = gql`
    query getDefaultAppointmentStartEndTime($projectId: String!) {
  getDefaultAppointmentStartEndTime(projectId: $projectId) {
    id
    projectId
    startTime
    endTime
  }
}
    `;

/**
 * __useGetDefaultAppointmentStartEndTimeQuery__
 *
 * To run a query within a React component, call `useGetDefaultAppointmentStartEndTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDefaultAppointmentStartEndTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDefaultAppointmentStartEndTimeQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetDefaultAppointmentStartEndTimeQuery(baseOptions: Apollo.QueryHookOptions<GetDefaultAppointmentStartEndTimeQuery, GetDefaultAppointmentStartEndTimeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDefaultAppointmentStartEndTimeQuery, GetDefaultAppointmentStartEndTimeQueryVariables>(GetDefaultAppointmentStartEndTimeDocument, options);
      }
export function useGetDefaultAppointmentStartEndTimeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDefaultAppointmentStartEndTimeQuery, GetDefaultAppointmentStartEndTimeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDefaultAppointmentStartEndTimeQuery, GetDefaultAppointmentStartEndTimeQueryVariables>(GetDefaultAppointmentStartEndTimeDocument, options);
        }
export type GetDefaultAppointmentStartEndTimeQueryHookResult = ReturnType<typeof useGetDefaultAppointmentStartEndTimeQuery>;
export type GetDefaultAppointmentStartEndTimeLazyQueryHookResult = ReturnType<typeof useGetDefaultAppointmentStartEndTimeLazyQuery>;
export type GetDefaultAppointmentStartEndTimeQueryResult = Apollo.QueryResult<GetDefaultAppointmentStartEndTimeQuery, GetDefaultAppointmentStartEndTimeQueryVariables>;
export const GetEditAppointmentDocument = gql`
    query getEditAppointment($appointmentId: String!) {
  getOneAppointment(appointment_id: $appointmentId) {
    id
    project {
      id
      name
    }
    salePerson {
      ID
      name
    }
    saleTeam {
      id
      name
    }
    appointmentDate
    startTime
    endTime
    appointmentPurpose {
      id
      name
    }
    lead {
      id
      fullName
      phoneNo
      email
    }
    needManagerAssistant
    remarks
    participantLimit
    leadSourceFromLead {
      leadSource {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetEditAppointmentQuery__
 *
 * To run a query within a React component, call `useGetEditAppointmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditAppointmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditAppointmentQuery({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *   },
 * });
 */
export function useGetEditAppointmentQuery(baseOptions: Apollo.QueryHookOptions<GetEditAppointmentQuery, GetEditAppointmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditAppointmentQuery, GetEditAppointmentQueryVariables>(GetEditAppointmentDocument, options);
      }
export function useGetEditAppointmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditAppointmentQuery, GetEditAppointmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditAppointmentQuery, GetEditAppointmentQueryVariables>(GetEditAppointmentDocument, options);
        }
export type GetEditAppointmentQueryHookResult = ReturnType<typeof useGetEditAppointmentQuery>;
export type GetEditAppointmentLazyQueryHookResult = ReturnType<typeof useGetEditAppointmentLazyQuery>;
export type GetEditAppointmentQueryResult = Apollo.QueryResult<GetEditAppointmentQuery, GetEditAppointmentQueryVariables>;
export const GetFormDataDocument = gql`
    query getFormData($limit: Float!, $page: Float!, $search: String) {
  allProjectInvolve(limit: $limit, page: $page, search: $search) {
    project {
      id
      name
    }
    level
  }
  getManyAppointmentType {
    id
    name
  }
}
    `;

/**
 * __useGetFormDataQuery__
 *
 * To run a query within a React component, call `useGetFormDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormDataQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetFormDataQuery(baseOptions: Apollo.QueryHookOptions<GetFormDataQuery, GetFormDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFormDataQuery, GetFormDataQueryVariables>(GetFormDataDocument, options);
      }
export function useGetFormDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFormDataQuery, GetFormDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFormDataQuery, GetFormDataQueryVariables>(GetFormDataDocument, options);
        }
export type GetFormDataQueryHookResult = ReturnType<typeof useGetFormDataQuery>;
export type GetFormDataLazyQueryHookResult = ReturnType<typeof useGetFormDataLazyQuery>;
export type GetFormDataQueryResult = Apollo.QueryResult<GetFormDataQuery, GetFormDataQueryVariables>;
export const GetSalesPersonDocument = gql`
    query getSalesPerson($teamID: String!) {
  getSalesPerson(teamId: $teamID) {
    ID
    name
  }
}
    `;

/**
 * __useGetSalesPersonQuery__
 *
 * To run a query within a React component, call `useGetSalesPersonQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesPersonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesPersonQuery({
 *   variables: {
 *      teamID: // value for 'teamID'
 *   },
 * });
 */
export function useGetSalesPersonQuery(baseOptions: Apollo.QueryHookOptions<GetSalesPersonQuery, GetSalesPersonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesPersonQuery, GetSalesPersonQueryVariables>(GetSalesPersonDocument, options);
      }
export function useGetSalesPersonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesPersonQuery, GetSalesPersonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesPersonQuery, GetSalesPersonQueryVariables>(GetSalesPersonDocument, options);
        }
export type GetSalesPersonQueryHookResult = ReturnType<typeof useGetSalesPersonQuery>;
export type GetSalesPersonLazyQueryHookResult = ReturnType<typeof useGetSalesPersonLazyQuery>;
export type GetSalesPersonQueryResult = Apollo.QueryResult<GetSalesPersonQuery, GetSalesPersonQueryVariables>;
export const GetTeamsDocument = gql`
    query getTeams($projectID: String!) {
  getTeams(projectId: $projectID) {
    id
    name
  }
}
    `;

/**
 * __useGetTeamsQuery__
 *
 * To run a query within a React component, call `useGetTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamsQuery({
 *   variables: {
 *      projectID: // value for 'projectID'
 *   },
 * });
 */
export function useGetTeamsQuery(baseOptions: Apollo.QueryHookOptions<GetTeamsQuery, GetTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamsQuery, GetTeamsQueryVariables>(GetTeamsDocument, options);
      }
export function useGetTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamsQuery, GetTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamsQuery, GetTeamsQueryVariables>(GetTeamsDocument, options);
        }
export type GetTeamsQueryHookResult = ReturnType<typeof useGetTeamsQuery>;
export type GetTeamsLazyQueryHookResult = ReturnType<typeof useGetTeamsLazyQuery>;
export type GetTeamsQueryResult = Apollo.QueryResult<GetTeamsQuery, GetTeamsQueryVariables>;
export const LeadGetMasterDataDocument = gql`
    query leadGetMasterData {
  GetAllMasterInfo {
    LeadSources {
      id
      name
      commonStatus
      defaulted
    }
  }
}
    `;

/**
 * __useLeadGetMasterDataQuery__
 *
 * To run a query within a React component, call `useLeadGetMasterDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeadGetMasterDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeadGetMasterDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useLeadGetMasterDataQuery(baseOptions?: Apollo.QueryHookOptions<LeadGetMasterDataQuery, LeadGetMasterDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeadGetMasterDataQuery, LeadGetMasterDataQueryVariables>(LeadGetMasterDataDocument, options);
      }
export function useLeadGetMasterDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeadGetMasterDataQuery, LeadGetMasterDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeadGetMasterDataQuery, LeadGetMasterDataQueryVariables>(LeadGetMasterDataDocument, options);
        }
export type LeadGetMasterDataQueryHookResult = ReturnType<typeof useLeadGetMasterDataQuery>;
export type LeadGetMasterDataLazyQueryHookResult = ReturnType<typeof useLeadGetMasterDataLazyQuery>;
export type LeadGetMasterDataQueryResult = Apollo.QueryResult<LeadGetMasterDataQuery, LeadGetMasterDataQueryVariables>;
export const GetDaysAppointmentDocument = gql`
    query getDaysAppointment {
  getDaysOfAppointment
}
    `;

/**
 * __useGetDaysAppointmentQuery__
 *
 * To run a query within a React component, call `useGetDaysAppointmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDaysAppointmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDaysAppointmentQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDaysAppointmentQuery(baseOptions?: Apollo.QueryHookOptions<GetDaysAppointmentQuery, GetDaysAppointmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDaysAppointmentQuery, GetDaysAppointmentQueryVariables>(GetDaysAppointmentDocument, options);
      }
export function useGetDaysAppointmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDaysAppointmentQuery, GetDaysAppointmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDaysAppointmentQuery, GetDaysAppointmentQueryVariables>(GetDaysAppointmentDocument, options);
        }
export type GetDaysAppointmentQueryHookResult = ReturnType<typeof useGetDaysAppointmentQuery>;
export type GetDaysAppointmentLazyQueryHookResult = ReturnType<typeof useGetDaysAppointmentLazyQuery>;
export type GetDaysAppointmentQueryResult = Apollo.QueryResult<GetDaysAppointmentQuery, GetDaysAppointmentQueryVariables>;
export const GetNotificationsListDocument = gql`
    query getNotificationsList($limit: Float!, $page: Float!, $search: String, $projectId: String) {
  getNotificationsList(limit: $limit, page: $page, search: $search, projectId: $projectId)
}
    `;

/**
 * __useGetNotificationsListQuery__
 *
 * To run a query within a React component, call `useGetNotificationsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetNotificationsListQuery(baseOptions: Apollo.QueryHookOptions<GetNotificationsListQuery, GetNotificationsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationsListQuery, GetNotificationsListQueryVariables>(GetNotificationsListDocument, options);
      }
export function useGetNotificationsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationsListQuery, GetNotificationsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationsListQuery, GetNotificationsListQueryVariables>(GetNotificationsListDocument, options);
        }
export type GetNotificationsListQueryHookResult = ReturnType<typeof useGetNotificationsListQuery>;
export type GetNotificationsListLazyQueryHookResult = ReturnType<typeof useGetNotificationsListLazyQuery>;
export type GetNotificationsListQueryResult = Apollo.QueryResult<GetNotificationsListQuery, GetNotificationsListQueryVariables>;
export const MarkAllReadDocument = gql`
    query markAllRead($projectId: String) {
  markAllRead(projectId: $projectId)
}
    `;

/**
 * __useMarkAllReadQuery__
 *
 * To run a query within a React component, call `useMarkAllReadQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarkAllReadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarkAllReadQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useMarkAllReadQuery(baseOptions?: Apollo.QueryHookOptions<MarkAllReadQuery, MarkAllReadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarkAllReadQuery, MarkAllReadQueryVariables>(MarkAllReadDocument, options);
      }
export function useMarkAllReadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarkAllReadQuery, MarkAllReadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarkAllReadQuery, MarkAllReadQueryVariables>(MarkAllReadDocument, options);
        }
export type MarkAllReadQueryHookResult = ReturnType<typeof useMarkAllReadQuery>;
export type MarkAllReadLazyQueryHookResult = ReturnType<typeof useMarkAllReadLazyQuery>;
export type MarkAllReadQueryResult = Apollo.QueryResult<MarkAllReadQuery, MarkAllReadQueryVariables>;
export const MarkAsReadDocument = gql`
    mutation markAsRead($notificationIds: [String!]!) {
  markAsRead(notificationIds: $notificationIds)
}
    `;
export type MarkAsReadMutationFn = Apollo.MutationFunction<MarkAsReadMutation, MarkAsReadMutationVariables>;

/**
 * __useMarkAsReadMutation__
 *
 * To run a mutation, you first call `useMarkAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAsReadMutation, { data, loading, error }] = useMarkAsReadMutation({
 *   variables: {
 *      notificationIds: // value for 'notificationIds'
 *   },
 * });
 */
export function useMarkAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkAsReadMutation, MarkAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkAsReadMutation, MarkAsReadMutationVariables>(MarkAsReadDocument, options);
      }
export type MarkAsReadMutationHookResult = ReturnType<typeof useMarkAsReadMutation>;
export type MarkAsReadMutationResult = Apollo.MutationResult<MarkAsReadMutation>;
export type MarkAsReadMutationOptions = Apollo.BaseMutationOptions<MarkAsReadMutation, MarkAsReadMutationVariables>;
export const GetNewsAnnouncementListDocument = gql`
    query getNewsAnnouncementList($limit: Float!, $page: Float!, $search: String) {
  getNewsAnnouncement(limit: $limit, page: $page, search: $search) {
    newsData {
      id
      title
      startDate
      endDate
      attachment {
        id
        seqNo
        resourceUrl
      }
    }
    total
  }
}
    `;

/**
 * __useGetNewsAnnouncementListQuery__
 *
 * To run a query within a React component, call `useGetNewsAnnouncementListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsAnnouncementListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsAnnouncementListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetNewsAnnouncementListQuery(baseOptions: Apollo.QueryHookOptions<GetNewsAnnouncementListQuery, GetNewsAnnouncementListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNewsAnnouncementListQuery, GetNewsAnnouncementListQueryVariables>(GetNewsAnnouncementListDocument, options);
      }
export function useGetNewsAnnouncementListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNewsAnnouncementListQuery, GetNewsAnnouncementListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNewsAnnouncementListQuery, GetNewsAnnouncementListQueryVariables>(GetNewsAnnouncementListDocument, options);
        }
export type GetNewsAnnouncementListQueryHookResult = ReturnType<typeof useGetNewsAnnouncementListQuery>;
export type GetNewsAnnouncementListLazyQueryHookResult = ReturnType<typeof useGetNewsAnnouncementListLazyQuery>;
export type GetNewsAnnouncementListQueryResult = Apollo.QueryResult<GetNewsAnnouncementListQuery, GetNewsAnnouncementListQueryVariables>;
export const GetNewsDetailsDocument = gql`
    query getNewsDetails($newsId: String!) {
  getNewsDetails(newsId: $newsId) {
    id
    title
    description
    startDate
    endDate
    attachment {
      id
      seqNo
      resourceUrl
    }
  }
}
    `;

/**
 * __useGetNewsDetailsQuery__
 *
 * To run a query within a React component, call `useGetNewsDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsDetailsQuery({
 *   variables: {
 *      newsId: // value for 'newsId'
 *   },
 * });
 */
export function useGetNewsDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetNewsDetailsQuery, GetNewsDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNewsDetailsQuery, GetNewsDetailsQueryVariables>(GetNewsDetailsDocument, options);
      }
export function useGetNewsDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNewsDetailsQuery, GetNewsDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNewsDetailsQuery, GetNewsDetailsQueryVariables>(GetNewsDetailsDocument, options);
        }
export type GetNewsDetailsQueryHookResult = ReturnType<typeof useGetNewsDetailsQuery>;
export type GetNewsDetailsLazyQueryHookResult = ReturnType<typeof useGetNewsDetailsLazyQuery>;
export type GetNewsDetailsQueryResult = Apollo.QueryResult<GetNewsDetailsQuery, GetNewsDetailsQueryVariables>;
export const GetKeyCollectionAppointmentListDocument = gql`
    query getKeyCollectionAppointmentList {
  getKeyCollectionAppointmentList {
    id
    unitNo
    keyCollectionTimeslotId
    contactName
    date
    time
    userName
    saleId
    status
    plumberId
    plumberName
    electricianId
    electricianName
    alarmVendorId
    alarmVendorName
    siteSupervisorId
    siteSupervisorName
    noOfKey
  }
}
    `;

/**
 * __useGetKeyCollectionAppointmentListQuery__
 *
 * To run a query within a React component, call `useGetKeyCollectionAppointmentListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKeyCollectionAppointmentListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKeyCollectionAppointmentListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetKeyCollectionAppointmentListQuery(baseOptions?: Apollo.QueryHookOptions<GetKeyCollectionAppointmentListQuery, GetKeyCollectionAppointmentListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetKeyCollectionAppointmentListQuery, GetKeyCollectionAppointmentListQueryVariables>(GetKeyCollectionAppointmentListDocument, options);
      }
export function useGetKeyCollectionAppointmentListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetKeyCollectionAppointmentListQuery, GetKeyCollectionAppointmentListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetKeyCollectionAppointmentListQuery, GetKeyCollectionAppointmentListQueryVariables>(GetKeyCollectionAppointmentListDocument, options);
        }
export type GetKeyCollectionAppointmentListQueryHookResult = ReturnType<typeof useGetKeyCollectionAppointmentListQuery>;
export type GetKeyCollectionAppointmentListLazyQueryHookResult = ReturnType<typeof useGetKeyCollectionAppointmentListLazyQuery>;
export type GetKeyCollectionAppointmentListQueryResult = Apollo.QueryResult<GetKeyCollectionAppointmentListQuery, GetKeyCollectionAppointmentListQueryVariables>;
export const GetKeyCollectionAppointmentByIdDocument = gql`
    query getKeyCollectionAppointmentById($id: String!) {
  getKeyCollectionAppointmentById(id: $id) {
    id
    unitNo
    keyCollectionTimeslotId
    contactName
    date
    time
    userName
    saleId
    status
    plumberId
    plumberName
    electricianId
    electricianName
    alarmVendorId
    alarmVendorName
    siteSupervisorId
    siteSupervisorName
    handOverDate
    keysCollected
    sanitaryDate
    sanitaryRemark
    electricalDate
    electricalRemark
  }
}
    `;

/**
 * __useGetKeyCollectionAppointmentByIdQuery__
 *
 * To run a query within a React component, call `useGetKeyCollectionAppointmentByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKeyCollectionAppointmentByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKeyCollectionAppointmentByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetKeyCollectionAppointmentByIdQuery(baseOptions: Apollo.QueryHookOptions<GetKeyCollectionAppointmentByIdQuery, GetKeyCollectionAppointmentByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetKeyCollectionAppointmentByIdQuery, GetKeyCollectionAppointmentByIdQueryVariables>(GetKeyCollectionAppointmentByIdDocument, options);
      }
export function useGetKeyCollectionAppointmentByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetKeyCollectionAppointmentByIdQuery, GetKeyCollectionAppointmentByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetKeyCollectionAppointmentByIdQuery, GetKeyCollectionAppointmentByIdQueryVariables>(GetKeyCollectionAppointmentByIdDocument, options);
        }
export type GetKeyCollectionAppointmentByIdQueryHookResult = ReturnType<typeof useGetKeyCollectionAppointmentByIdQuery>;
export type GetKeyCollectionAppointmentByIdLazyQueryHookResult = ReturnType<typeof useGetKeyCollectionAppointmentByIdLazyQuery>;
export type GetKeyCollectionAppointmentByIdQueryResult = Apollo.QueryResult<GetKeyCollectionAppointmentByIdQuery, GetKeyCollectionAppointmentByIdQueryVariables>;
export const AddKeyCollectionAppointmentDocument = gql`
    mutation addKeyCollectionAppointment($input: keyCollectionAppointmentInput!) {
  addKeyCollectionAppointment(input: $input)
}
    `;
export type AddKeyCollectionAppointmentMutationFn = Apollo.MutationFunction<AddKeyCollectionAppointmentMutation, AddKeyCollectionAppointmentMutationVariables>;

/**
 * __useAddKeyCollectionAppointmentMutation__
 *
 * To run a mutation, you first call `useAddKeyCollectionAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddKeyCollectionAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addKeyCollectionAppointmentMutation, { data, loading, error }] = useAddKeyCollectionAppointmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddKeyCollectionAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<AddKeyCollectionAppointmentMutation, AddKeyCollectionAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddKeyCollectionAppointmentMutation, AddKeyCollectionAppointmentMutationVariables>(AddKeyCollectionAppointmentDocument, options);
      }
export type AddKeyCollectionAppointmentMutationHookResult = ReturnType<typeof useAddKeyCollectionAppointmentMutation>;
export type AddKeyCollectionAppointmentMutationResult = Apollo.MutationResult<AddKeyCollectionAppointmentMutation>;
export type AddKeyCollectionAppointmentMutationOptions = Apollo.BaseMutationOptions<AddKeyCollectionAppointmentMutation, AddKeyCollectionAppointmentMutationVariables>;
export const EditKeyCollectionAppointmentDocument = gql`
    mutation editKeyCollectionAppointment($input: EditKeyCollectionAppointmentInput!) {
  editKeyCollectionAppointment(input: $input)
}
    `;
export type EditKeyCollectionAppointmentMutationFn = Apollo.MutationFunction<EditKeyCollectionAppointmentMutation, EditKeyCollectionAppointmentMutationVariables>;

/**
 * __useEditKeyCollectionAppointmentMutation__
 *
 * To run a mutation, you first call `useEditKeyCollectionAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditKeyCollectionAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editKeyCollectionAppointmentMutation, { data, loading, error }] = useEditKeyCollectionAppointmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditKeyCollectionAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<EditKeyCollectionAppointmentMutation, EditKeyCollectionAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditKeyCollectionAppointmentMutation, EditKeyCollectionAppointmentMutationVariables>(EditKeyCollectionAppointmentDocument, options);
      }
export type EditKeyCollectionAppointmentMutationHookResult = ReturnType<typeof useEditKeyCollectionAppointmentMutation>;
export type EditKeyCollectionAppointmentMutationResult = Apollo.MutationResult<EditKeyCollectionAppointmentMutation>;
export type EditKeyCollectionAppointmentMutationOptions = Apollo.BaseMutationOptions<EditKeyCollectionAppointmentMutation, EditKeyCollectionAppointmentMutationVariables>;
export const CompleteKeyCollectionAppointmentDocument = gql`
    mutation completeKeyCollectionAppointment($input: completedCollectionAppointment!) {
  completeKeyCollectionAppointment(input: $input)
}
    `;
export type CompleteKeyCollectionAppointmentMutationFn = Apollo.MutationFunction<CompleteKeyCollectionAppointmentMutation, CompleteKeyCollectionAppointmentMutationVariables>;

/**
 * __useCompleteKeyCollectionAppointmentMutation__
 *
 * To run a mutation, you first call `useCompleteKeyCollectionAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteKeyCollectionAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeKeyCollectionAppointmentMutation, { data, loading, error }] = useCompleteKeyCollectionAppointmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteKeyCollectionAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<CompleteKeyCollectionAppointmentMutation, CompleteKeyCollectionAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteKeyCollectionAppointmentMutation, CompleteKeyCollectionAppointmentMutationVariables>(CompleteKeyCollectionAppointmentDocument, options);
      }
export type CompleteKeyCollectionAppointmentMutationHookResult = ReturnType<typeof useCompleteKeyCollectionAppointmentMutation>;
export type CompleteKeyCollectionAppointmentMutationResult = Apollo.MutationResult<CompleteKeyCollectionAppointmentMutation>;
export type CompleteKeyCollectionAppointmentMutationOptions = Apollo.BaseMutationOptions<CompleteKeyCollectionAppointmentMutation, CompleteKeyCollectionAppointmentMutationVariables>;
export const DeleteKeyCollectionAppointmentByIdDocument = gql`
    mutation deleteKeyCollectionAppointmentById($id: String!) {
  deleteKeyCollectionAppointmentById(id: $id)
}
    `;
export type DeleteKeyCollectionAppointmentByIdMutationFn = Apollo.MutationFunction<DeleteKeyCollectionAppointmentByIdMutation, DeleteKeyCollectionAppointmentByIdMutationVariables>;

/**
 * __useDeleteKeyCollectionAppointmentByIdMutation__
 *
 * To run a mutation, you first call `useDeleteKeyCollectionAppointmentByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteKeyCollectionAppointmentByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteKeyCollectionAppointmentByIdMutation, { data, loading, error }] = useDeleteKeyCollectionAppointmentByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteKeyCollectionAppointmentByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteKeyCollectionAppointmentByIdMutation, DeleteKeyCollectionAppointmentByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteKeyCollectionAppointmentByIdMutation, DeleteKeyCollectionAppointmentByIdMutationVariables>(DeleteKeyCollectionAppointmentByIdDocument, options);
      }
export type DeleteKeyCollectionAppointmentByIdMutationHookResult = ReturnType<typeof useDeleteKeyCollectionAppointmentByIdMutation>;
export type DeleteKeyCollectionAppointmentByIdMutationResult = Apollo.MutationResult<DeleteKeyCollectionAppointmentByIdMutation>;
export type DeleteKeyCollectionAppointmentByIdMutationOptions = Apollo.BaseMutationOptions<DeleteKeyCollectionAppointmentByIdMutation, DeleteKeyCollectionAppointmentByIdMutationVariables>;
export const CancelKeyCollectionAppointmentDocument = gql`
    mutation cancelKeyCollectionAppointment($id: String!, $saleId: String!) {
  cancelKeyCollectionAppointment(id: $id, saleId: $saleId)
}
    `;
export type CancelKeyCollectionAppointmentMutationFn = Apollo.MutationFunction<CancelKeyCollectionAppointmentMutation, CancelKeyCollectionAppointmentMutationVariables>;

/**
 * __useCancelKeyCollectionAppointmentMutation__
 *
 * To run a mutation, you first call `useCancelKeyCollectionAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelKeyCollectionAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelKeyCollectionAppointmentMutation, { data, loading, error }] = useCancelKeyCollectionAppointmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useCancelKeyCollectionAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<CancelKeyCollectionAppointmentMutation, CancelKeyCollectionAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelKeyCollectionAppointmentMutation, CancelKeyCollectionAppointmentMutationVariables>(CancelKeyCollectionAppointmentDocument, options);
      }
export type CancelKeyCollectionAppointmentMutationHookResult = ReturnType<typeof useCancelKeyCollectionAppointmentMutation>;
export type CancelKeyCollectionAppointmentMutationResult = Apollo.MutationResult<CancelKeyCollectionAppointmentMutation>;
export type CancelKeyCollectionAppointmentMutationOptions = Apollo.BaseMutationOptions<CancelKeyCollectionAppointmentMutation, CancelKeyCollectionAppointmentMutationVariables>;
export const GetUnitsForKeyCollectionDocument = gql`
    query getUnitsForKeyCollection {
  getUnitsForKeyCollection {
    saleId
    unitId
    unitNo
    fullName
  }
}
    `;

/**
 * __useGetUnitsForKeyCollectionQuery__
 *
 * To run a query within a React component, call `useGetUnitsForKeyCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitsForKeyCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitsForKeyCollectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUnitsForKeyCollectionQuery(baseOptions?: Apollo.QueryHookOptions<GetUnitsForKeyCollectionQuery, GetUnitsForKeyCollectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitsForKeyCollectionQuery, GetUnitsForKeyCollectionQueryVariables>(GetUnitsForKeyCollectionDocument, options);
      }
export function useGetUnitsForKeyCollectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitsForKeyCollectionQuery, GetUnitsForKeyCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitsForKeyCollectionQuery, GetUnitsForKeyCollectionQueryVariables>(GetUnitsForKeyCollectionDocument, options);
        }
export type GetUnitsForKeyCollectionQueryHookResult = ReturnType<typeof useGetUnitsForKeyCollectionQuery>;
export type GetUnitsForKeyCollectionLazyQueryHookResult = ReturnType<typeof useGetUnitsForKeyCollectionLazyQuery>;
export type GetUnitsForKeyCollectionQueryResult = Apollo.QueryResult<GetUnitsForKeyCollectionQuery, GetUnitsForKeyCollectionQueryVariables>;
export const GetTimeSlotByDateDocument = gql`
    query getTimeSlotByDate($date: DateTime!) {
  getTimeSlotByDate(date: $date) {
    scheduleId
    userData {
      id
      name
    }
    timeSlot {
      scheduleTime
      timeSlotDetail {
        id
        userId
        available
        unitNo
      }
    }
  }
}
    `;

/**
 * __useGetTimeSlotByDateQuery__
 *
 * To run a query within a React component, call `useGetTimeSlotByDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimeSlotByDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimeSlotByDateQuery({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetTimeSlotByDateQuery(baseOptions: Apollo.QueryHookOptions<GetTimeSlotByDateQuery, GetTimeSlotByDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTimeSlotByDateQuery, GetTimeSlotByDateQueryVariables>(GetTimeSlotByDateDocument, options);
      }
export function useGetTimeSlotByDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTimeSlotByDateQuery, GetTimeSlotByDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTimeSlotByDateQuery, GetTimeSlotByDateQueryVariables>(GetTimeSlotByDateDocument, options);
        }
export type GetTimeSlotByDateQueryHookResult = ReturnType<typeof useGetTimeSlotByDateQuery>;
export type GetTimeSlotByDateLazyQueryHookResult = ReturnType<typeof useGetTimeSlotByDateLazyQuery>;
export type GetTimeSlotByDateQueryResult = Apollo.QueryResult<GetTimeSlotByDateQuery, GetTimeSlotByDateQueryVariables>;
export const GetContractorByTypeDocument = gql`
    query getContractorByType {
  getContractorByType {
    PLUMBER {
      id
      name
      contractorType
    }
    ELECTRICIAN {
      id
      name
      contractorType
    }
    ALARM_VENDOR {
      id
      name
      contractorType
    }
    SITE_SUPERVISOR {
      id
      name
      contractorType
    }
  }
}
    `;

/**
 * __useGetContractorByTypeQuery__
 *
 * To run a query within a React component, call `useGetContractorByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractorByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractorByTypeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetContractorByTypeQuery(baseOptions?: Apollo.QueryHookOptions<GetContractorByTypeQuery, GetContractorByTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractorByTypeQuery, GetContractorByTypeQueryVariables>(GetContractorByTypeDocument, options);
      }
export function useGetContractorByTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractorByTypeQuery, GetContractorByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractorByTypeQuery, GetContractorByTypeQueryVariables>(GetContractorByTypeDocument, options);
        }
export type GetContractorByTypeQueryHookResult = ReturnType<typeof useGetContractorByTypeQuery>;
export type GetContractorByTypeLazyQueryHookResult = ReturnType<typeof useGetContractorByTypeLazyQuery>;
export type GetContractorByTypeQueryResult = Apollo.QueryResult<GetContractorByTypeQuery, GetContractorByTypeQueryVariables>;
export const GetOsAmountDocument = gql`
    query getOSAmount($saleId: String!) {
  getOSAmount(saleId: $saleId)
}
    `;

/**
 * __useGetOsAmountQuery__
 *
 * To run a query within a React component, call `useGetOsAmountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOsAmountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOsAmountQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetOsAmountQuery(baseOptions: Apollo.QueryHookOptions<GetOsAmountQuery, GetOsAmountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOsAmountQuery, GetOsAmountQueryVariables>(GetOsAmountDocument, options);
      }
export function useGetOsAmountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOsAmountQuery, GetOsAmountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOsAmountQuery, GetOsAmountQueryVariables>(GetOsAmountDocument, options);
        }
export type GetOsAmountQueryHookResult = ReturnType<typeof useGetOsAmountQuery>;
export type GetOsAmountLazyQueryHookResult = ReturnType<typeof useGetOsAmountLazyQuery>;
export type GetOsAmountQueryResult = Apollo.QueryResult<GetOsAmountQuery, GetOsAmountQueryVariables>;
export const GetAllProjectKeyCollectionContractorDocument = gql`
    query getAllProjectKeyCollectionContractor {
  getAllProjectKeyCollectionContractor {
    id
    name
    contactNo
    email
    contractorType
    commonStatus
  }
}
    `;

/**
 * __useGetAllProjectKeyCollectionContractorQuery__
 *
 * To run a query within a React component, call `useGetAllProjectKeyCollectionContractorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllProjectKeyCollectionContractorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllProjectKeyCollectionContractorQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllProjectKeyCollectionContractorQuery(baseOptions?: Apollo.QueryHookOptions<GetAllProjectKeyCollectionContractorQuery, GetAllProjectKeyCollectionContractorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllProjectKeyCollectionContractorQuery, GetAllProjectKeyCollectionContractorQueryVariables>(GetAllProjectKeyCollectionContractorDocument, options);
      }
export function useGetAllProjectKeyCollectionContractorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllProjectKeyCollectionContractorQuery, GetAllProjectKeyCollectionContractorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllProjectKeyCollectionContractorQuery, GetAllProjectKeyCollectionContractorQueryVariables>(GetAllProjectKeyCollectionContractorDocument, options);
        }
export type GetAllProjectKeyCollectionContractorQueryHookResult = ReturnType<typeof useGetAllProjectKeyCollectionContractorQuery>;
export type GetAllProjectKeyCollectionContractorLazyQueryHookResult = ReturnType<typeof useGetAllProjectKeyCollectionContractorLazyQuery>;
export type GetAllProjectKeyCollectionContractorQueryResult = Apollo.QueryResult<GetAllProjectKeyCollectionContractorQuery, GetAllProjectKeyCollectionContractorQueryVariables>;
export const GetProjectKeyCollectionContractorByIdDocument = gql`
    query getProjectKeyCollectionContractorById($id: String!) {
  getProjectKeyCollectionContractorById(id: $id) {
    name
    contactNo
    email
    contractorType
  }
}
    `;

/**
 * __useGetProjectKeyCollectionContractorByIdQuery__
 *
 * To run a query within a React component, call `useGetProjectKeyCollectionContractorByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectKeyCollectionContractorByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectKeyCollectionContractorByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectKeyCollectionContractorByIdQuery(baseOptions: Apollo.QueryHookOptions<GetProjectKeyCollectionContractorByIdQuery, GetProjectKeyCollectionContractorByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectKeyCollectionContractorByIdQuery, GetProjectKeyCollectionContractorByIdQueryVariables>(GetProjectKeyCollectionContractorByIdDocument, options);
      }
export function useGetProjectKeyCollectionContractorByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectKeyCollectionContractorByIdQuery, GetProjectKeyCollectionContractorByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectKeyCollectionContractorByIdQuery, GetProjectKeyCollectionContractorByIdQueryVariables>(GetProjectKeyCollectionContractorByIdDocument, options);
        }
export type GetProjectKeyCollectionContractorByIdQueryHookResult = ReturnType<typeof useGetProjectKeyCollectionContractorByIdQuery>;
export type GetProjectKeyCollectionContractorByIdLazyQueryHookResult = ReturnType<typeof useGetProjectKeyCollectionContractorByIdLazyQuery>;
export type GetProjectKeyCollectionContractorByIdQueryResult = Apollo.QueryResult<GetProjectKeyCollectionContractorByIdQuery, GetProjectKeyCollectionContractorByIdQueryVariables>;
export const AddProjectKeyCollectionContractorDocument = gql`
    mutation addProjectKeyCollectionContractor($input: projectKeyCollectionContractorInput!) {
  addProjectKeyCollectionContractor(input: $input)
}
    `;
export type AddProjectKeyCollectionContractorMutationFn = Apollo.MutationFunction<AddProjectKeyCollectionContractorMutation, AddProjectKeyCollectionContractorMutationVariables>;

/**
 * __useAddProjectKeyCollectionContractorMutation__
 *
 * To run a mutation, you first call `useAddProjectKeyCollectionContractorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProjectKeyCollectionContractorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProjectKeyCollectionContractorMutation, { data, loading, error }] = useAddProjectKeyCollectionContractorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddProjectKeyCollectionContractorMutation(baseOptions?: Apollo.MutationHookOptions<AddProjectKeyCollectionContractorMutation, AddProjectKeyCollectionContractorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProjectKeyCollectionContractorMutation, AddProjectKeyCollectionContractorMutationVariables>(AddProjectKeyCollectionContractorDocument, options);
      }
export type AddProjectKeyCollectionContractorMutationHookResult = ReturnType<typeof useAddProjectKeyCollectionContractorMutation>;
export type AddProjectKeyCollectionContractorMutationResult = Apollo.MutationResult<AddProjectKeyCollectionContractorMutation>;
export type AddProjectKeyCollectionContractorMutationOptions = Apollo.BaseMutationOptions<AddProjectKeyCollectionContractorMutation, AddProjectKeyCollectionContractorMutationVariables>;
export const EditProjectKeyCollectionContractorDocument = gql`
    mutation editProjectKeyCollectionContractor($input: EditProjectKeyCollectionContractorInput!) {
  editProjectKeyCollectionContractor(input: $input)
}
    `;
export type EditProjectKeyCollectionContractorMutationFn = Apollo.MutationFunction<EditProjectKeyCollectionContractorMutation, EditProjectKeyCollectionContractorMutationVariables>;

/**
 * __useEditProjectKeyCollectionContractorMutation__
 *
 * To run a mutation, you first call `useEditProjectKeyCollectionContractorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditProjectKeyCollectionContractorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editProjectKeyCollectionContractorMutation, { data, loading, error }] = useEditProjectKeyCollectionContractorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditProjectKeyCollectionContractorMutation(baseOptions?: Apollo.MutationHookOptions<EditProjectKeyCollectionContractorMutation, EditProjectKeyCollectionContractorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditProjectKeyCollectionContractorMutation, EditProjectKeyCollectionContractorMutationVariables>(EditProjectKeyCollectionContractorDocument, options);
      }
export type EditProjectKeyCollectionContractorMutationHookResult = ReturnType<typeof useEditProjectKeyCollectionContractorMutation>;
export type EditProjectKeyCollectionContractorMutationResult = Apollo.MutationResult<EditProjectKeyCollectionContractorMutation>;
export type EditProjectKeyCollectionContractorMutationOptions = Apollo.BaseMutationOptions<EditProjectKeyCollectionContractorMutation, EditProjectKeyCollectionContractorMutationVariables>;
export const DeleteProjectKeyCollectionContractorByIdDocument = gql`
    mutation deleteProjectKeyCollectionContractorById($id: String!) {
  deleteProjectKeyCollectionContractorById(id: $id)
}
    `;
export type DeleteProjectKeyCollectionContractorByIdMutationFn = Apollo.MutationFunction<DeleteProjectKeyCollectionContractorByIdMutation, DeleteProjectKeyCollectionContractorByIdMutationVariables>;

/**
 * __useDeleteProjectKeyCollectionContractorByIdMutation__
 *
 * To run a mutation, you first call `useDeleteProjectKeyCollectionContractorByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectKeyCollectionContractorByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectKeyCollectionContractorByIdMutation, { data, loading, error }] = useDeleteProjectKeyCollectionContractorByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProjectKeyCollectionContractorByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectKeyCollectionContractorByIdMutation, DeleteProjectKeyCollectionContractorByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectKeyCollectionContractorByIdMutation, DeleteProjectKeyCollectionContractorByIdMutationVariables>(DeleteProjectKeyCollectionContractorByIdDocument, options);
      }
export type DeleteProjectKeyCollectionContractorByIdMutationHookResult = ReturnType<typeof useDeleteProjectKeyCollectionContractorByIdMutation>;
export type DeleteProjectKeyCollectionContractorByIdMutationResult = Apollo.MutationResult<DeleteProjectKeyCollectionContractorByIdMutation>;
export type DeleteProjectKeyCollectionContractorByIdMutationOptions = Apollo.BaseMutationOptions<DeleteProjectKeyCollectionContractorByIdMutation, DeleteProjectKeyCollectionContractorByIdMutationVariables>;
export const GetKeyCollectionContractorTypeDocument = gql`
    query getKeyCollectionContractorType {
  getKeyCollectionContractorType
}
    `;

/**
 * __useGetKeyCollectionContractorTypeQuery__
 *
 * To run a query within a React component, call `useGetKeyCollectionContractorTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKeyCollectionContractorTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKeyCollectionContractorTypeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetKeyCollectionContractorTypeQuery(baseOptions?: Apollo.QueryHookOptions<GetKeyCollectionContractorTypeQuery, GetKeyCollectionContractorTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetKeyCollectionContractorTypeQuery, GetKeyCollectionContractorTypeQueryVariables>(GetKeyCollectionContractorTypeDocument, options);
      }
export function useGetKeyCollectionContractorTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetKeyCollectionContractorTypeQuery, GetKeyCollectionContractorTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetKeyCollectionContractorTypeQuery, GetKeyCollectionContractorTypeQueryVariables>(GetKeyCollectionContractorTypeDocument, options);
        }
export type GetKeyCollectionContractorTypeQueryHookResult = ReturnType<typeof useGetKeyCollectionContractorTypeQuery>;
export type GetKeyCollectionContractorTypeLazyQueryHookResult = ReturnType<typeof useGetKeyCollectionContractorTypeLazyQuery>;
export type GetKeyCollectionContractorTypeQueryResult = Apollo.QueryResult<GetKeyCollectionContractorTypeQuery, GetKeyCollectionContractorTypeQueryVariables>;
export const GetAllProjectKeyCollectionScheduleDocument = gql`
    query getAllProjectKeyCollectionSchedule {
  getAllProjectKeyCollectionSchedule {
    projectId
    id
    accountId
    startDate
    endDate
    startTime
    endTime
    interval
    isDeletable
  }
}
    `;

/**
 * __useGetAllProjectKeyCollectionScheduleQuery__
 *
 * To run a query within a React component, call `useGetAllProjectKeyCollectionScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllProjectKeyCollectionScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllProjectKeyCollectionScheduleQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllProjectKeyCollectionScheduleQuery(baseOptions?: Apollo.QueryHookOptions<GetAllProjectKeyCollectionScheduleQuery, GetAllProjectKeyCollectionScheduleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllProjectKeyCollectionScheduleQuery, GetAllProjectKeyCollectionScheduleQueryVariables>(GetAllProjectKeyCollectionScheduleDocument, options);
      }
export function useGetAllProjectKeyCollectionScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllProjectKeyCollectionScheduleQuery, GetAllProjectKeyCollectionScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllProjectKeyCollectionScheduleQuery, GetAllProjectKeyCollectionScheduleQueryVariables>(GetAllProjectKeyCollectionScheduleDocument, options);
        }
export type GetAllProjectKeyCollectionScheduleQueryHookResult = ReturnType<typeof useGetAllProjectKeyCollectionScheduleQuery>;
export type GetAllProjectKeyCollectionScheduleLazyQueryHookResult = ReturnType<typeof useGetAllProjectKeyCollectionScheduleLazyQuery>;
export type GetAllProjectKeyCollectionScheduleQueryResult = Apollo.QueryResult<GetAllProjectKeyCollectionScheduleQuery, GetAllProjectKeyCollectionScheduleQueryVariables>;
export const AddProjectKeyCollectionScheduleDocument = gql`
    mutation addProjectKeyCollectionSchedule($input: projectKeyCollectionInput!) {
  addProjectKeyCollectionSchedule(input: $input)
}
    `;
export type AddProjectKeyCollectionScheduleMutationFn = Apollo.MutationFunction<AddProjectKeyCollectionScheduleMutation, AddProjectKeyCollectionScheduleMutationVariables>;

/**
 * __useAddProjectKeyCollectionScheduleMutation__
 *
 * To run a mutation, you first call `useAddProjectKeyCollectionScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProjectKeyCollectionScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProjectKeyCollectionScheduleMutation, { data, loading, error }] = useAddProjectKeyCollectionScheduleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddProjectKeyCollectionScheduleMutation(baseOptions?: Apollo.MutationHookOptions<AddProjectKeyCollectionScheduleMutation, AddProjectKeyCollectionScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProjectKeyCollectionScheduleMutation, AddProjectKeyCollectionScheduleMutationVariables>(AddProjectKeyCollectionScheduleDocument, options);
      }
export type AddProjectKeyCollectionScheduleMutationHookResult = ReturnType<typeof useAddProjectKeyCollectionScheduleMutation>;
export type AddProjectKeyCollectionScheduleMutationResult = Apollo.MutationResult<AddProjectKeyCollectionScheduleMutation>;
export type AddProjectKeyCollectionScheduleMutationOptions = Apollo.BaseMutationOptions<AddProjectKeyCollectionScheduleMutation, AddProjectKeyCollectionScheduleMutationVariables>;
export const DeleteProjectKeyCollectionScheduleDocument = gql`
    mutation deleteProjectKeyCollectionSchedule($collectionKeyScheduleID: String!) {
  deleteProjectKeyCollectionSchedule(collectionKeyScheduleID: $collectionKeyScheduleID)
}
    `;
export type DeleteProjectKeyCollectionScheduleMutationFn = Apollo.MutationFunction<DeleteProjectKeyCollectionScheduleMutation, DeleteProjectKeyCollectionScheduleMutationVariables>;

/**
 * __useDeleteProjectKeyCollectionScheduleMutation__
 *
 * To run a mutation, you first call `useDeleteProjectKeyCollectionScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectKeyCollectionScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectKeyCollectionScheduleMutation, { data, loading, error }] = useDeleteProjectKeyCollectionScheduleMutation({
 *   variables: {
 *      collectionKeyScheduleID: // value for 'collectionKeyScheduleID'
 *   },
 * });
 */
export function useDeleteProjectKeyCollectionScheduleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectKeyCollectionScheduleMutation, DeleteProjectKeyCollectionScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectKeyCollectionScheduleMutation, DeleteProjectKeyCollectionScheduleMutationVariables>(DeleteProjectKeyCollectionScheduleDocument, options);
      }
export type DeleteProjectKeyCollectionScheduleMutationHookResult = ReturnType<typeof useDeleteProjectKeyCollectionScheduleMutation>;
export type DeleteProjectKeyCollectionScheduleMutationResult = Apollo.MutationResult<DeleteProjectKeyCollectionScheduleMutation>;
export type DeleteProjectKeyCollectionScheduleMutationOptions = Apollo.BaseMutationOptions<DeleteProjectKeyCollectionScheduleMutation, DeleteProjectKeyCollectionScheduleMutationVariables>;
export const GetKeyCollectionSettingSummaryDocument = gql`
    query getKeyCollectionSettingSummary {
  keyCollectionContractorLastUpdate
  keyCollectionScheduleLastUpdate
  keyCollectionAppointmentLastUpdate
}
    `;

/**
 * __useGetKeyCollectionSettingSummaryQuery__
 *
 * To run a query within a React component, call `useGetKeyCollectionSettingSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKeyCollectionSettingSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKeyCollectionSettingSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetKeyCollectionSettingSummaryQuery(baseOptions?: Apollo.QueryHookOptions<GetKeyCollectionSettingSummaryQuery, GetKeyCollectionSettingSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetKeyCollectionSettingSummaryQuery, GetKeyCollectionSettingSummaryQueryVariables>(GetKeyCollectionSettingSummaryDocument, options);
      }
export function useGetKeyCollectionSettingSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetKeyCollectionSettingSummaryQuery, GetKeyCollectionSettingSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetKeyCollectionSettingSummaryQuery, GetKeyCollectionSettingSummaryQueryVariables>(GetKeyCollectionSettingSummaryDocument, options);
        }
export type GetKeyCollectionSettingSummaryQueryHookResult = ReturnType<typeof useGetKeyCollectionSettingSummaryQuery>;
export type GetKeyCollectionSettingSummaryLazyQueryHookResult = ReturnType<typeof useGetKeyCollectionSettingSummaryLazyQuery>;
export type GetKeyCollectionSettingSummaryQueryResult = Apollo.QueryResult<GetKeyCollectionSettingSummaryQuery, GetKeyCollectionSettingSummaryQueryVariables>;
export const GetDateByScheduleIdDocument = gql`
    query getDateByScheduleId($id: String!) {
  getDateByScheduleId(id: $id) {
    teamMember {
      id
      name
    }
    dateList
    startDate
    endDate
    startTime
    endTime
  }
}
    `;

/**
 * __useGetDateByScheduleIdQuery__
 *
 * To run a query within a React component, call `useGetDateByScheduleIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDateByScheduleIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDateByScheduleIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDateByScheduleIdQuery(baseOptions: Apollo.QueryHookOptions<GetDateByScheduleIdQuery, GetDateByScheduleIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDateByScheduleIdQuery, GetDateByScheduleIdQueryVariables>(GetDateByScheduleIdDocument, options);
      }
export function useGetDateByScheduleIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDateByScheduleIdQuery, GetDateByScheduleIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDateByScheduleIdQuery, GetDateByScheduleIdQueryVariables>(GetDateByScheduleIdDocument, options);
        }
export type GetDateByScheduleIdQueryHookResult = ReturnType<typeof useGetDateByScheduleIdQuery>;
export type GetDateByScheduleIdLazyQueryHookResult = ReturnType<typeof useGetDateByScheduleIdLazyQuery>;
export type GetDateByScheduleIdQueryResult = Apollo.QueryResult<GetDateByScheduleIdQuery, GetDateByScheduleIdQueryVariables>;
export const GetProjectKeyCollectionScheduleByIdDocument = gql`
    query getProjectKeyCollectionScheduleByID($date: DateTime!, $id: String!) {
  getProjectKeyCollectionScheduleByID(date: $date, id: $id) {
    scheduleTime
    timeSlotDetail {
      id
      userId
      available
    }
  }
}
    `;

/**
 * __useGetProjectKeyCollectionScheduleByIdQuery__
 *
 * To run a query within a React component, call `useGetProjectKeyCollectionScheduleByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectKeyCollectionScheduleByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectKeyCollectionScheduleByIdQuery({
 *   variables: {
 *      date: // value for 'date'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectKeyCollectionScheduleByIdQuery(baseOptions: Apollo.QueryHookOptions<GetProjectKeyCollectionScheduleByIdQuery, GetProjectKeyCollectionScheduleByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectKeyCollectionScheduleByIdQuery, GetProjectKeyCollectionScheduleByIdQueryVariables>(GetProjectKeyCollectionScheduleByIdDocument, options);
      }
export function useGetProjectKeyCollectionScheduleByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectKeyCollectionScheduleByIdQuery, GetProjectKeyCollectionScheduleByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectKeyCollectionScheduleByIdQuery, GetProjectKeyCollectionScheduleByIdQueryVariables>(GetProjectKeyCollectionScheduleByIdDocument, options);
        }
export type GetProjectKeyCollectionScheduleByIdQueryHookResult = ReturnType<typeof useGetProjectKeyCollectionScheduleByIdQuery>;
export type GetProjectKeyCollectionScheduleByIdLazyQueryHookResult = ReturnType<typeof useGetProjectKeyCollectionScheduleByIdLazyQuery>;
export type GetProjectKeyCollectionScheduleByIdQueryResult = Apollo.QueryResult<GetProjectKeyCollectionScheduleByIdQuery, GetProjectKeyCollectionScheduleByIdQueryVariables>;
export const GetAllLadDocument = gql`
    query getAllLad {
  getAllLad {
    generationBatchDate
    generationBatchId
    totalUnitAndFacilityAmount
    unitsByBatchCount
    unitLadAmount
    isSimulate
    facilityLadAmount
  }
}
    `;

/**
 * __useGetAllLadQuery__
 *
 * To run a query within a React component, call `useGetAllLadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllLadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllLadQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllLadQuery(baseOptions?: Apollo.QueryHookOptions<GetAllLadQuery, GetAllLadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllLadQuery, GetAllLadQueryVariables>(GetAllLadDocument, options);
      }
export function useGetAllLadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllLadQuery, GetAllLadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllLadQuery, GetAllLadQueryVariables>(GetAllLadDocument, options);
        }
export type GetAllLadQueryHookResult = ReturnType<typeof useGetAllLadQuery>;
export type GetAllLadLazyQueryHookResult = ReturnType<typeof useGetAllLadLazyQuery>;
export type GetAllLadQueryResult = Apollo.QueryResult<GetAllLadQuery, GetAllLadQueryVariables>;
export const GetUnitsLadFormSourceDocument = gql`
    query getUnitsLadFormSource {
  getUnitsLadFormSource {
    block
    totalFloor
    floorList {
      floorLabel
      totalUnit
      unitList {
        unitId
        unitNo
      }
    }
  }
}
    `;

/**
 * __useGetUnitsLadFormSourceQuery__
 *
 * To run a query within a React component, call `useGetUnitsLadFormSourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitsLadFormSourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitsLadFormSourceQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUnitsLadFormSourceQuery(baseOptions?: Apollo.QueryHookOptions<GetUnitsLadFormSourceQuery, GetUnitsLadFormSourceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitsLadFormSourceQuery, GetUnitsLadFormSourceQueryVariables>(GetUnitsLadFormSourceDocument, options);
      }
export function useGetUnitsLadFormSourceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitsLadFormSourceQuery, GetUnitsLadFormSourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitsLadFormSourceQuery, GetUnitsLadFormSourceQueryVariables>(GetUnitsLadFormSourceDocument, options);
        }
export type GetUnitsLadFormSourceQueryHookResult = ReturnType<typeof useGetUnitsLadFormSourceQuery>;
export type GetUnitsLadFormSourceLazyQueryHookResult = ReturnType<typeof useGetUnitsLadFormSourceLazyQuery>;
export type GetUnitsLadFormSourceQueryResult = Apollo.QueryResult<GetUnitsLadFormSourceQuery, GetUnitsLadFormSourceQueryVariables>;
export const GetPostedLadDetailByIdDocument = gql`
    query getPostedLadDetailById($generationBatch: String!) {
  getPostedLadDetailById(generationBatch: $generationBatch) {
    totalUnit
    totalUnitLadAmount
    totalFacilityLadAmount
    totalAllUnitFacilityAmount
    generationBatchDate
    LADDetailListing {
      saleId
      unitId
      unitNo
      ladId
      unitDuesDay
      facilityDuesDay
      actualUnitLADAmount
      actualFacilityLADAmount
      totalUnitFacilityAmount
      contraId
      isAllocated
      documentNo
    }
  }
}
    `;

/**
 * __useGetPostedLadDetailByIdQuery__
 *
 * To run a query within a React component, call `useGetPostedLadDetailByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostedLadDetailByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostedLadDetailByIdQuery({
 *   variables: {
 *      generationBatch: // value for 'generationBatch'
 *   },
 * });
 */
export function useGetPostedLadDetailByIdQuery(baseOptions: Apollo.QueryHookOptions<GetPostedLadDetailByIdQuery, GetPostedLadDetailByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostedLadDetailByIdQuery, GetPostedLadDetailByIdQueryVariables>(GetPostedLadDetailByIdDocument, options);
      }
export function useGetPostedLadDetailByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostedLadDetailByIdQuery, GetPostedLadDetailByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostedLadDetailByIdQuery, GetPostedLadDetailByIdQueryVariables>(GetPostedLadDetailByIdDocument, options);
        }
export type GetPostedLadDetailByIdQueryHookResult = ReturnType<typeof useGetPostedLadDetailByIdQuery>;
export type GetPostedLadDetailByIdLazyQueryHookResult = ReturnType<typeof useGetPostedLadDetailByIdLazyQuery>;
export type GetPostedLadDetailByIdQueryResult = Apollo.QueryResult<GetPostedLadDetailByIdQuery, GetPostedLadDetailByIdQueryVariables>;
export const GetSimulatedLadDetailByIdDocument = gql`
    query getSimulatedLadDetailById($generationBatch: String!) {
  getSimulatedLadDetailById(generationBatch: $generationBatch) {
    totalUnit
    totalUnitLadAmount
    totalFacilityLadAmount
    totalAllUnitFacilityAmount
    generationBatchDate
    LADDetailListing {
      saleId
      unitId
      unitNo
      unitDuesDay
      facilityDuesDay
      actualUnitLADAmount
      actualFacilityLADAmount
      totalUnitFacilityAmount
    }
  }
}
    `;

/**
 * __useGetSimulatedLadDetailByIdQuery__
 *
 * To run a query within a React component, call `useGetSimulatedLadDetailByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSimulatedLadDetailByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSimulatedLadDetailByIdQuery({
 *   variables: {
 *      generationBatch: // value for 'generationBatch'
 *   },
 * });
 */
export function useGetSimulatedLadDetailByIdQuery(baseOptions: Apollo.QueryHookOptions<GetSimulatedLadDetailByIdQuery, GetSimulatedLadDetailByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSimulatedLadDetailByIdQuery, GetSimulatedLadDetailByIdQueryVariables>(GetSimulatedLadDetailByIdDocument, options);
      }
export function useGetSimulatedLadDetailByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSimulatedLadDetailByIdQuery, GetSimulatedLadDetailByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSimulatedLadDetailByIdQuery, GetSimulatedLadDetailByIdQueryVariables>(GetSimulatedLadDetailByIdDocument, options);
        }
export type GetSimulatedLadDetailByIdQueryHookResult = ReturnType<typeof useGetSimulatedLadDetailByIdQuery>;
export type GetSimulatedLadDetailByIdLazyQueryHookResult = ReturnType<typeof useGetSimulatedLadDetailByIdLazyQuery>;
export type GetSimulatedLadDetailByIdQueryResult = Apollo.QueryResult<GetSimulatedLadDetailByIdQuery, GetSimulatedLadDetailByIdQueryVariables>;
export const AddLadDocument = gql`
    mutation addLad($input: AddLadInput!) {
  addLad(input: $input)
}
    `;
export type AddLadMutationFn = Apollo.MutationFunction<AddLadMutation, AddLadMutationVariables>;

/**
 * __useAddLadMutation__
 *
 * To run a mutation, you first call `useAddLadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLadMutation, { data, loading, error }] = useAddLadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddLadMutation(baseOptions?: Apollo.MutationHookOptions<AddLadMutation, AddLadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddLadMutation, AddLadMutationVariables>(AddLadDocument, options);
      }
export type AddLadMutationHookResult = ReturnType<typeof useAddLadMutation>;
export type AddLadMutationResult = Apollo.MutationResult<AddLadMutation>;
export type AddLadMutationOptions = Apollo.BaseMutationOptions<AddLadMutation, AddLadMutationVariables>;
export const DeleteLadDocument = gql`
    mutation deleteLad($ladId: String!) {
  deleteLad(ladId: $ladId)
}
    `;
export type DeleteLadMutationFn = Apollo.MutationFunction<DeleteLadMutation, DeleteLadMutationVariables>;

/**
 * __useDeleteLadMutation__
 *
 * To run a mutation, you first call `useDeleteLadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLadMutation, { data, loading, error }] = useDeleteLadMutation({
 *   variables: {
 *      ladId: // value for 'ladId'
 *   },
 * });
 */
export function useDeleteLadMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLadMutation, DeleteLadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLadMutation, DeleteLadMutationVariables>(DeleteLadDocument, options);
      }
export type DeleteLadMutationHookResult = ReturnType<typeof useDeleteLadMutation>;
export type DeleteLadMutationResult = Apollo.MutationResult<DeleteLadMutation>;
export type DeleteLadMutationOptions = Apollo.BaseMutationOptions<DeleteLadMutation, DeleteLadMutationVariables>;
export const ReversalLadDocument = gql`
    mutation reversalLad($input: reversalLadInput!) {
  reversalLad(input: $input)
}
    `;
export type ReversalLadMutationFn = Apollo.MutationFunction<ReversalLadMutation, ReversalLadMutationVariables>;

/**
 * __useReversalLadMutation__
 *
 * To run a mutation, you first call `useReversalLadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReversalLadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reversalLadMutation, { data, loading, error }] = useReversalLadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReversalLadMutation(baseOptions?: Apollo.MutationHookOptions<ReversalLadMutation, ReversalLadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReversalLadMutation, ReversalLadMutationVariables>(ReversalLadDocument, options);
      }
export type ReversalLadMutationHookResult = ReturnType<typeof useReversalLadMutation>;
export type ReversalLadMutationResult = Apollo.MutationResult<ReversalLadMutation>;
export type ReversalLadMutationOptions = Apollo.BaseMutationOptions<ReversalLadMutation, ReversalLadMutationVariables>;
export const CalculateLadGenerateValueDocument = gql`
    query calculateLADGenerateValue($input: calculateLADGenerateValueInput!) {
  calculateLADGenerateValue(input: $input) {
    totalUnit
    totalUnitLadAmount
    totalAllUnitFacilityAmount
    totalFacilityLadAmount
    LADGenerateListing {
      saleId
      unitId
      unitNo
      actualUnitLADAmount
      unitDuesDay
      facilityDuesDay
      actualFacilityLADAmount
      totalUnitFacilityAmount
      totalUnitFacilityAmountWithoutTax
      totalTaxAmount
    }
  }
}
    `;

/**
 * __useCalculateLadGenerateValueQuery__
 *
 * To run a query within a React component, call `useCalculateLadGenerateValueQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalculateLadGenerateValueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalculateLadGenerateValueQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCalculateLadGenerateValueQuery(baseOptions: Apollo.QueryHookOptions<CalculateLadGenerateValueQuery, CalculateLadGenerateValueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalculateLadGenerateValueQuery, CalculateLadGenerateValueQueryVariables>(CalculateLadGenerateValueDocument, options);
      }
export function useCalculateLadGenerateValueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalculateLadGenerateValueQuery, CalculateLadGenerateValueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalculateLadGenerateValueQuery, CalculateLadGenerateValueQueryVariables>(CalculateLadGenerateValueDocument, options);
        }
export type CalculateLadGenerateValueQueryHookResult = ReturnType<typeof useCalculateLadGenerateValueQuery>;
export type CalculateLadGenerateValueLazyQueryHookResult = ReturnType<typeof useCalculateLadGenerateValueLazyQuery>;
export type CalculateLadGenerateValueQueryResult = Apollo.QueryResult<CalculateLadGenerateValueQuery, CalculateLadGenerateValueQueryVariables>;
export const GetProjectLadByProjectIdDocument = gql`
    query getProjectLadByProjectId {
  getProjectLadByProjectId {
    id
    accountId
    projectId
    startWith
    unitLadPercent
    unitDuration
    payoutPercent
    spaPercent
    commonFacility
    facilityLadPercent
    facilityLadDuration
    taxSchemeId
    commonStatus
  }
}
    `;

/**
 * __useGetProjectLadByProjectIdQuery__
 *
 * To run a query within a React component, call `useGetProjectLadByProjectIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectLadByProjectIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectLadByProjectIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProjectLadByProjectIdQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectLadByProjectIdQuery, GetProjectLadByProjectIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectLadByProjectIdQuery, GetProjectLadByProjectIdQueryVariables>(GetProjectLadByProjectIdDocument, options);
      }
export function useGetProjectLadByProjectIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectLadByProjectIdQuery, GetProjectLadByProjectIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectLadByProjectIdQuery, GetProjectLadByProjectIdQueryVariables>(GetProjectLadByProjectIdDocument, options);
        }
export type GetProjectLadByProjectIdQueryHookResult = ReturnType<typeof useGetProjectLadByProjectIdQuery>;
export type GetProjectLadByProjectIdLazyQueryHookResult = ReturnType<typeof useGetProjectLadByProjectIdLazyQuery>;
export type GetProjectLadByProjectIdQueryResult = Apollo.QueryResult<GetProjectLadByProjectIdQuery, GetProjectLadByProjectIdQueryVariables>;
export const AddProjectLadDocument = gql`
    mutation addProjectLad($input: projectLadInput!) {
  addProjectLad(input: $input)
}
    `;
export type AddProjectLadMutationFn = Apollo.MutationFunction<AddProjectLadMutation, AddProjectLadMutationVariables>;

/**
 * __useAddProjectLadMutation__
 *
 * To run a mutation, you first call `useAddProjectLadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProjectLadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProjectLadMutation, { data, loading, error }] = useAddProjectLadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddProjectLadMutation(baseOptions?: Apollo.MutationHookOptions<AddProjectLadMutation, AddProjectLadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProjectLadMutation, AddProjectLadMutationVariables>(AddProjectLadDocument, options);
      }
export type AddProjectLadMutationHookResult = ReturnType<typeof useAddProjectLadMutation>;
export type AddProjectLadMutationResult = Apollo.MutationResult<AddProjectLadMutation>;
export type AddProjectLadMutationOptions = Apollo.BaseMutationOptions<AddProjectLadMutation, AddProjectLadMutationVariables>;
export const EditProjectLadDocument = gql`
    mutation editProjectLad($input: EditProjectLadInput!) {
  editProjectLad(input: $input)
}
    `;
export type EditProjectLadMutationFn = Apollo.MutationFunction<EditProjectLadMutation, EditProjectLadMutationVariables>;

/**
 * __useEditProjectLadMutation__
 *
 * To run a mutation, you first call `useEditProjectLadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditProjectLadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editProjectLadMutation, { data, loading, error }] = useEditProjectLadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditProjectLadMutation(baseOptions?: Apollo.MutationHookOptions<EditProjectLadMutation, EditProjectLadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditProjectLadMutation, EditProjectLadMutationVariables>(EditProjectLadDocument, options);
      }
export type EditProjectLadMutationHookResult = ReturnType<typeof useEditProjectLadMutation>;
export type EditProjectLadMutationResult = Apollo.MutationResult<EditProjectLadMutation>;
export type EditProjectLadMutationOptions = Apollo.BaseMutationOptions<EditProjectLadMutation, EditProjectLadMutationVariables>;
export const GetLadSettingSummaryDocument = gql`
    query getLadSettingSummary {
  ladSettingLastUpdate
  projectLadLastUpdate
  ladProcessingCount
}
    `;

/**
 * __useGetLadSettingSummaryQuery__
 *
 * To run a query within a React component, call `useGetLadSettingSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLadSettingSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLadSettingSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLadSettingSummaryQuery(baseOptions?: Apollo.QueryHookOptions<GetLadSettingSummaryQuery, GetLadSettingSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLadSettingSummaryQuery, GetLadSettingSummaryQueryVariables>(GetLadSettingSummaryDocument, options);
      }
export function useGetLadSettingSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLadSettingSummaryQuery, GetLadSettingSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLadSettingSummaryQuery, GetLadSettingSummaryQueryVariables>(GetLadSettingSummaryDocument, options);
        }
export type GetLadSettingSummaryQueryHookResult = ReturnType<typeof useGetLadSettingSummaryQuery>;
export type GetLadSettingSummaryLazyQueryHookResult = ReturnType<typeof useGetLadSettingSummaryLazyQuery>;
export type GetLadSettingSummaryQueryResult = Apollo.QueryResult<GetLadSettingSummaryQuery, GetLadSettingSummaryQueryVariables>;
export const GetLandDepositListingByProjectDocument = gql`
    query getLandDepositListingByProject($projectId: String!) {
  getLandDepositListingByProject(projectId: $projectId) {
    saleDate
    saleNo
    unitNo
    purchaserName
    ujpPaidAmt
    ujppPaidAmt
    ujpTotalAmt
    ujppTotalAmt
    ujpBillingAmt
    ujppBillingAmt
    paidCounter
    salePrice
    saleId
  }
}
    `;

/**
 * __useGetLandDepositListingByProjectQuery__
 *
 * To run a query within a React component, call `useGetLandDepositListingByProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLandDepositListingByProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLandDepositListingByProjectQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetLandDepositListingByProjectQuery(baseOptions: Apollo.QueryHookOptions<GetLandDepositListingByProjectQuery, GetLandDepositListingByProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLandDepositListingByProjectQuery, GetLandDepositListingByProjectQueryVariables>(GetLandDepositListingByProjectDocument, options);
      }
export function useGetLandDepositListingByProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLandDepositListingByProjectQuery, GetLandDepositListingByProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLandDepositListingByProjectQuery, GetLandDepositListingByProjectQueryVariables>(GetLandDepositListingByProjectDocument, options);
        }
export type GetLandDepositListingByProjectQueryHookResult = ReturnType<typeof useGetLandDepositListingByProjectQuery>;
export type GetLandDepositListingByProjectLazyQueryHookResult = ReturnType<typeof useGetLandDepositListingByProjectLazyQuery>;
export type GetLandDepositListingByProjectQueryResult = Apollo.QueryResult<GetLandDepositListingByProjectQuery, GetLandDepositListingByProjectQueryVariables>;
export const GetPaidLandDepositsListingBySaleDocument = gql`
    query getPaidLandDepositsListingBySale($saleId: String!) {
  getLandDepositBySale(saleId: $saleId) {
    saleDate
    saleNo
    unitNo
    purchaserName
    ujpPaidAmt
    ujppPaidAmt
    ujpTotalAmt
    ujpBillingAmt
    ujppBillingAmt
    ujppCurrentOutstanding
    ujpCurrentOutstanding
    ujppTotalAmt
    paidCounter
    salePrice
  }
  getPaidLandDepositsListingBySale(saleId: $saleId) {
    id
    depositDate
    depositType
    depositAmount
  }
}
    `;

/**
 * __useGetPaidLandDepositsListingBySaleQuery__
 *
 * To run a query within a React component, call `useGetPaidLandDepositsListingBySaleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaidLandDepositsListingBySaleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaidLandDepositsListingBySaleQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetPaidLandDepositsListingBySaleQuery(baseOptions: Apollo.QueryHookOptions<GetPaidLandDepositsListingBySaleQuery, GetPaidLandDepositsListingBySaleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaidLandDepositsListingBySaleQuery, GetPaidLandDepositsListingBySaleQueryVariables>(GetPaidLandDepositsListingBySaleDocument, options);
      }
export function useGetPaidLandDepositsListingBySaleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaidLandDepositsListingBySaleQuery, GetPaidLandDepositsListingBySaleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaidLandDepositsListingBySaleQuery, GetPaidLandDepositsListingBySaleQueryVariables>(GetPaidLandDepositsListingBySaleDocument, options);
        }
export type GetPaidLandDepositsListingBySaleQueryHookResult = ReturnType<typeof useGetPaidLandDepositsListingBySaleQuery>;
export type GetPaidLandDepositsListingBySaleLazyQueryHookResult = ReturnType<typeof useGetPaidLandDepositsListingBySaleLazyQuery>;
export type GetPaidLandDepositsListingBySaleQueryResult = Apollo.QueryResult<GetPaidLandDepositsListingBySaleQuery, GetPaidLandDepositsListingBySaleQueryVariables>;
export const GetPaidLandDepositByIdDocument = gql`
    query getPaidLandDepositById($id: String, $saleId: String!) {
  getLandDepositBySale(saleId: $saleId) {
    saleDate
    saleNo
    unitNo
    purchaserName
    ujpPaidAmt
    ujppPaidAmt
    ujpBillingAmt
    ujppBillingAmt
    paidCounter
    salePrice
  }
  getPaidLandDepositById(id: $id) {
    id
    depositType
    depositAmount
    documentNo
    paymentMethod
    bankName
    description
    depositDate
  }
}
    `;

/**
 * __useGetPaidLandDepositByIdQuery__
 *
 * To run a query within a React component, call `useGetPaidLandDepositByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaidLandDepositByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaidLandDepositByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetPaidLandDepositByIdQuery(baseOptions: Apollo.QueryHookOptions<GetPaidLandDepositByIdQuery, GetPaidLandDepositByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaidLandDepositByIdQuery, GetPaidLandDepositByIdQueryVariables>(GetPaidLandDepositByIdDocument, options);
      }
export function useGetPaidLandDepositByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaidLandDepositByIdQuery, GetPaidLandDepositByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaidLandDepositByIdQuery, GetPaidLandDepositByIdQueryVariables>(GetPaidLandDepositByIdDocument, options);
        }
export type GetPaidLandDepositByIdQueryHookResult = ReturnType<typeof useGetPaidLandDepositByIdQuery>;
export type GetPaidLandDepositByIdLazyQueryHookResult = ReturnType<typeof useGetPaidLandDepositByIdLazyQuery>;
export type GetPaidLandDepositByIdQueryResult = Apollo.QueryResult<GetPaidLandDepositByIdQuery, GetPaidLandDepositByIdQueryVariables>;
export const GetLandDepositFormMasterDataDocument = gql`
    query getLandDepositFormMasterData($projectId: String!) {
  getLandDepositFormMasterData(projectId: $projectId)
}
    `;

/**
 * __useGetLandDepositFormMasterDataQuery__
 *
 * To run a query within a React component, call `useGetLandDepositFormMasterDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLandDepositFormMasterDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLandDepositFormMasterDataQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetLandDepositFormMasterDataQuery(baseOptions: Apollo.QueryHookOptions<GetLandDepositFormMasterDataQuery, GetLandDepositFormMasterDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLandDepositFormMasterDataQuery, GetLandDepositFormMasterDataQueryVariables>(GetLandDepositFormMasterDataDocument, options);
      }
export function useGetLandDepositFormMasterDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLandDepositFormMasterDataQuery, GetLandDepositFormMasterDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLandDepositFormMasterDataQuery, GetLandDepositFormMasterDataQueryVariables>(GetLandDepositFormMasterDataDocument, options);
        }
export type GetLandDepositFormMasterDataQueryHookResult = ReturnType<typeof useGetLandDepositFormMasterDataQuery>;
export type GetLandDepositFormMasterDataLazyQueryHookResult = ReturnType<typeof useGetLandDepositFormMasterDataLazyQuery>;
export type GetLandDepositFormMasterDataQueryResult = Apollo.QueryResult<GetLandDepositFormMasterDataQuery, GetLandDepositFormMasterDataQueryVariables>;
export const GetLandDepositFormMasterDataByProjectDocument = gql`
    query getLandDepositFormMasterDataByProject($projectId: String!) {
  getLandDepositFormMasterDataByProject(projectId: $projectId)
}
    `;

/**
 * __useGetLandDepositFormMasterDataByProjectQuery__
 *
 * To run a query within a React component, call `useGetLandDepositFormMasterDataByProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLandDepositFormMasterDataByProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLandDepositFormMasterDataByProjectQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetLandDepositFormMasterDataByProjectQuery(baseOptions: Apollo.QueryHookOptions<GetLandDepositFormMasterDataByProjectQuery, GetLandDepositFormMasterDataByProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLandDepositFormMasterDataByProjectQuery, GetLandDepositFormMasterDataByProjectQueryVariables>(GetLandDepositFormMasterDataByProjectDocument, options);
      }
export function useGetLandDepositFormMasterDataByProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLandDepositFormMasterDataByProjectQuery, GetLandDepositFormMasterDataByProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLandDepositFormMasterDataByProjectQuery, GetLandDepositFormMasterDataByProjectQueryVariables>(GetLandDepositFormMasterDataByProjectDocument, options);
        }
export type GetLandDepositFormMasterDataByProjectQueryHookResult = ReturnType<typeof useGetLandDepositFormMasterDataByProjectQuery>;
export type GetLandDepositFormMasterDataByProjectLazyQueryHookResult = ReturnType<typeof useGetLandDepositFormMasterDataByProjectLazyQuery>;
export type GetLandDepositFormMasterDataByProjectQueryResult = Apollo.QueryResult<GetLandDepositFormMasterDataByProjectQuery, GetLandDepositFormMasterDataByProjectQueryVariables>;
export const CreatePaidLandDepositDocument = gql`
    mutation createPaidLandDeposit($input: PaidLandDepositInput!) {
  createPaidLandDeposit(input: $input)
}
    `;
export type CreatePaidLandDepositMutationFn = Apollo.MutationFunction<CreatePaidLandDepositMutation, CreatePaidLandDepositMutationVariables>;

/**
 * __useCreatePaidLandDepositMutation__
 *
 * To run a mutation, you first call `useCreatePaidLandDepositMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaidLandDepositMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaidLandDepositMutation, { data, loading, error }] = useCreatePaidLandDepositMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePaidLandDepositMutation(baseOptions?: Apollo.MutationHookOptions<CreatePaidLandDepositMutation, CreatePaidLandDepositMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePaidLandDepositMutation, CreatePaidLandDepositMutationVariables>(CreatePaidLandDepositDocument, options);
      }
export type CreatePaidLandDepositMutationHookResult = ReturnType<typeof useCreatePaidLandDepositMutation>;
export type CreatePaidLandDepositMutationResult = Apollo.MutationResult<CreatePaidLandDepositMutation>;
export type CreatePaidLandDepositMutationOptions = Apollo.BaseMutationOptions<CreatePaidLandDepositMutation, CreatePaidLandDepositMutationVariables>;
export const GetSaleLoanListingForIndoDocument = gql`
    query getSaleLoanListingForIndo($status: String, $keySearch: String, $projectId: String!) {
  getSaleLoanListingForIndo(status: $status, keySearch: $keySearch, projectId: $projectId) {
    id
    borrowerName
    loanSignDate
    saleLoanNo
    approvalStatus
    unitNo
    financier
    approvedPercentage
    applyAmount
    approvedAmount
  }
}
    `;

/**
 * __useGetSaleLoanListingForIndoQuery__
 *
 * To run a query within a React component, call `useGetSaleLoanListingForIndoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSaleLoanListingForIndoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSaleLoanListingForIndoQuery({
 *   variables: {
 *      status: // value for 'status'
 *      keySearch: // value for 'keySearch'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetSaleLoanListingForIndoQuery(baseOptions: Apollo.QueryHookOptions<GetSaleLoanListingForIndoQuery, GetSaleLoanListingForIndoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSaleLoanListingForIndoQuery, GetSaleLoanListingForIndoQueryVariables>(GetSaleLoanListingForIndoDocument, options);
      }
export function useGetSaleLoanListingForIndoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSaleLoanListingForIndoQuery, GetSaleLoanListingForIndoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSaleLoanListingForIndoQuery, GetSaleLoanListingForIndoQueryVariables>(GetSaleLoanListingForIndoDocument, options);
        }
export type GetSaleLoanListingForIndoQueryHookResult = ReturnType<typeof useGetSaleLoanListingForIndoQuery>;
export type GetSaleLoanListingForIndoLazyQueryHookResult = ReturnType<typeof useGetSaleLoanListingForIndoLazyQuery>;
export type GetSaleLoanListingForIndoQueryResult = Apollo.QueryResult<GetSaleLoanListingForIndoQuery, GetSaleLoanListingForIndoQueryVariables>;
export const GetLoanApplyUnitForLoanApprovalDocument = gql`
    query getLoanApplyUnitForLoanApproval($projectId: String!, $saleLoanID: String) {
  getLoanApplyUnitForLoanApproval(projectId: $projectId, saleLoanID: $saleLoanID) {
    saleId
    id
    unitNo
    fullName
    appliedAmt
  }
}
    `;

/**
 * __useGetLoanApplyUnitForLoanApprovalQuery__
 *
 * To run a query within a React component, call `useGetLoanApplyUnitForLoanApprovalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoanApplyUnitForLoanApprovalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoanApplyUnitForLoanApprovalQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      saleLoanID: // value for 'saleLoanID'
 *   },
 * });
 */
export function useGetLoanApplyUnitForLoanApprovalQuery(baseOptions: Apollo.QueryHookOptions<GetLoanApplyUnitForLoanApprovalQuery, GetLoanApplyUnitForLoanApprovalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoanApplyUnitForLoanApprovalQuery, GetLoanApplyUnitForLoanApprovalQueryVariables>(GetLoanApplyUnitForLoanApprovalDocument, options);
      }
export function useGetLoanApplyUnitForLoanApprovalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLoanApplyUnitForLoanApprovalQuery, GetLoanApplyUnitForLoanApprovalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoanApplyUnitForLoanApprovalQuery, GetLoanApplyUnitForLoanApprovalQueryVariables>(GetLoanApplyUnitForLoanApprovalDocument, options);
        }
export type GetLoanApplyUnitForLoanApprovalQueryHookResult = ReturnType<typeof useGetLoanApplyUnitForLoanApprovalQuery>;
export type GetLoanApplyUnitForLoanApprovalLazyQueryHookResult = ReturnType<typeof useGetLoanApplyUnitForLoanApprovalLazyQuery>;
export type GetLoanApplyUnitForLoanApprovalQueryResult = Apollo.QueryResult<GetLoanApplyUnitForLoanApprovalQuery, GetLoanApplyUnitForLoanApprovalQueryVariables>;
export const GetLoanApplyForLoanApprovalDocument = gql`
    query getLoanApplyForLoanApproval($unitId: String!) {
  getLoanApplyForLoanApproval(unitId: $unitId) {
    fullName
  }
}
    `;

/**
 * __useGetLoanApplyForLoanApprovalQuery__
 *
 * To run a query within a React component, call `useGetLoanApplyForLoanApprovalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoanApplyForLoanApprovalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoanApplyForLoanApprovalQuery({
 *   variables: {
 *      unitId: // value for 'unitId'
 *   },
 * });
 */
export function useGetLoanApplyForLoanApprovalQuery(baseOptions: Apollo.QueryHookOptions<GetLoanApplyForLoanApprovalQuery, GetLoanApplyForLoanApprovalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoanApplyForLoanApprovalQuery, GetLoanApplyForLoanApprovalQueryVariables>(GetLoanApplyForLoanApprovalDocument, options);
      }
export function useGetLoanApplyForLoanApprovalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLoanApplyForLoanApprovalQuery, GetLoanApplyForLoanApprovalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoanApplyForLoanApprovalQuery, GetLoanApplyForLoanApprovalQueryVariables>(GetLoanApplyForLoanApprovalDocument, options);
        }
export type GetLoanApplyForLoanApprovalQueryHookResult = ReturnType<typeof useGetLoanApplyForLoanApprovalQuery>;
export type GetLoanApplyForLoanApprovalLazyQueryHookResult = ReturnType<typeof useGetLoanApplyForLoanApprovalLazyQuery>;
export type GetLoanApplyForLoanApprovalQueryResult = Apollo.QueryResult<GetLoanApplyForLoanApprovalQuery, GetLoanApplyForLoanApprovalQueryVariables>;
export const GetEndFinancierForLoanApprovalDocument = gql`
    query getEndFinancierForLoanApproval($projectId: String!) {
  getEndFinancierForLoanApproval(projectId: $projectId) {
    id
    financierName
    financierBankId
  }
}
    `;

/**
 * __useGetEndFinancierForLoanApprovalQuery__
 *
 * To run a query within a React component, call `useGetEndFinancierForLoanApprovalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEndFinancierForLoanApprovalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEndFinancierForLoanApprovalQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetEndFinancierForLoanApprovalQuery(baseOptions: Apollo.QueryHookOptions<GetEndFinancierForLoanApprovalQuery, GetEndFinancierForLoanApprovalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEndFinancierForLoanApprovalQuery, GetEndFinancierForLoanApprovalQueryVariables>(GetEndFinancierForLoanApprovalDocument, options);
      }
export function useGetEndFinancierForLoanApprovalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEndFinancierForLoanApprovalQuery, GetEndFinancierForLoanApprovalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEndFinancierForLoanApprovalQuery, GetEndFinancierForLoanApprovalQueryVariables>(GetEndFinancierForLoanApprovalDocument, options);
        }
export type GetEndFinancierForLoanApprovalQueryHookResult = ReturnType<typeof useGetEndFinancierForLoanApprovalQuery>;
export type GetEndFinancierForLoanApprovalLazyQueryHookResult = ReturnType<typeof useGetEndFinancierForLoanApprovalLazyQuery>;
export type GetEndFinancierForLoanApprovalQueryResult = Apollo.QueryResult<GetEndFinancierForLoanApprovalQuery, GetEndFinancierForLoanApprovalQueryVariables>;
export const GetMortgagePlanFromFinancierIdDocument = gql`
    query getMortgagePlanFromFinancierId($financierId: String!) {
  getMortgagePlanFromFinancierId(financierId: $financierId) {
    id
    mortgagePlanName
  }
}
    `;

/**
 * __useGetMortgagePlanFromFinancierIdQuery__
 *
 * To run a query within a React component, call `useGetMortgagePlanFromFinancierIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMortgagePlanFromFinancierIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMortgagePlanFromFinancierIdQuery({
 *   variables: {
 *      financierId: // value for 'financierId'
 *   },
 * });
 */
export function useGetMortgagePlanFromFinancierIdQuery(baseOptions: Apollo.QueryHookOptions<GetMortgagePlanFromFinancierIdQuery, GetMortgagePlanFromFinancierIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMortgagePlanFromFinancierIdQuery, GetMortgagePlanFromFinancierIdQueryVariables>(GetMortgagePlanFromFinancierIdDocument, options);
      }
export function useGetMortgagePlanFromFinancierIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMortgagePlanFromFinancierIdQuery, GetMortgagePlanFromFinancierIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMortgagePlanFromFinancierIdQuery, GetMortgagePlanFromFinancierIdQueryVariables>(GetMortgagePlanFromFinancierIdDocument, options);
        }
export type GetMortgagePlanFromFinancierIdQueryHookResult = ReturnType<typeof useGetMortgagePlanFromFinancierIdQuery>;
export type GetMortgagePlanFromFinancierIdLazyQueryHookResult = ReturnType<typeof useGetMortgagePlanFromFinancierIdLazyQuery>;
export type GetMortgagePlanFromFinancierIdQueryResult = Apollo.QueryResult<GetMortgagePlanFromFinancierIdQuery, GetMortgagePlanFromFinancierIdQueryVariables>;
export const GetMortgagePaymentFromMortgagePlanIdDocument = gql`
    query getMortgagePaymentFromMortgagePlanId($mortgageId: String!) {
  getMortgagePaymentFromMortgagePlanId(mortgageId: $mortgageId) {
    id
    endfinancierMortgagePlanId
    mortgagePaymentName
    mortgagePercentage
    mortgageExpectedCount
    mortgageExpectedFreq
    mortgageExpectedFrom
    sumRetention
    retention {
      retentionId
      retentionName
      retentionValue
      retentionBy
      retentionExpectedCount
      retentionExpectedFreq
      retentionExpectedFrom
      endfinMortgagePaymentId
    }
  }
}
    `;

/**
 * __useGetMortgagePaymentFromMortgagePlanIdQuery__
 *
 * To run a query within a React component, call `useGetMortgagePaymentFromMortgagePlanIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMortgagePaymentFromMortgagePlanIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMortgagePaymentFromMortgagePlanIdQuery({
 *   variables: {
 *      mortgageId: // value for 'mortgageId'
 *   },
 * });
 */
export function useGetMortgagePaymentFromMortgagePlanIdQuery(baseOptions: Apollo.QueryHookOptions<GetMortgagePaymentFromMortgagePlanIdQuery, GetMortgagePaymentFromMortgagePlanIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMortgagePaymentFromMortgagePlanIdQuery, GetMortgagePaymentFromMortgagePlanIdQueryVariables>(GetMortgagePaymentFromMortgagePlanIdDocument, options);
      }
export function useGetMortgagePaymentFromMortgagePlanIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMortgagePaymentFromMortgagePlanIdQuery, GetMortgagePaymentFromMortgagePlanIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMortgagePaymentFromMortgagePlanIdQuery, GetMortgagePaymentFromMortgagePlanIdQueryVariables>(GetMortgagePaymentFromMortgagePlanIdDocument, options);
        }
export type GetMortgagePaymentFromMortgagePlanIdQueryHookResult = ReturnType<typeof useGetMortgagePaymentFromMortgagePlanIdQuery>;
export type GetMortgagePaymentFromMortgagePlanIdLazyQueryHookResult = ReturnType<typeof useGetMortgagePaymentFromMortgagePlanIdLazyQuery>;
export type GetMortgagePaymentFromMortgagePlanIdQueryResult = Apollo.QueryResult<GetMortgagePaymentFromMortgagePlanIdQuery, GetMortgagePaymentFromMortgagePlanIdQueryVariables>;
export const GetMortgagePaymentFromMortgagePlanIdWithSaleLoanIdDocument = gql`
    query getMortgagePaymentFromMortgagePlanIdWithSaleLoanId($mortgageId: String!, $saleLoanId: String!) {
  getMortgagePaymentFromMortgagePlanIdWithSaleLoanId(mortgageId: $mortgageId, saleLoanId: $saleLoanId) {
    id
    endfinancierMortgagePlanId
    mortgagePaymentName
    mortgagePercentage
    mortgageExpectedCount
    mortgageExpectedFreq
    mortgageExpectedFrom
    retention {
      retentionId
      retentionName
      retentionValue
      retentionBy
      retentionExpectedCount
      retentionExpectedFreq
      retentionExpectedFrom
      endfinMortgagePaymentId
    }
  }
}
    `;

/**
 * __useGetMortgagePaymentFromMortgagePlanIdWithSaleLoanIdQuery__
 *
 * To run a query within a React component, call `useGetMortgagePaymentFromMortgagePlanIdWithSaleLoanIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMortgagePaymentFromMortgagePlanIdWithSaleLoanIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMortgagePaymentFromMortgagePlanIdWithSaleLoanIdQuery({
 *   variables: {
 *      mortgageId: // value for 'mortgageId'
 *      saleLoanId: // value for 'saleLoanId'
 *   },
 * });
 */
export function useGetMortgagePaymentFromMortgagePlanIdWithSaleLoanIdQuery(baseOptions: Apollo.QueryHookOptions<GetMortgagePaymentFromMortgagePlanIdWithSaleLoanIdQuery, GetMortgagePaymentFromMortgagePlanIdWithSaleLoanIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMortgagePaymentFromMortgagePlanIdWithSaleLoanIdQuery, GetMortgagePaymentFromMortgagePlanIdWithSaleLoanIdQueryVariables>(GetMortgagePaymentFromMortgagePlanIdWithSaleLoanIdDocument, options);
      }
export function useGetMortgagePaymentFromMortgagePlanIdWithSaleLoanIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMortgagePaymentFromMortgagePlanIdWithSaleLoanIdQuery, GetMortgagePaymentFromMortgagePlanIdWithSaleLoanIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMortgagePaymentFromMortgagePlanIdWithSaleLoanIdQuery, GetMortgagePaymentFromMortgagePlanIdWithSaleLoanIdQueryVariables>(GetMortgagePaymentFromMortgagePlanIdWithSaleLoanIdDocument, options);
        }
export type GetMortgagePaymentFromMortgagePlanIdWithSaleLoanIdQueryHookResult = ReturnType<typeof useGetMortgagePaymentFromMortgagePlanIdWithSaleLoanIdQuery>;
export type GetMortgagePaymentFromMortgagePlanIdWithSaleLoanIdLazyQueryHookResult = ReturnType<typeof useGetMortgagePaymentFromMortgagePlanIdWithSaleLoanIdLazyQuery>;
export type GetMortgagePaymentFromMortgagePlanIdWithSaleLoanIdQueryResult = Apollo.QueryResult<GetMortgagePaymentFromMortgagePlanIdWithSaleLoanIdQuery, GetMortgagePaymentFromMortgagePlanIdWithSaleLoanIdQueryVariables>;
export const GetInstallmentBySaleIdDocument = gql`
    query getInstallmentBySaleId($saleId: String!) {
  getInstallmentBySaleId(saleId: $saleId) {
    id
    isFixAmt
    value
    paymentAmt
  }
}
    `;

/**
 * __useGetInstallmentBySaleIdQuery__
 *
 * To run a query within a React component, call `useGetInstallmentBySaleIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstallmentBySaleIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstallmentBySaleIdQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetInstallmentBySaleIdQuery(baseOptions: Apollo.QueryHookOptions<GetInstallmentBySaleIdQuery, GetInstallmentBySaleIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstallmentBySaleIdQuery, GetInstallmentBySaleIdQueryVariables>(GetInstallmentBySaleIdDocument, options);
      }
export function useGetInstallmentBySaleIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstallmentBySaleIdQuery, GetInstallmentBySaleIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstallmentBySaleIdQuery, GetInstallmentBySaleIdQueryVariables>(GetInstallmentBySaleIdDocument, options);
        }
export type GetInstallmentBySaleIdQueryHookResult = ReturnType<typeof useGetInstallmentBySaleIdQuery>;
export type GetInstallmentBySaleIdLazyQueryHookResult = ReturnType<typeof useGetInstallmentBySaleIdLazyQuery>;
export type GetInstallmentBySaleIdQueryResult = Apollo.QueryResult<GetInstallmentBySaleIdQuery, GetInstallmentBySaleIdQueryVariables>;
export const GetMortgageRetentionFromPaymentIdDocument = gql`
    query getMortgageRetentionFromPaymentId($paymentId: [String!]!) {
  getMortgageRetentionFromPaymentId(paymentId: $paymentId) {
    id
    name
    retentionValue
    retentionBy
    retentionExpectedCount
    retentionExpectedFreq
    retentionExpectedFrom
    endfinMortgagePaymentId
  }
}
    `;

/**
 * __useGetMortgageRetentionFromPaymentIdQuery__
 *
 * To run a query within a React component, call `useGetMortgageRetentionFromPaymentIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMortgageRetentionFromPaymentIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMortgageRetentionFromPaymentIdQuery({
 *   variables: {
 *      paymentId: // value for 'paymentId'
 *   },
 * });
 */
export function useGetMortgageRetentionFromPaymentIdQuery(baseOptions: Apollo.QueryHookOptions<GetMortgageRetentionFromPaymentIdQuery, GetMortgageRetentionFromPaymentIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMortgageRetentionFromPaymentIdQuery, GetMortgageRetentionFromPaymentIdQueryVariables>(GetMortgageRetentionFromPaymentIdDocument, options);
      }
export function useGetMortgageRetentionFromPaymentIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMortgageRetentionFromPaymentIdQuery, GetMortgageRetentionFromPaymentIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMortgageRetentionFromPaymentIdQuery, GetMortgageRetentionFromPaymentIdQueryVariables>(GetMortgageRetentionFromPaymentIdDocument, options);
        }
export type GetMortgageRetentionFromPaymentIdQueryHookResult = ReturnType<typeof useGetMortgageRetentionFromPaymentIdQuery>;
export type GetMortgageRetentionFromPaymentIdLazyQueryHookResult = ReturnType<typeof useGetMortgageRetentionFromPaymentIdLazyQuery>;
export type GetMortgageRetentionFromPaymentIdQueryResult = Apollo.QueryResult<GetMortgageRetentionFromPaymentIdQuery, GetMortgageRetentionFromPaymentIdQueryVariables>;
export const GetSaleLoanInfoBasedOnSaleLoanIdDocument = gql`
    query getSaleLoanInfoBasedOnSaleLoanId($id: String!) {
  getSaleLoanInfoBasedOnSaleLoanId(id: $id) {
    id
    accountId
    unitId
    unitNo
    applyAmount
    approvedAmount
    financierName
    financierId
    financierReference
    loanSignDate
    constructionDate
    fullName
    borrowerName
    endfinancierMortgagePlanId
    mortgageName
    description
    loanPeriod
    borrowerName
    loanInterestRate
    loanInterestMonth
    approvalStatus
    saleLoanNo
    submittedBy
    submittedDate
    payment {
      paymentId
      paymentName
      loanAmount
      expectedCount
      expectedFreq
      expectedFrom
      endfinMortgagePaymentId
      retention {
        retentionId
        retentionName
        loanAmount
        expectedCount
        expectedFreq
        expectedFrom
        endfinMortgageRetentionId
      }
    }
  }
}
    `;

/**
 * __useGetSaleLoanInfoBasedOnSaleLoanIdQuery__
 *
 * To run a query within a React component, call `useGetSaleLoanInfoBasedOnSaleLoanIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSaleLoanInfoBasedOnSaleLoanIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSaleLoanInfoBasedOnSaleLoanIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSaleLoanInfoBasedOnSaleLoanIdQuery(baseOptions: Apollo.QueryHookOptions<GetSaleLoanInfoBasedOnSaleLoanIdQuery, GetSaleLoanInfoBasedOnSaleLoanIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSaleLoanInfoBasedOnSaleLoanIdQuery, GetSaleLoanInfoBasedOnSaleLoanIdQueryVariables>(GetSaleLoanInfoBasedOnSaleLoanIdDocument, options);
      }
export function useGetSaleLoanInfoBasedOnSaleLoanIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSaleLoanInfoBasedOnSaleLoanIdQuery, GetSaleLoanInfoBasedOnSaleLoanIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSaleLoanInfoBasedOnSaleLoanIdQuery, GetSaleLoanInfoBasedOnSaleLoanIdQueryVariables>(GetSaleLoanInfoBasedOnSaleLoanIdDocument, options);
        }
export type GetSaleLoanInfoBasedOnSaleLoanIdQueryHookResult = ReturnType<typeof useGetSaleLoanInfoBasedOnSaleLoanIdQuery>;
export type GetSaleLoanInfoBasedOnSaleLoanIdLazyQueryHookResult = ReturnType<typeof useGetSaleLoanInfoBasedOnSaleLoanIdLazyQuery>;
export type GetSaleLoanInfoBasedOnSaleLoanIdQueryResult = Apollo.QueryResult<GetSaleLoanInfoBasedOnSaleLoanIdQuery, GetSaleLoanInfoBasedOnSaleLoanIdQueryVariables>;
export const InsertNewSaleLoanDocument = gql`
    mutation insertNewSaleLoan($input: SaleLoanInput!) {
  insertNewSaleLoan(input: $input)
}
    `;
export type InsertNewSaleLoanMutationFn = Apollo.MutationFunction<InsertNewSaleLoanMutation, InsertNewSaleLoanMutationVariables>;

/**
 * __useInsertNewSaleLoanMutation__
 *
 * To run a mutation, you first call `useInsertNewSaleLoanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertNewSaleLoanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertNewSaleLoanMutation, { data, loading, error }] = useInsertNewSaleLoanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInsertNewSaleLoanMutation(baseOptions?: Apollo.MutationHookOptions<InsertNewSaleLoanMutation, InsertNewSaleLoanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertNewSaleLoanMutation, InsertNewSaleLoanMutationVariables>(InsertNewSaleLoanDocument, options);
      }
export type InsertNewSaleLoanMutationHookResult = ReturnType<typeof useInsertNewSaleLoanMutation>;
export type InsertNewSaleLoanMutationResult = Apollo.MutationResult<InsertNewSaleLoanMutation>;
export type InsertNewSaleLoanMutationOptions = Apollo.BaseMutationOptions<InsertNewSaleLoanMutation, InsertNewSaleLoanMutationVariables>;
export const UpdateLoanApprovalDocument = gql`
    mutation updateLoanApproval($input: updateSaleLoanApprovalInput!) {
  updateLoanApproval(input: $input)
}
    `;
export type UpdateLoanApprovalMutationFn = Apollo.MutationFunction<UpdateLoanApprovalMutation, UpdateLoanApprovalMutationVariables>;

/**
 * __useUpdateLoanApprovalMutation__
 *
 * To run a mutation, you first call `useUpdateLoanApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLoanApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLoanApprovalMutation, { data, loading, error }] = useUpdateLoanApprovalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLoanApprovalMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLoanApprovalMutation, UpdateLoanApprovalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLoanApprovalMutation, UpdateLoanApprovalMutationVariables>(UpdateLoanApprovalDocument, options);
      }
export type UpdateLoanApprovalMutationHookResult = ReturnType<typeof useUpdateLoanApprovalMutation>;
export type UpdateLoanApprovalMutationResult = Apollo.MutationResult<UpdateLoanApprovalMutation>;
export type UpdateLoanApprovalMutationOptions = Apollo.BaseMutationOptions<UpdateLoanApprovalMutation, UpdateLoanApprovalMutationVariables>;
export const UpdateSaleLoanApprvalDocument = gql`
    mutation updateSaleLoanApprval($input: updateSaleLoanApprovalFormInput!) {
  updateSaleLoanApprval(input: $input)
}
    `;
export type UpdateSaleLoanApprvalMutationFn = Apollo.MutationFunction<UpdateSaleLoanApprvalMutation, UpdateSaleLoanApprvalMutationVariables>;

/**
 * __useUpdateSaleLoanApprvalMutation__
 *
 * To run a mutation, you first call `useUpdateSaleLoanApprvalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSaleLoanApprvalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSaleLoanApprvalMutation, { data, loading, error }] = useUpdateSaleLoanApprvalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSaleLoanApprvalMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSaleLoanApprvalMutation, UpdateSaleLoanApprvalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSaleLoanApprvalMutation, UpdateSaleLoanApprvalMutationVariables>(UpdateSaleLoanApprvalDocument, options);
      }
export type UpdateSaleLoanApprvalMutationHookResult = ReturnType<typeof useUpdateSaleLoanApprvalMutation>;
export type UpdateSaleLoanApprvalMutationResult = Apollo.MutationResult<UpdateSaleLoanApprvalMutation>;
export type UpdateSaleLoanApprvalMutationOptions = Apollo.BaseMutationOptions<UpdateSaleLoanApprvalMutation, UpdateSaleLoanApprvalMutationVariables>;
export const GetLoanDifferentialListingDocument = gql`
    query getLoanDifferentialListing($projectId: String!, $status: String) {
  getLoanDifferentialListing(projectId: $projectId, status: $status) {
    id
    borrowerName
    applyAmount
    approvedAmount
    unitNo
    financier
    approvalDate
    rescheduled
    rescheduling
    clusterCode
    saleId
    rescheduleId
    rescheduleApprovalStatus
  }
}
    `;

/**
 * __useGetLoanDifferentialListingQuery__
 *
 * To run a query within a React component, call `useGetLoanDifferentialListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoanDifferentialListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoanDifferentialListingQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetLoanDifferentialListingQuery(baseOptions: Apollo.QueryHookOptions<GetLoanDifferentialListingQuery, GetLoanDifferentialListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoanDifferentialListingQuery, GetLoanDifferentialListingQueryVariables>(GetLoanDifferentialListingDocument, options);
      }
export function useGetLoanDifferentialListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLoanDifferentialListingQuery, GetLoanDifferentialListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoanDifferentialListingQuery, GetLoanDifferentialListingQueryVariables>(GetLoanDifferentialListingDocument, options);
        }
export type GetLoanDifferentialListingQueryHookResult = ReturnType<typeof useGetLoanDifferentialListingQuery>;
export type GetLoanDifferentialListingLazyQueryHookResult = ReturnType<typeof useGetLoanDifferentialListingLazyQuery>;
export type GetLoanDifferentialListingQueryResult = Apollo.QueryResult<GetLoanDifferentialListingQuery, GetLoanDifferentialListingQueryVariables>;
export const GetPendingInstallmentByIdDocument = gql`
    query getPendingInstallmentById($id: String!) {
  getPendingInstallmentById(id: $id) {
    id
    borrowerName
    approvedAmount
    applyAmount
    unitNo
    clusterCode
    saleId
    financier
    approvalDate
    bookDate
    fullName
    salesNo
    rescheduleDate
    installments {
      unallocatedAmount
      id
      commonStatus
      taxAmount
      baseAmount
      documentDate
      documentAmount
      billType
      description
    }
  }
}
    `;

/**
 * __useGetPendingInstallmentByIdQuery__
 *
 * To run a query within a React component, call `useGetPendingInstallmentByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingInstallmentByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingInstallmentByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPendingInstallmentByIdQuery(baseOptions: Apollo.QueryHookOptions<GetPendingInstallmentByIdQuery, GetPendingInstallmentByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPendingInstallmentByIdQuery, GetPendingInstallmentByIdQueryVariables>(GetPendingInstallmentByIdDocument, options);
      }
export function useGetPendingInstallmentByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPendingInstallmentByIdQuery, GetPendingInstallmentByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPendingInstallmentByIdQuery, GetPendingInstallmentByIdQueryVariables>(GetPendingInstallmentByIdDocument, options);
        }
export type GetPendingInstallmentByIdQueryHookResult = ReturnType<typeof useGetPendingInstallmentByIdQuery>;
export type GetPendingInstallmentByIdLazyQueryHookResult = ReturnType<typeof useGetPendingInstallmentByIdLazyQuery>;
export type GetPendingInstallmentByIdQueryResult = Apollo.QueryResult<GetPendingInstallmentByIdQuery, GetPendingInstallmentByIdQueryVariables>;
export const RescheduledLoanDifferentialDocument = gql`
    mutation rescheduledLoanDifferential($input: RescheduleLoanInput!) {
  rescheduledLoanDifferential(input: $input)
}
    `;
export type RescheduledLoanDifferentialMutationFn = Apollo.MutationFunction<RescheduledLoanDifferentialMutation, RescheduledLoanDifferentialMutationVariables>;

/**
 * __useRescheduledLoanDifferentialMutation__
 *
 * To run a mutation, you first call `useRescheduledLoanDifferentialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRescheduledLoanDifferentialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rescheduledLoanDifferentialMutation, { data, loading, error }] = useRescheduledLoanDifferentialMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRescheduledLoanDifferentialMutation(baseOptions?: Apollo.MutationHookOptions<RescheduledLoanDifferentialMutation, RescheduledLoanDifferentialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RescheduledLoanDifferentialMutation, RescheduledLoanDifferentialMutationVariables>(RescheduledLoanDifferentialDocument, options);
      }
export type RescheduledLoanDifferentialMutationHookResult = ReturnType<typeof useRescheduledLoanDifferentialMutation>;
export type RescheduledLoanDifferentialMutationResult = Apollo.MutationResult<RescheduledLoanDifferentialMutation>;
export type RescheduledLoanDifferentialMutationOptions = Apollo.BaseMutationOptions<RescheduledLoanDifferentialMutation, RescheduledLoanDifferentialMutationVariables>;
export const GetApprovedLoanRescheduleListDocument = gql`
    query getApprovedLoanRescheduleList($saleId: String!, $rescheduleId: String!) {
  getApprovedLoanRescheduleList(saleId: $saleId, rescheduleId: $rescheduleId) {
    rescheduleid
    installmentid
    isbuyerportion
    billtype
    ledgertype
    isselected
    documentdate
    description
    documentamount
    rescheduleno
    rescheduledate
    expiredate
    expiryby
    baseamt
    taxamt
    unallocatedamount
    oldinstallmentid
    commonstatus
  }
}
    `;

/**
 * __useGetApprovedLoanRescheduleListQuery__
 *
 * To run a query within a React component, call `useGetApprovedLoanRescheduleListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApprovedLoanRescheduleListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApprovedLoanRescheduleListQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *      rescheduleId: // value for 'rescheduleId'
 *   },
 * });
 */
export function useGetApprovedLoanRescheduleListQuery(baseOptions: Apollo.QueryHookOptions<GetApprovedLoanRescheduleListQuery, GetApprovedLoanRescheduleListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApprovedLoanRescheduleListQuery, GetApprovedLoanRescheduleListQueryVariables>(GetApprovedLoanRescheduleListDocument, options);
      }
export function useGetApprovedLoanRescheduleListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApprovedLoanRescheduleListQuery, GetApprovedLoanRescheduleListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApprovedLoanRescheduleListQuery, GetApprovedLoanRescheduleListQueryVariables>(GetApprovedLoanRescheduleListDocument, options);
        }
export type GetApprovedLoanRescheduleListQueryHookResult = ReturnType<typeof useGetApprovedLoanRescheduleListQuery>;
export type GetApprovedLoanRescheduleListLazyQueryHookResult = ReturnType<typeof useGetApprovedLoanRescheduleListLazyQuery>;
export type GetApprovedLoanRescheduleListQueryResult = Apollo.QueryResult<GetApprovedLoanRescheduleListQuery, GetApprovedLoanRescheduleListQueryVariables>;
export const GetRescheduleLoanDocument = gql`
    query getRescheduleLoan($rescheduleId: String!) {
  getRescheduleLoan(rescheduleId: $rescheduleId) {
    premiumAmount
    billType
    startDate
    description
    submittedBy
    submittedDate
    noInstallment
    unitNo
    projectClusterName
    salesRegistrationNo
  }
}
    `;

/**
 * __useGetRescheduleLoanQuery__
 *
 * To run a query within a React component, call `useGetRescheduleLoanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRescheduleLoanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRescheduleLoanQuery({
 *   variables: {
 *      rescheduleId: // value for 'rescheduleId'
 *   },
 * });
 */
export function useGetRescheduleLoanQuery(baseOptions: Apollo.QueryHookOptions<GetRescheduleLoanQuery, GetRescheduleLoanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRescheduleLoanQuery, GetRescheduleLoanQueryVariables>(GetRescheduleLoanDocument, options);
      }
export function useGetRescheduleLoanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRescheduleLoanQuery, GetRescheduleLoanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRescheduleLoanQuery, GetRescheduleLoanQueryVariables>(GetRescheduleLoanDocument, options);
        }
export type GetRescheduleLoanQueryHookResult = ReturnType<typeof useGetRescheduleLoanQuery>;
export type GetRescheduleLoanLazyQueryHookResult = ReturnType<typeof useGetRescheduleLoanLazyQuery>;
export type GetRescheduleLoanQueryResult = Apollo.QueryResult<GetRescheduleLoanQuery, GetRescheduleLoanQueryVariables>;
export const GetLoanDifferentialCountDocument = gql`
    query getLoanDifferentialCount($projectId: String!) {
  getLoanDifferentialCount(projectId: $projectId) {
    pendingCount
    completedCount
  }
}
    `;

/**
 * __useGetLoanDifferentialCountQuery__
 *
 * To run a query within a React component, call `useGetLoanDifferentialCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoanDifferentialCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoanDifferentialCountQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetLoanDifferentialCountQuery(baseOptions: Apollo.QueryHookOptions<GetLoanDifferentialCountQuery, GetLoanDifferentialCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoanDifferentialCountQuery, GetLoanDifferentialCountQueryVariables>(GetLoanDifferentialCountDocument, options);
      }
export function useGetLoanDifferentialCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLoanDifferentialCountQuery, GetLoanDifferentialCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoanDifferentialCountQuery, GetLoanDifferentialCountQueryVariables>(GetLoanDifferentialCountDocument, options);
        }
export type GetLoanDifferentialCountQueryHookResult = ReturnType<typeof useGetLoanDifferentialCountQuery>;
export type GetLoanDifferentialCountLazyQueryHookResult = ReturnType<typeof useGetLoanDifferentialCountLazyQuery>;
export type GetLoanDifferentialCountQueryResult = Apollo.QueryResult<GetLoanDifferentialCountQuery, GetLoanDifferentialCountQueryVariables>;
export const GetLoanPaymentListingByIdDocument = gql`
    query getLoanPaymentListingById($id: String!) {
  getLoanPaymentListingById(id: $id) {
    id
    loanReleaseId
    referenceNo
    financier
    documentAmt
    documentDate
    bankAccountId
    saleLoanPaymentPlanDetails {
      sale_id
      sale_loan_id
      sale_loan_payment_plan_id
      amount
      unit_no
      name
    }
  }
}
    `;

/**
 * __useGetLoanPaymentListingByIdQuery__
 *
 * To run a query within a React component, call `useGetLoanPaymentListingByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoanPaymentListingByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoanPaymentListingByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLoanPaymentListingByIdQuery(baseOptions: Apollo.QueryHookOptions<GetLoanPaymentListingByIdQuery, GetLoanPaymentListingByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoanPaymentListingByIdQuery, GetLoanPaymentListingByIdQueryVariables>(GetLoanPaymentListingByIdDocument, options);
      }
export function useGetLoanPaymentListingByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLoanPaymentListingByIdQuery, GetLoanPaymentListingByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoanPaymentListingByIdQuery, GetLoanPaymentListingByIdQueryVariables>(GetLoanPaymentListingByIdDocument, options);
        }
export type GetLoanPaymentListingByIdQueryHookResult = ReturnType<typeof useGetLoanPaymentListingByIdQuery>;
export type GetLoanPaymentListingByIdLazyQueryHookResult = ReturnType<typeof useGetLoanPaymentListingByIdLazyQuery>;
export type GetLoanPaymentListingByIdQueryResult = Apollo.QueryResult<GetLoanPaymentListingByIdQuery, GetLoanPaymentListingByIdQueryVariables>;
export const GetLoanPaymentListingDocument = gql`
    query getLoanPaymentListing($projectId: String!, $status: String, $search: String) {
  getLoanPaymentListing(projectId: $projectId, status: $status, search: $search) {
    id
    referenceNo
    documentAmt
    documentDate
    financier
    approvalStatus
    loanPaymentNo
  }
}
    `;

/**
 * __useGetLoanPaymentListingQuery__
 *
 * To run a query within a React component, call `useGetLoanPaymentListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoanPaymentListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoanPaymentListingQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      status: // value for 'status'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetLoanPaymentListingQuery(baseOptions: Apollo.QueryHookOptions<GetLoanPaymentListingQuery, GetLoanPaymentListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoanPaymentListingQuery, GetLoanPaymentListingQueryVariables>(GetLoanPaymentListingDocument, options);
      }
export function useGetLoanPaymentListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLoanPaymentListingQuery, GetLoanPaymentListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoanPaymentListingQuery, GetLoanPaymentListingQueryVariables>(GetLoanPaymentListingDocument, options);
        }
export type GetLoanPaymentListingQueryHookResult = ReturnType<typeof useGetLoanPaymentListingQuery>;
export type GetLoanPaymentListingLazyQueryHookResult = ReturnType<typeof useGetLoanPaymentListingLazyQuery>;
export type GetLoanPaymentListingQueryResult = Apollo.QueryResult<GetLoanPaymentListingQuery, GetLoanPaymentListingQueryVariables>;
export const GetLoanPaymentDetailsDocument = gql`
    query getLoanPaymentDetails($saleLoanPaymentId: String!) {
  getLoanPaymentDetails(saleLoanPaymentId: $saleLoanPaymentId) {
    loanPaymentNo
    loanPaymentDate
    loanReleaseNo
    loanReleaseDate
    endFinancier
    disbursementBankAccount
    mortgagePlan
    paymentName
    paymentPercentage
    retentionId
    retentionName
    retentionBy
    retentionValue
    submittedBy
    submittedDate
    approvedBy
    approvedDate
    totalApproveAmt
    approvedAmtLoanExt
    saleLoanPaymentPlanDetails {
      sale_id
      sale_loan_id
      sale_loan_no
      sale_loan_payment_plan_id
      unit_no
      name
      amount
      approvedAmt
    }
  }
}
    `;

/**
 * __useGetLoanPaymentDetailsQuery__
 *
 * To run a query within a React component, call `useGetLoanPaymentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoanPaymentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoanPaymentDetailsQuery({
 *   variables: {
 *      saleLoanPaymentId: // value for 'saleLoanPaymentId'
 *   },
 * });
 */
export function useGetLoanPaymentDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetLoanPaymentDetailsQuery, GetLoanPaymentDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoanPaymentDetailsQuery, GetLoanPaymentDetailsQueryVariables>(GetLoanPaymentDetailsDocument, options);
      }
export function useGetLoanPaymentDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLoanPaymentDetailsQuery, GetLoanPaymentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoanPaymentDetailsQuery, GetLoanPaymentDetailsQueryVariables>(GetLoanPaymentDetailsDocument, options);
        }
export type GetLoanPaymentDetailsQueryHookResult = ReturnType<typeof useGetLoanPaymentDetailsQuery>;
export type GetLoanPaymentDetailsLazyQueryHookResult = ReturnType<typeof useGetLoanPaymentDetailsLazyQuery>;
export type GetLoanPaymentDetailsQueryResult = Apollo.QueryResult<GetLoanPaymentDetailsQuery, GetLoanPaymentDetailsQueryVariables>;
export const GetLoanPaymentSummaryDocument = gql`
    query getLoanPaymentSummary($projectId: String!) {
  getLoanPaymentSummary(projectId: $projectId) {
    posted
    draft
  }
}
    `;

/**
 * __useGetLoanPaymentSummaryQuery__
 *
 * To run a query within a React component, call `useGetLoanPaymentSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoanPaymentSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoanPaymentSummaryQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetLoanPaymentSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetLoanPaymentSummaryQuery, GetLoanPaymentSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoanPaymentSummaryQuery, GetLoanPaymentSummaryQueryVariables>(GetLoanPaymentSummaryDocument, options);
      }
export function useGetLoanPaymentSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLoanPaymentSummaryQuery, GetLoanPaymentSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoanPaymentSummaryQuery, GetLoanPaymentSummaryQueryVariables>(GetLoanPaymentSummaryDocument, options);
        }
export type GetLoanPaymentSummaryQueryHookResult = ReturnType<typeof useGetLoanPaymentSummaryQuery>;
export type GetLoanPaymentSummaryLazyQueryHookResult = ReturnType<typeof useGetLoanPaymentSummaryLazyQuery>;
export type GetLoanPaymentSummaryQueryResult = Apollo.QueryResult<GetLoanPaymentSummaryQuery, GetLoanPaymentSummaryQueryVariables>;
export const GetUnitForPaymentPlanDetailsDocument = gql`
    query GetUnitForPaymentPlanDetails($loanPaymentPlanDetails: [UnitForPaymentPlanDetailsInput!]!) {
  getUnitForPaymentPlanDetails(loanPaymentPlanDetails: $loanPaymentPlanDetails) {
    sale_id
    sale_loan_id
    sale_loan_payment_plan_id
    sale_loan_refinancing_id
    sale_loan_refinancing_payment_plan_id
    sale_loan_refinancing_retention_id
    amount
    unit_no
    name
  }
}
    `;

/**
 * __useGetUnitForPaymentPlanDetailsQuery__
 *
 * To run a query within a React component, call `useGetUnitForPaymentPlanDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitForPaymentPlanDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitForPaymentPlanDetailsQuery({
 *   variables: {
 *      loanPaymentPlanDetails: // value for 'loanPaymentPlanDetails'
 *   },
 * });
 */
export function useGetUnitForPaymentPlanDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetUnitForPaymentPlanDetailsQuery, GetUnitForPaymentPlanDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitForPaymentPlanDetailsQuery, GetUnitForPaymentPlanDetailsQueryVariables>(GetUnitForPaymentPlanDetailsDocument, options);
      }
export function useGetUnitForPaymentPlanDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitForPaymentPlanDetailsQuery, GetUnitForPaymentPlanDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitForPaymentPlanDetailsQuery, GetUnitForPaymentPlanDetailsQueryVariables>(GetUnitForPaymentPlanDetailsDocument, options);
        }
export type GetUnitForPaymentPlanDetailsQueryHookResult = ReturnType<typeof useGetUnitForPaymentPlanDetailsQuery>;
export type GetUnitForPaymentPlanDetailsLazyQueryHookResult = ReturnType<typeof useGetUnitForPaymentPlanDetailsLazyQuery>;
export type GetUnitForPaymentPlanDetailsQueryResult = Apollo.QueryResult<GetUnitForPaymentPlanDetailsQuery, GetUnitForPaymentPlanDetailsQueryVariables>;
export const AddLoanPaymentDocument = gql`
    mutation addLoanPayment($input: AddLoanPaymentInput!, $projectId: String!, $status: String!) {
  addLoanPayment(input: $input, projectId: $projectId, status: $status)
}
    `;
export type AddLoanPaymentMutationFn = Apollo.MutationFunction<AddLoanPaymentMutation, AddLoanPaymentMutationVariables>;

/**
 * __useAddLoanPaymentMutation__
 *
 * To run a mutation, you first call `useAddLoanPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLoanPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLoanPaymentMutation, { data, loading, error }] = useAddLoanPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *      projectId: // value for 'projectId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useAddLoanPaymentMutation(baseOptions?: Apollo.MutationHookOptions<AddLoanPaymentMutation, AddLoanPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddLoanPaymentMutation, AddLoanPaymentMutationVariables>(AddLoanPaymentDocument, options);
      }
export type AddLoanPaymentMutationHookResult = ReturnType<typeof useAddLoanPaymentMutation>;
export type AddLoanPaymentMutationResult = Apollo.MutationResult<AddLoanPaymentMutation>;
export type AddLoanPaymentMutationOptions = Apollo.BaseMutationOptions<AddLoanPaymentMutation, AddLoanPaymentMutationVariables>;
export const EditLoanPaymentDocument = gql`
    mutation editLoanPayment($input: AddLoanPaymentInput!, $projectId: String!, $id: String!, $status: String!) {
  editLoanPayment(input: $input, projectId: $projectId, id: $id, status: $status)
}
    `;
export type EditLoanPaymentMutationFn = Apollo.MutationFunction<EditLoanPaymentMutation, EditLoanPaymentMutationVariables>;

/**
 * __useEditLoanPaymentMutation__
 *
 * To run a mutation, you first call `useEditLoanPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditLoanPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editLoanPaymentMutation, { data, loading, error }] = useEditLoanPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *      projectId: // value for 'projectId'
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useEditLoanPaymentMutation(baseOptions?: Apollo.MutationHookOptions<EditLoanPaymentMutation, EditLoanPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditLoanPaymentMutation, EditLoanPaymentMutationVariables>(EditLoanPaymentDocument, options);
      }
export type EditLoanPaymentMutationHookResult = ReturnType<typeof useEditLoanPaymentMutation>;
export type EditLoanPaymentMutationResult = Apollo.MutationResult<EditLoanPaymentMutation>;
export type EditLoanPaymentMutationOptions = Apollo.BaseMutationOptions<EditLoanPaymentMutation, EditLoanPaymentMutationVariables>;
export const DeleteLoanPaymentDocument = gql`
    mutation deleteLoanPayment($id: String!) {
  deleteLoanPayment(id: $id)
}
    `;
export type DeleteLoanPaymentMutationFn = Apollo.MutationFunction<DeleteLoanPaymentMutation, DeleteLoanPaymentMutationVariables>;

/**
 * __useDeleteLoanPaymentMutation__
 *
 * To run a mutation, you first call `useDeleteLoanPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLoanPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLoanPaymentMutation, { data, loading, error }] = useDeleteLoanPaymentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLoanPaymentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLoanPaymentMutation, DeleteLoanPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLoanPaymentMutation, DeleteLoanPaymentMutationVariables>(DeleteLoanPaymentDocument, options);
      }
export type DeleteLoanPaymentMutationHookResult = ReturnType<typeof useDeleteLoanPaymentMutation>;
export type DeleteLoanPaymentMutationResult = Apollo.MutationResult<DeleteLoanPaymentMutation>;
export type DeleteLoanPaymentMutationOptions = Apollo.BaseMutationOptions<DeleteLoanPaymentMutation, DeleteLoanPaymentMutationVariables>;
export const GetLoanReleaseListingDocument = gql`
    query getLoanReleaseListing($projectId: String!, $status: String) {
  getLoanReleaseListing(projectId: $projectId, status: $status) {
    id
    docNo
    releaseDate
    isPaid
    approvalStatus
    submittedDate
    amtPerPaymentPlan
    submittedBy
    approvedDate
    approvedBy
    financierId
    endFinancierMortgageId
    endfinMortgagePaymentPlanId
    endfinMortgageRetentionId
    isSaleLoanPayment
    isSaleLoanRefinancing
    saleLoanPaymentPlanDetails {
      amount
      sale_id
      sale_loan_id
      sale_loan_refinancing_id
      sale_loan_payment_plan_id
      sale_loan_retention_id
      sale_loan_refinancing_payment_plan_id
      sale_loan_refinancing_retention_id
    }
    financier {
      name
      id
    }
    mortgagePayment {
      id
      name
    }
    mortgagePlan {
      id
      name
    }
    mortgageRetention {
      id
      name
    }
  }
}
    `;

/**
 * __useGetLoanReleaseListingQuery__
 *
 * To run a query within a React component, call `useGetLoanReleaseListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoanReleaseListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoanReleaseListingQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetLoanReleaseListingQuery(baseOptions: Apollo.QueryHookOptions<GetLoanReleaseListingQuery, GetLoanReleaseListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoanReleaseListingQuery, GetLoanReleaseListingQueryVariables>(GetLoanReleaseListingDocument, options);
      }
export function useGetLoanReleaseListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLoanReleaseListingQuery, GetLoanReleaseListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoanReleaseListingQuery, GetLoanReleaseListingQueryVariables>(GetLoanReleaseListingDocument, options);
        }
export type GetLoanReleaseListingQueryHookResult = ReturnType<typeof useGetLoanReleaseListingQuery>;
export type GetLoanReleaseListingLazyQueryHookResult = ReturnType<typeof useGetLoanReleaseListingLazyQuery>;
export type GetLoanReleaseListingQueryResult = Apollo.QueryResult<GetLoanReleaseListingQuery, GetLoanReleaseListingQueryVariables>;
export const GetLoanReleasesDocument = gql`
    query getLoanReleases($projectId: String!, $status: String) {
  getLoanReleases(projectId: $projectId, status: $status) {
    id
    docNo
    releaseDate
    isPaid
    approvalStatus
    submittedDate
    amtPerPaymentPlan
    submittedBy
    approvedDate
    approvedBy
    financierId
    endFinancierMortgageId
    endfinMortgagePaymentPlanId
    endfinMortgageRetentionId
    saleLoanPaymentPlanDetails {
      sale_loan_payment_plan_id
      amount
      sale_id
      sale_loan_id
    }
    financier {
      name
      id
    }
    mortgagePayment {
      id
      name
    }
    mortgagePlan {
      id
      name
    }
    mortgageRetention {
      id
      name
    }
  }
}
    `;

/**
 * __useGetLoanReleasesQuery__
 *
 * To run a query within a React component, call `useGetLoanReleasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoanReleasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoanReleasesQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetLoanReleasesQuery(baseOptions: Apollo.QueryHookOptions<GetLoanReleasesQuery, GetLoanReleasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoanReleasesQuery, GetLoanReleasesQueryVariables>(GetLoanReleasesDocument, options);
      }
export function useGetLoanReleasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLoanReleasesQuery, GetLoanReleasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoanReleasesQuery, GetLoanReleasesQueryVariables>(GetLoanReleasesDocument, options);
        }
export type GetLoanReleasesQueryHookResult = ReturnType<typeof useGetLoanReleasesQuery>;
export type GetLoanReleasesLazyQueryHookResult = ReturnType<typeof useGetLoanReleasesLazyQuery>;
export type GetLoanReleasesQueryResult = Apollo.QueryResult<GetLoanReleasesQuery, GetLoanReleasesQueryVariables>;
export const GetSaleLoanTableListingDocument = gql`
    query getSaleLoanTableListing($financierId: String!, $endfinancierMortgagePlanId: String!, $type: String!, $paymentId: String!, $saleLoanReleaseId: String!, $loanSignDate: DateTime!) {
  getSaleLoanTableListing(financierId: $financierId, endfinancierMortgagePlanId: $endfinancierMortgagePlanId, type: $type, paymentId: $paymentId, saleLoanReleaseId: $saleLoanReleaseId, loanSignDate: $loanSignDate) {
    sale_loan_id
    full_name
    sale_loan_amount
    sale_id
    unit_no
    emp_name
    apply_amt
    approved_amt
    is_refinanced
    table_ref
    sale_loan_payment_plan_id
  }
}
    `;

/**
 * __useGetSaleLoanTableListingQuery__
 *
 * To run a query within a React component, call `useGetSaleLoanTableListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSaleLoanTableListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSaleLoanTableListingQuery({
 *   variables: {
 *      financierId: // value for 'financierId'
 *      endfinancierMortgagePlanId: // value for 'endfinancierMortgagePlanId'
 *      type: // value for 'type'
 *      paymentId: // value for 'paymentId'
 *      saleLoanReleaseId: // value for 'saleLoanReleaseId'
 *      loanSignDate: // value for 'loanSignDate'
 *   },
 * });
 */
export function useGetSaleLoanTableListingQuery(baseOptions: Apollo.QueryHookOptions<GetSaleLoanTableListingQuery, GetSaleLoanTableListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSaleLoanTableListingQuery, GetSaleLoanTableListingQueryVariables>(GetSaleLoanTableListingDocument, options);
      }
export function useGetSaleLoanTableListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSaleLoanTableListingQuery, GetSaleLoanTableListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSaleLoanTableListingQuery, GetSaleLoanTableListingQueryVariables>(GetSaleLoanTableListingDocument, options);
        }
export type GetSaleLoanTableListingQueryHookResult = ReturnType<typeof useGetSaleLoanTableListingQuery>;
export type GetSaleLoanTableListingLazyQueryHookResult = ReturnType<typeof useGetSaleLoanTableListingLazyQuery>;
export type GetSaleLoanTableListingQueryResult = Apollo.QueryResult<GetSaleLoanTableListingQuery, GetSaleLoanTableListingQueryVariables>;
export const GetSaleLoanDetailsDocument = gql`
    query getSaleLoanDetails($saleLoanReleaseId: String!) {
  getSaleLoanDetails(saleLoanReleaseId: $saleLoanReleaseId) {
    saleLoanPaymentId
    docNo
    financierId
    financierName
    mortgageId
    mortgageName
    paymentId
    paymentName
    paymentPercentage
    retentionId
    retentionName
    retentionBy
    retentionValue
    submittedBy
    submittedName
    releaseDate
    approvedDate
    submittedDate
    totalApproveAmt
    approvedName
    approvedBy
    saleLoanPaymentPlanDetails {
      saleLoanId
      saleId
      unitId
      unitNo
      approvedAmt
      appAmt
      saleLoanNo
      fullName
    }
  }
}
    `;

/**
 * __useGetSaleLoanDetailsQuery__
 *
 * To run a query within a React component, call `useGetSaleLoanDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSaleLoanDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSaleLoanDetailsQuery({
 *   variables: {
 *      saleLoanReleaseId: // value for 'saleLoanReleaseId'
 *   },
 * });
 */
export function useGetSaleLoanDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetSaleLoanDetailsQuery, GetSaleLoanDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSaleLoanDetailsQuery, GetSaleLoanDetailsQueryVariables>(GetSaleLoanDetailsDocument, options);
      }
export function useGetSaleLoanDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSaleLoanDetailsQuery, GetSaleLoanDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSaleLoanDetailsQuery, GetSaleLoanDetailsQueryVariables>(GetSaleLoanDetailsDocument, options);
        }
export type GetSaleLoanDetailsQueryHookResult = ReturnType<typeof useGetSaleLoanDetailsQuery>;
export type GetSaleLoanDetailsLazyQueryHookResult = ReturnType<typeof useGetSaleLoanDetailsLazyQuery>;
export type GetSaleLoanDetailsQueryResult = Apollo.QueryResult<GetSaleLoanDetailsQuery, GetSaleLoanDetailsQueryVariables>;
export const GetAttachmentReleaseDocument = gql`
    query getAttachmentRelease($refId: String!) {
  getAttachmentRelease(refId: $refId) {
    id
    mediaType
    resourceUrl
    fileName
    seqNo
  }
}
    `;

/**
 * __useGetAttachmentReleaseQuery__
 *
 * To run a query within a React component, call `useGetAttachmentReleaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttachmentReleaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttachmentReleaseQuery({
 *   variables: {
 *      refId: // value for 'refId'
 *   },
 * });
 */
export function useGetAttachmentReleaseQuery(baseOptions: Apollo.QueryHookOptions<GetAttachmentReleaseQuery, GetAttachmentReleaseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAttachmentReleaseQuery, GetAttachmentReleaseQueryVariables>(GetAttachmentReleaseDocument, options);
      }
export function useGetAttachmentReleaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAttachmentReleaseQuery, GetAttachmentReleaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAttachmentReleaseQuery, GetAttachmentReleaseQueryVariables>(GetAttachmentReleaseDocument, options);
        }
export type GetAttachmentReleaseQueryHookResult = ReturnType<typeof useGetAttachmentReleaseQuery>;
export type GetAttachmentReleaseLazyQueryHookResult = ReturnType<typeof useGetAttachmentReleaseLazyQuery>;
export type GetAttachmentReleaseQueryResult = Apollo.QueryResult<GetAttachmentReleaseQuery, GetAttachmentReleaseQueryVariables>;
export const AddSaleLoanReleaseDocument = gql`
    mutation addSaleLoanRelease($input: SaleLoanReleaseInput!) {
  addSaleLoanRelease(input: $input)
}
    `;
export type AddSaleLoanReleaseMutationFn = Apollo.MutationFunction<AddSaleLoanReleaseMutation, AddSaleLoanReleaseMutationVariables>;

/**
 * __useAddSaleLoanReleaseMutation__
 *
 * To run a mutation, you first call `useAddSaleLoanReleaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSaleLoanReleaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSaleLoanReleaseMutation, { data, loading, error }] = useAddSaleLoanReleaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddSaleLoanReleaseMutation(baseOptions?: Apollo.MutationHookOptions<AddSaleLoanReleaseMutation, AddSaleLoanReleaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSaleLoanReleaseMutation, AddSaleLoanReleaseMutationVariables>(AddSaleLoanReleaseDocument, options);
      }
export type AddSaleLoanReleaseMutationHookResult = ReturnType<typeof useAddSaleLoanReleaseMutation>;
export type AddSaleLoanReleaseMutationResult = Apollo.MutationResult<AddSaleLoanReleaseMutation>;
export type AddSaleLoanReleaseMutationOptions = Apollo.BaseMutationOptions<AddSaleLoanReleaseMutation, AddSaleLoanReleaseMutationVariables>;
export const EditSaleLoanReleaseDocument = gql`
    mutation editSaleLoanRelease($id: String!, $input: SaleLoanReleaseInput!, $fileDB: [String!], $fileOld: [String!]) {
  editSaleLoanRelease(id: $id, input: $input, fileDB: $fileDB, fileOld: $fileOld)
}
    `;
export type EditSaleLoanReleaseMutationFn = Apollo.MutationFunction<EditSaleLoanReleaseMutation, EditSaleLoanReleaseMutationVariables>;

/**
 * __useEditSaleLoanReleaseMutation__
 *
 * To run a mutation, you first call `useEditSaleLoanReleaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSaleLoanReleaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSaleLoanReleaseMutation, { data, loading, error }] = useEditSaleLoanReleaseMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      fileDB: // value for 'fileDB'
 *      fileOld: // value for 'fileOld'
 *   },
 * });
 */
export function useEditSaleLoanReleaseMutation(baseOptions?: Apollo.MutationHookOptions<EditSaleLoanReleaseMutation, EditSaleLoanReleaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditSaleLoanReleaseMutation, EditSaleLoanReleaseMutationVariables>(EditSaleLoanReleaseDocument, options);
      }
export type EditSaleLoanReleaseMutationHookResult = ReturnType<typeof useEditSaleLoanReleaseMutation>;
export type EditSaleLoanReleaseMutationResult = Apollo.MutationResult<EditSaleLoanReleaseMutation>;
export type EditSaleLoanReleaseMutationOptions = Apollo.BaseMutationOptions<EditSaleLoanReleaseMutation, EditSaleLoanReleaseMutationVariables>;
export const DeleteSaleLoanReleaseDocument = gql`
    mutation deleteSaleLoanRelease($releaseId: String!) {
  deleteSaleLoanRelease(releaseId: $releaseId)
}
    `;
export type DeleteSaleLoanReleaseMutationFn = Apollo.MutationFunction<DeleteSaleLoanReleaseMutation, DeleteSaleLoanReleaseMutationVariables>;

/**
 * __useDeleteSaleLoanReleaseMutation__
 *
 * To run a mutation, you first call `useDeleteSaleLoanReleaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSaleLoanReleaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSaleLoanReleaseMutation, { data, loading, error }] = useDeleteSaleLoanReleaseMutation({
 *   variables: {
 *      releaseId: // value for 'releaseId'
 *   },
 * });
 */
export function useDeleteSaleLoanReleaseMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSaleLoanReleaseMutation, DeleteSaleLoanReleaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSaleLoanReleaseMutation, DeleteSaleLoanReleaseMutationVariables>(DeleteSaleLoanReleaseDocument, options);
      }
export type DeleteSaleLoanReleaseMutationHookResult = ReturnType<typeof useDeleteSaleLoanReleaseMutation>;
export type DeleteSaleLoanReleaseMutationResult = Apollo.MutationResult<DeleteSaleLoanReleaseMutation>;
export type DeleteSaleLoanReleaseMutationOptions = Apollo.BaseMutationOptions<DeleteSaleLoanReleaseMutation, DeleteSaleLoanReleaseMutationVariables>;
export const ApproveSaleLoanReleaseDocument = gql`
    mutation approveSaleLoanRelease($releaseId: String!) {
  approveSaleLoanRelease(releaseId: $releaseId)
}
    `;
export type ApproveSaleLoanReleaseMutationFn = Apollo.MutationFunction<ApproveSaleLoanReleaseMutation, ApproveSaleLoanReleaseMutationVariables>;

/**
 * __useApproveSaleLoanReleaseMutation__
 *
 * To run a mutation, you first call `useApproveSaleLoanReleaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveSaleLoanReleaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveSaleLoanReleaseMutation, { data, loading, error }] = useApproveSaleLoanReleaseMutation({
 *   variables: {
 *      releaseId: // value for 'releaseId'
 *   },
 * });
 */
export function useApproveSaleLoanReleaseMutation(baseOptions?: Apollo.MutationHookOptions<ApproveSaleLoanReleaseMutation, ApproveSaleLoanReleaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveSaleLoanReleaseMutation, ApproveSaleLoanReleaseMutationVariables>(ApproveSaleLoanReleaseDocument, options);
      }
export type ApproveSaleLoanReleaseMutationHookResult = ReturnType<typeof useApproveSaleLoanReleaseMutation>;
export type ApproveSaleLoanReleaseMutationResult = Apollo.MutationResult<ApproveSaleLoanReleaseMutation>;
export type ApproveSaleLoanReleaseMutationOptions = Apollo.BaseMutationOptions<ApproveSaleLoanReleaseMutation, ApproveSaleLoanReleaseMutationVariables>;
export const RejectSaleLoanReleaseDocument = gql`
    mutation rejectSaleLoanRelease($releaseId: String!) {
  rejectSaleLoanRelease(releaseId: $releaseId)
}
    `;
export type RejectSaleLoanReleaseMutationFn = Apollo.MutationFunction<RejectSaleLoanReleaseMutation, RejectSaleLoanReleaseMutationVariables>;

/**
 * __useRejectSaleLoanReleaseMutation__
 *
 * To run a mutation, you first call `useRejectSaleLoanReleaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectSaleLoanReleaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectSaleLoanReleaseMutation, { data, loading, error }] = useRejectSaleLoanReleaseMutation({
 *   variables: {
 *      releaseId: // value for 'releaseId'
 *   },
 * });
 */
export function useRejectSaleLoanReleaseMutation(baseOptions?: Apollo.MutationHookOptions<RejectSaleLoanReleaseMutation, RejectSaleLoanReleaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectSaleLoanReleaseMutation, RejectSaleLoanReleaseMutationVariables>(RejectSaleLoanReleaseDocument, options);
      }
export type RejectSaleLoanReleaseMutationHookResult = ReturnType<typeof useRejectSaleLoanReleaseMutation>;
export type RejectSaleLoanReleaseMutationResult = Apollo.MutationResult<RejectSaleLoanReleaseMutation>;
export type RejectSaleLoanReleaseMutationOptions = Apollo.BaseMutationOptions<RejectSaleLoanReleaseMutation, RejectSaleLoanReleaseMutationVariables>;
export const GetLoanReleaseNotificationELetterDocument = gql`
    query getLoanReleaseNotificationELetter($saleLoanIds: [String!], $financierId: String!, $letterTemplateId: String!, $loanReleaseId: String, $mortgagePaymentId: String, $mortgageRetentionId: String) {
  getLoanReleaseNotificationELetter(saleLoanIds: $saleLoanIds, financierId: $financierId, letterTemplateId: $letterTemplateId, loanReleaseId: $loanReleaseId, mortgagePaymentId: $mortgagePaymentId, mortgageRetentionId: $mortgageRetentionId) {
    content
    fileName
  }
}
    `;

/**
 * __useGetLoanReleaseNotificationELetterQuery__
 *
 * To run a query within a React component, call `useGetLoanReleaseNotificationELetterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoanReleaseNotificationELetterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoanReleaseNotificationELetterQuery({
 *   variables: {
 *      saleLoanIds: // value for 'saleLoanIds'
 *      financierId: // value for 'financierId'
 *      letterTemplateId: // value for 'letterTemplateId'
 *      loanReleaseId: // value for 'loanReleaseId'
 *      mortgagePaymentId: // value for 'mortgagePaymentId'
 *      mortgageRetentionId: // value for 'mortgageRetentionId'
 *   },
 * });
 */
export function useGetLoanReleaseNotificationELetterQuery(baseOptions: Apollo.QueryHookOptions<GetLoanReleaseNotificationELetterQuery, GetLoanReleaseNotificationELetterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoanReleaseNotificationELetterQuery, GetLoanReleaseNotificationELetterQueryVariables>(GetLoanReleaseNotificationELetterDocument, options);
      }
export function useGetLoanReleaseNotificationELetterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLoanReleaseNotificationELetterQuery, GetLoanReleaseNotificationELetterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoanReleaseNotificationELetterQuery, GetLoanReleaseNotificationELetterQueryVariables>(GetLoanReleaseNotificationELetterDocument, options);
        }
export type GetLoanReleaseNotificationELetterQueryHookResult = ReturnType<typeof useGetLoanReleaseNotificationELetterQuery>;
export type GetLoanReleaseNotificationELetterLazyQueryHookResult = ReturnType<typeof useGetLoanReleaseNotificationELetterLazyQuery>;
export type GetLoanReleaseNotificationELetterQueryResult = Apollo.QueryResult<GetLoanReleaseNotificationELetterQuery, GetLoanReleaseNotificationELetterQueryVariables>;
export const GetLoanReleaseNotificationProjectELetterListingDocument = gql`
    query getLoanReleaseNotificationProjectELetterListing($projectId: String!) {
  getLoanReleaseNotificationProjectELetterListing(projectId: $projectId) {
    id
    name
    letterType
    defaulted
  }
}
    `;

/**
 * __useGetLoanReleaseNotificationProjectELetterListingQuery__
 *
 * To run a query within a React component, call `useGetLoanReleaseNotificationProjectELetterListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoanReleaseNotificationProjectELetterListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoanReleaseNotificationProjectELetterListingQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetLoanReleaseNotificationProjectELetterListingQuery(baseOptions: Apollo.QueryHookOptions<GetLoanReleaseNotificationProjectELetterListingQuery, GetLoanReleaseNotificationProjectELetterListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoanReleaseNotificationProjectELetterListingQuery, GetLoanReleaseNotificationProjectELetterListingQueryVariables>(GetLoanReleaseNotificationProjectELetterListingDocument, options);
      }
export function useGetLoanReleaseNotificationProjectELetterListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLoanReleaseNotificationProjectELetterListingQuery, GetLoanReleaseNotificationProjectELetterListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoanReleaseNotificationProjectELetterListingQuery, GetLoanReleaseNotificationProjectELetterListingQueryVariables>(GetLoanReleaseNotificationProjectELetterListingDocument, options);
        }
export type GetLoanReleaseNotificationProjectELetterListingQueryHookResult = ReturnType<typeof useGetLoanReleaseNotificationProjectELetterListingQuery>;
export type GetLoanReleaseNotificationProjectELetterListingLazyQueryHookResult = ReturnType<typeof useGetLoanReleaseNotificationProjectELetterListingLazyQuery>;
export type GetLoanReleaseNotificationProjectELetterListingQueryResult = Apollo.QueryResult<GetLoanReleaseNotificationProjectELetterListingQuery, GetLoanReleaseNotificationProjectELetterListingQueryVariables>;
export const GetSaleLoanReleaseCountDocument = gql`
    query getSaleLoanReleaseCount($projectId: String!) {
  getSaleLoanReleaseCount(projectId: $projectId) {
    draftCount
    submittedCount
    approvedCount
  }
}
    `;

/**
 * __useGetSaleLoanReleaseCountQuery__
 *
 * To run a query within a React component, call `useGetSaleLoanReleaseCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSaleLoanReleaseCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSaleLoanReleaseCountQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetSaleLoanReleaseCountQuery(baseOptions: Apollo.QueryHookOptions<GetSaleLoanReleaseCountQuery, GetSaleLoanReleaseCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSaleLoanReleaseCountQuery, GetSaleLoanReleaseCountQueryVariables>(GetSaleLoanReleaseCountDocument, options);
      }
export function useGetSaleLoanReleaseCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSaleLoanReleaseCountQuery, GetSaleLoanReleaseCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSaleLoanReleaseCountQuery, GetSaleLoanReleaseCountQueryVariables>(GetSaleLoanReleaseCountDocument, options);
        }
export type GetSaleLoanReleaseCountQueryHookResult = ReturnType<typeof useGetSaleLoanReleaseCountQuery>;
export type GetSaleLoanReleaseCountLazyQueryHookResult = ReturnType<typeof useGetSaleLoanReleaseCountLazyQuery>;
export type GetSaleLoanReleaseCountQueryResult = Apollo.QueryResult<GetSaleLoanReleaseCountQuery, GetSaleLoanReleaseCountQueryVariables>;
export const GetAllMotTrackingDocument = gql`
    query getAllMotTracking($projectId: String!) {
  getAllMotTracking(projectId: $projectId) {
    id
    unitNo
    titleExecutionDate
    titleNotificationDate
  }
}
    `;

/**
 * __useGetAllMotTrackingQuery__
 *
 * To run a query within a React component, call `useGetAllMotTrackingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllMotTrackingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllMotTrackingQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetAllMotTrackingQuery(baseOptions: Apollo.QueryHookOptions<GetAllMotTrackingQuery, GetAllMotTrackingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllMotTrackingQuery, GetAllMotTrackingQueryVariables>(GetAllMotTrackingDocument, options);
      }
export function useGetAllMotTrackingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllMotTrackingQuery, GetAllMotTrackingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllMotTrackingQuery, GetAllMotTrackingQueryVariables>(GetAllMotTrackingDocument, options);
        }
export type GetAllMotTrackingQueryHookResult = ReturnType<typeof useGetAllMotTrackingQuery>;
export type GetAllMotTrackingLazyQueryHookResult = ReturnType<typeof useGetAllMotTrackingLazyQuery>;
export type GetAllMotTrackingQueryResult = Apollo.QueryResult<GetAllMotTrackingQuery, GetAllMotTrackingQueryVariables>;
export const GetAllUnitMotTrackingDocument = gql`
    query getAllUnitMotTracking($projectId: String!) {
  getAllUnitMotTracking(projectId: $projectId) {
    saleId
    unitNo
    hsdHsmNo
    lotPtNo
    buyerSolicitorName
    buyerSolicitorCode
    developerSolicitorName
    developerSolicitorCode
  }
}
    `;

/**
 * __useGetAllUnitMotTrackingQuery__
 *
 * To run a query within a React component, call `useGetAllUnitMotTrackingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllUnitMotTrackingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllUnitMotTrackingQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetAllUnitMotTrackingQuery(baseOptions: Apollo.QueryHookOptions<GetAllUnitMotTrackingQuery, GetAllUnitMotTrackingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllUnitMotTrackingQuery, GetAllUnitMotTrackingQueryVariables>(GetAllUnitMotTrackingDocument, options);
      }
export function useGetAllUnitMotTrackingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllUnitMotTrackingQuery, GetAllUnitMotTrackingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllUnitMotTrackingQuery, GetAllUnitMotTrackingQueryVariables>(GetAllUnitMotTrackingDocument, options);
        }
export type GetAllUnitMotTrackingQueryHookResult = ReturnType<typeof useGetAllUnitMotTrackingQuery>;
export type GetAllUnitMotTrackingLazyQueryHookResult = ReturnType<typeof useGetAllUnitMotTrackingLazyQuery>;
export type GetAllUnitMotTrackingQueryResult = Apollo.QueryResult<GetAllUnitMotTrackingQuery, GetAllUnitMotTrackingQueryVariables>;
export const GetMotTrackingByIdDocument = gql`
    query getMotTrackingById($projectId: String!, $id: String!) {
  getMotTrackingById(projectId: $projectId, id: $id) {
    unitNo
    hsdHsmNo
    lotPtNo
    titleExecutionDate
    titleNotificationDate
    titleForward
    motReceiptNo
    motTransferDate
    motSubmissionNo
    motSubmissionDate
    motMortgageNo
    motMortgageDate
    instructionToSolicitor
    motIn
    motOut
    receiveMotCancellation
    forwardMotDirector
    receiveMotDirector
    forwardMotComSec
    receiveMotComSec
    receiveLawyerAcknowledgement
    requestForTitle
    releaseForTitle
    receivedTitleDutyTransferred
    confirmationPresentationReceipt
    receivedFrom
    stampDutyPaymentDate
    stampDutyPayment
    remark
    buyerSolicitorName
    buyerSolicitorCode
    developerSolicitorName
    developerSolicitorCode
    motSolicitorId
    motSolicitorReferenceNo
  }
}
    `;

/**
 * __useGetMotTrackingByIdQuery__
 *
 * To run a query within a React component, call `useGetMotTrackingByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMotTrackingByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMotTrackingByIdQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMotTrackingByIdQuery(baseOptions: Apollo.QueryHookOptions<GetMotTrackingByIdQuery, GetMotTrackingByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMotTrackingByIdQuery, GetMotTrackingByIdQueryVariables>(GetMotTrackingByIdDocument, options);
      }
export function useGetMotTrackingByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMotTrackingByIdQuery, GetMotTrackingByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMotTrackingByIdQuery, GetMotTrackingByIdQueryVariables>(GetMotTrackingByIdDocument, options);
        }
export type GetMotTrackingByIdQueryHookResult = ReturnType<typeof useGetMotTrackingByIdQuery>;
export type GetMotTrackingByIdLazyQueryHookResult = ReturnType<typeof useGetMotTrackingByIdLazyQuery>;
export type GetMotTrackingByIdQueryResult = Apollo.QueryResult<GetMotTrackingByIdQuery, GetMotTrackingByIdQueryVariables>;
export const AddMotTrackingDocument = gql`
    mutation addMotTracking($input: AddMotTrackingInput!) {
  addMotTracking(input: $input)
}
    `;
export type AddMotTrackingMutationFn = Apollo.MutationFunction<AddMotTrackingMutation, AddMotTrackingMutationVariables>;

/**
 * __useAddMotTrackingMutation__
 *
 * To run a mutation, you first call `useAddMotTrackingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMotTrackingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMotTrackingMutation, { data, loading, error }] = useAddMotTrackingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddMotTrackingMutation(baseOptions?: Apollo.MutationHookOptions<AddMotTrackingMutation, AddMotTrackingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMotTrackingMutation, AddMotTrackingMutationVariables>(AddMotTrackingDocument, options);
      }
export type AddMotTrackingMutationHookResult = ReturnType<typeof useAddMotTrackingMutation>;
export type AddMotTrackingMutationResult = Apollo.MutationResult<AddMotTrackingMutation>;
export type AddMotTrackingMutationOptions = Apollo.BaseMutationOptions<AddMotTrackingMutation, AddMotTrackingMutationVariables>;
export const EditMotTrackingDocument = gql`
    mutation editMotTracking($input: EditMotTrackingInput!) {
  editMotTracking(input: $input)
}
    `;
export type EditMotTrackingMutationFn = Apollo.MutationFunction<EditMotTrackingMutation, EditMotTrackingMutationVariables>;

/**
 * __useEditMotTrackingMutation__
 *
 * To run a mutation, you first call `useEditMotTrackingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditMotTrackingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editMotTrackingMutation, { data, loading, error }] = useEditMotTrackingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditMotTrackingMutation(baseOptions?: Apollo.MutationHookOptions<EditMotTrackingMutation, EditMotTrackingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditMotTrackingMutation, EditMotTrackingMutationVariables>(EditMotTrackingDocument, options);
      }
export type EditMotTrackingMutationHookResult = ReturnType<typeof useEditMotTrackingMutation>;
export type EditMotTrackingMutationResult = Apollo.MutationResult<EditMotTrackingMutation>;
export type EditMotTrackingMutationOptions = Apollo.BaseMutationOptions<EditMotTrackingMutation, EditMotTrackingMutationVariables>;
export const DeleteMotTrackingDocument = gql`
    mutation deleteMotTracking($motTrackingId: String!) {
  deleteMotTracking(motTrackingId: $motTrackingId)
}
    `;
export type DeleteMotTrackingMutationFn = Apollo.MutationFunction<DeleteMotTrackingMutation, DeleteMotTrackingMutationVariables>;

/**
 * __useDeleteMotTrackingMutation__
 *
 * To run a mutation, you first call `useDeleteMotTrackingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMotTrackingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMotTrackingMutation, { data, loading, error }] = useDeleteMotTrackingMutation({
 *   variables: {
 *      motTrackingId: // value for 'motTrackingId'
 *   },
 * });
 */
export function useDeleteMotTrackingMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMotTrackingMutation, DeleteMotTrackingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMotTrackingMutation, DeleteMotTrackingMutationVariables>(DeleteMotTrackingDocument, options);
      }
export type DeleteMotTrackingMutationHookResult = ReturnType<typeof useDeleteMotTrackingMutation>;
export type DeleteMotTrackingMutationResult = Apollo.MutationResult<DeleteMotTrackingMutation>;
export type DeleteMotTrackingMutationOptions = Apollo.BaseMutationOptions<DeleteMotTrackingMutation, DeleteMotTrackingMutationVariables>;
export const GetNupListingDocument = gql`
    query getNupListing($projectId: String!, $approvalStatus: String, $nupId: String) {
  getNupListing(projectId: $projectId, approvalStatus: $approvalStatus, nupId: $nupId) {
    id
    unitId
    contactId
    contact {
      name
    }
    agentName
    unitNo
    cluster
    type
    media
    code
    status
    amount
    description
    remarks
    reason
    reservedDate
    expiredDate
    nupNumber
    rejectedBy
    rejectedTs
    ktpUrl
    npwpUrl
    paymentUrl
  }
}
    `;

/**
 * __useGetNupListingQuery__
 *
 * To run a query within a React component, call `useGetNupListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNupListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNupListingQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      approvalStatus: // value for 'approvalStatus'
 *      nupId: // value for 'nupId'
 *   },
 * });
 */
export function useGetNupListingQuery(baseOptions: Apollo.QueryHookOptions<GetNupListingQuery, GetNupListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNupListingQuery, GetNupListingQueryVariables>(GetNupListingDocument, options);
      }
export function useGetNupListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNupListingQuery, GetNupListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNupListingQuery, GetNupListingQueryVariables>(GetNupListingDocument, options);
        }
export type GetNupListingQueryHookResult = ReturnType<typeof useGetNupListingQuery>;
export type GetNupListingLazyQueryHookResult = ReturnType<typeof useGetNupListingLazyQuery>;
export type GetNupListingQueryResult = Apollo.QueryResult<GetNupListingQuery, GetNupListingQueryVariables>;
export const SubmitNupDocument = gql`
    mutation submitNup($status: String!, $nupId: String!) {
  submitNup(status: $status, nupId: $nupId)
}
    `;
export type SubmitNupMutationFn = Apollo.MutationFunction<SubmitNupMutation, SubmitNupMutationVariables>;

/**
 * __useSubmitNupMutation__
 *
 * To run a mutation, you first call `useSubmitNupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitNupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitNupMutation, { data, loading, error }] = useSubmitNupMutation({
 *   variables: {
 *      status: // value for 'status'
 *      nupId: // value for 'nupId'
 *   },
 * });
 */
export function useSubmitNupMutation(baseOptions?: Apollo.MutationHookOptions<SubmitNupMutation, SubmitNupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitNupMutation, SubmitNupMutationVariables>(SubmitNupDocument, options);
      }
export type SubmitNupMutationHookResult = ReturnType<typeof useSubmitNupMutation>;
export type SubmitNupMutationResult = Apollo.MutationResult<SubmitNupMutation>;
export type SubmitNupMutationOptions = Apollo.BaseMutationOptions<SubmitNupMutation, SubmitNupMutationVariables>;
export const GetNupCountDocument = gql`
    query getNupCount($projectId: String!) {
  getNupCount(projectId: $projectId) {
    pending
    approve
    reject
  }
}
    `;

/**
 * __useGetNupCountQuery__
 *
 * To run a query within a React component, call `useGetNupCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNupCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNupCountQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetNupCountQuery(baseOptions: Apollo.QueryHookOptions<GetNupCountQuery, GetNupCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNupCountQuery, GetNupCountQueryVariables>(GetNupCountDocument, options);
      }
export function useGetNupCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNupCountQuery, GetNupCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNupCountQuery, GetNupCountQueryVariables>(GetNupCountDocument, options);
        }
export type GetNupCountQueryHookResult = ReturnType<typeof useGetNupCountQuery>;
export type GetNupCountLazyQueryHookResult = ReturnType<typeof useGetNupCountLazyQuery>;
export type GetNupCountQueryResult = Apollo.QueryResult<GetNupCountQuery, GetNupCountQueryVariables>;
export const GetNotificationHistoryDayDocument = gql`
    query getNotificationHistoryDay {
  getNotificationHistoryDay
}
    `;

/**
 * __useGetNotificationHistoryDayQuery__
 *
 * To run a query within a React component, call `useGetNotificationHistoryDayQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationHistoryDayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationHistoryDayQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNotificationHistoryDayQuery(baseOptions?: Apollo.QueryHookOptions<GetNotificationHistoryDayQuery, GetNotificationHistoryDayQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationHistoryDayQuery, GetNotificationHistoryDayQueryVariables>(GetNotificationHistoryDayDocument, options);
      }
export function useGetNotificationHistoryDayLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationHistoryDayQuery, GetNotificationHistoryDayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationHistoryDayQuery, GetNotificationHistoryDayQueryVariables>(GetNotificationHistoryDayDocument, options);
        }
export type GetNotificationHistoryDayQueryHookResult = ReturnType<typeof useGetNotificationHistoryDayQuery>;
export type GetNotificationHistoryDayLazyQueryHookResult = ReturnType<typeof useGetNotificationHistoryDayLazyQuery>;
export type GetNotificationHistoryDayQueryResult = Apollo.QueryResult<GetNotificationHistoryDayQuery, GetNotificationHistoryDayQueryVariables>;
export const SaveNotificationPermissionDocument = gql`
    mutation saveNotificationPermission($input: NotificationInput!) {
  saveNotificationPermission(input: $input)
}
    `;
export type SaveNotificationPermissionMutationFn = Apollo.MutationFunction<SaveNotificationPermissionMutation, SaveNotificationPermissionMutationVariables>;

/**
 * __useSaveNotificationPermissionMutation__
 *
 * To run a mutation, you first call `useSaveNotificationPermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveNotificationPermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveNotificationPermissionMutation, { data, loading, error }] = useSaveNotificationPermissionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveNotificationPermissionMutation(baseOptions?: Apollo.MutationHookOptions<SaveNotificationPermissionMutation, SaveNotificationPermissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveNotificationPermissionMutation, SaveNotificationPermissionMutationVariables>(SaveNotificationPermissionDocument, options);
      }
export type SaveNotificationPermissionMutationHookResult = ReturnType<typeof useSaveNotificationPermissionMutation>;
export type SaveNotificationPermissionMutationResult = Apollo.MutationResult<SaveNotificationPermissionMutation>;
export type SaveNotificationPermissionMutationOptions = Apollo.BaseMutationOptions<SaveNotificationPermissionMutation, SaveNotificationPermissionMutationVariables>;
export const GetPurchaserPaymentScheduleDocument = gql`
    query getPurchaserPaymentSchedule($projectId: String!, $search: String) {
  getPurchaserPaymentSchedule(projectId: $projectId, search: $search) {
    saleId
    salesNo
    salesRegistrationNo
    salesRegNo
    unitNo
    fullName
    bookDate
    sellingPrice
    clusterName
    detail {
      documentDate
      baseAmt
      taxAmt
      documentAmt
      description
    }
  }
}
    `;

/**
 * __useGetPurchaserPaymentScheduleQuery__
 *
 * To run a query within a React component, call `useGetPurchaserPaymentScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPurchaserPaymentScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPurchaserPaymentScheduleQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetPurchaserPaymentScheduleQuery(baseOptions: Apollo.QueryHookOptions<GetPurchaserPaymentScheduleQuery, GetPurchaserPaymentScheduleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPurchaserPaymentScheduleQuery, GetPurchaserPaymentScheduleQueryVariables>(GetPurchaserPaymentScheduleDocument, options);
      }
export function useGetPurchaserPaymentScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPurchaserPaymentScheduleQuery, GetPurchaserPaymentScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPurchaserPaymentScheduleQuery, GetPurchaserPaymentScheduleQueryVariables>(GetPurchaserPaymentScheduleDocument, options);
        }
export type GetPurchaserPaymentScheduleQueryHookResult = ReturnType<typeof useGetPurchaserPaymentScheduleQuery>;
export type GetPurchaserPaymentScheduleLazyQueryHookResult = ReturnType<typeof useGetPurchaserPaymentScheduleLazyQuery>;
export type GetPurchaserPaymentScheduleQueryResult = Apollo.QueryResult<GetPurchaserPaymentScheduleQuery, GetPurchaserPaymentScheduleQueryVariables>;
export const GetRescheduleInstallmentDocument = gql`
    query getRescheduleInstallment($projectId: String!, $saleId: String!) {
  getRescheduleInstallment(projectId: $projectId, saleId: $saleId) {
    rescheduleId
    saleId
    docNo
    docDate
    descs
    approvalStatus
    installment
    premiumAmt
    billType
    precision
  }
}
    `;

/**
 * __useGetRescheduleInstallmentQuery__
 *
 * To run a query within a React component, call `useGetRescheduleInstallmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRescheduleInstallmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRescheduleInstallmentQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetRescheduleInstallmentQuery(baseOptions: Apollo.QueryHookOptions<GetRescheduleInstallmentQuery, GetRescheduleInstallmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRescheduleInstallmentQuery, GetRescheduleInstallmentQueryVariables>(GetRescheduleInstallmentDocument, options);
      }
export function useGetRescheduleInstallmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRescheduleInstallmentQuery, GetRescheduleInstallmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRescheduleInstallmentQuery, GetRescheduleInstallmentQueryVariables>(GetRescheduleInstallmentDocument, options);
        }
export type GetRescheduleInstallmentQueryHookResult = ReturnType<typeof useGetRescheduleInstallmentQuery>;
export type GetRescheduleInstallmentLazyQueryHookResult = ReturnType<typeof useGetRescheduleInstallmentLazyQuery>;
export type GetRescheduleInstallmentQueryResult = Apollo.QueryResult<GetRescheduleInstallmentQuery, GetRescheduleInstallmentQueryVariables>;
export const GetRescheduleDetailsDocument = gql`
    query getRescheduleDetails($rescheduleId: String!) {
  getRescheduleDetails(rescheduleId: $rescheduleId) {
    id
    rescheduleId
    ledgerType
    documentDate
    baseAmt
    taxAmt
    description
    isSelected
    reschedule {
      premiumAmt
      startDate
    }
    unallocatedAmount
    billType
  }
}
    `;

/**
 * __useGetRescheduleDetailsQuery__
 *
 * To run a query within a React component, call `useGetRescheduleDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRescheduleDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRescheduleDetailsQuery({
 *   variables: {
 *      rescheduleId: // value for 'rescheduleId'
 *   },
 * });
 */
export function useGetRescheduleDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetRescheduleDetailsQuery, GetRescheduleDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRescheduleDetailsQuery, GetRescheduleDetailsQueryVariables>(GetRescheduleDetailsDocument, options);
      }
export function useGetRescheduleDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRescheduleDetailsQuery, GetRescheduleDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRescheduleDetailsQuery, GetRescheduleDetailsQueryVariables>(GetRescheduleDetailsDocument, options);
        }
export type GetRescheduleDetailsQueryHookResult = ReturnType<typeof useGetRescheduleDetailsQuery>;
export type GetRescheduleDetailsLazyQueryHookResult = ReturnType<typeof useGetRescheduleDetailsLazyQuery>;
export type GetRescheduleDetailsQueryResult = Apollo.QueryResult<GetRescheduleDetailsQuery, GetRescheduleDetailsQueryVariables>;
export const GetInstallmentListDocument = gql`
    query getInstallmentList($saleId: String!) {
  getInstallmentList(saleId: $saleId) {
    id
    saleId
    rescheduleId
    projectId
    glGenerationBatch
    documentDate
    documentAmt
    baseAmt
    taxAmt
    unallocatedAmount
    transDate
    description
    interestRate
    glGenerated
    billType
    salePaymentId
    commonStatus
    sale {
      unitId
      salesNo
      salesStatus
      listPrice
    }
    approvalStatus {
      approvalstatus
    }
  }
}
    `;

/**
 * __useGetInstallmentListQuery__
 *
 * To run a query within a React component, call `useGetInstallmentListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstallmentListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstallmentListQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetInstallmentListQuery(baseOptions: Apollo.QueryHookOptions<GetInstallmentListQuery, GetInstallmentListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstallmentListQuery, GetInstallmentListQueryVariables>(GetInstallmentListDocument, options);
      }
export function useGetInstallmentListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstallmentListQuery, GetInstallmentListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstallmentListQuery, GetInstallmentListQueryVariables>(GetInstallmentListDocument, options);
        }
export type GetInstallmentListQueryHookResult = ReturnType<typeof useGetInstallmentListQuery>;
export type GetInstallmentListLazyQueryHookResult = ReturnType<typeof useGetInstallmentListLazyQuery>;
export type GetInstallmentListQueryResult = Apollo.QueryResult<GetInstallmentListQuery, GetInstallmentListQueryVariables>;
export const GetInstallmentPendingListDocument = gql`
    query getInstallmentPendingList($saleId: String!, $rescheduleId: String!) {
  getInstallmentPendingList(saleId: $saleId, rescheduleId: $rescheduleId) {
    id
    saleId
    rescheduleId
    projectId
    glGenerationBatch
    documentDate
    documentAmt
    baseAmt
    taxAmt
    unallocatedAmount
    transDate
    description
    interestRate
    glGenerated
    billType
    salePaymentId
    commonStatus
    ledgerType
    oldInstallmentId
    sale {
      unitId
      salesNo
      salesStatus
      listPrice
    }
  }
}
    `;

/**
 * __useGetInstallmentPendingListQuery__
 *
 * To run a query within a React component, call `useGetInstallmentPendingListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstallmentPendingListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstallmentPendingListQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *      rescheduleId: // value for 'rescheduleId'
 *   },
 * });
 */
export function useGetInstallmentPendingListQuery(baseOptions: Apollo.QueryHookOptions<GetInstallmentPendingListQuery, GetInstallmentPendingListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstallmentPendingListQuery, GetInstallmentPendingListQueryVariables>(GetInstallmentPendingListDocument, options);
      }
export function useGetInstallmentPendingListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstallmentPendingListQuery, GetInstallmentPendingListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstallmentPendingListQuery, GetInstallmentPendingListQueryVariables>(GetInstallmentPendingListDocument, options);
        }
export type GetInstallmentPendingListQueryHookResult = ReturnType<typeof useGetInstallmentPendingListQuery>;
export type GetInstallmentPendingListLazyQueryHookResult = ReturnType<typeof useGetInstallmentPendingListLazyQuery>;
export type GetInstallmentPendingListQueryResult = Apollo.QueryResult<GetInstallmentPendingListQuery, GetInstallmentPendingListQueryVariables>;
export const GetApprovedRescheduleListDocument = gql`
    query getApprovedRescheduleList($saleId: String!, $rescheduleId: String!) {
  getApprovedRescheduleList(saleId: $saleId, rescheduleId: $rescheduleId) {
    rescheduleid
    installmentid
    isbuyerportion
    billtype
    ledgertype
    isselected
    documentdate
    description
    documentamount
    rescheduleno
    rescheduledate
    expiredate
    expiryby
    baseamt
    taxamt
    unallocatedamount
    oldinstallmentid
    commonstatus
  }
}
    `;

/**
 * __useGetApprovedRescheduleListQuery__
 *
 * To run a query within a React component, call `useGetApprovedRescheduleListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApprovedRescheduleListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApprovedRescheduleListQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *      rescheduleId: // value for 'rescheduleId'
 *   },
 * });
 */
export function useGetApprovedRescheduleListQuery(baseOptions: Apollo.QueryHookOptions<GetApprovedRescheduleListQuery, GetApprovedRescheduleListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApprovedRescheduleListQuery, GetApprovedRescheduleListQueryVariables>(GetApprovedRescheduleListDocument, options);
      }
export function useGetApprovedRescheduleListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApprovedRescheduleListQuery, GetApprovedRescheduleListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApprovedRescheduleListQuery, GetApprovedRescheduleListQueryVariables>(GetApprovedRescheduleListDocument, options);
        }
export type GetApprovedRescheduleListQueryHookResult = ReturnType<typeof useGetApprovedRescheduleListQuery>;
export type GetApprovedRescheduleListLazyQueryHookResult = ReturnType<typeof useGetApprovedRescheduleListLazyQuery>;
export type GetApprovedRescheduleListQueryResult = Apollo.QueryResult<GetApprovedRescheduleListQuery, GetApprovedRescheduleListQueryVariables>;
export const AddRescheduleInstallmentDocument = gql`
    mutation addRescheduleInstallment($input: rescheduleInstInput!) {
  addRescheduleInstallment(input: $input)
}
    `;
export type AddRescheduleInstallmentMutationFn = Apollo.MutationFunction<AddRescheduleInstallmentMutation, AddRescheduleInstallmentMutationVariables>;

/**
 * __useAddRescheduleInstallmentMutation__
 *
 * To run a mutation, you first call `useAddRescheduleInstallmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRescheduleInstallmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRescheduleInstallmentMutation, { data, loading, error }] = useAddRescheduleInstallmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddRescheduleInstallmentMutation(baseOptions?: Apollo.MutationHookOptions<AddRescheduleInstallmentMutation, AddRescheduleInstallmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddRescheduleInstallmentMutation, AddRescheduleInstallmentMutationVariables>(AddRescheduleInstallmentDocument, options);
      }
export type AddRescheduleInstallmentMutationHookResult = ReturnType<typeof useAddRescheduleInstallmentMutation>;
export type AddRescheduleInstallmentMutationResult = Apollo.MutationResult<AddRescheduleInstallmentMutation>;
export type AddRescheduleInstallmentMutationOptions = Apollo.BaseMutationOptions<AddRescheduleInstallmentMutation, AddRescheduleInstallmentMutationVariables>;
export const GetInstallmentApprovalListDocument = gql`
    query getInstallmentApprovalList($projectId: String!, $status: String!) {
  getInstallmentApprovalList(projectId: $projectId, status: $status) {
    rescheduleId
    saleId
    docNo
    docDate
    descs
    approvalStatus
    installment
    premiumAmt
    unitNo
    clusterName
    billType
    createdBy
    modBy
    createdTs
    modTs
    createdByName
    modByName
  }
}
    `;

/**
 * __useGetInstallmentApprovalListQuery__
 *
 * To run a query within a React component, call `useGetInstallmentApprovalListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstallmentApprovalListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstallmentApprovalListQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetInstallmentApprovalListQuery(baseOptions: Apollo.QueryHookOptions<GetInstallmentApprovalListQuery, GetInstallmentApprovalListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstallmentApprovalListQuery, GetInstallmentApprovalListQueryVariables>(GetInstallmentApprovalListDocument, options);
      }
export function useGetInstallmentApprovalListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstallmentApprovalListQuery, GetInstallmentApprovalListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstallmentApprovalListQuery, GetInstallmentApprovalListQueryVariables>(GetInstallmentApprovalListDocument, options);
        }
export type GetInstallmentApprovalListQueryHookResult = ReturnType<typeof useGetInstallmentApprovalListQuery>;
export type GetInstallmentApprovalListLazyQueryHookResult = ReturnType<typeof useGetInstallmentApprovalListLazyQuery>;
export type GetInstallmentApprovalListQueryResult = Apollo.QueryResult<GetInstallmentApprovalListQuery, GetInstallmentApprovalListQueryVariables>;
export const ApproveRescheduleInstallmentDocument = gql`
    mutation approveRescheduleInstallment($saleId: String!, $rescheduleId: String!) {
  approveRescheduleInstallment(saleId: $saleId, rescheduleId: $rescheduleId)
}
    `;
export type ApproveRescheduleInstallmentMutationFn = Apollo.MutationFunction<ApproveRescheduleInstallmentMutation, ApproveRescheduleInstallmentMutationVariables>;

/**
 * __useApproveRescheduleInstallmentMutation__
 *
 * To run a mutation, you first call `useApproveRescheduleInstallmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveRescheduleInstallmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveRescheduleInstallmentMutation, { data, loading, error }] = useApproveRescheduleInstallmentMutation({
 *   variables: {
 *      saleId: // value for 'saleId'
 *      rescheduleId: // value for 'rescheduleId'
 *   },
 * });
 */
export function useApproveRescheduleInstallmentMutation(baseOptions?: Apollo.MutationHookOptions<ApproveRescheduleInstallmentMutation, ApproveRescheduleInstallmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveRescheduleInstallmentMutation, ApproveRescheduleInstallmentMutationVariables>(ApproveRescheduleInstallmentDocument, options);
      }
export type ApproveRescheduleInstallmentMutationHookResult = ReturnType<typeof useApproveRescheduleInstallmentMutation>;
export type ApproveRescheduleInstallmentMutationResult = Apollo.MutationResult<ApproveRescheduleInstallmentMutation>;
export type ApproveRescheduleInstallmentMutationOptions = Apollo.BaseMutationOptions<ApproveRescheduleInstallmentMutation, ApproveRescheduleInstallmentMutationVariables>;
export const RejectRescheduleInstallmentDocument = gql`
    mutation rejectRescheduleInstallment($saleId: String!, $rescheduleId: String!) {
  rejectRescheduleInstallment(saleId: $saleId, rescheduleId: $rescheduleId)
}
    `;
export type RejectRescheduleInstallmentMutationFn = Apollo.MutationFunction<RejectRescheduleInstallmentMutation, RejectRescheduleInstallmentMutationVariables>;

/**
 * __useRejectRescheduleInstallmentMutation__
 *
 * To run a mutation, you first call `useRejectRescheduleInstallmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectRescheduleInstallmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectRescheduleInstallmentMutation, { data, loading, error }] = useRejectRescheduleInstallmentMutation({
 *   variables: {
 *      saleId: // value for 'saleId'
 *      rescheduleId: // value for 'rescheduleId'
 *   },
 * });
 */
export function useRejectRescheduleInstallmentMutation(baseOptions?: Apollo.MutationHookOptions<RejectRescheduleInstallmentMutation, RejectRescheduleInstallmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectRescheduleInstallmentMutation, RejectRescheduleInstallmentMutationVariables>(RejectRescheduleInstallmentDocument, options);
      }
export type RejectRescheduleInstallmentMutationHookResult = ReturnType<typeof useRejectRescheduleInstallmentMutation>;
export type RejectRescheduleInstallmentMutationResult = Apollo.MutationResult<RejectRescheduleInstallmentMutation>;
export type RejectRescheduleInstallmentMutationOptions = Apollo.BaseMutationOptions<RejectRescheduleInstallmentMutation, RejectRescheduleInstallmentMutationVariables>;
export const GetPrecisionRoundingDocument = gql`
    query getPrecisionRounding($projectId: String!) {
  getPrecisionRounding(projectId: $projectId)
}
    `;

/**
 * __useGetPrecisionRoundingQuery__
 *
 * To run a query within a React component, call `useGetPrecisionRoundingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrecisionRoundingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrecisionRoundingQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetPrecisionRoundingQuery(baseOptions: Apollo.QueryHookOptions<GetPrecisionRoundingQuery, GetPrecisionRoundingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPrecisionRoundingQuery, GetPrecisionRoundingQueryVariables>(GetPrecisionRoundingDocument, options);
      }
export function useGetPrecisionRoundingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPrecisionRoundingQuery, GetPrecisionRoundingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPrecisionRoundingQuery, GetPrecisionRoundingQueryVariables>(GetPrecisionRoundingDocument, options);
        }
export type GetPrecisionRoundingQueryHookResult = ReturnType<typeof useGetPrecisionRoundingQuery>;
export type GetPrecisionRoundingLazyQueryHookResult = ReturnType<typeof useGetPrecisionRoundingLazyQuery>;
export type GetPrecisionRoundingQueryResult = Apollo.QueryResult<GetPrecisionRoundingQuery, GetPrecisionRoundingQueryVariables>;
export const GetAllArchitectCertDocument = gql`
    query getAllArchitectCert {
  getAllArchitectCert {
    id
    certificateNo
    certificateDate
    formattedCertificateDate
    billCount
    totalUnitCount
    approvedCount
    pendingCount
    allowReversal
    architectCertUnitStatus
    unitIds
    unitIndex
    billingStageIndex
    pbUnitIds
  }
}
    `;

/**
 * __useGetAllArchitectCertQuery__
 *
 * To run a query within a React component, call `useGetAllArchitectCertQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllArchitectCertQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllArchitectCertQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllArchitectCertQuery(baseOptions?: Apollo.QueryHookOptions<GetAllArchitectCertQuery, GetAllArchitectCertQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllArchitectCertQuery, GetAllArchitectCertQueryVariables>(GetAllArchitectCertDocument, options);
      }
export function useGetAllArchitectCertLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllArchitectCertQuery, GetAllArchitectCertQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllArchitectCertQuery, GetAllArchitectCertQueryVariables>(GetAllArchitectCertDocument, options);
        }
export type GetAllArchitectCertQueryHookResult = ReturnType<typeof useGetAllArchitectCertQuery>;
export type GetAllArchitectCertLazyQueryHookResult = ReturnType<typeof useGetAllArchitectCertLazyQuery>;
export type GetAllArchitectCertQueryResult = Apollo.QueryResult<GetAllArchitectCertQuery, GetAllArchitectCertQueryVariables>;
export const GetUnitWorkProgressCreateDocument = gql`
    query getUnitWorkProgressCreate($projectId: String!, $progressIds: [String!]!, $isCarpark: Boolean!) {
  getUnitWorkProgressCreate(projectId: $projectId, progressIds: $progressIds, isCarpark: $isCarpark) {
    block
    totalFloor
    floorList {
      floorLabel
      totalUnit
      unitList {
        unitId
        unitNo
      }
    }
  }
}
    `;

/**
 * __useGetUnitWorkProgressCreateQuery__
 *
 * To run a query within a React component, call `useGetUnitWorkProgressCreateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitWorkProgressCreateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitWorkProgressCreateQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      progressIds: // value for 'progressIds'
 *      isCarpark: // value for 'isCarpark'
 *   },
 * });
 */
export function useGetUnitWorkProgressCreateQuery(baseOptions: Apollo.QueryHookOptions<GetUnitWorkProgressCreateQuery, GetUnitWorkProgressCreateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitWorkProgressCreateQuery, GetUnitWorkProgressCreateQueryVariables>(GetUnitWorkProgressCreateDocument, options);
      }
export function useGetUnitWorkProgressCreateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitWorkProgressCreateQuery, GetUnitWorkProgressCreateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitWorkProgressCreateQuery, GetUnitWorkProgressCreateQueryVariables>(GetUnitWorkProgressCreateDocument, options);
        }
export type GetUnitWorkProgressCreateQueryHookResult = ReturnType<typeof useGetUnitWorkProgressCreateQuery>;
export type GetUnitWorkProgressCreateLazyQueryHookResult = ReturnType<typeof useGetUnitWorkProgressCreateLazyQuery>;
export type GetUnitWorkProgressCreateQueryResult = Apollo.QueryResult<GetUnitWorkProgressCreateQuery, GetUnitWorkProgressCreateQueryVariables>;
export const GetBlockFloorUnitDocument = gql`
    query getBlockFloorUnit($projectId: String!) {
  getBlockFloorUnit(projectId: $projectId) {
    block
    totalFloor
    floorList {
      floorLabel
      totalUnit
      unitList {
        unitId
        unitNo
      }
    }
  }
}
    `;

/**
 * __useGetBlockFloorUnitQuery__
 *
 * To run a query within a React component, call `useGetBlockFloorUnitQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlockFloorUnitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBlockFloorUnitQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetBlockFloorUnitQuery(baseOptions: Apollo.QueryHookOptions<GetBlockFloorUnitQuery, GetBlockFloorUnitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBlockFloorUnitQuery, GetBlockFloorUnitQueryVariables>(GetBlockFloorUnitDocument, options);
      }
export function useGetBlockFloorUnitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBlockFloorUnitQuery, GetBlockFloorUnitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBlockFloorUnitQuery, GetBlockFloorUnitQueryVariables>(GetBlockFloorUnitDocument, options);
        }
export type GetBlockFloorUnitQueryHookResult = ReturnType<typeof useGetBlockFloorUnitQuery>;
export type GetBlockFloorUnitLazyQueryHookResult = ReturnType<typeof useGetBlockFloorUnitLazyQuery>;
export type GetBlockFloorUnitQueryResult = Apollo.QueryResult<GetBlockFloorUnitQuery, GetBlockFloorUnitQueryVariables>;
export const GetUnitWorkProgressUpdateDocument = gql`
    query getUnitWorkProgressUpdate($projectId: String!, $id: String!, $isCarpark: Boolean!) {
  getUnitWorkProgressUpdate(projectId: $projectId, id: $id, isCarpark: $isCarpark) {
    block
    totalFloor
    floorList {
      floorLabel
      totalUnit
      unitList {
        unitId
        unitNo
      }
    }
  }
}
    `;

/**
 * __useGetUnitWorkProgressUpdateQuery__
 *
 * To run a query within a React component, call `useGetUnitWorkProgressUpdateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitWorkProgressUpdateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitWorkProgressUpdateQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      id: // value for 'id'
 *      isCarpark: // value for 'isCarpark'
 *   },
 * });
 */
export function useGetUnitWorkProgressUpdateQuery(baseOptions: Apollo.QueryHookOptions<GetUnitWorkProgressUpdateQuery, GetUnitWorkProgressUpdateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitWorkProgressUpdateQuery, GetUnitWorkProgressUpdateQueryVariables>(GetUnitWorkProgressUpdateDocument, options);
      }
export function useGetUnitWorkProgressUpdateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitWorkProgressUpdateQuery, GetUnitWorkProgressUpdateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitWorkProgressUpdateQuery, GetUnitWorkProgressUpdateQueryVariables>(GetUnitWorkProgressUpdateDocument, options);
        }
export type GetUnitWorkProgressUpdateQueryHookResult = ReturnType<typeof useGetUnitWorkProgressUpdateQuery>;
export type GetUnitWorkProgressUpdateLazyQueryHookResult = ReturnType<typeof useGetUnitWorkProgressUpdateLazyQuery>;
export type GetUnitWorkProgressUpdateQueryResult = Apollo.QueryResult<GetUnitWorkProgressUpdateQuery, GetUnitWorkProgressUpdateQueryVariables>;
export const GetProgressStageDocument = gql`
    query getProgressStage($projectId: String!, $isCarpark: Boolean!) {
  getProgressStage(projectId: $projectId, isCarpark: $isCarpark) {
    id
    name
    isCarPark
  }
}
    `;

/**
 * __useGetProgressStageQuery__
 *
 * To run a query within a React component, call `useGetProgressStageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgressStageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgressStageQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      isCarpark: // value for 'isCarpark'
 *   },
 * });
 */
export function useGetProgressStageQuery(baseOptions: Apollo.QueryHookOptions<GetProgressStageQuery, GetProgressStageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProgressStageQuery, GetProgressStageQueryVariables>(GetProgressStageDocument, options);
      }
export function useGetProgressStageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProgressStageQuery, GetProgressStageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProgressStageQuery, GetProgressStageQueryVariables>(GetProgressStageDocument, options);
        }
export type GetProgressStageQueryHookResult = ReturnType<typeof useGetProgressStageQuery>;
export type GetProgressStageLazyQueryHookResult = ReturnType<typeof useGetProgressStageLazyQuery>;
export type GetProgressStageQueryResult = Apollo.QueryResult<GetProgressStageQuery, GetProgressStageQueryVariables>;
export const GetArchitectCertByIdDocument = gql`
    query getArchitectCertById($architectCertId: String!, $projectId: String!) {
  getArchitectCertById(architectCertId: $architectCertId, projectId: $projectId) {
    id
    accountId
    projectId
    certificateDate
    certificateNo
    commonStatus
    architectCertUnit {
      unitId
      status
      units {
        unitNo
        id
        unitStatus
        saleSubProduct {
          sales {
            unit {
              unitNo
            }
          }
        }
      }
    }
    totalUnitCount
    getArchitectCertAttachment {
      resourceUrl
      mediaType
      fileName
    }
    architectCertWorkProgress {
      progress {
        name
        id
        isCarPark
      }
    }
    totalPostedBill
    architectCertUnitStatus
  }
}
    `;

/**
 * __useGetArchitectCertByIdQuery__
 *
 * To run a query within a React component, call `useGetArchitectCertByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArchitectCertByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArchitectCertByIdQuery({
 *   variables: {
 *      architectCertId: // value for 'architectCertId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetArchitectCertByIdQuery(baseOptions: Apollo.QueryHookOptions<GetArchitectCertByIdQuery, GetArchitectCertByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArchitectCertByIdQuery, GetArchitectCertByIdQueryVariables>(GetArchitectCertByIdDocument, options);
      }
export function useGetArchitectCertByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArchitectCertByIdQuery, GetArchitectCertByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArchitectCertByIdQuery, GetArchitectCertByIdQueryVariables>(GetArchitectCertByIdDocument, options);
        }
export type GetArchitectCertByIdQueryHookResult = ReturnType<typeof useGetArchitectCertByIdQuery>;
export type GetArchitectCertByIdLazyQueryHookResult = ReturnType<typeof useGetArchitectCertByIdLazyQuery>;
export type GetArchitectCertByIdQueryResult = Apollo.QueryResult<GetArchitectCertByIdQuery, GetArchitectCertByIdQueryVariables>;
export const AddArchitectCertDocument = gql`
    mutation addArchitectCert($input: ArchitectCertInput!) {
  addArchitectCert(input: $input)
}
    `;
export type AddArchitectCertMutationFn = Apollo.MutationFunction<AddArchitectCertMutation, AddArchitectCertMutationVariables>;

/**
 * __useAddArchitectCertMutation__
 *
 * To run a mutation, you first call `useAddArchitectCertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddArchitectCertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addArchitectCertMutation, { data, loading, error }] = useAddArchitectCertMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddArchitectCertMutation(baseOptions?: Apollo.MutationHookOptions<AddArchitectCertMutation, AddArchitectCertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddArchitectCertMutation, AddArchitectCertMutationVariables>(AddArchitectCertDocument, options);
      }
export type AddArchitectCertMutationHookResult = ReturnType<typeof useAddArchitectCertMutation>;
export type AddArchitectCertMutationResult = Apollo.MutationResult<AddArchitectCertMutation>;
export type AddArchitectCertMutationOptions = Apollo.BaseMutationOptions<AddArchitectCertMutation, AddArchitectCertMutationVariables>;
export const DeleteArchitectCertDocument = gql`
    mutation deleteArchitectCert($architectCertId: String!, $projectId: String!) {
  deleteArchitectCert(architectCertId: $architectCertId, projectId: $projectId)
}
    `;
export type DeleteArchitectCertMutationFn = Apollo.MutationFunction<DeleteArchitectCertMutation, DeleteArchitectCertMutationVariables>;

/**
 * __useDeleteArchitectCertMutation__
 *
 * To run a mutation, you first call `useDeleteArchitectCertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteArchitectCertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteArchitectCertMutation, { data, loading, error }] = useDeleteArchitectCertMutation({
 *   variables: {
 *      architectCertId: // value for 'architectCertId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useDeleteArchitectCertMutation(baseOptions?: Apollo.MutationHookOptions<DeleteArchitectCertMutation, DeleteArchitectCertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteArchitectCertMutation, DeleteArchitectCertMutationVariables>(DeleteArchitectCertDocument, options);
      }
export type DeleteArchitectCertMutationHookResult = ReturnType<typeof useDeleteArchitectCertMutation>;
export type DeleteArchitectCertMutationResult = Apollo.MutationResult<DeleteArchitectCertMutation>;
export type DeleteArchitectCertMutationOptions = Apollo.BaseMutationOptions<DeleteArchitectCertMutation, DeleteArchitectCertMutationVariables>;
export const EditArchitectCertDocument = gql`
    mutation editArchitectCert($input: EditArchitectCertInput!) {
  editArchitectCert(input: $input)
}
    `;
export type EditArchitectCertMutationFn = Apollo.MutationFunction<EditArchitectCertMutation, EditArchitectCertMutationVariables>;

/**
 * __useEditArchitectCertMutation__
 *
 * To run a mutation, you first call `useEditArchitectCertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditArchitectCertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editArchitectCertMutation, { data, loading, error }] = useEditArchitectCertMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditArchitectCertMutation(baseOptions?: Apollo.MutationHookOptions<EditArchitectCertMutation, EditArchitectCertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditArchitectCertMutation, EditArchitectCertMutationVariables>(EditArchitectCertDocument, options);
      }
export type EditArchitectCertMutationHookResult = ReturnType<typeof useEditArchitectCertMutation>;
export type EditArchitectCertMutationResult = Apollo.MutationResult<EditArchitectCertMutation>;
export type EditArchitectCertMutationOptions = Apollo.BaseMutationOptions<EditArchitectCertMutation, EditArchitectCertMutationVariables>;
export const ApprovalArchitectCertDocument = gql`
    mutation approvalArchitectCert($architectCertId: String!, $projectId: String!, $unitIds: [String!]!) {
  approvalArchitectCert(architectCertId: $architectCertId, projectId: $projectId, unitIds: $unitIds)
}
    `;
export type ApprovalArchitectCertMutationFn = Apollo.MutationFunction<ApprovalArchitectCertMutation, ApprovalArchitectCertMutationVariables>;

/**
 * __useApprovalArchitectCertMutation__
 *
 * To run a mutation, you first call `useApprovalArchitectCertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApprovalArchitectCertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approvalArchitectCertMutation, { data, loading, error }] = useApprovalArchitectCertMutation({
 *   variables: {
 *      architectCertId: // value for 'architectCertId'
 *      projectId: // value for 'projectId'
 *      unitIds: // value for 'unitIds'
 *   },
 * });
 */
export function useApprovalArchitectCertMutation(baseOptions?: Apollo.MutationHookOptions<ApprovalArchitectCertMutation, ApprovalArchitectCertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApprovalArchitectCertMutation, ApprovalArchitectCertMutationVariables>(ApprovalArchitectCertDocument, options);
      }
export type ApprovalArchitectCertMutationHookResult = ReturnType<typeof useApprovalArchitectCertMutation>;
export type ApprovalArchitectCertMutationResult = Apollo.MutationResult<ApprovalArchitectCertMutation>;
export type ApprovalArchitectCertMutationOptions = Apollo.BaseMutationOptions<ApprovalArchitectCertMutation, ApprovalArchitectCertMutationVariables>;
export const VoidArchitectCertDocument = gql`
    mutation voidArchitectCert($architectCertId: String!, $projectId: String!, $unitIds: [String!]!) {
  voidArchitectCert(architectCertId: $architectCertId, projectId: $projectId, unitIds: $unitIds)
}
    `;
export type VoidArchitectCertMutationFn = Apollo.MutationFunction<VoidArchitectCertMutation, VoidArchitectCertMutationVariables>;

/**
 * __useVoidArchitectCertMutation__
 *
 * To run a mutation, you first call `useVoidArchitectCertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVoidArchitectCertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [voidArchitectCertMutation, { data, loading, error }] = useVoidArchitectCertMutation({
 *   variables: {
 *      architectCertId: // value for 'architectCertId'
 *      projectId: // value for 'projectId'
 *      unitIds: // value for 'unitIds'
 *   },
 * });
 */
export function useVoidArchitectCertMutation(baseOptions?: Apollo.MutationHookOptions<VoidArchitectCertMutation, VoidArchitectCertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VoidArchitectCertMutation, VoidArchitectCertMutationVariables>(VoidArchitectCertDocument, options);
      }
export type VoidArchitectCertMutationHookResult = ReturnType<typeof useVoidArchitectCertMutation>;
export type VoidArchitectCertMutationResult = Apollo.MutationResult<VoidArchitectCertMutation>;
export type VoidArchitectCertMutationOptions = Apollo.BaseMutationOptions<VoidArchitectCertMutation, VoidArchitectCertMutationVariables>;
export const ReversalArchCertUnitListingDocument = gql`
    query reversalArchCertUnitListing($architectCertId: String!) {
  reversalArchCertUnitListing(architectCertId: $architectCertId) {
    unitId
    unitNo
    unitStatus
    saleUnitNo
  }
}
    `;

/**
 * __useReversalArchCertUnitListingQuery__
 *
 * To run a query within a React component, call `useReversalArchCertUnitListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useReversalArchCertUnitListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReversalArchCertUnitListingQuery({
 *   variables: {
 *      architectCertId: // value for 'architectCertId'
 *   },
 * });
 */
export function useReversalArchCertUnitListingQuery(baseOptions: Apollo.QueryHookOptions<ReversalArchCertUnitListingQuery, ReversalArchCertUnitListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReversalArchCertUnitListingQuery, ReversalArchCertUnitListingQueryVariables>(ReversalArchCertUnitListingDocument, options);
      }
export function useReversalArchCertUnitListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReversalArchCertUnitListingQuery, ReversalArchCertUnitListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReversalArchCertUnitListingQuery, ReversalArchCertUnitListingQueryVariables>(ReversalArchCertUnitListingDocument, options);
        }
export type ReversalArchCertUnitListingQueryHookResult = ReturnType<typeof useReversalArchCertUnitListingQuery>;
export type ReversalArchCertUnitListingLazyQueryHookResult = ReturnType<typeof useReversalArchCertUnitListingLazyQuery>;
export type ReversalArchCertUnitListingQueryResult = Apollo.QueryResult<ReversalArchCertUnitListingQuery, ReversalArchCertUnitListingQueryVariables>;
export const GetPostedUnitListDocument = gql`
    query getPostedUnitList($architectCertId: String!) {
  getPostedUnitList(architectCertId: $architectCertId) {
    unitId
  }
}
    `;

/**
 * __useGetPostedUnitListQuery__
 *
 * To run a query within a React component, call `useGetPostedUnitListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostedUnitListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostedUnitListQuery({
 *   variables: {
 *      architectCertId: // value for 'architectCertId'
 *   },
 * });
 */
export function useGetPostedUnitListQuery(baseOptions: Apollo.QueryHookOptions<GetPostedUnitListQuery, GetPostedUnitListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostedUnitListQuery, GetPostedUnitListQueryVariables>(GetPostedUnitListDocument, options);
      }
export function useGetPostedUnitListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostedUnitListQuery, GetPostedUnitListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostedUnitListQuery, GetPostedUnitListQueryVariables>(GetPostedUnitListDocument, options);
        }
export type GetPostedUnitListQueryHookResult = ReturnType<typeof useGetPostedUnitListQuery>;
export type GetPostedUnitListLazyQueryHookResult = ReturnType<typeof useGetPostedUnitListLazyQuery>;
export type GetPostedUnitListQueryResult = Apollo.QueryResult<GetPostedUnitListQuery, GetPostedUnitListQueryVariables>;
export const ReversalArchitectCertDocument = gql`
    mutation reversalArchitectCert($architectCertId: String!, $projectId: String!, $unitIds: [String!]!) {
  reversalArchitectCert(architectCertId: $architectCertId, projectId: $projectId, unitIds: $unitIds)
}
    `;
export type ReversalArchitectCertMutationFn = Apollo.MutationFunction<ReversalArchitectCertMutation, ReversalArchitectCertMutationVariables>;

/**
 * __useReversalArchitectCertMutation__
 *
 * To run a mutation, you first call `useReversalArchitectCertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReversalArchitectCertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reversalArchitectCertMutation, { data, loading, error }] = useReversalArchitectCertMutation({
 *   variables: {
 *      architectCertId: // value for 'architectCertId'
 *      projectId: // value for 'projectId'
 *      unitIds: // value for 'unitIds'
 *   },
 * });
 */
export function useReversalArchitectCertMutation(baseOptions?: Apollo.MutationHookOptions<ReversalArchitectCertMutation, ReversalArchitectCertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReversalArchitectCertMutation, ReversalArchitectCertMutationVariables>(ReversalArchitectCertDocument, options);
      }
export type ReversalArchitectCertMutationHookResult = ReturnType<typeof useReversalArchitectCertMutation>;
export type ReversalArchitectCertMutationResult = Apollo.MutationResult<ReversalArchitectCertMutation>;
export type ReversalArchitectCertMutationOptions = Apollo.BaseMutationOptions<ReversalArchitectCertMutation, ReversalArchitectCertMutationVariables>;
export const GetAllMiscBillingByStatusDocument = gql`
    query getAllMiscBillingByStatus($status: String!) {
  getAllMiscBillingByStatus(status: $status) {
    documentDate
    generationBatch
    totalAmount
    status
    unitList {
      unitNo
      totalAmount
      billingList {
        billItem
        docAmount
      }
    }
  }
}
    `;

/**
 * __useGetAllMiscBillingByStatusQuery__
 *
 * To run a query within a React component, call `useGetAllMiscBillingByStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllMiscBillingByStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllMiscBillingByStatusQuery({
 *   variables: {
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetAllMiscBillingByStatusQuery(baseOptions: Apollo.QueryHookOptions<GetAllMiscBillingByStatusQuery, GetAllMiscBillingByStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllMiscBillingByStatusQuery, GetAllMiscBillingByStatusQueryVariables>(GetAllMiscBillingByStatusDocument, options);
      }
export function useGetAllMiscBillingByStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllMiscBillingByStatusQuery, GetAllMiscBillingByStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllMiscBillingByStatusQuery, GetAllMiscBillingByStatusQueryVariables>(GetAllMiscBillingByStatusDocument, options);
        }
export type GetAllMiscBillingByStatusQueryHookResult = ReturnType<typeof useGetAllMiscBillingByStatusQuery>;
export type GetAllMiscBillingByStatusLazyQueryHookResult = ReturnType<typeof useGetAllMiscBillingByStatusLazyQuery>;
export type GetAllMiscBillingByStatusQueryResult = Apollo.QueryResult<GetAllMiscBillingByStatusQuery, GetAllMiscBillingByStatusQueryVariables>;
export const GetMiscBillingByBatchIdDocument = gql`
    query getMiscBillingByBatchId($generationBatch: String!) {
  getMiscBillingByBatchId(generationBatch: $generationBatch) {
    documentDate
    billItemIds
    units
    creditTerm
    interestRate
  }
}
    `;

/**
 * __useGetMiscBillingByBatchIdQuery__
 *
 * To run a query within a React component, call `useGetMiscBillingByBatchIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMiscBillingByBatchIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMiscBillingByBatchIdQuery({
 *   variables: {
 *      generationBatch: // value for 'generationBatch'
 *   },
 * });
 */
export function useGetMiscBillingByBatchIdQuery(baseOptions: Apollo.QueryHookOptions<GetMiscBillingByBatchIdQuery, GetMiscBillingByBatchIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMiscBillingByBatchIdQuery, GetMiscBillingByBatchIdQueryVariables>(GetMiscBillingByBatchIdDocument, options);
      }
export function useGetMiscBillingByBatchIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMiscBillingByBatchIdQuery, GetMiscBillingByBatchIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMiscBillingByBatchIdQuery, GetMiscBillingByBatchIdQueryVariables>(GetMiscBillingByBatchIdDocument, options);
        }
export type GetMiscBillingByBatchIdQueryHookResult = ReturnType<typeof useGetMiscBillingByBatchIdQuery>;
export type GetMiscBillingByBatchIdLazyQueryHookResult = ReturnType<typeof useGetMiscBillingByBatchIdLazyQuery>;
export type GetMiscBillingByBatchIdQueryResult = Apollo.QueryResult<GetMiscBillingByBatchIdQuery, GetMiscBillingByBatchIdQueryVariables>;
export const GetMiscBillingDetailsDocument = gql`
    query getMiscBillingDetails($generationBatch: String!) {
  getMiscBillingDetails(generationBatch: $generationBatch) {
    documentDate
    generationBatch
    totalAmount
    status
    unitList {
      unitNo
      totalAmount
      billingList {
        billItem
        docAmount
      }
    }
  }
}
    `;

/**
 * __useGetMiscBillingDetailsQuery__
 *
 * To run a query within a React component, call `useGetMiscBillingDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMiscBillingDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMiscBillingDetailsQuery({
 *   variables: {
 *      generationBatch: // value for 'generationBatch'
 *   },
 * });
 */
export function useGetMiscBillingDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetMiscBillingDetailsQuery, GetMiscBillingDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMiscBillingDetailsQuery, GetMiscBillingDetailsQueryVariables>(GetMiscBillingDetailsDocument, options);
      }
export function useGetMiscBillingDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMiscBillingDetailsQuery, GetMiscBillingDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMiscBillingDetailsQuery, GetMiscBillingDetailsQueryVariables>(GetMiscBillingDetailsDocument, options);
        }
export type GetMiscBillingDetailsQueryHookResult = ReturnType<typeof useGetMiscBillingDetailsQuery>;
export type GetMiscBillingDetailsLazyQueryHookResult = ReturnType<typeof useGetMiscBillingDetailsLazyQuery>;
export type GetMiscBillingDetailsQueryResult = Apollo.QueryResult<GetMiscBillingDetailsQuery, GetMiscBillingDetailsQueryVariables>;
export const GenerateMiscBillingDocument = gql`
    mutation generateMiscBilling($input: generateMiscBillingInput!) {
  generateMiscBilling(input: $input)
}
    `;
export type GenerateMiscBillingMutationFn = Apollo.MutationFunction<GenerateMiscBillingMutation, GenerateMiscBillingMutationVariables>;

/**
 * __useGenerateMiscBillingMutation__
 *
 * To run a mutation, you first call `useGenerateMiscBillingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateMiscBillingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateMiscBillingMutation, { data, loading, error }] = useGenerateMiscBillingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateMiscBillingMutation(baseOptions?: Apollo.MutationHookOptions<GenerateMiscBillingMutation, GenerateMiscBillingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateMiscBillingMutation, GenerateMiscBillingMutationVariables>(GenerateMiscBillingDocument, options);
      }
export type GenerateMiscBillingMutationHookResult = ReturnType<typeof useGenerateMiscBillingMutation>;
export type GenerateMiscBillingMutationResult = Apollo.MutationResult<GenerateMiscBillingMutation>;
export type GenerateMiscBillingMutationOptions = Apollo.BaseMutationOptions<GenerateMiscBillingMutation, GenerateMiscBillingMutationVariables>;
export const EditMiscBillingDocument = gql`
    mutation editMiscBilling($input: editMiscBillingInput!) {
  editMiscBilling(input: $input)
}
    `;
export type EditMiscBillingMutationFn = Apollo.MutationFunction<EditMiscBillingMutation, EditMiscBillingMutationVariables>;

/**
 * __useEditMiscBillingMutation__
 *
 * To run a mutation, you first call `useEditMiscBillingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditMiscBillingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editMiscBillingMutation, { data, loading, error }] = useEditMiscBillingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditMiscBillingMutation(baseOptions?: Apollo.MutationHookOptions<EditMiscBillingMutation, EditMiscBillingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditMiscBillingMutation, EditMiscBillingMutationVariables>(EditMiscBillingDocument, options);
      }
export type EditMiscBillingMutationHookResult = ReturnType<typeof useEditMiscBillingMutation>;
export type EditMiscBillingMutationResult = Apollo.MutationResult<EditMiscBillingMutation>;
export type EditMiscBillingMutationOptions = Apollo.BaseMutationOptions<EditMiscBillingMutation, EditMiscBillingMutationVariables>;
export const ApprovedMiscBillingDocument = gql`
    mutation approvedMiscBilling($generationBatchIds: [String!]!, $action: String!) {
  approvedMiscBilling(generationBatchIds: $generationBatchIds, action: $action)
}
    `;
export type ApprovedMiscBillingMutationFn = Apollo.MutationFunction<ApprovedMiscBillingMutation, ApprovedMiscBillingMutationVariables>;

/**
 * __useApprovedMiscBillingMutation__
 *
 * To run a mutation, you first call `useApprovedMiscBillingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApprovedMiscBillingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approvedMiscBillingMutation, { data, loading, error }] = useApprovedMiscBillingMutation({
 *   variables: {
 *      generationBatchIds: // value for 'generationBatchIds'
 *      action: // value for 'action'
 *   },
 * });
 */
export function useApprovedMiscBillingMutation(baseOptions?: Apollo.MutationHookOptions<ApprovedMiscBillingMutation, ApprovedMiscBillingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApprovedMiscBillingMutation, ApprovedMiscBillingMutationVariables>(ApprovedMiscBillingDocument, options);
      }
export type ApprovedMiscBillingMutationHookResult = ReturnType<typeof useApprovedMiscBillingMutation>;
export type ApprovedMiscBillingMutationResult = Apollo.MutationResult<ApprovedMiscBillingMutation>;
export type ApprovedMiscBillingMutationOptions = Apollo.BaseMutationOptions<ApprovedMiscBillingMutation, ApprovedMiscBillingMutationVariables>;
export const PostingMiscBillingDocument = gql`
    mutation postingMiscBilling($input: postingMiscBillingInput!) {
  postingMiscBilling(input: $input)
}
    `;
export type PostingMiscBillingMutationFn = Apollo.MutationFunction<PostingMiscBillingMutation, PostingMiscBillingMutationVariables>;

/**
 * __usePostingMiscBillingMutation__
 *
 * To run a mutation, you first call `usePostingMiscBillingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostingMiscBillingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postingMiscBillingMutation, { data, loading, error }] = usePostingMiscBillingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePostingMiscBillingMutation(baseOptions?: Apollo.MutationHookOptions<PostingMiscBillingMutation, PostingMiscBillingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PostingMiscBillingMutation, PostingMiscBillingMutationVariables>(PostingMiscBillingDocument, options);
      }
export type PostingMiscBillingMutationHookResult = ReturnType<typeof usePostingMiscBillingMutation>;
export type PostingMiscBillingMutationResult = Apollo.MutationResult<PostingMiscBillingMutation>;
export type PostingMiscBillingMutationOptions = Apollo.BaseMutationOptions<PostingMiscBillingMutation, PostingMiscBillingMutationVariables>;
export const AbortMiscBillingDocument = gql`
    mutation abortMiscBilling($input: postingMiscBillingInput!) {
  abortMiscBilling(input: $input)
}
    `;
export type AbortMiscBillingMutationFn = Apollo.MutationFunction<AbortMiscBillingMutation, AbortMiscBillingMutationVariables>;

/**
 * __useAbortMiscBillingMutation__
 *
 * To run a mutation, you first call `useAbortMiscBillingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAbortMiscBillingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [abortMiscBillingMutation, { data, loading, error }] = useAbortMiscBillingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAbortMiscBillingMutation(baseOptions?: Apollo.MutationHookOptions<AbortMiscBillingMutation, AbortMiscBillingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AbortMiscBillingMutation, AbortMiscBillingMutationVariables>(AbortMiscBillingDocument, options);
      }
export type AbortMiscBillingMutationHookResult = ReturnType<typeof useAbortMiscBillingMutation>;
export type AbortMiscBillingMutationResult = Apollo.MutationResult<AbortMiscBillingMutation>;
export type AbortMiscBillingMutationOptions = Apollo.BaseMutationOptions<AbortMiscBillingMutation, AbortMiscBillingMutationVariables>;
export const ReversalMiscBillingDocument = gql`
    mutation reversalMiscBilling($generationBatch: String!) {
  reversalMiscBilling(generationBatch: $generationBatch)
}
    `;
export type ReversalMiscBillingMutationFn = Apollo.MutationFunction<ReversalMiscBillingMutation, ReversalMiscBillingMutationVariables>;

/**
 * __useReversalMiscBillingMutation__
 *
 * To run a mutation, you first call `useReversalMiscBillingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReversalMiscBillingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reversalMiscBillingMutation, { data, loading, error }] = useReversalMiscBillingMutation({
 *   variables: {
 *      generationBatch: // value for 'generationBatch'
 *   },
 * });
 */
export function useReversalMiscBillingMutation(baseOptions?: Apollo.MutationHookOptions<ReversalMiscBillingMutation, ReversalMiscBillingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReversalMiscBillingMutation, ReversalMiscBillingMutationVariables>(ReversalMiscBillingDocument, options);
      }
export type ReversalMiscBillingMutationHookResult = ReturnType<typeof useReversalMiscBillingMutation>;
export type ReversalMiscBillingMutationResult = Apollo.MutationResult<ReversalMiscBillingMutation>;
export type ReversalMiscBillingMutationOptions = Apollo.BaseMutationOptions<ReversalMiscBillingMutation, ReversalMiscBillingMutationVariables>;
export const GetMBallUnitDocument = gql`
    query getMBallUnit {
  getMBallUnit {
    block
    totalFloor
    floorList {
      floorLabel
      totalUnit
      unitList {
        unitId
        unitNo
      }
    }
  }
}
    `;

/**
 * __useGetMBallUnitQuery__
 *
 * To run a query within a React component, call `useGetMBallUnitQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMBallUnitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMBallUnitQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMBallUnitQuery(baseOptions?: Apollo.QueryHookOptions<GetMBallUnitQuery, GetMBallUnitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMBallUnitQuery, GetMBallUnitQueryVariables>(GetMBallUnitDocument, options);
      }
export function useGetMBallUnitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMBallUnitQuery, GetMBallUnitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMBallUnitQuery, GetMBallUnitQueryVariables>(GetMBallUnitDocument, options);
        }
export type GetMBallUnitQueryHookResult = ReturnType<typeof useGetMBallUnitQuery>;
export type GetMBallUnitLazyQueryHookResult = ReturnType<typeof useGetMBallUnitLazyQuery>;
export type GetMBallUnitQueryResult = Apollo.QueryResult<GetMBallUnitQuery, GetMBallUnitQueryVariables>;
export const GetMiscChargesByDateDocument = gql`
    query getMiscChargesByDate($date: DateTime!) {
  getMiscChargesByDate(date: $date) {
    miscChargesId
    billItemName
    billItemId
    taxSchemeId
    taxSchemeName
    effectiveDate
    taxSchemeDetailId
    totalTaxRate
    taxSchemeDetailItems {
      taxId
      taxCode
      taxRate
    }
  }
}
    `;

/**
 * __useGetMiscChargesByDateQuery__
 *
 * To run a query within a React component, call `useGetMiscChargesByDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMiscChargesByDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMiscChargesByDateQuery({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetMiscChargesByDateQuery(baseOptions: Apollo.QueryHookOptions<GetMiscChargesByDateQuery, GetMiscChargesByDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMiscChargesByDateQuery, GetMiscChargesByDateQueryVariables>(GetMiscChargesByDateDocument, options);
      }
export function useGetMiscChargesByDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMiscChargesByDateQuery, GetMiscChargesByDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMiscChargesByDateQuery, GetMiscChargesByDateQueryVariables>(GetMiscChargesByDateDocument, options);
        }
export type GetMiscChargesByDateQueryHookResult = ReturnType<typeof useGetMiscChargesByDateQuery>;
export type GetMiscChargesByDateLazyQueryHookResult = ReturnType<typeof useGetMiscChargesByDateLazyQuery>;
export type GetMiscChargesByDateQueryResult = Apollo.QueryResult<GetMiscChargesByDateQuery, GetMiscChargesByDateQueryVariables>;
export const ProgressBillingListForGenerateDocument = gql`
    query progressBillingListForGenerate($signed: Boolean!, $booked: Boolean!, $docDate: DateTime!) {
  progressBillingListForGenerate(signed: $signed, booked: $booked, docDate: $docDate) {
    unitNo
    saleUnitNo
    saleId
    salesStatus
    totalPrincipalAmt
    totalDocAmt
    totalTaxAmt
    billingCount
    billingDetail {
      title
      principalAmt
      progressBillingId
      addOnRefTable
      addOnRefId
      docNo
      docAmt
      stageSeqNo
      installmentSeqNo
      docDate
      taxAmt
    }
  }
}
    `;

/**
 * __useProgressBillingListForGenerateQuery__
 *
 * To run a query within a React component, call `useProgressBillingListForGenerateQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgressBillingListForGenerateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgressBillingListForGenerateQuery({
 *   variables: {
 *      signed: // value for 'signed'
 *      booked: // value for 'booked'
 *      docDate: // value for 'docDate'
 *   },
 * });
 */
export function useProgressBillingListForGenerateQuery(baseOptions: Apollo.QueryHookOptions<ProgressBillingListForGenerateQuery, ProgressBillingListForGenerateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgressBillingListForGenerateQuery, ProgressBillingListForGenerateQueryVariables>(ProgressBillingListForGenerateDocument, options);
      }
export function useProgressBillingListForGenerateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgressBillingListForGenerateQuery, ProgressBillingListForGenerateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgressBillingListForGenerateQuery, ProgressBillingListForGenerateQueryVariables>(ProgressBillingListForGenerateDocument, options);
        }
export type ProgressBillingListForGenerateQueryHookResult = ReturnType<typeof useProgressBillingListForGenerateQuery>;
export type ProgressBillingListForGenerateLazyQueryHookResult = ReturnType<typeof useProgressBillingListForGenerateLazyQuery>;
export type ProgressBillingListForGenerateQueryResult = Apollo.QueryResult<ProgressBillingListForGenerateQuery, ProgressBillingListForGenerateQueryVariables>;
export const GenerateProgressBillingDocument = gql`
    mutation generateProgressBilling($input: generateProgressBillingBasicInput!) {
  generateProgressBilling(input: $input)
}
    `;
export type GenerateProgressBillingMutationFn = Apollo.MutationFunction<GenerateProgressBillingMutation, GenerateProgressBillingMutationVariables>;

/**
 * __useGenerateProgressBillingMutation__
 *
 * To run a mutation, you first call `useGenerateProgressBillingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateProgressBillingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateProgressBillingMutation, { data, loading, error }] = useGenerateProgressBillingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateProgressBillingMutation(baseOptions?: Apollo.MutationHookOptions<GenerateProgressBillingMutation, GenerateProgressBillingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateProgressBillingMutation, GenerateProgressBillingMutationVariables>(GenerateProgressBillingDocument, options);
      }
export type GenerateProgressBillingMutationHookResult = ReturnType<typeof useGenerateProgressBillingMutation>;
export type GenerateProgressBillingMutationResult = Apollo.MutationResult<GenerateProgressBillingMutation>;
export type GenerateProgressBillingMutationOptions = Apollo.BaseMutationOptions<GenerateProgressBillingMutation, GenerateProgressBillingMutationVariables>;
export const PostingProgressBillingDocument = gql`
    mutation postingProgressBilling($input: [updatePbStatusInput!]!) {
  postingProgressBilling(input: $input)
}
    `;
export type PostingProgressBillingMutationFn = Apollo.MutationFunction<PostingProgressBillingMutation, PostingProgressBillingMutationVariables>;

/**
 * __usePostingProgressBillingMutation__
 *
 * To run a mutation, you first call `usePostingProgressBillingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostingProgressBillingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postingProgressBillingMutation, { data, loading, error }] = usePostingProgressBillingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePostingProgressBillingMutation(baseOptions?: Apollo.MutationHookOptions<PostingProgressBillingMutation, PostingProgressBillingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PostingProgressBillingMutation, PostingProgressBillingMutationVariables>(PostingProgressBillingDocument, options);
      }
export type PostingProgressBillingMutationHookResult = ReturnType<typeof usePostingProgressBillingMutation>;
export type PostingProgressBillingMutationResult = Apollo.MutationResult<PostingProgressBillingMutation>;
export type PostingProgressBillingMutationOptions = Apollo.BaseMutationOptions<PostingProgressBillingMutation, PostingProgressBillingMutationVariables>;
export const ReversalProgressBillingDocument = gql`
    mutation reversalProgressBilling($input: [updatePbStatusInput!]!, $removeGenerationBatch: Boolean!) {
  reversalProgressBilling(input: $input, removeGenerationBatch: $removeGenerationBatch)
}
    `;
export type ReversalProgressBillingMutationFn = Apollo.MutationFunction<ReversalProgressBillingMutation, ReversalProgressBillingMutationVariables>;

/**
 * __useReversalProgressBillingMutation__
 *
 * To run a mutation, you first call `useReversalProgressBillingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReversalProgressBillingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reversalProgressBillingMutation, { data, loading, error }] = useReversalProgressBillingMutation({
 *   variables: {
 *      input: // value for 'input'
 *      removeGenerationBatch: // value for 'removeGenerationBatch'
 *   },
 * });
 */
export function useReversalProgressBillingMutation(baseOptions?: Apollo.MutationHookOptions<ReversalProgressBillingMutation, ReversalProgressBillingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReversalProgressBillingMutation, ReversalProgressBillingMutationVariables>(ReversalProgressBillingDocument, options);
      }
export type ReversalProgressBillingMutationHookResult = ReturnType<typeof useReversalProgressBillingMutation>;
export type ReversalProgressBillingMutationResult = Apollo.MutationResult<ReversalProgressBillingMutation>;
export type ReversalProgressBillingMutationOptions = Apollo.BaseMutationOptions<ReversalProgressBillingMutation, ReversalProgressBillingMutationVariables>;
export const UpdateProgressBillingDocument = gql`
    mutation updateProgressBilling($input: editProgressBillingInput!) {
  updateProgressBilling(input: $input)
}
    `;
export type UpdateProgressBillingMutationFn = Apollo.MutationFunction<UpdateProgressBillingMutation, UpdateProgressBillingMutationVariables>;

/**
 * __useUpdateProgressBillingMutation__
 *
 * To run a mutation, you first call `useUpdateProgressBillingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProgressBillingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProgressBillingMutation, { data, loading, error }] = useUpdateProgressBillingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProgressBillingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProgressBillingMutation, UpdateProgressBillingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProgressBillingMutation, UpdateProgressBillingMutationVariables>(UpdateProgressBillingDocument, options);
      }
export type UpdateProgressBillingMutationHookResult = ReturnType<typeof useUpdateProgressBillingMutation>;
export type UpdateProgressBillingMutationResult = Apollo.MutationResult<UpdateProgressBillingMutation>;
export type UpdateProgressBillingMutationOptions = Apollo.BaseMutationOptions<UpdateProgressBillingMutation, UpdateProgressBillingMutationVariables>;
export const GetProjectCreditTermDocument = gql`
    query getProjectCreditTerm {
  getProjectCreditTerm {
    creditTerms
    interestRate
  }
}
    `;

/**
 * __useGetProjectCreditTermQuery__
 *
 * To run a query within a React component, call `useGetProjectCreditTermQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectCreditTermQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectCreditTermQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProjectCreditTermQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectCreditTermQuery, GetProjectCreditTermQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectCreditTermQuery, GetProjectCreditTermQueryVariables>(GetProjectCreditTermDocument, options);
      }
export function useGetProjectCreditTermLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectCreditTermQuery, GetProjectCreditTermQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectCreditTermQuery, GetProjectCreditTermQueryVariables>(GetProjectCreditTermDocument, options);
        }
export type GetProjectCreditTermQueryHookResult = ReturnType<typeof useGetProjectCreditTermQuery>;
export type GetProjectCreditTermLazyQueryHookResult = ReturnType<typeof useGetProjectCreditTermLazyQuery>;
export type GetProjectCreditTermQueryResult = Apollo.QueryResult<GetProjectCreditTermQuery, GetProjectCreditTermQueryVariables>;
export const GetProgressBillingDocument = gql`
    query getProgressBilling($status: String!) {
  getProgressBilling(status: $status) {
    documentDate
    generationBatch
    totalPrincipalAmt
    unitCount
    allowPosted
    allowReversal
    isReversal
    billingDetail {
      progressBillingId
      unitNo
      saleId
      allowPosted
      allowReversal
    }
    unitIndex
  }
}
    `;

/**
 * __useGetProgressBillingQuery__
 *
 * To run a query within a React component, call `useGetProgressBillingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgressBillingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgressBillingQuery({
 *   variables: {
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetProgressBillingQuery(baseOptions: Apollo.QueryHookOptions<GetProgressBillingQuery, GetProgressBillingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProgressBillingQuery, GetProgressBillingQueryVariables>(GetProgressBillingDocument, options);
      }
export function useGetProgressBillingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProgressBillingQuery, GetProgressBillingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProgressBillingQuery, GetProgressBillingQueryVariables>(GetProgressBillingDocument, options);
        }
export type GetProgressBillingQueryHookResult = ReturnType<typeof useGetProgressBillingQuery>;
export type GetProgressBillingLazyQueryHookResult = ReturnType<typeof useGetProgressBillingLazyQuery>;
export type GetProgressBillingQueryResult = Apollo.QueryResult<GetProgressBillingQuery, GetProgressBillingQueryVariables>;
export const GetProgressBillingByGenerationIdDocument = gql`
    query getProgressBillingByGenerationId($generationBatchId: String!) {
  getProgressBillingByGenerationId(generationBatchId: $generationBatchId) {
    unitNo
    saleUnitNo
    saleId
    docDate
    creditTerm
    salesStatus
    totalPrincipalAmt
    totalDocAmt
    totalTaxAmt
    billingCount
    interestRate
    billingDetail {
      title
      principalAmt
      progressBillingId
      addOnRefTable
      addOnRefId
      docNo
      docAmt
      stageSeqNo
      installmentSeqNo
      docDate
      taxAmt
    }
    pbDetail {
      details {
        totalTaxAmt
        isVp
        documentNo
        stageSeqNo
        documentDate
        paymentParty
        addOnPurchase
        isStakeholder
        creditDocumentNo
        installmentSeqNo
        paymentPartyCode
        addOnPurchaseName
        progressBillingId
        calculatedDocumentAmt
        paymentPlanDetailTitle
      }
      isReversal
      stageSeqNo
      paymentParty
      addOnPurchase
      paymentPartyCode
      addOnPurchaseName
      paymentPlanDetailTitle
      totalDocumentAmt
      gotAC
    }
  }
}
    `;

/**
 * __useGetProgressBillingByGenerationIdQuery__
 *
 * To run a query within a React component, call `useGetProgressBillingByGenerationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgressBillingByGenerationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgressBillingByGenerationIdQuery({
 *   variables: {
 *      generationBatchId: // value for 'generationBatchId'
 *   },
 * });
 */
export function useGetProgressBillingByGenerationIdQuery(baseOptions: Apollo.QueryHookOptions<GetProgressBillingByGenerationIdQuery, GetProgressBillingByGenerationIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProgressBillingByGenerationIdQuery, GetProgressBillingByGenerationIdQueryVariables>(GetProgressBillingByGenerationIdDocument, options);
      }
export function useGetProgressBillingByGenerationIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProgressBillingByGenerationIdQuery, GetProgressBillingByGenerationIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProgressBillingByGenerationIdQuery, GetProgressBillingByGenerationIdQueryVariables>(GetProgressBillingByGenerationIdDocument, options);
        }
export type GetProgressBillingByGenerationIdQueryHookResult = ReturnType<typeof useGetProgressBillingByGenerationIdQuery>;
export type GetProgressBillingByGenerationIdLazyQueryHookResult = ReturnType<typeof useGetProgressBillingByGenerationIdLazyQuery>;
export type GetProgressBillingByGenerationIdQueryResult = Apollo.QueryResult<GetProgressBillingByGenerationIdQuery, GetProgressBillingByGenerationIdQueryVariables>;
export const ClearPBbyBatchIdDocument = gql`
    mutation clearPBbyBatchId($generateBatchId: String!) {
  clearPBbyBatchId(generateBatchId: $generateBatchId)
}
    `;
export type ClearPBbyBatchIdMutationFn = Apollo.MutationFunction<ClearPBbyBatchIdMutation, ClearPBbyBatchIdMutationVariables>;

/**
 * __useClearPBbyBatchIdMutation__
 *
 * To run a mutation, you first call `useClearPBbyBatchIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearPBbyBatchIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearPBbyBatchIdMutation, { data, loading, error }] = useClearPBbyBatchIdMutation({
 *   variables: {
 *      generateBatchId: // value for 'generateBatchId'
 *   },
 * });
 */
export function useClearPBbyBatchIdMutation(baseOptions?: Apollo.MutationHookOptions<ClearPBbyBatchIdMutation, ClearPBbyBatchIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearPBbyBatchIdMutation, ClearPBbyBatchIdMutationVariables>(ClearPBbyBatchIdDocument, options);
      }
export type ClearPBbyBatchIdMutationHookResult = ReturnType<typeof useClearPBbyBatchIdMutation>;
export type ClearPBbyBatchIdMutationResult = Apollo.MutationResult<ClearPBbyBatchIdMutation>;
export type ClearPBbyBatchIdMutationOptions = Apollo.BaseMutationOptions<ClearPBbyBatchIdMutation, ClearPBbyBatchIdMutationVariables>;
export const GetProgressMiscBillingSettingSummaryDocument = gql`
    query getProgressMiscBillingSettingSummary {
  standardMiscChargesLastUpdate
  architectCertLastUpdate
  progressBillingLastUpdate
  miscBillingLastUpdate
}
    `;

/**
 * __useGetProgressMiscBillingSettingSummaryQuery__
 *
 * To run a query within a React component, call `useGetProgressMiscBillingSettingSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgressMiscBillingSettingSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgressMiscBillingSettingSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProgressMiscBillingSettingSummaryQuery(baseOptions?: Apollo.QueryHookOptions<GetProgressMiscBillingSettingSummaryQuery, GetProgressMiscBillingSettingSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProgressMiscBillingSettingSummaryQuery, GetProgressMiscBillingSettingSummaryQueryVariables>(GetProgressMiscBillingSettingSummaryDocument, options);
      }
export function useGetProgressMiscBillingSettingSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProgressMiscBillingSettingSummaryQuery, GetProgressMiscBillingSettingSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProgressMiscBillingSettingSummaryQuery, GetProgressMiscBillingSettingSummaryQueryVariables>(GetProgressMiscBillingSettingSummaryDocument, options);
        }
export type GetProgressMiscBillingSettingSummaryQueryHookResult = ReturnType<typeof useGetProgressMiscBillingSettingSummaryQuery>;
export type GetProgressMiscBillingSettingSummaryLazyQueryHookResult = ReturnType<typeof useGetProgressMiscBillingSettingSummaryLazyQuery>;
export type GetProgressMiscBillingSettingSummaryQueryResult = Apollo.QueryResult<GetProgressMiscBillingSettingSummaryQuery, GetProgressMiscBillingSettingSummaryQueryVariables>;
export const GetAllProjectMiscChargesDocument = gql`
    query getAllProjectMiscCharges {
  getAllProjectMiscCharges {
    id
    accountId
    interestRate
    remark
    taxSchemeId
    formula
    billItemName
    isDeletable
  }
}
    `;

/**
 * __useGetAllProjectMiscChargesQuery__
 *
 * To run a query within a React component, call `useGetAllProjectMiscChargesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllProjectMiscChargesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllProjectMiscChargesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllProjectMiscChargesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllProjectMiscChargesQuery, GetAllProjectMiscChargesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllProjectMiscChargesQuery, GetAllProjectMiscChargesQueryVariables>(GetAllProjectMiscChargesDocument, options);
      }
export function useGetAllProjectMiscChargesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllProjectMiscChargesQuery, GetAllProjectMiscChargesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllProjectMiscChargesQuery, GetAllProjectMiscChargesQueryVariables>(GetAllProjectMiscChargesDocument, options);
        }
export type GetAllProjectMiscChargesQueryHookResult = ReturnType<typeof useGetAllProjectMiscChargesQuery>;
export type GetAllProjectMiscChargesLazyQueryHookResult = ReturnType<typeof useGetAllProjectMiscChargesLazyQuery>;
export type GetAllProjectMiscChargesQueryResult = Apollo.QueryResult<GetAllProjectMiscChargesQuery, GetAllProjectMiscChargesQueryVariables>;
export const GetProjectMiscChargesByIdDocument = gql`
    query getProjectMiscChargesById($id: String!) {
  getProjectMiscChargesById(id: $id) {
    id
    accountId
    interestRate
    remark
    taxSchemeId
    formula
    billItemName
    billItemId
    isDeletable
  }
}
    `;

/**
 * __useGetProjectMiscChargesByIdQuery__
 *
 * To run a query within a React component, call `useGetProjectMiscChargesByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectMiscChargesByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectMiscChargesByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectMiscChargesByIdQuery(baseOptions: Apollo.QueryHookOptions<GetProjectMiscChargesByIdQuery, GetProjectMiscChargesByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectMiscChargesByIdQuery, GetProjectMiscChargesByIdQueryVariables>(GetProjectMiscChargesByIdDocument, options);
      }
export function useGetProjectMiscChargesByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectMiscChargesByIdQuery, GetProjectMiscChargesByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectMiscChargesByIdQuery, GetProjectMiscChargesByIdQueryVariables>(GetProjectMiscChargesByIdDocument, options);
        }
export type GetProjectMiscChargesByIdQueryHookResult = ReturnType<typeof useGetProjectMiscChargesByIdQuery>;
export type GetProjectMiscChargesByIdLazyQueryHookResult = ReturnType<typeof useGetProjectMiscChargesByIdLazyQuery>;
export type GetProjectMiscChargesByIdQueryResult = Apollo.QueryResult<GetProjectMiscChargesByIdQuery, GetProjectMiscChargesByIdQueryVariables>;
export const AddProjectMiscChargesDocument = gql`
    mutation addProjectMiscCharges($input: addProjectMiscChargesInput!) {
  addProjectMiscCharges(input: $input)
}
    `;
export type AddProjectMiscChargesMutationFn = Apollo.MutationFunction<AddProjectMiscChargesMutation, AddProjectMiscChargesMutationVariables>;

/**
 * __useAddProjectMiscChargesMutation__
 *
 * To run a mutation, you first call `useAddProjectMiscChargesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProjectMiscChargesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProjectMiscChargesMutation, { data, loading, error }] = useAddProjectMiscChargesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddProjectMiscChargesMutation(baseOptions?: Apollo.MutationHookOptions<AddProjectMiscChargesMutation, AddProjectMiscChargesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProjectMiscChargesMutation, AddProjectMiscChargesMutationVariables>(AddProjectMiscChargesDocument, options);
      }
export type AddProjectMiscChargesMutationHookResult = ReturnType<typeof useAddProjectMiscChargesMutation>;
export type AddProjectMiscChargesMutationResult = Apollo.MutationResult<AddProjectMiscChargesMutation>;
export type AddProjectMiscChargesMutationOptions = Apollo.BaseMutationOptions<AddProjectMiscChargesMutation, AddProjectMiscChargesMutationVariables>;
export const DeleteProjectMiscChargesDocument = gql`
    mutation deleteProjectMiscCharges($projectMiscChargesId: String!) {
  deleteProjectMiscCharges(projectMiscChargesId: $projectMiscChargesId)
}
    `;
export type DeleteProjectMiscChargesMutationFn = Apollo.MutationFunction<DeleteProjectMiscChargesMutation, DeleteProjectMiscChargesMutationVariables>;

/**
 * __useDeleteProjectMiscChargesMutation__
 *
 * To run a mutation, you first call `useDeleteProjectMiscChargesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectMiscChargesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectMiscChargesMutation, { data, loading, error }] = useDeleteProjectMiscChargesMutation({
 *   variables: {
 *      projectMiscChargesId: // value for 'projectMiscChargesId'
 *   },
 * });
 */
export function useDeleteProjectMiscChargesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectMiscChargesMutation, DeleteProjectMiscChargesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectMiscChargesMutation, DeleteProjectMiscChargesMutationVariables>(DeleteProjectMiscChargesDocument, options);
      }
export type DeleteProjectMiscChargesMutationHookResult = ReturnType<typeof useDeleteProjectMiscChargesMutation>;
export type DeleteProjectMiscChargesMutationResult = Apollo.MutationResult<DeleteProjectMiscChargesMutation>;
export type DeleteProjectMiscChargesMutationOptions = Apollo.BaseMutationOptions<DeleteProjectMiscChargesMutation, DeleteProjectMiscChargesMutationVariables>;
export const EditProjectMiscChargesDocument = gql`
    mutation editProjectMiscCharges($input: editProjectMiscChargesInput!) {
  editProjectMiscCharges(input: $input)
}
    `;
export type EditProjectMiscChargesMutationFn = Apollo.MutationFunction<EditProjectMiscChargesMutation, EditProjectMiscChargesMutationVariables>;

/**
 * __useEditProjectMiscChargesMutation__
 *
 * To run a mutation, you first call `useEditProjectMiscChargesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditProjectMiscChargesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editProjectMiscChargesMutation, { data, loading, error }] = useEditProjectMiscChargesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditProjectMiscChargesMutation(baseOptions?: Apollo.MutationHookOptions<EditProjectMiscChargesMutation, EditProjectMiscChargesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditProjectMiscChargesMutation, EditProjectMiscChargesMutationVariables>(EditProjectMiscChargesDocument, options);
      }
export type EditProjectMiscChargesMutationHookResult = ReturnType<typeof useEditProjectMiscChargesMutation>;
export type EditProjectMiscChargesMutationResult = Apollo.MutationResult<EditProjectMiscChargesMutation>;
export type EditProjectMiscChargesMutationOptions = Apollo.BaseMutationOptions<EditProjectMiscChargesMutation, EditProjectMiscChargesMutationVariables>;
export const CloneProjectMiscChargesDocument = gql`
    mutation cloneProjectMiscCharges($cloneProjectMiscChargesId: String!) {
  cloneProjectMiscCharges(cloneProjectMiscChargesId: $cloneProjectMiscChargesId)
}
    `;
export type CloneProjectMiscChargesMutationFn = Apollo.MutationFunction<CloneProjectMiscChargesMutation, CloneProjectMiscChargesMutationVariables>;

/**
 * __useCloneProjectMiscChargesMutation__
 *
 * To run a mutation, you first call `useCloneProjectMiscChargesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneProjectMiscChargesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneProjectMiscChargesMutation, { data, loading, error }] = useCloneProjectMiscChargesMutation({
 *   variables: {
 *      cloneProjectMiscChargesId: // value for 'cloneProjectMiscChargesId'
 *   },
 * });
 */
export function useCloneProjectMiscChargesMutation(baseOptions?: Apollo.MutationHookOptions<CloneProjectMiscChargesMutation, CloneProjectMiscChargesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneProjectMiscChargesMutation, CloneProjectMiscChargesMutationVariables>(CloneProjectMiscChargesDocument, options);
      }
export type CloneProjectMiscChargesMutationHookResult = ReturnType<typeof useCloneProjectMiscChargesMutation>;
export type CloneProjectMiscChargesMutationResult = Apollo.MutationResult<CloneProjectMiscChargesMutation>;
export type CloneProjectMiscChargesMutationOptions = Apollo.BaseMutationOptions<CloneProjectMiscChargesMutation, CloneProjectMiscChargesMutationVariables>;
export const GetMiscBillItemDocument = gql`
    query getMiscBillItem($id: String) {
  getMiscBillItem(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useGetMiscBillItemQuery__
 *
 * To run a query within a React component, call `useGetMiscBillItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMiscBillItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMiscBillItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMiscBillItemQuery(baseOptions?: Apollo.QueryHookOptions<GetMiscBillItemQuery, GetMiscBillItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMiscBillItemQuery, GetMiscBillItemQueryVariables>(GetMiscBillItemDocument, options);
      }
export function useGetMiscBillItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMiscBillItemQuery, GetMiscBillItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMiscBillItemQuery, GetMiscBillItemQueryVariables>(GetMiscBillItemDocument, options);
        }
export type GetMiscBillItemQueryHookResult = ReturnType<typeof useGetMiscBillItemQuery>;
export type GetMiscBillItemLazyQueryHookResult = ReturnType<typeof useGetMiscBillItemLazyQuery>;
export type GetMiscBillItemQueryResult = Apollo.QueryResult<GetMiscBillItemQuery, GetMiscBillItemQueryVariables>;
export const GetAvaiableCloneMiscChargeProjectDocument = gql`
    query getAvaiableCloneMiscChargeProject {
  getAvaiableCloneMiscChargeProject {
    id
    name
  }
}
    `;

/**
 * __useGetAvaiableCloneMiscChargeProjectQuery__
 *
 * To run a query within a React component, call `useGetAvaiableCloneMiscChargeProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvaiableCloneMiscChargeProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvaiableCloneMiscChargeProjectQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAvaiableCloneMiscChargeProjectQuery(baseOptions?: Apollo.QueryHookOptions<GetAvaiableCloneMiscChargeProjectQuery, GetAvaiableCloneMiscChargeProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvaiableCloneMiscChargeProjectQuery, GetAvaiableCloneMiscChargeProjectQueryVariables>(GetAvaiableCloneMiscChargeProjectDocument, options);
      }
export function useGetAvaiableCloneMiscChargeProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvaiableCloneMiscChargeProjectQuery, GetAvaiableCloneMiscChargeProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvaiableCloneMiscChargeProjectQuery, GetAvaiableCloneMiscChargeProjectQueryVariables>(GetAvaiableCloneMiscChargeProjectDocument, options);
        }
export type GetAvaiableCloneMiscChargeProjectQueryHookResult = ReturnType<typeof useGetAvaiableCloneMiscChargeProjectQuery>;
export type GetAvaiableCloneMiscChargeProjectLazyQueryHookResult = ReturnType<typeof useGetAvaiableCloneMiscChargeProjectLazyQuery>;
export type GetAvaiableCloneMiscChargeProjectQueryResult = Apollo.QueryResult<GetAvaiableCloneMiscChargeProjectQuery, GetAvaiableCloneMiscChargeProjectQueryVariables>;
export const GetApprovalPolicyAssignmentFlagDocument = gql`
    query getApprovalPolicyAssignmentFlag {
  getApprovalPolicyAssignmentFlag
}
    `;

/**
 * __useGetApprovalPolicyAssignmentFlagQuery__
 *
 * To run a query within a React component, call `useGetApprovalPolicyAssignmentFlagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApprovalPolicyAssignmentFlagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApprovalPolicyAssignmentFlagQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetApprovalPolicyAssignmentFlagQuery(baseOptions?: Apollo.QueryHookOptions<GetApprovalPolicyAssignmentFlagQuery, GetApprovalPolicyAssignmentFlagQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApprovalPolicyAssignmentFlagQuery, GetApprovalPolicyAssignmentFlagQueryVariables>(GetApprovalPolicyAssignmentFlagDocument, options);
      }
export function useGetApprovalPolicyAssignmentFlagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApprovalPolicyAssignmentFlagQuery, GetApprovalPolicyAssignmentFlagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApprovalPolicyAssignmentFlagQuery, GetApprovalPolicyAssignmentFlagQueryVariables>(GetApprovalPolicyAssignmentFlagDocument, options);
        }
export type GetApprovalPolicyAssignmentFlagQueryHookResult = ReturnType<typeof useGetApprovalPolicyAssignmentFlagQuery>;
export type GetApprovalPolicyAssignmentFlagLazyQueryHookResult = ReturnType<typeof useGetApprovalPolicyAssignmentFlagLazyQuery>;
export type GetApprovalPolicyAssignmentFlagQueryResult = Apollo.QueryResult<GetApprovalPolicyAssignmentFlagQuery, GetApprovalPolicyAssignmentFlagQueryVariables>;
export const GetApprovalPolicyAssignmentListingByCategoryDocument = gql`
    query getApprovalPolicyAssignmentListingByCategory($category: String!) {
  getApprovalPolicyAssignmentListingByCategory(category: $category) {
    id
    lowerLimit
    upperLimit
    approvalList {
      stepNo
      roleId
      roleName
    }
  }
}
    `;

/**
 * __useGetApprovalPolicyAssignmentListingByCategoryQuery__
 *
 * To run a query within a React component, call `useGetApprovalPolicyAssignmentListingByCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApprovalPolicyAssignmentListingByCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApprovalPolicyAssignmentListingByCategoryQuery({
 *   variables: {
 *      category: // value for 'category'
 *   },
 * });
 */
export function useGetApprovalPolicyAssignmentListingByCategoryQuery(baseOptions: Apollo.QueryHookOptions<GetApprovalPolicyAssignmentListingByCategoryQuery, GetApprovalPolicyAssignmentListingByCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApprovalPolicyAssignmentListingByCategoryQuery, GetApprovalPolicyAssignmentListingByCategoryQueryVariables>(GetApprovalPolicyAssignmentListingByCategoryDocument, options);
      }
export function useGetApprovalPolicyAssignmentListingByCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApprovalPolicyAssignmentListingByCategoryQuery, GetApprovalPolicyAssignmentListingByCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApprovalPolicyAssignmentListingByCategoryQuery, GetApprovalPolicyAssignmentListingByCategoryQueryVariables>(GetApprovalPolicyAssignmentListingByCategoryDocument, options);
        }
export type GetApprovalPolicyAssignmentListingByCategoryQueryHookResult = ReturnType<typeof useGetApprovalPolicyAssignmentListingByCategoryQuery>;
export type GetApprovalPolicyAssignmentListingByCategoryLazyQueryHookResult = ReturnType<typeof useGetApprovalPolicyAssignmentListingByCategoryLazyQuery>;
export type GetApprovalPolicyAssignmentListingByCategoryQueryResult = Apollo.QueryResult<GetApprovalPolicyAssignmentListingByCategoryQuery, GetApprovalPolicyAssignmentListingByCategoryQueryVariables>;
export const AddEditApprovalPolicyAssignmentDocument = gql`
    mutation addEditApprovalPolicyAssignment($input: AddEditApprovalAssignmentInput!) {
  addEditApprovalPolicyAssignment(input: $input)
}
    `;
export type AddEditApprovalPolicyAssignmentMutationFn = Apollo.MutationFunction<AddEditApprovalPolicyAssignmentMutation, AddEditApprovalPolicyAssignmentMutationVariables>;

/**
 * __useAddEditApprovalPolicyAssignmentMutation__
 *
 * To run a mutation, you first call `useAddEditApprovalPolicyAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEditApprovalPolicyAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEditApprovalPolicyAssignmentMutation, { data, loading, error }] = useAddEditApprovalPolicyAssignmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddEditApprovalPolicyAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<AddEditApprovalPolicyAssignmentMutation, AddEditApprovalPolicyAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEditApprovalPolicyAssignmentMutation, AddEditApprovalPolicyAssignmentMutationVariables>(AddEditApprovalPolicyAssignmentDocument, options);
      }
export type AddEditApprovalPolicyAssignmentMutationHookResult = ReturnType<typeof useAddEditApprovalPolicyAssignmentMutation>;
export type AddEditApprovalPolicyAssignmentMutationResult = Apollo.MutationResult<AddEditApprovalPolicyAssignmentMutation>;
export type AddEditApprovalPolicyAssignmentMutationOptions = Apollo.BaseMutationOptions<AddEditApprovalPolicyAssignmentMutation, AddEditApprovalPolicyAssignmentMutationVariables>;
export const CopyFromApprovalPolicyDocument = gql`
    mutation copyFromApprovalPolicy($category: String!) {
  copyFromApprovalPolicy(category: $category)
}
    `;
export type CopyFromApprovalPolicyMutationFn = Apollo.MutationFunction<CopyFromApprovalPolicyMutation, CopyFromApprovalPolicyMutationVariables>;

/**
 * __useCopyFromApprovalPolicyMutation__
 *
 * To run a mutation, you first call `useCopyFromApprovalPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyFromApprovalPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyFromApprovalPolicyMutation, { data, loading, error }] = useCopyFromApprovalPolicyMutation({
 *   variables: {
 *      category: // value for 'category'
 *   },
 * });
 */
export function useCopyFromApprovalPolicyMutation(baseOptions?: Apollo.MutationHookOptions<CopyFromApprovalPolicyMutation, CopyFromApprovalPolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyFromApprovalPolicyMutation, CopyFromApprovalPolicyMutationVariables>(CopyFromApprovalPolicyDocument, options);
      }
export type CopyFromApprovalPolicyMutationHookResult = ReturnType<typeof useCopyFromApprovalPolicyMutation>;
export type CopyFromApprovalPolicyMutationResult = Apollo.MutationResult<CopyFromApprovalPolicyMutation>;
export type CopyFromApprovalPolicyMutationOptions = Apollo.BaseMutationOptions<CopyFromApprovalPolicyMutation, CopyFromApprovalPolicyMutationVariables>;
export const GetCampaignListByProjectDocument = gql`
    query getCampaignListByProject($projectId: String!) {
  getCampaignList(projectId: $projectId) {
    id
    accountId
    name
    startDate
    endDate
    commonStatus
    getCampaignEventsCount
    getCampaignSaleRebatePackageCount
    isExistInMasterData
    isExistInTransactionData
  }
}
    `;

/**
 * __useGetCampaignListByProjectQuery__
 *
 * To run a query within a React component, call `useGetCampaignListByProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignListByProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignListByProjectQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetCampaignListByProjectQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignListByProjectQuery, GetCampaignListByProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignListByProjectQuery, GetCampaignListByProjectQueryVariables>(GetCampaignListByProjectDocument, options);
      }
export function useGetCampaignListByProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignListByProjectQuery, GetCampaignListByProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignListByProjectQuery, GetCampaignListByProjectQueryVariables>(GetCampaignListByProjectDocument, options);
        }
export type GetCampaignListByProjectQueryHookResult = ReturnType<typeof useGetCampaignListByProjectQuery>;
export type GetCampaignListByProjectLazyQueryHookResult = ReturnType<typeof useGetCampaignListByProjectLazyQuery>;
export type GetCampaignListByProjectQueryResult = Apollo.QueryResult<GetCampaignListByProjectQuery, GetCampaignListByProjectQueryVariables>;
export const AddCampaignDocument = gql`
    mutation addCampaign($input: AdminCampaignInput!) {
  addCampaign(input: $input)
}
    `;
export type AddCampaignMutationFn = Apollo.MutationFunction<AddCampaignMutation, AddCampaignMutationVariables>;

/**
 * __useAddCampaignMutation__
 *
 * To run a mutation, you first call `useAddCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCampaignMutation, { data, loading, error }] = useAddCampaignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCampaignMutation(baseOptions?: Apollo.MutationHookOptions<AddCampaignMutation, AddCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCampaignMutation, AddCampaignMutationVariables>(AddCampaignDocument, options);
      }
export type AddCampaignMutationHookResult = ReturnType<typeof useAddCampaignMutation>;
export type AddCampaignMutationResult = Apollo.MutationResult<AddCampaignMutation>;
export type AddCampaignMutationOptions = Apollo.BaseMutationOptions<AddCampaignMutation, AddCampaignMutationVariables>;
export const EditCampaignDocument = gql`
    mutation editCampaign($input: AdminCampaignInput!) {
  editCampaign(input: $input)
}
    `;
export type EditCampaignMutationFn = Apollo.MutationFunction<EditCampaignMutation, EditCampaignMutationVariables>;

/**
 * __useEditCampaignMutation__
 *
 * To run a mutation, you first call `useEditCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCampaignMutation, { data, loading, error }] = useEditCampaignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditCampaignMutation(baseOptions?: Apollo.MutationHookOptions<EditCampaignMutation, EditCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCampaignMutation, EditCampaignMutationVariables>(EditCampaignDocument, options);
      }
export type EditCampaignMutationHookResult = ReturnType<typeof useEditCampaignMutation>;
export type EditCampaignMutationResult = Apollo.MutationResult<EditCampaignMutation>;
export type EditCampaignMutationOptions = Apollo.BaseMutationOptions<EditCampaignMutation, EditCampaignMutationVariables>;
export const DeleteCampaignByIdDocument = gql`
    mutation deleteCampaignById($campaignId: String!, $isDeletable: Boolean!) {
  deleteCampaignById(campaignId: $campaignId, isDeletable: $isDeletable)
}
    `;
export type DeleteCampaignByIdMutationFn = Apollo.MutationFunction<DeleteCampaignByIdMutation, DeleteCampaignByIdMutationVariables>;

/**
 * __useDeleteCampaignByIdMutation__
 *
 * To run a mutation, you first call `useDeleteCampaignByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCampaignByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCampaignByIdMutation, { data, loading, error }] = useDeleteCampaignByIdMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      isDeletable: // value for 'isDeletable'
 *   },
 * });
 */
export function useDeleteCampaignByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCampaignByIdMutation, DeleteCampaignByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCampaignByIdMutation, DeleteCampaignByIdMutationVariables>(DeleteCampaignByIdDocument, options);
      }
export type DeleteCampaignByIdMutationHookResult = ReturnType<typeof useDeleteCampaignByIdMutation>;
export type DeleteCampaignByIdMutationResult = Apollo.MutationResult<DeleteCampaignByIdMutation>;
export type DeleteCampaignByIdMutationOptions = Apollo.BaseMutationOptions<DeleteCampaignByIdMutation, DeleteCampaignByIdMutationVariables>;
export const ActivateCampaignByIdDocument = gql`
    mutation activateCampaignById($campaignId: String!) {
  activateCampaignById(campaignId: $campaignId)
}
    `;
export type ActivateCampaignByIdMutationFn = Apollo.MutationFunction<ActivateCampaignByIdMutation, ActivateCampaignByIdMutationVariables>;

/**
 * __useActivateCampaignByIdMutation__
 *
 * To run a mutation, you first call `useActivateCampaignByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateCampaignByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateCampaignByIdMutation, { data, loading, error }] = useActivateCampaignByIdMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useActivateCampaignByIdMutation(baseOptions?: Apollo.MutationHookOptions<ActivateCampaignByIdMutation, ActivateCampaignByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateCampaignByIdMutation, ActivateCampaignByIdMutationVariables>(ActivateCampaignByIdDocument, options);
      }
export type ActivateCampaignByIdMutationHookResult = ReturnType<typeof useActivateCampaignByIdMutation>;
export type ActivateCampaignByIdMutationResult = Apollo.MutationResult<ActivateCampaignByIdMutation>;
export type ActivateCampaignByIdMutationOptions = Apollo.BaseMutationOptions<ActivateCampaignByIdMutation, ActivateCampaignByIdMutationVariables>;
export const CampaignDataByIdDocument = gql`
    query campaignDataById($campaign_id: String!) {
  getCampaignById(campaignId: $campaign_id) {
    name
    id
    startDate
    endDate
  }
}
    `;

/**
 * __useCampaignDataByIdQuery__
 *
 * To run a query within a React component, call `useCampaignDataByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignDataByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignDataByIdQuery({
 *   variables: {
 *      campaign_id: // value for 'campaign_id'
 *   },
 * });
 */
export function useCampaignDataByIdQuery(baseOptions: Apollo.QueryHookOptions<CampaignDataByIdQuery, CampaignDataByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignDataByIdQuery, CampaignDataByIdQueryVariables>(CampaignDataByIdDocument, options);
      }
export function useCampaignDataByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignDataByIdQuery, CampaignDataByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignDataByIdQuery, CampaignDataByIdQueryVariables>(CampaignDataByIdDocument, options);
        }
export type CampaignDataByIdQueryHookResult = ReturnType<typeof useCampaignDataByIdQuery>;
export type CampaignDataByIdLazyQueryHookResult = ReturnType<typeof useCampaignDataByIdLazyQuery>;
export type CampaignDataByIdQueryResult = Apollo.QueryResult<CampaignDataByIdQuery, CampaignDataByIdQueryVariables>;
export const GetEventsListByCampaignDocument = gql`
    query getEventsListByCampaign($campaign_id: String!) {
  getEventsListByCampaign(campaignId: $campaign_id) {
    events {
      id
      name
      desc
      website
      location
      startDate
      endDate
      budget
    }
  }
}
    `;

/**
 * __useGetEventsListByCampaignQuery__
 *
 * To run a query within a React component, call `useGetEventsListByCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventsListByCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventsListByCampaignQuery({
 *   variables: {
 *      campaign_id: // value for 'campaign_id'
 *   },
 * });
 */
export function useGetEventsListByCampaignQuery(baseOptions: Apollo.QueryHookOptions<GetEventsListByCampaignQuery, GetEventsListByCampaignQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventsListByCampaignQuery, GetEventsListByCampaignQueryVariables>(GetEventsListByCampaignDocument, options);
      }
export function useGetEventsListByCampaignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventsListByCampaignQuery, GetEventsListByCampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventsListByCampaignQuery, GetEventsListByCampaignQueryVariables>(GetEventsListByCampaignDocument, options);
        }
export type GetEventsListByCampaignQueryHookResult = ReturnType<typeof useGetEventsListByCampaignQuery>;
export type GetEventsListByCampaignLazyQueryHookResult = ReturnType<typeof useGetEventsListByCampaignLazyQuery>;
export type GetEventsListByCampaignQueryResult = Apollo.QueryResult<GetEventsListByCampaignQuery, GetEventsListByCampaignQueryVariables>;
export const GetEventByIdDocument = gql`
    query getEventById($campaignId: String!, $id: String!) {
  getEventById(campaignId: $campaignId, id: $id) {
    id
    name
    desc
    website
    location
    startDate
    endDate
    budget
  }
}
    `;

/**
 * __useGetEventByIdQuery__
 *
 * To run a query within a React component, call `useGetEventByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventByIdQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEventByIdQuery(baseOptions: Apollo.QueryHookOptions<GetEventByIdQuery, GetEventByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventByIdQuery, GetEventByIdQueryVariables>(GetEventByIdDocument, options);
      }
export function useGetEventByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventByIdQuery, GetEventByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventByIdQuery, GetEventByIdQueryVariables>(GetEventByIdDocument, options);
        }
export type GetEventByIdQueryHookResult = ReturnType<typeof useGetEventByIdQuery>;
export type GetEventByIdLazyQueryHookResult = ReturnType<typeof useGetEventByIdLazyQuery>;
export type GetEventByIdQueryResult = Apollo.QueryResult<GetEventByIdQuery, GetEventByIdQueryVariables>;
export const GetEventByDateDocument = gql`
    query getEventByDate($saleId: String!) {
  getEventByDate(saleId: $saleId) {
    id
    name
  }
}
    `;

/**
 * __useGetEventByDateQuery__
 *
 * To run a query within a React component, call `useGetEventByDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventByDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventByDateQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetEventByDateQuery(baseOptions: Apollo.QueryHookOptions<GetEventByDateQuery, GetEventByDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventByDateQuery, GetEventByDateQueryVariables>(GetEventByDateDocument, options);
      }
export function useGetEventByDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventByDateQuery, GetEventByDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventByDateQuery, GetEventByDateQueryVariables>(GetEventByDateDocument, options);
        }
export type GetEventByDateQueryHookResult = ReturnType<typeof useGetEventByDateQuery>;
export type GetEventByDateLazyQueryHookResult = ReturnType<typeof useGetEventByDateLazyQuery>;
export type GetEventByDateQueryResult = Apollo.QueryResult<GetEventByDateQuery, GetEventByDateQueryVariables>;
export const AddEventsDocument = gql`
    mutation addEvents($input: AdminEventsInput!) {
  addEvents(input: $input)
}
    `;
export type AddEventsMutationFn = Apollo.MutationFunction<AddEventsMutation, AddEventsMutationVariables>;

/**
 * __useAddEventsMutation__
 *
 * To run a mutation, you first call `useAddEventsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEventsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEventsMutation, { data, loading, error }] = useAddEventsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddEventsMutation(baseOptions?: Apollo.MutationHookOptions<AddEventsMutation, AddEventsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEventsMutation, AddEventsMutationVariables>(AddEventsDocument, options);
      }
export type AddEventsMutationHookResult = ReturnType<typeof useAddEventsMutation>;
export type AddEventsMutationResult = Apollo.MutationResult<AddEventsMutation>;
export type AddEventsMutationOptions = Apollo.BaseMutationOptions<AddEventsMutation, AddEventsMutationVariables>;
export const EditEventsDocument = gql`
    mutation editEvents($input: AdminEventsInput!) {
  editEvents(input: $input)
}
    `;
export type EditEventsMutationFn = Apollo.MutationFunction<EditEventsMutation, EditEventsMutationVariables>;

/**
 * __useEditEventsMutation__
 *
 * To run a mutation, you first call `useEditEventsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditEventsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editEventsMutation, { data, loading, error }] = useEditEventsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditEventsMutation(baseOptions?: Apollo.MutationHookOptions<EditEventsMutation, EditEventsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditEventsMutation, EditEventsMutationVariables>(EditEventsDocument, options);
      }
export type EditEventsMutationHookResult = ReturnType<typeof useEditEventsMutation>;
export type EditEventsMutationResult = Apollo.MutationResult<EditEventsMutation>;
export type EditEventsMutationOptions = Apollo.BaseMutationOptions<EditEventsMutation, EditEventsMutationVariables>;
export const DeleteEventsDocument = gql`
    mutation deleteEvents($eventsId: String!) {
  deleteEventsById(eventsId: $eventsId)
}
    `;
export type DeleteEventsMutationFn = Apollo.MutationFunction<DeleteEventsMutation, DeleteEventsMutationVariables>;

/**
 * __useDeleteEventsMutation__
 *
 * To run a mutation, you first call `useDeleteEventsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventsMutation, { data, loading, error }] = useDeleteEventsMutation({
 *   variables: {
 *      eventsId: // value for 'eventsId'
 *   },
 * });
 */
export function useDeleteEventsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEventsMutation, DeleteEventsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEventsMutation, DeleteEventsMutationVariables>(DeleteEventsDocument, options);
      }
export type DeleteEventsMutationHookResult = ReturnType<typeof useDeleteEventsMutation>;
export type DeleteEventsMutationResult = Apollo.MutationResult<DeleteEventsMutation>;
export type DeleteEventsMutationOptions = Apollo.BaseMutationOptions<DeleteEventsMutation, DeleteEventsMutationVariables>;
export const AssignCarParkDocument = gql`
    mutation assignCarPark($input: [assignCarParkInput!]!) {
  assignCarPark(input: $input)
}
    `;
export type AssignCarParkMutationFn = Apollo.MutationFunction<AssignCarParkMutation, AssignCarParkMutationVariables>;

/**
 * __useAssignCarParkMutation__
 *
 * To run a mutation, you first call `useAssignCarParkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignCarParkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignCarParkMutation, { data, loading, error }] = useAssignCarParkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignCarParkMutation(baseOptions?: Apollo.MutationHookOptions<AssignCarParkMutation, AssignCarParkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignCarParkMutation, AssignCarParkMutationVariables>(AssignCarParkDocument, options);
      }
export type AssignCarParkMutationHookResult = ReturnType<typeof useAssignCarParkMutation>;
export type AssignCarParkMutationResult = Apollo.MutationResult<AssignCarParkMutation>;
export type AssignCarParkMutationOptions = Apollo.BaseMutationOptions<AssignCarParkMutation, AssignCarParkMutationVariables>;
export const GetCarParksDocument = gql`
    query getCarParks($parentId: [String!]) {
  getCarParks(parentId: $parentId) {
    carParks {
      id
      unitNo
    }
    assignedCarparks {
      parentId
      parentUnitNo
      carParks {
        id
        unitNo
      }
    }
  }
}
    `;

/**
 * __useGetCarParksQuery__
 *
 * To run a query within a React component, call `useGetCarParksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarParksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCarParksQuery({
 *   variables: {
 *      parentId: // value for 'parentId'
 *   },
 * });
 */
export function useGetCarParksQuery(baseOptions?: Apollo.QueryHookOptions<GetCarParksQuery, GetCarParksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCarParksQuery, GetCarParksQueryVariables>(GetCarParksDocument, options);
      }
export function useGetCarParksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCarParksQuery, GetCarParksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCarParksQuery, GetCarParksQueryVariables>(GetCarParksDocument, options);
        }
export type GetCarParksQueryHookResult = ReturnType<typeof useGetCarParksQuery>;
export type GetCarParksLazyQueryHookResult = ReturnType<typeof useGetCarParksLazyQuery>;
export type GetCarParksQueryResult = Apollo.QueryResult<GetCarParksQuery, GetCarParksQueryVariables>;
export const GenerateCarParkDocument = gql`
    mutation generateCarPark($input: generateUnitBasicInput!) {
  generateCarPark(input: $input)
}
    `;
export type GenerateCarParkMutationFn = Apollo.MutationFunction<GenerateCarParkMutation, GenerateCarParkMutationVariables>;

/**
 * __useGenerateCarParkMutation__
 *
 * To run a mutation, you first call `useGenerateCarParkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateCarParkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateCarParkMutation, { data, loading, error }] = useGenerateCarParkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateCarParkMutation(baseOptions?: Apollo.MutationHookOptions<GenerateCarParkMutation, GenerateCarParkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateCarParkMutation, GenerateCarParkMutationVariables>(GenerateCarParkDocument, options);
      }
export type GenerateCarParkMutationHookResult = ReturnType<typeof useGenerateCarParkMutation>;
export type GenerateCarParkMutationResult = Apollo.MutationResult<GenerateCarParkMutation>;
export type GenerateCarParkMutationOptions = Apollo.BaseMutationOptions<GenerateCarParkMutation, GenerateCarParkMutationVariables>;
export const GetProjectConstructionDocument = gql`
    query getProjectConstruction($projectId: String!) {
  getAllProjectConstruction(projectId: $projectId) {
    id
    architectureStructure
    numberBlockUnit
    landProprietor
    planner
    buildingDesigner
    superStructureType
    propertyAgent
    architect
    startDate
    completionDate
    landPermitDate
    taxRegNo
    spaDuration
    basePrice
  }
}
    `;

/**
 * __useGetProjectConstructionQuery__
 *
 * To run a query within a React component, call `useGetProjectConstructionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectConstructionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectConstructionQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetProjectConstructionQuery(baseOptions: Apollo.QueryHookOptions<GetProjectConstructionQuery, GetProjectConstructionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectConstructionQuery, GetProjectConstructionQueryVariables>(GetProjectConstructionDocument, options);
      }
export function useGetProjectConstructionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectConstructionQuery, GetProjectConstructionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectConstructionQuery, GetProjectConstructionQueryVariables>(GetProjectConstructionDocument, options);
        }
export type GetProjectConstructionQueryHookResult = ReturnType<typeof useGetProjectConstructionQuery>;
export type GetProjectConstructionLazyQueryHookResult = ReturnType<typeof useGetProjectConstructionLazyQuery>;
export type GetProjectConstructionQueryResult = Apollo.QueryResult<GetProjectConstructionQuery, GetProjectConstructionQueryVariables>;
export const AddProjectConstructionDocument = gql`
    mutation addProjectConstruction($input: ProjectConstructionInput!) {
  addProjectConstruction(input: $input)
}
    `;
export type AddProjectConstructionMutationFn = Apollo.MutationFunction<AddProjectConstructionMutation, AddProjectConstructionMutationVariables>;

/**
 * __useAddProjectConstructionMutation__
 *
 * To run a mutation, you first call `useAddProjectConstructionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProjectConstructionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProjectConstructionMutation, { data, loading, error }] = useAddProjectConstructionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddProjectConstructionMutation(baseOptions?: Apollo.MutationHookOptions<AddProjectConstructionMutation, AddProjectConstructionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProjectConstructionMutation, AddProjectConstructionMutationVariables>(AddProjectConstructionDocument, options);
      }
export type AddProjectConstructionMutationHookResult = ReturnType<typeof useAddProjectConstructionMutation>;
export type AddProjectConstructionMutationResult = Apollo.MutationResult<AddProjectConstructionMutation>;
export type AddProjectConstructionMutationOptions = Apollo.BaseMutationOptions<AddProjectConstructionMutation, AddProjectConstructionMutationVariables>;
export const EditProjectConstructionDocument = gql`
    mutation editProjectConstruction($input: EditProjectConstructionInputInput!) {
  editProductConstruction(input: $input)
}
    `;
export type EditProjectConstructionMutationFn = Apollo.MutationFunction<EditProjectConstructionMutation, EditProjectConstructionMutationVariables>;

/**
 * __useEditProjectConstructionMutation__
 *
 * To run a mutation, you first call `useEditProjectConstructionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditProjectConstructionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editProjectConstructionMutation, { data, loading, error }] = useEditProjectConstructionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditProjectConstructionMutation(baseOptions?: Apollo.MutationHookOptions<EditProjectConstructionMutation, EditProjectConstructionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditProjectConstructionMutation, EditProjectConstructionMutationVariables>(EditProjectConstructionDocument, options);
      }
export type EditProjectConstructionMutationHookResult = ReturnType<typeof useEditProjectConstructionMutation>;
export type EditProjectConstructionMutationResult = Apollo.MutationResult<EditProjectConstructionMutation>;
export type EditProjectConstructionMutationOptions = Apollo.BaseMutationOptions<EditProjectConstructionMutation, EditProjectConstructionMutationVariables>;
export const AssignDiscountDocument = gql`
    mutation assignDiscount($input: assignDiscountInput!) {
  assignDiscount(input: $input)
}
    `;
export type AssignDiscountMutationFn = Apollo.MutationFunction<AssignDiscountMutation, AssignDiscountMutationVariables>;

/**
 * __useAssignDiscountMutation__
 *
 * To run a mutation, you first call `useAssignDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignDiscountMutation, { data, loading, error }] = useAssignDiscountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignDiscountMutation(baseOptions?: Apollo.MutationHookOptions<AssignDiscountMutation, AssignDiscountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignDiscountMutation, AssignDiscountMutationVariables>(AssignDiscountDocument, options);
      }
export type AssignDiscountMutationHookResult = ReturnType<typeof useAssignDiscountMutation>;
export type AssignDiscountMutationResult = Apollo.MutationResult<AssignDiscountMutation>;
export type AssignDiscountMutationOptions = Apollo.BaseMutationOptions<AssignDiscountMutation, AssignDiscountMutationVariables>;
export const EditAssignDiscountDocument = gql`
    mutation editAssignDiscount($input: assignDiscountInput!) {
  editAssignDiscount(input: $input)
}
    `;
export type EditAssignDiscountMutationFn = Apollo.MutationFunction<EditAssignDiscountMutation, EditAssignDiscountMutationVariables>;

/**
 * __useEditAssignDiscountMutation__
 *
 * To run a mutation, you first call `useEditAssignDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditAssignDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editAssignDiscountMutation, { data, loading, error }] = useEditAssignDiscountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditAssignDiscountMutation(baseOptions?: Apollo.MutationHookOptions<EditAssignDiscountMutation, EditAssignDiscountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditAssignDiscountMutation, EditAssignDiscountMutationVariables>(EditAssignDiscountDocument, options);
      }
export type EditAssignDiscountMutationHookResult = ReturnType<typeof useEditAssignDiscountMutation>;
export type EditAssignDiscountMutationResult = Apollo.MutationResult<EditAssignDiscountMutation>;
export type EditAssignDiscountMutationOptions = Apollo.BaseMutationOptions<EditAssignDiscountMutation, EditAssignDiscountMutationVariables>;
export const UnassignDiscountDocument = gql`
    mutation unassignDiscount($projectId: String!, $discountId: String!) {
  unassignDiscount(projectId: $projectId, discountId: $discountId)
}
    `;
export type UnassignDiscountMutationFn = Apollo.MutationFunction<UnassignDiscountMutation, UnassignDiscountMutationVariables>;

/**
 * __useUnassignDiscountMutation__
 *
 * To run a mutation, you first call `useUnassignDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignDiscountMutation, { data, loading, error }] = useUnassignDiscountMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      discountId: // value for 'discountId'
 *   },
 * });
 */
export function useUnassignDiscountMutation(baseOptions?: Apollo.MutationHookOptions<UnassignDiscountMutation, UnassignDiscountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnassignDiscountMutation, UnassignDiscountMutationVariables>(UnassignDiscountDocument, options);
      }
export type UnassignDiscountMutationHookResult = ReturnType<typeof useUnassignDiscountMutation>;
export type UnassignDiscountMutationResult = Apollo.MutationResult<UnassignDiscountMutation>;
export type UnassignDiscountMutationOptions = Apollo.BaseMutationOptions<UnassignDiscountMutation, UnassignDiscountMutationVariables>;
export const SetDefaultDiscountForProjectDocument = gql`
    mutation setDefaultDiscountForProject($projectId: String!, $discountId: String!, $check: Boolean!) {
  setDefaultDiscountForProject(projectId: $projectId, discountId: $discountId, check: $check)
}
    `;
export type SetDefaultDiscountForProjectMutationFn = Apollo.MutationFunction<SetDefaultDiscountForProjectMutation, SetDefaultDiscountForProjectMutationVariables>;

/**
 * __useSetDefaultDiscountForProjectMutation__
 *
 * To run a mutation, you first call `useSetDefaultDiscountForProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultDiscountForProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultDiscountForProjectMutation, { data, loading, error }] = useSetDefaultDiscountForProjectMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      discountId: // value for 'discountId'
 *      check: // value for 'check'
 *   },
 * });
 */
export function useSetDefaultDiscountForProjectMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultDiscountForProjectMutation, SetDefaultDiscountForProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultDiscountForProjectMutation, SetDefaultDiscountForProjectMutationVariables>(SetDefaultDiscountForProjectDocument, options);
      }
export type SetDefaultDiscountForProjectMutationHookResult = ReturnType<typeof useSetDefaultDiscountForProjectMutation>;
export type SetDefaultDiscountForProjectMutationResult = Apollo.MutationResult<SetDefaultDiscountForProjectMutation>;
export type SetDefaultDiscountForProjectMutationOptions = Apollo.BaseMutationOptions<SetDefaultDiscountForProjectMutation, SetDefaultDiscountForProjectMutationVariables>;
export const GetAssignedDiscountByIdDocument = gql`
    query getAssignedDiscountById($projectId: String!, $discountId: String!) {
  getAssignedDiscountById(projectId: $projectId, discountId: $discountId) {
    discountId
    projectId
    effectiveDate
    expired_date
    defaulted
  }
}
    `;

/**
 * __useGetAssignedDiscountByIdQuery__
 *
 * To run a query within a React component, call `useGetAssignedDiscountByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignedDiscountByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignedDiscountByIdQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      discountId: // value for 'discountId'
 *   },
 * });
 */
export function useGetAssignedDiscountByIdQuery(baseOptions: Apollo.QueryHookOptions<GetAssignedDiscountByIdQuery, GetAssignedDiscountByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssignedDiscountByIdQuery, GetAssignedDiscountByIdQueryVariables>(GetAssignedDiscountByIdDocument, options);
      }
export function useGetAssignedDiscountByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssignedDiscountByIdQuery, GetAssignedDiscountByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssignedDiscountByIdQuery, GetAssignedDiscountByIdQueryVariables>(GetAssignedDiscountByIdDocument, options);
        }
export type GetAssignedDiscountByIdQueryHookResult = ReturnType<typeof useGetAssignedDiscountByIdQuery>;
export type GetAssignedDiscountByIdLazyQueryHookResult = ReturnType<typeof useGetAssignedDiscountByIdLazyQuery>;
export type GetAssignedDiscountByIdQueryResult = Apollo.QueryResult<GetAssignedDiscountByIdQuery, GetAssignedDiscountByIdQueryVariables>;
export const GetDiscountAssignedByProjectIdDocument = gql`
    query getDiscountAssignedByProjectId($projectId: String!) {
  getDiscountAssignedByProjectId(projectId: $projectId) {
    id
    title
    formula
    prefix
    discountTypeId
    description
    isIntegrated
    discountVal
    projectDiscounts {
      id
      projectId
      discountId
      effectiveDate
      expired_date
      defaulted
    }
    isExistInMasterData
    isExistInTransactionData
  }
}
    `;

/**
 * __useGetDiscountAssignedByProjectIdQuery__
 *
 * To run a query within a React component, call `useGetDiscountAssignedByProjectIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiscountAssignedByProjectIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiscountAssignedByProjectIdQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetDiscountAssignedByProjectIdQuery(baseOptions: Apollo.QueryHookOptions<GetDiscountAssignedByProjectIdQuery, GetDiscountAssignedByProjectIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDiscountAssignedByProjectIdQuery, GetDiscountAssignedByProjectIdQueryVariables>(GetDiscountAssignedByProjectIdDocument, options);
      }
export function useGetDiscountAssignedByProjectIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDiscountAssignedByProjectIdQuery, GetDiscountAssignedByProjectIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDiscountAssignedByProjectIdQuery, GetDiscountAssignedByProjectIdQueryVariables>(GetDiscountAssignedByProjectIdDocument, options);
        }
export type GetDiscountAssignedByProjectIdQueryHookResult = ReturnType<typeof useGetDiscountAssignedByProjectIdQuery>;
export type GetDiscountAssignedByProjectIdLazyQueryHookResult = ReturnType<typeof useGetDiscountAssignedByProjectIdLazyQuery>;
export type GetDiscountAssignedByProjectIdQueryResult = Apollo.QueryResult<GetDiscountAssignedByProjectIdQuery, GetDiscountAssignedByProjectIdQueryVariables>;
export const GetDiscountAssigmentByProjectIdDocument = gql`
    query getDiscountAssigmentByProjectId($projectId: String!) {
  getDiscountAssigmentByProjectId(projectId: $projectId) {
    title
    description
    formula
    discountTypeId
    discountVal
    id
    isIntegrated
    prefix
    isExistInMasterData
    isExistInTransactionData
  }
}
    `;

/**
 * __useGetDiscountAssigmentByProjectIdQuery__
 *
 * To run a query within a React component, call `useGetDiscountAssigmentByProjectIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiscountAssigmentByProjectIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiscountAssigmentByProjectIdQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetDiscountAssigmentByProjectIdQuery(baseOptions: Apollo.QueryHookOptions<GetDiscountAssigmentByProjectIdQuery, GetDiscountAssigmentByProjectIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDiscountAssigmentByProjectIdQuery, GetDiscountAssigmentByProjectIdQueryVariables>(GetDiscountAssigmentByProjectIdDocument, options);
      }
export function useGetDiscountAssigmentByProjectIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDiscountAssigmentByProjectIdQuery, GetDiscountAssigmentByProjectIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDiscountAssigmentByProjectIdQuery, GetDiscountAssigmentByProjectIdQueryVariables>(GetDiscountAssigmentByProjectIdDocument, options);
        }
export type GetDiscountAssigmentByProjectIdQueryHookResult = ReturnType<typeof useGetDiscountAssigmentByProjectIdQuery>;
export type GetDiscountAssigmentByProjectIdLazyQueryHookResult = ReturnType<typeof useGetDiscountAssigmentByProjectIdLazyQuery>;
export type GetDiscountAssigmentByProjectIdQueryResult = Apollo.QueryResult<GetDiscountAssigmentByProjectIdQuery, GetDiscountAssigmentByProjectIdQueryVariables>;
export const GetProjectFireInsuranceDocument = gql`
    query getProjectFireInsurance($projectId: String!) {
  getProjectFireInsurance(projectId: $projectId) {
    id
    accountId
    projectId
    companyName
    certificateNo
    companyAddress {
      address
      city
      state
      country
      postCode
    }
  }
}
    `;

/**
 * __useGetProjectFireInsuranceQuery__
 *
 * To run a query within a React component, call `useGetProjectFireInsuranceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectFireInsuranceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectFireInsuranceQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetProjectFireInsuranceQuery(baseOptions: Apollo.QueryHookOptions<GetProjectFireInsuranceQuery, GetProjectFireInsuranceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectFireInsuranceQuery, GetProjectFireInsuranceQueryVariables>(GetProjectFireInsuranceDocument, options);
      }
export function useGetProjectFireInsuranceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectFireInsuranceQuery, GetProjectFireInsuranceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectFireInsuranceQuery, GetProjectFireInsuranceQueryVariables>(GetProjectFireInsuranceDocument, options);
        }
export type GetProjectFireInsuranceQueryHookResult = ReturnType<typeof useGetProjectFireInsuranceQuery>;
export type GetProjectFireInsuranceLazyQueryHookResult = ReturnType<typeof useGetProjectFireInsuranceLazyQuery>;
export type GetProjectFireInsuranceQueryResult = Apollo.QueryResult<GetProjectFireInsuranceQuery, GetProjectFireInsuranceQueryVariables>;
export const CreateProjectFireInsuranceDocument = gql`
    mutation createProjectFireInsurance($input: projectFireInsuranceInput!) {
  createProjectFireInsurance(input: $input) {
    projectId
    companyName
    companyAddress {
      address
      country
      city
      state
      postCode
    }
    certificateNo
  }
}
    `;
export type CreateProjectFireInsuranceMutationFn = Apollo.MutationFunction<CreateProjectFireInsuranceMutation, CreateProjectFireInsuranceMutationVariables>;

/**
 * __useCreateProjectFireInsuranceMutation__
 *
 * To run a mutation, you first call `useCreateProjectFireInsuranceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectFireInsuranceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectFireInsuranceMutation, { data, loading, error }] = useCreateProjectFireInsuranceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProjectFireInsuranceMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectFireInsuranceMutation, CreateProjectFireInsuranceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectFireInsuranceMutation, CreateProjectFireInsuranceMutationVariables>(CreateProjectFireInsuranceDocument, options);
      }
export type CreateProjectFireInsuranceMutationHookResult = ReturnType<typeof useCreateProjectFireInsuranceMutation>;
export type CreateProjectFireInsuranceMutationResult = Apollo.MutationResult<CreateProjectFireInsuranceMutation>;
export type CreateProjectFireInsuranceMutationOptions = Apollo.BaseMutationOptions<CreateProjectFireInsuranceMutation, CreateProjectFireInsuranceMutationVariables>;
export const UpdateProjectFireInsuranceDocument = gql`
    mutation updateProjectFireInsurance($input: EditProjectFireInsuranceInput!) {
  updateProjectFireInsurance(input: $input) {
    id
    projectId
    companyName
    companyAddress {
      address
      country
      city
      state
      postCode
    }
    certificateNo
  }
}
    `;
export type UpdateProjectFireInsuranceMutationFn = Apollo.MutationFunction<UpdateProjectFireInsuranceMutation, UpdateProjectFireInsuranceMutationVariables>;

/**
 * __useUpdateProjectFireInsuranceMutation__
 *
 * To run a mutation, you first call `useUpdateProjectFireInsuranceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectFireInsuranceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectFireInsuranceMutation, { data, loading, error }] = useUpdateProjectFireInsuranceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProjectFireInsuranceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectFireInsuranceMutation, UpdateProjectFireInsuranceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectFireInsuranceMutation, UpdateProjectFireInsuranceMutationVariables>(UpdateProjectFireInsuranceDocument, options);
      }
export type UpdateProjectFireInsuranceMutationHookResult = ReturnType<typeof useUpdateProjectFireInsuranceMutation>;
export type UpdateProjectFireInsuranceMutationResult = Apollo.MutationResult<UpdateProjectFireInsuranceMutation>;
export type UpdateProjectFireInsuranceMutationOptions = Apollo.BaseMutationOptions<UpdateProjectFireInsuranceMutation, UpdateProjectFireInsuranceMutationVariables>;
export const GetUnassignedNotaryListDocument = gql`
    query getUnassignedNotaryList {
  getUnassignedNotaryList {
    notaryId
    name
    email
    notaryCode
  }
}
    `;

/**
 * __useGetUnassignedNotaryListQuery__
 *
 * To run a query within a React component, call `useGetUnassignedNotaryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnassignedNotaryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnassignedNotaryListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUnassignedNotaryListQuery(baseOptions?: Apollo.QueryHookOptions<GetUnassignedNotaryListQuery, GetUnassignedNotaryListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnassignedNotaryListQuery, GetUnassignedNotaryListQueryVariables>(GetUnassignedNotaryListDocument, options);
      }
export function useGetUnassignedNotaryListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnassignedNotaryListQuery, GetUnassignedNotaryListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnassignedNotaryListQuery, GetUnassignedNotaryListQueryVariables>(GetUnassignedNotaryListDocument, options);
        }
export type GetUnassignedNotaryListQueryHookResult = ReturnType<typeof useGetUnassignedNotaryListQuery>;
export type GetUnassignedNotaryListLazyQueryHookResult = ReturnType<typeof useGetUnassignedNotaryListLazyQuery>;
export type GetUnassignedNotaryListQueryResult = Apollo.QueryResult<GetUnassignedNotaryListQuery, GetUnassignedNotaryListQueryVariables>;
export const GetAssignedNotaryListDocument = gql`
    query getAssignedNotaryList {
  getAssignedNotaryList {
    id
    name
    email
    notaryCode
    notaryId
  }
}
    `;

/**
 * __useGetAssignedNotaryListQuery__
 *
 * To run a query within a React component, call `useGetAssignedNotaryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignedNotaryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignedNotaryListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAssignedNotaryListQuery(baseOptions?: Apollo.QueryHookOptions<GetAssignedNotaryListQuery, GetAssignedNotaryListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssignedNotaryListQuery, GetAssignedNotaryListQueryVariables>(GetAssignedNotaryListDocument, options);
      }
export function useGetAssignedNotaryListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssignedNotaryListQuery, GetAssignedNotaryListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssignedNotaryListQuery, GetAssignedNotaryListQueryVariables>(GetAssignedNotaryListDocument, options);
        }
export type GetAssignedNotaryListQueryHookResult = ReturnType<typeof useGetAssignedNotaryListQuery>;
export type GetAssignedNotaryListLazyQueryHookResult = ReturnType<typeof useGetAssignedNotaryListLazyQuery>;
export type GetAssignedNotaryListQueryResult = Apollo.QueryResult<GetAssignedNotaryListQuery, GetAssignedNotaryListQueryVariables>;
export const AddAssignNotaryDocument = gql`
    mutation addAssignNotary($input: AddAssignNotaryInput!) {
  addAssignNotary(input: $input)
}
    `;
export type AddAssignNotaryMutationFn = Apollo.MutationFunction<AddAssignNotaryMutation, AddAssignNotaryMutationVariables>;

/**
 * __useAddAssignNotaryMutation__
 *
 * To run a mutation, you first call `useAddAssignNotaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAssignNotaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAssignNotaryMutation, { data, loading, error }] = useAddAssignNotaryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAssignNotaryMutation(baseOptions?: Apollo.MutationHookOptions<AddAssignNotaryMutation, AddAssignNotaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAssignNotaryMutation, AddAssignNotaryMutationVariables>(AddAssignNotaryDocument, options);
      }
export type AddAssignNotaryMutationHookResult = ReturnType<typeof useAddAssignNotaryMutation>;
export type AddAssignNotaryMutationResult = Apollo.MutationResult<AddAssignNotaryMutation>;
export type AddAssignNotaryMutationOptions = Apollo.BaseMutationOptions<AddAssignNotaryMutation, AddAssignNotaryMutationVariables>;
export const DeleteAssignNotaryDocument = gql`
    mutation deleteAssignNotary($input: DeleteAssignNotaryInput!) {
  deleteAssignNotary(input: $input)
}
    `;
export type DeleteAssignNotaryMutationFn = Apollo.MutationFunction<DeleteAssignNotaryMutation, DeleteAssignNotaryMutationVariables>;

/**
 * __useDeleteAssignNotaryMutation__
 *
 * To run a mutation, you first call `useDeleteAssignNotaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssignNotaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssignNotaryMutation, { data, loading, error }] = useDeleteAssignNotaryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAssignNotaryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAssignNotaryMutation, DeleteAssignNotaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAssignNotaryMutation, DeleteAssignNotaryMutationVariables>(DeleteAssignNotaryDocument, options);
      }
export type DeleteAssignNotaryMutationHookResult = ReturnType<typeof useDeleteAssignNotaryMutation>;
export type DeleteAssignNotaryMutationResult = Apollo.MutationResult<DeleteAssignNotaryMutation>;
export type DeleteAssignNotaryMutationOptions = Apollo.BaseMutationOptions<DeleteAssignNotaryMutation, DeleteAssignNotaryMutationVariables>;
export const FinancierPanelListDocument = gql`
    query financierPanelList($projectId: String!) {
  panelByProject(projectId: $projectId) {
    financierStatus
    id
    assignedDate
    financialLimit
    financierInfo {
      id
      name
      financierId
    }
    financierCommonStatus
  }
}
    `;

/**
 * __useFinancierPanelListQuery__
 *
 * To run a query within a React component, call `useFinancierPanelListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinancierPanelListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinancierPanelListQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useFinancierPanelListQuery(baseOptions: Apollo.QueryHookOptions<FinancierPanelListQuery, FinancierPanelListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FinancierPanelListQuery, FinancierPanelListQueryVariables>(FinancierPanelListDocument, options);
      }
export function useFinancierPanelListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FinancierPanelListQuery, FinancierPanelListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FinancierPanelListQuery, FinancierPanelListQueryVariables>(FinancierPanelListDocument, options);
        }
export type FinancierPanelListQueryHookResult = ReturnType<typeof useFinancierPanelListQuery>;
export type FinancierPanelListLazyQueryHookResult = ReturnType<typeof useFinancierPanelListLazyQuery>;
export type FinancierPanelListQueryResult = Apollo.QueryResult<FinancierPanelListQuery, FinancierPanelListQueryVariables>;
export const FinancierAssignListDocument = gql`
    query financierAssignList($projectId: String!, $financierId: String) {
  panelFinancierList(project_id: $projectId, financier_id: $financierId) {
    id
    name
    financialLimit
    financierContact {
      id
      name
    }
    projectInvitation {
      projectId
      invitation {
        contactInfo {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useFinancierAssignListQuery__
 *
 * To run a query within a React component, call `useFinancierAssignListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinancierAssignListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinancierAssignListQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      financierId: // value for 'financierId'
 *   },
 * });
 */
export function useFinancierAssignListQuery(baseOptions: Apollo.QueryHookOptions<FinancierAssignListQuery, FinancierAssignListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FinancierAssignListQuery, FinancierAssignListQueryVariables>(FinancierAssignListDocument, options);
      }
export function useFinancierAssignListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FinancierAssignListQuery, FinancierAssignListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FinancierAssignListQuery, FinancierAssignListQueryVariables>(FinancierAssignListDocument, options);
        }
export type FinancierAssignListQueryHookResult = ReturnType<typeof useFinancierAssignListQuery>;
export type FinancierAssignListLazyQueryHookResult = ReturnType<typeof useFinancierAssignListLazyQuery>;
export type FinancierAssignListQueryResult = Apollo.QueryResult<FinancierAssignListQuery, FinancierAssignListQueryVariables>;
export const FinancierPanelDetailDocument = gql`
    query financierPanelDetail($financierId: String!, $projectId: String!) {
  panelDetails(financier_id: $financierId, project_id: $projectId) {
    id
    name
    endfinFinancierId
    officeTel
    address {
      address
      city
      state
      country
      postCode
    }
    financierContact {
      id
      name
      phoneNo
      email
      invitationDate
      default
    }
  }
}
    `;

/**
 * __useFinancierPanelDetailQuery__
 *
 * To run a query within a React component, call `useFinancierPanelDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinancierPanelDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinancierPanelDetailQuery({
 *   variables: {
 *      financierId: // value for 'financierId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useFinancierPanelDetailQuery(baseOptions: Apollo.QueryHookOptions<FinancierPanelDetailQuery, FinancierPanelDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FinancierPanelDetailQuery, FinancierPanelDetailQueryVariables>(FinancierPanelDetailDocument, options);
      }
export function useFinancierPanelDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FinancierPanelDetailQuery, FinancierPanelDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FinancierPanelDetailQuery, FinancierPanelDetailQueryVariables>(FinancierPanelDetailDocument, options);
        }
export type FinancierPanelDetailQueryHookResult = ReturnType<typeof useFinancierPanelDetailQuery>;
export type FinancierPanelDetailLazyQueryHookResult = ReturnType<typeof useFinancierPanelDetailLazyQuery>;
export type FinancierPanelDetailQueryResult = Apollo.QueryResult<FinancierPanelDetailQuery, FinancierPanelDetailQueryVariables>;
export const SetDefaultFinancierContactDocument = gql`
    mutation setDefaultFinancierContact($contactId: String!, $project_id: String!, $financier_id: String!) {
  setDefaultFinancierContact(contactId: $contactId, project_id: $project_id, financier_id: $financier_id)
}
    `;
export type SetDefaultFinancierContactMutationFn = Apollo.MutationFunction<SetDefaultFinancierContactMutation, SetDefaultFinancierContactMutationVariables>;

/**
 * __useSetDefaultFinancierContactMutation__
 *
 * To run a mutation, you first call `useSetDefaultFinancierContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultFinancierContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultFinancierContactMutation, { data, loading, error }] = useSetDefaultFinancierContactMutation({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      project_id: // value for 'project_id'
 *      financier_id: // value for 'financier_id'
 *   },
 * });
 */
export function useSetDefaultFinancierContactMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultFinancierContactMutation, SetDefaultFinancierContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultFinancierContactMutation, SetDefaultFinancierContactMutationVariables>(SetDefaultFinancierContactDocument, options);
      }
export type SetDefaultFinancierContactMutationHookResult = ReturnType<typeof useSetDefaultFinancierContactMutation>;
export type SetDefaultFinancierContactMutationResult = Apollo.MutationResult<SetDefaultFinancierContactMutation>;
export type SetDefaultFinancierContactMutationOptions = Apollo.BaseMutationOptions<SetDefaultFinancierContactMutation, SetDefaultFinancierContactMutationVariables>;
export const FinancierAssignPanelDocument = gql`
    mutation financierAssignPanel($input: AdminFinancierPanelInput!) {
  assignPanel(input: $input)
}
    `;
export type FinancierAssignPanelMutationFn = Apollo.MutationFunction<FinancierAssignPanelMutation, FinancierAssignPanelMutationVariables>;

/**
 * __useFinancierAssignPanelMutation__
 *
 * To run a mutation, you first call `useFinancierAssignPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinancierAssignPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [financierAssignPanelMutation, { data, loading, error }] = useFinancierAssignPanelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFinancierAssignPanelMutation(baseOptions?: Apollo.MutationHookOptions<FinancierAssignPanelMutation, FinancierAssignPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinancierAssignPanelMutation, FinancierAssignPanelMutationVariables>(FinancierAssignPanelDocument, options);
      }
export type FinancierAssignPanelMutationHookResult = ReturnType<typeof useFinancierAssignPanelMutation>;
export type FinancierAssignPanelMutationResult = Apollo.MutationResult<FinancierAssignPanelMutation>;
export type FinancierAssignPanelMutationOptions = Apollo.BaseMutationOptions<FinancierAssignPanelMutation, FinancierAssignPanelMutationVariables>;
export const FinancierUnassignPanelDocument = gql`
    mutation financierUnassignPanel($financierId: String!, $projectId: String!) {
  unassignPanel(financier_id: $financierId, project_id: $projectId)
}
    `;
export type FinancierUnassignPanelMutationFn = Apollo.MutationFunction<FinancierUnassignPanelMutation, FinancierUnassignPanelMutationVariables>;

/**
 * __useFinancierUnassignPanelMutation__
 *
 * To run a mutation, you first call `useFinancierUnassignPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinancierUnassignPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [financierUnassignPanelMutation, { data, loading, error }] = useFinancierUnassignPanelMutation({
 *   variables: {
 *      financierId: // value for 'financierId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useFinancierUnassignPanelMutation(baseOptions?: Apollo.MutationHookOptions<FinancierUnassignPanelMutation, FinancierUnassignPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinancierUnassignPanelMutation, FinancierUnassignPanelMutationVariables>(FinancierUnassignPanelDocument, options);
      }
export type FinancierUnassignPanelMutationHookResult = ReturnType<typeof useFinancierUnassignPanelMutation>;
export type FinancierUnassignPanelMutationResult = Apollo.MutationResult<FinancierUnassignPanelMutation>;
export type FinancierUnassignPanelMutationOptions = Apollo.BaseMutationOptions<FinancierUnassignPanelMutation, FinancierUnassignPanelMutationVariables>;
export const EditFinancierLimitDocument = gql`
    mutation editFinancierLimit($id: String!, $financialLimit: Float!) {
  editFinancialLimit(id: $id, financialLimit: $financialLimit)
}
    `;
export type EditFinancierLimitMutationFn = Apollo.MutationFunction<EditFinancierLimitMutation, EditFinancierLimitMutationVariables>;

/**
 * __useEditFinancierLimitMutation__
 *
 * To run a mutation, you first call `useEditFinancierLimitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditFinancierLimitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editFinancierLimitMutation, { data, loading, error }] = useEditFinancierLimitMutation({
 *   variables: {
 *      id: // value for 'id'
 *      financialLimit: // value for 'financialLimit'
 *   },
 * });
 */
export function useEditFinancierLimitMutation(baseOptions?: Apollo.MutationHookOptions<EditFinancierLimitMutation, EditFinancierLimitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditFinancierLimitMutation, EditFinancierLimitMutationVariables>(EditFinancierLimitDocument, options);
      }
export type EditFinancierLimitMutationHookResult = ReturnType<typeof useEditFinancierLimitMutation>;
export type EditFinancierLimitMutationResult = Apollo.MutationResult<EditFinancierLimitMutation>;
export type EditFinancierLimitMutationOptions = Apollo.BaseMutationOptions<EditFinancierLimitMutation, EditFinancierLimitMutationVariables>;
export const SolicitorAppointedListDocument = gql`
    query solicitorAppointedList($project_id: String!) {
  solicitorAppointedList(project_id: $project_id) {
    id
    solicitorId
    name
    modTs
    logoUrl
    commonStatus
    officeTel
    default(projectId: $project_id)
    solicitorStatus(project_id: $project_id)
    solicitorUnitCount(project_id: $project_id) {
      allocated
      sold
    }
  }
}
    `;

/**
 * __useSolicitorAppointedListQuery__
 *
 * To run a query within a React component, call `useSolicitorAppointedListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSolicitorAppointedListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSolicitorAppointedListQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *   },
 * });
 */
export function useSolicitorAppointedListQuery(baseOptions: Apollo.QueryHookOptions<SolicitorAppointedListQuery, SolicitorAppointedListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SolicitorAppointedListQuery, SolicitorAppointedListQueryVariables>(SolicitorAppointedListDocument, options);
      }
export function useSolicitorAppointedListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SolicitorAppointedListQuery, SolicitorAppointedListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SolicitorAppointedListQuery, SolicitorAppointedListQueryVariables>(SolicitorAppointedListDocument, options);
        }
export type SolicitorAppointedListQueryHookResult = ReturnType<typeof useSolicitorAppointedListQuery>;
export type SolicitorAppointedListLazyQueryHookResult = ReturnType<typeof useSolicitorAppointedListLazyQuery>;
export type SolicitorAppointedListQueryResult = Apollo.QueryResult<SolicitorAppointedListQuery, SolicitorAppointedListQueryVariables>;
export const SolicitorListForAssignmentDocument = gql`
    query solicitorListForAssignment($projectId: String!) {
  solicitorListForAssignment(project_id: $projectId) {
    id
    solicitorId
    name
  }
}
    `;

/**
 * __useSolicitorListForAssignmentQuery__
 *
 * To run a query within a React component, call `useSolicitorListForAssignmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useSolicitorListForAssignmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSolicitorListForAssignmentQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useSolicitorListForAssignmentQuery(baseOptions: Apollo.QueryHookOptions<SolicitorListForAssignmentQuery, SolicitorListForAssignmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SolicitorListForAssignmentQuery, SolicitorListForAssignmentQueryVariables>(SolicitorListForAssignmentDocument, options);
      }
export function useSolicitorListForAssignmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SolicitorListForAssignmentQuery, SolicitorListForAssignmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SolicitorListForAssignmentQuery, SolicitorListForAssignmentQueryVariables>(SolicitorListForAssignmentDocument, options);
        }
export type SolicitorListForAssignmentQueryHookResult = ReturnType<typeof useSolicitorListForAssignmentQuery>;
export type SolicitorListForAssignmentLazyQueryHookResult = ReturnType<typeof useSolicitorListForAssignmentLazyQuery>;
export type SolicitorListForAssignmentQueryResult = Apollo.QueryResult<SolicitorListForAssignmentQuery, SolicitorListForAssignmentQueryVariables>;
export const AssignSolicitorToProjectDocument = gql`
    mutation assignSolicitorToProject($projectId: String!, $solicitor_appointed_id: [String!]!) {
  assignSolicitorToProject(project_id: $projectId, solicitor_appointed_id: $solicitor_appointed_id)
}
    `;
export type AssignSolicitorToProjectMutationFn = Apollo.MutationFunction<AssignSolicitorToProjectMutation, AssignSolicitorToProjectMutationVariables>;

/**
 * __useAssignSolicitorToProjectMutation__
 *
 * To run a mutation, you first call `useAssignSolicitorToProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignSolicitorToProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignSolicitorToProjectMutation, { data, loading, error }] = useAssignSolicitorToProjectMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      solicitor_appointed_id: // value for 'solicitor_appointed_id'
 *   },
 * });
 */
export function useAssignSolicitorToProjectMutation(baseOptions?: Apollo.MutationHookOptions<AssignSolicitorToProjectMutation, AssignSolicitorToProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignSolicitorToProjectMutation, AssignSolicitorToProjectMutationVariables>(AssignSolicitorToProjectDocument, options);
      }
export type AssignSolicitorToProjectMutationHookResult = ReturnType<typeof useAssignSolicitorToProjectMutation>;
export type AssignSolicitorToProjectMutationResult = Apollo.MutationResult<AssignSolicitorToProjectMutation>;
export type AssignSolicitorToProjectMutationOptions = Apollo.BaseMutationOptions<AssignSolicitorToProjectMutation, AssignSolicitorToProjectMutationVariables>;
export const SolicitorAppointedDetailsDocument = gql`
    query solicitorAppointedDetails($solicitor_appointed_id: String!) {
  solicitorAppointedDetails(solicitor_appointed_id: $solicitor_appointed_id) {
    id
    name
    email
    officeTel
    address {
      address
    }
    createdTs
    contactName
    contactEmail
    contactPhoneNo
  }
}
    `;

/**
 * __useSolicitorAppointedDetailsQuery__
 *
 * To run a query within a React component, call `useSolicitorAppointedDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSolicitorAppointedDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSolicitorAppointedDetailsQuery({
 *   variables: {
 *      solicitor_appointed_id: // value for 'solicitor_appointed_id'
 *   },
 * });
 */
export function useSolicitorAppointedDetailsQuery(baseOptions: Apollo.QueryHookOptions<SolicitorAppointedDetailsQuery, SolicitorAppointedDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SolicitorAppointedDetailsQuery, SolicitorAppointedDetailsQueryVariables>(SolicitorAppointedDetailsDocument, options);
      }
export function useSolicitorAppointedDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SolicitorAppointedDetailsQuery, SolicitorAppointedDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SolicitorAppointedDetailsQuery, SolicitorAppointedDetailsQueryVariables>(SolicitorAppointedDetailsDocument, options);
        }
export type SolicitorAppointedDetailsQueryHookResult = ReturnType<typeof useSolicitorAppointedDetailsQuery>;
export type SolicitorAppointedDetailsLazyQueryHookResult = ReturnType<typeof useSolicitorAppointedDetailsLazyQuery>;
export type SolicitorAppointedDetailsQueryResult = Apollo.QueryResult<SolicitorAppointedDetailsQuery, SolicitorAppointedDetailsQueryVariables>;
export const UnassignPanelSolicitorDocument = gql`
    mutation unassignPanelSolicitor($project_id: String!, $solicitor_id: String!) {
  unassignSolicitorFromProject(project_id: $project_id, solicitor_id: $solicitor_id)
}
    `;
export type UnassignPanelSolicitorMutationFn = Apollo.MutationFunction<UnassignPanelSolicitorMutation, UnassignPanelSolicitorMutationVariables>;

/**
 * __useUnassignPanelSolicitorMutation__
 *
 * To run a mutation, you first call `useUnassignPanelSolicitorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignPanelSolicitorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignPanelSolicitorMutation, { data, loading, error }] = useUnassignPanelSolicitorMutation({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      solicitor_id: // value for 'solicitor_id'
 *   },
 * });
 */
export function useUnassignPanelSolicitorMutation(baseOptions?: Apollo.MutationHookOptions<UnassignPanelSolicitorMutation, UnassignPanelSolicitorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnassignPanelSolicitorMutation, UnassignPanelSolicitorMutationVariables>(UnassignPanelSolicitorDocument, options);
      }
export type UnassignPanelSolicitorMutationHookResult = ReturnType<typeof useUnassignPanelSolicitorMutation>;
export type UnassignPanelSolicitorMutationResult = Apollo.MutationResult<UnassignPanelSolicitorMutation>;
export type UnassignPanelSolicitorMutationOptions = Apollo.BaseMutationOptions<UnassignPanelSolicitorMutation, UnassignPanelSolicitorMutationVariables>;
export const MarkAsDefaultSolicitorDocument = gql`
    mutation markAsDefaultSolicitor($projectId: String!, $solicitorId: String!) {
  markAsDefault(projectId: $projectId, solicitorId: $solicitorId)
}
    `;
export type MarkAsDefaultSolicitorMutationFn = Apollo.MutationFunction<MarkAsDefaultSolicitorMutation, MarkAsDefaultSolicitorMutationVariables>;

/**
 * __useMarkAsDefaultSolicitorMutation__
 *
 * To run a mutation, you first call `useMarkAsDefaultSolicitorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAsDefaultSolicitorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAsDefaultSolicitorMutation, { data, loading, error }] = useMarkAsDefaultSolicitorMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      solicitorId: // value for 'solicitorId'
 *   },
 * });
 */
export function useMarkAsDefaultSolicitorMutation(baseOptions?: Apollo.MutationHookOptions<MarkAsDefaultSolicitorMutation, MarkAsDefaultSolicitorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkAsDefaultSolicitorMutation, MarkAsDefaultSolicitorMutationVariables>(MarkAsDefaultSolicitorDocument, options);
      }
export type MarkAsDefaultSolicitorMutationHookResult = ReturnType<typeof useMarkAsDefaultSolicitorMutation>;
export type MarkAsDefaultSolicitorMutationResult = Apollo.MutationResult<MarkAsDefaultSolicitorMutation>;
export type MarkAsDefaultSolicitorMutationOptions = Apollo.BaseMutationOptions<MarkAsDefaultSolicitorMutation, MarkAsDefaultSolicitorMutationVariables>;
export const GetAllProjectPaymentPlanDocument = gql`
    query getAllProjectPaymentPlan($project_id: String!, $typePaymentPlan: TypePaymentPlanEnum!) {
  getAllProjectPaymentPlan(project_id: $project_id, typePaymentPlan: $typePaymentPlan) {
    id
    accountId
    projectId
    paymentPlanId
    defaulted
    commonStatus
    startDate
    endDate
    paymentPlanName
    paymentPlanEffecDate
  }
}
    `;

/**
 * __useGetAllProjectPaymentPlanQuery__
 *
 * To run a query within a React component, call `useGetAllProjectPaymentPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllProjectPaymentPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllProjectPaymentPlanQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      typePaymentPlan: // value for 'typePaymentPlan'
 *   },
 * });
 */
export function useGetAllProjectPaymentPlanQuery(baseOptions: Apollo.QueryHookOptions<GetAllProjectPaymentPlanQuery, GetAllProjectPaymentPlanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllProjectPaymentPlanQuery, GetAllProjectPaymentPlanQueryVariables>(GetAllProjectPaymentPlanDocument, options);
      }
export function useGetAllProjectPaymentPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllProjectPaymentPlanQuery, GetAllProjectPaymentPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllProjectPaymentPlanQuery, GetAllProjectPaymentPlanQueryVariables>(GetAllProjectPaymentPlanDocument, options);
        }
export type GetAllProjectPaymentPlanQueryHookResult = ReturnType<typeof useGetAllProjectPaymentPlanQuery>;
export type GetAllProjectPaymentPlanLazyQueryHookResult = ReturnType<typeof useGetAllProjectPaymentPlanLazyQuery>;
export type GetAllProjectPaymentPlanQueryResult = Apollo.QueryResult<GetAllProjectPaymentPlanQuery, GetAllProjectPaymentPlanQueryVariables>;
export const GetAllPaymentPlanForProjectDocument = gql`
    query getAllPaymentPlanForProject {
  getAllPaymentPlanForProject {
    name
    id
    accountId
    recordStatus
    effectiveDate
  }
}
    `;

/**
 * __useGetAllPaymentPlanForProjectQuery__
 *
 * To run a query within a React component, call `useGetAllPaymentPlanForProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPaymentPlanForProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPaymentPlanForProjectQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllPaymentPlanForProjectQuery(baseOptions?: Apollo.QueryHookOptions<GetAllPaymentPlanForProjectQuery, GetAllPaymentPlanForProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllPaymentPlanForProjectQuery, GetAllPaymentPlanForProjectQueryVariables>(GetAllPaymentPlanForProjectDocument, options);
      }
export function useGetAllPaymentPlanForProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllPaymentPlanForProjectQuery, GetAllPaymentPlanForProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllPaymentPlanForProjectQuery, GetAllPaymentPlanForProjectQueryVariables>(GetAllPaymentPlanForProjectDocument, options);
        }
export type GetAllPaymentPlanForProjectQueryHookResult = ReturnType<typeof useGetAllPaymentPlanForProjectQuery>;
export type GetAllPaymentPlanForProjectLazyQueryHookResult = ReturnType<typeof useGetAllPaymentPlanForProjectLazyQuery>;
export type GetAllPaymentPlanForProjectQueryResult = Apollo.QueryResult<GetAllPaymentPlanForProjectQuery, GetAllPaymentPlanForProjectQueryVariables>;
export const SetDefaultPaymentPlanForProjectDocument = gql`
    mutation setDefaultPaymentPlanForProject($input: SetDefaultPaymentPlanForProjectInput!) {
  setDefaultPaymentPlanForProject(input: $input)
}
    `;
export type SetDefaultPaymentPlanForProjectMutationFn = Apollo.MutationFunction<SetDefaultPaymentPlanForProjectMutation, SetDefaultPaymentPlanForProjectMutationVariables>;

/**
 * __useSetDefaultPaymentPlanForProjectMutation__
 *
 * To run a mutation, you first call `useSetDefaultPaymentPlanForProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultPaymentPlanForProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultPaymentPlanForProjectMutation, { data, loading, error }] = useSetDefaultPaymentPlanForProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetDefaultPaymentPlanForProjectMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultPaymentPlanForProjectMutation, SetDefaultPaymentPlanForProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultPaymentPlanForProjectMutation, SetDefaultPaymentPlanForProjectMutationVariables>(SetDefaultPaymentPlanForProjectDocument, options);
      }
export type SetDefaultPaymentPlanForProjectMutationHookResult = ReturnType<typeof useSetDefaultPaymentPlanForProjectMutation>;
export type SetDefaultPaymentPlanForProjectMutationResult = Apollo.MutationResult<SetDefaultPaymentPlanForProjectMutation>;
export type SetDefaultPaymentPlanForProjectMutationOptions = Apollo.BaseMutationOptions<SetDefaultPaymentPlanForProjectMutation, SetDefaultPaymentPlanForProjectMutationVariables>;
export const AddProjectPaymentPlanDocument = gql`
    mutation addProjectPaymentPlan($input: AddProjectPaymentPlanInput!) {
  addProjectPaymentPlan(input: $input)
}
    `;
export type AddProjectPaymentPlanMutationFn = Apollo.MutationFunction<AddProjectPaymentPlanMutation, AddProjectPaymentPlanMutationVariables>;

/**
 * __useAddProjectPaymentPlanMutation__
 *
 * To run a mutation, you first call `useAddProjectPaymentPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProjectPaymentPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProjectPaymentPlanMutation, { data, loading, error }] = useAddProjectPaymentPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddProjectPaymentPlanMutation(baseOptions?: Apollo.MutationHookOptions<AddProjectPaymentPlanMutation, AddProjectPaymentPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProjectPaymentPlanMutation, AddProjectPaymentPlanMutationVariables>(AddProjectPaymentPlanDocument, options);
      }
export type AddProjectPaymentPlanMutationHookResult = ReturnType<typeof useAddProjectPaymentPlanMutation>;
export type AddProjectPaymentPlanMutationResult = Apollo.MutationResult<AddProjectPaymentPlanMutation>;
export type AddProjectPaymentPlanMutationOptions = Apollo.BaseMutationOptions<AddProjectPaymentPlanMutation, AddProjectPaymentPlanMutationVariables>;
export const DeleteProjectPaymentPlanDocument = gql`
    mutation deleteProjectPaymentPlan($projectPaymentPlanId: String!, $typePaymentPlan: TypePaymentPlanEnum!) {
  deleteProjectPaymentPlan(projectPaymentPlanId: $projectPaymentPlanId, typePaymentPlan: $typePaymentPlan)
}
    `;
export type DeleteProjectPaymentPlanMutationFn = Apollo.MutationFunction<DeleteProjectPaymentPlanMutation, DeleteProjectPaymentPlanMutationVariables>;

/**
 * __useDeleteProjectPaymentPlanMutation__
 *
 * To run a mutation, you first call `useDeleteProjectPaymentPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectPaymentPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectPaymentPlanMutation, { data, loading, error }] = useDeleteProjectPaymentPlanMutation({
 *   variables: {
 *      projectPaymentPlanId: // value for 'projectPaymentPlanId'
 *      typePaymentPlan: // value for 'typePaymentPlan'
 *   },
 * });
 */
export function useDeleteProjectPaymentPlanMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectPaymentPlanMutation, DeleteProjectPaymentPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectPaymentPlanMutation, DeleteProjectPaymentPlanMutationVariables>(DeleteProjectPaymentPlanDocument, options);
      }
export type DeleteProjectPaymentPlanMutationHookResult = ReturnType<typeof useDeleteProjectPaymentPlanMutation>;
export type DeleteProjectPaymentPlanMutationResult = Apollo.MutationResult<DeleteProjectPaymentPlanMutation>;
export type DeleteProjectPaymentPlanMutationOptions = Apollo.BaseMutationOptions<DeleteProjectPaymentPlanMutation, DeleteProjectPaymentPlanMutationVariables>;
export const DeactivateProjectPaymentPlanDocument = gql`
    mutation deactivateProjectPaymentPlan($projectPaymentPlanId: String!, $typePaymentPlan: TypePaymentPlanEnum!) {
  deactivateProjectPaymentPlan(projectPaymentPlanId: $projectPaymentPlanId, typePaymentPlan: $typePaymentPlan)
}
    `;
export type DeactivateProjectPaymentPlanMutationFn = Apollo.MutationFunction<DeactivateProjectPaymentPlanMutation, DeactivateProjectPaymentPlanMutationVariables>;

/**
 * __useDeactivateProjectPaymentPlanMutation__
 *
 * To run a mutation, you first call `useDeactivateProjectPaymentPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateProjectPaymentPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateProjectPaymentPlanMutation, { data, loading, error }] = useDeactivateProjectPaymentPlanMutation({
 *   variables: {
 *      projectPaymentPlanId: // value for 'projectPaymentPlanId'
 *      typePaymentPlan: // value for 'typePaymentPlan'
 *   },
 * });
 */
export function useDeactivateProjectPaymentPlanMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateProjectPaymentPlanMutation, DeactivateProjectPaymentPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateProjectPaymentPlanMutation, DeactivateProjectPaymentPlanMutationVariables>(DeactivateProjectPaymentPlanDocument, options);
      }
export type DeactivateProjectPaymentPlanMutationHookResult = ReturnType<typeof useDeactivateProjectPaymentPlanMutation>;
export type DeactivateProjectPaymentPlanMutationResult = Apollo.MutationResult<DeactivateProjectPaymentPlanMutation>;
export type DeactivateProjectPaymentPlanMutationOptions = Apollo.BaseMutationOptions<DeactivateProjectPaymentPlanMutation, DeactivateProjectPaymentPlanMutationVariables>;
export const GetAllProjectPermitDocument = gql`
    query getAllProjectPermit($projectId: String!) {
  getAllProjectPermit(projectId: $projectId) {
    id
    projectId
    permitNo
    permitType
    issueDate
    expiryDate
    commonStatus
  }
}
    `;

/**
 * __useGetAllProjectPermitQuery__
 *
 * To run a query within a React component, call `useGetAllProjectPermitQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllProjectPermitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllProjectPermitQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetAllProjectPermitQuery(baseOptions: Apollo.QueryHookOptions<GetAllProjectPermitQuery, GetAllProjectPermitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllProjectPermitQuery, GetAllProjectPermitQueryVariables>(GetAllProjectPermitDocument, options);
      }
export function useGetAllProjectPermitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllProjectPermitQuery, GetAllProjectPermitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllProjectPermitQuery, GetAllProjectPermitQueryVariables>(GetAllProjectPermitDocument, options);
        }
export type GetAllProjectPermitQueryHookResult = ReturnType<typeof useGetAllProjectPermitQuery>;
export type GetAllProjectPermitLazyQueryHookResult = ReturnType<typeof useGetAllProjectPermitLazyQuery>;
export type GetAllProjectPermitQueryResult = Apollo.QueryResult<GetAllProjectPermitQuery, GetAllProjectPermitQueryVariables>;
export const GetProjectPermitByIdDocument = gql`
    query getProjectPermitById($projectId: String!) {
  getProjectPermitById(projectId: $projectId) {
    id
    projectId
    permitNo
    permitType
    issueDate
    expiryDate
    commonStatus
  }
}
    `;

/**
 * __useGetProjectPermitByIdQuery__
 *
 * To run a query within a React component, call `useGetProjectPermitByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectPermitByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectPermitByIdQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetProjectPermitByIdQuery(baseOptions: Apollo.QueryHookOptions<GetProjectPermitByIdQuery, GetProjectPermitByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectPermitByIdQuery, GetProjectPermitByIdQueryVariables>(GetProjectPermitByIdDocument, options);
      }
export function useGetProjectPermitByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectPermitByIdQuery, GetProjectPermitByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectPermitByIdQuery, GetProjectPermitByIdQueryVariables>(GetProjectPermitByIdDocument, options);
        }
export type GetProjectPermitByIdQueryHookResult = ReturnType<typeof useGetProjectPermitByIdQuery>;
export type GetProjectPermitByIdLazyQueryHookResult = ReturnType<typeof useGetProjectPermitByIdLazyQuery>;
export type GetProjectPermitByIdQueryResult = Apollo.QueryResult<GetProjectPermitByIdQuery, GetProjectPermitByIdQueryVariables>;
export const AddProjectPermitDocument = gql`
    mutation addProjectPermit($input: AddProjectPermitInput!) {
  addProjectPermit(input: $input)
}
    `;
export type AddProjectPermitMutationFn = Apollo.MutationFunction<AddProjectPermitMutation, AddProjectPermitMutationVariables>;

/**
 * __useAddProjectPermitMutation__
 *
 * To run a mutation, you first call `useAddProjectPermitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProjectPermitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProjectPermitMutation, { data, loading, error }] = useAddProjectPermitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddProjectPermitMutation(baseOptions?: Apollo.MutationHookOptions<AddProjectPermitMutation, AddProjectPermitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProjectPermitMutation, AddProjectPermitMutationVariables>(AddProjectPermitDocument, options);
      }
export type AddProjectPermitMutationHookResult = ReturnType<typeof useAddProjectPermitMutation>;
export type AddProjectPermitMutationResult = Apollo.MutationResult<AddProjectPermitMutation>;
export type AddProjectPermitMutationOptions = Apollo.BaseMutationOptions<AddProjectPermitMutation, AddProjectPermitMutationVariables>;
export const EditProjectPermitDocument = gql`
    mutation editProjectPermit($input: EditProjectPermitInput!) {
  editProjectPermit(input: $input)
}
    `;
export type EditProjectPermitMutationFn = Apollo.MutationFunction<EditProjectPermitMutation, EditProjectPermitMutationVariables>;

/**
 * __useEditProjectPermitMutation__
 *
 * To run a mutation, you first call `useEditProjectPermitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditProjectPermitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editProjectPermitMutation, { data, loading, error }] = useEditProjectPermitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditProjectPermitMutation(baseOptions?: Apollo.MutationHookOptions<EditProjectPermitMutation, EditProjectPermitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditProjectPermitMutation, EditProjectPermitMutationVariables>(EditProjectPermitDocument, options);
      }
export type EditProjectPermitMutationHookResult = ReturnType<typeof useEditProjectPermitMutation>;
export type EditProjectPermitMutationResult = Apollo.MutationResult<EditProjectPermitMutation>;
export type EditProjectPermitMutationOptions = Apollo.BaseMutationOptions<EditProjectPermitMutation, EditProjectPermitMutationVariables>;
export const DeleteProjectPermitDocument = gql`
    mutation deleteProjectPermit($id: String!) {
  deleteProjectPermit(id: $id)
}
    `;
export type DeleteProjectPermitMutationFn = Apollo.MutationFunction<DeleteProjectPermitMutation, DeleteProjectPermitMutationVariables>;

/**
 * __useDeleteProjectPermitMutation__
 *
 * To run a mutation, you first call `useDeleteProjectPermitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectPermitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectPermitMutation, { data, loading, error }] = useDeleteProjectPermitMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProjectPermitMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectPermitMutation, DeleteProjectPermitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectPermitMutation, DeleteProjectPermitMutationVariables>(DeleteProjectPermitDocument, options);
      }
export type DeleteProjectPermitMutationHookResult = ReturnType<typeof useDeleteProjectPermitMutation>;
export type DeleteProjectPermitMutationResult = Apollo.MutationResult<DeleteProjectPermitMutation>;
export type DeleteProjectPermitMutationOptions = Apollo.BaseMutationOptions<DeleteProjectPermitMutation, DeleteProjectPermitMutationVariables>;
export const GetProjectPermitTypeDocument = gql`
    query getProjectPermitType {
  getProjectPermitType
}
    `;

/**
 * __useGetProjectPermitTypeQuery__
 *
 * To run a query within a React component, call `useGetProjectPermitTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectPermitTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectPermitTypeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProjectPermitTypeQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectPermitTypeQuery, GetProjectPermitTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectPermitTypeQuery, GetProjectPermitTypeQueryVariables>(GetProjectPermitTypeDocument, options);
      }
export function useGetProjectPermitTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectPermitTypeQuery, GetProjectPermitTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectPermitTypeQuery, GetProjectPermitTypeQueryVariables>(GetProjectPermitTypeDocument, options);
        }
export type GetProjectPermitTypeQueryHookResult = ReturnType<typeof useGetProjectPermitTypeQuery>;
export type GetProjectPermitTypeLazyQueryHookResult = ReturnType<typeof useGetProjectPermitTypeLazyQuery>;
export type GetProjectPermitTypeQueryResult = Apollo.QueryResult<GetProjectPermitTypeQuery, GetProjectPermitTypeQueryVariables>;
export const GetAllProjectDocument = gql`
    query getAllProject {
  getAllProject {
    id
    name
    holdingCompanyId
    developmentCompanyId
    townshipName
    desc
    completionDate
    launchDate
    state
    city
    minPrice
    maxPrice
    tenure
    currency
    uom
    landType
    projectCode
    firstGalleryImage {
      url
    }
    holdingCompany {
      name
      id
    }
    developmentCompany {
      name
      id
    }
  }
}
    `;

/**
 * __useGetAllProjectQuery__
 *
 * To run a query within a React component, call `useGetAllProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllProjectQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllProjectQuery(baseOptions?: Apollo.QueryHookOptions<GetAllProjectQuery, GetAllProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllProjectQuery, GetAllProjectQueryVariables>(GetAllProjectDocument, options);
      }
export function useGetAllProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllProjectQuery, GetAllProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllProjectQuery, GetAllProjectQueryVariables>(GetAllProjectDocument, options);
        }
export type GetAllProjectQueryHookResult = ReturnType<typeof useGetAllProjectQuery>;
export type GetAllProjectLazyQueryHookResult = ReturnType<typeof useGetAllProjectLazyQuery>;
export type GetAllProjectQueryResult = Apollo.QueryResult<GetAllProjectQuery, GetAllProjectQueryVariables>;
export const ProjectDetailDocument = gql`
    query projectDetail($id: String!) {
  projectDetail(id: $id) {
    name
    projectCode
    developmentCompanyId
    desc
    holdingCompany {
      id
      name
    }
    developmentCompany {
      id
      name
    }
    townshipName
    landType
    projectType {
      id
      name
    }
    tenure
    state
    city
    minPrice
    maxPrice
    launchDate
    completionDate
    totalReminderEmailTemplate
    totalReminderLetterTemplate
    projectExt {
      id
      bankAccountId
      bankProfileId
      plotNo
      companyBankProfile {
        id
        name
        bankAccount {
          id
          code
        }
      }
      companyBankAccount {
        id
        code
        accountNo
      }
    }
  }
}
    `;

/**
 * __useProjectDetailQuery__
 *
 * To run a query within a React component, call `useProjectDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProjectDetailQuery(baseOptions: Apollo.QueryHookOptions<ProjectDetailQuery, ProjectDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectDetailQuery, ProjectDetailQueryVariables>(ProjectDetailDocument, options);
      }
export function useProjectDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectDetailQuery, ProjectDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectDetailQuery, ProjectDetailQueryVariables>(ProjectDetailDocument, options);
        }
export type ProjectDetailQueryHookResult = ReturnType<typeof useProjectDetailQuery>;
export type ProjectDetailLazyQueryHookResult = ReturnType<typeof useProjectDetailLazyQuery>;
export type ProjectDetailQueryResult = Apollo.QueryResult<ProjectDetailQuery, ProjectDetailQueryVariables>;
export const AddProjectDocument = gql`
    mutation addProject($input: AdminProjectInput!) {
  addProject(input: $input)
}
    `;
export type AddProjectMutationFn = Apollo.MutationFunction<AddProjectMutation, AddProjectMutationVariables>;

/**
 * __useAddProjectMutation__
 *
 * To run a mutation, you first call `useAddProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProjectMutation, { data, loading, error }] = useAddProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddProjectMutation(baseOptions?: Apollo.MutationHookOptions<AddProjectMutation, AddProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProjectMutation, AddProjectMutationVariables>(AddProjectDocument, options);
      }
export type AddProjectMutationHookResult = ReturnType<typeof useAddProjectMutation>;
export type AddProjectMutationResult = Apollo.MutationResult<AddProjectMutation>;
export type AddProjectMutationOptions = Apollo.BaseMutationOptions<AddProjectMutation, AddProjectMutationVariables>;
export const EditProjectDocument = gql`
    mutation editProject($input: AdminProjectInput!) {
  editProject(input: $input)
}
    `;
export type EditProjectMutationFn = Apollo.MutationFunction<EditProjectMutation, EditProjectMutationVariables>;

/**
 * __useEditProjectMutation__
 *
 * To run a mutation, you first call `useEditProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editProjectMutation, { data, loading, error }] = useEditProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditProjectMutation(baseOptions?: Apollo.MutationHookOptions<EditProjectMutation, EditProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditProjectMutation, EditProjectMutationVariables>(EditProjectDocument, options);
      }
export type EditProjectMutationHookResult = ReturnType<typeof useEditProjectMutation>;
export type EditProjectMutationResult = Apollo.MutationResult<EditProjectMutation>;
export type EditProjectMutationOptions = Apollo.BaseMutationOptions<EditProjectMutation, EditProjectMutationVariables>;
export const GetProjectDetailByIdDocument = gql`
    query getProjectDetailById($id: String!) {
  getProjectDetailById(id: $id) {
    id
    projectName
    projectCode
    description
    holdingCompanyId
    holdingCompanyName
    developmentCompanyId
    developmentCompanyName
    townshipId
    townshipName
    projectTypeId
    projectType
    landType
    tenure
    uom
    currency
    country
    state
    city
    minPrice
    maxPrice
    launchDate
    completionDate
    plotNo
    bankId
    bankCode
    bankName
    firstGalleryImage {
      url
    }
    bankAccounts {
      bankAccountId
      bankProfileId
      bankAccountCode
      bankAccountNo
      bankCurrency
      bankProfileName
    }
  }
}
    `;

/**
 * __useGetProjectDetailByIdQuery__
 *
 * To run a query within a React component, call `useGetProjectDetailByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectDetailByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectDetailByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectDetailByIdQuery(baseOptions: Apollo.QueryHookOptions<GetProjectDetailByIdQuery, GetProjectDetailByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectDetailByIdQuery, GetProjectDetailByIdQueryVariables>(GetProjectDetailByIdDocument, options);
      }
export function useGetProjectDetailByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectDetailByIdQuery, GetProjectDetailByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectDetailByIdQuery, GetProjectDetailByIdQueryVariables>(GetProjectDetailByIdDocument, options);
        }
export type GetProjectDetailByIdQueryHookResult = ReturnType<typeof useGetProjectDetailByIdQuery>;
export type GetProjectDetailByIdLazyQueryHookResult = ReturnType<typeof useGetProjectDetailByIdLazyQuery>;
export type GetProjectDetailByIdQueryResult = Apollo.QueryResult<GetProjectDetailByIdQuery, GetProjectDetailByIdQueryVariables>;
export const GetBankProfileWithAccountDocument = gql`
    query getBankProfileWithAccount($companyId: String!) {
  getBankProfileWithAccount(companyId: $companyId) {
    bankAccountId
    bankProfileId
    bankAccountCode
    bankAccountNo
    bankCurrency
    bankProfileName
  }
}
    `;

/**
 * __useGetBankProfileWithAccountQuery__
 *
 * To run a query within a React component, call `useGetBankProfileWithAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBankProfileWithAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBankProfileWithAccountQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetBankProfileWithAccountQuery(baseOptions: Apollo.QueryHookOptions<GetBankProfileWithAccountQuery, GetBankProfileWithAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBankProfileWithAccountQuery, GetBankProfileWithAccountQueryVariables>(GetBankProfileWithAccountDocument, options);
      }
export function useGetBankProfileWithAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBankProfileWithAccountQuery, GetBankProfileWithAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBankProfileWithAccountQuery, GetBankProfileWithAccountQueryVariables>(GetBankProfileWithAccountDocument, options);
        }
export type GetBankProfileWithAccountQueryHookResult = ReturnType<typeof useGetBankProfileWithAccountQuery>;
export type GetBankProfileWithAccountLazyQueryHookResult = ReturnType<typeof useGetBankProfileWithAccountLazyQuery>;
export type GetBankProfileWithAccountQueryResult = Apollo.QueryResult<GetBankProfileWithAccountQuery, GetBankProfileWithAccountQueryVariables>;
export const GetAvailableBankProfileWithAccountDocument = gql`
    query getAvailableBankProfileWithAccount($companyId: String!) {
  getAvailableBankProfileWithAccount(companyId: $companyId) {
    bankAccountId
    bankProfileId
    bankAccountCode
    bankAccountNo
    bankCurrency
    bankProfileName
  }
}
    `;

/**
 * __useGetAvailableBankProfileWithAccountQuery__
 *
 * To run a query within a React component, call `useGetAvailableBankProfileWithAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableBankProfileWithAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableBankProfileWithAccountQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetAvailableBankProfileWithAccountQuery(baseOptions: Apollo.QueryHookOptions<GetAvailableBankProfileWithAccountQuery, GetAvailableBankProfileWithAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableBankProfileWithAccountQuery, GetAvailableBankProfileWithAccountQueryVariables>(GetAvailableBankProfileWithAccountDocument, options);
      }
export function useGetAvailableBankProfileWithAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableBankProfileWithAccountQuery, GetAvailableBankProfileWithAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableBankProfileWithAccountQuery, GetAvailableBankProfileWithAccountQueryVariables>(GetAvailableBankProfileWithAccountDocument, options);
        }
export type GetAvailableBankProfileWithAccountQueryHookResult = ReturnType<typeof useGetAvailableBankProfileWithAccountQuery>;
export type GetAvailableBankProfileWithAccountLazyQueryHookResult = ReturnType<typeof useGetAvailableBankProfileWithAccountLazyQuery>;
export type GetAvailableBankProfileWithAccountQueryResult = Apollo.QueryResult<GetAvailableBankProfileWithAccountQuery, GetAvailableBankProfileWithAccountQueryVariables>;
export const UserAccessEntityDocument = gql`
    mutation UserAccessEntity($projectId: String!) {
  updateUserLatestEntity(project_id: $projectId)
}
    `;
export type UserAccessEntityMutationFn = Apollo.MutationFunction<UserAccessEntityMutation, UserAccessEntityMutationVariables>;

/**
 * __useUserAccessEntityMutation__
 *
 * To run a mutation, you first call `useUserAccessEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserAccessEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userAccessEntityMutation, { data, loading, error }] = useUserAccessEntityMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useUserAccessEntityMutation(baseOptions?: Apollo.MutationHookOptions<UserAccessEntityMutation, UserAccessEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserAccessEntityMutation, UserAccessEntityMutationVariables>(UserAccessEntityDocument, options);
      }
export type UserAccessEntityMutationHookResult = ReturnType<typeof useUserAccessEntityMutation>;
export type UserAccessEntityMutationResult = Apollo.MutationResult<UserAccessEntityMutation>;
export type UserAccessEntityMutationOptions = Apollo.BaseMutationOptions<UserAccessEntityMutation, UserAccessEntityMutationVariables>;
export const GetProjectClusterListingDocument = gql`
    query getProjectClusterListing($projectId: String!) {
  getProjectClusterListing(projectId: $projectId) {
    id
    projectId
    name
    desc
    accountId
  }
}
    `;

/**
 * __useGetProjectClusterListingQuery__
 *
 * To run a query within a React component, call `useGetProjectClusterListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectClusterListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectClusterListingQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetProjectClusterListingQuery(baseOptions: Apollo.QueryHookOptions<GetProjectClusterListingQuery, GetProjectClusterListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectClusterListingQuery, GetProjectClusterListingQueryVariables>(GetProjectClusterListingDocument, options);
      }
export function useGetProjectClusterListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectClusterListingQuery, GetProjectClusterListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectClusterListingQuery, GetProjectClusterListingQueryVariables>(GetProjectClusterListingDocument, options);
        }
export type GetProjectClusterListingQueryHookResult = ReturnType<typeof useGetProjectClusterListingQuery>;
export type GetProjectClusterListingLazyQueryHookResult = ReturnType<typeof useGetProjectClusterListingLazyQuery>;
export type GetProjectClusterListingQueryResult = Apollo.QueryResult<GetProjectClusterListingQuery, GetProjectClusterListingQueryVariables>;
export const ProjectClusterNameExistDocument = gql`
    query projectClusterNameExist($name: String!, $clusterId: String!, $developmentCompany: String!) {
  projectClusterNameExist(developmentCompany: $developmentCompany, clusterId: $clusterId, name: $name)
}
    `;

/**
 * __useProjectClusterNameExistQuery__
 *
 * To run a query within a React component, call `useProjectClusterNameExistQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectClusterNameExistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectClusterNameExistQuery({
 *   variables: {
 *      name: // value for 'name'
 *      clusterId: // value for 'clusterId'
 *      developmentCompany: // value for 'developmentCompany'
 *   },
 * });
 */
export function useProjectClusterNameExistQuery(baseOptions: Apollo.QueryHookOptions<ProjectClusterNameExistQuery, ProjectClusterNameExistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectClusterNameExistQuery, ProjectClusterNameExistQueryVariables>(ProjectClusterNameExistDocument, options);
      }
export function useProjectClusterNameExistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectClusterNameExistQuery, ProjectClusterNameExistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectClusterNameExistQuery, ProjectClusterNameExistQueryVariables>(ProjectClusterNameExistDocument, options);
        }
export type ProjectClusterNameExistQueryHookResult = ReturnType<typeof useProjectClusterNameExistQuery>;
export type ProjectClusterNameExistLazyQueryHookResult = ReturnType<typeof useProjectClusterNameExistLazyQuery>;
export type ProjectClusterNameExistQueryResult = Apollo.QueryResult<ProjectClusterNameExistQuery, ProjectClusterNameExistQueryVariables>;
export const AddProjectClusterDocument = gql`
    mutation addProjectCluster($input: addProjectClusterInput!) {
  addProjectCluster(input: $input)
}
    `;
export type AddProjectClusterMutationFn = Apollo.MutationFunction<AddProjectClusterMutation, AddProjectClusterMutationVariables>;

/**
 * __useAddProjectClusterMutation__
 *
 * To run a mutation, you first call `useAddProjectClusterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProjectClusterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProjectClusterMutation, { data, loading, error }] = useAddProjectClusterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddProjectClusterMutation(baseOptions?: Apollo.MutationHookOptions<AddProjectClusterMutation, AddProjectClusterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProjectClusterMutation, AddProjectClusterMutationVariables>(AddProjectClusterDocument, options);
      }
export type AddProjectClusterMutationHookResult = ReturnType<typeof useAddProjectClusterMutation>;
export type AddProjectClusterMutationResult = Apollo.MutationResult<AddProjectClusterMutation>;
export type AddProjectClusterMutationOptions = Apollo.BaseMutationOptions<AddProjectClusterMutation, AddProjectClusterMutationVariables>;
export const EditProjectClusterDocument = gql`
    mutation editProjectCluster($input: editProjectClusterInput!) {
  editProjectCluster(input: $input)
}
    `;
export type EditProjectClusterMutationFn = Apollo.MutationFunction<EditProjectClusterMutation, EditProjectClusterMutationVariables>;

/**
 * __useEditProjectClusterMutation__
 *
 * To run a mutation, you first call `useEditProjectClusterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditProjectClusterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editProjectClusterMutation, { data, loading, error }] = useEditProjectClusterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditProjectClusterMutation(baseOptions?: Apollo.MutationHookOptions<EditProjectClusterMutation, EditProjectClusterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditProjectClusterMutation, EditProjectClusterMutationVariables>(EditProjectClusterDocument, options);
      }
export type EditProjectClusterMutationHookResult = ReturnType<typeof useEditProjectClusterMutation>;
export type EditProjectClusterMutationResult = Apollo.MutationResult<EditProjectClusterMutation>;
export type EditProjectClusterMutationOptions = Apollo.BaseMutationOptions<EditProjectClusterMutation, EditProjectClusterMutationVariables>;
export const DeleteProjectClusterDocument = gql`
    mutation deleteProjectCluster($id: String!) {
  deleteProjectCluster(id: $id)
}
    `;
export type DeleteProjectClusterMutationFn = Apollo.MutationFunction<DeleteProjectClusterMutation, DeleteProjectClusterMutationVariables>;

/**
 * __useDeleteProjectClusterMutation__
 *
 * To run a mutation, you first call `useDeleteProjectClusterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectClusterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectClusterMutation, { data, loading, error }] = useDeleteProjectClusterMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProjectClusterMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectClusterMutation, DeleteProjectClusterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectClusterMutation, DeleteProjectClusterMutationVariables>(DeleteProjectClusterDocument, options);
      }
export type DeleteProjectClusterMutationHookResult = ReturnType<typeof useDeleteProjectClusterMutation>;
export type DeleteProjectClusterMutationResult = Apollo.MutationResult<DeleteProjectClusterMutation>;
export type DeleteProjectClusterMutationOptions = Apollo.BaseMutationOptions<DeleteProjectClusterMutation, DeleteProjectClusterMutationVariables>;
export const GetProjectPolicyDocument = gql`
    query getProjectPolicy($projectId: String!) {
  getProjectPolicy(projectId: $projectId) {
    id
    projectId
    interestRate
    creditTerms
    roundingMode
    roundingPrecision
    unitSort
  }
}
    `;

/**
 * __useGetProjectPolicyQuery__
 *
 * To run a query within a React component, call `useGetProjectPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectPolicyQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetProjectPolicyQuery(baseOptions: Apollo.QueryHookOptions<GetProjectPolicyQuery, GetProjectPolicyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectPolicyQuery, GetProjectPolicyQueryVariables>(GetProjectPolicyDocument, options);
      }
export function useGetProjectPolicyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectPolicyQuery, GetProjectPolicyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectPolicyQuery, GetProjectPolicyQueryVariables>(GetProjectPolicyDocument, options);
        }
export type GetProjectPolicyQueryHookResult = ReturnType<typeof useGetProjectPolicyQuery>;
export type GetProjectPolicyLazyQueryHookResult = ReturnType<typeof useGetProjectPolicyLazyQuery>;
export type GetProjectPolicyQueryResult = Apollo.QueryResult<GetProjectPolicyQuery, GetProjectPolicyQueryVariables>;
export const CreateProjectPolicyDocument = gql`
    mutation createProjectPolicy($input: AddProjectPolicyInput!) {
  createProjectPolicy(input: $input) {
    projectId
    interestRate
    creditTerms
    roundingMode
    roundingPrecision
  }
}
    `;
export type CreateProjectPolicyMutationFn = Apollo.MutationFunction<CreateProjectPolicyMutation, CreateProjectPolicyMutationVariables>;

/**
 * __useCreateProjectPolicyMutation__
 *
 * To run a mutation, you first call `useCreateProjectPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectPolicyMutation, { data, loading, error }] = useCreateProjectPolicyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProjectPolicyMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectPolicyMutation, CreateProjectPolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectPolicyMutation, CreateProjectPolicyMutationVariables>(CreateProjectPolicyDocument, options);
      }
export type CreateProjectPolicyMutationHookResult = ReturnType<typeof useCreateProjectPolicyMutation>;
export type CreateProjectPolicyMutationResult = Apollo.MutationResult<CreateProjectPolicyMutation>;
export type CreateProjectPolicyMutationOptions = Apollo.BaseMutationOptions<CreateProjectPolicyMutation, CreateProjectPolicyMutationVariables>;
export const UpdateProjectPolicyDocument = gql`
    mutation updateProjectPolicy($input: EditProjectPolicyInput!) {
  updateProjectPolicy(input: $input) {
    id
    projectId
    interestRate
    creditTerms
    roundingMode
    roundingPrecision
  }
}
    `;
export type UpdateProjectPolicyMutationFn = Apollo.MutationFunction<UpdateProjectPolicyMutation, UpdateProjectPolicyMutationVariables>;

/**
 * __useUpdateProjectPolicyMutation__
 *
 * To run a mutation, you first call `useUpdateProjectPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectPolicyMutation, { data, loading, error }] = useUpdateProjectPolicyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProjectPolicyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectPolicyMutation, UpdateProjectPolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectPolicyMutation, UpdateProjectPolicyMutationVariables>(UpdateProjectPolicyDocument, options);
      }
export type UpdateProjectPolicyMutationHookResult = ReturnType<typeof useUpdateProjectPolicyMutation>;
export type UpdateProjectPolicyMutationResult = Apollo.MutationResult<UpdateProjectPolicyMutation>;
export type UpdateProjectPolicyMutationOptions = Apollo.BaseMutationOptions<UpdateProjectPolicyMutation, UpdateProjectPolicyMutationVariables>;
export const AddProjectPolicyDocument = gql`
    mutation addProjectPolicy($projectPolicyInput: ProjectPolicyInput!, $latePaymentInput: LateInterestInput!) {
  addProjectPolicy(projectPolicyInput: $projectPolicyInput, latePaymentInput: $latePaymentInput)
}
    `;
export type AddProjectPolicyMutationFn = Apollo.MutationFunction<AddProjectPolicyMutation, AddProjectPolicyMutationVariables>;

/**
 * __useAddProjectPolicyMutation__
 *
 * To run a mutation, you first call `useAddProjectPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProjectPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProjectPolicyMutation, { data, loading, error }] = useAddProjectPolicyMutation({
 *   variables: {
 *      projectPolicyInput: // value for 'projectPolicyInput'
 *      latePaymentInput: // value for 'latePaymentInput'
 *   },
 * });
 */
export function useAddProjectPolicyMutation(baseOptions?: Apollo.MutationHookOptions<AddProjectPolicyMutation, AddProjectPolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProjectPolicyMutation, AddProjectPolicyMutationVariables>(AddProjectPolicyDocument, options);
      }
export type AddProjectPolicyMutationHookResult = ReturnType<typeof useAddProjectPolicyMutation>;
export type AddProjectPolicyMutationResult = Apollo.MutationResult<AddProjectPolicyMutation>;
export type AddProjectPolicyMutationOptions = Apollo.BaseMutationOptions<AddProjectPolicyMutation, AddProjectPolicyMutationVariables>;
export const GetUsersRoleProjectDocument = gql`
    query getUsersRoleProject($projectId: String!, $roleId: String!) {
  getUsersRoleProject(projectId: $projectId, roleId: $roleId)
}
    `;

/**
 * __useGetUsersRoleProjectQuery__
 *
 * To run a query within a React component, call `useGetUsersRoleProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersRoleProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersRoleProjectQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useGetUsersRoleProjectQuery(baseOptions: Apollo.QueryHookOptions<GetUsersRoleProjectQuery, GetUsersRoleProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersRoleProjectQuery, GetUsersRoleProjectQueryVariables>(GetUsersRoleProjectDocument, options);
      }
export function useGetUsersRoleProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersRoleProjectQuery, GetUsersRoleProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersRoleProjectQuery, GetUsersRoleProjectQueryVariables>(GetUsersRoleProjectDocument, options);
        }
export type GetUsersRoleProjectQueryHookResult = ReturnType<typeof useGetUsersRoleProjectQuery>;
export type GetUsersRoleProjectLazyQueryHookResult = ReturnType<typeof useGetUsersRoleProjectLazyQuery>;
export type GetUsersRoleProjectQueryResult = Apollo.QueryResult<GetUsersRoleProjectQuery, GetUsersRoleProjectQueryVariables>;
export const GetProjectUserRoleDocument = gql`
    query getProjectUserRole($projectId: String!) {
  getProjectUserRole(projectId: $projectId) {
    ID
    name
    roleIds
  }
}
    `;

/**
 * __useGetProjectUserRoleQuery__
 *
 * To run a query within a React component, call `useGetProjectUserRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectUserRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectUserRoleQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetProjectUserRoleQuery(baseOptions: Apollo.QueryHookOptions<GetProjectUserRoleQuery, GetProjectUserRoleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectUserRoleQuery, GetProjectUserRoleQueryVariables>(GetProjectUserRoleDocument, options);
      }
export function useGetProjectUserRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectUserRoleQuery, GetProjectUserRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectUserRoleQuery, GetProjectUserRoleQueryVariables>(GetProjectUserRoleDocument, options);
        }
export type GetProjectUserRoleQueryHookResult = ReturnType<typeof useGetProjectUserRoleQuery>;
export type GetProjectUserRoleLazyQueryHookResult = ReturnType<typeof useGetProjectUserRoleLazyQuery>;
export type GetProjectUserRoleQueryResult = Apollo.QueryResult<GetProjectUserRoleQuery, GetProjectUserRoleQueryVariables>;
export const CreateListEntityRoleUserDocument = gql`
    mutation createListEntityRoleUser($roleUserIDs: [UserRoleAssignmentInput!]!, $projectId: String!) {
  CreateListEntityRoleUser(projectId: $projectId, roleUserIDs: $roleUserIDs)
}
    `;
export type CreateListEntityRoleUserMutationFn = Apollo.MutationFunction<CreateListEntityRoleUserMutation, CreateListEntityRoleUserMutationVariables>;

/**
 * __useCreateListEntityRoleUserMutation__
 *
 * To run a mutation, you first call `useCreateListEntityRoleUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateListEntityRoleUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createListEntityRoleUserMutation, { data, loading, error }] = useCreateListEntityRoleUserMutation({
 *   variables: {
 *      roleUserIDs: // value for 'roleUserIDs'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useCreateListEntityRoleUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateListEntityRoleUserMutation, CreateListEntityRoleUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateListEntityRoleUserMutation, CreateListEntityRoleUserMutationVariables>(CreateListEntityRoleUserDocument, options);
      }
export type CreateListEntityRoleUserMutationHookResult = ReturnType<typeof useCreateListEntityRoleUserMutation>;
export type CreateListEntityRoleUserMutationResult = Apollo.MutationResult<CreateListEntityRoleUserMutation>;
export type CreateListEntityRoleUserMutationOptions = Apollo.BaseMutationOptions<CreateListEntityRoleUserMutation, CreateListEntityRoleUserMutationVariables>;
export const CreateProjectRoleUserDocument = gql`
    mutation CreateProjectRoleUser($input: ProjectRoleInput!) {
  CreateProjectRoleUser(input: $input)
}
    `;
export type CreateProjectRoleUserMutationFn = Apollo.MutationFunction<CreateProjectRoleUserMutation, CreateProjectRoleUserMutationVariables>;

/**
 * __useCreateProjectRoleUserMutation__
 *
 * To run a mutation, you first call `useCreateProjectRoleUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectRoleUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectRoleUserMutation, { data, loading, error }] = useCreateProjectRoleUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProjectRoleUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectRoleUserMutation, CreateProjectRoleUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectRoleUserMutation, CreateProjectRoleUserMutationVariables>(CreateProjectRoleUserDocument, options);
      }
export type CreateProjectRoleUserMutationHookResult = ReturnType<typeof useCreateProjectRoleUserMutation>;
export type CreateProjectRoleUserMutationResult = Apollo.MutationResult<CreateProjectRoleUserMutation>;
export type CreateProjectRoleUserMutationOptions = Apollo.BaseMutationOptions<CreateProjectRoleUserMutation, CreateProjectRoleUserMutationVariables>;
export const GetProjectSalesPolicyByProjectIdDocument = gql`
    query getProjectSalesPolicyByProjectId($projectId: String!) {
  getProjectSalesPolicyByProjectId(projectId: $projectId) {
    id
    npvBasicRate
    npvRate
    roundingPrecision
    roundingMode
    interestBasicRate
    interestRate
    collectLandDeposit
    ujpMinimumDepositAmount
    ujpDepositAmount
    generateOverdueDebtorEvery
    generateOverdueDebtorTime
    taxSchemeId
    projectSalesPolicy {
      id
      landAreaFrom
      landAreaTo
      depositAmount
    }
  }
}
    `;

/**
 * __useGetProjectSalesPolicyByProjectIdQuery__
 *
 * To run a query within a React component, call `useGetProjectSalesPolicyByProjectIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectSalesPolicyByProjectIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectSalesPolicyByProjectIdQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetProjectSalesPolicyByProjectIdQuery(baseOptions: Apollo.QueryHookOptions<GetProjectSalesPolicyByProjectIdQuery, GetProjectSalesPolicyByProjectIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectSalesPolicyByProjectIdQuery, GetProjectSalesPolicyByProjectIdQueryVariables>(GetProjectSalesPolicyByProjectIdDocument, options);
      }
export function useGetProjectSalesPolicyByProjectIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectSalesPolicyByProjectIdQuery, GetProjectSalesPolicyByProjectIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectSalesPolicyByProjectIdQuery, GetProjectSalesPolicyByProjectIdQueryVariables>(GetProjectSalesPolicyByProjectIdDocument, options);
        }
export type GetProjectSalesPolicyByProjectIdQueryHookResult = ReturnType<typeof useGetProjectSalesPolicyByProjectIdQuery>;
export type GetProjectSalesPolicyByProjectIdLazyQueryHookResult = ReturnType<typeof useGetProjectSalesPolicyByProjectIdLazyQuery>;
export type GetProjectSalesPolicyByProjectIdQueryResult = Apollo.QueryResult<GetProjectSalesPolicyByProjectIdQuery, GetProjectSalesPolicyByProjectIdQueryVariables>;
export const GetTaxSchemeLateInterestDocument = gql`
    query getTaxSchemeLateInterest {
  getTaxSchemeLateInterest {
    taxSchemeId
    taxSchemeName
  }
}
    `;

/**
 * __useGetTaxSchemeLateInterestQuery__
 *
 * To run a query within a React component, call `useGetTaxSchemeLateInterestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaxSchemeLateInterestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaxSchemeLateInterestQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTaxSchemeLateInterestQuery(baseOptions?: Apollo.QueryHookOptions<GetTaxSchemeLateInterestQuery, GetTaxSchemeLateInterestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaxSchemeLateInterestQuery, GetTaxSchemeLateInterestQueryVariables>(GetTaxSchemeLateInterestDocument, options);
      }
export function useGetTaxSchemeLateInterestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaxSchemeLateInterestQuery, GetTaxSchemeLateInterestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaxSchemeLateInterestQuery, GetTaxSchemeLateInterestQueryVariables>(GetTaxSchemeLateInterestDocument, options);
        }
export type GetTaxSchemeLateInterestQueryHookResult = ReturnType<typeof useGetTaxSchemeLateInterestQuery>;
export type GetTaxSchemeLateInterestLazyQueryHookResult = ReturnType<typeof useGetTaxSchemeLateInterestLazyQuery>;
export type GetTaxSchemeLateInterestQueryResult = Apollo.QueryResult<GetTaxSchemeLateInterestQuery, GetTaxSchemeLateInterestQueryVariables>;
export const AddProjectSalesAndDetailsPolicyDocument = gql`
    mutation addProjectSalesAndDetailsPolicy($input: AddProjectSalesPolicyInput!, $projectId: String!) {
  addProjectSalesAndDetailsPolicy(input: $input, projectId: $projectId)
}
    `;
export type AddProjectSalesAndDetailsPolicyMutationFn = Apollo.MutationFunction<AddProjectSalesAndDetailsPolicyMutation, AddProjectSalesAndDetailsPolicyMutationVariables>;

/**
 * __useAddProjectSalesAndDetailsPolicyMutation__
 *
 * To run a mutation, you first call `useAddProjectSalesAndDetailsPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProjectSalesAndDetailsPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProjectSalesAndDetailsPolicyMutation, { data, loading, error }] = useAddProjectSalesAndDetailsPolicyMutation({
 *   variables: {
 *      input: // value for 'input'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useAddProjectSalesAndDetailsPolicyMutation(baseOptions?: Apollo.MutationHookOptions<AddProjectSalesAndDetailsPolicyMutation, AddProjectSalesAndDetailsPolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProjectSalesAndDetailsPolicyMutation, AddProjectSalesAndDetailsPolicyMutationVariables>(AddProjectSalesAndDetailsPolicyDocument, options);
      }
export type AddProjectSalesAndDetailsPolicyMutationHookResult = ReturnType<typeof useAddProjectSalesAndDetailsPolicyMutation>;
export type AddProjectSalesAndDetailsPolicyMutationResult = Apollo.MutationResult<AddProjectSalesAndDetailsPolicyMutation>;
export type AddProjectSalesAndDetailsPolicyMutationOptions = Apollo.BaseMutationOptions<AddProjectSalesAndDetailsPolicyMutation, AddProjectSalesAndDetailsPolicyMutationVariables>;
export const EditProjectSalesPolicyAndDetailsDocument = gql`
    mutation editProjectSalesPolicyAndDetails($input: EditProjectSalesPolicyInput!, $projectId: String!, $projectSalesPolicyId: String!) {
  editProjectSalesPolicyAndDetails(input: $input, projectId: $projectId, projectSalesPolicyId: $projectSalesPolicyId)
}
    `;
export type EditProjectSalesPolicyAndDetailsMutationFn = Apollo.MutationFunction<EditProjectSalesPolicyAndDetailsMutation, EditProjectSalesPolicyAndDetailsMutationVariables>;

/**
 * __useEditProjectSalesPolicyAndDetailsMutation__
 *
 * To run a mutation, you first call `useEditProjectSalesPolicyAndDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditProjectSalesPolicyAndDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editProjectSalesPolicyAndDetailsMutation, { data, loading, error }] = useEditProjectSalesPolicyAndDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *      projectId: // value for 'projectId'
 *      projectSalesPolicyId: // value for 'projectSalesPolicyId'
 *   },
 * });
 */
export function useEditProjectSalesPolicyAndDetailsMutation(baseOptions?: Apollo.MutationHookOptions<EditProjectSalesPolicyAndDetailsMutation, EditProjectSalesPolicyAndDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditProjectSalesPolicyAndDetailsMutation, EditProjectSalesPolicyAndDetailsMutationVariables>(EditProjectSalesPolicyAndDetailsDocument, options);
      }
export type EditProjectSalesPolicyAndDetailsMutationHookResult = ReturnType<typeof useEditProjectSalesPolicyAndDetailsMutation>;
export type EditProjectSalesPolicyAndDetailsMutationResult = Apollo.MutationResult<EditProjectSalesPolicyAndDetailsMutation>;
export type EditProjectSalesPolicyAndDetailsMutationOptions = Apollo.BaseMutationOptions<EditProjectSalesPolicyAndDetailsMutation, EditProjectSalesPolicyAndDetailsMutationVariables>;
export const GetProjectSalesPolicyEnumOutputDocument = gql`
    query getProjectSalesPolicyEnumOutput {
  getProjectSalesPolicyEnumOutput {
    npvBasicRate {
      id
      name
    }
    roundingMode {
      id
      name
    }
    roundingPrecision {
      id
      name
    }
    interestBasicRate {
      id
      name
    }
    overdueDay {
      id
      name
    }
  }
}
    `;

/**
 * __useGetProjectSalesPolicyEnumOutputQuery__
 *
 * To run a query within a React component, call `useGetProjectSalesPolicyEnumOutputQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectSalesPolicyEnumOutputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectSalesPolicyEnumOutputQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProjectSalesPolicyEnumOutputQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectSalesPolicyEnumOutputQuery, GetProjectSalesPolicyEnumOutputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectSalesPolicyEnumOutputQuery, GetProjectSalesPolicyEnumOutputQueryVariables>(GetProjectSalesPolicyEnumOutputDocument, options);
      }
export function useGetProjectSalesPolicyEnumOutputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectSalesPolicyEnumOutputQuery, GetProjectSalesPolicyEnumOutputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectSalesPolicyEnumOutputQuery, GetProjectSalesPolicyEnumOutputQueryVariables>(GetProjectSalesPolicyEnumOutputDocument, options);
        }
export type GetProjectSalesPolicyEnumOutputQueryHookResult = ReturnType<typeof useGetProjectSalesPolicyEnumOutputQuery>;
export type GetProjectSalesPolicyEnumOutputLazyQueryHookResult = ReturnType<typeof useGetProjectSalesPolicyEnumOutputLazyQuery>;
export type GetProjectSalesPolicyEnumOutputQueryResult = Apollo.QueryResult<GetProjectSalesPolicyEnumOutputQuery, GetProjectSalesPolicyEnumOutputQueryVariables>;
export const GetProjectSettingSummaryDocument = gql`
    query getProjectSettingSummary($projectId: String!) {
  projectLastUpdate(projectId: $projectId)
  roleAuthLastUpdate(projectId: $projectId)
  projectSalesPolicyLastUpdate(projectId: $projectId)
  unitCount(projectId: $projectId)
  carParkCount(projectId: $projectId)
  salesPackagesCount(projectId: $projectId)
  assignedDiscountCount(projectId: $projectId)
  projectCampaignCount(projectId: $projectId)
  panelEndFinCount(projectId: $projectId)
  totalFinancialLimit(projectId: $projectId)
  panelSolicitorCount(projectId: $projectId)
  projectLetterLastUpdate(projectId: $projectId)
  stampDutyIntegrationLastUpdate(projectId: $projectId)
  salesOfficeLastUpdate(projectId: $projectId)
  constructionInfoLastUpdate(projectId: $projectId)
  fireInsuranceLastUpdate(projectId: $projectId)
  businessPermitLastUpdate(projectId: $projectId)
  projectPaymentPlanLastUpdate(projectId: $projectId)
  projectPaymentPlanCount(projectId: $projectId)
  promotionalPackagesLastUpdate(projectId: $projectId)
  teamAssignmentLastUpdate(projectId: $projectId)
  projectReminderSettingLastUpdate(projectId: $projectId)
  unitStatutoryDocumentCount(projectId: $projectId)
  priceAdjustmentSummary(projectId: $projectId) {
    lastUpdateDate
    count
  }
  notaryAssignmentLastUpdate(projectId: $projectId)
}
    `;

/**
 * __useGetProjectSettingSummaryQuery__
 *
 * To run a query within a React component, call `useGetProjectSettingSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectSettingSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectSettingSummaryQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetProjectSettingSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetProjectSettingSummaryQuery, GetProjectSettingSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectSettingSummaryQuery, GetProjectSettingSummaryQueryVariables>(GetProjectSettingSummaryDocument, options);
      }
export function useGetProjectSettingSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectSettingSummaryQuery, GetProjectSettingSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectSettingSummaryQuery, GetProjectSettingSummaryQueryVariables>(GetProjectSettingSummaryDocument, options);
        }
export type GetProjectSettingSummaryQueryHookResult = ReturnType<typeof useGetProjectSettingSummaryQuery>;
export type GetProjectSettingSummaryLazyQueryHookResult = ReturnType<typeof useGetProjectSettingSummaryLazyQuery>;
export type GetProjectSettingSummaryQueryResult = Apollo.QueryResult<GetProjectSettingSummaryQuery, GetProjectSettingSummaryQueryVariables>;
export const GetPromotionalItemListingDocument = gql`
    query getPromotionalItemListing($projectId: String!) {
  getPromotionalItemListing(projectId: $projectId) {
    id
    name
    cost
    description
  }
}
    `;

/**
 * __useGetPromotionalItemListingQuery__
 *
 * To run a query within a React component, call `useGetPromotionalItemListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPromotionalItemListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPromotionalItemListingQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetPromotionalItemListingQuery(baseOptions: Apollo.QueryHookOptions<GetPromotionalItemListingQuery, GetPromotionalItemListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPromotionalItemListingQuery, GetPromotionalItemListingQueryVariables>(GetPromotionalItemListingDocument, options);
      }
export function useGetPromotionalItemListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPromotionalItemListingQuery, GetPromotionalItemListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPromotionalItemListingQuery, GetPromotionalItemListingQueryVariables>(GetPromotionalItemListingDocument, options);
        }
export type GetPromotionalItemListingQueryHookResult = ReturnType<typeof useGetPromotionalItemListingQuery>;
export type GetPromotionalItemListingLazyQueryHookResult = ReturnType<typeof useGetPromotionalItemListingLazyQuery>;
export type GetPromotionalItemListingQueryResult = Apollo.QueryResult<GetPromotionalItemListingQuery, GetPromotionalItemListingQueryVariables>;
export const AddPromotionalItemDocument = gql`
    mutation addPromotionalItem($input: AddPromotionalItemInput!) {
  addPromotionalItem(input: $input)
}
    `;
export type AddPromotionalItemMutationFn = Apollo.MutationFunction<AddPromotionalItemMutation, AddPromotionalItemMutationVariables>;

/**
 * __useAddPromotionalItemMutation__
 *
 * To run a mutation, you first call `useAddPromotionalItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPromotionalItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPromotionalItemMutation, { data, loading, error }] = useAddPromotionalItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPromotionalItemMutation(baseOptions?: Apollo.MutationHookOptions<AddPromotionalItemMutation, AddPromotionalItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPromotionalItemMutation, AddPromotionalItemMutationVariables>(AddPromotionalItemDocument, options);
      }
export type AddPromotionalItemMutationHookResult = ReturnType<typeof useAddPromotionalItemMutation>;
export type AddPromotionalItemMutationResult = Apollo.MutationResult<AddPromotionalItemMutation>;
export type AddPromotionalItemMutationOptions = Apollo.BaseMutationOptions<AddPromotionalItemMutation, AddPromotionalItemMutationVariables>;
export const EditPromotionalItemDocument = gql`
    mutation editPromotionalItem($input: EditPromotionalItemInput!) {
  editPromotionalItem(input: $input)
}
    `;
export type EditPromotionalItemMutationFn = Apollo.MutationFunction<EditPromotionalItemMutation, EditPromotionalItemMutationVariables>;

/**
 * __useEditPromotionalItemMutation__
 *
 * To run a mutation, you first call `useEditPromotionalItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPromotionalItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPromotionalItemMutation, { data, loading, error }] = useEditPromotionalItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditPromotionalItemMutation(baseOptions?: Apollo.MutationHookOptions<EditPromotionalItemMutation, EditPromotionalItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditPromotionalItemMutation, EditPromotionalItemMutationVariables>(EditPromotionalItemDocument, options);
      }
export type EditPromotionalItemMutationHookResult = ReturnType<typeof useEditPromotionalItemMutation>;
export type EditPromotionalItemMutationResult = Apollo.MutationResult<EditPromotionalItemMutation>;
export type EditPromotionalItemMutationOptions = Apollo.BaseMutationOptions<EditPromotionalItemMutation, EditPromotionalItemMutationVariables>;
export const DeletePromotionalItemDocument = gql`
    mutation deletePromotionalItem($projectId: String!, $promotionalItemId: String!) {
  deletePromotionalItem(projectId: $projectId, promotionalItemId: $promotionalItemId)
}
    `;
export type DeletePromotionalItemMutationFn = Apollo.MutationFunction<DeletePromotionalItemMutation, DeletePromotionalItemMutationVariables>;

/**
 * __useDeletePromotionalItemMutation__
 *
 * To run a mutation, you first call `useDeletePromotionalItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePromotionalItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePromotionalItemMutation, { data, loading, error }] = useDeletePromotionalItemMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      promotionalItemId: // value for 'promotionalItemId'
 *   },
 * });
 */
export function useDeletePromotionalItemMutation(baseOptions?: Apollo.MutationHookOptions<DeletePromotionalItemMutation, DeletePromotionalItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePromotionalItemMutation, DeletePromotionalItemMutationVariables>(DeletePromotionalItemDocument, options);
      }
export type DeletePromotionalItemMutationHookResult = ReturnType<typeof useDeletePromotionalItemMutation>;
export type DeletePromotionalItemMutationResult = Apollo.MutationResult<DeletePromotionalItemMutation>;
export type DeletePromotionalItemMutationOptions = Apollo.BaseMutationOptions<DeletePromotionalItemMutation, DeletePromotionalItemMutationVariables>;
export const GetPromotionalPackagesListingDocument = gql`
    query getPromotionalPackagesListing($projectId: String!) {
  getPromotionalPackagesListing(projectId: $projectId) {
    name
    promotionalPackageId
    costPrice
    promoPrice
    startDate
    endDate
  }
}
    `;

/**
 * __useGetPromotionalPackagesListingQuery__
 *
 * To run a query within a React component, call `useGetPromotionalPackagesListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPromotionalPackagesListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPromotionalPackagesListingQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetPromotionalPackagesListingQuery(baseOptions: Apollo.QueryHookOptions<GetPromotionalPackagesListingQuery, GetPromotionalPackagesListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPromotionalPackagesListingQuery, GetPromotionalPackagesListingQueryVariables>(GetPromotionalPackagesListingDocument, options);
      }
export function useGetPromotionalPackagesListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPromotionalPackagesListingQuery, GetPromotionalPackagesListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPromotionalPackagesListingQuery, GetPromotionalPackagesListingQueryVariables>(GetPromotionalPackagesListingDocument, options);
        }
export type GetPromotionalPackagesListingQueryHookResult = ReturnType<typeof useGetPromotionalPackagesListingQuery>;
export type GetPromotionalPackagesListingLazyQueryHookResult = ReturnType<typeof useGetPromotionalPackagesListingLazyQuery>;
export type GetPromotionalPackagesListingQueryResult = Apollo.QueryResult<GetPromotionalPackagesListingQuery, GetPromotionalPackagesListingQueryVariables>;
export const GetPromotionalPackagesItemDetailsListingDocument = gql`
    query getPromotionalPackagesItemDetailsListing($promotionalPackagesId: String!) {
  getPromotionalPackagesItemDetailsListing(promotionalPackagesId: $promotionalPackagesId) {
    id
    packageName
    startDate
    endDate
    itemName
    costPrice
    promoPrice
    itemDescription
    promotionalPackageId
    promotionalItemId
  }
}
    `;

/**
 * __useGetPromotionalPackagesItemDetailsListingQuery__
 *
 * To run a query within a React component, call `useGetPromotionalPackagesItemDetailsListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPromotionalPackagesItemDetailsListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPromotionalPackagesItemDetailsListingQuery({
 *   variables: {
 *      promotionalPackagesId: // value for 'promotionalPackagesId'
 *   },
 * });
 */
export function useGetPromotionalPackagesItemDetailsListingQuery(baseOptions: Apollo.QueryHookOptions<GetPromotionalPackagesItemDetailsListingQuery, GetPromotionalPackagesItemDetailsListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPromotionalPackagesItemDetailsListingQuery, GetPromotionalPackagesItemDetailsListingQueryVariables>(GetPromotionalPackagesItemDetailsListingDocument, options);
      }
export function useGetPromotionalPackagesItemDetailsListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPromotionalPackagesItemDetailsListingQuery, GetPromotionalPackagesItemDetailsListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPromotionalPackagesItemDetailsListingQuery, GetPromotionalPackagesItemDetailsListingQueryVariables>(GetPromotionalPackagesItemDetailsListingDocument, options);
        }
export type GetPromotionalPackagesItemDetailsListingQueryHookResult = ReturnType<typeof useGetPromotionalPackagesItemDetailsListingQuery>;
export type GetPromotionalPackagesItemDetailsListingLazyQueryHookResult = ReturnType<typeof useGetPromotionalPackagesItemDetailsListingLazyQuery>;
export type GetPromotionalPackagesItemDetailsListingQueryResult = Apollo.QueryResult<GetPromotionalPackagesItemDetailsListingQuery, GetPromotionalPackagesItemDetailsListingQueryVariables>;
export const GetPromotionalPackagesByProjectIdDocument = gql`
    query getPromotionalPackagesByProjectId($promotionalPackagesId: String!, $projectId: String!) {
  getPromotionalPackagesByProjectId(promotionalPackagesId: $promotionalPackagesId, projectId: $projectId) {
    id
    accountId
    projectId
    name
    startDate
    endDate
    createdBy
    createdTs
    items {
      id
      accountId
      promotionalPackagesId
      promotionalItemId
      costPrice
      promoPrice
      description
      recordStatus
      createdBy
      createdTs
    }
  }
}
    `;

/**
 * __useGetPromotionalPackagesByProjectIdQuery__
 *
 * To run a query within a React component, call `useGetPromotionalPackagesByProjectIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPromotionalPackagesByProjectIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPromotionalPackagesByProjectIdQuery({
 *   variables: {
 *      promotionalPackagesId: // value for 'promotionalPackagesId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetPromotionalPackagesByProjectIdQuery(baseOptions: Apollo.QueryHookOptions<GetPromotionalPackagesByProjectIdQuery, GetPromotionalPackagesByProjectIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPromotionalPackagesByProjectIdQuery, GetPromotionalPackagesByProjectIdQueryVariables>(GetPromotionalPackagesByProjectIdDocument, options);
      }
export function useGetPromotionalPackagesByProjectIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPromotionalPackagesByProjectIdQuery, GetPromotionalPackagesByProjectIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPromotionalPackagesByProjectIdQuery, GetPromotionalPackagesByProjectIdQueryVariables>(GetPromotionalPackagesByProjectIdDocument, options);
        }
export type GetPromotionalPackagesByProjectIdQueryHookResult = ReturnType<typeof useGetPromotionalPackagesByProjectIdQuery>;
export type GetPromotionalPackagesByProjectIdLazyQueryHookResult = ReturnType<typeof useGetPromotionalPackagesByProjectIdLazyQuery>;
export type GetPromotionalPackagesByProjectIdQueryResult = Apollo.QueryResult<GetPromotionalPackagesByProjectIdQuery, GetPromotionalPackagesByProjectIdQueryVariables>;
export const GetPromotionalItemDocument = gql`
    query getPromotionalItem {
  getPromotionalItem {
    promotionalItemId
    name
  }
}
    `;

/**
 * __useGetPromotionalItemQuery__
 *
 * To run a query within a React component, call `useGetPromotionalItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPromotionalItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPromotionalItemQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPromotionalItemQuery(baseOptions?: Apollo.QueryHookOptions<GetPromotionalItemQuery, GetPromotionalItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPromotionalItemQuery, GetPromotionalItemQueryVariables>(GetPromotionalItemDocument, options);
      }
export function useGetPromotionalItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPromotionalItemQuery, GetPromotionalItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPromotionalItemQuery, GetPromotionalItemQueryVariables>(GetPromotionalItemDocument, options);
        }
export type GetPromotionalItemQueryHookResult = ReturnType<typeof useGetPromotionalItemQuery>;
export type GetPromotionalItemLazyQueryHookResult = ReturnType<typeof useGetPromotionalItemLazyQuery>;
export type GetPromotionalItemQueryResult = Apollo.QueryResult<GetPromotionalItemQuery, GetPromotionalItemQueryVariables>;
export const AddPromotionalPackageDocument = gql`
    mutation addPromotionalPackage($projectId: String!, $input: AddPromotionalPackagesInput!) {
  addPromotionalPackage(projectId: $projectId, input: $input)
}
    `;
export type AddPromotionalPackageMutationFn = Apollo.MutationFunction<AddPromotionalPackageMutation, AddPromotionalPackageMutationVariables>;

/**
 * __useAddPromotionalPackageMutation__
 *
 * To run a mutation, you first call `useAddPromotionalPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPromotionalPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPromotionalPackageMutation, { data, loading, error }] = useAddPromotionalPackageMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPromotionalPackageMutation(baseOptions?: Apollo.MutationHookOptions<AddPromotionalPackageMutation, AddPromotionalPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPromotionalPackageMutation, AddPromotionalPackageMutationVariables>(AddPromotionalPackageDocument, options);
      }
export type AddPromotionalPackageMutationHookResult = ReturnType<typeof useAddPromotionalPackageMutation>;
export type AddPromotionalPackageMutationResult = Apollo.MutationResult<AddPromotionalPackageMutation>;
export type AddPromotionalPackageMutationOptions = Apollo.BaseMutationOptions<AddPromotionalPackageMutation, AddPromotionalPackageMutationVariables>;
export const EditPromotionalPackagesDocument = gql`
    mutation editPromotionalPackages($projectId: String!, $input: EditPromotionalPackagesInput!, $promotionalPackageId: String!) {
  editPromotionalPackages(projectId: $projectId, input: $input, promotionalPackageId: $promotionalPackageId)
}
    `;
export type EditPromotionalPackagesMutationFn = Apollo.MutationFunction<EditPromotionalPackagesMutation, EditPromotionalPackagesMutationVariables>;

/**
 * __useEditPromotionalPackagesMutation__
 *
 * To run a mutation, you first call `useEditPromotionalPackagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPromotionalPackagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPromotionalPackagesMutation, { data, loading, error }] = useEditPromotionalPackagesMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      input: // value for 'input'
 *      promotionalPackageId: // value for 'promotionalPackageId'
 *   },
 * });
 */
export function useEditPromotionalPackagesMutation(baseOptions?: Apollo.MutationHookOptions<EditPromotionalPackagesMutation, EditPromotionalPackagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditPromotionalPackagesMutation, EditPromotionalPackagesMutationVariables>(EditPromotionalPackagesDocument, options);
      }
export type EditPromotionalPackagesMutationHookResult = ReturnType<typeof useEditPromotionalPackagesMutation>;
export type EditPromotionalPackagesMutationResult = Apollo.MutationResult<EditPromotionalPackagesMutation>;
export type EditPromotionalPackagesMutationOptions = Apollo.BaseMutationOptions<EditPromotionalPackagesMutation, EditPromotionalPackagesMutationVariables>;
export const DeletePromotionalPackageDocument = gql`
    mutation deletePromotionalPackage($projectId: String!, $promotionalPackageId: String!) {
  deletePromotionalPackage(projectId: $projectId, promotionalPackageId: $promotionalPackageId)
}
    `;
export type DeletePromotionalPackageMutationFn = Apollo.MutationFunction<DeletePromotionalPackageMutation, DeletePromotionalPackageMutationVariables>;

/**
 * __useDeletePromotionalPackageMutation__
 *
 * To run a mutation, you first call `useDeletePromotionalPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePromotionalPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePromotionalPackageMutation, { data, loading, error }] = useDeletePromotionalPackageMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      promotionalPackageId: // value for 'promotionalPackageId'
 *   },
 * });
 */
export function useDeletePromotionalPackageMutation(baseOptions?: Apollo.MutationHookOptions<DeletePromotionalPackageMutation, DeletePromotionalPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePromotionalPackageMutation, DeletePromotionalPackageMutationVariables>(DeletePromotionalPackageDocument, options);
      }
export type DeletePromotionalPackageMutationHookResult = ReturnType<typeof useDeletePromotionalPackageMutation>;
export type DeletePromotionalPackageMutationResult = Apollo.MutationResult<DeletePromotionalPackageMutation>;
export type DeletePromotionalPackageMutationOptions = Apollo.BaseMutationOptions<DeletePromotionalPackageMutation, DeletePromotionalPackageMutationVariables>;
export const DeletePromotionalItemInDetailsListingDocument = gql`
    mutation deletePromotionalItemInDetailsListing($promotionalPackagesItemId: String!) {
  deletePromotionalItemInDetailsListing(promotionalPackagesItemId: $promotionalPackagesItemId)
}
    `;
export type DeletePromotionalItemInDetailsListingMutationFn = Apollo.MutationFunction<DeletePromotionalItemInDetailsListingMutation, DeletePromotionalItemInDetailsListingMutationVariables>;

/**
 * __useDeletePromotionalItemInDetailsListingMutation__
 *
 * To run a mutation, you first call `useDeletePromotionalItemInDetailsListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePromotionalItemInDetailsListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePromotionalItemInDetailsListingMutation, { data, loading, error }] = useDeletePromotionalItemInDetailsListingMutation({
 *   variables: {
 *      promotionalPackagesItemId: // value for 'promotionalPackagesItemId'
 *   },
 * });
 */
export function useDeletePromotionalItemInDetailsListingMutation(baseOptions?: Apollo.MutationHookOptions<DeletePromotionalItemInDetailsListingMutation, DeletePromotionalItemInDetailsListingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePromotionalItemInDetailsListingMutation, DeletePromotionalItemInDetailsListingMutationVariables>(DeletePromotionalItemInDetailsListingDocument, options);
      }
export type DeletePromotionalItemInDetailsListingMutationHookResult = ReturnType<typeof useDeletePromotionalItemInDetailsListingMutation>;
export type DeletePromotionalItemInDetailsListingMutationResult = Apollo.MutationResult<DeletePromotionalItemInDetailsListingMutation>;
export type DeletePromotionalItemInDetailsListingMutationOptions = Apollo.BaseMutationOptions<DeletePromotionalItemInDetailsListingMutation, DeletePromotionalItemInDetailsListingMutationVariables>;
export const GetProjectSalesOfficeDocument = gql`
    query getProjectSalesOffice {
  getProjectSalesOffice {
    id
    salesOfficeTel
    salesOfficeFax
    salesOfficeAddress
    propertyManager
    projectManager
    generalManager
    salesMarketingHOD
    creditControlHOD
    creditControlOfficeTel
    creditControlEmail
    customerCareHOD
    customerCareContactNo
    customerCareEmail
    areaUOM1
    areaUOM2
    areaUOM3
    areaUOMConversion1
    areaUOMConversion2
    salesLocalAuthorityName
    salesLocalAuthorityContactNo
    salesLocalAuthorityAddress {
      address
      country
      city
      state
      postCode
    }
    customerCareLocalAuthorityName
    customerCareLocalAuthorityContactNo
    customerCareLocalAuthorityAddress {
      address
      country
      city
      state
      postCode
    }
    buildingContractorAwarded
    buildingContractorName
    warrantyPeriod
    DLPTerm1
    DLPTerm2
    salesPermit
    architecturePermit
    constructionPermit
    builtUpArea
    densityPercentage
    floorArea
    floorAreaPercent
    commonArea
    commonAreaPercent
    greenspaceArea
    greenspaceAreaPercent
    landArea
    usageRatioPercent
    usagePurpose
  }
}
    `;

/**
 * __useGetProjectSalesOfficeQuery__
 *
 * To run a query within a React component, call `useGetProjectSalesOfficeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectSalesOfficeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectSalesOfficeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProjectSalesOfficeQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectSalesOfficeQuery, GetProjectSalesOfficeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectSalesOfficeQuery, GetProjectSalesOfficeQueryVariables>(GetProjectSalesOfficeDocument, options);
      }
export function useGetProjectSalesOfficeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectSalesOfficeQuery, GetProjectSalesOfficeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectSalesOfficeQuery, GetProjectSalesOfficeQueryVariables>(GetProjectSalesOfficeDocument, options);
        }
export type GetProjectSalesOfficeQueryHookResult = ReturnType<typeof useGetProjectSalesOfficeQuery>;
export type GetProjectSalesOfficeLazyQueryHookResult = ReturnType<typeof useGetProjectSalesOfficeLazyQuery>;
export type GetProjectSalesOfficeQueryResult = Apollo.QueryResult<GetProjectSalesOfficeQuery, GetProjectSalesOfficeQueryVariables>;
export const AddProjectSalesOfficeDocument = gql`
    mutation addProjectSalesOffice($input: SalesOfficeInput!) {
  addProjectSalesOffice(input: $input)
}
    `;
export type AddProjectSalesOfficeMutationFn = Apollo.MutationFunction<AddProjectSalesOfficeMutation, AddProjectSalesOfficeMutationVariables>;

/**
 * __useAddProjectSalesOfficeMutation__
 *
 * To run a mutation, you first call `useAddProjectSalesOfficeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProjectSalesOfficeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProjectSalesOfficeMutation, { data, loading, error }] = useAddProjectSalesOfficeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddProjectSalesOfficeMutation(baseOptions?: Apollo.MutationHookOptions<AddProjectSalesOfficeMutation, AddProjectSalesOfficeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProjectSalesOfficeMutation, AddProjectSalesOfficeMutationVariables>(AddProjectSalesOfficeDocument, options);
      }
export type AddProjectSalesOfficeMutationHookResult = ReturnType<typeof useAddProjectSalesOfficeMutation>;
export type AddProjectSalesOfficeMutationResult = Apollo.MutationResult<AddProjectSalesOfficeMutation>;
export type AddProjectSalesOfficeMutationOptions = Apollo.BaseMutationOptions<AddProjectSalesOfficeMutation, AddProjectSalesOfficeMutationVariables>;
export const EditProjectSalesOfficeDocument = gql`
    mutation editProjectSalesOffice($input: EditSalesOfficeInput!) {
  editProjectSalesOffice(input: $input)
}
    `;
export type EditProjectSalesOfficeMutationFn = Apollo.MutationFunction<EditProjectSalesOfficeMutation, EditProjectSalesOfficeMutationVariables>;

/**
 * __useEditProjectSalesOfficeMutation__
 *
 * To run a mutation, you first call `useEditProjectSalesOfficeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditProjectSalesOfficeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editProjectSalesOfficeMutation, { data, loading, error }] = useEditProjectSalesOfficeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditProjectSalesOfficeMutation(baseOptions?: Apollo.MutationHookOptions<EditProjectSalesOfficeMutation, EditProjectSalesOfficeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditProjectSalesOfficeMutation, EditProjectSalesOfficeMutationVariables>(EditProjectSalesOfficeDocument, options);
      }
export type EditProjectSalesOfficeMutationHookResult = ReturnType<typeof useEditProjectSalesOfficeMutation>;
export type EditProjectSalesOfficeMutationResult = Apollo.MutationResult<EditProjectSalesOfficeMutation>;
export type EditProjectSalesOfficeMutationOptions = Apollo.BaseMutationOptions<EditProjectSalesOfficeMutation, EditProjectSalesOfficeMutationVariables>;
export const GetPackageFormSourceDocument = gql`
    query getPackageFormSource($saleId: String!) {
  getPackageFormSource(saleId: $saleId) {
    id
    name
    desc
    projectId
    listPrice
    marketValue
    startDate
    endDate
    isDeletable
    packageExt {
      taxSchemeId
      defaulted
    }
    isIntegrated
    commonStatus
  }
}
    `;

/**
 * __useGetPackageFormSourceQuery__
 *
 * To run a query within a React component, call `useGetPackageFormSourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPackageFormSourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPackageFormSourceQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetPackageFormSourceQuery(baseOptions: Apollo.QueryHookOptions<GetPackageFormSourceQuery, GetPackageFormSourceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPackageFormSourceQuery, GetPackageFormSourceQueryVariables>(GetPackageFormSourceDocument, options);
      }
export function useGetPackageFormSourceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPackageFormSourceQuery, GetPackageFormSourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPackageFormSourceQuery, GetPackageFormSourceQueryVariables>(GetPackageFormSourceDocument, options);
        }
export type GetPackageFormSourceQueryHookResult = ReturnType<typeof useGetPackageFormSourceQuery>;
export type GetPackageFormSourceLazyQueryHookResult = ReturnType<typeof useGetPackageFormSourceLazyQuery>;
export type GetPackageFormSourceQueryResult = Apollo.QueryResult<GetPackageFormSourceQuery, GetPackageFormSourceQueryVariables>;
export const GetSalesPackagesListDocument = gql`
    query getSalesPackagesList {
  getSalesPackagesList {
    id
    name
    desc
    projectId
    listPrice
    marketValue
    startDate
    endDate
    isDeletable
    packageExt {
      taxSchemeId
      defaulted
    }
    isIntegrated
    commonStatus
  }
}
    `;

/**
 * __useGetSalesPackagesListQuery__
 *
 * To run a query within a React component, call `useGetSalesPackagesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesPackagesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesPackagesListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSalesPackagesListQuery(baseOptions?: Apollo.QueryHookOptions<GetSalesPackagesListQuery, GetSalesPackagesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesPackagesListQuery, GetSalesPackagesListQueryVariables>(GetSalesPackagesListDocument, options);
      }
export function useGetSalesPackagesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesPackagesListQuery, GetSalesPackagesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesPackagesListQuery, GetSalesPackagesListQueryVariables>(GetSalesPackagesListDocument, options);
        }
export type GetSalesPackagesListQueryHookResult = ReturnType<typeof useGetSalesPackagesListQuery>;
export type GetSalesPackagesListLazyQueryHookResult = ReturnType<typeof useGetSalesPackagesListLazyQuery>;
export type GetSalesPackagesListQueryResult = Apollo.QueryResult<GetSalesPackagesListQuery, GetSalesPackagesListQueryVariables>;
export const SetDefaultSalesPackageForProjectDocument = gql`
    mutation setDefaultSalesPackageForProject($projectId: String!, $packageId: String!, $check: Boolean!) {
  setDefaultSalesPackageForProject(projectId: $projectId, packageId: $packageId, check: $check)
}
    `;
export type SetDefaultSalesPackageForProjectMutationFn = Apollo.MutationFunction<SetDefaultSalesPackageForProjectMutation, SetDefaultSalesPackageForProjectMutationVariables>;

/**
 * __useSetDefaultSalesPackageForProjectMutation__
 *
 * To run a mutation, you first call `useSetDefaultSalesPackageForProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultSalesPackageForProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultSalesPackageForProjectMutation, { data, loading, error }] = useSetDefaultSalesPackageForProjectMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      packageId: // value for 'packageId'
 *      check: // value for 'check'
 *   },
 * });
 */
export function useSetDefaultSalesPackageForProjectMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultSalesPackageForProjectMutation, SetDefaultSalesPackageForProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultSalesPackageForProjectMutation, SetDefaultSalesPackageForProjectMutationVariables>(SetDefaultSalesPackageForProjectDocument, options);
      }
export type SetDefaultSalesPackageForProjectMutationHookResult = ReturnType<typeof useSetDefaultSalesPackageForProjectMutation>;
export type SetDefaultSalesPackageForProjectMutationResult = Apollo.MutationResult<SetDefaultSalesPackageForProjectMutation>;
export type SetDefaultSalesPackageForProjectMutationOptions = Apollo.BaseMutationOptions<SetDefaultSalesPackageForProjectMutation, SetDefaultSalesPackageForProjectMutationVariables>;
export const AddSalesPackageDocument = gql`
    mutation addSalesPackage($input: AddSalesPackageInput!) {
  addSalesPackage(input: $input)
}
    `;
export type AddSalesPackageMutationFn = Apollo.MutationFunction<AddSalesPackageMutation, AddSalesPackageMutationVariables>;

/**
 * __useAddSalesPackageMutation__
 *
 * To run a mutation, you first call `useAddSalesPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSalesPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSalesPackageMutation, { data, loading, error }] = useAddSalesPackageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddSalesPackageMutation(baseOptions?: Apollo.MutationHookOptions<AddSalesPackageMutation, AddSalesPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSalesPackageMutation, AddSalesPackageMutationVariables>(AddSalesPackageDocument, options);
      }
export type AddSalesPackageMutationHookResult = ReturnType<typeof useAddSalesPackageMutation>;
export type AddSalesPackageMutationResult = Apollo.MutationResult<AddSalesPackageMutation>;
export type AddSalesPackageMutationOptions = Apollo.BaseMutationOptions<AddSalesPackageMutation, AddSalesPackageMutationVariables>;
export const EditSalesPackageDocument = gql`
    mutation editSalesPackage($input: EditSalesPackageInput!) {
  editSalesPackage(input: $input)
}
    `;
export type EditSalesPackageMutationFn = Apollo.MutationFunction<EditSalesPackageMutation, EditSalesPackageMutationVariables>;

/**
 * __useEditSalesPackageMutation__
 *
 * To run a mutation, you first call `useEditSalesPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSalesPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSalesPackageMutation, { data, loading, error }] = useEditSalesPackageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditSalesPackageMutation(baseOptions?: Apollo.MutationHookOptions<EditSalesPackageMutation, EditSalesPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditSalesPackageMutation, EditSalesPackageMutationVariables>(EditSalesPackageDocument, options);
      }
export type EditSalesPackageMutationHookResult = ReturnType<typeof useEditSalesPackageMutation>;
export type EditSalesPackageMutationResult = Apollo.MutationResult<EditSalesPackageMutation>;
export type EditSalesPackageMutationOptions = Apollo.BaseMutationOptions<EditSalesPackageMutation, EditSalesPackageMutationVariables>;
export const GetSalesPackageByIdDocument = gql`
    query getSalesPackageById($id: String!) {
  getSalesPackageById(id: $id) {
    id
    name
    desc
    projectId
    listPrice
    marketValue
    startDate
    endDate
    packageExt {
      taxSchemeId
      defaulted
    }
  }
}
    `;

/**
 * __useGetSalesPackageByIdQuery__
 *
 * To run a query within a React component, call `useGetSalesPackageByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesPackageByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesPackageByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSalesPackageByIdQuery(baseOptions: Apollo.QueryHookOptions<GetSalesPackageByIdQuery, GetSalesPackageByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesPackageByIdQuery, GetSalesPackageByIdQueryVariables>(GetSalesPackageByIdDocument, options);
      }
export function useGetSalesPackageByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesPackageByIdQuery, GetSalesPackageByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesPackageByIdQuery, GetSalesPackageByIdQueryVariables>(GetSalesPackageByIdDocument, options);
        }
export type GetSalesPackageByIdQueryHookResult = ReturnType<typeof useGetSalesPackageByIdQuery>;
export type GetSalesPackageByIdLazyQueryHookResult = ReturnType<typeof useGetSalesPackageByIdLazyQuery>;
export type GetSalesPackageByIdQueryResult = Apollo.QueryResult<GetSalesPackageByIdQuery, GetSalesPackageByIdQueryVariables>;
export const ActivatePackageDocument = gql`
    mutation activatePackage($id: String!) {
  activatePackage(id: $id)
}
    `;
export type ActivatePackageMutationFn = Apollo.MutationFunction<ActivatePackageMutation, ActivatePackageMutationVariables>;

/**
 * __useActivatePackageMutation__
 *
 * To run a mutation, you first call `useActivatePackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivatePackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activatePackageMutation, { data, loading, error }] = useActivatePackageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActivatePackageMutation(baseOptions?: Apollo.MutationHookOptions<ActivatePackageMutation, ActivatePackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivatePackageMutation, ActivatePackageMutationVariables>(ActivatePackageDocument, options);
      }
export type ActivatePackageMutationHookResult = ReturnType<typeof useActivatePackageMutation>;
export type ActivatePackageMutationResult = Apollo.MutationResult<ActivatePackageMutation>;
export type ActivatePackageMutationOptions = Apollo.BaseMutationOptions<ActivatePackageMutation, ActivatePackageMutationVariables>;
export const DeactivatePackageDocument = gql`
    mutation deactivatePackage($id: String!) {
  deactivatePackage(id: $id)
}
    `;
export type DeactivatePackageMutationFn = Apollo.MutationFunction<DeactivatePackageMutation, DeactivatePackageMutationVariables>;

/**
 * __useDeactivatePackageMutation__
 *
 * To run a mutation, you first call `useDeactivatePackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivatePackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivatePackageMutation, { data, loading, error }] = useDeactivatePackageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeactivatePackageMutation(baseOptions?: Apollo.MutationHookOptions<DeactivatePackageMutation, DeactivatePackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivatePackageMutation, DeactivatePackageMutationVariables>(DeactivatePackageDocument, options);
      }
export type DeactivatePackageMutationHookResult = ReturnType<typeof useDeactivatePackageMutation>;
export type DeactivatePackageMutationResult = Apollo.MutationResult<DeactivatePackageMutation>;
export type DeactivatePackageMutationOptions = Apollo.BaseMutationOptions<DeactivatePackageMutation, DeactivatePackageMutationVariables>;
export const GetProjectByIdDocument = gql`
    query getProjectById($projectId: String!) {
  getProjectById(projectId: $projectId) {
    id
    name
    currency
  }
}
    `;

/**
 * __useGetProjectByIdQuery__
 *
 * To run a query within a React component, call `useGetProjectByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectByIdQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetProjectByIdQuery(baseOptions: Apollo.QueryHookOptions<GetProjectByIdQuery, GetProjectByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectByIdQuery, GetProjectByIdQueryVariables>(GetProjectByIdDocument, options);
      }
export function useGetProjectByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectByIdQuery, GetProjectByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectByIdQuery, GetProjectByIdQueryVariables>(GetProjectByIdDocument, options);
        }
export type GetProjectByIdQueryHookResult = ReturnType<typeof useGetProjectByIdQuery>;
export type GetProjectByIdLazyQueryHookResult = ReturnType<typeof useGetProjectByIdLazyQuery>;
export type GetProjectByIdQueryResult = Apollo.QueryResult<GetProjectByIdQuery, GetProjectByIdQueryVariables>;
export const GetStampDutyIntegrationDocument = gql`
    query getStampDutyIntegration($projectId: String!, $id: String!) {
  getStampDutyIntegration(projectId: $projectId, id: $id) {
    id
    type
    projectLetterTemplateName
    extension
    stampDutyDescription
  }
}
    `;

/**
 * __useGetStampDutyIntegrationQuery__
 *
 * To run a query within a React component, call `useGetStampDutyIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStampDutyIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStampDutyIntegrationQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetStampDutyIntegrationQuery(baseOptions: Apollo.QueryHookOptions<GetStampDutyIntegrationQuery, GetStampDutyIntegrationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStampDutyIntegrationQuery, GetStampDutyIntegrationQueryVariables>(GetStampDutyIntegrationDocument, options);
      }
export function useGetStampDutyIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStampDutyIntegrationQuery, GetStampDutyIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStampDutyIntegrationQuery, GetStampDutyIntegrationQueryVariables>(GetStampDutyIntegrationDocument, options);
        }
export type GetStampDutyIntegrationQueryHookResult = ReturnType<typeof useGetStampDutyIntegrationQuery>;
export type GetStampDutyIntegrationLazyQueryHookResult = ReturnType<typeof useGetStampDutyIntegrationLazyQuery>;
export type GetStampDutyIntegrationQueryResult = Apollo.QueryResult<GetStampDutyIntegrationQuery, GetStampDutyIntegrationQueryVariables>;
export const GetStampDutyIntegrationListingDocument = gql`
    query getStampDutyIntegrationListing($projectId: String!) {
  getStampDutyIntegrationListing(projectId: $projectId) {
    id
    type
    projectLetterTemplateId
    projectLetterTemplateName
    extension
    stampDutyId
    stampDutyDescription
  }
}
    `;

/**
 * __useGetStampDutyIntegrationListingQuery__
 *
 * To run a query within a React component, call `useGetStampDutyIntegrationListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStampDutyIntegrationListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStampDutyIntegrationListingQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetStampDutyIntegrationListingQuery(baseOptions: Apollo.QueryHookOptions<GetStampDutyIntegrationListingQuery, GetStampDutyIntegrationListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStampDutyIntegrationListingQuery, GetStampDutyIntegrationListingQueryVariables>(GetStampDutyIntegrationListingDocument, options);
      }
export function useGetStampDutyIntegrationListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStampDutyIntegrationListingQuery, GetStampDutyIntegrationListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStampDutyIntegrationListingQuery, GetStampDutyIntegrationListingQueryVariables>(GetStampDutyIntegrationListingDocument, options);
        }
export type GetStampDutyIntegrationListingQueryHookResult = ReturnType<typeof useGetStampDutyIntegrationListingQuery>;
export type GetStampDutyIntegrationListingLazyQueryHookResult = ReturnType<typeof useGetStampDutyIntegrationListingLazyQuery>;
export type GetStampDutyIntegrationListingQueryResult = Apollo.QueryResult<GetStampDutyIntegrationListingQuery, GetStampDutyIntegrationListingQueryVariables>;
export const CreateStampDutyIntegrationDocument = gql`
    mutation createStampDutyIntegration($input: CreateStampDutyIntegrationInput!) {
  createStampDutyIntegration(input: $input)
}
    `;
export type CreateStampDutyIntegrationMutationFn = Apollo.MutationFunction<CreateStampDutyIntegrationMutation, CreateStampDutyIntegrationMutationVariables>;

/**
 * __useCreateStampDutyIntegrationMutation__
 *
 * To run a mutation, you first call `useCreateStampDutyIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStampDutyIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStampDutyIntegrationMutation, { data, loading, error }] = useCreateStampDutyIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStampDutyIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<CreateStampDutyIntegrationMutation, CreateStampDutyIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStampDutyIntegrationMutation, CreateStampDutyIntegrationMutationVariables>(CreateStampDutyIntegrationDocument, options);
      }
export type CreateStampDutyIntegrationMutationHookResult = ReturnType<typeof useCreateStampDutyIntegrationMutation>;
export type CreateStampDutyIntegrationMutationResult = Apollo.MutationResult<CreateStampDutyIntegrationMutation>;
export type CreateStampDutyIntegrationMutationOptions = Apollo.BaseMutationOptions<CreateStampDutyIntegrationMutation, CreateStampDutyIntegrationMutationVariables>;
export const UpdateStampDutyIntegrationDocument = gql`
    mutation updateStampDutyIntegration($input: UpdateStampDutyIntegrationInput!) {
  updateStampDutyIntegration(input: $input)
}
    `;
export type UpdateStampDutyIntegrationMutationFn = Apollo.MutationFunction<UpdateStampDutyIntegrationMutation, UpdateStampDutyIntegrationMutationVariables>;

/**
 * __useUpdateStampDutyIntegrationMutation__
 *
 * To run a mutation, you first call `useUpdateStampDutyIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStampDutyIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStampDutyIntegrationMutation, { data, loading, error }] = useUpdateStampDutyIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStampDutyIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStampDutyIntegrationMutation, UpdateStampDutyIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStampDutyIntegrationMutation, UpdateStampDutyIntegrationMutationVariables>(UpdateStampDutyIntegrationDocument, options);
      }
export type UpdateStampDutyIntegrationMutationHookResult = ReturnType<typeof useUpdateStampDutyIntegrationMutation>;
export type UpdateStampDutyIntegrationMutationResult = Apollo.MutationResult<UpdateStampDutyIntegrationMutation>;
export type UpdateStampDutyIntegrationMutationOptions = Apollo.BaseMutationOptions<UpdateStampDutyIntegrationMutation, UpdateStampDutyIntegrationMutationVariables>;
export const DeleteStampDutyIntegrationDocument = gql`
    mutation deleteStampDutyIntegration($id: String!) {
  deleteStampDutyIntegration(id: $id)
}
    `;
export type DeleteStampDutyIntegrationMutationFn = Apollo.MutationFunction<DeleteStampDutyIntegrationMutation, DeleteStampDutyIntegrationMutationVariables>;

/**
 * __useDeleteStampDutyIntegrationMutation__
 *
 * To run a mutation, you first call `useDeleteStampDutyIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStampDutyIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStampDutyIntegrationMutation, { data, loading, error }] = useDeleteStampDutyIntegrationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteStampDutyIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteStampDutyIntegrationMutation, DeleteStampDutyIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteStampDutyIntegrationMutation, DeleteStampDutyIntegrationMutationVariables>(DeleteStampDutyIntegrationDocument, options);
      }
export type DeleteStampDutyIntegrationMutationHookResult = ReturnType<typeof useDeleteStampDutyIntegrationMutation>;
export type DeleteStampDutyIntegrationMutationResult = Apollo.MutationResult<DeleteStampDutyIntegrationMutation>;
export type DeleteStampDutyIntegrationMutationOptions = Apollo.BaseMutationOptions<DeleteStampDutyIntegrationMutation, DeleteStampDutyIntegrationMutationVariables>;
export const GetStampDutyOptionsDocument = gql`
    query getStampDutyOptions {
  getStampDutyOptions {
    id
    code
    description
  }
}
    `;

/**
 * __useGetStampDutyOptionsQuery__
 *
 * To run a query within a React component, call `useGetStampDutyOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStampDutyOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStampDutyOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStampDutyOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetStampDutyOptionsQuery, GetStampDutyOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStampDutyOptionsQuery, GetStampDutyOptionsQueryVariables>(GetStampDutyOptionsDocument, options);
      }
export function useGetStampDutyOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStampDutyOptionsQuery, GetStampDutyOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStampDutyOptionsQuery, GetStampDutyOptionsQueryVariables>(GetStampDutyOptionsDocument, options);
        }
export type GetStampDutyOptionsQueryHookResult = ReturnType<typeof useGetStampDutyOptionsQuery>;
export type GetStampDutyOptionsLazyQueryHookResult = ReturnType<typeof useGetStampDutyOptionsLazyQuery>;
export type GetStampDutyOptionsQueryResult = Apollo.QueryResult<GetStampDutyOptionsQuery, GetStampDutyOptionsQueryVariables>;
export const GetStandardLetterByCategoryDocument = gql`
    query getStandardLetterByCategory {
  getStandardLetterByCategory {
    letterCategory
    letterDetail {
      id
      name
      type
      isAllowHtmlEditor
      isAllowReportDesignEditor
    }
  }
}
    `;

/**
 * __useGetStandardLetterByCategoryQuery__
 *
 * To run a query within a React component, call `useGetStandardLetterByCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStandardLetterByCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStandardLetterByCategoryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStandardLetterByCategoryQuery(baseOptions?: Apollo.QueryHookOptions<GetStandardLetterByCategoryQuery, GetStandardLetterByCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStandardLetterByCategoryQuery, GetStandardLetterByCategoryQueryVariables>(GetStandardLetterByCategoryDocument, options);
      }
export function useGetStandardLetterByCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStandardLetterByCategoryQuery, GetStandardLetterByCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStandardLetterByCategoryQuery, GetStandardLetterByCategoryQueryVariables>(GetStandardLetterByCategoryDocument, options);
        }
export type GetStandardLetterByCategoryQueryHookResult = ReturnType<typeof useGetStandardLetterByCategoryQuery>;
export type GetStandardLetterByCategoryLazyQueryHookResult = ReturnType<typeof useGetStandardLetterByCategoryLazyQuery>;
export type GetStandardLetterByCategoryQueryResult = Apollo.QueryResult<GetStandardLetterByCategoryQuery, GetStandardLetterByCategoryQueryVariables>;
export const GetProjectLetterTemplateListingDocument = gql`
    query getProjectLetterTemplateListing($standardLetterId: String!, $projectId: String!) {
  getProjectLetterTemplateListing(standardLetterId: $standardLetterId, projectId: $projectId) {
    id
    standardLetterId
    name
    defaulted
    standardLetter {
      name
      isAllowHtmlEditor
      isAllowReportDesignEditor
    }
    slDataSource {
      id
      version
    }
    isReportDesignEditor
    standardLetterDataSourceVersion
  }
}
    `;

/**
 * __useGetProjectLetterTemplateListingQuery__
 *
 * To run a query within a React component, call `useGetProjectLetterTemplateListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectLetterTemplateListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectLetterTemplateListingQuery({
 *   variables: {
 *      standardLetterId: // value for 'standardLetterId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetProjectLetterTemplateListingQuery(baseOptions: Apollo.QueryHookOptions<GetProjectLetterTemplateListingQuery, GetProjectLetterTemplateListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectLetterTemplateListingQuery, GetProjectLetterTemplateListingQueryVariables>(GetProjectLetterTemplateListingDocument, options);
      }
export function useGetProjectLetterTemplateListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectLetterTemplateListingQuery, GetProjectLetterTemplateListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectLetterTemplateListingQuery, GetProjectLetterTemplateListingQueryVariables>(GetProjectLetterTemplateListingDocument, options);
        }
export type GetProjectLetterTemplateListingQueryHookResult = ReturnType<typeof useGetProjectLetterTemplateListingQuery>;
export type GetProjectLetterTemplateListingLazyQueryHookResult = ReturnType<typeof useGetProjectLetterTemplateListingLazyQuery>;
export type GetProjectLetterTemplateListingQueryResult = Apollo.QueryResult<GetProjectLetterTemplateListingQuery, GetProjectLetterTemplateListingQueryVariables>;
export const AddStandardLetterDocument = gql`
    mutation addStandardLetter($input: StandardLetterInput!) {
  addStandardLetter(input: $input)
}
    `;
export type AddStandardLetterMutationFn = Apollo.MutationFunction<AddStandardLetterMutation, AddStandardLetterMutationVariables>;

/**
 * __useAddStandardLetterMutation__
 *
 * To run a mutation, you first call `useAddStandardLetterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddStandardLetterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addStandardLetterMutation, { data, loading, error }] = useAddStandardLetterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddStandardLetterMutation(baseOptions?: Apollo.MutationHookOptions<AddStandardLetterMutation, AddStandardLetterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddStandardLetterMutation, AddStandardLetterMutationVariables>(AddStandardLetterDocument, options);
      }
export type AddStandardLetterMutationHookResult = ReturnType<typeof useAddStandardLetterMutation>;
export type AddStandardLetterMutationResult = Apollo.MutationResult<AddStandardLetterMutation>;
export type AddStandardLetterMutationOptions = Apollo.BaseMutationOptions<AddStandardLetterMutation, AddStandardLetterMutationVariables>;
export const EditStandardLetterDocument = gql`
    mutation editStandardLetter($input: EditStandardLetterInput!) {
  editStandardLetter(input: $input)
}
    `;
export type EditStandardLetterMutationFn = Apollo.MutationFunction<EditStandardLetterMutation, EditStandardLetterMutationVariables>;

/**
 * __useEditStandardLetterMutation__
 *
 * To run a mutation, you first call `useEditStandardLetterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditStandardLetterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editStandardLetterMutation, { data, loading, error }] = useEditStandardLetterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditStandardLetterMutation(baseOptions?: Apollo.MutationHookOptions<EditStandardLetterMutation, EditStandardLetterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditStandardLetterMutation, EditStandardLetterMutationVariables>(EditStandardLetterDocument, options);
      }
export type EditStandardLetterMutationHookResult = ReturnType<typeof useEditStandardLetterMutation>;
export type EditStandardLetterMutationResult = Apollo.MutationResult<EditStandardLetterMutation>;
export type EditStandardLetterMutationOptions = Apollo.BaseMutationOptions<EditStandardLetterMutation, EditStandardLetterMutationVariables>;
export const GetProjectLetterTemplateByIdDocument = gql`
    query getProjectLetterTemplateById($standardLetterId: String!, $projectId: String!, $letterTemplateId: String!) {
  getProjectLetterTemplateById(standardLetterId: $standardLetterId, projectId: $projectId, letterTemplateId: $letterTemplateId) {
    id
    standardLetterId
    name
    templateBody
    jointBuyerSignRequired
    isReportDesignEditor
  }
}
    `;

/**
 * __useGetProjectLetterTemplateByIdQuery__
 *
 * To run a query within a React component, call `useGetProjectLetterTemplateByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectLetterTemplateByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectLetterTemplateByIdQuery({
 *   variables: {
 *      standardLetterId: // value for 'standardLetterId'
 *      projectId: // value for 'projectId'
 *      letterTemplateId: // value for 'letterTemplateId'
 *   },
 * });
 */
export function useGetProjectLetterTemplateByIdQuery(baseOptions: Apollo.QueryHookOptions<GetProjectLetterTemplateByIdQuery, GetProjectLetterTemplateByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectLetterTemplateByIdQuery, GetProjectLetterTemplateByIdQueryVariables>(GetProjectLetterTemplateByIdDocument, options);
      }
export function useGetProjectLetterTemplateByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectLetterTemplateByIdQuery, GetProjectLetterTemplateByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectLetterTemplateByIdQuery, GetProjectLetterTemplateByIdQueryVariables>(GetProjectLetterTemplateByIdDocument, options);
        }
export type GetProjectLetterTemplateByIdQueryHookResult = ReturnType<typeof useGetProjectLetterTemplateByIdQuery>;
export type GetProjectLetterTemplateByIdLazyQueryHookResult = ReturnType<typeof useGetProjectLetterTemplateByIdLazyQuery>;
export type GetProjectLetterTemplateByIdQueryResult = Apollo.QueryResult<GetProjectLetterTemplateByIdQuery, GetProjectLetterTemplateByIdQueryVariables>;
export const CloneStandardLetterDocument = gql`
    mutation cloneStandardLetter($letterTemplateIds: [String!]!) {
  cloneStandardLetter(letterTemplateIds: $letterTemplateIds)
}
    `;
export type CloneStandardLetterMutationFn = Apollo.MutationFunction<CloneStandardLetterMutation, CloneStandardLetterMutationVariables>;

/**
 * __useCloneStandardLetterMutation__
 *
 * To run a mutation, you first call `useCloneStandardLetterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneStandardLetterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneStandardLetterMutation, { data, loading, error }] = useCloneStandardLetterMutation({
 *   variables: {
 *      letterTemplateIds: // value for 'letterTemplateIds'
 *   },
 * });
 */
export function useCloneStandardLetterMutation(baseOptions?: Apollo.MutationHookOptions<CloneStandardLetterMutation, CloneStandardLetterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneStandardLetterMutation, CloneStandardLetterMutationVariables>(CloneStandardLetterDocument, options);
      }
export type CloneStandardLetterMutationHookResult = ReturnType<typeof useCloneStandardLetterMutation>;
export type CloneStandardLetterMutationResult = Apollo.MutationResult<CloneStandardLetterMutation>;
export type CloneStandardLetterMutationOptions = Apollo.BaseMutationOptions<CloneStandardLetterMutation, CloneStandardLetterMutationVariables>;
export const DeleteStandardLetterDocument = gql`
    mutation deleteStandardLetter($letterTemplateId: String!) {
  deleteStandardLetter(letterTemplateId: $letterTemplateId)
}
    `;
export type DeleteStandardLetterMutationFn = Apollo.MutationFunction<DeleteStandardLetterMutation, DeleteStandardLetterMutationVariables>;

/**
 * __useDeleteStandardLetterMutation__
 *
 * To run a mutation, you first call `useDeleteStandardLetterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStandardLetterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStandardLetterMutation, { data, loading, error }] = useDeleteStandardLetterMutation({
 *   variables: {
 *      letterTemplateId: // value for 'letterTemplateId'
 *   },
 * });
 */
export function useDeleteStandardLetterMutation(baseOptions?: Apollo.MutationHookOptions<DeleteStandardLetterMutation, DeleteStandardLetterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteStandardLetterMutation, DeleteStandardLetterMutationVariables>(DeleteStandardLetterDocument, options);
      }
export type DeleteStandardLetterMutationHookResult = ReturnType<typeof useDeleteStandardLetterMutation>;
export type DeleteStandardLetterMutationResult = Apollo.MutationResult<DeleteStandardLetterMutation>;
export type DeleteStandardLetterMutationOptions = Apollo.BaseMutationOptions<DeleteStandardLetterMutation, DeleteStandardLetterMutationVariables>;
export const SetDefaultStandardLetterDocument = gql`
    mutation setDefaultStandardLetter($letterTemplateId: String!, $defaulted: Boolean!) {
  setDefaultStandardLetter(letterTemplateId: $letterTemplateId, defaulted: $defaulted)
}
    `;
export type SetDefaultStandardLetterMutationFn = Apollo.MutationFunction<SetDefaultStandardLetterMutation, SetDefaultStandardLetterMutationVariables>;

/**
 * __useSetDefaultStandardLetterMutation__
 *
 * To run a mutation, you first call `useSetDefaultStandardLetterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultStandardLetterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultStandardLetterMutation, { data, loading, error }] = useSetDefaultStandardLetterMutation({
 *   variables: {
 *      letterTemplateId: // value for 'letterTemplateId'
 *      defaulted: // value for 'defaulted'
 *   },
 * });
 */
export function useSetDefaultStandardLetterMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultStandardLetterMutation, SetDefaultStandardLetterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultStandardLetterMutation, SetDefaultStandardLetterMutationVariables>(SetDefaultStandardLetterDocument, options);
      }
export type SetDefaultStandardLetterMutationHookResult = ReturnType<typeof useSetDefaultStandardLetterMutation>;
export type SetDefaultStandardLetterMutationResult = Apollo.MutationResult<SetDefaultStandardLetterMutation>;
export type SetDefaultStandardLetterMutationOptions = Apollo.BaseMutationOptions<SetDefaultStandardLetterMutation, SetDefaultStandardLetterMutationVariables>;
export const ProjectLetterTemplateRebuildReportDocument = gql`
    mutation projectLetterTemplateRebuildReport($id: String!, $sldsId: String!) {
  projectLetterTemplateRebuildReport(id: $id, sldsId: $sldsId)
}
    `;
export type ProjectLetterTemplateRebuildReportMutationFn = Apollo.MutationFunction<ProjectLetterTemplateRebuildReportMutation, ProjectLetterTemplateRebuildReportMutationVariables>;

/**
 * __useProjectLetterTemplateRebuildReportMutation__
 *
 * To run a mutation, you first call `useProjectLetterTemplateRebuildReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectLetterTemplateRebuildReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectLetterTemplateRebuildReportMutation, { data, loading, error }] = useProjectLetterTemplateRebuildReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *      sldsId: // value for 'sldsId'
 *   },
 * });
 */
export function useProjectLetterTemplateRebuildReportMutation(baseOptions?: Apollo.MutationHookOptions<ProjectLetterTemplateRebuildReportMutation, ProjectLetterTemplateRebuildReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectLetterTemplateRebuildReportMutation, ProjectLetterTemplateRebuildReportMutationVariables>(ProjectLetterTemplateRebuildReportDocument, options);
      }
export type ProjectLetterTemplateRebuildReportMutationHookResult = ReturnType<typeof useProjectLetterTemplateRebuildReportMutation>;
export type ProjectLetterTemplateRebuildReportMutationResult = Apollo.MutationResult<ProjectLetterTemplateRebuildReportMutation>;
export type ProjectLetterTemplateRebuildReportMutationOptions = Apollo.BaseMutationOptions<ProjectLetterTemplateRebuildReportMutation, ProjectLetterTemplateRebuildReportMutationVariables>;
export const DesignProjectLetterTemplateDocument = gql`
    mutation designProjectLetterTemplate($input: DesignLetterTemplateInput!) {
  designProjectLetterTemplate(input: $input)
}
    `;
export type DesignProjectLetterTemplateMutationFn = Apollo.MutationFunction<DesignProjectLetterTemplateMutation, DesignProjectLetterTemplateMutationVariables>;

/**
 * __useDesignProjectLetterTemplateMutation__
 *
 * To run a mutation, you first call `useDesignProjectLetterTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDesignProjectLetterTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [designProjectLetterTemplateMutation, { data, loading, error }] = useDesignProjectLetterTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDesignProjectLetterTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DesignProjectLetterTemplateMutation, DesignProjectLetterTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DesignProjectLetterTemplateMutation, DesignProjectLetterTemplateMutationVariables>(DesignProjectLetterTemplateDocument, options);
      }
export type DesignProjectLetterTemplateMutationHookResult = ReturnType<typeof useDesignProjectLetterTemplateMutation>;
export type DesignProjectLetterTemplateMutationResult = Apollo.MutationResult<DesignProjectLetterTemplateMutation>;
export type DesignProjectLetterTemplateMutationOptions = Apollo.BaseMutationOptions<DesignProjectLetterTemplateMutation, DesignProjectLetterTemplateMutationVariables>;
export const GetSalesTeamByProjectDocument = gql`
    query getSalesTeamByProject($projectId: String!) {
  getSalesTeamByProject(projectId: $projectId) {
    id
    name
    memberCount
  }
}
    `;

/**
 * __useGetSalesTeamByProjectQuery__
 *
 * To run a query within a React component, call `useGetSalesTeamByProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesTeamByProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesTeamByProjectQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetSalesTeamByProjectQuery(baseOptions: Apollo.QueryHookOptions<GetSalesTeamByProjectQuery, GetSalesTeamByProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesTeamByProjectQuery, GetSalesTeamByProjectQueryVariables>(GetSalesTeamByProjectDocument, options);
      }
export function useGetSalesTeamByProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesTeamByProjectQuery, GetSalesTeamByProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesTeamByProjectQuery, GetSalesTeamByProjectQueryVariables>(GetSalesTeamByProjectDocument, options);
        }
export type GetSalesTeamByProjectQueryHookResult = ReturnType<typeof useGetSalesTeamByProjectQuery>;
export type GetSalesTeamByProjectLazyQueryHookResult = ReturnType<typeof useGetSalesTeamByProjectLazyQuery>;
export type GetSalesTeamByProjectQueryResult = Apollo.QueryResult<GetSalesTeamByProjectQuery, GetSalesTeamByProjectQueryVariables>;
export const EditSalesTeamsDocument = gql`
    mutation editSalesTeams($input: EditTeamInput!) {
  editSalesTeams(input: $input)
}
    `;
export type EditSalesTeamsMutationFn = Apollo.MutationFunction<EditSalesTeamsMutation, EditSalesTeamsMutationVariables>;

/**
 * __useEditSalesTeamsMutation__
 *
 * To run a mutation, you first call `useEditSalesTeamsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSalesTeamsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSalesTeamsMutation, { data, loading, error }] = useEditSalesTeamsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditSalesTeamsMutation(baseOptions?: Apollo.MutationHookOptions<EditSalesTeamsMutation, EditSalesTeamsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditSalesTeamsMutation, EditSalesTeamsMutationVariables>(EditSalesTeamsDocument, options);
      }
export type EditSalesTeamsMutationHookResult = ReturnType<typeof useEditSalesTeamsMutation>;
export type EditSalesTeamsMutationResult = Apollo.MutationResult<EditSalesTeamsMutation>;
export type EditSalesTeamsMutationOptions = Apollo.BaseMutationOptions<EditSalesTeamsMutation, EditSalesTeamsMutationVariables>;
export const AddSalesTeamsDocument = gql`
    mutation addSalesTeams($input: TeamInput!) {
  addSalesTeams(input: $input)
}
    `;
export type AddSalesTeamsMutationFn = Apollo.MutationFunction<AddSalesTeamsMutation, AddSalesTeamsMutationVariables>;

/**
 * __useAddSalesTeamsMutation__
 *
 * To run a mutation, you first call `useAddSalesTeamsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSalesTeamsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSalesTeamsMutation, { data, loading, error }] = useAddSalesTeamsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddSalesTeamsMutation(baseOptions?: Apollo.MutationHookOptions<AddSalesTeamsMutation, AddSalesTeamsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSalesTeamsMutation, AddSalesTeamsMutationVariables>(AddSalesTeamsDocument, options);
      }
export type AddSalesTeamsMutationHookResult = ReturnType<typeof useAddSalesTeamsMutation>;
export type AddSalesTeamsMutationResult = Apollo.MutationResult<AddSalesTeamsMutation>;
export type AddSalesTeamsMutationOptions = Apollo.BaseMutationOptions<AddSalesTeamsMutation, AddSalesTeamsMutationVariables>;
export const DeleteSalesTeamByIdDocument = gql`
    mutation deleteSalesTeamById($teamId: String!) {
  deleteSalesTeamById(teamId: $teamId)
}
    `;
export type DeleteSalesTeamByIdMutationFn = Apollo.MutationFunction<DeleteSalesTeamByIdMutation, DeleteSalesTeamByIdMutationVariables>;

/**
 * __useDeleteSalesTeamByIdMutation__
 *
 * To run a mutation, you first call `useDeleteSalesTeamByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSalesTeamByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSalesTeamByIdMutation, { data, loading, error }] = useDeleteSalesTeamByIdMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useDeleteSalesTeamByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSalesTeamByIdMutation, DeleteSalesTeamByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSalesTeamByIdMutation, DeleteSalesTeamByIdMutationVariables>(DeleteSalesTeamByIdDocument, options);
      }
export type DeleteSalesTeamByIdMutationHookResult = ReturnType<typeof useDeleteSalesTeamByIdMutation>;
export type DeleteSalesTeamByIdMutationResult = Apollo.MutationResult<DeleteSalesTeamByIdMutation>;
export type DeleteSalesTeamByIdMutationOptions = Apollo.BaseMutationOptions<DeleteSalesTeamByIdMutation, DeleteSalesTeamByIdMutationVariables>;
export const GetAssignedTeamMembersDocument = gql`
    query getAssignedTeamMembers($teamId: String!) {
  getAssignedTeamMembers(teamId: $teamId) {
    ID
    name
    contactNo
    email
  }
}
    `;

/**
 * __useGetAssignedTeamMembersQuery__
 *
 * To run a query within a React component, call `useGetAssignedTeamMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignedTeamMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignedTeamMembersQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useGetAssignedTeamMembersQuery(baseOptions: Apollo.QueryHookOptions<GetAssignedTeamMembersQuery, GetAssignedTeamMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssignedTeamMembersQuery, GetAssignedTeamMembersQueryVariables>(GetAssignedTeamMembersDocument, options);
      }
export function useGetAssignedTeamMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssignedTeamMembersQuery, GetAssignedTeamMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssignedTeamMembersQuery, GetAssignedTeamMembersQueryVariables>(GetAssignedTeamMembersDocument, options);
        }
export type GetAssignedTeamMembersQueryHookResult = ReturnType<typeof useGetAssignedTeamMembersQuery>;
export type GetAssignedTeamMembersLazyQueryHookResult = ReturnType<typeof useGetAssignedTeamMembersLazyQuery>;
export type GetAssignedTeamMembersQueryResult = Apollo.QueryResult<GetAssignedTeamMembersQuery, GetAssignedTeamMembersQueryVariables>;
export const GetUnassignedTeamMembersDocument = gql`
    query getUnassignedTeamMembers($projectId: String!, $teamId: String!) {
  getUnassignedTeamMembers(projectId: $projectId, teamId: $teamId) {
    ID
    name
    contactNo
    email
  }
}
    `;

/**
 * __useGetUnassignedTeamMembersQuery__
 *
 * To run a query within a React component, call `useGetUnassignedTeamMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnassignedTeamMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnassignedTeamMembersQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useGetUnassignedTeamMembersQuery(baseOptions: Apollo.QueryHookOptions<GetUnassignedTeamMembersQuery, GetUnassignedTeamMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnassignedTeamMembersQuery, GetUnassignedTeamMembersQueryVariables>(GetUnassignedTeamMembersDocument, options);
      }
export function useGetUnassignedTeamMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnassignedTeamMembersQuery, GetUnassignedTeamMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnassignedTeamMembersQuery, GetUnassignedTeamMembersQueryVariables>(GetUnassignedTeamMembersDocument, options);
        }
export type GetUnassignedTeamMembersQueryHookResult = ReturnType<typeof useGetUnassignedTeamMembersQuery>;
export type GetUnassignedTeamMembersLazyQueryHookResult = ReturnType<typeof useGetUnassignedTeamMembersLazyQuery>;
export type GetUnassignedTeamMembersQueryResult = Apollo.QueryResult<GetUnassignedTeamMembersQuery, GetUnassignedTeamMembersQueryVariables>;
export const AssignTeamMemberDocument = gql`
    mutation assignTeamMember($projectId: String!, $teamId: String!, $userIds: [String!]!) {
  assignTeamMember(projectId: $projectId, teamId: $teamId, userIds: $userIds)
}
    `;
export type AssignTeamMemberMutationFn = Apollo.MutationFunction<AssignTeamMemberMutation, AssignTeamMemberMutationVariables>;

/**
 * __useAssignTeamMemberMutation__
 *
 * To run a mutation, you first call `useAssignTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignTeamMemberMutation, { data, loading, error }] = useAssignTeamMemberMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      teamId: // value for 'teamId'
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useAssignTeamMemberMutation(baseOptions?: Apollo.MutationHookOptions<AssignTeamMemberMutation, AssignTeamMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignTeamMemberMutation, AssignTeamMemberMutationVariables>(AssignTeamMemberDocument, options);
      }
export type AssignTeamMemberMutationHookResult = ReturnType<typeof useAssignTeamMemberMutation>;
export type AssignTeamMemberMutationResult = Apollo.MutationResult<AssignTeamMemberMutation>;
export type AssignTeamMemberMutationOptions = Apollo.BaseMutationOptions<AssignTeamMemberMutation, AssignTeamMemberMutationVariables>;
export const UnassignTeamMemberDocument = gql`
    mutation unassignTeamMember($teamId: String!, $userIds: [String!]!) {
  unassignTeamMember(teamId: $teamId, userIds: $userIds)
}
    `;
export type UnassignTeamMemberMutationFn = Apollo.MutationFunction<UnassignTeamMemberMutation, UnassignTeamMemberMutationVariables>;

/**
 * __useUnassignTeamMemberMutation__
 *
 * To run a mutation, you first call `useUnassignTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignTeamMemberMutation, { data, loading, error }] = useUnassignTeamMemberMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useUnassignTeamMemberMutation(baseOptions?: Apollo.MutationHookOptions<UnassignTeamMemberMutation, UnassignTeamMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnassignTeamMemberMutation, UnassignTeamMemberMutationVariables>(UnassignTeamMemberDocument, options);
      }
export type UnassignTeamMemberMutationHookResult = ReturnType<typeof useUnassignTeamMemberMutation>;
export type UnassignTeamMemberMutationResult = Apollo.MutationResult<UnassignTeamMemberMutation>;
export type UnassignTeamMemberMutationOptions = Apollo.BaseMutationOptions<UnassignTeamMemberMutation, UnassignTeamMemberMutationVariables>;
export const GetPriceAdjustmentListDocument = gql`
    query getPriceAdjustmentList($projectId: String!, $statusFilter: [String!]) {
  getPriceAdjustmentList(projectId: $projectId, statusFilter: $statusFilter) {
    id
    name
    remark
    status
    approvalRoleId
    unitCount
    submitUserData {
      ID
      name
    }
  }
}
    `;

/**
 * __useGetPriceAdjustmentListQuery__
 *
 * To run a query within a React component, call `useGetPriceAdjustmentListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPriceAdjustmentListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPriceAdjustmentListQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      statusFilter: // value for 'statusFilter'
 *   },
 * });
 */
export function useGetPriceAdjustmentListQuery(baseOptions: Apollo.QueryHookOptions<GetPriceAdjustmentListQuery, GetPriceAdjustmentListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPriceAdjustmentListQuery, GetPriceAdjustmentListQueryVariables>(GetPriceAdjustmentListDocument, options);
      }
export function useGetPriceAdjustmentListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPriceAdjustmentListQuery, GetPriceAdjustmentListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPriceAdjustmentListQuery, GetPriceAdjustmentListQueryVariables>(GetPriceAdjustmentListDocument, options);
        }
export type GetPriceAdjustmentListQueryHookResult = ReturnType<typeof useGetPriceAdjustmentListQuery>;
export type GetPriceAdjustmentListLazyQueryHookResult = ReturnType<typeof useGetPriceAdjustmentListLazyQuery>;
export type GetPriceAdjustmentListQueryResult = Apollo.QueryResult<GetPriceAdjustmentListQuery, GetPriceAdjustmentListQueryVariables>;
export const GetPriceAdjustmentByIdDocument = gql`
    query getPriceAdjustmentById($projectId: String!, $id: String!) {
  getPriceAdjustmentById(projectId: $projectId, id: $id) {
    id
    name
    computationMode
    computationValue
    roundingMode
    roundingPrecision
    displayRoundingMode
    displayRoundingPrecision
    reason
    remark
    status
    approvalRoleId
    priceAdjustmentUnit {
      id
      newUnitListPrice
      unitListPrice
      unitNo
      unitId
    }
    defaultReason {
      id
      name
    }
  }
}
    `;

/**
 * __useGetPriceAdjustmentByIdQuery__
 *
 * To run a query within a React component, call `useGetPriceAdjustmentByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPriceAdjustmentByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPriceAdjustmentByIdQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPriceAdjustmentByIdQuery(baseOptions: Apollo.QueryHookOptions<GetPriceAdjustmentByIdQuery, GetPriceAdjustmentByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPriceAdjustmentByIdQuery, GetPriceAdjustmentByIdQueryVariables>(GetPriceAdjustmentByIdDocument, options);
      }
export function useGetPriceAdjustmentByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPriceAdjustmentByIdQuery, GetPriceAdjustmentByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPriceAdjustmentByIdQuery, GetPriceAdjustmentByIdQueryVariables>(GetPriceAdjustmentByIdDocument, options);
        }
export type GetPriceAdjustmentByIdQueryHookResult = ReturnType<typeof useGetPriceAdjustmentByIdQuery>;
export type GetPriceAdjustmentByIdLazyQueryHookResult = ReturnType<typeof useGetPriceAdjustmentByIdLazyQuery>;
export type GetPriceAdjustmentByIdQueryResult = Apollo.QueryResult<GetPriceAdjustmentByIdQuery, GetPriceAdjustmentByIdQueryVariables>;
export const AddPriceAdjustmentDocument = gql`
    mutation addPriceAdjustment($input: AddPriceAdjustmentInput!) {
  addPriceAdjustment(input: $input)
}
    `;
export type AddPriceAdjustmentMutationFn = Apollo.MutationFunction<AddPriceAdjustmentMutation, AddPriceAdjustmentMutationVariables>;

/**
 * __useAddPriceAdjustmentMutation__
 *
 * To run a mutation, you first call `useAddPriceAdjustmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPriceAdjustmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPriceAdjustmentMutation, { data, loading, error }] = useAddPriceAdjustmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPriceAdjustmentMutation(baseOptions?: Apollo.MutationHookOptions<AddPriceAdjustmentMutation, AddPriceAdjustmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPriceAdjustmentMutation, AddPriceAdjustmentMutationVariables>(AddPriceAdjustmentDocument, options);
      }
export type AddPriceAdjustmentMutationHookResult = ReturnType<typeof useAddPriceAdjustmentMutation>;
export type AddPriceAdjustmentMutationResult = Apollo.MutationResult<AddPriceAdjustmentMutation>;
export type AddPriceAdjustmentMutationOptions = Apollo.BaseMutationOptions<AddPriceAdjustmentMutation, AddPriceAdjustmentMutationVariables>;
export const EditPriceAdjustmentDocument = gql`
    mutation editPriceAdjustment($input: EditPriceAdjustmentInput!) {
  editPriceAdjustment(input: $input)
}
    `;
export type EditPriceAdjustmentMutationFn = Apollo.MutationFunction<EditPriceAdjustmentMutation, EditPriceAdjustmentMutationVariables>;

/**
 * __useEditPriceAdjustmentMutation__
 *
 * To run a mutation, you first call `useEditPriceAdjustmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPriceAdjustmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPriceAdjustmentMutation, { data, loading, error }] = useEditPriceAdjustmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditPriceAdjustmentMutation(baseOptions?: Apollo.MutationHookOptions<EditPriceAdjustmentMutation, EditPriceAdjustmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditPriceAdjustmentMutation, EditPriceAdjustmentMutationVariables>(EditPriceAdjustmentDocument, options);
      }
export type EditPriceAdjustmentMutationHookResult = ReturnType<typeof useEditPriceAdjustmentMutation>;
export type EditPriceAdjustmentMutationResult = Apollo.MutationResult<EditPriceAdjustmentMutation>;
export type EditPriceAdjustmentMutationOptions = Apollo.BaseMutationOptions<EditPriceAdjustmentMutation, EditPriceAdjustmentMutationVariables>;
export const GetSelectUnitAtPriceAdjustmentDocument = gql`
    query getSelectUnitAtPriceAdjustment($projectId: String!, $id: String) {
  getSelectUnitAtPriceAdjustment(projectId: $projectId, id: $id) {
    block
    totalFloor
    floorList {
      floorLabel
      totalUnit
      unitList {
        unitId
        unitNo
      }
    }
  }
}
    `;

/**
 * __useGetSelectUnitAtPriceAdjustmentQuery__
 *
 * To run a query within a React component, call `useGetSelectUnitAtPriceAdjustmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSelectUnitAtPriceAdjustmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSelectUnitAtPriceAdjustmentQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSelectUnitAtPriceAdjustmentQuery(baseOptions: Apollo.QueryHookOptions<GetSelectUnitAtPriceAdjustmentQuery, GetSelectUnitAtPriceAdjustmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSelectUnitAtPriceAdjustmentQuery, GetSelectUnitAtPriceAdjustmentQueryVariables>(GetSelectUnitAtPriceAdjustmentDocument, options);
      }
export function useGetSelectUnitAtPriceAdjustmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSelectUnitAtPriceAdjustmentQuery, GetSelectUnitAtPriceAdjustmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSelectUnitAtPriceAdjustmentQuery, GetSelectUnitAtPriceAdjustmentQueryVariables>(GetSelectUnitAtPriceAdjustmentDocument, options);
        }
export type GetSelectUnitAtPriceAdjustmentQueryHookResult = ReturnType<typeof useGetSelectUnitAtPriceAdjustmentQuery>;
export type GetSelectUnitAtPriceAdjustmentLazyQueryHookResult = ReturnType<typeof useGetSelectUnitAtPriceAdjustmentLazyQuery>;
export type GetSelectUnitAtPriceAdjustmentQueryResult = Apollo.QueryResult<GetSelectUnitAtPriceAdjustmentQuery, GetSelectUnitAtPriceAdjustmentQueryVariables>;
export const UpdatePriceAdjustmentStatusDocument = gql`
    mutation updatePriceAdjustmentStatus($projectId: String!, $isApproved: Boolean!, $sourceIds: [String!]!) {
  updatePriceAdjustmentStatus(projectId: $projectId, isApproved: $isApproved, sourceIds: $sourceIds)
}
    `;
export type UpdatePriceAdjustmentStatusMutationFn = Apollo.MutationFunction<UpdatePriceAdjustmentStatusMutation, UpdatePriceAdjustmentStatusMutationVariables>;

/**
 * __useUpdatePriceAdjustmentStatusMutation__
 *
 * To run a mutation, you first call `useUpdatePriceAdjustmentStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePriceAdjustmentStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePriceAdjustmentStatusMutation, { data, loading, error }] = useUpdatePriceAdjustmentStatusMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      isApproved: // value for 'isApproved'
 *      sourceIds: // value for 'sourceIds'
 *   },
 * });
 */
export function useUpdatePriceAdjustmentStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePriceAdjustmentStatusMutation, UpdatePriceAdjustmentStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePriceAdjustmentStatusMutation, UpdatePriceAdjustmentStatusMutationVariables>(UpdatePriceAdjustmentStatusDocument, options);
      }
export type UpdatePriceAdjustmentStatusMutationHookResult = ReturnType<typeof useUpdatePriceAdjustmentStatusMutation>;
export type UpdatePriceAdjustmentStatusMutationResult = Apollo.MutationResult<UpdatePriceAdjustmentStatusMutation>;
export type UpdatePriceAdjustmentStatusMutationOptions = Apollo.BaseMutationOptions<UpdatePriceAdjustmentStatusMutation, UpdatePriceAdjustmentStatusMutationVariables>;
export const GetReasonListDocument = gql`
    query getReasonList {
  getReasonList {
    id
    name
  }
}
    `;

/**
 * __useGetReasonListQuery__
 *
 * To run a query within a React component, call `useGetReasonListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReasonListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReasonListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReasonListQuery(baseOptions?: Apollo.QueryHookOptions<GetReasonListQuery, GetReasonListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReasonListQuery, GetReasonListQueryVariables>(GetReasonListDocument, options);
      }
export function useGetReasonListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReasonListQuery, GetReasonListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReasonListQuery, GetReasonListQueryVariables>(GetReasonListDocument, options);
        }
export type GetReasonListQueryHookResult = ReturnType<typeof useGetReasonListQuery>;
export type GetReasonListLazyQueryHookResult = ReturnType<typeof useGetReasonListLazyQuery>;
export type GetReasonListQueryResult = Apollo.QueryResult<GetReasonListQuery, GetReasonListQueryVariables>;
export const SoftDeletePriceAdjustmentDocument = gql`
    mutation softDeletePriceAdjustment($id: String!) {
  softDeletePriceAdjustment(id: $id)
}
    `;
export type SoftDeletePriceAdjustmentMutationFn = Apollo.MutationFunction<SoftDeletePriceAdjustmentMutation, SoftDeletePriceAdjustmentMutationVariables>;

/**
 * __useSoftDeletePriceAdjustmentMutation__
 *
 * To run a mutation, you first call `useSoftDeletePriceAdjustmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftDeletePriceAdjustmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softDeletePriceAdjustmentMutation, { data, loading, error }] = useSoftDeletePriceAdjustmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSoftDeletePriceAdjustmentMutation(baseOptions?: Apollo.MutationHookOptions<SoftDeletePriceAdjustmentMutation, SoftDeletePriceAdjustmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SoftDeletePriceAdjustmentMutation, SoftDeletePriceAdjustmentMutationVariables>(SoftDeletePriceAdjustmentDocument, options);
      }
export type SoftDeletePriceAdjustmentMutationHookResult = ReturnType<typeof useSoftDeletePriceAdjustmentMutation>;
export type SoftDeletePriceAdjustmentMutationResult = Apollo.MutationResult<SoftDeletePriceAdjustmentMutation>;
export type SoftDeletePriceAdjustmentMutationOptions = Apollo.BaseMutationOptions<SoftDeletePriceAdjustmentMutation, SoftDeletePriceAdjustmentMutationVariables>;
export const GetBlockByProjectDocument = gql`
    query GetBlockByProject($ProjectId: String!, $SubproductStatus: Boolean!) {
  GetBlockByProject(ProjectId: $ProjectId, SubproductStatus: $SubproductStatus) {
    blocks
    integrated
  }
}
    `;

/**
 * __useGetBlockByProjectQuery__
 *
 * To run a query within a React component, call `useGetBlockByProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlockByProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBlockByProjectQuery({
 *   variables: {
 *      ProjectId: // value for 'ProjectId'
 *      SubproductStatus: // value for 'SubproductStatus'
 *   },
 * });
 */
export function useGetBlockByProjectQuery(baseOptions: Apollo.QueryHookOptions<GetBlockByProjectQuery, GetBlockByProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBlockByProjectQuery, GetBlockByProjectQueryVariables>(GetBlockByProjectDocument, options);
      }
export function useGetBlockByProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBlockByProjectQuery, GetBlockByProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBlockByProjectQuery, GetBlockByProjectQueryVariables>(GetBlockByProjectDocument, options);
        }
export type GetBlockByProjectQueryHookResult = ReturnType<typeof useGetBlockByProjectQuery>;
export type GetBlockByProjectLazyQueryHookResult = ReturnType<typeof useGetBlockByProjectLazyQuery>;
export type GetBlockByProjectQueryResult = Apollo.QueryResult<GetBlockByProjectQuery, GetBlockByProjectQueryVariables>;
export const GetUnitByProjectBlockDocument = gql`
    query GetUnitByProjectBlock($ProjectId: String!, $Block: String!) {
  GetUnitByProjectBlock(ProjectId: $ProjectId, Block: $Block) {
    id
    unitNo
    phase
    unitTypeId
    unitLayoutId
    unitLayoutDes
    facingDirectionId
    block
    floor
    floorLabel
    builtUp
    landArea
    extraLandArea
    facingDirection {
      id
      name
    }
    facingView
    price
    timeLock
    cell
    hsdNo
    ptdNo
    isBumi
    commonStatus
    unitStatus
    unitLockBy
    unitType {
      id
      name
      seq_no
    }
    unitLayout {
      desc
    }
  }
}
    `;

/**
 * __useGetUnitByProjectBlockQuery__
 *
 * To run a query within a React component, call `useGetUnitByProjectBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitByProjectBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitByProjectBlockQuery({
 *   variables: {
 *      ProjectId: // value for 'ProjectId'
 *      Block: // value for 'Block'
 *   },
 * });
 */
export function useGetUnitByProjectBlockQuery(baseOptions: Apollo.QueryHookOptions<GetUnitByProjectBlockQuery, GetUnitByProjectBlockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitByProjectBlockQuery, GetUnitByProjectBlockQueryVariables>(GetUnitByProjectBlockDocument, options);
      }
export function useGetUnitByProjectBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitByProjectBlockQuery, GetUnitByProjectBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitByProjectBlockQuery, GetUnitByProjectBlockQueryVariables>(GetUnitByProjectBlockDocument, options);
        }
export type GetUnitByProjectBlockQueryHookResult = ReturnType<typeof useGetUnitByProjectBlockQuery>;
export type GetUnitByProjectBlockLazyQueryHookResult = ReturnType<typeof useGetUnitByProjectBlockLazyQuery>;
export type GetUnitByProjectBlockQueryResult = Apollo.QueryResult<GetUnitByProjectBlockQuery, GetUnitByProjectBlockQueryVariables>;
export const GetAllPropertyUnitTypeDocument = gql`
    query getAllPropertyUnitType {
  getAllPropertyType {
    id
    name
    commercialPurposeDesc
  }
  getAllUnitType {
    id
    name
  }
}
    `;

/**
 * __useGetAllPropertyUnitTypeQuery__
 *
 * To run a query within a React component, call `useGetAllPropertyUnitTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPropertyUnitTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPropertyUnitTypeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllPropertyUnitTypeQuery(baseOptions?: Apollo.QueryHookOptions<GetAllPropertyUnitTypeQuery, GetAllPropertyUnitTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllPropertyUnitTypeQuery, GetAllPropertyUnitTypeQueryVariables>(GetAllPropertyUnitTypeDocument, options);
      }
export function useGetAllPropertyUnitTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllPropertyUnitTypeQuery, GetAllPropertyUnitTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllPropertyUnitTypeQuery, GetAllPropertyUnitTypeQueryVariables>(GetAllPropertyUnitTypeDocument, options);
        }
export type GetAllPropertyUnitTypeQueryHookResult = ReturnType<typeof useGetAllPropertyUnitTypeQuery>;
export type GetAllPropertyUnitTypeLazyQueryHookResult = ReturnType<typeof useGetAllPropertyUnitTypeLazyQuery>;
export type GetAllPropertyUnitTypeQueryResult = Apollo.QueryResult<GetAllPropertyUnitTypeQuery, GetAllPropertyUnitTypeQueryVariables>;
export const GetAllUnitProjectDocument = gql`
    query GetAllUnitProject($projectId: String!) {
  GetAllUnitProject(projectId: $projectId)
}
    `;

/**
 * __useGetAllUnitProjectQuery__
 *
 * To run a query within a React component, call `useGetAllUnitProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllUnitProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllUnitProjectQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetAllUnitProjectQuery(baseOptions: Apollo.QueryHookOptions<GetAllUnitProjectQuery, GetAllUnitProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllUnitProjectQuery, GetAllUnitProjectQueryVariables>(GetAllUnitProjectDocument, options);
      }
export function useGetAllUnitProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllUnitProjectQuery, GetAllUnitProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllUnitProjectQuery, GetAllUnitProjectQueryVariables>(GetAllUnitProjectDocument, options);
        }
export type GetAllUnitProjectQueryHookResult = ReturnType<typeof useGetAllUnitProjectQuery>;
export type GetAllUnitProjectLazyQueryHookResult = ReturnType<typeof useGetAllUnitProjectLazyQuery>;
export type GetAllUnitProjectQueryResult = Apollo.QueryResult<GetAllUnitProjectQuery, GetAllUnitProjectQueryVariables>;
export const GetAllFloorByBlockDocument = gql`
    query getAllFloorByBlock($projectId: String!, $block: String!, $subproductStatus: Boolean!) {
  getAllFloorByBlock(block: $block, projectId: $projectId, subproductStatus: $subproductStatus) {
    cellList
    availableUnitCount
    signUnitCount
    soldUnitCount
    unavailableUnitCount
    floorList {
      floorLabel
      unitList {
        unitId
        unitNo
        unitCell
        unitFloor
        unitStatus
        unitFloorLabel
        commonStatus
        isBumi
      }
    }
  }
}
    `;

/**
 * __useGetAllFloorByBlockQuery__
 *
 * To run a query within a React component, call `useGetAllFloorByBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllFloorByBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllFloorByBlockQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      block: // value for 'block'
 *      subproductStatus: // value for 'subproductStatus'
 *   },
 * });
 */
export function useGetAllFloorByBlockQuery(baseOptions: Apollo.QueryHookOptions<GetAllFloorByBlockQuery, GetAllFloorByBlockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllFloorByBlockQuery, GetAllFloorByBlockQueryVariables>(GetAllFloorByBlockDocument, options);
      }
export function useGetAllFloorByBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllFloorByBlockQuery, GetAllFloorByBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllFloorByBlockQuery, GetAllFloorByBlockQueryVariables>(GetAllFloorByBlockDocument, options);
        }
export type GetAllFloorByBlockQueryHookResult = ReturnType<typeof useGetAllFloorByBlockQuery>;
export type GetAllFloorByBlockLazyQueryHookResult = ReturnType<typeof useGetAllFloorByBlockLazyQuery>;
export type GetAllFloorByBlockQueryResult = Apollo.QueryResult<GetAllFloorByBlockQuery, GetAllFloorByBlockQueryVariables>;
export const ExportExcelDocument = gql`
    query exportExcel($projectId: String!, $exportType: String!) {
  exportExcel(projectId: $projectId, exportType: $exportType) {
    base64
    projectname
  }
}
    `;

/**
 * __useExportExcelQuery__
 *
 * To run a query within a React component, call `useExportExcelQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportExcelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportExcelQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      exportType: // value for 'exportType'
 *   },
 * });
 */
export function useExportExcelQuery(baseOptions: Apollo.QueryHookOptions<ExportExcelQuery, ExportExcelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportExcelQuery, ExportExcelQueryVariables>(ExportExcelDocument, options);
      }
export function useExportExcelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportExcelQuery, ExportExcelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportExcelQuery, ExportExcelQueryVariables>(ExportExcelDocument, options);
        }
export type ExportExcelQueryHookResult = ReturnType<typeof useExportExcelQuery>;
export type ExportExcelLazyQueryHookResult = ReturnType<typeof useExportExcelLazyQuery>;
export type ExportExcelQueryResult = Apollo.QueryResult<ExportExcelQuery, ExportExcelQueryVariables>;
export const ImportExcelDocument = gql`
    query importExcel($file: Upload!, $projectId: String!, $method: String!, $importType: String!) {
  importExcel(file: $file, projectId: $projectId, method: $method, importType: $importType) {
    message
    file_name
    file
  }
}
    `;

/**
 * __useImportExcelQuery__
 *
 * To run a query within a React component, call `useImportExcelQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportExcelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportExcelQuery({
 *   variables: {
 *      file: // value for 'file'
 *      projectId: // value for 'projectId'
 *      method: // value for 'method'
 *      importType: // value for 'importType'
 *   },
 * });
 */
export function useImportExcelQuery(baseOptions: Apollo.QueryHookOptions<ImportExcelQuery, ImportExcelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImportExcelQuery, ImportExcelQueryVariables>(ImportExcelDocument, options);
      }
export function useImportExcelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImportExcelQuery, ImportExcelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImportExcelQuery, ImportExcelQueryVariables>(ImportExcelDocument, options);
        }
export type ImportExcelQueryHookResult = ReturnType<typeof useImportExcelQuery>;
export type ImportExcelLazyQueryHookResult = ReturnType<typeof useImportExcelLazyQuery>;
export type ImportExcelQueryResult = Apollo.QueryResult<ImportExcelQuery, ImportExcelQueryVariables>;
export const ImportUnitOptionsDocument = gql`
    query ImportUnitOptions($projectId: String!, $checkType: String!) {
  ImportUnitOptions(projectId: $projectId, checkType: $checkType) {
    displayImportMethods
    overwrite
    append
    modify
    emptyProject
  }
}
    `;

/**
 * __useImportUnitOptionsQuery__
 *
 * To run a query within a React component, call `useImportUnitOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportUnitOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportUnitOptionsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      checkType: // value for 'checkType'
 *   },
 * });
 */
export function useImportUnitOptionsQuery(baseOptions: Apollo.QueryHookOptions<ImportUnitOptionsQuery, ImportUnitOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImportUnitOptionsQuery, ImportUnitOptionsQueryVariables>(ImportUnitOptionsDocument, options);
      }
export function useImportUnitOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImportUnitOptionsQuery, ImportUnitOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImportUnitOptionsQuery, ImportUnitOptionsQueryVariables>(ImportUnitOptionsDocument, options);
        }
export type ImportUnitOptionsQueryHookResult = ReturnType<typeof useImportUnitOptionsQuery>;
export type ImportUnitOptionsLazyQueryHookResult = ReturnType<typeof useImportUnitOptionsLazyQuery>;
export type ImportUnitOptionsQueryResult = Apollo.QueryResult<ImportUnitOptionsQuery, ImportUnitOptionsQueryVariables>;
export const GetUnitMasterDataDocument = gql`
    query getUnitMasterData($projectId: String!) {
  getUnitMasterData(projectId: $projectId) {
    propertyType {
      id
      name
    }
    paymentPlan {
      id
      name
    }
    direction {
      id
      name
    }
    unitType {
      id
      name
    }
    unitLayout {
      id
      name
    }
    solicitor {
      id
      name
      solicitorCode
    }
    cluster {
      id
      name
    }
    taxScheme {
      id
      name
    }
  }
}
    `;

/**
 * __useGetUnitMasterDataQuery__
 *
 * To run a query within a React component, call `useGetUnitMasterDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitMasterDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitMasterDataQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetUnitMasterDataQuery(baseOptions: Apollo.QueryHookOptions<GetUnitMasterDataQuery, GetUnitMasterDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitMasterDataQuery, GetUnitMasterDataQueryVariables>(GetUnitMasterDataDocument, options);
      }
export function useGetUnitMasterDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitMasterDataQuery, GetUnitMasterDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitMasterDataQuery, GetUnitMasterDataQueryVariables>(GetUnitMasterDataDocument, options);
        }
export type GetUnitMasterDataQueryHookResult = ReturnType<typeof useGetUnitMasterDataQuery>;
export type GetUnitMasterDataLazyQueryHookResult = ReturnType<typeof useGetUnitMasterDataLazyQuery>;
export type GetUnitMasterDataQueryResult = Apollo.QueryResult<GetUnitMasterDataQuery, GetUnitMasterDataQueryVariables>;
export const GenerateUnitDocument = gql`
    mutation generateUnit($input: generateUnitInput!) {
  generateUnit(input: $input)
}
    `;
export type GenerateUnitMutationFn = Apollo.MutationFunction<GenerateUnitMutation, GenerateUnitMutationVariables>;

/**
 * __useGenerateUnitMutation__
 *
 * To run a mutation, you first call `useGenerateUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateUnitMutation, { data, loading, error }] = useGenerateUnitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateUnitMutation(baseOptions?: Apollo.MutationHookOptions<GenerateUnitMutation, GenerateUnitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateUnitMutation, GenerateUnitMutationVariables>(GenerateUnitDocument, options);
      }
export type GenerateUnitMutationHookResult = ReturnType<typeof useGenerateUnitMutation>;
export type GenerateUnitMutationResult = Apollo.MutationResult<GenerateUnitMutation>;
export type GenerateUnitMutationOptions = Apollo.BaseMutationOptions<GenerateUnitMutation, GenerateUnitMutationVariables>;
export const EditUnitInformationDocument = gql`
    mutation editUnitInformation($input: editUnitInformationInput!) {
  editUnitInformation(input: $input)
}
    `;
export type EditUnitInformationMutationFn = Apollo.MutationFunction<EditUnitInformationMutation, EditUnitInformationMutationVariables>;

/**
 * __useEditUnitInformationMutation__
 *
 * To run a mutation, you first call `useEditUnitInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditUnitInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editUnitInformationMutation, { data, loading, error }] = useEditUnitInformationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditUnitInformationMutation(baseOptions?: Apollo.MutationHookOptions<EditUnitInformationMutation, EditUnitInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditUnitInformationMutation, EditUnitInformationMutationVariables>(EditUnitInformationDocument, options);
      }
export type EditUnitInformationMutationHookResult = ReturnType<typeof useEditUnitInformationMutation>;
export type EditUnitInformationMutationResult = Apollo.MutationResult<EditUnitInformationMutation>;
export type EditUnitInformationMutationOptions = Apollo.BaseMutationOptions<EditUnitInformationMutation, EditUnitInformationMutationVariables>;
export const DeleteSelectedUnitsDocument = gql`
    mutation deleteSelectedUnits($input: deleteUnitInput!) {
  deleteSelectedUnits(input: $input)
}
    `;
export type DeleteSelectedUnitsMutationFn = Apollo.MutationFunction<DeleteSelectedUnitsMutation, DeleteSelectedUnitsMutationVariables>;

/**
 * __useDeleteSelectedUnitsMutation__
 *
 * To run a mutation, you first call `useDeleteSelectedUnitsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSelectedUnitsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSelectedUnitsMutation, { data, loading, error }] = useDeleteSelectedUnitsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSelectedUnitsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSelectedUnitsMutation, DeleteSelectedUnitsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSelectedUnitsMutation, DeleteSelectedUnitsMutationVariables>(DeleteSelectedUnitsDocument, options);
      }
export type DeleteSelectedUnitsMutationHookResult = ReturnType<typeof useDeleteSelectedUnitsMutation>;
export type DeleteSelectedUnitsMutationResult = Apollo.MutationResult<DeleteSelectedUnitsMutation>;
export type DeleteSelectedUnitsMutationOptions = Apollo.BaseMutationOptions<DeleteSelectedUnitsMutation, DeleteSelectedUnitsMutationVariables>;
export const GetUnitByIdDocument = gql`
    query getUnitByID($unitId: String!) {
  getUnitByID(unitId: $unitId) {
    id
    unitNo
    block
    floor
    floorLabel
    price
    bottomPrice
    builtUp
    landArea
    extraLandArea
    facingView
    isBumi
    phase
    propertyType {
      name
    }
    facingDirection {
      name
    }
    unitType {
      name
    }
    unitLayout {
      desc
    }
    units {
      unitNo
    }
    unitExt {
      landAreaRate
      usableArea
      noOfStorey
      dlpExpiryDate
      scheduleLaunchDate
      actualBuiltUpArea
      builtUpAreaRate
      actualLandArea
      shareValue
      lotPtNo
      hsdHsmNo
      masterGrantNo
      district
      subdivisionMukim
      leasePejakanNegeri
      noOfKey
      remark
      bumiReleaseDate
      bumiReleaseReferenceNo
      dlp1Date
      dlp2Date
      premium
      bumiAllocation
      stampDutyWaiver
      unitAddress {
        address
        country
        city
        state
        postCode
      }
      projectCluster {
        name
      }
      paymentPlan {
        name
      }
      lawyer {
        name
      }
      stakeholder {
        name
      }
      bookingFee
    }
  }
}
    `;

/**
 * __useGetUnitByIdQuery__
 *
 * To run a query within a React component, call `useGetUnitByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitByIdQuery({
 *   variables: {
 *      unitId: // value for 'unitId'
 *   },
 * });
 */
export function useGetUnitByIdQuery(baseOptions: Apollo.QueryHookOptions<GetUnitByIdQuery, GetUnitByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitByIdQuery, GetUnitByIdQueryVariables>(GetUnitByIdDocument, options);
      }
export function useGetUnitByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitByIdQuery, GetUnitByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitByIdQuery, GetUnitByIdQueryVariables>(GetUnitByIdDocument, options);
        }
export type GetUnitByIdQueryHookResult = ReturnType<typeof useGetUnitByIdQuery>;
export type GetUnitByIdLazyQueryHookResult = ReturnType<typeof useGetUnitByIdLazyQuery>;
export type GetUnitByIdQueryResult = Apollo.QueryResult<GetUnitByIdQuery, GetUnitByIdQueryVariables>;
export const EditBlockLabelDocument = gql`
    mutation editBlockLabel($input: EditBlockInput!) {
  editBlockLabel(input: $input)
}
    `;
export type EditBlockLabelMutationFn = Apollo.MutationFunction<EditBlockLabelMutation, EditBlockLabelMutationVariables>;

/**
 * __useEditBlockLabelMutation__
 *
 * To run a mutation, you first call `useEditBlockLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditBlockLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editBlockLabelMutation, { data, loading, error }] = useEditBlockLabelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditBlockLabelMutation(baseOptions?: Apollo.MutationHookOptions<EditBlockLabelMutation, EditBlockLabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditBlockLabelMutation, EditBlockLabelMutationVariables>(EditBlockLabelDocument, options);
      }
export type EditBlockLabelMutationHookResult = ReturnType<typeof useEditBlockLabelMutation>;
export type EditBlockLabelMutationResult = Apollo.MutationResult<EditBlockLabelMutation>;
export type EditBlockLabelMutationOptions = Apollo.BaseMutationOptions<EditBlockLabelMutation, EditBlockLabelMutationVariables>;
export const GetUnitNoPrefixDocument = gql`
    query getUnitNoPrefix {
  getUnitNoPrefix
}
    `;

/**
 * __useGetUnitNoPrefixQuery__
 *
 * To run a query within a React component, call `useGetUnitNoPrefixQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitNoPrefixQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitNoPrefixQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUnitNoPrefixQuery(baseOptions?: Apollo.QueryHookOptions<GetUnitNoPrefixQuery, GetUnitNoPrefixQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitNoPrefixQuery, GetUnitNoPrefixQueryVariables>(GetUnitNoPrefixDocument, options);
      }
export function useGetUnitNoPrefixLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitNoPrefixQuery, GetUnitNoPrefixQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitNoPrefixQuery, GetUnitNoPrefixQueryVariables>(GetUnitNoPrefixDocument, options);
        }
export type GetUnitNoPrefixQueryHookResult = ReturnType<typeof useGetUnitNoPrefixQuery>;
export type GetUnitNoPrefixLazyQueryHookResult = ReturnType<typeof useGetUnitNoPrefixLazyQuery>;
export type GetUnitNoPrefixQueryResult = Apollo.QueryResult<GetUnitNoPrefixQuery, GetUnitNoPrefixQueryVariables>;
export const GetUnitStatutoryDocsListDocument = gql`
    query getUnitStatutoryDocsList {
  getUnitStatutoryDocsList {
    id
    docCnt
    unitNo
    statutoryDocId
    statutoryDocName
    statutoryDocCode
    clusterName
  }
}
    `;

/**
 * __useGetUnitStatutoryDocsListQuery__
 *
 * To run a query within a React component, call `useGetUnitStatutoryDocsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitStatutoryDocsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitStatutoryDocsListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUnitStatutoryDocsListQuery(baseOptions?: Apollo.QueryHookOptions<GetUnitStatutoryDocsListQuery, GetUnitStatutoryDocsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitStatutoryDocsListQuery, GetUnitStatutoryDocsListQueryVariables>(GetUnitStatutoryDocsListDocument, options);
      }
export function useGetUnitStatutoryDocsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitStatutoryDocsListQuery, GetUnitStatutoryDocsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitStatutoryDocsListQuery, GetUnitStatutoryDocsListQueryVariables>(GetUnitStatutoryDocsListDocument, options);
        }
export type GetUnitStatutoryDocsListQueryHookResult = ReturnType<typeof useGetUnitStatutoryDocsListQuery>;
export type GetUnitStatutoryDocsListLazyQueryHookResult = ReturnType<typeof useGetUnitStatutoryDocsListLazyQuery>;
export type GetUnitStatutoryDocsListQueryResult = Apollo.QueryResult<GetUnitStatutoryDocsListQuery, GetUnitStatutoryDocsListQueryVariables>;
export const GetUnitPropertyTitleListDocument = gql`
    query getUnitPropertyTitleList($projectId: String!) {
  getUnitPropertyTitleList(projectId: $projectId) {
    block
    totalFloor
    floorList {
      floorLabel
      totalUnit
      unitList {
        unitId
        unitNo
      }
    }
  }
}
    `;

/**
 * __useGetUnitPropertyTitleListQuery__
 *
 * To run a query within a React component, call `useGetUnitPropertyTitleListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitPropertyTitleListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitPropertyTitleListQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetUnitPropertyTitleListQuery(baseOptions: Apollo.QueryHookOptions<GetUnitPropertyTitleListQuery, GetUnitPropertyTitleListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitPropertyTitleListQuery, GetUnitPropertyTitleListQueryVariables>(GetUnitPropertyTitleListDocument, options);
      }
export function useGetUnitPropertyTitleListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitPropertyTitleListQuery, GetUnitPropertyTitleListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitPropertyTitleListQuery, GetUnitPropertyTitleListQueryVariables>(GetUnitPropertyTitleListDocument, options);
        }
export type GetUnitPropertyTitleListQueryHookResult = ReturnType<typeof useGetUnitPropertyTitleListQuery>;
export type GetUnitPropertyTitleListLazyQueryHookResult = ReturnType<typeof useGetUnitPropertyTitleListLazyQuery>;
export type GetUnitPropertyTitleListQueryResult = Apollo.QueryResult<GetUnitPropertyTitleListQuery, GetUnitPropertyTitleListQueryVariables>;
export const AddUnitStatutoryDocumentDocument = gql`
    mutation addUnitStatutoryDocument($input: AddUnitStatutoryDocumentIndoInput!) {
  addUnitStatutoryDocument(input: $input)
}
    `;
export type AddUnitStatutoryDocumentMutationFn = Apollo.MutationFunction<AddUnitStatutoryDocumentMutation, AddUnitStatutoryDocumentMutationVariables>;

/**
 * __useAddUnitStatutoryDocumentMutation__
 *
 * To run a mutation, you first call `useAddUnitStatutoryDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUnitStatutoryDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUnitStatutoryDocumentMutation, { data, loading, error }] = useAddUnitStatutoryDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddUnitStatutoryDocumentMutation(baseOptions?: Apollo.MutationHookOptions<AddUnitStatutoryDocumentMutation, AddUnitStatutoryDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUnitStatutoryDocumentMutation, AddUnitStatutoryDocumentMutationVariables>(AddUnitStatutoryDocumentDocument, options);
      }
export type AddUnitStatutoryDocumentMutationHookResult = ReturnType<typeof useAddUnitStatutoryDocumentMutation>;
export type AddUnitStatutoryDocumentMutationResult = Apollo.MutationResult<AddUnitStatutoryDocumentMutation>;
export type AddUnitStatutoryDocumentMutationOptions = Apollo.BaseMutationOptions<AddUnitStatutoryDocumentMutation, AddUnitStatutoryDocumentMutationVariables>;
export const BookingListBusinessInsightDocument = gql`
    query bookingListBusinessInsight {
  bookingListBusinessInsight {
    totalCount
    totalAmount
    cancelCount
    signCount
    cancelRate
    signRate
    direct {
      totalCount
      totalAmount
      existingCount
      existingAmount
      newCount
      newAmount
    }
    lead {
      totalCount
      totalAmount
      existingCount
      existingAmount
      newCount
      newAmount
    }
    agency {
      totalCount
      totalAmount
      existingCount
      existingAmount
      newCount
      newAmount
    }
  }
}
    `;

/**
 * __useBookingListBusinessInsightQuery__
 *
 * To run a query within a React component, call `useBookingListBusinessInsightQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingListBusinessInsightQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingListBusinessInsightQuery({
 *   variables: {
 *   },
 * });
 */
export function useBookingListBusinessInsightQuery(baseOptions?: Apollo.QueryHookOptions<BookingListBusinessInsightQuery, BookingListBusinessInsightQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingListBusinessInsightQuery, BookingListBusinessInsightQueryVariables>(BookingListBusinessInsightDocument, options);
      }
export function useBookingListBusinessInsightLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingListBusinessInsightQuery, BookingListBusinessInsightQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingListBusinessInsightQuery, BookingListBusinessInsightQueryVariables>(BookingListBusinessInsightDocument, options);
        }
export type BookingListBusinessInsightQueryHookResult = ReturnType<typeof useBookingListBusinessInsightQuery>;
export type BookingListBusinessInsightLazyQueryHookResult = ReturnType<typeof useBookingListBusinessInsightLazyQuery>;
export type BookingListBusinessInsightQueryResult = Apollo.QueryResult<BookingListBusinessInsightQuery, BookingListBusinessInsightQueryVariables>;
export const BookingListAnalysisBusinessInsightDocument = gql`
    query bookingListAnalysisBusinessInsight {
  bookingListAnalysisBusinessInsight {
    totalCount
    totalAmount
    cancelCount
    signCount
    cancelRate
    signRate
    leadSources {
      leadSourceName
      leadSourceCount
      value
    }
  }
}
    `;

/**
 * __useBookingListAnalysisBusinessInsightQuery__
 *
 * To run a query within a React component, call `useBookingListAnalysisBusinessInsightQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingListAnalysisBusinessInsightQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingListAnalysisBusinessInsightQuery({
 *   variables: {
 *   },
 * });
 */
export function useBookingListAnalysisBusinessInsightQuery(baseOptions?: Apollo.QueryHookOptions<BookingListAnalysisBusinessInsightQuery, BookingListAnalysisBusinessInsightQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingListAnalysisBusinessInsightQuery, BookingListAnalysisBusinessInsightQueryVariables>(BookingListAnalysisBusinessInsightDocument, options);
      }
export function useBookingListAnalysisBusinessInsightLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingListAnalysisBusinessInsightQuery, BookingListAnalysisBusinessInsightQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingListAnalysisBusinessInsightQuery, BookingListAnalysisBusinessInsightQueryVariables>(BookingListAnalysisBusinessInsightDocument, options);
        }
export type BookingListAnalysisBusinessInsightQueryHookResult = ReturnType<typeof useBookingListAnalysisBusinessInsightQuery>;
export type BookingListAnalysisBusinessInsightLazyQueryHookResult = ReturnType<typeof useBookingListAnalysisBusinessInsightLazyQuery>;
export type BookingListAnalysisBusinessInsightQueryResult = Apollo.QueryResult<BookingListAnalysisBusinessInsightQuery, BookingListAnalysisBusinessInsightQueryVariables>;
export const GetBusinessInsightSummaryDocument = gql`
    query getBusinessInsightSummary {
  getBusinessInsightSummary {
    ToPMsummary
    waitingListSummary
    outstandingSnPSummary
    loanBISummary
    bookingListSummary
    slpSummary
    pspSummary
    lsmSummary
    salesMovementSummary
    salesAnalysisSummary
    salesAnalysisByUnitSummary
    scaSummary
    stpSummary
    sapSummary
    sdaSummary
    cpSummary
  }
}
    `;

/**
 * __useGetBusinessInsightSummaryQuery__
 *
 * To run a query within a React component, call `useGetBusinessInsightSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessInsightSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessInsightSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBusinessInsightSummaryQuery(baseOptions?: Apollo.QueryHookOptions<GetBusinessInsightSummaryQuery, GetBusinessInsightSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBusinessInsightSummaryQuery, GetBusinessInsightSummaryQueryVariables>(GetBusinessInsightSummaryDocument, options);
      }
export function useGetBusinessInsightSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBusinessInsightSummaryQuery, GetBusinessInsightSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBusinessInsightSummaryQuery, GetBusinessInsightSummaryQueryVariables>(GetBusinessInsightSummaryDocument, options);
        }
export type GetBusinessInsightSummaryQueryHookResult = ReturnType<typeof useGetBusinessInsightSummaryQuery>;
export type GetBusinessInsightSummaryLazyQueryHookResult = ReturnType<typeof useGetBusinessInsightSummaryLazyQuery>;
export type GetBusinessInsightSummaryQueryResult = Apollo.QueryResult<GetBusinessInsightSummaryQuery, GetBusinessInsightSummaryQueryVariables>;
export const GetCampaignPerformanceDocument = gql`
    query getCampaignPerformance {
  getCampaignPerformance {
    id
    name
    total
    converted
    unconverted
    booked
    signed
    leads
    startDate
    endDate
  }
}
    `;

/**
 * __useGetCampaignPerformanceQuery__
 *
 * To run a query within a React component, call `useGetCampaignPerformanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignPerformanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignPerformanceQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCampaignPerformanceQuery(baseOptions?: Apollo.QueryHookOptions<GetCampaignPerformanceQuery, GetCampaignPerformanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignPerformanceQuery, GetCampaignPerformanceQueryVariables>(GetCampaignPerformanceDocument, options);
      }
export function useGetCampaignPerformanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignPerformanceQuery, GetCampaignPerformanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignPerformanceQuery, GetCampaignPerformanceQueryVariables>(GetCampaignPerformanceDocument, options);
        }
export type GetCampaignPerformanceQueryHookResult = ReturnType<typeof useGetCampaignPerformanceQuery>;
export type GetCampaignPerformanceLazyQueryHookResult = ReturnType<typeof useGetCampaignPerformanceLazyQuery>;
export type GetCampaignPerformanceQueryResult = Apollo.QueryResult<GetCampaignPerformanceQuery, GetCampaignPerformanceQueryVariables>;
export const GetEventPerformanceByCampaignIdDocument = gql`
    query getEventPerformanceByCampaignId($campaignId: String!) {
  getEventPerformanceByCampaignId(campaignId: $campaignId) {
    id
    name
    total
    converted
    unconverted
    booked
    signed
    leads
    startDate
    endDate
    budget
    cold
    hot
    open
    wait
    drop
    repeat
    cancelled
  }
}
    `;

/**
 * __useGetEventPerformanceByCampaignIdQuery__
 *
 * To run a query within a React component, call `useGetEventPerformanceByCampaignIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventPerformanceByCampaignIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventPerformanceByCampaignIdQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useGetEventPerformanceByCampaignIdQuery(baseOptions: Apollo.QueryHookOptions<GetEventPerformanceByCampaignIdQuery, GetEventPerformanceByCampaignIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventPerformanceByCampaignIdQuery, GetEventPerformanceByCampaignIdQueryVariables>(GetEventPerformanceByCampaignIdDocument, options);
      }
export function useGetEventPerformanceByCampaignIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventPerformanceByCampaignIdQuery, GetEventPerformanceByCampaignIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventPerformanceByCampaignIdQuery, GetEventPerformanceByCampaignIdQueryVariables>(GetEventPerformanceByCampaignIdDocument, options);
        }
export type GetEventPerformanceByCampaignIdQueryHookResult = ReturnType<typeof useGetEventPerformanceByCampaignIdQuery>;
export type GetEventPerformanceByCampaignIdLazyQueryHookResult = ReturnType<typeof useGetEventPerformanceByCampaignIdLazyQuery>;
export type GetEventPerformanceByCampaignIdQueryResult = Apollo.QueryResult<GetEventPerformanceByCampaignIdQuery, GetEventPerformanceByCampaignIdQueryVariables>;
export const GetOutstandingSnPDocument = gql`
    query getOutstandingSnP {
  getOutstandingSnP {
    oneWeek {
      unit_id
      unit_no
      book_date
      sales_team_name
      buyer_name
      spa_price
    }
    twoWeek {
      unit_id
      unit_no
      book_date
      sales_team_name
      buyer_name
      spa_price
    }
    threeWeek {
      unit_id
      unit_no
      book_date
      sales_team_name
      buyer_name
      spa_price
    }
    fourWeek {
      unit_id
      unit_no
      book_date
      sales_team_name
      buyer_name
      spa_price
    }
  }
}
    `;

/**
 * __useGetOutstandingSnPQuery__
 *
 * To run a query within a React component, call `useGetOutstandingSnPQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOutstandingSnPQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOutstandingSnPQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOutstandingSnPQuery(baseOptions?: Apollo.QueryHookOptions<GetOutstandingSnPQuery, GetOutstandingSnPQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOutstandingSnPQuery, GetOutstandingSnPQueryVariables>(GetOutstandingSnPDocument, options);
      }
export function useGetOutstandingSnPLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOutstandingSnPQuery, GetOutstandingSnPQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOutstandingSnPQuery, GetOutstandingSnPQueryVariables>(GetOutstandingSnPDocument, options);
        }
export type GetOutstandingSnPQueryHookResult = ReturnType<typeof useGetOutstandingSnPQuery>;
export type GetOutstandingSnPLazyQueryHookResult = ReturnType<typeof useGetOutstandingSnPLazyQuery>;
export type GetOutstandingSnPQueryResult = Apollo.QueryResult<GetOutstandingSnPQuery, GetOutstandingSnPQueryVariables>;
export const ProjectSalesBusinessInsightDataDocument = gql`
    query projectSalesBusinessInsightData {
  projectSalesBusinessInsightData {
    id
    currency
    projectSpec {
      reservationSales
      reservationAgency
      __typename
    }
    unitCountByStatus {
      totalUnitCount
      totalUnitPrice
      availableUnitCount
      signedUnitCount
      soldUnitCount
      bookUnitCount
      unavailableUnitCount
      reservationUnitCount
      totalAvailableUnitPrice
      totalSignedUnitPrice
      totalBookUnitPrice
      totalReservationUnitPrice
      totalSoldUnitPrice
      totalUnavailableUnitPrice
      __typename
    }
    unitCountByBlock {
      block
      totalUnitCount
      availableUnitCount
      signUnitCount
      soldUnitCount
      bookUnitCount
      unavailableUnitCount
      reservationUnitCount
      __typename
    }
    unitCountByUnitType {
      unitType
      totalUnitCount
      availableUnitCount
      signUnitCount
      soldUnitCount
      bookUnitCount
      unavailableUnitCount
      reservationUnitCount
      __typename
    }
  }
}
    `;

/**
 * __useProjectSalesBusinessInsightDataQuery__
 *
 * To run a query within a React component, call `useProjectSalesBusinessInsightDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectSalesBusinessInsightDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectSalesBusinessInsightDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useProjectSalesBusinessInsightDataQuery(baseOptions?: Apollo.QueryHookOptions<ProjectSalesBusinessInsightDataQuery, ProjectSalesBusinessInsightDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectSalesBusinessInsightDataQuery, ProjectSalesBusinessInsightDataQueryVariables>(ProjectSalesBusinessInsightDataDocument, options);
      }
export function useProjectSalesBusinessInsightDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectSalesBusinessInsightDataQuery, ProjectSalesBusinessInsightDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectSalesBusinessInsightDataQuery, ProjectSalesBusinessInsightDataQueryVariables>(ProjectSalesBusinessInsightDataDocument, options);
        }
export type ProjectSalesBusinessInsightDataQueryHookResult = ReturnType<typeof useProjectSalesBusinessInsightDataQuery>;
export type ProjectSalesBusinessInsightDataLazyQueryHookResult = ReturnType<typeof useProjectSalesBusinessInsightDataLazyQuery>;
export type ProjectSalesBusinessInsightDataQueryResult = Apollo.QueryResult<ProjectSalesBusinessInsightDataQuery, ProjectSalesBusinessInsightDataQueryVariables>;
export const GetLeadSourceFilterListDocument = gql`
    query getLeadSourceFilterList {
  getLeadSourceFilterList {
    id
    name
  }
}
    `;

/**
 * __useGetLeadSourceFilterListQuery__
 *
 * To run a query within a React component, call `useGetLeadSourceFilterListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeadSourceFilterListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeadSourceFilterListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLeadSourceFilterListQuery(baseOptions?: Apollo.QueryHookOptions<GetLeadSourceFilterListQuery, GetLeadSourceFilterListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeadSourceFilterListQuery, GetLeadSourceFilterListQueryVariables>(GetLeadSourceFilterListDocument, options);
      }
export function useGetLeadSourceFilterListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeadSourceFilterListQuery, GetLeadSourceFilterListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeadSourceFilterListQuery, GetLeadSourceFilterListQueryVariables>(GetLeadSourceFilterListDocument, options);
        }
export type GetLeadSourceFilterListQueryHookResult = ReturnType<typeof useGetLeadSourceFilterListQuery>;
export type GetLeadSourceFilterListLazyQueryHookResult = ReturnType<typeof useGetLeadSourceFilterListLazyQuery>;
export type GetLeadSourceFilterListQueryResult = Apollo.QueryResult<GetLeadSourceFilterListQuery, GetLeadSourceFilterListQueryVariables>;
export const GetLeadCountByProjectDocument = gql`
    query getLeadCountByProject($lead_source_id: String) {
  getLeadCountByProject(lead_source_id: $lead_source_id) {
    projectId
    waitingCount
    openCount
    hotCount
    coldCount
    dropCount
    bookedCount
    reservationCount
    signedCount
    totalCount
    totalConvertedAmount
    droppedRate {
      rate
      totalDropLead
    }
  }
}
    `;

/**
 * __useGetLeadCountByProjectQuery__
 *
 * To run a query within a React component, call `useGetLeadCountByProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeadCountByProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeadCountByProjectQuery({
 *   variables: {
 *      lead_source_id: // value for 'lead_source_id'
 *   },
 * });
 */
export function useGetLeadCountByProjectQuery(baseOptions?: Apollo.QueryHookOptions<GetLeadCountByProjectQuery, GetLeadCountByProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeadCountByProjectQuery, GetLeadCountByProjectQueryVariables>(GetLeadCountByProjectDocument, options);
      }
export function useGetLeadCountByProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeadCountByProjectQuery, GetLeadCountByProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeadCountByProjectQuery, GetLeadCountByProjectQueryVariables>(GetLeadCountByProjectDocument, options);
        }
export type GetLeadCountByProjectQueryHookResult = ReturnType<typeof useGetLeadCountByProjectQuery>;
export type GetLeadCountByProjectLazyQueryHookResult = ReturnType<typeof useGetLeadCountByProjectLazyQuery>;
export type GetLeadCountByProjectQueryResult = Apollo.QueryResult<GetLeadCountByProjectQuery, GetLeadCountByProjectQueryVariables>;
export const GetSalesAnalysisCountDocument = gql`
    query getSalesAnalysisCount($selectedDate: DateTime!) {
  getSalesAnalysisCount(selectedDate: $selectedDate) {
    dailyBook {
      daily_date
      bookedCount
      cancelBookCount
      cumulativeCount
    }
    dailySign {
      daily_date
      signedCount
      cancelSignCount
      cumulativeCount
    }
    weeklyBook {
      start_week
      end_week
      start_week_alt
      bookedCount
      cancelBookCount
      cumulativeCount
    }
    weeklySign {
      start_week
      end_week
      start_week_alt
      signedCount
      cancelSignCount
      cumulativeCount
    }
    monthlyBook {
      months
      months_alt
      bookedCount
      cancelBookCount
      cumulativeCount
    }
    monthlySign {
      months
      months_alt
      signedCount
      cancelSignCount
      cumulativeCount
    }
  }
}
    `;

/**
 * __useGetSalesAnalysisCountQuery__
 *
 * To run a query within a React component, call `useGetSalesAnalysisCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesAnalysisCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesAnalysisCountQuery({
 *   variables: {
 *      selectedDate: // value for 'selectedDate'
 *   },
 * });
 */
export function useGetSalesAnalysisCountQuery(baseOptions: Apollo.QueryHookOptions<GetSalesAnalysisCountQuery, GetSalesAnalysisCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesAnalysisCountQuery, GetSalesAnalysisCountQueryVariables>(GetSalesAnalysisCountDocument, options);
      }
export function useGetSalesAnalysisCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesAnalysisCountQuery, GetSalesAnalysisCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesAnalysisCountQuery, GetSalesAnalysisCountQueryVariables>(GetSalesAnalysisCountDocument, options);
        }
export type GetSalesAnalysisCountQueryHookResult = ReturnType<typeof useGetSalesAnalysisCountQuery>;
export type GetSalesAnalysisCountLazyQueryHookResult = ReturnType<typeof useGetSalesAnalysisCountLazyQuery>;
export type GetSalesAnalysisCountQueryResult = Apollo.QueryResult<GetSalesAnalysisCountQuery, GetSalesAnalysisCountQueryVariables>;
export const GetDailySalesAnalysisCountDocument = gql`
    query getDailySalesAnalysisCount($selectedDate: DateTime!, $salesType: String!) {
  getDailySalesAnalysisCount(selectedDate: $selectedDate, salesType: $salesType) {
    dailyDate
    dailyCount
    cumulativeCount
  }
}
    `;

/**
 * __useGetDailySalesAnalysisCountQuery__
 *
 * To run a query within a React component, call `useGetDailySalesAnalysisCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailySalesAnalysisCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailySalesAnalysisCountQuery({
 *   variables: {
 *      selectedDate: // value for 'selectedDate'
 *      salesType: // value for 'salesType'
 *   },
 * });
 */
export function useGetDailySalesAnalysisCountQuery(baseOptions: Apollo.QueryHookOptions<GetDailySalesAnalysisCountQuery, GetDailySalesAnalysisCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailySalesAnalysisCountQuery, GetDailySalesAnalysisCountQueryVariables>(GetDailySalesAnalysisCountDocument, options);
      }
export function useGetDailySalesAnalysisCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDailySalesAnalysisCountQuery, GetDailySalesAnalysisCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailySalesAnalysisCountQuery, GetDailySalesAnalysisCountQueryVariables>(GetDailySalesAnalysisCountDocument, options);
        }
export type GetDailySalesAnalysisCountQueryHookResult = ReturnType<typeof useGetDailySalesAnalysisCountQuery>;
export type GetDailySalesAnalysisCountLazyQueryHookResult = ReturnType<typeof useGetDailySalesAnalysisCountLazyQuery>;
export type GetDailySalesAnalysisCountQueryResult = Apollo.QueryResult<GetDailySalesAnalysisCountQuery, GetDailySalesAnalysisCountQueryVariables>;
export const GetWeeklySalesAnalysisCountDocument = gql`
    query getWeeklySalesAnalysisCount($selectedDate: DateTime!, $salesType: String!) {
  getWeeklySalesAnalysisCount(selectedDate: $selectedDate, salesType: $salesType) {
    startWeek
    endWeek
    weeklyCount
    cumulativeCount
  }
}
    `;

/**
 * __useGetWeeklySalesAnalysisCountQuery__
 *
 * To run a query within a React component, call `useGetWeeklySalesAnalysisCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWeeklySalesAnalysisCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWeeklySalesAnalysisCountQuery({
 *   variables: {
 *      selectedDate: // value for 'selectedDate'
 *      salesType: // value for 'salesType'
 *   },
 * });
 */
export function useGetWeeklySalesAnalysisCountQuery(baseOptions: Apollo.QueryHookOptions<GetWeeklySalesAnalysisCountQuery, GetWeeklySalesAnalysisCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWeeklySalesAnalysisCountQuery, GetWeeklySalesAnalysisCountQueryVariables>(GetWeeklySalesAnalysisCountDocument, options);
      }
export function useGetWeeklySalesAnalysisCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWeeklySalesAnalysisCountQuery, GetWeeklySalesAnalysisCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWeeklySalesAnalysisCountQuery, GetWeeklySalesAnalysisCountQueryVariables>(GetWeeklySalesAnalysisCountDocument, options);
        }
export type GetWeeklySalesAnalysisCountQueryHookResult = ReturnType<typeof useGetWeeklySalesAnalysisCountQuery>;
export type GetWeeklySalesAnalysisCountLazyQueryHookResult = ReturnType<typeof useGetWeeklySalesAnalysisCountLazyQuery>;
export type GetWeeklySalesAnalysisCountQueryResult = Apollo.QueryResult<GetWeeklySalesAnalysisCountQuery, GetWeeklySalesAnalysisCountQueryVariables>;
export const GetMonthlySalesAnalysisCountDocument = gql`
    query getMonthlySalesAnalysisCount($selectedDate: DateTime!, $salesType: String!) {
  getMonthlySalesAnalysisCount(selectedDate: $selectedDate, salesType: $salesType) {
    monthlyDate
    monthlyCount
    cumulativeCount
  }
}
    `;

/**
 * __useGetMonthlySalesAnalysisCountQuery__
 *
 * To run a query within a React component, call `useGetMonthlySalesAnalysisCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMonthlySalesAnalysisCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMonthlySalesAnalysisCountQuery({
 *   variables: {
 *      selectedDate: // value for 'selectedDate'
 *      salesType: // value for 'salesType'
 *   },
 * });
 */
export function useGetMonthlySalesAnalysisCountQuery(baseOptions: Apollo.QueryHookOptions<GetMonthlySalesAnalysisCountQuery, GetMonthlySalesAnalysisCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMonthlySalesAnalysisCountQuery, GetMonthlySalesAnalysisCountQueryVariables>(GetMonthlySalesAnalysisCountDocument, options);
      }
export function useGetMonthlySalesAnalysisCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMonthlySalesAnalysisCountQuery, GetMonthlySalesAnalysisCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMonthlySalesAnalysisCountQuery, GetMonthlySalesAnalysisCountQueryVariables>(GetMonthlySalesAnalysisCountDocument, options);
        }
export type GetMonthlySalesAnalysisCountQueryHookResult = ReturnType<typeof useGetMonthlySalesAnalysisCountQuery>;
export type GetMonthlySalesAnalysisCountLazyQueryHookResult = ReturnType<typeof useGetMonthlySalesAnalysisCountLazyQuery>;
export type GetMonthlySalesAnalysisCountQueryResult = Apollo.QueryResult<GetMonthlySalesAnalysisCountQuery, GetMonthlySalesAnalysisCountQueryVariables>;
export const GetUnitTypeSaByUnitTypeDocument = gql`
    query getUnitTypeSAByUnitType {
  getUnitTypeSAByUnitType {
    unitType
    totalUnitCount
    availableUnitCount
    signUnitCount
    soldUnitCount
    bookUnitCount
    unavailableUnitCount
    reservationUnitCount
  }
}
    `;

/**
 * __useGetUnitTypeSaByUnitTypeQuery__
 *
 * To run a query within a React component, call `useGetUnitTypeSaByUnitTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitTypeSaByUnitTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitTypeSaByUnitTypeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUnitTypeSaByUnitTypeQuery(baseOptions?: Apollo.QueryHookOptions<GetUnitTypeSaByUnitTypeQuery, GetUnitTypeSaByUnitTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitTypeSaByUnitTypeQuery, GetUnitTypeSaByUnitTypeQueryVariables>(GetUnitTypeSaByUnitTypeDocument, options);
      }
export function useGetUnitTypeSaByUnitTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitTypeSaByUnitTypeQuery, GetUnitTypeSaByUnitTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitTypeSaByUnitTypeQuery, GetUnitTypeSaByUnitTypeQueryVariables>(GetUnitTypeSaByUnitTypeDocument, options);
        }
export type GetUnitTypeSaByUnitTypeQueryHookResult = ReturnType<typeof useGetUnitTypeSaByUnitTypeQuery>;
export type GetUnitTypeSaByUnitTypeLazyQueryHookResult = ReturnType<typeof useGetUnitTypeSaByUnitTypeLazyQuery>;
export type GetUnitTypeSaByUnitTypeQueryResult = Apollo.QueryResult<GetUnitTypeSaByUnitTypeQuery, GetUnitTypeSaByUnitTypeQueryVariables>;
export const WaitingListUnitSaByUnitTypeDocument = gql`
    query waitingListUnitSAByUnitType {
  waitingListUnitSAByUnitType {
    unit_type
    totalCount
    WaitingListByUnitType {
      unit_layout_id
      unit_type_id
      unit_layout
      unit_type
      count
    }
  }
}
    `;

/**
 * __useWaitingListUnitSaByUnitTypeQuery__
 *
 * To run a query within a React component, call `useWaitingListUnitSaByUnitTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useWaitingListUnitSaByUnitTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWaitingListUnitSaByUnitTypeQuery({
 *   variables: {
 *   },
 * });
 */
export function useWaitingListUnitSaByUnitTypeQuery(baseOptions?: Apollo.QueryHookOptions<WaitingListUnitSaByUnitTypeQuery, WaitingListUnitSaByUnitTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WaitingListUnitSaByUnitTypeQuery, WaitingListUnitSaByUnitTypeQueryVariables>(WaitingListUnitSaByUnitTypeDocument, options);
      }
export function useWaitingListUnitSaByUnitTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WaitingListUnitSaByUnitTypeQuery, WaitingListUnitSaByUnitTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WaitingListUnitSaByUnitTypeQuery, WaitingListUnitSaByUnitTypeQueryVariables>(WaitingListUnitSaByUnitTypeDocument, options);
        }
export type WaitingListUnitSaByUnitTypeQueryHookResult = ReturnType<typeof useWaitingListUnitSaByUnitTypeQuery>;
export type WaitingListUnitSaByUnitTypeLazyQueryHookResult = ReturnType<typeof useWaitingListUnitSaByUnitTypeLazyQuery>;
export type WaitingListUnitSaByUnitTypeQueryResult = Apollo.QueryResult<WaitingListUnitSaByUnitTypeQuery, WaitingListUnitSaByUnitTypeQueryVariables>;
export const GetSalesRaceBiDocument = gql`
    query getSalesRaceBI {
  getSalesRaceBI {
    id
    name
    value
  }
}
    `;

/**
 * __useGetSalesRaceBiQuery__
 *
 * To run a query within a React component, call `useGetSalesRaceBiQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesRaceBiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesRaceBiQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSalesRaceBiQuery(baseOptions?: Apollo.QueryHookOptions<GetSalesRaceBiQuery, GetSalesRaceBiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesRaceBiQuery, GetSalesRaceBiQueryVariables>(GetSalesRaceBiDocument, options);
      }
export function useGetSalesRaceBiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesRaceBiQuery, GetSalesRaceBiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesRaceBiQuery, GetSalesRaceBiQueryVariables>(GetSalesRaceBiDocument, options);
        }
export type GetSalesRaceBiQueryHookResult = ReturnType<typeof useGetSalesRaceBiQuery>;
export type GetSalesRaceBiLazyQueryHookResult = ReturnType<typeof useGetSalesRaceBiLazyQuery>;
export type GetSalesRaceBiQueryResult = Apollo.QueryResult<GetSalesRaceBiQuery, GetSalesRaceBiQueryVariables>;
export const GetSalesAgeBiDocument = gql`
    query getSalesAgeBI {
  getSalesAgeBI {
    id
    name
    value
  }
}
    `;

/**
 * __useGetSalesAgeBiQuery__
 *
 * To run a query within a React component, call `useGetSalesAgeBiQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesAgeBiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesAgeBiQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSalesAgeBiQuery(baseOptions?: Apollo.QueryHookOptions<GetSalesAgeBiQuery, GetSalesAgeBiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesAgeBiQuery, GetSalesAgeBiQueryVariables>(GetSalesAgeBiDocument, options);
      }
export function useGetSalesAgeBiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesAgeBiQuery, GetSalesAgeBiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesAgeBiQuery, GetSalesAgeBiQueryVariables>(GetSalesAgeBiDocument, options);
        }
export type GetSalesAgeBiQueryHookResult = ReturnType<typeof useGetSalesAgeBiQuery>;
export type GetSalesAgeBiLazyQueryHookResult = ReturnType<typeof useGetSalesAgeBiLazyQuery>;
export type GetSalesAgeBiQueryResult = Apollo.QueryResult<GetSalesAgeBiQuery, GetSalesAgeBiQueryVariables>;
export const GetSalesPurchaserIncomeRangeDocument = gql`
    query getSalesPurchaserIncomeRange {
  getSalesPurchaserIncomeRange {
    id
    name
    value
  }
}
    `;

/**
 * __useGetSalesPurchaserIncomeRangeQuery__
 *
 * To run a query within a React component, call `useGetSalesPurchaserIncomeRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesPurchaserIncomeRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesPurchaserIncomeRangeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSalesPurchaserIncomeRangeQuery(baseOptions?: Apollo.QueryHookOptions<GetSalesPurchaserIncomeRangeQuery, GetSalesPurchaserIncomeRangeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesPurchaserIncomeRangeQuery, GetSalesPurchaserIncomeRangeQueryVariables>(GetSalesPurchaserIncomeRangeDocument, options);
      }
export function useGetSalesPurchaserIncomeRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesPurchaserIncomeRangeQuery, GetSalesPurchaserIncomeRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesPurchaserIncomeRangeQuery, GetSalesPurchaserIncomeRangeQueryVariables>(GetSalesPurchaserIncomeRangeDocument, options);
        }
export type GetSalesPurchaserIncomeRangeQueryHookResult = ReturnType<typeof useGetSalesPurchaserIncomeRangeQuery>;
export type GetSalesPurchaserIncomeRangeLazyQueryHookResult = ReturnType<typeof useGetSalesPurchaserIncomeRangeLazyQuery>;
export type GetSalesPurchaserIncomeRangeQueryResult = Apollo.QueryResult<GetSalesPurchaserIncomeRangeQuery, GetSalesPurchaserIncomeRangeQueryVariables>;
export const GetSalesJointBuyerIncomeRangeDocument = gql`
    query getSalesJointBuyerIncomeRange {
  getSalesJointBuyerIncomeRange {
    id
    name
    value
  }
}
    `;

/**
 * __useGetSalesJointBuyerIncomeRangeQuery__
 *
 * To run a query within a React component, call `useGetSalesJointBuyerIncomeRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesJointBuyerIncomeRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesJointBuyerIncomeRangeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSalesJointBuyerIncomeRangeQuery(baseOptions?: Apollo.QueryHookOptions<GetSalesJointBuyerIncomeRangeQuery, GetSalesJointBuyerIncomeRangeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesJointBuyerIncomeRangeQuery, GetSalesJointBuyerIncomeRangeQueryVariables>(GetSalesJointBuyerIncomeRangeDocument, options);
      }
export function useGetSalesJointBuyerIncomeRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesJointBuyerIncomeRangeQuery, GetSalesJointBuyerIncomeRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesJointBuyerIncomeRangeQuery, GetSalesJointBuyerIncomeRangeQueryVariables>(GetSalesJointBuyerIncomeRangeDocument, options);
        }
export type GetSalesJointBuyerIncomeRangeQueryHookResult = ReturnType<typeof useGetSalesJointBuyerIncomeRangeQuery>;
export type GetSalesJointBuyerIncomeRangeLazyQueryHookResult = ReturnType<typeof useGetSalesJointBuyerIncomeRangeLazyQuery>;
export type GetSalesJointBuyerIncomeRangeQueryResult = Apollo.QueryResult<GetSalesJointBuyerIncomeRangeQuery, GetSalesJointBuyerIncomeRangeQueryVariables>;
export const GetSalesMovementDocument = gql`
    query getSalesMovement($selectedDate: DateTime!) {
  getSalesMovementData(selectedDate: $selectedDate) {
    currency
    dailyMovement {
      bookedTotalSellingPrice
      bookedCount
      reserveTotalSellingPrice
      reserveCount
      signedTotalSellingPrice
      signedCount
      cancelledTotalSellingPrice
      cancelledCount
      sale_origin
      daily_date
      __typename
    }
    weeklyMovement {
      bookedTotalSellingPrice
      bookedCount
      reserveTotalSellingPrice
      reserveCount
      signedTotalSellingPrice
      signedCount
      cancelledTotalSellingPrice
      cancelledCount
      sale_origin
      start_week
      end_week
      start_week_alt
      __typename
    }
    monthlyMovement {
      bookedTotalSellingPrice
      bookedCount
      reserveTotalSellingPrice
      reserveCount
      signedTotalSellingPrice
      signedCount
      cancelledTotalSellingPrice
      cancelledCount
      sale_origin
      months
      months_alt
      __typename
    }
  }
}
    `;

/**
 * __useGetSalesMovementQuery__
 *
 * To run a query within a React component, call `useGetSalesMovementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesMovementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesMovementQuery({
 *   variables: {
 *      selectedDate: // value for 'selectedDate'
 *   },
 * });
 */
export function useGetSalesMovementQuery(baseOptions: Apollo.QueryHookOptions<GetSalesMovementQuery, GetSalesMovementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesMovementQuery, GetSalesMovementQueryVariables>(GetSalesMovementDocument, options);
      }
export function useGetSalesMovementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesMovementQuery, GetSalesMovementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesMovementQuery, GetSalesMovementQueryVariables>(GetSalesMovementDocument, options);
        }
export type GetSalesMovementQueryHookResult = ReturnType<typeof useGetSalesMovementQuery>;
export type GetSalesMovementLazyQueryHookResult = ReturnType<typeof useGetSalesMovementLazyQuery>;
export type GetSalesMovementQueryResult = Apollo.QueryResult<GetSalesMovementQuery, GetSalesMovementQueryVariables>;
export const GetTeamBiDocument = gql`
    query getTeamBI($startDate: DateTime!, $endDate: DateTime!) {
  getTeamBI(startDate: $startDate, endDate: $endDate) {
    team {
      teamId
      teamName
      totalTeamCount
      totalTeamPrice
      staff {
        signedCount
        bookCount
        reserveCount
        cancelCount
        sumSpaPrice
        sumBookAmt
        sumReserveAmt
        sumCancelAmt
        salesPersonName
      }
    }
    agency {
      teamId
      agencyName
      totalTeamCount
      totalTeamPrice
      staff {
        signedCount
        bookCount
        reserveCount
        cancelCount
        sumSpaPrice
        sumBookAmt
        sumReserveAmt
        sumCancelAmt
        salesPersonName
      }
    }
  }
}
    `;

/**
 * __useGetTeamBiQuery__
 *
 * To run a query within a React component, call `useGetTeamBiQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamBiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamBiQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetTeamBiQuery(baseOptions: Apollo.QueryHookOptions<GetTeamBiQuery, GetTeamBiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamBiQuery, GetTeamBiQueryVariables>(GetTeamBiDocument, options);
      }
export function useGetTeamBiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamBiQuery, GetTeamBiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamBiQuery, GetTeamBiQueryVariables>(GetTeamBiDocument, options);
        }
export type GetTeamBiQueryHookResult = ReturnType<typeof useGetTeamBiQuery>;
export type GetTeamBiLazyQueryHookResult = ReturnType<typeof useGetTeamBiLazyQuery>;
export type GetTeamBiQueryResult = Apollo.QueryResult<GetTeamBiQuery, GetTeamBiQueryVariables>;
export const GetSalesTeamBiDocument = gql`
    query getSalesTeamBI {
  getSalesTeamBI {
    team {
      teamId
      teamName
      totalTeamCount
      totalTeamPrice
      staff {
        signedCount
        bookCount
        reserveCount
        cancelCount
        sumSpaPrice
        sumBookAmt
        sumReserveAmt
        sumCancelAmt
        salesPersonName
      }
    }
  }
}
    `;

/**
 * __useGetSalesTeamBiQuery__
 *
 * To run a query within a React component, call `useGetSalesTeamBiQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesTeamBiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesTeamBiQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSalesTeamBiQuery(baseOptions?: Apollo.QueryHookOptions<GetSalesTeamBiQuery, GetSalesTeamBiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesTeamBiQuery, GetSalesTeamBiQueryVariables>(GetSalesTeamBiDocument, options);
      }
export function useGetSalesTeamBiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesTeamBiQuery, GetSalesTeamBiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesTeamBiQuery, GetSalesTeamBiQueryVariables>(GetSalesTeamBiDocument, options);
        }
export type GetSalesTeamBiQueryHookResult = ReturnType<typeof useGetSalesTeamBiQuery>;
export type GetSalesTeamBiLazyQueryHookResult = ReturnType<typeof useGetSalesTeamBiLazyQuery>;
export type GetSalesTeamBiQueryResult = Apollo.QueryResult<GetSalesTeamBiQuery, GetSalesTeamBiQueryVariables>;
export const GetPaymentMethodDataDocument = gql`
    query getPaymentMethodData {
  getPaymentMethodData {
    totalCount
    totalAmount
    cashCount
    cashAmount
    chequeCount
    chequeAmount
    creditCardCount
    creditCardAmount
    onlinePaymentCount
    onlinePaymentAmount
    onlineTransferCount
    onlineTransferAmount
  }
}
    `;

/**
 * __useGetPaymentMethodDataQuery__
 *
 * To run a query within a React component, call `useGetPaymentMethodDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentMethodDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentMethodDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPaymentMethodDataQuery(baseOptions?: Apollo.QueryHookOptions<GetPaymentMethodDataQuery, GetPaymentMethodDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentMethodDataQuery, GetPaymentMethodDataQueryVariables>(GetPaymentMethodDataDocument, options);
      }
export function useGetPaymentMethodDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentMethodDataQuery, GetPaymentMethodDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentMethodDataQuery, GetPaymentMethodDataQueryVariables>(GetPaymentMethodDataDocument, options);
        }
export type GetPaymentMethodDataQueryHookResult = ReturnType<typeof useGetPaymentMethodDataQuery>;
export type GetPaymentMethodDataLazyQueryHookResult = ReturnType<typeof useGetPaymentMethodDataLazyQuery>;
export type GetPaymentMethodDataQueryResult = Apollo.QueryResult<GetPaymentMethodDataQuery, GetPaymentMethodDataQueryVariables>;
export const WaitingListUnitTypeBiDocument = gql`
    query waitingListUnitTypeBI {
  waitingListUnitTypeBI {
    unit_type
    totalCount
    WaitingListByUnitType {
      unit_layout_id
      unit_type_id
      unit_layout
      unit_type
      count
    }
  }
}
    `;

/**
 * __useWaitingListUnitTypeBiQuery__
 *
 * To run a query within a React component, call `useWaitingListUnitTypeBiQuery` and pass it any options that fit your needs.
 * When your component renders, `useWaitingListUnitTypeBiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWaitingListUnitTypeBiQuery({
 *   variables: {
 *   },
 * });
 */
export function useWaitingListUnitTypeBiQuery(baseOptions?: Apollo.QueryHookOptions<WaitingListUnitTypeBiQuery, WaitingListUnitTypeBiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WaitingListUnitTypeBiQuery, WaitingListUnitTypeBiQueryVariables>(WaitingListUnitTypeBiDocument, options);
      }
export function useWaitingListUnitTypeBiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WaitingListUnitTypeBiQuery, WaitingListUnitTypeBiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WaitingListUnitTypeBiQuery, WaitingListUnitTypeBiQueryVariables>(WaitingListUnitTypeBiDocument, options);
        }
export type WaitingListUnitTypeBiQueryHookResult = ReturnType<typeof useWaitingListUnitTypeBiQuery>;
export type WaitingListUnitTypeBiLazyQueryHookResult = ReturnType<typeof useWaitingListUnitTypeBiLazyQuery>;
export type WaitingListUnitTypeBiQueryResult = Apollo.QueryResult<WaitingListUnitTypeBiQuery, WaitingListUnitTypeBiQueryVariables>;
export const WaitingListCountBiDocument = gql`
    query waitingListCountBI {
  waitingListCountBI {
    total_waiting
    converted
    cancelled
  }
}
    `;

/**
 * __useWaitingListCountBiQuery__
 *
 * To run a query within a React component, call `useWaitingListCountBiQuery` and pass it any options that fit your needs.
 * When your component renders, `useWaitingListCountBiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWaitingListCountBiQuery({
 *   variables: {
 *   },
 * });
 */
export function useWaitingListCountBiQuery(baseOptions?: Apollo.QueryHookOptions<WaitingListCountBiQuery, WaitingListCountBiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WaitingListCountBiQuery, WaitingListCountBiQueryVariables>(WaitingListCountBiDocument, options);
      }
export function useWaitingListCountBiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WaitingListCountBiQuery, WaitingListCountBiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WaitingListCountBiQuery, WaitingListCountBiQueryVariables>(WaitingListCountBiDocument, options);
        }
export type WaitingListCountBiQueryHookResult = ReturnType<typeof useWaitingListCountBiQuery>;
export type WaitingListCountBiLazyQueryHookResult = ReturnType<typeof useWaitingListCountBiLazyQuery>;
export type WaitingListCountBiQueryResult = Apollo.QueryResult<WaitingListCountBiQuery, WaitingListCountBiQueryVariables>;
export const LoanAcceptanceRateDocument = gql`
    query loanAcceptanceRate {
  loanAcceptanceRate {
    accepted
    name
    pending
    rejected
    total
  }
}
    `;

/**
 * __useLoanAcceptanceRateQuery__
 *
 * To run a query within a React component, call `useLoanAcceptanceRateQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoanAcceptanceRateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoanAcceptanceRateQuery({
 *   variables: {
 *   },
 * });
 */
export function useLoanAcceptanceRateQuery(baseOptions?: Apollo.QueryHookOptions<LoanAcceptanceRateQuery, LoanAcceptanceRateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoanAcceptanceRateQuery, LoanAcceptanceRateQueryVariables>(LoanAcceptanceRateDocument, options);
      }
export function useLoanAcceptanceRateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoanAcceptanceRateQuery, LoanAcceptanceRateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoanAcceptanceRateQuery, LoanAcceptanceRateQueryVariables>(LoanAcceptanceRateDocument, options);
        }
export type LoanAcceptanceRateQueryHookResult = ReturnType<typeof useLoanAcceptanceRateQuery>;
export type LoanAcceptanceRateLazyQueryHookResult = ReturnType<typeof useLoanAcceptanceRateLazyQuery>;
export type LoanAcceptanceRateQueryResult = Apollo.QueryResult<LoanAcceptanceRateQuery, LoanAcceptanceRateQueryVariables>;
export const EndFinancingLimitStatusDocument = gql`
    query endFinancingLimitStatus {
  endFinancingLimitStatus {
    approvalAmount
    financialLimit
    name
  }
}
    `;

/**
 * __useEndFinancingLimitStatusQuery__
 *
 * To run a query within a React component, call `useEndFinancingLimitStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useEndFinancingLimitStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEndFinancingLimitStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useEndFinancingLimitStatusQuery(baseOptions?: Apollo.QueryHookOptions<EndFinancingLimitStatusQuery, EndFinancingLimitStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EndFinancingLimitStatusQuery, EndFinancingLimitStatusQueryVariables>(EndFinancingLimitStatusDocument, options);
      }
export function useEndFinancingLimitStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EndFinancingLimitStatusQuery, EndFinancingLimitStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EndFinancingLimitStatusQuery, EndFinancingLimitStatusQueryVariables>(EndFinancingLimitStatusDocument, options);
        }
export type EndFinancingLimitStatusQueryHookResult = ReturnType<typeof useEndFinancingLimitStatusQuery>;
export type EndFinancingLimitStatusLazyQueryHookResult = ReturnType<typeof useEndFinancingLimitStatusLazyQuery>;
export type EndFinancingLimitStatusQueryResult = Apollo.QueryResult<EndFinancingLimitStatusQuery, EndFinancingLimitStatusQueryVariables>;
export const GetLotStatusMovementDataDocument = gql`
    query getLotStatusMovementData($unitTypeId: String, $propertyTypeId: String) {
  getLotStatusMovementData(unitTypeId: $unitTypeId, propertyTypeId: $propertyTypeId) {
    weeklyMovement {
      transactionDate
      cancelledCount
      bookedCount
      soldCount
    }
    monthlyMovement {
      transactionDate
      cancelledCount
      bookedCount
      soldCount
    }
  }
}
    `;

/**
 * __useGetLotStatusMovementDataQuery__
 *
 * To run a query within a React component, call `useGetLotStatusMovementDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLotStatusMovementDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLotStatusMovementDataQuery({
 *   variables: {
 *      unitTypeId: // value for 'unitTypeId'
 *      propertyTypeId: // value for 'propertyTypeId'
 *   },
 * });
 */
export function useGetLotStatusMovementDataQuery(baseOptions?: Apollo.QueryHookOptions<GetLotStatusMovementDataQuery, GetLotStatusMovementDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLotStatusMovementDataQuery, GetLotStatusMovementDataQueryVariables>(GetLotStatusMovementDataDocument, options);
      }
export function useGetLotStatusMovementDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLotStatusMovementDataQuery, GetLotStatusMovementDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLotStatusMovementDataQuery, GetLotStatusMovementDataQueryVariables>(GetLotStatusMovementDataDocument, options);
        }
export type GetLotStatusMovementDataQueryHookResult = ReturnType<typeof useGetLotStatusMovementDataQuery>;
export type GetLotStatusMovementDataLazyQueryHookResult = ReturnType<typeof useGetLotStatusMovementDataLazyQuery>;
export type GetLotStatusMovementDataQueryResult = Apollo.QueryResult<GetLotStatusMovementDataQuery, GetLotStatusMovementDataQueryVariables>;
export const GetUnitTypeListDocument = gql`
    query getUnitTypeList($projectId: String!) {
  getUnitTypeList(projectId: $projectId) {
    id
    name
  }
}
    `;

/**
 * __useGetUnitTypeListQuery__
 *
 * To run a query within a React component, call `useGetUnitTypeListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitTypeListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitTypeListQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetUnitTypeListQuery(baseOptions: Apollo.QueryHookOptions<GetUnitTypeListQuery, GetUnitTypeListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitTypeListQuery, GetUnitTypeListQueryVariables>(GetUnitTypeListDocument, options);
      }
export function useGetUnitTypeListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitTypeListQuery, GetUnitTypeListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitTypeListQuery, GetUnitTypeListQueryVariables>(GetUnitTypeListDocument, options);
        }
export type GetUnitTypeListQueryHookResult = ReturnType<typeof useGetUnitTypeListQuery>;
export type GetUnitTypeListLazyQueryHookResult = ReturnType<typeof useGetUnitTypeListLazyQuery>;
export type GetUnitTypeListQueryResult = Apollo.QueryResult<GetUnitTypeListQuery, GetUnitTypeListQueryVariables>;
export const GetPropertyTypeListDocument = gql`
    query getPropertyTypeList($projectId: String!) {
  getPropertyTypeList(projectId: $projectId) {
    id
    name
  }
}
    `;

/**
 * __useGetPropertyTypeListQuery__
 *
 * To run a query within a React component, call `useGetPropertyTypeListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertyTypeListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertyTypeListQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetPropertyTypeListQuery(baseOptions: Apollo.QueryHookOptions<GetPropertyTypeListQuery, GetPropertyTypeListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertyTypeListQuery, GetPropertyTypeListQueryVariables>(GetPropertyTypeListDocument, options);
      }
export function useGetPropertyTypeListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertyTypeListQuery, GetPropertyTypeListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertyTypeListQuery, GetPropertyTypeListQueryVariables>(GetPropertyTypeListDocument, options);
        }
export type GetPropertyTypeListQueryHookResult = ReturnType<typeof useGetPropertyTypeListQuery>;
export type GetPropertyTypeListLazyQueryHookResult = ReturnType<typeof useGetPropertyTypeListLazyQuery>;
export type GetPropertyTypeListQueryResult = Apollo.QueryResult<GetPropertyTypeListQuery, GetPropertyTypeListQueryVariables>;
export const GetSalesPerformanceStatusDocument = gql`
    query getSalesPerformanceStatus {
  getSalesPerformanceStatus {
    code
    desc
  }
}
    `;

/**
 * __useGetSalesPerformanceStatusQuery__
 *
 * To run a query within a React component, call `useGetSalesPerformanceStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesPerformanceStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesPerformanceStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSalesPerformanceStatusQuery(baseOptions?: Apollo.QueryHookOptions<GetSalesPerformanceStatusQuery, GetSalesPerformanceStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesPerformanceStatusQuery, GetSalesPerformanceStatusQueryVariables>(GetSalesPerformanceStatusDocument, options);
      }
export function useGetSalesPerformanceStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesPerformanceStatusQuery, GetSalesPerformanceStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesPerformanceStatusQuery, GetSalesPerformanceStatusQueryVariables>(GetSalesPerformanceStatusDocument, options);
        }
export type GetSalesPerformanceStatusQueryHookResult = ReturnType<typeof useGetSalesPerformanceStatusQuery>;
export type GetSalesPerformanceStatusLazyQueryHookResult = ReturnType<typeof useGetSalesPerformanceStatusLazyQuery>;
export type GetSalesPerformanceStatusQueryResult = Apollo.QueryResult<GetSalesPerformanceStatusQuery, GetSalesPerformanceStatusQueryVariables>;
export const GetUnitTypeDocument = gql`
    query getUnitType {
  getUnitType {
    unitTypeId
    name
  }
}
    `;

/**
 * __useGetUnitTypeQuery__
 *
 * To run a query within a React component, call `useGetUnitTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitTypeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUnitTypeQuery(baseOptions?: Apollo.QueryHookOptions<GetUnitTypeQuery, GetUnitTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitTypeQuery, GetUnitTypeQueryVariables>(GetUnitTypeDocument, options);
      }
export function useGetUnitTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitTypeQuery, GetUnitTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitTypeQuery, GetUnitTypeQueryVariables>(GetUnitTypeDocument, options);
        }
export type GetUnitTypeQueryHookResult = ReturnType<typeof useGetUnitTypeQuery>;
export type GetUnitTypeLazyQueryHookResult = ReturnType<typeof useGetUnitTypeLazyQuery>;
export type GetUnitTypeQueryResult = Apollo.QueryResult<GetUnitTypeQuery, GetUnitTypeQueryVariables>;
export const GetSalesTeamStatusDocument = gql`
    query getSalesTeamStatus {
  getSalesTeamStatus {
    code
    desc
  }
}
    `;

/**
 * __useGetSalesTeamStatusQuery__
 *
 * To run a query within a React component, call `useGetSalesTeamStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesTeamStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesTeamStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSalesTeamStatusQuery(baseOptions?: Apollo.QueryHookOptions<GetSalesTeamStatusQuery, GetSalesTeamStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesTeamStatusQuery, GetSalesTeamStatusQueryVariables>(GetSalesTeamStatusDocument, options);
      }
export function useGetSalesTeamStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesTeamStatusQuery, GetSalesTeamStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesTeamStatusQuery, GetSalesTeamStatusQueryVariables>(GetSalesTeamStatusDocument, options);
        }
export type GetSalesTeamStatusQueryHookResult = ReturnType<typeof useGetSalesTeamStatusQuery>;
export type GetSalesTeamStatusLazyQueryHookResult = ReturnType<typeof useGetSalesTeamStatusLazyQuery>;
export type GetSalesTeamStatusQueryResult = Apollo.QueryResult<GetSalesTeamStatusQuery, GetSalesTeamStatusQueryVariables>;
export const GetLeadStatusDocument = gql`
    query getLeadStatus {
  getLeadStatus {
    code
    desc
  }
}
    `;

/**
 * __useGetLeadStatusQuery__
 *
 * To run a query within a React component, call `useGetLeadStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeadStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeadStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLeadStatusQuery(baseOptions?: Apollo.QueryHookOptions<GetLeadStatusQuery, GetLeadStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeadStatusQuery, GetLeadStatusQueryVariables>(GetLeadStatusDocument, options);
      }
export function useGetLeadStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeadStatusQuery, GetLeadStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeadStatusQuery, GetLeadStatusQueryVariables>(GetLeadStatusDocument, options);
        }
export type GetLeadStatusQueryHookResult = ReturnType<typeof useGetLeadStatusQuery>;
export type GetLeadStatusLazyQueryHookResult = ReturnType<typeof useGetLeadStatusLazyQuery>;
export type GetLeadStatusQueryResult = Apollo.QueryResult<GetLeadStatusQuery, GetLeadStatusQueryVariables>;
export const GetSalesTeamDocument = gql`
    query getSalesTeam($status: String!) {
  getSalesTeam(status: $status) {
    teamId
    name
  }
}
    `;

/**
 * __useGetSalesTeamQuery__
 *
 * To run a query within a React component, call `useGetSalesTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesTeamQuery({
 *   variables: {
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetSalesTeamQuery(baseOptions: Apollo.QueryHookOptions<GetSalesTeamQuery, GetSalesTeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesTeamQuery, GetSalesTeamQueryVariables>(GetSalesTeamDocument, options);
      }
export function useGetSalesTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesTeamQuery, GetSalesTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesTeamQuery, GetSalesTeamQueryVariables>(GetSalesTeamDocument, options);
        }
export type GetSalesTeamQueryHookResult = ReturnType<typeof useGetSalesTeamQuery>;
export type GetSalesTeamLazyQueryHookResult = ReturnType<typeof useGetSalesTeamLazyQuery>;
export type GetSalesTeamQueryResult = Apollo.QueryResult<GetSalesTeamQuery, GetSalesTeamQueryVariables>;
export const GetLoanAndFinancierDocument = gql`
    query getLoanAndFinancier {
  getProjectLoanFinancier {
    financierId
    name
  }
  getLoanStatus {
    code
    desc
  }
}
    `;

/**
 * __useGetLoanAndFinancierQuery__
 *
 * To run a query within a React component, call `useGetLoanAndFinancierQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoanAndFinancierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoanAndFinancierQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLoanAndFinancierQuery(baseOptions?: Apollo.QueryHookOptions<GetLoanAndFinancierQuery, GetLoanAndFinancierQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoanAndFinancierQuery, GetLoanAndFinancierQueryVariables>(GetLoanAndFinancierDocument, options);
      }
export function useGetLoanAndFinancierLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLoanAndFinancierQuery, GetLoanAndFinancierQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoanAndFinancierQuery, GetLoanAndFinancierQueryVariables>(GetLoanAndFinancierDocument, options);
        }
export type GetLoanAndFinancierQueryHookResult = ReturnType<typeof useGetLoanAndFinancierQuery>;
export type GetLoanAndFinancierLazyQueryHookResult = ReturnType<typeof useGetLoanAndFinancierLazyQuery>;
export type GetLoanAndFinancierQueryResult = Apollo.QueryResult<GetLoanAndFinancierQuery, GetLoanAndFinancierQueryVariables>;
export const ExportSalesPerformanceDocument = gql`
    query exportSalesPerformance($status: String!, $startDate: DateTime!, $endDate: DateTime!) {
  exportSalesPerformance(status: $status, startDate: $startDate, endDate: $endDate) {
    base64
    projectName
  }
}
    `;

/**
 * __useExportSalesPerformanceQuery__
 *
 * To run a query within a React component, call `useExportSalesPerformanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportSalesPerformanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportSalesPerformanceQuery({
 *   variables: {
 *      status: // value for 'status'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useExportSalesPerformanceQuery(baseOptions: Apollo.QueryHookOptions<ExportSalesPerformanceQuery, ExportSalesPerformanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportSalesPerformanceQuery, ExportSalesPerformanceQueryVariables>(ExportSalesPerformanceDocument, options);
      }
export function useExportSalesPerformanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportSalesPerformanceQuery, ExportSalesPerformanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportSalesPerformanceQuery, ExportSalesPerformanceQueryVariables>(ExportSalesPerformanceDocument, options);
        }
export type ExportSalesPerformanceQueryHookResult = ReturnType<typeof useExportSalesPerformanceQuery>;
export type ExportSalesPerformanceLazyQueryHookResult = ReturnType<typeof useExportSalesPerformanceLazyQuery>;
export type ExportSalesPerformanceQueryResult = Apollo.QueryResult<ExportSalesPerformanceQuery, ExportSalesPerformanceQueryVariables>;
export const ExportLotStatusMovementDocument = gql`
    query exportLotStatusMovement($status: String!, $startDate: DateTime!, $endDate: DateTime!) {
  exportLotStatusMovement(status: $status, startDate: $startDate, endDate: $endDate) {
    base64
    projectName
  }
}
    `;

/**
 * __useExportLotStatusMovementQuery__
 *
 * To run a query within a React component, call `useExportLotStatusMovementQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportLotStatusMovementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportLotStatusMovementQuery({
 *   variables: {
 *      status: // value for 'status'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useExportLotStatusMovementQuery(baseOptions: Apollo.QueryHookOptions<ExportLotStatusMovementQuery, ExportLotStatusMovementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportLotStatusMovementQuery, ExportLotStatusMovementQueryVariables>(ExportLotStatusMovementDocument, options);
      }
export function useExportLotStatusMovementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportLotStatusMovementQuery, ExportLotStatusMovementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportLotStatusMovementQuery, ExportLotStatusMovementQueryVariables>(ExportLotStatusMovementDocument, options);
        }
export type ExportLotStatusMovementQueryHookResult = ReturnType<typeof useExportLotStatusMovementQuery>;
export type ExportLotStatusMovementLazyQueryHookResult = ReturnType<typeof useExportLotStatusMovementLazyQuery>;
export type ExportLotStatusMovementQueryResult = Apollo.QueryResult<ExportLotStatusMovementQuery, ExportLotStatusMovementQueryVariables>;
export const ExportSalesMovementDocument = gql`
    query exportSalesMovement($status: String!, $startDate: DateTime!, $endDate: DateTime!) {
  exportSalesMovement(status: $status, startDate: $startDate, endDate: $endDate) {
    base64
    projectName
  }
}
    `;

/**
 * __useExportSalesMovementQuery__
 *
 * To run a query within a React component, call `useExportSalesMovementQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportSalesMovementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportSalesMovementQuery({
 *   variables: {
 *      status: // value for 'status'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useExportSalesMovementQuery(baseOptions: Apollo.QueryHookOptions<ExportSalesMovementQuery, ExportSalesMovementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportSalesMovementQuery, ExportSalesMovementQueryVariables>(ExportSalesMovementDocument, options);
      }
export function useExportSalesMovementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportSalesMovementQuery, ExportSalesMovementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportSalesMovementQuery, ExportSalesMovementQueryVariables>(ExportSalesMovementDocument, options);
        }
export type ExportSalesMovementQueryHookResult = ReturnType<typeof useExportSalesMovementQuery>;
export type ExportSalesMovementLazyQueryHookResult = ReturnType<typeof useExportSalesMovementLazyQuery>;
export type ExportSalesMovementQueryResult = Apollo.QueryResult<ExportSalesMovementQuery, ExportSalesMovementQueryVariables>;
export const ExportSalesAnalysisDocument = gql`
    query exportSalesAnalysis($status: String!, $startDate: DateTime!, $endDate: DateTime!) {
  exportSalesAnalysis(status: $status, startDate: $startDate, endDate: $endDate) {
    base64
    projectName
  }
}
    `;

/**
 * __useExportSalesAnalysisQuery__
 *
 * To run a query within a React component, call `useExportSalesAnalysisQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportSalesAnalysisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportSalesAnalysisQuery({
 *   variables: {
 *      status: // value for 'status'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useExportSalesAnalysisQuery(baseOptions: Apollo.QueryHookOptions<ExportSalesAnalysisQuery, ExportSalesAnalysisQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportSalesAnalysisQuery, ExportSalesAnalysisQueryVariables>(ExportSalesAnalysisDocument, options);
      }
export function useExportSalesAnalysisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportSalesAnalysisQuery, ExportSalesAnalysisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportSalesAnalysisQuery, ExportSalesAnalysisQueryVariables>(ExportSalesAnalysisDocument, options);
        }
export type ExportSalesAnalysisQueryHookResult = ReturnType<typeof useExportSalesAnalysisQuery>;
export type ExportSalesAnalysisLazyQueryHookResult = ReturnType<typeof useExportSalesAnalysisLazyQuery>;
export type ExportSalesAnalysisQueryResult = Apollo.QueryResult<ExportSalesAnalysisQuery, ExportSalesAnalysisQueryVariables>;
export const ExportSalesAnalysisByUnitDocument = gql`
    query exportSalesAnalysisByUnit($status: String!, $startDate: DateTime!, $endDate: DateTime!) {
  exportSalesAnalysisByUnit(status: $status, startDate: $startDate, endDate: $endDate) {
    base64
    projectName
  }
}
    `;

/**
 * __useExportSalesAnalysisByUnitQuery__
 *
 * To run a query within a React component, call `useExportSalesAnalysisByUnitQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportSalesAnalysisByUnitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportSalesAnalysisByUnitQuery({
 *   variables: {
 *      status: // value for 'status'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useExportSalesAnalysisByUnitQuery(baseOptions: Apollo.QueryHookOptions<ExportSalesAnalysisByUnitQuery, ExportSalesAnalysisByUnitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportSalesAnalysisByUnitQuery, ExportSalesAnalysisByUnitQueryVariables>(ExportSalesAnalysisByUnitDocument, options);
      }
export function useExportSalesAnalysisByUnitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportSalesAnalysisByUnitQuery, ExportSalesAnalysisByUnitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportSalesAnalysisByUnitQuery, ExportSalesAnalysisByUnitQueryVariables>(ExportSalesAnalysisByUnitDocument, options);
        }
export type ExportSalesAnalysisByUnitQueryHookResult = ReturnType<typeof useExportSalesAnalysisByUnitQuery>;
export type ExportSalesAnalysisByUnitLazyQueryHookResult = ReturnType<typeof useExportSalesAnalysisByUnitLazyQuery>;
export type ExportSalesAnalysisByUnitQueryResult = Apollo.QueryResult<ExportSalesAnalysisByUnitQuery, ExportSalesAnalysisByUnitQueryVariables>;
export const ExportSalesDemographicAnalysisDocument = gql`
    query exportSalesDemographicAnalysis($startDate: DateTime!, $endDate: DateTime!) {
  exportSalesDemographicAnalysis(startDate: $startDate, endDate: $endDate) {
    base64
    projectName
  }
}
    `;

/**
 * __useExportSalesDemographicAnalysisQuery__
 *
 * To run a query within a React component, call `useExportSalesDemographicAnalysisQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportSalesDemographicAnalysisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportSalesDemographicAnalysisQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useExportSalesDemographicAnalysisQuery(baseOptions: Apollo.QueryHookOptions<ExportSalesDemographicAnalysisQuery, ExportSalesDemographicAnalysisQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportSalesDemographicAnalysisQuery, ExportSalesDemographicAnalysisQueryVariables>(ExportSalesDemographicAnalysisDocument, options);
      }
export function useExportSalesDemographicAnalysisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportSalesDemographicAnalysisQuery, ExportSalesDemographicAnalysisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportSalesDemographicAnalysisQuery, ExportSalesDemographicAnalysisQueryVariables>(ExportSalesDemographicAnalysisDocument, options);
        }
export type ExportSalesDemographicAnalysisQueryHookResult = ReturnType<typeof useExportSalesDemographicAnalysisQuery>;
export type ExportSalesDemographicAnalysisLazyQueryHookResult = ReturnType<typeof useExportSalesDemographicAnalysisLazyQuery>;
export type ExportSalesDemographicAnalysisQueryResult = Apollo.QueryResult<ExportSalesDemographicAnalysisQuery, ExportSalesDemographicAnalysisQueryVariables>;
export const ExportWaitListByUnitTypeDocument = gql`
    query exportWaitListByUnitType($unitType: String!, $startDate: DateTime!, $endDate: DateTime!) {
  exportWaitListByUnitType(unitType: $unitType, startDate: $startDate, endDate: $endDate) {
    base64
    projectName
  }
}
    `;

/**
 * __useExportWaitListByUnitTypeQuery__
 *
 * To run a query within a React component, call `useExportWaitListByUnitTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportWaitListByUnitTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportWaitListByUnitTypeQuery({
 *   variables: {
 *      unitType: // value for 'unitType'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useExportWaitListByUnitTypeQuery(baseOptions: Apollo.QueryHookOptions<ExportWaitListByUnitTypeQuery, ExportWaitListByUnitTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportWaitListByUnitTypeQuery, ExportWaitListByUnitTypeQueryVariables>(ExportWaitListByUnitTypeDocument, options);
      }
export function useExportWaitListByUnitTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportWaitListByUnitTypeQuery, ExportWaitListByUnitTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportWaitListByUnitTypeQuery, ExportWaitListByUnitTypeQueryVariables>(ExportWaitListByUnitTypeDocument, options);
        }
export type ExportWaitListByUnitTypeQueryHookResult = ReturnType<typeof useExportWaitListByUnitTypeQuery>;
export type ExportWaitListByUnitTypeLazyQueryHookResult = ReturnType<typeof useExportWaitListByUnitTypeLazyQuery>;
export type ExportWaitListByUnitTypeQueryResult = Apollo.QueryResult<ExportWaitListByUnitTypeQuery, ExportWaitListByUnitTypeQueryVariables>;
export const ExportCampaignPerformanceDocument = gql`
    query exportCampaignPerformance($startDate: DateTime!, $endDate: DateTime!) {
  exportCampaignPerformance(startDate: $startDate, endDate: $endDate) {
    base64
    projectName
  }
}
    `;

/**
 * __useExportCampaignPerformanceQuery__
 *
 * To run a query within a React component, call `useExportCampaignPerformanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportCampaignPerformanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportCampaignPerformanceQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useExportCampaignPerformanceQuery(baseOptions: Apollo.QueryHookOptions<ExportCampaignPerformanceQuery, ExportCampaignPerformanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportCampaignPerformanceQuery, ExportCampaignPerformanceQueryVariables>(ExportCampaignPerformanceDocument, options);
      }
export function useExportCampaignPerformanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportCampaignPerformanceQuery, ExportCampaignPerformanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportCampaignPerformanceQuery, ExportCampaignPerformanceQueryVariables>(ExportCampaignPerformanceDocument, options);
        }
export type ExportCampaignPerformanceQueryHookResult = ReturnType<typeof useExportCampaignPerformanceQuery>;
export type ExportCampaignPerformanceLazyQueryHookResult = ReturnType<typeof useExportCampaignPerformanceLazyQuery>;
export type ExportCampaignPerformanceQueryResult = Apollo.QueryResult<ExportCampaignPerformanceQuery, ExportCampaignPerformanceQueryVariables>;
export const ExportTeamPerformanceDocument = gql`
    query exportTeamPerformance($startDate: DateTime!, $endDate: DateTime!) {
  exportTeamPerformance(startDate: $startDate, endDate: $endDate) {
    base64
    projectName
  }
}
    `;

/**
 * __useExportTeamPerformanceQuery__
 *
 * To run a query within a React component, call `useExportTeamPerformanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportTeamPerformanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportTeamPerformanceQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useExportTeamPerformanceQuery(baseOptions: Apollo.QueryHookOptions<ExportTeamPerformanceQuery, ExportTeamPerformanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportTeamPerformanceQuery, ExportTeamPerformanceQueryVariables>(ExportTeamPerformanceDocument, options);
      }
export function useExportTeamPerformanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportTeamPerformanceQuery, ExportTeamPerformanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportTeamPerformanceQuery, ExportTeamPerformanceQueryVariables>(ExportTeamPerformanceDocument, options);
        }
export type ExportTeamPerformanceQueryHookResult = ReturnType<typeof useExportTeamPerformanceQuery>;
export type ExportTeamPerformanceLazyQueryHookResult = ReturnType<typeof useExportTeamPerformanceLazyQuery>;
export type ExportTeamPerformanceQueryResult = Apollo.QueryResult<ExportTeamPerformanceQuery, ExportTeamPerformanceQueryVariables>;
export const ExportSalesLeadPerformanceDocument = gql`
    query exportSalesLeadPerformance($status: String!, $startDate: DateTime!, $endDate: DateTime!) {
  exportSalesLeadPerformance(status: $status, startDate: $startDate, endDate: $endDate) {
    base64
    projectName
  }
}
    `;

/**
 * __useExportSalesLeadPerformanceQuery__
 *
 * To run a query within a React component, call `useExportSalesLeadPerformanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportSalesLeadPerformanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportSalesLeadPerformanceQuery({
 *   variables: {
 *      status: // value for 'status'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useExportSalesLeadPerformanceQuery(baseOptions: Apollo.QueryHookOptions<ExportSalesLeadPerformanceQuery, ExportSalesLeadPerformanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportSalesLeadPerformanceQuery, ExportSalesLeadPerformanceQueryVariables>(ExportSalesLeadPerformanceDocument, options);
      }
export function useExportSalesLeadPerformanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportSalesLeadPerformanceQuery, ExportSalesLeadPerformanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportSalesLeadPerformanceQuery, ExportSalesLeadPerformanceQueryVariables>(ExportSalesLeadPerformanceDocument, options);
        }
export type ExportSalesLeadPerformanceQueryHookResult = ReturnType<typeof useExportSalesLeadPerformanceQuery>;
export type ExportSalesLeadPerformanceLazyQueryHookResult = ReturnType<typeof useExportSalesLeadPerformanceLazyQuery>;
export type ExportSalesLeadPerformanceQueryResult = Apollo.QueryResult<ExportSalesLeadPerformanceQuery, ExportSalesLeadPerformanceQueryVariables>;
export const ExportTrackingOfPaymentMethodDocument = gql`
    query exportTrackingOfPaymentMethod($startDate: DateTime!, $endDate: DateTime!) {
  exportTrackingOfPaymentMethod(startDate: $startDate, endDate: $endDate) {
    base64
    projectName
  }
}
    `;

/**
 * __useExportTrackingOfPaymentMethodQuery__
 *
 * To run a query within a React component, call `useExportTrackingOfPaymentMethodQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportTrackingOfPaymentMethodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportTrackingOfPaymentMethodQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useExportTrackingOfPaymentMethodQuery(baseOptions: Apollo.QueryHookOptions<ExportTrackingOfPaymentMethodQuery, ExportTrackingOfPaymentMethodQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportTrackingOfPaymentMethodQuery, ExportTrackingOfPaymentMethodQueryVariables>(ExportTrackingOfPaymentMethodDocument, options);
      }
export function useExportTrackingOfPaymentMethodLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportTrackingOfPaymentMethodQuery, ExportTrackingOfPaymentMethodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportTrackingOfPaymentMethodQuery, ExportTrackingOfPaymentMethodQueryVariables>(ExportTrackingOfPaymentMethodDocument, options);
        }
export type ExportTrackingOfPaymentMethodQueryHookResult = ReturnType<typeof useExportTrackingOfPaymentMethodQuery>;
export type ExportTrackingOfPaymentMethodLazyQueryHookResult = ReturnType<typeof useExportTrackingOfPaymentMethodLazyQuery>;
export type ExportTrackingOfPaymentMethodQueryResult = Apollo.QueryResult<ExportTrackingOfPaymentMethodQuery, ExportTrackingOfPaymentMethodQueryVariables>;
export const ExportBookingListAnalysisDocument = gql`
    query exportBookingListAnalysis($startDate: DateTime!, $endDate: DateTime!) {
  exportBookingListAnalysis(startDate: $startDate, endDate: $endDate) {
    base64
    projectName
  }
}
    `;

/**
 * __useExportBookingListAnalysisQuery__
 *
 * To run a query within a React component, call `useExportBookingListAnalysisQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportBookingListAnalysisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportBookingListAnalysisQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useExportBookingListAnalysisQuery(baseOptions: Apollo.QueryHookOptions<ExportBookingListAnalysisQuery, ExportBookingListAnalysisQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportBookingListAnalysisQuery, ExportBookingListAnalysisQueryVariables>(ExportBookingListAnalysisDocument, options);
      }
export function useExportBookingListAnalysisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportBookingListAnalysisQuery, ExportBookingListAnalysisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportBookingListAnalysisQuery, ExportBookingListAnalysisQueryVariables>(ExportBookingListAnalysisDocument, options);
        }
export type ExportBookingListAnalysisQueryHookResult = ReturnType<typeof useExportBookingListAnalysisQuery>;
export type ExportBookingListAnalysisLazyQueryHookResult = ReturnType<typeof useExportBookingListAnalysisLazyQuery>;
export type ExportBookingListAnalysisQueryResult = Apollo.QueryResult<ExportBookingListAnalysisQuery, ExportBookingListAnalysisQueryVariables>;
export const ExportLoanAndFinancingDocument = gql`
    query exportLoanAndFinancing($financier: String!, $status: String!, $startDate: DateTime!, $endDate: DateTime!) {
  exportLoanAndFinancing(financier: $financier, status: $status, startDate: $startDate, endDate: $endDate) {
    base64
    projectName
  }
}
    `;

/**
 * __useExportLoanAndFinancingQuery__
 *
 * To run a query within a React component, call `useExportLoanAndFinancingQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportLoanAndFinancingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportLoanAndFinancingQuery({
 *   variables: {
 *      financier: // value for 'financier'
 *      status: // value for 'status'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useExportLoanAndFinancingQuery(baseOptions: Apollo.QueryHookOptions<ExportLoanAndFinancingQuery, ExportLoanAndFinancingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportLoanAndFinancingQuery, ExportLoanAndFinancingQueryVariables>(ExportLoanAndFinancingDocument, options);
      }
export function useExportLoanAndFinancingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportLoanAndFinancingQuery, ExportLoanAndFinancingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportLoanAndFinancingQuery, ExportLoanAndFinancingQueryVariables>(ExportLoanAndFinancingDocument, options);
        }
export type ExportLoanAndFinancingQueryHookResult = ReturnType<typeof useExportLoanAndFinancingQuery>;
export type ExportLoanAndFinancingLazyQueryHookResult = ReturnType<typeof useExportLoanAndFinancingLazyQuery>;
export type ExportLoanAndFinancingQueryResult = Apollo.QueryResult<ExportLoanAndFinancingQuery, ExportLoanAndFinancingQueryVariables>;
export const ExportOutstandingSpDocument = gql`
    query exportOutstandingSP($startDate: DateTime!, $endDate: DateTime!) {
  exportOutstandingSP(startDate: $startDate, endDate: $endDate) {
    base64
    projectName
  }
}
    `;

/**
 * __useExportOutstandingSpQuery__
 *
 * To run a query within a React component, call `useExportOutstandingSpQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportOutstandingSpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportOutstandingSpQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useExportOutstandingSpQuery(baseOptions: Apollo.QueryHookOptions<ExportOutstandingSpQuery, ExportOutstandingSpQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportOutstandingSpQuery, ExportOutstandingSpQueryVariables>(ExportOutstandingSpDocument, options);
      }
export function useExportOutstandingSpLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportOutstandingSpQuery, ExportOutstandingSpQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportOutstandingSpQuery, ExportOutstandingSpQueryVariables>(ExportOutstandingSpDocument, options);
        }
export type ExportOutstandingSpQueryHookResult = ReturnType<typeof useExportOutstandingSpQuery>;
export type ExportOutstandingSpLazyQueryHookResult = ReturnType<typeof useExportOutstandingSpLazyQuery>;
export type ExportOutstandingSpQueryResult = Apollo.QueryResult<ExportOutstandingSpQuery, ExportOutstandingSpQueryVariables>;
export const GetAllProjectTitleDocument = gql`
    query getAllProjectTitle {
  getAllProjectTitle {
    id
    projectId
    accountId
    titleType
    titleNo
    issueDate
    receiveDate
    expiryDate
    remark
    unitIndex
    projectTitleUnits {
      unitId
      units {
        unitNo
      }
    }
  }
}
    `;

/**
 * __useGetAllProjectTitleQuery__
 *
 * To run a query within a React component, call `useGetAllProjectTitleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllProjectTitleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllProjectTitleQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllProjectTitleQuery(baseOptions?: Apollo.QueryHookOptions<GetAllProjectTitleQuery, GetAllProjectTitleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllProjectTitleQuery, GetAllProjectTitleQueryVariables>(GetAllProjectTitleDocument, options);
      }
export function useGetAllProjectTitleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllProjectTitleQuery, GetAllProjectTitleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllProjectTitleQuery, GetAllProjectTitleQueryVariables>(GetAllProjectTitleDocument, options);
        }
export type GetAllProjectTitleQueryHookResult = ReturnType<typeof useGetAllProjectTitleQuery>;
export type GetAllProjectTitleLazyQueryHookResult = ReturnType<typeof useGetAllProjectTitleLazyQuery>;
export type GetAllProjectTitleQueryResult = Apollo.QueryResult<GetAllProjectTitleQuery, GetAllProjectTitleQueryVariables>;
export const GetProjectTitleByIdDocument = gql`
    query getProjectTitleById($projectId: String!, $id: String!) {
  getProjectTitleById(projectId: $projectId, id: $id) {
    id
    projectId
    accountId
    titleType
    titleNo
    issueDate
    receiveDate
    expiryDate
    remark
    projectTitleUnits {
      unitId
    }
  }
}
    `;

/**
 * __useGetProjectTitleByIdQuery__
 *
 * To run a query within a React component, call `useGetProjectTitleByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectTitleByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectTitleByIdQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectTitleByIdQuery(baseOptions: Apollo.QueryHookOptions<GetProjectTitleByIdQuery, GetProjectTitleByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectTitleByIdQuery, GetProjectTitleByIdQueryVariables>(GetProjectTitleByIdDocument, options);
      }
export function useGetProjectTitleByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectTitleByIdQuery, GetProjectTitleByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectTitleByIdQuery, GetProjectTitleByIdQueryVariables>(GetProjectTitleByIdDocument, options);
        }
export type GetProjectTitleByIdQueryHookResult = ReturnType<typeof useGetProjectTitleByIdQuery>;
export type GetProjectTitleByIdLazyQueryHookResult = ReturnType<typeof useGetProjectTitleByIdLazyQuery>;
export type GetProjectTitleByIdQueryResult = Apollo.QueryResult<GetProjectTitleByIdQuery, GetProjectTitleByIdQueryVariables>;
export const GetUnitPropertyTitleCreateDocument = gql`
    query getUnitPropertyTitleCreate($projectId: String!, $propertyTitleId: String) {
  getUnitPropertyTitleCreate(projectId: $projectId, propertyTitleId: $propertyTitleId) {
    block
    totalFloor
    floorList {
      floorLabel
      totalUnit
      unitList {
        unitId
        unitNo
      }
    }
  }
}
    `;

/**
 * __useGetUnitPropertyTitleCreateQuery__
 *
 * To run a query within a React component, call `useGetUnitPropertyTitleCreateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitPropertyTitleCreateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitPropertyTitleCreateQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      propertyTitleId: // value for 'propertyTitleId'
 *   },
 * });
 */
export function useGetUnitPropertyTitleCreateQuery(baseOptions: Apollo.QueryHookOptions<GetUnitPropertyTitleCreateQuery, GetUnitPropertyTitleCreateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitPropertyTitleCreateQuery, GetUnitPropertyTitleCreateQueryVariables>(GetUnitPropertyTitleCreateDocument, options);
      }
export function useGetUnitPropertyTitleCreateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitPropertyTitleCreateQuery, GetUnitPropertyTitleCreateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitPropertyTitleCreateQuery, GetUnitPropertyTitleCreateQueryVariables>(GetUnitPropertyTitleCreateDocument, options);
        }
export type GetUnitPropertyTitleCreateQueryHookResult = ReturnType<typeof useGetUnitPropertyTitleCreateQuery>;
export type GetUnitPropertyTitleCreateLazyQueryHookResult = ReturnType<typeof useGetUnitPropertyTitleCreateLazyQuery>;
export type GetUnitPropertyTitleCreateQueryResult = Apollo.QueryResult<GetUnitPropertyTitleCreateQuery, GetUnitPropertyTitleCreateQueryVariables>;
export const GetFloorByProjectBlockDocument = gql`
    query GetFloorByProjectBlock($Block: String!, $ProjectId: String!) {
  GetFloorByProjectBlock(Block: $Block, ProjectId: $ProjectId) {
    projectid
    block
    floor
    floorlabel
    Unit {
      projectId
      unitNo
      id
      unitNo
      phase
      builtUp
      price
      cell
      unitTypeId
      unitLayoutId
      block
      floorLabel
      floor
      unitStatus
      unitLockBy
    }
  }
}
    `;

/**
 * __useGetFloorByProjectBlockQuery__
 *
 * To run a query within a React component, call `useGetFloorByProjectBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFloorByProjectBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFloorByProjectBlockQuery({
 *   variables: {
 *      Block: // value for 'Block'
 *      ProjectId: // value for 'ProjectId'
 *   },
 * });
 */
export function useGetFloorByProjectBlockQuery(baseOptions: Apollo.QueryHookOptions<GetFloorByProjectBlockQuery, GetFloorByProjectBlockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFloorByProjectBlockQuery, GetFloorByProjectBlockQueryVariables>(GetFloorByProjectBlockDocument, options);
      }
export function useGetFloorByProjectBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFloorByProjectBlockQuery, GetFloorByProjectBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFloorByProjectBlockQuery, GetFloorByProjectBlockQueryVariables>(GetFloorByProjectBlockDocument, options);
        }
export type GetFloorByProjectBlockQueryHookResult = ReturnType<typeof useGetFloorByProjectBlockQuery>;
export type GetFloorByProjectBlockLazyQueryHookResult = ReturnType<typeof useGetFloorByProjectBlockLazyQuery>;
export type GetFloorByProjectBlockQueryResult = Apollo.QueryResult<GetFloorByProjectBlockQuery, GetFloorByProjectBlockQueryVariables>;
export const AddProjectTitleDocument = gql`
    mutation addProjectTitle($input: AddProjectTitleInput!) {
  addProjectTitle(input: $input)
}
    `;
export type AddProjectTitleMutationFn = Apollo.MutationFunction<AddProjectTitleMutation, AddProjectTitleMutationVariables>;

/**
 * __useAddProjectTitleMutation__
 *
 * To run a mutation, you first call `useAddProjectTitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProjectTitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProjectTitleMutation, { data, loading, error }] = useAddProjectTitleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddProjectTitleMutation(baseOptions?: Apollo.MutationHookOptions<AddProjectTitleMutation, AddProjectTitleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProjectTitleMutation, AddProjectTitleMutationVariables>(AddProjectTitleDocument, options);
      }
export type AddProjectTitleMutationHookResult = ReturnType<typeof useAddProjectTitleMutation>;
export type AddProjectTitleMutationResult = Apollo.MutationResult<AddProjectTitleMutation>;
export type AddProjectTitleMutationOptions = Apollo.BaseMutationOptions<AddProjectTitleMutation, AddProjectTitleMutationVariables>;
export const EditProjectTitleDocument = gql`
    mutation editProjectTitle($input: EditProjectTitleInput!) {
  editProjectTitle(input: $input)
}
    `;
export type EditProjectTitleMutationFn = Apollo.MutationFunction<EditProjectTitleMutation, EditProjectTitleMutationVariables>;

/**
 * __useEditProjectTitleMutation__
 *
 * To run a mutation, you first call `useEditProjectTitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditProjectTitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editProjectTitleMutation, { data, loading, error }] = useEditProjectTitleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditProjectTitleMutation(baseOptions?: Apollo.MutationHookOptions<EditProjectTitleMutation, EditProjectTitleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditProjectTitleMutation, EditProjectTitleMutationVariables>(EditProjectTitleDocument, options);
      }
export type EditProjectTitleMutationHookResult = ReturnType<typeof useEditProjectTitleMutation>;
export type EditProjectTitleMutationResult = Apollo.MutationResult<EditProjectTitleMutation>;
export type EditProjectTitleMutationOptions = Apollo.BaseMutationOptions<EditProjectTitleMutation, EditProjectTitleMutationVariables>;
export const DeleteProjectTitleDocument = gql`
    mutation deleteProjectTitle($projectTitleId: String!) {
  deleteProjectTitle(projectTitleId: $projectTitleId)
}
    `;
export type DeleteProjectTitleMutationFn = Apollo.MutationFunction<DeleteProjectTitleMutation, DeleteProjectTitleMutationVariables>;

/**
 * __useDeleteProjectTitleMutation__
 *
 * To run a mutation, you first call `useDeleteProjectTitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectTitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectTitleMutation, { data, loading, error }] = useDeleteProjectTitleMutation({
 *   variables: {
 *      projectTitleId: // value for 'projectTitleId'
 *   },
 * });
 */
export function useDeleteProjectTitleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectTitleMutation, DeleteProjectTitleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectTitleMutation, DeleteProjectTitleMutationVariables>(DeleteProjectTitleDocument, options);
      }
export type DeleteProjectTitleMutationHookResult = ReturnType<typeof useDeleteProjectTitleMutation>;
export type DeleteProjectTitleMutationResult = Apollo.MutationResult<DeleteProjectTitleMutation>;
export type DeleteProjectTitleMutationOptions = Apollo.BaseMutationOptions<DeleteProjectTitleMutation, DeleteProjectTitleMutationVariables>;
export const GetPropertyTitleTypeDocument = gql`
    query getPropertyTitleType {
  getPropertyTitleType
}
    `;

/**
 * __useGetPropertyTitleTypeQuery__
 *
 * To run a query within a React component, call `useGetPropertyTitleTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertyTitleTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertyTitleTypeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPropertyTitleTypeQuery(baseOptions?: Apollo.QueryHookOptions<GetPropertyTitleTypeQuery, GetPropertyTitleTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertyTitleTypeQuery, GetPropertyTitleTypeQueryVariables>(GetPropertyTitleTypeDocument, options);
      }
export function useGetPropertyTitleTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertyTitleTypeQuery, GetPropertyTitleTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertyTitleTypeQuery, GetPropertyTitleTypeQueryVariables>(GetPropertyTitleTypeDocument, options);
        }
export type GetPropertyTitleTypeQueryHookResult = ReturnType<typeof useGetPropertyTitleTypeQuery>;
export type GetPropertyTitleTypeLazyQueryHookResult = ReturnType<typeof useGetPropertyTitleTypeLazyQuery>;
export type GetPropertyTitleTypeQueryResult = Apollo.QueryResult<GetPropertyTitleTypeQuery, GetPropertyTitleTypeQueryVariables>;
export const GetCollectionActivityDetailByIdDocument = gql`
    query getCollectionActivityDetailByID($id: String!) {
  getCollectionActivityDetailByID(id: $id) {
    activityDate
    activityRemark
    activityStatus
    attachment {
      allowDelete
      fileName
      id
      isPrivate
      mediaType
      resourceUrl
    }
  }
}
    `;

/**
 * __useGetCollectionActivityDetailByIdQuery__
 *
 * To run a query within a React component, call `useGetCollectionActivityDetailByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionActivityDetailByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionActivityDetailByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCollectionActivityDetailByIdQuery(baseOptions: Apollo.QueryHookOptions<GetCollectionActivityDetailByIdQuery, GetCollectionActivityDetailByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectionActivityDetailByIdQuery, GetCollectionActivityDetailByIdQueryVariables>(GetCollectionActivityDetailByIdDocument, options);
      }
export function useGetCollectionActivityDetailByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectionActivityDetailByIdQuery, GetCollectionActivityDetailByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectionActivityDetailByIdQuery, GetCollectionActivityDetailByIdQueryVariables>(GetCollectionActivityDetailByIdDocument, options);
        }
export type GetCollectionActivityDetailByIdQueryHookResult = ReturnType<typeof useGetCollectionActivityDetailByIdQuery>;
export type GetCollectionActivityDetailByIdLazyQueryHookResult = ReturnType<typeof useGetCollectionActivityDetailByIdLazyQuery>;
export type GetCollectionActivityDetailByIdQueryResult = Apollo.QueryResult<GetCollectionActivityDetailByIdQuery, GetCollectionActivityDetailByIdQueryVariables>;
export const GetCollectionActivityListingDocument = gql`
    query getCollectionActivityListing($saleId: String!) {
  getCollectionActivityListing(saleId: $saleId) {
    id
    accountId
    saleId
    activityDate
    activityRemark
    completedDate
    activityStatus
    commonStatus
    attachment {
      allowDelete
      fileName
      id
      isPrivate
      mediaType
      resourceUrl
    }
  }
}
    `;

/**
 * __useGetCollectionActivityListingQuery__
 *
 * To run a query within a React component, call `useGetCollectionActivityListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionActivityListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionActivityListingQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetCollectionActivityListingQuery(baseOptions: Apollo.QueryHookOptions<GetCollectionActivityListingQuery, GetCollectionActivityListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectionActivityListingQuery, GetCollectionActivityListingQueryVariables>(GetCollectionActivityListingDocument, options);
      }
export function useGetCollectionActivityListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectionActivityListingQuery, GetCollectionActivityListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectionActivityListingQuery, GetCollectionActivityListingQueryVariables>(GetCollectionActivityListingDocument, options);
        }
export type GetCollectionActivityListingQueryHookResult = ReturnType<typeof useGetCollectionActivityListingQuery>;
export type GetCollectionActivityListingLazyQueryHookResult = ReturnType<typeof useGetCollectionActivityListingLazyQuery>;
export type GetCollectionActivityListingQueryResult = Apollo.QueryResult<GetCollectionActivityListingQuery, GetCollectionActivityListingQueryVariables>;
export const GetCollectionActivitySummaryDocument = gql`
    query getCollectionActivitySummary($saleId: String!) {
  getCollectionActivitySummary(saleId: $saleId) {
    totalOutstanding
    purchaserDetail {
      email
      purchaserName
      unitNo
      phoneNo
      isCompany
      companyName
      officeTel
    }
  }
}
    `;

/**
 * __useGetCollectionActivitySummaryQuery__
 *
 * To run a query within a React component, call `useGetCollectionActivitySummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionActivitySummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionActivitySummaryQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetCollectionActivitySummaryQuery(baseOptions: Apollo.QueryHookOptions<GetCollectionActivitySummaryQuery, GetCollectionActivitySummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectionActivitySummaryQuery, GetCollectionActivitySummaryQueryVariables>(GetCollectionActivitySummaryDocument, options);
      }
export function useGetCollectionActivitySummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectionActivitySummaryQuery, GetCollectionActivitySummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectionActivitySummaryQuery, GetCollectionActivitySummaryQueryVariables>(GetCollectionActivitySummaryDocument, options);
        }
export type GetCollectionActivitySummaryQueryHookResult = ReturnType<typeof useGetCollectionActivitySummaryQuery>;
export type GetCollectionActivitySummaryLazyQueryHookResult = ReturnType<typeof useGetCollectionActivitySummaryLazyQuery>;
export type GetCollectionActivitySummaryQueryResult = Apollo.QueryResult<GetCollectionActivitySummaryQuery, GetCollectionActivitySummaryQueryVariables>;
export const AddPaCollectionActivityDocument = gql`
    mutation addPACollectionActivity($input: AddPACollectionActivityListingInput!) {
  addPACollectionActivity(input: $input)
}
    `;
export type AddPaCollectionActivityMutationFn = Apollo.MutationFunction<AddPaCollectionActivityMutation, AddPaCollectionActivityMutationVariables>;

/**
 * __useAddPaCollectionActivityMutation__
 *
 * To run a mutation, you first call `useAddPaCollectionActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPaCollectionActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPaCollectionActivityMutation, { data, loading, error }] = useAddPaCollectionActivityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPaCollectionActivityMutation(baseOptions?: Apollo.MutationHookOptions<AddPaCollectionActivityMutation, AddPaCollectionActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPaCollectionActivityMutation, AddPaCollectionActivityMutationVariables>(AddPaCollectionActivityDocument, options);
      }
export type AddPaCollectionActivityMutationHookResult = ReturnType<typeof useAddPaCollectionActivityMutation>;
export type AddPaCollectionActivityMutationResult = Apollo.MutationResult<AddPaCollectionActivityMutation>;
export type AddPaCollectionActivityMutationOptions = Apollo.BaseMutationOptions<AddPaCollectionActivityMutation, AddPaCollectionActivityMutationVariables>;
export const EditPaCollectionActivityDocument = gql`
    mutation editPACollectionActivity($input: EditPACollectionActivityInput!) {
  editPACollectionActivity(input: $input)
}
    `;
export type EditPaCollectionActivityMutationFn = Apollo.MutationFunction<EditPaCollectionActivityMutation, EditPaCollectionActivityMutationVariables>;

/**
 * __useEditPaCollectionActivityMutation__
 *
 * To run a mutation, you first call `useEditPaCollectionActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPaCollectionActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPaCollectionActivityMutation, { data, loading, error }] = useEditPaCollectionActivityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditPaCollectionActivityMutation(baseOptions?: Apollo.MutationHookOptions<EditPaCollectionActivityMutation, EditPaCollectionActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditPaCollectionActivityMutation, EditPaCollectionActivityMutationVariables>(EditPaCollectionActivityDocument, options);
      }
export type EditPaCollectionActivityMutationHookResult = ReturnType<typeof useEditPaCollectionActivityMutation>;
export type EditPaCollectionActivityMutationResult = Apollo.MutationResult<EditPaCollectionActivityMutation>;
export type EditPaCollectionActivityMutationOptions = Apollo.BaseMutationOptions<EditPaCollectionActivityMutation, EditPaCollectionActivityMutationVariables>;
export const UpdatePaCollectionActivityDocument = gql`
    mutation updatePACollectionActivity($input: UpdatePACollectionActivityInput!) {
  updatePACollectionActivity(input: $input)
}
    `;
export type UpdatePaCollectionActivityMutationFn = Apollo.MutationFunction<UpdatePaCollectionActivityMutation, UpdatePaCollectionActivityMutationVariables>;

/**
 * __useUpdatePaCollectionActivityMutation__
 *
 * To run a mutation, you first call `useUpdatePaCollectionActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaCollectionActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaCollectionActivityMutation, { data, loading, error }] = useUpdatePaCollectionActivityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePaCollectionActivityMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaCollectionActivityMutation, UpdatePaCollectionActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePaCollectionActivityMutation, UpdatePaCollectionActivityMutationVariables>(UpdatePaCollectionActivityDocument, options);
      }
export type UpdatePaCollectionActivityMutationHookResult = ReturnType<typeof useUpdatePaCollectionActivityMutation>;
export type UpdatePaCollectionActivityMutationResult = Apollo.MutationResult<UpdatePaCollectionActivityMutation>;
export type UpdatePaCollectionActivityMutationOptions = Apollo.BaseMutationOptions<UpdatePaCollectionActivityMutation, UpdatePaCollectionActivityMutationVariables>;
export const GetPAcontraListDocument = gql`
    query getPAcontraList($saleId: String!, $status: String!) {
  getPAcontraList(saleId: $saleId, status: $status) {
    allowReversal
    id
    documentDate
    documentAmount
    documentNo
    requestedBy
    description
    approvedDate
    approvedBy
    status
    unallocatedAmount
    submittedBy
    approvedBy
    submittedDate
    attachment {
      id
      fileName
      allowDelete
      isPrivate
      mediaType
      resourceUrl
    }
    requestUserData {
      ID
      name
    }
    submitUserData {
      ID
      name
    }
    approveUserData {
      ID
      name
    }
    taxData {
      taxSchemeId
      taxSchemeName
      effectiveDate
      taxSchemeDetailId
      totalTaxRate
      totalTaxAmount
    }
  }
}
    `;

/**
 * __useGetPAcontraListQuery__
 *
 * To run a query within a React component, call `useGetPAcontraListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPAcontraListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPAcontraListQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetPAcontraListQuery(baseOptions: Apollo.QueryHookOptions<GetPAcontraListQuery, GetPAcontraListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPAcontraListQuery, GetPAcontraListQueryVariables>(GetPAcontraListDocument, options);
      }
export function useGetPAcontraListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPAcontraListQuery, GetPAcontraListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPAcontraListQuery, GetPAcontraListQueryVariables>(GetPAcontraListDocument, options);
        }
export type GetPAcontraListQueryHookResult = ReturnType<typeof useGetPAcontraListQuery>;
export type GetPAcontraListLazyQueryHookResult = ReturnType<typeof useGetPAcontraListLazyQuery>;
export type GetPAcontraListQueryResult = Apollo.QueryResult<GetPAcontraListQuery, GetPAcontraListQueryVariables>;
export const GetPaContraSubmittedListDocument = gql`
    query getPAContraSubmittedList($saleId: String!) {
  getPAContraSubmittedList(saleId: $saleId) {
    id
    documentAmount
    documentDate
    description
    approvalRoleId
    submittedDate
    unallocatedAmount
    attachment {
      id
      fileName
      allowDelete
      isPrivate
      mediaType
      resourceUrl
    }
    billItem {
      billItemType
      id
      name
    }
    requestUserData {
      ID
      name
    }
    submitUserData {
      ID
      name
    }
    approveUserData {
      ID
      name
    }
    taxData {
      taxSchemeId
      taxSchemeName
      effectiveDate
      taxSchemeDetailId
      totalTaxRate
      totalTaxAmount
    }
    billingDetailTaxData {
      taxSchemeName
      totalTaxRate
      totalTaxAmount
    }
  }
}
    `;

/**
 * __useGetPaContraSubmittedListQuery__
 *
 * To run a query within a React component, call `useGetPaContraSubmittedListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaContraSubmittedListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaContraSubmittedListQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetPaContraSubmittedListQuery(baseOptions: Apollo.QueryHookOptions<GetPaContraSubmittedListQuery, GetPaContraSubmittedListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaContraSubmittedListQuery, GetPaContraSubmittedListQueryVariables>(GetPaContraSubmittedListDocument, options);
      }
export function useGetPaContraSubmittedListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaContraSubmittedListQuery, GetPaContraSubmittedListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaContraSubmittedListQuery, GetPaContraSubmittedListQueryVariables>(GetPaContraSubmittedListDocument, options);
        }
export type GetPaContraSubmittedListQueryHookResult = ReturnType<typeof useGetPaContraSubmittedListQuery>;
export type GetPaContraSubmittedListLazyQueryHookResult = ReturnType<typeof useGetPaContraSubmittedListLazyQuery>;
export type GetPaContraSubmittedListQueryResult = Apollo.QueryResult<GetPaContraSubmittedListQuery, GetPaContraSubmittedListQueryVariables>;
export const GetPAcontraByIdDocument = gql`
    query getPAcontraById($id: String!) {
  getPAcontraById(id: $id) {
    allowReversal
    approvedBy
    approvedDate
    billItemId
    description
    documentAmount
    documentDate
    documentNo
    documentRef
    id
    requestedBy
    status
    submittedBy
    submittedDate
    unallocatedAmount
    voidDate
    allocation {
      allocateAmount
    }
    attachment {
      id
      fileName
      allowDelete
      isPrivate
      mediaType
      resourceUrl
    }
    billItem {
      id
      name
      billItemType
    }
    requestUserData {
      ID
      name
    }
    submitUserData {
      ID
      name
    }
    approveUserData {
      ID
      name
    }
    taxData {
      taxSchemeId
      taxSchemeName
      effectiveDate
      taxSchemeDetailId
      totalTaxRate
      totalTaxAmount
      isExclusive
    }
    projectDetail {
      name
    }
    voidUserData {
      name
    }
  }
}
    `;

/**
 * __useGetPAcontraByIdQuery__
 *
 * To run a query within a React component, call `useGetPAcontraByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPAcontraByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPAcontraByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPAcontraByIdQuery(baseOptions: Apollo.QueryHookOptions<GetPAcontraByIdQuery, GetPAcontraByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPAcontraByIdQuery, GetPAcontraByIdQueryVariables>(GetPAcontraByIdDocument, options);
      }
export function useGetPAcontraByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPAcontraByIdQuery, GetPAcontraByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPAcontraByIdQuery, GetPAcontraByIdQueryVariables>(GetPAcontraByIdDocument, options);
        }
export type GetPAcontraByIdQueryHookResult = ReturnType<typeof useGetPAcontraByIdQuery>;
export type GetPAcontraByIdLazyQueryHookResult = ReturnType<typeof useGetPAcontraByIdLazyQuery>;
export type GetPAcontraByIdQueryResult = Apollo.QueryResult<GetPAcontraByIdQuery, GetPAcontraByIdQueryVariables>;
export const GetPAcontraSummaryDocument = gql`
    query getPAcontraSummary($projectId: String!, $saleId: String!) {
  getPAcontraSummary(projectId: $projectId, saleId: $saleId) {
    totalCharges
    totalUnallocated
    totalDraft
    totalSubmitted
  }
}
    `;

/**
 * __useGetPAcontraSummaryQuery__
 *
 * To run a query within a React component, call `useGetPAcontraSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPAcontraSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPAcontraSummaryQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetPAcontraSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetPAcontraSummaryQuery, GetPAcontraSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPAcontraSummaryQuery, GetPAcontraSummaryQueryVariables>(GetPAcontraSummaryDocument, options);
      }
export function useGetPAcontraSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPAcontraSummaryQuery, GetPAcontraSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPAcontraSummaryQuery, GetPAcontraSummaryQueryVariables>(GetPAcontraSummaryDocument, options);
        }
export type GetPAcontraSummaryQueryHookResult = ReturnType<typeof useGetPAcontraSummaryQuery>;
export type GetPAcontraSummaryLazyQueryHookResult = ReturnType<typeof useGetPAcontraSummaryLazyQuery>;
export type GetPAcontraSummaryQueryResult = Apollo.QueryResult<GetPAcontraSummaryQuery, GetPAcontraSummaryQueryVariables>;
export const AddPAcontraDocument = gql`
    mutation addPAcontra($isSubmitted: Boolean!, $input: AddPAmoduleDataInput!) {
  addPAcontra(isSubmitted: $isSubmitted, input: $input)
}
    `;
export type AddPAcontraMutationFn = Apollo.MutationFunction<AddPAcontraMutation, AddPAcontraMutationVariables>;

/**
 * __useAddPAcontraMutation__
 *
 * To run a mutation, you first call `useAddPAcontraMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPAcontraMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPAcontraMutation, { data, loading, error }] = useAddPAcontraMutation({
 *   variables: {
 *      isSubmitted: // value for 'isSubmitted'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPAcontraMutation(baseOptions?: Apollo.MutationHookOptions<AddPAcontraMutation, AddPAcontraMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPAcontraMutation, AddPAcontraMutationVariables>(AddPAcontraDocument, options);
      }
export type AddPAcontraMutationHookResult = ReturnType<typeof useAddPAcontraMutation>;
export type AddPAcontraMutationResult = Apollo.MutationResult<AddPAcontraMutation>;
export type AddPAcontraMutationOptions = Apollo.BaseMutationOptions<AddPAcontraMutation, AddPAcontraMutationVariables>;
export const EditPAcontraDocument = gql`
    mutation editPAcontra($isSubmitted: Boolean!, $input: EditPAmoduleDataInput!) {
  editPAcontra(isSubmitted: $isSubmitted, input: $input)
}
    `;
export type EditPAcontraMutationFn = Apollo.MutationFunction<EditPAcontraMutation, EditPAcontraMutationVariables>;

/**
 * __useEditPAcontraMutation__
 *
 * To run a mutation, you first call `useEditPAcontraMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPAcontraMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPAcontraMutation, { data, loading, error }] = useEditPAcontraMutation({
 *   variables: {
 *      isSubmitted: // value for 'isSubmitted'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditPAcontraMutation(baseOptions?: Apollo.MutationHookOptions<EditPAcontraMutation, EditPAcontraMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditPAcontraMutation, EditPAcontraMutationVariables>(EditPAcontraDocument, options);
      }
export type EditPAcontraMutationHookResult = ReturnType<typeof useEditPAcontraMutation>;
export type EditPAcontraMutationResult = Apollo.MutationResult<EditPAcontraMutation>;
export type EditPAcontraMutationOptions = Apollo.BaseMutationOptions<EditPAcontraMutation, EditPAcontraMutationVariables>;
export const GetPAcreditNoteListDocument = gql`
    query getPAcreditNoteList($saleId: String!, $status: String!) {
  getPAcreditNoteList(saleId: $saleId, status: $status) {
    allowReversal
    approvedBy
    approvedDate
    description
    documentAmount
    documentDate
    documentNo
    id
    requestedBy
    status
    submittedBy
    submittedDate
    unallocatedAmount
    voidDate
    attachment {
      id
      fileName
      allowDelete
      isPrivate
      mediaType
      resourceUrl
    }
    billItem {
      billItemType
      id
      name
    }
    requestUserData {
      ID
      name
    }
    submitUserData {
      ID
      name
    }
    approveUserData {
      ID
      name
    }
    taxData {
      taxSchemeId
      taxSchemeName
      effectiveDate
      taxSchemeDetailId
      totalTaxRate
      totalTaxAmount
    }
  }
}
    `;

/**
 * __useGetPAcreditNoteListQuery__
 *
 * To run a query within a React component, call `useGetPAcreditNoteListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPAcreditNoteListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPAcreditNoteListQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetPAcreditNoteListQuery(baseOptions: Apollo.QueryHookOptions<GetPAcreditNoteListQuery, GetPAcreditNoteListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPAcreditNoteListQuery, GetPAcreditNoteListQueryVariables>(GetPAcreditNoteListDocument, options);
      }
export function useGetPAcreditNoteListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPAcreditNoteListQuery, GetPAcreditNoteListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPAcreditNoteListQuery, GetPAcreditNoteListQueryVariables>(GetPAcreditNoteListDocument, options);
        }
export type GetPAcreditNoteListQueryHookResult = ReturnType<typeof useGetPAcreditNoteListQuery>;
export type GetPAcreditNoteListLazyQueryHookResult = ReturnType<typeof useGetPAcreditNoteListLazyQuery>;
export type GetPAcreditNoteListQueryResult = Apollo.QueryResult<GetPAcreditNoteListQuery, GetPAcreditNoteListQueryVariables>;
export const GetPaCreditNoteSubmittedListDocument = gql`
    query getPACreditNoteSubmittedList($saleId: String!) {
  getPACreditNoteSubmittedList(saleId: $saleId) {
    id
    documentAmount
    documentDate
    description
    approvalRoleId
    submittedDate
    unallocatedAmount
    attachment {
      id
      fileName
      allowDelete
      isPrivate
      mediaType
      resourceUrl
    }
    billItem {
      billItemType
      id
      name
    }
    requestUserData {
      ID
      name
    }
    submitUserData {
      ID
      name
    }
    approveUserData {
      ID
      name
    }
    taxData {
      taxSchemeId
      taxSchemeName
      effectiveDate
      taxSchemeDetailId
      totalTaxRate
      totalTaxAmount
    }
    billingDetailTaxData {
      taxSchemeName
      totalTaxRate
      totalTaxAmount
    }
  }
}
    `;

/**
 * __useGetPaCreditNoteSubmittedListQuery__
 *
 * To run a query within a React component, call `useGetPaCreditNoteSubmittedListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaCreditNoteSubmittedListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaCreditNoteSubmittedListQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetPaCreditNoteSubmittedListQuery(baseOptions: Apollo.QueryHookOptions<GetPaCreditNoteSubmittedListQuery, GetPaCreditNoteSubmittedListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaCreditNoteSubmittedListQuery, GetPaCreditNoteSubmittedListQueryVariables>(GetPaCreditNoteSubmittedListDocument, options);
      }
export function useGetPaCreditNoteSubmittedListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaCreditNoteSubmittedListQuery, GetPaCreditNoteSubmittedListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaCreditNoteSubmittedListQuery, GetPaCreditNoteSubmittedListQueryVariables>(GetPaCreditNoteSubmittedListDocument, options);
        }
export type GetPaCreditNoteSubmittedListQueryHookResult = ReturnType<typeof useGetPaCreditNoteSubmittedListQuery>;
export type GetPaCreditNoteSubmittedListLazyQueryHookResult = ReturnType<typeof useGetPaCreditNoteSubmittedListLazyQuery>;
export type GetPaCreditNoteSubmittedListQueryResult = Apollo.QueryResult<GetPaCreditNoteSubmittedListQuery, GetPaCreditNoteSubmittedListQueryVariables>;
export const GetPAcreditNoteSummaryDocument = gql`
    query getPAcreditNoteSummary($projectId: String!, $saleId: String!) {
  getPAcreditNoteSummary(projectId: $projectId, saleId: $saleId) {
    totalCharges
    totalUnallocated
    totalDraft
    totalSubmitted
  }
}
    `;

/**
 * __useGetPAcreditNoteSummaryQuery__
 *
 * To run a query within a React component, call `useGetPAcreditNoteSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPAcreditNoteSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPAcreditNoteSummaryQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetPAcreditNoteSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetPAcreditNoteSummaryQuery, GetPAcreditNoteSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPAcreditNoteSummaryQuery, GetPAcreditNoteSummaryQueryVariables>(GetPAcreditNoteSummaryDocument, options);
      }
export function useGetPAcreditNoteSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPAcreditNoteSummaryQuery, GetPAcreditNoteSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPAcreditNoteSummaryQuery, GetPAcreditNoteSummaryQueryVariables>(GetPAcreditNoteSummaryDocument, options);
        }
export type GetPAcreditNoteSummaryQueryHookResult = ReturnType<typeof useGetPAcreditNoteSummaryQuery>;
export type GetPAcreditNoteSummaryLazyQueryHookResult = ReturnType<typeof useGetPAcreditNoteSummaryLazyQuery>;
export type GetPAcreditNoteSummaryQueryResult = Apollo.QueryResult<GetPAcreditNoteSummaryQuery, GetPAcreditNoteSummaryQueryVariables>;
export const GetPAcreditNoteByIdDocument = gql`
    query getPAcreditNoteById($id: String!) {
  getPAcreditNoteById(id: $id) {
    allowReversal
    approvedBy
    approvedDate
    billItemId
    description
    documentAmount
    documentDate
    documentNo
    documentRef
    isReversal
    requestedBy
    status
    submittedBy
    submittedDate
    unallocatedAmount
    voidBy
    voidDate
    attachment {
      id
      fileName
      allowDelete
      isPrivate
      mediaType
      resourceUrl
    }
    billItem {
      id
      name
      billItemType
    }
    requestUserData {
      ID
      name
    }
    submitUserData {
      ID
      name
    }
    approveUserData {
      ID
      name
    }
    voidUserData {
      name
    }
    taxData {
      taxSchemeId
      taxSchemeName
      effectiveDate
      taxSchemeDetailId
      totalTaxRate
      totalTaxAmount
      totalTaxAmount
      isExclusive
    }
    projectDetail {
      name
    }
  }
}
    `;

/**
 * __useGetPAcreditNoteByIdQuery__
 *
 * To run a query within a React component, call `useGetPAcreditNoteByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPAcreditNoteByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPAcreditNoteByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPAcreditNoteByIdQuery(baseOptions: Apollo.QueryHookOptions<GetPAcreditNoteByIdQuery, GetPAcreditNoteByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPAcreditNoteByIdQuery, GetPAcreditNoteByIdQueryVariables>(GetPAcreditNoteByIdDocument, options);
      }
export function useGetPAcreditNoteByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPAcreditNoteByIdQuery, GetPAcreditNoteByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPAcreditNoteByIdQuery, GetPAcreditNoteByIdQueryVariables>(GetPAcreditNoteByIdDocument, options);
        }
export type GetPAcreditNoteByIdQueryHookResult = ReturnType<typeof useGetPAcreditNoteByIdQuery>;
export type GetPAcreditNoteByIdLazyQueryHookResult = ReturnType<typeof useGetPAcreditNoteByIdLazyQuery>;
export type GetPAcreditNoteByIdQueryResult = Apollo.QueryResult<GetPAcreditNoteByIdQuery, GetPAcreditNoteByIdQueryVariables>;
export const AddPAcreditNoteDocument = gql`
    mutation addPAcreditNote($isSubmitted: Boolean!, $input: AddPAmoduleDataInput!) {
  addPAcreditNote(isSubmitted: $isSubmitted, input: $input)
}
    `;
export type AddPAcreditNoteMutationFn = Apollo.MutationFunction<AddPAcreditNoteMutation, AddPAcreditNoteMutationVariables>;

/**
 * __useAddPAcreditNoteMutation__
 *
 * To run a mutation, you first call `useAddPAcreditNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPAcreditNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPAcreditNoteMutation, { data, loading, error }] = useAddPAcreditNoteMutation({
 *   variables: {
 *      isSubmitted: // value for 'isSubmitted'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPAcreditNoteMutation(baseOptions?: Apollo.MutationHookOptions<AddPAcreditNoteMutation, AddPAcreditNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPAcreditNoteMutation, AddPAcreditNoteMutationVariables>(AddPAcreditNoteDocument, options);
      }
export type AddPAcreditNoteMutationHookResult = ReturnType<typeof useAddPAcreditNoteMutation>;
export type AddPAcreditNoteMutationResult = Apollo.MutationResult<AddPAcreditNoteMutation>;
export type AddPAcreditNoteMutationOptions = Apollo.BaseMutationOptions<AddPAcreditNoteMutation, AddPAcreditNoteMutationVariables>;
export const EditPAcreditNoteDocument = gql`
    mutation editPAcreditNote($isSubmitted: Boolean!, $input: EditPAmoduleDataInput!) {
  editPAcreditNote(isSubmitted: $isSubmitted, input: $input)
}
    `;
export type EditPAcreditNoteMutationFn = Apollo.MutationFunction<EditPAcreditNoteMutation, EditPAcreditNoteMutationVariables>;

/**
 * __useEditPAcreditNoteMutation__
 *
 * To run a mutation, you first call `useEditPAcreditNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPAcreditNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPAcreditNoteMutation, { data, loading, error }] = useEditPAcreditNoteMutation({
 *   variables: {
 *      isSubmitted: // value for 'isSubmitted'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditPAcreditNoteMutation(baseOptions?: Apollo.MutationHookOptions<EditPAcreditNoteMutation, EditPAcreditNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditPAcreditNoteMutation, EditPAcreditNoteMutationVariables>(EditPAcreditNoteDocument, options);
      }
export type EditPAcreditNoteMutationHookResult = ReturnType<typeof useEditPAcreditNoteMutation>;
export type EditPAcreditNoteMutationResult = Apollo.MutationResult<EditPAcreditNoteMutation>;
export type EditPAcreditNoteMutationOptions = Apollo.BaseMutationOptions<EditPAcreditNoteMutation, EditPAcreditNoteMutationVariables>;
export const GetPAdebitNoteListDocument = gql`
    query getPAdebitNoteList($saleId: String!, $status: String!) {
  getPAdebitNoteList(saleId: $saleId, status: $status) {
    allowReversal
    approvedBy
    approvedDate
    billItemId
    creditTerm
    description
    documentAmount
    documentDate
    documentNo
    dueDate
    id
    interestRate
    isReversal
    requestedBy
    status
    submittedBy
    submittedDate
    unallocatedAmount
    attachment {
      allowDelete
      fileName
      id
      isPrivate
      mediaType
      resourceUrl
    }
    billItem {
      billItemType
      id
      name
    }
    billItemInt {
      billItemType
      id
      name
    }
    requestUserData {
      ID
      name
    }
    submitUserData {
      ID
      name
    }
    approveUserData {
      ID
      name
    }
    taxData {
      taxSchemeId
      taxSchemeName
      effectiveDate
      taxSchemeDetailId
      totalTaxRate
      totalTaxAmount
    }
    unitDetail
    contactDetail
  }
}
    `;

/**
 * __useGetPAdebitNoteListQuery__
 *
 * To run a query within a React component, call `useGetPAdebitNoteListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPAdebitNoteListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPAdebitNoteListQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetPAdebitNoteListQuery(baseOptions: Apollo.QueryHookOptions<GetPAdebitNoteListQuery, GetPAdebitNoteListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPAdebitNoteListQuery, GetPAdebitNoteListQueryVariables>(GetPAdebitNoteListDocument, options);
      }
export function useGetPAdebitNoteListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPAdebitNoteListQuery, GetPAdebitNoteListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPAdebitNoteListQuery, GetPAdebitNoteListQueryVariables>(GetPAdebitNoteListDocument, options);
        }
export type GetPAdebitNoteListQueryHookResult = ReturnType<typeof useGetPAdebitNoteListQuery>;
export type GetPAdebitNoteListLazyQueryHookResult = ReturnType<typeof useGetPAdebitNoteListLazyQuery>;
export type GetPAdebitNoteListQueryResult = Apollo.QueryResult<GetPAdebitNoteListQuery, GetPAdebitNoteListQueryVariables>;
export const GetPAdebitNoteSummaryDocument = gql`
    query getPAdebitNoteSummary($projectId: String!, $saleId: String!) {
  getPAdebitNoteSummary(projectId: $projectId, saleId: $saleId) {
    totalCharges
    totalUnallocated
    totalDraft
    totalSubmitted
  }
}
    `;

/**
 * __useGetPAdebitNoteSummaryQuery__
 *
 * To run a query within a React component, call `useGetPAdebitNoteSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPAdebitNoteSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPAdebitNoteSummaryQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetPAdebitNoteSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetPAdebitNoteSummaryQuery, GetPAdebitNoteSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPAdebitNoteSummaryQuery, GetPAdebitNoteSummaryQueryVariables>(GetPAdebitNoteSummaryDocument, options);
      }
export function useGetPAdebitNoteSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPAdebitNoteSummaryQuery, GetPAdebitNoteSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPAdebitNoteSummaryQuery, GetPAdebitNoteSummaryQueryVariables>(GetPAdebitNoteSummaryDocument, options);
        }
export type GetPAdebitNoteSummaryQueryHookResult = ReturnType<typeof useGetPAdebitNoteSummaryQuery>;
export type GetPAdebitNoteSummaryLazyQueryHookResult = ReturnType<typeof useGetPAdebitNoteSummaryLazyQuery>;
export type GetPAdebitNoteSummaryQueryResult = Apollo.QueryResult<GetPAdebitNoteSummaryQuery, GetPAdebitNoteSummaryQueryVariables>;
export const GetPAdebitNoteByIdDocument = gql`
    query getPAdebitNoteById($id: String!) {
  getPAdebitNoteById(id: $id) {
    approvedBy
    approvedDate
    billItemId
    description
    documentAmount
    documentDate
    documentNo
    dueDate
    isIncludeHoliday
    requestedBy
    status
    submittedBy
    submittedDate
    unallocatedAmount
    voidDate
    attachment {
      allowDelete
      fileName
      id
      isPrivate
      mediaType
      resourceUrl
    }
    billItem {
      billItemType
      id
      name
    }
    creditTerm
    interestRate
    requestUserData {
      ID
      name
    }
    submitUserData {
      ID
      name
    }
    approveUserData {
      ID
      name
    }
    voidUserData {
      ID
      name
    }
    taxData {
      taxSchemeId
      taxSchemeName
      effectiveDate
      taxSchemeDetailId
      totalTaxRate
      totalTaxAmount
      isExclusive
    }
    projectDetail {
      name
    }
  }
}
    `;

/**
 * __useGetPAdebitNoteByIdQuery__
 *
 * To run a query within a React component, call `useGetPAdebitNoteByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPAdebitNoteByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPAdebitNoteByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPAdebitNoteByIdQuery(baseOptions: Apollo.QueryHookOptions<GetPAdebitNoteByIdQuery, GetPAdebitNoteByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPAdebitNoteByIdQuery, GetPAdebitNoteByIdQueryVariables>(GetPAdebitNoteByIdDocument, options);
      }
export function useGetPAdebitNoteByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPAdebitNoteByIdQuery, GetPAdebitNoteByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPAdebitNoteByIdQuery, GetPAdebitNoteByIdQueryVariables>(GetPAdebitNoteByIdDocument, options);
        }
export type GetPAdebitNoteByIdQueryHookResult = ReturnType<typeof useGetPAdebitNoteByIdQuery>;
export type GetPAdebitNoteByIdLazyQueryHookResult = ReturnType<typeof useGetPAdebitNoteByIdLazyQuery>;
export type GetPAdebitNoteByIdQueryResult = Apollo.QueryResult<GetPAdebitNoteByIdQuery, GetPAdebitNoteByIdQueryVariables>;
export const AddPAdebitNoteDocument = gql`
    mutation addPAdebitNote($isSubmitted: Boolean!, $input: AddPAdebitNoteInput!) {
  addPAdebitNote(isSubmitted: $isSubmitted, input: $input)
}
    `;
export type AddPAdebitNoteMutationFn = Apollo.MutationFunction<AddPAdebitNoteMutation, AddPAdebitNoteMutationVariables>;

/**
 * __useAddPAdebitNoteMutation__
 *
 * To run a mutation, you first call `useAddPAdebitNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPAdebitNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPAdebitNoteMutation, { data, loading, error }] = useAddPAdebitNoteMutation({
 *   variables: {
 *      isSubmitted: // value for 'isSubmitted'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPAdebitNoteMutation(baseOptions?: Apollo.MutationHookOptions<AddPAdebitNoteMutation, AddPAdebitNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPAdebitNoteMutation, AddPAdebitNoteMutationVariables>(AddPAdebitNoteDocument, options);
      }
export type AddPAdebitNoteMutationHookResult = ReturnType<typeof useAddPAdebitNoteMutation>;
export type AddPAdebitNoteMutationResult = Apollo.MutationResult<AddPAdebitNoteMutation>;
export type AddPAdebitNoteMutationOptions = Apollo.BaseMutationOptions<AddPAdebitNoteMutation, AddPAdebitNoteMutationVariables>;
export const EditPAdebitNoteDocument = gql`
    mutation editPAdebitNote($isSubmitted: Boolean!, $input: EditPAdebitNoteInput!) {
  editPAdebitNote(isSubmitted: $isSubmitted, input: $input)
}
    `;
export type EditPAdebitNoteMutationFn = Apollo.MutationFunction<EditPAdebitNoteMutation, EditPAdebitNoteMutationVariables>;

/**
 * __useEditPAdebitNoteMutation__
 *
 * To run a mutation, you first call `useEditPAdebitNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPAdebitNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPAdebitNoteMutation, { data, loading, error }] = useEditPAdebitNoteMutation({
 *   variables: {
 *      isSubmitted: // value for 'isSubmitted'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditPAdebitNoteMutation(baseOptions?: Apollo.MutationHookOptions<EditPAdebitNoteMutation, EditPAdebitNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditPAdebitNoteMutation, EditPAdebitNoteMutationVariables>(EditPAdebitNoteDocument, options);
      }
export type EditPAdebitNoteMutationHookResult = ReturnType<typeof useEditPAdebitNoteMutation>;
export type EditPAdebitNoteMutationResult = Apollo.MutationResult<EditPAdebitNoteMutation>;
export type EditPAdebitNoteMutationOptions = Apollo.BaseMutationOptions<EditPAdebitNoteMutation, EditPAdebitNoteMutationVariables>;
export const GetPAlateInterestListDocument = gql`
    query getPAlateInterestList($saleId: String!) {
  getPAlateInterestList(saleId: $saleId) {
    id
    documentDate
    documentAmount
    description
    status
    dueDate
    documentNo
    creditTerm
    submittedDate
    submittedBy
    unallocatedAmount
    interestAmount
  }
}
    `;

/**
 * __useGetPAlateInterestListQuery__
 *
 * To run a query within a React component, call `useGetPAlateInterestListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPAlateInterestListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPAlateInterestListQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetPAlateInterestListQuery(baseOptions: Apollo.QueryHookOptions<GetPAlateInterestListQuery, GetPAlateInterestListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPAlateInterestListQuery, GetPAlateInterestListQueryVariables>(GetPAlateInterestListDocument, options);
      }
export function useGetPAlateInterestListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPAlateInterestListQuery, GetPAlateInterestListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPAlateInterestListQuery, GetPAlateInterestListQueryVariables>(GetPAlateInterestListDocument, options);
        }
export type GetPAlateInterestListQueryHookResult = ReturnType<typeof useGetPAlateInterestListQuery>;
export type GetPAlateInterestListLazyQueryHookResult = ReturnType<typeof useGetPAlateInterestListLazyQuery>;
export type GetPAlateInterestListQueryResult = Apollo.QueryResult<GetPAlateInterestListQuery, GetPAlateInterestListQueryVariables>;
export const GetPAlateInterestByIdDocument = gql`
    query getPAlateInterestById($id: String!) {
  getPAlateInterestById(id: $id) {
    documentNo
    documentDate
    dueDate
    creditTerm
    description
    documentAmount
    submittedDate
    submittedBy
    approvedDate
    approvedBy
    unallocatedAmount
    submitUserData {
      name
    }
    approveUserData {
      name
    }
    voidUserData {
      name
    }
    taxData {
      taxSchemeId
      taxSchemeName
      effectiveDate
      taxSchemeDetailId
      totalTaxRate
      totalTaxAmount
    }
    projectDetail {
      name
    }
    documentRef
  }
}
    `;

/**
 * __useGetPAlateInterestByIdQuery__
 *
 * To run a query within a React component, call `useGetPAlateInterestByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPAlateInterestByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPAlateInterestByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPAlateInterestByIdQuery(baseOptions: Apollo.QueryHookOptions<GetPAlateInterestByIdQuery, GetPAlateInterestByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPAlateInterestByIdQuery, GetPAlateInterestByIdQueryVariables>(GetPAlateInterestByIdDocument, options);
      }
export function useGetPAlateInterestByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPAlateInterestByIdQuery, GetPAlateInterestByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPAlateInterestByIdQuery, GetPAlateInterestByIdQueryVariables>(GetPAlateInterestByIdDocument, options);
        }
export type GetPAlateInterestByIdQueryHookResult = ReturnType<typeof useGetPAlateInterestByIdQuery>;
export type GetPAlateInterestByIdLazyQueryHookResult = ReturnType<typeof useGetPAlateInterestByIdLazyQuery>;
export type GetPAlateInterestByIdQueryResult = Apollo.QueryResult<GetPAlateInterestByIdQuery, GetPAlateInterestByIdQueryVariables>;
export const GetPAlateInterestSummaryDocument = gql`
    query getPAlateInterestSummary($saleId: String!) {
  getPAlateInterestSummary(saleId: $saleId) {
    totalCharges
    totalUnallocated
    totalDraft
    totalSubmitted
  }
}
    `;

/**
 * __useGetPAlateInterestSummaryQuery__
 *
 * To run a query within a React component, call `useGetPAlateInterestSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPAlateInterestSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPAlateInterestSummaryQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetPAlateInterestSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetPAlateInterestSummaryQuery, GetPAlateInterestSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPAlateInterestSummaryQuery, GetPAlateInterestSummaryQueryVariables>(GetPAlateInterestSummaryDocument, options);
      }
export function useGetPAlateInterestSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPAlateInterestSummaryQuery, GetPAlateInterestSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPAlateInterestSummaryQuery, GetPAlateInterestSummaryQueryVariables>(GetPAlateInterestSummaryDocument, options);
        }
export type GetPAlateInterestSummaryQueryHookResult = ReturnType<typeof useGetPAlateInterestSummaryQuery>;
export type GetPAlateInterestSummaryLazyQueryHookResult = ReturnType<typeof useGetPAlateInterestSummaryLazyQuery>;
export type GetPAlateInterestSummaryQueryResult = Apollo.QueryResult<GetPAlateInterestSummaryQuery, GetPAlateInterestSummaryQueryVariables>;
export const GetPAlateInterestStatusDocument = gql`
    query getPAlateInterestStatus {
  getPAlateInterestStatus {
    status
  }
}
    `;

/**
 * __useGetPAlateInterestStatusQuery__
 *
 * To run a query within a React component, call `useGetPAlateInterestStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPAlateInterestStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPAlateInterestStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPAlateInterestStatusQuery(baseOptions?: Apollo.QueryHookOptions<GetPAlateInterestStatusQuery, GetPAlateInterestStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPAlateInterestStatusQuery, GetPAlateInterestStatusQueryVariables>(GetPAlateInterestStatusDocument, options);
      }
export function useGetPAlateInterestStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPAlateInterestStatusQuery, GetPAlateInterestStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPAlateInterestStatusQuery, GetPAlateInterestStatusQueryVariables>(GetPAlateInterestStatusDocument, options);
        }
export type GetPAlateInterestStatusQueryHookResult = ReturnType<typeof useGetPAlateInterestStatusQuery>;
export type GetPAlateInterestStatusLazyQueryHookResult = ReturnType<typeof useGetPAlateInterestStatusLazyQuery>;
export type GetPAlateInterestStatusQueryResult = Apollo.QueryResult<GetPAlateInterestStatusQuery, GetPAlateInterestStatusQueryVariables>;
export const AddPaLateInterestChargesDocument = gql`
    mutation addPALateInterestCharges($input: addPALateInterestInput!) {
  addPALateInterestCharges(input: $input)
}
    `;
export type AddPaLateInterestChargesMutationFn = Apollo.MutationFunction<AddPaLateInterestChargesMutation, AddPaLateInterestChargesMutationVariables>;

/**
 * __useAddPaLateInterestChargesMutation__
 *
 * To run a mutation, you first call `useAddPaLateInterestChargesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPaLateInterestChargesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPaLateInterestChargesMutation, { data, loading, error }] = useAddPaLateInterestChargesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPaLateInterestChargesMutation(baseOptions?: Apollo.MutationHookOptions<AddPaLateInterestChargesMutation, AddPaLateInterestChargesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPaLateInterestChargesMutation, AddPaLateInterestChargesMutationVariables>(AddPaLateInterestChargesDocument, options);
      }
export type AddPaLateInterestChargesMutationHookResult = ReturnType<typeof useAddPaLateInterestChargesMutation>;
export type AddPaLateInterestChargesMutationResult = Apollo.MutationResult<AddPaLateInterestChargesMutation>;
export type AddPaLateInterestChargesMutationOptions = Apollo.BaseMutationOptions<AddPaLateInterestChargesMutation, AddPaLateInterestChargesMutationVariables>;
export const GetTempPAlateInterestListDocument = gql`
    query getTempPAlateInterestList($saleId: String!, $temporary: Boolean!, $generateDate: DateTime!) {
  getTempPAlateInterestList(saleId: $saleId, temporary: $temporary, generateDate: $generateDate) {
    refTable
    refId
    overdueDay
    documentRef
    description
    interestStartDate
    documentDate
    documentAmount
    interestEndDate
    dueDate
    status
    creditTerm
    billItemId
    status
    generationBatchDate
    generationBatch
    isIncludeHoliday
    calculateAmt
    calculateRate
    billDocumentNo
  }
}
    `;

/**
 * __useGetTempPAlateInterestListQuery__
 *
 * To run a query within a React component, call `useGetTempPAlateInterestListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTempPAlateInterestListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTempPAlateInterestListQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *      temporary: // value for 'temporary'
 *      generateDate: // value for 'generateDate'
 *   },
 * });
 */
export function useGetTempPAlateInterestListQuery(baseOptions: Apollo.QueryHookOptions<GetTempPAlateInterestListQuery, GetTempPAlateInterestListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTempPAlateInterestListQuery, GetTempPAlateInterestListQueryVariables>(GetTempPAlateInterestListDocument, options);
      }
export function useGetTempPAlateInterestListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTempPAlateInterestListQuery, GetTempPAlateInterestListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTempPAlateInterestListQuery, GetTempPAlateInterestListQueryVariables>(GetTempPAlateInterestListDocument, options);
        }
export type GetTempPAlateInterestListQueryHookResult = ReturnType<typeof useGetTempPAlateInterestListQuery>;
export type GetTempPAlateInterestListLazyQueryHookResult = ReturnType<typeof useGetTempPAlateInterestListLazyQuery>;
export type GetTempPAlateInterestListQueryResult = Apollo.QueryResult<GetTempPAlateInterestListQuery, GetTempPAlateInterestListQueryVariables>;
export const GetCreditTermsDocument = gql`
    query getCreditTerms {
  getCreditTerms
}
    `;

/**
 * __useGetCreditTermsQuery__
 *
 * To run a query within a React component, call `useGetCreditTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditTermsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCreditTermsQuery(baseOptions?: Apollo.QueryHookOptions<GetCreditTermsQuery, GetCreditTermsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditTermsQuery, GetCreditTermsQueryVariables>(GetCreditTermsDocument, options);
      }
export function useGetCreditTermsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditTermsQuery, GetCreditTermsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditTermsQuery, GetCreditTermsQueryVariables>(GetCreditTermsDocument, options);
        }
export type GetCreditTermsQueryHookResult = ReturnType<typeof useGetCreditTermsQuery>;
export type GetCreditTermsLazyQueryHookResult = ReturnType<typeof useGetCreditTermsLazyQuery>;
export type GetCreditTermsQueryResult = Apollo.QueryResult<GetCreditTermsQuery, GetCreditTermsQueryVariables>;
export const GetPAcollectionMasterDataDocument = gql`
    query getPAcollectionMasterData($saleId: String!) {
  getPAcollectionMasterData(saleId: $saleId) {
    unitNo
    financierList {
      financierId
      financierName
    }
    bankList {
      bankAccountCode
      bankAccountId
      bankAccountNo
      bankProfileId
      bankProfileName
      currency
      isSelected
    }
  }
}
    `;

/**
 * __useGetPAcollectionMasterDataQuery__
 *
 * To run a query within a React component, call `useGetPAcollectionMasterDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPAcollectionMasterDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPAcollectionMasterDataQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetPAcollectionMasterDataQuery(baseOptions: Apollo.QueryHookOptions<GetPAcollectionMasterDataQuery, GetPAcollectionMasterDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPAcollectionMasterDataQuery, GetPAcollectionMasterDataQueryVariables>(GetPAcollectionMasterDataDocument, options);
      }
export function useGetPAcollectionMasterDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPAcollectionMasterDataQuery, GetPAcollectionMasterDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPAcollectionMasterDataQuery, GetPAcollectionMasterDataQueryVariables>(GetPAcollectionMasterDataDocument, options);
        }
export type GetPAcollectionMasterDataQueryHookResult = ReturnType<typeof useGetPAcollectionMasterDataQuery>;
export type GetPAcollectionMasterDataLazyQueryHookResult = ReturnType<typeof useGetPAcollectionMasterDataLazyQuery>;
export type GetPAcollectionMasterDataQueryResult = Apollo.QueryResult<GetPAcollectionMasterDataQuery, GetPAcollectionMasterDataQueryVariables>;
export const GetPaymentReminderBySaleIdDocument = gql`
    query getPaymentReminderBySaleId($saleId: String!) {
  getPaymentReminderBySaleId(saleId: $saleId) {
    unitNo
    saleId
    reminderDate
    generationBatch
    paymentReminderDetails {
      documentNo
      documentDate
      dueDate
      balanceAmount
      reminderSeq
    }
  }
}
    `;

/**
 * __useGetPaymentReminderBySaleIdQuery__
 *
 * To run a query within a React component, call `useGetPaymentReminderBySaleIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentReminderBySaleIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentReminderBySaleIdQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetPaymentReminderBySaleIdQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentReminderBySaleIdQuery, GetPaymentReminderBySaleIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentReminderBySaleIdQuery, GetPaymentReminderBySaleIdQueryVariables>(GetPaymentReminderBySaleIdDocument, options);
      }
export function useGetPaymentReminderBySaleIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentReminderBySaleIdQuery, GetPaymentReminderBySaleIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentReminderBySaleIdQuery, GetPaymentReminderBySaleIdQueryVariables>(GetPaymentReminderBySaleIdDocument, options);
        }
export type GetPaymentReminderBySaleIdQueryHookResult = ReturnType<typeof useGetPaymentReminderBySaleIdQuery>;
export type GetPaymentReminderBySaleIdLazyQueryHookResult = ReturnType<typeof useGetPaymentReminderBySaleIdLazyQuery>;
export type GetPaymentReminderBySaleIdQueryResult = Apollo.QueryResult<GetPaymentReminderBySaleIdQuery, GetPaymentReminderBySaleIdQueryVariables>;
export const GetMiscBillingTaxDocument = gql`
    query getMiscBillingTax {
  getMiscBillingTax {
    taxId
    code
    effectiveDate
    rate
  }
}
    `;

/**
 * __useGetMiscBillingTaxQuery__
 *
 * To run a query within a React component, call `useGetMiscBillingTaxQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMiscBillingTaxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMiscBillingTaxQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMiscBillingTaxQuery(baseOptions?: Apollo.QueryHookOptions<GetMiscBillingTaxQuery, GetMiscBillingTaxQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMiscBillingTaxQuery, GetMiscBillingTaxQueryVariables>(GetMiscBillingTaxDocument, options);
      }
export function useGetMiscBillingTaxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMiscBillingTaxQuery, GetMiscBillingTaxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMiscBillingTaxQuery, GetMiscBillingTaxQueryVariables>(GetMiscBillingTaxDocument, options);
        }
export type GetMiscBillingTaxQueryHookResult = ReturnType<typeof useGetMiscBillingTaxQuery>;
export type GetMiscBillingTaxLazyQueryHookResult = ReturnType<typeof useGetMiscBillingTaxLazyQuery>;
export type GetMiscBillingTaxQueryResult = Apollo.QueryResult<GetMiscBillingTaxQuery, GetMiscBillingTaxQueryVariables>;
export const GetMiscBillingTaxByDocDateDocument = gql`
    query getMiscBillingTaxByDocDate($docDate: DateTime!) {
  getMiscBillingTaxByDocDate(docDate: $docDate) {
    taxSchemeId
    taxSchemeName
    effectiveDate
    isExclusive
    taxSchemeDetailId
    totalTaxRate
    taxSchemeDetailItems {
      taxId
      taxCode
      taxRate
    }
  }
}
    `;

/**
 * __useGetMiscBillingTaxByDocDateQuery__
 *
 * To run a query within a React component, call `useGetMiscBillingTaxByDocDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMiscBillingTaxByDocDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMiscBillingTaxByDocDateQuery({
 *   variables: {
 *      docDate: // value for 'docDate'
 *   },
 * });
 */
export function useGetMiscBillingTaxByDocDateQuery(baseOptions: Apollo.QueryHookOptions<GetMiscBillingTaxByDocDateQuery, GetMiscBillingTaxByDocDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMiscBillingTaxByDocDateQuery, GetMiscBillingTaxByDocDateQueryVariables>(GetMiscBillingTaxByDocDateDocument, options);
      }
export function useGetMiscBillingTaxByDocDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMiscBillingTaxByDocDateQuery, GetMiscBillingTaxByDocDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMiscBillingTaxByDocDateQuery, GetMiscBillingTaxByDocDateQueryVariables>(GetMiscBillingTaxByDocDateDocument, options);
        }
export type GetMiscBillingTaxByDocDateQueryHookResult = ReturnType<typeof useGetMiscBillingTaxByDocDateQuery>;
export type GetMiscBillingTaxByDocDateLazyQueryHookResult = ReturnType<typeof useGetMiscBillingTaxByDocDateLazyQuery>;
export type GetMiscBillingTaxByDocDateQueryResult = Apollo.QueryResult<GetMiscBillingTaxByDocDateQuery, GetMiscBillingTaxByDocDateQueryVariables>;
export const GetPAmiscBillingListDocument = gql`
    query getPAmiscBillingList($saleId: String!, $status: String!) {
  getPAmiscBillingList(saleId: $saleId, status: $status) {
    allowReversal
    approvedBy
    approvedDate
    billItemId
    creditTerm
    description
    documentAmount
    documentDate
    documentNo
    dueDate
    id
    interestRate
    requestedBy
    status
    submittedBy
    submittedDate
    unallocatedAmount
    attachment {
      allowDelete
      fileName
      id
      isPrivate
      mediaType
      resourceUrl
    }
    billItem {
      billItemType
      id
      name
    }
    requestUserData {
      ID
      name
    }
    submitUserData {
      ID
      name
    }
    approveUserData {
      ID
      name
    }
    taxData {
      taxSchemeId
      taxSchemeName
      effectiveDate
      taxSchemeDetailId
      totalTaxRate
      totalTaxAmount
    }
  }
}
    `;

/**
 * __useGetPAmiscBillingListQuery__
 *
 * To run a query within a React component, call `useGetPAmiscBillingListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPAmiscBillingListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPAmiscBillingListQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetPAmiscBillingListQuery(baseOptions: Apollo.QueryHookOptions<GetPAmiscBillingListQuery, GetPAmiscBillingListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPAmiscBillingListQuery, GetPAmiscBillingListQueryVariables>(GetPAmiscBillingListDocument, options);
      }
export function useGetPAmiscBillingListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPAmiscBillingListQuery, GetPAmiscBillingListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPAmiscBillingListQuery, GetPAmiscBillingListQueryVariables>(GetPAmiscBillingListDocument, options);
        }
export type GetPAmiscBillingListQueryHookResult = ReturnType<typeof useGetPAmiscBillingListQuery>;
export type GetPAmiscBillingListLazyQueryHookResult = ReturnType<typeof useGetPAmiscBillingListLazyQuery>;
export type GetPAmiscBillingListQueryResult = Apollo.QueryResult<GetPAmiscBillingListQuery, GetPAmiscBillingListQueryVariables>;
export const GetPAmiscBillingByIdDocument = gql`
    query getPAmiscBillingById($id: String!) {
  getPAmiscBillingById(id: $id) {
    approvedBy
    approvedDate
    billItemId
    creditTerm
    description
    documentAmount
    documentDate
    documentNo
    documentRef
    dueDate
    interestRate
    isIncludeHoliday
    status
    submittedDate
    unallocatedAmount
    voidDate
    attachment {
      allowDelete
      fileName
      id
      isPrivate
      mediaType
      resourceUrl
    }
    billItem {
      billItemType
      id
      name
    }
    requestUserData {
      ID
      name
    }
    submitUserData {
      ID
      name
    }
    approveUserData {
      ID
      name
    }
    voidUserData {
      ID
      name
    }
    taxData {
      taxSchemeId
      taxSchemeName
      effectiveDate
      taxSchemeDetailId
      totalTaxRate
      totalTaxAmount
      isExclusive
    }
    projectDetail {
      name
    }
  }
}
    `;

/**
 * __useGetPAmiscBillingByIdQuery__
 *
 * To run a query within a React component, call `useGetPAmiscBillingByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPAmiscBillingByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPAmiscBillingByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPAmiscBillingByIdQuery(baseOptions: Apollo.QueryHookOptions<GetPAmiscBillingByIdQuery, GetPAmiscBillingByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPAmiscBillingByIdQuery, GetPAmiscBillingByIdQueryVariables>(GetPAmiscBillingByIdDocument, options);
      }
export function useGetPAmiscBillingByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPAmiscBillingByIdQuery, GetPAmiscBillingByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPAmiscBillingByIdQuery, GetPAmiscBillingByIdQueryVariables>(GetPAmiscBillingByIdDocument, options);
        }
export type GetPAmiscBillingByIdQueryHookResult = ReturnType<typeof useGetPAmiscBillingByIdQuery>;
export type GetPAmiscBillingByIdLazyQueryHookResult = ReturnType<typeof useGetPAmiscBillingByIdLazyQuery>;
export type GetPAmiscBillingByIdQueryResult = Apollo.QueryResult<GetPAmiscBillingByIdQuery, GetPAmiscBillingByIdQueryVariables>;
export const AddPAmiscBillingDocument = gql`
    mutation addPAmiscBilling($isSubmitted: Boolean!, $input: AddPAMiscBillingInput!) {
  addPAmiscBilling(isSubmitted: $isSubmitted, input: $input)
}
    `;
export type AddPAmiscBillingMutationFn = Apollo.MutationFunction<AddPAmiscBillingMutation, AddPAmiscBillingMutationVariables>;

/**
 * __useAddPAmiscBillingMutation__
 *
 * To run a mutation, you first call `useAddPAmiscBillingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPAmiscBillingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPAmiscBillingMutation, { data, loading, error }] = useAddPAmiscBillingMutation({
 *   variables: {
 *      isSubmitted: // value for 'isSubmitted'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPAmiscBillingMutation(baseOptions?: Apollo.MutationHookOptions<AddPAmiscBillingMutation, AddPAmiscBillingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPAmiscBillingMutation, AddPAmiscBillingMutationVariables>(AddPAmiscBillingDocument, options);
      }
export type AddPAmiscBillingMutationHookResult = ReturnType<typeof useAddPAmiscBillingMutation>;
export type AddPAmiscBillingMutationResult = Apollo.MutationResult<AddPAmiscBillingMutation>;
export type AddPAmiscBillingMutationOptions = Apollo.BaseMutationOptions<AddPAmiscBillingMutation, AddPAmiscBillingMutationVariables>;
export const EditPAmiscBillingDocument = gql`
    mutation editPAmiscBilling($isSubmitted: Boolean!, $input: EditPAMiscBillingInput!) {
  editPAmiscBilling(isSubmitted: $isSubmitted, input: $input)
}
    `;
export type EditPAmiscBillingMutationFn = Apollo.MutationFunction<EditPAmiscBillingMutation, EditPAmiscBillingMutationVariables>;

/**
 * __useEditPAmiscBillingMutation__
 *
 * To run a mutation, you first call `useEditPAmiscBillingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPAmiscBillingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPAmiscBillingMutation, { data, loading, error }] = useEditPAmiscBillingMutation({
 *   variables: {
 *      isSubmitted: // value for 'isSubmitted'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditPAmiscBillingMutation(baseOptions?: Apollo.MutationHookOptions<EditPAmiscBillingMutation, EditPAmiscBillingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditPAmiscBillingMutation, EditPAmiscBillingMutationVariables>(EditPAmiscBillingDocument, options);
      }
export type EditPAmiscBillingMutationHookResult = ReturnType<typeof useEditPAmiscBillingMutation>;
export type EditPAmiscBillingMutationResult = Apollo.MutationResult<EditPAmiscBillingMutation>;
export type EditPAmiscBillingMutationOptions = Apollo.BaseMutationOptions<EditPAmiscBillingMutation, EditPAmiscBillingMutationVariables>;
export const GetPAmiscBillingSummaryDocument = gql`
    query getPAmiscBillingSummary($saleId: String!) {
  getPAmiscBillingSummary(saleId: $saleId) {
    totalCharges
    totalUnallocated
    totalDraft
    totalSubmitted
  }
}
    `;

/**
 * __useGetPAmiscBillingSummaryQuery__
 *
 * To run a query within a React component, call `useGetPAmiscBillingSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPAmiscBillingSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPAmiscBillingSummaryQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetPAmiscBillingSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetPAmiscBillingSummaryQuery, GetPAmiscBillingSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPAmiscBillingSummaryQuery, GetPAmiscBillingSummaryQueryVariables>(GetPAmiscBillingSummaryDocument, options);
      }
export function useGetPAmiscBillingSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPAmiscBillingSummaryQuery, GetPAmiscBillingSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPAmiscBillingSummaryQuery, GetPAmiscBillingSummaryQueryVariables>(GetPAmiscBillingSummaryDocument, options);
        }
export type GetPAmiscBillingSummaryQueryHookResult = ReturnType<typeof useGetPAmiscBillingSummaryQuery>;
export type GetPAmiscBillingSummaryLazyQueryHookResult = ReturnType<typeof useGetPAmiscBillingSummaryLazyQuery>;
export type GetPAmiscBillingSummaryQueryResult = Apollo.QueryResult<GetPAmiscBillingSummaryQuery, GetPAmiscBillingSummaryQueryVariables>;
export const DeletePAmbDataDocument = gql`
    mutation deletePAmbData($id: String!) {
  deletePAmbData(id: $id)
}
    `;
export type DeletePAmbDataMutationFn = Apollo.MutationFunction<DeletePAmbDataMutation, DeletePAmbDataMutationVariables>;

/**
 * __useDeletePAmbDataMutation__
 *
 * To run a mutation, you first call `useDeletePAmbDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePAmbDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePAmbDataMutation, { data, loading, error }] = useDeletePAmbDataMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePAmbDataMutation(baseOptions?: Apollo.MutationHookOptions<DeletePAmbDataMutation, DeletePAmbDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePAmbDataMutation, DeletePAmbDataMutationVariables>(DeletePAmbDataDocument, options);
      }
export type DeletePAmbDataMutationHookResult = ReturnType<typeof useDeletePAmbDataMutation>;
export type DeletePAmbDataMutationResult = Apollo.MutationResult<DeletePAmbDataMutation>;
export type DeletePAmbDataMutationOptions = Apollo.BaseMutationOptions<DeletePAmbDataMutation, DeletePAmbDataMutationVariables>;
export const GetSalesContractCreditTermDocument = gql`
    query getSalesContractCreditTerm($saleId: String!) {
  getSalesContractCreditTerm(saleId: $saleId) {
    creditTerm
  }
}
    `;

/**
 * __useGetSalesContractCreditTermQuery__
 *
 * To run a query within a React component, call `useGetSalesContractCreditTermQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesContractCreditTermQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesContractCreditTermQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetSalesContractCreditTermQuery(baseOptions: Apollo.QueryHookOptions<GetSalesContractCreditTermQuery, GetSalesContractCreditTermQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesContractCreditTermQuery, GetSalesContractCreditTermQueryVariables>(GetSalesContractCreditTermDocument, options);
      }
export function useGetSalesContractCreditTermLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesContractCreditTermQuery, GetSalesContractCreditTermQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesContractCreditTermQuery, GetSalesContractCreditTermQueryVariables>(GetSalesContractCreditTermDocument, options);
        }
export type GetSalesContractCreditTermQueryHookResult = ReturnType<typeof useGetSalesContractCreditTermQuery>;
export type GetSalesContractCreditTermLazyQueryHookResult = ReturnType<typeof useGetSalesContractCreditTermLazyQuery>;
export type GetSalesContractCreditTermQueryResult = Apollo.QueryResult<GetSalesContractCreditTermQuery, GetSalesContractCreditTermQueryVariables>;
export const GetProgressBillingByIdDocument = gql`
    query getProgressBillingById($id: String!) {
  getProgressBillingById(id: $id) {
    amount
    creditTerm
    description
    documentAmount
    documentDate
    documentNo
    documentRef
    dueDate
    gotArchitectCert
    id
    installmentSeqNo
    interestRate
    isFinancialBilling
    isIncludeHoliday
    isStakeholder
    isVpStage
    paymentPlanDetailId
    principalAmt
    purchaserAcc
    stageSeqNo
    title
    unallocatedAmount
    voidDate
    voidUserData {
      ID
      name
    }
    taxData {
      taxSchemeId
      taxSchemeName
      effectiveDate
      taxSchemeDetailId
      totalTaxRate
      totalTaxAmount
    }
    billingDetailTaxData {
      taxSchemeName
      totalTaxRate
      totalTaxAmount
    }
    projectDetail {
      name
    }
    billItem {
      billItemType
      id
      name
    }
  }
}
    `;

/**
 * __useGetProgressBillingByIdQuery__
 *
 * To run a query within a React component, call `useGetProgressBillingByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgressBillingByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgressBillingByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProgressBillingByIdQuery(baseOptions: Apollo.QueryHookOptions<GetProgressBillingByIdQuery, GetProgressBillingByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProgressBillingByIdQuery, GetProgressBillingByIdQueryVariables>(GetProgressBillingByIdDocument, options);
      }
export function useGetProgressBillingByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProgressBillingByIdQuery, GetProgressBillingByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProgressBillingByIdQuery, GetProgressBillingByIdQueryVariables>(GetProgressBillingByIdDocument, options);
        }
export type GetProgressBillingByIdQueryHookResult = ReturnType<typeof useGetProgressBillingByIdQuery>;
export type GetProgressBillingByIdLazyQueryHookResult = ReturnType<typeof useGetProgressBillingByIdLazyQuery>;
export type GetProgressBillingByIdQueryResult = Apollo.QueryResult<GetProgressBillingByIdQuery, GetProgressBillingByIdQueryVariables>;
export const ReversalPBdataDocument = gql`
    mutation reversalPBdata($input: postingProgressBillingInput!) {
  reversalPBdata(input: $input)
}
    `;
export type ReversalPBdataMutationFn = Apollo.MutationFunction<ReversalPBdataMutation, ReversalPBdataMutationVariables>;

/**
 * __useReversalPBdataMutation__
 *
 * To run a mutation, you first call `useReversalPBdataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReversalPBdataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reversalPBdataMutation, { data, loading, error }] = useReversalPBdataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReversalPBdataMutation(baseOptions?: Apollo.MutationHookOptions<ReversalPBdataMutation, ReversalPBdataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReversalPBdataMutation, ReversalPBdataMutationVariables>(ReversalPBdataDocument, options);
      }
export type ReversalPBdataMutationHookResult = ReturnType<typeof useReversalPBdataMutation>;
export type ReversalPBdataMutationResult = Apollo.MutationResult<ReversalPBdataMutation>;
export type ReversalPBdataMutationOptions = Apollo.BaseMutationOptions<ReversalPBdataMutation, ReversalPBdataMutationVariables>;
export const GetNewPBdataDocument = gql`
    query getNewPBdata($saleId: String!) {
  getNewPBdata(saleId: $saleId) {
    sale_progress_billing {
      details {
        isVp
        documentNo
        stageSeqNo
        documentDate
        paymentParty
        addOnPurchase
        isStakeholder
        outstandingAmt
        creditDocumentNo
        installmentSeqNo
        paymentPartyCode
        addOnPurchaseName
        progressBillingId
        calculatedDocumentAmt
        paymentPlanDetailTitle
      }
      isReversal
      stageSeqNo
      paymentParty
      addOnPurchase
      paymentPartyCode
      addOnPurchaseName
      paymentPlanDetailTitle
      totalDocumentAmt
      totalOutstanding
      gotAC
      allow_reversal
      system_use
    }
    car_park {
      carPark
      progressBilling {
        details {
          isVp
          documentNo
          stageSeqNo
          documentDate
          paymentParty
          addOnPurchase
          isStakeholder
          outstandingAmt
          creditDocumentNo
          installmentSeqNo
          paymentPartyCode
          addOnPurchaseName
          progressBillingId
          calculatedDocumentAmt
          paymentPlanDetailTitle
        }
        totalDocumentAmt
        totalOutstanding
        paymentPlanDetailTitle
        gotAC
        allow_reversal
        isReversal
        system_use
      }
    }
    sale_package {
      salePackage
      progressBilling {
        details {
          isVp
          documentNo
          stageSeqNo
          documentDate
          paymentParty
          addOnPurchase
          isStakeholder
          outstandingAmt
          creditDocumentNo
          installmentSeqNo
          paymentPartyCode
          addOnPurchaseName
          progressBillingId
          calculatedDocumentAmt
          paymentPlanDetailTitle
        }
        totalDocumentAmt
        totalOutstanding
        paymentPlanDetailTitle
        gotAC
        allow_reversal
        isReversal
        system_use
      }
    }
  }
}
    `;

/**
 * __useGetNewPBdataQuery__
 *
 * To run a query within a React component, call `useGetNewPBdataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewPBdataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewPBdataQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetNewPBdataQuery(baseOptions: Apollo.QueryHookOptions<GetNewPBdataQuery, GetNewPBdataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNewPBdataQuery, GetNewPBdataQueryVariables>(GetNewPBdataDocument, options);
      }
export function useGetNewPBdataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNewPBdataQuery, GetNewPBdataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNewPBdataQuery, GetNewPBdataQueryVariables>(GetNewPBdataDocument, options);
        }
export type GetNewPBdataQueryHookResult = ReturnType<typeof useGetNewPBdataQuery>;
export type GetNewPBdataLazyQueryHookResult = ReturnType<typeof useGetNewPBdataLazyQuery>;
export type GetNewPBdataQueryResult = Apollo.QueryResult<GetNewPBdataQuery, GetNewPBdataQueryVariables>;
export const GetPBdataListDocument = gql`
    query getPBdataList($saleId: String!) {
  getPBdataList(saleId: $saleId) {
    sale_product {
      titleBar
      data {
        id
        sale_id
        is_stakeholder
        document_no
        document_ref
        description
        document_date
        due_date
        is_installment
        is_vp_stage
        stage_seq_no
        installment_seq_no
        title
        acId
        isAC
        isReversal
        isBuyer
        fbData {
          totalFBamount
          fbList {
            financier_name
            financier_code
          }
        }
        creditDocumentNo
        installmentData {
          id
          creditDocumentNo
          document_no
          isBuyer
          outstandingAmt
          pbAmount
          document_date
        }
        sumOrengeAmount
        sumRedAmount
        canReversal
        isVoid
        is_stakeholder
        allow_reversal
      }
    }
    sale_subproduct {
      titleBar
      data {
        id
        sale_id
        is_stakeholder
        document_no
        document_ref
        description
        document_date
        due_date
        is_installment
        is_vp_stage
        stage_seq_no
        installment_seq_no
        title
        acId
        isAC
        isReversal
        isBuyer
        fbData {
          totalFBamount
          fbList {
            financier_name
            financier_code
          }
        }
        creditDocumentNo
        installmentData {
          id
          creditDocumentNo
          document_no
          isBuyer
          outstandingAmt
          pbAmount
          document_date
        }
        sumOrengeAmount
        sumRedAmount
        canReversal
        isVoid
        is_stakeholder
        allow_reversal
      }
    }
    sale_package {
      titleBar
      data {
        id
        sale_id
        is_stakeholder
        document_no
        document_ref
        description
        document_date
        due_date
        is_installment
        is_vp_stage
        stage_seq_no
        installment_seq_no
        title
        acId
        isAC
        isReversal
        isBuyer
        fbData {
          totalFBamount
          fbList {
            financier_name
            financier_code
          }
        }
        creditDocumentNo
        installmentData {
          id
          creditDocumentNo
          document_no
          isBuyer
          outstandingAmt
          pbAmount
          document_date
        }
        sumOrengeAmount
        sumRedAmount
        canReversal
        isVoid
        is_stakeholder
        allow_reversal
      }
    }
  }
}
    `;

/**
 * __useGetPBdataListQuery__
 *
 * To run a query within a React component, call `useGetPBdataListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPBdataListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPBdataListQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetPBdataListQuery(baseOptions: Apollo.QueryHookOptions<GetPBdataListQuery, GetPBdataListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPBdataListQuery, GetPBdataListQueryVariables>(GetPBdataListDocument, options);
      }
export function useGetPBdataListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPBdataListQuery, GetPBdataListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPBdataListQuery, GetPBdataListQueryVariables>(GetPBdataListDocument, options);
        }
export type GetPBdataListQueryHookResult = ReturnType<typeof useGetPBdataListQuery>;
export type GetPBdataListLazyQueryHookResult = ReturnType<typeof useGetPBdataListLazyQuery>;
export type GetPBdataListQueryResult = Apollo.QueryResult<GetPBdataListQuery, GetPBdataListQueryVariables>;
export const GetPurchaserAccListingDocument = gql`
    query getPurchaserAccListing {
  getPurchaserAccListing {
    unitId
    unitNo
    purchaserName
    saleId
    contactId
    phoneNo
    icNo
    remark
    date
    status
  }
}
    `;

/**
 * __useGetPurchaserAccListingQuery__
 *
 * To run a query within a React component, call `useGetPurchaserAccListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPurchaserAccListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPurchaserAccListingQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPurchaserAccListingQuery(baseOptions?: Apollo.QueryHookOptions<GetPurchaserAccListingQuery, GetPurchaserAccListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPurchaserAccListingQuery, GetPurchaserAccListingQueryVariables>(GetPurchaserAccListingDocument, options);
      }
export function useGetPurchaserAccListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPurchaserAccListingQuery, GetPurchaserAccListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPurchaserAccListingQuery, GetPurchaserAccListingQueryVariables>(GetPurchaserAccListingDocument, options);
        }
export type GetPurchaserAccListingQueryHookResult = ReturnType<typeof useGetPurchaserAccListingQuery>;
export type GetPurchaserAccListingLazyQueryHookResult = ReturnType<typeof useGetPurchaserAccListingLazyQuery>;
export type GetPurchaserAccListingQueryResult = Apollo.QueryResult<GetPurchaserAccListingQuery, GetPurchaserAccListingQueryVariables>;
export const GetPurchaserDetailDocument = gql`
    query getPurchaserDetail($saleId: String!) {
  getPurchaserDetail(saleId: $saleId) {
    saleId
    purchaserName
    unitNo
    taxSchemeId
    phoneNo
    icNo
    isCompany
    companyName
  }
}
    `;

/**
 * __useGetPurchaserDetailQuery__
 *
 * To run a query within a React component, call `useGetPurchaserDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPurchaserDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPurchaserDetailQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetPurchaserDetailQuery(baseOptions: Apollo.QueryHookOptions<GetPurchaserDetailQuery, GetPurchaserDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPurchaserDetailQuery, GetPurchaserDetailQueryVariables>(GetPurchaserDetailDocument, options);
      }
export function useGetPurchaserDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPurchaserDetailQuery, GetPurchaserDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPurchaserDetailQuery, GetPurchaserDetailQueryVariables>(GetPurchaserDetailDocument, options);
        }
export type GetPurchaserDetailQueryHookResult = ReturnType<typeof useGetPurchaserDetailQuery>;
export type GetPurchaserDetailLazyQueryHookResult = ReturnType<typeof useGetPurchaserDetailLazyQuery>;
export type GetPurchaserDetailQueryResult = Apollo.QueryResult<GetPurchaserDetailQuery, GetPurchaserDetailQueryVariables>;
export const EditPAmoduleStatusDocument = gql`
    mutation editPAmoduleStatus($tableRef: String!, $isApproved: Boolean!, $sourceIds: [String!]!) {
  editPAmoduleStatus(tableRef: $tableRef, isApproved: $isApproved, sourceIds: $sourceIds)
}
    `;
export type EditPAmoduleStatusMutationFn = Apollo.MutationFunction<EditPAmoduleStatusMutation, EditPAmoduleStatusMutationVariables>;

/**
 * __useEditPAmoduleStatusMutation__
 *
 * To run a mutation, you first call `useEditPAmoduleStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPAmoduleStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPAmoduleStatusMutation, { data, loading, error }] = useEditPAmoduleStatusMutation({
 *   variables: {
 *      tableRef: // value for 'tableRef'
 *      isApproved: // value for 'isApproved'
 *      sourceIds: // value for 'sourceIds'
 *   },
 * });
 */
export function useEditPAmoduleStatusMutation(baseOptions?: Apollo.MutationHookOptions<EditPAmoduleStatusMutation, EditPAmoduleStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditPAmoduleStatusMutation, EditPAmoduleStatusMutationVariables>(EditPAmoduleStatusDocument, options);
      }
export type EditPAmoduleStatusMutationHookResult = ReturnType<typeof useEditPAmoduleStatusMutation>;
export type EditPAmoduleStatusMutationResult = Apollo.MutationResult<EditPAmoduleStatusMutation>;
export type EditPAmoduleStatusMutationOptions = Apollo.BaseMutationOptions<EditPAmoduleStatusMutation, EditPAmoduleStatusMutationVariables>;
export const AllocatePAmoduleDocument = gql`
    mutation allocatePAmodule($input: AllocatePAmoduleDataInput!) {
  allocatePAmodule(input: $input)
}
    `;
export type AllocatePAmoduleMutationFn = Apollo.MutationFunction<AllocatePAmoduleMutation, AllocatePAmoduleMutationVariables>;

/**
 * __useAllocatePAmoduleMutation__
 *
 * To run a mutation, you first call `useAllocatePAmoduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAllocatePAmoduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [allocatePAmoduleMutation, { data, loading, error }] = useAllocatePAmoduleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAllocatePAmoduleMutation(baseOptions?: Apollo.MutationHookOptions<AllocatePAmoduleMutation, AllocatePAmoduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AllocatePAmoduleMutation, AllocatePAmoduleMutationVariables>(AllocatePAmoduleDocument, options);
      }
export type AllocatePAmoduleMutationHookResult = ReturnType<typeof useAllocatePAmoduleMutation>;
export type AllocatePAmoduleMutationResult = Apollo.MutationResult<AllocatePAmoduleMutation>;
export type AllocatePAmoduleMutationOptions = Apollo.BaseMutationOptions<AllocatePAmoduleMutation, AllocatePAmoduleMutationVariables>;
export const GetPAsummaryDocument = gql`
    query getPAsummary($saleId: String!) {
  getPAsummary(saleId: $saleId) {
    progressBillingSummary {
      totalCharges
      totalUnallocated
      pbData {
        has_architect_cert
        has_posted
        stage_seq_no
      }
    }
    purchaserDetail {
      saleId
      purchaserName
      unitNo
      taxSchemeId
      phoneNo
      icNo
      contactId
    }
    creditNoteSummary {
      totalCharges
      totalUnallocated
      totalDraft
      totalSubmitted
    }
    debitNoteSummary {
      totalCharges
      totalUnallocated
      totalDraft
      totalSubmitted
    }
    rebateSummary {
      totalCharges
      totalUnallocated
      totalDraft
      totalSubmitted
    }
    contraSummary {
      totalCharges
      totalUnallocated
      totalDraft
      totalSubmitted
    }
    miscBillingSummary {
      totalCharges
      totalUnallocated
      totalDraft
      totalSubmitted
    }
    lateInterestSummary {
      totalCharges
      totalUnallocated
      totalDraft
      totalSubmitted
    }
    refundSummary {
      totalCharges
      totalUnallocated
      totalDraft
      totalSubmitted
    }
    collectionSummary {
      totalCharges
      totalUnallocated
      totalDraft
      totalSubmitted
    }
    contactData {
      contactId
      icNo
      phoneNo
      purchaserName
      companyName
      companyRegNo
      isCompany
      officeTel
    }
    unitData {
      contactId
      saleId
      unitId
      unitNo
      unitStatus
    }
    collectionActivity {
      activityDate
      activityRemark
    }
    paymentReminder {
      reminder1
      reminder2
      reminder3
    }
  }
}
    `;

/**
 * __useGetPAsummaryQuery__
 *
 * To run a query within a React component, call `useGetPAsummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPAsummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPAsummaryQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetPAsummaryQuery(baseOptions: Apollo.QueryHookOptions<GetPAsummaryQuery, GetPAsummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPAsummaryQuery, GetPAsummaryQueryVariables>(GetPAsummaryDocument, options);
      }
export function useGetPAsummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPAsummaryQuery, GetPAsummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPAsummaryQuery, GetPAsummaryQueryVariables>(GetPAsummaryDocument, options);
        }
export type GetPAsummaryQueryHookResult = ReturnType<typeof useGetPAsummaryQuery>;
export type GetPAsummaryLazyQueryHookResult = ReturnType<typeof useGetPAsummaryLazyQuery>;
export type GetPAsummaryQueryResult = Apollo.QueryResult<GetPAsummaryQuery, GetPAsummaryQueryVariables>;
export const GetAllBillingBySaleIdDocument = gql`
    query getAllBillingBySaleId($billItemId: String, $creditId: String, $taxSchemeId: String, $mainTable: String!, $saleId: String!) {
  getAllBillingBySaleId(billItemId: $billItemId, creditId: $creditId, taxSchemeId: $taxSchemeId, mainTable: $mainTable, saleId: $saleId) {
    id
    table
    documentNo
    documentDate
    documentAmount
    description
    outstanding
    currentAllocate
    totalAllocateAmount
    enabledAllocate
    financialBillingId
  }
}
    `;

/**
 * __useGetAllBillingBySaleIdQuery__
 *
 * To run a query within a React component, call `useGetAllBillingBySaleIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllBillingBySaleIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllBillingBySaleIdQuery({
 *   variables: {
 *      billItemId: // value for 'billItemId'
 *      creditId: // value for 'creditId'
 *      taxSchemeId: // value for 'taxSchemeId'
 *      mainTable: // value for 'mainTable'
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetAllBillingBySaleIdQuery(baseOptions: Apollo.QueryHookOptions<GetAllBillingBySaleIdQuery, GetAllBillingBySaleIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllBillingBySaleIdQuery, GetAllBillingBySaleIdQueryVariables>(GetAllBillingBySaleIdDocument, options);
      }
export function useGetAllBillingBySaleIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllBillingBySaleIdQuery, GetAllBillingBySaleIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllBillingBySaleIdQuery, GetAllBillingBySaleIdQueryVariables>(GetAllBillingBySaleIdDocument, options);
        }
export type GetAllBillingBySaleIdQueryHookResult = ReturnType<typeof useGetAllBillingBySaleIdQuery>;
export type GetAllBillingBySaleIdLazyQueryHookResult = ReturnType<typeof useGetAllBillingBySaleIdLazyQuery>;
export type GetAllBillingBySaleIdQueryResult = Apollo.QueryResult<GetAllBillingBySaleIdQuery, GetAllBillingBySaleIdQueryVariables>;
export const ReversalPaRecordByIdDocument = gql`
    mutation reversalPARecordById($id: String!, $saleId: String!, $tableRef: String!) {
  reversalPARecordById(id: $id, saleId: $saleId, tableRef: $tableRef)
}
    `;
export type ReversalPaRecordByIdMutationFn = Apollo.MutationFunction<ReversalPaRecordByIdMutation, ReversalPaRecordByIdMutationVariables>;

/**
 * __useReversalPaRecordByIdMutation__
 *
 * To run a mutation, you first call `useReversalPaRecordByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReversalPaRecordByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reversalPaRecordByIdMutation, { data, loading, error }] = useReversalPaRecordByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      saleId: // value for 'saleId'
 *      tableRef: // value for 'tableRef'
 *   },
 * });
 */
export function useReversalPaRecordByIdMutation(baseOptions?: Apollo.MutationHookOptions<ReversalPaRecordByIdMutation, ReversalPaRecordByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReversalPaRecordByIdMutation, ReversalPaRecordByIdMutationVariables>(ReversalPaRecordByIdDocument, options);
      }
export type ReversalPaRecordByIdMutationHookResult = ReturnType<typeof useReversalPaRecordByIdMutation>;
export type ReversalPaRecordByIdMutationResult = Apollo.MutationResult<ReversalPaRecordByIdMutation>;
export type ReversalPaRecordByIdMutationOptions = Apollo.BaseMutationOptions<ReversalPaRecordByIdMutation, ReversalPaRecordByIdMutationVariables>;
export const GetContactListDocument = gql`
    query getContactList($unitId: String) {
  getContactList(unitId: $unitId) {
    contactId
    icNo
    phoneNo
    purchaserName
    isCompany
    companyName
    companyRegNo
    officeTel
  }
}
    `;

/**
 * __useGetContactListQuery__
 *
 * To run a query within a React component, call `useGetContactListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactListQuery({
 *   variables: {
 *      unitId: // value for 'unitId'
 *   },
 * });
 */
export function useGetContactListQuery(baseOptions?: Apollo.QueryHookOptions<GetContactListQuery, GetContactListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactListQuery, GetContactListQueryVariables>(GetContactListDocument, options);
      }
export function useGetContactListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactListQuery, GetContactListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactListQuery, GetContactListQueryVariables>(GetContactListDocument, options);
        }
export type GetContactListQueryHookResult = ReturnType<typeof useGetContactListQuery>;
export type GetContactListLazyQueryHookResult = ReturnType<typeof useGetContactListLazyQuery>;
export type GetContactListQueryResult = Apollo.QueryResult<GetContactListQuery, GetContactListQueryVariables>;
export const GetUnitListDocument = gql`
    query getUnitList($contactId: String) {
  getUnitList(contactId: $contactId) {
    contactId
    saleId
    unitId
    unitNo
    unitStatus
    salesConvertedStatus
    clusterName
  }
}
    `;

/**
 * __useGetUnitListQuery__
 *
 * To run a query within a React component, call `useGetUnitListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitListQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useGetUnitListQuery(baseOptions?: Apollo.QueryHookOptions<GetUnitListQuery, GetUnitListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitListQuery, GetUnitListQueryVariables>(GetUnitListDocument, options);
      }
export function useGetUnitListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitListQuery, GetUnitListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitListQuery, GetUnitListQueryVariables>(GetUnitListDocument, options);
        }
export type GetUnitListQueryHookResult = ReturnType<typeof useGetUnitListQuery>;
export type GetUnitListLazyQueryHookResult = ReturnType<typeof useGetUnitListLazyQuery>;
export type GetUnitListQueryResult = Apollo.QueryResult<GetUnitListQuery, GetUnitListQueryVariables>;
export const DeletePAdataDocument = gql`
    mutation deletePAdata($tableRef: String!, $id: String!, $haveAllocation: Boolean!) {
  deletePAdata(tableRef: $tableRef, id: $id, haveAllocation: $haveAllocation)
}
    `;
export type DeletePAdataMutationFn = Apollo.MutationFunction<DeletePAdataMutation, DeletePAdataMutationVariables>;

/**
 * __useDeletePAdataMutation__
 *
 * To run a mutation, you first call `useDeletePAdataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePAdataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePAdataMutation, { data, loading, error }] = useDeletePAdataMutation({
 *   variables: {
 *      tableRef: // value for 'tableRef'
 *      id: // value for 'id'
 *      haveAllocation: // value for 'haveAllocation'
 *   },
 * });
 */
export function useDeletePAdataMutation(baseOptions?: Apollo.MutationHookOptions<DeletePAdataMutation, DeletePAdataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePAdataMutation, DeletePAdataMutationVariables>(DeletePAdataDocument, options);
      }
export type DeletePAdataMutationHookResult = ReturnType<typeof useDeletePAdataMutation>;
export type DeletePAdataMutationResult = Apollo.MutationResult<DeletePAdataMutation>;
export type DeletePAdataMutationOptions = Apollo.BaseMutationOptions<DeletePAdataMutation, DeletePAdataMutationVariables>;
export const GetProjectLetterTemplateDocument = gql`
    query getProjectLetterTemplate($letterType: String!) {
  getProjectLetterTemplate(letterType: $letterType) {
    templateId
    stdLtrId
    templateName
    letterName
  }
}
    `;

/**
 * __useGetProjectLetterTemplateQuery__
 *
 * To run a query within a React component, call `useGetProjectLetterTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectLetterTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectLetterTemplateQuery({
 *   variables: {
 *      letterType: // value for 'letterType'
 *   },
 * });
 */
export function useGetProjectLetterTemplateQuery(baseOptions: Apollo.QueryHookOptions<GetProjectLetterTemplateQuery, GetProjectLetterTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectLetterTemplateQuery, GetProjectLetterTemplateQueryVariables>(GetProjectLetterTemplateDocument, options);
      }
export function useGetProjectLetterTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectLetterTemplateQuery, GetProjectLetterTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectLetterTemplateQuery, GetProjectLetterTemplateQueryVariables>(GetProjectLetterTemplateDocument, options);
        }
export type GetProjectLetterTemplateQueryHookResult = ReturnType<typeof useGetProjectLetterTemplateQuery>;
export type GetProjectLetterTemplateLazyQueryHookResult = ReturnType<typeof useGetProjectLetterTemplateLazyQuery>;
export type GetProjectLetterTemplateQueryResult = Apollo.QueryResult<GetProjectLetterTemplateQuery, GetProjectLetterTemplateQueryVariables>;
export const GetPArebateListDocument = gql`
    query getPArebateList($saleId: String!, $status: String!) {
  getPArebateList(saleId: $saleId, status: $status) {
    allowReversal
    approvedBy
    approvedDate
    description
    documentAmount
    documentDate
    documentNo
    id
    requestedBy
    status
    submittedBy
    submittedDate
    unallocatedAmount
    attachment {
      id
      fileName
      allowDelete
      isPrivate
      mediaType
      resourceUrl
    }
    billItem {
      billItemType
      id
      name
    }
    requestUserData {
      ID
      name
    }
    submitUserData {
      ID
      name
    }
    approveUserData {
      ID
      name
    }
    taxData {
      taxSchemeId
      taxSchemeName
      effectiveDate
      taxSchemeDetailId
      totalTaxRate
      totalTaxAmount
    }
  }
}
    `;

/**
 * __useGetPArebateListQuery__
 *
 * To run a query within a React component, call `useGetPArebateListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPArebateListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPArebateListQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetPArebateListQuery(baseOptions: Apollo.QueryHookOptions<GetPArebateListQuery, GetPArebateListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPArebateListQuery, GetPArebateListQueryVariables>(GetPArebateListDocument, options);
      }
export function useGetPArebateListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPArebateListQuery, GetPArebateListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPArebateListQuery, GetPArebateListQueryVariables>(GetPArebateListDocument, options);
        }
export type GetPArebateListQueryHookResult = ReturnType<typeof useGetPArebateListQuery>;
export type GetPArebateListLazyQueryHookResult = ReturnType<typeof useGetPArebateListLazyQuery>;
export type GetPArebateListQueryResult = Apollo.QueryResult<GetPArebateListQuery, GetPArebateListQueryVariables>;
export const GetPaRebateSubmittedListDocument = gql`
    query getPARebateSubmittedList($saleId: String!) {
  getPARebateSubmittedList(saleId: $saleId) {
    id
    documentAmount
    documentDate
    description
    approvalRoleId
    submittedDate
    unallocatedAmount
    attachment {
      id
      fileName
      allowDelete
      isPrivate
      mediaType
      resourceUrl
    }
    billItem {
      billItemType
      id
      name
    }
    requestUserData {
      ID
      name
    }
    submitUserData {
      ID
      name
    }
    approveUserData {
      ID
      name
    }
    taxData {
      taxSchemeId
      taxSchemeName
      effectiveDate
      taxSchemeDetailId
      totalTaxRate
      totalTaxAmount
    }
    billingDetailTaxData {
      taxSchemeName
      totalTaxRate
      totalTaxAmount
    }
  }
}
    `;

/**
 * __useGetPaRebateSubmittedListQuery__
 *
 * To run a query within a React component, call `useGetPaRebateSubmittedListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaRebateSubmittedListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaRebateSubmittedListQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetPaRebateSubmittedListQuery(baseOptions: Apollo.QueryHookOptions<GetPaRebateSubmittedListQuery, GetPaRebateSubmittedListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaRebateSubmittedListQuery, GetPaRebateSubmittedListQueryVariables>(GetPaRebateSubmittedListDocument, options);
      }
export function useGetPaRebateSubmittedListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaRebateSubmittedListQuery, GetPaRebateSubmittedListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaRebateSubmittedListQuery, GetPaRebateSubmittedListQueryVariables>(GetPaRebateSubmittedListDocument, options);
        }
export type GetPaRebateSubmittedListQueryHookResult = ReturnType<typeof useGetPaRebateSubmittedListQuery>;
export type GetPaRebateSubmittedListLazyQueryHookResult = ReturnType<typeof useGetPaRebateSubmittedListLazyQuery>;
export type GetPaRebateSubmittedListQueryResult = Apollo.QueryResult<GetPaRebateSubmittedListQuery, GetPaRebateSubmittedListQueryVariables>;
export const GetPArebateSummaryDocument = gql`
    query getPArebateSummary($projectId: String!, $saleId: String!) {
  getPArebateSummary(projectId: $projectId, saleId: $saleId) {
    totalCharges
    totalUnallocated
    totalDraft
    totalSubmitted
  }
}
    `;

/**
 * __useGetPArebateSummaryQuery__
 *
 * To run a query within a React component, call `useGetPArebateSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPArebateSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPArebateSummaryQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetPArebateSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetPArebateSummaryQuery, GetPArebateSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPArebateSummaryQuery, GetPArebateSummaryQueryVariables>(GetPArebateSummaryDocument, options);
      }
export function useGetPArebateSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPArebateSummaryQuery, GetPArebateSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPArebateSummaryQuery, GetPArebateSummaryQueryVariables>(GetPArebateSummaryDocument, options);
        }
export type GetPArebateSummaryQueryHookResult = ReturnType<typeof useGetPArebateSummaryQuery>;
export type GetPArebateSummaryLazyQueryHookResult = ReturnType<typeof useGetPArebateSummaryLazyQuery>;
export type GetPArebateSummaryQueryResult = Apollo.QueryResult<GetPArebateSummaryQuery, GetPArebateSummaryQueryVariables>;
export const GetPArebateByIdDocument = gql`
    query getPArebateById($id: String!) {
  getPArebateById(id: $id) {
    allowReversal
    approvedBy
    approvedDate
    billItemId
    description
    documentAmount
    documentDate
    documentNo
    documentRef
    id
    requestedBy
    status
    submittedBy
    submittedDate
    unallocatedAmount
    voidDate
    allocation {
      allocateAmount
    }
    attachment {
      id
      fileName
      allowDelete
      isPrivate
      mediaType
      resourceUrl
    }
    billItem {
      billItemType
      id
      name
    }
    requestUserData {
      ID
      name
    }
    submitUserData {
      ID
      name
    }
    approveUserData {
      ID
      name
    }
    taxData {
      taxSchemeId
      taxSchemeName
      effectiveDate
      taxSchemeDetailId
      totalTaxRate
      totalTaxAmount
      isExclusive
    }
    voidUserData {
      name
    }
    projectDetail {
      name
    }
  }
}
    `;

/**
 * __useGetPArebateByIdQuery__
 *
 * To run a query within a React component, call `useGetPArebateByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPArebateByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPArebateByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPArebateByIdQuery(baseOptions: Apollo.QueryHookOptions<GetPArebateByIdQuery, GetPArebateByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPArebateByIdQuery, GetPArebateByIdQueryVariables>(GetPArebateByIdDocument, options);
      }
export function useGetPArebateByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPArebateByIdQuery, GetPArebateByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPArebateByIdQuery, GetPArebateByIdQueryVariables>(GetPArebateByIdDocument, options);
        }
export type GetPArebateByIdQueryHookResult = ReturnType<typeof useGetPArebateByIdQuery>;
export type GetPArebateByIdLazyQueryHookResult = ReturnType<typeof useGetPArebateByIdLazyQuery>;
export type GetPArebateByIdQueryResult = Apollo.QueryResult<GetPArebateByIdQuery, GetPArebateByIdQueryVariables>;
export const AddPArebateDocument = gql`
    mutation addPArebate($isSubmitted: Boolean!, $input: AddPAmoduleDataInput!) {
  addPArebate(isSubmitted: $isSubmitted, input: $input)
}
    `;
export type AddPArebateMutationFn = Apollo.MutationFunction<AddPArebateMutation, AddPArebateMutationVariables>;

/**
 * __useAddPArebateMutation__
 *
 * To run a mutation, you first call `useAddPArebateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPArebateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPArebateMutation, { data, loading, error }] = useAddPArebateMutation({
 *   variables: {
 *      isSubmitted: // value for 'isSubmitted'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPArebateMutation(baseOptions?: Apollo.MutationHookOptions<AddPArebateMutation, AddPArebateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPArebateMutation, AddPArebateMutationVariables>(AddPArebateDocument, options);
      }
export type AddPArebateMutationHookResult = ReturnType<typeof useAddPArebateMutation>;
export type AddPArebateMutationResult = Apollo.MutationResult<AddPArebateMutation>;
export type AddPArebateMutationOptions = Apollo.BaseMutationOptions<AddPArebateMutation, AddPArebateMutationVariables>;
export const EditPArebateDocument = gql`
    mutation editPArebate($isSubmitted: Boolean!, $input: EditPAmoduleDataInput!) {
  editPArebate(isSubmitted: $isSubmitted, input: $input)
}
    `;
export type EditPArebateMutationFn = Apollo.MutationFunction<EditPArebateMutation, EditPArebateMutationVariables>;

/**
 * __useEditPArebateMutation__
 *
 * To run a mutation, you first call `useEditPArebateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPArebateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPArebateMutation, { data, loading, error }] = useEditPArebateMutation({
 *   variables: {
 *      isSubmitted: // value for 'isSubmitted'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditPArebateMutation(baseOptions?: Apollo.MutationHookOptions<EditPArebateMutation, EditPArebateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditPArebateMutation, EditPArebateMutationVariables>(EditPArebateDocument, options);
      }
export type EditPArebateMutationHookResult = ReturnType<typeof useEditPArebateMutation>;
export type EditPArebateMutationResult = Apollo.MutationResult<EditPArebateMutation>;
export type EditPArebateMutationOptions = Apollo.BaseMutationOptions<EditPArebateMutation, EditPArebateMutationVariables>;
export const GetPArefundListDocument = gql`
    query getPArefundList($saleId: String!, $status: String!) {
  getPArefundList(saleId: $saleId, status: $status) {
    id
    documentDate
    documentAmount
    documentNo
    description
    status
    submittedBy
    approvedBy
    approvedDate
    submittedDate
    attachment {
      id
      fileName
      allowDelete
      isPrivate
      mediaType
      resourceUrl
    }
    submitUserData {
      name
    }
    approveUserData {
      name
    }
  }
}
    `;

/**
 * __useGetPArefundListQuery__
 *
 * To run a query within a React component, call `useGetPArefundListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPArefundListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPArefundListQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetPArefundListQuery(baseOptions: Apollo.QueryHookOptions<GetPArefundListQuery, GetPArefundListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPArefundListQuery, GetPArefundListQueryVariables>(GetPArefundListDocument, options);
      }
export function useGetPArefundListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPArefundListQuery, GetPArefundListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPArefundListQuery, GetPArefundListQueryVariables>(GetPArefundListDocument, options);
        }
export type GetPArefundListQueryHookResult = ReturnType<typeof useGetPArefundListQuery>;
export type GetPArefundListLazyQueryHookResult = ReturnType<typeof useGetPArefundListLazyQuery>;
export type GetPArefundListQueryResult = Apollo.QueryResult<GetPArefundListQuery, GetPArefundListQueryVariables>;
export const GetPaRefundSubmittedListDocument = gql`
    query getPARefundSubmittedList($saleId: String!) {
  getPARefundSubmittedList(saleId: $saleId) {
    id
    documentAmount
    documentDate
    description
    approvalRoleId
    submittedDate
    attachment {
      id
      fileName
      allowDelete
      isPrivate
      mediaType
      resourceUrl
    }
    submitUserData {
      ID
      name
    }
    approveUserData {
      ID
      name
    }
  }
}
    `;

/**
 * __useGetPaRefundSubmittedListQuery__
 *
 * To run a query within a React component, call `useGetPaRefundSubmittedListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaRefundSubmittedListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaRefundSubmittedListQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetPaRefundSubmittedListQuery(baseOptions: Apollo.QueryHookOptions<GetPaRefundSubmittedListQuery, GetPaRefundSubmittedListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaRefundSubmittedListQuery, GetPaRefundSubmittedListQueryVariables>(GetPaRefundSubmittedListDocument, options);
      }
export function useGetPaRefundSubmittedListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaRefundSubmittedListQuery, GetPaRefundSubmittedListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaRefundSubmittedListQuery, GetPaRefundSubmittedListQueryVariables>(GetPaRefundSubmittedListDocument, options);
        }
export type GetPaRefundSubmittedListQueryHookResult = ReturnType<typeof useGetPaRefundSubmittedListQuery>;
export type GetPaRefundSubmittedListLazyQueryHookResult = ReturnType<typeof useGetPaRefundSubmittedListLazyQuery>;
export type GetPaRefundSubmittedListQueryResult = Apollo.QueryResult<GetPaRefundSubmittedListQuery, GetPaRefundSubmittedListQueryVariables>;
export const GetPArefundSummaryDocument = gql`
    query getPArefundSummary($projectId: String!, $saleId: String!) {
  getPArefundSummary(projectId: $projectId, saleId: $saleId) {
    totalCharges
    totalUnallocated
    totalDraft
    totalSubmitted
  }
}
    `;

/**
 * __useGetPArefundSummaryQuery__
 *
 * To run a query within a React component, call `useGetPArefundSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPArefundSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPArefundSummaryQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetPArefundSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetPArefundSummaryQuery, GetPArefundSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPArefundSummaryQuery, GetPArefundSummaryQueryVariables>(GetPArefundSummaryDocument, options);
      }
export function useGetPArefundSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPArefundSummaryQuery, GetPArefundSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPArefundSummaryQuery, GetPArefundSummaryQueryVariables>(GetPArefundSummaryDocument, options);
        }
export type GetPArefundSummaryQueryHookResult = ReturnType<typeof useGetPArefundSummaryQuery>;
export type GetPArefundSummaryLazyQueryHookResult = ReturnType<typeof useGetPArefundSummaryLazyQuery>;
export type GetPArefundSummaryQueryResult = Apollo.QueryResult<GetPArefundSummaryQuery, GetPArefundSummaryQueryVariables>;
export const GetPArefundByIdDocument = gql`
    query getPArefundById($id: String!) {
  getPArefundById(id: $id) {
    approvedBy
    approvedDate
    bankAccountId
    chequeDate
    chequeExpireDate
    creditCardType
    description
    documentAmount
    documentDate
    documentNo
    documentRef
    id
    refundMethod
    saleId
    status
    submittedBy
    submittedDate
    attachment {
      id
      fileName
      allowDelete
      isPrivate
      mediaType
      resourceUrl
    }
    submitUserData {
      ID
      name
    }
    approveUserData {
      ID
      name
    }
    projectDetail {
      name
    }
  }
}
    `;

/**
 * __useGetPArefundByIdQuery__
 *
 * To run a query within a React component, call `useGetPArefundByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPArefundByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPArefundByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPArefundByIdQuery(baseOptions: Apollo.QueryHookOptions<GetPArefundByIdQuery, GetPArefundByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPArefundByIdQuery, GetPArefundByIdQueryVariables>(GetPArefundByIdDocument, options);
      }
export function useGetPArefundByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPArefundByIdQuery, GetPArefundByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPArefundByIdQuery, GetPArefundByIdQueryVariables>(GetPArefundByIdDocument, options);
        }
export type GetPArefundByIdQueryHookResult = ReturnType<typeof useGetPArefundByIdQuery>;
export type GetPArefundByIdLazyQueryHookResult = ReturnType<typeof useGetPArefundByIdLazyQuery>;
export type GetPArefundByIdQueryResult = Apollo.QueryResult<GetPArefundByIdQuery, GetPArefundByIdQueryVariables>;
export const AddPArefundDocument = gql`
    mutation addPArefund($isSubmitted: Boolean!, $input: AddRefundDataInput!) {
  addPArefund(isSubmitted: $isSubmitted, input: $input)
}
    `;
export type AddPArefundMutationFn = Apollo.MutationFunction<AddPArefundMutation, AddPArefundMutationVariables>;

/**
 * __useAddPArefundMutation__
 *
 * To run a mutation, you first call `useAddPArefundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPArefundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPArefundMutation, { data, loading, error }] = useAddPArefundMutation({
 *   variables: {
 *      isSubmitted: // value for 'isSubmitted'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPArefundMutation(baseOptions?: Apollo.MutationHookOptions<AddPArefundMutation, AddPArefundMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPArefundMutation, AddPArefundMutationVariables>(AddPArefundDocument, options);
      }
export type AddPArefundMutationHookResult = ReturnType<typeof useAddPArefundMutation>;
export type AddPArefundMutationResult = Apollo.MutationResult<AddPArefundMutation>;
export type AddPArefundMutationOptions = Apollo.BaseMutationOptions<AddPArefundMutation, AddPArefundMutationVariables>;
export const EditPArefundDocument = gql`
    mutation editPArefund($isSubmitted: Boolean!, $input: EditRefundDataInput!) {
  editPArefund(isSubmitted: $isSubmitted, input: $input)
}
    `;
export type EditPArefundMutationFn = Apollo.MutationFunction<EditPArefundMutation, EditPArefundMutationVariables>;

/**
 * __useEditPArefundMutation__
 *
 * To run a mutation, you first call `useEditPArefundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPArefundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPArefundMutation, { data, loading, error }] = useEditPArefundMutation({
 *   variables: {
 *      isSubmitted: // value for 'isSubmitted'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditPArefundMutation(baseOptions?: Apollo.MutationHookOptions<EditPArefundMutation, EditPArefundMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditPArefundMutation, EditPArefundMutationVariables>(EditPArefundDocument, options);
      }
export type EditPArefundMutationHookResult = ReturnType<typeof useEditPArefundMutation>;
export type EditPArefundMutationResult = Apollo.MutationResult<EditPArefundMutation>;
export type EditPArefundMutationOptions = Apollo.BaseMutationOptions<EditPArefundMutation, EditPArefundMutationVariables>;
export const GetRefundAllocationDocument = gql`
    query getRefundAllocation($saleId: String!, $refundId: String) {
  getRefundAllocation(saleId: $saleId, refundId: $refundId) {
    creditId
    docAmt
    docNo
    outstandingAmt
    description
    docDate
    creditRefTable
    outstandingAmt
    currentAllocate
    totalAllocate
  }
}
    `;

/**
 * __useGetRefundAllocationQuery__
 *
 * To run a query within a React component, call `useGetRefundAllocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRefundAllocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRefundAllocationQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *      refundId: // value for 'refundId'
 *   },
 * });
 */
export function useGetRefundAllocationQuery(baseOptions: Apollo.QueryHookOptions<GetRefundAllocationQuery, GetRefundAllocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRefundAllocationQuery, GetRefundAllocationQueryVariables>(GetRefundAllocationDocument, options);
      }
export function useGetRefundAllocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRefundAllocationQuery, GetRefundAllocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRefundAllocationQuery, GetRefundAllocationQueryVariables>(GetRefundAllocationDocument, options);
        }
export type GetRefundAllocationQueryHookResult = ReturnType<typeof useGetRefundAllocationQuery>;
export type GetRefundAllocationLazyQueryHookResult = ReturnType<typeof useGetRefundAllocationLazyQuery>;
export type GetRefundAllocationQueryResult = Apollo.QueryResult<GetRefundAllocationQuery, GetRefundAllocationQueryVariables>;
export const GetAllocationByCreditIdDocument = gql`
    query getAllocationByCreditId($id: String!) {
  getAllocationByCreditId(id: $id) {
    allocateAmount
    debitNote {
      id
      description
      documentAmount
      documentDate
      documentNo
      isReversal
      voidBy
    }
  }
}
    `;

/**
 * __useGetAllocationByCreditIdQuery__
 *
 * To run a query within a React component, call `useGetAllocationByCreditIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllocationByCreditIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllocationByCreditIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAllocationByCreditIdQuery(baseOptions: Apollo.QueryHookOptions<GetAllocationByCreditIdQuery, GetAllocationByCreditIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllocationByCreditIdQuery, GetAllocationByCreditIdQueryVariables>(GetAllocationByCreditIdDocument, options);
      }
export function useGetAllocationByCreditIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllocationByCreditIdQuery, GetAllocationByCreditIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllocationByCreditIdQuery, GetAllocationByCreditIdQueryVariables>(GetAllocationByCreditIdDocument, options);
        }
export type GetAllocationByCreditIdQueryHookResult = ReturnType<typeof useGetAllocationByCreditIdQuery>;
export type GetAllocationByCreditIdLazyQueryHookResult = ReturnType<typeof useGetAllocationByCreditIdLazyQuery>;
export type GetAllocationByCreditIdQueryResult = Apollo.QueryResult<GetAllocationByCreditIdQuery, GetAllocationByCreditIdQueryVariables>;
export const GetPaIndoSummaryDocument = gql`
    query getPAIndoSummary($projectId: String!) {
  getPAIndoSummary(projectId: $projectId) {
    purchaserInstallmentSummary {
      totalDocAmt
      draftCount
      submitCount
      approveCount
      totalUnallocatedAmt
    }
    additionalPackageSummary {
      totalUnallocatedAmt
      totalDocAmt
      itemCount
      totalSellingPrice
    }
    carParkSummary {
      totalOutstandingAmount
      totalAllocateAmount
      itemCount
      totalSellingPrice
    }
    miscBillingSummary {
      totalDocAmt
      draftCount
      submitCount
      approveCount
      totalUnallocatedAmt
    }
    lateInterestSummary {
      totalCharges
      totalUnallocatedAmt
      totalApproved
    }
    debitNoteSummary {
      totalDocAmt
      draftCount
      submitCount
      approveCount
      totalUnallocatedAmt
    }
    creditNoteSummary {
      totalDocAmt
      draftCount
      submitCount
      approveCount
      totalUnallocatedAmt
    }
    rebateSummary {
      totalDocAmt
      draftCount
      submitCount
      approveCount
      totalUnallocatedAmt
    }
    paymentSummary {
      totalDocAmt
      draftCount
      submitCount
      approveCount
      totalUnallocatedAmt
    }
    depositSummary {
      totalDocAmt
      draftCount
      submitCount
      approveCount
      totalUnallocatedAmt
    }
    contraSummary {
      totalDocAmt
      draftCount
      submitCount
      approveCount
      totalUnallocatedAmt
    }
    refundSummary {
      totalDocAmt
      draftCount
      submitCount
      approveCount
      totalUnallocatedAmt
    }
  }
}
    `;

/**
 * __useGetPaIndoSummaryQuery__
 *
 * To run a query within a React component, call `useGetPaIndoSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaIndoSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaIndoSummaryQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetPaIndoSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetPaIndoSummaryQuery, GetPaIndoSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaIndoSummaryQuery, GetPaIndoSummaryQueryVariables>(GetPaIndoSummaryDocument, options);
      }
export function useGetPaIndoSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaIndoSummaryQuery, GetPaIndoSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaIndoSummaryQuery, GetPaIndoSummaryQueryVariables>(GetPaIndoSummaryDocument, options);
        }
export type GetPaIndoSummaryQueryHookResult = ReturnType<typeof useGetPaIndoSummaryQuery>;
export type GetPaIndoSummaryLazyQueryHookResult = ReturnType<typeof useGetPaIndoSummaryLazyQuery>;
export type GetPaIndoSummaryQueryResult = Apollo.QueryResult<GetPaIndoSummaryQuery, GetPaIndoSummaryQueryVariables>;
export const GetPaIndoMiscBillingSummaryDocument = gql`
    query getPAIndoMiscBillingSummary($projectId: String!, $status: String, $saleId: String) {
  getPAIndoMiscBillingSummary(projectId: $projectId, status: $status, saleId: $saleId) {
    id
    saleId
    documentDate
    documentAmount
    unitDetail
    contactDetail
    interestRate
    creditTerm
    billItemInt {
      billItemType
      name
    }
    description
    dueDate
    taxData {
      taxSchemeName
      totalTaxRate
    }
    requestedBy
    submittedBy
    submittedDate
    taxLedger {
      taxAmount
    }
    attachment {
      allowDelete
      fileName
      id
      isPrivate
      mediaType
      resourceUrl
    }
    requestUserData {
      ID
      name
      userName
    }
    submitUserData {
      ID
      name
      userName
    }
    approveUserData {
      ID
      name
      userName
    }
    unallocatedAmount
    unallocatedAmountSummary
    documentNo
    clusterName {
      name
    }
    salesRegNo {
      salesRegistrationNo
    }
    status
    generationBatch
    generationBatchDate
  }
}
    `;

/**
 * __useGetPaIndoMiscBillingSummaryQuery__
 *
 * To run a query within a React component, call `useGetPaIndoMiscBillingSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaIndoMiscBillingSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaIndoMiscBillingSummaryQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      status: // value for 'status'
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetPaIndoMiscBillingSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetPaIndoMiscBillingSummaryQuery, GetPaIndoMiscBillingSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaIndoMiscBillingSummaryQuery, GetPaIndoMiscBillingSummaryQueryVariables>(GetPaIndoMiscBillingSummaryDocument, options);
      }
export function useGetPaIndoMiscBillingSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaIndoMiscBillingSummaryQuery, GetPaIndoMiscBillingSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaIndoMiscBillingSummaryQuery, GetPaIndoMiscBillingSummaryQueryVariables>(GetPaIndoMiscBillingSummaryDocument, options);
        }
export type GetPaIndoMiscBillingSummaryQueryHookResult = ReturnType<typeof useGetPaIndoMiscBillingSummaryQuery>;
export type GetPaIndoMiscBillingSummaryLazyQueryHookResult = ReturnType<typeof useGetPaIndoMiscBillingSummaryLazyQuery>;
export type GetPaIndoMiscBillingSummaryQueryResult = Apollo.QueryResult<GetPaIndoMiscBillingSummaryQuery, GetPaIndoMiscBillingSummaryQueryVariables>;
export const GetUnitAndContactListDocument = gql`
    query getUnitAndContactList($projectId: String!, $saleId: String, $search: String) {
  getUnitAndContactList(projectId: $projectId, saleId: $saleId, search: $search) {
    unitId
    saleId
    unitNo
    fullName
    clusterName
    salesRegistrationNo
  }
}
    `;

/**
 * __useGetUnitAndContactListQuery__
 *
 * To run a query within a React component, call `useGetUnitAndContactListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitAndContactListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitAndContactListQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      saleId: // value for 'saleId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetUnitAndContactListQuery(baseOptions: Apollo.QueryHookOptions<GetUnitAndContactListQuery, GetUnitAndContactListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitAndContactListQuery, GetUnitAndContactListQueryVariables>(GetUnitAndContactListDocument, options);
      }
export function useGetUnitAndContactListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitAndContactListQuery, GetUnitAndContactListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitAndContactListQuery, GetUnitAndContactListQueryVariables>(GetUnitAndContactListDocument, options);
        }
export type GetUnitAndContactListQueryHookResult = ReturnType<typeof useGetUnitAndContactListQuery>;
export type GetUnitAndContactListLazyQueryHookResult = ReturnType<typeof useGetUnitAndContactListLazyQuery>;
export type GetUnitAndContactListQueryResult = Apollo.QueryResult<GetUnitAndContactListQuery, GetUnitAndContactListQueryVariables>;
export const GetBillItemIntListByTypeDocument = gql`
    query getBillItemIntListByType($type: String!) {
  getBillItemIntListByType(type: $type) {
    id
    name
  }
}
    `;

/**
 * __useGetBillItemIntListByTypeQuery__
 *
 * To run a query within a React component, call `useGetBillItemIntListByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillItemIntListByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBillItemIntListByTypeQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetBillItemIntListByTypeQuery(baseOptions: Apollo.QueryHookOptions<GetBillItemIntListByTypeQuery, GetBillItemIntListByTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBillItemIntListByTypeQuery, GetBillItemIntListByTypeQueryVariables>(GetBillItemIntListByTypeDocument, options);
      }
export function useGetBillItemIntListByTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBillItemIntListByTypeQuery, GetBillItemIntListByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBillItemIntListByTypeQuery, GetBillItemIntListByTypeQueryVariables>(GetBillItemIntListByTypeDocument, options);
        }
export type GetBillItemIntListByTypeQueryHookResult = ReturnType<typeof useGetBillItemIntListByTypeQuery>;
export type GetBillItemIntListByTypeLazyQueryHookResult = ReturnType<typeof useGetBillItemIntListByTypeLazyQuery>;
export type GetBillItemIntListByTypeQueryResult = Apollo.QueryResult<GetBillItemIntListByTypeQuery, GetBillItemIntListByTypeQueryVariables>;
export const GetPaIndoDebitNoteSummaryDocument = gql`
    query getPAIndoDebitNoteSummary($projectId: String!, $status: String, $saleId: String) {
  getPAIndoDebitNoteSummary(projectId: $projectId, status: $status, saleId: $saleId) {
    id
    saleId
    documentDate
    documentAmount
    documentNo
    unitDetail
    contactDetail
    interestRate
    creditTerm
    billItemInt {
      id
      name
      billItemType
    }
    description
    dueDate
    taxData {
      taxSchemeName
      totalTaxRate
    }
    taxLedger {
      taxAmount
    }
    requestedBy
    submittedBy
    submittedDate
    requestUserData {
      ID
      name
      userName
    }
    submitUserData {
      ID
      name
      userName
    }
    approveUserData {
      ID
      name
      userName
    }
    billItemInt {
      id
      name
    }
    attachment {
      allowDelete
      fileName
      id
      isPrivate
      mediaType
      resourceUrl
    }
    taxLedger {
      taxAmount
    }
    unallocatedAmount
    unallocatedAmountSummary
    clusterName {
      name
    }
    salesRegNo {
      salesRegistrationNo
    }
  }
}
    `;

/**
 * __useGetPaIndoDebitNoteSummaryQuery__
 *
 * To run a query within a React component, call `useGetPaIndoDebitNoteSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaIndoDebitNoteSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaIndoDebitNoteSummaryQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      status: // value for 'status'
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetPaIndoDebitNoteSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetPaIndoDebitNoteSummaryQuery, GetPaIndoDebitNoteSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaIndoDebitNoteSummaryQuery, GetPaIndoDebitNoteSummaryQueryVariables>(GetPaIndoDebitNoteSummaryDocument, options);
      }
export function useGetPaIndoDebitNoteSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaIndoDebitNoteSummaryQuery, GetPaIndoDebitNoteSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaIndoDebitNoteSummaryQuery, GetPaIndoDebitNoteSummaryQueryVariables>(GetPaIndoDebitNoteSummaryDocument, options);
        }
export type GetPaIndoDebitNoteSummaryQueryHookResult = ReturnType<typeof useGetPaIndoDebitNoteSummaryQuery>;
export type GetPaIndoDebitNoteSummaryLazyQueryHookResult = ReturnType<typeof useGetPaIndoDebitNoteSummaryLazyQuery>;
export type GetPaIndoDebitNoteSummaryQueryResult = Apollo.QueryResult<GetPaIndoDebitNoteSummaryQuery, GetPaIndoDebitNoteSummaryQueryVariables>;
export const GetPaIndoCreditNoteSummaryDocument = gql`
    query getPAIndoCreditNoteSummary($projectId: String!, $status: String, $saleId: String) {
  getPAIndoCreditNoteSummary(projectId: $projectId, status: $status, saleId: $saleId) {
    id
    saleId
    documentDate
    documentAmount
    documentNo
    unitDetail
    contactDetail
    billItemInt {
      id
      name
      billItemType
    }
    description
    taxData {
      taxSchemeName
      totalTaxRate
    }
    taxLedger {
      taxAmount
    }
    requestedBy
    submittedBy
    submittedDate
    requestUserData {
      ID
      name
      userName
    }
    submitUserData {
      ID
      name
      userName
    }
    approveUserData {
      ID
      name
      userName
    }
    attachment {
      allowDelete
      fileName
      id
      isPrivate
      mediaType
      resourceUrl
    }
    taxLedger {
      taxAmount
    }
    unallocatedAmount
    unallocatedAmountSummary
    clusterName {
      name
    }
    salesRegNo {
      salesRegistrationNo
    }
    allocationData {
      allocateAmount
      allocationDate
      creditId
      debitId
      miscDescription
      debitNoteDescription
      installmentDescription
      documentNo
    }
  }
}
    `;

/**
 * __useGetPaIndoCreditNoteSummaryQuery__
 *
 * To run a query within a React component, call `useGetPaIndoCreditNoteSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaIndoCreditNoteSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaIndoCreditNoteSummaryQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      status: // value for 'status'
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetPaIndoCreditNoteSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetPaIndoCreditNoteSummaryQuery, GetPaIndoCreditNoteSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaIndoCreditNoteSummaryQuery, GetPaIndoCreditNoteSummaryQueryVariables>(GetPaIndoCreditNoteSummaryDocument, options);
      }
export function useGetPaIndoCreditNoteSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaIndoCreditNoteSummaryQuery, GetPaIndoCreditNoteSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaIndoCreditNoteSummaryQuery, GetPaIndoCreditNoteSummaryQueryVariables>(GetPaIndoCreditNoteSummaryDocument, options);
        }
export type GetPaIndoCreditNoteSummaryQueryHookResult = ReturnType<typeof useGetPaIndoCreditNoteSummaryQuery>;
export type GetPaIndoCreditNoteSummaryLazyQueryHookResult = ReturnType<typeof useGetPaIndoCreditNoteSummaryLazyQuery>;
export type GetPaIndoCreditNoteSummaryQueryResult = Apollo.QueryResult<GetPaIndoCreditNoteSummaryQuery, GetPaIndoCreditNoteSummaryQueryVariables>;
export const GetPaIndoRebateSummaryDocument = gql`
    query getPAIndoRebateSummary($projectId: String!, $status: String, $saleId: String) {
  getPAIndoRebateSummary(projectId: $projectId, status: $status, saleId: $saleId) {
    id
    saleId
    documentDate
    documentAmount
    documentNo
    unitDetail
    contactDetail
    billItemInt {
      id
      name
      billItemType
    }
    description
    taxData {
      taxSchemeName
      totalTaxRate
    }
    taxLedger {
      taxAmount
    }
    requestedBy
    submittedBy
    submittedDate
    requestUserData {
      ID
      name
      userName
    }
    submitUserData {
      ID
      name
      userName
    }
    approveUserData {
      ID
      name
      userName
    }
    unallocatedAmount
    unallocatedAmountSummary
    attachment {
      allowDelete
      fileName
      id
      isPrivate
      mediaType
      resourceUrl
    }
    clusterName {
      name
    }
    salesRegNo {
      salesRegistrationNo
    }
    allocationData {
      allocateAmount
      allocationDate
      creditId
      debitId
      miscDescription
      debitNoteDescription
      installmentDescription
      documentNo
    }
  }
}
    `;

/**
 * __useGetPaIndoRebateSummaryQuery__
 *
 * To run a query within a React component, call `useGetPaIndoRebateSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaIndoRebateSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaIndoRebateSummaryQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      status: // value for 'status'
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetPaIndoRebateSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetPaIndoRebateSummaryQuery, GetPaIndoRebateSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaIndoRebateSummaryQuery, GetPaIndoRebateSummaryQueryVariables>(GetPaIndoRebateSummaryDocument, options);
      }
export function useGetPaIndoRebateSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaIndoRebateSummaryQuery, GetPaIndoRebateSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaIndoRebateSummaryQuery, GetPaIndoRebateSummaryQueryVariables>(GetPaIndoRebateSummaryDocument, options);
        }
export type GetPaIndoRebateSummaryQueryHookResult = ReturnType<typeof useGetPaIndoRebateSummaryQuery>;
export type GetPaIndoRebateSummaryLazyQueryHookResult = ReturnType<typeof useGetPaIndoRebateSummaryLazyQuery>;
export type GetPaIndoRebateSummaryQueryResult = Apollo.QueryResult<GetPaIndoRebateSummaryQuery, GetPaIndoRebateSummaryQueryVariables>;
export const GetPaIndoPaymentSummaryDocument = gql`
    query getPAIndoPaymentSummary($projectId: String!, $status: String, $saleId: String) {
  getPAIndoPaymentSummary(projectId: $projectId, status: $status, saleId: $saleId) {
    id
    saleId
    documentDate
    documentAmount
    documentNo
    unitDetail
    contactDetail
    description
    paymentMethod
    creditCardType
    chequeDate
    chequeExpireDate
    documentRef
    receiptAmount
    submittedBy
    submittedDate
    allowReversal
    taxData {
      taxSchemeName
      totalTaxRate
    }
    taxLedger {
      taxAmount
    }
    unallocatedAmount
    unallocatedAmountSummary
    submitUserData {
      userName
      name
    }
    approveUserData {
      userName
      name
    }
    bankAccount {
      code
      accountNo
      bankProfile {
        name
      }
    }
    attachment {
      allowDelete
      fileName
      id
      isPrivate
      mediaType
      resourceUrl
    }
    attachment {
      allowDelete
      fileName
      id
      isPrivate
      mediaType
      resourceUrl
    }
    clusterName {
      name
    }
    salesRegNo {
      salesRegistrationNo
    }
    allocationData {
      allocationId
      allocateAmount
      allocationDate
      creditId
      debitId
      miscDescription
      debitNoteDescription
      installmentDescription
      packagesDescription
      carParkDescription
      lateInterestDescription
      documentNo
    }
  }
}
    `;

/**
 * __useGetPaIndoPaymentSummaryQuery__
 *
 * To run a query within a React component, call `useGetPaIndoPaymentSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaIndoPaymentSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaIndoPaymentSummaryQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      status: // value for 'status'
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetPaIndoPaymentSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetPaIndoPaymentSummaryQuery, GetPaIndoPaymentSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaIndoPaymentSummaryQuery, GetPaIndoPaymentSummaryQueryVariables>(GetPaIndoPaymentSummaryDocument, options);
      }
export function useGetPaIndoPaymentSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaIndoPaymentSummaryQuery, GetPaIndoPaymentSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaIndoPaymentSummaryQuery, GetPaIndoPaymentSummaryQueryVariables>(GetPaIndoPaymentSummaryDocument, options);
        }
export type GetPaIndoPaymentSummaryQueryHookResult = ReturnType<typeof useGetPaIndoPaymentSummaryQuery>;
export type GetPaIndoPaymentSummaryLazyQueryHookResult = ReturnType<typeof useGetPaIndoPaymentSummaryLazyQuery>;
export type GetPaIndoPaymentSummaryQueryResult = Apollo.QueryResult<GetPaIndoPaymentSummaryQuery, GetPaIndoPaymentSummaryQueryVariables>;
export const GetPurchaserDataDocument = gql`
    query getPurchaserData($projectId: String!, $saleId: String!, $tableRef: String!) {
  getPurchaserData(projectId: $projectId, saleId: $saleId, tableRef: $tableRef) {
    fullName
    unitNo
    totalDocAmt
    totalOutstanding
    clusterName
    salesRegistrationNo
    salesRegistrationDate
  }
}
    `;

/**
 * __useGetPurchaserDataQuery__
 *
 * To run a query within a React component, call `useGetPurchaserDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPurchaserDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPurchaserDataQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      saleId: // value for 'saleId'
 *      tableRef: // value for 'tableRef'
 *   },
 * });
 */
export function useGetPurchaserDataQuery(baseOptions: Apollo.QueryHookOptions<GetPurchaserDataQuery, GetPurchaserDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPurchaserDataQuery, GetPurchaserDataQueryVariables>(GetPurchaserDataDocument, options);
      }
export function useGetPurchaserDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPurchaserDataQuery, GetPurchaserDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPurchaserDataQuery, GetPurchaserDataQueryVariables>(GetPurchaserDataDocument, options);
        }
export type GetPurchaserDataQueryHookResult = ReturnType<typeof useGetPurchaserDataQuery>;
export type GetPurchaserDataLazyQueryHookResult = ReturnType<typeof useGetPurchaserDataLazyQuery>;
export type GetPurchaserDataQueryResult = Apollo.QueryResult<GetPurchaserDataQuery, GetPurchaserDataQueryVariables>;
export const GetCreditCardTypeDescDocument = gql`
    query getCreditCardTypeDesc {
  getCreditCardTypeDesc
}
    `;

/**
 * __useGetCreditCardTypeDescQuery__
 *
 * To run a query within a React component, call `useGetCreditCardTypeDescQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditCardTypeDescQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditCardTypeDescQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCreditCardTypeDescQuery(baseOptions?: Apollo.QueryHookOptions<GetCreditCardTypeDescQuery, GetCreditCardTypeDescQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditCardTypeDescQuery, GetCreditCardTypeDescQueryVariables>(GetCreditCardTypeDescDocument, options);
      }
export function useGetCreditCardTypeDescLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditCardTypeDescQuery, GetCreditCardTypeDescQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditCardTypeDescQuery, GetCreditCardTypeDescQueryVariables>(GetCreditCardTypeDescDocument, options);
        }
export type GetCreditCardTypeDescQueryHookResult = ReturnType<typeof useGetCreditCardTypeDescQuery>;
export type GetCreditCardTypeDescLazyQueryHookResult = ReturnType<typeof useGetCreditCardTypeDescLazyQuery>;
export type GetCreditCardTypeDescQueryResult = Apollo.QueryResult<GetCreditCardTypeDescQuery, GetCreditCardTypeDescQueryVariables>;
export const GetBillTypeDescDocument = gql`
    query getBillTypeDesc {
  getBillTypeDesc
}
    `;

/**
 * __useGetBillTypeDescQuery__
 *
 * To run a query within a React component, call `useGetBillTypeDescQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillTypeDescQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBillTypeDescQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBillTypeDescQuery(baseOptions?: Apollo.QueryHookOptions<GetBillTypeDescQuery, GetBillTypeDescQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBillTypeDescQuery, GetBillTypeDescQueryVariables>(GetBillTypeDescDocument, options);
      }
export function useGetBillTypeDescLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBillTypeDescQuery, GetBillTypeDescQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBillTypeDescQuery, GetBillTypeDescQueryVariables>(GetBillTypeDescDocument, options);
        }
export type GetBillTypeDescQueryHookResult = ReturnType<typeof useGetBillTypeDescQuery>;
export type GetBillTypeDescLazyQueryHookResult = ReturnType<typeof useGetBillTypeDescLazyQuery>;
export type GetBillTypeDescQueryResult = Apollo.QueryResult<GetBillTypeDescQuery, GetBillTypeDescQueryVariables>;
export const GetPaIndoDepositSummaryDocument = gql`
    query getPAIndoDepositSummary($projectId: String!, $status: String, $saleId: String) {
  getPAIndoDepositSummary(projectId: $projectId, status: $status, saleId: $saleId) {
    id
    saleId
    unitDetail
    contactDetail
    billItemInt {
      billItemType
      name
    }
    description
    submittedBy
    submittedDate
    taxLedger {
      taxAmount
    }
    submitUserData {
      name
      userName
    }
    approveUserData {
      name
      userName
    }
    outstanding
    documentNo
    paymentMethod
    documentAmount
    documentDate
    bankAccountId
    bankAccount {
      code
      accountNo
      bankProfile {
        name
      }
    }
    chequeDate
    chequeExpireDate
    documentRef
    attachment {
      allowDelete
      fileName
      id
      isPrivate
      mediaType
      resourceUrl
    }
    creditCardType
    convertedToPayment
    clusterName {
      name
    }
    salesRegNo {
      salesRegistrationNo
    }
  }
}
    `;

/**
 * __useGetPaIndoDepositSummaryQuery__
 *
 * To run a query within a React component, call `useGetPaIndoDepositSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaIndoDepositSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaIndoDepositSummaryQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      status: // value for 'status'
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetPaIndoDepositSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetPaIndoDepositSummaryQuery, GetPaIndoDepositSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaIndoDepositSummaryQuery, GetPaIndoDepositSummaryQueryVariables>(GetPaIndoDepositSummaryDocument, options);
      }
export function useGetPaIndoDepositSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaIndoDepositSummaryQuery, GetPaIndoDepositSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaIndoDepositSummaryQuery, GetPaIndoDepositSummaryQueryVariables>(GetPaIndoDepositSummaryDocument, options);
        }
export type GetPaIndoDepositSummaryQueryHookResult = ReturnType<typeof useGetPaIndoDepositSummaryQuery>;
export type GetPaIndoDepositSummaryLazyQueryHookResult = ReturnType<typeof useGetPaIndoDepositSummaryLazyQuery>;
export type GetPaIndoDepositSummaryQueryResult = Apollo.QueryResult<GetPaIndoDepositSummaryQuery, GetPaIndoDepositSummaryQueryVariables>;
export const GetPaIndoRefundSummaryDocument = gql`
    query getPAIndoRefundSummary($projectId: String!, $status: String, $saleId: String) {
  getPAIndoRefundSummary(projectId: $projectId, status: $status, saleId: $saleId) {
    id
    saleId
    documentDate
    documentAmount
    documentNo
    unitDetail
    contactDetail
    description
    refundMethod
    creditCardType
    chequeDate
    chequeExpireDate
    bankAccountId
    documentRef
    submittedBy
    submittedDate
    taxData {
      taxSchemeName
      totalTaxRate
    }
    taxLedger {
      taxAmount
    }
    unallocatedAmount
    submitUserData {
      userName
      name
    }
    approveUserData {
      userName
      name
    }
    attachment {
      allowDelete
      fileName
      id
      isPrivate
      mediaType
      resourceUrl
    }
    bankAccount {
      code
      accountNo
      bankProfile {
        name
      }
    }
    clusterName {
      name
    }
    salesRegNo {
      salesRegistrationNo
    }
    allocationData {
      allocateAmount
      allocationDate
      creditId
      debitId
      miscDescription
      debitNoteDescription
      installmentDescription
      documentNo
      receiptDescription
      rebateDescription
      allocationDate
    }
  }
}
    `;

/**
 * __useGetPaIndoRefundSummaryQuery__
 *
 * To run a query within a React component, call `useGetPaIndoRefundSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaIndoRefundSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaIndoRefundSummaryQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      status: // value for 'status'
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetPaIndoRefundSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetPaIndoRefundSummaryQuery, GetPaIndoRefundSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaIndoRefundSummaryQuery, GetPaIndoRefundSummaryQueryVariables>(GetPaIndoRefundSummaryDocument, options);
      }
export function useGetPaIndoRefundSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaIndoRefundSummaryQuery, GetPaIndoRefundSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaIndoRefundSummaryQuery, GetPaIndoRefundSummaryQueryVariables>(GetPaIndoRefundSummaryDocument, options);
        }
export type GetPaIndoRefundSummaryQueryHookResult = ReturnType<typeof useGetPaIndoRefundSummaryQuery>;
export type GetPaIndoRefundSummaryLazyQueryHookResult = ReturnType<typeof useGetPaIndoRefundSummaryLazyQuery>;
export type GetPaIndoRefundSummaryQueryResult = Apollo.QueryResult<GetPaIndoRefundSummaryQuery, GetPaIndoRefundSummaryQueryVariables>;
export const PaIndoPurchaserLedgerSummaryDocument = gql`
    query PAIndoPurchaserLedgerSummary($saleId: String!) {
  getPAsummary(saleId: $saleId) {
    progressBillingSummary {
      totalCharges
      totalUnallocated
    }
    purchaserDetail {
      saleId
      purchaserName
      unitNo
      phoneNo
      icNo
      contactId
    }
    creditNoteSummary {
      totalCharges
      totalUnallocated
      totalDraft
      totalSubmitted
      totalApproved
    }
    debitNoteSummary {
      totalCharges
      totalUnallocated
      totalDraft
      totalSubmitted
      totalApproved
    }
    rebateSummary {
      totalCharges
      totalUnallocated
      totalDraft
      totalSubmitted
      totalApproved
    }
    contraSummary {
      totalCharges
      totalUnallocated
      totalDraft
      totalSubmitted
      totalApproved
    }
    miscBillingSummary {
      totalCharges
      totalUnallocated
      totalDraft
      totalSubmitted
      totalApproved
    }
    lateInterestSummary {
      totalCharges
      totalUnallocated
      lastCalculatedDate
    }
    refundSummary {
      totalCharges
      totalUnallocated
      totalDraft
      totalSubmitted
      totalApproved
    }
    collectionSummary {
      totalCharges
      totalUnallocated
      totalDraft
      totalSubmitted
      totalApproved
    }
    contactData {
      contactId
      icNo
      phoneNo
      purchaserName
      email
    }
    unitData {
      contactId
      saleId
      unitId
      unitNo
      unitStatus
      salesConvertedStatus
      clusterName
    }
    collectionActivity {
      activityDate
      activityRemark
    }
    paymentReminder {
      reminder1
      reminder2
      reminder3
    }
    depositSummary {
      totalCharges
      totalUnallocated
      totalDraft
      totalSubmitted
      totalApproved
    }
    purchaserInstallmentSummary {
      totalCharges
      totalUnallocated
      totalInstallmentSaleAmount
    }
    bankLoanSummary {
      loanAppliedAmount
      loanApprovedAmount
    }
    overdueAging {
      period1
      period2
      period3
      period4
      period5
      period6
    }
    dueDateRange {
      range1 {
        totalDueDateRange
        dueDateRangeListing {
          purchaserInstallmentDetail {
            id
            documentDate
            description
            documentAmount
            totalAlocated
            outstanding
          }
          miscBillingDetail {
            id
            documentDate
            description
            documentAmount
            totalAlocated
            outstanding
          }
          debitNoteDetail {
            id
            documentDate
            description
            documentAmount
            totalAlocated
            outstanding
          }
          carparkInstallmentDetail {
            id
            documentDate
            description
            documentAmount
            totalAlocated
            outstanding
          }
          addPackageInstallmentDetail {
            id
            documentDate
            description
            documentAmount
            totalAlocated
            outstanding
          }
          lateInterestDetail {
            id
            documentDate
            description
            documentAmount
            totalAlocated
            outstanding
          }
        }
        dueDateRangeHeader {
          purchaserInstallmentDetail {
            title
            totalDocumentAmount
            totalOutstanding
          }
          miscBillingDetail {
            title
            totalDocumentAmount
            totalOutstanding
          }
          debitNoteDetail {
            title
            totalDocumentAmount
            totalOutstanding
          }
          carparkInstallmentDetail {
            title
            totalDocumentAmount
            totalOutstanding
          }
          addPackageInstallmentDetail {
            title
            totalDocumentAmount
            totalOutstanding
          }
          lateInterestDetail {
            title
            totalDocumentAmount
            totalOutstanding
          }
        }
      }
      range2 {
        totalDueDateRange
        dueDateRangeListing {
          purchaserInstallmentDetail {
            id
            documentDate
            description
            documentAmount
            totalAlocated
            outstanding
          }
          miscBillingDetail {
            id
            documentDate
            description
            documentAmount
            totalAlocated
            outstanding
          }
          debitNoteDetail {
            id
            documentDate
            description
            documentAmount
            totalAlocated
            outstanding
          }
          carparkInstallmentDetail {
            id
            documentDate
            description
            documentAmount
            totalAlocated
            outstanding
          }
          addPackageInstallmentDetail {
            id
            documentDate
            description
            documentAmount
            totalAlocated
            outstanding
          }
          lateInterestDetail {
            id
            documentDate
            description
            documentAmount
            totalAlocated
            outstanding
          }
        }
        dueDateRangeHeader {
          purchaserInstallmentDetail {
            title
            totalDocumentAmount
            totalOutstanding
          }
          miscBillingDetail {
            title
            totalDocumentAmount
            totalOutstanding
          }
          debitNoteDetail {
            title
            totalDocumentAmount
            totalOutstanding
          }
          carparkInstallmentDetail {
            title
            totalDocumentAmount
            totalOutstanding
          }
          addPackageInstallmentDetail {
            title
            totalDocumentAmount
            totalOutstanding
          }
          lateInterestDetail {
            title
            totalDocumentAmount
            totalOutstanding
          }
        }
      }
      range3 {
        totalDueDateRange
        dueDateRangeListing {
          purchaserInstallmentDetail {
            id
            documentDate
            description
            documentAmount
            totalAlocated
            outstanding
          }
          miscBillingDetail {
            id
            documentDate
            description
            documentAmount
            totalAlocated
            outstanding
          }
          debitNoteDetail {
            id
            documentDate
            description
            documentAmount
            totalAlocated
            outstanding
          }
          carparkInstallmentDetail {
            id
            documentDate
            description
            documentAmount
            totalAlocated
            outstanding
          }
          addPackageInstallmentDetail {
            id
            documentDate
            description
            documentAmount
            totalAlocated
            outstanding
          }
          lateInterestDetail {
            id
            documentDate
            description
            documentAmount
            totalAlocated
            outstanding
          }
        }
        dueDateRangeHeader {
          purchaserInstallmentDetail {
            title
            totalDocumentAmount
            totalOutstanding
          }
          miscBillingDetail {
            title
            totalDocumentAmount
            totalOutstanding
          }
          debitNoteDetail {
            title
            totalDocumentAmount
            totalOutstanding
          }
          carparkInstallmentDetail {
            title
            totalDocumentAmount
            totalOutstanding
          }
          addPackageInstallmentDetail {
            title
            totalDocumentAmount
            totalOutstanding
          }
          lateInterestDetail {
            title
            totalDocumentAmount
            totalOutstanding
          }
        }
      }
      range4 {
        totalDueDateRange
        dueDateRangeListing {
          purchaserInstallmentDetail {
            id
            documentDate
            description
            documentAmount
            totalAlocated
            outstanding
          }
          miscBillingDetail {
            id
            documentDate
            description
            documentAmount
            totalAlocated
            outstanding
          }
          debitNoteDetail {
            id
            documentDate
            description
            documentAmount
            totalAlocated
            outstanding
          }
          carparkInstallmentDetail {
            id
            documentDate
            description
            documentAmount
            totalAlocated
            outstanding
          }
          addPackageInstallmentDetail {
            id
            documentDate
            description
            documentAmount
            totalAlocated
            outstanding
          }
          lateInterestDetail {
            id
            documentDate
            description
            documentAmount
            totalAlocated
            outstanding
          }
        }
        dueDateRangeHeader {
          purchaserInstallmentDetail {
            title
            totalDocumentAmount
            totalOutstanding
          }
          miscBillingDetail {
            title
            totalDocumentAmount
            totalOutstanding
          }
          debitNoteDetail {
            title
            totalDocumentAmount
            totalOutstanding
          }
          carparkInstallmentDetail {
            title
            totalDocumentAmount
            totalOutstanding
          }
          addPackageInstallmentDetail {
            title
            totalDocumentAmount
            totalOutstanding
          }
          lateInterestDetail {
            title
            totalDocumentAmount
            totalOutstanding
          }
        }
      }
      range5 {
        totalDueDateRange
        dueDateRangeListing {
          purchaserInstallmentDetail {
            id
            documentDate
            description
            documentAmount
            totalAlocated
            outstanding
          }
          miscBillingDetail {
            id
            documentDate
            description
            documentAmount
            totalAlocated
            outstanding
          }
          debitNoteDetail {
            id
            documentDate
            description
            documentAmount
            totalAlocated
            outstanding
          }
          carparkInstallmentDetail {
            id
            documentDate
            description
            documentAmount
            totalAlocated
            outstanding
          }
          addPackageInstallmentDetail {
            id
            documentDate
            description
            documentAmount
            totalAlocated
            outstanding
          }
          lateInterestDetail {
            id
            documentDate
            description
            documentAmount
            totalAlocated
            outstanding
          }
        }
        dueDateRangeHeader {
          purchaserInstallmentDetail {
            title
            totalDocumentAmount
            totalOutstanding
          }
          miscBillingDetail {
            title
            totalDocumentAmount
            totalOutstanding
          }
          debitNoteDetail {
            title
            totalDocumentAmount
            totalOutstanding
          }
          carparkInstallmentDetail {
            title
            totalDocumentAmount
            totalOutstanding
          }
          addPackageInstallmentDetail {
            title
            totalDocumentAmount
            totalOutstanding
          }
          lateInterestDetail {
            title
            totalDocumentAmount
            totalOutstanding
          }
        }
      }
      range6 {
        totalDueDateRange
        dueDateRangeListing {
          purchaserInstallmentDetail {
            id
            documentDate
            description
            documentAmount
            totalAlocated
            outstanding
          }
          miscBillingDetail {
            id
            documentDate
            description
            documentAmount
            totalAlocated
            outstanding
          }
          debitNoteDetail {
            id
            documentDate
            description
            documentAmount
            totalAlocated
            outstanding
          }
          carparkInstallmentDetail {
            id
            documentDate
            description
            documentAmount
            totalAlocated
            outstanding
          }
          addPackageInstallmentDetail {
            id
            documentDate
            description
            documentAmount
            totalAlocated
            outstanding
          }
          lateInterestDetail {
            id
            documentDate
            description
            documentAmount
            totalAlocated
            outstanding
          }
        }
        dueDateRangeHeader {
          purchaserInstallmentDetail {
            title
            totalDocumentAmount
            totalOutstanding
          }
          miscBillingDetail {
            title
            totalDocumentAmount
            totalOutstanding
          }
          debitNoteDetail {
            title
            totalDocumentAmount
            totalOutstanding
          }
          carparkInstallmentDetail {
            title
            totalDocumentAmount
            totalOutstanding
          }
          addPackageInstallmentDetail {
            title
            totalDocumentAmount
            totalOutstanding
          }
          lateInterestDetail {
            title
            totalDocumentAmount
            totalOutstanding
          }
        }
      }
      range7 {
        totalDueDateRange
        dueDateRangeListing {
          purchaserInstallmentDetail {
            id
            documentDate
            description
            documentAmount
            totalAlocated
            outstanding
          }
          miscBillingDetail {
            id
            documentDate
            description
            documentAmount
            totalAlocated
            outstanding
          }
          debitNoteDetail {
            id
            documentDate
            description
            documentAmount
            totalAlocated
            outstanding
          }
          carparkInstallmentDetail {
            id
            documentDate
            description
            documentAmount
            totalAlocated
            outstanding
          }
          addPackageInstallmentDetail {
            id
            documentDate
            description
            documentAmount
            totalAlocated
            outstanding
          }
          lateInterestDetail {
            id
            documentDate
            description
            documentAmount
            totalAlocated
            outstanding
          }
        }
        dueDateRangeHeader {
          purchaserInstallmentDetail {
            title
            totalDocumentAmount
            totalOutstanding
          }
          miscBillingDetail {
            title
            totalDocumentAmount
            totalOutstanding
          }
          debitNoteDetail {
            title
            totalDocumentAmount
            totalOutstanding
          }
          carparkInstallmentDetail {
            title
            totalDocumentAmount
            totalOutstanding
          }
          addPackageInstallmentDetail {
            title
            totalDocumentAmount
            totalOutstanding
          }
          lateInterestDetail {
            title
            totalDocumentAmount
            totalOutstanding
          }
        }
      }
      unallocated {
        totalDueDateRange
        dueDateRangeListing {
          creditNoteDetail {
            id
            documentDate
            description
            documentAmount
            totalAlocated
            outstanding
          }
          rebateDetail {
            id
            documentDate
            description
            documentAmount
            totalAlocated
            outstanding
          }
          paymentDetail {
            id
            documentDate
            description
            documentAmount
            totalAlocated
            outstanding
          }
          contraDetail {
            id
            documentDate
            description
            documentAmount
            totalAlocated
            outstanding
          }
        }
        dueDateRangeHeader {
          creditNoteDetail {
            title
            totalDocumentAmount
            totalOutstanding
          }
          rebateDetail {
            title
            totalDocumentAmount
            totalOutstanding
          }
          paymentDetail {
            title
            totalDocumentAmount
            totalOutstanding
          }
          contraDetail {
            title
            totalDocumentAmount
            totalOutstanding
          }
        }
      }
    }
    carParkSummary {
      totalOutstandingAmount
      totalAllocateAmount
      itemCount
      totalSellingPrice
    }
    totalUnallocated
    totalGrandOutstading
    additionalPackageSummary {
      totalOutstandingAmount
      totalAllocateAmount
      itemCount
      totalSellingPrice
    }
  }
}
    `;

/**
 * __usePaIndoPurchaserLedgerSummaryQuery__
 *
 * To run a query within a React component, call `usePaIndoPurchaserLedgerSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaIndoPurchaserLedgerSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaIndoPurchaserLedgerSummaryQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function usePaIndoPurchaserLedgerSummaryQuery(baseOptions: Apollo.QueryHookOptions<PaIndoPurchaserLedgerSummaryQuery, PaIndoPurchaserLedgerSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaIndoPurchaserLedgerSummaryQuery, PaIndoPurchaserLedgerSummaryQueryVariables>(PaIndoPurchaserLedgerSummaryDocument, options);
      }
export function usePaIndoPurchaserLedgerSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaIndoPurchaserLedgerSummaryQuery, PaIndoPurchaserLedgerSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaIndoPurchaserLedgerSummaryQuery, PaIndoPurchaserLedgerSummaryQueryVariables>(PaIndoPurchaserLedgerSummaryDocument, options);
        }
export type PaIndoPurchaserLedgerSummaryQueryHookResult = ReturnType<typeof usePaIndoPurchaserLedgerSummaryQuery>;
export type PaIndoPurchaserLedgerSummaryLazyQueryHookResult = ReturnType<typeof usePaIndoPurchaserLedgerSummaryLazyQuery>;
export type PaIndoPurchaserLedgerSummaryQueryResult = Apollo.QueryResult<PaIndoPurchaserLedgerSummaryQuery, PaIndoPurchaserLedgerSummaryQueryVariables>;
export const GetIndoContactListDocument = gql`
    query getIndoContactList($unitId: String) {
  getContactList(unitId: $unitId) {
    contactId
    icNo
    phoneNo
    purchaserName
    email
  }
}
    `;

/**
 * __useGetIndoContactListQuery__
 *
 * To run a query within a React component, call `useGetIndoContactListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIndoContactListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIndoContactListQuery({
 *   variables: {
 *      unitId: // value for 'unitId'
 *   },
 * });
 */
export function useGetIndoContactListQuery(baseOptions?: Apollo.QueryHookOptions<GetIndoContactListQuery, GetIndoContactListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIndoContactListQuery, GetIndoContactListQueryVariables>(GetIndoContactListDocument, options);
      }
export function useGetIndoContactListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIndoContactListQuery, GetIndoContactListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIndoContactListQuery, GetIndoContactListQueryVariables>(GetIndoContactListDocument, options);
        }
export type GetIndoContactListQueryHookResult = ReturnType<typeof useGetIndoContactListQuery>;
export type GetIndoContactListLazyQueryHookResult = ReturnType<typeof useGetIndoContactListLazyQuery>;
export type GetIndoContactListQueryResult = Apollo.QueryResult<GetIndoContactListQuery, GetIndoContactListQueryVariables>;
export const GetAllBillingIndoBySaleIdDocument = gql`
    query getAllBillingIndoBySaleId($billItemId: String, $creditId: String, $mainTable: String!, $saleId: String!, $projectId: String, $tableFilter: String, $debitId: String, $isApproved: Boolean, $tabType: String) {
  getAllBillingBySaleId(billItemId: $billItemId, creditId: $creditId, mainTable: $mainTable, saleId: $saleId, projectId: $projectId, tableFilter: $tableFilter, debitId: $debitId, isApproved: $isApproved, tabType: $tabType) {
    id
    table
    documentNo
    documentDate
    documentAmount
    description
    outstanding
    currentAllocate
    totalAllocateAmount
    enabledAllocate
    financialBillingId
    billItemName
    reverseDate
  }
}
    `;

/**
 * __useGetAllBillingIndoBySaleIdQuery__
 *
 * To run a query within a React component, call `useGetAllBillingIndoBySaleIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllBillingIndoBySaleIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllBillingIndoBySaleIdQuery({
 *   variables: {
 *      billItemId: // value for 'billItemId'
 *      creditId: // value for 'creditId'
 *      mainTable: // value for 'mainTable'
 *      saleId: // value for 'saleId'
 *      projectId: // value for 'projectId'
 *      tableFilter: // value for 'tableFilter'
 *      debitId: // value for 'debitId'
 *      isApproved: // value for 'isApproved'
 *      tabType: // value for 'tabType'
 *   },
 * });
 */
export function useGetAllBillingIndoBySaleIdQuery(baseOptions: Apollo.QueryHookOptions<GetAllBillingIndoBySaleIdQuery, GetAllBillingIndoBySaleIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllBillingIndoBySaleIdQuery, GetAllBillingIndoBySaleIdQueryVariables>(GetAllBillingIndoBySaleIdDocument, options);
      }
export function useGetAllBillingIndoBySaleIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllBillingIndoBySaleIdQuery, GetAllBillingIndoBySaleIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllBillingIndoBySaleIdQuery, GetAllBillingIndoBySaleIdQueryVariables>(GetAllBillingIndoBySaleIdDocument, options);
        }
export type GetAllBillingIndoBySaleIdQueryHookResult = ReturnType<typeof useGetAllBillingIndoBySaleIdQuery>;
export type GetAllBillingIndoBySaleIdLazyQueryHookResult = ReturnType<typeof useGetAllBillingIndoBySaleIdLazyQuery>;
export type GetAllBillingIndoBySaleIdQueryResult = Apollo.QueryResult<GetAllBillingIndoBySaleIdQuery, GetAllBillingIndoBySaleIdQueryVariables>;
export const GetAllTypeBillingBySaleIdDocument = gql`
    query getAllTypeBillingBySaleId($billItemId: String, $creditId: String, $mainTable: String!, $saleId: String!, $projectId: String, $tableFilter: String, $debitId: String, $isApproved: Boolean, $tableStatus: String) {
  getAllTypeBillingBySaleId(billItemId: $billItemId, creditId: $creditId, mainTable: $mainTable, saleId: $saleId, projectId: $projectId, tableFilter: $tableFilter, debitId: $debitId, isApproved: $isApproved, tableStatus: $tableStatus) {
    id
    table
    name
    numRow
    documentNo
    documentDate
    documentAmount
    description
    outstanding
    currentAllocate
    totalAllocateAmount
    enabledAllocate
    financialBillingId
    billItemName
    reverseDate
    amount
    currentOutstanding
  }
}
    `;

/**
 * __useGetAllTypeBillingBySaleIdQuery__
 *
 * To run a query within a React component, call `useGetAllTypeBillingBySaleIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTypeBillingBySaleIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllTypeBillingBySaleIdQuery({
 *   variables: {
 *      billItemId: // value for 'billItemId'
 *      creditId: // value for 'creditId'
 *      mainTable: // value for 'mainTable'
 *      saleId: // value for 'saleId'
 *      projectId: // value for 'projectId'
 *      tableFilter: // value for 'tableFilter'
 *      debitId: // value for 'debitId'
 *      isApproved: // value for 'isApproved'
 *      tableStatus: // value for 'tableStatus'
 *   },
 * });
 */
export function useGetAllTypeBillingBySaleIdQuery(baseOptions: Apollo.QueryHookOptions<GetAllTypeBillingBySaleIdQuery, GetAllTypeBillingBySaleIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllTypeBillingBySaleIdQuery, GetAllTypeBillingBySaleIdQueryVariables>(GetAllTypeBillingBySaleIdDocument, options);
      }
export function useGetAllTypeBillingBySaleIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllTypeBillingBySaleIdQuery, GetAllTypeBillingBySaleIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllTypeBillingBySaleIdQuery, GetAllTypeBillingBySaleIdQueryVariables>(GetAllTypeBillingBySaleIdDocument, options);
        }
export type GetAllTypeBillingBySaleIdQueryHookResult = ReturnType<typeof useGetAllTypeBillingBySaleIdQuery>;
export type GetAllTypeBillingBySaleIdLazyQueryHookResult = ReturnType<typeof useGetAllTypeBillingBySaleIdLazyQuery>;
export type GetAllTypeBillingBySaleIdQueryResult = Apollo.QueryResult<GetAllTypeBillingBySaleIdQuery, GetAllTypeBillingBySaleIdQueryVariables>;
export const GetPaIndoPaymentSummaryListWPaginationDocument = gql`
    query getPAIndoPaymentSummaryListWPagination($projectId: String!, $status: String, $saleId: String, $pgnInput: PaginationInput!) {
  getPAIndoPaymentSummaryListWPagination(projectId: $projectId, status: $status, saleId: $saleId, pgnInput: $pgnInput) {
    data {
      id
      saleId
      documentDate
      documentAmount
      documentNo
      description
      paymentMethod
      creditCardType
      chequeDate
      chequeExpireDate
      documentRef
      receiptAmount
      submittedBy
      submittedDate
      allowReversal
      taxData {
        taxSchemeName
        totalTaxRate
      }
      taxLedger {
        taxAmount
      }
      unallocatedAmount
      unallocatedAmountSummary
      submitUserData {
        userName
        name
      }
      approveUserData {
        userName
        name
      }
      bankAccount {
        code
        accountNo
        bankProfile {
          name
        }
      }
      attachment {
        allowDelete
        fileName
        id
        isPrivate
        mediaType
        resourceUrl
      }
      clusterName {
        name
      }
      salesRegNo {
        salesRegistrationNo
      }
      allocationData {
        allocationId
        allocateAmount
        allocationDate
        creditId
        debitId
        miscDescription
        debitNoteDescription
        installmentDescription
        packagesDescription
        carParkDescription
        lateInterestDescription
        documentNo
      }
      sales {
        unit {
          unitNo
        }
        contact {
          fullName
        }
      }
    }
    totalDataLength
    isHasMore
  }
}
    `;

/**
 * __useGetPaIndoPaymentSummaryListWPaginationQuery__
 *
 * To run a query within a React component, call `useGetPaIndoPaymentSummaryListWPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaIndoPaymentSummaryListWPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaIndoPaymentSummaryListWPaginationQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      status: // value for 'status'
 *      saleId: // value for 'saleId'
 *      pgnInput: // value for 'pgnInput'
 *   },
 * });
 */
export function useGetPaIndoPaymentSummaryListWPaginationQuery(baseOptions: Apollo.QueryHookOptions<GetPaIndoPaymentSummaryListWPaginationQuery, GetPaIndoPaymentSummaryListWPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaIndoPaymentSummaryListWPaginationQuery, GetPaIndoPaymentSummaryListWPaginationQueryVariables>(GetPaIndoPaymentSummaryListWPaginationDocument, options);
      }
export function useGetPaIndoPaymentSummaryListWPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaIndoPaymentSummaryListWPaginationQuery, GetPaIndoPaymentSummaryListWPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaIndoPaymentSummaryListWPaginationQuery, GetPaIndoPaymentSummaryListWPaginationQueryVariables>(GetPaIndoPaymentSummaryListWPaginationDocument, options);
        }
export type GetPaIndoPaymentSummaryListWPaginationQueryHookResult = ReturnType<typeof useGetPaIndoPaymentSummaryListWPaginationQuery>;
export type GetPaIndoPaymentSummaryListWPaginationLazyQueryHookResult = ReturnType<typeof useGetPaIndoPaymentSummaryListWPaginationLazyQuery>;
export type GetPaIndoPaymentSummaryListWPaginationQueryResult = Apollo.QueryResult<GetPaIndoPaymentSummaryListWPaginationQuery, GetPaIndoPaymentSummaryListWPaginationQueryVariables>;
export const GetPackageItemListingDocument = gql`
    query getPackageItemListing($saleId: String!) {
  getPackageItemListing(saleId: $saleId) {
    id
    sellingPrice
    itemName
    numRow
    totalOutstanding
    totalAllocated
    totalDocumentAmount
    packageId
  }
}
    `;

/**
 * __useGetPackageItemListingQuery__
 *
 * To run a query within a React component, call `useGetPackageItemListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPackageItemListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPackageItemListingQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetPackageItemListingQuery(baseOptions: Apollo.QueryHookOptions<GetPackageItemListingQuery, GetPackageItemListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPackageItemListingQuery, GetPackageItemListingQueryVariables>(GetPackageItemListingDocument, options);
      }
export function useGetPackageItemListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPackageItemListingQuery, GetPackageItemListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPackageItemListingQuery, GetPackageItemListingQueryVariables>(GetPackageItemListingDocument, options);
        }
export type GetPackageItemListingQueryHookResult = ReturnType<typeof useGetPackageItemListingQuery>;
export type GetPackageItemListingLazyQueryHookResult = ReturnType<typeof useGetPackageItemListingLazyQuery>;
export type GetPackageItemListingQueryResult = Apollo.QueryResult<GetPackageItemListingQuery, GetPackageItemListingQueryVariables>;
export const GetPaIndoAdditionalDetailDocument = gql`
    query getPaIndoAdditionalDetail($saleId: String!, $id: String!) {
  getPaIndoAdditionalDetail(saleId: $saleId, id: $id) {
    id
    document_amount
    document_no
    outstanding
    total_allocated
    document_date
    creditTerm
    billType
  }
}
    `;

/**
 * __useGetPaIndoAdditionalDetailQuery__
 *
 * To run a query within a React component, call `useGetPaIndoAdditionalDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaIndoAdditionalDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaIndoAdditionalDetailQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPaIndoAdditionalDetailQuery(baseOptions: Apollo.QueryHookOptions<GetPaIndoAdditionalDetailQuery, GetPaIndoAdditionalDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaIndoAdditionalDetailQuery, GetPaIndoAdditionalDetailQueryVariables>(GetPaIndoAdditionalDetailDocument, options);
      }
export function useGetPaIndoAdditionalDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaIndoAdditionalDetailQuery, GetPaIndoAdditionalDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaIndoAdditionalDetailQuery, GetPaIndoAdditionalDetailQueryVariables>(GetPaIndoAdditionalDetailDocument, options);
        }
export type GetPaIndoAdditionalDetailQueryHookResult = ReturnType<typeof useGetPaIndoAdditionalDetailQuery>;
export type GetPaIndoAdditionalDetailLazyQueryHookResult = ReturnType<typeof useGetPaIndoAdditionalDetailLazyQuery>;
export type GetPaIndoAdditionalDetailQueryResult = Apollo.QueryResult<GetPaIndoAdditionalDetailQuery, GetPaIndoAdditionalDetailQueryVariables>;
export const GetPaIndoAddtionalPackagesDocument = gql`
    query getPAIndoAddtionalPackages {
  getPAIndoAddtionalPackages {
    sellingPrice
    unitName
    totalDocumentAmount
    totalOutstanding
    totalAllocated
    fullName
    saleId
    totalSalePackage
  }
}
    `;

/**
 * __useGetPaIndoAddtionalPackagesQuery__
 *
 * To run a query within a React component, call `useGetPaIndoAddtionalPackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaIndoAddtionalPackagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaIndoAddtionalPackagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPaIndoAddtionalPackagesQuery(baseOptions?: Apollo.QueryHookOptions<GetPaIndoAddtionalPackagesQuery, GetPaIndoAddtionalPackagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaIndoAddtionalPackagesQuery, GetPaIndoAddtionalPackagesQueryVariables>(GetPaIndoAddtionalPackagesDocument, options);
      }
export function useGetPaIndoAddtionalPackagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaIndoAddtionalPackagesQuery, GetPaIndoAddtionalPackagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaIndoAddtionalPackagesQuery, GetPaIndoAddtionalPackagesQueryVariables>(GetPaIndoAddtionalPackagesDocument, options);
        }
export type GetPaIndoAddtionalPackagesQueryHookResult = ReturnType<typeof useGetPaIndoAddtionalPackagesQuery>;
export type GetPaIndoAddtionalPackagesLazyQueryHookResult = ReturnType<typeof useGetPaIndoAddtionalPackagesLazyQuery>;
export type GetPaIndoAddtionalPackagesQueryResult = Apollo.QueryResult<GetPaIndoAddtionalPackagesQuery, GetPaIndoAddtionalPackagesQueryVariables>;
export const GetAllocationListingDocument = gql`
    query getAllocationListing($projectId: String!, $refTable: String!, $creditId: String!) {
  getAllocationListing(projectId: $projectId, refTable: $refTable, creditId: $creditId) {
    id
    accountId
    creditRefTable
    creditId
    allocateAmount
    createdTs
    debitRefTable
    debitId
    allowReversal
    documentNo
    allocationDate
    originalId
  }
}
    `;

/**
 * __useGetAllocationListingQuery__
 *
 * To run a query within a React component, call `useGetAllocationListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllocationListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllocationListingQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      refTable: // value for 'refTable'
 *      creditId: // value for 'creditId'
 *   },
 * });
 */
export function useGetAllocationListingQuery(baseOptions: Apollo.QueryHookOptions<GetAllocationListingQuery, GetAllocationListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllocationListingQuery, GetAllocationListingQueryVariables>(GetAllocationListingDocument, options);
      }
export function useGetAllocationListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllocationListingQuery, GetAllocationListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllocationListingQuery, GetAllocationListingQueryVariables>(GetAllocationListingDocument, options);
        }
export type GetAllocationListingQueryHookResult = ReturnType<typeof useGetAllocationListingQuery>;
export type GetAllocationListingLazyQueryHookResult = ReturnType<typeof useGetAllocationListingLazyQuery>;
export type GetAllocationListingQueryResult = Apollo.QueryResult<GetAllocationListingQuery, GetAllocationListingQueryVariables>;
export const ReversalAllocationDocument = gql`
    mutation reversalAllocation($projectId: String!, $creditId: String!, $debitId: String!, $allocationId: String!, $reversalDate: String!, $saleId: String!) {
  reversalAllocation(projectId: $projectId, creditId: $creditId, debitId: $debitId, allocationId: $allocationId, reversalDate: $reversalDate, saleId: $saleId)
}
    `;
export type ReversalAllocationMutationFn = Apollo.MutationFunction<ReversalAllocationMutation, ReversalAllocationMutationVariables>;

/**
 * __useReversalAllocationMutation__
 *
 * To run a mutation, you first call `useReversalAllocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReversalAllocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reversalAllocationMutation, { data, loading, error }] = useReversalAllocationMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      creditId: // value for 'creditId'
 *      debitId: // value for 'debitId'
 *      allocationId: // value for 'allocationId'
 *      reversalDate: // value for 'reversalDate'
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useReversalAllocationMutation(baseOptions?: Apollo.MutationHookOptions<ReversalAllocationMutation, ReversalAllocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReversalAllocationMutation, ReversalAllocationMutationVariables>(ReversalAllocationDocument, options);
      }
export type ReversalAllocationMutationHookResult = ReturnType<typeof useReversalAllocationMutation>;
export type ReversalAllocationMutationResult = Apollo.MutationResult<ReversalAllocationMutation>;
export type ReversalAllocationMutationOptions = Apollo.BaseMutationOptions<ReversalAllocationMutation, ReversalAllocationMutationVariables>;
export const GetCarParkUnitInstallmentDocument = gql`
    query getCarParkUnitInstallment($saleId: String) {
  getCarParkUnitInstallment(saleId: $saleId) {
    totalDocumentAmount
    totalAllocated
    totalOutstanding
    unitId
    unitNo
    clusterName
    contactName
    installmentCount
  }
}
    `;

/**
 * __useGetCarParkUnitInstallmentQuery__
 *
 * To run a query within a React component, call `useGetCarParkUnitInstallmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarParkUnitInstallmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCarParkUnitInstallmentQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetCarParkUnitInstallmentQuery(baseOptions?: Apollo.QueryHookOptions<GetCarParkUnitInstallmentQuery, GetCarParkUnitInstallmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCarParkUnitInstallmentQuery, GetCarParkUnitInstallmentQueryVariables>(GetCarParkUnitInstallmentDocument, options);
      }
export function useGetCarParkUnitInstallmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCarParkUnitInstallmentQuery, GetCarParkUnitInstallmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCarParkUnitInstallmentQuery, GetCarParkUnitInstallmentQueryVariables>(GetCarParkUnitInstallmentDocument, options);
        }
export type GetCarParkUnitInstallmentQueryHookResult = ReturnType<typeof useGetCarParkUnitInstallmentQuery>;
export type GetCarParkUnitInstallmentLazyQueryHookResult = ReturnType<typeof useGetCarParkUnitInstallmentLazyQuery>;
export type GetCarParkUnitInstallmentQueryResult = Apollo.QueryResult<GetCarParkUnitInstallmentQuery, GetCarParkUnitInstallmentQueryVariables>;
export const GetCarParkInstallmentDocument = gql`
    query getCarParkInstallment($saleId: String, $unitId: String) {
  getCarParkInstallment(saleId: $saleId, unitId: $unitId) {
    id
    sellingPrice
    itemName
    totalDocumentAmount
    totalAllocated
    totalOutstanding
    unitId
    unitNo
    clusterName
    contactName
  }
}
    `;

/**
 * __useGetCarParkInstallmentQuery__
 *
 * To run a query within a React component, call `useGetCarParkInstallmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarParkInstallmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCarParkInstallmentQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *      unitId: // value for 'unitId'
 *   },
 * });
 */
export function useGetCarParkInstallmentQuery(baseOptions?: Apollo.QueryHookOptions<GetCarParkInstallmentQuery, GetCarParkInstallmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCarParkInstallmentQuery, GetCarParkInstallmentQueryVariables>(GetCarParkInstallmentDocument, options);
      }
export function useGetCarParkInstallmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCarParkInstallmentQuery, GetCarParkInstallmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCarParkInstallmentQuery, GetCarParkInstallmentQueryVariables>(GetCarParkInstallmentDocument, options);
        }
export type GetCarParkInstallmentQueryHookResult = ReturnType<typeof useGetCarParkInstallmentQuery>;
export type GetCarParkInstallmentLazyQueryHookResult = ReturnType<typeof useGetCarParkInstallmentLazyQuery>;
export type GetCarParkInstallmentQueryResult = Apollo.QueryResult<GetCarParkInstallmentQuery, GetCarParkInstallmentQueryVariables>;
export const GetCarParkInstallmentDetailDocument = gql`
    query getCarParkInstallmentDetail($saleId: String, $id: String!) {
  getCarParkInstallmentDetail(saleId: $saleId, id: $id) {
    id
    documentAmount
    documentNo
    outstanding
    totalAllocated
    documentDate
    creditTerm
    billType
  }
}
    `;

/**
 * __useGetCarParkInstallmentDetailQuery__
 *
 * To run a query within a React component, call `useGetCarParkInstallmentDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarParkInstallmentDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCarParkInstallmentDetailQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCarParkInstallmentDetailQuery(baseOptions: Apollo.QueryHookOptions<GetCarParkInstallmentDetailQuery, GetCarParkInstallmentDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCarParkInstallmentDetailQuery, GetCarParkInstallmentDetailQueryVariables>(GetCarParkInstallmentDetailDocument, options);
      }
export function useGetCarParkInstallmentDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCarParkInstallmentDetailQuery, GetCarParkInstallmentDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCarParkInstallmentDetailQuery, GetCarParkInstallmentDetailQueryVariables>(GetCarParkInstallmentDetailDocument, options);
        }
export type GetCarParkInstallmentDetailQueryHookResult = ReturnType<typeof useGetCarParkInstallmentDetailQuery>;
export type GetCarParkInstallmentDetailLazyQueryHookResult = ReturnType<typeof useGetCarParkInstallmentDetailLazyQuery>;
export type GetCarParkInstallmentDetailQueryResult = Apollo.QueryResult<GetCarParkInstallmentDetailQuery, GetCarParkInstallmentDetailQueryVariables>;
export const GetPaIndoContraListDocument = gql`
    query getPAIndoContraList($projectId: String!, $saleId: String) {
  getPAIndoContraList(projectId: $projectId, saleId: $saleId) {
    id
    accountId
    projectId
    saleId
    documentNo
    documentRef
    description
    documentDate
    documentAmount
    requestedBy
    glGenerationBatch
    glGenerated
    submittedBy
    submittedDate
    approvedBy
    approvedDate
    status
    commonStatus
    billItemId
    voidBy
    voidDate
    allowReversal
    refId
    ref_table
    unallocatedAmount
    unallocatedAmountSummary
  }
}
    `;

/**
 * __useGetPaIndoContraListQuery__
 *
 * To run a query within a React component, call `useGetPaIndoContraListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaIndoContraListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaIndoContraListQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetPaIndoContraListQuery(baseOptions: Apollo.QueryHookOptions<GetPaIndoContraListQuery, GetPaIndoContraListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaIndoContraListQuery, GetPaIndoContraListQueryVariables>(GetPaIndoContraListDocument, options);
      }
export function useGetPaIndoContraListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaIndoContraListQuery, GetPaIndoContraListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaIndoContraListQuery, GetPaIndoContraListQueryVariables>(GetPaIndoContraListDocument, options);
        }
export type GetPaIndoContraListQueryHookResult = ReturnType<typeof useGetPaIndoContraListQuery>;
export type GetPaIndoContraListLazyQueryHookResult = ReturnType<typeof useGetPaIndoContraListLazyQuery>;
export type GetPaIndoContraListQueryResult = Apollo.QueryResult<GetPaIndoContraListQuery, GetPaIndoContraListQueryVariables>;
export const GetPaIndoContraByIdDocument = gql`
    query getPAIndoContraById($projectId: String!, $id: String!) {
  getPAIndoContraById(projectId: $projectId, id: $id) {
    id
    accountId
    projectId
    saleId
    documentNo
    documentRef
    description
    documentDate
    documentAmount
    requestedBy
    glGenerationBatch
    glGenerated
    submittedBy
    submittedDate
    approvedBy
    approvedDate
    status
    commonStatus
    billItemId
    voidBy
    voidDate
    allowReversal
    refId
    ref_table
    unallocatedAmount
    unallocatedAmountSummary
    deposit {
      documentNo
    }
    submitUserData {
      ID
      name
      userName
    }
    approveUserData {
      ID
      name
      userName
    }
    voidUserData {
      ID
      name
      userName
    }
  }
}
    `;

/**
 * __useGetPaIndoContraByIdQuery__
 *
 * To run a query within a React component, call `useGetPaIndoContraByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaIndoContraByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaIndoContraByIdQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPaIndoContraByIdQuery(baseOptions: Apollo.QueryHookOptions<GetPaIndoContraByIdQuery, GetPaIndoContraByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaIndoContraByIdQuery, GetPaIndoContraByIdQueryVariables>(GetPaIndoContraByIdDocument, options);
      }
export function useGetPaIndoContraByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaIndoContraByIdQuery, GetPaIndoContraByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaIndoContraByIdQuery, GetPaIndoContraByIdQueryVariables>(GetPaIndoContraByIdDocument, options);
        }
export type GetPaIndoContraByIdQueryHookResult = ReturnType<typeof useGetPaIndoContraByIdQuery>;
export type GetPaIndoContraByIdLazyQueryHookResult = ReturnType<typeof useGetPaIndoContraByIdLazyQuery>;
export type GetPaIndoContraByIdQueryResult = Apollo.QueryResult<GetPaIndoContraByIdQuery, GetPaIndoContraByIdQueryVariables>;
export const AllocationContraIndoDocument = gql`
    mutation allocationContraIndo($input: AllocationContraInput!) {
  allocationContraIndo(input: $input)
}
    `;
export type AllocationContraIndoMutationFn = Apollo.MutationFunction<AllocationContraIndoMutation, AllocationContraIndoMutationVariables>;

/**
 * __useAllocationContraIndoMutation__
 *
 * To run a mutation, you first call `useAllocationContraIndoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAllocationContraIndoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [allocationContraIndoMutation, { data, loading, error }] = useAllocationContraIndoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAllocationContraIndoMutation(baseOptions?: Apollo.MutationHookOptions<AllocationContraIndoMutation, AllocationContraIndoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AllocationContraIndoMutation, AllocationContraIndoMutationVariables>(AllocationContraIndoDocument, options);
      }
export type AllocationContraIndoMutationHookResult = ReturnType<typeof useAllocationContraIndoMutation>;
export type AllocationContraIndoMutationResult = Apollo.MutationResult<AllocationContraIndoMutation>;
export type AllocationContraIndoMutationOptions = Apollo.BaseMutationOptions<AllocationContraIndoMutation, AllocationContraIndoMutationVariables>;
export const GetPaIndoCreditNoteByIdDocument = gql`
    query getPAIndoCreditNoteById($projectId: String!, $id: String!) {
  getPAIndoCreditNoteById(projectId: $projectId, id: $id) {
    saleId
    approvedBy
    approvedDate
    billItemId
    description
    documentAmount
    documentDate
    documentNo
    documentRef
    status
    submittedDate
    unallocatedAmount
    voidDate
    attachment {
      allowDelete
      fileName
      id
      isPrivate
      mediaType
      resourceUrl
    }
    billItemInt {
      billItemType
      id
      name
    }
    requestUserData {
      ID
      name
    }
    submitUserData {
      ID
      name
    }
    approveUserData {
      ID
      name
    }
    voidUserData {
      ID
      name
    }
    taxData {
      taxSchemeId
      taxSchemeName
      effectiveDate
      taxSchemeDetailId
      totalTaxRate
      totalTaxAmount
      isExclusive
    }
    projectDetail {
      name
    }
    unitDetail
    contactDetail
    taxLedger {
      taxAmount
    }
    submitUserData {
      userName
    }
    approveUserData {
      userName
    }
    clusterName {
      name
    }
  }
}
    `;

/**
 * __useGetPaIndoCreditNoteByIdQuery__
 *
 * To run a query within a React component, call `useGetPaIndoCreditNoteByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaIndoCreditNoteByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaIndoCreditNoteByIdQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPaIndoCreditNoteByIdQuery(baseOptions: Apollo.QueryHookOptions<GetPaIndoCreditNoteByIdQuery, GetPaIndoCreditNoteByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaIndoCreditNoteByIdQuery, GetPaIndoCreditNoteByIdQueryVariables>(GetPaIndoCreditNoteByIdDocument, options);
      }
export function useGetPaIndoCreditNoteByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaIndoCreditNoteByIdQuery, GetPaIndoCreditNoteByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaIndoCreditNoteByIdQuery, GetPaIndoCreditNoteByIdQueryVariables>(GetPaIndoCreditNoteByIdDocument, options);
        }
export type GetPaIndoCreditNoteByIdQueryHookResult = ReturnType<typeof useGetPaIndoCreditNoteByIdQuery>;
export type GetPaIndoCreditNoteByIdLazyQueryHookResult = ReturnType<typeof useGetPaIndoCreditNoteByIdLazyQuery>;
export type GetPaIndoCreditNoteByIdQueryResult = Apollo.QueryResult<GetPaIndoCreditNoteByIdQuery, GetPaIndoCreditNoteByIdQueryVariables>;
export const GetPaIndoDebitNoteByIdDocument = gql`
    query getPAIndoDebitNoteById($projectId: String!, $id: String!) {
  getPAIndoDebitNoteById(projectId: $projectId, id: $id) {
    saleId
    approvedBy
    approvedDate
    billItemId
    creditTerm
    description
    documentAmount
    documentDate
    documentNo
    documentRef
    dueDate
    interestRate
    isIncludeHoliday
    status
    submittedDate
    unallocatedAmount
    voidDate
    attachment {
      allowDelete
      fileName
      id
      isPrivate
      mediaType
      resourceUrl
    }
    billItemInt {
      billItemType
      id
      name
    }
    requestUserData {
      ID
      name
    }
    submitUserData {
      ID
      name
    }
    approveUserData {
      ID
      name
    }
    voidUserData {
      ID
      name
    }
    taxData {
      taxSchemeId
      taxSchemeName
      effectiveDate
      taxSchemeDetailId
      totalTaxRate
      totalTaxAmount
      isExclusive
    }
    projectDetail {
      name
    }
    unitDetail
    contactDetail
    taxLedger {
      taxAmount
    }
    submitUserData {
      userName
    }
    approveUserData {
      userName
    }
    clusterName {
      name
    }
  }
}
    `;

/**
 * __useGetPaIndoDebitNoteByIdQuery__
 *
 * To run a query within a React component, call `useGetPaIndoDebitNoteByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaIndoDebitNoteByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaIndoDebitNoteByIdQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPaIndoDebitNoteByIdQuery(baseOptions: Apollo.QueryHookOptions<GetPaIndoDebitNoteByIdQuery, GetPaIndoDebitNoteByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaIndoDebitNoteByIdQuery, GetPaIndoDebitNoteByIdQueryVariables>(GetPaIndoDebitNoteByIdDocument, options);
      }
export function useGetPaIndoDebitNoteByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaIndoDebitNoteByIdQuery, GetPaIndoDebitNoteByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaIndoDebitNoteByIdQuery, GetPaIndoDebitNoteByIdQueryVariables>(GetPaIndoDebitNoteByIdDocument, options);
        }
export type GetPaIndoDebitNoteByIdQueryHookResult = ReturnType<typeof useGetPaIndoDebitNoteByIdQuery>;
export type GetPaIndoDebitNoteByIdLazyQueryHookResult = ReturnType<typeof useGetPaIndoDebitNoteByIdLazyQuery>;
export type GetPaIndoDebitNoteByIdQueryResult = Apollo.QueryResult<GetPaIndoDebitNoteByIdQuery, GetPaIndoDebitNoteByIdQueryVariables>;
export const GetPaIndoDepositByIdDocument = gql`
    query getPAIndoDepositById($projectId: String!, $id: String!) {
  getPAIndoDepositById(projectId: $projectId, id: $id) {
    id
    accountId
    projectId
    saleId
    depositTypeId
    paymentMethod
    documentDate
    documentAmount
    documentRef
    description
    bankAccountId
    chequeNo
    status
    submittedDate
    submittedBy
    approvedDate
    approvedBy
    commonStatus
    voidDate
    voidBy
    documentNo
    chequeDate
    chequeExpireDate
    creditCardType
    attachment {
      allowDelete
      fileName
      id
      isPrivate
      mediaType
      resourceUrl
    }
    billItemInt {
      billItemType
      id
      name
    }
    outstanding
    submitUserData {
      ID
      name
      userName
    }
    approveUserData {
      ID
      name
      userName
    }
    voidUserData {
      ID
      name
      userName
    }
    taxData {
      taxSchemeId
      taxSchemeName
      effectiveDate
      taxSchemeDetailId
      totalTaxRate
    }
    projectDetail {
      name
    }
    unitDetail
    contactDetail
    taxLedger {
      taxAmount
    }
    bankAccount {
      id
      code
      accountNo
      bankProfile {
        name
      }
    }
    clusterName {
      name
    }
  }
}
    `;

/**
 * __useGetPaIndoDepositByIdQuery__
 *
 * To run a query within a React component, call `useGetPaIndoDepositByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaIndoDepositByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaIndoDepositByIdQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPaIndoDepositByIdQuery(baseOptions: Apollo.QueryHookOptions<GetPaIndoDepositByIdQuery, GetPaIndoDepositByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaIndoDepositByIdQuery, GetPaIndoDepositByIdQueryVariables>(GetPaIndoDepositByIdDocument, options);
      }
export function useGetPaIndoDepositByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaIndoDepositByIdQuery, GetPaIndoDepositByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaIndoDepositByIdQuery, GetPaIndoDepositByIdQueryVariables>(GetPaIndoDepositByIdDocument, options);
        }
export type GetPaIndoDepositByIdQueryHookResult = ReturnType<typeof useGetPaIndoDepositByIdQuery>;
export type GetPaIndoDepositByIdLazyQueryHookResult = ReturnType<typeof useGetPaIndoDepositByIdLazyQuery>;
export type GetPaIndoDepositByIdQueryResult = Apollo.QueryResult<GetPaIndoDepositByIdQuery, GetPaIndoDepositByIdQueryVariables>;
export const CreatePaIndoDepositDocument = gql`
    mutation createPAIndoDeposit($input: paIndoDepositInput!) {
  createPAIndoDeposit(input: $input)
}
    `;
export type CreatePaIndoDepositMutationFn = Apollo.MutationFunction<CreatePaIndoDepositMutation, CreatePaIndoDepositMutationVariables>;

/**
 * __useCreatePaIndoDepositMutation__
 *
 * To run a mutation, you first call `useCreatePaIndoDepositMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaIndoDepositMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaIndoDepositMutation, { data, loading, error }] = useCreatePaIndoDepositMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePaIndoDepositMutation(baseOptions?: Apollo.MutationHookOptions<CreatePaIndoDepositMutation, CreatePaIndoDepositMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePaIndoDepositMutation, CreatePaIndoDepositMutationVariables>(CreatePaIndoDepositDocument, options);
      }
export type CreatePaIndoDepositMutationHookResult = ReturnType<typeof useCreatePaIndoDepositMutation>;
export type CreatePaIndoDepositMutationResult = Apollo.MutationResult<CreatePaIndoDepositMutation>;
export type CreatePaIndoDepositMutationOptions = Apollo.BaseMutationOptions<CreatePaIndoDepositMutation, CreatePaIndoDepositMutationVariables>;
export const EditPaIndoDepositDocument = gql`
    mutation editPAIndoDeposit($input: paIndoEditDepositInput!) {
  editPAIndoDeposit(input: $input)
}
    `;
export type EditPaIndoDepositMutationFn = Apollo.MutationFunction<EditPaIndoDepositMutation, EditPaIndoDepositMutationVariables>;

/**
 * __useEditPaIndoDepositMutation__
 *
 * To run a mutation, you first call `useEditPaIndoDepositMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPaIndoDepositMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPaIndoDepositMutation, { data, loading, error }] = useEditPaIndoDepositMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditPaIndoDepositMutation(baseOptions?: Apollo.MutationHookOptions<EditPaIndoDepositMutation, EditPaIndoDepositMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditPaIndoDepositMutation, EditPaIndoDepositMutationVariables>(EditPaIndoDepositDocument, options);
      }
export type EditPaIndoDepositMutationHookResult = ReturnType<typeof useEditPaIndoDepositMutation>;
export type EditPaIndoDepositMutationResult = Apollo.MutationResult<EditPaIndoDepositMutation>;
export type EditPaIndoDepositMutationOptions = Apollo.BaseMutationOptions<EditPaIndoDepositMutation, EditPaIndoDepositMutationVariables>;
export const ConvertToPaymentDocument = gql`
    mutation convertToPayment($depositId: String!, $depositDate: String!, $documentAmount: Float!) {
  convertToPayment(depositId: $depositId, depositDate: $depositDate, documentAmount: $documentAmount)
}
    `;
export type ConvertToPaymentMutationFn = Apollo.MutationFunction<ConvertToPaymentMutation, ConvertToPaymentMutationVariables>;

/**
 * __useConvertToPaymentMutation__
 *
 * To run a mutation, you first call `useConvertToPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConvertToPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [convertToPaymentMutation, { data, loading, error }] = useConvertToPaymentMutation({
 *   variables: {
 *      depositId: // value for 'depositId'
 *      depositDate: // value for 'depositDate'
 *      documentAmount: // value for 'documentAmount'
 *   },
 * });
 */
export function useConvertToPaymentMutation(baseOptions?: Apollo.MutationHookOptions<ConvertToPaymentMutation, ConvertToPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConvertToPaymentMutation, ConvertToPaymentMutationVariables>(ConvertToPaymentDocument, options);
      }
export type ConvertToPaymentMutationHookResult = ReturnType<typeof useConvertToPaymentMutation>;
export type ConvertToPaymentMutationResult = Apollo.MutationResult<ConvertToPaymentMutation>;
export type ConvertToPaymentMutationOptions = Apollo.BaseMutationOptions<ConvertToPaymentMutation, ConvertToPaymentMutationVariables>;
export const GetLateInterestBySaleIdDocument = gql`
    query getLateInterestBySaleId($saleId: String!, $generationDate: DateTime!) {
  getLateInterestBySaleId(saleId: $saleId, generationDate: $generationDate) {
    mainUnitLateInterest {
      saleId
      installmentId
      dueDate
      description
      documentDate
      allocationDate
      interestStartDate
      interestEndDate
      documentAmount
      creditTerm
      outstanding
      generateDate
      overdueDay
      interestAmount
    }
    carParkLateInterest {
      saleId
      installmentId
      dueDate
      description
      documentDate
      allocationDate
      interestStartDate
      interestEndDate
      documentAmount
      creditTerm
      outstanding
      generateDate
      overdueDay
      interestAmount
    }
    packagesLateInterest {
      saleId
      installmentId
      dueDate
      description
      documentDate
      allocationDate
      interestStartDate
      interestEndDate
      documentAmount
      creditTerm
      outstanding
      generateDate
      overdueDay
      interestAmount
    }
    miscBillingLateInterest {
      saleId
      installmentId
      dueDate
      description
      documentDate
      allocationDate
      interestStartDate
      interestEndDate
      documentAmount
      creditTerm
      outstanding
      generateDate
      overdueDay
      interestAmount
    }
    bankAccountNo
    bankAccountName
  }
}
    `;

/**
 * __useGetLateInterestBySaleIdQuery__
 *
 * To run a query within a React component, call `useGetLateInterestBySaleIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLateInterestBySaleIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLateInterestBySaleIdQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *      generationDate: // value for 'generationDate'
 *   },
 * });
 */
export function useGetLateInterestBySaleIdQuery(baseOptions: Apollo.QueryHookOptions<GetLateInterestBySaleIdQuery, GetLateInterestBySaleIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLateInterestBySaleIdQuery, GetLateInterestBySaleIdQueryVariables>(GetLateInterestBySaleIdDocument, options);
      }
export function useGetLateInterestBySaleIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLateInterestBySaleIdQuery, GetLateInterestBySaleIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLateInterestBySaleIdQuery, GetLateInterestBySaleIdQueryVariables>(GetLateInterestBySaleIdDocument, options);
        }
export type GetLateInterestBySaleIdQueryHookResult = ReturnType<typeof useGetLateInterestBySaleIdQuery>;
export type GetLateInterestBySaleIdLazyQueryHookResult = ReturnType<typeof useGetLateInterestBySaleIdLazyQuery>;
export type GetLateInterestBySaleIdQueryResult = Apollo.QueryResult<GetLateInterestBySaleIdQuery, GetLateInterestBySaleIdQueryVariables>;
export const GetListLateInterestDocument = gql`
    query getListLateInterest($saleId: String!) {
  getListLateInterest(saleId: $saleId) {
    id
    accountId
    projectId
    saleId
    documentNo
    documentDate
    documentAmount
    totalNegotiateAmt
    totalWaiveAmt
    description
    bankAccount
    status
    submittedDate
    submittedBy
    voidDate
    voidBy
    approvedDate
    approvedBy
    glGenerationBatch
    glGenerated
    commonStatus
    totalCharges
    totalUnallocated
    submitUserData {
      ID
      name
    }
  }
}
    `;

/**
 * __useGetListLateInterestQuery__
 *
 * To run a query within a React component, call `useGetListLateInterestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListLateInterestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListLateInterestQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetListLateInterestQuery(baseOptions: Apollo.QueryHookOptions<GetListLateInterestQuery, GetListLateInterestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetListLateInterestQuery, GetListLateInterestQueryVariables>(GetListLateInterestDocument, options);
      }
export function useGetListLateInterestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetListLateInterestQuery, GetListLateInterestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetListLateInterestQuery, GetListLateInterestQueryVariables>(GetListLateInterestDocument, options);
        }
export type GetListLateInterestQueryHookResult = ReturnType<typeof useGetListLateInterestQuery>;
export type GetListLateInterestLazyQueryHookResult = ReturnType<typeof useGetListLateInterestLazyQuery>;
export type GetListLateInterestQueryResult = Apollo.QueryResult<GetListLateInterestQuery, GetListLateInterestQueryVariables>;
export const GetPaIndoLateInterestListingDocument = gql`
    query getPAIndoLateInterestListing($projectId: String!, $status: String) {
  getPAIndoLateInterestListing(projectId: $projectId, status: $status) {
    id
    projectId
    saleId
    debitId
    allocateAmount
    documentDate
    documentNo
    description
    documentAmount
    totalNegotiateAmt
    bankAccount
    submittedDate
    submittedBy
    submitUserData {
      ID
      name
    }
    totalWaiveAmt
    fullName
    unitNo
    clusterName
  }
}
    `;

/**
 * __useGetPaIndoLateInterestListingQuery__
 *
 * To run a query within a React component, call `useGetPaIndoLateInterestListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaIndoLateInterestListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaIndoLateInterestListingQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetPaIndoLateInterestListingQuery(baseOptions: Apollo.QueryHookOptions<GetPaIndoLateInterestListingQuery, GetPaIndoLateInterestListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaIndoLateInterestListingQuery, GetPaIndoLateInterestListingQueryVariables>(GetPaIndoLateInterestListingDocument, options);
      }
export function useGetPaIndoLateInterestListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaIndoLateInterestListingQuery, GetPaIndoLateInterestListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaIndoLateInterestListingQuery, GetPaIndoLateInterestListingQueryVariables>(GetPaIndoLateInterestListingDocument, options);
        }
export type GetPaIndoLateInterestListingQueryHookResult = ReturnType<typeof useGetPaIndoLateInterestListingQuery>;
export type GetPaIndoLateInterestListingLazyQueryHookResult = ReturnType<typeof useGetPaIndoLateInterestListingLazyQuery>;
export type GetPaIndoLateInterestListingQueryResult = Apollo.QueryResult<GetPaIndoLateInterestListingQuery, GetPaIndoLateInterestListingQueryVariables>;
export const GetLateInterestsDetailDocument = gql`
    query getLateInterestsDetail($saleId: String!, $lateInterestId: String!) {
  getLateInterestsDetail(saleId: $saleId, lateInterestId: $lateInterestId) {
    saleId
    dueDate
    overdueDay
    description
    documentDate
    documentAmount
    creditTerm
    interestStartDate
    interestEndDate
    interestAmount
    submittedDate
    refTable
    refId
    waiveAmt
  }
}
    `;

/**
 * __useGetLateInterestsDetailQuery__
 *
 * To run a query within a React component, call `useGetLateInterestsDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLateInterestsDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLateInterestsDetailQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *      lateInterestId: // value for 'lateInterestId'
 *   },
 * });
 */
export function useGetLateInterestsDetailQuery(baseOptions: Apollo.QueryHookOptions<GetLateInterestsDetailQuery, GetLateInterestsDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLateInterestsDetailQuery, GetLateInterestsDetailQueryVariables>(GetLateInterestsDetailDocument, options);
      }
export function useGetLateInterestsDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLateInterestsDetailQuery, GetLateInterestsDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLateInterestsDetailQuery, GetLateInterestsDetailQueryVariables>(GetLateInterestsDetailDocument, options);
        }
export type GetLateInterestsDetailQueryHookResult = ReturnType<typeof useGetLateInterestsDetailQuery>;
export type GetLateInterestsDetailLazyQueryHookResult = ReturnType<typeof useGetLateInterestsDetailLazyQuery>;
export type GetLateInterestsDetailQueryResult = Apollo.QueryResult<GetLateInterestsDetailQuery, GetLateInterestsDetailQueryVariables>;
export const GenerateLatePaymentInterestDocument = gql`
    mutation generateLatePaymentInterest($saleId: String!, $status: String!, $generationDate: DateTime!, $unitNegotiatedAmount: Float!, $carParkNegotiatedAmount: Float!, $packagesNegotiatedAmount: Float!, $miscBillingNegotiatedAmount: Float!) {
  generateLatePaymentInterest(saleId: $saleId, status: $status, generationDate: $generationDate, unitNegotiatedAmount: $unitNegotiatedAmount, carParkNegotiatedAmount: $carParkNegotiatedAmount, packagesNegotiatedAmount: $packagesNegotiatedAmount, miscBillingNegotiatedAmount: $miscBillingNegotiatedAmount)
}
    `;
export type GenerateLatePaymentInterestMutationFn = Apollo.MutationFunction<GenerateLatePaymentInterestMutation, GenerateLatePaymentInterestMutationVariables>;

/**
 * __useGenerateLatePaymentInterestMutation__
 *
 * To run a mutation, you first call `useGenerateLatePaymentInterestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateLatePaymentInterestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateLatePaymentInterestMutation, { data, loading, error }] = useGenerateLatePaymentInterestMutation({
 *   variables: {
 *      saleId: // value for 'saleId'
 *      status: // value for 'status'
 *      generationDate: // value for 'generationDate'
 *      unitNegotiatedAmount: // value for 'unitNegotiatedAmount'
 *      carParkNegotiatedAmount: // value for 'carParkNegotiatedAmount'
 *      packagesNegotiatedAmount: // value for 'packagesNegotiatedAmount'
 *      miscBillingNegotiatedAmount: // value for 'miscBillingNegotiatedAmount'
 *   },
 * });
 */
export function useGenerateLatePaymentInterestMutation(baseOptions?: Apollo.MutationHookOptions<GenerateLatePaymentInterestMutation, GenerateLatePaymentInterestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateLatePaymentInterestMutation, GenerateLatePaymentInterestMutationVariables>(GenerateLatePaymentInterestDocument, options);
      }
export type GenerateLatePaymentInterestMutationHookResult = ReturnType<typeof useGenerateLatePaymentInterestMutation>;
export type GenerateLatePaymentInterestMutationResult = Apollo.MutationResult<GenerateLatePaymentInterestMutation>;
export type GenerateLatePaymentInterestMutationOptions = Apollo.BaseMutationOptions<GenerateLatePaymentInterestMutation, GenerateLatePaymentInterestMutationVariables>;
export const ApproveLateInterestsByIdDocument = gql`
    mutation approveLateInterestsById($saleId: String!, $lateInterestId: String!) {
  approveLateInterestsById(saleId: $saleId, lateInterestId: $lateInterestId)
}
    `;
export type ApproveLateInterestsByIdMutationFn = Apollo.MutationFunction<ApproveLateInterestsByIdMutation, ApproveLateInterestsByIdMutationVariables>;

/**
 * __useApproveLateInterestsByIdMutation__
 *
 * To run a mutation, you first call `useApproveLateInterestsByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveLateInterestsByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveLateInterestsByIdMutation, { data, loading, error }] = useApproveLateInterestsByIdMutation({
 *   variables: {
 *      saleId: // value for 'saleId'
 *      lateInterestId: // value for 'lateInterestId'
 *   },
 * });
 */
export function useApproveLateInterestsByIdMutation(baseOptions?: Apollo.MutationHookOptions<ApproveLateInterestsByIdMutation, ApproveLateInterestsByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveLateInterestsByIdMutation, ApproveLateInterestsByIdMutationVariables>(ApproveLateInterestsByIdDocument, options);
      }
export type ApproveLateInterestsByIdMutationHookResult = ReturnType<typeof useApproveLateInterestsByIdMutation>;
export type ApproveLateInterestsByIdMutationResult = Apollo.MutationResult<ApproveLateInterestsByIdMutation>;
export type ApproveLateInterestsByIdMutationOptions = Apollo.BaseMutationOptions<ApproveLateInterestsByIdMutation, ApproveLateInterestsByIdMutationVariables>;
export const RejectLateInterestsByIdDocument = gql`
    mutation rejectLateInterestsById($saleId: String!, $lateInterestId: String!) {
  rejectLateInterestsById(saleId: $saleId, lateInterestId: $lateInterestId)
}
    `;
export type RejectLateInterestsByIdMutationFn = Apollo.MutationFunction<RejectLateInterestsByIdMutation, RejectLateInterestsByIdMutationVariables>;

/**
 * __useRejectLateInterestsByIdMutation__
 *
 * To run a mutation, you first call `useRejectLateInterestsByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectLateInterestsByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectLateInterestsByIdMutation, { data, loading, error }] = useRejectLateInterestsByIdMutation({
 *   variables: {
 *      saleId: // value for 'saleId'
 *      lateInterestId: // value for 'lateInterestId'
 *   },
 * });
 */
export function useRejectLateInterestsByIdMutation(baseOptions?: Apollo.MutationHookOptions<RejectLateInterestsByIdMutation, RejectLateInterestsByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectLateInterestsByIdMutation, RejectLateInterestsByIdMutationVariables>(RejectLateInterestsByIdDocument, options);
      }
export type RejectLateInterestsByIdMutationHookResult = ReturnType<typeof useRejectLateInterestsByIdMutation>;
export type RejectLateInterestsByIdMutationResult = Apollo.MutationResult<RejectLateInterestsByIdMutation>;
export type RejectLateInterestsByIdMutationOptions = Apollo.BaseMutationOptions<RejectLateInterestsByIdMutation, RejectLateInterestsByIdMutationVariables>;
export const UpdateLateInterestsByIdDocument = gql`
    mutation updateLateInterestsById($saleId: String!, $lateInterestId: String!, $status: String!, $generationDate: DateTime!, $unitNegotiatedAmount: Float!, $carParkNegotiatedAmount: Float!, $packagesNegotiatedAmount: Float!, $miscBillingNegotiatedAmount: Float!) {
  updateLateInterestsById(saleId: $saleId, lateInterestId: $lateInterestId, status: $status, generationDate: $generationDate, unitNegotiatedAmount: $unitNegotiatedAmount, carParkNegotiatedAmount: $carParkNegotiatedAmount, packagesNegotiatedAmount: $packagesNegotiatedAmount, miscBillingNegotiatedAmount: $miscBillingNegotiatedAmount)
}
    `;
export type UpdateLateInterestsByIdMutationFn = Apollo.MutationFunction<UpdateLateInterestsByIdMutation, UpdateLateInterestsByIdMutationVariables>;

/**
 * __useUpdateLateInterestsByIdMutation__
 *
 * To run a mutation, you first call `useUpdateLateInterestsByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLateInterestsByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLateInterestsByIdMutation, { data, loading, error }] = useUpdateLateInterestsByIdMutation({
 *   variables: {
 *      saleId: // value for 'saleId'
 *      lateInterestId: // value for 'lateInterestId'
 *      status: // value for 'status'
 *      generationDate: // value for 'generationDate'
 *      unitNegotiatedAmount: // value for 'unitNegotiatedAmount'
 *      carParkNegotiatedAmount: // value for 'carParkNegotiatedAmount'
 *      packagesNegotiatedAmount: // value for 'packagesNegotiatedAmount'
 *      miscBillingNegotiatedAmount: // value for 'miscBillingNegotiatedAmount'
 *   },
 * });
 */
export function useUpdateLateInterestsByIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLateInterestsByIdMutation, UpdateLateInterestsByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLateInterestsByIdMutation, UpdateLateInterestsByIdMutationVariables>(UpdateLateInterestsByIdDocument, options);
      }
export type UpdateLateInterestsByIdMutationHookResult = ReturnType<typeof useUpdateLateInterestsByIdMutation>;
export type UpdateLateInterestsByIdMutationResult = Apollo.MutationResult<UpdateLateInterestsByIdMutation>;
export type UpdateLateInterestsByIdMutationOptions = Apollo.BaseMutationOptions<UpdateLateInterestsByIdMutation, UpdateLateInterestsByIdMutationVariables>;
export const GetPaIndomiscBillingByIdDocument = gql`
    query getPAIndomiscBillingById($projectId: String!, $id: String!) {
  getPAIndomiscBillingById(projectId: $projectId, id: $id) {
    saleId
    approvedBy
    approvedDate
    billItemId
    creditTerm
    description
    documentAmount
    documentDate
    documentNo
    documentRef
    dueDate
    interestRate
    isIncludeHoliday
    status
    submittedDate
    unallocatedAmount
    voidDate
    attachment {
      allowDelete
      fileName
      id
      isPrivate
      mediaType
      resourceUrl
    }
    billItemInt {
      billItemType
      id
      name
    }
    requestUserData {
      ID
      name
    }
    submitUserData {
      ID
      name
    }
    approveUserData {
      ID
      name
    }
    voidUserData {
      ID
      name
    }
    taxData {
      taxSchemeId
      taxSchemeName
      effectiveDate
      taxSchemeDetailId
      totalTaxRate
      totalTaxAmount
      isExclusive
    }
    projectDetail {
      name
    }
    unitDetail
    contactDetail
    taxLedger {
      taxAmount
    }
    submitUserData {
      userName
    }
    approveUserData {
      userName
    }
    clusterName {
      name
    }
  }
}
    `;

/**
 * __useGetPaIndomiscBillingByIdQuery__
 *
 * To run a query within a React component, call `useGetPaIndomiscBillingByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaIndomiscBillingByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaIndomiscBillingByIdQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPaIndomiscBillingByIdQuery(baseOptions: Apollo.QueryHookOptions<GetPaIndomiscBillingByIdQuery, GetPaIndomiscBillingByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaIndomiscBillingByIdQuery, GetPaIndomiscBillingByIdQueryVariables>(GetPaIndomiscBillingByIdDocument, options);
      }
export function useGetPaIndomiscBillingByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaIndomiscBillingByIdQuery, GetPaIndomiscBillingByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaIndomiscBillingByIdQuery, GetPaIndomiscBillingByIdQueryVariables>(GetPaIndomiscBillingByIdDocument, options);
        }
export type GetPaIndomiscBillingByIdQueryHookResult = ReturnType<typeof useGetPaIndomiscBillingByIdQuery>;
export type GetPaIndomiscBillingByIdLazyQueryHookResult = ReturnType<typeof useGetPaIndomiscBillingByIdLazyQuery>;
export type GetPaIndomiscBillingByIdQueryResult = Apollo.QueryResult<GetPaIndomiscBillingByIdQuery, GetPaIndomiscBillingByIdQueryVariables>;
export const EditPaIndoMiscBillingDocument = gql`
    mutation editPAIndoMiscBilling($isSubmitted: Boolean!, $input: EditPAMiscBillingInput!) {
  editPAmiscBilling(isSubmitted: $isSubmitted, input: $input)
}
    `;
export type EditPaIndoMiscBillingMutationFn = Apollo.MutationFunction<EditPaIndoMiscBillingMutation, EditPaIndoMiscBillingMutationVariables>;

/**
 * __useEditPaIndoMiscBillingMutation__
 *
 * To run a mutation, you first call `useEditPaIndoMiscBillingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPaIndoMiscBillingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPaIndoMiscBillingMutation, { data, loading, error }] = useEditPaIndoMiscBillingMutation({
 *   variables: {
 *      isSubmitted: // value for 'isSubmitted'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditPaIndoMiscBillingMutation(baseOptions?: Apollo.MutationHookOptions<EditPaIndoMiscBillingMutation, EditPaIndoMiscBillingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditPaIndoMiscBillingMutation, EditPaIndoMiscBillingMutationVariables>(EditPaIndoMiscBillingDocument, options);
      }
export type EditPaIndoMiscBillingMutationHookResult = ReturnType<typeof useEditPaIndoMiscBillingMutation>;
export type EditPaIndoMiscBillingMutationResult = Apollo.MutationResult<EditPaIndoMiscBillingMutation>;
export type EditPaIndoMiscBillingMutationOptions = Apollo.BaseMutationOptions<EditPaIndoMiscBillingMutation, EditPaIndoMiscBillingMutationVariables>;
export const CalculateMiscBillingTaxAmountDocument = gql`
    query calculateMiscBillingTaxAmount($input: calculateMiscBillingTaxAmountInput!) {
  calculateMiscBillingTaxAmount(input: $input)
}
    `;

/**
 * __useCalculateMiscBillingTaxAmountQuery__
 *
 * To run a query within a React component, call `useCalculateMiscBillingTaxAmountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalculateMiscBillingTaxAmountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalculateMiscBillingTaxAmountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCalculateMiscBillingTaxAmountQuery(baseOptions: Apollo.QueryHookOptions<CalculateMiscBillingTaxAmountQuery, CalculateMiscBillingTaxAmountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalculateMiscBillingTaxAmountQuery, CalculateMiscBillingTaxAmountQueryVariables>(CalculateMiscBillingTaxAmountDocument, options);
      }
export function useCalculateMiscBillingTaxAmountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalculateMiscBillingTaxAmountQuery, CalculateMiscBillingTaxAmountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalculateMiscBillingTaxAmountQuery, CalculateMiscBillingTaxAmountQueryVariables>(CalculateMiscBillingTaxAmountDocument, options);
        }
export type CalculateMiscBillingTaxAmountQueryHookResult = ReturnType<typeof useCalculateMiscBillingTaxAmountQuery>;
export type CalculateMiscBillingTaxAmountLazyQueryHookResult = ReturnType<typeof useCalculateMiscBillingTaxAmountLazyQuery>;
export type CalculateMiscBillingTaxAmountQueryResult = Apollo.QueryResult<CalculateMiscBillingTaxAmountQuery, CalculateMiscBillingTaxAmountQueryVariables>;
export const GetPaIndoPaymentByIdDocument = gql`
    query getPAIndoPaymentById($projectId: String!, $id: String!) {
  getPAIndoPaymentById(projectId: $projectId, id: $id) {
    saleId
    approvedBy
    approvedDate
    description
    documentAmount
    documentDate
    documentNo
    documentRef
    status
    submittedDate
    unallocatedAmount
    paymentMethod
    receiptAmount
    chequeDate
    chequeExpireDate
    creditCardType
    bankAccountId
    voidDate
    attachment {
      allowDelete
      fileName
      id
      isPrivate
      mediaType
      resourceUrl
    }
    submitUserData {
      ID
      name
    }
    approveUserData {
      ID
      name
    }
    voidUserData {
      ID
      name
    }
    taxData {
      taxSchemeId
      taxSchemeName
      effectiveDate
      taxSchemeDetailId
      totalTaxRate
    }
    projectDetail {
      name
    }
    taxLedger {
      taxAmount
    }
    bankAccount {
      id
      code
      accountNo
      bankProfile {
        name
      }
    }
    unitDetail
    contactDetail
    taxLedger {
      taxAmount
    }
    submitUserData {
      userName
    }
    approveUserData {
      userName
    }
    clusterName {
      name
    }
    salesRegNo {
      salesRegistrationNo
      salesRegistrationDate
    }
  }
}
    `;

/**
 * __useGetPaIndoPaymentByIdQuery__
 *
 * To run a query within a React component, call `useGetPaIndoPaymentByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaIndoPaymentByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaIndoPaymentByIdQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPaIndoPaymentByIdQuery(baseOptions: Apollo.QueryHookOptions<GetPaIndoPaymentByIdQuery, GetPaIndoPaymentByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaIndoPaymentByIdQuery, GetPaIndoPaymentByIdQueryVariables>(GetPaIndoPaymentByIdDocument, options);
      }
export function useGetPaIndoPaymentByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaIndoPaymentByIdQuery, GetPaIndoPaymentByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaIndoPaymentByIdQuery, GetPaIndoPaymentByIdQueryVariables>(GetPaIndoPaymentByIdDocument, options);
        }
export type GetPaIndoPaymentByIdQueryHookResult = ReturnType<typeof useGetPaIndoPaymentByIdQuery>;
export type GetPaIndoPaymentByIdLazyQueryHookResult = ReturnType<typeof useGetPaIndoPaymentByIdLazyQuery>;
export type GetPaIndoPaymentByIdQueryResult = Apollo.QueryResult<GetPaIndoPaymentByIdQuery, GetPaIndoPaymentByIdQueryVariables>;
export const AllocationReceiptIndoDocument = gql`
    mutation allocationReceiptIndo($input: AllocationInputIndo!) {
  allocationReceiptIndo(input: $input)
}
    `;
export type AllocationReceiptIndoMutationFn = Apollo.MutationFunction<AllocationReceiptIndoMutation, AllocationReceiptIndoMutationVariables>;

/**
 * __useAllocationReceiptIndoMutation__
 *
 * To run a mutation, you first call `useAllocationReceiptIndoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAllocationReceiptIndoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [allocationReceiptIndoMutation, { data, loading, error }] = useAllocationReceiptIndoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAllocationReceiptIndoMutation(baseOptions?: Apollo.MutationHookOptions<AllocationReceiptIndoMutation, AllocationReceiptIndoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AllocationReceiptIndoMutation, AllocationReceiptIndoMutationVariables>(AllocationReceiptIndoDocument, options);
      }
export type AllocationReceiptIndoMutationHookResult = ReturnType<typeof useAllocationReceiptIndoMutation>;
export type AllocationReceiptIndoMutationResult = Apollo.MutationResult<AllocationReceiptIndoMutation>;
export type AllocationReceiptIndoMutationOptions = Apollo.BaseMutationOptions<AllocationReceiptIndoMutation, AllocationReceiptIndoMutationVariables>;
export const GetPaymentELetterTemplateListingDocument = gql`
    query getPaymentELetterTemplateListing($projectId: String!) {
  getPaymentELetterTemplateListing(projectId: $projectId) {
    id
    name
    letterType
    defaulted
  }
}
    `;

/**
 * __useGetPaymentELetterTemplateListingQuery__
 *
 * To run a query within a React component, call `useGetPaymentELetterTemplateListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentELetterTemplateListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentELetterTemplateListingQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetPaymentELetterTemplateListingQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentELetterTemplateListingQuery, GetPaymentELetterTemplateListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentELetterTemplateListingQuery, GetPaymentELetterTemplateListingQueryVariables>(GetPaymentELetterTemplateListingDocument, options);
      }
export function useGetPaymentELetterTemplateListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentELetterTemplateListingQuery, GetPaymentELetterTemplateListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentELetterTemplateListingQuery, GetPaymentELetterTemplateListingQueryVariables>(GetPaymentELetterTemplateListingDocument, options);
        }
export type GetPaymentELetterTemplateListingQueryHookResult = ReturnType<typeof useGetPaymentELetterTemplateListingQuery>;
export type GetPaymentELetterTemplateListingLazyQueryHookResult = ReturnType<typeof useGetPaymentELetterTemplateListingLazyQuery>;
export type GetPaymentELetterTemplateListingQueryResult = Apollo.QueryResult<GetPaymentELetterTemplateListingQuery, GetPaymentELetterTemplateListingQueryVariables>;
export const GetPaymentELetterDocument = gql`
    query getPaymentELetter($letterTemplateId: String!, $receiptId: String!) {
  getPaymentELetter(letterTemplateId: $letterTemplateId, receiptId: $receiptId) {
    content
    fileName
  }
}
    `;

/**
 * __useGetPaymentELetterQuery__
 *
 * To run a query within a React component, call `useGetPaymentELetterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentELetterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentELetterQuery({
 *   variables: {
 *      letterTemplateId: // value for 'letterTemplateId'
 *      receiptId: // value for 'receiptId'
 *   },
 * });
 */
export function useGetPaymentELetterQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentELetterQuery, GetPaymentELetterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentELetterQuery, GetPaymentELetterQueryVariables>(GetPaymentELetterDocument, options);
      }
export function useGetPaymentELetterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentELetterQuery, GetPaymentELetterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentELetterQuery, GetPaymentELetterQueryVariables>(GetPaymentELetterDocument, options);
        }
export type GetPaymentELetterQueryHookResult = ReturnType<typeof useGetPaymentELetterQuery>;
export type GetPaymentELetterLazyQueryHookResult = ReturnType<typeof useGetPaymentELetterLazyQuery>;
export type GetPaymentELetterQueryResult = Apollo.QueryResult<GetPaymentELetterQuery, GetPaymentELetterQueryVariables>;
export const GetPaIndoPaymentReminderBySaleIdDocument = gql`
    query getPAIndoPaymentReminderBySaleId($saleId: String!) {
  getPaymentReminderBySaleId(saleId: $saleId) {
    unitNo
    saleId
    reminderDate
    generationBatch
    paymentReminderDetails {
      documentNo
      documentDate
      dueDate
      balanceAmount
      reminderSeq
    }
  }
}
    `;

/**
 * __useGetPaIndoPaymentReminderBySaleIdQuery__
 *
 * To run a query within a React component, call `useGetPaIndoPaymentReminderBySaleIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaIndoPaymentReminderBySaleIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaIndoPaymentReminderBySaleIdQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetPaIndoPaymentReminderBySaleIdQuery(baseOptions: Apollo.QueryHookOptions<GetPaIndoPaymentReminderBySaleIdQuery, GetPaIndoPaymentReminderBySaleIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaIndoPaymentReminderBySaleIdQuery, GetPaIndoPaymentReminderBySaleIdQueryVariables>(GetPaIndoPaymentReminderBySaleIdDocument, options);
      }
export function useGetPaIndoPaymentReminderBySaleIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaIndoPaymentReminderBySaleIdQuery, GetPaIndoPaymentReminderBySaleIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaIndoPaymentReminderBySaleIdQuery, GetPaIndoPaymentReminderBySaleIdQueryVariables>(GetPaIndoPaymentReminderBySaleIdDocument, options);
        }
export type GetPaIndoPaymentReminderBySaleIdQueryHookResult = ReturnType<typeof useGetPaIndoPaymentReminderBySaleIdQuery>;
export type GetPaIndoPaymentReminderBySaleIdLazyQueryHookResult = ReturnType<typeof useGetPaIndoPaymentReminderBySaleIdLazyQuery>;
export type GetPaIndoPaymentReminderBySaleIdQueryResult = Apollo.QueryResult<GetPaIndoPaymentReminderBySaleIdQuery, GetPaIndoPaymentReminderBySaleIdQueryVariables>;
export const GetPaIndoAllPaymentReminderDocument = gql`
    query getPAIndoAllPaymentReminder {
  getAllPaymentReminder {
    unitNo
    reminder1
    reminder2
    reminder3
    reminderDate
    balanceAmount
    generationBatch
  }
}
    `;

/**
 * __useGetPaIndoAllPaymentReminderQuery__
 *
 * To run a query within a React component, call `useGetPaIndoAllPaymentReminderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaIndoAllPaymentReminderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaIndoAllPaymentReminderQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPaIndoAllPaymentReminderQuery(baseOptions?: Apollo.QueryHookOptions<GetPaIndoAllPaymentReminderQuery, GetPaIndoAllPaymentReminderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaIndoAllPaymentReminderQuery, GetPaIndoAllPaymentReminderQueryVariables>(GetPaIndoAllPaymentReminderDocument, options);
      }
export function useGetPaIndoAllPaymentReminderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaIndoAllPaymentReminderQuery, GetPaIndoAllPaymentReminderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaIndoAllPaymentReminderQuery, GetPaIndoAllPaymentReminderQueryVariables>(GetPaIndoAllPaymentReminderDocument, options);
        }
export type GetPaIndoAllPaymentReminderQueryHookResult = ReturnType<typeof useGetPaIndoAllPaymentReminderQuery>;
export type GetPaIndoAllPaymentReminderLazyQueryHookResult = ReturnType<typeof useGetPaIndoAllPaymentReminderLazyQuery>;
export type GetPaIndoAllPaymentReminderQueryResult = Apollo.QueryResult<GetPaIndoAllPaymentReminderQuery, GetPaIndoAllPaymentReminderQueryVariables>;
export const GetPurchaserInstallmentListingDocument = gql`
    query getPurchaserInstallmentListing($projectId: String!) {
  getPurchaserInstallmentListing(projectId: $projectId) {
    saleId
    fullName
    clusterName
    unitNo
    totalDocAmt
    totalUnallocatedAmt
    salesRegistrationDate
    salesNo
    salesRegistrationNo
  }
}
    `;

/**
 * __useGetPurchaserInstallmentListingQuery__
 *
 * To run a query within a React component, call `useGetPurchaserInstallmentListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPurchaserInstallmentListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPurchaserInstallmentListingQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetPurchaserInstallmentListingQuery(baseOptions: Apollo.QueryHookOptions<GetPurchaserInstallmentListingQuery, GetPurchaserInstallmentListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPurchaserInstallmentListingQuery, GetPurchaserInstallmentListingQueryVariables>(GetPurchaserInstallmentListingDocument, options);
      }
export function useGetPurchaserInstallmentListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPurchaserInstallmentListingQuery, GetPurchaserInstallmentListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPurchaserInstallmentListingQuery, GetPurchaserInstallmentListingQueryVariables>(GetPurchaserInstallmentListingDocument, options);
        }
export type GetPurchaserInstallmentListingQueryHookResult = ReturnType<typeof useGetPurchaserInstallmentListingQuery>;
export type GetPurchaserInstallmentListingLazyQueryHookResult = ReturnType<typeof useGetPurchaserInstallmentListingLazyQuery>;
export type GetPurchaserInstallmentListingQueryResult = Apollo.QueryResult<GetPurchaserInstallmentListingQuery, GetPurchaserInstallmentListingQueryVariables>;
export const GetPurchaserInstallmentDocument = gql`
    query getPurchaserInstallment($projectId: String!, $saleId: String!) {
  getPurchaserInstallment(projectId: $projectId, saleId: $saleId) {
    id
    saleId
    transDate
    documentDate
    documentAmt
    billType
    unallocatedAmount
    description
    sale {
      saleExtension {
        creditTerm
      }
    }
  }
}
    `;

/**
 * __useGetPurchaserInstallmentQuery__
 *
 * To run a query within a React component, call `useGetPurchaserInstallmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPurchaserInstallmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPurchaserInstallmentQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetPurchaserInstallmentQuery(baseOptions: Apollo.QueryHookOptions<GetPurchaserInstallmentQuery, GetPurchaserInstallmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPurchaserInstallmentQuery, GetPurchaserInstallmentQueryVariables>(GetPurchaserInstallmentDocument, options);
      }
export function useGetPurchaserInstallmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPurchaserInstallmentQuery, GetPurchaserInstallmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPurchaserInstallmentQuery, GetPurchaserInstallmentQueryVariables>(GetPurchaserInstallmentDocument, options);
        }
export type GetPurchaserInstallmentQueryHookResult = ReturnType<typeof useGetPurchaserInstallmentQuery>;
export type GetPurchaserInstallmentLazyQueryHookResult = ReturnType<typeof useGetPurchaserInstallmentLazyQuery>;
export type GetPurchaserInstallmentQueryResult = Apollo.QueryResult<GetPurchaserInstallmentQuery, GetPurchaserInstallmentQueryVariables>;
export const GetPaIndoRebateByIdDocument = gql`
    query getPAIndoRebateById($projectId: String!, $id: String!) {
  getPAIndoRebateById(projectId: $projectId, id: $id) {
    saleId
    approvedBy
    approvedDate
    billItemId
    description
    documentAmount
    documentDate
    documentNo
    documentRef
    status
    submittedDate
    unallocatedAmount
    voidDate
    attachment {
      allowDelete
      fileName
      id
      isPrivate
      mediaType
      resourceUrl
    }
    billItemInt {
      billItemType
      id
      name
    }
    requestUserData {
      ID
      name
    }
    submitUserData {
      ID
      name
    }
    approveUserData {
      ID
      name
    }
    voidUserData {
      ID
      name
    }
    taxData {
      taxSchemeId
      taxSchemeName
      effectiveDate
      taxSchemeDetailId
      totalTaxRate
      totalTaxAmount
      isExclusive
    }
    projectDetail {
      name
    }
    taxLedger {
      taxAmount
    }
    unitDetail
    contactDetail
    submitUserData {
      userName
    }
    approveUserData {
      userName
    }
    clusterName {
      name
    }
  }
}
    `;

/**
 * __useGetPaIndoRebateByIdQuery__
 *
 * To run a query within a React component, call `useGetPaIndoRebateByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaIndoRebateByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaIndoRebateByIdQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPaIndoRebateByIdQuery(baseOptions: Apollo.QueryHookOptions<GetPaIndoRebateByIdQuery, GetPaIndoRebateByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaIndoRebateByIdQuery, GetPaIndoRebateByIdQueryVariables>(GetPaIndoRebateByIdDocument, options);
      }
export function useGetPaIndoRebateByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaIndoRebateByIdQuery, GetPaIndoRebateByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaIndoRebateByIdQuery, GetPaIndoRebateByIdQueryVariables>(GetPaIndoRebateByIdDocument, options);
        }
export type GetPaIndoRebateByIdQueryHookResult = ReturnType<typeof useGetPaIndoRebateByIdQuery>;
export type GetPaIndoRebateByIdLazyQueryHookResult = ReturnType<typeof useGetPaIndoRebateByIdLazyQuery>;
export type GetPaIndoRebateByIdQueryResult = Apollo.QueryResult<GetPaIndoRebateByIdQuery, GetPaIndoRebateByIdQueryVariables>;
export const GetPaIndoRefundByIdDocument = gql`
    query getPAIndoRefundById($projectId: String!, $id: String!) {
  getPAIndoRefundById(projectId: $projectId, id: $id) {
    saleId
    approvedBy
    approvedDate
    description
    documentAmount
    documentDate
    documentNo
    documentRef
    status
    submittedDate
    unallocatedAmount
    refundMethod
    chequeDate
    chequeExpireDate
    creditCardType
    bankAccountId
    attachment {
      allowDelete
      fileName
      id
      isPrivate
      mediaType
      resourceUrl
    }
    submitUserData {
      ID
      name
    }
    approveUserData {
      ID
      name
    }
    taxData {
      taxSchemeId
      taxSchemeName
      effectiveDate
      taxSchemeDetailId
      totalTaxRate
    }
    projectDetail {
      name
    }
    taxLedger {
      taxAmount
    }
    bankAccount {
      id
      code
      accountNo
      bankProfile {
        name
      }
    }
    unitDetail
    contactDetail
    clusterName {
      name
    }
  }
}
    `;

/**
 * __useGetPaIndoRefundByIdQuery__
 *
 * To run a query within a React component, call `useGetPaIndoRefundByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaIndoRefundByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaIndoRefundByIdQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPaIndoRefundByIdQuery(baseOptions: Apollo.QueryHookOptions<GetPaIndoRefundByIdQuery, GetPaIndoRefundByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaIndoRefundByIdQuery, GetPaIndoRefundByIdQueryVariables>(GetPaIndoRefundByIdDocument, options);
      }
export function useGetPaIndoRefundByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaIndoRefundByIdQuery, GetPaIndoRefundByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaIndoRefundByIdQuery, GetPaIndoRefundByIdQueryVariables>(GetPaIndoRefundByIdDocument, options);
        }
export type GetPaIndoRefundByIdQueryHookResult = ReturnType<typeof useGetPaIndoRefundByIdQuery>;
export type GetPaIndoRefundByIdLazyQueryHookResult = ReturnType<typeof useGetPaIndoRefundByIdLazyQuery>;
export type GetPaIndoRefundByIdQueryResult = Apollo.QueryResult<GetPaIndoRefundByIdQuery, GetPaIndoRefundByIdQueryVariables>;
export const PostingRefundDocument = gql`
    mutation postingRefund($input: PostingInput!) {
  postingRefund(input: $input)
}
    `;
export type PostingRefundMutationFn = Apollo.MutationFunction<PostingRefundMutation, PostingRefundMutationVariables>;

/**
 * __usePostingRefundMutation__
 *
 * To run a mutation, you first call `usePostingRefundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostingRefundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postingRefundMutation, { data, loading, error }] = usePostingRefundMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePostingRefundMutation(baseOptions?: Apollo.MutationHookOptions<PostingRefundMutation, PostingRefundMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PostingRefundMutation, PostingRefundMutationVariables>(PostingRefundDocument, options);
      }
export type PostingRefundMutationHookResult = ReturnType<typeof usePostingRefundMutation>;
export type PostingRefundMutationResult = Apollo.MutationResult<PostingRefundMutation>;
export type PostingRefundMutationOptions = Apollo.BaseMutationOptions<PostingRefundMutation, PostingRefundMutationVariables>;
export const GetUnitListTransferDocument = gql`
    query getUnitListTransfer($projectId: String!, $unitTransferId: String) {
  getUnitListTransfer(projectId: $projectId, unitTransferId: $unitTransferId) {
    saleId
    unitId
    unitNo
    documentAmount
    documentNo
    miscBillingId
    oldContactId
    fullName
    email
    phoneNo
    icNo
  }
}
    `;

/**
 * __useGetUnitListTransferQuery__
 *
 * To run a query within a React component, call `useGetUnitListTransferQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitListTransferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitListTransferQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      unitTransferId: // value for 'unitTransferId'
 *   },
 * });
 */
export function useGetUnitListTransferQuery(baseOptions: Apollo.QueryHookOptions<GetUnitListTransferQuery, GetUnitListTransferQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitListTransferQuery, GetUnitListTransferQueryVariables>(GetUnitListTransferDocument, options);
      }
export function useGetUnitListTransferLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitListTransferQuery, GetUnitListTransferQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitListTransferQuery, GetUnitListTransferQueryVariables>(GetUnitListTransferDocument, options);
        }
export type GetUnitListTransferQueryHookResult = ReturnType<typeof useGetUnitListTransferQuery>;
export type GetUnitListTransferLazyQueryHookResult = ReturnType<typeof useGetUnitListTransferLazyQuery>;
export type GetUnitListTransferQueryResult = Apollo.QueryResult<GetUnitListTransferQuery, GetUnitListTransferQueryVariables>;
export const GetPurchaserTransferListDocument = gql`
    query getPurchaserTransferList($projectId: String!, $approvalStatus: String!) {
  getPurchaserTransferList(projectId: $projectId, approvalStatus: $approvalStatus) {
    id
    unitNo
    approvalStatus
    adminFee
    transferDate
    saleId
  }
}
    `;

/**
 * __useGetPurchaserTransferListQuery__
 *
 * To run a query within a React component, call `useGetPurchaserTransferListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPurchaserTransferListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPurchaserTransferListQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      approvalStatus: // value for 'approvalStatus'
 *   },
 * });
 */
export function useGetPurchaserTransferListQuery(baseOptions: Apollo.QueryHookOptions<GetPurchaserTransferListQuery, GetPurchaserTransferListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPurchaserTransferListQuery, GetPurchaserTransferListQueryVariables>(GetPurchaserTransferListDocument, options);
      }
export function useGetPurchaserTransferListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPurchaserTransferListQuery, GetPurchaserTransferListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPurchaserTransferListQuery, GetPurchaserTransferListQueryVariables>(GetPurchaserTransferListDocument, options);
        }
export type GetPurchaserTransferListQueryHookResult = ReturnType<typeof useGetPurchaserTransferListQuery>;
export type GetPurchaserTransferListLazyQueryHookResult = ReturnType<typeof useGetPurchaserTransferListLazyQuery>;
export type GetPurchaserTransferListQueryResult = Apollo.QueryResult<GetPurchaserTransferListQuery, GetPurchaserTransferListQueryVariables>;
export const GetPurchaserNameByIdDocument = gql`
    query getPurchaserNameById($projectId: String!, $saleId: String!, $purchaserNameTransferId: String!) {
  getPurchaserNameById(projectId: $projectId, saleId: $saleId, purchaserNameTransferId: $purchaserNameTransferId) {
    purchaserNameTransferId
    saleId
    unitId
    adminFee
    unitClusterId
    unitNo
    salesConvertedStatus
    status
    miscBillingId
    documentAmount
    documentNo
    oldContactId
    fullName
    email
    phoneNo
    icNo
    buyerList {
      IsPrincipalBuyer
      detailId
      email
      gender
      dateOfBirth
      incomeRange
      homeTelNo
      identityNo
      maritalStatus
      mobileNo
      name
      nationality
      officeTelNo
      profession
      religion
      salutation
      commonStatus
      address {
        address
        address2
        country
        city
        district
        subdistrict
        state
        postCode
        postCodeName
        AddressType
        isPrimary
      }
      addressList {
        isPrimary
        addressType
        address {
          address
          address2
          country
          city
          district
          subdistrict
          state
          postCode
          postCodeName
          AddressType
          isPrimary
        }
      }
      contactExt {
        IsVip
        contactExtId
        identityType
        mailingMethod
        remark
        subscribeMaterialEmail
        subscribeMaterialPaNews
        subscribeMaterialSms
        subscribeMaterialWhatsapp
      }
      tax {
        nameTax
        taxRegNo
        taxAddress
      }
    }
  }
}
    `;

/**
 * __useGetPurchaserNameByIdQuery__
 *
 * To run a query within a React component, call `useGetPurchaserNameByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPurchaserNameByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPurchaserNameByIdQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      saleId: // value for 'saleId'
 *      purchaserNameTransferId: // value for 'purchaserNameTransferId'
 *   },
 * });
 */
export function useGetPurchaserNameByIdQuery(baseOptions: Apollo.QueryHookOptions<GetPurchaserNameByIdQuery, GetPurchaserNameByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPurchaserNameByIdQuery, GetPurchaserNameByIdQueryVariables>(GetPurchaserNameByIdDocument, options);
      }
export function useGetPurchaserNameByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPurchaserNameByIdQuery, GetPurchaserNameByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPurchaserNameByIdQuery, GetPurchaserNameByIdQueryVariables>(GetPurchaserNameByIdDocument, options);
        }
export type GetPurchaserNameByIdQueryHookResult = ReturnType<typeof useGetPurchaserNameByIdQuery>;
export type GetPurchaserNameByIdLazyQueryHookResult = ReturnType<typeof useGetPurchaserNameByIdLazyQuery>;
export type GetPurchaserNameByIdQueryResult = Apollo.QueryResult<GetPurchaserNameByIdQuery, GetPurchaserNameByIdQueryVariables>;
export const GetBuyerListBySaleIdDocument = gql`
    query getBuyerListBySaleId($projectId: String!, $saleId: String!) {
  getBuyerListBySaleId(saleId: $saleId, projectId: $projectId) {
    IsPrincipalBuyer
    detailId
    email
    gender
    homeTelNo
    identityNo
    maritalStatus
    mobileNo
    name
    nationality
    officeTelNo
    profession
    religion
    salutation
    commonStatus
    address {
      address
      address2
      country
      city
      district
      subdistrict
      state
      postCode
      postCodeName
      AddressType
      isPrimary
    }
    addressList {
      isPrimary
      addressType
      address {
        address
        address2
        country
        city
        district
        subdistrict
        state
        postCode
        postCodeName
        AddressType
        isPrimary
      }
    }
    contactExt {
      IsVip
      contactExtId
      identityType
      mailingMethod
      remark
      subscribeMaterialEmail
      subscribeMaterialPaNews
      subscribeMaterialSms
      subscribeMaterialWhatsapp
    }
    tax {
      nameTax
      taxRegNo
      taxAddress
    }
  }
}
    `;

/**
 * __useGetBuyerListBySaleIdQuery__
 *
 * To run a query within a React component, call `useGetBuyerListBySaleIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBuyerListBySaleIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBuyerListBySaleIdQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetBuyerListBySaleIdQuery(baseOptions: Apollo.QueryHookOptions<GetBuyerListBySaleIdQuery, GetBuyerListBySaleIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBuyerListBySaleIdQuery, GetBuyerListBySaleIdQueryVariables>(GetBuyerListBySaleIdDocument, options);
      }
export function useGetBuyerListBySaleIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBuyerListBySaleIdQuery, GetBuyerListBySaleIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBuyerListBySaleIdQuery, GetBuyerListBySaleIdQueryVariables>(GetBuyerListBySaleIdDocument, options);
        }
export type GetBuyerListBySaleIdQueryHookResult = ReturnType<typeof useGetBuyerListBySaleIdQuery>;
export type GetBuyerListBySaleIdLazyQueryHookResult = ReturnType<typeof useGetBuyerListBySaleIdLazyQuery>;
export type GetBuyerListBySaleIdQueryResult = Apollo.QueryResult<GetBuyerListBySaleIdQuery, GetBuyerListBySaleIdQueryVariables>;
export const SaveDraftPurchaserTransferDocument = gql`
    mutation saveDraftPurchaserTransfer($input: addPurchaserTransferInput!) {
  saveDraftPurchaserTransfer(input: $input)
}
    `;
export type SaveDraftPurchaserTransferMutationFn = Apollo.MutationFunction<SaveDraftPurchaserTransferMutation, SaveDraftPurchaserTransferMutationVariables>;

/**
 * __useSaveDraftPurchaserTransferMutation__
 *
 * To run a mutation, you first call `useSaveDraftPurchaserTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveDraftPurchaserTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveDraftPurchaserTransferMutation, { data, loading, error }] = useSaveDraftPurchaserTransferMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveDraftPurchaserTransferMutation(baseOptions?: Apollo.MutationHookOptions<SaveDraftPurchaserTransferMutation, SaveDraftPurchaserTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveDraftPurchaserTransferMutation, SaveDraftPurchaserTransferMutationVariables>(SaveDraftPurchaserTransferDocument, options);
      }
export type SaveDraftPurchaserTransferMutationHookResult = ReturnType<typeof useSaveDraftPurchaserTransferMutation>;
export type SaveDraftPurchaserTransferMutationResult = Apollo.MutationResult<SaveDraftPurchaserTransferMutation>;
export type SaveDraftPurchaserTransferMutationOptions = Apollo.BaseMutationOptions<SaveDraftPurchaserTransferMutation, SaveDraftPurchaserTransferMutationVariables>;
export const ApprovedPurchaserTransferDocument = gql`
    mutation approvedPurchaserTransfer($input: addPurchaserTransferInput!) {
  approvedPurchaserTransfer(input: $input)
}
    `;
export type ApprovedPurchaserTransferMutationFn = Apollo.MutationFunction<ApprovedPurchaserTransferMutation, ApprovedPurchaserTransferMutationVariables>;

/**
 * __useApprovedPurchaserTransferMutation__
 *
 * To run a mutation, you first call `useApprovedPurchaserTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApprovedPurchaserTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approvedPurchaserTransferMutation, { data, loading, error }] = useApprovedPurchaserTransferMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApprovedPurchaserTransferMutation(baseOptions?: Apollo.MutationHookOptions<ApprovedPurchaserTransferMutation, ApprovedPurchaserTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApprovedPurchaserTransferMutation, ApprovedPurchaserTransferMutationVariables>(ApprovedPurchaserTransferDocument, options);
      }
export type ApprovedPurchaserTransferMutationHookResult = ReturnType<typeof useApprovedPurchaserTransferMutation>;
export type ApprovedPurchaserTransferMutationResult = Apollo.MutationResult<ApprovedPurchaserTransferMutation>;
export type ApprovedPurchaserTransferMutationOptions = Apollo.BaseMutationOptions<ApprovedPurchaserTransferMutation, ApprovedPurchaserTransferMutationVariables>;
export const ApprovedPurchaserTransferInListingDocument = gql`
    mutation approvedPurchaserTransferInListing($input: approvedPurchaserInListingInput!) {
  approvedPurchaserTransferInListing(input: $input)
}
    `;
export type ApprovedPurchaserTransferInListingMutationFn = Apollo.MutationFunction<ApprovedPurchaserTransferInListingMutation, ApprovedPurchaserTransferInListingMutationVariables>;

/**
 * __useApprovedPurchaserTransferInListingMutation__
 *
 * To run a mutation, you first call `useApprovedPurchaserTransferInListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApprovedPurchaserTransferInListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approvedPurchaserTransferInListingMutation, { data, loading, error }] = useApprovedPurchaserTransferInListingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApprovedPurchaserTransferInListingMutation(baseOptions?: Apollo.MutationHookOptions<ApprovedPurchaserTransferInListingMutation, ApprovedPurchaserTransferInListingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApprovedPurchaserTransferInListingMutation, ApprovedPurchaserTransferInListingMutationVariables>(ApprovedPurchaserTransferInListingDocument, options);
      }
export type ApprovedPurchaserTransferInListingMutationHookResult = ReturnType<typeof useApprovedPurchaserTransferInListingMutation>;
export type ApprovedPurchaserTransferInListingMutationResult = Apollo.MutationResult<ApprovedPurchaserTransferInListingMutation>;
export type ApprovedPurchaserTransferInListingMutationOptions = Apollo.BaseMutationOptions<ApprovedPurchaserTransferInListingMutation, ApprovedPurchaserTransferInListingMutationVariables>;
export const CancelPurchaserTransferDocument = gql`
    mutation cancelPurchaserTransfer($input: cancelPurchaserTransferInput!) {
  cancelPurchaserTransfer(input: $input)
}
    `;
export type CancelPurchaserTransferMutationFn = Apollo.MutationFunction<CancelPurchaserTransferMutation, CancelPurchaserTransferMutationVariables>;

/**
 * __useCancelPurchaserTransferMutation__
 *
 * To run a mutation, you first call `useCancelPurchaserTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelPurchaserTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelPurchaserTransferMutation, { data, loading, error }] = useCancelPurchaserTransferMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelPurchaserTransferMutation(baseOptions?: Apollo.MutationHookOptions<CancelPurchaserTransferMutation, CancelPurchaserTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelPurchaserTransferMutation, CancelPurchaserTransferMutationVariables>(CancelPurchaserTransferDocument, options);
      }
export type CancelPurchaserTransferMutationHookResult = ReturnType<typeof useCancelPurchaserTransferMutation>;
export type CancelPurchaserTransferMutationResult = Apollo.MutationResult<CancelPurchaserTransferMutation>;
export type CancelPurchaserTransferMutationOptions = Apollo.BaseMutationOptions<CancelPurchaserTransferMutation, CancelPurchaserTransferMutationVariables>;
export const GetSalesLoanRefinancingListDocument = gql`
    query getSalesLoanRefinancingList($approvalStatus: String!, $projectId: String!) {
  getSalesLoanRefinancingList(approvalStatus: $approvalStatus, projectId: $projectId) {
    id
    projectId
    approvalStatus
    unitNo
    fullName
    newFinancier
    refinancingDate
    oldFinancier
    refinancingNo
  }
}
    `;

/**
 * __useGetSalesLoanRefinancingListQuery__
 *
 * To run a query within a React component, call `useGetSalesLoanRefinancingListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesLoanRefinancingListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesLoanRefinancingListQuery({
 *   variables: {
 *      approvalStatus: // value for 'approvalStatus'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetSalesLoanRefinancingListQuery(baseOptions: Apollo.QueryHookOptions<GetSalesLoanRefinancingListQuery, GetSalesLoanRefinancingListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesLoanRefinancingListQuery, GetSalesLoanRefinancingListQueryVariables>(GetSalesLoanRefinancingListDocument, options);
      }
export function useGetSalesLoanRefinancingListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesLoanRefinancingListQuery, GetSalesLoanRefinancingListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesLoanRefinancingListQuery, GetSalesLoanRefinancingListQueryVariables>(GetSalesLoanRefinancingListDocument, options);
        }
export type GetSalesLoanRefinancingListQueryHookResult = ReturnType<typeof useGetSalesLoanRefinancingListQuery>;
export type GetSalesLoanRefinancingListLazyQueryHookResult = ReturnType<typeof useGetSalesLoanRefinancingListLazyQuery>;
export type GetSalesLoanRefinancingListQueryResult = Apollo.QueryResult<GetSalesLoanRefinancingListQuery, GetSalesLoanRefinancingListQueryVariables>;
export const GetRefinancingDetailsByIdDocument = gql`
    query getRefinancingDetailsById($id: String!) {
  getRefinancingDetailsById(id: $id) {
    id
    saleId
    projectId
    approvalStatus
    unitNo
    fullName
    newFinancier
    refinancingDate
    oldFinancier
    borrowerName
    mortgageName
    borrowerAcct
    remarks
    submittedBy
    submittedDate
    oldBalance {
      event_name
      old_balance
      net_balance
      endfin_mortgage_payment_id
      retentions
    }
    newPaymentPlan {
      event_item
      event_amt
      event_estimate_date
      endfin_mortgage_payment_id
      endfin_mortgage_retention_id
    }
    approvedBy
    approvedDate
    endfinancierMortgageId
    loanRefRecordId
    loanRefTable
    newFinancierId
    oldFinancierId
    refinancingNo
  }
}
    `;

/**
 * __useGetRefinancingDetailsByIdQuery__
 *
 * To run a query within a React component, call `useGetRefinancingDetailsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRefinancingDetailsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRefinancingDetailsByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRefinancingDetailsByIdQuery(baseOptions: Apollo.QueryHookOptions<GetRefinancingDetailsByIdQuery, GetRefinancingDetailsByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRefinancingDetailsByIdQuery, GetRefinancingDetailsByIdQueryVariables>(GetRefinancingDetailsByIdDocument, options);
      }
export function useGetRefinancingDetailsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRefinancingDetailsByIdQuery, GetRefinancingDetailsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRefinancingDetailsByIdQuery, GetRefinancingDetailsByIdQueryVariables>(GetRefinancingDetailsByIdDocument, options);
        }
export type GetRefinancingDetailsByIdQueryHookResult = ReturnType<typeof useGetRefinancingDetailsByIdQuery>;
export type GetRefinancingDetailsByIdLazyQueryHookResult = ReturnType<typeof useGetRefinancingDetailsByIdLazyQuery>;
export type GetRefinancingDetailsByIdQueryResult = Apollo.QueryResult<GetRefinancingDetailsByIdQuery, GetRefinancingDetailsByIdQueryVariables>;
export const ApproveRefinancingDocument = gql`
    mutation approveRefinancing($refinancingId: String!, $projectId: String!) {
  approveRefinancing(refinancingId: $refinancingId, projectId: $projectId)
}
    `;
export type ApproveRefinancingMutationFn = Apollo.MutationFunction<ApproveRefinancingMutation, ApproveRefinancingMutationVariables>;

/**
 * __useApproveRefinancingMutation__
 *
 * To run a mutation, you first call `useApproveRefinancingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveRefinancingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveRefinancingMutation, { data, loading, error }] = useApproveRefinancingMutation({
 *   variables: {
 *      refinancingId: // value for 'refinancingId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useApproveRefinancingMutation(baseOptions?: Apollo.MutationHookOptions<ApproveRefinancingMutation, ApproveRefinancingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveRefinancingMutation, ApproveRefinancingMutationVariables>(ApproveRefinancingDocument, options);
      }
export type ApproveRefinancingMutationHookResult = ReturnType<typeof useApproveRefinancingMutation>;
export type ApproveRefinancingMutationResult = Apollo.MutationResult<ApproveRefinancingMutation>;
export type ApproveRefinancingMutationOptions = Apollo.BaseMutationOptions<ApproveRefinancingMutation, ApproveRefinancingMutationVariables>;
export const GetRefinancingMasterDataDocument = gql`
    query getRefinancingMasterData {
  getRefinancingMasterData {
    unitList {
      sale_id
      unitNo
      borrower_name
      borrower_acct
      full_name
      name
      endfinancier_mortgage_plan_id
      loan_sign_date
      table_ref
      sale_loan_id
      old_balance
      saleLoanPayment {
        paymentId
        loanAmt
        netAmt
        saleLoanId
        endfinMortgagePaymentId
        paymentName
        constructionDate
        loanSignDate
        expectedCount
        expectedFreq
        expectedFrom
        saleLoanRetention {
          retentionId
          retentionName
          retentionValue
          saleLoanPaymentId
          endfinMortgageRetentionId
          constructionDate
          loanSignDate
          expectedCount
          expectedFreq
          expectedFrom
        }
      }
    }
    financierLists {
      newFinancierId
      financierName
    }
  }
}
    `;

/**
 * __useGetRefinancingMasterDataQuery__
 *
 * To run a query within a React component, call `useGetRefinancingMasterDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRefinancingMasterDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRefinancingMasterDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRefinancingMasterDataQuery(baseOptions?: Apollo.QueryHookOptions<GetRefinancingMasterDataQuery, GetRefinancingMasterDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRefinancingMasterDataQuery, GetRefinancingMasterDataQueryVariables>(GetRefinancingMasterDataDocument, options);
      }
export function useGetRefinancingMasterDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRefinancingMasterDataQuery, GetRefinancingMasterDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRefinancingMasterDataQuery, GetRefinancingMasterDataQueryVariables>(GetRefinancingMasterDataDocument, options);
        }
export type GetRefinancingMasterDataQueryHookResult = ReturnType<typeof useGetRefinancingMasterDataQuery>;
export type GetRefinancingMasterDataLazyQueryHookResult = ReturnType<typeof useGetRefinancingMasterDataLazyQuery>;
export type GetRefinancingMasterDataQueryResult = Apollo.QueryResult<GetRefinancingMasterDataQuery, GetRefinancingMasterDataQueryVariables>;
export const GetMortgageDataDocument = gql`
    query getMortgageData($newFinancierId: String!, $prevMortgageId: String!) {
  getMortgageData(newFinancierId: $newFinancierId, prevMortgageId: $prevMortgageId) {
    id
    financierId
    name
  }
}
    `;

/**
 * __useGetMortgageDataQuery__
 *
 * To run a query within a React component, call `useGetMortgageDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMortgageDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMortgageDataQuery({
 *   variables: {
 *      newFinancierId: // value for 'newFinancierId'
 *      prevMortgageId: // value for 'prevMortgageId'
 *   },
 * });
 */
export function useGetMortgageDataQuery(baseOptions: Apollo.QueryHookOptions<GetMortgageDataQuery, GetMortgageDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMortgageDataQuery, GetMortgageDataQueryVariables>(GetMortgageDataDocument, options);
      }
export function useGetMortgageDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMortgageDataQuery, GetMortgageDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMortgageDataQuery, GetMortgageDataQueryVariables>(GetMortgageDataDocument, options);
        }
export type GetMortgageDataQueryHookResult = ReturnType<typeof useGetMortgageDataQuery>;
export type GetMortgageDataLazyQueryHookResult = ReturnType<typeof useGetMortgageDataLazyQuery>;
export type GetMortgageDataQueryResult = Apollo.QueryResult<GetMortgageDataQuery, GetMortgageDataQueryVariables>;
export const GetPaymentPlanDocument = gql`
    query getPaymentPlan($mortgageId: String!) {
  getPaymentPlan(mortgageId: $mortgageId) {
    id
    endfinMortgagePaymentId
    name
    eventItem
  }
}
    `;

/**
 * __useGetPaymentPlanQuery__
 *
 * To run a query within a React component, call `useGetPaymentPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentPlanQuery({
 *   variables: {
 *      mortgageId: // value for 'mortgageId'
 *   },
 * });
 */
export function useGetPaymentPlanQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentPlanQuery, GetPaymentPlanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentPlanQuery, GetPaymentPlanQueryVariables>(GetPaymentPlanDocument, options);
      }
export function useGetPaymentPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentPlanQuery, GetPaymentPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentPlanQuery, GetPaymentPlanQueryVariables>(GetPaymentPlanDocument, options);
        }
export type GetPaymentPlanQueryHookResult = ReturnType<typeof useGetPaymentPlanQuery>;
export type GetPaymentPlanLazyQueryHookResult = ReturnType<typeof useGetPaymentPlanLazyQuery>;
export type GetPaymentPlanQueryResult = Apollo.QueryResult<GetPaymentPlanQuery, GetPaymentPlanQueryVariables>;
export const GetNewPaymentPlanDocument = gql`
    query getNewPaymentPlan($mortgageId: String!) {
  getNewPaymentPlan(mortgageId: $mortgageId) {
    id
    endfinMortgagePaymentId
    endfinMortgageRetentionId
    name
    eventItem
  }
}
    `;

/**
 * __useGetNewPaymentPlanQuery__
 *
 * To run a query within a React component, call `useGetNewPaymentPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewPaymentPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewPaymentPlanQuery({
 *   variables: {
 *      mortgageId: // value for 'mortgageId'
 *   },
 * });
 */
export function useGetNewPaymentPlanQuery(baseOptions: Apollo.QueryHookOptions<GetNewPaymentPlanQuery, GetNewPaymentPlanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNewPaymentPlanQuery, GetNewPaymentPlanQueryVariables>(GetNewPaymentPlanDocument, options);
      }
export function useGetNewPaymentPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNewPaymentPlanQuery, GetNewPaymentPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNewPaymentPlanQuery, GetNewPaymentPlanQueryVariables>(GetNewPaymentPlanDocument, options);
        }
export type GetNewPaymentPlanQueryHookResult = ReturnType<typeof useGetNewPaymentPlanQuery>;
export type GetNewPaymentPlanLazyQueryHookResult = ReturnType<typeof useGetNewPaymentPlanLazyQuery>;
export type GetNewPaymentPlanQueryResult = Apollo.QueryResult<GetNewPaymentPlanQuery, GetNewPaymentPlanQueryVariables>;
export const AddSaleLoanRefinancingDocument = gql`
    mutation addSaleLoanRefinancing($input: addSaleLoanRefinancingInput!) {
  addSaleLoanRefinancing(input: $input)
}
    `;
export type AddSaleLoanRefinancingMutationFn = Apollo.MutationFunction<AddSaleLoanRefinancingMutation, AddSaleLoanRefinancingMutationVariables>;

/**
 * __useAddSaleLoanRefinancingMutation__
 *
 * To run a mutation, you first call `useAddSaleLoanRefinancingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSaleLoanRefinancingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSaleLoanRefinancingMutation, { data, loading, error }] = useAddSaleLoanRefinancingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddSaleLoanRefinancingMutation(baseOptions?: Apollo.MutationHookOptions<AddSaleLoanRefinancingMutation, AddSaleLoanRefinancingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSaleLoanRefinancingMutation, AddSaleLoanRefinancingMutationVariables>(AddSaleLoanRefinancingDocument, options);
      }
export type AddSaleLoanRefinancingMutationHookResult = ReturnType<typeof useAddSaleLoanRefinancingMutation>;
export type AddSaleLoanRefinancingMutationResult = Apollo.MutationResult<AddSaleLoanRefinancingMutation>;
export type AddSaleLoanRefinancingMutationOptions = Apollo.BaseMutationOptions<AddSaleLoanRefinancingMutation, AddSaleLoanRefinancingMutationVariables>;
export const EditSaleLoanRefinancingDocument = gql`
    mutation editSaleLoanRefinancing($input: editSaleLoanRefinancingInput!) {
  editSaleLoanRefinancing(input: $input)
}
    `;
export type EditSaleLoanRefinancingMutationFn = Apollo.MutationFunction<EditSaleLoanRefinancingMutation, EditSaleLoanRefinancingMutationVariables>;

/**
 * __useEditSaleLoanRefinancingMutation__
 *
 * To run a mutation, you first call `useEditSaleLoanRefinancingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSaleLoanRefinancingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSaleLoanRefinancingMutation, { data, loading, error }] = useEditSaleLoanRefinancingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditSaleLoanRefinancingMutation(baseOptions?: Apollo.MutationHookOptions<EditSaleLoanRefinancingMutation, EditSaleLoanRefinancingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditSaleLoanRefinancingMutation, EditSaleLoanRefinancingMutationVariables>(EditSaleLoanRefinancingDocument, options);
      }
export type EditSaleLoanRefinancingMutationHookResult = ReturnType<typeof useEditSaleLoanRefinancingMutation>;
export type EditSaleLoanRefinancingMutationResult = Apollo.MutationResult<EditSaleLoanRefinancingMutation>;
export type EditSaleLoanRefinancingMutationOptions = Apollo.BaseMutationOptions<EditSaleLoanRefinancingMutation, EditSaleLoanRefinancingMutationVariables>;
export const DeleteSaleLoanRefinancingDocument = gql`
    mutation deleteSaleLoanRefinancing($refinancingId: String!) {
  deleteSaleLoanRefinancing(refinancingId: $refinancingId)
}
    `;
export type DeleteSaleLoanRefinancingMutationFn = Apollo.MutationFunction<DeleteSaleLoanRefinancingMutation, DeleteSaleLoanRefinancingMutationVariables>;

/**
 * __useDeleteSaleLoanRefinancingMutation__
 *
 * To run a mutation, you first call `useDeleteSaleLoanRefinancingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSaleLoanRefinancingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSaleLoanRefinancingMutation, { data, loading, error }] = useDeleteSaleLoanRefinancingMutation({
 *   variables: {
 *      refinancingId: // value for 'refinancingId'
 *   },
 * });
 */
export function useDeleteSaleLoanRefinancingMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSaleLoanRefinancingMutation, DeleteSaleLoanRefinancingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSaleLoanRefinancingMutation, DeleteSaleLoanRefinancingMutationVariables>(DeleteSaleLoanRefinancingDocument, options);
      }
export type DeleteSaleLoanRefinancingMutationHookResult = ReturnType<typeof useDeleteSaleLoanRefinancingMutation>;
export type DeleteSaleLoanRefinancingMutationResult = Apollo.MutationResult<DeleteSaleLoanRefinancingMutation>;
export type DeleteSaleLoanRefinancingMutationOptions = Apollo.BaseMutationOptions<DeleteSaleLoanRefinancingMutation, DeleteSaleLoanRefinancingMutationVariables>;
export const GetSaleRefinancingCountDocument = gql`
    query getSaleRefinancingCount($projectId: String!) {
  getSaleRefinancingCount(projectId: $projectId) {
    draftCount
    submittedCount
    approvedCount
  }
}
    `;

/**
 * __useGetSaleRefinancingCountQuery__
 *
 * To run a query within a React component, call `useGetSaleRefinancingCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSaleRefinancingCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSaleRefinancingCountQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetSaleRefinancingCountQuery(baseOptions: Apollo.QueryHookOptions<GetSaleRefinancingCountQuery, GetSaleRefinancingCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSaleRefinancingCountQuery, GetSaleRefinancingCountQueryVariables>(GetSaleRefinancingCountDocument, options);
      }
export function useGetSaleRefinancingCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSaleRefinancingCountQuery, GetSaleRefinancingCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSaleRefinancingCountQuery, GetSaleRefinancingCountQueryVariables>(GetSaleRefinancingCountDocument, options);
        }
export type GetSaleRefinancingCountQueryHookResult = ReturnType<typeof useGetSaleRefinancingCountQuery>;
export type GetSaleRefinancingCountLazyQueryHookResult = ReturnType<typeof useGetSaleRefinancingCountLazyQuery>;
export type GetSaleRefinancingCountQueryResult = Apollo.QueryResult<GetSaleRefinancingCountQuery, GetSaleRefinancingCountQueryVariables>;
export const GetRoundingDocument = gql`
    query getRounding {
  getRounding {
    roundingMode {
      id
      name
    }
    roundingPrecision {
      id
      name
    }
  }
}
    `;

/**
 * __useGetRoundingQuery__
 *
 * To run a query within a React component, call `useGetRoundingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoundingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoundingQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRoundingQuery(baseOptions?: Apollo.QueryHookOptions<GetRoundingQuery, GetRoundingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoundingQuery, GetRoundingQueryVariables>(GetRoundingDocument, options);
      }
export function useGetRoundingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoundingQuery, GetRoundingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoundingQuery, GetRoundingQueryVariables>(GetRoundingDocument, options);
        }
export type GetRoundingQueryHookResult = ReturnType<typeof useGetRoundingQuery>;
export type GetRoundingLazyQueryHookResult = ReturnType<typeof useGetRoundingLazyQuery>;
export type GetRoundingQueryResult = Apollo.QueryResult<GetRoundingQuery, GetRoundingQueryVariables>;
export const GetAllSpaReminderDocument = gql`
    query getAllSpaReminder {
  getAllSpaReminder {
    reminderDate
    reminder1
    reminder2
    reminder3
    generationBatch
    unitNo
  }
}
    `;

/**
 * __useGetAllSpaReminderQuery__
 *
 * To run a query within a React component, call `useGetAllSpaReminderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSpaReminderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllSpaReminderQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllSpaReminderQuery(baseOptions?: Apollo.QueryHookOptions<GetAllSpaReminderQuery, GetAllSpaReminderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllSpaReminderQuery, GetAllSpaReminderQueryVariables>(GetAllSpaReminderDocument, options);
      }
export function useGetAllSpaReminderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllSpaReminderQuery, GetAllSpaReminderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllSpaReminderQuery, GetAllSpaReminderQueryVariables>(GetAllSpaReminderDocument, options);
        }
export type GetAllSpaReminderQueryHookResult = ReturnType<typeof useGetAllSpaReminderQuery>;
export type GetAllSpaReminderLazyQueryHookResult = ReturnType<typeof useGetAllSpaReminderLazyQuery>;
export type GetAllSpaReminderQueryResult = Apollo.QueryResult<GetAllSpaReminderQuery, GetAllSpaReminderQueryVariables>;
export const GenerateReminderSaleListDocument = gql`
    mutation generateReminderSaleList($reminderDate: DateTime!) {
  generateReminderSaleList(reminderDate: $reminderDate) {
    reminder1
    reminder2
    reminder3
    reminderDetailList {
      reminderId
      saleId
      isCompany
      companyName
      unitNo
      bookDate
      reminderSeq
      reminderDate
      buyerName
      share {
        sharedBy
        sharedDateTime
        sharedMethod
      }
    }
  }
}
    `;
export type GenerateReminderSaleListMutationFn = Apollo.MutationFunction<GenerateReminderSaleListMutation, GenerateReminderSaleListMutationVariables>;

/**
 * __useGenerateReminderSaleListMutation__
 *
 * To run a mutation, you first call `useGenerateReminderSaleListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateReminderSaleListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateReminderSaleListMutation, { data, loading, error }] = useGenerateReminderSaleListMutation({
 *   variables: {
 *      reminderDate: // value for 'reminderDate'
 *   },
 * });
 */
export function useGenerateReminderSaleListMutation(baseOptions?: Apollo.MutationHookOptions<GenerateReminderSaleListMutation, GenerateReminderSaleListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateReminderSaleListMutation, GenerateReminderSaleListMutationVariables>(GenerateReminderSaleListDocument, options);
      }
export type GenerateReminderSaleListMutationHookResult = ReturnType<typeof useGenerateReminderSaleListMutation>;
export type GenerateReminderSaleListMutationResult = Apollo.MutationResult<GenerateReminderSaleListMutation>;
export type GenerateReminderSaleListMutationOptions = Apollo.BaseMutationOptions<GenerateReminderSaleListMutation, GenerateReminderSaleListMutationVariables>;
export const GetSpaReminderByIdDocument = gql`
    query getSpaReminderById($reminderDate: DateTime!, $generationBatch: String!) {
  getSpaReminderById(reminderDate: $reminderDate, generationBatch: $generationBatch) {
    reminder1
    reminder2
    reminder3
    reminderDetailList {
      reminderId
      saleId
      unitNo
      bookDate
      reminderSeq
      reminderDate
      buyerName
      isCompany
      companyName
      share {
        sharedBy
        sharedDateTime
        sharedMethod
      }
    }
  }
}
    `;

/**
 * __useGetSpaReminderByIdQuery__
 *
 * To run a query within a React component, call `useGetSpaReminderByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpaReminderByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpaReminderByIdQuery({
 *   variables: {
 *      reminderDate: // value for 'reminderDate'
 *      generationBatch: // value for 'generationBatch'
 *   },
 * });
 */
export function useGetSpaReminderByIdQuery(baseOptions: Apollo.QueryHookOptions<GetSpaReminderByIdQuery, GetSpaReminderByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpaReminderByIdQuery, GetSpaReminderByIdQueryVariables>(GetSpaReminderByIdDocument, options);
      }
export function useGetSpaReminderByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpaReminderByIdQuery, GetSpaReminderByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpaReminderByIdQuery, GetSpaReminderByIdQueryVariables>(GetSpaReminderByIdDocument, options);
        }
export type GetSpaReminderByIdQueryHookResult = ReturnType<typeof useGetSpaReminderByIdQuery>;
export type GetSpaReminderByIdLazyQueryHookResult = ReturnType<typeof useGetSpaReminderByIdLazyQuery>;
export type GetSpaReminderByIdQueryResult = Apollo.QueryResult<GetSpaReminderByIdQuery, GetSpaReminderByIdQueryVariables>;
export const ShareSpaReminderDocument = gql`
    mutation shareSpaReminder($input: reminderInput!) {
  shareSpaReminder(input: $input) {
    downloadFile
    isProject
    letterTemplateList {
      letterTemplateId
      letterTemplateName
    }
  }
}
    `;
export type ShareSpaReminderMutationFn = Apollo.MutationFunction<ShareSpaReminderMutation, ShareSpaReminderMutationVariables>;

/**
 * __useShareSpaReminderMutation__
 *
 * To run a mutation, you first call `useShareSpaReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareSpaReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareSpaReminderMutation, { data, loading, error }] = useShareSpaReminderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useShareSpaReminderMutation(baseOptions?: Apollo.MutationHookOptions<ShareSpaReminderMutation, ShareSpaReminderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShareSpaReminderMutation, ShareSpaReminderMutationVariables>(ShareSpaReminderDocument, options);
      }
export type ShareSpaReminderMutationHookResult = ReturnType<typeof useShareSpaReminderMutation>;
export type ShareSpaReminderMutationResult = Apollo.MutationResult<ShareSpaReminderMutation>;
export type ShareSpaReminderMutationOptions = Apollo.BaseMutationOptions<ShareSpaReminderMutation, ShareSpaReminderMutationVariables>;
export const ShareSpaReminderByLetterTemplateIdDocument = gql`
    mutation shareSpaReminderByLetterTemplateId($input: shareSpaReminderByIdInput!) {
  shareSpaReminderByLetterTemplateId(input: $input)
}
    `;
export type ShareSpaReminderByLetterTemplateIdMutationFn = Apollo.MutationFunction<ShareSpaReminderByLetterTemplateIdMutation, ShareSpaReminderByLetterTemplateIdMutationVariables>;

/**
 * __useShareSpaReminderByLetterTemplateIdMutation__
 *
 * To run a mutation, you first call `useShareSpaReminderByLetterTemplateIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareSpaReminderByLetterTemplateIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareSpaReminderByLetterTemplateIdMutation, { data, loading, error }] = useShareSpaReminderByLetterTemplateIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useShareSpaReminderByLetterTemplateIdMutation(baseOptions?: Apollo.MutationHookOptions<ShareSpaReminderByLetterTemplateIdMutation, ShareSpaReminderByLetterTemplateIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShareSpaReminderByLetterTemplateIdMutation, ShareSpaReminderByLetterTemplateIdMutationVariables>(ShareSpaReminderByLetterTemplateIdDocument, options);
      }
export type ShareSpaReminderByLetterTemplateIdMutationHookResult = ReturnType<typeof useShareSpaReminderByLetterTemplateIdMutation>;
export type ShareSpaReminderByLetterTemplateIdMutationResult = Apollo.MutationResult<ShareSpaReminderByLetterTemplateIdMutation>;
export type ShareSpaReminderByLetterTemplateIdMutationOptions = Apollo.BaseMutationOptions<ShareSpaReminderByLetterTemplateIdMutation, ShareSpaReminderByLetterTemplateIdMutationVariables>;
export const GetSalesAdminSettingSummaryDocument = gql`
    query getSalesAdminSettingSummary {
  getProjectName
  saleContractSummary {
    totalBooked
    totalSigned
    totalCancelled
  }
  saleCancellationSummary {
    count
    totalForfeitureSum
  }
  spReminderCount
  downpaymentReminderCount
  unitTransferSummary {
    totalDraft
    totalSubmitted
  }
  bankLoanUnitCount
  bankLoanTotalAmount
  collectionSummary {
    totalDraft
    totalSubmitted
    totalApproved
  }
  purchaserAccountsCount
  stakeholderCount {
    totalAmt
    totalDeemCollected
    totalReleaseAmt
  }
  propertyTitleUnitCount
  totalPropertyTitleUnitCount
  unitsVpLetterCount
  areaVarianceSummaryIndonesia {
    count
    nettBuiltUp
    totalCompensate
  }
  areaVariancePolicyIndonesiaLastUpdate
  areaVarianceIndonesiaLastUpdate
  areaVarianceIndonesiaCount
  rescheduleInstallmentLastUpdate
  rescheduleInstallmentSubmittedCount
  ladSummary {
    totalCount
    totalUnitAmount
    totalFacilityAmount
    totalAmount
  }
  keyCollectionCount {
    totalCount
    totalCompletedCount
  }
  motTrackingCount
  totalMotUnitCount
  subsaleCount
  totalBridgingFinancing
  totalRedemption
  saleLandDepositSummary {
    showMenu
    outstandingCount
  }
}
    `;

/**
 * __useGetSalesAdminSettingSummaryQuery__
 *
 * To run a query within a React component, call `useGetSalesAdminSettingSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesAdminSettingSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesAdminSettingSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSalesAdminSettingSummaryQuery(baseOptions?: Apollo.QueryHookOptions<GetSalesAdminSettingSummaryQuery, GetSalesAdminSettingSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesAdminSettingSummaryQuery, GetSalesAdminSettingSummaryQueryVariables>(GetSalesAdminSettingSummaryDocument, options);
      }
export function useGetSalesAdminSettingSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesAdminSettingSummaryQuery, GetSalesAdminSettingSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesAdminSettingSummaryQuery, GetSalesAdminSettingSummaryQueryVariables>(GetSalesAdminSettingSummaryDocument, options);
        }
export type GetSalesAdminSettingSummaryQueryHookResult = ReturnType<typeof useGetSalesAdminSettingSummaryQuery>;
export type GetSalesAdminSettingSummaryLazyQueryHookResult = ReturnType<typeof useGetSalesAdminSettingSummaryLazyQuery>;
export type GetSalesAdminSettingSummaryQueryResult = Apollo.QueryResult<GetSalesAdminSettingSummaryQuery, GetSalesAdminSettingSummaryQueryVariables>;
export const GetAllProjectCountDocument = gql`
    query getAllProjectCount {
  getAllProjectCount
}
    `;

/**
 * __useGetAllProjectCountQuery__
 *
 * To run a query within a React component, call `useGetAllProjectCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllProjectCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllProjectCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllProjectCountQuery(baseOptions?: Apollo.QueryHookOptions<GetAllProjectCountQuery, GetAllProjectCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllProjectCountQuery, GetAllProjectCountQueryVariables>(GetAllProjectCountDocument, options);
      }
export function useGetAllProjectCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllProjectCountQuery, GetAllProjectCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllProjectCountQuery, GetAllProjectCountQueryVariables>(GetAllProjectCountDocument, options);
        }
export type GetAllProjectCountQueryHookResult = ReturnType<typeof useGetAllProjectCountQuery>;
export type GetAllProjectCountLazyQueryHookResult = ReturnType<typeof useGetAllProjectCountLazyQuery>;
export type GetAllProjectCountQueryResult = Apollo.QueryResult<GetAllProjectCountQuery, GetAllProjectCountQueryVariables>;
export const GetSalesCancellationListDocument = gql`
    query getSalesCancellationList {
  getSalesCancellationList {
    id
    cancellationDate
    status
    salesRegistrationNo
    clusterName
    unitId
    unitNo
    sellingPrice
    purchaserName
    cancellationReason
    salesNo
    refundAmt
    paidToDate
  }
  getSalesCancellationStatus
}
    `;

/**
 * __useGetSalesCancellationListQuery__
 *
 * To run a query within a React component, call `useGetSalesCancellationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesCancellationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesCancellationListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSalesCancellationListQuery(baseOptions?: Apollo.QueryHookOptions<GetSalesCancellationListQuery, GetSalesCancellationListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesCancellationListQuery, GetSalesCancellationListQueryVariables>(GetSalesCancellationListDocument, options);
      }
export function useGetSalesCancellationListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesCancellationListQuery, GetSalesCancellationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesCancellationListQuery, GetSalesCancellationListQueryVariables>(GetSalesCancellationListDocument, options);
        }
export type GetSalesCancellationListQueryHookResult = ReturnType<typeof useGetSalesCancellationListQuery>;
export type GetSalesCancellationListLazyQueryHookResult = ReturnType<typeof useGetSalesCancellationListLazyQuery>;
export type GetSalesCancellationListQueryResult = Apollo.QueryResult<GetSalesCancellationListQuery, GetSalesCancellationListQueryVariables>;
export const GetSalesCancellationByIdDocument = gql`
    query getSalesCancellationById($id: String!) {
  getSalesCancellationById(id: $id) {
    cancellationDate
    completedBy
    saleId
    status
    unitId
    unitNo
    sellingPrice
    bookDate
    contactId
    purchaserName
    forfeitureSum
    taxSchemeId
    cancellationReasonId
    cancellationReason
    remarks
    totalRefundableAmount
    taxToDate
    taxToDateAmount
    finalTaxToDate
    finalTaxToDateAmount
    refundAmt
    refundTax
    chargeFinalTax
    salesNo
    paidToDate
    buyBackAmount
  }
}
    `;

/**
 * __useGetSalesCancellationByIdQuery__
 *
 * To run a query within a React component, call `useGetSalesCancellationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesCancellationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesCancellationByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSalesCancellationByIdQuery(baseOptions: Apollo.QueryHookOptions<GetSalesCancellationByIdQuery, GetSalesCancellationByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesCancellationByIdQuery, GetSalesCancellationByIdQueryVariables>(GetSalesCancellationByIdDocument, options);
      }
export function useGetSalesCancellationByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesCancellationByIdQuery, GetSalesCancellationByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesCancellationByIdQuery, GetSalesCancellationByIdQueryVariables>(GetSalesCancellationByIdDocument, options);
        }
export type GetSalesCancellationByIdQueryHookResult = ReturnType<typeof useGetSalesCancellationByIdQuery>;
export type GetSalesCancellationByIdLazyQueryHookResult = ReturnType<typeof useGetSalesCancellationByIdLazyQuery>;
export type GetSalesCancellationByIdQueryResult = Apollo.QueryResult<GetSalesCancellationByIdQuery, GetSalesCancellationByIdQueryVariables>;
export const GetUnitsForSalesCancelDocument = gql`
    query getUnitsForSalesCancel {
  getUnitsForSalesCancel {
    saleId
    saleStatus
    bookDate
    unitId
    unitNo
    unitStatus
    contactId
    purchaserName
    isCompany
    companyName
    sellingPrice
    taxSchemeId
    totalRefundableAmount
    paidToDate
    taxToDate
    finalTaxToDate
    buyBackAmt
    salesRegistrationDate
  }
}
    `;

/**
 * __useGetUnitsForSalesCancelQuery__
 *
 * To run a query within a React component, call `useGetUnitsForSalesCancelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitsForSalesCancelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitsForSalesCancelQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUnitsForSalesCancelQuery(baseOptions?: Apollo.QueryHookOptions<GetUnitsForSalesCancelQuery, GetUnitsForSalesCancelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitsForSalesCancelQuery, GetUnitsForSalesCancelQueryVariables>(GetUnitsForSalesCancelDocument, options);
      }
export function useGetUnitsForSalesCancelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitsForSalesCancelQuery, GetUnitsForSalesCancelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitsForSalesCancelQuery, GetUnitsForSalesCancelQueryVariables>(GetUnitsForSalesCancelDocument, options);
        }
export type GetUnitsForSalesCancelQueryHookResult = ReturnType<typeof useGetUnitsForSalesCancelQuery>;
export type GetUnitsForSalesCancelLazyQueryHookResult = ReturnType<typeof useGetUnitsForSalesCancelLazyQuery>;
export type GetUnitsForSalesCancelQueryResult = Apollo.QueryResult<GetUnitsForSalesCancelQuery, GetUnitsForSalesCancelQueryVariables>;
export const GetUnitDetailDocument = gql`
    query getUnitDetail($unitId: String!) {
  GetUnitDetail(unitId: $unitId) {
    id
    unitNo
    unitStatus
    price
    builtUp
    landArea
  }
}
    `;

/**
 * __useGetUnitDetailQuery__
 *
 * To run a query within a React component, call `useGetUnitDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitDetailQuery({
 *   variables: {
 *      unitId: // value for 'unitId'
 *   },
 * });
 */
export function useGetUnitDetailQuery(baseOptions: Apollo.QueryHookOptions<GetUnitDetailQuery, GetUnitDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitDetailQuery, GetUnitDetailQueryVariables>(GetUnitDetailDocument, options);
      }
export function useGetUnitDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitDetailQuery, GetUnitDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitDetailQuery, GetUnitDetailQueryVariables>(GetUnitDetailDocument, options);
        }
export type GetUnitDetailQueryHookResult = ReturnType<typeof useGetUnitDetailQuery>;
export type GetUnitDetailLazyQueryHookResult = ReturnType<typeof useGetUnitDetailLazyQuery>;
export type GetUnitDetailQueryResult = Apollo.QueryResult<GetUnitDetailQuery, GetUnitDetailQueryVariables>;
export const AddSalesCancellationDocument = gql`
    mutation addSalesCancellation($input: AddSalesCancellationInput!) {
  addSalesCancellation(input: $input)
}
    `;
export type AddSalesCancellationMutationFn = Apollo.MutationFunction<AddSalesCancellationMutation, AddSalesCancellationMutationVariables>;

/**
 * __useAddSalesCancellationMutation__
 *
 * To run a mutation, you first call `useAddSalesCancellationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSalesCancellationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSalesCancellationMutation, { data, loading, error }] = useAddSalesCancellationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddSalesCancellationMutation(baseOptions?: Apollo.MutationHookOptions<AddSalesCancellationMutation, AddSalesCancellationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSalesCancellationMutation, AddSalesCancellationMutationVariables>(AddSalesCancellationDocument, options);
      }
export type AddSalesCancellationMutationHookResult = ReturnType<typeof useAddSalesCancellationMutation>;
export type AddSalesCancellationMutationResult = Apollo.MutationResult<AddSalesCancellationMutation>;
export type AddSalesCancellationMutationOptions = Apollo.BaseMutationOptions<AddSalesCancellationMutation, AddSalesCancellationMutationVariables>;
export const EditSalesCancellationDocument = gql`
    mutation editSalesCancellation($input: EditSalesCancellationInput!) {
  editSalesCancellation(input: $input)
}
    `;
export type EditSalesCancellationMutationFn = Apollo.MutationFunction<EditSalesCancellationMutation, EditSalesCancellationMutationVariables>;

/**
 * __useEditSalesCancellationMutation__
 *
 * To run a mutation, you first call `useEditSalesCancellationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSalesCancellationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSalesCancellationMutation, { data, loading, error }] = useEditSalesCancellationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditSalesCancellationMutation(baseOptions?: Apollo.MutationHookOptions<EditSalesCancellationMutation, EditSalesCancellationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditSalesCancellationMutation, EditSalesCancellationMutationVariables>(EditSalesCancellationDocument, options);
      }
export type EditSalesCancellationMutationHookResult = ReturnType<typeof useEditSalesCancellationMutation>;
export type EditSalesCancellationMutationResult = Apollo.MutationResult<EditSalesCancellationMutation>;
export type EditSalesCancellationMutationOptions = Apollo.BaseMutationOptions<EditSalesCancellationMutation, EditSalesCancellationMutationVariables>;
export const DeleteSalesCancellationDocument = gql`
    mutation deleteSalesCancellation($id: String!) {
  deleteSalesCancellation(id: $id)
}
    `;
export type DeleteSalesCancellationMutationFn = Apollo.MutationFunction<DeleteSalesCancellationMutation, DeleteSalesCancellationMutationVariables>;

/**
 * __useDeleteSalesCancellationMutation__
 *
 * To run a mutation, you first call `useDeleteSalesCancellationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSalesCancellationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSalesCancellationMutation, { data, loading, error }] = useDeleteSalesCancellationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSalesCancellationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSalesCancellationMutation, DeleteSalesCancellationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSalesCancellationMutation, DeleteSalesCancellationMutationVariables>(DeleteSalesCancellationDocument, options);
      }
export type DeleteSalesCancellationMutationHookResult = ReturnType<typeof useDeleteSalesCancellationMutation>;
export type DeleteSalesCancellationMutationResult = Apollo.MutationResult<DeleteSalesCancellationMutation>;
export type DeleteSalesCancellationMutationOptions = Apollo.BaseMutationOptions<DeleteSalesCancellationMutation, DeleteSalesCancellationMutationVariables>;
export const UpdateSalesCancellationStatusDocument = gql`
    mutation updateSalesCancellationStatus($input: UpdateStatusCancellationInput!) {
  updateSalesCancellationStatus(input: $input)
}
    `;
export type UpdateSalesCancellationStatusMutationFn = Apollo.MutationFunction<UpdateSalesCancellationStatusMutation, UpdateSalesCancellationStatusMutationVariables>;

/**
 * __useUpdateSalesCancellationStatusMutation__
 *
 * To run a mutation, you first call `useUpdateSalesCancellationStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSalesCancellationStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSalesCancellationStatusMutation, { data, loading, error }] = useUpdateSalesCancellationStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSalesCancellationStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSalesCancellationStatusMutation, UpdateSalesCancellationStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSalesCancellationStatusMutation, UpdateSalesCancellationStatusMutationVariables>(UpdateSalesCancellationStatusDocument, options);
      }
export type UpdateSalesCancellationStatusMutationHookResult = ReturnType<typeof useUpdateSalesCancellationStatusMutation>;
export type UpdateSalesCancellationStatusMutationResult = Apollo.MutationResult<UpdateSalesCancellationStatusMutation>;
export type UpdateSalesCancellationStatusMutationOptions = Apollo.BaseMutationOptions<UpdateSalesCancellationStatusMutation, UpdateSalesCancellationStatusMutationVariables>;
export const ApproveSalesCancellationDocument = gql`
    mutation approveSalesCancellation($ids: [String!]!) {
  approveSalesCancellation(ids: $ids)
}
    `;
export type ApproveSalesCancellationMutationFn = Apollo.MutationFunction<ApproveSalesCancellationMutation, ApproveSalesCancellationMutationVariables>;

/**
 * __useApproveSalesCancellationMutation__
 *
 * To run a mutation, you first call `useApproveSalesCancellationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveSalesCancellationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveSalesCancellationMutation, { data, loading, error }] = useApproveSalesCancellationMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useApproveSalesCancellationMutation(baseOptions?: Apollo.MutationHookOptions<ApproveSalesCancellationMutation, ApproveSalesCancellationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveSalesCancellationMutation, ApproveSalesCancellationMutationVariables>(ApproveSalesCancellationDocument, options);
      }
export type ApproveSalesCancellationMutationHookResult = ReturnType<typeof useApproveSalesCancellationMutation>;
export type ApproveSalesCancellationMutationResult = Apollo.MutationResult<ApproveSalesCancellationMutation>;
export type ApproveSalesCancellationMutationOptions = Apollo.BaseMutationOptions<ApproveSalesCancellationMutation, ApproveSalesCancellationMutationVariables>;
export const RejectSalesCancellationDocument = gql`
    mutation rejectSalesCancellation($ids: [String!]!) {
  rejectSalesCancellation(ids: $ids)
}
    `;
export type RejectSalesCancellationMutationFn = Apollo.MutationFunction<RejectSalesCancellationMutation, RejectSalesCancellationMutationVariables>;

/**
 * __useRejectSalesCancellationMutation__
 *
 * To run a mutation, you first call `useRejectSalesCancellationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectSalesCancellationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectSalesCancellationMutation, { data, loading, error }] = useRejectSalesCancellationMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useRejectSalesCancellationMutation(baseOptions?: Apollo.MutationHookOptions<RejectSalesCancellationMutation, RejectSalesCancellationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectSalesCancellationMutation, RejectSalesCancellationMutationVariables>(RejectSalesCancellationDocument, options);
      }
export type RejectSalesCancellationMutationHookResult = ReturnType<typeof useRejectSalesCancellationMutation>;
export type RejectSalesCancellationMutationResult = Apollo.MutationResult<RejectSalesCancellationMutation>;
export type RejectSalesCancellationMutationOptions = Apollo.BaseMutationOptions<RejectSalesCancellationMutation, RejectSalesCancellationMutationVariables>;
export const GetSaleCancelReasonDocument = gql`
    query getSaleCancelReason {
  getSaleCancelReason {
    id
    name
    defaulted
  }
}
    `;

/**
 * __useGetSaleCancelReasonQuery__
 *
 * To run a query within a React component, call `useGetSaleCancelReasonQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSaleCancelReasonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSaleCancelReasonQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSaleCancelReasonQuery(baseOptions?: Apollo.QueryHookOptions<GetSaleCancelReasonQuery, GetSaleCancelReasonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSaleCancelReasonQuery, GetSaleCancelReasonQueryVariables>(GetSaleCancelReasonDocument, options);
      }
export function useGetSaleCancelReasonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSaleCancelReasonQuery, GetSaleCancelReasonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSaleCancelReasonQuery, GetSaleCancelReasonQueryVariables>(GetSaleCancelReasonDocument, options);
        }
export type GetSaleCancelReasonQueryHookResult = ReturnType<typeof useGetSaleCancelReasonQuery>;
export type GetSaleCancelReasonLazyQueryHookResult = ReturnType<typeof useGetSaleCancelReasonLazyQuery>;
export type GetSaleCancelReasonQueryResult = Apollo.QueryResult<GetSaleCancelReasonQuery, GetSaleCancelReasonQueryVariables>;
export const GetSalesCancellationELetterDocument = gql`
    query getSalesCancellationELetter($saleCancellationId: String!, $letterTemplateId: String!) {
  getSalesCancellationELetter(saleCancellationId: $saleCancellationId, letterTemplateId: $letterTemplateId) {
    content
    fileName
  }
}
    `;

/**
 * __useGetSalesCancellationELetterQuery__
 *
 * To run a query within a React component, call `useGetSalesCancellationELetterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesCancellationELetterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesCancellationELetterQuery({
 *   variables: {
 *      saleCancellationId: // value for 'saleCancellationId'
 *      letterTemplateId: // value for 'letterTemplateId'
 *   },
 * });
 */
export function useGetSalesCancellationELetterQuery(baseOptions: Apollo.QueryHookOptions<GetSalesCancellationELetterQuery, GetSalesCancellationELetterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesCancellationELetterQuery, GetSalesCancellationELetterQueryVariables>(GetSalesCancellationELetterDocument, options);
      }
export function useGetSalesCancellationELetterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesCancellationELetterQuery, GetSalesCancellationELetterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesCancellationELetterQuery, GetSalesCancellationELetterQueryVariables>(GetSalesCancellationELetterDocument, options);
        }
export type GetSalesCancellationELetterQueryHookResult = ReturnType<typeof useGetSalesCancellationELetterQuery>;
export type GetSalesCancellationELetterLazyQueryHookResult = ReturnType<typeof useGetSalesCancellationELetterLazyQuery>;
export type GetSalesCancellationELetterQueryResult = Apollo.QueryResult<GetSalesCancellationELetterQuery, GetSalesCancellationELetterQueryVariables>;
export const GetSalesCancellationELetterTemplateListingDocument = gql`
    query getSalesCancellationELetterTemplateListing($projectId: String!) {
  getSalesCancellationELetterTemplateListing(projectId: $projectId) {
    id
    name
    letterType
    defaulted
  }
}
    `;

/**
 * __useGetSalesCancellationELetterTemplateListingQuery__
 *
 * To run a query within a React component, call `useGetSalesCancellationELetterTemplateListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesCancellationELetterTemplateListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesCancellationELetterTemplateListingQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetSalesCancellationELetterTemplateListingQuery(baseOptions: Apollo.QueryHookOptions<GetSalesCancellationELetterTemplateListingQuery, GetSalesCancellationELetterTemplateListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesCancellationELetterTemplateListingQuery, GetSalesCancellationELetterTemplateListingQueryVariables>(GetSalesCancellationELetterTemplateListingDocument, options);
      }
export function useGetSalesCancellationELetterTemplateListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesCancellationELetterTemplateListingQuery, GetSalesCancellationELetterTemplateListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesCancellationELetterTemplateListingQuery, GetSalesCancellationELetterTemplateListingQueryVariables>(GetSalesCancellationELetterTemplateListingDocument, options);
        }
export type GetSalesCancellationELetterTemplateListingQueryHookResult = ReturnType<typeof useGetSalesCancellationELetterTemplateListingQuery>;
export type GetSalesCancellationELetterTemplateListingLazyQueryHookResult = ReturnType<typeof useGetSalesCancellationELetterTemplateListingLazyQuery>;
export type GetSalesCancellationELetterTemplateListingQueryResult = Apollo.QueryResult<GetSalesCancellationELetterTemplateListingQuery, GetSalesCancellationELetterTemplateListingQueryVariables>;
export const GetSalesCancellationCountDocument = gql`
    query getSalesCancellationCount($projectId: String!) {
  getSalesCancellationCount(projectId: $projectId) {
    openCount
    completedCount
    cancelCount
  }
}
    `;

/**
 * __useGetSalesCancellationCountQuery__
 *
 * To run a query within a React component, call `useGetSalesCancellationCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesCancellationCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesCancellationCountQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetSalesCancellationCountQuery(baseOptions: Apollo.QueryHookOptions<GetSalesCancellationCountQuery, GetSalesCancellationCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesCancellationCountQuery, GetSalesCancellationCountQueryVariables>(GetSalesCancellationCountDocument, options);
      }
export function useGetSalesCancellationCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesCancellationCountQuery, GetSalesCancellationCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesCancellationCountQuery, GetSalesCancellationCountQueryVariables>(GetSalesCancellationCountDocument, options);
        }
export type GetSalesCancellationCountQueryHookResult = ReturnType<typeof useGetSalesCancellationCountQuery>;
export type GetSalesCancellationCountLazyQueryHookResult = ReturnType<typeof useGetSalesCancellationCountLazyQuery>;
export type GetSalesCancellationCountQueryResult = Apollo.QueryResult<GetSalesCancellationCountQuery, GetSalesCancellationCountQueryVariables>;
export const GetCommissionCalculationListingDocument = gql`
    query GetCommissionCalculationListing($projectId: String!, $inputDate: String) {
  getCommissionCalculationListing(projectId: $projectId, inputDate: $inputDate) {
    position
    employeeName
    employeeId
    unitNo
    salesConvertedStatus
    salesRegistrationNo
    description
    principal
    effectiveDate
    paidToDate
    release
    propertyType
    commissionType
    minimumTarget
    salesRegistrationDate
    commissionPackageTargetId
    companyId
    dealClosure
    parentId
    overRiding
    unitsSold
    unitSum
    saleId
    finalContractPrice
    finalCommission
    projectCommissionPackageId
    totalFinalContractPrice
    totalFinalCommission
    companyCommissionTeamId
    jobPositionId
    level
  }
}
    `;

/**
 * __useGetCommissionCalculationListingQuery__
 *
 * To run a query within a React component, call `useGetCommissionCalculationListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommissionCalculationListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommissionCalculationListingQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      inputDate: // value for 'inputDate'
 *   },
 * });
 */
export function useGetCommissionCalculationListingQuery(baseOptions: Apollo.QueryHookOptions<GetCommissionCalculationListingQuery, GetCommissionCalculationListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommissionCalculationListingQuery, GetCommissionCalculationListingQueryVariables>(GetCommissionCalculationListingDocument, options);
      }
export function useGetCommissionCalculationListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommissionCalculationListingQuery, GetCommissionCalculationListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommissionCalculationListingQuery, GetCommissionCalculationListingQueryVariables>(GetCommissionCalculationListingDocument, options);
        }
export type GetCommissionCalculationListingQueryHookResult = ReturnType<typeof useGetCommissionCalculationListingQuery>;
export type GetCommissionCalculationListingLazyQueryHookResult = ReturnType<typeof useGetCommissionCalculationListingLazyQuery>;
export type GetCommissionCalculationListingQueryResult = Apollo.QueryResult<GetCommissionCalculationListingQuery, GetCommissionCalculationListingQueryVariables>;
export const CreateProjectCommissionCalculationDocument = gql`
    mutation createProjectCommissionCalculation($input: [commissionCalculationInput!]!, $inputDetail: [commissionCalculationDetailInput!]!) {
  createProjectCommissionCalculation(input: $input, inputDetail: $inputDetail)
}
    `;
export type CreateProjectCommissionCalculationMutationFn = Apollo.MutationFunction<CreateProjectCommissionCalculationMutation, CreateProjectCommissionCalculationMutationVariables>;

/**
 * __useCreateProjectCommissionCalculationMutation__
 *
 * To run a mutation, you first call `useCreateProjectCommissionCalculationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectCommissionCalculationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectCommissionCalculationMutation, { data, loading, error }] = useCreateProjectCommissionCalculationMutation({
 *   variables: {
 *      input: // value for 'input'
 *      inputDetail: // value for 'inputDetail'
 *   },
 * });
 */
export function useCreateProjectCommissionCalculationMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectCommissionCalculationMutation, CreateProjectCommissionCalculationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectCommissionCalculationMutation, CreateProjectCommissionCalculationMutationVariables>(CreateProjectCommissionCalculationDocument, options);
      }
export type CreateProjectCommissionCalculationMutationHookResult = ReturnType<typeof useCreateProjectCommissionCalculationMutation>;
export type CreateProjectCommissionCalculationMutationResult = Apollo.MutationResult<CreateProjectCommissionCalculationMutation>;
export type CreateProjectCommissionCalculationMutationOptions = Apollo.BaseMutationOptions<CreateProjectCommissionCalculationMutation, CreateProjectCommissionCalculationMutationVariables>;
export const GetCommissionCalculationDataDocument = gql`
    query GetCommissionCalculationData($projectId: String!, $inputDate: String) {
  getCommissionCalculationData(projectId: $projectId, inputDate: $inputDate) {
    projectId
    generateDate
    totalSelling
    principal
    employeeId
    totalSelling
  }
}
    `;

/**
 * __useGetCommissionCalculationDataQuery__
 *
 * To run a query within a React component, call `useGetCommissionCalculationDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommissionCalculationDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommissionCalculationDataQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      inputDate: // value for 'inputDate'
 *   },
 * });
 */
export function useGetCommissionCalculationDataQuery(baseOptions: Apollo.QueryHookOptions<GetCommissionCalculationDataQuery, GetCommissionCalculationDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommissionCalculationDataQuery, GetCommissionCalculationDataQueryVariables>(GetCommissionCalculationDataDocument, options);
      }
export function useGetCommissionCalculationDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommissionCalculationDataQuery, GetCommissionCalculationDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommissionCalculationDataQuery, GetCommissionCalculationDataQueryVariables>(GetCommissionCalculationDataDocument, options);
        }
export type GetCommissionCalculationDataQueryHookResult = ReturnType<typeof useGetCommissionCalculationDataQuery>;
export type GetCommissionCalculationDataLazyQueryHookResult = ReturnType<typeof useGetCommissionCalculationDataLazyQuery>;
export type GetCommissionCalculationDataQueryResult = Apollo.QueryResult<GetCommissionCalculationDataQuery, GetCommissionCalculationDataQueryVariables>;
export const GetCommissionCalculationDetailDataDocument = gql`
    query GetCommissionCalculationDetailData($inputDate: String!, $projectId: String!) {
  getCommissionCalculationDetailData(inputDate: $inputDate, projectId: $projectId) {
    parent_id
    principal
    job_position
    generate_date
    employee_name
    employee_id
    total_selling
    total_commission
    type
    children {
      detail_id
      project_commission_calc_id
      doc_no
      doc_date
      sale_id
      net_selling
      commission_amt
      commission_type
      generate_date
      employee_name
      unit_no
      type
      children {
        child_id
        project_commission_calc_id
        doc_no
        doc_date
        sale_id
        net_selling
        commission_amt
        commission_type
        type
      }
    }
  }
}
    `;

/**
 * __useGetCommissionCalculationDetailDataQuery__
 *
 * To run a query within a React component, call `useGetCommissionCalculationDetailDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommissionCalculationDetailDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommissionCalculationDetailDataQuery({
 *   variables: {
 *      inputDate: // value for 'inputDate'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetCommissionCalculationDetailDataQuery(baseOptions: Apollo.QueryHookOptions<GetCommissionCalculationDetailDataQuery, GetCommissionCalculationDetailDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommissionCalculationDetailDataQuery, GetCommissionCalculationDetailDataQueryVariables>(GetCommissionCalculationDetailDataDocument, options);
      }
export function useGetCommissionCalculationDetailDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommissionCalculationDetailDataQuery, GetCommissionCalculationDetailDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommissionCalculationDetailDataQuery, GetCommissionCalculationDetailDataQueryVariables>(GetCommissionCalculationDetailDataDocument, options);
        }
export type GetCommissionCalculationDetailDataQueryHookResult = ReturnType<typeof useGetCommissionCalculationDetailDataQuery>;
export type GetCommissionCalculationDetailDataLazyQueryHookResult = ReturnType<typeof useGetCommissionCalculationDetailDataLazyQuery>;
export type GetCommissionCalculationDetailDataQueryResult = Apollo.QueryResult<GetCommissionCalculationDetailDataQuery, GetCommissionCalculationDetailDataQueryVariables>;
export const GetCompanyRewardDetailDataDocument = gql`
    query GetCompanyRewardDetailData($inputDate: String!) {
  getCompanyRewardDetailData(inputDate: $inputDate) {
    parent_id
    principal
    job_position
    commission_type
    generate_date
    employee_name
    employee_id
    total_selling
    total_commission
    type
    children {
      detail_id
      sales_registration_no
      company_commission_calc_id
      unit_no
      doc_no
      doc_date
      sale_id
      net_selling
      commission_amt
      commission_type
      generate_date
      employee_name
      type
      children {
        child_id
        company_commission_calc_id
        doc_no
        doc_date
        sale_id
        net_selling
        commission_amt
        commission_type
        type
      }
    }
  }
}
    `;

/**
 * __useGetCompanyRewardDetailDataQuery__
 *
 * To run a query within a React component, call `useGetCompanyRewardDetailDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyRewardDetailDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyRewardDetailDataQuery({
 *   variables: {
 *      inputDate: // value for 'inputDate'
 *   },
 * });
 */
export function useGetCompanyRewardDetailDataQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyRewardDetailDataQuery, GetCompanyRewardDetailDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyRewardDetailDataQuery, GetCompanyRewardDetailDataQueryVariables>(GetCompanyRewardDetailDataDocument, options);
      }
export function useGetCompanyRewardDetailDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyRewardDetailDataQuery, GetCompanyRewardDetailDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyRewardDetailDataQuery, GetCompanyRewardDetailDataQueryVariables>(GetCompanyRewardDetailDataDocument, options);
        }
export type GetCompanyRewardDetailDataQueryHookResult = ReturnType<typeof useGetCompanyRewardDetailDataQuery>;
export type GetCompanyRewardDetailDataLazyQueryHookResult = ReturnType<typeof useGetCompanyRewardDetailDataLazyQuery>;
export type GetCompanyRewardDetailDataQueryResult = Apollo.QueryResult<GetCompanyRewardDetailDataQuery, GetCompanyRewardDetailDataQueryVariables>;
export const GetCommissionCalculationListingDataDocument = gql`
    query GetCommissionCalculationListingData($projectId: String!, $inputDate: String) {
  getCommissionCalculationListingData(projectId: $projectId, inputDate: $inputDate) {
    employeeTotalCommission
    employeeTotalSale
    position
    employeeName
    employeeId
    unitNo
    salesConvertedStatus
    propertyType
    commissionType
    salesRegistrationNo
    salesRegistrationDate
    projectCommissionPackageId
    existProjectCommissionPackageId
    existEmployeeId
    companyId
    unitSum
    finalCommission
    totalFinalContractPrice
    totalFinalCommission
    finalContractPrice
    saleId
    principal
    description
    effectiveDate
    minimumTarget
    dealClosure
    overRiding
    unitsSold
    unitLayout
  }
}
    `;

/**
 * __useGetCommissionCalculationListingDataQuery__
 *
 * To run a query within a React component, call `useGetCommissionCalculationListingDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommissionCalculationListingDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommissionCalculationListingDataQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      inputDate: // value for 'inputDate'
 *   },
 * });
 */
export function useGetCommissionCalculationListingDataQuery(baseOptions: Apollo.QueryHookOptions<GetCommissionCalculationListingDataQuery, GetCommissionCalculationListingDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommissionCalculationListingDataQuery, GetCommissionCalculationListingDataQueryVariables>(GetCommissionCalculationListingDataDocument, options);
      }
export function useGetCommissionCalculationListingDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommissionCalculationListingDataQuery, GetCommissionCalculationListingDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommissionCalculationListingDataQuery, GetCommissionCalculationListingDataQueryVariables>(GetCommissionCalculationListingDataDocument, options);
        }
export type GetCommissionCalculationListingDataQueryHookResult = ReturnType<typeof useGetCommissionCalculationListingDataQuery>;
export type GetCommissionCalculationListingDataLazyQueryHookResult = ReturnType<typeof useGetCommissionCalculationListingDataLazyQuery>;
export type GetCommissionCalculationListingDataQueryResult = Apollo.QueryResult<GetCommissionCalculationListingDataQuery, GetCommissionCalculationListingDataQueryVariables>;
export const GetCompanyRewardDataDocument = gql`
    query GetCompanyRewardData($projectId: String!, $inputDate: String) {
  getCompanyRewardData(projectId: $projectId, inputDate: $inputDate) {
    id
    saleId
    employeeName
    employeeId
    projectId
    salesRegistrationDate
    salesRegistrationNo
    ejpEmployeeId
    ejpEmployeeName
    description
    jobPosition
    companyId
    commissionType
    propertyType
    principal
    taxSchemeId
    paymentPlanMarkUpAmount
    existCompanyCommissionPackageId
    existEmployeeId
    unitNo
    effectiveDate
    finalContractPrice
    paidToDatePercentage
    isDealClosure
    finalCommission
    totalFinalCommission
    dealClosure
    overRiding
    companyCommissionPackageId
    employeeTotalCommission
    employeeTotalSale
  }
}
    `;

/**
 * __useGetCompanyRewardDataQuery__
 *
 * To run a query within a React component, call `useGetCompanyRewardDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyRewardDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyRewardDataQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      inputDate: // value for 'inputDate'
 *   },
 * });
 */
export function useGetCompanyRewardDataQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyRewardDataQuery, GetCompanyRewardDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyRewardDataQuery, GetCompanyRewardDataQueryVariables>(GetCompanyRewardDataDocument, options);
      }
export function useGetCompanyRewardDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyRewardDataQuery, GetCompanyRewardDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyRewardDataQuery, GetCompanyRewardDataQueryVariables>(GetCompanyRewardDataDocument, options);
        }
export type GetCompanyRewardDataQueryHookResult = ReturnType<typeof useGetCompanyRewardDataQuery>;
export type GetCompanyRewardDataLazyQueryHookResult = ReturnType<typeof useGetCompanyRewardDataLazyQuery>;
export type GetCompanyRewardDataQueryResult = Apollo.QueryResult<GetCompanyRewardDataQuery, GetCompanyRewardDataQueryVariables>;
export const CreateCompanyRewardCalculationDocument = gql`
    mutation CreateCompanyRewardCalculation($input: [companyRewardInput!]!, $inputDetail: [companyRewardDetailInput!]!) {
  createCompanyRewardCalculation(input: $input, inputDetail: $inputDetail)
}
    `;
export type CreateCompanyRewardCalculationMutationFn = Apollo.MutationFunction<CreateCompanyRewardCalculationMutation, CreateCompanyRewardCalculationMutationVariables>;

/**
 * __useCreateCompanyRewardCalculationMutation__
 *
 * To run a mutation, you first call `useCreateCompanyRewardCalculationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyRewardCalculationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyRewardCalculationMutation, { data, loading, error }] = useCreateCompanyRewardCalculationMutation({
 *   variables: {
 *      input: // value for 'input'
 *      inputDetail: // value for 'inputDetail'
 *   },
 * });
 */
export function useCreateCompanyRewardCalculationMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompanyRewardCalculationMutation, CreateCompanyRewardCalculationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompanyRewardCalculationMutation, CreateCompanyRewardCalculationMutationVariables>(CreateCompanyRewardCalculationDocument, options);
      }
export type CreateCompanyRewardCalculationMutationHookResult = ReturnType<typeof useCreateCompanyRewardCalculationMutation>;
export type CreateCompanyRewardCalculationMutationResult = Apollo.MutationResult<CreateCompanyRewardCalculationMutation>;
export type CreateCompanyRewardCalculationMutationOptions = Apollo.BaseMutationOptions<CreateCompanyRewardCalculationMutation, CreateCompanyRewardCalculationMutationVariables>;
export const GetCompanyRewardListingNewDocument = gql`
    query GetCompanyRewardListingNew {
  getCompanyRewardListingNew {
    id
    companyId
    generateDate
    totalSelling
    principal
    employeeId
  }
}
    `;

/**
 * __useGetCompanyRewardListingNewQuery__
 *
 * To run a query within a React component, call `useGetCompanyRewardListingNewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyRewardListingNewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyRewardListingNewQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompanyRewardListingNewQuery(baseOptions?: Apollo.QueryHookOptions<GetCompanyRewardListingNewQuery, GetCompanyRewardListingNewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyRewardListingNewQuery, GetCompanyRewardListingNewQueryVariables>(GetCompanyRewardListingNewDocument, options);
      }
export function useGetCompanyRewardListingNewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyRewardListingNewQuery, GetCompanyRewardListingNewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyRewardListingNewQuery, GetCompanyRewardListingNewQueryVariables>(GetCompanyRewardListingNewDocument, options);
        }
export type GetCompanyRewardListingNewQueryHookResult = ReturnType<typeof useGetCompanyRewardListingNewQuery>;
export type GetCompanyRewardListingNewLazyQueryHookResult = ReturnType<typeof useGetCompanyRewardListingNewLazyQuery>;
export type GetCompanyRewardListingNewQueryResult = Apollo.QueryResult<GetCompanyRewardListingNewQuery, GetCompanyRewardListingNewQueryVariables>;
export const AddCommissionPaymentsDocument = gql`
    mutation addCommissionPayments($inputs: [AddCommissionPaymentInput!]!) {
  addCommissionPayments(inputs: $inputs)
}
    `;
export type AddCommissionPaymentsMutationFn = Apollo.MutationFunction<AddCommissionPaymentsMutation, AddCommissionPaymentsMutationVariables>;

/**
 * __useAddCommissionPaymentsMutation__
 *
 * To run a mutation, you first call `useAddCommissionPaymentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCommissionPaymentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCommissionPaymentsMutation, { data, loading, error }] = useAddCommissionPaymentsMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useAddCommissionPaymentsMutation(baseOptions?: Apollo.MutationHookOptions<AddCommissionPaymentsMutation, AddCommissionPaymentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCommissionPaymentsMutation, AddCommissionPaymentsMutationVariables>(AddCommissionPaymentsDocument, options);
      }
export type AddCommissionPaymentsMutationHookResult = ReturnType<typeof useAddCommissionPaymentsMutation>;
export type AddCommissionPaymentsMutationResult = Apollo.MutationResult<AddCommissionPaymentsMutation>;
export type AddCommissionPaymentsMutationOptions = Apollo.BaseMutationOptions<AddCommissionPaymentsMutation, AddCommissionPaymentsMutationVariables>;
export const EditCommissionPaymentByIdDocument = gql`
    mutation editCommissionPaymentById($id: String!, $input: EditCommissionPaymentInput!) {
  editCommissionPaymentById(id: $id, input: $input)
}
    `;
export type EditCommissionPaymentByIdMutationFn = Apollo.MutationFunction<EditCommissionPaymentByIdMutation, EditCommissionPaymentByIdMutationVariables>;

/**
 * __useEditCommissionPaymentByIdMutation__
 *
 * To run a mutation, you first call `useEditCommissionPaymentByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCommissionPaymentByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCommissionPaymentByIdMutation, { data, loading, error }] = useEditCommissionPaymentByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditCommissionPaymentByIdMutation(baseOptions?: Apollo.MutationHookOptions<EditCommissionPaymentByIdMutation, EditCommissionPaymentByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCommissionPaymentByIdMutation, EditCommissionPaymentByIdMutationVariables>(EditCommissionPaymentByIdDocument, options);
      }
export type EditCommissionPaymentByIdMutationHookResult = ReturnType<typeof useEditCommissionPaymentByIdMutation>;
export type EditCommissionPaymentByIdMutationResult = Apollo.MutationResult<EditCommissionPaymentByIdMutation>;
export type EditCommissionPaymentByIdMutationOptions = Apollo.BaseMutationOptions<EditCommissionPaymentByIdMutation, EditCommissionPaymentByIdMutationVariables>;
export const DeleteCommissionPaymentByIdDocument = gql`
    mutation deleteCommissionPaymentById($id: String!) {
  deleteCommissionPaymentById(id: $id)
}
    `;
export type DeleteCommissionPaymentByIdMutationFn = Apollo.MutationFunction<DeleteCommissionPaymentByIdMutation, DeleteCommissionPaymentByIdMutationVariables>;

/**
 * __useDeleteCommissionPaymentByIdMutation__
 *
 * To run a mutation, you first call `useDeleteCommissionPaymentByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommissionPaymentByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommissionPaymentByIdMutation, { data, loading, error }] = useDeleteCommissionPaymentByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCommissionPaymentByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCommissionPaymentByIdMutation, DeleteCommissionPaymentByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCommissionPaymentByIdMutation, DeleteCommissionPaymentByIdMutationVariables>(DeleteCommissionPaymentByIdDocument, options);
      }
export type DeleteCommissionPaymentByIdMutationHookResult = ReturnType<typeof useDeleteCommissionPaymentByIdMutation>;
export type DeleteCommissionPaymentByIdMutationResult = Apollo.MutationResult<DeleteCommissionPaymentByIdMutation>;
export type DeleteCommissionPaymentByIdMutationOptions = Apollo.BaseMutationOptions<DeleteCommissionPaymentByIdMutation, DeleteCommissionPaymentByIdMutationVariables>;
export const AddCommissionStatutoryDocumentDocument = gql`
    mutation addCommissionStatutoryDocument($input: AddCommissionStatutoryDocumentInput!) {
  addCommissionStatutoryDocument(input: $input)
}
    `;
export type AddCommissionStatutoryDocumentMutationFn = Apollo.MutationFunction<AddCommissionStatutoryDocumentMutation, AddCommissionStatutoryDocumentMutationVariables>;

/**
 * __useAddCommissionStatutoryDocumentMutation__
 *
 * To run a mutation, you first call `useAddCommissionStatutoryDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCommissionStatutoryDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCommissionStatutoryDocumentMutation, { data, loading, error }] = useAddCommissionStatutoryDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCommissionStatutoryDocumentMutation(baseOptions?: Apollo.MutationHookOptions<AddCommissionStatutoryDocumentMutation, AddCommissionStatutoryDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCommissionStatutoryDocumentMutation, AddCommissionStatutoryDocumentMutationVariables>(AddCommissionStatutoryDocumentDocument, options);
      }
export type AddCommissionStatutoryDocumentMutationHookResult = ReturnType<typeof useAddCommissionStatutoryDocumentMutation>;
export type AddCommissionStatutoryDocumentMutationResult = Apollo.MutationResult<AddCommissionStatutoryDocumentMutation>;
export type AddCommissionStatutoryDocumentMutationOptions = Apollo.BaseMutationOptions<AddCommissionStatutoryDocumentMutation, AddCommissionStatutoryDocumentMutationVariables>;
export const DeleteCommissionStatutoryDocumentByIdDocument = gql`
    mutation deleteCommissionStatutoryDocumentById($id: String!) {
  deleteCommissionStatutoryDocumentById(id: $id)
}
    `;
export type DeleteCommissionStatutoryDocumentByIdMutationFn = Apollo.MutationFunction<DeleteCommissionStatutoryDocumentByIdMutation, DeleteCommissionStatutoryDocumentByIdMutationVariables>;

/**
 * __useDeleteCommissionStatutoryDocumentByIdMutation__
 *
 * To run a mutation, you first call `useDeleteCommissionStatutoryDocumentByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommissionStatutoryDocumentByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommissionStatutoryDocumentByIdMutation, { data, loading, error }] = useDeleteCommissionStatutoryDocumentByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCommissionStatutoryDocumentByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCommissionStatutoryDocumentByIdMutation, DeleteCommissionStatutoryDocumentByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCommissionStatutoryDocumentByIdMutation, DeleteCommissionStatutoryDocumentByIdMutationVariables>(DeleteCommissionStatutoryDocumentByIdDocument, options);
      }
export type DeleteCommissionStatutoryDocumentByIdMutationHookResult = ReturnType<typeof useDeleteCommissionStatutoryDocumentByIdMutation>;
export type DeleteCommissionStatutoryDocumentByIdMutationResult = Apollo.MutationResult<DeleteCommissionStatutoryDocumentByIdMutation>;
export type DeleteCommissionStatutoryDocumentByIdMutationOptions = Apollo.BaseMutationOptions<DeleteCommissionStatutoryDocumentByIdMutation, DeleteCommissionStatutoryDocumentByIdMutationVariables>;
export const EditCommissionStatutoryDocumentByIdDocument = gql`
    mutation editCommissionStatutoryDocumentById($id: String!, $statutoryDocId: String!) {
  editCommissionStatutoryDocumentById(id: $id, statutoryDocId: $statutoryDocId)
}
    `;
export type EditCommissionStatutoryDocumentByIdMutationFn = Apollo.MutationFunction<EditCommissionStatutoryDocumentByIdMutation, EditCommissionStatutoryDocumentByIdMutationVariables>;

/**
 * __useEditCommissionStatutoryDocumentByIdMutation__
 *
 * To run a mutation, you first call `useEditCommissionStatutoryDocumentByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCommissionStatutoryDocumentByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCommissionStatutoryDocumentByIdMutation, { data, loading, error }] = useEditCommissionStatutoryDocumentByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      statutoryDocId: // value for 'statutoryDocId'
 *   },
 * });
 */
export function useEditCommissionStatutoryDocumentByIdMutation(baseOptions?: Apollo.MutationHookOptions<EditCommissionStatutoryDocumentByIdMutation, EditCommissionStatutoryDocumentByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCommissionStatutoryDocumentByIdMutation, EditCommissionStatutoryDocumentByIdMutationVariables>(EditCommissionStatutoryDocumentByIdDocument, options);
      }
export type EditCommissionStatutoryDocumentByIdMutationHookResult = ReturnType<typeof useEditCommissionStatutoryDocumentByIdMutation>;
export type EditCommissionStatutoryDocumentByIdMutationResult = Apollo.MutationResult<EditCommissionStatutoryDocumentByIdMutation>;
export type EditCommissionStatutoryDocumentByIdMutationOptions = Apollo.BaseMutationOptions<EditCommissionStatutoryDocumentByIdMutation, EditCommissionStatutoryDocumentByIdMutationVariables>;
export const GetCommissionTypeListingDocument = gql`
    query getCommissionTypeListing {
  getCommissionTypeListing {
    id
    name
    interval
    payOutType
    targetBy
    commonStatus
  }
}
    `;

/**
 * __useGetCommissionTypeListingQuery__
 *
 * To run a query within a React component, call `useGetCommissionTypeListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommissionTypeListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommissionTypeListingQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCommissionTypeListingQuery(baseOptions?: Apollo.QueryHookOptions<GetCommissionTypeListingQuery, GetCommissionTypeListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommissionTypeListingQuery, GetCommissionTypeListingQueryVariables>(GetCommissionTypeListingDocument, options);
      }
export function useGetCommissionTypeListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommissionTypeListingQuery, GetCommissionTypeListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommissionTypeListingQuery, GetCommissionTypeListingQueryVariables>(GetCommissionTypeListingDocument, options);
        }
export type GetCommissionTypeListingQueryHookResult = ReturnType<typeof useGetCommissionTypeListingQuery>;
export type GetCommissionTypeListingLazyQueryHookResult = ReturnType<typeof useGetCommissionTypeListingLazyQuery>;
export type GetCommissionTypeListingQueryResult = Apollo.QueryResult<GetCommissionTypeListingQuery, GetCommissionTypeListingQueryVariables>;
export const SubmitCommissionTypeDocument = gql`
    mutation submitCommissionType($input: commissionTypeInput!) {
  submitCommissionType(input: $input)
}
    `;
export type SubmitCommissionTypeMutationFn = Apollo.MutationFunction<SubmitCommissionTypeMutation, SubmitCommissionTypeMutationVariables>;

/**
 * __useSubmitCommissionTypeMutation__
 *
 * To run a mutation, you first call `useSubmitCommissionTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitCommissionTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitCommissionTypeMutation, { data, loading, error }] = useSubmitCommissionTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitCommissionTypeMutation(baseOptions?: Apollo.MutationHookOptions<SubmitCommissionTypeMutation, SubmitCommissionTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitCommissionTypeMutation, SubmitCommissionTypeMutationVariables>(SubmitCommissionTypeDocument, options);
      }
export type SubmitCommissionTypeMutationHookResult = ReturnType<typeof useSubmitCommissionTypeMutation>;
export type SubmitCommissionTypeMutationResult = Apollo.MutationResult<SubmitCommissionTypeMutation>;
export type SubmitCommissionTypeMutationOptions = Apollo.BaseMutationOptions<SubmitCommissionTypeMutation, SubmitCommissionTypeMutationVariables>;
export const DeleteCommissionTypeDocument = gql`
    mutation deleteCommissionType($id: String!) {
  deleteCommissionType(id: $id)
}
    `;
export type DeleteCommissionTypeMutationFn = Apollo.MutationFunction<DeleteCommissionTypeMutation, DeleteCommissionTypeMutationVariables>;

/**
 * __useDeleteCommissionTypeMutation__
 *
 * To run a mutation, you first call `useDeleteCommissionTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommissionTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommissionTypeMutation, { data, loading, error }] = useDeleteCommissionTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCommissionTypeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCommissionTypeMutation, DeleteCommissionTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCommissionTypeMutation, DeleteCommissionTypeMutationVariables>(DeleteCommissionTypeDocument, options);
      }
export type DeleteCommissionTypeMutationHookResult = ReturnType<typeof useDeleteCommissionTypeMutation>;
export type DeleteCommissionTypeMutationResult = Apollo.MutationResult<DeleteCommissionTypeMutation>;
export type DeleteCommissionTypeMutationOptions = Apollo.BaseMutationOptions<DeleteCommissionTypeMutation, DeleteCommissionTypeMutationVariables>;
export const IsCanEditOrDeleteCommisionTypeDocument = gql`
    query isCanEditOrDeleteCommisionType($commisionId: String!) {
  isCanEditOrDeleteCommisionType(commisionId: $commisionId)
}
    `;

/**
 * __useIsCanEditOrDeleteCommisionTypeQuery__
 *
 * To run a query within a React component, call `useIsCanEditOrDeleteCommisionTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsCanEditOrDeleteCommisionTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsCanEditOrDeleteCommisionTypeQuery({
 *   variables: {
 *      commisionId: // value for 'commisionId'
 *   },
 * });
 */
export function useIsCanEditOrDeleteCommisionTypeQuery(baseOptions: Apollo.QueryHookOptions<IsCanEditOrDeleteCommisionTypeQuery, IsCanEditOrDeleteCommisionTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsCanEditOrDeleteCommisionTypeQuery, IsCanEditOrDeleteCommisionTypeQueryVariables>(IsCanEditOrDeleteCommisionTypeDocument, options);
      }
export function useIsCanEditOrDeleteCommisionTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsCanEditOrDeleteCommisionTypeQuery, IsCanEditOrDeleteCommisionTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsCanEditOrDeleteCommisionTypeQuery, IsCanEditOrDeleteCommisionTypeQueryVariables>(IsCanEditOrDeleteCommisionTypeDocument, options);
        }
export type IsCanEditOrDeleteCommisionTypeQueryHookResult = ReturnType<typeof useIsCanEditOrDeleteCommisionTypeQuery>;
export type IsCanEditOrDeleteCommisionTypeLazyQueryHookResult = ReturnType<typeof useIsCanEditOrDeleteCommisionTypeLazyQuery>;
export type IsCanEditOrDeleteCommisionTypeQueryResult = Apollo.QueryResult<IsCanEditOrDeleteCommisionTypeQuery, IsCanEditOrDeleteCommisionTypeQueryVariables>;
export const GetCompanyCommissionPackageListingDocument = gql`
    query getCompanyCommissionPackageListing($principal: String!) {
  getCompanyCommissionPackageListing(principal: $principal) {
    id
    companyId
    companyCommissionId
    principal
    companyCommission {
      id
      commissionTypeId
      description
    }
    companyCommissionPackageDetails {
      id
      companyCommissionPackageId
      effectiveDate
      commissionPackageTargets {
        id
        refId
        refTable
        minimumTarget
        commissionPackageTargetDetails {
          id
          commissionPackageTargetId
          positionId
          teamPositionId
          dealClosure
          overriding
        }
      }
    }
  }
}
    `;

/**
 * __useGetCompanyCommissionPackageListingQuery__
 *
 * To run a query within a React component, call `useGetCompanyCommissionPackageListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyCommissionPackageListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyCommissionPackageListingQuery({
 *   variables: {
 *      principal: // value for 'principal'
 *   },
 * });
 */
export function useGetCompanyCommissionPackageListingQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyCommissionPackageListingQuery, GetCompanyCommissionPackageListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyCommissionPackageListingQuery, GetCompanyCommissionPackageListingQueryVariables>(GetCompanyCommissionPackageListingDocument, options);
      }
export function useGetCompanyCommissionPackageListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyCommissionPackageListingQuery, GetCompanyCommissionPackageListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyCommissionPackageListingQuery, GetCompanyCommissionPackageListingQueryVariables>(GetCompanyCommissionPackageListingDocument, options);
        }
export type GetCompanyCommissionPackageListingQueryHookResult = ReturnType<typeof useGetCompanyCommissionPackageListingQuery>;
export type GetCompanyCommissionPackageListingLazyQueryHookResult = ReturnType<typeof useGetCompanyCommissionPackageListingLazyQuery>;
export type GetCompanyCommissionPackageListingQueryResult = Apollo.QueryResult<GetCompanyCommissionPackageListingQuery, GetCompanyCommissionPackageListingQueryVariables>;
export const AddCompanyCommissionPackageDocument = gql`
    mutation addCompanyCommissionPackage($companyCommissionId: String!, $principal: String!) {
  addCompanyCommissionPackage(companyCommissionId: $companyCommissionId, principal: $principal)
}
    `;
export type AddCompanyCommissionPackageMutationFn = Apollo.MutationFunction<AddCompanyCommissionPackageMutation, AddCompanyCommissionPackageMutationVariables>;

/**
 * __useAddCompanyCommissionPackageMutation__
 *
 * To run a mutation, you first call `useAddCompanyCommissionPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCompanyCommissionPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCompanyCommissionPackageMutation, { data, loading, error }] = useAddCompanyCommissionPackageMutation({
 *   variables: {
 *      companyCommissionId: // value for 'companyCommissionId'
 *      principal: // value for 'principal'
 *   },
 * });
 */
export function useAddCompanyCommissionPackageMutation(baseOptions?: Apollo.MutationHookOptions<AddCompanyCommissionPackageMutation, AddCompanyCommissionPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCompanyCommissionPackageMutation, AddCompanyCommissionPackageMutationVariables>(AddCompanyCommissionPackageDocument, options);
      }
export type AddCompanyCommissionPackageMutationHookResult = ReturnType<typeof useAddCompanyCommissionPackageMutation>;
export type AddCompanyCommissionPackageMutationResult = Apollo.MutationResult<AddCompanyCommissionPackageMutation>;
export type AddCompanyCommissionPackageMutationOptions = Apollo.BaseMutationOptions<AddCompanyCommissionPackageMutation, AddCompanyCommissionPackageMutationVariables>;
export const AddCompanyCommissionPackageDetailDocument = gql`
    mutation addCompanyCommissionPackageDetail($input: CompanyCommissionPackageDetailInput!) {
  addCompanyCommissionPackageDetail(input: $input)
}
    `;
export type AddCompanyCommissionPackageDetailMutationFn = Apollo.MutationFunction<AddCompanyCommissionPackageDetailMutation, AddCompanyCommissionPackageDetailMutationVariables>;

/**
 * __useAddCompanyCommissionPackageDetailMutation__
 *
 * To run a mutation, you first call `useAddCompanyCommissionPackageDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCompanyCommissionPackageDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCompanyCommissionPackageDetailMutation, { data, loading, error }] = useAddCompanyCommissionPackageDetailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCompanyCommissionPackageDetailMutation(baseOptions?: Apollo.MutationHookOptions<AddCompanyCommissionPackageDetailMutation, AddCompanyCommissionPackageDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCompanyCommissionPackageDetailMutation, AddCompanyCommissionPackageDetailMutationVariables>(AddCompanyCommissionPackageDetailDocument, options);
      }
export type AddCompanyCommissionPackageDetailMutationHookResult = ReturnType<typeof useAddCompanyCommissionPackageDetailMutation>;
export type AddCompanyCommissionPackageDetailMutationResult = Apollo.MutationResult<AddCompanyCommissionPackageDetailMutation>;
export type AddCompanyCommissionPackageDetailMutationOptions = Apollo.BaseMutationOptions<AddCompanyCommissionPackageDetailMutation, AddCompanyCommissionPackageDetailMutationVariables>;
export const EditCompanyCommissionPackageDetailDocument = gql`
    mutation editCompanyCommissionPackageDetail($input: CompanyCommissionPackageDetailInput!) {
  editCompanyCommissionPackageDetail(input: $input)
}
    `;
export type EditCompanyCommissionPackageDetailMutationFn = Apollo.MutationFunction<EditCompanyCommissionPackageDetailMutation, EditCompanyCommissionPackageDetailMutationVariables>;

/**
 * __useEditCompanyCommissionPackageDetailMutation__
 *
 * To run a mutation, you first call `useEditCompanyCommissionPackageDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCompanyCommissionPackageDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCompanyCommissionPackageDetailMutation, { data, loading, error }] = useEditCompanyCommissionPackageDetailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditCompanyCommissionPackageDetailMutation(baseOptions?: Apollo.MutationHookOptions<EditCompanyCommissionPackageDetailMutation, EditCompanyCommissionPackageDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCompanyCommissionPackageDetailMutation, EditCompanyCommissionPackageDetailMutationVariables>(EditCompanyCommissionPackageDetailDocument, options);
      }
export type EditCompanyCommissionPackageDetailMutationHookResult = ReturnType<typeof useEditCompanyCommissionPackageDetailMutation>;
export type EditCompanyCommissionPackageDetailMutationResult = Apollo.MutationResult<EditCompanyCommissionPackageDetailMutation>;
export type EditCompanyCommissionPackageDetailMutationOptions = Apollo.BaseMutationOptions<EditCompanyCommissionPackageDetailMutation, EditCompanyCommissionPackageDetailMutationVariables>;
export const DeleteCompanyCommissionPackageDetailDocument = gql`
    mutation deleteCompanyCommissionPackageDetail($id: String!) {
  deleteCompanyCommissionPackageDetail(id: $id)
}
    `;
export type DeleteCompanyCommissionPackageDetailMutationFn = Apollo.MutationFunction<DeleteCompanyCommissionPackageDetailMutation, DeleteCompanyCommissionPackageDetailMutationVariables>;

/**
 * __useDeleteCompanyCommissionPackageDetailMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyCommissionPackageDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyCommissionPackageDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanyCommissionPackageDetailMutation, { data, loading, error }] = useDeleteCompanyCommissionPackageDetailMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCompanyCommissionPackageDetailMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCompanyCommissionPackageDetailMutation, DeleteCompanyCommissionPackageDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCompanyCommissionPackageDetailMutation, DeleteCompanyCommissionPackageDetailMutationVariables>(DeleteCompanyCommissionPackageDetailDocument, options);
      }
export type DeleteCompanyCommissionPackageDetailMutationHookResult = ReturnType<typeof useDeleteCompanyCommissionPackageDetailMutation>;
export type DeleteCompanyCommissionPackageDetailMutationResult = Apollo.MutationResult<DeleteCompanyCommissionPackageDetailMutation>;
export type DeleteCompanyCommissionPackageDetailMutationOptions = Apollo.BaseMutationOptions<DeleteCompanyCommissionPackageDetailMutation, DeleteCompanyCommissionPackageDetailMutationVariables>;
export const GetCompanyCommissionTeamListingDocument = gql`
    query getCompanyCommissionTeamListing {
  getCompanyCommissionTeamListing
}
    `;

/**
 * __useGetCompanyCommissionTeamListingQuery__
 *
 * To run a query within a React component, call `useGetCompanyCommissionTeamListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyCommissionTeamListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyCommissionTeamListingQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompanyCommissionTeamListingQuery(baseOptions?: Apollo.QueryHookOptions<GetCompanyCommissionTeamListingQuery, GetCompanyCommissionTeamListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyCommissionTeamListingQuery, GetCompanyCommissionTeamListingQueryVariables>(GetCompanyCommissionTeamListingDocument, options);
      }
export function useGetCompanyCommissionTeamListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyCommissionTeamListingQuery, GetCompanyCommissionTeamListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyCommissionTeamListingQuery, GetCompanyCommissionTeamListingQueryVariables>(GetCompanyCommissionTeamListingDocument, options);
        }
export type GetCompanyCommissionTeamListingQueryHookResult = ReturnType<typeof useGetCompanyCommissionTeamListingQuery>;
export type GetCompanyCommissionTeamListingLazyQueryHookResult = ReturnType<typeof useGetCompanyCommissionTeamListingLazyQuery>;
export type GetCompanyCommissionTeamListingQueryResult = Apollo.QueryResult<GetCompanyCommissionTeamListingQuery, GetCompanyCommissionTeamListingQueryVariables>;
export const GetPositionCodeOptionsByCompanyCommissionTeamDocument = gql`
    query getPositionCodeOptionsByCompanyCommissionTeam($principal: String!, $generateDate: DateTime!) {
  getPositionCodeOptionsByCompanyCommissionTeam(principal: $principal, generateDate: $generateDate) {
    positionId
    teamPositionId
    teamPositionName
  }
}
    `;

/**
 * __useGetPositionCodeOptionsByCompanyCommissionTeamQuery__
 *
 * To run a query within a React component, call `useGetPositionCodeOptionsByCompanyCommissionTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPositionCodeOptionsByCompanyCommissionTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPositionCodeOptionsByCompanyCommissionTeamQuery({
 *   variables: {
 *      principal: // value for 'principal'
 *      generateDate: // value for 'generateDate'
 *   },
 * });
 */
export function useGetPositionCodeOptionsByCompanyCommissionTeamQuery(baseOptions: Apollo.QueryHookOptions<GetPositionCodeOptionsByCompanyCommissionTeamQuery, GetPositionCodeOptionsByCompanyCommissionTeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPositionCodeOptionsByCompanyCommissionTeamQuery, GetPositionCodeOptionsByCompanyCommissionTeamQueryVariables>(GetPositionCodeOptionsByCompanyCommissionTeamDocument, options);
      }
export function useGetPositionCodeOptionsByCompanyCommissionTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPositionCodeOptionsByCompanyCommissionTeamQuery, GetPositionCodeOptionsByCompanyCommissionTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPositionCodeOptionsByCompanyCommissionTeamQuery, GetPositionCodeOptionsByCompanyCommissionTeamQueryVariables>(GetPositionCodeOptionsByCompanyCommissionTeamDocument, options);
        }
export type GetPositionCodeOptionsByCompanyCommissionTeamQueryHookResult = ReturnType<typeof useGetPositionCodeOptionsByCompanyCommissionTeamQuery>;
export type GetPositionCodeOptionsByCompanyCommissionTeamLazyQueryHookResult = ReturnType<typeof useGetPositionCodeOptionsByCompanyCommissionTeamLazyQuery>;
export type GetPositionCodeOptionsByCompanyCommissionTeamQueryResult = Apollo.QueryResult<GetPositionCodeOptionsByCompanyCommissionTeamQuery, GetPositionCodeOptionsByCompanyCommissionTeamQueryVariables>;
export const AddCompanyCommissionTeamDocument = gql`
    mutation addCompanyCommissionTeam($generateDate: DateTime!) {
  addCompanyCommissionTeam(generateDate: $generateDate)
}
    `;
export type AddCompanyCommissionTeamMutationFn = Apollo.MutationFunction<AddCompanyCommissionTeamMutation, AddCompanyCommissionTeamMutationVariables>;

/**
 * __useAddCompanyCommissionTeamMutation__
 *
 * To run a mutation, you first call `useAddCompanyCommissionTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCompanyCommissionTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCompanyCommissionTeamMutation, { data, loading, error }] = useAddCompanyCommissionTeamMutation({
 *   variables: {
 *      generateDate: // value for 'generateDate'
 *   },
 * });
 */
export function useAddCompanyCommissionTeamMutation(baseOptions?: Apollo.MutationHookOptions<AddCompanyCommissionTeamMutation, AddCompanyCommissionTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCompanyCommissionTeamMutation, AddCompanyCommissionTeamMutationVariables>(AddCompanyCommissionTeamDocument, options);
      }
export type AddCompanyCommissionTeamMutationHookResult = ReturnType<typeof useAddCompanyCommissionTeamMutation>;
export type AddCompanyCommissionTeamMutationResult = Apollo.MutationResult<AddCompanyCommissionTeamMutation>;
export type AddCompanyCommissionTeamMutationOptions = Apollo.BaseMutationOptions<AddCompanyCommissionTeamMutation, AddCompanyCommissionTeamMutationVariables>;
export const SubmitCompanyCommissionTeamDetailDocument = gql`
    mutation submitCompanyCommissionTeamDetail($input: companyCommissionTeamDetailInput!) {
  submitCompanyCommissionTeamDetail(input: $input)
}
    `;
export type SubmitCompanyCommissionTeamDetailMutationFn = Apollo.MutationFunction<SubmitCompanyCommissionTeamDetailMutation, SubmitCompanyCommissionTeamDetailMutationVariables>;

/**
 * __useSubmitCompanyCommissionTeamDetailMutation__
 *
 * To run a mutation, you first call `useSubmitCompanyCommissionTeamDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitCompanyCommissionTeamDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitCompanyCommissionTeamDetailMutation, { data, loading, error }] = useSubmitCompanyCommissionTeamDetailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitCompanyCommissionTeamDetailMutation(baseOptions?: Apollo.MutationHookOptions<SubmitCompanyCommissionTeamDetailMutation, SubmitCompanyCommissionTeamDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitCompanyCommissionTeamDetailMutation, SubmitCompanyCommissionTeamDetailMutationVariables>(SubmitCompanyCommissionTeamDetailDocument, options);
      }
export type SubmitCompanyCommissionTeamDetailMutationHookResult = ReturnType<typeof useSubmitCompanyCommissionTeamDetailMutation>;
export type SubmitCompanyCommissionTeamDetailMutationResult = Apollo.MutationResult<SubmitCompanyCommissionTeamDetailMutation>;
export type SubmitCompanyCommissionTeamDetailMutationOptions = Apollo.BaseMutationOptions<SubmitCompanyCommissionTeamDetailMutation, SubmitCompanyCommissionTeamDetailMutationVariables>;
export const DeleteCompanyCommissionTeamDetailDocument = gql`
    mutation deleteCompanyCommissionTeamDetail($id: String!) {
  deleteCompanyCommissionTeamDetail(id: $id)
}
    `;
export type DeleteCompanyCommissionTeamDetailMutationFn = Apollo.MutationFunction<DeleteCompanyCommissionTeamDetailMutation, DeleteCompanyCommissionTeamDetailMutationVariables>;

/**
 * __useDeleteCompanyCommissionTeamDetailMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyCommissionTeamDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyCommissionTeamDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanyCommissionTeamDetailMutation, { data, loading, error }] = useDeleteCompanyCommissionTeamDetailMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCompanyCommissionTeamDetailMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCompanyCommissionTeamDetailMutation, DeleteCompanyCommissionTeamDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCompanyCommissionTeamDetailMutation, DeleteCompanyCommissionTeamDetailMutationVariables>(DeleteCompanyCommissionTeamDetailDocument, options);
      }
export type DeleteCompanyCommissionTeamDetailMutationHookResult = ReturnType<typeof useDeleteCompanyCommissionTeamDetailMutation>;
export type DeleteCompanyCommissionTeamDetailMutationResult = Apollo.MutationResult<DeleteCompanyCommissionTeamDetailMutation>;
export type DeleteCompanyCommissionTeamDetailMutationOptions = Apollo.BaseMutationOptions<DeleteCompanyCommissionTeamDetailMutation, DeleteCompanyCommissionTeamDetailMutationVariables>;
export const GetCompanyRewardListingDocument = gql`
    query getCompanyRewardListing {
  getCompanyRewardListing {
    id
    companyId
    commissionTypeId
    description
    commonStatus
    commissionType {
      id
      name
      interval
      payOutType
      targetBy
      commonStatus
    }
    commissionPayments {
      id
      paidToDate
      release
      remarks
      commissionStatutoryDocs {
        id
        statutoryDocId
        commissionPaymentId
        statutoryDocument {
          id
          name
          code
        }
      }
    }
  }
}
    `;

/**
 * __useGetCompanyRewardListingQuery__
 *
 * To run a query within a React component, call `useGetCompanyRewardListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyRewardListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyRewardListingQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompanyRewardListingQuery(baseOptions?: Apollo.QueryHookOptions<GetCompanyRewardListingQuery, GetCompanyRewardListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyRewardListingQuery, GetCompanyRewardListingQueryVariables>(GetCompanyRewardListingDocument, options);
      }
export function useGetCompanyRewardListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyRewardListingQuery, GetCompanyRewardListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyRewardListingQuery, GetCompanyRewardListingQueryVariables>(GetCompanyRewardListingDocument, options);
        }
export type GetCompanyRewardListingQueryHookResult = ReturnType<typeof useGetCompanyRewardListingQuery>;
export type GetCompanyRewardListingLazyQueryHookResult = ReturnType<typeof useGetCompanyRewardListingLazyQuery>;
export type GetCompanyRewardListingQueryResult = Apollo.QueryResult<GetCompanyRewardListingQuery, GetCompanyRewardListingQueryVariables>;
export const SubmitCompanyRewardDocument = gql`
    mutation submitCompanyReward($commissionTypeId: String!, $description: String!, $id: String) {
  submitCompanyReward(commissionTypeId: $commissionTypeId, description: $description, id: $id)
}
    `;
export type SubmitCompanyRewardMutationFn = Apollo.MutationFunction<SubmitCompanyRewardMutation, SubmitCompanyRewardMutationVariables>;

/**
 * __useSubmitCompanyRewardMutation__
 *
 * To run a mutation, you first call `useSubmitCompanyRewardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitCompanyRewardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitCompanyRewardMutation, { data, loading, error }] = useSubmitCompanyRewardMutation({
 *   variables: {
 *      commissionTypeId: // value for 'commissionTypeId'
 *      description: // value for 'description'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSubmitCompanyRewardMutation(baseOptions?: Apollo.MutationHookOptions<SubmitCompanyRewardMutation, SubmitCompanyRewardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitCompanyRewardMutation, SubmitCompanyRewardMutationVariables>(SubmitCompanyRewardDocument, options);
      }
export type SubmitCompanyRewardMutationHookResult = ReturnType<typeof useSubmitCompanyRewardMutation>;
export type SubmitCompanyRewardMutationResult = Apollo.MutationResult<SubmitCompanyRewardMutation>;
export type SubmitCompanyRewardMutationOptions = Apollo.BaseMutationOptions<SubmitCompanyRewardMutation, SubmitCompanyRewardMutationVariables>;
export const DeleteCompanyRewardDocument = gql`
    mutation deleteCompanyReward($id: String!) {
  deleteCompanyReward(id: $id)
}
    `;
export type DeleteCompanyRewardMutationFn = Apollo.MutationFunction<DeleteCompanyRewardMutation, DeleteCompanyRewardMutationVariables>;

/**
 * __useDeleteCompanyRewardMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyRewardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyRewardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanyRewardMutation, { data, loading, error }] = useDeleteCompanyRewardMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCompanyRewardMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCompanyRewardMutation, DeleteCompanyRewardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCompanyRewardMutation, DeleteCompanyRewardMutationVariables>(DeleteCompanyRewardDocument, options);
      }
export type DeleteCompanyRewardMutationHookResult = ReturnType<typeof useDeleteCompanyRewardMutation>;
export type DeleteCompanyRewardMutationResult = Apollo.MutationResult<DeleteCompanyRewardMutation>;
export type DeleteCompanyRewardMutationOptions = Apollo.BaseMutationOptions<DeleteCompanyRewardMutation, DeleteCompanyRewardMutationVariables>;
export const AddCompanyRewardCommPaymentDocument = gql`
    mutation addCompanyRewardCommPayment($input: [commissionPaymentInput!]!) {
  addCompanyRewardCommPayment(input: $input)
}
    `;
export type AddCompanyRewardCommPaymentMutationFn = Apollo.MutationFunction<AddCompanyRewardCommPaymentMutation, AddCompanyRewardCommPaymentMutationVariables>;

/**
 * __useAddCompanyRewardCommPaymentMutation__
 *
 * To run a mutation, you first call `useAddCompanyRewardCommPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCompanyRewardCommPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCompanyRewardCommPaymentMutation, { data, loading, error }] = useAddCompanyRewardCommPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCompanyRewardCommPaymentMutation(baseOptions?: Apollo.MutationHookOptions<AddCompanyRewardCommPaymentMutation, AddCompanyRewardCommPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCompanyRewardCommPaymentMutation, AddCompanyRewardCommPaymentMutationVariables>(AddCompanyRewardCommPaymentDocument, options);
      }
export type AddCompanyRewardCommPaymentMutationHookResult = ReturnType<typeof useAddCompanyRewardCommPaymentMutation>;
export type AddCompanyRewardCommPaymentMutationResult = Apollo.MutationResult<AddCompanyRewardCommPaymentMutation>;
export type AddCompanyRewardCommPaymentMutationOptions = Apollo.BaseMutationOptions<AddCompanyRewardCommPaymentMutation, AddCompanyRewardCommPaymentMutationVariables>;
export const EditCompanyRewardCommPaymentDocument = gql`
    mutation editCompanyRewardCommPayment($input: commissionPaymentInput!) {
  editCompanyRewardCommPayment(input: $input)
}
    `;
export type EditCompanyRewardCommPaymentMutationFn = Apollo.MutationFunction<EditCompanyRewardCommPaymentMutation, EditCompanyRewardCommPaymentMutationVariables>;

/**
 * __useEditCompanyRewardCommPaymentMutation__
 *
 * To run a mutation, you first call `useEditCompanyRewardCommPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCompanyRewardCommPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCompanyRewardCommPaymentMutation, { data, loading, error }] = useEditCompanyRewardCommPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditCompanyRewardCommPaymentMutation(baseOptions?: Apollo.MutationHookOptions<EditCompanyRewardCommPaymentMutation, EditCompanyRewardCommPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCompanyRewardCommPaymentMutation, EditCompanyRewardCommPaymentMutationVariables>(EditCompanyRewardCommPaymentDocument, options);
      }
export type EditCompanyRewardCommPaymentMutationHookResult = ReturnType<typeof useEditCompanyRewardCommPaymentMutation>;
export type EditCompanyRewardCommPaymentMutationResult = Apollo.MutationResult<EditCompanyRewardCommPaymentMutation>;
export type EditCompanyRewardCommPaymentMutationOptions = Apollo.BaseMutationOptions<EditCompanyRewardCommPaymentMutation, EditCompanyRewardCommPaymentMutationVariables>;
export const DeleteCompanyRewardCommPaymentDocument = gql`
    mutation deleteCompanyRewardCommPayment($id: String!) {
  deleteCompanyRewardCommPayment(id: $id)
}
    `;
export type DeleteCompanyRewardCommPaymentMutationFn = Apollo.MutationFunction<DeleteCompanyRewardCommPaymentMutation, DeleteCompanyRewardCommPaymentMutationVariables>;

/**
 * __useDeleteCompanyRewardCommPaymentMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyRewardCommPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyRewardCommPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanyRewardCommPaymentMutation, { data, loading, error }] = useDeleteCompanyRewardCommPaymentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCompanyRewardCommPaymentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCompanyRewardCommPaymentMutation, DeleteCompanyRewardCommPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCompanyRewardCommPaymentMutation, DeleteCompanyRewardCommPaymentMutationVariables>(DeleteCompanyRewardCommPaymentDocument, options);
      }
export type DeleteCompanyRewardCommPaymentMutationHookResult = ReturnType<typeof useDeleteCompanyRewardCommPaymentMutation>;
export type DeleteCompanyRewardCommPaymentMutationResult = Apollo.MutationResult<DeleteCompanyRewardCommPaymentMutation>;
export type DeleteCompanyRewardCommPaymentMutationOptions = Apollo.BaseMutationOptions<DeleteCompanyRewardCommPaymentMutation, DeleteCompanyRewardCommPaymentMutationVariables>;
export const SubmitCompanyRewardCommStatutoryDocDocument = gql`
    mutation submitCompanyRewardCommStatutoryDoc($commissionPaymentId: String!, $statutoryDocId: String!, $id: String) {
  submitCompanyRewardCommStatutoryDoc(commissionPaymentId: $commissionPaymentId, statutoryDocId: $statutoryDocId, id: $id)
}
    `;
export type SubmitCompanyRewardCommStatutoryDocMutationFn = Apollo.MutationFunction<SubmitCompanyRewardCommStatutoryDocMutation, SubmitCompanyRewardCommStatutoryDocMutationVariables>;

/**
 * __useSubmitCompanyRewardCommStatutoryDocMutation__
 *
 * To run a mutation, you first call `useSubmitCompanyRewardCommStatutoryDocMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitCompanyRewardCommStatutoryDocMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitCompanyRewardCommStatutoryDocMutation, { data, loading, error }] = useSubmitCompanyRewardCommStatutoryDocMutation({
 *   variables: {
 *      commissionPaymentId: // value for 'commissionPaymentId'
 *      statutoryDocId: // value for 'statutoryDocId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSubmitCompanyRewardCommStatutoryDocMutation(baseOptions?: Apollo.MutationHookOptions<SubmitCompanyRewardCommStatutoryDocMutation, SubmitCompanyRewardCommStatutoryDocMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitCompanyRewardCommStatutoryDocMutation, SubmitCompanyRewardCommStatutoryDocMutationVariables>(SubmitCompanyRewardCommStatutoryDocDocument, options);
      }
export type SubmitCompanyRewardCommStatutoryDocMutationHookResult = ReturnType<typeof useSubmitCompanyRewardCommStatutoryDocMutation>;
export type SubmitCompanyRewardCommStatutoryDocMutationResult = Apollo.MutationResult<SubmitCompanyRewardCommStatutoryDocMutation>;
export type SubmitCompanyRewardCommStatutoryDocMutationOptions = Apollo.BaseMutationOptions<SubmitCompanyRewardCommStatutoryDocMutation, SubmitCompanyRewardCommStatutoryDocMutationVariables>;
export const DeleteCompanyRewardCommStatutoryDocDocument = gql`
    mutation deleteCompanyRewardCommStatutoryDoc($id: String!) {
  deleteCompanyRewardCommStatutoryDoc(id: $id)
}
    `;
export type DeleteCompanyRewardCommStatutoryDocMutationFn = Apollo.MutationFunction<DeleteCompanyRewardCommStatutoryDocMutation, DeleteCompanyRewardCommStatutoryDocMutationVariables>;

/**
 * __useDeleteCompanyRewardCommStatutoryDocMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyRewardCommStatutoryDocMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyRewardCommStatutoryDocMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanyRewardCommStatutoryDocMutation, { data, loading, error }] = useDeleteCompanyRewardCommStatutoryDocMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCompanyRewardCommStatutoryDocMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCompanyRewardCommStatutoryDocMutation, DeleteCompanyRewardCommStatutoryDocMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCompanyRewardCommStatutoryDocMutation, DeleteCompanyRewardCommStatutoryDocMutationVariables>(DeleteCompanyRewardCommStatutoryDocDocument, options);
      }
export type DeleteCompanyRewardCommStatutoryDocMutationHookResult = ReturnType<typeof useDeleteCompanyRewardCommStatutoryDocMutation>;
export type DeleteCompanyRewardCommStatutoryDocMutationResult = Apollo.MutationResult<DeleteCompanyRewardCommStatutoryDocMutation>;
export type DeleteCompanyRewardCommStatutoryDocMutationOptions = Apollo.BaseMutationOptions<DeleteCompanyRewardCommStatutoryDocMutation, DeleteCompanyRewardCommStatutoryDocMutationVariables>;
export const GetCompanyRewardCountDocument = gql`
    query getCompanyRewardCount {
  getCompanyRewardCount
}
    `;

/**
 * __useGetCompanyRewardCountQuery__
 *
 * To run a query within a React component, call `useGetCompanyRewardCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyRewardCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyRewardCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompanyRewardCountQuery(baseOptions?: Apollo.QueryHookOptions<GetCompanyRewardCountQuery, GetCompanyRewardCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyRewardCountQuery, GetCompanyRewardCountQueryVariables>(GetCompanyRewardCountDocument, options);
      }
export function useGetCompanyRewardCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyRewardCountQuery, GetCompanyRewardCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyRewardCountQuery, GetCompanyRewardCountQueryVariables>(GetCompanyRewardCountDocument, options);
        }
export type GetCompanyRewardCountQueryHookResult = ReturnType<typeof useGetCompanyRewardCountQuery>;
export type GetCompanyRewardCountLazyQueryHookResult = ReturnType<typeof useGetCompanyRewardCountLazyQuery>;
export type GetCompanyRewardCountQueryResult = Apollo.QueryResult<GetCompanyRewardCountQuery, GetCompanyRewardCountQueryVariables>;
export const GetProjectCommissionsDocument = gql`
    query getProjectCommissions($projectId: String!) {
  getProjectCommissions(projectId: $projectId) {
    id
    description
    interval
    payOutType
    targetBy
    rateClassification
    commissionPayments {
      id
      paidToDate
      release
      remarks
      commissionStatutoryDocuments {
        id
        code
        name
        statutoryDocId
      }
    }
    canEditOrDelete
  }
}
    `;

/**
 * __useGetProjectCommissionsQuery__
 *
 * To run a query within a React component, call `useGetProjectCommissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectCommissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectCommissionsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetProjectCommissionsQuery(baseOptions: Apollo.QueryHookOptions<GetProjectCommissionsQuery, GetProjectCommissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectCommissionsQuery, GetProjectCommissionsQueryVariables>(GetProjectCommissionsDocument, options);
      }
export function useGetProjectCommissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectCommissionsQuery, GetProjectCommissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectCommissionsQuery, GetProjectCommissionsQueryVariables>(GetProjectCommissionsDocument, options);
        }
export type GetProjectCommissionsQueryHookResult = ReturnType<typeof useGetProjectCommissionsQuery>;
export type GetProjectCommissionsLazyQueryHookResult = ReturnType<typeof useGetProjectCommissionsLazyQuery>;
export type GetProjectCommissionsQueryResult = Apollo.QueryResult<GetProjectCommissionsQuery, GetProjectCommissionsQueryVariables>;
export const GetProjectCommissionByIdDocument = gql`
    query getProjectCommissionById($id: String!) {
  getProjectCommissionById(id: $id) {
    id
    description
    rateClassification
    commissionTypeId
  }
}
    `;

/**
 * __useGetProjectCommissionByIdQuery__
 *
 * To run a query within a React component, call `useGetProjectCommissionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectCommissionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectCommissionByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectCommissionByIdQuery(baseOptions: Apollo.QueryHookOptions<GetProjectCommissionByIdQuery, GetProjectCommissionByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectCommissionByIdQuery, GetProjectCommissionByIdQueryVariables>(GetProjectCommissionByIdDocument, options);
      }
export function useGetProjectCommissionByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectCommissionByIdQuery, GetProjectCommissionByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectCommissionByIdQuery, GetProjectCommissionByIdQueryVariables>(GetProjectCommissionByIdDocument, options);
        }
export type GetProjectCommissionByIdQueryHookResult = ReturnType<typeof useGetProjectCommissionByIdQuery>;
export type GetProjectCommissionByIdLazyQueryHookResult = ReturnType<typeof useGetProjectCommissionByIdLazyQuery>;
export type GetProjectCommissionByIdQueryResult = Apollo.QueryResult<GetProjectCommissionByIdQuery, GetProjectCommissionByIdQueryVariables>;
export const AddProjectCommisionDocument = gql`
    mutation addProjectCommision($input: AddProjectCommissionInput!) {
  addProjectCommission(input: $input)
}
    `;
export type AddProjectCommisionMutationFn = Apollo.MutationFunction<AddProjectCommisionMutation, AddProjectCommisionMutationVariables>;

/**
 * __useAddProjectCommisionMutation__
 *
 * To run a mutation, you first call `useAddProjectCommisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProjectCommisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProjectCommisionMutation, { data, loading, error }] = useAddProjectCommisionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddProjectCommisionMutation(baseOptions?: Apollo.MutationHookOptions<AddProjectCommisionMutation, AddProjectCommisionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProjectCommisionMutation, AddProjectCommisionMutationVariables>(AddProjectCommisionDocument, options);
      }
export type AddProjectCommisionMutationHookResult = ReturnType<typeof useAddProjectCommisionMutation>;
export type AddProjectCommisionMutationResult = Apollo.MutationResult<AddProjectCommisionMutation>;
export type AddProjectCommisionMutationOptions = Apollo.BaseMutationOptions<AddProjectCommisionMutation, AddProjectCommisionMutationVariables>;
export const EditProjectCommissionByIdDocument = gql`
    mutation editProjectCommissionById($id: String!, $input: EditProjectCommissionInput!) {
  editProjectCommissionById(id: $id, input: $input)
}
    `;
export type EditProjectCommissionByIdMutationFn = Apollo.MutationFunction<EditProjectCommissionByIdMutation, EditProjectCommissionByIdMutationVariables>;

/**
 * __useEditProjectCommissionByIdMutation__
 *
 * To run a mutation, you first call `useEditProjectCommissionByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditProjectCommissionByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editProjectCommissionByIdMutation, { data, loading, error }] = useEditProjectCommissionByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditProjectCommissionByIdMutation(baseOptions?: Apollo.MutationHookOptions<EditProjectCommissionByIdMutation, EditProjectCommissionByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditProjectCommissionByIdMutation, EditProjectCommissionByIdMutationVariables>(EditProjectCommissionByIdDocument, options);
      }
export type EditProjectCommissionByIdMutationHookResult = ReturnType<typeof useEditProjectCommissionByIdMutation>;
export type EditProjectCommissionByIdMutationResult = Apollo.MutationResult<EditProjectCommissionByIdMutation>;
export type EditProjectCommissionByIdMutationOptions = Apollo.BaseMutationOptions<EditProjectCommissionByIdMutation, EditProjectCommissionByIdMutationVariables>;
export const DeleteProjectCommissionByIdDocument = gql`
    mutation deleteProjectCommissionById($id: String!) {
  deleteProjectCommissionById(id: $id)
}
    `;
export type DeleteProjectCommissionByIdMutationFn = Apollo.MutationFunction<DeleteProjectCommissionByIdMutation, DeleteProjectCommissionByIdMutationVariables>;

/**
 * __useDeleteProjectCommissionByIdMutation__
 *
 * To run a mutation, you first call `useDeleteProjectCommissionByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectCommissionByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectCommissionByIdMutation, { data, loading, error }] = useDeleteProjectCommissionByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProjectCommissionByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectCommissionByIdMutation, DeleteProjectCommissionByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectCommissionByIdMutation, DeleteProjectCommissionByIdMutationVariables>(DeleteProjectCommissionByIdDocument, options);
      }
export type DeleteProjectCommissionByIdMutationHookResult = ReturnType<typeof useDeleteProjectCommissionByIdMutation>;
export type DeleteProjectCommissionByIdMutationResult = Apollo.MutationResult<DeleteProjectCommissionByIdMutation>;
export type DeleteProjectCommissionByIdMutationOptions = Apollo.BaseMutationOptions<DeleteProjectCommissionByIdMutation, DeleteProjectCommissionByIdMutationVariables>;
export const GetProjectCommissionPackageListingDocument = gql`
    query getProjectCommissionPackageListing($projectId: String!, $principal: String!) {
  getProjectCommissionPackageListing(projectId: $projectId, principal: $principal)
}
    `;

/**
 * __useGetProjectCommissionPackageListingQuery__
 *
 * To run a query within a React component, call `useGetProjectCommissionPackageListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectCommissionPackageListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectCommissionPackageListingQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      principal: // value for 'principal'
 *   },
 * });
 */
export function useGetProjectCommissionPackageListingQuery(baseOptions: Apollo.QueryHookOptions<GetProjectCommissionPackageListingQuery, GetProjectCommissionPackageListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectCommissionPackageListingQuery, GetProjectCommissionPackageListingQueryVariables>(GetProjectCommissionPackageListingDocument, options);
      }
export function useGetProjectCommissionPackageListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectCommissionPackageListingQuery, GetProjectCommissionPackageListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectCommissionPackageListingQuery, GetProjectCommissionPackageListingQueryVariables>(GetProjectCommissionPackageListingDocument, options);
        }
export type GetProjectCommissionPackageListingQueryHookResult = ReturnType<typeof useGetProjectCommissionPackageListingQuery>;
export type GetProjectCommissionPackageListingLazyQueryHookResult = ReturnType<typeof useGetProjectCommissionPackageListingLazyQuery>;
export type GetProjectCommissionPackageListingQueryResult = Apollo.QueryResult<GetProjectCommissionPackageListingQuery, GetProjectCommissionPackageListingQueryVariables>;
export const AddProjectCommissionPackageDocument = gql`
    mutation addProjectCommissionPackage($projectCommissionId: String!, $principal: String!) {
  addProjectCommissionPackage(projectCommissionId: $projectCommissionId, principal: $principal)
}
    `;
export type AddProjectCommissionPackageMutationFn = Apollo.MutationFunction<AddProjectCommissionPackageMutation, AddProjectCommissionPackageMutationVariables>;

/**
 * __useAddProjectCommissionPackageMutation__
 *
 * To run a mutation, you first call `useAddProjectCommissionPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProjectCommissionPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProjectCommissionPackageMutation, { data, loading, error }] = useAddProjectCommissionPackageMutation({
 *   variables: {
 *      projectCommissionId: // value for 'projectCommissionId'
 *      principal: // value for 'principal'
 *   },
 * });
 */
export function useAddProjectCommissionPackageMutation(baseOptions?: Apollo.MutationHookOptions<AddProjectCommissionPackageMutation, AddProjectCommissionPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProjectCommissionPackageMutation, AddProjectCommissionPackageMutationVariables>(AddProjectCommissionPackageDocument, options);
      }
export type AddProjectCommissionPackageMutationHookResult = ReturnType<typeof useAddProjectCommissionPackageMutation>;
export type AddProjectCommissionPackageMutationResult = Apollo.MutationResult<AddProjectCommissionPackageMutation>;
export type AddProjectCommissionPackageMutationOptions = Apollo.BaseMutationOptions<AddProjectCommissionPackageMutation, AddProjectCommissionPackageMutationVariables>;
export const AddProjectCommissionPackageDetailDocument = gql`
    mutation addProjectCommissionPackageDetail($input: ProjectCommissionPackageDetailInput!) {
  addProjectCommissionPackageDetail(input: $input)
}
    `;
export type AddProjectCommissionPackageDetailMutationFn = Apollo.MutationFunction<AddProjectCommissionPackageDetailMutation, AddProjectCommissionPackageDetailMutationVariables>;

/**
 * __useAddProjectCommissionPackageDetailMutation__
 *
 * To run a mutation, you first call `useAddProjectCommissionPackageDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProjectCommissionPackageDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProjectCommissionPackageDetailMutation, { data, loading, error }] = useAddProjectCommissionPackageDetailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddProjectCommissionPackageDetailMutation(baseOptions?: Apollo.MutationHookOptions<AddProjectCommissionPackageDetailMutation, AddProjectCommissionPackageDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProjectCommissionPackageDetailMutation, AddProjectCommissionPackageDetailMutationVariables>(AddProjectCommissionPackageDetailDocument, options);
      }
export type AddProjectCommissionPackageDetailMutationHookResult = ReturnType<typeof useAddProjectCommissionPackageDetailMutation>;
export type AddProjectCommissionPackageDetailMutationResult = Apollo.MutationResult<AddProjectCommissionPackageDetailMutation>;
export type AddProjectCommissionPackageDetailMutationOptions = Apollo.BaseMutationOptions<AddProjectCommissionPackageDetailMutation, AddProjectCommissionPackageDetailMutationVariables>;
export const EditProjectCommissionPackageDetailDocument = gql`
    mutation editProjectCommissionPackageDetail($input: ProjectCommissionPackageDetailInput!) {
  editProjectCommissionPackageDetail(input: $input)
}
    `;
export type EditProjectCommissionPackageDetailMutationFn = Apollo.MutationFunction<EditProjectCommissionPackageDetailMutation, EditProjectCommissionPackageDetailMutationVariables>;

/**
 * __useEditProjectCommissionPackageDetailMutation__
 *
 * To run a mutation, you first call `useEditProjectCommissionPackageDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditProjectCommissionPackageDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editProjectCommissionPackageDetailMutation, { data, loading, error }] = useEditProjectCommissionPackageDetailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditProjectCommissionPackageDetailMutation(baseOptions?: Apollo.MutationHookOptions<EditProjectCommissionPackageDetailMutation, EditProjectCommissionPackageDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditProjectCommissionPackageDetailMutation, EditProjectCommissionPackageDetailMutationVariables>(EditProjectCommissionPackageDetailDocument, options);
      }
export type EditProjectCommissionPackageDetailMutationHookResult = ReturnType<typeof useEditProjectCommissionPackageDetailMutation>;
export type EditProjectCommissionPackageDetailMutationResult = Apollo.MutationResult<EditProjectCommissionPackageDetailMutation>;
export type EditProjectCommissionPackageDetailMutationOptions = Apollo.BaseMutationOptions<EditProjectCommissionPackageDetailMutation, EditProjectCommissionPackageDetailMutationVariables>;
export const DeleteProjectCommissionPackageDetailDocument = gql`
    mutation deleteProjectCommissionPackageDetail($id: String!) {
  deleteProjectCommissionPackageDetail(id: $id)
}
    `;
export type DeleteProjectCommissionPackageDetailMutationFn = Apollo.MutationFunction<DeleteProjectCommissionPackageDetailMutation, DeleteProjectCommissionPackageDetailMutationVariables>;

/**
 * __useDeleteProjectCommissionPackageDetailMutation__
 *
 * To run a mutation, you first call `useDeleteProjectCommissionPackageDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectCommissionPackageDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectCommissionPackageDetailMutation, { data, loading, error }] = useDeleteProjectCommissionPackageDetailMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProjectCommissionPackageDetailMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectCommissionPackageDetailMutation, DeleteProjectCommissionPackageDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectCommissionPackageDetailMutation, DeleteProjectCommissionPackageDetailMutationVariables>(DeleteProjectCommissionPackageDetailDocument, options);
      }
export type DeleteProjectCommissionPackageDetailMutationHookResult = ReturnType<typeof useDeleteProjectCommissionPackageDetailMutation>;
export type DeleteProjectCommissionPackageDetailMutationResult = Apollo.MutationResult<DeleteProjectCommissionPackageDetailMutation>;
export type DeleteProjectCommissionPackageDetailMutationOptions = Apollo.BaseMutationOptions<DeleteProjectCommissionPackageDetailMutation, DeleteProjectCommissionPackageDetailMutationVariables>;
export const GetProjectCommissionOptionsDocument = gql`
    query getProjectCommissionOptions($projectId: String!) {
  getProjectCommissionOptions(projectId: $projectId) {
    id
    description
    rateClassification
    commissionType {
      id
      name
      interval
      payOutType
      targetBy
    }
  }
}
    `;

/**
 * __useGetProjectCommissionOptionsQuery__
 *
 * To run a query within a React component, call `useGetProjectCommissionOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectCommissionOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectCommissionOptionsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetProjectCommissionOptionsQuery(baseOptions: Apollo.QueryHookOptions<GetProjectCommissionOptionsQuery, GetProjectCommissionOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectCommissionOptionsQuery, GetProjectCommissionOptionsQueryVariables>(GetProjectCommissionOptionsDocument, options);
      }
export function useGetProjectCommissionOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectCommissionOptionsQuery, GetProjectCommissionOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectCommissionOptionsQuery, GetProjectCommissionOptionsQueryVariables>(GetProjectCommissionOptionsDocument, options);
        }
export type GetProjectCommissionOptionsQueryHookResult = ReturnType<typeof useGetProjectCommissionOptionsQuery>;
export type GetProjectCommissionOptionsLazyQueryHookResult = ReturnType<typeof useGetProjectCommissionOptionsLazyQuery>;
export type GetProjectCommissionOptionsQueryResult = Apollo.QueryResult<GetProjectCommissionOptionsQuery, GetProjectCommissionOptionsQueryVariables>;
export const GetProjectCommissionTeamStructureListingDocument = gql`
    query getProjectCommissionTeamStructureListing($projectId: String!) {
  getProjectCommissionTeamStructureListing(projectId: $projectId)
}
    `;

/**
 * __useGetProjectCommissionTeamStructureListingQuery__
 *
 * To run a query within a React component, call `useGetProjectCommissionTeamStructureListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectCommissionTeamStructureListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectCommissionTeamStructureListingQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetProjectCommissionTeamStructureListingQuery(baseOptions: Apollo.QueryHookOptions<GetProjectCommissionTeamStructureListingQuery, GetProjectCommissionTeamStructureListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectCommissionTeamStructureListingQuery, GetProjectCommissionTeamStructureListingQueryVariables>(GetProjectCommissionTeamStructureListingDocument, options);
      }
export function useGetProjectCommissionTeamStructureListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectCommissionTeamStructureListingQuery, GetProjectCommissionTeamStructureListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectCommissionTeamStructureListingQuery, GetProjectCommissionTeamStructureListingQueryVariables>(GetProjectCommissionTeamStructureListingDocument, options);
        }
export type GetProjectCommissionTeamStructureListingQueryHookResult = ReturnType<typeof useGetProjectCommissionTeamStructureListingQuery>;
export type GetProjectCommissionTeamStructureListingLazyQueryHookResult = ReturnType<typeof useGetProjectCommissionTeamStructureListingLazyQuery>;
export type GetProjectCommissionTeamStructureListingQueryResult = Apollo.QueryResult<GetProjectCommissionTeamStructureListingQuery, GetProjectCommissionTeamStructureListingQueryVariables>;
export const SetProjectCommissionTeamDocument = gql`
    mutation setProjectCommissionTeam($projectCommissionTeamInput: projectCommissionTeamInput!) {
  setProjectCommissionTeam(input: $projectCommissionTeamInput)
}
    `;
export type SetProjectCommissionTeamMutationFn = Apollo.MutationFunction<SetProjectCommissionTeamMutation, SetProjectCommissionTeamMutationVariables>;

/**
 * __useSetProjectCommissionTeamMutation__
 *
 * To run a mutation, you first call `useSetProjectCommissionTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetProjectCommissionTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setProjectCommissionTeamMutation, { data, loading, error }] = useSetProjectCommissionTeamMutation({
 *   variables: {
 *      projectCommissionTeamInput: // value for 'projectCommissionTeamInput'
 *   },
 * });
 */
export function useSetProjectCommissionTeamMutation(baseOptions?: Apollo.MutationHookOptions<SetProjectCommissionTeamMutation, SetProjectCommissionTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetProjectCommissionTeamMutation, SetProjectCommissionTeamMutationVariables>(SetProjectCommissionTeamDocument, options);
      }
export type SetProjectCommissionTeamMutationHookResult = ReturnType<typeof useSetProjectCommissionTeamMutation>;
export type SetProjectCommissionTeamMutationResult = Apollo.MutationResult<SetProjectCommissionTeamMutation>;
export type SetProjectCommissionTeamMutationOptions = Apollo.BaseMutationOptions<SetProjectCommissionTeamMutation, SetProjectCommissionTeamMutationVariables>;
export const DeleteProjectCommissionTeamDocument = gql`
    mutation deleteProjectCommissionTeam($id: String!) {
  deleteProjectCommissionTeam(id: $id)
}
    `;
export type DeleteProjectCommissionTeamMutationFn = Apollo.MutationFunction<DeleteProjectCommissionTeamMutation, DeleteProjectCommissionTeamMutationVariables>;

/**
 * __useDeleteProjectCommissionTeamMutation__
 *
 * To run a mutation, you first call `useDeleteProjectCommissionTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectCommissionTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectCommissionTeamMutation, { data, loading, error }] = useDeleteProjectCommissionTeamMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProjectCommissionTeamMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectCommissionTeamMutation, DeleteProjectCommissionTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectCommissionTeamMutation, DeleteProjectCommissionTeamMutationVariables>(DeleteProjectCommissionTeamDocument, options);
      }
export type DeleteProjectCommissionTeamMutationHookResult = ReturnType<typeof useDeleteProjectCommissionTeamMutation>;
export type DeleteProjectCommissionTeamMutationResult = Apollo.MutationResult<DeleteProjectCommissionTeamMutation>;
export type DeleteProjectCommissionTeamMutationOptions = Apollo.BaseMutationOptions<DeleteProjectCommissionTeamMutation, DeleteProjectCommissionTeamMutationVariables>;
export const SetProjectCommissionTeamDetailDocument = gql`
    mutation setProjectCommissionTeamDetail($input: projectCommissionTeamDetailInput!) {
  setProjectCommissionTeamDetail(input: $input)
}
    `;
export type SetProjectCommissionTeamDetailMutationFn = Apollo.MutationFunction<SetProjectCommissionTeamDetailMutation, SetProjectCommissionTeamDetailMutationVariables>;

/**
 * __useSetProjectCommissionTeamDetailMutation__
 *
 * To run a mutation, you first call `useSetProjectCommissionTeamDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetProjectCommissionTeamDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setProjectCommissionTeamDetailMutation, { data, loading, error }] = useSetProjectCommissionTeamDetailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetProjectCommissionTeamDetailMutation(baseOptions?: Apollo.MutationHookOptions<SetProjectCommissionTeamDetailMutation, SetProjectCommissionTeamDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetProjectCommissionTeamDetailMutation, SetProjectCommissionTeamDetailMutationVariables>(SetProjectCommissionTeamDetailDocument, options);
      }
export type SetProjectCommissionTeamDetailMutationHookResult = ReturnType<typeof useSetProjectCommissionTeamDetailMutation>;
export type SetProjectCommissionTeamDetailMutationResult = Apollo.MutationResult<SetProjectCommissionTeamDetailMutation>;
export type SetProjectCommissionTeamDetailMutationOptions = Apollo.BaseMutationOptions<SetProjectCommissionTeamDetailMutation, SetProjectCommissionTeamDetailMutationVariables>;
export const DeleteProjectCommissionTeamDetailDocument = gql`
    mutation deleteProjectCommissionTeamDetail($id: String!) {
  deleteProjectCommissionTeamDetail(id: $id)
}
    `;
export type DeleteProjectCommissionTeamDetailMutationFn = Apollo.MutationFunction<DeleteProjectCommissionTeamDetailMutation, DeleteProjectCommissionTeamDetailMutationVariables>;

/**
 * __useDeleteProjectCommissionTeamDetailMutation__
 *
 * To run a mutation, you first call `useDeleteProjectCommissionTeamDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectCommissionTeamDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectCommissionTeamDetailMutation, { data, loading, error }] = useDeleteProjectCommissionTeamDetailMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProjectCommissionTeamDetailMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectCommissionTeamDetailMutation, DeleteProjectCommissionTeamDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectCommissionTeamDetailMutation, DeleteProjectCommissionTeamDetailMutationVariables>(DeleteProjectCommissionTeamDetailDocument, options);
      }
export type DeleteProjectCommissionTeamDetailMutationHookResult = ReturnType<typeof useDeleteProjectCommissionTeamDetailMutation>;
export type DeleteProjectCommissionTeamDetailMutationResult = Apollo.MutationResult<DeleteProjectCommissionTeamDetailMutation>;
export type DeleteProjectCommissionTeamDetailMutationOptions = Apollo.BaseMutationOptions<DeleteProjectCommissionTeamDetailMutation, DeleteProjectCommissionTeamDetailMutationVariables>;
export const GetProjectCommissionTeamAgencyAppointedDocument = gql`
    query getProjectCommissionTeamAgencyAppointed($projectId: String!) {
  getProjectCommissionTeamAgencyAppointed(projectId: $projectId) {
    id
    name
  }
}
    `;

/**
 * __useGetProjectCommissionTeamAgencyAppointedQuery__
 *
 * To run a query within a React component, call `useGetProjectCommissionTeamAgencyAppointedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectCommissionTeamAgencyAppointedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectCommissionTeamAgencyAppointedQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetProjectCommissionTeamAgencyAppointedQuery(baseOptions: Apollo.QueryHookOptions<GetProjectCommissionTeamAgencyAppointedQuery, GetProjectCommissionTeamAgencyAppointedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectCommissionTeamAgencyAppointedQuery, GetProjectCommissionTeamAgencyAppointedQueryVariables>(GetProjectCommissionTeamAgencyAppointedDocument, options);
      }
export function useGetProjectCommissionTeamAgencyAppointedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectCommissionTeamAgencyAppointedQuery, GetProjectCommissionTeamAgencyAppointedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectCommissionTeamAgencyAppointedQuery, GetProjectCommissionTeamAgencyAppointedQueryVariables>(GetProjectCommissionTeamAgencyAppointedDocument, options);
        }
export type GetProjectCommissionTeamAgencyAppointedQueryHookResult = ReturnType<typeof useGetProjectCommissionTeamAgencyAppointedQuery>;
export type GetProjectCommissionTeamAgencyAppointedLazyQueryHookResult = ReturnType<typeof useGetProjectCommissionTeamAgencyAppointedLazyQuery>;
export type GetProjectCommissionTeamAgencyAppointedQueryResult = Apollo.QueryResult<GetProjectCommissionTeamAgencyAppointedQuery, GetProjectCommissionTeamAgencyAppointedQueryVariables>;
export const GetProjectNameByIdDocument = gql`
    query getProjectNameById($projectId: String!) {
  getProjectById(projectId: $projectId) {
    id
    name
  }
}
    `;

/**
 * __useGetProjectNameByIdQuery__
 *
 * To run a query within a React component, call `useGetProjectNameByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectNameByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectNameByIdQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetProjectNameByIdQuery(baseOptions: Apollo.QueryHookOptions<GetProjectNameByIdQuery, GetProjectNameByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectNameByIdQuery, GetProjectNameByIdQueryVariables>(GetProjectNameByIdDocument, options);
      }
export function useGetProjectNameByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectNameByIdQuery, GetProjectNameByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectNameByIdQuery, GetProjectNameByIdQueryVariables>(GetProjectNameByIdDocument, options);
        }
export type GetProjectNameByIdQueryHookResult = ReturnType<typeof useGetProjectNameByIdQuery>;
export type GetProjectNameByIdLazyQueryHookResult = ReturnType<typeof useGetProjectNameByIdLazyQuery>;
export type GetProjectNameByIdQueryResult = Apollo.QueryResult<GetProjectNameByIdQuery, GetProjectNameByIdQueryVariables>;
export const GetAllJobPositionDocument = gql`
    query getAllJobPosition($projectId: String!) {
  getAllJobPosition(projectId: $projectId) {
    jobPositions {
      id
      position
      countOfEmployee
    }
    recentModTs
  }
}
    `;

/**
 * __useGetAllJobPositionQuery__
 *
 * To run a query within a React component, call `useGetAllJobPositionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllJobPositionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllJobPositionQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetAllJobPositionQuery(baseOptions: Apollo.QueryHookOptions<GetAllJobPositionQuery, GetAllJobPositionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllJobPositionQuery, GetAllJobPositionQueryVariables>(GetAllJobPositionDocument, options);
      }
export function useGetAllJobPositionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllJobPositionQuery, GetAllJobPositionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllJobPositionQuery, GetAllJobPositionQueryVariables>(GetAllJobPositionDocument, options);
        }
export type GetAllJobPositionQueryHookResult = ReturnType<typeof useGetAllJobPositionQuery>;
export type GetAllJobPositionLazyQueryHookResult = ReturnType<typeof useGetAllJobPositionLazyQuery>;
export type GetAllJobPositionQueryResult = Apollo.QueryResult<GetAllJobPositionQuery, GetAllJobPositionQueryVariables>;
export const AddJobPositionDocument = gql`
    mutation addJobPosition($input: addJobPositionInput!) {
  addJobPosition(input: $input)
}
    `;
export type AddJobPositionMutationFn = Apollo.MutationFunction<AddJobPositionMutation, AddJobPositionMutationVariables>;

/**
 * __useAddJobPositionMutation__
 *
 * To run a mutation, you first call `useAddJobPositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddJobPositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addJobPositionMutation, { data, loading, error }] = useAddJobPositionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddJobPositionMutation(baseOptions?: Apollo.MutationHookOptions<AddJobPositionMutation, AddJobPositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddJobPositionMutation, AddJobPositionMutationVariables>(AddJobPositionDocument, options);
      }
export type AddJobPositionMutationHookResult = ReturnType<typeof useAddJobPositionMutation>;
export type AddJobPositionMutationResult = Apollo.MutationResult<AddJobPositionMutation>;
export type AddJobPositionMutationOptions = Apollo.BaseMutationOptions<AddJobPositionMutation, AddJobPositionMutationVariables>;
export const DeleteJobPositionDocument = gql`
    mutation deleteJobPosition($positionId: String!) {
  deleteJobPosition(positionId: $positionId)
}
    `;
export type DeleteJobPositionMutationFn = Apollo.MutationFunction<DeleteJobPositionMutation, DeleteJobPositionMutationVariables>;

/**
 * __useDeleteJobPositionMutation__
 *
 * To run a mutation, you first call `useDeleteJobPositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteJobPositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteJobPositionMutation, { data, loading, error }] = useDeleteJobPositionMutation({
 *   variables: {
 *      positionId: // value for 'positionId'
 *   },
 * });
 */
export function useDeleteJobPositionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteJobPositionMutation, DeleteJobPositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteJobPositionMutation, DeleteJobPositionMutationVariables>(DeleteJobPositionDocument, options);
      }
export type DeleteJobPositionMutationHookResult = ReturnType<typeof useDeleteJobPositionMutation>;
export type DeleteJobPositionMutationResult = Apollo.MutationResult<DeleteJobPositionMutation>;
export type DeleteJobPositionMutationOptions = Apollo.BaseMutationOptions<DeleteJobPositionMutation, DeleteJobPositionMutationVariables>;
export const EditJobPositionDocument = gql`
    mutation editJobPosition($positionId: String!, $positionName: String!) {
  editJobPosition(positionId: $positionId, positionName: $positionName)
}
    `;
export type EditJobPositionMutationFn = Apollo.MutationFunction<EditJobPositionMutation, EditJobPositionMutationVariables>;

/**
 * __useEditJobPositionMutation__
 *
 * To run a mutation, you first call `useEditJobPositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditJobPositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editJobPositionMutation, { data, loading, error }] = useEditJobPositionMutation({
 *   variables: {
 *      positionId: // value for 'positionId'
 *      positionName: // value for 'positionName'
 *   },
 * });
 */
export function useEditJobPositionMutation(baseOptions?: Apollo.MutationHookOptions<EditJobPositionMutation, EditJobPositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditJobPositionMutation, EditJobPositionMutationVariables>(EditJobPositionDocument, options);
      }
export type EditJobPositionMutationHookResult = ReturnType<typeof useEditJobPositionMutation>;
export type EditJobPositionMutationResult = Apollo.MutationResult<EditJobPositionMutation>;
export type EditJobPositionMutationOptions = Apollo.BaseMutationOptions<EditJobPositionMutation, EditJobPositionMutationVariables>;
export const GetAllEmployeeJobPositionDocument = gql`
    query getAllEmployeeJobPosition($projectId: String!) {
  getAllEmployeeJobPosition(projectId: $projectId) {
    id
    position
    employeeJobPosition {
      id
      employeeName
    }
  }
}
    `;

/**
 * __useGetAllEmployeeJobPositionQuery__
 *
 * To run a query within a React component, call `useGetAllEmployeeJobPositionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllEmployeeJobPositionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllEmployeeJobPositionQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetAllEmployeeJobPositionQuery(baseOptions: Apollo.QueryHookOptions<GetAllEmployeeJobPositionQuery, GetAllEmployeeJobPositionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllEmployeeJobPositionQuery, GetAllEmployeeJobPositionQueryVariables>(GetAllEmployeeJobPositionDocument, options);
      }
export function useGetAllEmployeeJobPositionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllEmployeeJobPositionQuery, GetAllEmployeeJobPositionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllEmployeeJobPositionQuery, GetAllEmployeeJobPositionQueryVariables>(GetAllEmployeeJobPositionDocument, options);
        }
export type GetAllEmployeeJobPositionQueryHookResult = ReturnType<typeof useGetAllEmployeeJobPositionQuery>;
export type GetAllEmployeeJobPositionLazyQueryHookResult = ReturnType<typeof useGetAllEmployeeJobPositionLazyQuery>;
export type GetAllEmployeeJobPositionQueryResult = Apollo.QueryResult<GetAllEmployeeJobPositionQuery, GetAllEmployeeJobPositionQueryVariables>;
export const EditEmployeeJobPositionDocument = gql`
    mutation editEmployeeJobPosition($input: editEmployeeJobPositionInput!) {
  editEmployeeJobPosition(input: $input)
}
    `;
export type EditEmployeeJobPositionMutationFn = Apollo.MutationFunction<EditEmployeeJobPositionMutation, EditEmployeeJobPositionMutationVariables>;

/**
 * __useEditEmployeeJobPositionMutation__
 *
 * To run a mutation, you first call `useEditEmployeeJobPositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditEmployeeJobPositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editEmployeeJobPositionMutation, { data, loading, error }] = useEditEmployeeJobPositionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditEmployeeJobPositionMutation(baseOptions?: Apollo.MutationHookOptions<EditEmployeeJobPositionMutation, EditEmployeeJobPositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditEmployeeJobPositionMutation, EditEmployeeJobPositionMutationVariables>(EditEmployeeJobPositionDocument, options);
      }
export type EditEmployeeJobPositionMutationHookResult = ReturnType<typeof useEditEmployeeJobPositionMutation>;
export type EditEmployeeJobPositionMutationResult = Apollo.MutationResult<EditEmployeeJobPositionMutation>;
export type EditEmployeeJobPositionMutationOptions = Apollo.BaseMutationOptions<EditEmployeeJobPositionMutation, EditEmployeeJobPositionMutationVariables>;
export const GetAllJobPositionOptionDocument = gql`
    query getAllJobPositionOption($projectId: String!) {
  getAllJobPositionOption(projectId: $projectId) {
    id
    position
  }
}
    `;

/**
 * __useGetAllJobPositionOptionQuery__
 *
 * To run a query within a React component, call `useGetAllJobPositionOptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllJobPositionOptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllJobPositionOptionQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetAllJobPositionOptionQuery(baseOptions: Apollo.QueryHookOptions<GetAllJobPositionOptionQuery, GetAllJobPositionOptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllJobPositionOptionQuery, GetAllJobPositionOptionQueryVariables>(GetAllJobPositionOptionDocument, options);
      }
export function useGetAllJobPositionOptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllJobPositionOptionQuery, GetAllJobPositionOptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllJobPositionOptionQuery, GetAllJobPositionOptionQueryVariables>(GetAllJobPositionOptionDocument, options);
        }
export type GetAllJobPositionOptionQueryHookResult = ReturnType<typeof useGetAllJobPositionOptionQuery>;
export type GetAllJobPositionOptionLazyQueryHookResult = ReturnType<typeof useGetAllJobPositionOptionLazyQuery>;
export type GetAllJobPositionOptionQueryResult = Apollo.QueryResult<GetAllJobPositionOptionQuery, GetAllJobPositionOptionQueryVariables>;
export const GetSaleCommissionSummaryDocument = gql`
    query getSaleCommissionSummary($projectId: String!) {
  commissionTypeCount
  companyCommissionTeamDate
  companyCommissionPackageDate
  projectCommissionDate
  projectCommissionTeamStructureDate(projectId: $projectId)
  projectCommissionPackageDate(projectId: $projectId)
  getCommissionCalculationRecentData(projectId: $projectId)
}
    `;

/**
 * __useGetSaleCommissionSummaryQuery__
 *
 * To run a query within a React component, call `useGetSaleCommissionSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSaleCommissionSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSaleCommissionSummaryQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetSaleCommissionSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetSaleCommissionSummaryQuery, GetSaleCommissionSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSaleCommissionSummaryQuery, GetSaleCommissionSummaryQueryVariables>(GetSaleCommissionSummaryDocument, options);
      }
export function useGetSaleCommissionSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSaleCommissionSummaryQuery, GetSaleCommissionSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSaleCommissionSummaryQuery, GetSaleCommissionSummaryQueryVariables>(GetSaleCommissionSummaryDocument, options);
        }
export type GetSaleCommissionSummaryQueryHookResult = ReturnType<typeof useGetSaleCommissionSummaryQuery>;
export type GetSaleCommissionSummaryLazyQueryHookResult = ReturnType<typeof useGetSaleCommissionSummaryLazyQuery>;
export type GetSaleCommissionSummaryQueryResult = Apollo.QueryResult<GetSaleCommissionSummaryQuery, GetSaleCommissionSummaryQueryVariables>;
export const GetMarkUpBySaleIdDocument = gql`
    query getMarkUpBySaleId($id: String!) {
  getMarkUpBySaleId(id: $id) {
    markUpBy
    markUpValue
    markUpReason
    markUpAmount
  }
}
    `;

/**
 * __useGetMarkUpBySaleIdQuery__
 *
 * To run a query within a React component, call `useGetMarkUpBySaleIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarkUpBySaleIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMarkUpBySaleIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMarkUpBySaleIdQuery(baseOptions: Apollo.QueryHookOptions<GetMarkUpBySaleIdQuery, GetMarkUpBySaleIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMarkUpBySaleIdQuery, GetMarkUpBySaleIdQueryVariables>(GetMarkUpBySaleIdDocument, options);
      }
export function useGetMarkUpBySaleIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMarkUpBySaleIdQuery, GetMarkUpBySaleIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMarkUpBySaleIdQuery, GetMarkUpBySaleIdQueryVariables>(GetMarkUpBySaleIdDocument, options);
        }
export type GetMarkUpBySaleIdQueryHookResult = ReturnType<typeof useGetMarkUpBySaleIdQuery>;
export type GetMarkUpBySaleIdLazyQueryHookResult = ReturnType<typeof useGetMarkUpBySaleIdLazyQuery>;
export type GetMarkUpBySaleIdQueryResult = Apollo.QueryResult<GetMarkUpBySaleIdQuery, GetMarkUpBySaleIdQueryVariables>;
export const AddSaleMarkUpDocument = gql`
    mutation addSaleMarkUp($input: markUpInput!) {
  addSaleMarkUp(input: $input)
}
    `;
export type AddSaleMarkUpMutationFn = Apollo.MutationFunction<AddSaleMarkUpMutation, AddSaleMarkUpMutationVariables>;

/**
 * __useAddSaleMarkUpMutation__
 *
 * To run a mutation, you first call `useAddSaleMarkUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSaleMarkUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSaleMarkUpMutation, { data, loading, error }] = useAddSaleMarkUpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddSaleMarkUpMutation(baseOptions?: Apollo.MutationHookOptions<AddSaleMarkUpMutation, AddSaleMarkUpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSaleMarkUpMutation, AddSaleMarkUpMutationVariables>(AddSaleMarkUpDocument, options);
      }
export type AddSaleMarkUpMutationHookResult = ReturnType<typeof useAddSaleMarkUpMutation>;
export type AddSaleMarkUpMutationResult = Apollo.MutationResult<AddSaleMarkUpMutation>;
export type AddSaleMarkUpMutationOptions = Apollo.BaseMutationOptions<AddSaleMarkUpMutation, AddSaleMarkUpMutationVariables>;
export const GetMarkUpByDocument = gql`
    query getMarkUpBy {
  getMarkUpBy
}
    `;

/**
 * __useGetMarkUpByQuery__
 *
 * To run a query within a React component, call `useGetMarkUpByQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarkUpByQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMarkUpByQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMarkUpByQuery(baseOptions?: Apollo.QueryHookOptions<GetMarkUpByQuery, GetMarkUpByQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMarkUpByQuery, GetMarkUpByQueryVariables>(GetMarkUpByDocument, options);
      }
export function useGetMarkUpByLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMarkUpByQuery, GetMarkUpByQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMarkUpByQuery, GetMarkUpByQueryVariables>(GetMarkUpByDocument, options);
        }
export type GetMarkUpByQueryHookResult = ReturnType<typeof useGetMarkUpByQuery>;
export type GetMarkUpByLazyQueryHookResult = ReturnType<typeof useGetMarkUpByLazyQuery>;
export type GetMarkUpByQueryResult = Apollo.QueryResult<GetMarkUpByQuery, GetMarkUpByQueryVariables>;
export const GetOtherContactListDocument = gql`
    query getOtherContactList($saleID: String!) {
  getOtherContactList(saleID: $saleID) {
    id
    accountId
    saleId
    name
    contactNo
    officeTel
    email
    salutationId
    relationshipId
    remark
    isPrimary
  }
}
    `;

/**
 * __useGetOtherContactListQuery__
 *
 * To run a query within a React component, call `useGetOtherContactListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOtherContactListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOtherContactListQuery({
 *   variables: {
 *      saleID: // value for 'saleID'
 *   },
 * });
 */
export function useGetOtherContactListQuery(baseOptions: Apollo.QueryHookOptions<GetOtherContactListQuery, GetOtherContactListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOtherContactListQuery, GetOtherContactListQueryVariables>(GetOtherContactListDocument, options);
      }
export function useGetOtherContactListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOtherContactListQuery, GetOtherContactListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOtherContactListQuery, GetOtherContactListQueryVariables>(GetOtherContactListDocument, options);
        }
export type GetOtherContactListQueryHookResult = ReturnType<typeof useGetOtherContactListQuery>;
export type GetOtherContactListLazyQueryHookResult = ReturnType<typeof useGetOtherContactListLazyQuery>;
export type GetOtherContactListQueryResult = Apollo.QueryResult<GetOtherContactListQuery, GetOtherContactListQueryVariables>;
export const GetOtherContactByIdDocument = gql`
    query getOtherContactById($saleID: String!, $ID: String!) {
  getOtherContactById(saleID: $saleID, ID: $ID) {
    id
    accountId
    saleId
    name
    contactNo
    officeTel
    email
    salutationId
    relationshipId
    remark
    isPrimary
    salutation {
      name
      id
    }
  }
}
    `;

/**
 * __useGetOtherContactByIdQuery__
 *
 * To run a query within a React component, call `useGetOtherContactByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOtherContactByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOtherContactByIdQuery({
 *   variables: {
 *      saleID: // value for 'saleID'
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useGetOtherContactByIdQuery(baseOptions: Apollo.QueryHookOptions<GetOtherContactByIdQuery, GetOtherContactByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOtherContactByIdQuery, GetOtherContactByIdQueryVariables>(GetOtherContactByIdDocument, options);
      }
export function useGetOtherContactByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOtherContactByIdQuery, GetOtherContactByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOtherContactByIdQuery, GetOtherContactByIdQueryVariables>(GetOtherContactByIdDocument, options);
        }
export type GetOtherContactByIdQueryHookResult = ReturnType<typeof useGetOtherContactByIdQuery>;
export type GetOtherContactByIdLazyQueryHookResult = ReturnType<typeof useGetOtherContactByIdLazyQuery>;
export type GetOtherContactByIdQueryResult = Apollo.QueryResult<GetOtherContactByIdQuery, GetOtherContactByIdQueryVariables>;
export const AddSalesContractOtherContactDocument = gql`
    mutation addSalesContractOtherContact($input: addSalesContractContactInput!, $saleID: String!) {
  addSalesContractOtherContact(input: $input, saleID: $saleID)
}
    `;
export type AddSalesContractOtherContactMutationFn = Apollo.MutationFunction<AddSalesContractOtherContactMutation, AddSalesContractOtherContactMutationVariables>;

/**
 * __useAddSalesContractOtherContactMutation__
 *
 * To run a mutation, you first call `useAddSalesContractOtherContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSalesContractOtherContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSalesContractOtherContactMutation, { data, loading, error }] = useAddSalesContractOtherContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *      saleID: // value for 'saleID'
 *   },
 * });
 */
export function useAddSalesContractOtherContactMutation(baseOptions?: Apollo.MutationHookOptions<AddSalesContractOtherContactMutation, AddSalesContractOtherContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSalesContractOtherContactMutation, AddSalesContractOtherContactMutationVariables>(AddSalesContractOtherContactDocument, options);
      }
export type AddSalesContractOtherContactMutationHookResult = ReturnType<typeof useAddSalesContractOtherContactMutation>;
export type AddSalesContractOtherContactMutationResult = Apollo.MutationResult<AddSalesContractOtherContactMutation>;
export type AddSalesContractOtherContactMutationOptions = Apollo.BaseMutationOptions<AddSalesContractOtherContactMutation, AddSalesContractOtherContactMutationVariables>;
export const EditSalesContractOtherContactDocument = gql`
    mutation editSalesContractOtherContact($input: editSalesContractContactInput!, $saleID: String!) {
  editSalesContractOtherContact(input: $input, saleID: $saleID)
}
    `;
export type EditSalesContractOtherContactMutationFn = Apollo.MutationFunction<EditSalesContractOtherContactMutation, EditSalesContractOtherContactMutationVariables>;

/**
 * __useEditSalesContractOtherContactMutation__
 *
 * To run a mutation, you first call `useEditSalesContractOtherContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSalesContractOtherContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSalesContractOtherContactMutation, { data, loading, error }] = useEditSalesContractOtherContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *      saleID: // value for 'saleID'
 *   },
 * });
 */
export function useEditSalesContractOtherContactMutation(baseOptions?: Apollo.MutationHookOptions<EditSalesContractOtherContactMutation, EditSalesContractOtherContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditSalesContractOtherContactMutation, EditSalesContractOtherContactMutationVariables>(EditSalesContractOtherContactDocument, options);
      }
export type EditSalesContractOtherContactMutationHookResult = ReturnType<typeof useEditSalesContractOtherContactMutation>;
export type EditSalesContractOtherContactMutationResult = Apollo.MutationResult<EditSalesContractOtherContactMutation>;
export type EditSalesContractOtherContactMutationOptions = Apollo.BaseMutationOptions<EditSalesContractOtherContactMutation, EditSalesContractOtherContactMutationVariables>;
export const GetPurchaserInfoListingDocument = gql`
    query getPurchaserInfoListing($saleId: String!) {
  getPurchaserInfoListing(saleId: $saleId) {
    name
    error
    draggable
    isBumi
    icNo
    id
    seqNo
    jointBuyerId
    isCompany
    companyName
    companyRegNo
  }
}
    `;

/**
 * __useGetPurchaserInfoListingQuery__
 *
 * To run a query within a React component, call `useGetPurchaserInfoListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPurchaserInfoListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPurchaserInfoListingQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetPurchaserInfoListingQuery(baseOptions: Apollo.QueryHookOptions<GetPurchaserInfoListingQuery, GetPurchaserInfoListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPurchaserInfoListingQuery, GetPurchaserInfoListingQueryVariables>(GetPurchaserInfoListingDocument, options);
      }
export function useGetPurchaserInfoListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPurchaserInfoListingQuery, GetPurchaserInfoListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPurchaserInfoListingQuery, GetPurchaserInfoListingQueryVariables>(GetPurchaserInfoListingDocument, options);
        }
export type GetPurchaserInfoListingQueryHookResult = ReturnType<typeof useGetPurchaserInfoListingQuery>;
export type GetPurchaserInfoListingLazyQueryHookResult = ReturnType<typeof useGetPurchaserInfoListingLazyQuery>;
export type GetPurchaserInfoListingQueryResult = Apollo.QueryResult<GetPurchaserInfoListingQuery, GetPurchaserInfoListingQueryVariables>;
export const DeleteJointBuyerDocument = gql`
    mutation deleteJointBuyer($jointBuyerId: String!, $saleId: String!) {
  deleteJointBuyer(jointBuyerId: $jointBuyerId, saleId: $saleId)
}
    `;
export type DeleteJointBuyerMutationFn = Apollo.MutationFunction<DeleteJointBuyerMutation, DeleteJointBuyerMutationVariables>;

/**
 * __useDeleteJointBuyerMutation__
 *
 * To run a mutation, you first call `useDeleteJointBuyerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteJointBuyerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteJointBuyerMutation, { data, loading, error }] = useDeleteJointBuyerMutation({
 *   variables: {
 *      jointBuyerId: // value for 'jointBuyerId'
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useDeleteJointBuyerMutation(baseOptions?: Apollo.MutationHookOptions<DeleteJointBuyerMutation, DeleteJointBuyerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteJointBuyerMutation, DeleteJointBuyerMutationVariables>(DeleteJointBuyerDocument, options);
      }
export type DeleteJointBuyerMutationHookResult = ReturnType<typeof useDeleteJointBuyerMutation>;
export type DeleteJointBuyerMutationResult = Apollo.MutationResult<DeleteJointBuyerMutation>;
export type DeleteJointBuyerMutationOptions = Apollo.BaseMutationOptions<DeleteJointBuyerMutation, DeleteJointBuyerMutationVariables>;
export const UpdateJointBuyerSeqDocument = gql`
    mutation updateJointBuyerSeq($input: updateJointBuyerSeqInput!, $saleId: String!) {
  updateJointBuyerSeq(input: $input, saleId: $saleId)
}
    `;
export type UpdateJointBuyerSeqMutationFn = Apollo.MutationFunction<UpdateJointBuyerSeqMutation, UpdateJointBuyerSeqMutationVariables>;

/**
 * __useUpdateJointBuyerSeqMutation__
 *
 * To run a mutation, you first call `useUpdateJointBuyerSeqMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJointBuyerSeqMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJointBuyerSeqMutation, { data, loading, error }] = useUpdateJointBuyerSeqMutation({
 *   variables: {
 *      input: // value for 'input'
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useUpdateJointBuyerSeqMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJointBuyerSeqMutation, UpdateJointBuyerSeqMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJointBuyerSeqMutation, UpdateJointBuyerSeqMutationVariables>(UpdateJointBuyerSeqDocument, options);
      }
export type UpdateJointBuyerSeqMutationHookResult = ReturnType<typeof useUpdateJointBuyerSeqMutation>;
export type UpdateJointBuyerSeqMutationResult = Apollo.MutationResult<UpdateJointBuyerSeqMutation>;
export type UpdateJointBuyerSeqMutationOptions = Apollo.BaseMutationOptions<UpdateJointBuyerSeqMutation, UpdateJointBuyerSeqMutationVariables>;
export const GetGeneralTinByPartyDocument = gql`
    query getGeneralTinByParty($party: String) {
  getGeneralTinByParty(party: $party) {
    tin
  }
}
    `;

/**
 * __useGetGeneralTinByPartyQuery__
 *
 * To run a query within a React component, call `useGetGeneralTinByPartyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGeneralTinByPartyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGeneralTinByPartyQuery({
 *   variables: {
 *      party: // value for 'party'
 *   },
 * });
 */
export function useGetGeneralTinByPartyQuery(baseOptions?: Apollo.QueryHookOptions<GetGeneralTinByPartyQuery, GetGeneralTinByPartyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGeneralTinByPartyQuery, GetGeneralTinByPartyQueryVariables>(GetGeneralTinByPartyDocument, options);
      }
export function useGetGeneralTinByPartyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGeneralTinByPartyQuery, GetGeneralTinByPartyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGeneralTinByPartyQuery, GetGeneralTinByPartyQueryVariables>(GetGeneralTinByPartyDocument, options);
        }
export type GetGeneralTinByPartyQueryHookResult = ReturnType<typeof useGetGeneralTinByPartyQuery>;
export type GetGeneralTinByPartyLazyQueryHookResult = ReturnType<typeof useGetGeneralTinByPartyLazyQuery>;
export type GetGeneralTinByPartyQueryResult = Apollo.QueryResult<GetGeneralTinByPartyQuery, GetGeneralTinByPartyQueryVariables>;
export const GetAvailableUnitByProjectIdDocument = gql`
    query getAvailableUnitByProjectID {
  getAvailableUnitByProjectID {
    id
    unitNo
    builtUp
    landArea
    isBumi
    price
    unitExt {
      paymentPlanId
      builtUpAreaRate
      actualBuiltUpArea
      landAreaRate
      actualLandArea
      shareValue
    }
    propertyType {
      id
      commercialPurpose
      name
    }
  }
}
    `;

/**
 * __useGetAvailableUnitByProjectIdQuery__
 *
 * To run a query within a React component, call `useGetAvailableUnitByProjectIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableUnitByProjectIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableUnitByProjectIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAvailableUnitByProjectIdQuery(baseOptions?: Apollo.QueryHookOptions<GetAvailableUnitByProjectIdQuery, GetAvailableUnitByProjectIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableUnitByProjectIdQuery, GetAvailableUnitByProjectIdQueryVariables>(GetAvailableUnitByProjectIdDocument, options);
      }
export function useGetAvailableUnitByProjectIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableUnitByProjectIdQuery, GetAvailableUnitByProjectIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableUnitByProjectIdQuery, GetAvailableUnitByProjectIdQueryVariables>(GetAvailableUnitByProjectIdDocument, options);
        }
export type GetAvailableUnitByProjectIdQueryHookResult = ReturnType<typeof useGetAvailableUnitByProjectIdQuery>;
export type GetAvailableUnitByProjectIdLazyQueryHookResult = ReturnType<typeof useGetAvailableUnitByProjectIdLazyQuery>;
export type GetAvailableUnitByProjectIdQueryResult = Apollo.QueryResult<GetAvailableUnitByProjectIdQuery, GetAvailableUnitByProjectIdQueryVariables>;
export const GetSalesContractListDocument = gql`
    query getSalesContractList {
  getSalesContractList {
    id
    unitId
    salesPersonId
    developerSolicitorId
    leadId
    salesTeamId
    distance
    developerReference
    buyerReference
    salesNo
    sellingPrice
    isCompany
    bookingRemark
    bookDate
    isBumi
    paymentMethod
    bookingAmount
    listPrice
    billMethod
    expectedSnpDate
    spaDate
    stampDate
    salesStatus
    isBumi
    unit {
      unitNo
      isBumi
    }
    contact {
      id
      fullName
      companyName
    }
  }
}
    `;

/**
 * __useGetSalesContractListQuery__
 *
 * To run a query within a React component, call `useGetSalesContractListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesContractListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesContractListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSalesContractListQuery(baseOptions?: Apollo.QueryHookOptions<GetSalesContractListQuery, GetSalesContractListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesContractListQuery, GetSalesContractListQueryVariables>(GetSalesContractListDocument, options);
      }
export function useGetSalesContractListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesContractListQuery, GetSalesContractListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesContractListQuery, GetSalesContractListQueryVariables>(GetSalesContractListDocument, options);
        }
export type GetSalesContractListQueryHookResult = ReturnType<typeof useGetSalesContractListQuery>;
export type GetSalesContractListLazyQueryHookResult = ReturnType<typeof useGetSalesContractListLazyQuery>;
export type GetSalesContractListQueryResult = Apollo.QueryResult<GetSalesContractListQuery, GetSalesContractListQueryVariables>;
export const GetSalesContractByIdDocument = gql`
    query getSalesContractById($saleID: String!) {
  getSalesContractById(saleID: $saleID) {
    id
    unitId
    salesPersonId
    developerSolicitorId
    isCompany
    leadSource {
      id
    }
    buyerSolicitor {
      id
      name
    }
    developerSolicitor {
      id
      name
    }
    leadId
    incomeRange {
      id
      range
      defaulted
    }
    salesTeamId
    distance
    developerReference
    buyerReference
    salesNo
    bookingRemark
    bookDate
    isBumi
    paymentMethod
    bookingAmount
    listPrice
    sellingPrice
    isCompany
    billMethod
    expectedSnpDate
    spaDate
    stampDate
    cancelledDate
    salesStatus
    isBumi
    purchaserInfoName {
      name
      count
      error
    }
    salesRebateName {
      title
      checkPaymentPlan
      discountAmount
    }
    checkSalePackage {
      includeContractInvalid
      noIncludeContractInvalid
    }
    otherContactName
    addOnTotal
    progressBillingTotal
    salesPerson
    ContractPricingDiscount
    saleExtension {
      totalSalesValue
      loanGracePeriod
      isCashBuyer
      creditTerm
      isGenerateReminder
      isGenerateInterest
      campaignId
      salesType
      paymentPlanId
      paymentPlan {
        name
        details {
          isStakeholder
        }
      }
    }
    unit {
      unitNo
      builtUp
      isBumi
      id
      unitExt {
        stakeholderId
      }
    }
    contact {
      id
      fullName
      companyName
    }
    ProgressBilling
    bookingAttachments {
      bookingNricAttachments {
        id
      }
      bookingCcrAttachments {
        id
      }
    }
    address {
      city
      state
      address
      country
      postCode
    }
    eventId
  }
}
    `;

/**
 * __useGetSalesContractByIdQuery__
 *
 * To run a query within a React component, call `useGetSalesContractByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesContractByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesContractByIdQuery({
 *   variables: {
 *      saleID: // value for 'saleID'
 *   },
 * });
 */
export function useGetSalesContractByIdQuery(baseOptions: Apollo.QueryHookOptions<GetSalesContractByIdQuery, GetSalesContractByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesContractByIdQuery, GetSalesContractByIdQueryVariables>(GetSalesContractByIdDocument, options);
      }
export function useGetSalesContractByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesContractByIdQuery, GetSalesContractByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesContractByIdQuery, GetSalesContractByIdQueryVariables>(GetSalesContractByIdDocument, options);
        }
export type GetSalesContractByIdQueryHookResult = ReturnType<typeof useGetSalesContractByIdQuery>;
export type GetSalesContractByIdLazyQueryHookResult = ReturnType<typeof useGetSalesContractByIdLazyQuery>;
export type GetSalesContractByIdQueryResult = Apollo.QueryResult<GetSalesContractByIdQuery, GetSalesContractByIdQueryVariables>;
export const GetMainContactDocument = gql`
    query getMainContact($saleID: String!) {
  getSalesContractById(saleID: $saleID) {
    contact {
      id
      fullName
    }
  }
}
    `;

/**
 * __useGetMainContactQuery__
 *
 * To run a query within a React component, call `useGetMainContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMainContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMainContactQuery({
 *   variables: {
 *      saleID: // value for 'saleID'
 *   },
 * });
 */
export function useGetMainContactQuery(baseOptions: Apollo.QueryHookOptions<GetMainContactQuery, GetMainContactQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMainContactQuery, GetMainContactQueryVariables>(GetMainContactDocument, options);
      }
export function useGetMainContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMainContactQuery, GetMainContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMainContactQuery, GetMainContactQueryVariables>(GetMainContactDocument, options);
        }
export type GetMainContactQueryHookResult = ReturnType<typeof useGetMainContactQuery>;
export type GetMainContactLazyQueryHookResult = ReturnType<typeof useGetMainContactLazyQuery>;
export type GetMainContactQueryResult = Apollo.QueryResult<GetMainContactQuery, GetMainContactQueryVariables>;
export const GetWorkProgressBySaleDocument = gql`
    query getWorkProgressBySale($saleId: String!) {
  getWorkProgressBySale(saleId: $saleId) {
    id
    name
  }
}
    `;

/**
 * __useGetWorkProgressBySaleQuery__
 *
 * To run a query within a React component, call `useGetWorkProgressBySaleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkProgressBySaleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkProgressBySaleQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetWorkProgressBySaleQuery(baseOptions: Apollo.QueryHookOptions<GetWorkProgressBySaleQuery, GetWorkProgressBySaleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkProgressBySaleQuery, GetWorkProgressBySaleQueryVariables>(GetWorkProgressBySaleDocument, options);
      }
export function useGetWorkProgressBySaleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkProgressBySaleQuery, GetWorkProgressBySaleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkProgressBySaleQuery, GetWorkProgressBySaleQueryVariables>(GetWorkProgressBySaleDocument, options);
        }
export type GetWorkProgressBySaleQueryHookResult = ReturnType<typeof useGetWorkProgressBySaleQuery>;
export type GetWorkProgressBySaleLazyQueryHookResult = ReturnType<typeof useGetWorkProgressBySaleLazyQuery>;
export type GetWorkProgressBySaleQueryResult = Apollo.QueryResult<GetWorkProgressBySaleQuery, GetWorkProgressBySaleQueryVariables>;
export const EditSalesContractSolicitorsDocument = gql`
    mutation editSalesContractSolicitors($input: editSolicitorsInput!) {
  editSalesContractSolicitors(input: $input)
}
    `;
export type EditSalesContractSolicitorsMutationFn = Apollo.MutationFunction<EditSalesContractSolicitorsMutation, EditSalesContractSolicitorsMutationVariables>;

/**
 * __useEditSalesContractSolicitorsMutation__
 *
 * To run a mutation, you first call `useEditSalesContractSolicitorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSalesContractSolicitorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSalesContractSolicitorsMutation, { data, loading, error }] = useEditSalesContractSolicitorsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditSalesContractSolicitorsMutation(baseOptions?: Apollo.MutationHookOptions<EditSalesContractSolicitorsMutation, EditSalesContractSolicitorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditSalesContractSolicitorsMutation, EditSalesContractSolicitorsMutationVariables>(EditSalesContractSolicitorsDocument, options);
      }
export type EditSalesContractSolicitorsMutationHookResult = ReturnType<typeof useEditSalesContractSolicitorsMutation>;
export type EditSalesContractSolicitorsMutationResult = Apollo.MutationResult<EditSalesContractSolicitorsMutation>;
export type EditSalesContractSolicitorsMutationOptions = Apollo.BaseMutationOptions<EditSalesContractSolicitorsMutation, EditSalesContractSolicitorsMutationVariables>;
export const EditSalesContractOtherSalesInfoDocument = gql`
    mutation editSalesContractOtherSalesInfo($input: editOtherSalesInfoInput!) {
  editSalesContractOtherSalesInfo(input: $input)
}
    `;
export type EditSalesContractOtherSalesInfoMutationFn = Apollo.MutationFunction<EditSalesContractOtherSalesInfoMutation, EditSalesContractOtherSalesInfoMutationVariables>;

/**
 * __useEditSalesContractOtherSalesInfoMutation__
 *
 * To run a mutation, you first call `useEditSalesContractOtherSalesInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSalesContractOtherSalesInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSalesContractOtherSalesInfoMutation, { data, loading, error }] = useEditSalesContractOtherSalesInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditSalesContractOtherSalesInfoMutation(baseOptions?: Apollo.MutationHookOptions<EditSalesContractOtherSalesInfoMutation, EditSalesContractOtherSalesInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditSalesContractOtherSalesInfoMutation, EditSalesContractOtherSalesInfoMutationVariables>(EditSalesContractOtherSalesInfoDocument, options);
      }
export type EditSalesContractOtherSalesInfoMutationHookResult = ReturnType<typeof useEditSalesContractOtherSalesInfoMutation>;
export type EditSalesContractOtherSalesInfoMutationResult = Apollo.MutationResult<EditSalesContractOtherSalesInfoMutation>;
export type EditSalesContractOtherSalesInfoMutationOptions = Apollo.BaseMutationOptions<EditSalesContractOtherSalesInfoMutation, EditSalesContractOtherSalesInfoMutationVariables>;
export const DeleteSalesContractOtherContactDocument = gql`
    mutation deleteSalesContractOtherContact($saleContactId: String!) {
  deleteSalesContractOtherContact(saleContactId: $saleContactId)
}
    `;
export type DeleteSalesContractOtherContactMutationFn = Apollo.MutationFunction<DeleteSalesContractOtherContactMutation, DeleteSalesContractOtherContactMutationVariables>;

/**
 * __useDeleteSalesContractOtherContactMutation__
 *
 * To run a mutation, you first call `useDeleteSalesContractOtherContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSalesContractOtherContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSalesContractOtherContactMutation, { data, loading, error }] = useDeleteSalesContractOtherContactMutation({
 *   variables: {
 *      saleContactId: // value for 'saleContactId'
 *   },
 * });
 */
export function useDeleteSalesContractOtherContactMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSalesContractOtherContactMutation, DeleteSalesContractOtherContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSalesContractOtherContactMutation, DeleteSalesContractOtherContactMutationVariables>(DeleteSalesContractOtherContactDocument, options);
      }
export type DeleteSalesContractOtherContactMutationHookResult = ReturnType<typeof useDeleteSalesContractOtherContactMutation>;
export type DeleteSalesContractOtherContactMutationResult = Apollo.MutationResult<DeleteSalesContractOtherContactMutation>;
export type DeleteSalesContractOtherContactMutationOptions = Apollo.BaseMutationOptions<DeleteSalesContractOtherContactMutation, DeleteSalesContractOtherContactMutationVariables>;
export const ConvertToSignDocument = gql`
    mutation convertToSign($input: updateSNPSigned!) {
  convertToSign(input: $input) {
    isSuccessful
    isGenerated
  }
}
    `;
export type ConvertToSignMutationFn = Apollo.MutationFunction<ConvertToSignMutation, ConvertToSignMutationVariables>;

/**
 * __useConvertToSignMutation__
 *
 * To run a mutation, you first call `useConvertToSignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConvertToSignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [convertToSignMutation, { data, loading, error }] = useConvertToSignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConvertToSignMutation(baseOptions?: Apollo.MutationHookOptions<ConvertToSignMutation, ConvertToSignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConvertToSignMutation, ConvertToSignMutationVariables>(ConvertToSignDocument, options);
      }
export type ConvertToSignMutationHookResult = ReturnType<typeof useConvertToSignMutation>;
export type ConvertToSignMutationResult = Apollo.MutationResult<ConvertToSignMutation>;
export type ConvertToSignMutationOptions = Apollo.BaseMutationOptions<ConvertToSignMutation, ConvertToSignMutationVariables>;
export const ConvertToStampedDocument = gql`
    mutation convertToStamped($input: updateSNPStamped!) {
  convertToStamped(input: $input)
}
    `;
export type ConvertToStampedMutationFn = Apollo.MutationFunction<ConvertToStampedMutation, ConvertToStampedMutationVariables>;

/**
 * __useConvertToStampedMutation__
 *
 * To run a mutation, you first call `useConvertToStampedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConvertToStampedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [convertToStampedMutation, { data, loading, error }] = useConvertToStampedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConvertToStampedMutation(baseOptions?: Apollo.MutationHookOptions<ConvertToStampedMutation, ConvertToStampedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConvertToStampedMutation, ConvertToStampedMutationVariables>(ConvertToStampedDocument, options);
      }
export type ConvertToStampedMutationHookResult = ReturnType<typeof useConvertToStampedMutation>;
export type ConvertToStampedMutationResult = Apollo.MutationResult<ConvertToStampedMutation>;
export type ConvertToStampedMutationOptions = Apollo.BaseMutationOptions<ConvertToStampedMutation, ConvertToStampedMutationVariables>;
export const GetAllMasterDataDocument = gql`
    query getAllMasterData {
  GetAllMasterInfo {
    Races {
      id
      name
      defaulted
    }
    Salutations {
      id
      name
      defaulted
    }
    LeadSources {
      id
      name
      commonStatus
      defaulted
      systemUse
    }
    MaritalStatus {
      id
      name
      defaulted
    }
    IncomeRanges {
      id
      range
      defaulted
    }
    Nationalities {
      id
      name
    }
    Genders
    CurrencyCode
  }
}
    `;

/**
 * __useGetAllMasterDataQuery__
 *
 * To run a query within a React component, call `useGetAllMasterDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllMasterDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllMasterDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllMasterDataQuery(baseOptions?: Apollo.QueryHookOptions<GetAllMasterDataQuery, GetAllMasterDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllMasterDataQuery, GetAllMasterDataQueryVariables>(GetAllMasterDataDocument, options);
      }
export function useGetAllMasterDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllMasterDataQuery, GetAllMasterDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllMasterDataQuery, GetAllMasterDataQueryVariables>(GetAllMasterDataDocument, options);
        }
export type GetAllMasterDataQueryHookResult = ReturnType<typeof useGetAllMasterDataQuery>;
export type GetAllMasterDataLazyQueryHookResult = ReturnType<typeof useGetAllMasterDataLazyQuery>;
export type GetAllMasterDataQueryResult = Apollo.QueryResult<GetAllMasterDataQuery, GetAllMasterDataQueryVariables>;
export const GetDiscountListByProjectIdIntegratedFalseDocument = gql`
    query getDiscountListByProjectIdIntegratedFalse {
  getDiscountListByProjectId {
    id
    title
    formula
    prefix
    description
    isIntegrated
    discountVal
    projectDiscounts {
      effectiveDate
      expired_date
      defaulted
    }
  }
}
    `;

/**
 * __useGetDiscountListByProjectIdIntegratedFalseQuery__
 *
 * To run a query within a React component, call `useGetDiscountListByProjectIdIntegratedFalseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiscountListByProjectIdIntegratedFalseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiscountListByProjectIdIntegratedFalseQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDiscountListByProjectIdIntegratedFalseQuery(baseOptions?: Apollo.QueryHookOptions<GetDiscountListByProjectIdIntegratedFalseQuery, GetDiscountListByProjectIdIntegratedFalseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDiscountListByProjectIdIntegratedFalseQuery, GetDiscountListByProjectIdIntegratedFalseQueryVariables>(GetDiscountListByProjectIdIntegratedFalseDocument, options);
      }
export function useGetDiscountListByProjectIdIntegratedFalseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDiscountListByProjectIdIntegratedFalseQuery, GetDiscountListByProjectIdIntegratedFalseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDiscountListByProjectIdIntegratedFalseQuery, GetDiscountListByProjectIdIntegratedFalseQueryVariables>(GetDiscountListByProjectIdIntegratedFalseDocument, options);
        }
export type GetDiscountListByProjectIdIntegratedFalseQueryHookResult = ReturnType<typeof useGetDiscountListByProjectIdIntegratedFalseQuery>;
export type GetDiscountListByProjectIdIntegratedFalseLazyQueryHookResult = ReturnType<typeof useGetDiscountListByProjectIdIntegratedFalseLazyQuery>;
export type GetDiscountListByProjectIdIntegratedFalseQueryResult = Apollo.QueryResult<GetDiscountListByProjectIdIntegratedFalseQuery, GetDiscountListByProjectIdIntegratedFalseQueryVariables>;
export const GetProjectDiscountListDocument = gql`
    query getProjectDiscountList($discountType: String, $saleRebateId: String) {
  getProjectDiscountList(discountType: $discountType, saleRebateId: $saleRebateId) {
    discountId
    discountTitle
    discountPrefix
    discountVal
    disabled
  }
}
    `;

/**
 * __useGetProjectDiscountListQuery__
 *
 * To run a query within a React component, call `useGetProjectDiscountListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectDiscountListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectDiscountListQuery({
 *   variables: {
 *      discountType: // value for 'discountType'
 *      saleRebateId: // value for 'saleRebateId'
 *   },
 * });
 */
export function useGetProjectDiscountListQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectDiscountListQuery, GetProjectDiscountListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectDiscountListQuery, GetProjectDiscountListQueryVariables>(GetProjectDiscountListDocument, options);
      }
export function useGetProjectDiscountListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectDiscountListQuery, GetProjectDiscountListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectDiscountListQuery, GetProjectDiscountListQueryVariables>(GetProjectDiscountListDocument, options);
        }
export type GetProjectDiscountListQueryHookResult = ReturnType<typeof useGetProjectDiscountListQuery>;
export type GetProjectDiscountListLazyQueryHookResult = ReturnType<typeof useGetProjectDiscountListLazyQuery>;
export type GetProjectDiscountListQueryResult = Apollo.QueryResult<GetProjectDiscountListQuery, GetProjectDiscountListQueryVariables>;
export const GetProjectDiscountListWithoutSaleRebateDocument = gql`
    query getProjectDiscountListWithoutSaleRebate($discountType: String, $saleId: String) {
  getProjectDiscountListWithoutSaleRebate(discountType: $discountType, saleId: $saleId) {
    id
    effectiveDate
    expired_date
    defaulted
    discount {
      id
      title
      formula
      prefix
      discountVal
      discountType {
        name
      }
    }
  }
}
    `;

/**
 * __useGetProjectDiscountListWithoutSaleRebateQuery__
 *
 * To run a query within a React component, call `useGetProjectDiscountListWithoutSaleRebateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectDiscountListWithoutSaleRebateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectDiscountListWithoutSaleRebateQuery({
 *   variables: {
 *      discountType: // value for 'discountType'
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetProjectDiscountListWithoutSaleRebateQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectDiscountListWithoutSaleRebateQuery, GetProjectDiscountListWithoutSaleRebateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectDiscountListWithoutSaleRebateQuery, GetProjectDiscountListWithoutSaleRebateQueryVariables>(GetProjectDiscountListWithoutSaleRebateDocument, options);
      }
export function useGetProjectDiscountListWithoutSaleRebateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectDiscountListWithoutSaleRebateQuery, GetProjectDiscountListWithoutSaleRebateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectDiscountListWithoutSaleRebateQuery, GetProjectDiscountListWithoutSaleRebateQueryVariables>(GetProjectDiscountListWithoutSaleRebateDocument, options);
        }
export type GetProjectDiscountListWithoutSaleRebateQueryHookResult = ReturnType<typeof useGetProjectDiscountListWithoutSaleRebateQuery>;
export type GetProjectDiscountListWithoutSaleRebateLazyQueryHookResult = ReturnType<typeof useGetProjectDiscountListWithoutSaleRebateLazyQuery>;
export type GetProjectDiscountListWithoutSaleRebateQueryResult = Apollo.QueryResult<GetProjectDiscountListWithoutSaleRebateQuery, GetProjectDiscountListWithoutSaleRebateQueryVariables>;
export const GetSummarySaleContractDocument = gql`
    query getSummarySaleContract($saleId: String!) {
  getSummarySaleContract(saleId: $saleId) {
    subProduct {
      info
      count
      totalPrice
    }
    packages {
      info
      count
      totalPrice
    }
    discount {
      info
      count
      totalPrice
      isBumiDiscard
    }
    unit {
      propertyType
      sellingPrice
      area
      uom
    }
    markUp {
      markUpBy
      markUpValue
      markUpReason
      markUpAmount
    }
  }
}
    `;

/**
 * __useGetSummarySaleContractQuery__
 *
 * To run a query within a React component, call `useGetSummarySaleContractQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSummarySaleContractQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSummarySaleContractQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetSummarySaleContractQuery(baseOptions: Apollo.QueryHookOptions<GetSummarySaleContractQuery, GetSummarySaleContractQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSummarySaleContractQuery, GetSummarySaleContractQueryVariables>(GetSummarySaleContractDocument, options);
      }
export function useGetSummarySaleContractLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSummarySaleContractQuery, GetSummarySaleContractQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSummarySaleContractQuery, GetSummarySaleContractQueryVariables>(GetSummarySaleContractDocument, options);
        }
export type GetSummarySaleContractQueryHookResult = ReturnType<typeof useGetSummarySaleContractQuery>;
export type GetSummarySaleContractLazyQueryHookResult = ReturnType<typeof useGetSummarySaleContractLazyQuery>;
export type GetSummarySaleContractQueryResult = Apollo.QueryResult<GetSummarySaleContractQuery, GetSummarySaleContractQueryVariables>;
export const CalculateDiscountAmountDocument = gql`
    query calculateDiscountAmount($input: calculateDiscountAmountInput!) {
  calculateDiscountAmount(input: $input)
}
    `;

/**
 * __useCalculateDiscountAmountQuery__
 *
 * To run a query within a React component, call `useCalculateDiscountAmountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalculateDiscountAmountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalculateDiscountAmountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCalculateDiscountAmountQuery(baseOptions: Apollo.QueryHookOptions<CalculateDiscountAmountQuery, CalculateDiscountAmountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalculateDiscountAmountQuery, CalculateDiscountAmountQueryVariables>(CalculateDiscountAmountDocument, options);
      }
export function useCalculateDiscountAmountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalculateDiscountAmountQuery, CalculateDiscountAmountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalculateDiscountAmountQuery, CalculateDiscountAmountQueryVariables>(CalculateDiscountAmountDocument, options);
        }
export type CalculateDiscountAmountQueryHookResult = ReturnType<typeof useCalculateDiscountAmountQuery>;
export type CalculateDiscountAmountLazyQueryHookResult = ReturnType<typeof useCalculateDiscountAmountLazyQuery>;
export type CalculateDiscountAmountQueryResult = Apollo.QueryResult<CalculateDiscountAmountQuery, CalculateDiscountAmountQueryVariables>;
export const GetContractUnitDetailsDocument = gql`
    query getContractUnitDetails($unitId: String!) {
  getContractUnitDetails(unitId: $unitId) {
    unitNo
    propertyType
    commercialPurpose
    uom
    builtUpAreaRate
    builtUp
    landArea
    landAreaRate
    shareValue
    taxSchemeName
    isBumi
  }
}
    `;

/**
 * __useGetContractUnitDetailsQuery__
 *
 * To run a query within a React component, call `useGetContractUnitDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractUnitDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractUnitDetailsQuery({
 *   variables: {
 *      unitId: // value for 'unitId'
 *   },
 * });
 */
export function useGetContractUnitDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetContractUnitDetailsQuery, GetContractUnitDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractUnitDetailsQuery, GetContractUnitDetailsQueryVariables>(GetContractUnitDetailsDocument, options);
      }
export function useGetContractUnitDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractUnitDetailsQuery, GetContractUnitDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractUnitDetailsQuery, GetContractUnitDetailsQueryVariables>(GetContractUnitDetailsDocument, options);
        }
export type GetContractUnitDetailsQueryHookResult = ReturnType<typeof useGetContractUnitDetailsQuery>;
export type GetContractUnitDetailsLazyQueryHookResult = ReturnType<typeof useGetContractUnitDetailsLazyQuery>;
export type GetContractUnitDetailsQueryResult = Apollo.QueryResult<GetContractUnitDetailsQuery, GetContractUnitDetailsQueryVariables>;
export const GetAddressByIdDocument = gql`
    query getAddressById($contactId: String!) {
  getAddressById(contactId: $contactId)
}
    `;

/**
 * __useGetAddressByIdQuery__
 *
 * To run a query within a React component, call `useGetAddressByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAddressByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAddressByIdQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useGetAddressByIdQuery(baseOptions: Apollo.QueryHookOptions<GetAddressByIdQuery, GetAddressByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAddressByIdQuery, GetAddressByIdQueryVariables>(GetAddressByIdDocument, options);
      }
export function useGetAddressByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAddressByIdQuery, GetAddressByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAddressByIdQuery, GetAddressByIdQueryVariables>(GetAddressByIdDocument, options);
        }
export type GetAddressByIdQueryHookResult = ReturnType<typeof useGetAddressByIdQuery>;
export type GetAddressByIdLazyQueryHookResult = ReturnType<typeof useGetAddressByIdLazyQuery>;
export type GetAddressByIdQueryResult = Apollo.QueryResult<GetAddressByIdQuery, GetAddressByIdQueryVariables>;
export const GetContactByIdDocument = gql`
    query getContactById($contactId: String!) {
  getContactById(contactId: $contactId) {
    id
    companyName
    companyRegNo
    fullName
    email
    phoneNo
    officeTel
    homeTel
    gender
    icNo
    militaryIc
    homeTel
    officeTel
    photoUrl
    salutation {
      name
      id
    }
    nationality {
      name
      id
    }
    race {
      name
      id
    }
    maritalStatus {
      name
      id
    }
    contactExt {
      id
      identityType
      customerOrigin
      isBumi
      isVip
      isForeignPurchase
      subscribeMaterialSms
      subscribeMaterialWhatsapp
      subscribeMaterialEmail
      subscribeMaterialPaNews
      mailingMethod
      remark
      tin
      sstNo
    }
    addressList {
      id
      contactId
      isPrimary
      address {
        address
        country
        city
        state
        postCode
        AddressType
      }
    }
  }
}
    `;

/**
 * __useGetContactByIdQuery__
 *
 * To run a query within a React component, call `useGetContactByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactByIdQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useGetContactByIdQuery(baseOptions: Apollo.QueryHookOptions<GetContactByIdQuery, GetContactByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactByIdQuery, GetContactByIdQueryVariables>(GetContactByIdDocument, options);
      }
export function useGetContactByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactByIdQuery, GetContactByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactByIdQuery, GetContactByIdQueryVariables>(GetContactByIdDocument, options);
        }
export type GetContactByIdQueryHookResult = ReturnType<typeof useGetContactByIdQuery>;
export type GetContactByIdLazyQueryHookResult = ReturnType<typeof useGetContactByIdLazyQuery>;
export type GetContactByIdQueryResult = Apollo.QueryResult<GetContactByIdQuery, GetContactByIdQueryVariables>;
export const GetAllPackageByProjectDocument = gql`
    query getAllPackageByProject {
  getAllPackageByProject {
    id
    name
    desc
    projectId
    listPrice
    marketValue
    startDate
    endDate
    isIntegrated
    packageExt {
      defaulted
      taxSchemeId
    }
  }
}
    `;

/**
 * __useGetAllPackageByProjectQuery__
 *
 * To run a query within a React component, call `useGetAllPackageByProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPackageByProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPackageByProjectQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllPackageByProjectQuery(baseOptions?: Apollo.QueryHookOptions<GetAllPackageByProjectQuery, GetAllPackageByProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllPackageByProjectQuery, GetAllPackageByProjectQueryVariables>(GetAllPackageByProjectDocument, options);
      }
export function useGetAllPackageByProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllPackageByProjectQuery, GetAllPackageByProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllPackageByProjectQuery, GetAllPackageByProjectQueryVariables>(GetAllPackageByProjectDocument, options);
        }
export type GetAllPackageByProjectQueryHookResult = ReturnType<typeof useGetAllPackageByProjectQuery>;
export type GetAllPackageByProjectLazyQueryHookResult = ReturnType<typeof useGetAllPackageByProjectLazyQuery>;
export type GetAllPackageByProjectQueryResult = Apollo.QueryResult<GetAllPackageByProjectQuery, GetAllPackageByProjectQueryVariables>;
export const GetSalesContractAttachmentsDocument = gql`
    query getSalesContractAttachments($sale_id: String!) {
  getSalesContractAttachments(sale_id: $sale_id) {
    bookingAttachments {
      bookingNricAttachments {
        id
        accountId
        refTable
        refId
        refType
        mediaType
        resourceUrl
        fileName
        bucketFileName
        isPrivate
        seqNo
        allowDelete
      }
      bookingFeeAttachments {
        id
        accountId
        refTable
        refId
        refType
        mediaType
        resourceUrl
        fileName
        bucketFileName
        isPrivate
        seqNo
        allowDelete
      }
      solicitorAgreementAttachments {
        id
        accountId
        refTable
        refId
        refType
        mediaType
        resourceUrl
        fileName
        bucketFileName
        isPrivate
        seqNo
        allowDelete
      }
      solicitorOthersAttachments {
        id
        accountId
        refTable
        refId
        refType
        mediaType
        resourceUrl
        fileName
        bucketFileName
        isPrivate
        seqNo
        allowDelete
      }
      bookingCcrAttachments {
        id
        accountId
        refTable
        refId
        refType
        mediaType
        resourceUrl
        fileName
        bucketFileName
        isPrivate
        seqNo
        allowDelete
      }
    }
  }
}
    `;

/**
 * __useGetSalesContractAttachmentsQuery__
 *
 * To run a query within a React component, call `useGetSalesContractAttachmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesContractAttachmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesContractAttachmentsQuery({
 *   variables: {
 *      sale_id: // value for 'sale_id'
 *   },
 * });
 */
export function useGetSalesContractAttachmentsQuery(baseOptions: Apollo.QueryHookOptions<GetSalesContractAttachmentsQuery, GetSalesContractAttachmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesContractAttachmentsQuery, GetSalesContractAttachmentsQueryVariables>(GetSalesContractAttachmentsDocument, options);
      }
export function useGetSalesContractAttachmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesContractAttachmentsQuery, GetSalesContractAttachmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesContractAttachmentsQuery, GetSalesContractAttachmentsQueryVariables>(GetSalesContractAttachmentsDocument, options);
        }
export type GetSalesContractAttachmentsQueryHookResult = ReturnType<typeof useGetSalesContractAttachmentsQuery>;
export type GetSalesContractAttachmentsLazyQueryHookResult = ReturnType<typeof useGetSalesContractAttachmentsLazyQuery>;
export type GetSalesContractAttachmentsQueryResult = Apollo.QueryResult<GetSalesContractAttachmentsQuery, GetSalesContractAttachmentsQueryVariables>;
export const AddAttachmentsDocument = gql`
    mutation addAttachments($input: SalesAddAttachmentsInput!) {
  addAttachments(input: $input) {
    id
    accountId
    bucketFileName
    fileName
    isPrivate
    mediaType
    refId
    refTable
    refType
    resourceUrl
    seqNo
  }
}
    `;
export type AddAttachmentsMutationFn = Apollo.MutationFunction<AddAttachmentsMutation, AddAttachmentsMutationVariables>;

/**
 * __useAddAttachmentsMutation__
 *
 * To run a mutation, you first call `useAddAttachmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAttachmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAttachmentsMutation, { data, loading, error }] = useAddAttachmentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAttachmentsMutation(baseOptions?: Apollo.MutationHookOptions<AddAttachmentsMutation, AddAttachmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAttachmentsMutation, AddAttachmentsMutationVariables>(AddAttachmentsDocument, options);
      }
export type AddAttachmentsMutationHookResult = ReturnType<typeof useAddAttachmentsMutation>;
export type AddAttachmentsMutationResult = Apollo.MutationResult<AddAttachmentsMutation>;
export type AddAttachmentsMutationOptions = Apollo.BaseMutationOptions<AddAttachmentsMutation, AddAttachmentsMutationVariables>;
export const DownloadAttachmentDocument = gql`
    mutation downloadAttachment($input: SalesDownloadAttachmentInput!) {
  downloadAttachment(input: $input) {
    content
    fileName
  }
}
    `;
export type DownloadAttachmentMutationFn = Apollo.MutationFunction<DownloadAttachmentMutation, DownloadAttachmentMutationVariables>;

/**
 * __useDownloadAttachmentMutation__
 *
 * To run a mutation, you first call `useDownloadAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadAttachmentMutation, { data, loading, error }] = useDownloadAttachmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDownloadAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<DownloadAttachmentMutation, DownloadAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadAttachmentMutation, DownloadAttachmentMutationVariables>(DownloadAttachmentDocument, options);
      }
export type DownloadAttachmentMutationHookResult = ReturnType<typeof useDownloadAttachmentMutation>;
export type DownloadAttachmentMutationResult = Apollo.MutationResult<DownloadAttachmentMutation>;
export type DownloadAttachmentMutationOptions = Apollo.BaseMutationOptions<DownloadAttachmentMutation, DownloadAttachmentMutationVariables>;
export const DeleteAttachmentDocument = gql`
    mutation deleteAttachment($attachmentId: String!) {
  deleteAttachment(attachmentId: $attachmentId)
}
    `;
export type DeleteAttachmentMutationFn = Apollo.MutationFunction<DeleteAttachmentMutation, DeleteAttachmentMutationVariables>;

/**
 * __useDeleteAttachmentMutation__
 *
 * To run a mutation, you first call `useDeleteAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAttachmentMutation, { data, loading, error }] = useDeleteAttachmentMutation({
 *   variables: {
 *      attachmentId: // value for 'attachmentId'
 *   },
 * });
 */
export function useDeleteAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAttachmentMutation, DeleteAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAttachmentMutation, DeleteAttachmentMutationVariables>(DeleteAttachmentDocument, options);
      }
export type DeleteAttachmentMutationHookResult = ReturnType<typeof useDeleteAttachmentMutation>;
export type DeleteAttachmentMutationResult = Apollo.MutationResult<DeleteAttachmentMutation>;
export type DeleteAttachmentMutationOptions = Apollo.BaseMutationOptions<DeleteAttachmentMutation, DeleteAttachmentMutationVariables>;
export const GetProjectPaymentPlanDocument = gql`
    query getProjectPaymentPlan {
  getProjectPaymentPlan {
    id
    accountId
    projectId
    paymentPlanId
    defaulted
    paymentPlan {
      id
      name
      payMethod
      details {
        title
        workProgressId
        workProgress {
          isCarPark
        }
      }
    }
  }
}
    `;

/**
 * __useGetProjectPaymentPlanQuery__
 *
 * To run a query within a React component, call `useGetProjectPaymentPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectPaymentPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectPaymentPlanQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProjectPaymentPlanQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectPaymentPlanQuery, GetProjectPaymentPlanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectPaymentPlanQuery, GetProjectPaymentPlanQueryVariables>(GetProjectPaymentPlanDocument, options);
      }
export function useGetProjectPaymentPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectPaymentPlanQuery, GetProjectPaymentPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectPaymentPlanQuery, GetProjectPaymentPlanQueryVariables>(GetProjectPaymentPlanDocument, options);
        }
export type GetProjectPaymentPlanQueryHookResult = ReturnType<typeof useGetProjectPaymentPlanQuery>;
export type GetProjectPaymentPlanLazyQueryHookResult = ReturnType<typeof useGetProjectPaymentPlanLazyQuery>;
export type GetProjectPaymentPlanQueryResult = Apollo.QueryResult<GetProjectPaymentPlanQuery, GetProjectPaymentPlanQueryVariables>;
export const GetActiveProjectPaymentPlanDocument = gql`
    query getActiveProjectPaymentPlan($saleId: String!) {
  getActiveProjectPaymentPlan(saleId: $saleId) {
    paymentPlanId
    paymentPlanName
    status
    isStakeholder
  }
}
    `;

/**
 * __useGetActiveProjectPaymentPlanQuery__
 *
 * To run a query within a React component, call `useGetActiveProjectPaymentPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveProjectPaymentPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveProjectPaymentPlanQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetActiveProjectPaymentPlanQuery(baseOptions: Apollo.QueryHookOptions<GetActiveProjectPaymentPlanQuery, GetActiveProjectPaymentPlanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveProjectPaymentPlanQuery, GetActiveProjectPaymentPlanQueryVariables>(GetActiveProjectPaymentPlanDocument, options);
      }
export function useGetActiveProjectPaymentPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveProjectPaymentPlanQuery, GetActiveProjectPaymentPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveProjectPaymentPlanQuery, GetActiveProjectPaymentPlanQueryVariables>(GetActiveProjectPaymentPlanDocument, options);
        }
export type GetActiveProjectPaymentPlanQueryHookResult = ReturnType<typeof useGetActiveProjectPaymentPlanQuery>;
export type GetActiveProjectPaymentPlanLazyQueryHookResult = ReturnType<typeof useGetActiveProjectPaymentPlanLazyQuery>;
export type GetActiveProjectPaymentPlanQueryResult = Apollo.QueryResult<GetActiveProjectPaymentPlanQuery, GetActiveProjectPaymentPlanQueryVariables>;
export const GetSolicitorSignedDetailDocument = gql`
    query getSolicitorSignedDetail($sales_id: String!) {
  getSolicitorSignedInfo(salesId: $sales_id) {
    bookDate
    signedDate
    stampDate
    remark
    snpAgreement {
      mediaType
      name
      url
      id
    }
  }
}
    `;

/**
 * __useGetSolicitorSignedDetailQuery__
 *
 * To run a query within a React component, call `useGetSolicitorSignedDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSolicitorSignedDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSolicitorSignedDetailQuery({
 *   variables: {
 *      sales_id: // value for 'sales_id'
 *   },
 * });
 */
export function useGetSolicitorSignedDetailQuery(baseOptions: Apollo.QueryHookOptions<GetSolicitorSignedDetailQuery, GetSolicitorSignedDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSolicitorSignedDetailQuery, GetSolicitorSignedDetailQueryVariables>(GetSolicitorSignedDetailDocument, options);
      }
export function useGetSolicitorSignedDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSolicitorSignedDetailQuery, GetSolicitorSignedDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSolicitorSignedDetailQuery, GetSolicitorSignedDetailQueryVariables>(GetSolicitorSignedDetailDocument, options);
        }
export type GetSolicitorSignedDetailQueryHookResult = ReturnType<typeof useGetSolicitorSignedDetailQuery>;
export type GetSolicitorSignedDetailLazyQueryHookResult = ReturnType<typeof useGetSolicitorSignedDetailLazyQuery>;
export type GetSolicitorSignedDetailQueryResult = Apollo.QueryResult<GetSolicitorSignedDetailQuery, GetSolicitorSignedDetailQueryVariables>;
export const RecalculateProgressBillingDocument = gql`
    mutation recalculateProgressBilling($saleId: String!) {
  recalculateProgressBilling(saleId: $saleId)
}
    `;
export type RecalculateProgressBillingMutationFn = Apollo.MutationFunction<RecalculateProgressBillingMutation, RecalculateProgressBillingMutationVariables>;

/**
 * __useRecalculateProgressBillingMutation__
 *
 * To run a mutation, you first call `useRecalculateProgressBillingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecalculateProgressBillingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recalculateProgressBillingMutation, { data, loading, error }] = useRecalculateProgressBillingMutation({
 *   variables: {
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useRecalculateProgressBillingMutation(baseOptions?: Apollo.MutationHookOptions<RecalculateProgressBillingMutation, RecalculateProgressBillingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecalculateProgressBillingMutation, RecalculateProgressBillingMutationVariables>(RecalculateProgressBillingDocument, options);
      }
export type RecalculateProgressBillingMutationHookResult = ReturnType<typeof useRecalculateProgressBillingMutation>;
export type RecalculateProgressBillingMutationResult = Apollo.MutationResult<RecalculateProgressBillingMutation>;
export type RecalculateProgressBillingMutationOptions = Apollo.BaseMutationOptions<RecalculateProgressBillingMutation, RecalculateProgressBillingMutationVariables>;
export const UpdateSalesContractPaymentPlanDocument = gql`
    mutation updateSalesContractPaymentPlan($saleId: String!, $paymentPlanId: String!) {
  updateSalesContractPaymentPlan(saleId: $saleId, paymentPlanId: $paymentPlanId)
}
    `;
export type UpdateSalesContractPaymentPlanMutationFn = Apollo.MutationFunction<UpdateSalesContractPaymentPlanMutation, UpdateSalesContractPaymentPlanMutationVariables>;

/**
 * __useUpdateSalesContractPaymentPlanMutation__
 *
 * To run a mutation, you first call `useUpdateSalesContractPaymentPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSalesContractPaymentPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSalesContractPaymentPlanMutation, { data, loading, error }] = useUpdateSalesContractPaymentPlanMutation({
 *   variables: {
 *      saleId: // value for 'saleId'
 *      paymentPlanId: // value for 'paymentPlanId'
 *   },
 * });
 */
export function useUpdateSalesContractPaymentPlanMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSalesContractPaymentPlanMutation, UpdateSalesContractPaymentPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSalesContractPaymentPlanMutation, UpdateSalesContractPaymentPlanMutationVariables>(UpdateSalesContractPaymentPlanDocument, options);
      }
export type UpdateSalesContractPaymentPlanMutationHookResult = ReturnType<typeof useUpdateSalesContractPaymentPlanMutation>;
export type UpdateSalesContractPaymentPlanMutationResult = Apollo.MutationResult<UpdateSalesContractPaymentPlanMutation>;
export type UpdateSalesContractPaymentPlanMutationOptions = Apollo.BaseMutationOptions<UpdateSalesContractPaymentPlanMutation, UpdateSalesContractPaymentPlanMutationVariables>;
export const GetActiveCampaignByProjectDocument = gql`
    query getActiveCampaignByProject {
  getActiveCampaignByProject {
    id
    accountId
    name
    startDate
    endDate
    commonStatus
    getCampaignEventsCount
  }
}
    `;

/**
 * __useGetActiveCampaignByProjectQuery__
 *
 * To run a query within a React component, call `useGetActiveCampaignByProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveCampaignByProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveCampaignByProjectQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActiveCampaignByProjectQuery(baseOptions?: Apollo.QueryHookOptions<GetActiveCampaignByProjectQuery, GetActiveCampaignByProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveCampaignByProjectQuery, GetActiveCampaignByProjectQueryVariables>(GetActiveCampaignByProjectDocument, options);
      }
export function useGetActiveCampaignByProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveCampaignByProjectQuery, GetActiveCampaignByProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveCampaignByProjectQuery, GetActiveCampaignByProjectQueryVariables>(GetActiveCampaignByProjectDocument, options);
        }
export type GetActiveCampaignByProjectQueryHookResult = ReturnType<typeof useGetActiveCampaignByProjectQuery>;
export type GetActiveCampaignByProjectLazyQueryHookResult = ReturnType<typeof useGetActiveCampaignByProjectLazyQuery>;
export type GetActiveCampaignByProjectQueryResult = Apollo.QueryResult<GetActiveCampaignByProjectQuery, GetActiveCampaignByProjectQueryVariables>;
export const GetSaleContactListDocument = gql`
    query getSaleContactList($isCompany: Boolean!) {
  getSaleContactList(isCompany: $isCompany) {
    id
    fullName
    email
    phoneNo
    gender
    icNo
    militaryIc
    companyName
    companyRegNo
    homeTel
    officeTel
    salutation {
      id
    }
    nationality {
      id
    }
    race {
      id
    }
    maritalStatus {
      id
    }
    address {
      address
      country
      city
      state
      postCode
    }
    contactExt {
      identityType
      customerOrigin
      isBumi
      isForeignPurchase
      subscribeMaterialSms
      subscribeMaterialWhatsapp
      subscribeMaterialEmail
      subscribeMaterialPaNews
      mailingMethod
      remark
    }
    addressList {
      id
      isPrimary
      address {
        address
        country
        city
        state
        postCode
        AddressType
      }
    }
  }
}
    `;

/**
 * __useGetSaleContactListQuery__
 *
 * To run a query within a React component, call `useGetSaleContactListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSaleContactListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSaleContactListQuery({
 *   variables: {
 *      isCompany: // value for 'isCompany'
 *   },
 * });
 */
export function useGetSaleContactListQuery(baseOptions: Apollo.QueryHookOptions<GetSaleContactListQuery, GetSaleContactListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSaleContactListQuery, GetSaleContactListQueryVariables>(GetSaleContactListDocument, options);
      }
export function useGetSaleContactListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSaleContactListQuery, GetSaleContactListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSaleContactListQuery, GetSaleContactListQueryVariables>(GetSaleContactListDocument, options);
        }
export type GetSaleContactListQueryHookResult = ReturnType<typeof useGetSaleContactListQuery>;
export type GetSaleContactListLazyQueryHookResult = ReturnType<typeof useGetSaleContactListLazyQuery>;
export type GetSaleContactListQueryResult = Apollo.QueryResult<GetSaleContactListQuery, GetSaleContactListQueryVariables>;
export const CheckProjectSpecDocument = gql`
    query checkProjectSpec {
  checkProjectSpec {
    bookingFeeMandatory
    nricAttachmentRequired
    ccrAttachmentRequired
  }
}
    `;

/**
 * __useCheckProjectSpecQuery__
 *
 * To run a query within a React component, call `useCheckProjectSpecQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckProjectSpecQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckProjectSpecQuery({
 *   variables: {
 *   },
 * });
 */
export function useCheckProjectSpecQuery(baseOptions?: Apollo.QueryHookOptions<CheckProjectSpecQuery, CheckProjectSpecQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckProjectSpecQuery, CheckProjectSpecQueryVariables>(CheckProjectSpecDocument, options);
      }
export function useCheckProjectSpecLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckProjectSpecQuery, CheckProjectSpecQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckProjectSpecQuery, CheckProjectSpecQueryVariables>(CheckProjectSpecDocument, options);
        }
export type CheckProjectSpecQueryHookResult = ReturnType<typeof useCheckProjectSpecQuery>;
export type CheckProjectSpecLazyQueryHookResult = ReturnType<typeof useCheckProjectSpecLazyQuery>;
export type CheckProjectSpecQueryResult = Apollo.QueryResult<CheckProjectSpecQuery, CheckProjectSpecQueryVariables>;
export const SpaSigningReversalDocument = gql`
    mutation spaSigningReversal($saleId: String!) {
  spaSigningReversal(saleId: $saleId)
}
    `;
export type SpaSigningReversalMutationFn = Apollo.MutationFunction<SpaSigningReversalMutation, SpaSigningReversalMutationVariables>;

/**
 * __useSpaSigningReversalMutation__
 *
 * To run a mutation, you first call `useSpaSigningReversalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSpaSigningReversalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [spaSigningReversalMutation, { data, loading, error }] = useSpaSigningReversalMutation({
 *   variables: {
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useSpaSigningReversalMutation(baseOptions?: Apollo.MutationHookOptions<SpaSigningReversalMutation, SpaSigningReversalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SpaSigningReversalMutation, SpaSigningReversalMutationVariables>(SpaSigningReversalDocument, options);
      }
export type SpaSigningReversalMutationHookResult = ReturnType<typeof useSpaSigningReversalMutation>;
export type SpaSigningReversalMutationResult = Apollo.MutationResult<SpaSigningReversalMutation>;
export type SpaSigningReversalMutationOptions = Apollo.BaseMutationOptions<SpaSigningReversalMutation, SpaSigningReversalMutationVariables>;
export const GetSalesDiscountListDocument = gql`
    query getSalesDiscountList($saleID: String!) {
  getSalesDiscountList(saleID: $saleID) {
    id
    salesDiscountDiscardBumi
    discountId
    amount
    seqNo
    discount {
      title
      formula
      prefix
      discountVal
      discountType {
        name
      }
    }
    saleDiscountExtension {
      formula
      discountMethod
    }
  }
}
    `;

/**
 * __useGetSalesDiscountListQuery__
 *
 * To run a query within a React component, call `useGetSalesDiscountListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesDiscountListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesDiscountListQuery({
 *   variables: {
 *      saleID: // value for 'saleID'
 *   },
 * });
 */
export function useGetSalesDiscountListQuery(baseOptions: Apollo.QueryHookOptions<GetSalesDiscountListQuery, GetSalesDiscountListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesDiscountListQuery, GetSalesDiscountListQueryVariables>(GetSalesDiscountListDocument, options);
      }
export function useGetSalesDiscountListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesDiscountListQuery, GetSalesDiscountListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesDiscountListQuery, GetSalesDiscountListQueryVariables>(GetSalesDiscountListDocument, options);
        }
export type GetSalesDiscountListQueryHookResult = ReturnType<typeof useGetSalesDiscountListQuery>;
export type GetSalesDiscountListLazyQueryHookResult = ReturnType<typeof useGetSalesDiscountListLazyQuery>;
export type GetSalesDiscountListQueryResult = Apollo.QueryResult<GetSalesDiscountListQuery, GetSalesDiscountListQueryVariables>;
export const AddSalesContractDiscountDocument = gql`
    mutation addSalesContractDiscount($input: addSalesContractDiscountInput!, $saleId: String!) {
  addSalesContractDiscount(input: $input, saleId: $saleId)
}
    `;
export type AddSalesContractDiscountMutationFn = Apollo.MutationFunction<AddSalesContractDiscountMutation, AddSalesContractDiscountMutationVariables>;

/**
 * __useAddSalesContractDiscountMutation__
 *
 * To run a mutation, you first call `useAddSalesContractDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSalesContractDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSalesContractDiscountMutation, { data, loading, error }] = useAddSalesContractDiscountMutation({
 *   variables: {
 *      input: // value for 'input'
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useAddSalesContractDiscountMutation(baseOptions?: Apollo.MutationHookOptions<AddSalesContractDiscountMutation, AddSalesContractDiscountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSalesContractDiscountMutation, AddSalesContractDiscountMutationVariables>(AddSalesContractDiscountDocument, options);
      }
export type AddSalesContractDiscountMutationHookResult = ReturnType<typeof useAddSalesContractDiscountMutation>;
export type AddSalesContractDiscountMutationResult = Apollo.MutationResult<AddSalesContractDiscountMutation>;
export type AddSalesContractDiscountMutationOptions = Apollo.BaseMutationOptions<AddSalesContractDiscountMutation, AddSalesContractDiscountMutationVariables>;
export const EditSalesContractDiscountDocument = gql`
    mutation editSalesContractDiscount($input: editSalesContractDiscountInput!, $saleId: String!) {
  editSalesContractDiscount(input: $input, saleId: $saleId)
}
    `;
export type EditSalesContractDiscountMutationFn = Apollo.MutationFunction<EditSalesContractDiscountMutation, EditSalesContractDiscountMutationVariables>;

/**
 * __useEditSalesContractDiscountMutation__
 *
 * To run a mutation, you first call `useEditSalesContractDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSalesContractDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSalesContractDiscountMutation, { data, loading, error }] = useEditSalesContractDiscountMutation({
 *   variables: {
 *      input: // value for 'input'
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useEditSalesContractDiscountMutation(baseOptions?: Apollo.MutationHookOptions<EditSalesContractDiscountMutation, EditSalesContractDiscountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditSalesContractDiscountMutation, EditSalesContractDiscountMutationVariables>(EditSalesContractDiscountDocument, options);
      }
export type EditSalesContractDiscountMutationHookResult = ReturnType<typeof useEditSalesContractDiscountMutation>;
export type EditSalesContractDiscountMutationResult = Apollo.MutationResult<EditSalesContractDiscountMutation>;
export type EditSalesContractDiscountMutationOptions = Apollo.BaseMutationOptions<EditSalesContractDiscountMutation, EditSalesContractDiscountMutationVariables>;
export const DeleteSalesContractDiscountDocument = gql`
    mutation deleteSalesContractDiscount($discountId: String!, $saleId: String!) {
  deleteSalesContractDiscount(discountId: $discountId, saleId: $saleId)
}
    `;
export type DeleteSalesContractDiscountMutationFn = Apollo.MutationFunction<DeleteSalesContractDiscountMutation, DeleteSalesContractDiscountMutationVariables>;

/**
 * __useDeleteSalesContractDiscountMutation__
 *
 * To run a mutation, you first call `useDeleteSalesContractDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSalesContractDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSalesContractDiscountMutation, { data, loading, error }] = useDeleteSalesContractDiscountMutation({
 *   variables: {
 *      discountId: // value for 'discountId'
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useDeleteSalesContractDiscountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSalesContractDiscountMutation, DeleteSalesContractDiscountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSalesContractDiscountMutation, DeleteSalesContractDiscountMutationVariables>(DeleteSalesContractDiscountDocument, options);
      }
export type DeleteSalesContractDiscountMutationHookResult = ReturnType<typeof useDeleteSalesContractDiscountMutation>;
export type DeleteSalesContractDiscountMutationResult = Apollo.MutationResult<DeleteSalesContractDiscountMutation>;
export type DeleteSalesContractDiscountMutationOptions = Apollo.BaseMutationOptions<DeleteSalesContractDiscountMutation, DeleteSalesContractDiscountMutationVariables>;
export const GetSalesDiscountByIdDocument = gql`
    query getSalesDiscountById($saleId: String!, $discountId: String!) {
  getSalesDiscountById(saleId: $saleId, discountId: $discountId) {
    id
    discountId
    amount
    seqNo
    discount {
      title
      formula
      prefix
      discountVal
      discountType {
        name
      }
    }
    saleDiscountExtension {
      formula
      discountMethod
    }
    currentDiscountDetail {
      id
      effectiveDate
      expired_date
      defaulted
      discount {
        id
        title
        formula
        prefix
        discountVal
        discountType {
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetSalesDiscountByIdQuery__
 *
 * To run a query within a React component, call `useGetSalesDiscountByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesDiscountByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesDiscountByIdQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *      discountId: // value for 'discountId'
 *   },
 * });
 */
export function useGetSalesDiscountByIdQuery(baseOptions: Apollo.QueryHookOptions<GetSalesDiscountByIdQuery, GetSalesDiscountByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesDiscountByIdQuery, GetSalesDiscountByIdQueryVariables>(GetSalesDiscountByIdDocument, options);
      }
export function useGetSalesDiscountByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesDiscountByIdQuery, GetSalesDiscountByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesDiscountByIdQuery, GetSalesDiscountByIdQueryVariables>(GetSalesDiscountByIdDocument, options);
        }
export type GetSalesDiscountByIdQueryHookResult = ReturnType<typeof useGetSalesDiscountByIdQuery>;
export type GetSalesDiscountByIdLazyQueryHookResult = ReturnType<typeof useGetSalesDiscountByIdLazyQuery>;
export type GetSalesDiscountByIdQueryResult = Apollo.QueryResult<GetSalesDiscountByIdQuery, GetSalesDiscountByIdQueryVariables>;
export const UpdateDiscardBumiDocument = gql`
    mutation updateDiscardBumi($saleId: String!, $discardBumi: Boolean!) {
  updateDiscardBumi(saleId: $saleId, discardBumi: $discardBumi)
}
    `;
export type UpdateDiscardBumiMutationFn = Apollo.MutationFunction<UpdateDiscardBumiMutation, UpdateDiscardBumiMutationVariables>;

/**
 * __useUpdateDiscardBumiMutation__
 *
 * To run a mutation, you first call `useUpdateDiscardBumiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDiscardBumiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDiscardBumiMutation, { data, loading, error }] = useUpdateDiscardBumiMutation({
 *   variables: {
 *      saleId: // value for 'saleId'
 *      discardBumi: // value for 'discardBumi'
 *   },
 * });
 */
export function useUpdateDiscardBumiMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDiscardBumiMutation, UpdateDiscardBumiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDiscardBumiMutation, UpdateDiscardBumiMutationVariables>(UpdateDiscardBumiDocument, options);
      }
export type UpdateDiscardBumiMutationHookResult = ReturnType<typeof useUpdateDiscardBumiMutation>;
export type UpdateDiscardBumiMutationResult = Apollo.MutationResult<UpdateDiscardBumiMutation>;
export type UpdateDiscardBumiMutationOptions = Apollo.BaseMutationOptions<UpdateDiscardBumiMutation, UpdateDiscardBumiMutationVariables>;
export const GetSalesPackageListDocument = gql`
    query getSalesPackageList($saleID: String!) {
  getSalesPackageList(saleID: $saleID) {
    id
    name
    desc
    sellingPrice
    sellingMethod
    error
  }
}
    `;

/**
 * __useGetSalesPackageListQuery__
 *
 * To run a query within a React component, call `useGetSalesPackageListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesPackageListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesPackageListQuery({
 *   variables: {
 *      saleID: // value for 'saleID'
 *   },
 * });
 */
export function useGetSalesPackageListQuery(baseOptions: Apollo.QueryHookOptions<GetSalesPackageListQuery, GetSalesPackageListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesPackageListQuery, GetSalesPackageListQueryVariables>(GetSalesPackageListDocument, options);
      }
export function useGetSalesPackageListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesPackageListQuery, GetSalesPackageListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesPackageListQuery, GetSalesPackageListQueryVariables>(GetSalesPackageListDocument, options);
        }
export type GetSalesPackageListQueryHookResult = ReturnType<typeof useGetSalesPackageListQuery>;
export type GetSalesPackageListLazyQueryHookResult = ReturnType<typeof useGetSalesPackageListLazyQuery>;
export type GetSalesPackageListQueryResult = Apollo.QueryResult<GetSalesPackageListQuery, GetSalesPackageListQueryVariables>;
export const AddSalesContractPackageDocument = gql`
    mutation addSalesContractPackage($input: addSalesContractPackageInput!, $saleID: String!) {
  addSalesContractPackage(input: $input, saleID: $saleID)
}
    `;
export type AddSalesContractPackageMutationFn = Apollo.MutationFunction<AddSalesContractPackageMutation, AddSalesContractPackageMutationVariables>;

/**
 * __useAddSalesContractPackageMutation__
 *
 * To run a mutation, you first call `useAddSalesContractPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSalesContractPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSalesContractPackageMutation, { data, loading, error }] = useAddSalesContractPackageMutation({
 *   variables: {
 *      input: // value for 'input'
 *      saleID: // value for 'saleID'
 *   },
 * });
 */
export function useAddSalesContractPackageMutation(baseOptions?: Apollo.MutationHookOptions<AddSalesContractPackageMutation, AddSalesContractPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSalesContractPackageMutation, AddSalesContractPackageMutationVariables>(AddSalesContractPackageDocument, options);
      }
export type AddSalesContractPackageMutationHookResult = ReturnType<typeof useAddSalesContractPackageMutation>;
export type AddSalesContractPackageMutationResult = Apollo.MutationResult<AddSalesContractPackageMutation>;
export type AddSalesContractPackageMutationOptions = Apollo.BaseMutationOptions<AddSalesContractPackageMutation, AddSalesContractPackageMutationVariables>;
export const EditSalesContractPackageDocument = gql`
    mutation editSalesContractPackage($input: editSalesContractPackageInput!, $saleID: String!) {
  editSalesContractPackage(input: $input, saleID: $saleID)
}
    `;
export type EditSalesContractPackageMutationFn = Apollo.MutationFunction<EditSalesContractPackageMutation, EditSalesContractPackageMutationVariables>;

/**
 * __useEditSalesContractPackageMutation__
 *
 * To run a mutation, you first call `useEditSalesContractPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSalesContractPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSalesContractPackageMutation, { data, loading, error }] = useEditSalesContractPackageMutation({
 *   variables: {
 *      input: // value for 'input'
 *      saleID: // value for 'saleID'
 *   },
 * });
 */
export function useEditSalesContractPackageMutation(baseOptions?: Apollo.MutationHookOptions<EditSalesContractPackageMutation, EditSalesContractPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditSalesContractPackageMutation, EditSalesContractPackageMutationVariables>(EditSalesContractPackageDocument, options);
      }
export type EditSalesContractPackageMutationHookResult = ReturnType<typeof useEditSalesContractPackageMutation>;
export type EditSalesContractPackageMutationResult = Apollo.MutationResult<EditSalesContractPackageMutation>;
export type EditSalesContractPackageMutationOptions = Apollo.BaseMutationOptions<EditSalesContractPackageMutation, EditSalesContractPackageMutationVariables>;
export const DeleteSalesContractPackageDocument = gql`
    mutation deleteSalesContractPackage($id: String!, $saleID: String!) {
  deleteSalesContractPackage(id: $id, saleID: $saleID)
}
    `;
export type DeleteSalesContractPackageMutationFn = Apollo.MutationFunction<DeleteSalesContractPackageMutation, DeleteSalesContractPackageMutationVariables>;

/**
 * __useDeleteSalesContractPackageMutation__
 *
 * To run a mutation, you first call `useDeleteSalesContractPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSalesContractPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSalesContractPackageMutation, { data, loading, error }] = useDeleteSalesContractPackageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      saleID: // value for 'saleID'
 *   },
 * });
 */
export function useDeleteSalesContractPackageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSalesContractPackageMutation, DeleteSalesContractPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSalesContractPackageMutation, DeleteSalesContractPackageMutationVariables>(DeleteSalesContractPackageDocument, options);
      }
export type DeleteSalesContractPackageMutationHookResult = ReturnType<typeof useDeleteSalesContractPackageMutation>;
export type DeleteSalesContractPackageMutationResult = Apollo.MutationResult<DeleteSalesContractPackageMutation>;
export type DeleteSalesContractPackageMutationOptions = Apollo.BaseMutationOptions<DeleteSalesContractPackageMutation, DeleteSalesContractPackageMutationVariables>;
export const GetSalesContractPackageByIdDocument = gql`
    query getSalesContractPackageById($saleId: String!, $packageId: String!) {
  getSalesContractPackageById(saleId: $saleId, packageId: $packageId) {
    id
    accountId
    saleId
    packageId
    openMarketValue
    sellingPrice
    sellingMethod
    taxSchemeId
    workProgressId
    paymentPlanId
    package {
      name
    }
    workProgress {
      name
    }
    salePackage {
      id
      name
      desc
      projectId
      listPrice
      marketValue
      startDate
      endDate
      isIntegrated
    }
    workProgress {
      id
      name
    }
    projectPaymentPlan {
      id
      accountId
      projectId
      paymentPlanId
      defaulted
      paymentPlan {
        id
        name
        payMethod
        details {
          title
          workProgressId
        }
      }
    }
  }
}
    `;

/**
 * __useGetSalesContractPackageByIdQuery__
 *
 * To run a query within a React component, call `useGetSalesContractPackageByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesContractPackageByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesContractPackageByIdQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *      packageId: // value for 'packageId'
 *   },
 * });
 */
export function useGetSalesContractPackageByIdQuery(baseOptions: Apollo.QueryHookOptions<GetSalesContractPackageByIdQuery, GetSalesContractPackageByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesContractPackageByIdQuery, GetSalesContractPackageByIdQueryVariables>(GetSalesContractPackageByIdDocument, options);
      }
export function useGetSalesContractPackageByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesContractPackageByIdQuery, GetSalesContractPackageByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesContractPackageByIdQuery, GetSalesContractPackageByIdQueryVariables>(GetSalesContractPackageByIdDocument, options);
        }
export type GetSalesContractPackageByIdQueryHookResult = ReturnType<typeof useGetSalesContractPackageByIdQuery>;
export type GetSalesContractPackageByIdLazyQueryHookResult = ReturnType<typeof useGetSalesContractPackageByIdLazyQuery>;
export type GetSalesContractPackageByIdQueryResult = Apollo.QueryResult<GetSalesContractPackageByIdQuery, GetSalesContractPackageByIdQueryVariables>;
export const AddSaleRebatePackageDocument = gql`
    mutation addSaleRebatePackage($input: addSalesContractRebateInput!) {
  addSaleRebatePackage(input: $input)
}
    `;
export type AddSaleRebatePackageMutationFn = Apollo.MutationFunction<AddSaleRebatePackageMutation, AddSaleRebatePackageMutationVariables>;

/**
 * __useAddSaleRebatePackageMutation__
 *
 * To run a mutation, you first call `useAddSaleRebatePackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSaleRebatePackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSaleRebatePackageMutation, { data, loading, error }] = useAddSaleRebatePackageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddSaleRebatePackageMutation(baseOptions?: Apollo.MutationHookOptions<AddSaleRebatePackageMutation, AddSaleRebatePackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSaleRebatePackageMutation, AddSaleRebatePackageMutationVariables>(AddSaleRebatePackageDocument, options);
      }
export type AddSaleRebatePackageMutationHookResult = ReturnType<typeof useAddSaleRebatePackageMutation>;
export type AddSaleRebatePackageMutationResult = Apollo.MutationResult<AddSaleRebatePackageMutation>;
export type AddSaleRebatePackageMutationOptions = Apollo.BaseMutationOptions<AddSaleRebatePackageMutation, AddSaleRebatePackageMutationVariables>;
export const EditSaleRebatePackageDocument = gql`
    mutation editSaleRebatePackage($input: editSalesContractRebateInput!) {
  editSaleRebatePackage(input: $input)
}
    `;
export type EditSaleRebatePackageMutationFn = Apollo.MutationFunction<EditSaleRebatePackageMutation, EditSaleRebatePackageMutationVariables>;

/**
 * __useEditSaleRebatePackageMutation__
 *
 * To run a mutation, you first call `useEditSaleRebatePackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSaleRebatePackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSaleRebatePackageMutation, { data, loading, error }] = useEditSaleRebatePackageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditSaleRebatePackageMutation(baseOptions?: Apollo.MutationHookOptions<EditSaleRebatePackageMutation, EditSaleRebatePackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditSaleRebatePackageMutation, EditSaleRebatePackageMutationVariables>(EditSaleRebatePackageDocument, options);
      }
export type EditSaleRebatePackageMutationHookResult = ReturnType<typeof useEditSaleRebatePackageMutation>;
export type EditSaleRebatePackageMutationResult = Apollo.MutationResult<EditSaleRebatePackageMutation>;
export type EditSaleRebatePackageMutationOptions = Apollo.BaseMutationOptions<EditSaleRebatePackageMutation, EditSaleRebatePackageMutationVariables>;
export const GetSalesRebatePackageDocument = gql`
    query getSalesRebatePackage($saleId: String!) {
  getSalesRebatePackage(saleId: $saleId) {
    id
    discountAmount
    discountTitle
    workProgressName
    error
    documentNo
  }
}
    `;

/**
 * __useGetSalesRebatePackageQuery__
 *
 * To run a query within a React component, call `useGetSalesRebatePackageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesRebatePackageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesRebatePackageQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetSalesRebatePackageQuery(baseOptions: Apollo.QueryHookOptions<GetSalesRebatePackageQuery, GetSalesRebatePackageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesRebatePackageQuery, GetSalesRebatePackageQueryVariables>(GetSalesRebatePackageDocument, options);
      }
export function useGetSalesRebatePackageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesRebatePackageQuery, GetSalesRebatePackageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesRebatePackageQuery, GetSalesRebatePackageQueryVariables>(GetSalesRebatePackageDocument, options);
        }
export type GetSalesRebatePackageQueryHookResult = ReturnType<typeof useGetSalesRebatePackageQuery>;
export type GetSalesRebatePackageLazyQueryHookResult = ReturnType<typeof useGetSalesRebatePackageLazyQuery>;
export type GetSalesRebatePackageQueryResult = Apollo.QueryResult<GetSalesRebatePackageQuery, GetSalesRebatePackageQueryVariables>;
export const DeleteSalesRebateDocument = gql`
    mutation deleteSalesRebate($saleRebateId: String!, $saleId: String!) {
  deleteSalesRebate(saleRebateId: $saleRebateId, saleId: $saleId)
}
    `;
export type DeleteSalesRebateMutationFn = Apollo.MutationFunction<DeleteSalesRebateMutation, DeleteSalesRebateMutationVariables>;

/**
 * __useDeleteSalesRebateMutation__
 *
 * To run a mutation, you first call `useDeleteSalesRebateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSalesRebateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSalesRebateMutation, { data, loading, error }] = useDeleteSalesRebateMutation({
 *   variables: {
 *      saleRebateId: // value for 'saleRebateId'
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useDeleteSalesRebateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSalesRebateMutation, DeleteSalesRebateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSalesRebateMutation, DeleteSalesRebateMutationVariables>(DeleteSalesRebateDocument, options);
      }
export type DeleteSalesRebateMutationHookResult = ReturnType<typeof useDeleteSalesRebateMutation>;
export type DeleteSalesRebateMutationResult = Apollo.MutationResult<DeleteSalesRebateMutation>;
export type DeleteSalesRebateMutationOptions = Apollo.BaseMutationOptions<DeleteSalesRebateMutation, DeleteSalesRebateMutationVariables>;
export const GetSalesRebatePackageByIdDocument = gql`
    query getSalesRebatePackageById($saleId: String!, $saleRebateId: String!) {
  getSalesRebatePackageById(saleId: $saleId, saleRebateId: $saleRebateId) {
    id
    discountId
    discountMethod
    roundingMode
    roundingPrecision
    campaignId
    workProgressId
    discountAmount
    displayRoundingPrecision
    displayRoundingMode
    displayDiscountMethod
    rebateId
    seqNo
    workProgress {
      name
      id
    }
    discount {
      title
      discountVal
      prefix
      discountType {
        name
      }
    }
    campaign {
      name
    }
    rebate {
      documentNo
    }
  }
}
    `;

/**
 * __useGetSalesRebatePackageByIdQuery__
 *
 * To run a query within a React component, call `useGetSalesRebatePackageByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesRebatePackageByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesRebatePackageByIdQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *      saleRebateId: // value for 'saleRebateId'
 *   },
 * });
 */
export function useGetSalesRebatePackageByIdQuery(baseOptions: Apollo.QueryHookOptions<GetSalesRebatePackageByIdQuery, GetSalesRebatePackageByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesRebatePackageByIdQuery, GetSalesRebatePackageByIdQueryVariables>(GetSalesRebatePackageByIdDocument, options);
      }
export function useGetSalesRebatePackageByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesRebatePackageByIdQuery, GetSalesRebatePackageByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesRebatePackageByIdQuery, GetSalesRebatePackageByIdQueryVariables>(GetSalesRebatePackageByIdDocument, options);
        }
export type GetSalesRebatePackageByIdQueryHookResult = ReturnType<typeof useGetSalesRebatePackageByIdQuery>;
export type GetSalesRebatePackageByIdLazyQueryHookResult = ReturnType<typeof useGetSalesRebatePackageByIdLazyQuery>;
export type GetSalesRebatePackageByIdQueryResult = Apollo.QueryResult<GetSalesRebatePackageByIdQuery, GetSalesRebatePackageByIdQueryVariables>;
export const HasTeamDocument = gql`
    query hasTeam {
  hasTeam
}
    `;

/**
 * __useHasTeamQuery__
 *
 * To run a query within a React component, call `useHasTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasTeamQuery({
 *   variables: {
 *   },
 * });
 */
export function useHasTeamQuery(baseOptions?: Apollo.QueryHookOptions<HasTeamQuery, HasTeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HasTeamQuery, HasTeamQueryVariables>(HasTeamDocument, options);
      }
export function useHasTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HasTeamQuery, HasTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HasTeamQuery, HasTeamQueryVariables>(HasTeamDocument, options);
        }
export type HasTeamQueryHookResult = ReturnType<typeof useHasTeamQuery>;
export type HasTeamLazyQueryHookResult = ReturnType<typeof useHasTeamLazyQuery>;
export type HasTeamQueryResult = Apollo.QueryResult<HasTeamQuery, HasTeamQueryVariables>;
export const GetTeamDocument = gql`
    query getTeam {
  getTeam {
    id
    name
    users {
      id
      name
      teamId
    }
  }
}
    `;

/**
 * __useGetTeamQuery__
 *
 * To run a query within a React component, call `useGetTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTeamQuery(baseOptions?: Apollo.QueryHookOptions<GetTeamQuery, GetTeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamQuery, GetTeamQueryVariables>(GetTeamDocument, options);
      }
export function useGetTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamQuery, GetTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamQuery, GetTeamQueryVariables>(GetTeamDocument, options);
        }
export type GetTeamQueryHookResult = ReturnType<typeof useGetTeamQuery>;
export type GetTeamLazyQueryHookResult = ReturnType<typeof useGetTeamLazyQuery>;
export type GetTeamQueryResult = Apollo.QueryResult<GetTeamQuery, GetTeamQueryVariables>;
export const GetAgencyTeamDocument = gql`
    query getAgencyTeam {
  getAgencyTeam {
    id
    name
    agencyContractId
    users {
      id
      name
      agencyContractId
      agencyId
    }
  }
}
    `;

/**
 * __useGetAgencyTeamQuery__
 *
 * To run a query within a React component, call `useGetAgencyTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgencyTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgencyTeamQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAgencyTeamQuery(baseOptions?: Apollo.QueryHookOptions<GetAgencyTeamQuery, GetAgencyTeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgencyTeamQuery, GetAgencyTeamQueryVariables>(GetAgencyTeamDocument, options);
      }
export function useGetAgencyTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgencyTeamQuery, GetAgencyTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgencyTeamQuery, GetAgencyTeamQueryVariables>(GetAgencyTeamDocument, options);
        }
export type GetAgencyTeamQueryHookResult = ReturnType<typeof useGetAgencyTeamQuery>;
export type GetAgencyTeamLazyQueryHookResult = ReturnType<typeof useGetAgencyTeamLazyQuery>;
export type GetAgencyTeamQueryResult = Apollo.QueryResult<GetAgencyTeamQuery, GetAgencyTeamQueryVariables>;
export const GetSaleSubProductListDocument = gql`
    query getSaleSubProductList($saleID: String!) {
  getSaleSubProductList(saleID: $saleID) {
    id
    saleId
    unitId
    sellingPrice
    sellingMethod
    paymentPlanId
    unitNo
    parentId
  }
}
    `;

/**
 * __useGetSaleSubProductListQuery__
 *
 * To run a query within a React component, call `useGetSaleSubProductListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSaleSubProductListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSaleSubProductListQuery({
 *   variables: {
 *      saleID: // value for 'saleID'
 *   },
 * });
 */
export function useGetSaleSubProductListQuery(baseOptions: Apollo.QueryHookOptions<GetSaleSubProductListQuery, GetSaleSubProductListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSaleSubProductListQuery, GetSaleSubProductListQueryVariables>(GetSaleSubProductListDocument, options);
      }
export function useGetSaleSubProductListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSaleSubProductListQuery, GetSaleSubProductListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSaleSubProductListQuery, GetSaleSubProductListQueryVariables>(GetSaleSubProductListDocument, options);
        }
export type GetSaleSubProductListQueryHookResult = ReturnType<typeof useGetSaleSubProductListQuery>;
export type GetSaleSubProductListLazyQueryHookResult = ReturnType<typeof useGetSaleSubProductListLazyQuery>;
export type GetSaleSubProductListQueryResult = Apollo.QueryResult<GetSaleSubProductListQuery, GetSaleSubProductListQueryVariables>;
export const GetSaleContractSubProductByIdDocument = gql`
    query getSaleContractSubProductById($saleId: String!, $subProductId: String!) {
  getSaleContractSubProductById(saleId: $saleId, subProductId: $subProductId) {
    id
    accountId
    saleId
    unitId
    sellingPrice
    sellingMethod
    paymentPlanId
    unit {
      id
      unitNo
      isBumi
      price
      unitExt {
        paymentPlanId
      }
    }
    projectPaymentPlan {
      id
      accountId
      projectId
      paymentPlanId
      defaulted
      paymentPlan {
        id
        name
        payMethod
        details {
          title
          workProgressId
        }
      }
    }
  }
}
    `;

/**
 * __useGetSaleContractSubProductByIdQuery__
 *
 * To run a query within a React component, call `useGetSaleContractSubProductByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSaleContractSubProductByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSaleContractSubProductByIdQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *      subProductId: // value for 'subProductId'
 *   },
 * });
 */
export function useGetSaleContractSubProductByIdQuery(baseOptions: Apollo.QueryHookOptions<GetSaleContractSubProductByIdQuery, GetSaleContractSubProductByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSaleContractSubProductByIdQuery, GetSaleContractSubProductByIdQueryVariables>(GetSaleContractSubProductByIdDocument, options);
      }
export function useGetSaleContractSubProductByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSaleContractSubProductByIdQuery, GetSaleContractSubProductByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSaleContractSubProductByIdQuery, GetSaleContractSubProductByIdQueryVariables>(GetSaleContractSubProductByIdDocument, options);
        }
export type GetSaleContractSubProductByIdQueryHookResult = ReturnType<typeof useGetSaleContractSubProductByIdQuery>;
export type GetSaleContractSubProductByIdLazyQueryHookResult = ReturnType<typeof useGetSaleContractSubProductByIdLazyQuery>;
export type GetSaleContractSubProductByIdQueryResult = Apollo.QueryResult<GetSaleContractSubProductByIdQuery, GetSaleContractSubProductByIdQueryVariables>;
export const AddSalesContractSubProductDocument = gql`
    mutation addSalesContractSubProduct($input: addSalesContractSubproductInput!, $saleID: String!, $unitID: String!) {
  addSalesContractSubProduct(input: $input, saleID: $saleID, unitID: $unitID)
}
    `;
export type AddSalesContractSubProductMutationFn = Apollo.MutationFunction<AddSalesContractSubProductMutation, AddSalesContractSubProductMutationVariables>;

/**
 * __useAddSalesContractSubProductMutation__
 *
 * To run a mutation, you first call `useAddSalesContractSubProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSalesContractSubProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSalesContractSubProductMutation, { data, loading, error }] = useAddSalesContractSubProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *      saleID: // value for 'saleID'
 *      unitID: // value for 'unitID'
 *   },
 * });
 */
export function useAddSalesContractSubProductMutation(baseOptions?: Apollo.MutationHookOptions<AddSalesContractSubProductMutation, AddSalesContractSubProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSalesContractSubProductMutation, AddSalesContractSubProductMutationVariables>(AddSalesContractSubProductDocument, options);
      }
export type AddSalesContractSubProductMutationHookResult = ReturnType<typeof useAddSalesContractSubProductMutation>;
export type AddSalesContractSubProductMutationResult = Apollo.MutationResult<AddSalesContractSubProductMutation>;
export type AddSalesContractSubProductMutationOptions = Apollo.BaseMutationOptions<AddSalesContractSubProductMutation, AddSalesContractSubProductMutationVariables>;
export const EditSalesContractSubProductDocument = gql`
    mutation editSalesContractSubProduct($input: editSalesContractSubproductInput!, $saleID: String!, $unitID: String!) {
  editSalesContractSubProduct(input: $input, saleID: $saleID, unitID: $unitID)
}
    `;
export type EditSalesContractSubProductMutationFn = Apollo.MutationFunction<EditSalesContractSubProductMutation, EditSalesContractSubProductMutationVariables>;

/**
 * __useEditSalesContractSubProductMutation__
 *
 * To run a mutation, you first call `useEditSalesContractSubProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSalesContractSubProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSalesContractSubProductMutation, { data, loading, error }] = useEditSalesContractSubProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *      saleID: // value for 'saleID'
 *      unitID: // value for 'unitID'
 *   },
 * });
 */
export function useEditSalesContractSubProductMutation(baseOptions?: Apollo.MutationHookOptions<EditSalesContractSubProductMutation, EditSalesContractSubProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditSalesContractSubProductMutation, EditSalesContractSubProductMutationVariables>(EditSalesContractSubProductDocument, options);
      }
export type EditSalesContractSubProductMutationHookResult = ReturnType<typeof useEditSalesContractSubProductMutation>;
export type EditSalesContractSubProductMutationResult = Apollo.MutationResult<EditSalesContractSubProductMutation>;
export type EditSalesContractSubProductMutationOptions = Apollo.BaseMutationOptions<EditSalesContractSubProductMutation, EditSalesContractSubProductMutationVariables>;
export const DeleteSalesContractSubProductDocument = gql`
    mutation deleteSalesContractSubProduct($id: String!, $saleID: String!, $unitID: String!) {
  deleteSalesContractSubProduct(id: $id, saleID: $saleID, unitID: $unitID)
}
    `;
export type DeleteSalesContractSubProductMutationFn = Apollo.MutationFunction<DeleteSalesContractSubProductMutation, DeleteSalesContractSubProductMutationVariables>;

/**
 * __useDeleteSalesContractSubProductMutation__
 *
 * To run a mutation, you first call `useDeleteSalesContractSubProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSalesContractSubProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSalesContractSubProductMutation, { data, loading, error }] = useDeleteSalesContractSubProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *      saleID: // value for 'saleID'
 *      unitID: // value for 'unitID'
 *   },
 * });
 */
export function useDeleteSalesContractSubProductMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSalesContractSubProductMutation, DeleteSalesContractSubProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSalesContractSubProductMutation, DeleteSalesContractSubProductMutationVariables>(DeleteSalesContractSubProductDocument, options);
      }
export type DeleteSalesContractSubProductMutationHookResult = ReturnType<typeof useDeleteSalesContractSubProductMutation>;
export type DeleteSalesContractSubProductMutationResult = Apollo.MutationResult<DeleteSalesContractSubProductMutation>;
export type DeleteSalesContractSubProductMutationOptions = Apollo.BaseMutationOptions<DeleteSalesContractSubProductMutation, DeleteSalesContractSubProductMutationVariables>;
export const GetUnitIsSubProductByProjectIdDocument = gql`
    query getUnitIsSubProductByProjectId {
  getUnitIsSubProductByProjectId {
    id
    unitNo
    isBumi
    price
    unitExt {
      paymentPlanId
    }
  }
}
    `;

/**
 * __useGetUnitIsSubProductByProjectIdQuery__
 *
 * To run a query within a React component, call `useGetUnitIsSubProductByProjectIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitIsSubProductByProjectIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitIsSubProductByProjectIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUnitIsSubProductByProjectIdQuery(baseOptions?: Apollo.QueryHookOptions<GetUnitIsSubProductByProjectIdQuery, GetUnitIsSubProductByProjectIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitIsSubProductByProjectIdQuery, GetUnitIsSubProductByProjectIdQueryVariables>(GetUnitIsSubProductByProjectIdDocument, options);
      }
export function useGetUnitIsSubProductByProjectIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitIsSubProductByProjectIdQuery, GetUnitIsSubProductByProjectIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitIsSubProductByProjectIdQuery, GetUnitIsSubProductByProjectIdQueryVariables>(GetUnitIsSubProductByProjectIdDocument, options);
        }
export type GetUnitIsSubProductByProjectIdQueryHookResult = ReturnType<typeof useGetUnitIsSubProductByProjectIdQuery>;
export type GetUnitIsSubProductByProjectIdLazyQueryHookResult = ReturnType<typeof useGetUnitIsSubProductByProjectIdLazyQuery>;
export type GetUnitIsSubProductByProjectIdQueryResult = Apollo.QueryResult<GetUnitIsSubProductByProjectIdQuery, GetUnitIsSubProductByProjectIdQueryVariables>;
export const GetSellingMethodTypeDocument = gql`
    query getSellingMethodType {
  getSellingMethodType {
    id
    name
  }
}
    `;

/**
 * __useGetSellingMethodTypeQuery__
 *
 * To run a query within a React component, call `useGetSellingMethodTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSellingMethodTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSellingMethodTypeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSellingMethodTypeQuery(baseOptions?: Apollo.QueryHookOptions<GetSellingMethodTypeQuery, GetSellingMethodTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSellingMethodTypeQuery, GetSellingMethodTypeQueryVariables>(GetSellingMethodTypeDocument, options);
      }
export function useGetSellingMethodTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSellingMethodTypeQuery, GetSellingMethodTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSellingMethodTypeQuery, GetSellingMethodTypeQueryVariables>(GetSellingMethodTypeDocument, options);
        }
export type GetSellingMethodTypeQueryHookResult = ReturnType<typeof useGetSellingMethodTypeQuery>;
export type GetSellingMethodTypeLazyQueryHookResult = ReturnType<typeof useGetSellingMethodTypeLazyQuery>;
export type GetSellingMethodTypeQueryResult = Apollo.QueryResult<GetSellingMethodTypeQuery, GetSellingMethodTypeQueryVariables>;
export const GetSalesRegistrationListDocument = gql`
    query getSalesRegistrationList($projectId: String!, $approvalStatus: String!) {
  getSalesRegistrationList(projectId: $projectId, approvalStatus: $approvalStatus) {
    projectId
    saleId
    unitNo
    saleNo
    saleDate
    saleContractPrice
    purchaserName
    jointBuyerCount
    paymentPlanName
    salesRegistrationNo
    finalContractPrice
    saleRegDate
  }
}
    `;

/**
 * __useGetSalesRegistrationListQuery__
 *
 * To run a query within a React component, call `useGetSalesRegistrationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesRegistrationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesRegistrationListQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      approvalStatus: // value for 'approvalStatus'
 *   },
 * });
 */
export function useGetSalesRegistrationListQuery(baseOptions: Apollo.QueryHookOptions<GetSalesRegistrationListQuery, GetSalesRegistrationListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesRegistrationListQuery, GetSalesRegistrationListQueryVariables>(GetSalesRegistrationListDocument, options);
      }
export function useGetSalesRegistrationListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesRegistrationListQuery, GetSalesRegistrationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesRegistrationListQuery, GetSalesRegistrationListQueryVariables>(GetSalesRegistrationListDocument, options);
        }
export type GetSalesRegistrationListQueryHookResult = ReturnType<typeof useGetSalesRegistrationListQuery>;
export type GetSalesRegistrationListLazyQueryHookResult = ReturnType<typeof useGetSalesRegistrationListLazyQuery>;
export type GetSalesRegistrationListQueryResult = Apollo.QueryResult<GetSalesRegistrationListQuery, GetSalesRegistrationListQueryVariables>;
export const GetPendingRegisterUnitsDocument = gql`
    query getPendingRegisterUnits($projectId: String!) {
  getPendingRegisterUnits(projectId: $projectId) {
    saleId
    unitNo
    saleNo
    purchaserName
  }
}
    `;

/**
 * __useGetPendingRegisterUnitsQuery__
 *
 * To run a query within a React component, call `useGetPendingRegisterUnitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingRegisterUnitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingRegisterUnitsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetPendingRegisterUnitsQuery(baseOptions: Apollo.QueryHookOptions<GetPendingRegisterUnitsQuery, GetPendingRegisterUnitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPendingRegisterUnitsQuery, GetPendingRegisterUnitsQueryVariables>(GetPendingRegisterUnitsDocument, options);
      }
export function useGetPendingRegisterUnitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPendingRegisterUnitsQuery, GetPendingRegisterUnitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPendingRegisterUnitsQuery, GetPendingRegisterUnitsQueryVariables>(GetPendingRegisterUnitsDocument, options);
        }
export type GetPendingRegisterUnitsQueryHookResult = ReturnType<typeof useGetPendingRegisterUnitsQuery>;
export type GetPendingRegisterUnitsLazyQueryHookResult = ReturnType<typeof useGetPendingRegisterUnitsLazyQuery>;
export type GetPendingRegisterUnitsQueryResult = Apollo.QueryResult<GetPendingRegisterUnitsQuery, GetPendingRegisterUnitsQueryVariables>;
export const GetUnitBookingDetailsBySaleIdDocument = gql`
    query getUnitBookingDetailsBySaleId($saleId: String!, $projectId: String!) {
  getUnitBookingDetailsBySaleId(projectId: $projectId, saleId: $saleId) {
    saleId
    unitId
    mainBuyer {
      id
      fullName
    }
    jointBuyer {
      id
      contact {
        id
        fullName
      }
    }
    salesPaymentPlan
    bookingFee
    paymentPlan
    salePayment
    saleDate
    registerDate
    saleNo
    saleListPrice
    saleContractPrice
    unitNo
    taxAmt
    unitDetails {
      unitPrice
      landArea
      taxSchemeName
      taxSchemeId
      builtUp
    }
    carPark
    salePackage
    discounts
    paymentPlan
    others
    taxRate
    salesRegistrationNo
    salesConvertedStatus
    address {
      address
      country
      city
      state
      postCode
      AddressType
      isPrimary
    }
    commissionStructure {
      id
      level
      parentId
      employee {
        id
        employeeName
      }
      isDisable
      positionId
      position {
        position
      }
      commonStatus
      companyCommissionTeamId
    }
  }
}
    `;

/**
 * __useGetUnitBookingDetailsBySaleIdQuery__
 *
 * To run a query within a React component, call `useGetUnitBookingDetailsBySaleIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitBookingDetailsBySaleIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitBookingDetailsBySaleIdQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetUnitBookingDetailsBySaleIdQuery(baseOptions: Apollo.QueryHookOptions<GetUnitBookingDetailsBySaleIdQuery, GetUnitBookingDetailsBySaleIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitBookingDetailsBySaleIdQuery, GetUnitBookingDetailsBySaleIdQueryVariables>(GetUnitBookingDetailsBySaleIdDocument, options);
      }
export function useGetUnitBookingDetailsBySaleIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitBookingDetailsBySaleIdQuery, GetUnitBookingDetailsBySaleIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitBookingDetailsBySaleIdQuery, GetUnitBookingDetailsBySaleIdQueryVariables>(GetUnitBookingDetailsBySaleIdDocument, options);
        }
export type GetUnitBookingDetailsBySaleIdQueryHookResult = ReturnType<typeof useGetUnitBookingDetailsBySaleIdQuery>;
export type GetUnitBookingDetailsBySaleIdLazyQueryHookResult = ReturnType<typeof useGetUnitBookingDetailsBySaleIdLazyQuery>;
export type GetUnitBookingDetailsBySaleIdQueryResult = Apollo.QueryResult<GetUnitBookingDetailsBySaleIdQuery, GetUnitBookingDetailsBySaleIdQueryVariables>;
export const GetCarParkPaymentPlanDocument = gql`
    query getCarParkPaymentPlan($projectId: String!) {
  getCarParkPaymentPlan(projectId: $projectId) {
    id
    name
    markUpPercentage
    projectPaymentPlanId
    projectPlanStartDate
    projectPlanEndDate
  }
}
    `;

/**
 * __useGetCarParkPaymentPlanQuery__
 *
 * To run a query within a React component, call `useGetCarParkPaymentPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarParkPaymentPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCarParkPaymentPlanQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetCarParkPaymentPlanQuery(baseOptions: Apollo.QueryHookOptions<GetCarParkPaymentPlanQuery, GetCarParkPaymentPlanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCarParkPaymentPlanQuery, GetCarParkPaymentPlanQueryVariables>(GetCarParkPaymentPlanDocument, options);
      }
export function useGetCarParkPaymentPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCarParkPaymentPlanQuery, GetCarParkPaymentPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCarParkPaymentPlanQuery, GetCarParkPaymentPlanQueryVariables>(GetCarParkPaymentPlanDocument, options);
        }
export type GetCarParkPaymentPlanQueryHookResult = ReturnType<typeof useGetCarParkPaymentPlanQuery>;
export type GetCarParkPaymentPlanLazyQueryHookResult = ReturnType<typeof useGetCarParkPaymentPlanLazyQuery>;
export type GetCarParkPaymentPlanQueryResult = Apollo.QueryResult<GetCarParkPaymentPlanQuery, GetCarParkPaymentPlanQueryVariables>;
export const GetUnitPriceInfoDocument = gql`
    query getUnitPriceInfo($unitId: String!) {
  getUnitInfo(unitId: $unitId) {
    unitId
    unitPrice
    landArea
    taxSchemeId
    taxSchemeName
    landArea
    landAreaRate
    builtUp
    builtUpAreaRate
    commercialPurpose
    propertyType
  }
}
    `;

/**
 * __useGetUnitPriceInfoQuery__
 *
 * To run a query within a React component, call `useGetUnitPriceInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitPriceInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitPriceInfoQuery({
 *   variables: {
 *      unitId: // value for 'unitId'
 *   },
 * });
 */
export function useGetUnitPriceInfoQuery(baseOptions: Apollo.QueryHookOptions<GetUnitPriceInfoQuery, GetUnitPriceInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitPriceInfoQuery, GetUnitPriceInfoQueryVariables>(GetUnitPriceInfoDocument, options);
      }
export function useGetUnitPriceInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitPriceInfoQuery, GetUnitPriceInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitPriceInfoQuery, GetUnitPriceInfoQueryVariables>(GetUnitPriceInfoDocument, options);
        }
export type GetUnitPriceInfoQueryHookResult = ReturnType<typeof useGetUnitPriceInfoQuery>;
export type GetUnitPriceInfoLazyQueryHookResult = ReturnType<typeof useGetUnitPriceInfoLazyQuery>;
export type GetUnitPriceInfoQueryResult = Apollo.QueryResult<GetUnitPriceInfoQuery, GetUnitPriceInfoQueryVariables>;
export const EditUnitTaxSchemeDocument = gql`
    mutation editUnitTaxScheme($unitId: String!, $taxSchemeId: String!, $saleId: String!) {
  editUnitTaxScheme(unitId: $unitId, taxSchemeId: $taxSchemeId, saleId: $saleId)
}
    `;
export type EditUnitTaxSchemeMutationFn = Apollo.MutationFunction<EditUnitTaxSchemeMutation, EditUnitTaxSchemeMutationVariables>;

/**
 * __useEditUnitTaxSchemeMutation__
 *
 * To run a mutation, you first call `useEditUnitTaxSchemeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditUnitTaxSchemeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editUnitTaxSchemeMutation, { data, loading, error }] = useEditUnitTaxSchemeMutation({
 *   variables: {
 *      unitId: // value for 'unitId'
 *      taxSchemeId: // value for 'taxSchemeId'
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useEditUnitTaxSchemeMutation(baseOptions?: Apollo.MutationHookOptions<EditUnitTaxSchemeMutation, EditUnitTaxSchemeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditUnitTaxSchemeMutation, EditUnitTaxSchemeMutationVariables>(EditUnitTaxSchemeDocument, options);
      }
export type EditUnitTaxSchemeMutationHookResult = ReturnType<typeof useEditUnitTaxSchemeMutation>;
export type EditUnitTaxSchemeMutationResult = Apollo.MutationResult<EditUnitTaxSchemeMutation>;
export type EditUnitTaxSchemeMutationOptions = Apollo.BaseMutationOptions<EditUnitTaxSchemeMutation, EditUnitTaxSchemeMutationVariables>;
export const AddCarParkDocument = gql`
    mutation addCarPark($input: AddCarParkInput!) {
  addCarPark(input: $input)
}
    `;
export type AddCarParkMutationFn = Apollo.MutationFunction<AddCarParkMutation, AddCarParkMutationVariables>;

/**
 * __useAddCarParkMutation__
 *
 * To run a mutation, you first call `useAddCarParkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCarParkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCarParkMutation, { data, loading, error }] = useAddCarParkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCarParkMutation(baseOptions?: Apollo.MutationHookOptions<AddCarParkMutation, AddCarParkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCarParkMutation, AddCarParkMutationVariables>(AddCarParkDocument, options);
      }
export type AddCarParkMutationHookResult = ReturnType<typeof useAddCarParkMutation>;
export type AddCarParkMutationResult = Apollo.MutationResult<AddCarParkMutation>;
export type AddCarParkMutationOptions = Apollo.BaseMutationOptions<AddCarParkMutation, AddCarParkMutationVariables>;
export const AddContactPersonDocument = gql`
    mutation addContactPerson($input: saleContactPersonInput!, $saleId: String!) {
  addContactPerson(input: $input, saleId: $saleId)
}
    `;
export type AddContactPersonMutationFn = Apollo.MutationFunction<AddContactPersonMutation, AddContactPersonMutationVariables>;

/**
 * __useAddContactPersonMutation__
 *
 * To run a mutation, you first call `useAddContactPersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddContactPersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addContactPersonMutation, { data, loading, error }] = useAddContactPersonMutation({
 *   variables: {
 *      input: // value for 'input'
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useAddContactPersonMutation(baseOptions?: Apollo.MutationHookOptions<AddContactPersonMutation, AddContactPersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddContactPersonMutation, AddContactPersonMutationVariables>(AddContactPersonDocument, options);
      }
export type AddContactPersonMutationHookResult = ReturnType<typeof useAddContactPersonMutation>;
export type AddContactPersonMutationResult = Apollo.MutationResult<AddContactPersonMutation>;
export type AddContactPersonMutationOptions = Apollo.BaseMutationOptions<AddContactPersonMutation, AddContactPersonMutationVariables>;
export const EditContactPersonDocument = gql`
    mutation editContactPerson($input: editSaleContactPersonInput!, $saleId: String!) {
  editContactPerson(input: $input, saleId: $saleId)
}
    `;
export type EditContactPersonMutationFn = Apollo.MutationFunction<EditContactPersonMutation, EditContactPersonMutationVariables>;

/**
 * __useEditContactPersonMutation__
 *
 * To run a mutation, you first call `useEditContactPersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditContactPersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editContactPersonMutation, { data, loading, error }] = useEditContactPersonMutation({
 *   variables: {
 *      input: // value for 'input'
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useEditContactPersonMutation(baseOptions?: Apollo.MutationHookOptions<EditContactPersonMutation, EditContactPersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditContactPersonMutation, EditContactPersonMutationVariables>(EditContactPersonDocument, options);
      }
export type EditContactPersonMutationHookResult = ReturnType<typeof useEditContactPersonMutation>;
export type EditContactPersonMutationResult = Apollo.MutationResult<EditContactPersonMutation>;
export type EditContactPersonMutationOptions = Apollo.BaseMutationOptions<EditContactPersonMutation, EditContactPersonMutationVariables>;
export const DeleteContactPersonDocument = gql`
    mutation deleteContactPerson($saleContactId: String!) {
  deleteContactPerson(saleContactId: $saleContactId)
}
    `;
export type DeleteContactPersonMutationFn = Apollo.MutationFunction<DeleteContactPersonMutation, DeleteContactPersonMutationVariables>;

/**
 * __useDeleteContactPersonMutation__
 *
 * To run a mutation, you first call `useDeleteContactPersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContactPersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContactPersonMutation, { data, loading, error }] = useDeleteContactPersonMutation({
 *   variables: {
 *      saleContactId: // value for 'saleContactId'
 *   },
 * });
 */
export function useDeleteContactPersonMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContactPersonMutation, DeleteContactPersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContactPersonMutation, DeleteContactPersonMutationVariables>(DeleteContactPersonDocument, options);
      }
export type DeleteContactPersonMutationHookResult = ReturnType<typeof useDeleteContactPersonMutation>;
export type DeleteContactPersonMutationResult = Apollo.MutationResult<DeleteContactPersonMutation>;
export type DeleteContactPersonMutationOptions = Apollo.BaseMutationOptions<DeleteContactPersonMutation, DeleteContactPersonMutationVariables>;
export const AddJointBuyerDocument = gql`
    mutation addJointBuyer($input: Buyer!) {
  addJointBuyer(input: $input)
}
    `;
export type AddJointBuyerMutationFn = Apollo.MutationFunction<AddJointBuyerMutation, AddJointBuyerMutationVariables>;

/**
 * __useAddJointBuyerMutation__
 *
 * To run a mutation, you first call `useAddJointBuyerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddJointBuyerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addJointBuyerMutation, { data, loading, error }] = useAddJointBuyerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddJointBuyerMutation(baseOptions?: Apollo.MutationHookOptions<AddJointBuyerMutation, AddJointBuyerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddJointBuyerMutation, AddJointBuyerMutationVariables>(AddJointBuyerDocument, options);
      }
export type AddJointBuyerMutationHookResult = ReturnType<typeof useAddJointBuyerMutation>;
export type AddJointBuyerMutationResult = Apollo.MutationResult<AddJointBuyerMutation>;
export type AddJointBuyerMutationOptions = Apollo.BaseMutationOptions<AddJointBuyerMutation, AddJointBuyerMutationVariables>;
export const GetCarParkListingDocument = gql`
    query getCarParkListing($saleId: String!) {
  getCarParkListing(saleId: $saleId) {
    carParkId
    carParkNo
    carParkPrice
    paymentAmt
    taxSchemeId
    taxSchemeName
    sellingMethod
    paymentPlanId
    paymentPlanName
    unitId
  }
}
    `;

/**
 * __useGetCarParkListingQuery__
 *
 * To run a query within a React component, call `useGetCarParkListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarParkListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCarParkListingQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetCarParkListingQuery(baseOptions: Apollo.QueryHookOptions<GetCarParkListingQuery, GetCarParkListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCarParkListingQuery, GetCarParkListingQueryVariables>(GetCarParkListingDocument, options);
      }
export function useGetCarParkListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCarParkListingQuery, GetCarParkListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCarParkListingQuery, GetCarParkListingQueryVariables>(GetCarParkListingDocument, options);
        }
export type GetCarParkListingQueryHookResult = ReturnType<typeof useGetCarParkListingQuery>;
export type GetCarParkListingLazyQueryHookResult = ReturnType<typeof useGetCarParkListingLazyQuery>;
export type GetCarParkListingQueryResult = Apollo.QueryResult<GetCarParkListingQuery, GetCarParkListingQueryVariables>;
export const GetCarParkOptionDocument = gql`
    query getCarParkOption($projectId: String!, $saleId: String, $unitId: String, $carParkId: String) {
  getCarParkOption(projectId: $projectId, saleId: $saleId, unitId: $unitId, carParkId: $carParkId) {
    id
    unitNo
    price
  }
}
    `;

/**
 * __useGetCarParkOptionQuery__
 *
 * To run a query within a React component, call `useGetCarParkOptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarParkOptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCarParkOptionQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      saleId: // value for 'saleId'
 *      unitId: // value for 'unitId'
 *      carParkId: // value for 'carParkId'
 *   },
 * });
 */
export function useGetCarParkOptionQuery(baseOptions: Apollo.QueryHookOptions<GetCarParkOptionQuery, GetCarParkOptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCarParkOptionQuery, GetCarParkOptionQueryVariables>(GetCarParkOptionDocument, options);
      }
export function useGetCarParkOptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCarParkOptionQuery, GetCarParkOptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCarParkOptionQuery, GetCarParkOptionQueryVariables>(GetCarParkOptionDocument, options);
        }
export type GetCarParkOptionQueryHookResult = ReturnType<typeof useGetCarParkOptionQuery>;
export type GetCarParkOptionLazyQueryHookResult = ReturnType<typeof useGetCarParkOptionLazyQuery>;
export type GetCarParkOptionQueryResult = Apollo.QueryResult<GetCarParkOptionQuery, GetCarParkOptionQueryVariables>;
export const GetCarParkInfoDocument = gql`
    query getCarParkInfo($saleId: String!, $carParkId: String!) {
  getCarParkInfo(saleId: $saleId, carParkId: $carParkId) {
    carParkId
    carParkNo
    unitId
    carParkPrice
    taxSchemeId
    taxSchemeName
    sellingMethod
    paymentPlanId
    paymentPlanName
    taxRate
    paymentAmt
  }
}
    `;

/**
 * __useGetCarParkInfoQuery__
 *
 * To run a query within a React component, call `useGetCarParkInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarParkInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCarParkInfoQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *      carParkId: // value for 'carParkId'
 *   },
 * });
 */
export function useGetCarParkInfoQuery(baseOptions: Apollo.QueryHookOptions<GetCarParkInfoQuery, GetCarParkInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCarParkInfoQuery, GetCarParkInfoQueryVariables>(GetCarParkInfoDocument, options);
      }
export function useGetCarParkInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCarParkInfoQuery, GetCarParkInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCarParkInfoQuery, GetCarParkInfoQueryVariables>(GetCarParkInfoDocument, options);
        }
export type GetCarParkInfoQueryHookResult = ReturnType<typeof useGetCarParkInfoQuery>;
export type GetCarParkInfoLazyQueryHookResult = ReturnType<typeof useGetCarParkInfoLazyQuery>;
export type GetCarParkInfoQueryResult = Apollo.QueryResult<GetCarParkInfoQuery, GetCarParkInfoQueryVariables>;
export const GetSelectedCarParkPaymentPlanDocument = gql`
    query getSelectedCarParkPaymentPlan($carParkId: String!) {
  getSelectedCarParkPaymentPlan(carParkId: $carParkId) {
    id
    paymentAmt
    carParkId
    billAfter
    billCount
    billAfter
    billFrequency
    billType
    purchaserPaymentPlanDetailsId
    noInstallment
    title
    paymentValue
    installmentDetails {
      documentDate
      documentAmt
      billType
      baseAmt
      taxAmt
      description
    }
  }
}
    `;

/**
 * __useGetSelectedCarParkPaymentPlanQuery__
 *
 * To run a query within a React component, call `useGetSelectedCarParkPaymentPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSelectedCarParkPaymentPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSelectedCarParkPaymentPlanQuery({
 *   variables: {
 *      carParkId: // value for 'carParkId'
 *   },
 * });
 */
export function useGetSelectedCarParkPaymentPlanQuery(baseOptions: Apollo.QueryHookOptions<GetSelectedCarParkPaymentPlanQuery, GetSelectedCarParkPaymentPlanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSelectedCarParkPaymentPlanQuery, GetSelectedCarParkPaymentPlanQueryVariables>(GetSelectedCarParkPaymentPlanDocument, options);
      }
export function useGetSelectedCarParkPaymentPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSelectedCarParkPaymentPlanQuery, GetSelectedCarParkPaymentPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSelectedCarParkPaymentPlanQuery, GetSelectedCarParkPaymentPlanQueryVariables>(GetSelectedCarParkPaymentPlanDocument, options);
        }
export type GetSelectedCarParkPaymentPlanQueryHookResult = ReturnType<typeof useGetSelectedCarParkPaymentPlanQuery>;
export type GetSelectedCarParkPaymentPlanLazyQueryHookResult = ReturnType<typeof useGetSelectedCarParkPaymentPlanLazyQuery>;
export type GetSelectedCarParkPaymentPlanQueryResult = Apollo.QueryResult<GetSelectedCarParkPaymentPlanQuery, GetSelectedCarParkPaymentPlanQueryVariables>;
export const GetInstallmentsByCarParkIdDocument = gql`
    query getInstallmentsByCarParkId($carParkId: String!) {
  getInstallmentsByCarParkId(carParkId: $carParkId) {
    id
    documentAmt
    documentDate
    baseAmt
    taxAmt
    description
    billType
    carparkPaymentId
  }
}
    `;

/**
 * __useGetInstallmentsByCarParkIdQuery__
 *
 * To run a query within a React component, call `useGetInstallmentsByCarParkIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstallmentsByCarParkIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstallmentsByCarParkIdQuery({
 *   variables: {
 *      carParkId: // value for 'carParkId'
 *   },
 * });
 */
export function useGetInstallmentsByCarParkIdQuery(baseOptions: Apollo.QueryHookOptions<GetInstallmentsByCarParkIdQuery, GetInstallmentsByCarParkIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstallmentsByCarParkIdQuery, GetInstallmentsByCarParkIdQueryVariables>(GetInstallmentsByCarParkIdDocument, options);
      }
export function useGetInstallmentsByCarParkIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstallmentsByCarParkIdQuery, GetInstallmentsByCarParkIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstallmentsByCarParkIdQuery, GetInstallmentsByCarParkIdQueryVariables>(GetInstallmentsByCarParkIdDocument, options);
        }
export type GetInstallmentsByCarParkIdQueryHookResult = ReturnType<typeof useGetInstallmentsByCarParkIdQuery>;
export type GetInstallmentsByCarParkIdLazyQueryHookResult = ReturnType<typeof useGetInstallmentsByCarParkIdLazyQuery>;
export type GetInstallmentsByCarParkIdQueryResult = Apollo.QueryResult<GetInstallmentsByCarParkIdQuery, GetInstallmentsByCarParkIdQueryVariables>;
export const CalculateSalesRegDiscountDocument = gql`
    query calculateSalesRegDiscount($input: CalculateSalesRegDiscountInput!) {
  calculateSalesRegDiscount(input: $input)
}
    `;

/**
 * __useCalculateSalesRegDiscountQuery__
 *
 * To run a query within a React component, call `useCalculateSalesRegDiscountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalculateSalesRegDiscountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalculateSalesRegDiscountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCalculateSalesRegDiscountQuery(baseOptions: Apollo.QueryHookOptions<CalculateSalesRegDiscountQuery, CalculateSalesRegDiscountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalculateSalesRegDiscountQuery, CalculateSalesRegDiscountQueryVariables>(CalculateSalesRegDiscountDocument, options);
      }
export function useCalculateSalesRegDiscountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalculateSalesRegDiscountQuery, CalculateSalesRegDiscountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalculateSalesRegDiscountQuery, CalculateSalesRegDiscountQueryVariables>(CalculateSalesRegDiscountDocument, options);
        }
export type CalculateSalesRegDiscountQueryHookResult = ReturnType<typeof useCalculateSalesRegDiscountQuery>;
export type CalculateSalesRegDiscountLazyQueryHookResult = ReturnType<typeof useCalculateSalesRegDiscountLazyQuery>;
export type CalculateSalesRegDiscountQueryResult = Apollo.QueryResult<CalculateSalesRegDiscountQuery, CalculateSalesRegDiscountQueryVariables>;
export const GetJointBuyerDocument = gql`
    query getJointBuyer($contactId: String!) {
  getJointBuyer(contactId: $contactId) {
    id
    fullName
    email
    phoneNo
    gender
    icNo
    militaryIc
    homeTel
    officeTel
    dob
    companyName
    companyRegNo
    incomeRange {
      id
      range
    }
    salutation {
      name
      id
    }
    nationality {
      name
      id
    }
    race {
      name
      id
    }
    maritalStatus {
      name
      id
    }
    contactExt {
      id
      identityType
      customerOrigin
      isVip
      isForeignPurchase
      subscribeMaterialSms
      subscribeMaterialWhatsapp
      subscribeMaterialEmail
      subscribeMaterialPaNews
      mailingMethod
      professionId
      religionId
      nameOnTax
      taxRegistrationNo
      taxRegistrationAddress
      isPrincipalBuyer
      remark
    }
    contactAddress {
      address
      country
      city
      state
      postCode
      AddressType
    }
  }
  getAttachment(contactId: $contactId) {
    id
    fileName
    bucketFileName
    resourceUrl
  }
}
    `;

/**
 * __useGetJointBuyerQuery__
 *
 * To run a query within a React component, call `useGetJointBuyerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJointBuyerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJointBuyerQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useGetJointBuyerQuery(baseOptions: Apollo.QueryHookOptions<GetJointBuyerQuery, GetJointBuyerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJointBuyerQuery, GetJointBuyerQueryVariables>(GetJointBuyerDocument, options);
      }
export function useGetJointBuyerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJointBuyerQuery, GetJointBuyerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJointBuyerQuery, GetJointBuyerQueryVariables>(GetJointBuyerDocument, options);
        }
export type GetJointBuyerQueryHookResult = ReturnType<typeof useGetJointBuyerQuery>;
export type GetJointBuyerLazyQueryHookResult = ReturnType<typeof useGetJointBuyerLazyQuery>;
export type GetJointBuyerQueryResult = Apollo.QueryResult<GetJointBuyerQuery, GetJointBuyerQueryVariables>;
export const EditJointBuyerDocument = gql`
    mutation editJointBuyer($input: Buyer!) {
  editJointBuyer(input: $input)
}
    `;
export type EditJointBuyerMutationFn = Apollo.MutationFunction<EditJointBuyerMutation, EditJointBuyerMutationVariables>;

/**
 * __useEditJointBuyerMutation__
 *
 * To run a mutation, you first call `useEditJointBuyerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditJointBuyerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editJointBuyerMutation, { data, loading, error }] = useEditJointBuyerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditJointBuyerMutation(baseOptions?: Apollo.MutationHookOptions<EditJointBuyerMutation, EditJointBuyerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditJointBuyerMutation, EditJointBuyerMutationVariables>(EditJointBuyerDocument, options);
      }
export type EditJointBuyerMutationHookResult = ReturnType<typeof useEditJointBuyerMutation>;
export type EditJointBuyerMutationResult = Apollo.MutationResult<EditJointBuyerMutation>;
export type EditJointBuyerMutationOptions = Apollo.BaseMutationOptions<EditJointBuyerMutation, EditJointBuyerMutationVariables>;
export const GetPaymentPlanDetailsDocument = gql`
    query getPaymentPlanDetails($saleId: String!, $paymentPlanId: String!, $finalContractPrice: Float, $InstallmentSummaryInput: [InstallmentSummaryInput!], $paymentMarkUpAmt: Float, $taxSchemeId: String, $isCarparkOrPackage: Boolean, $regDate: DateTime) {
  getPaymentPlanDetails(saleId: $saleId, paymentPlanId: $paymentPlanId, finalContractPrice: $finalContractPrice, InstallmentSummaryInput: $InstallmentSummaryInput, paymentMarkUpAmt: $paymentMarkUpAmt, taxSchemeId: $taxSchemeId, isCarparkOrPackage: $isCarparkOrPackage, regDate: $regDate) {
    paymentPlanId
    markUpPercentage
    markUpPrice
    installmentSummary {
      paymentPlanDetailsId
      paymentPlanName
      billType
      billAfter
      billFreq
      billCount
      markUpPercentage
      installmentCount
      totalPayableAmt
      isFixAmt
      deductBookingFee
      installmentDetails {
        billType
        installementDate
        baseAmt
        taxAmt
        payableAmt
        seqNo
        description
      }
    }
    paymentPlanDate
    discAmt
  }
}
    `;

/**
 * __useGetPaymentPlanDetailsQuery__
 *
 * To run a query within a React component, call `useGetPaymentPlanDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentPlanDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentPlanDetailsQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *      paymentPlanId: // value for 'paymentPlanId'
 *      finalContractPrice: // value for 'finalContractPrice'
 *      InstallmentSummaryInput: // value for 'InstallmentSummaryInput'
 *      paymentMarkUpAmt: // value for 'paymentMarkUpAmt'
 *      taxSchemeId: // value for 'taxSchemeId'
 *      isCarparkOrPackage: // value for 'isCarparkOrPackage'
 *      regDate: // value for 'regDate'
 *   },
 * });
 */
export function useGetPaymentPlanDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentPlanDetailsQuery, GetPaymentPlanDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentPlanDetailsQuery, GetPaymentPlanDetailsQueryVariables>(GetPaymentPlanDetailsDocument, options);
      }
export function useGetPaymentPlanDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentPlanDetailsQuery, GetPaymentPlanDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentPlanDetailsQuery, GetPaymentPlanDetailsQueryVariables>(GetPaymentPlanDetailsDocument, options);
        }
export type GetPaymentPlanDetailsQueryHookResult = ReturnType<typeof useGetPaymentPlanDetailsQuery>;
export type GetPaymentPlanDetailsLazyQueryHookResult = ReturnType<typeof useGetPaymentPlanDetailsLazyQuery>;
export type GetPaymentPlanDetailsQueryResult = Apollo.QueryResult<GetPaymentPlanDetailsQuery, GetPaymentPlanDetailsQueryVariables>;
export const GetPurchaserInfoDocument = gql`
    query getPurchaserInfo($contactId: String!) {
  getPurchaserInfo(contactId: $contactId) {
    id
    fullName
    email
    phoneNo
    gender
    icNo
    militaryIc
    homeTel
    officeTel
    companyName
    companyRegNo
    salutation {
      name
      id
    }
    nationality {
      name
      id
    }
    race {
      name
      id
    }
    maritalStatus {
      name
      id
    }
    dob
    incomeRange {
      range
      id
    }
    contactExt {
      id
      identityType
      customerOrigin
      isVip
      isForeignPurchase
      subscribeMaterialSms
      subscribeMaterialWhatsapp
      subscribeMaterialEmail
      subscribeMaterialPaNews
      mailingMethod
      professionId
      religionId
      nameOnTax
      taxRegistrationNo
      taxRegistrationAddress
      isPrincipalBuyer
      remark
    }
    contactAddress {
      address
      country
      city
      state
      postCode
      AddressType
      isPrimary
    }
    address {
      address
      country
      city
      state
      postCode
      AddressType
      isPrimary
    }
  }
  getAttachment(contactId: $contactId) {
    id
    fileName
    bucketFileName
    resourceUrl
  }
}
    `;

/**
 * __useGetPurchaserInfoQuery__
 *
 * To run a query within a React component, call `useGetPurchaserInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPurchaserInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPurchaserInfoQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useGetPurchaserInfoQuery(baseOptions: Apollo.QueryHookOptions<GetPurchaserInfoQuery, GetPurchaserInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPurchaserInfoQuery, GetPurchaserInfoQueryVariables>(GetPurchaserInfoDocument, options);
      }
export function useGetPurchaserInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPurchaserInfoQuery, GetPurchaserInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPurchaserInfoQuery, GetPurchaserInfoQueryVariables>(GetPurchaserInfoDocument, options);
        }
export type GetPurchaserInfoQueryHookResult = ReturnType<typeof useGetPurchaserInfoQuery>;
export type GetPurchaserInfoLazyQueryHookResult = ReturnType<typeof useGetPurchaserInfoLazyQuery>;
export type GetPurchaserInfoQueryResult = Apollo.QueryResult<GetPurchaserInfoQuery, GetPurchaserInfoQueryVariables>;
export const DeleteMainPurchaserDocument = gql`
    mutation deleteMainPurchaser($saleId: String!) {
  deleteMainPurchaser(saleId: $saleId)
}
    `;
export type DeleteMainPurchaserMutationFn = Apollo.MutationFunction<DeleteMainPurchaserMutation, DeleteMainPurchaserMutationVariables>;

/**
 * __useDeleteMainPurchaserMutation__
 *
 * To run a mutation, you first call `useDeleteMainPurchaserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMainPurchaserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMainPurchaserMutation, { data, loading, error }] = useDeleteMainPurchaserMutation({
 *   variables: {
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useDeleteMainPurchaserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMainPurchaserMutation, DeleteMainPurchaserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMainPurchaserMutation, DeleteMainPurchaserMutationVariables>(DeleteMainPurchaserDocument, options);
      }
export type DeleteMainPurchaserMutationHookResult = ReturnType<typeof useDeleteMainPurchaserMutation>;
export type DeleteMainPurchaserMutationResult = Apollo.MutationResult<DeleteMainPurchaserMutation>;
export type DeleteMainPurchaserMutationOptions = Apollo.BaseMutationOptions<DeleteMainPurchaserMutation, DeleteMainPurchaserMutationVariables>;
export const EditPurchaserInfoDocument = gql`
    mutation editPurchaserInfo($input: Buyer!) {
  editPurchaserInfo(input: $input)
}
    `;
export type EditPurchaserInfoMutationFn = Apollo.MutationFunction<EditPurchaserInfoMutation, EditPurchaserInfoMutationVariables>;

/**
 * __useEditPurchaserInfoMutation__
 *
 * To run a mutation, you first call `useEditPurchaserInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPurchaserInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPurchaserInfoMutation, { data, loading, error }] = useEditPurchaserInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditPurchaserInfoMutation(baseOptions?: Apollo.MutationHookOptions<EditPurchaserInfoMutation, EditPurchaserInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditPurchaserInfoMutation, EditPurchaserInfoMutationVariables>(EditPurchaserInfoDocument, options);
      }
export type EditPurchaserInfoMutationHookResult = ReturnType<typeof useEditPurchaserInfoMutation>;
export type EditPurchaserInfoMutationResult = Apollo.MutationResult<EditPurchaserInfoMutation>;
export type EditPurchaserInfoMutationOptions = Apollo.BaseMutationOptions<EditPurchaserInfoMutation, EditPurchaserInfoMutationVariables>;
export const GetPackageListingDocument = gql`
    query getPackageListing($saleId: String!) {
  getPackageListing(saleId: $saleId) {
    id
    packageName
    packageId
    itemCount
    openMarketValue
    sellingPrice
    sellingMethod
    taxSchemeId
    taxSchemeName
    paymentPlanId
  }
}
    `;

/**
 * __useGetPackageListingQuery__
 *
 * To run a query within a React component, call `useGetPackageListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPackageListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPackageListingQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetPackageListingQuery(baseOptions: Apollo.QueryHookOptions<GetPackageListingQuery, GetPackageListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPackageListingQuery, GetPackageListingQueryVariables>(GetPackageListingDocument, options);
      }
export function useGetPackageListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPackageListingQuery, GetPackageListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPackageListingQuery, GetPackageListingQueryVariables>(GetPackageListingDocument, options);
        }
export type GetPackageListingQueryHookResult = ReturnType<typeof useGetPackageListingQuery>;
export type GetPackageListingLazyQueryHookResult = ReturnType<typeof useGetPackageListingLazyQuery>;
export type GetPackageListingQueryResult = Apollo.QueryResult<GetPackageListingQuery, GetPackageListingQueryVariables>;
export const GetPackageOptionDocument = gql`
    query getPackageOption($projectId: String!) {
  getPackageOption(projectId: $projectId) {
    id
    name
    items {
      costPrice
      promoPrice
      description
      promotionalItem {
        name
      }
    }
  }
}
    `;

/**
 * __useGetPackageOptionQuery__
 *
 * To run a query within a React component, call `useGetPackageOptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPackageOptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPackageOptionQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetPackageOptionQuery(baseOptions: Apollo.QueryHookOptions<GetPackageOptionQuery, GetPackageOptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPackageOptionQuery, GetPackageOptionQueryVariables>(GetPackageOptionDocument, options);
      }
export function useGetPackageOptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPackageOptionQuery, GetPackageOptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPackageOptionQuery, GetPackageOptionQueryVariables>(GetPackageOptionDocument, options);
        }
export type GetPackageOptionQueryHookResult = ReturnType<typeof useGetPackageOptionQuery>;
export type GetPackageOptionLazyQueryHookResult = ReturnType<typeof useGetPackageOptionLazyQuery>;
export type GetPackageOptionQueryResult = Apollo.QueryResult<GetPackageOptionQuery, GetPackageOptionQueryVariables>;
export const GetPackageInfoDocument = gql`
    query getPackageInfo($packageId: String!) {
  getPackageInfo(packageId: $packageId) {
    id
    sellingMethod
    taxSchemeId
    paymentPlanId
    promotionalPackage {
      id
      name
      items {
        costPrice
        promoPrice
        description
        promotionalItem {
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetPackageInfoQuery__
 *
 * To run a query within a React component, call `useGetPackageInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPackageInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPackageInfoQuery({
 *   variables: {
 *      packageId: // value for 'packageId'
 *   },
 * });
 */
export function useGetPackageInfoQuery(baseOptions: Apollo.QueryHookOptions<GetPackageInfoQuery, GetPackageInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPackageInfoQuery, GetPackageInfoQueryVariables>(GetPackageInfoDocument, options);
      }
export function useGetPackageInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPackageInfoQuery, GetPackageInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPackageInfoQuery, GetPackageInfoQueryVariables>(GetPackageInfoDocument, options);
        }
export type GetPackageInfoQueryHookResult = ReturnType<typeof useGetPackageInfoQuery>;
export type GetPackageInfoLazyQueryHookResult = ReturnType<typeof useGetPackageInfoLazyQuery>;
export type GetPackageInfoQueryResult = Apollo.QueryResult<GetPackageInfoQuery, GetPackageInfoQueryVariables>;
export const GetSelectedPackagePaymentPlanDocument = gql`
    query getSelectedPackagePaymentPlan($packageId: String!) {
  getSelectedPackagePaymentPlan(packageId: $packageId) {
    id
    salePackageId
    paymentAmt
    paymentValue
    purchaserPaymentPlanDetailsId
    billType
    billCount
    billFrequency
    billAfter
    noInstallment
    title
  }
}
    `;

/**
 * __useGetSelectedPackagePaymentPlanQuery__
 *
 * To run a query within a React component, call `useGetSelectedPackagePaymentPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSelectedPackagePaymentPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSelectedPackagePaymentPlanQuery({
 *   variables: {
 *      packageId: // value for 'packageId'
 *   },
 * });
 */
export function useGetSelectedPackagePaymentPlanQuery(baseOptions: Apollo.QueryHookOptions<GetSelectedPackagePaymentPlanQuery, GetSelectedPackagePaymentPlanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSelectedPackagePaymentPlanQuery, GetSelectedPackagePaymentPlanQueryVariables>(GetSelectedPackagePaymentPlanDocument, options);
      }
export function useGetSelectedPackagePaymentPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSelectedPackagePaymentPlanQuery, GetSelectedPackagePaymentPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSelectedPackagePaymentPlanQuery, GetSelectedPackagePaymentPlanQueryVariables>(GetSelectedPackagePaymentPlanDocument, options);
        }
export type GetSelectedPackagePaymentPlanQueryHookResult = ReturnType<typeof useGetSelectedPackagePaymentPlanQuery>;
export type GetSelectedPackagePaymentPlanLazyQueryHookResult = ReturnType<typeof useGetSelectedPackagePaymentPlanLazyQuery>;
export type GetSelectedPackagePaymentPlanQueryResult = Apollo.QueryResult<GetSelectedPackagePaymentPlanQuery, GetSelectedPackagePaymentPlanQueryVariables>;
export const GetInstallmentsByPackageIdDocument = gql`
    query getInstallmentsByPackageId($packageId: String!) {
  getInstallmentsByPackageId(packageId: $packageId) {
    id
    description
    documentNo
    documentDate
    documentAmt
    baseAmt
    taxAmt
    description
    billType
    packagesPaymentId
  }
}
    `;

/**
 * __useGetInstallmentsByPackageIdQuery__
 *
 * To run a query within a React component, call `useGetInstallmentsByPackageIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstallmentsByPackageIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstallmentsByPackageIdQuery({
 *   variables: {
 *      packageId: // value for 'packageId'
 *   },
 * });
 */
export function useGetInstallmentsByPackageIdQuery(baseOptions: Apollo.QueryHookOptions<GetInstallmentsByPackageIdQuery, GetInstallmentsByPackageIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstallmentsByPackageIdQuery, GetInstallmentsByPackageIdQueryVariables>(GetInstallmentsByPackageIdDocument, options);
      }
export function useGetInstallmentsByPackageIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstallmentsByPackageIdQuery, GetInstallmentsByPackageIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstallmentsByPackageIdQuery, GetInstallmentsByPackageIdQueryVariables>(GetInstallmentsByPackageIdDocument, options);
        }
export type GetInstallmentsByPackageIdQueryHookResult = ReturnType<typeof useGetInstallmentsByPackageIdQuery>;
export type GetInstallmentsByPackageIdLazyQueryHookResult = ReturnType<typeof useGetInstallmentsByPackageIdLazyQuery>;
export type GetInstallmentsByPackageIdQueryResult = Apollo.QueryResult<GetInstallmentsByPackageIdQuery, GetInstallmentsByPackageIdQueryVariables>;
export const AddPackageIntoSaleDocument = gql`
    mutation addPackageIntoSale($input: addPackageInput!) {
  addPackageIntoSale(input: $input)
}
    `;
export type AddPackageIntoSaleMutationFn = Apollo.MutationFunction<AddPackageIntoSaleMutation, AddPackageIntoSaleMutationVariables>;

/**
 * __useAddPackageIntoSaleMutation__
 *
 * To run a mutation, you first call `useAddPackageIntoSaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPackageIntoSaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPackageIntoSaleMutation, { data, loading, error }] = useAddPackageIntoSaleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPackageIntoSaleMutation(baseOptions?: Apollo.MutationHookOptions<AddPackageIntoSaleMutation, AddPackageIntoSaleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPackageIntoSaleMutation, AddPackageIntoSaleMutationVariables>(AddPackageIntoSaleDocument, options);
      }
export type AddPackageIntoSaleMutationHookResult = ReturnType<typeof useAddPackageIntoSaleMutation>;
export type AddPackageIntoSaleMutationResult = Apollo.MutationResult<AddPackageIntoSaleMutation>;
export type AddPackageIntoSaleMutationOptions = Apollo.BaseMutationOptions<AddPackageIntoSaleMutation, AddPackageIntoSaleMutationVariables>;
export const SubmitSaleIntoRegistrationDocument = gql`
    mutation submitSaleIntoRegistration($input: salesRegistrationInput!) {
  addSaleIntoRegistration(input: $input)
}
    `;
export type SubmitSaleIntoRegistrationMutationFn = Apollo.MutationFunction<SubmitSaleIntoRegistrationMutation, SubmitSaleIntoRegistrationMutationVariables>;

/**
 * __useSubmitSaleIntoRegistrationMutation__
 *
 * To run a mutation, you first call `useSubmitSaleIntoRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitSaleIntoRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitSaleIntoRegistrationMutation, { data, loading, error }] = useSubmitSaleIntoRegistrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitSaleIntoRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<SubmitSaleIntoRegistrationMutation, SubmitSaleIntoRegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitSaleIntoRegistrationMutation, SubmitSaleIntoRegistrationMutationVariables>(SubmitSaleIntoRegistrationDocument, options);
      }
export type SubmitSaleIntoRegistrationMutationHookResult = ReturnType<typeof useSubmitSaleIntoRegistrationMutation>;
export type SubmitSaleIntoRegistrationMutationResult = Apollo.MutationResult<SubmitSaleIntoRegistrationMutation>;
export type SubmitSaleIntoRegistrationMutationOptions = Apollo.BaseMutationOptions<SubmitSaleIntoRegistrationMutation, SubmitSaleIntoRegistrationMutationVariables>;
export const ChangeSubmittedSaleStatusDocument = gql`
    mutation changeSubmittedSaleStatus($saleId: String!, $status: String!) {
  changeSubmittedSaleStatus(saleId: $saleId, status: $status)
}
    `;
export type ChangeSubmittedSaleStatusMutationFn = Apollo.MutationFunction<ChangeSubmittedSaleStatusMutation, ChangeSubmittedSaleStatusMutationVariables>;

/**
 * __useChangeSubmittedSaleStatusMutation__
 *
 * To run a mutation, you first call `useChangeSubmittedSaleStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeSubmittedSaleStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeSubmittedSaleStatusMutation, { data, loading, error }] = useChangeSubmittedSaleStatusMutation({
 *   variables: {
 *      saleId: // value for 'saleId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useChangeSubmittedSaleStatusMutation(baseOptions?: Apollo.MutationHookOptions<ChangeSubmittedSaleStatusMutation, ChangeSubmittedSaleStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeSubmittedSaleStatusMutation, ChangeSubmittedSaleStatusMutationVariables>(ChangeSubmittedSaleStatusDocument, options);
      }
export type ChangeSubmittedSaleStatusMutationHookResult = ReturnType<typeof useChangeSubmittedSaleStatusMutation>;
export type ChangeSubmittedSaleStatusMutationResult = Apollo.MutationResult<ChangeSubmittedSaleStatusMutation>;
export type ChangeSubmittedSaleStatusMutationOptions = Apollo.BaseMutationOptions<ChangeSubmittedSaleStatusMutation, ChangeSubmittedSaleStatusMutationVariables>;
export const GetSalesRegistrationMasterDataDocument = gql`
    query getSalesRegistrationMasterData {
  GetAllMasterInfo {
    LeadSources {
      id
      name
    }
    Events {
      id
      campaignId
      name
      startDate
      endDate
    }
    CommercialPurposes
  }
  getSalesRegistrationsMasterData
}
    `;

/**
 * __useGetSalesRegistrationMasterDataQuery__
 *
 * To run a query within a React component, call `useGetSalesRegistrationMasterDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesRegistrationMasterDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesRegistrationMasterDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSalesRegistrationMasterDataQuery(baseOptions?: Apollo.QueryHookOptions<GetSalesRegistrationMasterDataQuery, GetSalesRegistrationMasterDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesRegistrationMasterDataQuery, GetSalesRegistrationMasterDataQueryVariables>(GetSalesRegistrationMasterDataDocument, options);
      }
export function useGetSalesRegistrationMasterDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesRegistrationMasterDataQuery, GetSalesRegistrationMasterDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesRegistrationMasterDataQuery, GetSalesRegistrationMasterDataQueryVariables>(GetSalesRegistrationMasterDataDocument, options);
        }
export type GetSalesRegistrationMasterDataQueryHookResult = ReturnType<typeof useGetSalesRegistrationMasterDataQuery>;
export type GetSalesRegistrationMasterDataLazyQueryHookResult = ReturnType<typeof useGetSalesRegistrationMasterDataLazyQuery>;
export type GetSalesRegistrationMasterDataQueryResult = Apollo.QueryResult<GetSalesRegistrationMasterDataQuery, GetSalesRegistrationMasterDataQueryVariables>;
export const GetContactPersonByIdDocument = gql`
    query getContactPersonById($contactPersonId: String!) {
  getContactPersonById(contactPersonId: $contactPersonId) {
    id
    name
    contactNo
    officeTel
    email
    remark
    salutationId
    isPrimary
    relationshipId
  }
}
    `;

/**
 * __useGetContactPersonByIdQuery__
 *
 * To run a query within a React component, call `useGetContactPersonByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactPersonByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactPersonByIdQuery({
 *   variables: {
 *      contactPersonId: // value for 'contactPersonId'
 *   },
 * });
 */
export function useGetContactPersonByIdQuery(baseOptions: Apollo.QueryHookOptions<GetContactPersonByIdQuery, GetContactPersonByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactPersonByIdQuery, GetContactPersonByIdQueryVariables>(GetContactPersonByIdDocument, options);
      }
export function useGetContactPersonByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactPersonByIdQuery, GetContactPersonByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactPersonByIdQuery, GetContactPersonByIdQueryVariables>(GetContactPersonByIdDocument, options);
        }
export type GetContactPersonByIdQueryHookResult = ReturnType<typeof useGetContactPersonByIdQuery>;
export type GetContactPersonByIdLazyQueryHookResult = ReturnType<typeof useGetContactPersonByIdLazyQuery>;
export type GetContactPersonByIdQueryResult = Apollo.QueryResult<GetContactPersonByIdQuery, GetContactPersonByIdQueryVariables>;
export const GetSalesRegistrationCountDocument = gql`
    query getSalesRegistrationCount($projectId: String!) {
  getSalesRegistrationCount(projectId: $projectId) {
    draftCount
    submittedCount
    approvedCount
    rejectedCount
  }
}
    `;

/**
 * __useGetSalesRegistrationCountQuery__
 *
 * To run a query within a React component, call `useGetSalesRegistrationCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesRegistrationCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesRegistrationCountQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetSalesRegistrationCountQuery(baseOptions: Apollo.QueryHookOptions<GetSalesRegistrationCountQuery, GetSalesRegistrationCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesRegistrationCountQuery, GetSalesRegistrationCountQueryVariables>(GetSalesRegistrationCountDocument, options);
      }
export function useGetSalesRegistrationCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesRegistrationCountQuery, GetSalesRegistrationCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesRegistrationCountQuery, GetSalesRegistrationCountQueryVariables>(GetSalesRegistrationCountDocument, options);
        }
export type GetSalesRegistrationCountQueryHookResult = ReturnType<typeof useGetSalesRegistrationCountQuery>;
export type GetSalesRegistrationCountLazyQueryHookResult = ReturnType<typeof useGetSalesRegistrationCountLazyQuery>;
export type GetSalesRegistrationCountQueryResult = Apollo.QueryResult<GetSalesRegistrationCountQuery, GetSalesRegistrationCountQueryVariables>;
export const DeleteCarParkDocument = gql`
    mutation deleteCarPark($carParkId: String!) {
  deleteCarPark(carParkId: $carParkId)
}
    `;
export type DeleteCarParkMutationFn = Apollo.MutationFunction<DeleteCarParkMutation, DeleteCarParkMutationVariables>;

/**
 * __useDeleteCarParkMutation__
 *
 * To run a mutation, you first call `useDeleteCarParkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCarParkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCarParkMutation, { data, loading, error }] = useDeleteCarParkMutation({
 *   variables: {
 *      carParkId: // value for 'carParkId'
 *   },
 * });
 */
export function useDeleteCarParkMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCarParkMutation, DeleteCarParkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCarParkMutation, DeleteCarParkMutationVariables>(DeleteCarParkDocument, options);
      }
export type DeleteCarParkMutationHookResult = ReturnType<typeof useDeleteCarParkMutation>;
export type DeleteCarParkMutationResult = Apollo.MutationResult<DeleteCarParkMutation>;
export type DeleteCarParkMutationOptions = Apollo.BaseMutationOptions<DeleteCarParkMutation, DeleteCarParkMutationVariables>;
export const EditCarParkDocument = gql`
    mutation editCarPark($input: editCarParkInput!) {
  editCarPark(input: $input)
}
    `;
export type EditCarParkMutationFn = Apollo.MutationFunction<EditCarParkMutation, EditCarParkMutationVariables>;

/**
 * __useEditCarParkMutation__
 *
 * To run a mutation, you first call `useEditCarParkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCarParkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCarParkMutation, { data, loading, error }] = useEditCarParkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditCarParkMutation(baseOptions?: Apollo.MutationHookOptions<EditCarParkMutation, EditCarParkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCarParkMutation, EditCarParkMutationVariables>(EditCarParkDocument, options);
      }
export type EditCarParkMutationHookResult = ReturnType<typeof useEditCarParkMutation>;
export type EditCarParkMutationResult = Apollo.MutationResult<EditCarParkMutation>;
export type EditCarParkMutationOptions = Apollo.BaseMutationOptions<EditCarParkMutation, EditCarParkMutationVariables>;
export const DeletePackageDocument = gql`
    mutation deletePackage($packageId: String!) {
  deletePackage(packageId: $packageId)
}
    `;
export type DeletePackageMutationFn = Apollo.MutationFunction<DeletePackageMutation, DeletePackageMutationVariables>;

/**
 * __useDeletePackageMutation__
 *
 * To run a mutation, you first call `useDeletePackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePackageMutation, { data, loading, error }] = useDeletePackageMutation({
 *   variables: {
 *      packageId: // value for 'packageId'
 *   },
 * });
 */
export function useDeletePackageMutation(baseOptions?: Apollo.MutationHookOptions<DeletePackageMutation, DeletePackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePackageMutation, DeletePackageMutationVariables>(DeletePackageDocument, options);
      }
export type DeletePackageMutationHookResult = ReturnType<typeof useDeletePackageMutation>;
export type DeletePackageMutationResult = Apollo.MutationResult<DeletePackageMutation>;
export type DeletePackageMutationOptions = Apollo.BaseMutationOptions<DeletePackageMutation, DeletePackageMutationVariables>;
export const EditPackageSaleRegistrationDocument = gql`
    mutation editPackageSaleRegistration($input: editPackageInput!) {
  editPackageSaleRegistration(input: $input)
}
    `;
export type EditPackageSaleRegistrationMutationFn = Apollo.MutationFunction<EditPackageSaleRegistrationMutation, EditPackageSaleRegistrationMutationVariables>;

/**
 * __useEditPackageSaleRegistrationMutation__
 *
 * To run a mutation, you first call `useEditPackageSaleRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPackageSaleRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPackageSaleRegistrationMutation, { data, loading, error }] = useEditPackageSaleRegistrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditPackageSaleRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<EditPackageSaleRegistrationMutation, EditPackageSaleRegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditPackageSaleRegistrationMutation, EditPackageSaleRegistrationMutationVariables>(EditPackageSaleRegistrationDocument, options);
      }
export type EditPackageSaleRegistrationMutationHookResult = ReturnType<typeof useEditPackageSaleRegistrationMutation>;
export type EditPackageSaleRegistrationMutationResult = Apollo.MutationResult<EditPackageSaleRegistrationMutation>;
export type EditPackageSaleRegistrationMutationOptions = Apollo.BaseMutationOptions<EditPackageSaleRegistrationMutation, EditPackageSaleRegistrationMutationVariables>;
export const DiscardPendingDataDocument = gql`
    mutation discardPendingData($input: DiscardPendingDataInput!) {
  discardPendingData(input: $input)
}
    `;
export type DiscardPendingDataMutationFn = Apollo.MutationFunction<DiscardPendingDataMutation, DiscardPendingDataMutationVariables>;

/**
 * __useDiscardPendingDataMutation__
 *
 * To run a mutation, you first call `useDiscardPendingDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDiscardPendingDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [discardPendingDataMutation, { data, loading, error }] = useDiscardPendingDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDiscardPendingDataMutation(baseOptions?: Apollo.MutationHookOptions<DiscardPendingDataMutation, DiscardPendingDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DiscardPendingDataMutation, DiscardPendingDataMutationVariables>(DiscardPendingDataDocument, options);
      }
export type DiscardPendingDataMutationHookResult = ReturnType<typeof useDiscardPendingDataMutation>;
export type DiscardPendingDataMutationResult = Apollo.MutationResult<DiscardPendingDataMutation>;
export type DiscardPendingDataMutationOptions = Apollo.BaseMutationOptions<DiscardPendingDataMutation, DiscardPendingDataMutationVariables>;
export const GetSalesDiscountListingDocument = gql`
    query getSalesDiscountListing($saleId: String!) {
  getSalesDiscountListing(saleId: $saleId) {
    id
    title
    description
    amount
    discountId
  }
}
    `;

/**
 * __useGetSalesDiscountListingQuery__
 *
 * To run a query within a React component, call `useGetSalesDiscountListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesDiscountListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesDiscountListingQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetSalesDiscountListingQuery(baseOptions: Apollo.QueryHookOptions<GetSalesDiscountListingQuery, GetSalesDiscountListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesDiscountListingQuery, GetSalesDiscountListingQueryVariables>(GetSalesDiscountListingDocument, options);
      }
export function useGetSalesDiscountListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesDiscountListingQuery, GetSalesDiscountListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesDiscountListingQuery, GetSalesDiscountListingQueryVariables>(GetSalesDiscountListingDocument, options);
        }
export type GetSalesDiscountListingQueryHookResult = ReturnType<typeof useGetSalesDiscountListingQuery>;
export type GetSalesDiscountListingLazyQueryHookResult = ReturnType<typeof useGetSalesDiscountListingLazyQuery>;
export type GetSalesDiscountListingQueryResult = Apollo.QueryResult<GetSalesDiscountListingQuery, GetSalesDiscountListingQueryVariables>;
export const GetSalesRegistrationDiscountByIdDocument = gql`
    query getSalesRegistrationDiscountById($id: String!) {
  getSalesRegistrationDiscountById(id: $id) {
    id
    title
    description
    amount
    prefix
    method
    seqNo
  }
}
    `;

/**
 * __useGetSalesRegistrationDiscountByIdQuery__
 *
 * To run a query within a React component, call `useGetSalesRegistrationDiscountByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesRegistrationDiscountByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesRegistrationDiscountByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSalesRegistrationDiscountByIdQuery(baseOptions: Apollo.QueryHookOptions<GetSalesRegistrationDiscountByIdQuery, GetSalesRegistrationDiscountByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesRegistrationDiscountByIdQuery, GetSalesRegistrationDiscountByIdQueryVariables>(GetSalesRegistrationDiscountByIdDocument, options);
      }
export function useGetSalesRegistrationDiscountByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesRegistrationDiscountByIdQuery, GetSalesRegistrationDiscountByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesRegistrationDiscountByIdQuery, GetSalesRegistrationDiscountByIdQueryVariables>(GetSalesRegistrationDiscountByIdDocument, options);
        }
export type GetSalesRegistrationDiscountByIdQueryHookResult = ReturnType<typeof useGetSalesRegistrationDiscountByIdQuery>;
export type GetSalesRegistrationDiscountByIdLazyQueryHookResult = ReturnType<typeof useGetSalesRegistrationDiscountByIdLazyQuery>;
export type GetSalesRegistrationDiscountByIdQueryResult = Apollo.QueryResult<GetSalesRegistrationDiscountByIdQuery, GetSalesRegistrationDiscountByIdQueryVariables>;
export const CalculateSaleDiscountAmountDocument = gql`
    query calculateSaleDiscountAmount($input: CalculateSalesDiscountInput!) {
  calculateSaleDiscountAmount(input: $input)
}
    `;

/**
 * __useCalculateSaleDiscountAmountQuery__
 *
 * To run a query within a React component, call `useCalculateSaleDiscountAmountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalculateSaleDiscountAmountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalculateSaleDiscountAmountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCalculateSaleDiscountAmountQuery(baseOptions: Apollo.QueryHookOptions<CalculateSaleDiscountAmountQuery, CalculateSaleDiscountAmountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalculateSaleDiscountAmountQuery, CalculateSaleDiscountAmountQueryVariables>(CalculateSaleDiscountAmountDocument, options);
      }
export function useCalculateSaleDiscountAmountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalculateSaleDiscountAmountQuery, CalculateSaleDiscountAmountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalculateSaleDiscountAmountQuery, CalculateSaleDiscountAmountQueryVariables>(CalculateSaleDiscountAmountDocument, options);
        }
export type CalculateSaleDiscountAmountQueryHookResult = ReturnType<typeof useCalculateSaleDiscountAmountQuery>;
export type CalculateSaleDiscountAmountLazyQueryHookResult = ReturnType<typeof useCalculateSaleDiscountAmountLazyQuery>;
export type CalculateSaleDiscountAmountQueryResult = Apollo.QueryResult<CalculateSaleDiscountAmountQuery, CalculateSaleDiscountAmountQueryVariables>;
export const ReCalculateTotalSaleDiscountDocument = gql`
    query reCalculateTotalSaleDiscount($saleId: String!, $paymentPlanMarkUpAmt: Float!) {
  reCalculateTotalSaleDiscount(saleId: $saleId, paymentPlanMarkUpAmt: $paymentPlanMarkUpAmt)
}
    `;

/**
 * __useReCalculateTotalSaleDiscountQuery__
 *
 * To run a query within a React component, call `useReCalculateTotalSaleDiscountQuery` and pass it any options that fit your needs.
 * When your component renders, `useReCalculateTotalSaleDiscountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReCalculateTotalSaleDiscountQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *      paymentPlanMarkUpAmt: // value for 'paymentPlanMarkUpAmt'
 *   },
 * });
 */
export function useReCalculateTotalSaleDiscountQuery(baseOptions: Apollo.QueryHookOptions<ReCalculateTotalSaleDiscountQuery, ReCalculateTotalSaleDiscountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReCalculateTotalSaleDiscountQuery, ReCalculateTotalSaleDiscountQueryVariables>(ReCalculateTotalSaleDiscountDocument, options);
      }
export function useReCalculateTotalSaleDiscountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReCalculateTotalSaleDiscountQuery, ReCalculateTotalSaleDiscountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReCalculateTotalSaleDiscountQuery, ReCalculateTotalSaleDiscountQueryVariables>(ReCalculateTotalSaleDiscountDocument, options);
        }
export type ReCalculateTotalSaleDiscountQueryHookResult = ReturnType<typeof useReCalculateTotalSaleDiscountQuery>;
export type ReCalculateTotalSaleDiscountLazyQueryHookResult = ReturnType<typeof useReCalculateTotalSaleDiscountLazyQuery>;
export type ReCalculateTotalSaleDiscountQueryResult = Apollo.QueryResult<ReCalculateTotalSaleDiscountQuery, ReCalculateTotalSaleDiscountQueryVariables>;
export const AddSalesRegistrationDiscountDocument = gql`
    mutation addSalesRegistrationDiscount($input: addSalesContractDiscountInput!, $saleId: String!) {
  addSalesRegistrationDiscount(input: $input, saleId: $saleId)
}
    `;
export type AddSalesRegistrationDiscountMutationFn = Apollo.MutationFunction<AddSalesRegistrationDiscountMutation, AddSalesRegistrationDiscountMutationVariables>;

/**
 * __useAddSalesRegistrationDiscountMutation__
 *
 * To run a mutation, you first call `useAddSalesRegistrationDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSalesRegistrationDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSalesRegistrationDiscountMutation, { data, loading, error }] = useAddSalesRegistrationDiscountMutation({
 *   variables: {
 *      input: // value for 'input'
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useAddSalesRegistrationDiscountMutation(baseOptions?: Apollo.MutationHookOptions<AddSalesRegistrationDiscountMutation, AddSalesRegistrationDiscountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSalesRegistrationDiscountMutation, AddSalesRegistrationDiscountMutationVariables>(AddSalesRegistrationDiscountDocument, options);
      }
export type AddSalesRegistrationDiscountMutationHookResult = ReturnType<typeof useAddSalesRegistrationDiscountMutation>;
export type AddSalesRegistrationDiscountMutationResult = Apollo.MutationResult<AddSalesRegistrationDiscountMutation>;
export type AddSalesRegistrationDiscountMutationOptions = Apollo.BaseMutationOptions<AddSalesRegistrationDiscountMutation, AddSalesRegistrationDiscountMutationVariables>;
export const GetSalesRegistrationELetterDocument = gql`
    query getSalesRegistrationELetter($letterTemplateId: String!, $saleId: String!) {
  getSalesRegistrationELetter(letterTemplateId: $letterTemplateId, saleId: $saleId) {
    content
    fileName
  }
}
    `;

/**
 * __useGetSalesRegistrationELetterQuery__
 *
 * To run a query within a React component, call `useGetSalesRegistrationELetterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesRegistrationELetterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesRegistrationELetterQuery({
 *   variables: {
 *      letterTemplateId: // value for 'letterTemplateId'
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetSalesRegistrationELetterQuery(baseOptions: Apollo.QueryHookOptions<GetSalesRegistrationELetterQuery, GetSalesRegistrationELetterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesRegistrationELetterQuery, GetSalesRegistrationELetterQueryVariables>(GetSalesRegistrationELetterDocument, options);
      }
export function useGetSalesRegistrationELetterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesRegistrationELetterQuery, GetSalesRegistrationELetterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesRegistrationELetterQuery, GetSalesRegistrationELetterQueryVariables>(GetSalesRegistrationELetterDocument, options);
        }
export type GetSalesRegistrationELetterQueryHookResult = ReturnType<typeof useGetSalesRegistrationELetterQuery>;
export type GetSalesRegistrationELetterLazyQueryHookResult = ReturnType<typeof useGetSalesRegistrationELetterLazyQuery>;
export type GetSalesRegistrationELetterQueryResult = Apollo.QueryResult<GetSalesRegistrationELetterQuery, GetSalesRegistrationELetterQueryVariables>;
export const GetSalesRegistrationELetterTemplateListingDocument = gql`
    query getSalesRegistrationELetterTemplateListing($projectId: String!) {
  getSalesRegistrationELetterTemplateListing(projectId: $projectId) {
    id
    name
    letterType
    defaulted
  }
}
    `;

/**
 * __useGetSalesRegistrationELetterTemplateListingQuery__
 *
 * To run a query within a React component, call `useGetSalesRegistrationELetterTemplateListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesRegistrationELetterTemplateListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesRegistrationELetterTemplateListingQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetSalesRegistrationELetterTemplateListingQuery(baseOptions: Apollo.QueryHookOptions<GetSalesRegistrationELetterTemplateListingQuery, GetSalesRegistrationELetterTemplateListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesRegistrationELetterTemplateListingQuery, GetSalesRegistrationELetterTemplateListingQueryVariables>(GetSalesRegistrationELetterTemplateListingDocument, options);
      }
export function useGetSalesRegistrationELetterTemplateListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesRegistrationELetterTemplateListingQuery, GetSalesRegistrationELetterTemplateListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesRegistrationELetterTemplateListingQuery, GetSalesRegistrationELetterTemplateListingQueryVariables>(GetSalesRegistrationELetterTemplateListingDocument, options);
        }
export type GetSalesRegistrationELetterTemplateListingQueryHookResult = ReturnType<typeof useGetSalesRegistrationELetterTemplateListingQuery>;
export type GetSalesRegistrationELetterTemplateListingLazyQueryHookResult = ReturnType<typeof useGetSalesRegistrationELetterTemplateListingLazyQuery>;
export type GetSalesRegistrationELetterTemplateListingQueryResult = Apollo.QueryResult<GetSalesRegistrationELetterTemplateListingQuery, GetSalesRegistrationELetterTemplateListingQueryVariables>;
export const UpdatePaymentPlanCarParkDocument = gql`
    mutation updatePaymentPlanCarPark($saleId: String!, $regDate: DateTime) {
  updatePaymentPlanCarPark(saleId: $saleId, regDate: $regDate)
}
    `;
export type UpdatePaymentPlanCarParkMutationFn = Apollo.MutationFunction<UpdatePaymentPlanCarParkMutation, UpdatePaymentPlanCarParkMutationVariables>;

/**
 * __useUpdatePaymentPlanCarParkMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentPlanCarParkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentPlanCarParkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentPlanCarParkMutation, { data, loading, error }] = useUpdatePaymentPlanCarParkMutation({
 *   variables: {
 *      saleId: // value for 'saleId'
 *      regDate: // value for 'regDate'
 *   },
 * });
 */
export function useUpdatePaymentPlanCarParkMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaymentPlanCarParkMutation, UpdatePaymentPlanCarParkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePaymentPlanCarParkMutation, UpdatePaymentPlanCarParkMutationVariables>(UpdatePaymentPlanCarParkDocument, options);
      }
export type UpdatePaymentPlanCarParkMutationHookResult = ReturnType<typeof useUpdatePaymentPlanCarParkMutation>;
export type UpdatePaymentPlanCarParkMutationResult = Apollo.MutationResult<UpdatePaymentPlanCarParkMutation>;
export type UpdatePaymentPlanCarParkMutationOptions = Apollo.BaseMutationOptions<UpdatePaymentPlanCarParkMutation, UpdatePaymentPlanCarParkMutationVariables>;
export const UpdatePaymentPlanPackageDocument = gql`
    mutation updatePaymentPlanPackage($saleId: String!, $regDate: DateTime) {
  updatePaymentPlanPackage(saleId: $saleId, regDate: $regDate)
}
    `;
export type UpdatePaymentPlanPackageMutationFn = Apollo.MutationFunction<UpdatePaymentPlanPackageMutation, UpdatePaymentPlanPackageMutationVariables>;

/**
 * __useUpdatePaymentPlanPackageMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentPlanPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentPlanPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentPlanPackageMutation, { data, loading, error }] = useUpdatePaymentPlanPackageMutation({
 *   variables: {
 *      saleId: // value for 'saleId'
 *      regDate: // value for 'regDate'
 *   },
 * });
 */
export function useUpdatePaymentPlanPackageMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaymentPlanPackageMutation, UpdatePaymentPlanPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePaymentPlanPackageMutation, UpdatePaymentPlanPackageMutationVariables>(UpdatePaymentPlanPackageDocument, options);
      }
export type UpdatePaymentPlanPackageMutationHookResult = ReturnType<typeof useUpdatePaymentPlanPackageMutation>;
export type UpdatePaymentPlanPackageMutationResult = Apollo.MutationResult<UpdatePaymentPlanPackageMutation>;
export type UpdatePaymentPlanPackageMutationOptions = Apollo.BaseMutationOptions<UpdatePaymentPlanPackageMutation, UpdatePaymentPlanPackageMutationVariables>;
export const UpdateCarParkInstallmentDocument = gql`
    mutation updateCarParkInstallment($input: basePaymentPlanSummary!) {
  updateCarParkInstallment(input: $input)
}
    `;
export type UpdateCarParkInstallmentMutationFn = Apollo.MutationFunction<UpdateCarParkInstallmentMutation, UpdateCarParkInstallmentMutationVariables>;

/**
 * __useUpdateCarParkInstallmentMutation__
 *
 * To run a mutation, you first call `useUpdateCarParkInstallmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCarParkInstallmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCarParkInstallmentMutation, { data, loading, error }] = useUpdateCarParkInstallmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCarParkInstallmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCarParkInstallmentMutation, UpdateCarParkInstallmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCarParkInstallmentMutation, UpdateCarParkInstallmentMutationVariables>(UpdateCarParkInstallmentDocument, options);
      }
export type UpdateCarParkInstallmentMutationHookResult = ReturnType<typeof useUpdateCarParkInstallmentMutation>;
export type UpdateCarParkInstallmentMutationResult = Apollo.MutationResult<UpdateCarParkInstallmentMutation>;
export type UpdateCarParkInstallmentMutationOptions = Apollo.BaseMutationOptions<UpdateCarParkInstallmentMutation, UpdateCarParkInstallmentMutationVariables>;
export const GetAllSolicitorListDocument = gql`
    query getAllSolicitorList {
  getAllSolicitorList {
    id
    solicitorId
    name
    solicitorCode
    commonStatus
    projectCount
    unitCount
    isExistInMasterData
    isExistInTransactionData
  }
}
    `;

/**
 * __useGetAllSolicitorListQuery__
 *
 * To run a query within a React component, call `useGetAllSolicitorListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSolicitorListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllSolicitorListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllSolicitorListQuery(baseOptions?: Apollo.QueryHookOptions<GetAllSolicitorListQuery, GetAllSolicitorListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllSolicitorListQuery, GetAllSolicitorListQueryVariables>(GetAllSolicitorListDocument, options);
      }
export function useGetAllSolicitorListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllSolicitorListQuery, GetAllSolicitorListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllSolicitorListQuery, GetAllSolicitorListQueryVariables>(GetAllSolicitorListDocument, options);
        }
export type GetAllSolicitorListQueryHookResult = ReturnType<typeof useGetAllSolicitorListQuery>;
export type GetAllSolicitorListLazyQueryHookResult = ReturnType<typeof useGetAllSolicitorListLazyQuery>;
export type GetAllSolicitorListQueryResult = Apollo.QueryResult<GetAllSolicitorListQuery, GetAllSolicitorListQueryVariables>;
export const GetActiveSolicitorDocument = gql`
    query getActiveSolicitor {
  activeSolicitorList {
    id
    solicitorId
    solicitorCode
    name
    email
    createdTs
    officeTel
    address {
      address
      city
      state
      country
      postCode
    }
    contactName
    contactPhoneNo
    commonStatus
    contactEmail
  }
}
    `;

/**
 * __useGetActiveSolicitorQuery__
 *
 * To run a query within a React component, call `useGetActiveSolicitorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveSolicitorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveSolicitorQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActiveSolicitorQuery(baseOptions?: Apollo.QueryHookOptions<GetActiveSolicitorQuery, GetActiveSolicitorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveSolicitorQuery, GetActiveSolicitorQueryVariables>(GetActiveSolicitorDocument, options);
      }
export function useGetActiveSolicitorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveSolicitorQuery, GetActiveSolicitorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveSolicitorQuery, GetActiveSolicitorQueryVariables>(GetActiveSolicitorDocument, options);
        }
export type GetActiveSolicitorQueryHookResult = ReturnType<typeof useGetActiveSolicitorQuery>;
export type GetActiveSolicitorLazyQueryHookResult = ReturnType<typeof useGetActiveSolicitorLazyQuery>;
export type GetActiveSolicitorQueryResult = Apollo.QueryResult<GetActiveSolicitorQuery, GetActiveSolicitorQueryVariables>;
export const SolicitorDetailsDocument = gql`
    query solicitorDetails($solicitor_appointed_id: String!) {
  solicitorDetails(solicitor_appointed_id: $solicitor_appointed_id) {
    name
    solicitorCode
    email
    id
    officeTel
    address {
      address
      city
      state
      country
      postCode
    }
    contactName
    contactPhoneNo
    contactEmail
    saleBuyerSolicitor {
      unitId
      projectId
      project {
        name
      }
    }
    saleDeveloperSolicitor {
      unitId
      projectId
      project {
        name
      }
    }
    saleLoan {
      sale {
        unitId
        projectId
        project {
          name
        }
      }
    }
  }
}
    `;

/**
 * __useSolicitorDetailsQuery__
 *
 * To run a query within a React component, call `useSolicitorDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSolicitorDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSolicitorDetailsQuery({
 *   variables: {
 *      solicitor_appointed_id: // value for 'solicitor_appointed_id'
 *   },
 * });
 */
export function useSolicitorDetailsQuery(baseOptions: Apollo.QueryHookOptions<SolicitorDetailsQuery, SolicitorDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SolicitorDetailsQuery, SolicitorDetailsQueryVariables>(SolicitorDetailsDocument, options);
      }
export function useSolicitorDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SolicitorDetailsQuery, SolicitorDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SolicitorDetailsQuery, SolicitorDetailsQueryVariables>(SolicitorDetailsDocument, options);
        }
export type SolicitorDetailsQueryHookResult = ReturnType<typeof useSolicitorDetailsQuery>;
export type SolicitorDetailsLazyQueryHookResult = ReturnType<typeof useSolicitorDetailsLazyQuery>;
export type SolicitorDetailsQueryResult = Apollo.QueryResult<SolicitorDetailsQuery, SolicitorDetailsQueryVariables>;
export const AddSolicitorDocument = gql`
    mutation addSolicitor($input: AdminSolicitorInput!) {
  addSolicitor(input: $input)
}
    `;
export type AddSolicitorMutationFn = Apollo.MutationFunction<AddSolicitorMutation, AddSolicitorMutationVariables>;

/**
 * __useAddSolicitorMutation__
 *
 * To run a mutation, you first call `useAddSolicitorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSolicitorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSolicitorMutation, { data, loading, error }] = useAddSolicitorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddSolicitorMutation(baseOptions?: Apollo.MutationHookOptions<AddSolicitorMutation, AddSolicitorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSolicitorMutation, AddSolicitorMutationVariables>(AddSolicitorDocument, options);
      }
export type AddSolicitorMutationHookResult = ReturnType<typeof useAddSolicitorMutation>;
export type AddSolicitorMutationResult = Apollo.MutationResult<AddSolicitorMutation>;
export type AddSolicitorMutationOptions = Apollo.BaseMutationOptions<AddSolicitorMutation, AddSolicitorMutationVariables>;
export const EditSolicitorDocument = gql`
    mutation editSolicitor($input: AdminSolicitorInput!, $solicitor_appointed_id: String!) {
  editSolicitor(input: $input, solicitor_appointed_id: $solicitor_appointed_id)
}
    `;
export type EditSolicitorMutationFn = Apollo.MutationFunction<EditSolicitorMutation, EditSolicitorMutationVariables>;

/**
 * __useEditSolicitorMutation__
 *
 * To run a mutation, you first call `useEditSolicitorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSolicitorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSolicitorMutation, { data, loading, error }] = useEditSolicitorMutation({
 *   variables: {
 *      input: // value for 'input'
 *      solicitor_appointed_id: // value for 'solicitor_appointed_id'
 *   },
 * });
 */
export function useEditSolicitorMutation(baseOptions?: Apollo.MutationHookOptions<EditSolicitorMutation, EditSolicitorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditSolicitorMutation, EditSolicitorMutationVariables>(EditSolicitorDocument, options);
      }
export type EditSolicitorMutationHookResult = ReturnType<typeof useEditSolicitorMutation>;
export type EditSolicitorMutationResult = Apollo.MutationResult<EditSolicitorMutation>;
export type EditSolicitorMutationOptions = Apollo.BaseMutationOptions<EditSolicitorMutation, EditSolicitorMutationVariables>;
export const SuspendSolicitorDocument = gql`
    mutation suspendSolicitor($solicitor_appointed_id: String!, $isDeletable: Boolean!) {
  suspendSolicitor(solicitor_appointed_id: $solicitor_appointed_id, isDeletable: $isDeletable)
}
    `;
export type SuspendSolicitorMutationFn = Apollo.MutationFunction<SuspendSolicitorMutation, SuspendSolicitorMutationVariables>;

/**
 * __useSuspendSolicitorMutation__
 *
 * To run a mutation, you first call `useSuspendSolicitorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuspendSolicitorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [suspendSolicitorMutation, { data, loading, error }] = useSuspendSolicitorMutation({
 *   variables: {
 *      solicitor_appointed_id: // value for 'solicitor_appointed_id'
 *      isDeletable: // value for 'isDeletable'
 *   },
 * });
 */
export function useSuspendSolicitorMutation(baseOptions?: Apollo.MutationHookOptions<SuspendSolicitorMutation, SuspendSolicitorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuspendSolicitorMutation, SuspendSolicitorMutationVariables>(SuspendSolicitorDocument, options);
      }
export type SuspendSolicitorMutationHookResult = ReturnType<typeof useSuspendSolicitorMutation>;
export type SuspendSolicitorMutationResult = Apollo.MutationResult<SuspendSolicitorMutation>;
export type SuspendSolicitorMutationOptions = Apollo.BaseMutationOptions<SuspendSolicitorMutation, SuspendSolicitorMutationVariables>;
export const ActivateSolicitorByIdDocument = gql`
    mutation activateSolicitorById($solicitorAppointedId: String!) {
  activateSolicitorById(solicitorAppointedId: $solicitorAppointedId)
}
    `;
export type ActivateSolicitorByIdMutationFn = Apollo.MutationFunction<ActivateSolicitorByIdMutation, ActivateSolicitorByIdMutationVariables>;

/**
 * __useActivateSolicitorByIdMutation__
 *
 * To run a mutation, you first call `useActivateSolicitorByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateSolicitorByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateSolicitorByIdMutation, { data, loading, error }] = useActivateSolicitorByIdMutation({
 *   variables: {
 *      solicitorAppointedId: // value for 'solicitorAppointedId'
 *   },
 * });
 */
export function useActivateSolicitorByIdMutation(baseOptions?: Apollo.MutationHookOptions<ActivateSolicitorByIdMutation, ActivateSolicitorByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateSolicitorByIdMutation, ActivateSolicitorByIdMutationVariables>(ActivateSolicitorByIdDocument, options);
      }
export type ActivateSolicitorByIdMutationHookResult = ReturnType<typeof useActivateSolicitorByIdMutation>;
export type ActivateSolicitorByIdMutationResult = Apollo.MutationResult<ActivateSolicitorByIdMutation>;
export type ActivateSolicitorByIdMutationOptions = Apollo.BaseMutationOptions<ActivateSolicitorByIdMutation, ActivateSolicitorByIdMutationVariables>;
export const GetStakeholderDeemCollectedListingDocument = gql`
    query getStakeholderDeemCollectedListing($solicitorId: String!) {
  getStakeholderDeemCollectedListing(solicitorId: $solicitorId) {
    solicitorId
    collectionBatchId
    collectionDate
    saleCount
    totalDeemCollected
    attachment {
      fileName
      mediaType
      resourceUrl
    }
    unitNo
    status
    voidBy
    documentDate
    collectionReferenceNo
  }
}
    `;

/**
 * __useGetStakeholderDeemCollectedListingQuery__
 *
 * To run a query within a React component, call `useGetStakeholderDeemCollectedListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStakeholderDeemCollectedListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStakeholderDeemCollectedListingQuery({
 *   variables: {
 *      solicitorId: // value for 'solicitorId'
 *   },
 * });
 */
export function useGetStakeholderDeemCollectedListingQuery(baseOptions: Apollo.QueryHookOptions<GetStakeholderDeemCollectedListingQuery, GetStakeholderDeemCollectedListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStakeholderDeemCollectedListingQuery, GetStakeholderDeemCollectedListingQueryVariables>(GetStakeholderDeemCollectedListingDocument, options);
      }
export function useGetStakeholderDeemCollectedListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStakeholderDeemCollectedListingQuery, GetStakeholderDeemCollectedListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStakeholderDeemCollectedListingQuery, GetStakeholderDeemCollectedListingQueryVariables>(GetStakeholderDeemCollectedListingDocument, options);
        }
export type GetStakeholderDeemCollectedListingQueryHookResult = ReturnType<typeof useGetStakeholderDeemCollectedListingQuery>;
export type GetStakeholderDeemCollectedListingLazyQueryHookResult = ReturnType<typeof useGetStakeholderDeemCollectedListingLazyQuery>;
export type GetStakeholderDeemCollectedListingQueryResult = Apollo.QueryResult<GetStakeholderDeemCollectedListingQuery, GetStakeholderDeemCollectedListingQueryVariables>;
export const GetStakeholderDeemCollectedDetailDocument = gql`
    query getStakeholderDeemCollectedDetail($solicitorId: String!, $collectionBatchId: String!) {
  getStakeholderDeemCollectedDetail(solicitorId: $solicitorId, collectionBatchId: $collectionBatchId) {
    solicitorId
    collectionBatch
    collectionReferenceNo
    collectionDate
    durationFlag
    totalDeemCollected
    attachments {
      attachmentId
      fileName
      resourceUrl
      mediaType
    }
  }
}
    `;

/**
 * __useGetStakeholderDeemCollectedDetailQuery__
 *
 * To run a query within a React component, call `useGetStakeholderDeemCollectedDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStakeholderDeemCollectedDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStakeholderDeemCollectedDetailQuery({
 *   variables: {
 *      solicitorId: // value for 'solicitorId'
 *      collectionBatchId: // value for 'collectionBatchId'
 *   },
 * });
 */
export function useGetStakeholderDeemCollectedDetailQuery(baseOptions: Apollo.QueryHookOptions<GetStakeholderDeemCollectedDetailQuery, GetStakeholderDeemCollectedDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStakeholderDeemCollectedDetailQuery, GetStakeholderDeemCollectedDetailQueryVariables>(GetStakeholderDeemCollectedDetailDocument, options);
      }
export function useGetStakeholderDeemCollectedDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStakeholderDeemCollectedDetailQuery, GetStakeholderDeemCollectedDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStakeholderDeemCollectedDetailQuery, GetStakeholderDeemCollectedDetailQueryVariables>(GetStakeholderDeemCollectedDetailDocument, options);
        }
export type GetStakeholderDeemCollectedDetailQueryHookResult = ReturnType<typeof useGetStakeholderDeemCollectedDetailQuery>;
export type GetStakeholderDeemCollectedDetailLazyQueryHookResult = ReturnType<typeof useGetStakeholderDeemCollectedDetailLazyQuery>;
export type GetStakeholderDeemCollectedDetailQueryResult = Apollo.QueryResult<GetStakeholderDeemCollectedDetailQuery, GetStakeholderDeemCollectedDetailQueryVariables>;
export const GetStakeholderAvailableDeemCollectedUnitDocument = gql`
    query getStakeholderAvailableDeemCollectedUnit($solicitorId: String!, $mode: String!, $collectionBatchId: String) {
  getStakeholderAvailableDeemCollectedUnit(solicitorId: $solicitorId, mode: $mode, collectionBatchId: $collectionBatchId) {
    saleId
    unitNo
    totalDeemCollected
    deemCollectedIds
    deemCollectedData {
      bankName
      buyerName
      collectionBatchId
      financierCode
      financierName
      pbDescription
      pbDocumentNo
      pbId
      saleId
      spAmount
      spDueDate
      spId
      unitNo
      financialBillingId
    }
  }
}
    `;

/**
 * __useGetStakeholderAvailableDeemCollectedUnitQuery__
 *
 * To run a query within a React component, call `useGetStakeholderAvailableDeemCollectedUnitQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStakeholderAvailableDeemCollectedUnitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStakeholderAvailableDeemCollectedUnitQuery({
 *   variables: {
 *      solicitorId: // value for 'solicitorId'
 *      mode: // value for 'mode'
 *      collectionBatchId: // value for 'collectionBatchId'
 *   },
 * });
 */
export function useGetStakeholderAvailableDeemCollectedUnitQuery(baseOptions: Apollo.QueryHookOptions<GetStakeholderAvailableDeemCollectedUnitQuery, GetStakeholderAvailableDeemCollectedUnitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStakeholderAvailableDeemCollectedUnitQuery, GetStakeholderAvailableDeemCollectedUnitQueryVariables>(GetStakeholderAvailableDeemCollectedUnitDocument, options);
      }
export function useGetStakeholderAvailableDeemCollectedUnitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStakeholderAvailableDeemCollectedUnitQuery, GetStakeholderAvailableDeemCollectedUnitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStakeholderAvailableDeemCollectedUnitQuery, GetStakeholderAvailableDeemCollectedUnitQueryVariables>(GetStakeholderAvailableDeemCollectedUnitDocument, options);
        }
export type GetStakeholderAvailableDeemCollectedUnitQueryHookResult = ReturnType<typeof useGetStakeholderAvailableDeemCollectedUnitQuery>;
export type GetStakeholderAvailableDeemCollectedUnitLazyQueryHookResult = ReturnType<typeof useGetStakeholderAvailableDeemCollectedUnitLazyQuery>;
export type GetStakeholderAvailableDeemCollectedUnitQueryResult = Apollo.QueryResult<GetStakeholderAvailableDeemCollectedUnitQuery, GetStakeholderAvailableDeemCollectedUnitQueryVariables>;
export const AddDeemCollectedDocument = gql`
    mutation addDeemCollected($input: deemCollectedInput!) {
  addDeemCollected(input: $input)
}
    `;
export type AddDeemCollectedMutationFn = Apollo.MutationFunction<AddDeemCollectedMutation, AddDeemCollectedMutationVariables>;

/**
 * __useAddDeemCollectedMutation__
 *
 * To run a mutation, you first call `useAddDeemCollectedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDeemCollectedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDeemCollectedMutation, { data, loading, error }] = useAddDeemCollectedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddDeemCollectedMutation(baseOptions?: Apollo.MutationHookOptions<AddDeemCollectedMutation, AddDeemCollectedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDeemCollectedMutation, AddDeemCollectedMutationVariables>(AddDeemCollectedDocument, options);
      }
export type AddDeemCollectedMutationHookResult = ReturnType<typeof useAddDeemCollectedMutation>;
export type AddDeemCollectedMutationResult = Apollo.MutationResult<AddDeemCollectedMutation>;
export type AddDeemCollectedMutationOptions = Apollo.BaseMutationOptions<AddDeemCollectedMutation, AddDeemCollectedMutationVariables>;
export const EditDeemCollectedDocument = gql`
    mutation editDeemCollected($input: EditDeemCollectedInput!) {
  editDeemCollected(input: $input)
}
    `;
export type EditDeemCollectedMutationFn = Apollo.MutationFunction<EditDeemCollectedMutation, EditDeemCollectedMutationVariables>;

/**
 * __useEditDeemCollectedMutation__
 *
 * To run a mutation, you first call `useEditDeemCollectedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditDeemCollectedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editDeemCollectedMutation, { data, loading, error }] = useEditDeemCollectedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditDeemCollectedMutation(baseOptions?: Apollo.MutationHookOptions<EditDeemCollectedMutation, EditDeemCollectedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditDeemCollectedMutation, EditDeemCollectedMutationVariables>(EditDeemCollectedDocument, options);
      }
export type EditDeemCollectedMutationHookResult = ReturnType<typeof useEditDeemCollectedMutation>;
export type EditDeemCollectedMutationResult = Apollo.MutationResult<EditDeemCollectedMutation>;
export type EditDeemCollectedMutationOptions = Apollo.BaseMutationOptions<EditDeemCollectedMutation, EditDeemCollectedMutationVariables>;
export const PostDeemCollectedDocument = gql`
    mutation postDeemCollected($input: postDeemCollectedInput!) {
  postDeemCollected(input: $input)
}
    `;
export type PostDeemCollectedMutationFn = Apollo.MutationFunction<PostDeemCollectedMutation, PostDeemCollectedMutationVariables>;

/**
 * __usePostDeemCollectedMutation__
 *
 * To run a mutation, you first call `usePostDeemCollectedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostDeemCollectedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postDeemCollectedMutation, { data, loading, error }] = usePostDeemCollectedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePostDeemCollectedMutation(baseOptions?: Apollo.MutationHookOptions<PostDeemCollectedMutation, PostDeemCollectedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PostDeemCollectedMutation, PostDeemCollectedMutationVariables>(PostDeemCollectedDocument, options);
      }
export type PostDeemCollectedMutationHookResult = ReturnType<typeof usePostDeemCollectedMutation>;
export type PostDeemCollectedMutationResult = Apollo.MutationResult<PostDeemCollectedMutation>;
export type PostDeemCollectedMutationOptions = Apollo.BaseMutationOptions<PostDeemCollectedMutation, PostDeemCollectedMutationVariables>;
export const SoftDeleteStakeholderProcessDocument = gql`
    mutation softDeleteStakeholderProcess($collectionBatchId: String!, $solicitorId: String!) {
  softDeleteStakeholderProcess(collectionBatchId: $collectionBatchId, solicitorId: $solicitorId)
}
    `;
export type SoftDeleteStakeholderProcessMutationFn = Apollo.MutationFunction<SoftDeleteStakeholderProcessMutation, SoftDeleteStakeholderProcessMutationVariables>;

/**
 * __useSoftDeleteStakeholderProcessMutation__
 *
 * To run a mutation, you first call `useSoftDeleteStakeholderProcessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftDeleteStakeholderProcessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softDeleteStakeholderProcessMutation, { data, loading, error }] = useSoftDeleteStakeholderProcessMutation({
 *   variables: {
 *      collectionBatchId: // value for 'collectionBatchId'
 *      solicitorId: // value for 'solicitorId'
 *   },
 * });
 */
export function useSoftDeleteStakeholderProcessMutation(baseOptions?: Apollo.MutationHookOptions<SoftDeleteStakeholderProcessMutation, SoftDeleteStakeholderProcessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SoftDeleteStakeholderProcessMutation, SoftDeleteStakeholderProcessMutationVariables>(SoftDeleteStakeholderProcessDocument, options);
      }
export type SoftDeleteStakeholderProcessMutationHookResult = ReturnType<typeof useSoftDeleteStakeholderProcessMutation>;
export type SoftDeleteStakeholderProcessMutationResult = Apollo.MutationResult<SoftDeleteStakeholderProcessMutation>;
export type SoftDeleteStakeholderProcessMutationOptions = Apollo.BaseMutationOptions<SoftDeleteStakeholderProcessMutation, SoftDeleteStakeholderProcessMutationVariables>;
export const ReversalStakeholderProcessDocument = gql`
    mutation reversalStakeholderProcess($collectionBatchId: String!, $solicitorId: String!) {
  reversalStakeholderProcess(collectionBatchId: $collectionBatchId, solicitorId: $solicitorId)
}
    `;
export type ReversalStakeholderProcessMutationFn = Apollo.MutationFunction<ReversalStakeholderProcessMutation, ReversalStakeholderProcessMutationVariables>;

/**
 * __useReversalStakeholderProcessMutation__
 *
 * To run a mutation, you first call `useReversalStakeholderProcessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReversalStakeholderProcessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reversalStakeholderProcessMutation, { data, loading, error }] = useReversalStakeholderProcessMutation({
 *   variables: {
 *      collectionBatchId: // value for 'collectionBatchId'
 *      solicitorId: // value for 'solicitorId'
 *   },
 * });
 */
export function useReversalStakeholderProcessMutation(baseOptions?: Apollo.MutationHookOptions<ReversalStakeholderProcessMutation, ReversalStakeholderProcessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReversalStakeholderProcessMutation, ReversalStakeholderProcessMutationVariables>(ReversalStakeholderProcessDocument, options);
      }
export type ReversalStakeholderProcessMutationHookResult = ReturnType<typeof useReversalStakeholderProcessMutation>;
export type ReversalStakeholderProcessMutationResult = Apollo.MutationResult<ReversalStakeholderProcessMutation>;
export type ReversalStakeholderProcessMutationOptions = Apollo.BaseMutationOptions<ReversalStakeholderProcessMutation, ReversalStakeholderProcessMutationVariables>;
export const PostReleaseDataDocument = gql`
    mutation postReleaseData($id: String!) {
  postReleaseData(id: $id)
}
    `;
export type PostReleaseDataMutationFn = Apollo.MutationFunction<PostReleaseDataMutation, PostReleaseDataMutationVariables>;

/**
 * __usePostReleaseDataMutation__
 *
 * To run a mutation, you first call `usePostReleaseDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostReleaseDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postReleaseDataMutation, { data, loading, error }] = usePostReleaseDataMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePostReleaseDataMutation(baseOptions?: Apollo.MutationHookOptions<PostReleaseDataMutation, PostReleaseDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PostReleaseDataMutation, PostReleaseDataMutationVariables>(PostReleaseDataDocument, options);
      }
export type PostReleaseDataMutationHookResult = ReturnType<typeof usePostReleaseDataMutation>;
export type PostReleaseDataMutationResult = Apollo.MutationResult<PostReleaseDataMutation>;
export type PostReleaseDataMutationOptions = Apollo.BaseMutationOptions<PostReleaseDataMutation, PostReleaseDataMutationVariables>;
export const ReversalReleaseDataDocument = gql`
    mutation reversalReleaseData($id: String!) {
  reversalReleaseData(id: $id)
}
    `;
export type ReversalReleaseDataMutationFn = Apollo.MutationFunction<ReversalReleaseDataMutation, ReversalReleaseDataMutationVariables>;

/**
 * __useReversalReleaseDataMutation__
 *
 * To run a mutation, you first call `useReversalReleaseDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReversalReleaseDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reversalReleaseDataMutation, { data, loading, error }] = useReversalReleaseDataMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReversalReleaseDataMutation(baseOptions?: Apollo.MutationHookOptions<ReversalReleaseDataMutation, ReversalReleaseDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReversalReleaseDataMutation, ReversalReleaseDataMutationVariables>(ReversalReleaseDataDocument, options);
      }
export type ReversalReleaseDataMutationHookResult = ReturnType<typeof useReversalReleaseDataMutation>;
export type ReversalReleaseDataMutationResult = Apollo.MutationResult<ReversalReleaseDataMutation>;
export type ReversalReleaseDataMutationOptions = Apollo.BaseMutationOptions<ReversalReleaseDataMutation, ReversalReleaseDataMutationVariables>;
export const GetAllStakeholderProcessDocument = gql`
    query getAllStakeholderProcess($project_id: String!) {
  getAllStakeholderProcess(project_id: $project_id) {
    data {
      id
    }
    total
  }
}
    `;

/**
 * __useGetAllStakeholderProcessQuery__
 *
 * To run a query within a React component, call `useGetAllStakeholderProcessQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllStakeholderProcessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllStakeholderProcessQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *   },
 * });
 */
export function useGetAllStakeholderProcessQuery(baseOptions: Apollo.QueryHookOptions<GetAllStakeholderProcessQuery, GetAllStakeholderProcessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllStakeholderProcessQuery, GetAllStakeholderProcessQueryVariables>(GetAllStakeholderProcessDocument, options);
      }
export function useGetAllStakeholderProcessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllStakeholderProcessQuery, GetAllStakeholderProcessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllStakeholderProcessQuery, GetAllStakeholderProcessQueryVariables>(GetAllStakeholderProcessDocument, options);
        }
export type GetAllStakeholderProcessQueryHookResult = ReturnType<typeof useGetAllStakeholderProcessQuery>;
export type GetAllStakeholderProcessLazyQueryHookResult = ReturnType<typeof useGetAllStakeholderProcessLazyQuery>;
export type GetAllStakeholderProcessQueryResult = Apollo.QueryResult<GetAllStakeholderProcessQuery, GetAllStakeholderProcessQueryVariables>;
export const GetPaymentMethodDescDocument = gql`
    query getPaymentMethodDesc {
  getPaymentMethodDesc
}
    `;

/**
 * __useGetPaymentMethodDescQuery__
 *
 * To run a query within a React component, call `useGetPaymentMethodDescQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentMethodDescQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentMethodDescQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPaymentMethodDescQuery(baseOptions?: Apollo.QueryHookOptions<GetPaymentMethodDescQuery, GetPaymentMethodDescQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentMethodDescQuery, GetPaymentMethodDescQueryVariables>(GetPaymentMethodDescDocument, options);
      }
export function useGetPaymentMethodDescLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentMethodDescQuery, GetPaymentMethodDescQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentMethodDescQuery, GetPaymentMethodDescQueryVariables>(GetPaymentMethodDescDocument, options);
        }
export type GetPaymentMethodDescQueryHookResult = ReturnType<typeof useGetPaymentMethodDescQuery>;
export type GetPaymentMethodDescLazyQueryHookResult = ReturnType<typeof useGetPaymentMethodDescLazyQuery>;
export type GetPaymentMethodDescQueryResult = Apollo.QueryResult<GetPaymentMethodDescQuery, GetPaymentMethodDescQueryVariables>;
export const GetStakeholderProcessListingDocument = gql`
    query getStakeholderProcessListing {
  getStakeholderProcessListing {
    solicitorId
    solicitorName
    solicitorCode
    saleCount
    totalAmt
    totalDeemCollected
    deemCollectedSaleCount
    totalReleaseAmt
    releaseSaleCount
    outstandingReleaseAmt
    unitIndex
  }
}
    `;

/**
 * __useGetStakeholderProcessListingQuery__
 *
 * To run a query within a React component, call `useGetStakeholderProcessListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStakeholderProcessListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStakeholderProcessListingQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStakeholderProcessListingQuery(baseOptions?: Apollo.QueryHookOptions<GetStakeholderProcessListingQuery, GetStakeholderProcessListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStakeholderProcessListingQuery, GetStakeholderProcessListingQueryVariables>(GetStakeholderProcessListingDocument, options);
      }
export function useGetStakeholderProcessListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStakeholderProcessListingQuery, GetStakeholderProcessListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStakeholderProcessListingQuery, GetStakeholderProcessListingQueryVariables>(GetStakeholderProcessListingDocument, options);
        }
export type GetStakeholderProcessListingQueryHookResult = ReturnType<typeof useGetStakeholderProcessListingQuery>;
export type GetStakeholderProcessListingLazyQueryHookResult = ReturnType<typeof useGetStakeholderProcessListingLazyQuery>;
export type GetStakeholderProcessListingQueryResult = Apollo.QueryResult<GetStakeholderProcessListingQuery, GetStakeholderProcessListingQueryVariables>;
export const GetStakeholderProcessBySolicitorIdDocument = gql`
    query getStakeholderProcessBySolicitorId($solicitorId: String!) {
  getStakeholderProcessBySolicitorId(solicitorId: $solicitorId) {
    solicitorId
    solicitorName
    solicitorCode
    saleCount
    totalAmt
    totalDeemCollected
    deemCollectedSaleCount
    totalReleaseAmt
    releaseSaleCount
    outstandingReleaseAmt
  }
}
    `;

/**
 * __useGetStakeholderProcessBySolicitorIdQuery__
 *
 * To run a query within a React component, call `useGetStakeholderProcessBySolicitorIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStakeholderProcessBySolicitorIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStakeholderProcessBySolicitorIdQuery({
 *   variables: {
 *      solicitorId: // value for 'solicitorId'
 *   },
 * });
 */
export function useGetStakeholderProcessBySolicitorIdQuery(baseOptions: Apollo.QueryHookOptions<GetStakeholderProcessBySolicitorIdQuery, GetStakeholderProcessBySolicitorIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStakeholderProcessBySolicitorIdQuery, GetStakeholderProcessBySolicitorIdQueryVariables>(GetStakeholderProcessBySolicitorIdDocument, options);
      }
export function useGetStakeholderProcessBySolicitorIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStakeholderProcessBySolicitorIdQuery, GetStakeholderProcessBySolicitorIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStakeholderProcessBySolicitorIdQuery, GetStakeholderProcessBySolicitorIdQueryVariables>(GetStakeholderProcessBySolicitorIdDocument, options);
        }
export type GetStakeholderProcessBySolicitorIdQueryHookResult = ReturnType<typeof useGetStakeholderProcessBySolicitorIdQuery>;
export type GetStakeholderProcessBySolicitorIdLazyQueryHookResult = ReturnType<typeof useGetStakeholderProcessBySolicitorIdLazyQuery>;
export type GetStakeholderProcessBySolicitorIdQueryResult = Apollo.QueryResult<GetStakeholderProcessBySolicitorIdQuery, GetStakeholderProcessBySolicitorIdQueryVariables>;
export const GetStakeholderUnitSummaryBySolicitorIdDocument = gql`
    query getStakeholderUnitSummaryBySolicitorId($solicitorId: String!) {
  getStakeholderUnitSummaryBySolicitorId(solicitorId: $solicitorId) {
    saleId
    unitNo
    totalDeemCollected
    totalReleaseAmt
    outstandingReleaseAmt
  }
}
    `;

/**
 * __useGetStakeholderUnitSummaryBySolicitorIdQuery__
 *
 * To run a query within a React component, call `useGetStakeholderUnitSummaryBySolicitorIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStakeholderUnitSummaryBySolicitorIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStakeholderUnitSummaryBySolicitorIdQuery({
 *   variables: {
 *      solicitorId: // value for 'solicitorId'
 *   },
 * });
 */
export function useGetStakeholderUnitSummaryBySolicitorIdQuery(baseOptions: Apollo.QueryHookOptions<GetStakeholderUnitSummaryBySolicitorIdQuery, GetStakeholderUnitSummaryBySolicitorIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStakeholderUnitSummaryBySolicitorIdQuery, GetStakeholderUnitSummaryBySolicitorIdQueryVariables>(GetStakeholderUnitSummaryBySolicitorIdDocument, options);
      }
export function useGetStakeholderUnitSummaryBySolicitorIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStakeholderUnitSummaryBySolicitorIdQuery, GetStakeholderUnitSummaryBySolicitorIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStakeholderUnitSummaryBySolicitorIdQuery, GetStakeholderUnitSummaryBySolicitorIdQueryVariables>(GetStakeholderUnitSummaryBySolicitorIdDocument, options);
        }
export type GetStakeholderUnitSummaryBySolicitorIdQueryHookResult = ReturnType<typeof useGetStakeholderUnitSummaryBySolicitorIdQuery>;
export type GetStakeholderUnitSummaryBySolicitorIdLazyQueryHookResult = ReturnType<typeof useGetStakeholderUnitSummaryBySolicitorIdLazyQuery>;
export type GetStakeholderUnitSummaryBySolicitorIdQueryResult = Apollo.QueryResult<GetStakeholderUnitSummaryBySolicitorIdQuery, GetStakeholderUnitSummaryBySolicitorIdQueryVariables>;
export const GetStakeholderUnitDetailDocument = gql`
    query getStakeholderUnitDetail($solicitorId: String!, $saleId: String!) {
  getStakeholderUnitDetail(saleId: $saleId, solicitorId: $solicitorId) {
    saleId
    unitNo
    billingDescription
    dueDate
    deemCollected
    outstandingReleaseAmt
  }
}
    `;

/**
 * __useGetStakeholderUnitDetailQuery__
 *
 * To run a query within a React component, call `useGetStakeholderUnitDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStakeholderUnitDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStakeholderUnitDetailQuery({
 *   variables: {
 *      solicitorId: // value for 'solicitorId'
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetStakeholderUnitDetailQuery(baseOptions: Apollo.QueryHookOptions<GetStakeholderUnitDetailQuery, GetStakeholderUnitDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStakeholderUnitDetailQuery, GetStakeholderUnitDetailQueryVariables>(GetStakeholderUnitDetailDocument, options);
      }
export function useGetStakeholderUnitDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStakeholderUnitDetailQuery, GetStakeholderUnitDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStakeholderUnitDetailQuery, GetStakeholderUnitDetailQueryVariables>(GetStakeholderUnitDetailDocument, options);
        }
export type GetStakeholderUnitDetailQueryHookResult = ReturnType<typeof useGetStakeholderUnitDetailQuery>;
export type GetStakeholderUnitDetailLazyQueryHookResult = ReturnType<typeof useGetStakeholderUnitDetailLazyQuery>;
export type GetStakeholderUnitDetailQueryResult = Apollo.QueryResult<GetStakeholderUnitDetailQuery, GetStakeholderUnitDetailQueryVariables>;
export const ChangeStakeholderDocument = gql`
    mutation changeStakeholder($solicitorId: String!, $saleIdList: [String!]!) {
  changeStakeholder(solicitorId: $solicitorId, saleIdList: $saleIdList)
}
    `;
export type ChangeStakeholderMutationFn = Apollo.MutationFunction<ChangeStakeholderMutation, ChangeStakeholderMutationVariables>;

/**
 * __useChangeStakeholderMutation__
 *
 * To run a mutation, you first call `useChangeStakeholderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeStakeholderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeStakeholderMutation, { data, loading, error }] = useChangeStakeholderMutation({
 *   variables: {
 *      solicitorId: // value for 'solicitorId'
 *      saleIdList: // value for 'saleIdList'
 *   },
 * });
 */
export function useChangeStakeholderMutation(baseOptions?: Apollo.MutationHookOptions<ChangeStakeholderMutation, ChangeStakeholderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeStakeholderMutation, ChangeStakeholderMutationVariables>(ChangeStakeholderDocument, options);
      }
export type ChangeStakeholderMutationHookResult = ReturnType<typeof useChangeStakeholderMutation>;
export type ChangeStakeholderMutationResult = Apollo.MutationResult<ChangeStakeholderMutation>;
export type ChangeStakeholderMutationOptions = Apollo.BaseMutationOptions<ChangeStakeholderMutation, ChangeStakeholderMutationVariables>;
export const GetStakeholderReleaseListingDocument = gql`
    query getStakeholderReleaseListing($solicitorId: String!) {
  getStakeholderReleaseListing(solicitorId: $solicitorId) {
    stakeholderReleaseId
    solicitorId
    releaseDate
    saleCount
    totalReleaseAmt
    attachment {
      fileName
      mediaType
      resourceUrl
    }
    unitNo
    gl_generation_batch
    status
    isVoid
    releaseRefNo
  }
}
    `;

/**
 * __useGetStakeholderReleaseListingQuery__
 *
 * To run a query within a React component, call `useGetStakeholderReleaseListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStakeholderReleaseListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStakeholderReleaseListingQuery({
 *   variables: {
 *      solicitorId: // value for 'solicitorId'
 *   },
 * });
 */
export function useGetStakeholderReleaseListingQuery(baseOptions: Apollo.QueryHookOptions<GetStakeholderReleaseListingQuery, GetStakeholderReleaseListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStakeholderReleaseListingQuery, GetStakeholderReleaseListingQueryVariables>(GetStakeholderReleaseListingDocument, options);
      }
export function useGetStakeholderReleaseListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStakeholderReleaseListingQuery, GetStakeholderReleaseListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStakeholderReleaseListingQuery, GetStakeholderReleaseListingQueryVariables>(GetStakeholderReleaseListingDocument, options);
        }
export type GetStakeholderReleaseListingQueryHookResult = ReturnType<typeof useGetStakeholderReleaseListingQuery>;
export type GetStakeholderReleaseListingLazyQueryHookResult = ReturnType<typeof useGetStakeholderReleaseListingLazyQuery>;
export type GetStakeholderReleaseListingQueryResult = Apollo.QueryResult<GetStakeholderReleaseListingQuery, GetStakeholderReleaseListingQueryVariables>;
export const GetStakeholderReleaseUnitDocument = gql`
    query getStakeholderReleaseUnit($solicitorId: String!, $id: String) {
  getStakeholderReleaseUnit(solicitorId: $solicitorId, id: $id) {
    dueDate
    saleId
    unitNo
    outstandingAmt
    stakeholderProcessId
    stakeholderProcessReleaseId
    amount
    releaseAmt
    collectionBatch
    isCheck
    title
    purchaserName
    billingStageName
  }
}
    `;

/**
 * __useGetStakeholderReleaseUnitQuery__
 *
 * To run a query within a React component, call `useGetStakeholderReleaseUnitQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStakeholderReleaseUnitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStakeholderReleaseUnitQuery({
 *   variables: {
 *      solicitorId: // value for 'solicitorId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetStakeholderReleaseUnitQuery(baseOptions: Apollo.QueryHookOptions<GetStakeholderReleaseUnitQuery, GetStakeholderReleaseUnitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStakeholderReleaseUnitQuery, GetStakeholderReleaseUnitQueryVariables>(GetStakeholderReleaseUnitDocument, options);
      }
export function useGetStakeholderReleaseUnitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStakeholderReleaseUnitQuery, GetStakeholderReleaseUnitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStakeholderReleaseUnitQuery, GetStakeholderReleaseUnitQueryVariables>(GetStakeholderReleaseUnitDocument, options);
        }
export type GetStakeholderReleaseUnitQueryHookResult = ReturnType<typeof useGetStakeholderReleaseUnitQuery>;
export type GetStakeholderReleaseUnitLazyQueryHookResult = ReturnType<typeof useGetStakeholderReleaseUnitLazyQuery>;
export type GetStakeholderReleaseUnitQueryResult = Apollo.QueryResult<GetStakeholderReleaseUnitQuery, GetStakeholderReleaseUnitQueryVariables>;
export const AddReleaseCollectedDocument = gql`
    mutation addReleaseCollected($input: releaseCollectedInput!) {
  addReleaseCollected(input: $input)
}
    `;
export type AddReleaseCollectedMutationFn = Apollo.MutationFunction<AddReleaseCollectedMutation, AddReleaseCollectedMutationVariables>;

/**
 * __useAddReleaseCollectedMutation__
 *
 * To run a mutation, you first call `useAddReleaseCollectedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddReleaseCollectedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addReleaseCollectedMutation, { data, loading, error }] = useAddReleaseCollectedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddReleaseCollectedMutation(baseOptions?: Apollo.MutationHookOptions<AddReleaseCollectedMutation, AddReleaseCollectedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddReleaseCollectedMutation, AddReleaseCollectedMutationVariables>(AddReleaseCollectedDocument, options);
      }
export type AddReleaseCollectedMutationHookResult = ReturnType<typeof useAddReleaseCollectedMutation>;
export type AddReleaseCollectedMutationResult = Apollo.MutationResult<AddReleaseCollectedMutation>;
export type AddReleaseCollectedMutationOptions = Apollo.BaseMutationOptions<AddReleaseCollectedMutation, AddReleaseCollectedMutationVariables>;
export const EditReleaseCollectedDocument = gql`
    mutation editReleaseCollected($input: EditReleaseCollectedInput!) {
  editReleaseCollected(input: $input)
}
    `;
export type EditReleaseCollectedMutationFn = Apollo.MutationFunction<EditReleaseCollectedMutation, EditReleaseCollectedMutationVariables>;

/**
 * __useEditReleaseCollectedMutation__
 *
 * To run a mutation, you first call `useEditReleaseCollectedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditReleaseCollectedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editReleaseCollectedMutation, { data, loading, error }] = useEditReleaseCollectedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditReleaseCollectedMutation(baseOptions?: Apollo.MutationHookOptions<EditReleaseCollectedMutation, EditReleaseCollectedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditReleaseCollectedMutation, EditReleaseCollectedMutationVariables>(EditReleaseCollectedDocument, options);
      }
export type EditReleaseCollectedMutationHookResult = ReturnType<typeof useEditReleaseCollectedMutation>;
export type EditReleaseCollectedMutationResult = Apollo.MutationResult<EditReleaseCollectedMutation>;
export type EditReleaseCollectedMutationOptions = Apollo.BaseMutationOptions<EditReleaseCollectedMutation, EditReleaseCollectedMutationVariables>;
export const GetStakeholderReleaseDetailDocument = gql`
    query getStakeholderReleaseDetail($solicitorId: String!, $stakeholderReleaseId: String!) {
  getStakeholderReleaseDetail(stakeholderReleaseId: $stakeholderReleaseId, solicitorId: $solicitorId) {
    stakeholderReleaseId
    solicitorId
    releaseDate
    releaseMethod
    releaseReferenceNo
    releaseRemark
    attachments {
      attachmentId
      fileName
      resourceUrl
      mediaType
    }
    overdueRelease {
      dueDate
      saleCount
      totalReleaseAmt
      overdueReleaseUnitDetail {
        saleId
        unitNo
        releaseAmt
      }
    }
  }
}
    `;

/**
 * __useGetStakeholderReleaseDetailQuery__
 *
 * To run a query within a React component, call `useGetStakeholderReleaseDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStakeholderReleaseDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStakeholderReleaseDetailQuery({
 *   variables: {
 *      solicitorId: // value for 'solicitorId'
 *      stakeholderReleaseId: // value for 'stakeholderReleaseId'
 *   },
 * });
 */
export function useGetStakeholderReleaseDetailQuery(baseOptions: Apollo.QueryHookOptions<GetStakeholderReleaseDetailQuery, GetStakeholderReleaseDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStakeholderReleaseDetailQuery, GetStakeholderReleaseDetailQueryVariables>(GetStakeholderReleaseDetailDocument, options);
      }
export function useGetStakeholderReleaseDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStakeholderReleaseDetailQuery, GetStakeholderReleaseDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStakeholderReleaseDetailQuery, GetStakeholderReleaseDetailQueryVariables>(GetStakeholderReleaseDetailDocument, options);
        }
export type GetStakeholderReleaseDetailQueryHookResult = ReturnType<typeof useGetStakeholderReleaseDetailQuery>;
export type GetStakeholderReleaseDetailLazyQueryHookResult = ReturnType<typeof useGetStakeholderReleaseDetailLazyQuery>;
export type GetStakeholderReleaseDetailQueryResult = Apollo.QueryResult<GetStakeholderReleaseDetailQuery, GetStakeholderReleaseDetailQueryVariables>;
export const DeleteReleaseDataDocument = gql`
    mutation deleteReleaseData($id: String!) {
  deleteReleaseData(id: $id)
}
    `;
export type DeleteReleaseDataMutationFn = Apollo.MutationFunction<DeleteReleaseDataMutation, DeleteReleaseDataMutationVariables>;

/**
 * __useDeleteReleaseDataMutation__
 *
 * To run a mutation, you first call `useDeleteReleaseDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReleaseDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReleaseDataMutation, { data, loading, error }] = useDeleteReleaseDataMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteReleaseDataMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReleaseDataMutation, DeleteReleaseDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReleaseDataMutation, DeleteReleaseDataMutationVariables>(DeleteReleaseDataDocument, options);
      }
export type DeleteReleaseDataMutationHookResult = ReturnType<typeof useDeleteReleaseDataMutation>;
export type DeleteReleaseDataMutationResult = Apollo.MutationResult<DeleteReleaseDataMutation>;
export type DeleteReleaseDataMutationOptions = Apollo.BaseMutationOptions<DeleteReleaseDataMutation, DeleteReleaseDataMutationVariables>;
export const GetAllPropertyTypeDocument = gql`
    query getAllPropertyType {
  getAllPropertyType {
    id
    name
    commonStatus
    defaulted
    commercialPurpose
    landPlots
    commercialPurposeDesc
    propertyTypeExt {
      id
    }
    isDeletable
    isExistInMasterData
    isExistInTransactionData
  }
}
    `;

/**
 * __useGetAllPropertyTypeQuery__
 *
 * To run a query within a React component, call `useGetAllPropertyTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPropertyTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPropertyTypeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllPropertyTypeQuery(baseOptions?: Apollo.QueryHookOptions<GetAllPropertyTypeQuery, GetAllPropertyTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllPropertyTypeQuery, GetAllPropertyTypeQueryVariables>(GetAllPropertyTypeDocument, options);
      }
export function useGetAllPropertyTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllPropertyTypeQuery, GetAllPropertyTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllPropertyTypeQuery, GetAllPropertyTypeQueryVariables>(GetAllPropertyTypeDocument, options);
        }
export type GetAllPropertyTypeQueryHookResult = ReturnType<typeof useGetAllPropertyTypeQuery>;
export type GetAllPropertyTypeLazyQueryHookResult = ReturnType<typeof useGetAllPropertyTypeLazyQuery>;
export type GetAllPropertyTypeQueryResult = Apollo.QueryResult<GetAllPropertyTypeQuery, GetAllPropertyTypeQueryVariables>;
export const GetPropertyTypeExtDocument = gql`
    query getPropertyTypeExt {
  getPropertyTypeExt {
    id
    propertyTypeId
  }
}
    `;

/**
 * __useGetPropertyTypeExtQuery__
 *
 * To run a query within a React component, call `useGetPropertyTypeExtQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertyTypeExtQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertyTypeExtQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPropertyTypeExtQuery(baseOptions?: Apollo.QueryHookOptions<GetPropertyTypeExtQuery, GetPropertyTypeExtQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertyTypeExtQuery, GetPropertyTypeExtQueryVariables>(GetPropertyTypeExtDocument, options);
      }
export function useGetPropertyTypeExtLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertyTypeExtQuery, GetPropertyTypeExtQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertyTypeExtQuery, GetPropertyTypeExtQueryVariables>(GetPropertyTypeExtDocument, options);
        }
export type GetPropertyTypeExtQueryHookResult = ReturnType<typeof useGetPropertyTypeExtQuery>;
export type GetPropertyTypeExtLazyQueryHookResult = ReturnType<typeof useGetPropertyTypeExtLazyQuery>;
export type GetPropertyTypeExtQueryResult = Apollo.QueryResult<GetPropertyTypeExtQuery, GetPropertyTypeExtQueryVariables>;
export const GetPropertyTaxDocument = gql`
    query getPropertyTax {
  getPropertyTax {
    id
    code
    description
    classType
  }
}
    `;

/**
 * __useGetPropertyTaxQuery__
 *
 * To run a query within a React component, call `useGetPropertyTaxQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertyTaxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertyTaxQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPropertyTaxQuery(baseOptions?: Apollo.QueryHookOptions<GetPropertyTaxQuery, GetPropertyTaxQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertyTaxQuery, GetPropertyTaxQueryVariables>(GetPropertyTaxDocument, options);
      }
export function useGetPropertyTaxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertyTaxQuery, GetPropertyTaxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertyTaxQuery, GetPropertyTaxQueryVariables>(GetPropertyTaxDocument, options);
        }
export type GetPropertyTaxQueryHookResult = ReturnType<typeof useGetPropertyTaxQuery>;
export type GetPropertyTaxLazyQueryHookResult = ReturnType<typeof useGetPropertyTaxLazyQuery>;
export type GetPropertyTaxQueryResult = Apollo.QueryResult<GetPropertyTaxQuery, GetPropertyTaxQueryVariables>;
export const GetPropertyTaxByInputDocument = gql`
    query getPropertyTaxByInput {
  getPropertyTaxByInput {
    id
    code
    description
    classType
  }
}
    `;

/**
 * __useGetPropertyTaxByInputQuery__
 *
 * To run a query within a React component, call `useGetPropertyTaxByInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertyTaxByInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertyTaxByInputQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPropertyTaxByInputQuery(baseOptions?: Apollo.QueryHookOptions<GetPropertyTaxByInputQuery, GetPropertyTaxByInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertyTaxByInputQuery, GetPropertyTaxByInputQueryVariables>(GetPropertyTaxByInputDocument, options);
      }
export function useGetPropertyTaxByInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertyTaxByInputQuery, GetPropertyTaxByInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertyTaxByInputQuery, GetPropertyTaxByInputQueryVariables>(GetPropertyTaxByInputDocument, options);
        }
export type GetPropertyTaxByInputQueryHookResult = ReturnType<typeof useGetPropertyTaxByInputQuery>;
export type GetPropertyTaxByInputLazyQueryHookResult = ReturnType<typeof useGetPropertyTaxByInputLazyQuery>;
export type GetPropertyTaxByInputQueryResult = Apollo.QueryResult<GetPropertyTaxByInputQuery, GetPropertyTaxByInputQueryVariables>;
export const AddPropertyTypeDocument = gql`
    mutation addPropertyType($input: PropertyTypeInput!) {
  addPropertyType(input: $input)
}
    `;
export type AddPropertyTypeMutationFn = Apollo.MutationFunction<AddPropertyTypeMutation, AddPropertyTypeMutationVariables>;

/**
 * __useAddPropertyTypeMutation__
 *
 * To run a mutation, you first call `useAddPropertyTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPropertyTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPropertyTypeMutation, { data, loading, error }] = useAddPropertyTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPropertyTypeMutation(baseOptions?: Apollo.MutationHookOptions<AddPropertyTypeMutation, AddPropertyTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPropertyTypeMutation, AddPropertyTypeMutationVariables>(AddPropertyTypeDocument, options);
      }
export type AddPropertyTypeMutationHookResult = ReturnType<typeof useAddPropertyTypeMutation>;
export type AddPropertyTypeMutationResult = Apollo.MutationResult<AddPropertyTypeMutation>;
export type AddPropertyTypeMutationOptions = Apollo.BaseMutationOptions<AddPropertyTypeMutation, AddPropertyTypeMutationVariables>;
export const EditPropertyTypeDocument = gql`
    mutation editPropertyType($input: EditPropertyTypeInput!) {
  editPropertyType(input: $input)
}
    `;
export type EditPropertyTypeMutationFn = Apollo.MutationFunction<EditPropertyTypeMutation, EditPropertyTypeMutationVariables>;

/**
 * __useEditPropertyTypeMutation__
 *
 * To run a mutation, you first call `useEditPropertyTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPropertyTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPropertyTypeMutation, { data, loading, error }] = useEditPropertyTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditPropertyTypeMutation(baseOptions?: Apollo.MutationHookOptions<EditPropertyTypeMutation, EditPropertyTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditPropertyTypeMutation, EditPropertyTypeMutationVariables>(EditPropertyTypeDocument, options);
      }
export type EditPropertyTypeMutationHookResult = ReturnType<typeof useEditPropertyTypeMutation>;
export type EditPropertyTypeMutationResult = Apollo.MutationResult<EditPropertyTypeMutation>;
export type EditPropertyTypeMutationOptions = Apollo.BaseMutationOptions<EditPropertyTypeMutation, EditPropertyTypeMutationVariables>;
export const DeletePropertyTypeByIdDocument = gql`
    mutation deletePropertyTypeById($propertyTypeId: String!, $isDeletable: Boolean!) {
  deletePropertyTypeById(propertyTypeId: $propertyTypeId, isDeletable: $isDeletable)
}
    `;
export type DeletePropertyTypeByIdMutationFn = Apollo.MutationFunction<DeletePropertyTypeByIdMutation, DeletePropertyTypeByIdMutationVariables>;

/**
 * __useDeletePropertyTypeByIdMutation__
 *
 * To run a mutation, you first call `useDeletePropertyTypeByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePropertyTypeByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePropertyTypeByIdMutation, { data, loading, error }] = useDeletePropertyTypeByIdMutation({
 *   variables: {
 *      propertyTypeId: // value for 'propertyTypeId'
 *      isDeletable: // value for 'isDeletable'
 *   },
 * });
 */
export function useDeletePropertyTypeByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeletePropertyTypeByIdMutation, DeletePropertyTypeByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePropertyTypeByIdMutation, DeletePropertyTypeByIdMutationVariables>(DeletePropertyTypeByIdDocument, options);
      }
export type DeletePropertyTypeByIdMutationHookResult = ReturnType<typeof useDeletePropertyTypeByIdMutation>;
export type DeletePropertyTypeByIdMutationResult = Apollo.MutationResult<DeletePropertyTypeByIdMutation>;
export type DeletePropertyTypeByIdMutationOptions = Apollo.BaseMutationOptions<DeletePropertyTypeByIdMutation, DeletePropertyTypeByIdMutationVariables>;
export const ActivatePropertyTypeByIdDocument = gql`
    mutation activatePropertyTypeById($propertyTypeId: String!) {
  activatePropertyTypeById(propertyTypeId: $propertyTypeId)
}
    `;
export type ActivatePropertyTypeByIdMutationFn = Apollo.MutationFunction<ActivatePropertyTypeByIdMutation, ActivatePropertyTypeByIdMutationVariables>;

/**
 * __useActivatePropertyTypeByIdMutation__
 *
 * To run a mutation, you first call `useActivatePropertyTypeByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivatePropertyTypeByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activatePropertyTypeByIdMutation, { data, loading, error }] = useActivatePropertyTypeByIdMutation({
 *   variables: {
 *      propertyTypeId: // value for 'propertyTypeId'
 *   },
 * });
 */
export function useActivatePropertyTypeByIdMutation(baseOptions?: Apollo.MutationHookOptions<ActivatePropertyTypeByIdMutation, ActivatePropertyTypeByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivatePropertyTypeByIdMutation, ActivatePropertyTypeByIdMutationVariables>(ActivatePropertyTypeByIdDocument, options);
      }
export type ActivatePropertyTypeByIdMutationHookResult = ReturnType<typeof useActivatePropertyTypeByIdMutation>;
export type ActivatePropertyTypeByIdMutationResult = Apollo.MutationResult<ActivatePropertyTypeByIdMutation>;
export type ActivatePropertyTypeByIdMutationOptions = Apollo.BaseMutationOptions<ActivatePropertyTypeByIdMutation, ActivatePropertyTypeByIdMutationVariables>;
export const SetDefaultPropertyTypeDocument = gql`
    mutation setDefaultPropertyType($propertyTypeId: String!) {
  setDefaultPropertyType(propertyTypeId: $propertyTypeId)
}
    `;
export type SetDefaultPropertyTypeMutationFn = Apollo.MutationFunction<SetDefaultPropertyTypeMutation, SetDefaultPropertyTypeMutationVariables>;

/**
 * __useSetDefaultPropertyTypeMutation__
 *
 * To run a mutation, you first call `useSetDefaultPropertyTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultPropertyTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultPropertyTypeMutation, { data, loading, error }] = useSetDefaultPropertyTypeMutation({
 *   variables: {
 *      propertyTypeId: // value for 'propertyTypeId'
 *   },
 * });
 */
export function useSetDefaultPropertyTypeMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultPropertyTypeMutation, SetDefaultPropertyTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultPropertyTypeMutation, SetDefaultPropertyTypeMutationVariables>(SetDefaultPropertyTypeDocument, options);
      }
export type SetDefaultPropertyTypeMutationHookResult = ReturnType<typeof useSetDefaultPropertyTypeMutation>;
export type SetDefaultPropertyTypeMutationResult = Apollo.MutationResult<SetDefaultPropertyTypeMutation>;
export type SetDefaultPropertyTypeMutationOptions = Apollo.BaseMutationOptions<SetDefaultPropertyTypeMutation, SetDefaultPropertyTypeMutationVariables>;
export const RemoveDefaultPropertyTypeDocument = gql`
    mutation removeDefaultPropertyType($propertyTypeId: String!) {
  removeDefaultPropertyType(propertyTypeId: $propertyTypeId)
}
    `;
export type RemoveDefaultPropertyTypeMutationFn = Apollo.MutationFunction<RemoveDefaultPropertyTypeMutation, RemoveDefaultPropertyTypeMutationVariables>;

/**
 * __useRemoveDefaultPropertyTypeMutation__
 *
 * To run a mutation, you first call `useRemoveDefaultPropertyTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDefaultPropertyTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDefaultPropertyTypeMutation, { data, loading, error }] = useRemoveDefaultPropertyTypeMutation({
 *   variables: {
 *      propertyTypeId: // value for 'propertyTypeId'
 *   },
 * });
 */
export function useRemoveDefaultPropertyTypeMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDefaultPropertyTypeMutation, RemoveDefaultPropertyTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveDefaultPropertyTypeMutation, RemoveDefaultPropertyTypeMutationVariables>(RemoveDefaultPropertyTypeDocument, options);
      }
export type RemoveDefaultPropertyTypeMutationHookResult = ReturnType<typeof useRemoveDefaultPropertyTypeMutation>;
export type RemoveDefaultPropertyTypeMutationResult = Apollo.MutationResult<RemoveDefaultPropertyTypeMutation>;
export type RemoveDefaultPropertyTypeMutationOptions = Apollo.BaseMutationOptions<RemoveDefaultPropertyTypeMutation, RemoveDefaultPropertyTypeMutationVariables>;
export const OrganizePropertyTypeDocument = gql`
    mutation organizePropertyType($propertyTypeId: [String!]!) {
  organizePropertyType(propertyTypeId: $propertyTypeId)
}
    `;
export type OrganizePropertyTypeMutationFn = Apollo.MutationFunction<OrganizePropertyTypeMutation, OrganizePropertyTypeMutationVariables>;

/**
 * __useOrganizePropertyTypeMutation__
 *
 * To run a mutation, you first call `useOrganizePropertyTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizePropertyTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizePropertyTypeMutation, { data, loading, error }] = useOrganizePropertyTypeMutation({
 *   variables: {
 *      propertyTypeId: // value for 'propertyTypeId'
 *   },
 * });
 */
export function useOrganizePropertyTypeMutation(baseOptions?: Apollo.MutationHookOptions<OrganizePropertyTypeMutation, OrganizePropertyTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizePropertyTypeMutation, OrganizePropertyTypeMutationVariables>(OrganizePropertyTypeDocument, options);
      }
export type OrganizePropertyTypeMutationHookResult = ReturnType<typeof useOrganizePropertyTypeMutation>;
export type OrganizePropertyTypeMutationResult = Apollo.MutationResult<OrganizePropertyTypeMutation>;
export type OrganizePropertyTypeMutationOptions = Apollo.BaseMutationOptions<OrganizePropertyTypeMutation, OrganizePropertyTypeMutationVariables>;
export const GetAllProjectTypeDocument = gql`
    query getAllProjectType {
  getAllProjectType {
    id
    name
    commonStatus
    defaulted
    isDeletable
    isExistInMasterData
    isExistInTransactionData
  }
}
    `;

/**
 * __useGetAllProjectTypeQuery__
 *
 * To run a query within a React component, call `useGetAllProjectTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllProjectTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllProjectTypeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllProjectTypeQuery(baseOptions?: Apollo.QueryHookOptions<GetAllProjectTypeQuery, GetAllProjectTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllProjectTypeQuery, GetAllProjectTypeQueryVariables>(GetAllProjectTypeDocument, options);
      }
export function useGetAllProjectTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllProjectTypeQuery, GetAllProjectTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllProjectTypeQuery, GetAllProjectTypeQueryVariables>(GetAllProjectTypeDocument, options);
        }
export type GetAllProjectTypeQueryHookResult = ReturnType<typeof useGetAllProjectTypeQuery>;
export type GetAllProjectTypeLazyQueryHookResult = ReturnType<typeof useGetAllProjectTypeLazyQuery>;
export type GetAllProjectTypeQueryResult = Apollo.QueryResult<GetAllProjectTypeQuery, GetAllProjectTypeQueryVariables>;
export const AddProjectTypeDocument = gql`
    mutation addProjectType($input: ProjectTypeInput!) {
  addProjectType(input: $input)
}
    `;
export type AddProjectTypeMutationFn = Apollo.MutationFunction<AddProjectTypeMutation, AddProjectTypeMutationVariables>;

/**
 * __useAddProjectTypeMutation__
 *
 * To run a mutation, you first call `useAddProjectTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProjectTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProjectTypeMutation, { data, loading, error }] = useAddProjectTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddProjectTypeMutation(baseOptions?: Apollo.MutationHookOptions<AddProjectTypeMutation, AddProjectTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProjectTypeMutation, AddProjectTypeMutationVariables>(AddProjectTypeDocument, options);
      }
export type AddProjectTypeMutationHookResult = ReturnType<typeof useAddProjectTypeMutation>;
export type AddProjectTypeMutationResult = Apollo.MutationResult<AddProjectTypeMutation>;
export type AddProjectTypeMutationOptions = Apollo.BaseMutationOptions<AddProjectTypeMutation, AddProjectTypeMutationVariables>;
export const EditProjectTypeDocument = gql`
    mutation editProjectType($input: EditProjectTypeInput!) {
  editProjectType(input: $input)
}
    `;
export type EditProjectTypeMutationFn = Apollo.MutationFunction<EditProjectTypeMutation, EditProjectTypeMutationVariables>;

/**
 * __useEditProjectTypeMutation__
 *
 * To run a mutation, you first call `useEditProjectTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditProjectTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editProjectTypeMutation, { data, loading, error }] = useEditProjectTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditProjectTypeMutation(baseOptions?: Apollo.MutationHookOptions<EditProjectTypeMutation, EditProjectTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditProjectTypeMutation, EditProjectTypeMutationVariables>(EditProjectTypeDocument, options);
      }
export type EditProjectTypeMutationHookResult = ReturnType<typeof useEditProjectTypeMutation>;
export type EditProjectTypeMutationResult = Apollo.MutationResult<EditProjectTypeMutation>;
export type EditProjectTypeMutationOptions = Apollo.BaseMutationOptions<EditProjectTypeMutation, EditProjectTypeMutationVariables>;
export const DeleteProjectTypeByIdDocument = gql`
    mutation deleteProjectTypeById($projectTypeId: String!, $isDeletable: Boolean!) {
  deleteProjectTypeById(projectTypeId: $projectTypeId, isDeletable: $isDeletable)
}
    `;
export type DeleteProjectTypeByIdMutationFn = Apollo.MutationFunction<DeleteProjectTypeByIdMutation, DeleteProjectTypeByIdMutationVariables>;

/**
 * __useDeleteProjectTypeByIdMutation__
 *
 * To run a mutation, you first call `useDeleteProjectTypeByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectTypeByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectTypeByIdMutation, { data, loading, error }] = useDeleteProjectTypeByIdMutation({
 *   variables: {
 *      projectTypeId: // value for 'projectTypeId'
 *      isDeletable: // value for 'isDeletable'
 *   },
 * });
 */
export function useDeleteProjectTypeByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectTypeByIdMutation, DeleteProjectTypeByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectTypeByIdMutation, DeleteProjectTypeByIdMutationVariables>(DeleteProjectTypeByIdDocument, options);
      }
export type DeleteProjectTypeByIdMutationHookResult = ReturnType<typeof useDeleteProjectTypeByIdMutation>;
export type DeleteProjectTypeByIdMutationResult = Apollo.MutationResult<DeleteProjectTypeByIdMutation>;
export type DeleteProjectTypeByIdMutationOptions = Apollo.BaseMutationOptions<DeleteProjectTypeByIdMutation, DeleteProjectTypeByIdMutationVariables>;
export const ActivateProjectTypeByIdDocument = gql`
    mutation activateProjectTypeById($projectTypeId: String!) {
  activateProjectTypeById(projectTypeId: $projectTypeId)
}
    `;
export type ActivateProjectTypeByIdMutationFn = Apollo.MutationFunction<ActivateProjectTypeByIdMutation, ActivateProjectTypeByIdMutationVariables>;

/**
 * __useActivateProjectTypeByIdMutation__
 *
 * To run a mutation, you first call `useActivateProjectTypeByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateProjectTypeByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateProjectTypeByIdMutation, { data, loading, error }] = useActivateProjectTypeByIdMutation({
 *   variables: {
 *      projectTypeId: // value for 'projectTypeId'
 *   },
 * });
 */
export function useActivateProjectTypeByIdMutation(baseOptions?: Apollo.MutationHookOptions<ActivateProjectTypeByIdMutation, ActivateProjectTypeByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateProjectTypeByIdMutation, ActivateProjectTypeByIdMutationVariables>(ActivateProjectTypeByIdDocument, options);
      }
export type ActivateProjectTypeByIdMutationHookResult = ReturnType<typeof useActivateProjectTypeByIdMutation>;
export type ActivateProjectTypeByIdMutationResult = Apollo.MutationResult<ActivateProjectTypeByIdMutation>;
export type ActivateProjectTypeByIdMutationOptions = Apollo.BaseMutationOptions<ActivateProjectTypeByIdMutation, ActivateProjectTypeByIdMutationVariables>;
export const SetDefaultProjectTypeDocument = gql`
    mutation setDefaultProjectType($projectTypeId: String!) {
  setDefaultProjectType(projectTypeId: $projectTypeId)
}
    `;
export type SetDefaultProjectTypeMutationFn = Apollo.MutationFunction<SetDefaultProjectTypeMutation, SetDefaultProjectTypeMutationVariables>;

/**
 * __useSetDefaultProjectTypeMutation__
 *
 * To run a mutation, you first call `useSetDefaultProjectTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultProjectTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultProjectTypeMutation, { data, loading, error }] = useSetDefaultProjectTypeMutation({
 *   variables: {
 *      projectTypeId: // value for 'projectTypeId'
 *   },
 * });
 */
export function useSetDefaultProjectTypeMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultProjectTypeMutation, SetDefaultProjectTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultProjectTypeMutation, SetDefaultProjectTypeMutationVariables>(SetDefaultProjectTypeDocument, options);
      }
export type SetDefaultProjectTypeMutationHookResult = ReturnType<typeof useSetDefaultProjectTypeMutation>;
export type SetDefaultProjectTypeMutationResult = Apollo.MutationResult<SetDefaultProjectTypeMutation>;
export type SetDefaultProjectTypeMutationOptions = Apollo.BaseMutationOptions<SetDefaultProjectTypeMutation, SetDefaultProjectTypeMutationVariables>;
export const RemoveDefaultProjectTypeDocument = gql`
    mutation removeDefaultProjectType($projectTypeId: String!) {
  removeDefaultProjectType(projectTypeId: $projectTypeId)
}
    `;
export type RemoveDefaultProjectTypeMutationFn = Apollo.MutationFunction<RemoveDefaultProjectTypeMutation, RemoveDefaultProjectTypeMutationVariables>;

/**
 * __useRemoveDefaultProjectTypeMutation__
 *
 * To run a mutation, you first call `useRemoveDefaultProjectTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDefaultProjectTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDefaultProjectTypeMutation, { data, loading, error }] = useRemoveDefaultProjectTypeMutation({
 *   variables: {
 *      projectTypeId: // value for 'projectTypeId'
 *   },
 * });
 */
export function useRemoveDefaultProjectTypeMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDefaultProjectTypeMutation, RemoveDefaultProjectTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveDefaultProjectTypeMutation, RemoveDefaultProjectTypeMutationVariables>(RemoveDefaultProjectTypeDocument, options);
      }
export type RemoveDefaultProjectTypeMutationHookResult = ReturnType<typeof useRemoveDefaultProjectTypeMutation>;
export type RemoveDefaultProjectTypeMutationResult = Apollo.MutationResult<RemoveDefaultProjectTypeMutation>;
export type RemoveDefaultProjectTypeMutationOptions = Apollo.BaseMutationOptions<RemoveDefaultProjectTypeMutation, RemoveDefaultProjectTypeMutationVariables>;
export const OrganizeProjectTypeDocument = gql`
    mutation organizeProjectType($projectTypeId: [String!]!) {
  organizeProjectType(projectTypeId: $projectTypeId)
}
    `;
export type OrganizeProjectTypeMutationFn = Apollo.MutationFunction<OrganizeProjectTypeMutation, OrganizeProjectTypeMutationVariables>;

/**
 * __useOrganizeProjectTypeMutation__
 *
 * To run a mutation, you first call `useOrganizeProjectTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizeProjectTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizeProjectTypeMutation, { data, loading, error }] = useOrganizeProjectTypeMutation({
 *   variables: {
 *      projectTypeId: // value for 'projectTypeId'
 *   },
 * });
 */
export function useOrganizeProjectTypeMutation(baseOptions?: Apollo.MutationHookOptions<OrganizeProjectTypeMutation, OrganizeProjectTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizeProjectTypeMutation, OrganizeProjectTypeMutationVariables>(OrganizeProjectTypeDocument, options);
      }
export type OrganizeProjectTypeMutationHookResult = ReturnType<typeof useOrganizeProjectTypeMutation>;
export type OrganizeProjectTypeMutationResult = Apollo.MutationResult<OrganizeProjectTypeMutation>;
export type OrganizeProjectTypeMutationOptions = Apollo.BaseMutationOptions<OrganizeProjectTypeMutation, OrganizeProjectTypeMutationVariables>;
export const GetAllMaritalStatusDocument = gql`
    query getAllMaritalStatus {
  getAllMaritalStatus {
    id
    name
    commonStatus
    defaulted
    isDeletable
    isExistInTransactionData
  }
}
    `;

/**
 * __useGetAllMaritalStatusQuery__
 *
 * To run a query within a React component, call `useGetAllMaritalStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllMaritalStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllMaritalStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllMaritalStatusQuery(baseOptions?: Apollo.QueryHookOptions<GetAllMaritalStatusQuery, GetAllMaritalStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllMaritalStatusQuery, GetAllMaritalStatusQueryVariables>(GetAllMaritalStatusDocument, options);
      }
export function useGetAllMaritalStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllMaritalStatusQuery, GetAllMaritalStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllMaritalStatusQuery, GetAllMaritalStatusQueryVariables>(GetAllMaritalStatusDocument, options);
        }
export type GetAllMaritalStatusQueryHookResult = ReturnType<typeof useGetAllMaritalStatusQuery>;
export type GetAllMaritalStatusLazyQueryHookResult = ReturnType<typeof useGetAllMaritalStatusLazyQuery>;
export type GetAllMaritalStatusQueryResult = Apollo.QueryResult<GetAllMaritalStatusQuery, GetAllMaritalStatusQueryVariables>;
export const EditMaritalStatusDocument = gql`
    mutation editMaritalStatus($input: EditMaritalStatusInput!) {
  editMaritalStatus(input: $input)
}
    `;
export type EditMaritalStatusMutationFn = Apollo.MutationFunction<EditMaritalStatusMutation, EditMaritalStatusMutationVariables>;

/**
 * __useEditMaritalStatusMutation__
 *
 * To run a mutation, you first call `useEditMaritalStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditMaritalStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editMaritalStatusMutation, { data, loading, error }] = useEditMaritalStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditMaritalStatusMutation(baseOptions?: Apollo.MutationHookOptions<EditMaritalStatusMutation, EditMaritalStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditMaritalStatusMutation, EditMaritalStatusMutationVariables>(EditMaritalStatusDocument, options);
      }
export type EditMaritalStatusMutationHookResult = ReturnType<typeof useEditMaritalStatusMutation>;
export type EditMaritalStatusMutationResult = Apollo.MutationResult<EditMaritalStatusMutation>;
export type EditMaritalStatusMutationOptions = Apollo.BaseMutationOptions<EditMaritalStatusMutation, EditMaritalStatusMutationVariables>;
export const AddMaritalStatusDocument = gql`
    mutation addMaritalStatus($input: MaritalStatusInput!) {
  addMaritalStatus(input: $input)
}
    `;
export type AddMaritalStatusMutationFn = Apollo.MutationFunction<AddMaritalStatusMutation, AddMaritalStatusMutationVariables>;

/**
 * __useAddMaritalStatusMutation__
 *
 * To run a mutation, you first call `useAddMaritalStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMaritalStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMaritalStatusMutation, { data, loading, error }] = useAddMaritalStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddMaritalStatusMutation(baseOptions?: Apollo.MutationHookOptions<AddMaritalStatusMutation, AddMaritalStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMaritalStatusMutation, AddMaritalStatusMutationVariables>(AddMaritalStatusDocument, options);
      }
export type AddMaritalStatusMutationHookResult = ReturnType<typeof useAddMaritalStatusMutation>;
export type AddMaritalStatusMutationResult = Apollo.MutationResult<AddMaritalStatusMutation>;
export type AddMaritalStatusMutationOptions = Apollo.BaseMutationOptions<AddMaritalStatusMutation, AddMaritalStatusMutationVariables>;
export const DeleteMaritalStatusByIdDocument = gql`
    mutation deleteMaritalStatusById($maritalStatusId: String!) {
  deleteMaritalStatusById(maritalStatusId: $maritalStatusId)
}
    `;
export type DeleteMaritalStatusByIdMutationFn = Apollo.MutationFunction<DeleteMaritalStatusByIdMutation, DeleteMaritalStatusByIdMutationVariables>;

/**
 * __useDeleteMaritalStatusByIdMutation__
 *
 * To run a mutation, you first call `useDeleteMaritalStatusByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMaritalStatusByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMaritalStatusByIdMutation, { data, loading, error }] = useDeleteMaritalStatusByIdMutation({
 *   variables: {
 *      maritalStatusId: // value for 'maritalStatusId'
 *   },
 * });
 */
export function useDeleteMaritalStatusByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMaritalStatusByIdMutation, DeleteMaritalStatusByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMaritalStatusByIdMutation, DeleteMaritalStatusByIdMutationVariables>(DeleteMaritalStatusByIdDocument, options);
      }
export type DeleteMaritalStatusByIdMutationHookResult = ReturnType<typeof useDeleteMaritalStatusByIdMutation>;
export type DeleteMaritalStatusByIdMutationResult = Apollo.MutationResult<DeleteMaritalStatusByIdMutation>;
export type DeleteMaritalStatusByIdMutationOptions = Apollo.BaseMutationOptions<DeleteMaritalStatusByIdMutation, DeleteMaritalStatusByIdMutationVariables>;
export const SetDefaultMaritalStatusDocument = gql`
    mutation setDefaultMaritalStatus($maritalStatusId: String!) {
  setDefaultMaritalStatus(maritalStatusId: $maritalStatusId)
}
    `;
export type SetDefaultMaritalStatusMutationFn = Apollo.MutationFunction<SetDefaultMaritalStatusMutation, SetDefaultMaritalStatusMutationVariables>;

/**
 * __useSetDefaultMaritalStatusMutation__
 *
 * To run a mutation, you first call `useSetDefaultMaritalStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultMaritalStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultMaritalStatusMutation, { data, loading, error }] = useSetDefaultMaritalStatusMutation({
 *   variables: {
 *      maritalStatusId: // value for 'maritalStatusId'
 *   },
 * });
 */
export function useSetDefaultMaritalStatusMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultMaritalStatusMutation, SetDefaultMaritalStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultMaritalStatusMutation, SetDefaultMaritalStatusMutationVariables>(SetDefaultMaritalStatusDocument, options);
      }
export type SetDefaultMaritalStatusMutationHookResult = ReturnType<typeof useSetDefaultMaritalStatusMutation>;
export type SetDefaultMaritalStatusMutationResult = Apollo.MutationResult<SetDefaultMaritalStatusMutation>;
export type SetDefaultMaritalStatusMutationOptions = Apollo.BaseMutationOptions<SetDefaultMaritalStatusMutation, SetDefaultMaritalStatusMutationVariables>;
export const RemoveDefaultMaritalStatusDocument = gql`
    mutation removeDefaultMaritalStatus($maritalStatusId: String!) {
  removeDefaultMaritalStatus(maritalStatusId: $maritalStatusId)
}
    `;
export type RemoveDefaultMaritalStatusMutationFn = Apollo.MutationFunction<RemoveDefaultMaritalStatusMutation, RemoveDefaultMaritalStatusMutationVariables>;

/**
 * __useRemoveDefaultMaritalStatusMutation__
 *
 * To run a mutation, you first call `useRemoveDefaultMaritalStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDefaultMaritalStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDefaultMaritalStatusMutation, { data, loading, error }] = useRemoveDefaultMaritalStatusMutation({
 *   variables: {
 *      maritalStatusId: // value for 'maritalStatusId'
 *   },
 * });
 */
export function useRemoveDefaultMaritalStatusMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDefaultMaritalStatusMutation, RemoveDefaultMaritalStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveDefaultMaritalStatusMutation, RemoveDefaultMaritalStatusMutationVariables>(RemoveDefaultMaritalStatusDocument, options);
      }
export type RemoveDefaultMaritalStatusMutationHookResult = ReturnType<typeof useRemoveDefaultMaritalStatusMutation>;
export type RemoveDefaultMaritalStatusMutationResult = Apollo.MutationResult<RemoveDefaultMaritalStatusMutation>;
export type RemoveDefaultMaritalStatusMutationOptions = Apollo.BaseMutationOptions<RemoveDefaultMaritalStatusMutation, RemoveDefaultMaritalStatusMutationVariables>;
export const OrganizeMaritalStatusDocument = gql`
    mutation organizeMaritalStatus($maritalStatusIds: [String!]!) {
  organizeMaritalStatus(maritalStatusIds: $maritalStatusIds)
}
    `;
export type OrganizeMaritalStatusMutationFn = Apollo.MutationFunction<OrganizeMaritalStatusMutation, OrganizeMaritalStatusMutationVariables>;

/**
 * __useOrganizeMaritalStatusMutation__
 *
 * To run a mutation, you first call `useOrganizeMaritalStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizeMaritalStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizeMaritalStatusMutation, { data, loading, error }] = useOrganizeMaritalStatusMutation({
 *   variables: {
 *      maritalStatusIds: // value for 'maritalStatusIds'
 *   },
 * });
 */
export function useOrganizeMaritalStatusMutation(baseOptions?: Apollo.MutationHookOptions<OrganizeMaritalStatusMutation, OrganizeMaritalStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizeMaritalStatusMutation, OrganizeMaritalStatusMutationVariables>(OrganizeMaritalStatusDocument, options);
      }
export type OrganizeMaritalStatusMutationHookResult = ReturnType<typeof useOrganizeMaritalStatusMutation>;
export type OrganizeMaritalStatusMutationResult = Apollo.MutationResult<OrganizeMaritalStatusMutation>;
export type OrganizeMaritalStatusMutationOptions = Apollo.BaseMutationOptions<OrganizeMaritalStatusMutation, OrganizeMaritalStatusMutationVariables>;
export const ActivateMaritalStatusDocument = gql`
    mutation activateMaritalStatus($maritalStatusId: String!) {
  activateMaritalStatus(maritalStatusId: $maritalStatusId)
}
    `;
export type ActivateMaritalStatusMutationFn = Apollo.MutationFunction<ActivateMaritalStatusMutation, ActivateMaritalStatusMutationVariables>;

/**
 * __useActivateMaritalStatusMutation__
 *
 * To run a mutation, you first call `useActivateMaritalStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateMaritalStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateMaritalStatusMutation, { data, loading, error }] = useActivateMaritalStatusMutation({
 *   variables: {
 *      maritalStatusId: // value for 'maritalStatusId'
 *   },
 * });
 */
export function useActivateMaritalStatusMutation(baseOptions?: Apollo.MutationHookOptions<ActivateMaritalStatusMutation, ActivateMaritalStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateMaritalStatusMutation, ActivateMaritalStatusMutationVariables>(ActivateMaritalStatusDocument, options);
      }
export type ActivateMaritalStatusMutationHookResult = ReturnType<typeof useActivateMaritalStatusMutation>;
export type ActivateMaritalStatusMutationResult = Apollo.MutationResult<ActivateMaritalStatusMutation>;
export type ActivateMaritalStatusMutationOptions = Apollo.BaseMutationOptions<ActivateMaritalStatusMutation, ActivateMaritalStatusMutationVariables>;
export const DeactivateMaritalStatusDocument = gql`
    mutation deactivateMaritalStatus($maritalStatusId: String!) {
  deactivateMaritalStatus(maritalStatusId: $maritalStatusId)
}
    `;
export type DeactivateMaritalStatusMutationFn = Apollo.MutationFunction<DeactivateMaritalStatusMutation, DeactivateMaritalStatusMutationVariables>;

/**
 * __useDeactivateMaritalStatusMutation__
 *
 * To run a mutation, you first call `useDeactivateMaritalStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateMaritalStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateMaritalStatusMutation, { data, loading, error }] = useDeactivateMaritalStatusMutation({
 *   variables: {
 *      maritalStatusId: // value for 'maritalStatusId'
 *   },
 * });
 */
export function useDeactivateMaritalStatusMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateMaritalStatusMutation, DeactivateMaritalStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateMaritalStatusMutation, DeactivateMaritalStatusMutationVariables>(DeactivateMaritalStatusDocument, options);
      }
export type DeactivateMaritalStatusMutationHookResult = ReturnType<typeof useDeactivateMaritalStatusMutation>;
export type DeactivateMaritalStatusMutationResult = Apollo.MutationResult<DeactivateMaritalStatusMutation>;
export type DeactivateMaritalStatusMutationOptions = Apollo.BaseMutationOptions<DeactivateMaritalStatusMutation, DeactivateMaritalStatusMutationVariables>;
export const GetAllDirectionDocument = gql`
    query getAllDirection {
  getAllDirection {
    id
    name
    commonStatus
    defaulted
    isDeletable
    isExistInMasterData
    isExistInTransactionData
  }
}
    `;

/**
 * __useGetAllDirectionQuery__
 *
 * To run a query within a React component, call `useGetAllDirectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllDirectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllDirectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllDirectionQuery(baseOptions?: Apollo.QueryHookOptions<GetAllDirectionQuery, GetAllDirectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllDirectionQuery, GetAllDirectionQueryVariables>(GetAllDirectionDocument, options);
      }
export function useGetAllDirectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllDirectionQuery, GetAllDirectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllDirectionQuery, GetAllDirectionQueryVariables>(GetAllDirectionDocument, options);
        }
export type GetAllDirectionQueryHookResult = ReturnType<typeof useGetAllDirectionQuery>;
export type GetAllDirectionLazyQueryHookResult = ReturnType<typeof useGetAllDirectionLazyQuery>;
export type GetAllDirectionQueryResult = Apollo.QueryResult<GetAllDirectionQuery, GetAllDirectionQueryVariables>;
export const EditDirectionDocument = gql`
    mutation editDirection($input: EditDirectionInput!) {
  editDirection(input: $input)
}
    `;
export type EditDirectionMutationFn = Apollo.MutationFunction<EditDirectionMutation, EditDirectionMutationVariables>;

/**
 * __useEditDirectionMutation__
 *
 * To run a mutation, you first call `useEditDirectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditDirectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editDirectionMutation, { data, loading, error }] = useEditDirectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditDirectionMutation(baseOptions?: Apollo.MutationHookOptions<EditDirectionMutation, EditDirectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditDirectionMutation, EditDirectionMutationVariables>(EditDirectionDocument, options);
      }
export type EditDirectionMutationHookResult = ReturnType<typeof useEditDirectionMutation>;
export type EditDirectionMutationResult = Apollo.MutationResult<EditDirectionMutation>;
export type EditDirectionMutationOptions = Apollo.BaseMutationOptions<EditDirectionMutation, EditDirectionMutationVariables>;
export const AddDirectionDocument = gql`
    mutation addDirection($input: DirectionInput!) {
  addDirection(input: $input)
}
    `;
export type AddDirectionMutationFn = Apollo.MutationFunction<AddDirectionMutation, AddDirectionMutationVariables>;

/**
 * __useAddDirectionMutation__
 *
 * To run a mutation, you first call `useAddDirectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDirectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDirectionMutation, { data, loading, error }] = useAddDirectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddDirectionMutation(baseOptions?: Apollo.MutationHookOptions<AddDirectionMutation, AddDirectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDirectionMutation, AddDirectionMutationVariables>(AddDirectionDocument, options);
      }
export type AddDirectionMutationHookResult = ReturnType<typeof useAddDirectionMutation>;
export type AddDirectionMutationResult = Apollo.MutationResult<AddDirectionMutation>;
export type AddDirectionMutationOptions = Apollo.BaseMutationOptions<AddDirectionMutation, AddDirectionMutationVariables>;
export const DeleteDirectionByIdDocument = gql`
    mutation deleteDirectionById($directionId: String!, $isDeletable: Boolean!) {
  deleteDirectionById(directionId: $directionId, isDeletable: $isDeletable)
}
    `;
export type DeleteDirectionByIdMutationFn = Apollo.MutationFunction<DeleteDirectionByIdMutation, DeleteDirectionByIdMutationVariables>;

/**
 * __useDeleteDirectionByIdMutation__
 *
 * To run a mutation, you first call `useDeleteDirectionByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDirectionByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDirectionByIdMutation, { data, loading, error }] = useDeleteDirectionByIdMutation({
 *   variables: {
 *      directionId: // value for 'directionId'
 *      isDeletable: // value for 'isDeletable'
 *   },
 * });
 */
export function useDeleteDirectionByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDirectionByIdMutation, DeleteDirectionByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDirectionByIdMutation, DeleteDirectionByIdMutationVariables>(DeleteDirectionByIdDocument, options);
      }
export type DeleteDirectionByIdMutationHookResult = ReturnType<typeof useDeleteDirectionByIdMutation>;
export type DeleteDirectionByIdMutationResult = Apollo.MutationResult<DeleteDirectionByIdMutation>;
export type DeleteDirectionByIdMutationOptions = Apollo.BaseMutationOptions<DeleteDirectionByIdMutation, DeleteDirectionByIdMutationVariables>;
export const ActivateDirectionByIdDocument = gql`
    mutation activateDirectionById($directionId: String!) {
  activateDirectionById(directionId: $directionId)
}
    `;
export type ActivateDirectionByIdMutationFn = Apollo.MutationFunction<ActivateDirectionByIdMutation, ActivateDirectionByIdMutationVariables>;

/**
 * __useActivateDirectionByIdMutation__
 *
 * To run a mutation, you first call `useActivateDirectionByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateDirectionByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateDirectionByIdMutation, { data, loading, error }] = useActivateDirectionByIdMutation({
 *   variables: {
 *      directionId: // value for 'directionId'
 *   },
 * });
 */
export function useActivateDirectionByIdMutation(baseOptions?: Apollo.MutationHookOptions<ActivateDirectionByIdMutation, ActivateDirectionByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateDirectionByIdMutation, ActivateDirectionByIdMutationVariables>(ActivateDirectionByIdDocument, options);
      }
export type ActivateDirectionByIdMutationHookResult = ReturnType<typeof useActivateDirectionByIdMutation>;
export type ActivateDirectionByIdMutationResult = Apollo.MutationResult<ActivateDirectionByIdMutation>;
export type ActivateDirectionByIdMutationOptions = Apollo.BaseMutationOptions<ActivateDirectionByIdMutation, ActivateDirectionByIdMutationVariables>;
export const SetDefaultDirectionDocument = gql`
    mutation setDefaultDirection($directionId: String!) {
  setDefaultDirection(directionId: $directionId)
}
    `;
export type SetDefaultDirectionMutationFn = Apollo.MutationFunction<SetDefaultDirectionMutation, SetDefaultDirectionMutationVariables>;

/**
 * __useSetDefaultDirectionMutation__
 *
 * To run a mutation, you first call `useSetDefaultDirectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultDirectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultDirectionMutation, { data, loading, error }] = useSetDefaultDirectionMutation({
 *   variables: {
 *      directionId: // value for 'directionId'
 *   },
 * });
 */
export function useSetDefaultDirectionMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultDirectionMutation, SetDefaultDirectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultDirectionMutation, SetDefaultDirectionMutationVariables>(SetDefaultDirectionDocument, options);
      }
export type SetDefaultDirectionMutationHookResult = ReturnType<typeof useSetDefaultDirectionMutation>;
export type SetDefaultDirectionMutationResult = Apollo.MutationResult<SetDefaultDirectionMutation>;
export type SetDefaultDirectionMutationOptions = Apollo.BaseMutationOptions<SetDefaultDirectionMutation, SetDefaultDirectionMutationVariables>;
export const RemoveDefaultDirectionDocument = gql`
    mutation removeDefaultDirection($directionId: String!) {
  removeDefaultDirection(directionId: $directionId)
}
    `;
export type RemoveDefaultDirectionMutationFn = Apollo.MutationFunction<RemoveDefaultDirectionMutation, RemoveDefaultDirectionMutationVariables>;

/**
 * __useRemoveDefaultDirectionMutation__
 *
 * To run a mutation, you first call `useRemoveDefaultDirectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDefaultDirectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDefaultDirectionMutation, { data, loading, error }] = useRemoveDefaultDirectionMutation({
 *   variables: {
 *      directionId: // value for 'directionId'
 *   },
 * });
 */
export function useRemoveDefaultDirectionMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDefaultDirectionMutation, RemoveDefaultDirectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveDefaultDirectionMutation, RemoveDefaultDirectionMutationVariables>(RemoveDefaultDirectionDocument, options);
      }
export type RemoveDefaultDirectionMutationHookResult = ReturnType<typeof useRemoveDefaultDirectionMutation>;
export type RemoveDefaultDirectionMutationResult = Apollo.MutationResult<RemoveDefaultDirectionMutation>;
export type RemoveDefaultDirectionMutationOptions = Apollo.BaseMutationOptions<RemoveDefaultDirectionMutation, RemoveDefaultDirectionMutationVariables>;
export const OrganizeDirectionDocument = gql`
    mutation organizeDirection($directionId: [String!]!) {
  organizeDirection(directionId: $directionId)
}
    `;
export type OrganizeDirectionMutationFn = Apollo.MutationFunction<OrganizeDirectionMutation, OrganizeDirectionMutationVariables>;

/**
 * __useOrganizeDirectionMutation__
 *
 * To run a mutation, you first call `useOrganizeDirectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizeDirectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizeDirectionMutation, { data, loading, error }] = useOrganizeDirectionMutation({
 *   variables: {
 *      directionId: // value for 'directionId'
 *   },
 * });
 */
export function useOrganizeDirectionMutation(baseOptions?: Apollo.MutationHookOptions<OrganizeDirectionMutation, OrganizeDirectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizeDirectionMutation, OrganizeDirectionMutationVariables>(OrganizeDirectionDocument, options);
      }
export type OrganizeDirectionMutationHookResult = ReturnType<typeof useOrganizeDirectionMutation>;
export type OrganizeDirectionMutationResult = Apollo.MutationResult<OrganizeDirectionMutation>;
export type OrganizeDirectionMutationOptions = Apollo.BaseMutationOptions<OrganizeDirectionMutation, OrganizeDirectionMutationVariables>;
export const GetAllRaceDocument = gql`
    query getAllRace {
  getAllRace {
    id
    name
    commonStatus
    defaulted
    isDeletable
    isExistInMasterData
    isExistInTransactionData
  }
}
    `;

/**
 * __useGetAllRaceQuery__
 *
 * To run a query within a React component, call `useGetAllRaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRaceQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllRaceQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRaceQuery, GetAllRaceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRaceQuery, GetAllRaceQueryVariables>(GetAllRaceDocument, options);
      }
export function useGetAllRaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRaceQuery, GetAllRaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRaceQuery, GetAllRaceQueryVariables>(GetAllRaceDocument, options);
        }
export type GetAllRaceQueryHookResult = ReturnType<typeof useGetAllRaceQuery>;
export type GetAllRaceLazyQueryHookResult = ReturnType<typeof useGetAllRaceLazyQuery>;
export type GetAllRaceQueryResult = Apollo.QueryResult<GetAllRaceQuery, GetAllRaceQueryVariables>;
export const AddRaceDocument = gql`
    mutation addRace($input: RaceInput!) {
  addRace(input: $input)
}
    `;
export type AddRaceMutationFn = Apollo.MutationFunction<AddRaceMutation, AddRaceMutationVariables>;

/**
 * __useAddRaceMutation__
 *
 * To run a mutation, you first call `useAddRaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRaceMutation, { data, loading, error }] = useAddRaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddRaceMutation(baseOptions?: Apollo.MutationHookOptions<AddRaceMutation, AddRaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddRaceMutation, AddRaceMutationVariables>(AddRaceDocument, options);
      }
export type AddRaceMutationHookResult = ReturnType<typeof useAddRaceMutation>;
export type AddRaceMutationResult = Apollo.MutationResult<AddRaceMutation>;
export type AddRaceMutationOptions = Apollo.BaseMutationOptions<AddRaceMutation, AddRaceMutationVariables>;
export const EditRaceDocument = gql`
    mutation editRace($input: EditRaceInput!) {
  editRace(input: $input)
}
    `;
export type EditRaceMutationFn = Apollo.MutationFunction<EditRaceMutation, EditRaceMutationVariables>;

/**
 * __useEditRaceMutation__
 *
 * To run a mutation, you first call `useEditRaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditRaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editRaceMutation, { data, loading, error }] = useEditRaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditRaceMutation(baseOptions?: Apollo.MutationHookOptions<EditRaceMutation, EditRaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditRaceMutation, EditRaceMutationVariables>(EditRaceDocument, options);
      }
export type EditRaceMutationHookResult = ReturnType<typeof useEditRaceMutation>;
export type EditRaceMutationResult = Apollo.MutationResult<EditRaceMutation>;
export type EditRaceMutationOptions = Apollo.BaseMutationOptions<EditRaceMutation, EditRaceMutationVariables>;
export const DeleteRaceByIdDocument = gql`
    mutation deleteRaceById($raceId: String!, $isDeletable: Boolean!) {
  deleteRaceById(raceId: $raceId, isDeletable: $isDeletable)
}
    `;
export type DeleteRaceByIdMutationFn = Apollo.MutationFunction<DeleteRaceByIdMutation, DeleteRaceByIdMutationVariables>;

/**
 * __useDeleteRaceByIdMutation__
 *
 * To run a mutation, you first call `useDeleteRaceByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRaceByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRaceByIdMutation, { data, loading, error }] = useDeleteRaceByIdMutation({
 *   variables: {
 *      raceId: // value for 'raceId'
 *      isDeletable: // value for 'isDeletable'
 *   },
 * });
 */
export function useDeleteRaceByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRaceByIdMutation, DeleteRaceByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRaceByIdMutation, DeleteRaceByIdMutationVariables>(DeleteRaceByIdDocument, options);
      }
export type DeleteRaceByIdMutationHookResult = ReturnType<typeof useDeleteRaceByIdMutation>;
export type DeleteRaceByIdMutationResult = Apollo.MutationResult<DeleteRaceByIdMutation>;
export type DeleteRaceByIdMutationOptions = Apollo.BaseMutationOptions<DeleteRaceByIdMutation, DeleteRaceByIdMutationVariables>;
export const ActivateRaceByIdDocument = gql`
    mutation activateRaceById($raceId: String!) {
  activateRaceById(raceId: $raceId)
}
    `;
export type ActivateRaceByIdMutationFn = Apollo.MutationFunction<ActivateRaceByIdMutation, ActivateRaceByIdMutationVariables>;

/**
 * __useActivateRaceByIdMutation__
 *
 * To run a mutation, you first call `useActivateRaceByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateRaceByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateRaceByIdMutation, { data, loading, error }] = useActivateRaceByIdMutation({
 *   variables: {
 *      raceId: // value for 'raceId'
 *   },
 * });
 */
export function useActivateRaceByIdMutation(baseOptions?: Apollo.MutationHookOptions<ActivateRaceByIdMutation, ActivateRaceByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateRaceByIdMutation, ActivateRaceByIdMutationVariables>(ActivateRaceByIdDocument, options);
      }
export type ActivateRaceByIdMutationHookResult = ReturnType<typeof useActivateRaceByIdMutation>;
export type ActivateRaceByIdMutationResult = Apollo.MutationResult<ActivateRaceByIdMutation>;
export type ActivateRaceByIdMutationOptions = Apollo.BaseMutationOptions<ActivateRaceByIdMutation, ActivateRaceByIdMutationVariables>;
export const SetDefaultRaceDocument = gql`
    mutation setDefaultRace($raceId: String!) {
  setDefaultRace(raceId: $raceId)
}
    `;
export type SetDefaultRaceMutationFn = Apollo.MutationFunction<SetDefaultRaceMutation, SetDefaultRaceMutationVariables>;

/**
 * __useSetDefaultRaceMutation__
 *
 * To run a mutation, you first call `useSetDefaultRaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultRaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultRaceMutation, { data, loading, error }] = useSetDefaultRaceMutation({
 *   variables: {
 *      raceId: // value for 'raceId'
 *   },
 * });
 */
export function useSetDefaultRaceMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultRaceMutation, SetDefaultRaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultRaceMutation, SetDefaultRaceMutationVariables>(SetDefaultRaceDocument, options);
      }
export type SetDefaultRaceMutationHookResult = ReturnType<typeof useSetDefaultRaceMutation>;
export type SetDefaultRaceMutationResult = Apollo.MutationResult<SetDefaultRaceMutation>;
export type SetDefaultRaceMutationOptions = Apollo.BaseMutationOptions<SetDefaultRaceMutation, SetDefaultRaceMutationVariables>;
export const RemoveDefaultRaceDocument = gql`
    mutation removeDefaultRace($raceId: String!) {
  removeDefaultRace(raceId: $raceId)
}
    `;
export type RemoveDefaultRaceMutationFn = Apollo.MutationFunction<RemoveDefaultRaceMutation, RemoveDefaultRaceMutationVariables>;

/**
 * __useRemoveDefaultRaceMutation__
 *
 * To run a mutation, you first call `useRemoveDefaultRaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDefaultRaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDefaultRaceMutation, { data, loading, error }] = useRemoveDefaultRaceMutation({
 *   variables: {
 *      raceId: // value for 'raceId'
 *   },
 * });
 */
export function useRemoveDefaultRaceMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDefaultRaceMutation, RemoveDefaultRaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveDefaultRaceMutation, RemoveDefaultRaceMutationVariables>(RemoveDefaultRaceDocument, options);
      }
export type RemoveDefaultRaceMutationHookResult = ReturnType<typeof useRemoveDefaultRaceMutation>;
export type RemoveDefaultRaceMutationResult = Apollo.MutationResult<RemoveDefaultRaceMutation>;
export type RemoveDefaultRaceMutationOptions = Apollo.BaseMutationOptions<RemoveDefaultRaceMutation, RemoveDefaultRaceMutationVariables>;
export const OrganizeRaceDocument = gql`
    mutation organizeRace($raceIds: [String!]!) {
  organizeRace(raceIds: $raceIds)
}
    `;
export type OrganizeRaceMutationFn = Apollo.MutationFunction<OrganizeRaceMutation, OrganizeRaceMutationVariables>;

/**
 * __useOrganizeRaceMutation__
 *
 * To run a mutation, you first call `useOrganizeRaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizeRaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizeRaceMutation, { data, loading, error }] = useOrganizeRaceMutation({
 *   variables: {
 *      raceIds: // value for 'raceIds'
 *   },
 * });
 */
export function useOrganizeRaceMutation(baseOptions?: Apollo.MutationHookOptions<OrganizeRaceMutation, OrganizeRaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizeRaceMutation, OrganizeRaceMutationVariables>(OrganizeRaceDocument, options);
      }
export type OrganizeRaceMutationHookResult = ReturnType<typeof useOrganizeRaceMutation>;
export type OrganizeRaceMutationResult = Apollo.MutationResult<OrganizeRaceMutation>;
export type OrganizeRaceMutationOptions = Apollo.BaseMutationOptions<OrganizeRaceMutation, OrganizeRaceMutationVariables>;
export const GetAllUnitTypeDocument = gql`
    query getAllUnitType {
  getAllUnitType {
    id
    name
    commonStatus
    defaulted
    isDeletable
    isExistInMasterData
    isExistInTransactionData
  }
}
    `;

/**
 * __useGetAllUnitTypeQuery__
 *
 * To run a query within a React component, call `useGetAllUnitTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllUnitTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllUnitTypeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllUnitTypeQuery(baseOptions?: Apollo.QueryHookOptions<GetAllUnitTypeQuery, GetAllUnitTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllUnitTypeQuery, GetAllUnitTypeQueryVariables>(GetAllUnitTypeDocument, options);
      }
export function useGetAllUnitTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllUnitTypeQuery, GetAllUnitTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllUnitTypeQuery, GetAllUnitTypeQueryVariables>(GetAllUnitTypeDocument, options);
        }
export type GetAllUnitTypeQueryHookResult = ReturnType<typeof useGetAllUnitTypeQuery>;
export type GetAllUnitTypeLazyQueryHookResult = ReturnType<typeof useGetAllUnitTypeLazyQuery>;
export type GetAllUnitTypeQueryResult = Apollo.QueryResult<GetAllUnitTypeQuery, GetAllUnitTypeQueryVariables>;
export const AddUnitTypeDocument = gql`
    mutation addUnitType($input: UnitTypeInput!) {
  addUnitType(input: $input)
}
    `;
export type AddUnitTypeMutationFn = Apollo.MutationFunction<AddUnitTypeMutation, AddUnitTypeMutationVariables>;

/**
 * __useAddUnitTypeMutation__
 *
 * To run a mutation, you first call `useAddUnitTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUnitTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUnitTypeMutation, { data, loading, error }] = useAddUnitTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddUnitTypeMutation(baseOptions?: Apollo.MutationHookOptions<AddUnitTypeMutation, AddUnitTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUnitTypeMutation, AddUnitTypeMutationVariables>(AddUnitTypeDocument, options);
      }
export type AddUnitTypeMutationHookResult = ReturnType<typeof useAddUnitTypeMutation>;
export type AddUnitTypeMutationResult = Apollo.MutationResult<AddUnitTypeMutation>;
export type AddUnitTypeMutationOptions = Apollo.BaseMutationOptions<AddUnitTypeMutation, AddUnitTypeMutationVariables>;
export const EditUnitTypeDocument = gql`
    mutation editUnitType($input: EditUnitTypeInput!) {
  editUnitType(input: $input)
}
    `;
export type EditUnitTypeMutationFn = Apollo.MutationFunction<EditUnitTypeMutation, EditUnitTypeMutationVariables>;

/**
 * __useEditUnitTypeMutation__
 *
 * To run a mutation, you first call `useEditUnitTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditUnitTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editUnitTypeMutation, { data, loading, error }] = useEditUnitTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditUnitTypeMutation(baseOptions?: Apollo.MutationHookOptions<EditUnitTypeMutation, EditUnitTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditUnitTypeMutation, EditUnitTypeMutationVariables>(EditUnitTypeDocument, options);
      }
export type EditUnitTypeMutationHookResult = ReturnType<typeof useEditUnitTypeMutation>;
export type EditUnitTypeMutationResult = Apollo.MutationResult<EditUnitTypeMutation>;
export type EditUnitTypeMutationOptions = Apollo.BaseMutationOptions<EditUnitTypeMutation, EditUnitTypeMutationVariables>;
export const DeleteUnitTypeByIdDocument = gql`
    mutation deleteUnitTypeById($unitTypeId: String!, $isDeletable: Boolean!) {
  deleteUnitTypeById(unitTypeId: $unitTypeId, isDeletable: $isDeletable)
}
    `;
export type DeleteUnitTypeByIdMutationFn = Apollo.MutationFunction<DeleteUnitTypeByIdMutation, DeleteUnitTypeByIdMutationVariables>;

/**
 * __useDeleteUnitTypeByIdMutation__
 *
 * To run a mutation, you first call `useDeleteUnitTypeByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUnitTypeByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUnitTypeByIdMutation, { data, loading, error }] = useDeleteUnitTypeByIdMutation({
 *   variables: {
 *      unitTypeId: // value for 'unitTypeId'
 *      isDeletable: // value for 'isDeletable'
 *   },
 * });
 */
export function useDeleteUnitTypeByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUnitTypeByIdMutation, DeleteUnitTypeByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUnitTypeByIdMutation, DeleteUnitTypeByIdMutationVariables>(DeleteUnitTypeByIdDocument, options);
      }
export type DeleteUnitTypeByIdMutationHookResult = ReturnType<typeof useDeleteUnitTypeByIdMutation>;
export type DeleteUnitTypeByIdMutationResult = Apollo.MutationResult<DeleteUnitTypeByIdMutation>;
export type DeleteUnitTypeByIdMutationOptions = Apollo.BaseMutationOptions<DeleteUnitTypeByIdMutation, DeleteUnitTypeByIdMutationVariables>;
export const ActivateUnitTypeByIdDocument = gql`
    mutation activateUnitTypeById($unitTypeId: String!) {
  activateUnitTypeById(unitTypeId: $unitTypeId)
}
    `;
export type ActivateUnitTypeByIdMutationFn = Apollo.MutationFunction<ActivateUnitTypeByIdMutation, ActivateUnitTypeByIdMutationVariables>;

/**
 * __useActivateUnitTypeByIdMutation__
 *
 * To run a mutation, you first call `useActivateUnitTypeByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateUnitTypeByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateUnitTypeByIdMutation, { data, loading, error }] = useActivateUnitTypeByIdMutation({
 *   variables: {
 *      unitTypeId: // value for 'unitTypeId'
 *   },
 * });
 */
export function useActivateUnitTypeByIdMutation(baseOptions?: Apollo.MutationHookOptions<ActivateUnitTypeByIdMutation, ActivateUnitTypeByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateUnitTypeByIdMutation, ActivateUnitTypeByIdMutationVariables>(ActivateUnitTypeByIdDocument, options);
      }
export type ActivateUnitTypeByIdMutationHookResult = ReturnType<typeof useActivateUnitTypeByIdMutation>;
export type ActivateUnitTypeByIdMutationResult = Apollo.MutationResult<ActivateUnitTypeByIdMutation>;
export type ActivateUnitTypeByIdMutationOptions = Apollo.BaseMutationOptions<ActivateUnitTypeByIdMutation, ActivateUnitTypeByIdMutationVariables>;
export const SetDefaultUnitTypeDocument = gql`
    mutation setDefaultUnitType($unitTypeId: String!) {
  setDefaultUnitType(unitTypeId: $unitTypeId)
}
    `;
export type SetDefaultUnitTypeMutationFn = Apollo.MutationFunction<SetDefaultUnitTypeMutation, SetDefaultUnitTypeMutationVariables>;

/**
 * __useSetDefaultUnitTypeMutation__
 *
 * To run a mutation, you first call `useSetDefaultUnitTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultUnitTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultUnitTypeMutation, { data, loading, error }] = useSetDefaultUnitTypeMutation({
 *   variables: {
 *      unitTypeId: // value for 'unitTypeId'
 *   },
 * });
 */
export function useSetDefaultUnitTypeMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultUnitTypeMutation, SetDefaultUnitTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultUnitTypeMutation, SetDefaultUnitTypeMutationVariables>(SetDefaultUnitTypeDocument, options);
      }
export type SetDefaultUnitTypeMutationHookResult = ReturnType<typeof useSetDefaultUnitTypeMutation>;
export type SetDefaultUnitTypeMutationResult = Apollo.MutationResult<SetDefaultUnitTypeMutation>;
export type SetDefaultUnitTypeMutationOptions = Apollo.BaseMutationOptions<SetDefaultUnitTypeMutation, SetDefaultUnitTypeMutationVariables>;
export const RemoveDefaultUnitTypeDocument = gql`
    mutation removeDefaultUnitType($unitTypeId: String!) {
  removeDefaultUnitType(unitTypeId: $unitTypeId)
}
    `;
export type RemoveDefaultUnitTypeMutationFn = Apollo.MutationFunction<RemoveDefaultUnitTypeMutation, RemoveDefaultUnitTypeMutationVariables>;

/**
 * __useRemoveDefaultUnitTypeMutation__
 *
 * To run a mutation, you first call `useRemoveDefaultUnitTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDefaultUnitTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDefaultUnitTypeMutation, { data, loading, error }] = useRemoveDefaultUnitTypeMutation({
 *   variables: {
 *      unitTypeId: // value for 'unitTypeId'
 *   },
 * });
 */
export function useRemoveDefaultUnitTypeMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDefaultUnitTypeMutation, RemoveDefaultUnitTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveDefaultUnitTypeMutation, RemoveDefaultUnitTypeMutationVariables>(RemoveDefaultUnitTypeDocument, options);
      }
export type RemoveDefaultUnitTypeMutationHookResult = ReturnType<typeof useRemoveDefaultUnitTypeMutation>;
export type RemoveDefaultUnitTypeMutationResult = Apollo.MutationResult<RemoveDefaultUnitTypeMutation>;
export type RemoveDefaultUnitTypeMutationOptions = Apollo.BaseMutationOptions<RemoveDefaultUnitTypeMutation, RemoveDefaultUnitTypeMutationVariables>;
export const OrganizeUnitTypeDocument = gql`
    mutation organizeUnitType($unitTypeId: [String!]!) {
  organizeUnitType(unitTypeId: $unitTypeId)
}
    `;
export type OrganizeUnitTypeMutationFn = Apollo.MutationFunction<OrganizeUnitTypeMutation, OrganizeUnitTypeMutationVariables>;

/**
 * __useOrganizeUnitTypeMutation__
 *
 * To run a mutation, you first call `useOrganizeUnitTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizeUnitTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizeUnitTypeMutation, { data, loading, error }] = useOrganizeUnitTypeMutation({
 *   variables: {
 *      unitTypeId: // value for 'unitTypeId'
 *   },
 * });
 */
export function useOrganizeUnitTypeMutation(baseOptions?: Apollo.MutationHookOptions<OrganizeUnitTypeMutation, OrganizeUnitTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizeUnitTypeMutation, OrganizeUnitTypeMutationVariables>(OrganizeUnitTypeDocument, options);
      }
export type OrganizeUnitTypeMutationHookResult = ReturnType<typeof useOrganizeUnitTypeMutation>;
export type OrganizeUnitTypeMutationResult = Apollo.MutationResult<OrganizeUnitTypeMutation>;
export type OrganizeUnitTypeMutationOptions = Apollo.BaseMutationOptions<OrganizeUnitTypeMutation, OrganizeUnitTypeMutationVariables>;
export const GetAllDesignationDocument = gql`
    query getAllDesignation {
  getAllDesignation {
    id
    name
    commonStatus
    defaulted
    isDeletable
  }
}
    `;

/**
 * __useGetAllDesignationQuery__
 *
 * To run a query within a React component, call `useGetAllDesignationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllDesignationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllDesignationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllDesignationQuery(baseOptions?: Apollo.QueryHookOptions<GetAllDesignationQuery, GetAllDesignationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllDesignationQuery, GetAllDesignationQueryVariables>(GetAllDesignationDocument, options);
      }
export function useGetAllDesignationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllDesignationQuery, GetAllDesignationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllDesignationQuery, GetAllDesignationQueryVariables>(GetAllDesignationDocument, options);
        }
export type GetAllDesignationQueryHookResult = ReturnType<typeof useGetAllDesignationQuery>;
export type GetAllDesignationLazyQueryHookResult = ReturnType<typeof useGetAllDesignationLazyQuery>;
export type GetAllDesignationQueryResult = Apollo.QueryResult<GetAllDesignationQuery, GetAllDesignationQueryVariables>;
export const AddDesignationDocument = gql`
    mutation addDesignation($input: ParameterInput!) {
  addDesignation(input: $input)
}
    `;
export type AddDesignationMutationFn = Apollo.MutationFunction<AddDesignationMutation, AddDesignationMutationVariables>;

/**
 * __useAddDesignationMutation__
 *
 * To run a mutation, you first call `useAddDesignationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDesignationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDesignationMutation, { data, loading, error }] = useAddDesignationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddDesignationMutation(baseOptions?: Apollo.MutationHookOptions<AddDesignationMutation, AddDesignationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDesignationMutation, AddDesignationMutationVariables>(AddDesignationDocument, options);
      }
export type AddDesignationMutationHookResult = ReturnType<typeof useAddDesignationMutation>;
export type AddDesignationMutationResult = Apollo.MutationResult<AddDesignationMutation>;
export type AddDesignationMutationOptions = Apollo.BaseMutationOptions<AddDesignationMutation, AddDesignationMutationVariables>;
export const EditDesignationDocument = gql`
    mutation editDesignation($input: EditParameterInput!) {
  editDesignation(input: $input)
}
    `;
export type EditDesignationMutationFn = Apollo.MutationFunction<EditDesignationMutation, EditDesignationMutationVariables>;

/**
 * __useEditDesignationMutation__
 *
 * To run a mutation, you first call `useEditDesignationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditDesignationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editDesignationMutation, { data, loading, error }] = useEditDesignationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditDesignationMutation(baseOptions?: Apollo.MutationHookOptions<EditDesignationMutation, EditDesignationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditDesignationMutation, EditDesignationMutationVariables>(EditDesignationDocument, options);
      }
export type EditDesignationMutationHookResult = ReturnType<typeof useEditDesignationMutation>;
export type EditDesignationMutationResult = Apollo.MutationResult<EditDesignationMutation>;
export type EditDesignationMutationOptions = Apollo.BaseMutationOptions<EditDesignationMutation, EditDesignationMutationVariables>;
export const DeleteDesignationByIdDocument = gql`
    mutation deleteDesignationById($designationId: String!) {
  deleteDesignationById(designationId: $designationId)
}
    `;
export type DeleteDesignationByIdMutationFn = Apollo.MutationFunction<DeleteDesignationByIdMutation, DeleteDesignationByIdMutationVariables>;

/**
 * __useDeleteDesignationByIdMutation__
 *
 * To run a mutation, you first call `useDeleteDesignationByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDesignationByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDesignationByIdMutation, { data, loading, error }] = useDeleteDesignationByIdMutation({
 *   variables: {
 *      designationId: // value for 'designationId'
 *   },
 * });
 */
export function useDeleteDesignationByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDesignationByIdMutation, DeleteDesignationByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDesignationByIdMutation, DeleteDesignationByIdMutationVariables>(DeleteDesignationByIdDocument, options);
      }
export type DeleteDesignationByIdMutationHookResult = ReturnType<typeof useDeleteDesignationByIdMutation>;
export type DeleteDesignationByIdMutationResult = Apollo.MutationResult<DeleteDesignationByIdMutation>;
export type DeleteDesignationByIdMutationOptions = Apollo.BaseMutationOptions<DeleteDesignationByIdMutation, DeleteDesignationByIdMutationVariables>;
export const DeactivateDesignationByIdDocument = gql`
    mutation deactivateDesignationById($designationId: String!) {
  deactivateDesignationById(designationId: $designationId)
}
    `;
export type DeactivateDesignationByIdMutationFn = Apollo.MutationFunction<DeactivateDesignationByIdMutation, DeactivateDesignationByIdMutationVariables>;

/**
 * __useDeactivateDesignationByIdMutation__
 *
 * To run a mutation, you first call `useDeactivateDesignationByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateDesignationByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateDesignationByIdMutation, { data, loading, error }] = useDeactivateDesignationByIdMutation({
 *   variables: {
 *      designationId: // value for 'designationId'
 *   },
 * });
 */
export function useDeactivateDesignationByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateDesignationByIdMutation, DeactivateDesignationByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateDesignationByIdMutation, DeactivateDesignationByIdMutationVariables>(DeactivateDesignationByIdDocument, options);
      }
export type DeactivateDesignationByIdMutationHookResult = ReturnType<typeof useDeactivateDesignationByIdMutation>;
export type DeactivateDesignationByIdMutationResult = Apollo.MutationResult<DeactivateDesignationByIdMutation>;
export type DeactivateDesignationByIdMutationOptions = Apollo.BaseMutationOptions<DeactivateDesignationByIdMutation, DeactivateDesignationByIdMutationVariables>;
export const ActivateDesignationByIdDocument = gql`
    mutation activateDesignationById($designationId: String!) {
  activateDesignationById(designationId: $designationId)
}
    `;
export type ActivateDesignationByIdMutationFn = Apollo.MutationFunction<ActivateDesignationByIdMutation, ActivateDesignationByIdMutationVariables>;

/**
 * __useActivateDesignationByIdMutation__
 *
 * To run a mutation, you first call `useActivateDesignationByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateDesignationByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateDesignationByIdMutation, { data, loading, error }] = useActivateDesignationByIdMutation({
 *   variables: {
 *      designationId: // value for 'designationId'
 *   },
 * });
 */
export function useActivateDesignationByIdMutation(baseOptions?: Apollo.MutationHookOptions<ActivateDesignationByIdMutation, ActivateDesignationByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateDesignationByIdMutation, ActivateDesignationByIdMutationVariables>(ActivateDesignationByIdDocument, options);
      }
export type ActivateDesignationByIdMutationHookResult = ReturnType<typeof useActivateDesignationByIdMutation>;
export type ActivateDesignationByIdMutationResult = Apollo.MutationResult<ActivateDesignationByIdMutation>;
export type ActivateDesignationByIdMutationOptions = Apollo.BaseMutationOptions<ActivateDesignationByIdMutation, ActivateDesignationByIdMutationVariables>;
export const GetAllIndustryDocument = gql`
    query getAllIndustry {
  getAllIndustry {
    id
    name
    commonStatus
    defaulted
    isDeletable
  }
}
    `;

/**
 * __useGetAllIndustryQuery__
 *
 * To run a query within a React component, call `useGetAllIndustryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllIndustryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllIndustryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllIndustryQuery(baseOptions?: Apollo.QueryHookOptions<GetAllIndustryQuery, GetAllIndustryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllIndustryQuery, GetAllIndustryQueryVariables>(GetAllIndustryDocument, options);
      }
export function useGetAllIndustryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllIndustryQuery, GetAllIndustryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllIndustryQuery, GetAllIndustryQueryVariables>(GetAllIndustryDocument, options);
        }
export type GetAllIndustryQueryHookResult = ReturnType<typeof useGetAllIndustryQuery>;
export type GetAllIndustryLazyQueryHookResult = ReturnType<typeof useGetAllIndustryLazyQuery>;
export type GetAllIndustryQueryResult = Apollo.QueryResult<GetAllIndustryQuery, GetAllIndustryQueryVariables>;
export const AddIndustryDocument = gql`
    mutation addIndustry($input: ParameterInput!) {
  addIndustry(input: $input)
}
    `;
export type AddIndustryMutationFn = Apollo.MutationFunction<AddIndustryMutation, AddIndustryMutationVariables>;

/**
 * __useAddIndustryMutation__
 *
 * To run a mutation, you first call `useAddIndustryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddIndustryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addIndustryMutation, { data, loading, error }] = useAddIndustryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddIndustryMutation(baseOptions?: Apollo.MutationHookOptions<AddIndustryMutation, AddIndustryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddIndustryMutation, AddIndustryMutationVariables>(AddIndustryDocument, options);
      }
export type AddIndustryMutationHookResult = ReturnType<typeof useAddIndustryMutation>;
export type AddIndustryMutationResult = Apollo.MutationResult<AddIndustryMutation>;
export type AddIndustryMutationOptions = Apollo.BaseMutationOptions<AddIndustryMutation, AddIndustryMutationVariables>;
export const EditIndustryDocument = gql`
    mutation editIndustry($input: EditParameterInput!) {
  editIndustry(input: $input)
}
    `;
export type EditIndustryMutationFn = Apollo.MutationFunction<EditIndustryMutation, EditIndustryMutationVariables>;

/**
 * __useEditIndustryMutation__
 *
 * To run a mutation, you first call `useEditIndustryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditIndustryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editIndustryMutation, { data, loading, error }] = useEditIndustryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditIndustryMutation(baseOptions?: Apollo.MutationHookOptions<EditIndustryMutation, EditIndustryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditIndustryMutation, EditIndustryMutationVariables>(EditIndustryDocument, options);
      }
export type EditIndustryMutationHookResult = ReturnType<typeof useEditIndustryMutation>;
export type EditIndustryMutationResult = Apollo.MutationResult<EditIndustryMutation>;
export type EditIndustryMutationOptions = Apollo.BaseMutationOptions<EditIndustryMutation, EditIndustryMutationVariables>;
export const DeleteIndustryByIdDocument = gql`
    mutation deleteIndustryById($industryId: String!) {
  deleteIndustryById(industryId: $industryId)
}
    `;
export type DeleteIndustryByIdMutationFn = Apollo.MutationFunction<DeleteIndustryByIdMutation, DeleteIndustryByIdMutationVariables>;

/**
 * __useDeleteIndustryByIdMutation__
 *
 * To run a mutation, you first call `useDeleteIndustryByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIndustryByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIndustryByIdMutation, { data, loading, error }] = useDeleteIndustryByIdMutation({
 *   variables: {
 *      industryId: // value for 'industryId'
 *   },
 * });
 */
export function useDeleteIndustryByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteIndustryByIdMutation, DeleteIndustryByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteIndustryByIdMutation, DeleteIndustryByIdMutationVariables>(DeleteIndustryByIdDocument, options);
      }
export type DeleteIndustryByIdMutationHookResult = ReturnType<typeof useDeleteIndustryByIdMutation>;
export type DeleteIndustryByIdMutationResult = Apollo.MutationResult<DeleteIndustryByIdMutation>;
export type DeleteIndustryByIdMutationOptions = Apollo.BaseMutationOptions<DeleteIndustryByIdMutation, DeleteIndustryByIdMutationVariables>;
export const DeactivateIndustryByIdDocument = gql`
    mutation deactivateIndustryById($industryId: String!) {
  deactivateIndustryById(industryId: $industryId)
}
    `;
export type DeactivateIndustryByIdMutationFn = Apollo.MutationFunction<DeactivateIndustryByIdMutation, DeactivateIndustryByIdMutationVariables>;

/**
 * __useDeactivateIndustryByIdMutation__
 *
 * To run a mutation, you first call `useDeactivateIndustryByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateIndustryByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateIndustryByIdMutation, { data, loading, error }] = useDeactivateIndustryByIdMutation({
 *   variables: {
 *      industryId: // value for 'industryId'
 *   },
 * });
 */
export function useDeactivateIndustryByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateIndustryByIdMutation, DeactivateIndustryByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateIndustryByIdMutation, DeactivateIndustryByIdMutationVariables>(DeactivateIndustryByIdDocument, options);
      }
export type DeactivateIndustryByIdMutationHookResult = ReturnType<typeof useDeactivateIndustryByIdMutation>;
export type DeactivateIndustryByIdMutationResult = Apollo.MutationResult<DeactivateIndustryByIdMutation>;
export type DeactivateIndustryByIdMutationOptions = Apollo.BaseMutationOptions<DeactivateIndustryByIdMutation, DeactivateIndustryByIdMutationVariables>;
export const ActivateIndustryByIdDocument = gql`
    mutation activateIndustryById($industryId: String!) {
  activateIndustryById(industryId: $industryId)
}
    `;
export type ActivateIndustryByIdMutationFn = Apollo.MutationFunction<ActivateIndustryByIdMutation, ActivateIndustryByIdMutationVariables>;

/**
 * __useActivateIndustryByIdMutation__
 *
 * To run a mutation, you first call `useActivateIndustryByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateIndustryByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateIndustryByIdMutation, { data, loading, error }] = useActivateIndustryByIdMutation({
 *   variables: {
 *      industryId: // value for 'industryId'
 *   },
 * });
 */
export function useActivateIndustryByIdMutation(baseOptions?: Apollo.MutationHookOptions<ActivateIndustryByIdMutation, ActivateIndustryByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateIndustryByIdMutation, ActivateIndustryByIdMutationVariables>(ActivateIndustryByIdDocument, options);
      }
export type ActivateIndustryByIdMutationHookResult = ReturnType<typeof useActivateIndustryByIdMutation>;
export type ActivateIndustryByIdMutationResult = Apollo.MutationResult<ActivateIndustryByIdMutation>;
export type ActivateIndustryByIdMutationOptions = Apollo.BaseMutationOptions<ActivateIndustryByIdMutation, ActivateIndustryByIdMutationVariables>;
export const GetAllProfessionDocument = gql`
    query getAllProfession {
  getAllProfession {
    id
    name
    commonStatus
    defaulted
    isDeletable
    isExistInMasterData
    isExistInTransactionData
  }
}
    `;

/**
 * __useGetAllProfessionQuery__
 *
 * To run a query within a React component, call `useGetAllProfessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllProfessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllProfessionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllProfessionQuery(baseOptions?: Apollo.QueryHookOptions<GetAllProfessionQuery, GetAllProfessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllProfessionQuery, GetAllProfessionQueryVariables>(GetAllProfessionDocument, options);
      }
export function useGetAllProfessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllProfessionQuery, GetAllProfessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllProfessionQuery, GetAllProfessionQueryVariables>(GetAllProfessionDocument, options);
        }
export type GetAllProfessionQueryHookResult = ReturnType<typeof useGetAllProfessionQuery>;
export type GetAllProfessionLazyQueryHookResult = ReturnType<typeof useGetAllProfessionLazyQuery>;
export type GetAllProfessionQueryResult = Apollo.QueryResult<GetAllProfessionQuery, GetAllProfessionQueryVariables>;
export const AddProfessionDocument = gql`
    mutation addProfession($input: ParameterInput!) {
  addProfession(input: $input)
}
    `;
export type AddProfessionMutationFn = Apollo.MutationFunction<AddProfessionMutation, AddProfessionMutationVariables>;

/**
 * __useAddProfessionMutation__
 *
 * To run a mutation, you first call `useAddProfessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProfessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProfessionMutation, { data, loading, error }] = useAddProfessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddProfessionMutation(baseOptions?: Apollo.MutationHookOptions<AddProfessionMutation, AddProfessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProfessionMutation, AddProfessionMutationVariables>(AddProfessionDocument, options);
      }
export type AddProfessionMutationHookResult = ReturnType<typeof useAddProfessionMutation>;
export type AddProfessionMutationResult = Apollo.MutationResult<AddProfessionMutation>;
export type AddProfessionMutationOptions = Apollo.BaseMutationOptions<AddProfessionMutation, AddProfessionMutationVariables>;
export const EditProfessionDocument = gql`
    mutation editProfession($input: EditParameterInput!) {
  editProfession(input: $input)
}
    `;
export type EditProfessionMutationFn = Apollo.MutationFunction<EditProfessionMutation, EditProfessionMutationVariables>;

/**
 * __useEditProfessionMutation__
 *
 * To run a mutation, you first call `useEditProfessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditProfessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editProfessionMutation, { data, loading, error }] = useEditProfessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditProfessionMutation(baseOptions?: Apollo.MutationHookOptions<EditProfessionMutation, EditProfessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditProfessionMutation, EditProfessionMutationVariables>(EditProfessionDocument, options);
      }
export type EditProfessionMutationHookResult = ReturnType<typeof useEditProfessionMutation>;
export type EditProfessionMutationResult = Apollo.MutationResult<EditProfessionMutation>;
export type EditProfessionMutationOptions = Apollo.BaseMutationOptions<EditProfessionMutation, EditProfessionMutationVariables>;
export const DeleteProfessionByIdDocument = gql`
    mutation deleteProfessionById($professionId: String!) {
  deleteProfessionById(professionId: $professionId)
}
    `;
export type DeleteProfessionByIdMutationFn = Apollo.MutationFunction<DeleteProfessionByIdMutation, DeleteProfessionByIdMutationVariables>;

/**
 * __useDeleteProfessionByIdMutation__
 *
 * To run a mutation, you first call `useDeleteProfessionByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProfessionByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProfessionByIdMutation, { data, loading, error }] = useDeleteProfessionByIdMutation({
 *   variables: {
 *      professionId: // value for 'professionId'
 *   },
 * });
 */
export function useDeleteProfessionByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProfessionByIdMutation, DeleteProfessionByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProfessionByIdMutation, DeleteProfessionByIdMutationVariables>(DeleteProfessionByIdDocument, options);
      }
export type DeleteProfessionByIdMutationHookResult = ReturnType<typeof useDeleteProfessionByIdMutation>;
export type DeleteProfessionByIdMutationResult = Apollo.MutationResult<DeleteProfessionByIdMutation>;
export type DeleteProfessionByIdMutationOptions = Apollo.BaseMutationOptions<DeleteProfessionByIdMutation, DeleteProfessionByIdMutationVariables>;
export const DeactivateProfessionByIdDocument = gql`
    mutation deactivateProfessionById($professionId: String!) {
  deactivateProfessionById(professionId: $professionId)
}
    `;
export type DeactivateProfessionByIdMutationFn = Apollo.MutationFunction<DeactivateProfessionByIdMutation, DeactivateProfessionByIdMutationVariables>;

/**
 * __useDeactivateProfessionByIdMutation__
 *
 * To run a mutation, you first call `useDeactivateProfessionByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateProfessionByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateProfessionByIdMutation, { data, loading, error }] = useDeactivateProfessionByIdMutation({
 *   variables: {
 *      professionId: // value for 'professionId'
 *   },
 * });
 */
export function useDeactivateProfessionByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateProfessionByIdMutation, DeactivateProfessionByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateProfessionByIdMutation, DeactivateProfessionByIdMutationVariables>(DeactivateProfessionByIdDocument, options);
      }
export type DeactivateProfessionByIdMutationHookResult = ReturnType<typeof useDeactivateProfessionByIdMutation>;
export type DeactivateProfessionByIdMutationResult = Apollo.MutationResult<DeactivateProfessionByIdMutation>;
export type DeactivateProfessionByIdMutationOptions = Apollo.BaseMutationOptions<DeactivateProfessionByIdMutation, DeactivateProfessionByIdMutationVariables>;
export const ActivateProfessionByIdDocument = gql`
    mutation activateProfessionById($professionId: String!) {
  activateProfessionById(professionId: $professionId)
}
    `;
export type ActivateProfessionByIdMutationFn = Apollo.MutationFunction<ActivateProfessionByIdMutation, ActivateProfessionByIdMutationVariables>;

/**
 * __useActivateProfessionByIdMutation__
 *
 * To run a mutation, you first call `useActivateProfessionByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateProfessionByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateProfessionByIdMutation, { data, loading, error }] = useActivateProfessionByIdMutation({
 *   variables: {
 *      professionId: // value for 'professionId'
 *   },
 * });
 */
export function useActivateProfessionByIdMutation(baseOptions?: Apollo.MutationHookOptions<ActivateProfessionByIdMutation, ActivateProfessionByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateProfessionByIdMutation, ActivateProfessionByIdMutationVariables>(ActivateProfessionByIdDocument, options);
      }
export type ActivateProfessionByIdMutationHookResult = ReturnType<typeof useActivateProfessionByIdMutation>;
export type ActivateProfessionByIdMutationResult = Apollo.MutationResult<ActivateProfessionByIdMutation>;
export type ActivateProfessionByIdMutationOptions = Apollo.BaseMutationOptions<ActivateProfessionByIdMutation, ActivateProfessionByIdMutationVariables>;
export const GetAllRelationshipDocument = gql`
    query getAllRelationship {
  getAllRelationship {
    id
    name
    commonStatus
    defaulted
    isDeletable
    isExistInMasterData
    isExistInTransactionData
  }
}
    `;

/**
 * __useGetAllRelationshipQuery__
 *
 * To run a query within a React component, call `useGetAllRelationshipQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelationshipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelationshipQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllRelationshipQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelationshipQuery, GetAllRelationshipQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelationshipQuery, GetAllRelationshipQueryVariables>(GetAllRelationshipDocument, options);
      }
export function useGetAllRelationshipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelationshipQuery, GetAllRelationshipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelationshipQuery, GetAllRelationshipQueryVariables>(GetAllRelationshipDocument, options);
        }
export type GetAllRelationshipQueryHookResult = ReturnType<typeof useGetAllRelationshipQuery>;
export type GetAllRelationshipLazyQueryHookResult = ReturnType<typeof useGetAllRelationshipLazyQuery>;
export type GetAllRelationshipQueryResult = Apollo.QueryResult<GetAllRelationshipQuery, GetAllRelationshipQueryVariables>;
export const AddRelationshipDocument = gql`
    mutation addRelationship($input: ParameterInput!) {
  addRelationship(input: $input)
}
    `;
export type AddRelationshipMutationFn = Apollo.MutationFunction<AddRelationshipMutation, AddRelationshipMutationVariables>;

/**
 * __useAddRelationshipMutation__
 *
 * To run a mutation, you first call `useAddRelationshipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRelationshipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRelationshipMutation, { data, loading, error }] = useAddRelationshipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddRelationshipMutation(baseOptions?: Apollo.MutationHookOptions<AddRelationshipMutation, AddRelationshipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddRelationshipMutation, AddRelationshipMutationVariables>(AddRelationshipDocument, options);
      }
export type AddRelationshipMutationHookResult = ReturnType<typeof useAddRelationshipMutation>;
export type AddRelationshipMutationResult = Apollo.MutationResult<AddRelationshipMutation>;
export type AddRelationshipMutationOptions = Apollo.BaseMutationOptions<AddRelationshipMutation, AddRelationshipMutationVariables>;
export const EditRelationshipDocument = gql`
    mutation editRelationship($input: EditParameterInput!) {
  editRelationship(input: $input)
}
    `;
export type EditRelationshipMutationFn = Apollo.MutationFunction<EditRelationshipMutation, EditRelationshipMutationVariables>;

/**
 * __useEditRelationshipMutation__
 *
 * To run a mutation, you first call `useEditRelationshipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditRelationshipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editRelationshipMutation, { data, loading, error }] = useEditRelationshipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditRelationshipMutation(baseOptions?: Apollo.MutationHookOptions<EditRelationshipMutation, EditRelationshipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditRelationshipMutation, EditRelationshipMutationVariables>(EditRelationshipDocument, options);
      }
export type EditRelationshipMutationHookResult = ReturnType<typeof useEditRelationshipMutation>;
export type EditRelationshipMutationResult = Apollo.MutationResult<EditRelationshipMutation>;
export type EditRelationshipMutationOptions = Apollo.BaseMutationOptions<EditRelationshipMutation, EditRelationshipMutationVariables>;
export const DeleteRelationshipByIdDocument = gql`
    mutation deleteRelationshipById($relationshipId: String!) {
  deleteRelationshipById(relationshipId: $relationshipId)
}
    `;
export type DeleteRelationshipByIdMutationFn = Apollo.MutationFunction<DeleteRelationshipByIdMutation, DeleteRelationshipByIdMutationVariables>;

/**
 * __useDeleteRelationshipByIdMutation__
 *
 * To run a mutation, you first call `useDeleteRelationshipByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRelationshipByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRelationshipByIdMutation, { data, loading, error }] = useDeleteRelationshipByIdMutation({
 *   variables: {
 *      relationshipId: // value for 'relationshipId'
 *   },
 * });
 */
export function useDeleteRelationshipByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRelationshipByIdMutation, DeleteRelationshipByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRelationshipByIdMutation, DeleteRelationshipByIdMutationVariables>(DeleteRelationshipByIdDocument, options);
      }
export type DeleteRelationshipByIdMutationHookResult = ReturnType<typeof useDeleteRelationshipByIdMutation>;
export type DeleteRelationshipByIdMutationResult = Apollo.MutationResult<DeleteRelationshipByIdMutation>;
export type DeleteRelationshipByIdMutationOptions = Apollo.BaseMutationOptions<DeleteRelationshipByIdMutation, DeleteRelationshipByIdMutationVariables>;
export const DeactivateRelationshipByIdDocument = gql`
    mutation deactivateRelationshipById($relationshipId: String!) {
  deactivateRelationshipById(relationshipId: $relationshipId)
}
    `;
export type DeactivateRelationshipByIdMutationFn = Apollo.MutationFunction<DeactivateRelationshipByIdMutation, DeactivateRelationshipByIdMutationVariables>;

/**
 * __useDeactivateRelationshipByIdMutation__
 *
 * To run a mutation, you first call `useDeactivateRelationshipByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateRelationshipByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateRelationshipByIdMutation, { data, loading, error }] = useDeactivateRelationshipByIdMutation({
 *   variables: {
 *      relationshipId: // value for 'relationshipId'
 *   },
 * });
 */
export function useDeactivateRelationshipByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateRelationshipByIdMutation, DeactivateRelationshipByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateRelationshipByIdMutation, DeactivateRelationshipByIdMutationVariables>(DeactivateRelationshipByIdDocument, options);
      }
export type DeactivateRelationshipByIdMutationHookResult = ReturnType<typeof useDeactivateRelationshipByIdMutation>;
export type DeactivateRelationshipByIdMutationResult = Apollo.MutationResult<DeactivateRelationshipByIdMutation>;
export type DeactivateRelationshipByIdMutationOptions = Apollo.BaseMutationOptions<DeactivateRelationshipByIdMutation, DeactivateRelationshipByIdMutationVariables>;
export const ActivateRelationshipByIdDocument = gql`
    mutation activateRelationshipById($relationshipId: String!) {
  activateRelationshipById(relationshipId: $relationshipId)
}
    `;
export type ActivateRelationshipByIdMutationFn = Apollo.MutationFunction<ActivateRelationshipByIdMutation, ActivateRelationshipByIdMutationVariables>;

/**
 * __useActivateRelationshipByIdMutation__
 *
 * To run a mutation, you first call `useActivateRelationshipByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateRelationshipByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateRelationshipByIdMutation, { data, loading, error }] = useActivateRelationshipByIdMutation({
 *   variables: {
 *      relationshipId: // value for 'relationshipId'
 *   },
 * });
 */
export function useActivateRelationshipByIdMutation(baseOptions?: Apollo.MutationHookOptions<ActivateRelationshipByIdMutation, ActivateRelationshipByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateRelationshipByIdMutation, ActivateRelationshipByIdMutationVariables>(ActivateRelationshipByIdDocument, options);
      }
export type ActivateRelationshipByIdMutationHookResult = ReturnType<typeof useActivateRelationshipByIdMutation>;
export type ActivateRelationshipByIdMutationResult = Apollo.MutationResult<ActivateRelationshipByIdMutation>;
export type ActivateRelationshipByIdMutationOptions = Apollo.BaseMutationOptions<ActivateRelationshipByIdMutation, ActivateRelationshipByIdMutationVariables>;
export const GetAllReligionDocument = gql`
    query getAllReligion {
  getAllReligion {
    id
    name
    commonStatus
    defaulted
    isDeletable
  }
}
    `;

/**
 * __useGetAllReligionQuery__
 *
 * To run a query within a React component, call `useGetAllReligionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllReligionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllReligionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllReligionQuery(baseOptions?: Apollo.QueryHookOptions<GetAllReligionQuery, GetAllReligionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllReligionQuery, GetAllReligionQueryVariables>(GetAllReligionDocument, options);
      }
export function useGetAllReligionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllReligionQuery, GetAllReligionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllReligionQuery, GetAllReligionQueryVariables>(GetAllReligionDocument, options);
        }
export type GetAllReligionQueryHookResult = ReturnType<typeof useGetAllReligionQuery>;
export type GetAllReligionLazyQueryHookResult = ReturnType<typeof useGetAllReligionLazyQuery>;
export type GetAllReligionQueryResult = Apollo.QueryResult<GetAllReligionQuery, GetAllReligionQueryVariables>;
export const AddReligionDocument = gql`
    mutation addReligion($input: ParameterInput!) {
  addReligion(input: $input)
}
    `;
export type AddReligionMutationFn = Apollo.MutationFunction<AddReligionMutation, AddReligionMutationVariables>;

/**
 * __useAddReligionMutation__
 *
 * To run a mutation, you first call `useAddReligionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddReligionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addReligionMutation, { data, loading, error }] = useAddReligionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddReligionMutation(baseOptions?: Apollo.MutationHookOptions<AddReligionMutation, AddReligionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddReligionMutation, AddReligionMutationVariables>(AddReligionDocument, options);
      }
export type AddReligionMutationHookResult = ReturnType<typeof useAddReligionMutation>;
export type AddReligionMutationResult = Apollo.MutationResult<AddReligionMutation>;
export type AddReligionMutationOptions = Apollo.BaseMutationOptions<AddReligionMutation, AddReligionMutationVariables>;
export const EditReligionDocument = gql`
    mutation editReligion($input: EditParameterInput!) {
  editReligion(input: $input)
}
    `;
export type EditReligionMutationFn = Apollo.MutationFunction<EditReligionMutation, EditReligionMutationVariables>;

/**
 * __useEditReligionMutation__
 *
 * To run a mutation, you first call `useEditReligionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditReligionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editReligionMutation, { data, loading, error }] = useEditReligionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditReligionMutation(baseOptions?: Apollo.MutationHookOptions<EditReligionMutation, EditReligionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditReligionMutation, EditReligionMutationVariables>(EditReligionDocument, options);
      }
export type EditReligionMutationHookResult = ReturnType<typeof useEditReligionMutation>;
export type EditReligionMutationResult = Apollo.MutationResult<EditReligionMutation>;
export type EditReligionMutationOptions = Apollo.BaseMutationOptions<EditReligionMutation, EditReligionMutationVariables>;
export const DeleteReligionByIdDocument = gql`
    mutation deleteReligionById($religionId: String!) {
  deleteReligionById(religionId: $religionId)
}
    `;
export type DeleteReligionByIdMutationFn = Apollo.MutationFunction<DeleteReligionByIdMutation, DeleteReligionByIdMutationVariables>;

/**
 * __useDeleteReligionByIdMutation__
 *
 * To run a mutation, you first call `useDeleteReligionByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReligionByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReligionByIdMutation, { data, loading, error }] = useDeleteReligionByIdMutation({
 *   variables: {
 *      religionId: // value for 'religionId'
 *   },
 * });
 */
export function useDeleteReligionByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReligionByIdMutation, DeleteReligionByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReligionByIdMutation, DeleteReligionByIdMutationVariables>(DeleteReligionByIdDocument, options);
      }
export type DeleteReligionByIdMutationHookResult = ReturnType<typeof useDeleteReligionByIdMutation>;
export type DeleteReligionByIdMutationResult = Apollo.MutationResult<DeleteReligionByIdMutation>;
export type DeleteReligionByIdMutationOptions = Apollo.BaseMutationOptions<DeleteReligionByIdMutation, DeleteReligionByIdMutationVariables>;
export const DeactivateReligionByIdDocument = gql`
    mutation deactivateReligionById($religionId: String!) {
  deactivateReligionById(religionId: $religionId)
}
    `;
export type DeactivateReligionByIdMutationFn = Apollo.MutationFunction<DeactivateReligionByIdMutation, DeactivateReligionByIdMutationVariables>;

/**
 * __useDeactivateReligionByIdMutation__
 *
 * To run a mutation, you first call `useDeactivateReligionByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateReligionByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateReligionByIdMutation, { data, loading, error }] = useDeactivateReligionByIdMutation({
 *   variables: {
 *      religionId: // value for 'religionId'
 *   },
 * });
 */
export function useDeactivateReligionByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateReligionByIdMutation, DeactivateReligionByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateReligionByIdMutation, DeactivateReligionByIdMutationVariables>(DeactivateReligionByIdDocument, options);
      }
export type DeactivateReligionByIdMutationHookResult = ReturnType<typeof useDeactivateReligionByIdMutation>;
export type DeactivateReligionByIdMutationResult = Apollo.MutationResult<DeactivateReligionByIdMutation>;
export type DeactivateReligionByIdMutationOptions = Apollo.BaseMutationOptions<DeactivateReligionByIdMutation, DeactivateReligionByIdMutationVariables>;
export const ActivateReligionByIdDocument = gql`
    mutation activateReligionById($religionId: String!) {
  activateReligionById(religionId: $religionId)
}
    `;
export type ActivateReligionByIdMutationFn = Apollo.MutationFunction<ActivateReligionByIdMutation, ActivateReligionByIdMutationVariables>;

/**
 * __useActivateReligionByIdMutation__
 *
 * To run a mutation, you first call `useActivateReligionByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateReligionByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateReligionByIdMutation, { data, loading, error }] = useActivateReligionByIdMutation({
 *   variables: {
 *      religionId: // value for 'religionId'
 *   },
 * });
 */
export function useActivateReligionByIdMutation(baseOptions?: Apollo.MutationHookOptions<ActivateReligionByIdMutation, ActivateReligionByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateReligionByIdMutation, ActivateReligionByIdMutationVariables>(ActivateReligionByIdDocument, options);
      }
export type ActivateReligionByIdMutationHookResult = ReturnType<typeof useActivateReligionByIdMutation>;
export type ActivateReligionByIdMutationResult = Apollo.MutationResult<ActivateReligionByIdMutation>;
export type ActivateReligionByIdMutationOptions = Apollo.BaseMutationOptions<ActivateReligionByIdMutation, ActivateReligionByIdMutationVariables>;
export const OrganizeReligionDocument = gql`
    mutation organizeReligion($religionIds: [String!]!) {
  organizeReligion(religionIds: $religionIds)
}
    `;
export type OrganizeReligionMutationFn = Apollo.MutationFunction<OrganizeReligionMutation, OrganizeReligionMutationVariables>;

/**
 * __useOrganizeReligionMutation__
 *
 * To run a mutation, you first call `useOrganizeReligionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizeReligionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizeReligionMutation, { data, loading, error }] = useOrganizeReligionMutation({
 *   variables: {
 *      religionIds: // value for 'religionIds'
 *   },
 * });
 */
export function useOrganizeReligionMutation(baseOptions?: Apollo.MutationHookOptions<OrganizeReligionMutation, OrganizeReligionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizeReligionMutation, OrganizeReligionMutationVariables>(OrganizeReligionDocument, options);
      }
export type OrganizeReligionMutationHookResult = ReturnType<typeof useOrganizeReligionMutation>;
export type OrganizeReligionMutationResult = Apollo.MutationResult<OrganizeReligionMutation>;
export type OrganizeReligionMutationOptions = Apollo.BaseMutationOptions<OrganizeReligionMutation, OrganizeReligionMutationVariables>;
export const GetAllEducationDocument = gql`
    query getAllEducation {
  getAllEducation {
    id
    name
    commonStatus
    defaulted
    isDeletable
  }
}
    `;

/**
 * __useGetAllEducationQuery__
 *
 * To run a query within a React component, call `useGetAllEducationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllEducationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllEducationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllEducationQuery(baseOptions?: Apollo.QueryHookOptions<GetAllEducationQuery, GetAllEducationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllEducationQuery, GetAllEducationQueryVariables>(GetAllEducationDocument, options);
      }
export function useGetAllEducationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllEducationQuery, GetAllEducationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllEducationQuery, GetAllEducationQueryVariables>(GetAllEducationDocument, options);
        }
export type GetAllEducationQueryHookResult = ReturnType<typeof useGetAllEducationQuery>;
export type GetAllEducationLazyQueryHookResult = ReturnType<typeof useGetAllEducationLazyQuery>;
export type GetAllEducationQueryResult = Apollo.QueryResult<GetAllEducationQuery, GetAllEducationQueryVariables>;
export const AddEducationDocument = gql`
    mutation addEducation($input: ParameterInput!) {
  addEducation(input: $input)
}
    `;
export type AddEducationMutationFn = Apollo.MutationFunction<AddEducationMutation, AddEducationMutationVariables>;

/**
 * __useAddEducationMutation__
 *
 * To run a mutation, you first call `useAddEducationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEducationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEducationMutation, { data, loading, error }] = useAddEducationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddEducationMutation(baseOptions?: Apollo.MutationHookOptions<AddEducationMutation, AddEducationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEducationMutation, AddEducationMutationVariables>(AddEducationDocument, options);
      }
export type AddEducationMutationHookResult = ReturnType<typeof useAddEducationMutation>;
export type AddEducationMutationResult = Apollo.MutationResult<AddEducationMutation>;
export type AddEducationMutationOptions = Apollo.BaseMutationOptions<AddEducationMutation, AddEducationMutationVariables>;
export const DeleteEducationByIdDocument = gql`
    mutation deleteEducationById($educationId: String!) {
  deleteEducationById(educationId: $educationId)
}
    `;
export type DeleteEducationByIdMutationFn = Apollo.MutationFunction<DeleteEducationByIdMutation, DeleteEducationByIdMutationVariables>;

/**
 * __useDeleteEducationByIdMutation__
 *
 * To run a mutation, you first call `useDeleteEducationByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEducationByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEducationByIdMutation, { data, loading, error }] = useDeleteEducationByIdMutation({
 *   variables: {
 *      educationId: // value for 'educationId'
 *   },
 * });
 */
export function useDeleteEducationByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEducationByIdMutation, DeleteEducationByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEducationByIdMutation, DeleteEducationByIdMutationVariables>(DeleteEducationByIdDocument, options);
      }
export type DeleteEducationByIdMutationHookResult = ReturnType<typeof useDeleteEducationByIdMutation>;
export type DeleteEducationByIdMutationResult = Apollo.MutationResult<DeleteEducationByIdMutation>;
export type DeleteEducationByIdMutationOptions = Apollo.BaseMutationOptions<DeleteEducationByIdMutation, DeleteEducationByIdMutationVariables>;
export const DeactivateEducationByIdDocument = gql`
    mutation deactivateEducationById($educationId: String!) {
  deactivateEducationById(educationId: $educationId)
}
    `;
export type DeactivateEducationByIdMutationFn = Apollo.MutationFunction<DeactivateEducationByIdMutation, DeactivateEducationByIdMutationVariables>;

/**
 * __useDeactivateEducationByIdMutation__
 *
 * To run a mutation, you first call `useDeactivateEducationByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateEducationByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateEducationByIdMutation, { data, loading, error }] = useDeactivateEducationByIdMutation({
 *   variables: {
 *      educationId: // value for 'educationId'
 *   },
 * });
 */
export function useDeactivateEducationByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateEducationByIdMutation, DeactivateEducationByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateEducationByIdMutation, DeactivateEducationByIdMutationVariables>(DeactivateEducationByIdDocument, options);
      }
export type DeactivateEducationByIdMutationHookResult = ReturnType<typeof useDeactivateEducationByIdMutation>;
export type DeactivateEducationByIdMutationResult = Apollo.MutationResult<DeactivateEducationByIdMutation>;
export type DeactivateEducationByIdMutationOptions = Apollo.BaseMutationOptions<DeactivateEducationByIdMutation, DeactivateEducationByIdMutationVariables>;
export const ActivateEducationByIdDocument = gql`
    mutation activateEducationById($educationId: String!) {
  activateEducationById(educationId: $educationId)
}
    `;
export type ActivateEducationByIdMutationFn = Apollo.MutationFunction<ActivateEducationByIdMutation, ActivateEducationByIdMutationVariables>;

/**
 * __useActivateEducationByIdMutation__
 *
 * To run a mutation, you first call `useActivateEducationByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateEducationByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateEducationByIdMutation, { data, loading, error }] = useActivateEducationByIdMutation({
 *   variables: {
 *      educationId: // value for 'educationId'
 *   },
 * });
 */
export function useActivateEducationByIdMutation(baseOptions?: Apollo.MutationHookOptions<ActivateEducationByIdMutation, ActivateEducationByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateEducationByIdMutation, ActivateEducationByIdMutationVariables>(ActivateEducationByIdDocument, options);
      }
export type ActivateEducationByIdMutationHookResult = ReturnType<typeof useActivateEducationByIdMutation>;
export type ActivateEducationByIdMutationResult = Apollo.MutationResult<ActivateEducationByIdMutation>;
export type ActivateEducationByIdMutationOptions = Apollo.BaseMutationOptions<ActivateEducationByIdMutation, ActivateEducationByIdMutationVariables>;
export const EditEducationDocument = gql`
    mutation editEducation($input: EditParameterInput!) {
  editEducation(input: $input)
}
    `;
export type EditEducationMutationFn = Apollo.MutationFunction<EditEducationMutation, EditEducationMutationVariables>;

/**
 * __useEditEducationMutation__
 *
 * To run a mutation, you first call `useEditEducationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditEducationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editEducationMutation, { data, loading, error }] = useEditEducationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditEducationMutation(baseOptions?: Apollo.MutationHookOptions<EditEducationMutation, EditEducationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditEducationMutation, EditEducationMutationVariables>(EditEducationDocument, options);
      }
export type EditEducationMutationHookResult = ReturnType<typeof useEditEducationMutation>;
export type EditEducationMutationResult = Apollo.MutationResult<EditEducationMutation>;
export type EditEducationMutationOptions = Apollo.BaseMutationOptions<EditEducationMutation, EditEducationMutationVariables>;
export const GetAllIncomeRangeDocument = gql`
    query getAllIncomeRange {
  getAllIncomeRange {
    id
    range
    commonStatus
    defaulted
    isDeletable
    isExistInTransactionData
  }
}
    `;

/**
 * __useGetAllIncomeRangeQuery__
 *
 * To run a query within a React component, call `useGetAllIncomeRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllIncomeRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllIncomeRangeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllIncomeRangeQuery(baseOptions?: Apollo.QueryHookOptions<GetAllIncomeRangeQuery, GetAllIncomeRangeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllIncomeRangeQuery, GetAllIncomeRangeQueryVariables>(GetAllIncomeRangeDocument, options);
      }
export function useGetAllIncomeRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllIncomeRangeQuery, GetAllIncomeRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllIncomeRangeQuery, GetAllIncomeRangeQueryVariables>(GetAllIncomeRangeDocument, options);
        }
export type GetAllIncomeRangeQueryHookResult = ReturnType<typeof useGetAllIncomeRangeQuery>;
export type GetAllIncomeRangeLazyQueryHookResult = ReturnType<typeof useGetAllIncomeRangeLazyQuery>;
export type GetAllIncomeRangeQueryResult = Apollo.QueryResult<GetAllIncomeRangeQuery, GetAllIncomeRangeQueryVariables>;
export const AddIncomeRangeDocument = gql`
    mutation addIncomeRange($input: IncomeRangeInput!) {
  addIncomeRange(input: $input)
}
    `;
export type AddIncomeRangeMutationFn = Apollo.MutationFunction<AddIncomeRangeMutation, AddIncomeRangeMutationVariables>;

/**
 * __useAddIncomeRangeMutation__
 *
 * To run a mutation, you first call `useAddIncomeRangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddIncomeRangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addIncomeRangeMutation, { data, loading, error }] = useAddIncomeRangeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddIncomeRangeMutation(baseOptions?: Apollo.MutationHookOptions<AddIncomeRangeMutation, AddIncomeRangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddIncomeRangeMutation, AddIncomeRangeMutationVariables>(AddIncomeRangeDocument, options);
      }
export type AddIncomeRangeMutationHookResult = ReturnType<typeof useAddIncomeRangeMutation>;
export type AddIncomeRangeMutationResult = Apollo.MutationResult<AddIncomeRangeMutation>;
export type AddIncomeRangeMutationOptions = Apollo.BaseMutationOptions<AddIncomeRangeMutation, AddIncomeRangeMutationVariables>;
export const DeleteIncomeRangeByIdDocument = gql`
    mutation deleteIncomeRangeById($incomeRangeId: String!) {
  deleteIncomeRangeById(incomeRangeId: $incomeRangeId)
}
    `;
export type DeleteIncomeRangeByIdMutationFn = Apollo.MutationFunction<DeleteIncomeRangeByIdMutation, DeleteIncomeRangeByIdMutationVariables>;

/**
 * __useDeleteIncomeRangeByIdMutation__
 *
 * To run a mutation, you first call `useDeleteIncomeRangeByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIncomeRangeByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIncomeRangeByIdMutation, { data, loading, error }] = useDeleteIncomeRangeByIdMutation({
 *   variables: {
 *      incomeRangeId: // value for 'incomeRangeId'
 *   },
 * });
 */
export function useDeleteIncomeRangeByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteIncomeRangeByIdMutation, DeleteIncomeRangeByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteIncomeRangeByIdMutation, DeleteIncomeRangeByIdMutationVariables>(DeleteIncomeRangeByIdDocument, options);
      }
export type DeleteIncomeRangeByIdMutationHookResult = ReturnType<typeof useDeleteIncomeRangeByIdMutation>;
export type DeleteIncomeRangeByIdMutationResult = Apollo.MutationResult<DeleteIncomeRangeByIdMutation>;
export type DeleteIncomeRangeByIdMutationOptions = Apollo.BaseMutationOptions<DeleteIncomeRangeByIdMutation, DeleteIncomeRangeByIdMutationVariables>;
export const ActivateIncomeRangeByIdDocument = gql`
    mutation activateIncomeRangeById($incomeRangeId: String!) {
  activateIncomeRangeById(incomeRangeId: $incomeRangeId)
}
    `;
export type ActivateIncomeRangeByIdMutationFn = Apollo.MutationFunction<ActivateIncomeRangeByIdMutation, ActivateIncomeRangeByIdMutationVariables>;

/**
 * __useActivateIncomeRangeByIdMutation__
 *
 * To run a mutation, you first call `useActivateIncomeRangeByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateIncomeRangeByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateIncomeRangeByIdMutation, { data, loading, error }] = useActivateIncomeRangeByIdMutation({
 *   variables: {
 *      incomeRangeId: // value for 'incomeRangeId'
 *   },
 * });
 */
export function useActivateIncomeRangeByIdMutation(baseOptions?: Apollo.MutationHookOptions<ActivateIncomeRangeByIdMutation, ActivateIncomeRangeByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateIncomeRangeByIdMutation, ActivateIncomeRangeByIdMutationVariables>(ActivateIncomeRangeByIdDocument, options);
      }
export type ActivateIncomeRangeByIdMutationHookResult = ReturnType<typeof useActivateIncomeRangeByIdMutation>;
export type ActivateIncomeRangeByIdMutationResult = Apollo.MutationResult<ActivateIncomeRangeByIdMutation>;
export type ActivateIncomeRangeByIdMutationOptions = Apollo.BaseMutationOptions<ActivateIncomeRangeByIdMutation, ActivateIncomeRangeByIdMutationVariables>;
export const DeactivateIncomeRangeByIdDocument = gql`
    mutation deactivateIncomeRangeById($incomeRangeId: String!) {
  deactivateIncomeRangeById(incomeRangeId: $incomeRangeId)
}
    `;
export type DeactivateIncomeRangeByIdMutationFn = Apollo.MutationFunction<DeactivateIncomeRangeByIdMutation, DeactivateIncomeRangeByIdMutationVariables>;

/**
 * __useDeactivateIncomeRangeByIdMutation__
 *
 * To run a mutation, you first call `useDeactivateIncomeRangeByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateIncomeRangeByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateIncomeRangeByIdMutation, { data, loading, error }] = useDeactivateIncomeRangeByIdMutation({
 *   variables: {
 *      incomeRangeId: // value for 'incomeRangeId'
 *   },
 * });
 */
export function useDeactivateIncomeRangeByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateIncomeRangeByIdMutation, DeactivateIncomeRangeByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateIncomeRangeByIdMutation, DeactivateIncomeRangeByIdMutationVariables>(DeactivateIncomeRangeByIdDocument, options);
      }
export type DeactivateIncomeRangeByIdMutationHookResult = ReturnType<typeof useDeactivateIncomeRangeByIdMutation>;
export type DeactivateIncomeRangeByIdMutationResult = Apollo.MutationResult<DeactivateIncomeRangeByIdMutation>;
export type DeactivateIncomeRangeByIdMutationOptions = Apollo.BaseMutationOptions<DeactivateIncomeRangeByIdMutation, DeactivateIncomeRangeByIdMutationVariables>;
export const EditIncomeRangeDocument = gql`
    mutation editIncomeRange($input: EditIncomeRangeInput!) {
  editIncomeRange(input: $input)
}
    `;
export type EditIncomeRangeMutationFn = Apollo.MutationFunction<EditIncomeRangeMutation, EditIncomeRangeMutationVariables>;

/**
 * __useEditIncomeRangeMutation__
 *
 * To run a mutation, you first call `useEditIncomeRangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditIncomeRangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editIncomeRangeMutation, { data, loading, error }] = useEditIncomeRangeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditIncomeRangeMutation(baseOptions?: Apollo.MutationHookOptions<EditIncomeRangeMutation, EditIncomeRangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditIncomeRangeMutation, EditIncomeRangeMutationVariables>(EditIncomeRangeDocument, options);
      }
export type EditIncomeRangeMutationHookResult = ReturnType<typeof useEditIncomeRangeMutation>;
export type EditIncomeRangeMutationResult = Apollo.MutationResult<EditIncomeRangeMutation>;
export type EditIncomeRangeMutationOptions = Apollo.BaseMutationOptions<EditIncomeRangeMutation, EditIncomeRangeMutationVariables>;
export const SetDefaultIncomeRangeDocument = gql`
    mutation setDefaultIncomeRange($incomeRangeId: String!) {
  setDefaultIncomeRange(incomeRangeId: $incomeRangeId)
}
    `;
export type SetDefaultIncomeRangeMutationFn = Apollo.MutationFunction<SetDefaultIncomeRangeMutation, SetDefaultIncomeRangeMutationVariables>;

/**
 * __useSetDefaultIncomeRangeMutation__
 *
 * To run a mutation, you first call `useSetDefaultIncomeRangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultIncomeRangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultIncomeRangeMutation, { data, loading, error }] = useSetDefaultIncomeRangeMutation({
 *   variables: {
 *      incomeRangeId: // value for 'incomeRangeId'
 *   },
 * });
 */
export function useSetDefaultIncomeRangeMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultIncomeRangeMutation, SetDefaultIncomeRangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultIncomeRangeMutation, SetDefaultIncomeRangeMutationVariables>(SetDefaultIncomeRangeDocument, options);
      }
export type SetDefaultIncomeRangeMutationHookResult = ReturnType<typeof useSetDefaultIncomeRangeMutation>;
export type SetDefaultIncomeRangeMutationResult = Apollo.MutationResult<SetDefaultIncomeRangeMutation>;
export type SetDefaultIncomeRangeMutationOptions = Apollo.BaseMutationOptions<SetDefaultIncomeRangeMutation, SetDefaultIncomeRangeMutationVariables>;
export const RemoveDefaultIncomeRangeDocument = gql`
    mutation removeDefaultIncomeRange($incomeRangeId: String!) {
  removeDefaultIncomeRange(incomeRangeId: $incomeRangeId)
}
    `;
export type RemoveDefaultIncomeRangeMutationFn = Apollo.MutationFunction<RemoveDefaultIncomeRangeMutation, RemoveDefaultIncomeRangeMutationVariables>;

/**
 * __useRemoveDefaultIncomeRangeMutation__
 *
 * To run a mutation, you first call `useRemoveDefaultIncomeRangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDefaultIncomeRangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDefaultIncomeRangeMutation, { data, loading, error }] = useRemoveDefaultIncomeRangeMutation({
 *   variables: {
 *      incomeRangeId: // value for 'incomeRangeId'
 *   },
 * });
 */
export function useRemoveDefaultIncomeRangeMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDefaultIncomeRangeMutation, RemoveDefaultIncomeRangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveDefaultIncomeRangeMutation, RemoveDefaultIncomeRangeMutationVariables>(RemoveDefaultIncomeRangeDocument, options);
      }
export type RemoveDefaultIncomeRangeMutationHookResult = ReturnType<typeof useRemoveDefaultIncomeRangeMutation>;
export type RemoveDefaultIncomeRangeMutationResult = Apollo.MutationResult<RemoveDefaultIncomeRangeMutation>;
export type RemoveDefaultIncomeRangeMutationOptions = Apollo.BaseMutationOptions<RemoveDefaultIncomeRangeMutation, RemoveDefaultIncomeRangeMutationVariables>;
export const OrganizeIncomeRangeDocument = gql`
    mutation organizeIncomeRange($incomeRangeIds: [String!]!) {
  organizeIncomeRange(incomeRangeIds: $incomeRangeIds)
}
    `;
export type OrganizeIncomeRangeMutationFn = Apollo.MutationFunction<OrganizeIncomeRangeMutation, OrganizeIncomeRangeMutationVariables>;

/**
 * __useOrganizeIncomeRangeMutation__
 *
 * To run a mutation, you first call `useOrganizeIncomeRangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizeIncomeRangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizeIncomeRangeMutation, { data, loading, error }] = useOrganizeIncomeRangeMutation({
 *   variables: {
 *      incomeRangeIds: // value for 'incomeRangeIds'
 *   },
 * });
 */
export function useOrganizeIncomeRangeMutation(baseOptions?: Apollo.MutationHookOptions<OrganizeIncomeRangeMutation, OrganizeIncomeRangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizeIncomeRangeMutation, OrganizeIncomeRangeMutationVariables>(OrganizeIncomeRangeDocument, options);
      }
export type OrganizeIncomeRangeMutationHookResult = ReturnType<typeof useOrganizeIncomeRangeMutation>;
export type OrganizeIncomeRangeMutationResult = Apollo.MutationResult<OrganizeIncomeRangeMutation>;
export type OrganizeIncomeRangeMutationOptions = Apollo.BaseMutationOptions<OrganizeIncomeRangeMutation, OrganizeIncomeRangeMutationVariables>;
export const GetAllSalutationDocument = gql`
    query getAllSalutation {
  getAllSalutation {
    id
    name
    commonStatus
    defaulted
    isDeletable
    isExistInTransactionData
  }
}
    `;

/**
 * __useGetAllSalutationQuery__
 *
 * To run a query within a React component, call `useGetAllSalutationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSalutationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllSalutationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllSalutationQuery(baseOptions?: Apollo.QueryHookOptions<GetAllSalutationQuery, GetAllSalutationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllSalutationQuery, GetAllSalutationQueryVariables>(GetAllSalutationDocument, options);
      }
export function useGetAllSalutationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllSalutationQuery, GetAllSalutationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllSalutationQuery, GetAllSalutationQueryVariables>(GetAllSalutationDocument, options);
        }
export type GetAllSalutationQueryHookResult = ReturnType<typeof useGetAllSalutationQuery>;
export type GetAllSalutationLazyQueryHookResult = ReturnType<typeof useGetAllSalutationLazyQuery>;
export type GetAllSalutationQueryResult = Apollo.QueryResult<GetAllSalutationQuery, GetAllSalutationQueryVariables>;
export const AddSalutationDocument = gql`
    mutation addSalutation($input: SalutationInput!) {
  addSalutation(input: $input)
}
    `;
export type AddSalutationMutationFn = Apollo.MutationFunction<AddSalutationMutation, AddSalutationMutationVariables>;

/**
 * __useAddSalutationMutation__
 *
 * To run a mutation, you first call `useAddSalutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSalutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSalutationMutation, { data, loading, error }] = useAddSalutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddSalutationMutation(baseOptions?: Apollo.MutationHookOptions<AddSalutationMutation, AddSalutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSalutationMutation, AddSalutationMutationVariables>(AddSalutationDocument, options);
      }
export type AddSalutationMutationHookResult = ReturnType<typeof useAddSalutationMutation>;
export type AddSalutationMutationResult = Apollo.MutationResult<AddSalutationMutation>;
export type AddSalutationMutationOptions = Apollo.BaseMutationOptions<AddSalutationMutation, AddSalutationMutationVariables>;
export const EditSalutationDocument = gql`
    mutation editSalutation($input: EditSalutationInput!) {
  editSalutation(input: $input)
}
    `;
export type EditSalutationMutationFn = Apollo.MutationFunction<EditSalutationMutation, EditSalutationMutationVariables>;

/**
 * __useEditSalutationMutation__
 *
 * To run a mutation, you first call `useEditSalutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSalutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSalutationMutation, { data, loading, error }] = useEditSalutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditSalutationMutation(baseOptions?: Apollo.MutationHookOptions<EditSalutationMutation, EditSalutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditSalutationMutation, EditSalutationMutationVariables>(EditSalutationDocument, options);
      }
export type EditSalutationMutationHookResult = ReturnType<typeof useEditSalutationMutation>;
export type EditSalutationMutationResult = Apollo.MutationResult<EditSalutationMutation>;
export type EditSalutationMutationOptions = Apollo.BaseMutationOptions<EditSalutationMutation, EditSalutationMutationVariables>;
export const DeleteSalutationByIdDocument = gql`
    mutation deleteSalutationById($salutationId: String!) {
  deleteSalutationById(salutationId: $salutationId)
}
    `;
export type DeleteSalutationByIdMutationFn = Apollo.MutationFunction<DeleteSalutationByIdMutation, DeleteSalutationByIdMutationVariables>;

/**
 * __useDeleteSalutationByIdMutation__
 *
 * To run a mutation, you first call `useDeleteSalutationByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSalutationByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSalutationByIdMutation, { data, loading, error }] = useDeleteSalutationByIdMutation({
 *   variables: {
 *      salutationId: // value for 'salutationId'
 *   },
 * });
 */
export function useDeleteSalutationByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSalutationByIdMutation, DeleteSalutationByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSalutationByIdMutation, DeleteSalutationByIdMutationVariables>(DeleteSalutationByIdDocument, options);
      }
export type DeleteSalutationByIdMutationHookResult = ReturnType<typeof useDeleteSalutationByIdMutation>;
export type DeleteSalutationByIdMutationResult = Apollo.MutationResult<DeleteSalutationByIdMutation>;
export type DeleteSalutationByIdMutationOptions = Apollo.BaseMutationOptions<DeleteSalutationByIdMutation, DeleteSalutationByIdMutationVariables>;
export const SetDefaultSalutationDocument = gql`
    mutation setDefaultSalutation($salutationId: String!) {
  setDefaultSalutation(salutationId: $salutationId)
}
    `;
export type SetDefaultSalutationMutationFn = Apollo.MutationFunction<SetDefaultSalutationMutation, SetDefaultSalutationMutationVariables>;

/**
 * __useSetDefaultSalutationMutation__
 *
 * To run a mutation, you first call `useSetDefaultSalutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultSalutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultSalutationMutation, { data, loading, error }] = useSetDefaultSalutationMutation({
 *   variables: {
 *      salutationId: // value for 'salutationId'
 *   },
 * });
 */
export function useSetDefaultSalutationMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultSalutationMutation, SetDefaultSalutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultSalutationMutation, SetDefaultSalutationMutationVariables>(SetDefaultSalutationDocument, options);
      }
export type SetDefaultSalutationMutationHookResult = ReturnType<typeof useSetDefaultSalutationMutation>;
export type SetDefaultSalutationMutationResult = Apollo.MutationResult<SetDefaultSalutationMutation>;
export type SetDefaultSalutationMutationOptions = Apollo.BaseMutationOptions<SetDefaultSalutationMutation, SetDefaultSalutationMutationVariables>;
export const RemoveDefaultSalutationDocument = gql`
    mutation removeDefaultSalutation($salutationId: String!) {
  removeDefaultSalutation(salutationId: $salutationId)
}
    `;
export type RemoveDefaultSalutationMutationFn = Apollo.MutationFunction<RemoveDefaultSalutationMutation, RemoveDefaultSalutationMutationVariables>;

/**
 * __useRemoveDefaultSalutationMutation__
 *
 * To run a mutation, you first call `useRemoveDefaultSalutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDefaultSalutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDefaultSalutationMutation, { data, loading, error }] = useRemoveDefaultSalutationMutation({
 *   variables: {
 *      salutationId: // value for 'salutationId'
 *   },
 * });
 */
export function useRemoveDefaultSalutationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDefaultSalutationMutation, RemoveDefaultSalutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveDefaultSalutationMutation, RemoveDefaultSalutationMutationVariables>(RemoveDefaultSalutationDocument, options);
      }
export type RemoveDefaultSalutationMutationHookResult = ReturnType<typeof useRemoveDefaultSalutationMutation>;
export type RemoveDefaultSalutationMutationResult = Apollo.MutationResult<RemoveDefaultSalutationMutation>;
export type RemoveDefaultSalutationMutationOptions = Apollo.BaseMutationOptions<RemoveDefaultSalutationMutation, RemoveDefaultSalutationMutationVariables>;
export const OrganizeSalutationDocument = gql`
    mutation organizeSalutation($salutationIds: [String!]!) {
  organizeSalutation(salutationIds: $salutationIds)
}
    `;
export type OrganizeSalutationMutationFn = Apollo.MutationFunction<OrganizeSalutationMutation, OrganizeSalutationMutationVariables>;

/**
 * __useOrganizeSalutationMutation__
 *
 * To run a mutation, you first call `useOrganizeSalutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizeSalutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizeSalutationMutation, { data, loading, error }] = useOrganizeSalutationMutation({
 *   variables: {
 *      salutationIds: // value for 'salutationIds'
 *   },
 * });
 */
export function useOrganizeSalutationMutation(baseOptions?: Apollo.MutationHookOptions<OrganizeSalutationMutation, OrganizeSalutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizeSalutationMutation, OrganizeSalutationMutationVariables>(OrganizeSalutationDocument, options);
      }
export type OrganizeSalutationMutationHookResult = ReturnType<typeof useOrganizeSalutationMutation>;
export type OrganizeSalutationMutationResult = Apollo.MutationResult<OrganizeSalutationMutation>;
export type OrganizeSalutationMutationOptions = Apollo.BaseMutationOptions<OrganizeSalutationMutation, OrganizeSalutationMutationVariables>;
export const ActivateSalutationDocument = gql`
    mutation activateSalutation($salutationId: String!) {
  activateSalutation(salutationId: $salutationId)
}
    `;
export type ActivateSalutationMutationFn = Apollo.MutationFunction<ActivateSalutationMutation, ActivateSalutationMutationVariables>;

/**
 * __useActivateSalutationMutation__
 *
 * To run a mutation, you first call `useActivateSalutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateSalutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateSalutationMutation, { data, loading, error }] = useActivateSalutationMutation({
 *   variables: {
 *      salutationId: // value for 'salutationId'
 *   },
 * });
 */
export function useActivateSalutationMutation(baseOptions?: Apollo.MutationHookOptions<ActivateSalutationMutation, ActivateSalutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateSalutationMutation, ActivateSalutationMutationVariables>(ActivateSalutationDocument, options);
      }
export type ActivateSalutationMutationHookResult = ReturnType<typeof useActivateSalutationMutation>;
export type ActivateSalutationMutationResult = Apollo.MutationResult<ActivateSalutationMutation>;
export type ActivateSalutationMutationOptions = Apollo.BaseMutationOptions<ActivateSalutationMutation, ActivateSalutationMutationVariables>;
export const DeactivateSalutationDocument = gql`
    mutation deactivateSalutation($salutationId: String!) {
  deactivateSalutation(salutationId: $salutationId)
}
    `;
export type DeactivateSalutationMutationFn = Apollo.MutationFunction<DeactivateSalutationMutation, DeactivateSalutationMutationVariables>;

/**
 * __useDeactivateSalutationMutation__
 *
 * To run a mutation, you first call `useDeactivateSalutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateSalutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateSalutationMutation, { data, loading, error }] = useDeactivateSalutationMutation({
 *   variables: {
 *      salutationId: // value for 'salutationId'
 *   },
 * });
 */
export function useDeactivateSalutationMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateSalutationMutation, DeactivateSalutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateSalutationMutation, DeactivateSalutationMutationVariables>(DeactivateSalutationDocument, options);
      }
export type DeactivateSalutationMutationHookResult = ReturnType<typeof useDeactivateSalutationMutation>;
export type DeactivateSalutationMutationResult = Apollo.MutationResult<DeactivateSalutationMutation>;
export type DeactivateSalutationMutationOptions = Apollo.BaseMutationOptions<DeactivateSalutationMutation, DeactivateSalutationMutationVariables>;
export const OrganizeParameterDocument = gql`
    mutation organizeParameter($parameterIds: [String!]!, $parameterType: String!) {
  organizeParameter(parameterIds: $parameterIds, parameterType: $parameterType)
}
    `;
export type OrganizeParameterMutationFn = Apollo.MutationFunction<OrganizeParameterMutation, OrganizeParameterMutationVariables>;

/**
 * __useOrganizeParameterMutation__
 *
 * To run a mutation, you first call `useOrganizeParameterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizeParameterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizeParameterMutation, { data, loading, error }] = useOrganizeParameterMutation({
 *   variables: {
 *      parameterIds: // value for 'parameterIds'
 *      parameterType: // value for 'parameterType'
 *   },
 * });
 */
export function useOrganizeParameterMutation(baseOptions?: Apollo.MutationHookOptions<OrganizeParameterMutation, OrganizeParameterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizeParameterMutation, OrganizeParameterMutationVariables>(OrganizeParameterDocument, options);
      }
export type OrganizeParameterMutationHookResult = ReturnType<typeof useOrganizeParameterMutation>;
export type OrganizeParameterMutationResult = Apollo.MutationResult<OrganizeParameterMutation>;
export type OrganizeParameterMutationOptions = Apollo.BaseMutationOptions<OrganizeParameterMutation, OrganizeParameterMutationVariables>;
export const SetDefaultParameterDocument = gql`
    mutation setDefaultParameter($parameterId: String!, $parameterType: String!) {
  setDefaultParameter(parameterId: $parameterId, parameterType: $parameterType)
}
    `;
export type SetDefaultParameterMutationFn = Apollo.MutationFunction<SetDefaultParameterMutation, SetDefaultParameterMutationVariables>;

/**
 * __useSetDefaultParameterMutation__
 *
 * To run a mutation, you first call `useSetDefaultParameterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultParameterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultParameterMutation, { data, loading, error }] = useSetDefaultParameterMutation({
 *   variables: {
 *      parameterId: // value for 'parameterId'
 *      parameterType: // value for 'parameterType'
 *   },
 * });
 */
export function useSetDefaultParameterMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultParameterMutation, SetDefaultParameterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultParameterMutation, SetDefaultParameterMutationVariables>(SetDefaultParameterDocument, options);
      }
export type SetDefaultParameterMutationHookResult = ReturnType<typeof useSetDefaultParameterMutation>;
export type SetDefaultParameterMutationResult = Apollo.MutationResult<SetDefaultParameterMutation>;
export type SetDefaultParameterMutationOptions = Apollo.BaseMutationOptions<SetDefaultParameterMutation, SetDefaultParameterMutationVariables>;
export const RemoveDefaultParameterDocument = gql`
    mutation removeDefaultParameter($parameterId: String!, $parameterType: String!) {
  removeDefaultParameter(parameterId: $parameterId, parameterType: $parameterType)
}
    `;
export type RemoveDefaultParameterMutationFn = Apollo.MutationFunction<RemoveDefaultParameterMutation, RemoveDefaultParameterMutationVariables>;

/**
 * __useRemoveDefaultParameterMutation__
 *
 * To run a mutation, you first call `useRemoveDefaultParameterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDefaultParameterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDefaultParameterMutation, { data, loading, error }] = useRemoveDefaultParameterMutation({
 *   variables: {
 *      parameterId: // value for 'parameterId'
 *      parameterType: // value for 'parameterType'
 *   },
 * });
 */
export function useRemoveDefaultParameterMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDefaultParameterMutation, RemoveDefaultParameterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveDefaultParameterMutation, RemoveDefaultParameterMutationVariables>(RemoveDefaultParameterDocument, options);
      }
export type RemoveDefaultParameterMutationHookResult = ReturnType<typeof useRemoveDefaultParameterMutation>;
export type RemoveDefaultParameterMutationResult = Apollo.MutationResult<RemoveDefaultParameterMutation>;
export type RemoveDefaultParameterMutationOptions = Apollo.BaseMutationOptions<RemoveDefaultParameterMutation, RemoveDefaultParameterMutationVariables>;
export const StandardParameterSummaryDocument = gql`
    query standardParameterSummary {
  propertyTypeCount
  projectTypeCount
  unitDirectionCount
  unitTypeCount
  raceCount
  maritalStatusCount
  salutationCount
  religonCount
  relationshipCount
  educationCount
  industryCount
  designationCount
  professionCount
  incomeRangeCount
}
    `;

/**
 * __useStandardParameterSummaryQuery__
 *
 * To run a query within a React component, call `useStandardParameterSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useStandardParameterSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStandardParameterSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useStandardParameterSummaryQuery(baseOptions?: Apollo.QueryHookOptions<StandardParameterSummaryQuery, StandardParameterSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StandardParameterSummaryQuery, StandardParameterSummaryQueryVariables>(StandardParameterSummaryDocument, options);
      }
export function useStandardParameterSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StandardParameterSummaryQuery, StandardParameterSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StandardParameterSummaryQuery, StandardParameterSummaryQueryVariables>(StandardParameterSummaryDocument, options);
        }
export type StandardParameterSummaryQueryHookResult = ReturnType<typeof useStandardParameterSummaryQuery>;
export type StandardParameterSummaryLazyQueryHookResult = ReturnType<typeof useStandardParameterSummaryLazyQuery>;
export type StandardParameterSummaryQueryResult = Apollo.QueryResult<StandardParameterSummaryQuery, StandardParameterSummaryQueryVariables>;
export const GetStatutoryTypeDocument = gql`
    query getStatutoryType {
  getStatutoryDocsList {
    id
    code
    name
    perSalesContract
  }
}
    `;

/**
 * __useGetStatutoryTypeQuery__
 *
 * To run a query within a React component, call `useGetStatutoryTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStatutoryTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStatutoryTypeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStatutoryTypeQuery(baseOptions?: Apollo.QueryHookOptions<GetStatutoryTypeQuery, GetStatutoryTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStatutoryTypeQuery, GetStatutoryTypeQueryVariables>(GetStatutoryTypeDocument, options);
      }
export function useGetStatutoryTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStatutoryTypeQuery, GetStatutoryTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStatutoryTypeQuery, GetStatutoryTypeQueryVariables>(GetStatutoryTypeDocument, options);
        }
export type GetStatutoryTypeQueryHookResult = ReturnType<typeof useGetStatutoryTypeQuery>;
export type GetStatutoryTypeLazyQueryHookResult = ReturnType<typeof useGetStatutoryTypeLazyQuery>;
export type GetStatutoryTypeQueryResult = Apollo.QueryResult<GetStatutoryTypeQuery, GetStatutoryTypeQueryVariables>;
export const GetUnitStatutoryDocumentListByTypeDocument = gql`
    query getUnitStatutoryDocumentListByType($projectId: String!, $perSalesContract: Boolean!, $statutoryDocumentId: String!) {
  getUnitStatutoryDocumentListByType(projectId: $projectId, perSalesContract: $perSalesContract, statutoryDocumentId: $statutoryDocumentId) {
    unitStatutoryId
    projectId
    unitId
    unitNo
    fullName
    saleId
    contactId
    perSalesContract
    totalUploaded
    totalNeedToBeUpload
    documents {
      id
      projectId
      accountId
      unitStatutoryId
      statutoryDocumentId
      documentRef
      documentDate
      isMerge
      attachment
      notaryId
      bpnLandArea
      resourceUrl
      fileName
      mediaType
    }
  }
}
    `;

/**
 * __useGetUnitStatutoryDocumentListByTypeQuery__
 *
 * To run a query within a React component, call `useGetUnitStatutoryDocumentListByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitStatutoryDocumentListByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitStatutoryDocumentListByTypeQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      perSalesContract: // value for 'perSalesContract'
 *      statutoryDocumentId: // value for 'statutoryDocumentId'
 *   },
 * });
 */
export function useGetUnitStatutoryDocumentListByTypeQuery(baseOptions: Apollo.QueryHookOptions<GetUnitStatutoryDocumentListByTypeQuery, GetUnitStatutoryDocumentListByTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitStatutoryDocumentListByTypeQuery, GetUnitStatutoryDocumentListByTypeQueryVariables>(GetUnitStatutoryDocumentListByTypeDocument, options);
      }
export function useGetUnitStatutoryDocumentListByTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitStatutoryDocumentListByTypeQuery, GetUnitStatutoryDocumentListByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitStatutoryDocumentListByTypeQuery, GetUnitStatutoryDocumentListByTypeQueryVariables>(GetUnitStatutoryDocumentListByTypeDocument, options);
        }
export type GetUnitStatutoryDocumentListByTypeQueryHookResult = ReturnType<typeof useGetUnitStatutoryDocumentListByTypeQuery>;
export type GetUnitStatutoryDocumentListByTypeLazyQueryHookResult = ReturnType<typeof useGetUnitStatutoryDocumentListByTypeLazyQuery>;
export type GetUnitStatutoryDocumentListByTypeQueryResult = Apollo.QueryResult<GetUnitStatutoryDocumentListByTypeQuery, GetUnitStatutoryDocumentListByTypeQueryVariables>;
export const GetStatutoryUnitListDocument = gql`
    query getStatutoryUnitList($projectId: String!) {
  getStatutoryUnitList(projectId: $projectId) {
    unitId
    unitNo
    clusterName
    fullName
  }
}
    `;

/**
 * __useGetStatutoryUnitListQuery__
 *
 * To run a query within a React component, call `useGetStatutoryUnitListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStatutoryUnitListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStatutoryUnitListQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetStatutoryUnitListQuery(baseOptions: Apollo.QueryHookOptions<GetStatutoryUnitListQuery, GetStatutoryUnitListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStatutoryUnitListQuery, GetStatutoryUnitListQueryVariables>(GetStatutoryUnitListDocument, options);
      }
export function useGetStatutoryUnitListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStatutoryUnitListQuery, GetStatutoryUnitListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStatutoryUnitListQuery, GetStatutoryUnitListQueryVariables>(GetStatutoryUnitListDocument, options);
        }
export type GetStatutoryUnitListQueryHookResult = ReturnType<typeof useGetStatutoryUnitListQuery>;
export type GetStatutoryUnitListLazyQueryHookResult = ReturnType<typeof useGetStatutoryUnitListLazyQuery>;
export type GetStatutoryUnitListQueryResult = Apollo.QueryResult<GetStatutoryUnitListQuery, GetStatutoryUnitListQueryVariables>;
export const GetStatutoryTypeByUnitDocument = gql`
    query getStatutoryTypeByUnit($unitId: String!, $projectId: String!) {
  getStatutoryTypeByUnit(unitId: $unitId, projectId: $projectId) {
    statutoryDocId
    unitStatutoryId
    code
    name
    saleId
    contactId
    fullName
    perSalesContract
    totalUploaded
    totalNeedToBeUploaded
    documents {
      id
      accountId
      unitStatutoryId
      projectId
      documentRef
      documentDate
      statutoryDocumentId
      isMerge
      notaryId
      bpnLandArea
      attachment
      notaryId
      bpnLandArea
      resourceUrl
      fileName
      mediaType
    }
  }
}
    `;

/**
 * __useGetStatutoryTypeByUnitQuery__
 *
 * To run a query within a React component, call `useGetStatutoryTypeByUnitQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStatutoryTypeByUnitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStatutoryTypeByUnitQuery({
 *   variables: {
 *      unitId: // value for 'unitId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetStatutoryTypeByUnitQuery(baseOptions: Apollo.QueryHookOptions<GetStatutoryTypeByUnitQuery, GetStatutoryTypeByUnitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStatutoryTypeByUnitQuery, GetStatutoryTypeByUnitQueryVariables>(GetStatutoryTypeByUnitDocument, options);
      }
export function useGetStatutoryTypeByUnitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStatutoryTypeByUnitQuery, GetStatutoryTypeByUnitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStatutoryTypeByUnitQuery, GetStatutoryTypeByUnitQueryVariables>(GetStatutoryTypeByUnitDocument, options);
        }
export type GetStatutoryTypeByUnitQueryHookResult = ReturnType<typeof useGetStatutoryTypeByUnitQuery>;
export type GetStatutoryTypeByUnitLazyQueryHookResult = ReturnType<typeof useGetStatutoryTypeByUnitLazyQuery>;
export type GetStatutoryTypeByUnitQueryResult = Apollo.QueryResult<GetStatutoryTypeByUnitQuery, GetStatutoryTypeByUnitQueryVariables>;
export const AddSalesStatutoryDocumentDocument = gql`
    mutation addSalesStatutoryDocument($input: AddSalesStatutoryDocumentIndoInput!) {
  addSalesStatutoryDocument(input: $input)
}
    `;
export type AddSalesStatutoryDocumentMutationFn = Apollo.MutationFunction<AddSalesStatutoryDocumentMutation, AddSalesStatutoryDocumentMutationVariables>;

/**
 * __useAddSalesStatutoryDocumentMutation__
 *
 * To run a mutation, you first call `useAddSalesStatutoryDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSalesStatutoryDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSalesStatutoryDocumentMutation, { data, loading, error }] = useAddSalesStatutoryDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddSalesStatutoryDocumentMutation(baseOptions?: Apollo.MutationHookOptions<AddSalesStatutoryDocumentMutation, AddSalesStatutoryDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSalesStatutoryDocumentMutation, AddSalesStatutoryDocumentMutationVariables>(AddSalesStatutoryDocumentDocument, options);
      }
export type AddSalesStatutoryDocumentMutationHookResult = ReturnType<typeof useAddSalesStatutoryDocumentMutation>;
export type AddSalesStatutoryDocumentMutationResult = Apollo.MutationResult<AddSalesStatutoryDocumentMutation>;
export type AddSalesStatutoryDocumentMutationOptions = Apollo.BaseMutationOptions<AddSalesStatutoryDocumentMutation, AddSalesStatutoryDocumentMutationVariables>;
export const EditSalesStatutoryDocumentDocument = gql`
    mutation editSalesStatutoryDocument($input: EditSalesStatutoryDocumentIndoInput!) {
  editSalesStatutoryDocument(input: $input)
}
    `;
export type EditSalesStatutoryDocumentMutationFn = Apollo.MutationFunction<EditSalesStatutoryDocumentMutation, EditSalesStatutoryDocumentMutationVariables>;

/**
 * __useEditSalesStatutoryDocumentMutation__
 *
 * To run a mutation, you first call `useEditSalesStatutoryDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSalesStatutoryDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSalesStatutoryDocumentMutation, { data, loading, error }] = useEditSalesStatutoryDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditSalesStatutoryDocumentMutation(baseOptions?: Apollo.MutationHookOptions<EditSalesStatutoryDocumentMutation, EditSalesStatutoryDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditSalesStatutoryDocumentMutation, EditSalesStatutoryDocumentMutationVariables>(EditSalesStatutoryDocumentDocument, options);
      }
export type EditSalesStatutoryDocumentMutationHookResult = ReturnType<typeof useEditSalesStatutoryDocumentMutation>;
export type EditSalesStatutoryDocumentMutationResult = Apollo.MutationResult<EditSalesStatutoryDocumentMutation>;
export type EditSalesStatutoryDocumentMutationOptions = Apollo.BaseMutationOptions<EditSalesStatutoryDocumentMutation, EditSalesStatutoryDocumentMutationVariables>;
export const DeleteSalesStatutoryDocumentDocument = gql`
    mutation deleteSalesStatutoryDocument($id: String!) {
  deleteSalesStatutoryDocument(id: $id)
}
    `;
export type DeleteSalesStatutoryDocumentMutationFn = Apollo.MutationFunction<DeleteSalesStatutoryDocumentMutation, DeleteSalesStatutoryDocumentMutationVariables>;

/**
 * __useDeleteSalesStatutoryDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteSalesStatutoryDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSalesStatutoryDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSalesStatutoryDocumentMutation, { data, loading, error }] = useDeleteSalesStatutoryDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSalesStatutoryDocumentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSalesStatutoryDocumentMutation, DeleteSalesStatutoryDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSalesStatutoryDocumentMutation, DeleteSalesStatutoryDocumentMutationVariables>(DeleteSalesStatutoryDocumentDocument, options);
      }
export type DeleteSalesStatutoryDocumentMutationHookResult = ReturnType<typeof useDeleteSalesStatutoryDocumentMutation>;
export type DeleteSalesStatutoryDocumentMutationResult = Apollo.MutationResult<DeleteSalesStatutoryDocumentMutation>;
export type DeleteSalesStatutoryDocumentMutationOptions = Apollo.BaseMutationOptions<DeleteSalesStatutoryDocumentMutation, DeleteSalesStatutoryDocumentMutationVariables>;
export const MergeSalesStatutoryDocumentDocument = gql`
    mutation mergeSalesStatutoryDocument($input: MergeSalesStatutoryDocumentIndoInput!) {
  mergeSalesStatutoryDocument(input: $input)
}
    `;
export type MergeSalesStatutoryDocumentMutationFn = Apollo.MutationFunction<MergeSalesStatutoryDocumentMutation, MergeSalesStatutoryDocumentMutationVariables>;

/**
 * __useMergeSalesStatutoryDocumentMutation__
 *
 * To run a mutation, you first call `useMergeSalesStatutoryDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeSalesStatutoryDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeSalesStatutoryDocumentMutation, { data, loading, error }] = useMergeSalesStatutoryDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMergeSalesStatutoryDocumentMutation(baseOptions?: Apollo.MutationHookOptions<MergeSalesStatutoryDocumentMutation, MergeSalesStatutoryDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MergeSalesStatutoryDocumentMutation, MergeSalesStatutoryDocumentMutationVariables>(MergeSalesStatutoryDocumentDocument, options);
      }
export type MergeSalesStatutoryDocumentMutationHookResult = ReturnType<typeof useMergeSalesStatutoryDocumentMutation>;
export type MergeSalesStatutoryDocumentMutationResult = Apollo.MutationResult<MergeSalesStatutoryDocumentMutation>;
export type MergeSalesStatutoryDocumentMutationOptions = Apollo.BaseMutationOptions<MergeSalesStatutoryDocumentMutation, MergeSalesStatutoryDocumentMutationVariables>;
export const DownloadStatutoryDocumentListDocument = gql`
    query downloadStatutoryDocumentList($projectId: String!) {
  downloadStatutoryDocumentList(projectId: $projectId) {
    base64
    isSubProduct
    projectname
  }
}
    `;

/**
 * __useDownloadStatutoryDocumentListQuery__
 *
 * To run a query within a React component, call `useDownloadStatutoryDocumentListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadStatutoryDocumentListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadStatutoryDocumentListQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useDownloadStatutoryDocumentListQuery(baseOptions: Apollo.QueryHookOptions<DownloadStatutoryDocumentListQuery, DownloadStatutoryDocumentListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadStatutoryDocumentListQuery, DownloadStatutoryDocumentListQueryVariables>(DownloadStatutoryDocumentListDocument, options);
      }
export function useDownloadStatutoryDocumentListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadStatutoryDocumentListQuery, DownloadStatutoryDocumentListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadStatutoryDocumentListQuery, DownloadStatutoryDocumentListQueryVariables>(DownloadStatutoryDocumentListDocument, options);
        }
export type DownloadStatutoryDocumentListQueryHookResult = ReturnType<typeof useDownloadStatutoryDocumentListQuery>;
export type DownloadStatutoryDocumentListLazyQueryHookResult = ReturnType<typeof useDownloadStatutoryDocumentListLazyQuery>;
export type DownloadStatutoryDocumentListQueryResult = Apollo.QueryResult<DownloadStatutoryDocumentListQuery, DownloadStatutoryDocumentListQueryVariables>;
export const UploadStatutoryDocumentListDocument = gql`
    query uploadStatutoryDocumentList($projectId: String!, $file: Upload!) {
  uploadStatutoryDocumentList(projectId: $projectId, file: $file) {
    message
  }
}
    `;

/**
 * __useUploadStatutoryDocumentListQuery__
 *
 * To run a query within a React component, call `useUploadStatutoryDocumentListQuery` and pass it any options that fit your needs.
 * When your component renders, `useUploadStatutoryDocumentListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUploadStatutoryDocumentListQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadStatutoryDocumentListQuery(baseOptions: Apollo.QueryHookOptions<UploadStatutoryDocumentListQuery, UploadStatutoryDocumentListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UploadStatutoryDocumentListQuery, UploadStatutoryDocumentListQueryVariables>(UploadStatutoryDocumentListDocument, options);
      }
export function useUploadStatutoryDocumentListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UploadStatutoryDocumentListQuery, UploadStatutoryDocumentListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UploadStatutoryDocumentListQuery, UploadStatutoryDocumentListQueryVariables>(UploadStatutoryDocumentListDocument, options);
        }
export type UploadStatutoryDocumentListQueryHookResult = ReturnType<typeof useUploadStatutoryDocumentListQuery>;
export type UploadStatutoryDocumentListLazyQueryHookResult = ReturnType<typeof useUploadStatutoryDocumentListLazyQuery>;
export type UploadStatutoryDocumentListQueryResult = Apollo.QueryResult<UploadStatutoryDocumentListQuery, UploadStatutoryDocumentListQueryVariables>;
export const GetNotarySelectionListDocument = gql`
    query getNotarySelectionList($projectId: String!) {
  getNotarySelectionList(projectId: $projectId) {
    notaryId
    name
  }
}
    `;

/**
 * __useGetNotarySelectionListQuery__
 *
 * To run a query within a React component, call `useGetNotarySelectionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotarySelectionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotarySelectionListQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetNotarySelectionListQuery(baseOptions: Apollo.QueryHookOptions<GetNotarySelectionListQuery, GetNotarySelectionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotarySelectionListQuery, GetNotarySelectionListQueryVariables>(GetNotarySelectionListDocument, options);
      }
export function useGetNotarySelectionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotarySelectionListQuery, GetNotarySelectionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotarySelectionListQuery, GetNotarySelectionListQueryVariables>(GetNotarySelectionListDocument, options);
        }
export type GetNotarySelectionListQueryHookResult = ReturnType<typeof useGetNotarySelectionListQuery>;
export type GetNotarySelectionListLazyQueryHookResult = ReturnType<typeof useGetNotarySelectionListLazyQuery>;
export type GetNotarySelectionListQueryResult = Apollo.QueryResult<GetNotarySelectionListQuery, GetNotarySelectionListQueryVariables>;
export const GetAllSubsaleDocument = gql`
    query getAllSubsale {
  getAllSubsale {
    id
    unitNo
    spaDate
    sellingPrice
    purchaserName
    status
    isCompany
    companyName
  }
}
    `;

/**
 * __useGetAllSubsaleQuery__
 *
 * To run a query within a React component, call `useGetAllSubsaleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSubsaleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllSubsaleQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllSubsaleQuery(baseOptions?: Apollo.QueryHookOptions<GetAllSubsaleQuery, GetAllSubsaleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllSubsaleQuery, GetAllSubsaleQueryVariables>(GetAllSubsaleDocument, options);
      }
export function useGetAllSubsaleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllSubsaleQuery, GetAllSubsaleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllSubsaleQuery, GetAllSubsaleQueryVariables>(GetAllSubsaleDocument, options);
        }
export type GetAllSubsaleQueryHookResult = ReturnType<typeof useGetAllSubsaleQuery>;
export type GetAllSubsaleLazyQueryHookResult = ReturnType<typeof useGetAllSubsaleLazyQuery>;
export type GetAllSubsaleQueryResult = Apollo.QueryResult<GetAllSubsaleQuery, GetAllSubsaleQueryVariables>;
export const GetSubsaleByIdDocument = gql`
    query getSubsaleById($id: String!) {
  getSubsaleById(id: $id) {
    id
    units {
      id
      unitNo
    }
    subsaleCategory
    rrDate
    spaDate
    sellingPrice
    doaDate
    buyerSolicitorId
    buyerSolicitorReferenceNo
    vendorSolicitorId
    vendorSolicitorReferenceNo
    administrationCharges
    printingCharges
    serviceChargeDeposit
    dmcDate
    buyerName
    buyerIdentityNo
    isCompany
    contactId
    subsaleContactName {
      companyName
      companyRegNo
      nationality {
        id
        name
      }
      icNo
      militaryIc
      fullName
      salutation {
        id
        name
      }
      race {
        id
        name
      }
      maritalStatus {
        id
        name
      }
      gender
      email
      address {
        address
        country
        postCode
        state
        city
      }
      homeTel
      phoneNo
      officeTel
      subsaleContactExtension {
        customerOrigin
        identityType
        remark
        isBumi
        isForeignPurchase
        subscribeMaterialSms
        subscribeMaterialWhatsapp
        subscribeMaterialEmail
        subscribeMaterialPaNews
        mailingMethod
      }
    }
    subsaleJointBuyers {
      id
      subsaleJointBuyerContactName {
        nationality {
          id
          name
        }
        icNo
        militaryIc
        fullName
        salutation {
          id
          name
        }
        race {
          id
          name
        }
        maritalStatus {
          id
          name
        }
        gender
        email
        address {
          address
          country
          postCode
          state
          city
        }
        homeTel
        phoneNo
        officeTel
        subsaleJointBuyerContactExtension {
          customerOrigin
          identityType
          remark
          isBumi
          isForeignPurchase
          subscribeMaterialSms
          subscribeMaterialWhatsapp
          subscribeMaterialEmail
          subscribeMaterialPaNews
          mailingMethod
        }
      }
    }
    subsaleLoans {
      id
      subsaleFinancierName {
        name
        financierCode
      }
      financierId
      financierReferenceNo
      RRDate
      RRSolicitorId
      RRSolicitorReferenceNo
      DOADate
      DOASolicitorId
      DOASolicitorReferenceNo
      LoanSolicitorId
      loanSolicitorReferenceNo
    }
  }
}
    `;

/**
 * __useGetSubsaleByIdQuery__
 *
 * To run a query within a React component, call `useGetSubsaleByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubsaleByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubsaleByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSubsaleByIdQuery(baseOptions: Apollo.QueryHookOptions<GetSubsaleByIdQuery, GetSubsaleByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubsaleByIdQuery, GetSubsaleByIdQueryVariables>(GetSubsaleByIdDocument, options);
      }
export function useGetSubsaleByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubsaleByIdQuery, GetSubsaleByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubsaleByIdQuery, GetSubsaleByIdQueryVariables>(GetSubsaleByIdDocument, options);
        }
export type GetSubsaleByIdQueryHookResult = ReturnType<typeof useGetSubsaleByIdQuery>;
export type GetSubsaleByIdLazyQueryHookResult = ReturnType<typeof useGetSubsaleByIdLazyQuery>;
export type GetSubsaleByIdQueryResult = Apollo.QueryResult<GetSubsaleByIdQuery, GetSubsaleByIdQueryVariables>;
export const GetSubsaleUnitDetailDocument = gql`
    query getSubsaleUnitDetail($id: String!) {
  getSubsaleUnitDetail(id: $id) {
    unitId
    unitNo
    purchaserName
    buyerSolicitorName
    buyerSolicitorCode
    isCompany
    companyName
  }
}
    `;

/**
 * __useGetSubsaleUnitDetailQuery__
 *
 * To run a query within a React component, call `useGetSubsaleUnitDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubsaleUnitDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubsaleUnitDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSubsaleUnitDetailQuery(baseOptions: Apollo.QueryHookOptions<GetSubsaleUnitDetailQuery, GetSubsaleUnitDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubsaleUnitDetailQuery, GetSubsaleUnitDetailQueryVariables>(GetSubsaleUnitDetailDocument, options);
      }
export function useGetSubsaleUnitDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubsaleUnitDetailQuery, GetSubsaleUnitDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubsaleUnitDetailQuery, GetSubsaleUnitDetailQueryVariables>(GetSubsaleUnitDetailDocument, options);
        }
export type GetSubsaleUnitDetailQueryHookResult = ReturnType<typeof useGetSubsaleUnitDetailQuery>;
export type GetSubsaleUnitDetailLazyQueryHookResult = ReturnType<typeof useGetSubsaleUnitDetailLazyQuery>;
export type GetSubsaleUnitDetailQueryResult = Apollo.QueryResult<GetSubsaleUnitDetailQuery, GetSubsaleUnitDetailQueryVariables>;
export const GetSubsaleUnitDocument = gql`
    query getSubsaleUnit {
  getSubsaleUnit {
    unitId
    unitNo
    purchaserName
    buyerSolicitorName
    buyerSolicitorCode
    isCompany
    companyName
  }
}
    `;

/**
 * __useGetSubsaleUnitQuery__
 *
 * To run a query within a React component, call `useGetSubsaleUnitQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubsaleUnitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubsaleUnitQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSubsaleUnitQuery(baseOptions?: Apollo.QueryHookOptions<GetSubsaleUnitQuery, GetSubsaleUnitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubsaleUnitQuery, GetSubsaleUnitQueryVariables>(GetSubsaleUnitDocument, options);
      }
export function useGetSubsaleUnitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubsaleUnitQuery, GetSubsaleUnitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubsaleUnitQuery, GetSubsaleUnitQueryVariables>(GetSubsaleUnitDocument, options);
        }
export type GetSubsaleUnitQueryHookResult = ReturnType<typeof useGetSubsaleUnitQuery>;
export type GetSubsaleUnitLazyQueryHookResult = ReturnType<typeof useGetSubsaleUnitLazyQuery>;
export type GetSubsaleUnitQueryResult = Apollo.QueryResult<GetSubsaleUnitQuery, GetSubsaleUnitQueryVariables>;
export const GetSubsaleContactListDocument = gql`
    query getSubsaleContactList($isCompany: Boolean!) {
  getSubsaleContactList(isCompany: $isCompany) {
    id
    fullName
    email
    phoneNo
    gender
    icNo
    militaryIc
    companyName
    companyRegNo
    homeTel
    officeTel
    salutation {
      id
    }
    nationality {
      id
    }
    race {
      id
    }
    maritalStatus {
      id
    }
    address {
      address
      country
      city
      state
      postCode
    }
    contactExt {
      identityType
      customerOrigin
      isBumi
      isForeignPurchase
      subscribeMaterialSms
      subscribeMaterialWhatsapp
      subscribeMaterialEmail
      subscribeMaterialPaNews
      mailingMethod
      remark
    }
  }
}
    `;

/**
 * __useGetSubsaleContactListQuery__
 *
 * To run a query within a React component, call `useGetSubsaleContactListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubsaleContactListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubsaleContactListQuery({
 *   variables: {
 *      isCompany: // value for 'isCompany'
 *   },
 * });
 */
export function useGetSubsaleContactListQuery(baseOptions: Apollo.QueryHookOptions<GetSubsaleContactListQuery, GetSubsaleContactListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubsaleContactListQuery, GetSubsaleContactListQueryVariables>(GetSubsaleContactListDocument, options);
      }
export function useGetSubsaleContactListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubsaleContactListQuery, GetSubsaleContactListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubsaleContactListQuery, GetSubsaleContactListQueryVariables>(GetSubsaleContactListDocument, options);
        }
export type GetSubsaleContactListQueryHookResult = ReturnType<typeof useGetSubsaleContactListQuery>;
export type GetSubsaleContactListLazyQueryHookResult = ReturnType<typeof useGetSubsaleContactListLazyQuery>;
export type GetSubsaleContactListQueryResult = Apollo.QueryResult<GetSubsaleContactListQuery, GetSubsaleContactListQueryVariables>;
export const GetSubsaleLoanByIdDocument = gql`
    query getSubsaleLoanById($id: String!) {
  getSubsaleLoanById(id: $id) {
    financierId
    financierReferenceNo
    RRDate
    RRSolicitorId
    RRSolicitorReferenceNo
    DOADate
    DOASolicitorId
    DOASolicitorReferenceNo
    LoanSolicitorId
    loanSolicitorReferenceNo
  }
}
    `;

/**
 * __useGetSubsaleLoanByIdQuery__
 *
 * To run a query within a React component, call `useGetSubsaleLoanByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubsaleLoanByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubsaleLoanByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSubsaleLoanByIdQuery(baseOptions: Apollo.QueryHookOptions<GetSubsaleLoanByIdQuery, GetSubsaleLoanByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubsaleLoanByIdQuery, GetSubsaleLoanByIdQueryVariables>(GetSubsaleLoanByIdDocument, options);
      }
export function useGetSubsaleLoanByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubsaleLoanByIdQuery, GetSubsaleLoanByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubsaleLoanByIdQuery, GetSubsaleLoanByIdQueryVariables>(GetSubsaleLoanByIdDocument, options);
        }
export type GetSubsaleLoanByIdQueryHookResult = ReturnType<typeof useGetSubsaleLoanByIdQuery>;
export type GetSubsaleLoanByIdLazyQueryHookResult = ReturnType<typeof useGetSubsaleLoanByIdLazyQuery>;
export type GetSubsaleLoanByIdQueryResult = Apollo.QueryResult<GetSubsaleLoanByIdQuery, GetSubsaleLoanByIdQueryVariables>;
export const GetSubsaleJointBuyerByIdDocument = gql`
    query getSubsaleJointBuyerById($id: String!) {
  getSubsaleJointBuyerById(id: $id) {
    subsaleJointBuyerContactName {
      nationality {
        name
      }
      icNo
      militaryIc
      fullName
      salutation {
        name
      }
      race {
        name
      }
      maritalStatus {
        name
      }
      gender
      email
      address {
        address
        country
        postCode
        state
        city
      }
      homeTel
      phoneNo
      officeTel
      subsaleJointBuyerContactExtension {
        customerOrigin
        identityType
        remark
        isBumi
        isForeignPurchase
        subscribeMaterialSms
        subscribeMaterialWhatsapp
        subscribeMaterialEmail
        subscribeMaterialPaNews
        mailingMethod
      }
    }
  }
}
    `;

/**
 * __useGetSubsaleJointBuyerByIdQuery__
 *
 * To run a query within a React component, call `useGetSubsaleJointBuyerByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubsaleJointBuyerByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubsaleJointBuyerByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSubsaleJointBuyerByIdQuery(baseOptions: Apollo.QueryHookOptions<GetSubsaleJointBuyerByIdQuery, GetSubsaleJointBuyerByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubsaleJointBuyerByIdQuery, GetSubsaleJointBuyerByIdQueryVariables>(GetSubsaleJointBuyerByIdDocument, options);
      }
export function useGetSubsaleJointBuyerByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubsaleJointBuyerByIdQuery, GetSubsaleJointBuyerByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubsaleJointBuyerByIdQuery, GetSubsaleJointBuyerByIdQueryVariables>(GetSubsaleJointBuyerByIdDocument, options);
        }
export type GetSubsaleJointBuyerByIdQueryHookResult = ReturnType<typeof useGetSubsaleJointBuyerByIdQuery>;
export type GetSubsaleJointBuyerByIdLazyQueryHookResult = ReturnType<typeof useGetSubsaleJointBuyerByIdLazyQuery>;
export type GetSubsaleJointBuyerByIdQueryResult = Apollo.QueryResult<GetSubsaleJointBuyerByIdQuery, GetSubsaleJointBuyerByIdQueryVariables>;
export const AddSubsaleDocument = gql`
    mutation addSubsale($input: AddSubsaleInput!) {
  addSubsale(input: $input)
}
    `;
export type AddSubsaleMutationFn = Apollo.MutationFunction<AddSubsaleMutation, AddSubsaleMutationVariables>;

/**
 * __useAddSubsaleMutation__
 *
 * To run a mutation, you first call `useAddSubsaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSubsaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSubsaleMutation, { data, loading, error }] = useAddSubsaleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddSubsaleMutation(baseOptions?: Apollo.MutationHookOptions<AddSubsaleMutation, AddSubsaleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSubsaleMutation, AddSubsaleMutationVariables>(AddSubsaleDocument, options);
      }
export type AddSubsaleMutationHookResult = ReturnType<typeof useAddSubsaleMutation>;
export type AddSubsaleMutationResult = Apollo.MutationResult<AddSubsaleMutation>;
export type AddSubsaleMutationOptions = Apollo.BaseMutationOptions<AddSubsaleMutation, AddSubsaleMutationVariables>;
export const EditSubsaleDocument = gql`
    mutation editSubsale($input: EditSubsaleInput!) {
  editSubsale(input: $input)
}
    `;
export type EditSubsaleMutationFn = Apollo.MutationFunction<EditSubsaleMutation, EditSubsaleMutationVariables>;

/**
 * __useEditSubsaleMutation__
 *
 * To run a mutation, you first call `useEditSubsaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSubsaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSubsaleMutation, { data, loading, error }] = useEditSubsaleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditSubsaleMutation(baseOptions?: Apollo.MutationHookOptions<EditSubsaleMutation, EditSubsaleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditSubsaleMutation, EditSubsaleMutationVariables>(EditSubsaleDocument, options);
      }
export type EditSubsaleMutationHookResult = ReturnType<typeof useEditSubsaleMutation>;
export type EditSubsaleMutationResult = Apollo.MutationResult<EditSubsaleMutation>;
export type EditSubsaleMutationOptions = Apollo.BaseMutationOptions<EditSubsaleMutation, EditSubsaleMutationVariables>;
export const DeleteSubsaleDocument = gql`
    mutation deleteSubsale($subsaleId: String!) {
  deleteSubsale(subsaleId: $subsaleId)
}
    `;
export type DeleteSubsaleMutationFn = Apollo.MutationFunction<DeleteSubsaleMutation, DeleteSubsaleMutationVariables>;

/**
 * __useDeleteSubsaleMutation__
 *
 * To run a mutation, you first call `useDeleteSubsaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSubsaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSubsaleMutation, { data, loading, error }] = useDeleteSubsaleMutation({
 *   variables: {
 *      subsaleId: // value for 'subsaleId'
 *   },
 * });
 */
export function useDeleteSubsaleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSubsaleMutation, DeleteSubsaleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSubsaleMutation, DeleteSubsaleMutationVariables>(DeleteSubsaleDocument, options);
      }
export type DeleteSubsaleMutationHookResult = ReturnType<typeof useDeleteSubsaleMutation>;
export type DeleteSubsaleMutationResult = Apollo.MutationResult<DeleteSubsaleMutation>;
export type DeleteSubsaleMutationOptions = Apollo.BaseMutationOptions<DeleteSubsaleMutation, DeleteSubsaleMutationVariables>;
export const CompleteSubsaleDocument = gql`
    mutation completeSubsale($subsaleId: String!) {
  completeSubsale(subsaleId: $subsaleId)
}
    `;
export type CompleteSubsaleMutationFn = Apollo.MutationFunction<CompleteSubsaleMutation, CompleteSubsaleMutationVariables>;

/**
 * __useCompleteSubsaleMutation__
 *
 * To run a mutation, you first call `useCompleteSubsaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteSubsaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeSubsaleMutation, { data, loading, error }] = useCompleteSubsaleMutation({
 *   variables: {
 *      subsaleId: // value for 'subsaleId'
 *   },
 * });
 */
export function useCompleteSubsaleMutation(baseOptions?: Apollo.MutationHookOptions<CompleteSubsaleMutation, CompleteSubsaleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteSubsaleMutation, CompleteSubsaleMutationVariables>(CompleteSubsaleDocument, options);
      }
export type CompleteSubsaleMutationHookResult = ReturnType<typeof useCompleteSubsaleMutation>;
export type CompleteSubsaleMutationResult = Apollo.MutationResult<CompleteSubsaleMutation>;
export type CompleteSubsaleMutationOptions = Apollo.BaseMutationOptions<CompleteSubsaleMutation, CompleteSubsaleMutationVariables>;
export const ReopenSubsaleDocument = gql`
    mutation reopenSubsale($subsaleId: String!) {
  reopenSubsale(subsaleId: $subsaleId)
}
    `;
export type ReopenSubsaleMutationFn = Apollo.MutationFunction<ReopenSubsaleMutation, ReopenSubsaleMutationVariables>;

/**
 * __useReopenSubsaleMutation__
 *
 * To run a mutation, you first call `useReopenSubsaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReopenSubsaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reopenSubsaleMutation, { data, loading, error }] = useReopenSubsaleMutation({
 *   variables: {
 *      subsaleId: // value for 'subsaleId'
 *   },
 * });
 */
export function useReopenSubsaleMutation(baseOptions?: Apollo.MutationHookOptions<ReopenSubsaleMutation, ReopenSubsaleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReopenSubsaleMutation, ReopenSubsaleMutationVariables>(ReopenSubsaleDocument, options);
      }
export type ReopenSubsaleMutationHookResult = ReturnType<typeof useReopenSubsaleMutation>;
export type ReopenSubsaleMutationResult = Apollo.MutationResult<ReopenSubsaleMutation>;
export type ReopenSubsaleMutationOptions = Apollo.BaseMutationOptions<ReopenSubsaleMutation, ReopenSubsaleMutationVariables>;
export const GetAllNationalityDocument = gql`
    query getAllNationality {
  getAllNationality {
    id
    name
  }
}
    `;

/**
 * __useGetAllNationalityQuery__
 *
 * To run a query within a React component, call `useGetAllNationalityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllNationalityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllNationalityQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllNationalityQuery(baseOptions?: Apollo.QueryHookOptions<GetAllNationalityQuery, GetAllNationalityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllNationalityQuery, GetAllNationalityQueryVariables>(GetAllNationalityDocument, options);
      }
export function useGetAllNationalityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllNationalityQuery, GetAllNationalityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllNationalityQuery, GetAllNationalityQueryVariables>(GetAllNationalityDocument, options);
        }
export type GetAllNationalityQueryHookResult = ReturnType<typeof useGetAllNationalityQuery>;
export type GetAllNationalityLazyQueryHookResult = ReturnType<typeof useGetAllNationalityLazyQuery>;
export type GetAllNationalityQueryResult = Apollo.QueryResult<GetAllNationalityQuery, GetAllNationalityQueryVariables>;
export const GetAllSaleUnitNoByProjectIdDocument = gql`
    query getAllSaleUnitNoByProjectId($projectId: String!) {
  getAllSaleUnitNoList(projectId: $projectId) {
    id
    unitId
    contact {
      id
    }
    unit {
      unitNo
    }
  }
}
    `;

/**
 * __useGetAllSaleUnitNoByProjectIdQuery__
 *
 * To run a query within a React component, call `useGetAllSaleUnitNoByProjectIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSaleUnitNoByProjectIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllSaleUnitNoByProjectIdQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetAllSaleUnitNoByProjectIdQuery(baseOptions: Apollo.QueryHookOptions<GetAllSaleUnitNoByProjectIdQuery, GetAllSaleUnitNoByProjectIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllSaleUnitNoByProjectIdQuery, GetAllSaleUnitNoByProjectIdQueryVariables>(GetAllSaleUnitNoByProjectIdDocument, options);
      }
export function useGetAllSaleUnitNoByProjectIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllSaleUnitNoByProjectIdQuery, GetAllSaleUnitNoByProjectIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllSaleUnitNoByProjectIdQuery, GetAllSaleUnitNoByProjectIdQueryVariables>(GetAllSaleUnitNoByProjectIdDocument, options);
        }
export type GetAllSaleUnitNoByProjectIdQueryHookResult = ReturnType<typeof useGetAllSaleUnitNoByProjectIdQuery>;
export type GetAllSaleUnitNoByProjectIdLazyQueryHookResult = ReturnType<typeof useGetAllSaleUnitNoByProjectIdLazyQuery>;
export type GetAllSaleUnitNoByProjectIdQueryResult = Apollo.QueryResult<GetAllSaleUnitNoByProjectIdQuery, GetAllSaleUnitNoByProjectIdQueryVariables>;
export const GetCurrentBuyerDetailsDocument = gql`
    query getCurrentBuyerDetails($saleId: String!) {
  getCurrentBuyerDetails(saleId: $saleId) {
    id
    contact {
      id
      fullName
    }
    buyerSolicitor {
      id
      name
    }
  }
}
    `;

/**
 * __useGetCurrentBuyerDetailsQuery__
 *
 * To run a query within a React component, call `useGetCurrentBuyerDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentBuyerDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentBuyerDetailsQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetCurrentBuyerDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentBuyerDetailsQuery, GetCurrentBuyerDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentBuyerDetailsQuery, GetCurrentBuyerDetailsQueryVariables>(GetCurrentBuyerDetailsDocument, options);
      }
export function useGetCurrentBuyerDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentBuyerDetailsQuery, GetCurrentBuyerDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentBuyerDetailsQuery, GetCurrentBuyerDetailsQueryVariables>(GetCurrentBuyerDetailsDocument, options);
        }
export type GetCurrentBuyerDetailsQueryHookResult = ReturnType<typeof useGetCurrentBuyerDetailsQuery>;
export type GetCurrentBuyerDetailsLazyQueryHookResult = ReturnType<typeof useGetCurrentBuyerDetailsLazyQuery>;
export type GetCurrentBuyerDetailsQueryResult = Apollo.QueryResult<GetCurrentBuyerDetailsQuery, GetCurrentBuyerDetailsQueryVariables>;
export const GetEndFinancierDetailsByProjectIdDocument = gql`
    query getEndFinancierDetailsByProjectId($projectId: String!) {
  getEndFinancierDetails(projectId: $projectId) {
    id
    financier {
      id
      name
    }
  }
}
    `;

/**
 * __useGetEndFinancierDetailsByProjectIdQuery__
 *
 * To run a query within a React component, call `useGetEndFinancierDetailsByProjectIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEndFinancierDetailsByProjectIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEndFinancierDetailsByProjectIdQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetEndFinancierDetailsByProjectIdQuery(baseOptions: Apollo.QueryHookOptions<GetEndFinancierDetailsByProjectIdQuery, GetEndFinancierDetailsByProjectIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEndFinancierDetailsByProjectIdQuery, GetEndFinancierDetailsByProjectIdQueryVariables>(GetEndFinancierDetailsByProjectIdDocument, options);
      }
export function useGetEndFinancierDetailsByProjectIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEndFinancierDetailsByProjectIdQuery, GetEndFinancierDetailsByProjectIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEndFinancierDetailsByProjectIdQuery, GetEndFinancierDetailsByProjectIdQueryVariables>(GetEndFinancierDetailsByProjectIdDocument, options);
        }
export type GetEndFinancierDetailsByProjectIdQueryHookResult = ReturnType<typeof useGetEndFinancierDetailsByProjectIdQuery>;
export type GetEndFinancierDetailsByProjectIdLazyQueryHookResult = ReturnType<typeof useGetEndFinancierDetailsByProjectIdLazyQuery>;
export type GetEndFinancierDetailsByProjectIdQueryResult = Apollo.QueryResult<GetEndFinancierDetailsByProjectIdQuery, GetEndFinancierDetailsByProjectIdQueryVariables>;
export const GetSolicitorAppointedListDocument = gql`
    query getSolicitorAppointedList {
  getSolicitorAppointedList {
    id
    name
  }
}
    `;

/**
 * __useGetSolicitorAppointedListQuery__
 *
 * To run a query within a React component, call `useGetSolicitorAppointedListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSolicitorAppointedListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSolicitorAppointedListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSolicitorAppointedListQuery(baseOptions?: Apollo.QueryHookOptions<GetSolicitorAppointedListQuery, GetSolicitorAppointedListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSolicitorAppointedListQuery, GetSolicitorAppointedListQueryVariables>(GetSolicitorAppointedListDocument, options);
      }
export function useGetSolicitorAppointedListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSolicitorAppointedListQuery, GetSolicitorAppointedListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSolicitorAppointedListQuery, GetSolicitorAppointedListQueryVariables>(GetSolicitorAppointedListDocument, options);
        }
export type GetSolicitorAppointedListQueryHookResult = ReturnType<typeof useGetSolicitorAppointedListQuery>;
export type GetSolicitorAppointedListLazyQueryHookResult = ReturnType<typeof useGetSolicitorAppointedListLazyQuery>;
export type GetSolicitorAppointedListQueryResult = Apollo.QueryResult<GetSolicitorAppointedListQuery, GetSolicitorAppointedListQueryVariables>;
export const GetUnitBookingListingSaleDocument = gql`
    query getUnitBookingListingSale($projectId: String!, $approvalStatus: String) {
  getUnitBookingListingSale(projectId: $projectId, approvalStatus: $approvalStatus) {
    saleId
    bookDate
    salesNo
    unitId
    unitNo
    fullName
    sellingPrice
    totalBookingFee
    collectedBookingFee
    saleBookingAmount
    pendingBookingFee
    jointBuyerCount
    salesConvertedStatus
    convertedToBooking
  }
}
    `;

/**
 * __useGetUnitBookingListingSaleQuery__
 *
 * To run a query within a React component, call `useGetUnitBookingListingSaleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitBookingListingSaleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitBookingListingSaleQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      approvalStatus: // value for 'approvalStatus'
 *   },
 * });
 */
export function useGetUnitBookingListingSaleQuery(baseOptions: Apollo.QueryHookOptions<GetUnitBookingListingSaleQuery, GetUnitBookingListingSaleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitBookingListingSaleQuery, GetUnitBookingListingSaleQueryVariables>(GetUnitBookingListingSaleDocument, options);
      }
export function useGetUnitBookingListingSaleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitBookingListingSaleQuery, GetUnitBookingListingSaleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitBookingListingSaleQuery, GetUnitBookingListingSaleQueryVariables>(GetUnitBookingListingSaleDocument, options);
        }
export type GetUnitBookingListingSaleQueryHookResult = ReturnType<typeof useGetUnitBookingListingSaleQuery>;
export type GetUnitBookingListingSaleLazyQueryHookResult = ReturnType<typeof useGetUnitBookingListingSaleLazyQuery>;
export type GetUnitBookingListingSaleQueryResult = Apollo.QueryResult<GetUnitBookingListingSaleQuery, GetUnitBookingListingSaleQueryVariables>;
export const GetCountStatusBookingDocument = gql`
    query getCountStatusBooking($projectId: String!) {
  getCountStatusBooking(projectId: $projectId) {
    status
    convertedStatus
    collectedBookingFee
  }
}
    `;

/**
 * __useGetCountStatusBookingQuery__
 *
 * To run a query within a React component, call `useGetCountStatusBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountStatusBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountStatusBookingQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetCountStatusBookingQuery(baseOptions: Apollo.QueryHookOptions<GetCountStatusBookingQuery, GetCountStatusBookingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCountStatusBookingQuery, GetCountStatusBookingQueryVariables>(GetCountStatusBookingDocument, options);
      }
export function useGetCountStatusBookingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCountStatusBookingQuery, GetCountStatusBookingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCountStatusBookingQuery, GetCountStatusBookingQueryVariables>(GetCountStatusBookingDocument, options);
        }
export type GetCountStatusBookingQueryHookResult = ReturnType<typeof useGetCountStatusBookingQuery>;
export type GetCountStatusBookingLazyQueryHookResult = ReturnType<typeof useGetCountStatusBookingLazyQuery>;
export type GetCountStatusBookingQueryResult = Apollo.QueryResult<GetCountStatusBookingQuery, GetCountStatusBookingQueryVariables>;
export const GetUnitBookingDetailsDocument = gql`
    query getUnitBookingDetails($projectId: String!, $saleId: String!) {
  getUnitBookingDetails(projectId: $projectId, saleId: $saleId) {
    projectId
    saleId
    bookDate
    salesNo
    unitId
    contactId
    unitNo
    bookingFee
    builtUp
    builtUpAreaRate
    landArea
    unitClusterId
    landAreaRate
    commercialPurpose
    propertyTypeName
    taxScheme
    fullName
    jointBuyers {
      jointBuyerId
      contactId
      jointBuyerName
      religionIdJoint
      professionIdJoint
      officeTelJoint
      homeTelJoint
      phoneNoJoint
      nameOnTaxJoint
      taxRegistrationNoJoint
      taxRegistrationAddressJoint
    }
    jointBuyerCount
    amount
    sellingPrice
    professionId
    religionId
    nameOnTax
    taxRegistrationNo
    taxRegistrationAddress
    officeTel
    homeTel
    phoneNo
  }
}
    `;

/**
 * __useGetUnitBookingDetailsQuery__
 *
 * To run a query within a React component, call `useGetUnitBookingDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitBookingDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitBookingDetailsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetUnitBookingDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetUnitBookingDetailsQuery, GetUnitBookingDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitBookingDetailsQuery, GetUnitBookingDetailsQueryVariables>(GetUnitBookingDetailsDocument, options);
      }
export function useGetUnitBookingDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitBookingDetailsQuery, GetUnitBookingDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitBookingDetailsQuery, GetUnitBookingDetailsQueryVariables>(GetUnitBookingDetailsDocument, options);
        }
export type GetUnitBookingDetailsQueryHookResult = ReturnType<typeof useGetUnitBookingDetailsQuery>;
export type GetUnitBookingDetailsLazyQueryHookResult = ReturnType<typeof useGetUnitBookingDetailsLazyQuery>;
export type GetUnitBookingDetailsQueryResult = Apollo.QueryResult<GetUnitBookingDetailsQuery, GetUnitBookingDetailsQueryVariables>;
export const GetPurchaserDetailsByContactIdDocument = gql`
    query getPurchaserDetailsByContactId($saleId: String!, $contactId: String!) {
  getPurchaserDetailsByContactId(saleId: $saleId, contactId: $contactId) {
    fullName
    identityNo
    nationality
    email
    identityType
    salutation
    maritalStatus
    gender
    dob
    incomeRange
    customerOrigin
    addressDetail {
      address
      country
      city
      state
      postCode
    }
    contactAddresses {
      AddressType
      address
      country
      city
      state
      postCode
    }
    profession
    religion
    nameOnTax
    taxRegistrationNo
    taxRegistrationAddress
    otherContactNumber
    otherOfficeTelNo
    otherHomeTelNo
    mailingMethod
    subscribeMaterialEmail
    subscribeMaterialSms
    subscribeMaterialWhatsApp
    subscribeMaterialPaNews
    remarks
    isPrincipalBuyer
  }
}
    `;

/**
 * __useGetPurchaserDetailsByContactIdQuery__
 *
 * To run a query within a React component, call `useGetPurchaserDetailsByContactIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPurchaserDetailsByContactIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPurchaserDetailsByContactIdQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useGetPurchaserDetailsByContactIdQuery(baseOptions: Apollo.QueryHookOptions<GetPurchaserDetailsByContactIdQuery, GetPurchaserDetailsByContactIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPurchaserDetailsByContactIdQuery, GetPurchaserDetailsByContactIdQueryVariables>(GetPurchaserDetailsByContactIdDocument, options);
      }
export function useGetPurchaserDetailsByContactIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPurchaserDetailsByContactIdQuery, GetPurchaserDetailsByContactIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPurchaserDetailsByContactIdQuery, GetPurchaserDetailsByContactIdQueryVariables>(GetPurchaserDetailsByContactIdDocument, options);
        }
export type GetPurchaserDetailsByContactIdQueryHookResult = ReturnType<typeof useGetPurchaserDetailsByContactIdQuery>;
export type GetPurchaserDetailsByContactIdLazyQueryHookResult = ReturnType<typeof useGetPurchaserDetailsByContactIdLazyQuery>;
export type GetPurchaserDetailsByContactIdQueryResult = Apollo.QueryResult<GetPurchaserDetailsByContactIdQuery, GetPurchaserDetailsByContactIdQueryVariables>;
export const GetJointBuyerDetailsByContactIdDocument = gql`
    query getJointBuyerDetailsByContactId($jointBuyerId: String!, $contactId: String!) {
  getJointBuyerDetailsByContactId(jointBuyerId: $jointBuyerId, contactId: $contactId) {
    fullName
    identityNo
    nationality
    email
    identityType
    salutation
    maritalStatus
    gender
    customerOrigin
    addressDetail {
      address
      country
      city
      state
      postCode
    }
    profession
    religion
    nameOnTax
    taxRegistrationNo
    taxRegistrationAddress
    otherContactNumber
    otherOfficeTelNo
    otherHomeTelNo
    mailingMethod
    subscribeMaterialEmail
    subscribeMaterialSms
    subscribeMaterialWhatsApp
    subscribeMaterialPaNews
    remarks
    isPrincipalBuyer
  }
}
    `;

/**
 * __useGetJointBuyerDetailsByContactIdQuery__
 *
 * To run a query within a React component, call `useGetJointBuyerDetailsByContactIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJointBuyerDetailsByContactIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJointBuyerDetailsByContactIdQuery({
 *   variables: {
 *      jointBuyerId: // value for 'jointBuyerId'
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useGetJointBuyerDetailsByContactIdQuery(baseOptions: Apollo.QueryHookOptions<GetJointBuyerDetailsByContactIdQuery, GetJointBuyerDetailsByContactIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJointBuyerDetailsByContactIdQuery, GetJointBuyerDetailsByContactIdQueryVariables>(GetJointBuyerDetailsByContactIdDocument, options);
      }
export function useGetJointBuyerDetailsByContactIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJointBuyerDetailsByContactIdQuery, GetJointBuyerDetailsByContactIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJointBuyerDetailsByContactIdQuery, GetJointBuyerDetailsByContactIdQueryVariables>(GetJointBuyerDetailsByContactIdDocument, options);
        }
export type GetJointBuyerDetailsByContactIdQueryHookResult = ReturnType<typeof useGetJointBuyerDetailsByContactIdQuery>;
export type GetJointBuyerDetailsByContactIdLazyQueryHookResult = ReturnType<typeof useGetJointBuyerDetailsByContactIdLazyQuery>;
export type GetJointBuyerDetailsByContactIdQueryResult = Apollo.QueryResult<GetJointBuyerDetailsByContactIdQuery, GetJointBuyerDetailsByContactIdQueryVariables>;
export const GetBookingFeeListingBySaleIdDocument = gql`
    query getBookingFeeListingBySaleId($saleId: String!) {
  getBookingFeeListingBySaleId(saleId: $saleId) {
    saleInfo {
      saleId
      bookDate
      salesNo
      unitId
      unitNo
      fullName
      sellingPrice
      totalBookingFee
      collectedBookingFee
      pendingBookingFee
      jointBuyerCount
    }
    bookingFeeList {
      saleId
      salePaymentId
      transactionDate
      receiptNo
      remark
      amount
      status
      verificationStatus
    }
  }
}
    `;

/**
 * __useGetBookingFeeListingBySaleIdQuery__
 *
 * To run a query within a React component, call `useGetBookingFeeListingBySaleIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingFeeListingBySaleIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingFeeListingBySaleIdQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetBookingFeeListingBySaleIdQuery(baseOptions: Apollo.QueryHookOptions<GetBookingFeeListingBySaleIdQuery, GetBookingFeeListingBySaleIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookingFeeListingBySaleIdQuery, GetBookingFeeListingBySaleIdQueryVariables>(GetBookingFeeListingBySaleIdDocument, options);
      }
export function useGetBookingFeeListingBySaleIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookingFeeListingBySaleIdQuery, GetBookingFeeListingBySaleIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookingFeeListingBySaleIdQuery, GetBookingFeeListingBySaleIdQueryVariables>(GetBookingFeeListingBySaleIdDocument, options);
        }
export type GetBookingFeeListingBySaleIdQueryHookResult = ReturnType<typeof useGetBookingFeeListingBySaleIdQuery>;
export type GetBookingFeeListingBySaleIdLazyQueryHookResult = ReturnType<typeof useGetBookingFeeListingBySaleIdLazyQuery>;
export type GetBookingFeeListingBySaleIdQueryResult = Apollo.QueryResult<GetBookingFeeListingBySaleIdQuery, GetBookingFeeListingBySaleIdQueryVariables>;
export const GetBookingFeeByIdDocument = gql`
    query getBookingFeeById($salePaymentId: String!) {
  getBookingFeeById(salePaymentId: $salePaymentId) {
    paymentDate
    trNo
    paymentMethod
    paymentAmt
    paymentRefNo
    paymentRemarks
    modBy
    modTs
    paymentStatus
    bankId
    attachment {
      id
      fileName
      isPrivate
      mediaType
      resourceUrl
    }
  }
}
    `;

/**
 * __useGetBookingFeeByIdQuery__
 *
 * To run a query within a React component, call `useGetBookingFeeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingFeeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingFeeByIdQuery({
 *   variables: {
 *      salePaymentId: // value for 'salePaymentId'
 *   },
 * });
 */
export function useGetBookingFeeByIdQuery(baseOptions: Apollo.QueryHookOptions<GetBookingFeeByIdQuery, GetBookingFeeByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookingFeeByIdQuery, GetBookingFeeByIdQueryVariables>(GetBookingFeeByIdDocument, options);
      }
export function useGetBookingFeeByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookingFeeByIdQuery, GetBookingFeeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookingFeeByIdQuery, GetBookingFeeByIdQueryVariables>(GetBookingFeeByIdDocument, options);
        }
export type GetBookingFeeByIdQueryHookResult = ReturnType<typeof useGetBookingFeeByIdQuery>;
export type GetBookingFeeByIdLazyQueryHookResult = ReturnType<typeof useGetBookingFeeByIdLazyQuery>;
export type GetBookingFeeByIdQueryResult = Apollo.QueryResult<GetBookingFeeByIdQuery, GetBookingFeeByIdQueryVariables>;
export const GetUnitByStatusDocument = gql`
    query getUnitByStatus($projectId: String!, $launchDate: DateTime!) {
  getUnitByStatus(projectId: $projectId, launchDate: $launchDate) {
    projectId
    unitClusterId
    unitId
    unitNo
    price
    unitStatus
    builtUp
    builtUpAreaRate
    landArea
    landAreaRate
    commercialPurpose
    propertyTypeName
  }
}
    `;

/**
 * __useGetUnitByStatusQuery__
 *
 * To run a query within a React component, call `useGetUnitByStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitByStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitByStatusQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      launchDate: // value for 'launchDate'
 *   },
 * });
 */
export function useGetUnitByStatusQuery(baseOptions: Apollo.QueryHookOptions<GetUnitByStatusQuery, GetUnitByStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitByStatusQuery, GetUnitByStatusQueryVariables>(GetUnitByStatusDocument, options);
      }
export function useGetUnitByStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitByStatusQuery, GetUnitByStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitByStatusQuery, GetUnitByStatusQueryVariables>(GetUnitByStatusDocument, options);
        }
export type GetUnitByStatusQueryHookResult = ReturnType<typeof useGetUnitByStatusQuery>;
export type GetUnitByStatusLazyQueryHookResult = ReturnType<typeof useGetUnitByStatusLazyQuery>;
export type GetUnitByStatusQueryResult = Apollo.QueryResult<GetUnitByStatusQuery, GetUnitByStatusQueryVariables>;
export const GetUnitByUnitIdDocument = gql`
    query getUnitByUnitId($projectId: String!, $unitId: String!) {
  getUnitByUnitId(projectId: $projectId, unitId: $unitId) {
    projectId
    unitClusterId
    unitId
    unitNo
    unitStatus
    builtUp
    builtUpAreaRate
    landArea
    landAreaRate
    commercialPurpose
    propertyTypeName
  }
}
    `;

/**
 * __useGetUnitByUnitIdQuery__
 *
 * To run a query within a React component, call `useGetUnitByUnitIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitByUnitIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitByUnitIdQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      unitId: // value for 'unitId'
 *   },
 * });
 */
export function useGetUnitByUnitIdQuery(baseOptions: Apollo.QueryHookOptions<GetUnitByUnitIdQuery, GetUnitByUnitIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitByUnitIdQuery, GetUnitByUnitIdQueryVariables>(GetUnitByUnitIdDocument, options);
      }
export function useGetUnitByUnitIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitByUnitIdQuery, GetUnitByUnitIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitByUnitIdQuery, GetUnitByUnitIdQueryVariables>(GetUnitByUnitIdDocument, options);
        }
export type GetUnitByUnitIdQueryHookResult = ReturnType<typeof useGetUnitByUnitIdQuery>;
export type GetUnitByUnitIdLazyQueryHookResult = ReturnType<typeof useGetUnitByUnitIdLazyQuery>;
export type GetUnitByUnitIdQueryResult = Apollo.QueryResult<GetUnitByUnitIdQuery, GetUnitByUnitIdQueryVariables>;
export const GetProfessionByIdDocument = gql`
    query getProfessionById($professionId: String!) {
  getProfessionById(professionId: $professionId) {
    id
    name
  }
}
    `;

/**
 * __useGetProfessionByIdQuery__
 *
 * To run a query within a React component, call `useGetProfessionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfessionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfessionByIdQuery({
 *   variables: {
 *      professionId: // value for 'professionId'
 *   },
 * });
 */
export function useGetProfessionByIdQuery(baseOptions: Apollo.QueryHookOptions<GetProfessionByIdQuery, GetProfessionByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProfessionByIdQuery, GetProfessionByIdQueryVariables>(GetProfessionByIdDocument, options);
      }
export function useGetProfessionByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProfessionByIdQuery, GetProfessionByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProfessionByIdQuery, GetProfessionByIdQueryVariables>(GetProfessionByIdDocument, options);
        }
export type GetProfessionByIdQueryHookResult = ReturnType<typeof useGetProfessionByIdQuery>;
export type GetProfessionByIdLazyQueryHookResult = ReturnType<typeof useGetProfessionByIdLazyQuery>;
export type GetProfessionByIdQueryResult = Apollo.QueryResult<GetProfessionByIdQuery, GetProfessionByIdQueryVariables>;
export const GetReligionByIdDocument = gql`
    query getReligionById($religionId: String!) {
  getReligionById(religionId: $religionId) {
    id
    name
  }
}
    `;

/**
 * __useGetReligionByIdQuery__
 *
 * To run a query within a React component, call `useGetReligionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReligionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReligionByIdQuery({
 *   variables: {
 *      religionId: // value for 'religionId'
 *   },
 * });
 */
export function useGetReligionByIdQuery(baseOptions: Apollo.QueryHookOptions<GetReligionByIdQuery, GetReligionByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReligionByIdQuery, GetReligionByIdQueryVariables>(GetReligionByIdDocument, options);
      }
export function useGetReligionByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReligionByIdQuery, GetReligionByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReligionByIdQuery, GetReligionByIdQueryVariables>(GetReligionByIdDocument, options);
        }
export type GetReligionByIdQueryHookResult = ReturnType<typeof useGetReligionByIdQuery>;
export type GetReligionByIdLazyQueryHookResult = ReturnType<typeof useGetReligionByIdLazyQuery>;
export type GetReligionByIdQueryResult = Apollo.QueryResult<GetReligionByIdQuery, GetReligionByIdQueryVariables>;
export const BookingContactListDocument = gql`
    query BookingContactList {
  BookingContactList {
    contactId
    fullName
    nationality
    identityNo
    otherContactNumber
    email
    gender
    dob
    incomeRange
    contactExtId
    salutation
    maritalStatus
    identityType
    profession
    religion
    nameOnTax
    taxRegistrationAddress
    taxRegistrationNo
    mailingMethod
    subscribeMaterialEmail
    subscribeMaterialSms
    subscribeMaterialWhatsApp
    subscribeMaterialPaNews
    remarks
    customerOrigin
    companyName
    companyRegNo
    isForeignPurchase
    isVip
    correspondenceAddress {
      state
      city
      postCode
      country
      address
    }
  }
}
    `;

/**
 * __useBookingContactListQuery__
 *
 * To run a query within a React component, call `useBookingContactListQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingContactListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingContactListQuery({
 *   variables: {
 *   },
 * });
 */
export function useBookingContactListQuery(baseOptions?: Apollo.QueryHookOptions<BookingContactListQuery, BookingContactListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingContactListQuery, BookingContactListQueryVariables>(BookingContactListDocument, options);
      }
export function useBookingContactListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingContactListQuery, BookingContactListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingContactListQuery, BookingContactListQueryVariables>(BookingContactListDocument, options);
        }
export type BookingContactListQueryHookResult = ReturnType<typeof useBookingContactListQuery>;
export type BookingContactListLazyQueryHookResult = ReturnType<typeof useBookingContactListLazyQuery>;
export type BookingContactListQueryResult = Apollo.QueryResult<BookingContactListQuery, BookingContactListQueryVariables>;
export const GetAddressListByContactDocument = gql`
    query getAddressListByContact($contactId: String!) {
  getAddressListByContact(contactId: $contactId) {
    contactId
    addressList {
      state
      city
      postCode
      country
      address
      AddressType
    }
  }
}
    `;

/**
 * __useGetAddressListByContactQuery__
 *
 * To run a query within a React component, call `useGetAddressListByContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAddressListByContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAddressListByContactQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useGetAddressListByContactQuery(baseOptions: Apollo.QueryHookOptions<GetAddressListByContactQuery, GetAddressListByContactQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAddressListByContactQuery, GetAddressListByContactQueryVariables>(GetAddressListByContactDocument, options);
      }
export function useGetAddressListByContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAddressListByContactQuery, GetAddressListByContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAddressListByContactQuery, GetAddressListByContactQueryVariables>(GetAddressListByContactDocument, options);
        }
export type GetAddressListByContactQueryHookResult = ReturnType<typeof useGetAddressListByContactQuery>;
export type GetAddressListByContactLazyQueryHookResult = ReturnType<typeof useGetAddressListByContactLazyQuery>;
export type GetAddressListByContactQueryResult = Apollo.QueryResult<GetAddressListByContactQuery, GetAddressListByContactQueryVariables>;
export const AddAndEditBookingFeeBySaleIdDocument = gql`
    mutation addAndEditBookingFeeBySaleId($input: addAndEditBookingFeeInput!) {
  addAndEditBookingFeeBySaleId(input: $input)
}
    `;
export type AddAndEditBookingFeeBySaleIdMutationFn = Apollo.MutationFunction<AddAndEditBookingFeeBySaleIdMutation, AddAndEditBookingFeeBySaleIdMutationVariables>;

/**
 * __useAddAndEditBookingFeeBySaleIdMutation__
 *
 * To run a mutation, you first call `useAddAndEditBookingFeeBySaleIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAndEditBookingFeeBySaleIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAndEditBookingFeeBySaleIdMutation, { data, loading, error }] = useAddAndEditBookingFeeBySaleIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAndEditBookingFeeBySaleIdMutation(baseOptions?: Apollo.MutationHookOptions<AddAndEditBookingFeeBySaleIdMutation, AddAndEditBookingFeeBySaleIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAndEditBookingFeeBySaleIdMutation, AddAndEditBookingFeeBySaleIdMutationVariables>(AddAndEditBookingFeeBySaleIdDocument, options);
      }
export type AddAndEditBookingFeeBySaleIdMutationHookResult = ReturnType<typeof useAddAndEditBookingFeeBySaleIdMutation>;
export type AddAndEditBookingFeeBySaleIdMutationResult = Apollo.MutationResult<AddAndEditBookingFeeBySaleIdMutation>;
export type AddAndEditBookingFeeBySaleIdMutationOptions = Apollo.BaseMutationOptions<AddAndEditBookingFeeBySaleIdMutation, AddAndEditBookingFeeBySaleIdMutationVariables>;
export const ApproveAndCancelBookingFeeByIdDocument = gql`
    mutation approveAndCancelBookingFeeById($input: approveAndCancelBookingFeeInput!) {
  approveAndCancelBookingFeeById(input: $input)
}
    `;
export type ApproveAndCancelBookingFeeByIdMutationFn = Apollo.MutationFunction<ApproveAndCancelBookingFeeByIdMutation, ApproveAndCancelBookingFeeByIdMutationVariables>;

/**
 * __useApproveAndCancelBookingFeeByIdMutation__
 *
 * To run a mutation, you first call `useApproveAndCancelBookingFeeByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveAndCancelBookingFeeByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveAndCancelBookingFeeByIdMutation, { data, loading, error }] = useApproveAndCancelBookingFeeByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApproveAndCancelBookingFeeByIdMutation(baseOptions?: Apollo.MutationHookOptions<ApproveAndCancelBookingFeeByIdMutation, ApproveAndCancelBookingFeeByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveAndCancelBookingFeeByIdMutation, ApproveAndCancelBookingFeeByIdMutationVariables>(ApproveAndCancelBookingFeeByIdDocument, options);
      }
export type ApproveAndCancelBookingFeeByIdMutationHookResult = ReturnType<typeof useApproveAndCancelBookingFeeByIdMutation>;
export type ApproveAndCancelBookingFeeByIdMutationResult = Apollo.MutationResult<ApproveAndCancelBookingFeeByIdMutation>;
export type ApproveAndCancelBookingFeeByIdMutationOptions = Apollo.BaseMutationOptions<ApproveAndCancelBookingFeeByIdMutation, ApproveAndCancelBookingFeeByIdMutationVariables>;
export const SaveBookingExpressDocument = gql`
    mutation saveBookingExpress($input: addNewUnitBookingInput!) {
  saveBookingExpress(input: $input)
}
    `;
export type SaveBookingExpressMutationFn = Apollo.MutationFunction<SaveBookingExpressMutation, SaveBookingExpressMutationVariables>;

/**
 * __useSaveBookingExpressMutation__
 *
 * To run a mutation, you first call `useSaveBookingExpressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveBookingExpressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveBookingExpressMutation, { data, loading, error }] = useSaveBookingExpressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveBookingExpressMutation(baseOptions?: Apollo.MutationHookOptions<SaveBookingExpressMutation, SaveBookingExpressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveBookingExpressMutation, SaveBookingExpressMutationVariables>(SaveBookingExpressDocument, options);
      }
export type SaveBookingExpressMutationHookResult = ReturnType<typeof useSaveBookingExpressMutation>;
export type SaveBookingExpressMutationResult = Apollo.MutationResult<SaveBookingExpressMutation>;
export type SaveBookingExpressMutationOptions = Apollo.BaseMutationOptions<SaveBookingExpressMutation, SaveBookingExpressMutationVariables>;
export const TemporaryUploadUnitBookingDocument = gql`
    mutation temporaryUploadUnitBooking($input: temporaryUploadPurchaser!) {
  temporaryUploadUnitBooking(input: $input)
}
    `;
export type TemporaryUploadUnitBookingMutationFn = Apollo.MutationFunction<TemporaryUploadUnitBookingMutation, TemporaryUploadUnitBookingMutationVariables>;

/**
 * __useTemporaryUploadUnitBookingMutation__
 *
 * To run a mutation, you first call `useTemporaryUploadUnitBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTemporaryUploadUnitBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [temporaryUploadUnitBookingMutation, { data, loading, error }] = useTemporaryUploadUnitBookingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTemporaryUploadUnitBookingMutation(baseOptions?: Apollo.MutationHookOptions<TemporaryUploadUnitBookingMutation, TemporaryUploadUnitBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TemporaryUploadUnitBookingMutation, TemporaryUploadUnitBookingMutationVariables>(TemporaryUploadUnitBookingDocument, options);
      }
export type TemporaryUploadUnitBookingMutationHookResult = ReturnType<typeof useTemporaryUploadUnitBookingMutation>;
export type TemporaryUploadUnitBookingMutationResult = Apollo.MutationResult<TemporaryUploadUnitBookingMutation>;
export type TemporaryUploadUnitBookingMutationOptions = Apollo.BaseMutationOptions<TemporaryUploadUnitBookingMutation, TemporaryUploadUnitBookingMutationVariables>;
export const GetBookingFeeELetterTemplateListingDocument = gql`
    query getBookingFeeELetterTemplateListing($projectId: String!) {
  getBookingFeeELetterTemplateListing(projectId: $projectId) {
    id
    name
    letterType
    defaulted
  }
}
    `;

/**
 * __useGetBookingFeeELetterTemplateListingQuery__
 *
 * To run a query within a React component, call `useGetBookingFeeELetterTemplateListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingFeeELetterTemplateListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingFeeELetterTemplateListingQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetBookingFeeELetterTemplateListingQuery(baseOptions: Apollo.QueryHookOptions<GetBookingFeeELetterTemplateListingQuery, GetBookingFeeELetterTemplateListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookingFeeELetterTemplateListingQuery, GetBookingFeeELetterTemplateListingQueryVariables>(GetBookingFeeELetterTemplateListingDocument, options);
      }
export function useGetBookingFeeELetterTemplateListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookingFeeELetterTemplateListingQuery, GetBookingFeeELetterTemplateListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookingFeeELetterTemplateListingQuery, GetBookingFeeELetterTemplateListingQueryVariables>(GetBookingFeeELetterTemplateListingDocument, options);
        }
export type GetBookingFeeELetterTemplateListingQueryHookResult = ReturnType<typeof useGetBookingFeeELetterTemplateListingQuery>;
export type GetBookingFeeELetterTemplateListingLazyQueryHookResult = ReturnType<typeof useGetBookingFeeELetterTemplateListingLazyQuery>;
export type GetBookingFeeELetterTemplateListingQueryResult = Apollo.QueryResult<GetBookingFeeELetterTemplateListingQuery, GetBookingFeeELetterTemplateListingQueryVariables>;
export const GetBookingFeeELetterDocument = gql`
    query getBookingFeeELetter($letterTemplateId: String!, $salePaymentId: String!) {
  getBookingFeeELetter(letterTemplateId: $letterTemplateId, salePaymentId: $salePaymentId) {
    content
    fileName
  }
}
    `;

/**
 * __useGetBookingFeeELetterQuery__
 *
 * To run a query within a React component, call `useGetBookingFeeELetterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingFeeELetterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingFeeELetterQuery({
 *   variables: {
 *      letterTemplateId: // value for 'letterTemplateId'
 *      salePaymentId: // value for 'salePaymentId'
 *   },
 * });
 */
export function useGetBookingFeeELetterQuery(baseOptions: Apollo.QueryHookOptions<GetBookingFeeELetterQuery, GetBookingFeeELetterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookingFeeELetterQuery, GetBookingFeeELetterQueryVariables>(GetBookingFeeELetterDocument, options);
      }
export function useGetBookingFeeELetterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookingFeeELetterQuery, GetBookingFeeELetterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookingFeeELetterQuery, GetBookingFeeELetterQueryVariables>(GetBookingFeeELetterDocument, options);
        }
export type GetBookingFeeELetterQueryHookResult = ReturnType<typeof useGetBookingFeeELetterQuery>;
export type GetBookingFeeELetterLazyQueryHookResult = ReturnType<typeof useGetBookingFeeELetterLazyQuery>;
export type GetBookingFeeELetterQueryResult = Apollo.QueryResult<GetBookingFeeELetterQuery, GetBookingFeeELetterQueryVariables>;
export const GetUnitTransferListingDocument = gql`
    query getUnitTransferListing($status: String!) {
  getUnitTransferListing(status: $status) {
    id
    saleId
    oldUnitNo
    fullName
    phoneNo
    builtUp
    builtUpArea
    landArea
    extraLandArea
    builtUpAreaRate
    landAreaRate
    extraLandAreaRate
    sellingPrice
    paymentPlanName
    discardBumiDiscount
    oldSaleDetail {
      discounts {
        discountId
        title
        amount
        formula
        discountMethod
      }
    }
    newUnitNo
    newBuiltUp
    newBuiltUpArea
    newLandArea
    newExtraLandArea
    newBuiltUpAreaRate
    newLandAreaRate
    newExtraLandAreaRate
    newListPrice
    newSellingPrice
    paymentPlanId
    transferDate
    paymentMethod
    administrationCharges
    reason
    remark
    newDiscount {
      discardBumi
      discounts {
        discountId
        title
        amount
        formula
        discountMethod
      }
    }
    approvalRoleId
  }
}
    `;

/**
 * __useGetUnitTransferListingQuery__
 *
 * To run a query within a React component, call `useGetUnitTransferListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitTransferListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitTransferListingQuery({
 *   variables: {
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetUnitTransferListingQuery(baseOptions: Apollo.QueryHookOptions<GetUnitTransferListingQuery, GetUnitTransferListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitTransferListingQuery, GetUnitTransferListingQueryVariables>(GetUnitTransferListingDocument, options);
      }
export function useGetUnitTransferListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitTransferListingQuery, GetUnitTransferListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitTransferListingQuery, GetUnitTransferListingQueryVariables>(GetUnitTransferListingDocument, options);
        }
export type GetUnitTransferListingQueryHookResult = ReturnType<typeof useGetUnitTransferListingQuery>;
export type GetUnitTransferListingLazyQueryHookResult = ReturnType<typeof useGetUnitTransferListingLazyQuery>;
export type GetUnitTransferListingQueryResult = Apollo.QueryResult<GetUnitTransferListingQuery, GetUnitTransferListingQueryVariables>;
export const GetUnitTransferByIdDocument = gql`
    query getUnitTransferById($id: String!) {
  getUnitTransferById(id: $id) {
    oldUnitId
    oldUnitNo
    builtUp
    builtUpArea
    landArea
    extraLandArea
    builtUpAreaRate
    landAreaRate
    extraLandAreaRate
    sellingPrice
    discardBumiDiscount
    fullName
    phoneNo
    isCompany
    companyName
    companyRegNo
    oldSaleDetail {
      discounts {
        discountId
        title
        seqNo
        amount
        formula
        discountMethod
      }
    }
    paymentPlanName
    saleId
    newUnitId
    newUnitNo
    newBuiltUp
    newBuiltUpArea
    newLandArea
    newExtraLandArea
    newBuiltUpAreaRate
    newLandAreaRate
    newExtraLandAreaRate
    newListPrice
    newSellingPrice
    transferDate
    paymentPlanId
    paymentMethod
    administrationCharges
    reason
    remark
    newDiscount {
      discardBumi
      discounts {
        discountId
        title
        seqNo
        amount
        formula
        discountMethod
      }
    }
  }
}
    `;

/**
 * __useGetUnitTransferByIdQuery__
 *
 * To run a query within a React component, call `useGetUnitTransferByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitTransferByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitTransferByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUnitTransferByIdQuery(baseOptions: Apollo.QueryHookOptions<GetUnitTransferByIdQuery, GetUnitTransferByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitTransferByIdQuery, GetUnitTransferByIdQueryVariables>(GetUnitTransferByIdDocument, options);
      }
export function useGetUnitTransferByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitTransferByIdQuery, GetUnitTransferByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitTransferByIdQuery, GetUnitTransferByIdQueryVariables>(GetUnitTransferByIdDocument, options);
        }
export type GetUnitTransferByIdQueryHookResult = ReturnType<typeof useGetUnitTransferByIdQuery>;
export type GetUnitTransferByIdLazyQueryHookResult = ReturnType<typeof useGetUnitTransferByIdLazyQuery>;
export type GetUnitTransferByIdQueryResult = Apollo.QueryResult<GetUnitTransferByIdQuery, GetUnitTransferByIdQueryVariables>;
export const GetUnitTransferDropdownDocument = gql`
    query getUnitTransferDropdown {
  getUnitTransferDropdown {
    saleId
    unitId
    unitNo
    fullName
    phoneNo
    builtUp
    builtUpArea
    landArea
    extraLandArea
    builtUpAreaRate
    landAreaRate
    extraLandAreaRate
    sellingPrice
    paymentPlanName
    isCompany
    companyName
    companyRegNo
    nricNo
    discardBumiDiscount
    discountList {
      discountId
      title
      discountMethod
      amount
      seqNo
      formula
    }
  }
}
    `;

/**
 * __useGetUnitTransferDropdownQuery__
 *
 * To run a query within a React component, call `useGetUnitTransferDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitTransferDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitTransferDropdownQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUnitTransferDropdownQuery(baseOptions?: Apollo.QueryHookOptions<GetUnitTransferDropdownQuery, GetUnitTransferDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitTransferDropdownQuery, GetUnitTransferDropdownQueryVariables>(GetUnitTransferDropdownDocument, options);
      }
export function useGetUnitTransferDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitTransferDropdownQuery, GetUnitTransferDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitTransferDropdownQuery, GetUnitTransferDropdownQueryVariables>(GetUnitTransferDropdownDocument, options);
        }
export type GetUnitTransferDropdownQueryHookResult = ReturnType<typeof useGetUnitTransferDropdownQuery>;
export type GetUnitTransferDropdownLazyQueryHookResult = ReturnType<typeof useGetUnitTransferDropdownLazyQuery>;
export type GetUnitTransferDropdownQueryResult = Apollo.QueryResult<GetUnitTransferDropdownQuery, GetUnitTransferDropdownQueryVariables>;
export const GetAvailableUnitDropdownDocument = gql`
    query getAvailableUnitDropdown {
  getAvailableUnitDropdown {
    unitId
    unitNo
    builtUp
    builtUpArea
    landArea
    extraLandArea
    builtUpAreaRate
    landAreaRate
    extraLandAreaRate
    listPrice
    paymentPlanId
  }
}
    `;

/**
 * __useGetAvailableUnitDropdownQuery__
 *
 * To run a query within a React component, call `useGetAvailableUnitDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableUnitDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableUnitDropdownQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAvailableUnitDropdownQuery(baseOptions?: Apollo.QueryHookOptions<GetAvailableUnitDropdownQuery, GetAvailableUnitDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableUnitDropdownQuery, GetAvailableUnitDropdownQueryVariables>(GetAvailableUnitDropdownDocument, options);
      }
export function useGetAvailableUnitDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableUnitDropdownQuery, GetAvailableUnitDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableUnitDropdownQuery, GetAvailableUnitDropdownQueryVariables>(GetAvailableUnitDropdownDocument, options);
        }
export type GetAvailableUnitDropdownQueryHookResult = ReturnType<typeof useGetAvailableUnitDropdownQuery>;
export type GetAvailableUnitDropdownLazyQueryHookResult = ReturnType<typeof useGetAvailableUnitDropdownLazyQuery>;
export type GetAvailableUnitDropdownQueryResult = Apollo.QueryResult<GetAvailableUnitDropdownQuery, GetAvailableUnitDropdownQueryVariables>;
export const GetPaymentPlanDropdownDocument = gql`
    query getPaymentPlanDropdown {
  getPaymentPlanDropdown {
    id
    paymentPlanId
    defaulted
    paymentPlan {
      name
      payMethod
      effectiveDate
    }
  }
}
    `;

/**
 * __useGetPaymentPlanDropdownQuery__
 *
 * To run a query within a React component, call `useGetPaymentPlanDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentPlanDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentPlanDropdownQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPaymentPlanDropdownQuery(baseOptions?: Apollo.QueryHookOptions<GetPaymentPlanDropdownQuery, GetPaymentPlanDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentPlanDropdownQuery, GetPaymentPlanDropdownQueryVariables>(GetPaymentPlanDropdownDocument, options);
      }
export function useGetPaymentPlanDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentPlanDropdownQuery, GetPaymentPlanDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentPlanDropdownQuery, GetPaymentPlanDropdownQueryVariables>(GetPaymentPlanDropdownDocument, options);
        }
export type GetPaymentPlanDropdownQueryHookResult = ReturnType<typeof useGetPaymentPlanDropdownQuery>;
export type GetPaymentPlanDropdownLazyQueryHookResult = ReturnType<typeof useGetPaymentPlanDropdownLazyQuery>;
export type GetPaymentPlanDropdownQueryResult = Apollo.QueryResult<GetPaymentPlanDropdownQuery, GetPaymentPlanDropdownQueryVariables>;
export const GetUnitTransferReasonDocument = gql`
    query getUnitTransferReason {
  getUnitTransferReason {
    id
    name
    defaulted
  }
}
    `;

/**
 * __useGetUnitTransferReasonQuery__
 *
 * To run a query within a React component, call `useGetUnitTransferReasonQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitTransferReasonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitTransferReasonQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUnitTransferReasonQuery(baseOptions?: Apollo.QueryHookOptions<GetUnitTransferReasonQuery, GetUnitTransferReasonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitTransferReasonQuery, GetUnitTransferReasonQueryVariables>(GetUnitTransferReasonDocument, options);
      }
export function useGetUnitTransferReasonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitTransferReasonQuery, GetUnitTransferReasonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitTransferReasonQuery, GetUnitTransferReasonQueryVariables>(GetUnitTransferReasonDocument, options);
        }
export type GetUnitTransferReasonQueryHookResult = ReturnType<typeof useGetUnitTransferReasonQuery>;
export type GetUnitTransferReasonLazyQueryHookResult = ReturnType<typeof useGetUnitTransferReasonLazyQuery>;
export type GetUnitTransferReasonQueryResult = Apollo.QueryResult<GetUnitTransferReasonQuery, GetUnitTransferReasonQueryVariables>;
export const AddUnitTransferDocument = gql`
    mutation addUnitTransfer($input: AddUnitTransferInput!) {
  addUnitTransfer(input: $input)
}
    `;
export type AddUnitTransferMutationFn = Apollo.MutationFunction<AddUnitTransferMutation, AddUnitTransferMutationVariables>;

/**
 * __useAddUnitTransferMutation__
 *
 * To run a mutation, you first call `useAddUnitTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUnitTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUnitTransferMutation, { data, loading, error }] = useAddUnitTransferMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddUnitTransferMutation(baseOptions?: Apollo.MutationHookOptions<AddUnitTransferMutation, AddUnitTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUnitTransferMutation, AddUnitTransferMutationVariables>(AddUnitTransferDocument, options);
      }
export type AddUnitTransferMutationHookResult = ReturnType<typeof useAddUnitTransferMutation>;
export type AddUnitTransferMutationResult = Apollo.MutationResult<AddUnitTransferMutation>;
export type AddUnitTransferMutationOptions = Apollo.BaseMutationOptions<AddUnitTransferMutation, AddUnitTransferMutationVariables>;
export const EditUnitTransferDocument = gql`
    mutation editUnitTransfer($input: EditUnitTransferInput!) {
  editUnitTransfer(input: $input)
}
    `;
export type EditUnitTransferMutationFn = Apollo.MutationFunction<EditUnitTransferMutation, EditUnitTransferMutationVariables>;

/**
 * __useEditUnitTransferMutation__
 *
 * To run a mutation, you first call `useEditUnitTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditUnitTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editUnitTransferMutation, { data, loading, error }] = useEditUnitTransferMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditUnitTransferMutation(baseOptions?: Apollo.MutationHookOptions<EditUnitTransferMutation, EditUnitTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditUnitTransferMutation, EditUnitTransferMutationVariables>(EditUnitTransferDocument, options);
      }
export type EditUnitTransferMutationHookResult = ReturnType<typeof useEditUnitTransferMutation>;
export type EditUnitTransferMutationResult = Apollo.MutationResult<EditUnitTransferMutation>;
export type EditUnitTransferMutationOptions = Apollo.BaseMutationOptions<EditUnitTransferMutation, EditUnitTransferMutationVariables>;
export const DeleteUnitTransferDocument = gql`
    mutation deleteUnitTransfer($unitTransferId: String!) {
  deleteUnitTransfer(unitTransferId: $unitTransferId)
}
    `;
export type DeleteUnitTransferMutationFn = Apollo.MutationFunction<DeleteUnitTransferMutation, DeleteUnitTransferMutationVariables>;

/**
 * __useDeleteUnitTransferMutation__
 *
 * To run a mutation, you first call `useDeleteUnitTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUnitTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUnitTransferMutation, { data, loading, error }] = useDeleteUnitTransferMutation({
 *   variables: {
 *      unitTransferId: // value for 'unitTransferId'
 *   },
 * });
 */
export function useDeleteUnitTransferMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUnitTransferMutation, DeleteUnitTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUnitTransferMutation, DeleteUnitTransferMutationVariables>(DeleteUnitTransferDocument, options);
      }
export type DeleteUnitTransferMutationHookResult = ReturnType<typeof useDeleteUnitTransferMutation>;
export type DeleteUnitTransferMutationResult = Apollo.MutationResult<DeleteUnitTransferMutation>;
export type DeleteUnitTransferMutationOptions = Apollo.BaseMutationOptions<DeleteUnitTransferMutation, DeleteUnitTransferMutationVariables>;
export const RejectUnitTransferDocument = gql`
    mutation rejectUnitTransfer($unitTransferIds: [String!]!) {
  rejectUnitTransfer(unitTransferIds: $unitTransferIds)
}
    `;
export type RejectUnitTransferMutationFn = Apollo.MutationFunction<RejectUnitTransferMutation, RejectUnitTransferMutationVariables>;

/**
 * __useRejectUnitTransferMutation__
 *
 * To run a mutation, you first call `useRejectUnitTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectUnitTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectUnitTransferMutation, { data, loading, error }] = useRejectUnitTransferMutation({
 *   variables: {
 *      unitTransferIds: // value for 'unitTransferIds'
 *   },
 * });
 */
export function useRejectUnitTransferMutation(baseOptions?: Apollo.MutationHookOptions<RejectUnitTransferMutation, RejectUnitTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectUnitTransferMutation, RejectUnitTransferMutationVariables>(RejectUnitTransferDocument, options);
      }
export type RejectUnitTransferMutationHookResult = ReturnType<typeof useRejectUnitTransferMutation>;
export type RejectUnitTransferMutationResult = Apollo.MutationResult<RejectUnitTransferMutation>;
export type RejectUnitTransferMutationOptions = Apollo.BaseMutationOptions<RejectUnitTransferMutation, RejectUnitTransferMutationVariables>;
export const ApproveUnitTransferDocument = gql`
    mutation approveUnitTransfer($unitTransferIds: [String!]!) {
  approveUnitTransfer(unitTransferIds: $unitTransferIds)
}
    `;
export type ApproveUnitTransferMutationFn = Apollo.MutationFunction<ApproveUnitTransferMutation, ApproveUnitTransferMutationVariables>;

/**
 * __useApproveUnitTransferMutation__
 *
 * To run a mutation, you first call `useApproveUnitTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveUnitTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveUnitTransferMutation, { data, loading, error }] = useApproveUnitTransferMutation({
 *   variables: {
 *      unitTransferIds: // value for 'unitTransferIds'
 *   },
 * });
 */
export function useApproveUnitTransferMutation(baseOptions?: Apollo.MutationHookOptions<ApproveUnitTransferMutation, ApproveUnitTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveUnitTransferMutation, ApproveUnitTransferMutationVariables>(ApproveUnitTransferDocument, options);
      }
export type ApproveUnitTransferMutationHookResult = ReturnType<typeof useApproveUnitTransferMutation>;
export type ApproveUnitTransferMutationResult = Apollo.MutationResult<ApproveUnitTransferMutation>;
export type ApproveUnitTransferMutationOptions = Apollo.BaseMutationOptions<ApproveUnitTransferMutation, ApproveUnitTransferMutationVariables>;
export const GetUnitTransferMasterDataDocument = gql`
    query getUnitTransferMasterData($transferId: String, $transferDate: DateTime) {
  getUnitTransferIndoMasterData(transferId: $transferId, transferDate: $transferDate) {
    fromUnit {
      saleId
      adminFee
      miscBillId
      unitNo
      projectId
      saleRegDate
      totalAllocateAmt
      totalUnallocateAmt
      additionalPackages {
        id
        accountId
        saleId
        packageId
        promotionalPackageId
        openMarketValue
        sellingPrice
        taxSchemeId
        workProgressId
        discountId
        discountAmount
        isIncludeContract
        sellingMethod
        paymentPlanId
        commonStatus
        promotionalPackage {
          id
          accountId
          projectId
          name
          startDate
          endDate
          recordStatus
        }
      }
      mainBuyer {
        id
        fullName
        email
        phoneNo
        gender
        icNo
        militaryIc
        homeTel
        officeTel
        salutation {
          name
          id
        }
        nationality {
          name
          id
        }
        race {
          name
          id
        }
        maritalStatus {
          name
          id
        }
        contactExt {
          id
          identityType
          customerOrigin
          isVip
          isForeignPurchase
          subscribeMaterialSms
          subscribeMaterialWhatsapp
          subscribeMaterialEmail
          subscribeMaterialPaNews
          mailingMethod
          professionId
          religionId
          nameOnTax
          taxRegistrationNo
          taxRegistrationAddress
          isPrincipalBuyer
          remark
        }
        contactAddress {
          address
          country
          city
          state
          postCode
          AddressType
        }
      }
      builtUp
      listPrice
    }
    toUnit {
      unitId
      unitNo
      projectId
      builtUp
      purchaserName
      listPrice
      landArea
      taxSchemeId
      taxSchemeName
      builtUpAreaRate
      landAreaRate
      commercialPurpose
      propertyType
    }
    transferReason {
      id
      name
    }
    paymentPlans {
      id
      name
      markUpPercentage
      projectPaymentPlan
      projectPlanStartDate
      projectPlanEndDate
    }
  }
}
    `;

/**
 * __useGetUnitTransferMasterDataQuery__
 *
 * To run a query within a React component, call `useGetUnitTransferMasterDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitTransferMasterDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitTransferMasterDataQuery({
 *   variables: {
 *      transferId: // value for 'transferId'
 *      transferDate: // value for 'transferDate'
 *   },
 * });
 */
export function useGetUnitTransferMasterDataQuery(baseOptions?: Apollo.QueryHookOptions<GetUnitTransferMasterDataQuery, GetUnitTransferMasterDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitTransferMasterDataQuery, GetUnitTransferMasterDataQueryVariables>(GetUnitTransferMasterDataDocument, options);
      }
export function useGetUnitTransferMasterDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitTransferMasterDataQuery, GetUnitTransferMasterDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitTransferMasterDataQuery, GetUnitTransferMasterDataQueryVariables>(GetUnitTransferMasterDataDocument, options);
        }
export type GetUnitTransferMasterDataQueryHookResult = ReturnType<typeof useGetUnitTransferMasterDataQuery>;
export type GetUnitTransferMasterDataLazyQueryHookResult = ReturnType<typeof useGetUnitTransferMasterDataLazyQuery>;
export type GetUnitTransferMasterDataQueryResult = Apollo.QueryResult<GetUnitTransferMasterDataQuery, GetUnitTransferMasterDataQueryVariables>;
export const GetUnitTransferPaymentPlanDetailsDocument = gql`
    query getUnitTransferPaymentPlanDetails($unitId: String!, $paymentPlanId: String!, $finalContractPrice: Float, $InstallmentSummaryInput: [InstallmentSummaryInput!], $paymentMarkUpAmt: Float, $taxSchemeId: String, $isCarparkOrPackage: Boolean, $regDate: DateTime, $prevSaleId: String!) {
  getUnitTransferPaymentPlanDetails(unitId: $unitId, paymentPlanId: $paymentPlanId, finalContractPrice: $finalContractPrice, InstallmentSummaryInput: $InstallmentSummaryInput, paymentMarkUpAmt: $paymentMarkUpAmt, taxSchemeId: $taxSchemeId, isCarparkOrPackage: $isCarparkOrPackage, regDate: $regDate, prevSaleId: $prevSaleId) {
    paymentPlanId
    markUpPercentage
    markUpPrice
    installmentSummary {
      paymentPlanDetailsId
      paymentPlanName
      billType
      billAfter
      billFreq
      billCount
      markUpPercentage
      installmentCount
      totalPayableAmt
      isFixAmt
      deductBookingFee
      installmentDetails {
        billType
        installementDate
        baseAmt
        taxAmt
        payableAmt
        seqNo
        description
      }
    }
    paymentPlanDate
  }
}
    `;

/**
 * __useGetUnitTransferPaymentPlanDetailsQuery__
 *
 * To run a query within a React component, call `useGetUnitTransferPaymentPlanDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitTransferPaymentPlanDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitTransferPaymentPlanDetailsQuery({
 *   variables: {
 *      unitId: // value for 'unitId'
 *      paymentPlanId: // value for 'paymentPlanId'
 *      finalContractPrice: // value for 'finalContractPrice'
 *      InstallmentSummaryInput: // value for 'InstallmentSummaryInput'
 *      paymentMarkUpAmt: // value for 'paymentMarkUpAmt'
 *      taxSchemeId: // value for 'taxSchemeId'
 *      isCarparkOrPackage: // value for 'isCarparkOrPackage'
 *      regDate: // value for 'regDate'
 *      prevSaleId: // value for 'prevSaleId'
 *   },
 * });
 */
export function useGetUnitTransferPaymentPlanDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetUnitTransferPaymentPlanDetailsQuery, GetUnitTransferPaymentPlanDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitTransferPaymentPlanDetailsQuery, GetUnitTransferPaymentPlanDetailsQueryVariables>(GetUnitTransferPaymentPlanDetailsDocument, options);
      }
export function useGetUnitTransferPaymentPlanDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitTransferPaymentPlanDetailsQuery, GetUnitTransferPaymentPlanDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitTransferPaymentPlanDetailsQuery, GetUnitTransferPaymentPlanDetailsQueryVariables>(GetUnitTransferPaymentPlanDetailsDocument, options);
        }
export type GetUnitTransferPaymentPlanDetailsQueryHookResult = ReturnType<typeof useGetUnitTransferPaymentPlanDetailsQuery>;
export type GetUnitTransferPaymentPlanDetailsLazyQueryHookResult = ReturnType<typeof useGetUnitTransferPaymentPlanDetailsLazyQuery>;
export type GetUnitTransferPaymentPlanDetailsQueryResult = Apollo.QueryResult<GetUnitTransferPaymentPlanDetailsQuery, GetUnitTransferPaymentPlanDetailsQueryVariables>;
export const GetUnitTransferPricingPaymentPlanDetailsDocument = gql`
    query getUnitTransferPricingPaymentPlanDetails($inputs: [GetUnitTransferPricingPaymentPlanInput!]!) {
  getUnitTransferPricingPaymentPlanDetails(inputs: $inputs) {
    id
    paymentPlanId
    markUpPercentage
    markUpPrice
    installmentSummary {
      paymentPlanDetailsId
      paymentPlanName
      billType
      billAfter
      billFreq
      billCount
      markUpPercentage
      installmentCount
      totalPayableAmt
      isFixAmt
      deductBookingFee
      installmentDetails {
        billType
        installementDate
        baseAmt
        taxAmt
        payableAmt
        seqNo
        description
      }
    }
    paymentPlanDate
  }
}
    `;

/**
 * __useGetUnitTransferPricingPaymentPlanDetailsQuery__
 *
 * To run a query within a React component, call `useGetUnitTransferPricingPaymentPlanDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitTransferPricingPaymentPlanDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitTransferPricingPaymentPlanDetailsQuery({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useGetUnitTransferPricingPaymentPlanDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetUnitTransferPricingPaymentPlanDetailsQuery, GetUnitTransferPricingPaymentPlanDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitTransferPricingPaymentPlanDetailsQuery, GetUnitTransferPricingPaymentPlanDetailsQueryVariables>(GetUnitTransferPricingPaymentPlanDetailsDocument, options);
      }
export function useGetUnitTransferPricingPaymentPlanDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitTransferPricingPaymentPlanDetailsQuery, GetUnitTransferPricingPaymentPlanDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitTransferPricingPaymentPlanDetailsQuery, GetUnitTransferPricingPaymentPlanDetailsQueryVariables>(GetUnitTransferPricingPaymentPlanDetailsDocument, options);
        }
export type GetUnitTransferPricingPaymentPlanDetailsQueryHookResult = ReturnType<typeof useGetUnitTransferPricingPaymentPlanDetailsQuery>;
export type GetUnitTransferPricingPaymentPlanDetailsLazyQueryHookResult = ReturnType<typeof useGetUnitTransferPricingPaymentPlanDetailsLazyQuery>;
export type GetUnitTransferPricingPaymentPlanDetailsQueryResult = Apollo.QueryResult<GetUnitTransferPricingPaymentPlanDetailsQuery, GetUnitTransferPricingPaymentPlanDetailsQueryVariables>;
export const SubmitUnitTransferFormDocument = gql`
    mutation submitUnitTransferForm($input: submitUnitTransferFormInput!, $transferId: String) {
  submitUnitTransferForm(input: $input, transferId: $transferId)
}
    `;
export type SubmitUnitTransferFormMutationFn = Apollo.MutationFunction<SubmitUnitTransferFormMutation, SubmitUnitTransferFormMutationVariables>;

/**
 * __useSubmitUnitTransferFormMutation__
 *
 * To run a mutation, you first call `useSubmitUnitTransferFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitUnitTransferFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitUnitTransferFormMutation, { data, loading, error }] = useSubmitUnitTransferFormMutation({
 *   variables: {
 *      input: // value for 'input'
 *      transferId: // value for 'transferId'
 *   },
 * });
 */
export function useSubmitUnitTransferFormMutation(baseOptions?: Apollo.MutationHookOptions<SubmitUnitTransferFormMutation, SubmitUnitTransferFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitUnitTransferFormMutation, SubmitUnitTransferFormMutationVariables>(SubmitUnitTransferFormDocument, options);
      }
export type SubmitUnitTransferFormMutationHookResult = ReturnType<typeof useSubmitUnitTransferFormMutation>;
export type SubmitUnitTransferFormMutationResult = Apollo.MutationResult<SubmitUnitTransferFormMutation>;
export type SubmitUnitTransferFormMutationOptions = Apollo.BaseMutationOptions<SubmitUnitTransferFormMutation, SubmitUnitTransferFormMutationVariables>;
export const GetUnitTransferIndoListingDocument = gql`
    query getUnitTransferIndoListing($status: String!) {
  getUnitTransferIndoList(status: $status) {
    id
    mainBuyer
    oldUnitNo
    newUnitNo
    transferDate
    cancelReason
  }
}
    `;

/**
 * __useGetUnitTransferIndoListingQuery__
 *
 * To run a query within a React component, call `useGetUnitTransferIndoListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitTransferIndoListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitTransferIndoListingQuery({
 *   variables: {
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetUnitTransferIndoListingQuery(baseOptions: Apollo.QueryHookOptions<GetUnitTransferIndoListingQuery, GetUnitTransferIndoListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitTransferIndoListingQuery, GetUnitTransferIndoListingQueryVariables>(GetUnitTransferIndoListingDocument, options);
      }
export function useGetUnitTransferIndoListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitTransferIndoListingQuery, GetUnitTransferIndoListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitTransferIndoListingQuery, GetUnitTransferIndoListingQueryVariables>(GetUnitTransferIndoListingDocument, options);
        }
export type GetUnitTransferIndoListingQueryHookResult = ReturnType<typeof useGetUnitTransferIndoListingQuery>;
export type GetUnitTransferIndoListingLazyQueryHookResult = ReturnType<typeof useGetUnitTransferIndoListingLazyQuery>;
export type GetUnitTransferIndoListingQueryResult = Apollo.QueryResult<GetUnitTransferIndoListingQuery, GetUnitTransferIndoListingQueryVariables>;
export const GetPurchaserPaymentPlanDetailDocument = gql`
    query getPurchaserPaymentPlanDetail($paymentPlanDetailId: String!) {
  getPurchaserPaymentPlanDetail(paymentPlanDetailId: $paymentPlanDetailId) {
    id
    accountId
    purchaserPaymentPlanId
    title
    paymentBy
    paymentValue
    billType
    noInstallment
    deductBookingFee
    billCount
    billFrequency
    billAfter
    recordStatus
    createdBy
    createdTs
    modBy
    modTs
  }
}
    `;

/**
 * __useGetPurchaserPaymentPlanDetailQuery__
 *
 * To run a query within a React component, call `useGetPurchaserPaymentPlanDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPurchaserPaymentPlanDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPurchaserPaymentPlanDetailQuery({
 *   variables: {
 *      paymentPlanDetailId: // value for 'paymentPlanDetailId'
 *   },
 * });
 */
export function useGetPurchaserPaymentPlanDetailQuery(baseOptions: Apollo.QueryHookOptions<GetPurchaserPaymentPlanDetailQuery, GetPurchaserPaymentPlanDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPurchaserPaymentPlanDetailQuery, GetPurchaserPaymentPlanDetailQueryVariables>(GetPurchaserPaymentPlanDetailDocument, options);
      }
export function useGetPurchaserPaymentPlanDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPurchaserPaymentPlanDetailQuery, GetPurchaserPaymentPlanDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPurchaserPaymentPlanDetailQuery, GetPurchaserPaymentPlanDetailQueryVariables>(GetPurchaserPaymentPlanDetailDocument, options);
        }
export type GetPurchaserPaymentPlanDetailQueryHookResult = ReturnType<typeof useGetPurchaserPaymentPlanDetailQuery>;
export type GetPurchaserPaymentPlanDetailLazyQueryHookResult = ReturnType<typeof useGetPurchaserPaymentPlanDetailLazyQuery>;
export type GetPurchaserPaymentPlanDetailQueryResult = Apollo.QueryResult<GetPurchaserPaymentPlanDetailQuery, GetPurchaserPaymentPlanDetailQueryVariables>;
export const GetUnitTransferIndoEditDataDocument = gql`
    query getUnitTransferIndoEditData($transferId: String!) {
  getUnitTransferIndoById(id: $transferId) {
    id
    transferDate
    fromUnit {
      saleId
      adminFee
      miscBillId
      unitNo
      projectId
      totalAllocateAmt
      saleRegDate
      mainBuyer {
        id
        fullName
        email
        phoneNo
        gender
        icNo
        militaryIc
        homeTel
        officeTel
        salutation {
          name
          id
        }
        nationality {
          name
          id
        }
        race {
          name
          id
        }
        maritalStatus {
          name
          id
        }
        contactExt {
          id
          identityType
          customerOrigin
          isVip
          isForeignPurchase
          subscribeMaterialSms
          subscribeMaterialWhatsapp
          subscribeMaterialEmail
          subscribeMaterialPaNews
          mailingMethod
          professionId
          religionId
          nameOnTax
          taxRegistrationNo
          taxRegistrationAddress
          isPrincipalBuyer
          remark
        }
        contactAddress {
          address
          country
          city
          state
          postCode
          AddressType
        }
      }
      builtUp
      listPrice
    }
    toUnit {
      unitId
      unitNo
      projectId
      builtUp
      listPrice
      landArea
      taxSchemeId
      taxSchemeName
      builtUpAreaRate
      landAreaRate
      commercialPurpose
      propertyType
    }
    transferReason
    mainBuyer {
      id
      fullName
      email
      phoneNo
      gender
      icNo
      militaryIc
      homeTel
      officeTel
      salutation {
        name
        id
      }
      nationality {
        name
        id
      }
      race {
        name
        id
      }
      maritalStatus {
        name
        id
      }
      contactExt {
        id
        identityType
        customerOrigin
        isVip
        isForeignPurchase
        subscribeMaterialSms
        subscribeMaterialWhatsapp
        subscribeMaterialEmail
        subscribeMaterialPaNews
        mailingMethod
        professionId
        religionId
        nameOnTax
        taxRegistrationNo
        taxRegistrationAddress
        isPrincipalBuyer
        remark
      }
      contactAddress {
        address
        country
        city
        state
        postCode
        AddressType
      }
    }
    jointBuyer {
      id
      fullName
      email
      phoneNo
      gender
      icNo
      militaryIc
      homeTel
      officeTel
      salutation {
        name
        id
      }
      nationality {
        name
        id
      }
      race {
        name
        id
      }
      maritalStatus {
        name
        id
      }
      contactExt {
        id
        identityType
        customerOrigin
        isVip
        isForeignPurchase
        subscribeMaterialSms
        subscribeMaterialWhatsapp
        subscribeMaterialEmail
        subscribeMaterialPaNews
        mailingMethod
        professionId
        religionId
        nameOnTax
        taxRegistrationNo
        taxRegistrationAddress
        isPrincipalBuyer
        remark
      }
      contactAddress {
        address
        country
        city
        state
        postCode
        AddressType
      }
    }
    taxSchema {
      id
      name
    }
    salePackage
    discounts {
      discountAmount
      discountID
      discountMethod
      formula
      title
    }
    carPark
    salesPaymentPlan
    others
    taxRate
  }
}
    `;

/**
 * __useGetUnitTransferIndoEditDataQuery__
 *
 * To run a query within a React component, call `useGetUnitTransferIndoEditDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitTransferIndoEditDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitTransferIndoEditDataQuery({
 *   variables: {
 *      transferId: // value for 'transferId'
 *   },
 * });
 */
export function useGetUnitTransferIndoEditDataQuery(baseOptions: Apollo.QueryHookOptions<GetUnitTransferIndoEditDataQuery, GetUnitTransferIndoEditDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitTransferIndoEditDataQuery, GetUnitTransferIndoEditDataQueryVariables>(GetUnitTransferIndoEditDataDocument, options);
      }
export function useGetUnitTransferIndoEditDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitTransferIndoEditDataQuery, GetUnitTransferIndoEditDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitTransferIndoEditDataQuery, GetUnitTransferIndoEditDataQueryVariables>(GetUnitTransferIndoEditDataDocument, options);
        }
export type GetUnitTransferIndoEditDataQueryHookResult = ReturnType<typeof useGetUnitTransferIndoEditDataQuery>;
export type GetUnitTransferIndoEditDataLazyQueryHookResult = ReturnType<typeof useGetUnitTransferIndoEditDataLazyQuery>;
export type GetUnitTransferIndoEditDataQueryResult = Apollo.QueryResult<GetUnitTransferIndoEditDataQuery, GetUnitTransferIndoEditDataQueryVariables>;
export const EditUnitTransferIndoDocument = gql`
    mutation editUnitTransferIndo($input: submitUnitTransferFormInput!, $transferId: String!) {
  editUnitTransferIndo(transferId: $transferId, input: $input)
}
    `;
export type EditUnitTransferIndoMutationFn = Apollo.MutationFunction<EditUnitTransferIndoMutation, EditUnitTransferIndoMutationVariables>;

/**
 * __useEditUnitTransferIndoMutation__
 *
 * To run a mutation, you first call `useEditUnitTransferIndoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditUnitTransferIndoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editUnitTransferIndoMutation, { data, loading, error }] = useEditUnitTransferIndoMutation({
 *   variables: {
 *      input: // value for 'input'
 *      transferId: // value for 'transferId'
 *   },
 * });
 */
export function useEditUnitTransferIndoMutation(baseOptions?: Apollo.MutationHookOptions<EditUnitTransferIndoMutation, EditUnitTransferIndoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditUnitTransferIndoMutation, EditUnitTransferIndoMutationVariables>(EditUnitTransferIndoDocument, options);
      }
export type EditUnitTransferIndoMutationHookResult = ReturnType<typeof useEditUnitTransferIndoMutation>;
export type EditUnitTransferIndoMutationResult = Apollo.MutationResult<EditUnitTransferIndoMutation>;
export type EditUnitTransferIndoMutationOptions = Apollo.BaseMutationOptions<EditUnitTransferIndoMutation, EditUnitTransferIndoMutationVariables>;
export const ApproveUnitTransferIndoDocument = gql`
    mutation approveUnitTransferIndo($input: ApproveUnitTransferIndoInput!) {
  approveUnitTransferIndo(input: $input)
}
    `;
export type ApproveUnitTransferIndoMutationFn = Apollo.MutationFunction<ApproveUnitTransferIndoMutation, ApproveUnitTransferIndoMutationVariables>;

/**
 * __useApproveUnitTransferIndoMutation__
 *
 * To run a mutation, you first call `useApproveUnitTransferIndoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveUnitTransferIndoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveUnitTransferIndoMutation, { data, loading, error }] = useApproveUnitTransferIndoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApproveUnitTransferIndoMutation(baseOptions?: Apollo.MutationHookOptions<ApproveUnitTransferIndoMutation, ApproveUnitTransferIndoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveUnitTransferIndoMutation, ApproveUnitTransferIndoMutationVariables>(ApproveUnitTransferIndoDocument, options);
      }
export type ApproveUnitTransferIndoMutationHookResult = ReturnType<typeof useApproveUnitTransferIndoMutation>;
export type ApproveUnitTransferIndoMutationResult = Apollo.MutationResult<ApproveUnitTransferIndoMutation>;
export type ApproveUnitTransferIndoMutationOptions = Apollo.BaseMutationOptions<ApproveUnitTransferIndoMutation, ApproveUnitTransferIndoMutationVariables>;
export const GetUnitTransferIndoDetailsDocument = gql`
    query getUnitTransferIndoDetails($transferId: String!) {
  getUnitTransferIndoDetails(transferId: $transferId) {
    id
    newSaleId
    mainBuyer
    projectId
    oldUnitNo
    newUnitNo
    adminFee
    reason
    attachment
    status
    transferDate
    salesPaymentPlan
    approvedBy
    approvedDate
  }
}
    `;

/**
 * __useGetUnitTransferIndoDetailsQuery__
 *
 * To run a query within a React component, call `useGetUnitTransferIndoDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitTransferIndoDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitTransferIndoDetailsQuery({
 *   variables: {
 *      transferId: // value for 'transferId'
 *   },
 * });
 */
export function useGetUnitTransferIndoDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetUnitTransferIndoDetailsQuery, GetUnitTransferIndoDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitTransferIndoDetailsQuery, GetUnitTransferIndoDetailsQueryVariables>(GetUnitTransferIndoDetailsDocument, options);
      }
export function useGetUnitTransferIndoDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitTransferIndoDetailsQuery, GetUnitTransferIndoDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitTransferIndoDetailsQuery, GetUnitTransferIndoDetailsQueryVariables>(GetUnitTransferIndoDetailsDocument, options);
        }
export type GetUnitTransferIndoDetailsQueryHookResult = ReturnType<typeof useGetUnitTransferIndoDetailsQuery>;
export type GetUnitTransferIndoDetailsLazyQueryHookResult = ReturnType<typeof useGetUnitTransferIndoDetailsLazyQuery>;
export type GetUnitTransferIndoDetailsQueryResult = Apollo.QueryResult<GetUnitTransferIndoDetailsQuery, GetUnitTransferIndoDetailsQueryVariables>;
export const GetTaxRateDocument = gql`
    query getTaxRate($taxSchemeId: String!) {
  getTaxRate(taxSchemeId: $taxSchemeId)
}
    `;

/**
 * __useGetTaxRateQuery__
 *
 * To run a query within a React component, call `useGetTaxRateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaxRateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaxRateQuery({
 *   variables: {
 *      taxSchemeId: // value for 'taxSchemeId'
 *   },
 * });
 */
export function useGetTaxRateQuery(baseOptions: Apollo.QueryHookOptions<GetTaxRateQuery, GetTaxRateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaxRateQuery, GetTaxRateQueryVariables>(GetTaxRateDocument, options);
      }
export function useGetTaxRateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaxRateQuery, GetTaxRateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaxRateQuery, GetTaxRateQueryVariables>(GetTaxRateDocument, options);
        }
export type GetTaxRateQueryHookResult = ReturnType<typeof useGetTaxRateQuery>;
export type GetTaxRateLazyQueryHookResult = ReturnType<typeof useGetTaxRateLazyQuery>;
export type GetTaxRateQueryResult = Apollo.QueryResult<GetTaxRateQuery, GetTaxRateQueryVariables>;
export const GetAllUnitsVpLetterDocument = gql`
    query getAllUnitsVpLetter {
  getAllUnitsVpLetter {
    vpLetterDate
    vpLetterCount
    unitIndex
  }
}
    `;

/**
 * __useGetAllUnitsVpLetterQuery__
 *
 * To run a query within a React component, call `useGetAllUnitsVpLetterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllUnitsVpLetterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllUnitsVpLetterQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllUnitsVpLetterQuery(baseOptions?: Apollo.QueryHookOptions<GetAllUnitsVpLetterQuery, GetAllUnitsVpLetterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllUnitsVpLetterQuery, GetAllUnitsVpLetterQueryVariables>(GetAllUnitsVpLetterDocument, options);
      }
export function useGetAllUnitsVpLetterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllUnitsVpLetterQuery, GetAllUnitsVpLetterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllUnitsVpLetterQuery, GetAllUnitsVpLetterQueryVariables>(GetAllUnitsVpLetterDocument, options);
        }
export type GetAllUnitsVpLetterQueryHookResult = ReturnType<typeof useGetAllUnitsVpLetterQuery>;
export type GetAllUnitsVpLetterLazyQueryHookResult = ReturnType<typeof useGetAllUnitsVpLetterLazyQuery>;
export type GetAllUnitsVpLetterQueryResult = Apollo.QueryResult<GetAllUnitsVpLetterQuery, GetAllUnitsVpLetterQueryVariables>;
export const GetUnitsVpLetterByDateDocument = gql`
    query getUnitsVpLetterByDate($vpLetterDate: DateTime!) {
  getUnitsVpLetterByDate(vpLetterDate: $vpLetterDate) {
    block
    totalFloor
    floorList {
      floorLabel
      totalUnit
      unitList {
        unitId
        unitNo
      }
    }
  }
}
    `;

/**
 * __useGetUnitsVpLetterByDateQuery__
 *
 * To run a query within a React component, call `useGetUnitsVpLetterByDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitsVpLetterByDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitsVpLetterByDateQuery({
 *   variables: {
 *      vpLetterDate: // value for 'vpLetterDate'
 *   },
 * });
 */
export function useGetUnitsVpLetterByDateQuery(baseOptions: Apollo.QueryHookOptions<GetUnitsVpLetterByDateQuery, GetUnitsVpLetterByDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitsVpLetterByDateQuery, GetUnitsVpLetterByDateQueryVariables>(GetUnitsVpLetterByDateDocument, options);
      }
export function useGetUnitsVpLetterByDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitsVpLetterByDateQuery, GetUnitsVpLetterByDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitsVpLetterByDateQuery, GetUnitsVpLetterByDateQueryVariables>(GetUnitsVpLetterByDateDocument, options);
        }
export type GetUnitsVpLetterByDateQueryHookResult = ReturnType<typeof useGetUnitsVpLetterByDateQuery>;
export type GetUnitsVpLetterByDateLazyQueryHookResult = ReturnType<typeof useGetUnitsVpLetterByDateLazyQuery>;
export type GetUnitsVpLetterByDateQueryResult = Apollo.QueryResult<GetUnitsVpLetterByDateQuery, GetUnitsVpLetterByDateQueryVariables>;
export const GetVPviewUnitDocument = gql`
    query getVPviewUnit($vpLetterDate: DateTime!) {
  getVPviewUnit(vpLetterDate: $vpLetterDate) {
    id
    unitNo
  }
}
    `;

/**
 * __useGetVPviewUnitQuery__
 *
 * To run a query within a React component, call `useGetVPviewUnitQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVPviewUnitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVPviewUnitQuery({
 *   variables: {
 *      vpLetterDate: // value for 'vpLetterDate'
 *   },
 * });
 */
export function useGetVPviewUnitQuery(baseOptions: Apollo.QueryHookOptions<GetVPviewUnitQuery, GetVPviewUnitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVPviewUnitQuery, GetVPviewUnitQueryVariables>(GetVPviewUnitDocument, options);
      }
export function useGetVPviewUnitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVPviewUnitQuery, GetVPviewUnitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVPviewUnitQuery, GetVPviewUnitQueryVariables>(GetVPviewUnitDocument, options);
        }
export type GetVPviewUnitQueryHookResult = ReturnType<typeof useGetVPviewUnitQuery>;
export type GetVPviewUnitLazyQueryHookResult = ReturnType<typeof useGetVPviewUnitLazyQuery>;
export type GetVPviewUnitQueryResult = Apollo.QueryResult<GetVPviewUnitQuery, GetVPviewUnitQueryVariables>;
export const SaveUnitsVpLetterDateDocument = gql`
    mutation saveUnitsVpLetterDate($input: UnitsVpLetterInput!) {
  saveUnitsVpLetterDate(input: $input)
}
    `;
export type SaveUnitsVpLetterDateMutationFn = Apollo.MutationFunction<SaveUnitsVpLetterDateMutation, SaveUnitsVpLetterDateMutationVariables>;

/**
 * __useSaveUnitsVpLetterDateMutation__
 *
 * To run a mutation, you first call `useSaveUnitsVpLetterDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveUnitsVpLetterDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveUnitsVpLetterDateMutation, { data, loading, error }] = useSaveUnitsVpLetterDateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveUnitsVpLetterDateMutation(baseOptions?: Apollo.MutationHookOptions<SaveUnitsVpLetterDateMutation, SaveUnitsVpLetterDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveUnitsVpLetterDateMutation, SaveUnitsVpLetterDateMutationVariables>(SaveUnitsVpLetterDateDocument, options);
      }
export type SaveUnitsVpLetterDateMutationHookResult = ReturnType<typeof useSaveUnitsVpLetterDateMutation>;
export type SaveUnitsVpLetterDateMutationResult = Apollo.MutationResult<SaveUnitsVpLetterDateMutation>;
export type SaveUnitsVpLetterDateMutationOptions = Apollo.BaseMutationOptions<SaveUnitsVpLetterDateMutation, SaveUnitsVpLetterDateMutationVariables>;
export const GetUnitsVpFormSourceDocument = gql`
    query getUnitsVpFormSource {
  getUnitsVpFormSource {
    block
    totalFloor
    floorList {
      floorLabel
      totalUnit
      unitList {
        unitId
        unitNo
      }
    }
  }
}
    `;

/**
 * __useGetUnitsVpFormSourceQuery__
 *
 * To run a query within a React component, call `useGetUnitsVpFormSourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitsVpFormSourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitsVpFormSourceQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUnitsVpFormSourceQuery(baseOptions?: Apollo.QueryHookOptions<GetUnitsVpFormSourceQuery, GetUnitsVpFormSourceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitsVpFormSourceQuery, GetUnitsVpFormSourceQueryVariables>(GetUnitsVpFormSourceDocument, options);
      }
export function useGetUnitsVpFormSourceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitsVpFormSourceQuery, GetUnitsVpFormSourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitsVpFormSourceQuery, GetUnitsVpFormSourceQueryVariables>(GetUnitsVpFormSourceDocument, options);
        }
export type GetUnitsVpFormSourceQueryHookResult = ReturnType<typeof useGetUnitsVpFormSourceQuery>;
export type GetUnitsVpFormSourceLazyQueryHookResult = ReturnType<typeof useGetUnitsVpFormSourceLazyQuery>;
export type GetUnitsVpFormSourceQueryResult = Apollo.QueryResult<GetUnitsVpFormSourceQuery, GetUnitsVpFormSourceQueryVariables>;